(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2888],{

/***/ 41860:
/***/ (function(module) {

!function(e,t){ true?module.exports=t():0}(window,(function(){return function(e){var t={};function a(r){if(t[r])return t[r].exports;var n=t[r]={i:r,l:!1,exports:{}};return e[r].call(n.exports,n,n.exports,a),n.l=!0,n.exports}return a.m=e,a.c=t,a.d=function(e,t,r){a.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r})},a.r=function(e){"undefined"!==typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},a.t=function(e,t){if(1&t&&(e=a(e)),8&t)return e;if(4&t&&"object"===typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(a.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var n in e)a.d(r,n,function(t){return e[t]}.bind(null,n));return r},a.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return a.d(t,"a",t),t},a.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},a.p="",a(a.s=144)}([function(e,t,a){var r;!function(){"use strict";var a={}.hasOwnProperty;function n(){for(var e=[],t=0;t<arguments.length;t++){var r=arguments[t];if(r){var i=typeof r;if("string"===i||"number"===i)e.push(r);else if(Array.isArray(r)&&r.length){var o=n.apply(null,r);o&&e.push(o)}else if("object"===i)for(var s in r)a.call(r,s)&&r[s]&&e.push(s)}}return e.join(" ")}e.exports?(n.default=n,e.exports=n):void 0===(r=function(){return n}.apply(t,[]))||(e.exports=r)}()},function(e,t,a){e.exports={"card-input__wrapper":"-wMSeYyd1oxr12akf2KiW","card-input__icon":"LG8NPDcUMJlIVKf-vmZYS","card-input__form":"_1rROkhE_InAmAGBv9PbBh8","card-input__spinner":"_15TC8X2U755Z-Hf-ih6QH0","card-input__spinner--active":"_1S9AS3BoV1JGA8Wvu0f5OB","card-input__form--loading":"_2_YFYtMPvqZWQG7QMEyFVK","adyen-checkout__input":"j2oksRnjgVh11hRREN03v","adyen-checkout__card__cvc__input--hidden":"_1bIHbqBrDUDWE6iNTKdVoo","revolving-plan-installments__disabled":"_1wm1GR0fzcXXgnIfIM6Xih"}},function(e,t,a){(function(t){var a=function(e){return e&&e.Math==Math&&e};e.exports=a("object"==typeof globalThis&&globalThis)||a("object"==typeof window&&window)||a("object"==typeof self&&self)||a("object"==typeof t&&t)||function(){return this}()||Function("return this")()}).call(this,a(28))},function(e,t,a){e.exports={"adyen-checkout__payment-methods-list":"iGQlrgUxnAsLb4qtu0dOc","adyen-checkout__payment-method":"_1Rv6Y28L612jCrJtlPzepi","adyen-checkout__payment-method__details":"_3u1CYXsnDFNlMBMpufyrsq","adyen-checkout__payment-method__image":"_1fo2qAgp7ayytaKrqbZpQI","adyen-checkout__payment-method__image__wrapper":"_11rD_9hAzkhgGyt7QOo002","adyen-checkout__payment-method--selected":"_3BJR28lK23l7BF0ouQL_18"}},function(e,t){e.exports=function(e){try{return!!e()}catch(e){return!0}}},function(e,t,a){e.exports={"adyen-checkout__dropdown":"_25j1wxcG6JMayoahR4dwTP","adyen-checkout__dropdown__button":"fyN7g68OwE8jYoU4M7kus","adyen-checkout__dropdown__button--active":"_3iqZCnn-31LQsexJZnNY7Y","adyen-checkout__dropdown__list":"ZH972lEag_JGA8QEQO7ng","adyen-checkout__dropdown__list--active":"_2WnEj5QNGxd_iZR-53o07C","adyen-checkout__dropdown__element":"_30ugZ2ebrREuog3c07S2JO"}},function(e,t,a){var r=a(4);e.exports=!r((function(){return 7!=Object.defineProperty({},1,{get:function(){return 7}})[1]}))},function(e,t){var a={}.hasOwnProperty;e.exports=function(e,t){return a.call(e,t)}},function(e,t,a){var r=a(2),n=a(29).f,i=a(12),o=a(77),s=a(19),c=a(81),d=a(85);e.exports=function(e,t){var a,l,u,p,m,h=e.target,f=e.global,y=e.stat;if(a=f?r:y?r[h]||s(h,{}):(r[h]||{}).prototype)for(l in t){if(p=t[l],u=e.noTargetGet?(m=n(a,l))&&m.value:a[l],!d(f?l:h+(y?".":"#")+l,e.forced)&&void 0!==u){if(typeof p===typeof u)continue;c(p,u)}(e.sham||u&&u.sham)&&i(p,"sham",!0),o(a,l,p,e)}}},function(e,t){e.exports=function(e){return"object"===typeof e?null!==e:"function"===typeof e}},function(e,t,a){e.exports={"sf-input__wrapper":"_1EXw9Cav0pmID2b-ymwNmz","adyen-checkout__input":"_2NaT42mcuvEbfoJUjXGSch"}},function(e,t,a){e.exports={"loading-input__form":"jZ0YjSr9W9MlpurLCM8H","loading-input__form--loading":"_1tkkSlJUdKo032lWINvPsx","loading-input__spinner":"SEHC8PPYoyGWCEoqeuUXX","loading-input__spinner--active":"_1gPx4O2oXmC_ICmXU5w9cb"}},function(e,t,a){var r=a(6),n=a(13),i=a(31);e.exports=r?function(e,t,a){return n.f(e,t,i(1,a))}:function(e,t,a){return e[t]=a,e}},function(e,t,a){var r=a(6),n=a(35),i=a(14),o=a(34),s=Object.defineProperty;t.f=r?s:function(e,t,a){if(i(e),t=o(t,!0),i(a),n)try{return s(e,t,a)}catch(e){}if("get"in a||"set"in a)throw TypeError("Accessors not supported");return"value"in a&&(e[t]=a.value),e}},function(e,t,a){var r=a(9);e.exports=function(e){if(!r(e))throw TypeError(String(e)+" is not an object");return e}},function(e){e.exports=JSON.parse('{"payButton":"Pay","payButton.redirecting":"Redirecting...","storeDetails":"Save for my next payment","creditCard.holderName":"Name on card","creditCard.holderName.placeholder":"J. Smith","creditCard.holderName.invalid":"Invalid cardholder name","creditCard.numberField.title":"Card number","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Expiry date","creditCard.expiryDateField.placeholder":"MM/YY","creditCard.expiryDateField.month":"Month","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"YY","creditCard.expiryDateField.year":"Year","creditCard.cvcField.title":"CVC / CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"Remember for next time","creditCard.cvcField.placeholder.4digits":"4 digits","creditCard.cvcField.placeholder.3digits":"3 digits","creditCard.taxNumber.placeholder":"YYMMDD / 0123456789","installments":"Number of installments","installmentOption":"%{times}x %{partialValue}","installmentOptionMonths":"%{times} months","installments.oneTime":"One time payment","installments.installments":"Installments payment","installments.revolving":"Revolving payment","sepaDirectDebit.ibanField.invalid":"Invalid account number","sepaDirectDebit.nameField.placeholder":"J. Smith","sepa.ownerName":"Holder Name","sepa.ibanNumber":"Account Number (IBAN)","error.title":"Error","error.subtitle.redirect":"Redirect failed","error.subtitle.payment":"Payment failed","error.subtitle.refused":"Payment refused","error.message.unknown":"An unknown error occurred","idealIssuer.selectField.title":"Bank","idealIssuer.selectField.placeholder":"Select your bank","creditCard.success":"Payment Successful","loading":"Loading\u2026","continue":"Continue","continueTo":"Continue to","wechatpay.timetopay":"You have %@ to pay","wechatpay.scanqrcode":"Scan QR code","personalDetails":"Personal details","companyDetails":"Company details","companyDetails.name":"Company name","companyDetails.registrationNumber":"Registration number","socialSecurityNumber":"Social security number","firstName":"First name","infix":"Prefix","lastName":"Last name","mobileNumber":"Mobile number","mobileNumber.invalid":"Invalid mobile number","city":"City","postalCode":"Postal code","countryCode":"Country Code","telephoneNumber":"Telephone number","dateOfBirth":"Date of birth","shopperEmail":"Email address","gender":"Gender","male":"Male","female":"Female","billingAddress":"Billing address","street":"Street","stateOrProvince":"State or province","country":"Country","houseNumberOrName":"House number","separateDeliveryAddress":"Specify a separate delivery address","deliveryAddress":"Delivery Address","zipCode":"Zip code","apartmentSuite":"Apartment / Suite","provinceOrTerritory":"Province or Territory","cityTown":"City / Town","address":"Address","state":"State","creditCard.cvcField.title.optional":"CVC / CVV (optional)","issuerList.wallet.placeholder":"Select your wallet","privacyPolicy":"Privacy policy","afterPay.agreement":"I agree with the %@ of AfterPay","paymentConditions":"payment conditions","openApp":"Open the app","voucher.readInstructions":"Read instructions","voucher.introduction":"Thank you for your purchase, please use the following coupon to complete your payment.","voucher.expirationDate":"Expiration Date","voucher.alternativeReference":"Alternative Reference","dragonpay.voucher.non.bank.selectField.placeholder":"Select your provider","dragonpay.voucher.bank.selectField.placeholder":"Select your bank","voucher.paymentReferenceLabel":"Payment Reference","voucher.surcharge":"Incl. %@ surcharge","voucher.introduction.doku":"Thank you for your purchase, please use the following information to complete your payment.","voucher.shopperName":"Shopper Name","voucher.merchantName":"Merchant","voucher.introduction.econtext":"Thank you for your purchase, please use the following information to complete your payment.","voucher.telephoneNumber":"Phone Number","voucher.shopperReference":"Shopper Reference","voucher.collectionInstitutionNumber":"Collection Institution Number","voucher.econtext.telephoneNumber.invalid":"Telephone number must be 10 or 11 digits long","boletobancario.btnLabel":"Generate Boleto","boleto.sendCopyToEmail":"Send a copy to my email","button.copy":"Copy","button.download":"Download","boleto.socialSecurityNumber":"CPF/CNPJ","creditCard.storedCard.description.ariaLabel":"Stored card ends in %@","voucher.entity":"Entity","donateButton":"Donate","notNowButton":"Not now","thanksForYourSupport":"Thanks for your support!","preauthorizeWith":"Preauthorize with","confirmPreauthorization":"Confirm preauthorization","confirmPurchase":"Confirm purchase","applyGiftcard":"Redeem","giftcardBalance":"Gift card balance","deductedBalance":"Deducted balance","creditCard.pin.title":"Pin","creditCard.encryptedPassword.label":"First 2 digits of card password","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Invalid password","creditCard.taxNumber.label":"Cardholder birthdate (YYMMDD) or Corporate registration number (10 digits)","creditCard.taxNumber.labelAlt":"Corporate registration number (10 digits)","creditCard.taxNumber.invalid":"Invalid Cardholder birthdate or Corporate registration number","storedPaymentMethod.disable.button":"Remove","storedPaymentMethod.disable.confirmation":"Remove stored payment method","storedPaymentMethod.disable.confirmButton":"Yes, remove","storedPaymentMethod.disable.cancelButton":"Cancel","ach.bankAccount":"Bank account","ach.accountHolderNameField.title":"Account holder name","ach.accountHolderNameField.placeholder":"J. Smith","ach.accountHolderNameField.invalid":"Invalid account holder name","ach.accountNumberField.title":"Account number","ach.accountNumberField.invalid":"Invalid account number","ach.accountLocationField.title":"ABA routing number","ach.accountLocationField.invalid":"Invalid ABA routing number","select.state":"Select state","select.stateOrProvince":"Select state or province","select.provinceOrTerritory":"Select province or territory","select.country":"Select country","telephoneNumber.invalid":"Invalid telephone number","qrCodeOrApp":"or","paypal.processingPayment":"Processing payment...","generateQRCode":"Generate QR code","await.waitForConfirmation":"Waiting for confirmation","mbway.confirmPayment":"Confirm your payment on the MB WAY app","shopperEmail.invalid":"Invalid email address","dateOfBirth.format":"DD/MM/YYYY","dateOfBirth.invalid":"You must be at least 18 years old","blik.confirmPayment":"Open your banking app to confirm the payment.","blik.invalid":"Enter 6 numbers","blik.code":"6-digit code","blik.help":"Get the code from your banking app.","swish.pendingMessage":"After you scan, the status can be pending for up to 10 minutes. Attempting to pay again within this time may result in multiple charges.","error.va.gen.01":"Incomplete field","error.va.gen.02":"Field not valid","error.va.sf-cc-num.01":"Invalid card number","error.va.sf-cc-num.03":"Unsupported card entered","error.va.sf-cc-dat.01":"Card too old","error.va.sf-cc-dat.02":"Date too far in the future","error.giftcard.no-balance":"This gift card has zero balance","error.giftcard.card-error":"In our records we have no gift card with this number","error.giftcard.currency-error":"Gift cards are only valid in the currency they were issued in","amazonpay.signout":"Sign out from Amazon","amazonpay.changePaymentDetails":"Change payment details","partialPayment.warning":"Select another payment method to pay the remaining","partialPayment.remainingBalance":"Remaining balance will be %{amount}","bankTransfer.beneficiary":"Beneficiary","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"Reference","bankTransfer.introduction":"Continue to create a new bank transfer payment. You can use the details in the following screen to finalize this payment.","bankTransfer.instructions":"Thank you for your purchase, please use the following information to complete your payment.","bacs.accountHolderName":"Bank account holder name","bacs.accountHolderName.invalid":"Invalid bank account holder name","bacs.accountNumber":"Bank account number","bacs.accountNumber.invalid":"Invalid bank account number","bacs.bankLocationId":"Sort code","bacs.bankLocationId.invalid":"Invalid sort code","bacs.consent.amount":"I agree that the above amount will be deducted from my bank account.","bacs.consent.account":"I confirm the account is in my name and I am the only signatory required to authorise the Direct Debit on this account.","edit":"Edit","bacs.confirm":"Confirm and pay","bacs.result.introduction":"Download your Direct Debit Instruction (DDI / Mandate)","download.pdf":"Download PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe for secured card number","creditCard.encryptedCardNumber.aria.label":"Card number field","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe for secured card expiry date","creditCard.encryptedExpiryDate.aria.label":"Expiry date field","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe for secured card expiry month","creditCard.encryptedExpiryMonth.aria.label":"Expiry month field","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe for secured card expiry year","creditCard.encryptedExpiryYear.aria.label":"Expiry year field","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe for secured card security code","creditCard.encryptedSecurityCode.aria.label":"Security code field","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe for secured gift card number","giftcard.encryptedCardNumber.aria.label":"Gift card number field","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe for secured gift card security code","giftcard.encryptedSecurityCode.aria.label":"Gift card security code field","giftcardTransactionLimit":"Max. %{amount} allowed per transaction on this gift card","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe for secured bank account number","ach.encryptedBankAccountNumber.aria.label":"Bank account field","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe for secured bank routing number","ach.encryptedBankLocationId.aria.label":"Bank routing number field","pix.instructions":"Open the app with the PIX registered key, choose Pay with PIX and scan the QR Code or copy and paste the code"}')},function(e,t,a){e.exports={"apple-pay-button":"_1dIj5OBNHw-_NvtfqKwJuZ","apple-pay-button-black":"_3kQn_urayEY_qN10JCDZ8J","apple-pay-button-white":"Crk4OPiucf8byDY_XkCtZ","apple-pay-button-white-with-line":"_3QQ9y6Oiu8jxi0RjuzlwKE","apple-pay-button--type-plain":"_3LOpY03tW2ejIa0YfQeLkj","apple-pay-button--type-buy":"_1wFWUnhKvJFkhCm-mH9n9C","apple-pay-button--type-donate":"_302hppXqBoqpUJHMjj1VSS","apple-pay-button--type-check-out":"_36UYjdq-NOAy6pxtkAM6ef","apple-pay-button--type-book":"_1bi-_fx2SBWe0CAAzJEPGa","apple-pay-button--type-subscribe":"c0ymV02fsvcG3rtm3Jwyn"}},function(e,t,a){var r=a(18),n=a(33);e.exports=function(e){return r(n(e))}},function(e,t,a){var r=a(4),n=a(32),i="".split;e.exports=r((function(){return!Object("z").propertyIsEnumerable(0)}))?function(e){return"String"==n(e)?i.call(e,""):Object(e)}:Object},function(e,t,a){var r=a(2),n=a(12);e.exports=function(e,t){try{n(r,e,t)}catch(a){r[e]=t}return t}},function(e,t,a){var r=a(2),n=a(19),i="__core-js_shared__",o=r[i]||n(i,{});e.exports=o},function(e,t){e.exports={}},function(e,t,a){var r=a(2);e.exports=r},function(e,t){e.exports=["constructor","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","toLocaleString","toString","valueOf"]},function(e,t,a){var r=a(42),n=a(23);e.exports=Object.keys||function(e){return r(e,n)}},function(e,t,a){var r=a(33);e.exports=function(e){return Object(r(e))}},function(e,t,a){var r=a(47),n=a(92),i=a(13),o=r("unscopables"),s=Array.prototype;void 0==s[o]&&i.f(s,o,{configurable:!0,value:n(null)}),e.exports=function(e){s[o][e]=!0}},function(e,t,a){var r=a(2),n=a(49),i=Function.call;e.exports=function(e,t,a){return n(i,r[e].prototype[t],a)}},function(e,t){var a;a=function(){return this}();try{a=a||new Function("return this")()}catch(e){"object"===typeof window&&(a=window)}e.exports=a},function(e,t,a){var r=a(6),n=a(30),i=a(31),o=a(17),s=a(34),c=a(7),d=a(35),l=Object.getOwnPropertyDescriptor;t.f=r?l:function(e,t){if(e=o(e),t=s(t,!0),d)try{return l(e,t)}catch(e){}if(c(e,t))return i(!n.f.call(e,t),e[t])}},function(e,t,a){"use strict";var r={}.propertyIsEnumerable,n=Object.getOwnPropertyDescriptor,i=n&&!r.call({1:2},1);t.f=i?function(e){var t=n(this,e);return!!t&&t.enumerable}:r},function(e,t){e.exports=function(e,t){return{enumerable:!(1&e),configurable:!(2&e),writable:!(4&e),value:t}}},function(e,t){var a={}.toString;e.exports=function(e){return a.call(e).slice(8,-1)}},function(e,t){e.exports=function(e){if(void 0==e)throw TypeError("Can't call method on "+e);return e}},function(e,t,a){var r=a(9);e.exports=function(e,t){if(!r(e))return e;var a,n;if(t&&"function"==typeof(a=e.toString)&&!r(n=a.call(e)))return n;if("function"==typeof(a=e.valueOf)&&!r(n=a.call(e)))return n;if(!t&&"function"==typeof(a=e.toString)&&!r(n=a.call(e)))return n;throw TypeError("Can't convert object to primitive value")}},function(e,t,a){var r=a(6),n=a(4),i=a(36);e.exports=!r&&!n((function(){return 7!=Object.defineProperty(i("div"),"a",{get:function(){return 7}}).a}))},function(e,t,a){var r=a(2),n=a(9),i=r.document,o=n(i)&&n(i.createElement);e.exports=function(e){return o?i.createElement(e):{}}},function(e,t,a){var r=a(20),n=Function.toString;"function"!=typeof r.inspectSource&&(r.inspectSource=function(e){return n.call(e)}),e.exports=r.inspectSource},function(e,t,a){var r=a(39),n=a(40),i=r("keys");e.exports=function(e){return i[e]||(i[e]=n(e))}},function(e,t,a){var r=a(80),n=a(20);(e.exports=function(e,t){return n[e]||(n[e]=void 0!==t?t:{})})("versions",[]).push({version:"3.9.0",mode:r?"pure":"global",copyright:"\xa9 2021 Denis Pushkarev (zloirock.ru)"})},function(e,t){var a=0,r=Math.random();e.exports=function(e){return"Symbol("+String(void 0===e?"":e)+")_"+(++a+r).toString(36)}},function(e,t,a){var r=a(22),n=a(2),i=function(e){return"function"==typeof e?e:void 0};e.exports=function(e,t){return arguments.length<2?i(r[e])||i(n[e]):r[e]&&r[e][t]||n[e]&&n[e][t]}},function(e,t,a){var r=a(7),n=a(17),i=a(43).indexOf,o=a(21);e.exports=function(e,t){var a,s=n(e),c=0,d=[];for(a in s)!r(o,a)&&r(s,a)&&d.push(a);for(;t.length>c;)r(s,a=t[c++])&&(~i(d,a)||d.push(a));return d}},function(e,t,a){var r=a(17),n=a(44),i=a(84),o=function(e){return function(t,a,o){var s,c=r(t),d=n(c.length),l=i(o,d);if(e&&a!=a){for(;d>l;)if((s=c[l++])!=s)return!0}else for(;d>l;l++)if((e||l in c)&&c[l]===a)return e||l||0;return!e&&-1}};e.exports={includes:o(!0),indexOf:o(!1)}},function(e,t,a){var r=a(45),n=Math.min;e.exports=function(e){return e>0?n(r(e),9007199254740991):0}},function(e,t){var a=Math.ceil,r=Math.floor;e.exports=function(e){return isNaN(e=+e)?0:(e>0?r:a)(e)}},function(e,t){t.f=Object.getOwnPropertySymbols},function(e,t,a){var r=a(2),n=a(39),i=a(7),o=a(40),s=a(48),c=a(91),d=n("wks"),l=r.Symbol,u=c?l:l&&l.withoutSetter||o;e.exports=function(e){return i(d,e)||(s&&i(l,e)?d[e]=l[e]:d[e]=u("Symbol."+e)),d[e]}},function(e,t,a){var r=a(4);e.exports=!!Object.getOwnPropertySymbols&&!r((function(){return!String(Symbol())}))},function(e,t,a){var r=a(95);e.exports=function(e,t,a){if(r(e),void 0===t)return e;switch(a){case 0:return function(){return e.call(t)};case 1:return function(a){return e.call(t,a)};case 2:return function(a,r){return e.call(t,a,r)};case 3:return function(a,r,n){return e.call(t,a,r,n)}}return function(){return e.apply(t,arguments)}}},function(e,t,a){var r=a(49),n=a(18),i=a(25),o=a(44),s=a(98),c=[].push,d=function(e){var t=1==e,a=2==e,d=3==e,l=4==e,u=6==e,p=7==e,m=5==e||u;return function(h,f,y,b){for(var v,g,k=i(h),C=n(k),_=r(f,y,3),N=o(C.length),w=0,P=b||s,F=t?P(h,N):a||p?P(h,0):void 0;N>w;w++)if((m||w in C)&&(g=_(v=C[w],w,k),e))if(t)F[w]=g;else if(g)switch(e){case 3:return!0;case 5:return v;case 6:return w;case 2:c.call(F,v)}else switch(e){case 4:return!1;case 7:c.call(F,v)}return u?-1:d||l?l:F}};e.exports={forEach:d(0),map:d(1),filter:d(2),some:d(3),every:d(4),find:d(5),findIndex:d(6),filterOut:d(7)}},function(e,t,a){},function(e){e.exports=JSON.parse('{"payButton":"Zaplatit","payButton.redirecting":"P\u0159esm\u011brov\xe1n\xed...","storeDetails":"Ulo\u017eit pro\xa0p\u0159\xed\u0161t\xed platby","creditCard.holderName":"Jm\xe9no na\xa0kart\u011b","creditCard.holderName.placeholder":"Jan Nov\xe1k","creditCard.holderName.invalid":"Neplatn\xe9 jm\xe9no dr\u017eitele karty","creditCard.numberField.title":"\u010c\xedslo karty","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Konec platnosti","creditCard.expiryDateField.placeholder":"MM/RR","creditCard.expiryDateField.month":"M\u011bs\xedc","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"RR","creditCard.expiryDateField.year":"Rok","creditCard.cvcField.title":"K\xf3d CVC/CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"Zapamatovat si pro\xa0p\u0159\xed\u0161t\u011b","creditCard.cvcField.placeholder.4digits":"4 \u010d\xedslice","creditCard.cvcField.placeholder.3digits":"3 \u010d\xedslice","creditCard.taxNumber.placeholder":"RRMMDD / 0123456789","installments":"Po\u010det spl\xe1tek","installmentOption":"%{times}\xd7 %{partialValue}","installmentOptionMonths":"%{times} m\u011bs\xedc\u016f","installments.oneTime":"Jednor\xe1zov\xe1 platba","installments.installments":"Platba na\xa0spl\xe1tky","installments.revolving":"Opakuj\xedc\xed se platba","sepaDirectDebit.ibanField.invalid":"Neplatn\xe9 \u010d\xedslo \xfa\u010dtu","sepaDirectDebit.nameField.placeholder":"Jan Nov\xe1k","sepa.ownerName":"Jm\xe9no dr\u017eitele \xfa\u010dtu","sepa.ibanNumber":"\u010c\xedslo \xfa\u010dtu (IBAN)","error.title":"Chyba","error.subtitle.redirect":"P\u0159esm\u011brov\xe1n\xed selhalo","error.subtitle.payment":"Platba selhala","error.subtitle.refused":"Platba zam\xedtnuta","error.message.unknown":"Do\u0161lo k\xa0nezn\xe1m\xe9 chyb\u011b","idealIssuer.selectField.title":"Banka","idealIssuer.selectField.placeholder":"Vyberte svou banku","creditCard.success":"Platba prob\u011bhla \xfasp\u011b\u0161n\u011b","loading":"Na\u010d\xedt\xe1n\xed\u2026","continue":"Pokra\u010dovat","continueTo":"Pokra\u010dovat k","wechatpay.timetopay":"Na\xa0zaplacen\xed v\xe1m zb\xfdv\xe1 %@","wechatpay.scanqrcode":"Naskenovat QR k\xf3d","personalDetails":"Osobn\xed \xfadaje","companyDetails":"\xdadaje o\xa0spole\u010dnosti","companyDetails.name":"N\xe1zev spole\u010dnosti","companyDetails.registrationNumber":"Registra\u010dn\xed \u010d\xedslo","socialSecurityNumber":"Rodn\xe9 \u010d\xedslo","firstName":"Jm\xe9no","infix":"Prefix","lastName":"P\u0159\xedjmen\xed","mobileNumber":"\u010c\xedslo na mobil","mobileNumber.invalid":"Neplatn\xe9 \u010d\xedslo mobiln\xedho telefonu","city":"M\u011bsto","postalCode":"PS\u010c","countryCode":"K\xf3d zem\u011b","telephoneNumber":"Telefonn\xed \u010d\xedslo","dateOfBirth":"Datum narozen\xed","shopperEmail":"E-mailov\xe1 adresa","gender":"Pohlav\xed","male":"Mu\u017e","female":"\u017dena","billingAddress":"Faktura\u010dn\xed adresa","street":"Ulice","stateOrProvince":"Kraj nebo okres","country":"Zem\u011b","houseNumberOrName":"\u010c\xedslo popisn\xe9","separateDeliveryAddress":"Zadat dodac\xed adresu odli\u0161nou od faktura\u010dn\xed","deliveryAddress":"Dodac\xed adresa","zipCode":"PS\u010c","apartmentSuite":"Byt","provinceOrTerritory":"Provincie nebo teritorium","cityTown":"M\u011bsto","address":"Adresa","state":"St\xe1t","creditCard.cvcField.title.optional":"K\xf3d CVC/CVV (voliteln\xe9)","issuerList.wallet.placeholder":"Vyberte svou pen\u011b\u017eenku","privacyPolicy":"Z\xe1sady ochrany osobn\xedch \xfadaj\u016f","afterPay.agreement":"Souhlas\xedm s %@ spole\u010dnosti AfterPay","paymentConditions":"platebn\xedmi podm\xednkami","openApp":"Otev\u0159ete aplikaci","voucher.readInstructions":"P\u0159e\u010dt\u011bte si pokyny","voucher.introduction":"D\u011bkujeme za\xa0n\xe1kup. K\xa0dokon\u010den\xed platby pou\u017eijte pros\xedm n\xe1sleduj\xedc\xed kup\xf3n.","voucher.expirationDate":"Datum konce platnosti","voucher.alternativeReference":"N\xe1hradn\xed \u010d\xedslo","dragonpay.voucher.non.bank.selectField.placeholder":"Vyberte sv\xe9ho poskytovatele","dragonpay.voucher.bank.selectField.placeholder":"Vyberte svou banku","voucher.paymentReferenceLabel":"\u010c\xedslo platby","voucher.surcharge":"V\u010detn\u011b p\u0159ir\xe1\u017eky %@","voucher.introduction.doku":"D\u011bkujeme za n\xe1kup. K dokon\u010den\xed platby pou\u017eijte pros\xedm n\xe1sleduj\xedc\xed informace.","voucher.shopperName":"Jm\xe9no kupuj\xedc\xedho","voucher.merchantName":"Obchodn\xedk","voucher.introduction.econtext":"D\u011bkujeme za n\xe1kup. K dokon\u010den\xed platby pou\u017eijte pros\xedm n\xe1sleduj\xedc\xed informace.","voucher.telephoneNumber":"Telefonn\xed \u010d\xedslo","voucher.shopperReference":"\u010c\xedslo kupuj\xedc\xedho","voucher.collectionInstitutionNumber":"\u010c\xedslo inkasn\xed instituce","voucher.econtext.telephoneNumber.invalid":"Telefonn\xed \u010d\xedslo mus\xed obsahovat 10 nebo 11 \u010d\xedslic.","boletobancario.btnLabel":"Vygenerovat Boleto","boleto.sendCopyToEmail":"Poslat mi kopii na e-mail","button.copy":"Kop\xedrovat","button.download":"St\xe1hnout","creditCard.storedCard.description.ariaLabel":"Ulo\u017een\xe1 karta kon\u010d\xed na %@","voucher.entity":"Subjekt","donateButton":"P\u0159isp\u011bt","notNowButton":"Te\u010f ne","thanksForYourSupport":"D\u011bkujeme v\xe1m za podporu!","preauthorizeWith":"P\u0159edautorizovat pomoc\xed","confirmPreauthorization":"Potvrdit p\u0159edautorizaci","confirmPurchase":"Potvrdit n\xe1kup","applyGiftcard":"Uplatnit","giftcardBalance":"Z\u016fstatek na d\xe1rkov\xe9 kart\u011b","deductedBalance":"Ode\u010dten\xfd z\u016fstatek","creditCard.pin.title":"Pin","creditCard.encryptedPassword.label":"Prvn\xed 2 \u010d\xedslice hesla karty","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Neplatn\xe9 heslo","creditCard.taxNumber.label":"Datum narozen\xed dr\u017eitele karty (RRMMDD) nebo registra\u010dn\xed \u010d\xedslo spole\u010dnosti (10 \u010d\xedslic)","creditCard.taxNumber.labelAlt":"Registra\u010dn\xed \u010d\xedslo spole\u010dnosti (10 \u010d\xedslic)","creditCard.taxNumber.invalid":"Neplatn\xe9 datum narozen\xed dr\u017eitele karty nebo registra\u010dn\xed \u010d\xedslo spole\u010dnosti","storedPaymentMethod.disable.button":"Odebrat","storedPaymentMethod.disable.confirmation":"Odebrat ulo\u017een\xfd zp\u016fsob platby","storedPaymentMethod.disable.confirmButton":"Ano, odebrat","storedPaymentMethod.disable.cancelButton":"Zru\u0161it","ach.bankAccount":"Bankovn\xed \xfa\u010det","ach.accountHolderNameField.title":"Jm\xe9no dr\u017eitele \xfa\u010dtu","ach.accountHolderNameField.placeholder":"Jan Nov\xe1k","ach.accountHolderNameField.invalid":"Neplatn\xe9 jm\xe9no dr\u017eitele \xfa\u010dtu","ach.accountNumberField.title":"\u010c\xedslo \xfa\u010dtu","ach.accountNumberField.invalid":"Neplatn\xe9 \u010d\xedslo \xfa\u010dtu","ach.accountLocationField.title":"Sm\u011brovac\xed tranzitn\xed \u010d\xedslo ABA","ach.accountLocationField.invalid":"Neplatn\xe9 sm\u011brovac\xed tranzitn\xed \u010d\xedslo ABA","select.state":"Vyberte st\xe1t","select.stateOrProvince":"Vyberte kraj nebo okres","select.provinceOrTerritory":"Vyberte provincii nebo teritorium","select.country":"Vyberte zemi","telephoneNumber.invalid":"Neplatn\xe9 telefonn\xed \u010d\xedslo","qrCodeOrApp":"nebo","paypal.processingPayment":"Zpracov\xe1n\xed platby...","generateQRCode":"Vygenerovat QR k\xf3d","await.waitForConfirmation":"\u010cek\xe1 se na\xa0potvrzen\xed","mbway.confirmPayment":"Potvr\u010fte platbu v\xa0aplikaci MB WAY","shopperEmail.invalid":"Neplatn\xe1 e-mailov\xe1 adresa","dateOfBirth.format":"DD/MM/RRRR","dateOfBirth.invalid":"Mus\xed v\xe1m b\xfdt alespo\u0148 18 let","blik.confirmPayment":"Spus\u0165te bankovn\xed aplikaci a potvr\u010fte platbu.","blik.invalid":"Zadejte 6 \u010d\xedsel","blik.code":"\u0160estim\xedstn\xfd k\xf3d","blik.help":"Z\xedskejte k\xf3d z bankovn\xed aplikace.","swish.pendingMessage":"Po naskenov\xe1n\xed QR k\xf3du m\u016f\u017ee trvat a\u017e 10 minut, ne\u017e se stav zm\u011bn\xed. Pokud budete zkou\u0161et b\u011bhem t\xe9to doby platbu opakovat, m\u016f\u017ee b\xfdt \u010d\xe1stka zaplacena v\xedcekr\xe1t.","error.va.gen.01":"Ne\xfapln\xe9 pole","error.va.gen.02":"Pole nen\xed platn\xe9","error.va.sf-cc-num.01":"Neplatn\xe9 \u010d\xedslo karty","error.va.sf-cc-num.03":"Zad\xe1na nepodporovan\xe1 karta","error.va.sf-cc-dat.01":"P\u0159\xedli\u0161 star\xe1 karta","error.va.sf-cc-dat.02":"Datum p\u0159\xedli\u0161 daleko v budoucnosti","error.giftcard.no-balance":"Na d\xe1rkov\xe9 kart\u011b je nulov\xfd z\u016fstatek","error.giftcard.card-error":"V\xa0na\u0161ich z\xe1znamech nen\xed \u017e\xe1dn\xe1 d\xe1rkov\xe1 karta s\xa0t\xedmto \u010d\xedslem","error.giftcard.currency-error":"D\xe1rkov\xe9 karty jsou platn\xe9 jenom v\xa0m\u011bn\u011b, ve kter\xe9 byly vystaven\xe9","amazonpay.signout":"Odhl\xe1sit se z Amazonu","amazonpay.changePaymentDetails":"Zm\u011bnit \xfadaje o platb\u011b","partialPayment.warning":"Zvolte jin\xfd zp\u016fsob platby pro platbu zb\xfdvaj\xedc\xedch","partialPayment.remainingBalance":"Zb\xfdvaj\xedc\xed z\u016fstatek bude %{amount}","bankTransfer.beneficiary":"P\u0159\xedjemce","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"Odkaz","bankTransfer.introduction":"Vytvo\u0159te novou platbu bankovn\xedm p\u0159evodem. K dokon\u010den\xed t\xe9to platby m\u016f\u017eete pou\u017e\xedt \xfadaje na n\xe1sleduj\xedc\xed obrazovce.","bankTransfer.instructions":"D\u011bkujeme za n\xe1kup. K dokon\u010den\xed platby pou\u017eijte pros\xedm n\xe1sleduj\xedc\xed informace.","bacs.accountHolderName":"Jm\xe9no dr\u017eitele bankovn\xedho \xfa\u010dtu","bacs.accountHolderName.invalid":"Neplatn\xe9 jm\xe9no dr\u017eitele bankovn\xedho \xfa\u010dtu","bacs.accountNumber":"\u010c\xedslo bankovn\xedho \xfa\u010dtu","bacs.accountNumber.invalid":"Neplatn\xe9 \u010d\xedslo bankovn\xedho \xfa\u010dtu","bacs.bankLocationId":"K\xf3d Sort","bacs.bankLocationId.invalid":"Neplatn\xfd k\xf3d Sort","bacs.consent.amount":"Souhlas\xedm s\xa0t\xedm, \u017ee mi bude n\xe1sleduj\xedc\xed \u010d\xe1stka ode\u010dtena z\xa0bankovn\xedho \xfa\u010dtu.","bacs.consent.account":"Potvrzuji, \u017ee \xfa\u010det je veden na moje jm\xe9no a\xa0jsem jedin\xfdm disponentem, jeho\u017e podpis je nutn\xfd ke schv\xe1len\xed p\u0159\xedm\xe9ho inkasa.","edit":"Editovat","bacs.confirm":"Potvrdit a\xa0zaplatit","bacs.result.introduction":"St\xe1hn\u011bte si pokyny k\xa0p\u0159\xedm\xe9mu inkasu (DDI / podpisov\xe9 pr\xe1vo)","download.pdf":"St\xe1hnout PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe pro \u010d\xedslo zabezpe\u010den\xe9 karty","creditCard.encryptedCardNumber.aria.label":"Pole pro \u010d\xedslo karty","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe pro datum vypr\u0161en\xed platnosti zabezpe\u010den\xe9 karty","creditCard.encryptedExpiryDate.aria.label":"Pole pro datum vypr\u0161en\xed platnosti","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe pro m\u011bs\xedc vypr\u0161en\xed platnosti zabezpe\u010den\xe9 karty","creditCard.encryptedExpiryMonth.aria.label":"Pole pro m\u011bs\xedc vypr\u0161en\xed platnosti","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe pro rok vypr\u0161en\xed platnosti zabezpe\u010den\xe9 karty","creditCard.encryptedExpiryYear.aria.label":"Pole pro rok vypr\u0161en\xed platnosti","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe pro bezpe\u010dnostn\xed k\xf3d zabezpe\u010den\xe9 karty","creditCard.encryptedSecurityCode.aria.label":"Pole pro bezpe\u010dnostn\xed k\xf3d","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe pro \u010d\xedslo zabezpe\u010den\xe9 d\xe1rkov\xe9 karty","giftcard.encryptedCardNumber.aria.label":"Pole pro \u010d\xedslo d\xe1rkov\xe9 karty","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe pro bezpe\u010dnostn\xed k\xf3d zabezpe\u010den\xe9 d\xe1rkov\xe9 karty","giftcard.encryptedSecurityCode.aria.label":"Pole pro bezpe\u010dnostn\xed k\xf3d d\xe1rkov\xe9 karty","giftcardTransactionLimit":"Maxim\xe1ln\xed povolen\xe1 %{amount} za jednu transakci touto d\xe1rkovou kartou.","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe pro \u010d\xedslo zabezpe\u010den\xe9ho bankovn\xedho \xfa\u010dtu","ach.encryptedBankAccountNumber.aria.label":"Pole pro bankovn\xed \xfa\u010det","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe pro \u010d\xedslo zabezpe\u010den\xe9ho k\xf3du banky","ach.encryptedBankLocationId.aria.label":"Pole pro k\xf3d banky"}')},function(e){e.exports=JSON.parse('{"payButton":"Betal","payButton.redirecting":"Omdirigerer ...","storeDetails":"Gem til min n\xe6ste betaling","creditCard.holderName":"Navn p\xe5 kort","creditCard.holderName.placeholder":"J. Hansen","creditCard.holderName.invalid":"Ugyldigt kortholdernavn","creditCard.numberField.title":"Kortnummer","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Udl\xf8bsdato","creditCard.expiryDateField.placeholder":"MM/\xc5\xc5","creditCard.expiryDateField.month":"M\xe5ned","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"\xc5\xc5","creditCard.expiryDateField.year":"\xc5r","creditCard.cvcField.title":"CVC / CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"Husk til n\xe6ste gang","creditCard.cvcField.placeholder.4digits":"4 cifre","creditCard.cvcField.placeholder.3digits":"3 cifre","creditCard.taxNumber.placeholder":"\xc5\xc5MMDD/0123456789","installments":"Antal rater","installmentOption":"%{times}x %{partialValue}","installmentOptionMonths":"%{times} m\xe5neder","installments.oneTime":"Engangsbetaling","installments.installments":"Afdragsbetaling","installments.revolving":"L\xf8bende betaling","sepaDirectDebit.ibanField.invalid":"Ugyldigt kontonummer","sepaDirectDebit.nameField.placeholder":"J. Smith","sepa.ownerName":"Kontohavernavn","sepa.ibanNumber":"Kontonummer (IBAN)","error.title":"Fejl","error.subtitle.redirect":"Omdirigering fejlede","error.subtitle.payment":"Betaling fejlede","error.subtitle.refused":"Betaling afvist","error.message.unknown":"Der opstod en ukendt fejl","idealIssuer.selectField.title":"Bank","idealIssuer.selectField.placeholder":"V\xe6lg din bank","creditCard.success":"Betaling gennemf\xf8rt","loading":"Indl\xe6ser\u2026","continue":"Forts\xe6t","continueTo":"Forts\xe6t til","wechatpay.timetopay":"Du har %@ at betale","wechatpay.scanqrcode":"Scan QR-kode","personalDetails":"Personlige oplysninger","companyDetails":"Virksomhedsoplysninger","companyDetails.name":"Virksomhedsnavn","companyDetails.registrationNumber":"CVR-nummer","socialSecurityNumber":"CPR-nummer","firstName":"Fornavn","infix":"Pr\xe6fiks","lastName":"Efternavn","mobileNumber":"Mobilnummer","mobileNumber.invalid":"Ugyldigt mobilnummer","city":"By","postalCode":"Postnummer","countryCode":"Landekode","telephoneNumber":"Telefonnummer","dateOfBirth":"F\xf8dselsdato","shopperEmail":"E-mailadresse","gender":"K\xf8n","male":"Mand","female":"Kvinde","billingAddress":"Faktureringsadresse","street":"Gade","stateOrProvince":"Region eller kommune","country":"Land","houseNumberOrName":"Husnummer","separateDeliveryAddress":"Angiv en separat leveringsadresse","deliveryAddress":"Leveringsadresse","zipCode":"Postnummer","apartmentSuite":"Lejlighed/suite","provinceOrTerritory":"Provins eller territorium","cityTown":"By","address":"Adresse","state":"Stat","creditCard.cvcField.title.optional":"CVC / CVV (valgfrit)","issuerList.wallet.placeholder":"V\xe6lg tegnebog","privacyPolicy":"Politik om privatlivets fred","afterPay.agreement":"Jeg accepterer AfterPays %@","paymentConditions":"betalingsbetingelser","openApp":"\xc5bn appen","voucher.readInstructions":"L\xe6s anvisningerne","voucher.introduction":"Tak for dit k\xf8b. Brug f\xf8lgende kupon til at gennemf\xf8re din betaling.","voucher.expirationDate":"Udl\xf8bsdato","voucher.alternativeReference":"Alternativ reference","dragonpay.voucher.non.bank.selectField.placeholder":"V\xe6lg din udbyder","dragonpay.voucher.bank.selectField.placeholder":"V\xe6lg din bank","voucher.paymentReferenceLabel":"Betalingsreference","voucher.surcharge":"Inkl. till\xe6gsbegyr p\xe5 %@","voucher.introduction.doku":"Tak for dit k\xf8b. Brug f\xf8lgende oplysninger til at gennemf\xf8re din betaling.","voucher.shopperName":"Kundenavn","voucher.merchantName":"S\xe6lger","voucher.introduction.econtext":"Tak for dit k\xf8b. Brug f\xf8lgende oplysninger til at gennemf\xf8re din betaling.","voucher.telephoneNumber":"Telefonnummer","voucher.shopperReference":"K\xf8bers reference","voucher.collectionInstitutionNumber":"Id-nummer til opkr\xe6vningsinstitution","voucher.econtext.telephoneNumber.invalid":"Telefonnummer skal best\xe5 af 10 eller 11 cifre","boletobancario.btnLabel":"Gener\xe9r Boleto","boleto.sendCopyToEmail":"Send en kopi til min e-mail","button.copy":"Kopi\xe9r","button.download":"Download","creditCard.storedCard.description.ariaLabel":"Gemt kort ender p\xe5 %@","voucher.entity":"Enhed","donateButton":"Giv et bidrag","notNowButton":"Ikke nu","thanksForYourSupport":"Tak for din st\xf8tte!","preauthorizeWith":"Forh\xe5ndsgodkend med","confirmPreauthorization":"Bekr\xe6ft forh\xe5ndsgodkendelse","confirmPurchase":"Bekr\xe6ft k\xf8b","applyGiftcard":"Indl\xf8s","giftcardBalance":"Saldo p\xe5 gavekort","deductedBalance":"Fratrukket saldo","creditCard.pin.title":"Pinkode","creditCard.encryptedPassword.label":"F\xf8rste 2 cifre i adgangskode til kort","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Ugyldig adgangskode","creditCard.taxNumber.label":"Kortholders f\xf8dselsdato (\xc5\xc5MMDD) eller virksomheds registreringsnummer (10 cifre)","creditCard.taxNumber.labelAlt":"Virksomheds registreringsnummer (10 cifre)","creditCard.taxNumber.invalid":"Ugyldig f\xf8dselsdato for kortholder eller virksomheds registreringsnummer","storedPaymentMethod.disable.button":"Fjern","storedPaymentMethod.disable.confirmation":"Fjern gemt betalingsm\xe5de","storedPaymentMethod.disable.confirmButton":"Ja, fjern","storedPaymentMethod.disable.cancelButton":"Annuller","ach.bankAccount":"Bankkonto","ach.accountHolderNameField.title":"Kontohavers navn","ach.accountHolderNameField.placeholder":"J. Hansen","ach.accountHolderNameField.invalid":"Ugyldigt kontohavernavn","ach.accountNumberField.title":"Kontonummer","ach.accountNumberField.invalid":"Ugyldigt kontonummer","ach.accountLocationField.title":"ABA-registreringsnummer","ach.accountLocationField.invalid":"Ugyldigt ABA-registreringsnummer","select.state":"V\xe6lg stat","select.stateOrProvince":"V\xe6lg region eller kommune","select.provinceOrTerritory":"V\xe6lg provins eller territorium","select.country":"V\xe6lg land","telephoneNumber.invalid":"Ugyldigt telefonnummer","qrCodeOrApp":"eller","paypal.processingPayment":"Behandler betaling ...","generateQRCode":"Gener\xe9r QR-kode","await.waitForConfirmation":"Venter p\xe5 bekr\xe6ftelse","mbway.confirmPayment":"Bekr\xe6ft din betaling p\xe5 appen MB WAY","shopperEmail.invalid":"Ugyldig e-mailadresse","dateOfBirth.format":"DD/MM/\xc5\xc5\xc5\xc5","dateOfBirth.invalid":"Du skal v\xe6re mindst 18 \xe5r","blik.confirmPayment":"\xc5bn din bankapp for at bekr\xe6fte betalingen.","blik.invalid":"Indtast 6 tal","blik.code":"6-cifret kode","blik.help":"F\xe5 koden fra din bankapp.","swish.pendingMessage":"Visning af status kan tage op til 10 minutter efter scanning. Et nyt fors\xf8g p\xe5 betaling inden for dette tidsrum kan muligvis medf\xf8re flere gebyrer.","error.va.gen.01":"Felt ikke udfyldt","error.va.gen.02":"Ugyldigt felt","error.va.sf-cc-num.01":"Ugyldigt kortnummer","error.va.sf-cc-num.03":"Ikke-underst\xf8ttet kort indtastet","error.va.sf-cc-dat.01":"Kort for gammelt","error.va.sf-cc-dat.02":"Dato for langt ude i fremtiden","error.giftcard.no-balance":"Saldoen p\xe5 gavekortet er 0","error.giftcard.card-error":"Vi har ikke et gavekort med dette nummer i vores optegnelser","error.giftcard.currency-error":"Gavekort er kun gyldige i udstedelsesvalutaen","amazonpay.signout":"Log ud af Amazon","amazonpay.changePaymentDetails":"Skift betalingsoplysninger","partialPayment.warning":"V\xe6lg en anden betalingsm\xe5de til betaling af restbel\xf8bet","partialPayment.remainingBalance":"Restbel\xf8bet vil v\xe6re %{amount}","bankTransfer.beneficiary":"Betalingsmodtager","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"Reference","bankTransfer.introduction":"Forts\xe6t med at oprette ny betalingsoverf\xf8rsel via bank. Du kan bruge oplysningerne p\xe5 den f\xf8lgende sk\xe6rm til at afslutte betalingen.","bankTransfer.instructions":"Tak for dit k\xf8b. Brug f\xf8lgende oplysninger til at gennemf\xf8re din betaling.","bacs.accountHolderName":"Bankkontohavers navn","bacs.accountHolderName.invalid":"Ugyldigt navn p\xe5 bankkontohaver","bacs.accountNumber":"Bankkontonummer","bacs.accountNumber.invalid":"Ugyldigt bankkontonummer","bacs.bankLocationId":"Registreringsnummer","bacs.bankLocationId.invalid":"Ugyldigt registreringsnummer","bacs.consent.amount":"Jeg accepterer, at bel\xf8bet ovenfor tr\xe6kkes p\xe5 min bankkonto.","bacs.consent.account":"Jeg bekr\xe6fter, at kontoen er i mit navn, og at jeg er den eneste underskriver, der kr\xe6ves for at godkende direkte debitering af kontoen.","edit":"Rediger","bacs.confirm":"Bekr\xe6ft, og betal","bacs.result.introduction":"Download vejledningen til direkte debitering (fuldmagt til direkte debitering)","download.pdf":"Download PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe til sikret kortnummer","creditCard.encryptedCardNumber.aria.label":"Kortnummerfelt","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe til udl\xf8bsdato for sikret kort","creditCard.encryptedExpiryDate.aria.label":"Felt til udl\xf8bsdato","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe til udl\xf8bsm\xe5ned for sikret kort","creditCard.encryptedExpiryMonth.aria.label":"Felt til udl\xf8bsm\xe5ned","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe til udl\xf8bs\xe5r for sikret kort","creditCard.encryptedExpiryYear.aria.label":"Felt til udl\xf8bs\xe5r","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe til sikkerhedskode for sikret kort","creditCard.encryptedSecurityCode.aria.label":"Felt til sikkerhedskode","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe til nummer for sikret gavekort","giftcard.encryptedCardNumber.aria.label":"Felt til gavekortnummer","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe til sikkerhedskode for sikret gavekort","giftcard.encryptedSecurityCode.aria.label":"Felt til sikkerhedskode for gavekort","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe til sikret bankkontonummer","ach.encryptedBankAccountNumber.aria.label":"Felt til bankkonto","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe til registreringsnummer for sikret bank","ach.encryptedBankLocationId.aria.label":"Felt til registreringsnummer for bank"}')},function(e){e.exports=JSON.parse('{"payButton":"Zahlen","payButton.redirecting":"Umleiten\xa0\u2026","storeDetails":"F\xfcr zuk\xfcnftige Zahlvorg\xe4nge speichern","creditCard.holderName":"Name auf der Karte","creditCard.holderName.placeholder":"A. M\xfcller","creditCard.holderName.invalid":"Ung\xfcltiger Karteninhabername","creditCard.numberField.title":"Kartennummer","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Ablaufdatum","creditCard.expiryDateField.placeholder":"MM/JJ","creditCard.expiryDateField.month":"Monat","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"JJ","creditCard.expiryDateField.year":"Jahr","creditCard.cvcField.title":"CVC / CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"F\xfcr das n\xe4chste Mal speichern","creditCard.cvcField.placeholder.4digits":"4 Stellen","creditCard.cvcField.placeholder.3digits":"3 Stellen","creditCard.taxNumber.placeholder":"JJMMTT/0123456789","installments":"Anzahl der Raten","installmentOption":"%{times}x %{partialValue}","installmentOptionMonths":"%{times} Monate","installments.oneTime":"Einmalige Zahlung","installments.installments":"Ratenzahlung","installments.revolving":"Ratenzahlung","sepaDirectDebit.ibanField.invalid":"Ung\xfcltige Kontonummer","sepaDirectDebit.nameField.placeholder":"L. Schmidt","sepa.ownerName":"Name des Kontoinhabers","sepa.ibanNumber":"Kontonummer (IBAN)","error.title":"Fehler","error.subtitle.redirect":"Weiterleitung fehlgeschlagen","error.subtitle.payment":"Zahlung fehlgeschlagen","error.subtitle.refused":"Zahlvorgang verweigert","error.message.unknown":"Es ist ein unbekannter Fehler aufgetreten.","idealIssuer.selectField.title":"Bank","idealIssuer.selectField.placeholder":"W\xe4hlen Sie Ihre Bank","creditCard.success":"Zahlung erfolgreich","loading":"Laden \u2026","continue":"Weiter","continueTo":"Weiter zu","wechatpay.timetopay":"Sie haben noch %@ um zu zahlen","wechatpay.scanqrcode":"QR-Code scannen","personalDetails":"Pers\xf6nliche Angaben","companyDetails":"Unternehmensdaten","companyDetails.name":"Unternehmensname","companyDetails.registrationNumber":"Registrierungsnummer","socialSecurityNumber":"Sozialversicherungsnummer","firstName":"Vorname","infix":"Vorwahl","lastName":"Nachname","mobileNumber":"Handynummer","mobileNumber.invalid":"Ung\xfcltige Handynummer","city":"Stadt","postalCode":"Postleitzahl","countryCode":"Landesvorwahl","telephoneNumber":"Telefonnummer","dateOfBirth":"Geburtsdatum","shopperEmail":"E-Mail-Adresse","gender":"Geschlecht","male":"M\xe4nnlich","female":"Weiblich","billingAddress":"Rechnungsadresse","street":"Stra\xdfe","stateOrProvince":"Bundesland","country":"Land","houseNumberOrName":"Hausnummer","separateDeliveryAddress":"Abweichende Lieferadresse angeben","deliveryAddress":"Lieferadresse","zipCode":"PLZ","apartmentSuite":"Wohnung/Geschoss","provinceOrTerritory":"Provinz oder Territorium","cityTown":"Ort","address":"Stra\xdfe und Hausnummer","state":"Bundesstaat","creditCard.cvcField.title.optional":"CVC / CVV (optional)","issuerList.wallet.placeholder":"Virtuelle Brieftasche ausw\xe4hlen","privacyPolicy":"Datenschutz","afterPay.agreement":"Ich bin mit den %@ von AfterPay einverstanden","paymentConditions":"Zahlungsbedingungen","openApp":"App \xf6ffnen","voucher.readInstructions":"Anweisungen lesen","voucher.introduction":"Vielen Dank f\xfcr Ihren Kauf. Bitte schlie\xdfen Sie Ihre Zahlung unter Verwendung des folgenden Gutscheins ab.","voucher.expirationDate":"G\xfcltig bis","voucher.alternativeReference":"Alternative Referenz","dragonpay.voucher.non.bank.selectField.placeholder":"Anbieter ausw\xe4hlen","dragonpay.voucher.bank.selectField.placeholder":"Bank ausw\xe4hlen","voucher.paymentReferenceLabel":"Zahlungsreferenz","voucher.surcharge":"Inkl. % @Zuschlag","voucher.introduction.doku":"Vielen Dank f\xfcr Ihren Kauf. Bitte schlie\xdfen Sie Ihre Zahlung unter Verwendung der folgenden Informationen ab.","voucher.shopperName":"Name des K\xe4ufers","voucher.merchantName":"H\xe4ndler","voucher.introduction.econtext":"Vielen Dank f\xfcr Ihren Kauf. Bitte schlie\xdfen Sie Ihre Zahlung unter Verwendung der folgenden Informationen ab.","voucher.telephoneNumber":"Telefonnummer","voucher.shopperReference":"Kundenreferenz","voucher.collectionInstitutionNumber":"Nummer der Zahlungsannahmestelle","voucher.econtext.telephoneNumber.invalid":"Die Telefonnummer muss 10- oder 11-stellig sein","boletobancario.btnLabel":"Boleto generieren","boleto.sendCopyToEmail":"Eine Kopie an meine E-Mail-Adresse senden","button.copy":"Kopieren","button.download":"Herunterladen","creditCard.storedCard.description.ariaLabel":"Gespeicherte Karte endet auf %@","voucher.entity":"Entit\xe4t","donateButton":"Spenden","notNowButton":"Nicht jetzt","thanksForYourSupport":"Danke f\xfcr Ihre Unterst\xfctzung!","preauthorizeWith":"Vorautorisieren mit","confirmPreauthorization":"Vorautorisierung best\xe4tigen","confirmPurchase":"Kauf best\xe4tigen","applyGiftcard":"Einl\xf6sen","giftcardBalance":"Saldo der Geschenkkarte","deductedBalance":"Abgezogener Betrag","creditCard.pin.title":"PIN","creditCard.encryptedPassword.label":"Die ersten zwei Ziffern des Kartenpassworts","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Ung\xfcltiges Passwort","creditCard.taxNumber.label":"Geburtsdatum des Karteninhabers (JJMMTT) oder Unternehmensregistrierungsnummer (10-stellig)","creditCard.taxNumber.labelAlt":"Unternehmensregistrierungsnummer (10-stellig)","creditCard.taxNumber.invalid":"Ung\xfcltiges Geburtsdatum des Karteninhabers oder ung\xfcltige Unternehmensregistrierungsnummer","storedPaymentMethod.disable.button":"Entfernen","storedPaymentMethod.disable.confirmation":"Gespeicherte Zahlungsmethode entfernen","storedPaymentMethod.disable.confirmButton":"Ja, entfernen","storedPaymentMethod.disable.cancelButton":"Abbrechen","ach.bankAccount":"Bankkonto","ach.accountHolderNameField.title":"Name des Kontoinhabers","ach.accountHolderNameField.placeholder":"A. M\xfcller","ach.accountHolderNameField.invalid":"Ung\xfcltiger Kontoinhabername","ach.accountNumberField.title":"Kontonummer","ach.accountNumberField.invalid":"Ung\xfcltige Kontonummer","ach.accountLocationField.title":"ABA-Nummer","ach.accountLocationField.invalid":"Ung\xfcltige ABA-Nummer","select.state":"Bundesstaat ausw\xe4hlen","select.stateOrProvince":"Bundesland oder Provinz/Region ausw\xe4hlen","select.provinceOrTerritory":"Provinz oder Territorium ausw\xe4hlen","select.country":"Land ausw\xe4hlen","telephoneNumber.invalid":"Ung\xfcltige Telefonnummer","qrCodeOrApp":"oder","paypal.processingPayment":"Zahlung wird verarbeitet\xa0\u2026","generateQRCode":"QR-Code generieren","await.waitForConfirmation":"Warten auf Best\xe4tigung","mbway.confirmPayment":"Best\xe4tigen Sie Ihre Zahlung in der MB WAY-App","shopperEmail.invalid":"Ung\xfcltige E-Mail-Adresse","dateOfBirth.format":"TT.MM.JJJJ","dateOfBirth.invalid":"Sie m\xfcssen mindestens 18 Jahre alt sein","blik.confirmPayment":"\xd6ffnen Sie Ihre Banking-App, um die Zahlung zu best\xe4tigen.","blik.invalid":"6 Zahlen eingeben","blik.code":"6-stelliger Code","blik.help":"Rufen Sie den Code \xfcber Ihre Banking-App ab.","swish.pendingMessage":"Es kann sein, dass der Status bis zu 10 Minuten nach dem Scan \u201eausstehend\u201c lautet. Wenn Sie w\xe4hrenddessen einen neuen Zahlungsversuch unternehmen, kann es sein, dass Ihnen mehrere Betr\xe4ge in Rechnung gestellt werden.","error.va.gen.01":"Feld nicht ausgef\xfcllt","error.va.gen.02":"Feld ung\xfcltig","error.va.sf-cc-num.01":"Ung\xfcltige Kartennummer","error.va.sf-cc-num.03":"Nicht unterst\xfctzte Karte eingegeben","error.va.sf-cc-dat.01":"Karte zu alt","error.va.sf-cc-dat.02":"Datum zu weit in der Zukunft","error.giftcard.no-balance":"Auf dieser Geschenkkarte ist kein Guthaben vorhanden","error.giftcard.card-error":"Es gibt in unserem System keine Geschenkkarte mit dieser Nummer","error.giftcard.currency-error":"Geschenkkarten sind nur in der W\xe4hrung g\xfcltig, in der sie ausgestellt wurden","amazonpay.signout":"Von Amazon abmelden","amazonpay.changePaymentDetails":"Zahlungsinformationen \xe4ndern","partialPayment.warning":"W\xe4hlen Sie eine andere Zahlungsmethode zur Zahlung des Restbetrags","partialPayment.remainingBalance":"Es verbleibt ein Restbetrag von %{amount}","bankTransfer.beneficiary":"Empf\xe4nger","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"Referenz","bankTransfer.introduction":"Fortfahren, um eine neue Bank\xfcberweisungszahlung zu erstellen. Sie k\xf6nnen die Informationen auf dem n\xe4chsten Bildschirm verwenden, um diese Zahlung abzuschlie\xdfen.","bankTransfer.instructions":"Vielen Dank f\xfcr Ihren Kauf. Bitte schlie\xdfen Sie Ihre Zahlung unter Verwendung der folgenden Informationen ab.","bacs.accountHolderName":"Name des Bankkontoinhabers","bacs.accountHolderName.invalid":"Ung\xfcltiger Bankkontoinhabername","bacs.accountNumber":"Bankkontonummer","bacs.accountNumber.invalid":"Ung\xfcltige Bankkontonummer","bacs.bankLocationId":"Bankleitzahl","bacs.bankLocationId.invalid":"Ung\xfcltige Bankleitzahl","bacs.consent.amount":"Ich bin damit einverstanden, dass der oben genannte Betrag von meinem Bankkonto abgebucht wird.","bacs.consent.account":"Ich best\xe4tige, dass das Konto unter meinem Namen l\xe4uft und ich der einzige erforderliche Unterzeichner bin, um die Lastschrift f\xfcr dieses Konto zu autorisieren.","edit":"Bearbeiten","bacs.confirm":"Best\xe4tigen und bezahlen","bacs.result.introduction":"Laden Sie Ihre Lastschriftanweisung (DDI/Einzugserm\xe4chtigung) herunter","download.pdf":"PDF herunterladen","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe f\xfcr Nummer der gesicherten Karte","creditCard.encryptedCardNumber.aria.label":"Feld \u201eKartennummer\u201c","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe f\xfcr Ablaufdatum der gesicherten Karte","creditCard.encryptedExpiryDate.aria.label":"Feld \u201eAblaufdatum\u201c","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe f\xfcr Monat des Ablaufdatums der gesicherten Karte","creditCard.encryptedExpiryMonth.aria.label":"Feld \u201eMonat des Ablaufdatums\u201c","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe f\xfcr Jahr des Ablaufdatums der gesicherten Karte","creditCard.encryptedExpiryYear.aria.label":"Feld \u201eJahr des Ablaufdatums\u201c","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe f\xfcr Sicherheitscode der gesicherten Karte","creditCard.encryptedSecurityCode.aria.label":"Feld \u201eSicherheitscode\u201c","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe f\xfcr Geschenkkartennummer der gesicherten Karte","giftcard.encryptedCardNumber.aria.label":"Feld \u201eGeschenkkartennummer\u201c","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe f\xfcr Sicherheitscode der gesicherten Geschenkkarte","giftcard.encryptedSecurityCode.aria.label":"Feld \u201eSicherheitscode der Geschenkkarte\u201c","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe f\xfcr gesicherte Bankkontonummer","ach.encryptedBankAccountNumber.aria.label":"Feld \u201eBankkonto\u201c","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe f\xfcr gesicherte BLZ","ach.encryptedBankLocationId.aria.label":"Bankleitzahl-Feld"}')},function(e){e.exports=JSON.parse('{"payButton":"\u03a0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae","payButton.redirecting":"\u0391\u03bd\u03b1\u03ba\u03b1\u03c4\u03b5\u03cd\u03b8\u03c5\u03bd\u03c3\u03b7...","storeDetails":"\u0391\u03c0\u03bf\u03b8\u03ae\u03ba\u03b5\u03c5\u03c3\u03b7 \u03b3\u03b9\u03b1 \u03c4\u03b7\u03bd \u03b5\u03c0\u03cc\u03bc\u03b5\u03bd\u03b7 \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae \u03bc\u03bf\u03c5","creditCard.holderName":"\u038c\u03bd\u03bf\u03bc\u03b1 \u03c3\u03c4\u03b7\u03bd \u03ba\u03ac\u03c1\u03c4\u03b1","creditCard.holderName.placeholder":"\u0393. \u03a0\u03b1\u03c0\u03b1\u03b4\u03ac\u03ba\u03b7\u03c2","creditCard.holderName.invalid":"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf \u03cc\u03bd\u03bf\u03bc\u03b1 \u03ba\u03b1\u03c4\u03cc\u03c7\u03bf\u03c5 \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","creditCard.numberField.title":"\u0391\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"\u0397\u03bc\u03b5\u03c1\u03bf\u03bc\u03b7\u03bd\u03af\u03b1 \u03bb\u03ae\u03be\u03b7\u03c2","creditCard.expiryDateField.placeholder":"\u039c\u039c/\u0395\u0395","creditCard.expiryDateField.month":"\u039c\u03ae\u03bd\u03b1\u03c2","creditCard.expiryDateField.month.placeholder":"\u039c\u039c","creditCard.expiryDateField.year.placeholder":"\u0395\u0395","creditCard.expiryDateField.year":"\u0388\u03c4\u03bf\u03c2","creditCard.cvcField.title":"CVC/CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"\u0391\u03c0\u03bf\u03bc\u03bd\u03b7\u03bc\u03cc\u03bd\u03b5\u03c5\u03c3\u03b7 \u03b3\u03b9\u03b1 \u03c4\u03b7\u03bd \u03b5\u03c0\u03cc\u03bc\u03b5\u03bd\u03b7 \u03c6\u03bf\u03c1\u03ac","creditCard.cvcField.placeholder.4digits":"4\u03c8\u03ae\u03c6\u03b9\u03bf\u03c2","creditCard.cvcField.placeholder.3digits":"3\u03c8\u03ae\u03c6\u03b9\u03bf\u03c2","creditCard.taxNumber.placeholder":"\u0395\u0395\u039c\u039c\u0397\u0397 / 0123456789","installments":"\u0391\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03b4\u03cc\u03c3\u03b5\u03c9\u03bd","installmentOption":"%{times}x %{partialValue}","installmentOptionMonths":"%{times} \u03bc\u03ae\u03bd\u03b5\u03c2","installments.oneTime":"\u0395\u03c6\u03ac\u03c0\u03b1\u03be \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae","installments.installments":"\u03a0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae \u03bc\u03b5 \u03b4\u03cc\u03c3\u03b5\u03b9\u03c2","installments.revolving":"\u0391\u03bd\u03b1\u03ba\u03c5\u03ba\u03bb\u03bf\u03cd\u03bc\u03b5\u03bd\u03b7 \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae","sepaDirectDebit.ibanField.invalid":"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf\u03c2 \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03bf\u03cd","sepaDirectDebit.nameField.placeholder":"\u0393. \u03a0\u03b1\u03c0\u03b1\u03b4\u03ac\u03ba\u03b7\u03c2","sepa.ownerName":"\u038c\u03bd\u03bf\u03bc\u03b1 \u03ba\u03b1\u03c4\u03cc\u03c7\u03bf\u03c5","sepa.ibanNumber":"\u0391\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03bf\u03cd (IBAN)","error.title":"\u03a3\u03c6\u03ac\u03bb\u03bc\u03b1","error.subtitle.redirect":"\u0397 \u03b1\u03bd\u03b1\u03ba\u03b1\u03c4\u03b5\u03cd\u03b8\u03c5\u03bd\u03c3\u03b7 \u03b1\u03c0\u03ad\u03c4\u03c5\u03c7\u03b5","error.subtitle.payment":"\u0397 \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae \u03b1\u03c0\u03ad\u03c4\u03c5\u03c7\u03b5","error.subtitle.refused":"\u0397 \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae \u03b1\u03c0\u03bf\u03c1\u03c1\u03af\u03c6\u03b8\u03b7\u03ba\u03b5","error.message.unknown":"\u03a0\u03c1\u03bf\u03ad\u03ba\u03c5\u03c8\u03b5 \u03ac\u03b3\u03bd\u03c9\u03c3\u03c4\u03bf \u03c3\u03c6\u03ac\u03bb\u03bc\u03b1","idealIssuer.selectField.title":"\u03a4\u03c1\u03ac\u03c0\u03b5\u03b6\u03b1","idealIssuer.selectField.placeholder":"\u0395\u03c0\u03b9\u03bb\u03ad\u03be\u03c4\u03b5 \u03c4\u03b7\u03bd \u03c4\u03c1\u03ac\u03c0\u03b5\u03b6\u03ac \u03c3\u03b1\u03c2","creditCard.success":"\u0397 \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae \u03bf\u03bb\u03bf\u03ba\u03bb\u03b7\u03c1\u03ce\u03b8\u03b7\u03ba\u03b5 \u03b5\u03c0\u03b9\u03c4\u03c5\u03c7\u03ce\u03c2","loading":"\u03a6\u03cc\u03c1\u03c4\u03c9\u03c3\u03b7...","continue":"\u03a3\u03c5\u03bd\u03ad\u03c7\u03b5\u03b9\u03b1","continueTo":"\u039c\u03b5\u03c4\u03ac\u03b2\u03b1\u03c3\u03b7 \u03c3\u03c4\u03b7\u03bd","wechatpay.timetopay":"\u0388\u03c7\u03b5\u03c4\u03b5 \u03c3\u03c4\u03b7 \u03b4\u03b9\u03ac\u03b8\u03b5\u03c3\u03ae \u03c3\u03b1\u03c2 %@ \u03b3\u03b9\u03b1 \u03c4\u03b7\u03bd \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae","wechatpay.scanqrcode":"\u03a3\u03ac\u03c1\u03c9\u03c3\u03b7 \u03ba\u03c9\u03b4\u03b9\u03ba\u03bf\u03cd QR","personalDetails":"\u03a0\u03c1\u03bf\u03c3\u03c9\u03c0\u03b9\u03ba\u03ac \u03c3\u03c4\u03bf\u03b9\u03c7\u03b5\u03af\u03b1","companyDetails":"\u03a3\u03c4\u03bf\u03b9\u03c7\u03b5\u03af\u03b1 \u03b5\u03c4\u03b1\u03b9\u03c1\u03b5\u03af\u03b1\u03c2","companyDetails.name":"\u038c\u03bd\u03bf\u03bc\u03b1 \u03b5\u03c4\u03b1\u03b9\u03c1\u03b5\u03af\u03b1\u03c2","companyDetails.registrationNumber":"\u0391\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03bc\u03b7\u03c4\u03c1\u03ce\u03bf\u03c5","socialSecurityNumber":"\u0391\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03c6\u03bf\u03c1\u03bf\u03bb\u03bf\u03b3\u03b9\u03ba\u03bf\u03cd \u03bc\u03b7\u03c4\u03c1\u03ce\u03bf\u03c5","firstName":"\u038c\u03bd\u03bf\u03bc\u03b1","infix":"\u03a0\u03c1\u03cc\u03b8\u03b5\u03bc\u03b1","lastName":"\u0395\u03c0\u03ce\u03bd\u03c5\u03bc\u03bf","mobileNumber":"\u0391\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03ba\u03b9\u03bd\u03b7\u03c4\u03bf\u03cd","mobileNumber.invalid":"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf\u03c2 \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03ba\u03b9\u03bd\u03b7\u03c4\u03bf\u03cd","city":"\u03a0\u03cc\u03bb\u03b7","postalCode":"\u03a4\u03b1\u03c7\u03c5\u03b4\u03c1\u03bf\u03bc\u03b9\u03ba\u03cc\u03c2 \u03ba\u03c9\u03b4\u03b9\u03ba\u03cc\u03c2","countryCode":"\u039a\u03c9\u03b4\u03b9\u03ba\u03cc\u03c2 \u03c7\u03ce\u03c1\u03b1\u03c2","telephoneNumber":"\u0391\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03c4\u03b7\u03bb\u03b5\u03c6\u03ce\u03bd\u03bf\u03c5","dateOfBirth":"\u0397\u03bc\u03b5\u03c1\u03bf\u03bc\u03b7\u03bd\u03af\u03b1 \u03b3\u03ad\u03bd\u03bd\u03b7\u03c3\u03b7\u03c2","shopperEmail":"\u0394\u03b9\u03b5\u03cd\u03b8\u03c5\u03bd\u03c3\u03b7 email","gender":"\u03a6\u03cd\u03bb\u03bf","male":"\u0386\u03bd\u03c4\u03c1\u03b1\u03c2","female":"\u0393\u03c5\u03bd\u03b1\u03af\u03ba\u03b1","billingAddress":"\u0394\u03b9\u03b5\u03cd\u03b8\u03c5\u03bd\u03c3\u03b7 \u03c4\u03b9\u03bc\u03bf\u03bb\u03cc\u03b3\u03b7\u03c3\u03b7\u03c2","street":"\u039f\u03b4\u03cc\u03c2","stateOrProvince":"\u03a0\u03bf\u03bb\u03b9\u03c4\u03b5\u03af\u03b1 \u03ae \u03b5\u03c0\u03b1\u03c1\u03c7\u03af\u03b1","country":"\u03a7\u03ce\u03c1\u03b1","houseNumberOrName":"\u0391\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03bf\u03b9\u03ba\u03af\u03b1\u03c2","separateDeliveryAddress":"\u039a\u03b1\u03b8\u03bf\u03c1\u03af\u03c3\u03c4\u03b5 \u03bc\u03b9\u03b1 \u03be\u03b5\u03c7\u03c9\u03c1\u03b9\u03c3\u03c4\u03ae \u03b4\u03b9\u03b5\u03cd\u03b8\u03c5\u03bd\u03c3\u03b7 \u03c0\u03b1\u03c1\u03ac\u03b4\u03bf\u03c3\u03b7\u03c2","deliveryAddress":"\u0394\u03b9\u03b5\u03cd\u03b8\u03c5\u03bd\u03c3\u03b7 \u03c0\u03b1\u03c1\u03ac\u03b4\u03bf\u03c3\u03b7\u03c2","zipCode":"\u03a4\u03b1\u03c7\u03c5\u03b4\u03c1\u03bf\u03bc\u03b9\u03ba\u03cc\u03c2 \u03ba\u03ce\u03b4\u03b9\u03ba\u03b1\u03c2","apartmentSuite":"\u0394\u03b9\u03b1\u03bc\u03ad\u03c1\u03b9\u03c3\u03bc\u03b1/\u0393\u03c1\u03b1\u03c6\u03b5\u03af\u03bf","provinceOrTerritory":"\u0395\u03c0\u03b1\u03c1\u03c7\u03af\u03b1 \u03ae \u03c0\u03b5\u03c1\u03b9\u03c6\u03ad\u03c1\u03b5\u03b9\u03b1","cityTown":"\u03a0\u03cc\u03bb\u03b7 / \u039a\u03bf\u03b9\u03bd\u03cc\u03c4\u03b7\u03c4\u03b1","address":"\u0394\u03b9\u03b5\u03cd\u03b8\u03c5\u03bd\u03c3\u03b7","state":"\u03a0\u03bf\u03bb\u03b9\u03c4\u03b5\u03af\u03b1","creditCard.cvcField.title.optional":"CVC/CVV (\u03c0\u03c1\u03bf\u03b1\u03b9\u03c1\u03b5\u03c4\u03b9\u03ba\u03ac)","issuerList.wallet.placeholder":"\u0395\u03c0\u03b9\u03bb\u03ad\u03be\u03c4\u03b5 \u03c4\u03bf \u03c0\u03bf\u03c1\u03c4\u03bf\u03c6\u03cc\u03bb\u03b9 \u03c3\u03b1\u03c2","privacyPolicy":"\u03a0\u03bf\u03bb\u03b9\u03c4\u03b9\u03ba\u03ae \u03b1\u03c0\u03bf\u03c1\u03c1\u03ae\u03c4\u03bf\u03c5","afterPay.agreement":"\u0391\u03c0\u03bf\u03b4\u03ad\u03c7\u03bf\u03bc\u03b1\u03b9 \u03c4\u03bf\u03c5\u03c2 %@ \u03c4\u03bf\u03c5 AfterPay","paymentConditions":"\u03cc\u03c1\u03bf\u03c5\u03c2 \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae\u03c2","openApp":"\u0386\u03bd\u03bf\u03b9\u03b3\u03bc\u03b1 \u03c4\u03b7\u03c2 \u03b5\u03c6\u03b1\u03c1\u03bc\u03bf\u03b3\u03ae\u03c2","voucher.readInstructions":"\u0394\u03b9\u03b1\u03b2\u03ac\u03c3\u03c4\u03b5 \u03c4\u03b9\u03c2 \u03bf\u03b4\u03b7\u03b3\u03af\u03b5\u03c2","voucher.introduction":"\u03a3\u03b1\u03c2 \u03b5\u03c5\u03c7\u03b1\u03c1\u03b9\u03c3\u03c4\u03bf\u03cd\u03bc\u03b5 \u03b3\u03b9\u03b1 \u03c4\u03b7\u03bd \u03b1\u03b3\u03bf\u03c1\u03ac. \u03a7\u03c1\u03b7\u03c3\u03b9\u03bc\u03bf\u03c0\u03bf\u03b9\u03ae\u03c3\u03c4\u03b5 \u03c4\u03bf \u03c0\u03b1\u03c1\u03b1\u03ba\u03ac\u03c4\u03c9 \u03ba\u03bf\u03c5\u03c0\u03cc\u03bd\u03b9 \u03b3\u03b9\u03b1 \u03bd\u03b1 \u03bf\u03bb\u03bf\u03ba\u03bb\u03b7\u03c1\u03ce\u03c3\u03b5\u03c4\u03b5 \u03c4\u03b7\u03bd \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae.","voucher.expirationDate":"\u0397\u03bc\u03b5\u03c1\u03bf\u03bc\u03b7\u03bd\u03af\u03b1 \u03bb\u03ae\u03be\u03b7\u03c2","voucher.alternativeReference":"\u0395\u03bd\u03b1\u03bb\u03bb\u03b1\u03ba\u03c4\u03b9\u03ba\u03ae \u03b1\u03bd\u03b1\u03c6\u03bf\u03c1\u03ac","dragonpay.voucher.non.bank.selectField.placeholder":"\u0395\u03c0\u03b9\u03bb\u03ad\u03be\u03c4\u03b5 \u03c4\u03bf\u03bd \u03c0\u03ac\u03c1\u03bf\u03c7\u03cc \u03c3\u03b1\u03c2","dragonpay.voucher.bank.selectField.placeholder":"\u0395\u03c0\u03b9\u03bb\u03ad\u03be\u03c4\u03b5 \u03c4\u03b7\u03bd \u03c4\u03c1\u03ac\u03c0\u03b5\u03b6\u03ac \u03c3\u03b1\u03c2","voucher.paymentReferenceLabel":"\u0391\u03bd\u03b1\u03c6\u03bf\u03c1\u03ac \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae\u03c2","voucher.surcharge":"\u03a0\u03b5\u03c1\u03b9\u03bb\u03b1\u03bc\u03b2\u03ac\u03bd\u03b5\u03c4\u03b1\u03b9 \u03c0\u03c1\u03cc\u03c3\u03b8\u03b5\u03c4\u03b7 \u03c7\u03c1\u03ad\u03c9\u03c3\u03b7 %@","voucher.introduction.doku":"\u03a3\u03b1\u03c2 \u03b5\u03c5\u03c7\u03b1\u03c1\u03b9\u03c3\u03c4\u03bf\u03cd\u03bc\u03b5 \u03b3\u03b9\u03b1 \u03c4\u03b7\u03bd \u03b1\u03b3\u03bf\u03c1\u03ac. \u03a7\u03c1\u03b7\u03c3\u03b9\u03bc\u03bf\u03c0\u03bf\u03b9\u03ae\u03c3\u03c4\u03b5 \u03c4\u03b9\u03c2 \u03b1\u03ba\u03cc\u03bb\u03bf\u03c5\u03b8\u03b5\u03c2 \u03c0\u03bb\u03b7\u03c1\u03bf\u03c6\u03bf\u03c1\u03af\u03b5\u03c2 \u03b3\u03b9\u03b1 \u03bd\u03b1 \u03bf\u03bb\u03bf\u03ba\u03bb\u03b7\u03c1\u03ce\u03c3\u03b5\u03c4\u03b5 \u03c4\u03b7\u03bd \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae.","voucher.shopperName":"\u038c\u03bd\u03bf\u03bc\u03b1 \u03b1\u03b3\u03bf\u03c1\u03b1\u03c3\u03c4\u03ae","voucher.merchantName":"\u0388\u03bc\u03c0\u03bf\u03c1\u03bf\u03c2","voucher.introduction.econtext":"\u03a3\u03b1\u03c2 \u03b5\u03c5\u03c7\u03b1\u03c1\u03b9\u03c3\u03c4\u03bf\u03cd\u03bc\u03b5 \u03b3\u03b9\u03b1 \u03c4\u03b7\u03bd \u03b1\u03b3\u03bf\u03c1\u03ac. \u03a7\u03c1\u03b7\u03c3\u03b9\u03bc\u03bf\u03c0\u03bf\u03b9\u03ae\u03c3\u03c4\u03b5 \u03c4\u03b9\u03c2 \u03b1\u03ba\u03cc\u03bb\u03bf\u03c5\u03b8\u03b5\u03c2 \u03c0\u03bb\u03b7\u03c1\u03bf\u03c6\u03bf\u03c1\u03af\u03b5\u03c2 \u03b3\u03b9\u03b1 \u03bd\u03b1 \u03bf\u03bb\u03bf\u03ba\u03bb\u03b7\u03c1\u03ce\u03c3\u03b5\u03c4\u03b5 \u03c4\u03b7\u03bd \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae.","voucher.telephoneNumber":"\u0391\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03c4\u03b7\u03bb\u03b5\u03c6\u03ce\u03bd\u03bf\u03c5","voucher.shopperReference":"\u0391\u03bd\u03b1\u03c6\u03bf\u03c1\u03ac \u03b1\u03b3\u03bf\u03c1\u03b1\u03c3\u03c4\u03ae","voucher.collectionInstitutionNumber":"\u0391\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03c0\u03c1\u03b1\u03ba\u03c4\u03bf\u03c1\u03b5\u03af\u03bf\u03c5 \u03b5\u03b9\u03c3\u03c0\u03c1\u03ac\u03be\u03b5\u03c9\u03bd","voucher.econtext.telephoneNumber.invalid":"\u039f \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03c4\u03b7\u03bb\u03b5\u03c6\u03ce\u03bd\u03bf\u03c5 \u03c0\u03c1\u03ad\u03c0\u03b5\u03b9 \u03bd\u03b1 \u03c0\u03b5\u03c1\u03b9\u03ad\u03c7\u03b5\u03b9 10 \u03ae 11 \u03c8\u03b7\u03c6\u03af\u03b1","boletobancario.btnLabel":"\u0394\u03b7\u03bc\u03b9\u03bf\u03c5\u03c1\u03b3\u03af\u03b1 Boleto","boleto.sendCopyToEmail":"\u0391\u03c0\u03bf\u03c3\u03c4\u03bf\u03bb\u03ae \u03b1\u03bd\u03c4\u03b9\u03b3\u03c1\u03ac\u03c6\u03bf\u03c5 \u03c3\u03c4\u03b7 \u03b4\u03b9\u03b5\u03cd\u03b8\u03c5\u03bd\u03c3\u03b7 email \u03bc\u03bf\u03c5","button.copy":"\u0391\u03bd\u03c4\u03b9\u03b3\u03c1\u03b1\u03c6\u03ae","button.download":"\u039b\u03ae\u03c8\u03b7","creditCard.storedCard.description.ariaLabel":"\u0397 \u03b1\u03c0\u03bf\u03b8\u03b7\u03ba\u03b5\u03c5\u03bc\u03ad\u03bd\u03b7 \u03ba\u03ac\u03c1\u03c4\u03b1 \u03c4\u03b5\u03bb\u03b5\u03b9\u03ce\u03bd\u03b5\u03b9 \u03c3\u03b5 %@","voucher.entity":"\u039f\u03bd\u03c4\u03cc\u03c4\u03b7\u03c4\u03b1","donateButton":"\u0394\u03c9\u03c1\u03b5\u03ac","notNowButton":"\u038c\u03c7\u03b9 \u03c4\u03ce\u03c1\u03b1","thanksForYourSupport":"\u03a3\u03b1\u03c2 \u03b5\u03c5\u03c7\u03b1\u03c1\u03b9\u03c3\u03c4\u03bf\u03cd\u03bc\u03b5 \u03b3\u03b9\u03b1 \u03c4\u03b7\u03bd \u03c5\u03c0\u03bf\u03c3\u03c4\u03ae\u03c1\u03b9\u03be\u03b7!","preauthorizeWith":"\u03a0\u03c1\u03bf\u03b5\u03be\u03bf\u03c5\u03c3\u03b9\u03bf\u03b4\u03cc\u03c4\u03b7\u03c3\u03b7 \u03bc\u03b5","confirmPreauthorization":"\u0395\u03c0\u03b9\u03b2\u03b5\u03b2\u03b1\u03af\u03c9\u03c3\u03b7 \u03c0\u03c1\u03bf\u03b5\u03be\u03bf\u03c5\u03c3\u03b9\u03bf\u03b4\u03cc\u03c4\u03b7\u03c3\u03b7\u03c2","confirmPurchase":"\u0395\u03c0\u03b9\u03b2\u03b5\u03b2\u03b1\u03af\u03c9\u03c3\u03b7 \u03b1\u03b3\u03bf\u03c1\u03ac\u03c2","applyGiftcard":"\u0395\u03be\u03b1\u03c1\u03b3\u03cd\u03c1\u03c9\u03c3\u03b7","giftcardBalance":"\u03a5\u03c0\u03cc\u03bb\u03bf\u03b9\u03c0\u03bf \u03b4\u03c9\u03c1\u03bf\u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","deductedBalance":"\u03a5\u03c0\u03cc\u03bb\u03bf\u03b9\u03c0\u03bf \u03c0\u03bf\u03c5 \u03b1\u03c6\u03b1\u03b9\u03c1\u03ad\u03b8\u03b7\u03ba\u03b5","creditCard.pin.title":"\u039a\u03c9\u03b4\u03b9\u03ba\u03cc\u03c2 PIN","creditCard.encryptedPassword.label":"\u03a4\u03b1 \u03c0\u03c1\u03ce\u03c4\u03b1 2 \u03c8\u03b7\u03c6\u03af\u03b1 \u03c4\u03bf\u03c5 \u03ba\u03c9\u03b4\u03b9\u03ba\u03bf\u03cd \u03c0\u03c1\u03cc\u03c3\u03b2\u03b1\u03c3\u03b7\u03c2 \u03c4\u03b7\u03c2 \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf\u03c2 \u03ba\u03c9\u03b4\u03b9\u03ba\u03cc\u03c2 \u03c0\u03c1\u03cc\u03c3\u03b2\u03b1\u03c3\u03b7\u03c2","creditCard.taxNumber.label":"\u0397\u03bc\u03b5\u03c1\u03bf\u03bc\u03b7\u03bd\u03af\u03b1 \u03b3\u03ad\u03bd\u03bd\u03b7\u03c3\u03b7\u03c2 \u03ba\u03b1\u03c4\u03cc\u03c7\u03bf\u03c5 \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2 (YYMMDD) \u03ae \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03bc\u03b7\u03c4\u03c1\u03ce\u03bf\u03c5 \u03b5\u03c4\u03b1\u03b9\u03c1\u03b5\u03b9\u03ce\u03bd (10 \u03c8\u03b7\u03c6\u03af\u03b1)","creditCard.taxNumber.labelAlt":"\u0391\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03bc\u03b7\u03c4\u03c1\u03ce\u03bf\u03c5 \u03b5\u03c4\u03b1\u03b9\u03c1\u03b5\u03b9\u03ce\u03bd (10 \u03c8\u03b7\u03c6\u03af\u03b1)","creditCard.taxNumber.invalid":"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03b7 \u03b7\u03bc\u03b5\u03c1\u03bf\u03bc\u03b7\u03bd\u03af\u03b1 \u03b3\u03ad\u03bd\u03bd\u03b7\u03c3\u03b7\u03c2 \u03ba\u03b1\u03c4\u03cc\u03c7\u03bf\u03c5 \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2 \u03ae \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03bc\u03b7\u03c4\u03c1\u03ce\u03bf\u03c5 \u03b5\u03c4\u03b1\u03b9\u03c1\u03b5\u03b9\u03ce\u03bd","storedPaymentMethod.disable.button":"\u0391\u03c6\u03b1\u03af\u03c1\u03b5\u03c3\u03b7","storedPaymentMethod.disable.confirmation":"\u0391\u03c6\u03b1\u03af\u03c1\u03b5\u03c3\u03b7 \u03b1\u03c0\u03bf\u03b8\u03b7\u03ba\u03b5\u03c5\u03bc\u03ad\u03bd\u03bf\u03c5 \u03c4\u03c1\u03cc\u03c0\u03bf\u03c5 \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae\u03c2","storedPaymentMethod.disable.confirmButton":"\u039d\u03b1\u03b9, \u03b1\u03c6\u03b1\u03af\u03c1\u03b5\u03c3\u03b7","storedPaymentMethod.disable.cancelButton":"\u0386\u03ba\u03c5\u03c1\u03bf","ach.bankAccount":"\u03a4\u03c1\u03b1\u03c0\u03b5\u03b6\u03b9\u03ba\u03cc\u03c2 \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03cc\u03c2","ach.accountHolderNameField.title":"\u038c\u03bd\u03bf\u03bc\u03b1 \u03ba\u03b1\u03c4\u03cc\u03c7\u03bf\u03c5 \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03bf\u03cd","ach.accountHolderNameField.placeholder":"\u0393. \u03a0\u03b1\u03c0\u03b1\u03b4\u03ac\u03ba\u03b7\u03c2","ach.accountHolderNameField.invalid":"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf \u03cc\u03bd\u03bf\u03bc\u03b1 \u03ba\u03b1\u03c4\u03cc\u03c7\u03bf\u03c5 \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03bf\u03cd","ach.accountNumberField.title":"\u0391\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03bf\u03cd","ach.accountNumberField.invalid":"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf\u03c2 \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03bf\u03cd","ach.accountLocationField.title":"\u0391\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03b4\u03c1\u03bf\u03bc\u03bf\u03bb\u03cc\u03b3\u03b7\u03c3\u03b7\u03c2 ABA","ach.accountLocationField.invalid":"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf\u03c2 \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03b4\u03c1\u03bf\u03bc\u03bf\u03bb\u03cc\u03b3\u03b7\u03c3\u03b7\u03c2 ABA","select.state":"\u0395\u03c0\u03b9\u03bb\u03ad\u03be\u03c4\u03b5 \u03c0\u03bf\u03bb\u03b9\u03c4\u03b5\u03af\u03b1","select.stateOrProvince":"\u0395\u03c0\u03b9\u03bb\u03ad\u03be\u03c4\u03b5 \u03c0\u03bf\u03bb\u03b9\u03c4\u03b5\u03af\u03b1 \u03ae \u03b5\u03c0\u03b1\u03c1\u03c7\u03af\u03b1","select.provinceOrTerritory":"\u0395\u03c0\u03b9\u03bb\u03ad\u03be\u03c4\u03b5 \u03b5\u03c0\u03b1\u03c1\u03c7\u03af\u03b1 \u03ae \u03c0\u03b5\u03c1\u03b9\u03c6\u03ad\u03c1\u03b5\u03b9\u03b1","select.country":"\u0395\u03c0\u03b9\u03bb\u03ad\u03be\u03c4\u03b5 \u03c7\u03ce\u03c1\u03b1","telephoneNumber.invalid":"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf\u03c2 \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03c4\u03b7\u03bb\u03b5\u03c6\u03ce\u03bd\u03bf\u03c5","qrCodeOrApp":"\u03ae","paypal.processingPayment":"\u0395\u03c0\u03b5\u03be\u03b5\u03c1\u03b3\u03b1\u03c3\u03af\u03b1 \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae\u03c2...","generateQRCode":"\u0394\u03b7\u03bc\u03b9\u03bf\u03c5\u03c1\u03b3\u03af\u03b1 \u03ba\u03c9\u03b4\u03b9\u03ba\u03bf\u03cd QR","await.waitForConfirmation":"\u0391\u03bd\u03b1\u03bc\u03bf\u03bd\u03ae \u03b3\u03b9\u03b1 \u03b5\u03c0\u03b9\u03b2\u03b5\u03b2\u03b1\u03af\u03c9\u03c3\u03b7\u2026","mbway.confirmPayment":"\u0395\u03c0\u03b9\u03b2\u03b5\u03b2\u03b1\u03b9\u03ce\u03c3\u03c4\u03b5 \u03c4\u03b7\u03bd \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae \u03c3\u03c4\u03b7\u03bd \u03b5\u03c6\u03b1\u03c1\u03bc\u03bf\u03b3\u03ae MB WAY","shopperEmail.invalid":"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03b7 \u03b4\u03b9\u03b5\u03cd\u03b8\u03c5\u03bd\u03c3\u03b7 email","dateOfBirth.format":"\u0397\u0397/\u039c\u039c/\u0395\u0395\u0395\u0395","dateOfBirth.invalid":"\u03a0\u03c1\u03ad\u03c0\u03b5\u03b9 \u03bd\u03b1 \u03b5\u03af\u03c3\u03c4\u03b5 \u03c4\u03bf\u03c5\u03bb\u03ac\u03c7\u03b9\u03c3\u03c4\u03bf\u03bd 18 \u03b5\u03c4\u03ce\u03bd","blik.confirmPayment":"\u0391\u03bd\u03bf\u03af\u03be\u03c4\u03b5 \u03c4\u03b7\u03bd \u03b5\u03c6\u03b1\u03c1\u03bc\u03bf\u03b3\u03ae \u03c4\u03c1\u03b1\u03c0\u03b5\u03b6\u03b9\u03ba\u03ae\u03c2 \u03c3\u03b1\u03c2 \u03b3\u03b9\u03b1 \u03bd\u03b1 \u03b5\u03c0\u03b9\u03b2\u03b5\u03b2\u03b1\u03b9\u03ce\u03c3\u03b5\u03c4\u03b5 \u03c4\u03b7\u03bd \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae.","blik.invalid":"\u0395\u03b9\u03c3\u03b1\u03b3\u03ac\u03b3\u03b5\u03c4\u03b5 6 \u03c8\u03b7\u03c6\u03af\u03b1","blik.code":"6\u03c8\u03ae\u03c6\u03b9\u03bf\u03c2 \u03ba\u03c9\u03b4\u03b9\u03ba\u03cc\u03c2","blik.help":"\u039b\u03ac\u03b2\u03b5\u03c4\u03b5 \u03c4\u03bf\u03bd \u03ba\u03c9\u03b4\u03b9\u03ba\u03cc \u03b1\u03c0\u03cc \u03c4\u03b7\u03bd \u03b5\u03c6\u03b1\u03c1\u03bc\u03bf\u03b3\u03ae \u03c4\u03c1\u03b1\u03c0\u03b5\u03b6\u03b9\u03ba\u03ae\u03c2 \u03c3\u03b1\u03c2.","swish.pendingMessage":"\u039c\u03b5\u03c4\u03ac \u03c4\u03b7 \u03c3\u03ac\u03c1\u03c9\u03c3\u03b7, \u03b7 \u03ba\u03b1\u03c4\u03ac\u03c3\u03c4\u03b1\u03c3\u03b7 \u03bc\u03c0\u03bf\u03c1\u03b5\u03af \u03bd\u03b1 \u03b5\u03af\u03bd\u03b1\u03b9 \u03b5\u03ba\u03ba\u03c1\u03b5\u03bc\u03ae\u03c2 \u03b3\u03b9\u03b1 \u03ad\u03c9\u03c2 10 \u03bb\u03b5\u03c0\u03c4\u03ac. \u0397 \u03b1\u03c0\u03cc\u03c0\u03b5\u03b9\u03c1\u03b1 \u03b5\u03ba \u03bd\u03ad\u03bf\u03c5 \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae\u03c2 \u03b5\u03bd\u03c4\u03cc\u03c2 \u03b1\u03c5\u03c4\u03bf\u03cd \u03c4\u03bf\u03c5 \u03c7\u03c1\u03bf\u03bd\u03b9\u03ba\u03bf\u03cd \u03b4\u03b9\u03b1\u03c3\u03c4\u03ae\u03bc\u03b1\u03c4\u03bf\u03c2 \u03b5\u03bd\u03b4\u03ad\u03c7\u03b5\u03c4\u03b1\u03b9 \u03bd\u03b1 \u03c0\u03c1\u03bf\u03ba\u03b1\u03bb\u03ad\u03c3\u03b5\u03b9 \u03c0\u03c1\u03cc\u03c3\u03b8\u03b5\u03c4\u03b7 \u03c7\u03c1\u03ad\u03c9\u03c3\u03b7.","error.va.gen.01":"\u0395\u03bb\u03bb\u03b9\u03c0\u03ad\u03c2 \u03c0\u03b5\u03b4\u03af\u03bf","error.va.gen.02":"\u03a4\u03bf \u03c0\u03b5\u03b4\u03af\u03bf \u03b4\u03b5\u03bd \u03b5\u03af\u03bd\u03b1\u03b9 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf","error.va.sf-cc-num.01":"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf\u03c2 \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","error.va.sf-cc-num.03":"\u0395\u03b9\u03c3\u03ac\u03c7\u03b8\u03b7\u03ba\u03b5 \u03bc\u03b7 \u03c5\u03c0\u03bf\u03c3\u03c4\u03b7\u03c1\u03b9\u03b6\u03cc\u03bc\u03b5\u03bd\u03b7 \u03ba\u03ac\u03c1\u03c4\u03b1","error.va.sf-cc-dat.01":"\u0397 \u03ba\u03ac\u03c1\u03c4\u03b1 \u03b5\u03af\u03bd\u03b1\u03b9 \u03c0\u03bf\u03bb\u03cd \u03c0\u03b1\u03bb\u03b9\u03ac","error.va.sf-cc-dat.02":"\u0397 \u03b7\u03bc\u03b5\u03c1\u03bf\u03bc\u03b7\u03bd\u03af\u03b1 \u03b5\u03af\u03bd\u03b1\u03b9 \u03c0\u03bf\u03bb\u03cd \u03bc\u03b1\u03ba\u03c1\u03b9\u03bd\u03ae","error.giftcard.no-balance":"\u0397 \u03c3\u03c5\u03b3\u03ba\u03b5\u03ba\u03c1\u03b9\u03bc\u03ad\u03bd\u03b7 \u03b4\u03c9\u03c1\u03bf\u03ba\u03ac\u03c1\u03c4\u03b1 \u03ad\u03c7\u03b5\u03b9 \u03bc\u03b7\u03b4\u03b5\u03bd\u03b9\u03ba\u03cc \u03c5\u03c0\u03cc\u03bb\u03bf\u03b9\u03c0\u03bf","error.giftcard.card-error":"\u03a3\u03c4\u03b1 \u03b1\u03c1\u03c7\u03b5\u03af\u03b1 \u03bc\u03b1\u03c2 \u03b4\u03b5\u03bd \u03c5\u03c0\u03ac\u03c1\u03c7\u03b5\u03b9 \u03b4\u03c9\u03c1\u03bf\u03ba\u03ac\u03c1\u03c4\u03b1 \u03bc\u03b5 \u03b1\u03c5\u03c4\u03cc\u03bd \u03c4\u03bf\u03bd \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc","error.giftcard.currency-error":"\u039f\u03b9 \u03b4\u03c9\u03c1\u03bf\u03ba\u03ac\u03c1\u03c4\u03b5\u03c2 \u03b9\u03c3\u03c7\u03cd\u03bf\u03c5\u03bd \u03bc\u03cc\u03bd\u03bf \u03b3\u03b9\u03b1 \u03c4\u03bf \u03bd\u03cc\u03bc\u03b9\u03c3\u03bc\u03b1 \u03c3\u03c4\u03bf \u03bf\u03c0\u03bf\u03af\u03bf \u03b5\u03ba\u03b4\u03cc\u03b8\u03b7\u03ba\u03b1\u03bd","amazonpay.signout":"\u0391\u03c0\u03bf\u03c3\u03cd\u03bd\u03b4\u03b5\u03c3\u03b7 \u03b1\u03c0\u03cc \u03c4\u03bf Amazon","amazonpay.changePaymentDetails":"\u0391\u03bb\u03bb\u03b1\u03b3\u03ae \u03c3\u03c4\u03bf\u03b9\u03c7\u03b5\u03af\u03c9\u03bd \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae\u03c2","partialPayment.warning":"\u0395\u03c0\u03b9\u03bb\u03ad\u03be\u03c4\u03b5 \u03ad\u03bd\u03b1\u03bd \u03ac\u03bb\u03bb\u03bf \u03c4\u03c1\u03cc\u03c0\u03bf \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae\u03c2 \u03b3\u03b9\u03b1 \u03ba\u03b1\u03c4\u03b1\u03b2\u03bf\u03bb\u03ae \u03c4\u03bf\u03c5 \u03b5\u03bd\u03b1\u03c0\u03bf\u03bc\u03b5\u03af\u03bd\u03b1\u03bd\u03c4\u03bf\u03c2 \u03c0\u03bf\u03c3\u03bf\u03cd","partialPayment.remainingBalance":"\u03a4\u03bf \u03c5\u03c0\u03cc\u03bb\u03bf\u03b9\u03c0\u03bf \u03b8\u03b1 \u03b5\u03af\u03bd\u03b1\u03b9 %{amount}","bankTransfer.beneficiary":"\u0394\u03b9\u03ba\u03b1\u03b9\u03bf\u03cd\u03c7\u03bf\u03c2","bankTransfer.iban":"\u0399\u0392\u0391\u039d","bankTransfer.bic":"BIC","bankTransfer.reference":"\u0391\u03bd\u03b1\u03c6\u03bf\u03c1\u03ac","bankTransfer.introduction":"\u03a3\u03c5\u03bd\u03b5\u03c7\u03af\u03c3\u03c4\u03b5 \u03b3\u03b9\u03b1 \u03bd\u03b1 \u03b4\u03b7\u03bc\u03b9\u03bf\u03c5\u03c1\u03b3\u03ae\u03c3\u03b5\u03c4\u03b5 \u03bd\u03ad\u03b1 \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae \u03bc\u03ad\u03c3\u03c9 \u03c4\u03c1\u03b1\u03c0\u03b5\u03b6\u03b9\u03ba\u03ae\u03c2 \u03bc\u03b5\u03c4\u03b1\u03c6\u03bf\u03c1\u03ac\u03c2. \u039c\u03c0\u03bf\u03c1\u03b5\u03af\u03c4\u03b5 \u03bd\u03b1 \u03c7\u03c1\u03b7\u03c3\u03b9\u03bc\u03bf\u03c0\u03bf\u03b9\u03ae\u03c3\u03b5\u03c4\u03b5 \u03c4\u03b1 \u03c3\u03c4\u03bf\u03b9\u03c7\u03b5\u03af\u03b1 \u03c3\u03c4\u03b7\u03bd \u03b1\u03ba\u03cc\u03bb\u03bf\u03c5\u03b8\u03b7 \u03bf\u03b8\u03cc\u03bd\u03b7 \u03b3\u03b9\u03b1 \u03bd\u03b1 \u03bf\u03bb\u03bf\u03ba\u03bb\u03b7\u03c1\u03ce\u03c3\u03b5\u03c4\u03b5 \u03b1\u03c5\u03c4\u03ae\u03bd \u03c4\u03b7\u03bd \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae.","bankTransfer.instructions":"\u03a3\u03b1\u03c2 \u03b5\u03c5\u03c7\u03b1\u03c1\u03b9\u03c3\u03c4\u03bf\u03cd\u03bc\u03b5 \u03b3\u03b9\u03b1 \u03c4\u03b7\u03bd \u03b1\u03b3\u03bf\u03c1\u03ac. \u03a7\u03c1\u03b7\u03c3\u03b9\u03bc\u03bf\u03c0\u03bf\u03b9\u03ae\u03c3\u03c4\u03b5 \u03c4\u03b9\u03c2 \u03b1\u03ba\u03cc\u03bb\u03bf\u03c5\u03b8\u03b5\u03c2 \u03c0\u03bb\u03b7\u03c1\u03bf\u03c6\u03bf\u03c1\u03af\u03b5\u03c2 \u03b3\u03b9\u03b1 \u03bd\u03b1 \u03bf\u03bb\u03bf\u03ba\u03bb\u03b7\u03c1\u03ce\u03c3\u03b5\u03c4\u03b5 \u03c4\u03b7\u03bd \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae.","bacs.accountHolderName":"\u038c\u03bd\u03bf\u03bc\u03b1 \u03b4\u03b9\u03ba\u03b1\u03b9\u03bf\u03cd\u03c7\u03bf\u03c5 \u03c4\u03c1\u03b1\u03c0\u03b5\u03b6\u03b9\u03ba\u03bf\u03cd \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03bf\u03cd","bacs.accountHolderName.invalid":"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf \u03cc\u03bd\u03bf\u03bc\u03b1 \u03b4\u03b9\u03ba\u03b1\u03b9\u03bf\u03cd\u03c7\u03bf\u03c5 \u03c4\u03c1\u03b1\u03c0\u03b5\u03b6\u03b9\u03ba\u03bf\u03cd \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03bf\u03cd","bacs.accountNumber":"\u0391\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03c4\u03c1\u03b1\u03c0\u03b5\u03b6\u03b9\u03ba\u03bf\u03cd \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03bf\u03cd","bacs.accountNumber.invalid":"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf\u03c2 \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03c4\u03c1\u03b1\u03c0\u03b5\u03b6\u03b9\u03ba\u03bf\u03cd \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03bf\u03cd","bacs.bankLocationId":"\u039a\u03c9\u03b4\u03b9\u03ba\u03cc\u03c2 \u03c4\u03c1\u03ac\u03c0\u03b5\u03b6\u03b1\u03c2","bacs.bankLocationId.invalid":"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf\u03c2 \u03ba\u03c9\u03b4\u03b9\u03ba\u03cc\u03c2 \u03c4\u03c1\u03ac\u03c0\u03b5\u03b6\u03b1\u03c2","bacs.consent.amount":"\u0391\u03c0\u03bf\u03b4\u03ad\u03c7\u03bf\u03bc\u03b1\u03b9 \u03cc\u03c4\u03b9 \u03c4\u03bf \u03c0\u03b9\u03bf \u03c0\u03ac\u03bd\u03c9 \u03c0\u03bf\u03c3\u03cc \u03b8\u03b1 \u03b1\u03c6\u03b1\u03b9\u03c1\u03b5\u03b8\u03b5\u03af \u03b1\u03c0\u03cc \u03c4\u03bf\u03bd \u03c4\u03c1\u03b1\u03c0\u03b5\u03b6\u03b9\u03ba\u03cc \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03cc \u03bc\u03bf\u03c5.","bacs.consent.account":"\u0395\u03c0\u03b9\u03b2\u03b5\u03b2\u03b1\u03b9\u03ce\u03bd\u03c9 \u03cc\u03c4\u03b9 \u03bf \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03cc\u03c2 \u03b5\u03af\u03bd\u03b1\u03b9 \u03c3\u03c4\u03bf \u03cc\u03bd\u03bf\u03bc\u03ac \u03bc\u03bf\u03c5 \u03ba\u03b1\u03b9 \u03c0\u03c9\u03c2 \u03b5\u03af\u03bc\u03b1\u03b9 \u03bf/\u03b7 \u03bc\u03bf\u03bd\u03b1\u03b4\u03b9\u03ba\u03cc\u03c2/\u03bc\u03bf\u03bd\u03b1\u03b4\u03b9\u03ba\u03ae \u03c5\u03c0\u03bf\u03b3\u03c1\u03ac\u03c6\u03c9\u03bd/\u03c5\u03c0\u03bf\u03b3\u03c1\u03ac\u03c6\u03bf\u03c5\u03c3\u03b1 \u03c0\u03bf\u03c5 \u03b1\u03c0\u03b1\u03b9\u03c4\u03b5\u03af\u03c4\u03b1\u03b9 \u03b3\u03b9\u03b1 \u03b5\u03be\u03bf\u03c5\u03c3\u03b9\u03bf\u03b4\u03cc\u03c4\u03b7\u03c3\u03b7 \u03c4\u03b7\u03c2 \u0386\u03bc\u03b5\u03c3\u03b7\u03c2 \u03a7\u03c1\u03ad\u03c9\u03c3\u03b7\u03c2 \u03c3\u03b5 \u03b1\u03c5\u03c4\u03cc\u03bd \u03c4\u03bf\u03bd \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03cc.","edit":"\u0395\u03c0\u03b5\u03be\u03b5\u03c1\u03b3\u03b1\u03c3\u03af\u03b1","bacs.confirm":"\u0395\u03c0\u03b9\u03b2\u03b5\u03b2\u03b1\u03af\u03c9\u03c3\u03b7 \u03ba\u03b1\u03b9 \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae","bacs.result.introduction":"\u039a\u03b1\u03c4\u03b5\u03b2\u03ac\u03c3\u03c4\u03b5 \u03c4\u03b7\u03bd \u0395\u03bd\u03c4\u03bf\u03bb\u03ae \u0386\u03bc\u03b5\u03c3\u03b7\u03c2 \u03a7\u03c1\u03ad\u03c9\u03c3\u03b7\u03c2 (DDI/\u0395\u03bd\u03c4\u03bf\u03bb\u03ae)","download.pdf":"\u039b\u03ae\u03c8\u03b7 PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe \u03b3\u03b9\u03b1 \u03b1\u03c3\u03c6\u03b1\u03bb\u03ae \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","creditCard.encryptedCardNumber.aria.label":"\u03a0\u03b5\u03b4\u03af\u03bf \u03b1\u03c1\u03b9\u03b8\u03bc\u03bf\u03cd \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe \u03b3\u03b9\u03b1 \u03b1\u03c3\u03c6\u03b1\u03bb\u03ae \u03b7\u03bc\u03b5\u03c1\u03bf\u03bc\u03b7\u03bd\u03af\u03b1 \u03bb\u03ae\u03be\u03b7\u03c2 \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","creditCard.encryptedExpiryDate.aria.label":"\u03a0\u03b5\u03b4\u03af\u03bf \u03b7\u03bc\u03b5\u03c1\u03bf\u03bc\u03b7\u03bd\u03af\u03b1\u03c2 \u03bb\u03ae\u03be\u03b7\u03c2","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe \u03b3\u03b9\u03b1 \u03b1\u03c3\u03c6\u03b1\u03bb\u03ae \u03bc\u03ae\u03bd\u03b1 \u03bb\u03ae\u03be\u03b7\u03c2 \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","creditCard.encryptedExpiryMonth.aria.label":"\u03a0\u03b5\u03b4\u03af\u03bf \u03bc\u03ae\u03bd\u03b1 \u03bb\u03ae\u03be\u03b7\u03c2","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe \u03b3\u03b9\u03b1 \u03b1\u03c3\u03c6\u03b1\u03bb\u03ad\u03c2 \u03ad\u03c4\u03bf\u03c2 \u03bb\u03ae\u03be\u03b7\u03c2 \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","creditCard.encryptedExpiryYear.aria.label":"\u03a0\u03b5\u03b4\u03af\u03bf \u03ad\u03c4\u03bf\u03c5\u03c2 \u03bb\u03ae\u03be\u03b7\u03c2","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe \u03b3\u03b9\u03b1 \u03b1\u03c3\u03c6\u03b1\u03bb\u03ae \u03ba\u03c9\u03b4\u03b9\u03ba\u03cc \u03b1\u03c3\u03c6\u03b1\u03bb\u03b5\u03af\u03b1\u03c2 \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","creditCard.encryptedSecurityCode.aria.label":"\u03a0\u03b5\u03b4\u03af\u03bf \u03ba\u03c9\u03b4\u03b9\u03ba\u03bf\u03cd \u03b1\u03c3\u03c6\u03b1\u03bb\u03b5\u03af\u03b1\u03c2","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe \u03b3\u03b9\u03b1 \u03b1\u03c3\u03c6\u03b1\u03bb\u03ae \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc \u03b4\u03c9\u03c1\u03bf\u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","giftcard.encryptedCardNumber.aria.label":"\u03a0\u03b5\u03b4\u03af\u03bf \u03b1\u03c1\u03b9\u03b8\u03bc\u03bf\u03cd \u03b4\u03c9\u03c1\u03bf\u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe \u03b3\u03b9\u03b1 \u03b1\u03c3\u03c6\u03b1\u03bb\u03ae \u03ba\u03c9\u03b4\u03b9\u03ba\u03cc \u03b1\u03c3\u03c6\u03b1\u03bb\u03b5\u03af\u03b1\u03c2 \u03b4\u03c9\u03c1\u03bf\u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","giftcard.encryptedSecurityCode.aria.label":"\u03a0\u03b5\u03b4\u03af\u03bf \u03ba\u03c9\u03b4\u03b9\u03ba\u03bf\u03cd \u03b1\u03c3\u03c6\u03b1\u03bb\u03b5\u03af\u03b1\u03c2 \u03b4\u03c9\u03c1\u03bf\u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","giftcardTransactionLimit":"\u03a4\u03bf \u03bc\u03ad\u03b3\u03b9\u03c3\u03c4\u03bf \u03b5\u03c0\u03b9\u03c4\u03c1\u03b5\u03c0\u03cc\u03bc\u03b5\u03bd\u03bf \u03c0\u03bf\u03c3\u03cc \u03b1\u03bd\u03ac \u03c3\u03c5\u03bd\u03b1\u03bb\u03bb\u03b1\u03b3\u03ae \u03c3\u03b5 \u03b1\u03c5\u03c4\u03ae\u03bd \u03c4\u03b7 \u03b4\u03c9\u03c1\u03bf\u03ba\u03ac\u03c1\u03c4\u03b1 \u03b5\u03af\u03bd\u03b1\u03b9 %{amount}","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe \u03b3\u03b9\u03b1 \u03b1\u03c3\u03c6\u03b1\u03bb\u03ae \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc \u03c4\u03c1\u03b1\u03c0\u03b5\u03b6\u03b9\u03ba\u03bf\u03cd \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03bf\u03cd","ach.encryptedBankAccountNumber.aria.label":"\u03a0\u03b5\u03b4\u03af\u03bf \u03c4\u03c1\u03b1\u03c0\u03b5\u03b6\u03b9\u03ba\u03bf\u03cd \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03bf\u03cd","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe \u03b3\u03b9\u03b1 \u03b1\u03c3\u03c6\u03b1\u03bb\u03ae \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc \u03ba\u03c9\u03b4\u03b9\u03ba\u03bf\u03cd \u03c5\u03c0\u03bf\u03ba\u03b1\u03c4\u03b1\u03c3\u03c4\u03ae\u03bc\u03b1\u03c4\u03bf\u03c2 \u03c4\u03c1\u03ac\u03c0\u03b5\u03b6\u03b1\u03c2","ach.encryptedBankLocationId.aria.label":"\u03a0\u03b5\u03b4\u03af\u03bf \u03b1\u03c1\u03b9\u03b8\u03bc\u03bf\u03cd \u03ba\u03c9\u03b4\u03b9\u03ba\u03bf\u03cd \u03c5\u03c0\u03bf\u03ba\u03b1\u03c4\u03b1\u03c3\u03c4\u03ae\u03bc\u03b1\u03c4\u03bf\u03c2 \u03c4\u03c1\u03ac\u03c0\u03b5\u03b6\u03b1\u03c2"}')},function(e){e.exports=JSON.parse('{"payButton":"Pagar","payButton.redirecting":"Redirigiendo...","storeDetails":"Recordar para mi pr\xf3ximo pago","creditCard.holderName":"Nombre en la tarjeta","creditCard.holderName.placeholder":"Juan P\xe9rez","creditCard.holderName.invalid":"Nombre del titular de tarjeta no v\xe1lido","creditCard.numberField.title":"N\xfamero de tarjeta","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Fecha de expiraci\xf3n","creditCard.expiryDateField.placeholder":"MM/AA","creditCard.expiryDateField.month":"Mes","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"AA","creditCard.expiryDateField.year":"A\xf1o","creditCard.cvcField.title":"CVC / CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"Recordar para la pr\xf3xima vez","creditCard.cvcField.placeholder.4digits":"4 d\xedgitos","creditCard.cvcField.placeholder.3digits":"3 d\xedgitos","creditCard.taxNumber.placeholder":"YYMMDD/0123456789","installments":"N\xfamero de plazos","installmentOption":"%{times}x %{partialValue}","installmentOptionMonths":"%{times}\xa0meses","installments.oneTime":"Pago \xfanico","installments.installments":"Pago fraccionado","installments.revolving":"Pago rotativo","sepaDirectDebit.ibanField.invalid":"N\xfamero de cuenta no v\xe1lido","sepaDirectDebit.nameField.placeholder":"J. Smith","sepa.ownerName":"Nombre del titular de cuenta","sepa.ibanNumber":"N\xfamero de cuenta (IBAN)","error.title":"Error","error.subtitle.redirect":"Redirecci\xf3n fallida","error.subtitle.payment":"Pago fallido","error.subtitle.refused":"Pago rechazado","error.message.unknown":"Se ha producido un error desconocido","idealIssuer.selectField.title":"Banco","idealIssuer.selectField.placeholder":"Seleccione su banco","creditCard.success":"Pago realizado correctamente","loading":"Cargando...","continue":"Continuar","continueTo":"Continuar a","wechatpay.timetopay":"Tiene %@ para pagar","wechatpay.scanqrcode":"Escanear c\xf3digo QR","personalDetails":"Datos personales","companyDetails":"Datos de la empresa","companyDetails.name":"Nombre de la empresa","companyDetails.registrationNumber":"N\xfamero de registro","socialSecurityNumber":"N\xfamero de seguridad social","firstName":"Nombre","infix":"Prefijo","lastName":"Apellidos","mobileNumber":"Tel\xe9fono m\xf3vil","mobileNumber.invalid":"N\xfamero de m\xf3vil no v\xe1lido","city":"Ciudad","postalCode":"C\xf3digo postal","countryCode":"Prefijo internacional","telephoneNumber":"N\xfamero de tel\xe9fono","dateOfBirth":"Fecha de nacimiento","shopperEmail":"Direcci\xf3n de correo electr\xf3nico","gender":"G\xe9nero","male":"Masculino","female":"Femenino","billingAddress":"Direcci\xf3n de facturaci\xf3n","street":"Calle","stateOrProvince":"Provincia o estado","country":"Pa\xeds","houseNumberOrName":"N\xfamero de vivienda","separateDeliveryAddress":"Especificar otra direcci\xf3n de env\xedo","deliveryAddress":"Direcci\xf3n de env\xedo","zipCode":"C\xf3digo postal","apartmentSuite":"Apartamento/suite","provinceOrTerritory":"Provincia o territorio","cityTown":"Ciudad/poblaci\xf3n","address":"Direcci\xf3n","state":"Estado","creditCard.cvcField.title.optional":"CVC / CVV (opcional)","issuerList.wallet.placeholder":"Seleccione su monedero electr\xf3nico","privacyPolicy":"Pol\xedtica de privacidad","afterPay.agreement":"S\xed, acepto las %@ de AfterPay","paymentConditions":"condiciones de pago","openApp":"Abrir la aplicaci\xf3n","voucher.readInstructions":"Leer instrucciones","voucher.introduction":"Gracias por su compra. Use el siguiente cup\xf3n para completar su pago.","voucher.expirationDate":"Fecha de caducidad","voucher.alternativeReference":"Referencia alternativa","dragonpay.voucher.non.bank.selectField.placeholder":"Seleccione su proveedor","dragonpay.voucher.bank.selectField.placeholder":"Seleccione su banco","voucher.paymentReferenceLabel":"Referencia de pago","voucher.surcharge":"Incluye recargo de %@","voucher.introduction.doku":"Gracias por su compra. Use la informaci\xf3n siguiente para completar su pago.","voucher.shopperName":"Nombre del comprador","voucher.merchantName":"Vendedor","voucher.introduction.econtext":"Gracias por su compra. Use la informaci\xf3n siguiente para completar su pago.","voucher.telephoneNumber":"N\xfamero de tel\xe9fono","voucher.shopperReference":"Referencia cliente","voucher.collectionInstitutionNumber":"N\xfamero de instituci\xf3n de cobro","voucher.econtext.telephoneNumber.invalid":"El n\xfamero de tel\xe9fono debe tener 10 u 11 d\xedgitos","boletobancario.btnLabel":"Generar Boleto","boleto.sendCopyToEmail":"Enviar copia a mi correo electr\xf3nico","button.copy":"Copiar","button.download":"Descargar","creditCard.storedCard.description.ariaLabel":"La tarjeta almacenada termina en %@","voucher.entity":"Entidad","donateButton":"Donar","notNowButton":"Ahora no","thanksForYourSupport":"\xa1Gracias por su contribuci\xf3n!","preauthorizeWith":"Preautorizar con","confirmPreauthorization":"Confirmar preautorizaci\xf3n","confirmPurchase":"Confirmar compra","applyGiftcard":"Canjear","giftcardBalance":"Saldo de la tarjeta regalo","deductedBalance":"Saldo deducido","creditCard.pin.title":"PIN","creditCard.encryptedPassword.label":"Primeros 2 d\xedgitos de la contrase\xf1a de la tarjeta","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Contrase\xf1a incorrecta","creditCard.taxNumber.label":"Fecha de nacimiento del titular de la tarjeta (AAMMDD) o n\xfamero de registro comercial (10 d\xedgitos)","creditCard.taxNumber.labelAlt":"N\xfamero de registro comercial (10 d\xedgitos)","creditCard.taxNumber.invalid":"Fecha de nacimiento del titular o n\xfamero de registro comercial incorrectos","storedPaymentMethod.disable.button":"Eliminar","storedPaymentMethod.disable.confirmation":"Eliminar m\xe9todo de pago almacenado","storedPaymentMethod.disable.confirmButton":"S\xed, eliminar","storedPaymentMethod.disable.cancelButton":"Cancelar","ach.bankAccount":"Cuenta bancaria","ach.accountHolderNameField.title":"Nombre del titular de la cuenta","ach.accountHolderNameField.placeholder":"Juan P\xe9rez","ach.accountHolderNameField.invalid":"El nombre del titular de la cuenta no es v\xe1lido","ach.accountNumberField.title":"N\xfamero de cuenta","ach.accountNumberField.invalid":"N\xfamero de cuenta no v\xe1lido","ach.accountLocationField.title":"N\xfamero de ruta ABA","ach.accountLocationField.invalid":"El n\xfamero de ruta ABA no es v\xe1lido","select.state":"Seleccione el estado","select.stateOrProvince":"Seleccione el estado o provincia","select.provinceOrTerritory":"Seleccione la provincia o territorio","select.country":"Seleccione el pa\xeds","telephoneNumber.invalid":"El n\xfamero de tel\xe9fono no es v\xe1lido","qrCodeOrApp":"o","paypal.processingPayment":"Procesando pago...","generateQRCode":"Generar c\xf3digo QR","await.waitForConfirmation":"Esperando confirmaci\xf3n","mbway.confirmPayment":"Confirme su pago en la aplicaci\xf3n MB WAY","shopperEmail.invalid":"La direcci\xf3n de correo electr\xf3nico no es v\xe1lida","dateOfBirth.format":"DD/MM/AAAA","dateOfBirth.invalid":"Debe ser mayor de 18 a\xf1os","blik.confirmPayment":"Abra la aplicaci\xf3n de su banco para confirmar el pago.","blik.invalid":"Introduzca 6 d\xedgitos","blik.code":"C\xf3digo de 6 d\xedgitos","blik.help":"Consiga el c\xf3digo en la aplicaci\xf3n de su banco.","swish.pendingMessage":"Tras escanearlo, su estado puede seguir en pendiente hasta 10\xa0minutos. Podr\xedan realizarse varios cargos si se intenta pagar de nuevo durante este periodo.","error.va.gen.01":"Campo incompleto","error.va.gen.02":"Campo no v\xe1lido","error.va.sf-cc-num.01":"N\xfamero de tarjeta no v\xe1lido","error.va.sf-cc-num.03":"Se ha introducido una tarjeta no admitida","error.va.sf-cc-dat.01":"Tarjeta demasiado vieja","error.va.sf-cc-dat.02":"Fecha con demasiada antelaci\xf3n","error.giftcard.no-balance":"Esta tarjeta regalo no tiene saldo","error.giftcard.card-error":"No tenemos ninguna tarjeta regalo con este n\xfamero en nuestros registros.","error.giftcard.currency-error":"Las tarjetas regalo solo son v\xe1lidas en la moneda en que fueron emitidas","amazonpay.signout":"Salir de Amazon","amazonpay.changePaymentDetails":"Cambiar detalles de pago","partialPayment.warning":"Seleccione otro m\xe9todo de pago para pagar la cantidad restante","partialPayment.remainingBalance":"El saldo restante ser\xe1 %{{amount}","bankTransfer.beneficiary":"Beneficiario","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"referencia","bankTransfer.introduction":"Contin\xfae para crear un nuevo pago mediante transferencia bancaria. Puede utilizar los detalles en la siguiente pantalla para finalizar este pago.","bankTransfer.instructions":"Gracias por su compra. Use la siguiente informaci\xf3n para completar su pago.","bacs.accountHolderName":"Nombre del titular de la cuenta bancaria","bacs.accountHolderName.invalid":"El nombre del titular de la cuenta bancaria no es v\xe1lido","bacs.accountNumber":"N\xfamero de cuenta bancaria","bacs.accountNumber.invalid":"El n\xfamero de cuenta bancaria no es v\xe1lido","bacs.bankLocationId":"C\xf3digo de sucursal","bacs.bankLocationId.invalid":"El c\xf3digo de sucursal no es v\xe1lido","bacs.consent.amount":"Estoy de acuerdo con que la cantidad anterior se deduzca de mi cuenta bancaria.","bacs.consent.account":"Confirmo que la cuenta est\xe1 a mi nombre y soy el \xfanico firmante necesario para autorizar d\xe9bitos directos en esta cuenta.","edit":"Editar","bacs.confirm":"Confirmar y pagar","bacs.result.introduction":"Descargue su instrucci\xf3n de d\xe9bito directo (IDD/mandato)","download.pdf":"Descargar PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe del n\xfamero de tarjeta asegurada","creditCard.encryptedCardNumber.aria.label":"Campo del n\xfamero de tarjeta","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe de la fecha de caducidad de la tarjeta asegurada","creditCard.encryptedExpiryDate.aria.label":"Campo de la fecha de caducidad","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe del mes de caducidad de tarjeta asegurada","creditCard.encryptedExpiryMonth.aria.label":"Campo del mes de caducidad","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe del a\xf1o de caducidad de la tarjeta asegurada","creditCard.encryptedExpiryYear.aria.label":"Campo del a\xf1o de caducidad","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe del c\xf3digo de seguridad de la tarjeta asegurada","creditCard.encryptedSecurityCode.aria.label":"Campo del c\xf3digo de seguridad","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe del n\xfamero de la tarjeta de regalo asegurada","giftcard.encryptedCardNumber.aria.label":"Campo del n\xfamero de la tarjeta de regalo","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe del c\xf3digo de seguridad de la tarjeta de regalo asegurada","giftcard.encryptedSecurityCode.aria.label":"Campo del c\xf3digo de seguridad de la tarjeta de regalo","giftcardTransactionLimit":"Se permite un m\xe1ximo de %{amount} por transacci\xf3n en esta tarjeta de regalo","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe del n\xfamero de la cuenta bancaria asegurada","ach.encryptedBankAccountNumber.aria.label":"Campo de la cuenta bancaria","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe del n\xfamero de ruta del banco asegurado","ach.encryptedBankLocationId.aria.label":"Campo del n\xfamero de ruta del banco"}')},function(e){e.exports=JSON.parse('{"payButton":"Maksa","payButton.redirecting":"Uudelleenohjataan ...","storeDetails":"Tallenna seuraavaa maksuani varten","creditCard.holderName":"Nimi kortilla","creditCard.holderName.placeholder":"J. Smith","creditCard.holderName.invalid":"Ei-kelvollinen kortinhaltijan nimi","creditCard.numberField.title":"Kortin numero","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Voimassaolop\xe4iv\xe4m\xe4\xe4r\xe4","creditCard.expiryDateField.placeholder":"KK / VV","creditCard.expiryDateField.month":"Kuukausi","creditCard.expiryDateField.month.placeholder":"KK","creditCard.expiryDateField.year.placeholder":"VV","creditCard.expiryDateField.year":"Vuosi","creditCard.cvcField.title":"CVC / CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"Muista seuraavalla kerralla","creditCard.cvcField.placeholder.4digits":"4 lukua","creditCard.cvcField.placeholder.3digits":"3 lukua","creditCard.taxNumber.placeholder":"VVKKPP / 0123456789","installments":"Asennusten m\xe4\xe4r\xe4","installmentOption":"% {kertaa} x% {osittainenarvo}","installmentOptionMonths":"% {kertaa} kuukautta","installments.oneTime":"Kertamaksu","installments.installments":"Er\xe4maksu","installments.revolving":"Toistuva maksu","sepaDirectDebit.ibanField.invalid":"V\xe4\xe4r\xe4 tilin numero","sepaDirectDebit.nameField.placeholder":"J. Smith","sepa.ownerName":"Haltijan nimi","sepa.ibanNumber":"Tilinumero (IBAN)","error.title":"Virhe","error.subtitle.redirect":"Uuteen kohteeseen siirto ep\xe4onnistui","error.subtitle.payment":"Maksu ep\xe4nnistui","error.subtitle.refused":"Maksu hyl\xe4tty","error.message.unknown":"Tapahtui tuntematon virhe","idealIssuer.selectField.title":"Pankki","idealIssuer.selectField.placeholder":"Valitse pankkisi","creditCard.success":"Maksu onnistui","loading":"Ladataan...","continue":"Jatka","continueTo":"Jatka kohteeseen","wechatpay.timetopay":"Sinulla on %@ maksettavana","wechatpay.scanqrcode":"Skannaa QR-koodi","personalDetails":"Henkil\xf6tiedot","companyDetails":"Yhti\xf6n tiedot","companyDetails.name":"Yhti\xf6n nimi","companyDetails.registrationNumber":"Rekisterinumero","socialSecurityNumber":"Sosiaaliturvatunnus","firstName":"Etunimi","infix":"Etuliite","lastName":"Sukunimi","mobileNumber":"Matkapuhelinnumero","mobileNumber.invalid":"Ei-kelvollinen matkapuhelinnumero","city":"Kaupunki","postalCode":"Postinumero","countryCode":"Maakoodi","telephoneNumber":"Puhelinnumero","dateOfBirth":"Syntym\xe4aika","shopperEmail":"S\xe4hk\xf6postiosoite","gender":"Sukupuoli","male":"Mies","female":"Nainen","billingAddress":"Laskutusosoite","street":"Katu","stateOrProvince":"Osavaltio tai l\xe4\xe4ni","country":"Maa","houseNumberOrName":"Talon numero","separateDeliveryAddress":"M\xe4\xe4rit\xe4 erillinen toimitusosoite","deliveryAddress":"Toimitusosoite","zipCode":"Postinumero","apartmentSuite":"Huoneisto / sviitti","provinceOrTerritory":"Maakunta tai alue","cityTown":"Kaupunki / taajama","address":"Osoite","state":"Osavaltio","creditCard.cvcField.title.optional":"CVC / CVV (valinnainen)","issuerList.wallet.placeholder":"Valitse lompakkosi","privacyPolicy":"Tietosuojamenettely","afterPay.agreement":"Hyv\xe4ksyn AfterPayn %@","paymentConditions":"maksuehdot","openApp":"Avaa sovellus","voucher.readInstructions":"Lue ohjeet","voucher.introduction":"Kiitos hankinnastasi, k\xe4yt\xe4 seuraavaa kuponkia vied\xe4ksesi maksusi p\xe4\xe4t\xf6kseen.","voucher.expirationDate":"Vanhenemisp\xe4iv\xe4m\xe4\xe4r\xe4","voucher.alternativeReference":"Vaihtoehtoinen viite","dragonpay.voucher.non.bank.selectField.placeholder":"Valitse toimittajasi","dragonpay.voucher.bank.selectField.placeholder":"Valitse pankkisi","voucher.paymentReferenceLabel":"Maksun viite","voucher.surcharge":"Sis. %@ lis\xe4maksun","voucher.introduction.doku":"Kiitos hankinnastasi, k\xe4yt\xe4 seuraavia tietoja p\xe4\xe4tt\xe4\xe4ksesi maksusi.","voucher.shopperName":"Ostajan nimi","voucher.merchantName":"Kauppias","voucher.introduction.econtext":"Kiitos hankinnastasi, k\xe4yt\xe4 seuraavia tietoja p\xe4\xe4tt\xe4\xe4ksesi maksusi.","voucher.telephoneNumber":"Puhelinnumero","voucher.shopperReference":"Ostajan viite","voucher.collectionInstitutionNumber":"Ker\xe4\xe4v\xe4n laitoksen numero","voucher.econtext.telephoneNumber.invalid":"Puhelinnumeron on oltava 10 tai 11 numeroa pitk\xe4","boletobancario.btnLabel":"Luo Boleto","boleto.sendCopyToEmail":"L\xe4het\xe4 kopio s\xe4hk\xf6postiini","button.copy":"Kopio","button.download":"Lataa","creditCard.storedCard.description.ariaLabel":"Tallennetun kortin viimeiset luvut ovat %@","voucher.entity":"Kokonaisuus","donateButton":"Lahjoita","notNowButton":"Ei nyt","thanksForYourSupport":"Kiitos tuestasi!","preauthorizeWith":"Ennkkolupa k\xe4ytt\xe4j\xe4n kanssa","confirmPreauthorization":"Vahvista ennakkolupa","confirmPurchase":"Vahvista hankinta","applyGiftcard":"Lunasta","giftcardBalance":"Lahjakortin saldo","deductedBalance":"V\xe4hennetty saldo","creditCard.pin.title":"Pin-tunnus","creditCard.encryptedPassword.label":"Kortin salasanan ensimm\xe4iset 2 lukua","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Kelpaamaton salasana","creditCard.taxNumber.label":"Kortinhaltijan syntym\xe4p\xe4iv\xe4 (VVKKPP) tai yrityksen rekisterinumero (10 lukua)","creditCard.taxNumber.labelAlt":"Yrityksen rekisterinumero (10 lukua)","creditCard.taxNumber.invalid":"Kelpaamaton kortinhaltijan syntym\xe4p\xe4iv\xe4 (VVKKPP) tai yrityksen rekisterinumero","storedPaymentMethod.disable.button":"Poista","storedPaymentMethod.disable.confirmation":"Poista tallennettu maksutapa","storedPaymentMethod.disable.confirmButton":"Kyll\xe4, poista","storedPaymentMethod.disable.cancelButton":"Peruuta","ach.bankAccount":"Pankkitili","ach.accountHolderNameField.title":"Tilinhaltijan nimi","ach.accountHolderNameField.placeholder":"J. Smith","ach.accountHolderNameField.invalid":"Ei-kelvollinen tilinhaltijan nimi","ach.accountNumberField.title":"Tilinumero","ach.accountNumberField.invalid":"V\xe4\xe4r\xe4 tilin numero","ach.accountLocationField.title":"ABA-reititysnumero","ach.accountLocationField.invalid":"Ei-kelvollinen ABA-reititysnumero","select.state":"Valitse osavaltio","select.stateOrProvince":"Valitse osavaltio tai l\xe4\xe4ni","select.provinceOrTerritory":"Valitse maakunta tai alue","select.country":"Valitse maa","telephoneNumber.invalid":"Ei-kelvollinen puhelinnumero","qrCodeOrApp":"tai","paypal.processingPayment":"Maksua k\xe4sitell\xe4\xe4n...","generateQRCode":"Tuota QR-koodi","await.waitForConfirmation":"Odottaa vahvistusta","mbway.confirmPayment":"Vahvista maksusi MB WAY -sovelluksella","shopperEmail.invalid":"Ei-kelvollinen s\xe4hk\xf6postiosoite","dateOfBirth.format":"PP/KK/VVVV","dateOfBirth.invalid":"Sinun on oltava v\xe4hint\xe4\xe4n 18-vuotias","blik.confirmPayment":"Avaa pankkisovelluksesi vahvistaaksesi maksun.","blik.invalid":"Sy\xf6t\xe4 6 lukua","blik.code":"6-numeroinen koodi","blik.help":"Hanki koodi pankkisovelluksestasi.","swish.pendingMessage":"Skannattuasi, tila voi odottaa jopa 10 minuuttia. Yritys maksaa uudelleen t\xe4ss\xe4 ajassa voi tuottaa moninkertaisia maksuja.","error.va.gen.01":"T\xe4ydent\xe4m\xe4t\xf6n kentt\xe4","error.va.gen.02":"Kentt\xe4 ei kelpaa","error.va.sf-cc-num.01":"V\xe4\xe4r\xe4 kortin numero","error.va.sf-cc-num.03":"Ei-tuettu kortti asetettu","error.va.sf-cc-dat.01":"Kortti on liian vanha","error.va.sf-cc-dat.02":"P\xe4iv\xe4m\xe4\xe4r\xe4 liian kaukana tulevaisuudessa","error.giftcard.no-balance":"Lahjakortin saldo on nolla","error.giftcard.card-error":"Asiakirjoissamme ei ole t\xe4m\xe4n numeron lahjakorttia","error.giftcard.currency-error":"Gift cards are only valid in the currency they were issued in","amazonpay.signout":"Kirjaudu ulos Amazonista","amazonpay.changePaymentDetails":"Muuta maksutietoja","partialPayment.warning":"Valitse toinen maksutapa j\xe4\xe4nn\xf6ksen maksamiseksi","partialPayment.remainingBalance":"J\xe4ljell\xe4 oleva saldo on% {summa}","bankTransfer.beneficiary":"Edunsaaja","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"Viite","bankTransfer.introduction":"Jatka uuden pankkisiirtomaksun luomista. Voit viimeistell\xe4 t\xe4m\xe4n maksun seuraavan n\xe4yt\xf6n tietojen avulla.","bankTransfer.instructions":"Kiitos hankinnastasi, k\xe4yt\xe4 seuraavia tietoja p\xe4\xe4tt\xe4\xe4ksesi maksusi.","bacs.accountHolderName":"Tilinhaltijan nimi","bacs.accountHolderName.invalid":"Ei-kelvollinen tilinhaltijan nimi","bacs.accountNumber":"Pankkitilinumero","bacs.accountNumber.invalid":"V\xe4\xe4r\xe4 tilin numero","bacs.bankLocationId":"Lajittelukoodi","bacs.bankLocationId.invalid":"Ei-kelvollinen lajittelukoodi","bacs.consent.amount":"Hyv\xe4ksyn, ett\xe4 alla oleva summa veloitetaan pankkitililt\xe4ni.","bacs.consent.account":"Vahvistan, ett\xe4 tili on nimess\xe4ni ja olen ainoa allekirjoittaja, joka vaaditaan valtuuttamaan suoraveloitus t\xe4ll\xe4 tilill\xe4.","edit":"Muokkaa","bacs.confirm":"Vahvista ja maksa","bacs.result.introduction":"Lataa suoraveloitusohjeet (DDI / Mandate)","download.pdf":"Lataa PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe suojatulle kortin numerolle","creditCard.encryptedCardNumber.aria.label":"Kortin numero -kentt\xe4","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe suojatulle kortin viimeiselle k\xe4ytt\xf6p\xe4iv\xe4lle","creditCard.encryptedExpiryDate.aria.label":"Viimeinen voimassaolop\xe4iv\xe4 -kentt\xe4","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe suojatulle kortin viimeiselle k\xe4ytt\xf6kuukaudelle","creditCard.encryptedExpiryMonth.aria.label":"Viimeinen voimassaolokuukausi -kentt\xe4","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe suojatulle kortin viimeiselle voimassaolovuodelle","creditCard.encryptedExpiryYear.aria.label":"Viimeinen voimassaolovuosi-kentt\xe4","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe suojatulle kortin turvakoodille","creditCard.encryptedSecurityCode.aria.label":"Turvakoodikentt\xe4","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe suojatulle lahjakortin numerolle","giftcard.encryptedCardNumber.aria.label":"Lahjakorttinumeron kentt\xe4","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe suojatulle lahjakortin turvakoodille","giftcard.encryptedSecurityCode.aria.label":"Lahjakortin turvakoodikentt\xe4","giftcardTransactionLimit":"Maks. % {summa} sallittu tapahtumaa kohti t\xe4ll\xe4 lahjakortilla","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe suojatulle pankkitilinumerolle","ach.encryptedBankAccountNumber.aria.label":"Pankkitilikentt\xe4","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe suojatulle pankin reititysnumerolle","ach.encryptedBankLocationId.aria.label":"Pankin reititysnumerokentt\xe4"}')},function(e){e.exports=JSON.parse('{"payButton":"Payer","payButton.redirecting":"Redirection...","storeDetails":"Sauvegarder pour mon prochain paiement","creditCard.holderName":"Nom sur la carte","creditCard.holderName.placeholder":"J. Smith","creditCard.holderName.invalid":"Nom du porteur de carte incorrect","creditCard.numberField.title":"Num\xe9ro de la carte","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Date d\'expiration","creditCard.expiryDateField.placeholder":"MM/AA","creditCard.expiryDateField.month":"Mois","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"AA","creditCard.expiryDateField.year":"Ann\xe9e","creditCard.cvcField.title":"CVC / CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"Enregistrer pour la prochaine fois","creditCard.cvcField.placeholder.4digits":"4\xa0chiffres","creditCard.cvcField.placeholder.3digits":"3\xa0chiffres","creditCard.taxNumber.placeholder":"AAMMJJ / 0123456789","installments":"Nombre de versements","installmentOption":"%{times}x %{partialValue}","installmentOptionMonths":"%{times}\xa0mois","installments.oneTime":"Paiement unique","installments.installments":"Paiement \xe9chelonn\xe9","installments.revolving":"Paiement en plusieurs fois","sepaDirectDebit.ibanField.invalid":"Num\xe9ro de compte non valide","sepaDirectDebit.nameField.placeholder":"N. Bernard","sepa.ownerName":"Au nom de","sepa.ibanNumber":"Num\xe9ro de compte (IBAN)","error.title":"Erreur","error.subtitle.redirect":"\xc9chec de la redirection","error.subtitle.payment":"\xc9chec du paiement","error.subtitle.refused":"Paiement refus\xe9","error.message.unknown":"Une erreur inconnue s\'est produite","idealIssuer.selectField.title":"Banque","idealIssuer.selectField.placeholder":"S\xe9lectionnez votre banque","creditCard.success":"Paiement r\xe9ussi","loading":"Chargement en cours...","continue":"Continuer","continueTo":"Poursuivre vers","wechatpay.timetopay":"Vous avez %@ pour payer cette somme","wechatpay.scanqrcode":"Scanner le code QR","personalDetails":"Informations personnelles","companyDetails":"Coordonn\xe9es de l\'entreprise","companyDetails.name":"Nom de l\'entreprise","companyDetails.registrationNumber":"Num\xe9ro d\'enregistrement","socialSecurityNumber":"Num\xe9ro de s\xe9curit\xe9 sociale","firstName":"Pr\xe9nom","infix":"Pr\xe9fixe","lastName":"Nom de famille","mobileNumber":"Num\xe9ro de portable","mobileNumber.invalid":"Num\xe9ro de portable non valide","city":"Ville","postalCode":"Code postal","countryCode":"Code pays","telephoneNumber":"Num\xe9ro de t\xe9l\xe9phone","dateOfBirth":"Date de naissance","shopperEmail":"Adresse e-mail","gender":"Sexe","male":"Homme","female":"Femme","billingAddress":"Adresse de facturation","street":"Rue","stateOrProvince":"\xc9tat ou province","country":"Pays","houseNumberOrName":"Num\xe9ro de rue","separateDeliveryAddress":"Indiquer une adresse de livraison distincte","deliveryAddress":"Adresse de livraison","zipCode":"Code postal","apartmentSuite":"Appartement","provinceOrTerritory":"Province ou territoire","cityTown":"Ville","address":"Adresse","state":"\xc9tat","creditCard.cvcField.title.optional":"CVC / CVV (facultatif)","issuerList.wallet.placeholder":"S\xe9lectionnez votre portefeuille","privacyPolicy":"Politique de confidentialit\xe9","afterPay.agreement":"J\'accepte les %@ de AfterPay","paymentConditions":"conditions de paiement","openApp":"Ouvrir l\'application","voucher.readInstructions":"Lire les instructions","voucher.introduction":"Merci pour votre achat, veuillez utiliser le coupon suivant pour finaliser votre paiement.","voucher.expirationDate":"Date d\'expiration","voucher.alternativeReference":"Autre r\xe9f\xe9rence","dragonpay.voucher.non.bank.selectField.placeholder":"S\xe9lectionnez votre fournisseur","dragonpay.voucher.bank.selectField.placeholder":"S\xe9lectionnez votre banque","voucher.paymentReferenceLabel":"R\xe9f\xe9rence du paiement","voucher.surcharge":"Comprend une surcharge de %@","voucher.introduction.doku":"Nous vous remercions de votre achat. Veuillez finaliser votre paiement \xe0 l\'aide des informations suivantes.","voucher.shopperName":"Nom de l\'acheteur","voucher.merchantName":"Marchand","voucher.introduction.econtext":"Nous vous remercions de votre achat. Veuillez finaliser votre paiement \xe0 l\'aide des informations suivantes.","voucher.telephoneNumber":"Num\xe9ro de t\xe9l\xe9phone","voucher.shopperReference":"R\xe9f\xe9rence client","voucher.collectionInstitutionNumber":"Num\xe9ro du point de paiement","voucher.econtext.telephoneNumber.invalid":"Le num\xe9ro de t\xe9l\xe9phone doit comporter 10 ou 11\xa0chiffres","boletobancario.btnLabel":"G\xe9n\xe9rer un Boleto","boleto.sendCopyToEmail":"Envoyer une copie \xe0 mon adresse e-mail","button.copy":"Copier","button.download":"T\xe9l\xe9charger","creditCard.storedCard.description.ariaLabel":"La carte enregistr\xe9e se termine en %@","voucher.entity":"Entit\xe9","donateButton":"Faire un don","notNowButton":"Pas maintenant","thanksForYourSupport":"Merci de votre soutien\xa0!","preauthorizeWith":"Pr\xe9-autoriser avec","confirmPreauthorization":"Confirmer la pr\xe9-autorisation","confirmPurchase":"Confirmer l\'achat","applyGiftcard":"Utiliser","giftcardBalance":"Solde de la carte cadeau","deductedBalance":"Solde d\xe9duit","creditCard.pin.title":"PIN","creditCard.encryptedPassword.label":"Les deux premiers chiffres du code de votre carte","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Code incorrect","creditCard.taxNumber.label":"Date de naissance du porteur de carte (au format AAMMJJ) ou num\xe9ro d\'identification de l\'entreprise (\xe0 10\xa0chiffres)","creditCard.taxNumber.labelAlt":"Num\xe9ro d\'identification de l\'entreprise (\xe0 10\xa0chiffres)","creditCard.taxNumber.invalid":"Date de naissance du porteur de carte ou num\xe9ro d\'identification de l\'entreprise incorrect(e)","storedPaymentMethod.disable.button":"Supprimer","storedPaymentMethod.disable.confirmation":"Supprimer le mode de paiement enregistr\xe9","storedPaymentMethod.disable.confirmButton":"Oui, supprimer","storedPaymentMethod.disable.cancelButton":"Annuler","ach.bankAccount":"Compte bancaire","ach.accountHolderNameField.title":"Nom du titulaire du compte","ach.accountHolderNameField.placeholder":"J. Smith","ach.accountHolderNameField.invalid":"Nom du titulaire du compte incorrect","ach.accountNumberField.title":"Num\xe9ro du compte","ach.accountNumberField.invalid":"Num\xe9ro du compte incorrect","ach.accountLocationField.title":"Code ABA","ach.accountLocationField.invalid":"Code ABA incorrect","select.state":"S\xe9lectionnez l\'\xc9tat","select.stateOrProvince":"S\xe9lectionnez l\'\xc9tat ou la province","select.provinceOrTerritory":"S\xe9lectionnez la province ou le territoire","select.country":"S\xe9lectionnez le pays","telephoneNumber.invalid":"Num\xe9ro de t\xe9l\xe9phone incorrect","qrCodeOrApp":"ou","paypal.processingPayment":"Traitement du paiement en cours...","generateQRCode":"G\xe9n\xe9rer un code QR","await.waitForConfirmation":"En attente de confirmation","mbway.confirmPayment":"Confirmez votre paiement sur l\'application MB WAY","shopperEmail.invalid":"Adresse e-mail incorrecte","dateOfBirth.format":"JJ/MM/AAAA","dateOfBirth.invalid":"Vous devez \xeatre \xe2g\xe9(e) d\'au moins 18\xa0ans","blik.confirmPayment":"Ouvrez votre application bancaire pour confirmer le paiement.","blik.invalid":"Saisissez les 6\xa0chiffres","blik.code":"Code \xe0 6\xa0chiffres","blik.help":"Ouvrez votre application bancaire pour obtenir le code.","swish.pendingMessage":"Apr\xe8s avoir scann\xe9 le code QR, la mise \xe0 jour du statut de paiement peut prendre jusqu\'\xe0 10\xa0minutes. Si vous effectuez une nouvelle tentative de paiement dans ce d\xe9lai, cela pourrait occasionner plusieurs d\xe9bits.","error.va.gen.01":"Champ incomplet","error.va.gen.02":"Champ non valide","error.va.sf-cc-num.01":"Num\xe9ro de carte non valide","error.va.sf-cc-num.03":"Carte ins\xe9r\xe9e non prise en charge","error.va.sf-cc-dat.01":"Carte trop ancienne","error.va.sf-cc-dat.02":"La date doit \xeatre plus proche","error.giftcard.no-balance":"Aucun solde n\'est disponible sur cette carte cadeau","error.giftcard.card-error":"Aucune carte cadeau ne correspond \xe0 ce num\xe9ro","error.giftcard.currency-error":"Les cartes cadeaux sont valables uniquement dans la devise dans laquelle elles ont \xe9t\xe9 \xe9mises","amazonpay.signout":"Se d\xe9connecter d\'Amazon","amazonpay.changePaymentDetails":"Modifier les informations de paiement","partialPayment.warning":"S\xe9lectionnez un autre mode de paiement pour r\xe9gler le solde","partialPayment.remainingBalance":"Le solde restant sera de %{amount}","bankTransfer.beneficiary":"B\xe9n\xe9ficiaire","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"R\xe9f\xe9rence","bankTransfer.introduction":"Continuez \xe0 cr\xe9er un nouveau paiement par virement bancaire. Utilisez les informations de l\'\xe9cran suivant pour finaliser ce paiement.","bankTransfer.instructions":"Merci pour votre achat\xa0! Veuillez utiliser les informations suivantes pour finaliser votre paiement.","bacs.accountHolderName":"Nom du titulaire du compte bancaire","bacs.accountHolderName.invalid":"Nom du titulaire du compte bancaire incorrect","bacs.accountNumber":"Num\xe9ro du compte bancaire","bacs.accountNumber.invalid":"Num\xe9ro du compte bancaire incorrect","bacs.bankLocationId":"Code de tri (sort code)","bacs.bankLocationId.invalid":"Code de tri (sort code) non valide","bacs.consent.amount":"J\'accepte que le montant ci-dessus soit d\xe9duit de mon compte bancaire.","bacs.consent.account":"Je confirme \xeatre le titulaire du compte et qu\'aucune autre signature que la mienne n\'est requise pour autoriser un pr\xe9l\xe8vement sur ce compte.","edit":"Modifier","bacs.confirm":"Confirmer et payer","bacs.result.introduction":"T\xe9l\xe9chargez votre mandat de pr\xe9l\xe8vement (DDI)","download.pdf":"T\xe9l\xe9charger le PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe pour le num\xe9ro de carte avec garantie","creditCard.encryptedCardNumber.aria.label":"Champ du num\xe9ro de carte","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe pour la date d\'expiration de la carte avec garantie","creditCard.encryptedExpiryDate.aria.label":"Champ de la date d\'expiration","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe pour le mois d\'expiration de la carte avec garantie","creditCard.encryptedExpiryMonth.aria.label":"Champ du mois d\'expiration","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe pour l\'ann\xe9e d\'expiration de la carte avec garantie","creditCard.encryptedExpiryYear.aria.label":"Champ de l\'ann\xe9e d\'expiration","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe pour le code de s\xe9curit\xe9 de la carte avec garantie","creditCard.encryptedSecurityCode.aria.label":"Champ du code de s\xe9curit\xe9","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe pour le num\xe9ro de la carte-cadeau avec garantie","giftcard.encryptedCardNumber.aria.label":"Champ du num\xe9ro de la carte cadeau","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe pour le code de s\xe9curit\xe9 de la carte-cadeau avec garantie","giftcard.encryptedSecurityCode.aria.label":"Champ du code de s\xe9curit\xe9 de la carte-cadeau","giftcardTransactionLimit":"Montant maximum autoris\xe9 par transaction avec cette carte cadeau\xa0: %{amount}","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe pour le num\xe9ro du compte bancaire avec garantie","ach.encryptedBankAccountNumber.aria.label":"Champ du compte bancaire","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe pour le num\xe9ro de routage du compte avec garantie","ach.encryptedBankLocationId.aria.label":"Champ du num\xe9ro de routage"}')},function(e){e.exports=JSON.parse('{"payButton":"Platiti","payButton.redirecting":"Preusmjeravanje...","storeDetails":"Pohrani za moje sljede\u0107e pla\u0107anje","creditCard.holderName":"Ime na kartici","creditCard.holderName.placeholder":"J. Smith","creditCard.holderName.invalid":"Neva\u017ee\u0107e ime vlasnika kartice","creditCard.numberField.title":"Broj kartice","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Datum isteka","creditCard.expiryDateField.placeholder":"MM/GG","creditCard.expiryDateField.month":"Mjesec","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"GG","creditCard.expiryDateField.year":"Godina","creditCard.cvcField.title":"CVC/CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"Zapamtiti za sljede\u0107i put","creditCard.cvcField.placeholder.4digits":"4 znamenke","creditCard.cvcField.placeholder.3digits":"3 znamenke","creditCard.taxNumber.placeholder":"YYMMDD / 0123456789","installments":"Broj rata","installmentOption":"%{times} x %{partialValue}","installmentOptionMonths":"Mjeseci: %{times}","installments.oneTime":"Jednokratno pla\u0107anje","installments.installments":"Pla\u0107anje na rate","installments.revolving":"Obnovljivo pla\u0107anje","sepaDirectDebit.ibanField.invalid":"Neva\u017ee\u0107i broj ra\u010duna","sepaDirectDebit.nameField.placeholder":"J. Smith","sepa.ownerName":"Ime vlasnika","sepa.ibanNumber":"Broj ra\u010duna (IBAN)","error.title":"Gre\u0161ka","error.subtitle.redirect":"Preusmjeravanje nije uspjelo","error.subtitle.payment":"Pla\u0107anje nije uspjelo","error.subtitle.refused":"Pla\u0107anje odbijeno","error.message.unknown":"Dogodila se nepoznata gre\u0161ka","idealIssuer.selectField.title":"Banka","idealIssuer.selectField.placeholder":"Odaberite banku","creditCard.success":"Pla\u0107anje uspje\u0161no","loading":"U\u010ditavanje\u2026","continue":"Nastavi","continueTo":"Nastavi na","wechatpay.timetopay":"Imate %@ za pla\u0107anje","wechatpay.scanqrcode":"Skeniraj QR k\xf4d","personalDetails":"Osobni podatci","companyDetails":"Detalji tvrtke","companyDetails.name":"Naziv tvrtke","companyDetails.registrationNumber":"Mati\u010dni broj","socialSecurityNumber":"Broj socijalnog osiguranja","firstName":"Ime","infix":"Prefiks","lastName":"Prezime","mobileNumber":"Broj mobilnog telefona","mobileNumber.invalid":"Neva\u017ee\u0107i broj mobilnog telefona","city":"Grad","postalCode":"Po\u0161tanski broj","countryCode":"Pozivni broj dr\u017eave","telephoneNumber":"Telefonski broj","dateOfBirth":"Datum ro\u0111enja","shopperEmail":"Adresa e-po\u0161te","gender":"Spol","male":"Mu\u0161karac","female":"\u017dena","billingAddress":"Adresa za ra\u010dun","street":"Ulica","stateOrProvince":"Dr\u017eava ili pokrajina","country":"Zemlja","houseNumberOrName":"Ku\u0107ni broj","separateDeliveryAddress":"Navedite zasebnu adresu za dostavu","deliveryAddress":"Adresa za dostavu","zipCode":"Po\u0161tanski broj","apartmentSuite":"Stan/apartman","provinceOrTerritory":"Pokrajina ili teritorij","cityTown":"Grad","address":"Adresa","state":"Savezna dr\u017eava","creditCard.cvcField.title.optional":"CVC/CVV (nije obavezno)","issuerList.wallet.placeholder":"Odaberite svoju nov\u010danik","privacyPolicy":"Politika privatnosti","afterPay.agreement":"Sla\u017eem se s %@ usluge AfterPay","paymentConditions":"uvjetima pla\u0107anja","openApp":"Otvorite aplikaciju","voucher.readInstructions":"Pro\u010ditajte upute","voucher.introduction":"Zahvaljujemo na kupnji, upotrijebite sljede\u0107i kupon za dovr\u0161etak pla\u0107anja.","voucher.expirationDate":"Datum isteka","voucher.alternativeReference":"Alternativna referenca","dragonpay.voucher.non.bank.selectField.placeholder":"Odaberite davatelja usluge","dragonpay.voucher.bank.selectField.placeholder":"Odaberite banku","voucher.paymentReferenceLabel":"Referenca za pla\u0107anje","voucher.surcharge":"Uklju\u010duje %@ nadoplate","voucher.introduction.doku":"Zahvaljujemo na kupnji, upotrijebite sljede\u0107e podatke za dovr\u0161etak pla\u0107anja.","voucher.shopperName":"Ime kupca","voucher.merchantName":"Trgovac","voucher.introduction.econtext":"Zahvaljujemo na kupnji, upotrijebite sljede\u0107e podatke za dovr\u0161etak pla\u0107anja.","voucher.telephoneNumber":"Broj telefona","voucher.shopperReference":"Referenca kupca","voucher.collectionInstitutionNumber":"Broj ustanove za prikupljanje","voucher.econtext.telephoneNumber.invalid":"Telefonski broj mora imati 10 ili 11 znamenki","boletobancario.btnLabel":"Generiraj Boleto","boleto.sendCopyToEmail":"Po\u0161alji kopiju na moju e-po\u0161tu","button.copy":"Kopiraj","button.download":"Preuzmi","creditCard.storedCard.description.ariaLabel":"Pohranjena kartica zavr\u0161ava na %@","voucher.entity":"Entitet","donateButton":"Doniraj","notNowButton":"Ne sada","thanksForYourSupport":"Hvala na podr\u0161ci!","preauthorizeWith":"Prethodno odobri s","confirmPreauthorization":"Potvrdite prethodno odobrenje","confirmPurchase":"Potvrdite kupnju","applyGiftcard":"Iskoristite","giftcardBalance":"Stanje na poklon-kartici","deductedBalance":"Potro\u0161eni iznos","creditCard.pin.title":"Pin","creditCard.encryptedPassword.label":"Prve 2 znamenke lozinke kartice","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Lozinka je neto\u010dna","creditCard.taxNumber.label":"Datum ro\u0111enja vlasnika kartice (GGMMDD) ili registracijski broj tvrtke (10 znamenki)","creditCard.taxNumber.labelAlt":"Registracijski broj tvrtke (10 znamenki)","creditCard.taxNumber.invalid":"Neto\u010dan datum ro\u0111enja vlasnika kartice (GGMMDD) ili registracijski broj tvrtke (10 znamenki)","storedPaymentMethod.disable.button":"Ukloni","storedPaymentMethod.disable.confirmation":"Uklonite pohranjeni na\u010din pla\u0107anja","storedPaymentMethod.disable.confirmButton":"Da, ukloni","storedPaymentMethod.disable.cancelButton":"Otka\u017ei","ach.bankAccount":"Bankovni ra\u010dun","ach.accountHolderNameField.title":"Ime vlasnika ra\u010duna","ach.accountHolderNameField.placeholder":"J. Smith","ach.accountHolderNameField.invalid":"Neva\u017ee\u0107e ime vlasnika ra\u010duna","ach.accountNumberField.title":"Broj ra\u010duna","ach.accountNumberField.invalid":"Neva\u017ee\u0107i broj ra\u010duna","ach.accountLocationField.title":"ABA identifikacijski broj","ach.accountLocationField.invalid":"Neva\u017ee\u0107i ABA identifikacijski broj","select.state":"Odaberite saveznu dr\u017eavu","select.stateOrProvince":"Odaberite dr\u017eavu ili provinciju","select.provinceOrTerritory":"Odaberite provinciju ili teritorij","select.country":"Odaberite dr\u017eavu","telephoneNumber.invalid":"Neva\u017ee\u0107i telefonski broj","qrCodeOrApp":"ili","paypal.processingPayment":"Obrada pla\u0107anja u tijeku...","generateQRCode":"Generirajte QR k\xf4d","await.waitForConfirmation":"\u010ceka se potvrda","mbway.confirmPayment":"Potvrdite uplatu u aplikaciji MB WAY","shopperEmail.invalid":"Neva\u017ee\u0107a adresa e-po\u0161te","dateOfBirth.format":"DD/MM/GGGG","dateOfBirth.invalid":"Morate imati najmanje 18 godina","blik.confirmPayment":"Otvorite svoju bankovnu aplikaciju kako biste potvrdili pla\u0107anje.","blik.invalid":"Unesite 6 znamenki","blik.code":"6-znamenkasti k\xf4d","blik.help":"Preuzmite k\xf4d iz bankovne aplikacije.","swish.pendingMessage":"Nakon skeniranja status mo\u017ee biti na \u010dekanju do 10 minuta. Poku\u0161aj ponovnog pla\u0107anja u istom periodu mo\u017ee rezultirati vi\u0161estrukim naplatama.","error.va.gen.01":"Nepotpuno polje","error.va.gen.02":"Neva\u017ee\u0107e polje","error.va.sf-cc-num.01":"Neva\u017ee\u0107i broj kartice","error.va.sf-cc-num.03":"Unijeli ste nepodr\u017eanu vrstu kartice","error.va.sf-cc-dat.01":"Kartica je prestara","error.va.sf-cc-dat.02":"Datum je predaleko u budu\u0107nosti","error.giftcard.no-balance":"Stanje na ovoj poklon-kartici iznosi nula","error.giftcard.card-error":"U na\u0161oj evidenciji nemamo poklon-karticu s ovim brojem","error.giftcard.currency-error":"Poklon-kartice vrijede samo u valuti u kojoj su izdane","amazonpay.signout":"Odjava iz Amazona","amazonpay.changePaymentDetails":"Promijenite pojedinosti o pla\u0107anju","partialPayment.warning":"Odaberite drugi na\u010din pla\u0107anja da biste platili preostali iznos","partialPayment.remainingBalance":"Preostalo stanje na ra\u010dunu iznosit \u0107e %{amount}","bankTransfer.beneficiary":"Primatelj","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"Referenca","bankTransfer.introduction":"Nastavite da biste kreirali novu uplatu putem bankovne transakcije. Za finaliziranje ovog pla\u0107anja mo\u017eete se koristiti pojedinostima na sljede\u0107em zaslonu.","bankTransfer.instructions":"Zahvaljujemo na kupnji, upotrijebite sljede\u0107e podatke za dovr\u0161etak pla\u0107anja.","bacs.accountHolderName":"Ime vlasnika bankovnog ra\u010duna","bacs.accountHolderName.invalid":"Neva\u017ee\u0107e ime vlasnika bankovnog ra\u010duna","bacs.accountNumber":"Broj bankovnog ra\u010duna","bacs.accountNumber.invalid":"Neva\u017ee\u0107i broj bankovnog ra\u010duna","bacs.bankLocationId":"Identifikacijski k\xf4d banke (UK)","bacs.bankLocationId.invalid":"Neva\u017ee\u0107i identifikacijski k\xf4d banke (UK)","bacs.consent.amount":"Sla\u017eem se da se gore navedeni iznos oduzme s mog bankovnog ra\u010duna.","bacs.consent.account":"Potvr\u0111ujem da je ra\u010dun na moje ime i da sam jedini potpisnik potreban za autorizaciju izravnog tere\u0107enja na ovom ra\u010dunu.","edit":"Uredi","bacs.confirm":"Potvrdi i plati","bacs.result.introduction":"Preuzmite upute za izravno tere\u0107enje (DDI / mandat)","download.pdf":"Preuzmite PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe za broj prepaid kartice","creditCard.encryptedCardNumber.aria.label":"Polje za broj kartice","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe za datum isteka prepaid kartice","creditCard.encryptedExpiryDate.aria.label":"Polje za datum isteka","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe za mjesec isteka prepaid kartice","creditCard.encryptedExpiryMonth.aria.label":"Polje za mjesec isteka","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe za godinu isteka prepaid kartice","creditCard.encryptedExpiryYear.aria.label":"Polje za godinu isteka","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe za sigurnosni k\xf4d prepaid kartice","creditCard.encryptedSecurityCode.aria.label":"Polje za sigurnosni k\xf4d","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe za broj prepaid poklon-kartice","giftcard.encryptedCardNumber.aria.label":"Polje za broj poklon-kartice","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe za sigurnosni k\xf4d prepaid poklon-kartice","giftcard.encryptedSecurityCode.aria.label":"Polje za sigurnosni k\xf4d poklon-kartice","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe za prepaid broj bankovnog ra\u010duna","ach.encryptedBankAccountNumber.aria.label":"Polje za broj bankovnog ra\u010duna","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe za identifikacijski broj prepaid banke","ach.encryptedBankLocationId.aria.label":"Polje za identifikacijski broj banke"}')},function(e){e.exports=JSON.parse('{"payButton":"Fizet\xe9s","payButton.redirecting":"\xc1tir\xe1ny\xedt\xe1s...","storeDetails":"Ment\xe9s a k\xf6vetkez\u0151 fizet\xe9shez","creditCard.holderName":"A k\xe1rty\xe1n szerepl\u0151 n\xe9v","creditCard.holderName.placeholder":"Gipsz Jakab","creditCard.holderName.invalid":"A k\xe1rtyatulajdonos neve \xe9rv\xe9nytelen","creditCard.numberField.title":"K\xe1rtyasz\xe1m","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Lej\xe1rati d\xe1tum","creditCard.expiryDateField.placeholder":"HH/\xc9\xc9","creditCard.expiryDateField.month":"H\xf3nap","creditCard.expiryDateField.month.placeholder":"HH","creditCard.expiryDateField.year.placeholder":"\xc9\xc9","creditCard.expiryDateField.year":"\xc9v","creditCard.cvcField.title":"CVC/CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"Megjegyz\xe9s a k\xf6vetkez\u0151 alkalomra","creditCard.cvcField.placeholder.4digits":"4 sz\xe1mjegy\u0171","creditCard.cvcField.placeholder.3digits":"3 sz\xe1mjegy\u0171","creditCard.taxNumber.placeholder":"\xc9\xc9HHNN / 0123456789","installments":"R\xe9szletek sz\xe1ma","installmentOption":"%{times} x %{partialValue}","installmentOptionMonths":"%{times} h\xf3nap","installments.oneTime":"Egy\xf6sszeg\u0171 fizet\xe9s","installments.installments":"R\xe9szletfizet\xe9s","installments.revolving":"T\xf6bb\xf6sszeg\u0171 fizet\xe9s","sepaDirectDebit.ibanField.invalid":"\xc9rv\xe9nytelen sz\xe1mlasz\xe1m","sepaDirectDebit.nameField.placeholder":"Gipsz Jakab","sepa.ownerName":"Sz\xe1mlatulajdonos neve","sepa.ibanNumber":"Sz\xe1mlasz\xe1m (IBAN)","error.title":"Hiba","error.subtitle.redirect":"Sikertelen \xe1tir\xe1ny\xedt\xe1s","error.subtitle.payment":"Sikertelen fizet\xe9s","error.subtitle.refused":"A fizet\xe9s elutas\xedtva","error.message.unknown":"Ismeretlen hiba t\xf6rt\xe9nt","idealIssuer.selectField.title":"Bank","idealIssuer.selectField.placeholder":"Bank kiv\xe1laszt\xe1sa","creditCard.success":"Sikeres fizet\xe9s","loading":"Bet\xf6lt\xe9s\u2026","continue":"Folytat\xe1s","continueTo":"Folytat\xe1s a k\xf6vetkez\u0151vel:","wechatpay.timetopay":"Fizet\xe9shez rendelkez\xe9sre \xe1ll\xf3 id\u0151: %@","wechatpay.scanqrcode":"QR-k\xf3d beolvas\xe1sa","personalDetails":"Szem\xe9lyes adatok","companyDetails":"C\xe9g adatai","companyDetails.name":"C\xe9gn\xe9v","companyDetails.registrationNumber":"C\xe9gjegyz\xe9ksz\xe1m","socialSecurityNumber":"Szem\xe9lyi igazolv\xe1ny sz\xe1ma","firstName":"Keresztn\xe9v","infix":"El\u0151tag","lastName":"Vezet\xe9kn\xe9v","mobileNumber":"Mobiltelefonsz\xe1m","mobileNumber.invalid":"\xc9rv\xe9nytelen mobilsz\xe1m","city":"V\xe1ros","postalCode":"Ir\xe1ny\xedt\xf3sz\xe1m","countryCode":"Orsz\xe1gk\xf3d","telephoneNumber":"Telefonsz\xe1m","dateOfBirth":"Sz\xfclet\xe9si d\xe1tum","shopperEmail":"E-mail-c\xedm","gender":"Nem","male":"F\xe9rfi","female":"N\u0151","billingAddress":"Sz\xe1ml\xe1z\xe1si c\xedm","street":"Utca","stateOrProvince":"\xc1llam vagy tartom\xe1ny","country":"Orsz\xe1g","houseNumberOrName":"H\xe1zsz\xe1m","separateDeliveryAddress":"Elt\xe9r\u0151 sz\xe1ll\xedt\xe1si c\xedm megad\xe1sa","deliveryAddress":"Sz\xe1ll\xedt\xe1si c\xedm","zipCode":"Ir\xe1ny\xedt\xf3sz\xe1m","apartmentSuite":"Lak\xe1s/ajt\xf3sz\xe1m","provinceOrTerritory":"Tartom\xe1ny vagy ter\xfclet","cityTown":"V\xe1ros","address":"C\xedm","state":"\xc1llam","creditCard.cvcField.title.optional":"CVC/CVV (opcion\xe1lis)","issuerList.wallet.placeholder":"P\xe9nzt\xe1rca kiv\xe1laszt\xe1sa","privacyPolicy":"Adatv\xe9delmi szab\xe1lyzat","afterPay.agreement":"Elfogadom az AfterPay %@","paymentConditions":"fizet\xe9si felt\xe9teleit","openApp":"Alkalmaz\xe1s megnyit\xe1sa","voucher.readInstructions":"Olvassa el az utas\xedt\xe1sokat","voucher.introduction":"K\xf6sz\xf6nj\xfck a v\xe1s\xe1rl\xe1st! K\xe9rj\xfck, a fizet\xe9shez haszn\xe1lja a k\xf6vetkez\u0151 kupont.","voucher.expirationDate":"Lej\xe1rati d\xe1tum","voucher.alternativeReference":"Alternat\xedv hivatkoz\xe1s","dragonpay.voucher.non.bank.selectField.placeholder":"Szolg\xe1ltat\xf3 kiv\xe1laszt\xe1sa","dragonpay.voucher.bank.selectField.placeholder":"Bank kiv\xe1laszt\xe1sa","voucher.paymentReferenceLabel":"Fizet\xe9si referencia","voucher.surcharge":"%@ p\xf3td\xedjat tartalmaz","voucher.introduction.doku":"K\xf6sz\xf6nj\xfck a v\xe1s\xe1rl\xe1st! K\xe9rj\xfck, a fizet\xe9shez haszn\xe1lja a k\xf6vetkez\u0151 inform\xe1ci\xf3t.","voucher.shopperName":"V\xe1s\xe1rl\xf3 neve","voucher.merchantName":"Keresked\u0151","voucher.introduction.econtext":"K\xf6sz\xf6nj\xfck a v\xe1s\xe1rl\xe1st! K\xe9rj\xfck, a fizet\xe9shez haszn\xe1lja a k\xf6vetkez\u0151 inform\xe1ci\xf3t.","voucher.telephoneNumber":"Telefonsz\xe1m","voucher.shopperReference":"V\xe1s\xe1rl\xf3i referencia","voucher.collectionInstitutionNumber":"Beszed\u0151 c\xe9g sz\xe1ma","voucher.econtext.telephoneNumber.invalid":"A telefonsz\xe1mnak 10 vagy 11 sz\xe1mjegyb\u0151l kell \xe1llnia","boletobancario.btnLabel":"Boleto l\xe9trehoz\xe1sa","boleto.sendCopyToEmail":"M\xe1solat k\xfcld\xe9se az e-mail-c\xedmemre","button.copy":"M\xe1sol\xe1s","button.download":"Let\xf6lt\xe9s","creditCard.storedCard.description.ariaLabel":"A t\xe1rolt k\xe1rtya sz\xe1m\xe1nak v\xe9gz\u0151d\xe9se: %@","voucher.entity":"Entit\xe1s","donateButton":"Adom\xe1nyoz\xe1s","notNowButton":"Most nem","thanksForYourSupport":"K\xf6sz\xf6nj\xfck a t\xe1mogat\xe1s\xe1t!","preauthorizeWith":"El\u0151zetes meghatalmaz\xe1s a k\xf6vetkez\u0151vel:","confirmPreauthorization":"El\u0151zetes meghatalmaz\xe1s j\xf3v\xe1hagy\xe1sa","confirmPurchase":"Fizet\xe9s j\xf3v\xe1hagy\xe1sa","applyGiftcard":"Bev\xe1lt\xe1s","giftcardBalance":"Aj\xe1nd\xe9kk\xe1rtya egyenlege","deductedBalance":"Levont egyenleg","creditCard.pin.title":"PIN-k\xf3d","creditCard.encryptedPassword.label":"K\xe1rtya jelszav\xe1nak els\u0151 2 sz\xe1mjegye","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"\xc9rv\xe9nytelen jelsz\xf3","creditCard.taxNumber.label":"K\xe1rtyatulajdonos sz\xfclet\xe9si d\xe1tuma (\xc9\xc9HHNN) vagy c\xe9gjegyz\xe9ksz\xe1m (10 sz\xe1mjegy\u0171)","creditCard.taxNumber.labelAlt":"C\xe9gjegyz\xe9ksz\xe1m (10 sz\xe1mjegy\u0171)","creditCard.taxNumber.invalid":"A k\xe1rtyatulajdonos sz\xfclet\xe9si d\xe1tuma vagy a c\xe9gjegyz\xe9ksz\xe1m \xe9rv\xe9nytelen","storedPaymentMethod.disable.button":"Elt\xe1vol\xedt\xe1s","storedPaymentMethod.disable.confirmation":"T\xe1rolt fizet\xe9si m\xf3d elt\xe1vol\xedt\xe1sa","storedPaymentMethod.disable.confirmButton":"Igen, elt\xe1vol\xedtom","storedPaymentMethod.disable.cancelButton":"M\xe9gse","ach.bankAccount":"Banksz\xe1mla","ach.accountHolderNameField.title":"Sz\xe1mlatulajdonos neve","ach.accountHolderNameField.placeholder":"Gipsz Jakab","ach.accountHolderNameField.invalid":"A sz\xe1mlatulajdonos neve \xe9rv\xe9nytelen","ach.accountNumberField.title":"Sz\xe1mlasz\xe1m","ach.accountNumberField.invalid":"\xc9rv\xe9nytelen sz\xe1mlasz\xe1m","ach.accountLocationField.title":"ABA-ir\xe1ny\xedt\xf3sz\xe1m","ach.accountLocationField.invalid":"\xc9rv\xe9nytelen ABA-ir\xe1ny\xedt\xf3sz\xe1m","select.state":"\xc1llam kiv\xe1laszt\xe1sa","select.stateOrProvince":"\xc1llam vagy tartom\xe1ny kiv\xe1laszt\xe1sa","select.provinceOrTerritory":"Tartom\xe1ny vagy ter\xfclet kiv\xe1laszt\xe1sa","select.country":"Orsz\xe1g kiv\xe1laszt\xe1sa","telephoneNumber.invalid":"\xc9rv\xe9nytelen telefonsz\xe1m","qrCodeOrApp":"vagy","paypal.processingPayment":"Fizet\xe9s feldolgoz\xe1sa\u2026","generateQRCode":"QR-k\xf3d l\xe9trehoz\xe1sa","await.waitForConfirmation":"V\xe1rakoz\xe1s a j\xf3v\xe1hagy\xe1sra","mbway.confirmPayment":"Fizet\xe9s j\xf3v\xe1hagy\xe1sa az MB WAY alkalmaz\xe1sban","shopperEmail.invalid":"\xc9rv\xe9nytelen e-mail-c\xedm","dateOfBirth.format":"NN/HH/\xc9\xc9\xc9\xc9","dateOfBirth.invalid":"Legal\xe1bb 18 \xe9vesnek kell lennie","blik.confirmPayment":"A fizet\xe9s j\xf3v\xe1hagy\xe1s\xe1hoz nyissa meg a banki alkalmaz\xe1st.","blik.invalid":"Adjon meg 6 sz\xe1mjegyet","blik.code":"6 sz\xe1mjegy\u0171 k\xf3d","blik.help":"K\xf3d lek\xe9r\xe9se a banki alkalmaz\xe1sb\xf3l.","swish.pendingMessage":"A QR-k\xf3d beolvas\xe1s\xe1t k\xf6vet\u0151en az \xe1llapot ak\xe1r 10 percig is f\xfcgg\u0151ben lehet. Ha ek\xf6zben \xfajb\xf3l fizet\xe9st k\xeds\xe9rel meg, az t\xf6bbsz\xf6ri fizet\xe9st eredm\xe9nyezhet.","error.va.gen.01":"Hi\xe1nyos mez\u0151","error.va.gen.02":"\xc9rv\xe9nytelen mez\u0151","error.va.sf-cc-num.01":"\xc9rv\xe9nytelen k\xe1rtyasz\xe1m","error.va.sf-cc-num.03":"A megadott k\xe1rtya nem t\xe1mogatott","error.va.sf-cc-dat.01":"A k\xe1rtya t\xfal r\xe9gi","error.va.sf-cc-dat.02":"T\xfal t\xe1voli j\xf6v\u0151beli d\xe1tum","error.giftcard.no-balance":"Az aj\xe1nd\xe9kk\xe1rtya egyenlege nulla","error.giftcard.card-error":"Nyilv\xe1ntart\xe1sunkban nem szerepel ilyen sz\xe1m\xfa aj\xe1nd\xe9kk\xe1rtya","error.giftcard.currency-error":"Az aj\xe1nd\xe9kk\xe1rty\xe1k csak abban a p\xe9nznemben \xe9rv\xe9nyesek, amelyre ki\xe1ll\xedtott\xe1k azokat","amazonpay.signout":"Kijelentkez\xe9s az Amazonr\xf3l","amazonpay.changePaymentDetails":"Fizet\xe9si adatok m\xf3dos\xedt\xe1sa","partialPayment.warning":"M\xe1sik fizet\xe9si m\xf3d v\xe1laszt\xe1sa a fennmarad\xf3 r\xe9sz fizet\xe9s\xe9hez","partialPayment.remainingBalance":"A fennmarad\xf3 egyenleg %{amount} lesz","bankTransfer.beneficiary":"Kedvezm\xe9nyezett","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"Referencia","bankTransfer.introduction":"Folytassa, hogy elind\xedtson egy \xfaj banki \xe1tutal\xe1sos fizet\xe9st. A fizet\xe9s v\xe9gleges\xedt\xe9s\xe9hez felhaszn\xe1lhatja a k\xf6vetkez\u0151 k\xe9perny\u0151n megjelen\u0151 adatokat.","bankTransfer.instructions":"K\xf6sz\xf6nj\xfck a v\xe1s\xe1rl\xe1st! K\xe9rj\xfck, a fizet\xe9shez haszn\xe1lja a k\xf6vetkez\u0151 inform\xe1ci\xf3t.","bacs.accountHolderName":"Banksz\xe1mla-tulajdonos neve","bacs.accountHolderName.invalid":"A banksz\xe1mla-tulajdonos neve \xe9rv\xe9nytelen","bacs.accountNumber":"Banksz\xe1mlasz\xe1m","bacs.accountNumber.invalid":"\xc9rv\xe9nytelen banksz\xe1mlasz\xe1m","bacs.bankLocationId":"Banki azonos\xedt\xf3","bacs.bankLocationId.invalid":"\xc9rv\xe9nytelen banki azonos\xedt\xf3","bacs.consent.amount":"Elfogadom, hogy a fenti \xf6sszeget levonj\xe1k a banksz\xe1ml\xe1mr\xf3l.","bacs.consent.account":"Meger\u0151s\xedtem, hogy a banksz\xe1mla az \xe9n nevemen van, \xe9s \xe9n vagyok a banksz\xe1ml\xe1t \xe9rint\u0151 beszed\xe9si megb\xedz\xe1s j\xf3v\xe1hagy\xe1s\xe1hoz sz\xfcks\xe9ges egyetlen al\xe1\xedr\xf3.","edit":"Szerkeszt\xe9s","bacs.confirm":"Meger\u0151s\xedt\xe9s \xe9s fizet\xe9s","bacs.result.introduction":"Beszed\xe9si megb\xedz\xe1si utas\xedt\xe1s (meghatalmaz\xe1s) let\xf6lt\xe9se","download.pdf":"PDF let\xf6lt\xe9se","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe a biztons\xe1gos k\xe1rtyasz\xe1mhoz","creditCard.encryptedCardNumber.aria.label":"K\xe1rtyasz\xe1m mez\u0151je","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe a biztons\xe1gos k\xe1rtyalej\xe1rati d\xe1tumhoz","creditCard.encryptedExpiryDate.aria.label":"Lej\xe1rati d\xe1tum mez\u0151je","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe a biztons\xe1gos k\xe1rtyalej\xe1rati h\xf3naphoz","creditCard.encryptedExpiryMonth.aria.label":"Lej\xe1rati h\xf3nap mez\u0151je","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe a biztons\xe1gos k\xe1rtyalej\xe1rati \xe9vhez","creditCard.encryptedExpiryYear.aria.label":"Lej\xe1rati \xe9v mez\u0151je","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe a biztons\xe1gos k\xe1rtyabiztons\xe1gi k\xf3dhoz","creditCard.encryptedSecurityCode.aria.label":"Biztons\xe1gi k\xf3d mez\u0151je","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe a biztons\xe1gos aj\xe1nd\xe9kk\xe1rtyasz\xe1mhoz","giftcard.encryptedCardNumber.aria.label":"Aj\xe1nd\xe9kk\xe1rtyasz\xe1m mez\u0151je","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe a biztons\xe1gos aj\xe1nd\xe9kk\xe1rtya biztons\xe1gi k\xf3dhoz","giftcard.encryptedSecurityCode.aria.label":"Aj\xe1nd\xe9kk\xe1rtya biztons\xe1gi k\xf3dj\xe1nak mez\u0151je","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe a biztons\xe1gos banksz\xe1mlasz\xe1mhoz","ach.encryptedBankAccountNumber.aria.label":"Banksz\xe1mla mez\u0151je","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe a biztons\xe1gos bankazonos\xedt\xf3 k\xf3dhoz","ach.encryptedBankLocationId.aria.label":"Bankazonos\xedt\xf3 k\xf3d mez\u0151je"}')},function(e){e.exports=JSON.parse('{"payButton":"Paga","payButton.redirecting":"Reindirizzamento...","storeDetails":"Salva per il prossimo pagamento","creditCard.holderName":"Nome sulla carta","creditCard.holderName.placeholder":"J. Smith","creditCard.holderName.invalid":"Nome del titolare della carta non valido","creditCard.numberField.title":"Numero carta","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Data di scadenza","creditCard.expiryDateField.placeholder":"MM/AA","creditCard.expiryDateField.month":"Mese","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"AA","creditCard.expiryDateField.year":"Anno","creditCard.cvcField.title":"CVC / CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"Ricorda per la prossima volta","creditCard.cvcField.placeholder.4digits":"4 cifre","creditCard.cvcField.placeholder.3digits":"3 cifre","creditCard.taxNumber.placeholder":"AAMMGG/0123456789","installments":"Numero di rate","installmentOption":"%{partialValue} x%{times}","installmentOptionMonths":"%{times} mesi","installments.oneTime":"Pagamento una tantum","installments.installments":"Pagamento rateale","installments.revolving":"Pagamento ricorrente","sepaDirectDebit.ibanField.invalid":"Numero di conto non valido","sepaDirectDebit.nameField.placeholder":"A. Bianchi","sepa.ownerName":"Nome Intestatario Conto","sepa.ibanNumber":"Numero di conto (IBAN)","error.title":"Errore","error.subtitle.redirect":"Reindirizzamento non riuscito","error.subtitle.payment":"Pagamento non riuscito","error.subtitle.refused":"Pagamento respinto","error.message.unknown":"Si \xe8 verificato un errore sconosciuto","idealIssuer.selectField.title":"Banca","idealIssuer.selectField.placeholder":"Seleziona la banca","creditCard.success":"Pagamento riuscito","loading":"Caricamento in corso...","continue":"Continua","continueTo":"Procedi verso","wechatpay.timetopay":"Devi pagare %@","wechatpay.scanqrcode":"Scansiona il codice QR","personalDetails":"Dati personali","companyDetails":"Informazioni dell\'azienda","companyDetails.name":"Ragione sociale","companyDetails.registrationNumber":"Numero di registrazione","socialSecurityNumber":"Numero di previdenza sociale","firstName":"Nome","infix":"Prefisso","lastName":"Cognome","mobileNumber":"Numero di cellulare","mobileNumber.invalid":"Numero di cellulare non valido","city":"Citt\xe0","postalCode":"Codice postale","countryCode":"Codice nazionale","telephoneNumber":"Numero di telefono","dateOfBirth":"Data di nascita","shopperEmail":"Indirizzo e-mail","gender":"Sesso","male":"Uomo","female":"Donna","billingAddress":"Indirizzo di fatturazione","street":"Via","stateOrProvince":"Stato o provincia","country":"Paese","houseNumberOrName":"Numero civico","separateDeliveryAddress":"Specifica un indirizzo di consegna alternativo","deliveryAddress":"Indirizzo di consegna","zipCode":"CAP","apartmentSuite":"Appartamento/suite","provinceOrTerritory":"Provincia o territorio","cityTown":"Citt\xe0","address":"Indirizzo","state":"Stato","creditCard.cvcField.title.optional":"CVC/CVV (facoltativo)","issuerList.wallet.placeholder":"Seleziona il tuo portafoglio","privacyPolicy":"Informativa sulla privacy","afterPay.agreement":"Accetto i %@ di AfterPay","paymentConditions":"termini di pagamento","openApp":"Apri l\'app","voucher.readInstructions":"Leggi le istruzioni","voucher.introduction":"Grazie per il tuo acquisto, utilizza il seguente coupon per completare il pagamento.","voucher.expirationDate":"Data di scadenza","voucher.alternativeReference":"Riferimento alternativo","dragonpay.voucher.non.bank.selectField.placeholder":"Seleziona il tuo fornitore","dragonpay.voucher.bank.selectField.placeholder":"Seleziona la banca","voucher.paymentReferenceLabel":"Riferimento del pagamento","voucher.surcharge":"Include un sovrapprezzo di %@","voucher.introduction.doku":"Grazie per il tuo acquisto, utilizza i seguenti dati per completare il pagamento.","voucher.shopperName":"Nome dell\'acquirente","voucher.merchantName":"Esercente","voucher.introduction.econtext":"Grazie per il tuo acquisto, utilizza i seguenti dati per completare il pagamento.","voucher.telephoneNumber":"Numero di telefono","voucher.shopperReference":"Riferimento dell\'acquirente","voucher.collectionInstitutionNumber":"Codice identificativo del negozio","voucher.econtext.telephoneNumber.invalid":"Il numero di telefono deve essere di 10 o 11 cifre","boletobancario.btnLabel":"Genera Boleto","boleto.sendCopyToEmail":"Invia una copia alla mia e-mail","button.copy":"Copia","button.download":"Scarica","creditCard.storedCard.description.ariaLabel":"La carta memorizzata termina in %@","voucher.entity":"Entit\xe0","donateButton":"Dona","notNowButton":"Non ora","thanksForYourSupport":"Grazie per il tuo sostegno!","preauthorizeWith":"Preautorizza con","confirmPreauthorization":"Conferma preautorizzazione","confirmPurchase":"Conferma acquisto","applyGiftcard":"Riscatta","giftcardBalance":"Saldo del buono","deductedBalance":"Importo detratto","creditCard.pin.title":"Pin","creditCard.encryptedPassword.label":"Prime 2 cifre della password della carta","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Password non valida","creditCard.taxNumber.label":"Data di nascita del titolare della carta (AAMMGG) o numero di registrazione aziendale (10 cifre)","creditCard.taxNumber.labelAlt":"Numero di registrazione aziendale (10 cifre)","creditCard.taxNumber.invalid":"Data di nascita del titolare della carta o numero di registrazione aziendale non validi","storedPaymentMethod.disable.button":"Rimuovi","storedPaymentMethod.disable.confirmation":"Rimuovi il metodo di pagamento archiviato","storedPaymentMethod.disable.confirmButton":"S\xec, rimuoverli","storedPaymentMethod.disable.cancelButton":"Cancella","ach.bankAccount":"Conto bancario","ach.accountHolderNameField.title":"Nome del titolare del conto","ach.accountHolderNameField.placeholder":"J. Smith","ach.accountHolderNameField.invalid":"Nome del titolare del conto non valido","ach.accountNumberField.title":"Numero di conto","ach.accountNumberField.invalid":"Numero di conto non valido","ach.accountLocationField.title":"Codice ABA","ach.accountLocationField.invalid":"Codice ABA non valido","select.state":"Seleziona stato","select.stateOrProvince":"Seleziona stato o provincia","select.provinceOrTerritory":"Seleziona provincia o territorio","select.country":"Seleziona paese","telephoneNumber.invalid":"Numero di telefono non valido","qrCodeOrApp":"o","paypal.processingPayment":"Elaborazione del pagamento in corso...","generateQRCode":"Genera codice QR","await.waitForConfirmation":"In attesa di conferma","mbway.confirmPayment":"Conferma il pagamento con l\'app MB WAY","shopperEmail.invalid":"Indirizzo e-mail non valido","dateOfBirth.format":"GG/MM/AAAA","dateOfBirth.invalid":"Devi avere almeno 18 anni","blik.confirmPayment":"Apri l\'app della tua banca per confermare il pagamento.","blik.invalid":"Inserisci 6 numeri","blik.code":"Codice a 6 cifre","blik.help":"Ottieni il codice dalla app della tua banca.","swish.pendingMessage":"In seguito alla scansione, lo stato della transazione pu\xf2 rimanere in sospeso per un massimo di 10 minuti. Un nuovo tentativo di pagamento durante questo lasso di tempo pu\xf2 comportare pagamenti multipli.","error.va.gen.01":"Campo incompleto","error.va.gen.02":"Campo non valido","error.va.sf-cc-num.01":"Numero carta non valido","error.va.sf-cc-num.03":"Tipo di carta non supportato","error.va.sf-cc-dat.01":"Carta troppo vecchia","error.va.sf-cc-dat.02":"Data troppo avanti nel futuro","error.giftcard.no-balance":"Questo buono regalo ha un saldo pari a zero","error.giftcard.card-error":"Non abbiamo alcun buono regalo con questo numero nei nostri archivi","error.giftcard.currency-error":"I buono regalo sono validi solo nella valuta in cui sono state emessi","amazonpay.signout":"Esci da Amazon","amazonpay.changePaymentDetails":"Modifica i dettagli di pagamento","partialPayment.warning":"Seleziona un altro metodo di pagamento per pagare l\'importo rimanente","partialPayment.remainingBalance":"Il saldo rimanente sar\xe0 di %{amount}","bankTransfer.beneficiary":"Beneficiario","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"Riferimento","bankTransfer.introduction":"Continua per creare un nuovo pagamento tramite bonifico bancario. Puoi utilizzare i dettagli nella schermata seguente per completare l\'operazione.","bankTransfer.instructions":"Grazie per il tuo acquisto, utilizza i seguenti dati per completare il pagamento.","bacs.accountHolderName":"Nome del titolare del conto bancario","bacs.accountHolderName.invalid":"Nome del titolare del conto bancario non valido","bacs.accountNumber":"Numero di conto bancario","bacs.accountNumber.invalid":"Numero di conto bancario non valido","bacs.bankLocationId":"Sort code","bacs.bankLocationId.invalid":"Sort code non valido","bacs.consent.amount":"Accetto che l\'importo sopra indicato venga detratto dal mio conto bancario.","bacs.consent.account":"Confermo che il conto \xe8 intestato al sottoscritto e che sono l\'unico firmatario a dover autorizzare l\'addebito diretto su questo conto.","edit":"Modifica","bacs.confirm":"Conferma e paga","bacs.result.introduction":"Scarica le Istruzioni per l\'addebito diretto (DDI / Mandato)","download.pdf":"Scarica PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe per numero di carta protetta","creditCard.encryptedCardNumber.aria.label":"Campo numero di carta","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe data di scadenza per numero di carta protetta","creditCard.encryptedExpiryDate.aria.label":"Campo data di scadenza","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe mese di scadenza per numero di carta protetta","creditCard.encryptedExpiryMonth.aria.label":"Campo mese di scadenza","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe anno di scadenza per numero di carta protetta","creditCard.encryptedExpiryYear.aria.label":"Campo anno di scadenza","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe per codice di sicurezza della carta protetta","creditCard.encryptedSecurityCode.aria.label":"Campo codice di sicurezza","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe per numero di carta regalo protetta","giftcard.encryptedCardNumber.aria.label":"Campo numero carta regalo","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe per codice di sicurezza della carta regalo protetta","giftcard.encryptedSecurityCode.aria.label":"Campo codice di sicurezza della carta regalo","giftcardTransactionLimit":"Importo massimo di %{amount} per transazione su questo buono regalo","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe per numero di numero di conto bancario protetto","ach.encryptedBankAccountNumber.aria.label":"Campo conto bancario","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe per numero di routing bancario sicuro","ach.encryptedBankLocationId.aria.label":"Campo numero di routing bancario"}')},function(e){e.exports=JSON.parse('{"payButton":"\u652f\u6255\u3046","payButton.redirecting":"\u30ea\u30c0\u30a4\u30ec\u30af\u30c8\u3057\u3066\u3044\u307e\u3059...","storeDetails":"\u6b21\u56de\u306e\u304a\u652f\u6255\u3044\u306e\u305f\u3081\u8a73\u7d30\u3092\u4fdd\u5b58","creditCard.holderName":"\u30ab\u30fc\u30c9\u4e0a\u306e\u540d\u524d","creditCard.holderName.placeholder":"Taro Yamada","creditCard.holderName.invalid":"\u7121\u52b9\u306a\u30ab\u30fc\u30c9\u6240\u6709\u8005\u540d","creditCard.numberField.title":"\u30ab\u30fc\u30c9\u756a\u53f7","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"\u6709\u52b9\u671f\u9650","creditCard.expiryDateField.placeholder":"MM/YY","creditCard.expiryDateField.month":"\u6708","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"YY","creditCard.expiryDateField.year":"\u5e74","creditCard.cvcField.title":"\u30bb\u30ad\u30e5\u30ea\u30c6\u30a3\u30fc\u30b3\u30fc\u30c9 (CVC)","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"\u6b21\u56de\u306e\u305f\u3081\u306b\u4fdd\u5b58\u3057\u307e\u3059","creditCard.cvcField.placeholder.4digits":"4\u6841","creditCard.cvcField.placeholder.3digits":"3\u6841","creditCard.taxNumber.placeholder":"\u5e74\u6708\u65e5\uff08YYMMDD\uff09/ 0123456789","installments":"\u5206\u5272\u56de\u6570","installmentOption":"%{times}x %{partialValue}","installmentOptionMonths":"%{times}\u304b\u6708","installments.oneTime":"\u4e00\u62ec\u6255\u3044","installments.installments":"\u5206\u5272\u6255\u3044","installments.revolving":"\u30ea\u30dc\u6255\u3044","sepaDirectDebit.ibanField.invalid":"\u53e3\u5ea7\u756a\u53f7\u306e\u5165\u529b\u9593\u9055\u3044","sepaDirectDebit.nameField.placeholder":"J. Smith","sepa.ownerName":"\u540d\u7fa9","sepa.ibanNumber":"\u53e3\u5ea7\u756a\u53f7 (IBAN)","error.title":"\u30a8\u30e9\u30fc","error.subtitle.redirect":"\u753b\u9762\u306e\u5207\u308a\u66ff\u3048\u5931\u6557\u306b\u3057\u307e\u3057\u305f","error.subtitle.payment":"\u652f\u6255\u3067\u304d\u307e\u305b\u3093\u3067\u3057\u305f","error.subtitle.refused":"\u30ab\u30fc\u30c9\u4f1a\u793e\u3067\u53d6\u5f15\u304c\u627f\u8a8d\u3055\u308c\u307e\u305b\u3093\u3067\u3057\u305f\u3002","error.message.unknown":"\u4e0d\u660e\u306a\u30a8\u30e9\u30fc\u304c\u767a\u751f\u3057\u307e\u3057\u305f","idealIssuer.selectField.title":"\u9280\u884c","idealIssuer.selectField.placeholder":"\u9280\u884c\u3092\u9078\u629e\u3057\u3066\u304f\u3060\u3055\u3044","creditCard.success":"\u8a8d\u8a3c\u304c\u6210\u529f\u3057\u307e\u3057\u305f","loading":"\u8aad\u307f\u8fbc\u3093\u3067\u3044\u307e\u3059...","continue":"\u7d9a\u3051\u308b","continueTo":"\u6b21\u3078\u9032\u3080\uff1a","wechatpay.timetopay":"%@\u3092\u304a\u652f\u6255\u3044\u4e0b\u3055\u3044\u3002","wechatpay.scanqrcode":"QR \u30b3\u30fc\u30c9\u3092\u30b9\u30ad\u30e3\u30f3\u3059\u308b","personalDetails":"\u500b\u4eba\u60c5\u5831","companyDetails":"\u4f1a\u793e\u60c5\u5831","companyDetails.name":"\u4f1a\u793e\u540d","companyDetails.registrationNumber":"\u767b\u9332\u756a\u53f7","socialSecurityNumber":"\u30bd\u30fc\u30b7\u30e3\u30eb\u30bb\u30ad\u30e5\u30ea\u30c6\u30a3\u30fc\u756a\u53f7","firstName":"\u540d","infix":"\u656c\u79f0","lastName":"\u59d3","mobileNumber":"\u643a\u5e2f\u756a\u53f7","mobileNumber.invalid":"\u7121\u52b9\u306a\u643a\u5e2f\u96fb\u8a71\u756a\u53f7","city":"\u5e02\u533a","postalCode":"\u90f5\u4fbf\u756a\u53f7","countryCode":"\u56fd\u30b3\u30fc\u30c9","telephoneNumber":"\u96fb\u8a71\u756a\u53f7","dateOfBirth":"\u751f\u5e74\u6708\u65e5","shopperEmail":"E\u30e1\u30fc\u30eb\u30a2\u30c9\u30ec\u30b9","gender":"\u6027\u5225","male":"\u7537\u6027","female":"\u5973\u6027","billingAddress":"\u3054\u8acb\u6c42\u4f4f\u6240","street":"\u756a\u5730","stateOrProvince":"\u90fd\u9053\u5e9c\u770c","country":"\u56fd","houseNumberOrName":"\u90e8\u5c4b\u756a\u53f7","separateDeliveryAddress":"\u5225\u306e\u914d\u9001\u5148\u4f4f\u6240\u3092\u6307\u5b9a\u3057\u3066\u304f\u3060\u3055\u3044","deliveryAddress":"\u914d\u9001\u5148\u4f4f\u6240","zipCode":"\u90f5\u4fbf\u756a\u53f7","apartmentSuite":"\u30a2\u30d1\u30fc\u30c8\u540d/\u90e8\u5c4b\u540d","provinceOrTerritory":"\u5dde\u307e\u305f\u306f\u6e96\u5dde","cityTown":"\u5e02\u533a\u753a\u6751","address":"\u4f4f\u6240","state":"\u90fd\u9053\u5e9c\u770c","creditCard.cvcField.title.optional":"\u30bb\u30ad\u30e5\u30ea\u30c6\u30a3\u30fc\u30b3\u30fc\u30c9(\u4efb\u610f)","issuerList.wallet.placeholder":"\u30a6\u30a9\u30ec\u30c3\u30c8\u3092\u9078\u629e\u3057\u3066\u304f\u3060\u3055\u3044","privacyPolicy":"\u30d7\u30e9\u30a4\u30d0\u30b7\u30fc\u30dd\u30ea\u30b7\u30fc","afterPay.agreement":"AfterPay\u306e%@\u3067\u540c\u610f","paymentConditions":"\u652f\u6255\u6761\u4ef6","openApp":"\u30a2\u30d7\u30ea\u3092\u958b\u304f","voucher.readInstructions":"\u624b\u9806\u3092\u53c2\u7167\u3057\u3066\u304f\u3060\u3055\u3044","voucher.introduction":"\u304a\u8cb7\u3044\u4e0a\u3052\u3042\u308a\u304c\u3068\u3046\u3054\u3056\u3044\u307e\u3059\u3002\u4ee5\u4e0b\u306e\u30af\u30fc\u30dd\u30f3\u3092\u4f7f\u7528\u3057\u3066\u3001\u304a\u652f\u6255\u3044\u3092\u5b8c\u4e86\u3057\u3066\u304f\u3060\u3055\u3044\u3002","voucher.expirationDate":"\u6709\u52b9\u671f\u9650","voucher.alternativeReference":"\u5225\u306e\u53c2\u7167","dragonpay.voucher.non.bank.selectField.placeholder":"\u30d7\u30ed\u30d0\u30a4\u30c0\u30fc\u3092\u9078\u629e\u3057\u3066\u304f\u3060\u3055\u3044","dragonpay.voucher.bank.selectField.placeholder":"\u9280\u884c\u3092\u9078\u629e\u3057\u3066\u304f\u3060\u3055\u3044","voucher.paymentReferenceLabel":"\u652f\u6255\u306e\u53c2\u7167","voucher.surcharge":"%@ \u306e\u8ffd\u52a0\u6599\u91d1\u3092\u542b\u3080","voucher.introduction.doku":"\u304a\u8cb7\u3044\u4e0a\u3052\u3042\u308a\u304c\u3068\u3046\u3054\u3056\u3044\u307e\u3059\u3002\u4ee5\u4e0b\u306e\u60c5\u5831\u3092\u4f7f\u7528\u3057\u3066\u3001\u304a\u652f\u6255\u3044\u3092\u5b8c\u4e86\u3057\u3066\u304f\u3060\u3055\u3044\u3002","voucher.shopperName":"\u8cfc\u5165\u8005\u6c0f\u540d","voucher.merchantName":"\u696d\u8005","voucher.introduction.econtext":"\u304a\u8cb7\u3044\u4e0a\u3052\u3042\u308a\u304c\u3068\u3046\u3054\u3056\u3044\u307e\u3059\u3002\u4ee5\u4e0b\u306e\u60c5\u5831\u3092\u4f7f\u7528\u3057\u3066\u3001\u304a\u652f\u6255\u3044\u3092\u5b8c\u4e86\u3057\u3066\u304f\u3060\u3055\u3044\u3002","voucher.telephoneNumber":"\u96fb\u8a71\u756a\u53f7","voucher.shopperReference":"\u8cfc\u5165\u8005\u5411\u3051\u53c2\u8003\u60c5\u5831","voucher.collectionInstitutionNumber":"\u53ce\u7d0d\u6a5f\u95a2\u756a\u53f7","voucher.econtext.telephoneNumber.invalid":"\u96fb\u8a71\u756a\u53f7\u306f10\u6841\u307e\u305f\u306f11\u6841\u306b\u3057\u3066\u304f\u3060\u3055\u3044","boletobancario.btnLabel":"Boleto\u3092\u751f\u6210\u3059\u308b","boleto.sendCopyToEmail":"\u81ea\u5206\u306e\u30e1\u30fc\u30eb\u30a2\u30c9\u30ec\u30b9\u306b\u30b3\u30d4\u30fc\u3092\u9001\u4fe1\u3059\u308b","button.copy":"\u30b3\u30d4\u30fc","button.download":"\u30c0\u30a6\u30f3\u30ed\u30fc\u30c9","creditCard.storedCard.description.ariaLabel":"\u4fdd\u5b58\u3055\u308c\u305f\u30ab\u30fc\u30c9\u306f\uff05@\u306b\u7d42\u4e86\u3057\u307e\u3059","voucher.entity":"\u30a8\u30f3\u30c6\u30a3\u30c6\u30a3","donateButton":"\u5bc4\u4ed8\u3059\u308b","notNowButton":"\u4eca\u306f\u3057\u306a\u3044","thanksForYourSupport":"\u3054\u652f\u63f4\u3044\u305f\u3060\u304d\u3042\u308a\u304c\u3068\u3046\u3054\u3056\u3044\u307e\u3059\u3002","preauthorizeWith":"\u6b21\u3067\u4e8b\u524d\u8a8d\u8a3c\u3059\u308b\uff1a","confirmPreauthorization":"\u4e8b\u524d\u627f\u8a8d\u3092\u78ba\u8a8d\u3059\u308b","confirmPurchase":"\u8cfc\u5165\u3092\u78ba\u8a8d\u3059\u308b","applyGiftcard":"\u5229\u7528\u3059\u308b","giftcardBalance":"\u30ae\u30d5\u30c8\u30ab\u30fc\u30c9\u306e\u6b8b\u9ad8","deductedBalance":"\u5dee\u3057\u5f15\u304d\u5f8c\u6b8b\u9ad8","creditCard.pin.title":"PIN","creditCard.encryptedPassword.label":"\u30ab\u30fc\u30c9\u306e\u30d1\u30b9\u30ef\u30fc\u30c9\u306e\u6700\u521d\u306e2\u6841","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"\u30d1\u30b9\u30ef\u30fc\u30c9\u304c\u7121\u52b9\u3067\u3059","creditCard.taxNumber.label":"\u30ab\u30fc\u30c9\u6240\u6709\u8005\u306e\u751f\u5e74\u6708\u65e5\uff08YYMMDD\uff09\u307e\u305f\u306f\u6cd5\u4eba\u767b\u9332\u756a\u53f7\uff0810\u6841\uff09","creditCard.taxNumber.labelAlt":"\u6cd5\u4eba\u767b\u9332\u756a\u53f7\uff0810\u6841\uff09","creditCard.taxNumber.invalid":"\u30ab\u30fc\u30c9\u6240\u6709\u8005\u306e\u751f\u5e74\u6708\u65e5\u307e\u305f\u306f\u6cd5\u4eba\u767b\u9332\u756a\u53f7\u304c\u7121\u52b9\u3067\u3059","storedPaymentMethod.disable.button":"\u524a\u9664","storedPaymentMethod.disable.confirmation":"\u4fdd\u5b58\u3055\u308c\u3066\u3044\u308b\u652f\u6255\u65b9\u6cd5\u3092\u524a\u9664\u3059\u308b","storedPaymentMethod.disable.confirmButton":"\u306f\u3044\u3001\u524a\u9664\u3057\u307e\u3059","storedPaymentMethod.disable.cancelButton":"\u30ad\u30e3\u30f3\u30bb\u30eb","ach.bankAccount":"\u9280\u884c\u53e3\u5ea7","ach.accountHolderNameField.title":"\u53e3\u5ea7\u540d\u7fa9","ach.accountHolderNameField.placeholder":"Taro Yamada","ach.accountHolderNameField.invalid":"\u7121\u52b9\u306a\u53e3\u5ea7\u540d\u7fa9","ach.accountNumberField.title":"\u53e3\u5ea7\u756a\u53f7","ach.accountNumberField.invalid":"\u53e3\u5ea7\u756a\u53f7\u306e\u5165\u529b\u9593\u9055\u3044","ach.accountLocationField.title":"ABA\u30ca\u30f3\u30d0\u30fc","ach.accountLocationField.invalid":"\u7121\u52b9\u306aABA\u30ca\u30f3\u30d0\u30fc","select.state":"\u90fd\u9053\u5e9c\u770c\u3092\u9078\u629e\u3057\u3066\u304f\u3060\u3055\u3044","select.stateOrProvince":"\u90fd\u9053\u5e9c\u770c\u3092\u9078\u629e\u3057\u3066\u304f\u3060\u3055\u3044","select.provinceOrTerritory":"\u5dde\u307e\u305f\u306f\u6e96\u5dde\u3092\u9078\u629e\u3057\u3066\u304f\u3060\u3055\u3044","select.country":"\u56fd\u3092\u9078\u629e\u3057\u3066\u304f\u3060\u3055\u3044","telephoneNumber.invalid":"\u7121\u52b9\u306a\u96fb\u8a71\u756a\u53f7","qrCodeOrApp":"\u307e\u305f\u306f","paypal.processingPayment":"\u652f\u6255\u3044\u3092\u51e6\u7406\u3057\u3066\u3044\u307e\u3059...","generateQRCode":"QR\u30b3\u30fc\u30c9\u3092\u751f\u6210\u3059\u308b","await.waitForConfirmation":"\u78ba\u8a8d\u3092\u5f85\u3063\u3066\u3044\u307e\u3059","mbway.confirmPayment":"MB WAY\u30a2\u30d7\u30ea\u3067\u652f\u6255\u3092\u78ba\u8a8d\u3059\u308b","shopperEmail.invalid":"E\u30e1\u30fc\u30eb\u30a2\u30c9\u30ec\u30b9\u304c\u7121\u52b9\u3067\u3059","dateOfBirth.format":"DD/MM/YYYY","dateOfBirth.invalid":"18\u6b73\u4ee5\u4e0a\u306e\u65b9\u306e\u307f\u3054\u5229\u7528\u3044\u305f\u3060\u3051\u307e\u3059","blik.confirmPayment":"\u30d0\u30f3\u30ad\u30f3\u30b0\u30a2\u30d7\u30ea\u3092\u958b\u3044\u3066\u3001\u652f\u6255\u3092\u78ba\u8a8d\u3057\u3066\u304f\u3060\u3055\u3044\u3002","blik.invalid":"6\u3064\u306e\u6570\u5b57\u3092\u5165\u529b\u3057\u3066\u304f\u3060\u3055\u3044","blik.code":"6\u6841\u306e\u30b3\u30fc\u30c9","blik.help":"\u30d0\u30f3\u30ad\u30f3\u30b0\u30a2\u30d7\u30ea\u304b\u3089\u30b3\u30fc\u30c9\u3092\u53d6\u5f97\u3057\u3066\u304f\u3060\u3055\u3044\u3002","swish.pendingMessage":"\u30b9\u30ad\u30e3\u30f3\u5f8c\u3001\u30b9\u30c6\u30fc\u30bf\u30b9\u306f\u6700\u592710\u5206\u9593\u4fdd\u7559\u72b6\u614b\u306b\u306a\u308a\u307e\u3059\u3002\u3053\u306e\u9593\u306b\u518d\u5ea6\u304a\u652f\u6255\u3044\u3044\u305f\u3060\u3053\u3046\u3068\u3059\u308b\u3068\u3001\u8907\u6570\u306e\u8acb\u6c42\u304c\u767a\u751f\u3059\u308b\u5834\u5408\u304c\u3042\u308a\u307e\u3059\u3002","error.va.gen.01":"\u4e0d\u5b8c\u5168\u306a\u30d5\u30a3\u30fc\u30eb\u30c9","error.va.gen.02":"\u30d5\u30a3\u30fc\u30eb\u30c9\u304c\u7121\u52b9\u3067\u3059","error.va.sf-cc-num.01":"\u30ab\u30fc\u30c9\u756a\u53f7\u304c\u7121\u52b9\u3067\u3059","error.va.sf-cc-num.03":"\u30b5\u30dd\u30fc\u30c8\u3055\u308c\u3066\u3044\u306a\u3044\u30ab\u30fc\u30c9\u304c\u5165\u529b\u3055\u308c\u307e\u3057\u305f","error.va.sf-cc-dat.01":"\u30ab\u30fc\u30c9\u304c\u53e4\u3059\u304e\u307e\u3059","error.va.sf-cc-dat.02":"\u672a\u6765\u306e\u65e5\u4ed8\u304c\u5148\u3059\u304e\u3067\u3059","error.giftcard.no-balance":"\u3053\u306e\u30ae\u30d5\u30c8\u30ab\u30fc\u30c9\u306e\u6b8b\u9ad8\u306f\u30bc\u30ed\u3067\u3059","error.giftcard.card-error":"\u8a18\u9332\u3067\u306f\u3001\u3053\u306e\u756a\u53f7\u306e\u30ae\u30d5\u30c8\u30ab\u30fc\u30c9\u306f\u3042\u308a\u307e\u305b\u3093","error.giftcard.currency-error":"\u30ae\u30d5\u30c8\u30ab\u30fc\u30c9\u306f\u3001\u767a\u884c\u3055\u308c\u305f\u901a\u8ca8\u3067\u306e\u307f\u6709\u52b9\u3067\u3059\u3002","amazonpay.signout":"Amazon\u304b\u3089\u30b5\u30a4\u30f3\u30a2\u30a6\u30c8\u3059\u308b","amazonpay.changePaymentDetails":"\u652f\u6255\u660e\u7d30\u3092\u5909\u66f4\u3059\u308b","partialPayment.warning":"\u6b8b\u91d1\u3092\u652f\u6255\u3046\u5225\u306e\u652f\u6255\u65b9\u6cd5\u3092\u9078\u629e\u3057\u3066\u304f\u3060\u3055\u3044","partialPayment.remainingBalance":"\u6b8b\u308a\u306e\u6b8b\u9ad8\u306f%{amount}\u306b\u306a\u308a\u307e\u3059","bankTransfer.beneficiary":"\u53d7\u76ca\u8005","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"\u53c2\u7167","bankTransfer.introduction":"\u65b0\u3057\u3044\u9280\u884c\u632f\u8fbc\u306b\u3088\u308b\u304a\u652f\u6255\u306e\u4f5c\u6210\u3092\u7d9a\u884c\u3057\u307e\u3059\u3002\u6b21\u306e\u753b\u9762\u306e\u8a73\u7d30\u3092\u4f7f\u7528\u3057\u3066\u3001\u3053\u306e\u304a\u652f\u6255\u3044\u3092\u78ba\u5b9a\u3067\u304d\u307e\u3059\u3002","bankTransfer.instructions":"\u304a\u8cb7\u3044\u4e0a\u3052\u3042\u308a\u304c\u3068\u3046\u3054\u3056\u3044\u307e\u3059\u3002\u4ee5\u4e0b\u306e\u60c5\u5831\u3092\u4f7f\u7528\u3057\u3066\u3001\u304a\u652f\u6255\u3044\u3092\u5b8c\u4e86\u3057\u3066\u304f\u3060\u3055\u3044\u3002","bacs.accountHolderName":"\u9280\u884c\u53e3\u5ea7\u540d\u7fa9","bacs.accountHolderName.invalid":"\u9280\u884c\u53e3\u5ea7\u540d\u7fa9\u304c\u7121\u52b9\u3067\u3059","bacs.accountNumber":"\u9280\u884c\u53e3\u5ea7\u756a\u53f7","bacs.accountNumber.invalid":"\u9280\u884c\u53e3\u5ea7\u756a\u53f7\u304c\u7121\u52b9\u3067\u3059","bacs.bankLocationId":"\u30bd\u30fc\u30c8\u30b3\u30fc\u30c9","bacs.bankLocationId.invalid":"\u30bd\u30fc\u30c8\u30b3\u30fc\u30c9\u304c\u7121\u52b9\u3067\u3059","bacs.consent.amount":"\u4e0a\u8a18\u306e\u91d1\u984d\u304c\u79c1\u306e\u9280\u884c\u53e3\u5ea7\u304b\u3089\u5f15\u304d\u843d\u3068\u3055\u308c\u308b\u3053\u3068\u306b\u540c\u610f\u3057\u307e\u3059\u3002","bacs.consent.account":"\u53e3\u5ea7\u304c\u79c1\u306e\u540d\u7fa9\u3067\u3042\u308b\u3053\u3068\u3092\u78ba\u8a8d\u3057\u3001\u3053\u306e\u53e3\u5ea7\u304b\u3089\u306e\u81ea\u52d5\u5f15\u304d\u843d\u3068\u3057\u3092\u627f\u8a8d\u3059\u308b\u305f\u3081\u306b\u5fc5\u8981\u306a\u552f\u4e00\u306e\u7f72\u540d\u8005\u3067\u3042\u308b\u3053\u3068\u3092\u78ba\u8a8d\u3057\u307e\u3059\u3002","edit":"\u7de8\u96c6","bacs.confirm":"\u78ba\u8a8d\u3057\u3066\u652f\u6255\u3046","bacs.result.introduction":"\u81ea\u52d5\u5f15\u304d\u843d\u3068\u3057\u306e\u8aac\u660e (DDI/\u59d4\u4efb\u72b6) \u3092\u30c0\u30a6\u30f3\u30ed\u30fc\u30c9\u3059\u308b","download.pdf":"PDF\u3092\u30c0\u30a6\u30f3\u30ed\u30fc\u30c9","creditCard.encryptedCardNumber.aria.iframeTitle":"\u4fdd\u8b77\u3055\u308c\u305f\u30ab\u30fc\u30c9\u756a\u53f7\u306e iframe","creditCard.encryptedCardNumber.aria.label":"\u30ab\u30fc\u30c9\u756a\u53f7\u30d5\u30a3\u30fc\u30eb\u30c9","creditCard.encryptedExpiryDate.aria.iframeTitle":"\u4fdd\u8b77\u3055\u308c\u305f\u30ab\u30fc\u30c9\u306e\u6709\u52b9\u671f\u9650\u65e5\u306e iframe","creditCard.encryptedExpiryDate.aria.label":"\u6709\u52b9\u671f\u9650\u65e5\u30d5\u30a3\u30fc\u30eb\u30c9","creditCard.encryptedExpiryMonth.aria.iframeTitle":"\u4fdd\u8b77\u3055\u308c\u305f\u30ab\u30fc\u30c9\u306e\u6709\u52b9\u671f\u9650\u6708\u306e iframe","creditCard.encryptedExpiryMonth.aria.label":"\u6709\u52b9\u671f\u9650\u6708\u30d5\u30a3\u30fc\u30eb\u30c9","creditCard.encryptedExpiryYear.aria.iframeTitle":"\u4fdd\u8b77\u3055\u308c\u305f\u30ab\u30fc\u30c9\u306e\u6709\u52b9\u671f\u9650\u5e74\u306e iframe","creditCard.encryptedExpiryYear.aria.label":"\u6709\u52b9\u671f\u9650\u5e74\u30d5\u30a3\u30fc\u30eb\u30c9","creditCard.encryptedSecurityCode.aria.iframeTitle":"\u4fdd\u8b77\u3055\u308c\u305f\u30ab\u30fc\u30c9\u306e\u30bb\u30ad\u30e5\u30ea\u30c6\u30a3\u30b3\u30fc\u30c9\u306e iframe","creditCard.encryptedSecurityCode.aria.label":"\u30bb\u30ad\u30e5\u30ea\u30c6\u30a3\u30b3\u30fc\u30c9\u30d5\u30a3\u30fc\u30eb\u30c9","giftcard.encryptedCardNumber.aria.iframeTitle":"\u4fdd\u8b77\u3055\u308c\u305f\u30ae\u30d5\u30c8\u30ab\u30fc\u30c9\u756a\u53f7\u306e iframe","giftcard.encryptedCardNumber.aria.label":"\u30ae\u30d5\u30c8\u30ab\u30fc\u30c9\u756a\u53f7\u30d5\u30a3\u30fc\u30eb\u30c9","giftcard.encryptedSecurityCode.aria.iframeTitle":"\u4fdd\u8b77\u3055\u308c\u305f\u30ae\u30d5\u30c8\u30ab\u30fc\u30c9\u306e\u30bb\u30ad\u30e5\u30ea\u30c6\u30a3\u30b3\u30fc\u30c9\u306e iframe","giftcard.encryptedSecurityCode.aria.label":"\u30ae\u30d5\u30c8\u30ab\u30fc\u30c9\u306e\u30bb\u30ad\u30e5\u30ea\u30c6\u30a3\u30b3\u30fc\u30c9\u30d5\u30a3\u30fc\u30eb\u30c9","giftcardTransactionLimit":"\u3053\u306e\u30ae\u30d5\u30c8\u30ab\u30fc\u30c9\u3067\u306e\u53d6\u5f15\u3054\u3068\u306b\u8a31\u53ef\u3055\u308c\u308b\u6700\u5927%{amount}","ach.encryptedBankAccountNumber.aria.iframeTitle":"\u4fdd\u8b77\u3055\u308c\u305f\u9280\u884c\u53e3\u5ea7\u756a\u53f7\u306e iframe","ach.encryptedBankAccountNumber.aria.label":"\u9280\u884c\u53e3\u5ea7\u30d5\u30a3\u30fc\u30eb\u30c9","ach.encryptedBankLocationId.aria.iframeTitle":"\u4fdd\u8b77\u3055\u308c\u305f\u9280\u884c\u652f\u5e97\u756a\u53f7\u306e iframe","ach.encryptedBankLocationId.aria.label":"\u9280\u884c\u652f\u5e97\u756a\u53f7\u30d5\u30a3\u30fc\u30eb\u30c9"}')},function(e){e.exports=JSON.parse('{"payButton":"\uacb0\uc81c","payButton.redirecting":"\ub9ac\ub514\ub809\uc158 \uc911...","storeDetails":"\ub2e4\uc74c \uacb0\uc81c\ub97c \uc704\ud574 \uc774 \uc218\ub2e8 \uc800\uc7a5","creditCard.holderName":"\uce74\ub4dc\uc0c1\uc758 \uc774\ub984","creditCard.holderName.placeholder":"J. Smith","creditCard.holderName.invalid":"\uc720\ud6a8\ud558\uc9c0 \uc54a\uc740 \uce74\ub4dc \uc18c\uc720\uc790 \uc774\ub984","creditCard.numberField.title":"\uce74\ub4dc \ubc88\ud638","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"\ub9cc\ub8cc\uc77c","creditCard.expiryDateField.placeholder":"MM/YY","creditCard.expiryDateField.month":"\uc6d4","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"YY","creditCard.expiryDateField.year":"\uc5f0\ub3c4","creditCard.cvcField.title":"CVC / CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"\ub2e4\uc74c\uc744 \uc704\ud574 \uc800\uc7a5","creditCard.cvcField.placeholder.4digits":"4\uc790\ub9ac","creditCard.cvcField.placeholder.3digits":"3\uc790\ub9ac","creditCard.taxNumber.placeholder":"YYMMDD / 0123456789","installments":"\ud560\ubd80 \uac1c\uc6d4 \uc218","installmentOption":"%{times}x %{partialValue}","installmentOptionMonths":"%{times}\uac1c\uc6d4","installments.oneTime":"\uc77c\uc2dc\ubd88 \uacb0\uc81c","installments.installments":"\ud560\ubd80 \uacb0\uc81c","installments.revolving":"\ub9ac\ubcfc\ube59 \uacb0\uc81c","sepaDirectDebit.ibanField.invalid":"\uc720\ud6a8\ud558\uc9c0 \uc54a\uc740 \uacc4\uc88c \ubc88\ud638","sepaDirectDebit.nameField.placeholder":"J. Smith","sepa.ownerName":"\uc18c\uc720\uc790 \uc774\ub984","sepa.ibanNumber":"\uacc4\uc88c \ubc88\ud638(IBAN)","error.title":"\uc624\ub958","error.subtitle.redirect":"\ub9ac\ub514\ub809\uc158 \uc2e4\ud328","error.subtitle.payment":"\uacb0\uc81c \uc2e4\ud328","error.subtitle.refused":"\uacb0\uc81c \uac70\ubd80","error.message.unknown":"\uc54c \uc218 \uc5c6\ub294 \uc624\ub958 \ubc1c\uc0dd","idealIssuer.selectField.title":"\uc740\ud589","idealIssuer.selectField.placeholder":"\uc740\ud589 \uc120\ud0dd","creditCard.success":"\uacb0\uc81c \uc131\uacf5","loading":"\ub85c\ub4dc \uc911\u2026","continue":"\uacc4\uc18d","continueTo":"\ub2e4\uc74c\uc73c\ub85c \uacc4\uc18d:","wechatpay.timetopay":"\ub0a8\uc740 \uacb0\uc81c \uc2dc\ud55c: %@","wechatpay.scanqrcode":"QR \ucf54\ub4dc \uc2a4\uce94","personalDetails":"\uac1c\uc778 \uc815\ubcf4","companyDetails":"\ud68c\uc0ac \uc815\ubcf4","companyDetails.name":"\ud68c\uc0ac\uba85","companyDetails.registrationNumber":"\ub4f1\ub85d \ubc88\ud638","socialSecurityNumber":"\uc0ac\ud68c \ubcf4\uc7a5 \ubc88\ud638(\uc8fc\ubbfc\ub4f1\ub85d\ubc88\ud638)","firstName":"\uc774\ub984","infix":"\uba85\uce6d","lastName":"\uc131","mobileNumber":"\ud734\ub300\ud3f0 \ubc88\ud638","mobileNumber.invalid":"\uc720\ud6a8\ud558\uc9c0 \uc54a\uc740 \ud734\ub300\ud3f0 \ubc88\ud638","city":"\uc2dc","postalCode":"\uc6b0\ud3b8\ubc88\ud638","countryCode":"\uad6d\uac00 \ucf54\ub4dc","telephoneNumber":"\uc804\ud654\ubc88\ud638","dateOfBirth":"\uc0dd\ub144\uc6d4\uc77c","shopperEmail":"\uc774\uba54\uc77c \uc8fc\uc18c","gender":"\uc131\ubcc4","male":"\ub0a8\uc131","female":"\uc5ec\uc131","billingAddress":"\uccad\uad6c\uc9c0 \uc8fc\uc18c","street":"\ub3c4\ub85c\uba85","stateOrProvince":"\uc8fc/\ub3c4","country":"\uad6d\uac00","houseNumberOrName":"\uc9d1 \uc804\ud654\ubc88\ud638","separateDeliveryAddress":"\ubc30\uc1a1 \uc8fc\uc18c \ubcc4\ub3c4 \uc9c0\uc815","deliveryAddress":"\ubc30\uc1a1 \uc8fc\uc18c","zipCode":"\uc6b0\ud3b8\ubc88\ud638","apartmentSuite":"\uc544\ud30c\ud2b8/\uac74\ubb3c","provinceOrTerritory":"\ub3c4","cityTown":"\uc2dc/\uad6c","address":"\uc8fc\uc18c","state":"\uc8fc","creditCard.cvcField.title.optional":"CVC / CVV (\uc120\ud0dd)","issuerList.wallet.placeholder":"\uc804\uc790 \uc9c0\uac11 \uc120\ud0dd","privacyPolicy":"\uac1c\uc778\uc815\ubcf4 \ubcf4\ud638\uc815\ucc45","afterPay.agreement":"AfterPay\uc758 %@\uc5d0 \ub3d9\uc758\ud569\ub2c8\ub2e4.","paymentConditions":"\uacb0\uc81c \uc870\uac74","openApp":"\uc571 \uc5f4\uae30","voucher.readInstructions":"\uc548\ub0b4 \uc77d\uae30","voucher.introduction":"\uad6c\ub9e4\ud574 \uc8fc\uc154\uc11c \uac10\uc0ac\ud569\ub2c8\ub2e4. \ub2e4\uc74c \ucfe0\ud3f0\uc744 \uc0ac\uc6a9\ud558\uc5ec \uacb0\uc81c\ub97c \uc644\ub8cc\ud558\uc2ed\uc2dc\uc624.","voucher.expirationDate":"\ub9cc\ub8cc\uc77c","voucher.alternativeReference":"\ub300\uccb4 \ucc38\uc870\ubc88\ud638","dragonpay.voucher.non.bank.selectField.placeholder":"\uc81c\uacf5 \uc5c5\uccb4 \uc120\ud0dd","dragonpay.voucher.bank.selectField.placeholder":"\uc740\ud589 \uc120\ud0dd","voucher.paymentReferenceLabel":"\uacb0\uc81c \ucc38\uc870\ubc88\ud638","voucher.surcharge":"%@ \ud560\uc99d\ub8cc \ud3ec\ud568","voucher.introduction.doku":"\uad6c\ub9e4\ud574 \uc8fc\uc154\uc11c \uac10\uc0ac\ud569\ub2c8\ub2e4. \ub2e4\uc74c \uc815\ubcf4\ub97c \uc774\uc6a9\ud558\uc5ec \uacb0\uc81c\ub97c \uc644\ub8cc\ud558\uc2ed\uc2dc\uc624.","voucher.shopperName":"\uad6c\ub9e4\uc790 \uc774\ub984","voucher.merchantName":"\uac00\ub9f9\uc810","voucher.introduction.econtext":"\uad6c\ub9e4\ud574 \uc8fc\uc154\uc11c \uac10\uc0ac\ud569\ub2c8\ub2e4. \ub2e4\uc74c \uc815\ubcf4\ub97c \uc774\uc6a9\ud558\uc5ec \uacb0\uc81c\ub97c \uc644\ub8cc\ud558\uc2ed\uc2dc\uc624.","voucher.telephoneNumber":"\uc804\ud654\ubc88\ud638","voucher.shopperReference":"\uad6c\ub9e4\uc790 \ucc38\uc870\ubc88\ud638","voucher.collectionInstitutionNumber":"\uc218\uae08 \uae30\uad00 \ubc88\ud638","voucher.econtext.telephoneNumber.invalid":"\uc804\ud654\ubc88\ud638\ub294 10\uc790\ub9ac \ub610\ub294 11\uc790\ub9ac \uc22b\uc790\uc5ec\uc57c \ud569\ub2c8\ub2e4","boletobancario.btnLabel":"Boleto \uc0dd\uc131","boleto.sendCopyToEmail":"\ub0b4 \uc774\uba54\uc77c\ub85c \uc0ac\ubcf8 \ubcf4\ub0b4\uae30","button.copy":"\ubcf5\uc0ac","button.download":"\ub2e4\uc6b4\ub85c\ub4dc","creditCard.storedCard.description.ariaLabel":"\uc800\uc7a5\ub41c \uce74\ub4dc\ub294 %@ \ud6c4 \uc885\ub8cc\ub429\ub2c8\ub2e4.","voucher.entity":"\ubc1c\uae09\uc0ac","donateButton":"\uae30\ubd80\ud558\uae30","notNowButton":"\ub2e4\uc74c\uc5d0 \ud558\uae30","thanksForYourSupport":"\ub3c4\uc640\uc8fc\uc154\uc11c \uac10\uc0ac\ud569\ub2c8\ub2e4!","preauthorizeWith":"\uc0ac\uc804 \uc2b9\uc778 \ubc29\ubc95:","confirmPreauthorization":"\uc0ac\uc804 \uc2b9\uc778 \ud655\uc778","confirmPurchase":"\uad6c\ub9e4 \ud655\uc778","applyGiftcard":"\uae30\ud504\ud2b8 \uce74\ub4dc\ub85c \uacb0\uc81c","giftcardBalance":"\uae30\ud504\ud2b8 \uce74\ub4dc \uc794\uc561","deductedBalance":"\uacf5\uc81c \uc794\uc561","creditCard.pin.title":"\ube44\ubc00\ubc88\ud638","creditCard.encryptedPassword.label":"\uce74\ub4dc \ube44\ubc00\ubc88\ud638 \uccab 2\uc790\ub9ac","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"\uc720\ud6a8\ud558\uc9c0 \uc54a\uc740 \ubc88\ud638","creditCard.taxNumber.label":"\uce74\ub4dc \uc18c\uc720\uc790 \uc0dd\ub144\uc6d4\uc77c(\uc608: 870130) \ub610\ub294 \ubc95\uc778 \ub4f1\ub85d \ubc88\ud638(10\uc790\ub9ac)","creditCard.taxNumber.labelAlt":"\ubc95\uc778 \ub4f1\ub85d \ubc88\ud638(10\uc790\ub9ac)","creditCard.taxNumber.invalid":"\uc720\ud6a8\ud558\uc9c0 \uc54a\uc740 \uce74\ub4dc \uc18c\uc720\uc790 \uc0dd\ub144\uc6d4\uc77c \ub610\ub294 \ubc95\uc778 \ub4f1\ub85d \ubc88\ud638","storedPaymentMethod.disable.button":"\uc0ad\uc81c","storedPaymentMethod.disable.confirmation":"\uc800\uc7a5\ub41c \uacb0\uc81c \uc218\ub2e8 \uc0ad\uc81c","storedPaymentMethod.disable.confirmButton":"\uc608, \uc0ad\uc81c\ud569\ub2c8\ub2e4","storedPaymentMethod.disable.cancelButton":"\ucde8\uc18c","ach.bankAccount":"\uc740\ud589 \uacc4\uc88c","ach.accountHolderNameField.title":"\uacc4\uc88c \uc18c\uc720\uc790 \uc774\ub984","ach.accountHolderNameField.placeholder":"J. Smith","ach.accountHolderNameField.invalid":"\uc720\ud6a8\ud558\uc9c0 \uc54a\uc740 \uacc4\uc88c \uc18c\uc720\uc790 \uc774\ub984","ach.accountNumberField.title":"\uacc4\uc88c \ubc88\ud638","ach.accountNumberField.invalid":"\uc720\ud6a8\ud558\uc9c0 \uc54a\uc740 \uacc4\uc88c \ubc88\ud638","ach.accountLocationField.title":"ABA \ub77c\uc6b0\ud305 \ubc88\ud638","ach.accountLocationField.invalid":"\uc720\ud6a8\ud558\uc9c0 \uc54a\uc740 ABA \ub77c\uc6b0\ud305 \ubc88\ud638","select.state":"\uc8fc \uc120\ud0dd","select.stateOrProvince":"\uc8fc/\ub3c4 \uc120\ud0dd","select.provinceOrTerritory":"\ub3c4 \uc120\ud0dd","select.country":"\uad6d\uac00 \uc120\ud0dd","telephoneNumber.invalid":"\uc720\ud6a8\ud558\uc9c0 \uc54a\uc740 \uc804\ud654\ubc88\ud638","qrCodeOrApp":"\ub610\ub294","paypal.processingPayment":"\uacb0\uc81c \ucc98\ub9ac \uc911...","generateQRCode":"QR \ucf54\ub4dc \uc0dd\uc131","await.waitForConfirmation":"\ud655\uc778 \ub300\uae30\uc911","mbway.confirmPayment":"MB WAY \uc571\uc5d0\uc11c \uacb0\uc81c\ub97c \ud655\uc778\ud558\uc2ed\uc2dc\uc624","shopperEmail.invalid":"\uc720\ud6a8\ud558\uc9c0 \uc54a\uc740 \uc774\uba54\uc77c \uc8fc\uc18c","dateOfBirth.format":"DD(\uc77c)/MM(\uc6d4)/YYYY(\uc5f0\ub3c4)","dateOfBirth.invalid":"\ucd5c\uc18c 18\uc138 \uc774\uc0c1\uc774\uc5b4\uc57c \ud569\ub2c8\ub2e4","blik.confirmPayment":"\ubc45\ud0b9 \uc571\uc744 \uc5f4\uc5b4\uc11c \uacb0\uc81c\ub97c \ud655\uc778\ud558\uc138\uc694.","blik.invalid":"6\uc790\ub9ac \uc22b\uc790 \uc785\ub825","blik.code":"6\uc790\ub9ac \ucf54\ub4dc","blik.help":"\ubc45\ud0b9 \uc571\uc5d0\uc11c \ucf54\ub4dc\ub97c \uac00\uc838\uc624\uc138\uc694.","swish.pendingMessage":"\uc2a4\uce94 \ud6c4 \ucd5c\ub300 10\ubd84 \ub3d9\uc548 \uc0c1\ud0dc\uac00 \ubcf4\ub958\ub420 \uc218 \uc788\uc2b5\ub2c8\ub2e4. 10\ubd84 \ub0b4\uc5d0 \ub2e4\uc2dc \uc2dc\ub3c4\ud560 \uacbd\uc6b0 \uae08\uc561\uc774 \uc5ec\ub7ec \ubc88 \uccad\uad6c\ub420 \uc218 \uc788\uc2b5\ub2c8\ub2e4.","error.va.gen.01":"\ubbf8\uc644\ub8cc \ud544\ub4dc","error.va.gen.02":"\ud544\ub4dc\uac00 \uc720\ud6a8\ud558\uc9c0 \uc54a\uc2b5\ub2c8\ub2e4","error.va.sf-cc-num.01":"\uc720\ud6a8\ud558\uc9c0 \uc54a\uc740 \uce74\ub4dc \ubc88\ud638\uc785\ub2c8\ub2e4","error.va.sf-cc-num.03":"\uc9c0\uc6d0\ub418\uc9c0 \uc54a\ub294 \uce74\ub4dc\uac00 \uc785\ub825\ub418\uc5c8\uc2b5\ub2c8\ub2e4","error.va.sf-cc-dat.01":"\uce74\ub4dc\uac00 \ub108\ubb34 \uc624\ub798\ub418\uc5c8\uc2b5\ub2c8\ub2e4","error.va.sf-cc-dat.02":"\ud604\uc7ac\ub85c\ubd80\ud130 \ub108\ubb34 \uba3c \ub0a0\uc9dc\uc785\ub2c8\ub2e4","error.giftcard.no-balance":"\uc774 \uae30\ud504\ud2b8 \uce74\ub4dc\uc5d0\ub294 \uc794\uc561\uc774 \uc5c6\uc2b5\ub2c8\ub2e4","error.giftcard.card-error":"\uc774 \uae30\ud504\ud2b8 \uce74\ub4dc \ubc88\ud638\ub294 \ub2f9\uc0ac\uc5d0 \ub4f1\ub85d\ub418\uc5b4 \uc788\uc9c0 \uc54a\uc2b5\ub2c8\ub2e4","error.giftcard.currency-error":"\uae30\ud504\ud2b8 \uce74\ub4dc\ub294 \ubc1c\uae09\ub41c \ud1b5\ud654\ub85c\ub9cc \uc0ac\uc6a9\ud558\uc2e4 \uc218 \uc788\uc2b5\ub2c8\ub2e4","amazonpay.signout":"Amazon\uc5d0\uc11c \ub85c\uadf8\uc544\uc6c3","amazonpay.changePaymentDetails":"\uacb0\uc81c \uc815\ubcf4 \ubcc0\uacbd","partialPayment.warning":"\ub098\uba38\uc9c0 \ube44\uc6a9 \uc9c0\ubd88\uc5d0 \uc0ac\uc6a9\ud560 \ub2e4\ub978 \uacb0\uc81c \uc218\ub2e8 \uc120\ud0dd\ud558\uae30","partialPayment.remainingBalance":"\ub0a8\uc740 \uc794\uc561\uc740 %{amount}\uc785\ub2c8\ub2e4","bankTransfer.beneficiary":"\uc218\ub839\uc778","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"\ucc38\uc870 \ubc88\ud638","bankTransfer.introduction":"\uc0c8 \uacc4\uc88c \uc774\uccb4 \uac74\uc744 \uacc4\uc18d \uc9c4\ud589\ud569\ub2c8\ub2e4. \ub2e4\uc74c \ud654\uba74\uc5d0 \ub098\uc624\ub294 \uc815\ubcf4\ub97c \uc774\uc6a9\ud574 \uc774\uccb4\ub97c \uc644\ub8cc\ud558\uc2e4 \uc218 \uc788\uc2b5\ub2c8\ub2e4.","bankTransfer.instructions":"\uad6c\ub9e4\ud574 \uc8fc\uc154\uc11c \uac10\uc0ac\ud569\ub2c8\ub2e4. \ub2e4\uc74c \uc815\ubcf4\ub97c \uc774\uc6a9\ud558\uc5ec \uacb0\uc81c\ub97c \uc644\ub8cc\ud558\uc2ed\uc2dc\uc624.","bacs.accountHolderName":"\uc608\uae08\uc8fc \uc774\ub984","bacs.accountHolderName.invalid":"\uc608\uae08\uc8fc \uc774\ub984\uc774 \uc720\ud6a8\ud558\uc9c0 \uc54a\uc2b5\ub2c8\ub2e4","bacs.accountNumber":"\uacc4\uc88c \ubc88\ud638","bacs.accountNumber.invalid":"\uacc4\uc88c \ubc88\ud638\uac00 \uc720\ud6a8\ud558\uc9c0 \uc54a\uc2b5\ub2c8\ub2e4","bacs.bankLocationId":"\uc740\ud589 \uc2dd\ubcc4 \ucf54\ub4dc","bacs.bankLocationId.invalid":"\uc740\ud589 \uc2dd\ubcc4 \ucf54\ub4dc\uac00 \uc720\ud6a8\ud558\uc9c0 \uc54a\uc2b5\ub2c8\ub2e4","bacs.consent.amount":"\uacc4\uc88c\uc5d0\uc11c \uc704\uc758 \uae08\uc561\uc744 \uc774\uccb4\ud558\ub294 \uac83\uc5d0 \ub3d9\uc758\ud569\ub2c8\ub2e4.","bacs.consent.account":"\ubcf8\uc778\uc774 \uc774 \uacc4\uc88c\uc758 \uc608\uae08\uc8fc\uc774\uba70, \uc774 \uacc4\uc88c\uc5d0\uc11c\uc758 \uc790\ub3d9 \uc774\uccb4\ub97c \uc2b9\uc778\ud558\uae30 \uc704\ud574 \ud544\uc694\ud55c \uc720\uc77c\ud55c \uc11c\uba85\uc778\uc785\ub2c8\ub2e4.","edit":"\uc218\uc815","bacs.confirm":"\ud655\uc778 \ubc0f \uacb0\uc81c","bacs.result.introduction":"\uc790\ub3d9 \uc774\uccb4 \uc548\ub0b4(DDI/\ud544\uc218) \ub2e4\uc6b4\ub85c\ub4dc","download.pdf":"PDF \ub2e4\uc6b4\ub85c\ub4dc","creditCard.encryptedCardNumber.aria.iframeTitle":"\uce74\ub4dc \ubc88\ud638 \ubcf4\uc548\uc744 \uc704\ud55c Iframe","creditCard.encryptedCardNumber.aria.label":"\uce74\ub4dc \ubc88\ud638 \uc785\ub825\ub780","creditCard.encryptedExpiryDate.aria.iframeTitle":"\uce74\ub4dc \ub9cc\ub8cc \ub0a0\uc9dc \ubcf4\uc548\uc744 \uc704\ud55c Iframe","creditCard.encryptedExpiryDate.aria.label":"\ub9cc\ub8cc \ub0a0\uc9dc \uc785\ub825\ub780","creditCard.encryptedExpiryMonth.aria.iframeTitle":"\uce74\ub4dc \ub9cc\ub8cc \uc6d4 \ubcf4\uc548\uc744 \uc704\ud55c Iframe","creditCard.encryptedExpiryMonth.aria.label":"\ub9cc\ub8cc \uc6d4 \uc785\ub825\ub780","creditCard.encryptedExpiryYear.aria.iframeTitle":"\uce74\ub4dc \ub9cc\ub8cc \uc5f0\ub3c4 \ubcf4\uc548\uc744 \uc704\ud55c Iframe","creditCard.encryptedExpiryYear.aria.label":"\ub9cc\ub8cc \uc5f0\ub3c4 \uc785\ub825\ub780","creditCard.encryptedSecurityCode.aria.iframeTitle":"\uce74\ub4dc \ubcf4\uc548 \ucf54\ub4dc \ubcf4\uc548\uc744 \uc704\ud55c Iframe","creditCard.encryptedSecurityCode.aria.label":"\ubcf4\uc548 \ucf54\ub4dc \uc785\ub825\ub780","giftcard.encryptedCardNumber.aria.iframeTitle":"\uae30\ud504\ud2b8 \uce74\ub4dc \ubc88\ud638 \ubcf4\uc548\uc744 \uc704\ud55c Iframe","giftcard.encryptedCardNumber.aria.label":"\uae30\ud504\ud2b8 \uce74\ub4dc \ubc88\ud638 \uc785\ub825\ub780","giftcard.encryptedSecurityCode.aria.iframeTitle":"\uae30\ud504\ud2b8 \uce74\ub4dc \ubcf4\uc548 \ucf54\ub4dc \ubcf4\uc548\uc744 \uc704\ud55c Iframe","giftcard.encryptedSecurityCode.aria.label":"\uae30\ud504\ud2b8 \uce74\ub4dc \ubcf4\uc548 \ucf54\ub4dc \uc785\ub825\ub780","giftcardTransactionLimit":"\uc774 \uae30\ud504\ud2b8\uce74\ub4dc\ub85c \uac74\ub2f9 \uacb0\uc81c \uac00\ub2a5\ud55c \ucd5c\uace0 \uc561\uc218\ub294 %{amount}","ach.encryptedBankAccountNumber.aria.iframeTitle":"\uc740\ud589 \uacc4\uc88c \ubc88\ud638 \ubcf4\uc548\uc744 \uc704\ud55c Iframe","ach.encryptedBankAccountNumber.aria.label":"\uc740\ud589 \uacc4\uc88c \uc785\ub825\ub780","ach.encryptedBankLocationId.aria.iframeTitle":"\uc740\ud589 \ub77c\uc6b0\ud305 \ubc88\ud638 \ubcf4\uc548\uc744 \uc704\ud55c Iframe","ach.encryptedBankLocationId.aria.label":"\uc740\ud589 \ub77c\uc6b0\ud305 \ubc88\ud638 \uc785\ub825\ub780"}')},function(e){e.exports=JSON.parse('{"payButton":"Betaal","payButton.redirecting":"U wordt doorverwezen...","storeDetails":"Bewaar voor mijn volgende betaling","creditCard.holderName":"Naam op kaart","creditCard.holderName.placeholder":"J. Janssen","creditCard.holderName.invalid":"Ongeldige naam kaarthouder","creditCard.numberField.title":"Kaartnummer","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Vervaldatum","creditCard.expiryDateField.placeholder":"MM/JJ","creditCard.expiryDateField.month":"Maand","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"JJ","creditCard.expiryDateField.year":"Jaar","creditCard.cvcField.title":"Verificatiecode","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"Onthouden voor de volgende keer","creditCard.cvcField.placeholder.4digits":"4 cijfers","creditCard.cvcField.placeholder.3digits":"3 cijfers","creditCard.taxNumber.placeholder":"JJMMDD / 0123456789","installments":"Aantal termijnen","installmentOption":"%{times}x %{partialValue}","installmentOptionMonths":"%{times} maanden","installments.oneTime":"Eenmalige betaling","installments.installments":"Betaling termijnen","installments.revolving":"Terugkerende betaling","sepaDirectDebit.ibanField.invalid":"Ongeldig rekeningnummer","sepaDirectDebit.nameField.placeholder":"P. de Ridder","sepa.ownerName":"Ten name van","sepa.ibanNumber":"Rekeningnummer (IBAN)","error.title":"Fout","error.subtitle.redirect":"Doorsturen niet gelukt","error.subtitle.payment":"Betaling is niet geslaagd","error.subtitle.refused":"Betaling geweigerd","error.message.unknown":"Er is een onbekende fout opgetreden","idealIssuer.selectField.title":"Bank","idealIssuer.selectField.placeholder":"Selecteer uw bank","creditCard.success":"Betaling geslaagd","loading":"Laden....","continue":"Doorgaan","continueTo":"Doorgaan naar","wechatpay.timetopay":"U heeft %@ om te betalen","wechatpay.scanqrcode":"QR-code scannen","personalDetails":"Persoonlijke gegevens","companyDetails":"Bedrijfsgegevens","companyDetails.name":"Bedrijfsnaam","companyDetails.registrationNumber":"Registratienummer","socialSecurityNumber":"Burgerservicenummer","firstName":"Voornaam","infix":"Voorvoegsel","lastName":"Achternaam","mobileNumber":"Telefoonnummer mobiel","mobileNumber.invalid":"Ongeldig mobiel nummer","city":"Stad","postalCode":"Postcode","countryCode":"Landcode","telephoneNumber":"Telefoonnummer","dateOfBirth":"Geboortedatum","shopperEmail":"E-mailadres","gender":"Geslacht","male":"Man","female":"Vrouw","billingAddress":"Factuuradres","street":"Straatnaam","stateOrProvince":"Staat of provincie","country":"Land","houseNumberOrName":"Huisnummer","separateDeliveryAddress":"Een afwijkend bezorgadres opgeven","deliveryAddress":"Bezorgadres","zipCode":"Postcode","apartmentSuite":"Appartement/Suite","provinceOrTerritory":"Provincie of territorium","cityTown":"Stad","address":"Adres","state":"Staat","creditCard.cvcField.title.optional":"CVC / CVV (optioneel)","issuerList.wallet.placeholder":"Selecteer uw portemonnee","privacyPolicy":"Privacybeleid","afterPay.agreement":"Ik ga akkoord met de %@ van AfterPay","paymentConditions":"betalingsvoorwaarden","openApp":"Open de app","voucher.readInstructions":"Instructies lezen","voucher.introduction":"Bedankt voor uw aankoop. Gebruik deze coupon om uw betaling te voltooien.","voucher.expirationDate":"Vervaldatum","voucher.alternativeReference":"Alternatieve referentie","dragonpay.voucher.non.bank.selectField.placeholder":"Selecteer uw aanbieder","dragonpay.voucher.bank.selectField.placeholder":"Selecteer uw bank","voucher.paymentReferenceLabel":"Betalingsreferentie","voucher.surcharge":"Inclusief %@ toeslag","voucher.introduction.doku":"Bedankt voor uw aankoop. Gebruik de volgende informatie om uw betaling te voltooien.","voucher.shopperName":"Klantnaam","voucher.merchantName":"Verkoper","voucher.introduction.econtext":"Bedankt voor uw aankoop. Gebruik de volgende informatie om uw betaling te voltooien.","voucher.telephoneNumber":"Telefoonnummer","voucher.shopperReference":"Klant referentie","voucher.collectionInstitutionNumber":"Nummer ophaallocatie","voucher.econtext.telephoneNumber.invalid":"Het telefoonnummer moet uit 10 of 11 cijfers bestaan","boletobancario.btnLabel":"Boleto genereren","boleto.sendCopyToEmail":"Stuur een kopie naar mijn e-mailadres","button.copy":"Kopi\xebren","button.download":"Downloaden","creditCard.storedCard.description.ariaLabel":"Opgeslagen kaart eindigt op %@","voucher.entity":"Entiteit","donateButton":"Doneren","notNowButton":"Niet nu","thanksForYourSupport":"Bedankt voor uw donatie!","preauthorizeWith":"Preautorisatie uitvoeren met","confirmPreauthorization":"Preautorisatie bevestigen","confirmPurchase":"Aankoop bevestigen","applyGiftcard":"Inwisselen","giftcardBalance":"Saldo cadeaukaart","deductedBalance":"Afgetrokken bedrag","creditCard.pin.title":"PIN","creditCard.encryptedPassword.label":"Eerste twee cijfers van het wachtwoord van de kaart","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Ongeldig wachtwoord","creditCard.taxNumber.label":"Geboortedatum (JJ-MM-DD) of bedrijfsregistratienummer (10 cijfers) van kaarthouder","creditCard.taxNumber.labelAlt":"Bedrijfsregistratienummer (10 cijfers)","creditCard.taxNumber.invalid":"Geboortedatum of bedrijfsregistratienummer van kaarthouder is ongeldig","storedPaymentMethod.disable.button":"Verwijderen","storedPaymentMethod.disable.confirmation":"Opgeslagen betalingsmethode verwijderen","storedPaymentMethod.disable.confirmButton":"Ja, verwijderen","storedPaymentMethod.disable.cancelButton":"Annuleren","ach.bankAccount":"Bankrekening","ach.accountHolderNameField.title":"Naam rekeninghouder","ach.accountHolderNameField.placeholder":"J. Janssen","ach.accountHolderNameField.invalid":"Ongeldige naam rekeninghouder","ach.accountNumberField.title":"Rekeningnummer","ach.accountNumberField.invalid":"Ongeldig rekeningnummer","ach.accountLocationField.title":"Routingnummer (ABA)","ach.accountLocationField.invalid":"Ongeldig routingnummer (ABA)","select.state":"Selecteer staat","select.stateOrProvince":"Selecteer staat of provincie","select.provinceOrTerritory":"Selecteer provincie of territorium","select.country":"Selecteer land","telephoneNumber.invalid":"Ongeldig telefoonnummer","qrCodeOrApp":"of","paypal.processingPayment":"Betaling wordt verwerkt...","generateQRCode":"Genereer QR-code","await.waitForConfirmation":"Wacht op bevestiging","mbway.confirmPayment":"Bevestig uw betaling via de MB WAY-app","shopperEmail.invalid":"Ongeldig e-mailadres","dateOfBirth.format":"DD/MM/JJJJ","dateOfBirth.invalid":"U moet minimaal 18 jaar oud zijn","blik.confirmPayment":"Open uw bankapp om de betaling te bevestigen.","blik.invalid":"Voer 6 cijfers in","blik.code":"6-cijferige code","blik.help":"Haal de code op in uw bankapp.","swish.pendingMessage":"Nadat u hebt gescand, kan de status maximaal 10 minuten in behandeling zijn. Als u binnen deze periode opnieuw probeert te betalen, kunnen er meerdere keren kosten in rekening worden gebracht.","error.va.gen.01":"Onvolledig veld","error.va.gen.02":"Veld niet geldig","error.va.sf-cc-num.01":"Ongeldig kaartnummer","error.va.sf-cc-num.03":"Niet-ondersteunde kaart ingevoerd","error.va.sf-cc-dat.01":"Kaart te oud","error.va.sf-cc-dat.02":"Datum te ver in de toekomst","error.giftcard.no-balance":"Deze cadeaukaart heeft geen saldo","error.giftcard.card-error":"We hebben geen cadeaukaart met dit nummer in onze administratie","error.giftcard.currency-error":"Cadeaukaarten zijn alleen geldig in de valuta waarin ze zijn uitgegeven","amazonpay.signout":"Afmelden bij Amazon","amazonpay.changePaymentDetails":"Betalingsgegevens wijzigen","partialPayment.warning":"Selecteer een andere betaalmethode om het resterende deel te betalen","partialPayment.remainingBalance":"Het resterende saldo is %{amount}","bankTransfer.beneficiary":"Begunstigde","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"Referentie","bankTransfer.introduction":"Ga door om een nieuwe overschrijving aan te maken. U kunt de gegevens in het volgende scherm gebruiken om deze betaling af te ronden.","bankTransfer.instructions":"Bedankt voor uw aankoop. Gebruik de volgende informatie om uw betaling te voltooien.","bacs.accountHolderName":"Naam bankrekeninghouder","bacs.accountHolderName.invalid":"Ongeldige naam bankrekeninghouder","bacs.accountNumber":"Bankrekeningnummer","bacs.accountNumber.invalid":"Ongeldig bankrekeningnummer","bacs.bankLocationId":"Bankcode","bacs.bankLocationId.invalid":"Ongeldige bankcode","bacs.consent.amount":"Ik ga ermee akkoord dat het bovengenoemde bedrag van mijn bankrekening wordt afgeschreven.","bacs.consent.account":"Ik bevestig dat de rekening op mijn naam staat en dat ik de enige ondertekenaar ben die toestemming kan geven voor automatische incasso\'s vanaf deze rekening.","edit":"Bewerken","bacs.confirm":"Bevestigen en betalen","bacs.result.introduction":"Download uw machtiging automatische incasso","download.pdf":"PDF downloaden","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe voor beveiligd kaartnummer","creditCard.encryptedCardNumber.aria.label":"Veld voor kaartnummer","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe voor vervaldatum beveiligde kaart","creditCard.encryptedExpiryDate.aria.label":"Veld voor vervaldatum","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe voor vervalmaand beveiligde kaart","creditCard.encryptedExpiryMonth.aria.label":"Veld voor vervalmaand","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe voor vervaljaar beveiligde kaart","creditCard.encryptedExpiryYear.aria.label":"Veld voor vervaljaar","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe voor beveiligingscode beveiligde kaart","creditCard.encryptedSecurityCode.aria.label":"Veld voor beveiligingscode","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe voor beveiligd cadeaubonnummer","giftcard.encryptedCardNumber.aria.label":"Veld voor cadeaubonnummer","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe voor beveiligingscode beveiligde cadeaubon","giftcard.encryptedSecurityCode.aria.label":"Veld beveiligingscode cadeaubon","giftcardTransactionLimit":"Max. %{amount} toegestaan per transactie met deze cadeaubon","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe voor beveiligd bankrekeningnummer","ach.encryptedBankAccountNumber.aria.label":"Veld voor bankrekening","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe voor beveiligde BIC-code","ach.encryptedBankLocationId.aria.label":"Veld voor BIC-code"}')},function(e){e.exports=JSON.parse('{"payButton":"Betal","payButton.redirecting":"Omdirigerer...","storeDetails":"Lagre til min neste betaling","creditCard.holderName":"Navn p\xe5 kortet","creditCard.holderName.placeholder":"O. Nordmann","creditCard.holderName.invalid":"Ugyldig navn p\xe5 kortholder","creditCard.numberField.title":"Kortnummer","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Utl\xf8psdato","creditCard.expiryDateField.placeholder":"MM/\xc5\xc5","creditCard.expiryDateField.month":"M\xe5ned","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"\xc5\xc5","creditCard.expiryDateField.year":"\xc5r","creditCard.cvcField.title":"CVC / CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"Husk til neste gang","creditCard.cvcField.placeholder.4digits":"4 siffer","creditCard.cvcField.placeholder.3digits":"3 siffer","creditCard.taxNumber.placeholder":"YYMMDD / 0123456789","installments":"Antall avdrag","installmentOption":"%{times}x %{partialValue}","installmentOptionMonths":"%{times} m\xe5neder","installments.oneTime":"Engangsbetaling","installments.installments":"Avdragsbetaling","installments.revolving":"Gjentakende betaling","sepaDirectDebit.ibanField.invalid":"Ugyldig kontonummer","sepaDirectDebit.nameField.placeholder":"O. Nordmann","sepa.ownerName":"Kortholders navn","sepa.ibanNumber":"Kontonummer (IBAN)","error.title":"Feil","error.subtitle.redirect":"Videresending feilet","error.subtitle.payment":"Betaling feilet","error.subtitle.refused":"Betaling avvist","error.message.unknown":"En ukjent feil oppstod","idealIssuer.selectField.title":"Bank","idealIssuer.selectField.placeholder":"Velg din bank","creditCard.success":"Betalingen var vellykket","loading":"Laster...","continue":"Fortsett","continueTo":"Fortsett til","wechatpay.timetopay":"Du har %@ igjen til \xe5 betale","wechatpay.scanqrcode":"Skann QR-kode","personalDetails":"Personopplysninger","companyDetails":"Firmadetaljer","companyDetails.name":"Firmanavn","companyDetails.registrationNumber":"Registreringsnummer","socialSecurityNumber":"Personnummer","firstName":"Fornavn","infix":"Prefiks","lastName":"Etternavn","mobileNumber":"Mobilnummer","mobileNumber.invalid":"Ugyldig mobilnummer","city":"Poststed","postalCode":"Postnummer","countryCode":"Landkode","telephoneNumber":"Telefonnummer","dateOfBirth":"F\xf8dselsdato","shopperEmail":"E-postadresse","gender":"Kj\xf8nn","male":"Mann","female":"Kvinne","billingAddress":"Faktureringsadresse","street":"Gate","stateOrProvince":"Fylke","country":"Land","houseNumberOrName":"Husnummer","separateDeliveryAddress":"Spesifiser en separat leveringsadresse","deliveryAddress":"Leveringsadresse","zipCode":"Postnummer","apartmentSuite":"Leilighet/suite","provinceOrTerritory":"Provins eller territorium","cityTown":"By","address":"Adresse","state":"Delstat","creditCard.cvcField.title.optional":"CVC / CVV (valgfritt)","issuerList.wallet.placeholder":"Velg lommebok","privacyPolicy":"Retningslinjer for personvern","afterPay.agreement":"Jeg godtar AfterPays %@","paymentConditions":"betalingsbetingelser","openApp":"\xc5pne appen","voucher.readInstructions":"Les instruksjoner","voucher.introduction":"Takk for ditt kj\xf8p. Vennligst bruk den f\xf8lgende kupongen til \xe5 fullf\xf8re betalingen.","voucher.expirationDate":"Utl\xf8psdato","voucher.alternativeReference":"Alternativ referanse","dragonpay.voucher.non.bank.selectField.placeholder":"Velg din leverand\xf8r","dragonpay.voucher.bank.selectField.placeholder":"Velg din bank","voucher.paymentReferenceLabel":"Betalingsreferanse","voucher.surcharge":"Inkl. %@ tilleggsavgift","voucher.introduction.doku":"Takk for ditt kj\xf8p, vennligst bruk den f\xf8lgende informasjonen for \xe5 fullf\xf8re betalingen.","voucher.shopperName":"Kundenavn","voucher.merchantName":"Forhandler","voucher.introduction.econtext":"Takk for ditt kj\xf8p, vennligst bruk den f\xf8lgende informasjonen for \xe5 fullf\xf8re betalingen.","voucher.telephoneNumber":"Telefonnummer","voucher.shopperReference":"Kundereferanse","voucher.collectionInstitutionNumber":"Innbetalingslokasjonsnummer","voucher.econtext.telephoneNumber.invalid":"Telefonnummeret m\xe5 v\xe6re 10 eller 11 sifre langt","boletobancario.btnLabel":"Generer Boleto","boleto.sendCopyToEmail":"Send meg en kopi p\xe5 e-post","button.copy":"Kopier","button.download":"Last ned","creditCard.storedCard.description.ariaLabel":"Lagret kort slutter p\xe5 %@","voucher.entity":"Enhet","donateButton":"Don\xe9r","notNowButton":"Ikke n\xe5","thanksForYourSupport":"Takk for din st\xf8tte!","preauthorizeWith":"Forh\xe5ndsgodkjenn med","confirmPreauthorization":"Bekreft forh\xe5ndsgodkjenning","confirmPurchase":"Bekreft kj\xf8p","applyGiftcard":"L\xf8s inn","giftcardBalance":"Gavekortsaldo","deductedBalance":"Fratrukket bel\xf8p","creditCard.pin.title":"PIN","creditCard.encryptedPassword.label":"F\xf8rste 2 sifre av kortpassord","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Ugyldig passord","creditCard.taxNumber.label":"Kortholders f\xf8dselsdato (YYMMDD) eller bedriftsregistreringsnummer (10 siffer)","creditCard.taxNumber.labelAlt":"Bedriftsregistreringsnummer (10 siffer)","creditCard.taxNumber.invalid":"Ugyldig kortholders f\xf8dselsdato eller bedriftsregistreringsnummer","storedPaymentMethod.disable.button":"Fjern","storedPaymentMethod.disable.confirmation":"Fjern lagret betalingsmetode","storedPaymentMethod.disable.confirmButton":"Ja, fjern","storedPaymentMethod.disable.cancelButton":"Avbryt","ach.bankAccount":"Bankkonto","ach.accountHolderNameField.title":"Kontoholders navn","ach.accountHolderNameField.placeholder":"O. Nordmann","ach.accountHolderNameField.invalid":"Ugyldig navn p\xe5 kontoholder","ach.accountNumberField.title":"Kontonummer","ach.accountNumberField.invalid":"Ugyldig kontonummer","ach.accountLocationField.title":"ABA-dirigeringsnummer","ach.accountLocationField.invalid":"Ugyldig ABA-dirigeringsnummer","select.state":"Velg delstat","select.stateOrProvince":"Velg delstat eller provins","select.provinceOrTerritory":"Velg provins eller territorium","select.country":"Velg land","telephoneNumber.invalid":"Ugyldig telefonnummer","qrCodeOrApp":"eller","paypal.processingPayment":"Behandler betaling \u2026","generateQRCode":"Generer QR-kode","await.waitForConfirmation":"Venter p\xe5 bekreftelse","mbway.confirmPayment":"Bekreft betalingen din i MB WAY-appen","shopperEmail.invalid":"Ugyldig e-postadresse","dateOfBirth.format":"DD/MM/\xc5\xc5\xc5\xc5","dateOfBirth.invalid":"Du m\xe5 v\xe6re minst 18 \xe5r gammel","blik.confirmPayment":"\xc5pne bank-appen din for \xe5 bekrefte betalingen.","blik.invalid":"Tast inn 6 tall","blik.code":"6-sifret kode","blik.help":"Hent koden fra bank-appen din.","swish.pendingMessage":"Etter at du har skannet koden kan det ta opptil 10 minutter f\xf8r betalingen vises som bekreftet. Fors\xf8k p\xe5 \xe5 betale igjen kan f\xf8re til flere innbetalinger.","error.va.gen.01":"Ufullstendig felt","error.va.gen.02":"Feltet er ikke gyldig","error.va.sf-cc-num.01":"Ugyldig kortnummer","error.va.sf-cc-num.03":"Det angitte kortet st\xf8ttes ikke","error.va.sf-cc-dat.01":"Kortet er for gammelt","error.va.sf-cc-dat.02":"Datoen er for langt inn i fremtiden","error.giftcard.no-balance":"Dette gavekortet har en saldo p\xe5 null","error.giftcard.card-error":"Vi har ikke noe gavekort med dette nummeret i registrene v\xe5re","error.giftcard.currency-error":"Gavekort er kun gyldige i den valutaen de ble utstedt i","amazonpay.signout":"Logg ut av Amazon","amazonpay.changePaymentDetails":"Endre betalingsdetaljer","partialPayment.warning":"Velg en annen betalingsmetode for \xe5 betale det gjenv\xe6rende","partialPayment.remainingBalance":"Gjenv\xe6rende saldo vil v\xe6re %{amount}","bankTransfer.beneficiary":"Mottaker","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"referanse","bankTransfer.introduction":"Fortsett for \xe5 opprette en ny betaling via bankoverf\xf8ring. Du kan bruke detaljene i det f\xf8lgende skjermbildet for \xe5 fullf\xf8re betalingen.","bankTransfer.instructions":"Takk for kj\xf8pet. Vennligst benytt den f\xf8lgende informasjonen til \xe5 fullf\xf8re betalingen.","bacs.accountHolderName":"Kontoholders navn","bacs.accountHolderName.invalid":"Ugyldig kontoholdernavn","bacs.accountNumber":"Bankkontonummer","bacs.accountNumber.invalid":"Ugyldig bankkontonummer","bacs.bankLocationId":"Sorteringskode","bacs.bankLocationId.invalid":"Ugyldig sorteringskode","bacs.consent.amount":"Jeg samtykker til at bel\xf8pet ovenfor blir trukket fra bankkontoen min.","bacs.consent.account":"Jeg bekrefter at kontoen st\xe5r i mitt navn, og at jeg er den eneste signataren som kreves for \xe5 autorisere direktebelastningen p\xe5 denne kontoen.","edit":"Endre","bacs.confirm":"Bekreft og betal","bacs.result.introduction":"Last ned instruksjoner for direktebelastning (DDI/ mandat)","download.pdf":"Last ned PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe for sikret kortnummer","creditCard.encryptedCardNumber.aria.label":"Kortnummerfelt","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe for sikret kortutl\xf8psdato","creditCard.encryptedExpiryDate.aria.label":"Felt for utl\xf8psdato","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe for sikret kortutl\xf8psm\xe5ned","creditCard.encryptedExpiryMonth.aria.label":"Felt for utl\xf8psm\xe5ned","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe for sikret kortutl\xf8ps\xe5r","creditCard.encryptedExpiryYear.aria.label":"Felt for utl\xf8ps\xe5r","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe for sikret kortsikkerhetskode","creditCard.encryptedSecurityCode.aria.label":"Felt for sikkerhetskode","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe for sikret gavekortnummer","giftcard.encryptedCardNumber.aria.label":"Felt for gavekortnummer","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe for sikret gavekort-sikkerhetskode","giftcard.encryptedSecurityCode.aria.label":"Felt for sikkerhetskode for gavekort","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe for sikret bankkontonummer","ach.encryptedBankAccountNumber.aria.label":"Bankkontofelt","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe for sikret bankdirigeringsnummer","ach.encryptedBankLocationId.aria.label":"Felt for bankdirigeringsnummer"}')},function(e){e.exports=JSON.parse('{"payButton":"Zap\u0142a\u0107","payButton.redirecting":"Przekierowywanie...","storeDetails":"Zapisz na potrzeby nast\u0119pnej p\u0142atno\u015bci","creditCard.holderName":"Imi\u0119 i nazwisko na karcie","creditCard.holderName.placeholder":"J. Kowalski","creditCard.holderName.invalid":"Nieprawid\u0142owe imi\u0119 i nazwisko posiadacza karty","creditCard.numberField.title":"Numer karty ","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Data wa\u017cno\u015bci","creditCard.expiryDateField.placeholder":"MM/RR","creditCard.expiryDateField.month":"Miesi\u0105c","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"RR","creditCard.expiryDateField.year":"Rok","creditCard.cvcField.title":"CVC / CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"Zapami\u0119taj na przysz\u0142o\u015b\u0107","creditCard.cvcField.placeholder.4digits":"4 cyfry","creditCard.cvcField.placeholder.3digits":"3 cyfry","creditCard.taxNumber.placeholder":"RRMMDD / 0123456789","installments":"Liczba rat","installmentOption":"%{times}x %{partialValue}","installmentOptionMonths":"%{times} miesi\u0119cy","installments.oneTime":"P\u0142atno\u015b\u0107 jednorazowa","installments.installments":"P\u0142atno\u015b\u0107 ratalna","installments.revolving":"P\u0142atno\u015b\u0107 odnawialna","sepaDirectDebit.ibanField.invalid":"Nieprawid\u0142owy numer rachunku","sepaDirectDebit.nameField.placeholder":"J. Kowalski","sepa.ownerName":"Imi\u0119 i nazwisko posiadacza karty","sepa.ibanNumber":"Numer rachunku (IBAN)","error.title":"B\u0142\u0105d","error.subtitle.redirect":"Przekierowanie nie powiod\u0142o si\u0119","error.subtitle.payment":"P\u0142atno\u015b\u0107 nie powiod\u0142a si\u0119","error.subtitle.refused":"P\u0142atno\u015b\u0107 zosta\u0142a odrzucona","error.message.unknown":"Wyst\u0105pi\u0142 nieoczekiwany b\u0142\u0105d","idealIssuer.selectField.title":"Bank","idealIssuer.selectField.placeholder":"Wybierz sw\xf3j bank","creditCard.success":"P\u0142atno\u015b\u0107 zako\u0144czona sukcesem","loading":"\u0141adowanie...","continue":"Kontynuuj","continueTo":"Przejd\u017a do","wechatpay.timetopay":"Masz do zap\u0142acenia %@","wechatpay.scanqrcode":"Zeskanuj kod QR","personalDetails":"Dane osobowe","companyDetails":"Dane firmy","companyDetails.name":"Nazwa firmy","companyDetails.registrationNumber":"Numer w rejestrze","socialSecurityNumber":"Numer dowodu osobistego","firstName":"Imi\u0119","infix":"Prefiks","lastName":"Nazwisko","mobileNumber":"Numer telefonu kom\xf3rkowego","mobileNumber.invalid":"Nieprawid\u0142owy numer telefonu kom\xf3rkowego","city":"Miasto","postalCode":"Kod pocztowy","countryCode":"Kod kraju","telephoneNumber":"Numer telefonu","dateOfBirth":"Data urodzenia","shopperEmail":"Adres e-mail","gender":"P\u0142e\u0107","male":"M\u0119\u017cczyzna","female":"Kobieta","billingAddress":"Adres rozliczeniowy","street":"Ulica","stateOrProvince":"Wojew\xf3dztwo","country":"Kraj","houseNumberOrName":"Numer domu i mieszkania","separateDeliveryAddress":"Podaj osobny adres dostawy","deliveryAddress":"Adres dostawy","zipCode":"Kod pocztowy","apartmentSuite":"Numer domu/mieszkania","provinceOrTerritory":"Region lub terytorium","cityTown":"Miejscowo\u015b\u0107","address":"Adres","state":"Stan","creditCard.cvcField.title.optional":"CVC / CVV (opcjonalnie)","issuerList.wallet.placeholder":"Wybierz sw\xf3j portfel","privacyPolicy":"Polityka prywatno\u015bci.","afterPay.agreement":"Zgadzam si\u0119 z dokumentem %@ AfterPay","paymentConditions":"warunki p\u0142atno\u015bci","openApp":"Otw\xf3rz aplikacj\u0119","voucher.readInstructions":"Przeczytaj instrukcje","voucher.introduction":"Dzi\u0119kujemy za zakup, doko\u0144cz p\u0142atno\u015b\u0107 przy u\u017cyciu tego kuponu.","voucher.expirationDate":"Data wa\u017cno\u015bci","voucher.alternativeReference":"Dodatkowy numer referencyjny","dragonpay.voucher.non.bank.selectField.placeholder":"Wybierz dostawc\u0119","dragonpay.voucher.bank.selectField.placeholder":"Wybierz sw\xf3j bank","voucher.paymentReferenceLabel":"Nr referencyjny p\u0142atno\u015bci","voucher.surcharge":"Zawiera %@ op\u0142aty dodatkowej","voucher.introduction.doku":"Dzi\u0119kujemy za zakup. Doko\u0144cz p\u0142atno\u015b\u0107 przy u\u017cyciu poni\u017cszych informacji.","voucher.shopperName":"Imi\u0119 i nazwisko klienta","voucher.merchantName":"Sprzedaj\u0105cy","voucher.introduction.econtext":"Dzi\u0119kujemy za zakup. Doko\u0144cz p\u0142atno\u015b\u0107 przy u\u017cyciu poni\u017cszych informacji.","voucher.telephoneNumber":"Numer telefonu","voucher.shopperReference":"Dane referencyjne kupuj\u0105cych","voucher.collectionInstitutionNumber":"Numer instytucji pobieraj\u0105cej op\u0142at\u0119","voucher.econtext.telephoneNumber.invalid":"Numer telefonu musi mie\u0107 10 lub 11 cyfr","boletobancario.btnLabel":"Wygeneruj p\u0142atno\u015b\u0107 Boleto","boleto.sendCopyToEmail":"Wy\u015blij kopi\u0119 na m\xf3j e-mail","button.copy":"Kopiuj","button.download":"Pobierz","creditCard.storedCard.description.ariaLabel":"Zapisana karta ko\u0144czy si\u0119 na % @","voucher.entity":"Pozycja","donateButton":"Przeka\u017c darowizn\u0119","notNowButton":"Nie teraz","thanksForYourSupport":"Dzi\u0119kujemy za wsparcie!","preauthorizeWith":"Autoryzuj wst\u0119pnie za pomoc\u0105:","confirmPreauthorization":"Potwierd\u017a autoryzacj\u0119 wst\u0119pn\u0105","confirmPurchase":"Potwierd\u017a zakup","applyGiftcard":"Wykorzystaj","giftcardBalance":"Saldo karty podarunkowej","deductedBalance":"Saldo potr\u0105cone","creditCard.pin.title":"PIN","creditCard.encryptedPassword.label":"Pierwsze 2 cyfry has\u0142a karty","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Nieprawid\u0142owe has\u0142o","creditCard.taxNumber.label":"Data urodzenia posiadacza karty (RRMMDD) lub firmowy numer rejestracyjny (10 cyfr)","creditCard.taxNumber.labelAlt":"Firmowy numer rejestracyjny (10 cyfr)","creditCard.taxNumber.invalid":"Nieprawid\u0142owa data urodzenia posiadacza karty lub nieprawid\u0142owy firmowy numer rejestracyjny","storedPaymentMethod.disable.button":"Usu\u0144","storedPaymentMethod.disable.confirmation":"Usu\u0144 zapisan\u0105 metod\u0119 p\u0142atno\u015bci","storedPaymentMethod.disable.confirmButton":"Tak, usu\u0144","storedPaymentMethod.disable.cancelButton":"Anuluj","ach.bankAccount":"Rachunek bankowy","ach.accountHolderNameField.title":"Imi\u0119 i nazwisko posiadacza rachunku","ach.accountHolderNameField.placeholder":"J. Kowalski","ach.accountHolderNameField.invalid":"Nieprawid\u0142owe imi\u0119 i nazwisko posiadacza rachunku","ach.accountNumberField.title":"Numer rachunku","ach.accountNumberField.invalid":"Nieprawid\u0142owy numer rachunku","ach.accountLocationField.title":"Kod bankowy ABA Routing Number","ach.accountLocationField.invalid":"Nieprawid\u0142owy kod bankowy ABA Routing Number","select.state":"Wybierz stan","select.stateOrProvince":"Wybierz stan/wojew\xf3dztwo","select.provinceOrTerritory":"Wybierz region/terytorium","select.country":"Wybierz kraj","telephoneNumber.invalid":"Nieprawid\u0142owy numer telefonu","qrCodeOrApp":"lub","paypal.processingPayment":"Przetwarzanie p\u0142atno\u015bci...","generateQRCode":"Wygeneruj kod QR","await.waitForConfirmation":"Oczekiwanie na potwierdzenie","mbway.confirmPayment":"Potwierd\u017a p\u0142atno\u015b\u0107 w aplikacji MB WAY","shopperEmail.invalid":"Niepoprawny adres email","dateOfBirth.format":"DD/MM/RRRR","dateOfBirth.invalid":"Musisz mie\u0107 co najmniej 18 lat","blik.confirmPayment":"Otw\xf3rz aplikacj\u0119 bankow\u0105, aby potwierdzi\u0107 p\u0142atno\u015b\u0107.","blik.invalid":"Wpisz 6 cyfr","blik.code":"6-cyfrowy kod","blik.help":"Uzyskaj kod ze swojej aplikacji bankowej.","swish.pendingMessage":"Po zeskanowaniu transakcja mo\u017ce mie\u0107 status \u201eOczekuj\u0105ca\u201d do 10 minut. Pr\xf3ba ponownego dokonania p\u0142atno\u015bci w tym czasie mo\u017ce spowodowa\u0107 wielokrotne naliczenie op\u0142aty.","error.va.gen.01":"Niekompletne dane w polu","error.va.gen.02":"Dane w polu s\u0105 nieprawid\u0142owe","error.va.sf-cc-num.01":"Nieprawid\u0142owy numer karty","error.va.sf-cc-num.03":"Wprowadzono nieobs\u0142ugiwan\u0105 kart\u0119","error.va.sf-cc-dat.01":"Termin wa\u017cno\u015bci karty min\u0105\u0142","error.va.sf-cc-dat.02":"Data w zbyt odleg\u0142ej przysz\u0142o\u015bci","error.giftcard.no-balance":"Saldo karty podarunkowej jest puste","error.giftcard.card-error":"W naszych rejestrach nie ma karty podarunkowej o tym numerze","error.giftcard.currency-error":"Karty podarunkowe s\u0105 wa\u017cne tylko w walucie, w kt\xf3rej zosta\u0142y wydane","amazonpay.signout":"Wyloguj si\u0119 z Amazon","amazonpay.changePaymentDetails":"Zmie\u0144 szczeg\xf3\u0142y p\u0142atno\u015bci","partialPayment.warning":"Wybierz inn\u0105 metod\u0119 p\u0142atno\u015bci, aby zap\u0142aci\u0107 pozosta\u0142\u0105 kwot\u0119","partialPayment.remainingBalance":"Pozosta\u0142e saldo wynosi %(kwota}","bankTransfer.beneficiary":"Beneficjent","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"Ref. sprze.","bankTransfer.introduction":"Kontynuuj tworzenie nowej p\u0142atno\u015bci przelewem bankowym. Mo\u017cesz u\u017cy\u0107 szczeg\xf3\u0142\xf3w na nast\u0119pnym ekranie, aby sfinalizowa\u0107 t\u0119 p\u0142atno\u015b\u0107.","bankTransfer.instructions":"Dzi\u0119kujemy za zakup. Doko\u0144cz p\u0142atno\u015b\u0107 przy u\u017cyciu poni\u017cszych informacji.","bacs.accountHolderName":"Imi\u0119 i nazwisko posiadacza rachunku","bacs.accountHolderName.invalid":"Nieprawid\u0142owe imi\u0119 i nazwisko posiadacza rachunku","bacs.accountNumber":"Numer rachunku","bacs.accountNumber.invalid":"Nieprawid\u0142owy numer rachunku","bacs.bankLocationId":"Numer rozliczeniowy SORT","bacs.bankLocationId.invalid":"Nieprawid\u0142owy numer rozliczeniowy SORT","bacs.consent.amount":"Wyra\u017cam zgod\u0119 na pobranie powy\u017cszej kwoty z mojego rachunku bankowego.","bacs.consent.account":"Potwierdzam, \u017ce konto jest zarejestrowane na moje nazwisko i jestem jedynym sygnatariuszem wymaganym do autoryzacji polecenia zap\u0142aty na tym koncie.","edit":"Edytuj","bacs.confirm":"Potwierd\u017a i zap\u0142a\u0107","bacs.result.introduction":"Pobierz dyspozycj\u0119 polecenia zap\u0142aty (DDI/upowa\u017cnienie)","download.pdf":"Pobierz PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Element Iframe dla numeru zabezpieczonej karty","creditCard.encryptedCardNumber.aria.label":"Pole numeru karty","creditCard.encryptedExpiryDate.aria.iframeTitle":"Element Iframe dla daty wa\u017cno\u015bci zabezpieczonej karty","creditCard.encryptedExpiryDate.aria.label":"Pole daty wa\u017cno\u015bci","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Element Iframe dla miesi\u0105ca wyga\u015bni\u0119cia zabezpieczonej karty","creditCard.encryptedExpiryMonth.aria.label":"Pole miesi\u0105ca wyga\u015bni\u0119cia","creditCard.encryptedExpiryYear.aria.iframeTitle":"Element Iframe dla roku wyga\u015bni\u0119cia zabezpieczonej karty","creditCard.encryptedExpiryYear.aria.label":"Pole roku wyga\u015bni\u0119cia","creditCard.encryptedSecurityCode.aria.iframeTitle":"Element Iframe dla kodu bezpiecze\u0144stwa zabezpieczonej karty","creditCard.encryptedSecurityCode.aria.label":"Pole kodu bezpiecze\u0144stwa","giftcard.encryptedCardNumber.aria.iframeTitle":"Element Iframe dla numeru zabezpieczonej karty podarunkowej","giftcard.encryptedCardNumber.aria.label":"Pole numeru karty podarunkowej","giftcard.encryptedSecurityCode.aria.iframeTitle":"Element Iframe dla kodu bezpiecze\u0144stwa zabezpieczonej karty podarunkowej","giftcard.encryptedSecurityCode.aria.label":"Pole kodu bezpiecze\u0144stwa karty podarunkowej","giftcardTransactionLimit":"Maks. dozwolona kwota (%{amount}) na transakcj\u0119 t\u0105 kart\u0105 upominkow\u0105","ach.encryptedBankAccountNumber.aria.iframeTitle":"Element Iframe dla zabezpieczonego numeru rachunku bankowego","ach.encryptedBankAccountNumber.aria.label":"Pole rachunku bankowego","ach.encryptedBankLocationId.aria.iframeTitle":"Element Iframe dla zabezpieczonego kodu bankowego (Bank Routing Number)","ach.encryptedBankLocationId.aria.label":"Pole kodu bankowego (Bank Routing Number)"}')},function(e){e.exports=JSON.parse('{"payButton":"Pagar","payButton.redirecting":"Redirecionando...","storeDetails":"Salvar para meu pr\xf3ximo pagamento","creditCard.holderName":"Nome no cart\xe3o","creditCard.holderName.placeholder":"J. Smith","creditCard.holderName.invalid":"Nome do titular do cart\xe3o inv\xe1lido","creditCard.numberField.title":"N\xfamero do cart\xe3o","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Data de validade","creditCard.expiryDateField.placeholder":"MM/AA","creditCard.expiryDateField.month":"M\xeas","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"AA","creditCard.expiryDateField.year":"Ano","creditCard.cvcField.title":"CVC / CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"Lembrar para a pr\xf3xima vez","creditCard.cvcField.placeholder.4digits":"4 d\xedgitos","creditCard.cvcField.placeholder.3digits":"3 d\xedgitos","creditCard.taxNumber.placeholder":"AAAMMDD / 0123456789","installments":"Op\xe7\xf5es de Parcelamento","installmentOption":"%{times}x %{partialValue}","installmentOptionMonths":"%{times} meses","installments.oneTime":"Pagamento \xe0 vista","installments.installments":"Pagamento parcelado","installments.revolving":"Pagamento rotativo","sepaDirectDebit.ibanField.invalid":"N\xfamero de conta inv\xe1lido","sepaDirectDebit.nameField.placeholder":"J. Silva","sepa.ownerName":"Nome do titular da conta banc\xe1ria","sepa.ibanNumber":"N\xfamero de conta (NIB)","error.title":"Erro","error.subtitle.redirect":"Falha no redirecionamento","error.subtitle.payment":"Falha no pagamento","error.subtitle.refused":"Pagamento recusado","error.message.unknown":"Ocorreu um erro desconhecido","idealIssuer.selectField.title":"Banco","idealIssuer.selectField.placeholder":"Selecione seu banco","creditCard.success":"Pagamento bem-sucedido","loading":"Carregando...","continue":"Continuar","continueTo":"Continuar para","wechatpay.timetopay":"Voc\xea tem %@ para pagar","wechatpay.scanqrcode":"Escanear c\xf3digo QR","personalDetails":"Informa\xe7\xf5es pessoais","companyDetails":"Dados da empresa","companyDetails.name":"Nome da empresa","companyDetails.registrationNumber":"N\xfamero de registro","socialSecurityNumber":"CPF","firstName":"Nome","infix":"Prefixo","lastName":"Sobrenome","mobileNumber":"Celular","mobileNumber.invalid":"N\xfamero de celular inv\xe1lido","city":"Cidade","postalCode":"CEP","countryCode":"C\xf3digo do pa\xeds","telephoneNumber":"N\xfamero de telefone","dateOfBirth":"Data de nascimento","shopperEmail":"Endere\xe7o de e-mail","gender":"G\xeanero","male":"Masculino","female":"Feminino","billingAddress":"Endere\xe7o de cobran\xe7a","street":"Rua","stateOrProvince":"Estado ou prov\xedncia","country":"Pa\xeds","houseNumberOrName":"N\xfamero da casa","separateDeliveryAddress":"Especificar um endere\xe7o de entrega separado","deliveryAddress":"Endere\xe7o de entrega","zipCode":"C\xf3digo postal","apartmentSuite":"Apartamento/Conjunto","provinceOrTerritory":"Prov\xedncia ou territ\xf3rio","cityTown":"Cidade","address":"Endere\xe7o","state":"Estado","creditCard.cvcField.title.optional":"CVC / CVV (opcional)","issuerList.wallet.placeholder":"Selecione uma carteira","privacyPolicy":"Pol\xedtica de Privacidade","afterPay.agreement":"Eu concordo com as %@ do AfterPay","paymentConditions":"condi\xe7\xf5es de pagamento","openApp":"Abrir o aplicativo","voucher.readInstructions":"Leia as instru\xe7\xf5es","voucher.introduction":"Obrigado pela sua compra, use o cupom a seguir para concluir o seu pagamento.","voucher.expirationDate":"Data de validade","voucher.alternativeReference":"Refer\xeancia alternativa","dragonpay.voucher.non.bank.selectField.placeholder":"Selecione o seu fornecedor","dragonpay.voucher.bank.selectField.placeholder":"Selecione seu banco","voucher.paymentReferenceLabel":"Refer\xeancia de pagamento","voucher.surcharge":"Inclui %@ de sobretaxa","voucher.introduction.doku":"Obrigado pela sua compra, use a informa\xe7\xe3o a seguir para concluir o seu pagamento.","voucher.shopperName":"Nome do consumidor","voucher.merchantName":"Comerciante online","voucher.introduction.econtext":"Obrigado pela sua compra, use a informa\xe7\xe3o a seguir para concluir o seu pagamento.","voucher.telephoneNumber":"N\xfamero de telefone","voucher.shopperReference":"Refer\xeancia do consumidor","voucher.collectionInstitutionNumber":"N\xfamero da institui\xe7\xe3o de cobran\xe7a","voucher.econtext.telephoneNumber.invalid":"O n\xfamero de telefone deve ter 10 ou 11 d\xedgitos","boletobancario.btnLabel":"Gerar Boleto","boleto.sendCopyToEmail":"Enviar uma c\xf3pia por e-mail","button.copy":"Copiar","button.download":"Baixar","creditCard.storedCard.description.ariaLabel":"O cart\xe3o armazenado termina em %@","voucher.entity":"Entidade","donateButton":"Doar","notNowButton":"Agora n\xe3o","thanksForYourSupport":"Obrigado pelo apoio!","preauthorizeWith":"Pr\xe9-autorizar com","confirmPreauthorization":"Confirmar pr\xe9-autoriza\xe7\xe3o","confirmPurchase":"Confirmar compra","applyGiftcard":"Resgatar","giftcardBalance":"Saldo do vale-presente","deductedBalance":"Saldo debitado","creditCard.pin.title":"Pin","creditCard.encryptedPassword.label":"Primeiros dois d\xedgitos da senha do cart\xe3o","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Senha inv\xe1lida","creditCard.taxNumber.label":"Data de nascimento do titular do cart\xe3o (AAMMDD) ou n\xfamero de registro corporativo (10 d\xedgitos)","creditCard.taxNumber.labelAlt":"N\xfamero de registro corporativo (10 d\xedgitos)","creditCard.taxNumber.invalid":"Data de nascimento do titular do cart\xe3o ou n\xfamero de registro corporativo inv\xe1lidos","storedPaymentMethod.disable.button":"Remover","storedPaymentMethod.disable.confirmation":"Remover m\xe9todo de pagamento armazenado","storedPaymentMethod.disable.confirmButton":"Sim, remover","storedPaymentMethod.disable.cancelButton":"Cancelar","ach.bankAccount":"Conta banc\xe1ria","ach.accountHolderNameField.title":"Nome do titular da conta","ach.accountHolderNameField.placeholder":"J. Smith","ach.accountHolderNameField.invalid":"Nome do titular da conta inv\xe1lido","ach.accountNumberField.title":"N\xfamero da conta","ach.accountNumberField.invalid":"N\xfamero de conta inv\xe1lido","ach.accountLocationField.title":"N\xfamero de roteamento ABA","ach.accountLocationField.invalid":"N\xfamero de roteamento ABA inv\xe1lido","select.state":"Selecionar estado","select.stateOrProvince":"Selecione estado ou prov\xedncia","select.provinceOrTerritory":"Selecionar prov\xedncia ou territ\xf3rio","select.country":"Selecione o pa\xeds","telephoneNumber.invalid":"N\xfamero de telefone inv\xe1lido","qrCodeOrApp":"ou","paypal.processingPayment":"Processando pagamento...","generateQRCode":"Gerar c\xf3digo QR","await.waitForConfirmation":"Aguardando confirma\xe7\xe3o","mbway.confirmPayment":"Confirme seu pagamento no aplicativo MB WAY","shopperEmail.invalid":"Endere\xe7o de e-mail inv\xe1lido","dateOfBirth.format":"DD/MM/AAAA","dateOfBirth.invalid":"Voc\xea deve ter pelo menos 18 anos","blik.confirmPayment":"Abra o aplicativo do seu banco para confirmar o pagamento.","blik.invalid":"Digite 6 n\xfameros","blik.code":"C\xf3digo de 6 d\xedgitos","blik.help":"Obtenha o c\xf3digo no aplicativo do seu banco.","swish.pendingMessage":"Depois de escanear o QR, o status pode ficar pendente por at\xe9 10 minutos. N\xe3o tente refazer o pagamento antes desse per\xedodo para evitar cobran\xe7a duplicada.","error.va.gen.01":"Campo incompleto","error.va.gen.02":"Campo inv\xe1lido","error.va.sf-cc-num.01":"N\xfamero de cart\xe3o inv\xe1lido","error.va.sf-cc-num.03":"O cart\xe3o inserido n\xe3o \xe9 aceito","error.va.sf-cc-dat.01":"Cart\xe3o muito antigo","error.va.sf-cc-dat.02":"Data muito distante","error.giftcard.no-balance":"Este vale-presente tem saldo zero","error.giftcard.card-error":"N\xe3o existe um vale-presente com esse n\xfamero em nossos registros","error.giftcard.currency-error":"Os vales-presente s\xe3o v\xe1lidos somente na moeda em que foram emitidos","amazonpay.signout":"Sair do Amazon","amazonpay.changePaymentDetails":"Alterar dados de pagamento","partialPayment.warning":"Selecione outro m\xe9todo de pagamento para pagar o restante","partialPayment.remainingBalance":"O saldo restante ser\xe1 %{amount}","bankTransfer.beneficiary":"Benefici\xe1rio","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"Refer\xeancia","bankTransfer.introduction":"Continue criando o novo pagamento por transfer\xeancia banc\xe1ria. Use as informa\xe7\xf5es na tela a seguir para conclu\xed-lo.","bankTransfer.instructions":"Obrigado pela sua compra, use a informa\xe7\xe3o a seguir para concluir o seu pagamento.","bacs.accountHolderName":"Nome do titular da conta banc\xe1ria","bacs.accountHolderName.invalid":"Nome do titular da conta banc\xe1ria inv\xe1lido","bacs.accountNumber":"N\xfamero da conta banc\xe1ria","bacs.accountNumber.invalid":"N\xfamero da conta banc\xe1ria inv\xe1lido","bacs.bankLocationId":"C\xf3digo de classifica\xe7\xe3o","bacs.bankLocationId.invalid":"C\xf3digo de classifica\xe7\xe3o inv\xe1lido","bacs.consent.amount":"Concordo que o valor acima seja deduzido da minha conta banc\xe1ria.","bacs.consent.account":"Confirmo que a conta est\xe1 em meu nome e que sou o \xfanico signat\xe1rio que deve autorizar o d\xe9bito direto nessa conta.","edit":"Editar","bacs.confirm":"Confirmar e pagar","bacs.result.introduction":"Baixar instru\xe7\xe3o de d\xe9bito direto (DDI)","download.pdf":"Baixar PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe para n\xfamero de cart\xe3o seguro","creditCard.encryptedCardNumber.aria.label":"Campo de n\xfamero de cart\xe3o","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe para data de validade do cart\xe3o seguro","creditCard.encryptedExpiryDate.aria.label":"Campo de data de validade","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe para m\xeas de validade do cart\xe3o seguro","creditCard.encryptedExpiryMonth.aria.label":"Campo de m\xeas de validade","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe para ano de validade do cart\xe3o seguro","creditCard.encryptedExpiryYear.aria.label":"Campo de ano de validade","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe para c\xf3digo de seguran\xe7a do cart\xe3o seguro","creditCard.encryptedSecurityCode.aria.label":"Campo de c\xf3digo de seguran\xe7a","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe para n\xfamero de cart\xe3o-presente seguro","giftcard.encryptedCardNumber.aria.label":"Campo de n\xfamero do cart\xe3o-presente","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe para c\xf3digo de seguran\xe7a do cart\xe3o-presente seguro","giftcard.encryptedSecurityCode.aria.label":"Campo de c\xf3digo de seguran\xe7a do cart\xe3o-presente","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe para n\xfamero de conta banc\xe1ria segura","ach.encryptedBankAccountNumber.aria.label":"Campo de conta banc\xe1ria","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe para n\xfamero de roteamento banc\xe1rio seguro","ach.encryptedBankLocationId.aria.label":"Campo de n\xfamero de roteamento banc\xe1rio","pix.instructions":"Abra o app com sua chave PIX cadastrada, escolha Pagar com Pix e escaneie o QR Code ou copie e cole o c\xf3digo"}')},function(e){e.exports=JSON.parse('{"payButton":"Pl\u0103ti\u021bi","payButton.redirecting":"Se redirec\u021bioneaz\u0103...","storeDetails":"Salveaz\u0103 pentru urm\u0103toarea mea plat\u0103","creditCard.holderName":"Numele de pe card","creditCard.holderName.placeholder":"J. Smith","creditCard.holderName.invalid":"Numele posesorului de card este incorect","creditCard.numberField.title":"Num\u0103r card","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Data expir\u0103rii","creditCard.expiryDateField.placeholder":"LL/AA","creditCard.expiryDateField.month":"Lun\u0103","creditCard.expiryDateField.month.placeholder":"LL","creditCard.expiryDateField.year.placeholder":"AA","creditCard.expiryDateField.year":"An","creditCard.cvcField.title":"CVC/CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"Re\u021bine pentru data viitoare","creditCard.cvcField.placeholder.4digits":"4 cifre","creditCard.cvcField.placeholder.3digits":"3 cifre","creditCard.taxNumber.placeholder":"AALLZZ / 0123456789","installments":"Num\u0103r de rate","installmentOption":"%{times}x %{partialValue}","installmentOptionMonths":"%{times} luni","installments.oneTime":"Plat\u0103 unic\u0103","installments.installments":"Plat\u0103 \xeen rate","installments.revolving":"Plat\u0103 recurent\u0103","sepaDirectDebit.ibanField.invalid":"Num\u0103rul de cont este incorect","sepaDirectDebit.nameField.placeholder":"J. Smith","sepa.ownerName":"Nume posesor","sepa.ibanNumber":"Num\u0103r cont (IBAN)","error.title":"Eroare","error.subtitle.redirect":"Redirec\u021bionare e\u0219uat\u0103","error.subtitle.payment":"Plat\u0103 e\u0219uat\u0103","error.subtitle.refused":"Plat\u0103 refuzat\u0103","error.message.unknown":"S-a produs o eroare necunoscut\u0103","idealIssuer.selectField.title":"Banc\u0103","idealIssuer.selectField.placeholder":"Selecta\u021bi-v\u0103 banca","creditCard.success":"Plat\u0103 reu\u0219it\u0103","loading":"Se \xeencarc\u0103...","continue":"Continuare","continueTo":"Continua\u021bi c\u0103tre","wechatpay.timetopay":"Trebuie s\u0103 achita\u021bi %@","wechatpay.scanqrcode":"Scana\u021bi codul QR","personalDetails":"Informa\u021bii personale","companyDetails":"Informa\u021bii societate","companyDetails.name":"Denumirea societ\u0103\u021bii","companyDetails.registrationNumber":"Num\u0103r de \xeenregistrare","socialSecurityNumber":"Cod numeric personal","firstName":"Prenume","infix":"Titulatur\u0103","lastName":"Nume de familie","mobileNumber":"Num\u0103r de mobil","mobileNumber.invalid":"Num\u0103r de telefon mobil incorect","city":"Ora\u0219","postalCode":"Cod po\u0219tal","countryCode":"Codul \u021b\u0103rii","telephoneNumber":"Num\u0103r de telefon","dateOfBirth":"Data na\u0219terii","shopperEmail":"Adres\u0103 de e-mail","gender":"Gen","male":"B\u0103rbat","female":"Femeie","billingAddress":"Adresa de facturare","street":"Strada","stateOrProvince":"Jude\u021b sau provincie","country":"\u021aar\u0103","houseNumberOrName":"Num\u0103r","separateDeliveryAddress":"Specifica\u021bi o adres\u0103 de livrare separat\u0103","deliveryAddress":"Adres\u0103 de livrare","zipCode":"Cod po\u0219tal","apartmentSuite":"Apartament","provinceOrTerritory":"Provincie sau teritoriu","cityTown":"Ora\u0219/localitate","address":"Adres\u0103","state":"Stat","creditCard.cvcField.title.optional":"CVC/CVV (op\u021bional)","issuerList.wallet.placeholder":"Selecta\u021bi-v\u0103 portofelul","privacyPolicy":"Politica de confiden\u021bialitate","afterPay.agreement":"Sunt de acord cu %@ apar\u021bin\xe2nd AfterPay","paymentConditions":"condi\u021bii de plat\u0103","openApp":"Deschide\u021bi aplica\u021bia","voucher.readInstructions":"Citi\u021bi instruc\u021biunile","voucher.introduction":"V\u0103 mul\u021bumim pentru cump\u0103r\u0103turi, v\u0103 rug\u0103m s\u0103 utiliza\u021bi urm\u0103torul cupon pentru a v\u0103 finaliza plata.","voucher.expirationDate":"Data de expirare","voucher.alternativeReference":"Referin\u021b\u0103 alternativ\u0103","dragonpay.voucher.non.bank.selectField.placeholder":"Selecta\u021bi furnizorul dvs.","dragonpay.voucher.bank.selectField.placeholder":"Selecta\u021bi banca dvs.","voucher.paymentReferenceLabel":"Referin\u021ba pl\u0103\u021bii","voucher.surcharge":"Include suprataxa de %@","voucher.introduction.doku":"V\u0103 mul\u021bumim pentru cump\u0103r\u0103turi, v\u0103 rug\u0103m s\u0103 utiliza\u021bi urm\u0103toarele informa\u021bii pentru a v\u0103 finaliza plata.","voucher.shopperName":"Nume cump\u0103r\u0103tor","voucher.merchantName":"Comerciant","voucher.introduction.econtext":"V\u0103 mul\u021bumim pentru cump\u0103r\u0103turi, v\u0103 rug\u0103m s\u0103 utiliza\u021bi urm\u0103toarele informa\u021bii pentru a v\u0103 finaliza plata.","voucher.telephoneNumber":"Num\u0103r de telefon","voucher.shopperReference":"Referin\u021b\u0103 cump\u0103r\u0103tor","voucher.collectionInstitutionNumber":"Num\u0103r institu\u021bie de colectare","voucher.econtext.telephoneNumber.invalid":"Num\u0103rul de telefon trebuie s\u0103 aib\u0103 10 sau 11 cifre","boletobancario.btnLabel":"Generare Boleto","boleto.sendCopyToEmail":"Trimite o copie la adresa mea de e-mail","button.copy":"Copiere","button.download":"Desc\u0103rcare","creditCard.storedCard.description.ariaLabel":"Cardul memorat se termin\u0103 \xeen %@","voucher.entity":"Entitate","donateButton":"Dona\u021bi","notNowButton":"Nu acum","thanksForYourSupport":"V\u0103 mul\u021bumim pentru sprijin!","preauthorizeWith":"Preautorizare cu","confirmPreauthorization":"Confirma\u021bi preautorizarea","confirmPurchase":"Confirma\u021bi achizi\u021bia","applyGiftcard":"Valorificare","giftcardBalance":"Soldul de pe cardul cadou","deductedBalance":"Sold sc\u0103zut","creditCard.pin.title":"PIN","creditCard.encryptedPassword.label":"Primele 2 cifre ale parolei aferente cardului","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Parol\u0103 incorect\u0103","creditCard.taxNumber.label":"Data de na\u0219tere a posesorului de card (AALLZZ) sau num\u0103rul de \xeenregistrare al societ\u0103\u021bii (10 cifre).","creditCard.taxNumber.labelAlt":"Num\u0103rul de \xeenregistrare al societ\u0103\u021bii (10 cifre)","creditCard.taxNumber.invalid":"Data de na\u0219tere a posesorului de card sau num\u0103rul de \xeenregistrare al societ\u0103\u021bii este incorect","storedPaymentMethod.disable.button":"\u0218tergere","storedPaymentMethod.disable.confirmation":"\u0218terge\u021bi metoda de plat\u0103 memorat\u0103","storedPaymentMethod.disable.confirmButton":"Da, \u0219terge","storedPaymentMethod.disable.cancelButton":"Anulare","ach.bankAccount":"Cont bancar","ach.accountHolderNameField.title":"Numele titularului de cont","ach.accountHolderNameField.placeholder":"J. Smith","ach.accountHolderNameField.invalid":"Numele titularului de cont este incorect","ach.accountNumberField.title":"Num\u0103r de cont","ach.accountNumberField.invalid":"Num\u0103rul de cont este incorect","ach.accountLocationField.title":"Num\u0103r de direc\u021bionare ABA","ach.accountLocationField.invalid":"Num\u0103r de direc\u021bionare ABA incorect","select.state":"Selecta\u021bi statul","select.stateOrProvince":"Selecta\u021bi jude\u021bul sau provincia","select.provinceOrTerritory":"Selecta\u021bi provincia sau teritoriul","select.country":"Selecta\u021bi \u021bara","telephoneNumber.invalid":"Num\u0103r de telefon incorect","qrCodeOrApp":"sau","paypal.processingPayment":"Se prelucreaz\u0103 plata...","generateQRCode":"Genera\u021bi codul QR","await.waitForConfirmation":"Se a\u0219teapt\u0103 confirmarea","mbway.confirmPayment":"Confirma\u021bi plata \xeen aplica\u021bia MB WAY","shopperEmail.invalid":"Adres\u0103 de e-mail incorect\u0103","dateOfBirth.format":"ZZ/LL/AAAA","dateOfBirth.invalid":"Trebuie s\u0103 ave\u021bi minimum 18 ani","blik.confirmPayment":"Deschide\u021bi aplica\u021bia dvs. de banking pentru a confirma plata.","blik.invalid":"Introduce\u021bi 6 cifre","blik.code":"Cod din 6 cifre","blik.help":"Ob\u021bine\u021bi codul din aplica\u021bia dvs. de banking.","swish.pendingMessage":"Dup\u0103 ce scana\u021bi, starea poate fi \u201e\xeen a\u0219teptare\u201d timp de maximum 10 minute. \xcencerc\u0103rile de a pl\u0103ti din nou \xeen acest r\u0103stimp pot genera prelev\u0103ri multiple de fonduri.","error.va.gen.01":"C\xe2mp incomplet","error.va.gen.02":"C\xe2mp incorect","error.va.sf-cc-num.01":"Num\u0103r de card incorect","error.va.sf-cc-num.03":"A fost introdus un card neacceptat","error.va.sf-cc-dat.01":"Cardul este prea vechi","error.va.sf-cc-dat.02":"Data este prea departe \xeen viitor","error.giftcard.no-balance":"Acest card cadou are soldul zero","error.giftcard.card-error":"\xcen eviden\u021bele noastre nu figureaz\u0103 niciun card cadou cu acest num\u0103r","error.giftcard.currency-error":"Cardurile cadou sunt valabile numai \xeen moneda \xeen care au fost emise","amazonpay.signout":"Deconecta\u021bi-v\u0103 de pe platforma Amazon","amazonpay.changePaymentDetails":"Modifica\u021bi detaliile de plat\u0103","partialPayment.warning":"Pentru a achita suma r\u0103mas\u0103, selecta\u021bi o alt\u0103 metod\u0103 de plat\u0103","partialPayment.remainingBalance":"Soldul r\u0103mas va fi de %{amount}","bankTransfer.beneficiary":"Beneficiar","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"Referin\u0163\u0103","bankTransfer.introduction":"Continua\u021bi s\u0103 crea\u021bi o nou\u0103 plat\u0103 prin transfer bancar. Pute\u021bi utiliza detaliile din ecranul urm\u0103tor pentru a finaliza aceast\u0103 plat\u0103.","bankTransfer.instructions":"V\u0103 mul\u021bumim pentru cump\u0103r\u0103turi, v\u0103 rug\u0103m s\u0103 utiliza\u021bi urm\u0103toarele informa\u021bii pentru a v\u0103 finaliza plata.","bacs.accountHolderName":"Numele titularului contului bancar","bacs.accountHolderName.invalid":"Numele titularului contului bancar este incorect","bacs.accountNumber":"Num\u0103rul contului bancar","bacs.accountNumber.invalid":"Num\u0103rul contului bancar este incorect","bacs.bankLocationId":"Cod de identificare bancar\u0103","bacs.bankLocationId.invalid":"Cod de identificare bancar\u0103 incorect","bacs.consent.amount":"Sunt de acord ca suma men\u021bionat\u0103 mai sus s\u0103 fie dedus\u0103 din contul meu bancar.","bacs.consent.account":"Confirm c\u0103 sunt titularul acestui cont \u0219i c\u0103 sunt singurul semnatar necesar pentru autorizarea debitului direct pentru acest cont.","edit":"Editare","bacs.confirm":"Confirma\u021bi \u0219i pl\u0103ti\u021bi","bacs.result.introduction":"Desc\u0103rca\u021bi instruc\u021biunile de debitare direct\u0103 (DDI/mandat)","download.pdf":"Desc\u0103rca\u021bi PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe pentru num\u0103rul cardului securizat","creditCard.encryptedCardNumber.aria.label":"C\xe2mp aferent num\u0103rului cardului","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe pentru data de expirare a cardului securizat","creditCard.encryptedExpiryDate.aria.label":"C\xe2mp aferent datei de expirare","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe pentru luna de expirare a cardului securizat","creditCard.encryptedExpiryMonth.aria.label":"C\xe2mp aferent lunii de expirare","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe pentru anul de expirare a cardului securizat","creditCard.encryptedExpiryYear.aria.label":"C\xe2mp aferent anului de expirare","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe pentru codul de securitate al cardului securizat","creditCard.encryptedSecurityCode.aria.label":"C\xe2mp aferent codului de securitate","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe pentru num\u0103rul cardului cadou securizat","giftcard.encryptedCardNumber.aria.label":"C\xe2mp aferent num\u0103rului cardului cadou","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe pentru codul de securitate al cardului cadou securizat","giftcard.encryptedSecurityCode.aria.label":"C\xe2mp aferent codului de securitate al cardului cadou","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe pentru num\u0103rul contului bancar securizat","ach.encryptedBankAccountNumber.aria.label":"C\xe2mp aferent contului bancar","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe pentru num\u0103rul securizat de direc\u021bionare bancar\u0103 (routing number)","ach.encryptedBankLocationId.aria.label":"C\xe2mp aferent codului de direc\u021bionare bancar\u0103 (routing number)"}')},function(e){e.exports=JSON.parse('{"payButton":"\u0417\u0430\u043f\u043b\u0430\u0442\u0438\u0442\u044c","payButton.redirecting":"\u041f\u0435\u0440\u0435\u043d\u0430\u043f\u0440\u0430\u0432\u043b\u0435\u043d\u0438\u0435...","storeDetails":"\u0421\u043e\u0445\u0440\u0430\u043d\u0438\u0442\u044c \u0434\u043b\u044f \u0441\u043b\u0435\u0434\u0443\u044e\u0449\u0435\u0433\u043e \u043f\u043b\u0430\u0442\u0435\u0436\u0430","creditCard.holderName":"\u0418\u043c\u044f \u043d\u0430 \u043a\u0430\u0440\u0442\u0435","creditCard.holderName.placeholder":"\u0418. \u041f\u0435\u0442\u0440\u043e\u0432","creditCard.holderName.invalid":"\u041d\u0435\u0432\u0435\u0440\u043d\u043e\u0435 \u0438\u043c\u044f \u0432\u043b\u0430\u0434\u0435\u043b\u044c\u0446\u0430 \u043a\u0430\u0440\u0442\u044b","creditCard.numberField.title":"\u041d\u043e\u043c\u0435\u0440 \u043a\u0430\u0440\u0442\u044b","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"\u0421\u0440\u043e\u043a \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044f","creditCard.expiryDateField.placeholder":"\u041c\u041c/\u0413\u0413","creditCard.expiryDateField.month":"\u041c\u0435\u0441\u044f\u0446","creditCard.expiryDateField.month.placeholder":"\u041c\u041c","creditCard.expiryDateField.year.placeholder":"\u0413\u0413","creditCard.expiryDateField.year":"\u0413\u043e\u0434","creditCard.cvcField.title":"CVC / CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"\u0417\u0430\u043f\u043e\u043c\u043d\u0438\u0442\u044c \u043d\u0430 \u0441\u043b\u0435\u0434\u0443\u044e\u0449\u0438\u0439 \u0440\u0430\u0437","creditCard.cvcField.placeholder.4digits":"4 \u0446\u0438\u0444\u0440\u044b","creditCard.cvcField.placeholder.3digits":"3 \u0446\u0438\u0444\u0440\u044b","creditCard.taxNumber.placeholder":"\u0413\u0413\u041c\u041c\u0414\u0414 / 0123456789","installments":"\u041a\u043e\u043b\u0438\u0447\u0435\u0441\u0442\u0432\u043e \u043f\u043b\u0430\u0442\u0435\u0436\u0435\u0439","installmentOption":"%{times}\xd7 %{partialValue}","installmentOptionMonths":"%{times} \u043c\u0435\u0441.","installments.oneTime":"\u041e\u0434\u043d\u043e\u0440\u0430\u0437\u043e\u0432\u044b\u0439 \u043f\u043b\u0430\u0442\u0435\u0436","installments.installments":"\u0420\u0430\u0441\u0441\u0440\u043e\u0447\u043a\u0430","installments.revolving":"\u041f\u043e\u0432\u0442\u043e\u0440\u044f\u044e\u0449\u0430\u044f\u0441\u044f \u043e\u043f\u043b\u0430\u0442\u0430","sepaDirectDebit.ibanField.invalid":"\u041d\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043b\u044c\u043d\u044b\u0439 \u043d\u043e\u043c\u0435\u0440 \u0441\u0447\u0435\u0442\u0430","sepaDirectDebit.nameField.placeholder":"\u0418. \u041f\u0435\u0442\u0440\u043e\u0432","sepa.ownerName":"\u0418\u043c\u044f \u0432\u043b\u0430\u0434\u0435\u043b\u044c\u0446\u0430","sepa.ibanNumber":"\u041d\u043e\u043c\u0435\u0440 \u0441\u0447\u0435\u0442\u0430 (IBAN)","error.title":"\u041e\u0448\u0438\u0431\u043a\u0430","error.subtitle.redirect":"\u0421\u0431\u043e\u0439 \u043f\u0435\u0440\u0435\u043d\u0430\u043f\u0440\u0430\u0432\u043b\u0435\u043d\u0438\u044f","error.subtitle.payment":"\u0421\u0431\u043e\u0439 \u043e\u043f\u043b\u0430\u0442\u044b","error.subtitle.refused":"\u041e\u043f\u043b\u0430\u0442\u0430 \u043e\u0442\u043a\u043b\u043e\u043d\u0435\u043d\u0430","error.message.unknown":"\u0412\u043e\u0437\u043d\u0438\u043a\u043b\u0430 \u043d\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043d\u0430\u044f \u043e\u0448\u0438\u0431\u043a\u0430","idealIssuer.selectField.title":"\u0411\u0430\u043d\u043a","idealIssuer.selectField.placeholder":"\u0412\u044b\u0431\u0435\u0440\u0438\u0442\u0435 \u0431\u0430\u043d\u043a","creditCard.success":"\u041f\u043b\u0430\u0442\u0435\u0436 \u0443\u0441\u043f\u0435\u0448\u043d\u043e \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043d","loading":"\u0417\u0430\u0433\u0440\u0443\u0437\u043a\u0430\u2026","continue":"\u041f\u0440\u043e\u0434\u043e\u043b\u0436\u0438\u0442\u044c","continueTo":"\u041f\u0435\u0440\u0435\u0439\u0442\u0438 \u043a","wechatpay.timetopay":"\u0423 \u0432\u0430\u0441 %@ \u043d\u0430 \u043e\u043f\u043b\u0430\u0442\u0443","wechatpay.scanqrcode":"\u0421\u043a\u0430\u043d\u0438\u0440\u043e\u0432\u0430\u0442\u044c QR-\u043a\u043e\u0434","personalDetails":"\u041b\u0438\u0447\u043d\u044b\u0435 \u0434\u0430\u043d\u043d\u044b\u0435","companyDetails":"\u0414\u0430\u043d\u043d\u044b\u0435 \u043a\u043e\u043c\u043f\u0430\u043d\u0438\u0438","companyDetails.name":"\u041d\u0430\u0437\u0432\u0430\u043d\u0438\u0435 \u043a\u043e\u043c\u043f\u0430\u043d\u0438\u0438","companyDetails.registrationNumber":"\u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u043e\u043d\u043d\u044b\u0439 \u043d\u043e\u043c\u0435\u0440","socialSecurityNumber":"\u041d\u043e\u043c\u0435\u0440 \u0441\u043e\u0446\u0438\u0430\u043b\u044c\u043d\u043e\u0433\u043e \u0441\u0442\u0440\u0430\u0445\u043e\u0432\u0430\u043d\u0438\u044f \u0438\u043b\u0438 \u0418\u041d\u041d","firstName":"\u0418\u043c\u044f","infix":"\u041f\u0440\u0438\u0441\u0442\u0430\u0432\u043a\u0430","lastName":"\u0424\u0430\u043c\u0438\u043b\u0438\u044f","mobileNumber":"\u041c\u043e\u0431\u0438\u043b\u044c\u043d\u044b\u0439 \u0442\u0435\u043b\u0435\u0444\u043e\u043d","mobileNumber.invalid":"\u041d\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043b\u044c\u043d\u043e\u0439 \u043d\u043e\u043c\u0435\u0440 \u043c\u043e\u0431\u0438\u043b\u044c\u043d\u043e\u0433\u043e","city":"\u0413\u043e\u0440\u043e\u0434","postalCode":"\u041f\u043e\u0447\u0442\u043e\u0432\u044b\u0439 \u0438\u043d\u0434\u0435\u043a\u0441","countryCode":"\u041a\u043e\u0434 \u0441\u0442\u0440\u0430\u043d\u044b","telephoneNumber":"\u041d\u043e\u043c\u0435\u0440 \u0442\u0435\u043b\u0435\u0444\u043e\u043d\u0430","dateOfBirth":"\u0414\u0430\u0442\u0430 \u0440\u043e\u0436\u0434\u0435\u043d\u0438\u044f","shopperEmail":"\u0410\u0434\u0440\u0435\u0441 \u044d\u043b. \u043f\u043e\u0447\u0442\u044b","gender":"\u041f\u043e\u043b","male":"\u041c\u0443\u0436\u0447\u0438\u043d\u0430","female":"\u0416\u0435\u043d\u0449\u0438\u043d\u0430","billingAddress":"\u041f\u043b\u0430\u0442\u0435\u0436\u043d\u044b\u0439 \u0430\u0434\u0440\u0435\u0441","street":"\u0423\u043b\u0438\u0446\u0430","stateOrProvince":"\u0420\u0435\u0433\u0438\u043e\u043d","country":"\u0421\u0442\u0440\u0430\u043d\u0430","houseNumberOrName":"\u041d\u043e\u043c\u0435\u0440 \u0434\u043e\u043c\u0430","separateDeliveryAddress":"\u0423\u043a\u0430\u0436\u0438\u0442\u0435 \u043e\u0442\u0434\u0435\u043b\u044c\u043d\u044b\u0439 \u0430\u0434\u0440\u0435\u0441 \u0434\u043e\u0441\u0442\u0430\u0432\u043a\u0438","deliveryAddress":"\u0410\u0434\u0440\u0435\u0441 \u0434\u043e\u0441\u0442\u0430\u0432\u043a\u0438","zipCode":"\u041f\u043e\u0447\u0442\u043e\u0432\u044b\u0439 \u0438\u043d\u0434\u0435\u043a\u0441","apartmentSuite":"\u041a\u0432\u0430\u0440\u0442\u0438\u0440\u0430","provinceOrTerritory":"\u041f\u0440\u043e\u0432\u0438\u043d\u0446\u0438\u044f \u0438\u043b\u0438 \u0442\u0435\u0440\u0440\u0438\u0442\u043e\u0440\u0438\u044f","cityTown":"\u0413\u043e\u0440\u043e\u0434","address":"\u0410\u0434\u0440\u0435\u0441","state":"\u0428\u0442\u0430\u0442","creditCard.cvcField.title.optional":"CVC / CVV (\u043d\u0435\u043e\u0431\u044f\u0437\u0430\u0442\u0435\u043b\u044c\u043d\u043e)","issuerList.wallet.placeholder":"\u0412\u044b\u0431\u0435\u0440\u0438\u0442\u0435 \u043a\u043e\u0448\u0435\u043b\u0435\u043a","privacyPolicy":"\u041f\u043e\u043b\u0438\u0442\u0438\u043a\u0430 \u043a\u043e\u043d\u0444\u0438\u0434\u0435\u043d\u0446\u0438\u0430\u043b\u044c\u043d\u043e\u0441\u0442\u0438","afterPay.agreement":"\u042f \u043f\u0440\u0438\u043d\u0438\u043c\u0430\u044e %@ AfterPay","paymentConditions":"\u0443\u0441\u043b\u043e\u0432\u0438\u044f \u043e\u043f\u043b\u0430\u0442\u044b","openApp":"\u041e\u0442\u043a\u0440\u044b\u0442\u044c \u043f\u0440\u0438\u043b\u043e\u0436\u0435\u043d\u0438\u0435","voucher.readInstructions":"\u041f\u0440\u043e\u0447\u0438\u0442\u0430\u0439\u0442\u0435 \u0438\u043d\u0441\u0442\u0440\u0443\u043a\u0446\u0438\u0438","voucher.introduction":"\u0411\u043b\u0430\u0433\u043e\u0434\u0430\u0440\u0438\u043c \u0437\u0430 \u043f\u043e\u043a\u0443\u043f\u043a\u0443. \u0414\u043b\u044f \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043d\u0438\u044f \u043e\u043f\u043b\u0430\u0442\u044b \u0438\u0441\u043f\u043e\u043b\u044c\u0437\u0443\u0439\u0442\u0435 \u0441\u043b\u0435\u0434\u0443\u044e\u0449\u0438\u0439 \u043a\u0443\u043f\u043e\u043d.","voucher.expirationDate":"\u0421\u0440\u043e\u043a \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044f","voucher.alternativeReference":"\u0414\u0440\u0443\u0433\u043e\u0439 \u043a\u043e\u0434","dragonpay.voucher.non.bank.selectField.placeholder":"\u0412\u044b\u0431\u0435\u0440\u0438\u0442\u0435 \u0441\u0432\u043e\u0435\u0433\u043e \u043e\u043f\u0435\u0440\u0430\u0442\u043e\u0440\u0430","dragonpay.voucher.bank.selectField.placeholder":"\u0412\u044b\u0431\u0435\u0440\u0438\u0442\u0435 \u0431\u0430\u043d\u043a","voucher.paymentReferenceLabel":"\u041a\u043e\u0434 \u043e\u043f\u043b\u0430\u0442\u044b","voucher.surcharge":"\u0412\u043a\u043b. \u043a\u043e\u043c\u0438\u0441\u0441\u0438\u044e %@","voucher.introduction.doku":"\u0411\u043b\u0430\u0433\u043e\u0434\u0430\u0440\u0438\u043c \u0437\u0430 \u043f\u043e\u043a\u0443\u043f\u043a\u0443. \u0414\u043b\u044f \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043d\u0438\u044f \u043e\u043f\u043b\u0430\u0442\u044b \u0438\u0441\u043f\u043e\u043b\u044c\u0437\u0443\u0439\u0442\u0435 \u0441\u043b\u0435\u0434\u0443\u044e\u0449\u0438\u0435 \u0441\u0432\u0435\u0434\u0435\u043d\u0438\u044f.","voucher.shopperName":"\u0418\u043c\u044f \u043f\u043e\u043a\u0443\u043f\u0430\u0442\u0435\u043b\u044f","voucher.merchantName":"\u041f\u0440\u043e\u0434\u0430\u0432\u0435\u0446","voucher.introduction.econtext":"\u0411\u043b\u0430\u0433\u043e\u0434\u0430\u0440\u0438\u043c \u0437\u0430 \u043f\u043e\u043a\u0443\u043f\u043a\u0443. \u0414\u043b\u044f \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043d\u0438\u044f \u043e\u043f\u043b\u0430\u0442\u044b \u0438\u0441\u043f\u043e\u043b\u044c\u0437\u0443\u0439\u0442\u0435 \u0441\u043b\u0435\u0434\u0443\u044e\u0449\u0438\u0435 \u0441\u0432\u0435\u0434\u0435\u043d\u0438\u044f.","voucher.telephoneNumber":"\u041d\u043e\u043c\u0435\u0440 \u0442\u0435\u043b\u0435\u0444\u043e\u043d\u0430","voucher.shopperReference":"\u0421\u043f\u0440\u0430\u0432\u043e\u0447\u043d\u0438\u043a \u043f\u043e\u043a\u0443\u043f\u0430\u0442\u0435\u043b\u044f","voucher.collectionInstitutionNumber":"\u041d\u043e\u043c\u0435\u0440 \u043f\u043e\u043b\u0443\u0447\u0430\u0442\u0435\u043b\u044f \u0441\u0440\u0435\u0434\u0441\u0442\u0432","voucher.econtext.telephoneNumber.invalid":"\u041d\u043e\u043c\u0435\u0440 \u0442\u0435\u043b\u0435\u0444\u043e\u043d\u0430 \u0434\u043e\u043b\u0436\u0435\u043d \u0431\u044b\u0442\u044c \u0434\u043b\u0438\u043d\u043e\u0439 10 \u0438\u043b\u0438 11 \u0446\u0438\u0444\u0440","boletobancario.btnLabel":"\u0421\u043e\u0437\u0434\u0430\u0442\u044c Boleto","boleto.sendCopyToEmail":"\u041e\u0442\u043f\u0440\u0430\u0432\u0438\u0442\u044c \u043c\u043d\u0435 \u043a\u043e\u043f\u0438\u044e \u043d\u0430 \u044d\u043b. \u043f\u043e\u0447\u0442\u0443","button.copy":"\u041a\u043e\u043f\u0438\u044f","button.download":"\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044c","creditCard.storedCard.description.ariaLabel":"\u0421\u043e\u0445\u0440\u0430\u043d\u0435\u043d\u043d\u0430\u044f \u043a\u0430\u0440\u0442\u0430 \u0437\u0430\u043a\u0430\u043d\u0447\u0438\u0432\u0430\u0435\u0442\u0441\u044f \u043d\u0430 %@","voucher.entity":"\u041e\u0431\u044a\u0435\u043a\u0442","donateButton":"\u041f\u043e\u0436\u0435\u0440\u0442\u0432\u043e\u0432\u0430\u0442\u044c","notNowButton":"\u041f\u043e\u0437\u0436\u0435","thanksForYourSupport":"\u0411\u043b\u0430\u0433\u043e\u0434\u0430\u0440\u0438\u043c \u0437\u0430 \u043f\u043e\u0434\u0434\u0435\u0440\u0436\u043a\u0443!","preauthorizeWith":"\u041f\u0440\u0435\u0434\u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u044f \u0432","confirmPreauthorization":"\u041f\u043e\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044c \u043f\u0440\u0435\u0434\u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u044e","confirmPurchase":"\u041f\u043e\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044c \u043f\u043e\u043a\u0443\u043f\u043a\u0443","applyGiftcard":"\u0418\u0441\u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u044c","giftcardBalance":"\u0411\u0430\u043b\u0430\u043d\u0441 \u043f\u043e\u0434\u0430\u0440\u043e\u0447\u043d\u043e\u0439 \u043a\u0430\u0440\u0442\u044b","deductedBalance":"\u0411\u0430\u043b\u0430\u043d\u0441 \u0441\u043f\u0438\u0441\u0430\u043d\u0438\u0439","creditCard.pin.title":"PIN-\u043a\u043e\u0434","creditCard.encryptedPassword.label":"\u041f\u0435\u0440\u0432\u044b\u0435 2 \u0446\u0438\u0444\u0440\u044b \u043f\u0430\u0440\u043e\u043b\u044f \u043a\u0430\u0440\u0442\u044b","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"\u041d\u0435\u0432\u0435\u0440\u043d\u044b\u0439 \u043f\u0430\u0440\u043e\u043b\u044c","creditCard.taxNumber.label":"\u0414\u0430\u0442\u0430 \u0440\u043e\u0436\u0434\u0435\u043d\u0438\u044f \u0432\u043b\u0430\u0434\u0435\u043b\u044c\u0446\u0430 \u043a\u0430\u0440\u0442\u044b (\u0413\u0413\u041c\u041c\u0414\u0414) \u0438\u043b\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u043e\u043d\u043d\u044b\u0439 \u043d\u043e\u043c\u0435\u0440 \u043f\u0440\u0435\u0434\u043f\u0440\u0438\u044f\u0442\u0438\u044f (10 \u0446\u0438\u0444\u0440)","creditCard.taxNumber.labelAlt":"\u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u043e\u043d\u043d\u044b\u0439 \u043d\u043e\u043c\u0435\u0440 \u043f\u0440\u0435\u0434\u043f\u0440\u0438\u044f\u0442\u0438\u044f (10 \u0446\u0438\u0444\u0440)","creditCard.taxNumber.invalid":"\u041d\u0435\u0432\u0435\u0440\u043d\u0430\u044f \u0434\u0430\u0442\u0430 \u0440\u043e\u0436\u0434\u0435\u043d\u0438\u044f \u0432\u043b\u0430\u0434\u0435\u043b\u044c\u0446\u0430 \u043a\u0430\u0440\u0442\u044b \u0438\u043b\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u043e\u043d\u043d\u043e\u0433\u043e \u043d\u043e\u043c\u0435\u0440\u0430 \u043f\u0440\u0435\u0434\u043f\u0440\u0438\u044f\u0442\u0438\u044f","storedPaymentMethod.disable.button":"\u0423\u0434\u0430\u043b\u0438\u0442\u044c","storedPaymentMethod.disable.confirmation":"\u0423\u0434\u0430\u043b\u0438\u0442\u044c \u0441\u043e\u0445\u0440\u0430\u043d\u0435\u043d\u043d\u044b\u0439 \u0441\u043f\u043e\u0441\u043e\u0431 \u043e\u043f\u043b\u0430\u0442\u044b","storedPaymentMethod.disable.confirmButton":"\u0414\u0430, \u0443\u0434\u0430\u043b\u0438\u0442\u044c","storedPaymentMethod.disable.cancelButton":"\u041e\u0442\u043c\u0435\u043d\u0438\u0442\u044c","ach.bankAccount":"\u0411\u0430\u043d\u043a\u043e\u0432\u0441\u043a\u0438\u0439 \u0441\u0447\u0435\u0442","ach.accountHolderNameField.title":"\u0418\u043c\u044f \u0432\u043b\u0430\u0434\u0435\u043b\u044c\u0446\u0430 \u043a\u0430\u0440\u0442\u044b","ach.accountHolderNameField.placeholder":"\u0418. \u041f\u0435\u0442\u0440\u043e\u0432","ach.accountHolderNameField.invalid":"\u041d\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043b\u044c\u043d\u043e\u0435 \u0438\u043c\u044f \u0432\u043b\u0430\u0434\u0435\u043b\u044c\u0446\u0430 \u043a\u0430\u0440\u0442\u044b","ach.accountNumberField.title":"\u041d\u043e\u043c\u0435\u0440 \u0441\u0447\u0435\u0442\u0430","ach.accountNumberField.invalid":"\u041d\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043b\u044c\u043d\u044b\u0439 \u043d\u043e\u043c\u0435\u0440 \u0441\u0447\u0435\u0442\u0430","ach.accountLocationField.title":"\u041c\u0430\u0440\u0448\u0440\u0443\u0442\u043d\u044b\u0439 \u043d\u043e\u043c\u0435\u0440 ABA","ach.accountLocationField.invalid":"\u041d\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043b\u044c\u043d\u044b\u0439 \u043c\u0430\u0440\u0448\u0440\u0443\u0442\u043d\u044b\u0439 \u043d\u043e\u043c\u0435\u0440 ABA","select.state":"\u0412\u044b\u0431\u0435\u0440\u0438\u0442\u0435 \u0448\u0442\u0430\u0442","select.stateOrProvince":"\u0412\u044b\u0431\u0435\u0440\u0438\u0442\u0435 \u0448\u0442\u0430\u0442 \u0438\u043b\u0438 \u043e\u0431\u043b\u0430\u0441\u0442\u044c","select.provinceOrTerritory":"\u0412\u044b\u0431\u0435\u0440\u0438\u0442\u0435 \u043f\u0440\u043e\u0432\u0438\u043d\u0446\u0438\u044e \u0438\u043b\u0438 \u0442\u0435\u0440\u0440\u0438\u0442\u043e\u0440\u0438\u044e","select.country":"\u0412\u044b\u0431\u0435\u0440\u0438\u0442\u0435 \u0441\u0442\u0440\u0430\u043d\u0443","telephoneNumber.invalid":"\u041d\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043b\u044c\u043d\u044b\u0439 \u043d\u043e\u043c\u0435\u0440 \u0442\u0435\u043b\u0435\u0444\u043e\u043d\u0430","qrCodeOrApp":"\u0438\u043b\u0438","paypal.processingPayment":"\u041f\u043b\u0430\u0442\u0435\u0436 \u043e\u0431\u0440\u0430\u0431\u0430\u0442\u044b\u0432\u0430\u0435\u0442\u0441\u044f\u2026","generateQRCode":"\u0421\u043e\u0437\u0434\u0430\u0442\u044c QR-\u043a\u043e\u0434","await.waitForConfirmation":"\u041e\u0436\u0438\u0434\u0430\u043d\u0438\u0435 \u043f\u043e\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043d\u0438\u044f","mbway.confirmPayment":"\u041f\u043e\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435 \u043e\u043f\u043b\u0430\u0442\u0443 \u0432 \u043f\u0440\u0438\u043b\u043e\u0436\u0435\u043d\u0438\u0438 MB WAY","shopperEmail.invalid":"\u041d\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043b\u044c\u043d\u044b\u0439 \u0430\u0434\u0440\u0435\u0441 \u044d\u043b. \u043f\u043e\u0447\u0442\u044b","dateOfBirth.format":"\u0414\u0414/\u041c\u041c/\u0413\u0413\u0413\u0413","dateOfBirth.invalid":"\u0412\u0430\u043c \u0434\u043e\u043b\u0436\u043d\u043e \u0431\u044b\u0442\u044c 18 \u043b\u0435\u0442 \u0438\u043b\u0438 \u0431\u043e\u043b\u044c\u0448\u0435","blik.confirmPayment":"\u0414\u043b\u044f \u043f\u043e\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043d\u0438\u044f \u043e\u043f\u043b\u0430\u0442\u044b \u043e\u0442\u043a\u0440\u043e\u0439\u0442\u0435 \u043f\u0440\u0438\u043b\u043e\u0436\u0435\u043d\u0438\u0435 \u0431\u0430\u043d\u043a\u0430.","blik.invalid":"\u0412\u0432\u0435\u0434\u0438\u0442\u0435 6 \u0446\u0438\u0444\u0440","blik.code":"6-\u0437\u043d\u0430\u0447\u043d\u044b\u0439 \u043a\u043e\u0434","blik.help":"\u041f\u043e\u043b\u0443\u0447\u0438\u0442\u0435 \u043a\u043e\u0434 \u0438\u0437 \u0431\u0430\u043d\u043a\u043e\u0432\u0441\u043a\u043e\u0433\u043e \u043f\u0440\u0438\u043b\u043e\u0436\u0435\u043d\u0438\u044f.","swish.pendingMessage":"\u041e\u0431\u0440\u0430\u0431\u043e\u0442\u043a\u0430 \u043e\u043f\u043b\u0430\u0442\u044b \u043f\u043e\u0441\u043b\u0435 \u0441\u043a\u0430\u043d\u0438\u0440\u043e\u0432\u0430\u043d\u0438\u044f \u043c\u043e\u0436\u0435\u0442 \u0437\u0430\u043d\u044f\u0442\u044c 10 \u043c\u0438\u043d\u0443\u0442. \u041f\u043e\u043f\u044b\u0442\u043a\u0430 \u043f\u0440\u043e\u0432\u0435\u0441\u0442\u0438 \u043e\u043f\u043b\u0430\u0442\u0443 \u043f\u043e\u0432\u0442\u043e\u0440\u043d\u043e \u0432 \u0442\u0435\u0447\u0435\u043d\u0438\u0435 \u0443\u043a\u0430\u0437\u0430\u043d\u043d\u043e\u0433\u043e \u0432\u0440\u0435\u043c\u0435\u043d\u0438 \u043c\u043e\u0436\u0435\u0442 \u043f\u0440\u0438\u0432\u0435\u0441\u0442\u0438 \u043a \u043d\u0435\u0441\u043a\u043e\u043b\u044c\u043a\u0438\u043c \u0441\u043f\u0438\u0441\u0430\u043d\u0438\u044f\u043c \u0441\u043e \u0441\u0447\u0435\u0442\u0430.","error.va.gen.01":"\u041d\u0435\u0437\u0430\u043f\u043e\u043b\u043d\u0435\u043d\u043d\u043e\u0435 \u043f\u043e\u043b\u0435","error.va.gen.02":"\u041d\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043b\u044c\u043d\u043e\u0435 \u043f\u043e\u043b\u0435","error.va.sf-cc-num.01":"\u041d\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043b\u044c\u043d\u044b\u0439 \u043d\u043e\u043c\u0435\u0440 \u043a\u0430\u0440\u0442\u044b","error.va.sf-cc-num.03":"\u0412\u0432\u0435\u0434\u0435\u043d\u0430 \u043d\u0435\u043f\u043e\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u043c\u0430\u044f \u043a\u0430\u0440\u0442\u0430","error.va.sf-cc-dat.01":"\u0423\u0441\u0442\u0430\u0440\u0435\u0432\u0448\u0430\u044f \u043a\u0430\u0440\u0442\u0430","error.va.sf-cc-dat.02":"\u0414\u0430\u0442\u0430 \u0441\u043b\u0438\u0448\u043a\u043e\u043c \u0434\u0430\u043b\u0435\u043a\u043e \u0432 \u0431\u0443\u0434\u0443\u0449\u0435\u043c","error.giftcard.no-balance":"\u041d\u0430 \u044d\u0442\u043e\u0439 \u043f\u043e\u0434\u0430\u0440\u043e\u0447\u043d\u043e\u0439 \u043a\u0430\u0440\u0442\u0435 \u043d\u0435\u0442 \u0441\u0440\u0435\u0434\u0441\u0442\u0432","error.giftcard.card-error":"\u0423 \u043d\u0430\u0441 \u043d\u0435 \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043e\u0432\u0430\u043d\u0430 \u043a\u0430\u0440\u0442\u0430 \u0441 \u0442\u0430\u043a\u0438\u043c \u043d\u043e\u043c\u0435\u0440\u043e\u043c","error.giftcard.currency-error":"\u041f\u0440\u0438\u043d\u0438\u043c\u0430\u044e\u0442\u0441\u044f \u0442\u043e\u043b\u044c\u043a\u043e \u043f\u043e\u0434\u0430\u0440\u043e\u0447\u043d\u044b\u0435 \u043a\u0430\u0440\u0442\u044b \u0441\u043e\u043e\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044e\u0449\u0435\u0439 \u0432\u0430\u043b\u044e\u0442\u044b","amazonpay.signout":"\u0412\u044b\u0439\u0442\u0438 \u0438\u0437 Amazon","amazonpay.changePaymentDetails":"\u0418\u0437\u043c\u0435\u043d\u0438\u0442\u044c \u0438\u043d\u0444\u043e\u0440\u043c\u0430\u0446\u0438\u044e \u043e\u0431 \u043e\u043f\u043b\u0430\u0442\u0435","partialPayment.warning":"\u0412\u044b\u0431\u0440\u0430\u0442\u044c \u0434\u0440\u0443\u0433\u043e\u0439 \u0441\u043f\u043e\u0441\u043e\u0431 \u043e\u043f\u043b\u0430\u0442\u044b \u043e\u0441\u0442\u0430\u0442\u043a\u0430","partialPayment.remainingBalance":"\u041e\u0441\u0442\u0430\u0442\u043e\u043a \u043d\u0430 \u0431\u0430\u043b\u0430\u043d\u0441\u0435 \u0441\u043e\u0441\u0442\u0430\u0432\u0438\u0442 %{amount}","bankTransfer.beneficiary":"\u041f\u043e\u043b\u0443\u0447\u0430\u0442\u0435\u043b\u044c","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"\u0421\u0441\u044b\u043b\u043a\u0430","bankTransfer.introduction":"\u0414\u043b\u044f \u0441\u043e\u0437\u0434\u0430\u043d\u0438\u044f \u043d\u043e\u0432\u043e\u0433\u043e \u0431\u0430\u043d\u043a\u043e\u0432\u0441\u043a\u043e\u0433\u043e \u043f\u0435\u0440\u0435\u0447\u0438\u0441\u043b\u0435\u043d\u0438\u044f \u043f\u0435\u0440\u0435\u0439\u0434\u0438\u0442\u0435 \u0434\u0430\u043b\u0435\u0435. \u0414\u043b\u044f \u043e\u043a\u043e\u043d\u0447\u0430\u0442\u0435\u043b\u044c\u043d\u043e\u0433\u043e \u043e\u0444\u043e\u0440\u043c\u043b\u0435\u043d\u0438\u044f \u043f\u043b\u0430\u0442\u0435\u0436\u0430 \u0438\u0441\u043f\u043e\u043b\u044c\u0437\u0443\u0439\u0442\u0435 \u0441\u0432\u0435\u0434\u0435\u043d\u0438\u044f \u043d\u0430 \u0441\u043b\u0435\u0434\u0443\u044e\u0449\u0435\u043c \u044d\u043a\u0440\u0430\u043d\u0435.","bankTransfer.instructions":"\u0411\u043b\u0430\u0433\u043e\u0434\u0430\u0440\u0438\u043c \u0437\u0430 \u043f\u043e\u043a\u0443\u043f\u043a\u0443. \u0414\u043b\u044f \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043d\u0438\u044f \u043e\u043f\u043b\u0430\u0442\u044b \u0438\u0441\u043f\u043e\u043b\u044c\u0437\u0443\u0439\u0442\u0435 \u0441\u043b\u0435\u0434\u0443\u044e\u0449\u0438\u0435 \u0441\u0432\u0435\u0434\u0435\u043d\u0438\u044f.","bacs.accountHolderName":"\u0418\u043c\u044f \u0432\u043b\u0430\u0434\u0435\u043b\u044c\u0446\u0430 \u0431\u0430\u043d\u043a\u043e\u0432\u0441\u043a\u043e\u0433\u043e \u0441\u0447\u0435\u0442\u0430","bacs.accountHolderName.invalid":"\u041d\u0435\u0432\u0435\u0440\u043d\u043e\u0435 \u0438\u043c\u044f \u0432\u043b\u0430\u0434\u0435\u043b\u044c\u0446\u0430 \u0431\u0430\u043d\u043a\u043e\u0432\u0441\u043a\u043e\u0433\u043e \u0441\u0447\u0435\u0442\u0430","bacs.accountNumber":"\u041d\u043e\u043c\u0435\u0440 \u0431\u0430\u043d\u043a\u043e\u0432\u0441\u043a\u043e\u0433\u043e \u0441\u0447\u0435\u0442\u0430","bacs.accountNumber.invalid":"\u041d\u0435\u0432\u0435\u0440\u043d\u044b\u0439 \u043d\u043e\u043c\u0435\u0440 \u0431\u0430\u043d\u043a\u043e\u0432\u0441\u043a\u043e\u0433\u043e \u0441\u0447\u0435\u0442\u0430","bacs.bankLocationId":"\u041a\u043e\u0434 \u0431\u0430\u043d\u043a\u0430","bacs.bankLocationId.invalid":"\u041d\u0435\u0432\u0435\u0440\u043d\u044b\u0439 \u043a\u043e\u0434 \u0431\u0430\u043d\u043a\u0430","bacs.consent.amount":"\u0412\u044b\u0440\u0430\u0436\u0430\u044e \u0441\u043e\u0433\u043b\u0430\u0441\u0438\u0435 \u043d\u0430 \u0441\u043f\u0438\u0441\u0430\u043d\u0438\u0435 \u0432\u044b\u0448\u0435\u0443\u043a\u0430\u0437\u0430\u043d\u043d\u043e\u0439 \u0441\u0443\u043c\u043c\u044b \u0441 \u043c\u043e\u0435\u0433\u043e \u0431\u0430\u043d\u043a\u043e\u0432\u0441\u043a\u043e\u0433\u043e \u0441\u0447\u0435\u0442\u0430.","bacs.consent.account":"\u041f\u043e\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0430\u044e, \u0447\u0442\u043e \u0441\u0447\u0435\u0442 \u043e\u0444\u043e\u0440\u043c\u043b\u0435\u043d \u043d\u0430 \u043c\u043e\u0435 \u0438\u043c\u044f \u0438 \u0447\u0442\u043e \u044f \u2013 \u0435\u0434\u0438\u043d\u0441\u0442\u0432\u0435\u043d\u043d\u043e\u0435 \u043b\u0438\u0446\u043e, \u0438\u043c\u0435\u044e\u0449\u0435\u0435 \u043f\u0440\u0430\u0432\u043e \u043f\u043e\u0434\u043f\u0438\u0441\u0438, \u0440\u0430\u0437\u0440\u0435\u0448\u0430\u044e\u0449\u0435\u0439 \u043f\u0440\u044f\u043c\u043e\u0435 \u0434\u0435\u0431\u0435\u0442\u043e\u0432\u0430\u043d\u0438\u0435 \u0441\u0440\u0435\u0434\u0441\u0442\u0432 \u0441\u043e \u0441\u0447\u0435\u0442\u0430.","edit":"\u0418\u0437\u043c\u0435\u043d\u0438\u0442\u044c","bacs.confirm":"\u041f\u043e\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044c \u0438 \u043e\u043f\u043b\u0430\u0442\u0438\u0442\u044c","bacs.result.introduction":"\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044c \u0440\u0430\u0441\u043f\u043e\u0440\u044f\u0436\u0435\u043d\u0438\u0435 \u043f\u0440\u044f\u043c\u043e\u0433\u043e \u0434\u0435\u0431\u0435\u0442\u043e\u0432\u0430\u043d\u0438\u044f (DDI / \u043f\u043e\u0440\u0443\u0447\u0435\u043d\u0438\u0435)","download.pdf":"\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044c PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe \u0434\u043b\u044f \u0437\u0430\u0449\u0438\u0442\u044b \u043d\u043e\u043c\u0435\u0440\u0430 \u043a\u0430\u0440\u0442\u044b","creditCard.encryptedCardNumber.aria.label":"\u041f\u043e\u043b\u0435 \u043d\u043e\u043c\u0435\u0440\u0430 \u043a\u0430\u0440\u0442\u044b","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe \u0434\u043b\u044f \u0437\u0430\u0449\u0438\u0442\u044b \u0434\u0430\u0442\u044b \u0441\u0440\u043e\u043a\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044f \u043a\u0430\u0440\u0442\u044b","creditCard.encryptedExpiryDate.aria.label":"\u041f\u043e\u043b\u0435 \u0434\u0430\u0442\u044b \u0441\u0440\u043e\u043a\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044f","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe \u0434\u043b\u044f \u0437\u0430\u0449\u0438\u0442\u044b \u0434\u0430\u043d\u043d\u044b\u0445 \u043c\u0435\u0441\u044f\u0446\u0430 \u0441\u0440\u043e\u043a\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044f \u043a\u0430\u0440\u0442\u044b","creditCard.encryptedExpiryMonth.aria.label":"\u041f\u043e\u043b\u0435 \u043c\u0435\u0441\u044f\u0446\u0430 \u0441\u0440\u043e\u043a\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044f","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe \u0434\u043b\u044f \u0437\u0430\u0449\u0438\u0442\u044b \u0434\u0430\u043d\u043d\u044b\u0445 \u0433\u043e\u0434\u0430 \u0441\u0440\u043e\u043a\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044f \u043a\u0430\u0440\u0442\u044b","creditCard.encryptedExpiryYear.aria.label":"\u041f\u043e\u043b\u0435 \u0433\u043e\u0434\u0430 \u0441\u0440\u043e\u043a\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044f","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe \u0434\u043b\u044f \u0437\u0430\u0449\u0438\u0442\u044b \u0437\u0430\u0449\u0438\u0442\u043d\u043e\u0433\u043e \u043a\u043e\u0434\u0430","creditCard.encryptedSecurityCode.aria.label":"\u041f\u043e\u043b\u0435 \u0437\u0430\u0449\u0438\u0442\u043d\u043e\u0433\u043e \u043a\u043e\u0434\u0430","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe \u0434\u043b\u044f \u0437\u0430\u0449\u0438\u0442\u044b \u043d\u043e\u043c\u0435\u0440\u0430 \u043f\u043e\u0434\u0430\u0440\u043e\u0447\u043d\u043e\u0439 \u043a\u0430\u0440\u0442\u044b","giftcard.encryptedCardNumber.aria.label":"\u041f\u043e\u043b\u0435 \u043d\u043e\u043c\u0435\u0440\u0430 \u043f\u043e\u0434\u0430\u0440\u043e\u0447\u043d\u043e\u0439 \u043a\u0430\u0440\u0442\u044b","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe \u0434\u043b\u044f \u0437\u0430\u0449\u0438\u0442\u044b \u0437\u0430\u0449\u0438\u0442\u043d\u043e\u0433\u043e \u043a\u043e\u0434\u0430 \u043f\u043e\u0434\u0430\u0440\u043e\u0447\u043d\u043e\u0439 \u043a\u0430\u0440\u0442\u044b","giftcard.encryptedSecurityCode.aria.label":"\u041f\u043e\u043b\u0435 \u0437\u0430\u0449\u0438\u0442\u043d\u043e\u0433\u043e \u043a\u043e\u0434\u0430 \u043f\u043e\u0434\u0430\u0440\u043e\u0447\u043d\u043e\u0439 \u043a\u0430\u0440\u0442\u044b","giftcardTransactionLimit":"\u041c\u0430\u043a\u0441\u0438\u043c\u0430\u043b\u044c\u043d\u0430\u044f \u0441\u0443\u043c\u043c\u0430, \u043f\u0440\u0435\u0434\u0443\u0441\u043c\u043e\u0442\u0440\u0435\u043d\u043d\u0430\u044f \u0434\u043b\u044f \u043e\u0442\u0434\u0435\u043b\u044c\u043d\u043e\u0439 \u043e\u043f\u0435\u0440\u0430\u0446\u0438\u0438 \u043f\u043e \u044d\u0442\u043e\u0439 \u043f\u043e\u0434\u0430\u0440\u043e\u0447\u043d\u043e\u0439 \u043a\u0430\u0440\u0442\u0435: %{amount}","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe \u0434\u043b\u044f \u0437\u0430\u0449\u0438\u0442\u044b \u043d\u043e\u043c\u0435\u0440\u0430 \u0431\u0430\u043d\u043a\u043e\u0432\u0441\u043a\u043e\u0433\u043e \u0441\u0447\u0435\u0442\u0430","ach.encryptedBankAccountNumber.aria.label":"\u041f\u043e\u043b\u0435 \u0431\u0430\u043d\u043a\u043e\u0432\u0441\u043a\u043e\u0433\u043e \u0441\u0447\u0435\u0442\u0430","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe \u0434\u043b\u044f \u0437\u0430\u0449\u0438\u0442\u044b \u043a\u043e\u0434\u0430 \u0431\u0430\u043d\u043a\u0430","ach.encryptedBankLocationId.aria.label":"\u041f\u043e\u043b\u0435 \u043a\u043e\u0434\u0430 \u0431\u0430\u043d\u043a\u0430"}')},function(e){e.exports=JSON.parse('{"payButton":"Zaplati\u0165","payButton.redirecting":"Prebieha presmerovanie ...","storeDetails":"Ulo\u017ei\u0165 pre moju \u010fal\u0161iu platbu","creditCard.holderName":"Meno na karte","creditCard.holderName.placeholder":"J. Nov\xe1k","creditCard.holderName.invalid":"Neplatn\xe9 meno dr\u017eite\u013ea karty","creditCard.numberField.title":"\u010c\xedslo karty","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Koniec platnosti","creditCard.expiryDateField.placeholder":"MM/RR","creditCard.expiryDateField.month":"Mesiac","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"RR","creditCard.expiryDateField.year":"Rok","creditCard.cvcField.title":"CVC/CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"Zapam\xe4ta\u0165 na bud\xface pou\u017eitie","creditCard.cvcField.placeholder.4digits":"4 \u010d\xedslice","creditCard.cvcField.placeholder.3digits":"3 \u010d\xedslice","creditCard.taxNumber.placeholder":"RRMMDD/0123456789","installments":"Po\u010det spl\xe1tok","installmentOption":"% {times} x % {partialValue}","installmentOptionMonths":"%{times} mesiace/-ov","installments.oneTime":"Jednorazov\xe1 platba","installments.installments":"Platba po spl\xe1tkach","installments.revolving":"Revolvingov\xe1 platba","sepaDirectDebit.ibanField.invalid":"Neplatn\xe9 \u010d\xedslo \xfa\u010dtu","sepaDirectDebit.nameField.placeholder":"J. Nov\xe1k","sepa.ownerName":"Meno dr\u017eite\u013ea","sepa.ibanNumber":"\u010c\xedslo \xfa\u010dtu (IBAN)","error.title":"Chyba","error.subtitle.redirect":"Nepodarilo sa presmerova\u0165","error.subtitle.payment":"Platba zlyhala","error.subtitle.refused":"Platba bola zamietnut\xe1","error.message.unknown":"Vyskytla sa nezn\xe1ma chyba","idealIssuer.selectField.title":"Banka","idealIssuer.selectField.placeholder":"Vyberte svoju banku","creditCard.success":"Platba bola \xfaspe\u0161n\xe1","loading":"Na\u010d\xedtava sa\u2026","continue":"Pokra\u010dova\u0165","continueTo":"Pokra\u010dova\u0165 do","wechatpay.timetopay":"Na zaplatenie m\xe1te %@","wechatpay.scanqrcode":"Naskenujte QR k\xf3d","personalDetails":"Osobn\xe9 \xfadaje","companyDetails":"\xdadaje o spolo\u010dnosti","companyDetails.name":"N\xe1zov spolo\u010dnosti","companyDetails.registrationNumber":"Identifika\u010dn\xe9 \u010d\xedslo","socialSecurityNumber":"Rodn\xe9 \u010d\xedslo","firstName":"Krstn\xe9 meno","infix":"Predpona k priezvisku (ak existuje)","lastName":"Priezvisko","mobileNumber":"Mobiln\xe9 telef\xf3nne \u010d\xedslo","mobileNumber.invalid":"Neplatn\xe9 \u010d\xedslo na mobil","city":"Mesto","postalCode":"PS\u010c","countryCode":"K\xf3d krajiny","telephoneNumber":"Telef\xf3nne \u010d\xedslo","dateOfBirth":"D\xe1tum narodenia","shopperEmail":"E-mailov\xe1 adresa","gender":"Pohlavie","male":"Mu\u017e","female":"\u017dena","billingAddress":"Faktura\u010dn\xe1 adresa","street":"Ulica","stateOrProvince":"Kraj","country":"Krajina","houseNumberOrName":"\u010c\xedslo domu","separateDeliveryAddress":"Zadajte samostatn\xfa dodaciu adresu","deliveryAddress":"Dodacia adresa","zipCode":"PS\u010c","apartmentSuite":"Byt/apartm\xe1n","provinceOrTerritory":"Okres alebo \xfazemie","cityTown":"Mesto/obec","address":"Adresa","state":"\u0160t\xe1t","creditCard.cvcField.title.optional":"CVC/CVV (volite\u013en\xe9)","issuerList.wallet.placeholder":"Vyberte si pe\u0148a\u017eenku","privacyPolicy":"Z\xe1sady ochrany osobn\xfdch \xfadajov","afterPay.agreement":"S\xfahlas\xedm s %@ AfterPay","paymentConditions":"podmienkami platby","openApp":"Otvorte aplik\xe1ciu","voucher.readInstructions":"Pre\u010d\xedtajte si pokyny","voucher.introduction":"\u010eakujeme v\xe1m za n\xe1kup; na dokon\u010denie platby pou\u017eite nasleduj\xfaci kup\xf3n.","voucher.expirationDate":"D\xe1tum vypr\u0161ania platnosti","voucher.alternativeReference":"Alternat\xedvny odkaz","dragonpay.voucher.non.bank.selectField.placeholder":"Vyberte si poskytovate\u013ea","dragonpay.voucher.bank.selectField.placeholder":"Vyberte svoju banku","voucher.paymentReferenceLabel":"Platobn\xe1 referencia","voucher.surcharge":"Vr\xe1tane poplatku vo v\xfd\u0161ke %@","voucher.introduction.doku":"\u010eakujeme v\xe1m za n\xe1kup. Na dokon\u010denie platby pou\u017eite nasleduj\xface inform\xe1cie.","voucher.shopperName":"Meno kupuj\xfaceho","voucher.merchantName":"Predajca","voucher.introduction.econtext":"\u010eakujeme v\xe1m za n\xe1kup. Na dokon\u010denie platby pou\u017eite nasleduj\xface inform\xe1cie.","voucher.telephoneNumber":"Telef\xf3nne \u010d\xedslo","voucher.shopperReference":"Referencia kupuj\xfaceho","voucher.collectionInstitutionNumber":"\u010c\xedslo inkasnej in\u0161tit\xfacie","voucher.econtext.telephoneNumber.invalid":"Telef\xf3nne \u010d\xedslo mus\xed ma\u0165 10 alebo 11 \u010d\xedslic","boletobancario.btnLabel":"Generova\u0165 Boleto","boleto.sendCopyToEmail":"Zasla\u0165 k\xf3piu na m\xf4j e-mail","button.copy":"Kop\xedrova\u0165","button.download":"Stiahnu\u0165","creditCard.storedCard.description.ariaLabel":"Platnos\u0165 ulo\u017eenej karty kon\u010d\xed o %@","voucher.entity":"Subjekt","donateButton":"Prispie\u0165","notNowButton":"Teraz nie","thanksForYourSupport":"\u010eakujeme za podporu!","preauthorizeWith":"Predbe\u017ene autorizova\u0165 pomocou","confirmPreauthorization":"Potvr\u010fte predbe\u017en\xfa autoriz\xe1ciu","confirmPurchase":"Potvr\u010fte n\xe1kup","applyGiftcard":"Uplatni\u0165","giftcardBalance":"Zostatok na dar\u010dekovej karte","deductedBalance":"Zn\xed\u017een\xfd zostatok","creditCard.pin.title":"K\xf3d PIN","creditCard.encryptedPassword.label":"Prv\xe9 2 \u010d\xedslice hesla karty","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Neplan\xe9 heslo","creditCard.taxNumber.label":"D\xe1tum narodenia dr\u017eite\u013ea karty (RRRMMDD) alebo identifika\u010dn\xe9 \u010d\xedslo organiz\xe1cie (10 \u010d\xedslic)","creditCard.taxNumber.labelAlt":"Identifika\u010dn\xe9 \u010d\xedslo organiz\xe1cie (10 \u010d\xedslic)","creditCard.taxNumber.invalid":"Neplatn\xfd d\xe1tum narodenia dr\u017eite\u013ea karty alebo identifika\u010dn\xe9 \u010d\xedslo organiz\xe1cie","storedPaymentMethod.disable.button":"Odstr\xe1ni\u0165","storedPaymentMethod.disable.confirmation":"Odstr\xe1ni\u0165 ulo\u017een\xfd sp\xf4sob platby","storedPaymentMethod.disable.confirmButton":"\xc1no, odstr\xe1ni\u0165","storedPaymentMethod.disable.cancelButton":"Zru\u0161i\u0165","ach.bankAccount":"Bankov\xfd \xfa\u010det","ach.accountHolderNameField.title":"Meno majite\u013ea \xfa\u010dtu","ach.accountHolderNameField.placeholder":"J. Nov\xe1k","ach.accountHolderNameField.invalid":"Neplatn\xe9 meno majite\u013ea \xfa\u010dtu","ach.accountNumberField.title":"\u010c\xedslo \xfa\u010dtu","ach.accountNumberField.invalid":"Neplatn\xe9 \u010d\xedslo \xfa\u010dtu","ach.accountLocationField.title":"Smerovacie \u010d\xedslo ABA","ach.accountLocationField.invalid":"Neplatn\xe9 smerovacie \u010d\xedslo ABA","select.state":"Vyberte kraj","select.stateOrProvince":"Vyberte kraj alebo okres","select.provinceOrTerritory":"Vyberte okres alebo \xfazemie","select.country":"Vyberte krajinu","telephoneNumber.invalid":"Neplatn\xe9 telef\xf3nne \u010d\xedslo","qrCodeOrApp":"alebo","paypal.processingPayment":"Platba sa sprac\xfava.","generateQRCode":"Generova\u0165 QR k\xf3d","await.waitForConfirmation":"\u010cak\xe1 sa na potvrdenie","mbway.confirmPayment":"Potvr\u010fte svoju platbu v aplik\xe1cii MB WAY","shopperEmail.invalid":"Neplatn\xe1 emailov\xe1 adresa","dateOfBirth.format":"DD/MM/RRRR","dateOfBirth.invalid":"Mus\xedte ma\u0165 aspo\u0148 18 rokov","blik.confirmPayment":"Otvorte svoju bankov\xfa aplik\xe1ciu a potvr\u010fte platbu.","blik.invalid":"Zadajte 6 \u010d\xedslic","blik.code":"6-cifern\xfd k\xf3d","blik.help":"Z\xedskajte k\xf3d zo svojej bankovej aplik\xe1cie.","swish.pendingMessage":"Po nasn\xedman\xed m\xf4\u017ee spracovanie trva\u0165 a\u017e 10 min\xfat. Pokus o op\xe4tovn\xe9 zaplatenie v tejto lehote m\xf4\u017ee vies\u0165 k nieko\u013ek\xfdm poplatkom.","error.va.gen.01":"Ne\xfapln\xe9 pole","error.va.gen.02":"Pole je neplatn\xe9","error.va.sf-cc-num.01":"Neplatn\xe9 \u010d\xedslo karty","error.va.sf-cc-num.03":"Zadali ste nepodporovan\xfa kartu","error.va.sf-cc-dat.01":"Karta je pr\xedli\u0161 star\xe1","error.va.sf-cc-dat.02":"D\xe1tum je pr\xedli\u0161 \u010faleko v bud\xfacnosti","error.giftcard.no-balance":"T\xe1to dar\u010dekov\xe1 karta m\xe1 nulov\xfd zostatok","error.giftcard.card-error":"V na\u0161ich z\xe1znamoch nem\xe1me \u017eiadnu dar\u010dekov\xfa kartu s t\xfdmto \u010d\xedslom","error.giftcard.currency-error":"Dar\u010dekov\xe9 karty s\xfa platn\xe9 iba v mene, v ktorej boli vydan\xe9","amazonpay.signout":"Odhl\xe1si\u0165 sa z Amazonu","amazonpay.changePaymentDetails":"Zmeni\u0165 podrobnosti o platbe","partialPayment.warning":"Ak chcete zaplati\u0165 zostatok, vyberte in\xfd sp\xf4sob platby","partialPayment.remainingBalance":"Zvy\u0161n\xfd zostatok bude %{amount}","bankTransfer.beneficiary":"Pr\xedjemca","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"Referencie","bankTransfer.introduction":"Pokra\u010dujte vo vytv\xe1ran\xed novej platby bankov\xfdm prevodom. T\xfato platbu m\xf4\u017eete dokon\u010di\u0165 pomocou inform\xe1ci\xed na nasleduj\xfacej obrazovke.","bankTransfer.instructions":"\u010eakujeme v\xe1m za n\xe1kup. Na dokon\u010denie platby pou\u017eite nasleduj\xface inform\xe1cie.","bacs.accountHolderName":"Meno majite\u013ea bankov\xe9ho \xfa\u010dtu","bacs.accountHolderName.invalid":"Neplatn\xe9 meno majite\u013ea bankov\xe9ho \xfa\u010dtu","bacs.accountNumber":"\u010c\xedslo bankov\xe9ho \xfa\u010dtu","bacs.accountNumber.invalid":"Neplatn\xe9 \u010d\xedslo bankov\xe9ho \xfa\u010dtu","bacs.bankLocationId":"Variabiln\xfd symbol","bacs.bankLocationId.invalid":"Neplatn\xfd variabiln\xfd symbol","bacs.consent.amount":"S\xfahlas\xedm s t\xfdm, \u017ee ni\u017e\u0161ie uveden\xe1 \u010diastka bude odp\xedsan\xe1 z m\xf4jho bankov\xe9ho \xfa\u010dtu.","bacs.consent.account":"Potvrdzujem, \u017ee \xfa\u010det je na moje meno a som jedin\xfd podpisovate\u013e, ktor\xfd je povinn\xfd autorizova\u0165 inkaso v tomto \xfa\u010dte.","edit":"Upravi\u0165","bacs.confirm":"Potvrdi\u0165 a zaplati\u0165","bacs.result.introduction":"Stiahnite si pokyny k inkasu (DDI/Mand\xe1t)","download.pdf":"Stiahnu\u0165 vo form\xe1te PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe pre zabezpe\u010den\xe9 \u010d\xedslo karty","creditCard.encryptedCardNumber.aria.label":"Pole pre \u010d\xedslo karty","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe pre de\u0148 konca platnosti zabezpe\u010denej karty","creditCard.encryptedExpiryDate.aria.label":"Pole d\u0148a konca platnosti","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe pre mesiac konca platnosti zabezpe\u010denej karty","creditCard.encryptedExpiryMonth.aria.label":"Pole mesiaca konca platnosti","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe pre rok konca platnosti zabezpe\u010denej karty","creditCard.encryptedExpiryYear.aria.label":"Pole roka konca platnosti","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe pre bezpe\u010dnostn\xfd k\xf3d zabezpe\u010denej karty","creditCard.encryptedSecurityCode.aria.label":"Pole bezpe\u010dnostn\xe9ho k\xf3du","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe pre \u010d\xedslo zabezpe\u010denej dar\u010dekovej karty","giftcard.encryptedCardNumber.aria.label":"Pole pre \u010d\xedslo dar\u010dekovej karty","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe pre bezpe\u010dnostn\xfd k\xf3d zabezpe\u010denej dar\u010dekovej karty","giftcard.encryptedSecurityCode.aria.label":"Pole bezpe\u010dnostn\xe9ho k\xf3du dar\u010dekovej karty","giftcardTransactionLimit":"Pre transakciu s touto dar\u010dekovou kartou je povolen\xe9 maximum %{amount}","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe pre \u010d\xedslo zabezpe\u010den\xe9ho bankov\xe9ho \xfa\u010dtu","ach.encryptedBankAccountNumber.aria.label":"Pole bankov\xe9ho \xfa\u010dtu","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe pre zabezpe\u010den\xe9 smerovacie \u010d\xedslo banky","ach.encryptedBankLocationId.aria.label":"Pole smerovacieho \u010d\xedsla banky"}')},function(e){e.exports=JSON.parse('{"payButton":"Pla\u010dilo","payButton.redirecting":"Preusmerjanje ...","storeDetails":"Shrani za moje naslednje pla\u010dilo","creditCard.holderName":"Ime na kartici","creditCard.holderName.placeholder":"J. Novak","creditCard.holderName.invalid":"Neveljavno ime imetnika kartice","creditCard.numberField.title":"\u0160tevilka kartice","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Datum veljavnosti","creditCard.expiryDateField.placeholder":"MM/LL","creditCard.expiryDateField.month":"Mesec","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"LL","creditCard.expiryDateField.year":"Leto","creditCard.cvcField.title":"CVC/CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"Zapomni si za prihodnji\u010d","creditCard.cvcField.placeholder.4digits":"4 \u0161tevke","creditCard.cvcField.placeholder.3digits":"3 \u0161tevke","creditCard.taxNumber.placeholder":"LLMMDD / 0123456789","installments":"\u0160tevilo obrokov","installmentOption":"%{times} \xd7 %{partialValue}","installmentOptionMonths":"\u0160t. mesecev: %{times}","installments.oneTime":"Enkratno pla\u010dilo","installments.installments":"Obro\u010dno pla\u010dilo","installments.revolving":"Revolving pla\u010dilo","sepaDirectDebit.ibanField.invalid":"Neveljavna \u0161tevilka ra\u010duna","sepaDirectDebit.nameField.placeholder":"J. Novak","sepa.ownerName":"Ime imetnika","sepa.ibanNumber":"\u0160tevilka ra\u010duna (IBAN)","error.title":"Napaka","error.subtitle.redirect":"Preusmeritev ni uspela","error.subtitle.payment":"Pla\u010dilo ni uspelo","error.subtitle.refused":"Pla\u010dilo je bilo zavrnjeno","error.message.unknown":"Pri\u0161lo je do neznane napake","idealIssuer.selectField.title":"Banka","idealIssuer.selectField.placeholder":"Izberite svojo banko","creditCard.success":"Pla\u010dilo je bilo uspe\u0161no","loading":"Nalaganje \u2026","continue":"Nadaljuj","continueTo":"Nadaljujte na","wechatpay.timetopay":"Pla\u010dati morate %@","wechatpay.scanqrcode":"Opti\u010dno preberite kodo QR","personalDetails":"Osebni podatki","companyDetails":"Podrobnosti o podjetju","companyDetails.name":"Ime podjetja","companyDetails.registrationNumber":"Mati\u010dna \u0161tevilka podjetja","socialSecurityNumber":"\u0160tevilka socialnega zavarovanja","firstName":"Ime","infix":"Naziv","lastName":"Priimek","mobileNumber":"\u0160tevilka mobilnega telefona","mobileNumber.invalid":"Neveljavna \u0161tevilka mobilnega telefona","city":"Mesto","postalCode":"Po\u0161tna \u0161tevilka","countryCode":"Koda dr\u017eave","telephoneNumber":"Telefonska \u0161tevilka","dateOfBirth":"Datum rojstva","shopperEmail":"Elektronski naslov","gender":"Spol","male":"Mo\u0161ki","female":"\u017denski","billingAddress":"Naslov za ra\u010dun","street":"Ulica","stateOrProvince":"Dr\u017eava ali provinca","country":"Dr\u017eava","houseNumberOrName":"Hi\u0161na \u0161tevilka","separateDeliveryAddress":"Navedite lo\u010den naslov za dostavo","deliveryAddress":"Naslov za dostavo","zipCode":"Po\u0161tna \u0161tevilka","apartmentSuite":"\u0160t. apartmaja/stanovanja","provinceOrTerritory":"Obmo\u010dje ali ozemlje","cityTown":"Mesto","address":"Naslov","state":"Dr\u017eava","creditCard.cvcField.title.optional":"CVC/CVV (neobvezno)","issuerList.wallet.placeholder":"Izberite svojo denarnico","privacyPolicy":"Pravilnik o zasebnosti","afterPay.agreement":"Strinjam se s %@ ponudnika AfterPay","paymentConditions":"pla\u010dilnimi pogoji","openApp":"Odprite aplikacijo","voucher.readInstructions":"Preberite navodila","voucher.introduction":"Zahvaljujemo se vam za nakup. Za dokon\u010danje pla\u010dila uporabite naslednji kupon.","voucher.expirationDate":"Datum poteka veljavnosti","voucher.alternativeReference":"Druga referen\u010dna \u0161tevilka","dragonpay.voucher.non.bank.selectField.placeholder":"Izberite svojega ponudnika","dragonpay.voucher.bank.selectField.placeholder":"Izberite svojo banko","voucher.paymentReferenceLabel":"Referen\u010dna \u0161tevilka pla\u010dila","voucher.surcharge":"Vklj. %@ dopla\u010dila","voucher.introduction.doku":"Zahvaljujemo se vam za nakup. Za dokon\u010danje pla\u010dila uporabite naslednji kupon.","voucher.shopperName":"Ime kupca","voucher.merchantName":"Trgovec","voucher.introduction.econtext":"Zahvaljujemo se vam za nakup. Za dokon\u010danje pla\u010dila uporabite naslednji kupon.","voucher.telephoneNumber":"Telefonska \u0161tevilka","voucher.shopperReference":"Referen\u010dna \u0161tevilka kupca","voucher.collectionInstitutionNumber":"\u0160tevilka ustanove za zbiranje","voucher.econtext.telephoneNumber.invalid":"Telefonska \u0161tevilka mora vsebovati 10 ali 11 \u0161tevk","boletobancario.btnLabel":"Ustvari Boleto","boleto.sendCopyToEmail":"Po\u0161lji kopijo na moj elektronski naslov","button.copy":"Kopiraj","button.download":"Prenesi","creditCard.storedCard.description.ariaLabel":"Shranjena kartica se kon\u010da na %@","voucher.entity":"Entiteta","donateButton":"Donirajte","notNowButton":"Ne zdaj","thanksForYourSupport":"Zahvaljujemo se vam za podporo!","preauthorizeWith":"Predhodna odobritev s/z:","confirmPreauthorization":"Potrdi predhodno odobritev","confirmPurchase":"Potrditev nakupa","applyGiftcard":"Unov\u010di","giftcardBalance":"Stanje na darilni kartici","deductedBalance":"Odbiti znesek","creditCard.pin.title":"PIN","creditCard.encryptedPassword.label":"Prvi dve \u0161tevki gesla za kartico","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Neveljavno geslo","creditCard.taxNumber.label":"Datum rojstva imetnika kartice (LLMMDD) ali registracijska \u0161tevilka podjetja (10 \u0161tevk)","creditCard.taxNumber.labelAlt":"Mati\u010dna \u0161tevilka podjetja (10 \u0161tevk)","creditCard.taxNumber.invalid":"Neveljaven datum rojstva imetnika kartice ali mati\u010dna \u0161tevilka podjetja","storedPaymentMethod.disable.button":"Odstrani","storedPaymentMethod.disable.confirmation":"Odstrani shranjen na\u010din pla\u010dila","storedPaymentMethod.disable.confirmButton":"Da, odstrani","storedPaymentMethod.disable.cancelButton":"Prekli\u010di","ach.bankAccount":"Ban\u010dni ra\u010dun","ach.accountHolderNameField.title":"Ime imetnika ra\u010duna","ach.accountHolderNameField.placeholder":"J. Novak","ach.accountHolderNameField.invalid":"Neveljavno ime imetnika ra\u010duna","ach.accountNumberField.title":"\u0160tevilka ra\u010duna","ach.accountNumberField.invalid":"Neveljavna \u0161tevilka ra\u010duna","ach.accountLocationField.title":"Koda banke ABA","ach.accountLocationField.invalid":"Neveljavna koda banke ABA","select.state":"Izberite dr\u017eavo","select.stateOrProvince":"Izberite dr\u017eavo ali provinco","select.provinceOrTerritory":"Izberite obmo\u010dje ali ozemlje","select.country":"Izberite dr\u017eavo","telephoneNumber.invalid":"Neveljavna telefonska \u0161tevilka","qrCodeOrApp":"ali","paypal.processingPayment":"Obdelava pla\u010dila ...","generateQRCode":"Ustvari kodo QR","await.waitForConfirmation":"\u010cakanje na potrditev","mbway.confirmPayment":"Potrdite svoje pla\u010dilo v aplikaciji MB WAY","shopperEmail.invalid":"Neveljaven elektronski naslov","dateOfBirth.format":"DD/MM/LLLL","dateOfBirth.invalid":"Imeti morate najmanj 18 let","blik.confirmPayment":"Za potrditev pla\u010dila odprite svojo ban\u010dno aplikacijo.","blik.invalid":"Vnesite 6 \u0161tevilk","blik.code":"6-mestna koda","blik.help":"Pridobite kodo iz ban\u010dne aplikacije.","swish.pendingMessage":"Ko opti\u010dno preberete, lahko \u010dakanje traja do 10 minut. Poskus ponovnega pla\u010dila v tem \u010dasu lahko povzro\u010di ve\u010d odtegljajev.","error.va.gen.01":"Nepopolno polje","error.va.gen.02":"Polje ni veljavno","error.va.sf-cc-num.01":"Neveljavna \u0161tevilka kartice","error.va.sf-cc-num.03":"Vnesena je nepodprta kartica","error.va.sf-cc-dat.01":"Kartica je prestara","error.va.sf-cc-dat.02":"Datum je predale\u010d v prihodnosti","error.giftcard.no-balance":"Na tej darilni kartici ni sredstev","error.giftcard.card-error":"V na\u0161i evidenci nimamo darilne kartice s to \u0161tevilko","error.giftcard.currency-error":"Darilne kartice so veljavne samo za valuto, za katero so bile izdane","amazonpay.signout":"Odjava iz Amazona","amazonpay.changePaymentDetails":"Sprememba podrobnosti pla\u010dila","partialPayment.warning":"Izberite drugo vrsto pla\u010dila za pla\u010dilo ostanka","partialPayment.remainingBalance":"Preostalo stanje bo %{amount}","bankTransfer.beneficiary":"Upravi\u010denec","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"Referenca","bankTransfer.introduction":"Nadaljujte ustvarjanje novega pla\u010dila z ban\u010dnim nakazilom. Za dokon\u010danje tega pla\u010dila lahko uporabite podatke na naslednjem zaslonu.","bankTransfer.instructions":"Zahvaljujemo se vam za nakup. Za dokon\u010danje pla\u010dila uporabite naslednji kupon.","bacs.accountHolderName":"Ime imetnika ban\u010dnega ra\u010duna","bacs.accountHolderName.invalid":"Neveljavno ime imetnika ra\u010duna","bacs.accountNumber":"\u0160tevilka ban\u010dnega ra\u010duna","bacs.accountNumber.invalid":"Neveljavna \u0161tevilka ban\u010dnega ra\u010duna","bacs.bankLocationId":"\u0160tevilka banke","bacs.bankLocationId.invalid":"Neveljavna \u0161tevilka banke","bacs.consent.amount":"Sogla\u0161am s tem, da bo zgornji znesek odtegnjen z mojega ban\u010dnega ra\u010duna.","bacs.consent.account":"Potrjujem, da je ra\u010dun ustvarjen v mojem imenu in sem edini podpisnik za odobritev neposredne bremenitve za ta ra\u010dun.","edit":"Uredi","bacs.confirm":"Potrdi in pla\u010daj","bacs.result.introduction":"Prenesite navodila za neposredno bremenitev (DDI/mandat)","download.pdf":"Prenos datoteke PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe za zavarovano \u0161tevilko kartice","creditCard.encryptedCardNumber.aria.label":"Polje s \u0161tevilko kartice","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe za zavarovan potek veljavnosti kartice","creditCard.encryptedExpiryDate.aria.label":"Polje z datumom poteka veljavnosti","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe za zavarovan mesec poteka veljavnosti kartice","creditCard.encryptedExpiryMonth.aria.label":"Polje z mesecem poteka veljavnosti","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe za zavarovano leto poteka veljavnosti kartice","creditCard.encryptedExpiryYear.aria.label":"Polje z letom poteka veljavnosti","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe za zavarovano varnostno kodo kartice","creditCard.encryptedSecurityCode.aria.label":"Polje z varnostno kodo","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe za zavarovano \u0161tevilko darilne kartice","giftcard.encryptedCardNumber.aria.label":"Polje s \u0161tevilko darilne kartice","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe za zavarovano varnostno kodo darilne kartice","giftcard.encryptedSecurityCode.aria.label":"Polje z varnostno kodo darilne kartice","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe za zavarovano \u0161tevilko ban\u010dnega ra\u010duna","ach.encryptedBankAccountNumber.aria.label":"Polje z ban\u010dnim ra\u010dunom","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe za zavarovano kodo banke","ach.encryptedBankLocationId.aria.label":"Polje s kodo banke"}')},function(e){e.exports=JSON.parse('{"payButton":"Betala","payButton.redirecting":"Omdirigerar\u2026","storeDetails":"Spara till min n\xe4sta betalning","creditCard.holderName":"Namn p\xe5 kort","creditCard.holderName.placeholder":"J. Smith","creditCard.holderName.invalid":"Kortinnehavarens namn \xe4r ogiltigt","creditCard.numberField.title":"Kortnummer","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Utg\xe5ngsdatum","creditCard.expiryDateField.placeholder":"MM/AA","creditCard.expiryDateField.month":"M\xe5nad","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"\xc5\xc5","creditCard.expiryDateField.year":"\xc5r","creditCard.cvcField.title":"CVC / CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"Kom ih\xe5g till n\xe4sta g\xe5ng","creditCard.cvcField.placeholder.4digits":"4 siffror","creditCard.cvcField.placeholder.3digits":"3 siffror","creditCard.taxNumber.placeholder":"\xc5\xc5MMDD / 0123456789","installments":"Number of installments","installmentOption":"%{times} x %{partialValue}","installmentOptionMonths":"%{times} m\xe5nader","installments.oneTime":"Eng\xe5ngsbetalning","installments.installments":"Delbetalningar","installments.revolving":"Uppdelad betalning","sepaDirectDebit.ibanField.invalid":"Ogiltigt kontonummer","sepaDirectDebit.nameField.placeholder":"J. Johansson","sepa.ownerName":"K\xe4nt av kontoinnehavaren","sepa.ibanNumber":"Kontonummer (IBAN)","error.title":"Fel","error.subtitle.redirect":"Omdirigering misslyckades","error.subtitle.payment":"Betalning misslyckades","error.subtitle.refused":"Betalning avvisad","error.message.unknown":"Ett ok\xe4nt fel uppstod","idealIssuer.selectField.title":"Bank","idealIssuer.selectField.placeholder":"V\xe4lj din bank","creditCard.success":"Betalning lyckades","loading":"Laddar\u2026","continue":"Forts\xe4tt","continueTo":"Forts\xe4tt till","wechatpay.timetopay":"Du har %@ att betala","wechatpay.scanqrcode":"Skanna QR-kod","personalDetails":"Personuppgifter","companyDetails":"F\xf6retagsinformation","companyDetails.name":"F\xf6retagsnamn","companyDetails.registrationNumber":"Registreringsnummer","socialSecurityNumber":"Personnummer","firstName":"F\xf6rnamn","infix":"Prefix","lastName":"Efternamn","mobileNumber":"Mobilnummer","mobileNumber.invalid":"Ogiltigt mobilnummer","city":"Stad","postalCode":"Postnummer","countryCode":"Landskod","telephoneNumber":"Telefonnummer","dateOfBirth":"F\xf6delsedatum","shopperEmail":"E-postadress","gender":"K\xf6n","male":"Man","female":"Kvinna","billingAddress":"Faktureringsadress","street":"Gatuadress","stateOrProvince":"Delstat eller region","country":"Land","houseNumberOrName":"Husnummer","separateDeliveryAddress":"Ange en separat leveransadress","deliveryAddress":"Leveransadress","zipCode":"Postnummer","apartmentSuite":"L\xe4genhetsnummer","provinceOrTerritory":"Provins eller territorium","cityTown":"Ort","address":"Adress","state":"Delstat","creditCard.cvcField.title.optional":"CVC/CVV (tillval)","issuerList.wallet.placeholder":"V\xe4j din pl\xe5nbok","privacyPolicy":"Sekretesspolicy","afterPay.agreement":"Jag godk\xe4nner AfterPays %@","paymentConditions":"betalvillkor","openApp":"\xd6ppna appen","voucher.readInstructions":"L\xe4s instruktionerna","voucher.introduction":"Tack f\xf6r ditt k\xf6p, v\xe4nligen anv\xe4nd f\xf6ljande kupong f\xf6r att slutf\xf6ra din betalning.","voucher.expirationDate":"Utg\xe5ngsdatum","voucher.alternativeReference":"Alternativ referens","dragonpay.voucher.non.bank.selectField.placeholder":"V\xe4lj din leverant\xf6r","dragonpay.voucher.bank.selectField.placeholder":"V\xe4lj din bank","voucher.paymentReferenceLabel":"Betalreferens","voucher.surcharge":"Inklusive %@ i avgift","voucher.introduction.doku":"Tack f\xf6r ditt k\xf6p, v\xe4nligen anv\xe4nd f\xf6ljande information f\xf6r att slutf\xf6ra din betalning.","voucher.shopperName":"Konsumentens namn","voucher.merchantName":"Handlare","voucher.introduction.econtext":"Tack f\xf6r ditt k\xf6p, v\xe4nligen anv\xe4nd f\xf6ljande information f\xf6r att slutf\xf6ra din betalning.","voucher.telephoneNumber":"Telefonnummer","voucher.shopperReference":"K\xf6parreferens","voucher.collectionInstitutionNumber":"Nummer p\xe5 upph\xe4mtningsplats","voucher.econtext.telephoneNumber.invalid":"Telefonnumret m\xe5ste inneh\xe5lla 10 eller 11 siffror","boletobancario.btnLabel":"Generera Boleto","boleto.sendCopyToEmail":"Skicka en kopia till min e-post","button.copy":"Kopiera","button.download":"Ladda ner","creditCard.storedCard.description.ariaLabel":"Sparat kort slutar p\xe5 %@","voucher.entity":"Enhet","donateButton":"Donera","notNowButton":"Inte nu","thanksForYourSupport":"Tack f\xf6r ditt st\xf6d!","preauthorizeWith":"F\xf6rauktorisera med","confirmPreauthorization":"Bekr\xe4fta f\xf6rauktorisering","confirmPurchase":"Bekr\xe4fta k\xf6p","applyGiftcard":"L\xf6s in","giftcardBalance":"Presentkortssaldo","deductedBalance":"Avdraget saldo","creditCard.pin.title":"PIN-kod","creditCard.encryptedPassword.label":"De tv\xe5 f\xf6rsta siffrorna i kortets l\xf6senord","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Ogiltigt l\xf6senord","creditCard.taxNumber.label":"Kortinnehavarens f\xf6delsedatum (\xc5\xc5MMDD) eller f\xf6retagets organisationsnummer (10 siffror)","creditCard.taxNumber.labelAlt":"F\xf6retagets organisationsnummer (10 siffror)","creditCard.taxNumber.invalid":"Ogiltigt f\xf6delsedatum eller organisationsnummer","storedPaymentMethod.disable.button":"Ta bort","storedPaymentMethod.disable.confirmation":"Ta bort sparat betalningss\xe4tt","storedPaymentMethod.disable.confirmButton":"Ja, ta bort","storedPaymentMethod.disable.cancelButton":"Avbryt","ach.bankAccount":"Bankkonto","ach.accountHolderNameField.title":"Kontoinnehavarens namn","ach.accountHolderNameField.placeholder":"A. Andersson","ach.accountHolderNameField.invalid":"Kontoinnehavarens namn \xe4r ogiltigt","ach.accountNumberField.title":"Kontonummer","ach.accountNumberField.invalid":"Ogiltigt kontonummer","ach.accountLocationField.title":"ABA-nummer","ach.accountLocationField.invalid":"Ogiltigt ABA-nummer","select.state":"V\xe4lj delstat","select.stateOrProvince":"V\xe4lj delstat eller provins","select.provinceOrTerritory":"V\xe4lj provins eller territorium","select.country":"V\xe4lj land","telephoneNumber.invalid":"Ogiltigt telefonnummer","qrCodeOrApp":"eller","paypal.processingPayment":"Behandlar betalning \u2026","generateQRCode":"Generera QR-kod","await.waitForConfirmation":"V\xe4ntar p\xe5 bekr\xe4ftelse","mbway.confirmPayment":"Bekr\xe4fta din betalning i appen MB WAY","shopperEmail.invalid":"Ogiltig e-postadress","dateOfBirth.format":"DD/MM/\xc5\xc5\xc5\xc5","dateOfBirth.invalid":"Du m\xe5ste vara minst 18 \xe5r","blik.confirmPayment":"\xd6ppna din bankapp f\xf6r att bekr\xe4fta betalningen.","blik.invalid":"Ange 6 siffror","blik.code":"Sexsiffrig kod","blik.help":"H\xe4mta koden fr\xe5n din bankapp.","swish.pendingMessage":"N\xe4r du har skannat kan statusen vara v\xe4ntande i upp till tio minuter. Att f\xf6rs\xf6ka betala igen inom denna tid kan leda till flera debiteringar.","error.va.gen.01":"Ofullst\xe4ndigt f\xe4lt","error.va.gen.02":"F\xe4ltet ogiltigt","error.va.sf-cc-num.01":"Ogiltigt kortnummer","error.va.sf-cc-num.03":"Det angivna kortet st\xf6ds inte","error.va.sf-cc-dat.01":"Kortet \xe4r f\xf6r gammalt","error.va.sf-cc-dat.02":"Datumet ligger f\xf6r l\xe5ngt fram i framtiden","error.giftcard.no-balance":"Saldot f\xf6r detta presentkort \xe4r noll","error.giftcard.card-error":"Vi har inte registrerat n\xe5got presentkort med det numret","error.giftcard.currency-error":"Presentkort \xe4r endast giltiga i den valuta som de utf\xe4rdades i","amazonpay.signout":"Logga ut fr\xe5n Amazon","amazonpay.changePaymentDetails":"\xc4ndra betalningsuppgifter","partialPayment.warning":"V\xe4lj ett annat betalningss\xe4tt f\xf6r att betala det \xe5terst\xe5ende","partialPayment.remainingBalance":"\xc5terst\xe5ende saldo blir %{amount}","bankTransfer.beneficiary":"Mottagare","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"referens","bankTransfer.introduction":"Forts\xe4tt f\xf6r att skapa en ny bank\xf6verf\xf6ring. Du kan anv\xe4nda informationen p\xe5 f\xf6ljande sk\xe4rm f\xf6r att slutf\xf6ra denna betalning.","bankTransfer.instructions":"Tack f\xf6r ditt k\xf6p! Anv\xe4nd f\xf6ljande information f\xf6r att slutf\xf6ra din betalning.","bacs.accountHolderName":"Bankkontoinnehavarens namn","bacs.accountHolderName.invalid":"Ogiltigt namn p\xe5 bankkontoinnehavare","bacs.accountNumber":"Bankkontonummer","bacs.accountNumber.invalid":"Ogiltigt bankkontonummer","bacs.bankLocationId":"Clearingnummer","bacs.bankLocationId.invalid":"Ogiltigt clearingnummer","bacs.consent.amount":"Jag godk\xe4nner att ovanst\xe5ende belopp dras fr\xe5n mitt bankkonto.","bacs.consent.account":"Jag bekr\xe4ftar att jag \xe4r kontoinnehavare och att jag \xe4r den enda person vars godk\xe4nnande kr\xe4vs f\xf6r att auktorisera autogiro fr\xe5n detta konto.","edit":"Redigera","bacs.confirm":"Bekr\xe4fta och betala","bacs.result.introduction":"Ladda ner din instruktion f\xf6r autogiro/direktdebitering (DDI / Mandate)","download.pdf":"Ladda ner PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe f\xf6r s\xe4krat kortnummer","creditCard.encryptedCardNumber.aria.label":"F\xe4lt f\xf6r kortnummer","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe f\xf6r s\xe4krat utg\xe5ngsdatum f\xf6r kort","creditCard.encryptedExpiryDate.aria.label":"F\xe4lt f\xf6r utg\xe5ngsdatum","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe f\xf6r s\xe4krad utg\xe5ngsm\xe5nad f\xf6r kort","creditCard.encryptedExpiryMonth.aria.label":"F\xe4lt f\xf6r utg\xe5ngsm\xe5nad","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe f\xf6r s\xe4krat utg\xe5ngs\xe5r f\xf6r kort","creditCard.encryptedExpiryYear.aria.label":"F\xe4lt f\xf6r utg\xe5ngs\xe5r","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe f\xf6r s\xe4krad s\xe4kerhetskod f\xf6r kort","creditCard.encryptedSecurityCode.aria.label":"F\xe4lt f\xf6r s\xe4kerhetskod","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe f\xf6r s\xe4krat presentkortsnummer","giftcard.encryptedCardNumber.aria.label":"F\xe4lt f\xf6r presentkortsnummer","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe f\xf6r s\xe4krad s\xe4kerhetskod f\xf6r presentkort","giftcard.encryptedSecurityCode.aria.label":"F\xe4lt f\xf6r s\xe4kerhetskod f\xf6r presentkort","giftcardTransactionLimit":"Maximalt %{amount} per transaktion \xe4r till\xe5tet p\xe5 detta presentkort","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe f\xf6r s\xe4krat bankkontonummer","ach.encryptedBankAccountNumber.aria.label":"F\xe4lt f\xf6r bankkontonummer","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe f\xf6r s\xe4krat clearingnummer","ach.encryptedBankLocationId.aria.label":"F\xe4lt f\xf6r clearingnummer"}')},function(e){e.exports=JSON.parse('{"payButton":"\u652f\u4ed8","payButton.redirecting":"\u6b63\u5728\u91cd\u5b9a\u5411...","storeDetails":"\u4fdd\u5b58\u4ee5\u4fbf\u4e0b\u6b21\u652f\u4ed8\u4f7f\u7528","creditCard.holderName":"\u5361\u7247\u4e0a\u7684\u59d3\u540d","creditCard.holderName.placeholder":"J. Smith","creditCard.holderName.invalid":"\u65e0\u6548\u7684\u6301\u5361\u4eba\u59d3\u540d","creditCard.numberField.title":"\u5361\u53f7","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"\u6709\u6548\u671f","creditCard.expiryDateField.placeholder":"\u6708\u6708/\u5e74\u5e74","creditCard.expiryDateField.month":"\u6708","creditCard.expiryDateField.month.placeholder":"\u6708\u6708","creditCard.expiryDateField.year.placeholder":"\u5e74\u5e74","creditCard.expiryDateField.year":"\u5e74","creditCard.cvcField.title":"CVC / CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"\u8bb0\u4f4f\u4ee5\u4fbf\u4e0b\u6b21\u4f7f\u7528","creditCard.cvcField.placeholder.4digits":"4 \u4f4d\u6570","creditCard.cvcField.placeholder.3digits":"3 \u4f4d\u6570","creditCard.taxNumber.placeholder":"\u5e74\u6708\u65e5 / 0123456789","installments":"\u5206\u671f\u4ed8\u6b3e\u671f\u6570","installmentOption":"%{times}x %{partialValue}","installmentOptionMonths":"%{times} \u4e2a\u6708","installments.oneTime":"\u5168\u6b3e\u652f\u4ed8","installments.installments":"\u5206\u671f\u652f\u4ed8","installments.revolving":"\u5faa\u73af\u652f\u4ed8","sepaDirectDebit.ibanField.invalid":"\u65e0\u6548\u7684\u8d26\u53f7","sepaDirectDebit.nameField.placeholder":"J. Smith","sepa.ownerName":"\u6301\u5361\u4eba\u59d3\u540d","sepa.ibanNumber":"\u8d26\u53f7 (IBAN)","error.title":"\u9519\u8bef","error.subtitle.redirect":"\u91cd\u5b9a\u5411\u5931\u8d25","error.subtitle.payment":"\u652f\u4ed8\u5931\u8d25","error.subtitle.refused":"\u652f\u4ed8\u88ab\u62d2","error.message.unknown":"\u53d1\u751f\u672a\u77e5\u9519\u8bef","idealIssuer.selectField.title":"\u94f6\u884c","idealIssuer.selectField.placeholder":"\u9009\u62e9\u60a8\u7684\u94f6\u884c","creditCard.success":"\u652f\u4ed8\u6210\u529f","loading":"\u6b63\u5728\u52a0\u8f7d...","continue":"\u7ee7\u7eed","continueTo":"\u7ee7\u7eed\u81f3","wechatpay.timetopay":"\u60a8\u9700\u8981\u652f\u4ed8 %@","wechatpay.scanqrcode":"\u626b\u63cf\u4e8c\u7ef4\u7801","personalDetails":"\u4e2a\u4eba\u8be6\u7ec6\u4fe1\u606f","companyDetails":"\u516c\u53f8\u8be6\u60c5","companyDetails.name":"\u516c\u53f8\u540d\u79f0","companyDetails.registrationNumber":"\u6ce8\u518c\u53f7","socialSecurityNumber":"\u793e\u4f1a\u4fdd\u9669\u53f7\u7801","firstName":"\u540d\u5b57","infix":"\u524d\u7f00","lastName":"\u59d3\u6c0f","mobileNumber":"\u624b\u673a\u53f7","mobileNumber.invalid":"\u65e0\u6548\u7684\u624b\u673a\u53f7\u7801","city":"\u57ce\u5e02","postalCode":"\u90ae\u653f\u7f16\u7801","countryCode":"\u56fd\u5bb6\u4ee3\u7801","telephoneNumber":"\u7535\u8bdd\u53f7\u7801","dateOfBirth":"\u51fa\u751f\u65e5\u671f","shopperEmail":"\u7535\u5b50\u90ae\u4ef6\u5730\u5740","gender":"\u6027\u522b","male":"\u7537","female":"\u5973","billingAddress":"\u8d26\u5355\u5730\u5740","street":"\u8857\u9053","stateOrProvince":"\u5dde\u6216\u7701","country":"\u56fd\u5bb6/\u5730\u533a","houseNumberOrName":"\u95e8\u724c\u53f7","separateDeliveryAddress":"\u6307\u5b9a\u4e00\u4e2a\u5355\u72ec\u7684\u5bc4\u9001\u5730\u5740","deliveryAddress":"\u5bc4\u9001\u5730\u5740","zipCode":"\u90ae\u653f\u7f16\u7801","apartmentSuite":"\u516c\u5bd3 / \u5957\u623f","provinceOrTerritory":"\u7701\u6216\u5730\u533a","cityTown":"\u5e02 / \u9547","address":"\u5730\u5740","state":"\u5dde","creditCard.cvcField.title.optional":"CVC / CVV\uff08\u53ef\u9009\uff09","issuerList.wallet.placeholder":"\u9009\u62e9\u60a8\u7684\u94b1\u5305","privacyPolicy":"\u9690\u79c1\u653f\u7b56","afterPay.agreement":"\u6211\u540c\u610f AfterPay \u7684 %@","paymentConditions":"\u652f\u4ed8\u6761\u4ef6","openApp":"\u6253\u5f00\u5e94\u7528","voucher.readInstructions":"\u9605\u8bfb\u8bf4\u660e","voucher.introduction":"\u611f\u8c22\u60a8\u7684\u8d2d\u4e70\uff0c\u8bf7\u4f7f\u7528\u4ee5\u4e0b\u4f18\u60e0\u5238\u5b8c\u6210\u652f\u4ed8\u3002","voucher.expirationDate":"\u6709\u6548\u671f","voucher.alternativeReference":"\u5907\u9009\u4ee3\u7801","dragonpay.voucher.non.bank.selectField.placeholder":"\u9009\u62e9\u60a8\u7684\u63d0\u4f9b\u5546","dragonpay.voucher.bank.selectField.placeholder":"\u9009\u62e9\u60a8\u7684\u94f6\u884c","voucher.paymentReferenceLabel":"\u4ea4\u6613\u53f7","voucher.surcharge":"\u5305\u62ec %@ \u7684\u9644\u52a0\u8d39","voucher.introduction.doku":"\u611f\u8c22\u60a8\u7684\u8d2d\u4e70\uff0c\u8bf7\u4f7f\u7528\u4ee5\u4e0b\u4fe1\u606f\u5b8c\u6210\u652f\u4ed8\u3002","voucher.shopperName":"\u987e\u5ba2\u59d3\u540d","voucher.merchantName":"\u5546\u6237","voucher.introduction.econtext":"\u611f\u8c22\u60a8\u7684\u8d2d\u4e70\uff0c\u8bf7\u4f7f\u7528\u4ee5\u4e0b\u4fe1\u606f\u5b8c\u6210\u652f\u4ed8\u3002","voucher.telephoneNumber":"\u7535\u8bdd\u53f7\u7801","voucher.shopperReference":"\u987e\u5ba2\u53c2\u8003","voucher.collectionInstitutionNumber":"\u6536\u6b3e\u673a\u6784\u7f16\u53f7","voucher.econtext.telephoneNumber.invalid":"\u7535\u8bdd\u53f7\u7801\u5fc5\u987b\u4e3a 10 \u6216 11 \u4f4d\u6570\u5b57","boletobancario.btnLabel":"\u751f\u6210 Boleto","boleto.sendCopyToEmail":"\u5c06\u526f\u672c\u53d1\u9001\u5230\u6211\u7684\u7535\u5b50\u90ae\u7bb1","button.copy":"\u590d\u5236","button.download":"\u4e0b\u8f7d","creditCard.storedCard.description.ariaLabel":"\u5b58\u50a8\u7684\u5361\u7247\u4ee5 \uff05@ \u7ed3\u5c3e","voucher.entity":"\u5b9e\u4f53","donateButton":"\u6350\u8d60","notNowButton":"\u6682\u4e0d","thanksForYourSupport":"\u611f\u8c22\u60a8\u7684\u652f\u6301\uff01","preauthorizeWith":"\u9884\u5148\u6388\u6743","confirmPreauthorization":"\u786e\u8ba4\u9884\u5148\u6388\u6743","confirmPurchase":"\u786e\u8ba4\u8d2d\u4e70","applyGiftcard":"\u5151\u6362","giftcardBalance":"\u793c\u54c1\u5361\u4f59\u989d","deductedBalance":"\u6263\u51cf\u4f59\u989d","creditCard.pin.title":"Pin","creditCard.encryptedPassword.label":"\u5361\u7247\u5bc6\u7801\u7684\u524d 2 \u4f4d\u6570","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"\u65e0\u6548\u7684\u5bc6\u7801","creditCard.taxNumber.label":"\u6301\u5361\u4eba\u751f\u65e5 (YYMMDD) \u6216\u516c\u53f8\u6ce8\u518c\u53f7\uff0810 \u4f4d\u6570\uff09","creditCard.taxNumber.labelAlt":"\u516c\u53f8\u6ce8\u518c\u53f7\uff0810 \u4f4d\u6570\uff09","creditCard.taxNumber.invalid":"\u65e0\u6548\u7684\u6301\u5361\u4eba\u751f\u65e5\u6216\u516c\u53f8\u6ce8\u518c\u53f7","storedPaymentMethod.disable.button":"\u5220\u9664","storedPaymentMethod.disable.confirmation":"\u5220\u9664\u5b58\u50a8\u7684\u652f\u4ed8\u65b9\u5f0f","storedPaymentMethod.disable.confirmButton":"\u662f\uff0c\u5220\u9664","storedPaymentMethod.disable.cancelButton":"\u53d6\u6d88","ach.bankAccount":"\u94f6\u884c\u8d26\u6237","ach.accountHolderNameField.title":"\u8d26\u6237\u6301\u6709\u4eba\u59d3\u540d","ach.accountHolderNameField.placeholder":"J. Smith","ach.accountHolderNameField.invalid":"\u65e0\u6548\u7684\u8d26\u6237\u6301\u6709\u4eba\u59d3\u540d","ach.accountNumberField.title":"\u8d26\u53f7","ach.accountNumberField.invalid":"\u65e0\u6548\u7684\u8d26\u53f7","ach.accountLocationField.title":"ABA \u8def\u7531\u7535\u6c47\u7f16\u7801","ach.accountLocationField.invalid":"\u65e0\u6548\u7684 ABA \u8def\u7531\u7535\u6c47\u7f16\u7801","select.state":"\u9009\u62e9\u5dde","select.stateOrProvince":"\u9009\u62e9\u5dde\u6216\u7701","select.provinceOrTerritory":"\u9009\u62e9\u7701\u6216\u5730\u533a","select.country":"\u9009\u62e9\u56fd\u5bb6/\u5730\u533a","telephoneNumber.invalid":"\u65e0\u6548\u7684\u7535\u8bdd\u53f7\u7801","qrCodeOrApp":"\u6216\u8005","paypal.processingPayment":"\u6b63\u5728\u5904\u7406\u4ed8\u6b3e...","generateQRCode":"\u751f\u6210\u4e8c\u7ef4\u7801","await.waitForConfirmation":"\u7b49\u5f85\u786e\u8ba4","mbway.confirmPayment":"\u5728 MB WAY \u5e94\u7528\u4e0a\u786e\u8ba4\u60a8\u7684\u4ed8\u6b3e","shopperEmail.invalid":"\u65e0\u6548\u7684\u90ae\u4ef6\u5730\u5740","dateOfBirth.format":"DD/MM/YYYY","dateOfBirth.invalid":"\u60a8\u5fc5\u987b\u5e74\u6ee1 18 \u5468\u5c81","blik.confirmPayment":"\u6253\u5f00\u60a8\u7684\u94f6\u884c\u5e94\u7528\u4ee5\u786e\u8ba4\u652f\u4ed8\u3002","blik.invalid":"\u8f93\u5165 6 \u4f4d\u6570","blik.code":"6 \u4f4d\u6570\u4ee3\u7801","blik.help":"\u4ece\u60a8\u7684\u94f6\u884c\u5e94\u7528\u4e2d\u83b7\u53d6\u4ee3\u7801\u3002","swish.pendingMessage":"\u626b\u63cf\u540e\uff0c\u72b6\u6001\u53ef\u80fd\u4f1a\u4fdd\u6301\u6700\u591a 10 \u5206\u949f\u3002\u5728\u6b64\u65f6\u95f4\u5185\u518d\u6b21\u5c1d\u8bd5\u4ed8\u6b3e\u53ef\u80fd\u4f1a\u5bfc\u81f4\u591a\u6b21\u6536\u8d39\u3002","error.va.gen.01":"\u4e0d\u5b8c\u6574\u5b57\u6bb5","error.va.gen.02":"\u65e0\u6548\u5b57\u6bb5","error.va.sf-cc-num.01":"\u65e0\u6548\u7684\u5361\u53f7","error.va.sf-cc-num.03":"\u4e0d\u652f\u6301\u8f93\u5165\u7684\u5361\u7247","error.va.sf-cc-dat.01":"\u5361\u7247\u592a\u65e7","error.va.sf-cc-dat.02":"\u65e5\u671f\u592a\u4e45\u8fdc","error.giftcard.no-balance":"\u793c\u54c1\u5361\u4f59\u989d\u4e3a\u96f6","error.giftcard.card-error":"\u6211\u4eec\u7684\u6570\u636e\u5e93\u4e2d\u6ca1\u6709\u8fd9\u4e2a\u53f7\u7801\u7684\u793c\u54c1\u5361","error.giftcard.currency-error":"\u793c\u54c1\u5361\u4ec5\u4ee5\u5176\u53d1\u884c\u7684\u8d27\u5e01\u4e3a\u6709\u6548\u8d27\u5e01","amazonpay.signout":"\u9000\u51fa Amazon","amazonpay.changePaymentDetails":"\u66f4\u6539\u652f\u4ed8\u8be6\u60c5","partialPayment.warning":"\u8bf7\u9009\u62e9\u5176\u4ed6\u652f\u4ed8\u65b9\u5f0f\u652f\u4ed8\u5269\u4f59\u6b3e\u9879","partialPayment.remainingBalance":"\u5269\u4f59\u989d\u5ea6\u4e3a %{amount}","bankTransfer.beneficiary":"\u6536\u6b3e\u4eba","bankTransfer.iban":"IBAN","bankTransfer.bic":"\u4e2d\u56fd\u5de5\u5546\u94f6\u884c","bankTransfer.reference":"\u53c2\u8003","bankTransfer.introduction":"\u7ee7\u7eed\u65b0\u5efa\u94f6\u884c\u8f6c\u8d26\u4ed8\u6b3e\u3002\u60a8\u53ef\u4ee5\u4f7f\u7528\u4ee5\u4e0b\u5c4f\u5e55\u4e2d\u7684\u8be6\u7ec6\u4fe1\u606f\u6765\u5b8c\u6210\u8fd9\u7b14\u4ed8\u6b3e\u3002","bankTransfer.instructions":"\u611f\u8c22\u60a8\u7684\u8d2d\u4e70\uff0c\u8bf7\u4f7f\u7528\u4ee5\u4e0b\u4fe1\u606f\u5b8c\u6210\u652f\u4ed8\u3002","bacs.accountHolderName":"\u94f6\u884c\u8d26\u6237\u6301\u6709\u4eba\u59d3\u540d","bacs.accountHolderName.invalid":"\u65e0\u6548\u7684\u94f6\u884c\u8d26\u6237\u6301\u6709\u4eba\u59d3\u540d","bacs.accountNumber":"\u94f6\u884c\u8d26\u53f7","bacs.accountNumber.invalid":"\u65e0\u6548\u7684\u94f6\u884c\u8d26\u53f7","bacs.bankLocationId":"\u5206\u7c7b\u4ee3\u7801","bacs.bankLocationId.invalid":"\u65e0\u6548\u7684\u5206\u7c7b\u4ee3\u7801","bacs.consent.amount":"\u6211\u540c\u610f\u4ece\u94f6\u884c\u8d26\u6237\u4e2d\u6263\u9664\u4e0a\u8ff0\u91d1\u989d\u3002","bacs.consent.account":"\u6211\u786e\u8ba4\u8be5\u8d26\u6237\u4e3a\u6211\u540d\u4e0b\u7684\u8d26\u6237\uff0c\u5e76\u4e14\u6211\u662f\u6388\u6743\u8be5\u8d26\u6237\u76f4\u63a5\u501f\u8bb0\u7684\u552f\u4e00\u7b7e\u7f72\u4eba\u3002","edit":"\u7f16\u8f91","bacs.confirm":"\u786e\u8ba4\u5e76\u652f\u4ed8","bacs.result.introduction":"\u4e0b\u8f7d\u60a8\u7684\u76f4\u63a5\u501f\u8bb0\u6307\u793a\uff08DDI/\u59d4\u6258\uff09","download.pdf":"\u4e0b\u8f7d PDF \u6587\u4ef6","creditCard.encryptedCardNumber.aria.iframeTitle":"\u5b89\u5168\u5361\u53f7 Iframe","creditCard.encryptedCardNumber.aria.label":"\u5361\u53f7\u5b57\u6bb5","creditCard.encryptedExpiryDate.aria.iframeTitle":"\u5b89\u5168\u5361\u7247\u8fc7\u671f\u65e5\u671f Iframe","creditCard.encryptedExpiryDate.aria.label":"\u8fc7\u671f\u65e5\u671f\u5b57\u6bb5","creditCard.encryptedExpiryMonth.aria.iframeTitle":"\u5b89\u5168\u5361\u7247\u8fc7\u671f\u6708\u4efd Iframe","creditCard.encryptedExpiryMonth.aria.label":"\u8fc7\u671f\u6708\u4efd\u5b57\u6bb5","creditCard.encryptedExpiryYear.aria.iframeTitle":"\u5b89\u5168\u5361\u7247\u8fc7\u671f\u5e74\u4efd Iframe","creditCard.encryptedExpiryYear.aria.label":"\u8fc7\u671f\u5e74\u4efd\u5b57\u6bb5","creditCard.encryptedSecurityCode.aria.iframeTitle":"\u5b89\u5168\u5361\u7247\u5b89\u5168\u7801 Iframe","creditCard.encryptedSecurityCode.aria.label":"\u5b89\u5168\u7801\u5b57\u6bb5","giftcard.encryptedCardNumber.aria.iframeTitle":"\u5b89\u5168\u793c\u54c1\u5361\u53f7 Iframe","giftcard.encryptedCardNumber.aria.label":"\u793c\u54c1\u5361\u53f7\u5b57\u6bb5","giftcard.encryptedSecurityCode.aria.iframeTitle":"\u5b89\u5168\u793c\u54c1\u5361\u5b89\u5168\u7801 Iframe","giftcard.encryptedSecurityCode.aria.label":"\u793c\u54c1\u5361\u5b89\u5168\u7801\u5b57\u6bb5","giftcardTransactionLimit":"\u6b64\u793c\u54c1\u5361\u4e0a\u6bcf\u7b14\u4ea4\u6613\u5141\u8bb8\u7684\u6700\u5927\u91d1\u989d\u4e3a %{amount}","ach.encryptedBankAccountNumber.aria.iframeTitle":"\u5b89\u5168\u94f6\u884c\u8d26\u53f7 Iframe","ach.encryptedBankAccountNumber.aria.label":"\u94f6\u884c\u8d26\u53f7\u5b57\u6bb5","ach.encryptedBankLocationId.aria.iframeTitle":"\u5b89\u5168\u94f6\u884c\u8def\u7531\u7535\u6c47\u7f16\u7801 Iframe","ach.encryptedBankLocationId.aria.label":"\u94f6\u884c\u8def\u7531\u7535\u6c47\u7f16\u7801\u5b57\u6bb5"}')},function(e){e.exports=JSON.parse('{"payButton":"\u652f\u4ed8","payButton.redirecting":"\u91cd\u65b0\u5c0e\u5411\u4e2d......","storeDetails":"\u5132\u5b58\u4ee5\u4f9b\u4e0b\u6b21\u4ed8\u6b3e\u4f7f\u7528","creditCard.holderName":"\u4fe1\u7528\u5361\u4e0a\u7684\u59d3\u540d","creditCard.holderName.placeholder":"J. Smith","creditCard.holderName.invalid":"\u6301\u5361\u4eba\u59d3\u540d\u7121\u6548","creditCard.numberField.title":"\u4fe1\u7528\u5361\u865f\u78bc","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"\u5230\u671f\u65e5\u671f","creditCard.expiryDateField.placeholder":"MM/YY","creditCard.expiryDateField.month":"\u6708\u4efd","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"YY","creditCard.expiryDateField.year":"\u5e74\u4efd","creditCard.cvcField.title":"\u4fe1\u7528\u5361\u9a57\u8b49\u78bc / \u4fe1\u7528\u5361\u5b89\u5168\u78bc","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"\u8a18\u4f4f\u4f9b\u4e0b\u6b21\u4f7f\u7528","creditCard.cvcField.placeholder.4digits":"4 \u4f4d\u6578","creditCard.cvcField.placeholder.3digits":"3 \u4f4d\u6578","creditCard.taxNumber.placeholder":"\u5e74\u6708\u65e5\uff0f0123456789","installments":"\u5206\u671f\u4ed8\u6b3e\u7684\u671f\u6578","installmentOption":"%{times}x %{partialValue}","installmentOptionMonths":"\uff05{times} \u500b\u6708","installments.oneTime":"\u4e00\u6b21\u6027\u4ed8\u6b3e","installments.installments":"\u5206\u671f\u4ed8\u6b3e","installments.revolving":"\u5ef6\u671f\u4ed8\u6b3e","sepaDirectDebit.ibanField.invalid":"\u5e33\u6236\u865f\u78bc\u7121\u6548","sepaDirectDebit.nameField.placeholder":"J. Smith","sepa.ownerName":"\u6301\u6709\u4eba\u540d\u7a31","sepa.ibanNumber":"\u5e33\u6236\u865f\u78bc (IBAN)","error.title":"\u932f\u8aa4","error.subtitle.redirect":"\u7121\u6cd5\u91cd\u65b0\u5c0e\u5411","error.subtitle.payment":"\u4ed8\u6b3e\u5931\u6557","error.subtitle.refused":"\u4ed8\u6b3e\u906d\u62d2\u7d55","error.message.unknown":"\u767c\u751f\u672a\u77e5\u932f\u8aa4","idealIssuer.selectField.title":"\u9280\u884c","idealIssuer.selectField.placeholder":"\u9078\u53d6\u60a8\u7684\u9280\u884c","creditCard.success":"\u4ed8\u6b3e\u6210\u529f","loading":"\u6b63\u5728\u8f09\u5165...","continue":"\u7e7c\u7e8c","continueTo":"\u7e7c\u7e8c\u524d\u5f80","wechatpay.timetopay":"\u60a8\u6709 %@ \u53ef\u4ee5\u652f\u4ed8","wechatpay.scanqrcode":"\u6383\u63cf QR \u4ee3\u78bc","personalDetails":"\u500b\u4eba\u8a73\u7d30\u8cc7\u6599","companyDetails":"\u516c\u53f8\u8a73\u60c5","companyDetails.name":"\u516c\u53f8\u540d\u7a31","companyDetails.registrationNumber":"\u8a3b\u518a\u865f\u78bc","socialSecurityNumber":"\u793e\u6703\u5b89\u5168\u78bc","firstName":"\u540d\u5b57","infix":"\u524d\u7db4","lastName":"\u59d3\u6c0f","mobileNumber":"\u884c\u52d5\u96fb\u8a71\u865f\u78bc","mobileNumber.invalid":"\u624b\u6a5f\u865f\u78bc\u7121\u6548","city":"\u57ce\u5e02","postalCode":"\u90f5\u905e\u5340\u865f","countryCode":"\u570b\u5bb6\u4ee3\u78bc","telephoneNumber":"\u96fb\u8a71\u865f\u78bc","dateOfBirth":"\u51fa\u751f\u65e5\u671f","shopperEmail":"\u96fb\u5b50\u90f5\u4ef6\u5730\u5740","gender":"\u6027\u5225","male":"\u7537","female":"\u5973","billingAddress":"\u5e33\u55ae\u5730\u5740","street":"\u8857\u9053","stateOrProvince":"\u5dde/\u7e23/\u5e02","country":"\u570b\u5bb6/\u5730\u5340","houseNumberOrName":"\u9580\u724c\u865f","separateDeliveryAddress":"\u6307\u5b9a\u53e6\u4e00\u500b\u6d3e\u9001\u5730\u5740","deliveryAddress":"\u6d3e\u9001\u5730\u5740","zipCode":"\u90f5\u905e\u5340\u865f","apartmentSuite":"\u516c\u5bd3\uff0f\u5957\u623f","provinceOrTerritory":"\u7701\u6216\u5730\u5340","cityTown":"\u5e02\uff0f\u93ae","address":"\u5730\u5740","state":"\u5dde","creditCard.cvcField.title.optional":"CVC / CVV (\u53ef\u9078)","issuerList.wallet.placeholder":"\u9078\u53d6\u60a8\u7684\u96fb\u5b50\u9322\u5305","privacyPolicy":"\u96b1\u79c1\u6b0a\u653f\u7b56","afterPay.agreement":"\u6211\u540c\u610f AfterPay \u7684%@","paymentConditions":"\u4ed8\u6b3e\u7d30\u5247","openApp":"\u958b\u555f\u61c9\u7528\u7a0b\u5f0f","voucher.readInstructions":"\u95b1\u89bd\u8aaa\u660e","voucher.introduction":"\u591a\u8b1d\u60e0\u9867\uff0c\u8acb\u4f7f\u7528\u4ee5\u4e0b\u512a\u60e0\u5238\u5b8c\u6210\u4ed8\u6b3e\u3002","voucher.expirationDate":"\u5230\u671f\u65e5\u671f","voucher.alternativeReference":"\u5099\u9078\u53c3\u7167","dragonpay.voucher.non.bank.selectField.placeholder":"\u9078\u64c7\u60a8\u7684\u4f9b\u61c9\u5546","dragonpay.voucher.bank.selectField.placeholder":"\u9078\u53d6\u60a8\u7684\u9280\u884c","voucher.paymentReferenceLabel":"\u4ed8\u6b3e\u53c3\u7167\u865f\u78bc","voucher.surcharge":"\u5305\u542b %@ \u9644\u52a0\u8cbb","voucher.introduction.doku":"\u591a\u8b1d\u60e0\u9867\uff0c\u8acb\u4f7f\u7528\u4ee5\u4e0b\u8cc7\u8a0a\u5b8c\u6210\u4ed8\u6b3e\u3002","voucher.shopperName":"\u8cfc\u7269\u8005\u59d3\u540d","voucher.merchantName":"\u5546\u5bb6","voucher.introduction.econtext":"\u591a\u8b1d\u60e0\u9867\uff0c\u8acb\u4f7f\u7528\u4ee5\u4e0b\u8cc7\u8a0a\u5b8c\u6210\u4ed8\u6b3e\u3002","voucher.telephoneNumber":"\u96fb\u8a71\u865f\u78bc","voucher.shopperReference":"\u8cfc\u7269\u8005\u53c3\u8003","voucher.collectionInstitutionNumber":"\u6536\u6b3e\u6a5f\u69cb\u7de8\u865f","voucher.econtext.telephoneNumber.invalid":"\u96fb\u8a71\u865f\u78bc\u7684\u9577\u5ea6\u5fc5\u9808\u70ba 10 \u6216 11 \u4f4d\u6578","boletobancario.btnLabel":"\u7522\u751f Boleto","boleto.sendCopyToEmail":"\u5c07\u8907\u672c\u50b3\u9001\u81f3\u6211\u7684\u96fb\u5b50\u90f5\u4ef6","button.copy":"\u8907\u88fd","button.download":"\u4e0b\u8f09","creditCard.storedCard.description.ariaLabel":"\u5df2\u5132\u5b58\u4ee5 %@ \u7d50\u5c3e\u7684\u4fe1\u7528\u5361","voucher.entity":"\u5be6\u9ad4","donateButton":"\u6350\u8d08","notNowButton":"\u7a0d\u5f8c\u518d\u8aaa","thanksForYourSupport":"\u611f\u8b1d\u60a8\u7684\u652f\u6301\uff01","preauthorizeWith":"\u900f\u904e\u4ee5\u4e0b\u65b9\u5f0f\u9032\u884c\u9810\u5148\u6388\u6b0a\uff1a","confirmPreauthorization":"\u78ba\u8a8d\u9810\u5148\u6388\u6b0a","confirmPurchase":"\u78ba\u8a8d\u8cfc\u8cb7","applyGiftcard":"\u514c\u63db","giftcardBalance":"\u79ae\u54c1\u5361\u9918\u984d","deductedBalance":"\u6263\u9664\u9918\u984d","creditCard.pin.title":"\u6578\u5b57\u5bc6\u78bc","creditCard.encryptedPassword.label":"\u5361\u5bc6\u78bc\u7684\u524d 2 \u4f4d\u6578\u5b57","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"\u5bc6\u78bc\u7121\u6548","creditCard.taxNumber.label":"\u6301\u5361\u4eba\u751f\u65e5\uff08\u5e74\u6708\u65e5\uff09\u6216\u516c\u53f8\u8a3b\u518a\u865f\u78bc\uff0810 \u4f4d\u6578\uff09","creditCard.taxNumber.labelAlt":"\u516c\u53f8\u8a3b\u518a\u865f\u78bc\uff0810 \u4f4d\u6578\uff09","creditCard.taxNumber.invalid":"\u6301\u5361\u4eba\u751f\u65e5\u6216\u516c\u53f8\u8a3b\u518a\u865f\u78bc\u7121\u6548","storedPaymentMethod.disable.button":"\u79fb\u9664","storedPaymentMethod.disable.confirmation":"\u79fb\u9664\u5df2\u5132\u5b58\u4ed8\u6b3e\u65b9\u5f0f","storedPaymentMethod.disable.confirmButton":"\u662f\uff0c\u8acb\u79fb\u9664","storedPaymentMethod.disable.cancelButton":"\u53d6\u6d88","ach.bankAccount":"\u9280\u884c\u5e33\u6236","ach.accountHolderNameField.title":"\u5e33\u6236\u6301\u6709\u4eba\u59d3\u540d","ach.accountHolderNameField.placeholder":"J. Smith","ach.accountHolderNameField.invalid":"\u5e33\u6236\u6301\u6709\u4eba\u59d3\u540d\u7121\u6548","ach.accountNumberField.title":"\u5e33\u6236\u865f\u78bc","ach.accountNumberField.invalid":"\u5e33\u6236\u865f\u78bc\u7121\u6548","ach.accountLocationField.title":"ABA \u532f\u6b3e\u8def\u5f91\u7de8\u865f","ach.accountLocationField.invalid":"ABA \u532f\u6b3e\u8def\u5f91\u7de8\u865f\u7121\u6548","select.state":"\u9078\u53d6\u5dde","select.stateOrProvince":"\u9078\u64c7\u5dde\u6216\u7701","select.provinceOrTerritory":"\u9078\u53d6\u7701\u6216\u5730\u5340","select.country":"\u9078\u64c7\u570b\u5bb6\uff0f\u5730\u5340","telephoneNumber.invalid":"\u96fb\u8a71\u865f\u78bc\u7121\u6548","qrCodeOrApp":"\u6216","paypal.processingPayment":"\u6b63\u5728\u8655\u7406\u4ed8\u6b3e\u2026\u2026","generateQRCode":"\u7522\u751f QR \u4ee3\u78bc","await.waitForConfirmation":"\u6b63\u5728\u7b49\u5019\u78ba\u8a8d","mbway.confirmPayment":"\u5728 MB WAY \u61c9\u7528\u7a0b\u5f0f\u4e0a\u78ba\u8a8d\u60a8\u7684\u4ed8\u6b3e","shopperEmail.invalid":"\u96fb\u5b50\u90f5\u4ef6\u5730\u5740\u7121\u6548","dateOfBirth.format":"\u65e5\uff0f\u6708\uff0f\u5e74","dateOfBirth.invalid":"\u60a8\u5fc5\u9808\u5e74\u6eff 18 \u6b72","blik.confirmPayment":"\u958b\u555f\u60a8\u7684\u9280\u884c\u61c9\u7528\u7a0b\u5f0f\u4ee5\u78ba\u8a8d\u4ed8\u6b3e\u3002","blik.invalid":"\u8f38\u5165 6 \u500b\u6578\u5b57","blik.code":"6 \u4f4d\u6578\u4ee3\u78bc","blik.help":"\u5f9e\u60a8\u7684\u9280\u884c\u61c9\u7528\u7a0b\u5f0f\u4e2d\u7372\u53d6\u4ee3\u78bc\u3002","swish.pendingMessage":"\u6383\u63cf\u5f8c\uff0c\u8a72\u5f85\u5b8c\u6210\u72c0\u614b\u53ef\u80fd\u6301\u7e8c\u9577\u9054 10 \u5206\u9418\u3002\u8a66\u5716\u5728\u9019\u6bb5\u6642\u9593\u5167\u518d\u6b21\u4ed8\u6b3e\u53ef\u80fd\u6703\u5c0e\u81f4\u591a\u91cd\u6536\u8cbb\u3002","error.va.gen.01":"\u4e0d\u5b8c\u6574\u6b04\u4f4d","error.va.gen.02":"\u6b04\u4f4d\u7121\u6548","error.va.sf-cc-num.01":"\u4fe1\u7528\u5361\u865f\u78bc\u7121\u6548","error.va.sf-cc-num.03":"\u8f38\u5165\u4e86\u4e0d\u652f\u63f4\u7684\u5361","error.va.sf-cc-dat.01":"\u5361\u592a\u820a","error.va.sf-cc-dat.02":"\u672a\u4f86\u65e5\u671f\u8ddd\u4eca\u592a\u4e45","error.giftcard.no-balance":"\u6b64\u79ae\u54c1\u5361\u7684\u9918\u984d\u70ba\u96f6","error.giftcard.card-error":"\u6211\u5011\u7684\u8a18\u9304\u4e2d\u4e26\u6c92\u6709\u9019\u500b\u865f\u78bc\u7684\u79ae\u54c1\u5361","error.giftcard.currency-error":"\u79ae\u54c1\u5361\u53ea\u80fd\u4ee5\u5176\u7c3d\u767c\u6642\u6240\u4f7f\u7528\u7684\u8ca8\u5e63\u9032\u884c\u7d50\u7b97","amazonpay.signout":"\u5f9e Amazon \u767b\u51fa","amazonpay.changePaymentDetails":"\u8b8a\u66f4\u4ed8\u6b3e\u660e\u7d30","partialPayment.warning":"\u9078\u53d6\u5176\u4ed6\u4ed8\u6b3e\u65b9\u5f0f\u4f86\u652f\u4ed8\u9918\u984d","partialPayment.remainingBalance":"\u9918\u984d\u5c07\u70ba %{amount}","bankTransfer.beneficiary":"\u53d7\u6b3e\u4eba","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"\u53c3\u7167","bankTransfer.introduction":"\u7e7c\u7e8c\u5efa\u7acb\u65b0\u7684\u9280\u884c\u8f49\u5e33\u4ed8\u6b3e\u3002\u60a8\u53ef\u4ee5\u4f7f\u7528\u4ee5\u4e0b\u87a2\u5e55\u4e2d\u7684\u8a73\u7d30\u8cc7\u8a0a\u4f86\u5b8c\u6210\u6b64\u9805\u4ed8\u6b3e\u3002","bankTransfer.instructions":"\u591a\u8b1d\u60e0\u9867\uff0c\u8acb\u4f7f\u7528\u4ee5\u4e0b\u8cc7\u8a0a\u5b8c\u6210\u4ed8\u6b3e\u3002","bacs.accountHolderName":"\u9280\u884c\u5e33\u6236\u6301\u6709\u4eba\u59d3\u540d","bacs.accountHolderName.invalid":"\u9280\u884c\u5e33\u6236\u6301\u6709\u4eba\u59d3\u540d\u7121\u6548","bacs.accountNumber":"\u9280\u884c\u5e33\u6236\u865f\u78bc","bacs.accountNumber.invalid":"\u9280\u884c\u5e33\u6236\u865f\u78bc\u7121\u6548","bacs.bankLocationId":"\u9280\u884c\u4ee3\u78bc","bacs.bankLocationId.invalid":"\u9280\u884c\u4ee3\u78bc\u7121\u6548","bacs.consent.amount":"\u6211\u540c\u610f\u5f9e\u6211\u7684\u9280\u884c\u5e33\u6236\u6263\u9664\u4e0a\u8ff0\u91d1\u984d\u3002","bacs.consent.account":"\u6211\u78ba\u8a8d\u8a72\u5e33\u6236\u4ee5\u6211\u7684\u540d\u7fa9\u958b\u8a2d\uff0c\u4e26\u4e14\u6211\u662f\u6388\u6b0a\u5f9e\u8a72\u5e33\u6236\u76f4\u63a5\u6263\u6b3e\u7684\u552f\u4e00\u7c3d\u7f72\u4eba\u3002","edit":"\u7de8\u8f2f","bacs.confirm":"\u78ba\u8a8d\u4e26\u652f\u4ed8","bacs.result.introduction":"\u4e0b\u8f09\u60a8\u7684\u76f4\u63a5\u6263\u6b3e\u6307\u793a\uff08DDI\uff0f\u6388\u6b0a\uff09","download.pdf":"\u4e0b\u8f09 PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"\u5b89\u5168\u5361\u865f\u7684 IFrame","creditCard.encryptedCardNumber.aria.label":"\u5361\u865f\u6b04\u4f4d","creditCard.encryptedExpiryDate.aria.iframeTitle":"\u5b89\u5168\u5361\u5230\u671f\u65e5\u671f\u7684 IFrame","creditCard.encryptedExpiryDate.aria.label":"\u5230\u671f\u65e5\u671f\u6b04\u4f4d","creditCard.encryptedExpiryMonth.aria.iframeTitle":"\u5b89\u5168\u5361\u5230\u671f\u6708\u4efd\u7684 IFrame","creditCard.encryptedExpiryMonth.aria.label":"\u5230\u671f\u6708\u4efd\u6b04\u4f4d","creditCard.encryptedExpiryYear.aria.iframeTitle":"\u5b89\u5168\u5361\u5230\u671f\u5e74\u4efd\u7684 IFrame","creditCard.encryptedExpiryYear.aria.label":"\u5230\u671f\u5e74\u4efd\u6b04\u4f4d","creditCard.encryptedSecurityCode.aria.iframeTitle":"\u5b89\u5168\u5361\u5b89\u5168\u78bc\u7684 IFrame","creditCard.encryptedSecurityCode.aria.label":"\u5b89\u5168\u78bc\u6b04\u4f4d","giftcard.encryptedCardNumber.aria.iframeTitle":"\u5b89\u5168\u79ae\u54c1\u5361\u865f\u7684 IFrame","giftcard.encryptedCardNumber.aria.label":"\u79ae\u54c1\u5361\u865f\u6b04\u4f4d","giftcard.encryptedSecurityCode.aria.iframeTitle":"\u5b89\u5168\u79ae\u54c1\u5361\u5b89\u5168\u78bc\u7684 IFrame","giftcard.encryptedSecurityCode.aria.label":"\u79ae\u54c1\u5361\u5b89\u5168\u78bc\u6b04\u4f4d","ach.encryptedBankAccountNumber.aria.iframeTitle":"\u5b89\u5168\u9280\u884c\u5e33\u6236\u865f\u78bc\u7684 IFrame","ach.encryptedBankAccountNumber.aria.label":"\u9280\u884c\u5e33\u6236\u6b04\u4f4d","ach.encryptedBankLocationId.aria.iframeTitle":"\u5b89\u5168\u9280\u884c\u532f\u6b3e\u8def\u5f91\u7de8\u865f\u7684 IFrame","ach.encryptedBankLocationId.aria.label":"\u9280\u884c\u532f\u6b3e\u8def\u5f91\u7de8\u865f\u6b04\u4f4d"}')},function(e,t,a){a(76);var r=a(22);e.exports=r.Object.assign},function(e,t,a){var r=a(8),n=a(86);r({target:"Object",stat:!0,forced:Object.assign!==n},{assign:n})},function(e,t,a){var r=a(2),n=a(12),i=a(7),o=a(19),s=a(37),c=a(78),d=c.get,l=c.enforce,u=String(String).split("String");(e.exports=function(e,t,a,s){var c,d=!!s&&!!s.unsafe,p=!!s&&!!s.enumerable,m=!!s&&!!s.noTargetGet;"function"==typeof a&&("string"!=typeof t||i(a,"name")||n(a,"name",t),(c=l(a)).source||(c.source=u.join("string"==typeof t?t:""))),e!==r?(d?!m&&e[t]&&(p=!0):delete e[t],p?e[t]=a:n(e,t,a)):p?e[t]=a:o(t,a)})(Function.prototype,"toString",(function(){return"function"==typeof this&&d(this).source||s(this)}))},function(e,t,a){var r,n,i,o=a(79),s=a(2),c=a(9),d=a(12),l=a(7),u=a(20),p=a(38),m=a(21),h=s.WeakMap;if(o){var f=u.state||(u.state=new h),y=f.get,b=f.has,v=f.set;r=function(e,t){return t.facade=e,v.call(f,e,t),t},n=function(e){return y.call(f,e)||{}},i=function(e){return b.call(f,e)}}else{var g=p("state");m[g]=!0,r=function(e,t){return t.facade=e,d(e,g,t),t},n=function(e){return l(e,g)?e[g]:{}},i=function(e){return l(e,g)}}e.exports={set:r,get:n,has:i,enforce:function(e){return i(e)?n(e):r(e,{})},getterFor:function(e){return function(t){var a;if(!c(t)||(a=n(t)).type!==e)throw TypeError("Incompatible receiver, "+e+" required");return a}}}},function(e,t,a){var r=a(2),n=a(37),i=r.WeakMap;e.exports="function"===typeof i&&/native code/.test(n(i))},function(e,t){e.exports=!1},function(e,t,a){var r=a(7),n=a(82),i=a(29),o=a(13);e.exports=function(e,t){for(var a=n(t),s=o.f,c=i.f,d=0;d<a.length;d++){var l=a[d];r(e,l)||s(e,l,c(t,l))}}},function(e,t,a){var r=a(41),n=a(83),i=a(46),o=a(14);e.exports=r("Reflect","ownKeys")||function(e){var t=n.f(o(e)),a=i.f;return a?t.concat(a(e)):t}},function(e,t,a){var r=a(42),n=a(23).concat("length","prototype");t.f=Object.getOwnPropertyNames||function(e){return r(e,n)}},function(e,t,a){var r=a(45),n=Math.max,i=Math.min;e.exports=function(e,t){var a=r(e);return a<0?n(a+t,0):i(a,t)}},function(e,t,a){var r=a(4),n=/#|\.prototype\./,i=function(e,t){var a=s[o(e)];return a==d||a!=c&&("function"==typeof t?r(t):!!t)},o=i.normalize=function(e){return String(e).replace(n,".").toLowerCase()},s=i.data={},c=i.NATIVE="N",d=i.POLYFILL="P";e.exports=i},function(e,t,a){"use strict";var r=a(6),n=a(4),i=a(24),o=a(46),s=a(30),c=a(25),d=a(18),l=Object.assign,u=Object.defineProperty;e.exports=!l||n((function(){if(r&&1!==l({b:1},l(u({},"a",{enumerable:!0,get:function(){u(this,"b",{value:3,enumerable:!1})}}),{b:2})).b)return!0;var e={},t={},a=Symbol(),n="abcdefghijklmnopqrst";return e[a]=7,n.split("").forEach((function(e){t[e]=e})),7!=l({},e)[a]||i(l({},t)).join("")!=n}))?function(e,t){for(var a=c(e),n=arguments.length,l=1,u=o.f,p=s.f;n>l;)for(var m,h=d(arguments[l++]),f=u?i(h).concat(u(h)):i(h),y=f.length,b=0;y>b;)m=f[b++],r&&!p.call(h,m)||(a[m]=h[m]);return a}:l},function(e,t,a){a(88);var r=a(22);e.exports=r.Object.keys},function(e,t,a){var r=a(8),n=a(25),i=a(24);r({target:"Object",stat:!0,forced:a(4)((function(){i(1)}))},{keys:function(e){return i(n(e))}})},function(e,t,a){a(90);var r=a(27);e.exports=r("Array","includes")},function(e,t,a){"use strict";var r=a(8),n=a(43).includes,i=a(26);r({target:"Array",proto:!0},{includes:function(e){return n(this,e,arguments.length>1?arguments[1]:void 0)}}),i("includes")},function(e,t,a){var r=a(48);e.exports=r&&!Symbol.sham&&"symbol"==typeof Symbol.iterator},function(e,t,a){var r,n=a(14),i=a(93),o=a(23),s=a(21),c=a(94),d=a(36),l=a(38),u=l("IE_PROTO"),p=function(){},m=function(e){return"<script>"+e+"</"+"script>"},h=function(){try{r=document.domain&&new ActiveXObject("htmlfile")}catch(e){}var e,t;h=r?function(e){e.write(m("")),e.close();var t=e.parentWindow.Object;return e=null,t}(r):((t=d("iframe")).style.display="none",c.appendChild(t),t.src=String("javascript:"),(e=t.contentWindow.document).open(),e.write(m("document.F=Object")),e.close(),e.F);for(var a=o.length;a--;)delete h.prototype[o[a]];return h()};s[u]=!0,e.exports=Object.create||function(e,t){var a;return null!==e?(p.prototype=n(e),a=new p,p.prototype=null,a[u]=e):a=h(),void 0===t?a:i(a,t)}},function(e,t,a){var r=a(6),n=a(13),i=a(14),o=a(24);e.exports=r?Object.defineProperties:function(e,t){i(e);for(var a,r=o(t),s=r.length,c=0;s>c;)n.f(e,a=r[c++],t[a]);return e}},function(e,t,a){var r=a(41);e.exports=r("document","documentElement")},function(e,t){e.exports=function(e){if("function"!=typeof e)throw TypeError(String(e)+" is not a function");return e}},function(e,t,a){a(97);var r=a(27);e.exports=r("Array","find")},function(e,t,a){"use strict";var r=a(8),n=a(50).find,i=a(26),o="find",s=!0;o in[]&&Array(1).find((function(){s=!1})),r({target:"Array",proto:!0,forced:s},{find:function(e){return n(this,e,arguments.length>1?arguments[1]:void 0)}}),i(o)},function(e,t,a){var r=a(9),n=a(99),i=a(47)("species");e.exports=function(e,t){var a;return n(e)&&("function"!=typeof(a=e.constructor)||a!==Array&&!n(a.prototype)?r(a)&&null===(a=a[i])&&(a=void 0):a=void 0),new(void 0===a?Array:a)(0===t?0:t)}},function(e,t,a){var r=a(32);e.exports=Array.isArray||function(e){return"Array"==r(e)}},function(e,t,a){a(101);var r=a(27);e.exports=r("Array","findIndex")},function(e,t,a){"use strict";var r=a(8),n=a(50).findIndex,i=a(26),o="findIndex",s=!0;o in[]&&Array(1).findIndex((function(){s=!1})),r({target:"Array",proto:!0,forced:s},{findIndex:function(e){return n(this,e,arguments.length>1?arguments[1]:void 0)}}),i(o)},function(e,t,a){"use strict";var r=a(103);e.exports=r;var n=l(!0),i=l(!1),o=l(null),s=l(void 0),c=l(0),d=l("");function l(e){var t=new r(r._0);return t._V=1,t._W=e,t}r.resolve=function(e){if(e instanceof r)return e;if(null===e)return o;if(void 0===e)return s;if(!0===e)return n;if(!1===e)return i;if(0===e)return c;if(""===e)return d;if("object"===typeof e||"function"===typeof e)try{var t=e.then;if("function"===typeof t)return new r(t.bind(e))}catch(e){return new r((function(t,a){a(e)}))}return l(e)};var u=function(e){return"function"===typeof Array.from?(u=Array.from,Array.from(e)):(u=function(e){return Array.prototype.slice.call(e)},Array.prototype.slice.call(e))};r.all=function(e){var t=u(e);return new r((function(e,a){if(0===t.length)return e([]);var n=t.length;function i(o,s){if(s&&("object"===typeof s||"function"===typeof s)){if(s instanceof r&&s.then===r.prototype.then){for(;3===s._V;)s=s._W;return 1===s._V?i(o,s._W):(2===s._V&&a(s._W),void s.then((function(e){i(o,e)}),a))}var c=s.then;if("function"===typeof c)return void new r(c.bind(s)).then((function(e){i(o,e)}),a)}t[o]=s,0===--n&&e(t)}for(var o=0;o<t.length;o++)i(o,t[o])}))},r.reject=function(e){return new r((function(t,a){a(e)}))},r.race=function(e){return new r((function(t,a){u(e).forEach((function(e){r.resolve(e).then(t,a)}))}))},r.prototype.catch=function(e){return this.then(null,e)}},function(e,t,a){"use strict";var r=a(104);function n(){}var i=null,o={};function s(e){if("object"!==typeof this)throw new TypeError("Promises must be constructed via new");if("function"!==typeof e)throw new TypeError("Promise constructor's argument is not a function");this._U=0,this._V=0,this._W=null,this._X=null,e!==n&&m(e,this)}function c(e,t){for(;3===e._V;)e=e._W;if(s._Y&&s._Y(e),0===e._V)return 0===e._U?(e._U=1,void(e._X=t)):1===e._U?(e._U=2,void(e._X=[e._X,t])):void e._X.push(t);!function(e,t){r((function(){var a=1===e._V?t.onFulfilled:t.onRejected;if(null!==a){var r=function(e,t){try{return e(t)}catch(e){return i=e,o}}(a,e._W);r===o?l(t.promise,i):d(t.promise,r)}else 1===e._V?d(t.promise,e._W):l(t.promise,e._W)}))}(e,t)}function d(e,t){if(t===e)return l(e,new TypeError("A promise cannot be resolved with itself."));if(t&&("object"===typeof t||"function"===typeof t)){var a=function(e){try{return e.then}catch(e){return i=e,o}}(t);if(a===o)return l(e,i);if(a===e.then&&t instanceof s)return e._V=3,e._W=t,void u(e);if("function"===typeof a)return void m(a.bind(t),e)}e._V=1,e._W=t,u(e)}function l(e,t){e._V=2,e._W=t,s._Z&&s._Z(e,t),u(e)}function u(e){if(1===e._U&&(c(e,e._X),e._X=null),2===e._U){for(var t=0;t<e._X.length;t++)c(e,e._X[t]);e._X=null}}function p(e,t,a){this.onFulfilled="function"===typeof e?e:null,this.onRejected="function"===typeof t?t:null,this.promise=a}function m(e,t){var a=!1,r=function(e,t,a){try{e(t,a)}catch(e){return i=e,o}}(e,(function(e){a||(a=!0,d(t,e))}),(function(e){a||(a=!0,l(t,e))}));a||r!==o||(a=!0,l(t,i))}e.exports=s,s._Y=null,s._Z=null,s._0=n,s.prototype.then=function(e,t){if(this.constructor!==s)return function(e,t,a){return new e.constructor((function(r,i){var o=new s(n);o.then(r,i),c(e,new p(t,a,o))}))}(this,e,t);var a=new s(n);return c(this,new p(e,t,a)),a}},function(e,t,a){"use strict";(function(t){function a(e){n.length||(r(),!0),n[n.length]=e}e.exports=a;var r,n=[],i=0;function o(){for(;i<n.length;){var e=i;if(i+=1,n[e].call(),i>1024){for(var t=0,a=n.length-i;t<a;t++)n[t]=n[t+i];n.length-=i,i=0}}n.length=0,i=0,!1}var s,c,d,l="undefined"!==typeof t?t:self,u=l.MutationObserver||l.WebKitMutationObserver;function p(e){return function(){var t=setTimeout(r,0),a=setInterval(r,50);function r(){clearTimeout(t),clearInterval(a),e()}}}"function"===typeof u?(s=1,c=new u(o),d=document.createTextNode(""),c.observe(d,{characterData:!0}),r=function(){s=-s,d.data=s}):r=p(o),a.requestFlush=r,a.makeRequestCallFromTimer=p}).call(this,a(28))},function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t,a){"use strict";a.r(t);var r="undefined"!==typeof globalThis&&globalThis||"undefined"!==typeof self&&self||"undefined"!==typeof r&&r,n="URLSearchParams"in r,i="Symbol"in r&&"iterator"in Symbol,o="FileReader"in r&&"Blob"in r&&function(){try{return new Blob,!0}catch(e){return!1}}(),s="FormData"in r,c="ArrayBuffer"in r;if(c)var d=["[object Int8Array]","[object Uint8Array]","[object Uint8ClampedArray]","[object Int16Array]","[object Uint16Array]","[object Int32Array]","[object Uint32Array]","[object Float32Array]","[object Float64Array]"],l=ArrayBuffer.isView||function(e){return e&&d.indexOf(Object.prototype.toString.call(e))>-1};function u(e){if("string"!==typeof e&&(e=String(e)),/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(e)||""===e)throw new TypeError('Invalid character in header field name: "'+e+'"');return e.toLowerCase()}function p(e){return"string"!==typeof e&&(e=String(e)),e}function m(e){var t={next:function(){var t=e.shift();return{done:void 0===t,value:t}}};return i&&(t[Symbol.iterator]=function(){return t}),t}function h(e){this.map={},e instanceof h?e.forEach((function(e,t){this.append(t,e)}),this):Array.isArray(e)?e.forEach((function(e){this.append(e[0],e[1])}),this):e&&Object.getOwnPropertyNames(e).forEach((function(t){this.append(t,e[t])}),this)}function f(e){if(e.bodyUsed)return Promise.reject(new TypeError("Already read"));e.bodyUsed=!0}function y(e){return new Promise((function(t,a){e.onload=function(){t(e.result)},e.onerror=function(){a(e.error)}}))}function b(e){var t=new FileReader,a=y(t);return t.readAsArrayBuffer(e),a}function v(e){if(e.slice)return e.slice(0);var t=new Uint8Array(e.byteLength);return t.set(new Uint8Array(e)),t.buffer}function g(){return this.bodyUsed=!1,this._initBody=function(e){var t;this.bodyUsed=this.bodyUsed,this._bodyInit=e,e?"string"===typeof e?this._bodyText=e:o&&Blob.prototype.isPrototypeOf(e)?this._bodyBlob=e:s&&FormData.prototype.isPrototypeOf(e)?this._bodyFormData=e:n&&URLSearchParams.prototype.isPrototypeOf(e)?this._bodyText=e.toString():c&&o&&((t=e)&&DataView.prototype.isPrototypeOf(t))?(this._bodyArrayBuffer=v(e.buffer),this._bodyInit=new Blob([this._bodyArrayBuffer])):c&&(ArrayBuffer.prototype.isPrototypeOf(e)||l(e))?this._bodyArrayBuffer=v(e):this._bodyText=e=Object.prototype.toString.call(e):this._bodyText="";var a=this.headers.get("content-type");a?a.indexOf("json")>=0&&"string"!==typeof this._bodyInit&&(this._bodyInit=this._bodyText):"string"===typeof e?this.headers.set("content-type","text/plain;charset=UTF-8"):this._bodyBlob&&this._bodyBlob.type?this.headers.set("content-type",this._bodyBlob.type):n&&URLSearchParams.prototype.isPrototypeOf(e)&&this.headers.set("content-type","application/x-www-form-urlencoded;charset=UTF-8")},o&&(this.blob=function(){var e=f(this);if(e)return e;if(this._bodyBlob)return Promise.resolve(this._bodyBlob);if(this._bodyArrayBuffer)return Promise.resolve(new Blob([this._bodyArrayBuffer]));if(this._bodyFormData)throw new Error("could not read FormData body as blob");return Promise.resolve(new Blob([this._bodyText]))},this.arrayBuffer=function(){if(this._bodyArrayBuffer){var e=f(this);return e||(ArrayBuffer.isView(this._bodyArrayBuffer)?Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset,this._bodyArrayBuffer.byteOffset+this._bodyArrayBuffer.byteLength)):Promise.resolve(this._bodyArrayBuffer))}return this.blob().then(b)}),this.text=function(){var e,t,a,r=f(this);if(r)return r;if(this._bodyBlob)return e=this._bodyBlob,t=new FileReader,a=y(t),t.readAsText(e),a;if(this._bodyArrayBuffer)return Promise.resolve(function(e){for(var t=new Uint8Array(e),a=new Array(t.length),r=0;r<t.length;r++)a[r]=String.fromCharCode(t[r]);return a.join("")}(this._bodyArrayBuffer));if(this._bodyFormData)throw new Error("could not read FormData body as text");return Promise.resolve(this._bodyText)},s&&(this.formData=function(){return this.text().then(_)}),this.json=function(){return this.text().then(JSON.parse)},this}h.prototype.append=function(e,t){e=u(e),t=p(t);var a=this.map[e];this.map[e]=a?a+", "+t:t},h.prototype.delete=function(e){delete this.map[u(e)]},h.prototype.get=function(e){return e=u(e),this.has(e)?this.map[e]:null},h.prototype.has=function(e){return this.map.hasOwnProperty(u(e))},h.prototype.set=function(e,t){this.map[u(e)]=p(t)},h.prototype.forEach=function(e,t){for(var a in this.map)this.map.hasOwnProperty(a)&&e.call(t,this.map[a],a,this)},h.prototype.keys=function(){var e=[];return this.forEach((function(t,a){e.push(a)})),m(e)},h.prototype.values=function(){var e=[];return this.forEach((function(t){e.push(t)})),m(e)},h.prototype.entries=function(){var e=[];return this.forEach((function(t,a){e.push([a,t])})),m(e)},i&&(h.prototype[Symbol.iterator]=h.prototype.entries);var k=["DELETE","GET","HEAD","OPTIONS","POST","PUT"];function C(e,t){if(!(this instanceof C))throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');var a,r,n=(t=t||{}).body;if(e instanceof C){if(e.bodyUsed)throw new TypeError("Already read");this.url=e.url,this.credentials=e.credentials,t.headers||(this.headers=new h(e.headers)),this.method=e.method,this.mode=e.mode,this.signal=e.signal,n||null==e._bodyInit||(n=e._bodyInit,e.bodyUsed=!0)}else this.url=String(e);if(this.credentials=t.credentials||this.credentials||"same-origin",!t.headers&&this.headers||(this.headers=new h(t.headers)),this.method=(a=t.method||this.method||"GET",r=a.toUpperCase(),k.indexOf(r)>-1?r:a),this.mode=t.mode||this.mode||null,this.signal=t.signal||this.signal,this.referrer=null,("GET"===this.method||"HEAD"===this.method)&&n)throw new TypeError("Body not allowed for GET or HEAD requests");if(this._initBody(n),("GET"===this.method||"HEAD"===this.method)&&("no-store"===t.cache||"no-cache"===t.cache)){var i=/([?&])_=[^&]*/;if(i.test(this.url))this.url=this.url.replace(i,"$1_="+(new Date).getTime());else{this.url+=(/\?/.test(this.url)?"&":"?")+"_="+(new Date).getTime()}}}function _(e){var t=new FormData;return e.trim().split("&").forEach((function(e){if(e){var a=e.split("="),r=a.shift().replace(/\+/g," "),n=a.join("=").replace(/\+/g," ");t.append(decodeURIComponent(r),decodeURIComponent(n))}})),t}function N(e,t){if(!(this instanceof N))throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');t||(t={}),this.type="default",this.status=void 0===t.status?200:t.status,this.ok=this.status>=200&&this.status<300,this.statusText=void 0===t.statusText?"":""+t.statusText,this.headers=new h(t.headers),this.url=t.url||"",this._initBody(e)}C.prototype.clone=function(){return new C(this,{body:this._bodyInit})},g.call(C.prototype),g.call(N.prototype),N.prototype.clone=function(){return new N(this._bodyInit,{status:this.status,statusText:this.statusText,headers:new h(this.headers),url:this.url})},N.error=function(){var e=new N(null,{status:0,statusText:""});return e.type="error",e};var w=[301,302,303,307,308];N.redirect=function(e,t){if(-1===w.indexOf(t))throw new RangeError("Invalid status code");return new N(null,{status:t,headers:{location:e}})};var P=r.DOMException;try{new P}catch(e){(P=function(e,t){this.message=e,this.name=t;var a=Error(e);this.stack=a.stack}).prototype=Object.create(Error.prototype),P.prototype.constructor=P}function F(e,t){return new Promise((function(a,n){var i=new C(e,t);if(i.signal&&i.signal.aborted)return n(new P("Aborted","AbortError"));var s=new XMLHttpRequest;function d(){s.abort()}s.onload=function(){var e,t,r={status:s.status,statusText:s.statusText,headers:(e=s.getAllResponseHeaders()||"",t=new h,e.replace(/\r?\n[\t ]+/g," ").split("\r").map((function(e){return 0===e.indexOf("\n")?e.substr(1,e.length):e})).forEach((function(e){var a=e.split(":"),r=a.shift().trim();if(r){var n=a.join(":").trim();t.append(r,n)}})),t)};r.url="responseURL"in s?s.responseURL:r.headers.get("X-Request-URL");var n="response"in s?s.response:s.responseText;setTimeout((function(){a(new N(n,r))}),0)},s.onerror=function(){setTimeout((function(){n(new TypeError("Network request failed"))}),0)},s.ontimeout=function(){setTimeout((function(){n(new TypeError("Network request failed"))}),0)},s.onabort=function(){setTimeout((function(){n(new P("Aborted","AbortError"))}),0)},s.open(i.method,function(e){try{return""===e&&r.location.href?r.location.href:e}catch(t){return e}}(i.url),!0),"include"===i.credentials?s.withCredentials=!0:"omit"===i.credentials&&(s.withCredentials=!1),"responseType"in s&&(o?s.responseType="blob":c&&i.headers.get("Content-Type")&&-1!==i.headers.get("Content-Type").indexOf("application/octet-stream")&&(s.responseType="arraybuffer")),!t||"object"!==typeof t.headers||t.headers instanceof h?i.headers.forEach((function(e,t){s.setRequestHeader(t,e)})):Object.getOwnPropertyNames(t.headers).forEach((function(e){s.setRequestHeader(e,p(t.headers[e]))})),i.signal&&(i.signal.addEventListener("abort",d),s.onreadystatechange=function(){4===s.readyState&&i.signal.removeEventListener("abort",d)}),s.send("undefined"===typeof i._bodyInit?null:i._bodyInit)}))}F.polyfill=!0,r.fetch||(r.fetch=F,r.Headers=h,r.Request=C,r.Response=N);a(75),a(87),a(89),a(96),a(100);[Element.prototype,CharacterData.prototype,DocumentType.prototype].forEach((function(e){e.hasOwnProperty("remove")||Object.defineProperty(e,"remove",{configurable:!0,enumerable:!0,writable:!0,value:function(){null!==this.parentNode&&this.parentNode.removeChild(this)}})})),"undefined"===typeof Promise&&(window.Promise=a(102));var x=function(e,t){return(x=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var a in t)Object.prototype.hasOwnProperty.call(t,a)&&(e[a]=t[a])})(e,t)};function S(e,t){if("function"!==typeof t&&null!==t)throw new TypeError("Class extends value "+String(t)+" is not a constructor or null");function a(){this.constructor=e}x(e,t),e.prototype=null===t?Object.create(t):(a.prototype=t.prototype,new a)}var D=function(){return(D=Object.assign||function(e){for(var t,a=1,r=arguments.length;a<r;a++)for(var n in t=arguments[a])Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n]);return e}).apply(this,arguments)};function A(e,t){var a={};for(var r in e)Object.prototype.hasOwnProperty.call(e,r)&&t.indexOf(r)<0&&(a[r]=e[r]);if(null!=e&&"function"===typeof Object.getOwnPropertySymbols){var n=0;for(r=Object.getOwnPropertySymbols(e);n<r.length;n++)t.indexOf(r[n])<0&&Object.prototype.propertyIsEnumerable.call(e,r[n])&&(a[r[n]]=e[r[n]])}return a}function B(e,t,a,r){return new(a||(a=Promise))((function(n,i){function o(e){try{c(r.next(e))}catch(e){i(e)}}function s(e){try{c(r.throw(e))}catch(e){i(e)}}function c(e){var t;e.done?n(e.value):(t=e.value,t instanceof a?t:new a((function(e){e(t)}))).then(o,s)}c((r=r.apply(e,t||[])).next())}))}function T(e,t){var a,r,n,i,o={label:0,sent:function(){if(1&n[0])throw n[1];return n[1]},trys:[],ops:[]};return i={next:s(0),throw:s(1),return:s(2)},"function"===typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function s(i){return function(s){return function(i){if(a)throw new TypeError("Generator is already executing.");for(;o;)try{if(a=1,r&&(n=2&i[0]?r.return:i[0]?r.throw||((n=r.return)&&n.call(r),0):r.next)&&!(n=n.call(r,i[1])).done)return n;switch(r=0,n&&(i=[2&i[0],n.value]),i[0]){case 0:case 1:n=i;break;case 4:return o.label++,{value:i[1],done:!1};case 5:o.label++,r=i[1],i=[0];continue;case 7:i=o.ops.pop(),o.trys.pop();continue;default:if(!(n=(n=o.trys).length>0&&n[n.length-1])&&(6===i[0]||2===i[0])){o=0;continue}if(3===i[0]&&(!n||i[1]>n[0]&&i[1]<n[3])){o.label=i[1];break}if(6===i[0]&&o.label<n[1]){o.label=n[1],n=i;break}if(n&&o.label<n[2]){o.label=n[2],o.ops.push(i);break}n[2]&&o.ops.pop(),o.trys.pop();continue}i=t.call(e,o)}catch(e){i=[6,e],r=0}finally{a=n=0}if(5&i[0])throw i[1];return{value:i[0]?i[1]:void 0,done:!0}}([i,s])}}}Object.create;function z(){for(var e=0,t=0,a=arguments.length;t<a;t++)e+=arguments[t].length;var r=Array(e),n=0;for(t=0;t<a;t++)for(var i=arguments[t],o=0,s=i.length;o<s;o++,n++)r[n]=i[o];return r}Object.create;var M=a(15),I="en-US",j=M,E={"cs-CZ":a(52),"da-DK":a(53),"de-DE":a(54),"el-GR":a(55),"en-US":M,"es-ES":a(56),"fi-FI":a(57),"fr-FR":a(58),"hr-HR":a(59),"hu-HU":a(60),"it-IT":a(61),"ja-JP":a(62),"ko-KR":a(63),"nl-NL":a(64),"no-NO":a(65),"pl-PL":a(66),"pt-BR":a(67),"ro-RO":a(68),"ru-RU":a(69),"sk-SK":a(70),"sl-SI":a(71),"sv-SE":a(72),"zh-CN":a(73),"zh-TW":a(74)},O=function(e){return e.toLowerCase().substring(0,2)};function R(e){var t=e.replace("_","-");if(new RegExp("([a-z]{2})([-])([A-Z]{2})").test(t))return t;var a=t.split("-"),r=a[0],n=a[1];if(!r||!n)return null;var i=[r.toLowerCase(),n.toUpperCase()].join("-");return 5===i.length?i:null}function V(e,t){if(void 0===t&&(t=[]),!e||e.length<1||e.length>5)return I;var a=R(e);return t.indexOf(a)>-1?a:function(e,t){return e&&"string"===typeof e&&t.find((function(t){return O(t)===O(e)}))||null}(a||e,t)}var L,U,K,q,H,G=function(e,t){return e.replace(/%{(\w+)}/g,(function(e,a){return t[a]||""}))},Y={IDR:1,JPY:1,KRW:1,VND:1,BYR:1,CVE:1,DJF:1,GHC:1,GNF:1,KMF:1,PYG:1,RWF:1,UGX:1,VUV:1,XAF:1,XOF:1,XPF:1,MRO:10,BHD:1e3,JOD:1e3,KWD:1e3,OMR:1e3,LYD:1e3,TND:1e3},W=function(e,t){var a=function(e){return Y[e]||100}(t);return parseInt(String(e),10)/a},J=function(){function e(e,t){var a=this;void 0===e&&(e=I),void 0===t&&(t={}),this.translations=j;var r=Object.keys(E);this.customTranslations=function(e,t){return void 0===e&&(e={}),Object.keys(e).reduce((function(a,r){var n=R(r)||V(r,t);return n&&(a[n]=e[r]),a}),{})}(t,r);var n=Object.keys(this.customTranslations);this.supportedLocales=z(r,n).filter((function(e,t,a){return a.indexOf(e)===t})),this.locale=R(e)||V(e,this.supportedLocales)||I;var i=this.locale.split("-")[0];this.languageCode=i,this.loaded=function(e,t){return void 0===t&&(t={}),B(void 0,void 0,void 0,(function(){var a;return T(this,(function(r){return a=V(e,Object.keys(E))||I,[2,D(D(D({},j),E[a]),!!t[e]&&t[e])]}))}))}(this.locale,this.customTranslations).then((function(e){a.translations=e}))}return e.prototype.get=function(e,t){var a=function(e,t,a){void 0===a&&(a={values:{},count:0});var r=t+"__plural",n=function(e){return t+"__"+e};return Object.prototype.hasOwnProperty.call(e,n(a.count))?G(e[n(a.count)],a.values):Object.prototype.hasOwnProperty.call(e,r)&&a.count>1?G(e[r],a.values):Object.prototype.hasOwnProperty.call(e,t)?G(e[t],a.values):null}(this.translations,e,t);return null!==a?a:e},e.prototype.amount=function(e,t,a){return function(e,t,a,r){void 0===r&&(r={});var n=e.toString(),i=W(n,a),o=t.replace("_","-"),s=D({style:"currency",currency:a,currencyDisplay:"symbol"},r);try{return i.toLocaleString(o,s)}catch(e){return n}}(e,this.locale,t,a)},e.prototype.date=function(e,t){void 0===t&&(t={});var a=D({year:"numeric",month:"2-digit",day:"2-digit"},t);return new Date(e).toLocaleDateString(this.locale,a)},e}(),Z={},Q=[],$=/acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;function X(e,t){for(var a in t)e[a]=t[a];return e}function ee(e){var t=e.parentNode;t&&t.removeChild(e)}function te(e,t,a){var r,n,i,o=arguments,s={};for(i in t)"key"==i?r=t[i]:"ref"==i?n=t[i]:s[i]=t[i];if(arguments.length>3)for(a=[a],i=3;i<arguments.length;i++)a.push(o[i]);if(null!=a&&(s.children=a),"function"==typeof e&&null!=e.defaultProps)for(i in e.defaultProps)void 0===s[i]&&(s[i]=e.defaultProps[i]);return ae(e,s,r,n,null)}function ae(e,t,a,r,n){var i={type:e,props:t,key:a,ref:r,__k:null,__:null,__b:0,__e:null,__d:void 0,__c:null,__h:null,constructor:void 0,__v:null==n?++L.__v:n};return null!=L.vnode&&L.vnode(i),i}function re(e){return e.children}function ne(e,t){this.props=e,this.context=t}function ie(e,t){if(null==t)return e.__?ie(e.__,e.__.__k.indexOf(e)+1):null;for(var a;t<e.__k.length;t++)if(null!=(a=e.__k[t])&&null!=a.__e)return a.__e;return"function"==typeof e.type?ie(e):null}function oe(e){var t,a;if(null!=(e=e.__)&&null!=e.__c){for(e.__e=e.__c.base=null,t=0;t<e.__k.length;t++)if(null!=(a=e.__k[t])&&null!=a.__e){e.__e=e.__c.base=a.__e;break}return oe(e)}}function se(e){(!e.__d&&(e.__d=!0)&&U.push(e)&&!ce.__r++||q!==L.debounceRendering)&&((q=L.debounceRendering)||K)(ce)}function ce(){for(var e;ce.__r=U.length;)e=U.sort((function(e,t){return e.__v.__b-t.__v.__b})),U=[],e.some((function(e){var t,a,r,n,i,o;e.__d&&(i=(n=(t=e).__v).__e,(o=t.__P)&&(a=[],(r=X({},n)).__v=n.__v+1,be(o,n,r,t.__n,void 0!==o.ownerSVGElement,null!=n.__h?[i]:null,a,null==i?ie(n):i,n.__h),ve(a,n),n.__e!=i&&oe(n)))}))}function de(e,t,a,r,n,i,o,s,c,d){var l,u,p,m,h,f,y,b=r&&r.__k||Q,v=b.length;for(a.__k=[],l=0;l<t.length;l++)if(null!=(m=a.__k[l]=null==(m=t[l])||"boolean"==typeof m?null:"string"==typeof m||"number"==typeof m?ae(null,m,null,null,m):Array.isArray(m)?ae(re,{children:m},null,null,null):m.__b>0?ae(m.type,m.props,m.key,null,m.__v):m)){if(m.__=a,m.__b=a.__b+1,null===(p=b[l])||p&&m.key==p.key&&m.type===p.type)b[l]=void 0;else for(u=0;u<v;u++){if((p=b[u])&&m.key==p.key&&m.type===p.type){b[u]=void 0;break}p=null}be(e,m,p=p||Z,n,i,o,s,c,d),h=m.__e,(u=m.ref)&&p.ref!=u&&(y||(y=[]),p.ref&&y.push(p.ref,null,m),y.push(u,m.__c||h,m)),null!=h?(null==f&&(f=h),"function"==typeof m.type&&null!=m.__k&&m.__k===p.__k?m.__d=c=le(m,c,e):c=pe(e,m,p,b,h,c),d||"option"!==a.type?"function"==typeof a.type&&(a.__d=c):e.value=""):c&&p.__e==c&&c.parentNode!=e&&(c=ie(p))}for(a.__e=f,l=v;l--;)null!=b[l]&&("function"==typeof a.type&&null!=b[l].__e&&b[l].__e==a.__d&&(a.__d=ie(r,l+1)),Ce(b[l],b[l]));if(y)for(l=0;l<y.length;l++)ke(y[l],y[++l],y[++l])}function le(e,t,a){var r,n;for(r=0;r<e.__k.length;r++)(n=e.__k[r])&&(n.__=e,t="function"==typeof n.type?le(n,t,a):pe(a,n,n,e.__k,n.__e,t));return t}function ue(e,t){return t=t||[],null==e||"boolean"==typeof e||(Array.isArray(e)?e.some((function(e){ue(e,t)})):t.push(e)),t}function pe(e,t,a,r,n,i){var o,s,c;if(void 0!==t.__d)o=t.__d,t.__d=void 0;else if(null==a||n!=i||null==n.parentNode)e:if(null==i||i.parentNode!==e)e.appendChild(n),o=null;else{for(s=i,c=0;(s=s.nextSibling)&&c<r.length;c+=2)if(s==n)break e;e.insertBefore(n,i),o=i}return void 0!==o?o:n.nextSibling}function me(e,t,a){"-"===t[0]?e.setProperty(t,a):e[t]=null==a?"":"number"!=typeof a||$.test(t)?a:a+"px"}function he(e,t,a,r,n){var i;e:if("style"===t)if("string"==typeof a)e.style.cssText=a;else{if("string"==typeof r&&(e.style.cssText=r=""),r)for(t in r)a&&t in a||me(e.style,t,"");if(a)for(t in a)r&&a[t]===r[t]||me(e.style,t,a[t])}else if("o"===t[0]&&"n"===t[1])i=t!==(t=t.replace(/Capture$/,"")),t=t.toLowerCase()in e?t.toLowerCase().slice(2):t.slice(2),e.l||(e.l={}),e.l[t+i]=a,a?r||e.addEventListener(t,i?ye:fe,i):e.removeEventListener(t,i?ye:fe,i);else if("dangerouslySetInnerHTML"!==t){if(n)t=t.replace(/xlink[H:h]/,"h").replace(/sName$/,"s");else if("href"!==t&&"list"!==t&&"form"!==t&&"download"!==t&&t in e)try{e[t]=null==a?"":a;break e}catch(e){}"function"==typeof a||(null!=a&&(!1!==a||"a"===t[0]&&"r"===t[1])?e.setAttribute(t,a):e.removeAttribute(t))}}function fe(e){this.l[e.type+!1](L.event?L.event(e):e)}function ye(e){this.l[e.type+!0](L.event?L.event(e):e)}function be(e,t,a,r,n,i,o,s,c){var d,l,u,p,m,h,f,y,b,v,g,k=t.type;if(void 0!==t.constructor)return null;null!=a.__h&&(c=a.__h,s=t.__e=a.__e,t.__h=null,i=[s]),(d=L.__b)&&d(t);try{e:if("function"==typeof k){if(y=t.props,b=(d=k.contextType)&&r[d.__c],v=d?b?b.props.value:d.__:r,a.__c?f=(l=t.__c=a.__c).__=l.__E:("prototype"in k&&k.prototype.render?t.__c=l=new k(y,v):(t.__c=l=new ne(y,v),l.constructor=k,l.render=_e),b&&b.sub(l),l.props=y,l.state||(l.state={}),l.context=v,l.__n=r,u=l.__d=!0,l.__h=[]),null==l.__s&&(l.__s=l.state),null!=k.getDerivedStateFromProps&&(l.__s==l.state&&(l.__s=X({},l.__s)),X(l.__s,k.getDerivedStateFromProps(y,l.__s))),p=l.props,m=l.state,u)null==k.getDerivedStateFromProps&&null!=l.componentWillMount&&l.componentWillMount(),null!=l.componentDidMount&&l.__h.push(l.componentDidMount);else{if(null==k.getDerivedStateFromProps&&y!==p&&null!=l.componentWillReceiveProps&&l.componentWillReceiveProps(y,v),!l.__e&&null!=l.shouldComponentUpdate&&!1===l.shouldComponentUpdate(y,l.__s,v)||t.__v===a.__v){l.props=y,l.state=l.__s,t.__v!==a.__v&&(l.__d=!1),l.__v=t,t.__e=a.__e,t.__k=a.__k,l.__h.length&&o.push(l);break e}null!=l.componentWillUpdate&&l.componentWillUpdate(y,l.__s,v),null!=l.componentDidUpdate&&l.__h.push((function(){l.componentDidUpdate(p,m,h)}))}l.context=v,l.props=y,l.state=l.__s,(d=L.__r)&&d(t),l.__d=!1,l.__v=t,l.__P=e,d=l.render(l.props,l.state,l.context),l.state=l.__s,null!=l.getChildContext&&(r=X(X({},r),l.getChildContext())),u||null==l.getSnapshotBeforeUpdate||(h=l.getSnapshotBeforeUpdate(p,m)),g=null!=d&&d.type===re&&null==d.key?d.props.children:d,de(e,Array.isArray(g)?g:[g],t,a,r,n,i,o,s,c),l.base=t.__e,t.__h=null,l.__h.length&&o.push(l),f&&(l.__E=l.__=null),l.__e=!1}else null==i&&t.__v===a.__v?(t.__k=a.__k,t.__e=a.__e):t.__e=ge(a.__e,t,a,r,n,i,o,c);(d=L.diffed)&&d(t)}catch(e){t.__v=null,(c||null!=i)&&(t.__e=s,t.__h=!!c,i[i.indexOf(s)]=null),L.__e(e,t,a)}}function ve(e,t){L.__c&&L.__c(t,e),e.some((function(t){try{e=t.__h,t.__h=[],e.some((function(e){e.call(t)}))}catch(e){L.__e(e,t.__v)}}))}function ge(e,t,a,r,n,i,o,s){var c,d,l,u,p=a.props,m=t.props,h=t.type,f=0;if("svg"===h&&(n=!0),null!=i)for(;f<i.length;f++)if((c=i[f])&&(c===e||(h?c.localName==h:3==c.nodeType))){e=c,i[f]=null;break}if(null==e){if(null===h)return document.createTextNode(m);e=n?document.createElementNS("http://www.w3.org/2000/svg",h):document.createElement(h,m.is&&m),i=null,s=!1}if(null===h)p===m||s&&e.data===m||(e.data=m);else{if(i=i&&Q.slice.call(e.childNodes),d=(p=a.props||Z).dangerouslySetInnerHTML,l=m.dangerouslySetInnerHTML,!s){if(null!=i)for(p={},u=0;u<e.attributes.length;u++)p[e.attributes[u].name]=e.attributes[u].value;(l||d)&&(l&&(d&&l.__html==d.__html||l.__html===e.innerHTML)||(e.innerHTML=l&&l.__html||""))}if(function(e,t,a,r,n){var i;for(i in a)"children"===i||"key"===i||i in t||he(e,i,null,a[i],r);for(i in t)n&&"function"!=typeof t[i]||"children"===i||"key"===i||"value"===i||"checked"===i||a[i]===t[i]||he(e,i,t[i],a[i],r)}(e,m,p,n,s),l)t.__k=[];else if(f=t.props.children,de(e,Array.isArray(f)?f:[f],t,a,r,n&&"foreignObject"!==h,i,o,e.firstChild,s),null!=i)for(f=i.length;f--;)null!=i[f]&&ee(i[f]);s||("value"in m&&void 0!==(f=m.value)&&(f!==e.value||"progress"===h&&!f)&&he(e,"value",f,p.value,!1),"checked"in m&&void 0!==(f=m.checked)&&f!==e.checked&&he(e,"checked",f,p.checked,!1))}return e}function ke(e,t,a){try{"function"==typeof e?e(t):e.current=t}catch(e){L.__e(e,a)}}function Ce(e,t,a){var r,n,i;if(L.unmount&&L.unmount(e),(r=e.ref)&&(r.current&&r.current!==e.__e||ke(r,null,t)),a||"function"==typeof e.type||(a=null!=(n=e.__e)),e.__e=e.__d=void 0,null!=(r=e.__c)){if(r.componentWillUnmount)try{r.componentWillUnmount()}catch(e){L.__e(e,t)}r.base=r.__P=null}if(r=e.__k)for(i=0;i<r.length;i++)r[i]&&Ce(r[i],t,a);null!=n&&ee(n)}function _e(e,t,a){return this.constructor(e,a)}function Ne(e,t,a){var r,n,i;L.__&&L.__(e,t),n=(r="function"==typeof a)?null:a&&a.__k||t.__k,i=[],be(t,e=(!r&&a||t).__k=te(re,null,[e]),n||Z,Z,void 0!==t.ownerSVGElement,!r&&a?[a]:n?null:t.firstChild?Q.slice.call(t.childNodes):null,i,!r&&a?a:n?n.__e:t.firstChild,r),ve(i,e)}L={__e:function(e,t){for(var a,r,n;t=t.__;)if((a=t.__c)&&!a.__)try{if((r=a.constructor)&&null!=r.getDerivedStateFromError&&(a.setState(r.getDerivedStateFromError(e)),n=a.__d),null!=a.componentDidCatch&&(a.componentDidCatch(e),n=a.__d),n)return a.__E=a}catch(t){e=t}throw e},__v:0},ne.prototype.setState=function(e,t){var a;a=null!=this.__s&&this.__s!==this.state?this.__s:this.__s=X({},this.state),"function"==typeof e&&(e=e(X({},a),this.props)),e&&X(a,e),null!=e&&this.__v&&(t&&this.__h.push(t),se(this))},ne.prototype.forceUpdate=function(e){this.__v&&(this.__e=!0,e&&this.__h.push(e),se(this))},ne.prototype.render=re,U=[],K="function"==typeof Promise?Promise.prototype.then.bind(Promise.resolve()):setTimeout,ce.__r=0,H=0;var we=function(e,t){return t.split(".").reduce((function(e,t){return e&&e[t]?e[t]:void 0}),e)},Pe=function(){var e=this;this.events={},this.on=function(t,a){e.events[t]=e.events[t]||[],e.events[t].push(a)},this.off=function(t,a){e.events[t]&&(e.events[t]=e.events[t].reduce((function(e,t){return t!==a&&e.push(t),e}),[]))},this.emit=function(t,a){e.events[t]&&e.events[t].forEach((function(e){e(a)}))}};function Fe(){return"xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g,(function(e){var t=16*Math.random()|0;return("x"==e?t:3&t|8).toString(16)}))}var xe,Se,De,Ae=function(){function e(e){this._id=this.constructor.type+"-"+Fe(),this.eventEmitter=new Pe,this.props=this.formatProps(D(D({},this.constructor.defaultProps),e)),this._parentInstance=this.props._parentInstance,this._node=null,this.state={}}return e.prototype.formatProps=function(e){return e},e.prototype.formatData=function(){return{}},e.prototype.setState=function(e){this.state=D(D({},this.state),e)},Object.defineProperty(e.prototype,"data",{get:function(){var e=we(this.props,"modules.risk.data"),t=we(this.props,"modules.analytics.conversionId"),a=this.state.order||this.props.order;return D(D(D(D(D({},e&&{riskData:{clientData:e}}),t&&{conversionId:t}),a&&{order:{orderData:a.orderData,pspReference:a.pspReference}}),this.formatData()),{clientStateDataIndicator:!0})},enumerable:!1,configurable:!0}),e.prototype.render=function(){throw new Error("Payment method cannot be rendered.")},e.prototype.mount=function(e){var t="string"===typeof e?document.querySelector(e):e;if(!t)throw new Error("Component could not mount. Root node was not found.");if(this._node)throw new Error("Component is already mounted.");return this._node=t,this._component=this.render(),Ne(this._component,t),this.props.modules&&this.props.modules.analytics&&!this.props.isDropin&&this.props.modules.analytics.send({containerWidth:this._node&&this._node.offsetWidth,component:this.constructor.type,flavor:"components"}),this},e.prototype.update=function(e){return this.props=this.formatProps(D(D({},this.props),e)),this.state={},this.unmount().remount()},e.prototype.remount=function(e){if(!this._node)throw new Error("Component is not mounted.");return Ne(e||this.render(),this._node,null),this},e.prototype.unmount=function(){return this._node&&Ne(null,this._node),this},e.prototype.remove=function(){this.unmount(),this._parentInstance&&this._parentInstance.remove(this)},e.defaultProps={},e}(),Be="https://checkoutshopper-live.adyen.com/checkoutshopper/",Te=function(e){var t=e.name,a=e.loadingContext,r=e.imageFolder,n=void 0===r?"":r,i=e.parentFolder,o=void 0===i?"":i,s=e.extension,c=e.size,d=void 0===c?"":c,l=e.subFolder;return a+"images/"+n+(void 0===l?"":l)+o+t+d+"."+s},ze=function(e){var t=e.loadingContext,a=void 0===t?Be:t,r=e.extension,n=void 0===r?"svg":r,i=e.size,o=void 0===i?"3x":i,s=A(e,["loadingContext","extension","size"]);return function(e){var t=D({extension:n,loadingContext:a,imageFolder:"logos/",parentFolder:"",name:e},s);return Te("svg"!==n?D({size:"@"+o,subFolder:"small/"},t):t)}},Me=ze,Ie=a(0),je=a.n(Ie),Ee=(a(105),function(e){var t=e.inline,a=void 0!==t&&t,r=e.size;return te("div",{className:"adyen-checkout__spinner__wrapper "+(a?"adyen-checkout__spinner__wrapper--inline":"")},te("div",{className:"adyen-checkout__spinner adyen-checkout__spinner--"+(void 0===r?"large":r)}))}),Oe=0,Re=[],Ve=L.__b,Le=L.__r,Ue=L.diffed,Ke=L.__c,qe=L.unmount;function He(e,t){L.__h&&L.__h(Se,e,Oe||t),Oe=0;var a=Se.__H||(Se.__H={__:[],__h:[]});return e>=a.__.length&&a.__.push({}),a.__[e]}function Ge(e){return Oe=1,function(e,t,a){var r=He(xe++,2);return r.t=e,r.__c||(r.__=[a?a(t):at(void 0,t),function(e){var t=r.t(r.__[0],e);r.__[0]!==t&&(r.__=[t,r.__[1]],r.__c.setState({}))}],r.__c=Se),r.__}(at,e)}function Ye(e,t){var a=He(xe++,3);!L.__s&&tt(a.__H,t)&&(a.__=e,a.__H=t,Se.__H.__h.push(a))}function We(e,t){var a=He(xe++,4);!L.__s&&tt(a.__H,t)&&(a.__=e,a.__H=t,Se.__h.push(a))}function Je(e){return Oe=5,Ze((function(){return{current:e}}),[])}function Ze(e,t){var a=He(xe++,7);return tt(a.__H,t)&&(a.__=e(),a.__H=t,a.__h=e),a.__}function Qe(){Re.forEach((function(e){if(e.__P)try{e.__H.__h.forEach(Xe),e.__H.__h.forEach(et),e.__H.__h=[]}catch(t){e.__H.__h=[],L.__e(t,e.__v)}})),Re=[]}L.__b=function(e){Se=null,Ve&&Ve(e)},L.__r=function(e){Le&&Le(e),xe=0;var t=(Se=e.__c).__H;t&&(t.__h.forEach(Xe),t.__h.forEach(et),t.__h=[])},L.diffed=function(e){Ue&&Ue(e);var t=e.__c;t&&t.__H&&t.__H.__h.length&&(1!==Re.push(t)&&De===L.requestAnimationFrame||((De=L.requestAnimationFrame)||function(e){var t,a=function(){clearTimeout(r),$e&&cancelAnimationFrame(t),setTimeout(e)},r=setTimeout(a,100);$e&&(t=requestAnimationFrame(a))})(Qe)),Se=void 0},L.__c=function(e,t){t.some((function(e){try{e.__h.forEach(Xe),e.__h=e.__h.filter((function(e){return!e.__||et(e)}))}catch(a){t.some((function(e){e.__h&&(e.__h=[])})),t=[],L.__e(a,e.__v)}})),Ke&&Ke(e,t)},L.unmount=function(e){qe&&qe(e);var t=e.__c;if(t&&t.__H)try{t.__H.__.forEach(Xe)}catch(e){L.__e(e,t.__v)}};var $e="function"==typeof requestAnimationFrame;function Xe(e){var t=Se;"function"==typeof e.__c&&e.__c(),Se=t}function et(e){var t=Se;e.__c=e.__(),Se=t}function tt(e,t){return!e||e.length!==t.length||t.some((function(t,a){return t!==e[a]}))}function at(e,t){return"function"==typeof t?t(e):t}var rt=function(e,t){var a={__c:t="__cC"+H++,__:e,Consumer:function(e,t){return e.children(t)},Provider:function(e){var a,r;return this.getChildContext||(a=[],(r={})[t]=this,this.getChildContext=function(){return r},this.shouldComponentUpdate=function(e){this.props.value!==e.value&&a.some(se)},this.sub=function(e){a.push(e);var t=e.componentWillUnmount;e.componentWillUnmount=function(){a.splice(a.indexOf(e),1),t&&t.call(e)}}),e.children}};return a.Provider.__=a.Consumer.contextType=a}({i18n:new J,loadingContext:""});var nt=function(){return function(e){var t=Se.context[e.__c],a=He(xe++,9);return a.__c=e,t?(null==a.__&&(a.__=!0,t.sub(Se)),t.props.value):e.__}(rt)},it=(a(106),function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.onClick=function(e){e.preventDefault(),t.props.disabled||t.props.onClick(e,{complete:t.complete})},t.complete=function(e){void 0===e&&(e=1e3),t.setState({completed:!0}),setTimeout((function(){t.setState({completed:!1})}),e)},t}return S(t,e),t.prototype.render=function(e,t){var a=e.classNameModifiers,r=void 0===a?[]:a,n=e.disabled,i=e.href,o=e.icon,s=e.secondary,c=e.inline,d=e.label,l=e.status,u=t.completed,p=nt().i18n,m=o?te("img",{className:"adyen-checkout__button__icon",src:o,alt:"","aria-hidden":"true"}):"",h=z(r,c?["inline"]:[],u?["completed"]:[],s?["secondary"]:[],"loading"===l||"redirect"===l?["loading"]:[]),f=je()(z(["adyen-checkout__button"],h.map((function(e){return"adyen-checkout__button--"+e})))),y={loading:te(Ee,{size:"medium"}),redirect:te("span",{className:"adyen-checkout__button__content"},te(Ee,{size:"small",inline:!0}),p.get("payButton.redirecting")),default:te("span",{className:"adyen-checkout__button__content"},m,te("span",{className:"adyen-checkout__button__text"},d))},b=y[l]||y.default;return i?te("a",{className:f,href:i,disabled:n,target:this.props.target,rel:this.props.rel},b):te("button",{className:f,type:"button",disabled:n,onClick:this.onClick},b)},t.defaultProps={status:"default",disabled:!1,label:"",secondary:!1,inline:!1,target:"_self",onClick:function(){}},t}(ne)),ot=function(e){var t=e.amount,a=e.classNameModifiers,r=void 0===a?[]:a,n=e.label,i=A(e,["amount","classNameModifiers","label"]),o=nt().i18n,s=t&&{}.hasOwnProperty.call(t,"value")&&0===t.value?o.get("confirmPreauthorization"):o.get("payButton")+" "+((null===t||void 0===t?void 0:t.value)&&(null===t||void 0===t?void 0:t.currency)?o.amount(t.value,t.currency):"");return te(it,D({},i,{classNameModifiers:z(r,["pay"]),label:n||s}))},st=function(e){function t(t){var a=e.call(this,t)||this;return a.payButton=function(e){return te(ot,D({},e,{amount:a.props.amount,onClick:a.submit}))},a.submit=a.submit.bind(a),a.setState=a.setState.bind(a),a.onValid=a.onValid.bind(a),a.onComplete=a.onComplete.bind(a),a.handleAction=a.handleAction.bind(a),a.elementRef=t&&t.elementRef||a,a}return S(t,e),t.prototype.setState=function(e){this.state=D(D({},this.state),e),this.onChange()},t.prototype.onChange=function(){var e=this.isValid,t={data:this.data,isValid:e};return this.props.onChange&&this.props.onChange(t,this),e&&this.onValid(),t},t.prototype.onValid=function(){var e={data:this.data};return this.props.onValid&&this.props.onValid(e,this),e},t.prototype.startPayment=function(){return Promise.resolve(!0)},t.prototype.submit=function(){var e=this,t=this.props,a=t.onError,r=void 0===a?function(){}:a,n=t.onSubmit,i=void 0===n?function(){}:n;this.startPayment().then((function(){var t=e,a=t.data,r=t.isValid;return r?i({data:a,isValid:r},e):(e.showValidation(),!1)})).catch((function(e){return r(e)}))},t.prototype.onComplete=function(e){this.props.onComplete&&this.props.onComplete(e,this)},t.prototype.showValidation=function(){return this.componentRef&&this.componentRef.showValidation&&this.componentRef.showValidation(),this},t.prototype.setStatus=function(e){return this.componentRef&&this.componentRef.setStatus&&this.componentRef.setStatus(e),this},t.prototype.handleAction=function(e){var t=this;if(!e||!e.type)throw new Error("Invalid Action");var a=this.props.createFromAction(e,D(D({},this.props),{onAdditionalDetails:function(e){return t.props.onAdditionalDetails(e,t.elementRef)}}));return a?(this.unmount(),a.mount(this._node),a):null},Object.defineProperty(t.prototype,"isValid",{get:function(){return!1},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"icon",{get:function(){return Me({loadingContext:this.props.loadingContext})(this.constructor.type)},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"displayName",{get:function(){return this.props.name||this.constructor.type},enumerable:!1,configurable:!0}),t}(Ae),ct=st,dt=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return S(t,e),t.prototype.iframeOnLoad=function(){this.props.callback&&"function"===typeof this.props.callback&&this.props.callback(this.iframeEl.contentWindow)},t.prototype.componentDidMount=function(){this.iframeEl.addEventListener?this.iframeEl.addEventListener("load",this.iframeOnLoad.bind(this),!1):this.iframeEl.attachEvent?this.iframeEl.attachEvent("onload",this.iframeOnLoad.bind(this)):this.iframeEl.onload=this.iframeOnLoad.bind(this)},t.prototype.componentWillUnmount=function(){this.iframeEl.removeEventListener?this.iframeEl.removeEventListener("load",this.iframeOnLoad.bind(this),!1):this.iframeEl.detachEvent?this.iframeEl.detachEvent("onload",this.iframeOnLoad.bind(this)):this.iframeEl.onload=null},t.prototype.render=function(e){var t=this,a=e.name,r=e.src,n=e.width,i=e.height,o=e.minWidth,s=e.minHeight,c=e.border;return te("iframe",{ref:function(e){t.iframeEl=e},allow:e.allow,className:"adyen-checkout__iframe adyen-checkout__iframe--"+a,name:a,src:r,width:n,height:i,"min-width":o,"min-height":s,border:c,style:{border:0},frameBorder:"0",title:e.title,referrerpolicy:"origin"})},t.defaultProps={width:"0",height:"0",minWidth:"0",minHeight:"0",border:"0",src:null,allow:null,title:"components iframe"},t}(ne),lt=function(e,t,a){var r;return{promise:new Promise((function(n,i){r=setTimeout((function(){i(a)}),e),t.then((function(e){clearTimeout(r),n(e)})).catch((function(e){clearTimeout(r),i(e)}))})),cancel:function(){clearTimeout(r)}}},ut="deviceFingerprint",pt={result:{type:ut,value:"df-timedOut"},errorCode:"timeout"},mt={result:{type:ut,value:"df-failed"}},ht="unknownError",ft={timeout:"iframe loading timed out",wrongOrigin:"Result did not come from the expected origin",wrongDataType:"Result data was not of the expected type",missingProperty:"Result data did not contain the expected properties",unknownError:"An unknown error occurred"},yt=function(e,t,a,r,n){return function(i){var o=D({},r);if((i.origin||i.originalEvent.origin)!==e)return"Message was not sent from the expected domain";if("string"!==typeof i.data)return"Event data was not of type string";if(!i.data.length)return"Invalid event data string";try{var s=JSON.parse(i.data);if(!Object.prototype.hasOwnProperty.call(s,"type")||s.type!==n)return"Event data was not of expected type";t(s)}catch(e){return a(o),!1}return!0}},bt=function(e){var t=/^(?:([A-Za-z]+):)?(\/{0,3})([0-9.\-A-Za-z]+)(?::(\d+))?(?:\/([^?#]*))?(?:\?([^#]*))?(?:#(.*))?$/.exec(e);if(!t)return null;var a=t[1],r=t[2],n=t[3],i=t[4];return a&&r&&n?a+":"+r+n+(i?":"+i:""):null},vt=function(e){function t(t){var a=e.call(this,t)||this;return a.postMessageDomain=bt(a.props.loadingContext)||a.props.loadingContext,a}return S(t,e),t.prototype.getDfpPromise=function(){var e=this;return new Promise((function(t,a){e.processMessageHandler=yt(e.postMessageDomain,t,a,mt,ut),window.addEventListener("message",e.processMessageHandler)}))},t.prototype.componentDidMount=function(){var e=this;this.deviceFingerPrintPromise=lt(2e4,this.getDfpPromise(),pt),this.deviceFingerPrintPromise.promise.then((function(t){e.props.onCompleteFingerprint(t),window.removeEventListener("message",e.processMessageHandler)})).catch((function(t){e.props.onErrorFingerprint(t),window.removeEventListener("message",e.processMessageHandler)}))},t.prototype.render=function(e){var t=e.dfpURL;return te("div",{className:"adyen-checkout-risk__device-fingerprint"},te(dt,{name:"dfIframe",src:t,allow:"geolocation; microphone; camera;",title:"devicefingerprinting iframe"}))},t}(ne),gt=function(e){return{errorCode:e,message:ft[e]||ft[ht],type:ut}},kt=function(e){function t(t){var a=e.call(this,t)||this,r=t.clientKey||t.originKey;return r&&(a.state={status:"retrievingFingerPrint",dfpURL:a.props.loadingContext+"assets/html/"+r+"/dfp.1.0.0.html"}),a}return S(t,e),t.prototype.setStatusComplete=function(e){var t=this;this.setState({status:"complete"},(function(){t.props.onComplete(e)}))},t.prototype.render=function(e,t){var a=this,r=e.loadingContext,n=t.dfpURL;return"retrievingFingerPrint"===this.state.status?te("div",{className:"adyen-checkout-risk__device-fingerprint--wrapper",style:{position:"absolute",width:0,height:0}},te(vt,{loadingContext:r,dfpURL:n,onCompleteFingerprint:function(e){a.setStatusComplete(e)},onErrorFingerprint:function(e){a.props.onError(gt(e.errorCode)),a.setStatusComplete(e.result)}})):null},t.defaultProps={onComplete:function(){},onError:function(){}},t}(ne),Ct=window.atob,_t=window.btoa,Nt={decode:function(e){return!!Nt.isBase64(e)&&(!!Nt.isBase64(e)&&(t=e,decodeURIComponent(Array.prototype.map.call(Ct(t),(function(e){return"%"+("00"+e.charCodeAt(0).toString(16)).slice(-2)})).join(""))));var t},encode:function(e){return _t(e)},isBase64:function(e){return!!e&&(!(e.length%4)&&_t(Ct(e))===e)}},wt=Nt,Pt=function(e){function t(t){var a,r=e.call(this,t)||this;r.nodeRiskContainer=null,r.onComplete=function(e){var t,a=D(D({},r.state.data),((t={})[e.type]=e.value,t.persistentCookie=e.persistentCookie,t.components=e.components,t));r.setState({data:a,isValid:!0}),r.props.risk.onComplete(r.data),r.cleanUp()},r.onError=function(e){r.props.risk.onError(e),r.cleanUp()},r.cleanUp=function(){r.nodeRiskContainer&&r.nodeRiskContainer.remove()};var n=((a={}).deviceFingerprint=null,a);return r.setState({data:n}),!0===r.props.risk.enabled&&(document.querySelector(r.props.risk.node)?(r.nodeRiskContainer=document.createElement("div"),document.querySelector(r.props.risk.node).appendChild(r.nodeRiskContainer),r.mount(r.nodeRiskContainer)):r.onError({message:"RiskModule node was not found"})),r}return S(t,e),t.prototype.formatProps=function(e){return D(D({},e),{risk:D(D({},t.defaultProps.risk),e.risk)})},Object.defineProperty(t.prototype,"isValid",{get:function(){return this.state.isValid},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"data",{get:function(){if(this.isValid){var e=D({version:"1.0.0"},this.state.data);return wt.encode(JSON.stringify(e))}return!1},enumerable:!1,configurable:!0}),t.prototype.componentWillUnmount=function(){this.cleanUp()},t.prototype.render=function(){return te(kt,D({},this.props,{loadingContext:this.props.loadingContext,onComplete:this.onComplete,onError:this.onError}))},t.type="risk",t.defaultProps={risk:{enabled:!0,onComplete:function(){},onError:function(){},node:"body"}},t}(Ae);a(107);function Ft(e){var t=e.children,a=e.classNameModifiers,r=void 0===a?[]:a,n=e.label,i=e.readonly,o=void 0!==i&&i,s=nt().i18n;return te("div",{className:je()(z(["adyen-checkout__fieldset"],r.map((function(e){return"adyen-checkout__fieldset--"+e})),[{"adyen-checkout__fieldset--readonly":o}]))},n&&te("div",{className:"adyen-checkout__fieldset__title"},s.get(n)),te("div",{className:"adyen-checkout__fieldset__fields"},t))}a(108);var xt=function(e){var t=e.type,a=e.className,r=void 0===a?"":a,n=nt().loadingContext,i=Me({loadingContext:n,imageFolder:"components/"})(t);return te("img",{className:je()("adyen-checkout__icon",r),alt:t,src:i})},St=function(e){function t(t){var a=e.call(this,t)||this;return a.state={focused:!1},a.onFocus=a.onFocus.bind(a),a.onBlur=a.onBlur.bind(a),a}return S(t,e),t.prototype.onFocus=function(e){var t=this;this.setState({focused:!0},(function(){t.props.onFocus&&t.props.onFocus(e)}))},t.prototype.onBlur=function(e){var t=this;this.setState({focused:!1},(function(){t.props.onBlur&&t.props.onBlur(e),t.props.onFieldBlur&&t.props.onFieldBlur(e)}))},t.getDerivedStateFromProps=function(e,t){return void 0!==e.focused&&e.focused!==t.focused?{focused:e.focused}:void 0!==e.filled&&e.filled!==t.filled?{filled:e.filled}:null},t.prototype.render=function(e){var t=this,a=e.className,r=void 0===a?"":a,n=e.classNameModifiers,i=void 0===n?[]:n,o=e.children,s=e.errorMessage,c=e.helper,d=e.inputWrapperModifiers,l=void 0===d?[]:d,u=e.isLoading,p=e.isValid,m=e.label,h=e.dualBrandingElements;return te("div",{className:je()("adyen-checkout__field",r,i.map((function(e){return"adyen-checkout__field--"+e})),{"adyen-checkout__field--error":s,"adyen-checkout__field--valid":p})},te("label",{onClick:this.props.onFocusField,className:je()({"adyen-checkout__label":!0,"adyen-checkout__label--focused":this.state.focused,"adyen-checkout__label--filled":this.state.filled,"adyen-checkout__label--disabled":this.props.disabled})},"string"===typeof m&&te("span",{className:je()({"adyen-checkout__label__text":!0,"adyen-checkout__label__text--error":s})},m),"function"===typeof m&&m(),c&&te("span",{className:"adyen-checkout__helper-text"},c),te("div",{className:je()(z(["adyen-checkout__input-wrapper"],l.map((function(e){return"adyen-checkout__input-wrapper--"+e}))))},ue(o).map((function(e){return function(e,t,a){var r,n,i,o=arguments,s=X({},e.props);for(i in t)"key"==i?r=t[i]:"ref"==i?n=t[i]:s[i]=t[i];if(arguments.length>3)for(a=[a],i=3;i<arguments.length;i++)a.push(o[i]);return null!=a&&(s.children=a),ae(e.type,s,r||e.key,n||e.ref,null)}(e,{isValid:p,onFocus:t.onFocus,onBlur:t.onBlur,isInvalid:!!s})})),u&&te("span",{className:"adyen-checkout-input__inline-validation adyen-checkout-input__inline-validation--loading"},te(Ee,{size:"small"})),p&&!h&&te("span",{className:"adyen-checkout-input__inline-validation adyen-checkout-input__inline-validation--valid"},te(xt,{type:"checkmark"})),s&&te("span",{className:"adyen-checkout-input__inline-validation adyen-checkout-input__inline-validation--invalid"},te(xt,{type:"field_error"}))),s&&s.length&&te("span",{className:"adyen-checkout__error-text","aria-live":"polite"},s)))},t}(ne),Dt=function(e){var t=e.data,a=t.name,r=t.registrationNumber;return te(Ft,{classNameModifiers:["companyDetails"],label:"companyDetails",readonly:!0},a&&a+" ",r&&r+" ")};function At(e){var t=e.autoCorrect,a=e.classNameModifiers,r=e.isInvalid,n=e.isValid,i=e.readonly,o=void 0===i?null:i,s=e.spellCheck,c=e.type,d=je()("adyen-checkout__input",["adyen-checkout__input--"+c],e.className,{"adyen-checkout__input--invalid":r,"adyen-checkout__input--valid":n},a.map((function(e){return"adyen-checkout__input--"+e})));return te("input",D({},e,{type:c,className:d,onInput:function(t){t.target.value=t.target.value.replace(/[\uff01-\uff5e]/g,(function(e){return String.fromCharCode(e.charCodeAt(0)-65248)})),e.onInput(t)},readOnly:o,spellCheck:s,autoCorrect:t}))}function Bt(e){return te(At,D({classNameModifiers:["large"]},e,{type:"text"}))}At.defaultProps={type:"text",classNameModifiers:[]};var Tt=function(){var e=document.createElement("input");return e.setAttribute("type","date"),"date"===e.type},zt=function(e){if(void 0===e&&(e=""),-1===e.indexOf("/"))return e;var t=e.split("/"),a=t[0],r=void 0===a?"":a,n=t[1],i=void 0===n?"":n,o=t[2],s=void 0===o?"":o;return r&&i&&s?s+"-"+i+"-"+r:null};function Mt(e){return te(At,Ze(Tt,[])?D({},e,{type:"date"}):D({},e,{onInput:function(t){var a=t.target.value;t.target.value=function(e){var t=e.replace(/\D|\s/g,"").replace(/^(00)(.*)?/,"01$2").replace(/^(3[2-9])(.*)?/,"0$1$2").replace(/^([4-9])(.*)?/,"0$1").replace(/^([0-9]{2})(00)(.*)?/,"$101").replace(/^(3[01])(02)(.*)?/,"29$2").replace(/^([0-9]{2})([2-9]|1[3-9])(.*)?/,"$10$2").replace(/^([0-9]{2})([0-9]{2})([0-9])/,"$1/$2/$3").replace(/^([0-9]{2})([0-9])/,"$1/$2"),a=t.split("/"),r=a[0],n=void 0===r?"":r,i=a[1],o=void 0===i?"":i,s=a[2],c=void 0===s?"":s;return 4===c.length&&"29"===n&&"02"===o&&(Number(c)%4!==0||"00"===c.substr(2,2)&&Number(c)%400!==0)?t.replace(/^29/,"28"):t}(a),e.onInput(t)},maxLength:10}))}function It(e){return te(At,D({},e,{type:"tel"}))}function jt(e){return te(At,D({},e,{type:"email",autoCapitalize:"off"}))}a(109);function Et(e){var t=e.items,a=e.i18n,r=e.name,n=e.onChange,i=e.value,o=e.isInvalid;return te("div",{className:"adyen-checkout__radio_group"},t.map((function(t){return te("label",{key:t.id,className:"adyen-checkout__radio_group__input-wrapper"},te("input",{type:"radio",checked:i===t.id,className:"adyen-checkout__radio_group__input",name:r,onChange:n,onClick:n,value:t.id}),te("span",{className:je()(["adyen-checkout__label__text","adyen-checkout__radio_group__label",e.className,{"adyen-checkout__radio_group__label--invalid":o}])},a.get(t.name)))})))}Et.defaultProps={onChange:function(){},items:[]};a(110);function Ot(e){var t=e.classNameModifiers,a=void 0===t?[]:t,r=e.label,n=e.isInvalid,i=e.onChange,o=A(e,["classNameModifiers","label","isInvalid","onChange"]);return te("label",{className:"adyen-checkout__checkbox"},te("input",D({},o,{className:je()(["adyen-checkout__checkbox__input",[o.className],{"adyen-checkout__checkbox__input--invalid":n},a.map((function(e){return"adyen-checkout__input--"+e}))]),type:"checkbox",onChange:i})),te("span",{className:"adyen-checkout__checkbox__label"},r))}Ot.defaultProps={onChange:function(){}};var Rt=a(5),Vt=a.n(Rt),Lt=(a(111),function(e){function t(t){var a=e.call(this,t)||this;return a.state={toggleDropdown:!1},a.toggle=a.toggle.bind(a),a.select=a.select.bind(a),a.closeDropdown=a.closeDropdown.bind(a),a.handleButtonKeyDown=a.handleButtonKeyDown.bind(a),a.handleClickOutside=a.handleClickOutside.bind(a),a.handleKeyDown=a.handleKeyDown.bind(a),a.handleOnError=a.handleOnError.bind(a),a}return S(t,e),t.prototype.componentDidMount=function(){document.addEventListener("click",this.handleClickOutside,!1)},t.prototype.componentWillUnmount=function(){document.removeEventListener("click",this.handleClickOutside,!1)},t.prototype.handleClickOutside=function(e){this.selectContainer.contains(e.target)||this.setState({toggleDropdown:!1})},t.prototype.toggle=function(e){e.preventDefault(),this.setState({toggleDropdown:!this.state.toggleDropdown})},t.prototype.select=function(e){e.preventDefault(),this.closeDropdown(),this.props.onChange(e)},t.prototype.closeDropdown=function(){var e=this;this.setState({toggleDropdown:!1},(function(){return e.toggleButton.focus()}))},t.prototype.handleKeyDown=function(e){switch(e.key){case"Escape":e.preventDefault(),this.setState({toggleDropdown:!1});break;case" ":case"Enter":this.select(e);break;case"ArrowDown":e.preventDefault(),e.target.nextElementSibling&&e.target.nextElementSibling.focus();break;case"ArrowUp":e.preventDefault(),e.target.previousElementSibling&&e.target.previousElementSibling.focus()}},t.prototype.handleButtonKeyDown=function(e){var t;switch(e.key){case"ArrowUp":case"ArrowDown":case" ":case"Enter":e.preventDefault(),this.setState({toggleDropdown:!0}),(null===(t=this.dropdownList)||void 0===t?void 0:t.firstElementChild)&&this.dropdownList.firstElementChild.focus()}},t.prototype.handleOnError=function(e){e.target.style.cssText="display: none"},t.prototype.render=function(e,t){var a,r,n=this,i=e.className,o=void 0===i?"":i,s=e.classNameModifiers,c=void 0===s?[]:s,d=e.isInvalid,l=e.items,u=void 0===l?[]:l,p=e.placeholder,m=e.readonly,h=e.selected,f=t.toggleDropdown,y=u.find((function(e){return e.id===h}))||{};return te("div",{className:je()(z(["adyen-checkout__dropdown",Vt.a["adyen-checkout__dropdown"],o],c.map((function(e){return"adyen-checkout__dropdown--"+e})))),ref:function(e){n.selectContainer=e}},te("button",{type:"button",className:je()(["adyen-checkout__dropdown__button",Vt.a["adyen-checkout__dropdown__button"],(a={"adyen-checkout__dropdown__button--readonly":m,"adyen-checkout__dropdown__button--active":f},a[Vt.a["adyen-checkout__dropdown__button--active"]]=f,a["adyen-checkout__dropdown__button--invalid"]=d,a)]),onClick:m?void 0:this.toggle,onKeyDown:m?void 0:this.handleButtonKeyDown,tabIndex:0,title:y.name||p,"aria-haspopup":"listbox","aria-expanded":f,"aria-disabled":m,ref:function(e){n.toggleButton=e}},te("span",{className:"adyen-checkout__dropdown__button__text"},y.selectedOptionName||y.name||p),y.icon&&te("img",{className:"adyen-checkout__dropdown__button__icon",src:y.icon,alt:y.name,onError:this.handleOnError})),te("ul",{role:"listbox",className:je()((r={"adyen-checkout__dropdown__list":!0},r[Vt.a["adyen-checkout__dropdown__list"]]=!0,r["adyen-checkout__dropdown__list--active"]=f,r[Vt.a["adyen-checkout__dropdown__list--active"]]=f,r)),ref:function(e){n.dropdownList=e}},u.map((function(e){return te("li",{key:e.id,role:"option",tabIndex:-1,"aria-selected":e.id===y.id,className:je()(["adyen-checkout__dropdown__element",Vt.a["adyen-checkout__dropdown__element"],{"adyen-checkout__dropdown__element--active":e.id===y.id}]),"data-value":e.id,onClick:n.select,onKeyDown:n.handleKeyDown},te("span",null,e.name),e.icon&&te("img",{className:"adyen-checkout__dropdown__element__icon",alt:e.name,src:e.icon,onError:n.handleOnError}))}))))},t.defaultProps={items:[],readonly:!1,onChange:function(){}},t}(ne)),Ut=(a(112),function(e,t){var a={boolean:Ot,date:Mt,emailAddress:jt,radio:Et,select:Lt,tel:It,text:Bt,default:Bt};return te(a[e]||a.default,D({},t))}),Kt={input:{default:function(){return!0}},blur:{shopperEmail:function(e){return/\S+@\S+\.\S+/.test(e)},default:function(){return!0}}},qt=function(){function e(e){void 0===e&&(e={}),this.rules=Kt,this.setRules(e)}return e.prototype.setRules=function(e){this.rules={input:D(D({},this.rules&&this.rules.input),e&&e.input),blur:D(D({},this.rules&&this.rules.blur),e&&e.blur)}},e.prototype.validate=function(e,t){var a=this;return void 0===t&&(t="blur"),function(r){var n=a.rules[t][e]?e:"default";return a.rules[t][n](r)}},e}();function Ht(e){var t=e.label,a=void 0===t?"":t,r=e.namePrefix,n=e.requiredFields,i=e.visibility,o=e.validator,s=nt().i18n,c=Ge(e.data),d=c[0],l=c[1],u=Ge({}),p=u[0],m=u[1],h=Ge({}),f=h[0],y=h[1],b=function(e){return function(t){var a=t.target,n=a.name,i=a.value,s=n.split(r+".").pop(),c=o.validate(s,e)(i),d=c.isValid,u=c.errorMessage;l((function(e){var t;return D(D({},e),((t={})[s]=i,t))})),y((function(e){var t;return D(D({},e),((t={})[s]=d,t))})),m((function(e){var t;return D(D({},e),((t={})[s]=!d&&u,t))}))}},v=function(e){return(r?r+".":"")+e};return Ye((function(){var t=n.every((function(e){return o.validate(e,"blur")(d[e]).isValid})),a=function(e){var t=e.name,a=e.registrationNumber;return D({},(t||a)&&{company:D(D({},t&&{name:t}),a&&{registrationNumber:a})})}(d);e.onChange({data:a,isValid:t})}),[d,f,p]),this.showValidation=function(){m(n.reduce((function(e,t){var a=o.validate(t,"blur")(d[t]),r=a.isValid,n=a.errorMessage;return e[t]=!r&&n,e}),{}))},"hidden"===i?null:"readOnly"===i?te(Dt,D({},e,{data:d})):te(Ft,{classNameModifiers:[a],label:a},n.includes("name")&&te(St,{label:s.get("companyDetails.name"),classNameModifiers:["name"],errorMessage:!!p.name},Ut("text",{name:v("name"),value:d.name,classNameModifiers:["name"],onInput:b("input"),onChange:b("blur"),spellCheck:!1})),n.includes("registrationNumber")&&te(St,{label:s.get("companyDetails.registrationNumber"),classNameModifiers:["registrationNumber"],errorMessage:!!p.registrationNumber},Ut("text",{name:v("registrationNumber"),value:d.registrationNumber,classNameModifiers:["registrationNumber"],onInput:b("input"),onChange:b("blur"),spellCheck:!1})))}Ht.defaultProps={data:{},onChange:function(){},visibility:"editable",requiredFields:["name","registrationNumber"],validator:new qt({blur:{default:function(e){return{isValid:e&&e.length>0,errorMessage:!0}}}})};var Gt=function(e){var t=e.data,a=t.firstName,r=t.lastName,n=t.shopperEmail,i=t.telephoneNumber;return te(Ft,{classNameModifiers:["personalDetails"],label:"personalDetails",readonly:!0},a&&a+" ",r&&r+" ",n&&te(re,null,te("br",null),n),i&&te(re,null,te("br",null),i))},Yt=/^\s*[\w\-+_]+(\.[\w\-+_]+)*@[\w\-+_]+\.[\w\-+_]+(\.[\w-+_]+)*\s*$/,Wt=/^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s./0-9]*$/,Jt=function(e){if(!e)return!1;var t=zt(e),a=Date.now()-Date.parse(t);return new Date(a).getFullYear()-1970>=18},Zt={blur:{default:function(e){return{isValid:e&&e.length>0,errorMessage:!0}},dateOfBirth:function(e){return{isValid:Jt(e),errorMessage:"dateOfBirth.invalid"}},telephoneNumber:function(e){return{isValid:Wt.test(e),errorMessage:!0}},shopperEmail:function(e){return{isValid:Yt.test(e),errorMessage:!0}}}};function Qt(e){var t=e.label,a=void 0===t?"":t,r=e.namePrefix,n=e.placeholders,i=e.requiredFields,o=e.visibility,s=e.validator,c=nt().i18n,d=Ge(e.data),l=d[0],u=d[1],p=Ge({}),m=p[0],h=p[1],f=Ge({}),y=f[0],b=f[1],v=Ze(Tt,[]),g=function(e){return function(t){var a=t.target,n=a.name,i=a.value,o=n.split(r+".").pop(),c=s.validate(o,e)(i),d=c.isValid,l=c.errorMessage;u((function(e){var t;return D(D({},e),((t={})[o]=i,t))})),b((function(e){var t;return D(D({},e),((t={})[o]=d,t))})),h((function(e){var t;return D(D({},e),((t={})[o]=!d&&l,t))}))}},k=function(e){return(r?r+".":"")+e},C=function(e){return"string"===typeof e?c.get(e):e};return Ye((function(){var t=i.every((function(e){return s.validate(e,"blur")(l[e]).isValid})),a=function(e){var t=e.firstName,a=e.lastName,r=e.gender,n=e.dateOfBirth,i=e.shopperEmail,o=e.telephoneNumber;return D(D(D(D({},(t||a)&&{shopperName:D(D(D({},t&&{firstName:t}),a&&{lastName:a}),r&&{gender:r})}),n&&{dateOfBirth:zt(n)}),i&&{shopperEmail:i}),o&&{telephoneNumber:o})}(l);e.onChange({data:a,isValid:t})}),[l,y,m]),this.showValidation=function(){h(i.reduce((function(e,t){var a=s.validate(t,"blur")(l[t]),r=a.isValid,n=a.errorMessage;return e[t]=!r&&n,e}),{}))},"hidden"===o?null:"readOnly"===o?te(Gt,D({},e,{data:l})):te(Ft,{classNameModifiers:[a],label:a},i.includes("firstName")&&te(St,{label:c.get("firstName"),classNameModifiers:["col-50","firstName"],errorMessage:!!m.firstName},Ut("text",{name:k("firstName"),value:l.firstName,classNameModifiers:["firstName"],onInput:g("input"),onChange:g("blur"),placeholder:n.firstName,spellCheck:!1})),i.includes("lastName")&&te(St,{label:c.get("lastName"),classNameModifiers:["col-50","lastName"],errorMessage:!!m.lastName},Ut("text",{name:k("lastName"),value:l.lastName,classNameModifiers:["lastName"],onInput:g("input"),onChange:g("blur"),placeholder:n.lastName,spellCheck:!1})),i.includes("gender")&&te(St,{errorMessage:!!m.gender,classNameModifiers:["gender"]},Ut("radio",{i18n:c,name:k("gender"),value:l.gender,items:[{id:"MALE",name:"male"},{id:"FEMALE",name:"female"}],classNameModifiers:["gender"],onInput:g("input"),onChange:g("blur")})),i.includes("dateOfBirth")&&te(St,{label:c.get("dateOfBirth"),classNameModifiers:["col-50","lastName"],errorMessage:C(m.dateOfBirth),helper:v?null:c.get("dateOfBirth.format")},Ut("date",{name:k("dateOfBirth"),value:l.dateOfBirth,classNameModifiers:["dateOfBirth"],onInput:g("input"),onChange:g("blur"),placeholder:n.dateOfBirth})),i.includes("shopperEmail")&&te(St,{label:c.get("shopperEmail"),classNameModifiers:["shopperEmail"],errorMessage:C(m.shopperEmail)},Ut("emailAddress",{name:k("shopperEmail"),value:l.shopperEmail,classNameModifiers:["shopperEmail"],onInput:g("input"),onChange:g("blur"),placeholder:n.shopperEmail})),i.includes("telephoneNumber")&&te(St,{label:c.get("telephoneNumber"),classNameModifiers:["telephoneNumber"],errorMessage:C(m.telephoneNumber)},Ut("tel",{name:k("telephoneNumber"),value:l.telephoneNumber,classNameModifiers:["telephoneNumber"],onInput:g("input"),onChange:g("blur"),placeholder:n.telephoneNumber})))}Qt.defaultProps={data:{},onChange:function(){},placeholders:{},requiredFields:["firstName","lastName","gender","dateOfBirth","shopperEmail","telephoneNumber"],validator:new qt(Zt),visibility:"editable"};var $t=function(e){var t=e.data,a=e.label,r=t.street,n=t.houseNumberOrName,i=t.city,o=t.postalCode,s=t.stateOrProvince,c=t.country;return te(Ft,{classNameModifiers:[a],label:a,readonly:!0},!!r&&r,n&&", "+n+",",te("br",null),o&&""+o,i&&", "+i,s&&"N/A"!==s&&", "+s,c&&", "+c+" ")},Xt={blur:{default:function(e){return e&&e.length>0}}},ea=["street","houseNumberOrName","postalCode","city","stateOrProvince","country"],ta=ea[0],aa=ea[1],ra=ea[2],na=ea[3],ia=ea[4],oa=ea[5],sa=["BR","CA","US"],ca={CA:[oa,ta,aa,[[na,70],[ra,30]],ia],GB:[oa,[[aa,30],[ta,70]],[[na,70],[ra,30]],ia],US:[oa,ta,aa,na,[[ia,50],[ra,50]]],default:[oa,[[ta,70],[aa,30]],[[ra,30],[na,70]],ia]},da={city:{GB:"cityTown",default:na},country:{default:oa},houseNumberOrName:{CA:"apartmentSuite",US:"apartmentSuite",default:aa},postalCode:{US:"zipCode",default:ra},stateOrProvince:{BR:"state",CA:"provinceOrTerritory",US:"state",default:ia},stateOrProvincePlaceholder:{BR:"select.state",CA:"select.provinceOrTerritory",US:"select.state",default:"select.stateOrProvince"},street:{CA:"address",US:"address",default:ta}},la=function(e,t){return da[e][t]||da[e].default};function ua(e,t){var a=e.path,r=e.loadingContext,n=void 0===r?Be:r,i=e.method,o=void 0===i?"GET":i,s=e.contentType,c=void 0===s?"text/plain":s,d=e.clientKey,l=void 0===d?null:d,u={method:o,mode:"cors",cache:"default",credentials:"same-origin",headers:D({Accept:"application/json","Content-Type":c},l&&{"x-client-key":l}),redirect:"follow",referrerPolicy:"no-referrer-when-downgrade",body:JSON.stringify(t)},p=""+n+a;return fetch(p,u).then((function(e){return e.ok?e.json():console.warn("Service at "+p+" is not available")})).then((function(e){return e})).catch((function(e){return console.warn("Call to "+p+" failed. Error= "+e),e}))}function pa(e){var t=e.classNameModifiers,a=e.selectedCountry,r=e.onDropdownChange,n=e.value,i=e.readOnly,o=nt(),s=o.i18n,c=o.loadingContext,d=Ge([]),l=d[0],u=d[1],p=Ge(!1),m=p[0],h=p[1],f=la("stateOrProvince",a),y=la("stateOrProvincePlaceholder",a);return We((function(){if(!a||!sa.includes(a))return u([]),void h(!0);ua({path:"datasets/states/"+a+"/"+s.locale+".json",loadingContext:c}).then((function(e){var t=e&&e.length?e:[];u(t),h(!0)})).catch((function(){u([]),h(!0)}))}),[a]),m&&l.length?te(St,{label:s.get(f),classNameModifiers:t,errorMessage:e.errorMessage},Ut("select",{name:"stateOrProvince",onChange:r,selected:n,placeholder:s.get(y),items:l,readonly:i&&!!n})):null}function ma(e){var t=e.allowedCountries,a=void 0===t?[]:t,r=e.classNameModifiers,n=void 0===r?[]:r,i=e.errorMessage,o=e.onDropdownChange,s=e.value,c=nt(),d=c.i18n,l=c.loadingContext,u=Ge([]),p=u[0],m=u[1],h=Ge(!1),f=h[0],y=h[1],b=Ge(e.readOnly),v=b[0],g=b[1];return We((function(){ua({path:"datasets/countries/"+d.locale+".json",loadingContext:l}).then((function(e){var t=a.length?e.filter((function(e){return a.includes(e.id)})):e;m(t||[]),g(1===t.length||v),y(!0)})).catch((function(e){console.error(e),m([]),y(!0)}))}),[]),f?te(St,{label:d.get("country"),errorMessage:i,classNameModifiers:n},Ut("select",{onChange:o,name:"country",placeholder:d.get("select.country"),selected:s,items:p,readonly:v&&!!s})):null}var ha=function(e){var t=nt().i18n,a=e.classNameModifiers,r=void 0===a?[]:a,n=e.data,i=e.errors,o=e.fieldName,s=e.onInput,c=!!i[o],d=n[o],l=la(o,n.country);switch(o){case"country":return te(ma,{classNameModifiers:r,allowedCountries:e.allowedCountries,errorMessage:c,onDropdownChange:e.onDropdownChange,value:d});case"stateOrProvince":return te(pa,{classNameModifiers:r,selectedCountry:n.country,errorMessage:c,onDropdownChange:e.onDropdownChange,value:d});default:return te(St,{label:t.get(l),classNameModifiers:r,errorMessage:c},Ut("text",{classNameModifiers:r,name:o,value:d,onInput:s}))}};function fa(e){var t=e.label,a=void 0===t?"":t,r=e.requiredFields,n=e.visibility,i=new qt(Xt),o=Ge(function(e,t){return ea.filter((function(a){return!!e[a]||!t.includes(a)})).reduce((function(t,a){return t[a]=e[a]||"N/A",t}),{})}(e.data,r)),s=o[0],c=o[1],d=Ge({}),l=d[0],u=d[1],p=Ge({}),m=p[0],h=p[1],f=function(e){var t=e.target,a=t.name,r=t.value,n=i.validate(a,"blur")(r);c((function(e){var t;return D(D({},e),((t={})[a]=r,t))})),h((function(e){var t;return D(D({},e),((t={})[a]=n,t))})),u((function(e){var t;return D(D({},e),((t={})[a]=!n,t))}))};if(Ye((function(){var e=s.country,t=sa.includes(e)?"":"N/A";c((function(e){return D(D({},e),{stateOrProvince:t})}))}),[s.country]),Ye((function(){var e=r.includes("stateOrProvince"),t=s.country&&sa.includes(s.country),a=e&&t,n=s.stateOrProvince||(a?"":"N/A");c((function(e){return D(D({},e),{stateOrProvince:n})}))}),[]),Ye((function(){var t=r.every((function(e){return i.validate(e,"blur")(s[e])}));e.onChange({data:s,isValid:t})}),[s,m,l]),this.showValidation=function(){u(r.reduce((function(e,t){return e[t]=!i.validate(t,"blur")(s[t]),e}),{}))},"hidden"===n)return null;if("readOnly"===n)return te($t,{data:s,label:a});var y,b=function(t,a){var n,i=a.classNameModifiers,o=void 0===i?[]:i;return r.includes(t)?te(ha,{key:t,allowedCountries:e.allowedCountries,classNameModifiers:z(o,[t]),data:s,errors:l,fieldName:t,onInput:f,onDropdownChange:(n=t,function(e){var t=e.currentTarget.getAttribute("data-value");c((function(e){var a;return D(D({},e),((a={})[n]=t,a))})),h((function(e){var a;return D(D({},e),((a={})[n]=!!t,a))})),u((function(e){var a;return D(D({},e),((a={})[n]=!t,a))}))})}):null};return te(Ft,{classNameModifiers:[a],label:a},(y=s.country,ca[y]||ca.default).map((function(e){return e instanceof Array?te("div",{className:"adyen-checkout__field-group"},e.map((function(e){var t=e[0],a=e[1];return b(t,{classNameModifiers:["col-"+a]})}))):b(e,{})})))}function ya(e){var t,a=e.data,r=e.errorMessage,n=e.label,i=e.onChange,o=A(e,["data","errorMessage","label","onChange"]);return te(St,{classNameModifiers:["consentCheckbox"],errorMessage:r},te(Ot,{name:"consentCheckbox",classNameModifiers:z(null!==(t=o.classNameModifiers)&&void 0!==t?t:o.classNameModifiers=[],["consentCheckbox"]),onInput:i,value:a.consentCheckbox,label:n,checked:o.checked}))}fa.defaultProps={data:{},onChange:function(){},visibility:"editable",requiredFields:ea,countryCode:null};var ba=function(e,t){return void 0===t&&(t={}),va.reduce((function(a,r){var n,i="hidden"!==e[r],o="deliveryAddress"===r,s="hidden"===(null===e||void 0===e?void 0:e.billingAddress);return a[r]=i&&(!o||s||(void 0===(n=t[r])&&(n={}),Object.keys(n).length>1)),a}),{})},va=(a(113),["companyDetails","personalDetails","billingAddress","deliveryAddress"]);function ga(e){var t=e.countryCode,a=e.visibility,r=nt().i18n,n=Ge(ba(a,e.data)),i=n[0],o=n[1],s=va.reduce((function(e,t){return e[t]={current:null},e}),{}),c=!!e.consentCheckboxLabel,d=!c&&Object.keys(i).every((function(e){return!i[e]})),l="editable"===a.deliveryAddress&&"hidden"!==a.billingAddress,u=Ge(D(D({},e.data),c&&{consentCheckbox:!1})),p=u[0],m=u[1],h=Ge({}),f=h[0],y=h[1],b=Ge({}),v=b[0],g=b[1],k=Ge("ready"),C=k[0],_=k[1];this.setStatus=function(e){_(e)},Ye((function(){var t=Object.keys(i).every((function(e){return!i[e]||!!v[e]})),a=!c||!!v.consentCheckbox,r=t&&a,n=function(e,t){return Object.keys(t).filter((function(t){return e[t]})).reduce((function(e,a){return e[a]=t[a],e}),{})}(i,p);e.onChange({data:n,isValid:r})}),[p,i]);var N=function(e){return function(t){m((function(a){var r;return D(D({},a),((r={})[e]=t.data,r))})),g((function(a){var r;return D(D({},a),((r={})[e]=t.isValid,r))}))}};return this.showValidation=function(){va.forEach((function(e){s[e].current&&s[e].current.showValidation()})),y(D({},c&&{consentCheckbox:!p.consentCheckbox}))},te("div",{className:"adyen-checkout__open-invoice"},i.companyDetails&&te(Ht,{data:p.companyDetails,label:"companyDetails",onChange:N("companyDetails"),ref:s.companyDetails,visibility:a.companyDetails}),i.personalDetails&&te(Qt,{data:p.personalDetails,requiredFields:e.personalDetailsRequiredFields,label:"personalDetails",onChange:N("personalDetails"),ref:s.personalDetails,visibility:a.personalDetails}),i.billingAddress&&te(fa,{allowedCountries:e.allowedCountries,countryCode:t,data:p.billingAddress,label:"billingAddress",onChange:N("billingAddress"),ref:s.billingAddress,visibility:a.billingAddress}),l&&te(Ot,{label:r.get("separateDeliveryAddress"),checked:i.deliveryAddress,classNameModifiers:["separateDeliveryAddress"],name:"separateDeliveryAddress",onChange:function(){o((function(e){return D(D({},e),{deliveryAddress:!i.deliveryAddress})}))}}),i.deliveryAddress&&te(fa,{allowedCountries:e.allowedCountries,countryCode:t,data:p.deliveryAddress,label:"deliveryAddress",onChange:N("deliveryAddress"),ref:s.deliveryAddress,visibility:a.deliveryAddress}),c&&te(ya,{data:p,errorMessage:!!f.consentCheckbox,label:e.consentCheckboxLabel,onChange:function(e){var t=e.target.checked;m((function(e){return D(D({},e),{consentCheckbox:t})})),g((function(e){return D(D({},e),{consentCheckbox:t})})),y((function(e){return D(D({},e),{consentCheckbox:!t})}))}}),e.showPayButton&&e.payButton({status:C,classNameModifiers:z(d?["standalone"]:[]),label:r.get("confirmPurchase")}))}var ka=function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.state={loaded:!1},t}return S(t,e),t.prototype.componentDidMount=function(){var e=this;this.props.i18n?this.props.i18n.loaded.then((function(){e.setState({loaded:!0})})):this.setState({loaded:!0})},t.prototype.render=function(e){var t=e.children;return this.state.loaded?te(rt.Provider,{value:{i18n:this.props.i18n,loadingContext:this.props.loadingContext}},ue(t)):null},t}(ne),Ca=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return S(t,e),Object.defineProperty(t.prototype,"isValid",{get:function(){return!!this.state.isValid},enumerable:!1,configurable:!0}),t.prototype.formatProps=function(e){var a,r,n=e.countryCode||(null===(r=null===(a=e.data)||void 0===a?void 0:a.billingAddress)||void 0===r?void 0:r.countryCode);return D(D({},e),{allowedCountries:[n],visibility:D(D({},t.defaultProps.visibility),e.visibility),data:D(D({},e.data),{billingAddress:D(D({},e.data.billingAddress),{country:n}),deliveryAddress:D(D({},e.data.deliveryAddress),{country:n})})})},t.prototype.formatData=function(){var e=this.state.data,t=void 0===e?{}:e,a=t.companyDetails,r=void 0===a?{}:a,n=t.personalDetails,i=void 0===n?{}:n,o=t.billingAddress,s=t.deliveryAddress;return D(D(D(D({paymentMethod:{type:this.constructor.type}},i),r),o&&{billingAddress:o}),(s||o)&&{deliveryAddress:s||o})},t.prototype.render=function(){var e=this;return te(ka,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},te(ga,D({ref:function(t){e.componentRef=t}},this.props,this.state,{consentCheckbox:this.props.consentCheckbox,onChange:this.setState,onSubmit:this.submit,payButton:this.payButton})))},t.defaultProps={onChange:function(){},data:{companyDetails:{},personalDetails:{},billingAddress:{},deliveryAddress:{}},visibility:{companyDetails:"hidden",personalDetails:"editable",billingAddress:"editable",deliveryAddress:"editable"}},t}(ct);function _a(e){var t=nt().i18n,a=t.get("paymentConditions"),r=t.get("afterPay.agreement").split("%@"),n=r[0],i=r[1];return n&&i?te(re,null,n,te("a",{className:"adyen-checkout__link",target:"_blank",rel:"noopener noreferrer",href:e.url},a),i):te("span",{className:"adyen-checkout__checkbox__label"},t.get("privacyPolicy"))}var Na=["BE","NL"];var wa=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return S(t,e),t.prototype.formatProps=function(t){var a,r,n;return D(D({},e.prototype.formatProps.call(this,t)),{allowedCountries:t.countryCode?[t.countryCode]:Na,consentCheckboxLabel:te(_a,{url:(r=t.countryCode,n=null===(a=t.i18n)||void 0===a?void 0:a.locale,"en"===(null===n||void 0===n?void 0:n.toLowerCase().slice(0,2))?"https://www.afterpay.nl/en/algemeen/pay-with-afterpay/payment-conditions":"be"===(null===r||void 0===r?void 0:r.toLowerCase())?"https://www.afterpay.be/be/footer/betalen-met-afterpay/betalingsvoorwaarden":"https://www.afterpay.nl/nl/algemeen/betalen-met-afterpay/betalingsvoorwaarden")})})},t.type="afterpay_default",t}(Ca),Pa=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return S(t,e),t.prototype.formatProps=function(t){return D(D({},e.prototype.formatProps.call(this,t)),{allowedCountries:t.countryCode?[t.countryCode]:Na,consentCheckboxLabel:te(_a,{url:"https://www.afterpay.nl/nl/algemeen/zakelijke-partners/betalingsvoorwaarden-zakelijk"})})},t.type="afterpay_b2b",t.defaultProps={onChange:function(){},data:{companyDetails:{},personalDetails:{},billingAddress:{},deliveryAddress:{}},visibility:{companyDetails:"editable",personalDetails:"editable",billingAddress:"editable",deliveryAddress:"editable"}},t}(Ca);function Fa(){var e=we(window,"screen.colorDepth")||"",t=!!we(window,"navigator.javaEnabled")&&window.navigator.javaEnabled(),a=we(window,"screen.height")||"",r=we(window,"screen.width")||"",n=we(window,"navigator.userAgent")||"";return{acceptHeader:"*/*",colorDepth:e,language:we(window,"navigator.language")||we(window,"navigator.browserLanguage"),javaEnabled:t,screenHeight:a,screenWidth:r,userAgent:n,timeZoneOffset:(new Date).getTimezoneOffset()}}var xa=["en_GB","de_DE","fr_FR","it_IT","es_ES"],Sa=["en_US"];function Da(e,t){return function(e){return"US"===e?Sa:xa}(t).includes(e)?e:function(e){return"US"===e?"en_US":"en_GB"}(t)}function Aa(e,t,a){return ua({loadingContext:e,method:"POST",path:"v1/AmazonPayUtility/getCheckoutDetails?token="+t},a)}function Ba(e){var t,a,r,n,i=this,o=nt().loadingContext,s=e.amazonRef,c=e.buttonColor,d=e.configuration,l=void 0===d?{}:d,u=Ge(null),p=u[0],m=u[1],h=(t=l.storeId,a=e.returnUrl,r=e.cancelUrl,n=e.deliverySpecifications,D({storeId:t,webCheckoutDetails:D({checkoutReviewReturnUrl:a},r&&{checkoutCancelUrl:r})},n&&{deliverySpecifications:n})),f=D(D({},c&&{buttonColor:c}),{checkoutLanguage:Da(e.locale,e.region),ledgerCurrency:e.currency,merchantId:l.merchantId,productType:e.productType,placement:e.placement,sandbox:"TEST"===e.environment}),y=function(){new Promise(e.onClick).then(i.initCheckout).catch((function(t){e.onError(t,i.componentRef)}))};return this.initCheckout=function(){var e={payloadJSON:JSON.stringify(h),publicKeyId:l.publicKeyId,signature:p};s.Pay.initCheckout(D(D({},f),{createCheckoutSessionConfig:e}))},Ye((function(){var t=e.clientKey;(function(e,t,a){return ua({loadingContext:e,method:"POST",path:"v1/AmazonPayUtility/signString?token="+t},{stringToSign:JSON.stringify(a)})})(o,t,h).then((function(t){if(!(null===t||void 0===t?void 0:t.signature))return console.error("Could not get AmazonPay signature");m(t.signature),e.showPayButton&&s.Pay.renderButton("#amazonPayButton",f).onClick(y)})).catch((function(t){console.error(t),e.onError&&e.onError(t,i.componentRef)}))}),[]),e.showPayButton?te("div",{className:"adyen-checkout__amazonpay__button",id:"amazonPayButton"}):null}function Ta(e){var t=nt().i18n,a=e.amazonRef,r=e.amazonCheckoutSessionId;return Ye((function(){var e={amazonCheckoutSessionId:r,changeAction:"changeAddress"};a.Pay.bindChangeAction(".adyen-checkout__amazonpay__button--changeAddress",e)}),[]),te("button",{type:"button",className:"adyen-checkout__button adyen-checkout__button--ghost adyen-checkout__amazonpay__button--changeAddress"},t.get("amazonpay.changePaymentDetails"))}function za(e){var t=this,a=nt(),r=a.i18n,n=a.loadingContext;return this.createOrder=function(){var a=e.amazonCheckoutSessionId,r=e.amount,i=e.clientKey,o=e.returnUrl;(function(e,t,a){return ua({loadingContext:e,method:"POST",path:"v1/AmazonPayUtility/updateCheckoutSession?token="+t},a)})(n,i,{amount:r,checkoutResultReturnUrl:o,checkoutSessionId:a}).then((function(e){var t;if(!(null===(t=null===e||void 0===e?void 0:e.action)||void 0===t?void 0:t.type))return console.error(e.errorMessage||"Could not get the AmazonPay URL");"redirect"===e.action.type&&window.location.assign(e.action.url)})).catch((function(a){e.onError&&e.onError(a,t.componentRef)}))},te(it,{classNameModifiers:["standalone","pay"],label:r.get("confirmPurchase"),onClick:this.createOrder})}function Ma(e){return te("button",{type:"button",className:"adyen-checkout__button  adyen-checkout__button--ghost adyen-checkout__amazonpay__button--signOut",onClick:function(){new Promise(e.onSignOut).then((function(){e.amazonRef.Pay.signout()})).catch(console.error)}},nt().i18n.get("amazonpay.signout"))}var Ia=function(e,t){var a=this;void 0===t&&(t="body"),this.load=function(){return new Promise((function(e,t){a.script.src=a.src,a.script.async=!0,a.script.onload=e,a.script.onerror=function(){a.remove(),t(new Error("Unable to load script "+a.src))},document.querySelector(a.node).appendChild(a.script)}))},this.remove=function(){return a.script.remove()},this.script=document.createElement("script"),this.src=e,this.node=t};function ja(e){var t=Ge("pending"),a=t[0],r=t[1],n=Je(null),i=Je(null),o=function(){r("ready")};return this.submit=function(){return n.current&&n.current.initCheckout?n.current.initCheckout():i.current&&i.current.createOrder?i.current.createOrder():void 0},Ye((function(){var t="US"===e.region?"https://static-na.payments-amazon.com/checkout.js":"https://static-eu.payments-amazon.com/checkout.js",a=new Ia(t);return a.load().then(o),function(){a.remove()}}),[]),"pending"===a?te("div",{className:"adyen-checkout__amazonpay"},te("div",{className:"adyen-checkout__amazonpay__status adyen-checkout__amazonpay__status--pending"},te(Ee,null))):e.showSignOutButton?te("div",{className:"adyen-checkout__amazonpay"},te(Ma,{amazonRef:window.amazon,onSignOut:e.onSignOut})):e.amazonCheckoutSessionId?te("div",{className:"adyen-checkout__amazonpay"},e.showOrderButton&&te(za,{amazonCheckoutSessionId:e.amazonCheckoutSessionId,amount:e.amount,clientKey:e.clientKey,onError:e.onError,returnUrl:e.returnUrl,ref:i}),e.showChangePaymentDetailsButton&&te(Ta,{amazonCheckoutSessionId:e.amazonCheckoutSessionId,amazonRef:window.amazon})):te("div",{className:"adyen-checkout__amazonpay"},te(Ba,D({},e,{amazonRef:window.amazon,ref:n})))}var Ea={configuration:{},environment:"TEST",locale:"en_GB",placement:"Cart",productType:"PayAndShip",region:"EU",showOrderButton:!0,showChangePaymentDetailsButton:!1,showSignOutButton:!1,showPayButton:!0,onClick:function(e){return e()},onSignOut:function(e){return e()}},Oa=(a(114),function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return S(t,e),t.prototype.formatProps=function(e){return D(D({},e),{environment:e.environment.toUpperCase(),locale:e.locale.replace("-","_"),region:e.region.toUpperCase()})},t.prototype.formatData=function(){var e=this.props.amazonCheckoutSessionId;return{paymentMethod:D({type:t.type},e&&{checkoutSessionId:e}),browserInfo:this.browserInfo}},t.prototype.getShopperDetails=function(){var e=this.props,t=e.amazonCheckoutSessionId,a=e.loadingContext,r=e.clientKey;return t?Aa(a,r,{checkoutSessionId:t,getDeliveryAddress:!0}):console.error("Could not shopper details. Missing checkoutSessionId.")},t.prototype.handleDeclineFlow=function(){var e=this,t=this.props,a=t.amazonCheckoutSessionId,r=t.loadingContext,n=t.clientKey;if(!a)return console.error("Could handle the decline flow. Missing checkoutSessionId.");Aa(r,n,{checkoutSessionId:a,getDeclineFlowUrl:!0}).then((function(e){if(void 0===e&&(e={}),!(null===e||void 0===e?void 0:e.declineFlowUrl))throw e;window.location.assign(e.declineFlowUrl)})).catch((function(t){e.props.onError&&e.props.onError(t,e.componentRef)}))},Object.defineProperty(t.prototype,"isValid",{get:function(){return!0},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"browserInfo",{get:function(){return Fa()},enumerable:!1,configurable:!0}),t.prototype.submit=function(){var e=this.data,t=this.isValid,a=this.props.onSubmit,r=void 0===a?function(){}:a;return this.componentRef&&this.componentRef.submit?this.componentRef.submit():r({data:e,isValid:t},this)},t.prototype.render=function(){var e=this;return te(ka,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},te(ja,D({ref:function(t){e.componentRef=t}},this.props)))},t.type="amazonpay",t.defaultProps=Ea,t}(ct)),Ra=a(16),Va=a.n(Ra),La=(a(115),function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return S(t,e),t.prototype.render=function(e){var t=e.buttonColor,a=e.buttonType;return te("button",{type:"button","aria-label":this.props.i18n.get("payButton"),lang:this.props.i18n.languageCode,className:je()("adyen-checkout__applepay__button","adyen-checkout__applepay__button--"+t,"adyen-checkout__applepay__button--"+a,[Va.a["apple-pay-button"]],[Va.a["apple-pay-button-"+t]],[Va.a["apple-pay-button--type-"+a]]),onClick:this.props.onClick})},t.defaultProps={onClick:function(){},buttonColor:"black",buttonType:"plain"},t}(ne)),Ua=function(){function e(e,t){var a=this;this.session=new ApplePaySession(t.version,e),this.session.onvalidatemerchant=function(e){return a.onvalidatemerchant(e,t.onValidateMerchant)},this.session.onpaymentauthorized=function(e){return a.onpaymentauthorized(e,t.onPaymentAuthorized)},this.session.oncancel=function(e){return a.oncancel(e,t.onCancel)},"function"===typeof t.onPaymentMethodSelected&&(this.session.onpaymentmethodselected=function(e){return a.onpaymentmethodselected(e,t.onPaymentMethodSelected)}),"function"===typeof t.onShippingContactSelected&&(this.session.onshippingcontactselected=function(e){return a.onshippingcontactselected(e,t.onShippingContactSelected)}),"function"===typeof t.onShippingMethodSelected&&(this.session.onshippingmethodselected=function(e){return a.onshippingmethodselected(e,t.onShippingMethodSelected)})}return e.prototype.begin=function(){return this.session.begin()},e.prototype.onvalidatemerchant=function(e,t){var a=this;new Promise((function(a,r){return t(a,r,e.validationURL)})).then((function(e){a.session.completeMerchantValidation(e)})).catch((function(e){console.error(e),a.session.abort()}))},e.prototype.onpaymentauthorized=function(e,t){var a=this;return new Promise((function(a,r){return t(a,r,e)})).then((function(){a.session.completePayment(ApplePaySession.STATUS_SUCCESS)})).catch((function(){a.session.completePayment(ApplePaySession.STATUS_FAILURE)}))},e.prototype.onpaymentmethodselected=function(e,t){var a=this;return new Promise((function(a,r){return t(a,r,e)})).then((function(e){a.session.completePaymentMethodSelection(e)})).catch((function(e){a.session.completePaymentMethodSelection(e)}))},e.prototype.onshippingcontactselected=function(e,t){var a=this;return new Promise((function(a,r){return t(a,r,e)})).then((function(e){a.session.completeShippingContactSelection(e)})).catch((function(e){a.session.completeShippingContactSelection(e)}))},e.prototype.onshippingmethodselected=function(e,t){var a=this;return new Promise((function(a,r){return t(a,r,e)})).then((function(e){a.session.completeShippingMethodSelection(e)})).catch((function(e){a.session.completeShippingMethodSelection(e)}))},e.prototype.oncancel=function(e,t){return t(e)},e}(),Ka={amount:{currency:"USD",value:0},countryCode:"US",totalPriceStatus:"final",totalPriceLabel:void 0,configuration:{merchantName:"",merchantId:""},initiative:"web",lineItems:void 0,merchantCapabilities:["supports3DS"],shippingMethods:void 0,shippingType:void 0,supportedCountries:void 0,supportedNetworks:["amex","discover","masterCard","visa"],requiredBillingContactFields:void 0,requiredShippingContactFields:void 0,billingContact:void 0,shippingContact:void 0,applicationData:void 0,onClick:function(e){return e()},onSubmit:function(){},onError:function(){},onAuthorized:function(e){return e()},onPaymentMethodSelected:null,onShippingContactSelected:null,onShippingMethodSelected:null,buttonType:"plain",buttonColor:"black",showPayButton:!0},qa=function(e){var t=e.countryCode,a=(e.companyName,e.amount),r=A(e,["countryCode","companyName","amount"]),n=function(e){return String(W(e.value,e.currency))}(a);return{countryCode:t,currencyCode:a.currency,total:{label:r.totalPriceLabel,amount:n,type:r.totalPriceStatus},lineItems:r.lineItems,shippingMethods:r.shippingMethods,shippingType:r.shippingType,merchantCapabilities:r.merchantCapabilities,supportedCountries:r.supportedCountries,supportedNetworks:r.supportedNetworks,requiredShippingContactFields:r.requiredShippingContactFields,requiredBillingContactFields:r.requiredBillingContactFields,billingContact:r.billingContact,shippingContact:r.shippingContact,applicationData:r.applicationData}};var Ha=function(e){function t(t){var a=e.call(this,t)||this;return a.startSession=a.startSession.bind(a),a.submit=a.submit.bind(a),a.validateMerchant=a.validateMerchant.bind(a),a}return S(t,e),t.prototype.formatProps=function(e){var t,a,r,n=function(e){var t,a;return"undefined"!==typeof(null===(t=e.amount)||void 0===t?void 0:t.value)&&(null===(a=e.amount)||void 0===a?void 0:a.currency)?e.amount:"number"===typeof e.amount&&e.currencyCode?{value:e.amount,currency:e.currencyCode}:null}(e),i=e.version||function(e){for(var t=[],a=e;a>0;a--)t.push(a);return t.find((function(e){return e&&window.ApplePaySession&&ApplePaySession.supportsVersion(e)}))}(10),o=e.configuration,s=void 0===o?{}:o,c=(null===(t=e.brands)||void 0===t?void 0:t.length)?(a=e.brands,r={mc:"masterCard",amex:"amex",visa:"visa",elodebit:"elo",elo:"elo",interac:"interac",discover:"discover",jcb:"jcb",electron:"electron",maestro:"maestro"},a.reduce((function(e,t){return r[t]&&!e.includes(r[t])&&e.push(r[t]),e}),[])):e.supportedNetworks;return D(D({onAuthorized:function(e){return e()}},e),{configuration:{merchantId:s.merchantIdentifier||s.merchantId||Ka.configuration.merchantId,merchantName:s.merchantDisplayName||s.merchantName||Ka.configuration.merchantName},supportedNetworks:c,version:i,totalPriceLabel:e.totalPriceLabel||s.merchantName,amount:n,onCancel:function(t){return e.onError(t)}})},t.prototype.formatData=function(){return{paymentMethod:D({type:t.type},this.state)}},t.prototype.submit=function(){this.startPayment()},t.prototype.startPayment=function(){return Promise.resolve(this.startSession(this.props.onAuthorized))},t.prototype.startSession=function(e){var t=this,a=this.props,r=a.version,n=a.onValidateMerchant,i=a.onSubmit,o=a.onCancel,s=a.onPaymentMethodSelected,c=a.onShippingMethodSelected,d=a.onShippingContactSelected;return new Promise((function(e,a){return t.props.onClick(e,a)})).then((function(){var a=qa(D({companyName:t.props.configuration.merchantName},t.props));new Ua(a,{version:r,onCancel:o,onPaymentMethodSelected:s,onShippingMethodSelected:c,onShippingContactSelected:d,onValidateMerchant:n||t.validateMerchant,onPaymentAuthorized:function(a,r,n){n.payment.token&&n.payment.token.paymentData&&t.setState({applePayToken:btoa(JSON.stringify(n.payment.token.paymentData))}),i({data:t.data,isValid:t.isValid},t),e(a,r,n)}}).begin()}))},t.prototype.validateMerchant=function(e,t){return B(this,void 0,void 0,(function(){var a,r,n,i,o,s,c,d,l,u,p,m,h;return T(this,(function(f){switch(f.label){case 0:a=window.location.hostname,r=this.props,n=r.clientKey,i=r.configuration,o=r.loadingContext,s=r.initiative,c=i.merchantName,d=i.merchantId,l={loadingContext:o,path:"v1/applePay/sessions?token="+n,method:"post"},u={displayName:c,domainName:a,initiative:s,merchantIdentifier:d},f.label=1;case 1:return f.trys.push([1,3,,4]),[4,ua(l,u)];case 2:return p=f.sent(),(m=wt.decode(p.data))||t("Could not decode Apple Pay session"),h=JSON.parse(m),e(h),[3,4];case 3:return f.sent(),t("Could not get Apple Pay session"),[3,4];case 4:return[2]}}))}))},Object.defineProperty(t.prototype,"isValid",{get:function(){return!0},enumerable:!1,configurable:!0}),t.prototype.isAvailable=function(){return"https:"!==document.location.protocol?Promise.reject(new Error("Trying to start an Apple Pay session from an insecure document")):this.props.onValidateMerchant||this.props.clientKey?window.ApplePaySession&&ApplePaySession.canMakePayments()&&ApplePaySession.supportsVersion(this.props.version)?Promise.resolve(ApplePaySession.canMakePayments()):Promise.reject(new Error("Apple Pay is not available on this device")):Promise.reject(new Error("clientKey was not provided"))},t.prototype.render=function(){var e=this;return this.props.showPayButton?te(La,{i18n:this.props.i18n,buttonColor:this.props.buttonColor,buttonType:this.props.buttonType,onClick:function(t){t.preventDefault(),e.submit()}}):null},t.type="applepay",t.defaultProps=Ka,t}(ct),Ga=(a(116),function(e,t){var a=e.issuer,r=e.items;if(!a)return t.get("continue");var n=r.find((function(e){return e.id===a})).name;return t.get("continueTo")+" "+n});function Ya(e){var t=e.items,a=e.placeholder,r=e.issuer,n=void 0===r?null:r,i=A(e,["items","placeholder","issuer"]),o=nt().i18n,s=Ge(n),c=s[0],d=s[1],l=Ge(!1),u=l[0],p=l[1],m=Ge("ready"),h=m[0],f=m[1];this.setStatus=function(e){f(e)};return Ye((function(){i.onChange({issuer:c})}),[c]),this.showValidation=function(){p(!c)},te("div",{className:"adyen-checkout__issuer-list"},te(St,{errorMessage:u,classNameModifiers:["issuer-list"]},Ut("select",{items:t,selected:c,placeholder:o.get(a),name:"issuer",className:"adyen-checkout__issuer-list__dropdown",onChange:function(e){var t=e.currentTarget.getAttribute("data-value");d(t),p(!1)}})),i.showPayButton&&i.payButton({status:h,label:Ga({issuer:c,items:t},o)}))}Ya.defaultProps={onChange:function(){},placeholder:"idealIssuer.selectField.placeholder"};var Wa=Ya,Ja=function(e,t){return function(a){if(!a)return null;var r=D({parentFolder:a?t+"/":"",type:a||t},e);return ze(r)(a)}},Za=function(e){function t(t){var a=e.call(this,t)||this;if(a.props.showImage){var r=Ja({loadingContext:a.props.loadingContext},a.constructor.type);a.props.items=a.props.items.map((function(e){return D(D({},e),{icon:r(e.id)})}))}return a}return S(t,e),t.prototype.formatProps=function(e){return D(D({},e),{items:e.details&&e.details.length?(e.details.find((function(e){return"issuer"===e.key}))||{}).items:e.items})},t.prototype.formatData=function(){return{paymentMethod:{type:this.constructor.type,issuer:this.state.issuer}}},Object.defineProperty(t.prototype,"isValid",{get:function(){var e;return!!(null===(e=this.state)||void 0===e?void 0:e.issuer)},enumerable:!1,configurable:!0}),t.prototype.render=function(){var e=this;return te(ka,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},te(Wa,D({ref:function(t){e.componentRef=t}},this.props,this.state,{onChange:this.setState,onSubmit:this.submit,payButton:this.payButton})))},t.defaultProps={showImage:!0,onValid:function(){},items:[],loadingContext:Be},t}(ct),Qa=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return S(t,e),t.prototype.formatProps=function(t){return D(D({},e.prototype.formatProps.call(this,t)),{showImage:!1})},t.type="billdesk_online",t}(Za),$a=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return S(t,e),t.prototype.formatProps=function(t){return D(D({},e.prototype.formatProps.call(this,t)),{showImage:!1,placeholder:"issuerList.wallet.placeholder"})},t.type="billdesk_wallet",t}(Za),Xa=function(e,t){return ze({type:"card"===e?"nocard":e||"nocard",extension:"svg",loadingContext:t})(e)},er=a(1),tr=a.n(er);function ar(e){var t=e.brand,a=nt().loadingContext,r="card"===t?"nocard":t;return te("img",{className:tr.a["card-input__icon"]+" adyen-checkout__card__cardNumber__brandIcon",onError:function(e){e.target.style.cssText="display: none"},alt:t,src:Xa(r,a)})}a(117);var rr=function(e){var t=e.brand,a=e.onClick,r=e.dataValue,n=e.notSelected,i=nt().loadingContext,o="card"===t?"nocard":t;return te("img",{className:tr.a["card-input__icon"]+" "+(n?"adyen-checkout__card__cardNumber__brandIcon--not-selected":"")+" adyen-checkout__card__cardNumber__brandIcon",onError:function(e){e.target.style.cssText="display: none"},alt:t,src:Xa(o,i),onClick:a,"data-value":r})};function nr(e){var t,a=nt().i18n,r=e.error,n=void 0===r?"":r,i=e.isValid,o=void 0!==i&&i,s=e.onFocusField,c=void 0===s?function(){}:s,d=e.dualBrandingElements,l=e.dualBrandingChangeHandler,u=e.dualBrandingSelected;return te(St,{label:e.label,focused:e.focused,filled:e.filled,classNameModifiers:["cardNumber"],onFocusField:function(){return c("encryptedCardNumber")},errorMessage:n&&a.get(n),isValid:o,dualBrandingElements:d},te("span",{"data-cse":"encryptedCardNumber",className:je()((t={"adyen-checkout__input":!0,"adyen-checkout__input--large":!0,"adyen-checkout__card__cardNumber__input":!0},t[tr.a["adyen-checkout__input"]]=!0,t["adyen-checkout__input--error"]=n,t["adyen-checkout__input--focus"]=e.focused,t["adyen-checkout__input--valid"]=o,t["adyen-checkout__card__cardNumber__input--noBrand"]=!e.showBrandIcon,t))},e.showBrandIcon&&!d&&te(ar,{brand:e.brand})),d&&!n&&te("div",{className:je()(["adyen-checkout__card__dual-branding__buttons",{"adyen-checkout__card__dual-branding__buttons--active":o}])},d.map((function(e){return te(rr,{key:e.id,brand:e.id,onClick:l,dataValue:e.id,notSelected:""!==u&&u!==e.id})}))))}function ir(e){var t=e.frontCVC,a=void 0!==t&&t;return te("div",{className:je()({"adyen-checkout__card__cvc__hint__wrapper":!0,"adyen-checkout__field__cvc--front-hint":!!a,"adyen-checkout__field__cvc--back-hint":!a})},te("svg",{className:"adyen-checkout__card__cvc__hint adyen-checkout__card__cvc__hint--front",width:"27",height:"18",viewBox:"0 0 27 18",fill:"none",xmlns:"http://www.w3.org/2000/svg"},te("path",{d:"M0 3C0 1.34315 1.34315 0 3 0H24C25.6569 0 27 1.34315 27 3V15C27 16.6569 25.6569 18 24 18H3C1.34315 18 0 16.6569 0 15V3Z",fill:"#E6E9EB"}),te("rect",{x:"4",y:"12",width:"19",height:"2",fill:"#B9C4C9"}),te("rect",{x:"4",y:"4",width:"4",height:"4",rx:"1",fill:"white"}),te("rect",{className:"adyen-checkout__card__cvc__hint__location",x:"16.5",y:"4.5",width:"7",height:"5",rx:"2.5",stroke:"#D10244"})),te("svg",{className:"adyen-checkout__card__cvc__hint adyen-checkout__card__cvc__hint--back",width:"27",height:"18",viewBox:"0 0 27 18",fill:"none",xmlns:"http://www.w3.org/2000/svg"},te("path",{d:"M27 4.00001V3.37501C27 2.4799 26.6444 1.62146 26.0115 0.988518C25.3786 0.355581 24.5201 0 23.625 0H3.375C2.47989 0 1.62145 0.355581 0.988514 0.988518C0.355579 1.62146 0 2.4799 0 3.37501V4.00001H27Z",fill:"#E6E9EB"}),te("path",{d:"M0 6.99994V14.6666C0 15.5507 0.355579 16.3985 0.988514 17.0237C1.62145 17.6488 2.47989 18 3.375 18H23.625C24.5201 18 25.3786 17.6488 26.0115 17.0237C26.6444 16.3985 27 15.5507 27 14.6666V6.99994H0Z",fill:"#E6E9EB"}),te("rect",{y:"4.00012",width:"27",height:"3.00001",fill:"#687282"}),te("path",{d:"M4 11C4 10.4477 4.44772 10 5 10H21C22.1046 10 23 10.8954 23 12C23 13.1046 22.1046 14 21 14H5C4.44771 14 4 13.5523 4 13V11Z",fill:"white"}),te("rect",{className:"adyen-checkout__card__cvc__hint__location",x:"16.5",y:"9.5",width:"7",height:"5",rx:"2.5",stroke:"#D10244"})))}function or(e){var t,a,r=e.label,n=e.onFocusField,i=void 0===n?function(){}:n,o=e.error,s=void 0===o?"":o,c=e.className,d=void 0===c?"":c,l=e.classNameModifiers,u=void 0===l?[]:l,p=e.focused,m=e.filled,h=e.isValid,f=e.frontCVC,y=void 0!==f&&f,b=e.hideCVCForBrand,v=void 0!==b&&b,g=e.cvcRequired,k=void 0===g||g,C=nt().i18n,_=je()(d,((t={"adyen-checkout__field__cvc":!0})[tr.a["adyen-checkout__card__cvc__input--hidden"]]=v,t["adyen-checkout__field__cvc--optional"]=!k,t)),N=je()(((a={"adyen-checkout__input":!0,"adyen-checkout__input--small":!0,"adyen-checkout__card__cvc__input":!0,"adyen-checkout__input--error":s,"adyen-checkout__input--focus":p,"adyen-checkout__input--valid":h})[tr.a["adyen-checkout__input"]]=!0,a)),w=k?r:C.get("creditCard.cvcField.title.optional");return te(St,{label:w,focused:p,filled:m,classNameModifiers:z(u,["securityCode"]),onFocusField:function(){return i("encryptedSecurityCode")},className:_,errorMessage:s&&C.get(s),isValid:h},te("span",{className:N,"data-cse":"encryptedSecurityCode"}),te(ir,{frontCVC:y}))}function sr(e){var t=e.label,a=e.focused,r=e.filled,n=e.onFocusField,i=e.className,o=void 0===i?"":i,s=e.error,c=void 0===s?"":s,d=e.isValid,l=void 0!==d&&d,u=nt().i18n;return te(St,{label:t,classNameModifiers:["expiryDate"],className:o,focused:a,filled:r,onFocusField:function(){return n("encryptedExpiryDate")},errorMessage:c&&u.get(c),isValid:l},te("span",{"data-cse":"encryptedExpiryDate",className:je()("adyen-checkout__input","adyen-checkout__input--small","adyen-checkout__card__exp-date__input",[tr.a["adyen-checkout__input"]],{"adyen-checkout__input--error":c,"adyen-checkout__input--focus":a,"adyen-checkout__input--valid":l})}))}function cr(e){var t=e.brand,a=e.cvcRequired,r=e.dualBrandingElements,n=e.dualBrandingChangeHandler,i=e.dualBrandingSelected,o=e.errors,s=e.focusedElement,c=e.hasCVC,d=e.hideCVCForBrand,l=e.onFocusField,u=e.showBrandIcon,p=e.valid,m=nt().i18n;return te("div",{className:"adyen-checkout__card__form"},te(nr,{brand:t,error:o.encryptedCardNumber,focused:"encryptedCardNumber"===s,isValid:!!p.encryptedCardNumber,label:m.get("creditCard.numberField.title"),onFocusField:l,filled:!!o.encryptedCardNumber||!!p.encryptedCardNumber,showBrandIcon:u,dualBrandingElements:r,dualBrandingChangeHandler:n,dualBrandingSelected:i}),te("div",{className:"adyen-checkout__card__exp-cvc adyen-checkout__field-wrapper"},te(sr,{error:o.encryptedExpiryDate||o.encryptedExpiryYear||o.encryptedExpiryMonth,focused:"encryptedExpiryDate"===s,isValid:!!p.encryptedExpiryMonth&&!!p.encryptedExpiryYear,filled:!!o.encryptedExpiryDate||!!p.encryptedExpiryYear,label:m.get("creditCard.expiryDateField.title"),onFocusField:l,className:"adyen-checkout__field--50"}),c&&te(or,{cvcRequired:a,error:o.encryptedSecurityCode,focused:"encryptedSecurityCode"===s,hideCVCForBrand:d,isValid:!!p.encryptedSecurityCode,filled:!!o.encryptedSecurityCode||!!p.encryptedSecurityCode,label:m.get("creditCard.cvcField.title"),onFocusField:l,className:"adyen-checkout__field--50",frontCVC:"amex"===t})))}function dr(e){var t=e.onChange,a=e.placeholder,r=e.value,n=e.required,i=e.error,o=void 0!==i&&i,s=e.isValid,c=nt().i18n;return te(St,{label:c.get("creditCard.holderName"),className:"adyen-checkout__card__holderName",errorMessage:o&&c.get("creditCard.holderName.invalid"),isValid:!!s},Ut("text",{className:"adyen-checkout__card__holderName__input "+tr.a["adyen-checkout__input"],placeholder:a||c.get("creditCard.holderName.placeholder"),value:r,required:n,onInput:t}))}function lr(e){var t,a,r=nt().i18n,n=e.amount,i=e.brand,o=e.onChange,s=e.type,c=e.installmentOptions[i]||e.installmentOptions.card,d=Ge((null===c||void 0===c?void 0:c.preselectedValue)||(null===c||void 0===c?void 0:c.values[0])),l=d[0],u=d[1],p=Ge("onetime"),m=p[0],h=p[1],f=null===(t=null===c||void 0===c?void 0:c.plans)||void 0===t?void 0:t.includes("revolving"),y=function(e){var t=e.currentTarget.getAttribute("data-value");u(Number(t))},b=function(e){var t,a,i;return"amount"===s?(t="installmentOption",a={count:e,values:{times:e,partialValue:(i=e,r.amount(n.value/i,n.currency))}}):(t="installmentOptionMonths",a={count:e,values:{times:e}}),{id:e,name:n.value?r.get(t,a):""+e}};return Ye((function(){var e,t=(null===(e=null===c||void 0===c?void 0:c.values)||void 0===e?void 0:e.includes(l))?l:null===c||void 0===c?void 0:c.values[0];u(t)}),[i]),Ye((function(){var e=D(D({value:l},f&&"revolving"===m&&{plan:m,value:1}),f&&"onetime"===m&&{value:1});o(c?e:{value:null})}),[l,c,m]),c?0===n.value?null:te("div",{className:"adyen-checkout__installments"},f?te(Ft,{classNameModifiers:["revolving-plan"],label:""},te(Et,{items:[{id:"onetime",name:"installments.oneTime"},{id:"installments",name:"installments.installments"},{id:"revolving",name:"installments.revolving"}],i18n:r,onChange:function(e){var t=e.currentTarget.getAttribute("value");h(t)},value:m}),te(St,{className:"installments"!==m?""+tr.a["revolving-plan-installments__disabled"]:""+tr.a["revolving-plan-installments"],classNameModifiers:["revolving-plan-installments"]},Ut("select",{items:c.values.map(b),selected:l,onChange:y,name:"installments"}))):te(St,{label:r.get("installments"),classNameModifiers:["installments"]},Ut("select",{items:c.values.map(b),selected:l,onChange:y,name:"installments",readonly:1===(null===(a=null===c||void 0===c?void 0:c.values)||void 0===a?void 0:a.length)}))):null}lr.defaultProps={brand:"",amount:{},onChange:function(){}};var ur=lr;function pr(e){var t,a=nt().i18n,r=function(e){return void 0===e&&(e=""),6===e.length||10===e.length},n=Ge({taxNumber:e.taxNumber}),i=n[0],o=n[1],s=Ge({taxNumber:r(e.taxNumber)}),c=s[0],d=s[1],l=Ge({}),u=l[0],p=l[1],m=Ze((function(){var e;return(null===(e=i.taxNumber)||void 0===e?void 0:e.length)>6?a.get("creditCard.taxNumber.labelAlt"):a.get("creditCard.taxNumber.label")}),[i.taxNumber]),h=function(e){o(D(D({},i),{taxNumber:e.target.value})),d(D(D({},c),{taxNumber:r(e.target.value)})),p(D(D({},u),{taxNumber:!1}))};return Ye((function(){e.onChange(i,c)}),[i.taxNumber]),Ye((function(){return function(){e.onChange({taxNumber:void 0},{taxNumber:!1})}}),[]),this.showValidation=function(){p({taxNumber:!r(i.taxNumber)})},te("div",{className:"adyen-checkout__card__kcp-authentication"},te(St,{label:m,filled:e.filled,classNameModifiers:["kcp-taxNumber"],errorMessage:u.taxNumber&&a.get("creditCard.taxNumber.invalid"),isValid:c.taxNumber},Ut("tel",{className:"adyen-checkout__card__kcp-taxNumber__input "+tr.a["adyen-checkout__input"],placeholder:a.get("creditCard.taxNumber.placeholder"),maxLength:10,minLength:6,autoComplete:!1,value:i.taxNumber,required:!0,onChange:h,onInput:h})),te(St,{label:a.get("creditCard.encryptedPassword.label"),focused:"encryptedPassword"===e.focusedElement,filled:e.filled,classNameModifiers:["50","koreanAuthentication-encryptedPassword"],onFocusField:function(){return e.onFocusField("encryptedPassword")},errorMessage:e.encryptedPasswordState.errors&&a.get("creditCard.encryptedPassword.invalid"),isValid:e.encryptedPasswordState.valid},te("span",{"data-cse":"encryptedPassword",className:je()((t={"adyen-checkout__input":!0,"adyen-checkout__input--large":!0},t[tr.a["adyen-checkout__input"]]=!0,t["adyen-checkout__input--error"]=e.encryptedPasswordState.errors,t["adyen-checkout__input--valid"]=e.encryptedPasswordState.valid,t["adyen-checkout__input--focus"]="encryptedPassword"===e.focusedElement,t))})))}var mr=a(11),hr=a.n(mr),fr=function(e){var t,a,r=e.children,n=e.status,i=je()("adyen-checkout__loading-input__form",hr.a["loading-input__form"],((t={})[hr.a["loading-input__form--loading"]]="loading"===n,t));return te("div",{style:{position:"relative"}},te("div",{className:je()(((a={})[hr.a["loading-input__spinner"]]=!0,a[hr.a["loading-input__spinner--active"]]="loading"===n,a))},te(Ee,null)),te("div",{className:i},r))};function yr(e){var t=e.brand,a=e.hasCVC,r=e.onFocusField,n=e.errors,i=e.valid,o=A(e,["brand","hasCVC","onFocusField","errors","valid"]),s=nt().i18n;return te("div",{className:"adyen-checkout__card__form adyen-checkout__card__form--oneClick","aria-label":s.get("creditCard.storedCard.description.ariaLabel").replace("%@",o.lastFour)+" "+s.get("creditCard.expiryDateField.title")+" "+o.expiryMonth+"/"+o.expiryYear},te("div",{className:"adyen-checkout__card__exp-cvc adyen-checkout__field-wrapper"},te(St,{label:s.get("creditCard.expiryDateField.title"),className:"adyen-checkout__field--50",classNameModifiers:["storedCard"],disabled:!0},te("div",{className:"adyen-checkout__input adyen-checkout__input--disabled adyen-checkout__card__exp-date__input--oneclick"},o.expiryMonth," / ",o.expiryYear)),a&&te(or,{cvcRequired:o.cvcRequired,error:n.encryptedSecurityCode,focused:"encryptedSecurityCode"===o.focusedElement,filled:!!i.encryptedSecurityCode||!!n.encryptedSecurityCode,hideCVCForBrand:o.hideCVCForBrand,isValid:!!i.encryptedSecurityCode,label:s.get("creditCard.cvcField.title"),onFocusField:r,className:"adyen-checkout__field--50",classNameModifiers:["storedCard"],frontCVC:"amex"===t})))}var br,vr="encryptedCardNumber",gr="encryptedExpiryDate",kr="encryptedExpiryMonth",Cr="encryptedExpiryYear",_r="encryptedSecurityCode",Nr="encryptedPassword",wr=["amex","mc","visa"],Pr=["sepa","sepadirectdebit","ach","giftcard"],Fr="required",xr="optional",Sr="hidden",Dr="Unsupported card entered",Ar=((br={})["incomplete field"]="error.va.gen.01",br["field not valid"]="error.va.gen.02",br["luhn check failed"]="error.va.sf-cc-num.01",br["Card too old"]="error.va.sf-cc-dat.01",br["Date too far in future"]="error.va.sf-cc-dat.02",br["Unsupported card entered"]="error.va.sf-cc-num.03",br),Br=Ar["incomplete field"],Tr=function(e,t){return t===gr?(e.encryptedExpiryMonth=!1,e.encryptedExpiryYear=!1):e[t]=!1,e},zr=function(e,t){return function(a,r){var n=!0!==t.valid[r]?function(e,t){return 1!==t||e!==kr&&e!==Cr?e:gr}(r,e):null;return(n=function(e,t){var a=e===_r,r=!t.errors.encryptedSecurityCode;return(t.cvcPolicy===xr||t.cvcPolicy===Sr)&&r&&a?null:e}(n,t))&&!a.includes(n)&&a.push(n),a}};function Mr(e){return"object"===typeof e&&null!==e&&"[object Array]"===Object.prototype.toString.call(e)}function Ir(){for(var e=[],t=0;t<arguments.length;t++)e[t]=arguments[t];var a=Mr(e[0])?e[0]:e;return{from:function(e){return a.map((function(t){var a;return t in e?((a={})[t]=e[t],a):{}})).reduce((function(e,t){return D(D({},e),t)}),{})}}}var jr=Object.prototype.toString;function Er(e){return"object"===typeof e&&null!==e&&"[object Array]"===Object.prototype.toString.call(e)}function Or(e){return e.hideCVC?Sr:!0===e.cvcRequired?Fr:xr}function Rr(e){return null!=e}function Vr(e){return!1!==e&&Rr(e)}function Lr(e){return!!e&&"object"===typeof e}function Ur(e,t){void 0===e&&(e={}),void 0===t&&(t={});var a=Object.keys(e),r=Object.keys(t);if(a.length!==r.length)return!1;for(var n=0,i=a;n<i.length;n++){var o=i[n];if(Lr(e[o])&&!Ur(e[o],t[o]))return!1;if(e[o]!==t[o])return!1}return!0}function Kr(e){return!Vr(e)||(!(!("number"===typeof(t=e)||Lr(t)&&"[object Number]"===jr.call(t))||0!==e&&!Number.isNaN(e))||(!(!Er(e)&&!function(e){return"string"===typeof e||Lr(e)&&"[object String]"===jr.call(e)}(e)||0!==e.length)||!(!Lr(e)||0!==Object.keys(e).length)));var t}var qr=window.console&&window.console.error&&window.console.error.bind(window.console),Hr=(window.console&&window.console.info&&window.console.info.bind(window.console),window.console&&window.console.log&&window.console.log.bind(window.console)),Gr=window.console&&window.console.warn&&window.console.warn.bind(window.console);function Yr(){var e;this.config.cardGroupTypes=Er(e=this.props.cardGroupTypes)&&e.length?e:wr;var t=this.props.loadingContext;if(t){var a;this.config.loadingContext="/"===(a=t).charAt(a.length-1)?t:t+"/",this.config.locale=this.props.locale,this.config.isCreditCardType=!1===Pr.includes(this.props.type),this.config.iframeUIConfig=this.props.iframeUIConfig,this.config.allowedDOMAccess=!(!1===this.props.allowedDOMAccess||"false"===this.props.allowedDOMAccess),this.config.autoFocus=!(!1===this.props.autoFocus||"false"===this.props.autoFocus),this.config.showWarnings=!0===this.props.showWarnings||"true"===this.props.showWarnings,this.config.trimTrailingSeparator=!(!1===this.props.trimTrailingSeparator||"false"===this.props.trimTrailingSeparator),this.config.keypadFix=!(!1===this.props.keypadFix||"false"===this.props.keypadFix),this.config.sfLogAtStart=!0===this.props._b$dl;var r=this.config.isCreditCardType?"card":this.props.type;r.indexOf("sepa")>-1&&(r="iban");var n=this.props.clientKey?this.props.clientKey:this.props.originKey,i=btoa(window.location.origin);this.config.iframeSrc=this.config.loadingContext+"securedfields/"+n+"/3.3.1/securedFields.html?type="+r+"&d="+i}else Gr("WARNING Config :: no loadingContext has been specified!")}var Wr=function(){};function Jr(e){void 0===e&&(e={}),this.callbacks.onLoad=e.onLoad?e.onLoad:Wr,this.callbacks.onConfigSuccess=e.onConfigSuccess?e.onConfigSuccess:Wr,this.callbacks.onFieldValid=e.onFieldValid?e.onFieldValid:Wr,this.callbacks.onAllValid=e.onAllValid?e.onAllValid:Wr,this.callbacks.onBrand=e.onBrand?e.onBrand:Wr,this.callbacks.onError=e.onError?e.onError:Wr,this.callbacks.onFocus=e.onFocus?e.onFocus:Wr,this.callbacks.onBinValue=e.onBinValue?e.onBinValue:Wr,this.callbacks.onAutoComplete=e.onAutoComplete?e.onAutoComplete:Wr,this.callbacks.onAdditionalSFConfig=e.onAdditionalSFConfig?e.onAdditionalSFConfig:Wr,this.callbacks.onAdditionalSFRemoved=e.onAdditionalSFRemoved?e.onAdditionalSFRemoved:Wr}var Zr=function(e,t,a){if(t){var r=JSON.stringify(e);t.postMessage(r,a)}};function Qr(e){var t,a;if(e.fieldType===vr){var r={brand:e.brand,cvcPolicy:e.cvcPolicy?e.cvcPolicy:Or(e)},n=(t=r,a=this.state.brand,!Ur(t,a));if(!n)return null;var i="card"===this.state.type;if(i&&n){this.state.brand=r;var o={txVariant:this.state.type,brand:r.brand};if(Object.prototype.hasOwnProperty.call(this.state.securedFields,_r)){var s=D(D({},o),{fieldType:_r,hideCVC:e.cvcPolicy===Sr,cvcRequired:e.cvcPolicy===Fr,numKey:this.state.securedFields.encryptedSecurityCode.numKey});Zr(s,this.getIframeContentWin(_r),this.config.loadingContext)}}var c=i?D(D(D({},e.brand&&{brand:e.brand}),e.cvcText&&{cvcText:e.cvcText}),e.cvcPolicy&&{cvcPolicy:e.cvcPolicy}):null;if(c&&c.brand){var d=c;d.type=this.state.type,d.rootNode=this.props.rootNode,this.callbacks.onBrand(d)}return c}return null}var $r=function(e,t,a,r,n,i){return{fieldType:e,encryptedFieldName:t,uid:a,valid:r,type:n,rootNode:i}},Xr=function(e,t){var a=[];return e&&"function"===typeof e.querySelectorAll&&(a=[].slice.call(e.querySelectorAll(t))),a},en=function(e,t){if(e)return e.querySelector(t)},tn=function(e,t){if(e)return e.getAttribute(t)},an=function(e,t,a,r){if("function"!==typeof e.addEventListener){if(!e.attachEvent)throw new Error(": Unable to bind "+t+"-event");e.attachEvent("on"+t,a)}else e.addEventListener(t,a,r)},rn=function(e,t,a,r){if("function"===typeof e.addEventListener)e.removeEventListener(t,a,r);else{if(!e.attachEvent)throw new Error(": Unable to unbind "+t+"-event");e.detachEvent("on"+t,a)}},nn=function(e,t,a,r,n){if(!Object.prototype.hasOwnProperty.call(e,"error"))return null;var i=t,o={rootNode:r,fieldType:e.fieldType,error:null,type:null},s=""!==e.error;return s||i.hasError?i.errorType===Ar["Unsupported card entered"]?null:(o.error=s?e.error:"",o.type=a,i.hasError=s,i.errorType=o.error,n(o),o):null};function on(e){var t,a,r,n,i=e.fieldType;if("card"===this.state.type&&Object.prototype.hasOwnProperty.call(e,"cvcRequired")&&Rr(e.cvcRequired)&&Object.prototype.hasOwnProperty.call(this.state.securedFields,_r)){var o=Or(e);this.state.securedFields.encryptedSecurityCode.cvcPolicy=o,e.cvcPolicy=o}if(nn(e,this.state.securedFields[i],this.state.type,this.props.rootNode,this.callbacks.onError),this.state.securedFields[i].isEncrypted){t=function(e,t,a){var r,n,i=e===gr,o=[],s=["encryptedExpiryMonth","encryptedExpiryYear"],c=i?2:1;for(r=0;r<c;r+=1){n=i?s[r]:e;var d=$r(e,i?n:e,t+"-encrypted-"+n,!1,t,a);o.push(d)}return o}(i,this.state.type,this.props.rootNode),i===vr&&(t[0].endDigits="");for(var s=0,c=t.length;s<c;s+=1)this.config.allowedDOMAccess&&(a=this.props.rootNode,r=t[s].uid,n=void 0,(n=en(a,"#"+r))&&a.removeChild(n)),this.callbacks.onFieldValid(t[s]);this.state.securedFields[i].isEncrypted=!1}this.assessFormValidity(),Object.prototype.hasOwnProperty.call(e,"brand")&&this.processBrand(e)}function sn(e){var t,a,r=e.fieldType;this.config.autoFocus&&("year"!==e.type&&r!==Cr||this.setFocusOnFrame(_r),r===kr&&this.setFocusOnFrame(Cr));var n=e[r];this.state.securedFields[r].isEncrypted=!0,this.config.allowedDOMAccess&&function(e,t,a){var r,n,i,o,s,c,d,l;for(r=0;r<e.length;r+=1){var u=e[r];n=t+"-encrypted-"+(i=u.encryptedFieldName),s=i,c=u.blob,l=void 0,(l=en(o=a,"#"+(d=n)))||((l=document.createElement("input")).type="hidden",l.name=s,l.id=d,o.appendChild(l)),l.setAttribute("value",c)}}(n,this.state.type,this.props.rootNode),nn({error:"",fieldType:r},this.state.securedFields[r],this.state.type,this.props.rootNode,this.callbacks.onError);var i=function(e,t,a,r){var n,i,o,s,c,d=[];for(n=0;n<r.length;n+=1){i=t+"-encrypted-"+(s=(o=r[n]).encryptedFieldName),c=o.blob;var l=$r(e,s,i,!0,t,a);l.blob=c,d.push(l)}return d}(r,this.state.type,this.props.rootNode,n);for(r===vr&&Vr(e.endDigits)&&(i[0].endDigits=e.endDigits),t=0,a=i.length;t<a;t+=1)this.callbacks.onFieldValid(i[t]);this.assessFormValidity()}var cn={__NO_BRAND:"noBrand",cards:[]};cn.cards.push({cardType:"mc",startingRules:[51,52,53,54,55,22,23,24,25,26,27],permittedLengths:[16],pattern:/^(5[1-5][0-9]{0,14}|2[2-7][0-9]{0,14})$/,securityCode:"CVC"}),cn.cards.push({cardType:"visadankort",startingRules:[4571],permittedLengths:[16],pattern:/^(4571)[0-9]{0,12}$/}),cn.cards.push({cardType:"visa",startingRules:[4],permittedLengths:[13,16,19],pattern:/^4[0-9]{0,18}$/,securityCode:"CVV"}),cn.cards.push({cardType:"amex",startingRules:[34,37],permittedLengths:[15],pattern:/^3[47][0-9]{0,13}$/,securityCode:"CID"}),cn.cards.push({cardType:"diners",startingRules:[36],permittedLengths:[14],pattern:/^(36)[0-9]{0,12}$/}),cn.cards.push({cardType:"maestrouk",startingRules:[6759],permittedLengths:[16,18,19],pattern:/^(6759)[0-9]{0,15}$/}),cn.cards.push({cardType:"solo",startingRules:[6767],permittedLengths:[16,18,19],pattern:/^(6767)[0-9]{0,15}$/}),cn.cards.push({cardType:"laser",startingRules:[6304,6706,677117,677120],permittedLengths:[16,17,18,19],pattern:/^(6304|6706|6709|6771)[0-9]{0,15}$/,cvcRequired:!1}),cn.cards.push({cardType:"discover",startingRules:[6011,644,645,646,647,648,649,65],permittedLengths:[16],pattern:/^(6011[0-9]{0,12}|(644|645|646|647|648|649)[0-9]{0,13}|65[0-9]{0,14})$/}),cn.cards.push({cardType:"jcb",startingRules:[3528,3529,353,354,355,356,357,358],permittedLengths:[16,19],pattern:/^(352[8,9]{1}[0-9]{0,15}|35[4-8]{1}[0-9]{0,16})$/,securityCode:"CAV"}),cn.cards.push({cardType:"bcmc",startingRules:[6703,479658,606005],permittedLengths:[16,17,18,19],pattern:/^((6703)[0-9]{0,15}|(479658|606005)[0-9]{0,13})$/,cvcRequired:!1,hideCVC:!0}),cn.cards.push({cardType:"bijcard",startingRules:[5100081],permittedLengths:[16],pattern:/^(5100081)[0-9]{0,9}$/}),cn.cards.push({cardType:"dankort",startingRules:[5019],permittedLengths:[16],pattern:/^(5019)[0-9]{0,12}$/}),cn.cards.push({cardType:"hipercard",startingRules:[606282],permittedLengths:[16],pattern:/^(606282)[0-9]{0,10}$/}),cn.cards.push({cardType:"cup",startingRules:[62,81],permittedLengths:[14,15,16,17,18,19],pattern:/^(62|81)[0-9]{0,17}$/}),cn.cards.push({cardType:"maestro",startingRules:[50,56,57,58,6],permittedLengths:[16,17,18,19],pattern:/^(5[0|6-8][0-9]{0,17}|6[0-9]{0,18})$/,cvcRequired:!1}),cn.cards.push({cardType:"elo",startingRules:[506699,50670,50671,50672,50673,50674,50675,50676,506770,506771,506772,506773,506774,506775,506776,506777,506778,401178,438935,451416,457631,457632,504175,627780,636297,636368,651653,506728,509096,509083,509082,655001,650487,509081,509074,509066,431274,438935,457631,457632,506744,506747,506748,506753,509069,650906,506730,509067,655003,509068],permittedLengths:[16],pattern:/^((((506699)|(506770)|(506771)|(506772)|(506773)|(506774)|(506775)|(506776)|(506777)|(506778)|(401178)|(438935)|(451416)|(457631)|(457632)|(504175)|(627780)|(636368)|(636297))[0-9]{0,10})|((50676)|(50675)|(50674)|(50673)|(50672)|(50671)|(50670))[0-9]{0,11})$/}),cn.cards.push({cardType:"uatp",startingRules:[1],permittedLengths:[15],pattern:/^1[0-9]{0,14}$/,cvcRequired:!1}),cn.cards.push({cardType:"cartebancaire",startingRules:[4,5,6],permittedLengths:[16],pattern:/^[4-6][0-9]{0,15}$/}),cn.cards.push({cardType:"visaalphabankbonus",startingRules:[450903],permittedLengths:[16],pattern:/^(450903)[0-9]{0,10}$/}),cn.cards.push({cardType:"mcalphabankbonus",startingRules:[510099],permittedLengths:[16],pattern:/^(510099)[0-9]{0,10}$/}),cn.cards.push({cardType:"hiper",startingRules:[637095,637568,637599,637609,637612],permittedLengths:[16],pattern:/^(637095|637568|637599|637609|637612)[0-9]{0,10}$/}),cn.cards.push({cardType:"oasis",startingRules:[982616],permittedLengths:[16],pattern:/^(982616)[0-9]{0,10}$/,cvcRequired:!1}),cn.cards.push({cardType:"karenmillen",startingRules:[98261465],permittedLengths:[16],pattern:/^(98261465)[0-9]{0,8}$/,cvcRequired:!1}),cn.cards.push({cardType:"warehouse",startingRules:[982633],permittedLengths:[16],pattern:/^(982633)[0-9]{0,10}$/,cvcRequired:!1}),cn.cards.push({cardType:"mir",startingRules:[220],permittedLengths:[16,17,18,19],pattern:/^(220)[0-9]{0,16}$/}),cn.cards.push({cardType:"codensa",startingRules:[590712],permittedLengths:[16],pattern:/^(590712)[0-9]{0,10}$/}),cn.cards.push({cardType:"naranja",startingRules:[377798,377799,402917,402918,527571,527572,589562],permittedLengths:[16,17,18,19],pattern:/^(37|40|5[28])([279])\d*$/}),cn.cards.push({cardType:"cabal",startingRules:[589657,600691,603522,6042,6043,636908],permittedLengths:[16,17,18,19],pattern:/^(58|6[03])([03469])\d*$/}),cn.cards.push({cardType:"shopping",startingRules:[2799,589407,603488],permittedLengths:[16,17,18,19],pattern:/^(27|58|60)([39])\d*$/}),cn.cards.push({cardType:"argencard",startingRules:[501],permittedLengths:[16,17,18,19],pattern:/^(50)(1)\d*$/}),cn.cards.push({cardType:"troy",startingRules:[9792],permittedLengths:[16],pattern:/^(97)(9)\d*$/}),cn.cards.push({cardType:"forbrugsforeningen",startingRules:[600722],permittedLengths:[16],pattern:/^(60)(0)\d*$/}),cn.cards.push({cardType:"vpay",startingRules:[401,408,413,434,435,437,439,441,442,443,444,446,447,455,458,460,461,463,466,471,479,482,483,487],permittedLengths:[13,14,15,16,17,18,19],pattern:/^(40[1,8]|413|43[4,5]|44[1,2,3,4,6,7]|45[5,8]|46[0,1,3,6]|47[1,9]|48[2,3,7])[0-9]{0,16}$/});var dn=function(e){return cn.cards.filter((function(t){return t.cardType===e}))[0]},ln=function(e){return void 0===e&&(e="card"),"card"===e||"scheme"===e};cn.__NO_BRAND,cn.cards;var un=function(e){var t=Ar[e];return t||((t=Object.keys(Ar).find((function(t){return Ar[t]===e})))||e)},pn=function(e,t){var a=D({},e);return a.error=a.error?a.error:function(e){return Object.keys(Ar).reduce((function(t,a){var r=Ar[a];return(r.indexOf("sf-")>-1||r.indexOf("gen.01")>-1)&&(t[r]=e.get(r)),t}),{})}(t),a};var mn=function(e){function t(t,a){var r=e.call(this)||this,n=["fieldType","iframeSrc","cvcPolicy","loadingContext","holderEl"],i=function(){for(var e=[],t=0;t<arguments.length;t++)e[t]=arguments[t];var a=Mr(e[0])?e[0]:e;return{from:function(e){var t=Object.keys(e).filter((function(e){return!a.includes(e)}));return Ir.apply(void 0,t).from(e)}}}(n).from(t);r.config=D(D(D({},r.config),i),{iframeUIConfig:D({},i.iframeUIConfig)});var o=Ir(n).from(t);return r.fieldType=o.fieldType,r.cvcPolicy=o.cvcPolicy,r.iframeSrc=o.iframeSrc,r.loadingContext=o.loadingContext,r.holderEl=o.holderEl,r.isValid=!1,r.iframeContentWindow=null,r.numKey=function(){if(!window.crypto)return 4294967296*Math.random()|0;var e=new Uint32Array(1);return window.crypto.getRandomValues(e),e[0]}(),r.isEncrypted=!1,r.hasError=!1,r.errorType="",r.init(a)}return S(t,e),t.prototype.init=function(e){var t=function(e,t,a){var r,n,i="card"===e.txVariant?"creditCard":e.txVariant,o=a.get(i+"."+t+".aria.iframeTitle"),s=a.get(i+"."+t+".aria.label"),c=we(e,"iframeUIConfig.ariaConfig.lang")||e.locale,d=we(e,"iframeUIConfig.ariaConfig."+t);n=d?D(D({},d),{iframeTitle:d.iframeTitle||o,label:d.label||s}):{iframeTitle:o,label:s};var l=pn(n,a);return D(D({},c&&{lang:c}),((r={})[t]=l,r))}(this.config,this.fieldType,e);this.config.iframeUIConfig.ariaConfig=t;var a=function(e,t,a){var r,n=e.iframeUIConfig.placeholders?e.iframeUIConfig.placeholders[t]:void 0;return"undefined"===typeof n&&(n=function(e){var t;return(t={}).encryptedCardNumber=e.get&&e.get("creditCard.numberField.placeholder"),t.encryptedExpiryDate=e.get&&e.get("creditCard.expiryDateField.placeholder"),t.encryptedExpiryMonth=e.get&&e.get("creditCard.expiryDateField.month.placeholder"),t.encryptedExpiryYear=e.get&&e.get("creditCard.expiryDateField.year.placeholder"),t.encryptedSecurityCode=e.get&&e.get("creditCard.cvcField.placeholder"),t.encryptedPassword=e.get&&e.get("creditCard.encryptedPassword.placeholder"),t}(a)[t]),(r={})[t]=n,r}(this.config,this.fieldType,e);this.config.iframeUIConfig.placeholders=a;var r=function(e){var t=e.src,a=e.title,r=void 0===a?"iframe element":a,n=e.policy,i=void 0===n?"origin":n,o=e.styleStr,s=void 0===o?"border: none; height:100%; width:100%;":o,c=document.createElement("iframe");c.setAttribute("src",t),c.setAttribute("class","js-iframe"),c.setAttribute("title",r),c.setAttribute("frameborder","0"),c.setAttribute("scrolling","no"),c.setAttribute("allowtransparency","true"),c.setAttribute("style",s),c.setAttribute("referrerpolicy",i);var d=document.createTextNode("<p>Your browser does not support iframes.</p>");return c.appendChild(d),c}({src:this.iframeSrc,title:t[this.fieldType].iframeTitle,policy:"origin"});this.holderEl.appendChild(r);var n=en(this.holderEl,".js-iframe");return n&&(this.iframeContentWindow=n.contentWindow,this.iframeOnLoadListener=this.iframeOnLoadListenerFn,an(n,"load",this.iframeOnLoadListener,!1)),this},t.prototype.iframeOnLoadListenerFn=function(){rn(window,"load",this.iframeOnLoadListener,!1),this.postMessageListener=this.postMessageListenerFn,an(window,"message",this.postMessageListener,!1);var e={fieldType:this.fieldType,cvcRequired:this.cvcPolicy===Fr,numKey:this.numKey,txVariant:this.config.txVariant,extraFieldData:this.config.extraFieldData,cardGroupTypes:this.config.cardGroupTypes,iframeUIConfig:this.config.iframeUIConfig,sfLogAtStart:this.config.sfLogAtStart,showWarnings:this.config.showWarnings,trimTrailingSeparator:this.config.trimTrailingSeparator,isCreditCardType:this.config.isCreditCardType};Zr(e,this.iframeContentWindow,this.loadingContext),this.onIframeLoadedCallback()},t.prototype.postMessageListenerFn=function(e){if(function(e,t,a){var r=e.origin,n=t.indexOf("/checkoutshopper/"),i=n>-1?t.substring(0,n):t,o=i.length-1;return"/"===i.charAt(o)&&(i=i.substring(0,o)),r===i||(a&&(Gr("####################################################################################"),Gr("WARNING postMessageValidation: postMessage listener for iframe::origin mismatch!\n Received message with origin:",r,"but the only allowed origin for messages to CSF is",i),Gr("### event.data=",e.data),Gr("####################################################################################")),!1)}(e,this.loadingContext,this.config.showWarnings)){var t;0;try{t=JSON.parse(e.data)}catch(t){return function(e){return e.data&&e.data.type&&"string"===typeof e.data.type&&e.data.type.indexOf("webpack")>-1}(e)?void(this.config.showWarnings&&Hr("### SecuredField::postMessageListenerFn:: PARSE FAIL - WEBPACK")):function(e){return e.data&&"string"===typeof e.data&&e.data.indexOf("cvox")>-1}(e)?void(this.config.showWarnings&&Hr("### SecuredField::postMessageListenerFn:: PARSE FAIL - CHROMEVOX")):void(this.config.showWarnings&&Hr("### SecuredField::postMessageListenerFn:: PARSE FAIL - UNKNOWN REASON: event.data=",e.data))}if(Object.prototype.hasOwnProperty.call(t,"action")&&Object.prototype.hasOwnProperty.call(t,"numKey"))if(this.numKey===t.numKey)switch(t.action){case"encryption":this.isValid=!0,this.onEncryptionCallback(t);break;case"config":this.onConfigCallback(t);break;case"focus":this.onFocusCallback(t);break;case"binValue":this.onBinValueCallback(t);break;case"click":this.onClickCallback(t);break;case"shifttab":this.onShiftTabCallback(t);break;case"autoComplete":this.onAutoCompleteCallback(t);break;default:this.isValid=!1,this.onValidationCallback(t)}else this.config.showWarnings&&Gr("WARNING SecuredField :: postMessage listener for iframe :: data mismatch! (Probably a message from an unrelated securedField)");else this.config.showWarnings&&Gr("WARNING SecuredField :: postMessage listener for iframe :: data mismatch!")}},t.prototype.destroy=function(){rn(window,"message",this.postMessageListener,!1),this.iframeContentWindow=null,function(e){for(;e.firstChild;)e.removeChild(e.firstChild)}(this.holderEl)},t.prototype.onIframeLoaded=function(e){return this.onIframeLoadedCallback=e,this},t.prototype.onEncryption=function(e){return this.onEncryptionCallback=e,this},t.prototype.onValidation=function(e){return this.onValidationCallback=e,this},t.prototype.onConfig=function(e){return this.onConfigCallback=e,this},t.prototype.onFocus=function(e){return this.onFocusCallback=e,this},t.prototype.onBinValue=function(e){return this.onBinValueCallback=e,this},t.prototype.onClick=function(e){return this.onClickCallback=e,this},t.prototype.onShiftTab=function(e){return this.onShiftTabCallback=e,this},t.prototype.onAutoComplete=function(e){return this.onAutoCompleteCallback=e,this},Object.defineProperty(t.prototype,"errorType",{get:function(){return this._errorType},set:function(e){this._errorType=e},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"hasError",{get:function(){return this._hasError},set:function(e){this._hasError=e},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"isValid",{get:function(){if(this.fieldType===_r)switch(this.cvcPolicy){case Sr:return!0;case xr:return!this.hasError;default:return this._isValid}return this._isValid},set:function(e){this._isValid=e},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"cvcPolicy",{get:function(){return this._cvcPolicy},set:function(e){this.fieldType===_r&&e!==this.cvcPolicy&&(this._cvcPolicy=e,this.hasError&&"isValidated"===this.errorType&&(this.hasError=!1))},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"iframeContentWindow",{get:function(){return this._iframeContentWindow},set:function(e){this._iframeContentWindow=e},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"isEncrypted",{get:function(){return this._isEncrypted},set:function(e){this._isEncrypted=e},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"numKey",{get:function(){return this._numKey},set:function(e){this._numKey=e},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"iframeOnLoadListener",{get:function(){return this._iframeOnLoadListener},set:function(e){this._iframeOnLoadListener=e.bind(this)},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"postMessageListener",{get:function(){return this._postMessageListener},set:function(e){this._postMessageListener=e.bind(this)},enumerable:!1,configurable:!0}),t}((function(){this.config={}})),hn={cvcRequired:!0,hideCVC:!1};function fn(){this.encryptedAttrName="data-encrypted-field";var e=Xr(this.props.rootNode,"["+this.encryptedAttrName+"]");return e.length||(this.encryptedAttrName="data-cse",e=Xr(this.props.rootNode,"["+this.encryptedAttrName+"]")),this.config.isCreditCardType?(this.isSingleBrandedCard=!1,this.hasRedundantCVCField=!1,this.securityCode="",this.createCardSecuredFields(e)):this.createNonCardSecuredFields(e)}function yn(e){return e.forEach(this.setupSecuredField.bind(this)),e.length}function bn(e){var t=this,a=this.state.type;if("card"===a&&1===this.config.cardGroupTypes.length&&(a=this.config.cardGroupTypes[0],this.state.type=a),this.isSingleBrandedCard="card"!==a,this.isSingleBrandedCard){var r=dn(a);Rr(r)?(hn.cvcRequired=!1!==r.cvcRequired,hn.hideCVC=!0===r.hideCVC,this.securityCode=r.securityCode):this.state.type="unrecognised-single-brand"}else this.config.cardGroupTypes.forEach((function(e){Rr(dn(e))||Gr('WARNING: The passed cardGroupType item "'+e+'" is not recognised by SecuredFields. This may affect whether it will be possible to process this payment.')}));if(e.forEach(this.setupSecuredField.bind(this)),this.isSingleBrandedCard){var n={type:this.state.type,rootNode:this.props.rootNode,brand:a,cvcPolicy:Or(hn),cvcText:this.securityCode};setTimeout((function(){t.callbacks.onBrand(n)}),0)}return this.hasRedundantCVCField?e.length-1:e.length}function vn(e){var t=this,a=tn(e,this.encryptedAttrName);a===Cr&&(this.state.hasSeparateDateFields=!0);var r=tn(e,"data-info");if(a===_r&&this.isSingleBrandedCard&&hn.hideCVC)this.hasRedundantCVCField=!0;else{var n={fieldType:a,extraFieldData:r,txVariant:this.state.type,cardGroupTypes:this.config.cardGroupTypes,iframeUIConfig:this.config.iframeUIConfig?this.config.iframeUIConfig:{},sfLogAtStart:this.config.sfLogAtStart,trimTrailingSeparator:this.config.trimTrailingSeparator,cvcPolicy:Or(hn),isCreditCardType:this.config.isCreditCardType,iframeSrc:this.config.iframeSrc,loadingContext:this.config.loadingContext,showWarnings:this.config.showWarnings,holderEl:e,locale:this.config.locale},i=new mn(n,this.props.i18n).onIframeLoaded((function(){if(t.state.iframeCount+=1,t.state.iframeCount===t.state.originalNumIframes){0;t.callbacks.onLoad({iframesLoaded:!0})}})).onConfig((function(e){t.handleIframeConfigFeedback(e)})).onFocus((function(e){t.handleFocus(e)})).onBinValue((function(e){t.handleBinValue(e)})).onClick((function(e){t.postMessageToAllIframes({fieldType:e.fieldType,click:!0})})).onShiftTab((function(e){t.handleSFShiftTab(e.fieldType)})).onEncryption((function(e){t.handleEncryption(e)})).onValidation((function(e){t.handleValidation(e)})).onAutoComplete((function(e){t.processAutoComplete(e)}));this.state.securedFields[a]=i}}function gn(e,t){if(Object.prototype.hasOwnProperty.call(this.state.securedFields,e)){0;var a={txVariant:this.state.type,fieldType:e,focus:!0,numKey:this.state.securedFields[e].numKey};Zr(a,this.getIframeContentWin(e),this.config.loadingContext)}}function kn(e){var t=this,a=Object.keys(e||{});a.length&&Object.keys(this.state.securedFields).forEach((function(r){var n={txVariant:t.state.type,fieldType:r,numKey:t.state.securedFields[r].numKey};a.forEach((function(t){n[t]=e[t]})),Zr(n,t.getIframeContentWin(r),t.config.loadingContext)}))}function Cn(){var e=this;this.postMessageToAllIframes({destroy:!0}),Object.keys(this.state.securedFields).forEach((function(t){var a=e.state.securedFields[t];a&&a.destroy(),e.state.securedFields[t]=null})),this.destroyTouchendListener(),this.state.securedFields={}}function _n(e){var t=this;if("cc-name"===e.name){var a=D({},e);delete a.numKey;var r=a;this.callbacks.onAutoComplete(r)}if("cc-exp"===e.name){var n=e.value.replace(/[^0-9]/gi,"/").split("/");if(2!==n.length)return;1===n[0].length&&(n[0]="0"+n[0]);var i=n[0],o=n[1].substr(2),s=i+"/"+o;if(Object.prototype.hasOwnProperty.call(this.state.securedFields,gr)){var c={txVariant:this.state.type,fieldType:gr,autoComplete:s,numKey:this.state.securedFields.encryptedExpiryDate.numKey};return void Zr(c,this.getIframeContentWin(gr),this.config.loadingContext)}if(Object.prototype.hasOwnProperty.call(this.state.securedFields,kr)){c={txVariant:this.state.type,fieldType:kr,autoComplete:i,numKey:this.state.securedFields.encryptedExpiryMonth.numKey};Zr(c,this.getIframeContentWin(kr),this.config.loadingContext)}Object.prototype.hasOwnProperty.call(this.state.securedFields,Cr)&&setTimeout((function(){var e={txVariant:t.state.type,fieldType:Cr,autoComplete:o,numKey:t.state.securedFields.encryptedExpiryYear.numKey};Zr(e,t.getIframeContentWin(Cr),t.config.loadingContext)}),0)}}function Nn(e){var t=D({},e);delete t.numKey,t.rootNode=this.props.rootNode,t.type=this.state.type;var a=t.fieldType;t.focus?this.state.currentFocusObject!==a&&(this.state.currentFocusObject=a,this.state.registerFieldForIos||this.handleAdditionalFields()):this.state.currentFocusObject===a&&(this.state.currentFocusObject=null);var r=t;r.currentFocusObject=this.state.currentFocusObject,this.callbacks.onFocus(r)}function wn(e){if(this.state.iframeConfigCount+=1,this.state.isConfigured){0;var t={additionalIframeConfigured:!0,fieldType:e.fieldType,type:this.state.type};this.callbacks.onAdditionalSFConfig(t)}else if(this.state.iframeConfigCount===this.state.originalNumIframes)return this.isConfigured(),!0;return!1}function Pn(){this.state.isConfigured=!0;var e={iframesConfigured:!0,type:this.state.type};if(this.callbacks.onConfigSuccess(e),1===this.state.numIframes&&this.config.isCreditCardType){if("card"===this.state.type)return void qr("ERROR: Payment method with a single secured field - but 'type' has not been set to a specific card brand");var t=dn(this.state.type);if(t)!(Rr(t.cvcRequired)&&!t.cvcRequired)||this.assessFormValidity()}}function Fn(){var e=function(e){for(var t=Object.keys(e),a=0,r=t.length;a<r;a+=1)if(!e[t[a]].isValid)return!1;return!0}(this.state.securedFields),t=e!==this.state.allValid;if(this.state.allValid=e,e||t){var a={allValid:e,type:this.state.type,rootNode:this.props.rootNode};this.callbacks.onAllValid(a)}}function xn(e){var t=e.binValue,a=e.encryptedBin,r=e.uuid,n={binValue:t,type:this.state.type};a&&(n.encryptedBin=a,n.uuid=r),this.callbacks.onBinValue(n)}function Sn(e){if(Object.prototype.hasOwnProperty.call(this.state.securedFields,vr)){var t=D(D({txVariant:this.state.type},e),{fieldType:vr,numKey:this.state.securedFields.encryptedCardNumber.numKey});Zr(t,this.getIframeContentWin(vr),this.config.loadingContext)}}function Dn(e){if(e){var t=e.supportedBrands[0],a=t.brand,r={brand:a,cvcPolicy:t.cvcPolicy,cvcText:"Security code",fieldType:vr};this.processBrand(r),this.sendBrandToCardSF({brand:a,enableLuhnCheck:!1!==e.supportedBrands[0].enableLuhnCheck}),"card"===this.state.type&&Object.prototype.hasOwnProperty.call(this.state.securedFields,_r)&&(this.state.securedFields.encryptedSecurityCode.cvcPolicy=t.cvcPolicy),this.assessFormValidity()}else this.sendBrandToCardSF({brand:"reset"})}var An={__IS_ANDROID:/(android)/i.test(navigator.userAgent),__IS_IE:function(){var e=navigator.userAgent,t=e.indexOf("MSIE ");if(t>0)return parseInt(e.substring(t+5,e.indexOf(".",t)),10);if(e.indexOf("Trident/")>0){var a=e.indexOf("rv:");return parseInt(e.substring(a+3,e.indexOf(".",a)),10)}var r=e.indexOf("Edge/");return r>0&&parseInt(e.substring(r+5,e.indexOf(".",r)),10)}(),__IS_IOS:/iphone|ipod|ipad/i.test(navigator.userAgent),__IS_FIREFOX:/(firefox)/i.test(navigator.userAgent),__IS_SAFARI:/(safari)/i.test(navigator.userAgent)&&!/(chrome)/i.test(navigator.userAgent)};var Bn={touchendListener:function(e){var t,a=e.target;if(a instanceof HTMLInputElement||HTMLTextAreaElement&&a instanceof HTMLTextAreaElement){var r=a.value,n="selectionStart"in(t=a)?t.selectionStart:0,i=!1;n===r.length&&(n-=1,i=!0),a.value=r,a.setSelectionRange&&(a.focus(),a.setSelectionRange(n,n),i&&(n+=1,setTimeout((function(){a.setSelectionRange(n,n)}),0)))}else{if(this.config.keypadFix){var o=this.props.rootNode,s=document.createElement("input");s.style.width="1px",s.style.height="1px",s.style.opacity="0",s.style.fontSize="18px",o.appendChild(s),s.focus(),o.removeChild(s)}}this.destroyTouchendListener(),this.state.registerFieldForIos=!1,this.postMessageToAllIframes({fieldType:"additionalField",click:!0})},handleAdditionalFields:function(){if(An.__IS_IOS){var e=en(document,"body");e.style.cursor="pointer",an(e,"touchend",this.touchendListener),this.state.registerFieldForIos=!0}},destroyTouchendListener:function(){if(An.__IS_IOS){var e=en(document,"body");e.style.cursor="auto",rn(e,"touchend",this.touchendListener)}}},Tn=function(e,t){return function(e,t){void 0===t&&(t=!0);var a=Array.prototype.slice.call(Xr(document,"*[data-cse], a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), object, embed, *[tabindex], *[contenteditable]")),r=[];a.forEach((function(e){var t=e.getAttribute("tabindex"),a=!t||parseInt(t,10)>=0,n=e.getBoundingClientRect(),i=n.width>0&&n.height>0;a&&i&&r.push(e)}));var n=function(e,t){for(var a=0;a<e.length;a+=1)if(t(e[a]))return a;return-1}(r,(function(t){return t===e||e.contains(t)}));return r[n+(t?-1:1)]}(en(t,"[data-cse="+e+"]"))};var zn=function(e){var t;switch(this.state.type){case"ach":t=function(e){var t;return"encryptedBankLocationId"===e&&(t="encryptedBankAccountNumber"),{fieldToFocus:t,additionalField:void 0}}(e);break;case"giftcard":t=function(e,t){var a,r;switch(e){case vr:a=Tn(vr,t);break;case _r:r=vr}return{fieldToFocus:r,additionalField:a}}(e,this.props.rootNode);break;default:t=this.state.isKCP?function(e,t,a){var r,n;switch(e){case vr:r=Tn(vr,t);break;case gr:case kr:n=vr;break;case Cr:n=kr;break;case _r:n=a?Cr:gr;break;case Nr:case"encryptedPin":r=Tn(e,t)}return{fieldToFocus:n,additionalField:r}}(e,this.props.rootNode,this.state.hasSeparateDateFields):function(e,t,a,r){var n,i;switch(e){case vr:n=Tn(vr,t);break;case gr:case kr:i=vr;break;case Cr:i=kr;break;case _r:1===r?n=Tn(_r,t):i=a?Cr:gr}return{fieldToFocus:i,additionalField:n}}(e,this.props.rootNode,this.state.hasSeparateDateFields,this.state.numIframes)}var a,r=t.fieldToFocus,n=t.additionalField;r?this.setFocusOnFrame(r,false):n&&(a=n)&&(a.focus(),a.blur(),a.focus())},Mn=function(e){(An.__IS_FIREFOX||An.__IS_IE&&An.__IS_IE<=11)&&this.handleShiftTab(e)},In=function(e){void 0===e&&(e="You cannot use secured fields"),Gr(e+" - they are not yet configured. Use the 'onConfigSuccess' callback to know when this has happened.")},jn=function(e){function t(t){var a=e.call(this,t)||this;return a.state={type:a.props.type,brand:"card"!==a.props.type?{brand:a.props.type,cvcPolicy:"required"}:{brand:null,cvcPolicy:"required"},allValid:void 0,numIframes:0,originalNumIframes:0,iframeCount:0,iframeConfigCount:0,isConfigured:!1,hasSeparateDateFields:!1,currentFocusObject:null,registerFieldForIos:!1,securedFields:{},isKCP:!1},a.configHandler=Yr,a.callbacksHandler=Jr,a.handleIframeConfigFeedback=wn,a.isConfigured=Pn,a.assessFormValidity=Fn,a.processBrand=Qr,a.handleValidation=on,a.handleEncryption=sn,a.createSecuredFields=fn,a.createNonCardSecuredFields=yn,a.createCardSecuredFields=bn,a.setupSecuredField=vn,a.postMessageToAllIframes=kn,a.setFocusOnFrame=gn,a.handleFocus=Nn,a.handleAdditionalFields=Bn.handleAdditionalFields,a.touchendListener=Bn.touchendListener.bind(a),a.destroyTouchendListener=Bn.destroyTouchendListener,a.handleSFShiftTab=Mn,a.handleShiftTab=zn,a.destroySecuredFields=Cn,a.processAutoComplete=_n,a.handleBinValue=xn,a.brandsFromBinLookup=Dn,a.sendBrandToCardSF=Sn,a.init(),a}return S(t,e),t.prototype.init=function(){this.configHandler(),this.callbacksHandler(this.props.callbacks);var e=this.createSecuredFields();this.state.numIframes=this.state.originalNumIframes=e,this.state.isKCP=!!this.props.isKCP},t.prototype.createReturnObject=function(){var e=this;return{updateStyles:function(t){e.state.isConfigured?e.postMessageToAllIframes({styleObject:t}):Gr("You cannot update the secured fields styling - they are not yet configured. Use the 'onConfigSuccess' callback to know when this has happened.")},setFocusOnFrame:function(t){e.state.isConfigured?e.setFocusOnFrame(t):In("You cannot set focus on any secured field")},isValidated:function(t,a){if(e.state.isConfigured){if(Object.prototype.hasOwnProperty.call(e.state.securedFields,t)){e.state.securedFields[t].hasError=!0,""===e.state.securedFields[t].errorType&&(e.state.securedFields[t].errorType="isValidated");var r={txVariant:e.state.type,fieldType:t,externalValidation:!0,code:a,numKey:e.state.securedFields[t].numKey};Zr(r,e.getIframeContentWin(t),e.config.loadingContext)}}else In("You cannot set validated on any secured field")},hasUnsupportedCard:function(t,a){if(e.state.isConfigured){if(Object.prototype.hasOwnProperty.call(e.state.securedFields,t)){e.state.securedFields[t].hasError=!!a,e.state.securedFields[t].errorType=a;var r={txVariant:e.state.type,fieldType:t,unsupportedCard:!!a,code:a,numKey:e.state.securedFields[t].numKey};Zr(r,e.getIframeContentWin(t),e.config.loadingContext)}}else In("You cannot set hasUnsupportedCard on any secured field")},destroy:function(){e.state.isConfigured?e.destroySecuredFields():In("You cannot destroy secured fields")},brandsFromBinLookup:function(t){if(!e.config.isCreditCardType)return null;e.state.isConfigured?e.brandsFromBinLookup(t):In("You cannot set pass brands to secured fields")},addSecuredField:function(t){var a=en(e.props.rootNode,'[data-cse="'+t+'"]');a&&(e.state.numIframes+=1,e.setupSecuredField(a))},removeSecuredField:function(t){if(e.state.securedFields[t]){e.state.securedFields[t].destroy(),delete e.state.securedFields[t],e.state.numIframes-=1;var a={additionalIframeRemoved:!0,fieldType:t,type:e.state.type};e.callbacks.onAdditionalSFRemoved(a)}},setKCPStatus:function(t){e.state.isKCP=t}}},t.prototype.getIframeContentWin=function(e){var t;return(null===(t=this.state.securedFields[e])||void 0===t?void 0:t.iframeContentWindow)||null},t}((function(e){this.props=e,this.state={},this.config={},this.callbacks={}})),En=function(e){if(!e)throw new Error("No securedFields configuration object defined");var t=D({},e),a=ln(t.type);if(t.type=a?"card":t.type,!Object.prototype.hasOwnProperty.call(t,"rootNode"))return qr('ERROR: SecuredFields configuration object is missing a "rootNode" property'),null;if(Kr(t.clientKey)&&Kr(t.originKey))return Gr('WARNING: Checkout configuration object is missing a "clientKey" property.\nFor a transition period the originKey will be accepted instead but this will eventually be deprecated'),null;var r=function(e){var t;return"object"===typeof e&&(t=e),"string"!==typeof e||(t=en(document,e))?t:null}(t.rootNode);return r?(t.rootNode=r,new jn(t).createReturnObject()):(window.console&&window.console.error&&window.console.error("ERROR: SecuredFields cannot find a valid rootNode element for",t.type),null)};var On={handleFocus:function(e){e.fieldType===_r&&(this.numCharsInCVC=e.numChars),this.props.onFocus(e)},handleOnAllValid:function(e){var t=this;return!this.state.hasUnsupportedCard&&(this.setState({isSfpValid:e.allValid},(function(){t.props.onChange(t.state),t.props.onAllValid(e)})),!0)},handleOnAutoComplete:function(e){var t=this;this.setState({autoCompleteName:e.value},(function(){t.props.onChange(t.state),t.setState({autoCompleteName:null})})),this.props.onAutoComplete(e)},handleOnFieldValid:function(e){var t=this;return(!this.state.hasUnsupportedCard||e.fieldType!==vr)&&(this.setState((function(t){var a,r,n;return{data:D(D({},t.data),(a={},a[e.encryptedFieldName]=e.blob,a)),valid:D(D({},t.valid),(r={},r[e.encryptedFieldName]=e.valid,r)),errors:D(D({},t.errors),(n={},n[e.fieldType]=!0===t.errors[e.fieldType],n))}}),(function(){t.props.onChange(t.state),t.props.onFieldValid(e)})),!0)},handleOnLoad:function(e){var t=this;this.props.onLoad(e),this.originKeyErrorTimeout=setTimeout((function(){"ready"!==t.state.status&&(t.setState({status:"originKeyError"}),t.props.onError({error:"originKeyError",fieldType:"defaultError"}))}),this.originKeyTimeoutMS)},handleOnConfigSuccess:function(e){var t=this;clearTimeout(this.originKeyErrorTimeout),this.setState({status:"ready"},(function(){t.props.onConfigSuccess(e)}))},handleOnBrand:function(e){var t=this;this.setState((function(a){var r,n;return{brand:e.brand,cvcPolicy:null!==(n=e.cvcPolicy)&&void 0!==n?n:Fr,errors:D(D({},a.errors),(r={},r.encryptedSecurityCode=(e.cvcPolicy!==xr&&e.cvcPolicy!==Sr||0!==t.numCharsInCVC)&&a.errors.encryptedSecurityCode,r)),hideCVCForBrand:e.cvcPolicy===Sr}}),(function(){var a,r,n;t.props.onChange(t.state),t.props.onBrand(D(D({},e),{brandImageUrl:(a=e.brand,r=t.props.loadingContext,n="card"===a?"nocard":a||"nocard",ze({type:n,extension:"svg",loadingContext:r})(n))}))})),(this.props.hideCVC||e.cvcPolicy===Sr||e.cvcPolicy===xr)&&this.props.oneClick&&this.handleOnNoDataRequired()},handleOnError:function(e,t){void 0===t&&(t=null),this.state.hasUnsupportedCard&&e.fieldType;var a=e.error;this.setState((function(r){var n;return{errors:D(D({},r.errors),(n={},n[e.fieldType]=a||!1,n)),hasUnsupportedCard:null!==t&&t}})),e.errorI18n=this.props.i18n.get(a);var r=un(a);return e.errorText=""!==r?r:"error was cleared",this.props.onError(e),!0},handleOnNoDataRequired:function(){var e=this;this.setState({status:"ready"},(function(){return e.props.onChange({isSfpValid:!0})}))}},Rn={type:"card",originKey:null,keypadFix:!0,rootNode:null,loadingContext:null,groupTypes:[],allowedDOMAccess:!1,showWarnings:!1,autoFocus:!0,trimTrailingSeparator:!0,onChange:function(){},onLoad:function(){},onConfigSuccess:function(){},onAllValid:function(){},onFieldValid:function(){},onBrand:function(){},onError:function(){},onBinValue:function(){},onFocus:function(){},onAutoComplete:function(){},placeholders:{},ariaLabels:{},styles:{}},Vn=function(e){function t(t){var a=e.call(this,t)||this;a.setRootNode=function(e){a.rootNode=e};var r={status:"loading",brand:t.type,errors:{},valid:{},data:{},cvcPolicy:Fr,isSfpValid:!1,hasKoreanFields:a.props.hasKoreanFields};return a.state=r,a.originKeyErrorTimeout=null,a.originKeyTimeoutMS=15e3,a.numCharsInCVC=0,a.handleOnLoad=On.handleOnLoad.bind(a),a.handleOnConfigSuccess=On.handleOnConfigSuccess.bind(a),a.handleOnFieldValid=On.handleOnFieldValid.bind(a),a.handleOnAllValid=On.handleOnAllValid.bind(a),a.handleOnBrand=On.handleOnBrand.bind(a),a.handleFocus=On.handleFocus.bind(a),a.handleOnError=On.handleOnError.bind(a),a.handleOnNoDataRequired=On.handleOnNoDataRequired.bind(a),a.handleOnAutoComplete=On.handleOnAutoComplete.bind(a),a.processBinLookupResponse=a.processBinLookupResponse.bind(a),a.setFocusOn=a.setFocusOn.bind(a),a.updateStyles=a.updateStyles.bind(a),a.handleUnsupportedCard=a.handleUnsupportedCard.bind(a),a.showValidation=a.showValidation.bind(a),a.destroy=a.destroy.bind(a),a}return S(t,e),t.prototype.componentDidMount=function(){this.props.rootNode&&this.setRootNode(this.props.rootNode);var e,t=(e=this.rootNode)?Array.prototype.slice.call(e.querySelectorAll('[data-cse*="encrypted"]')).map((function(e){return e.getAttribute("data-cse")})):[],a=t.reduce(Tr,{});this.setState({valid:a}),this.numDateFields=t.filter((function(e){return e.match(/Expiry/)})).length,t.length?(this.destroy(),this.initializeCSF(this.rootNode)):this.handleOnNoDataRequired()},t.prototype.componentDidUpdate=function(){this.checkForKCPFields()},t.prototype.componentWillUnmount=function(){this.csf=null},t.prototype.initializeCSF=function(e){var t=this.props.loadingContext;var a={rootNode:e,type:this.props.type,originKey:this.props.originKey,clientKey:this.props.clientKey,cardGroupTypes:this.props.groupTypes,allowedDOMAccess:this.props.allowedDOMAccess,autoFocus:this.props.autoFocus,trimTrailingSeparator:this.props.trimTrailingSeparator,loadingContext:t,keypadFix:this.props.keypadFix,showWarnings:this.props.showWarnings,iframeUIConfig:{sfStyles:this.props.styles,placeholders:this.props.placeholders,ariaConfig:this.props.ariaLabels},i18n:this.props.i18n,callbacks:{onLoad:this.handleOnLoad,onConfigSuccess:this.handleOnConfigSuccess,onFieldValid:this.handleOnFieldValid,onAllValid:this.handleOnAllValid,onBrand:this.handleOnBrand,onError:this.handleOnError,onFocus:this.handleFocus,onBinValue:this.props.onBinValue,onAutoComplete:this.handleOnAutoComplete,onAdditionalSFConfig:this.props.onAdditionalSFConfig,onAdditionalSFRemoved:this.props.onAdditionalSFRemoved},isKCP:this.state.hasKoreanFields,locale:this.props.locale};this.csf=En(a)},t.prototype.checkForKCPFields=function(){var e=this,t=!1;if(this.props.koreanAuthenticationRequired&&(t=this.issuingCountryCode?"kr"===this.issuingCountryCode:"kr"===this.props.countryCode),this.state.hasKoreanFields&&!t){this.setState((function(e){var t,a,r;return{data:D(D({},e.data),(t={},t.encryptedPassword=void 0,t)),valid:D(D({},e.valid),(a={},a.encryptedPassword=!1,a)),errors:D(D({},e.errors),(r={},r.encryptedPassword=!1,r)),hasKoreanFields:!1}}),(function(){e.props.onChange(e.state)})),this.csf.removeSecuredField(Nr),this.csf.setKCPStatus(!1)}if(!this.state.hasKoreanFields&&t){this.setState((function(e){var t;return{valid:D(D({},e.valid),(t={},t.encryptedPassword=!1,t)),hasKoreanFields:!0,isSfpValid:!1}}),(function(){e.props.onChange(e.state)})),this.csf.addSecuredField(Nr),this.csf.setKCPStatus(!0)}},t.prototype.getChildContext=function(){return{i18n:this.props.i18n}},t.prototype.handleUnsupportedCard=function(e){var t=!!e.error;return this.handleOnError(e,t),this.csf&&this.csf.hasUnsupportedCard(vr,e.error),t},t.prototype.setFocusOn=function(e){this.csf&&this.csf.setFocusOnFrame(e)},t.prototype.updateStyles=function(e){this.csf&&this.csf.updateStyles(e)},t.prototype.destroy=function(){this.csf&&this.csf.destroy()},t.prototype.showValidation=function(){var e=this,t=this.numDateFields,a=this.state;Object.keys(a.valid).reduce(zr(t,a),[]).forEach((function(t){var r=function(e,t,a){return{rootNode:t,fieldType:e,error:we(a,"errors."+e)||Br,type:"card"}}(t,e.rootNode,a);e.handleOnError(r),e.csf&&e.csf.isValidated&&e.csf.isValidated(t,r.error)}))},t.prototype.processBinLookupResponse=function(e){var t;this.state.hasUnsupportedCard&&(this.setState((function(e){var t;return{errors:D(D({},e.errors),(t={},t.encryptedCardNumber=!1,t)),hasUnsupportedCard:!1}})),this.csf&&this.csf.hasUnsupportedCard(vr,"")),this.issuingCountryCode=null===(t=null===e||void 0===e?void 0:e.issuingCountryCode)||void 0===t?void 0:t.toLowerCase(),this.csf&&this.csf.brandsFromBinLookup(e)},t.prototype.render=function(e,t){return e.render({setRootNode:this.setRootNode,setFocusOn:this.setFocusOn},t)},t.defaultProps=Rn,t}(ne);var Ln=function(e){var t=e.storeDetails,a=void 0!==t&&t,r=A(e,["storeDetails"]),n=nt().i18n,i=Ge(a),o=i[0],s=i[1];return Ye((function(){r.onChange(o)}),[o]),te("div",{className:"adyen-checkout__store-details"},Ut("boolean",{onChange:function(e){s(e.target.checked)},label:n.get("storeDetails"),value:o,name:"storeDetails"}))},Un={details:[],type:"card",hasHolderName:!1,holderNameRequired:!1,enableStoreDetails:!1,hideCVC:!1,hasCVC:!0,hasStoreDetails:!1,storedDetails:!1,showBrandIcon:!0,billingAddressRequired:!1,billingAddressRequiredFields:["street","houseNumberOrName","postalCode","city","stateOrProvince","country"],installmentOptions:{},configuration:{koreanAuthenticationRequired:!1},onLoad:function(){},onConfigSuccess:function(){},onAllValid:function(){},onFieldValid:function(){},onBrand:function(){},onError:function(){},onBinValue:function(){},onBlur:function(){},onFocus:function(){},onChange:function(){},originKey:null,holderName:"",data:{holderName:"",billingAddress:{}},styles:{},placeholders:{},ariaLabels:{}},Kn={base:{caretColor:"#0066FF"}},qn=function(e,t){return void 0===t&&(t=!1),!t||!!e&&"string"===typeof e&&e.trim().length>0};var Hn={handleFocus:function(e){var t=!0===e.focus;this.setState({focusedElement:e.currentFocusObject}),t?this.props.onFocus(e):this.props.onBlur(e)},handleAddress:function(e){this.setState((function(t){return D(D({},t),{billingAddress:e.data,valid:D(D({},t.valid),{billingAddress:e.isValid})})}))},handleKCPAuthentication:function(e,t){this.setState((function(a){return{data:D(D({},a.data),e),valid:D(D({},a.valid),t)}}))},handleOnStoreDetails:function(e){this.setState({storePaymentMethod:e})},handleHolderName:function(e){var t=this,a=e.target.value;this.setState((function(e){return{data:D(D({},e.data),{holderName:a}),errors:D(D({},e.errors),{holderName:!!t.props.holderNameRequired&&!qn(a)}),valid:D(D({},e.valid),{holderName:!t.props.holderNameRequired||qn(a,t.props.holderNameRequired)})}}))},handleInstallments:function(e){this.setState({installments:e})},handleSecuredFieldsChange:function(e){var t=this,a=e,r=a.autoCompleteName&&this.props.hasHolderName?a.autoCompleteName:this.state.data.holderName;this.setState((function(e){return D(D({},e),{data:D(D(D({},t.state.data),a.data),{holderName:r}),errors:D(D({},t.state.errors),a.errors),valid:D(D(D({},t.state.valid),a.valid),{holderName:!t.props.holderNameRequired||qn(r,t.props.holderNameRequired)}),isSfpValid:a.isSfpValid,hideCVCForBrand:a.hideCVCForBrand,brand:a.brand})}))},handleAdditionalDataSelection:function(e){var t=e.currentTarget.getAttribute("data-value");this.setState({additionalSelectValue:t});var a=this.state.additionalSelectElements.reduce((function(e,a){return a.brandObject.brand===t&&e.push(a.brandObject),e}),[]);this.sfp.current.processBinLookupResponse({issuingCountryCode:this.state.issuingCountryCode,supportedBrands:a})},validateCardInput:function(){var e=this,t=qn(this.state.data.holderName,this.props.holderNameRequired),a=this.state.isSfpValid,r=!this.props.billingAddressRequired||this.state.valid.billingAddress,n=this.state.issuingCountryCode?"kr"===this.state.issuingCountryCode:"kr"===this.props.countryCode,i=!this.props.configuration.koreanAuthenticationRequired||!n||!!this.state.valid.taxNumber&&!!this.state.valid.encryptedPassword,o=a&&t&&r&&i;this.setState({isValid:o},(function(){e.props.onChange(e.state)}))}};function Gn(e){var t,a,r,n;if(!e)return this.resetAdditionalSelectState(),void this.sfp.current.processBinLookupResponse(e);if(null===(t=e.supportedBrands)||void 0===t?void 0:t.length){var i=e.supportedBrands;if(i.length>1){var o=(r=(a=i)[0],n=a[1],{stateObject:{additionalSelectElements:[{id:r.brand,brandObject:r},{id:n.brand,brandObject:n}]},leadBrand:r});this.setState(o.stateObject),this.sfp.current.processBinLookupResponse({issuingCountryCode:e.issuingCountryCode,supportedBrands:[o.leadBrand]})}else this.resetAdditionalSelectState(),this.setState({additionalSelectValue:i[0].brand}),this.sfp.current.processBinLookupResponse({issuingCountryCode:e.issuingCountryCode,supportedBrands:i})}}a(118);var Yn=function(e){function t(t){var a=e.call(this,t)||this;return a.sfp={current:null},a.billingAddressRef={current:null},a.kcpAuthenticationRef={current:null},a.state=D(D({status:"ready",errors:{},valid:D({},a.props.holderNameRequired&&{holderName:!1}),data:D({},a.props.hasHolderName&&{holderName:a.props.holderName||a.props.data.holderName})},a.props.billingAddressRequired&&{billingAddress:D({},a.props.data.billingAddress)}),{isValid:!1,hideCVCForBrand:!1,focusedElement:"",additionalSelectElements:[],additionalSelectValue:"",issuingCountryCode:null}),a.validateCardInput=Hn.validateCardInput.bind(a),a.handleFocus=Hn.handleFocus.bind(a),a.handleAddress=Hn.handleAddress.bind(a),a.handleHolderName=Hn.handleHolderName.bind(a),a.handleInstallments=Hn.handleInstallments.bind(a),a.handleKCPAuthentication=Hn.handleKCPAuthentication.bind(a),a.handleSecuredFieldsChange=Hn.handleSecuredFieldsChange.bind(a),a.handleOnStoreDetails=Hn.handleOnStoreDetails.bind(a),a.handleAdditionalDataSelection=Hn.handleAdditionalDataSelection.bind(a),a.processBinLookup=Gn.bind(a),a}return S(t,e),t.prototype.componentDidMount=function(){this.setFocusOn=this.sfp.current.setFocusOn,this.updateStyles=this.sfp.current.updateStyles,this.handleUnsupportedCard=this.sfp.current.handleUnsupportedCard},t.prototype.componentDidUpdate=function(e,t){Ur(t.billingAddress,this.state.billingAddress)&&t.storePaymentMethod===this.state.storePaymentMethod&&Ur(t.installments,this.state.installments)&&t.isSfpValid===this.state.isSfpValid&&t.hideCVCForBrand===this.state.hideCVCForBrand&&t.brand===this.state.brand&&t.additionalSelectValue===this.state.additionalSelectValue&&Ur(t.data,this.state.data)||this.validateCardInput()},t.prototype.componentWillUnmount=function(){this.sfp.current.destroy(),this.sfp=null},t.prototype.getChildContext=function(){return{i18n:this.props.i18n}},t.prototype.setStatus=function(e){this.setState({status:e})},t.prototype.resetAdditionalSelectState=function(){this.setState({additionalSelectElements:[],additionalSelectValue:""})},t.prototype.showValidation=function(){var e,t;this.sfp.current.showValidation(),this.props.holderNameRequired&&!this.state.valid.holderName&&this.setState((function(e){return{errors:D(D({},e.errors),{holderName:!0})}})),(null===(e=this.billingAddressRef)||void 0===e?void 0:e.current)&&this.billingAddressRef.current.showValidation(),(null===(t=this.kcpAuthenticationRef)||void 0===t?void 0:t.current)&&this.kcpAuthenticationRef.current.showValidation()},t.prototype.processBinLookupResponse=function(e){var t=this,a=(null===e||void 0===e?void 0:e.issuingCountryCode)?e.issuingCountryCode.toLowerCase():null;this.setState({issuingCountryCode:a},(function(){t.processBinLookup(e)}))},t.prototype.render=function(e,t){var a=this,r=e.countryCode,n=e.loadingContext,i=e.hasHolderName,o=e.hasCVC,s=e.installmentOptions,c=e.enableStoreDetails,d=e.showInstallmentAmounts,l=t.status,u=t.hideCVCForBrand,p=t.focusedElement,m=t.issuingCountryCode,h=!!Object.keys(s).length,f=this.props.oneClick||!!this.props.storedPaymentMethodId,y=m?"kr"===m:"kr"===r,b=null===d||void 0===d||d;return te(Vn,D({ref:this.sfp},this.props,{styles:D(D({},Kn),this.props.styles),koreanAuthenticationRequired:this.props.configuration.koreanAuthenticationRequired,hasKoreanFields:!(!this.props.configuration.koreanAuthenticationRequired||"kr"!==this.props.countryCode),onChange:this.handleSecuredFieldsChange,onBrand:this.props.onBrand,onFocus:this.handleFocus,type:this.props.brand,oneClick:f,render:function(e,t){var r,d=e.setRootNode,m=e.setFocusOn;return te("div",{ref:d,className:"adyen-checkout__card-input "+tr.a["card-input__wrapper"]+" adyen-checkout__card-input--"+(null!==(r=a.props.fundingSource)&&void 0!==r?r:"credit")},a.props.storedPaymentMethodId?te(fr,{status:t.status},te(yr,D({},a.props,{cvcRequired:t.cvcPolicy===Fr,errors:t.errors,brand:t.brand,hasCVC:o,hideCVCForBrand:u,onFocusField:m,focusedElement:p,status:t.status,valid:t.valid})),h&&te(ur,{amount:a.props.amount,brand:t.brand,installmentOptions:s,onChange:a.handleInstallments,type:b?"amount":"months"})):te(fr,{status:t.status},te(cr,D({},a.props,{brand:t.brand,focusedElement:p,onFocusField:m,hasCVC:o,hideCVCForBrand:u,errors:t.errors,valid:t.valid,cvcRequired:t.cvcPolicy===Fr,dualBrandingElements:a.state.additionalSelectElements.length>0&&a.state.additionalSelectElements,dualBrandingChangeHandler:a.handleAdditionalDataSelection,dualBrandingSelected:a.state.additionalSelectValue})),i&&te(dr,{required:a.props.holderNameRequired,placeholder:a.props.placeholders.holderName,value:a.state.data.holderName,error:!!a.state.errors.holderName,isValid:!!a.state.valid.holderName,onChange:a.handleHolderName}),a.props.configuration.koreanAuthenticationRequired&&y&&te(pr,{onFocusField:m,focusedElement:p,encryptedPasswordState:{data:t.encryptedPassword,valid:!!t.valid&&t.valid.encryptedPassword,errors:!!t.errors&&t.errors.encryptedPassword},ref:a.kcpAuthenticationRef,onChange:a.handleKCPAuthentication}),c&&te(Ln,{onChange:a.handleOnStoreDetails}),h&&te(ur,{amount:a.props.amount,brand:t.brand,installmentOptions:s,onChange:a.handleInstallments,type:b?"amount":"months"}),a.props.billingAddressRequired&&te(fa,{label:"billingAddress",data:a.state.billingAddress,onChange:a.handleAddress,allowedCountries:a.props.billingAddressAllowedCountries,requiredFields:a.props.billingAddressRequiredFields,ref:a.billingAddressRef})),a.props.showPayButton&&a.props.payButton({status:l,icon:Me({loadingContext:n,imageFolder:"components/"})("lock")}))}}))},t.defaultProps=Un,t}(ne);function Wn(e){var t=this;if(!1!==this.props.doBinLookup){if(e.encryptedBin&&this.props.clientKey)this.currentRequestId=e.uuid,ua({path:"v2/bin/binLookup?token="+this.props.clientKey,loadingContext:this.props.loadingContext,method:"POST",contentType:"application/json"},{supportedBrands:this.props.brands||wr,encryptedBin:e.encryptedBin,requestId:e.uuid}).then((function(a){var r;if((null===a||void 0===a?void 0:a.requestId)===t.currentRequestId)if(null===(r=a.brands)||void 0===r?void 0:r.length){var n=a.brands.reduce((function(e,t){return e.detectedBrands.push(t.brand),!0===t.supported?(e.supportedBrands.push(t),e):e}),{supportedBrands:[],detectedBrands:[]});if(n.supportedBrands.length)return t.processBinLookupResponse({issuingCountryCode:a.issuingCountryCode,supportedBrands:n.supportedBrands}),void t.props.onBinLookup({type:e.type,detectedBrands:n.detectedBrands,supportedBrands:n.supportedBrands.map((function(e){return e.brand})),brands:t.props.brands||wr});if(n.detectedBrands.length){var i={type:"card",fieldType:"encryptedCardNumber",error:un(Dr),detectedBrands:n.detectedBrands};return t.handleUnsupportedCard(i),void t.props.onBinLookup({type:e.type,detectedBrands:n.detectedBrands,supportedBrands:null,brands:t.props.brands||wr})}}else t.props.onBinLookup({type:e.type,detectedBrands:null,supportedBrands:null,brands:t.props.brands||wr});else t.props.onError(a||{errorType:"binLookup",message:"unknownError"})}));else if(this.currentRequestId){this.processBinLookupResponse(null),this.currentRequestId=null;this.handleUnsupportedCard({type:"card",fieldType:"encryptedCardNumber",error:""})}this.props.onBinValue&&this.props.onBinValue(e)}else this.props.onBinValue&&this.props.onBinValue(e)}var Jn=function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.onBrand=function(e){t.eventEmitter.emit("brand",D(D({},e),{brand:"card"===e.brand?null:e.brand})),t.props.onBrand&&t.props.onBrand(e)},t.onBinValue=Wn.bind(t),t}return S(t,e),t.prototype.formatProps=function(e){var t;return D(D(D(D({},e),{holderNameRequired:!!e.hasHolderName&&e.holderNameRequired,hasCVC:!(e.brand&&"bcmc"===e.brand||e.hideCVC),billingAddressRequired:!e.storedPaymentMethodId&&e.billingAddressRequired}),e.brands&&!e.groupTypes&&{groupTypes:e.brands}),{type:"scheme"===e.type?"card":e.type,countryCode:e.countryCode?e.countryCode.toLowerCase():null,configuration:D(D({},e.configuration),void 0!==e.koreanAuthenticationRequired&&{koreanAuthenticationRequired:e.koreanAuthenticationRequired}),onBinLookup:null!==(t=e.onBinLookup)&&void 0!==t?t:e.onBinLookup=function(){}})},t.prototype.formatData=function(){var e=this.state.additionalSelectValue||this.props.brand,a=this.props.enableStoreDetails&&"undefined"!==typeof this.state.storePaymentMethod;return D(D(D(D({paymentMethod:D(D(D(D({type:t.type},this.state.data),this.props.storedPaymentMethodId&&{storedPaymentMethodId:this.props.storedPaymentMethodId}),e&&{brand:e}),this.props.fundingSource&&{fundingSource:this.props.fundingSource})},this.state.billingAddress&&{billingAddress:this.state.billingAddress}),a&&{storePaymentMethod:Boolean(this.state.storePaymentMethod)}),this.state.installments&&this.state.installments.value&&{installments:this.state.installments}),{browserInfo:this.browserInfo})},t.prototype.updateStyles=function(e){var t;return(null===(t=this.componentRef)||void 0===t?void 0:t.updateStyles)&&this.componentRef.updateStyles(e),this},t.prototype.setFocusOn=function(e){var t;return(null===(t=this.componentRef)||void 0===t?void 0:t.setFocusOn)&&this.componentRef.setFocusOn(e),this},t.prototype.processBinLookupResponse=function(e){var t;return(null===(t=this.componentRef)||void 0===t?void 0:t.processBinLookupResponse)&&this.componentRef.processBinLookupResponse(e),this},t.prototype.handleUnsupportedCard=function(e){var t;return(null===(t=this.componentRef)||void 0===t?void 0:t.handleUnsupportedCard)&&this.componentRef.handleUnsupportedCard(e),this},Object.defineProperty(t.prototype,"isValid",{get:function(){return!!this.state.isValid},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"icon",{get:function(){return Me({loadingContext:this.props.loadingContext})(this.brand)},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"brands",{get:function(){var e=this.props,t=e.brands,a=e.loadingContext;return t?t.map((function(e){return{icon:Me({loadingContext:a})(e),name:e}})):[]},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"brand",{get:function(){return this.props.brand||this.props.type},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"displayName",{get:function(){return this.props.storedPaymentMethodId?"\u2022\u2022\u2022\u2022 "+this.props.lastFour:this.props.name||t.type},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"browserInfo",{get:function(){return Fa()},enumerable:!1,configurable:!0}),t.prototype.render=function(){var e=this;return te(ka,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},te(Yn,D({ref:function(t){e.componentRef=t}},this.props,this.state,{onChange:this.setState,onSubmit:this.submit,payButton:this.payButton,onBrand:this.onBrand,onBinValue:this.onBinValue,brand:this.brand})))},t.type="scheme",t}(st),Zn=Jn,Qn=function(e){function t(t){var a=e.call(this,t)||this;return a.onBrand=function(e){a.props.onBrand&&a.props.onBrand(e)},a}return S(t,e),t.prototype.formatProps=function(t){return D(D({brand:"bcmc"},e.prototype.formatProps.call(this,t)),{brands:["bcmc","maestro"]})},t}(Jn);a(119);function $n(e){var t=e.backgroundUrl,a=void 0===t?"":t,r=e.className,n=void 0===r?"":r,i=e.classNameModifiers,o=void 0===i?[]:i,s=e.src,c=void 0===s?"":s,d=e.alt,l=void 0===d?"":d,u=e.showOnError,p=void 0!==u&&u,m=Ge(!1),h=m[0],f=m[1],y=Je(null),b=function(){f(!0)},v=je.a.apply(void 0,z([[n],"adyen-checkout__image",{"adyen-checkout__image--loaded":h}],o.map((function(e){return"adyen-checkout__image--"+e}))));return Ye((function(){var e=a?new Image:y.current;e.src=a||c,e.onload=b,f(!!e.complete)}),[]),a?te("div",D({style:{backgroundUrl:a}},e,{className:v})):te("img",D({},e,{alt:l,ref:y,className:v,onError:function(){f(p)}}))}function Xn(e){var t=e.description,a=void 0===t?"":t,r=e.name,n=void 0===r?"":r,i=e.logoUrl,o=void 0===i?"":i,s=e.url,c=void 0===s?"":s,d=e.backgroundUrl,l=void 0===d?"":d;return te("div",{className:"adyen-checkout__campaign-container"},te($n,{className:"adyen-checkout__campaign-background-image",style:{backgroundImage:"linear-gradient(0, #000, #0003), url("+l+")"},backgroundUrl:l}),te("div",{className:"adyen-checkout__campaign-content"},o&&te("img",{src:o,className:"adyen-checkout__campaign-logo",alt:n}),n&&te("div",{className:"adyen-checkout__campaign-title"},n),a&&te("div",{className:"adyen-checkout__campaign-description"},a,c&&" \u203a")))}function ei(e){var t=e.url;return te("div",{className:"adyen-checkout__campaign"},!t&&te(Xn,D({},e)),t&&te("a",{href:t,className:"adyen-checkout__campaign-link",target:"_blank",rel:"noopener noreferrer"},te(Xn,D({},e))))}a(120);var ti=function(e){var t=e.options,a=void 0===t?[]:t,r=e.name,n=e.onChange;return te("div",{className:"adyen-checkout__button-group"},a.map((function(e,t){var a=e.label,i=e.selected,o=e.value,s=e.disabled;return te("label",{key:""+r+t,className:je()({"adyen-checkout__button":!0,"adyen-checkout__button--selected":i,"adyen-checkout__button--disabled":s})},te("input",{type:"radio",className:"adyen-checkout__button-group__input",value:o,checked:i,onChange:n,disabled:s}),te("span",{className:"adyen-checkout__button-text"},a))})))};a(121);function ai(e){var t=e.amounts,a=e.onCancel,r=e.onDonate,n=e.showCancelButton,i=void 0===n||n,o=nt(),s=o.i18n,c=o.loadingContext,d=t.currency,l=Ge("ready"),u=l[0],p=l[1],m=Ge(!1),h=m[0],f=m[1],y=Ge({currency:d,value:null}),b=y[0],v=y[1];this.setStatus=function(e){p(e)};var g=function(e,t){return s.amount(e,t,{minimumFractionDigits:0,maximumFractionDigits:0})};return Ye((function(){e.onChange({data:{amount:b},isValid:h})}),[b,h]),"error"===u?te("div",{className:"adyen-checkout__adyen-giving"},te($n,{className:"adyen-checkout__status__icon adyen-checkout__status__icon--error",src:ze({loadingContext:c,imageFolder:"components/"})("error"),alt:s.get("error.message.unknown")}),te("div",{className:"adyen-checkout__status__text"},s.get("error.message.unknown"))):"success"===u?te("div",{className:"adyen-checkout__adyen-giving"},te($n,{className:"adyen-checkout__status__icon adyen-checkout__status__icon--success",src:ze({loadingContext:c,imageFolder:"components/"})("heart"),alt:s.get("thanksForYourSupport")}),te("div",{className:"adyen-checkout__status__text"},s.get("thanksForYourSupport"))):te("div",{className:"adyen-checkout__adyen-giving"},te(ei,D({},e)),te("div",{className:"adyen-checkout__adyen-giving-actions"},te("div",{className:"adyen-checkout__amounts"},te(ti,{options:t.values.map((function(e){return{value:e,label:g(e,d),disabled:"loading"===u,selected:e===b.value}})),name:"amount",onChange:function(e){var t=e.target,a=parseInt(t.value,10);f(!0),v((function(e){return D(D({},e),{value:a})}))}})),te(it,{classNameModifiers:["donate"],onClick:function(){p("loading"),r({data:{amount:b}})},label:s.get("donateButton"),disabled:!b.value,status:u}),i&&te(it,{classNameModifiers:["ghost","decline"],onClick:function(){p("loading"),a({data:{amount:b},isValid:h})},disabled:"loading"===u,label:s.get("notNowButton")+" \u203a"})))}ai.defaultProps={onCancel:function(){},onChange:function(){},onDonate:function(){},amounts:{},showCancelButton:!0};var ri=function(e){function t(t){var a=e.call(this,t)||this;return a.handleRef=function(e){a.componentRef=e},a.donate=a.donate.bind(a),a}return S(t,e),Object.defineProperty(t.prototype,"data",{get:function(){return this.state.data},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"isValid",{get:function(){return this.state.isValid},enumerable:!1,configurable:!0}),t.prototype.setState=function(e){this.state=D(D({},this.state),e)},t.prototype.donate=function(){var e=this.data,t=this.isValid;this.props.onDonate({data:e,isValid:t},this)},t.prototype.render=function(){return te(ka,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},te(ai,D({},this.props,{ref:this.handleRef,onChange:this.setState,onDonate:this.donate})))},t.type="donation",t.defaultProps={onCancel:function(){},onDonate:function(){}},t}(ct),ni=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return S(t,e),t.prototype.componentDidMount=function(){var e=this;new Promise((function(t,a){return e.props.beforeRedirect(t,a,e.props.url)})).then((function(){e.postForm?e.postForm.submit():window.location.assign(e.props.url)})).catch((function(){}))},t.prototype.render=function(e){var t=this,a=e.url,r=e.method,n=e.data,i=void 0===n?{}:n;return"POST"===r?te("form",{method:"post",action:a,style:{display:"none"},ref:function(e){t.postForm=e}},Object.keys(i).map((function(e){return te("input",{type:"hidden",name:e,key:e,value:i[e]})}))):null},t.defaultProps={beforeRedirect:function(e){return e()},method:"GET",data:{}},t}(ne);var ii=function(e){var t=e.payButton,a=e.onSubmit,r=e.amount,n=void 0===r?null:r,i=e.name,o=A(e,["payButton","onSubmit","amount","name"]),s=nt().i18n,c=Ge("ready"),d=c[0],l=c[1];return this.setStatus=function(e){l(e)},te(re,null,t(D(D({},o),{status:d,classNameModifiers:["standalone"],label:n&&{}.hasOwnProperty.call(n,"value")&&0===n.value?s.get("preauthorizeWith")+" "+i:s.get("continueTo")+" "+i,onClick:a})))},oi=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return S(t,e),t.prototype.formatProps=function(e){return D(D({},e),{showButton:!!e.showPayButton})},t.prototype.formatData=function(){return{paymentMethod:{type:this.props.type}}},Object.defineProperty(t.prototype,"isValid",{get:function(){return!0},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"icon",{get:function(){return Me({loadingContext:this.props.loadingContext})(this.props.type)},enumerable:!1,configurable:!0}),t.prototype.render=function(){var e=this;return this.props.url&&this.props.method?te(ni,D({},this.props)):this.props.showButton?te(ka,D({},this.props,{loadingContext:this.props.loadingContext}),te(ii,D({},this.props,{onSubmit:this.submit,payButton:this.payButton,ref:function(t){e.componentRef=t}}))):null},t.type="redirect",t.defaultProps={type:t.type,showPayButton:!0},t}(ct),si=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return S(t,e),t.prototype.formatProps=function(e){var t;return D(D({},e),{showPayButton:null!==(t=e.showButton)&&void 0!==t?t:e.showPayButton})},t.prototype.formatData=function(){return{paymentMethod:{type:t.type}}},Object.defineProperty(t.prototype,"displayName",{get:function(){return this.props.name||this.constructor.type},enumerable:!1,configurable:!0}),t.prototype.render=function(){var e=this;return this.props.showPayButton?te(ka,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},te(ii,D({},this.props,{name:this.displayName,onSubmit:this.submit,payButton:this.payButton,ref:function(t){e.componentRef=t}}))):null},t.type="giropay",t}(oi),ci=2,di=0,li="adyen",ui="https://pay.google.com/gp/p/js/pay.js";function pi(e){var t=e.amount,a=e.countryCode,r=void 0===a?"US":a,n=e.totalPriceStatus,i=void 0===n?"FINAL":n,o=A(e,["amount","countryCode","totalPriceStatus"]),s=String(W(t.value,t.currency));return D({countryCode:r,currencyCode:t.currency,totalPrice:s,totalPriceStatus:i},o.transactionInfo)}function mi(e){var t=e.configuration,a=A(e,["configuration"]);return{apiVersion:ci,apiVersionMinor:di,transactionInfo:pi(a),merchantInfo:{merchantId:t.merchantId,merchantName:t.merchantName},allowedPaymentMethods:[{type:"CARD",tokenizationSpecification:{type:"PAYMENT_GATEWAY",parameters:{gateway:li,gatewayMerchantId:t.gatewayMerchantId}},parameters:{allowedAuthMethods:a.allowedAuthMethods,allowedCardNetworks:a.allowedCardNetworks,allowPrepaidCards:a.allowPrepaidCards,allowCreditCards:a.allowCreditCards,billingAddressRequired:a.billingAddressRequired,billingAddressParameters:a.billingAddressParameters}}],emailRequired:a.emailRequired,shippingAddressRequired:a.shippingAddressRequired,shippingAddressParameters:a.shippingAddressParameters,shippingOptionRequired:a.shippingOptionRequired,shippingOptionParameters:a.shippingOptionParameters,callbackIntents:a.callbackIntents}}var hi=function(){function e(e){var t=function(e){switch(void 0===e&&(e="TEST"),e.toLowerCase()){case"production":case"live":return"PRODUCTION";default:return"TEST"}}(e.environment);this.paymentsClient=this.getGooglePaymentsClient({environment:t,paymentDataCallbacks:e.paymentDataCallbacks})}return e.prototype.getGooglePaymentsClient=function(e){var t;return B(this,void 0,void 0,(function(){return T(this,(function(a){switch(a.label){case 0:return(null===(t=window.google)||void 0===t?void 0:t.payments)?[3,2]:[4,new Ia(ui).load()];case 1:a.sent(),a.label=2;case 2:return[2,new google.payments.api.PaymentsClient(e)]}}))}))},e.prototype.isReadyToPay=function(e){return this.paymentsClient?this.paymentsClient.then((function(t){return t.isReadyToPay((r=(a=e).allowedAuthMethods,n=a.allowedCardNetworks,i=a.existingPaymentMethodRequired,{apiVersion:ci,apiVersionMinor:di,allowedPaymentMethods:[{type:"CARD",parameters:{allowedAuthMethods:r,allowedCardNetworks:n},tokenizationSpecification:{type:"PAYMENT_GATEWAY",parameters:{}}}],existingPaymentMethodRequired:void 0!==i&&i}));var a,r,n,i})):Promise.reject(new Error("Google Pay is not available"))},e.prototype.prefetchPaymentData=function(e){if(!this.paymentsClient)throw new Error("Google Pay is not available");var t=mi(e);this.paymentsClient.then((function(e){return e.prefetchPaymentData(t)}))},e.prototype.initiatePayment=function(e){if(!this.paymentsClient)throw new Error("Google Pay is not available");var t=mi(e);return this.paymentsClient.then((function(e){return e.loadPaymentData(t)}))},e}(),fi=(a(122),function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.clicked=!1,t.handleClick=function(e){e.preventDefault(),e.stopPropagation(),t.clicked||(t.props.onClick(e),t.clicked=!0,setTimeout((function(){t.clicked=!1}),300))},t}return S(t,e),t.prototype.componentDidMount=function(){var e=this,t=this.props,a=t.buttonColor,r=t.buttonType;t.paymentsClient.then((function(t){return t.createButton({onClick:e.handleClick,buttonType:r,buttonColor:a})})).then((function(t){e.paywithgoogleWrapper.appendChild(t)}))},t.prototype.render=function(){var e=this;return te("span",{className:"adyen-checkout__paywithgoogle",ref:function(t){e.paywithgoogleWrapper=t}})},t.defaultProps={buttonColor:"default",buttonType:"long"},t}(ne)),yi={environment:"TEST",existingPaymentMethodRequired:!1,buttonColor:"default",buttonType:"long",showPayButton:!0,configuration:{gatewayMerchantId:"",merchantId:"",merchantName:""},amount:{value:0,currency:"USD"},countryCode:"US",totalPriceStatus:"FINAL",onError:function(){},onAuthorized:function(e){return e},onSubmit:function(){},onClick:function(e){return e()},allowedAuthMethods:["PAN_ONLY","CRYPTOGRAM_3DS"],allowedCardNetworks:["AMEX","DISCOVER","JCB","MASTERCARD","VISA"],allowCreditCards:!0,allowPrepaidCards:!0,billingAddressRequired:!1,billingAddressParameters:void 0,emailRequired:!1,shippingAddressRequired:!1,shippingAddressParameters:void 0,shippingOptionRequired:!1,shippingOptionParameters:void 0,paymentMethods:[]},bi=function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.googlePay=new hi(t.props),t.loadPayment=function(){var e=t.props,a=e.onSubmit,r=void 0===a?function(){}:a,n=e.onAuthorized,i=void 0===n?function(){}:n;return new Promise((function(e,a){return t.props.onClick(e,a)})).then((function(){return t.googlePay.initiatePayment(t.props)})).then((function(e){return t.setState({googlePayToken:e.paymentMethodData.tokenizationData.token,googlePayCardNetwork:e.paymentMethodData.info.cardNetwork}),r({data:t.data,isValid:t.isValid},t),i(e)})).catch((function(e){return t.props.onError(e),Promise.reject(e)}))},t.submit=function(){return t.loadPayment()},t.startPayment=function(){return t.loadPayment()},t.isAvailable=function(){return t.isReadyToPay().then((function(e){if(!e.result)throw new Error("Google Pay is not available");if(!1===e.paymentMethodPresent)throw new Error("Google Pay - No paymentMethodPresent");return!0})).catch((function(){return!1}))},t.isReadyToPay=function(){return t.googlePay.isReadyToPay(t.props)},t.prefetch=function(){return t.googlePay.prefetchPaymentData(t.props)},t}return S(t,e),t.prototype.formatProps=function(e){var t,a,r,n=e.configuration,i=n.merchantIdentifier,o=(null===(t=e.brands)||void 0===t?void 0:t.length)?(a=e.brands,r={mc:"MASTERCARD",amex:"AMEX",visa:"VISA",interac:"INTERAC",discover:"DISCOVER"},a.reduce((function(e,t){return r[t]&&!e.includes(r[t])&&e.push(r[t]),e}),[])):e.allowedCardNetworks;return D(D({},e),{showButton:!0===e.showPayButton,configuration:D(D({},n),i&&{merchantId:i}),allowedCardNetworks:o})},t.prototype.formatData=function(){return{paymentMethod:D({type:t.type},this.state)}},Object.defineProperty(t.prototype,"isValid",{get:function(){return!!this.state.googlePayToken},enumerable:!1,configurable:!0}),t.prototype.render=function(){return this.props.showButton?te(fi,{buttonColor:this.props.buttonColor,buttonType:this.props.buttonType,paymentsClient:this.googlePay.paymentsClient,onClick:this.submit}):null},t.type="paywithgoogle",t.defaultProps=yi,t}(ct),vi=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return S(t,e),t.type="entercash",t}(Za),gi={blur:{default:function(e){return{isValid:e&&e.length>0,errorMessage:!0}},telephoneNumber:function(e){return{isValid:e&&Wt.test(e)&&(10===e.length||11===e.length),errorMessage:"voucher.econtext.telephoneNumber.invalid"}},shopperEmail:function(e){return{isValid:Yt.test(e),errorMessage:!0}}}};function ki(e){var t=Ge(D({},e.data)),a=t[0],r=t[1],n=Ge(!1),i=n[0],o=n[1],s=Je(null),c=nt().i18n,d=new qt(gi);Ye((function(){e.onChange({data:a,isValid:i})}),[a,i]);var l=Ge("ready"),u=l[0],p=l[1];return this.setStatus=function(e){p(e)},this.showValidation=function(){s.current&&s.current.showValidation()},te("div",{className:"adyen-checkout__econtext-input__field"},te(Qt,{data:a,requiredFields:["firstName","lastName","telephoneNumber","shopperEmail"],onChange:function(e){r(e.data),o(e.isValid)},namePrefix:"econtext",ref:s,validator:d}),e.showPayButton&&e.payButton({status:u,label:c.get("confirmPurchase")}))}function Ci(e){var t,a,r=(t=e,(a=document.createElement("textArea")).readOnly=!0,a.value=t,document.body.appendChild(a),a);if(window.navigator.userAgent.match(/ipad|iphone/i)){var n=document.createRange();n.selectNodeContents(r);var i=window.getSelection();i.removeAllRanges(),i.addRange(n),r.setSelectionRange(0,999999)}else r.select();document.execCommand("copy"),document.body.removeChild(r)}var _i=Ci;a(51);function Ni(e){var t=e.voucherDetails,a=void 0===t?[]:t,r=e.className,n=void 0===r?"":r,i=A(e,["voucherDetails","className"]),o=nt(),s=o.i18n,c=o.loadingContext;return te("div",{className:je()("adyen-checkout__voucher-result","adyen-checkout__voucher-result--"+i.paymentMethodType,n)},te("div",{className:"adyen-checkout__voucher-result__top"},te("div",{className:"adyen-checkout__voucher-result__image"},!!i.imageUrl&&te("span",{className:"adyen-checkout__voucher-result__image__wrapper"},te("img",{alt:i.paymentMethodType,className:"adyen-checkout__voucher-result__image__brand",src:i.imageUrl})),!!i.issuerImageUrl&&te("span",{className:"adyen-checkout__voucher-result__image__wrapper"},te("img",{alt:i.paymentMethodType,className:"adyen-checkout__voucher-result__image__issuer",src:i.issuerImageUrl}))),te("div",{className:"adyen-checkout__voucher-result__introduction"},i.introduction," ",i.instructionsUrl&&te("a",{className:"adyen-checkout__link adyen-checkout__link--voucher-result-instructions",href:i.instructionsUrl,target:"_blank",rel:"noopener noreferrer"},s.get("voucher.readInstructions")," \u203a")),i.amount&&te("div",{className:"adyen-checkout__voucher-result__amount"},i.amount,i.surcharge&&te("span",{className:"adyen-checkout__voucher-result__surcharge"},"(",s.get("voucher.surcharge").replace("%@",i.surcharge),")"))),i.reference&&te("div",{className:"adyen-checkout__voucher-result__separator"},te("div",{className:"adyen-checkout__voucher-result__separator__inner"}),te("div",{className:"adyen-checkout__voucher-result__code__label"},te("span",{className:"adyen-checkout__voucher-result__code__label__text"},s.get("voucher.paymentReferenceLabel")))),te("div",{className:"adyen-checkout__voucher-result__bottom"},i.reference&&te("div",{className:"adyen-checkout__voucher-result__code"},i.barcode&&te("img",{alt:s.get("voucher.paymentReferenceLabel"),className:"adyen-checkout__voucher-result__code__barcode",src:i.barcode}),te("span",null,i.reference)),(!!i.downloadUrl||!!i.copyBtn)&&te("ul",{className:"adyen-checkout__voucher-result__actions"},!!i.copyBtn&&te("li",{className:"adyen-checkout__voucher-result__actions__item"},te(it,{inline:!0,secondary:!0,onClick:function(e,t){var a=t.complete;Ci(i.reference),a()},icon:Me({loadingContext:c,imageFolder:"components/"})("copy"),label:s.get("button.copy")})),!!i.downloadUrl&&te("li",{className:"adyen-checkout__voucher-result__actions__item"},te(it,{inline:!0,secondary:!0,href:i.downloadUrl,icon:Me({loadingContext:c,imageFolder:"components/"})("download"),label:i.downloadButtonText||s.get("button.download"),target:"_blank",rel:"noopener noreferrer"}))),te("ul",{className:"adyen-checkout__voucher-result__details"},a.filter((function(e){var t=e.label,a=e.value;return!!t&&!!a})).map((function(e,t){var a=e.label,r=e.value;return te("li",{key:t,className:"adyen-checkout__voucher-result__details__item"},te("span",{className:"adyen-checkout__voucher-result__details__label"},a),te("span",{className:"adyen-checkout__voucher-result__details__value"},r))})))))}var wi=function(e){var t=e.reference,a=e.totalAmount,r=e.expiresAt,n=e.paymentMethodType,i=e.maskedTelephoneNumber,o=e.instructionsUrl,s=e.collectionInstitutionNumber,c=nt(),d=c.loadingContext,l=c.i18n;return te(Ni,{paymentMethodType:n,reference:t,introduction:l.get("voucher.introduction.econtext"),imageUrl:Me({loadingContext:d})(n),instructionsUrl:o,amount:a&&l.amount(a.value,a.currency),voucherDetails:[{label:l.get("voucher.collectionInstitutionNumber"),value:s},{label:l.get("voucher.expirationDate"),value:l.date(r)},{label:l.get("voucher.telephoneNumber"),value:i}],copyBtn:!0})},Pi=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return S(t,e),Object.defineProperty(t.prototype,"isValid",{get:function(){return!!this.state.isValid},enumerable:!1,configurable:!0}),t.prototype.formatData=function(){return D(D({},this.state.data),{paymentMethod:{type:this.props.type||t.type}})},Object.defineProperty(t.prototype,"icon",{get:function(){return Me({loadingContext:this.props.loadingContext})(this.props.type)},enumerable:!1,configurable:!0}),t.prototype.render=function(){var e=this;return te(ka,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},this.props.reference?te(wi,D({ref:function(t){e.componentRef=t}},this.props)):te(ki,D({ref:function(t){e.componentRef=t}},this.props,{onChange:this.setState,onSubmit:this.submit,payButton:this.payButton})))},t.type="econtext",t}(ct),Fi=["ES","FR"],xi=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return S(t,e),t.prototype.formatProps=function(t){return D(D({},e.prototype.formatProps.call(this,t)),{allowedCountries:t.countryCode?[t.countryCode]:Fi})},t.type="facilypay_3x",t}(Ca),Si=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return S(t,e),t.prototype.formatProps=function(t){return D(D({},e.prototype.formatProps.call(this,t)),{allowedCountries:t.countryCode?[t.countryCode]:Fi})},t.type="facilypay_4x",t}(Ca),Di=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return S(t,e),t.prototype.formatProps=function(t){return D(D({},e.prototype.formatProps.call(this,t)),{allowedCountries:t.countryCode?[t.countryCode]:Fi})},t.type="facilypay_6x",t}(Ca),Ai=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return S(t,e),t.prototype.formatProps=function(t){return D(D({},e.prototype.formatProps.call(this,t)),{allowedCountries:t.countryCode?[t.countryCode]:Fi})},t.type="facilypay_10x",t}(Ca),Bi=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return S(t,e),t.prototype.formatProps=function(t){return D(D({},e.prototype.formatProps.call(this,t)),{allowedCountries:t.countryCode?[t.countryCode]:Fi})},t.type="facilypay_12x",t}(Ca),Ti=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return S(t,e),t.type="ideal",t}(Za),zi=["black","white"],Mi=["en_US","en_AU","en_GB","fr_CA","es_ES","it_IT","fr_FR","de_DE","pt_BR","zh_CN","da_DK","zh_HK","id_ID","he_IL","ja_JP","ko_KR","nl_NL","no_NO","pl_PL","pt_PT","ru_RU","sv_SE","th_TH","zh_TW"],Ii=function(e,t){return void 0===t&&(t={}),"paypal"===e?D({},t):Object.keys(t).reduce((function(e,a){var r=t[a];return("color"!==a||zi.includes(r))&&(e[a]=r),e}),{})},ji=function(e){var t=e.amount,a=e.countryCode,r=e.debug,n=e.environment,i=void 0===n?"":n,o=e.locale,s=e.configuration,c=e.commit,d=e.vault,l=function(e){var t=e?e.replace("-","_"):null;return Mi.includes(t)?t:null}(o),u=t?t.currency:null,p="test"===i.toLowerCase(),m=p?"AVzsPoGmjcm99YG02kq0iWL3KP3JedbMQJO2QUnVUc-t7aUzjkBWte7relkAC5SPUL50ovLGKmxfA674":"AU0Z-TP9t5_9196agaBN6ZD3UAwypdP1IX8ZYH3PcNNAQMXUTDQlChruXqQEhyI6-NKBKowN6ydkj477",h=s.merchantId,f=s.intent;return D(D(D(D(D(D(D({},h&&{"merchant-id":h}),l&&{locale:l}),a&&p&&{"buyer-country":a}),r&&p&&{debug:r}),u&&{currency:u}),f&&{intent:f}),{commit:c,vault:d,"client-id":m,"integration-date":"2020-02-01",components:"buttons,funding-eligibility"})};function Ei(e){var t=e.onInit,a=e.onComplete,r=e.onClick,n=e.onCancel,i=e.onError,o=e.onShippingChange,s=e.onSubmit,c=e.paypalRef,d=e.style,l=Je(null),u=Je(null),p=function(e,l){var u=c.Buttons({fundingSource:e,style:Ii(e,d),onInit:t,onClick:r,onCancel:n,onError:i,onShippingChange:o,createOrder:s,onApprove:a});u.isEligible()&&u.render(l.current)};return Ye((function(){var e=c.FUNDING,t=e.PAYPAL,a=e.CREDIT;p(t,l),p(a,u)}),[]),te("div",{className:"adyen-checkout__paypal__buttons"},te("div",{className:"adyen-checkout__paypal__button adyen-checkout__paypal__button--paypal",ref:l}),te("div",{className:"adyen-checkout__paypal__button adyen-checkout__paypal__button--credit",ref:u}))}function Oi(e){var t=nt().i18n,a=Ge("pending"),r=a[0],n=a[1];this.setStatus=function(e){n(e)};var i=function(){n("ready")};return Ye((function(){var t=function(e){var t=ji(e);return"https://www.paypal.com/sdk/js?"+decodeURIComponent(Object.keys(t).map((function(e){return e+"="+t[e]})).join("&"))}(e),a=new Ia(t);return a.load().then(i),function(){a.remove()}}),[]),te("div",{className:"adyen-checkout__paypal"},"pending"===r?te("div",{className:"adyen-checkout__paypal__status adyen-checkout__paypal__status--pending"},te(Ee,null)):"processing"===r?te("div",{className:"adyen-checkout__paypal__status adyen-checkout__paypal__status--processing"},te(Ee,{size:"medium",inline:!0})," ",t.get("paypal.processingPayment")):te(Ei,D({},e,{onComplete:function(t){n("processing"),e.onComplete(t)},paypalRef:window.paypal})))}var Ri={environment:"TEST",status:"loading",showPayButton:!0,merchantId:"",intent:null,commit:!0,vault:!1,style:{height:48},configuration:{merchantId:"",intent:null},onSubmit:function(){},onAdditionalDetails:function(){},onInit:function(){},onClick:function(){},onCancel:function(){},onError:function(){},onShippingChange:function(){}},Vi=(a(123),function(e){function t(t){var a=e.call(this,t)||this;return a.paymentData=null,a.resolve=null,a.reject=null,a.handleAction=a.handleAction.bind(a),a.updateWithAction=a.updateWithAction.bind(a),a.handleCancel=a.handleCancel.bind(a),a.handleComplete=a.handleComplete.bind(a),a.handleError=a.handleError.bind(a),a.handleSubmit=a.handleSubmit.bind(a),a.submit=a.submit.bind(a),a}return S(t,e),t.prototype.formatProps=function(e){var t=e.configuration,a=e.intent,r=e.merchantId;return D(D({},e),{configuration:D(D(D({},t),a&&{intent:a}),r&&{merchantId:r})})},t.prototype.formatData=function(){return{paymentMethod:{type:t.type,subtype:t.subtype}}},t.prototype.handleAction=function(e){return this.updateWithAction(e)},t.prototype.updateWithAction=function(e){if(e.paymentMethodType!==this.data.paymentMethod.type)throw new Error("Invalid Action");return e.paymentData&&(this.paymentData=e.paymentData),e.sdkData&&e.sdkData.token?this.resolve(e.sdkData.token):this.reject(new Error("No token was provided")),null},Object.defineProperty(t.prototype,"isValid",{get:function(){return!0},enumerable:!1,configurable:!0}),t.prototype.handleCancel=function(e){this.props.onCancel(e,this.elementRef)},t.prototype.handleComplete=function(e){var t={data:{details:e,paymentData:this.paymentData}};this.props.onAdditionalDetails(t,this.elementRef)},t.prototype.handleError=function(e){this.props.onError(e,this.elementRef)},t.prototype.startPayment=function(){return Promise.reject("Calling submit() is not supported for this payment method")},t.prototype.handleSubmit=function(){var e=this,t=this.data,a=this.isValid;return this.props.onSubmit&&this.props.onSubmit({data:t,isValid:a},this.elementRef),new Promise((function(t,a){e.resolve=t,e.reject=a}))},t.prototype.submit=function(){var e=this;this.startPayment().catch((function(t){e.props.onError(t,e.elementRef)}))},t.prototype.render=function(){var e=this;return this.props.showPayButton?te(Oi,D({ref:function(t){e.componentRef=t}},this.props,{onCancel:this.handleCancel,onChange:this.setState,onComplete:this.handleComplete,onError:this.handleError,onSubmit:this.handleSubmit})):null},t.type="paypal",t.subtype="sdk",t.defaultProps=Ri,t}(ct)),Li=function(e,t){return void 0===t&&(t=3),!!e&&e.length>=t},Ui=(a(124),function(e){function t(t){var a,r,n,i,o=e.call(this,t)||this;return o.handlePhoneInput=function(e){e.preventDefault();var t=e.target.value,a=Li(t,o.props.minLength);o.setState((function(e){return{data:D(D({},e.data),{phoneNumber:t}),errors:D(D({},e.errors),{phoneNumber:!a})}}),o.onChange)},o.handlePrefixChange=function(e){e.preventDefault();var t=e.currentTarget.getAttribute("data-value"),a=!!t;o.setState((function(e){return D({data:D(D({},e.data),{phonePrefix:t})},a&&{errors:D(D({},e.errors),{phonePrefix:!1})})}),o.onChange)},o.showValidation=function(){var e=!o.props.items||!o.props.items.length||!!o.state.data.phonePrefix,t=Li(o.state.data.phoneNumber,o.props.minLength);o.setState({errors:{phoneNumber:!t,phonePrefix:!e}})},o.handlePrefixChange=o.handlePrefixChange.bind(o),o.handlePhoneInput=o.handlePhoneInput.bind(o),o.onChange=o.onChange.bind(o),o.state={data:{phonePrefix:o.props.selected||(null===(a=o.props.data)||void 0===a?void 0:a.phonePrefix),phoneNumber:(null===(r=o.props.data)||void 0===r?void 0:r.phoneNumber)||""},isValid:!!(null===(n=o.props.data)||void 0===n?void 0:n.phonePrefix)&&!!(null===(i=o.props.data)||void 0===i?void 0:i.phoneNumber),errors:{}},o}return S(t,e),t.prototype.onChange=function(){var e=this,t=!this.props.items||!!this.state.data.phonePrefix,a=Li(this.state.data.phoneNumber,this.props.minLength),r=t&&a;this.setState({isValid:r},(function(){e.props.onChange(e.state)}))},t.prototype.render=function(){var e=!!this.props.items&&this.props.items.length;return te("div",{className:"adyen-checkout__phone-input"},te(St,{errorMessage:!!this.state.errors.phoneNumber,label:this.props.i18n.get("telephoneNumber"),className:je()({"adyen-checkout__input--phone-number":!0}),inputWrapperModifiers:["phoneInput"]},te("div",{className:"adyen-checkout__input-wrapper"},te("div",{className:je()({"adyen-checkout__input":!0,"adyen-checkout__input--invalid":!!this.state.errors.phoneNumber})},!!e&&te(St,{inputWrapperModifiers:["phoneInput"]},Ut("select",{className:"adyen-checkout__dropdown--small adyen-checkout__countryFlag",items:this.props.items,name:this.props.prefixName,onChange:this.handlePrefixChange,placeholder:this.props.i18n.get("infix"),selected:this.state.data.phonePrefix}),te("div",{className:"adyen-checkout__phoneNumber"},te("div",null,this.state.data.phonePrefix),te("input",{type:"tel",name:this.props.phoneName,value:this.state.data.phoneNumber,onInput:this.handlePhoneInput,placeholder:"123 456 789",className:"adyen-checkout__input adyen-checkout__input--phoneNumber",autoCorrect:"off"})))))),this.props.showPayButton&&this.props.payButton())},t.defaultProps={onChange:function(){},onValid:function(){},phoneName:"phoneNumber",prefixName:"phonePrefix",selected:null,minLength:3},t}(ne)),Ki=function(e){if(!e)throw new Error("No item passed");if(!e.code||!e.id)return!1;var t=e.code.toUpperCase().replace(/./g,(function(e){return String.fromCodePoint?String.fromCodePoint(e.charCodeAt(0)+127397):""}));return D(D({},e),{name:t+" "+e.name+" ("+e.id+")",selectedOptionName:t})},qi=function(e,t){if(e&&t){var a=e.find((function(e){return e.code===t}));return!!a&&a.id}return!1},Hi=[{id:"+7",name:"Russian Federation",code:"RU"},{id:"+9955",name:"Georgia",code:"GE"},{id:"+507",name:"Panama",code:"PA"},{id:"+44",name:"United Kingdom",code:"GB"},{id:"+992",name:"Tajikistan",code:"TJ"},{id:"+370",name:"Lithuania",code:"LT"},{id:"+972",name:"Israel",code:"IL"},{id:"+996",name:"Kyrgyzstan",code:"KG"},{id:"+380",name:"Ukraine",code:"UA"},{id:"+84",name:"Viet Nam",code:"VN"},{id:"+90",name:"Turkey",code:"TR"},{id:"+994",name:"Azerbaijan",code:"AZ"},{id:"+374",name:"Armenia",code:"AM"},{id:"+371",name:"Latvia",code:"LV"},{id:"+91",name:"India",code:"IN"},{id:"+66",name:"Thailand",code:"TH"},{id:"+373",name:"Moldova",code:"MD"},{id:"+1",name:"United States",code:"US"},{id:"+81",name:"Japan",code:"JP"},{id:"+998",name:"Uzbekistan",code:"UZ"},{id:"+77",name:"Kazakhstan",code:"KZ"},{id:"+375",name:"Belarus",code:"BY"},{id:"+372",name:"Estonia",code:"EE"},{id:"+40",name:"Romania",code:"RO"},{id:"+82",name:"Korea",code:"KR"}],Gi=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return S(t,e),Object.defineProperty(t.prototype,"isValid",{get:function(){return!!this.state.isValid},enumerable:!1,configurable:!0}),t.prototype.formatProps=function(e){return D(D({onValid:function(){}},e),{selected:qi(e.items,e.countryCode)})},t.prototype.formatData=function(){return{paymentMethod:{type:t.type,"qiwiwallet.telephoneNumberPrefix":this.state.data?this.state.data.phonePrefix:"","qiwiwallet.telephoneNumber":this.state.data?this.state.data.phoneNumber:""}}},t.prototype.render=function(){var e=this;return te(ka,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},te(Ui,D({ref:function(t){e.componentRef=t}},this.props,this.state,{onChange:this.setState,onSubmit:this.submit,payButton:this.payButton})))},t.type="qiwiwallet",t.defaultProps={items:Hi.map(Ki).filter((function(e){return!1!==e})),countryCode:Hi[0].code,prefixName:"qiwiwallet.telephoneNumberPrefix",phoneName:"qiwiwallet.telephoneNumber"},t}(ct),Yi=function(e){function t(t){var a=e.call(this,t)||this;return a.handleSecuredFieldsRef=function(e){a.sfp=e},a.handleSecuredFieldsChange=function(e){a.setState(D(D({},e),{isValid:e.isSfpValid}))},a}return S(t,e),t.prototype.componentDidMount=function(){this.setFocusOn=this.sfp.setFocusOn,this.updateStyles=this.sfp.updateStyles,this.showValidation=this.sfp.showValidation,this.processBinLookupResponse=this.sfp.processBinLookupResponse},t.prototype.componentDidUpdate=function(){this.props.onChange(this.state)},t.prototype.componentWillUnmount=function(){this.sfp.destroy(),this.sfp=null},t.prototype.getChildContext=function(){return{i18n:this.props.i18n}},t.prototype.render=function(){return te(Vn,D({ref:this.handleSecuredFieldsRef},this.props,{onChange:this.handleSecuredFieldsChange,render:function(){return null}}))},t.defaultProps={onChange:function(){},onError:function(){}},t}(ne),Wi=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return S(t,e),t.prototype.formatProps=function(e){return D(D(D({},e),{type:"scheme"===e.type?"card":e.type}),e.brands&&!e.groupTypes&&{groupTypes:e.brands})},t.prototype.formatData=function(){return{paymentMethod:D({type:t.type},this.state.data),browserInfo:this.browserInfo}},t.prototype.updateStyles=function(e){var t;return(null===(t=this.componentRef)||void 0===t?void 0:t.updateStyles)&&this.componentRef.updateStyles(e),this},t.prototype.setFocusOn=function(e){var t;return(null===(t=this.componentRef)||void 0===t?void 0:t.setFocusOn)&&this.componentRef.setFocusOn(e),this},t.prototype.processBinLookupResponse=function(e){var t;return(null===(t=this.componentRef)||void 0===t?void 0:t.processBinLookupResponse)&&this.componentRef.processBinLookupResponse(e),this},Object.defineProperty(t.prototype,"isValid",{get:function(){return!!this.state.isValid},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"icon",{get:function(){return Me({loadingContext:this.props.loadingContext})(this.props.type)},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"browserInfo",{get:function(){return Fa()},enumerable:!1,configurable:!0}),t.prototype.render=function(){var e=this;return te(ka,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},te(Yi,D({ref:function(t){e.componentRef=t}},this.props,this.state,{rootNode:this._node,onChange:this.setState})))},t.type="scheme",t}(ct),Ji={AD:{length:24,structure:"F04F04A12",example:"AD9912345678901234567890"},AE:{length:23,structure:"F03F16",example:"AE993331234567890123456"},AL:{length:28,structure:"F08A16",example:"AL47212110090000000235698741"},AT:{length:20,structure:"F05F11",example:"AT611904300234573201"},AZ:{length:28,structure:"U04A20",example:"AZ21NABZ00000000137010001944"},BA:{length:20,structure:"F03F03F08F02",example:"BA391290079401028494"},BE:{length:16,structure:"F03F07F02",example:"BE68 5390 0754 7034"},BG:{length:22,structure:"U04F04F02A08",example:"BG80BNBG96611020345678"},BH:{length:22,structure:"U04A14",example:"BH67BMAG00001299123456"},BR:{length:29,structure:"F08F05F10U01A01",example:"BR9700360305000010009795493P1"},CH:{length:21,structure:"F05A12",example:"CH9300762011623852957"},CR:{length:22,structure:"F04F14",example:"CR72012300000171549015"},CY:{length:28,structure:"F03F05A16",example:"CY17002001280000001200527600"},CZ:{length:24,structure:"F04F06F10",example:"CZ6508000000192000145399"},DE:{length:22,structure:"F08F10",example:"DE00123456789012345678"},DK:{length:18,structure:"F04F09F01",example:"DK5000400440116243"},DO:{length:28,structure:"U04F20",example:"DO28BAGR00000001212453611324"},EE:{length:20,structure:"F02F02F11F01",example:"EE382200221020145685"},ES:{length:24,structure:"F04F04F01F01F10",example:"ES9121000418450200051332"},FI:{length:18,structure:"F06F07F01",example:"FI2112345600000785"},FO:{length:18,structure:"F04F09F01",example:"FO6264600001631634"},FR:{length:27,structure:"F05F05A11F02",example:"FR1420041010050500013M02606"},GB:{length:22,structure:"U04F06F08",example:"GB29NWBK60161331926819"},GE:{length:22,structure:"U02F16",example:"GE29NB0000000101904917"},GI:{length:23,structure:"U04A15",example:"GI75NWBK000000007099453"},GL:{length:18,structure:"F04F09F01",example:"GL8964710001000206"},GR:{length:27,structure:"F03F04A16",example:"GR1601101250000000012300695"},GT:{length:28,structure:"A04A20",example:"GT82TRAJ01020000001210029690"},HR:{length:21,structure:"F07F10",example:"HR1210010051863000160"},HU:{length:28,structure:"F03F04F01F15F01",example:"HU42117730161111101800000000"},IE:{length:22,structure:"U04F06F08",example:"IE29AIBK93115212345678"},IL:{length:23,structure:"F03F03F13",example:"IL620108000000099999999"},IS:{length:26,structure:"F04F02F06F10",example:"IS140159260076545510730339"},IT:{length:27,structure:"U01F05F05A12",example:"IT60X0542811101000000123456"},KW:{length:30,structure:"U04A22",example:"KW81CBKU0000000000001234560101"},KZ:{length:20,structure:"F03A13",example:"KZ86125KZT5004100100"},LB:{length:28,structure:"F04A20",example:"LB62099900000001001901229114"},LC:{length:32,structure:"U04F24",example:"LC07HEMM000100010012001200013015"},LI:{length:21,structure:"F05A12",example:"LI21088100002324013AA"},LT:{length:20,structure:"F05F11",example:"LT121000011101001000"},LU:{length:20,structure:"F03A13",example:"LU280019400644750000"},LV:{length:21,structure:"U04A13",example:"LV80BANK0000435195001"},MC:{length:27,structure:"F05F05A11F02",example:"MC5811222000010123456789030"},MD:{length:24,structure:"U02A18",example:"MD24AG000225100013104168"},ME:{length:22,structure:"F03F13F02",example:"ME25505000012345678951"},MK:{length:19,structure:"F03A10F02",example:"MK07250120000058984"},MR:{length:27,structure:"F05F05F11F02",example:"MR1300020001010000123456753"},MT:{length:31,structure:"U04F05A18",example:"MT84MALT011000012345MTLCAST001S"},MU:{length:30,structure:"U04F02F02F12F03U03",example:"MU17BOMM0101101030300200000MUR"},NL:{length:18,structure:"U04F10",example:"NL99BANK0123456789"},NO:{length:15,structure:"F04F06F01",example:"NO9386011117947"},PK:{length:24,structure:"U04A16",example:"PK36SCBL0000001123456702"},PL:{length:28,structure:"F08F16",example:"PL00123456780912345678901234"},PS:{length:29,structure:"U04A21",example:"PS92PALS000000000400123456702"},PT:{length:25,structure:"F04F04F11F02",example:"PT50000201231234567890154"},RO:{length:24,structure:"U04A16",example:"RO49AAAA1B31007593840000"},RS:{length:22,structure:"F03F13F02",example:"RS35260005601001611379"},SA:{length:24,structure:"F02A18",example:"SA0380000000608010167519"},SE:{length:24,structure:"F03F16F01",example:"SE4550000000058398257466"},SI:{length:19,structure:"F05F08F02",example:"SI56263300012039086"},SK:{length:24,structure:"F04F06F10",example:"SK3112000000198742637541"},SM:{length:27,structure:"U01F05F05A12",example:"SM86U0322509800000000270100"},ST:{length:25,structure:"F08F11F02",example:"ST68000100010051845310112"},TL:{length:23,structure:"F03F14F02",example:"TL380080012345678910157"},TN:{length:24,structure:"F02F03F13F02",example:"TN5910006035183598478831"},TR:{length:26,structure:"F05F01A16",example:"TR330006100519786457841326"},VG:{length:24,structure:"U04F16",example:"VG96VPVG0000012345678901"},XK:{length:20,structure:"F04F10F02",example:"XK051212012345678906"},AO:{length:25,structure:"F21",example:"AO69123456789012345678901"},BF:{length:27,structure:"F23",example:"BF2312345678901234567890123"},BI:{length:16,structure:"F12",example:"BI41123456789012"},BJ:{length:28,structure:"F24",example:"BJ39123456789012345678901234"},CI:{length:28,structure:"U01F23",example:"CI17A12345678901234567890123"},CM:{length:27,structure:"F23",example:"CM9012345678901234567890123"},CV:{length:25,structure:"F21",example:"CV30123456789012345678901"},DZ:{length:24,structure:"F20",example:"DZ8612345678901234567890"},IR:{length:26,structure:"F22",example:"IR861234568790123456789012"},JO:{length:30,structure:"A04F22",example:"JO15AAAA1234567890123456789012"},MG:{length:27,structure:"F23",example:"MG1812345678901234567890123"},ML:{length:28,structure:"U01F23",example:"ML15A12345678901234567890123"},MZ:{length:25,structure:"F21",example:"MZ25123456789012345678901"},QA:{length:29,structure:"U04A21",example:"QA30AAAA123456789012345678901"},SN:{length:28,structure:"U01F23",example:"SN52A12345678901234567890123"},UA:{length:29,structure:"F25",example:"UA511234567890123456789012345"}},Zi=function(e){return e.replace(/\W/gi,"").replace(/(.{4})(?!$)/g,"$1 ").trim()},Qi=function(e){return e.replace(/[^a-zA-Z0-9]/g,"").toUpperCase()},$i=function(e,t){return function(e,t){if(null===t||!Ji[t]||!Ji[t].structure)return!1;var a=Ji[t].structure.match(/(.{3})/g).map((function(e){var t,a=e.slice(0,1),r=parseInt(e.slice(1),10);switch(a){case"A":t="0-9A-Za-z";break;case"B":t="0-9A-Z";break;case"C":t="A-Za-z";break;case"F":t="0-9";break;case"L":t="a-z";break;case"U":t="A-Z";break;case"W":t="0-9a-z"}return"(["+t+"]{"+r+"})"}));return new RegExp("^"+a.join("")+"$")}(0,t)},Xi=function(e){return void 0===e&&(e=null),e&&Ji[e]&&Ji[e].example?Zi(Ji[e].example):"AB00 1234 5678 9012 3456 7890"};function eo(e,t){void 0===t&&(t=null),this.status=e,this.code=t}var to=function(e){var t=Qi(e);return 1===function(e){for(var t,a=e;a.length>2;)t=a.slice(0,9),a=parseInt(t,10)%97+a.slice(t.length);return parseInt(a,10)%97}(function(e){var t=e,a="A".charCodeAt(0),r="Z".charCodeAt(0);return(t=(t=t.toUpperCase()).substr(4)+t.substr(0,4)).split("").map((function(e){var t=e.charCodeAt(0);return t>=a&&t<=r?t-a+10:e})).join("")}(t))&&function(e){var t=e.slice(0,2),a=$i(0,t);return a.test&&a.test(e.slice(4))||!1}(t)},ao=function(e){var t=Qi(e);if(e.length<2)return new eo("no-validate","TOO_SHORT");var a=function(e){return!(!e||!Ji[e])&&Ji[e]}(t.slice(0,2));return a?t.length>a.length?new eo("invalid","TOO_LONG"):t.length===a.length?to(e)?new eo("valid","VALID"):new eo("invalid","INVALID_IBAN"):new eo("no-validate","UNKNOWN"):new eo("invalid","INVALID_COUNTRY")},ro=function(e){return!!(e&&e.length&&e.length>0)},no=(a(125),function(e){function t(t){var a,r,n=e.call(this,t)||this;if(n.setData=function(e,t,a){n.setState((function(a){var r;return{data:D(D({},a.data),(r={},r[e]=t,r))}}),a)},n.setError=function(e,t,a){n.setState((function(a){var r;return{errors:D(D({},a.errors),(r={},r[e]=t,r))}}),a)},n.setValid=function(e,t,a){n.setState((function(a){var r;return{valid:D(D({},a.valid),(r={},r[e]=t,r))}}),a)},n.handleHolderInput=function(e){n.setState((function(t){return{data:D(D({},t.data),{"sepa.ownerName":e})}}),(function(){n.setError("holder",!ro(n.state.data["sepa.ownerName"])),n.onChange()}))},n.handleIbanInput=function(e){var t=e.target.value,a=Qi(t),r=Zi(a),i=ao(r).status,o=e.target.selectionStart,s=n.state.data["sepa.ibanNumber"],c=function(e,t,a){if(0===e||!t.length)return 0;var r=t.length-a.length,n=r>0,i=function(e,t){return/\s/.test(e.charAt(t))},o=e-r;return n&&(i(t,o+1)||i(t,o))?e+1:!n&&i(t,e-1)?e-1:e}(o,r,s);n.setState((function(e){return{data:D(D({},e.data),{"sepa.ibanNumber":r}),errors:D(D({},e.errors),{iban:"invalid"===i?"sepaDirectDebit.ibanField.invalid":null}),valid:D(D({},e.valid),{iban:"valid"===i})}}),(function(){e.target.setSelectionRange(c,c),n.onChange()}))},n.handleIbanBlur=function(e){var t=e.target.value;if(t.length>0){var a=ao(t).status;n.setError("iban","valid"!==a?"sepaDirectDebit.ibanField.invalid":null)}},n.state={status:"ready",data:{"sepa.ownerName":(null===(a=null===t||void 0===t?void 0:t.data)||void 0===a?void 0:a.ownerName)||"","sepa.ibanNumber":(null===(r=null===t||void 0===t?void 0:t.data)||void 0===r?void 0:r.ibanNumber)||""},isValid:!1,cursor:0,errors:{},valid:{}},n.state.data["sepa.ibanNumber"]){var i=Qi(n.state.data["sepa.ibanNumber"]);n.state.data["sepa.ibanNumber"]=Zi(i)}if(n.state.data["sepa.ibanNumber"]||n.state.data["sepa.ownerName"]){var o=n.props.holderName?ro(n.state.data["sepa.ownerName"]):"",s=(n.state.data["sepa.ibanNumber"]?"valid"===ao(n.state.data["sepa.ibanNumber"]).status:"")&&o,c={data:n.state.data,isValid:s};n.props.onChange(c)}return n}return S(t,e),t.prototype.setStatus=function(e){this.setState({status:e})},t.prototype.onChange=function(){var e=this.props.holderName?ro(this.state.data["sepa.ownerName"]):"",t="valid"===ao(this.state.data["sepa.ibanNumber"]).status&&e,a={data:this.state.data,isValid:t};this.props.onChange(a)},t.prototype.showValidation=function(){var e=ao(this.state.data["sepa.ibanNumber"]).status,t=ro(this.state.data["sepa.ownerName"]);this.setError("iban","valid"!==e?"sepaDirectDebit.ibanField.invalid":null),this.setError("holder",!t||null)},t.prototype.render=function(e,t){var a=this,r=e.placeholders,n=e.countryCode,i=t.data,o=t.errors,s=t.valid,c=nt().i18n;return te("div",{className:"adyen-checkout__iban-input"},this.props.holderName&&te(St,{className:"adyen-checkout__field--owner-name",label:c.get("sepa.ownerName"),filled:i["sepa.ownerName"]&&i["sepa.ownerName"].length,errorMessage:!!o.holder&&c.get("creditCard.holderName.invalid")},Ut("text",{name:"sepa.ownerName",className:"adyen-checkout__iban-input__owner-name",placeholder:"ownerName"in r?r.ownerName:c.get("sepaDirectDebit.nameField.placeholder"),value:i["sepa.ownerName"],"aria-invalid":!!this.state.errors.holder,"aria-label":c.get("sepa.ownerName"),onInput:function(e){return a.handleHolderInput(e.target.value)}})),te(St,{className:"adyen-checkout__field--iban-number",label:c.get("sepa.ibanNumber"),errorMessage:!!o.iban&&c.get(o.iban),filled:i["sepa.ibanNumber"]&&i["sepa.ibanNumber"].length,isValid:s.iban,onBlur:this.handleIbanBlur},Ut("text",{ref:function(e){a.ibanNumber=e},name:"sepa.ibanNumber",className:"adyen-checkout__iban-input__iban-number",classNameModifiers:["large"],placeholder:"ibanNumber"in r?r.ibanNumber:Xi(n),value:i["sepa.ibanNumber"],onInput:this.handleIbanInput,"aria-invalid":!!this.state.errors.iban,"aria-label":c.get("sepa.ibanNumber"),autocorrect:"off",spellcheck:!1})),this.props.showPayButton&&this.props.payButton({status:this.state.status}))},t.defaultProps={onChange:function(){},countryCode:null,holderName:!0,placeholders:{}},t}(ne)),io=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return S(t,e),t.prototype.formatProps=function(e){return D({holderName:!0},e)},t.prototype.formatData=function(){return{paymentMethod:{type:t.type,iban:this.state.data["sepa.ibanNumber"],ownerName:this.state.data["sepa.ownerName"]}}},Object.defineProperty(t.prototype,"isValid",{get:function(){return!!this.state.isValid},enumerable:!1,configurable:!0}),t.prototype.render=function(){var e=this;return te(ka,D({},this.props,{loadingContext:this.props.loadingContext}),te(no,D({ref:function(t){e.componentRef=t}},this.props,{onChange:this.setState,onSubmit:this.submit,payButton:this.payButton})))},t.type="sepadirectdebit",t}(ct),oo=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return S(t,e),t.prototype.componentDidMount=function(){this.formEl.submit()},t.prototype.render=function(e){var t=this,a=e.name,r=e.action,n=e.target,i=e.inputName,o=e.inputValue;return te("form",{ref:function(e){t.formEl=e},method:"POST",className:je()(["adyen-checkout__threeds2__form","adyen-checkout__threeds2__form--"+a]),name:a,action:r,target:n,style:{display:"none"}},te("input",{name:i,value:o}))},t}(ne),so={result:{transStatus:"U"},type:"challengeResult"},co={result:{transStatus:"U"},type:"challengeResult",errorCode:"timeout"},lo={result:{threeDSCompInd:"N"},type:"fingerPrintResult"},uo={result:{threeDSCompInd:"N"},type:"fingerPrintResult",errorCode:"timeout"},po="unknownError",mo={timeout:"ThreeDS2 timed out",wrongOrigin:"Result came in the right format but not from the expected origin",HTMLElementError:"No proper HTML element was passed",wrongDataType:"Result data was not of the expected type",missingProperty:"Result data did not contain the expected properties",unknownError:"An unknown error occurred"},ho={"01":["250px","400px"],"02":["390px","400px"],"03":["500px","600px"],"04":["600px","400px"],"05":["100%","100%"]},fo=function(e){var t=wt.decode(e);try{return t&&JSON.parse(t)}catch(e){throw new Error("Could not decode token")}},yo=function(e){if(!e||!Object.keys(e).length)throw new Error("No (populated) data object to encode");return wt.encode(JSON.stringify(e))},bo=function(e){var t=1===e.length?"0"+e:e;return Object.prototype.hasOwnProperty.call(ho,t)?t:"02"},vo=function(e,t,a){var r;return{data:(r={},r[e]=yo({threeDSCompInd:t.threeDSCompInd}),r.paymentData=a,r)}},go=function(e,t,a){return{data:{details:{"threeds2.fingerprint":yo(t)},paymentData:a}}},ko=function(e,t,a){var r;return{data:{details:(r={},r[e]=yo({transStatus:t,authorisationToken:a}),r)}}},Co=function(e,t,a){return{data:{details:{"threeds2.challengeResult":yo({transStatus:t})},paymentData:a}}},_o=function(e){return{errorCode:e,message:mo[e]||mo[po]}},No=function(e){var t=window.btoa(e).split("=")[0];return t=(t=t.replace(/\+/g,"-")).replace(/\//g,"_")},wo=["elementRef"],Po=["createFromAction","onAdditionalDetails","challengeWindowSize","size"],Fo=["challengeWindowSize","size"],xo="threeDSIframe",So=function(e){function t(t){var a=e.call(this,t)||this;a.iframeCallback=function(){a.setState({status:"iframeLoaded"})};var r=JSON.stringify(a.props.cReqData),n=No(r);return a.state={base64URLencodedData:n},a}return S(t,e),t.prototype.get3DS2ChallengePromise=function(){var e=this;return new Promise((function(t,a){e.processMessageHandler=yt(e.props.postMessageDomain,t,a,so,"challengeResult"),window.addEventListener("message",e.processMessageHandler)}))},t.prototype.componentDidMount=function(){var e=this;this.challengePromise=lt(6e5,this.get3DS2ChallengePromise(),co),this.challengePromise.promise.then((function(t){window.removeEventListener("message",e.processMessageHandler),e.props.onCompleteChallenge(t)})).catch((function(t){window.removeEventListener("message",e.processMessageHandler),e.props.onErrorChallenge(t)}))},t.prototype.componentWillUnmount=function(){this.challengePromise&&this.challengePromise.cancel(),window.removeEventListener("message",this.processMessageHandler)},t.prototype.render=function(e,t){var a=e.acsURL,r=e.cReqData,n=e.iframeSizeArr,i=t.base64URLencodedData,o=t.status,s=n[0],c=n[1];return te("div",{className:je()(["adyen-checkout__threeds2__challenge","adyen-checkout__threeds2__challenge--"+r.challengeWindowSize])},"iframeLoaded"!==o&&te(Ee,null),te(dt,{name:xo,width:s,height:c,callback:this.iframeCallback}),te(oo,{name:"cReqForm",action:a,target:xo,inputName:"creq",inputValue:i}))},t}(ne),Do=(a(126),function(e){function t(t){var a,r,n,i,o,s,c,d,l,u,p,m=e.call(this,t)||this;if(m.props.token){var h=(a={token:m.props.token,size:m.props.challengeWindowSize||m.props.size},n=a.token,i=a.size,o=fo(n),s=o.acsTransID,c=o.acsURL,d=o.messageVersion,l=o.threeDSNotificationURL,u=o.threeDSServerTransID,p=bt(l),{acsURL:c,cReqData:{acsTransID:s,messageVersion:d,threeDSServerTransID:u,messageType:"CReq",challengeWindowSize:bo(i)},iframeSizeArr:(r=i,ho[bo(r)]),postMessageDomain:p});m.state={status:"retrievingChallengeToken",challengeData:h}}else m.state={status:"error"},m.props.onError("Missing challengeToken parameter");return m}return S(t,e),t.prototype.setStatusComplete=function(e){var t=this;this.setState({status:"complete"},(function(){var a=(t.props.useOriginalFlow?Co:ko)(t.props.dataKey,e.transStatus,t.props.paymentData);t.props.onComplete(a)}))},t.prototype.render=function(e,t){var a=this,r=t.challengeData;return"retrievingChallengeToken"===this.state.status?te(So,D({onCompleteChallenge:function(e){a.setStatusComplete(e.result)},onErrorChallenge:function(e){var t=_o(e.errorCode);a.props.onError(t),a.setStatusComplete(e.result)}},r)):null},t.defaultProps={onComplete:function(){},onError:function(){}},t}(ne)),Ao=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return S(t,e),t.prototype.render=function(){return Rr(this.props.paymentData)?te(Do,D({},this.props,{onComplete:this.onComplete})):(this.props.onError({errorCode:"threeds2.challenge",message:"No paymentData received. Challenge cannot proceed"}),null)},t.type="threeDS2Challenge",t.defaultProps={dataKey:"threeDSResult",size:"02",type:"ChallengeShopper"},t}(ct),Bo="threeDSMethodIframe",To=function(e){function t(t){var a=e.call(this,t)||this,r=a.props,n=r.threeDSServerTransID,i=r.threeDSMethodNotificationURL,o=JSON.stringify({threeDSServerTransID:n,threeDSMethodNotificationURL:i}),s=No(o);return a.state={base64URLencodedData:s},a}return S(t,e),t.prototype.get3DS2MethodPromise=function(){var e=this;return new Promise((function(t,a){e.processMessageHandler=yt(e.props.postMessageDomain,t,a,lo,"fingerPrintResult"),window.addEventListener("message",e.processMessageHandler)}))},t.prototype.componentDidMount=function(){var e=this;this.fingerPrintPromise=lt(1e4,this.get3DS2MethodPromise(),uo),this.fingerPrintPromise.promise.then((function(t){window.removeEventListener("message",e.processMessageHandler),e.props.onCompleteFingerprint(t)})).catch((function(t){window.removeEventListener("message",e.processMessageHandler),e.props.onErrorFingerprint(t)}))},t.prototype.componentWillUnmount=function(){this.fingerPrintPromise&&this.fingerPrintPromise.cancel(),window.removeEventListener("message",this.processMessageHandler)},t.prototype.render=function(e,t){var a=e.threeDSMethodURL,r=t.base64URLencodedData;return te("div",{className:"adyen-checkout__3ds2-device-fingerprint"},this.props.showSpinner&&te(Ee,null),te("div",{style:{display:"none"}},te(dt,{name:Bo}),te(oo,{name:"threeDSMethodForm",action:a,target:Bo,inputName:"threeDSMethodData",inputValue:r})))},t.defaultProps={showSpinner:!0},t}(ne),zo=function(e){function t(t){var a=e.call(this,t)||this,r=a.props,n=r.token,i=r.notificationURL;if(n){var o=function(e){var t=e.token,a=e.notificationURL,r=fo(t),n=r.threeDSMethodNotificationURL,i=r.threeDSMethodUrl,o=a||n;return{threeDSServerTransID:r.threeDSServerTransID,threeDSMethodURL:i,threeDSMethodNotificationURL:o,postMessageDomain:bt(o)}}({token:n,notificationURL:i});a.state={status:"init",fingerPrintData:o}}else a.state={status:"error"},a.props.onError("Missing fingerprintToken parameter");return a}return S(t,e),t.prototype.componentDidMount=function(){this.state.fingerPrintData&&this.state.fingerPrintData.threeDSMethodURL&&this.state.fingerPrintData.threeDSMethodURL.length?this.setState({status:"retrievingFingerPrint"}):this.setStatusComplete({threeDSCompInd:"U"})},t.prototype.setStatusComplete=function(e){var t=this;this.setState({status:"complete"},(function(){var a=(t.props.useOriginalFlow?go:vo)(t.props.dataKey,e,t.props.paymentData);t.props.onComplete(a)}))},t.prototype.render=function(e,t){var a=this,r=t.fingerPrintData;return"retrievingFingerPrint"===this.state.status?te(To,D({onCompleteFingerprint:function(e){a.setStatusComplete(e.result)},onErrorFingerprint:function(e){var t=_o(e.errorCode);a.props.onError(t),a.setStatusComplete(e.result)},showSpinner:this.props.showSpinner},r)):null},t.type="scheme",t.defaultProps={onComplete:function(){},onError:function(){},paymentData:"",showSpinner:!0},t}(ne);function Mo(e){var t=this,a=e.data;ua({path:"v1/submitThreeDS2Fingerprint?token="+this.props.clientKey,loadingContext:this.props.loadingContext,method:"POST",contentType:"application/json",clientKey:this.props.clientKey},D({},a)).then((function(e){var a,r,n,i=null!==(a=t.props.elementRef)&&void 0!==a?a:t;if(e.action||e.details){if("completed"===e.type){var o=e.details;return t.onComplete({data:{details:o}})}return"threeDS2"===(null===(r=e.action)||void 0===r?void 0:r.type)||"redirect"===(null===(n=e.action)||void 0===n?void 0:n.type)?i.handleAction(e.action):void 0}console.error("Handled Error::callSubmit3DS2Fingerprint::FAILED:: resData=",e)}))}var Io=function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.callSubmit3DS2Fingerprint=Mo.bind(t),t}return S(t,e),t.prototype.render=function(){return this.props.paymentData?te(zo,D({},this.props,{onComplete:this.props.useOriginalFlow?this.onComplete:this.callSubmit3DS2Fingerprint})):(this.props.onError({errorCode:t.defaultProps.dataKey,message:"No paymentData received. Fingerprinting cannot proceed"}),null)},t.type="threeDS2Fingerprint",t.defaultProps={dataKey:"fingerprintResult",type:"IdentifyShopper"},t}(ct),jo=function(e,t){if(void 0===t&&(t=2),0===t)return e;var a=String(e);return a.length>=t?a:("0".repeat(t)+a).slice(-1*t)},Eo=function(e,t){var a=new Date,r=t.getTime()-a.getTime(),n=r/1e3,i=function(e,t,a){var r=a.getTime()-e.getTime();return 100-Math.round(100*(t.getTime()-e.getTime())/r)}(e,a,t);return{total:r,minutes:jo(Math.floor(n/60%60)),seconds:jo(Math.floor(n%60)),completed:r<=0,percentage:i}},Oo=function(e){function t(t){var a=e.call(this,t)||this,r=6e4*a.props.minutesFromNow,n=(new Date).getTime();return a.state={startTime:new Date(n),endTime:new Date(n+r),minutes:"-",seconds:"-"},a}return S(t,e),t.prototype.tick=function(){var e=Eo(this.state.startTime,this.state.endTime);if(e.completed)return this.props.onCompleted(),this.clearInterval();var t={minutes:e.minutes,seconds:e.seconds,percentage:e.percentage};return this.setState(D({},t)),this.props.onTick(t),t},t.prototype.clearInterval=function(){clearInterval(this.interval),delete this.interval},t.prototype.componentDidMount=function(){var e=this;this.interval=setInterval((function(){e.tick()}),1e3)},t.prototype.componentWillUnmount=function(){this.clearInterval()},t.prototype.render=function(){return te("span",{className:"adyen-checkout__countdown"},te("span",{className:"countdown__minutes"},this.state.minutes),te("span",{className:"countdown__separator"},":"),te("span",{className:"countdown__seconds"},this.state.seconds))},t.defaultProps={onTick:function(){},onCompleted:function(){}},t}(ne),Ro=function(e,t,a){if(!e||!t)throw new Error("Could not check the payment status");var r,n,i;return r=(a||Be)+"services/PaymentInitiation/v1/status?token="+t,n={paymentData:e},i={method:"POST",headers:{Accept:"application/json, text/plain, */*","Content-Type":"application/json"},body:JSON.stringify(n)},fetch(r,i).then((function(e){return e.json()})).catch((function(e){throw e}))},Vo=function(e){switch(e.resultCode.toLowerCase()){case"refused":case"error":case"cancelled":return{type:"error",props:D(D({},e),{message:"error.subtitle.refused"})};case"unknown":return{type:"error",props:D(D({},e),{message:"error.message.unknown"})};case"pending":case"received":return{type:e.resultCode.toLowerCase(),props:e};case"authorised":default:return{type:"success",props:e}}},Lo=function(e){if(!e.type&&e.resultCode)return Vo(e);if(!e.type)return{type:"error",props:e};switch(e.type.toLowerCase()){case"pending":return{type:"pending",props:e};case"complete":return Vo(e);case"validation":default:return{type:"error",props:e}}},Uo=(a(127),function(e){function t(t){var a=e.call(this,t)||this;return a.statusInterval=function(){a.checkStatus(),a.setState({timePassed:a.state.timePassed+a.props.delay}),a.state.timePassed>=a.props.throttleTime&&a.setState({delay:a.props.throttledInterval})},a.redirectToApp=function(e,t){void 0===t&&(t=function(){}),setTimeout((function(){a.props.onError(a.props.type+" App was not found"),t()}),25),window.location.assign(e)},a.state={buttonStatus:"default",completed:!1,delay:t.delay,expired:!1,loading:!0,onError:function(){},percentage:100,timePassed:0},a.onTimeUp=a.onTimeUp.bind(a),a.onTick=a.onTick.bind(a),a.onComplete=a.onComplete.bind(a),a.onError=a.onError.bind(a),a.checkStatus=a.checkStatus.bind(a),a}return S(t,e),t.prototype.componentDidMount=function(){var e=this,t=this.props,a=t.shouldRedirectOnMobile,r=t.url,n=window.matchMedia("(max-width: 768px)").matches&&/Android|iPhone|iPod/.test(navigator.userAgent),i=function(){e.interval=setInterval(e.statusInterval,e.state.delay)};a&&r&&n?this.redirectToApp(r,i):i()},t.prototype.componentDidUpdate=function(e,t){t.delay!==this.state.delay&&(clearInterval(this.interval),this.interval=setInterval(this.statusInterval,this.state.delay))},t.prototype.componentWillUnmount=function(){clearInterval(this.interval)},t.prototype.onTick=function(e){this.setState({percentage:e.percentage})},t.prototype.onTimeUp=function(){return this.setState({expired:!0}),clearInterval(this.interval),this.props.onError({type:"error",props:{errorMessage:"Payment Expired"}})},t.prototype.onComplete=function(e){return clearInterval(this.interval),this.setState({completed:!0,loading:!1}),this.props.onComplete({data:{details:{payload:e.props.payload},paymentData:this.props.paymentData}}),e},t.prototype.onError=function(e){return clearInterval(this.interval),this.setState({expired:!0,loading:!1}),this.props.onComplete({data:{details:{payload:e.props.payload},paymentData:this.props.paymentData}}),e},t.prototype.checkStatus=function(){var e=this,t=this.props,a=t.paymentData,r=t.originKey,n=t.clientKey,i=t.loadingContext;return Ro(a,n||r,i).then(Lo).catch((function(e){return{type:"network-error",props:e}})).then((function(t){switch(t.type){case"success":return e.onComplete(t);case"error":return e.onError(t);default:e.setState({loading:!1})}return t}))},t.prototype.render=function(e,t){var a=this,r=e.amount,n=e.url,i=e.brandLogo,o=e.countdownTime,s=e.i18n,c=e.loadingContext,d=e.type,l=t.expired,u=t.completed,p=t.loading,m=this.props.qrCodeData?c+"barcode.shtml?barcodeType=qrCode&fileType=png&data="+this.props.qrCodeData:this.props.qrCodeImage,h=function(e,t){return te("div",{className:"adyen-checkout__qr-loader adyen-checkout__qr-loader--result"},te("img",{className:"adyen-checkout__qr-loader__icon adyen-checkout__qr-loader__icon--result",src:ze({loadingContext:c,imageFolder:"components/"})(e),alt:s.get(t)}),te("div",{className:"adyen-checkout__qr-loader__subtitle adyen-checkout__qr-loader__subtitle--result"},s.get(t)))};if(l)return h("error","error.subtitle.payment");if(u)return h("success","creditCard.success");if(p)return te("div",{className:"adyen-checkout__qr-loader"},i&&te("img",{alt:d,src:i,className:"adyen-checkout__qr-loader__brand-logo"}),te(Ee,null));var f=s.get("wechatpay.timetopay").split("%@");return te("div",{className:"\n                    adyen-checkout__qr-loader\n                    adyen-checkout__qr-loader--"+d+"\n                    "+this.props.classNameModifiers.map((function(e){return"adyen-checkout__qr-loader--"+e}))+"\n                "},i&&te("img",{src:i,alt:d,className:"adyen-checkout__qr-loader__brand-logo"}),te("div",{className:"adyen-checkout__qr-loader__subtitle"},s.get(this.props.introduction)),te("img",{src:m,alt:s.get("wechatpay.scanqrcode")}),r&&r.value&&r.currency&&te("div",{className:"adyen-checkout__qr-loader__payment_amount"},s.amount(r.value,r.currency)),te("div",{className:"adyen-checkout__qr-loader__progress"},te("span",{className:"adyen-checkout__qr-loader__percentage",style:{width:this.state.percentage+"%"}})),te("div",{className:"adyen-checkout__qr-loader__countdown"},f[0],"\xa0",te(Oo,{minutesFromNow:o,onTick:this.onTick,onCompleted:this.onTimeUp}),"\xa0",f[1]),this.props.instructions&&te("div",{className:"adyen-checkout__qr-loader__instructions"},s.get(this.props.instructions)),this.props.copyBtn&&te("div",{className:"adyen-checkout__qr-loader__actions"},te(it,{inline:!0,secondary:!0,onClick:function(e,t){var r=t.complete;_i(a.props.qrCodeData),r()},icon:ze({loadingContext:c,imageFolder:"components/"})("copy"),label:s.get("button.copy")})),n&&te("div",{className:"adyen-checkout__qr-loader__app-link"},te("span",{className:"adyen-checkout__qr-loader__separator__label"},s.get("or")),te(it,{classNameModifiers:["qr-loader"],onClick:function(){return a.redirectToApp(n)},label:s.get("openApp")})))},t.defaultProps={delay:2e3,countdownTime:15,onError:function(){},onComplete:function(){},throttleTime:6e4,classNameModifiers:[],throttledInterval:1e4,introduction:"wechatpay.scanqrcode"},t}(ne)),Ko=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return S(t,e),t.prototype.formatData=function(){return{paymentMethod:D({type:this.props.type||this.constructor.type},this.state.data)}},Object.defineProperty(t.prototype,"isValid",{get:function(){return!0},enumerable:!1,configurable:!0}),t.prototype.render=function(){var e=this;return this.props.paymentData?te(ka,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},te(Uo,D({ref:function(t){e.componentRef=t}},this.props,{shouldRedirectOnMobile:this.props.shouldRedirectOnMobile,type:this.constructor.type,brandLogo:this.props.brandLogo||this.icon,delay:this.props.delay,onComplete:this.onComplete,countdownTime:this.props.countdownTime,instructions:this.props.instructions}))):this.props.showPayButton?te(ka,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},te(ii,{name:this.displayName,onSubmit:this.submit,payButton:this.payButton,ref:function(t){e.componentRef=t}})):null},t.defaultProps={qrCodeImage:"",amount:null,paymentData:null,onError:function(){},onComplete:function(){}},t}(ct),qo=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return S(t,e),t.prototype.formatProps=function(t){return D({delay:2e3,countdownTime:15},e.prototype.formatProps.call(this,t))},t.type="wechatpayQR",t}(Ko),Ho=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return S(t,e),t.prototype.formatProps=function(t){var a=window.matchMedia("(max-width: 768px)").matches&&/Android|iPhone|iPod/.test(navigator.userAgent);return D({delay:2e3,countdownTime:15,shouldRedirectOnMobile:!0,buttonLabel:a?"openApp":"generateQRCode"},e.prototype.formatProps.call(this,t))},t.type="bcmc_mobile",t}(Ko),Go=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return S(t,e),t.type="molpay_ebanking_fpx_MY",t}(Za),Yo=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return S(t,e),t.type="molpay_ebanking_TH",t}(Za),Wo=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return S(t,e),t.type="molpay_ebanking_VN",t}(Za),Jo=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return S(t,e),t.type="openbanking_UK",t}(Za),Zo=function(e){return Yt.test(e)};function Qo(e){var t=nt().i18n,a=Ge(!1),r=a[0],n=a[1],i=Ge(D(D({},e.data),e.issuer&&{issuer:e.issuer})),o=i[0],s=i[1],c=Ge({}),d=c[0],l=c[1],u=Ja({},e.type),p=e.items.map((function(e){return D(D({},e),{icon:u(e.id&&e.id.toLowerCase())})})),m=function(){return["dragonpay_ebanking","dragonpay_otc_banking","dragonpay_otc_non_banking"].indexOf(e.type)>-1},h=function(e,t){return Zo(e)&&(!!t||!m())},f=function(e){return"dragonpay_otc_non_banking"===e?"dragonpay.voucher.non.bank.selectField.placeholder":"dragonpay.voucher.bank.selectField.placeholder"};Ye((function(){e.issuer&&e.onChange({isValid:r,data:o,errors:d})}),[]),Ye((function(){e.onChange({isValid:r,data:o,errors:d})}),[r,o,d]);var y=Ge("ready"),b=y[0],v=y[1];return this.setStatus=function(e){v(e)},this.showValidation=function(){l({shopperEmail:!Zo(o.shopperEmail),issuer:!o.issuer})},te("div",{className:"adyen-checkout__dragonpay-input__field"},te(St,{label:t.get("shopperEmail"),errorMessage:d.shopperEmail},Ut("emailAddress",{name:"dragonpay.shopperEmail",autoCorrect:"off",value:o.shopperEmail,className:"adyen-checkout__input--large",spellCheck:!1,onInput:function(e){var t=e.target.value;n(h(t,o.issuer)),s(D(D({},o),{shopperEmail:t})),l(D(D({},d),{shopperEmail:!1}))}})),m()&&te(St,{label:t.get(f(e.type)),errorMessage:d.issuer},Ut("select",{items:p,selected:o.issuer,placeholder:t.get(f(e.type)),name:"issuer",className:"adyen-checkout__dropdown--large adyen-checkout__issuer-list__dropdown",onChange:function(e){var t=e.currentTarget.getAttribute("data-value");n(h(o.shopperEmail,t)),s(D(D({},o),{issuer:t})),l(D(D({},d),{issuer:!1}))}})),e.showPayButton&&e.payButton({status:b,label:t.get("confirmPurchase")}))}function $o(e){var t=e.reference,a=e.totalAmount,r=e.surcharge,n=e.expiresAt,i=e.alternativeReference,o=e.instructionsUrl,s=e.icon,c=e.issuer,d=e.paymentMethodType,l=nt(),u=l.loadingContext,p=l.i18n,m=Ja({loadingContext:u},d)(c.toLowerCase());return te(Ni,{reference:t,paymentMethodType:d,introduction:p.get("voucher.introduction"),imageUrl:s,issuerImageUrl:m,instructionsUrl:o,amount:a&&p.amount(a.value,a.currency),surcharge:r&&p.amount(r.value,r.currency),voucherDetails:[{label:p.get("voucher.expirationDate"),value:p.date(n)},{label:p.get("voucher.alternativeReference"),value:i}],copyBtn:!0})}Qo.defaultProps={data:{},items:[],onChange:function(){}};var Xo=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return S(t,e),Object.defineProperty(t.prototype,"isValid",{get:function(){return!!this.state.isValid},enumerable:!1,configurable:!0}),t.prototype.formatData=function(){var e=this.state.data,a=e.issuer,r=e.shopperEmail;return D(D({},r&&{shopperEmail:r}),{paymentMethod:D(D({},a&&{issuer:a}),{type:this.props.type||t.type})})},t.prototype.formatProps=function(e){return D(D({},e),{items:e.details&&e.details.length?(e.details.find((function(e){return"issuer"===e.key}))||{}).items:e.items})},t.prototype.render=function(){var e=this;return te(ka,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},this.props.reference?te($o,D({ref:function(t){e.componentRef=t},icon:this.icon},this.props)):te(Qo,D({ref:function(t){e.componentRef=t}},this.props,{onChange:this.setState,onSubmit:this.submit,payButton:this.payButton})))},t.type="dragonpay",t}(ct);function es(e){var t=Ge(D({},e.data)),a=t[0],r=t[1],n=Ge(!1),i=n[0],o=n[1],s=Je(null),c=nt().i18n;Ye((function(){e.onChange({data:a,isValid:i})}),[a,i]);var d=Ge("ready"),l=d[0],u=d[1];return this.setStatus=function(e){u(e)},this.showValidation=function(){s.current&&s.current.showValidation()},te("div",{className:"adyen-checkout__doku-input__field"},te(Qt,{data:a,requiredFields:["firstName","lastName","shopperEmail"],onChange:function(e){r(e.data),o(e.isValid)},namePrefix:"doku",ref:s}),e.showPayButton&&e.payButton({status:l,label:c.get("confirmPurchase")}))}var ts=function(e){var t=e.reference,a=e.expiresAt,r=e.instructionsUrl,n=e.shopperName,i=e.merchantName,o=e.totalAmount,s=e.paymentMethodType,c=nt(),d=c.loadingContext,l=c.i18n;return te(Ni,{paymentMethodType:s,reference:t,introduction:l.get("voucher.introduction.doku"),imageUrl:Me({loadingContext:d})(s),instructionsUrl:r,amount:o&&l.amount(o.value,o.currency),voucherDetails:[{label:l.get("voucher.expirationDate"),value:l.date(a)},{label:l.get("voucher.shopperName"),value:n},{label:l.get("voucher.merchantName"),value:i}],copyBtn:!0})},as=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return S(t,e),Object.defineProperty(t.prototype,"isValid",{get:function(){return!!this.state.isValid},enumerable:!1,configurable:!0}),t.prototype.formatData=function(){return D(D({},this.state.data),{paymentMethod:{type:this.props.type||t.type}})},Object.defineProperty(t.prototype,"icon",{get:function(){return Me({loadingContext:this.props.loadingContext})(this.props.type)},enumerable:!1,configurable:!0}),t.prototype.render=function(){var e=this;return te(ka,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},this.props.reference?te(ts,D({ref:function(t){e.componentRef=t}},this.props)):te(es,D({ref:function(t){e.componentRef=t}},this.props,{onChange:this.setState,onSubmit:this.submit,payButton:this.payButton})))},t.type="doku",t}(ct);function rs(e){var t=e.errors,a=e.value,r=e.onInput,n=e.onChange,i=nt().i18n,o=Ge(!1),s=o[0],c=o[1];return te("div",{className:je()("adyen-checkout__fieldset","adyen-checkout__fieldset--sendCopyToEmail",e.classNames)},te(St,{classNameModifiers:["sendCopyToEmail"]},Ut("boolean",{onChange:function(t){c(t.target.checked),e.onToggle(s)},label:i.get("boleto.sendCopyToEmail"),name:"sendCopyToEmail",value:s})),s&&te(St,{label:i.get("shopperEmail"),classNameModifiers:["shopperEmail"],errorMessage:t},Ut("emailAddress",{name:"shopperEmail",autoCorrect:"off",spellCheck:!1,value:a,onInput:r,onChange:n})))}function ns(e){return e.replace(/[^0-9]/g,"").trim()}function is(e){var t=ns(e);return t.length>11?function(e){return e.replace(/^(\d{2})(\d{3})(\d{3})?(\d{4})?(\d{1,2})?$/g,(function(e,t,a,r,n,i){return void 0===n&&(n=""),void 0===i&&(i=""),t+"."+a+"."+r+"/"+n+(i.length?"-"+i:"")}))}(t):function(e){return e.replace(/\W/gi,"").replace(/(\d{3})(?!$)/g,"$1.").replace(/(.{11}).(\d{1,2})$/g,"$1-$2")}(t)}var os=new qt({input:{socialSecurityNumber:function(e){return/(^\d{3}\.\d{3}\.\d{3}-\d{2}$)|(^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$)/.test(e)}},blur:{socialSecurityNumber:function(e){return/(^\d{3}\.\d{3}\.\d{3}-\d{2}$)|(^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$)/.test(e)},default:function(e){return e&&e.length>0}}});function ss(e){var t=nt().i18n,a=Je(null),r=Ge(D(D({},e.data),e.data.socialSecurityNumber&&{socialSecurityNumber:is(e.data.socialSecurityNumber)})),n=r[0],i=r[1],o=Ge({}),s=o[0],c=o[1],d=Ge(D({},e.data.socialSecurityNumber&&{socialSecurityNumber:os.validate("socialSecurityNumber","input")(is(this.props.data.socialSecurityNumber))})),l=d[0],u=d[1],p=Ge(!1),m=p[0],h=p[1],f=z(e.personalDetailsRequired||e.billingAddressRequired||e.showEmailAddress?[]:["standalone"]),y=function(e,t,a){var r,o,d;i(D(D({},n),((r={})[e]=t,r))),u(D(D({},l),((o={})[e]=a,o))),c(D(D({},s),((d={})[e]=!a,d)))},b=function(e){return function(t){var a=t.target.value,r=os.validate(e,"input")(a);y(e,a,r)}},v=function(e){return function(t){var a=t.target.value,r=os.validate(e,"blur")(a);y(e,a,r)}},g=Ge("ready"),k=g[0],C=g[1];return this.setStatus=function(e){C(e)},this.showValidation=function(){c(D(D({},m&&{shopperEmail:!os.validate("shopperEmail")(n.shopperEmail)}),e.personalDetailsRequired&&{firstName:!os.validate("firstName")(n.firstName),lastName:!os.validate("lastName")(n.lastName),socialSecurityNumber:!os.validate("socialSecurityNumber")(n.socialSecurityNumber)})),e.billingAddressRequired&&a.current.showValidation()},Ye((function(){var t=!e.personalDetailsRequired||["firstName","lastName","socialSecurityNumber"].reduce((function(e,t){return e&&Boolean(os.validate(t,"blur")(n[t]))}),!0),a=!e.billingAddressRequired||Boolean(l.billingAddress),r=m&&e.showEmailAddress,i=!r||Boolean(os.validate("shopperEmail","blur")(n.shopperEmail)),o=r?n.shopperEmail:null,s=t&&a&&i;e.onChange({data:D(D({},n),{shopperEmail:o}),isValid:s})}),[n,l,s,m]),te("div",{className:"adyen-checkout__boleto-input__field"},e.personalDetailsRequired&&te("div",{className:"adyen-checkout__fieldset adyen-checkout__fieldset--address adyen-checkout__fieldset--personalDetails"},te("div",{className:"adyen-checkout__fieldset__title"},t.get("personalDetails")),te("div",{className:"adyen-checkout__fieldset__fields"},te(St,{label:t.get("firstName"),classNameModifiers:["firstName","col-50"],errorMessage:s.firstName},Ut("text",{name:"firstName",autocorrect:"off",spellcheck:!1,value:n.firstName,onInput:b("firstName"),onChange:v("firstName")})),te(St,{label:t.get("lastName"),classNameModifiers:["lastName","col-50"],errorMessage:s.lastName},Ut("text",{name:"lastName",autocorrect:"off",spellcheck:!1,value:n.lastName,onInput:b("lastName"),onChange:v("lastName")})),te(St,{label:""+t.get("boleto.socialSecurityNumber"),classNameModifiers:["socialSecurityNumber"],errorMessage:s.socialSecurityNumber,isValid:Boolean(l.socialSecurityNumber)},Ut("text",{name:"socialSecurityNumber",autocorrect:"off",spellcheck:!1,value:n.socialSecurityNumber,onInput:function(e){var t,a,r,o="socialSecurityNumber",d=is(e.target.value),p=os.validate(o,"input")(d);i(D(D({},n),((t={})[o]=d,t))),u(D(D({},l),((a={})[o]=p,a))),c(D(D({},s),((r={})[o]=!1,r)))},maxLength:18,onChange:v("socialSecurityNumber")})))),e.billingAddressRequired&&te(fa,{label:"billingAddress",data:D(D({},n.billingAddress),{country:"BR"}),onChange:function(e){i(D(D({},n),{billingAddress:e.data})),u(D(D({},l),{billingAddress:e.isValid}))},requiredFields:["street","houseNumberOrName","postalCode","city","stateOrProvince"],ref:a}),e.showEmailAddress&&te(rs,{value:n.shopperEmail,errors:s.shopperEmail,onToggle:function(){return h(!m)},onInput:b("shopperEmail"),onChange:v("shopperEmail")}),e.showPayButton&&e.payButton({status:k,label:t.get("boletobancario.btnLabel"),classNameModifiers:f}))}ss.defaultProps={data:{},showEmailAddress:!0,personalDetailsRequired:!0,billingAddressRequired:!0};var cs=ss,ds=(a(128),function(e){var t=nt(),a=t.i18n,r=t.loadingContext,n=e.reference,i=e.expiresAt,o=e.totalAmount,s=e.paymentMethodType,c=e.downloadUrl,d=n.replace(/[^\d]/g,"").replace(/^(\d{4})(\d{5})\d{1}(\d{10})\d{1}(\d{10})\d{1}(\d{15})$/,"$1$5$2$3$4");return te(Ni,{reference:n,paymentMethodType:"boletobancario",barcode:r+"barcode.shtml?data="+d+"&barcodeType=BT_Int2of5A&fileType=png",introduction:a.get("voucher.introduction"),imageUrl:Me({loadingContext:r})(s),amount:o&&a.amount(o.value,o.currency),voucherDetails:[{label:a.get("voucher.expirationDate"),value:a.date(i)}],downloadUrl:c,copyBtn:!0})}),ls=function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.handleRef=function(e){t.componentRef=e},t}return S(t,e),Object.defineProperty(t.prototype,"isValid",{get:function(){return!!this.state.isValid},enumerable:!1,configurable:!0}),t.prototype.formatData=function(){var e=this.state.data,a=void 0===e?{}:e,r=a.billingAddress,n=a.shopperEmail,i=a.firstName,o=a.lastName,s=a.socialSecurityNumber,c=void 0===s?"":s;return D(D(D(D({paymentMethod:{type:this.props.type||t.type}},r&&{billingAddress:r}),n&&{shopperEmail:n}),i&&o&&{shopperName:{firstName:i,lastName:o}}),c&&{socialSecurityNumber:ns(c)})},t.prototype.render=function(){return te(ka,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},this.props.reference?te(ds,D({ref:this.handleRef,icon:this.icon},this.props)):te(cs,D({ref:this.handleRef},this.props,{onChange:this.setState,onSubmit:this.submit,payButton:this.payButton})))},t.type="boletobancario",t}(ct),us=(a(129),function(e){var t=nt(),a=t.i18n,r=t.loadingContext,n=e.alternativeReference,i=e.reference,o=e.expiresAt,s=e.merchantReference,c=e.totalAmount,d=e.paymentMethodType,l=e.downloadUrl,u=r+"barcode.shtml?data="+i+"&barcodeType=BT_Code128C&fileType=png",p=z(o?[{label:a.get("voucher.expirationDate"),value:a.date(o)}]:[],s?[{label:a.get("voucher.shopperReference"),value:s}]:[],n?[{label:a.get("voucher.alternativeReference"),value:n}]:[]);return te(Ni,{amount:c&&a.amount(c.value,c.currency),barcode:u,copyBtn:!0,downloadUrl:l,imageUrl:Me({loadingContext:r})(d),introduction:a.get("voucher.introduction"),paymentMethodType:"oxxo",reference:i,voucherDetails:p})}),ps=function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.handleRef=function(e){t.componentRef=e},t}return S(t,e),Object.defineProperty(t.prototype,"isValid",{get:function(){return!0},enumerable:!1,configurable:!0}),t.prototype.formatProps=function(e){return D(D({},e),{name:"Oxxo"})},t.prototype.formatData=function(){return{paymentMethod:{type:this.props.type||t.type}}},t.prototype.render=function(){return te(ka,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},this.props.reference?te(us,D({ref:this.handleRef},this.props)):this.payButton(D(D({},this.props),{classNameModifiers:["standalone"],label:this.props.i18n.get("continueTo")+" "+this.props.name,onClick:this.submit})))},t.type="oxxo",t}(ct),ms=function(e){var t=nt(),a=t.i18n,r=t.loadingContext,n=e.entity,i=e.reference,o=e.expiresAt,s=e.merchantReference,c=e.totalAmount,d=e.paymentMethodType,l=e.downloadUrl,u=z(n?[{label:a.get("voucher.entity"),value:n}]:[],o?[{label:a.get("voucher.expirationDate"),value:a.date(o)}]:[],s?[{label:a.get("voucher.shopperReference"),value:s}]:[]);return te(Ni,{amount:c&&a.amount(c.value,c.currency),barcode:null,copyBtn:!0,downloadUrl:l,imageUrl:Me({loadingContext:r})(d),introduction:a.get("voucher.introduction"),paymentMethodType:"multibanco",reference:i,voucherDetails:u})},hs=function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.handleRef=function(e){t.componentRef=e},t}return S(t,e),Object.defineProperty(t.prototype,"isValid",{get:function(){return!0},enumerable:!1,configurable:!0}),t.prototype.formatProps=function(e){return D(D({},e),{name:e.name||"Multibanco"})},t.prototype.formatData=function(){return{paymentMethod:{type:this.props.type||t.type}}},t.prototype.render=function(){var e=this;return this.props.reference?te(ka,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},te(ms,D({ref:this.handleRef},this.props))):this.props.showPayButton?te(ka,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},te(ii,{name:this.displayName,amount:this.props.amount,payButton:this.payButton,onSubmit:this.submit,ref:function(t){e.componentRef=t}})):null},t.type="multibanco",t.defaultProps={showPayButton:!0},t}(ct),fs=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return S(t,e),t.type="dotpay",t}(Za),ys=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return S(t,e),t.prototype.formatProps=function(t){return D(D({},e.prototype.formatProps.call(this,t)),{showImage:!1})},t.type="eps",t}(Za);a(130);function bs(e){var t=e.children,a=e.classNames,r=void 0===a?[]:a,n=e.type,i=void 0===n?"error":n,o=e.icon;return te("div",{className:je()("adyen-checkout__alert-message","adyen-checkout__alert-message--"+i,r)},o&&te(xt,{className:"adyen-checkout__alert-message__icon",type:o}),t)}a(131);var vs=function(e){e.brand;var t=e.amount,a=e.balance,r=e.transactionLimit,n=A(e,["brand","amount","balance","transactionLimit"]),i=nt().i18n,o=t.value>(null===r||void 0===r?void 0:r.value)?r:t,s=(null===a||void 0===a?void 0:a.value)-(null===o||void 0===o?void 0:o.value);return te("div",{className:"adyen-checkout__giftcard-result"},te("ul",{className:"adyen-checkout__giftcard-result__balance"},te("li",{className:"adyen-checkout__giftcard-result__balance__item"},te("span",{className:"adyen-checkout__giftcard-result__balance__title"},i.get("giftcardBalance")),te("span",{className:"adyen-checkout__giftcard-result__balance__value adyen-checkout__giftcard-result__balance__value--amount"},i.amount(a.value,a.currency))),r&&te("li",{className:"adyen-checkout__giftcard-result__balance__item"},te("span",{className:"adyen-checkout__giftcard-result__balance__title adyen-checkout__giftcard-result__balance__title--transactionLimit"},i.get("giftcardTransactionLimit",{values:{amount:i.amount(r.value,r.currency)}})))),this.props.showPayButton&&this.props.payButton({amount:o,status:n.status,onClick:n.onSubmit}),te("p",{className:"adyen-checkout__giftcard-result__remaining-balance"},i.get("partialPayment.remainingBalance",{values:{amount:i.amount(s,a.currency)}})))},gs=function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.state={status:"ready",data:{},balance:null,transactionLimit:null,focusedElement:!1,isValid:!1},t.onChange=function(e){t.props.onChange({data:e.data,isValid:e.isSfpValid})},t.showValidation=function(){t.sfp.showValidation()},t.handleFocus=function(e){t.setState({focusedElement:e.currentFocusObject}),!0===e.focus?t.props.onFocus(e):t.props.onBlur(e)},t.setBalance=function(e){var a=e.balance,r=e.transactionLimit;t.setState({balance:a,transactionLimit:r})},t}return S(t,e),t.prototype.setStatus=function(e){this.setState({status:e})},t.prototype.render=function(e,t){var a,r=this,n=t.focusedElement,i=t.balance,o=t.transactionLimit,s=nt().i18n,c=(null===o||void 0===o?void 0:o.value)<(null===i||void 0===i?void 0:i.value)?o:i,d=(null===c||void 0===c?void 0:c.value)>=(null===(a=this.props.amount)||void 0===a?void 0:a.value);if(c&&d)return te(vs,D({balance:i,transactionLimit:o,onSubmit:e.onSubmit},e));var l=function(e){if(e.errors.encryptedCardNumber)return s.get("error.va.sf-cc-num.01");switch(r.state.status){case"no-balance":return s.get("error.giftcard.no-balance");case"card-error":return s.get("error.giftcard.card-error");case"currency-error":return s.get("error.giftcard.currency-error");default:return null}};return te("div",{className:"adyen-checkout__giftcard"},"error"===this.state.status&&te(bs,{icon:"cross"},s.get("error.message.unknown")),te(Vn,D({},this.props,{ref:function(e){r.sfp=e},onChange:this.onChange,onFocus:this.handleFocus,type:"giftcard",render:function(t,a){var r=t.setRootNode,i=t.setFocusOn;return te("div",{ref:r,className:"adyen-checkout__field-wrapper"},te(St,{label:s.get("creditCard.numberField.title"),classNameModifiers:z(["number"],e.pinRequired?["70"]:["100"]),errorMessage:l(a),focused:"encryptedCardNumber"===n,onFocusField:function(){return i("encryptedCardNumber")}},te("span",{"data-cse":"encryptedCardNumber","data-info":'{"length":"15-22", "maskInterval":4}',className:je()({"adyen-checkout__input":!0,"adyen-checkout__input--large":!0,"adyen-checkout__card__cardNumber__input":!0,"adyen-checkout__input--error":l(a),"adyen-checkout__input--focus":"encryptedCardNumber"===n})})),e.pinRequired&&te(St,{label:s.get("creditCard.pin.title"),classNameModifiers:["pin","30"],errorMessage:a.errors.encryptedSecurityCode&&s.get(a.errors.encryptedSecurityCode),focused:"encryptedSecurityCode"===n,onFocusField:function(){return i("encryptedSecurityCode")}},te("span",{"data-cse":"encryptedSecurityCode","data-info":'{"length":"3-10", "maskInterval": 0}',className:je()({"adyen-checkout__input":!0,"adyen-checkout__input--large":!0,"adyen-checkout__card__cvc__input":!0,"adyen-checkout__input--error":a.errors.encryptedCardNumber,"adyen-checkout__input--focus":"encryptedSecurityCode"===n})})))}})),this.props.showPayButton&&this.props.payButton({status:this.state.status,onClick:this.props.onBalanceCheck,label:s.get("applyGiftcard")}))},t.defaultProps={pinRequired:!0,onChange:function(){},onFocus:function(){},onBlur:function(){}},t}(ne),ks=function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.onBalanceCheck=function(){return t.props.onBalanceCheck?t.isValid?new Promise((function(e,a){t.setStatus("loading"),t.props.onBalanceCheck(e,a,t.formatData())})).then((function(e){var a,r=e.balance,n=e.transactionLimit;if(!r)throw new Error("card-error");if((null===r||void 0===r?void 0:r.currency)!==(null===(a=t.props.amount)||void 0===a?void 0:a.currency))throw new Error("currency-error");if((null===r||void 0===r?void 0:r.value)<=0)throw new Error("no-balance");if(t.componentRef.setBalance({balance:r,transactionLimit:n}),t.props.amount.value>r.value||t.props.amount.value>n.value)return t.props.order?t.submit():t.onOrderRequest(t.data)})).catch((function(e){t.setStatus((null===e||void 0===e?void 0:e.message)||"error"),t.props.onError&&t.props.onError(e)})):(t.showValidation(),!1):t.submit()},t.onOrderRequest=function(e){return new Promise((function(a,r){t.props.onOrderRequest(a,r,e)})).then((function(e){t.setState({order:{orderData:e.orderData,pspReference:e.pspReference}}),t.submit()}))},t.payButton=function(e){return te(ot,D({},e))},t}return S(t,e),t.prototype.formatProps=function(e){return e},t.prototype.formatData=function(){var e,t;return{paymentMethod:{type:this.constructor.type,brand:this.props.brand,encryptedCardNumber:null===(e=this.state.data)||void 0===e?void 0:e.encryptedCardNumber,encryptedSecurityCode:null===(t=this.state.data)||void 0===t?void 0:t.encryptedSecurityCode}}},Object.defineProperty(t.prototype,"isValid",{get:function(){return!!this.state.isValid},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"icon",{get:function(){return Me({loadingContext:this.props.loadingContext})(this.props.brand)},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"displayName",{get:function(){return this.props.name},enumerable:!1,configurable:!0}),t.prototype.render=function(){var e=this;return te(ka,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},te(gs,D({ref:function(t){e.componentRef=t}},this.props,{onChange:this.setState,onBalanceCheck:this.onBalanceCheck,onSubmit:this.submit,payButton:this.payButton})))},t.type="giftcard",t}(ct),Cs=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return S(t,e),t.type="vipps",t.defaultProps={type:t.type,showPayButton:!0,name:"Vipps"},t}(oi),_s=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return S(t,e),t.prototype.formatProps=function(t){return D(D({},e.prototype.formatProps.call(this,t)),{showImage:!1})},t.type="payu_IN_cashcard",t}(Za),Ns=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return S(t,e),t.prototype.formatProps=function(t){return D(D({},e.prototype.formatProps.call(this,t)),{showImage:!1})},t.type="payu_IN_nb",t}(Za),ws=["AT","CH","DE","NL"],Ps=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return S(t,e),t.prototype.formatProps=function(t){return D(D({},e.prototype.formatProps.call(this,t)),{allowedCountries:t.countryCode?[t.countryCode]:ws})},t.type="ratepay",t}(Ca),Fs=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return S(t,e),t.prototype.formatProps=function(t){return D({shouldRedirectOnMobile:!0,delay:2e3,countdownTime:15,instructions:"swish.pendingMessage"},e.prototype.formatProps.call(this,t))},t.type="swish",t}(Ko),xs={isDropin:!0,onReady:function(){},onComplete:function(){},onCancel:function(){},onError:function(){},onSelect:function(){},onDisableStoredPaymentMethod:null,onChange:function(){},onSubmit:function(){},onAdditionalDetails:function(){},amount:{},installmentOptions:{},paymentMethodsConfiguration:{},openFirstPaymentMethod:!0,openFirstStoredPaymentMethod:!0,showStoredPaymentMethods:!0,showPaymentMethods:!0,showRemoveStoredPaymentMethodButton:!1,showPayButton:!0},Ss=function(e){var t=e.paymentMethodComponent,a=e.isLoaded;return t&&a?te("div",{className:"adyen-checkout__payment-method__details__content"},t):null},Ds=a(3),As=a.n(Ds),Bs=function(e){var t=e.src,a=e.name,r=e.disabled,n=void 0!==r&&r;return te("span",{className:je()("adyen-checkout__payment-method__image__wrapper",As.a["adyen-checkout__payment-method__image__wrapper"],{"adyen-checkout__payment-method__image__wrapper--disabled":!!n}),"aria-hidden":"true"},te($n,{className:"adyen-checkout__payment-method__image "+As.a["adyen-checkout__payment-method__image"],src:t,alt:a,"aria-label":a,focusable:"false"}))},Ts=(a(132),function(e){var t=e.id,a=e.open,r=e.onDisable,n=e.onCancel,i=nt().i18n;return te("div",{id:t,"aria-hidden":!a,className:je()({"adyen-checkout__payment-method__disable-confirmation":!0,"adyen-checkout__payment-method__disable-confirmation--open":a})},te("div",{className:"adyen-checkout__payment-method__disable-confirmation__content"},i.get("storedPaymentMethod.disable.confirmation"),te("div",{className:"adyen-checkout__payment-method__disable-confirmation__buttons"},te("button",{className:je()("adyen-checkout__button","adyen-checkout__payment-method__disable-confirmation__button","adyen-checkout__payment-method__disable-confirmation__button--remove"),disabled:!a,onClick:r},i.get("storedPaymentMethod.disable.confirmButton")),te("button",{className:je()("adyen-checkout__button","adyen-checkout__payment-method__disable-confirmation__button","adyen-checkout__payment-method__disable-confirmation__button--cancel"),disabled:!a,onClick:n},i.get("storedPaymentMethod.disable.cancelButton")))))}),zs=(a(133),function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.state={showDisableStoredPaymentMethodConfirmation:!1},t.isMouseDown=!1,t.onFocus=function(){t.isMouseDown||t.props.onSelect()},t.onMouseDown=function(){t.isMouseDown=!0},t.onMouseUp=function(){t.isMouseDown=!1},t.toggleDisableConfirmation=function(){t.setState({showDisableStoredPaymentMethodConfirmation:!t.state.showDisableStoredPaymentMethodConfirmation})},t.onDisableStoredPaymentMethod=function(){t.props.onDisableStoredPaymentMethod(t.props.paymentMethod),t.toggleDisableConfirmation()},t}return S(t,e),t.prototype.componentDidMount=function(){var e=this;this.props.paymentMethod.eventEmitter.on("brand",(function(t){e.setState({activeBrand:t.brand})}))},t.prototype.componentWillUnmount=function(){var e=this;this.props.paymentMethod.eventEmitter.off("brand",(function(t){e.setState({activeBrand:t.brand})}))},t.prototype.render=function(e,t){var a,r,n=e.paymentMethod,i=e.isSelected,o=e.isDisabling,s=e.isLoaded,c=e.isLoading,d=e.onSelect,l=e.standalone,u=t.activeBrand,p=void 0===u?null:u,m=nt().i18n;if(!n)return null;var h=je()(((a={"adyen-checkout__payment-method":!0})[As.a["adyen-checkout__payment-method"]]=!0,a["adyen-checkout__payment-method--"+n.props.type]=!0,a["adyen-checkout__payment-method--"+(null!==(r=n.props.fundingSource)&&void 0!==r?r:"credit")]=!0,a["adyen-checkout__payment-method--selected"]=i,a[As.a["adyen-checkout__payment-method--selected"]]=i,a["adyen-checkout__payment-method--loading"]=c,a["adyen-checkout__payment-method--disabling"]=o,a["adyen-checkout__payment-method--confirming"]=this.state.showDisableStoredPaymentMethodConfirmation,a["adyen-checkout__payment-method--standalone"]=l,a[As.a["adyen-checkout__payment-method--loading"]]=c,a[n.props.id]=!0,a[this.props.className]=!0,a)),f=this.props.showRemovePaymentMethodButton&&n.props.oneClick&&i,y="remove-"+n.props.id,b=!n.props.oneClick&&n.brands&&n.brands.length>0;return te("li",{key:n.props.id,className:h,onFocus:this.onFocus,onClick:d,onMouseDown:this.onMouseDown,onMouseUp:this.onMouseUp,tabIndex:c?-1:0},te("div",{className:"adyen-checkout__payment-method__header"},te("div",{className:"adyen-checkout__payment-method__header__title"},te("span",{className:je()({"adyen-checkout__payment-method__radio":!0,"adyen-checkout__payment-method__radio--selected":i}),"aria-hidden":"true"}),te(Bs,{name:n.props.name,src:n.icon}),te("span",{className:je()({"adyen-checkout__payment-method__name":!0,"adyen-checkout__payment-method__name--selected":i}),"aria-hidden":"true"},n.displayName)),f&&te("button",{type:"button",className:"adyen-checkout__button adyen-checkout__button--inline adyen-checkout__button--link",onClick:this.toggleDisableConfirmation,"aria-expanded":this.state.showDisableStoredPaymentMethodConfirmation,"aria-controls":y},m.get("storedPaymentMethod.disable.button")),b&&te("span",{className:"adyen-checkout__payment-method__brands"},n.brands.map((function(e){return te(Bs,{key:e.name,name:e.name,disabled:p&&e.name!==p,src:e.icon})})))),te("div",{className:"adyen-checkout__payment-method__details "+As.a["adyen-checkout__payment-method__details"]},f&&te(Ts,{id:y,open:this.state.showDisableStoredPaymentMethodConfirmation,onDisable:this.onDisableStoredPaymentMethod,onCancel:this.toggleDisableConfirmation}),te(Ss,{paymentMethodComponent:n.render(),isLoaded:s})))},t.defaultProps={paymentMethod:null,isSelected:!1,isLoaded:!1,isLoading:!1,showDisableStoredPaymentMethodConfirmation:!1,onSelect:function(){}},t}(ne)),Ms=(a(134),function(e){var t,a=e.order,r=e.orderStatus,n=e.onOrderCancel,i=nt(),o=i.loadingContext,s=i.i18n;return te("div",null,te("ul",{className:"adyen-checkout__order-payment-methods-list"},null===(t=null===r||void 0===r?void 0:r.paymentMethods)||void 0===t?void 0:t.map((function(e,t){return te("li",{key:e.type+"-"+t,className:"adyen-checkout__order-payment-method"},te("div",{className:"adyen-checkout__order-payment-method__header"},te("div",{className:"adyen-checkout__payment-method__header__title"},te(Bs,{name:e.type,src:Me({loadingContext:o})(e.type)}),"\u2022\u2022\u2022\u2022 ",e.lastFour),n&&te("button",{type:"button",className:"adyen-checkout__button adyen-checkout__button--inline adyen-checkout__button--link",onClick:function(){n({order:a})}},s.get("storedPaymentMethod.disable.button"))),te("div",{className:"adyen-checkout__order-payment-method__details"},te("div",{className:"adyen-checkout__order-payment-method__deducted-amount"},te("div",{className:"adyen-checkout__order-payment-method__deducted-amount__label"},s.get("deductedBalance")),te("div",{className:"adyen-checkout__order-payment-method__deducted-amount__value"},s.amount(e.amount.value,e.amount.currency)))))}))),r.remainingAmount&&te("div",{className:"adyen-checkout__order-remaining-amount"},s.get("partialPayment.warning")," ",te("strong",null,s.amount(r.remainingAmount.value,r.remainingAmount.currency))))}),Is=function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.onSelect=function(e){return function(){return t.props.onSelect(e)}},t}return S(t,e),t.prototype.componentDidMount=function(){if(this.props.paymentMethods[0]){var e=this.props.paymentMethods[0];(this.props.openFirstStoredPaymentMethod&&!0===we(e,"props.oneClick")||this.props.openFirstPaymentMethod)&&this.onSelect(e)()}},t.prototype.render=function(e){var t,a=this,r=e.paymentMethods,n=e.activePaymentMethod,i=e.cachedPaymentMethods,o=e.isLoading,s=je()(((t={})[As.a["adyen-checkout__payment-methods-list"]]=!0,t["adyen-checkout__payment-methods-list"]=!0,t["adyen-checkout__payment-methods-list--loading"]=o,t));return te(re,null,this.props.orderStatus&&te(Ms,{order:this.props.order,orderStatus:this.props.orderStatus,onOrderCancel:this.props.onOrderCancel}),te("ul",{className:s},r.map((function(e,t,s){var c=n&&n.props.id===e.props.id,d=e.props.id in i,l=n&&s[t+1]&&n.props.id===s[t+1].props.id;return te(zs,{className:je()({"adyen-checkout__payment-method--next-selected":l}),standalone:1===r.length,paymentMethod:e,isSelected:c,isDisabling:c&&a.props.isDisabling,isLoaded:d,isLoading:o,onSelect:a.onSelect(e),key:e.props.id,showRemovePaymentMethodButton:a.props.showRemovePaymentMethodButton,onDisableStoredPaymentMethod:a.props.onDisableStoredPaymentMethod})}))))},t.defaultProps={paymentMethods:[],activePaymentMethod:null,cachedPaymentMethods:{},orderStatus:null,onSelect:function(){},onDisableStoredPaymentMethod:function(){},isDisabling:!1,isLoading:!1},t}(ne),js=["amazonpay","androidpay","samsungpay"],Es=function(e){var t=e.type;return!js.includes(t)},Os=function(e){return!!e},Rs=function(e){if(e.isAvailable){var t=new Promise((function(e,t){return setTimeout(t,5e3)}));return Promise.race([e.isAvailable(),t])}return Promise.resolve(!!e)},Vs=function(e,t,a){void 0===e&&(e=[]),void 0===a&&(a={});var r=e.filter(Es).map((function(e){var r=D(D(D(D({},e),t),Wc(e.type,a)),{isDropin:!0}),n=Yc(e.type,r);return n||e.details||(n=Yc("redirect",r)),n})).filter(Os),n=r.map(Rs).map((function(e){return e.catch((function(e){return e}))}));return Promise.all(n).then((function(e){return r.filter((function(t,a){return!0===e[a]}))}))},Ls=function(e,t,a){return void 0===e&&(e=[]),void 0===a&&(a={}),Vs(e,D(D({},t),{oneClick:!0}),a)};function Us(e){return{amount:e.amount,countryCode:e.countryCode,elementRef:e.elementRef,environment:e.environment,i18n:e.i18n,installmentOptions:e.installmentOptions,loadingContext:e.loadingContext,modules:e.modules,onAdditionalDetails:e.onAdditionalDetails,onCancel:e.onCancel,onChange:e.onChange,onError:e.onError,order:e.order,onBalanceCheck:e.onBalanceCheck,onOrderRequest:e.onOrderRequest,onSubmit:e.onSubmit,originKey:e.originKey,clientKey:e.clientKey,showPayButton:e.showPayButton}}var Ks=function(e){var t=e.message,a=nt(),r=a.i18n,n=a.loadingContext;return te("div",{className:"adyen-checkout__status adyen-checkout__status--success"},te($n,{height:"88",className:"adyen-checkout__status__icon",src:ze({loadingContext:n,imageFolder:"components/"})("success"),alt:r.get(t||"creditCard.success")}),te("span",{className:"adyen-checkout__status__text"},r.get(t||"creditCard.success")))},qs=function(e){var t=e.message,a=nt(),r=a.loadingContext,n=a.i18n;return te("div",{className:"adyen-checkout__status adyen-checkout__status--error"},te($n,{className:"adyen-checkout__status__icon",src:ze({loadingContext:r,imageFolder:"components/"})("error"),alt:n.get(t||"error.message.unknown"),height:"88"}),te("span",{className:"adyen-checkout__status__text"},n.get(t||"error.message.unknown")))},Hs=(a(135),{Success:Ks,Error:qs});a(136);var Gs=function(e,t){return ua({path:"/v1/order/status?token="+e.clientKey,loadingContext:e.loadingContext,method:"POST"},{orderData:t.orderData})},Ys=function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.state={elements:[],orderStatus:null,isDisabling:!1,status:{type:"loading"},activePaymentMethod:null,cachedPaymentMethods:{}},t.prepareDropinData=function(){var e=t.props,a=e.paymentMethodsConfiguration,r=e.paymentMethods,n=e.storedPaymentMethods,i=e.order,o=e.clientKey,s=e.loadingContext,c=Us(t.props),d=t.props.showStoredPaymentMethods?Ls(n,c,a):[],l=t.props.showPaymentMethods?Vs(r,c,a):[],u=i?Gs({clientKey:o,loadingContext:s},i):null;Promise.all([d,l,u]).then((function(e){var a=e[0],r=e[1],n=e[2];t.setState({elements:z(a,r),orderStatus:n}),t.setStatus({type:"ready"}),t.props.modules.analytics&&t.props.modules.analytics.send({containerWidth:t.base&&t.base.offsetWidth,paymentMethods:r.map((function(e){return e.props.type})),component:"dropin",flavor:"dropin"})}))},t.setStatus=function(e){t.setState({status:e})},t.setActivePaymentMethod=function(e){t.setState((function(t){var a;return{activePaymentMethod:e,cachedPaymentMethods:D(D({},t.cachedPaymentMethods),(a={},a[e.props.id]=!0,a))}}))},t.handleOnSelectPaymentMethod=function(e){var a=t.state.activePaymentMethod;t.setActivePaymentMethod(e),(a&&a.props.id!==e.props.id||!a)&&t.props.onSelect(e)},t.handleDisableStoredPaymentMethod=function(e){t.setState({isDisabling:!0}),new Promise((function(a,r){return t.props.onDisableStoredPaymentMethod(e.props.storedPaymentMethodId,a,r)})).then((function(){t.setState((function(t){return{elements:t.elements.filter((function(t){return t.props.id!==e.props.id}))}})),t.setState({isDisabling:!1})})).catch((function(){t.setState({isDisabling:!1})}))},t}return S(t,e),t.prototype.componentDidMount=function(){this.prepareDropinData()},t.prototype.componentDidUpdate=function(e,t){t.status.type!==this.state.status.type&&this.state.activePaymentMethod&&this.state.activePaymentMethod.setStatus(this.state.status.type),"ready"===this.state.status.type&&"ready"!==t.status.type&&this.props.onReady&&this.props.onReady()},t.prototype.closeActivePaymentMethod=function(){this.setState({activePaymentMethod:null})},t.prototype.render=function(e,t){var a=t.elements,r=t.status,n=t.activePaymentMethod,i=t.cachedPaymentMethods,o="loading"===r.type,s="redirect"===r.type;switch(r.type){case"success":return te(Hs.Success,{message:we(r,"props.message")||null});case"error":return te(Hs.Error,{message:we(r,"props.message")||null});case"custom":return r.props.component.render();default:return te("div",{className:"adyen-checkout__dropin adyen-checkout__dropin--"+r.type},s&&r.props.component&&r.props.component.render(),o&&r.props&&r.props.component&&r.props.component.render(),a&&!!a.length&&te(Is,{isLoading:o||s,isDisabling:this.state.isDisabling,paymentMethods:a,activePaymentMethod:n,cachedPaymentMethods:i,order:this.props.order,orderStatus:this.state.orderStatus,onOrderCancel:this.props.onOrderCancel,onSelect:this.handleOnSelectPaymentMethod,openFirstPaymentMethod:this.props.openFirstPaymentMethod,openFirstStoredPaymentMethod:this.props.openFirstStoredPaymentMethod,onDisableStoredPaymentMethod:this.handleDisableStoredPaymentMethod,showRemovePaymentMethodButton:this.props.showRemovePaymentMethodButton}))}},t}(ne),Ws=function(e){function t(t){var a=e.call(this,t)||this;return a.dropinRef=null,a.handleSubmit=function(){var e=a.activePaymentMethod,t=e.data,r=e.isValid;return r?a.props.onSubmit({data:t,isValid:r},a):(a.showValidation(),!1)},a.submit=a.submit.bind(a),a}return S(t,e),Object.defineProperty(t.prototype,"isValid",{get:function(){return!!this.dropinRef&&!!this.dropinRef.state.activePaymentMethod&&!!this.dropinRef.state.activePaymentMethod.isValid},enumerable:!1,configurable:!0}),t.prototype.showValidation=function(){return this.dropinRef.state.activePaymentMethod&&this.dropinRef.state.activePaymentMethod.showValidation(),this},t.prototype.setStatus=function(e,t){return void 0===t&&(t={}),this.dropinRef.setStatus({type:e,props:t}),this},Object.defineProperty(t.prototype,"activePaymentMethod",{get:function(){return this.dropinRef.state||this.dropinRef.state.activePaymentMethod?this.dropinRef.state.activePaymentMethod:null},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"data",{get:function(){return this.activePaymentMethod?this.dropinRef.state.activePaymentMethod.data:null},enumerable:!1,configurable:!0}),t.prototype.submit=function(){var e=this;if(!this.activePaymentMethod)throw new Error("No active payment method.");this.activePaymentMethod.startPayment().then(this.handleSubmit).catch((function(t){return e.props.onError(t)}))},t.prototype.handleAction=function(e){var t,a=this;if(!e||!e.type)throw new Error("Invalid Action");if(null===(t=this.activePaymentMethod)||void 0===t?void 0:t.updateWithAction)return this.activePaymentMethod.updateWithAction(e);var r=e.paymentMethodType||"scheme",n=Wc(r,this.props.paymentMethodsConfiguration),i=this.props.createFromAction(e,D(D(D({isDropin:!0,elementRef:this.elementRef},this.props),n),{onAdditionalDetails:function(e){return a.props.onAdditionalDetails(e,a)}}));return i?this.setStatus(i.props.statusType,{component:i}):null},t.prototype.closeActivePaymentMethod=function(){this.dropinRef.closeActivePaymentMethod()},t.prototype.render=function(){var e=this;return te(ka,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},te(Ys,D({},this.props,{onChange:this.setState,onSubmit:this.handleSubmit,elementRef:this.elementRef,ref:function(t){e.dropinRef=t}})))},t.type="dropin",t.defaultProps=xs,t}(ct),Js=a(10),Zs=a.n(Js),Qs=function(e){var t,a=e.id,r=e.dataInfo,n=e.className,i=void 0===n?"":n,o=e.label,s=e.focused,c=e.filled,d=e.errorMessage,l=void 0===d?"":d,u=e.isValid,p=void 0!==u&&u,m=e.onFocusField,h="encrypted"+(a.charAt(0).toUpperCase()+a.slice(1));return te(St,{label:o,focused:s,filled:c,classNameModifiers:[a],onFocusField:function(){return m(h)},errorMessage:l,isValid:p,className:i},te("span",{"data-cse":h,"data-info":r,className:je()((t={"adyen-checkout__input":!0,"adyen-checkout__input--large":!0},t[Zs.a["adyen-checkout__input"]]=!0,t["adyen-checkout__input--error"]=l.length,t["adyen-checkout__input--focus"]=s,t["adyen-checkout__input--valid"]=p,t))}))},$s=function(e){var t=e.focusedElement,a=e.onFocusField,r=e.errors,n=e.valid,i=nt().i18n;return te("div",{className:"adyen-checkout__ach-sf__form adyen-checkout__field-wrapper"},te(Qs,{id:"bankAccountNumber",focused:"encryptedBankAccountNumber"===t,isValid:!!n.encryptedBankAccountNumber,label:i.get("ach.accountNumberField.title"),onFocusField:a,filled:!!r.encryptedBankAccountNumber||!!n.encryptedBankAccountNumber,errorMessage:!!r.encryptedBankAccountNumber&&i.get("ach.accountNumberField.invalid"),dataInfo:'{"length":"4-17", "maskInterval": 4}',className:"adyen-checkout__field--50"}),te(Qs,{id:"bankLocationId",focused:"encryptedBankLocationId"===t,isValid:!!n.encryptedBankLocationId,label:i.get("ach.accountLocationField.title"),onFocusField:a,filled:!!r.encryptedBankLocationId||!!n.encryptedBankLocationId,errorMessage:!!r.encryptedBankLocationId&&i.get("ach.accountLocationField.invalid"),dataInfo:'{"length":9}',className:"adyen-checkout__field--50"}))},Xs={base:{caretColor:"#0066FF"}};a(137);function ec(e,t){return void 0===t&&(t=!1),!t||!!e&&"string"===typeof e&&e.trim().length>0}function tc(e){var t=this,a=nt().i18n,r=e.hasHolderName&&(e.holderName||e.data.holderName),n=Ge({}),i=n[0],o=n[1],s=Ge(D({},e.holderNameRequired&&{holderName:r})),c=s[0],d=s[1],l=Ge(D({},e.hasHolderName&&{holderName:e.holderName||e.data.holderName})),u=l[0],p=l[1],m=Ge(e.billingAddressRequired?e.data.billingAddress:null),h=m[0],f=m[1],y=Ge(!1),b=y[0],v=y[1],g=Ge(""),k=g[0],C=g[1],_=function(e){f(D(D({},h),e.data)),d(D(D({},c),{billingAddress:e.isValid}))},N=function(t){var a=t.target.value;p(D(D({},u),{holderName:a})),o(D(D({},i),{holderName:!!e.holderNameRequired&&!ec(a)})),d(D(D({},c),{holderName:!e.holderNameRequired||ec(a,e.holderNameRequired)}))},w=Je(null),P=Je(null),F=Ge("ready"),x=F[0],S=F[1];return this.setStatus=function(e){S(e)},this.showValidation=function(){w.current.showValidation(),e.holderNameRequired&&!c.holderName&&o(D(D({},i),{holderName:!0})),P.current&&P.current.showValidation()},Ye((function(){return t.setFocusOn=w.current.setFocusOn,t.updateStyles=w.current.updateStyles,function(){w.current.destroy()}}),[]),Ye((function(){var t=ec(u.holderName,e.holderNameRequired),a=b,r=!e.billingAddressRequired||Boolean(c.billingAddress),n=a&&t&&r;e.onChange({data:u,isValid:n,billingAddress:h})}),[u,c,i]),te("div",{className:"adyen-checkout__ach"},te(Vn,D({ref:w},e,{styles:D(D({},Xs),e.styles),onChange:function(t){var a=t,r=a.autoCompleteName?a.autoCompleteName:u.holderName;p(D(D(D({},u),a.data),{holderName:r})),o(D(D({},i),a.errors)),d(D(D(D({},c),a.valid),{holderName:!e.holderNameRequired||ec(r,e.holderNameRequired)})),v(a.isSfpValid)},onFocus:function(t){var a=!0===t.focus;C(t.currentFocusObject),a?e.onFocus(t):e.onBlur(t)},render:function(t,r){var n=t.setRootNode,o=t.setFocusOn;return te("div",{ref:n,className:"adyen-checkout__ach-input "+Zs.a["sf-input__wrapper"]},te(fr,{status:r.status},te("div",{className:je()(["adyen-checkout__fieldset","adyen-checkout__fieldset--ach"])},te("div",{className:"adyen-checkout__fieldset__title"},a.get("ach.bankAccount")),e.hasHolderName&&te(St,{label:a.get("ach.accountHolderNameField.title"),className:"adyen-checkout__pm__holderName",errorMessage:!!i.holderName&&a.get("ach.accountHolderNameField.invalid"),isValid:!!c.holderName},Ut("text",{className:"adyen-checkout__pm__holderName__input "+Zs.a["adyen-checkout__input"],placeholder:e.placeholders.holderName||a.get("ach.accountHolderNameField.placeholder"),value:u.holderName,required:e.holderNameRequired,onInput:N})),te($s,{focusedElement:k,onFocusField:o,errors:r.errors,valid:r.valid})),e.billingAddressRequired&&te(fa,{label:"billingAddress",data:h,onChange:_,allowedCountries:e.billingAddressAllowedCountries,requiredFields:e.billingAddressRequiredFields,ref:P})))}})),e.showPayButton&&e.payButton({status:x,label:a.get("confirmPurchase")}))}tc.defaultProps={details:[],type:"ach",hasHolderName:!0,holderNameRequired:!0,billingAddressRequired:!0,billingAddressAllowedCountries:["US","PR"],onLoad:function(){},onConfigSuccess:function(){},onAllValid:function(){},onFieldValid:function(){},onBrand:function(){},onError:function(){},onBinValue:function(){},onBlur:function(){},onFocus:function(){},onChange:function(){},originKey:null,holderName:"",data:{holderName:"",billingAddress:{}},styles:{},placeholders:{},ariaLabels:{}};var ac=tc,rc=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return S(t,e),t.prototype.formatProps=function(e){var t;return D(D({},e),{holderNameRequired:null!==(t=e.hasHolderName)&&void 0!==t?t:e.holderNameRequired})},t.prototype.formatData=function(){var e,a=D(D({type:t.type},this.state.data),{ownerName:null===(e=this.state.data)||void 0===e?void 0:e.holderName});return delete a.holderName,D({paymentMethod:a},this.state.billingAddress&&{billingAddress:this.state.billingAddress})},t.prototype.updateStyles=function(e){return this.componentRef&&this.componentRef.updateStyles&&this.componentRef.updateStyles(e),this},t.prototype.setFocusOn=function(e){return this.componentRef&&this.componentRef.setFocusOn&&this.componentRef.setFocusOn(e),this},Object.defineProperty(t.prototype,"isValid",{get:function(){return!!this.state.isValid},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"displayName",{get:function(){return this.props.name},enumerable:!1,configurable:!0}),t.prototype.render=function(){var e=this;return te(ka,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},te(ac,D({ref:function(t){e.componentRef=t}},this.props,{onChange:this.setState,onSubmit:this.submit,payButton:this.payButton})))},t.type="ach",t}(ct),nc=/^[+]*[0-9]{1,4}[\s/0-9]*$/,ic={input:{telephoneNumber:function(e){var t=e.replace(/[^0-9+\s]/g,"");return{isValid:nc.test(t)&&t&&t.length>=7,value:t,showError:!1}},default:function(e){return e&&e.length>0}},blur:{telephoneNumber:function(e){return{isValid:nc.test(e)&&e&&e.length>=7,value:e,showError:!0}},default:function(e){return e&&e.length>0}}};a(138);function oc(e){var t=nt().i18n,a=new qt(ic),r=Ge(e.data),n=r[0],i=r[1],o=Ge({}),s=o[0],c=o[1],d=Ge(D({},e.data.telephoneNumber&&{telephoneNumber:a.validate("telephoneNumber","input")(e.data.telephoneNumber).isValid})),l=d[0],u=d[1],p=Ge("ready"),m=p[0],h=p[1];this.setStatus=function(e){h(e)},this.showValidation=function(){var t=!a.validate("telephoneNumber","input")(e.data.telephoneNumber).isValid;c(D(D({},s),{telephoneNumber:t}))};var f=function(e,t){return function(e){var r=e.target.value,o=a.validate("telephoneNumber",t)(r),d=o.value,p=o.isValid,m=o.showError;i(D(D({},n),{telephoneNumber:d})),c(D(D({},s),{telephoneNumber:!p&&m})),u(D(D({},l),{telephoneNumber:p}))}};return Ye((function(){e.onChange({data:n,isValid:l.telephoneNumber})}),[n,l]),te("div",{className:"adyen-checkout__mb-way"},te(St,{errorMessage:!!s.telephoneNumber&&t.get("telephoneNumber.invalid"),label:t.get("telephoneNumber"),className:je()("adyen-checkout__input--phone-number"),isValid:l.telephoneNumber},Ut("tel",{value:n.telephoneNumber,className:"adyen-checkout__pm__phoneNumber__input",placeholder:e.placeholders.telephoneNumber,required:!0,autoCorrect:"off",onChange:f(0,"blur"),onInput:f(0,"input")})),e.showPayButton&&e.payButton({status:m,label:t.get("confirmPurchase")}))}oc.defaultProps={onChange:function(){}};var sc=oc,cc=2e3,dc=15,lc=6e4,uc=1e4,pc="mbway",mc="mbway.confirmPayment",hc="await.waitForConfirmation",fc=!1;a(139);function yc(e){var t=this,a=nt(),r=a.i18n,n=a.loadingContext,i=Ge(!1),o=i[0],s=i[1],c=Ge(!1),d=c[0],l=c[1],u=Ge(!0),p=u[0],m=u[1],h=Ge(e.delay),f=h[0],y=h[1],b=Ge(100),v=b[0],g=b[1],k=Ge(0),C=k[0],_=k[1],N=Ge(!1),w=N[0],P=N[1],F=Ge(null),x=F[0],S=F[1],B=function(){var a=e.paymentData,r=e.accessKey;Ro(a,r,n).then(Lo).catch((function(e){var a=e.message,r=A(e,["message"]);return{type:"network-error",props:D(D({},a&&{message:t.props.i18n.get(a)}),r)}})).then((function(a){switch(a.type){case"success":!function(a){s(!0);var r={data:{details:{payload:a.props.payload},paymentData:e.paymentData}};e.onComplete(r,t)}(a);break;case"error":!function(a){l(!0);var r={data:{details:{payload:a.props.payload},paymentData:e.paymentData}};e.onComplete(r,t)}(a);break;default:m(!1)}}))};Ye((function(){var a=e.shouldRedirectOnMobile,r=e.url,n=window.matchMedia("(max-width: 768px)").matches&&/Android|iPhone|iPod/.test(navigator.userAgent);return a&&r&&n?t.redirectToApp(r,B):B(),function(){clearTimeout(x)}}),[]),Ye((function(){if(d)return clearTimeout(x);if(o)return clearTimeout(x);if(!p){S(setTimeout((function(){B();var t=C+f;_(t),t>=e.throttleTime&&!w&&(y(e.throttleInterval),P(!0))}),f))}}),[p,C,d,o]);var T=function(e,t){return te("div",{className:"adyen-checkout__await adyen-checkout__await--result"},te("img",{className:"adyen-checkout__await__icon adyen-checkout__await__icon--result",src:ze({loadingContext:n,imageFolder:"components/"})(e),alt:r.get(t)}),te("div",{className:"adyen-checkout__await__subtitle adyen-checkout__await__subtitle--result"},r.get(t)))};if(d)return T("error","error.subtitle.payment");if(o)return T("success","creditCard.success");if(p)return te("div",{className:"adyen-checkout__await"},e.brandLogo&&te("img",{src:e.brandLogo,alt:e.type,className:"adyen-checkout__await__brand-logo"}),te(Ee,{inline:!1,size:"large"}));var z=r.get("wechatpay.timetopay").split("%@");return te("div",{className:je()("adyen-checkout__await","adyen-checkout__await--"+e.type,e.classNameModifiers.map((function(e){return"adyen-checkout__await--"+e})))},e.brandLogo&&te("img",{src:e.brandLogo,alt:e.type,className:"adyen-checkout__await__brand-logo"}),te("div",{className:"adyen-checkout__await__subtitle"},e.messageText),te("div",{className:"adyen-checkout__await__indicator-holder"},te("div",{className:"adyen-checkout__await__indicator-spinner"},te(Ee,{inline:!1,size:"medium"})),te("div",{className:"adyen-checkout__await__indicator-text"},e.awaitText)),e.showCountdownTimer&&te("div",{className:"adyen-checkout__await__countdown-holder"},te("div",{className:"adyen-checkout__await__progress"},te("span",{className:"adyen-checkout__await__percentage",style:{width:v+"%"}})),te("div",{className:"adyen-checkout__await__countdown"},z[0],"\xa0",te(Oo,{minutesFromNow:e.countdownTime,onTick:function(e){g(e.percentage)},onCompleted:function(){l(!0),clearTimeout(x);e.onError({type:"error",props:{errorMessage:"Payment Expired"}},t)}}),"\xa0",z[1])),e.url&&te("div",{className:"adyen-checkout__await__app-link"},te("span",{className:"adyen-checkout__await__separator__label"},r.get("or")),te(it,{classNameModifiers:["await"],onClick:function(){return a=e.url,void 0===r&&(r=function(){}),setTimeout((function(){var a=e.type+" App was not found";e.onError(a,t),r()}),25),void window.location.assign(a);var a,r},label:r.get("openApp")})))}yc.defaultProps={countdownTime:15,onError:function(){},onComplete:function(){},throttleTime:6e4,throttleInterval:1e4,showCountdownTimer:!0,classNameModifiers:[],shouldRedirectOnMobile:!1,url:null};var bc=yc,vc=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return S(t,e),t.prototype.formatProps=function(e){var t=e.data,a=void 0===t?{}:t,r=e.placeholders,n=void 0===r?{}:r;return D(D({},e),{data:{telephoneNumber:a.telephoneNumber||a.phoneNumber||""},placeholders:{telephoneNumber:n.telephoneNumber||n.phoneNumber||"+351 932 123 456"}})},t.prototype.formatData=function(){var e;return{paymentMethod:D({type:t.type},(null===(e=this.state.data)||void 0===e?void 0:e.telephoneNumber)&&{telephoneNumber:this.state.data.telephoneNumber})}},Object.defineProperty(t.prototype,"isValid",{get:function(){return!!this.state.isValid},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"displayName",{get:function(){return this.props.name},enumerable:!1,configurable:!0}),t.prototype.render=function(){var e=this;if(this.props.paymentData){var t=this.props.originKey||this.props.clientKey;return te(ka,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},te(bc,{ref:function(t){e.componentRef=t},accessKey:t,paymentData:this.props.paymentData,onError:this.props.onError,onComplete:this.onComplete,brandLogo:this.icon,type:pc,messageText:this.props.i18n.get(mc),awaitText:this.props.i18n.get(hc),showCountdownTimer:fc,delay:cc,countdownTime:dc,throttleTime:lc,throttleInterval:uc}))}return te(ka,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},te(sc,D({ref:function(t){e.componentRef=t}},this.props,{onChange:this.setState,onSubmit:this.submit,payButton:this.payButton})))},t.type="mbway",t}(ct);a(140);function gc(e){var t=this,a=nt(),r=a.i18n,n=a.loadingContext,i=Ge(e.data),o=i[0],s=i[1],c=Ge({blikCode:!1}),d=c[0],l=c[1],u=Ge({blikCode:!1}),p=u[0],m=u[1],h=function(e){return function(t){t.preventDefault();var a=t.target.value,r=6===a.length;s({blikCode:a}),l(D(D({},p),{blikCode:"blur"===e&&!r})),m(D(D({},p),{blikCode:r}))}};Ye((function(){e.onChange({data:o,isValid:p.blikCode},t)}),[o,p,d]);var f=Ge("ready"),y=f[0],b=f[1];return this.setStatus=function(e){b(e)},te("div",{className:"adyen-checkout__blik"},te("p",{className:"adyen-checkout__blik__helper"},r.get("blik.help")),te(St,{errorMessage:!!d.blikCode&&r.get("blik.invalid"),label:r.get("blik.code"),classNameModifiers:["blikCode","50"],isValid:p.blikCode},Ut("text",{value:o.blikCode,name:"blikCode",spellcheck:!1,required:!0,autocorrect:"off",onInput:h("input"),onChange:h("blur"),placeholder:"123456",maxLength:6})),e.showPayButton&&e.payButton({status:y,icon:Me({loadingContext:n,imageFolder:"components/"})("lock")}))}gc.defaultProps={data:{blikCode:""}};var kc=gc,Cc=2e3,_c=15,Nc=6e4,wc=1e4,Pc="blik",Fc="blik.confirmPayment",xc="await.waitForConfirmation",Sc=!1,Dc=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return S(t,e),t.prototype.formatData=function(){var e=!!this.props.storedPaymentMethodId;return{paymentMethod:D(D({type:t.type},!e&&{blikCode:this.state.data.blikCode}),e&&{storedPaymentMethodId:this.props.storedPaymentMethodId})}},Object.defineProperty(t.prototype,"isValid",{get:function(){return!!this.props.storedPaymentMethodId||!!this.state.isValid},enumerable:!1,configurable:!0}),t.prototype.render=function(){var e=this;if(this.props.paymentData){var t=this.props.originKey||this.props.clientKey;return te(ka,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},te(bc,{ref:function(t){e.componentRef=t},accessKey:t,paymentData:this.props.paymentData,onError:this.props.onError,onComplete:this.onComplete,brandLogo:this.icon,type:Pc,messageText:this.props.i18n.get(Fc),awaitText:this.props.i18n.get(xc),showCountdownTimer:Sc,delay:Cc,countdownTime:_c,throttleTime:Nc,throttleInterval:wc}))}return te(ka,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},this.props.storedPaymentMethodId?te(ii,{name:this.displayName,amount:this.props.amount,payButton:this.payButton,onSubmit:this.submit,ref:function(t){e.componentRef=t}}):te(kc,D({ref:function(t){e.componentRef=t}},this.props,{onChange:this.setState,onSubmit:this.submit,payButton:this.payButton})))},t.type="blik",t}(ct);function Ac(e){var t=e.reference,a=e.totalAmount,r=e.paymentMethodType,n=nt(),i=n.loadingContext,o=n.i18n;return te(Ni,{paymentMethodType:r,introduction:o.get("bankTransfer.instructions"),imageUrl:Me({loadingContext:i})(r),amount:a&&o.amount(a.value,a.currency),voucherDetails:[{label:o.get("bankTransfer.beneficiary"),value:e.beneficiary},{label:o.get("bankTransfer.iban"),value:e.iban},{label:o.get("bankTransfer.bic"),value:e.bic},{label:o.get("bankTransfer.reference"),value:t}]})}a(141);var Bc=new qt({});var Tc=function(e){var t=nt().i18n,a=Ge({shopperEmail:!1}),r=a[0],n=a[1],i=Ge({shopperEmail:null}),o=i[0],s=i[1],c=Ge({shopperEmail:!1}),d=c[0],l=c[1],u=Ge(!1),p=u[0],m=u[1],h=function(e,t){return function(a){var i,c,u,p=a.target.value,m=Bc.validate(e,t)(p);s(D(D({},o),((i={})[e]=p,i))),l(D(D({},d),((c={})[e]=m,c))),n(D(D({},r),((u={})[e]=!m,u)))}};return this.showValidation=function(){n(D({},p&&{shopperEmail:!Bc.validate("shopperEmail")(o.shopperEmail)}))},Ye((function(){var t=p&&e.showEmailAddress,a=!t||Boolean(Bc.validate("shopperEmail","blur")(o.shopperEmail)),r=t?o.shopperEmail:null;e.onChange({data:D(D({},o),{shopperEmail:r}),isValid:a})}),[o,d,r,p]),te("div",{className:"adyen-checkout__bankTransfer"},te("p",{className:"adyen-checkout__bankTransfer__introduction"},t.get("bankTransfer.introduction")),te(rs,{classNames:"adyen-checkout__bankTransfer__emailField",value:o.shopperEmail,errors:r.shopperEmail,onToggle:function(){return m(!p)},onInput:h("shopperEmail","input"),onChange:h("shopperEmail","blur")}))},zc=function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.state={isValid:!t.props.showEmailAddress,data:{}},t.handleRef=function(e){t.componentRef=e},t}return S(t,e),Object.defineProperty(t.prototype,"isValid",{get:function(){return!!this.state.isValid},enumerable:!1,configurable:!0}),t.prototype.formatData=function(){var e=this.state.data.shopperEmail;return D({paymentMethod:{type:t.type}},e&&{shopperEmail:e})},t.prototype.render=function(){return this.props.reference?te(ka,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},te(Ac,D({ref:this.handleRef},this.props))):this.props.showPayButton?te(ka,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},te(Tc,D({ref:this.handleRef},this.props,{onChange:this.setState})),te(ii,D({},this.props,{name:this.displayName,onSubmit:this.submit,payButton:this.payButton}))):null},t.type="bankTransfer_IBAN",t.defaultProps={showPayButton:!0,showEmailAddress:!0},t}(ct),Mc=["CA","US"],Ic=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return S(t,e),t.prototype.formatProps=function(t){return D(D({},e.prototype.formatProps.call(this,t)),{allowedCountries:Mc,personalDetailsRequiredFields:["firstName","lastName","telephoneNumber","shopperEmail"]})},t.type="affirm",t}(Ca),jc=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return S(t,e),t.prototype.formatProps=function(t){return D({delay:2e3,countdownTime:15,copyBtn:!0,introduction:"pix.instructions"},e.prototype.formatProps.call(this,t))},t.type="pix",t}(Ko),Ec=/^(\d){1,8}$/,Oc=/^(\d){6}$/,Rc=/[^0-9]/g,Vc={input:{bankAccountNumber:function(e){var t=e.replace(Rc,"");return{isValid:Ec.test(t),value:t,showError:!1}},bankLocationId:function(e){var t=e.replace(Rc,"");return{isValid:Oc.test(t),value:t,showError:!1}},shopperEmail:function(e){return{isValid:Yt.test(e),value:e,showError:!1}},default:function(e){return{isValid:e&&e.length>0,value:e,showError:!1}}},blur:{bankAccountNumber:function(e){return{isValid:Ec.test(e),value:e,showError:!0}},bankLocationId:function(e){return{isValid:Oc.test(e),value:e,showError:!0}},shopperEmail:function(e){return{isValid:Yt.test(e),value:e,showError:!0}},default:function(e){return{isValid:e&&e.length>0,value:e,showError:!0}}}},Lc=(a(142),"enter-data"),Uc="confirm-data";function Kc(e){var t,a,r=this,n=nt().i18n,i=new qt(Vc),o=Ge(Lc),s=o[0],c=o[1];this.setStatus=c;var d=Ge(e.data),l=d[0],u=d[1],p=Ge({}),m=p[0],h=p[1],f=Ge(D(D(D(D({},e.data.holderName&&{holderName:i.validate("holderName","input")(e.data.holderName).isValid}),e.data.bankAccountNumber&&{bankAccountNumber:i.validate("bankAccountNumber","input")(e.data.bankAccountNumber).isValid}),e.data.bankLocationId&&{bankLocationId:i.validate("bankLocationId","input")(e.data.bankLocationId).isValid}),e.data.shopperEmail&&{shopperEmail:i.validate("shopperEmail","input")(e.data.shopperEmail).isValid})),y=f[0],b=f[1],v=Ge(!1),g=v[0],k=v[1];this.showValidation=function(){h({holderName:!i.validate("holderName","blur")(l.holderName).isValid,bankAccountNumber:!i.validate("bankAccountNumber","blur")(l.bankAccountNumber).isValid,bankLocationId:!i.validate("bankLocationId","blur")(l.bankLocationId).isValid,shopperEmail:!i.validate("shopperEmail","blur")(l.shopperEmail).isValid,amountConsentCheckbox:!l.amountConsentCheckbox,accountConsentCheckbox:!l.accountConsentCheckbox})};var C=function(e,t){return function(a){var r,n,o,s=a.target.value,c=i.validate(e,t)(s),d=c.value,p=c.isValid,f=c.showError;u(D(D({},l),((r={})[e]=d,r))),h(D(D({},m),((n={})[e]=!p&&f,n))),b(D(D({},y),((o={})[e]=p,o)))}},_=function(e){return function(){var t=!l[e];u((function(a){var r;return D(D({},a),((r={})[e]=t,r))})),b((function(a){var r;return D(D({},a),((r={})[e]=t,r))})),h((function(a){var r;return D(D({},a),((r={})[e]=!t,r))}))}};return Ye((function(){var t=y.holderName&&y.bankAccountNumber&&y.bankLocationId&&y.shopperEmail&&!!y.amountConsentCheckbox&&!!y.accountConsentCheckbox;k(t),e.onChange({data:l,isValid:t})}),[l,y]),te("div",{className:je()({"adyen-checkout__bacs":!0,"adyen-checkout__bacs--confirm":s===Uc||"loading"===s})},s==Uc&&te("div",{className:je()({"adyen-checkout__bacs--edit":!0,"adyen-checkout__bacs--edit-dropin":e.isDropin})},Ut("text",{name:"bacsEdit",className:"adyen-checkout__bacs--edit-button",value:n.get("edit"),"aria-label":n.get("edit"),readonly:!0,onClick:function(){r.setStatus(Lc)}})),te(St,{className:je()({"adyen-checkout__bacs--holder-name":!0,"adyen-checkout__field--inactive":s===Uc||"loading"===s}),label:n.get("bacs.accountHolderName"),errorMessage:!!m.holderName&&n.get("bacs.accountHolderName.invalid"),isValid:y.holderName},Ut("text",{name:"bacs.accountHolderName",className:"adyen-checkout__bacs-input--holder-name",placeholder:e.placeholders.holderName,value:l.holderName,"aria-invalid":!y.holderName,"aria-label":n.get("bacs.accountHolderName"),"aria-required":"true",required:!0,readonly:s===Uc||"loading"===s,autocorrect:"off",onChange:C("holderName","blur"),onInput:C("holderName","input")})),te("div",{className:"adyen-checkout__bacs__num-id adyen-checkout__field-wrapper"},te(St,{errorMessage:!!m.bankAccountNumber&&n.get("bacs.accountNumber.invalid"),label:n.get("bacs.accountNumber"),className:je()({"adyen-checkout__bacs--bank-account-number":!0,"adyen-checkout__field--inactive":s===Uc||"loading"===s}),classNameModifiers:["col-70"],isValid:y.bankAccountNumber},Ut("text",{value:l.bankAccountNumber,className:"adyen-checkout__bacs-input--bank-account-number",placeholder:e.placeholders.bankAccountNumber,"aria-invalid":!y.bankAccountNumber,"aria-label":n.get("bacs.accountNumber"),"aria-required":"true",required:!0,readonly:s===Uc||"loading"===s,autocorrect:"off",onChange:C("bankAccountNumber","blur"),onInput:C("bankAccountNumber","input")})),te(St,{errorMessage:!!m.bankLocationId&&n.get("bacs.bankLocationId.invalid"),label:n.get("bacs.bankLocationId"),className:je()({"adyen-checkout__bacs--bank-location-id":!0,"adyen-checkout__field--inactive":s===Uc||"loading"===s}),classNameModifiers:["col-30"],isValid:y.bankLocationId},Ut("text",{value:l.bankLocationId,className:"adyen-checkout__bacs-input--bank-location-id",placeholder:e.placeholders.bankLocationId,"aria-invalid":!y.bankLocationId,"aria-label":n.get("bacs.bankLocationId"),"aria-required":"true",required:!0,readonly:s===Uc||"loading"===s,autocorrect:"off",onChange:C("bankLocationId","blur"),onInput:C("bankLocationId","input")}))),te(St,{errorMessage:!!m.shopperEmail&&n.get("shopperEmail.invalid"),label:n.get("shopperEmail"),className:je()({"adyen-checkout__bacs--shopper-email":!0,"adyen-checkout__field--inactive":s===Uc||"loading"===s}),isValid:y.shopperEmail},Ut("emailAddress",{value:l.shopperEmail,name:"shopperEmail",className:"adyen-checkout__bacs-input--shopper-email",classNameModifiers:["large"],placeholder:e.placeholders.shopperEmail,spellcheck:!1,"aria-invalid":!y.shopperEmail,"aria-label":n.get("shopperEmail"),"aria-required":"true",required:!0,readonly:s===Uc||"loading"===s,autocorrect:"off",onInput:C("shopperEmail","input"),onChange:C("shopperEmail","blur")})),s===Lc&&te(ya,{data:l,classNameModifiers:["amountConsentCheckbox"],errorMessage:!!m.amountConsentCheckbox,label:n.get("bacs.consent.amount"),onChange:_("amountConsentCheckbox"),checked:!!l.amountConsentCheckbox}),s===Lc&&te(ya,{data:l,classNameModifiers:["accountConsentCheckbox"],errorMessage:!!m.accountConsentCheckbox,label:n.get("bacs.consent.account"),onChange:_("accountConsentCheckbox"),checked:!!l.accountConsentCheckbox}),e.showPayButton&&e.payButton({status:s,label:s===Lc?n.get("continue"):n.get("bacs.confirm")+" "+((null===(t=e.amount)||void 0===t?void 0:t.value)&&(null===(a=e.amount)||void 0===a?void 0:a.currency)?n.amount(e.amount.value,e.amount.currency):""),icon:Me({loadingContext:e.loadingContext,imageFolder:"components/"})("lock"),onClick:function(){if(!g)return r.showValidation(),!1;s!==Lc?s===Uc&&e.onSubmit():r.setStatus(Uc)}}))}Kc.defaultProps={data:{},placeholders:{}};var qc=Kc,Hc=(a(143),function(e){var t=nt(),a=t.i18n,r=t.loadingContext,n=e.url,i=e.paymentMethodType;return te(Ni,{paymentMethodType:i,introduction:a.get("bacs.result.introduction"),imageUrl:Me({loadingContext:r})(i),downloadUrl:n,downloadButtonText:a.get("download.pdf")})}),Gc={dropin:Ws,ach:rc,afterpay:wa,afterpay_default:wa,afterpay_b2b:Pa,amazonpay:Oa,amex:Zn,applepay:Ha,bankTransfer_IBAN:zc,bcmc:Qn,bcmc_mobile:Ho,bcmc_mobile_QR:Ho,blik:Dc,billdesk_online:Qa,billdesk_wallet:$a,boletobancario:ls,boletobancario_bancodobrasil:ls,boletobancario_bradesco:ls,boletobancario_hsbc:ls,boletobancario_itau:ls,boletobancario_santander:ls,primeiropay_boleto:ls,card:Zn,diners:Zn,directdebit_GB:function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.payButton=function(e){return te(ot,D({amount:t.props.amount,onClick:t.submit},e))},t}return S(t,e),t.prototype.formatData=function(){var e,a,r,n;return D({paymentMethod:D(D(D({type:t.type},(null===(e=this.state.data)||void 0===e?void 0:e.holderName)&&{holderName:this.state.data.holderName}),(null===(a=this.state.data)||void 0===a?void 0:a.bankAccountNumber)&&{bankAccountNumber:this.state.data.bankAccountNumber}),(null===(r=this.state.data)||void 0===r?void 0:r.bankLocationId)&&{bankLocationId:this.state.data.bankLocationId})},(null===(n=this.state.data)||void 0===n?void 0:n.shopperEmail)&&{shopperEmail:this.state.data.shopperEmail})},Object.defineProperty(t.prototype,"isValid",{get:function(){return!!this.state.isValid},enumerable:!1,configurable:!0}),t.prototype.render=function(){var e=this;return te(ka,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},this.props.url?te(Hc,{ref:function(t){e.componentRef=t},icon:this.icon,url:this.props.url,paymentMethodType:this.props.paymentMethodType}):te(qc,D({ref:function(t){e.componentRef=t}},this.props,{onChange:this.setState,payButton:this.payButton,onSubmit:this.submit})))},t.type="directdebit_GB",t}(ct),discover:Zn,doku:as,doku_alfamart:as,doku_permata_lite_atm:as,doku_indomaret:as,doku_atm_mandiri_va:as,doku_sinarmas_va:as,doku_mandiri_va:as,doku_cimb_va:as,doku_danamon_va:as,doku_bri_va:as,doku_bni_va:as,doku_bca_va:as,doku_wallet:as,donation:ri,dotpay:fs,dragonpay_ebanking:Xo,dragonpay_otc_banking:Xo,dragonpay_otc_non_banking:Xo,dragonpay_otc_philippines:Xo,econtext_seven_eleven:Pi,econtext_atm:Pi,econtext_stores:Pi,econtext_online:Pi,entercash:vi,eps:ys,facilypay_3x:xi,facilypay_4x:Si,facilypay_6x:Di,facilypay_10x:Ai,facilypay_12x:Bi,giropay:si,ideal:Ti,jcb:Zn,kcp:Zn,maestro:Zn,mbway:vc,mc:Zn,molpay_ebanking_fpx_MY:Go,molpay_ebanking_TH:Yo,molpay_ebanking_VN:Wo,openbanking_UK:Jo,paypal:Vi,payu_IN_cashcard:_s,payu_IN_nb:Ns,paywithgoogle:bi,pix:jc,qiwiwallet:Gi,ratepay:Ps,redirect:oi,securedfields:Wi,sepadirectdebit:io,scheme:Zn,threeDS2Challenge:Ao,threeDS2DeviceFingerprint:Io,visa:Zn,wechatpay:qo,wechatpayQR:qo,oxxo:ps,multibanco:hs,giftcard:ks,vipps:Cs,swish:Fs,affirm:Ic,default:null},Yc=function(e,t){var a=Gc[e]||Gc.default;return a?new a(D(D({},t),{id:e+"-"+Fe()})):null},Wc=function(e,t){return void 0===t&&(t={}),t["scheme"===e?"card":e]||{}},Jc=Gc;function Zc(e){return!this.length||this.indexOf(e.type)>-1}function Qc(e){return!this.length||this.indexOf(e.type)<0}function $c(e){return!!e&&!!e.supportedShopperInteractions&&e.supportedShopperInteractions.includes("Ecommerce")}var Xc=["scheme","blik"];function ed(e){return!!e&&!!e.type&&Xc.includes(e.type)}var td=function(e){return D(D({},e),{storedPaymentMethodId:e.id})},ad=function(){function e(e,t){var a,r,n,i,o,s;void 0===t&&(t={}),this.paymentMethods=[],this.storedPaymentMethods=[],function(e){var t,a;if("string"===typeof e)throw new Error('paymentMethodsResponse was provided but of an incorrect type (should be an object but a string was provided).Try JSON.parse("{...}") your paymentMethodsResponse.');if(e instanceof Array)throw new Error("paymentMethodsResponse was provided but of an incorrect type (should be an object but an array was provided).Please check you are passing the whole response.");!e||(null===(t=null===e||void 0===e?void 0:e.paymentMethods)||void 0===t?void 0:t.length)||(null===(a=null===e||void 0===e?void 0:e.storePaymentMethods)||void 0===a?void 0:a.length)||console.warn("paymentMethodsResponse was provided but no payment methods were found.")}(e),this.paymentMethods=e?(a=e.paymentMethods,n=(r=t).allowPaymentMethods,i=void 0===n?[]:n,o=r.removePaymentMethods,s=void 0===o?[]:o,a?a.filter(Zc,i).filter(Qc,s):[]):[],this.storedPaymentMethods=e?function(e,t){var a=t.allowPaymentMethods,r=void 0===a?[]:a,n=t.removePaymentMethods,i=void 0===n?[]:n;return e?e.filter(ed).filter(Zc,r).filter(Qc,i).filter($c).map(td):[]}(e.storedPaymentMethods,t):[]}return e.prototype.has=function(e){return Boolean(this.paymentMethods.find((function(t){return t.type===e})))},e.prototype.find=function(e){return this.paymentMethods.find((function(t){return t.type===e}))},e}(),rd={redirect:function(e,t){return Yc("redirect",D(D(D({},t),e),{statusType:"redirect"}))},threeDS2Fingerprint:function(e,t){return Yc("threeDS2DeviceFingerprint",D(D({createFromAction:t.createFromAction,token:e.token,paymentData:e.paymentData,onError:t.onError,showSpinner:!t.isDropin,isDropin:!!t.isDropin},t),{type:"IdentifyShopper",onComplete:t.onAdditionalDetails,statusType:"loading",useOriginalFlow:!0}))},threeDS2Challenge:function(e,t){var a;return Yc("threeDS2Challenge",D(D({},t),{token:e.token,paymentData:e.paymentData,onComplete:t.onAdditionalDetails,onError:t.onError,size:null!==(a=t.size)&&void 0!==a?a:"02",isDropin:!!t.isDropin,type:"ChallengeShopper",statusType:"custom",useOriginalFlow:!0}))},threeDS2:function(e,t){var a="fingerprint"===e.subtype?"threeDS2DeviceFingerprint":"threeDS2Challenge",r="fingerprint"===e.subtype?e.paymentData:e.authorisationToken,n=D({token:e.token,paymentData:r,onComplete:t.onAdditionalDetails,onError:t.onError,isDropin:!!t.isDropin,loadingContext:t.loadingContext,clientKey:t.clientKey},function(e,t){if("fingerprint"===e){var a=Ir(t.elementRef?wo:Po).from(t);return a.showSpinner=!t.isDropin,a.statusType="loading",a}var r=Ir(Fo).from(t);return r.statusType="custom",r}(e.subtype,t));return Yc(a,n)},voucher:function(e,t){return Yc(e.paymentMethodType,D(D(D({},e),t),{i18n:t.i18n,loadingContext:t.loadingContext,statusType:"custom"}))},qrCode:function(e,t){return Yc(e.paymentMethodType,D(D(D({},e),t),{onComplete:t.onAdditionalDetails,onError:t.onError,statusType:"custom"}))},await:function(e,t){return Yc(e.paymentMethodType,D(D(D({},e),t),{onComplete:t.onAdditionalDetails,onError:t.onError,statusType:"custom"}))},bankTransfer:function(e,t){return Yc(e.paymentMethodType,D(D(D({},e),t),{onComplete:t.onAdditionalDetails,onError:t.onError,statusType:"custom"}))}};var nd=function(e,t){void 0===t&&(t={});var a=rd[e.type];if(a&&"function"===typeof a)return a(e,t);throw new Error("Invalid Action")},id=function(e){void 0===e&&(e="https://checkoutshopper-live.adyen.com/checkoutshopper/");var t={test:"https://checkoutshopper-test.adyen.com/checkoutshopper/",live:"https://checkoutshopper-live.adyen.com/checkoutshopper/","live-us":"https://checkoutshopper-live-us.adyen.com/checkoutshopper/","live-au":"https://checkoutshopper-live-au.adyen.com/checkoutshopper/"};return t[e]||t[e.toLowerCase()]||e},od=function(e){return function(t){var a=D({version:"3.23.0",payload_version:1,platform:"web",locale:e.locale},t),r=Object.keys(a).map((function(e){return encodeURIComponent(e)+"="+encodeURIComponent(a[e])})).join("&");(new Image).src=e.loadingContext+"images/analytics.png?"+r}},sd=function(e){return function(t){if(!e.accessKey)return Promise.reject();var a=D({version:"3.23.0",platform:"web",locale:e.locale,flavor:"components",userAgent:navigator.userAgent,referrer:window.location.href,screenWidth:window.screen.width},t),r={method:"POST",headers:{Accept:"application/json, text/plain, */*","Content-Type":"application/json"},body:JSON.stringify(a)};return fetch(e.loadingContext+"v1/analytics/log?token="+e.accessKey,r).then((function(e){return e.ok})).catch((function(){}))}},cd=function(e){if(!e.accessKey)return Promise.reject();return fetch(e.loadingContext+"v1/analytics/id?token="+e.accessKey,{method:"POST",headers:{Accept:"application/json, text/plain, */*","Content-Type":"application/json"}}).then((function(e){if(e.ok)return e.json();throw new Error("Collect ID not available")})).then((function(e){return e.id})).catch((function(){}))},dd=function(){function e(){this.events=[]}return e.prototype.add=function(e){this.events.push(e)},e.prototype.run=function(e){var t=this.events.map((function(t){return t(e)}));return this.events=[],Promise.all(t)},e}(),ld=function(){function e(t){var a=this,r=t.loadingContext,n=t.locale,i=t.originKey,o=t.clientKey,s=t.analytics;this.conversionId=null,this.queue=new dd,this.props=D(D({},e.defaultProps),s);var c=o||i;this.logEvent=od({loadingContext:r,locale:n}),this.logTelemetry=sd({loadingContext:r,locale:n,accessKey:c});var d=this.props,l=d.conversion,u=d.enabled;l&&u&&(this.props.conversionId?(this.conversionId=this.props.conversionId,this.queue.run(this.conversionId)):cd({loadingContext:r,accessKey:c}).then((function(e){a.conversionId=e,a.queue.run(a.conversionId)})).catch((function(){a.queue.run()})))}return e.prototype.send=function(e){var t=this,a=this.props,r=a.conversion,n=a.enabled,i=a.telemetry;if(!0===n){if(!0===i){this.queue.add((function(a){return t.logTelemetry(D(D({},e),{conversionId:a})).catch((function(){}))})),r&&!this.conversionId||this.queue.run(this.conversionId)}this.logEvent(e)}},e.defaultProps={enabled:!0,telemetry:!0,conversion:!1,conversionId:null},e}(),ud=function(){function e(e){var t=this;this.components=[],this.update=function(e){return void 0===e&&(e={}),t.setOptions(e),t.components.forEach((function(e){return e.update(t.getPropsForComponent(t.options))})),t},this.remove=function(e){return t.components=t.components.filter((function(t){return t._id!==e._id})),e.unmount(),t},this.setOptions=function(e){return t.options=D(D({},t.options),e),t.options.loadingContext=id(t.options.environment),t.modules={risk:new Pt(t.options),analytics:new ld(t.options),i18n:new J(t.options.locale,t.options.translations)},t.paymentMethodsResponse=new ad(t.options.paymentMethodsResponse,t.options),t},this.create=this.create.bind(this),this.createFromAction=this.createFromAction.bind(this),this.setOptions(e)}return e.prototype.create=function(e,t){var a=this.getPropsForComponent(t);return e?this.handleCreate(e,a):this.handleCreateError()},e.prototype.createFromAction=function(e,t){if(void 0===t&&(t={}),e.type){var a=this.getPropsForComponent(t);return nd(e,a)}return this.handleCreateError()},e.prototype.getPropsForComponent=function(e){return D(D(D({paymentMethods:this.paymentMethodsResponse.paymentMethods,storedPaymentMethods:this.paymentMethodsResponse.storedPaymentMethods},this.options),e),{i18n:this.modules.i18n,modules:this.modules,createFromAction:this.createFromAction,_parentInstance:this})},e.prototype.handleCreate=function(e,t){if(void 0===t&&(t={}),e.prototype instanceof ct){var a=t.supportedShopperInteractions?[]:this.paymentMethodsResponse.find(e.type),r=Wc(e.type,t.paymentMethodsConfiguration),n=new e(D(D(D({},a),t),r));return this.components.push(n),n}if("string"===typeof e&&Jc[e])return this.handleCreate(Jc[e],t);if("string"===typeof e&&this.paymentMethodsResponse.has(e)&&!this.paymentMethodsResponse.find(e).details){r=Wc(e,t.paymentMethodsConfiguration);return this.handleCreate(Jc.redirect,D(D(D({},this.paymentMethodsResponse.find(e)),t),r))}return this.handleCreateError(e)},e.prototype.handleCreateError=function(e){var t=e&&e.name?e.name:"The passed payment method";throw new Error(e?t+" is not a valid Checkout Component":"No Payment Method component was passed")},e.version={version:"3.23.0",revision:"9634a3b",branch:"HEAD",buildId:"@adyen/adyen-web-17a8da7f-f568-49c6-bfa5-af341a4fc807"},e}();t.default=ud}]).default}));
//# sourceMappingURL=adyen.js.map

/***/ }),

/***/ 59185:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

(function (global, factory) {
	 true ? factory(exports) :
	0;
})(this, (function (exports) { 'use strict';

	var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof self !== 'undefined' ? self : {};

	function createCommonjsModule(fn, basedir, module) {
		return module = {
			path: basedir,
			exports: {},
			require: function (path, base) {
				return commonjsRequire(path, (base === undefined || base === null) ? module.path : base);
			}
		}, fn(module, module.exports), module.exports;
	}

	function commonjsRequire () {
		throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
	}

	var uaParser = createCommonjsModule(function (module, exports) {
	  /////////////////////////////////////////////////////////////////////////////////

	  /* UAParser.js v0.7.28
	     Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
	     MIT License */

	  /*
	  Detect Browser, Engine, OS, CPU, and Device type/model from User-Agent data.
	  Supports browser & node.js environment. 
	  Demo   : https://faisalman.github.io/ua-parser-js
	  Source : https://github.com/faisalman/ua-parser-js */
	  /////////////////////////////////////////////////////////////////////////////////
	  (function (window, undefined$1) {
	    // Constants
	    /////////////

	    var LIBVERSION = '0.7.28',
	        EMPTY = '',
	        UNKNOWN = '?',
	        FUNC_TYPE = 'function',
	        UNDEF_TYPE = 'undefined',
	        OBJ_TYPE = 'object',
	        STR_TYPE = 'string',
	        MAJOR = 'major',
	        MODEL = 'model',
	        NAME = 'name',
	        TYPE = 'type',
	        VENDOR = 'vendor',
	        VERSION = 'version',
	        ARCHITECTURE = 'architecture',
	        CONSOLE = 'console',
	        MOBILE = 'mobile',
	        TABLET = 'tablet',
	        SMARTTV = 'smarttv',
	        WEARABLE = 'wearable',
	        EMBEDDED = 'embedded',
	        UA_MAX_LENGTH = 255;
	    var AMAZON = 'Amazon',
	        APPLE = 'Apple',
	        ASUS = 'ASUS',
	        BLACKBERRY = 'BlackBerry',
	        BROWSER = 'Browser',
	        CHROME = 'Chrome',
	        EDGE = 'Edge',
	        FIREFOX = 'Firefox',
	        GOOGLE = 'Google',
	        HUAWEI = 'Huawei',
	        LG = 'LG',
	        MICROSOFT = 'Microsoft',
	        MOTOROLA = 'Motorola',
	        OPERA = 'Opera',
	        SAMSUNG = 'Samsung',
	        SONY = 'Sony',
	        XIAOMI = 'Xiaomi',
	        ZEBRA = 'Zebra'; ///////////
	    // Helper
	    //////////

	    var extend = function (regexes, extensions) {
	      var mergedRegexes = {};

	      for (var i in regexes) {
	        if (extensions[i] && extensions[i].length % 2 === 0) {
	          mergedRegexes[i] = extensions[i].concat(regexes[i]);
	        } else {
	          mergedRegexes[i] = regexes[i];
	        }
	      }

	      return mergedRegexes;
	    },
	        enumerize = function (arr) {
	      var enums = {};

	      for (var i = 0; i < arr.length; i++) {
	        enums[arr[i].toUpperCase()] = arr[i];
	      }

	      return enums;
	    },
	        has = function (str1, str2) {
	      return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
	    },
	        lowerize = function (str) {
	      return str.toLowerCase();
	    },
	        majorize = function (version) {
	      return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split('.')[0] : undefined$1;
	    },
	        trim = function (str, len) {
	      if (typeof str === STR_TYPE) {
	        str = str.replace(/^\s+|\s+$/g, EMPTY);
	        return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
	      }
	    }; ///////////////
	    // Map helper
	    //////////////


	    var rgxMapper = function (ua, arrays) {
	      var i = 0,
	          j,
	          k,
	          p,
	          q,
	          matches,
	          match; // loop through all regexes maps

	      while (i < arrays.length && !matches) {
	        var regex = arrays[i],
	            // even sequence (0,2,4,..)
	        props = arrays[i + 1]; // odd sequence (1,3,5,..)

	        j = k = 0; // try matching uastring with regexes

	        while (j < regex.length && !matches) {
	          matches = regex[j++].exec(ua);

	          if (!!matches) {
	            for (p = 0; p < props.length; p++) {
	              match = matches[++k];
	              q = props[p]; // check if given property is actually array

	              if (typeof q === OBJ_TYPE && q.length > 0) {
	                if (q.length == 2) {
	                  if (typeof q[1] == FUNC_TYPE) {
	                    // assign modified match
	                    this[q[0]] = q[1].call(this, match);
	                  } else {
	                    // assign given value, ignore regex match
	                    this[q[0]] = q[1];
	                  }
	                } else if (q.length == 3) {
	                  // check whether function or regex
	                  if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
	                    // call function (usually string mapper)
	                    this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined$1;
	                  } else {
	                    // sanitize match using given regex
	                    this[q[0]] = match ? match.replace(q[1], q[2]) : undefined$1;
	                  }
	                } else if (q.length == 4) {
	                  this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined$1;
	                }
	              } else {
	                this[q] = match ? match : undefined$1;
	              }
	            }
	          }
	        }

	        i += 2;
	      }
	    },
	        strMapper = function (str, map) {
	      for (var i in map) {
	        // check if current value is array
	        if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
	          for (var j = 0; j < map[i].length; j++) {
	            if (has(map[i][j], str)) {
	              return i === UNKNOWN ? undefined$1 : i;
	            }
	          }
	        } else if (has(map[i], str)) {
	          return i === UNKNOWN ? undefined$1 : i;
	        }
	      }

	      return str;
	    }; ///////////////
	    // String map
	    //////////////
	    // Safari < 3.0


	    var oldSafariMap = {
	      '1.0': '/8',
	      '1.2': '/1',
	      '1.3': '/3',
	      '2.0': '/412',
	      '2.0.2': '/416',
	      '2.0.3': '/417',
	      '2.0.4': '/419',
	      '?': '/'
	    },
	        windowsVersionMap = {
	      'ME': '4.90',
	      'NT 3.11': 'NT3.51',
	      'NT 4.0': 'NT4.0',
	      '2000': 'NT 5.0',
	      'XP': ['NT 5.1', 'NT 5.2'],
	      'Vista': 'NT 6.0',
	      '7': 'NT 6.1',
	      '8': 'NT 6.2',
	      '8.1': 'NT 6.3',
	      '10': ['NT 6.4', 'NT 10.0'],
	      'RT': 'ARM'
	    }; //////////////
	    // Regex map
	    /////////////

	    var regexes = {
	      browser: [[/\b(?:crmo|crios)\/([\w\.]+)/i // Chrome for Android/iOS
	      ], [VERSION, [NAME, 'Chrome']], [/edg(?:e|ios|a)?\/([\w\.]+)/i // Microsoft Edge
	      ], [VERSION, [NAME, 'Edge']], [// Presto based
	      /(opera mini)\/([-\w\.]+)/i, // Opera Mini
	      /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i, // Opera Mobi/Tablet
	      /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i // Opera
	      ], [NAME, VERSION], [/opios[\/ ]+([\w\.]+)/i // Opera mini on iphone >= 8.0
	      ], [VERSION, [NAME, OPERA + ' Mini']], [/\bopr\/([\w\.]+)/i // Opera Webkit
	      ], [VERSION, [NAME, OPERA]], [// Mixed
	      /(kindle)\/([\w\.]+)/i, // Kindle
	      /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i, // Lunascape/Maxthon/Netfront/Jasmine/Blazer
	      // Trident based
	      /(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i, // Avant/IEMobile/SlimBrowser
	      /(ba?idubrowser)[\/ ]?([\w\.]+)/i, // Baidu Browser
	      /(?:ms|\()(ie) ([\w\.]+)/i, // Internet Explorer
	      // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
	      /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale|qqbrowserlite|qq)\/([-\w\.]+)/i, // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
	      /(weibo)__([\d\.]+)/i // Weibo
	      ], [NAME, VERSION], [/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i // UCBrowser
	      ], [VERSION, [NAME, 'UC' + BROWSER]], [/\bqbcore\/([\w\.]+)/i // WeChat Desktop for Windows Built-in Browser
	      ], [VERSION, [NAME, 'WeChat(Win) Desktop']], [/micromessenger\/([\w\.]+)/i // WeChat
	      ], [VERSION, [NAME, 'WeChat']], [/konqueror\/([\w\.]+)/i // Konqueror
	      ], [VERSION, [NAME, 'Konqueror']], [/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i // IE11
	      ], [VERSION, [NAME, 'IE']], [/yabrowser\/([\w\.]+)/i // Yandex
	      ], [VERSION, [NAME, 'Yandex']], [/(avast|avg)\/([\w\.]+)/i // Avast/AVG Secure Browser
	      ], [[NAME, /(.+)/, '$1 Secure ' + BROWSER], VERSION], [/\bfocus\/([\w\.]+)/i // Firefox Focus
	      ], [VERSION, [NAME, FIREFOX + ' Focus']], [/\bopt\/([\w\.]+)/i // Opera Touch
	      ], [VERSION, [NAME, OPERA + ' Touch']], [/coc_coc\w+\/([\w\.]+)/i // Coc Coc Browser
	      ], [VERSION, [NAME, 'Coc Coc']], [/dolfin\/([\w\.]+)/i // Dolphin
	      ], [VERSION, [NAME, 'Dolphin']], [/coast\/([\w\.]+)/i // Opera Coast
	      ], [VERSION, [NAME, OPERA + ' Coast']], [/miuibrowser\/([\w\.]+)/i // MIUI Browser
	      ], [VERSION, [NAME, 'MIUI ' + BROWSER]], [/fxios\/([-\w\.]+)/i // Firefox for iOS
	      ], [VERSION, [NAME, FIREFOX]], [/\bqihu|(qi?ho?o?|360)browser/i // 360
	      ], [[NAME, '360 ' + BROWSER]], [/(oculus|samsung|sailfish)browser\/([\w\.]+)/i], [[NAME, /(.+)/, '$1 ' + BROWSER], VERSION], [// Oculus/Samsung/Sailfish Browser
	      /(comodo_dragon)\/([\w\.]+)/i // Comodo Dragon
	      ], [[NAME, /_/g, ' '], VERSION], [/(electron)\/([\w\.]+) safari/i, // Electron-based App
	      /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i, // Tesla
	      /m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i // QQBrowser/Baidu App/2345 Browser
	      ], [NAME, VERSION], [/(metasr)[\/ ]?([\w\.]+)/i, // SouGouBrowser
	      /(lbbrowser)/i // LieBao Browser
	      ], [NAME], [// WebView
	      /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i // Facebook App for iOS & Android
	      ], [[NAME, 'Facebook'], VERSION], [/safari (line)\/([\w\.]+)/i, // Line App for iOS
	      /\b(line)\/([\w\.]+)\/iab/i, // Line App for Android
	      /(chromium|instagram)[\/ ]([-\w\.]+)/i // Chromium/Instagram
	      ], [NAME, VERSION], [/\bgsa\/([\w\.]+) .*safari\//i // Google Search Appliance on iOS
	      ], [VERSION, [NAME, 'GSA']], [/headlesschrome(?:\/([\w\.]+)| )/i // Chrome Headless
	      ], [VERSION, [NAME, CHROME + ' Headless']], [/ wv\).+(chrome)\/([\w\.]+)/i // Chrome WebView
	      ], [[NAME, CHROME + ' WebView'], VERSION], [/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i // Android Browser
	      ], [VERSION, [NAME, 'Android ' + BROWSER]], [/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i // Chrome/OmniWeb/Arora/Tizen/Nokia
	      ], [NAME, VERSION], [/version\/([\w\.]+) .*mobile\/\w+ (safari)/i // Mobile Safari
	      ], [VERSION, [NAME, 'Mobile Safari']], [/version\/([\w\.]+) .*(mobile ?safari|safari)/i // Safari & Safari Mobile
	      ], [VERSION, NAME], [/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i // Safari < 3.0
	      ], [NAME, [VERSION, strMapper, oldSafariMap]], [/(webkit|khtml)\/([\w\.]+)/i], [NAME, VERSION], [// Gecko based
	      /(navigator|netscape\d?)\/([-\w\.]+)/i // Netscape
	      ], [[NAME, 'Netscape'], VERSION], [/mobile vr; rv:([\w\.]+)\).+firefox/i // Firefox Reality
	      ], [VERSION, [NAME, FIREFOX + ' Reality']], [/ekiohf.+(flow)\/([\w\.]+)/i, // Flow
	      /(swiftfox)/i, // Swiftfox
	      /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i, // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
	      /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i, // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
	      /(firefox)\/([\w\.]+)/i, // Other Firefox-based
	      /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i, // Mozilla
	      // Other
	      /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i, // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
	      /(links) \(([\w\.]+)/i // Links
	      ], [NAME, VERSION]],
	      cpu: [[/(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i // AMD64 (x64)
	      ], [[ARCHITECTURE, 'amd64']], [/(ia32(?=;))/i // IA32 (quicktime)
	      ], [[ARCHITECTURE, lowerize]], [/((?:i[346]|x)86)[;\)]/i // IA32 (x86)
	      ], [[ARCHITECTURE, 'ia32']], [/\b(aarch64|arm(v?8e?l?|_?64))\b/i // ARM64
	      ], [[ARCHITECTURE, 'arm64']], [/\b(arm(?:v[67])?ht?n?[fl]p?)\b/i // ARMHF
	      ], [[ARCHITECTURE, 'armhf']], [// PocketPC mistakenly identified as PowerPC
	      /windows (ce|mobile); ppc;/i], [[ARCHITECTURE, 'arm']], [/((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i // PowerPC
	      ], [[ARCHITECTURE, /ower/, EMPTY, lowerize]], [/(sun4\w)[;\)]/i // SPARC
	      ], [[ARCHITECTURE, 'sparc']], [/((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
	      ], [[ARCHITECTURE, lowerize]]],
	      device: [[//////////////////////////
	      // MOBILES & TABLETS
	      // Ordered by popularity
	      /////////////////////////
	      // Samsung
	      /\b(sch-i[89]0\d|shw-m380s|sm-[pt]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i], [MODEL, [VENDOR, SAMSUNG], [TYPE, TABLET]], [/\b((?:s[cgp]h|gt|sm)-\w+|galaxy nexus)/i, /samsung[- ]([-\w]+)/i, /sec-(sgh\w+)/i], [MODEL, [VENDOR, SAMSUNG], [TYPE, MOBILE]], [// Apple
	      /((ipod|iphone)\d+,\d+)/i // iPod/iPhone model
	      ], [MODEL, [VENDOR, APPLE], [TYPE, MOBILE]], [/(ipad\d+,\d+)/i // iPad model
	      ], [MODEL, [VENDOR, APPLE], [TYPE, TABLET]], [/\((ip(?:hone|od)[\w ]*);/i // iPod/iPhone
	      ], [MODEL, [VENDOR, APPLE], [TYPE, MOBILE]], [/\((ipad);[-\w\),; ]+apple/i, // iPad
	      /applecoremedia\/[\w\.]+ \((ipad)/i, /\b(ipad)\d\d?,\d\d?[;\]].+ios/i], [MODEL, [VENDOR, APPLE], [TYPE, TABLET]], [// Huawei
	      /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i], [MODEL, [VENDOR, HUAWEI], [TYPE, TABLET]], [/(?:huawei|honor)([-\w ]+)[;\)]/i, /\b(nexus 6p|\w{2,4}-[atu]?[ln][01259x][012359][an]?)\b(?!.+d\/s)/i], [MODEL, [VENDOR, HUAWEI], [TYPE, MOBILE]], [// Xiaomi
	      /\b(poco[\w ]+)(?: bui|\))/i, // Xiaomi POCO
	      /\b; (\w+) build\/hm\1/i, // Xiaomi Hongmi 'numeric' models
	      /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i, // Xiaomi Hongmi
	      /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i, // Xiaomi Redmi
	      /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i // Xiaomi Mi
	      ], [[MODEL, /_/g, ' '], [VENDOR, XIAOMI], [TYPE, MOBILE]], [/\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i // Mi Pad tablets
	      ], [[MODEL, /_/g, ' '], [VENDOR, XIAOMI], [TYPE, TABLET]], [// OPPO
	      /; (\w+) bui.+ oppo/i, /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007)\b/i], [MODEL, [VENDOR, 'OPPO'], [TYPE, MOBILE]], [// Vivo
	      /vivo (\w+)(?: bui|\))/i, /\b(v[12]\d{3}\w?[at])(?: bui|;)/i], [MODEL, [VENDOR, 'Vivo'], [TYPE, MOBILE]], [// Realme
	      /\b(rmx[12]\d{3})(?: bui|;|\))/i], [MODEL, [VENDOR, 'Realme'], [TYPE, MOBILE]], [// Motorola
	      /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i, /\bmot(?:orola)?[- ](\w*)/i, /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i], [MODEL, [VENDOR, MOTOROLA], [TYPE, MOBILE]], [/\b(mz60\d|xoom[2 ]{0,2}) build\//i], [MODEL, [VENDOR, MOTOROLA], [TYPE, TABLET]], [// LG
	      /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i], [MODEL, [VENDOR, LG], [TYPE, TABLET]], [/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i, /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i, /\blg-?([\d\w]+) bui/i], [MODEL, [VENDOR, LG], [TYPE, MOBILE]], [// Lenovo
	      /(ideatab[-\w ]+)/i, /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [// Nokia
	      /(?:maemo|nokia).*(n900|lumia \d+)/i, /nokia[-_ ]?([-\w\.]*)/i], [[MODEL, /_/g, ' '], [VENDOR, 'Nokia'], [TYPE, MOBILE]], [// Google
	      /(pixel c)\b/i // Google Pixel C
	      ], [MODEL, [VENDOR, GOOGLE], [TYPE, TABLET]], [/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i // Google Pixel
	      ], [MODEL, [VENDOR, GOOGLE], [TYPE, MOBILE]], [// Sony
	      /droid.+ ([c-g]\d{4}|so[-l]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i], [MODEL, [VENDOR, SONY], [TYPE, MOBILE]], [/sony tablet [ps]/i, /\b(?:sony)?sgp\w+(?: bui|\))/i], [[MODEL, 'Xperia Tablet'], [VENDOR, SONY], [TYPE, TABLET]], [// OnePlus
	      / (kb2005|in20[12]5|be20[12][59])\b/i, /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [// Amazon
	      /(alexa)webm/i, /(kf[a-z]{2}wi)( bui|\))/i, // Kindle Fire without Silk
	      /(kf[a-z]+)( bui|\)).+silk\//i // Kindle Fire HD
	      ], [MODEL, [VENDOR, AMAZON], [TYPE, TABLET]], [/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i // Fire Phone
	      ], [[MODEL, /(.+)/g, 'Fire Phone $1'], [VENDOR, AMAZON], [TYPE, MOBILE]], [// BlackBerry
	      /(playbook);[-\w\),; ]+(rim)/i // BlackBerry PlayBook
	      ], [MODEL, VENDOR, [TYPE, TABLET]], [/\b((?:bb[a-f]|st[hv])100-\d)/i, /\(bb10; (\w+)/i // BlackBerry 10
	      ], [MODEL, [VENDOR, BLACKBERRY], [TYPE, MOBILE]], [// Asus
	      /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i], [MODEL, [VENDOR, ASUS], [TYPE, TABLET]], [/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i], [MODEL, [VENDOR, ASUS], [TYPE, MOBILE]], [// HTC
	      /(nexus 9)/i // HTC Nexus 9
	      ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i, // HTC
	      // ZTE
	      /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i, /(alcatel|geeksphone|nexian|panasonic|sony)[-_ ]?([-\w]*)/i // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
	      ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [// Acer
	      /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [// Meizu
	      /droid.+; (m[1-5] note) bui/i, /\bmz-([-\w]{2,})/i], [MODEL, [VENDOR, 'Meizu'], [TYPE, MOBILE]], [// Sharp
	      /\b(sh-?[altvz]?\d\d[a-ekm]?)/i], [MODEL, [VENDOR, 'Sharp'], [TYPE, MOBILE]], [// MIXED
	      /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i, // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
	      /(hp) ([\w ]+\w)/i, // HP iPAQ
	      /(asus)-?(\w+)/i, // Asus
	      /(microsoft); (lumia[\w ]+)/i, // Microsoft Lumia
	      /(lenovo)[-_ ]?([-\w]+)/i, // Lenovo
	      /(jolla)/i, // Jolla
	      /(oppo) ?([\w ]+) bui/i // OPPO
	      ], [VENDOR, MODEL, [TYPE, MOBILE]], [/(archos) (gamepad2?)/i, // Archos
	      /(hp).+(touchpad(?!.+tablet)|tablet)/i, // HP TouchPad
	      /(kindle)\/([\w\.]+)/i, // Kindle
	      /(nook)[\w ]+build\/(\w+)/i, // Nook
	      /(dell) (strea[kpr\d ]*[\dko])/i, // Dell Streak
	      /(le[- ]+pan)[- ]+(\w{1,9}) bui/i, // Le Pan Tablets
	      /(trinity)[- ]*(t\d{3}) bui/i, // Trinity Tablets
	      /(gigaset)[- ]+(q\w{1,9}) bui/i, // Gigaset Tablets
	      /(vodafone) ([\w ]+)(?:\)| bui)/i // Vodafone
	      ], [VENDOR, MODEL, [TYPE, TABLET]], [/(surface duo)/i // Surface Duo
	      ], [MODEL, [VENDOR, MICROSOFT], [TYPE, TABLET]], [/droid [\d\.]+; (fp\du?)(?: b|\))/i // Fairphone
	      ], [MODEL, [VENDOR, 'Fairphone'], [TYPE, MOBILE]], [/(u304aa)/i // AT&T
	      ], [MODEL, [VENDOR, 'AT&T'], [TYPE, MOBILE]], [/\bsie-(\w*)/i // Siemens
	      ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [/\b(rct\w+) b/i // RCA Tablets
	      ], [MODEL, [VENDOR, 'RCA'], [TYPE, TABLET]], [/\b(venue[\d ]{2,7}) b/i // Dell Venue Tablets
	      ], [MODEL, [VENDOR, 'Dell'], [TYPE, TABLET]], [/\b(q(?:mv|ta)\w+) b/i // Verizon Tablet
	      ], [MODEL, [VENDOR, 'Verizon'], [TYPE, TABLET]], [/\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i // Barnes & Noble Tablet
	      ], [MODEL, [VENDOR, 'Barnes & Noble'], [TYPE, TABLET]], [/\b(tm\d{3}\w+) b/i], [MODEL, [VENDOR, 'NuVision'], [TYPE, TABLET]], [/\b(k88) b/i // ZTE K Series Tablet
	      ], [MODEL, [VENDOR, 'ZTE'], [TYPE, TABLET]], [/\b(nx\d{3}j) b/i // ZTE Nubia
	      ], [MODEL, [VENDOR, 'ZTE'], [TYPE, MOBILE]], [/\b(gen\d{3}) b.+49h/i // Swiss GEN Mobile
	      ], [MODEL, [VENDOR, 'Swiss'], [TYPE, MOBILE]], [/\b(zur\d{3}) b/i // Swiss ZUR Tablet
	      ], [MODEL, [VENDOR, 'Swiss'], [TYPE, TABLET]], [/\b((zeki)?tb.*\b) b/i // Zeki Tablets
	      ], [MODEL, [VENDOR, 'Zeki'], [TYPE, TABLET]], [/\b([yr]\d{2}) b/i, /\b(dragon[- ]+touch |dt)(\w{5}) b/i // Dragon Touch Tablet
	      ], [[VENDOR, 'Dragon Touch'], MODEL, [TYPE, TABLET]], [/\b(ns-?\w{0,9}) b/i // Insignia Tablets
	      ], [MODEL, [VENDOR, 'Insignia'], [TYPE, TABLET]], [/\b((nxa|next)-?\w{0,9}) b/i // NextBook Tablets
	      ], [MODEL, [VENDOR, 'NextBook'], [TYPE, TABLET]], [/\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i // Voice Xtreme Phones
	      ], [[VENDOR, 'Voice'], MODEL, [TYPE, MOBILE]], [/\b(lvtel\-)?(v1[12]) b/i // LvTel Phones
	      ], [[VENDOR, 'LvTel'], MODEL, [TYPE, MOBILE]], [/\b(ph-1) /i // Essential PH-1
	      ], [MODEL, [VENDOR, 'Essential'], [TYPE, MOBILE]], [/\b(v(100md|700na|7011|917g).*\b) b/i // Envizen Tablets
	      ], [MODEL, [VENDOR, 'Envizen'], [TYPE, TABLET]], [/\b(trio[-\w\. ]+) b/i // MachSpeed Tablets
	      ], [MODEL, [VENDOR, 'MachSpeed'], [TYPE, TABLET]], [/\btu_(1491) b/i // Rotor Tablets
	      ], [MODEL, [VENDOR, 'Rotor'], [TYPE, TABLET]], [/(shield[\w ]+) b/i // Nvidia Shield Tablets
	      ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, TABLET]], [/(sprint) (\w+)/i // Sprint Phones
	      ], [VENDOR, MODEL, [TYPE, MOBILE]], [/(kin\.[onetw]{3})/i // Microsoft Kin
	      ], [[MODEL, /\./g, ' '], [VENDOR, MICROSOFT], [TYPE, MOBILE]], [/droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i // Zebra
	      ], [MODEL, [VENDOR, ZEBRA], [TYPE, TABLET]], [/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i], [MODEL, [VENDOR, ZEBRA], [TYPE, MOBILE]], [///////////////////
	      // CONSOLES
	      ///////////////////
	      /(ouya)/i, // Ouya
	      /(nintendo) ([wids3utch]+)/i // Nintendo
	      ], [VENDOR, MODEL, [TYPE, CONSOLE]], [/droid.+; (shield) bui/i // Nvidia
	      ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [/(playstation [345portablevi]+)/i // Playstation
	      ], [MODEL, [VENDOR, SONY], [TYPE, CONSOLE]], [/\b(xbox(?: one)?(?!; xbox))[\); ]/i // Microsoft Xbox
	      ], [MODEL, [VENDOR, MICROSOFT], [TYPE, CONSOLE]], [///////////////////
	      // SMARTTVS
	      ///////////////////
	      /smart-tv.+(samsung)/i // Samsung
	      ], [VENDOR, [TYPE, SMARTTV]], [/hbbtv.+maple;(\d+)/i], [[MODEL, /^/, 'SmartTV'], [VENDOR, SAMSUNG], [TYPE, SMARTTV]], [/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i // LG SmartTV
	      ], [[VENDOR, LG], [TYPE, SMARTTV]], [/(apple) ?tv/i // Apple TV
	      ], [VENDOR, [MODEL, APPLE + ' TV'], [TYPE, SMARTTV]], [/crkey/i // Google Chromecast
	      ], [[MODEL, CHROME + 'cast'], [VENDOR, GOOGLE], [TYPE, SMARTTV]], [/droid.+aft(\w)( bui|\))/i // Fire TV
	      ], [MODEL, [VENDOR, AMAZON], [TYPE, SMARTTV]], [/\(dtv[\);].+(aquos)/i // Sharp
	      ], [MODEL, [VENDOR, 'Sharp'], [TYPE, SMARTTV]], [/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i, // Roku
	      /hbbtv\/\d+\.\d+\.\d+ +\([\w ]*; *(\w[^;]*);([^;]*)/i // HbbTV devices
	      ], [[VENDOR, trim], [MODEL, trim], [TYPE, SMARTTV]], [/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i // SmartTV from Unidentified Vendors
	      ], [[TYPE, SMARTTV]], [///////////////////
	      // WEARABLES
	      ///////////////////
	      /((pebble))app/i // Pebble
	      ], [VENDOR, MODEL, [TYPE, WEARABLE]], [/droid.+; (glass) \d/i // Google Glass
	      ], [MODEL, [VENDOR, GOOGLE], [TYPE, WEARABLE]], [/droid.+; (wt63?0{2,3})\)/i], [MODEL, [VENDOR, ZEBRA], [TYPE, WEARABLE]], [///////////////////
	      // EMBEDDED
	      ///////////////////
	      /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i // Tesla
	      ], [VENDOR, [TYPE, EMBEDDED]], [////////////////////
	      // MIXED (GENERIC)
	      ///////////////////
	      /droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i // Android Phones from Unidentified Vendors
	      ], [MODEL, [TYPE, MOBILE]], [/droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i // Android Tablets from Unidentified Vendors
	      ], [MODEL, [TYPE, TABLET]], [/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i // Unidentifiable Tablet
	      ], [[TYPE, TABLET]], [/(phone|mobile(?:[;\/]| safari)|pda(?=.+windows ce))/i // Unidentifiable Mobile
	      ], [[TYPE, MOBILE]], [/(android[-\w\. ]{0,9});.+buil/i // Generic Android Device
	      ], [MODEL, [VENDOR, 'Generic']]],
	      engine: [[/windows.+ edge\/([\w\.]+)/i // EdgeHTML
	      ], [VERSION, [NAME, EDGE + 'HTML']], [/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i // Blink
	      ], [VERSION, [NAME, 'Blink']], [/(presto)\/([\w\.]+)/i, // Presto
	      /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i, // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
	      /ekioh(flow)\/([\w\.]+)/i, // Flow
	      /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i, // KHTML/Tasman/Links
	      /(icab)[\/ ]([23]\.[\d\.]+)/i // iCab
	      ], [NAME, VERSION], [/rv\:([\w\.]{1,9})\b.+(gecko)/i // Gecko
	      ], [VERSION, NAME]],
	      os: [[// Windows
	      /microsoft (windows) (vista|xp)/i // Windows (iTunes)
	      ], [NAME, VERSION], [/(windows) nt 6\.2; (arm)/i, // Windows RT
	      /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i, // Windows Phone
	      /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i], [NAME, [VERSION, strMapper, windowsVersionMap]], [/(win(?=3|9|n)|win 9x )([nt\d\.]+)/i], [[NAME, 'Windows'], [VERSION, strMapper, windowsVersionMap]], [// iOS/macOS
	      /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i, // iOS
	      /cfnetwork\/.+darwin/i], [[VERSION, /_/g, '.'], [NAME, 'iOS']], [/(mac os x) ?([\w\. ]*)/i, /(macintosh|mac_powerpc\b)(?!.+haiku)/i // Mac OS
	      ], [[NAME, 'Mac OS'], [VERSION, /_/g, '.']], [// Mobile OSes
	      /droid ([\w\.]+)\b.+(android[- ]x86)/i // Android-x86
	      ], [VERSION, NAME], [// Android/WebOS/QNX/Bada/RIM/Maemo/MeeGo/Sailfish OS
	      /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i, /(blackberry)\w*\/([\w\.]*)/i, // Blackberry
	      /(tizen|kaios)[\/ ]([\w\.]+)/i, // Tizen/KaiOS
	      /\((series40);/i // Series 40
	      ], [NAME, VERSION], [/\(bb(10);/i // BlackBerry 10
	      ], [VERSION, [NAME, BLACKBERRY]], [/(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i // Symbian
	      ], [VERSION, [NAME, 'Symbian']], [/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i // Firefox OS
	      ], [VERSION, [NAME, FIREFOX + ' OS']], [/web0s;.+rt(tv)/i, /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i // WebOS
	      ], [VERSION, [NAME, 'webOS']], [// Google Chromecast
	      /crkey\/([\d\.]+)/i // Google Chromecast
	      ], [VERSION, [NAME, CHROME + 'cast']], [/(cros) [\w]+ ([\w\.]+\w)/i // Chromium OS
	      ], [[NAME, 'Chromium OS'], VERSION], [// Console
	      /(nintendo|playstation) ([wids345portablevuch]+)/i, // Nintendo/Playstation
	      /(xbox); +xbox ([^\);]+)/i, // Microsoft Xbox (360, One, X, S, Series X, Series S)
	      // Other
	      /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i, // Joli/Palm
	      /(mint)[\/\(\) ]?(\w*)/i, // Mint
	      /(mageia|vectorlinux)[; ]/i, // Mageia/VectorLinux
	      /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i, // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
	      /(hurd|linux) ?([\w\.]*)/i, // Hurd/Linux
	      /(gnu) ?([\w\.]*)/i, // GNU
	      /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i, // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
	      /(haiku) (\w+)/i // Haiku
	      ], [NAME, VERSION], [/(sunos) ?([\w\.\d]*)/i // Solaris
	      ], [[NAME, 'Solaris'], VERSION], [/((?:open)?solaris)[-\/ ]?([\w\.]*)/i, // Solaris
	      /(aix) ((\d)(?=\.|\)| )[\w\.])*/i, // AIX
	      /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux)/i, // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX
	      /(unix) ?([\w\.]*)/i // UNIX
	      ], [NAME, VERSION]]
	    }; /////////////////
	    // Constructor
	    ////////////////

	    var UAParser = function (ua, extensions) {
	      if (typeof ua === OBJ_TYPE) {
	        extensions = ua;
	        ua = undefined$1;
	      }

	      if (!(this instanceof UAParser)) {
	        return new UAParser(ua, extensions).getResult();
	      }

	      var _ua = ua || (typeof window !== UNDEF_TYPE && window.navigator && window.navigator.userAgent ? window.navigator.userAgent : EMPTY);

	      var _rgxmap = extensions ? extend(regexes, extensions) : regexes;

	      this.getBrowser = function () {
	        var _browser = {};
	        _browser[NAME] = undefined$1;
	        _browser[VERSION] = undefined$1;
	        rgxMapper.call(_browser, _ua, _rgxmap.browser);
	        _browser.major = majorize(_browser.version);
	        return _browser;
	      };

	      this.getCPU = function () {
	        var _cpu = {};
	        _cpu[ARCHITECTURE] = undefined$1;
	        rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
	        return _cpu;
	      };

	      this.getDevice = function () {
	        var _device = {};
	        _device[VENDOR] = undefined$1;
	        _device[MODEL] = undefined$1;
	        _device[TYPE] = undefined$1;
	        rgxMapper.call(_device, _ua, _rgxmap.device);
	        return _device;
	      };

	      this.getEngine = function () {
	        var _engine = {};
	        _engine[NAME] = undefined$1;
	        _engine[VERSION] = undefined$1;
	        rgxMapper.call(_engine, _ua, _rgxmap.engine);
	        return _engine;
	      };

	      this.getOS = function () {
	        var _os = {};
	        _os[NAME] = undefined$1;
	        _os[VERSION] = undefined$1;
	        rgxMapper.call(_os, _ua, _rgxmap.os);
	        return _os;
	      };

	      this.getResult = function () {
	        return {
	          ua: this.getUA(),
	          browser: this.getBrowser(),
	          engine: this.getEngine(),
	          os: this.getOS(),
	          device: this.getDevice(),
	          cpu: this.getCPU()
	        };
	      };

	      this.getUA = function () {
	        return _ua;
	      };

	      this.setUA = function (ua) {
	        _ua = typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH ? trim(ua, UA_MAX_LENGTH) : ua;
	        return this;
	      };

	      this.setUA(_ua);
	      return this;
	    };

	    UAParser.VERSION = LIBVERSION;
	    UAParser.BROWSER = enumerize([NAME, VERSION, MAJOR]);
	    UAParser.CPU = enumerize([ARCHITECTURE]);
	    UAParser.DEVICE = enumerize([MODEL, VENDOR, TYPE, CONSOLE, MOBILE, SMARTTV, TABLET, WEARABLE, EMBEDDED]);
	    UAParser.ENGINE = UAParser.OS = enumerize([NAME, VERSION]); ///////////
	    // Export
	    //////////
	    // check js environment

	    {
	      // nodejs env
	      if (module.exports) {
	        exports = module.exports = UAParser;
	      }

	      exports.UAParser = UAParser;
	    } // jQuery/Zepto specific (optional)
	    // Note:
	    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
	    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
	    //   and we should catch that.


	    var $ = typeof window !== UNDEF_TYPE && (window.jQuery || window.Zepto);

	    if ($ && !$.ua) {
	      var parser = new UAParser();
	      $.ua = parser.getResult();

	      $.ua.get = function () {
	        return parser.getUA();
	      };

	      $.ua.set = function (ua) {
	        parser.setUA(ua);
	        var result = parser.getResult();

	        for (var prop in result) {
	          $.ua[prop] = result[prop];
	        }
	      };
	    }
	  })(typeof window === 'object' ? window : commonjsGlobal);
	});

	var ApplicationContextProviderImpl = /** @class */ (function () {
	    function ApplicationContextProviderImpl() {
	        this.ua = new uaParser.UAParser(navigator.userAgent).getResult();
	    }
	    ApplicationContextProviderImpl.prototype.getApplicationContext = function () {
	        return {
	            versionName: this.versionName,
	            language: getLanguage(),
	            platform: 'Web',
	            os: getOs(this.ua),
	            deviceModel: getDeviceModel(this.ua),
	        };
	    };
	    return ApplicationContextProviderImpl;
	}());
	var getOs = function (ua) {
	    var _a, _b;
	    return [(_a = ua.browser) === null || _a === void 0 ? void 0 : _a.name, (_b = ua.browser) === null || _b === void 0 ? void 0 : _b.major]
	        .filter(function (e) { return e !== null && e !== undefined; })
	        .join(' ');
	};
	var getDeviceModel = function (ua) {
	    var _a;
	    return (_a = ua.os) === null || _a === void 0 ? void 0 : _a.name;
	};
	var getLanguage = function () {
	    return ((typeof navigator !== 'undefined' &&
	        ((navigator.languages && navigator.languages[0]) ||
	            navigator.language)) ||
	        '');
	};

	var EventBridgeImpl = /** @class */ (function () {
	    function EventBridgeImpl() {
	        this.queue = [];
	    }
	    EventBridgeImpl.prototype.logEvent = function (event) {
	        if (!this.receiver) {
	            if (this.queue.length < 512) {
	                this.queue.push(event);
	            }
	        }
	        else {
	            this.receiver(event);
	        }
	    };
	    EventBridgeImpl.prototype.setEventReceiver = function (receiver) {
	        this.receiver = receiver;
	        if (this.queue.length > 0) {
	            this.queue.forEach(function (event) {
	                receiver(event);
	            });
	            this.queue = [];
	        }
	    };
	    return EventBridgeImpl;
	}());

	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation.

	Permission to use, copy, modify, and/or distribute this software for any
	purpose with or without fee is hereby granted.

	THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	PERFORMANCE OF THIS SOFTWARE.
	***************************************************************************** */
	var __assign = function () {
	  __assign = Object.assign || function __assign(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	      s = arguments[i];

	      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	    }

	    return t;
	  };

	  return __assign.apply(this, arguments);
	};

	var ID_OP_SET = '$set';
	var ID_OP_UNSET = '$unset';
	var ID_OP_CLEAR_ALL = '$clearAll';
	var IdentityStoreImpl = /** @class */ (function () {
	    function IdentityStoreImpl() {
	        this.identity = { userProperties: {} };
	        this.listeners = new Set();
	    }
	    IdentityStoreImpl.prototype.editIdentity = function () {
	        // eslint-disable-next-line @typescript-eslint/no-this-alias
	        var self = this;
	        var actingUserProperties = __assign({}, this.identity.userProperties);
	        var actingIdentity = __assign(__assign({}, this.identity), { userProperties: actingUserProperties });
	        return {
	            setUserId: function (userId) {
	                actingIdentity.userId = userId;
	                return this;
	            },
	            setDeviceId: function (deviceId) {
	                actingIdentity.deviceId = deviceId;
	                return this;
	            },
	            setUserProperties: function (userProperties) {
	                actingIdentity.userProperties = userProperties;
	                return this;
	            },
	            updateUserProperties: function (actions) {
	                var actingProperties = actingIdentity.userProperties || {};
	                for (var _i = 0, _a = Object.entries(actions); _i < _a.length; _i++) {
	                    var _b = _a[_i], action = _b[0], properties = _b[1];
	                    switch (action) {
	                        case ID_OP_SET:
	                            for (var _c = 0, _d = Object.entries(properties); _c < _d.length; _c++) {
	                                var _e = _d[_c], key = _e[0], value = _e[1];
	                                actingProperties[key] = value;
	                            }
	                            break;
	                        case ID_OP_UNSET:
	                            for (var _f = 0, _g = Object.keys(properties); _f < _g.length; _f++) {
	                                var key = _g[_f];
	                                delete actingProperties[key];
	                            }
	                            break;
	                        case ID_OP_CLEAR_ALL:
	                            actingProperties = {};
	                            break;
	                    }
	                }
	                actingIdentity.userProperties = actingProperties;
	                return this;
	            },
	            commit: function () {
	                self.setIdentity(actingIdentity);
	                return this;
	            },
	        };
	    };
	    IdentityStoreImpl.prototype.getIdentity = function () {
	        return __assign({}, this.identity);
	    };
	    IdentityStoreImpl.prototype.setIdentity = function (identity) {
	        var originalIdentity = __assign({}, this.identity);
	        this.identity = __assign({}, identity);
	        if (!isEqual(originalIdentity, this.identity)) {
	            this.listeners.forEach(function (listener) {
	                listener(identity);
	            });
	        }
	    };
	    IdentityStoreImpl.prototype.addIdentityListener = function (listener) {
	        this.listeners.add(listener);
	    };
	    IdentityStoreImpl.prototype.removeIdentityListener = function (listener) {
	        this.listeners.delete(listener);
	    };
	    return IdentityStoreImpl;
	}());
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	var isEqual = function (obj1, obj2) {
	    var primitive = ['string', 'number', 'boolean', 'undefined'];
	    var typeA = typeof obj1;
	    var typeB = typeof obj2;
	    if (typeA !== typeB) {
	        return false;
	    }
	    if (primitive.includes(typeA)) {
	        return obj1 === obj2;
	    }
	    //if got here - objects
	    if (obj1.length !== obj2.length) {
	        return false;
	    }
	    //check if arrays
	    var isArrayA = Array.isArray(obj1);
	    var isArrayB = Array.isArray(obj2);
	    if (isArrayA !== isArrayB) {
	        return false;
	    }
	    if (isArrayA && isArrayB) {
	        //arrays
	        for (var i = 0; i < obj1.length; i++) {
	            if (!isEqual(obj1[i], obj2[i])) {
	                return false;
	            }
	        }
	    }
	    else {
	        //objects
	        var sorted1 = Object.keys(obj1).sort();
	        var sorted2 = Object.keys(obj2).sort();
	        if (!isEqual(sorted1, sorted2)) {
	            return false;
	        }
	        //compare object values
	        var result_1 = true;
	        Object.keys(obj1).forEach(function (key) {
	            if (!isEqual(obj1[key], obj2[key])) {
	                result_1 = false;
	            }
	        });
	        return result_1;
	    }
	    return true;
	};

	var safeGlobal = typeof globalThis !== 'undefined' ? globalThis : __webpack_require__.g || self;

	safeGlobal['analyticsConnectorInstances'] = {};
	var AnalyticsConnector = /** @class */ (function () {
	    function AnalyticsConnector() {
	        this.identityStore = new IdentityStoreImpl();
	        this.eventBridge = new EventBridgeImpl();
	        this.applicationContextProvider = new ApplicationContextProviderImpl();
	    }
	    AnalyticsConnector.getInstance = function (instanceName) {
	        if (!safeGlobal['analyticsConnectorInstances'][instanceName]) {
	            safeGlobal['analyticsConnectorInstances'][instanceName] =
	                new AnalyticsConnector();
	        }
	        return safeGlobal['analyticsConnectorInstances'][instanceName];
	    };
	    return AnalyticsConnector;
	}());

	exports.AnalyticsConnector = AnalyticsConnector;

	Object.defineProperty(exports, '__esModule', { value: true });

}));


/***/ }),

/***/ 29293:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/////////////////////////////////////////////////////////////////////////////////
/* UAParser.js v0.7.28
   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
   MIT License *//*
   Detect Browser, Engine, OS, CPU, and Device type/model from User-Agent data.
   Supports browser & node.js environment. 
   Demo   : https://faisalman.github.io/ua-parser-js
   Source : https://github.com/faisalman/ua-parser-js */
/////////////////////////////////////////////////////////////////////////////////

(function (window, undefined) {

    'use strict';

    //////////////
    // Constants
    /////////////


    var LIBVERSION  = '0.7.28',
        EMPTY       = '',
        UNKNOWN     = '?',
        FUNC_TYPE   = 'function',
        UNDEF_TYPE  = 'undefined',
        OBJ_TYPE    = 'object',
        STR_TYPE    = 'string',
        MAJOR       = 'major',
        MODEL       = 'model',
        NAME        = 'name',
        TYPE        = 'type',
        VENDOR      = 'vendor',
        VERSION     = 'version',
        ARCHITECTURE= 'architecture',
        CONSOLE     = 'console',
        MOBILE      = 'mobile',
        TABLET      = 'tablet',
        SMARTTV     = 'smarttv',
        WEARABLE    = 'wearable',
        EMBEDDED    = 'embedded',
        UA_MAX_LENGTH = 255;

    var AMAZON  = 'Amazon',
        APPLE   = 'Apple',
        ASUS    = 'ASUS',
        BLACKBERRY = 'BlackBerry',
        BROWSER = 'Browser',
        CHROME  = 'Chrome',
        EDGE    = 'Edge',
        FIREFOX = 'Firefox',
        GOOGLE  = 'Google',
        HUAWEI  = 'Huawei',
        LG      = 'LG',
        MICROSOFT = 'Microsoft',
        MOTOROLA  = 'Motorola',
        OPERA   = 'Opera',
        SAMSUNG = 'Samsung',
        SONY    = 'Sony',
        XIAOMI  = 'Xiaomi',
        ZEBRA   = 'Zebra';

    ///////////
    // Helper
    //////////

    var extend = function (regexes, extensions) {
            var mergedRegexes = {};
            for (var i in regexes) {
                if (extensions[i] && extensions[i].length % 2 === 0) {
                    mergedRegexes[i] = extensions[i].concat(regexes[i]);
                } else {
                    mergedRegexes[i] = regexes[i];
                }
            }
            return mergedRegexes;
        },
        enumerize = function (arr) {
            var enums = {};
            for (var i = 0; i < arr.length; i++) {
                enums[arr[i].toUpperCase()] = arr[i];
            }
            return enums;
        },
        has = function (str1, str2) {
            return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
        },
        lowerize = function (str) {
            return str.toLowerCase();
        },
        majorize = function (version) {
            return typeof(version) === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split('.')[0] : undefined;
        },
        trim = function (str, len) {
            if (typeof(str) === STR_TYPE) {
                str = str.replace(/^\s+|\s+$/g, EMPTY);
                return typeof(len) === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
            }
    };

    ///////////////
    // Map helper
    //////////////

    var rgxMapper = function (ua, arrays) {

            var i = 0, j, k, p, q, matches, match;

            // loop through all regexes maps
            while (i < arrays.length && !matches) {

                var regex = arrays[i],       // even sequence (0,2,4,..)
                    props = arrays[i + 1];   // odd sequence (1,3,5,..)
                j = k = 0;

                // try matching uastring with regexes
                while (j < regex.length && !matches) {

                    matches = regex[j++].exec(ua);

                    if (!!matches) {
                        for (p = 0; p < props.length; p++) {
                            match = matches[++k];
                            q = props[p];
                            // check if given property is actually array
                            if (typeof q === OBJ_TYPE && q.length > 0) {
                                if (q.length == 2) {
                                    if (typeof q[1] == FUNC_TYPE) {
                                        // assign modified match
                                        this[q[0]] = q[1].call(this, match);
                                    } else {
                                        // assign given value, ignore regex match
                                        this[q[0]] = q[1];
                                    }
                                } else if (q.length == 3) {
                                    // check whether function or regex
                                    if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                                        // call function (usually string mapper)
                                        this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                                    } else {
                                        // sanitize match using given regex
                                        this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                                    }
                                } else if (q.length == 4) {
                                        this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                                }
                            } else {
                                this[q] = match ? match : undefined;
                            }
                        }
                    }
                }
                i += 2;
            }
        },

        strMapper = function (str, map) {

            for (var i in map) {
                // check if current value is array
                if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
                    for (var j = 0; j < map[i].length; j++) {
                        if (has(map[i][j], str)) {
                            return (i === UNKNOWN) ? undefined : i;
                        }
                    }
                } else if (has(map[i], str)) {
                    return (i === UNKNOWN) ? undefined : i;
                }
            }
            return str;
    };

    ///////////////
    // String map
    //////////////

    // Safari < 3.0
    var oldSafariMap = {
            '1.0'   : '/8',
            '1.2'   : '/1',
            '1.3'   : '/3',
            '2.0'   : '/412',
            '2.0.2' : '/416',
            '2.0.3' : '/417',
            '2.0.4' : '/419',
            '?'     : '/'
        },
        windowsVersionMap = {
            'ME'        : '4.90',
            'NT 3.11'   : 'NT3.51',
            'NT 4.0'    : 'NT4.0',
            '2000'      : 'NT 5.0',
            'XP'        : ['NT 5.1', 'NT 5.2'],
            'Vista'     : 'NT 6.0',
            '7'         : 'NT 6.1',
            '8'         : 'NT 6.2',
            '8.1'       : 'NT 6.3',
            '10'        : ['NT 6.4', 'NT 10.0'],
            'RT'        : 'ARM'
    };

    //////////////
    // Regex map
    /////////////

    var regexes = {

        browser : [[

            /\b(?:crmo|crios)\/([\w\.]+)/i                                      // Chrome for Android/iOS
            ], [VERSION, [NAME, 'Chrome']], [
            /edg(?:e|ios|a)?\/([\w\.]+)/i                                       // Microsoft Edge
            ], [VERSION, [NAME, 'Edge']], [

            // Presto based
            /(opera mini)\/([-\w\.]+)/i,                                        // Opera Mini
            /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,                 // Opera Mobi/Tablet
            /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i                           // Opera
            ], [NAME, VERSION], [
            /opios[\/ ]+([\w\.]+)/i                                             // Opera mini on iphone >= 8.0
            ], [VERSION, [NAME, OPERA+' Mini']], [
            /\bopr\/([\w\.]+)/i                                                 // Opera Webkit
            ], [VERSION, [NAME, OPERA]], [

            // Mixed
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,      // Lunascape/Maxthon/Netfront/Jasmine/Blazer
            // Trident based
            /(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i,               // Avant/IEMobile/SlimBrowser
            /(ba?idubrowser)[\/ ]?([\w\.]+)/i,                                  // Baidu Browser
            /(?:ms|\()(ie) ([\w\.]+)/i,                                         // Internet Explorer

            // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
            /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale|qqbrowserlite|qq)\/([-\w\.]+)/i,
                                                                                // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
            /(weibo)__([\d\.]+)/i                                               // Weibo
            ], [NAME, VERSION], [
            /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i                 // UCBrowser
            ], [VERSION, [NAME, 'UC'+BROWSER]], [
            /\bqbcore\/([\w\.]+)/i                                              // WeChat Desktop for Windows Built-in Browser
            ], [VERSION, [NAME, 'WeChat(Win) Desktop']], [
            /micromessenger\/([\w\.]+)/i                                        // WeChat
            ], [VERSION, [NAME, 'WeChat']], [
            /konqueror\/([\w\.]+)/i                                             // Konqueror
            ], [VERSION, [NAME, 'Konqueror']], [
            /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i                       // IE11
            ], [VERSION, [NAME, 'IE']], [
            /yabrowser\/([\w\.]+)/i                                             // Yandex
            ], [VERSION, [NAME, 'Yandex']], [
            /(avast|avg)\/([\w\.]+)/i                                           // Avast/AVG Secure Browser
            ], [[NAME, /(.+)/, '$1 Secure '+BROWSER], VERSION], [
            /\bfocus\/([\w\.]+)/i                                               // Firefox Focus
            ], [VERSION, [NAME, FIREFOX+' Focus']], [
            /\bopt\/([\w\.]+)/i                                                 // Opera Touch
            ], [VERSION, [NAME, OPERA+' Touch']], [
            /coc_coc\w+\/([\w\.]+)/i                                            // Coc Coc Browser
            ], [VERSION, [NAME, 'Coc Coc']], [
            /dolfin\/([\w\.]+)/i                                                // Dolphin
            ], [VERSION, [NAME, 'Dolphin']], [
            /coast\/([\w\.]+)/i                                                 // Opera Coast
            ], [VERSION, [NAME, OPERA+' Coast']], [
            /miuibrowser\/([\w\.]+)/i                                           // MIUI Browser
            ], [VERSION, [NAME, 'MIUI '+BROWSER]], [
            /fxios\/([-\w\.]+)/i                                                // Firefox for iOS
            ], [VERSION, [NAME, FIREFOX]], [
            /\bqihu|(qi?ho?o?|360)browser/i                                     // 360
            ], [[NAME, '360 '+BROWSER]], [
            /(oculus|samsung|sailfish)browser\/([\w\.]+)/i
            ], [[NAME, /(.+)/, '$1 '+BROWSER], VERSION], [                      // Oculus/Samsung/Sailfish Browser
            /(comodo_dragon)\/([\w\.]+)/i                                       // Comodo Dragon
            ], [[NAME, /_/g, ' '], VERSION], [
            /(electron)\/([\w\.]+) safari/i,                                    // Electron-based App
            /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,                   // Tesla
            /m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i            // QQBrowser/Baidu App/2345 Browser
            ], [NAME, VERSION], [
            /(metasr)[\/ ]?([\w\.]+)/i,                                         // SouGouBrowser
            /(lbbrowser)/i                                                      // LieBao Browser
            ], [NAME], [

            // WebView
            /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i       // Facebook App for iOS & Android
            ], [[NAME, 'Facebook'], VERSION], [
            /safari (line)\/([\w\.]+)/i,                                        // Line App for iOS
            /\b(line)\/([\w\.]+)\/iab/i,                                        // Line App for Android
            /(chromium|instagram)[\/ ]([-\w\.]+)/i                              // Chromium/Instagram
            ], [NAME, VERSION], [
            /\bgsa\/([\w\.]+) .*safari\//i                                      // Google Search Appliance on iOS
            ], [VERSION, [NAME, 'GSA']], [

            /headlesschrome(?:\/([\w\.]+)| )/i                                  // Chrome Headless
            ], [VERSION, [NAME, CHROME+' Headless']], [

            / wv\).+(chrome)\/([\w\.]+)/i                                       // Chrome WebView
            ], [[NAME, CHROME+' WebView'], VERSION], [

            /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i           // Android Browser
            ], [VERSION, [NAME, 'Android '+BROWSER]], [

            /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i       // Chrome/OmniWeb/Arora/Tizen/Nokia
            ], [NAME, VERSION], [

            /version\/([\w\.]+) .*mobile\/\w+ (safari)/i                        // Mobile Safari
            ], [VERSION, [NAME, 'Mobile Safari']], [
            /version\/([\w\.]+) .*(mobile ?safari|safari)/i                     // Safari & Safari Mobile
            ], [VERSION, NAME], [
            /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i                      // Safari < 3.0
            ], [NAME, [VERSION, strMapper, oldSafariMap]], [

            /(webkit|khtml)\/([\w\.]+)/i
            ], [NAME, VERSION], [

            // Gecko based
            /(navigator|netscape\d?)\/([-\w\.]+)/i                              // Netscape
            ], [[NAME, 'Netscape'], VERSION], [
            /mobile vr; rv:([\w\.]+)\).+firefox/i                               // Firefox Reality
            ], [VERSION, [NAME, FIREFOX+' Reality']], [
            /ekiohf.+(flow)\/([\w\.]+)/i,                                       // Flow
            /(swiftfox)/i,                                                      // Swiftfox
            /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
                                                                                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
            /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                                                                                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
            /(firefox)\/([\w\.]+)/i,                                            // Other Firefox-based
            /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,                         // Mozilla

            // Other
            /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                                                                                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
            /(links) \(([\w\.]+)/i                                              // Links
            ], [NAME, VERSION]
        ],

        cpu : [[

            /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i                     // AMD64 (x64)
            ], [[ARCHITECTURE, 'amd64']], [

            /(ia32(?=;))/i                                                      // IA32 (quicktime)
            ], [[ARCHITECTURE, lowerize]], [

            /((?:i[346]|x)86)[;\)]/i                                            // IA32 (x86)
            ], [[ARCHITECTURE, 'ia32']], [

            /\b(aarch64|arm(v?8e?l?|_?64))\b/i                                 // ARM64
            ], [[ARCHITECTURE, 'arm64']], [

            /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i                                   // ARMHF
            ], [[ARCHITECTURE, 'armhf']], [

            // PocketPC mistakenly identified as PowerPC
            /windows (ce|mobile); ppc;/i
            ], [[ARCHITECTURE, 'arm']], [

            /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i                            // PowerPC
            ], [[ARCHITECTURE, /ower/, EMPTY, lowerize]], [

            /(sun4\w)[;\)]/i                                                    // SPARC
            ], [[ARCHITECTURE, 'sparc']], [

            /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
                                                                                // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
            ], [[ARCHITECTURE, lowerize]]
        ],

        device : [[

            //////////////////////////
            // MOBILES & TABLETS
            // Ordered by popularity
            /////////////////////////

            // Samsung
            /\b(sch-i[89]0\d|shw-m380s|sm-[pt]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ], [MODEL, [VENDOR, SAMSUNG], [TYPE, TABLET]], [
            /\b((?:s[cgp]h|gt|sm)-\w+|galaxy nexus)/i,
            /samsung[- ]([-\w]+)/i,
            /sec-(sgh\w+)/i
            ], [MODEL, [VENDOR, SAMSUNG], [TYPE, MOBILE]], [

            // Apple
            /((ipod|iphone)\d+,\d+)/i                                           // iPod/iPhone model
            ], [MODEL, [VENDOR, APPLE], [TYPE, MOBILE]], [
            /(ipad\d+,\d+)/i                                                    // iPad model
            ], [MODEL, [VENDOR, APPLE], [TYPE, TABLET]], [
            /\((ip(?:hone|od)[\w ]*);/i                                         // iPod/iPhone
            ], [MODEL, [VENDOR, APPLE], [TYPE, MOBILE]], [
            /\((ipad);[-\w\),; ]+apple/i,                                       // iPad
            /applecoremedia\/[\w\.]+ \((ipad)/i,
            /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ], [MODEL, [VENDOR, APPLE], [TYPE, TABLET]], [

            // Huawei
            /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
            ], [MODEL, [VENDOR, HUAWEI], [TYPE, TABLET]], [
            /(?:huawei|honor)([-\w ]+)[;\)]/i,
            /\b(nexus 6p|\w{2,4}-[atu]?[ln][01259x][012359][an]?)\b(?!.+d\/s)/i
            ], [MODEL, [VENDOR, HUAWEI], [TYPE, MOBILE]], [

            // Xiaomi
            /\b(poco[\w ]+)(?: bui|\))/i,                                       // Xiaomi POCO
            /\b; (\w+) build\/hm\1/i,                                           // Xiaomi Hongmi 'numeric' models
            /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,                             // Xiaomi Hongmi
            /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,                   // Xiaomi Redmi
            /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i // Xiaomi Mi
            ], [[MODEL, /_/g, ' '], [VENDOR, XIAOMI], [TYPE, MOBILE]], [
            /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i                        // Mi Pad tablets
            ],[[MODEL, /_/g, ' '], [VENDOR, XIAOMI], [TYPE, TABLET]], [

            // OPPO
            /; (\w+) bui.+ oppo/i,
            /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007)\b/i
            ], [MODEL, [VENDOR, 'OPPO'], [TYPE, MOBILE]], [

            // Vivo
            /vivo (\w+)(?: bui|\))/i,
            /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ], [MODEL, [VENDOR, 'Vivo'], [TYPE, MOBILE]], [

            // Realme
            /\b(rmx[12]\d{3})(?: bui|;|\))/i
            ], [MODEL, [VENDOR, 'Realme'], [TYPE, MOBILE]], [

            // Motorola
            /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
            /\bmot(?:orola)?[- ](\w*)/i,
            /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ], [MODEL, [VENDOR, MOTOROLA], [TYPE, MOBILE]], [
            /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ], [MODEL, [VENDOR, MOTOROLA], [TYPE, TABLET]], [

            // LG
            /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ], [MODEL, [VENDOR, LG], [TYPE, TABLET]], [
            /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
            /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
            /\blg-?([\d\w]+) bui/i
            ], [MODEL, [VENDOR, LG], [TYPE, MOBILE]], [

            // Lenovo
            /(ideatab[-\w ]+)/i,
            /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
            ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [

            // Nokia
            /(?:maemo|nokia).*(n900|lumia \d+)/i,
            /nokia[-_ ]?([-\w\.]*)/i
            ], [[MODEL, /_/g, ' '], [VENDOR, 'Nokia'], [TYPE, MOBILE]], [

            // Google
            /(pixel c)\b/i                                                      // Google Pixel C
            ], [MODEL, [VENDOR, GOOGLE], [TYPE, TABLET]], [
            /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i                         // Google Pixel
            ], [MODEL, [VENDOR, GOOGLE], [TYPE, MOBILE]], [

            // Sony
            /droid.+ ([c-g]\d{4}|so[-l]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ], [MODEL, [VENDOR, SONY], [TYPE, MOBILE]], [
            /sony tablet [ps]/i,
            /\b(?:sony)?sgp\w+(?: bui|\))/i
            ], [[MODEL, 'Xperia Tablet'], [VENDOR, SONY], [TYPE, TABLET]], [

            // OnePlus
            / (kb2005|in20[12]5|be20[12][59])\b/i,
            /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [

            // Amazon
            /(alexa)webm/i,
            /(kf[a-z]{2}wi)( bui|\))/i,                                         // Kindle Fire without Silk
            /(kf[a-z]+)( bui|\)).+silk\//i                                      // Kindle Fire HD
            ], [MODEL, [VENDOR, AMAZON], [TYPE, TABLET]], [
            /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i                     // Fire Phone
            ], [[MODEL, /(.+)/g, 'Fire Phone $1'], [VENDOR, AMAZON], [TYPE, MOBILE]], [

            // BlackBerry
            /(playbook);[-\w\),; ]+(rim)/i                                      // BlackBerry PlayBook
            ], [MODEL, VENDOR, [TYPE, TABLET]], [
            /\b((?:bb[a-f]|st[hv])100-\d)/i,
            /\(bb10; (\w+)/i                                                    // BlackBerry 10
            ], [MODEL, [VENDOR, BLACKBERRY], [TYPE, MOBILE]], [

            // Asus
            /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ], [MODEL, [VENDOR, ASUS], [TYPE, TABLET]], [
            / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ], [MODEL, [VENDOR, ASUS], [TYPE, MOBILE]], [

            // HTC
            /(nexus 9)/i                                                        // HTC Nexus 9
            ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [
            /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,                         // HTC

            // ZTE
            /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
            /(alcatel|geeksphone|nexian|panasonic|sony)[-_ ]?([-\w]*)/i         // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
            ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [

            // Acer
            /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [

            // Meizu
            /droid.+; (m[1-5] note) bui/i,
            /\bmz-([-\w]{2,})/i
            ], [MODEL, [VENDOR, 'Meizu'], [TYPE, MOBILE]], [

            // Sharp
            /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ], [MODEL, [VENDOR, 'Sharp'], [TYPE, MOBILE]], [

            // MIXED
            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i,
                                                                                // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
            /(hp) ([\w ]+\w)/i,                                                 // HP iPAQ
            /(asus)-?(\w+)/i,                                                   // Asus
            /(microsoft); (lumia[\w ]+)/i,                                      // Microsoft Lumia
            /(lenovo)[-_ ]?([-\w]+)/i,                                          // Lenovo
            /(jolla)/i,                                                         // Jolla
            /(oppo) ?([\w ]+) bui/i                                             // OPPO
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /(archos) (gamepad2?)/i,                                            // Archos
            /(hp).+(touchpad(?!.+tablet)|tablet)/i,                             // HP TouchPad
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /(nook)[\w ]+build\/(\w+)/i,                                        // Nook
            /(dell) (strea[kpr\d ]*[\dko])/i,                                   // Dell Streak
            /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,                                  // Le Pan Tablets
            /(trinity)[- ]*(t\d{3}) bui/i,                                      // Trinity Tablets
            /(gigaset)[- ]+(q\w{1,9}) bui/i,                                    // Gigaset Tablets
            /(vodafone) ([\w ]+)(?:\)| bui)/i                                   // Vodafone
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /(surface duo)/i                                                    // Surface Duo
            ], [MODEL, [VENDOR, MICROSOFT], [TYPE, TABLET]], [
            /droid [\d\.]+; (fp\du?)(?: b|\))/i                                 // Fairphone
            ], [MODEL, [VENDOR, 'Fairphone'], [TYPE, MOBILE]], [
            /(u304aa)/i                                                         // AT&T
            ], [MODEL, [VENDOR, 'AT&T'], [TYPE, MOBILE]], [
            /\bsie-(\w*)/i                                                      // Siemens
            ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [
            /\b(rct\w+) b/i                                                     // RCA Tablets
            ], [MODEL, [VENDOR, 'RCA'], [TYPE, TABLET]], [
            /\b(venue[\d ]{2,7}) b/i                                            // Dell Venue Tablets
            ], [MODEL, [VENDOR, 'Dell'], [TYPE, TABLET]], [
            /\b(q(?:mv|ta)\w+) b/i                                              // Verizon Tablet
            ], [MODEL, [VENDOR, 'Verizon'], [TYPE, TABLET]], [
            /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i                       // Barnes & Noble Tablet
            ], [MODEL, [VENDOR, 'Barnes & Noble'], [TYPE, TABLET]], [
            /\b(tm\d{3}\w+) b/i
            ], [MODEL, [VENDOR, 'NuVision'], [TYPE, TABLET]], [
            /\b(k88) b/i                                                        // ZTE K Series Tablet
            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, TABLET]], [
            /\b(nx\d{3}j) b/i                                                   // ZTE Nubia
            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, MOBILE]], [
            /\b(gen\d{3}) b.+49h/i                                              // Swiss GEN Mobile
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, MOBILE]], [
            /\b(zur\d{3}) b/i                                                   // Swiss ZUR Tablet
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, TABLET]], [
            /\b((zeki)?tb.*\b) b/i                                              // Zeki Tablets
            ], [MODEL, [VENDOR, 'Zeki'], [TYPE, TABLET]], [
            /\b([yr]\d{2}) b/i,
            /\b(dragon[- ]+touch |dt)(\w{5}) b/i                                // Dragon Touch Tablet
            ], [[VENDOR, 'Dragon Touch'], MODEL, [TYPE, TABLET]], [
            /\b(ns-?\w{0,9}) b/i                                                // Insignia Tablets
            ], [MODEL, [VENDOR, 'Insignia'], [TYPE, TABLET]], [
            /\b((nxa|next)-?\w{0,9}) b/i                                        // NextBook Tablets
            ], [MODEL, [VENDOR, 'NextBook'], [TYPE, TABLET]], [
            /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i                  // Voice Xtreme Phones
            ], [[VENDOR, 'Voice'], MODEL, [TYPE, MOBILE]], [
            /\b(lvtel\-)?(v1[12]) b/i                                           // LvTel Phones
            ], [[VENDOR, 'LvTel'], MODEL, [TYPE, MOBILE]], [
            /\b(ph-1) /i                                                        // Essential PH-1
            ], [MODEL, [VENDOR, 'Essential'], [TYPE, MOBILE]], [
            /\b(v(100md|700na|7011|917g).*\b) b/i                               // Envizen Tablets
            ], [MODEL, [VENDOR, 'Envizen'], [TYPE, TABLET]], [
            /\b(trio[-\w\. ]+) b/i                                              // MachSpeed Tablets
            ], [MODEL, [VENDOR, 'MachSpeed'], [TYPE, TABLET]], [
            /\btu_(1491) b/i                                                    // Rotor Tablets
            ], [MODEL, [VENDOR, 'Rotor'], [TYPE, TABLET]], [
            /(shield[\w ]+) b/i                                                 // Nvidia Shield Tablets
            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, TABLET]], [
            /(sprint) (\w+)/i                                                   // Sprint Phones
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /(kin\.[onetw]{3})/i                                                // Microsoft Kin
            ], [[MODEL, /\./g, ' '], [VENDOR, MICROSOFT], [TYPE, MOBILE]], [
            /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i             // Zebra
            ], [MODEL, [VENDOR, ZEBRA], [TYPE, TABLET]], [
            /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ], [MODEL, [VENDOR, ZEBRA], [TYPE, MOBILE]], [

            ///////////////////
            // CONSOLES
            ///////////////////

            /(ouya)/i,                                                          // Ouya
            /(nintendo) ([wids3utch]+)/i                                        // Nintendo
            ], [VENDOR, MODEL, [TYPE, CONSOLE]], [
            /droid.+; (shield) bui/i                                            // Nvidia
            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [
            /(playstation [345portablevi]+)/i                                   // Playstation
            ], [MODEL, [VENDOR, SONY], [TYPE, CONSOLE]], [
            /\b(xbox(?: one)?(?!; xbox))[\); ]/i                                // Microsoft Xbox
            ], [MODEL, [VENDOR, MICROSOFT], [TYPE, CONSOLE]], [

            ///////////////////
            // SMARTTVS
            ///////////////////

            /smart-tv.+(samsung)/i                                              // Samsung
            ], [VENDOR, [TYPE, SMARTTV]], [
            /hbbtv.+maple;(\d+)/i
            ], [[MODEL, /^/, 'SmartTV'], [VENDOR, SAMSUNG], [TYPE, SMARTTV]], [
            /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i        // LG SmartTV
            ], [[VENDOR, LG], [TYPE, SMARTTV]], [
            /(apple) ?tv/i                                                      // Apple TV
            ], [VENDOR, [MODEL, APPLE+' TV'], [TYPE, SMARTTV]], [
            /crkey/i                                                            // Google Chromecast
            ], [[MODEL, CHROME+'cast'], [VENDOR, GOOGLE], [TYPE, SMARTTV]], [
            /droid.+aft(\w)( bui|\))/i                                          // Fire TV
            ], [MODEL, [VENDOR, AMAZON], [TYPE, SMARTTV]], [
            /\(dtv[\);].+(aquos)/i                                              // Sharp
            ], [MODEL, [VENDOR, 'Sharp'], [TYPE, SMARTTV]], [
            /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,                          // Roku
            /hbbtv\/\d+\.\d+\.\d+ +\([\w ]*; *(\w[^;]*);([^;]*)/i               // HbbTV devices
            ], [[VENDOR, trim], [MODEL, trim], [TYPE, SMARTTV]], [
            /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i                   // SmartTV from Unidentified Vendors
            ], [[TYPE, SMARTTV]], [

            ///////////////////
            // WEARABLES
            ///////////////////

            /((pebble))app/i                                                    // Pebble
            ], [VENDOR, MODEL, [TYPE, WEARABLE]], [
            /droid.+; (glass) \d/i                                              // Google Glass
            ], [MODEL, [VENDOR, GOOGLE], [TYPE, WEARABLE]], [
            /droid.+; (wt63?0{2,3})\)/i
            ], [MODEL, [VENDOR, ZEBRA], [TYPE, WEARABLE]], [

            ///////////////////
            // EMBEDDED
            ///////////////////

            /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i                              // Tesla
            ], [VENDOR, [TYPE, EMBEDDED]], [

            ////////////////////
            // MIXED (GENERIC)
            ///////////////////

            /droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i           // Android Phones from Unidentified Vendors
            ], [MODEL, [TYPE, MOBILE]], [
            /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i       // Android Tablets from Unidentified Vendors
            ], [MODEL, [TYPE, TABLET]], [
            /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i                      // Unidentifiable Tablet
            ], [[TYPE, TABLET]], [
            /(phone|mobile(?:[;\/]| safari)|pda(?=.+windows ce))/i              // Unidentifiable Mobile
            ], [[TYPE, MOBILE]], [
            /(android[-\w\. ]{0,9});.+buil/i                                    // Generic Android Device
            ], [MODEL, [VENDOR, 'Generic']]
        ],

        engine : [[

            /windows.+ edge\/([\w\.]+)/i                                       // EdgeHTML
            ], [VERSION, [NAME, EDGE+'HTML']], [

            /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i                         // Blink
            ], [VERSION, [NAME, 'Blink']], [

            /(presto)\/([\w\.]+)/i,                                             // Presto
            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i, // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
            /ekioh(flow)\/([\w\.]+)/i,                                          // Flow
            /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,                           // KHTML/Tasman/Links
            /(icab)[\/ ]([23]\.[\d\.]+)/i                                       // iCab
            ], [NAME, VERSION], [

            /rv\:([\w\.]{1,9})\b.+(gecko)/i                                     // Gecko
            ], [VERSION, NAME]
        ],

        os : [[

            // Windows
            /microsoft (windows) (vista|xp)/i                                   // Windows (iTunes)
            ], [NAME, VERSION], [
            /(windows) nt 6\.2; (arm)/i,                                        // Windows RT
            /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i,            // Windows Phone
            /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i
            ], [NAME, [VERSION, strMapper, windowsVersionMap]], [
            /(win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ], [[NAME, 'Windows'], [VERSION, strMapper, windowsVersionMap]], [

            // iOS/macOS
            /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,              // iOS
            /cfnetwork\/.+darwin/i
            ], [[VERSION, /_/g, '.'], [NAME, 'iOS']], [
            /(mac os x) ?([\w\. ]*)/i,
            /(macintosh|mac_powerpc\b)(?!.+haiku)/i                             // Mac OS
            ], [[NAME, 'Mac OS'], [VERSION, /_/g, '.']], [

            // Mobile OSes
            /droid ([\w\.]+)\b.+(android[- ]x86)/i                              // Android-x86
            ], [VERSION, NAME], [                                               // Android/WebOS/QNX/Bada/RIM/Maemo/MeeGo/Sailfish OS
            /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
            /(blackberry)\w*\/([\w\.]*)/i,                                      // Blackberry
            /(tizen|kaios)[\/ ]([\w\.]+)/i,                                     // Tizen/KaiOS
            /\((series40);/i                                                    // Series 40
            ], [NAME, VERSION], [
            /\(bb(10);/i                                                        // BlackBerry 10
            ], [VERSION, [NAME, BLACKBERRY]], [
            /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i         // Symbian
            ], [VERSION, [NAME, 'Symbian']], [
            /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i // Firefox OS
            ], [VERSION, [NAME, FIREFOX+' OS']], [
            /web0s;.+rt(tv)/i,
            /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i                              // WebOS
            ], [VERSION, [NAME, 'webOS']], [

            // Google Chromecast
            /crkey\/([\d\.]+)/i                                                 // Google Chromecast
            ], [VERSION, [NAME, CHROME+'cast']], [
            /(cros) [\w]+ ([\w\.]+\w)/i                                         // Chromium OS
            ], [[NAME, 'Chromium OS'], VERSION],[

            // Console
            /(nintendo|playstation) ([wids345portablevuch]+)/i,                 // Nintendo/Playstation
            /(xbox); +xbox ([^\);]+)/i,                                         // Microsoft Xbox (360, One, X, S, Series X, Series S)

            // Other
            /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,                            // Joli/Palm
            /(mint)[\/\(\) ]?(\w*)/i,                                           // Mint
            /(mageia|vectorlinux)[; ]/i,                                        // Mageia/VectorLinux
            /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                                                                                // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
            /(hurd|linux) ?([\w\.]*)/i,                                         // Hurd/Linux
            /(gnu) ?([\w\.]*)/i,                                                // GNU
            /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i, // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
            /(haiku) (\w+)/i                                                    // Haiku
            ], [NAME, VERSION], [
            /(sunos) ?([\w\.\d]*)/i                                             // Solaris
            ], [[NAME, 'Solaris'], VERSION], [
            /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,                              // Solaris
            /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,                                  // AIX
            /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux)/i,            // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX
            /(unix) ?([\w\.]*)/i                                                // UNIX
            ], [NAME, VERSION]
        ]
    };

    /////////////////
    // Constructor
    ////////////////

    var UAParser = function (ua, extensions) {

        if (typeof ua === OBJ_TYPE) {
            extensions = ua;
            ua = undefined;
        }

        if (!(this instanceof UAParser)) {
            return new UAParser(ua, extensions).getResult();
        }

        var _ua = ua || ((typeof window !== UNDEF_TYPE && window.navigator && window.navigator.userAgent) ? window.navigator.userAgent : EMPTY);
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;

        this.getBrowser = function () {
            var _browser = {};
            _browser[NAME] = undefined;
            _browser[VERSION] = undefined;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser.major = majorize(_browser.version);
            return _browser;
        };
        this.getCPU = function () {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function () {
            var _device = {};
            _device[VENDOR] = undefined;
            _device[MODEL] = undefined;
            _device[TYPE] = undefined;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            return _device;
        };
        this.getEngine = function () {
            var _engine = {};
            _engine[NAME] = undefined;
            _engine[VERSION] = undefined;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function () {
            var _os = {};
            _os[NAME] = undefined;
            _os[VERSION] = undefined;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            return _os;
        };
        this.getResult = function () {
            return {
                ua      : this.getUA(),
                browser : this.getBrowser(),
                engine  : this.getEngine(),
                os      : this.getOS(),
                device  : this.getDevice(),
                cpu     : this.getCPU()
            };
        };
        this.getUA = function () {
            return _ua;
        };
        this.setUA = function (ua) {
            _ua = (typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH) ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };

    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER =  enumerize([NAME, VERSION, MAJOR]);
    UAParser.CPU = enumerize([ARCHITECTURE]);
    UAParser.DEVICE = enumerize([MODEL, VENDOR, TYPE, CONSOLE, MOBILE, SMARTTV, TABLET, WEARABLE, EMBEDDED]);
    UAParser.ENGINE = UAParser.OS = enumerize([NAME, VERSION]);

    ///////////
    // Export
    //////////

    // check js environment
    if (typeof(exports) !== UNDEF_TYPE) {
        // nodejs env
        if ("object" !== UNDEF_TYPE && module.exports) {
            exports = module.exports = UAParser;
        }
        exports.UAParser = UAParser;
    } else {
        // requirejs env (optional)
        if ("function" === FUNC_TYPE && __webpack_require__.amdO) {
            !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
                return UAParser;
            }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else if (typeof window !== UNDEF_TYPE) {
            // browser env
            window.UAParser = UAParser;
        }
    }

    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = typeof window !== UNDEF_TYPE && (window.jQuery || window.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function () {
            return parser.getUA();
        };
        $.ua.set = function (ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for (var prop in result) {
                $.ua[prop] = result[prop];
            }
        };
    }

})(typeof window === 'object' ? window : this);


/***/ }),

/***/ 95318:
/***/ (function(module) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 20862:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _typeof = (__webpack_require__(50008)["default"]);

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

module.exports = _interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 50008:
/***/ (function(module) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
}

module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 24465:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ is_prop_valid_browser_esm; }
});

;// CONCATENATED MODULE: ./node_modules/@emotion/memoize/dist/memoize.browser.esm.js
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ var memoize_browser_esm = (memoize);

;// CONCATENATED MODULE: ./node_modules/@emotion/is-prop-valid/dist/is-prop-valid.browser.esm.js


var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var index = memoize_browser_esm(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

/* harmony default export */ var is_prop_valid_browser_esm = (index);


/***/ }),

/***/ 11206:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.FacebookLoginClient = void 0;
const helpers_1 = __webpack_require__(64356);
exports.FacebookLoginClient = {
    getFB: () => {
        if (!window.FB) {
            console.warn('FB not found');
            return;
        }
        return window.FB;
    },
    getLoginStatus(callback, isForcingRoudtrip = false) {
        const FB = this.getFB();
        if (!FB) {
            callback({ status: 'unknown' });
            return;
        }
        FB.getLoginStatus(callback, isForcingRoudtrip);
    },
    getProfile(callback, params) {
        var _a;
        (_a = this.getFB()) === null || _a === void 0 ? void 0 : _a.api('me', params, callback);
    },
    init(callback, initParams) {
        window.fbAsyncInit = () => {
            var _a;
            (_a = this.getFB()) === null || _a === void 0 ? void 0 : _a.init(initParams);
            callback();
        };
    },
    isRedirected(dialogParams) {
        var _a, _b;
        const params = (0, helpers_1.paramsToObject)(window.location.search);
        return (((_a = params['state'] === (dialogParams === null || dialogParams === void 0 ? void 0 : dialogParams.state)) !== null && _a !== void 0 ? _a : 'facebookdirect') &&
            params[(_b = dialogParams === null || dialogParams === void 0 ? void 0 : dialogParams.response_type) !== null && _b !== void 0 ? _b : ''] !== undefined);
    },
    loadSdk(language, useCustomerChat) {
        return __awaiter(this, void 0, void 0, function* () {
            yield (0, helpers_1.createScriptEle)('facebook-jssdk', `https://connect.facebook.net/${language}/sdk${useCustomerChat ? '/xfbml.customerchat' : ''}.js`);
        });
    },
    redirectToDialog(dialogParams, loginOptions) {
        window.location.href = `https://www.facebook.com/dialog/oauth${(0, helpers_1.objectToParams)(Object.assign(Object.assign({}, dialogParams), loginOptions))}`;
    },
    login(callback, loginOptions) {
        var _a;
        (_a = this.getFB()) === null || _a === void 0 ? void 0 : _a.login(callback, loginOptions);
    },
    logout(callback) {
        this.getLoginStatus((res) => {
            var _a;
            if (res.status === 'connected') {
                (_a = this.getFB()) === null || _a === void 0 ? void 0 : _a.logout(callback);
            }
            else {
                callback();
            }
        });
    },
};


/***/ }),

/***/ 97526:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const react_1 = __importStar(__webpack_require__(67294));
const facebook_login_client_1 = __webpack_require__(11206);
function FacebookLogin(props) {
    const { appId, language = 'en_US', scope = 'public_profile, email', fields = 'name,email,picture', onSuccess, onFail, onProfileSuccess, className, style, children = 'Login with Facebook', render, autoLoad = false, useRedirect = false, useCustomerChat = false, } = props;
    const initParams = Object.assign(Object.assign({ version: 'v9.0', xfbml: false, cookie: false, localStorage: true }, props.initParams), { appId });
    const dialogParams = Object.assign(Object.assign({ redirect_uri: typeof window !== 'undefined' ? location.origin + location.pathname : '/', state: 'facebookdirect', response_type: 'code' }, props.dialogParams), { client_id: appId });
    const loginOptions = Object.assign(Object.assign({ auth_type: '', return_scopes: false }, props.loginOptions), { scope });
    (0, react_1.useEffect)(() => {
        init();
    }, []);
    const init = () => __awaiter(this, void 0, void 0, function* () {
        yield facebook_login_client_1.FacebookLoginClient.loadSdk(language, useCustomerChat);
        facebook_login_client_1.FacebookLoginClient.init(() => {
            const isRedirected = facebook_login_client_1.FacebookLoginClient.isRedirected(dialogParams);
            if (isRedirected === false && autoLoad) {
                handleButtonClick();
                return;
            }
            if (isRedirected === true && useRedirect) {
                requestLogin();
            }
        }, initParams);
    });
    const requestLogin = () => {
        facebook_login_client_1.FacebookLoginClient.login((res) => {
            if (!res.authResponse) {
                onFail && onFail({ status: 'loginCancelled' });
                return;
            }
            onSuccess && onSuccess(res.authResponse);
            if (onProfileSuccess) {
                facebook_login_client_1.FacebookLoginClient.getProfile(onProfileSuccess, { fields });
            }
        }, Object.assign(Object.assign({}, loginOptions), { scope }));
    };
    const handleButtonClick = () => {
        if (useRedirect) {
            facebook_login_client_1.FacebookLoginClient.redirectToDialog(dialogParams, loginOptions);
            return;
        }
        if (!window.FB) {
            onFail && onFail({ status: 'facebookNotLoaded' });
            return;
        }
        requestLogin();
    };
    if (render) {
        return render({
            onClick: handleButtonClick,
            logout: facebook_login_client_1.FacebookLoginClient.logout,
        });
    }
    return (react_1.default.createElement("button", { type: "button", onClick: handleButtonClick, className: className, style: style }, children));
}
exports["default"] = FacebookLogin;


/***/ }),

/***/ 54933:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createScriptEle = void 0;
const createScriptEle = (id, src) => {
    return new Promise((resolve) => {
        const element = document.getElementsByTagName('script')[0];
        const fjs = element;
        // return if script already exists
        if (document.getElementById(id)) {
            return;
        }
        const js = document.createElement('script');
        js.id = id;
        js.src = src;
        js.onload = resolve;
        fjs.parentNode.insertBefore(js, fjs);
    });
};
exports.createScriptEle = createScriptEle;


/***/ }),

/***/ 64356:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(54933), exports);
__exportStar(__webpack_require__(11995), exports);


/***/ }),

/***/ 11995:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.paramsToObject = exports.objectToParams = exports.isObject = void 0;
const isObject = (obj) => {
    return Object.prototype.toString.call(obj) === '[object Object]';
};
exports.isObject = isObject;
/** Encode object to url parameters */
const objectToParams = (obj) => {
    if (!(0, exports.isObject)(obj) || Object.keys(obj).length === 0) {
        return '';
    }
    return ('?' +
        Object.keys(obj)
            .map((key) => `${key}=${encodeURIComponent(obj[key])}`)
            .join('&'));
};
exports.objectToParams = objectToParams;
/** Decode params to object */
const paramsToObject = (params) => (params === null || params === void 0 ? void 0 : params.replace(/^\?/, '').split('&').reduce((acc, chunk) => {
    if (!chunk) {
        return acc;
    }
    const [key, value] = chunk.split('=');
    return Object.assign(Object.assign({}, acc), { [key]: decodeURIComponent(value) });
}, {})) || {};
exports.paramsToObject = paramsToObject;


/***/ }),

/***/ 73502:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const facebook_login_1 = __importDefault(__webpack_require__(97526));
__exportStar(__webpack_require__(64356), exports);
__exportStar(__webpack_require__(43686), exports);
__exportStar(__webpack_require__(97526), exports);
__exportStar(__webpack_require__(11206), exports);
exports["default"] = facebook_login_1.default;


/***/ }),

/***/ 22653:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ 43686:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(22653), exports);
__exportStar(__webpack_require__(74750), exports);
__exportStar(__webpack_require__(2230), exports);


/***/ }),

/***/ 74750:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ 2230:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.LoginStatus = void 0;
var LoginStatus;
(function (LoginStatus) {
    LoginStatus["Connected"] = "connected";
    LoginStatus["NotAuthorized"] = "not_authorized";
    LoginStatus["Unknown"] = "unknown";
})(LoginStatus = exports.LoginStatus || (exports.LoginStatus = {}));


/***/ }),

/***/ 94471:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ag": function() { return /* binding */ i18n; }
});

// UNUSED EXPORTS: I18n, formats, setupI18n

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(15671);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(43144);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(60136);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(82963);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(61120);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(86854);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(45987);
;// CONCATENATED MODULE: ./node_modules/@lingui/core/esm/core.production.min.js
var i=function(e){return"string"==typeof e},s=function(e){return"function"==typeof e},u=new Map,c=new Map;function f(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=!(arguments.length>2&&void 0!==arguments[2])||arguments[2];return function(r){if(i(r)&&(r=new Date(r)),n){var a=v(e,t),o=c.get(a);if(o)return o.format(r);var l=new Intl.DateTimeFormat(e,t);return c.set(a,l),l.format(r)}var s=new Intl.DateTimeFormat(e,t);return s.format(r)}}function h(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=!(arguments.length>2&&void 0!==arguments[2])||arguments[2];return function(r){if(n){var a=v(e,t),o=u.get(a);if(o)return o.format(r);var l=new Intl.NumberFormat(e,t);return u.set(a,l),l.format(r)}var i=new Intl.NumberFormat(e,t);return i.format(r)}}function v(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=Array.isArray(e)?e.sort().join("-"):e;return"".concat(n,"-").concat(JSON.stringify(t))}var m=Object.freeze({__proto__:null,date:f,number:h}),g=/\\u[a-fA-F0-9]{4}|\\x[a-fA-F0-9]{2}/g;function _(e){var t=e.locale,n=e.locales,r=e.values,a=e.formats,o=e.localeData,u=function(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{plurals:void 0},r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:{};t=t||e;var a=n.plurals,o=function(e){return i(e)?r[e]||{style:e}:e},u=function(e,n){return function(r){var a=s(n)?n(r):n,o=Array.isArray(a)?a:[a],l=h(t)(e);return o.map((function(e){return i(e)?e.replace("#",l):e}))}};return a||console.error("Plurals for locale ".concat(e," aren't loaded. Use i18n.loadLocaleData method to load plurals for specific locale. Using other plural rule as a fallback.")),{plural:function(e,t){var n=t.offset,r=void 0===n?0:n,o=(0,objectWithoutProperties/* default */.Z)(t,["offset"]),i=o[e]||o[null==a?void 0:a(e-r)]||o.other;return u(e-r,i)},selectordinal:function(e,t){var n=t.offset,r=void 0===n?0:n,o=(0,objectWithoutProperties/* default */.Z)(t,["offset"]),i=o[e]||o[null==a?void 0:a(e-r,!0)]||o.other;return u(e-r,i)},select:function(e,t){return t[e]||t.other},number:function(e,n){return h(t,o(n))(e)},date:function(e,n){return f(t,o(n))(e)},undefined:function(e){return e}}}(t,n,o,a);return function e(t,n,a){var o=r[t],l=u[n](o,a),i=s(l)?l(e):l;return Array.isArray(i)?i.join(""):i}}function d(e,t,n,r){return function(a){var l=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},s=_({locale:t,locales:n,localeData:r,formats:l,values:a}),u=function e(t){return Array.isArray(t)?t.reduce((function(t,n){if(i(n))return t+n;var r=(0,slicedToArray/* default */.Z)(n,3),a=r[0],l=r[1],u=r[2],c={};null==u||i(u)?c=u:Object.keys(u).forEach((function(t){c[t]=e(u[t])}));var f=s(a,l,c);return null==f?t:t+f}),""):t},c=u(e);return i(c)&&g.test(c)?JSON.parse('"'.concat(c.trim(),'"')):i(c)?c.trim():c}}var p=function(){function n(){(0,classCallCheck/* default */.Z)(this,n),this._events={}}return (0,createClass/* default */.Z)(n,[{key:"on",value:function(e,t){var n=this;return this._hasEvent(e)||(this._events[e]=[]),this._events[e].push(t),function(){return n.removeListener(e,t)}}},{key:"removeListener",value:function(e,t){if(this._hasEvent(e)){var n=this._events[e].indexOf(t);~n&&this._events[e].splice(n,1)}}},{key:"emit",value:function(e){for(var t=this,n=arguments.length,r=new Array(n>1?n-1:0),a=1;a<n;a++)r[a-1]=arguments[a];this._hasEvent(e)&&this._events[e].map((function(e){return e.apply(t,r)}))}},{key:"_hasEvent",value:function(e){return Array.isArray(this._events[e])}}]),n}();function y(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(e){return!1}}();return function(){var n,o=(0,getPrototypeOf/* default */.Z)(e);if(t){var l=(0,getPrototypeOf/* default */.Z)(this).constructor;n=Reflect.construct(o,arguments,l)}else n=o.apply(this,arguments);return (0,possibleConstructorReturn/* default */.Z)(this,n)}}var b=function(r){(0,inherits/* default */.Z)(o,r);var a=y(o);function o(t){var n;return (0,classCallCheck/* default */.Z)(this,o),n=a.call(this),n._messages={},n._localeData={},null!=t.missing&&(n._missing=t.missing),null!=t.messages&&n.load(t.messages),null!=t.localeData&&n.loadLocaleData(t.localeData),null==t.locale&&null==t.locales||n.activate(t.locale,t.locales),n}return (0,createClass/* default */.Z)(o,[{key:"_loadLocaleData",value:function(e,t){null==this._localeData[e]?this._localeData[e]=t:Object.assign(this._localeData[e],t)}},{key:"loadLocaleData",value:function(e,t){var n=this;null!=t?this._loadLocaleData(e,t):Object.keys(e).forEach((function(t){return n._loadLocaleData(t,e[t])})),this.emit("change")}},{key:"_load",value:function(e,t){null==this._messages[e]?this._messages[e]=t:Object.assign(this._messages[e],t)}},{key:"load",value:function(e,t){var n=this;null!=t?this._load(e,t):Object.keys(e).forEach((function(t){return n._load(t,e[t])})),this.emit("change")}},{key:"activate",value:function(e,t){this._locale=e,this._locales=t,this.emit("change")}},{key:"_",value:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},r=n.message,a=n.formats,o=n.context;i(e)||(t=e.values||t,r=e.message,o=e.context,e=e.id);var l,u=!o&&!this.messages[e],c=o&&!this.messages[o][e],f=c||u,h=this._missing;return h&&f?s(h)?h(this._locale,e,o):h:(f&&this.emit("missing",{id:e,context:o,locale:this._locale}),l=o&&!c?this.messages[o][e]||r||e:this.messages[e]||r||e,i(l)&&g.test(l)?JSON.parse('"'.concat(l,'"')):i(l)?l:d(l,this._locale,this._locales,this.localeData)(t,a))}},{key:"date",value:function(e,t){return f(this._locales||this._locale,t)(e)}},{key:"number",value:function(e,t){return h(this._locales||this._locale,t)(e)}},{key:"locale",get:function(){return this._locale}},{key:"locales",get:function(){return this._locales}},{key:"messages",get:function(){var e;return null!==(e=this._messages[this._locale])&&void 0!==e?e:{}}},{key:"localeData",get:function(){var e;return null!==(e=this._localeData[this._locale])&&void 0!==e?e:{}}}]),o}(p);function D(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return new b(e)}var k=D();
//# sourceMappingURL=core.production.min.js.map

;// CONCATENATED MODULE: ./node_modules/@lingui/core/esm/index.js




const i18n =  true ? k : 0;
const setupI18n = (/* unused pure expression or super */ null && ( true ? setupI18nProd : 0));
const formats = (/* unused pure expression or super */ null && ( true ? formatsProd : 0));
const I18n = (/* unused pure expression or super */ null && ( true ? I18nProd : 0));

/***/ }),

/***/ 85169:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "bd": function() { return /* binding */ I18nProvider; },
  "cC": function() { return /* binding */ Trans; }
});

// UNUSED EXPORTS: useLingui, withI18n

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(86854);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(4942);
;// CONCATENATED MODULE: ./node_modules/@lingui/react/esm/react.production.min.js
var r=react.createContext(null);function o(){var e=react.useContext(r);return e}function a(e){return function(e){return function(t){var r=o(),a=r.i18n;return n.createElement(e,Object.assign({},t,{i18n:a}))}}}var i=function(t){var o=t.i18n,a=t.defaultComponent,i=t.forceRenderOnLocaleChange,c=void 0===i||i,u=t.children,l=function(){return{i18n:o,defaultComponent:a}},f=function(){return c&&o.locale||"default"},s=react.useState(l()),p=(0,slicedToArray/* default */.Z)(s,2),m=p[0],d=p[1],v=react.useState(f()),y=(0,slicedToArray/* default */.Z)(v,2),h=y[0],b=y[1];return react.useEffect((function(){var e=o.on("change",(function(){d(l()),b(f())}));return"default"===h&&b(f()),c&&"default"===h&&console.log("I18nProvider did not render. A call to i18n.activate still needs to happen or forceRenderOnLocaleChange must be set to false."),function(){return e()}}),[]),c&&"default"===h?null:react.createElement(r.Provider,{value:m,key:h},u)};function c(e,n){var t;if("undefined"==typeof Symbol||null==e[Symbol.iterator]){if(Array.isArray(e)||(t=function(e,n){if(!e)return;if("string"==typeof e)return u(e,n);var t=Object.prototype.toString.call(e).slice(8,-1);"Object"===t&&e.constructor&&(t=e.constructor.name);if("Map"===t||"Set"===t)return Array.from(e);if("Arguments"===t||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))return u(e,n)}(e))||n&&e&&"number"==typeof e.length){t&&(e=t);var r=0,o=function(){};return{s:o,n:function(){return r>=e.length?{done:!0}:{done:!1,value:e[r++]}},e:function(e){throw e},f:o}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var a,i=!0,c=!1;return{s:function(){t=e[Symbol.iterator]()},n:function(){var e=t.next();return i=e.done,e},e:function(e){c=!0,a=e},f:function(){try{i||null==t.return||t.return()}finally{if(c)throw a}}}}function u(e,n){(null==n||n>e.length)&&(n=e.length);for(var t=0,r=new Array(n);t<n;t++)r[t]=e[t];return r}var l=/<(\d+)>(.*?)<\/\1>|<(\d+)\/>/,f=/(?:\r\n|\r|\n)/g,s={area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0,menuitem:!0};function p(n){if(!n.length)return[];var t=n.slice(0,4),r=(0,slicedToArray/* default */.Z)(t,4),o=r[0],a=r[1],i=r[2],c=r[3];return[[parseInt(o||i),a||"",c]].concat(p(n.slice(4,n.length)))}var m=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"";return function(){return"".concat(n,"_").concat(e++)}};function d(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function v(e){for(var n=1;n<arguments.length;n++){var r=null!=arguments[n]?arguments[n]:{};n%2?d(Object(r),!0).forEach((function(n){(0,defineProperty/* default */.Z)(e,n,r[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):d(Object(r)).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(r,n))}))}return e}function y(t){var r=o(),a=r.i18n,i=r.defaultComponent,u=t.render,d=t.component,y=t.id,h=t.message,b=t.formats,g=v({},t.values),O=v({},t.components);g&&Object.keys(g).forEach((function(e){var t=g[e];if(react.isValidElement(t)){var r=Object.keys(O).length;O[r]=t,g[e]="<".concat(r,"/>")}}));var j=a&&"function"==typeof a._?a._(y,g,{message:h,formats:b}):y,w=j?function t(r){var o=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},a=m(0,"$lingui$"),i=r.replace(f,"").split(l);if(1===i.length)return r;var u=[],d=i.shift();d&&u.push(d);var v,y=c(p(i));try{for(y.s();!(v=y.n()).done;){var h=(0,slicedToArray/* default */.Z)(v.value,3),b=h[0],g=h[1],O=h[2],j=o[b];(!j||s[j.type]&&g)&&(j?console.error("".concat(j.type," is a void element tag therefore it must have no children")):console.error("Can use element at index '".concat(b,"' as it is not declared in the original translation")),j=react.createElement(react.Fragment)),u.push(react.cloneElement(j,{key:a()},g?t(g,o):j.props.children)),O&&u.push(O)}}catch(e){y.e(e)}finally{y.f()}return u}(j,O):null;if(null===u||null===d)return w;var E=i||react.Fragment;if(u&&d)console.error("You can't use both `component` and `render` prop at the same time. `component` is ignored.");else if(u&&"function"!=typeof u)console.error("Invalid value supplied to prop `render`. It must be a function, provided ".concat(u));else if(d&&"function"!=typeof d)return console.error("Invalid value supplied to prop `component`. It must be a React component, provided ".concat(d)),react.createElement(E,null,w);if("function"==typeof u)return u({id:y,translation:w,message:h});var P=d||E;return react.createElement(P,null,w)}y.defaultProps={values:{},components:{}};
//# sourceMappingURL=react.production.min.js.map

;// CONCATENATED MODULE: ./node_modules/@lingui/react/esm/index.js




const I18nProvider =  true ? i : 0;
const Trans =  true ? y : 0;
const useLingui = (/* unused pure expression or super */ null && ( true ? useLinguiProd : 0));
const withI18n = (/* unused pure expression or super */ null && ( true ? withI18nProd : 0));

/***/ }),

/***/ 282:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45987);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87462);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86010);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1591);
/* harmony import */ var _styles_colorManipulator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59693);
/* harmony import */ var _ButtonBase__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4024);
/* harmony import */ var _utils_capitalize__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93871);









var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, theme.typography.button, {
      boxSizing: 'border-box',
      minWidth: 64,
      padding: '6px 16px',
      borderRadius: theme.shape.borderRadius,
      color: theme.palette.text.primary,
      transition: theme.transitions.create(['background-color', 'box-shadow', 'border'], {
        duration: theme.transitions.duration.short
      }),
      '&:hover': {
        textDecoration: 'none',
        backgroundColor: (0,_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_2__/* .alpha */ .Fq)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        },
        '&$disabled': {
          backgroundColor: 'transparent'
        }
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    }),

    /* Styles applied to the span element that wraps the children. */
    label: {
      width: '100%',
      // Ensure the correct width for iOS Safari
      display: 'inherit',
      alignItems: 'inherit',
      justifyContent: 'inherit'
    },

    /* Styles applied to the root element if `variant="text"`. */
    text: {
      padding: '6px 8px'
    },

    /* Styles applied to the root element if `variant="text"` and `color="primary"`. */
    textPrimary: {
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: (0,_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_2__/* .alpha */ .Fq)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `variant="text"` and `color="secondary"`. */
    textSecondary: {
      color: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: (0,_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_2__/* .alpha */ .Fq)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `variant="outlined"`. */
    outlined: {
      padding: '5px 15px',
      border: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'),
      '&$disabled': {
        border: "1px solid ".concat(theme.palette.action.disabledBackground)
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */
    outlinedPrimary: {
      color: theme.palette.primary.main,
      border: "1px solid ".concat((0,_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_2__/* .alpha */ .Fq)(theme.palette.primary.main, 0.5)),
      '&:hover': {
        border: "1px solid ".concat(theme.palette.primary.main),
        backgroundColor: (0,_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_2__/* .alpha */ .Fq)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */
    outlinedSecondary: {
      color: theme.palette.secondary.main,
      border: "1px solid ".concat((0,_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_2__/* .alpha */ .Fq)(theme.palette.secondary.main, 0.5)),
      '&:hover': {
        border: "1px solid ".concat(theme.palette.secondary.main),
        backgroundColor: (0,_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_2__/* .alpha */ .Fq)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      },
      '&$disabled': {
        border: "1px solid ".concat(theme.palette.action.disabled)
      }
    },

    /* Styles applied to the root element if `variant="contained"`. */
    contained: {
      color: theme.palette.getContrastText(theme.palette.grey[300]),
      backgroundColor: theme.palette.grey[300],
      boxShadow: theme.shadows[2],
      '&:hover': {
        backgroundColor: theme.palette.grey.A100,
        boxShadow: theme.shadows[4],
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          boxShadow: theme.shadows[2],
          backgroundColor: theme.palette.grey[300]
        },
        '&$disabled': {
          backgroundColor: theme.palette.action.disabledBackground
        }
      },
      '&$focusVisible': {
        boxShadow: theme.shadows[6]
      },
      '&:active': {
        boxShadow: theme.shadows[8]
      },
      '&$disabled': {
        color: theme.palette.action.disabled,
        boxShadow: theme.shadows[0],
        backgroundColor: theme.palette.action.disabledBackground
      }
    },

    /* Styles applied to the root element if `variant="contained"` and `color="primary"`. */
    containedPrimary: {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: theme.palette.primary.main
        }
      }
    },

    /* Styles applied to the root element if `variant="contained"` and `color="secondary"`. */
    containedSecondary: {
      color: theme.palette.secondary.contrastText,
      backgroundColor: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: theme.palette.secondary.main
        }
      }
    },

    /* Styles applied to the root element if `disableElevation={true}`. */
    disableElevation: {
      boxShadow: 'none',
      '&:hover': {
        boxShadow: 'none'
      },
      '&$focusVisible': {
        boxShadow: 'none'
      },
      '&:active': {
        boxShadow: 'none'
      },
      '&$disabled': {
        boxShadow: 'none'
      }
    },

    /* Pseudo-class applied to the ButtonBase root element if the button is keyboard focused. */
    focusVisible: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit',
      borderColor: 'currentColor'
    },

    /* Styles applied to the root element if `size="small"` and `variant="text"`. */
    textSizeSmall: {
      padding: '4px 5px',
      fontSize: theme.typography.pxToRem(13)
    },

    /* Styles applied to the root element if `size="large"` and `variant="text"`. */
    textSizeLarge: {
      padding: '8px 11px',
      fontSize: theme.typography.pxToRem(15)
    },

    /* Styles applied to the root element if `size="small"` and `variant="outlined"`. */
    outlinedSizeSmall: {
      padding: '3px 9px',
      fontSize: theme.typography.pxToRem(13)
    },

    /* Styles applied to the root element if `size="large"` and `variant="outlined"`. */
    outlinedSizeLarge: {
      padding: '7px 21px',
      fontSize: theme.typography.pxToRem(15)
    },

    /* Styles applied to the root element if `size="small"` and `variant="contained"`. */
    containedSizeSmall: {
      padding: '4px 10px',
      fontSize: theme.typography.pxToRem(13)
    },

    /* Styles applied to the root element if `size="large"` and `variant="contained"`. */
    containedSizeLarge: {
      padding: '8px 22px',
      fontSize: theme.typography.pxToRem(15)
    },

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {},

    /* Styles applied to the root element if `size="large"`. */
    sizeLarge: {},

    /* Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {
      width: '100%'
    },

    /* Styles applied to the startIcon element if supplied. */
    startIcon: {
      display: 'inherit',
      marginRight: 8,
      marginLeft: -4,
      '&$iconSizeSmall': {
        marginLeft: -2
      }
    },

    /* Styles applied to the endIcon element if supplied. */
    endIcon: {
      display: 'inherit',
      marginRight: -4,
      marginLeft: 8,
      '&$iconSizeSmall': {
        marginRight: -2
      }
    },

    /* Styles applied to the icon element if supplied and `size="small"`. */
    iconSizeSmall: {
      '& > *:first-child': {
        fontSize: 18
      }
    },

    /* Styles applied to the icon element if supplied and `size="medium"`. */
    iconSizeMedium: {
      '& > *:first-child': {
        fontSize: 20
      }
    },

    /* Styles applied to the icon element if supplied and `size="large"`. */
    iconSizeLarge: {
      '& > *:first-child': {
        fontSize: 22
      }
    }
  };
};
var Button = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Button(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      _props$component = props.component,
      component = _props$component === void 0 ? 'button' : _props$component,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableElevati = props.disableElevation,
      disableElevation = _props$disableElevati === void 0 ? false : _props$disableElevati,
      _props$disableFocusRi = props.disableFocusRipple,
      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
      endIconProp = props.endIcon,
      focusVisibleClassName = props.focusVisibleClassName,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      startIconProp = props.startIcon,
      _props$type = props.type,
      type = _props$type === void 0 ? 'button' : _props$type,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'text' : _props$variant,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, ["children", "classes", "className", "color", "component", "disabled", "disableElevation", "disableFocusRipple", "endIcon", "focusVisibleClassName", "fullWidth", "size", "startIcon", "type", "variant"]);

  var startIcon = startIconProp && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(classes.startIcon, classes["iconSize".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(size))])
  }, startIconProp);
  var endIcon = endIconProp && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(classes.endIcon, classes["iconSize".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(size))])
  }, endIconProp);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ButtonBase__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(classes.root, classes[variant], className, color === 'inherit' ? classes.colorInherit : color !== 'default' && classes["".concat(variant).concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(color))], size !== 'medium' && [classes["".concat(variant, "Size").concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(size))], classes["size".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(size))]], disableElevation && classes.disableElevation, disabled && classes.disabled, fullWidth && classes.fullWidth),
    component: component,
    disabled: disabled,
    focusRipple: !disableFocusRipple,
    focusVisibleClassName: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(classes.focusVisible, focusVisibleClassName),
    ref: ref,
    type: type
  }, other), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: classes.label
  }, startIcon, children, endIcon));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(styles, {
  name: 'MuiButton'
})(Button));

/***/ }),

/***/ 4024:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ButtonBase_ButtonBase; }
});

// UNUSED EXPORTS: styles

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(45987);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useForkRef.js
var useForkRef = __webpack_require__(17294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useEventCallback.js
var useEventCallback = __webpack_require__(55192);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js + 1 modules
var withStyles = __webpack_require__(1591);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useIsFocusVisible.js
var useIsFocusVisible = __webpack_require__(24896);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(41451);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/TransitionGroup.js + 1 modules
var TransitionGroup = __webpack_require__(73350);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/ButtonBase/Ripple.js




var useEnhancedEffect = typeof window === 'undefined' ? react.useEffect : react.useLayoutEffect;
/**
 * @ignore - internal component.
 */

function Ripple(props) {
  var classes = props.classes,
      _props$pulsate = props.pulsate,
      pulsate = _props$pulsate === void 0 ? false : _props$pulsate,
      rippleX = props.rippleX,
      rippleY = props.rippleY,
      rippleSize = props.rippleSize,
      inProp = props.in,
      _props$onExited = props.onExited,
      onExited = _props$onExited === void 0 ? function () {} : _props$onExited,
      timeout = props.timeout;

  var _React$useState = react.useState(false),
      leaving = _React$useState[0],
      setLeaving = _React$useState[1];

  var rippleClassName = (0,clsx_m/* default */.Z)(classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
  var rippleStyles = {
    width: rippleSize,
    height: rippleSize,
    top: -(rippleSize / 2) + rippleY,
    left: -(rippleSize / 2) + rippleX
  };
  var childClassName = (0,clsx_m/* default */.Z)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
  var handleExited = (0,useEventCallback/* default */.Z)(onExited); // Ripple is used for user feedback (e.g. click or press) so we want to apply styles with the highest priority

  useEnhancedEffect(function () {
    if (!inProp) {
      // react-transition-group#onExit
      setLeaving(true); // react-transition-group#onExited

      var timeoutId = setTimeout(handleExited, timeout);
      return function () {
        clearTimeout(timeoutId);
      };
    }

    return undefined;
  }, [handleExited, inProp, timeout]);
  return /*#__PURE__*/react.createElement("span", {
    className: rippleClassName,
    style: rippleStyles
  }, /*#__PURE__*/react.createElement("span", {
    className: childClassName
  }));
}

 false ? 0 : void 0;
/* harmony default export */ var ButtonBase_Ripple = (Ripple);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/ButtonBase/TouchRipple.js









var DURATION = 550;
var DELAY_RIPPLE = 80;
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      overflow: 'hidden',
      pointerEvents: 'none',
      position: 'absolute',
      zIndex: 0,
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      borderRadius: 'inherit'
    },

    /* Styles applied to the internal `Ripple` components `ripple` class. */
    ripple: {
      opacity: 0,
      position: 'absolute'
    },

    /* Styles applied to the internal `Ripple` components `rippleVisible` class. */
    rippleVisible: {
      opacity: 0.3,
      transform: 'scale(1)',
      animation: "$enter ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
    },

    /* Styles applied to the internal `Ripple` components `ripplePulsate` class. */
    ripplePulsate: {
      animationDuration: "".concat(theme.transitions.duration.shorter, "ms")
    },

    /* Styles applied to the internal `Ripple` components `child` class. */
    child: {
      opacity: 1,
      display: 'block',
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      backgroundColor: 'currentColor'
    },

    /* Styles applied to the internal `Ripple` components `childLeaving` class. */
    childLeaving: {
      opacity: 0,
      animation: "$exit ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
    },

    /* Styles applied to the internal `Ripple` components `childPulsate` class. */
    childPulsate: {
      position: 'absolute',
      left: 0,
      top: 0,
      animation: "$pulsate 2500ms ".concat(theme.transitions.easing.easeInOut, " 200ms infinite")
    },
    '@keyframes enter': {
      '0%': {
        transform: 'scale(0)',
        opacity: 0.1
      },
      '100%': {
        transform: 'scale(1)',
        opacity: 0.3
      }
    },
    '@keyframes exit': {
      '0%': {
        opacity: 1
      },
      '100%': {
        opacity: 0
      }
    },
    '@keyframes pulsate': {
      '0%': {
        transform: 'scale(1)'
      },
      '50%': {
        transform: 'scale(0.92)'
      },
      '100%': {
        transform: 'scale(1)'
      }
    }
  };
};
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */

var TouchRipple = /*#__PURE__*/react.forwardRef(function TouchRipple(props, ref) {
  var _props$center = props.center,
      centerProp = _props$center === void 0 ? false : _props$center,
      classes = props.classes,
      className = props.className,
      other = (0,objectWithoutProperties/* default */.Z)(props, ["center", "classes", "className"]);

  var _React$useState = react.useState([]),
      ripples = _React$useState[0],
      setRipples = _React$useState[1];

  var nextKey = react.useRef(0);
  var rippleCallback = react.useRef(null);
  react.useEffect(function () {
    if (rippleCallback.current) {
      rippleCallback.current();
      rippleCallback.current = null;
    }
  }, [ripples]); // Used to filter out mouse emulated events on mobile.

  var ignoringMouseDown = react.useRef(false); // We use a timer in order to only show the ripples for touch "click" like events.
  // We don't want to display the ripple for touch scroll events.

  var startTimer = react.useRef(null); // This is the hook called once the previous timeout is ready.

  var startTimerCommit = react.useRef(null);
  var container = react.useRef(null);
  react.useEffect(function () {
    return function () {
      clearTimeout(startTimer.current);
    };
  }, []);
  var startCommit = react.useCallback(function (params) {
    var pulsate = params.pulsate,
        rippleX = params.rippleX,
        rippleY = params.rippleY,
        rippleSize = params.rippleSize,
        cb = params.cb;
    setRipples(function (oldRipples) {
      return [].concat((0,toConsumableArray/* default */.Z)(oldRipples), [/*#__PURE__*/react.createElement(ButtonBase_Ripple, {
        key: nextKey.current,
        classes: classes,
        timeout: DURATION,
        pulsate: pulsate,
        rippleX: rippleX,
        rippleY: rippleY,
        rippleSize: rippleSize
      })]);
    });
    nextKey.current += 1;
    rippleCallback.current = cb;
  }, [classes]);
  var start = react.useCallback(function () {
    var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var cb = arguments.length > 2 ? arguments[2] : undefined;
    var _options$pulsate = options.pulsate,
        pulsate = _options$pulsate === void 0 ? false : _options$pulsate,
        _options$center = options.center,
        center = _options$center === void 0 ? centerProp || options.pulsate : _options$center,
        _options$fakeElement = options.fakeElement,
        fakeElement = _options$fakeElement === void 0 ? false : _options$fakeElement;

    if (event.type === 'mousedown' && ignoringMouseDown.current) {
      ignoringMouseDown.current = false;
      return;
    }

    if (event.type === 'touchstart') {
      ignoringMouseDown.current = true;
    }

    var element = fakeElement ? null : container.current;
    var rect = element ? element.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    }; // Get the size of the ripple

    var rippleX;
    var rippleY;
    var rippleSize;

    if (center || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
      rippleX = Math.round(rect.width / 2);
      rippleY = Math.round(rect.height / 2);
    } else {
      var _ref = event.touches ? event.touches[0] : event,
          clientX = _ref.clientX,
          clientY = _ref.clientY;

      rippleX = Math.round(clientX - rect.left);
      rippleY = Math.round(clientY - rect.top);
    }

    if (center) {
      rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3); // For some reason the animation is broken on Mobile Chrome if the size if even.

      if (rippleSize % 2 === 0) {
        rippleSize += 1;
      }
    } else {
      var sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
      var sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
      rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
    } // Touche devices


    if (event.touches) {
      // check that this isn't another touchstart due to multitouch
      // otherwise we will only clear a single timer when unmounting while two
      // are running
      if (startTimerCommit.current === null) {
        // Prepare the ripple effect.
        startTimerCommit.current = function () {
          startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
          });
        }; // Delay the execution of the ripple effect.


        startTimer.current = setTimeout(function () {
          if (startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
          }
        }, DELAY_RIPPLE); // We have to make a tradeoff with this value.
      }
    } else {
      startCommit({
        pulsate: pulsate,
        rippleX: rippleX,
        rippleY: rippleY,
        rippleSize: rippleSize,
        cb: cb
      });
    }
  }, [centerProp, startCommit]);
  var pulsate = react.useCallback(function () {
    start({}, {
      pulsate: true
    });
  }, [start]);
  var stop = react.useCallback(function (event, cb) {
    clearTimeout(startTimer.current); // The touch interaction occurs too quickly.
    // We still want to show ripple effect.

    if (event.type === 'touchend' && startTimerCommit.current) {
      event.persist();
      startTimerCommit.current();
      startTimerCommit.current = null;
      startTimer.current = setTimeout(function () {
        stop(event, cb);
      });
      return;
    }

    startTimerCommit.current = null;
    setRipples(function (oldRipples) {
      if (oldRipples.length > 0) {
        return oldRipples.slice(1);
      }

      return oldRipples;
    });
    rippleCallback.current = cb;
  }, []);
  react.useImperativeHandle(ref, function () {
    return {
      pulsate: pulsate,
      start: start,
      stop: stop
    };
  }, [pulsate, start, stop]);
  return /*#__PURE__*/react.createElement("span", (0,esm_extends/* default */.Z)({
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    ref: container
  }, other), /*#__PURE__*/react.createElement(TransitionGroup/* default */.Z, {
    component: null,
    exit: true
  }, ripples));
});
 false ? 0 : void 0;
/* harmony default export */ var ButtonBase_TouchRipple = ((0,withStyles/* default */.Z)(styles, {
  flip: false,
  name: 'MuiTouchRipple'
})( /*#__PURE__*/react.memo(TouchRipple)));
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/ButtonBase/ButtonBase.js













var ButtonBase_styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    '-moz-appearance': 'none',
    // Reset
    '-webkit-appearance': 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
      borderStyle: 'none' // Remove Firefox dotted outline.

    },
    '&$disabled': {
      pointerEvents: 'none',
      // Disable link interactions
      cursor: 'default'
    },
    '@media print': {
      colorAdjust: 'exact'
    }
  },

  /* Pseudo-class applied to the root element if `disabled={true}`. */
  disabled: {},

  /* Pseudo-class applied to the root element if keyboard focused. */
  focusVisible: {}
};
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */

var ButtonBase = /*#__PURE__*/react.forwardRef(function ButtonBase(props, ref) {
  var action = props.action,
      buttonRefProp = props.buttonRef,
      _props$centerRipple = props.centerRipple,
      centerRipple = _props$centerRipple === void 0 ? false : _props$centerRipple,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      component = _props$component === void 0 ? 'button' : _props$component,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableRipple = props.disableRipple,
      disableRipple = _props$disableRipple === void 0 ? false : _props$disableRipple,
      _props$disableTouchRi = props.disableTouchRipple,
      disableTouchRipple = _props$disableTouchRi === void 0 ? false : _props$disableTouchRi,
      _props$focusRipple = props.focusRipple,
      focusRipple = _props$focusRipple === void 0 ? false : _props$focusRipple,
      focusVisibleClassName = props.focusVisibleClassName,
      onBlur = props.onBlur,
      onClick = props.onClick,
      onFocus = props.onFocus,
      onFocusVisible = props.onFocusVisible,
      onKeyDown = props.onKeyDown,
      onKeyUp = props.onKeyUp,
      onMouseDown = props.onMouseDown,
      onMouseLeave = props.onMouseLeave,
      onMouseUp = props.onMouseUp,
      onTouchEnd = props.onTouchEnd,
      onTouchMove = props.onTouchMove,
      onTouchStart = props.onTouchStart,
      onDragLeave = props.onDragLeave,
      _props$tabIndex = props.tabIndex,
      tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex,
      TouchRippleProps = props.TouchRippleProps,
      _props$type = props.type,
      type = _props$type === void 0 ? 'button' : _props$type,
      other = (0,objectWithoutProperties/* default */.Z)(props, ["action", "buttonRef", "centerRipple", "children", "classes", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "onBlur", "onClick", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "onDragLeave", "tabIndex", "TouchRippleProps", "type"]);

  var buttonRef = react.useRef(null);

  function getButtonNode() {
    // #StrictMode ready
    return react_dom.findDOMNode(buttonRef.current);
  }

  var rippleRef = react.useRef(null);

  var _React$useState = react.useState(false),
      focusVisible = _React$useState[0],
      setFocusVisible = _React$useState[1];

  if (disabled && focusVisible) {
    setFocusVisible(false);
  }

  var _useIsFocusVisible = (0,useIsFocusVisible/* default */.Z)(),
      isFocusVisible = _useIsFocusVisible.isFocusVisible,
      onBlurVisible = _useIsFocusVisible.onBlurVisible,
      focusVisibleRef = _useIsFocusVisible.ref;

  react.useImperativeHandle(action, function () {
    return {
      focusVisible: function focusVisible() {
        setFocusVisible(true);
        buttonRef.current.focus();
      }
    };
  }, []);
  react.useEffect(function () {
    if (focusVisible && focusRipple && !disableRipple) {
      rippleRef.current.pulsate();
    }
  }, [disableRipple, focusRipple, focusVisible]);

  function useRippleHandler(rippleAction, eventCallback) {
    var skipRippleAction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : disableTouchRipple;
    return (0,useEventCallback/* default */.Z)(function (event) {
      if (eventCallback) {
        eventCallback(event);
      }

      var ignore = skipRippleAction;

      if (!ignore && rippleRef.current) {
        rippleRef.current[rippleAction](event);
      }

      return true;
    });
  }

  var handleMouseDown = useRippleHandler('start', onMouseDown);
  var handleDragLeave = useRippleHandler('stop', onDragLeave);
  var handleMouseUp = useRippleHandler('stop', onMouseUp);
  var handleMouseLeave = useRippleHandler('stop', function (event) {
    if (focusVisible) {
      event.preventDefault();
    }

    if (onMouseLeave) {
      onMouseLeave(event);
    }
  });
  var handleTouchStart = useRippleHandler('start', onTouchStart);
  var handleTouchEnd = useRippleHandler('stop', onTouchEnd);
  var handleTouchMove = useRippleHandler('stop', onTouchMove);
  var handleBlur = useRippleHandler('stop', function (event) {
    if (focusVisible) {
      onBlurVisible(event);
      setFocusVisible(false);
    }

    if (onBlur) {
      onBlur(event);
    }
  }, false);
  var handleFocus = (0,useEventCallback/* default */.Z)(function (event) {
    // Fix for https://github.com/facebook/react/issues/7769
    if (!buttonRef.current) {
      buttonRef.current = event.currentTarget;
    }

    if (isFocusVisible(event)) {
      setFocusVisible(true);

      if (onFocusVisible) {
        onFocusVisible(event);
      }
    }

    if (onFocus) {
      onFocus(event);
    }
  });

  var isNonNativeButton = function isNonNativeButton() {
    var button = getButtonNode();
    return component && component !== 'button' && !(button.tagName === 'A' && button.href);
  };
  /**
   * IE 11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */


  var keydownRef = react.useRef(false);
  var handleKeyDown = (0,useEventCallback/* default */.Z)(function (event) {
    // Check if key is already down to avoid repeats being counted as multiple activations
    if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === ' ') {
      keydownRef.current = true;
      event.persist();
      rippleRef.current.stop(event, function () {
        rippleRef.current.start(event);
      });
    }

    if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') {
      event.preventDefault();
    }

    if (onKeyDown) {
      onKeyDown(event);
    } // Keyboard accessibility for non interactive elements


    if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
      event.preventDefault();

      if (onClick) {
        onClick(event);
      }
    }
  });
  var handleKeyUp = (0,useEventCallback/* default */.Z)(function (event) {
    // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
    // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
    if (focusRipple && event.key === ' ' && rippleRef.current && focusVisible && !event.defaultPrevented) {
      keydownRef.current = false;
      event.persist();
      rippleRef.current.stop(event, function () {
        rippleRef.current.pulsate(event);
      });
    }

    if (onKeyUp) {
      onKeyUp(event);
    } // Keyboard accessibility for non interactive elements


    if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) {
      onClick(event);
    }
  });
  var ComponentProp = component;

  if (ComponentProp === 'button' && other.href) {
    ComponentProp = 'a';
  }

  var buttonProps = {};

  if (ComponentProp === 'button') {
    buttonProps.type = type;
    buttonProps.disabled = disabled;
  } else {
    if (ComponentProp !== 'a' || !other.href) {
      buttonProps.role = 'button';
    }

    buttonProps['aria-disabled'] = disabled;
  }

  var handleUserRef = (0,useForkRef/* default */.Z)(buttonRefProp, ref);
  var handleOwnRef = (0,useForkRef/* default */.Z)(focusVisibleRef, buttonRef);
  var handleRef = (0,useForkRef/* default */.Z)(handleUserRef, handleOwnRef);

  var _React$useState2 = react.useState(false),
      mountedState = _React$useState2[0],
      setMountedState = _React$useState2[1];

  react.useEffect(function () {
    setMountedState(true);
  }, []);
  var enableTouchRipple = mountedState && !disableRipple && !disabled;

  if (false) {}

  return /*#__PURE__*/react.createElement(ComponentProp, (0,esm_extends/* default */.Z)({
    className: (0,clsx_m/* default */.Z)(classes.root, className, focusVisible && [classes.focusVisible, focusVisibleClassName], disabled && classes.disabled),
    onBlur: handleBlur,
    onClick: onClick,
    onFocus: handleFocus,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp,
    onMouseDown: handleMouseDown,
    onMouseLeave: handleMouseLeave,
    onMouseUp: handleMouseUp,
    onDragLeave: handleDragLeave,
    onTouchEnd: handleTouchEnd,
    onTouchMove: handleTouchMove,
    onTouchStart: handleTouchStart,
    ref: handleRef,
    tabIndex: disabled ? -1 : tabIndex
  }, buttonProps, other), children, enableTouchRipple ?
  /*#__PURE__*/

  /* TouchRipple is only needed client-side, x2 boost on the server. */
  react.createElement(ButtonBase_TouchRipple, (0,esm_extends/* default */.Z)({
    ref: rippleRef,
    center: centerRipple
  }, TouchRippleProps)) : null);
});
 false ? 0 : void 0;
/* harmony default export */ var ButtonBase_ButtonBase = ((0,withStyles/* default */.Z)(ButtonBase_styles, {
  name: 'MuiButtonBase'
})(ButtonBase));

/***/ }),

/***/ 52795:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73935);
/* harmony import */ var _utils_ownerDocument__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30626);
/* harmony import */ var _utils_useForkRef__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17294);
/* harmony import */ var _utils_useEventCallback__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55192);








function mapEventPropToEvent(eventProp) {
  return eventProp.substring(2).toLowerCase();
}

function clickedRootScrollbar(event) {
  return document.documentElement.clientWidth < event.clientX || document.documentElement.clientHeight < event.clientY;
}
/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 */


function ClickAwayListener(props) {
  var children = props.children,
      _props$disableReactTr = props.disableReactTree,
      disableReactTree = _props$disableReactTr === void 0 ? false : _props$disableReactTr,
      _props$mouseEvent = props.mouseEvent,
      mouseEvent = _props$mouseEvent === void 0 ? 'onClick' : _props$mouseEvent,
      onClickAway = props.onClickAway,
      _props$touchEvent = props.touchEvent,
      touchEvent = _props$touchEvent === void 0 ? 'onTouchEnd' : _props$touchEvent;
  var movedRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(false);
  var nodeRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null);
  var activatedRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(false);
  var syntheticEventRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(false);
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function () {
    // Ensure that this component is not "activated" synchronously.
    // https://github.com/facebook/react/issues/20074
    setTimeout(function () {
      activatedRef.current = true;
    }, 0);
    return function () {
      activatedRef.current = false;
    };
  }, []); // can be removed once we drop support for non ref forwarding class components

  var handleOwnRef = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function (instance) {
    // #StrictMode ready
    nodeRef.current = react_dom__WEBPACK_IMPORTED_MODULE_1__.findDOMNode(instance);
  }, []);
  var handleRef = (0,_utils_useForkRef__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(children.ref, handleOwnRef); // The handler doesn't take event.defaultPrevented into account:
  //
  // event.preventDefault() is meant to stop default behaviours like
  // clicking a checkbox to check it, hitting a button to submit a form,
  // and hitting left arrow to move the cursor in a text input etc.
  // Only special HTML elements have these default behaviors.

  var handleClickAway = (0,_utils_useEventCallback__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function (event) {
    // Given developers can stop the propagation of the synthetic event,
    // we can only be confident with a positive value.
    var insideReactTree = syntheticEventRef.current;
    syntheticEventRef.current = false; // 1. IE 11 support, which trigger the handleClickAway even after the unbind
    // 2. The child might render null.
    // 3. Behave like a blur listener.

    if (!activatedRef.current || !nodeRef.current || clickedRootScrollbar(event)) {
      return;
    } // Do not act if user performed touchmove


    if (movedRef.current) {
      movedRef.current = false;
      return;
    }

    var insideDOM; // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js

    if (event.composedPath) {
      insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
    } else {
      // TODO v6 remove dead logic https://caniuse.com/#search=composedPath.
      var doc = (0,_utils_ownerDocument__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(nodeRef.current);
      insideDOM = !doc.documentElement.contains(event.target) || nodeRef.current.contains(event.target);
    }

    if (!insideDOM && (disableReactTree || !insideReactTree)) {
      onClickAway(event);
    }
  }); // Keep track of mouse/touch events that bubbled up through the portal.

  var createHandleSynthetic = function createHandleSynthetic(handlerName) {
    return function (event) {
      syntheticEventRef.current = true;
      var childrenPropsHandler = children.props[handlerName];

      if (childrenPropsHandler) {
        childrenPropsHandler(event);
      }
    };
  };

  var childrenProps = {
    ref: handleRef
  };

  if (touchEvent !== false) {
    childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
  }

  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function () {
    if (touchEvent !== false) {
      var mappedTouchEvent = mapEventPropToEvent(touchEvent);
      var doc = (0,_utils_ownerDocument__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(nodeRef.current);

      var handleTouchMove = function handleTouchMove() {
        movedRef.current = true;
      };

      doc.addEventListener(mappedTouchEvent, handleClickAway);
      doc.addEventListener('touchmove', handleTouchMove);
      return function () {
        doc.removeEventListener(mappedTouchEvent, handleClickAway);
        doc.removeEventListener('touchmove', handleTouchMove);
      };
    }

    return undefined;
  }, [handleClickAway, touchEvent]);

  if (mouseEvent !== false) {
    childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
  }

  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function () {
    if (mouseEvent !== false) {
      var mappedMouseEvent = mapEventPropToEvent(mouseEvent);
      var doc = (0,_utils_ownerDocument__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(nodeRef.current);
      doc.addEventListener(mappedMouseEvent, handleClickAway);
      return function () {
        doc.removeEventListener(mappedMouseEvent, handleClickAway);
      };
    }

    return undefined;
  }, [handleClickAway, mouseEvent]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(children, childrenProps));
}

 false ? 0 : void 0;

if (false) {}

/* harmony default export */ __webpack_exports__["Z"] = (ClickAwayListener);

/***/ }),

/***/ 93579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Dialog_Dialog; }
});

// UNUSED EXPORTS: styles

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(45987);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(4942);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js + 1 modules
var withStyles = __webpack_require__(1591);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/capitalize.js
var capitalize = __webpack_require__(93871);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Modal/Modal.js + 3 modules
var Modal = __webpack_require__(5566);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(86854);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/Transition.js + 1 modules
var Transition = __webpack_require__(98885);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/transitions.js
var transitions = __webpack_require__(43366);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/useTheme.js
var useTheme = __webpack_require__(8920);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/transitions/utils.js
var utils = __webpack_require__(5653);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useForkRef.js
var useForkRef = __webpack_require__(17294);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Fade/Fade.js










var styles = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
};
var defaultTimeout = {
  enter: transitions/* duration.enteringScreen */.x9.enteringScreen,
  exit: transitions/* duration.leavingScreen */.x9.leavingScreen
};
/**
 * The Fade transition is used by the [Modal](/components/modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Fade = /*#__PURE__*/react.forwardRef(function Fade(props, ref) {
  var children = props.children,
      _props$disableStrictM = props.disableStrictModeCompat,
      disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM,
      inProp = props.in,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      style = props.style,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? Transition/* default */.ZP : _props$TransitionComp,
      _props$timeout = props.timeout,
      timeout = _props$timeout === void 0 ? defaultTimeout : _props$timeout,
      other = (0,objectWithoutProperties/* default */.Z)(props, ["children", "disableStrictModeCompat", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "TransitionComponent", "timeout"]);

  var theme = (0,useTheme/* default */.Z)();
  var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
  var nodeRef = react.useRef(null);
  var foreignRef = (0,useForkRef/* default */.Z)(children.ref, ref);
  var handleRef = (0,useForkRef/* default */.Z)(enableStrictModeCompat ? nodeRef : undefined, foreignRef);

  var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
    return function (nodeOrAppearing, maybeAppearing) {
      if (callback) {
        var _ref = enableStrictModeCompat ? [nodeRef.current, nodeOrAppearing] : [nodeOrAppearing, maybeAppearing],
            _ref2 = (0,slicedToArray/* default */.Z)(_ref, 2),
            node = _ref2[0],
            isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.


        if (isAppearing === undefined) {
          callback(node);
        } else {
          callback(node, isAppearing);
        }
      }
    };
  };

  var handleEntering = normalizedTransitionCallback(onEntering);
  var handleEnter = normalizedTransitionCallback(function (node, isAppearing) {
    (0,utils/* reflow */.n)(node); // So the animation always start from the start.

    var transitionProps = (0,utils/* getTransitionProps */.C)({
      style: style,
      timeout: timeout
    }, {
      mode: 'enter'
    });
    node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
    node.style.transition = theme.transitions.create('opacity', transitionProps);

    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  var handleEntered = normalizedTransitionCallback(onEntered);
  var handleExiting = normalizedTransitionCallback(onExiting);
  var handleExit = normalizedTransitionCallback(function (node) {
    var transitionProps = (0,utils/* getTransitionProps */.C)({
      style: style,
      timeout: timeout
    }, {
      mode: 'exit'
    });
    node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
    node.style.transition = theme.transitions.create('opacity', transitionProps);

    if (onExit) {
      onExit(node);
    }
  });
  var handleExited = normalizedTransitionCallback(onExited);
  return /*#__PURE__*/react.createElement(TransitionComponent, (0,esm_extends/* default */.Z)({
    appear: true,
    in: inProp,
    nodeRef: enableStrictModeCompat ? nodeRef : undefined,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    timeout: timeout
  }, other), function (state, childProps) {
    return /*#__PURE__*/react.cloneElement(children, (0,esm_extends/* default */.Z)({
      style: (0,esm_extends/* default */.Z)({
        opacity: 0,
        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
      }, styles[state], style, children.props.style),
      ref: handleRef
    }, childProps));
  });
});
 false ? 0 : void 0;
/* harmony default export */ var Fade_Fade = (Fade);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Backdrop/Backdrop.js







var Backdrop_styles = {
  /* Styles applied to the root element. */
  root: {
    // Improve scrollable dialog support.
    zIndex: -1,
    position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    WebkitTapHighlightColor: 'transparent'
  },

  /* Styles applied to the root element if `invisible={true}`. */
  invisible: {
    backgroundColor: 'transparent'
  }
};
var Backdrop = /*#__PURE__*/react.forwardRef(function Backdrop(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$invisible = props.invisible,
      invisible = _props$invisible === void 0 ? false : _props$invisible,
      open = props.open,
      transitionDuration = props.transitionDuration,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? Fade_Fade : _props$TransitionComp,
      other = (0,objectWithoutProperties/* default */.Z)(props, ["children", "classes", "className", "invisible", "open", "transitionDuration", "TransitionComponent"]);

  return /*#__PURE__*/react.createElement(TransitionComponent, (0,esm_extends/* default */.Z)({
    in: open,
    timeout: transitionDuration
  }, other), /*#__PURE__*/react.createElement("div", {
    className: (0,clsx_m/* default */.Z)(classes.root, className, invisible && classes.invisible),
    "aria-hidden": true,
    ref: ref
  }, children));
});
 false ? 0 : void 0;
/* harmony default export */ var Backdrop_Backdrop = ((0,withStyles/* default */.Z)(Backdrop_styles, {
  name: 'MuiBackdrop'
})(Backdrop));
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Paper/Paper.js
var Paper = __webpack_require__(79895);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Dialog/Dialog.js














var Dialog_styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      '@media print': {
        // Use !important to override the Modal inline-style.
        position: 'absolute !important'
      }
    },

    /* Styles applied to the container element if `scroll="paper"`. */
    scrollPaper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },

    /* Styles applied to the container element if `scroll="body"`. */
    scrollBody: {
      overflowY: 'auto',
      overflowX: 'hidden',
      textAlign: 'center',
      '&:after': {
        content: '""',
        display: 'inline-block',
        verticalAlign: 'middle',
        height: '100%',
        width: '0'
      }
    },

    /* Styles applied to the container element. */
    container: {
      height: '100%',
      '@media print': {
        height: 'auto'
      },
      // We disable the focus ring for mouse, touch and keyboard users.
      outline: 0
    },

    /* Styles applied to the `Paper` component. */
    paper: {
      margin: 32,
      position: 'relative',
      overflowY: 'auto',
      // Fix IE 11 issue, to remove at some point.
      '@media print': {
        overflowY: 'visible',
        boxShadow: 'none'
      }
    },

    /* Styles applied to the `Paper` component if `scroll="paper"`. */
    paperScrollPaper: {
      display: 'flex',
      flexDirection: 'column',
      maxHeight: 'calc(100% - 64px)'
    },

    /* Styles applied to the `Paper` component if `scroll="body"`. */
    paperScrollBody: {
      display: 'inline-block',
      verticalAlign: 'middle',
      textAlign: 'left' // 'initial' doesn't work on IE 11

    },

    /* Styles applied to the `Paper` component if `maxWidth=false`. */
    paperWidthFalse: {
      maxWidth: 'calc(100% - 64px)'
    },

    /* Styles applied to the `Paper` component if `maxWidth="xs"`. */
    paperWidthXs: {
      maxWidth: Math.max(theme.breakpoints.values.xs, 444),
      '&$paperScrollBody': (0,defineProperty/* default */.Z)({}, theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 32 * 2), {
        maxWidth: 'calc(100% - 64px)'
      })
    },

    /* Styles applied to the `Paper` component if `maxWidth="sm"`. */
    paperWidthSm: {
      maxWidth: theme.breakpoints.values.sm,
      '&$paperScrollBody': (0,defineProperty/* default */.Z)({}, theme.breakpoints.down(theme.breakpoints.values.sm + 32 * 2), {
        maxWidth: 'calc(100% - 64px)'
      })
    },

    /* Styles applied to the `Paper` component if `maxWidth="md"`. */
    paperWidthMd: {
      maxWidth: theme.breakpoints.values.md,
      '&$paperScrollBody': (0,defineProperty/* default */.Z)({}, theme.breakpoints.down(theme.breakpoints.values.md + 32 * 2), {
        maxWidth: 'calc(100% - 64px)'
      })
    },

    /* Styles applied to the `Paper` component if `maxWidth="lg"`. */
    paperWidthLg: {
      maxWidth: theme.breakpoints.values.lg,
      '&$paperScrollBody': (0,defineProperty/* default */.Z)({}, theme.breakpoints.down(theme.breakpoints.values.lg + 32 * 2), {
        maxWidth: 'calc(100% - 64px)'
      })
    },

    /* Styles applied to the `Paper` component if `maxWidth="xl"`. */
    paperWidthXl: {
      maxWidth: theme.breakpoints.values.xl,
      '&$paperScrollBody': (0,defineProperty/* default */.Z)({}, theme.breakpoints.down(theme.breakpoints.values.xl + 32 * 2), {
        maxWidth: 'calc(100% - 64px)'
      })
    },

    /* Styles applied to the `Paper` component if `fullWidth={true}`. */
    paperFullWidth: {
      width: 'calc(100% - 64px)'
    },

    /* Styles applied to the `Paper` component if `fullScreen={true}`. */
    paperFullScreen: {
      margin: 0,
      width: '100%',
      maxWidth: '100%',
      height: '100%',
      maxHeight: 'none',
      borderRadius: 0,
      '&$paperScrollBody': {
        margin: 0,
        maxWidth: '100%'
      }
    }
  };
};
var defaultTransitionDuration = {
  enter: transitions/* duration.enteringScreen */.x9.enteringScreen,
  exit: transitions/* duration.leavingScreen */.x9.leavingScreen
};
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */

var Dialog = /*#__PURE__*/react.forwardRef(function Dialog(props, ref) {
  var BackdropProps = props.BackdropProps,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$disableBackdro = props.disableBackdropClick,
      disableBackdropClick = _props$disableBackdro === void 0 ? false : _props$disableBackdro,
      _props$disableEscapeK = props.disableEscapeKeyDown,
      disableEscapeKeyDown = _props$disableEscapeK === void 0 ? false : _props$disableEscapeK,
      _props$fullScreen = props.fullScreen,
      fullScreen = _props$fullScreen === void 0 ? false : _props$fullScreen,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      _props$maxWidth = props.maxWidth,
      maxWidth = _props$maxWidth === void 0 ? 'sm' : _props$maxWidth,
      onBackdropClick = props.onBackdropClick,
      onClose = props.onClose,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onEscapeKeyDown = props.onEscapeKeyDown,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      open = props.open,
      _props$PaperComponent = props.PaperComponent,
      PaperComponent = _props$PaperComponent === void 0 ? Paper/* default */.Z : _props$PaperComponent,
      _props$PaperProps = props.PaperProps,
      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
      _props$scroll = props.scroll,
      scroll = _props$scroll === void 0 ? 'paper' : _props$scroll,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? Fade_Fade : _props$TransitionComp,
      _props$transitionDura = props.transitionDuration,
      transitionDuration = _props$transitionDura === void 0 ? defaultTransitionDuration : _props$transitionDura,
      TransitionProps = props.TransitionProps,
      ariaDescribedby = props['aria-describedby'],
      ariaLabelledby = props['aria-labelledby'],
      other = (0,objectWithoutProperties/* default */.Z)(props, ["BackdropProps", "children", "classes", "className", "disableBackdropClick", "disableEscapeKeyDown", "fullScreen", "fullWidth", "maxWidth", "onBackdropClick", "onClose", "onEnter", "onEntered", "onEntering", "onEscapeKeyDown", "onExit", "onExited", "onExiting", "open", "PaperComponent", "PaperProps", "scroll", "TransitionComponent", "transitionDuration", "TransitionProps", "aria-describedby", "aria-labelledby"]);

  var mouseDownTarget = react.useRef();

  var handleMouseDown = function handleMouseDown(event) {
    mouseDownTarget.current = event.target;
  };

  var handleBackdropClick = function handleBackdropClick(event) {
    // Ignore the events not coming from the "backdrop"
    // We don't want to close the dialog when clicking the dialog content.
    if (event.target !== event.currentTarget) {
      return;
    } // Make sure the event starts and ends on the same DOM element.


    if (event.target !== mouseDownTarget.current) {
      return;
    }

    mouseDownTarget.current = null;

    if (onBackdropClick) {
      onBackdropClick(event);
    }

    if (!disableBackdropClick && onClose) {
      onClose(event, 'backdropClick');
    }
  };

  return /*#__PURE__*/react.createElement(Modal/* default */.Z, (0,esm_extends/* default */.Z)({
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    BackdropComponent: Backdrop_Backdrop,
    BackdropProps: (0,esm_extends/* default */.Z)({
      transitionDuration: transitionDuration
    }, BackdropProps),
    closeAfterTransition: true
  }, disableBackdropClick ? {
    disableBackdropClick: disableBackdropClick
  } : {}, {
    disableEscapeKeyDown: disableEscapeKeyDown,
    onEscapeKeyDown: onEscapeKeyDown,
    onClose: onClose,
    open: open,
    ref: ref
  }, other), /*#__PURE__*/react.createElement(TransitionComponent, (0,esm_extends/* default */.Z)({
    appear: true,
    in: open,
    timeout: transitionDuration,
    onEnter: onEnter,
    onEntering: onEntering,
    onEntered: onEntered,
    onExit: onExit,
    onExiting: onExiting,
    onExited: onExited,
    role: "none presentation"
  }, TransitionProps), /*#__PURE__*/react.createElement("div", {
    className: (0,clsx_m/* default */.Z)(classes.container, classes["scroll".concat((0,capitalize/* default */.Z)(scroll))]),
    onMouseUp: handleBackdropClick,
    onMouseDown: handleMouseDown
  }, /*#__PURE__*/react.createElement(PaperComponent, (0,esm_extends/* default */.Z)({
    elevation: 24,
    role: "dialog",
    "aria-describedby": ariaDescribedby,
    "aria-labelledby": ariaLabelledby
  }, PaperProps, {
    className: (0,clsx_m/* default */.Z)(classes.paper, classes["paperScroll".concat((0,capitalize/* default */.Z)(scroll))], classes["paperWidth".concat((0,capitalize/* default */.Z)(String(maxWidth)))], PaperProps.className, fullScreen && classes.paperFullScreen, fullWidth && classes.paperFullWidth)
  }), children))));
});
 false ? 0 : void 0;
/* harmony default export */ var Dialog_Dialog = ((0,withStyles/* default */.Z)(Dialog_styles, {
  name: 'MuiDialog'
})(Dialog));

/***/ }),

/***/ 20170:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86854);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_transition_group__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98885);
/* harmony import */ var _styles_useTheme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8920);
/* harmony import */ var _transitions_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5653);
/* harmony import */ var _utils_useForkRef__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17294);










function getScale(value) {
  return "scale(".concat(value, ", ").concat(Math.pow(value, 2), ")");
}

var styles = {
  entering: {
    opacity: 1,
    transform: getScale(1)
  },
  entered: {
    opacity: 1,
    transform: 'none'
  }
};
/**
 * The Grow transition is used by the [Tooltip](/components/tooltips/) and
 * [Popover](/components/popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Grow = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Grow(props, ref) {
  var children = props.children,
      _props$disableStrictM = props.disableStrictModeCompat,
      disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM,
      inProp = props.in,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      style = props.style,
      _props$timeout = props.timeout,
      timeout = _props$timeout === void 0 ? 'auto' : _props$timeout,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? react_transition_group__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP : _props$TransitionComp,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, ["children", "disableStrictModeCompat", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"]);

  var timer = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  var autoTimeout = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  var theme = (0,_styles_useTheme__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
  var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
  var nodeRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null);
  var foreignRef = (0,_utils_useForkRef__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(children.ref, ref);
  var handleRef = (0,_utils_useForkRef__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(enableStrictModeCompat ? nodeRef : undefined, foreignRef);

  var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
    return function (nodeOrAppearing, maybeAppearing) {
      if (callback) {
        var _ref = enableStrictModeCompat ? [nodeRef.current, nodeOrAppearing] : [nodeOrAppearing, maybeAppearing],
            _ref2 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, 2),
            node = _ref2[0],
            isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.


        if (isAppearing === undefined) {
          callback(node);
        } else {
          callback(node, isAppearing);
        }
      }
    };
  };

  var handleEntering = normalizedTransitionCallback(onEntering);
  var handleEnter = normalizedTransitionCallback(function (node, isAppearing) {
    (0,_transitions_utils__WEBPACK_IMPORTED_MODULE_6__/* .reflow */ .n)(node); // So the animation always start from the start.

    var _getTransitionProps = (0,_transitions_utils__WEBPACK_IMPORTED_MODULE_6__/* .getTransitionProps */ .C)({
      style: style,
      timeout: timeout
    }, {
      mode: 'enter'
    }),
        transitionDuration = _getTransitionProps.duration,
        delay = _getTransitionProps.delay;

    var duration;

    if (timeout === 'auto') {
      duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
      autoTimeout.current = duration;
    } else {
      duration = transitionDuration;
    }

    node.style.transition = [theme.transitions.create('opacity', {
      duration: duration,
      delay: delay
    }), theme.transitions.create('transform', {
      duration: duration * 0.666,
      delay: delay
    })].join(',');

    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  var handleEntered = normalizedTransitionCallback(onEntered);
  var handleExiting = normalizedTransitionCallback(onExiting);
  var handleExit = normalizedTransitionCallback(function (node) {
    var _getTransitionProps2 = (0,_transitions_utils__WEBPACK_IMPORTED_MODULE_6__/* .getTransitionProps */ .C)({
      style: style,
      timeout: timeout
    }, {
      mode: 'exit'
    }),
        transitionDuration = _getTransitionProps2.duration,
        delay = _getTransitionProps2.delay;

    var duration;

    if (timeout === 'auto') {
      duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
      autoTimeout.current = duration;
    } else {
      duration = transitionDuration;
    }

    node.style.transition = [theme.transitions.create('opacity', {
      duration: duration,
      delay: delay
    }), theme.transitions.create('transform', {
      duration: duration * 0.666,
      delay: delay || duration * 0.333
    })].join(',');
    node.style.opacity = '0';
    node.style.transform = getScale(0.75);

    if (onExit) {
      onExit(node);
    }
  });
  var handleExited = normalizedTransitionCallback(onExited);

  var addEndListener = function addEndListener(nodeOrNext, maybeNext) {
    var next = enableStrictModeCompat ? nodeOrNext : maybeNext;

    if (timeout === 'auto') {
      timer.current = setTimeout(next, autoTimeout.current || 0);
    }
  };

  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function () {
    return function () {
      clearTimeout(timer.current);
    };
  }, []);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(TransitionComponent, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
    appear: true,
    in: inProp,
    nodeRef: enableStrictModeCompat ? nodeRef : undefined,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: addEndListener,
    timeout: timeout === 'auto' ? null : timeout
  }, other), function (state, childProps) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(children, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
      style: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        opacity: 0,
        transform: getScale(0.75),
        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
      }, styles[state], style, children.props.style),
      ref: handleRef
    }, childProps));
  });
});
 false ? 0 : void 0;
Grow.muiSupportAuto = true;
/* harmony default export */ __webpack_exports__["Z"] = (Grow);

/***/ }),

/***/ 17812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86010);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1591);
/* harmony import */ var _styles_colorManipulator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59693);
/* harmony import */ var _ButtonBase__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4024);
/* harmony import */ var _utils_capitalize__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93871);










var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      textAlign: 'center',
      flex: '0 0 auto',
      fontSize: theme.typography.pxToRem(24),
      padding: 12,
      borderRadius: '50%',
      overflow: 'visible',
      // Explicitly set the default value to solve a bug on IE 11.
      color: theme.palette.action.active,
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shortest
      }),
      '&:hover': {
        backgroundColor: (0,_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_1__/* .alpha */ .Fq)(theme.palette.action.active, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      },
      '&$disabled': {
        backgroundColor: 'transparent',
        color: theme.palette.action.disabled
      }
    },

    /* Styles applied to the root element if `edge="start"`. */
    edgeStart: {
      marginLeft: -12,
      '$sizeSmall&': {
        marginLeft: -3
      }
    },

    /* Styles applied to the root element if `edge="end"`. */
    edgeEnd: {
      marginRight: -12,
      '$sizeSmall&': {
        marginRight: -3
      }
    },

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: (0,_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_1__/* .alpha */ .Fq)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: (0,_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_1__/* .alpha */ .Fq)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      padding: 3,
      fontSize: theme.typography.pxToRem(18)
    },

    /* Styles applied to the children container element. */
    label: {
      width: '100%',
      display: 'flex',
      alignItems: 'inherit',
      justifyContent: 'inherit'
    }
  };
};
/**
 * Refer to the [Icons](/components/icons/) section of the documentation
 * regarding the available icon options.
 */

var IconButton = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function IconButton(props, ref) {
  var _props$edge = props.edge,
      edge = _props$edge === void 0 ? false : _props$edge,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableFocusRi = props.disableFocusRipple,
      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, ["edge", "children", "classes", "className", "color", "disabled", "disableFocusRipple", "size"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ButtonBase__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(classes.root, className, color !== 'default' && classes["color".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(color))], disabled && classes.disabled, size === "small" && classes["size".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(size))], {
      'start': classes.edgeStart,
      'end': classes.edgeEnd
    }[edge]),
    centerRipple: true,
    focusRipple: !disableFocusRipple,
    disabled: disabled,
    ref: ref
  }, other), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: classes.label
  }, children));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(styles, {
  name: 'MuiIconButton'
})(IconButton));

/***/ }),

/***/ 5566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Modal_Modal; }
});

// UNUSED EXPORTS: styles

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(45987);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/@material-ui/styles/esm/useTheme/useTheme.js
var useTheme = __webpack_require__(159);
// EXTERNAL MODULE: ./node_modules/@material-ui/styles/esm/getThemeProps/getThemeProps.js
var getThemeProps = __webpack_require__(93869);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/ownerDocument.js
var ownerDocument = __webpack_require__(30626);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Portal/Portal.js
var Portal = __webpack_require__(76234);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/createChainedFunction.js
var createChainedFunction = __webpack_require__(82568);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useForkRef.js
var useForkRef = __webpack_require__(17294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useEventCallback.js
var useEventCallback = __webpack_require__(55192);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/zIndex.js
var zIndex = __webpack_require__(92781);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(15671);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(43144);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(41451);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/getScrollbarSize.js
var getScrollbarSize = __webpack_require__(75840);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/ownerWindow.js
var ownerWindow = __webpack_require__(80713);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Modal/ModalManager.js





 // Is a vertical scrollbar displayed?

function isOverflowing(container) {
  var doc = (0,ownerDocument/* default */.Z)(container);

  if (doc.body === container) {
    return (0,ownerWindow/* default */.Z)(doc).innerWidth > doc.documentElement.clientWidth;
  }

  return container.scrollHeight > container.clientHeight;
}

function ariaHidden(node, show) {
  if (show) {
    node.setAttribute('aria-hidden', 'true');
  } else {
    node.removeAttribute('aria-hidden');
  }
}

function getPaddingRight(node) {
  return parseInt(window.getComputedStyle(node)['padding-right'], 10) || 0;
}

function ariaHiddenSiblings(container, mountNode, currentNode) {
  var nodesToExclude = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var show = arguments.length > 4 ? arguments[4] : undefined;
  var blacklist = [mountNode, currentNode].concat((0,toConsumableArray/* default */.Z)(nodesToExclude));
  var blacklistTagNames = ['TEMPLATE', 'SCRIPT', 'STYLE'];
  [].forEach.call(container.children, function (node) {
    if (node.nodeType === 1 && blacklist.indexOf(node) === -1 && blacklistTagNames.indexOf(node.tagName) === -1) {
      ariaHidden(node, show);
    }
  });
}

function findIndexOf(containerInfo, callback) {
  var idx = -1;
  containerInfo.some(function (item, index) {
    if (callback(item)) {
      idx = index;
      return true;
    }

    return false;
  });
  return idx;
}

function handleContainer(containerInfo, props) {
  var restoreStyle = [];
  var restorePaddings = [];
  var container = containerInfo.container;
  var fixedNodes;

  if (!props.disableScrollLock) {
    if (isOverflowing(container)) {
      // Compute the size before applying overflow hidden to avoid any scroll jumps.
      var scrollbarSize = (0,getScrollbarSize/* default */.Z)();
      restoreStyle.push({
        value: container.style.paddingRight,
        key: 'padding-right',
        el: container
      }); // Use computed style, here to get the real padding to add our scrollbar width.

      container.style['padding-right'] = "".concat(getPaddingRight(container) + scrollbarSize, "px"); // .mui-fixed is a global helper.

      fixedNodes = (0,ownerDocument/* default */.Z)(container).querySelectorAll('.mui-fixed');
      [].forEach.call(fixedNodes, function (node) {
        restorePaddings.push(node.style.paddingRight);
        node.style.paddingRight = "".concat(getPaddingRight(node) + scrollbarSize, "px");
      });
    } // Improve Gatsby support
    // https://css-tricks.com/snippets/css/force-vertical-scrollbar/


    var parent = container.parentElement;
    var scrollContainer = parent.nodeName === 'HTML' && window.getComputedStyle(parent)['overflow-y'] === 'scroll' ? parent : container; // Block the scroll even if no scrollbar is visible to account for mobile keyboard
    // screensize shrink.

    restoreStyle.push({
      value: scrollContainer.style.overflow,
      key: 'overflow',
      el: scrollContainer
    });
    scrollContainer.style.overflow = 'hidden';
  }

  var restore = function restore() {
    if (fixedNodes) {
      [].forEach.call(fixedNodes, function (node, i) {
        if (restorePaddings[i]) {
          node.style.paddingRight = restorePaddings[i];
        } else {
          node.style.removeProperty('padding-right');
        }
      });
    }

    restoreStyle.forEach(function (_ref) {
      var value = _ref.value,
          el = _ref.el,
          key = _ref.key;

      if (value) {
        el.style.setProperty(key, value);
      } else {
        el.style.removeProperty(key);
      }
    });
  };

  return restore;
}

function getHiddenSiblings(container) {
  var hiddenSiblings = [];
  [].forEach.call(container.children, function (node) {
    if (node.getAttribute && node.getAttribute('aria-hidden') === 'true') {
      hiddenSiblings.push(node);
    }
  });
  return hiddenSiblings;
}
/**
 * @ignore - do not document.
 *
 * Proper state management for containers and the modals in those containers.
 * Simplified, but inspired by react-overlay's ModalManager class.
 * Used by the Modal to ensure proper styling of containers.
 */


var ModalManager = /*#__PURE__*/function () {
  function ModalManager() {
    (0,classCallCheck/* default */.Z)(this, ModalManager);

    // this.modals[modalIndex] = modal
    this.modals = []; // this.containers[containerIndex] = {
    //   modals: [],
    //   container,
    //   restore: null,
    // }

    this.containers = [];
  }

  (0,createClass/* default */.Z)(ModalManager, [{
    key: "add",
    value: function add(modal, container) {
      var modalIndex = this.modals.indexOf(modal);

      if (modalIndex !== -1) {
        return modalIndex;
      }

      modalIndex = this.modals.length;
      this.modals.push(modal); // If the modal we are adding is already in the DOM.

      if (modal.modalRef) {
        ariaHidden(modal.modalRef, false);
      }

      var hiddenSiblingNodes = getHiddenSiblings(container);
      ariaHiddenSiblings(container, modal.mountNode, modal.modalRef, hiddenSiblingNodes, true);
      var containerIndex = findIndexOf(this.containers, function (item) {
        return item.container === container;
      });

      if (containerIndex !== -1) {
        this.containers[containerIndex].modals.push(modal);
        return modalIndex;
      }

      this.containers.push({
        modals: [modal],
        container: container,
        restore: null,
        hiddenSiblingNodes: hiddenSiblingNodes
      });
      return modalIndex;
    }
  }, {
    key: "mount",
    value: function mount(modal, props) {
      var containerIndex = findIndexOf(this.containers, function (item) {
        return item.modals.indexOf(modal) !== -1;
      });
      var containerInfo = this.containers[containerIndex];

      if (!containerInfo.restore) {
        containerInfo.restore = handleContainer(containerInfo, props);
      }
    }
  }, {
    key: "remove",
    value: function remove(modal) {
      var modalIndex = this.modals.indexOf(modal);

      if (modalIndex === -1) {
        return modalIndex;
      }

      var containerIndex = findIndexOf(this.containers, function (item) {
        return item.modals.indexOf(modal) !== -1;
      });
      var containerInfo = this.containers[containerIndex];
      containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
      this.modals.splice(modalIndex, 1); // If that was the last modal in a container, clean up the container.

      if (containerInfo.modals.length === 0) {
        // The modal might be closed before it had the chance to be mounted in the DOM.
        if (containerInfo.restore) {
          containerInfo.restore();
        }

        if (modal.modalRef) {
          // In case the modal wasn't in the DOM yet.
          ariaHidden(modal.modalRef, true);
        }

        ariaHiddenSiblings(containerInfo.container, modal.mountNode, modal.modalRef, containerInfo.hiddenSiblingNodes, false);
        this.containers.splice(containerIndex, 1);
      } else {
        // Otherwise make sure the next top modal is visible to a screen reader.
        var nextTop = containerInfo.modals[containerInfo.modals.length - 1]; // as soon as a modal is adding its modalRef is undefined. it can't set
        // aria-hidden because the dom element doesn't exist either
        // when modal was unmounted before modalRef gets null

        if (nextTop.modalRef) {
          ariaHidden(nextTop.modalRef, false);
        }
      }

      return modalIndex;
    }
  }, {
    key: "isTopModal",
    value: function isTopModal(modal) {
      return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
  }]);

  return ModalManager;
}();


;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Unstable_TrapFocus/Unstable_TrapFocus.js
/* eslint-disable consistent-return, jsx-a11y/no-noninteractive-tabindex, camelcase */






/**
 * Utility component that locks focus inside the component.
 */

function Unstable_TrapFocus(props) {
  var children = props.children,
      _props$disableAutoFoc = props.disableAutoFocus,
      disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc,
      _props$disableEnforce = props.disableEnforceFocus,
      disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce,
      _props$disableRestore = props.disableRestoreFocus,
      disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore,
      getDoc = props.getDoc,
      isEnabled = props.isEnabled,
      open = props.open;
  var ignoreNextEnforceFocus = react.useRef();
  var sentinelStart = react.useRef(null);
  var sentinelEnd = react.useRef(null);
  var nodeToRestore = react.useRef();
  var rootRef = react.useRef(null); // can be removed once we drop support for non ref forwarding class components

  var handleOwnRef = react.useCallback(function (instance) {
    // #StrictMode ready
    rootRef.current = react_dom.findDOMNode(instance);
  }, []);
  var handleRef = (0,useForkRef/* default */.Z)(children.ref, handleOwnRef);
  var prevOpenRef = react.useRef();
  react.useEffect(function () {
    prevOpenRef.current = open;
  }, [open]);

  if (!prevOpenRef.current && open && typeof window !== 'undefined') {
    // WARNING: Potentially unsafe in concurrent mode.
    // The way the read on `nodeToRestore` is setup could make this actually safe.
    // Say we render `open={false}` -> `open={true}` but never commit.
    // We have now written a state that wasn't committed. But no committed effect
    // will read this wrong value. We only read from `nodeToRestore` in effects
    // that were committed on `open={true}`
    // WARNING: Prevents the instance from being garbage collected. Should only
    // hold a weak ref.
    nodeToRestore.current = getDoc().activeElement;
  }

  react.useEffect(function () {
    if (!open) {
      return;
    }

    var doc = (0,ownerDocument/* default */.Z)(rootRef.current); // We might render an empty child.

    if (!disableAutoFocus && rootRef.current && !rootRef.current.contains(doc.activeElement)) {
      if (!rootRef.current.hasAttribute('tabIndex')) {
        if (false) {}

        rootRef.current.setAttribute('tabIndex', -1);
      }

      rootRef.current.focus();
    }

    var contain = function contain() {
      var rootElement = rootRef.current; // Cleanup functions are executed lazily in React 17.
      // Contain can be called between the component being unmounted and its cleanup function being run.

      if (rootElement === null) {
        return;
      }

      if (!doc.hasFocus() || disableEnforceFocus || !isEnabled() || ignoreNextEnforceFocus.current) {
        ignoreNextEnforceFocus.current = false;
        return;
      }

      if (rootRef.current && !rootRef.current.contains(doc.activeElement)) {
        rootRef.current.focus();
      }
    };

    var loopFocus = function loopFocus(event) {
      // 9 = Tab
      if (disableEnforceFocus || !isEnabled() || event.keyCode !== 9) {
        return;
      } // Make sure the next tab starts from the right place.


      if (doc.activeElement === rootRef.current) {
        // We need to ignore the next contain as
        // it will try to move the focus back to the rootRef element.
        ignoreNextEnforceFocus.current = true;

        if (event.shiftKey) {
          sentinelEnd.current.focus();
        } else {
          sentinelStart.current.focus();
        }
      }
    };

    doc.addEventListener('focus', contain, true);
    doc.addEventListener('keydown', loopFocus, true); // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area
    // e.g. https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
    //
    // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
    // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.

    var interval = setInterval(function () {
      contain();
    }, 50);
    return function () {
      clearInterval(interval);
      doc.removeEventListener('focus', contain, true);
      doc.removeEventListener('keydown', loopFocus, true); // restoreLastFocus()

      if (!disableRestoreFocus) {
        // In IE 11 it is possible for document.activeElement to be null resulting
        // in nodeToRestore.current being null.
        // Not all elements in IE 11 have a focus method.
        // Once IE 11 support is dropped the focus() call can be unconditional.
        if (nodeToRestore.current && nodeToRestore.current.focus) {
          nodeToRestore.current.focus();
        }

        nodeToRestore.current = null;
      }
    };
  }, [disableAutoFocus, disableEnforceFocus, disableRestoreFocus, isEnabled, open]);
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("div", {
    tabIndex: 0,
    ref: sentinelStart,
    "data-test": "sentinelStart"
  }), /*#__PURE__*/react.cloneElement(children, {
    ref: handleRef
  }), /*#__PURE__*/react.createElement("div", {
    tabIndex: 0,
    ref: sentinelEnd,
    "data-test": "sentinelEnd"
  }));
}

 false ? 0 : void 0;

if (false) {}

/* harmony default export */ var Unstable_TrapFocus_Unstable_TrapFocus = (Unstable_TrapFocus);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Modal/SimpleBackdrop.js




var styles = {
  /* Styles applied to the root element. */
  root: {
    zIndex: -1,
    position: 'fixed',
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    WebkitTapHighlightColor: 'transparent'
  },

  /* Styles applied to the root element if `invisible={true}`. */
  invisible: {
    backgroundColor: 'transparent'
  }
};
/**
 * @ignore - internal component.
 */

var SimpleBackdrop = /*#__PURE__*/react.forwardRef(function SimpleBackdrop(props, ref) {
  var _props$invisible = props.invisible,
      invisible = _props$invisible === void 0 ? false : _props$invisible,
      open = props.open,
      other = (0,objectWithoutProperties/* default */.Z)(props, ["invisible", "open"]);

  return open ? /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({
    "aria-hidden": true,
    ref: ref
  }, other, {
    style: (0,esm_extends/* default */.Z)({}, styles.root, invisible ? styles.invisible : {}, other.style)
  })) : null;
});
 false ? 0 : void 0;
/* harmony default export */ var Modal_SimpleBackdrop = (SimpleBackdrop);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Modal/Modal.js


















function getContainer(container) {
  container = typeof container === 'function' ? container() : container;
  return react_dom.findDOMNode(container);
}

function getHasTransition(props) {
  return props.children ? props.children.props.hasOwnProperty('in') : false;
} // A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.


var defaultManager = new ModalManager();
var Modal_styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'fixed',
      zIndex: theme.zIndex.modal,
      right: 0,
      bottom: 0,
      top: 0,
      left: 0
    },

    /* Styles applied to the root element if the `Modal` has exited. */
    hidden: {
      visibility: 'hidden'
    }
  };
};
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/api/dialog/)
 * - [Drawer](/api/drawer/)
 * - [Menu](/api/menu/)
 * - [Popover](/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */

var Modal = /*#__PURE__*/react.forwardRef(function Modal(inProps, ref) {
  var theme = (0,useTheme/* default */.Z)();
  var props = (0,getThemeProps/* default */.Z)({
    name: 'MuiModal',
    props: (0,esm_extends/* default */.Z)({}, inProps),
    theme: theme
  });

  var _props$BackdropCompon = props.BackdropComponent,
      BackdropComponent = _props$BackdropCompon === void 0 ? Modal_SimpleBackdrop : _props$BackdropCompon,
      BackdropProps = props.BackdropProps,
      children = props.children,
      _props$closeAfterTran = props.closeAfterTransition,
      closeAfterTransition = _props$closeAfterTran === void 0 ? false : _props$closeAfterTran,
      container = props.container,
      _props$disableAutoFoc = props.disableAutoFocus,
      disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc,
      _props$disableBackdro = props.disableBackdropClick,
      disableBackdropClick = _props$disableBackdro === void 0 ? false : _props$disableBackdro,
      _props$disableEnforce = props.disableEnforceFocus,
      disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce,
      _props$disableEscapeK = props.disableEscapeKeyDown,
      disableEscapeKeyDown = _props$disableEscapeK === void 0 ? false : _props$disableEscapeK,
      _props$disablePortal = props.disablePortal,
      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal,
      _props$disableRestore = props.disableRestoreFocus,
      disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore,
      _props$disableScrollL = props.disableScrollLock,
      disableScrollLock = _props$disableScrollL === void 0 ? false : _props$disableScrollL,
      _props$hideBackdrop = props.hideBackdrop,
      hideBackdrop = _props$hideBackdrop === void 0 ? false : _props$hideBackdrop,
      _props$keepMounted = props.keepMounted,
      keepMounted = _props$keepMounted === void 0 ? false : _props$keepMounted,
      _props$manager = props.manager,
      manager = _props$manager === void 0 ? defaultManager : _props$manager,
      onBackdropClick = props.onBackdropClick,
      onClose = props.onClose,
      onEscapeKeyDown = props.onEscapeKeyDown,
      onRendered = props.onRendered,
      open = props.open,
      other = (0,objectWithoutProperties/* default */.Z)(props, ["BackdropComponent", "BackdropProps", "children", "closeAfterTransition", "container", "disableAutoFocus", "disableBackdropClick", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "manager", "onBackdropClick", "onClose", "onEscapeKeyDown", "onRendered", "open"]);

  var _React$useState = react.useState(true),
      exited = _React$useState[0],
      setExited = _React$useState[1];

  var modal = react.useRef({});
  var mountNodeRef = react.useRef(null);
  var modalRef = react.useRef(null);
  var handleRef = (0,useForkRef/* default */.Z)(modalRef, ref);
  var hasTransition = getHasTransition(props);

  var getDoc = function getDoc() {
    return (0,ownerDocument/* default */.Z)(mountNodeRef.current);
  };

  var getModal = function getModal() {
    modal.current.modalRef = modalRef.current;
    modal.current.mountNode = mountNodeRef.current;
    return modal.current;
  };

  var handleMounted = function handleMounted() {
    manager.mount(getModal(), {
      disableScrollLock: disableScrollLock
    }); // Fix a bug on Chrome where the scroll isn't initially 0.

    modalRef.current.scrollTop = 0;
  };

  var handleOpen = (0,useEventCallback/* default */.Z)(function () {
    var resolvedContainer = getContainer(container) || getDoc().body;
    manager.add(getModal(), resolvedContainer); // The element was already mounted.

    if (modalRef.current) {
      handleMounted();
    }
  });
  var isTopModal = react.useCallback(function () {
    return manager.isTopModal(getModal());
  }, [manager]);
  var handlePortalRef = (0,useEventCallback/* default */.Z)(function (node) {
    mountNodeRef.current = node;

    if (!node) {
      return;
    }

    if (onRendered) {
      onRendered();
    }

    if (open && isTopModal()) {
      handleMounted();
    } else {
      ariaHidden(modalRef.current, true);
    }
  });
  var handleClose = react.useCallback(function () {
    manager.remove(getModal());
  }, [manager]);
  react.useEffect(function () {
    return function () {
      handleClose();
    };
  }, [handleClose]);
  react.useEffect(function () {
    if (open) {
      handleOpen();
    } else if (!hasTransition || !closeAfterTransition) {
      handleClose();
    }
  }, [open, handleClose, hasTransition, closeAfterTransition, handleOpen]);

  if (!keepMounted && !open && (!hasTransition || exited)) {
    return null;
  }

  var handleEnter = function handleEnter() {
    setExited(false);
  };

  var handleExited = function handleExited() {
    setExited(true);

    if (closeAfterTransition) {
      handleClose();
    }
  };

  var handleBackdropClick = function handleBackdropClick(event) {
    if (event.target !== event.currentTarget) {
      return;
    }

    if (onBackdropClick) {
      onBackdropClick(event);
    }

    if (!disableBackdropClick && onClose) {
      onClose(event, 'backdropClick');
    }
  };

  var handleKeyDown = function handleKeyDown(event) {
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviours like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    if (event.key !== 'Escape' || !isTopModal()) {
      return;
    }

    if (onEscapeKeyDown) {
      onEscapeKeyDown(event);
    }

    if (!disableEscapeKeyDown) {
      // Swallow the event, in case someone is listening for the escape key on the body.
      event.stopPropagation();

      if (onClose) {
        onClose(event, 'escapeKeyDown');
      }
    }
  };

  var inlineStyle = Modal_styles(theme || {
    zIndex: zIndex/* default */.Z
  });
  var childProps = {};

  if (children.props.tabIndex === undefined) {
    childProps.tabIndex = children.props.tabIndex || '-1';
  } // It's a Transition like component


  if (hasTransition) {
    childProps.onEnter = (0,createChainedFunction/* default */.Z)(handleEnter, children.props.onEnter);
    childProps.onExited = (0,createChainedFunction/* default */.Z)(handleExited, children.props.onExited);
  }

  return /*#__PURE__*/react.createElement(Portal/* default */.Z, {
    ref: handlePortalRef,
    container: container,
    disablePortal: disablePortal
  }, /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({
    ref: handleRef,
    onKeyDown: handleKeyDown,
    role: "presentation"
  }, other, {
    style: (0,esm_extends/* default */.Z)({}, inlineStyle.root, !open && exited ? inlineStyle.hidden : {}, other.style)
  }), hideBackdrop ? null : /*#__PURE__*/react.createElement(BackdropComponent, (0,esm_extends/* default */.Z)({
    open: open,
    onClick: handleBackdropClick
  }, BackdropProps)), /*#__PURE__*/react.createElement(Unstable_TrapFocus_Unstable_TrapFocus, {
    disableEnforceFocus: disableEnforceFocus,
    disableAutoFocus: disableAutoFocus,
    disableRestoreFocus: disableRestoreFocus,
    getDoc: getDoc,
    isEnabled: isTopModal,
    open: open
  }, /*#__PURE__*/react.cloneElement(children, childProps))));
});
 false ? 0 : void 0;
/* harmony default export */ var Modal_Modal = (Modal);

/***/ }),

/***/ 79895:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45987);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87462);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86010);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1591);







var styles = function styles(theme) {
  var elevations = {};
  theme.shadows.forEach(function (shadow, index) {
    elevations["elevation".concat(index)] = {
      boxShadow: shadow
    };
  });
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    /* Styles applied to the root element. */
    root: {
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.primary,
      transition: theme.transitions.create('box-shadow')
    },

    /* Styles applied to the root element if `square={false}`. */
    rounded: {
      borderRadius: theme.shape.borderRadius
    },

    /* Styles applied to the root element if `variant="outlined"`. */
    outlined: {
      border: "1px solid ".concat(theme.palette.divider)
    }
  }, elevations);
};
var Paper = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Paper(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$square = props.square,
      square = _props$square === void 0 ? false : _props$square,
      _props$elevation = props.elevation,
      elevation = _props$elevation === void 0 ? 1 : _props$elevation,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'elevation' : _props$variant,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, ["classes", "className", "component", "square", "elevation", "variant"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(classes.root, className, variant === 'outlined' ? classes.outlined : classes["elevation".concat(elevation)], !square && classes.rounded),
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(styles, {
  name: 'MuiPaper'
})(Paper));

/***/ }),

/***/ 76234:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73935);
/* harmony import */ var _utils_setRef__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34236);
/* harmony import */ var _utils_useForkRef__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17294);








function getContainer(container) {
  container = typeof container === 'function' ? container() : container; // #StrictMode ready

  return react_dom__WEBPACK_IMPORTED_MODULE_1__.findDOMNode(container);
}

var useEnhancedEffect = typeof window !== 'undefined' ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_0__.useEffect;
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 */

var Portal = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Portal(props, ref) {
  var children = props.children,
      container = props.container,
      _props$disablePortal = props.disablePortal,
      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal,
      onRendered = props.onRendered;

  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState(null),
      mountNode = _React$useState[0],
      setMountNode = _React$useState[1];

  var handleRef = (0,_utils_useForkRef__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(children) ? children.ref : null, ref);
  useEnhancedEffect(function () {
    if (!disablePortal) {
      setMountNode(getContainer(container) || document.body);
    }
  }, [container, disablePortal]);
  useEnhancedEffect(function () {
    if (mountNode && !disablePortal) {
      (0,_utils_setRef__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(ref, mountNode);
      return function () {
        (0,_utils_setRef__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(ref, null);
      };
    }

    return undefined;
  }, [ref, mountNode, disablePortal]);
  useEnhancedEffect(function () {
    if (onRendered && (mountNode || disablePortal)) {
      onRendered();
    }
  }, [onRendered, mountNode, disablePortal]);

  if (disablePortal) {
    if ( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(children)) {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(children, {
        ref: handleRef
      });
    }

    return children;
  }

  return mountNode ? /*#__PURE__*/react_dom__WEBPACK_IMPORTED_MODULE_1__.createPortal(children, mountNode) : mountNode;
});
 false ? 0 : void 0;

if (false) {}

/* harmony default export */ __webpack_exports__["Z"] = (Portal);

/***/ }),

/***/ 62087:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86010);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1591);
/* harmony import */ var _utils_capitalize__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93871);








var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      userSelect: 'none',
      width: '1em',
      height: '1em',
      display: 'inline-block',
      fill: 'currentColor',
      flexShrink: 0,
      fontSize: theme.typography.pxToRem(24),
      transition: theme.transitions.create('fill', {
        duration: theme.transitions.duration.shorter
      })
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the root element if `color="action"`. */
    colorAction: {
      color: theme.palette.action.active
    },

    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: theme.palette.error.main
    },

    /* Styles applied to the root element if `color="disabled"`. */
    colorDisabled: {
      color: theme.palette.action.disabled
    },

    /* Styles applied to the root element if `fontSize="inherit"`. */
    fontSizeInherit: {
      fontSize: 'inherit'
    },

    /* Styles applied to the root element if `fontSize="small"`. */
    fontSizeSmall: {
      fontSize: theme.typography.pxToRem(20)
    },

    /* Styles applied to the root element if `fontSize="large"`. */
    fontSizeLarge: {
      fontSize: theme.typography.pxToRem(35)
    }
  };
};
var SvgIcon = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function SvgIcon(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'inherit' : _props$color,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'svg' : _props$component,
      _props$fontSize = props.fontSize,
      fontSize = _props$fontSize === void 0 ? 'medium' : _props$fontSize,
      htmlColor = props.htmlColor,
      titleAccess = props.titleAccess,
      _props$viewBox = props.viewBox,
      viewBox = _props$viewBox === void 0 ? '0 0 24 24' : _props$viewBox,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props, ["children", "classes", "className", "color", "component", "fontSize", "htmlColor", "titleAccess", "viewBox"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(classes.root, className, color !== 'inherit' && classes["color".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(color))], fontSize !== 'default' && fontSize !== 'medium' && classes["fontSize".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(fontSize))]),
    focusable: "false",
    viewBox: viewBox,
    color: htmlColor,
    "aria-hidden": titleAccess ? undefined : true,
    role: titleAccess ? 'img' : undefined,
    ref: ref
  }, other), children, titleAccess ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", null, titleAccess) : null);
});
 false ? 0 : void 0;
SvgIcon.muiName = 'SvgIcon';
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(styles, {
  name: 'MuiSvgIcon'
})(SvgIcon));

/***/ }),

/***/ 59693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$n": function() { return /* binding */ lighten; },
/* harmony export */   "Fq": function() { return /* binding */ alpha; },
/* harmony export */   "U1": function() { return /* binding */ fade; },
/* harmony export */   "_4": function() { return /* binding */ emphasize; },
/* harmony export */   "_j": function() { return /* binding */ darken; },
/* harmony export */   "mi": function() { return /* binding */ getContrastRatio; }
/* harmony export */ });
/* unused harmony exports hexToRgb, rgbToHex, hslToRgb, decomposeColor, recomposeColor, getLuminance */
/* harmony import */ var _material_ui_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60288);


/* eslint-disable no-use-before-define */

/**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */
function clamp(value) {
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  if (false) {}

  return Math.min(Math.max(min, value), max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 *
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */


function hexToRgb(color) {
  color = color.substr(1);
  var re = new RegExp(".{1,".concat(color.length >= 6 ? 2 : 1, "}"), 'g');
  var colors = color.match(re);

  if (colors && colors[0].length === 1) {
    colors = colors.map(function (n) {
      return n + n;
    });
  }

  return colors ? "rgb".concat(colors.length === 4 ? 'a' : '', "(").concat(colors.map(function (n, index) {
    return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
  }).join(', '), ")") : '';
}

function intToHex(int) {
  var hex = int.toString(16);
  return hex.length === 1 ? "0".concat(hex) : hex;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 *
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */


function rgbToHex(color) {
  // Idempotent
  if (color.indexOf('#') === 0) {
    return color;
  }

  var _decomposeColor = decomposeColor(color),
      values = _decomposeColor.values;

  return "#".concat(values.map(function (n) {
    return intToHex(n);
  }).join(''));
}
/**
 * Converts a color from hsl format to rgb format.
 *
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */

function hslToRgb(color) {
  color = decomposeColor(color);
  var _color = color,
      values = _color.values;
  var h = values[0];
  var s = values[1] / 100;
  var l = values[2] / 100;
  var a = s * Math.min(l, 1 - l);

  var f = function f(n) {
    var k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (n + h / 30) % 12;
    return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
  };

  var type = 'rgb';
  var rgb = [Math.round(f(0) * 255), Math.round(f(8) * 255), Math.round(f(4) * 255)];

  if (color.type === 'hsla') {
    type += 'a';
    rgb.push(values[3]);
  }

  return recomposeColor({
    type: type,
    values: rgb
  });
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */

function decomposeColor(color) {
  // Idempotent
  if (color.type) {
    return color;
  }

  if (color.charAt(0) === '#') {
    return decomposeColor(hexToRgb(color));
  }

  var marker = color.indexOf('(');
  var type = color.substring(0, marker);

  if (['rgb', 'rgba', 'hsl', 'hsla'].indexOf(type) === -1) {
    throw new Error( false ? 0 : (0,_material_ui_utils__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(3, color));
  }

  var values = color.substring(marker + 1, color.length - 1).split(',');
  values = values.map(function (value) {
    return parseFloat(value);
  });
  return {
    type: type,
    values: values
  };
}
/**
 * Converts a color object with type and values to a string.
 *
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */

function recomposeColor(color) {
  var type = color.type;
  var values = color.values;

  if (type.indexOf('rgb') !== -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map(function (n, i) {
      return i < 3 ? parseInt(n, 10) : n;
    });
  } else if (type.indexOf('hsl') !== -1) {
    values[1] = "".concat(values[1], "%");
    values[2] = "".concat(values[2], "%");
  }

  return "".concat(type, "(").concat(values.join(', '), ")");
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */

function getContrastRatio(foreground, background) {
  var lumA = getLuminance(foreground);
  var lumB = getLuminance(background);
  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */

function getLuminance(color) {
  color = decomposeColor(color);
  var rgb = color.type === 'hsl' ? decomposeColor(hslToRgb(color)).values : color.values;
  rgb = rgb.map(function (val) {
    val /= 255; // normalized

    return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
  }); // Truncate at 3 digits

  return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function emphasize(color) {
  var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
}
var warnedOnce = false;
/**
 * Set the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} value - value to set the alpha channel to in the range 0 -1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 *
 * @deprecated
 * Use `import { alpha } from '@material-ui/core/styles'` instead.
 */

function fade(color, value) {
  if (false) {}

  return alpha(color, value);
}
/**
 * Set the absolute transparency of a color.
 * Any existing alpha value is overwritten.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} value - value to set the alpha channel to in the range 0-1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function alpha(color, value) {
  color = decomposeColor(color);
  value = clamp(value);

  if (color.type === 'rgb' || color.type === 'hsl') {
    color.type += 'a';
  }

  color.values[3] = value;
  return recomposeColor(color);
}
/**
 * Darkens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function darken(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] *= 1 - coefficient;
    }
  }

  return recomposeColor(color);
}
/**
 * Lightens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function lighten(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  }

  return recomposeColor(color);
}

/***/ }),

/***/ 83559:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ styles_createTheme; }
});

// UNUSED EXPORTS: createMuiTheme

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(45987);
// EXTERNAL MODULE: ./node_modules/@material-ui/utils/esm/deepmerge.js
var deepmerge = __webpack_require__(35953);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/styles/createBreakpoints.js


// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
var keys = ['xs', 'sm', 'md', 'lg', 'xl']; // Keep in mind that @media is inclusive by the CSS specification.

function createBreakpoints(breakpoints) {
  var _breakpoints$values = breakpoints.values,
      values = _breakpoints$values === void 0 ? {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
  } : _breakpoints$values,
      _breakpoints$unit = breakpoints.unit,
      unit = _breakpoints$unit === void 0 ? 'px' : _breakpoints$unit,
      _breakpoints$step = breakpoints.step,
      step = _breakpoints$step === void 0 ? 5 : _breakpoints$step,
      other = (0,objectWithoutProperties/* default */.Z)(breakpoints, ["values", "unit", "step"]);

  function up(key) {
    var value = typeof values[key] === 'number' ? values[key] : key;
    return "@media (min-width:".concat(value).concat(unit, ")");
  }

  function down(key) {
    var endIndex = keys.indexOf(key) + 1;
    var upperbound = values[keys[endIndex]];

    if (endIndex === keys.length) {
      // xl down applies to all sizes
      return up('xs');
    }

    var value = typeof upperbound === 'number' && endIndex > 0 ? upperbound : key;
    return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
  }

  function between(start, end) {
    var endIndex = keys.indexOf(end);

    if (endIndex === keys.length - 1) {
      return up(start);
    }

    return "@media (min-width:".concat(typeof values[start] === 'number' ? values[start] : start).concat(unit, ") and ") + "(max-width:".concat((endIndex !== -1 && typeof values[keys[endIndex + 1]] === 'number' ? values[keys[endIndex + 1]] : end) - step / 100).concat(unit, ")");
  }

  function only(key) {
    return between(key, key);
  }

  var warnedOnce = false;

  function width(key) {
    if (false) {}

    return values[key];
  }

  return (0,esm_extends/* default */.Z)({
    keys: keys,
    values: values,
    up: up,
    down: down,
    between: between,
    only: only,
    width: width
  }, other);
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(4942);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/styles/createMixins.js


function createMixins(breakpoints, spacing, mixins) {
  var _toolbar;

  return (0,esm_extends/* default */.Z)({
    gutters: function gutters() {
      var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      console.warn(['Material-UI: theme.mixins.gutters() is deprecated.', 'You can use the source of the mixin directly:', "\n      paddingLeft: theme.spacing(2),\n      paddingRight: theme.spacing(2),\n      [theme.breakpoints.up('sm')]: {\n        paddingLeft: theme.spacing(3),\n        paddingRight: theme.spacing(3),\n      },\n      "].join('\n'));
      return (0,esm_extends/* default */.Z)({
        paddingLeft: spacing(2),
        paddingRight: spacing(2)
      }, styles, (0,defineProperty/* default */.Z)({}, breakpoints.up('sm'), (0,esm_extends/* default */.Z)({
        paddingLeft: spacing(3),
        paddingRight: spacing(3)
      }, styles[breakpoints.up('sm')])));
    },
    toolbar: (_toolbar = {
      minHeight: 56
    }, (0,defineProperty/* default */.Z)(_toolbar, "".concat(breakpoints.up('xs'), " and (orientation: landscape)"), {
      minHeight: 48
    }), (0,defineProperty/* default */.Z)(_toolbar, breakpoints.up('sm'), {
      minHeight: 64
    }), _toolbar)
  }, mixins);
}
// EXTERNAL MODULE: ./node_modules/@material-ui/utils/esm/formatMuiErrorMessage.js
var formatMuiErrorMessage = __webpack_require__(60288);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/colors/common.js
var common = {
  black: '#000',
  white: '#fff'
};
/* harmony default export */ var colors_common = (common);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/colors/grey.js
var grey = {
  50: '#fafafa',
  100: '#f5f5f5',
  200: '#eeeeee',
  300: '#e0e0e0',
  400: '#bdbdbd',
  500: '#9e9e9e',
  600: '#757575',
  700: '#616161',
  800: '#424242',
  900: '#212121',
  A100: '#d5d5d5',
  A200: '#aaaaaa',
  A400: '#303030',
  A700: '#616161'
};
/* harmony default export */ var colors_grey = (grey);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/colors/indigo.js
var indigo = {
  50: '#e8eaf6',
  100: '#c5cae9',
  200: '#9fa8da',
  300: '#7986cb',
  400: '#5c6bc0',
  500: '#3f51b5',
  600: '#3949ab',
  700: '#303f9f',
  800: '#283593',
  900: '#1a237e',
  A100: '#8c9eff',
  A200: '#536dfe',
  A400: '#3d5afe',
  A700: '#304ffe'
};
/* harmony default export */ var colors_indigo = (indigo);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/colors/pink.js
var pink = {
  50: '#fce4ec',
  100: '#f8bbd0',
  200: '#f48fb1',
  300: '#f06292',
  400: '#ec407a',
  500: '#e91e63',
  600: '#d81b60',
  700: '#c2185b',
  800: '#ad1457',
  900: '#880e4f',
  A100: '#ff80ab',
  A200: '#ff4081',
  A400: '#f50057',
  A700: '#c51162'
};
/* harmony default export */ var colors_pink = (pink);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/colors/red.js
var red = {
  50: '#ffebee',
  100: '#ffcdd2',
  200: '#ef9a9a',
  300: '#e57373',
  400: '#ef5350',
  500: '#f44336',
  600: '#e53935',
  700: '#d32f2f',
  800: '#c62828',
  900: '#b71c1c',
  A100: '#ff8a80',
  A200: '#ff5252',
  A400: '#ff1744',
  A700: '#d50000'
};
/* harmony default export */ var colors_red = (red);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/colors/orange.js
var orange = {
  50: '#fff3e0',
  100: '#ffe0b2',
  200: '#ffcc80',
  300: '#ffb74d',
  400: '#ffa726',
  500: '#ff9800',
  600: '#fb8c00',
  700: '#f57c00',
  800: '#ef6c00',
  900: '#e65100',
  A100: '#ffd180',
  A200: '#ffab40',
  A400: '#ff9100',
  A700: '#ff6d00'
};
/* harmony default export */ var colors_orange = (orange);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/colors/blue.js
var blue = {
  50: '#e3f2fd',
  100: '#bbdefb',
  200: '#90caf9',
  300: '#64b5f6',
  400: '#42a5f5',
  500: '#2196f3',
  600: '#1e88e5',
  700: '#1976d2',
  800: '#1565c0',
  900: '#0d47a1',
  A100: '#82b1ff',
  A200: '#448aff',
  A400: '#2979ff',
  A700: '#2962ff'
};
/* harmony default export */ var colors_blue = (blue);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/colors/green.js
var green = {
  50: '#e8f5e9',
  100: '#c8e6c9',
  200: '#a5d6a7',
  300: '#81c784',
  400: '#66bb6a',
  500: '#4caf50',
  600: '#43a047',
  700: '#388e3c',
  800: '#2e7d32',
  900: '#1b5e20',
  A100: '#b9f6ca',
  A200: '#69f0ae',
  A400: '#00e676',
  A700: '#00c853'
};
/* harmony default export */ var colors_green = (green);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/colorManipulator.js
var colorManipulator = __webpack_require__(59693);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/styles/createPalette.js













var light = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: 'rgba(0, 0, 0, 0.87)',
    // Secondary text.
    secondary: 'rgba(0, 0, 0, 0.54)',
    // Disabled text have even lower visual prominence.
    disabled: 'rgba(0, 0, 0, 0.38)',
    // Text hints.
    hint: 'rgba(0, 0, 0, 0.38)'
  },
  // The color used to divide different elements.
  divider: 'rgba(0, 0, 0, 0.12)',
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: colors_common.white,
    default: colors_grey[50]
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: 'rgba(0, 0, 0, 0.54)',
    // The color of an hovered action.
    hover: 'rgba(0, 0, 0, 0.04)',
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: 'rgba(0, 0, 0, 0.08)',
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: 'rgba(0, 0, 0, 0.26)',
    // The background color of a disabled action.
    disabledBackground: 'rgba(0, 0, 0, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(0, 0, 0, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
};
var dark = {
  text: {
    primary: colors_common.white,
    secondary: 'rgba(255, 255, 255, 0.7)',
    disabled: 'rgba(255, 255, 255, 0.5)',
    hint: 'rgba(255, 255, 255, 0.5)',
    icon: 'rgba(255, 255, 255, 0.5)'
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  background: {
    paper: colors_grey[800],
    default: '#303030'
  },
  action: {
    active: colors_common.white,
    hover: 'rgba(255, 255, 255, 0.08)',
    hoverOpacity: 0.08,
    selected: 'rgba(255, 255, 255, 0.16)',
    selectedOpacity: 0.16,
    disabled: 'rgba(255, 255, 255, 0.3)',
    disabledBackground: 'rgba(255, 255, 255, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(255, 255, 255, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};

function addLightOrDark(intent, direction, shade, tonalOffset) {
  var tonalOffsetLight = tonalOffset.light || tonalOffset;
  var tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;

  if (!intent[direction]) {
    if (intent.hasOwnProperty(shade)) {
      intent[direction] = intent[shade];
    } else if (direction === 'light') {
      intent.light = (0,colorManipulator/* lighten */.$n)(intent.main, tonalOffsetLight);
    } else if (direction === 'dark') {
      intent.dark = (0,colorManipulator/* darken */._j)(intent.main, tonalOffsetDark);
    }
  }
}

function createPalette(palette) {
  var _palette$primary = palette.primary,
      primary = _palette$primary === void 0 ? {
    light: colors_indigo[300],
    main: colors_indigo[500],
    dark: colors_indigo[700]
  } : _palette$primary,
      _palette$secondary = palette.secondary,
      secondary = _palette$secondary === void 0 ? {
    light: colors_pink.A200,
    main: colors_pink.A400,
    dark: colors_pink.A700
  } : _palette$secondary,
      _palette$error = palette.error,
      error = _palette$error === void 0 ? {
    light: colors_red[300],
    main: colors_red[500],
    dark: colors_red[700]
  } : _palette$error,
      _palette$warning = palette.warning,
      warning = _palette$warning === void 0 ? {
    light: colors_orange[300],
    main: colors_orange[500],
    dark: colors_orange[700]
  } : _palette$warning,
      _palette$info = palette.info,
      info = _palette$info === void 0 ? {
    light: colors_blue[300],
    main: colors_blue[500],
    dark: colors_blue[700]
  } : _palette$info,
      _palette$success = palette.success,
      success = _palette$success === void 0 ? {
    light: colors_green[300],
    main: colors_green[500],
    dark: colors_green[700]
  } : _palette$success,
      _palette$type = palette.type,
      type = _palette$type === void 0 ? 'light' : _palette$type,
      _palette$contrastThre = palette.contrastThreshold,
      contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre,
      _palette$tonalOffset = palette.tonalOffset,
      tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset,
      other = (0,objectWithoutProperties/* default */.Z)(palette, ["primary", "secondary", "error", "warning", "info", "success", "type", "contrastThreshold", "tonalOffset"]); // Use the same logic as
  // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
  // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54


  function getContrastText(background) {
    var contrastText = (0,colorManipulator/* getContrastRatio */.mi)(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;

    if (false) { var contrast; }

    return contrastText;
  }

  var augmentColor = function augmentColor(color) {
    var mainShade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
    var lightShade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
    var darkShade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 700;
    color = (0,esm_extends/* default */.Z)({}, color);

    if (!color.main && color[mainShade]) {
      color.main = color[mainShade];
    }

    if (!color.main) {
      throw new Error( false ? 0 : (0,formatMuiErrorMessage/* default */.Z)(4, mainShade));
    }

    if (typeof color.main !== 'string') {
      throw new Error( false ? 0 : (0,formatMuiErrorMessage/* default */.Z)(5, JSON.stringify(color.main)));
    }

    addLightOrDark(color, 'light', lightShade, tonalOffset);
    addLightOrDark(color, 'dark', darkShade, tonalOffset);

    if (!color.contrastText) {
      color.contrastText = getContrastText(color.main);
    }

    return color;
  };

  var types = {
    dark: dark,
    light: light
  };

  if (false) {}

  var paletteOutput = (0,deepmerge/* default */.Z)((0,esm_extends/* default */.Z)({
    // A collection of common colors.
    common: colors_common,
    // The palette type, can be light or dark.
    type: type,
    // The colors used to represent primary interface elements for a user.
    primary: augmentColor(primary),
    // The colors used to represent secondary interface elements for a user.
    secondary: augmentColor(secondary, 'A400', 'A200', 'A700'),
    // The colors used to represent interface elements that the user should be made aware of.
    error: augmentColor(error),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: augmentColor(warning),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: augmentColor(info),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: augmentColor(success),
    // The grey colors.
    grey: colors_grey,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: contrastThreshold,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: getContrastText,
    // Generate a rich color object.
    augmentColor: augmentColor,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: tonalOffset
  }, types[type]), other);
  return paletteOutput;
}
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/styles/createTypography.js




function round(value) {
  return Math.round(value * 1e5) / 1e5;
}

var warnedOnce = false;

function roundWithDeprecationWarning(value) {
  if (false) {}

  return round(value);
}

var caseAllCaps = {
  textTransform: 'uppercase'
};
var defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
/**
 * @see @link{https://material.io/design/typography/the-type-system.html}
 * @see @link{https://material.io/design/typography/understanding-typography.html}
 */

function createTypography(palette, typography) {
  var _ref = typeof typography === 'function' ? typography(palette) : typography,
      _ref$fontFamily = _ref.fontFamily,
      fontFamily = _ref$fontFamily === void 0 ? defaultFontFamily : _ref$fontFamily,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize,
      _ref$fontWeightLight = _ref.fontWeightLight,
      fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight,
      _ref$fontWeightRegula = _ref.fontWeightRegular,
      fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula,
      _ref$fontWeightMedium = _ref.fontWeightMedium,
      fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium,
      _ref$fontWeightBold = _ref.fontWeightBold,
      fontWeightBold = _ref$fontWeightBold === void 0 ? 700 : _ref$fontWeightBold,
      _ref$htmlFontSize = _ref.htmlFontSize,
      htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize,
      allVariants = _ref.allVariants,
      pxToRem2 = _ref.pxToRem,
      other = (0,objectWithoutProperties/* default */.Z)(_ref, ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"]);

  if (false) {}

  var coef = fontSize / 14;

  var pxToRem = pxToRem2 || function (size) {
    return "".concat(size / htmlFontSize * coef, "rem");
  };

  var buildVariant = function buildVariant(fontWeight, size, lineHeight, letterSpacing, casing) {
    return (0,esm_extends/* default */.Z)({
      fontFamily: fontFamily,
      fontWeight: fontWeight,
      fontSize: pxToRem(size),
      // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
      lineHeight: lineHeight
    }, fontFamily === defaultFontFamily ? {
      letterSpacing: "".concat(round(letterSpacing / size), "em")
    } : {}, casing, allVariants);
  };

  var variants = {
    h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
    h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
    h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
    h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
    h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
    h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
    subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
    subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
    body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
    body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
    button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, caseAllCaps),
    caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
    overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps)
  };
  return (0,deepmerge/* default */.Z)((0,esm_extends/* default */.Z)({
    htmlFontSize: htmlFontSize,
    pxToRem: pxToRem,
    round: roundWithDeprecationWarning,
    // TODO v5: remove
    fontFamily: fontFamily,
    fontSize: fontSize,
    fontWeightLight: fontWeightLight,
    fontWeightRegular: fontWeightRegular,
    fontWeightMedium: fontWeightMedium,
    fontWeightBold: fontWeightBold
  }, variants), other, {
    clone: false // No need to clone deep

  });
}
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/styles/shadows.js
var shadowKeyUmbraOpacity = 0.2;
var shadowKeyPenumbraOpacity = 0.14;
var shadowAmbientShadowOpacity = 0.12;

function createShadow() {
  return ["".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0,0,0,").concat(shadowKeyUmbraOpacity, ")"), "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0,0,0,").concat(shadowKeyPenumbraOpacity, ")"), "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0,0,0,").concat(shadowAmbientShadowOpacity, ")")].join(',');
} // Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss


var shadows = ['none', createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
/* harmony default export */ var styles_shadows = (shadows);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/styles/shape.js
var shape = {
  borderRadius: 4
};
/* harmony default export */ var styles_shape = (shape);
// EXTERNAL MODULE: ./node_modules/@material-ui/system/esm/spacing.js + 1 modules
var esm_spacing = __webpack_require__(27122);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/styles/createSpacing.js

var warnOnce;
function createSpacing() {
  var spacingInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;

  // Already transformed.
  if (spacingInput.mui) {
    return spacingInput;
  } // Material Design layouts are visually balanced. Most measurements align to an 8dp grid applied, which aligns both spacing and the overall layout.
  // Smaller components, such as icons and type, can align to a 4dp grid.
  // https://material.io/design/layout/understanding-layout.html#usage


  var transform = (0,esm_spacing/* createUnarySpacing */.h)({
    spacing: spacingInput
  });

  var spacing = function spacing() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (false) {}

    if (args.length === 0) {
      return transform(1);
    }

    if (args.length === 1) {
      return transform(args[0]);
    }

    return args.map(function (argument) {
      if (typeof argument === 'string') {
        return argument;
      }

      var output = transform(argument);
      return typeof output === 'number' ? "".concat(output, "px") : output;
    }).join(' ');
  }; // Backward compatibility, to remove in v5.


  Object.defineProperty(spacing, 'unit', {
    get: function get() {
      if (false) {}

      return spacingInput;
    }
  });
  spacing.mui = true;
  return spacing;
}
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/transitions.js
var transitions = __webpack_require__(43366);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/zIndex.js
var zIndex = __webpack_require__(92781);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/styles/createTheme.js













function createTheme() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _options$breakpoints = options.breakpoints,
      breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints,
      _options$mixins = options.mixins,
      mixinsInput = _options$mixins === void 0 ? {} : _options$mixins,
      _options$palette = options.palette,
      paletteInput = _options$palette === void 0 ? {} : _options$palette,
      spacingInput = options.spacing,
      _options$typography = options.typography,
      typographyInput = _options$typography === void 0 ? {} : _options$typography,
      other = (0,objectWithoutProperties/* default */.Z)(options, ["breakpoints", "mixins", "palette", "spacing", "typography"]);

  var palette = createPalette(paletteInput);
  var breakpoints = createBreakpoints(breakpointsInput);
  var spacing = createSpacing(spacingInput);
  var muiTheme = (0,deepmerge/* default */.Z)({
    breakpoints: breakpoints,
    direction: 'ltr',
    mixins: createMixins(breakpoints, spacing, mixinsInput),
    overrides: {},
    // Inject custom styles
    palette: palette,
    props: {},
    // Provide default props
    shadows: styles_shadows,
    typography: createTypography(palette, typographyInput),
    spacing: spacing,
    shape: styles_shape,
    transitions: transitions/* default */.ZP,
    zIndex: zIndex/* default */.Z
  }, other);

  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  muiTheme = args.reduce(function (acc, argument) {
    return (0,deepmerge/* default */.Z)(acc, argument);
  }, muiTheme);

  if (false) { var traverse, pseudoClasses; }

  return muiTheme;
}

var createTheme_warnedOnce = false;
function createMuiTheme() {
  if (false) {}

  return createTheme.apply(void 0, arguments);
}
/* harmony default export */ var styles_createTheme = (createTheme);

/***/ }),

/***/ 99700:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _createTheme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83559);

var defaultTheme = (0,_createTheme__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
/* harmony default export */ __webpack_exports__["Z"] = (defaultTheme);

/***/ }),

/***/ 43366:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x9": function() { return /* binding */ duration; }
/* harmony export */ });
/* unused harmony export easing */
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45987);

// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
var easing = {
  // This is the most common easing curve.
  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
// to learn when use what timing

var duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};

function formatMs(milliseconds) {
  return "".concat(Math.round(milliseconds), "ms");
}
/**
 * @param {string|Array} props
 * @param {object} param
 * @param {string} param.prop
 * @param {number} param.duration
 * @param {string} param.easing
 * @param {number} param.delay
 */


/* harmony default export */ __webpack_exports__["ZP"] = ({
  easing: easing,
  duration: duration,
  create: function create() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['all'];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var _options$duration = options.duration,
        durationOption = _options$duration === void 0 ? duration.standard : _options$duration,
        _options$easing = options.easing,
        easingOption = _options$easing === void 0 ? easing.easeInOut : _options$easing,
        _options$delay = options.delay,
        delay = _options$delay === void 0 ? 0 : _options$delay,
        other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(options, ["duration", "easing", "delay"]);

    if (false) { var isNumber, isString; }

    return (Array.isArray(props) ? props : [props]).map(function (animatedProp) {
      return "".concat(animatedProp, " ").concat(typeof durationOption === 'string' ? durationOption : formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === 'string' ? delay : formatMs(delay));
    }).join(',');
  },
  getAutoHeightDuration: function getAutoHeightDuration(height) {
    if (!height) {
      return 0;
    }

    var constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10

    return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
  }
});

/***/ }),

/***/ 8920:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useTheme; }
/* harmony export */ });
/* harmony import */ var _material_ui_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(159);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _defaultTheme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99700);



function useTheme() {
  var theme = (0,_material_ui_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)() || _defaultTheme__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z;

  if (false) {}

  return theme;
}

/***/ }),

/***/ 1591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ styles_withStyles; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(45987);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
// EXTERNAL MODULE: ./node_modules/@material-ui/styles/esm/makeStyles/makeStyles.js + 18 modules
var makeStyles = __webpack_require__(19214);
// EXTERNAL MODULE: ./node_modules/@material-ui/styles/esm/getThemeProps/getThemeProps.js
var getThemeProps = __webpack_require__(93869);
// EXTERNAL MODULE: ./node_modules/@material-ui/styles/esm/useTheme/useTheme.js
var useTheme = __webpack_require__(159);
;// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/withStyles/withStyles.js








 // Link a style sheet with a component.
// It does not modify the component passed to it;
// instead, it returns a new component, with a `classes` property.

var withStyles = function withStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (Component) {
    var defaultTheme = options.defaultTheme,
        _options$withTheme = options.withTheme,
        withTheme = _options$withTheme === void 0 ? false : _options$withTheme,
        name = options.name,
        stylesOptions = (0,objectWithoutProperties/* default */.Z)(options, ["defaultTheme", "withTheme", "name"]);

    if (false) {}

    var classNamePrefix = name;

    if (false) { var displayName; }

    var useStyles = (0,makeStyles/* default */.Z)(stylesOrCreator, (0,esm_extends/* default */.Z)({
      defaultTheme: defaultTheme,
      Component: Component,
      name: name || Component.displayName,
      classNamePrefix: classNamePrefix
    }, stylesOptions));
    var WithStyles = /*#__PURE__*/react.forwardRef(function WithStyles(props, ref) {
      var classesProp = props.classes,
          innerRef = props.innerRef,
          other = (0,objectWithoutProperties/* default */.Z)(props, ["classes", "innerRef"]); // The wrapper receives only user supplied props, which could be a subset of
      // the actual props Component might receive due to merging with defaultProps.
      // So copying it here would give us the same result in the wrapper as well.


      var classes = useStyles((0,esm_extends/* default */.Z)({}, Component.defaultProps, props));
      var theme;
      var more = other;

      if (typeof name === 'string' || withTheme) {
        // name and withTheme are invariant in the outer scope
        // eslint-disable-next-line react-hooks/rules-of-hooks
        theme = (0,useTheme/* default */.Z)() || defaultTheme;

        if (name) {
          more = (0,getThemeProps/* default */.Z)({
            theme: theme,
            name: name,
            props: other
          });
        } // Provide the theme to the wrapped component.
        // So we don't have to use the `withTheme()` Higher-order Component.


        if (withTheme && !more.theme) {
          more.theme = theme;
        }
      }

      return /*#__PURE__*/react.createElement(Component, (0,esm_extends/* default */.Z)({
        ref: innerRef || ref,
        classes: classes
      }, more));
    });
     false ? 0 : void 0;

    if (false) {}

    hoist_non_react_statics_cjs_default()(WithStyles, Component);

    if (false) {}

    return WithStyles;
  };
};

/* harmony default export */ var withStyles_withStyles = (withStyles);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/defaultTheme.js
var defaultTheme = __webpack_require__(99700);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js




function styles_withStyles_withStyles(stylesOrCreator, options) {
  return withStyles_withStyles(stylesOrCreator, (0,esm_extends/* default */.Z)({
    defaultTheme: defaultTheme/* default */.Z
  }, options));
}

/* harmony default export */ var styles_withStyles = (styles_withStyles_withStyles);

/***/ }),

/***/ 92781:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
var zIndex = {
  mobileStepper: 1000,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
/* harmony default export */ __webpack_exports__["Z"] = (zIndex);

/***/ }),

/***/ 5653:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ getTransitionProps; },
/* harmony export */   "n": function() { return /* binding */ reflow; }
/* harmony export */ });
var reflow = function reflow(node) {
  return node.scrollTop;
};
function getTransitionProps(props, options) {
  var timeout = props.timeout,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style;
  return {
    duration: style.transitionDuration || typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
    delay: style.transitionDelay
  };
}

/***/ }),

/***/ 63457:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useMediaQuery; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87462);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(159);
/* harmony import */ var _material_ui_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93869);



function useMediaQuery(queryInput) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var theme = (0,_material_ui_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
  var props = (0,_material_ui_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    theme: theme,
    name: 'MuiUseMediaQuery',
    props: {}
  });

  if (false) {}

  var query = typeof queryInput === 'function' ? queryInput(theme) : queryInput;
  query = query.replace(/^@media( ?)/m, ''); // Wait for jsdom to support the match media feature.
  // All the browsers Material-UI support have this built-in.
  // This defensive check is here for simplicity.
  // Most of the time, the match media logic isn't central to people tests.

  var supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';

  var _props$options = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props, options),
      _props$options$defaul = _props$options.defaultMatches,
      defaultMatches = _props$options$defaul === void 0 ? false : _props$options$defaul,
      _props$options$matchM = _props$options.matchMedia,
      matchMedia = _props$options$matchM === void 0 ? supportMatchMedia ? window.matchMedia : null : _props$options$matchM,
      _props$options$noSsr = _props$options.noSsr,
      noSsr = _props$options$noSsr === void 0 ? false : _props$options$noSsr,
      _props$options$ssrMat = _props$options.ssrMatchMedia,
      ssrMatchMedia = _props$options$ssrMat === void 0 ? null : _props$options$ssrMat;

  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState(function () {
    if (noSsr && supportMatchMedia) {
      return matchMedia(query).matches;
    }

    if (ssrMatchMedia) {
      return ssrMatchMedia(query).matches;
    } // Once the component is mounted, we rely on the
    // event listeners to return the correct matches value.


    return defaultMatches;
  }),
      match = _React$useState[0],
      setMatch = _React$useState[1];

  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function () {
    var active = true;

    if (!supportMatchMedia) {
      return undefined;
    }

    var queryList = matchMedia(query);

    var updateMatch = function updateMatch() {
      // Workaround Safari wrong implementation of matchMedia
      // TODO can we remove it?
      // https://github.com/mui-org/material-ui/pull/17315#issuecomment-528286677
      if (active) {
        setMatch(queryList.matches);
      }
    };

    updateMatch();
    queryList.addListener(updateMatch);
    return function () {
      active = false;
      queryList.removeListener(updateMatch);
    };
  }, [query, matchMedia, supportMatchMedia]);

  if (false) {}

  return match;
}

/***/ }),

/***/ 93871:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ capitalize; }
/* harmony export */ });
/* harmony import */ var _material_ui_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60288);

// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
//
// A strict capitalization should uppercase the first letter of each word a the sentence.
// We only handle the first word.
function capitalize(string) {
  if (typeof string !== 'string') {
    throw new Error( false ? 0 : (0,_material_ui_utils__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(7));
  }

  return string.charAt(0).toUpperCase() + string.slice(1);
}

/***/ }),

/***/ 82568:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ createChainedFunction; }
/* harmony export */ });
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */
function createChainedFunction() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.reduce(function (acc, func) {
    if (func == null) {
      return acc;
    }

    if (false) {}

    return function chainedFunction() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      acc.apply(this, args);
      func.apply(this, args);
    };
  }, function () {});
}

/***/ }),

/***/ 63786:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ createSvgIcon; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87462);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _SvgIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62087);



/**
 * Private module reserved for @material-ui/x packages.
 */

function createSvgIcon(path, displayName) {
  var Component = function Component(props, ref) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_SvgIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
      ref: ref
    }, props), path);
  };

  if (false) {}

  Component.muiName = _SvgIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"].muiName */ .Z.muiName;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.memo( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(Component));
}

/***/ }),

/***/ 79437:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ debounce; }
/* harmony export */ });
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function debounce(func) {
  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 166;
  var timeout;

  function debounced() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    // eslint-disable-next-line consistent-this
    var that = this;

    var later = function later() {
      func.apply(that, args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  }

  debounced.clear = function () {
    clearTimeout(timeout);
  };

  return debounced;
}

/***/ }),

/***/ 75840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getScrollbarSize; }
/* harmony export */ });
// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/3ffe3a5d82f6f561b82ff78d82b32a7d14aed558/js/src/modal.js#L512-L519
function getScrollbarSize() {
  var scrollDiv = document.createElement('div');
  scrollDiv.style.width = '99px';
  scrollDiv.style.height = '99px';
  scrollDiv.style.position = 'absolute';
  scrollDiv.style.top = '-9999px';
  scrollDiv.style.overflow = 'scroll';
  document.body.appendChild(scrollDiv);
  var scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  return scrollbarSize;
}

/***/ }),

/***/ 44343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "capitalize": function() { return /* reexport */ capitalize/* default */.Z; },
  "createChainedFunction": function() { return /* reexport */ createChainedFunction/* default */.Z; },
  "createSvgIcon": function() { return /* reexport */ createSvgIcon/* default */.Z; },
  "debounce": function() { return /* reexport */ debounce/* default */.Z; },
  "deprecatedPropType": function() { return /* reexport */ deprecatedPropType; },
  "isMuiElement": function() { return /* reexport */ isMuiElement/* default */.Z; },
  "ownerDocument": function() { return /* reexport */ ownerDocument/* default */.Z; },
  "ownerWindow": function() { return /* reexport */ ownerWindow/* default */.Z; },
  "requirePropFactory": function() { return /* reexport */ requirePropFactory; },
  "setRef": function() { return /* reexport */ setRef/* default */.Z; },
  "unstable_useId": function() { return /* reexport */ unstable_useId/* default */.Z; },
  "unsupportedProp": function() { return /* reexport */ unsupportedProp; },
  "useControlled": function() { return /* reexport */ useControlled/* default */.Z; },
  "useEventCallback": function() { return /* reexport */ useEventCallback/* default */.Z; },
  "useForkRef": function() { return /* reexport */ useForkRef/* default */.Z; },
  "useIsFocusVisible": function() { return /* reexport */ useIsFocusVisible/* default */.Z; }
});

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/capitalize.js
var capitalize = __webpack_require__(93871);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/createChainedFunction.js
var createChainedFunction = __webpack_require__(82568);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/createSvgIcon.js
var createSvgIcon = __webpack_require__(63786);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/debounce.js
var debounce = __webpack_require__(79437);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/utils/deprecatedPropType.js
function deprecatedPropType(validator, reason) {
  if (true) {
    return function () {
      return null;
    };
  }

  return function (props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (typeof props[propName] !== 'undefined') {
      return new Error("The ".concat(location, " `").concat(propFullNameSafe, "` of ") + "`".concat(componentNameSafe, "` is deprecated. ").concat(reason));
    }

    return null;
  };
}
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/isMuiElement.js
var isMuiElement = __webpack_require__(83711);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/ownerDocument.js
var ownerDocument = __webpack_require__(30626);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/ownerWindow.js
var ownerWindow = __webpack_require__(80713);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/utils/requirePropFactory.js
function requirePropFactory(componentNameInError) {
  if (true) {
    return function () {
      return null;
    };
  }

  var requireProp = function requireProp(requiredProp) {
    return function (props, propName, componentName, location, propFullName) {
      var propFullNameSafe = propFullName || propName;

      if (typeof props[propName] !== 'undefined' && !props[requiredProp]) {
        return new Error("The prop `".concat(propFullNameSafe, "` of ") + "`".concat(componentNameInError, "` must be used on `").concat(requiredProp, "`."));
      }

      return null;
    };
  };

  return requireProp;
}
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/setRef.js
var setRef = __webpack_require__(34236);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/utils/unsupportedProp.js
function unsupportedProp(props, propName, componentName, location, propFullName) {
  if (true) {
    return null;
  }

  var propFullNameSafe = propFullName || propName;

  if (typeof props[propName] !== 'undefined') {
    return new Error("The prop `".concat(propFullNameSafe, "` is not supported. Please remove it."));
  }

  return null;
}
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useControlled.js
var useControlled = __webpack_require__(22775);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useEventCallback.js
var useEventCallback = __webpack_require__(55192);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useForkRef.js
var useForkRef = __webpack_require__(17294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/unstable_useId.js
var unstable_useId = __webpack_require__(95001);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useIsFocusVisible.js
var useIsFocusVisible = __webpack_require__(24896);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/utils/index.js













 // eslint-disable-next-line camelcase




/***/ }),

/***/ 83711:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ isMuiElement; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function isMuiElement(element, muiNames) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
}

/***/ }),

/***/ 30626:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ownerDocument; }
/* harmony export */ });
function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

/***/ }),

/***/ 80713:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ownerWindow; }
/* harmony export */ });
/* harmony import */ var _ownerDocument__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30626);

function ownerWindow(node) {
  var doc = (0,_ownerDocument__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(node);
  return doc.defaultView || window;
}

/***/ }),

/***/ 34236:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ setRef; }
/* harmony export */ });
// TODO v5: consider to make it private
function setRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}

/***/ }),

/***/ 95001:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useId; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/**
 * Private module reserved for @material-ui/x packages.
 */

function useId(idOverride) {
  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState(idOverride),
      defaultId = _React$useState[0],
      setDefaultId = _React$useState[1];

  var id = idOverride || defaultId;
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function () {
    if (defaultId == null) {
      // Fallback to this default id when possible.
      // Use the random value for client-side rendering only.
      // We can't use it server-side.
      setDefaultId("mui-".concat(Math.round(Math.random() * 1e5)));
    }
  }, [defaultId]);
  return id;
}

/***/ }),

/***/ 22775:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useControlled; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */

function useControlled(_ref) {
  var controlled = _ref.controlled,
      defaultProp = _ref.default,
      name = _ref.name,
      _ref$state = _ref.state,
      state = _ref$state === void 0 ? 'value' : _ref$state;

  var _React$useRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(controlled !== undefined),
      isControlled = _React$useRef.current;

  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState(defaultProp),
      valueState = _React$useState[0],
      setValue = _React$useState[1];

  var value = isControlled ? controlled : valueState;

  if (false) { var _React$useRef2, defaultValue; }

  var setValueIfUncontrolled = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function (newValue) {
    if (!isControlled) {
      setValue(newValue);
    }
  }, []);
  return [value, setValueIfUncontrolled];
}

/***/ }),

/***/ 55192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useEventCallback; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useEnhancedEffect = typeof window !== 'undefined' ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_0__.useEffect;
/**
 * https://github.com/facebook/react/issues/14099#issuecomment-440013892
 *
 * @param {function} fn
 */

function useEventCallback(fn) {
  var ref = react__WEBPACK_IMPORTED_MODULE_0__.useRef(fn);
  useEnhancedEffect(function () {
    ref.current = fn;
  });
  return react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function () {
    return (0, ref.current).apply(void 0, arguments);
  }, []);
}

/***/ }),

/***/ 17294:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useForkRef; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _setRef__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34236);


function useForkRef(refA, refB) {
  /**
   * This will create a new function if the ref props change and are defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior
   */
  return react__WEBPACK_IMPORTED_MODULE_0__.useMemo(function () {
    if (refA == null && refB == null) {
      return null;
    }

    return function (refValue) {
      (0,_setRef__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(refA, refValue);
      (0,_setRef__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(refB, refValue);
    };
  }, [refA, refB]);
}

/***/ }),

/***/ 24896:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useIsFocusVisible; }
/* harmony export */ });
/* unused harmony export teardown */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73935);
// based on https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js


var hadKeyboardEvent = true;
var hadFocusVisibleRecently = false;
var hadFocusVisibleRecentlyTimeout = null;
var inputTypesWhitelist = {
  text: true,
  search: true,
  url: true,
  tel: true,
  email: true,
  password: true,
  number: true,
  date: true,
  month: true,
  week: true,
  time: true,
  datetime: true,
  'datetime-local': true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @return {boolean}
 */

function focusTriggersKeyboardModality(node) {
  var type = node.type,
      tagName = node.tagName;

  if (tagName === 'INPUT' && inputTypesWhitelist[type] && !node.readOnly) {
    return true;
  }

  if (tagName === 'TEXTAREA' && !node.readOnly) {
    return true;
  }

  if (node.isContentEditable) {
    return true;
  }

  return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */


function handleKeyDown(event) {
  if (event.metaKey || event.altKey || event.ctrlKey) {
    return;
  }

  hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */


function handlePointerDown() {
  hadKeyboardEvent = false;
}

function handleVisibilityChange() {
  if (this.visibilityState === 'hidden') {
    // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    if (hadFocusVisibleRecently) {
      hadKeyboardEvent = true;
    }
  }
}

function prepare(doc) {
  doc.addEventListener('keydown', handleKeyDown, true);
  doc.addEventListener('mousedown', handlePointerDown, true);
  doc.addEventListener('pointerdown', handlePointerDown, true);
  doc.addEventListener('touchstart', handlePointerDown, true);
  doc.addEventListener('visibilitychange', handleVisibilityChange, true);
}

function teardown(doc) {
  doc.removeEventListener('keydown', handleKeyDown, true);
  doc.removeEventListener('mousedown', handlePointerDown, true);
  doc.removeEventListener('pointerdown', handlePointerDown, true);
  doc.removeEventListener('touchstart', handlePointerDown, true);
  doc.removeEventListener('visibilitychange', handleVisibilityChange, true);
}

function isFocusVisible(event) {
  var target = event.target;

  try {
    return target.matches(':focus-visible');
  } catch (error) {} // browsers not implementing :focus-visible will throw a SyntaxError
  // we use our own heuristic for those browsers
  // rethrow might be better if it's not the expected error but do we really
  // want to crash if focus-visible malfunctioned?
  // no need for validFocusTarget check. the user does that by attaching it to
  // focusable events only


  return hadKeyboardEvent || focusTriggersKeyboardModality(target);
}
/**
 * Should be called if a blur event is fired on a focus-visible element
 */


function handleBlurVisible() {
  // To detect a tab/window switch, we look for a blur event followed
  // rapidly by a visibility change.
  // If we don't see a visibility change within 100ms, it's probably a
  // regular focus change.
  hadFocusVisibleRecently = true;
  window.clearTimeout(hadFocusVisibleRecentlyTimeout);
  hadFocusVisibleRecentlyTimeout = window.setTimeout(function () {
    hadFocusVisibleRecently = false;
  }, 100);
}

function useIsFocusVisible() {
  var ref = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function (instance) {
    var node = react_dom__WEBPACK_IMPORTED_MODULE_1__.findDOMNode(instance);

    if (node != null) {
      prepare(node.ownerDocument);
    }
  }, []);

  if (false) {}

  return {
    isFocusVisible: isFocusVisible,
    onBlurVisible: handleBlurVisible,
    ref: ref
  };
}

/***/ }),

/***/ 80366:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(95318);

var _interopRequireWildcard = __webpack_require__(20862);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');

exports.Z = _default;

/***/ }),

/***/ 25281:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(95318);

var _interopRequireWildcard = __webpack_require__(20862);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"
}), 'KeyboardArrowUp');

exports.Z = _default;

/***/ }),

/***/ 2108:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "default", ({
  enumerable: true,
  get: function get() {
    return _utils.createSvgIcon;
  }
}));

var _utils = __webpack_require__(44343);

/***/ }),

/***/ 17076:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
/* harmony default export */ __webpack_exports__["Z"] = (hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__');

/***/ }),

/***/ 93869:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getThemeProps; }
/* harmony export */ });
/* eslint-disable no-restricted-syntax */
function getThemeProps(params) {
  var theme = params.theme,
      name = params.name,
      props = params.props;

  if (!theme || !theme.props || !theme.props[name]) {
    return props;
  } // Resolve default props, code borrow from React source.
  // https://github.com/facebook/react/blob/15a8f031838a553e41c0b66eb1bcf1da8448104d/packages/react/src/ReactElement.js#L221


  var defaultProps = theme.props[name];
  var propName;

  for (propName in defaultProps) {
    if (props[propName] === undefined) {
      props[propName] = defaultProps[propName];
    }
  }

  return props;
}

/***/ }),

/***/ 19214:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ makeStyles; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(45987);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/is-in-browser/dist/module.js
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isBrowser = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.nodeType === 9;

/* harmony default export */ var dist_module = (isBrowser);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(43144);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(94578);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(97326);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
;// CONCATENATED MODULE: ./node_modules/jss/dist/jss.esm.js








var plainObjectConstrurctor = {}.constructor;
function cloneStyle(style) {
  if (style == null || typeof style !== 'object') return style;
  if (Array.isArray(style)) return style.map(cloneStyle);
  if (style.constructor !== plainObjectConstrurctor) return style;
  var newStyle = {};

  for (var name in style) {
    newStyle[name] = cloneStyle(style[name]);
  }

  return newStyle;
}

/**
 * Create a rule instance.
 */

function createRule(name, decl, options) {
  if (name === void 0) {
    name = 'unnamed';
  }

  var jss = options.jss;
  var declCopy = cloneStyle(decl);
  var rule = jss.plugins.onCreateRule(name, declCopy, options);
  if (rule) return rule; // It is an at-rule and it has no instance.

  if (name[0] === '@') {
     false ? 0 : void 0;
  }

  return null;
}

var join = function join(value, by) {
  var result = '';

  for (var i = 0; i < value.length; i++) {
    // Remove !important from the value, it will be readded later.
    if (value[i] === '!important') break;
    if (result) result += by;
    result += value[i];
  }

  return result;
};
/**
 * Converts JSS array value to a CSS string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */


var toCssValue = function toCssValue(value, ignoreImportant) {
  if (ignoreImportant === void 0) {
    ignoreImportant = false;
  }

  if (!Array.isArray(value)) return value;
  var cssValue = ''; // Support space separated values via `[['5px', '10px']]`.

  if (Array.isArray(value[0])) {
    for (var i = 0; i < value.length; i++) {
      if (value[i] === '!important') break;
      if (cssValue) cssValue += ', ';
      cssValue += join(value[i], ' ');
    }
  } else cssValue = join(value, ', '); // Add !important, because it was ignored.


  if (!ignoreImportant && value[value.length - 1] === '!important') {
    cssValue += ' !important';
  }

  return cssValue;
};

function getWhitespaceSymbols(options) {
  if (options && options.format === false) {
    return {
      linebreak: '',
      space: ''
    };
  }

  return {
    linebreak: '\n',
    space: ' '
  };
}

/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */

function indentStr(str, indent) {
  var result = '';

  for (var index = 0; index < indent; index++) {
    result += '  ';
  }

  return result + str;
}
/**
 * Converts a Rule to CSS string.
 */


function toCss(selector, style, options) {
  if (options === void 0) {
    options = {};
  }

  var result = '';
  if (!style) return result;
  var _options = options,
      _options$indent = _options.indent,
      indent = _options$indent === void 0 ? 0 : _options$indent;
  var fallbacks = style.fallbacks;

  if (options.format === false) {
    indent = -Infinity;
  }

  var _getWhitespaceSymbols = getWhitespaceSymbols(options),
      linebreak = _getWhitespaceSymbols.linebreak,
      space = _getWhitespaceSymbols.space;

  if (selector) indent++; // Apply fallbacks first.

  if (fallbacks) {
    // Array syntax {fallbacks: [{prop: value}]}
    if (Array.isArray(fallbacks)) {
      for (var index = 0; index < fallbacks.length; index++) {
        var fallback = fallbacks[index];

        for (var prop in fallback) {
          var value = fallback[prop];

          if (value != null) {
            if (result) result += linebreak;
            result += indentStr(prop + ":" + space + toCssValue(value) + ";", indent);
          }
        }
      }
    } else {
      // Object syntax {fallbacks: {prop: value}}
      for (var _prop in fallbacks) {
        var _value = fallbacks[_prop];

        if (_value != null) {
          if (result) result += linebreak;
          result += indentStr(_prop + ":" + space + toCssValue(_value) + ";", indent);
        }
      }
    }
  }

  for (var _prop2 in style) {
    var _value2 = style[_prop2];

    if (_value2 != null && _prop2 !== 'fallbacks') {
      if (result) result += linebreak;
      result += indentStr(_prop2 + ":" + space + toCssValue(_value2) + ";", indent);
    }
  } // Allow empty style in this case, because properties will be added dynamically.


  if (!result && !options.allowEmpty) return result; // When rule is being stringified before selector was defined.

  if (!selector) return result;
  indent--;
  if (result) result = "" + linebreak + result + linebreak;
  return indentStr("" + selector + space + "{" + result, indent) + indentStr('}', indent);
}

var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
var nativeEscape = typeof CSS !== 'undefined' && CSS.escape;
var jss_esm_escape = (function (str) {
  return nativeEscape ? nativeEscape(str) : str.replace(escapeRegex, '\\$1');
});

var BaseStyleRule =
/*#__PURE__*/
function () {
  function BaseStyleRule(key, style, options) {
    this.type = 'style';
    this.isProcessed = false;
    var sheet = options.sheet,
        Renderer = options.Renderer;
    this.key = key;
    this.options = options;
    this.style = style;
    if (sheet) this.renderer = sheet.renderer;else if (Renderer) this.renderer = new Renderer();
  }
  /**
   * Get or set a style property.
   */


  var _proto = BaseStyleRule.prototype;

  _proto.prop = function prop(name, value, options) {
    // It's a getter.
    if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.

    var force = options ? options.force : false;
    if (!force && this.style[name] === value) return this;
    var newValue = value;

    if (!options || options.process !== false) {
      newValue = this.options.jss.plugins.onChangeValue(value, name, this);
    }

    var isEmpty = newValue == null || newValue === false;
    var isDefined = name in this.style; // Value is empty and wasn't defined before.

    if (isEmpty && !isDefined && !force) return this; // We are going to remove this value.

    var remove = isEmpty && isDefined;
    if (remove) delete this.style[name];else this.style[name] = newValue; // Renderable is defined if StyleSheet option `link` is true.

    if (this.renderable && this.renderer) {
      if (remove) this.renderer.removeProperty(this.renderable, name);else this.renderer.setProperty(this.renderable, name, newValue);
      return this;
    }

    var sheet = this.options.sheet;

    if (sheet && sheet.attached) {
       false ? 0 : void 0;
    }

    return this;
  };

  return BaseStyleRule;
}();
var StyleRule =
/*#__PURE__*/
function (_BaseStyleRule) {
  (0,inheritsLoose/* default */.Z)(StyleRule, _BaseStyleRule);

  function StyleRule(key, style, options) {
    var _this;

    _this = _BaseStyleRule.call(this, key, style, options) || this;
    var selector = options.selector,
        scoped = options.scoped,
        sheet = options.sheet,
        generateId = options.generateId;

    if (selector) {
      _this.selectorText = selector;
    } else if (scoped !== false) {
      _this.id = generateId((0,assertThisInitialized/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this)), sheet);
      _this.selectorText = "." + jss_esm_escape(_this.id);
    }

    return _this;
  }
  /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */


  var _proto2 = StyleRule.prototype;

  /**
   * Apply rule to an element inline.
   */
  _proto2.applyTo = function applyTo(renderable) {
    var renderer = this.renderer;

    if (renderer) {
      var json = this.toJSON();

      for (var prop in json) {
        renderer.setProperty(renderable, prop, json[prop]);
      }
    }

    return this;
  }
  /**
   * Returns JSON representation of the rule.
   * Fallbacks are not supported.
   * Useful for inline styles.
   */
  ;

  _proto2.toJSON = function toJSON() {
    var json = {};

    for (var prop in this.style) {
      var value = this.style[prop];
      if (typeof value !== 'object') json[prop] = value;else if (Array.isArray(value)) json[prop] = toCssValue(value);
    }

    return json;
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto2.toString = function toString(options) {
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;
    var opts = link ? (0,esm_extends/* default */.Z)({}, options, {
      allowEmpty: true
    }) : options;
    return toCss(this.selectorText, this.style, opts);
  };

  (0,createClass/* default */.Z)(StyleRule, [{
    key: "selector",
    set: function set(selector) {
      if (selector === this.selectorText) return;
      this.selectorText = selector;
      var renderer = this.renderer,
          renderable = this.renderable;
      if (!renderable || !renderer) return;
      var hasChanged = renderer.setSelector(renderable, selector); // If selector setter is not implemented, rerender the rule.

      if (!hasChanged) {
        renderer.replaceRule(renderable, this);
      }
    }
    /**
     * Get selector string.
     */
    ,
    get: function get() {
      return this.selectorText;
    }
  }]);

  return StyleRule;
}(BaseStyleRule);
var pluginStyleRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    if (key[0] === '@' || options.parent && options.parent.type === 'keyframes') {
      return null;
    }

    return new StyleRule(key, style, options);
  }
};

var defaultToStringOptions = {
  indent: 1,
  children: true
};
var atRegExp = /@([\w-]+)/;
/**
 * Conditional rule for @media, @supports
 */

var ConditionalRule =
/*#__PURE__*/
function () {
  function ConditionalRule(key, styles, options) {
    this.type = 'conditional';
    this.isProcessed = false;
    this.key = key;
    var atMatch = key.match(atRegExp);
    this.at = atMatch ? atMatch[1] : 'unknown'; // Key might contain a unique suffix in case the `name` passed by user was duplicate.

    this.query = options.name || "@" + this.at;
    this.options = options;
    this.rules = new RuleList((0,esm_extends/* default */.Z)({}, options, {
      parent: this
    }));

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }
  /**
   * Get a rule.
   */


  var _proto = ConditionalRule.prototype;

  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Create and register rule, run plugins.
   */
  ;

  _proto.addRule = function addRule(name, style, options) {
    var rule = this.rules.add(name, style, options);
    if (!rule) return null;
    this.options.jss.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Replace rule, run plugins.
   */
  ;

  _proto.replaceRule = function replaceRule(name, style, options) {
    var newRule = this.rules.replace(name, style, options);
    if (newRule) this.options.jss.plugins.onProcessRule(newRule);
    return newRule;
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    if (options === void 0) {
      options = defaultToStringOptions;
    }

    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    if (options.indent == null) options.indent = defaultToStringOptions.indent;
    if (options.children == null) options.children = defaultToStringOptions.children;

    if (options.children === false) {
      return this.query + " {}";
    }

    var children = this.rules.toString(options);
    return children ? this.query + " {" + linebreak + children + linebreak + "}" : '';
  };

  return ConditionalRule;
}();
var keyRegExp = /@media|@supports\s+/;
var pluginConditionalRule = {
  onCreateRule: function onCreateRule(key, styles, options) {
    return keyRegExp.test(key) ? new ConditionalRule(key, styles, options) : null;
  }
};

var defaultToStringOptions$1 = {
  indent: 1,
  children: true
};
var nameRegExp = /@keyframes\s+([\w-]+)/;
/**
 * Rule for @keyframes
 */

var KeyframesRule =
/*#__PURE__*/
function () {
  function KeyframesRule(key, frames, options) {
    this.type = 'keyframes';
    this.at = '@keyframes';
    this.isProcessed = false;
    var nameMatch = key.match(nameRegExp);

    if (nameMatch && nameMatch[1]) {
      this.name = nameMatch[1];
    } else {
      this.name = 'noname';
       false ? 0 : void 0;
    }

    this.key = this.type + "-" + this.name;
    this.options = options;
    var scoped = options.scoped,
        sheet = options.sheet,
        generateId = options.generateId;
    this.id = scoped === false ? this.name : jss_esm_escape(generateId(this, sheet));
    this.rules = new RuleList((0,esm_extends/* default */.Z)({}, options, {
      parent: this
    }));

    for (var name in frames) {
      this.rules.add(name, frames[name], (0,esm_extends/* default */.Z)({}, options, {
        parent: this
      }));
    }

    this.rules.process();
  }
  /**
   * Generates a CSS string.
   */


  var _proto = KeyframesRule.prototype;

  _proto.toString = function toString(options) {
    if (options === void 0) {
      options = defaultToStringOptions$1;
    }

    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    if (options.indent == null) options.indent = defaultToStringOptions$1.indent;
    if (options.children == null) options.children = defaultToStringOptions$1.children;

    if (options.children === false) {
      return this.at + " " + this.id + " {}";
    }

    var children = this.rules.toString(options);
    if (children) children = "" + linebreak + children + linebreak;
    return this.at + " " + this.id + " {" + children + "}";
  };

  return KeyframesRule;
}();
var keyRegExp$1 = /@keyframes\s+/;
var refRegExp = /\$([\w-]+)/g;

var findReferencedKeyframe = function findReferencedKeyframe(val, keyframes) {
  if (typeof val === 'string') {
    return val.replace(refRegExp, function (match, name) {
      if (name in keyframes) {
        return keyframes[name];
      }

       false ? 0 : void 0;
      return match;
    });
  }

  return val;
};
/**
 * Replace the reference for a animation name.
 */


var replaceRef = function replaceRef(style, prop, keyframes) {
  var value = style[prop];
  var refKeyframe = findReferencedKeyframe(value, keyframes);

  if (refKeyframe !== value) {
    style[prop] = refKeyframe;
  }
};

var pluginKeyframesRule = {
  onCreateRule: function onCreateRule(key, frames, options) {
    return typeof key === 'string' && keyRegExp$1.test(key) ? new KeyframesRule(key, frames, options) : null;
  },
  // Animation name ref replacer.
  onProcessStyle: function onProcessStyle(style, rule, sheet) {
    if (rule.type !== 'style' || !sheet) return style;
    if ('animation-name' in style) replaceRef(style, 'animation-name', sheet.keyframes);
    if ('animation' in style) replaceRef(style, 'animation', sheet.keyframes);
    return style;
  },
  onChangeValue: function onChangeValue(val, prop, rule) {
    var sheet = rule.options.sheet;

    if (!sheet) {
      return val;
    }

    switch (prop) {
      case 'animation':
        return findReferencedKeyframe(val, sheet.keyframes);

      case 'animation-name':
        return findReferencedKeyframe(val, sheet.keyframes);

      default:
        return val;
    }
  }
};

var KeyframeRule =
/*#__PURE__*/
function (_BaseStyleRule) {
  (0,inheritsLoose/* default */.Z)(KeyframeRule, _BaseStyleRule);

  function KeyframeRule() {
    return _BaseStyleRule.apply(this, arguments) || this;
  }

  var _proto = KeyframeRule.prototype;

  /**
   * Generates a CSS string.
   */
  _proto.toString = function toString(options) {
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;
    var opts = link ? (0,esm_extends/* default */.Z)({}, options, {
      allowEmpty: true
    }) : options;
    return toCss(this.key, this.style, opts);
  };

  return KeyframeRule;
}(BaseStyleRule);
var pluginKeyframeRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    if (options.parent && options.parent.type === 'keyframes') {
      return new KeyframeRule(key, style, options);
    }

    return null;
  }
};

var FontFaceRule =
/*#__PURE__*/
function () {
  function FontFaceRule(key, style, options) {
    this.type = 'font-face';
    this.at = '@font-face';
    this.isProcessed = false;
    this.key = key;
    this.style = style;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */


  var _proto = FontFaceRule.prototype;

  _proto.toString = function toString(options) {
    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    if (Array.isArray(this.style)) {
      var str = '';

      for (var index = 0; index < this.style.length; index++) {
        str += toCss(this.at, this.style[index]);
        if (this.style[index + 1]) str += linebreak;
      }

      return str;
    }

    return toCss(this.at, this.style, options);
  };

  return FontFaceRule;
}();
var keyRegExp$2 = /@font-face/;
var pluginFontFaceRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    return keyRegExp$2.test(key) ? new FontFaceRule(key, style, options) : null;
  }
};

var ViewportRule =
/*#__PURE__*/
function () {
  function ViewportRule(key, style, options) {
    this.type = 'viewport';
    this.at = '@viewport';
    this.isProcessed = false;
    this.key = key;
    this.style = style;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */


  var _proto = ViewportRule.prototype;

  _proto.toString = function toString(options) {
    return toCss(this.key, this.style, options);
  };

  return ViewportRule;
}();
var pluginViewportRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    return key === '@viewport' || key === '@-ms-viewport' ? new ViewportRule(key, style, options) : null;
  }
};

var SimpleRule =
/*#__PURE__*/
function () {
  function SimpleRule(key, value, options) {
    this.type = 'simple';
    this.isProcessed = false;
    this.key = key;
    this.value = value;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */
  // eslint-disable-next-line no-unused-vars


  var _proto = SimpleRule.prototype;

  _proto.toString = function toString(options) {
    if (Array.isArray(this.value)) {
      var str = '';

      for (var index = 0; index < this.value.length; index++) {
        str += this.key + " " + this.value[index] + ";";
        if (this.value[index + 1]) str += '\n';
      }

      return str;
    }

    return this.key + " " + this.value + ";";
  };

  return SimpleRule;
}();
var keysMap = {
  '@charset': true,
  '@import': true,
  '@namespace': true
};
var pluginSimpleRule = {
  onCreateRule: function onCreateRule(key, value, options) {
    return key in keysMap ? new SimpleRule(key, value, options) : null;
  }
};

var plugins = [pluginStyleRule, pluginConditionalRule, pluginKeyframesRule, pluginKeyframeRule, pluginFontFaceRule, pluginViewportRule, pluginSimpleRule];

var defaultUpdateOptions = {
  process: true
};
var forceUpdateOptions = {
  force: true,
  process: true
  /**
   * Contains rules objects and allows adding/removing etc.
   * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
   */

};

var RuleList =
/*#__PURE__*/
function () {
  // Rules registry for access by .get() method.
  // It contains the same rule registered by name and by selector.
  // Original styles object.
  // Used to ensure correct rules order.
  function RuleList(options) {
    this.map = {};
    this.raw = {};
    this.index = [];
    this.counter = 0;
    this.options = options;
    this.classes = options.classes;
    this.keyframes = options.keyframes;
  }
  /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */


  var _proto = RuleList.prototype;

  _proto.add = function add(name, decl, ruleOptions) {
    var _this$options = this.options,
        parent = _this$options.parent,
        sheet = _this$options.sheet,
        jss = _this$options.jss,
        Renderer = _this$options.Renderer,
        generateId = _this$options.generateId,
        scoped = _this$options.scoped;

    var options = (0,esm_extends/* default */.Z)({
      classes: this.classes,
      parent: parent,
      sheet: sheet,
      jss: jss,
      Renderer: Renderer,
      generateId: generateId,
      scoped: scoped,
      name: name,
      keyframes: this.keyframes,
      selector: undefined
    }, ruleOptions); // When user uses .createStyleSheet(), duplicate names are not possible, but
    // `sheet.addRule()` opens the door for any duplicate rule name. When this happens
    // we need to make the key unique within this RuleList instance scope.


    var key = name;

    if (name in this.raw) {
      key = name + "-d" + this.counter++;
    } // We need to save the original decl before creating the rule
    // because cache plugin needs to use it as a key to return a cached rule.


    this.raw[key] = decl;

    if (key in this.classes) {
      // E.g. rules inside of @media container
      options.selector = "." + jss_esm_escape(this.classes[key]);
    }

    var rule = createRule(key, decl, options);
    if (!rule) return null;
    this.register(rule);
    var index = options.index === undefined ? this.index.length : options.index;
    this.index.splice(index, 0, rule);
    return rule;
  }
  /**
   * Replace rule.
   * Create a new rule and remove old one instead of overwriting
   * because we want to invoke onCreateRule hook to make plugins work.
   */
  ;

  _proto.replace = function replace(name, decl, ruleOptions) {
    var oldRule = this.get(name);
    var oldIndex = this.index.indexOf(oldRule);

    if (oldRule) {
      this.remove(oldRule);
    }

    var options = ruleOptions;
    if (oldIndex !== -1) options = (0,esm_extends/* default */.Z)({}, ruleOptions, {
      index: oldIndex
    });
    return this.add(name, decl, options);
  }
  /**
   * Get a rule by name or selector.
   */
  ;

  _proto.get = function get(nameOrSelector) {
    return this.map[nameOrSelector];
  }
  /**
   * Delete a rule.
   */
  ;

  _proto.remove = function remove(rule) {
    this.unregister(rule);
    delete this.raw[rule.key];
    this.index.splice(this.index.indexOf(rule), 1);
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.index.indexOf(rule);
  }
  /**
   * Run `onProcessRule()` plugins on every rule.
   */
  ;

  _proto.process = function process() {
    var plugins = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
    // we end up with very hard-to-track-down side effects.

    this.index.slice(0).forEach(plugins.onProcessRule, plugins);
  }
  /**
   * Register a rule in `.map`, `.classes` and `.keyframes` maps.
   */
  ;

  _proto.register = function register(rule) {
    this.map[rule.key] = rule;

    if (rule instanceof StyleRule) {
      this.map[rule.selector] = rule;
      if (rule.id) this.classes[rule.key] = rule.id;
    } else if (rule instanceof KeyframesRule && this.keyframes) {
      this.keyframes[rule.name] = rule.id;
    }
  }
  /**
   * Unregister a rule.
   */
  ;

  _proto.unregister = function unregister(rule) {
    delete this.map[rule.key];

    if (rule instanceof StyleRule) {
      delete this.map[rule.selector];
      delete this.classes[rule.key];
    } else if (rule instanceof KeyframesRule) {
      delete this.keyframes[rule.name];
    }
  }
  /**
   * Update the function values with a new data.
   */
  ;

  _proto.update = function update() {
    var name;
    var data;
    var options;

    if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'string') {
      name = arguments.length <= 0 ? undefined : arguments[0];
      data = arguments.length <= 1 ? undefined : arguments[1];
      options = arguments.length <= 2 ? undefined : arguments[2];
    } else {
      data = arguments.length <= 0 ? undefined : arguments[0];
      options = arguments.length <= 1 ? undefined : arguments[1];
      name = null;
    }

    if (name) {
      this.updateOne(this.get(name), data, options);
    } else {
      for (var index = 0; index < this.index.length; index++) {
        this.updateOne(this.index[index], data, options);
      }
    }
  }
  /**
   * Execute plugins, update rule props.
   */
  ;

  _proto.updateOne = function updateOne(rule, data, options) {
    if (options === void 0) {
      options = defaultUpdateOptions;
    }

    var _this$options2 = this.options,
        plugins = _this$options2.jss.plugins,
        sheet = _this$options2.sheet; // It is a rules container like for e.g. ConditionalRule.

    if (rule.rules instanceof RuleList) {
      rule.rules.update(data, options);
      return;
    }

    var style = rule.style;
    plugins.onUpdate(data, rule, sheet, options); // We rely on a new `style` ref in case it was mutated during onUpdate hook.

    if (options.process && style && style !== rule.style) {
      // We need to run the plugins in case new `style` relies on syntax plugins.
      plugins.onProcessStyle(rule.style, rule, sheet); // Update and add props.

      for (var prop in rule.style) {
        var nextValue = rule.style[prop];
        var prevValue = style[prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.

        if (nextValue !== prevValue) {
          rule.prop(prop, nextValue, forceUpdateOptions);
        }
      } // Remove props.


      for (var _prop in style) {
        var _nextValue = rule.style[_prop];
        var _prevValue = style[_prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.

        if (_nextValue == null && _nextValue !== _prevValue) {
          rule.prop(_prop, null, forceUpdateOptions);
        }
      }
    }
  }
  /**
   * Convert rules to a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    var str = '';
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;

    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    for (var index = 0; index < this.index.length; index++) {
      var rule = this.index[index];
      var css = rule.toString(options); // No need to render an empty rule.

      if (!css && !link) continue;
      if (str) str += linebreak;
      str += css;
    }

    return str;
  };

  return RuleList;
}();

var StyleSheet =
/*#__PURE__*/
function () {
  function StyleSheet(styles, options) {
    this.attached = false;
    this.deployed = false;
    this.classes = {};
    this.keyframes = {};
    this.options = (0,esm_extends/* default */.Z)({}, options, {
      sheet: this,
      parent: this,
      classes: this.classes,
      keyframes: this.keyframes
    });

    if (options.Renderer) {
      this.renderer = new options.Renderer(this);
    }

    this.rules = new RuleList(this.options);

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }
  /**
   * Attach renderable to the render tree.
   */


  var _proto = StyleSheet.prototype;

  _proto.attach = function attach() {
    if (this.attached) return this;
    if (this.renderer) this.renderer.attach();
    this.attached = true; // Order is important, because we can't use insertRule API if style element is not attached.

    if (!this.deployed) this.deploy();
    return this;
  }
  /**
   * Remove renderable from render tree.
   */
  ;

  _proto.detach = function detach() {
    if (!this.attached) return this;
    if (this.renderer) this.renderer.detach();
    this.attached = false;
    return this;
  }
  /**
   * Add a rule to the current stylesheet.
   * Will insert a rule also after the stylesheet has been rendered first time.
   */
  ;

  _proto.addRule = function addRule(name, decl, options) {
    var queue = this.queue; // Plugins can create rules.
    // In order to preserve the right order, we need to queue all `.addRule` calls,
    // which happen after the first `rules.add()` call.

    if (this.attached && !queue) this.queue = [];
    var rule = this.rules.add(name, decl, options);
    if (!rule) return null;
    this.options.jss.plugins.onProcessRule(rule);

    if (this.attached) {
      if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
      // It will be inserted all together when .attach is called.

      if (queue) queue.push(rule);else {
        this.insertRule(rule);

        if (this.queue) {
          this.queue.forEach(this.insertRule, this);
          this.queue = undefined;
        }
      }
      return rule;
    } // We can't add rules to a detached style node.
    // We will redeploy the sheet once user will attach it.


    this.deployed = false;
    return rule;
  }
  /**
   * Replace a rule in the current stylesheet.
   */
  ;

  _proto.replaceRule = function replaceRule(nameOrSelector, decl, options) {
    var oldRule = this.rules.get(nameOrSelector);
    if (!oldRule) return this.addRule(nameOrSelector, decl, options);
    var newRule = this.rules.replace(nameOrSelector, decl, options);

    if (newRule) {
      this.options.jss.plugins.onProcessRule(newRule);
    }

    if (this.attached) {
      if (!this.deployed) return newRule; // Don't replace / delete rule directly if there is no stringified version yet.
      // It will be inserted all together when .attach is called.

      if (this.renderer) {
        if (!newRule) {
          this.renderer.deleteRule(oldRule);
        } else if (oldRule.renderable) {
          this.renderer.replaceRule(oldRule.renderable, newRule);
        }
      }

      return newRule;
    } // We can't replace rules to a detached style node.
    // We will redeploy the sheet once user will attach it.


    this.deployed = false;
    return newRule;
  }
  /**
   * Insert rule into the StyleSheet
   */
  ;

  _proto.insertRule = function insertRule(rule) {
    if (this.renderer) {
      this.renderer.insertRule(rule);
    }
  }
  /**
   * Create and add rules.
   * Will render also after Style Sheet was rendered the first time.
   */
  ;

  _proto.addRules = function addRules(styles, options) {
    var added = [];

    for (var name in styles) {
      var rule = this.addRule(name, styles[name], options);
      if (rule) added.push(rule);
    }

    return added;
  }
  /**
   * Get a rule by name or selector.
   */
  ;

  _proto.getRule = function getRule(nameOrSelector) {
    return this.rules.get(nameOrSelector);
  }
  /**
   * Delete a rule by name.
   * Returns `true`: if rule has been deleted from the DOM.
   */
  ;

  _proto.deleteRule = function deleteRule(name) {
    var rule = typeof name === 'object' ? name : this.rules.get(name);

    if (!rule || // Style sheet was created without link: true and attached, in this case we
    // won't be able to remove the CSS rule from the DOM.
    this.attached && !rule.renderable) {
      return false;
    }

    this.rules.remove(rule);

    if (this.attached && rule.renderable && this.renderer) {
      return this.renderer.deleteRule(rule.renderable);
    }

    return true;
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Deploy pure CSS string to a renderable.
   */
  ;

  _proto.deploy = function deploy() {
    if (this.renderer) this.renderer.deploy();
    this.deployed = true;
    return this;
  }
  /**
   * Update the function values with a new data.
   */
  ;

  _proto.update = function update() {
    var _this$rules;

    (_this$rules = this.rules).update.apply(_this$rules, arguments);

    return this;
  }
  /**
   * Updates a single rule.
   */
  ;

  _proto.updateOne = function updateOne(rule, data, options) {
    this.rules.updateOne(rule, data, options);
    return this;
  }
  /**
   * Convert rules to a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    return this.rules.toString(options);
  };

  return StyleSheet;
}();

var PluginsRegistry =
/*#__PURE__*/
function () {
  function PluginsRegistry() {
    this.plugins = {
      internal: [],
      external: []
    };
    this.registry = {};
  }

  var _proto = PluginsRegistry.prototype;

  /**
   * Call `onCreateRule` hooks and return an object if returned by a hook.
   */
  _proto.onCreateRule = function onCreateRule(name, decl, options) {
    for (var i = 0; i < this.registry.onCreateRule.length; i++) {
      var rule = this.registry.onCreateRule[i](name, decl, options);
      if (rule) return rule;
    }

    return null;
  }
  /**
   * Call `onProcessRule` hooks.
   */
  ;

  _proto.onProcessRule = function onProcessRule(rule) {
    if (rule.isProcessed) return;
    var sheet = rule.options.sheet;

    for (var i = 0; i < this.registry.onProcessRule.length; i++) {
      this.registry.onProcessRule[i](rule, sheet);
    }

    if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
    rule.isProcessed = true;
  }
  /**
   * Call `onProcessStyle` hooks.
   */
  ;

  _proto.onProcessStyle = function onProcessStyle(style, rule, sheet) {
    for (var i = 0; i < this.registry.onProcessStyle.length; i++) {
      rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
    }
  }
  /**
   * Call `onProcessSheet` hooks.
   */
  ;

  _proto.onProcessSheet = function onProcessSheet(sheet) {
    for (var i = 0; i < this.registry.onProcessSheet.length; i++) {
      this.registry.onProcessSheet[i](sheet);
    }
  }
  /**
   * Call `onUpdate` hooks.
   */
  ;

  _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
    for (var i = 0; i < this.registry.onUpdate.length; i++) {
      this.registry.onUpdate[i](data, rule, sheet, options);
    }
  }
  /**
   * Call `onChangeValue` hooks.
   */
  ;

  _proto.onChangeValue = function onChangeValue(value, prop, rule) {
    var processedValue = value;

    for (var i = 0; i < this.registry.onChangeValue.length; i++) {
      processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
    }

    return processedValue;
  }
  /**
   * Register a plugin.
   */
  ;

  _proto.use = function use(newPlugin, options) {
    if (options === void 0) {
      options = {
        queue: 'external'
      };
    }

    var plugins = this.plugins[options.queue]; // Avoids applying same plugin twice, at least based on ref.

    if (plugins.indexOf(newPlugin) !== -1) {
      return;
    }

    plugins.push(newPlugin);
    this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function (registry, plugin) {
      for (var name in plugin) {
        if (name in registry) {
          registry[name].push(plugin[name]);
        } else {
           false ? 0 : void 0;
        }
      }

      return registry;
    }, {
      onCreateRule: [],
      onProcessRule: [],
      onProcessStyle: [],
      onProcessSheet: [],
      onChangeValue: [],
      onUpdate: []
    });
  };

  return PluginsRegistry;
}();

/**
 * Sheets registry to access all instances in one place.
 */

var SheetsRegistry =
/*#__PURE__*/
function () {
  function SheetsRegistry() {
    this.registry = [];
  }

  var _proto = SheetsRegistry.prototype;

  /**
   * Register a Style Sheet.
   */
  _proto.add = function add(sheet) {
    var registry = this.registry;
    var index = sheet.options.index;
    if (registry.indexOf(sheet) !== -1) return;

    if (registry.length === 0 || index >= this.index) {
      registry.push(sheet);
      return;
    } // Find a position.


    for (var i = 0; i < registry.length; i++) {
      if (registry[i].options.index > index) {
        registry.splice(i, 0, sheet);
        return;
      }
    }
  }
  /**
   * Reset the registry.
   */
  ;

  _proto.reset = function reset() {
    this.registry = [];
  }
  /**
   * Remove a Style Sheet.
   */
  ;

  _proto.remove = function remove(sheet) {
    var index = this.registry.indexOf(sheet);
    this.registry.splice(index, 1);
  }
  /**
   * Convert all attached sheets to a CSS string.
   */
  ;

  _proto.toString = function toString(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        attached = _ref.attached,
        options = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["attached"]);

    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    var css = '';

    for (var i = 0; i < this.registry.length; i++) {
      var sheet = this.registry[i];

      if (attached != null && sheet.attached !== attached) {
        continue;
      }

      if (css) css += linebreak;
      css += sheet.toString(options);
    }

    return css;
  };

  (0,createClass/* default */.Z)(SheetsRegistry, [{
    key: "index",

    /**
     * Current highest index number.
     */
    get: function get() {
      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
    }
  }]);

  return SheetsRegistry;
}();

/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */

var sheets = new SheetsRegistry();

/* eslint-disable */

/**
 * Now that `globalThis` is available on most platforms
 * (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis#browser_compatibility)
 * we check for `globalThis` first. `globalThis` is necessary for jss
 * to run in Agoric's secure version of JavaScript (SES). Under SES,
 * `globalThis` exists, but `window`, `self`, and `Function('return
 * this')()` are all undefined for security reasons.
 *
 * https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
 */
var globalThis$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' && window.Math === Math ? window : typeof self !== 'undefined' && self.Math === Math ? self : Function('return this')();

var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
if (globalThis$1[ns] == null) globalThis$1[ns] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.

var moduleId = globalThis$1[ns]++;

var maxRules = 1e10;
/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */

var createGenerateId = function createGenerateId(options) {
  if (options === void 0) {
    options = {};
  }

  var ruleCounter = 0;

  var generateId = function generateId(rule, sheet) {
    ruleCounter += 1;

    if (ruleCounter > maxRules) {
       false ? 0 : void 0;
    }

    var jssId = '';
    var prefix = '';

    if (sheet) {
      if (sheet.options.classNamePrefix) {
        prefix = sheet.options.classNamePrefix;
      }

      if (sheet.options.jss.id != null) {
        jssId = String(sheet.options.jss.id);
      }
    }

    if (options.minify) {
      // Using "c" because a number can't be the first char in a class name.
      return "" + (prefix || 'c') + moduleId + jssId + ruleCounter;
    }

    return prefix + rule.key + "-" + moduleId + (jssId ? "-" + jssId : '') + "-" + ruleCounter;
  };

  return generateId;
};

/**
 * Cache the value from the first time a function is called.
 */

var memoize = function memoize(fn) {
  var value;
  return function () {
    if (!value) value = fn();
    return value;
  };
};
/**
 * Get a style property value.
 */


var getPropertyValue = function getPropertyValue(cssRule, prop) {
  try {
    // Support CSSTOM.
    if (cssRule.attributeStyleMap) {
      return cssRule.attributeStyleMap.get(prop);
    }

    return cssRule.style.getPropertyValue(prop);
  } catch (err) {
    // IE may throw if property is unknown.
    return '';
  }
};
/**
 * Set a style property.
 */


var setProperty = function setProperty(cssRule, prop, value) {
  try {
    var cssValue = value;

    if (Array.isArray(value)) {
      cssValue = toCssValue(value, true);

      if (value[value.length - 1] === '!important') {
        cssRule.style.setProperty(prop, cssValue, 'important');
        return true;
      }
    } // Support CSSTOM.


    if (cssRule.attributeStyleMap) {
      cssRule.attributeStyleMap.set(prop, cssValue);
    } else {
      cssRule.style.setProperty(prop, cssValue);
    }
  } catch (err) {
    // IE may throw if property is unknown.
    return false;
  }

  return true;
};
/**
 * Remove a style property.
 */


var removeProperty = function removeProperty(cssRule, prop) {
  try {
    // Support CSSTOM.
    if (cssRule.attributeStyleMap) {
      cssRule.attributeStyleMap.delete(prop);
    } else {
      cssRule.style.removeProperty(prop);
    }
  } catch (err) {
     false ? 0 : void 0;
  }
};
/**
 * Set the selector.
 */


var setSelector = function setSelector(cssRule, selectorText) {
  cssRule.selectorText = selectorText; // Return false if setter was not successful.
  // Currently works in chrome only.

  return cssRule.selectorText === selectorText;
};
/**
 * Gets the `head` element upon the first call and caches it.
 * We assume it can't be null.
 */


var getHead = memoize(function () {
  return document.querySelector('head');
});
/**
 * Find attached sheet with an index higher than the passed one.
 */

function findHigherSheet(registry, options) {
  for (var i = 0; i < registry.length; i++) {
    var sheet = registry[i];

    if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }

  return null;
}
/**
 * Find attached sheet with the highest index.
 */


function findHighestSheet(registry, options) {
  for (var i = registry.length - 1; i >= 0; i--) {
    var sheet = registry[i];

    if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }

  return null;
}
/**
 * Find a comment with "jss" inside.
 */


function findCommentNode(text) {
  var head = getHead();

  for (var i = 0; i < head.childNodes.length; i++) {
    var node = head.childNodes[i];

    if (node.nodeType === 8 && node.nodeValue.trim() === text) {
      return node;
    }
  }

  return null;
}
/**
 * Find a node before which we can insert the sheet.
 */


function findPrevNode(options) {
  var registry = sheets.registry;

  if (registry.length > 0) {
    // Try to insert before the next higher sheet.
    var sheet = findHigherSheet(registry, options);

    if (sheet && sheet.renderer) {
      return {
        parent: sheet.renderer.element.parentNode,
        node: sheet.renderer.element
      };
    } // Otherwise insert after the last attached.


    sheet = findHighestSheet(registry, options);

    if (sheet && sheet.renderer) {
      return {
        parent: sheet.renderer.element.parentNode,
        node: sheet.renderer.element.nextSibling
      };
    }
  } // Try to find a comment placeholder if registry is empty.


  var insertionPoint = options.insertionPoint;

  if (insertionPoint && typeof insertionPoint === 'string') {
    var comment = findCommentNode(insertionPoint);

    if (comment) {
      return {
        parent: comment.parentNode,
        node: comment.nextSibling
      };
    } // If user specifies an insertion point and it can't be found in the document -
    // bad specificity issues may appear.


     false ? 0 : void 0;
  }

  return false;
}
/**
 * Insert style element into the DOM.
 */


function insertStyle(style, options) {
  var insertionPoint = options.insertionPoint;
  var nextNode = findPrevNode(options);

  if (nextNode !== false && nextNode.parent) {
    nextNode.parent.insertBefore(style, nextNode.node);
    return;
  } // Works with iframes and any node types.


  if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
    var insertionPointElement = insertionPoint;
    var parentNode = insertionPointElement.parentNode;
    if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);else  false ? 0 : void 0;
    return;
  }

  getHead().appendChild(style);
}
/**
 * Read jss nonce setting from the page if the user has set it.
 */


var getNonce = memoize(function () {
  var node = document.querySelector('meta[property="csp-nonce"]');
  return node ? node.getAttribute('content') : null;
});

var _insertRule = function insertRule(container, rule, index) {
  try {
    if ('insertRule' in container) {
      container.insertRule(rule, index);
    } // Keyframes rule.
    else if ('appendRule' in container) {
        container.appendRule(rule);
      }
  } catch (err) {
     false ? 0 : void 0;
    return false;
  }

  return container.cssRules[index];
};

var getValidRuleInsertionIndex = function getValidRuleInsertionIndex(container, index) {
  var maxIndex = container.cssRules.length; // In case previous insertion fails, passed index might be wrong

  if (index === undefined || index > maxIndex) {
    // eslint-disable-next-line no-param-reassign
    return maxIndex;
  }

  return index;
};

var createStyle = function createStyle() {
  var el = document.createElement('style'); // Without it, IE will have a broken source order specificity if we
  // insert rules after we insert the style tag.
  // It seems to kick-off the source order specificity algorithm.

  el.textContent = '\n';
  return el;
};

var DomRenderer =
/*#__PURE__*/
function () {
  // Will be empty if link: true option is not set, because
  // it is only for use together with insertRule API.
  function DomRenderer(sheet) {
    this.getPropertyValue = getPropertyValue;
    this.setProperty = setProperty;
    this.removeProperty = removeProperty;
    this.setSelector = setSelector;
    this.hasInsertedRules = false;
    this.cssRules = [];
    // There is no sheet when the renderer is used from a standalone StyleRule.
    if (sheet) sheets.add(sheet);
    this.sheet = sheet;

    var _ref = this.sheet ? this.sheet.options : {},
        media = _ref.media,
        meta = _ref.meta,
        element = _ref.element;

    this.element = element || createStyle();
    this.element.setAttribute('data-jss', '');
    if (media) this.element.setAttribute('media', media);
    if (meta) this.element.setAttribute('data-meta', meta);
    var nonce = getNonce();
    if (nonce) this.element.setAttribute('nonce', nonce);
  }
  /**
   * Insert style element into render tree.
   */


  var _proto = DomRenderer.prototype;

  _proto.attach = function attach() {
    // In the case the element node is external and it is already in the DOM.
    if (this.element.parentNode || !this.sheet) return;
    insertStyle(this.element, this.sheet.options); // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
    // most browsers create a new CSSStyleSheet, except of all IEs.

    var deployed = Boolean(this.sheet && this.sheet.deployed);

    if (this.hasInsertedRules && deployed) {
      this.hasInsertedRules = false;
      this.deploy();
    }
  }
  /**
   * Remove style element from render tree.
   */
  ;

  _proto.detach = function detach() {
    if (!this.sheet) return;
    var parentNode = this.element.parentNode;
    if (parentNode) parentNode.removeChild(this.element); // In the most browsers, rules inserted using insertRule() API will be lost when style element is removed.
    // Though IE will keep them and we need a consistent behavior.

    if (this.sheet.options.link) {
      this.cssRules = [];
      this.element.textContent = '\n';
    }
  }
  /**
   * Inject CSS string into element.
   */
  ;

  _proto.deploy = function deploy() {
    var sheet = this.sheet;
    if (!sheet) return;

    if (sheet.options.link) {
      this.insertRules(sheet.rules);
      return;
    }

    this.element.textContent = "\n" + sheet.toString() + "\n";
  }
  /**
   * Insert RuleList into an element.
   */
  ;

  _proto.insertRules = function insertRules(rules, nativeParent) {
    for (var i = 0; i < rules.index.length; i++) {
      this.insertRule(rules.index[i], i, nativeParent);
    }
  }
  /**
   * Insert a rule into element.
   */
  ;

  _proto.insertRule = function insertRule(rule, index, nativeParent) {
    if (nativeParent === void 0) {
      nativeParent = this.element.sheet;
    }

    if (rule.rules) {
      var parent = rule;
      var latestNativeParent = nativeParent;

      if (rule.type === 'conditional' || rule.type === 'keyframes') {
        var _insertionIndex = getValidRuleInsertionIndex(nativeParent, index); // We need to render the container without children first.


        latestNativeParent = _insertRule(nativeParent, parent.toString({
          children: false
        }), _insertionIndex);

        if (latestNativeParent === false) {
          return false;
        }

        this.refCssRule(rule, _insertionIndex, latestNativeParent);
      }

      this.insertRules(parent.rules, latestNativeParent);
      return latestNativeParent;
    }

    var ruleStr = rule.toString();
    if (!ruleStr) return false;
    var insertionIndex = getValidRuleInsertionIndex(nativeParent, index);

    var nativeRule = _insertRule(nativeParent, ruleStr, insertionIndex);

    if (nativeRule === false) {
      return false;
    }

    this.hasInsertedRules = true;
    this.refCssRule(rule, insertionIndex, nativeRule);
    return nativeRule;
  };

  _proto.refCssRule = function refCssRule(rule, index, cssRule) {
    rule.renderable = cssRule; // We only want to reference the top level rules, deleteRule API doesn't support removing nested rules
    // like rules inside media queries or keyframes

    if (rule.options.parent instanceof StyleSheet) {
      this.cssRules.splice(index, 0, cssRule);
    }
  }
  /**
   * Delete a rule.
   */
  ;

  _proto.deleteRule = function deleteRule(cssRule) {
    var sheet = this.element.sheet;
    var index = this.indexOf(cssRule);
    if (index === -1) return false;
    sheet.deleteRule(index);
    this.cssRules.splice(index, 1);
    return true;
  }
  /**
   * Get index of a CSS Rule.
   */
  ;

  _proto.indexOf = function indexOf(cssRule) {
    return this.cssRules.indexOf(cssRule);
  }
  /**
   * Generate a new CSS rule and replace the existing one.
   */
  ;

  _proto.replaceRule = function replaceRule(cssRule, rule) {
    var index = this.indexOf(cssRule);
    if (index === -1) return false;
    this.element.sheet.deleteRule(index);
    this.cssRules.splice(index, 1);
    return this.insertRule(rule, index);
  }
  /**
   * Get all rules elements.
   */
  ;

  _proto.getRules = function getRules() {
    return this.element.sheet.cssRules;
  };

  return DomRenderer;
}();

var instanceCounter = 0;

var Jss =
/*#__PURE__*/
function () {
  function Jss(options) {
    this.id = instanceCounter++;
    this.version = "10.9.0";
    this.plugins = new PluginsRegistry();
    this.options = {
      id: {
        minify: false
      },
      createGenerateId: createGenerateId,
      Renderer: dist_module ? DomRenderer : null,
      plugins: []
    };
    this.generateId = createGenerateId({
      minify: false
    });

    for (var i = 0; i < plugins.length; i++) {
      this.plugins.use(plugins[i], {
        queue: 'internal'
      });
    }

    this.setup(options);
  }
  /**
   * Prepares various options, applies plugins.
   * Should not be used twice on the same instance, because there is no plugins
   * deduplication logic.
   */


  var _proto = Jss.prototype;

  _proto.setup = function setup(options) {
    if (options === void 0) {
      options = {};
    }

    if (options.createGenerateId) {
      this.options.createGenerateId = options.createGenerateId;
    }

    if (options.id) {
      this.options.id = (0,esm_extends/* default */.Z)({}, this.options.id, options.id);
    }

    if (options.createGenerateId || options.id) {
      this.generateId = this.options.createGenerateId(this.options.id);
    }

    if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;

    if ('Renderer' in options) {
      this.options.Renderer = options.Renderer;
    } // eslint-disable-next-line prefer-spread


    if (options.plugins) this.use.apply(this, options.plugins);
    return this;
  }
  /**
   * Create a Style Sheet.
   */
  ;

  _proto.createStyleSheet = function createStyleSheet(styles, options) {
    if (options === void 0) {
      options = {};
    }

    var _options = options,
        index = _options.index;

    if (typeof index !== 'number') {
      index = sheets.index === 0 ? 0 : sheets.index + 1;
    }

    var sheet = new StyleSheet(styles, (0,esm_extends/* default */.Z)({}, options, {
      jss: this,
      generateId: options.generateId || this.generateId,
      insertionPoint: this.options.insertionPoint,
      Renderer: this.options.Renderer,
      index: index
    }));
    this.plugins.onProcessSheet(sheet);
    return sheet;
  }
  /**
   * Detach the Style Sheet and remove it from the registry.
   */
  ;

  _proto.removeStyleSheet = function removeStyleSheet(sheet) {
    sheet.detach();
    sheets.remove(sheet);
    return this;
  }
  /**
   * Create a rule without a Style Sheet.
   * [Deprecated] will be removed in the next major version.
   */
  ;

  _proto.createRule = function createRule$1(name, style, options) {
    if (style === void 0) {
      style = {};
    }

    if (options === void 0) {
      options = {};
    }

    // Enable rule without name for inline styles.
    if (typeof name === 'object') {
      return this.createRule(undefined, name, style);
    }

    var ruleOptions = (0,esm_extends/* default */.Z)({}, options, {
      name: name,
      jss: this,
      Renderer: this.options.Renderer
    });

    if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
    if (!ruleOptions.classes) ruleOptions.classes = {};
    if (!ruleOptions.keyframes) ruleOptions.keyframes = {};

    var rule = createRule(name, style, ruleOptions);

    if (rule) this.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Register plugin. Passed function will be invoked with a rule instance.
   */
  ;

  _proto.use = function use() {
    var _this = this;

    for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
      plugins[_key] = arguments[_key];
    }

    plugins.forEach(function (plugin) {
      _this.plugins.use(plugin);
    });
    return this;
  };

  return Jss;
}();

var createJss = function createJss(options) {
  return new Jss(options);
};

/**
 * SheetsManager is like a WeakMap which is designed to count StyleSheet
 * instances and attach/detach automatically.
 * Used in react-jss.
 */

var SheetsManager =
/*#__PURE__*/
(/* unused pure expression or super */ null && (function () {
  function SheetsManager() {
    this.length = 0;
    this.sheets = new WeakMap();
  }

  var _proto = SheetsManager.prototype;

  _proto.get = function get(key) {
    var entry = this.sheets.get(key);
    return entry && entry.sheet;
  };

  _proto.add = function add(key, sheet) {
    if (this.sheets.has(key)) return;
    this.length++;
    this.sheets.set(key, {
      sheet: sheet,
      refs: 0
    });
  };

  _proto.manage = function manage(key) {
    var entry = this.sheets.get(key);

    if (entry) {
      if (entry.refs === 0) {
        entry.sheet.attach();
      }

      entry.refs++;
      return entry.sheet;
    }

    warning(false, "[JSS] SheetsManager: can't find sheet to manage");
    return undefined;
  };

  _proto.unmanage = function unmanage(key) {
    var entry = this.sheets.get(key);

    if (entry) {
      if (entry.refs > 0) {
        entry.refs--;
        if (entry.refs === 0) entry.sheet.detach();
      }
    } else {
      warning(false, "SheetsManager: can't find sheet to unmanage");
    }
  };

  _createClass(SheetsManager, [{
    key: "size",
    get: function get() {
      return this.length;
    }
  }]);

  return SheetsManager;
}()));

/**
* Export a constant indicating if this browser has CSSTOM support.
* https://developers.google.com/web/updates/2018/03/cssom
*/
var hasCSSTOMSupport = typeof CSS === 'object' && CSS != null && 'number' in CSS;

/**
 * Extracts a styles object with only props that contain function values.
 */
function getDynamicStyles(styles) {
  var to = null;

  for (var key in styles) {
    var value = styles[key];
    var type = typeof value;

    if (type === 'function') {
      if (!to) to = {};
      to[key] = value;
    } else if (type === 'object' && value !== null && !Array.isArray(value)) {
      var extracted = getDynamicStyles(value);

      if (extracted) {
        if (!to) to = {};
        to[key] = extracted;
      }
    }
  }

  return to;
}

/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */
var index = createJss();

/* harmony default export */ var jss_esm = ((/* unused pure expression or super */ null && (index)));


// EXTERNAL MODULE: ./node_modules/@material-ui/styles/esm/mergeClasses/mergeClasses.js
var mergeClasses = __webpack_require__(65835);
;// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/makeStyles/multiKeyStore.js
// Used https://github.com/thinkloop/multi-key-cache as inspiration
var multiKeyStore = {
  set: function set(cache, key1, key2, value) {
    var subCache = cache.get(key1);

    if (!subCache) {
      subCache = new Map();
      cache.set(key1, subCache);
    }

    subCache.set(key2, value);
  },
  get: function get(cache, key1, key2) {
    var subCache = cache.get(key1);
    return subCache ? subCache.get(key2) : undefined;
  },
  delete: function _delete(cache, key1, key2) {
    var subCache = cache.get(key1);
    subCache.delete(key2);
  }
};
/* harmony default export */ var makeStyles_multiKeyStore = (multiKeyStore);
// EXTERNAL MODULE: ./node_modules/@material-ui/styles/esm/useTheme/useTheme.js
var useTheme = __webpack_require__(159);
// EXTERNAL MODULE: ./node_modules/@material-ui/styles/esm/ThemeProvider/nested.js
var nested = __webpack_require__(17076);
;// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/createGenerateClassName/createGenerateClassName.js

/**
 * This is the list of the style rule name we use as drop in replacement for the built-in
 * pseudo classes (:checked, :disabled, :focused, etc.).
 *
 * Why do they exist in the first place?
 * These classes are used at a specificity of 2.
 * It allows them to override previously definied styles as well as
 * being untouched by simple user overrides.
 */

var pseudoClasses = ['checked', 'disabled', 'error', 'focused', 'focusVisible', 'required', 'expanded', 'selected']; // Returns a function which generates unique class names based on counters.
// When new generator function is created, rule counter is reset.
// We need to reset the rule counter for SSR for each request.
//
// It's inspired by
// https://github.com/cssinjs/jss/blob/4e6a05dd3f7b6572fdd3ab216861d9e446c20331/src/utils/createGenerateClassName.js

function createGenerateClassName() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$disableGloba = options.disableGlobal,
      disableGlobal = _options$disableGloba === void 0 ? false : _options$disableGloba,
      _options$productionPr = options.productionPrefix,
      productionPrefix = _options$productionPr === void 0 ? 'jss' : _options$productionPr,
      _options$seed = options.seed,
      seed = _options$seed === void 0 ? '' : _options$seed;
  var seedPrefix = seed === '' ? '' : "".concat(seed, "-");
  var ruleCounter = 0;

  var getNextCounterId = function getNextCounterId() {
    ruleCounter += 1;

    if (false) {}

    return ruleCounter;
  };

  return function (rule, styleSheet) {
    var name = styleSheet.options.name; // Is a global static MUI style?

    if (name && name.indexOf('Mui') === 0 && !styleSheet.options.link && !disableGlobal) {
      // We can use a shorthand class name, we never use the keys to style the components.
      if (pseudoClasses.indexOf(rule.key) !== -1) {
        return "Mui-".concat(rule.key);
      }

      var prefix = "".concat(seedPrefix).concat(name, "-").concat(rule.key);

      if (!styleSheet.options.theme[nested/* default */.Z] || seed !== '') {
        return prefix;
      }

      return "".concat(prefix, "-").concat(getNextCounterId());
    }

    if (true) {
      return "".concat(seedPrefix).concat(productionPrefix).concat(getNextCounterId());
    }

    var suffix = "".concat(rule.key, "-").concat(getNextCounterId()); // Help with debuggability.

    if (styleSheet.options.classNamePrefix) {
      return "".concat(seedPrefix).concat(styleSheet.options.classNamePrefix, "-").concat(suffix);
    }

    return "".concat(seedPrefix).concat(suffix);
  };
}
;// CONCATENATED MODULE: ./node_modules/jss-plugin-rule-value-function/dist/jss-plugin-rule-value-function.esm.js



var now = Date.now();
var fnValuesNs = "fnValues" + now;
var fnRuleNs = "fnStyle" + ++now;

var functionPlugin = function functionPlugin() {
  return {
    onCreateRule: function onCreateRule(name, decl, options) {
      if (typeof decl !== 'function') return null;
      var rule = createRule(name, {}, options);
      rule[fnRuleNs] = decl;
      return rule;
    },
    onProcessStyle: function onProcessStyle(style, rule) {
      // We need to extract function values from the declaration, so that we can keep core unaware of them.
      // We need to do that only once.
      // We don't need to extract functions on each style update, since this can happen only once.
      // We don't support function values inside of function rules.
      if (fnValuesNs in rule || fnRuleNs in rule) return style;
      var fnValues = {};

      for (var prop in style) {
        var value = style[prop];
        if (typeof value !== 'function') continue;
        delete style[prop];
        fnValues[prop] = value;
      }

      rule[fnValuesNs] = fnValues;
      return style;
    },
    onUpdate: function onUpdate(data, rule, sheet, options) {
      var styleRule = rule;
      var fnRule = styleRule[fnRuleNs]; // If we have a style function, the entire rule is dynamic and style object
      // will be returned from that function.

      if (fnRule) {
        // Empty object will remove all currently defined props
        // in case function rule returns a falsy value.
        styleRule.style = fnRule(data) || {};

        if (false) { var prop; }
      }

      var fnValues = styleRule[fnValuesNs]; // If we have a fn values map, it is a rule with function values.

      if (fnValues) {
        for (var _prop in fnValues) {
          styleRule.prop(_prop, fnValues[_prop](data), options);
        }
      }
    }
  };
};

/* harmony default export */ var jss_plugin_rule_value_function_esm = (functionPlugin);

;// CONCATENATED MODULE: ./node_modules/jss-plugin-global/dist/jss-plugin-global.esm.js



var at = '@global';
var atPrefix = '@global ';

var GlobalContainerRule =
/*#__PURE__*/
function () {
  function GlobalContainerRule(key, styles, options) {
    this.type = 'global';
    this.at = at;
    this.isProcessed = false;
    this.key = key;
    this.options = options;
    this.rules = new RuleList((0,esm_extends/* default */.Z)({}, options, {
      parent: this
    }));

    for (var selector in styles) {
      this.rules.add(selector, styles[selector]);
    }

    this.rules.process();
  }
  /**
   * Get a rule.
   */


  var _proto = GlobalContainerRule.prototype;

  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  }
  /**
   * Create and register rule, run plugins.
   */
  ;

  _proto.addRule = function addRule(name, style, options) {
    var rule = this.rules.add(name, style, options);
    if (rule) this.options.jss.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Replace rule, run plugins.
   */
  ;

  _proto.replaceRule = function replaceRule(name, style, options) {
    var newRule = this.rules.replace(name, style, options);
    if (newRule) this.options.jss.plugins.onProcessRule(newRule);
    return newRule;
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    return this.rules.toString(options);
  };

  return GlobalContainerRule;
}();

var GlobalPrefixedRule =
/*#__PURE__*/
function () {
  function GlobalPrefixedRule(key, style, options) {
    this.type = 'global';
    this.at = at;
    this.isProcessed = false;
    this.key = key;
    this.options = options;
    var selector = key.substr(atPrefix.length);
    this.rule = options.jss.createRule(selector, style, (0,esm_extends/* default */.Z)({}, options, {
      parent: this
    }));
  }

  var _proto2 = GlobalPrefixedRule.prototype;

  _proto2.toString = function toString(options) {
    return this.rule ? this.rule.toString(options) : '';
  };

  return GlobalPrefixedRule;
}();

var separatorRegExp = /\s*,\s*/g;

function addScope(selector, scope) {
  var parts = selector.split(separatorRegExp);
  var scoped = '';

  for (var i = 0; i < parts.length; i++) {
    scoped += scope + " " + parts[i].trim();
    if (parts[i + 1]) scoped += ', ';
  }

  return scoped;
}

function handleNestedGlobalContainerRule(rule, sheet) {
  var options = rule.options,
      style = rule.style;
  var rules = style ? style[at] : null;
  if (!rules) return;

  for (var name in rules) {
    sheet.addRule(name, rules[name], (0,esm_extends/* default */.Z)({}, options, {
      selector: addScope(name, rule.selector)
    }));
  }

  delete style[at];
}

function handlePrefixedGlobalRule(rule, sheet) {
  var options = rule.options,
      style = rule.style;

  for (var prop in style) {
    if (prop[0] !== '@' || prop.substr(0, at.length) !== at) continue;
    var selector = addScope(prop.substr(at.length), rule.selector);
    sheet.addRule(selector, style[prop], (0,esm_extends/* default */.Z)({}, options, {
      selector: selector
    }));
    delete style[prop];
  }
}
/**
 * Convert nested rules to separate, remove them from original styles.
 */


function jssGlobal() {
  function onCreateRule(name, styles, options) {
    if (!name) return null;

    if (name === at) {
      return new GlobalContainerRule(name, styles, options);
    }

    if (name[0] === '@' && name.substr(0, atPrefix.length) === atPrefix) {
      return new GlobalPrefixedRule(name, styles, options);
    }

    var parent = options.parent;

    if (parent) {
      if (parent.type === 'global' || parent.options.parent && parent.options.parent.type === 'global') {
        options.scoped = false;
      }
    }

    if (!options.selector && options.scoped === false) {
      options.selector = name;
    }

    return null;
  }

  function onProcessRule(rule, sheet) {
    if (rule.type !== 'style' || !sheet) return;
    handleNestedGlobalContainerRule(rule, sheet);
    handlePrefixedGlobalRule(rule, sheet);
  }

  return {
    onCreateRule: onCreateRule,
    onProcessRule: onProcessRule
  };
}

/* harmony default export */ var jss_plugin_global_esm = (jssGlobal);

;// CONCATENATED MODULE: ./node_modules/jss-plugin-nested/dist/jss-plugin-nested.esm.js



var jss_plugin_nested_esm_separatorRegExp = /\s*,\s*/g;
var parentRegExp = /&/g;
var jss_plugin_nested_esm_refRegExp = /\$([\w-]+)/g;
/**
 * Convert nested rules to separate, remove them from original styles.
 */

function jssNested() {
  // Get a function to be used for $ref replacement.
  function getReplaceRef(container, sheet) {
    return function (match, key) {
      var rule = container.getRule(key) || sheet && sheet.getRule(key);

      if (rule) {
        return rule.selector;
      }

       false ? 0 : void 0;
      return key;
    };
  }

  function replaceParentRefs(nestedProp, parentProp) {
    var parentSelectors = parentProp.split(jss_plugin_nested_esm_separatorRegExp);
    var nestedSelectors = nestedProp.split(jss_plugin_nested_esm_separatorRegExp);
    var result = '';

    for (var i = 0; i < parentSelectors.length; i++) {
      var parent = parentSelectors[i];

      for (var j = 0; j < nestedSelectors.length; j++) {
        var nested = nestedSelectors[j];
        if (result) result += ', '; // Replace all & by the parent or prefix & with the parent.

        result += nested.indexOf('&') !== -1 ? nested.replace(parentRegExp, parent) : parent + " " + nested;
      }
    }

    return result;
  }

  function getOptions(rule, container, prevOptions) {
    // Options has been already created, now we only increase index.
    if (prevOptions) return (0,esm_extends/* default */.Z)({}, prevOptions, {
      index: prevOptions.index + 1
    });
    var nestingLevel = rule.options.nestingLevel;
    nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;

    var options = (0,esm_extends/* default */.Z)({}, rule.options, {
      nestingLevel: nestingLevel,
      index: container.indexOf(rule) + 1 // We don't need the parent name to be set options for chlid.

    });

    delete options.name;
    return options;
  }

  function onProcessStyle(style, rule, sheet) {
    if (rule.type !== 'style') return style;
    var styleRule = rule;
    var container = styleRule.options.parent;
    var options;
    var replaceRef;

    for (var prop in style) {
      var isNested = prop.indexOf('&') !== -1;
      var isNestedConditional = prop[0] === '@';
      if (!isNested && !isNestedConditional) continue;
      options = getOptions(styleRule, container, options);

      if (isNested) {
        var selector = replaceParentRefs(prop, styleRule.selector); // Lazily create the ref replacer function just once for
        // all nested rules within the sheet.

        if (!replaceRef) replaceRef = getReplaceRef(container, sheet); // Replace all $refs.

        selector = selector.replace(jss_plugin_nested_esm_refRegExp, replaceRef);
        var name = styleRule.key + "-" + prop;

        if ('replaceRule' in container) {
          // for backward compatibility
          container.replaceRule(name, style[prop], (0,esm_extends/* default */.Z)({}, options, {
            selector: selector
          }));
        } else {
          container.addRule(name, style[prop], (0,esm_extends/* default */.Z)({}, options, {
            selector: selector
          }));
        }
      } else if (isNestedConditional) {
        // Place conditional right after the parent rule to ensure right ordering.
        container.addRule(prop, {}, options).addRule(styleRule.key, style[prop], {
          selector: styleRule.selector
        });
      }

      delete style[prop];
    }

    return style;
  }

  return {
    onProcessStyle: onProcessStyle
  };
}

/* harmony default export */ var jss_plugin_nested_esm = (jssNested);

;// CONCATENATED MODULE: ./node_modules/hyphenate-style-name/index.js
/* eslint-disable no-var, prefer-template */
var uppercasePattern = /[A-Z]/g
var msPattern = /^ms-/
var cache = {}

function toHyphenLower(match) {
  return '-' + match.toLowerCase()
}

function hyphenateStyleName(name) {
  if (cache.hasOwnProperty(name)) {
    return cache[name]
  }

  var hName = name.replace(uppercasePattern, toHyphenLower)
  return (cache[name] = msPattern.test(hName) ? '-' + hName : hName)
}

/* harmony default export */ var hyphenate_style_name = (hyphenateStyleName);

;// CONCATENATED MODULE: ./node_modules/jss-plugin-camel-case/dist/jss-plugin-camel-case.esm.js


/**
 * Convert camel cased property names to dash separated.
 */

function convertCase(style) {
  var converted = {};

  for (var prop in style) {
    var key = prop.indexOf('--') === 0 ? prop : hyphenate_style_name(prop);
    converted[key] = style[prop];
  }

  if (style.fallbacks) {
    if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map(convertCase);else converted.fallbacks = convertCase(style.fallbacks);
  }

  return converted;
}
/**
 * Allow camel cased property names by converting them back to dasherized.
 */


function camelCase() {
  function onProcessStyle(style) {
    if (Array.isArray(style)) {
      // Handle rules like @font-face, which can have multiple styles in an array
      for (var index = 0; index < style.length; index++) {
        style[index] = convertCase(style[index]);
      }

      return style;
    }

    return convertCase(style);
  }

  function onChangeValue(value, prop, rule) {
    if (prop.indexOf('--') === 0) {
      return value;
    }

    var hyphenatedProp = hyphenate_style_name(prop); // There was no camel case in place

    if (prop === hyphenatedProp) return value;
    rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.

    return null;
  }

  return {
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

/* harmony default export */ var jss_plugin_camel_case_esm = (camelCase);

;// CONCATENATED MODULE: ./node_modules/jss-plugin-default-unit/dist/jss-plugin-default-unit.esm.js


var px = hasCSSTOMSupport && CSS ? CSS.px : 'px';
var ms = hasCSSTOMSupport && CSS ? CSS.ms : 'ms';
var percent = hasCSSTOMSupport && CSS ? CSS.percent : '%';
/**
 * Generated jss-plugin-default-unit CSS property units
 */

var defaultUnits = {
  // Animation properties
  'animation-delay': ms,
  'animation-duration': ms,
  // Background properties
  'background-position': px,
  'background-position-x': px,
  'background-position-y': px,
  'background-size': px,
  // Border Properties
  border: px,
  'border-bottom': px,
  'border-bottom-left-radius': px,
  'border-bottom-right-radius': px,
  'border-bottom-width': px,
  'border-left': px,
  'border-left-width': px,
  'border-radius': px,
  'border-right': px,
  'border-right-width': px,
  'border-top': px,
  'border-top-left-radius': px,
  'border-top-right-radius': px,
  'border-top-width': px,
  'border-width': px,
  'border-block': px,
  'border-block-end': px,
  'border-block-end-width': px,
  'border-block-start': px,
  'border-block-start-width': px,
  'border-block-width': px,
  'border-inline': px,
  'border-inline-end': px,
  'border-inline-end-width': px,
  'border-inline-start': px,
  'border-inline-start-width': px,
  'border-inline-width': px,
  'border-start-start-radius': px,
  'border-start-end-radius': px,
  'border-end-start-radius': px,
  'border-end-end-radius': px,
  // Margin properties
  margin: px,
  'margin-bottom': px,
  'margin-left': px,
  'margin-right': px,
  'margin-top': px,
  'margin-block': px,
  'margin-block-end': px,
  'margin-block-start': px,
  'margin-inline': px,
  'margin-inline-end': px,
  'margin-inline-start': px,
  // Padding properties
  padding: px,
  'padding-bottom': px,
  'padding-left': px,
  'padding-right': px,
  'padding-top': px,
  'padding-block': px,
  'padding-block-end': px,
  'padding-block-start': px,
  'padding-inline': px,
  'padding-inline-end': px,
  'padding-inline-start': px,
  // Mask properties
  'mask-position-x': px,
  'mask-position-y': px,
  'mask-size': px,
  // Width and height properties
  height: px,
  width: px,
  'min-height': px,
  'max-height': px,
  'min-width': px,
  'max-width': px,
  // Position properties
  bottom: px,
  left: px,
  top: px,
  right: px,
  inset: px,
  'inset-block': px,
  'inset-block-end': px,
  'inset-block-start': px,
  'inset-inline': px,
  'inset-inline-end': px,
  'inset-inline-start': px,
  // Shadow properties
  'box-shadow': px,
  'text-shadow': px,
  // Column properties
  'column-gap': px,
  'column-rule': px,
  'column-rule-width': px,
  'column-width': px,
  // Font and text properties
  'font-size': px,
  'font-size-delta': px,
  'letter-spacing': px,
  'text-decoration-thickness': px,
  'text-indent': px,
  'text-stroke': px,
  'text-stroke-width': px,
  'word-spacing': px,
  // Motion properties
  motion: px,
  'motion-offset': px,
  // Outline properties
  outline: px,
  'outline-offset': px,
  'outline-width': px,
  // Perspective properties
  perspective: px,
  'perspective-origin-x': percent,
  'perspective-origin-y': percent,
  // Transform properties
  'transform-origin': percent,
  'transform-origin-x': percent,
  'transform-origin-y': percent,
  'transform-origin-z': percent,
  // Transition properties
  'transition-delay': ms,
  'transition-duration': ms,
  // Alignment properties
  'vertical-align': px,
  'flex-basis': px,
  // Some random properties
  'shape-margin': px,
  size: px,
  gap: px,
  // Grid properties
  grid: px,
  'grid-gap': px,
  'row-gap': px,
  'grid-row-gap': px,
  'grid-column-gap': px,
  'grid-template-rows': px,
  'grid-template-columns': px,
  'grid-auto-rows': px,
  'grid-auto-columns': px,
  // Not existing properties.
  // Used to avoid issues with jss-plugin-expand integration.
  'box-shadow-x': px,
  'box-shadow-y': px,
  'box-shadow-blur': px,
  'box-shadow-spread': px,
  'font-line-height': px,
  'text-shadow-x': px,
  'text-shadow-y': px,
  'text-shadow-blur': px
};

/**
 * Clones the object and adds a camel cased property version.
 */

function addCamelCasedVersion(obj) {
  var regExp = /(-[a-z])/g;

  var replace = function replace(str) {
    return str[1].toUpperCase();
  };

  var newObj = {};

  for (var key in obj) {
    newObj[key] = obj[key];
    newObj[key.replace(regExp, replace)] = obj[key];
  }

  return newObj;
}

var units = addCamelCasedVersion(defaultUnits);
/**
 * Recursive deep style passing function
 */

function iterate(prop, value, options) {
  if (value == null) return value;

  if (Array.isArray(value)) {
    for (var i = 0; i < value.length; i++) {
      value[i] = iterate(prop, value[i], options);
    }
  } else if (typeof value === 'object') {
    if (prop === 'fallbacks') {
      for (var innerProp in value) {
        value[innerProp] = iterate(innerProp, value[innerProp], options);
      }
    } else {
      for (var _innerProp in value) {
        value[_innerProp] = iterate(prop + "-" + _innerProp, value[_innerProp], options);
      }
    } // eslint-disable-next-line no-restricted-globals

  } else if (typeof value === 'number' && isNaN(value) === false) {
    var unit = options[prop] || units[prop]; // Add the unit if available, except for the special case of 0px.

    if (unit && !(value === 0 && unit === px)) {
      return typeof unit === 'function' ? unit(value).toString() : "" + value + unit;
    }

    return value.toString();
  }

  return value;
}
/**
 * Add unit to numeric values.
 */


function defaultUnit(options) {
  if (options === void 0) {
    options = {};
  }

  var camelCasedOptions = addCamelCasedVersion(options);

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    for (var prop in style) {
      style[prop] = iterate(prop, style[prop], camelCasedOptions);
    }

    return style;
  }

  function onChangeValue(value, prop) {
    return iterate(prop, value, camelCasedOptions);
  }

  return {
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

/* harmony default export */ var jss_plugin_default_unit_esm = (defaultUnit);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(41451);
;// CONCATENATED MODULE: ./node_modules/css-vendor/dist/css-vendor.esm.js



// Export javascript style and css style vendor prefixes.
var js = '';
var css = '';
var vendor = '';
var browser = '';
var isTouch = dist_module && 'ontouchstart' in document.documentElement; // We should not do anything if required serverside.

if (dist_module) {
  // Order matters. We need to check Webkit the last one because
  // other vendors use to add Webkit prefixes to some properties
  var jsCssMap = {
    Moz: '-moz-',
    ms: '-ms-',
    O: '-o-',
    Webkit: '-webkit-'
  };

  var _document$createEleme = document.createElement('p'),
      style = _document$createEleme.style;

  var testProp = 'Transform';

  for (var key in jsCssMap) {
    if (key + testProp in style) {
      js = key;
      css = jsCssMap[key];
      break;
    }
  } // Correctly detect the Edge browser.


  if (js === 'Webkit' && 'msHyphens' in style) {
    js = 'ms';
    css = jsCssMap.ms;
    browser = 'edge';
  } // Correctly detect the Safari browser.


  if (js === 'Webkit' && '-apple-trailing-word' in style) {
    vendor = 'apple';
  }
}
/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String, vendor: String, browser: String}}
 * @api public
 */


var prefix = {
  js: js,
  css: css,
  vendor: vendor,
  browser: browser,
  isTouch: isTouch
};

/**
 * Test if a keyframe at-rule should be prefixed or not
 *
 * @param {String} vendor prefix string for the current browser.
 * @return {String}
 * @api public
 */

function supportedKeyframes(key) {
  // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
  if (key[1] === '-') return key; // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
  // https://caniuse.com/#search=keyframes

  if (prefix.js === 'ms') return key;
  return "@" + prefix.css + "keyframes" + key.substr(10);
}

// https://caniuse.com/#search=appearance

var appearence = {
  noPrefill: ['appearance'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'appearance') return false;
    if (prefix.js === 'ms') return "-webkit-" + prop;
    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=color-adjust

var colorAdjust = {
  noPrefill: ['color-adjust'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'color-adjust') return false;
    if (prefix.js === 'Webkit') return prefix.css + "print-" + prop;
    return prop;
  }
};

var regExp = /[-\s]+(.)?/g;
/**
 * Replaces the letter with the capital letter
 *
 * @param {String} match
 * @param {String} c
 * @return {String}
 * @api private
 */

function toUpper(match, c) {
  return c ? c.toUpperCase() : '';
}
/**
 * Convert dash separated strings to camel-cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */


function camelize(str) {
  return str.replace(regExp, toUpper);
}

/**
 * Convert dash separated strings to pascal cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */

function pascalize(str) {
  return camelize("-" + str);
}

// but we can use a longhand property instead.
// https://caniuse.com/#search=mask

var mask = {
  noPrefill: ['mask'],
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^mask/.test(prop)) return false;

    if (prefix.js === 'Webkit') {
      var longhand = 'mask-image';

      if (camelize(longhand) in style) {
        return prop;
      }

      if (prefix.js + pascalize(longhand) in style) {
        return prefix.css + prop;
      }
    }

    return prop;
  }
};

// https://caniuse.com/#search=text-orientation

var textOrientation = {
  noPrefill: ['text-orientation'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'text-orientation') return false;

    if (prefix.vendor === 'apple' && !prefix.isTouch) {
      return prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=transform

var transform = {
  noPrefill: ['transform'],
  supportedProperty: function supportedProperty(prop, style, options) {
    if (prop !== 'transform') return false;

    if (options.transform) {
      return prop;
    }

    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=transition

var transition = {
  noPrefill: ['transition'],
  supportedProperty: function supportedProperty(prop, style, options) {
    if (prop !== 'transition') return false;

    if (options.transition) {
      return prop;
    }

    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=writing-mode

var writingMode = {
  noPrefill: ['writing-mode'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'writing-mode') return false;

    if (prefix.js === 'Webkit' || prefix.js === 'ms' && prefix.browser !== 'edge') {
      return prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=user-select

var userSelect = {
  noPrefill: ['user-select'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'user-select') return false;

    if (prefix.js === 'Moz' || prefix.js === 'ms' || prefix.vendor === 'apple') {
      return prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=multicolumn
// https://github.com/postcss/autoprefixer/issues/491
// https://github.com/postcss/autoprefixer/issues/177

var breakPropsOld = {
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^break-/.test(prop)) return false;

    if (prefix.js === 'Webkit') {
      var jsProp = "WebkitColumn" + pascalize(prop);
      return jsProp in style ? prefix.css + "column-" + prop : false;
    }

    if (prefix.js === 'Moz') {
      var _jsProp = "page" + pascalize(prop);

      return _jsProp in style ? "page-" + prop : false;
    }

    return false;
  }
};

// See https://github.com/postcss/autoprefixer/issues/324.

var inlineLogicalOld = {
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^(border|margin|padding)-inline/.test(prop)) return false;
    if (prefix.js === 'Moz') return prop;
    var newProp = prop.replace('-inline', '');
    return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
  }
};

// Camelization is required because we can't test using.
// CSS syntax for e.g. in FF.

var unprefixed = {
  supportedProperty: function supportedProperty(prop, style) {
    return camelize(prop) in style ? prop : false;
  }
};

var prefixed = {
  supportedProperty: function supportedProperty(prop, style) {
    var pascalized = pascalize(prop); // Return custom CSS variable without prefixing.

    if (prop[0] === '-') return prop; // Return already prefixed value without prefixing.

    if (prop[0] === '-' && prop[1] === '-') return prop;
    if (prefix.js + pascalized in style) return prefix.css + prop; // Try webkit fallback.

    if (prefix.js !== 'Webkit' && "Webkit" + pascalized in style) return "-webkit-" + prop;
    return false;
  }
};

// https://caniuse.com/#search=scroll-snap

var scrollSnap = {
  supportedProperty: function supportedProperty(prop) {
    if (prop.substring(0, 11) !== 'scroll-snap') return false;

    if (prefix.js === 'ms') {
      return "" + prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=overscroll-behavior

var overscrollBehavior = {
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'overscroll-behavior') return false;

    if (prefix.js === 'ms') {
      return prefix.css + "scroll-chaining";
    }

    return prop;
  }
};

var propMap = {
  'flex-grow': 'flex-positive',
  'flex-shrink': 'flex-negative',
  'flex-basis': 'flex-preferred-size',
  'justify-content': 'flex-pack',
  order: 'flex-order',
  'align-items': 'flex-align',
  'align-content': 'flex-line-pack' // 'align-self' is handled by 'align-self' plugin.

}; // Support old flex spec from 2012.

var flex2012 = {
  supportedProperty: function supportedProperty(prop, style) {
    var newProp = propMap[prop];
    if (!newProp) return false;
    return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
  }
};

var propMap$1 = {
  flex: 'box-flex',
  'flex-grow': 'box-flex',
  'flex-direction': ['box-orient', 'box-direction'],
  order: 'box-ordinal-group',
  'align-items': 'box-align',
  'flex-flow': ['box-orient', 'box-direction'],
  'justify-content': 'box-pack'
};
var propKeys = Object.keys(propMap$1);

var prefixCss = function prefixCss(p) {
  return prefix.css + p;
}; // Support old flex spec from 2009.


var flex2009 = {
  supportedProperty: function supportedProperty(prop, style, _ref) {
    var multiple = _ref.multiple;

    if (propKeys.indexOf(prop) > -1) {
      var newProp = propMap$1[prop];

      if (!Array.isArray(newProp)) {
        return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
      }

      if (!multiple) return false;

      for (var i = 0; i < newProp.length; i++) {
        if (!(prefix.js + pascalize(newProp[0]) in style)) {
          return false;
        }
      }

      return newProp.map(prefixCss);
    }

    return false;
  }
};

// plugins = [
//   ...plugins,
//    breakPropsOld,
//    inlineLogicalOld,
//    unprefixed,
//    prefixed,
//    scrollSnap,
//    flex2012,
//    flex2009
// ]
// Plugins without 'noPrefill' value, going last.
// 'flex-*' plugins should be at the bottom.
// 'flex2009' going after 'flex2012'.
// 'prefixed' going after 'unprefixed'

var css_vendor_esm_plugins = [appearence, colorAdjust, mask, textOrientation, transform, transition, writingMode, userSelect, breakPropsOld, inlineLogicalOld, unprefixed, prefixed, scrollSnap, overscrollBehavior, flex2012, flex2009];
var propertyDetectors = css_vendor_esm_plugins.filter(function (p) {
  return p.supportedProperty;
}).map(function (p) {
  return p.supportedProperty;
});
var noPrefill = css_vendor_esm_plugins.filter(function (p) {
  return p.noPrefill;
}).reduce(function (a, p) {
  a.push.apply(a, (0,toConsumableArray/* default */.Z)(p.noPrefill));
  return a;
}, []);

var el;
var css_vendor_esm_cache = {};

if (dist_module) {
  el = document.createElement('p'); // We test every property on vendor prefix requirement.
  // Once tested, result is cached. It gives us up to 70% perf boost.
  // http://jsperf.com/element-style-object-access-vs-plain-object
  //
  // Prefill cache with known css properties to reduce amount of
  // properties we need to feature test at runtime.
  // http://davidwalsh.name/vendor-prefix

  var computed = window.getComputedStyle(document.documentElement, '');

  for (var key$1 in computed) {
    // eslint-disable-next-line no-restricted-globals
    if (!isNaN(key$1)) css_vendor_esm_cache[computed[key$1]] = computed[key$1];
  } // Properties that cannot be correctly detected using the
  // cache prefill method.


  noPrefill.forEach(function (x) {
    return delete css_vendor_esm_cache[x];
  });
}
/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @param {Object} [options]
 * @return {String|Boolean}
 * @api public
 */


function supportedProperty(prop, options) {
  if (options === void 0) {
    options = {};
  }

  // For server-side rendering.
  if (!el) return prop; // Remove cache for benchmark tests or return property from the cache.

  if ( true && css_vendor_esm_cache[prop] != null) {
    return css_vendor_esm_cache[prop];
  } // Check if 'transition' or 'transform' natively supported in browser.


  if (prop === 'transition' || prop === 'transform') {
    options[prop] = prop in el.style;
  } // Find a plugin for current prefix property.


  for (var i = 0; i < propertyDetectors.length; i++) {
    css_vendor_esm_cache[prop] = propertyDetectors[i](prop, el.style, options); // Break loop, if value found.

    if (css_vendor_esm_cache[prop]) break;
  } // Reset styles for current property.
  // Firefox can even throw an error for invalid properties, e.g., "0".


  try {
    el.style[prop] = '';
  } catch (err) {
    return false;
  }

  return css_vendor_esm_cache[prop];
}

var cache$1 = {};
var transitionProperties = {
  transition: 1,
  'transition-property': 1,
  '-webkit-transition': 1,
  '-webkit-transition-property': 1
};
var transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
var el$1;
/**
 * Returns prefixed value transition/transform if needed.
 *
 * @param {String} match
 * @param {String} p1
 * @param {String} p2
 * @return {String}
 * @api private
 */

function prefixTransitionCallback(match, p1, p2) {
  if (p1 === 'var') return 'var';
  if (p1 === 'all') return 'all';
  if (p2 === 'all') return ', all';
  var prefixedValue = p1 ? supportedProperty(p1) : ", " + supportedProperty(p2);
  if (!prefixedValue) return p1 || p2;
  return prefixedValue;
}

if (dist_module) el$1 = document.createElement('p');
/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */

function supportedValue(property, value) {
  // For server-side rendering.
  var prefixedValue = value;
  if (!el$1 || property === 'content') return value; // It is a string or a number as a string like '1'.
  // We want only prefixable values here.
  // eslint-disable-next-line no-restricted-globals

  if (typeof prefixedValue !== 'string' || !isNaN(parseInt(prefixedValue, 10))) {
    return prefixedValue;
  } // Create cache key for current value.


  var cacheKey = property + prefixedValue; // Remove cache for benchmark tests or return value from cache.

  if ( true && cache$1[cacheKey] != null) {
    return cache$1[cacheKey];
  } // IE can even throw an error in some cases, for e.g. style.content = 'bar'.


  try {
    // Test value as it is.
    el$1.style[property] = prefixedValue;
  } catch (err) {
    // Return false if value not supported.
    cache$1[cacheKey] = false;
    return false;
  } // If 'transition' or 'transition-property' property.


  if (transitionProperties[property]) {
    prefixedValue = prefixedValue.replace(transPropsRegExp, prefixTransitionCallback);
  } else if (el$1.style[property] === '') {
    // Value with a vendor prefix.
    prefixedValue = prefix.css + prefixedValue; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.

    if (prefixedValue === '-ms-flex') el$1.style[property] = '-ms-flexbox'; // Test prefixed value.

    el$1.style[property] = prefixedValue; // Return false if value not supported.

    if (el$1.style[property] === '') {
      cache$1[cacheKey] = false;
      return false;
    }
  } // Reset styles for current property.


  el$1.style[property] = ''; // Write current value to cache.

  cache$1[cacheKey] = prefixedValue;
  return cache$1[cacheKey];
}



;// CONCATENATED MODULE: ./node_modules/jss-plugin-vendor-prefixer/dist/jss-plugin-vendor-prefixer.esm.js



/**
 * Add vendor prefix to a property name when needed.
 */

function jssVendorPrefixer() {
  function onProcessRule(rule) {
    if (rule.type === 'keyframes') {
      var atRule = rule;
      atRule.at = supportedKeyframes(atRule.at);
    }
  }

  function prefixStyle(style) {
    for (var prop in style) {
      var value = style[prop];

      if (prop === 'fallbacks' && Array.isArray(value)) {
        style[prop] = value.map(prefixStyle);
        continue;
      }

      var changeProp = false;
      var supportedProp = supportedProperty(prop);
      if (supportedProp && supportedProp !== prop) changeProp = true;
      var changeValue = false;
      var supportedValue$1 = supportedValue(supportedProp, toCssValue(value));
      if (supportedValue$1 && supportedValue$1 !== value) changeValue = true;

      if (changeProp || changeValue) {
        if (changeProp) delete style[prop];
        style[supportedProp || prop] = supportedValue$1 || value;
      }
    }

    return style;
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;
    return prefixStyle(style);
  }

  function onChangeValue(value, prop) {
    return supportedValue(prop, toCssValue(value)) || value;
  }

  return {
    onProcessRule: onProcessRule,
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

/* harmony default export */ var jss_plugin_vendor_prefixer_esm = (jssVendorPrefixer);

;// CONCATENATED MODULE: ./node_modules/jss-plugin-props-sort/dist/jss-plugin-props-sort.esm.js
/**
 * Sort props by length.
 */
function jssPropsSort() {
  var sort = function sort(prop0, prop1) {
    if (prop0.length === prop1.length) {
      return prop0 > prop1 ? 1 : -1;
    }

    return prop0.length - prop1.length;
  };

  return {
    onProcessStyle: function onProcessStyle(style, rule) {
      if (rule.type !== 'style') return style;
      var newStyle = {};
      var props = Object.keys(style).sort(sort);

      for (var i = 0; i < props.length; i++) {
        newStyle[props[i]] = style[props[i]];
      }

      return newStyle;
    }
  };
}

/* harmony default export */ var jss_plugin_props_sort_esm = (jssPropsSort);

;// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/jssPreset/jssPreset.js






 // Subset of jss-preset-default with only the plugins the Material-UI components are using.

function jssPreset_jssPreset() {
  return {
    plugins: [jss_plugin_rule_value_function_esm(), jss_plugin_global_esm(), jss_plugin_nested_esm(), jss_plugin_camel_case_esm(), jss_plugin_default_unit_esm(), // Disable the vendor prefixer server-side, it does nothing.
    // This way, we can get a performance boost.
    // In the documentation, we are using `autoprefixer` to solve this problem.
    typeof window === 'undefined' ? null : jss_plugin_vendor_prefixer_esm(), jss_plugin_props_sort_esm()]
  };
}
;// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/StylesProvider/StylesProvider.js







 // Default JSS instance.

var jss = createJss(jssPreset_jssPreset()); // Use a singleton or the provided one by the context.
//
// The counter-based approach doesn't tolerate any mistake.
// It's much safer to use the same counter everywhere.

var generateClassName = createGenerateClassName(); // Exported for test purposes

var sheetsManager = new Map();
var defaultOptions = {
  disableGeneration: false,
  generateClassName: generateClassName,
  jss: jss,
  sheetsCache: null,
  sheetsManager: sheetsManager,
  sheetsRegistry: null
};
var StylesContext = react.createContext(defaultOptions);

if (false) {}

var injectFirstNode;
function StylesProvider(props) {
  var children = props.children,
      _props$injectFirst = props.injectFirst,
      injectFirst = _props$injectFirst === void 0 ? false : _props$injectFirst,
      _props$disableGenerat = props.disableGeneration,
      disableGeneration = _props$disableGenerat === void 0 ? false : _props$disableGenerat,
      localOptions = _objectWithoutProperties(props, ["children", "injectFirst", "disableGeneration"]);

  var outerOptions = React.useContext(StylesContext);

  var context = _extends({}, outerOptions, {
    disableGeneration: disableGeneration
  }, localOptions);

  if (false) {}

  if (false) {}

  if (false) {}

  if (!context.jss.options.insertionPoint && injectFirst && typeof window !== 'undefined') {
    if (!injectFirstNode) {
      var head = document.head;
      injectFirstNode = document.createComment('mui-inject-first');
      head.insertBefore(injectFirstNode, head.firstChild);
    }

    context.jss = create({
      plugins: jssPreset().plugins,
      insertionPoint: injectFirstNode
    });
  }

  return /*#__PURE__*/React.createElement(StylesContext.Provider, {
    value: context
  }, children);
}
 false ? 0 : void 0;

if (false) {}
;// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/makeStyles/indexCounter.js
/* eslint-disable import/prefer-default-export */
// Global index counter to preserve source order.
// We create the style sheet during the creation of the component,
// children are handled after the parents, so the order of style elements would be parent->child.
// It is a problem though when a parent passes a className
// which needs to override any child's styles.
// StyleSheet of the child has a higher specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.
var indexCounter = -1e9;
function increment() {
  indexCounter += 1;

  if (false) {}

  return indexCounter;
}
// EXTERNAL MODULE: ./node_modules/@material-ui/utils/esm/deepmerge.js
var deepmerge = __webpack_require__(35953);
;// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/getStylesCreator/getStylesCreator.js




function getStylesCreator(stylesOrCreator) {
  var themingEnabled = typeof stylesOrCreator === 'function';

  if (false) {}

  return {
    create: function create(theme, name) {
      var styles;

      try {
        styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
      } catch (err) {
        if (false) {}

        throw err;
      }

      if (!name || !theme.overrides || !theme.overrides[name]) {
        return styles;
      }

      var overrides = theme.overrides[name];

      var stylesWithOverrides = (0,esm_extends/* default */.Z)({}, styles);

      Object.keys(overrides).forEach(function (key) {
        if (false) {}

        stylesWithOverrides[key] = (0,deepmerge/* default */.Z)(stylesWithOverrides[key], overrides[key]);
      });
      return stylesWithOverrides;
    },
    options: {}
  };
}
;// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/getStylesCreator/noopTheme.js
// We use the same empty object to ref count the styles that don't need a theme object.
var noopTheme = {};
/* harmony default export */ var getStylesCreator_noopTheme = (noopTheme);
;// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/makeStyles/makeStyles.js












function getClasses(_ref, classes, Component) {
  var state = _ref.state,
      stylesOptions = _ref.stylesOptions;

  if (stylesOptions.disableGeneration) {
    return classes || {};
  }

  if (!state.cacheClasses) {
    state.cacheClasses = {
      // Cache for the finalized classes value.
      value: null,
      // Cache for the last used classes prop pointer.
      lastProp: null,
      // Cache for the last used rendered classes pointer.
      lastJSS: {}
    };
  } // Tracks if either the rendered classes or classes prop has changed,
  // requiring the generation of a new finalized classes object.


  var generate = false;

  if (state.classes !== state.cacheClasses.lastJSS) {
    state.cacheClasses.lastJSS = state.classes;
    generate = true;
  }

  if (classes !== state.cacheClasses.lastProp) {
    state.cacheClasses.lastProp = classes;
    generate = true;
  }

  if (generate) {
    state.cacheClasses.value = (0,mergeClasses/* default */.Z)({
      baseClasses: state.cacheClasses.lastJSS,
      newClasses: classes,
      Component: Component
    });
  }

  return state.cacheClasses.value;
}

function attach(_ref2, props) {
  var state = _ref2.state,
      theme = _ref2.theme,
      stylesOptions = _ref2.stylesOptions,
      stylesCreator = _ref2.stylesCreator,
      name = _ref2.name;

  if (stylesOptions.disableGeneration) {
    return;
  }

  var sheetManager = makeStyles_multiKeyStore.get(stylesOptions.sheetsManager, stylesCreator, theme);

  if (!sheetManager) {
    sheetManager = {
      refs: 0,
      staticSheet: null,
      dynamicStyles: null
    };
    makeStyles_multiKeyStore.set(stylesOptions.sheetsManager, stylesCreator, theme, sheetManager);
  }

  var options = (0,esm_extends/* default */.Z)({}, stylesCreator.options, stylesOptions, {
    theme: theme,
    flip: typeof stylesOptions.flip === 'boolean' ? stylesOptions.flip : theme.direction === 'rtl'
  });

  options.generateId = options.serverGenerateClassName || options.generateClassName;
  var sheetsRegistry = stylesOptions.sheetsRegistry;

  if (sheetManager.refs === 0) {
    var staticSheet;

    if (stylesOptions.sheetsCache) {
      staticSheet = makeStyles_multiKeyStore.get(stylesOptions.sheetsCache, stylesCreator, theme);
    }

    var styles = stylesCreator.create(theme, name);

    if (!staticSheet) {
      staticSheet = stylesOptions.jss.createStyleSheet(styles, (0,esm_extends/* default */.Z)({
        link: false
      }, options));
      staticSheet.attach();

      if (stylesOptions.sheetsCache) {
        makeStyles_multiKeyStore.set(stylesOptions.sheetsCache, stylesCreator, theme, staticSheet);
      }
    }

    if (sheetsRegistry) {
      sheetsRegistry.add(staticSheet);
    }

    sheetManager.staticSheet = staticSheet;
    sheetManager.dynamicStyles = getDynamicStyles(styles);
  }

  if (sheetManager.dynamicStyles) {
    var dynamicSheet = stylesOptions.jss.createStyleSheet(sheetManager.dynamicStyles, (0,esm_extends/* default */.Z)({
      link: true
    }, options));
    dynamicSheet.update(props);
    dynamicSheet.attach();
    state.dynamicSheet = dynamicSheet;
    state.classes = (0,mergeClasses/* default */.Z)({
      baseClasses: sheetManager.staticSheet.classes,
      newClasses: dynamicSheet.classes
    });

    if (sheetsRegistry) {
      sheetsRegistry.add(dynamicSheet);
    }
  } else {
    state.classes = sheetManager.staticSheet.classes;
  }

  sheetManager.refs += 1;
}

function update(_ref3, props) {
  var state = _ref3.state;

  if (state.dynamicSheet) {
    state.dynamicSheet.update(props);
  }
}

function detach(_ref4) {
  var state = _ref4.state,
      theme = _ref4.theme,
      stylesOptions = _ref4.stylesOptions,
      stylesCreator = _ref4.stylesCreator;

  if (stylesOptions.disableGeneration) {
    return;
  }

  var sheetManager = makeStyles_multiKeyStore.get(stylesOptions.sheetsManager, stylesCreator, theme);
  sheetManager.refs -= 1;
  var sheetsRegistry = stylesOptions.sheetsRegistry;

  if (sheetManager.refs === 0) {
    makeStyles_multiKeyStore["delete"](stylesOptions.sheetsManager, stylesCreator, theme);
    stylesOptions.jss.removeStyleSheet(sheetManager.staticSheet);

    if (sheetsRegistry) {
      sheetsRegistry.remove(sheetManager.staticSheet);
    }
  }

  if (state.dynamicSheet) {
    stylesOptions.jss.removeStyleSheet(state.dynamicSheet);

    if (sheetsRegistry) {
      sheetsRegistry.remove(state.dynamicSheet);
    }
  }
}

function useSynchronousEffect(func, values) {
  var key = react.useRef([]);
  var output; // Store "generation" key. Just returns a new object every time

  var currentKey = react.useMemo(function () {
    return {};
  }, values); // eslint-disable-line react-hooks/exhaustive-deps
  // "the first render", or "memo dropped the value"

  if (key.current !== currentKey) {
    key.current = currentKey;
    output = func();
  }

  react.useEffect(function () {
    return function () {
      if (output) {
        output();
      }
    };
  }, [currentKey] // eslint-disable-line react-hooks/exhaustive-deps
  );
}

function makeStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var name = options.name,
      classNamePrefixOption = options.classNamePrefix,
      Component = options.Component,
      _options$defaultTheme = options.defaultTheme,
      defaultTheme = _options$defaultTheme === void 0 ? getStylesCreator_noopTheme : _options$defaultTheme,
      stylesOptions2 = (0,objectWithoutProperties/* default */.Z)(options, ["name", "classNamePrefix", "Component", "defaultTheme"]);

  var stylesCreator = getStylesCreator(stylesOrCreator);
  var classNamePrefix = name || classNamePrefixOption || 'makeStyles';
  stylesCreator.options = {
    index: increment(),
    name: name,
    meta: classNamePrefix,
    classNamePrefix: classNamePrefix
  };

  var useStyles = function useStyles() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var theme = (0,useTheme/* default */.Z)() || defaultTheme;

    var stylesOptions = (0,esm_extends/* default */.Z)({}, react.useContext(StylesContext), stylesOptions2);

    var instance = react.useRef();
    var shouldUpdate = react.useRef();
    useSynchronousEffect(function () {
      var current = {
        name: name,
        state: {},
        stylesCreator: stylesCreator,
        stylesOptions: stylesOptions,
        theme: theme
      };
      attach(current, props);
      shouldUpdate.current = false;
      instance.current = current;
      return function () {
        detach(current);
      };
    }, [theme, stylesCreator]);
    react.useEffect(function () {
      if (shouldUpdate.current) {
        update(instance.current, props);
      }

      shouldUpdate.current = true;
    });
    var classes = getClasses(instance.current, props.classes, Component);

    if (false) {}

    return classes;
  };

  return useStyles;
}

/***/ }),

/***/ 65835:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ mergeClasses; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87462);


function mergeClasses() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var baseClasses = options.baseClasses,
      newClasses = options.newClasses,
      Component = options.Component;

  if (!newClasses) {
    return baseClasses;
  }

  var nextClasses = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, baseClasses);

  if (false) {}

  Object.keys(newClasses).forEach(function (key) {
    if (false) {}

    if (newClasses[key]) {
      nextClasses[key] = "".concat(baseClasses[key], " ").concat(newClasses[key]);
    }
  });
  return nextClasses;
}

/***/ }),

/***/ 83800:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var ThemeContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);

if (false) {}

/* harmony default export */ __webpack_exports__["Z"] = (ThemeContext);

/***/ }),

/***/ 159:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useTheme; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _ThemeContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83800);


function useTheme() {
  var theme = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_ThemeContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);

  if (false) {}

  return theme;
}

/***/ }),

/***/ 71410:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ handleBreakpoints; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71002);




 // The breakpoint **start** at this value.
// For instance with the first breakpoint xs: [xs, sm[.

var values = {
  xs: 0,
  sm: 600,
  md: 960,
  lg: 1280,
  xl: 1920
};
var defaultBreakpoints = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ['xs', 'sm', 'md', 'lg', 'xl'],
  up: function up(key) {
    return "@media (min-width:".concat(values[key], "px)");
  }
};
function handleBreakpoints(props, propValue, styleFromPropValue) {
  if (false) {}

  if (Array.isArray(propValue)) {
    var themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;
    return propValue.reduce(function (acc, item, index) {
      acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
      return acc;
    }, {});
  }

  if ((0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(propValue) === 'object') {
    var _themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;

    return Object.keys(propValue).reduce(function (acc, breakpoint) {
      acc[_themeBreakpoints.up(breakpoint)] = styleFromPropValue(propValue[breakpoint]);
      return acc;
    }, {});
  }

  var output = styleFromPropValue(propValue);
  return output;
}

function breakpoints(styleFunction) {
  var newStyleFunction = function newStyleFunction(props) {
    var base = styleFunction(props);
    var themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;
    var extended = themeBreakpoints.keys.reduce(function (acc, key) {
      if (props[key]) {
        acc = acc || {};
        acc[themeBreakpoints.up(key)] = styleFunction(_extends({
          theme: props.theme
        }, props[key]));
      }

      return acc;
    }, null);
    return merge(base, extended);
  };

  newStyleFunction.propTypes =  false ? 0 : {};
  newStyleFunction.filterProps = ['xs', 'sm', 'md', 'lg', 'xl'].concat(_toConsumableArray(styleFunction.filterProps));
  return newStyleFunction;
}

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (breakpoints)));

/***/ }),

/***/ 19668:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _material_ui_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35953);


function merge(acc, item) {
  if (!item) {
    return acc;
  }

  return (0,_material_ui_utils__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(acc, item, {
    clone: false // No need to clone deep, it's way faster.

  });
}

/* harmony default export */ __webpack_exports__["Z"] = (merge);

/***/ }),

/***/ 27122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ createUnarySpacing; },
  "Z": function() { return /* binding */ esm_spacing; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(86854);
// EXTERNAL MODULE: ./node_modules/@material-ui/system/esm/breakpoints.js
var breakpoints = __webpack_require__(71410);
// EXTERNAL MODULE: ./node_modules/@material-ui/system/esm/merge.js
var merge = __webpack_require__(19668);
;// CONCATENATED MODULE: ./node_modules/@material-ui/system/esm/memoize.js
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) {
      cache[arg] = fn(arg);
    }

    return cache[arg];
  };
}
;// CONCATENATED MODULE: ./node_modules/@material-ui/system/esm/spacing.js





var properties = {
  m: 'margin',
  p: 'padding'
};
var directions = {
  t: 'Top',
  r: 'Right',
  b: 'Bottom',
  l: 'Left',
  x: ['Left', 'Right'],
  y: ['Top', 'Bottom']
};
var aliases = {
  marginX: 'mx',
  marginY: 'my',
  paddingX: 'px',
  paddingY: 'py'
}; // memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec

var getCssProperties = memoize(function (prop) {
  // It's not a shorthand notation.
  if (prop.length > 2) {
    if (aliases[prop]) {
      prop = aliases[prop];
    } else {
      return [prop];
    }
  }

  var _prop$split = prop.split(''),
      _prop$split2 = (0,slicedToArray/* default */.Z)(_prop$split, 2),
      a = _prop$split2[0],
      b = _prop$split2[1];

  var property = properties[a];
  var direction = directions[b] || '';
  return Array.isArray(direction) ? direction.map(function (dir) {
    return property + dir;
  }) : [property + direction];
});
var spacingKeys = ['m', 'mt', 'mr', 'mb', 'ml', 'mx', 'my', 'p', 'pt', 'pr', 'pb', 'pl', 'px', 'py', 'margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'padding', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft', 'paddingX', 'paddingY'];
function createUnarySpacing(theme) {
  var themeSpacing = theme.spacing || 8;

  if (typeof themeSpacing === 'number') {
    return function (abs) {
      if (false) {}

      return themeSpacing * abs;
    };
  }

  if (Array.isArray(themeSpacing)) {
    return function (abs) {
      if (false) {}

      return themeSpacing[abs];
    };
  }

  if (typeof themeSpacing === 'function') {
    return themeSpacing;
  }

  if (false) {}

  return function () {
    return undefined;
  };
}

function getValue(transformer, propValue) {
  if (typeof propValue === 'string' || propValue == null) {
    return propValue;
  }

  var abs = Math.abs(propValue);
  var transformed = transformer(abs);

  if (propValue >= 0) {
    return transformed;
  }

  if (typeof transformed === 'number') {
    return -transformed;
  }

  return "-".concat(transformed);
}

function getStyleFromPropValue(cssProperties, transformer) {
  return function (propValue) {
    return cssProperties.reduce(function (acc, cssProperty) {
      acc[cssProperty] = getValue(transformer, propValue);
      return acc;
    }, {});
  };
}

function spacing(props) {
  var theme = props.theme;
  var transformer = createUnarySpacing(theme);
  return Object.keys(props).map(function (prop) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (spacingKeys.indexOf(prop) === -1) {
      return null;
    }

    var cssProperties = getCssProperties(prop);
    var styleFromPropValue = getStyleFromPropValue(cssProperties, transformer);
    var propValue = props[prop];
    return (0,breakpoints/* handleBreakpoints */.k)(props, propValue, styleFromPropValue);
  }).reduce(merge/* default */.Z, {});
}

spacing.propTypes =  false ? 0 : {};
spacing.filterProps = spacingKeys;
/* harmony default export */ var esm_spacing = (spacing);

/***/ }),

/***/ 35953:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ deepmerge; }
/* harmony export */ });
/* unused harmony export isPlainObject */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71002);


function isPlainObject(item) {
  return item && (0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(item) === 'object' && item.constructor === Object;
}
function deepmerge(target, source) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    clone: true
  };
  var output = options.clone ? (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, target) : target;

  if (isPlainObject(target) && isPlainObject(source)) {
    Object.keys(source).forEach(function (key) {
      // Avoid prototype pollution
      if (key === '__proto__') {
        return;
      }

      if (isPlainObject(source[key]) && key in target) {
        output[key] = deepmerge(target[key], source[key], options);
      } else {
        output[key] = source[key];
      }
    });
  }

  return output;
}

/***/ }),

/***/ 60288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ formatMuiErrorMessage; }
/* harmony export */ });
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@material-ui/utils/macros/MuiError.macro` instead.
 * @param {number} code
 */
function formatMuiErrorMessage(code) {
  // Apply babel-plugin-transform-template-literals in loose mode
  // loose mode is safe iff we're concatenating primitives
  // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose

  /* eslint-disable prefer-template */
  var url = 'https://material-ui.com/production-error/?code=' + code;

  for (var i = 1; i < arguments.length; i += 1) {
    // rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
  }

  return 'Minified Material-UI error #' + code + '; visit ' + url + ' for the full message.';
  /* eslint-enable prefer-template */
}

/***/ }),

/***/ 19985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S1": function() { return /* binding */ init; },
  "jp": function() { return /* binding */ showReportDialog; }
});

// UNUSED EXPORTS: close, defaultIntegrations, flush, forceLoad, lastEventId, onLoad, wrap

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/logger.js
var esm_logger = __webpack_require__(12343);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/misc.js
var misc = __webpack_require__(62844);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/string.js
var string = __webpack_require__(57321);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/integrations/inboundfilters.js


// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
var DEFAULT_IGNORE_ERRORS = [/^Script error\.?$/, /^Javascript error: Script error\.? on line 0$/];

/** Options for the InboundFilters integration */

/** Inbound filters configurable by the user */
class InboundFilters  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'InboundFilters';}

  /**
   * @inheritDoc
   */
   __init() {this.name = InboundFilters.id;}

   constructor(  _options = {}) {;this._options = _options;InboundFilters.prototype.__init.call(this);}

  /**
   * @inheritDoc
   */
   setupOnce(addGlobalEventProcessor, getCurrentHub) {
    var eventProcess = (event) => {
      var hub = getCurrentHub();
      if (hub) {
        var self = hub.getIntegration(InboundFilters);
        if (self) {
          var client = hub.getClient();
          var clientOptions = client ? client.getOptions() : {};
          var options = _mergeOptions(self._options, clientOptions);
          return _shouldDropEvent(event, options) ? null : event;
        }
      }
      return event;
    };

    eventProcess.id = this.name;
    addGlobalEventProcessor(eventProcess);
  }
} InboundFilters.__initStatic();

/** JSDoc */
function _mergeOptions(
  internalOptions = {},
  clientOptions = {},
) {
  return {
    allowUrls: [...(internalOptions.allowUrls || []), ...(clientOptions.allowUrls || [])],
    denyUrls: [...(internalOptions.denyUrls || []), ...(clientOptions.denyUrls || [])],
    ignoreErrors: [
      ...(internalOptions.ignoreErrors || []),
      ...(clientOptions.ignoreErrors || []),
      ...DEFAULT_IGNORE_ERRORS,
    ],
    ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true,
  };
}

/** JSDoc */
function _shouldDropEvent(event, options) {
  if (options.ignoreInternal && _isSentryError(event)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.warn */.kg.warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0,misc/* getEventDescription */.jH)(event)}`);
    return true;
  }
  if (_isIgnoredError(event, options.ignoreErrors)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.warn */.kg.warn(
        `Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0,misc/* getEventDescription */.jH)(event)}`,
      );
    return true;
  }
  if (_isDeniedUrl(event, options.denyUrls)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.warn */.kg.warn(
        `Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0,misc/* getEventDescription */.jH)(
          event,
        )}.\nUrl: ${_getEventFilterUrl(event)}`,
      );
    return true;
  }
  if (!_isAllowedUrl(event, options.allowUrls)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.warn */.kg.warn(
        `Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0,misc/* getEventDescription */.jH)(
          event,
        )}.\nUrl: ${_getEventFilterUrl(event)}`,
      );
    return true;
  }
  return false;
}

function _isIgnoredError(event, ignoreErrors) {
  if (!ignoreErrors || !ignoreErrors.length) {
    return false;
  }

  return _getPossibleEventMessages(event).some(message =>
    ignoreErrors.some(pattern => (0,string/* isMatchingPattern */.zC)(message, pattern)),
  );
}

function _isDeniedUrl(event, denyUrls) {
  // TODO: Use Glob instead?
  if (!denyUrls || !denyUrls.length) {
    return false;
  }
  var url = _getEventFilterUrl(event);
  return !url ? false : denyUrls.some(pattern => (0,string/* isMatchingPattern */.zC)(url, pattern));
}

function _isAllowedUrl(event, allowUrls) {
  // TODO: Use Glob instead?
  if (!allowUrls || !allowUrls.length) {
    return true;
  }
  var url = _getEventFilterUrl(event);
  return !url ? true : allowUrls.some(pattern => (0,string/* isMatchingPattern */.zC)(url, pattern));
}

function _getPossibleEventMessages(event) {
  if (event.message) {
    return [event.message];
  }
  if (event.exception) {
    try {
      const { type = '', value = '' } = (event.exception.values && event.exception.values[0]) || {};
      return [`${value}`, `${type}: ${value}`];
    } catch (oO) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error(`Cannot extract message for event ${(0,misc/* getEventDescription */.jH)(event)}`);
      return [];
    }
  }
  return [];
}

function _isSentryError(event) {
  try {
    // @ts-ignore can't be a sentry error if undefined
        return event.exception.values[0].type === 'SentryError';
  } catch (e) {
    // ignore
  }
  return false;
}

function _getLastValidUrl(frames = []) {
  for (let i = frames.length - 1; i >= 0; i--) {
    var frame = frames[i];

    if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') {
      return frame.filename || null;
    }
  }

  return null;
}

function _getEventFilterUrl(event) {
  try {
    let frames;
    try {
      // @ts-ignore we only care about frames if the whole thing here is defined
      frames = event.exception.values[0].stacktrace.frames;
    } catch (e) {
      // ignore
    }
    return frames ? _getLastValidUrl(frames) : null;
  } catch (oO) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error(`Cannot extract url for event ${(0,misc/* getEventDescription */.jH)(event)}`);
    return null;
  }
}


//# sourceMappingURL=inboundfilters.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/object.js
var object = __webpack_require__(20535);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/integrations/functiontostring.js


let originalFunctionToString;

/** Patch toString calls to return proper name for wrapped functions */
class FunctionToString  {constructor() { FunctionToString.prototype.__init.call(this); }
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'FunctionToString';}

  /**
   * @inheritDoc
   */
   __init() {this.name = FunctionToString.id;}

  /**
   * @inheritDoc
   */
   setupOnce() {
        originalFunctionToString = Function.prototype.toString;

        Function.prototype.toString = function ( ...args) {
      var context = (0,object/* getOriginalFunction */.HK)(this) || this;
      return originalFunctionToString.apply(context, args);
    };
  }
} FunctionToString.__initStatic();


//# sourceMappingURL=functiontostring.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/hub/esm/scope.js
var esm_scope = __webpack_require__(46769);
// EXTERNAL MODULE: ./node_modules/@sentry/hub/esm/hub.js
var esm_hub = __webpack_require__(38641);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/integration.js



var installedIntegrations = [];

/** Map of integrations assigned to a client */

/**
 * @private
 */
function filterDuplicates(integrations) {
  return integrations.reduce((acc, integrations) => {
    if (acc.every(accIntegration => integrations.name !== accIntegration.name)) {
      acc.push(integrations);
    }
    return acc;
  }, [] );
}

/** Gets integration to install */
function getIntegrationsToSetup(options) {
  var defaultIntegrations = (options.defaultIntegrations && [...options.defaultIntegrations]) || [];
  var userIntegrations = options.integrations;

  let integrations = [...filterDuplicates(defaultIntegrations)];

  if (Array.isArray(userIntegrations)) {
    // Filter out integrations that are also included in user options
    integrations = [
      ...integrations.filter(integrations =>
        userIntegrations.every(userIntegration => userIntegration.name !== integrations.name),
      ),
      // And filter out duplicated user options integrations
      ...filterDuplicates(userIntegrations),
    ];
  } else if (typeof userIntegrations === 'function') {
    integrations = userIntegrations(integrations);
    integrations = Array.isArray(integrations) ? integrations : [integrations];
  }

  // Make sure that if present, `Debug` integration will always run last
  var integrationsNames = integrations.map(i => i.name);
  var alwaysLastToRun = 'Debug';
  if (integrationsNames.indexOf(alwaysLastToRun) !== -1) {
    integrations.push(...integrations.splice(integrationsNames.indexOf(alwaysLastToRun), 1));
  }

  return integrations;
}

/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */
function setupIntegrations(integrations) {
  var integrationIndex = {};

  integrations.forEach(integration => {
    integrationIndex[integration.name] = integration;

    if (installedIntegrations.indexOf(integration.name) === -1) {
      integration.setupOnce(esm_scope/* addGlobalEventProcessor */.c, esm_hub/* getCurrentHub */.Gd);
      installedIntegrations.push(integration.name);
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(`Integration installed: ${integration.name}`);
    }
  });

  return integrationIndex;
}


//# sourceMappingURL=integration.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/sdk.js



/** A class object that can instantiate Client objects. */

/**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */
function initAndBind(
  clientClass,
  options,
) {
  if (options.debug === true) {
    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
      esm_logger/* logger.enable */.kg.enable();
    } else {
      // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
            console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
    }
  }
  var hub = (0,esm_hub/* getCurrentHub */.Gd)();
  var scope = hub.getScope();
  if (scope) {
    scope.update(options.initialScope);
  }

  var client = new clientClass(options);
  hub.bindClient(client);
}


//# sourceMappingURL=sdk.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/error.js
/** An error emitted by Sentry SDKs and related utilities. */
class SentryError extends Error {
  /** Display name of this error instance. */
  

   constructor( message) {
    super(message);this.message = message;;

    this.name = new.target.prototype.constructor.name;
    Object.setPrototypeOf(this, new.target.prototype);
  }
}


//# sourceMappingURL=error.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/dsn.js


/** Regular expression used to parse a Dsn. */
var DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/;

function isValidProtocol(protocol) {
  return protocol === 'http' || protocol === 'https';
}

/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */
function dsnToString(dsn, withPassword = false) {
  const { host, path, pass, port, projectId, protocol, publicKey } = dsn;
  return (
    `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` +
    `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`
  );
}

/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents
 */
function dsnFromString(str) {
  var match = DSN_REGEX.exec(str);

  if (!match) {
    throw new SentryError(`Invalid Sentry Dsn: ${str}`);
  }

  const [protocol, publicKey, pass = '', host, port = '', lastPath] = match.slice(1);
  let path = '';
  let projectId = lastPath;

  var split = projectId.split('/');
  if (split.length > 1) {
    path = split.slice(0, -1).join('/');
    projectId = split.pop() ;
  }

  if (projectId) {
    var projectMatch = projectId.match(/^\d+/);
    if (projectMatch) {
      projectId = projectMatch[0];
    }
  }

  return dsnFromComponents({ host, pass, path, projectId, port, protocol: protocol , publicKey });
}

function dsnFromComponents(components) {
  return {
    protocol: components.protocol,
    publicKey: components.publicKey || '',
    pass: components.pass || '',
    host: components.host,
    port: components.port || '',
    path: components.path || '',
    projectId: components.projectId,
  };
}

function validateDsn(dsn) {
  if (!(typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
    return;
  }

  const { port, projectId, protocol } = dsn;

  var requiredComponents = ['protocol', 'publicKey', 'host', 'projectId'];
  requiredComponents.forEach(component => {
    if (!dsn[component]) {
      throw new SentryError(`Invalid Sentry Dsn: ${component} missing`);
    }
  });

  if (!projectId.match(/^\d+$/)) {
    throw new SentryError(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
  }

  if (!isValidProtocol(protocol)) {
    throw new SentryError(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
  }

  if (port && isNaN(parseInt(port, 10))) {
    throw new SentryError(`Invalid Sentry Dsn: Invalid port ${port}`);
  }

  return true;
}

/** The Sentry Dsn, identifying a Sentry instance and project. */
function makeDsn(from) {
  var components = typeof from === 'string' ? dsnFromString(from) : dsnFromComponents(from);
  validateDsn(components);
  return components;
}


//# sourceMappingURL=dsn.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/api.js


var SENTRY_API_VERSION = '7';

/** Returns the prefix to construct Sentry ingestion API endpoints. */
function getBaseApiEndpoint(dsn) {
  var protocol = dsn.protocol ? `${dsn.protocol}:` : '';
  var port = dsn.port ? `:${dsn.port}` : '';
  return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}

/** Returns the ingest API endpoint for target. */
function _getIngestEndpoint(dsn) {
  return `${getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}

/** Returns a URL-encoded string with auth config suitable for a query string. */
function _encodedAuth(dsn, sdkInfo) {
  return (0,object/* urlEncode */._j)({
    // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    sentry_key: dsn.publicKey,
    sentry_version: SENTRY_API_VERSION,
    ...(sdkInfo && { sentry_client: `${sdkInfo.name}/${sdkInfo.version}` }),
  });
}

/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */
function getEnvelopeEndpointWithUrlEncodedAuth(
  dsn,
  // TODO (v8): Remove `tunnelOrOptions` in favor of `options`, and use the substitute code below
  // options: ClientOptions = {} as ClientOptions,
  tunnelOrOptions = {} ,
) {
  // TODO (v8): Use this code instead
  // const { tunnel, _metadata = {} } = options;
  // return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;

  var tunnel = typeof tunnelOrOptions === 'string' ? tunnelOrOptions : tunnelOrOptions.tunnel;
  var sdkInfo =
    typeof tunnelOrOptions === 'string' || !tunnelOrOptions._metadata ? undefined : tunnelOrOptions._metadata.sdk;

  return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, sdkInfo)}`;
}

/** Returns the url to the report dialog endpoint. */
function getReportDialogEndpoint(
  dsnLike,
  dialogOptions

,
) {
  var dsn = makeDsn(dsnLike);
  var endpoint = `${getBaseApiEndpoint(dsn)}embed/error-page/`;

  let encodedOptions = `dsn=${dsnToString(dsn)}`;
  for (var key in dialogOptions) {
    if (key === 'dsn') {
      continue;
    }

    if (key === 'user') {
      var user = dialogOptions.user;
      if (!user) {
        continue;
      }
      if (user.name) {
        encodedOptions += `&name=${encodeURIComponent(user.name)}`;
      }
      if (user.email) {
        encodedOptions += `&email=${encodeURIComponent(user.email)}`;
      }
    } else {
      encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key] )}`;
    }
  }

  return `${endpoint}?${encodedOptions}`;
}


//# sourceMappingURL=api.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/global.js
var esm_global = __webpack_require__(82991);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/stacktrace.js
var stacktrace = __webpack_require__(30360);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/supports.js
var supports = __webpack_require__(8823);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/instrument.js
var instrument = __webpack_require__(9732);
// EXTERNAL MODULE: ./node_modules/@sentry/hub/esm/session.js
var esm_session = __webpack_require__(95771);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(67597);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/syncpromise.js
var syncpromise = __webpack_require__(96893);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/envelope.js


/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */
function createEnvelope(headers, items = []) {
  return [headers, items] ;
}

/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */
function addItemToEnvelope(envelope, newItem) {
  const [headers, items] = envelope;
  return [headers, [...items, newItem]] ;
}

/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 */
function forEachEnvelopeItem(
  envelope,
  callback,
) {
  var envelopeItems = envelope[1];
  envelopeItems.forEach((envelopeItem) => {
    var envelopeItemType = envelopeItem[0].type;
    callback(envelopeItem, envelopeItemType);
  });
}

function encodeUTF8(input, textEncoder) {
  var utf8 = textEncoder || new TextEncoder();
  return utf8.encode(input);
}

/**
 * Serializes an envelope.
 */
function serializeEnvelope(envelope, textEncoder) {
  const [envHeaders, items] = envelope;

  // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
  let parts = JSON.stringify(envHeaders);

  function append(next) {
    if (typeof parts === 'string') {
      parts = typeof next === 'string' ? parts + next : [encodeUTF8(parts, textEncoder), next];
    } else {
      parts.push(typeof next === 'string' ? encodeUTF8(next, textEncoder) : next);
    }
  }

  for (var item of items) {
    const [itemHeaders, payload] = item ;
    append(`\n${JSON.stringify(itemHeaders)}\n`);
    append(typeof payload === 'string' || payload instanceof Uint8Array ? payload : JSON.stringify(payload));
  }

  return typeof parts === 'string' ? parts : concatBuffers(parts);
}

function concatBuffers(buffers) {
  var totalLength = buffers.reduce((acc, buf) => acc + buf.length, 0);

  var merged = new Uint8Array(totalLength);
  let offset = 0;
  for (var buffer of buffers) {
    merged.set(buffer, offset);
    offset += buffer.length;
  }

  return merged;
}

/**
 * Creates attachment envelope items
 */
function createAttachmentEnvelopeItem(
  attachment,
  textEncoder,
) {
  var buffer = typeof attachment.data === 'string' ? encodeUTF8(attachment.data, textEncoder) : attachment.data;

  return [
    (0,object/* dropUndefinedKeys */.Jr)({
      type: 'attachment',
      length: buffer.length,
      filename: attachment.filename,
      content_type: attachment.contentType,
      attachment_type: attachment.attachmentType,
    }),
    buffer,
  ];
}

var ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
  session: 'session',
  sessions: 'session',
  attachment: 'attachment',
  transaction: 'transaction',
  event: 'error',
  client_report: 'internal',
  user_report: 'default',
};

/**
 * Maps the type of an envelope item to a data category.
 */
function envelopeItemTypeToDataCategory(type) {
  return ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}


//# sourceMappingURL=envelope.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/time.js
var time = __webpack_require__(21170);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/memo.js
/**
 * Helper to decycle json objects
 */
function memoBuilder() {
  var hasWeakSet = typeof WeakSet === 'function';
  var inner = hasWeakSet ? new WeakSet() : [];
  function memoize(obj) {
    if (hasWeakSet) {
      if (inner.has(obj)) {
        return true;
      }
      inner.add(obj);
      return false;
    }
        for (let i = 0; i < inner.length; i++) {
      var value = inner[i];
      if (value === obj) {
        return true;
      }
    }
    inner.push(obj);
    return false;
  }

  function unmemoize(obj) {
    if (hasWeakSet) {
      inner.delete(obj);
    } else {
      for (let i = 0; i < inner.length; i++) {
        if (inner[i] === obj) {
          inner.splice(i, 1);
          break;
        }
      }
    }
  }
  return [memoize, unmemoize];
}


//# sourceMappingURL=memo.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/normalize.js





/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output..
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */
function normalize(input, depth = +Infinity, maxProperties = +Infinity) {
  try {
    // since we're at the outermost level, we don't provide a key
    return visit('', input, depth, maxProperties);
  } catch (err) {
    return { ERROR: `**non-serializable** (${err})` };
  }
}

/** JSDoc */
function normalizeToSize(
    object,
  // Default Node.js REPL depth
  depth = 3,
  // 100kB, as 200kB is max payload size, so half sounds reasonable
  maxSize = 100 * 1024,
) {
  var normalized = normalize(object, depth);

  if (jsonSize(normalized) > maxSize) {
    return normalizeToSize(object, depth - 1, maxSize);
  }

  return normalized ;
}

/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */
function visit(
  key,
  value,
  depth = +Infinity,
  maxProperties = +Infinity,
  memo = memoBuilder(),
) {
  const [memoize, unmemoize] = memo;

  // Get the simple cases out of the way first
  if (value === null || (['number', 'boolean', 'string'].includes(typeof value) && !(0,is/* isNaN */.i2)(value))) {
    return value ;
  }

  var stringified = stringifyValue(key, value);

  // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
  // Everything else will have already been serialized, so if we don't see that pattern, we're done.
  if (!stringified.startsWith('[object ')) {
    return stringified;
  }

  // From here on, we can assert that `value` is either an object or an array.

  // Do not normalize objects that we know have already been normalized. As a general rule, the
  // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
  // have already been normalized.
  if ((value )['__sentry_skip_normalization__']) {
    return value ;
  }

  // We're also done if we've reached the max depth
  if (depth === 0) {
    // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
  }

  // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
  if (memoize(value)) {
    return '[Circular ~]';
  }

  // If the value has a `toJSON` method, we call it to extract more information
  var valueWithToJSON = value ;
  if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') {
    try {
      var jsonValue = valueWithToJSON.toJSON();
      // We need to normalize the return value of `.toJSON()` in case it has circular references
      return visit('', jsonValue, depth - 1, maxProperties, memo);
    } catch (err) {
      // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
  }

  // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
  // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
  // property/entry, and keep track of the number of items we add to it.
  var normalized = (Array.isArray(value) ? [] : {}) ;
  let numAdded = 0;

  // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
  // properties are non-enumerable and otherwise would get missed.
  var visitable = (0,object/* convertToPlainObject */.Sh)(value );

  for (var visitKey in visitable) {
    // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
    if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) {
      continue;
    }

    if (numAdded >= maxProperties) {
      normalized[visitKey] = '[MaxProperties ~]';
      break;
    }

    // Recursively visit all the child nodes
    var visitValue = visitable[visitKey];
    normalized[visitKey] = visit(visitKey, visitValue, depth - 1, maxProperties, memo);

    numAdded += 1;
  }

  // Once we've visited all the branches, remove the parent from memo storage
  unmemoize(value);

  // Return accumulated values
  return normalized;
}

/**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */
function stringifyValue(
  key,
  // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
  // our internal use, it'll do
  value,
) {
  try {
    if (key === 'domain' && value && typeof value === 'object' && (value )._events) {
      return '[Domain]';
    }

    if (key === 'domainEmitter') {
      return '[DomainEmitter]';
    }

    // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
    // which won't throw if they are not present.

    if (typeof __webpack_require__.g !== 'undefined' && value === __webpack_require__.g) {
      return '[Global]';
    }

        if (typeof window !== 'undefined' && value === window) {
      return '[Window]';
    }

        if (typeof document !== 'undefined' && value === document) {
      return '[Document]';
    }

    // React's SyntheticEvent thingy
    if ((0,is/* isSyntheticEvent */.Cy)(value)) {
      return '[SyntheticEvent]';
    }

    if (typeof value === 'number' && value !== value) {
      return '[NaN]';
    }

    // this catches `undefined` (but not `null`, which is a primitive and can be serialized on its own)
    if (value === void 0) {
      return '[undefined]';
    }

    if (typeof value === 'function') {
      return `[Function: ${(0,stacktrace/* getFunctionName */.$P)(value)}]`;
    }

    if (typeof value === 'symbol') {
      return `[${String(value)}]`;
    }

    // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
    if (typeof value === 'bigint') {
      return `[BigInt: ${String(value)}]`;
    }

    // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
    // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
    // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
    // we can make sure that only plain objects come out that way.
    return `[object ${(Object.getPrototypeOf(value) ).constructor.name}]`;
  } catch (err) {
    return `**non-serializable** (${err})`;
  }
}

/** Calculates bytes size of input string */
function utf8Length(value) {
    return ~-encodeURI(value).split(/%..|./).length;
}

/** Calculates bytes size of input object */
function jsonSize(value) {
  return utf8Length(JSON.stringify(value));
}


//# sourceMappingURL=normalize.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/baggage.js
var esm_baggage = __webpack_require__(99181);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/envelope.js


/** Extract sdk info from from the API metadata */
function getSdkMetadataForEnvelopeHeader(metadata) {
  if (!metadata || !metadata.sdk) {
    return;
  }
  const { name, version } = metadata.sdk;
  return { name, version };
}

/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/
function enhanceEventWithSdkInfo(event, sdkInfo) {
  if (!sdkInfo) {
    return event;
  }
  event.sdk = event.sdk || {};
  event.sdk.name = event.sdk.name || sdkInfo.name;
  event.sdk.version = event.sdk.version || sdkInfo.version;
  event.sdk.integrations = [...(event.sdk.integrations || []), ...(sdkInfo.integrations || [])];
  event.sdk.packages = [...(event.sdk.packages || []), ...(sdkInfo.packages || [])];
  return event;
}

/** Creates an envelope from a Session */
function createSessionEnvelope(
  session,
  dsn,
  metadata,
  tunnel,
) {
  var sdkInfo = getSdkMetadataForEnvelopeHeader(metadata);
  var envelopeHeaders = {
    sent_at: new Date().toISOString(),
    ...(sdkInfo && { sdk: sdkInfo }),
    ...(!!tunnel && { dsn: dsnToString(dsn) }),
  };

  var envelopeItem =
    'aggregates' in session ? [{ type: 'sessions' }, session] : [{ type: 'session' }, session];

  return createEnvelope(envelopeHeaders, [envelopeItem]);
}

/**
 * Create an Envelope from an event.
 */
function createEventEnvelope(
  event,
  dsn,
  metadata,
  tunnel,
) {
  var sdkInfo = getSdkMetadataForEnvelopeHeader(metadata);
  var eventType = event.type || 'event';

  const { transactionSampling } = event.sdkProcessingMetadata || {};
  const { method: samplingMethod, rate: sampleRate } = transactionSampling || {};

  enhanceEventWithSdkInfo(event, metadata && metadata.sdk);

  var envelopeHeaders = createEventEnvelopeHeaders(event, sdkInfo, tunnel, dsn);

  // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
  // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
  // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
  // of this `delete`, lest we miss putting it back in the next time the property is in use.)
  delete event.sdkProcessingMetadata;

  var eventItem = [
    {
      type: eventType,
      sample_rates: [{ id: samplingMethod, rate: sampleRate }],
    },
    event,
  ];
  return createEnvelope(envelopeHeaders, [eventItem]);
}

function createEventEnvelopeHeaders(
  event,
  sdkInfo,
  tunnel,
  dsn,
) {
  var baggage = event.sdkProcessingMetadata && event.sdkProcessingMetadata.baggage;
  var dynamicSamplingContext = baggage && (0,esm_baggage/* getSentryBaggageItems */.Hk)(baggage);

  return {
    event_id: event.event_id ,
    sent_at: new Date().toISOString(),
    ...(sdkInfo && { sdk: sdkInfo }),
    ...(!!tunnel && { dsn: dsnToString(dsn) }),
    ...(event.type === 'transaction' &&
      dynamicSamplingContext && {
        trace: (0,object/* dropUndefinedKeys */.Jr)({ ...dynamicSamplingContext }) ,
      }),
  };
}


//# sourceMappingURL=envelope.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/baseclient.js






var ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";

/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */
class BaseClient {
  /** Options passed to the SDK. */
  

  /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */
  

  /** Array of set up integrations. */
   __init() {this._integrations = {};}

  /** Indicates whether this client's integrations have been set up. */
   __init2() {this._integrationsInitialized = false;}

  /** Number of calls being processed */
   __init3() {this._numProcessing = 0;}

  /** Holds flushable  */
   __init4() {this._outcomes = {};}

  /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */
   constructor(options) {;BaseClient.prototype.__init.call(this);BaseClient.prototype.__init2.call(this);BaseClient.prototype.__init3.call(this);BaseClient.prototype.__init4.call(this);
    this._options = options;
    if (options.dsn) {
      this._dsn = makeDsn(options.dsn);
      var url = getEnvelopeEndpointWithUrlEncodedAuth(this._dsn, options);
      this._transport = options.transport({
        recordDroppedEvent: this.recordDroppedEvent.bind(this),
        ...options.transportOptions,
        url,
      });
    } else {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('No DSN provided, client will not do anything.');
    }
  }

  /**
   * @inheritDoc
   */
     captureException(exception, hint, scope) {
    // ensure we haven't captured this very object before
    if ((0,misc/* checkOrSetAlreadyCaught */.YO)(exception)) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(ALREADY_SEEN_ERROR);
      return;
    }

    let eventId = hint && hint.event_id;

    this._process(
      this.eventFromException(exception, hint)
        .then(event => this._captureEvent(event, hint, scope))
        .then(result => {
          eventId = result;
        }),
    );

    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureMessage(
    message,
        level,
    hint,
    scope,
  ) {
    let eventId = hint && hint.event_id;

    var promisedEvent = (0,is/* isPrimitive */.pt)(message)
      ? this.eventFromMessage(String(message), level, hint)
      : this.eventFromException(message, hint);

    this._process(
      promisedEvent
        .then(event => this._captureEvent(event, hint, scope))
        .then(result => {
          eventId = result;
        }),
    );

    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureEvent(event, hint, scope) {
    // ensure we haven't captured this very object before
    if (hint && hint.originalException && (0,misc/* checkOrSetAlreadyCaught */.YO)(hint.originalException)) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(ALREADY_SEEN_ERROR);
      return;
    }

    let eventId = hint && hint.event_id;

    this._process(
      this._captureEvent(event, hint, scope).then(result => {
        eventId = result;
      }),
    );

    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureSession(session) {
    if (!this._isEnabled()) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('SDK not enabled, will not capture session.');
      return;
    }

    if (!(typeof session.release === 'string')) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('Discarded session because of missing or non-string release');
    } else {
      this.sendSession(session);
      // After sending, we set init false to indicate it's not the first occurrence
      (0,esm_session/* updateSession */.CT)(session, { init: false });
    }
  }

  /**
   * @inheritDoc
   */
   getDsn() {
    return this._dsn;
  }

  /**
   * @inheritDoc
   */
   getOptions() {
    return this._options;
  }

  /**
   * @inheritDoc
   */
   getTransport() {
    return this._transport;
  }

  /**
   * @inheritDoc
   */
   flush(timeout) {
    var transport = this._transport;
    if (transport) {
      return this._isClientDoneProcessing(timeout).then(clientFinished => {
        return transport.flush(timeout).then(transportFlushed => clientFinished && transportFlushed);
      });
    } else {
      return (0,syncpromise/* resolvedSyncPromise */.WD)(true);
    }
  }

  /**
   * @inheritDoc
   */
   close(timeout) {
    return this.flush(timeout).then(result => {
      this.getOptions().enabled = false;
      return result;
    });
  }

  /**
   * Sets up the integrations
   */
   setupIntegrations() {
    if (this._isEnabled() && !this._integrationsInitialized) {
      this._integrations = setupIntegrations(this._options.integrations);
      this._integrationsInitialized = true;
    }
  }

  /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   */
   getIntegrationById(integrationId) {
    return this._integrations[integrationId];
  }

  /**
   * @inheritDoc
   */
   getIntegration(integration) {
    try {
      return (this._integrations[integration.id] ) || null;
    } catch (_oO) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn(`Cannot retrieve integration ${integration.id} from the current Client`);
      return null;
    }
  }

  /**
   * @inheritDoc
   */
   sendEvent(event, hint = {}) {
    if (this._dsn) {
      let env = createEventEnvelope(event, this._dsn, this._options._metadata, this._options.tunnel);

      for (var attachment of hint.attachments || []) {
        env = addItemToEnvelope(
          env,
          createAttachmentEnvelopeItem(
            attachment,
            this._options.transportOptions && this._options.transportOptions.textEncoder,
          ),
        );
      }

      this._sendEnvelope(env);
    }
  }

  /**
   * @inheritDoc
   */
   sendSession(session) {
    if (this._dsn) {
      var env = createSessionEnvelope(session, this._dsn, this._options._metadata, this._options.tunnel);
      this._sendEnvelope(env);
    }
  }

  /**
   * @inheritDoc
   */
   recordDroppedEvent(reason, category) {
    if (this._options.sendClientReports) {
      // We want to track each category (error, transaction, session) separately
      // but still keep the distinction between different type of outcomes.
      // We could use nested maps, but it's much easier to read and type this way.
      // A correct type for map-based implementation if we want to go that route
      // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
      // With typescript 4.1 we could even use template literal types
      var key = `${reason}:${category}`;
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(`Adding outcome: "${key}"`);

      // The following works because undefined + 1 === NaN and NaN is falsy
      this._outcomes[key] = this._outcomes[key] + 1 || 1;
    }
  }

  /** Updates existing session based on the provided event */
   _updateSessionFromEvent(session, event) {
    let crashed = false;
    let errored = false;
    var exceptions = event.exception && event.exception.values;

    if (exceptions) {
      errored = true;

      for (var ex of exceptions) {
        var mechanism = ex.mechanism;
        if (mechanism && mechanism.handled === false) {
          crashed = true;
          break;
        }
      }
    }

    // A session is updated and that session update is sent in only one of the two following scenarios:
    // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
    // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
    var sessionNonTerminal = session.status === 'ok';
    var shouldUpdateAndSend = (sessionNonTerminal && session.errors === 0) || (sessionNonTerminal && crashed);

    if (shouldUpdateAndSend) {
      (0,esm_session/* updateSession */.CT)(session, {
        ...(crashed && { status: 'crashed' }),
        errors: session.errors || Number(errored || crashed),
      });
      this.captureSession(session);
    }
  }

  /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */
   _isClientDoneProcessing(timeout) {
    return new syncpromise/* SyncPromise */.cW(resolve => {
      let ticked = 0;
      var tick = 1;

      var interval = setInterval(() => {
        if (this._numProcessing == 0) {
          clearInterval(interval);
          resolve(true);
        } else {
          ticked += tick;
          if (timeout && ticked >= timeout) {
            clearInterval(interval);
            resolve(false);
          }
        }
      }, tick);
    });
  }

  /** Determines whether this SDK is enabled and a valid Dsn is present. */
   _isEnabled() {
    return this.getOptions().enabled !== false && this._dsn !== undefined;
  }

  /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */
   _prepareEvent(event, hint, scope) {
    const { normalizeDepth = 3, normalizeMaxBreadth = 1000 } = this.getOptions();
    var prepared = {
      ...event,
      event_id: event.event_id || hint.event_id || (0,misc/* uuid4 */.DM)(),
      timestamp: event.timestamp || (0,time/* dateTimestampInSeconds */.yW)(),
    };

    this._applyClientOptions(prepared);
    this._applyIntegrationsMetadata(prepared);

    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    let finalScope = scope;
    if (hint.captureContext) {
      finalScope = esm_scope/* Scope.clone */.s.clone(finalScope).update(hint.captureContext);
    }

    // We prepare the result here with a resolved Event.
    let result = (0,syncpromise/* resolvedSyncPromise */.WD)(prepared);

    // This should be the last thing called, since we want that
    // {@link Hub.addEventProcessor} gets the finished prepared event.
    if (finalScope) {
      // Collect attachments from the hint and scope
      var attachments = [...(hint.attachments || []), ...finalScope.getAttachments()];

      if (attachments.length) {
        hint.attachments = attachments;
      }

      // In case we have a hub we reassign it.
      result = finalScope.applyToEvent(prepared, hint);
    }

    return result.then(evt => {
      if (typeof normalizeDepth === 'number' && normalizeDepth > 0) {
        return this._normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
      }
      return evt;
    });
  }

  /**
   * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
   * Normalized keys:
   * - `breadcrumbs.data`
   * - `user`
   * - `contexts`
   * - `extra`
   * @param event Event
   * @returns Normalized event
   */
   _normalizeEvent(event, depth, maxBreadth) {
    if (!event) {
      return null;
    }

    var normalized = {
      ...event,
      ...(event.breadcrumbs && {
        breadcrumbs: event.breadcrumbs.map(b => ({
          ...b,
          ...(b.data && {
            data: normalize(b.data, depth, maxBreadth),
          }),
        })),
      }),
      ...(event.user && {
        user: normalize(event.user, depth, maxBreadth),
      }),
      ...(event.contexts && {
        contexts: normalize(event.contexts, depth, maxBreadth),
      }),
      ...(event.extra && {
        extra: normalize(event.extra, depth, maxBreadth),
      }),
    };

    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
      normalized.contexts.trace = event.contexts.trace;

      // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
      if (event.contexts.trace.data) {
        normalized.contexts.trace.data = normalize(event.contexts.trace.data, depth, maxBreadth);
      }
    }

    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) {
      normalized.spans = event.spans.map(span => {
        // We cannot use the spread operator here because `toJSON` on `span` is non-enumerable
        if (span.data) {
          span.data = normalize(span.data, depth, maxBreadth);
        }
        return span;
      });
    }

    return normalized;
  }

  /**
   *  Enhances event using the client configuration.
   *  It takes care of all "static" values like environment, release and `dist`,
   *  as well as truncating overly long values.
   * @param event event instance to be enhanced
   */
   _applyClientOptions(event) {
    var options = this.getOptions();
    const { environment, release, dist, maxValueLength = 250 } = options;

    if (!('environment' in event)) {
      event.environment = 'environment' in options ? environment : 'production';
    }

    if (event.release === undefined && release !== undefined) {
      event.release = release;
    }

    if (event.dist === undefined && dist !== undefined) {
      event.dist = dist;
    }

    if (event.message) {
      event.message = (0,string/* truncate */.$G)(event.message, maxValueLength);
    }

    var exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) {
      exception.value = (0,string/* truncate */.$G)(exception.value, maxValueLength);
    }

    var request = event.request;
    if (request && request.url) {
      request.url = (0,string/* truncate */.$G)(request.url, maxValueLength);
    }
  }

  /**
   * This function adds all used integrations to the SDK info in the event.
   * @param event The event that will be filled with all integrations.
   */
   _applyIntegrationsMetadata(event) {
    var integrationsArray = Object.keys(this._integrations);
    if (integrationsArray.length > 0) {
      event.sdk = event.sdk || {};
      event.sdk.integrations = [...(event.sdk.integrations || []), ...integrationsArray];
    }
  }

  /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */
   _captureEvent(event, hint = {}, scope) {
    return this._processEvent(event, hint, scope).then(
      finalEvent => {
        return finalEvent.event_id;
      },
      reason => {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn(reason);
        return undefined;
      },
    );
  }

  /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */
   _processEvent(event, hint, scope) {
    const { beforeSend, sampleRate } = this.getOptions();

    if (!this._isEnabled()) {
      return (0,syncpromise/* rejectedSyncPromise */.$2)(new SentryError('SDK not enabled, will not capture event.'));
    }

    var isTransaction = event.type === 'transaction';
    // 1.0 === 100% events are sent
    // 0.0 === 0% events are sent
    // Sampling for transaction happens somewhere else
    if (!isTransaction && typeof sampleRate === 'number' && Math.random() > sampleRate) {
      this.recordDroppedEvent('sample_rate', 'error');
      return (0,syncpromise/* rejectedSyncPromise */.$2)(
        new SentryError(
          `Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`,
        ),
      );
    }

    return this._prepareEvent(event, hint, scope)
      .then(prepared => {
        if (prepared === null) {
          this.recordDroppedEvent('event_processor', event.type || 'error');
          throw new SentryError('An event processor returned null, will not send event.');
        }

        var isInternalException = hint.data && (hint.data ).__sentry__ === true;
        if (isInternalException || isTransaction || !beforeSend) {
          return prepared;
        }

        var beforeSendResult = beforeSend(prepared, hint);
        return _ensureBeforeSendRv(beforeSendResult);
      })
      .then(processedEvent => {
        if (processedEvent === null) {
          this.recordDroppedEvent('before_send', event.type || 'error');
          throw new SentryError('`beforeSend` returned `null`, will not send event.');
        }

        var session = scope && scope.getSession();
        if (!isTransaction && session) {
          this._updateSessionFromEvent(session, processedEvent);
        }

        this.sendEvent(processedEvent, hint);
        return processedEvent;
      })
      .then(null, reason => {
        if (reason instanceof SentryError) {
          throw reason;
        }

        this.captureException(reason, {
          data: {
            __sentry__: true,
          },
          originalException: reason ,
        });
        throw new SentryError(
          `Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`,
        );
      });
  }

  /**
   * Occupies the client with processing and event
   */
   _process(promise) {
    this._numProcessing += 1;
    void promise.then(
      value => {
        this._numProcessing -= 1;
        return value;
      },
      reason => {
        this._numProcessing -= 1;
        return reason;
      },
    );
  }

  /**
   * @inheritdoc
   */
   _sendEnvelope(envelope) {
    if (this._transport && this._dsn) {
      this._transport.send(envelope).then(null, reason => {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error('Error while sending event:', reason);
      });
    } else {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error('Transport disabled');
    }
  }

  /**
   * Clears outcomes on this client and returns them.
   */
   _clearOutcomes() {
    var outcomes = this._outcomes;
    this._outcomes = {};
    return Object.keys(outcomes).map(key => {
      const [reason, category] = key.split(':') ;
      return {
        reason,
        category,
        quantity: outcomes[key],
      };
    });
  }

  /**
   * @inheritDoc
   */
    

}

/**
 * Verifies that return value of configured `beforeSend` is of expected type.
 */
function _ensureBeforeSendRv(rv) {
  var nullErr = '`beforeSend` method has to return `null` or a valid event.';
  if ((0,is/* isThenable */.J8)(rv)) {
    return rv.then(
      event => {
        if (!((0,is/* isPlainObject */.PO)(event) || event === null)) {
          throw new SentryError(nullErr);
        }
        return event;
      },
      e => {
        throw new SentryError(`beforeSend rejected with ${e}`);
      },
    );
  } else if (!((0,is/* isPlainObject */.PO)(rv) || rv === null)) {
    throw new SentryError(nullErr);
  }
  return rv;
}


//# sourceMappingURL=baseclient.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/version.js
var version = __webpack_require__(40105);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/clientreport.js



/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */
function createClientReportEnvelope(
  discarded_events,
  dsn,
  timestamp,
) {
  var clientReportItem = [
    { type: 'client_report' },
    {
      timestamp: timestamp || (0,time/* dateTimestampInSeconds */.yW)(),
      discarded_events,
    },
  ];
  return createEnvelope(dsn ? { dsn } : {}, [clientReportItem]);
}


//# sourceMappingURL=clientreport.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/eventbuilder.js


/**
 * This function creates an exception from a JavaScript Error
 */
function exceptionFromError(stackParser, ex) {
  // Get the frames first since Opera can lose the stack if we touch anything else first
  var frames = parseStackFrames(stackParser, ex);

  var exception = {
    type: ex && ex.name,
    value: extractMessage(ex),
  };

  if (frames.length) {
    exception.stacktrace = { frames };
  }

  if (exception.type === undefined && exception.value === '') {
    exception.value = 'Unrecoverable error caught';
  }

  return exception;
}

/**
 * @hidden
 */
function eventFromPlainObject(
  stackParser,
  exception,
  syntheticException,
  isUnhandledRejection,
) {
  var event = {
    exception: {
      values: [
        {
          type: (0,is/* isEvent */.cO)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
          value: `Non-Error ${
            isUnhandledRejection ? 'promise rejection' : 'exception'
          } captured with keys: ${(0,object/* extractExceptionKeysForMessage */.zf)(exception)}`,
        },
      ],
    },
    extra: {
      __serialized__: normalizeToSize(exception),
    },
  };

  if (syntheticException) {
    var frames = parseStackFrames(stackParser, syntheticException);
    if (frames.length) {
      // event.exception.values[0] has been set above
      (event.exception ).values[0].stacktrace = { frames };
    }
  }

  return event;
}

/**
 * @hidden
 */
function eventFromError(stackParser, ex) {
  return {
    exception: {
      values: [exceptionFromError(stackParser, ex)],
    },
  };
}

/** Parses stack frames from an error */
function parseStackFrames(
  stackParser,
  ex,
) {
  // Access and store the stacktrace property before doing ANYTHING
  // else to it because Opera is not very good at providing it
  // reliably in other circumstances.
  var stacktrace = ex.stacktrace || ex.stack || '';

  var popSize = getPopSize(ex);

  try {
    return stackParser(stacktrace, popSize);
  } catch (e) {
    // no-empty
  }

  return [];
}

// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
var reactMinifiedRegexp = /Minified React error #\d+;/i;

function getPopSize(ex) {
  if (ex) {
    if (typeof ex.framesToPop === 'number') {
      return ex.framesToPop;
    }

    if (reactMinifiedRegexp.test(ex.message)) {
      return 1;
    }
  }

  return 0;
}

/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */
function extractMessage(ex) {
  var message = ex && ex.message;
  if (!message) {
    return 'No error message';
  }
  if (message.error && typeof message.error.message === 'string') {
    return message.error.message;
  }
  return message;
}

/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */
function eventFromException(
  stackParser,
  exception,
  hint,
  attachStacktrace,
) {
  var syntheticException = (hint && hint.syntheticException) || undefined;
  var event = eventFromUnknownInput(stackParser, exception, syntheticException, attachStacktrace);
  (0,misc/* addExceptionMechanism */.EG)(event); // defaults to { type: 'generic', handled: true }
  event.level = 'error';
  if (hint && hint.event_id) {
    event.event_id = hint.event_id;
  }
  return (0,syncpromise/* resolvedSyncPromise */.WD)(event);
}

/**
 * Builds and Event from a Message
 * @hidden
 */
function eventFromMessage(
  stackParser,
  message,
    level = 'info',
  hint,
  attachStacktrace,
) {
  var syntheticException = (hint && hint.syntheticException) || undefined;
  var event = eventFromString(stackParser, message, syntheticException, attachStacktrace);
  event.level = level;
  if (hint && hint.event_id) {
    event.event_id = hint.event_id;
  }
  return (0,syncpromise/* resolvedSyncPromise */.WD)(event);
}

/**
 * @hidden
 */
function eventFromUnknownInput(
  stackParser,
  exception,
  syntheticException,
  attachStacktrace,
  isUnhandledRejection,
) {
  let event;

  if ((0,is/* isErrorEvent */.VW)(exception ) && (exception ).error) {
    // If it is an ErrorEvent with `error` property, extract it to get actual Error
    var errorEvent = exception ;
    return eventFromError(stackParser, errorEvent.error );
  }

  // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
  // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
  // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
  //
  // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
  // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
  // https://webidl.spec.whatwg.org/#es-DOMException-specialness
  if ((0,is/* isDOMError */.TX)(exception ) || (0,is/* isDOMException */.fm)(exception )) {
    var domException = exception ;

    if ('stack' in (exception )) {
      event = eventFromError(stackParser, exception );
    } else {
      var name = domException.name || ((0,is/* isDOMError */.TX)(domException) ? 'DOMError' : 'DOMException');
      var message = domException.message ? `${name}: ${domException.message}` : name;
      event = eventFromString(stackParser, message, syntheticException, attachStacktrace);
      (0,misc/* addExceptionTypeValue */.Db)(event, message);
    }
    if ('code' in domException) {
      event.tags = { ...event.tags, 'DOMException.code': `${domException.code}` };
    }

    return event;
  }
  if ((0,is/* isError */.VZ)(exception)) {
    // we have a real Error object, do nothing
    return eventFromError(stackParser, exception);
  }
  if ((0,is/* isPlainObject */.PO)(exception) || (0,is/* isEvent */.cO)(exception)) {
    // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
    // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
    // group on any key/value change.
    var objectException = exception ;
    event = eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
    (0,misc/* addExceptionMechanism */.EG)(event, {
      synthetic: true,
    });
    return event;
  }

  // If none of previous checks were valid, then it means that it's not:
  // - an instance of DOMError
  // - an instance of DOMException
  // - an instance of Event
  // - an instance of Error
  // - a valid ErrorEvent (one with an error property)
  // - a plain Object
  //
  // So bail out and capture it as a simple message:
  event = eventFromString(stackParser, exception , syntheticException, attachStacktrace);
  (0,misc/* addExceptionTypeValue */.Db)(event, `${exception}`, undefined);
  (0,misc/* addExceptionMechanism */.EG)(event, {
    synthetic: true,
  });

  return event;
}

/**
 * @hidden
 */
function eventFromString(
  stackParser,
  input,
  syntheticException,
  attachStacktrace,
) {
  var event = {
    message: input,
  };

  if (attachStacktrace && syntheticException) {
    var frames = parseStackFrames(stackParser, syntheticException);
    if (frames.length) {
      event.exception = {
        values: [{ value: input, stacktrace: { frames } }],
      };
    }
  }

  return event;
}


//# sourceMappingURL=eventbuilder.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/browser.js
var browser = __webpack_require__(58464);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/severity.js
// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.

var validSeverityLevels = ['fatal', 'error', 'warning', 'log', 'info', 'debug'];

/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */
function severityFromString(level) {
  return severityLevelFromString(level) ;
}

/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */
function severityLevelFromString(level) {
  return (level === 'warn' ? 'warning' : validSeverityLevels.includes(level) ? level : 'log') ;
}


//# sourceMappingURL=severity.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/breadcrumbs.js



/** JSDoc */

var BREADCRUMB_INTEGRATION_ID = 'Breadcrumbs';

/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */
class Breadcrumbs  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = BREADCRUMB_INTEGRATION_ID;}

  /**
   * @inheritDoc
   */
   __init() {this.name = Breadcrumbs.id;}

  /**
   * Options of the breadcrumbs integration.
   */
  // This field is public, because we use it in the browser client to check if the `sentry` option is enabled.
  

  /**
   * @inheritDoc
   */
   constructor(options) {;Breadcrumbs.prototype.__init.call(this);
    this.options = {
      console: true,
      dom: true,
      fetch: true,
      history: true,
      sentry: true,
      xhr: true,
      ...options,
    };
  }

  /**
   * Instrument browser built-ins w/ breadcrumb capturing
   *  - Console API
   *  - DOM API (click/typing)
   *  - XMLHttpRequest API
   *  - Fetch API
   *  - History API
   */
   setupOnce() {
    if (this.options.console) {
      (0,instrument/* addInstrumentationHandler */.o)('console', _consoleBreadcrumb);
    }
    if (this.options.dom) {
      (0,instrument/* addInstrumentationHandler */.o)('dom', _domBreadcrumb(this.options.dom));
    }
    if (this.options.xhr) {
      (0,instrument/* addInstrumentationHandler */.o)('xhr', _xhrBreadcrumb);
    }
    if (this.options.fetch) {
      (0,instrument/* addInstrumentationHandler */.o)('fetch', _fetchBreadcrumb);
    }
    if (this.options.history) {
      (0,instrument/* addInstrumentationHandler */.o)('history', _historyBreadcrumb);
    }
  }
} Breadcrumbs.__initStatic();

/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */
function _domBreadcrumb(dom) {
    function _innerDomBreadcrumb(handlerData) {
    let target;
    let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;

    if (typeof keyAttrs === 'string') {
      keyAttrs = [keyAttrs];
    }

    // Accessing event.target can throw (see getsentry/raven-js#838, #768)
    try {
      target = handlerData.event.target
        ? (0,browser/* htmlTreeAsString */.R)(handlerData.event.target , keyAttrs)
        : (0,browser/* htmlTreeAsString */.R)(handlerData.event , keyAttrs);
    } catch (e) {
      target = '<unknown>';
    }

    if (target.length === 0) {
      return;
    }

    (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(
      {
        category: `ui.${handlerData.name}`,
        message: target,
      },
      {
        event: handlerData.event,
        name: handlerData.name,
        global: handlerData.global,
      },
    );
  }

  return _innerDomBreadcrumb;
}

/**
 * Creates breadcrumbs from console API calls
 */
function _consoleBreadcrumb(handlerData) {
  var breadcrumb = {
    category: 'console',
    data: {
      arguments: handlerData.args,
      logger: 'console',
    },
    level: severityLevelFromString(handlerData.level),
    message: (0,string/* safeJoin */.nK)(handlerData.args, ' '),
  };

  if (handlerData.level === 'assert') {
    if (handlerData.args[0] === false) {
      breadcrumb.message = `Assertion failed: ${(0,string/* safeJoin */.nK)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
      breadcrumb.data.arguments = handlerData.args.slice(1);
    } else {
      // Don't capture a breadcrumb for passed assertions
      return;
    }
  }

  (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(breadcrumb, {
    input: handlerData.args,
    level: handlerData.level,
  });
}

/**
 * Creates breadcrumbs from XHR API calls
 */
function _xhrBreadcrumb(handlerData) {
  if (handlerData.endTimestamp) {
    // We only capture complete, non-sentry requests
    if (handlerData.xhr.__sentry_own_request__) {
      return;
    }

    const { method, url, status_code, body } = handlerData.xhr.__sentry_xhr__ || {};

    (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(
      {
        category: 'xhr',
        data: {
          method,
          url,
          status_code,
        },
        type: 'http',
      },
      {
        xhr: handlerData.xhr,
        input: body,
      },
    );

    return;
  }
}

/**
 * Creates breadcrumbs from fetch API calls
 */
function _fetchBreadcrumb(handlerData) {
  // We only capture complete fetch requests
  if (!handlerData.endTimestamp) {
    return;
  }

  if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') {
    // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
    return;
  }

  if (handlerData.error) {
    (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(
      {
        category: 'fetch',
        data: handlerData.fetchData,
        level: 'error',
        type: 'http',
      },
      {
        data: handlerData.error,
        input: handlerData.args,
      },
    );
  } else {
    (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(
      {
        category: 'fetch',
        data: {
          ...handlerData.fetchData,
          status_code: handlerData.response.status,
        },
        type: 'http',
      },
      {
        input: handlerData.args,
        response: handlerData.response,
      },
    );
  }
}

/**
 * Creates breadcrumbs from history API calls
 */
function _historyBreadcrumb(handlerData) {
  var global = (0,esm_global/* getGlobalObject */.R)();
  let from = handlerData.from;
  let to = handlerData.to;
  var parsedLoc = (0,misc/* parseUrl */.en)(global.location.href);
  let parsedFrom = (0,misc/* parseUrl */.en)(from);
  var parsedTo = (0,misc/* parseUrl */.en)(to);

  // Initial pushState doesn't provide `from` information
  if (!parsedFrom.path) {
    parsedFrom = parsedLoc;
  }

  // Use only the path component of the URL if the URL matches the current
  // document (almost all the time when using pushState)
  if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) {
    to = parsedTo.relative;
  }
  if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) {
    from = parsedFrom.relative;
  }

  (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb({
    category: 'navigation',
    data: {
      from,
      to,
    },
  });
}


//# sourceMappingURL=breadcrumbs.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/transports/utils.js


var global = (0,esm_global/* getGlobalObject */.R)();
let cachedFetchImpl;

/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * var f = window.fetch;
 * window.fetch = function () {
 *   var p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */
function getNativeFetchImplementation() {
  if (cachedFetchImpl) {
    return cachedFetchImpl;
  }

  // Fast path to avoid DOM I/O
  if ((0,supports/* isNativeFetch */.Du)(global.fetch)) {
    return (cachedFetchImpl = global.fetch.bind(global));
  }

  var document = global.document;
  let fetchImpl = global.fetch;
    if (document && typeof document.createElement === 'function') {
    try {
      var sandbox = document.createElement('iframe');
      sandbox.hidden = true;
      document.head.appendChild(sandbox);
      var contentWindow = sandbox.contentWindow;
      if (contentWindow && contentWindow.fetch) {
        fetchImpl = contentWindow.fetch;
      }
      document.head.removeChild(sandbox);
    } catch (e) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        esm_logger/* logger.warn */.kg.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
    }
  }

  return (cachedFetchImpl = fetchImpl.bind(global));
  }

/**
 * Sends sdk client report using sendBeacon or fetch as a fallback if available
 *
 * @param url report endpoint
 * @param body report payload
 */
function sendReport(url, body) {
  var isRealNavigator = Object.prototype.toString.call(global && global.navigator) === '[object Navigator]';
  var hasSendBeacon = isRealNavigator && typeof global.navigator.sendBeacon === 'function';

  if (hasSendBeacon) {
    // Prevent illegal invocations - https://xgwang.me/posts/you-may-not-know-beacon/#it-may-throw-error%2C-be-sure-to-catch
    var sendBeacon = global.navigator.sendBeacon.bind(global.navigator);
    sendBeacon(url, body);
  } else if ((0,supports/* supportsFetch */.Ak)()) {
    var fetch = getNativeFetchImplementation();
    fetch(url, {
      body,
      method: 'POST',
      credentials: 'omit',
      keepalive: true,
    }).then(null, error => {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error(error);
    });
  }
}


//# sourceMappingURL=utils.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/client.js






var globalObject = (0,esm_global/* getGlobalObject */.R)();

/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */
class BrowserClient extends BaseClient {
  /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */
   constructor(options) {
    options._metadata = options._metadata || {};
    options._metadata.sdk = options._metadata.sdk || {
      name: 'sentry.javascript.browser',
      packages: [
        {
          name: 'npm:@sentry/browser',
          version: version/* SDK_VERSION */.J,
        },
      ],
      version: version/* SDK_VERSION */.J,
    };

    super(options);

    if (options.sendClientReports && globalObject.document) {
      globalObject.document.addEventListener('visibilitychange', () => {
        if (globalObject.document.visibilityState === 'hidden') {
          this._flushOutcomes();
        }
      });
    }
  }

  /**
   * @inheritDoc
   */
   eventFromException(exception, hint) {
    return eventFromException(this._options.stackParser, exception, hint, this._options.attachStacktrace);
  }

  /**
   * @inheritDoc
   */
   eventFromMessage(
    message,
        level = 'info',
    hint,
  ) {
    return eventFromMessage(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
  }

  /**
   * @inheritDoc
   */
   sendEvent(event, hint) {
    // We only want to add the sentry event breadcrumb when the user has the breadcrumb integration installed and
    // activated its `sentry` option.
    // We also do not want to use the `Breadcrumbs` class here directly, because we do not want it to be included in
    // bundles, if it is not used by the SDK.
    // This all sadly is a bit ugly, but we currently don't have a "pre-send" hook on the integrations so we do it this
    // way for now.
    var breadcrumbIntegration = this.getIntegrationById(BREADCRUMB_INTEGRATION_ID) ;
    if (
      breadcrumbIntegration &&
      // We check for definedness of `options`, even though it is not strictly necessary, because that access to
      // `.sentry` below does not throw, in case users provided their own integration with id "Breadcrumbs" that does
      // not have an`options` field
      breadcrumbIntegration.options &&
      breadcrumbIntegration.options.sentry
    ) {
      (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(
        {
          category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
          event_id: event.event_id,
          level: event.level,
          message: (0,misc/* getEventDescription */.jH)(event),
        },
        {
          event,
        },
      );
    }

    super.sendEvent(event, hint);
  }

  /**
   * @inheritDoc
   */
   _prepareEvent(event, hint, scope) {
    event.platform = event.platform || 'javascript';
    return super._prepareEvent(event, hint, scope);
  }

  /**
   * Sends client reports as an envelope.
   */
   _flushOutcomes() {
    var outcomes = this._clearOutcomes();

    if (outcomes.length === 0) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('No outcomes to send');
      return;
    }

    if (!this._dsn) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('No dsn provided, will not send outcomes');
      return;
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('Sending outcomes:', outcomes);

    var url = getEnvelopeEndpointWithUrlEncodedAuth(this._dsn, this._options);
    var envelope = createClientReportEnvelope(outcomes, this._options.tunnel && dsnToString(this._dsn));

    try {
      sendReport(url, serializeEnvelope(envelope));
    } catch (e) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error(e);
    }
  }
}


//# sourceMappingURL=client.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/stack-parsers.js


// global reference to slice
var UNKNOWN_FUNCTION = '?';

var OPERA10_PRIORITY = 10;
var OPERA11_PRIORITY = 20;
var CHROME_PRIORITY = 30;
var WINJS_PRIORITY = 40;
var GECKO_PRIORITY = 50;

function createFrame(filename, func, lineno, colno) {
  var frame = {
    filename,
    function: func,
    // All browser frames are considered in_app
    in_app: true,
  };

  if (lineno !== undefined) {
    frame.lineno = lineno;
  }

  if (colno !== undefined) {
    frame.colno = colno;
  }

  return frame;
}

// Chromium based browsers: Chrome, Brave, new Opera, new Edge
var chromeRegex =
  /^\s*at (?:(.*?) ?\((?:address at )?)?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
var chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;

var chrome = line => {
  var parts = chromeRegex.exec(line);

  if (parts) {
    var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line

    if (isEval) {
      var subMatch = chromeEvalRegex.exec(parts[2]);

      if (subMatch) {
        // throw out eval line/column and use top-most line/column number
        parts[2] = subMatch[1]; // url
        parts[3] = subMatch[2]; // line
        parts[4] = subMatch[3]; // column
      }
    }

    // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
    // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
    const [func, filename] = extractSafariExtensionDetails(parts[1] || UNKNOWN_FUNCTION, parts[2]);

    return createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
  }

  return;
};

var chromeStackLineParser = [CHROME_PRIORITY, chrome];

// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
var geckoREgex =
  /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|capacitor).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
var geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;

var gecko = line => {
  var parts = geckoREgex.exec(line);

  if (parts) {
    var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
    if (isEval) {
      var subMatch = geckoEvalRegex.exec(parts[3]);

      if (subMatch) {
        // throw out eval line/column and use top-most line number
        parts[1] = parts[1] || 'eval';
        parts[3] = subMatch[1];
        parts[4] = subMatch[2];
        parts[5] = ''; // no column when eval
      }
    }

    let filename = parts[3];
    let func = parts[1] || UNKNOWN_FUNCTION;
    [func, filename] = extractSafariExtensionDetails(func, filename);

    return createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
  }

  return;
};

var geckoStackLineParser = [GECKO_PRIORITY, gecko];

var winjsRegex =
  /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;

var winjs = line => {
  var parts = winjsRegex.exec(line);

  return parts
    ? createFrame(parts[2], parts[1] || UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined)
    : undefined;
};

var winjsStackLineParser = [WINJS_PRIORITY, winjs];

var opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;

var opera10 = line => {
  var parts = opera10Regex.exec(line);
  return parts ? createFrame(parts[2], parts[3] || UNKNOWN_FUNCTION, +parts[1]) : undefined;
};

var opera10StackLineParser = [OPERA10_PRIORITY, opera10];

var opera11Regex =
  / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;

var opera11 = line => {
  var parts = opera11Regex.exec(line);
  return parts ? createFrame(parts[5], parts[3] || parts[4] || UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};

var opera11StackLineParser = [OPERA11_PRIORITY, opera11];

var defaultStackLineParsers = [chromeStackLineParser, geckoStackLineParser, winjsStackLineParser];

var defaultStackParser = (0,stacktrace/* createStackParser */.pE)(...defaultStackLineParsers);

/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */
var extractSafariExtensionDetails = (func, filename) => {
  var isSafariExtension = func.indexOf('safari-extension') !== -1;
  var isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;

  return isSafariExtension || isSafariWebExtension
    ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : UNKNOWN_FUNCTION,
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`,
      ]
    : [func, filename];
};


//# sourceMappingURL=stack-parsers.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/hub/esm/exports.js
var esm_exports = __webpack_require__(92876);
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/helpers.js



let ignoreOnError = 0;

/**
 * @hidden
 */
function shouldIgnoreOnError() {
  return ignoreOnError > 0;
}

/**
 * @hidden
 */
function ignoreNextOnError() {
  // onerror should trigger before setTimeout
  ignoreOnError += 1;
  setTimeout(() => {
    ignoreOnError -= 1;
  });
}

/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */
function wrap(
  fn,
  options

 = {},
  before,
  ) {
  // for future readers what this does is wrap a function and then create
  // a bi-directional wrapping between them.
  //
  // example: wrapped = wrap(original);
  //  original.__sentry_wrapped__ -> wrapped
  //  wrapped.__sentry_original__ -> original

  if (typeof fn !== 'function') {
    return fn;
  }

  try {
    // if we're dealing with a function that was previously wrapped, return
    // the original wrapper.
    var wrapper = fn.__sentry_wrapped__;
    if (wrapper) {
      return wrapper;
    }

    // We don't wanna wrap it twice
    if ((0,object/* getOriginalFunction */.HK)(fn)) {
      return fn;
    }
  } catch (e) {
    // Just accessing custom props in some Selenium environments
    // can cause a "Permission denied" exception (see raven-js#495).
    // Bail on wrapping and return the function as-is (defers to window.onerror).
    return fn;
  }

    // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
  var sentryWrapped = function () {
    var args = Array.prototype.slice.call(arguments);

    try {
      if (before && typeof before === 'function') {
        before.apply(this, arguments);
      }

            var wrappedArguments = args.map((arg) => wrap(arg, options));

      // Attempt to invoke user-land function
      // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
      //       means the sentry.javascript SDK caught an error invoking your application code. This
      //       is expected behavior and NOT indicative of a bug with sentry.javascript.
      return fn.apply(this, wrappedArguments);
    } catch (ex) {
      ignoreNextOnError();

      (0,esm_exports/* withScope */.$e)((scope) => {
        scope.addEventProcessor((event) => {
          if (options.mechanism) {
            (0,misc/* addExceptionTypeValue */.Db)(event, undefined, undefined);
            (0,misc/* addExceptionMechanism */.EG)(event, options.mechanism);
          }

          event.extra = {
            ...event.extra,
            arguments: args,
          };

          return event;
        });

        (0,esm_exports/* captureException */.Tb)(ex);
      });

      throw ex;
    }
  };
  
  // Accessing some objects may throw
  // ref: https://github.com/getsentry/sentry-javascript/issues/1168
  try {
    for (var property in fn) {
      if (Object.prototype.hasOwnProperty.call(fn, property)) {
        sentryWrapped[property] = fn[property];
      }
    }
  } catch (_oO) {} 
  // Signal that this function has been wrapped/filled already
  // for both debugging and to prevent it to being wrapped/filled twice
  (0,object/* markFunctionWrapped */.$Q)(sentryWrapped, fn);

  (0,object/* addNonEnumerableProperty */.xp)(fn, '__sentry_wrapped__', sentryWrapped);

  // Restore original function name (not all browsers allow that)
  try {
    var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name') ;
    if (descriptor.configurable) {
      Object.defineProperty(sentryWrapped, 'name', {
        get() {
          return fn.name;
        },
      });
    }
      } catch (_oO) {}

  return sentryWrapped;
}

/**
 * All properties the report dialog supports
 */


//# sourceMappingURL=helpers.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/trycatch.js



var DEFAULT_EVENT_TARGET = [
  'EventTarget',
  'Window',
  'Node',
  'ApplicationCache',
  'AudioTrackList',
  'ChannelMergerNode',
  'CryptoOperation',
  'EventSource',
  'FileReader',
  'HTMLUnknownElement',
  'IDBDatabase',
  'IDBRequest',
  'IDBTransaction',
  'KeyOperation',
  'MediaController',
  'MessagePort',
  'ModalWindow',
  'Notification',
  'SVGElementInstance',
  'Screen',
  'TextTrack',
  'TextTrackCue',
  'TextTrackList',
  'WebSocket',
  'WebSocketWorker',
  'Worker',
  'XMLHttpRequest',
  'XMLHttpRequestEventTarget',
  'XMLHttpRequestUpload',
];

/** Wrap timer functions and event targets to catch errors and provide better meta data */
class TryCatch  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'TryCatch';}

  /**
   * @inheritDoc
   */
   __init() {this.name = TryCatch.id;}

  /** JSDoc */
  

  /**
   * @inheritDoc
   */
   constructor(options) {;TryCatch.prototype.__init.call(this);
    this._options = {
      XMLHttpRequest: true,
      eventTarget: true,
      requestAnimationFrame: true,
      setInterval: true,
      setTimeout: true,
      ...options,
    };
  }

  /**
   * Wrap timer functions and event targets to catch errors
   * and provide better metadata.
   */
   setupOnce() {
    var global = (0,esm_global/* getGlobalObject */.R)();

    if (this._options.setTimeout) {
      (0,object/* fill */.hl)(global, 'setTimeout', _wrapTimeFunction);
    }

    if (this._options.setInterval) {
      (0,object/* fill */.hl)(global, 'setInterval', _wrapTimeFunction);
    }

    if (this._options.requestAnimationFrame) {
      (0,object/* fill */.hl)(global, 'requestAnimationFrame', _wrapRAF);
    }

    if (this._options.XMLHttpRequest && 'XMLHttpRequest' in global) {
      (0,object/* fill */.hl)(XMLHttpRequest.prototype, 'send', _wrapXHR);
    }

    var eventTargetOption = this._options.eventTarget;
    if (eventTargetOption) {
      var eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : DEFAULT_EVENT_TARGET;
      eventTarget.forEach(_wrapEventTarget);
    }
  }
} TryCatch.__initStatic();

/** JSDoc */
function _wrapTimeFunction(original) {
    return function ( ...args) {
    var originalCallback = args[0];
    args[0] = wrap(originalCallback, {
      mechanism: {
        data: { function: (0,stacktrace/* getFunctionName */.$P)(original) },
        handled: true,
        type: 'instrument',
      },
    });
    return original.apply(this, args);
  };
}

/** JSDoc */
function _wrapRAF(original) {
    return function ( callback) {
        return original.apply(this, [
      wrap(callback, {
        mechanism: {
          data: {
            function: 'requestAnimationFrame',
            handler: (0,stacktrace/* getFunctionName */.$P)(original),
          },
          handled: true,
          type: 'instrument',
        },
      }),
    ]);
  };
}

/** JSDoc */
function _wrapXHR(originalSend) {
    return function ( ...args) {
        var xhr = this;
    var xmlHttpRequestProps = ['onload', 'onerror', 'onprogress', 'onreadystatechange'];

    xmlHttpRequestProps.forEach(prop => {
      if (prop in xhr && typeof xhr[prop] === 'function') {
                (0,object/* fill */.hl)(xhr, prop, function (original) {
          var wrapOptions = {
            mechanism: {
              data: {
                function: prop,
                handler: (0,stacktrace/* getFunctionName */.$P)(original),
              },
              handled: true,
              type: 'instrument',
            },
          };

          // If Instrument integration has been called before TryCatch, get the name of original function
          var originalFunction = (0,object/* getOriginalFunction */.HK)(original);
          if (originalFunction) {
            wrapOptions.mechanism.data.handler = (0,stacktrace/* getFunctionName */.$P)(originalFunction);
          }

          // Otherwise wrap directly
          return wrap(original, wrapOptions);
        });
      }
    });

    return originalSend.apply(this, args);
  };
}

/** JSDoc */
function _wrapEventTarget(target) {
    var global = (0,esm_global/* getGlobalObject */.R)() ;
    var proto = global[target] && global[target].prototype;

    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
    return;
  }

  (0,object/* fill */.hl)(proto, 'addEventListener', function (original)

 {
    return function (
            
      eventName,
      fn,
      options,
    ) {
      try {
        if (typeof fn.handleEvent === 'function') {
          // ESlint disable explanation:
          //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
          //  introduce a bug here, because bind returns a new function that doesn't have our
          //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
          //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                    fn.handleEvent = wrap(fn.handleEvent, {
            mechanism: {
              data: {
                function: 'handleEvent',
                handler: (0,stacktrace/* getFunctionName */.$P)(fn),
                target,
              },
              handled: true,
              type: 'instrument',
            },
          });
        }
      } catch (err) {
        // can sometimes get 'Permission denied to access property "handle Event'
      }

      return original.apply(this, [
        eventName,
                wrap(fn , {
          mechanism: {
            data: {
              function: 'addEventListener',
              handler: (0,stacktrace/* getFunctionName */.$P)(fn),
              target,
            },
            handled: true,
            type: 'instrument',
          },
        }),
        options,
      ]);
    };
  });

  (0,object/* fill */.hl)(
    proto,
    'removeEventListener',
    function (
      originalRemoveEventListener,
          ) {
      return function (
                
        eventName,
        fn,
        options,
      ) {
        /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */
        var wrappedEventHandler = fn ;
        try {
          var originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
          if (originalEventHandler) {
            originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
          }
        } catch (e) {
          // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
        }
        return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
      };
    },
  );
}


//# sourceMappingURL=trycatch.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/globalhandlers.js





/** Global handlers */
class GlobalHandlers  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'GlobalHandlers';}

  /**
   * @inheritDoc
   */
   __init() {this.name = GlobalHandlers.id;}

  /** JSDoc */
  

  /**
   * Stores references functions to installing handlers. Will set to undefined
   * after they have been run so that they are not used twice.
   */
   __init2() {this._installFunc = {
    onerror: _installGlobalOnErrorHandler,
    onunhandledrejection: _installGlobalOnUnhandledRejectionHandler,
  };}

  /** JSDoc */
   constructor(options) {;GlobalHandlers.prototype.__init.call(this);GlobalHandlers.prototype.__init2.call(this);
    this._options = {
      onerror: true,
      onunhandledrejection: true,
      ...options,
    };
  }
  /**
   * @inheritDoc
   */
   setupOnce() {
    Error.stackTraceLimit = 50;
    var options = this._options;

    // We can disable guard-for-in as we construct the options object above + do checks against
    // `this._installFunc` for the property.
        for (var key in options) {
      var installFunc = this._installFunc[key ];
      if (installFunc && options[key ]) {
        globalHandlerLog(key);
        installFunc();
        this._installFunc[key ] = undefined;
      }
    }
  }
} GlobalHandlers.__initStatic();

/** JSDoc */
function _installGlobalOnErrorHandler() {
  (0,instrument/* addInstrumentationHandler */.o)(
    'error',
        (data) => {
      const [hub, stackParser, attachStacktrace] = getHubAndOptions();
      if (!hub.getIntegration(GlobalHandlers)) {
        return;
      }
      const { msg, url, line, column, error } = data;
      if (shouldIgnoreOnError() || (error && error.__sentry_own_request__)) {
        return;
      }

      var event =
        error === undefined && (0,is/* isString */.HD)(msg)
          ? _eventFromIncompleteOnError(msg, url, line, column)
          : _enhanceEventWithInitialFrame(
              eventFromUnknownInput(stackParser, error || msg, undefined, attachStacktrace, false),
              url,
              line,
              column,
            );

      event.level = 'error';

      addMechanismAndCapture(hub, error, event, 'onerror');
    },
  );
}

/** JSDoc */
function _installGlobalOnUnhandledRejectionHandler() {
  (0,instrument/* addInstrumentationHandler */.o)(
    'unhandledrejection',
        (e) => {
      const [hub, stackParser, attachStacktrace] = getHubAndOptions();
      if (!hub.getIntegration(GlobalHandlers)) {
        return;
      }
      let error = e;

      // dig the object of the rejection out of known event types
      try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ('reason' in e) {
          error = e.reason;
        }
        // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
        // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
        // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
        // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
        // https://github.com/getsentry/sentry-javascript/issues/2380
        else if ('detail' in e && 'reason' in e.detail) {
          error = e.detail.reason;
        }
      } catch (_oO) {
        // no-empty
      }

      if (shouldIgnoreOnError() || (error && error.__sentry_own_request__)) {
        return true;
      }

      var event = (0,is/* isPrimitive */.pt)(error)
        ? _eventFromRejectionWithPrimitive(error)
        : eventFromUnknownInput(stackParser, error, undefined, attachStacktrace, true);

      event.level = 'error';

      addMechanismAndCapture(hub, error, event, 'onunhandledrejection');
      return;
    },
  );
}

/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */
function _eventFromRejectionWithPrimitive(reason) {
  return {
    exception: {
      values: [
        {
          type: 'UnhandledRejection',
          // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
          value: `Non-Error promise rejection captured with value: ${String(reason)}`,
        },
      ],
    },
  };
}

/**
 * This function creates a stack from an old, error-less onerror handler.
 */
function _eventFromIncompleteOnError(msg, url, line, column) {
  var ERROR_TYPES_RE =
    /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;

  // If 'message' is ErrorEvent, get real message from inside
  let message = (0,is/* isErrorEvent */.VW)(msg) ? msg.message : msg;
  let name = 'Error';

  var groups = message.match(ERROR_TYPES_RE);
  if (groups) {
    name = groups[1];
    message = groups[2];
  }

  var event = {
    exception: {
      values: [
        {
          type: name,
          value: message,
        },
      ],
    },
  };

  return _enhanceEventWithInitialFrame(event, url, line, column);
}

/** JSDoc */
function _enhanceEventWithInitialFrame(event, url, line, column) {
  // event.exception
  var e = (event.exception = event.exception || {});
  // event.exception.values
  var ev = (e.values = e.values || []);
  // event.exception.values[0]
  var ev0 = (ev[0] = ev[0] || {});
  // event.exception.values[0].stacktrace
  var ev0s = (ev0.stacktrace = ev0.stacktrace || {});
  // event.exception.values[0].stacktrace.frames
  var ev0sf = (ev0s.frames = ev0s.frames || []);

  var colno = isNaN(parseInt(column, 10)) ? undefined : column;
  var lineno = isNaN(parseInt(line, 10)) ? undefined : line;
  var filename = (0,is/* isString */.HD)(url) && url.length > 0 ? url : (0,browser/* getLocationHref */.l)();

  // event.exception.values[0].stacktrace.frames
  if (ev0sf.length === 0) {
    ev0sf.push({
      colno,
      filename,
      function: '?',
      in_app: true,
      lineno,
    });
  }

  return event;
}

function globalHandlerLog(type) {
  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(`Global Handler attached: ${type}`);
}

function addMechanismAndCapture(hub, error, event, type) {
  (0,misc/* addExceptionMechanism */.EG)(event, {
    handled: false,
    type,
  });
  hub.captureEvent(event, {
    originalException: error,
  });
}

function getHubAndOptions() {
  var hub = (0,esm_hub/* getCurrentHub */.Gd)();
  var client = hub.getClient();
  var options = (client && client.getOptions()) || {
    stackParser: () => [],
    attachStacktrace: false,
  };
  return [hub, options.stackParser, options.attachStacktrace];
}


//# sourceMappingURL=globalhandlers.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/linkederrors.js




var DEFAULT_KEY = 'cause';
var DEFAULT_LIMIT = 5;

/** Adds SDK info to an event. */
class LinkedErrors  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'LinkedErrors';}

  /**
   * @inheritDoc
   */
    __init() {this.name = LinkedErrors.id;}

  /**
   * @inheritDoc
   */
  

  /**
   * @inheritDoc
   */
  

  /**
   * @inheritDoc
   */
   constructor(options = {}) {;LinkedErrors.prototype.__init.call(this);
    this._key = options.key || DEFAULT_KEY;
    this._limit = options.limit || DEFAULT_LIMIT;
  }

  /**
   * @inheritDoc
   */
   setupOnce() {
    var client = (0,esm_hub/* getCurrentHub */.Gd)().getClient();
    if (!client) {
      return;
    }
    (0,esm_scope/* addGlobalEventProcessor */.c)((event, hint) => {
      var self = (0,esm_hub/* getCurrentHub */.Gd)().getIntegration(LinkedErrors);
      return self ? _handler(client.getOptions().stackParser, self._key, self._limit, event, hint) : event;
    });
  }
} LinkedErrors.__initStatic();

/**
 * @inheritDoc
 */
function _handler(
  parser,
  key,
  limit,
  event,
  hint,
) {
  if (!event.exception || !event.exception.values || !hint || !(0,is/* isInstanceOf */.V9)(hint.originalException, Error)) {
    return event;
  }
  var linkedErrors = _walkErrorTree(parser, limit, hint.originalException , key);
  event.exception.values = [...linkedErrors, ...event.exception.values];
  return event;
}

/**
 * JSDOC
 */
function _walkErrorTree(
  parser,
  limit,
  error,
  key,
  stack = [],
) {
  if (!(0,is/* isInstanceOf */.V9)(error[key], Error) || stack.length + 1 >= limit) {
    return stack;
  }
  var exception = exceptionFromError(parser, error[key]);
  return _walkErrorTree(parser, limit, error[key], key, [exception, ...stack]);
}


//# sourceMappingURL=linkederrors.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/dedupe.js


/** Deduplication filter */
class Dedupe  {constructor() { Dedupe.prototype.__init.call(this); }
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'Dedupe';}

  /**
   * @inheritDoc
   */
   __init() {this.name = Dedupe.id;}

  /**
   * @inheritDoc
   */
  

  /**
   * @inheritDoc
   */
   setupOnce(addGlobalEventProcessor, getCurrentHub) {
    var eventProcessor = currentEvent => {
      var self = getCurrentHub().getIntegration(Dedupe);
      if (self) {
        // Juuust in case something goes wrong
        try {
          if (dedupe_shouldDropEvent(currentEvent, self._previousEvent)) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('Event dropped due to being a duplicate of previously captured event.');
            return null;
          }
        } catch (_oO) {
          return (self._previousEvent = currentEvent);
        }

        return (self._previousEvent = currentEvent);
      }
      return currentEvent;
    };

    eventProcessor.id = this.name;
    addGlobalEventProcessor(eventProcessor);
  }
} Dedupe.__initStatic();

/** JSDoc */
function dedupe_shouldDropEvent(currentEvent, previousEvent) {
  if (!previousEvent) {
    return false;
  }

  if (_isSameMessageEvent(currentEvent, previousEvent)) {
    return true;
  }

  if (_isSameExceptionEvent(currentEvent, previousEvent)) {
    return true;
  }

  return false;
}

/** JSDoc */
function _isSameMessageEvent(currentEvent, previousEvent) {
  var currentMessage = currentEvent.message;
  var previousMessage = previousEvent.message;

  // If neither event has a message property, they were both exceptions, so bail out
  if (!currentMessage && !previousMessage) {
    return false;
  }

  // If only one event has a stacktrace, but not the other one, they are not the same
  if ((currentMessage && !previousMessage) || (!currentMessage && previousMessage)) {
    return false;
  }

  if (currentMessage !== previousMessage) {
    return false;
  }

  if (!_isSameFingerprint(currentEvent, previousEvent)) {
    return false;
  }

  if (!_isSameStacktrace(currentEvent, previousEvent)) {
    return false;
  }

  return true;
}

/** JSDoc */
function _isSameExceptionEvent(currentEvent, previousEvent) {
  var previousException = _getExceptionFromEvent(previousEvent);
  var currentException = _getExceptionFromEvent(currentEvent);

  if (!previousException || !currentException) {
    return false;
  }

  if (previousException.type !== currentException.type || previousException.value !== currentException.value) {
    return false;
  }

  if (!_isSameFingerprint(currentEvent, previousEvent)) {
    return false;
  }

  if (!_isSameStacktrace(currentEvent, previousEvent)) {
    return false;
  }

  return true;
}

/** JSDoc */
function _isSameStacktrace(currentEvent, previousEvent) {
  let currentFrames = _getFramesFromEvent(currentEvent);
  let previousFrames = _getFramesFromEvent(previousEvent);

  // If neither event has a stacktrace, they are assumed to be the same
  if (!currentFrames && !previousFrames) {
    return true;
  }

  // If only one event has a stacktrace, but not the other one, they are not the same
  if ((currentFrames && !previousFrames) || (!currentFrames && previousFrames)) {
    return false;
  }

  currentFrames = currentFrames ;
  previousFrames = previousFrames ;

  // If number of frames differ, they are not the same
  if (previousFrames.length !== currentFrames.length) {
    return false;
  }

  // Otherwise, compare the two
  for (let i = 0; i < previousFrames.length; i++) {
    var frameA = previousFrames[i];
    var frameB = currentFrames[i];

    if (
      frameA.filename !== frameB.filename ||
      frameA.lineno !== frameB.lineno ||
      frameA.colno !== frameB.colno ||
      frameA.function !== frameB.function
    ) {
      return false;
    }
  }

  return true;
}

/** JSDoc */
function _isSameFingerprint(currentEvent, previousEvent) {
  let currentFingerprint = currentEvent.fingerprint;
  let previousFingerprint = previousEvent.fingerprint;

  // If neither event has a fingerprint, they are assumed to be the same
  if (!currentFingerprint && !previousFingerprint) {
    return true;
  }

  // If only one event has a fingerprint, but not the other one, they are not the same
  if ((currentFingerprint && !previousFingerprint) || (!currentFingerprint && previousFingerprint)) {
    return false;
  }

  currentFingerprint = currentFingerprint ;
  previousFingerprint = previousFingerprint ;

  // Otherwise, compare the two
  try {
    return !!(currentFingerprint.join('') === previousFingerprint.join(''));
  } catch (_oO) {
    return false;
  }
}

/** JSDoc */
function _getExceptionFromEvent(event) {
  return event.exception && event.exception.values && event.exception.values[0];
}

/** JSDoc */
function _getFramesFromEvent(event) {
  var exception = event.exception;

  if (exception) {
    try {
      // @ts-ignore Object could be undefined
      return exception.values[0].stacktrace.frames;
    } catch (_oO) {
      return undefined;
    }
  }
  return undefined;
}


//# sourceMappingURL=dedupe.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/httpcontext.js



var httpcontext_global = (0,esm_global/* getGlobalObject */.R)();

/** HttpContext integration collects information about HTTP request headers */
class HttpContext  {constructor() { HttpContext.prototype.__init.call(this); }
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'HttpContext';}

  /**
   * @inheritDoc
   */
   __init() {this.name = HttpContext.id;}

  /**
   * @inheritDoc
   */
   setupOnce() {
    (0,esm_scope/* addGlobalEventProcessor */.c)((event) => {
      if ((0,esm_hub/* getCurrentHub */.Gd)().getIntegration(HttpContext)) {
        // if none of the information we want exists, don't bother
        if (!httpcontext_global.navigator && !httpcontext_global.location && !httpcontext_global.document) {
          return event;
        }

        // grab as much info as exists and add it to the event
        var url = (event.request && event.request.url) || (httpcontext_global.location && httpcontext_global.location.href);
        const { referrer } = httpcontext_global.document || {};
        const { userAgent } = httpcontext_global.navigator || {};

        var headers = {
          ...(event.request && event.request.headers),
          ...(referrer && { Referer: referrer }),
          ...(userAgent && { 'User-Agent': userAgent }),
        };
        var request = { ...(url && { url }), headers };

        return { ...event, request };
      }
      return event;
    });
  }
} HttpContext.__initStatic();


//# sourceMappingURL=httpcontext.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/promisebuffer.js



/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */
function makePromiseBuffer(limit) {
  var buffer = [];

  function isReady() {
    return limit === undefined || buffer.length < limit;
  }

  /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */
  function remove(task) {
    return buffer.splice(buffer.indexOf(task), 1)[0];
  }

  /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */
  function add(taskProducer) {
    if (!isReady()) {
      return (0,syncpromise/* rejectedSyncPromise */.$2)(new SentryError('Not adding Promise due to buffer limit reached.'));
    }

    // start the task and add its promise to the queue
    var task = taskProducer();
    if (buffer.indexOf(task) === -1) {
      buffer.push(task);
    }
    void task
      .then(() => remove(task))
      // Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
      // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
      // have promises, so TS has to polyfill when down-compiling.)
      .then(null, () =>
        remove(task).then(null, () => {
          // We have to add another catch here because `remove()` starts a new promise chain.
        }),
      );
    return task;
  }

  /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */
  function drain(timeout) {
    return new syncpromise/* SyncPromise */.cW((resolve, reject) => {
      let counter = buffer.length;

      if (!counter) {
        return resolve(true);
      }

      // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
      var capturedSetTimeout = setTimeout(() => {
        if (timeout && timeout > 0) {
          resolve(false);
        }
      }, timeout);

      // if all promises resolve in time, cancel the timer and resolve to `true`
      buffer.forEach(item => {
        void (0,syncpromise/* resolvedSyncPromise */.WD)(item).then(() => {
                    if (!--counter) {
            clearTimeout(capturedSetTimeout);
            resolve(true);
          }
        }, reject);
      });
    });
  }

  return {
    $: buffer,
    add,
    drain,
  };
}


//# sourceMappingURL=promisebuffer.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/ratelimit.js
// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend

var DEFAULT_RETRY_AFTER = 60 * 1000; // 60 seconds

/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */
function parseRetryAfterHeader(header, now = Date.now()) {
  var headerDelay = parseInt(`${header}`, 10);
  if (!isNaN(headerDelay)) {
    return headerDelay * 1000;
  }

  var headerDate = Date.parse(`${header}`);
  if (!isNaN(headerDate)) {
    return headerDate - now;
  }

  return DEFAULT_RETRY_AFTER;
}

/**
 * Gets the time that given category is disabled until for rate limiting
 */
function disabledUntil(limits, category) {
  return limits[category] || limits.all || 0;
}

/**
 * Checks if a category is rate limited
 */
function isRateLimited(limits, category, now = Date.now()) {
  return disabledUntil(limits, category) > now;
}

/**
 * Update ratelimits from incoming headers.
 * Returns true if headers contains a non-empty rate limiting header.
 */
function updateRateLimits(
  limits,
  { statusCode, headers },
  now = Date.now(),
) {
  var updatedRateLimits = {
    ...limits,
  };

  // "The name is case-insensitive."
  // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
  var rateLimitHeader = headers && headers['x-sentry-rate-limits'];
  var retryAfterHeader = headers && headers['retry-after'];

  if (rateLimitHeader) {
    /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     */
    for (var limit of rateLimitHeader.trim().split(',')) {
      const [retryAfter, categories] = limit.split(':', 2);
      var headerDelay = parseInt(retryAfter, 10);
      var delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
      if (!categories) {
        updatedRateLimits.all = now + delay;
      } else {
        for (var category of categories.split(';')) {
          updatedRateLimits[category] = now + delay;
        }
      }
    }
  } else if (retryAfterHeader) {
    updatedRateLimits.all = now + parseRetryAfterHeader(retryAfterHeader, now);
  } else if (statusCode === 429) {
    updatedRateLimits.all = now + 60 * 1000;
  }

  return updatedRateLimits;
}


//# sourceMappingURL=ratelimit.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/transports/base.js


var DEFAULT_TRANSPORT_BUFFER_SIZE = 30;

/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */
function createTransport(
  options,
  makeRequest,
  buffer = makePromiseBuffer(options.bufferSize || DEFAULT_TRANSPORT_BUFFER_SIZE),
) {
  let rateLimits = {};

  var flush = (timeout) => buffer.drain(timeout);

  function send(envelope) {
    var filteredEnvelopeItems = [];

    // Drop rate limited items from envelope
    forEachEnvelopeItem(envelope, (item, type) => {
      var envelopeItemDataCategory = envelopeItemTypeToDataCategory(type);
      if (isRateLimited(rateLimits, envelopeItemDataCategory)) {
        options.recordDroppedEvent('ratelimit_backoff', envelopeItemDataCategory);
      } else {
        filteredEnvelopeItems.push(item);
      }
    });

    // Skip sending if envelope is empty after filtering out rate limited events
    if (filteredEnvelopeItems.length === 0) {
      return (0,syncpromise/* resolvedSyncPromise */.WD)();
    }

        var filteredEnvelope = createEnvelope(envelope[0], filteredEnvelopeItems );

    // Creates client report for each item in an envelope
    var recordEnvelopeLoss = (reason) => {
      forEachEnvelopeItem(filteredEnvelope, (_, type) => {
        options.recordDroppedEvent(reason, envelopeItemTypeToDataCategory(type));
      });
    };

    var requestTask = () =>
      makeRequest({ body: serializeEnvelope(filteredEnvelope, options.textEncoder) }).then(
        response => {
          // We don't want to throw on NOK responses, but we want to at least log them
          if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
          }

          rateLimits = updateRateLimits(rateLimits, response);
        },
        error => {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error('Failed while sending event:', error);
          recordEnvelopeLoss('network_error');
        },
      );

    return buffer.add(requestTask).then(
      result => result,
      error => {
        if (error instanceof SentryError) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error('Skipped sending event due to full buffer');
          recordEnvelopeLoss('queue_overflow');
          return (0,syncpromise/* resolvedSyncPromise */.WD)();
        } else {
          throw error;
        }
      },
    );
  }

  return {
    send,
    flush,
  };
}


//# sourceMappingURL=base.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/transports/fetch.js



/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */
function makeFetchTransport(
  options,
  nativeFetch = getNativeFetchImplementation(),
) {
  function makeRequest(request) {
    var requestOptions = {
      body: request.body,
      method: 'POST',
      referrerPolicy: 'origin',
      headers: options.headers,
      ...options.fetchOptions,
    };

    return nativeFetch(options.url, requestOptions).then(response => ({
      statusCode: response.status,
      headers: {
        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
        'retry-after': response.headers.get('Retry-After'),
      },
    }));
  }

  return createTransport(options, makeRequest);
}


//# sourceMappingURL=fetch.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/transports/xhr.js



/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */
var XHR_READYSTATE_DONE = 4;

/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */
function makeXHRTransport(options) {
  function makeRequest(request) {
    return new syncpromise/* SyncPromise */.cW((resolve, reject) => {
      var xhr = new XMLHttpRequest();

      xhr.onerror = reject;

      xhr.onreadystatechange = () => {
        if (xhr.readyState === XHR_READYSTATE_DONE) {
          resolve({
            statusCode: xhr.status,
            headers: {
              'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
              'retry-after': xhr.getResponseHeader('Retry-After'),
            },
          });
        }
      };

      xhr.open('POST', options.url);

      for (var header in options.headers) {
        if (Object.prototype.hasOwnProperty.call(options.headers, header)) {
          xhr.setRequestHeader(header, options.headers[header]);
        }
      }

      xhr.send(request.body);
    });
  }

  return createTransport(options, makeRequest);
}


//# sourceMappingURL=xhr.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/sdk.js
















var defaultIntegrations = [
  new InboundFilters(),
  new FunctionToString(),
  new TryCatch(),
  new Breadcrumbs(),
  new GlobalHandlers(),
  new LinkedErrors(),
  new Dedupe(),
  new HttpContext(),
];

/**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */
function init(options = {}) {
  if (options.defaultIntegrations === undefined) {
    options.defaultIntegrations = defaultIntegrations;
  }
  if (options.release === undefined) {
    var window = (0,esm_global/* getGlobalObject */.R)();
    // This supports the variable that sentry-webpack-plugin injects
    if (window.SENTRY_RELEASE && window.SENTRY_RELEASE.id) {
      options.release = window.SENTRY_RELEASE.id;
    }
  }
  if (options.autoSessionTracking === undefined) {
    options.autoSessionTracking = true;
  }
  if (options.sendClientReports === undefined) {
    options.sendClientReports = true;
  }

  var clientOptions = {
    ...options,
    stackParser: (0,stacktrace/* stackParserFromStackParserOptions */.Sq)(options.stackParser || defaultStackParser),
    integrations: getIntegrationsToSetup(options),
    transport: options.transport || ((0,supports/* supportsFetch */.Ak)() ? makeFetchTransport : makeXHRTransport),
  };

  initAndBind(BrowserClient, clientOptions);

  if (options.autoSessionTracking) {
    startSessionTracking();
  }
}

/**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */
function showReportDialog(options = {}, hub = (0,esm_hub/* getCurrentHub */.Gd)()) {
  // doesn't work without a document (React Native)
  var global = (0,esm_global/* getGlobalObject */.R)();
  if (!global.document) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error('Global document not defined in showReportDialog call');
    return;
  }

  const { client, scope } = hub.getStackTop();
  var dsn = options.dsn || (client && client.getDsn());
  if (!dsn) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error('DSN not configured for showReportDialog call');
    return;
  }

  if (scope) {
    options.user = {
      ...scope.getUser(),
      ...options.user,
    };
  }

  if (!options.eventId) {
    options.eventId = hub.lastEventId();
  }

  var script = global.document.createElement('script');
  script.async = true;
  script.src = getReportDialogEndpoint(dsn, options);

  if (options.onLoad) {
        script.onload = options.onLoad;
  }

  var injectionPoint = global.document.head || global.document.body;
  if (injectionPoint) {
    injectionPoint.appendChild(script);
  } else {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error('Not injecting report dialog. No injection point found in HTML');
  }
}

/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */
function lastEventId() {
  return getCurrentHub().lastEventId();
}

/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function forceLoad() {
  // Noop
}

/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function onLoad(callback) {
  callback();
}

/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */
function flush(timeout) {
  var client = getCurrentHub().getClient();
  if (client) {
    return client.flush(timeout);
  }
  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn('Cannot flush events. No client defined.');
  return resolvedSyncPromise(false);
}

/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */
function sdk_close(timeout) {
  var client = getCurrentHub().getClient();
  if (client) {
    return client.close(timeout);
  }
  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn('Cannot flush events and disable SDK. No client defined.');
  return resolvedSyncPromise(false);
}

/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */
function sdk_wrap(fn) {
  return wrap$1(fn)();
}

function startSessionOnHub(hub) {
  hub.startSession({ ignoreDuration: true });
  hub.captureSession();
}

/**
 * Enable automatic Session Tracking for the initial page load.
 */
function startSessionTracking() {
  var window = (0,esm_global/* getGlobalObject */.R)();
  var document = window.document;

  if (typeof document === 'undefined') {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.warn */.kg.warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
    return;
  }

  var hub = (0,esm_hub/* getCurrentHub */.Gd)();

  // The only way for this to be false is for there to be a version mismatch between @sentry/browser (>= 6.0.0) and
  // @sentry/hub (< 5.27.0). In the simple case, there won't ever be such a mismatch, because the two packages are
  // pinned at the same version in package.json, but there are edge cases where it's possible. See
  // https://github.com/getsentry/sentry-javascript/issues/3207 and
  // https://github.com/getsentry/sentry-javascript/issues/3234 and
  // https://github.com/getsentry/sentry-javascript/issues/3278.
  if (!hub.captureSession) {
    return;
  }

  // The session duration for browser sessions does not track a meaningful
  // concept that can be used as a metric.
  // Automatically captured sessions are akin to page views, and thus we
  // discard their duration.
  startSessionOnHub(hub);

  // We want to create a session for every navigation as well
  (0,instrument/* addInstrumentationHandler */.o)('history', ({ from, to }) => {
    // Don't create an additional session for the initial route or if the location did not change
    if (!(from === undefined || from === to)) {
      startSessionOnHub((0,esm_hub/* getCurrentHub */.Gd)());
    }
  });
}


//# sourceMappingURL=sdk.js.map


/***/ }),

/***/ 40105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ SDK_VERSION; }
/* harmony export */ });
var SDK_VERSION = '7.7.0';


//# sourceMappingURL=version.js.map


/***/ }),

/***/ 92876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$e": function() { return /* binding */ withScope; },
/* harmony export */   "Tb": function() { return /* binding */ captureException; },
/* harmony export */   "av": function() { return /* binding */ setUser; },
/* harmony export */   "e": function() { return /* binding */ configureScope; },
/* harmony export */   "eN": function() { return /* binding */ captureEvent; }
/* harmony export */ });
/* unused harmony exports addBreadcrumb, captureMessage, setContext, setExtra, setExtras, setTag, setTags, startTransaction */
/* harmony import */ var _hub_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38641);


// Note: All functions in this file are typed with a return value of `ReturnType<Hub[HUB_FUNCTION]>`,
// where HUB_FUNCTION is some method on the Hub class.
//
// This is done to make sure the top level SDK methods stay in sync with the hub methods.
// Although every method here has an explicit return type, some of them (that map to void returns) do not
// contain `return` keywords. This is done to save on bundle size, as `return` is not minifiable.

/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception An exception-like object.
 * @param captureContext Additional scope data to apply to exception event.
 * @returns The generated eventId.
 */
function captureException(exception, captureContext) {
  return (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().captureException(exception, { captureContext });
}

/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param Severity Define the level of the message.
 * @returns The generated eventId.
 */
function captureMessage(
  message,
    captureContext,
) {
  // This is necessary to provide explicit scopes upgrade, without changing the original
  // arity of the `captureMessage(message, level)` method.
  var level = typeof captureContext === 'string' ? captureContext : undefined;
  var context = typeof captureContext !== 'string' ? { captureContext } : undefined;
  return getCurrentHub().captureMessage(message, level, context);
}

/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @returns The generated eventId.
 */
function captureEvent(event, hint) {
  return (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().captureEvent(event, hint);
}

/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 */
function configureScope(callback) {
  (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().configureScope(callback);
}

/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */
function addBreadcrumb(breadcrumb) {
  getCurrentHub().addBreadcrumb(breadcrumb);
}

/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */
function setContext(name, context) {
  getCurrentHub().setContext(name, context);
}

/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */
function setExtras(extras) {
  getCurrentHub().setExtras(extras);
}

/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */
function setExtra(key, extra) {
  getCurrentHub().setExtra(key, extra);
}

/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */
function setTags(tags) {
  getCurrentHub().setTags(tags);
}

/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */
function setTag(key, value) {
  getCurrentHub().setTag(key, value);
}

/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */
function setUser(user) {
  (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().setUser(user);
}

/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 *
 * @param callback that will be enclosed into push/popScope.
 */
function withScope(callback) {
  (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().withScope(callback);
}

/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.finish()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 */
function startTransaction(
  context,
  customSamplingContext,
) {
  return getCurrentHub().startTransaction(
    {
      metadata: { source: 'custom' },
      ...context,
    },
    customSamplingContext,
  );
}


//# sourceMappingURL=exports.js.map


/***/ }),

/***/ 38641:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gd": function() { return /* binding */ getCurrentHub; },
/* harmony export */   "cu": function() { return /* binding */ getMainCarrier; }
/* harmony export */ });
/* unused harmony exports API_VERSION, Hub, getHubFromCarrier, makeMain, setHubOnCarrier */
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62844);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21170);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12343);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82991);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92448);
/* harmony import */ var _scope_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46769);
/* harmony import */ var _session_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95771);




/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */
var API_VERSION = 4;

/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */
var DEFAULT_BREADCRUMBS = 100;

/**
 * A layer in the process stack.
 * @hidden
 */

/**
 * @inheritDoc
 */
class Hub  {
  /** Is a {@link Layer}[] containing the client and scope */
    __init() {this._stack = [{}];}

  /** Contains the last event id of a captured event.  */
  

  /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   */
   constructor(client, scope = new _scope_js__WEBPACK_IMPORTED_MODULE_0__/* .Scope */ .s(),   _version = API_VERSION) {;this._version = _version;Hub.prototype.__init.call(this);
    this.getStackTop().scope = scope;
    if (client) {
      this.bindClient(client);
    }
  }

  /**
   * @inheritDoc
   */
   isOlderThan(version) {
    return this._version < version;
  }

  /**
   * @inheritDoc
   */
   bindClient(client) {
    var top = this.getStackTop();
    top.client = client;
    if (client && client.setupIntegrations) {
      client.setupIntegrations();
    }
  }

  /**
   * @inheritDoc
   */
   pushScope() {
    // We want to clone the content of prev scope
    var scope = _scope_js__WEBPACK_IMPORTED_MODULE_0__/* .Scope.clone */ .s.clone(this.getScope());
    this.getStack().push({
      client: this.getClient(),
      scope,
    });
    return scope;
  }

  /**
   * @inheritDoc
   */
   popScope() {
    if (this.getStack().length <= 1) return false;
    return !!this.getStack().pop();
  }

  /**
   * @inheritDoc
   */
   withScope(callback) {
    var scope = this.pushScope();
    try {
      callback(scope);
    } finally {
      this.popScope();
    }
  }

  /**
   * @inheritDoc
   */
   getClient() {
    return this.getStackTop().client ;
  }

  /** Returns the scope of the top stack. */
   getScope() {
    return this.getStackTop().scope;
  }

  /** Returns the scope stack for domains or the process. */
   getStack() {
    return this._stack;
  }

  /** Returns the topmost scope layer in the order domain > local > process. */
   getStackTop() {
    return this._stack[this._stack.length - 1];
  }

  /**
   * @inheritDoc
   */
     captureException(exception, hint) {
    var eventId = (this._lastEventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)());
    var syntheticException = new Error('Sentry syntheticException');
    this._withClient((client, scope) => {
      client.captureException(
        exception,
        {
          originalException: exception,
          syntheticException,
          ...hint,
          event_id: eventId,
        },
        scope,
      );
    });
    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureMessage(
    message,
        level,
    hint,
  ) {
    var eventId = (this._lastEventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)());
    var syntheticException = new Error(message);
    this._withClient((client, scope) => {
      client.captureMessage(
        message,
        level,
        {
          originalException: message,
          syntheticException,
          ...hint,
          event_id: eventId,
        },
        scope,
      );
    });
    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureEvent(event, hint) {
    var eventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)();
    if (event.type !== 'transaction') {
      this._lastEventId = eventId;
    }

    this._withClient((client, scope) => {
      client.captureEvent(event, { ...hint, event_id: eventId }, scope);
    });
    return eventId;
  }

  /**
   * @inheritDoc
   */
   lastEventId() {
    return this._lastEventId;
  }

  /**
   * @inheritDoc
   */
   addBreadcrumb(breadcrumb, hint) {
    const { scope, client } = this.getStackTop();

    if (!scope || !client) return;

        const { beforeBreadcrumb = null, maxBreadcrumbs = DEFAULT_BREADCRUMBS } =
      (client.getOptions && client.getOptions()) || {};

    if (maxBreadcrumbs <= 0) return;

    var timestamp = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .dateTimestampInSeconds */ .yW)();
    var mergedBreadcrumb = { timestamp, ...breadcrumb };
    var finalBreadcrumb = beforeBreadcrumb
      ? ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .consoleSandbox */ .Cf)(() => beforeBreadcrumb(mergedBreadcrumb, hint)) )
      : mergedBreadcrumb;

    if (finalBreadcrumb === null) return;

    scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
  }

  /**
   * @inheritDoc
   */
   setUser(user) {
    var scope = this.getScope();
    if (scope) scope.setUser(user);
  }

  /**
   * @inheritDoc
   */
   setTags(tags) {
    var scope = this.getScope();
    if (scope) scope.setTags(tags);
  }

  /**
   * @inheritDoc
   */
   setExtras(extras) {
    var scope = this.getScope();
    if (scope) scope.setExtras(extras);
  }

  /**
   * @inheritDoc
   */
   setTag(key, value) {
    var scope = this.getScope();
    if (scope) scope.setTag(key, value);
  }

  /**
   * @inheritDoc
   */
   setExtra(key, extra) {
    var scope = this.getScope();
    if (scope) scope.setExtra(key, extra);
  }

  /**
   * @inheritDoc
   */
     setContext(name, context) {
    var scope = this.getScope();
    if (scope) scope.setContext(name, context);
  }

  /**
   * @inheritDoc
   */
   configureScope(callback) {
    const { scope, client } = this.getStackTop();
    if (scope && client) {
      callback(scope);
    }
  }

  /**
   * @inheritDoc
   */
   run(callback) {
    var oldHub = makeMain(this);
    try {
      callback(this);
    } finally {
      makeMain(oldHub);
    }
  }

  /**
   * @inheritDoc
   */
   getIntegration(integration) {
    var client = this.getClient();
    if (!client) return null;
    try {
      return client.getIntegration(integration);
    } catch (_oO) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.warn */ .kg.warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
      return null;
    }
  }

  /**
   * @inheritDoc
   */
   startTransaction(context, customSamplingContext) {
    return this._callExtensionMethod('startTransaction', context, customSamplingContext);
  }

  /**
   * @inheritDoc
   */
   traceHeaders() {
    return this._callExtensionMethod('traceHeaders');
  }

  /**
   * @inheritDoc
   */
   captureSession(endSession = false) {
    // both send the update and pull the session from the scope
    if (endSession) {
      return this.endSession();
    }

    // only send the update
    this._sendSessionUpdate();
  }

  /**
   * @inheritDoc
   */
   endSession() {
    var layer = this.getStackTop();
    var scope = layer && layer.scope;
    var session = scope && scope.getSession();
    if (session) {
      (0,_session_js__WEBPACK_IMPORTED_MODULE_4__/* .closeSession */ .RJ)(session);
    }
    this._sendSessionUpdate();

    // the session is over; take it off of the scope
    if (scope) {
      scope.setSession();
    }
  }

  /**
   * @inheritDoc
   */
   startSession(context) {
    const { scope, client } = this.getStackTop();
    const { release, environment } = (client && client.getOptions()) || {};

    // Will fetch userAgent if called from browser sdk
    var global = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .getGlobalObject */ .R)();
    const { userAgent } = global.navigator || {};

    var session = (0,_session_js__WEBPACK_IMPORTED_MODULE_4__/* .makeSession */ .Hv)({
      release,
      environment,
      ...(scope && { user: scope.getUser() }),
      ...(userAgent && { userAgent }),
      ...context,
    });

    if (scope) {
      // End existing session if there's one
      var currentSession = scope.getSession && scope.getSession();
      if (currentSession && currentSession.status === 'ok') {
        (0,_session_js__WEBPACK_IMPORTED_MODULE_4__/* .updateSession */ .CT)(currentSession, { status: 'exited' });
      }
      this.endSession();

      // Afterwards we set the new session on the scope
      scope.setSession(session);
    }

    return session;
  }

  /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   */
   shouldSendDefaultPii() {
    var client = this.getClient();
    var options = client && client.getOptions();
    return Boolean(options && options.sendDefaultPii);
  }

  /**
   * Sends the current Session on the scope
   */
   _sendSessionUpdate() {
    const { scope, client } = this.getStackTop();
    if (!scope) return;

    var session = scope.getSession();
    if (session) {
      if (client && client.captureSession) {
        client.captureSession(session);
      }
    }
  }

  /**
   * Internal helper function to call a method on the top client if it exists.
   *
   * @param method The method to call on the client.
   * @param args Arguments to pass to the client function.
   */
   _withClient(callback) {
    const { scope, client } = this.getStackTop();
    if (client) {
      callback(client, scope);
    }
  }

  /**
   * Calls global extension method and binding current instance to the function call
   */
  // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
     _callExtensionMethod(method, ...args) {
    var carrier = getMainCarrier();
    var sentry = carrier.__SENTRY__;
    if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') {
      return sentry.extensions[method].apply(this, args);
    }
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.warn */ .kg.warn(`Extension method ${method} couldn't be found, doing nothing.`);
  }
}

/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/
function getMainCarrier() {
  var carrier = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .getGlobalObject */ .R)();
  carrier.__SENTRY__ = carrier.__SENTRY__ || {
    extensions: {},
    hub: undefined,
  };
  return carrier;
}

/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 */
function makeMain(hub) {
  var registry = getMainCarrier();
  var oldHub = getHubFromCarrier(registry);
  setHubOnCarrier(registry, hub);
  return oldHub;
}

/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 */
function getCurrentHub() {
  // Get main carrier (global for every environment)
  var registry = getMainCarrier();

  // If there's no hub, or its an old API, assign a new one
  if (!hasHubOnCarrier(registry) || getHubFromCarrier(registry).isOlderThan(API_VERSION)) {
    setHubOnCarrier(registry, new Hub());
  }

  // Prefer domains over global if they are there (applicable only to Node environment)
  if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .isNodeEnv */ .KV)()) {
    return getHubFromActiveDomain(registry);
  }
  // Return hub that lives on a global object
  return getHubFromCarrier(registry);
}

/**
 * Try to read the hub from an active domain, and fallback to the registry if one doesn't exist
 * @returns discovered hub
 */
function getHubFromActiveDomain(registry) {
  try {
    var sentry = getMainCarrier().__SENTRY__;
    var activeDomain = sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;

    // If there's no active domain, just return global hub
    if (!activeDomain) {
      return getHubFromCarrier(registry);
    }

    // If there's no hub on current domain, or it's an old API, assign a new one
    if (!hasHubOnCarrier(activeDomain) || getHubFromCarrier(activeDomain).isOlderThan(API_VERSION)) {
      var registryHubTopStack = getHubFromCarrier(registry).getStackTop();
      setHubOnCarrier(activeDomain, new Hub(registryHubTopStack.client, _scope_js__WEBPACK_IMPORTED_MODULE_0__/* .Scope.clone */ .s.clone(registryHubTopStack.scope)));
    }

    // Return hub that lives on a domain
    return getHubFromCarrier(activeDomain);
  } catch (_Oo) {
    // Return hub that lives on a global object
    return getHubFromCarrier(registry);
  }
}

/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */
function hasHubOnCarrier(carrier) {
  return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}

/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */
function getHubFromCarrier(carrier) {
  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .getGlobalSingleton */ .Y)('hub', () => new Hub(), carrier);
}

/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */
function setHubOnCarrier(carrier, hub) {
  if (!carrier) return false;
  var __SENTRY__ = (carrier.__SENTRY__ = carrier.__SENTRY__ || {});
  __SENTRY__.hub = hub;
  return true;
}


//# sourceMappingURL=hub.js.map


/***/ }),

/***/ 46769:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ addGlobalEventProcessor; },
/* harmony export */   "s": function() { return /* binding */ Scope; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67597);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21170);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96893);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12343);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82991);
/* harmony import */ var _session_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95771);



/**
 * Absolute maximum number of breadcrumbs added to an event.
 * The `maxBreadcrumbs` option cannot be higher than this value.
 */
var MAX_BREADCRUMBS = 100;

/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */
class Scope  {
  /** Flag if notifying is happening. */
  

  /** Callback for client to receive scope changes. */
  

  /** Callback list that will be called after {@link applyToEvent}. */
  

  /** Array of breadcrumbs. */
  

  /** User */
  

  /** Tags */
  

  /** Extra */
  

  /** Contexts */
  

  /** Attachments */
  

  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */
  

  /** Fingerprint */
  

  /** Severity */
    

  /** Transaction Name */
  

  /** Span */
  

  /** Session */
  

  /** Request Mode Session Status */
  

   constructor() {
    this._notifyingListeners = false;
    this._scopeListeners = [];
    this._eventProcessors = [];
    this._breadcrumbs = [];
    this._attachments = [];
    this._user = {};
    this._tags = {};
    this._extra = {};
    this._contexts = {};
    this._sdkProcessingMetadata = {};
  }

  /**
   * Inherit values from the parent scope.
   * @param scope to clone.
   */
   static clone(scope) {
    var newScope = new Scope();
    if (scope) {
      newScope._breadcrumbs = [...scope._breadcrumbs];
      newScope._tags = { ...scope._tags };
      newScope._extra = { ...scope._extra };
      newScope._contexts = { ...scope._contexts };
      newScope._user = scope._user;
      newScope._level = scope._level;
      newScope._span = scope._span;
      newScope._session = scope._session;
      newScope._transactionName = scope._transactionName;
      newScope._fingerprint = scope._fingerprint;
      newScope._eventProcessors = [...scope._eventProcessors];
      newScope._requestSession = scope._requestSession;
      newScope._attachments = [...scope._attachments];
    }
    return newScope;
  }

  /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */
   addScopeListener(callback) {
    this._scopeListeners.push(callback);
  }

  /**
   * @inheritDoc
   */
   addEventProcessor(callback) {
    this._eventProcessors.push(callback);
    return this;
  }

  /**
   * @inheritDoc
   */
   setUser(user) {
    this._user = user || {};
    if (this._session) {
      (0,_session_js__WEBPACK_IMPORTED_MODULE_0__/* .updateSession */ .CT)(this._session, { user });
    }
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   getUser() {
    return this._user;
  }

  /**
   * @inheritDoc
   */
   getRequestSession() {
    return this._requestSession;
  }

  /**
   * @inheritDoc
   */
   setRequestSession(requestSession) {
    this._requestSession = requestSession;
    return this;
  }

  /**
   * @inheritDoc
   */
   setTags(tags) {
    this._tags = {
      ...this._tags,
      ...tags,
    };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setTag(key, value) {
    this._tags = { ...this._tags, [key]: value };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setExtras(extras) {
    this._extra = {
      ...this._extra,
      ...extras,
    };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setExtra(key, extra) {
    this._extra = { ...this._extra, [key]: extra };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setFingerprint(fingerprint) {
    this._fingerprint = fingerprint;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setLevel(
        level,
  ) {
    this._level = level;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setTransactionName(name) {
    this._transactionName = name;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setContext(key, context) {
    if (context === null) {
            delete this._contexts[key];
    } else {
      this._contexts = { ...this._contexts, [key]: context };
    }

    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setSpan(span) {
    this._span = span;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   getSpan() {
    return this._span;
  }

  /**
   * @inheritDoc
   */
   getTransaction() {
    // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
    // have a pointer to the currently-active transaction.
    var span = this.getSpan();
    return span && span.transaction;
  }

  /**
   * @inheritDoc
   */
   setSession(session) {
    if (!session) {
      delete this._session;
    } else {
      this._session = session;
    }
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   getSession() {
    return this._session;
  }

  /**
   * @inheritDoc
   */
   update(captureContext) {
    if (!captureContext) {
      return this;
    }

    if (typeof captureContext === 'function') {
      var updatedScope = (captureContext )(this);
      return updatedScope instanceof Scope ? updatedScope : this;
    }

    if (captureContext instanceof Scope) {
      this._tags = { ...this._tags, ...captureContext._tags };
      this._extra = { ...this._extra, ...captureContext._extra };
      this._contexts = { ...this._contexts, ...captureContext._contexts };
      if (captureContext._user && Object.keys(captureContext._user).length) {
        this._user = captureContext._user;
      }
      if (captureContext._level) {
        this._level = captureContext._level;
      }
      if (captureContext._fingerprint) {
        this._fingerprint = captureContext._fingerprint;
      }
      if (captureContext._requestSession) {
        this._requestSession = captureContext._requestSession;
      }
    } else if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isPlainObject */ .PO)(captureContext)) {
            captureContext = captureContext ;
      this._tags = { ...this._tags, ...captureContext.tags };
      this._extra = { ...this._extra, ...captureContext.extra };
      this._contexts = { ...this._contexts, ...captureContext.contexts };
      if (captureContext.user) {
        this._user = captureContext.user;
      }
      if (captureContext.level) {
        this._level = captureContext.level;
      }
      if (captureContext.fingerprint) {
        this._fingerprint = captureContext.fingerprint;
      }
      if (captureContext.requestSession) {
        this._requestSession = captureContext.requestSession;
      }
    }

    return this;
  }

  /**
   * @inheritDoc
   */
   clear() {
    this._breadcrumbs = [];
    this._tags = {};
    this._extra = {};
    this._user = {};
    this._contexts = {};
    this._level = undefined;
    this._transactionName = undefined;
    this._fingerprint = undefined;
    this._requestSession = undefined;
    this._span = undefined;
    this._session = undefined;
    this._notifyScopeListeners();
    this._attachments = [];
    return this;
  }

  /**
   * @inheritDoc
   */
   addBreadcrumb(breadcrumb, maxBreadcrumbs) {
    var maxCrumbs = typeof maxBreadcrumbs === 'number' ? Math.min(maxBreadcrumbs, MAX_BREADCRUMBS) : MAX_BREADCRUMBS;

    // No data has been changed, so don't notify scope listeners
    if (maxCrumbs <= 0) {
      return this;
    }

    var mergedBreadcrumb = {
      timestamp: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .dateTimestampInSeconds */ .yW)(),
      ...breadcrumb,
    };
    this._breadcrumbs = [...this._breadcrumbs, mergedBreadcrumb].slice(-maxCrumbs);
    this._notifyScopeListeners();

    return this;
  }

  /**
   * @inheritDoc
   */
   clearBreadcrumbs() {
    this._breadcrumbs = [];
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   addAttachment(attachment) {
    this._attachments.push(attachment);
    return this;
  }

  /**
   * @inheritDoc
   */
   getAttachments() {
    return this._attachments;
  }

  /**
   * @inheritDoc
   */
   clearAttachments() {
    this._attachments = [];
    return this;
  }

  /**
   * Applies the current context and fingerprint to the event.
   * Note that breadcrumbs will be added by the client.
   * Also if the event has already breadcrumbs on it, we do not merge them.
   * @param event Event
   * @param hint May contain additional information about the original exception.
   * @hidden
   */
   applyToEvent(event, hint = {}) {
    if (this._extra && Object.keys(this._extra).length) {
      event.extra = { ...this._extra, ...event.extra };
    }
    if (this._tags && Object.keys(this._tags).length) {
      event.tags = { ...this._tags, ...event.tags };
    }
    if (this._user && Object.keys(this._user).length) {
      event.user = { ...this._user, ...event.user };
    }
    if (this._contexts && Object.keys(this._contexts).length) {
      event.contexts = { ...this._contexts, ...event.contexts };
    }
    if (this._level) {
      event.level = this._level;
    }
    if (this._transactionName) {
      event.transaction = this._transactionName;
    }

    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (this._span) {
      event.contexts = { trace: this._span.getTraceContext(), ...event.contexts };
      var transactionName = this._span.transaction && this._span.transaction.name;
      if (transactionName) {
        event.tags = { transaction: transactionName, ...event.tags };
      }
    }

    this._applyFingerprint(event);

    event.breadcrumbs = [...(event.breadcrumbs || []), ...this._breadcrumbs];
    event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;

    event.sdkProcessingMetadata = { ...event.sdkProcessingMetadata, ...this._sdkProcessingMetadata };

    return this._notifyEventProcessors([...getGlobalEventProcessors(), ...this._eventProcessors], event, hint);
  }

  /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */
   setSDKProcessingMetadata(newData) {
    this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...newData };

    return this;
  }

  /**
   * This will be called after {@link applyToEvent} is finished.
   */
   _notifyEventProcessors(
    processors,
    event,
    hint,
    index = 0,
  ) {
    return new _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .SyncPromise */ .cW((resolve, reject) => {
      var processor = processors[index];
      if (event === null || typeof processor !== 'function') {
        resolve(event);
      } else {
        var result = processor({ ...event }, hint) ;

        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
          processor.id &&
          result === null &&
          _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log(`Event processor "${processor.id}" dropped event`);

        if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isThenable */ .J8)(result)) {
          void result
            .then(final => this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve))
            .then(null, reject);
        } else {
          void this._notifyEventProcessors(processors, result, hint, index + 1)
            .then(resolve)
            .then(null, reject);
        }
      }
    });
  }

  /**
   * This will be called on every set call.
   */
   _notifyScopeListeners() {
    // We need this check for this._notifyingListeners to be able to work on scope during updates
    // If this check is not here we'll produce endless recursion when something is done with the scope
    // during the callback.
    if (!this._notifyingListeners) {
      this._notifyingListeners = true;
      this._scopeListeners.forEach(callback => {
        callback(this);
      });
      this._notifyingListeners = false;
    }
  }

  /**
   * Applies fingerprint from the scope to the event if there's one,
   * uses message if there's one instead or get rid of empty fingerprint
   */
   _applyFingerprint(event) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint
      ? Array.isArray(event.fingerprint)
        ? event.fingerprint
        : [event.fingerprint]
      : [];

    // If we have something on the scope, then merge it with event
    if (this._fingerprint) {
      event.fingerprint = event.fingerprint.concat(this._fingerprint);
    }

    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) {
      delete event.fingerprint;
    }
  }
}

/**
 * Returns the global event processors.
 */
function getGlobalEventProcessors() {
  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .getGlobalSingleton */ .Y)('globalEventProcessors', () => []);
}

/**
 * Add a EventProcessor to be kept globally.
 * @param callback EventProcessor to add
 */
function addGlobalEventProcessor(callback) {
  getGlobalEventProcessors().push(callback);
}


//# sourceMappingURL=scope.js.map


/***/ }),

/***/ 95771:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CT": function() { return /* binding */ updateSession; },
/* harmony export */   "Hv": function() { return /* binding */ makeSession; },
/* harmony export */   "RJ": function() { return /* binding */ closeSession; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21170);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62844);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20535);


/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */
function makeSession(context) {
  // Both timestamp and started are in seconds since the UNIX epoch.
  var startingTime = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .timestampInSeconds */ .ph)();

  var session = {
    sid: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)(),
    init: true,
    timestamp: startingTime,
    started: startingTime,
    duration: 0,
    status: 'ok',
    errors: 0,
    ignoreDuration: false,
    toJSON: () => sessionToJSON(session),
  };

  if (context) {
    updateSession(session, context);
  }

  return session;
}

/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */
function updateSession(session, context = {}) {
  if (context.user) {
    if (!session.ipAddress && context.user.ip_address) {
      session.ipAddress = context.user.ip_address;
    }

    if (!session.did && !context.did) {
      session.did = context.user.id || context.user.email || context.user.username;
    }
  }

  session.timestamp = context.timestamp || (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .timestampInSeconds */ .ph)();

  if (context.ignoreDuration) {
    session.ignoreDuration = context.ignoreDuration;
  }
  if (context.sid) {
    // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)();
  }
  if (context.init !== undefined) {
    session.init = context.init;
  }
  if (!session.did && context.did) {
    session.did = `${context.did}`;
  }
  if (typeof context.started === 'number') {
    session.started = context.started;
  }
  if (session.ignoreDuration) {
    session.duration = undefined;
  } else if (typeof context.duration === 'number') {
    session.duration = context.duration;
  } else {
    var duration = session.timestamp - session.started;
    session.duration = duration >= 0 ? duration : 0;
  }
  if (context.release) {
    session.release = context.release;
  }
  if (context.environment) {
    session.environment = context.environment;
  }
  if (!session.ipAddress && context.ipAddress) {
    session.ipAddress = context.ipAddress;
  }
  if (!session.userAgent && context.userAgent) {
    session.userAgent = context.userAgent;
  }
  if (typeof context.errors === 'number') {
    session.errors = context.errors;
  }
  if (context.status) {
    session.status = context.status;
  }
}

/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */
function closeSession(session, status) {
  let context = {};
  if (status) {
    context = { status };
  } else if (session.status === 'ok') {
    context = { status: 'exited' };
  }

  updateSession(session, context);
}

/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */
function sessionToJSON(session) {
  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .dropUndefinedKeys */ .Jr)({
    sid: `${session.sid}`,
    init: session.init,
    // Make sure that sec is converted to ms for date constructor
    started: new Date(session.started * 1000).toISOString(),
    timestamp: new Date(session.timestamp * 1000).toISOString(),
    status: session.status,
    errors: session.errors,
    did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
    duration: session.duration,
    attrs: {
      release: session.release,
      environment: session.environment,
      ip_address: session.ipAddress,
      user_agent: session.userAgent,
    },
  });
}


//# sourceMappingURL=session.js.map


/***/ }),

/***/ 24975:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SV": function() { return /* binding */ ErrorBoundary; }
/* harmony export */ });
/* unused harmony exports UNKNOWN_COMPONENT, isAtLeastReact17, withErrorBoundary */
/* harmony import */ var _sentry_browser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92876);
/* harmony import */ var _sentry_browser__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19985);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12343);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8679);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);





var _jsxFileName = "/home/runner/work/sentry-javascript/sentry-javascript/packages/react/src/errorboundary.tsx";
function isAtLeastReact17(version) {
  var major = version.match(/^([^.]+)/);
  return major !== null && parseInt(major[0]) >= 17;
}

var UNKNOWN_COMPONENT = 'unknown';

var INITIAL_STATE = {
  componentStack: null,
  error: null,
  eventId: null,
};

/**
 * A ErrorBoundary component that logs errors to Sentry. Requires React >= 16.
 * NOTE: If you are a Sentry user, and you are seeing this stack frame, it means the
 * Sentry React SDK ErrorBoundary caught an error invoking your application code. This
 * is expected behavior and NOT indicative of a bug with the Sentry React SDK.
 */
class ErrorBoundary extends react__WEBPACK_IMPORTED_MODULE_1__.Component {constructor(...args) { super(...args); ErrorBoundary.prototype.__init.call(this);ErrorBoundary.prototype.__init2.call(this); }
   __init() {this.state = INITIAL_STATE;}

   componentDidCatch(error, { componentStack }) {
    const { beforeCapture, onError, showDialog, dialogOptions } = this.props;

    (0,_sentry_browser__WEBPACK_IMPORTED_MODULE_2__/* .withScope */ .$e)(scope => {
      // If on React version >= 17, create stack trace from componentStack param and links
      // to to the original error using `error.cause` otherwise relies on error param for stacktrace.
      // Linking errors requires the `LinkedErrors` integration be enabled.
      if (isAtLeastReact17(react__WEBPACK_IMPORTED_MODULE_1__.version)) {
        var errorBoundaryError = new Error(error.message);
        errorBoundaryError.name = `React ErrorBoundary ${errorBoundaryError.name}`;
        errorBoundaryError.stack = componentStack;

        // Using the `LinkedErrors` integration to link the errors together.
        error.cause = errorBoundaryError;
      }

      if (beforeCapture) {
        beforeCapture(scope, error, componentStack);
      }
      var eventId = (0,_sentry_browser__WEBPACK_IMPORTED_MODULE_2__/* .captureException */ .Tb)(error, { contexts: { react: { componentStack } } });
      if (onError) {
        onError(error, componentStack, eventId);
      }
      if (showDialog) {
        (0,_sentry_browser__WEBPACK_IMPORTED_MODULE_3__/* .showReportDialog */ .jp)({ ...dialogOptions, eventId });
      }

      // componentDidCatch is used over getDerivedStateFromError
      // so that componentStack is accessible through state.
      this.setState({ error, componentStack, eventId });
    });
  }

   componentDidMount() {
    const { onMount } = this.props;
    if (onMount) {
      onMount();
    }
  }

   componentWillUnmount() {
    const { error, componentStack, eventId } = this.state;
    const { onUnmount } = this.props;
    if (onUnmount) {
      onUnmount(error, componentStack, eventId);
    }
  }

   __init2() {this.resetErrorBoundary = () => {
    const { onReset } = this.props;
    const { error, componentStack, eventId } = this.state;
    if (onReset) {
      onReset(error, componentStack, eventId);
    }
    this.setState(INITIAL_STATE);
  };}

   render() {
    const { fallback, children } = this.props;
    const { error, componentStack, eventId } = this.state;

    if (error) {
      let element = undefined;
      if (typeof fallback === 'function') {
        element = fallback({ error, componentStack, resetError: this.resetErrorBoundary, eventId });
      } else {
        element = fallback;
      }

      if (react__WEBPACK_IMPORTED_MODULE_1__.isValidElement(element)) {
        return element;
      }

      if (fallback) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.warn */ .kg.warn('fallback did not produce a valid ReactElement');
      }

      // Fail gracefully if no fallback provided or is not valid
      return null;
    }

    if (typeof children === 'function') {
      return (children )();
    }
    return children;
  }
}

function withErrorBoundary(
  WrappedComponent,
  errorBoundaryOptions,
) {
    var componentDisplayName = WrappedComponent.displayName || WrappedComponent.name || UNKNOWN_COMPONENT;

  var Wrapped = (props) => (
    React.createElement(ErrorBoundary, { ...errorBoundaryOptions, __self: this, __source: {fileName: _jsxFileName, lineNumber: 168}}
      , React.createElement(WrappedComponent, { ...props, __self: this, __source: {fileName: _jsxFileName, lineNumber: 169}} )
    )
  );

    Wrapped.displayName = `errorBoundary(${componentDisplayName})`;

  // Copy over static methods from Wrapped component to Profiler HOC
  // See: https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
  hoistNonReactStatics(Wrapped, WrappedComponent);
  return Wrapped;
}


//# sourceMappingURL=errorboundary.js.map


/***/ }),

/***/ 62758:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ro": function() { return /* binding */ addExtensionMethods; },
  "lb": function() { return /* binding */ startIdleTransaction; }
});

// UNUSED EXPORTS: _addTracingExtensions

// EXTERNAL MODULE: ./node_modules/@sentry/hub/esm/hub.js
var hub = __webpack_require__(38641);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/logger.js
var logger = __webpack_require__(12343);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(67597);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/node.js + 1 modules
var node = __webpack_require__(92448);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/instrument.js
var instrument = __webpack_require__(9732);
// EXTERNAL MODULE: ./node_modules/@sentry/tracing/esm/utils.js
var utils = __webpack_require__(63233);
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/errors.js



/**
 * Configures global error listeners
 */
function registerErrorInstrumentation() {
  (0,instrument/* addInstrumentationHandler */.o)('error', errorCallback);
  (0,instrument/* addInstrumentationHandler */.o)('unhandledrejection', errorCallback);
}

/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */
function errorCallback() {
  var activeTransaction = (0,utils/* getActiveTransaction */.x1)();
  if (activeTransaction) {
    var status = 'internal_error';
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log(`[Tracing] Transaction: ${status} -> Global error occured`);
    activeTransaction.setStatus(status);
  }
}


//# sourceMappingURL=errors.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/tracing/esm/idletransaction.js
var idletransaction = __webpack_require__(16458);
// EXTERNAL MODULE: ./node_modules/@sentry/tracing/esm/transaction.js
var esm_transaction = __webpack_require__(33391);
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/hubextensions.js
/* module decorator */ module = __webpack_require__.hmd(module);







/** Returns all trace headers that are currently on the top scope. */
function traceHeaders() {
  var scope = this.getScope();
  if (scope) {
    var span = scope.getSpan();
    if (span) {
      return {
        'sentry-trace': span.toTraceparent(),
      };
    }
  }
  return {};
}

/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * @param transaction: The transaction needing a sampling decision
 * @param options: The current client's options, so we can access `tracesSampleRate` and/or `tracesSampler`
 * @param samplingContext: Default and user-provided data which may be used to help make the decision
 *
 * @returns The given transaction with its `sampled` value set
 */
function sample(
  transaction,
  options,
  samplingContext,
) {
  // nothing to do if tracing is not enabled
  if (!(0,utils/* hasTracingEnabled */.zu)(options)) {
    transaction.sampled = false;
    return transaction;
  }

  // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
  if (transaction.sampled !== undefined) {
    transaction.setMetadata({
      transactionSampling: { method: 'explicitly_set' },
    });
    return transaction;
  }

  // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` were defined, so one of these should
  // work; prefer the hook if so
  let sampleRate;
  if (typeof options.tracesSampler === 'function') {
    sampleRate = options.tracesSampler(samplingContext);
    transaction.setMetadata({
      transactionSampling: {
        method: 'client_sampler',
        // cast to number in case it's a boolean
        rate: Number(sampleRate),
      },
    });
  } else if (samplingContext.parentSampled !== undefined) {
    sampleRate = samplingContext.parentSampled;
    transaction.setMetadata({
      transactionSampling: { method: 'inheritance' },
    });
  } else {
    sampleRate = options.tracesSampleRate;
    transaction.setMetadata({
      transactionSampling: {
        method: 'client_rate',
        // cast to number in case it's a boolean
        rate: Number(sampleRate),
      },
    });
  }

  // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
  // only valid values are booleans or numbers between 0 and 1.)
  if (!isValidSampleRate(sampleRate)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.warn */.kg.warn('[Tracing] Discarding transaction because of invalid sample rate.');
    transaction.sampled = false;
    return transaction;
  }

  // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
  if (!sampleRate) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.log */.kg.log(
        `[Tracing] Discarding transaction because ${
          typeof options.tracesSampler === 'function'
            ? 'tracesSampler returned 0 or false'
            : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'
        }`,
      );
    transaction.sampled = false;
    return transaction;
  }

  // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
  // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
  transaction.sampled = Math.random() < (sampleRate );

  // if we're not going to keep it, we're done
  if (!transaction.sampled) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.log */.kg.log(
        `[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(
          sampleRate,
        )})`,
      );
    return transaction;
  }

  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log(`[Tracing] starting ${transaction.op} transaction - ${transaction.name}`);
  return transaction;
}

/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */
function isValidSampleRate(rate) {
  // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    if ((0,is/* isNaN */.i2)(rate) || !(typeof rate === 'number' || typeof rate === 'boolean')) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.warn */.kg.warn(
        `[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(
          rate,
        )} of type ${JSON.stringify(typeof rate)}.`,
      );
    return false;
  }

  // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
  if (rate < 0 || rate > 1) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.warn */.kg.warn(`[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got ${rate}.`);
    return false;
  }
  return true;
}

/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */
function _startTransaction(
  
  transactionContext,
  customSamplingContext,
) {
  var client = this.getClient();
  var options = (client && client.getOptions()) || {};

  let transaction = new esm_transaction/* Transaction */.Y(transactionContext, this);
  transaction = sample(transaction, options, {
    parentSampled: transactionContext.parentSampled,
    transactionContext,
    ...customSamplingContext,
  });
  if (transaction.sampled) {
    transaction.initSpanRecorder(options._experiments && (options._experiments.maxSpans ));
  }
  return transaction;
}

/**
 * Create new idle transaction.
 */
function startIdleTransaction(
  hub,
  transactionContext,
  idleTimeout,
  finalTimeout,
  onScope,
  customSamplingContext,
) {
  var client = hub.getClient();
  var options = (client && client.getOptions()) || {};

  let transaction = new idletransaction/* IdleTransaction */.io(transactionContext, hub, idleTimeout, finalTimeout, onScope);
  transaction = sample(transaction, options, {
    parentSampled: transactionContext.parentSampled,
    transactionContext,
    ...customSamplingContext,
  });
  if (transaction.sampled) {
    transaction.initSpanRecorder(options._experiments && (options._experiments.maxSpans ));
  }
  return transaction;
}

/**
 * @private
 */
function _addTracingExtensions() {
  var carrier = (0,hub/* getMainCarrier */.cu)();
  if (!carrier.__SENTRY__) {
    return;
  }
  carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
  if (!carrier.__SENTRY__.extensions.startTransaction) {
    carrier.__SENTRY__.extensions.startTransaction = _startTransaction;
  }
  if (!carrier.__SENTRY__.extensions.traceHeaders) {
    carrier.__SENTRY__.extensions.traceHeaders = traceHeaders;
  }
}

/**
 * @private
 */
function _autoloadDatabaseIntegrations() {
  var carrier = (0,hub/* getMainCarrier */.cu)();
  if (!carrier.__SENTRY__) {
    return;
  }

  var packageToIntegrationMapping = {
    mongodb() {
      var integration = (0,node/* dynamicRequire */.l$)(module, './integrations/node/mongo') 

;
      return new integration.Mongo();
    },
    mongoose() {
      var integration = (0,node/* dynamicRequire */.l$)(module, './integrations/node/mongo') 

;
      return new integration.Mongo({ mongoose: true });
    },
    mysql() {
      var integration = (0,node/* dynamicRequire */.l$)(module, './integrations/node/mysql') 

;
      return new integration.Mysql();
    },
    pg() {
      var integration = (0,node/* dynamicRequire */.l$)(module, './integrations/node/postgres') 

;
      return new integration.Postgres();
    },
  };

  var mappedPackages = Object.keys(packageToIntegrationMapping)
    .filter(moduleName => !!(0,node/* loadModule */.$y)(moduleName))
    .map(pkg => {
      try {
        return packageToIntegrationMapping[pkg]();
      } catch (e) {
        return undefined;
      }
    })
    .filter(p => p) ;

  if (mappedPackages.length > 0) {
    carrier.__SENTRY__.integrations = [...(carrier.__SENTRY__.integrations || []), ...mappedPackages];
  }
}

/**
 * This patches the global object and injects the Tracing extensions methods
 */
function addExtensionMethods() {
  _addTracingExtensions();

  // Detect and automatically load specified integrations.
  if ((0,node/* isNodeEnv */.KV)()) {
    _autoloadDatabaseIntegrations();
  }

  // If an error happens globally, we should make sure transaction status is set to error.
  registerErrorInstrumentation();
}


//# sourceMappingURL=hubextensions.js.map


/***/ }),

/***/ 16458:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "io": function() { return /* binding */ IdleTransaction; },
/* harmony export */   "mg": function() { return /* binding */ DEFAULT_FINAL_TIMEOUT; },
/* harmony export */   "nT": function() { return /* binding */ DEFAULT_IDLE_TIMEOUT; }
/* harmony export */ });
/* unused harmony exports HEARTBEAT_INTERVAL, IdleTransactionSpanRecorder */
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21170);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12343);
/* harmony import */ var _span_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55334);
/* harmony import */ var _transaction_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33391);




var DEFAULT_IDLE_TIMEOUT = 1000;
var DEFAULT_FINAL_TIMEOUT = 30000;
var HEARTBEAT_INTERVAL = 5000;

/**
 * @inheritDoc
 */
class IdleTransactionSpanRecorder extends _span_js__WEBPACK_IMPORTED_MODULE_0__/* .SpanRecorder */ .gB {
   constructor(
      _pushActivity,
      _popActivity,
     transactionSpanId,
    maxlen,
  ) {
    super(maxlen);this._pushActivity = _pushActivity;this._popActivity = _popActivity;this.transactionSpanId = transactionSpanId;;
  }

  /**
   * @inheritDoc
   */
   add(span) {
    // We should make sure we do not push and pop activities for
    // the transaction that this span recorder belongs to.
    if (span.spanId !== this.transactionSpanId) {
      // We patch span.finish() to pop an activity after setting an endTimestamp.
      span.finish = (endTimestamp) => {
        span.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)();
        this._popActivity(span.spanId);
      };

      // We should only push new activities if the span does not have an end timestamp.
      if (span.endTimestamp === undefined) {
        this._pushActivity(span.spanId);
      }
    }

    super.add(span);
  }
}

/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */
class IdleTransaction extends _transaction_js__WEBPACK_IMPORTED_MODULE_2__/* .Transaction */ .Y {
  // Activities store a list of active spans
   __init() {this.activities = {};}

  // Track state of activities in previous heartbeat
  

  // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
   __init2() {this._heartbeatCounter = 0;}

  // We should not use heartbeat if we finished a transaction
   __init3() {this._finished = false;}

    __init4() {this._beforeFinishCallbacks = [];}

  /**
   * Timer that tracks Transaction idleTimeout
   */
  

   constructor(
    transactionContext,
      _idleHub,
    /**
     * The time to wait in ms until the idle transaction will be finished. This timer is started each time
     * there are no active spans on this transaction.
     */
      _idleTimeout = DEFAULT_IDLE_TIMEOUT,
    /**
     * The final value in ms that a transaction cannot exceed
     */
      _finalTimeout = DEFAULT_FINAL_TIMEOUT,
    // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
      _onScope = false,
  ) {
    super(transactionContext, _idleHub);this._idleHub = _idleHub;this._idleTimeout = _idleTimeout;this._finalTimeout = _finalTimeout;this._onScope = _onScope;IdleTransaction.prototype.__init.call(this);IdleTransaction.prototype.__init2.call(this);IdleTransaction.prototype.__init3.call(this);IdleTransaction.prototype.__init4.call(this);;

    if (_onScope) {
      // There should only be one active transaction on the scope
      clearActiveTransaction(_idleHub);

      // We set the transaction here on the scope so error events pick up the trace
      // context and attach it to the error.
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(`Setting idle transaction on scope. Span ID: ${this.spanId}`);
      _idleHub.configureScope(scope => scope.setSpan(this));
    }

    this._startIdleTimeout();
    setTimeout(() => {
      if (!this._finished) {
        this.setStatus('deadline_exceeded');
        this.finish();
      }
    }, this._finalTimeout);
  }

  /** {@inheritDoc} */
   finish(endTimestamp = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)()) {
    this._finished = true;
    this.activities = {};

    if (this.spanRecorder) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] finishing IdleTransaction', new Date(endTimestamp * 1000).toISOString(), this.op);

      for (var callback of this._beforeFinishCallbacks) {
        callback(this, endTimestamp);
      }

      this.spanRecorder.spans = this.spanRecorder.spans.filter((span) => {
        // If we are dealing with the transaction itself, we just return it
        if (span.spanId === this.spanId) {
          return true;
        }

        // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
        if (!span.endTimestamp) {
          span.endTimestamp = endTimestamp;
          span.setStatus('cancelled');
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
            _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] cancelling span since transaction ended early', JSON.stringify(span, undefined, 2));
        }

        var keepSpan = span.startTimestamp < endTimestamp;
        if (!keepSpan) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
            _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(
              '[Tracing] discarding Span since it happened after Transaction was finished',
              JSON.stringify(span, undefined, 2),
            );
        }
        return keepSpan;
      });

      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] flushing IdleTransaction');
    } else {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] No active IdleTransaction');
    }

    // if `this._onScope` is `true`, the transaction put itself on the scope when it started
    if (this._onScope) {
      clearActiveTransaction(this._idleHub);
    }

    return super.finish(endTimestamp);
  }

  /**
   * Register a callback function that gets excecuted before the transaction finishes.
   * Useful for cleanup or if you want to add any additional spans based on current context.
   *
   * This is exposed because users have no other way of running something before an idle transaction
   * finishes.
   */
   registerBeforeFinishCallback(callback) {
    this._beforeFinishCallbacks.push(callback);
  }

  /**
   * @inheritDoc
   */
   initSpanRecorder(maxlen) {
    if (!this.spanRecorder) {
      var pushActivity = (id) => {
        if (this._finished) {
          return;
        }
        this._pushActivity(id);
      };
      var popActivity = (id) => {
        if (this._finished) {
          return;
        }
        this._popActivity(id);
      };

      this.spanRecorder = new IdleTransactionSpanRecorder(pushActivity, popActivity, this.spanId, maxlen);

      // Start heartbeat so that transactions do not run forever.
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('Starting heartbeat');
      this._pingHeartbeat();
    }
    this.spanRecorder.add(this);
  }

  /**
   * Cancels the existing idletimeout, if there is one
   */
   _cancelIdleTimeout() {
    if (this._idleTimeoutID) {
      clearTimeout(this._idleTimeoutID);
      this._idleTimeoutID = undefined;
    }
  }

  /**
   * Creates an idletimeout
   */
   _startIdleTimeout(endTimestamp) {
    this._cancelIdleTimeout();
    this._idleTimeoutID = setTimeout(() => {
      if (!this._finished && Object.keys(this.activities).length === 0) {
        this.finish(endTimestamp);
      }
    }, this._idleTimeout);
  }

  /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */
   _pushActivity(spanId) {
    this._cancelIdleTimeout();
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(`[Tracing] pushActivity: ${spanId}`);
    this.activities[spanId] = true;
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] new activities count', Object.keys(this.activities).length);
  }

  /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */
   _popActivity(spanId) {
    if (this.activities[spanId]) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(`[Tracing] popActivity ${spanId}`);
            delete this.activities[spanId];
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] new activities count', Object.keys(this.activities).length);
    }

    if (Object.keys(this.activities).length === 0) {
      // We need to add the timeout here to have the real endtimestamp of the transaction
      // Remember timestampWithMs is in seconds, timeout is in ms
      var endTimestamp = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)() + this._idleTimeout / 1000;
      this._startIdleTimeout(endTimestamp);
    }
  }

  /**
   * Checks when entries of this.activities are not changing for 3 beats.
   * If this occurs we finish the transaction.
   */
   _beat() {
    // We should not be running heartbeat if the idle transaction is finished.
    if (this._finished) {
      return;
    }

    var heartbeatString = Object.keys(this.activities).join('');

    if (heartbeatString === this._prevHeartbeatString) {
      this._heartbeatCounter += 1;
    } else {
      this._heartbeatCounter = 1;
    }

    this._prevHeartbeatString = heartbeatString;

    if (this._heartbeatCounter >= 3) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] Transaction finished because of no change for 3 heart beats');
      this.setStatus('deadline_exceeded');
      this.finish();
    } else {
      this._pingHeartbeat();
    }
  }

  /**
   * Pings the heartbeat
   */
   _pingHeartbeat() {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(`pinging Heartbeat -> current counter: ${this._heartbeatCounter}`);
    setTimeout(() => {
      this._beat();
    }, HEARTBEAT_INTERVAL);
  }
}

/**
 * Reset transaction on scope to `undefined`
 */
function clearActiveTransaction(hub) {
  var scope = hub.getScope();
  if (scope) {
    var transaction = scope.getTransaction();
    if (transaction) {
      scope.setSpan(undefined);
    }
  }
}


//# sourceMappingURL=idletransaction.js.map


/***/ }),

/***/ 55334:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dr": function() { return /* binding */ Span; },
/* harmony export */   "gB": function() { return /* binding */ SpanRecorder; }
/* harmony export */ });
/* unused harmony export spanStatusfromHttpCode */
/* harmony import */ var _sentry_utils_esm_buildPolyfills__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45375);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62844);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21170);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20535);



/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */
class SpanRecorder {
   __init() {this.spans = [];}

   constructor(maxlen = 1000) {;SpanRecorder.prototype.__init.call(this);
    this._maxlen = maxlen;
  }

  /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */
   add(span) {
    if (this.spans.length > this._maxlen) {
      span.spanRecorder = undefined;
    } else {
      this.spans.push(span);
    }
  }
}

/**
 * Span contains all data about a span
 */
class Span  {
  /**
   * @inheritDoc
   */
   __init2() {this.traceId = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .uuid4 */ .DM)();}

  /**
   * @inheritDoc
   */
   __init3() {this.spanId = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .uuid4 */ .DM)().substring(16);}

  /**
   * @inheritDoc
   */
  

  /**
   * Internal keeper of the status
   */
  

  /**
   * @inheritDoc
   */
  

  /**
   * Timestamp in seconds when the span was created.
   */
   __init4() {this.startTimestamp = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)();}

  /**
   * Timestamp in seconds when the span ended.
   */
  

  /**
   * @inheritDoc
   */
  

  /**
   * @inheritDoc
   */
  

  /**
   * @inheritDoc
   */
   __init5() {this.tags = {};}

  /**
   * @inheritDoc
   */
     __init6() {this.data = {};}

  /**
   * List of spans that were finalized
   */
  

  /**
   * @inheritDoc
   */
  

  /**
   * You should never call the constructor manually, always use `Sentry.startTransaction()`
   * or call `startChild()` on an existing span.
   * @internal
   * @hideconstructor
   * @hidden
   */
   constructor(spanContext) {;Span.prototype.__init2.call(this);Span.prototype.__init3.call(this);Span.prototype.__init4.call(this);Span.prototype.__init5.call(this);Span.prototype.__init6.call(this);
    if (!spanContext) {
      return this;
    }
    if (spanContext.traceId) {
      this.traceId = spanContext.traceId;
    }
    if (spanContext.spanId) {
      this.spanId = spanContext.spanId;
    }
    if (spanContext.parentSpanId) {
      this.parentSpanId = spanContext.parentSpanId;
    }
    // We want to include booleans as well here
    if ('sampled' in spanContext) {
      this.sampled = spanContext.sampled;
    }
    if (spanContext.op) {
      this.op = spanContext.op;
    }
    if (spanContext.description) {
      this.description = spanContext.description;
    }
    if (spanContext.data) {
      this.data = spanContext.data;
    }
    if (spanContext.tags) {
      this.tags = spanContext.tags;
    }
    if (spanContext.status) {
      this.status = spanContext.status;
    }
    if (spanContext.startTimestamp) {
      this.startTimestamp = spanContext.startTimestamp;
    }
    if (spanContext.endTimestamp) {
      this.endTimestamp = spanContext.endTimestamp;
    }
  }

  /**
   * @inheritDoc
   */
   startChild(
    spanContext,
  ) {
    var childSpan = new Span({
      ...spanContext,
      parentSpanId: this.spanId,
      sampled: this.sampled,
      traceId: this.traceId,
    });

    childSpan.spanRecorder = this.spanRecorder;
    if (childSpan.spanRecorder) {
      childSpan.spanRecorder.add(childSpan);
    }

    childSpan.transaction = this.transaction;

    return childSpan;
  }

  /**
   * @inheritDoc
   */
   setTag(key, value) {
    this.tags = { ...this.tags, [key]: value };
    return this;
  }

  /**
   * @inheritDoc
   */
     setData(key, value) {
    this.data = { ...this.data, [key]: value };
    return this;
  }

  /**
   * @inheritDoc
   */
   setStatus(value) {
    this.status = value;
    return this;
  }

  /**
   * @inheritDoc
   */
   setHttpStatus(httpStatus) {
    this.setTag('http.status_code', String(httpStatus));
    var spanStatus = spanStatusfromHttpCode(httpStatus);
    if (spanStatus !== 'unknown_error') {
      this.setStatus(spanStatus);
    }
    return this;
  }

  /**
   * @inheritDoc
   */
   isSuccess() {
    return this.status === 'ok';
  }

  /**
   * @inheritDoc
   */
   finish(endTimestamp) {
    this.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)();
  }

  /**
   * @inheritDoc
   */
   toTraceparent() {
    let sampledString = '';
    if (this.sampled !== undefined) {
      sampledString = this.sampled ? '-1' : '-0';
    }
    return `${this.traceId}-${this.spanId}${sampledString}`;
  }

  /**
   * @inheritDoc
   */
   toContext() {
    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .dropUndefinedKeys */ .Jr)({
      data: this.data,
      description: this.description,
      endTimestamp: this.endTimestamp,
      op: this.op,
      parentSpanId: this.parentSpanId,
      sampled: this.sampled,
      spanId: this.spanId,
      startTimestamp: this.startTimestamp,
      status: this.status,
      tags: this.tags,
      traceId: this.traceId,
    });
  }

  /**
   * @inheritDoc
   */
   updateWithContext(spanContext) {
    this.data = (0,_sentry_utils_esm_buildPolyfills__WEBPACK_IMPORTED_MODULE_3__/* ._nullishCoalesce */ .h)(spanContext.data, () => ( {}));
    this.description = spanContext.description;
    this.endTimestamp = spanContext.endTimestamp;
    this.op = spanContext.op;
    this.parentSpanId = spanContext.parentSpanId;
    this.sampled = spanContext.sampled;
    this.spanId = (0,_sentry_utils_esm_buildPolyfills__WEBPACK_IMPORTED_MODULE_3__/* ._nullishCoalesce */ .h)(spanContext.spanId, () => ( this.spanId));
    this.startTimestamp = (0,_sentry_utils_esm_buildPolyfills__WEBPACK_IMPORTED_MODULE_3__/* ._nullishCoalesce */ .h)(spanContext.startTimestamp, () => ( this.startTimestamp));
    this.status = spanContext.status;
    this.tags = (0,_sentry_utils_esm_buildPolyfills__WEBPACK_IMPORTED_MODULE_3__/* ._nullishCoalesce */ .h)(spanContext.tags, () => ( {}));
    this.traceId = (0,_sentry_utils_esm_buildPolyfills__WEBPACK_IMPORTED_MODULE_3__/* ._nullishCoalesce */ .h)(spanContext.traceId, () => ( this.traceId));

    return this;
  }

  /**
   * @inheritDoc
   */
   getTraceContext()

 {
    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .dropUndefinedKeys */ .Jr)({
      data: Object.keys(this.data).length > 0 ? this.data : undefined,
      description: this.description,
      op: this.op,
      parent_span_id: this.parentSpanId,
      span_id: this.spanId,
      status: this.status,
      tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
      trace_id: this.traceId,
    });
  }

  /**
   * @inheritDoc
   */
   toJSON()

 {
    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .dropUndefinedKeys */ .Jr)({
      data: Object.keys(this.data).length > 0 ? this.data : undefined,
      description: this.description,
      op: this.op,
      parent_span_id: this.parentSpanId,
      span_id: this.spanId,
      start_timestamp: this.startTimestamp,
      status: this.status,
      tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
      timestamp: this.endTimestamp,
      trace_id: this.traceId,
    });
  }
}

/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */
function spanStatusfromHttpCode(httpStatus) {
  if (httpStatus < 400 && httpStatus >= 100) {
    return 'ok';
  }

  if (httpStatus >= 400 && httpStatus < 500) {
    switch (httpStatus) {
      case 401:
        return 'unauthenticated';
      case 403:
        return 'permission_denied';
      case 404:
        return 'not_found';
      case 409:
        return 'already_exists';
      case 413:
        return 'failed_precondition';
      case 429:
        return 'resource_exhausted';
      default:
        return 'invalid_argument';
    }
  }

  if (httpStatus >= 500 && httpStatus < 600) {
    switch (httpStatus) {
      case 501:
        return 'unimplemented';
      case 503:
        return 'unavailable';
      case 504:
        return 'deadline_exceeded';
      default:
        return 'internal_error';
    }
  }

  return 'unknown_error';
}


//# sourceMappingURL=span.js.map


/***/ }),

/***/ 33391:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ Transaction; }
/* harmony export */ });
/* harmony import */ var _sentry_utils_esm_buildPolyfills__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45375);
/* harmony import */ var _sentry_hub__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38641);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12343);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20535);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99181);
/* harmony import */ var _span_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55334);





/** JSDoc */
class Transaction extends _span_js__WEBPACK_IMPORTED_MODULE_0__/* .Span */ .Dr  {
  

  /**
   * The reference to the current hub.
   */
  

   __init() {this._measurements = {};}

  /**
   * This constructor should never be called manually. Those instrumenting tracing should use
   * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
   * @internal
   * @hideconstructor
   * @hidden
   */
   constructor(transactionContext, hub) {
    super(transactionContext);Transaction.prototype.__init.call(this);;

    this._hub = hub || (0,_sentry_hub__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentHub */ .Gd)();

    this._name = transactionContext.name || '';

    this.metadata = transactionContext.metadata || {};
    this._trimEnd = transactionContext.trimEnd;

    // this is because transactions are also spans, and spans have a transaction pointer
    this.transaction = this;
  }

  /** Getter for `name` property */
   get name() {
    return this._name;
  }

  /** Setter for `name` property, which also sets `source` */
   set name(newName) {
    this._name = newName;
    this.metadata.source = 'custom';
  }

  /**
   * JSDoc
   */
   setName(name, source = 'custom') {
    this.name = name;
    this.metadata.source = source;
  }

  /**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */
   initSpanRecorder(maxlen = 1000) {
    if (!this.spanRecorder) {
      this.spanRecorder = new _span_js__WEBPACK_IMPORTED_MODULE_0__/* .SpanRecorder */ .gB(maxlen);
    }
    this.spanRecorder.add(this);
  }

  /**
   * @inheritDoc
   */
   setMeasurement(name, value, unit = '') {
    this._measurements[name] = { value, unit };
  }

  /**
   * @inheritDoc
   */
   setMetadata(newMetadata) {
    this.metadata = { ...this.metadata, ...newMetadata };
  }

  /**
   * @inheritDoc
   */
   finish(endTimestamp) {
    // This transaction is already finished, so we should not flush it again.
    if (this.endTimestamp !== undefined) {
      return undefined;
    }

    if (!this.name) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.warn */ .kg.warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
      this.name = '<unlabeled transaction>';
    }

    // just sets the end timestamp
    super.finish(endTimestamp);

    if (this.sampled !== true) {
      // At this point if `sampled !== true` we want to discard the transaction.
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.log */ .kg.log('[Tracing] Discarding transaction because its trace was not chosen to be sampled.');

      var client = this._hub.getClient();
      if (client) {
        client.recordDroppedEvent('sample_rate', 'transaction');
      }

      return undefined;
    }

    var finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter(s => s !== this && s.endTimestamp) : [];

    if (this._trimEnd && finishedSpans.length > 0) {
      this.endTimestamp = finishedSpans.reduce((prev, current) => {
        if (prev.endTimestamp && current.endTimestamp) {
          return prev.endTimestamp > current.endTimestamp ? prev : current;
        }
        return prev;
      }).endTimestamp;
    }

    var metadata = this.metadata;

    var transaction = {
      contexts: {
        trace: this.getTraceContext(),
      },
      spans: finishedSpans,
      start_timestamp: this.startTimestamp,
      tags: this.tags,
      timestamp: this.endTimestamp,
      transaction: this.name,
      type: 'transaction',
      sdkProcessingMetadata: {
        ...metadata,
        baggage: this.getBaggage(),
      },
      ...(metadata.source && {
        transaction_info: {
          source: metadata.source,
        },
      }),
    };

    var hasMeasurements = Object.keys(this._measurements).length > 0;

    if (hasMeasurements) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.log */ .kg.log(
          '[Measurements] Adding measurements to transaction',
          JSON.stringify(this._measurements, undefined, 2),
        );
      transaction.measurements = this._measurements;
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.log */ .kg.log(`[Tracing] Finishing ${this.op} transaction: ${this.name}.`);

    return this._hub.captureEvent(transaction);
  }

  /**
   * @inheritDoc
   */
   toContext() {
    var spanContext = super.toContext();

    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .dropUndefinedKeys */ .Jr)({
      ...spanContext,
      name: this.name,
      trimEnd: this._trimEnd,
    });
  }

  /**
   * @inheritDoc
   */
   updateWithContext(transactionContext) {
    super.updateWithContext(transactionContext);

    this.name = (0,_sentry_utils_esm_buildPolyfills__WEBPACK_IMPORTED_MODULE_4__/* ._nullishCoalesce */ .h)(transactionContext.name, () => ( ''));

    this._trimEnd = transactionContext.trimEnd;

    return this;
  }

  /**
   * @inheritdoc
   *
   * @experimental
   */
   getBaggage() {
    var existingBaggage = this.metadata.baggage;

    // Only add Sentry baggage items to baggage, if baggage does not exist yet or it is still
    // empty and mutable
    var finalBaggage =
      !existingBaggage || (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .isBaggageMutable */ .Gp)(existingBaggage)
        ? this._populateBaggageWithSentryValues(existingBaggage)
        : existingBaggage;

    // Update the baggage stored on the transaction.
    this.metadata.baggage = finalBaggage;

    return finalBaggage;
  }

  /**
   * Collects and adds data to the passed baggage object.
   *
   * Note: This function does not explicitly check if the passed baggage object is allowed
   * to be modified. Implicitly, `setBaggageValue` will not make modification to the object
   * if it was already set immutable.
   *
   * After adding the data, the baggage object is set immutable to prevent further modifications.
   *
   * @param baggage
   *
   * @returns modified and immutable baggage object
   */
   _populateBaggageWithSentryValues(baggage = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .createBaggage */ .Hn)({})) {
    var hub = this._hub || (0,_sentry_hub__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentHub */ .Gd)();
    var client = hub && hub.getClient();

    if (!client) return baggage;

    const { environment, release } = client.getOptions() || {};
    const { publicKey: public_key } = client.getDsn() || {};

    var rate = this.metadata && this.metadata.transactionSampling && this.metadata.transactionSampling.rate;
    var sample_rate =
      rate !== undefined
        ? rate.toLocaleString('fullwide', { useGrouping: false, maximumFractionDigits: 16 })
        : undefined;

    var scope = hub.getScope();
    const { segment: user_segment } = (scope && scope.getUser()) || {};

    var source = this.metadata.source;
    var transaction = source && source !== 'url' ? this.name : undefined;

    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .createBaggage */ .Hn)(
      (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .dropUndefinedKeys */ .Jr)({
        environment,
        release,
        transaction,
        user_segment,
        public_key,
        trace_id: this.traceId,
        sample_rate,
        ...(0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .getSentryBaggageItems */ .Hk)(baggage), // keep user-added values
      } ),
      '',
      false, // set baggage immutable
    );
  }
}


//# sourceMappingURL=transaction.js.map


/***/ }),

/***/ 63233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "XL": function() { return /* binding */ msToSec; },
/* harmony export */   "x1": function() { return /* binding */ getActiveTransaction; },
/* harmony export */   "zu": function() { return /* binding */ hasTracingEnabled; }
/* harmony export */ });
/* unused harmony export secToMs */
/* harmony import */ var _sentry_hub__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38641);



/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */
function hasTracingEnabled(
  maybeOptions,
) {
  var client = (0,_sentry_hub__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().getClient();
  var options = maybeOptions || (client && client.getOptions());
  return !!options && ('tracesSampleRate' in options || 'tracesSampler' in options);
}

/** Grabs active transaction off scope, if any */
function getActiveTransaction(maybeHub) {
  var hub = maybeHub || (0,_sentry_hub__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)();
  var scope = hub.getScope();
  return scope && (scope.getTransaction() );
}

/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */
function msToSec(time) {
  return time / 1000;
}

/**
 * Converts from seconds to milliseconds
 * @param time time in seconds
 */
function secToMs(time) {
  return time * 1000;
}


//# sourceMappingURL=utils.js.map


/***/ }),

/***/ 99181:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gp": function() { return /* binding */ isBaggageMutable; },
/* harmony export */   "Hk": function() { return /* binding */ getSentryBaggageItems; },
/* harmony export */   "Hn": function() { return /* binding */ createBaggage; },
/* harmony export */   "J8": function() { return /* binding */ mergeAndSerializeBaggage; },
/* harmony export */   "bU": function() { return /* binding */ BAGGAGE_HEADER_NAME; },
/* harmony export */   "rg": function() { return /* binding */ parseBaggageSetMutability; }
/* harmony export */ });
/* unused harmony exports MAX_BAGGAGE_STRING_LENGTH, SENTRY_BAGGAGE_KEY_PREFIX, SENTRY_BAGGAGE_KEY_PREFIX_REGEX, getBaggageValue, getThirdPartyBaggage, isSentryBaggageEmpty, parseBaggageHeader, serializeBaggage, setBaggageImmutable, setBaggageValue */
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67597);
/* harmony import */ var _logger_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12343);



var BAGGAGE_HEADER_NAME = 'baggage';

var SENTRY_BAGGAGE_KEY_PREFIX = 'sentry-';

var SENTRY_BAGGAGE_KEY_PREFIX_REGEX = /^sentry-/;

/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */
var MAX_BAGGAGE_STRING_LENGTH = 8192;

/** Create an instance of Baggage */
function createBaggage(initItems, baggageString = '', mutable = true) {
  return [{ ...initItems }, baggageString, mutable];
}

/** Get a value from baggage */
function getBaggageValue(baggage, key) {
  return baggage[0][key];
}

/** Add a value to baggage */
function setBaggageValue(baggage, key, value) {
  if (isBaggageMutable(baggage)) {
    baggage[0][key] = value;
  }
}

/** Check if the Sentry part of the passed baggage (i.e. the first element in the tuple) is empty */
function isSentryBaggageEmpty(baggage) {
  return Object.keys(baggage[0]).length === 0;
}

/** Returns Sentry specific baggage values */
function getSentryBaggageItems(baggage) {
  return baggage[0];
}

/**
 * Returns 3rd party baggage string of @param baggage
 * @param baggage
 */
function getThirdPartyBaggage(baggage) {
  return baggage[1];
}

/**
 * Checks if baggage is mutable
 * @param baggage
 * @returns true if baggage is mutable, else false
 */
function isBaggageMutable(baggage) {
  return baggage[2];
}

/**
 * Sets the passed baggage immutable
 * @param baggage
 */
function setBaggageImmutable(baggage) {
  baggage[2] = false;
}

/** Serialize a baggage object */
function serializeBaggage(baggage) {
  return Object.keys(baggage[0]).reduce((prev, key) => {
    var val = baggage[0][key] ;
    var baggageEntry = `${SENTRY_BAGGAGE_KEY_PREFIX}${encodeURIComponent(key)}=${encodeURIComponent(val)}`;
    var newVal = prev === '' ? baggageEntry : `${prev},${baggageEntry}`;
    if (newVal.length > MAX_BAGGAGE_STRING_LENGTH) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        _logger_js__WEBPACK_IMPORTED_MODULE_0__/* .logger.warn */ .kg.warn(`Not adding key: ${key} with val: ${val} to baggage due to exceeding baggage size limits.`);
      return prev;
    } else {
      return newVal;
    }
  }, baggage[1]);
}

/**
 * Parse a baggage header from a string or a string array and return a Baggage object
 *
 * If @param includeThirdPartyEntries is set to true, third party baggage entries are added to the Baggage object
 * (This is necessary for merging potentially pre-existing baggage headers in outgoing requests with
 * our `sentry-` values)
 */
function parseBaggageHeader(
  inputBaggageValue,
  includeThirdPartyEntries = false,
) {
  // Adding this check here because we got reports of this function failing due to the input value
  // not being a string. This debug log might help us determine what's going on here.
  if ((!Array.isArray(inputBaggageValue) && !(0,_is_js__WEBPACK_IMPORTED_MODULE_1__/* .isString */ .HD)(inputBaggageValue)) || typeof inputBaggageValue === 'number') {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      _logger_js__WEBPACK_IMPORTED_MODULE_0__/* .logger.warn */ .kg.warn(
        '[parseBaggageHeader] Received input value of incompatible type: ',
        typeof inputBaggageValue,
        inputBaggageValue,
      );

    // Gonna early-return an empty baggage object so that we don't fail later on
    return createBaggage({}, '');
  }

  var baggageEntries = ((0,_is_js__WEBPACK_IMPORTED_MODULE_1__/* .isString */ .HD)(inputBaggageValue) ? inputBaggageValue : inputBaggageValue.join(','))
    .split(',')
    .map(entry => entry.trim())
    .filter(entry => entry !== '' && (includeThirdPartyEntries || SENTRY_BAGGAGE_KEY_PREFIX_REGEX.test(entry)));

  return baggageEntries.reduce(
    ([baggageObj, baggageString], curr) => {
      const [key, val] = curr.split('=');
      if (SENTRY_BAGGAGE_KEY_PREFIX_REGEX.test(key)) {
        var baggageKey = decodeURIComponent(key.split('-')[1]);
        return [
          {
            ...baggageObj,
            [baggageKey]: decodeURIComponent(val),
          },
          baggageString,
          true,
        ];
      } else {
        return [baggageObj, baggageString === '' ? curr : `${baggageString},${curr}`, true];
      }
    },
    [{}, '', true],
  );
}

/**
 * Merges the baggage header we saved from the incoming request (or meta tag) with
 * a possibly created or modified baggage header by a third party that's been added
 * to the outgoing request header.
 *
 * In case @param headerBaggageString exists, we can safely add the the 3rd party part of @param headerBaggage
 * with our @param incomingBaggage. This is possible because if we modified anything beforehand,
 * it would only affect parts of the sentry baggage (@see Baggage interface).
 *
 * @param incomingBaggage the baggage header of the incoming request that might contain sentry entries
 * @param thirdPartyBaggageHeader possibly existing baggage header string or string[] added from a third
 *        party to the request headers
 *
 * @return a merged and serialized baggage string to be propagated with the outgoing request
 */
function mergeAndSerializeBaggage(incomingBaggage, thirdPartyBaggageHeader) {
  if (!incomingBaggage && !thirdPartyBaggageHeader) {
    return '';
  }

  var headerBaggage = (thirdPartyBaggageHeader && parseBaggageHeader(thirdPartyBaggageHeader, true)) || undefined;
  var thirdPartyHeaderBaggage = headerBaggage && getThirdPartyBaggage(headerBaggage);

  var finalBaggage = createBaggage((incomingBaggage && incomingBaggage[0]) || {}, thirdPartyHeaderBaggage || '');
  return serializeBaggage(finalBaggage);
}

/**
 * Helper function that takes a raw baggage string (if available) and the processed sentry-trace header
 * data (if available), parses the baggage string and creates a Baggage object
 * If there is no baggage string, it will create an empty Baggage object.
 * In a second step, this functions determines if the created Baggage object should be set immutable
 * to prevent mutation of the Sentry data.
 *
 * Extracted this logic to a function because it's duplicated in a lot of places.
 *
 * @param rawBaggageValue
 * @param sentryTraceHeader
 */
function parseBaggageSetMutability(
  rawBaggageValue,
  sentryTraceHeader,
) {
  var baggage = parseBaggageHeader(rawBaggageValue || '');

  // Because we are always creating a Baggage object by calling `parseBaggageHeader` above
  // (either a filled one or an empty one, even if we didn't get a `baggage` header),
  // we only need to check if we have a sentry-trace header or not. As soon as we have it,
  // we set baggage immutable. In case we don't get a sentry-trace header, we can assume that
  // this SDK is the head of the trace and thus we still permit mutation at this time.
  // There is one exception though, which is that we get a baggage-header with `sentry-`
  // items but NO sentry-trace header. In this case we also set the baggage immutable for now
  // but if smoething like this would ever happen, we should revisit this and determine
  // what this would actually mean for the trace (i.e. is this SDK the head?, what happened
  // before that we don't have a sentry-trace header?, etc)
  (sentryTraceHeader || !isSentryBaggageEmpty(baggage)) && setBaggageImmutable(baggage);

  return baggage;
}


//# sourceMappingURL=baggage.js.map


/***/ }),

/***/ 58464:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ htmlTreeAsString; },
/* harmony export */   "l": function() { return /* binding */ getLocationHref; }
/* harmony export */ });
/* harmony import */ var _global_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82991);
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67597);



/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function htmlTreeAsString(elem, keyAttrs) {
  

  // try/catch both:
  // - accessing event.target (see getsentry/raven-js#838, #768)
  // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
  // - can throw an exception in some circumstances.
  try {
    let currentElem = elem ;
    var MAX_TRAVERSE_HEIGHT = 5;
    var MAX_OUTPUT_LEN = 80;
    var out = [];
    let height = 0;
    let len = 0;
    var separator = ' > ';
    var sepLength = separator.length;
    let nextStr;

        while (currentElem && height++ < MAX_TRAVERSE_HEIGHT) {
      nextStr = _htmlElementAsString(currentElem, keyAttrs);
      // bail out if
      // - nextStr is the 'html' element
      // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
      //   (ignore this limit if we are on the first iteration)
      if (nextStr === 'html' || (height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN)) {
        break;
      }

      out.push(nextStr);

      len += nextStr.length;
      currentElem = currentElem.parentNode;
    }

    return out.reverse().join(separator);
  } catch (_oO) {
    return '<unknown>';
  }
}

/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function _htmlElementAsString(el, keyAttrs) {
  var elem = el 

;

  var out = [];
  let className;
  let classes;
  let key;
  let attr;
  let i;

  if (!elem || !elem.tagName) {
    return '';
  }

  out.push(elem.tagName.toLowerCase());

  // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
  var keyAttrPairs =
    keyAttrs && keyAttrs.length
      ? keyAttrs.filter(keyAttr => elem.getAttribute(keyAttr)).map(keyAttr => [keyAttr, elem.getAttribute(keyAttr)])
      : null;

  if (keyAttrPairs && keyAttrPairs.length) {
    keyAttrPairs.forEach(keyAttrPair => {
      out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
  } else {
    if (elem.id) {
      out.push(`#${elem.id}`);
    }

        className = elem.className;
    if (className && (0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(className)) {
      classes = className.split(/\s+/);
      for (i = 0; i < classes.length; i++) {
        out.push(`.${classes[i]}`);
      }
    }
  }
  var allowedAttrs = ['type', 'name', 'title', 'alt'];
  for (i = 0; i < allowedAttrs.length; i++) {
    key = allowedAttrs[i];
    attr = elem.getAttribute(key);
    if (attr) {
      out.push(`[${key}="${attr}"]`);
    }
  }
  return out.join('');
}

/**
 * A safe form of location.href
 */
function getLocationHref() {
  var global = (0,_global_js__WEBPACK_IMPORTED_MODULE_1__/* .getGlobalObject */ .R)();
  try {
    return global.document.location.href;
  } catch (oO) {
    return '';
  }
}


//# sourceMappingURL=browser.js.map


/***/ }),

/***/ 45375:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ _nullishCoalesce; }
/* harmony export */ });
/**
 * Polyfill for the nullish coalescing operator (`??`).
 *
 * Note that the RHS is wrapped in a function so that if it's a computed value, that evaluation won't happen unless the
 * LHS evaluates to a nullish value, to mimic the operator's short-circuiting behavior.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 *
 * @param lhs The value of the expression to the left of the `??`
 * @param rhsFn A function returning the value of the expression to the right of the `??`
 * @returns The LHS value, unless it's `null` or `undefined`, in which case, the RHS value
 */
function _nullishCoalesce(lhs, rhsFn) {
  // by checking for loose equality to `null`, we catch both `null` and `undefined`
  return lhs != null ? lhs : rhsFn();
}

// Sucrase version:
// function _nullishCoalesce(lhs, rhsFn) {
//   if (lhs != null) {
//     return lhs;
//   } else {
//     return rhsFn();
//   }
// }


//# sourceMappingURL=_nullishCoalesce.js.map


/***/ }),

/***/ 82991:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ getGlobalObject; },
/* harmony export */   "Y": function() { return /* binding */ getGlobalSingleton; }
/* harmony export */ });
/* harmony import */ var _node_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92448);


/** Internal */

var fallbackGlobalObject = {};

/**
 * Safely get global scope object
 *
 * @returns Global scope object
 */
function getGlobalObject() {
  return (
    (0,_node_js__WEBPACK_IMPORTED_MODULE_0__/* .isNodeEnv */ .KV)()
      ? __webpack_require__.g
      : typeof window !== 'undefined'       ? window       : typeof self !== 'undefined'
      ? self
      : fallbackGlobalObject
  ) ;
}

/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `getGlobalObject`'s return value
 * @returns the singleton
 */
function getGlobalSingleton(name, creator, obj) {
  var global = (obj || getGlobalObject()) ;
  var __SENTRY__ = (global.__SENTRY__ = global.__SENTRY__ || {});
  var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
  return singleton;
}


//# sourceMappingURL=global.js.map


/***/ }),

/***/ 9732:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ addInstrumentationHandler; }
/* harmony export */ });
/* harmony import */ var _global_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82991);
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67597);
/* harmony import */ var _logger_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12343);
/* harmony import */ var _object_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20535);
/* harmony import */ var _stacktrace_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30360);
/* harmony import */ var _supports_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8823);







var global = (0,_global_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)();

/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */

var handlers = {};
var instrumented = {};

/** Instruments given API */
function instrument(type) {
  if (instrumented[type]) {
    return;
  }

  instrumented[type] = true;

  switch (type) {
    case 'console':
      instrumentConsole();
      break;
    case 'dom':
      instrumentDOM();
      break;
    case 'xhr':
      instrumentXHR();
      break;
    case 'fetch':
      instrumentFetch();
      break;
    case 'history':
      instrumentHistory();
      break;
    case 'error':
      instrumentError();
      break;
    case 'unhandledrejection':
      instrumentUnhandledRejection();
      break;
    default:
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _logger_js__WEBPACK_IMPORTED_MODULE_1__/* .logger.warn */ .kg.warn('unknown instrumentation type:', type);
      return;
  }
}

/**
 * Add handler that will be called when given type of instrumentation triggers.
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addInstrumentationHandler(type, callback) {
  handlers[type] = handlers[type] || [];
  (handlers[type] ).push(callback);
  instrument(type);
}

/** JSDoc */
function triggerHandlers(type, data) {
  if (!type || !handlers[type]) {
    return;
  }

  for (var handler of handlers[type] || []) {
    try {
      handler(data);
    } catch (e) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        _logger_js__WEBPACK_IMPORTED_MODULE_1__/* .logger.error */ .kg.error(
          `Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0,_stacktrace_js__WEBPACK_IMPORTED_MODULE_2__/* .getFunctionName */ .$P)(handler)}\nError:`,
          e,
        );
    }
  }
}

/** JSDoc */
function instrumentConsole() {
  if (!('console' in global)) {
    return;
  }

  _logger_js__WEBPACK_IMPORTED_MODULE_1__/* .CONSOLE_LEVELS.forEach */ .RU.forEach(function (level) {
    if (!(level in global.console)) {
      return;
    }

    (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(global.console, level, function (originalConsoleMethod) {
      return function (...args) {
        triggerHandlers('console', { args, level });

        // this fails for some browsers. :(
        if (originalConsoleMethod) {
          originalConsoleMethod.apply(global.console, args);
        }
      };
    });
  });
}

/** JSDoc */
function instrumentFetch() {
  if (!(0,_supports_js__WEBPACK_IMPORTED_MODULE_4__/* .supportsNativeFetch */ .t$)()) {
    return;
  }

  (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(global, 'fetch', function (originalFetch) {
    return function (...args) {
      var handlerData = {
        args,
        fetchData: {
          method: getFetchMethod(args),
          url: getFetchUrl(args),
        },
        startTimestamp: Date.now(),
      };

      triggerHandlers('fetch', {
        ...handlerData,
      });

            return originalFetch.apply(global, args).then(
        (response) => {
          triggerHandlers('fetch', {
            ...handlerData,
            endTimestamp: Date.now(),
            response,
          });
          return response;
        },
        (error) => {
          triggerHandlers('fetch', {
            ...handlerData,
            endTimestamp: Date.now(),
            error,
          });
          // NOTE: If you are a Sentry user, and you are seeing this stack frame,
          //       it means the sentry.javascript SDK caught an error invoking your application code.
          //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
          throw error;
        },
      );
    };
  });
}

/** Extract `method` from fetch call arguments */
function getFetchMethod(fetchArgs = []) {
  if ('Request' in global && (0,_is_js__WEBPACK_IMPORTED_MODULE_5__/* .isInstanceOf */ .V9)(fetchArgs[0], Request) && fetchArgs[0].method) {
    return String(fetchArgs[0].method).toUpperCase();
  }
  if (fetchArgs[1] && fetchArgs[1].method) {
    return String(fetchArgs[1].method).toUpperCase();
  }
  return 'GET';
}

/** Extract `url` from fetch call arguments */
function getFetchUrl(fetchArgs = []) {
  if (typeof fetchArgs[0] === 'string') {
    return fetchArgs[0];
  }
  if ('Request' in global && (0,_is_js__WEBPACK_IMPORTED_MODULE_5__/* .isInstanceOf */ .V9)(fetchArgs[0], Request)) {
    return fetchArgs[0].url;
  }
  return String(fetchArgs[0]);
}

/** JSDoc */
function instrumentXHR() {
  if (!('XMLHttpRequest' in global)) {
    return;
  }

  var xhrproto = XMLHttpRequest.prototype;

  (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(xhrproto, 'open', function (originalOpen) {
    return function ( ...args) {
            var xhr = this;
      var url = args[1];
      var xhrInfo = (xhr.__sentry_xhr__ = {
                method: (0,_is_js__WEBPACK_IMPORTED_MODULE_5__/* .isString */ .HD)(args[0]) ? args[0].toUpperCase() : args[0],
        url: args[1],
      });

      // if Sentry key appears in URL, don't capture it as a request
            if ((0,_is_js__WEBPACK_IMPORTED_MODULE_5__/* .isString */ .HD)(url) && xhrInfo.method === 'POST' && url.match(/sentry_key/)) {
        xhr.__sentry_own_request__ = true;
      }

      var onreadystatechangeHandler = function () {
        if (xhr.readyState === 4) {
          try {
            // touching statusCode in some platforms throws
            // an exception
            xhrInfo.status_code = xhr.status;
          } catch (e) {
            /* do nothing */
          }

          triggerHandlers('xhr', {
            args,
            endTimestamp: Date.now(),
            startTimestamp: Date.now(),
            xhr,
          });
        }
      };

      if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') {
        (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(xhr, 'onreadystatechange', function (original) {
          return function (...readyStateArgs) {
            onreadystatechangeHandler();
            return original.apply(xhr, readyStateArgs);
          };
        });
      } else {
        xhr.addEventListener('readystatechange', onreadystatechangeHandler);
      }

      return originalOpen.apply(xhr, args);
    };
  });

  (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(xhrproto, 'send', function (originalSend) {
    return function ( ...args) {
      if (this.__sentry_xhr__ && args[0] !== undefined) {
        this.__sentry_xhr__.body = args[0];
      }

      triggerHandlers('xhr', {
        args,
        startTimestamp: Date.now(),
        xhr: this,
      });

      return originalSend.apply(this, args);
    };
  });
}

let lastHref;

/** JSDoc */
function instrumentHistory() {
  if (!(0,_supports_js__WEBPACK_IMPORTED_MODULE_4__/* .supportsHistory */ .Bf)()) {
    return;
  }

  var oldOnPopState = global.onpopstate;
  global.onpopstate = function ( ...args) {
    var to = global.location.href;
    // keep track of the current URL state, as we always receive only the updated state
    var from = lastHref;
    lastHref = to;
    triggerHandlers('history', {
      from,
      to,
    });
    if (oldOnPopState) {
      // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
      // https://github.com/getsentry/sentry-javascript/issues/3344
      // https://github.com/bugsnag/bugsnag-js/issues/469
      try {
        return oldOnPopState.apply(this, args);
      } catch (_oO) {
        // no-empty
      }
    }
  };

  /** @hidden */
  function historyReplacementFunction(originalHistoryFunction) {
    return function ( ...args) {
      var url = args.length > 2 ? args[2] : undefined;
      if (url) {
        // coerce to string (this is what pushState does)
        var from = lastHref;
        var to = String(url);
        // keep track of the current URL state, as we always receive only the updated state
        lastHref = to;
        triggerHandlers('history', {
          from,
          to,
        });
      }
      return originalHistoryFunction.apply(this, args);
    };
  }

  (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(global.history, 'pushState', historyReplacementFunction);
  (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(global.history, 'replaceState', historyReplacementFunction);
}

var debounceDuration = 1000;
let debounceTimerID;
let lastCapturedEvent;

/**
 * Decide whether the current event should finish the debounce of previously captured one.
 * @param previous previously captured event
 * @param current event to be captured
 */
function shouldShortcircuitPreviousDebounce(previous, current) {
  // If there was no previous event, it should always be swapped for the new one.
  if (!previous) {
    return true;
  }

  // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
  if (previous.type !== current.type) {
    return true;
  }

  try {
    // If both events have the same type, it's still possible that actions were performed on different targets.
    // e.g. 2 clicks on different buttons.
    if (previous.target !== current.target) {
      return true;
    }
  } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
  }

  // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
  // to which an event listener was attached), we treat them as the same action, as we want to capture
  // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
  return false;
}

/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */
function shouldSkipDOMEvent(event) {
  // We are only interested in filtering `keypress` events for now.
  if (event.type !== 'keypress') {
    return false;
  }

  try {
    var target = event.target ;

    if (!target || !target.tagName) {
      return true;
    }

    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
      return false;
    }
  } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
  }

  return true;
}

/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param handler function that will be triggered
 * @param globalListener indicates whether event was captured by the global event listener
 * @returns wrapped breadcrumb events handler
 * @hidden
 */
function makeDOMEventHandler(handler, globalListener = false) {
  return (event) => {
    // It's possible this handler might trigger multiple times for the same
    // event (e.g. event propagation through node ancestors).
    // Ignore if we've already captured that event.
    if (!event || lastCapturedEvent === event) {
      return;
    }

    // We always want to skip _some_ events.
    if (shouldSkipDOMEvent(event)) {
      return;
    }

    var name = event.type === 'keypress' ? 'input' : event.type;

    // If there is no debounce timer, it means that we can safely capture the new event and store it for future comparisons.
    if (debounceTimerID === undefined) {
      handler({
        event: event,
        name,
        global: globalListener,
      });
      lastCapturedEvent = event;
    }
    // If there is a debounce awaiting, see if the new event is different enough to treat it as a unique one.
    // If that's the case, emit the previous event and store locally the newly-captured DOM event.
    else if (shouldShortcircuitPreviousDebounce(lastCapturedEvent, event)) {
      handler({
        event: event,
        name,
        global: globalListener,
      });
      lastCapturedEvent = event;
    }

    // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
    clearTimeout(debounceTimerID);
    debounceTimerID = global.setTimeout(() => {
      debounceTimerID = undefined;
    }, debounceDuration);
  };
}

/** JSDoc */
function instrumentDOM() {
  if (!('document' in global)) {
    return;
  }

  // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
  // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
  // we instrument `addEventListener` so that we don't end up attaching this handler twice.
  var triggerDOMHandler = triggerHandlers.bind(null, 'dom');
  var globalDOMEventHandler = makeDOMEventHandler(triggerDOMHandler, true);
  global.document.addEventListener('click', globalDOMEventHandler, false);
  global.document.addEventListener('keypress', globalDOMEventHandler, false);

  // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
  // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
  // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
  // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
  // guaranteed to fire at least once.)
  ['EventTarget', 'Node'].forEach((target) => {
        var proto = (global )[target] && (global )[target].prototype;
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
      return;
    }

    (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(proto, 'addEventListener', function (originalAddEventListener) {
      return function (
        
        type,
        listener,
        options,
      ) {
        if (type === 'click' || type == 'keypress') {
          try {
            var el = this ;
            var handlers = (el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {});
            var handlerForType = (handlers[type] = handlers[type] || { refCount: 0 });

            if (!handlerForType.handler) {
              var handler = makeDOMEventHandler(triggerDOMHandler);
              handlerForType.handler = handler;
              originalAddEventListener.call(this, type, handler, options);
            }

            handlerForType.refCount += 1;
          } catch (e) {
            // Accessing dom properties is always fragile.
            // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
          }
        }

        return originalAddEventListener.call(this, type, listener, options);
      };
    });

    (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(
      proto,
      'removeEventListener',
      function (originalRemoveEventListener) {
        return function (
          
          type,
          listener,
          options,
        ) {
          if (type === 'click' || type == 'keypress') {
            try {
              var el = this ;
              var handlers = el.__sentry_instrumentation_handlers__ || {};
              var handlerForType = handlers[type];

              if (handlerForType) {
                handlerForType.refCount -= 1;
                // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                if (handlerForType.refCount <= 0) {
                  originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                  handlerForType.handler = undefined;
                  delete handlers[type];                 }

                // If there are no longer any custom handlers of any type on this element, cleanup everything.
                if (Object.keys(handlers).length === 0) {
                  delete el.__sentry_instrumentation_handlers__;
                }
              }
            } catch (e) {
              // Accessing dom properties is always fragile.
              // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
            }
          }

          return originalRemoveEventListener.call(this, type, listener, options);
        };
      },
    );
  });
}

let _oldOnErrorHandler = null;
/** JSDoc */
function instrumentError() {
  _oldOnErrorHandler = global.onerror;

  global.onerror = function (msg, url, line, column, error) {
    triggerHandlers('error', {
      column,
      error,
      line,
      msg,
      url,
    });

    if (_oldOnErrorHandler) {
            return _oldOnErrorHandler.apply(this, arguments);
    }

    return false;
  };
}

let _oldOnUnhandledRejectionHandler = null;
/** JSDoc */
function instrumentUnhandledRejection() {
  _oldOnUnhandledRejectionHandler = global.onunhandledrejection;

  global.onunhandledrejection = function (e) {
    triggerHandlers('unhandledrejection', e);

    if (_oldOnUnhandledRejectionHandler) {
            return _oldOnUnhandledRejectionHandler.apply(this, arguments);
    }

    return true;
  };
}


//# sourceMappingURL=instrument.js.map


/***/ }),

/***/ 67597:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cy": function() { return /* binding */ isSyntheticEvent; },
/* harmony export */   "HD": function() { return /* binding */ isString; },
/* harmony export */   "J8": function() { return /* binding */ isThenable; },
/* harmony export */   "Kj": function() { return /* binding */ isRegExp; },
/* harmony export */   "PO": function() { return /* binding */ isPlainObject; },
/* harmony export */   "TX": function() { return /* binding */ isDOMError; },
/* harmony export */   "V9": function() { return /* binding */ isInstanceOf; },
/* harmony export */   "VW": function() { return /* binding */ isErrorEvent; },
/* harmony export */   "VZ": function() { return /* binding */ isError; },
/* harmony export */   "cO": function() { return /* binding */ isEvent; },
/* harmony export */   "fm": function() { return /* binding */ isDOMException; },
/* harmony export */   "i2": function() { return /* binding */ isNaN; },
/* harmony export */   "kK": function() { return /* binding */ isElement; },
/* harmony export */   "pt": function() { return /* binding */ isPrimitive; }
/* harmony export */ });
var objectToString = Object.prototype.toString;

/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isError(wat) {
  switch (objectToString.call(wat)) {
    case '[object Error]':
    case '[object Exception]':
    case '[object DOMException]':
      return true;
    default:
      return isInstanceOf(wat, Error);
  }
}

function isBuiltin(wat, ty) {
  return objectToString.call(wat) === `[object ${ty}]`;
}

/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isErrorEvent(wat) {
  return isBuiltin(wat, 'ErrorEvent');
}

/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMError(wat) {
  return isBuiltin(wat, 'DOMError');
}

/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMException(wat) {
  return isBuiltin(wat, 'DOMException');
}

/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isString(wat) {
  return isBuiltin(wat, 'String');
}

/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPrimitive(wat) {
  return wat === null || (typeof wat !== 'object' && typeof wat !== 'function');
}

/**
 * Checks whether given value's type is an object literal
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPlainObject(wat) {
  return isBuiltin(wat, 'Object');
}

/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isEvent(wat) {
  return typeof Event !== 'undefined' && isInstanceOf(wat, Event);
}

/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isElement(wat) {
  return typeof Element !== 'undefined' && isInstanceOf(wat, Element);
}

/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isRegExp(wat) {
  return isBuiltin(wat, 'RegExp');
}

/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */
function isThenable(wat) {
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}

/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isSyntheticEvent(wat) {
  return isPlainObject(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}

/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isNaN(wat) {
  return typeof wat === 'number' && wat !== wat;
}

/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */
function isInstanceOf(wat, base) {
  try {
    return wat instanceof base;
  } catch (_e) {
    return false;
  }
}


//# sourceMappingURL=is.js.map


/***/ }),

/***/ 12343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cf": function() { return /* binding */ consoleSandbox; },
/* harmony export */   "RU": function() { return /* binding */ CONSOLE_LEVELS; },
/* harmony export */   "kg": function() { return /* binding */ logger; }
/* harmony export */ });
/* harmony import */ var _global_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82991);


// TODO: Implement different loggers for different environments
var global = (0,_global_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)();

/** Prefix for logging strings */
var PREFIX = 'Sentry Logger ';

var CONSOLE_LEVELS = ['debug', 'info', 'warn', 'error', 'log', 'assert', 'trace'] ;

/**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */
function consoleSandbox(callback) {
  var global = (0,_global_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)();

  if (!('console' in global)) {
    return callback();
  }

  var originalConsole = global.console ;
  var wrappedLevels = {};

  // Restore all wrapped console methods
  CONSOLE_LEVELS.forEach(level => {
    // TODO(v7): Remove this check as it's only needed for Node 6
    var originalWrappedFunc =
      originalConsole[level] && (originalConsole[level] ).__sentry_original__;
    if (level in global.console && originalWrappedFunc) {
      wrappedLevels[level] = originalConsole[level] ;
      originalConsole[level] = originalWrappedFunc ;
    }
  });

  try {
    return callback();
  } finally {
    // Revert restoration to wrapped state
    Object.keys(wrappedLevels).forEach(level => {
      originalConsole[level] = wrappedLevels[level ];
    });
  }
}

function makeLogger() {
  let enabled = false;
  var logger = {
    enable: () => {
      enabled = true;
    },
    disable: () => {
      enabled = false;
    },
  };

  if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
    CONSOLE_LEVELS.forEach(name => {
            logger[name] = (...args) => {
        if (enabled) {
          consoleSandbox(() => {
            global.console[name](`${PREFIX}[${name}]:`, ...args);
          });
        }
      };
    });
  } else {
    CONSOLE_LEVELS.forEach(name => {
      logger[name] = () => undefined;
    });
  }

  return logger ;
}

// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
let logger;
if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
  logger = (0,_global_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalSingleton */ .Y)('logger', makeLogger);
} else {
  logger = makeLogger();
}


//# sourceMappingURL=logger.js.map


/***/ }),

/***/ 62844:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DM": function() { return /* binding */ uuid4; },
/* harmony export */   "Db": function() { return /* binding */ addExceptionTypeValue; },
/* harmony export */   "EG": function() { return /* binding */ addExceptionMechanism; },
/* harmony export */   "YO": function() { return /* binding */ checkOrSetAlreadyCaught; },
/* harmony export */   "en": function() { return /* binding */ parseUrl; },
/* harmony export */   "jH": function() { return /* binding */ getEventDescription; },
/* harmony export */   "rt": function() { return /* binding */ stripUrlQueryAndFragment; }
/* harmony export */ });
/* unused harmony exports addContextToFrame, parseSemver */
/* harmony import */ var _global_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82991);
/* harmony import */ var _object_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20535);




/**
 * Extended Window interface that allows for Crypto API usage in IE browsers
 */

/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */
function uuid4() {
  var global = (0,_global_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)() ;
  var crypto = global.crypto || global.msCrypto;

  if (!(crypto === void 0) && crypto.getRandomValues) {
    // Use window.crypto API if available
    var arr = new Uint16Array(8);
    crypto.getRandomValues(arr);

    // set 4 in byte 7
        arr[3] = (arr[3] & 0xfff) | 0x4000;
    // set 2 most significant bits of byte 9 to '10'
        arr[4] = (arr[4] & 0x3fff) | 0x8000;

    var pad = (num) => {
      let v = num.toString(16);
      while (v.length < 4) {
        v = `0${v}`;
      }
      return v;
    };

    return (
      pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7])
    );
  }
  // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
  return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, c => {
        var r = (Math.random() * 16) | 0;
        var v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */
function parseUrl(url)

 {
  if (!url) {
    return {};
  }

  var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);

  if (!match) {
    return {};
  }

  // coerce to undefined values to empty string so we don't get 'undefined'
  var query = match[6] || '';
  var fragment = match[8] || '';
  return {
    host: match[4],
    path: match[5],
    protocol: match[2],
    relative: match[5] + query + fragment, // everything minus origin
  };
}

function getFirstException(event) {
  return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}

/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */
function getEventDescription(event) {
  const { message, event_id: eventId } = event;
  if (message) {
    return message;
  }

  var firstException = getFirstException(event);
  if (firstException) {
    if (firstException.type && firstException.value) {
      return `${firstException.type}: ${firstException.value}`;
    }
    return firstException.type || firstException.value || eventId || '<unknown>';
  }
  return eventId || '<unknown>';
}

/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */
function addExceptionTypeValue(event, value, type) {
  var exception = (event.exception = event.exception || {});
  var values = (exception.values = exception.values || []);
  var firstException = (values[0] = values[0] || {});
  if (!firstException.value) {
    firstException.value = value || '';
  }
  if (!firstException.type) {
    firstException.type = type || 'Error';
  }
}

/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */
function addExceptionMechanism(event, newMechanism) {
  var firstException = getFirstException(event);
  if (!firstException) {
    return;
  }

  var defaultMechanism = { type: 'generic', handled: true };
  var currentMechanism = firstException.mechanism;
  firstException.mechanism = { ...defaultMechanism, ...currentMechanism, ...newMechanism };

  if (newMechanism && 'data' in newMechanism) {
    var mergedData = { ...(currentMechanism && currentMechanism.data), ...newMechanism.data };
    firstException.mechanism.data = mergedData;
  }
}

// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var SEMVER_REGEXP =
  /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;

/**
 * Represents Semantic Versioning object
 */

/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */
function parseSemver(input) {
  var match = input.match(SEMVER_REGEXP) || [];
  var major = parseInt(match[1], 10);
  var minor = parseInt(match[2], 10);
  var patch = parseInt(match[3], 10);
  return {
    buildmetadata: match[5],
    major: isNaN(major) ? undefined : major,
    minor: isNaN(minor) ? undefined : minor,
    patch: isNaN(patch) ? undefined : patch,
    prerelease: match[4],
  };
}

/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */
function addContextToFrame(lines, frame, linesOfContext = 5) {
  var lineno = frame.lineno || 0;
  var maxLines = lines.length;
  var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);

  frame.pre_context = lines
    .slice(Math.max(0, sourceLine - linesOfContext), sourceLine)
    .map((line) => snipLine(line, 0));

  frame.context_line = snipLine(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);

  frame.post_context = lines
    .slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext)
    .map((line) => snipLine(line, 0));
}

/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */
function stripUrlQueryAndFragment(urlPath) {
    return urlPath.split(/[\?#]/, 1)[0];
}

/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */
function checkOrSetAlreadyCaught(exception) {
    if (exception && (exception ).__sentry_captured__) {
    return true;
  }

  try {
    // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
    // `ExtraErrorData` integration
    (0,_object_js__WEBPACK_IMPORTED_MODULE_1__/* .addNonEnumerableProperty */ .xp)(exception , '__sentry_captured__', true);
  } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
  }

  return false;
}


//# sourceMappingURL=misc.js.map


/***/ }),

/***/ 92448:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l$": function() { return /* binding */ dynamicRequire; },
  "KV": function() { return /* binding */ isNodeEnv; },
  "$y": function() { return /* binding */ loadModule; }
});

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/env.js
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These fags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */

/**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */
function isBrowserBundle() {
  return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}


//# sourceMappingURL=env.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/node.js
/* module decorator */ module = __webpack_require__.hmd(module);
/* provided dependency */ var process = __webpack_require__(34155);


/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */

/**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */
function isNodeEnv() {
  // explicitly check for browser bundles as those can be optimized statically
  // by terser/rollup.
  return (
    !isBrowserBundle() &&
    Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]'
  );
}

/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */
function dynamicRequire(mod, request) {
    return mod.require(request);
}

/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */
function loadModule(moduleName) {
  let mod;

  try {
    mod = dynamicRequire(module, moduleName);
  } catch (e) {
    // no-empty
  }

  try {
    const { cwd } = dynamicRequire(module, 'process');
    mod = dynamicRequire(module, `${cwd()}/node_modules/${moduleName}`) ;
  } catch (e) {
    // no-empty
  }

  return mod;
}


//# sourceMappingURL=node.js.map


/***/ }),

/***/ 20535:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$Q": function() { return /* binding */ markFunctionWrapped; },
/* harmony export */   "HK": function() { return /* binding */ getOriginalFunction; },
/* harmony export */   "Jr": function() { return /* binding */ dropUndefinedKeys; },
/* harmony export */   "Sh": function() { return /* binding */ convertToPlainObject; },
/* harmony export */   "_j": function() { return /* binding */ urlEncode; },
/* harmony export */   "hl": function() { return /* binding */ fill; },
/* harmony export */   "xp": function() { return /* binding */ addNonEnumerableProperty; },
/* harmony export */   "zf": function() { return /* binding */ extractExceptionKeysForMessage; }
/* harmony export */ });
/* unused harmony export objectify */
/* harmony import */ var _browser_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58464);
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67597);
/* harmony import */ var _string_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57321);




/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */
function fill(source, name, replacementFactory) {
  if (!(name in source)) {
    return;
  }

  var original = source[name] ;
  var wrapped = replacementFactory(original) ;

  // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
  // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
  if (typeof wrapped === 'function') {
    try {
      markFunctionWrapped(wrapped, original);
    } catch (_Oo) {
      // This can throw if multiple fill happens on a global object like XMLHttpRequest
      // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
  }

  source[name] = wrapped;
}

/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */
function addNonEnumerableProperty(obj, name, value) {
  Object.defineProperty(obj, name, {
    // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
    value: value,
    writable: true,
    configurable: true,
  });
}

/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */
function markFunctionWrapped(wrapped, original) {
  var proto = original.prototype || {};
  wrapped.prototype = original.prototype = proto;
  addNonEnumerableProperty(wrapped, '__sentry_original__', original);
}

/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */
function getOriginalFunction(func) {
  return func.__sentry_original__;
}

/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */
function urlEncode(object) {
  return Object.keys(object)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`)
    .join('&');
}

/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */
function convertToPlainObject(
  value,
)

 {
  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isError */ .VZ)(value)) {
    return {
      message: value.message,
      name: value.name,
      stack: value.stack,
      ...getOwnProperties(value),
    };
  } else if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isEvent */ .cO)(value)) {
    var newObj

 = {
      type: value.type,
      target: serializeEventTarget(value.target),
      currentTarget: serializeEventTarget(value.currentTarget),
      ...getOwnProperties(value),
    };

    if (typeof CustomEvent !== 'undefined' && (0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isInstanceOf */ .V9)(value, CustomEvent)) {
      newObj.detail = value.detail;
    }

    return newObj;
  } else {
    return value;
  }
}

/** Creates a string representation of the target of an `Event` object */
function serializeEventTarget(target) {
  try {
    return (0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isElement */ .kK)(target) ? (0,_browser_js__WEBPACK_IMPORTED_MODULE_1__/* .htmlTreeAsString */ .R)(target) : Object.prototype.toString.call(target);
  } catch (_oO) {
    return '<unknown>';
  }
}

/** Filters out all but an object's own properties */
function getOwnProperties(obj) {
  if (typeof obj === 'object' && obj !== null) {
    var extractedProps = {};
    for (var property in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, property)) {
        extractedProps[property] = (obj )[property];
      }
    }
    return extractedProps;
  } else {
    return {};
  }
}

/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */
function extractExceptionKeysForMessage(exception, maxLength = 40) {
  var keys = Object.keys(convertToPlainObject(exception));
  keys.sort();

  if (!keys.length) {
    return '[object has no keys]';
  }

  if (keys[0].length >= maxLength) {
    return (0,_string_js__WEBPACK_IMPORTED_MODULE_2__/* .truncate */ .$G)(keys[0], maxLength);
  }

  for (let includedKeys = keys.length; includedKeys > 0; includedKeys--) {
    var serialized = keys.slice(0, includedKeys).join(', ');
    if (serialized.length > maxLength) {
      continue;
    }
    if (includedKeys === keys.length) {
      return serialized;
    }
    return (0,_string_js__WEBPACK_IMPORTED_MODULE_2__/* .truncate */ .$G)(serialized, maxLength);
  }

  return '';
}

/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */
function dropUndefinedKeys(inputValue) {
  // This map keeps track of what already visited nodes map to.
  // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
  // references as the input object.
  var memoizationMap = new Map();

  // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
  return _dropUndefinedKeys(inputValue, memoizationMap);
}

function _dropUndefinedKeys(inputValue, memoizationMap) {
  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isPlainObject */ .PO)(inputValue)) {
    // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
    var memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) {
      return memoVal ;
    }

    var returnValue = {};
    // Store the mapping of this value in case we visit it again, in case of circular data
    memoizationMap.set(inputValue, returnValue);

    for (var key of Object.keys(inputValue)) {
      if (typeof inputValue[key] !== 'undefined') {
        returnValue[key] = _dropUndefinedKeys(inputValue[key], memoizationMap);
      }
    }

    return returnValue ;
  }

  if (Array.isArray(inputValue)) {
    // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
    var memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) {
      return memoVal ;
    }

    var returnValue = [];
    // Store the mapping of this value in case we visit it again, in case of circular data
    memoizationMap.set(inputValue, returnValue);

    inputValue.forEach((item) => {
      returnValue.push(_dropUndefinedKeys(item, memoizationMap));
    });

    return returnValue ;
  }

  return inputValue;
}

/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */
function objectify(wat) {
  let objectified;
  switch (true) {
    case wat === undefined || wat === null:
      objectified = new String(wat);
      break;

    // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
    // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
    // an object in order to wrap it.
    case typeof wat === 'symbol' || typeof wat === 'bigint':
      objectified = Object(wat);
      break;

    // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
    case isPrimitive(wat):
            objectified = new (wat ).constructor(wat);
      break;

    // by process of elimination, at this point we know that `wat` must already be an object
    default:
      objectified = wat;
      break;
  }
  return objectified;
}


//# sourceMappingURL=object.js.map


/***/ }),

/***/ 30360:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$P": function() { return /* binding */ getFunctionName; },
/* harmony export */   "Sq": function() { return /* binding */ stackParserFromStackParserOptions; },
/* harmony export */   "pE": function() { return /* binding */ createStackParser; }
/* harmony export */ });
/* unused harmony exports nodeStackLineParser, stripSentryFramesAndReverse */


var STACKTRACE_LIMIT = 50;

/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */
function createStackParser(...parsers) {
  var sortedParsers = parsers.sort((a, b) => a[0] - b[0]).map(p => p[1]);

  return (stack, skipFirst = 0) => {
    var frames = [];

    for (var line of stack.split('\n').slice(skipFirst)) {
      for (var parser of sortedParsers) {
        var frame = parser(line);

        if (frame) {
          frames.push(frame);
          break;
        }
      }
    }

    return stripSentryFramesAndReverse(frames);
  };
}

/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */
function stackParserFromStackParserOptions(stackParser) {
  if (Array.isArray(stackParser)) {
    return createStackParser(...stackParser);
  }
  return stackParser;
}

/**
 * @hidden
 */
function stripSentryFramesAndReverse(stack) {
  if (!stack.length) {
    return [];
  }

  let localStack = stack;

  var firstFrameFunction = localStack[0].function || '';
  var lastFrameFunction = localStack[localStack.length - 1].function || '';

  // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
  if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) {
    localStack = localStack.slice(1);
  }

  // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
  if (lastFrameFunction.indexOf('sentryWrapped') !== -1) {
    localStack = localStack.slice(0, -1);
  }

  // The frame where the crash happened, should be the last entry in the array
  return localStack
    .slice(0, STACKTRACE_LIMIT)
    .map(frame => ({
      ...frame,
      filename: frame.filename || localStack[0].filename,
      function: frame.function || '?',
    }))
    .reverse();
}

var defaultFunctionName = '<anonymous>';

/**
 * Safely extract function name from itself
 */
function getFunctionName(fn) {
  try {
    if (!fn || typeof fn !== 'function') {
      return defaultFunctionName;
    }
    return fn.name || defaultFunctionName;
  } catch (e) {
    // Just accessing custom props in some Selenium environments
    // can cause a "Permission denied" exception (see raven-js#495).
    return defaultFunctionName;
  }
}

function node(getModule) {
  var FILENAME_MATCH = /^\s*[-]{4,}$/;
  var FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+?):(\d+)(?::(\d+))?|([^)]+))\)?/;

    return (line) => {
    if (line.match(FILENAME_MATCH)) {
      return {
        filename: line,
      };
    }

    var lineMatch = line.match(FULL_MATCH);
    if (!lineMatch) {
      return undefined;
    }

    let object;
    let method;
    let functionName;
    let typeName;
    let methodName;

    if (lineMatch[1]) {
      functionName = lineMatch[1];

      let methodStart = functionName.lastIndexOf('.');
      if (functionName[methodStart - 1] === '.') {
                methodStart--;
      }

      if (methodStart > 0) {
        object = functionName.substr(0, methodStart);
        method = functionName.substr(methodStart + 1);
        var objectEnd = object.indexOf('.Module');
        if (objectEnd > 0) {
          functionName = functionName.substr(objectEnd + 1);
          object = object.substr(0, objectEnd);
        }
      }
      typeName = undefined;
    }

    if (method) {
      typeName = object;
      methodName = method;
    }

    if (method === '<anonymous>') {
      methodName = undefined;
      functionName = undefined;
    }

    if (functionName === undefined) {
      methodName = methodName || '<anonymous>';
      functionName = typeName ? `${typeName}.${methodName}` : methodName;
    }

    var filename = _optionalChain([lineMatch, 'access', _ => _[2], 'optionalAccess', _2 => _2.startsWith, 'call', _3 => _3('file://')]) ? lineMatch[2].substr(7) : lineMatch[2];
    var isNative = lineMatch[5] === 'native';
    var isInternal =
      isNative || (filename && !filename.startsWith('/') && !filename.startsWith('.') && filename.indexOf(':\\') !== 1);

    // in_app is all that's not an internal Node function or a module within node_modules
    // note that isNative appears to return true even for node core libraries
    // see https://github.com/getsentry/raven-node/issues/176
    var in_app = !isInternal && filename !== undefined && !filename.includes('node_modules/');

    return {
      filename,
      module: _optionalChain([getModule, 'optionalCall', _4 => _4(filename)]),
      function: functionName,
      lineno: parseInt(lineMatch[3], 10) || undefined,
      colno: parseInt(lineMatch[4], 10) || undefined,
      in_app,
    };
  };
}

/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */
function nodeStackLineParser(getModule) {
  return [90, node(getModule)];
}


//# sourceMappingURL=stacktrace.js.map


/***/ }),

/***/ 57321:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$G": function() { return /* binding */ truncate; },
/* harmony export */   "nK": function() { return /* binding */ safeJoin; },
/* harmony export */   "zC": function() { return /* binding */ isMatchingPattern; }
/* harmony export */ });
/* unused harmony exports escapeStringForRegex, snipLine */
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67597);


/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */
function truncate(str, max = 0) {
  if (typeof str !== 'string' || max === 0) {
    return str;
  }
  return str.length <= max ? str : `${str.substr(0, max)}...`;
}

/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */
function snipLine(line, colno) {
  let newLine = line;
  var lineLength = newLine.length;
  if (lineLength <= 150) {
    return newLine;
  }
  if (colno > lineLength) {
        colno = lineLength;
  }

  let start = Math.max(colno - 60, 0);
  if (start < 5) {
    start = 0;
  }

  let end = Math.min(start + 140, lineLength);
  if (end > lineLength - 5) {
    end = lineLength;
  }
  if (end === lineLength) {
    start = Math.max(end - 140, 0);
  }

  newLine = newLine.slice(start, end);
  if (start > 0) {
    newLine = `'{snip} ${newLine}`;
  }
  if (end < lineLength) {
    newLine += ' {snip}';
  }

  return newLine;
}

/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */
function safeJoin(input, delimiter) {
  if (!Array.isArray(input)) {
    return '';
  }

  var output = [];
    for (let i = 0; i < input.length; i++) {
    var value = input[i];
    try {
      output.push(String(value));
    } catch (e) {
      output.push('[value cannot be serialized]');
    }
  }

  return output.join(delimiter);
}

/**
 * Checks if the value matches a regex or includes the string
 * @param value The string value to be checked against
 * @param pattern Either a regex or a string that must be contained in value
 */
function isMatchingPattern(value, pattern) {
  if (!(0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(value)) {
    return false;
  }

  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isRegExp */ .Kj)(pattern)) {
    return pattern.test(value);
  }
  if (typeof pattern === 'string') {
    return value.indexOf(pattern) !== -1;
  }
  return false;
}

/**
 * Given a string, escape characters which have meaning in the regex grammar, such that the result is safe to feed to
 * `new RegExp()`.
 *
 * Based on https://github.com/sindresorhus/escape-string-regexp. Vendored to a) reduce the size by skipping the runtime
 * type-checking, and b) ensure it gets down-compiled for old versions of Node (the published package only supports Node
 * 12+).
 *
 * @param regexString The string to escape
 * @returns An version of the string with all special regex characters escaped
 */
function escapeStringForRegex(regexString) {
  // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
  // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
  return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}


//# sourceMappingURL=string.js.map


/***/ }),

/***/ 8823:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ak": function() { return /* binding */ supportsFetch; },
/* harmony export */   "Bf": function() { return /* binding */ supportsHistory; },
/* harmony export */   "Du": function() { return /* binding */ isNativeFetch; },
/* harmony export */   "t$": function() { return /* binding */ supportsNativeFetch; }
/* harmony export */ });
/* unused harmony exports supportsDOMError, supportsDOMException, supportsErrorEvent, supportsReferrerPolicy, supportsReportingObserver */
/* harmony import */ var _global_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82991);
/* harmony import */ var _logger_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12343);



/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */
function supportsErrorEvent() {
  try {
    new ErrorEvent('');
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMError() {
  try {
    // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
    // 1 argument required, but only 0 present.
    // @ts-ignore It really needs 1 argument, not 0.
    new DOMError('');
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMException() {
  try {
    new DOMException('');
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */
function supportsFetch() {
  if (!('fetch' in (0,_global_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)())) {
    return false;
  }

  try {
    new Headers();
    new Request('');
    new Response();
    return true;
  } catch (e) {
    return false;
  }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */
function isNativeFetch(func) {
  return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}

/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */
function supportsNativeFetch() {
  if (!supportsFetch()) {
    return false;
  }

  var global = (0,_global_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)();

  // Fast path to avoid DOM I/O
    if (isNativeFetch(global.fetch)) {
    return true;
  }

  // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
  // so create a "pure" iframe to see if that has native fetch
  let result = false;
  var doc = global.document;
    if (doc && typeof (doc.createElement ) === 'function') {
    try {
      var sandbox = doc.createElement('iframe');
      sandbox.hidden = true;
      doc.head.appendChild(sandbox);
      if (sandbox.contentWindow && sandbox.contentWindow.fetch) {
                result = isNativeFetch(sandbox.contentWindow.fetch);
      }
      doc.head.removeChild(sandbox);
    } catch (err) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        _logger_js__WEBPACK_IMPORTED_MODULE_1__/* .logger.warn */ .kg.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
  }

  return result;
}

/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */
function supportsReportingObserver() {
  return 'ReportingObserver' in getGlobalObject();
}

/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */
function supportsReferrerPolicy() {
  // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
  // (see https://caniuse.com/#feat=referrer-policy),
  // it doesn't. And it throws an exception instead of ignoring this parameter...
  // REF: https://github.com/getsentry/raven-js/issues/1233

  if (!supportsFetch()) {
    return false;
  }

  try {
    new Request('_', {
      referrerPolicy: 'origin' ,
    });
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */
function supportsHistory() {
  // NOTE: in Chrome App environment, touching history.pushState, *even inside
  //       a try/catch block*, will cause Chrome to output an error to console.error
  // borrowed from: https://github.com/angular/angular.js/pull/13945/files
  var global = (0,_global_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)();
      var chrome = (global ).chrome;
  var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    var hasHistoryApi = 'history' in global && !!global.history.pushState && !!global.history.replaceState;

  return !isChromePackagedApp && hasHistoryApi;
}


//# sourceMappingURL=supports.js.map


/***/ }),

/***/ 96893:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$2": function() { return /* binding */ rejectedSyncPromise; },
/* harmony export */   "WD": function() { return /* binding */ resolvedSyncPromise; },
/* harmony export */   "cW": function() { return /* binding */ SyncPromise; }
/* harmony export */ });
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67597);


/** SyncPromise internal states */
var States; (function (States) {
  /** Pending */
  var PENDING = 0; States[States["PENDING"] = PENDING] = "PENDING";
  /** Resolved / OK */
  var RESOLVED = 1; States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
  /** Rejected / Error */
  var REJECTED = 2; States[States["REJECTED"] = REJECTED] = "REJECTED";
})(States || (States = {}));

// Overloads so we can call resolvedSyncPromise without arguments and generic argument

/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */
function resolvedSyncPromise(value) {
  return new SyncPromise(resolve => {
    resolve(value);
  });
}

/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */
function rejectedSyncPromise(reason) {
  return new SyncPromise((_, reject) => {
    reject(reason);
  });
}

/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */
class SyncPromise {
   __init() {this._state = States.PENDING;}
   __init2() {this._handlers = [];}
  

   constructor(
    executor,
  ) {;SyncPromise.prototype.__init.call(this);SyncPromise.prototype.__init2.call(this);SyncPromise.prototype.__init3.call(this);SyncPromise.prototype.__init4.call(this);SyncPromise.prototype.__init5.call(this);SyncPromise.prototype.__init6.call(this);
    try {
      executor(this._resolve, this._reject);
    } catch (e) {
      this._reject(e);
    }
  }

  /** JSDoc */
   then(
    onfulfilled,
    onrejected,
  ) {
    return new SyncPromise((resolve, reject) => {
      this._handlers.push([
        false,
        result => {
          if (!onfulfilled) {
            // TODO: ¯\_(ツ)_/¯
            // TODO: FIXME
            resolve(result );
          } else {
            try {
              resolve(onfulfilled(result));
            } catch (e) {
              reject(e);
            }
          }
        },
        reason => {
          if (!onrejected) {
            reject(reason);
          } else {
            try {
              resolve(onrejected(reason));
            } catch (e) {
              reject(e);
            }
          }
        },
      ]);
      this._executeHandlers();
    });
  }

  /** JSDoc */
   catch(
    onrejected,
  ) {
    return this.then(val => val, onrejected);
  }

  /** JSDoc */
   finally(onfinally) {
    return new SyncPromise((resolve, reject) => {
      let val;
      let isRejected;

      return this.then(
        value => {
          isRejected = false;
          val = value;
          if (onfinally) {
            onfinally();
          }
        },
        reason => {
          isRejected = true;
          val = reason;
          if (onfinally) {
            onfinally();
          }
        },
      ).then(() => {
        if (isRejected) {
          reject(val);
          return;
        }

        resolve(val );
      });
    });
  }

  /** JSDoc */
    __init3() {this._resolve = (value) => {
    this._setResult(States.RESOLVED, value);
  };}

  /** JSDoc */
    __init4() {this._reject = (reason) => {
    this._setResult(States.REJECTED, reason);
  };}

  /** JSDoc */
    __init5() {this._setResult = (state, value) => {
    if (this._state !== States.PENDING) {
      return;
    }

    if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isThenable */ .J8)(value)) {
      void (value ).then(this._resolve, this._reject);
      return;
    }

    this._state = state;
    this._value = value;

    this._executeHandlers();
  };}

  /** JSDoc */
    __init6() {this._executeHandlers = () => {
    if (this._state === States.PENDING) {
      return;
    }

    var cachedHandlers = this._handlers.slice();
    this._handlers = [];

    cachedHandlers.forEach(handler => {
      if (handler[0]) {
        return;
      }

      if (this._state === States.RESOLVED) {
                handler[1](this._value );
      }

      if (this._state === States.REJECTED) {
        handler[2](this._value);
      }

      handler[0] = true;
    });
  };}
}


//# sourceMappingURL=syncpromise.js.map


/***/ }),

/***/ 21170:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z1": function() { return /* binding */ browserPerformanceTimeOrigin; },
/* harmony export */   "_I": function() { return /* binding */ timestampWithMs; },
/* harmony export */   "ph": function() { return /* binding */ timestampInSeconds; },
/* harmony export */   "yW": function() { return /* binding */ dateTimestampInSeconds; }
/* harmony export */ });
/* unused harmony exports _browserPerformanceTimeOriginMode, usingPerformanceAPI */
/* harmony import */ var _global_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82991);
/* harmony import */ var _node_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92448);
/* module decorator */ module = __webpack_require__.hmd(module);



/**
 * An object that can return the current timestamp in seconds since the UNIX epoch.
 */

/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */
var dateTimestampSource = {
  nowSeconds: () => Date.now() / 1000,
};

/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */

/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */
function getBrowserPerformance() {
  const { performance } = (0,_global_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)();
  if (!performance || !performance.now) {
    return undefined;
  }

  // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
  //
  // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
  // performance.now() gives a date arbitrarily in the past.
  //
  // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
  // undefined.
  //
  // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
  // interact with data coming out of performance entries.
  //
  // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
  // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
  // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
  // observed skews that can be as long as days, weeks or months.
  //
  // See https://github.com/getsentry/sentry-javascript/issues/2590.
  //
  // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
  // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
  // transactions of long-lived web pages.
  var timeOrigin = Date.now() - performance.now();

  return {
    now: () => performance.now(),
    timeOrigin,
  };
}

/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */
function getNodePerformance() {
  try {
    var perfHooks = (0,_node_js__WEBPACK_IMPORTED_MODULE_1__/* .dynamicRequire */ .l$)(module, 'perf_hooks') ;
    return perfHooks.performance;
  } catch (_) {
    return undefined;
  }
}

/**
 * The Performance API implementation for the current platform, if available.
 */
var platformPerformance = (0,_node_js__WEBPACK_IMPORTED_MODULE_1__/* .isNodeEnv */ .KV)() ? getNodePerformance() : getBrowserPerformance();

var timestampSource =
  platformPerformance === undefined
    ? dateTimestampSource
    : {
        nowSeconds: () => (platformPerformance.timeOrigin + platformPerformance.now()) / 1000,
      };

/**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */
var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);

/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * See `usingPerformanceAPI` to test whether the Performance API is used.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */
var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);

// Re-exported with an old name for backwards-compatibility.
var timestampWithMs = timestampInSeconds;

/**
 * A boolean that is true when timestampInSeconds uses the Performance API to produce monotonic timestamps.
 */
var usingPerformanceAPI = platformPerformance !== undefined;

/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */
let _browserPerformanceTimeOriginMode;

/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */
var browserPerformanceTimeOrigin = (() => {
  // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
  // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
  // data as reliable if they are within a reasonable threshold of the current time.

  const { performance } = (0,_global_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)();
  if (!performance || !performance.now) {
    _browserPerformanceTimeOriginMode = 'none';
    return undefined;
  }

  var threshold = 3600 * 1000;
  var performanceNow = performance.now();
  var dateNow = Date.now();

  // if timeOrigin isn't available set delta to threshold so it isn't used
  var timeOriginDelta = performance.timeOrigin
    ? Math.abs(performance.timeOrigin + performanceNow - dateNow)
    : threshold;
  var timeOriginIsReliable = timeOriginDelta < threshold;

  // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
  // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
  // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
  // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
  // Date API.
    var navigationStart = performance.timing && performance.timing.navigationStart;
  var hasNavigationStart = typeof navigationStart === 'number';
  // if navigationStart isn't available set delta to threshold so it isn't used
  var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
  var navigationStartIsReliable = navigationStartDelta < threshold;

  if (timeOriginIsReliable || navigationStartIsReliable) {
    // Use the more reliable time origin
    if (timeOriginDelta <= navigationStartDelta) {
      _browserPerformanceTimeOriginMode = 'timeOrigin';
      return performance.timeOrigin;
    } else {
      _browserPerformanceTimeOriginMode = 'navigationStart';
      return navigationStart;
    }
  }

  // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
  _browserPerformanceTimeOriginMode = 'dateNow';
  return dateNow;
})();


//# sourceMappingURL=time.js.map


/***/ }),

/***/ 16395:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var _global = (typeof window !== 'undefined' ? window : typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"89483e39899c62e9fdfcd9fcbfcfd1716505f7b0"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["yogobe-web@yogobe"]={id:"89483e39899c62e9fdfcd9fcbfcfd1716505f7b0"};
      

/***/ }),

/***/ 37947:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "css": function() { return /* binding */ css; },
/* harmony export */   "get": function() { return /* binding */ get; },
/* harmony export */   "responsive": function() { return /* binding */ responsive; }
/* harmony export */ });
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// based on https://github.com/developit/dlv
var get = function get(obj, key, def, p, undef) {
  key = key && key.split ? key.split('.') : [key];

  for (p = 0; p < key.length; p++) {
    obj = obj ? obj[key[p]] : undef;
  }

  return obj === undef ? def : obj;
};
var defaultBreakpoints = [40, 52, 64].map(function (n) {
  return n + 'em';
});
var defaultTheme = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72]
};
var aliases = {
  bg: 'backgroundColor',
  m: 'margin',
  mt: 'marginTop',
  mr: 'marginRight',
  mb: 'marginBottom',
  ml: 'marginLeft',
  mx: 'marginX',
  my: 'marginY',
  p: 'padding',
  pt: 'paddingTop',
  pr: 'paddingRight',
  pb: 'paddingBottom',
  pl: 'paddingLeft',
  px: 'paddingX',
  py: 'paddingY'
};
var multiples = {
  marginX: ['marginLeft', 'marginRight'],
  marginY: ['marginTop', 'marginBottom'],
  paddingX: ['paddingLeft', 'paddingRight'],
  paddingY: ['paddingTop', 'paddingBottom'],
  size: ['width', 'height']
};
var scales = {
  color: 'colors',
  backgroundColor: 'colors',
  borderColor: 'colors',
  margin: 'space',
  marginTop: 'space',
  marginRight: 'space',
  marginBottom: 'space',
  marginLeft: 'space',
  marginX: 'space',
  marginY: 'space',
  padding: 'space',
  paddingTop: 'space',
  paddingRight: 'space',
  paddingBottom: 'space',
  paddingLeft: 'space',
  paddingX: 'space',
  paddingY: 'space',
  top: 'space',
  right: 'space',
  bottom: 'space',
  left: 'space',
  gridGap: 'space',
  gridColumnGap: 'space',
  gridRowGap: 'space',
  gap: 'space',
  columnGap: 'space',
  rowGap: 'space',
  fontFamily: 'fonts',
  fontSize: 'fontSizes',
  fontWeight: 'fontWeights',
  lineHeight: 'lineHeights',
  letterSpacing: 'letterSpacings',
  border: 'borders',
  borderTop: 'borders',
  borderRight: 'borders',
  borderBottom: 'borders',
  borderLeft: 'borders',
  borderWidth: 'borderWidths',
  borderStyle: 'borderStyles',
  borderRadius: 'radii',
  borderTopRightRadius: 'radii',
  borderTopLeftRadius: 'radii',
  borderBottomRightRadius: 'radii',
  borderBottomLeftRadius: 'radii',
  borderTopWidth: 'borderWidths',
  borderTopColor: 'colors',
  borderTopStyle: 'borderStyles',
  borderBottomWidth: 'borderWidths',
  borderBottomColor: 'colors',
  borderBottomStyle: 'borderStyles',
  borderLeftWidth: 'borderWidths',
  borderLeftColor: 'colors',
  borderLeftStyle: 'borderStyles',
  borderRightWidth: 'borderWidths',
  borderRightColor: 'colors',
  borderRightStyle: 'borderStyles',
  outlineColor: 'colors',
  boxShadow: 'shadows',
  textShadow: 'shadows',
  zIndex: 'zIndices',
  width: 'sizes',
  minWidth: 'sizes',
  maxWidth: 'sizes',
  height: 'sizes',
  minHeight: 'sizes',
  maxHeight: 'sizes',
  flexBasis: 'sizes',
  size: 'sizes',
  // svg
  fill: 'colors',
  stroke: 'colors'
};

var positiveOrNegative = function positiveOrNegative(scale, value) {
  if (typeof value !== 'number' || value >= 0) {
    return get(scale, value, value);
  }

  var absolute = Math.abs(value);
  var n = get(scale, absolute, absolute);
  if (typeof n === 'string') return '-' + n;
  return n * -1;
};

var transforms = ['margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'top', 'bottom', 'left', 'right'].reduce(function (acc, curr) {
  var _extends2;

  return _extends({}, acc, (_extends2 = {}, _extends2[curr] = positiveOrNegative, _extends2));
}, {});
var responsive = function responsive(styles) {
  return function (theme) {
    var next = {};
    var breakpoints = get(theme, 'breakpoints', defaultBreakpoints);
    var mediaQueries = [null].concat(breakpoints.map(function (n) {
      return "@media screen and (min-width: " + n + ")";
    }));

    for (var key in styles) {
      var value = typeof styles[key] === 'function' ? styles[key](theme) : styles[key];
      if (value == null) continue;

      if (!Array.isArray(value)) {
        next[key] = value;
        continue;
      }

      for (var i = 0; i < value.slice(0, mediaQueries.length).length; i++) {
        var media = mediaQueries[i];

        if (!media) {
          next[key] = value[i];
          continue;
        }

        next[media] = next[media] || {};
        if (value[i] == null) continue;
        next[media][key] = value[i];
      }
    }

    return next;
  };
};
var css = function css(args) {
  return function (props) {
    if (props === void 0) {
      props = {};
    }

    var theme = _extends({}, defaultTheme, {}, props.theme || props);

    var result = {};
    var obj = typeof args === 'function' ? args(theme) : args;
    var styles = responsive(obj)(theme);

    for (var key in styles) {
      var x = styles[key];
      var val = typeof x === 'function' ? x(theme) : x;

      if (key === 'variant') {
        var variant = css(get(theme, val))(theme);
        result = _extends({}, result, {}, variant);
        continue;
      }

      if (val && typeof val === 'object') {
        result[key] = css(val)(theme);
        continue;
      }

      var prop = get(aliases, key, key);
      var scaleName = get(scales, prop);
      var scale = get(theme, scaleName, get(theme, prop, {}));
      var transform = get(transforms, prop, get);
      var value = transform(scale, val, val);

      if (multiples[prop]) {
        var dirs = multiples[prop];

        for (var i = 0; i < dirs.length; i++) {
          result[dirs[i]] = value;
        }
      } else {
        result[prop] = value;
      }
    }

    return result;
  };
};
/* harmony default export */ __webpack_exports__["default"] = (css);


/***/ }),

/***/ 61979:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "createShouldForwardProp": function() { return /* binding */ createShouldForwardProp; },
  "default": function() { return /* binding */ dist_index_esm; },
  "props": function() { return /* binding */ props; }
});

;// CONCATENATED MODULE: ./node_modules/@styled-system/should-forward-prop/node_modules/@emotion/memoize/dist/emotion-memoize.browser.esm.js
function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ var emotion_memoize_browser_esm = (memoize);

// EXTERNAL MODULE: ./node_modules/@emotion/is-prop-valid/dist/is-prop-valid.browser.esm.js + 1 modules
var is_prop_valid_browser_esm = __webpack_require__(24465);
// EXTERNAL MODULE: ./node_modules/styled-system/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(74786);
;// CONCATENATED MODULE: ./node_modules/@styled-system/should-forward-prop/dist/index.esm.js



var index_esm_all = (0,index_esm.compose)(index_esm.space, index_esm.typography, index_esm.color, index_esm.layout, index_esm.flexbox, index_esm.border, index_esm.background, index_esm.position, index_esm.grid, index_esm.shadow, index_esm.buttonStyle, index_esm.textStyle, index_esm.colorStyle);
var props = index_esm_all.propNames;
var createShouldForwardProp = function createShouldForwardProp(props) {
  var regex = new RegExp("^(" + props.join('|') + ")$");
  return emotion_memoize_browser_esm(function (prop) {
    return (0,is_prop_valid_browser_esm/* default */.Z)(prop) && !regex.test(prop);
  });
};
/* harmony default export */ var dist_index_esm = (createShouldForwardProp(props));


/***/ }),

/***/ 82152:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ equal; }
/* harmony export */ });
/* unused harmony export default */
var _a = Object.prototype, toString = _a.toString, hasOwnProperty = _a.hasOwnProperty;
var fnToStr = Function.prototype.toString;
var previousComparisons = new Map();
/**
 * Performs a deep equality check on two JavaScript values, tolerating cycles.
 */
function equal(a, b) {
    try {
        return check(a, b);
    }
    finally {
        previousComparisons.clear();
    }
}
function check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) {
        return true;
    }
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    var aTag = toString.call(a);
    var bTag = toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) {
        return false;
    }
    switch (aTag) {
        case '[object Array]':
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length)
                return false;
        // Fall through to object case...
        case '[object Object]': {
            if (previouslyCompared(a, b))
                return true;
            var aKeys = definedKeys(a);
            var bKeys = definedKeys(b);
            // If `a` and `b` have a different number of enumerable keys, they
            // must be different.
            var keyCount = aKeys.length;
            if (keyCount !== bKeys.length)
                return false;
            // Now make sure they have the same keys.
            for (var k = 0; k < keyCount; ++k) {
                if (!hasOwnProperty.call(b, aKeys[k])) {
                    return false;
                }
            }
            // Finally, check deep equality of all child properties.
            for (var k = 0; k < keyCount; ++k) {
                var key = aKeys[k];
                if (!check(a[key], b[key])) {
                    return false;
                }
            }
            return true;
        }
        case '[object Error]':
            return a.name === b.name && a.message === b.message;
        case '[object Number]':
            // Handle NaN, which is !== itself.
            if (a !== a)
                return b !== b;
        // Fall through to shared +a === +b case...
        case '[object Boolean]':
        case '[object Date]':
            return +a === +b;
        case '[object RegExp]':
        case '[object String]':
            return a == "" + b;
        case '[object Map]':
        case '[object Set]': {
            if (a.size !== b.size)
                return false;
            if (previouslyCompared(a, b))
                return true;
            var aIterator = a.entries();
            var isMap = aTag === '[object Map]';
            while (true) {
                var info = aIterator.next();
                if (info.done)
                    break;
                // If a instanceof Set, aValue === aKey.
                var _a = info.value, aKey = _a[0], aValue = _a[1];
                // So this works the same way for both Set and Map.
                if (!b.has(aKey)) {
                    return false;
                }
                // However, we care about deep equality of values only when dealing
                // with Map structures.
                if (isMap && !check(aValue, b.get(aKey))) {
                    return false;
                }
            }
            return true;
        }
        case '[object Uint16Array]':
        case '[object Uint8Array]': // Buffer, in Node.js.
        case '[object Uint32Array]':
        case '[object Int32Array]':
        case '[object Int8Array]':
        case '[object Int16Array]':
        case '[object ArrayBuffer]':
            // DataView doesn't need these conversions, but the equality check is
            // otherwise the same.
            a = new Uint8Array(a);
            b = new Uint8Array(b);
        // Fall through...
        case '[object DataView]': {
            var len = a.byteLength;
            if (len === b.byteLength) {
                while (len-- && a[len] === b[len]) {
                    // Keep looping as long as the bytes are equal.
                }
            }
            return len === -1;
        }
        case '[object AsyncFunction]':
        case '[object GeneratorFunction]':
        case '[object AsyncGeneratorFunction]':
        case '[object Function]': {
            var aCode = fnToStr.call(a);
            if (aCode !== fnToStr.call(b)) {
                return false;
            }
            // We consider non-native functions equal if they have the same code
            // (native functions require === because their code is censored).
            // Note that this behavior is not entirely sound, since !== function
            // objects with the same code can behave differently depending on
            // their closure scope. However, any function can behave differently
            // depending on the values of its input arguments (including this)
            // and its calling context (including its closure scope), even
            // though the function object is === to itself; and it is entirely
            // possible for functions that are not === to behave exactly the
            // same under all conceivable circumstances. Because none of these
            // factors are statically decidable in JavaScript, JS function
            // equality is not well-defined. This ambiguity allows us to
            // consider the best possible heuristic among various imperfect
            // options, and equating non-native functions that have the same
            // code has enormous practical benefits, such as when comparing
            // functions that are repeatedly passed as fresh function
            // expressions within objects that are otherwise deeply equal. Since
            // any function created from the same syntactic expression (in the
            // same code location) will always stringify to the same code
            // according to fnToStr.call, we can reasonably expect these
            // repeatedly passed function expressions to have the same code, and
            // thus behave "the same" (with all the caveats mentioned above),
            // even though the runtime function objects are !== to one another.
            return !endsWith(aCode, nativeCodeSuffix);
        }
    }
    // Otherwise the values are not equal.
    return false;
}
function definedKeys(obj) {
    // Remember that the second argument to Array.prototype.filter will be
    // used as `this` within the callback function.
    return Object.keys(obj).filter(isDefinedKey, obj);
}
function isDefinedKey(key) {
    return this[key] !== void 0;
}
var nativeCodeSuffix = "{ [native code] }";
function endsWith(full, suffix) {
    var fromIndex = full.length - suffix.length;
    return fromIndex >= 0 &&
        full.indexOf(suffix, fromIndex) === fromIndex;
}
function previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    var bSet = previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b))
            return true;
    }
    else {
        previousComparisons.set(a, bSet = new Set);
    }
    bSet.add(b);
    return false;
}


//# sourceMappingURL=equality.esm.js.map


/***/ }),

/***/ 657:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ Trie; }
/* harmony export */ });
// A [trie](https://en.wikipedia.org/wiki/Trie) data structure that holds
// object keys weakly, yet can also hold non-object keys, unlike the
// native `WeakMap`.
// If no makeData function is supplied, the looked-up data will be an empty,
// null-prototype Object.
var defaultMakeData = function () { return Object.create(null); };
// Useful for processing arguments objects as well as arrays.
var _a = Array.prototype, forEach = _a.forEach, slice = _a.slice;
var Trie = /** @class */ (function () {
    function Trie(weakness, makeData) {
        if (weakness === void 0) { weakness = true; }
        if (makeData === void 0) { makeData = defaultMakeData; }
        this.weakness = weakness;
        this.makeData = makeData;
    }
    Trie.prototype.lookup = function () {
        var array = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            array[_i] = arguments[_i];
        }
        return this.lookupArray(array);
    };
    Trie.prototype.lookupArray = function (array) {
        var node = this;
        forEach.call(array, function (key) { return node = node.getChildTrie(key); });
        return node.data || (node.data = this.makeData(slice.call(array)));
    };
    Trie.prototype.getChildTrie = function (key) {
        var map = this.weakness && isObjRef(key)
            ? this.weak || (this.weak = new WeakMap())
            : this.strong || (this.strong = new Map());
        var child = map.get(key);
        if (!child)
            map.set(key, child = new Trie(this.weakness, this.makeData));
        return child;
    };
    return Trie;
}());
function isObjRef(value) {
    switch (typeof value) {
        case "object":
            if (value === null)
                break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}


//# sourceMappingURL=trie.esm.js.map


/***/ }),

/***/ 19494:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ newInstance; }
});

;// CONCATENATED MODULE: ./node_modules/@amplitude/utils/esm/src/misc.js
/* provided dependency */ var process = __webpack_require__(34155);

/**
 * Checks whether we're in a Node.js environment
 *
 * @returns Answer to given question
 */
function isNodeEnv() {
    var _a;
    return typeof process === 'object' && ((_a = process === null || process === void 0 ? void 0 : process.versions) === null || _a === void 0 ? void 0 : _a.node) !== undefined;
}
/**
 * Checks whether we're in a browser environment
 *
 * @returns Answer to given question
 */
function isBrowserEnv() {
    return typeof window === 'object' && (window === null || window === void 0 ? void 0 : window.document) !== undefined;
}
var fallbackGlobalObject = {};
/**
 * Safely get global scope object
 *
 * @returns Global scope object
 */
var getGlobalObject = function () {
    if (isNodeEnv()) {
        return __webpack_require__.g;
    }
    else if (typeof window !== 'undefined') {
        return window;
    }
    else if (typeof self !== 'undefined') {
        return self;
    }
    else {
        return fallbackGlobalObject;
    }
};
var getGlobalAmplitudeNamespace = function () {
    var global = getGlobalObject();
    if (global.__AMPLITUDE__ === undefined) {
        global.__AMPLITUDE__ = {};
    }
    return global.__AMPLITUDE__;
};
/**
 * A promise-based way to sleep for x millseconds, then queue ourselves back to the
 * JS event loop.
 *
 * @param milliseconds The number of milliseconds to wait for
 */
var asyncSleep = function (milliseconds) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, milliseconds); })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
/**
 * Fixes browser edge case where Prototype.js injects Array.prototype.toJSON and breaks the built-in JSON.stringify()
 *
 * @returns true if Array.prototype.toJSON was deleted, false if not
 */
var prototypeJsFix = function () {
    var _a;
    if (isBrowserEnv()) {
        var augmentedWindow = window;
        var augmentedArray = Array;
        if (augmentedWindow.Prototype !== undefined && ((_a = augmentedArray.prototype) === null || _a === void 0 ? void 0 : _a.toJSON) !== undefined) {
            delete augmentedArray.prototype.toJSON;
            return true;
        }
    }
    return false;
};
//# sourceMappingURL=misc.js.map
// EXTERNAL MODULE: ./node_modules/blueimp-md5/js/md5.js
var md5 = __webpack_require__(99560);
var md5_default = /*#__PURE__*/__webpack_require__.n(md5);
// EXTERNAL MODULE: ./node_modules/query-string/index.js
var query_string = __webpack_require__(17563);
// EXTERNAL MODULE: ./node_modules/@amplitude/ua-parser-js/src/ua-parser.js
var ua_parser = __webpack_require__(29293);
var ua_parser_default = /*#__PURE__*/__webpack_require__.n(ua_parser);
// EXTERNAL MODULE: ./node_modules/@amplitude/analytics-connector/dist/analyticsConnector.umd.js
var analyticsConnector_umd = __webpack_require__(59185);
;// CONCATENATED MODULE: ./node_modules/amplitude-js/amplitude.esm.js
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];






function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

var Constants = {
  DEFAULT_INSTANCE: '$default_instance',
  API_VERSION: 2,
  MAX_STRING_LENGTH: 4096,
  MAX_PROPERTY_KEYS: 1000,
  IDENTIFY_EVENT: '$identify',
  GROUP_IDENTIFY_EVENT: '$groupidentify',
  EVENT_LOG_URL: 'api.amplitude.com',
  EVENT_LOG_EU_URL: 'api.eu.amplitude.com',
  DYNAMIC_CONFIG_URL: 'regionconfig.amplitude.com',
  DYNAMIC_CONFIG_EU_URL: 'regionconfig.eu.amplitude.com',
  // localStorageKeys
  LAST_EVENT_ID: 'amplitude_lastEventId',
  LAST_EVENT_TIME: 'amplitude_lastEventTime',
  LAST_IDENTIFY_ID: 'amplitude_lastIdentifyId',
  LAST_SEQUENCE_NUMBER: 'amplitude_lastSequenceNumber',
  SESSION_ID: 'amplitude_sessionId',
  // Used in cookie as well
  DEVICE_ID: 'amplitude_deviceId',
  OPT_OUT: 'amplitude_optOut',
  USER_ID: 'amplitude_userId',
  // indexes of properties in cookie v2 storage format
  DEVICE_ID_INDEX: 0,
  USER_ID_INDEX: 1,
  OPT_OUT_INDEX: 2,
  SESSION_ID_INDEX: 3,
  LAST_EVENT_TIME_INDEX: 4,
  EVENT_ID_INDEX: 5,
  IDENTIFY_ID_INDEX: 6,
  SEQUENCE_NUMBER_INDEX: 7,
  COOKIE_TEST_PREFIX: 'amp_cookie_test',
  COOKIE_PREFIX: 'amp',
  // Storage options
  STORAGE_DEFAULT: '',
  STORAGE_COOKIES: 'cookies',
  STORAGE_NONE: 'none',
  STORAGE_LOCAL: 'localStorage',
  STORAGE_SESSION: 'sessionStorage',
  // revenue keys
  REVENUE_EVENT: 'revenue_amount',
  REVENUE_PRODUCT_ID: '$productId',
  REVENUE_QUANTITY: '$quantity',
  REVENUE_PRICE: '$price',
  REVENUE_REVENUE_TYPE: '$revenueType',
  AMP_DEVICE_ID_PARAM: 'amp_device_id',
  // url param
  REFERRER: 'referrer',
  // UTM Params
  UTM_SOURCE: 'utm_source',
  UTM_MEDIUM: 'utm_medium',
  UTM_CAMPAIGN: 'utm_campaign',
  UTM_TERM: 'utm_term',
  UTM_CONTENT: 'utm_content',
  ATTRIBUTION_EVENT: '[Amplitude] Attribution Captured',
  TRANSPORT_HTTP: 'http',
  TRANSPORT_BEACON: 'beacon'
};

/*
 * UTF-8 encoder/decoder
 * http://www.webtoolkit.info/
 */
var UTF8 = {
  encode: function encode(s) {
    var utftext = '';

    for (var n = 0; n < s.length; n++) {
      var c = s.charCodeAt(n);

      if (c < 128) {
        utftext += String.fromCharCode(c);
      } else if (c > 127 && c < 2048) {
        utftext += String.fromCharCode(c >> 6 | 192);
        utftext += String.fromCharCode(c & 63 | 128);
      } else {
        utftext += String.fromCharCode(c >> 12 | 224);
        utftext += String.fromCharCode(c >> 6 & 63 | 128);
        utftext += String.fromCharCode(c & 63 | 128);
      }
    }

    return utftext;
  },
  decode: function decode(utftext) {
    var s = '';
    var i = 0;
    var c = 0,
        c1 = 0,
        c2 = 0;

    while (i < utftext.length) {
      c = utftext.charCodeAt(i);

      if (c < 128) {
        s += String.fromCharCode(c);
        i++;
      } else if (c > 191 && c < 224) {
        c1 = utftext.charCodeAt(i + 1);
        s += String.fromCharCode((c & 31) << 6 | c1 & 63);
        i += 2;
      } else {
        c1 = utftext.charCodeAt(i + 1);
        c2 = utftext.charCodeAt(i + 2);
        s += String.fromCharCode((c & 15) << 12 | (c1 & 63) << 6 | c2 & 63);
        i += 3;
      }
    }

    return s;
  }
};

/* global globalThis */
var GlobalScope = function () {
  if (typeof globalThis !== 'undefined') {
    return globalThis;
  }

  if (typeof window !== 'undefined') {
    return window;
  }

  if (typeof self !== 'undefined') {
    return self;
  }

  if (typeof __webpack_require__.g !== 'undefined') {
    return __webpack_require__.g;
  }
}();

/*
 * Base64 encoder/decoder
 * http://www.webtoolkit.info/
 */

var Base64 = {
  _keyStr: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
  encode: function encode(input) {
    try {
      if (GlobalScope.btoa && GlobalScope.atob) {
        return GlobalScope.btoa(unescape(encodeURIComponent(input)));
      }
    } catch (e) {//log(e);
    }

    return Base64._encode(input);
  },
  _encode: function _encode(input) {
    var output = '';
    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
    var i = 0;
    input = UTF8.encode(input);

    while (i < input.length) {
      chr1 = input.charCodeAt(i++);
      chr2 = input.charCodeAt(i++);
      chr3 = input.charCodeAt(i++);
      enc1 = chr1 >> 2;
      enc2 = (chr1 & 3) << 4 | chr2 >> 4;
      enc3 = (chr2 & 15) << 2 | chr3 >> 6;
      enc4 = chr3 & 63;

      if (isNaN(chr2)) {
        enc3 = enc4 = 64;
      } else if (isNaN(chr3)) {
        enc4 = 64;
      }

      output = output + Base64._keyStr.charAt(enc1) + Base64._keyStr.charAt(enc2) + Base64._keyStr.charAt(enc3) + Base64._keyStr.charAt(enc4);
    }

    return output;
  },
  decode: function decode(input) {
    try {
      if (GlobalScope.btoa && GlobalScope.atob) {
        return decodeURIComponent(escape(GlobalScope.atob(input)));
      }
    } catch (e) {//log(e);
    }

    return Base64._decode(input);
  },
  _decode: function _decode(input) {
    var output = '';
    var chr1, chr2, chr3;
    var enc1, enc2, enc3, enc4;
    var i = 0;
    input = input.replace(/[^A-Za-z0-9+/=]/g, '');

    while (i < input.length) {
      enc1 = Base64._keyStr.indexOf(input.charAt(i++));
      enc2 = Base64._keyStr.indexOf(input.charAt(i++));
      enc3 = Base64._keyStr.indexOf(input.charAt(i++));
      enc4 = Base64._keyStr.indexOf(input.charAt(i++));
      chr1 = enc1 << 2 | enc2 >> 4;
      chr2 = (enc2 & 15) << 4 | enc3 >> 2;
      chr3 = (enc3 & 3) << 6 | enc4;
      output = output + String.fromCharCode(chr1);

      if (enc3 !== 64) {
        output = output + String.fromCharCode(chr2);
      }

      if (enc4 !== 64) {
        output = output + String.fromCharCode(chr3);
      }
    }

    output = UTF8.decode(output);
    return output;
  }
};

/**
 * toString ref.
 * @private
 */
var amplitude_esm_toString = Object.prototype.toString;
/**
 * Return the type of `val`.
 * @private
 * @param {Mixed} val
 * @return {String}
 * @api public
 */

function type (val) {
  switch (amplitude_esm_toString.call(val)) {
    case '[object Date]':
      return 'date';

    case '[object RegExp]':
      return 'regexp';

    case '[object Arguments]':
      return 'arguments';

    case '[object Array]':
      return 'array';

    case '[object Error]':
      return 'error';
  }

  if (val === null) {
    return 'null';
  }

  if (val === undefined) {
    return 'undefined';
  }

  if (val !== val) {
    return 'nan';
  }

  if (val && val.nodeType === 1) {
    return 'element';
  }

  if (typeof Buffer !== 'undefined' && typeof Buffer.isBuffer === 'function' && Buffer.isBuffer(val)) {
    return 'buffer';
  }

  val = val.valueOf ? val.valueOf() : Object.prototype.valueOf.apply(val);
  return _typeof(val);
}

var logLevels = {
  DISABLE: 0,
  ERROR: 1,
  WARN: 2,
  INFO: 3
};
var logLevel = logLevels.WARN;

var setLogLevel = function setLogLevel(logLevelName) {
  if (Object.prototype.hasOwnProperty.call(logLevels, logLevelName)) {
    logLevel = logLevels[logLevelName];
  }
};

var getLogLevel = function getLogLevel() {
  return logLevel;
};

var log = {
  error: function error(s) {
    if (logLevel >= logLevels.ERROR) {
      _log(s);
    }
  },
  warn: function warn(s) {
    if (logLevel >= logLevels.WARN) {
      _log(s);
    }
  },
  info: function info(s) {
    if (logLevel >= logLevels.INFO) {
      _log(s);
    }
  }
};

var _log = function _log(s) {
  try {
    console.log('[Amplitude] ' + s);
  } catch (e) {// console logging not available
  }
};

var isEmptyString = function isEmptyString(str) {
  return !str || str.length === 0;
};

var sessionStorageEnabled = function sessionStorageEnabled() {
  try {
    if (GlobalScope.sessionStorage) {
      return true;
    }
  } catch (e) {// sessionStorage disabled
  }

  return false;
}; // truncate string values in event and user properties so that request size does not get too large


var truncate = function truncate(value) {
  if (type(value) === 'array') {
    for (var i = 0; i < value.length; i++) {
      value[i] = truncate(value[i]);
    }
  } else if (type(value) === 'object') {
    for (var key in value) {
      if (key in value) {
        value[key] = truncate(value[key]);
      }
    }
  } else {
    value = _truncateValue(value);
  }

  return value;
};

var _truncateValue = function _truncateValue(value) {
  if (type(value) === 'string') {
    return value.length > Constants.MAX_STRING_LENGTH ? value.substring(0, Constants.MAX_STRING_LENGTH) : value;
  }

  return value;
};

var validateInput = function validateInput(input, name, expectedType) {
  if (type(input) !== expectedType) {
    log.error('Invalid ' + name + ' input type. Expected ' + expectedType + ' but received ' + type(input));
    return false;
  }

  return true;
};

var validateDeviceId = function validateDeviceId(deviceId) {
  if (!validateInput(deviceId, 'deviceId', 'string')) {
    return false;
  }

  if (deviceId.includes('.')) {
    log.error("Device IDs may not contain '.' characters. Value will be ignored: \"".concat(deviceId, "\""));
    return false;
  }

  return true;
};

var validateTransport = function validateTransport(transport) {
  if (!validateInput(transport, 'transport', 'string')) {
    return false;
  }

  if (transport !== Constants.TRANSPORT_HTTP && transport !== Constants.TRANSPORT_BEACON) {
    log.error("transport value must be one of '".concat(Constants.TRANSPORT_BEACON, "' or '").concat(Constants.TRANSPORT_HTTP, "'"));
    return false;
  }

  if (transport !== Constants.TRANSPORT_HTTP && !navigator.sendBeacon) {
    log.error("browser does not support sendBeacon, so transport must be HTTP");
    return false;
  }

  return true;
}; // do some basic sanitization and type checking, also catch property dicts with more than 1000 key/value pairs


var validateProperties = function validateProperties(properties) {
  var propsType = type(properties);

  if (propsType !== 'object') {
    log.error('Error: invalid properties format. Expecting Javascript object, received ' + propsType + ', ignoring');
    return {};
  }

  if (Object.keys(properties).length > Constants.MAX_PROPERTY_KEYS) {
    log.error('Error: too many properties (more than 1000), ignoring');
    return {};
  }

  var copy = {}; // create a copy with all of the valid properties

  for (var property in properties) {
    if (!Object.prototype.hasOwnProperty.call(properties, property)) {
      continue;
    } // validate key


    var key = property;
    var keyType = type(key);

    if (keyType !== 'string') {
      key = String(key);
      log.warn('WARNING: Non-string property key, received type ' + keyType + ', coercing to string "' + key + '"');
    } // validate value


    var value = validatePropertyValue(key, properties[property]);

    if (value === null) {
      continue;
    }

    copy[key] = value;
  }

  return copy;
};

var invalidValueTypes = ['nan', 'function', 'arguments', 'regexp', 'element'];

var validatePropertyValue = function validatePropertyValue(key, value) {
  var valueType = type(value);

  if (invalidValueTypes.indexOf(valueType) !== -1) {
    log.warn('WARNING: Property key "' + key + '" with invalid value type ' + valueType + ', ignoring');
    value = null;
  } else if (valueType === 'undefined') {
    value = null;
  } else if (valueType === 'error') {
    value = String(value);
    log.warn('WARNING: Property key "' + key + '" with value type error, coercing to ' + value);
  } else if (valueType === 'array') {
    // check for nested arrays or objects
    var arrayCopy = [];

    for (var i = 0; i < value.length; i++) {
      var element = value[i];
      var elemType = type(element);

      if (elemType === 'array') {
        log.warn('WARNING: Cannot have ' + elemType + ' nested in an array property value, skipping');
        continue;
      } else if (elemType === 'object') {
        arrayCopy.push(validateProperties(element));
      } else {
        arrayCopy.push(validatePropertyValue(key, element));
      }
    }

    value = arrayCopy;
  } else if (valueType === 'object') {
    value = validateProperties(value);
  }

  return value;
};

var validateGroups = function validateGroups(groups) {
  var groupsType = type(groups);

  if (groupsType !== 'object') {
    log.error('Error: invalid groups format. Expecting Javascript object, received ' + groupsType + ', ignoring');
    return {};
  }

  var copy = {}; // create a copy with all of the valid properties

  for (var group in groups) {
    if (!Object.prototype.hasOwnProperty.call(groups, group)) {
      continue;
    } // validate key


    var key = group;
    var keyType = type(key);

    if (keyType !== 'string') {
      key = String(key);
      log.warn('WARNING: Non-string groupType, received type ' + keyType + ', coercing to string "' + key + '"');
    } // validate value


    var value = validateGroupName(key, groups[group]);

    if (value === null) {
      continue;
    }

    copy[key] = value;
  }

  return copy;
};

var validateGroupName = function validateGroupName(key, groupName) {
  var groupNameType = type(groupName);

  if (groupNameType === 'string') {
    return groupName;
  }

  if (groupNameType === 'date' || groupNameType === 'number' || groupNameType === 'boolean') {
    groupName = String(groupName);
    log.warn('WARNING: Non-string groupName, received type ' + groupNameType + ', coercing to string "' + groupName + '"');
    return groupName;
  }

  if (groupNameType === 'array') {
    // check for nested arrays or objects
    var arrayCopy = [];

    for (var i = 0; i < groupName.length; i++) {
      var element = groupName[i];
      var elemType = type(element);

      if (elemType === 'array' || elemType === 'object') {
        log.warn('WARNING: Skipping nested ' + elemType + ' in array groupName');
        continue;
      } else if (elemType === 'string') {
        arrayCopy.push(element);
      } else if (elemType === 'date' || elemType === 'number' || elemType === 'boolean') {
        element = String(element);
        log.warn('WARNING: Non-string groupName, received type ' + elemType + ', coercing to string "' + element + '"');
        arrayCopy.push(element);
      }
    }

    return arrayCopy;
  }

  log.warn('WARNING: Non-string groupName, received type ' + groupNameType + '. Please use strings or array of strings for groupName');
}; // parses the value of a url param (for example ?gclid=1234&...)


var getQueryParam = function getQueryParam(name, query) {
  name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  var results = regex.exec(query);
  return results === null ? undefined : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

var isWebWorkerEnvironment = function isWebWorkerEnvironment() {
  return typeof WorkerGlobalScope !== 'undefined';
};

var validateSessionId = function validateSessionId(sessionId) {
  if (validateInput(sessionId, 'sessionId', 'number') && new Date(sessionId).getTime() > 0) {
    return true;
  }

  log.error("sessionId value must in milliseconds since epoch (Unix Timestamp)");
  return false;
};

var utils = {
  setLogLevel: setLogLevel,
  getLogLevel: getLogLevel,
  logLevels: logLevels,
  log: log,
  isEmptyString: isEmptyString,
  isWebWorkerEnvironment: isWebWorkerEnvironment,
  getQueryParam: getQueryParam,
  sessionStorageEnabled: sessionStorageEnabled,
  truncate: truncate,
  validateGroups: validateGroups,
  validateInput: validateInput,
  validateProperties: validateProperties,
  validateDeviceId: validateDeviceId,
  validateTransport: validateTransport,
  validateSessionId: validateSessionId
};

var getLocation = function getLocation() {
  return GlobalScope.location;
};

// A URL safe variation on the the list of Base64 characters
var base64Chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_';

var base64Id = function base64Id() {
  var str = '';

  for (var i = 0; i < 22; ++i) {
    str += base64Chars.charAt(Math.floor(Math.random() * 64));
  }

  return str;
};

var get$1 = function get(name) {
  try {
    var ca = document.cookie.split(';');
    var value = null;

    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];

      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length);
      }

      if (c.indexOf(name) === 0) {
        value = c.substring(name.length, c.length);
        break;
      }
    }

    return value;
  } catch (e) {
    return null;
  }
};

var getAll = function getAll(name) {
  try {
    var cookieArray = document.cookie.split(';').map(function (c) {
      return c.trimStart();
    });
    var values = [];
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = cookieArray[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var cookie = _step.value;

        while (cookie.charAt(0) === ' ') {
          cookie = cookie.substring(1);
        }

        if (cookie.indexOf(name) === 0) {
          values.push(cookie.substring(name.length));
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return values;
  } catch (e) {
    return [];
  }
};

var set$1 = function set(name, value, opts) {
  var expires = value !== null ? opts.expirationDays : -1;

  if (expires) {
    var date = new Date();
    date.setTime(date.getTime() + expires * 24 * 60 * 60 * 1000);
    expires = date;
  }

  var str = name + '=' + value;

  if (expires) {
    str += '; expires=' + expires.toUTCString();
  }

  str += '; path=/';

  if (opts.domain) {
    str += '; domain=' + opts.domain;
  }

  if (opts.secure) {
    str += '; Secure';
  }

  if (opts.sameSite) {
    str += '; SameSite=' + opts.sameSite;
  }

  document.cookie = str;
};

var getLastEventTime = function getLastEventTime() {
  var cookie = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var strValue = cookie.split('.')[Constants.LAST_EVENT_TIME_INDEX];
  var parsedValue;

  if (strValue) {
    parsedValue = parseInt(strValue, 32);
  }

  if (parsedValue) {
    return parsedValue;
  } else {
    utils.log.warn("unable to parse malformed cookie: ".concat(cookie));
    return 0;
  }
};

var sortByEventTime = function sortByEventTime(cookies) {
  return _toConsumableArray(cookies).sort(function (c1, c2) {
    var t1 = getLastEventTime(c1);
    var t2 = getLastEventTime(c2); // sort c1 first if its last event time is more recent
    // i.e its event time integer is larger that c2's

    return t2 - t1;
  });
}; // test that cookies are enabled - navigator.cookiesEnabled yields false positives in IE, need to test directly


var areCookiesEnabled = function areCookiesEnabled() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var cookieName = Constants.COOKIE_TEST_PREFIX + base64Id();

  if (typeof document === 'undefined') {
    return false;
  }

  var _areCookiesEnabled = false;

  try {
    var uid = String(Date.now());
    set$1(cookieName, uid, opts);
    utils.log.info("Testing if cookies available");
    _areCookiesEnabled = get$1(cookieName + '=') === uid;
  } catch (e) {
    utils.log.warn("Error thrown when checking for cookies. Reason: \"".concat(e, "\""));
  } finally {
    utils.log.info("Cleaning up cookies availability test");
    set$1(cookieName, null, opts);
  }

  return _areCookiesEnabled;
};

var baseCookie = {
  set: set$1,
  get: get$1,
  getAll: getAll,
  getLastEventTime: getLastEventTime,
  sortByEventTime: sortByEventTime,
  areCookiesEnabled: areCookiesEnabled
};

var getHost = function getHost(url) {
  if (url) {
    if (typeof document !== 'undefined') {
      var a = document.createElement('a');
      a.href = url;
      return a.hostname || GlobalScope.location.hostname;
    }

    if (typeof URL === 'function') {
      var u = new URL(url);
      return u.hostname || GlobalScope.location.hostname;
    }
  }

  return GlobalScope.location.hostname;
};

var topDomain = function topDomain(url) {
  var host = getHost(url);
  var parts = host.split('.');
  var levels = [];
  var cname = '_tldtest_' + base64Id();
  if (utils.isWebWorkerEnvironment()) return '';

  for (var i = parts.length - 2; i >= 0; --i) {
    levels.push(parts.slice(i).join('.'));
  }

  for (var _i = 0; _i < levels.length; ++_i) {
    var domain = levels[_i];
    var opts = {
      domain: '.' + domain
    };
    baseCookie.set(cname, 1, opts);

    if (baseCookie.get(cname)) {
      baseCookie.set(cname, null, opts);
      return domain;
    }
  }

  return '';
};

/*
 * Cookie data
 */
var _options = {
  expirationDays: undefined,
  domain: undefined
};

var amplitude_esm_reset = function reset() {
  _options = {
    expirationDays: undefined,
    domain: undefined
  };
};

var options = function options(opts) {
  if (arguments.length === 0) {
    return _options;
  }

  opts = opts || {};
  _options.expirationDays = opts.expirationDays;
  _options.secure = opts.secure;
  _options.sameSite = opts.sameSite;
  var domain = !utils.isEmptyString(opts.domain) ? opts.domain : '.' + topDomain(getLocation().href);
  var token = Math.random();
  _options.domain = domain;
  set('amplitude_test', token);
  var stored = get('amplitude_test');

  if (!stored || stored !== token) {
    domain = null;
  }

  remove('amplitude_test');
  _options.domain = domain;
  return _options;
};

var _domainSpecific = function _domainSpecific(name) {
  // differentiate between cookies on different domains
  var suffix = '';

  if (_options.domain) {
    suffix = _options.domain.charAt(0) === '.' ? _options.domain.substring(1) : _options.domain;
  }

  return name + suffix;
};

var get = function get(name) {
  var nameEq = _domainSpecific(name) + '=';
  var value = baseCookie.get(nameEq);

  try {
    if (value) {
      return JSON.parse(Base64.decode(value));
    }
  } catch (e) {
    return null;
  }

  return null;
};

var set = function set(name, value) {
  try {
    baseCookie.set(_domainSpecific(name), Base64.encode(JSON.stringify(value)), _options);
    return true;
  } catch (e) {
    return false;
  }
};

var setRaw = function setRaw(name, value) {
  try {
    baseCookie.set(_domainSpecific(name), value, _options);
    return true;
  } catch (e) {
    return false;
  }
};

var getRaw = function getRaw(name) {
  var nameEq = _domainSpecific(name) + '=';
  return baseCookie.get(nameEq);
};

var remove = function remove(name) {
  try {
    baseCookie.set(_domainSpecific(name), null, _options);
    return true;
  } catch (e) {
    return false;
  }
};

var Cookie = {
  reset: amplitude_esm_reset,
  options: options,
  get: get,
  set: set,
  remove: remove,
  setRaw: setRaw,
  getRaw: getRaw
};

var WorkerStorage =
/*#__PURE__*/
function () {
  function WorkerStorage() {
    _classCallCheck(this, WorkerStorage);

    this.map = new Map();
    this.length = 0;
  }

  _createClass(WorkerStorage, [{
    key: "key",
    value: function key(index) {
      var keys = Array.from(this.map.keys());
      var key = keys[index];
      return this.map.get(key);
    }
  }, {
    key: "getItem",
    value: function getItem(key) {
      return this.map.get(key);
    }
  }, {
    key: "setItem",
    value: function setItem(key, value) {
      if (!this.map.has(key)) {
        this.length += 1;
      }

      this.map.set(key, value);
    }
  }, {
    key: "removeItem",
    value: function removeItem(key) {
      if (this.map.has(key)) {
        this.length -= 1;
        this.map.delete(key);
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      this.map.clear();
      this.length = 0;
    }
  }]);

  return WorkerStorage;
}();

/*
 * Implement localStorage to support Firefox 2-3 and IE 5-7
 */
var localStorage;

{
  // test that Window.localStorage is available and works
  var windowLocalStorageAvailable = function windowLocalStorageAvailable() {
    var uid = new Date();
    var result;

    try {
      GlobalScope.localStorage.setItem(uid, uid);
      result = GlobalScope.localStorage.getItem(uid) === String(uid);
      GlobalScope.localStorage.removeItem(uid);
      return result;
    } catch (e) {// localStorage not available
    }

    return false;
  };

  if (windowLocalStorageAvailable()) {
    localStorage = GlobalScope.localStorage;
  } else if (typeof GlobalScope !== 'undefined' && GlobalScope.globalStorage) {
    // Firefox 2-3 use globalStorage
    // See https://developer.mozilla.org/en/dom/storage#globalStorage
    try {
      localStorage = GlobalScope.globalStorage[GlobalScope.location.hostname];
    } catch (e) {// Something bad happened...
    }
  } else if (typeof document !== 'undefined') {
    // IE 5-7 use userData
    // See http://msdn.microsoft.com/en-us/library/ms531424(v=vs.85).aspx
    var div = document.createElement('div'),
        attrKey = 'localStorage';
    div.style.display = 'none';
    document.getElementsByTagName('head')[0].appendChild(div);

    if (div.addBehavior) {
      div.addBehavior('#default#userdata');
      localStorage = {
        length: 0,
        setItem: function setItem(k, v) {
          div.load(attrKey);

          if (!div.getAttribute(k)) {
            this.length++;
          }

          div.setAttribute(k, v);
          div.save(attrKey);
        },
        getItem: function getItem(k) {
          div.load(attrKey);
          return div.getAttribute(k);
        },
        removeItem: function removeItem(k) {
          div.load(attrKey);

          if (div.getAttribute(k)) {
            this.length--;
          }

          div.removeAttribute(k);
          div.save(attrKey);
        },
        clear: function clear() {
          div.load(attrKey);
          var i = 0;
          var attr;

          while (attr = div.XMLDocument.documentElement.attributes[i++]) {
            div.removeAttribute(attr.name);
          }

          div.save(attrKey);
          this.length = 0;
        },
        key: function key(k) {
          div.load(attrKey);
          return div.XMLDocument.documentElement.attributes[k];
        }
      };
      div.load(attrKey);
      localStorage.length = div.XMLDocument.documentElement.attributes.length;
    }
  } else if (utils.isWebWorkerEnvironment()) {
    // Web worker
    localStorage = new WorkerStorage();
  }

  if (!localStorage) {
    /* eslint-disable no-unused-vars */
    localStorage = {
      length: 0,
      setItem: function setItem(k, v) {},
      getItem: function getItem(k) {},
      removeItem: function removeItem(k) {},
      clear: function clear() {},
      key: function key(k) {}
    };
    /* eslint-enable no-unused-vars */
  }
}

var localStorage$1 = localStorage;

/*
 * Abstraction layer for cookie storage.
 * Uses cookie if available, otherwise fallback to localstorage.
 */

var cookieStorage = function cookieStorage() {
  this.storage = null;
};

cookieStorage.prototype.getStorage = function () {
  if (this.storage !== null) {
    return this.storage;
  }

  if (baseCookie.areCookiesEnabled()) {
    this.storage = Cookie;
  } else {
    // if cookies disabled, fallback to localstorage
    // note: localstorage does not persist across subdomains
    var keyPrefix = 'amp_cookiestore_';
    this.storage = {
      _options: {
        expirationDays: undefined,
        domain: undefined,
        secure: false
      },
      reset: function reset() {
        this._options = {
          expirationDays: undefined,
          domain: undefined,
          secure: false
        };
      },
      options: function options(opts) {
        if (arguments.length === 0) {
          return this._options;
        }

        opts = opts || {};
        this._options.expirationDays = opts.expirationDays || this._options.expirationDays; // localStorage is specific to subdomains

        this._options.domain = opts.domain || this._options.domain || GlobalScope && GlobalScope.location && GlobalScope.location.hostname;
        return this._options.secure = opts.secure || false;
      },
      get: function get(name) {
        try {
          return JSON.parse(localStorage$1.getItem(keyPrefix + name));
        } catch (e) {}
        /* eslint-disable-line no-empty */


        return null;
      },
      set: function set(name, value) {
        try {
          localStorage$1.setItem(keyPrefix + name, JSON.stringify(value));
          return true;
        } catch (e) {}
        /* eslint-disable-line no-empty */


        return false;
      },
      remove: function remove(name) {
        try {
          localStorage$1.removeItem(keyPrefix + name);
        } catch (e) {
          return false;
        }
      }
    };
  }

  return this.storage;
};

var _storageOptionExists;
var storageOptionExists = (_storageOptionExists = {}, _defineProperty(_storageOptionExists, Constants.STORAGE_COOKIES, true), _defineProperty(_storageOptionExists, Constants.STORAGE_NONE, true), _defineProperty(_storageOptionExists, Constants.STORAGE_LOCAL, true), _defineProperty(_storageOptionExists, Constants.STORAGE_SESSION, true), _storageOptionExists);
/**
 * MetadataStorage involves SDK data persistance
 * storage priority: cookies -> localStorage -> in memory
 * This priority can be overriden by setting the storage options.
 * if in localStorage, unable track users between subdomains
 * if in memory, then memory can't be shared between different tabs
 */

var MetadataStorage =
/*#__PURE__*/
function () {
  function MetadataStorage(_ref) {
    var storageKey = _ref.storageKey,
        disableCookies = _ref.disableCookies,
        domain = _ref.domain,
        secure = _ref.secure,
        sameSite = _ref.sameSite,
        expirationDays = _ref.expirationDays,
        storage = _ref.storage;

    _classCallCheck(this, MetadataStorage);

    this.storageKey = storageKey;
    this.domain = domain;
    this.secure = secure;
    this.sameSite = sameSite;
    this.expirationDays = expirationDays;
    this.cookieDomain = '';
    var writableTopDomain = topDomain(getLocation().href);
    this.cookieDomain = domain || (writableTopDomain ? '.' + writableTopDomain : null);

    if (storageOptionExists[storage]) {
      this.storage = storage;
    } else {
      var disableCookieStorage = disableCookies || !baseCookie.areCookiesEnabled({
        domain: this.cookieDomain,
        secure: this.secure,
        sameSite: this.sameSite,
        expirationDays: this.expirationDays
      });

      if (disableCookieStorage) {
        this.storage = Constants.STORAGE_LOCAL;
      } else {
        this.storage = Constants.STORAGE_COOKIES;
      }
    }
  }

  _createClass(MetadataStorage, [{
    key: "getCookieStorageKey",
    value: function getCookieStorageKey() {
      if (!this.domain) {
        return this.storageKey;
      }

      var suffix = this.domain.charAt(0) === '.' ? this.domain.substring(1) : this.domain;
      return "".concat(this.storageKey).concat(suffix ? "_".concat(suffix) : '');
    }
    /*
     * Data is saved as delimited values rather than JSO to minimize cookie space
     * Should not change order of the items
     */

  }, {
    key: "save",
    value: function save(_ref2) {
      var deviceId = _ref2.deviceId,
          userId = _ref2.userId,
          optOut = _ref2.optOut,
          sessionId = _ref2.sessionId,
          lastEventTime = _ref2.lastEventTime,
          eventId = _ref2.eventId,
          identifyId = _ref2.identifyId,
          sequenceNumber = _ref2.sequenceNumber;

      if (this.storage === Constants.STORAGE_NONE) {
        return;
      }

      var value = [deviceId, Base64.encode(userId || ''), // used to convert not unicode to alphanumeric since cookies only use alphanumeric
      optOut ? '1' : '', sessionId ? sessionId.toString(32) : '0', // generated when instantiated, timestamp (but re-uses session id in cookie if not expired) @TODO clients may want custom session id
      lastEventTime ? lastEventTime.toString(32) : '0', // last time an event was set
      eventId ? eventId.toString(32) : '0', identifyId ? identifyId.toString(32) : '0', sequenceNumber ? sequenceNumber.toString(32) : '0'].join('.');

      switch (this.storage) {
        case Constants.STORAGE_SESSION:
          if (GlobalScope.sessionStorage) {
            GlobalScope.sessionStorage.setItem(this.storageKey, value);
          }

          break;

        case Constants.STORAGE_LOCAL:
          localStorage$1.setItem(this.storageKey, value);
          break;

        case Constants.STORAGE_COOKIES:
          this.saveCookie(value);
          break;
      }
    }
  }, {
    key: "saveCookie",
    value: function saveCookie(value) {
      baseCookie.set(this.getCookieStorageKey(), value, {
        domain: this.cookieDomain,
        secure: this.secure,
        sameSite: this.sameSite,
        expirationDays: this.expirationDays
      });
    }
  }, {
    key: "load",
    value: function load() {
      var _this = this;

      var str;

      if (this.storage === Constants.STORAGE_COOKIES) {
        var cookieKey = this.getCookieStorageKey() + '=';
        var allCookies = baseCookie.getAll(cookieKey);

        if (allCookies.length === 0 || allCookies.length === 1) {
          str = allCookies[0];
        } else {
          // dedup cookies by deleting them all and restoring
          // the one with the most recent event time
          var latestCookie = baseCookie.sortByEventTime(allCookies)[0];
          allCookies.forEach(function () {
            return baseCookie.set(_this.getCookieStorageKey(), null, {});
          });
          this.saveCookie(latestCookie);
          str = baseCookie.get(cookieKey);
        }
      }

      if (!str) {
        str = localStorage$1.getItem(this.storageKey);
      }

      if (!str) {
        try {
          str = GlobalScope.sessionStorage && GlobalScope.sessionStorage.getItem(this.storageKey);
        } catch (e) {
          utils.log.info("window.sessionStorage unavailable. Reason: \"".concat(e, "\""));
        }
      }

      if (!str) {
        return null;
      }

      var values = str.split('.');
      var userId = null;

      if (values[Constants.USER_ID_INDEX]) {
        try {
          userId = Base64.decode(values[Constants.USER_ID_INDEX]);
        } catch (e) {
          userId = null;
        }
      }

      return {
        deviceId: values[Constants.DEVICE_ID_INDEX],
        userId: userId,
        optOut: values[Constants.OPT_OUT_INDEX] === '1',
        sessionId: parseInt(values[Constants.SESSION_ID_INDEX], 32),
        lastEventTime: parseInt(values[Constants.LAST_EVENT_TIME_INDEX], 32),
        eventId: parseInt(values[Constants.EVENT_ID_INDEX], 32),
        identifyId: parseInt(values[Constants.IDENTIFY_ID_INDEX], 32),
        sequenceNumber: parseInt(values[Constants.SEQUENCE_NUMBER_INDEX], 32)
      };
    }
    /**
     * Clears any saved metadata storage
     * @constructor AmplitudeClient
     * @public
     * @return {boolean} True if metadata was cleared, false if none existed
     */

  }, {
    key: "clear",
    value: function clear() {
      var str;

      if (this.storage === Constants.STORAGE_COOKIES) {
        str = baseCookie.get(this.getCookieStorageKey() + '=');
        baseCookie.set(this.getCookieStorageKey(), null, {
          domain: this.cookieDomain,
          secure: this.secure,
          sameSite: this.sameSite,
          expirationDays: 0
        });
      }

      if (!str) {
        str = localStorage$1.getItem(this.storageKey);
        localStorage$1.clear();
      }

      if (!str) {
        try {
          str = GlobalScope.sessionStorage && GlobalScope.sessionStorage.getItem(this.storageKey);
          GlobalScope.sessionStorage.clear();
        } catch (e) {
          utils.log.info("window.sessionStorage unavailable. Reason: \"".concat(e, "\""));
        }
      }

      return !!str;
    }
  }]);

  return MetadataStorage;
}();

var getUtmData = function getUtmData(rawCookie, query) {
  // Translate the utmz cookie format into url query string format.
  var cookie = rawCookie ? '?' + rawCookie.split('.').slice(-1)[0].replace(/\|/g, '&') : '';

  var fetchParam = function fetchParam(queryName, query, cookieName, cookie) {
    return utils.getQueryParam(queryName, query) || utils.getQueryParam(cookieName, cookie);
  };

  var utmSource = fetchParam(Constants.UTM_SOURCE, query, 'utmcsr', cookie);
  var utmMedium = fetchParam(Constants.UTM_MEDIUM, query, 'utmcmd', cookie);
  var utmCampaign = fetchParam(Constants.UTM_CAMPAIGN, query, 'utmccn', cookie);
  var utmTerm = fetchParam(Constants.UTM_TERM, query, 'utmctr', cookie);
  var utmContent = fetchParam(Constants.UTM_CONTENT, query, 'utmcct', cookie);
  var utmData = {};

  var addIfNotNull = function addIfNotNull(key, value) {
    if (!utils.isEmptyString(value)) {
      utmData[key] = value;
    }
  };

  addIfNotNull(Constants.UTM_SOURCE, utmSource);
  addIfNotNull(Constants.UTM_MEDIUM, utmMedium);
  addIfNotNull(Constants.UTM_CAMPAIGN, utmCampaign);
  addIfNotNull(Constants.UTM_TERM, utmTerm);
  addIfNotNull(Constants.UTM_CONTENT, utmContent);
  return utmData;
};

/*
 * Wrapper for a user properties JSON object that supports operations.
 * Note: if a user property is used in multiple operations on the same Identify object,
 * only the first operation will be saved, and the rest will be ignored.
 */

var AMP_OP_ADD = '$add';
var AMP_OP_APPEND = '$append';
var AMP_OP_CLEAR_ALL = '$clearAll';
var AMP_OP_PREPEND = '$prepend';
var AMP_OP_SET = '$set';
var AMP_OP_SET_ONCE = '$setOnce';
var AMP_OP_UNSET = '$unset';
var AMP_OP_PREINSERT = '$preInsert';
var AMP_OP_POSTINSERT = '$postInsert';
var AMP_OP_REMOVE = '$remove';
/**
 * Identify API - instance constructor. Identify objects are a wrapper for user property operations.
 * Each method adds a user property operation to the Identify object, and returns the same Identify object,
 * allowing you to chain multiple method calls together.
 * Note: if the same user property is used in multiple operations on a single Identify object,
 * only the first operation on that property will be saved, and the rest will be ignored.
 * @constructor Identify
 * @public
 * @example var identify = new amplitude.Identify();
 */

var Identify = function Identify() {
  this.userPropertiesOperations = {};
  this.properties = []; // keep track of keys that have been added
};
/**
 * Increment a user property by a given value (can also be negative to decrement).
 * If the user property does not have a value set yet, it will be initialized to 0 before being incremented.
 * @public
 * @param {string} property - The user property key.
 * @param {number|string} value - The amount by which to increment the user property. Allows numbers as strings (ex: '123').
 * @return {Identify} Returns the same Identify object, allowing you to chain multiple method calls together.
 * @example var identify = new amplitude.Identify().add('karma', 1).add('friends', 1);
 * amplitude.identify(identify); // send the Identify call
 */


Identify.prototype.add = function (property, value) {
  if (type(value) === 'number' || type(value) === 'string') {
    this._addOperation(AMP_OP_ADD, property, value);
  } else {
    utils.log.error('Unsupported type for value: ' + type(value) + ', expecting number or string');
  }

  return this;
};
/**
 * Append a value or values to a user property.
 * If the user property does not have a value set yet,
 * it will be initialized to an empty list before the new values are appended.
 * If the user property has an existing value and it is not a list,
 * the existing value will be converted into a list with the new values appended.
 * @public
 * @param {string} property - The user property key.
 * @param {number|string|list|object} value - A value or values to append.
 * Values can be numbers, strings, lists, or object (key:value dict will be flattened).
 * @return {Identify} Returns the same Identify object, allowing you to chain multiple method calls together.
 * @example var identify = new amplitude.Identify().append('ab-tests', 'new-user-tests');
 * identify.append('some_list', [1, 2, 3, 4, 'values']);
 * amplitude.identify(identify); // send the Identify call
 */


Identify.prototype.append = function (property, value) {
  this._addOperation(AMP_OP_APPEND, property, value);

  return this;
};
/**
 * Clear all user properties for the current user.
 * SDK user should instead call amplitude.clearUserProperties() instead of using this.
 * $clearAll needs to be sent on its own Identify object. If there are already other operations, then don't add $clearAll.
 * If $clearAll already in an Identify object, don't allow other operations to be added.
 * @private
 */


Identify.prototype.clearAll = function () {
  if (Object.keys(this.userPropertiesOperations).length > 0) {
    if (!Object.prototype.hasOwnProperty.call(this.userPropertiesOperations, AMP_OP_CLEAR_ALL)) {
      utils.log.error('Need to send $clearAll on its own Identify object without any other operations, skipping $clearAll');
    }

    return this;
  }

  this.userPropertiesOperations[AMP_OP_CLEAR_ALL] = '-';
  return this;
};
/**
 * Prepend a value or values to a user property.
 * Prepend means inserting the value or values at the front of a list.
 * If the user property does not have a value set yet,
 * it will be initialized to an empty list before the new values are prepended.
 * If the user property has an existing value and it is not a list,
 * the existing value will be converted into a list with the new values prepended.
 * @public
 * @param {string} property - The user property key.
 * @param {number|string|list|object} value - A value or values to prepend.
 * Values can be numbers, strings, lists, or object (key:value dict will be flattened).
 * @return {Identify} Returns the same Identify object, allowing you to chain multiple method calls together.
 * @example var identify = new amplitude.Identify().prepend('ab-tests', 'new-user-tests');
 * identify.prepend('some_list', [1, 2, 3, 4, 'values']);
 * amplitude.identify(identify); // send the Identify call
 */


Identify.prototype.prepend = function (property, value) {
  this._addOperation(AMP_OP_PREPEND, property, value);

  return this;
};
/**
 * Sets the value of a given user property. If a value already exists, it will be overwriten with the new value.
 * @public
 * @param {string} property - The user property key.
 * @param {number|string|list|boolean|object} value - A value or values to set.
 * Values can be numbers, strings, lists, or object (key:value dict will be flattened).
 * @return {Identify} Returns the same Identify object, allowing you to chain multiple method calls together.
 * @example var identify = new amplitude.Identify().set('user_type', 'beta');
 * identify.set('name', {'first': 'John', 'last': 'Doe'}); // dict is flattened and becomes name.first: John, name.last: Doe
 * amplitude.identify(identify); // send the Identify call
 */


Identify.prototype.set = function (property, value) {
  this._addOperation(AMP_OP_SET, property, value);

  return this;
};
/**
 * Sets the value of a given user property only once. Subsequent setOnce operations on that user property will be ignored;
 * however, that user property can still be modified through any of the other operations.
 * Useful for capturing properties such as 'initial_signup_date', 'initial_referrer', etc.
 * @public
 * @param {string} property - The user property key.
 * @param {number|string|list|boolean|object} value - A value or values to set once.
 * Values can be numbers, strings, lists, or object (key:value dict will be flattened).
 * @return {Identify} Returns the same Identify object, allowing you to chain multiple method calls together.
 * @example var identify = new amplitude.Identify().setOnce('sign_up_date', '2016-04-01');
 * amplitude.identify(identify); // send the Identify call
 */


Identify.prototype.setOnce = function (property, value) {
  this._addOperation(AMP_OP_SET_ONCE, property, value);

  return this;
};
/**
 * Unset and remove a user property. This user property will no longer show up in a user's profile.
 * @public
 * @param {string} property - The user property key.
 * @return {Identify} Returns the same Identify object, allowing you to chain multiple method calls together.
 * @example var identify = new amplitude.Identify().unset('user_type').unset('age');
 * amplitude.identify(identify); // send the Identify call
 */


Identify.prototype.unset = function (property) {
  this._addOperation(AMP_OP_UNSET, property, '-');

  return this;
};
/**
 * Preinsert a value or values to a user property, if it does not exist in the user property already.
 * Preinsert means inserting the value or values to the beginning of the specified user property.
 * If the item already exists in the user property, it will be a no-op.
 * @public
 * @param {string} property - The user property key.
 * @param {number|string|list|object} value - A value or values to insert.
 * @returns {Identify} Returns the same Identify object, allowing you to chain multiple method calls together.
 */


Identify.prototype.preInsert = function (property, value) {
  this._addOperation(AMP_OP_PREINSERT, property, value);

  return this;
};
/**
 * Postinsert a value or values to a user property, if it does not exist in the user property already.
 * Postinsert means inserting the value or values to the beginning of the specified user property.
 * If the item already exists in the user property, it will be a no-op.
 * @param {string} property - The user property key.
 * @param {number|string|list|object} value - A value or values to insert.
 * @returns {Identify} Returns the same Identify object, allowing you to chain multiple method calls together.
 */


Identify.prototype.postInsert = function (property, value) {
  this._addOperation(AMP_OP_POSTINSERT, property, value);

  return this;
};
/**
 * Remove a value or values to a user property, if it does exist in the user property.
 * If the item does not exist in the user property, it will be a no-op.
 * @param {string} property - The user property key.
 * @param {number|string|list|object} value - A value or values to remove.
 * @returns {Identify} Returns the same Identify object, allowing you to chain multiple method calls together.
 */


Identify.prototype.remove = function (property, value) {
  this._addOperation(AMP_OP_REMOVE, property, value);

  return this;
};
/**
 * Helper function that adds operation to the Identify's object
 * Handle's filtering of duplicate user property keys, and filtering for clearAll.
 * @private
 */


Identify.prototype._addOperation = function (operation, property, value) {
  // check that the identify doesn't already contain a clearAll
  if (Object.prototype.hasOwnProperty.call(this.userPropertiesOperations, AMP_OP_CLEAR_ALL)) {
    utils.log.error('This identify already contains a $clearAll operation, skipping operation ' + operation);
    return;
  } // check that property wasn't already used in this Identify


  if (this.properties.indexOf(property) !== -1) {
    utils.log.error('User property "' + property + '" already used in this identify, skipping operation ' + operation);
    return;
  }

  if (!Object.prototype.hasOwnProperty.call(this.userPropertiesOperations, operation)) {
    this.userPropertiesOperations[operation] = {};
  }

  this.userPropertiesOperations[operation][property] = value;
  this.properties.push(property);
};

/*
 * Simple AJAX request object
 */

var Request = function Request(url, data, headers) {
  this.url = url;
  this.data = data || {};
  this.headers = headers;
};

var CORS_HEADER = 'Cross-Origin-Resource-Policy';

function setHeaders(xhr, headers) {
  for (var header in headers) {
    if (header === CORS_HEADER && !headers[header]) {
      continue;
    }

    xhr.setRequestHeader(header, headers[header]);
  }
}

Request.prototype.send = function (callback) {
  var isIE = GlobalScope.XDomainRequest ? true : false;

  if (isIE) {
    var xdr = new GlobalScope.XDomainRequest();
    xdr.open('POST', this.url, true);

    xdr.onload = function () {
      callback(200, xdr.responseText);
    };

    xdr.onerror = function () {
      // status code not available from xdr, try string matching on responseText
      if (xdr.responseText === 'Request Entity Too Large') {
        callback(413, xdr.responseText);
      } else {
        callback(500, xdr.responseText);
      }
    };

    xdr.ontimeout = function () {};

    xdr.onprogress = function () {};

    xdr.send(query_string.stringify(this.data));
  } else if (typeof XMLHttpRequest !== 'undefined') {
    var xhr = new XMLHttpRequest();
    xhr.open('POST', this.url, true);

    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        callback(xhr.status, xhr.responseText);
      }
    };

    setHeaders(xhr, this.headers);
    xhr.send(query_string.stringify(this.data));
  } else {
    var responseStatus = undefined;
    fetch(this.url, {
      method: 'POST',
      headers: this.headers,
      body: query_string.stringify(this.data)
    }).then(function (response) {
      responseStatus = response.status;
      return response.text();
    }).then(function (responseText) {
      callback(responseStatus, responseText);
    });
  } //log('sent request to ' + this.url + ' with data ' + decodeURIComponent(queryString(this.data)));

};

/**
 * Revenue API - instance constructor. Wrapper for logging Revenue data. Revenue objects get passed to amplitude.logRevenueV2 to send to Amplitude servers.
 * Each method updates a revenue property in the Revenue object, and returns the same Revenue object,
 * allowing you to chain multiple method calls together.
 *
 * Note: price is a required field to log revenue events.
 * If quantity is not specified then defaults to 1.
 * @constructor Revenue
 * @public
 * @example var revenue = new amplitude.Revenue();
 */

var Revenue = function Revenue() {
  // required fields
  this._price = null; // optional fields

  this._productId = null;
  this._quantity = 1;
  this._revenueType = null;
  this._properties = null;
};
/**
 * Set a value for the product identifer.
 * @public
 * @param {string} productId - The value for the product identifier. Empty and invalid strings are ignored.
 * @return {Revenue} Returns the same Revenue object, allowing you to chain multiple method calls together.
 * @example var revenue = new amplitude.Revenue().setProductId('productIdentifier').setPrice(10.99);
 * amplitude.logRevenueV2(revenue);
 */


Revenue.prototype.setProductId = function setProductId(productId) {
  if (type(productId) !== 'string') {
    utils.log.error('Unsupported type for productId: ' + type(productId) + ', expecting string');
  } else if (utils.isEmptyString(productId)) {
    utils.log.error('Invalid empty productId');
  } else {
    this._productId = productId;
  }

  return this;
};
/**
 * Set a value for the quantity. Note revenue amount is calculated as price * quantity.
 * @public
 * @param {number} quantity - Integer value for the quantity. If not set, quantity defaults to 1.
 * @return {Revenue} Returns the same Revenue object, allowing you to chain multiple method calls together.
 * @example var revenue = new amplitude.Revenue().setProductId('productIdentifier').setPrice(10.99).setQuantity(5);
 * amplitude.logRevenueV2(revenue);
 */


Revenue.prototype.setQuantity = function setQuantity(quantity) {
  if (type(quantity) !== 'number') {
    utils.log.error('Unsupported type for quantity: ' + type(quantity) + ', expecting number');
  } else {
    this._quantity = parseInt(quantity);
  }

  return this;
};
/**
 * Set a value for the price. This field is required for all revenue being logged.
 *
 * Note: revenue amount is calculated as price * quantity.
 * @public
 * @param {number} price - Double value for the quantity.
 * @return {Revenue} Returns the same Revenue object, allowing you to chain multiple method calls together.
 * @example var revenue = new amplitude.Revenue().setProductId('productIdentifier').setPrice(10.99);
 * amplitude.logRevenueV2(revenue);
 */


Revenue.prototype.setPrice = function setPrice(price) {
  if (type(price) !== 'number') {
    utils.log.error('Unsupported type for price: ' + type(price) + ', expecting number');
  } else {
    this._price = price;
  }

  return this;
};
/**
 * Set a value for the revenueType (for example purchase, cost, tax, refund, etc).
 * @public
 * @param {string} revenueType - RevenueType to designate.
 * @return {Revenue} Returns the same Revenue object, allowing you to chain multiple method calls together.
 * @example var revenue = new amplitude.Revenue().setProductId('productIdentifier').setPrice(10.99).setRevenueType('purchase');
 * amplitude.logRevenueV2(revenue);
 */


Revenue.prototype.setRevenueType = function setRevenueType(revenueType) {
  if (type(revenueType) !== 'string') {
    utils.log.error('Unsupported type for revenueType: ' + type(revenueType) + ', expecting string');
  } else {
    this._revenueType = revenueType;
  }

  return this;
};
/**
 * Set event properties for the revenue event.
 * @public
 * @param {object} eventProperties - Revenue event properties to set.
 * @return {Revenue} Returns the same Revenue object, allowing you to chain multiple method calls together.
 * @example var event_properties = {'city': 'San Francisco'};
 * var revenue = new amplitude.Revenue().setProductId('productIdentifier').setPrice(10.99).setEventProperties(event_properties);
 * amplitude.logRevenueV2(revenue);
 */


Revenue.prototype.setEventProperties = function setEventProperties(eventProperties) {
  if (type(eventProperties) !== 'object') {
    utils.log.error('Unsupported type for eventProperties: ' + type(eventProperties) + ', expecting object');
  } else {
    this._properties = utils.validateProperties(eventProperties);
  }

  return this;
};
/**
 * @private
 */


Revenue.prototype._isValidRevenue = function _isValidRevenue() {
  if (type(this._price) !== 'number') {
    utils.log.error('Invalid revenue, need to set price field');
    return false;
  }

  return true;
};
/**
 * @private
 */


Revenue.prototype._toJSONObject = function _toJSONObject() {
  var obj = type(this._properties) === 'object' ? this._properties : {};

  if (this._productId !== null) {
    obj[Constants.REVENUE_PRODUCT_ID] = this._productId;
  }

  if (this._quantity !== null) {
    obj[Constants.REVENUE_QUANTITY] = this._quantity;
  }

  if (this._price !== null) {
    obj[Constants.REVENUE_PRICE] = this._price;
  }

  if (this._revenueType !== null) {
    obj[Constants.REVENUE_REVENUE_TYPE] = this._revenueType;
  }

  return obj;
};

/**
 * Source: [jed's gist]{@link https://gist.github.com/982883}.
 * Returns a random v4 UUID of the form xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx,
 * where each x is replaced with a random hexadecimal digit from 0 to f, and
 * y is replaced with a random hexadecimal digit from 8 to b.
 * Used to generate UUIDs for deviceIds.
 * @private
 */
var uuid = function uuid(a) {
  return a // if the placeholder was passed, return
  ? // a random number from 0 to 15
  (a ^ // unless b is 8,
  Math.random() * // in which case
  16 >> // a random number from
  a / 4). // 8 to 11
  toString(16) // in hexadecimal
  : // or otherwise a concatenated string:
  ([1e7] + // 10000000 +
  -1e3 + // -1000 +
  -4e3 + // -4000 +
  -8e3 + // -80000000 +
  -1e11). // -100000000000,
  replace( // replacing
  /[018]/g, // zeroes, ones, and eights with
  uuid // random hex digits
  );
};

var getLanguage = function getLanguage() {
  return typeof navigator !== 'undefined' && (navigator.languages && navigator.languages[0] || navigator.language || navigator.userLanguage) || '';
};

var language = {
  getLanguage: getLanguage
};

/**
 * AmplitudeServerZone is for Data Residency and handling server zone related properties.
 * The server zones now are US and EU.
 *
 * For usage like sending data to Amplitude's EU servers, you need to configure the serverZone during nitializing.
 */

var AmplitudeServerZone = {
  US: 'US',
  EU: 'EU'
};

var getEventLogApi = function getEventLogApi(serverZone) {
  var eventLogUrl = Constants.EVENT_LOG_URL;

  switch (serverZone) {
    case AmplitudeServerZone.EU:
      eventLogUrl = Constants.EVENT_LOG_EU_URL;
      break;

    case AmplitudeServerZone.US:
      eventLogUrl = Constants.EVENT_LOG_URL;
      break;
  }

  return eventLogUrl;
};

var getDynamicConfigApi = function getDynamicConfigApi(serverZone) {
  var dynamicConfigUrl = Constants.DYNAMIC_CONFIG_URL;

  switch (serverZone) {
    case AmplitudeServerZone.EU:
      dynamicConfigUrl = Constants.DYNAMIC_CONFIG_EU_URL;
      break;

    case AmplitudeServerZone.US:
      dynamicConfigUrl = Constants.DYNAMIC_CONFIG_URL;
      break;
  }

  return dynamicConfigUrl;
};

var version = "8.17.0";

/**
 * Options used when initializing Amplitude
 * @typedef {Object} Options
 * @property {string} [apiEndpoint=`api.amplitude.com`] - Endpoint to send amplitude event requests to.
 * @property {boolean} [batchEvents=`false`] -  If `true`, then events are batched together and uploaded only when the number of unsent events is greater than or equal to eventUploadThreshold or after eventUploadPeriodMillis milliseconds have passed since the first unsent event was logged.
 * @property {number} [cookieExpiration=`365`] - The number of days after which the Amplitude cookie will expire. 12 months is for GDPR compliance.
 * @property {string} [cookieName=`amplitude_id`] - *DEPRECATED*
 * @property {string} [sameSiteCookie='None'] -  Sets the SameSite flag on the amplitude cookie. Decides cookie privacy policy.
 * @property {boolean} [cookieForceUpgrade=`false`] - Forces pre-v6.0.0 instances to adopt post-v6.0.0 compat cookie formats.
 * @property {boolean} [deferInitialization=`null`] -  If `true`, disables the core functionality of the sdk, including saving a cookie and all logging, until explicitly enabled. To enable tracking, please call `amplitude.getInstance().enableTracking()` *Note: This will not affect users who already have an amplitude cookie. The decision to track events is determined by whether or not a user has an amplitude analytics cookie. If the `cookieExpiration</code> is manually defined to be a short lifespan, you may need to run `amplitude.getInstance().enableTracking()` upon the cookie expiring or upon logging in.*
 * @property {boolean} [disableCookies=`false`] -  Disable Ampllitude cookies altogether.
 * @property {string} [deviceId=A randomly generated UUID.] -  The custom Device ID to set. *Note: This is not recommended unless you know what you are doing (e.g. you have your own system for tracking user devices).*
 * @property {boolean} [deviceIdFromUrlParam=`false`] -  If `true`, then the SDK will parse Device ID values from the URL parameter amp_device_id if available. Device IDs defined in the configuration options during init will take priority over Device IDs from URL parameters.
 * @property {string} [domain=The top domain of the current page's URL. ('https://amplitude.com')] -  Set a custom domain for the Amplitude cookie. To include subdomains, add a preceding period, eg: `.amplitude.com`.
 * @property {number} [eventUploadPeriodMillis=`30000` (30 sec)] -  Amount of time in milliseconds that the SDK waits before uploading events if batchEvents is true.
 * @property {number} [eventUploadThreshold=`30`] -  Minimum number of events to batch together per request if batchEvents is true.
 * @property {boolean} [forceHttps=`true`] -  If `true`, the events will always be uploaded to HTTPS endpoint. Otherwise, it will use the embedding site's protocol.
 * @property {boolean} [includeFbclid=`false`] -  If `true`, captures the fbclid URL parameter as well as the user's initial_fbclid via a setOnce operation.
 * @property {boolean} [includeGclid=`false`] -  If `true`, captures the gclid URL parameter as well as the user's initial_gclid via a setOnce operation.
 * @property {boolean} [includeReferrer=`false`] -  If `true`, captures the referrer and referring_domain for each session, as well as the user's initial_referrer and initial_referring_domain via a setOnce operation.
 * @property {boolean} [includeUtm=`false`] -  If `true`, finds UTM parameters in the query string or the _utmz cookie, parses, and includes them as user properties on all events uploaded. This also captures initial UTM parameters for each session via a setOnce operation.
 * @property {string} [language=The language determined by the browser] -  Custom language to set.
 * @property {Object} [library=`{ name: 'amplitude-js', version: packageJsonVersion }`] -  Values for the library version
 * @property {string} [logLevel=`WARN`] -  Level of logs to be printed in the developer console. Valid values are 'DISABLE', 'ERROR', 'WARN', 'INFO'. To learn more about the different options, see below.
 * @property {boolean} [logAttributionCapturedEvent=`false`] - If `true`, the SDK will log an Amplitude event anytime new attribution values are captured from the user. **Note: These events count towards your event volume.** Event name being logged: [Amplitude] Attribution Captured. Event Properties that can be logged: `utm_source`, `utm_medium`, `utm_campaign`, `utm_term`, `utm_content`, `referrer`, `referring_domain`, `gclid`, `fbclid`. For UTM properties to be logged, `includeUtm` must be set to `true`. For the `referrer` and `referring_domain` properties to be logged, `includeReferrer` must be set to `true`. For the `gclid` property to be logged, `includeGclid` must be set to `true`. For the `fbclid` property to be logged, `includeFbclid` must be set to `true`.
 * @property {boolean} [optOut=`false`] -  Whether or not to disable tracking for the current user.
 * @property {function} [onError=`() => {}`] - Function to call on error.
 * @property {function} [onExitPage=`() => {}`] - Function called when the user exits the browser. Useful logging on page exit.
 * @property {Object} [plan] Tracking plan properties
 * @property {string} [plan.branch] The tracking plan branch name e.g. "main"
 * @property {string} [plan.source] The tracking plan source e.g. "web"
 * @property {string} [plan.version] The tracking plan version e.g. "1", "15"
 * @property {string} [platform=`Web`] -  Platform device is running on. Defaults to `Web` (browser, including mobile browsers).
 * @property {number} [savedMaxCount=`1000`] -  Maximum number of events to save in localStorage. If more events are logged while offline, then old events are removed.
 * @property {boolean} [saveEvents=`true`] -  If `true`, saves events to localStorage and removes them upon successful upload. *Note: Without saving events, events may be lost if the user navigates to another page before the events are uploaded.*
 * @property {boolean} [saveParamsReferrerOncePerSession=`true`] -  If `true`, then includeGclid, includeFbclid, includeReferrer, and includeUtm will only track their respective properties once per session. New values that come in during the middle of the user's session will be ignored. Set to false to always capture new values.
 * @property {boolean} [secureCookie=`false`] -  If `true`, the amplitude cookie will be set with the Secure flag.
 * @property {number} [sessionTimeout=`30*60*1000` (30 min)] -  The time between logged events before a new session starts in milliseconds.
 * @property {string[]} [storage=`''`] - Sets storage strategy.  Options are 'cookies', 'localStorage', 'sessionStorage', or `none`. Will override `disableCookies` option
 * @property {Object} [trackingOptions=`{ city: true, country: true, carrier: true, device_manufacturer: true, device_model: true, dma: true, ip_address: true, language: true, os_name: true, os_version: true, platform: true, region: true, version_name: true}`] - Type of data associated with a user.
 * @property {string} [transport=`http`] - Network transport mechanism used to send events. Options are 'http' and 'beacon'.
 * @property {boolean} [unsetParamsReferrerOnNewSession=`false`] -  If `false`, the existing `referrer` and `utm_parameter` values will be carried through each new session. If set to `true`, the `referrer` and `utm_parameter` user properties, which include `referrer`, `utm_source`, `utm_medium`, `utm_campaign`, `utm_term`, and `utm_content`, will be set to `null` upon instantiating a new session. Note: This only works if `includeReferrer` or `includeUtm` is set to `true`.
 * @property {string} [unsentKey=`amplitude_unsent`] - localStorage key that stores unsent events.
 * @property {string} [unsentIdentifyKey=`amplitude_unsent_identify`] - localStorage key that stores unsent identifies.
 * @property {number} [uploadBatchSize=`100`] -  The maximum number of events to send to the server per request.
 * @property {Object} [headers=`{ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }`] - Headers attached to an event(s) upload network request. Custom header properties are merged with this object.
 * @property {string} [serverZone] - For server zone related configuration, used for server api endpoint and dynamic configuration.
 * @property {boolean} [useDynamicConfig] - Enable dynamic configuration to find best server url for user.
 * @property {boolean} [serverZoneBasedApi] - To update api endpoint with serverZone change or not. For data residency, recommend to enable it unless using own proxy server.
 * @property {number} [sessionId=`null`] - The custom Session ID for the current session. *Note: This is not recommended unless you know what you are doing because the Session ID of a session is utilized for all session metrics in Amplitude.
 */

var DEFAULT_OPTIONS = {
  apiEndpoint: Constants.EVENT_LOG_URL,
  batchEvents: false,
  cookieExpiration: 365,
  // 12 months is for GDPR compliance
  cookieName: 'amplitude_id',
  // this is a deprecated option
  sameSiteCookie: 'Lax',
  // cookie privacy policy
  cookieForceUpgrade: false,
  deferInitialization: false,
  disableCookies: false,
  // this is a deprecated option
  deviceIdFromUrlParam: false,
  domain: '',
  eventUploadPeriodMillis: 30 * 1000,
  // 30s
  eventUploadThreshold: 30,
  forceHttps: true,
  includeFbclid: false,
  includeGclid: false,
  includeReferrer: false,
  includeUtm: false,
  language: language.getLanguage(),
  library: {
    name: 'amplitude-js',
    version: version
  },
  logLevel: 'WARN',
  logAttributionCapturedEvent: false,
  optOut: false,
  onError: function onError() {},
  onExitPage: function onExitPage() {},
  onNewSessionStart: function onNewSessionStart() {},
  plan: {
    branch: '',
    source: '',
    version: ''
  },
  platform: 'Web',
  savedMaxCount: 1000,
  saveEvents: true,
  saveParamsReferrerOncePerSession: true,
  secureCookie: false,
  sessionTimeout: 30 * 60 * 1000,
  storage: Constants.STORAGE_DEFAULT,
  trackingOptions: {
    city: true,
    country: true,
    carrier: true,
    device_manufacturer: true,
    device_model: true,
    dma: true,
    ip_address: true,
    language: true,
    os_name: true,
    os_version: true,
    platform: true,
    region: true,
    version_name: true
  },
  transport: Constants.TRANSPORT_HTTP,
  unsetParamsReferrerOnNewSession: false,
  unsentKey: 'amplitude_unsent',
  unsentIdentifyKey: 'amplitude_unsent_identify',
  uploadBatchSize: 100,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    'Cross-Origin-Resource-Policy': 'cross-origin'
  },
  serverZone: AmplitudeServerZone.US,
  useDynamicConfig: false,
  serverZoneBasedApi: false,
  sessionId: null
};

/**
 * Dynamic Configuration
 * Find the best server url automatically based on app users' geo location.
 */

var ConfigManager =
/*#__PURE__*/
function () {
  function ConfigManager() {
    _classCallCheck(this, ConfigManager);

    if (!ConfigManager.instance) {
      this.ingestionEndpoint = Constants.EVENT_LOG_URL;
      ConfigManager.instance = this;
    }

    return ConfigManager.instance;
  }

  _createClass(ConfigManager, [{
    key: "refresh",
    value: function refresh(serverZone, forceHttps, callback) {
      var protocol = 'https';

      if (!forceHttps && 'https:' !== GlobalScope.location.protocol) {
        protocol = 'http';
      }

      var dynamicConfigUrl = protocol + '://' + getDynamicConfigApi(serverZone);
      var self = this;
      var isIE = GlobalScope.XDomainRequest ? true : false;

      if (isIE) {
        var xdr = new GlobalScope.XDomainRequest();
        xdr.open('GET', dynamicConfigUrl, true);

        xdr.onload = function () {
          var response = JSON.parse(xdr.responseText);
          self.ingestionEndpoint = response['ingestionEndpoint'];

          if (callback) {
            callback();
          }
        };

        xdr.onerror = function () {};

        xdr.ontimeout = function () {};

        xdr.onprogress = function () {};

        xdr.send();
      } else {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', dynamicConfigUrl, true);

        xhr.onreadystatechange = function () {
          if (xhr.readyState === 4 && xhr.status === 200) {
            var response = JSON.parse(xhr.responseText);
            self.ingestionEndpoint = response['ingestionEndpoint'];

            if (callback) {
              callback();
            }
          }
        };

        xhr.send();
      }
    }
  }]);

  return ConfigManager;
}();

var instance$1 = new ConfigManager();

/**
 * AmplitudeClient SDK API - instance constructor.
 * The Amplitude class handles creation of client instances, all you need to do is call amplitude.getInstance()
 * @constructor AmplitudeClient
 * @public
 * @example var amplitudeClient = new AmplitudeClient();
 */

var AmplitudeClient = function AmplitudeClient(instanceName) {
  if (!isBrowserEnv() && !utils.isWebWorkerEnvironment()) {
    utils.log.warn('amplitude-js will not work in a non-browser environment. If you are planning to add Amplitude to a node environment, please use @amplitude/node');
  }

  this._instanceName = utils.isEmptyString(instanceName) ? Constants.DEFAULT_INSTANCE : instanceName.toLowerCase();
  this._unsentEvents = [];
  this._unsentIdentifys = [];
  this._ua = new (ua_parser_default())(navigator.userAgent).getResult();
  this.options = _objectSpread({}, DEFAULT_OPTIONS, {
    trackingOptions: _objectSpread({}, DEFAULT_OPTIONS.trackingOptions)
  });
  this.cookieStorage = new cookieStorage().getStorage();
  this._q = []; // queue for proxied functions before script load

  this._sending = false;
  this._updateScheduled = false;
  this._onInitCallbacks = [];
  this._onNewSessionStartCallbacks = []; // event meta data

  this._eventId = 0;
  this._identifyId = 0;
  this._lastEventTime = null;
  this._newSession = false; // sequence used for by frontend for prioritizing event send retries

  this._sequenceNumber = 0;
  this._sessionId = null;
  this._isInitialized = false; // used to integrate with experiment SDK (client-side exposure tracking & real-time user properties)

  this._connector = null;
  this._userAgent = navigator && navigator.userAgent || null;
};

AmplitudeClient.prototype.Identify = Identify;
AmplitudeClient.prototype.Revenue = Revenue;
/**
 * Initializes the Amplitude Javascript SDK with your apiKey and any optional configurations.
 * This is required before any other methods can be called.
 * @public
 * @param {string} apiKey - The API key for your app.
 * @param {string} opt_userId - (optional) An identifier for this user.
 * @param {object} opt_config - (optional) Configuration options.
 * See [options.js](https://amplitude.github.io/Amplitude-JavaScript/Options) for a list of options and default values.
 * @param {function} opt_callback - (optional) Provide a callback function to run after initialization is complete.
 * @example amplitudeClient.init('API_KEY', 'USER_ID', {includeReferrer: true, includeUtm: true}, function() { alert('init complete'); });
 */

AmplitudeClient.prototype.init = function init(apiKey, opt_userId, opt_config, opt_callback) {
  var _this = this;

  if (type(apiKey) !== 'string' || utils.isEmptyString(apiKey)) {
    utils.log.error('Invalid apiKey. Please re-initialize with a valid apiKey');
    return;
  }

  try {
    // used to integrate with experiment SDK (client-side exposure tracking & real-time user properties)
    this._connector = analyticsConnector_umd.AnalyticsConnector.getInstance(this._instanceName);

    _parseConfig(this.options, opt_config);

    if ((isBrowserEnv() || utils.isWebWorkerEnvironment()) && GlobalScope.Prototype !== undefined && Array.prototype.toJSON) {
      prototypeJsFix();
      utils.log.warn('Prototype.js injected Array.prototype.toJSON. Deleting Array.prototype.toJSON to prevent double-stringify');
    }

    if (this.options.cookieName !== DEFAULT_OPTIONS.cookieName) {
      utils.log.warn('The cookieName option is deprecated. We will be ignoring it for newer cookies');
    }

    if (this.options.serverZoneBasedApi) {
      this.options.apiEndpoint = getEventLogApi(this.options.serverZone);
    }

    this._refreshDynamicConfig();

    this.options.apiKey = apiKey;
    this._storageSuffix = '_' + apiKey + (this._instanceName === Constants.DEFAULT_INSTANCE ? '' : '_' + this._instanceName);
    this._storageSuffixV5 = apiKey.slice(0, 6);
    this._oldCookiename = this.options.cookieName + this._storageSuffix;
    this._unsentKey = this.options.unsentKey + this._storageSuffix;
    this._unsentIdentifyKey = this.options.unsentIdentifyKey + this._storageSuffix;
    this._cookieName = Constants.COOKIE_PREFIX + '_' + this._storageSuffixV5;
    this.cookieStorage.options({
      expirationDays: this.options.cookieExpiration,
      domain: this.options.domain,
      secure: this.options.secureCookie,
      sameSite: this.options.sameSiteCookie
    });
    this._metadataStorage = new MetadataStorage({
      storageKey: this._cookieName,
      disableCookies: this.options.disableCookies,
      expirationDays: this.options.cookieExpiration,
      domain: this.options.domain,
      secure: this.options.secureCookie,
      sameSite: this.options.sameSiteCookie,
      storage: this.options.storage
    });
    var hasOldCookie = !!this.cookieStorage.get(this._oldCookiename);
    var hasNewCookie = !!this._metadataStorage.load();
    this._useOldCookie = !hasNewCookie && hasOldCookie && !this.options.cookieForceUpgrade;
    var hasCookie = hasNewCookie || hasOldCookie;
    this.options.domain = this.cookieStorage.options().domain;

    if (this.options.deferInitialization && !hasCookie) {
      this._deferInitialization(apiKey, opt_userId, opt_config, opt_callback);

      return;
    }

    if (type(this.options.logLevel) === 'string') {
      utils.setLogLevel(this.options.logLevel);
    }

    var trackingOptions = _generateApiPropertiesTrackingConfig(this);

    this._apiPropertiesTrackingOptions = Object.keys(trackingOptions).length > 0 ? {
      tracking_options: trackingOptions
    } : {};

    if (this.options.cookieForceUpgrade && hasOldCookie) {
      if (!hasNewCookie) {
        _upgradeCookieData(this);
      }

      this.cookieStorage.remove(this._oldCookiename);
    }

    _loadCookieData(this);

    this._pendingReadStorage = true;

    var initFromStorage = function initFromStorage(storedDeviceId) {
      if (opt_config && opt_config.deviceId && !utils.validateDeviceId(opt_config.deviceId)) {
        utils.log.error("Invalid device ID rejected. Randomly generated UUID will be used instead of \"".concat(opt_config.deviceId, "\""));
        delete opt_config.deviceId;
      }

      _this.options.deviceId = _this._getInitialDeviceId(opt_config && opt_config.deviceId, storedDeviceId);
      _this.options.userId = type(opt_userId) === 'string' && !utils.isEmptyString(opt_userId) && opt_userId || type(opt_userId) === 'number' && opt_userId.toString() || _this.options.userId || null;
      var now = new Date().getTime();
      var startNewSession = !_this._sessionId || !_this._lastEventTime || now - _this._lastEventTime > _this.options.sessionTimeout || _this.options.sessionId;

      if (startNewSession) {
        if (_this.options.unsetParamsReferrerOnNewSession) {
          _this._unsetUTMParams();
        }

        _this._newSession = true;
        _this._sessionId = _this.options.sessionId || now; // reset this.options.sessionId to avoid re-usage
        // use instance.getSessionId() to get session id

        _this.options.sessionId = undefined; // only capture UTM params and referrer if new session

        if (_this.options.saveParamsReferrerOncePerSession) {
          _this._trackParamsAndReferrer();
        }
      }

      if (!_this.options.saveParamsReferrerOncePerSession) {
        _this._trackParamsAndReferrer();
      } // load unsent events and identifies before any attempt to log new ones


      if (_this.options.saveEvents) {
        _validateUnsentEventQueue(_this._unsentEvents);

        _validateUnsentEventQueue(_this._unsentIdentifys);
      }

      _this._lastEventTime = now;

      _saveCookieData(_this);

      _this._pendingReadStorage = false;

      _this._sendEventsIfReady(); // try sending unsent events


      for (var i = 0; i < _this._onInitCallbacks.length; i++) {
        _this._onInitCallbacks[i](_this);
      }

      _this._onInitCallbacks = [];
      _this._isInitialized = true;

      if (startNewSession) {
        _this._runNewSessionStartCallbacks();
      }
    };

    if (this.options.saveEvents) {
      this._unsentEvents = this._loadSavedUnsentEvents(this.options.unsentKey).map(function (event) {
        return {
          event: event
        };
      }).concat(this._unsentEvents);
      this._unsentIdentifys = this._loadSavedUnsentEvents(this.options.unsentIdentifyKey).map(function (event) {
        return {
          event: event
        };
      }).concat(this._unsentIdentifys);
    }

    if (opt_config && opt_config.onNewSessionStart) {
      this.onNewSessionStart(this.options.onNewSessionStart);
    }

    initFromStorage();
    this.runQueuedFunctions();

    if (type(opt_callback) === 'function') {
      opt_callback(this);
    }

    var onExitPage = this.options.onExitPage;

    if (type(onExitPage) === 'function') {
      if (!this.pageHandlersAdded) {
        this.pageHandlersAdded = true;

        var handleVisibilityChange = function handleVisibilityChange() {
          var prevTransport = _this.options.transport;

          _this.setTransport(Constants.TRANSPORT_BEACON);

          onExitPage();

          _this.setTransport(prevTransport);
        }; // Monitoring just page exits because that is the most requested feature for now
        // "If you're specifically trying to detect page unload events, the pagehide event is the best option."
        // https://developer.mozilla.org/en-US/docs/Web/API/Window/pagehide_event


        GlobalScope.addEventListener('pagehide', function () {
          handleVisibilityChange();
        }, false);
      }
    } // Sets an event receiver to receive and forward exposure events from the experiment SDK.


    this._connector.eventBridge.setEventReceiver(function (event) {
      _this._logEvent(event.eventType, event.eventProperties, event.userProperties);
    }); // Set the user ID and device ID in the core identity store to enable fetching variants.


    var editor = this._connector.identityStore.editIdentity();

    if (this.options.deviceId) {
      editor.setDeviceId(this.options.deviceId);
    }

    if (this.options.userId) {
      editor.setUserId(this.options.userId);
    }

    editor.commit();
  } catch (err) {
    utils.log.error(err);

    if (opt_config && type(opt_config.onError) === 'function') {
      opt_config.onError(err);
    }
  }
};

AmplitudeClient.prototype._runNewSessionStartCallbacks = function () {
  for (var i = 0; i < this._onNewSessionStartCallbacks.length; i++) {
    this._onNewSessionStartCallbacks[i](this);
  }
};

AmplitudeClient.prototype.deleteLowerLevelDomainCookies = function () {
  var host = getHost();
  var cookieHost = this.options.domain && this.options.domain[0] === '.' ? this.options.domain.slice(1) : this.options.domain;

  if (!cookieHost || !utils.isWebWorkerEnvironment()) {
    return;
  }

  if (host !== cookieHost) {
    if (new RegExp(cookieHost + '$').test(host)) {
      var hostParts = host.split('.');
      var cookieHostParts = cookieHost.split('.');

      for (var i = hostParts.length; i > cookieHostParts.length; --i) {
        var deleteDomain = hostParts.slice(hostParts.length - i).join('.');
        baseCookie.set(this._cookieName, null, {
          domain: '.' + deleteDomain
        });
      }

      baseCookie.set(this._cookieName, null, {});
    }
  }
};

AmplitudeClient.prototype._getInitialDeviceId = function (configDeviceId, storedDeviceId) {
  if (configDeviceId) {
    return configDeviceId;
  }

  if (this.options.deviceIdFromUrlParam) {
    var deviceIdFromUrlParam = this._getDeviceIdFromUrlParam(this._getUrlParams());

    if (deviceIdFromUrlParam) {
      return deviceIdFromUrlParam;
    }
  }

  if (this.options.deviceId) {
    return this.options.deviceId;
  }

  if (storedDeviceId) {
    return storedDeviceId;
  }

  return base64Id();
}; // validate properties for unsent events


var _validateUnsentEventQueue = function _validateUnsentEventQueue(queue) {
  for (var i = 0; i < queue.length; i++) {
    var userProperties = queue[i].event.user_properties;
    var eventProperties = queue[i].event.event_properties;
    var groups = queue[i].event.groups;
    queue[i].event.user_properties = utils.validateProperties(userProperties);
    queue[i].event.event_properties = utils.validateProperties(eventProperties);
    queue[i].event.groups = utils.validateGroups(groups);
  }
};
/**
 * @private
 */


AmplitudeClient.prototype._trackParamsAndReferrer = function _trackParamsAndReferrer() {
  var utmProperties;
  var referrerProperties;
  var gclidProperties;
  var fbclidProperties;

  if (this.options.includeUtm) {
    utmProperties = this._initUtmData();
  }

  if (this.options.includeReferrer) {
    referrerProperties = this._saveReferrer(this._getReferrer());
  }

  if (this.options.includeGclid) {
    gclidProperties = this._saveGclid(this._getUrlParams());
  }

  if (this.options.includeFbclid) {
    fbclidProperties = this._saveFbclid(this._getUrlParams());
  }

  if (this.options.logAttributionCapturedEvent) {
    var attributionProperties = _objectSpread({}, utmProperties, referrerProperties, gclidProperties, fbclidProperties);

    if (Object.keys(attributionProperties).length > 0) {
      this.logEvent(Constants.ATTRIBUTION_EVENT, attributionProperties);
    }
  }
};
/**
 * Parse and validate user specified config values and overwrite existing option value
 * DEFAULT_OPTIONS provides list of all config keys that are modifiable, as well as expected types for values
 * @private
 */


var _parseConfig = function _parseConfig(options, config) {
  if (type(config) !== 'object') {
    return;
  } // Add exception in headers


  var freeFormObjectKeys = new Set(['headers']); // validates config value is defined, is the correct type, and some additional value sanity checks

  var parseValidateAndLoad = function parseValidateAndLoad(key) {
    if (!Object.prototype.hasOwnProperty.call(options, key)) {
      return; // skip bogus config values
    }

    var inputValue = config[key];
    var expectedType = type(options[key]);

    if (key === 'transport' && !utils.validateTransport(inputValue)) {
      return;
    } else if (key === 'sessionId' && inputValue !== null) {
      options[key] = utils.validateSessionId(inputValue) ? inputValue : null;
      return;
    } else if (!utils.validateInput(inputValue, key + ' option', expectedType)) {
      return;
    }

    if (expectedType === 'boolean') {
      options[key] = !!inputValue;
    } else if (expectedType === 'string' && !utils.isEmptyString(inputValue) || expectedType === 'number' && inputValue > 0 || expectedType === 'function') {
      options[key] = inputValue;
    } else if (expectedType === 'object') {
      _parseConfig(options[key], inputValue);
    }
  };

  for (var key in config) {
    if (freeFormObjectKeys.has(key)) {
      options[key] = _objectSpread({}, options[key], config[key]);
    } else if (Object.prototype.hasOwnProperty.call(config, key)) {
      parseValidateAndLoad(key);
    }
  }
};
/**
 * Run functions queued up by proxy loading snippet
 * @private
 */


AmplitudeClient.prototype.runQueuedFunctions = function () {
  var queue = this._q;
  this._q = [];

  for (var i = 0; i < queue.length; i++) {
    var fn = this[queue[i][0]];

    if (type(fn) === 'function') {
      fn.apply(this, queue[i].slice(1));
    }
  }
};
/**
 * Check that the apiKey is set before calling a function. Logs a warning message if not set.
 * @private
 */


AmplitudeClient.prototype._apiKeySet = function _apiKeySet(methodName) {
  if (utils.isEmptyString(this.options.apiKey)) {
    utils.log.error('Invalid apiKey. Please set a valid apiKey with init() before calling ' + methodName);
    return false;
  }

  return true;
};
/**
 * Load saved events from localStorage. JSON deserializes event array. Handles case where string is corrupted.
 * @private
 */


AmplitudeClient.prototype._loadSavedUnsentEvents = function _loadSavedUnsentEvents(unsentKey) {
  var savedUnsentEventsString = this._getFromStorage(localStorage$1, unsentKey);

  var unsentEvents = this._parseSavedUnsentEventsString(savedUnsentEventsString, unsentKey);

  this._setInStorage(localStorage$1, unsentKey, JSON.stringify(unsentEvents));

  return unsentEvents;
};
/**
 * Load saved events from localStorage. JSON deserializes event array. Handles case where string is corrupted.
 * @private
 */


AmplitudeClient.prototype._parseSavedUnsentEventsString = function _parseSavedUnsentEventsString(savedUnsentEventsString, unsentKey) {
  if (utils.isEmptyString(savedUnsentEventsString)) {
    return []; // new app, does not have any saved events
  }

  if (type(savedUnsentEventsString) === 'string') {
    try {
      var events = JSON.parse(savedUnsentEventsString);

      if (type(events) === 'array') {
        // handle case where JSON dumping of unsent events is corrupted
        return events;
      }
    } catch (e) {}
    /* eslint-disable-line no-empty */

  }

  utils.log.error('Unable to load ' + unsentKey + ' events. Restart with a new empty queue.');
  return [];
};
/**
 * Returns true if a new session was created during initialization, otherwise false.
 * @public
 * @return {boolean} Whether a new session was created during initialization.
 */


AmplitudeClient.prototype.isNewSession = function isNewSession() {
  return this._newSession;
};
/**
 * Add callbacks to call after init. Useful for users who load Amplitude through a snippet.
 * @public
 */


AmplitudeClient.prototype.onInit = function onInit(callback) {
  if (this._isInitialized) {
    callback(this);
  } else {
    this._onInitCallbacks.push(callback);
  }
};
/**
 * Add callbacks to call after new session start.
 * @public
 */


AmplitudeClient.prototype.onNewSessionStart = function onNewSessionStart(callback) {
  this._onNewSessionStartCallbacks.push(callback);
};
/**
 * Returns the id of the current session.
 * @public
 * @return {number} Id of the current session.
 */


AmplitudeClient.prototype.getSessionId = function getSessionId() {
  return this._sessionId;
};
/**
 * Increments the eventId and returns it.
 * @private
 */


AmplitudeClient.prototype.nextEventId = function nextEventId() {
  this._eventId++;
  return this._eventId;
};
/**
 * Increments the identifyId and returns it.
 * @private
 */


AmplitudeClient.prototype.nextIdentifyId = function nextIdentifyId() {
  this._identifyId++;
  return this._identifyId;
};
/**
 * Increments the sequenceNumber and returns it.
 * @private
 */


AmplitudeClient.prototype.nextSequenceNumber = function nextSequenceNumber() {
  this._sequenceNumber++;
  return this._sequenceNumber;
};
/**
 * Returns the total count of unsent events and identifys
 * @private
 */


AmplitudeClient.prototype._unsentCount = function _unsentCount() {
  return this._unsentEvents.length + this._unsentIdentifys.length;
};
/**
 * Send events if ready. Returns true if events are sent.
 * @private
 */


AmplitudeClient.prototype._sendEventsIfReady = function _sendEventsIfReady() {
  if (this._unsentCount() === 0) {
    return false;
  } // if batching disabled, send any unsent events immediately


  if (!this.options.batchEvents) {
    this.sendEvents();
    return true;
  } // if batching enabled, check if min threshold met for batch size


  if (this._unsentCount() >= this.options.eventUploadThreshold) {
    this.sendEvents();
    return true;
  } // if beacon transport is activated, send events immediately
  // because there is no way to retry them later


  if (this.options.transport === Constants.TRANSPORT_BEACON) {
    this.sendEvents();
    return true;
  } // otherwise schedule an upload after 30s


  if (!this._updateScheduled) {
    // make sure we only schedule 1 upload
    this._updateScheduled = true;
    setTimeout(function () {
      this._updateScheduled = false;
      this.sendEvents();
    }.bind(this), this.options.eventUploadPeriodMillis);
  }

  return false; // an upload was scheduled, no events were uploaded
};
/**
 * Clears any stored events and metadata. Storage is then re-created on next event sending.
 * @public
 * @return {boolean} True if metadata was cleared, false if none existed
 */


AmplitudeClient.prototype.clearStorage = function clearStorage() {
  return this._metadataStorage.clear();
};
/**
 * Helper function to fetch values from storage
 * Storage argument allows for localStoraoge and sessionStoraoge
 * @private
 */


AmplitudeClient.prototype._getFromStorage = function _getFromStorage(storage, key) {
  return storage.getItem(key + this._storageSuffix);
};
/**
 * Helper function to set values in storage
 * Storage argument allows for localStoraoge and sessionStoraoge
 * @private
 */


AmplitudeClient.prototype._setInStorage = function _setInStorage(storage, key, value) {
  storage.setItem(key + this._storageSuffix, value);
};
/**
 * Fetches deviceId, userId, event meta data from amplitude cookie
 * @private
 */


var _loadCookieData = function _loadCookieData(scope) {
  if (!scope._useOldCookie) {
    var props = scope._metadataStorage.load();

    if (type(props) === 'object') {
      _loadCookieDataProps(scope, props);
    }

    return;
  }

  var cookieData = scope.cookieStorage.get(scope._oldCookiename);

  if (type(cookieData) === 'object') {
    _loadCookieDataProps(scope, cookieData);

    return;
  }
};

var _upgradeCookieData = function _upgradeCookieData(scope) {
  var cookieData = scope.cookieStorage.get(scope._oldCookiename);

  if (type(cookieData) === 'object') {
    _loadCookieDataProps(scope, cookieData);

    _saveCookieData(scope);
  }
};

var _loadCookieDataProps = function _loadCookieDataProps(scope, cookieData) {
  if (cookieData.deviceId) {
    scope.options.deviceId = cookieData.deviceId;
  }

  if (cookieData.userId) {
    scope.options.userId = cookieData.userId;
  }

  if (cookieData.optOut !== null && cookieData.optOut !== undefined) {
    // Do not clobber config opt out value if cookieData has optOut as false
    if (cookieData.optOut !== false) {
      scope.options.optOut = cookieData.optOut;
    }
  }

  if (cookieData.sessionId) {
    scope._sessionId = parseInt(cookieData.sessionId, 10);
  }

  if (cookieData.lastEventTime) {
    scope._lastEventTime = parseInt(cookieData.lastEventTime, 10);
  }

  if (cookieData.eventId) {
    scope._eventId = parseInt(cookieData.eventId, 10);
  }

  if (cookieData.identifyId) {
    scope._identifyId = parseInt(cookieData.identifyId, 10);
  }

  if (cookieData.sequenceNumber) {
    scope._sequenceNumber = parseInt(cookieData.sequenceNumber, 10);
  }
};
/**
 * Saves deviceId, userId, event meta data to amplitude cookie
 * @private
 */


var _saveCookieData = function _saveCookieData(scope) {
  var cookieData = {
    deviceId: scope.options.deviceId,
    userId: scope.options.userId,
    optOut: scope.options.optOut,
    sessionId: scope._sessionId,
    lastEventTime: scope._lastEventTime,
    eventId: scope._eventId,
    identifyId: scope._identifyId,
    sequenceNumber: scope._sequenceNumber
  };

  if (scope._useOldCookie) {
    scope.cookieStorage.set(scope.options.cookieName + scope._storageSuffix, cookieData);
  } else {
    scope._metadataStorage.save(cookieData);
  }
};
/**
 * Parse the utm properties out of cookies and query for adding to user properties.
 * @private
 */


AmplitudeClient.prototype._initUtmData = function _initUtmData(queryParams, cookieParams) {
  queryParams = queryParams || this._getUrlParams();
  cookieParams = cookieParams || this.cookieStorage.get('__utmz');
  var utmProperties = getUtmData(cookieParams, queryParams);

  _sendParamsReferrerUserProperties(this, utmProperties);

  return utmProperties;
};
/**
 * Unset the utm params from the Amplitude instance and update the identify.
 * @private
 */


AmplitudeClient.prototype._unsetUTMParams = function _unsetUTMParams() {
  var identify = new Identify();
  identify.unset(Constants.REFERRER);
  identify.unset(Constants.UTM_SOURCE);
  identify.unset(Constants.UTM_MEDIUM);
  identify.unset(Constants.UTM_CAMPAIGN);
  identify.unset(Constants.UTM_TERM);
  identify.unset(Constants.UTM_CONTENT);
  this.identify(identify);
};
/**
 * The calling function should determine when it is appropriate to send these user properties. This function
 * will no longer contain any session storage checking logic.
 * @private
 */


var _sendParamsReferrerUserProperties = function _sendParamsReferrerUserProperties(scope, userProperties) {
  if (type(userProperties) !== 'object' || Object.keys(userProperties).length === 0) {
    return;
  } // setOnce the initial user properties


  var identify = new Identify();

  for (var key in userProperties) {
    if (Object.prototype.hasOwnProperty.call(userProperties, key)) {
      identify.setOnce('initial_' + key, userProperties[key]);
      identify.set(key, userProperties[key]);
    }
  }

  scope.identify(identify);
};
/**
 * @private
 */


AmplitudeClient.prototype._getReferrer = function _getReferrer() {
  return typeof document !== 'undefined' ? document.referrer : '';
};
/**
 * @private
 */


AmplitudeClient.prototype._getUrlParams = function _getUrlParams() {
  return GlobalScope.location.search;
};
/**
 * Try to fetch Google Gclid from url params.
 * @private
 */


AmplitudeClient.prototype._saveGclid = function _saveGclid(urlParams) {
  var gclid = utils.getQueryParam('gclid', urlParams);

  if (utils.isEmptyString(gclid)) {
    return;
  }

  var gclidProperties = {
    gclid: gclid
  };

  _sendParamsReferrerUserProperties(this, gclidProperties);

  return gclidProperties;
};
/**
 * Try to fetch Facebook Fbclid from url params.
 * @private
 */


AmplitudeClient.prototype._saveFbclid = function _saveFbclid(urlParams) {
  var fbclid = utils.getQueryParam('fbclid', urlParams);

  if (utils.isEmptyString(fbclid)) {
    return;
  }

  var fbclidProperties = {
    fbclid: fbclid
  };

  _sendParamsReferrerUserProperties(this, fbclidProperties);

  return fbclidProperties;
};
/**
 * Try to fetch Amplitude device id from url params.
 * @private
 */


AmplitudeClient.prototype._getDeviceIdFromUrlParam = function _getDeviceIdFromUrlParam(urlParams) {
  return utils.getQueryParam(Constants.AMP_DEVICE_ID_PARAM, urlParams);
};
/**
 * Parse the domain from referrer info
 * @private
 */


AmplitudeClient.prototype._getReferringDomain = function _getReferringDomain(referrer) {
  if (utils.isEmptyString(referrer)) {
    return null;
  }

  var parts = referrer.split('/');

  if (parts.length >= 3) {
    return parts[2];
  }

  return null;
};
/**
 * Fetch the referrer information, parse the domain and send.
 * Since user properties are propagated on the server, only send once per session, don't need to send with every event
 * @private
 */


AmplitudeClient.prototype._saveReferrer = function _saveReferrer(referrer) {
  if (utils.isEmptyString(referrer)) {
    return;
  }

  var referrerInfo = {
    referrer: referrer,
    referring_domain: this._getReferringDomain(referrer)
  };

  _sendParamsReferrerUserProperties(this, referrerInfo);

  return referrerInfo;
};
/**
 * Saves unsent events and identifies to localStorage. JSON stringifies event queues before saving.
 * Note: this is called automatically every time events are logged, unless you explicitly set option saveEvents to false.
 * @private
 */


AmplitudeClient.prototype.saveEvents = function saveEvents() {
  try {
    var serializedUnsentEvents = JSON.stringify(this._unsentEvents.map(function (_ref) {
      var event = _ref.event;
      return event;
    }));

    this._setInStorage(localStorage$1, this.options.unsentKey, serializedUnsentEvents);
  } catch (e) {}
  /* eslint-disable-line no-empty */


  try {
    var serializedIdentifys = JSON.stringify(this._unsentIdentifys.map(function (unsentIdentify) {
      return unsentIdentify.event;
    }));

    this._setInStorage(localStorage$1, this.options.unsentIdentifyKey, serializedIdentifys);
  } catch (e) {}
  /* eslint-disable-line no-empty */

};
/**
 * Sets a customer domain for the amplitude cookie. Useful if you want to support cross-subdomain tracking.
 * @public
 * @param {string} domain to set.
 * @example amplitudeClient.setDomain('.amplitude.com');
 */


AmplitudeClient.prototype.setDomain = function setDomain(domain) {
  if (this._shouldDeferCall()) {
    return this._q.push(['setDomain'].concat(Array.prototype.slice.call(arguments, 0)));
  }

  if (!utils.validateInput(domain, 'domain', 'string')) {
    return;
  }

  try {
    this.cookieStorage.options({
      expirationDays: this.options.cookieExpiration,
      secure: this.options.secureCookie,
      domain: domain,
      sameSite: this.options.sameSiteCookie
    });
    this.options.domain = this.cookieStorage.options().domain;

    _loadCookieData(this);

    _saveCookieData(this);
  } catch (e) {
    utils.log.error(e);
  }
};
/**
 * Sets an identifier for the current user.
 * @public
 * @param {string} userId - identifier to set. Can be null.
 * @param {boolean} startNewSession - (optional) if start a new session or not
 * @example amplitudeClient.setUserId('joe@gmail.com');
 */


AmplitudeClient.prototype.setUserId = function setUserId(userId) {
  var startNewSession = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (!utils.validateInput(startNewSession, 'startNewSession', 'boolean')) {
    return;
  }

  if (this._shouldDeferCall()) {
    return this._q.push(['setUserId'].concat(Array.prototype.slice.call(arguments, 0)));
  }

  try {
    this.options.userId = userId !== undefined && userId !== null && '' + userId || null;

    if (startNewSession) {
      if (this.options.unsetParamsReferrerOnNewSession) {
        this._unsetUTMParams();
      }

      this._newSession = true;
      this._sessionId = new Date().getTime();

      this._runNewSessionStartCallbacks(); // only capture UTM params and referrer if new session


      if (this.options.saveParamsReferrerOncePerSession) {
        this._trackParamsAndReferrer();
      }
    }

    _saveCookieData(this); // Update core identity store to propagate new user info
    // to experiment SDK and trigger a fetch if the ID has changed.


    if (this._connector) {
      this._connector.identityStore.editIdentity().setUserId(this.options.userId).commit();
    }
  } catch (e) {
    utils.log.error(e);
  }
};
/**
 * Add user to a group or groups. You need to specify a groupType and groupName(s).
 *
 * For example you can group people by their organization.
 * In that case, groupType is "orgId" and groupName would be the actual ID(s).
 * groupName can be a string or an array of strings to indicate a user in multiple gruups.
 * You can also call setGroup multiple times with different groupTypes to track multiple types of groups (up to 5 per app).
 *
 * Note: this will also set groupType: groupName as a user property.
 * See the [advanced topics article](https://developers.amplitude.com/docs/javascript#user-groups) for more information.
 * @public
 * @param {string} groupType - the group type (ex: orgId)
 * @param {string|list} groupName - the name of the group (ex: 15), or a list of names of the groups
 * @example amplitudeClient.setGroup('orgId', 15); // this adds the current user to orgId 15.
 */


AmplitudeClient.prototype.setGroup = function (groupType, groupName) {
  if (this._shouldDeferCall()) {
    return this._q.push(['setGroup'].concat(Array.prototype.slice.call(arguments, 0)));
  }

  if (!this._apiKeySet('setGroup()') || !utils.validateInput(groupType, 'groupType', 'string') || utils.isEmptyString(groupType)) {
    return;
  }

  var groups = {};
  groups[groupType] = groupName;
  var identify = new Identify().set(groupType, groupName);

  this._logEvent(Constants.IDENTIFY_EVENT, null, null, identify.userPropertiesOperations, groups, null, null, null);
};
/**
 * Sets whether to opt current user out of tracking.
 * @public
 * @param {boolean} enable - if true then no events will be logged or sent.
 * @example: amplitude.setOptOut(true);
 */


AmplitudeClient.prototype.setOptOut = function setOptOut(enable) {
  if (this._shouldDeferCall()) {
    return this._q.push(['setOptOut'].concat(Array.prototype.slice.call(arguments, 0)));
  }

  if (!utils.validateInput(enable, 'enable', 'boolean')) {
    return;
  }

  try {
    this.options.optOut = enable;

    _saveCookieData(this);
  } catch (e) {
    utils.log.error(e);
  }
};
/**
 * Set a custom Session ID for the current session.
 * Note: This is not recommended unless you know what you are doing because the Session ID of a session is utilized for all session metrics in Amplitude.
 * The Session ID to set for the current session must be in milliseconds since epoch (Unix Timestamp).
 * @public
 * @param {int} sessionId to set.
 * @example amplitudeClient.setSessionId(1622158968000);
 */


AmplitudeClient.prototype.setSessionId = function setSessionId(sessionId) {
  if (!utils.validateInput(sessionId, 'sessionId', 'number')) {
    return;
  }

  try {
    this._sessionId = sessionId;

    _saveCookieData(this);
  } catch (e) {
    utils.log.error(e);
  }
};
/**
 * Sets the current Unix timestamp as the new Session ID for the instance.
 * @public
 * @example amplitudeClient.resetSessionId();
 */


AmplitudeClient.prototype.resetSessionId = function resetSessionId() {
  this.setSessionId(new Date().getTime());
};
/**
 * Regenerates a new random deviceId for current user. Note: this is not recommended unless you know what you
 * are doing. This can be used in conjunction with `setUserId(null)` to anonymize users after they log out.
 * With a null userId and a completely new deviceId, the current user would appear as a brand new user in dashboard.
 * This uses src/uuid.js to regenerate the deviceId.
 * @public
 */


AmplitudeClient.prototype.regenerateDeviceId = function regenerateDeviceId() {
  if (this._shouldDeferCall()) {
    return this._q.push(['regenerateDeviceId'].concat(Array.prototype.slice.call(arguments, 0)));
  }

  this.setDeviceId(base64Id());
};
/**
 * Sets a custom deviceId for current user. **Values may not have `.` inside them**
 * Note: this is not recommended unless you know what you are doing (like if you have your own system for managing deviceIds).
 * Make sure the deviceId you set is sufficiently unique
 * (we recommend something like a UUID - see src/uuid.js for an example of how to generate) to prevent conflicts with other devices in our system.
 * @public
 * @param {string} deviceId - custom deviceId for current user.
 * @example amplitudeClient.setDeviceId('45f0954f-eb79-4463-ac8a-233a6f45a8f0');
 */


AmplitudeClient.prototype.setDeviceId = function setDeviceId(deviceId) {
  if (this._shouldDeferCall()) {
    return this._q.push(['setDeviceId'].concat(Array.prototype.slice.call(arguments, 0)));
  }

  if (!utils.validateDeviceId(deviceId)) {
    return;
  }

  try {
    if (!utils.isEmptyString(deviceId)) {
      this.options.deviceId = '' + deviceId;

      _saveCookieData(this); // Update core identity store to propagate new user info
      // to experiment SDK and trigger a fetch if the ID has changed.


      if (this._connector) {
        this._connector.identityStore.editIdentity().setDeviceId(this.options.deviceId).commit();
      }
    }
  } catch (e) {
    utils.log.error(e);
  }
};
/**
 * Sets the network transport type for events. Typically used to set to 'beacon'
 * on an end-of-lifecycle event handler such as `onpagehide` or `onvisibilitychange`
 * @public
 * @param {string} transport - transport mechanism to use for events. Must be one of `http` or `beacon`.
 * @example amplitudeClient.setDeviceId('45f0954f-eb79-4463-ac8a-233a6f45a8f0');
 */


AmplitudeClient.prototype.setTransport = function setTransport(transport) {
  if (this._shouldDeferCall()) {
    return this._q.push(['setTransport'].concat(Array.prototype.slice.call(arguments, 0)));
  }

  if (!utils.validateTransport(transport)) {
    return;
  }

  this.options.transport = transport;
};
/**
 * Sets user properties for the current user.
 * @public
 * @param {object} - object with string keys and values for the user properties to set.
 * @param {boolean} - DEPRECATED opt_replace: in earlier versions of the JS SDK the user properties object was kept in
 * memory and replace = true would replace the object in memory. Now the properties are no longer stored in memory, so replace is deprecated.
 * @example amplitudeClient.setUserProperties({'gender': 'female', 'sign_up_complete': true})
 */


AmplitudeClient.prototype.setUserProperties = function setUserProperties(userProperties) {
  if (this._shouldDeferCall()) {
    return this._q.push(['setUserProperties'].concat(Array.prototype.slice.call(arguments, 0)));
  }

  if (!this._apiKeySet('setUserProperties()') || !utils.validateInput(userProperties, 'userProperties', 'object')) {
    return;
  } // sanitize the userProperties dict before converting into identify


  var sanitized = utils.truncate(utils.validateProperties(userProperties));

  if (Object.keys(sanitized).length === 0) {
    return;
  } // convert userProperties into an identify call


  var identify = new Identify();

  for (var property in sanitized) {
    if (Object.prototype.hasOwnProperty.call(sanitized, property)) {
      identify.set(property, sanitized[property]);
    }
  }

  this.identify(identify);
};
/**
 * Clear all of the user properties for the current user. Note: clearing user properties is irreversible!
 * @public
 * @example amplitudeClient.clearUserProperties();
 */


AmplitudeClient.prototype.clearUserProperties = function clearUserProperties() {
  if (this._shouldDeferCall()) {
    return this._q.push(['clearUserProperties'].concat(Array.prototype.slice.call(arguments, 0)));
  }

  if (!this._apiKeySet('clearUserProperties()')) {
    return;
  }

  var identify = new Identify();
  identify.clearAll();
  this.identify(identify);
};
/**
 * Applies the proxied functions on the proxied object to an instance of the real object.
 * Used to convert proxied Identify and Revenue objects.
 * @private
 */


var _convertProxyObjectToRealObject = function _convertProxyObjectToRealObject(instance, proxy) {
  for (var i = 0; i < proxy._q.length; i++) {
    var fn = instance[proxy._q[i][0]];

    if (type(fn) === 'function') {
      fn.apply(instance, proxy._q[i].slice(1));
    }
  }

  return instance;
};
/**
 * Send an identify call containing user property operations to Amplitude servers.
 * See the [Identify](https://amplitude.github.io/Amplitude-JavaScript/Identify/)
 * reference page for more information on the Identify API and user property operations.
 * @param {Identify} identify_obj - the Identify object containing the user property operations to send.
 * @param {Amplitude~eventCallback} opt_callback - (optional) callback function to run when the identify event has been sent.
 * Note: the server response code and response body from the identify event upload are passed to the callback function.
 * @param {Amplitude~eventCallback} opt_error_callback - (optional) a callback function to run after the event logging
 * fails. The failure can be from the request being malformed or from a network failure
 * Note: the server response code and response body from the event upload are passed to the callback function.
 * @example
 * var identify = new amplitude.Identify().set('colors', ['rose', 'gold']).add('karma', 1).setOnce('sign_up_date', '2016-03-31');
 * amplitude.identify(identify);
 */


AmplitudeClient.prototype.identify = function (identify_obj, opt_callback, opt_error_callback, outOfSession) {
  if (this._shouldDeferCall()) {
    return this._q.push(['identify'].concat(Array.prototype.slice.call(arguments, 0)));
  }

  if (!this._apiKeySet('identify()')) {
    _logErrorsWithCallbacks(opt_callback, opt_error_callback, 0, 'No request sent', {
      reason: 'API key is not set'
    });

    return;
  } // if identify input is a proxied object created by the async loading snippet, convert it into an identify object


  if (type(identify_obj) === 'object' && Object.prototype.hasOwnProperty.call(identify_obj, '_q')) {
    identify_obj = _convertProxyObjectToRealObject(new Identify(), identify_obj);
  }

  if (identify_obj instanceof Identify) {
    // only send if there are operations
    if (Object.keys(identify_obj.userPropertiesOperations).length > 0) {
      return this._logEvent(Constants.IDENTIFY_EVENT, null, null, identify_obj.userPropertiesOperations, null, null, null, opt_callback, opt_error_callback, outOfSession);
    } else {
      _logErrorsWithCallbacks(opt_callback, opt_error_callback, 0, 'No request sent', {
        reason: 'No user property operations'
      });
    }
  } else {
    utils.log.error('Invalid identify input type. Expected Identify object but saw ' + type(identify_obj));

    _logErrorsWithCallbacks(opt_callback, opt_error_callback, 0, 'No request sent', {
      reason: 'Invalid identify input type'
    });
  }
};

AmplitudeClient.prototype.groupIdentify = function (group_type, group_name, identify_obj, opt_callback, opt_error_callback, outOfSession) {
  if (this._shouldDeferCall()) {
    return this._q.push(['groupIdentify'].concat(Array.prototype.slice.call(arguments, 0)));
  }

  if (!this._apiKeySet('groupIdentify()')) {
    _logErrorsWithCallbacks(opt_callback, opt_error_callback, 0, 'No request sent', {
      reason: 'API key is not set'
    });

    return;
  }

  if (!utils.validateInput(group_type, 'group_type', 'string') || utils.isEmptyString(group_type)) {
    _logErrorsWithCallbacks(opt_callback, opt_error_callback, 0, 'No request sent', {
      reason: 'Invalid group type'
    });

    return;
  }

  if (group_name === null || group_name === undefined) {
    _logErrorsWithCallbacks(opt_callback, opt_error_callback, 0, 'No request sent', {
      reason: 'Invalid group name'
    });

    return;
  } // if identify input is a proxied object created by the async loading snippet, convert it into an identify object


  if (type(identify_obj) === 'object' && Object.prototype.hasOwnProperty.call(identify_obj, '_q')) {
    identify_obj = _convertProxyObjectToRealObject(new Identify(), identify_obj);
  }

  if (identify_obj instanceof Identify) {
    // only send if there are operations
    if (Object.keys(identify_obj.userPropertiesOperations).length > 0) {
      return this._logEvent(Constants.GROUP_IDENTIFY_EVENT, null, null, null, _defineProperty({}, group_type, group_name), identify_obj.userPropertiesOperations, null, opt_callback, opt_error_callback, outOfSession);
    } else {
      _logErrorsWithCallbacks(opt_callback, opt_error_callback, 0, 'No request sent', {
        reason: 'No group property operations'
      });
    }
  } else {
    utils.log.error('Invalid identify input type. Expected Identify object but saw ' + type(identify_obj));

    _logErrorsWithCallbacks(opt_callback, opt_error_callback, 0, 'No request sent', {
      reason: 'Invalid identify input type'
    });
  }
};
/**
 * Set a versionName for your application.
 * @public
 * @param {string} versionName - The version to set for your application.
 * @example amplitudeClient.setVersionName('1.12.3');
 */


AmplitudeClient.prototype.setVersionName = function setVersionName(versionName) {
  if (this._shouldDeferCall()) {
    return this._q.push(['setVersionName'].concat(Array.prototype.slice.call(arguments, 0)));
  }

  if (!utils.validateInput(versionName, 'versionName', 'string')) {
    return;
  }

  this.options.versionName = versionName;
};
/**
 * Private logEvent method. Keeps apiProperties from being publicly exposed.
 * @private
 */


AmplitudeClient.prototype._logEvent = function _logEvent(eventType, eventProperties, apiProperties, userProperties, groups, groupProperties, timestamp, callback, errorCallback, outOfSession) {
  _loadCookieData(this); // reload cookie before each log event to sync event meta-data between windows and tabs


  if (!eventType) {
    _logErrorsWithCallbacks(callback, errorCallback, 0, 'No request sent', {
      reason: 'Missing eventType'
    });

    return;
  }

  if (this.options.optOut) {
    _logErrorsWithCallbacks(callback, errorCallback, 0, 'No request sent', {
      reason: 'optOut is set to true'
    });

    return;
  }

  try {
    var eventId;

    if (eventType === Constants.IDENTIFY_EVENT || eventType === Constants.GROUP_IDENTIFY_EVENT) {
      eventId = this.nextIdentifyId();
    } else {
      eventId = this.nextEventId();
    }

    var sequenceNumber = this.nextSequenceNumber();
    var eventTime = type(timestamp) === 'number' ? timestamp : new Date().getTime();

    if (outOfSession) {
      this._sessionId = -1;
    } else if (!this._sessionId || !this._lastEventTime || eventTime - this._lastEventTime > this.options.sessionTimeout) {
      this._sessionId = eventTime;

      this._runNewSessionStartCallbacks();
    }

    this._lastEventTime = eventTime;

    _saveCookieData(this);

    var osName = this._ua.browser.name;
    var osVersion = this._ua.browser.major;
    var deviceModel = this._ua.device.model || this._ua.os.name;
    var deviceVendor = this._ua.device.vendor;
    userProperties = userProperties || {};

    var trackingOptions = _objectSpread({}, this._apiPropertiesTrackingOptions);

    apiProperties = _objectSpread({}, apiProperties || {}, trackingOptions);
    eventProperties = eventProperties || {};
    groups = groups || {};
    groupProperties = groupProperties || {};
    var event = {
      device_id: this.options.deviceId,
      user_id: this.options.userId,
      timestamp: eventTime,
      event_id: eventId,
      session_id: this._sessionId || -1,
      event_type: eventType,
      version_name: this.options.versionName || null,
      platform: _shouldTrackField(this, 'platform') ? this.options.platform : null,
      os_name: _shouldTrackField(this, 'os_name') ? osName || null : null,
      os_version: _shouldTrackField(this, 'os_version') ? osVersion || null : null,
      device_model: _shouldTrackField(this, 'device_model') ? deviceModel || null : null,
      device_manufacturer: _shouldTrackField(this, 'device_manufacturer') ? deviceVendor || null : null,
      language: _shouldTrackField(this, 'language') ? this.options.language : null,
      api_properties: apiProperties,
      event_properties: utils.truncate(utils.validateProperties(eventProperties)),
      user_properties: utils.truncate(utils.validateProperties(userProperties)),
      uuid: uuid(),
      library: this.options.library,
      sequence_number: sequenceNumber,
      // for ordering events and identifys
      groups: utils.truncate(utils.validateGroups(groups)),
      group_properties: utils.truncate(utils.validateProperties(groupProperties)),
      user_agent: this._userAgent
    };

    if (_isObservePlanSet(this)) {
      event.plan = {
        branch: this.options.plan.branch || undefined,
        source: this.options.plan.source || undefined,
        version: this.options.plan.version || undefined
      };
    }

    if (eventType === Constants.IDENTIFY_EVENT || eventType === Constants.GROUP_IDENTIFY_EVENT) {
      this._unsentIdentifys.push({
        event: event,
        callback: callback,
        errorCallback: errorCallback
      });

      this._limitEventsQueued(this._unsentIdentifys);
    } else {
      this._unsentEvents.push({
        event: event,
        callback: callback,
        errorCallback: errorCallback
      });

      this._limitEventsQueued(this._unsentEvents);
    }

    if (this.options.saveEvents) {
      this.saveEvents();
    }

    this._sendEventsIfReady(); // In the case of an identify event, update the core user store so the experiment SDK can fetch new variants and
    // utilize user properties in real time.


    if (eventType === Constants.IDENTIFY_EVENT && this._connector) {
      this._connector.identityStore.editIdentity().updateUserProperties(utils.truncate(utils.validateProperties(userProperties))).commit();
    }

    return eventId;
  } catch (e) {
    utils.log.error(e);
  }
};

var _isObservePlanSet = function _isObservePlanSet(scope) {
  return scope.options.plan && (scope.options.plan.source || scope.options.plan.branch || scope.options.plan.version);
};

var _shouldTrackField = function _shouldTrackField(scope, field) {
  return !!scope.options.trackingOptions[field];
};

var _generateApiPropertiesTrackingConfig = function _generateApiPropertiesTrackingConfig(scope) {
  // to limit size of config payload, only send fields that have been disabled
  var fields = ['city', 'country', 'dma', 'ip_address', 'region'];
  var config = {};

  for (var i = 0; i < fields.length; i++) {
    var field = fields[i];

    if (!_shouldTrackField(scope, field)) {
      config[field] = false;
    }
  }

  return config;
};
/**
 * Remove old events from the beginning of the array if too many have accumulated. Default limit is 1000 events.
 * @private
 */


AmplitudeClient.prototype._limitEventsQueued = function _limitEventsQueued(queue) {
  if (queue.length > this.options.savedMaxCount) {
    var deletedEvents = queue.splice(0, queue.length - this.options.savedMaxCount);
    deletedEvents.forEach(function (event) {
      _logErrorsWithCallbacks(event.callback, event.errorCallback, 0, 'No request sent', {
        reason: 'Event dropped because options.savedMaxCount exceeded. User may be offline or have a content blocker'
      });
    });
  }
};
/**
 * This is the callback for logEvent and identify calls. It gets called after the event/identify is uploaded,
 * and the server response code and response body from the upload request are passed to the callback function.
 * @callback Amplitude~eventCallback
 * @param {number} responseCode - Server response code for the event / identify upload request.
 * @param {string} responseBody - Server response body for the event / identify upload request.
 * @param {object} details - (optional) Additional information associated with sending event.
 */

/**
 * Log an event with eventType and eventProperties
 * @public
 * @param {string} eventType - name of event
 * @param {object} eventProperties - (optional) an object with string keys and values for the event properties.
 * @param {Amplitude~eventCallback} opt_callback - (optional) a callback function to run after the event is logged.
 * Note: the server response code and response body from the event upload are passed to the callback function.
 * @param {Amplitude~eventCallback} opt_error_callback - (optional) a callback function to run after the event logging
 * fails. The failure can be from the request being malformed or from a network failure
 * Note: the server response code and response body from the event upload are passed to the callback function.
 * @param {boolean} outOfSession - (optional) if this event is out of session or not
 * @example amplitudeClient.logEvent('Clicked Homepage Button', {'finished_flow': false, 'clicks': 15});
 */


AmplitudeClient.prototype.logEvent = function logEvent(eventType, eventProperties, opt_callback, opt_error_callback) {
  var outOfSession = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  if (this._shouldDeferCall()) {
    return this._q.push(['logEvent'].concat(Array.prototype.slice.call(arguments, 0)));
  }

  return this.logEventWithTimestamp(eventType, eventProperties, null, opt_callback, opt_error_callback, outOfSession);
};
/**
 * Log an event with eventType and eventProperties and a custom timestamp
 * @public
 * @param {string} eventType - name of event
 * @param {object} eventProperties - (optional) an object with string keys and values for the event properties.
 * @param {number} timestamp - (optional) the custom timestamp as milliseconds since epoch.
 * @param {Amplitude~eventCallback} opt_callback - (optional) a callback function to run after the event is logged.
 * Note: the server response code and response body from the event upload are passed to the callback function.
 * @param {Amplitude~eventCallback} opt_error_callback - (optional) a callback function to run after the event logging
 * fails. The failure can be from the request being malformed or from a network failure
 * Note: the server response code and response body from the event upload are passed to the callback function.
 * @param {boolean} outOfSession - (optional) if out of the sessioin or not
 * @example amplitudeClient.logEvent('Clicked Homepage Button', {'finished_flow': false, 'clicks': 15});
 */


AmplitudeClient.prototype.logEventWithTimestamp = function logEvent(eventType, eventProperties, timestamp, opt_callback, opt_error_callback) {
  var outOfSession = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

  if (this._shouldDeferCall()) {
    return this._q.push(['logEventWithTimestamp'].concat(Array.prototype.slice.call(arguments, 0)));
  }

  if (!this._apiKeySet('logEvent()')) {
    _logErrorsWithCallbacks(opt_callback, opt_error_callback, 0, 'No request sent', {
      reason: 'API key not set'
    });

    return -1;
  }

  if (!utils.validateInput(eventType, 'eventType', 'string')) {
    _logErrorsWithCallbacks(opt_callback, opt_error_callback, 0, 'No request sent', {
      reason: 'Invalid type for eventType'
    });

    return -1;
  }

  if (utils.isEmptyString(eventType)) {
    _logErrorsWithCallbacks(opt_callback, opt_error_callback, 0, 'No request sent', {
      reason: 'Missing eventType'
    });

    return -1;
  }

  if (!utils.validateInput(outOfSession, 'outOfSession', 'boolean')) {
    _logErrorsWithCallbacks(opt_callback, opt_error_callback, 0, 'No request sent', {
      reason: 'Invalid outOfSession value'
    });
  }

  return this._logEvent(eventType, eventProperties, null, null, null, null, timestamp, opt_callback, opt_error_callback, outOfSession);
};
/**
 * Log an event with eventType, eventProperties, and groups. Use this to set event-level groups.
 * Note: the group(s) set only apply for the specific event type being logged and does not persist on the user
 * (unless you explicitly set it with setGroup).
 *
 * See the [advanced topics article](https://developers.amplitude.com/docs/javascript#user-groups) for more information
 * about groups and Count by Distinct on the Amplitude platform.
 * @public
 * @param {string} eventType - name of event
 * @param {object} eventProperties - (optional) an object with string keys and values for the event properties.
 * @param {object} groups - (optional) an object with string groupType: groupName values for the event being logged.
 * groupName can be a string or an array of strings.
 * @param {Amplitude~eventCallback} opt_callback - (optional) a callback function to run after the event is logged.
 * Note: the server response code and response body from the event upload are passed to the callback function.
 * @param {Amplitude~eventCallback} opt_error_callback - (optional) a callback function to run after the event logging
 * fails. The failure can be from the request being malformed or from a network failure
 * Note: the server response code and response body from the event upload are passed to the callback function.
 * @example amplitudeClient.logEventWithGroups('Clicked Button', null, {'orgId': 24});
 */


AmplitudeClient.prototype.logEventWithGroups = function (eventType, eventProperties, groups, opt_callback, opt_error_callback) {
  var outOfSession = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

  if (this._shouldDeferCall()) {
    return this._q.push(['logEventWithGroups'].concat(Array.prototype.slice.call(arguments, 0)));
  }

  if (!this._apiKeySet('logEventWithGroups()')) {
    _logErrorsWithCallbacks(event.callback, event.errorCallback, 0, 'No request sent', {
      reason: 'API key not set'
    });

    return -1;
  }

  if (!utils.validateInput(eventType, 'eventType', 'string')) {
    _logErrorsWithCallbacks(event.callback, event.errorCallback, 0, 'No request sent', {
      reason: 'Invalid type for eventType'
    });

    return -1;
  }

  if (!utils.validateInput(outOfSession, 'outOfSession', 'boolean')) {
    _logErrorsWithCallbacks(event.callback, event.errorCallback, 0, 'No request sent', {
      reason: 'Invalid outOfSession value'
    });
  }

  return this._logEvent(eventType, eventProperties, null, null, groups, null, null, opt_callback, opt_error_callback, outOfSession);
};
/**
 * Test that n is a number or a numeric value.
 * @private
 */


var _isNumber = function _isNumber(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
};
/**
 * Handles errors that are sent to both callbacks
 * @private
 */


var _logErrorsWithCallbacks = function _logErrorsWithCallbacks(opt_callback, opt_error_callback, status, response, details) {
  if (type(opt_callback) === 'function') {
    opt_callback(status, response, details);
  }

  if (type(opt_error_callback) === 'function') {
    opt_error_callback(status, response, details);
  }
};
/**
 * Log revenue with Revenue interface. The new revenue interface allows for more revenue fields like
 * revenueType and event properties.
 *
 * See the [Revenue](https://amplitude.github.io/Amplitude-JavaScript/Revenue/)
 * reference page for more information on the Revenue interface and logging revenue.
 * @public
 * @param {Revenue} revenue_obj - the revenue object containing the revenue data being logged.
 * @example var revenue = new amplitude.Revenue().setProductId('productIdentifier').setPrice(10.99);
 * amplitude.logRevenueV2(revenue);
 */


AmplitudeClient.prototype.logRevenueV2 = function logRevenueV2(revenue_obj) {
  if (this._shouldDeferCall()) {
    return this._q.push(['logRevenueV2'].concat(Array.prototype.slice.call(arguments, 0)));
  }

  if (!this._apiKeySet('logRevenueV2()')) {
    return;
  } // if revenue input is a proxied object created by the async loading snippet, convert it into an revenue object


  if (type(revenue_obj) === 'object' && Object.prototype.hasOwnProperty.call(revenue_obj, '_q')) {
    revenue_obj = _convertProxyObjectToRealObject(new Revenue(), revenue_obj);
  }

  if (revenue_obj instanceof Revenue) {
    // only send if revenue is valid
    if (revenue_obj && revenue_obj._isValidRevenue()) {
      return this.logEvent(Constants.REVENUE_EVENT, revenue_obj._toJSONObject());
    }
  } else {
    utils.log.error('Invalid revenue input type. Expected Revenue object but saw ' + type(revenue_obj));
  }
};

{
  /**
   * Log revenue event with a price, quantity, and product identifier. DEPRECATED - use logRevenueV2
   * @public
   * @deprecated
   * @param {number} price - price of revenue event
   * @param {number} quantity - (optional) quantity of products in revenue event. If no quantity specified default to 1.
   * @param {string} product - (optional) product identifier
   * @example amplitudeClient.logRevenue(3.99, 1, 'product_1234');
   */
  AmplitudeClient.prototype.logRevenue = function logRevenue(price, quantity, product) {
    if (this._shouldDeferCall()) {
      return this._q.push(['logRevenue'].concat(Array.prototype.slice.call(arguments, 0)));
    } // Test that the parameters are of the right type.


    if (!this._apiKeySet('logRevenue()') || !_isNumber(price) || quantity !== undefined && !_isNumber(quantity)) {
      // utils.log('Price and quantity arguments to logRevenue must be numbers');
      return -1;
    }

    return this._logEvent(Constants.REVENUE_EVENT, {}, {
      productId: product,
      special: 'revenue_amount',
      quantity: quantity || 1,
      price: price
    }, null, null, null, null, null);
  };
}
/**
 * Calls error callback on unsent events
 * @private
 */


AmplitudeClient.prototype._logErrorsOnEvents = function _logErrorsOnEvents(maxEventId, maxIdentifyId, status, response) {
  var queues = ['_unsentEvents', '_unsentIdentifys'];

  for (var j = 0; j < queues.length; j++) {
    var queue = queues[j];
    var maxId = queue === '_unsentEvents' ? maxEventId : maxIdentifyId;

    for (var i = 0; i < this[queue].length || 0; i++) {
      var unsentEvent = this[queue][i];

      if (unsentEvent.event.event_id <= maxId) {
        if (unsentEvent.errorCallback) {
          unsentEvent.errorCallback(status, response);
        }
      }
    }
  }
};
/**
 * Remove events in storage with event ids up to and including maxEventId.
 * @private
 */


AmplitudeClient.prototype.removeEvents = function removeEvents(maxEventId, maxIdentifyId, status, response) {
  _removeEvents(this, '_unsentEvents', maxEventId, status, response);

  _removeEvents(this, '_unsentIdentifys', maxIdentifyId, status, response);
};
/**
 * Helper function to remove events up to maxId from a single queue.
 * Does a true filter in case events get out of order or old events are removed.
 * @private
 */


var _removeEvents = function _removeEvents(scope, eventQueue, maxId, status, response) {
  if (maxId < 0) {
    return;
  }

  var filteredEvents = [];

  for (var i = 0; i < scope[eventQueue].length || 0; i++) {
    var unsentEvent = scope[eventQueue][i];

    if (unsentEvent.event.event_id > maxId) {
      filteredEvents.push(unsentEvent);
    } else {
      if (unsentEvent.callback) {
        unsentEvent.callback(status, response);
      }
    }
  }

  scope[eventQueue] = filteredEvents;
};
/**
 * Send unsent events. Note: this is called automatically after events are logged if option batchEvents is false.
 * If batchEvents is true, then events are only sent when batch criterias are met.
 * @private
 */


AmplitudeClient.prototype.sendEvents = function sendEvents() {
  if (!this._apiKeySet('sendEvents()')) {
    this.removeEvents(Infinity, Infinity, 0, 'No request sent', {
      reason: 'API key not set'
    });
    return;
  }

  if (this.options.optOut) {
    this.removeEvents(Infinity, Infinity, 0, 'No request sent', {
      reason: 'Opt out is set to true'
    });
    return;
  } // How is it possible to get into this state?


  if (this._unsentCount() === 0) {
    return;
  } // We only make one request at a time. sendEvents will be invoked again once
  // the last request completes.
  // beacon data is sent synchronously, so don't pause for it


  if (this.options.transport !== Constants.TRANSPORT_BEACON) {
    if (this._sending) {
      return;
    }

    this._sending = true;
  }

  var protocol = this.options.forceHttps ? 'https' : 'https:' === GlobalScope.location.protocol ? 'https' : 'http';
  var url = protocol + '://' + this.options.apiEndpoint; // fetch events to send

  var numEvents = Math.min(this._unsentCount(), this.options.uploadBatchSize);

  var mergedEvents = this._mergeEventsAndIdentifys(numEvents);

  var maxEventId = mergedEvents.maxEventId;
  var maxIdentifyId = mergedEvents.maxIdentifyId;
  var events = JSON.stringify(mergedEvents.eventsToSend.map(function (_ref2) {
    var event = _ref2.event;
    return event;
  }));
  var uploadTime = new Date().getTime();
  var data = {
    client: this.options.apiKey,
    e: events,
    v: Constants.API_VERSION,
    upload_time: uploadTime,
    checksum: md5_default()(Constants.API_VERSION + this.options.apiKey + events + uploadTime)
  };

  if (this.options.transport === Constants.TRANSPORT_BEACON) {
    var success = navigator.sendBeacon(url, new URLSearchParams(data));

    if (success) {
      this.removeEvents(maxEventId, maxIdentifyId, 200, 'success');

      if (this.options.saveEvents) {
        this.saveEvents();
      }
    } else {
      this._logErrorsOnEvents(maxEventId, maxIdentifyId, 0, '');
    }

    return;
  }

  var scope = this;

  try {
    new Request(url, data, this.options.headers).send(function (status, response) {
      scope._sending = false;

      try {
        if (status === 200 && response === 'success') {
          scope.removeEvents(maxEventId, maxIdentifyId, status, response); // Update the event cache after the removal of sent events.

          if (scope.options.saveEvents) {
            scope.saveEvents();
          } // Send more events if any queued during previous send.


          scope._sendEventsIfReady(); // handle payload too large

        } else {
          scope._logErrorsOnEvents(maxEventId, maxIdentifyId, status, response);

          if (status === 413) {
            // utils.log('request too large');
            // Can't even get this one massive event through. Drop it, even if it is an identify.
            if (scope.options.uploadBatchSize === 1) {
              scope.removeEvents(maxEventId, maxIdentifyId, status, response);
            } // The server complained about the length of the request. Backoff and try again.


            scope.options.uploadBatchSize = Math.ceil(numEvents / 2);
            scope.sendEvents();
          }
        } // else {
        //  all the events are still queued, and will be retried when the next
        //  event is sent In the interest of debugging, it would be nice to have
        //  something like an event emitter for a better debugging experince
        //  here.
        // }

      } catch (e) {// utils.log.error('failed upload');
      }
    });
  } catch (e) {
    var status = 0,
        response = 'Request failed to send';
    utils.log.error(response);

    scope._logErrorsOnEvents(maxEventId, maxIdentifyId, status, response);

    scope.removeEvents(maxEventId, maxIdentifyId, status, response, {
      reason: e.message
    });
  }
};
/**
 * Merge unsent events and identifys together in sequential order based on their sequence number, for uploading.
 * Identifys given higher priority than Events. Also earlier sequence given priority
 * @private
 */


AmplitudeClient.prototype._mergeEventsAndIdentifys = function _mergeEventsAndIdentifys(numEvents) {
  // coalesce events from both queues
  var eventsToSend = [];
  var eventIndex = 0;
  var maxEventId = -1;
  var identifyIndex = 0;
  var maxIdentifyId = -1;

  while (eventsToSend.length < numEvents) {
    var unsentEvent = void 0;
    var noIdentifys = identifyIndex >= this._unsentIdentifys.length;
    var noEvents = eventIndex >= this._unsentEvents.length; // case 0: no events or identifys left
    // note this should not happen, this means we have less events and identifys than expected

    if (noEvents && noIdentifys) {
      utils.log.error('Merging Events and Identifys, less events and identifys than expected');
      break;
    } // case 1: no identifys - grab from events
    else if (noIdentifys) {
        unsentEvent = this._unsentEvents[eventIndex++];
        maxEventId = unsentEvent.event.event_id; // case 2: no events - grab from identifys
      } else if (noEvents) {
        unsentEvent = this._unsentIdentifys[identifyIndex++];
        maxIdentifyId = unsentEvent.event.event_id; // case 3: need to compare sequence numbers
      } else {
        // events logged before v2.5.0 won't have a sequence number, put those first
        if (!('sequence_number' in this._unsentEvents[eventIndex].event) || this._unsentEvents[eventIndex].event.sequence_number < this._unsentIdentifys[identifyIndex].event.sequence_number) {
          unsentEvent = this._unsentEvents[eventIndex++];
          maxEventId = unsentEvent.event.event_id;
        } else {
          unsentEvent = this._unsentIdentifys[identifyIndex++];
          maxIdentifyId = unsentEvent.event.event_id;
        }
      }

    eventsToSend.push(unsentEvent);
  }

  return {
    eventsToSend: eventsToSend,
    maxEventId: maxEventId,
    maxIdentifyId: maxIdentifyId
  };
};

{
  /**
   * Set global user properties. Note this is deprecated, and we recommend using setUserProperties
   * @public
   * @deprecated
   */
  AmplitudeClient.prototype.setGlobalUserProperties = function setGlobalUserProperties(userProperties) {
    this.setUserProperties(userProperties);
  };
}
/**
 * Get the current version of Amplitude's Javascript SDK.
 * @public
 * @returns {number} version number
 * @example var amplitudeVersion = amplitude.__VERSION__;
 */


AmplitudeClient.prototype.__VERSION__ = function getVersion() {
  return this.options.library.version;
};
/**
 * Sets the library name and version. Default is `amplitude-js` and the version defined in package.json. Used if you're building another library on top of amplitude-js and want a custom data source value
 * @public
 * @param {string} name - Custom library name
 * @param {string} version - Custom library version
 */


AmplitudeClient.prototype.setLibrary = function setLibrary(name, version) {
  if (name !== null && typeof name !== 'undefined') {
    this.options.library.name = name;
  }

  if (version !== null && typeof version !== 'undefined') {
    this.options.library.version = version;
  }
};
/**
 * Determines whether or not to push call to this._q or invoke it
 * @private
 */


AmplitudeClient.prototype._shouldDeferCall = function _shouldDeferCall() {
  return this._pendingReadStorage || this._initializationDeferred;
};
/**
 * Defers Initialization by putting all functions into storage until users
 * have accepted terms for tracking
 * @private
 */


AmplitudeClient.prototype._deferInitialization = function _deferInitialization() {
  this._initializationDeferred = true;

  this._q.push(['init'].concat(Array.prototype.slice.call(arguments, 0)));
};
/**
 * Enable tracking via logging events and dropping a cookie
 * Intended to be used with the deferInitialization configuration flag
 * This will drop a cookie and reset initialization deferred
 * @public
 */


AmplitudeClient.prototype.enableTracking = function enableTracking() {
  // This will call init (which drops the cookie) and will run any pending tasks
  this._initializationDeferred = false;

  _saveCookieData(this);

  this.runQueuedFunctions();
};
/**
 * Find best server url if choose to enable dynamic configuration.
 */


AmplitudeClient.prototype._refreshDynamicConfig = function _refreshDynamicConfig() {
  if (this.options.useDynamicConfig) {
    instance$1.refresh(this.options.serverZone, this.options.forceHttps, function () {
      this.options.apiEndpoint = instance$1.ingestionEndpoint;
    }.bind(this));
  }
};
/**
 * Returns the deviceId value.
 * @public
 * @return {string} Id of current device.
 */


AmplitudeClient.prototype.getDeviceId = function getDeviceId() {
  return this.options.deviceId;
};
/**
 * Returns the userId.
 * @public
 * @return {string} Id of current user.
 */


AmplitudeClient.prototype.getUserId = function getUserId() {
  return this.options.userId;
};
/**
 * Set a custom session expiration time.
 * @public
 * @param {number} timeInMillis - session expireation time in milliseconds.
 */


AmplitudeClient.prototype.setMinTimeBetweenSessionsMillis = function setMinTimeBetweenSessionsMillis(timeInMillis) {
  if (!utils.validateInput(timeInMillis, 'timeInMillis', 'number')) {
    return;
  }

  if (this._shouldDeferCall()) {
    return this._q.push(['setMinTimeBetweenSessionsMillis'].concat(Array.prototype.slice.call(arguments, 0)));
  }

  try {
    this.options.sessionTimeout = timeInMillis;
  } catch (e) {
    utils.log.error(e);
  }
};
/**
 * Sets minimum number of events to batch together per request if batchEvents is true.
 * @public
 * @param {number} eventUploadThreshold - The number of the event upload threshold. Default value is 30.
 * @example amplitudeClient.setEventUploadThreshold(10);
 */


AmplitudeClient.prototype.setEventUploadThreshold = function setEventUploadThreshold(eventUploadThreshold) {
  if (!utils.validateInput(eventUploadThreshold, 'eventUploadThreshold', 'number')) {
    return;
  }

  if (this._shouldDeferCall()) {
    return this._q.push(['setEventUploadThreshold'].concat(Array.prototype.slice.call(arguments, 0)));
  }

  try {
    this.options.eventUploadThreshold = eventUploadThreshold;
  } catch (e) {
    utils.log.error(e);
  }
};
/**
 * Dynamically adjust server URL
 * @public
 * @param {bool} useDynamicConfig - if enable dynamic config or not.
 * @example amplitudeClient.setUseDynamicConfig(true);
 */


AmplitudeClient.prototype.setUseDynamicConfig = function setUseDynamicConfig(useDynamicConfig) {
  if (!utils.validateInput(useDynamicConfig, 'useDynamicConfig', 'boolean')) {
    return;
  }

  if (this._shouldDeferCall()) {
    return this._q.push(['setUseDynamicConfig'].concat(Array.prototype.slice.call(arguments, 0)));
  }

  try {
    this.options.useDynamicConfig = useDynamicConfig;

    this._refreshDynamicConfig();
  } catch (e) {
    utils.log.error(e);
  }
};
/**
 * Sets the server zone, used for server api endpoint and dynamic configuration.
 * @public
 * @param {string} serverZone - the server zone value. AmplitudeServerZone.US or AmplitudeServerZone.EU.
 * @param {bool} serverZoneBasedApi - (optional) update api endpoint with serverZone change or not. For data residency, recommend to enable it unless using own proxy server.
 * @example amplitudeClient.setServerZone('joe@gmail.com', true);
 */


AmplitudeClient.prototype.setServerZone = function setServerZone(serverZone) {
  var serverZoneBasedApi = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (serverZone !== AmplitudeServerZone.EU && serverZone !== AmplitudeServerZone.US || !utils.validateInput(serverZoneBasedApi, 'serverZoneBasedApi', 'boolean')) {
    return;
  }

  if (this._shouldDeferCall()) {
    return this._q.push(['setServerZone'].concat(Array.prototype.slice.call(arguments, 0)));
  }

  try {
    this.options.serverZone = serverZone;
    this.options.serverZoneBasedApi = serverZoneBasedApi;

    if (serverZoneBasedApi) {
      this.options.apiEndpoint = getEventLogApi(this.options.serverZone);
    }
  } catch (e) {
    utils.log.error(e);
  }
};
/**
 * Sets the server URL for the request.
 * @public
 * @param {string} serverUrl - The value of the server URL.
 * @example amplitudeClient.setServerUrl('api.amplitude.com');
 */


AmplitudeClient.prototype.setServerUrl = function setServerUrl(serverUrl) {
  if (!utils.validateInput(serverUrl, 'serverUrl', 'string')) {
    return;
  }

  if (this._shouldDeferCall()) {
    return this._q.push(['setServerUrl'].concat(Array.prototype.slice.call(arguments, 0)));
  }

  try {
    this.options.apiEndpoint = serverUrl;
  } catch (e) {
    utils.log.error(e);
  }
};

/**
 * Deprecated legacy API of the Amplitude JS SDK - instance manager.
 *
 * Wraps around the current [AmplitudeClient](https://amplitude.github.io/Amplitude-JavaScript/) which provides more features
 * Function calls directly on amplitude have been deprecated. Please call methods on the default shared instance: amplitude.getInstance() instead.
 *
 * See the [3.0.0 changelog](https://github.com/amplitude/Amplitude-JavaScript/blob/ed405afb5f06d5cf5b72539a5d09179abcf7e1fe/README.md#300-update-and-logging-events-to-multiple-amplitude-apps) for more information about this change.
 * @constructor Amplitude
 * @public
 * @deprecated
 * @example var amplitude = new Amplitude();
 */

var Amplitude = function Amplitude() {
  this.options = _objectSpread({}, DEFAULT_OPTIONS);
  this._q = [];
  this._instances = {}; // mapping of instance names to instances
};

Amplitude.prototype.Identify = Identify;
Amplitude.prototype.Revenue = Revenue;

Amplitude.prototype.getInstance = function getInstance(instance) {
  instance = utils.isEmptyString(instance) ? Constants.DEFAULT_INSTANCE : instance.toLowerCase();
  var client = this._instances[instance];

  if (client === undefined) {
    client = new AmplitudeClient(instance);
    this._instances[instance] = client;
  }

  return client;
};

{
  /**
   * Initializes the Amplitude Javascript SDK with your apiKey and any optional configurations.
   * This is required before any other methods can be called.
   * @public
   * @param {string} apiKey - The API key for your app.
   * @param {string} opt_userId - (optional) An identifier for this user.
   * @param {object} opt_config - (optional) Configuration options.
   * See [options.js](https://github.com/amplitude/Amplitude-JavaScript/blob/master/src/options.js#L14) for list of options and default values.
   * @param {function} opt_callback - (optional) Provide a callback function to run after initialization is complete.
   * @deprecated Please use amplitude.getInstance().init(apiKey, opt_userId, opt_config, opt_callback);
   * @example amplitude.init('API_KEY', 'USER_ID', {includeReferrer: true, includeUtm: true}, function() { alert('init complete'); });
   */
  Amplitude.prototype.init = function init(apiKey, opt_userId, opt_config, opt_callback) {
    this.getInstance().init(apiKey, opt_userId, opt_config, function (instance) {
      // make options such as deviceId available for callback functions
      this.options = instance.options;

      if (type(opt_callback) === 'function') {
        opt_callback(instance);
      }
    }.bind(this));
  };
  /**
   * Returns true if a new session was created during initialization, otherwise false.
   * @public
   * @return {boolean} Whether a new session was created during initialization.
   * @deprecated Please use amplitude.getInstance().isNewSession();
   */


  Amplitude.prototype.isNewSession = function isNewSession() {
    return this.getInstance().isNewSession();
  };
  /**
   * Returns the id of the current session.
   * @public
   * @return {number} Id of the current session.
   * @deprecated Please use amplitude.getInstance().getSessionId();
   */


  Amplitude.prototype.getSessionId = function getSessionId() {
    return this.getInstance().getSessionId();
  };
  /**
   * Increments the eventId and returns it.
   * @private
   */


  Amplitude.prototype.nextEventId = function nextEventId() {
    return this.getInstance().nextEventId();
  };
  /**
   * Increments the identifyId and returns it.
   * @private
   */


  Amplitude.prototype.nextIdentifyId = function nextIdentifyId() {
    return this.getInstance().nextIdentifyId();
  };
  /**
   * Increments the sequenceNumber and returns it.
   * @private
   */


  Amplitude.prototype.nextSequenceNumber = function nextSequenceNumber() {
    return this.getInstance().nextSequenceNumber();
  };
  /**
   * Saves unsent events and identifies to localStorage. JSON stringifies event queues before saving.
   * Note: this is called automatically every time events are logged, unless you explicitly set option saveEvents to false.
   * @private
   */


  Amplitude.prototype.saveEvents = function saveEvents() {
    this.getInstance().saveEvents();
  };
  /**
   * Sets a customer domain for the amplitude cookie. Useful if you want to support cross-subdomain tracking.
   * @public
   * @param {string} domain to set.
   * @deprecated Please use amplitude.getInstance().setDomain(domain);
   * @example amplitude.setDomain('.amplitude.com');
   */


  Amplitude.prototype.setDomain = function setDomain(domain) {
    this.getInstance().setDomain(domain);
  };
  /**
   * Sets an identifier for the current user.
   * @public
   * @param {string} userId - identifier to set. Can be null.
   * @deprecated Please use amplitude.getInstance().setUserId(userId);
   * @example amplitude.setUserId('joe@gmail.com');
   */


  Amplitude.prototype.setUserId = function setUserId(userId) {
    this.getInstance().setUserId(userId);
  };
  /**
   * Add user to a group or groups. You need to specify a groupType and groupName(s).
   * For example you can group people by their organization.
   * In that case groupType is "orgId" and groupName would be the actual ID(s).
   * groupName can be a string or an array of strings to indicate a user in multiple gruups.
   * You can also call setGroup multiple times with different groupTypes to track multiple types of groups (up to 5 per app).
   * Note: this will also set groupType: groupName as a user property.
   * See the [advanced topics article](https://developers.amplitude.com/docs/javascript#user-groups) for more information.
   * @public
   * @param {string} groupType - the group type (ex: orgId)
   * @param {string|list} groupName - the name of the group (ex: 15), or a list of names of the groups
   * @deprecated Please use amplitude.getInstance().setGroup(groupType, groupName);
   * @example amplitude.setGroup('orgId', 15); // this adds the current user to orgId 15.
   */


  Amplitude.prototype.setGroup = function (groupType, groupName) {
    this.getInstance().setGroup(groupType, groupName);
  };
  /**
   * Sets whether to opt current user out of tracking.
   * @public
   * @param {boolean} enable - if true then no events will be logged or sent.
   * @deprecated Please use amplitude.getInstance().setOptOut(enable);
   * @example: amplitude.setOptOut(true);
   */


  Amplitude.prototype.setOptOut = function setOptOut(enable) {
    this.getInstance().setOptOut(enable);
  };
  /**
   * Regenerates a new random deviceId for current user. Note: this is not recommended unless you know what you
   * are doing. This can be used in conjunction with `setUserId(null)` to anonymize users after they log out.
   * With a null userId and a completely new deviceId, the current user would appear as a brand new user in dashboard.
   * This uses src/uuid.js to regenerate the deviceId.
   * @public
   * @deprecated Please use amplitude.getInstance().regenerateDeviceId();
   */


  Amplitude.prototype.regenerateDeviceId = function regenerateDeviceId() {
    this.getInstance().regenerateDeviceId();
  };
  /**
   * Sets a custom deviceId for current user. Note: this is not recommended unless you know what you are doing
   * (like if you have your own system for managing deviceIds).
   *
   * Make sure the deviceId you set is sufficiently unique
   * (we recommend something like a UUID - see src/uuid.js for an example of how to generate) to prevent conflicts with other devices in our system.
   * @public
   * @param {string} deviceId - custom deviceId for current user.
   * @deprecated Please use amplitude.getInstance().setDeviceId(deviceId);
   * @example amplitude.setDeviceId('45f0954f-eb79-4463-ac8a-233a6f45a8f0');
   */


  Amplitude.prototype.setDeviceId = function setDeviceId(deviceId) {
    this.getInstance().setDeviceId(deviceId);
  };
  /**
   * Sets user properties for the current user.
   * @public
   * @param {object} userProperties - object with string keys and values for the user properties to set.
   * @param {boolean} opt_replace - Deprecated. In earlier versions of the JS SDK the user properties object was kept in
   * memory and replace = true would replace the object in memory. Now the properties are no longer stored in memory, so replace is deprecated.
   * @deprecated Please use amplitude.getInstance().setUserProperties(userProperties);
   * @example amplitude.setUserProperties({'gender': 'female', 'sign_up_complete': true})
   */


  Amplitude.prototype.setUserProperties = function setUserProperties(userProperties) {
    this.getInstance().setUserProperties(userProperties);
  };
  /**
   * Clear all of the user properties for the current user. Note: clearing user properties is irreversible!
   * @public
   * @deprecated Please use amplitude.getInstance().clearUserProperties();
   * @example amplitude.clearUserProperties();
   */


  Amplitude.prototype.clearUserProperties = function clearUserProperties() {
    this.getInstance().clearUserProperties();
  };
  /**
   * Send an identify call containing user property operations to Amplitude servers.
   * See the [Identify](https://amplitude.github.io/Amplitude-JavaScript/Identify/)
   * reference page for more information on the Identify API and user property operations.
   * @param {Identify} identify_obj - the Identify object containing the user property operations to send.
   * @param {Amplitude~eventCallback} opt_callback - (optional) callback function to run when the identify event has been sent.
   * Note: the server response code and response body from the identify event upload are passed to the callback function.
   * @deprecated Please use amplitude.getInstance().identify(identify);
   * @example
   * var identify = new amplitude.Identify().set('colors', ['rose', 'gold']).add('karma', 1).setOnce('sign_up_date', '2016-03-31');
   * amplitude.identify(identify);
   */


  Amplitude.prototype.identify = function (identify_obj, opt_callback) {
    this.getInstance().identify(identify_obj, opt_callback);
  };
  /**
   * Set a versionName for your application.
   * @public
   * @param {string} versionName - The version to set for your application.
   * @deprecated Please use amplitude.getInstance().setVersionName(versionName);
   * @example amplitude.setVersionName('1.12.3');
   */


  Amplitude.prototype.setVersionName = function setVersionName(versionName) {
    this.getInstance().setVersionName(versionName);
  };
  /**
   * This is the callback for logEvent and identify calls. It gets called after the event/identify is uploaded,
   * and the server response code and response body from the upload request are passed to the callback function.
   * @callback Amplitude~eventCallback
   * @param {number} responseCode - Server response code for the event / identify upload request.
   * @param {string} responseBody - Server response body for the event / identify upload request.
   */

  /**
   * Log an event with eventType and eventProperties
   * @public
   * @param {string} eventType - name of event
   * @param {object} eventProperties - (optional) an object with string keys and values for the event properties.
   * @param {Amplitude~eventCallback} opt_callback - (optional) a callback function to run after the event is logged.
   * Note: the server response code and response body from the event upload are passed to the callback function.
   * @deprecated Please use amplitude.getInstance().logEvent(eventType, eventProperties, opt_callback);
   * @example amplitude.logEvent('Clicked Homepage Button', {'finished_flow': false, 'clicks': 15});
   */


  Amplitude.prototype.logEvent = function logEvent(eventType, eventProperties, opt_callback) {
    return this.getInstance().logEvent(eventType, eventProperties, opt_callback);
  };
  /**
   * Log an event with eventType, eventProperties, and groups. Use this to set event-level groups.
   *
   * Note: the group(s) set only apply for the specific event type being logged and does not persist on the user
   * (unless you explicitly set it with setGroup).
   *
   * See the [advanced topics article](https://developers.amplitude.com/docs/javascript#user-groups) for more information
   * about groups and Count by Distinct on the Amplitude platform.
   * @public
   * @param {string} eventType - name of event
   * @param {object} eventProperties - (optional) an object with string keys and values for the event properties.
   * @param {object} groups - (optional) an object with string groupType: groupName values for the event being logged.
   * groupName can be a string or an array of strings.
   * @param {Amplitude~eventCallback} opt_callback - (optional) a callback function to run after the event is logged.
   * Note: the server response code and response body from the event upload are passed to the callback function.
   * @deprecated Please use amplitude.getInstance().logEventWithGroups(eventType, eventProperties, groups, opt_callback);
   * @example amplitude.logEventWithGroups('Clicked Button', null, {'orgId': 24});
   */


  Amplitude.prototype.logEventWithGroups = function (eventType, eventProperties, groups, opt_callback) {
    return this.getInstance().logEventWithGroups(eventType, eventProperties, groups, opt_callback);
  };
  /**
   * Log revenue with Revenue interface. The new revenue interface allows for more revenue fields like
   * revenueType and event properties.
   *
   * See the [Revenue](https://amplitude.github.io/Amplitude-JavaScript/Revenue/)
   * reference page for more information on the Revenue interface and logging revenue.
   * @public
   * @param {Revenue} revenue_obj - the revenue object containing the revenue data being logged.
   * @deprecated Please use amplitude.getInstance().logRevenueV2(revenue_obj);
   * @example var revenue = new amplitude.Revenue().setProductId('productIdentifier').setPrice(10.99);
   * amplitude.logRevenueV2(revenue);
   */


  Amplitude.prototype.logRevenueV2 = function logRevenueV2(revenue_obj) {
    return this.getInstance().logRevenueV2(revenue_obj);
  };
  /**
   * Log revenue event with a price, quantity, and product identifier.
   * @public
   * @param {number} price - price of revenue event
   * @param {number} quantity - (optional) quantity of products in revenue event. If no quantity specified default to 1.
   * @param {string} product - (optional) product identifier
   * @deprecated Please use amplitude.getInstance().logRevenueV2(revenue_obj);
   * @example amplitude.logRevenue(3.99, 1, 'product_1234');
   */


  Amplitude.prototype.logRevenue = function logRevenue(price, quantity, product) {
    return this.getInstance().logRevenue(price, quantity, product);
  };
  /**
   * Remove events in storage with event ids up to and including maxEventId.
   * @private
   */


  Amplitude.prototype.removeEvents = function removeEvents(maxEventId, maxIdentifyId) {
    this.getInstance().removeEvents(maxEventId, maxIdentifyId);
  };
  /**
   * Send unsent events. Note: this is called automatically after events are logged if option batchEvents is false.
   * If batchEvents is true, then events are only sent when batch criterias are met.
   * @private
   * @param {Amplitude~eventCallback} callback - (optional) callback to run after events are sent.
   * Note the server response code and response body are passed to the callback as input arguments.
   */


  Amplitude.prototype.sendEvents = function sendEvents(callback) {
    this.getInstance().sendEvents(callback);
  };
  /**
   * Set global user properties.
   * @public
   * @deprecated Please use amplitudeClient.setUserProperties
   */


  Amplitude.prototype.setGlobalUserProperties = function setGlobalUserProperties(userProperties) {
    this.getInstance().setUserProperties(userProperties);
  };
}
/**
 * Get the current version of Amplitude's Javascript SDK.
 * @public
 * @returns {number} version number
 * @example var amplitudeVersion = amplitude.__VERSION__;
 */


Amplitude.prototype.__VERSION__ = version;

// Entry point
var old = typeof GlobalScope !== 'undefined' && GlobalScope.amplitude || {};
var newInstance = new Amplitude();
newInstance._q = old._q || [];
/**
 * Instantiates Amplitude object and runs all queued function logged by stubbed methods provided by snippets
 * Event queue allows async loading of SDK to not blocking client's app
 */

for (var instance in old._iq) {
  // migrate each instance's queue
  if (Object.prototype.hasOwnProperty.call(old._iq, instance)) {
    newInstance.getInstance(instance)._q = old._iq[instance]._q || [];
  }
} // If SDK is enabled as snippet, process the events queued by stubbed function




/***/ }),

/***/ 89776:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const { ApolloLink, Observable } = __webpack_require__(42451);
const {
  createSignalIfSupported,
  fallbackHttpConfig,
  parseAndCheckHttpResponse,
  rewriteURIForGET,
  selectHttpOptionsAndBody,
  selectURI,
  serializeFetchParameter,
} = __webpack_require__(85645);
const extractFiles = __webpack_require__(40804);
const formDataAppendFile = __webpack_require__(20463);
const isExtractableFile = __webpack_require__(38212);

/**
 * Creates a
 * [terminating Apollo Link](https://apollographql.com/docs/react/api/link/introduction/#the-terminating-link)
 * for [Apollo Client](https://apollographql.com/docs/react) that fetches a
 * [GraphQL multipart request](https://github.com/jaydenseric/graphql-multipart-request-spec)
 * if the GraphQL variables contain files (by default
 * [`FileList`](https://developer.mozilla.org/en-US/docs/Web/API/FileList),
 * [`File`](https://developer.mozilla.org/en-US/docs/Web/API/File),
 * [`Blob`](https://developer.mozilla.org/en-US/docs/Web/API/Blob), or
 * [`ReactNativeFile`](#class-reactnativefile) instances), or else fetches a
 * regular
 * [GraphQL POST or GET request](https://apollographql.com/docs/apollo-server/requests)
 * (depending on the config and GraphQL operation).
 *
 * Some of the options are similar to the
 * [`createHttpLink` options](https://apollographql.com/docs/react/api/link/apollo-link-http/#httplink-constructor-options).
 * @see [GraphQL multipart request spec](https://github.com/jaydenseric/graphql-multipart-request-spec).
 * @kind function
 * @name createUploadLink
 * @param {object} options Options.
 * @param {string} [options.uri="/graphql"] GraphQL endpoint URI.
 * @param {boolean} [options.useGETForQueries] Should GET be used to fetch queries, if there are no files to upload.
 * @param {ExtractableFileMatcher} [options.isExtractableFile=isExtractableFile] Customizes how files are matched in the GraphQL operation for extraction.
 * @param {class} [options.FormData] [`FormData`](https://developer.mozilla.org/en-US/docs/Web/API/FormData) implementation to use, defaulting to the [`FormData`](https://developer.mozilla.org/en-US/docs/Web/API/FormData) global.
 * @param {FormDataFileAppender} [options.formDataAppendFile=formDataAppendFile] Customizes how extracted files are appended to the [`FormData`](https://developer.mozilla.org/en-US/docs/Web/API/FormData) instance.
 * @param {Function} [options.fetch] [`fetch`](https://fetch.spec.whatwg.org) implementation to use, defaulting to the [`fetch`](https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/fetch) global.
 * @param {FetchOptions} [options.fetchOptions] [`fetch` options]{@link FetchOptions}; overridden by upload requirements.
 * @param {string} [options.credentials] Overrides `options.fetchOptions.credentials`.
 * @param {object} [options.headers] Merges with and overrides `options.fetchOptions.headers`.
 * @param {boolean} [options.includeExtensions=false] Toggles sending `extensions` fields to the GraphQL server.
 * @returns {ApolloLink} A [terminating Apollo Link](https://apollographql.com/docs/react/api/link/introduction/#the-terminating-link).
 * @example <caption>Ways to `import`.</caption>
 * ```js
 * import { createUploadLink } from "apollo-upload-client";
 * ```
 *
 * ```js
 * import createUploadLink from "apollo-upload-client/public/createUploadLink.js";
 * ```
 * @example <caption>Ways to `require`.</caption>
 * ```js
 * const { createUploadLink } = require("apollo-upload-client");
 * ```
 *
 * ```js
 * const createUploadLink = require("apollo-upload-client/public/createUploadLink.js");
 * ```
 * @example <caption>A basic Apollo Client setup.</caption>
 * ```js
 * import { ApolloClient, InMemoryCache } from "@apollo/client";
 * import createUploadLink from "apollo-upload-client/public/createUploadLink.js";
 *
 * const client = new ApolloClient({
 *   cache: new InMemoryCache(),
 *   link: createUploadLink(),
 * });
 * ```
 */
module.exports = function createUploadLink({
  uri: fetchUri = "/graphql",
  useGETForQueries,
  isExtractableFile: customIsExtractableFile = isExtractableFile,
  FormData: CustomFormData,
  formDataAppendFile: customFormDataAppendFile = formDataAppendFile,
  fetch: customFetch,
  fetchOptions,
  credentials,
  headers,
  includeExtensions,
} = {}) {
  const linkConfig = {
    http: { includeExtensions },
    options: fetchOptions,
    credentials,
    headers,
  };

  return new ApolloLink((operation) => {
    const context = operation.getContext();
    const {
      // Apollo Studio client awareness `name` and `version` can be configured
      // via `ApolloClient` constructor options:
      // https://apollographql.com/docs/studio/client-awareness/#using-apollo-server-and-apollo-client
      clientAwareness: { name, version } = {},
      headers,
    } = context;

    const contextConfig = {
      http: context.http,
      options: context.fetchOptions,
      credentials: context.credentials,
      headers: {
        // Client awareness headers can be overridden by context `headers`.
        ...(name && { "apollographql-client-name": name }),
        ...(version && { "apollographql-client-version": version }),
        ...headers,
      },
    };

    const { options, body } = selectHttpOptionsAndBody(
      operation,
      fallbackHttpConfig,
      linkConfig,
      contextConfig
    );

    const { clone, files } = extractFiles(body, "", customIsExtractableFile);

    let uri = selectURI(operation, fetchUri);

    if (files.size) {
      // Automatically set by `fetch` when the `body` is a `FormData` instance.
      delete options.headers["content-type"];

      // GraphQL multipart request spec:
      // https://github.com/jaydenseric/graphql-multipart-request-spec

      const RuntimeFormData = CustomFormData || FormData;

      const form = new RuntimeFormData();

      form.append("operations", serializeFetchParameter(clone, "Payload"));

      const map = {};
      let i = 0;
      files.forEach((paths) => {
        map[++i] = paths;
      });
      form.append("map", JSON.stringify(map));

      i = 0;
      files.forEach((paths, file) => {
        customFormDataAppendFile(form, ++i, file);
      });

      options.body = form;
    } else {
      if (
        useGETForQueries &&
        // If the operation contains some mutations GET shouldn’t be used.
        !operation.query.definitions.some(
          (definition) =>
            definition.kind === "OperationDefinition" &&
            definition.operation === "mutation"
        )
      )
        options.method = "GET";

      if (options.method === "GET") {
        const { newURI, parseError } = rewriteURIForGET(uri, body);
        if (parseError)
          // Apollo’s `HttpLink` uses `fromError` for this, but it’s not
          // exported from `@apollo/client/link/http`.
          return new Observable((observer) => {
            observer.error(parseError);
          });
        uri = newURI;
      } else options.body = serializeFetchParameter(clone, "Payload");
    }

    const { controller } = createSignalIfSupported();

    if (controller) {
      if (options.signal)
        // Respect the user configured abort controller signal.
        options.signal.aborted
          ? // Signal already aborted, so immediately abort.
            controller.abort()
          : // Signal not already aborted, so setup a listener to abort when it
            // does.
            options.signal.addEventListener(
              "abort",
              () => {
                controller.abort();
              },
              {
                // Prevent a memory leak if the user configured abort controller
                // is long lasting, or controls multiple things.
                once: true,
              }
            );

      options.signal = controller.signal;
    }

    const runtimeFetch = customFetch || fetch;

    return new Observable((observer) => {
      // Used to track if the observable is being cleaned up.
      let cleaningUp;

      runtimeFetch(uri, options)
        .then((response) => {
          // Forward the response on the context.
          operation.setContext({ response });
          return response;
        })
        .then(parseAndCheckHttpResponse(operation))
        .then((result) => {
          observer.next(result);
          observer.complete();
        })
        .catch((error) => {
          // If the observable is being cleaned up, there is no need to call
          // next or error because there are no more subscribers. An error after
          // cleanup begins is likely from the cleanup function aborting the
          // fetch.
          if (!cleaningUp) {
            // For errors such as an invalid fetch URI there will be no GraphQL
            // result with errors or data to forward.
            if (error.result && error.result.errors && error.result.data)
              observer.next(error.result);

            observer.error(error);
          }
        });

      // Cleanup function.
      return () => {
        cleaningUp = true;

        // Abort fetch. It’s ok to signal an abort even when not fetching.
        if (controller) controller.abort();
      };
    });
  });
};


/***/ }),

/***/ 20463:
/***/ (function(module) {

"use strict";


/**
 * The default implementation for [`createUploadLink`]{@link createUploadLink}
 * `options.formDataAppendFile` that uses the standard
 * [`FormData.append`](https://developer.mozilla.org/en-US/docs/Web/API/FormData/append)
 * method.
 * @kind function
 * @name formDataAppendFile
 * @type {FormDataFileAppender}
 * @param {FormData} formData [`FormData`](https://developer.mozilla.org/en-US/docs/Web/API/FormData) instance to append the specified file to.
 * @param {string} fieldName Field name for the file.
 * @param {*} file File to append.
 * @example <caption>Ways to `import`.</caption>
 * ```js
 * import { formDataAppendFile } from "apollo-upload-client";
 * ```
 *
 * ```js
 * import formDataAppendFile from "apollo-upload-client/public/formDataAppendFile.js";
 * ```
 * @example <caption>Ways to `require`.</caption>
 * ```js
 * const { formDataAppendFile } = require("apollo-upload-client");
 * ```
 *
 * ```js
 * const formDataAppendFile = require("apollo-upload-client/public/formDataAppendFile.js");
 * ```
 */
module.exports = function formDataAppendFile(formData, fieldName, file) {
  formData.append(fieldName, file, file.name);
};


/***/ }),

/***/ 38212:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


/**
 * The default implementation for [`createUploadLink`]{@link createUploadLink}
 * `options.isExtractableFile`.
 * @kind function
 * @name isExtractableFile
 * @type {ExtractableFileMatcher}
 * @param {*} value Value to check.
 * @returns {boolean} Is the value an extractable file.
 * @see [`extract-files` `isExtractableFile` docs](https://github.com/jaydenseric/extract-files#function-isextractablefile).
 * @example <caption>Ways to `import`.</caption>
 * ```js
 * import { isExtractableFile } from "apollo-upload-client";
 * ```
 *
 * ```js
 * import isExtractableFile from "apollo-upload-client/public/isExtractableFile.js";
 * ```
 * @example <caption>Ways to `require`.</caption>
 * ```js
 * const { isExtractableFile } = require("apollo-upload-client");
 * ```
 *
 * ```js
 * const isExtractableFile = require("apollo-upload-client/public/isExtractableFile.js");
 * ```
 */
module.exports = __webpack_require__(51268);


/***/ }),

/***/ 79742:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ 99560:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*
 * JavaScript MD5
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 *
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */

/* global define */

/* eslint-disable strict */

;(function ($) {
  'use strict'

  /**
   * Add integers, wrapping at 2^32.
   * This uses 16-bit operations internally to work around bugs in interpreters.
   *
   * @param {number} x First integer
   * @param {number} y Second integer
   * @returns {number} Sum
   */
  function safeAdd(x, y) {
    var lsw = (x & 0xffff) + (y & 0xffff)
    var msw = (x >> 16) + (y >> 16) + (lsw >> 16)
    return (msw << 16) | (lsw & 0xffff)
  }

  /**
   * Bitwise rotate a 32-bit number to the left.
   *
   * @param {number} num 32-bit number
   * @param {number} cnt Rotation count
   * @returns {number} Rotated number
   */
  function bitRotateLeft(num, cnt) {
    return (num << cnt) | (num >>> (32 - cnt))
  }

  /**
   * Basic operation the algorithm uses.
   *
   * @param {number} q q
   * @param {number} a a
   * @param {number} b b
   * @param {number} x x
   * @param {number} s s
   * @param {number} t t
   * @returns {number} Result
   */
  function md5cmn(q, a, b, x, s, t) {
    return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b)
  }
  /**
   * Basic operation the algorithm uses.
   *
   * @param {number} a a
   * @param {number} b b
   * @param {number} c c
   * @param {number} d d
   * @param {number} x x
   * @param {number} s s
   * @param {number} t t
   * @returns {number} Result
   */
  function md5ff(a, b, c, d, x, s, t) {
    return md5cmn((b & c) | (~b & d), a, b, x, s, t)
  }
  /**
   * Basic operation the algorithm uses.
   *
   * @param {number} a a
   * @param {number} b b
   * @param {number} c c
   * @param {number} d d
   * @param {number} x x
   * @param {number} s s
   * @param {number} t t
   * @returns {number} Result
   */
  function md5gg(a, b, c, d, x, s, t) {
    return md5cmn((b & d) | (c & ~d), a, b, x, s, t)
  }
  /**
   * Basic operation the algorithm uses.
   *
   * @param {number} a a
   * @param {number} b b
   * @param {number} c c
   * @param {number} d d
   * @param {number} x x
   * @param {number} s s
   * @param {number} t t
   * @returns {number} Result
   */
  function md5hh(a, b, c, d, x, s, t) {
    return md5cmn(b ^ c ^ d, a, b, x, s, t)
  }
  /**
   * Basic operation the algorithm uses.
   *
   * @param {number} a a
   * @param {number} b b
   * @param {number} c c
   * @param {number} d d
   * @param {number} x x
   * @param {number} s s
   * @param {number} t t
   * @returns {number} Result
   */
  function md5ii(a, b, c, d, x, s, t) {
    return md5cmn(c ^ (b | ~d), a, b, x, s, t)
  }

  /**
   * Calculate the MD5 of an array of little-endian words, and a bit length.
   *
   * @param {Array} x Array of little-endian words
   * @param {number} len Bit length
   * @returns {Array<number>} MD5 Array
   */
  function binlMD5(x, len) {
    /* append padding */
    x[len >> 5] |= 0x80 << len % 32
    x[(((len + 64) >>> 9) << 4) + 14] = len

    var i
    var olda
    var oldb
    var oldc
    var oldd
    var a = 1732584193
    var b = -271733879
    var c = -1732584194
    var d = 271733878

    for (i = 0; i < x.length; i += 16) {
      olda = a
      oldb = b
      oldc = c
      oldd = d

      a = md5ff(a, b, c, d, x[i], 7, -680876936)
      d = md5ff(d, a, b, c, x[i + 1], 12, -389564586)
      c = md5ff(c, d, a, b, x[i + 2], 17, 606105819)
      b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330)
      a = md5ff(a, b, c, d, x[i + 4], 7, -176418897)
      d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426)
      c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341)
      b = md5ff(b, c, d, a, x[i + 7], 22, -45705983)
      a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416)
      d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417)
      c = md5ff(c, d, a, b, x[i + 10], 17, -42063)
      b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162)
      a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682)
      d = md5ff(d, a, b, c, x[i + 13], 12, -40341101)
      c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290)
      b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329)

      a = md5gg(a, b, c, d, x[i + 1], 5, -165796510)
      d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632)
      c = md5gg(c, d, a, b, x[i + 11], 14, 643717713)
      b = md5gg(b, c, d, a, x[i], 20, -373897302)
      a = md5gg(a, b, c, d, x[i + 5], 5, -701558691)
      d = md5gg(d, a, b, c, x[i + 10], 9, 38016083)
      c = md5gg(c, d, a, b, x[i + 15], 14, -660478335)
      b = md5gg(b, c, d, a, x[i + 4], 20, -405537848)
      a = md5gg(a, b, c, d, x[i + 9], 5, 568446438)
      d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690)
      c = md5gg(c, d, a, b, x[i + 3], 14, -187363961)
      b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501)
      a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467)
      d = md5gg(d, a, b, c, x[i + 2], 9, -51403784)
      c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473)
      b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734)

      a = md5hh(a, b, c, d, x[i + 5], 4, -378558)
      d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463)
      c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562)
      b = md5hh(b, c, d, a, x[i + 14], 23, -35309556)
      a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060)
      d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353)
      c = md5hh(c, d, a, b, x[i + 7], 16, -155497632)
      b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640)
      a = md5hh(a, b, c, d, x[i + 13], 4, 681279174)
      d = md5hh(d, a, b, c, x[i], 11, -358537222)
      c = md5hh(c, d, a, b, x[i + 3], 16, -722521979)
      b = md5hh(b, c, d, a, x[i + 6], 23, 76029189)
      a = md5hh(a, b, c, d, x[i + 9], 4, -640364487)
      d = md5hh(d, a, b, c, x[i + 12], 11, -421815835)
      c = md5hh(c, d, a, b, x[i + 15], 16, 530742520)
      b = md5hh(b, c, d, a, x[i + 2], 23, -995338651)

      a = md5ii(a, b, c, d, x[i], 6, -198630844)
      d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415)
      c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905)
      b = md5ii(b, c, d, a, x[i + 5], 21, -57434055)
      a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571)
      d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606)
      c = md5ii(c, d, a, b, x[i + 10], 15, -1051523)
      b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799)
      a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359)
      d = md5ii(d, a, b, c, x[i + 15], 10, -30611744)
      c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380)
      b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649)
      a = md5ii(a, b, c, d, x[i + 4], 6, -145523070)
      d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379)
      c = md5ii(c, d, a, b, x[i + 2], 15, 718787259)
      b = md5ii(b, c, d, a, x[i + 9], 21, -343485551)

      a = safeAdd(a, olda)
      b = safeAdd(b, oldb)
      c = safeAdd(c, oldc)
      d = safeAdd(d, oldd)
    }
    return [a, b, c, d]
  }

  /**
   * Convert an array of little-endian words to a string
   *
   * @param {Array<number>} input MD5 Array
   * @returns {string} MD5 string
   */
  function binl2rstr(input) {
    var i
    var output = ''
    var length32 = input.length * 32
    for (i = 0; i < length32; i += 8) {
      output += String.fromCharCode((input[i >> 5] >>> i % 32) & 0xff)
    }
    return output
  }

  /**
   * Convert a raw string to an array of little-endian words
   * Characters >255 have their high-byte silently ignored.
   *
   * @param {string} input Raw input string
   * @returns {Array<number>} Array of little-endian words
   */
  function rstr2binl(input) {
    var i
    var output = []
    output[(input.length >> 2) - 1] = undefined
    for (i = 0; i < output.length; i += 1) {
      output[i] = 0
    }
    var length8 = input.length * 8
    for (i = 0; i < length8; i += 8) {
      output[i >> 5] |= (input.charCodeAt(i / 8) & 0xff) << i % 32
    }
    return output
  }

  /**
   * Calculate the MD5 of a raw string
   *
   * @param {string} s Input string
   * @returns {string} Raw MD5 string
   */
  function rstrMD5(s) {
    return binl2rstr(binlMD5(rstr2binl(s), s.length * 8))
  }

  /**
   * Calculates the HMAC-MD5 of a key and some data (raw strings)
   *
   * @param {string} key HMAC key
   * @param {string} data Raw input string
   * @returns {string} Raw MD5 string
   */
  function rstrHMACMD5(key, data) {
    var i
    var bkey = rstr2binl(key)
    var ipad = []
    var opad = []
    var hash
    ipad[15] = opad[15] = undefined
    if (bkey.length > 16) {
      bkey = binlMD5(bkey, key.length * 8)
    }
    for (i = 0; i < 16; i += 1) {
      ipad[i] = bkey[i] ^ 0x36363636
      opad[i] = bkey[i] ^ 0x5c5c5c5c
    }
    hash = binlMD5(ipad.concat(rstr2binl(data)), 512 + data.length * 8)
    return binl2rstr(binlMD5(opad.concat(hash), 512 + 128))
  }

  /**
   * Convert a raw string to a hex string
   *
   * @param {string} input Raw input string
   * @returns {string} Hex encoded string
   */
  function rstr2hex(input) {
    var hexTab = '0123456789abcdef'
    var output = ''
    var x
    var i
    for (i = 0; i < input.length; i += 1) {
      x = input.charCodeAt(i)
      output += hexTab.charAt((x >>> 4) & 0x0f) + hexTab.charAt(x & 0x0f)
    }
    return output
  }

  /**
   * Encode a string as UTF-8
   *
   * @param {string} input Input string
   * @returns {string} UTF8 string
   */
  function str2rstrUTF8(input) {
    return unescape(encodeURIComponent(input))
  }

  /**
   * Encodes input string as raw MD5 string
   *
   * @param {string} s Input string
   * @returns {string} Raw MD5 string
   */
  function rawMD5(s) {
    return rstrMD5(str2rstrUTF8(s))
  }
  /**
   * Encodes input string as Hex encoded string
   *
   * @param {string} s Input string
   * @returns {string} Hex encoded string
   */
  function hexMD5(s) {
    return rstr2hex(rawMD5(s))
  }
  /**
   * Calculates the raw HMAC-MD5 for the given key and data
   *
   * @param {string} k HMAC key
   * @param {string} d Input string
   * @returns {string} Raw MD5 string
   */
  function rawHMACMD5(k, d) {
    return rstrHMACMD5(str2rstrUTF8(k), str2rstrUTF8(d))
  }
  /**
   * Calculates the Hex encoded HMAC-MD5 for the given key and data
   *
   * @param {string} k HMAC key
   * @param {string} d Input string
   * @returns {string} Raw MD5 string
   */
  function hexHMACMD5(k, d) {
    return rstr2hex(rawHMACMD5(k, d))
  }

  /**
   * Calculates MD5 value for a given string.
   * If a key is provided, calculates the HMAC-MD5 value.
   * Returns a Hex encoded string unless the raw argument is given.
   *
   * @param {string} string Input string
   * @param {string} [key] HMAC key
   * @param {boolean} [raw] Raw output switch
   * @returns {string} MD5 output
   */
  function md5(string, key, raw) {
    if (!key) {
      if (!raw) {
        return hexMD5(string)
      }
      return rawMD5(string)
    }
    if (!raw) {
      return hexHMACMD5(key, string)
    }
    return rawHMACMD5(key, string)
  }

  if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return md5
    }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else {}
})(this)


/***/ }),

/***/ 48764:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(79742)
var ieee754 = __webpack_require__(80645)
var customInspectSymbol =
  (typeof Symbol === 'function' && typeof Symbol['for'] === 'function') // eslint-disable-line dot-notation
    ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
    : null

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

var K_MAX_LENGTH = 0x7fffffff
exports.kMaxLength = K_MAX_LENGTH

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
    typeof console.error === 'function') {
  console.error(
    'This browser lacks typed array (Uint8Array) support which is required by ' +
    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
  )
}

function typedArraySupport () {
  // Can typed array instances can be augmented?
  try {
    var arr = new Uint8Array(1)
    var proto = { foo: function () { return 42 } }
    Object.setPrototypeOf(proto, Uint8Array.prototype)
    Object.setPrototypeOf(arr, proto)
    return arr.foo() === 42
  } catch (e) {
    return false
  }
}

Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.buffer
  }
})

Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.byteOffset
  }
})

function createBuffer (length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"')
  }
  // Return an augmented `Uint8Array` instance
  var buf = new Uint8Array(length)
  Object.setPrototypeOf(buf, Buffer.prototype)
  return buf
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError(
        'The "string" argument must be of type string. Received type number'
      )
    }
    return allocUnsafe(arg)
  }
  return from(arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

function from (value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset)
  }

  if (ArrayBuffer.isView(value)) {
    return fromArrayView(value)
  }

  if (value == null) {
    throw new TypeError(
      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
      'or Array-like Object. Received type ' + (typeof value)
    )
  }

  if (isInstance(value, ArrayBuffer) ||
      (value && isInstance(value.buffer, ArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof SharedArrayBuffer !== 'undefined' &&
      (isInstance(value, SharedArrayBuffer) ||
      (value && isInstance(value.buffer, SharedArrayBuffer)))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof value === 'number') {
    throw new TypeError(
      'The "value" argument must not be of type number. Received type number'
    )
  }

  var valueOf = value.valueOf && value.valueOf()
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length)
  }

  var b = fromObject(value)
  if (b) return b

  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
      typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(
      value[Symbol.toPrimitive]('string'), encodingOrOffset, length
    )
  }

  throw new TypeError(
    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
    'or Array-like Object. Received type ' + (typeof value)
  )
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length)
}

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype)
Object.setPrototypeOf(Buffer, Uint8Array)

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number')
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"')
  }
}

function alloc (size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(size).fill(fill, encoding)
      : createBuffer(size).fill(fill)
  }
  return createBuffer(size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding)
}

function allocUnsafe (size) {
  assertSize(size)
  return createBuffer(size < 0 ? 0 : checked(size) | 0)
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size)
}

function fromString (string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding)
  }

  var length = byteLength(string, encoding) | 0
  var buf = createBuffer(length)

  var actual = buf.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual)
  }

  return buf
}

function fromArrayLike (array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  var buf = createBuffer(length)
  for (var i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255
  }
  return buf
}

function fromArrayView (arrayView) {
  if (isInstance(arrayView, Uint8Array)) {
    var copy = new Uint8Array(arrayView)
    return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength)
  }
  return fromArrayLike(arrayView)
}

function fromArrayBuffer (array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds')
  }

  var buf
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array)
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset)
  } else {
    buf = new Uint8Array(array, byteOffset, length)
  }

  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(buf, Buffer.prototype)

  return buf
}

function fromObject (obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    var buf = createBuffer(len)

    if (buf.length === 0) {
      return buf
    }

    obj.copy(buf, 0, 0, len)
    return buf
  }

  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0)
    }
    return fromArrayLike(obj)
  }

  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data)
  }
}

function checked (length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return b != null && b._isBuffer === true &&
    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
}

Buffer.compare = function compare (a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError(
      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
    )
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (isInstance(buf, Uint8Array)) {
      if (pos + buf.length > buffer.length) {
        Buffer.from(buf).copy(buffer, pos)
      } else {
        Uint8Array.prototype.set.call(
          buffer,
          buf,
          pos
        )
      }
    } else if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    } else {
      buf.copy(buffer, pos)
    }
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    throw new TypeError(
      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
      'Received type ' + typeof string
    )
  }

  var len = string.length
  var mustMatch = (arguments.length > 2 && arguments[2] === true)
  if (!mustMatch && len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
        }
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.toLocaleString = Buffer.prototype.toString

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
  if (this.length > max) str += ' ... '
  return '<Buffer ' + str + '>'
}
if (customInspectSymbol) {
  Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength)
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError(
      'The "target" argument must be one of type Buffer or Uint8Array. ' +
      'Received type ' + (typeof target)
    )
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  var strLen = string.length

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (numberIsNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0
    if (isFinite(length)) {
      length = length >>> 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
      case 'latin1':
      case 'binary':
        return asciiWrite(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF)
      ? 4
      : (firstByte > 0xDF)
          ? 3
          : (firstByte > 0xBF)
              ? 2
              : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += hexSliceLookupTable[buf[i]]
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
  for (var i = 0; i < bytes.length - 1; i += 2) {
    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf = this.subarray(start, end)
  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(newBuf, Buffer.prototype)

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUintLE =
Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUintBE =
Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUint8 =
Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUint16LE =
Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUint16BE =
Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUint32LE =
Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUint32BE =
Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUintLE =
Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUintBE =
Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUint8 =
Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeUint16LE =
Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeUint16BE =
Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeUint32LE =
Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset + 3] = (value >>> 24)
  this[offset + 2] = (value >>> 16)
  this[offset + 1] = (value >>> 8)
  this[offset] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeUint32BE =
Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  this[offset + 2] = (value >>> 16)
  this[offset + 3] = (value >>> 24)
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start

  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end)
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, end),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if ((encoding === 'utf8' && code < 128) ||
          encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255
  } else if (typeof val === 'boolean') {
    val = Number(val)
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : Buffer.from(val, encoding)
    var len = bytes.length
    if (len === 0) {
      throw new TypeError('The value "' + val +
        '" is invalid for argument "value"')
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0]
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance (obj, type) {
  return obj instanceof type ||
    (obj != null && obj.constructor != null && obj.constructor.name != null &&
      obj.constructor.name === type.name)
}
function numberIsNaN (obj) {
  // For IE11 support
  return obj !== obj // eslint-disable-line no-self-compare
}

// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var hexSliceLookupTable = (function () {
  var alphabet = '0123456789abcdef'
  var table = new Array(256)
  for (var i = 0; i < 16; ++i) {
    var i16 = i * 16
    for (var j = 0; j < 16; ++j) {
      table[i16 + j] = alphabet[i] + alphabet[j]
    }
  }
  return table
})()


/***/ }),

/***/ 86010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
function toVal(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__() {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal(tmp)) {
				str && (str += ' ');
				str += x
			}
		}
	}
	return str;
}


/***/ }),

/***/ 76489:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

__webpack_unused_export__ = parse;
__webpack_unused_export__ = serialize;

/**
 * Module variables.
 * @private
 */

var decode = decodeURIComponent;
var encode = encodeURIComponent;

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {}
  var opt = options || {};
  var pairs = str.split(';')
  var dec = opt.decode || decode;

  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i];
    var index = pair.indexOf('=')

    // skip things that don't look like key=value
    if (index < 0) {
      continue;
    }

    var key = pair.substring(0, index).trim()

    // only assign once
    if (undefined == obj[key]) {
      var val = pair.substring(index + 1, pair.length).trim()

      // quoted values
      if (val[0] === '"') {
        val = val.slice(1, -1)
      }

      obj[key] = tryDecode(val, dec);
    }
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;

    if (isNaN(maxAge) || !isFinite(maxAge)) {
      throw new TypeError('option maxAge is invalid')
    }

    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + opt.expires.toUTCString();
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      case 'none':
        str += '; SameSite=None';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}


/***/ }),

/***/ 44941:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _locale_en_US_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83975);

/* harmony default export */ __webpack_exports__["Z"] = (_locale_en_US_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);

/***/ }),

/***/ 84314:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ getDefaultOptions; }
/* harmony export */ });
/* unused harmony export setDefaultOptions */
var defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions;
}
function setDefaultOptions(newOptions) {
  defaultOptions = newOptions;
}

/***/ }),

/***/ 97621:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });

    case 'PP':
      return formatLong.date({
        width: 'medium'
      });

    case 'PPP':
      return formatLong.date({
        width: 'long'
      });

    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
};

var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });

    case 'pp':
      return formatLong.time({
        width: 'medium'
      });

    case 'ppp':
      return formatLong.time({
        width: 'long'
      });

    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
};

var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];

  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }

  var dateTimeFormat;

  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;

    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;

    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;

    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }

  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
};

var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
/* harmony default export */ __webpack_exports__["Z"] = (longFormatters);

/***/ }),

/***/ 24262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getTimezoneOffsetInMilliseconds; }
/* harmony export */ });
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}

/***/ }),

/***/ 33276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ getUTCISOWeek; }
});

// EXTERNAL MODULE: ./node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(19013);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCISOWeek/index.js
var startOfUTCISOWeek = __webpack_require__(66979);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getUTCISOWeekYear/index.js
var getUTCISOWeekYear = __webpack_require__(7032);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(13882);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCISOWeekYear/index.js



function startOfUTCISOWeekYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var year = (0,getUTCISOWeekYear/* default */.Z)(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = (0,startOfUTCISOWeek/* default */.Z)(fourthOfJanuary);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getUTCISOWeek/index.js




var MILLISECONDS_IN_WEEK = 604800000;
function getUTCISOWeek(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var diff = (0,startOfUTCISOWeek/* default */.Z)(date).getTime() - startOfUTCISOWeekYear(date).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

/***/ }),

/***/ 7032:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getUTCISOWeekYear; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);
/* harmony import */ var _startOfUTCISOWeek_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66979);



function getUTCISOWeekYear(dirtyDate) {
  (0,_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = (0,_startOfUTCISOWeek_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = (0,_startOfUTCISOWeek_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(fourthOfJanuaryOfThisYear);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

/***/ }),

/***/ 5230:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ getUTCWeek; }
});

// EXTERNAL MODULE: ./node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(19013);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCWeek/index.js
var startOfUTCWeek = __webpack_require__(59025);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getUTCWeekYear/index.js
var getUTCWeekYear = __webpack_require__(7651);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(13882);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/toInteger/index.js
var toInteger = __webpack_require__(83946);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/defaultOptions/index.js
var _lib_defaultOptions = __webpack_require__(84314);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCWeekYear/index.js





function startOfUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

  (0,requiredArgs/* default */.Z)(1, arguments);
  var defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  var firstWeekContainsDate = (0,toInteger/* default */.Z)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = (0,getUTCWeekYear/* default */.Z)(dirtyDate, options);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = (0,startOfUTCWeek/* default */.Z)(firstWeek, options);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getUTCWeek/index.js




var MILLISECONDS_IN_WEEK = 604800000;
function getUTCWeek(dirtyDate, options) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var diff = (0,startOfUTCWeek/* default */.Z)(date, options).getTime() - startOfUTCWeekYear(date, options).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

/***/ }),

/***/ 7651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getUTCWeekYear; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);
/* harmony import */ var _startOfUTCWeek_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59025);
/* harmony import */ var _toInteger_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83946);
/* harmony import */ var _defaultOptions_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84314);





function getUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

  (0,_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  var year = date.getUTCFullYear();
  var defaultOptions = (0,_defaultOptions_index_js__WEBPACK_IMPORTED_MODULE_2__/* .getDefaultOptions */ .j)();
  var firstWeekContainsDate = (0,_toInteger_index_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = (0,_startOfUTCWeek_index_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = (0,_startOfUTCWeek_index_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(firstWeekOfThisYear, options);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

/***/ }),

/***/ 5267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Do": function() { return /* binding */ isProtectedWeekYearToken; },
/* harmony export */   "Iu": function() { return /* binding */ isProtectedDayOfYearToken; },
/* harmony export */   "qp": function() { return /* binding */ throwProtectedError; }
/* harmony export */ });
var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  }
}

/***/ }),

/***/ 13882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ requiredArgs; }
/* harmony export */ });
function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

/***/ }),

/***/ 66979:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ startOfUTCISOWeek; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


function startOfUTCISOWeek(dirtyDate) {
  (0,_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var weekStartsOn = 1;
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

/***/ }),

/***/ 59025:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ startOfUTCWeek; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19013);
/* harmony import */ var _requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);
/* harmony import */ var _toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83946);
/* harmony import */ var _defaultOptions_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84314);




function startOfUTCWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

  (0,_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var defaultOptions = (0,_defaultOptions_index_js__WEBPACK_IMPORTED_MODULE_1__/* .getDefaultOptions */ .j)();
  var weekStartsOn = (0,_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

/***/ }),

/***/ 83946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ toInteger; }
/* harmony export */ });
function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }

  var number = Number(dirtyNumber);

  if (isNaN(number)) {
    return number;
  }

  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

/***/ }),

/***/ 51820:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ addMilliseconds; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83946);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */

function addMilliseconds(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var timestamp = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate).getTime();
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyAmount);
  return new Date(timestamp + amount);
}

/***/ }),

/***/ 36948:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "qk": function() { return /* binding */ millisecondsInSecond; },
/* harmony export */   "vh": function() { return /* binding */ millisecondsInHour; },
/* harmony export */   "yJ": function() { return /* binding */ millisecondsInMinute; }
/* harmony export */ });
/* unused harmony exports daysInWeek, daysInYear, maxTime, minTime, minutesInHour, monthsInQuarter, monthsInYear, quartersInYear, secondsInHour, secondsInMinute, secondsInDay, secondsInWeek, secondsInYear, secondsInMonth, secondsInQuarter */
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */
var daysInWeek = 7;
/**
 * Days in 1 year
 * One years equals 365.2425 days according to the formula:
 *
 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
 *
 * @name daysInYear
 * @constant
 * @type {number}
 * @default
 */

var daysInYear = 365.2425;
/**
 * Maximum allowed time.
 *
 * @name maxTime
 * @constant
 * @type {number}
 * @default
 */

var maxTime = Math.pow(10, 8) * 24 * 60 * 60 * 1000;
/**
 * Milliseconds in 1 minute
 *
 * @name millisecondsInMinute
 * @constant
 * @type {number}
 * @default
 */

var millisecondsInMinute = 60000;
/**
 * Milliseconds in 1 hour
 *
 * @name millisecondsInHour
 * @constant
 * @type {number}
 * @default
 */

var millisecondsInHour = 3600000;
/**
 * Milliseconds in 1 second
 *
 * @name millisecondsInSecond
 * @constant
 * @type {number}
 * @default
 */

var millisecondsInSecond = 1000;
/**
 * Minimum allowed time.
 *
 * @name minTime
 * @constant
 * @type {number}
 * @default
 */

var minTime = -maxTime;
/**
 * Minutes in 1 hour
 *
 * @name minutesInHour
 * @constant
 * @type {number}
 * @default
 */

var minutesInHour = 60;
/**
 * Months in 1 quarter
 *
 * @name monthsInQuarter
 * @constant
 * @type {number}
 * @default
 */

var monthsInQuarter = 3;
/**
 * Months in 1 year
 *
 * @name monthsInYear
 * @constant
 * @type {number}
 * @default
 */

var monthsInYear = 12;
/**
 * Quarters in 1 year
 *
 * @name quartersInYear
 * @constant
 * @type {number}
 * @default
 */

var quartersInYear = 4;
/**
 * Seconds in 1 hour
 *
 * @name secondsInHour
 * @constant
 * @type {number}
 * @default
 */

var secondsInHour = 3600;
/**
 * Seconds in 1 minute
 *
 * @name secondsInMinute
 * @constant
 * @type {number}
 * @default
 */

var secondsInMinute = 60;
/**
 * Seconds in 1 day
 *
 * @name secondsInDay
 * @constant
 * @type {number}
 * @default
 */

var secondsInDay = secondsInHour * 24;
/**
 * Seconds in 1 week
 *
 * @name secondsInWeek
 * @constant
 * @type {number}
 * @default
 */

var secondsInWeek = secondsInDay * 7;
/**
 * Seconds in 1 year
 *
 * @name secondsInYear
 * @constant
 * @type {number}
 * @default
 */

var secondsInYear = secondsInDay * daysInYear;
/**
 * Seconds in 1 month
 *
 * @name secondsInMonth
 * @constant
 * @type {number}
 * @default
 */

var secondsInMonth = secondsInYear / 12;
/**
 * Seconds in 1 quarter
 *
 * @name secondsInQuarter
 * @constant
 * @type {number}
 * @default
 */

var secondsInQuarter = secondsInMonth * 3;

/***/ }),

/***/ 42298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ format; }
});

// EXTERNAL MODULE: ./node_modules/date-fns/esm/isValid/index.js + 1 modules
var isValid = __webpack_require__(61436);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/subMilliseconds/index.js
var subMilliseconds = __webpack_require__(91218);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(19013);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(13882);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getUTCDayOfYear/index.js


var MILLISECONDS_IN_DAY = 86400000;
function getUTCDayOfYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getUTCISOWeek/index.js + 1 modules
var getUTCISOWeek = __webpack_require__(33276);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getUTCISOWeekYear/index.js
var getUTCISOWeekYear = __webpack_require__(7032);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getUTCWeek/index.js + 1 modules
var getUTCWeek = __webpack_require__(5230);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getUTCWeekYear/index.js
var getUTCWeekYear = __webpack_require__(7651);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/addLeadingZeros/index.js
function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();

  while (output.length < targetLength) {
    output = '0' + output;
  }

  return sign + output;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/format/lightFormatters/index.js

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */

var formatters = {
  // Year
  y: function y(date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
    var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function M(date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d: function d(date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function a(date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();

      case 'aaa':
        return dayPeriodEnumValue;

      case 'aaaaa':
        return dayPeriodEnumValue[0];

      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function h(date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function H(date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  // Minute
  m: function m(date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function s(date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function S(date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};
/* harmony default export */ var lightFormatters = (formatters);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/format/formatters/index.js







var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */
var formatters_formatters = {
  // Era
  G: function G(date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;

    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B

      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ

      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function y(date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }

    return lightFormatters.y(date, token);
  },
  // Local week-numbering year
  Y: function Y(date, token, localize, options) {
    var signedWeekYear = (0,getUTCWeekYear/* default */.Z)(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year

    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    } // Ordinal number


    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    } // Padding


    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function R(date, token) {
    var isoWeekYear = (0,getUTCISOWeekYear/* default */.Z)(date); // Padding

    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function u(date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function Q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'QQ':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...

      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'qq':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...

      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function M(date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      case 'M':
      case 'MM':
        return lightFormatters.M(date, token);
      // 1st, 2nd, ..., 12th

      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D

      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December

      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function L(date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12

      case 'LL':
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th

      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D

      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December

      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function w(date, token, localize, options) {
    var week = (0,getUTCWeek/* default */.Z)(date, options);

    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }

    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function I(date, token, localize) {
    var isoWeek = (0,getUTCISOWeek/* default */.Z)(date);

    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }

    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function d(date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }

    return lightFormatters.d(date, token);
  },
  // Day of year
  D: function D(date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);

    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }

    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function E(date, token, localize) {
    var dayOfWeek = date.getUTCDay();

    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function e(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th

      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function c(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th

      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T

      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu

      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday

      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function i(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;

    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02

      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd

      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue

      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function a(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function b(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }

    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function B(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }

    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function h(date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return lightFormatters.h(date, token);
  },
  // Hour [0-23]
  H: function H(date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }

    return lightFormatters.H(date, token);
  },
  // Hour [0-11]
  K: function K(date, token, localize) {
    var hours = date.getUTCHours() % 12;

    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function k(date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;

    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function m(date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }

    return lightFormatters.m(date, token);
  },
  // Second
  s: function s(date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }

    return lightFormatters.s(date, token);
  },
  // Fraction of second
  S: function S(date, token) {
    return lightFormatters.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function X(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    if (timezoneOffset === 0) {
      return 'Z';
    }

    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`

      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`

      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function x(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`

      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`

      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function O(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function z(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function t(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function T(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};

function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;

  if (minutes === 0) {
    return sign + String(hours);
  }

  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}

function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }

  return formatTimezone(offset, dirtyDelimiter);
}

function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}

/* harmony default export */ var format_formatters = (formatters_formatters);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/format/longFormatters/index.js
var longFormatters = __webpack_require__(97621);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js
var getTimezoneOffsetInMilliseconds = __webpack_require__(24262);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/protectedTokens/index.js
var protectedTokens = __webpack_require__(5267);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/toInteger/index.js
var toInteger = __webpack_require__(83946);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/defaultOptions/index.js
var _lib_defaultOptions = __webpack_require__(84314);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/defaultLocale/index.js
var defaultLocale = __webpack_require__(44941);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/format/index.js










 // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;

  (0,requiredArgs/* default */.Z)(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : defaultLocale/* default */.Z;
  var firstWeekContainsDate = (0,toInteger/* default */.Z)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var weekStartsOn = (0,toInteger/* default */.Z)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }

  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }

  var originalDate = (0,toDate/* default */.Z)(dirtyDate);

  if (!(0,isValid/* default */.Z)(originalDate)) {
    throw new RangeError('Invalid time value');
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376


  var timezoneOffset = (0,getTimezoneOffsetInMilliseconds/* default */.Z)(originalDate);
  var utcDate = (0,subMilliseconds/* default */.Z)(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters/* default */.Z[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }

    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }

    var firstCharacter = substring[0];

    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }

    var formatter = format_formatters[firstCharacter];

    if (formatter) {
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0,protectedTokens/* isProtectedWeekYearToken */.Do)(substring)) {
        (0,protectedTokens/* throwProtectedError */.qp)(substring, dirtyFormatStr, String(dirtyDate));
      }

      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0,protectedTokens/* isProtectedDayOfYearToken */.Iu)(substring)) {
        (0,protectedTokens/* throwProtectedError */.qp)(substring, dirtyFormatStr, String(dirtyDate));
      }

      return formatter(utcDate, substring, locale.localize, formatterOptions);
    }

    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }

    return substring;
  }).join('');
  return result;
}

function cleanEscapedString(input) {
  var matched = input.match(escapedStringRegExp);

  if (!matched) {
    return input;
  }

  return matched[1].replace(doubleQuoteRegExp, "'");
}

/***/ }),

/***/ 82644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ isFuture; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name isFuture
 * @category Common Helpers
 * @summary Is the given date in the future?
 * @pure false
 *
 * @description
 * Is the given date in the future?
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is in the future
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // If today is 6 October 2014, is 31 December 2014 in the future?
 * const result = isFuture(new Date(2014, 11, 31))
 * //=> true
 */

function isFuture(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  return (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate).getTime() > Date.now();
}

/***/ }),

/***/ 33913:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ isPast; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name isPast
 * @category Common Helpers
 * @summary Is the given date in the past?
 * @pure false
 *
 * @description
 * Is the given date in the past?
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is in the past
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // If today is 6 October 2014, is 2 July 2014 in the past?
 * const result = isPast(new Date(2014, 6, 2))
 * //=> true
 */

function isPast(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  return (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate).getTime() < Date.now();
}

/***/ }),

/***/ 61436:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ isValid; }
});

// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(13882);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isDate/index.js
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }


/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */

function isDate(value) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return value instanceof Date || _typeof(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(19013);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isValid/index.js



/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */

function isValid(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);

  if (!isDate(dirtyDate) && typeof dirtyDate !== 'number') {
    return false;
  }

  var date = (0,toDate/* default */.Z)(dirtyDate);
  return !isNaN(Number(date));
}

/***/ }),

/***/ 49526:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ buildFormatLongFn; }
/* harmony export */ });
function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

/***/ }),

/***/ 88486:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ buildLocalizeFn; }
/* harmony export */ });
function buildLocalizeFn(args) {
  return function (dirtyIndex, options) {
    var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
    var valuesArray;

    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;

      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;

      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }

    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!

    return valuesArray[index];
  };
}

/***/ }),

/***/ 76723:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ buildMatchFn; }
/* harmony export */ });
function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }

  return undefined;
}

function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }

  return undefined;
}

/***/ }),

/***/ 60974:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ buildMatchPatternFn; }
/* harmony export */ });
function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

/***/ }),

/***/ 81991:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};

var formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];

  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }

  return result;
};

/* harmony default export */ __webpack_exports__["Z"] = (formatDistance);

/***/ }),

/***/ 21865:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};

var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};

/* harmony default export */ __webpack_exports__["Z"] = (formatRelative);

/***/ }),

/***/ 11950:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _lib_buildLocalizeFn_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88486);

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.

var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};

var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  var rem100 = number % 100;

  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';

      case 2:
        return number + 'nd';

      case 3:
        return number + 'rd';
    }
  }

  return number + 'th';
};

var localize = {
  ordinalNumber: ordinalNumber,
  era: (0,_lib_buildLocalizeFn_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: (0,_lib_buildLocalizeFn_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: (0,_lib_buildLocalizeFn_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: (0,_lib_buildLocalizeFn_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: (0,_lib_buildLocalizeFn_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
/* harmony default export */ __webpack_exports__["Z"] = (localize);

/***/ }),

/***/ 7219:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _lib_buildMatchFn_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76723);
/* harmony import */ var _lib_buildMatchPatternFn_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60974);


var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: (0,_lib_buildMatchPatternFn_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: (0,_lib_buildMatchFn_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: (0,_lib_buildMatchFn_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: (0,_lib_buildMatchFn_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: (0,_lib_buildMatchFn_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: (0,_lib_buildMatchFn_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
/* harmony default export */ __webpack_exports__["Z"] = (match);

/***/ }),

/***/ 83975:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ en_US; }
});

// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/formatDistance/index.js
var formatDistance = __webpack_require__(81991);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/_lib/buildFormatLongFn/index.js
var buildFormatLongFn = __webpack_require__(49526);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/formatLong/index.js

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: (0,buildFormatLongFn/* default */.Z)({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: (0,buildFormatLongFn/* default */.Z)({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: (0,buildFormatLongFn/* default */.Z)({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
/* harmony default export */ var _lib_formatLong = (formatLong);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/formatRelative/index.js
var formatRelative = __webpack_require__(21865);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/localize/index.js
var localize = __webpack_require__(11950);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/match/index.js
var match = __webpack_require__(7219);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/index.js






/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */
var locale = {
  code: 'en-US',
  formatDistance: formatDistance/* default */.Z,
  formatLong: _lib_formatLong,
  formatRelative: formatRelative/* default */.Z,
  localize: localize/* default */.Z,
  match: match/* default */.Z,
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};
/* harmony default export */ var en_US = (locale);

/***/ }),

/***/ 35337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ parse; }
});

// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/defaultLocale/index.js
var defaultLocale = __webpack_require__(44941);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/subMilliseconds/index.js
var subMilliseconds = __webpack_require__(91218);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(19013);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/assign/index.js
function assign_assign(target, object) {
  if (target == null) {
    throw new TypeError('assign requires that input parameter not be null or undefined');
  }

  for (var property in object) {
    if (Object.prototype.hasOwnProperty.call(object, property)) {
      ;
      target[property] = object[property];
    }
  }

  return target;
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/format/longFormatters/index.js
var longFormatters = __webpack_require__(97621);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js
var getTimezoneOffsetInMilliseconds = __webpack_require__(24262);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/protectedTokens/index.js
var protectedTokens = __webpack_require__(5267);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/toInteger/index.js
var toInteger = __webpack_require__(83946);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(13882);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/Setter.js
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TIMEZONE_UNIT_PRIORITY = 10;
var Setter = /*#__PURE__*/function () {
  function Setter() {
    _classCallCheck(this, Setter);

    _defineProperty(this, "subPriority", 0);
  }

  _createClass(Setter, [{
    key: "validate",
    value: function validate(_utcDate, _options) {
      return true;
    }
  }]);

  return Setter;
}();
var ValueSetter = /*#__PURE__*/function (_Setter) {
  _inherits(ValueSetter, _Setter);

  var _super = _createSuper(ValueSetter);

  function ValueSetter(value, validateValue, setValue, priority, subPriority) {
    var _this;

    _classCallCheck(this, ValueSetter);

    _this = _super.call(this);
    _this.value = value;
    _this.validateValue = validateValue;
    _this.setValue = setValue;
    _this.priority = priority;

    if (subPriority) {
      _this.subPriority = subPriority;
    }

    return _this;
  }

  _createClass(ValueSetter, [{
    key: "validate",
    value: function validate(utcDate, options) {
      return this.validateValue(utcDate, this.value, options);
    }
  }, {
    key: "set",
    value: function set(utcDate, flags, options) {
      return this.setValue(utcDate, flags, this.value, options);
    }
  }]);

  return ValueSetter;
}(Setter);
var DateToSystemTimezoneSetter = /*#__PURE__*/function (_Setter2) {
  _inherits(DateToSystemTimezoneSetter, _Setter2);

  var _super2 = _createSuper(DateToSystemTimezoneSetter);

  function DateToSystemTimezoneSetter() {
    var _this2;

    _classCallCheck(this, DateToSystemTimezoneSetter);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this2), "priority", TIMEZONE_UNIT_PRIORITY);

    _defineProperty(_assertThisInitialized(_this2), "subPriority", -1);

    return _this2;
  }

  _createClass(DateToSystemTimezoneSetter, [{
    key: "set",
    value: function set(date, flags) {
      if (flags.timestampIsSet) {
        return date;
      }

      var convertedDate = new Date(0);
      convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
      convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
      return convertedDate;
    }
  }]);

  return DateToSystemTimezoneSetter;
}(Setter);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/Parser.js
function Parser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Parser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Parser_createClass(Constructor, protoProps, staticProps) { if (protoProps) Parser_defineProperties(Constructor.prototype, protoProps); if (staticProps) Parser_defineProperties(Constructor, staticProps); return Constructor; }


var Parser = /*#__PURE__*/function () {
  function Parser() {
    Parser_classCallCheck(this, Parser);
  }

  Parser_createClass(Parser, [{
    key: "run",
    value: function run(dateString, token, match, options) {
      var result = this.parse(dateString, token, match, options);

      if (!result) {
        return null;
      }

      return {
        setter: new ValueSetter(result.value, this.validate, this.set, this.priority, this.subPriority),
        rest: result.rest
      };
    }
  }, {
    key: "validate",
    value: function validate(_utcDate, _value, _options) {
      return true;
    }
  }]);

  return Parser;
}();
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/EraParser.js
function EraParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { EraParser_typeof = function _typeof(obj) { return typeof obj; }; } else { EraParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return EraParser_typeof(obj); }

function EraParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function EraParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function EraParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) EraParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) EraParser_defineProperties(Constructor, staticProps); return Constructor; }

function EraParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) EraParser_setPrototypeOf(subClass, superClass); }

function EraParser_setPrototypeOf(o, p) { EraParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return EraParser_setPrototypeOf(o, p); }

function EraParser_createSuper(Derived) { var hasNativeReflectConstruct = EraParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = EraParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = EraParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return EraParser_possibleConstructorReturn(this, result); }; }

function EraParser_possibleConstructorReturn(self, call) { if (call && (EraParser_typeof(call) === "object" || typeof call === "function")) { return call; } return EraParser_assertThisInitialized(self); }

function EraParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function EraParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function EraParser_getPrototypeOf(o) { EraParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return EraParser_getPrototypeOf(o); }

function EraParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var EraParser = /*#__PURE__*/function (_Parser) {
  EraParser_inherits(EraParser, _Parser);

  var _super = EraParser_createSuper(EraParser);

  function EraParser() {
    var _this;

    EraParser_classCallCheck(this, EraParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    EraParser_defineProperty(EraParser_assertThisInitialized(_this), "priority", 140);

    EraParser_defineProperty(EraParser_assertThisInitialized(_this), "incompatibleTokens", ['R', 'u', 't', 'T']);

    return _this;
  }

  EraParser_createClass(EraParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        // AD, BC
        case 'G':
        case 'GG':
        case 'GGG':
          return match.era(dateString, {
            width: 'abbreviated'
          }) || match.era(dateString, {
            width: 'narrow'
          });
        // A, B

        case 'GGGGG':
          return match.era(dateString, {
            width: 'narrow'
          });
        // Anno Domini, Before Christ

        case 'GGGG':
        default:
          return match.era(dateString, {
            width: 'wide'
          }) || match.era(dateString, {
            width: 'abbreviated'
          }) || match.era(dateString, {
            width: 'narrow'
          });
      }
    }
  }, {
    key: "set",
    value: function set(date, flags, value) {
      flags.era = value;
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return EraParser;
}(Parser);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/constants/index.js
var constants = __webpack_require__(36948);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/constants.js
var numericPatterns = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999

};
var timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/utils.js


function mapValue(parseFnResult, mapFn) {
  if (!parseFnResult) {
    return parseFnResult;
  }

  return {
    value: mapFn(parseFnResult.value),
    rest: parseFnResult.rest
  };
}
function parseNumericPattern(pattern, dateString) {
  var matchResult = dateString.match(pattern);

  if (!matchResult) {
    return null;
  }

  return {
    value: parseInt(matchResult[0], 10),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseTimezonePattern(pattern, dateString) {
  var matchResult = dateString.match(pattern);

  if (!matchResult) {
    return null;
  } // Input is 'Z'


  if (matchResult[0] === 'Z') {
    return {
      value: 0,
      rest: dateString.slice(1)
    };
  }

  var sign = matchResult[1] === '+' ? 1 : -1;
  var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
  var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
  var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
  return {
    value: sign * (hours * constants/* millisecondsInHour */.vh + minutes * constants/* millisecondsInMinute */.yJ + seconds * constants/* millisecondsInSecond */.qk),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseAnyDigitsSigned(dateString) {
  return parseNumericPattern(numericPatterns.anyDigitsSigned, dateString);
}
function parseNDigits(n, dateString) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigit, dateString);

    case 2:
      return parseNumericPattern(numericPatterns.twoDigits, dateString);

    case 3:
      return parseNumericPattern(numericPatterns.threeDigits, dateString);

    case 4:
      return parseNumericPattern(numericPatterns.fourDigits, dateString);

    default:
      return parseNumericPattern(new RegExp('^\\d{1,' + n + '}'), dateString);
  }
}
function parseNDigitsSigned(n, dateString) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigitSigned, dateString);

    case 2:
      return parseNumericPattern(numericPatterns.twoDigitsSigned, dateString);

    case 3:
      return parseNumericPattern(numericPatterns.threeDigitsSigned, dateString);

    case 4:
      return parseNumericPattern(numericPatterns.fourDigitsSigned, dateString);

    default:
      return parseNumericPattern(new RegExp('^-?\\d{1,' + n + '}'), dateString);
  }
}
function dayPeriodEnumToHours(dayPeriod) {
  switch (dayPeriod) {
    case 'morning':
      return 4;

    case 'evening':
      return 17;

    case 'pm':
    case 'noon':
    case 'afternoon':
      return 12;

    case 'am':
    case 'midnight':
    case 'night':
    default:
      return 0;
  }
}
function normalizeTwoDigitYear(twoDigitYear, currentYear) {
  var isCommonEra = currentYear > 0; // Absolute number of the current year:
  // 1 -> 1 AC
  // 0 -> 1 BC
  // -1 -> 2 BC

  var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
  var result;

  if (absCurrentYear <= 50) {
    result = twoDigitYear || 100;
  } else {
    var rangeEnd = absCurrentYear + 50;
    var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
    var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
  }

  return isCommonEra ? result : 1 - result;
}
function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/YearParser.js
function YearParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { YearParser_typeof = function _typeof(obj) { return typeof obj; }; } else { YearParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return YearParser_typeof(obj); }

function YearParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function YearParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function YearParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) YearParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) YearParser_defineProperties(Constructor, staticProps); return Constructor; }

function YearParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) YearParser_setPrototypeOf(subClass, superClass); }

function YearParser_setPrototypeOf(o, p) { YearParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return YearParser_setPrototypeOf(o, p); }

function YearParser_createSuper(Derived) { var hasNativeReflectConstruct = YearParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = YearParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = YearParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return YearParser_possibleConstructorReturn(this, result); }; }

function YearParser_possibleConstructorReturn(self, call) { if (call && (YearParser_typeof(call) === "object" || typeof call === "function")) { return call; } return YearParser_assertThisInitialized(self); }

function YearParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function YearParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function YearParser_getPrototypeOf(o) { YearParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return YearParser_getPrototypeOf(o); }

function YearParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



// From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
// | Year     |     y | yy |   yyy |  yyyy | yyyyy |
// |----------|-------|----|-------|-------|-------|
// | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
// | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
// | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
// | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
// | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
var YearParser = /*#__PURE__*/function (_Parser) {
  YearParser_inherits(YearParser, _Parser);

  var _super = YearParser_createSuper(YearParser);

  function YearParser() {
    var _this;

    YearParser_classCallCheck(this, YearParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    YearParser_defineProperty(YearParser_assertThisInitialized(_this), "priority", 130);

    YearParser_defineProperty(YearParser_assertThisInitialized(_this), "incompatibleTokens", ['Y', 'R', 'u', 'w', 'I', 'i', 'e', 'c', 't', 'T']);

    return _this;
  }

  YearParser_createClass(YearParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(year) {
        return {
          year: year,
          isTwoDigitYear: token === 'yy'
        };
      };

      switch (token) {
        case 'y':
          return mapValue(parseNDigits(4, dateString), valueCallback);

        case 'yo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'year'
          }), valueCallback);

        default:
          return mapValue(parseNDigits(token.length, dateString), valueCallback);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value.isTwoDigitYear || value.year > 0;
    }
  }, {
    key: "set",
    value: function set(date, flags, value) {
      var currentYear = date.getUTCFullYear();

      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }

      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return YearParser;
}(Parser);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getUTCWeekYear/index.js
var getUTCWeekYear = __webpack_require__(7651);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCWeek/index.js
var startOfUTCWeek = __webpack_require__(59025);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/LocalWeekYearParser.js
function LocalWeekYearParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { LocalWeekYearParser_typeof = function _typeof(obj) { return typeof obj; }; } else { LocalWeekYearParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return LocalWeekYearParser_typeof(obj); }

function LocalWeekYearParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function LocalWeekYearParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function LocalWeekYearParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) LocalWeekYearParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) LocalWeekYearParser_defineProperties(Constructor, staticProps); return Constructor; }

function LocalWeekYearParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) LocalWeekYearParser_setPrototypeOf(subClass, superClass); }

function LocalWeekYearParser_setPrototypeOf(o, p) { LocalWeekYearParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return LocalWeekYearParser_setPrototypeOf(o, p); }

function LocalWeekYearParser_createSuper(Derived) { var hasNativeReflectConstruct = LocalWeekYearParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = LocalWeekYearParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = LocalWeekYearParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return LocalWeekYearParser_possibleConstructorReturn(this, result); }; }

function LocalWeekYearParser_possibleConstructorReturn(self, call) { if (call && (LocalWeekYearParser_typeof(call) === "object" || typeof call === "function")) { return call; } return LocalWeekYearParser_assertThisInitialized(self); }

function LocalWeekYearParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function LocalWeekYearParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function LocalWeekYearParser_getPrototypeOf(o) { LocalWeekYearParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return LocalWeekYearParser_getPrototypeOf(o); }

function LocalWeekYearParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





// Local week-numbering year
var LocalWeekYearParser = /*#__PURE__*/function (_Parser) {
  LocalWeekYearParser_inherits(LocalWeekYearParser, _Parser);

  var _super = LocalWeekYearParser_createSuper(LocalWeekYearParser);

  function LocalWeekYearParser() {
    var _this;

    LocalWeekYearParser_classCallCheck(this, LocalWeekYearParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    LocalWeekYearParser_defineProperty(LocalWeekYearParser_assertThisInitialized(_this), "priority", 130);

    LocalWeekYearParser_defineProperty(LocalWeekYearParser_assertThisInitialized(_this), "incompatibleTokens", ['y', 'R', 'u', 'Q', 'q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']);

    return _this;
  }

  LocalWeekYearParser_createClass(LocalWeekYearParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(year) {
        return {
          year: year,
          isTwoDigitYear: token === 'YY'
        };
      };

      switch (token) {
        case 'Y':
          return mapValue(parseNDigits(4, dateString), valueCallback);

        case 'Yo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'year'
          }), valueCallback);

        default:
          return mapValue(parseNDigits(token.length, dateString), valueCallback);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value.isTwoDigitYear || value.year > 0;
    }
  }, {
    key: "set",
    value: function set(date, flags, value, options) {
      var currentYear = (0,getUTCWeekYear/* default */.Z)(date, options);

      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
        date.setUTCHours(0, 0, 0, 0);
        return (0,startOfUTCWeek/* default */.Z)(date, options);
      }

      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
      date.setUTCHours(0, 0, 0, 0);
      return (0,startOfUTCWeek/* default */.Z)(date, options);
    }
  }]);

  return LocalWeekYearParser;
}(Parser);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCISOWeek/index.js
var startOfUTCISOWeek = __webpack_require__(66979);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/ISOWeekYearParser.js
function ISOWeekYearParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { ISOWeekYearParser_typeof = function _typeof(obj) { return typeof obj; }; } else { ISOWeekYearParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return ISOWeekYearParser_typeof(obj); }

function ISOWeekYearParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ISOWeekYearParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function ISOWeekYearParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) ISOWeekYearParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) ISOWeekYearParser_defineProperties(Constructor, staticProps); return Constructor; }

function ISOWeekYearParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) ISOWeekYearParser_setPrototypeOf(subClass, superClass); }

function ISOWeekYearParser_setPrototypeOf(o, p) { ISOWeekYearParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return ISOWeekYearParser_setPrototypeOf(o, p); }

function ISOWeekYearParser_createSuper(Derived) { var hasNativeReflectConstruct = ISOWeekYearParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = ISOWeekYearParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = ISOWeekYearParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return ISOWeekYearParser_possibleConstructorReturn(this, result); }; }

function ISOWeekYearParser_possibleConstructorReturn(self, call) { if (call && (ISOWeekYearParser_typeof(call) === "object" || typeof call === "function")) { return call; } return ISOWeekYearParser_assertThisInitialized(self); }

function ISOWeekYearParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function ISOWeekYearParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ISOWeekYearParser_getPrototypeOf(o) { ISOWeekYearParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return ISOWeekYearParser_getPrototypeOf(o); }

function ISOWeekYearParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



 // ISO week-numbering year

var ISOWeekYearParser = /*#__PURE__*/function (_Parser) {
  ISOWeekYearParser_inherits(ISOWeekYearParser, _Parser);

  var _super = ISOWeekYearParser_createSuper(ISOWeekYearParser);

  function ISOWeekYearParser() {
    var _this;

    ISOWeekYearParser_classCallCheck(this, ISOWeekYearParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    ISOWeekYearParser_defineProperty(ISOWeekYearParser_assertThisInitialized(_this), "priority", 130);

    ISOWeekYearParser_defineProperty(ISOWeekYearParser_assertThisInitialized(_this), "incompatibleTokens", ['G', 'y', 'Y', 'u', 'Q', 'q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']);

    return _this;
  }

  ISOWeekYearParser_createClass(ISOWeekYearParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      if (token === 'R') {
        return parseNDigitsSigned(4, dateString);
      }

      return parseNDigitsSigned(token.length, dateString);
    }
  }, {
    key: "set",
    value: function set(_date, _flags, value) {
      var firstWeekOfYear = new Date(0);
      firstWeekOfYear.setUTCFullYear(value, 0, 4);
      firstWeekOfYear.setUTCHours(0, 0, 0, 0);
      return (0,startOfUTCISOWeek/* default */.Z)(firstWeekOfYear);
    }
  }]);

  return ISOWeekYearParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/ExtendedYearParser.js
function ExtendedYearParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { ExtendedYearParser_typeof = function _typeof(obj) { return typeof obj; }; } else { ExtendedYearParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return ExtendedYearParser_typeof(obj); }

function ExtendedYearParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ExtendedYearParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function ExtendedYearParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) ExtendedYearParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) ExtendedYearParser_defineProperties(Constructor, staticProps); return Constructor; }

function ExtendedYearParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) ExtendedYearParser_setPrototypeOf(subClass, superClass); }

function ExtendedYearParser_setPrototypeOf(o, p) { ExtendedYearParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return ExtendedYearParser_setPrototypeOf(o, p); }

function ExtendedYearParser_createSuper(Derived) { var hasNativeReflectConstruct = ExtendedYearParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = ExtendedYearParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = ExtendedYearParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return ExtendedYearParser_possibleConstructorReturn(this, result); }; }

function ExtendedYearParser_possibleConstructorReturn(self, call) { if (call && (ExtendedYearParser_typeof(call) === "object" || typeof call === "function")) { return call; } return ExtendedYearParser_assertThisInitialized(self); }

function ExtendedYearParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function ExtendedYearParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ExtendedYearParser_getPrototypeOf(o) { ExtendedYearParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return ExtendedYearParser_getPrototypeOf(o); }

function ExtendedYearParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var ExtendedYearParser = /*#__PURE__*/function (_Parser) {
  ExtendedYearParser_inherits(ExtendedYearParser, _Parser);

  var _super = ExtendedYearParser_createSuper(ExtendedYearParser);

  function ExtendedYearParser() {
    var _this;

    ExtendedYearParser_classCallCheck(this, ExtendedYearParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    ExtendedYearParser_defineProperty(ExtendedYearParser_assertThisInitialized(_this), "priority", 130);

    ExtendedYearParser_defineProperty(ExtendedYearParser_assertThisInitialized(_this), "incompatibleTokens", ['G', 'y', 'Y', 'R', 'w', 'I', 'i', 'e', 'c', 't', 'T']);

    return _this;
  }

  ExtendedYearParser_createClass(ExtendedYearParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      if (token === 'u') {
        return parseNDigitsSigned(4, dateString);
      }

      return parseNDigitsSigned(token.length, dateString);
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return ExtendedYearParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/QuarterParser.js
function QuarterParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { QuarterParser_typeof = function _typeof(obj) { return typeof obj; }; } else { QuarterParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return QuarterParser_typeof(obj); }

function QuarterParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function QuarterParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function QuarterParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) QuarterParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) QuarterParser_defineProperties(Constructor, staticProps); return Constructor; }

function QuarterParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) QuarterParser_setPrototypeOf(subClass, superClass); }

function QuarterParser_setPrototypeOf(o, p) { QuarterParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return QuarterParser_setPrototypeOf(o, p); }

function QuarterParser_createSuper(Derived) { var hasNativeReflectConstruct = QuarterParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = QuarterParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = QuarterParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return QuarterParser_possibleConstructorReturn(this, result); }; }

function QuarterParser_possibleConstructorReturn(self, call) { if (call && (QuarterParser_typeof(call) === "object" || typeof call === "function")) { return call; } return QuarterParser_assertThisInitialized(self); }

function QuarterParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function QuarterParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function QuarterParser_getPrototypeOf(o) { QuarterParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return QuarterParser_getPrototypeOf(o); }

function QuarterParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var QuarterParser = /*#__PURE__*/function (_Parser) {
  QuarterParser_inherits(QuarterParser, _Parser);

  var _super = QuarterParser_createSuper(QuarterParser);

  function QuarterParser() {
    var _this;

    QuarterParser_classCallCheck(this, QuarterParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    QuarterParser_defineProperty(QuarterParser_assertThisInitialized(_this), "priority", 120);

    QuarterParser_defineProperty(QuarterParser_assertThisInitialized(_this), "incompatibleTokens", ['Y', 'R', 'q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']);

    return _this;
  }

  QuarterParser_createClass(QuarterParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        // 1, 2, 3, 4
        case 'Q':
        case 'QQ':
          // 01, 02, 03, 04
          return parseNDigits(token.length, dateString);
        // 1st, 2nd, 3rd, 4th

        case 'Qo':
          return match.ordinalNumber(dateString, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4

        case 'QQQ':
          return match.quarter(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.quarter(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)

        case 'QQQQQ':
          return match.quarter(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // 1st quarter, 2nd quarter, ...

        case 'QQQQ':
        default:
          return match.quarter(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.quarter(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.quarter(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 4;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return QuarterParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/StandAloneQuarterParser.js
function StandAloneQuarterParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { StandAloneQuarterParser_typeof = function _typeof(obj) { return typeof obj; }; } else { StandAloneQuarterParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return StandAloneQuarterParser_typeof(obj); }

function StandAloneQuarterParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function StandAloneQuarterParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function StandAloneQuarterParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) StandAloneQuarterParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) StandAloneQuarterParser_defineProperties(Constructor, staticProps); return Constructor; }

function StandAloneQuarterParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) StandAloneQuarterParser_setPrototypeOf(subClass, superClass); }

function StandAloneQuarterParser_setPrototypeOf(o, p) { StandAloneQuarterParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return StandAloneQuarterParser_setPrototypeOf(o, p); }

function StandAloneQuarterParser_createSuper(Derived) { var hasNativeReflectConstruct = StandAloneQuarterParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = StandAloneQuarterParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = StandAloneQuarterParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return StandAloneQuarterParser_possibleConstructorReturn(this, result); }; }

function StandAloneQuarterParser_possibleConstructorReturn(self, call) { if (call && (StandAloneQuarterParser_typeof(call) === "object" || typeof call === "function")) { return call; } return StandAloneQuarterParser_assertThisInitialized(self); }

function StandAloneQuarterParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function StandAloneQuarterParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function StandAloneQuarterParser_getPrototypeOf(o) { StandAloneQuarterParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return StandAloneQuarterParser_getPrototypeOf(o); }

function StandAloneQuarterParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var StandAloneQuarterParser = /*#__PURE__*/function (_Parser) {
  StandAloneQuarterParser_inherits(StandAloneQuarterParser, _Parser);

  var _super = StandAloneQuarterParser_createSuper(StandAloneQuarterParser);

  function StandAloneQuarterParser() {
    var _this;

    StandAloneQuarterParser_classCallCheck(this, StandAloneQuarterParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    StandAloneQuarterParser_defineProperty(StandAloneQuarterParser_assertThisInitialized(_this), "priority", 120);

    StandAloneQuarterParser_defineProperty(StandAloneQuarterParser_assertThisInitialized(_this), "incompatibleTokens", ['Y', 'R', 'Q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']);

    return _this;
  }

  StandAloneQuarterParser_createClass(StandAloneQuarterParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        // 1, 2, 3, 4
        case 'q':
        case 'qq':
          // 01, 02, 03, 04
          return parseNDigits(token.length, dateString);
        // 1st, 2nd, 3rd, 4th

        case 'qo':
          return match.ordinalNumber(dateString, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4

        case 'qqq':
          return match.quarter(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.quarter(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)

        case 'qqqqq':
          return match.quarter(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // 1st quarter, 2nd quarter, ...

        case 'qqqq':
        default:
          return match.quarter(dateString, {
            width: 'wide',
            context: 'standalone'
          }) || match.quarter(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.quarter(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 4;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return StandAloneQuarterParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/MonthParser.js
function MonthParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { MonthParser_typeof = function _typeof(obj) { return typeof obj; }; } else { MonthParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return MonthParser_typeof(obj); }

function MonthParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function MonthParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function MonthParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) MonthParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) MonthParser_defineProperties(Constructor, staticProps); return Constructor; }

function MonthParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) MonthParser_setPrototypeOf(subClass, superClass); }

function MonthParser_setPrototypeOf(o, p) { MonthParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return MonthParser_setPrototypeOf(o, p); }

function MonthParser_createSuper(Derived) { var hasNativeReflectConstruct = MonthParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = MonthParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = MonthParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return MonthParser_possibleConstructorReturn(this, result); }; }

function MonthParser_possibleConstructorReturn(self, call) { if (call && (MonthParser_typeof(call) === "object" || typeof call === "function")) { return call; } return MonthParser_assertThisInitialized(self); }

function MonthParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function MonthParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function MonthParser_getPrototypeOf(o) { MonthParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return MonthParser_getPrototypeOf(o); }

function MonthParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var MonthParser = /*#__PURE__*/function (_Parser) {
  MonthParser_inherits(MonthParser, _Parser);

  var _super = MonthParser_createSuper(MonthParser);

  function MonthParser() {
    var _this;

    MonthParser_classCallCheck(this, MonthParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    MonthParser_defineProperty(MonthParser_assertThisInitialized(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'L', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);

    MonthParser_defineProperty(MonthParser_assertThisInitialized(_this), "priority", 110);

    return _this;
  }

  MonthParser_createClass(MonthParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(value) {
        return value - 1;
      };

      switch (token) {
        // 1, 2, ..., 12
        case 'M':
          return mapValue(parseNumericPattern(numericPatterns.month, dateString), valueCallback);
        // 01, 02, ..., 12

        case 'MM':
          return mapValue(parseNDigits(2, dateString), valueCallback);
        // 1st, 2nd, ..., 12th

        case 'Mo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'month'
          }), valueCallback);
        // Jan, Feb, ..., Dec

        case 'MMM':
          return match.month(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.month(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // J, F, ..., D

        case 'MMMMM':
          return match.month(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // January, February, ..., December

        case 'MMMM':
        default:
          return match.month(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.month(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.month(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 11;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return MonthParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/StandAloneMonthParser.js
function StandAloneMonthParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { StandAloneMonthParser_typeof = function _typeof(obj) { return typeof obj; }; } else { StandAloneMonthParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return StandAloneMonthParser_typeof(obj); }

function StandAloneMonthParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function StandAloneMonthParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function StandAloneMonthParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) StandAloneMonthParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) StandAloneMonthParser_defineProperties(Constructor, staticProps); return Constructor; }

function StandAloneMonthParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) StandAloneMonthParser_setPrototypeOf(subClass, superClass); }

function StandAloneMonthParser_setPrototypeOf(o, p) { StandAloneMonthParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return StandAloneMonthParser_setPrototypeOf(o, p); }

function StandAloneMonthParser_createSuper(Derived) { var hasNativeReflectConstruct = StandAloneMonthParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = StandAloneMonthParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = StandAloneMonthParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return StandAloneMonthParser_possibleConstructorReturn(this, result); }; }

function StandAloneMonthParser_possibleConstructorReturn(self, call) { if (call && (StandAloneMonthParser_typeof(call) === "object" || typeof call === "function")) { return call; } return StandAloneMonthParser_assertThisInitialized(self); }

function StandAloneMonthParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function StandAloneMonthParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function StandAloneMonthParser_getPrototypeOf(o) { StandAloneMonthParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return StandAloneMonthParser_getPrototypeOf(o); }

function StandAloneMonthParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var StandAloneMonthParser = /*#__PURE__*/function (_Parser) {
  StandAloneMonthParser_inherits(StandAloneMonthParser, _Parser);

  var _super = StandAloneMonthParser_createSuper(StandAloneMonthParser);

  function StandAloneMonthParser() {
    var _this;

    StandAloneMonthParser_classCallCheck(this, StandAloneMonthParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    StandAloneMonthParser_defineProperty(StandAloneMonthParser_assertThisInitialized(_this), "priority", 110);

    StandAloneMonthParser_defineProperty(StandAloneMonthParser_assertThisInitialized(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'M', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);

    return _this;
  }

  StandAloneMonthParser_createClass(StandAloneMonthParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(value) {
        return value - 1;
      };

      switch (token) {
        // 1, 2, ..., 12
        case 'L':
          return mapValue(parseNumericPattern(numericPatterns.month, dateString), valueCallback);
        // 01, 02, ..., 12

        case 'LL':
          return mapValue(parseNDigits(2, dateString), valueCallback);
        // 1st, 2nd, ..., 12th

        case 'Lo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'month'
          }), valueCallback);
        // Jan, Feb, ..., Dec

        case 'LLL':
          return match.month(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.month(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // J, F, ..., D

        case 'LLLLL':
          return match.month(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // January, February, ..., December

        case 'LLLL':
        default:
          return match.month(dateString, {
            width: 'wide',
            context: 'standalone'
          }) || match.month(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.month(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 11;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return StandAloneMonthParser;
}(Parser);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getUTCWeek/index.js + 1 modules
var getUTCWeek = __webpack_require__(5230);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/setUTCWeek/index.js




function setUTCWeek(dirtyDate, dirtyWeek, options) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var week = (0,toInteger/* default */.Z)(dirtyWeek);
  var diff = (0,getUTCWeek/* default */.Z)(date, options) - week;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/LocalWeekParser.js
function LocalWeekParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { LocalWeekParser_typeof = function _typeof(obj) { return typeof obj; }; } else { LocalWeekParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return LocalWeekParser_typeof(obj); }

function LocalWeekParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function LocalWeekParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function LocalWeekParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) LocalWeekParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) LocalWeekParser_defineProperties(Constructor, staticProps); return Constructor; }

function LocalWeekParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) LocalWeekParser_setPrototypeOf(subClass, superClass); }

function LocalWeekParser_setPrototypeOf(o, p) { LocalWeekParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return LocalWeekParser_setPrototypeOf(o, p); }

function LocalWeekParser_createSuper(Derived) { var hasNativeReflectConstruct = LocalWeekParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = LocalWeekParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = LocalWeekParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return LocalWeekParser_possibleConstructorReturn(this, result); }; }

function LocalWeekParser_possibleConstructorReturn(self, call) { if (call && (LocalWeekParser_typeof(call) === "object" || typeof call === "function")) { return call; } return LocalWeekParser_assertThisInitialized(self); }

function LocalWeekParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function LocalWeekParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function LocalWeekParser_getPrototypeOf(o) { LocalWeekParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return LocalWeekParser_getPrototypeOf(o); }

function LocalWeekParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





 // Local week of year

var LocalWeekParser = /*#__PURE__*/function (_Parser) {
  LocalWeekParser_inherits(LocalWeekParser, _Parser);

  var _super = LocalWeekParser_createSuper(LocalWeekParser);

  function LocalWeekParser() {
    var _this;

    LocalWeekParser_classCallCheck(this, LocalWeekParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    LocalWeekParser_defineProperty(LocalWeekParser_assertThisInitialized(_this), "priority", 100);

    LocalWeekParser_defineProperty(LocalWeekParser_assertThisInitialized(_this), "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']);

    return _this;
  }

  LocalWeekParser_createClass(LocalWeekParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'w':
          return parseNumericPattern(numericPatterns.week, dateString);

        case 'wo':
          return match.ordinalNumber(dateString, {
            unit: 'week'
          });

        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 53;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value, options) {
      return (0,startOfUTCWeek/* default */.Z)(setUTCWeek(date, value, options), options);
    }
  }]);

  return LocalWeekParser;
}(Parser);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getUTCISOWeek/index.js + 1 modules
var getUTCISOWeek = __webpack_require__(33276);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/setUTCISOWeek/index.js




function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var isoWeek = (0,toInteger/* default */.Z)(dirtyISOWeek);
  var diff = (0,getUTCISOWeek/* default */.Z)(date) - isoWeek;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/ISOWeekParser.js
function ISOWeekParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { ISOWeekParser_typeof = function _typeof(obj) { return typeof obj; }; } else { ISOWeekParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return ISOWeekParser_typeof(obj); }

function ISOWeekParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ISOWeekParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function ISOWeekParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) ISOWeekParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) ISOWeekParser_defineProperties(Constructor, staticProps); return Constructor; }

function ISOWeekParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) ISOWeekParser_setPrototypeOf(subClass, superClass); }

function ISOWeekParser_setPrototypeOf(o, p) { ISOWeekParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return ISOWeekParser_setPrototypeOf(o, p); }

function ISOWeekParser_createSuper(Derived) { var hasNativeReflectConstruct = ISOWeekParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = ISOWeekParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = ISOWeekParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return ISOWeekParser_possibleConstructorReturn(this, result); }; }

function ISOWeekParser_possibleConstructorReturn(self, call) { if (call && (ISOWeekParser_typeof(call) === "object" || typeof call === "function")) { return call; } return ISOWeekParser_assertThisInitialized(self); }

function ISOWeekParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function ISOWeekParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ISOWeekParser_getPrototypeOf(o) { ISOWeekParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return ISOWeekParser_getPrototypeOf(o); }

function ISOWeekParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





 // ISO week of year

var ISOWeekParser = /*#__PURE__*/function (_Parser) {
  ISOWeekParser_inherits(ISOWeekParser, _Parser);

  var _super = ISOWeekParser_createSuper(ISOWeekParser);

  function ISOWeekParser() {
    var _this;

    ISOWeekParser_classCallCheck(this, ISOWeekParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    ISOWeekParser_defineProperty(ISOWeekParser_assertThisInitialized(_this), "priority", 100);

    ISOWeekParser_defineProperty(ISOWeekParser_assertThisInitialized(_this), "incompatibleTokens", ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']);

    return _this;
  }

  ISOWeekParser_createClass(ISOWeekParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'I':
          return parseNumericPattern(numericPatterns.week, dateString);

        case 'Io':
          return match.ordinalNumber(dateString, {
            unit: 'week'
          });

        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 53;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      return (0,startOfUTCISOWeek/* default */.Z)(setUTCISOWeek(date, value));
    }
  }]);

  return ISOWeekParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/DateParser.js
function DateParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { DateParser_typeof = function _typeof(obj) { return typeof obj; }; } else { DateParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return DateParser_typeof(obj); }

function DateParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function DateParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function DateParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) DateParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) DateParser_defineProperties(Constructor, staticProps); return Constructor; }

function DateParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) DateParser_setPrototypeOf(subClass, superClass); }

function DateParser_setPrototypeOf(o, p) { DateParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return DateParser_setPrototypeOf(o, p); }

function DateParser_createSuper(Derived) { var hasNativeReflectConstruct = DateParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = DateParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = DateParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return DateParser_possibleConstructorReturn(this, result); }; }

function DateParser_possibleConstructorReturn(self, call) { if (call && (DateParser_typeof(call) === "object" || typeof call === "function")) { return call; } return DateParser_assertThisInitialized(self); }

function DateParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function DateParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function DateParser_getPrototypeOf(o) { DateParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return DateParser_getPrototypeOf(o); }

function DateParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // Day of the month

var DateParser = /*#__PURE__*/function (_Parser) {
  DateParser_inherits(DateParser, _Parser);

  var _super = DateParser_createSuper(DateParser);

  function DateParser() {
    var _this;

    DateParser_classCallCheck(this, DateParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    DateParser_defineProperty(DateParser_assertThisInitialized(_this), "priority", 90);

    DateParser_defineProperty(DateParser_assertThisInitialized(_this), "subPriority", 1);

    DateParser_defineProperty(DateParser_assertThisInitialized(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);

    return _this;
  }

  DateParser_createClass(DateParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'd':
          return parseNumericPattern(numericPatterns.date, dateString);

        case 'do':
          return match.ordinalNumber(dateString, {
            unit: 'date'
          });

        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(date, value) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex(year);
      var month = date.getUTCMonth();

      if (isLeapYear) {
        return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
      } else {
        return value >= 1 && value <= DAYS_IN_MONTH[month];
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCDate(value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return DateParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/DayOfYearParser.js
function DayOfYearParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { DayOfYearParser_typeof = function _typeof(obj) { return typeof obj; }; } else { DayOfYearParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return DayOfYearParser_typeof(obj); }

function DayOfYearParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function DayOfYearParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function DayOfYearParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) DayOfYearParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) DayOfYearParser_defineProperties(Constructor, staticProps); return Constructor; }

function DayOfYearParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) DayOfYearParser_setPrototypeOf(subClass, superClass); }

function DayOfYearParser_setPrototypeOf(o, p) { DayOfYearParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return DayOfYearParser_setPrototypeOf(o, p); }

function DayOfYearParser_createSuper(Derived) { var hasNativeReflectConstruct = DayOfYearParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = DayOfYearParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = DayOfYearParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return DayOfYearParser_possibleConstructorReturn(this, result); }; }

function DayOfYearParser_possibleConstructorReturn(self, call) { if (call && (DayOfYearParser_typeof(call) === "object" || typeof call === "function")) { return call; } return DayOfYearParser_assertThisInitialized(self); }

function DayOfYearParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function DayOfYearParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function DayOfYearParser_getPrototypeOf(o) { DayOfYearParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return DayOfYearParser_getPrototypeOf(o); }

function DayOfYearParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var DayOfYearParser = /*#__PURE__*/function (_Parser) {
  DayOfYearParser_inherits(DayOfYearParser, _Parser);

  var _super = DayOfYearParser_createSuper(DayOfYearParser);

  function DayOfYearParser() {
    var _this;

    DayOfYearParser_classCallCheck(this, DayOfYearParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    DayOfYearParser_defineProperty(DayOfYearParser_assertThisInitialized(_this), "priority", 90);

    DayOfYearParser_defineProperty(DayOfYearParser_assertThisInitialized(_this), "subpriority", 1);

    DayOfYearParser_defineProperty(DayOfYearParser_assertThisInitialized(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'M', 'L', 'w', 'I', 'd', 'E', 'i', 'e', 'c', 't', 'T']);

    return _this;
  }

  DayOfYearParser_createClass(DayOfYearParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'D':
        case 'DD':
          return parseNumericPattern(numericPatterns.dayOfYear, dateString);

        case 'Do':
          return match.ordinalNumber(dateString, {
            unit: 'date'
          });

        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(date, value) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex(year);

      if (isLeapYear) {
        return value >= 1 && value <= 366;
      } else {
        return value >= 1 && value <= 365;
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth(0, value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return DayOfYearParser;
}(Parser);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/defaultOptions/index.js
var _lib_defaultOptions = __webpack_require__(84314);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/setUTCDay/index.js




function setUTCDay(dirtyDate, dirtyDay, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

  (0,requiredArgs/* default */.Z)(2, arguments);
  var defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  var weekStartsOn = (0,toInteger/* default */.Z)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = (0,toDate/* default */.Z)(dirtyDate);
  var day = (0,toInteger/* default */.Z)(dirtyDay);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/DayParser.js
function DayParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { DayParser_typeof = function _typeof(obj) { return typeof obj; }; } else { DayParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return DayParser_typeof(obj); }

function DayParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function DayParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function DayParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) DayParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) DayParser_defineProperties(Constructor, staticProps); return Constructor; }

function DayParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) DayParser_setPrototypeOf(subClass, superClass); }

function DayParser_setPrototypeOf(o, p) { DayParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return DayParser_setPrototypeOf(o, p); }

function DayParser_createSuper(Derived) { var hasNativeReflectConstruct = DayParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = DayParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = DayParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return DayParser_possibleConstructorReturn(this, result); }; }

function DayParser_possibleConstructorReturn(self, call) { if (call && (DayParser_typeof(call) === "object" || typeof call === "function")) { return call; } return DayParser_assertThisInitialized(self); }

function DayParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function DayParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function DayParser_getPrototypeOf(o) { DayParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return DayParser_getPrototypeOf(o); }

function DayParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


 // Day of week

var DayParser = /*#__PURE__*/function (_Parser) {
  DayParser_inherits(DayParser, _Parser);

  var _super = DayParser_createSuper(DayParser);

  function DayParser() {
    var _this;

    DayParser_classCallCheck(this, DayParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    DayParser_defineProperty(DayParser_assertThisInitialized(_this), "priority", 90);

    DayParser_defineProperty(DayParser_assertThisInitialized(_this), "incompatibleTokens", ['D', 'i', 'e', 'c', 't', 'T']);

    return _this;
  }

  DayParser_createClass(DayParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        // Tue
        case 'E':
        case 'EE':
        case 'EEE':
          return match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // T

        case 'EEEEE':
          return match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu

        case 'EEEEEE':
          return match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tuesday

        case 'EEEE':
        default:
          return match.day(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 6;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return DayParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/LocalDayParser.js
function LocalDayParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { LocalDayParser_typeof = function _typeof(obj) { return typeof obj; }; } else { LocalDayParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return LocalDayParser_typeof(obj); }

function LocalDayParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function LocalDayParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function LocalDayParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) LocalDayParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) LocalDayParser_defineProperties(Constructor, staticProps); return Constructor; }

function LocalDayParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) LocalDayParser_setPrototypeOf(subClass, superClass); }

function LocalDayParser_setPrototypeOf(o, p) { LocalDayParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return LocalDayParser_setPrototypeOf(o, p); }

function LocalDayParser_createSuper(Derived) { var hasNativeReflectConstruct = LocalDayParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = LocalDayParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = LocalDayParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return LocalDayParser_possibleConstructorReturn(this, result); }; }

function LocalDayParser_possibleConstructorReturn(self, call) { if (call && (LocalDayParser_typeof(call) === "object" || typeof call === "function")) { return call; } return LocalDayParser_assertThisInitialized(self); }

function LocalDayParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function LocalDayParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function LocalDayParser_getPrototypeOf(o) { LocalDayParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return LocalDayParser_getPrototypeOf(o); }

function LocalDayParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



 // Local day of week

var LocalDayParser = /*#__PURE__*/function (_Parser) {
  LocalDayParser_inherits(LocalDayParser, _Parser);

  var _super = LocalDayParser_createSuper(LocalDayParser);

  function LocalDayParser() {
    var _this;

    LocalDayParser_classCallCheck(this, LocalDayParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    LocalDayParser_defineProperty(LocalDayParser_assertThisInitialized(_this), "priority", 90);

    LocalDayParser_defineProperty(LocalDayParser_assertThisInitialized(_this), "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'c', 't', 'T']);

    return _this;
  }

  LocalDayParser_createClass(LocalDayParser, [{
    key: "parse",
    value: function parse(dateString, token, match, options) {
      var valueCallback = function valueCallback(value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };

      switch (token) {
        // 3
        case 'e':
        case 'ee':
          // 03
          return mapValue(parseNDigits(token.length, dateString), valueCallback);
        // 3rd

        case 'eo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'day'
          }), valueCallback);
        // Tue

        case 'eee':
          return match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // T

        case 'eeeee':
          return match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu

        case 'eeeeee':
          return match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tuesday

        case 'eeee':
        default:
          return match.day(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 6;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return LocalDayParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/StandAloneLocalDayParser.js
function StandAloneLocalDayParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { StandAloneLocalDayParser_typeof = function _typeof(obj) { return typeof obj; }; } else { StandAloneLocalDayParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return StandAloneLocalDayParser_typeof(obj); }

function StandAloneLocalDayParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function StandAloneLocalDayParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function StandAloneLocalDayParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) StandAloneLocalDayParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) StandAloneLocalDayParser_defineProperties(Constructor, staticProps); return Constructor; }

function StandAloneLocalDayParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) StandAloneLocalDayParser_setPrototypeOf(subClass, superClass); }

function StandAloneLocalDayParser_setPrototypeOf(o, p) { StandAloneLocalDayParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return StandAloneLocalDayParser_setPrototypeOf(o, p); }

function StandAloneLocalDayParser_createSuper(Derived) { var hasNativeReflectConstruct = StandAloneLocalDayParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = StandAloneLocalDayParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = StandAloneLocalDayParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return StandAloneLocalDayParser_possibleConstructorReturn(this, result); }; }

function StandAloneLocalDayParser_possibleConstructorReturn(self, call) { if (call && (StandAloneLocalDayParser_typeof(call) === "object" || typeof call === "function")) { return call; } return StandAloneLocalDayParser_assertThisInitialized(self); }

function StandAloneLocalDayParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function StandAloneLocalDayParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function StandAloneLocalDayParser_getPrototypeOf(o) { StandAloneLocalDayParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return StandAloneLocalDayParser_getPrototypeOf(o); }

function StandAloneLocalDayParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



 // Stand-alone local day of week

var StandAloneLocalDayParser = /*#__PURE__*/function (_Parser) {
  StandAloneLocalDayParser_inherits(StandAloneLocalDayParser, _Parser);

  var _super = StandAloneLocalDayParser_createSuper(StandAloneLocalDayParser);

  function StandAloneLocalDayParser() {
    var _this;

    StandAloneLocalDayParser_classCallCheck(this, StandAloneLocalDayParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    StandAloneLocalDayParser_defineProperty(StandAloneLocalDayParser_assertThisInitialized(_this), "priority", 90);

    StandAloneLocalDayParser_defineProperty(StandAloneLocalDayParser_assertThisInitialized(_this), "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'e', 't', 'T']);

    return _this;
  }

  StandAloneLocalDayParser_createClass(StandAloneLocalDayParser, [{
    key: "parse",
    value: function parse(dateString, token, match, options) {
      var valueCallback = function valueCallback(value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };

      switch (token) {
        // 3
        case 'c':
        case 'cc':
          // 03
          return mapValue(parseNDigits(token.length, dateString), valueCallback);
        // 3rd

        case 'co':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'day'
          }), valueCallback);
        // Tue

        case 'ccc':
          return match.day(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'short',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // T

        case 'ccccc':
          return match.day(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // Tu

        case 'cccccc':
          return match.day(dateString, {
            width: 'short',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // Tuesday

        case 'cccc':
        default:
          return match.day(dateString, {
            width: 'wide',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'short',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 6;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return StandAloneLocalDayParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/setUTCISODay/index.js



function setUTCISODay(dirtyDate, dirtyDay) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var day = (0,toInteger/* default */.Z)(dirtyDay);

  if (day % 7 === 0) {
    day = day - 7;
  }

  var weekStartsOn = 1;
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/ISODayParser.js
function ISODayParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { ISODayParser_typeof = function _typeof(obj) { return typeof obj; }; } else { ISODayParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return ISODayParser_typeof(obj); }

function ISODayParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ISODayParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function ISODayParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) ISODayParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) ISODayParser_defineProperties(Constructor, staticProps); return Constructor; }

function ISODayParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) ISODayParser_setPrototypeOf(subClass, superClass); }

function ISODayParser_setPrototypeOf(o, p) { ISODayParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return ISODayParser_setPrototypeOf(o, p); }

function ISODayParser_createSuper(Derived) { var hasNativeReflectConstruct = ISODayParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = ISODayParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = ISODayParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return ISODayParser_possibleConstructorReturn(this, result); }; }

function ISODayParser_possibleConstructorReturn(self, call) { if (call && (ISODayParser_typeof(call) === "object" || typeof call === "function")) { return call; } return ISODayParser_assertThisInitialized(self); }

function ISODayParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function ISODayParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ISODayParser_getPrototypeOf(o) { ISODayParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return ISODayParser_getPrototypeOf(o); }

function ISODayParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



 // ISO day of week

var ISODayParser = /*#__PURE__*/function (_Parser) {
  ISODayParser_inherits(ISODayParser, _Parser);

  var _super = ISODayParser_createSuper(ISODayParser);

  function ISODayParser() {
    var _this;

    ISODayParser_classCallCheck(this, ISODayParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    ISODayParser_defineProperty(ISODayParser_assertThisInitialized(_this), "priority", 90);

    ISODayParser_defineProperty(ISODayParser_assertThisInitialized(_this), "incompatibleTokens", ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'E', 'e', 'c', 't', 'T']);

    return _this;
  }

  ISODayParser_createClass(ISODayParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(value) {
        if (value === 0) {
          return 7;
        }

        return value;
      };

      switch (token) {
        // 2
        case 'i':
        case 'ii':
          // 02
          return parseNDigits(token.length, dateString);
        // 2nd

        case 'io':
          return match.ordinalNumber(dateString, {
            unit: 'day'
          });
        // Tue

        case 'iii':
          return mapValue(match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          }), valueCallback);
        // T

        case 'iiiii':
          return mapValue(match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          }), valueCallback);
        // Tu

        case 'iiiiii':
          return mapValue(match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          }), valueCallback);
        // Tuesday

        case 'iiii':
        default:
          return mapValue(match.day(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          }), valueCallback);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 7;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date = setUTCISODay(date, value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return ISODayParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/AMPMParser.js
function AMPMParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { AMPMParser_typeof = function _typeof(obj) { return typeof obj; }; } else { AMPMParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return AMPMParser_typeof(obj); }

function AMPMParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function AMPMParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function AMPMParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) AMPMParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) AMPMParser_defineProperties(Constructor, staticProps); return Constructor; }

function AMPMParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) AMPMParser_setPrototypeOf(subClass, superClass); }

function AMPMParser_setPrototypeOf(o, p) { AMPMParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return AMPMParser_setPrototypeOf(o, p); }

function AMPMParser_createSuper(Derived) { var hasNativeReflectConstruct = AMPMParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = AMPMParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = AMPMParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return AMPMParser_possibleConstructorReturn(this, result); }; }

function AMPMParser_possibleConstructorReturn(self, call) { if (call && (AMPMParser_typeof(call) === "object" || typeof call === "function")) { return call; } return AMPMParser_assertThisInitialized(self); }

function AMPMParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function AMPMParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function AMPMParser_getPrototypeOf(o) { AMPMParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return AMPMParser_getPrototypeOf(o); }

function AMPMParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var AMPMParser = /*#__PURE__*/function (_Parser) {
  AMPMParser_inherits(AMPMParser, _Parser);

  var _super = AMPMParser_createSuper(AMPMParser);

  function AMPMParser() {
    var _this;

    AMPMParser_classCallCheck(this, AMPMParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    AMPMParser_defineProperty(AMPMParser_assertThisInitialized(_this), "priority", 80);

    AMPMParser_defineProperty(AMPMParser_assertThisInitialized(_this), "incompatibleTokens", ['b', 'B', 'H', 'k', 't', 'T']);

    return _this;
  }

  AMPMParser_createClass(AMPMParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'a':
        case 'aa':
        case 'aaa':
          return match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'aaaaa':
          return match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'aaaa':
        default:
          return match.dayPeriod(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    }
  }]);

  return AMPMParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/AMPMMidnightParser.js
function AMPMMidnightParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { AMPMMidnightParser_typeof = function _typeof(obj) { return typeof obj; }; } else { AMPMMidnightParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return AMPMMidnightParser_typeof(obj); }

function AMPMMidnightParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function AMPMMidnightParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function AMPMMidnightParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) AMPMMidnightParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) AMPMMidnightParser_defineProperties(Constructor, staticProps); return Constructor; }

function AMPMMidnightParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) AMPMMidnightParser_setPrototypeOf(subClass, superClass); }

function AMPMMidnightParser_setPrototypeOf(o, p) { AMPMMidnightParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return AMPMMidnightParser_setPrototypeOf(o, p); }

function AMPMMidnightParser_createSuper(Derived) { var hasNativeReflectConstruct = AMPMMidnightParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = AMPMMidnightParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = AMPMMidnightParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return AMPMMidnightParser_possibleConstructorReturn(this, result); }; }

function AMPMMidnightParser_possibleConstructorReturn(self, call) { if (call && (AMPMMidnightParser_typeof(call) === "object" || typeof call === "function")) { return call; } return AMPMMidnightParser_assertThisInitialized(self); }

function AMPMMidnightParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function AMPMMidnightParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function AMPMMidnightParser_getPrototypeOf(o) { AMPMMidnightParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return AMPMMidnightParser_getPrototypeOf(o); }

function AMPMMidnightParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var AMPMMidnightParser = /*#__PURE__*/function (_Parser) {
  AMPMMidnightParser_inherits(AMPMMidnightParser, _Parser);

  var _super = AMPMMidnightParser_createSuper(AMPMMidnightParser);

  function AMPMMidnightParser() {
    var _this;

    AMPMMidnightParser_classCallCheck(this, AMPMMidnightParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    AMPMMidnightParser_defineProperty(AMPMMidnightParser_assertThisInitialized(_this), "priority", 80);

    AMPMMidnightParser_defineProperty(AMPMMidnightParser_assertThisInitialized(_this), "incompatibleTokens", ['a', 'B', 'H', 'k', 't', 'T']);

    return _this;
  }

  AMPMMidnightParser_createClass(AMPMMidnightParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'b':
        case 'bb':
        case 'bbb':
          return match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'bbbbb':
          return match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'bbbb':
        default:
          return match.dayPeriod(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    }
  }]);

  return AMPMMidnightParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/DayPeriodParser.js
function DayPeriodParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { DayPeriodParser_typeof = function _typeof(obj) { return typeof obj; }; } else { DayPeriodParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return DayPeriodParser_typeof(obj); }

function DayPeriodParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function DayPeriodParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function DayPeriodParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) DayPeriodParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) DayPeriodParser_defineProperties(Constructor, staticProps); return Constructor; }

function DayPeriodParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) DayPeriodParser_setPrototypeOf(subClass, superClass); }

function DayPeriodParser_setPrototypeOf(o, p) { DayPeriodParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return DayPeriodParser_setPrototypeOf(o, p); }

function DayPeriodParser_createSuper(Derived) { var hasNativeReflectConstruct = DayPeriodParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = DayPeriodParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = DayPeriodParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return DayPeriodParser_possibleConstructorReturn(this, result); }; }

function DayPeriodParser_possibleConstructorReturn(self, call) { if (call && (DayPeriodParser_typeof(call) === "object" || typeof call === "function")) { return call; } return DayPeriodParser_assertThisInitialized(self); }

function DayPeriodParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function DayPeriodParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function DayPeriodParser_getPrototypeOf(o) { DayPeriodParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return DayPeriodParser_getPrototypeOf(o); }

function DayPeriodParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


 // in the morning, in the afternoon, in the evening, at night

var DayPeriodParser = /*#__PURE__*/function (_Parser) {
  DayPeriodParser_inherits(DayPeriodParser, _Parser);

  var _super = DayPeriodParser_createSuper(DayPeriodParser);

  function DayPeriodParser() {
    var _this;

    DayPeriodParser_classCallCheck(this, DayPeriodParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    DayPeriodParser_defineProperty(DayPeriodParser_assertThisInitialized(_this), "priority", 80);

    DayPeriodParser_defineProperty(DayPeriodParser_assertThisInitialized(_this), "incompatibleTokens", ['a', 'b', 't', 'T']);

    return _this;
  }

  DayPeriodParser_createClass(DayPeriodParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'B':
        case 'BB':
        case 'BBB':
          return match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'BBBBB':
          return match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'BBBB':
        default:
          return match.dayPeriod(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    }
  }]);

  return DayPeriodParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/Hour1to12Parser.js
function Hour1to12Parser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Hour1to12Parser_typeof = function _typeof(obj) { return typeof obj; }; } else { Hour1to12Parser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Hour1to12Parser_typeof(obj); }

function Hour1to12Parser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Hour1to12Parser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Hour1to12Parser_createClass(Constructor, protoProps, staticProps) { if (protoProps) Hour1to12Parser_defineProperties(Constructor.prototype, protoProps); if (staticProps) Hour1to12Parser_defineProperties(Constructor, staticProps); return Constructor; }

function Hour1to12Parser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) Hour1to12Parser_setPrototypeOf(subClass, superClass); }

function Hour1to12Parser_setPrototypeOf(o, p) { Hour1to12Parser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return Hour1to12Parser_setPrototypeOf(o, p); }

function Hour1to12Parser_createSuper(Derived) { var hasNativeReflectConstruct = Hour1to12Parser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Hour1to12Parser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Hour1to12Parser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Hour1to12Parser_possibleConstructorReturn(this, result); }; }

function Hour1to12Parser_possibleConstructorReturn(self, call) { if (call && (Hour1to12Parser_typeof(call) === "object" || typeof call === "function")) { return call; } return Hour1to12Parser_assertThisInitialized(self); }

function Hour1to12Parser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Hour1to12Parser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function Hour1to12Parser_getPrototypeOf(o) { Hour1to12Parser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return Hour1to12Parser_getPrototypeOf(o); }

function Hour1to12Parser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var Hour1to12Parser = /*#__PURE__*/function (_Parser) {
  Hour1to12Parser_inherits(Hour1to12Parser, _Parser);

  var _super = Hour1to12Parser_createSuper(Hour1to12Parser);

  function Hour1to12Parser() {
    var _this;

    Hour1to12Parser_classCallCheck(this, Hour1to12Parser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Hour1to12Parser_defineProperty(Hour1to12Parser_assertThisInitialized(_this), "priority", 70);

    Hour1to12Parser_defineProperty(Hour1to12Parser_assertThisInitialized(_this), "incompatibleTokens", ['H', 'K', 'k', 't', 'T']);

    return _this;
  }

  Hour1to12Parser_createClass(Hour1to12Parser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'h':
          return parseNumericPattern(numericPatterns.hour12h, dateString);

        case 'ho':
          return match.ordinalNumber(dateString, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 12;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      var isPM = date.getUTCHours() >= 12;

      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else if (!isPM && value === 12) {
        date.setUTCHours(0, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }

      return date;
    }
  }]);

  return Hour1to12Parser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/Hour0to23Parser.js
function Hour0to23Parser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Hour0to23Parser_typeof = function _typeof(obj) { return typeof obj; }; } else { Hour0to23Parser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Hour0to23Parser_typeof(obj); }

function Hour0to23Parser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Hour0to23Parser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Hour0to23Parser_createClass(Constructor, protoProps, staticProps) { if (protoProps) Hour0to23Parser_defineProperties(Constructor.prototype, protoProps); if (staticProps) Hour0to23Parser_defineProperties(Constructor, staticProps); return Constructor; }

function Hour0to23Parser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) Hour0to23Parser_setPrototypeOf(subClass, superClass); }

function Hour0to23Parser_setPrototypeOf(o, p) { Hour0to23Parser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return Hour0to23Parser_setPrototypeOf(o, p); }

function Hour0to23Parser_createSuper(Derived) { var hasNativeReflectConstruct = Hour0to23Parser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Hour0to23Parser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Hour0to23Parser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Hour0to23Parser_possibleConstructorReturn(this, result); }; }

function Hour0to23Parser_possibleConstructorReturn(self, call) { if (call && (Hour0to23Parser_typeof(call) === "object" || typeof call === "function")) { return call; } return Hour0to23Parser_assertThisInitialized(self); }

function Hour0to23Parser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Hour0to23Parser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function Hour0to23Parser_getPrototypeOf(o) { Hour0to23Parser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return Hour0to23Parser_getPrototypeOf(o); }

function Hour0to23Parser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var Hour0to23Parser = /*#__PURE__*/function (_Parser) {
  Hour0to23Parser_inherits(Hour0to23Parser, _Parser);

  var _super = Hour0to23Parser_createSuper(Hour0to23Parser);

  function Hour0to23Parser() {
    var _this;

    Hour0to23Parser_classCallCheck(this, Hour0to23Parser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Hour0to23Parser_defineProperty(Hour0to23Parser_assertThisInitialized(_this), "priority", 70);

    Hour0to23Parser_defineProperty(Hour0to23Parser_assertThisInitialized(_this), "incompatibleTokens", ['a', 'b', 'h', 'K', 'k', 't', 'T']);

    return _this;
  }

  Hour0to23Parser_createClass(Hour0to23Parser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'H':
          return parseNumericPattern(numericPatterns.hour23h, dateString);

        case 'Ho':
          return match.ordinalNumber(dateString, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 23;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCHours(value, 0, 0, 0);
      return date;
    }
  }]);

  return Hour0to23Parser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/Hour0To11Parser.js
function Hour0To11Parser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Hour0To11Parser_typeof = function _typeof(obj) { return typeof obj; }; } else { Hour0To11Parser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Hour0To11Parser_typeof(obj); }

function Hour0To11Parser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Hour0To11Parser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Hour0To11Parser_createClass(Constructor, protoProps, staticProps) { if (protoProps) Hour0To11Parser_defineProperties(Constructor.prototype, protoProps); if (staticProps) Hour0To11Parser_defineProperties(Constructor, staticProps); return Constructor; }

function Hour0To11Parser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) Hour0To11Parser_setPrototypeOf(subClass, superClass); }

function Hour0To11Parser_setPrototypeOf(o, p) { Hour0To11Parser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return Hour0To11Parser_setPrototypeOf(o, p); }

function Hour0To11Parser_createSuper(Derived) { var hasNativeReflectConstruct = Hour0To11Parser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Hour0To11Parser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Hour0To11Parser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Hour0To11Parser_possibleConstructorReturn(this, result); }; }

function Hour0To11Parser_possibleConstructorReturn(self, call) { if (call && (Hour0To11Parser_typeof(call) === "object" || typeof call === "function")) { return call; } return Hour0To11Parser_assertThisInitialized(self); }

function Hour0To11Parser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Hour0To11Parser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function Hour0To11Parser_getPrototypeOf(o) { Hour0To11Parser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return Hour0To11Parser_getPrototypeOf(o); }

function Hour0To11Parser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var Hour0To11Parser = /*#__PURE__*/function (_Parser) {
  Hour0To11Parser_inherits(Hour0To11Parser, _Parser);

  var _super = Hour0To11Parser_createSuper(Hour0To11Parser);

  function Hour0To11Parser() {
    var _this;

    Hour0To11Parser_classCallCheck(this, Hour0To11Parser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Hour0To11Parser_defineProperty(Hour0To11Parser_assertThisInitialized(_this), "priority", 70);

    Hour0To11Parser_defineProperty(Hour0To11Parser_assertThisInitialized(_this), "incompatibleTokens", ['h', 'H', 'k', 't', 'T']);

    return _this;
  }

  Hour0To11Parser_createClass(Hour0To11Parser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'K':
          return parseNumericPattern(numericPatterns.hour11h, dateString);

        case 'Ko':
          return match.ordinalNumber(dateString, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 11;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      var isPM = date.getUTCHours() >= 12;

      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }

      return date;
    }
  }]);

  return Hour0To11Parser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/Hour1To24Parser.js
function Hour1To24Parser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Hour1To24Parser_typeof = function _typeof(obj) { return typeof obj; }; } else { Hour1To24Parser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Hour1To24Parser_typeof(obj); }

function Hour1To24Parser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Hour1To24Parser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Hour1To24Parser_createClass(Constructor, protoProps, staticProps) { if (protoProps) Hour1To24Parser_defineProperties(Constructor.prototype, protoProps); if (staticProps) Hour1To24Parser_defineProperties(Constructor, staticProps); return Constructor; }

function Hour1To24Parser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) Hour1To24Parser_setPrototypeOf(subClass, superClass); }

function Hour1To24Parser_setPrototypeOf(o, p) { Hour1To24Parser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return Hour1To24Parser_setPrototypeOf(o, p); }

function Hour1To24Parser_createSuper(Derived) { var hasNativeReflectConstruct = Hour1To24Parser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Hour1To24Parser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Hour1To24Parser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Hour1To24Parser_possibleConstructorReturn(this, result); }; }

function Hour1To24Parser_possibleConstructorReturn(self, call) { if (call && (Hour1To24Parser_typeof(call) === "object" || typeof call === "function")) { return call; } return Hour1To24Parser_assertThisInitialized(self); }

function Hour1To24Parser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Hour1To24Parser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function Hour1To24Parser_getPrototypeOf(o) { Hour1To24Parser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return Hour1To24Parser_getPrototypeOf(o); }

function Hour1To24Parser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var Hour1To24Parser = /*#__PURE__*/function (_Parser) {
  Hour1To24Parser_inherits(Hour1To24Parser, _Parser);

  var _super = Hour1To24Parser_createSuper(Hour1To24Parser);

  function Hour1To24Parser() {
    var _this;

    Hour1To24Parser_classCallCheck(this, Hour1To24Parser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Hour1To24Parser_defineProperty(Hour1To24Parser_assertThisInitialized(_this), "priority", 70);

    Hour1To24Parser_defineProperty(Hour1To24Parser_assertThisInitialized(_this), "incompatibleTokens", ['a', 'b', 'h', 'H', 'K', 't', 'T']);

    return _this;
  }

  Hour1To24Parser_createClass(Hour1To24Parser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'k':
          return parseNumericPattern(numericPatterns.hour24h, dateString);

        case 'ko':
          return match.ordinalNumber(dateString, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 24;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      var hours = value <= 24 ? value % 24 : value;
      date.setUTCHours(hours, 0, 0, 0);
      return date;
    }
  }]);

  return Hour1To24Parser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/MinuteParser.js
function MinuteParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { MinuteParser_typeof = function _typeof(obj) { return typeof obj; }; } else { MinuteParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return MinuteParser_typeof(obj); }

function MinuteParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function MinuteParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function MinuteParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) MinuteParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) MinuteParser_defineProperties(Constructor, staticProps); return Constructor; }

function MinuteParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) MinuteParser_setPrototypeOf(subClass, superClass); }

function MinuteParser_setPrototypeOf(o, p) { MinuteParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return MinuteParser_setPrototypeOf(o, p); }

function MinuteParser_createSuper(Derived) { var hasNativeReflectConstruct = MinuteParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = MinuteParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = MinuteParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return MinuteParser_possibleConstructorReturn(this, result); }; }

function MinuteParser_possibleConstructorReturn(self, call) { if (call && (MinuteParser_typeof(call) === "object" || typeof call === "function")) { return call; } return MinuteParser_assertThisInitialized(self); }

function MinuteParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function MinuteParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function MinuteParser_getPrototypeOf(o) { MinuteParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return MinuteParser_getPrototypeOf(o); }

function MinuteParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var MinuteParser = /*#__PURE__*/function (_Parser) {
  MinuteParser_inherits(MinuteParser, _Parser);

  var _super = MinuteParser_createSuper(MinuteParser);

  function MinuteParser() {
    var _this;

    MinuteParser_classCallCheck(this, MinuteParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    MinuteParser_defineProperty(MinuteParser_assertThisInitialized(_this), "priority", 60);

    MinuteParser_defineProperty(MinuteParser_assertThisInitialized(_this), "incompatibleTokens", ['t', 'T']);

    return _this;
  }

  MinuteParser_createClass(MinuteParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'm':
          return parseNumericPattern(numericPatterns.minute, dateString);

        case 'mo':
          return match.ordinalNumber(dateString, {
            unit: 'minute'
          });

        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 59;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMinutes(value, 0, 0);
      return date;
    }
  }]);

  return MinuteParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/SecondParser.js
function SecondParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { SecondParser_typeof = function _typeof(obj) { return typeof obj; }; } else { SecondParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return SecondParser_typeof(obj); }

function SecondParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SecondParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function SecondParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) SecondParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) SecondParser_defineProperties(Constructor, staticProps); return Constructor; }

function SecondParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) SecondParser_setPrototypeOf(subClass, superClass); }

function SecondParser_setPrototypeOf(o, p) { SecondParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return SecondParser_setPrototypeOf(o, p); }

function SecondParser_createSuper(Derived) { var hasNativeReflectConstruct = SecondParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = SecondParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = SecondParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return SecondParser_possibleConstructorReturn(this, result); }; }

function SecondParser_possibleConstructorReturn(self, call) { if (call && (SecondParser_typeof(call) === "object" || typeof call === "function")) { return call; } return SecondParser_assertThisInitialized(self); }

function SecondParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function SecondParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function SecondParser_getPrototypeOf(o) { SecondParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return SecondParser_getPrototypeOf(o); }

function SecondParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var SecondParser = /*#__PURE__*/function (_Parser) {
  SecondParser_inherits(SecondParser, _Parser);

  var _super = SecondParser_createSuper(SecondParser);

  function SecondParser() {
    var _this;

    SecondParser_classCallCheck(this, SecondParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    SecondParser_defineProperty(SecondParser_assertThisInitialized(_this), "priority", 50);

    SecondParser_defineProperty(SecondParser_assertThisInitialized(_this), "incompatibleTokens", ['t', 'T']);

    return _this;
  }

  SecondParser_createClass(SecondParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 's':
          return parseNumericPattern(numericPatterns.second, dateString);

        case 'so':
          return match.ordinalNumber(dateString, {
            unit: 'second'
          });

        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 59;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCSeconds(value, 0);
      return date;
    }
  }]);

  return SecondParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/FractionOfSecondParser.js
function FractionOfSecondParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { FractionOfSecondParser_typeof = function _typeof(obj) { return typeof obj; }; } else { FractionOfSecondParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return FractionOfSecondParser_typeof(obj); }

function FractionOfSecondParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function FractionOfSecondParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function FractionOfSecondParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) FractionOfSecondParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) FractionOfSecondParser_defineProperties(Constructor, staticProps); return Constructor; }

function FractionOfSecondParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) FractionOfSecondParser_setPrototypeOf(subClass, superClass); }

function FractionOfSecondParser_setPrototypeOf(o, p) { FractionOfSecondParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return FractionOfSecondParser_setPrototypeOf(o, p); }

function FractionOfSecondParser_createSuper(Derived) { var hasNativeReflectConstruct = FractionOfSecondParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = FractionOfSecondParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = FractionOfSecondParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return FractionOfSecondParser_possibleConstructorReturn(this, result); }; }

function FractionOfSecondParser_possibleConstructorReturn(self, call) { if (call && (FractionOfSecondParser_typeof(call) === "object" || typeof call === "function")) { return call; } return FractionOfSecondParser_assertThisInitialized(self); }

function FractionOfSecondParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function FractionOfSecondParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function FractionOfSecondParser_getPrototypeOf(o) { FractionOfSecondParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return FractionOfSecondParser_getPrototypeOf(o); }

function FractionOfSecondParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var FractionOfSecondParser = /*#__PURE__*/function (_Parser) {
  FractionOfSecondParser_inherits(FractionOfSecondParser, _Parser);

  var _super = FractionOfSecondParser_createSuper(FractionOfSecondParser);

  function FractionOfSecondParser() {
    var _this;

    FractionOfSecondParser_classCallCheck(this, FractionOfSecondParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    FractionOfSecondParser_defineProperty(FractionOfSecondParser_assertThisInitialized(_this), "priority", 30);

    FractionOfSecondParser_defineProperty(FractionOfSecondParser_assertThisInitialized(_this), "incompatibleTokens", ['t', 'T']);

    return _this;
  }

  FractionOfSecondParser_createClass(FractionOfSecondParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      var valueCallback = function valueCallback(value) {
        return Math.floor(value * Math.pow(10, -token.length + 3));
      };

      return mapValue(parseNDigits(token.length, dateString), valueCallback);
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMilliseconds(value);
      return date;
    }
  }]);

  return FractionOfSecondParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/ISOTimezoneWithZParser.js
function ISOTimezoneWithZParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { ISOTimezoneWithZParser_typeof = function _typeof(obj) { return typeof obj; }; } else { ISOTimezoneWithZParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return ISOTimezoneWithZParser_typeof(obj); }

function ISOTimezoneWithZParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ISOTimezoneWithZParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function ISOTimezoneWithZParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) ISOTimezoneWithZParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) ISOTimezoneWithZParser_defineProperties(Constructor, staticProps); return Constructor; }

function ISOTimezoneWithZParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) ISOTimezoneWithZParser_setPrototypeOf(subClass, superClass); }

function ISOTimezoneWithZParser_setPrototypeOf(o, p) { ISOTimezoneWithZParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return ISOTimezoneWithZParser_setPrototypeOf(o, p); }

function ISOTimezoneWithZParser_createSuper(Derived) { var hasNativeReflectConstruct = ISOTimezoneWithZParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = ISOTimezoneWithZParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = ISOTimezoneWithZParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return ISOTimezoneWithZParser_possibleConstructorReturn(this, result); }; }

function ISOTimezoneWithZParser_possibleConstructorReturn(self, call) { if (call && (ISOTimezoneWithZParser_typeof(call) === "object" || typeof call === "function")) { return call; } return ISOTimezoneWithZParser_assertThisInitialized(self); }

function ISOTimezoneWithZParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function ISOTimezoneWithZParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ISOTimezoneWithZParser_getPrototypeOf(o) { ISOTimezoneWithZParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return ISOTimezoneWithZParser_getPrototypeOf(o); }

function ISOTimezoneWithZParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



 // Timezone (ISO-8601. +00:00 is `'Z'`)

var ISOTimezoneWithZParser = /*#__PURE__*/function (_Parser) {
  ISOTimezoneWithZParser_inherits(ISOTimezoneWithZParser, _Parser);

  var _super = ISOTimezoneWithZParser_createSuper(ISOTimezoneWithZParser);

  function ISOTimezoneWithZParser() {
    var _this;

    ISOTimezoneWithZParser_classCallCheck(this, ISOTimezoneWithZParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    ISOTimezoneWithZParser_defineProperty(ISOTimezoneWithZParser_assertThisInitialized(_this), "priority", 10);

    ISOTimezoneWithZParser_defineProperty(ISOTimezoneWithZParser_assertThisInitialized(_this), "incompatibleTokens", ['t', 'T', 'x']);

    return _this;
  }

  ISOTimezoneWithZParser_createClass(ISOTimezoneWithZParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      switch (token) {
        case 'X':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, dateString);

        case 'XX':
          return parseTimezonePattern(timezonePatterns.basic, dateString);

        case 'XXXX':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, dateString);

        case 'XXXXX':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, dateString);

        case 'XXX':
        default:
          return parseTimezonePattern(timezonePatterns.extended, dateString);
      }
    }
  }, {
    key: "set",
    value: function set(date, flags, value) {
      if (flags.timestampIsSet) {
        return date;
      }

      return new Date(date.getTime() - value);
    }
  }]);

  return ISOTimezoneWithZParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/ISOTimezoneParser.js
function ISOTimezoneParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { ISOTimezoneParser_typeof = function _typeof(obj) { return typeof obj; }; } else { ISOTimezoneParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return ISOTimezoneParser_typeof(obj); }

function ISOTimezoneParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ISOTimezoneParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function ISOTimezoneParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) ISOTimezoneParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) ISOTimezoneParser_defineProperties(Constructor, staticProps); return Constructor; }

function ISOTimezoneParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) ISOTimezoneParser_setPrototypeOf(subClass, superClass); }

function ISOTimezoneParser_setPrototypeOf(o, p) { ISOTimezoneParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return ISOTimezoneParser_setPrototypeOf(o, p); }

function ISOTimezoneParser_createSuper(Derived) { var hasNativeReflectConstruct = ISOTimezoneParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = ISOTimezoneParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = ISOTimezoneParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return ISOTimezoneParser_possibleConstructorReturn(this, result); }; }

function ISOTimezoneParser_possibleConstructorReturn(self, call) { if (call && (ISOTimezoneParser_typeof(call) === "object" || typeof call === "function")) { return call; } return ISOTimezoneParser_assertThisInitialized(self); }

function ISOTimezoneParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function ISOTimezoneParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ISOTimezoneParser_getPrototypeOf(o) { ISOTimezoneParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return ISOTimezoneParser_getPrototypeOf(o); }

function ISOTimezoneParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



 // Timezone (ISO-8601)

var ISOTimezoneParser = /*#__PURE__*/function (_Parser) {
  ISOTimezoneParser_inherits(ISOTimezoneParser, _Parser);

  var _super = ISOTimezoneParser_createSuper(ISOTimezoneParser);

  function ISOTimezoneParser() {
    var _this;

    ISOTimezoneParser_classCallCheck(this, ISOTimezoneParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    ISOTimezoneParser_defineProperty(ISOTimezoneParser_assertThisInitialized(_this), "priority", 10);

    ISOTimezoneParser_defineProperty(ISOTimezoneParser_assertThisInitialized(_this), "incompatibleTokens", ['t', 'T', 'X']);

    return _this;
  }

  ISOTimezoneParser_createClass(ISOTimezoneParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      switch (token) {
        case 'x':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, dateString);

        case 'xx':
          return parseTimezonePattern(timezonePatterns.basic, dateString);

        case 'xxxx':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, dateString);

        case 'xxxxx':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, dateString);

        case 'xxx':
        default:
          return parseTimezonePattern(timezonePatterns.extended, dateString);
      }
    }
  }, {
    key: "set",
    value: function set(date, flags, value) {
      if (flags.timestampIsSet) {
        return date;
      }

      return new Date(date.getTime() - value);
    }
  }]);

  return ISOTimezoneParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/TimestampSecondsParser.js
function TimestampSecondsParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { TimestampSecondsParser_typeof = function _typeof(obj) { return typeof obj; }; } else { TimestampSecondsParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return TimestampSecondsParser_typeof(obj); }

function TimestampSecondsParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function TimestampSecondsParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function TimestampSecondsParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) TimestampSecondsParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) TimestampSecondsParser_defineProperties(Constructor, staticProps); return Constructor; }

function TimestampSecondsParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) TimestampSecondsParser_setPrototypeOf(subClass, superClass); }

function TimestampSecondsParser_setPrototypeOf(o, p) { TimestampSecondsParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return TimestampSecondsParser_setPrototypeOf(o, p); }

function TimestampSecondsParser_createSuper(Derived) { var hasNativeReflectConstruct = TimestampSecondsParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = TimestampSecondsParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = TimestampSecondsParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return TimestampSecondsParser_possibleConstructorReturn(this, result); }; }

function TimestampSecondsParser_possibleConstructorReturn(self, call) { if (call && (TimestampSecondsParser_typeof(call) === "object" || typeof call === "function")) { return call; } return TimestampSecondsParser_assertThisInitialized(self); }

function TimestampSecondsParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function TimestampSecondsParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function TimestampSecondsParser_getPrototypeOf(o) { TimestampSecondsParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return TimestampSecondsParser_getPrototypeOf(o); }

function TimestampSecondsParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var TimestampSecondsParser = /*#__PURE__*/function (_Parser) {
  TimestampSecondsParser_inherits(TimestampSecondsParser, _Parser);

  var _super = TimestampSecondsParser_createSuper(TimestampSecondsParser);

  function TimestampSecondsParser() {
    var _this;

    TimestampSecondsParser_classCallCheck(this, TimestampSecondsParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    TimestampSecondsParser_defineProperty(TimestampSecondsParser_assertThisInitialized(_this), "priority", 40);

    TimestampSecondsParser_defineProperty(TimestampSecondsParser_assertThisInitialized(_this), "incompatibleTokens", '*');

    return _this;
  }

  TimestampSecondsParser_createClass(TimestampSecondsParser, [{
    key: "parse",
    value: function parse(dateString) {
      return parseAnyDigitsSigned(dateString);
    }
  }, {
    key: "set",
    value: function set(_date, _flags, value) {
      return [new Date(value * 1000), {
        timestampIsSet: true
      }];
    }
  }]);

  return TimestampSecondsParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/TimestampMillisecondsParser.js
function TimestampMillisecondsParser_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { TimestampMillisecondsParser_typeof = function _typeof(obj) { return typeof obj; }; } else { TimestampMillisecondsParser_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return TimestampMillisecondsParser_typeof(obj); }

function TimestampMillisecondsParser_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function TimestampMillisecondsParser_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function TimestampMillisecondsParser_createClass(Constructor, protoProps, staticProps) { if (protoProps) TimestampMillisecondsParser_defineProperties(Constructor.prototype, protoProps); if (staticProps) TimestampMillisecondsParser_defineProperties(Constructor, staticProps); return Constructor; }

function TimestampMillisecondsParser_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) TimestampMillisecondsParser_setPrototypeOf(subClass, superClass); }

function TimestampMillisecondsParser_setPrototypeOf(o, p) { TimestampMillisecondsParser_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return TimestampMillisecondsParser_setPrototypeOf(o, p); }

function TimestampMillisecondsParser_createSuper(Derived) { var hasNativeReflectConstruct = TimestampMillisecondsParser_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = TimestampMillisecondsParser_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = TimestampMillisecondsParser_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return TimestampMillisecondsParser_possibleConstructorReturn(this, result); }; }

function TimestampMillisecondsParser_possibleConstructorReturn(self, call) { if (call && (TimestampMillisecondsParser_typeof(call) === "object" || typeof call === "function")) { return call; } return TimestampMillisecondsParser_assertThisInitialized(self); }

function TimestampMillisecondsParser_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function TimestampMillisecondsParser_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function TimestampMillisecondsParser_getPrototypeOf(o) { TimestampMillisecondsParser_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return TimestampMillisecondsParser_getPrototypeOf(o); }

function TimestampMillisecondsParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var TimestampMillisecondsParser = /*#__PURE__*/function (_Parser) {
  TimestampMillisecondsParser_inherits(TimestampMillisecondsParser, _Parser);

  var _super = TimestampMillisecondsParser_createSuper(TimestampMillisecondsParser);

  function TimestampMillisecondsParser() {
    var _this;

    TimestampMillisecondsParser_classCallCheck(this, TimestampMillisecondsParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    TimestampMillisecondsParser_defineProperty(TimestampMillisecondsParser_assertThisInitialized(_this), "priority", 20);

    TimestampMillisecondsParser_defineProperty(TimestampMillisecondsParser_assertThisInitialized(_this), "incompatibleTokens", '*');

    return _this;
  }

  TimestampMillisecondsParser_createClass(TimestampMillisecondsParser, [{
    key: "parse",
    value: function parse(dateString) {
      return parseAnyDigitsSigned(dateString);
    }
  }, {
    key: "set",
    value: function set(_date, _flags, value) {
      return [new Date(value), {
        timestampIsSet: true
      }];
    }
  }]);

  return TimestampMillisecondsParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/index.js































/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
 * |  p  |                                |  P  |                                |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 */

var parsers = {
  G: new EraParser(),
  y: new YearParser(),
  Y: new LocalWeekYearParser(),
  R: new ISOWeekYearParser(),
  u: new ExtendedYearParser(),
  Q: new QuarterParser(),
  q: new StandAloneQuarterParser(),
  M: new MonthParser(),
  L: new StandAloneMonthParser(),
  w: new LocalWeekParser(),
  I: new ISOWeekParser(),
  d: new DateParser(),
  D: new DayOfYearParser(),
  E: new DayParser(),
  e: new LocalDayParser(),
  c: new StandAloneLocalDayParser(),
  i: new ISODayParser(),
  a: new AMPMParser(),
  b: new AMPMMidnightParser(),
  B: new DayPeriodParser(),
  h: new Hour1to12Parser(),
  H: new Hour0to23Parser(),
  K: new Hour0To11Parser(),
  k: new Hour1To24Parser(),
  m: new MinuteParser(),
  s: new SecondParser(),
  S: new FractionOfSecondParser(),
  X: new ISOTimezoneWithZParser(),
  x: new ISOTimezoneParser(),
  t: new TimestampSecondsParser(),
  T: new TimestampMillisecondsParser()
};
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/index.js
function parse_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { parse_typeof = function _typeof(obj) { return typeof obj; }; } else { parse_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return parse_typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }












 // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var notWhitespaceRegExp = /\S/;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name parse
 * @category Common Helpers
 * @summary Parse the date.
 *
 * @description
 * Return the date parsed from string using the given format string.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * parse('23 AM', 'HH a', new Date())
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `parse` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
 *
 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
 *
 *    while `uu` will just assign the year as is:
 *
 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
 *
 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
 *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be assigned to the date in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
 * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
 *
 * `referenceDate` must be passed for correct work of the function.
 * If you're not sure which `referenceDate` to supply, create a new instance of Date:
 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
 * In this case parsing will be done in the context of the current date.
 * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
 * then `Invalid Date` will be returned.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * If parsing failed, `Invalid Date` will be returned.
 * Invalid Date is a Date, whose time value is NaN.
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {String} dateString - the string to parse
 * @param {String} formatString - the string of tokens
 * @param {Date|Number} referenceDate - defines values missing from the parsed dateString
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {Date} the parsed date
 * @throws {TypeError} 3 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} `options.locale` must contain `match` property
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Parse 11 February 2014 from middle-endian format:
 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
 * //=> Tue Feb 11 2014 00:00:00
 *
 * @example
 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
 *   locale: eo
 * })
 * //=> Sun Feb 28 2010 00:00:00
 */

function parse(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;

  (0,requiredArgs/* default */.Z)(3, arguments);
  var dateString = String(dirtyDateString);
  var formatString = String(dirtyFormatString);
  var defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : defaultLocale/* default */.Z;

  if (!locale.match) {
    throw new RangeError('locale must contain match property');
  }

  var firstWeekContainsDate = (0,toInteger/* default */.Z)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var weekStartsOn = (0,toInteger/* default */.Z)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (formatString === '') {
    if (dateString === '') {
      return (0,toDate/* default */.Z)(dirtyReferenceDate);
    } else {
      return new Date(NaN);
    }
  }

  var subFnOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale
  }; // If timezone isn't specified, it will be set to the system timezone

  var setters = [new DateToSystemTimezoneSetter()];
  var tokens = formatString.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter in longFormatters/* default */.Z) {
      var longFormatter = longFormatters/* default */.Z[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }

    return substring;
  }).join('').match(formattingTokensRegExp);
  var usedTokens = [];

  var _iterator = _createForOfIteratorHelper(tokens),
      _step;

  try {
    var _loop = function _loop() {
      var token = _step.value;

      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0,protectedTokens/* isProtectedWeekYearToken */.Do)(token)) {
        (0,protectedTokens/* throwProtectedError */.qp)(token, formatString, dirtyDateString);
      }

      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0,protectedTokens/* isProtectedDayOfYearToken */.Iu)(token)) {
        (0,protectedTokens/* throwProtectedError */.qp)(token, formatString, dirtyDateString);
      }

      var firstCharacter = token[0];
      var parser = parsers[firstCharacter];

      if (parser) {
        var incompatibleTokens = parser.incompatibleTokens;

        if (Array.isArray(incompatibleTokens)) {
          var incompatibleToken = usedTokens.find(function (usedToken) {
            return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
          });

          if (incompatibleToken) {
            throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
          }
        } else if (parser.incompatibleTokens === '*' && usedTokens.length > 0) {
          throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
        }

        usedTokens.push({
          token: firstCharacter,
          fullToken: token
        });
        var parseResult = parser.run(dateString, token, locale.match, subFnOptions);

        if (!parseResult) {
          return {
            v: new Date(NaN)
          };
        }

        setters.push(parseResult.setter);
        dateString = parseResult.rest;
      } else {
        if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
          throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        } // Replace two single quote characters with one single quote character


        if (token === "''") {
          token = "'";
        } else if (firstCharacter === "'") {
          token = cleanEscapedString(token);
        } // Cut token from string, or, if string doesn't match the token, return Invalid Date


        if (dateString.indexOf(token) === 0) {
          dateString = dateString.slice(token.length);
        } else {
          return {
            v: new Date(NaN)
          };
        }
      }
    };

    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _ret = _loop();

      if (parse_typeof(_ret) === "object") return _ret.v;
    } // Check if the remaining input contains something other than whitespace

  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) {
    return new Date(NaN);
  }

  var uniquePrioritySetters = setters.map(function (setter) {
    return setter.priority;
  }).sort(function (a, b) {
    return b - a;
  }).filter(function (priority, index, array) {
    return array.indexOf(priority) === index;
  }).map(function (priority) {
    return setters.filter(function (setter) {
      return setter.priority === priority;
    }).sort(function (a, b) {
      return b.subPriority - a.subPriority;
    });
  }).map(function (setterArray) {
    return setterArray[0];
  });
  var date = (0,toDate/* default */.Z)(dirtyReferenceDate);

  if (isNaN(date.getTime())) {
    return new Date(NaN);
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.


  var utcDate = (0,subMilliseconds/* default */.Z)(date, (0,getTimezoneOffsetInMilliseconds/* default */.Z)(date));
  var flags = {};

  var _iterator2 = _createForOfIteratorHelper(uniquePrioritySetters),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var setter = _step2.value;

      if (!setter.validate(utcDate, subFnOptions)) {
        return new Date(NaN);
      }

      var result = setter.set(utcDate, flags, subFnOptions); // Result is tuple (date, flags)

      if (Array.isArray(result)) {
        utcDate = result[0];
        assign_assign(flags, result[1]); // Result is date
      } else {
        utcDate = result;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return utcDate;
}

function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

/***/ }),

/***/ 23855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ parseISO; }
/* harmony export */ });
/* harmony import */ var _constants_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36948);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83946);



/**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * @param {String} argument - the value to convert
 * @param {Object} [options] - an object with options.
 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * const result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * const result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */

function parseISO(argument, options) {
  var _options$additionalDi;

  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var additionalDigits = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);

  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError('additionalDigits must be 0, 1 or 2');
  }

  if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
    return new Date(NaN);
  }

  var dateStrings = splitDateString(argument);
  var date;

  if (dateStrings.date) {
    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
  }

  if (!date || isNaN(date.getTime())) {
    return new Date(NaN);
  }

  var timestamp = date.getTime();
  var time = 0;
  var offset;

  if (dateStrings.time) {
    time = parseTime(dateStrings.time);

    if (isNaN(time)) {
      return new Date(NaN);
    }
  }

  if (dateStrings.timezone) {
    offset = parseTimezone(dateStrings.timezone);

    if (isNaN(offset)) {
      return new Date(NaN);
    }
  } else {
    var dirtyDate = new Date(timestamp + time); // js parsed string assuming it's in UTC timezone
    // but we need it to be parsed in our timezone
    // so we use utc values to build date in our timezone.
    // Year values from 0 to 99 map to the years 1900 to 1999
    // so set year explicitly with setFullYear.

    var result = new Date(0);
    result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
    result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
    return result;
  }

  return new Date(timestamp + time + offset);
}
var patterns = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
};
var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;

function splitDateString(dateString) {
  var dateStrings = {};
  var array = dateString.split(patterns.dateTimeDelimiter);
  var timeString; // The regex match should only return at maximum two array elements.
  // [date], [time], or [date, time].

  if (array.length > 2) {
    return dateStrings;
  }

  if (/:/.test(array[0])) {
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];

    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
      timeString = dateString.substr(dateStrings.date.length, dateString.length);
    }
  }

  if (timeString) {
    var token = patterns.timezone.exec(timeString);

    if (token) {
      dateStrings.time = timeString.replace(token[1], '');
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }

  return dateStrings;
}

function parseYear(dateString, additionalDigits) {
  var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
  var captures = dateString.match(regex); // Invalid ISO-formatted year

  if (!captures) return {
    year: NaN,
    restDateString: ''
  };
  var year = captures[1] ? parseInt(captures[1]) : null;
  var century = captures[2] ? parseInt(captures[2]) : null; // either year or century is null, not both

  return {
    year: century === null ? year : century * 100,
    restDateString: dateString.slice((captures[1] || captures[2]).length)
  };
}

function parseDate(dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) return new Date(NaN);
  var captures = dateString.match(dateRegex); // Invalid ISO-formatted string

  if (!captures) return new Date(NaN);
  var isWeekDate = !!captures[4];
  var dayOfYear = parseDateUnit(captures[1]);
  var month = parseDateUnit(captures[2]) - 1;
  var day = parseDateUnit(captures[3]);
  var week = parseDateUnit(captures[4]);
  var dayOfWeek = parseDateUnit(captures[5]) - 1;

  if (isWeekDate) {
    if (!validateWeekDate(year, week, dayOfWeek)) {
      return new Date(NaN);
    }

    return dayOfISOWeekYear(year, week, dayOfWeek);
  } else {
    var date = new Date(0);

    if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
      return new Date(NaN);
    }

    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
    return date;
  }
}

function parseDateUnit(value) {
  return value ? parseInt(value) : 1;
}

function parseTime(timeString) {
  var captures = timeString.match(timeRegex);
  if (!captures) return NaN; // Invalid ISO-formatted time

  var hours = parseTimeUnit(captures[1]);
  var minutes = parseTimeUnit(captures[2]);
  var seconds = parseTimeUnit(captures[3]);

  if (!validateTime(hours, minutes, seconds)) {
    return NaN;
  }

  return hours * _constants_index_js__WEBPACK_IMPORTED_MODULE_2__/* .millisecondsInHour */ .vh + minutes * _constants_index_js__WEBPACK_IMPORTED_MODULE_2__/* .millisecondsInMinute */ .yJ + seconds * 1000;
}

function parseTimeUnit(value) {
  return value && parseFloat(value.replace(',', '.')) || 0;
}

function parseTimezone(timezoneString) {
  if (timezoneString === 'Z') return 0;
  var captures = timezoneString.match(timezoneRegex);
  if (!captures) return 0;
  var sign = captures[1] === '+' ? -1 : 1;
  var hours = parseInt(captures[2]);
  var minutes = captures[3] && parseInt(captures[3]) || 0;

  if (!validateTimezone(hours, minutes)) {
    return NaN;
  }

  return sign * (hours * _constants_index_js__WEBPACK_IMPORTED_MODULE_2__/* .millisecondsInHour */ .vh + minutes * _constants_index_js__WEBPACK_IMPORTED_MODULE_2__/* .millisecondsInMinute */ .yJ);
}

function dayOfISOWeekYear(isoWeekYear, week, day) {
  var date = new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
} // Validation functions
// February is null to handle the leap year (using ||)


var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

function validateDate(year, month, date) {
  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
}

function validateDayOfYearDate(year, dayOfYear) {
  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
}

function validateWeekDate(_year, week, day) {
  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}

function validateTime(hours, minutes, seconds) {
  if (hours === 24) {
    return minutes === 0 && seconds === 0;
  }

  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}

function validateTimezone(_hours, minutes) {
  return minutes >= 0 && minutes <= 59;
}

/***/ }),

/***/ 91218:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ subMilliseconds; }
/* harmony export */ });
/* harmony import */ var _addMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51820);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83946);



/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */

function subMilliseconds(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  return (0,_addMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyDate, -amount);
}

/***/ }),

/***/ 19013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ toDate; }
/* harmony export */ });
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }


/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */

function toDate(argument) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var argStr = Object.prototype.toString.call(argument); // Clone the date

  if (argument instanceof Date || _typeof(argument) === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"); // eslint-disable-next-line no-console

      console.warn(new Error().stack);
    }

    return new Date(NaN);
  }
}

/***/ }),

/***/ 44020:
/***/ (function(module) {

"use strict";

var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp(token, 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
	try {
		// Try to decode the entire string first
		return decodeURIComponent(components.join(''));
	} catch (err) {
		// Do nothing
	}

	if (components.length === 1) {
		return components;
	}

	split = split || 1;

	// Split the array in 2 parts
	var left = components.slice(0, split);
	var right = components.slice(split);

	return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode(input) {
	try {
		return decodeURIComponent(input);
	} catch (err) {
		var tokens = input.match(singleMatcher);

		for (var i = 1; i < tokens.length; i++) {
			input = decodeComponents(tokens, i).join('');

			tokens = input.match(singleMatcher);
		}

		return input;
	}
}

function customDecodeURIComponent(input) {
	// Keep track of all the replacements and prefill the map with the `BOM`
	var replaceMap = {
		'%FE%FF': '\uFFFD\uFFFD',
		'%FF%FE': '\uFFFD\uFFFD'
	};

	var match = multiMatcher.exec(input);
	while (match) {
		try {
			// Decode as big chunks as possible
			replaceMap[match[0]] = decodeURIComponent(match[0]);
		} catch (err) {
			var result = decode(match[0]);

			if (result !== match[0]) {
				replaceMap[match[0]] = result;
			}
		}

		match = multiMatcher.exec(input);
	}

	// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
	replaceMap['%C2'] = '\uFFFD';

	var entries = Object.keys(replaceMap);

	for (var i = 0; i < entries.length; i++) {
		// Replace all decoded components
		var key = entries[i];
		input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
	}

	return input;
}

module.exports = function (encodedURI) {
	if (typeof encodedURI !== 'string') {
		throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
	}

	try {
		encodedURI = encodedURI.replace(/\+/g, ' ');

		// Try the built in decoder first
		return decodeURIComponent(encodedURI);
	} catch (err) {
		// Fallback to a more advanced decoder
		return customDecodeURIComponent(encodedURI);
	}
};


/***/ }),

/***/ 72445:
/***/ (function(module) {

"use strict";


/**
 * Used to mark a
 * [React Native `File` substitute]{@link ReactNativeFileSubstitute}
 * in an object tree for [`extractFiles`]{@link extractFiles}. It’s too risky to
 * assume all objects with `uri`, `type` and `name` properties are files to
 * extract.
 * @kind class
 * @name ReactNativeFile
 * @param {ReactNativeFileSubstitute} file A [React Native](https://reactnative.dev) [`File`](https://developer.mozilla.org/en-US/docs/Web/API/File) substitute.
 * @example <caption>Ways to `import`.</caption>
 * ```js
 * import { ReactNativeFile } from 'extract-files';
 * ```
 *
 * ```js
 * import ReactNativeFile from 'extract-files/public/ReactNativeFile.js';
 * ```
 * @example <caption>Ways to `require`.</caption>
 * ```js
 * const { ReactNativeFile } = require('extract-files');
 * ```
 *
 * ```js
 * const ReactNativeFile = require('extract-files/public/ReactNativeFile.js');
 * ```
 * @example <caption>An extractable file in [React Native](https://reactnative.dev).</caption>
 * ```js
 * const file = new ReactNativeFile({
 *   uri: uriFromCameraRoll,
 *   name: 'a.jpg',
 *   type: 'image/jpeg',
 * });
 * ```
 */
module.exports = class ReactNativeFile {
  constructor({ uri, name, type }) {
    this.uri = uri;
    this.name = name;
    this.type = type;
  }
};


/***/ }),

/***/ 40804:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const defaultIsExtractableFile = __webpack_require__(51268);

/**
 * Clones a value, recursively extracting
 * [`File`](https://developer.mozilla.org/en-US/docs/Web/API/File),
 * [`Blob`](https://developer.mozilla.org/en-US/docs/Web/API/Blob) and
 * [`ReactNativeFile`]{@link ReactNativeFile} instances with their
 * [object paths]{@link ObjectPath}, replacing them with `null`.
 * [`FileList`](https://developer.mozilla.org/en-US/docs/Web/API/Filelist) instances
 * are treated as [`File`](https://developer.mozilla.org/en-US/docs/Web/API/File)
 * instance arrays.
 * @kind function
 * @name extractFiles
 * @param {*} value Value (typically an object tree) to extract files from.
 * @param {ObjectPath} [path=''] Prefix for object paths for extracted files.
 * @param {ExtractableFileMatcher} [isExtractableFile=isExtractableFile] The function used to identify extractable files.
 * @returns {ExtractFilesResult} Result.
 * @example <caption>Ways to `import`.</caption>
 * ```js
 * import { extractFiles } from 'extract-files';
 * ```
 *
 * ```js
 * import extractFiles from 'extract-files/public/extractFiles.js';
 * ```
 * @example <caption>Ways to `require`.</caption>
 * ```js
 * const { extractFiles } = require('extract-files');
 * ```
 *
 * ```js
 * const extractFiles = require('extract-files/public/extractFiles.js');
 * ```
 * @example <caption>Extract files from an object.</caption>
 * For the following:
 *
 * ```js
 * const file1 = new File(['1'], '1.txt', { type: 'text/plain' });
 * const file2 = new File(['2'], '2.txt', { type: 'text/plain' });
 * const value = {
 *   a: file1,
 *   b: [file1, file2],
 * };
 *
 * const { clone, files } = extractFiles(value, 'prefix');
 * ```
 *
 * `value` remains the same.
 *
 * `clone` is:
 *
 * ```json
 * {
 *   "a": null,
 *   "b": [null, null]
 * }
 * ```
 *
 * `files` is a [`Map`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map) instance containing:
 *
 * | Key     | Value                        |
 * | :------ | :--------------------------- |
 * | `file1` | `['prefix.a', 'prefix.b.0']` |
 * | `file2` | `['prefix.b.1']`             |
 */
module.exports = function extractFiles(
  value,
  path = '',
  isExtractableFile = defaultIsExtractableFile
) {
  // Map of extracted files and their object paths within the input value.
  const files = new Map();

  // Map of arrays and objects recursed within the input value and their clones,
  // for reusing clones of values that are referenced multiple times within the
  // input value.
  const clones = new Map();

  /**
   * Recursively clones the value, extracting files.
   * @kind function
   * @name extractFiles~recurse
   * @param {*} value Value to extract files from.
   * @param {ObjectPath} path Prefix for object paths for extracted files.
   * @param {Set} recursed Recursed arrays and objects for avoiding infinite recursion of circular references within the input value.
   * @returns {*} Clone of the value with files replaced with `null`.
   * @ignore
   */
  function recurse(value, path, recursed) {
    let clone = value;

    if (isExtractableFile(value)) {
      clone = null;

      const filePaths = files.get(value);

      filePaths ? filePaths.push(path) : files.set(value, [path]);
    } else {
      const isList =
        Array.isArray(value) ||
        (typeof FileList !== 'undefined' && value instanceof FileList);
      const isObject = value && value.constructor === Object;

      if (isList || isObject) {
        const hasClone = clones.has(value);

        if (hasClone) clone = clones.get(value);
        else {
          clone = isList ? [] : {};

          clones.set(value, clone);
        }

        if (!recursed.has(value)) {
          const pathPrefix = path ? `${path}.` : '';
          const recursedDeeper = new Set(recursed).add(value);

          if (isList) {
            let index = 0;

            for (const item of value) {
              const itemClone = recurse(
                item,
                pathPrefix + index++,
                recursedDeeper
              );

              if (!hasClone) clone.push(itemClone);
            }
          } else
            for (const key in value) {
              const propertyClone = recurse(
                value[key],
                pathPrefix + key,
                recursedDeeper
              );

              if (!hasClone) clone[key] = propertyClone;
            }
        }
      }
    }

    return clone;
  }

  return {
    clone: recurse(value, path, new Set()),
    files,
  };
};


/***/ }),

/***/ 51268:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const ReactNativeFile = __webpack_require__(72445);

/**
 * Checks if a value is an [extractable file]{@link ExtractableFile}.
 * @kind function
 * @name isExtractableFile
 * @type {ExtractableFileMatcher}
 * @param {*} value Value to check.
 * @returns {boolean} Is the value an [extractable file]{@link ExtractableFile}.
 * @example <caption>Ways to `import`.</caption>
 * ```js
 * import { isExtractableFile } from 'extract-files';
 * ```
 *
 * ```js
 * import isExtractableFile from 'extract-files/public/isExtractableFile.js';
 * ```
 * @example <caption>Ways to `require`.</caption>
 * ```js
 * const { isExtractableFile } = require('extract-files');
 * ```
 *
 * ```js
 * const isExtractableFile = require('extract-files/public/isExtractableFile.js');
 * ```
 */
module.exports = function isExtractableFile(value) {
  return (
    (typeof File !== 'undefined' && value instanceof File) ||
    (typeof Blob !== 'undefined' && value instanceof Blob) ||
    value instanceof ReactNativeFile
  );
};


/***/ }),

/***/ 12922:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ lib; },
  "J9": function() { return /* binding */ disableExperimentalFragmentVariables; },
  "_t": function() { return /* binding */ disableFragmentWarnings; },
  "wO": function() { return /* binding */ enableExperimentalFragmentVariables; },
  "Ps": function() { return /* binding */ gql; },
  "HW": function() { return /* binding */ resetCaches; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/graphql/jsutils/inspect.mjs
var inspect = __webpack_require__(25821);
// EXTERNAL MODULE: ./node_modules/graphql/jsutils/devAssert.mjs
var devAssert = __webpack_require__(37826);
// EXTERNAL MODULE: ./node_modules/graphql/jsutils/nodejsCustomInspectSymbol.mjs
var nodejsCustomInspectSymbol = __webpack_require__(45695);
;// CONCATENATED MODULE: ./node_modules/graphql/jsutils/defineToJSON.mjs

/**
 * The `defineToJSON()` function defines toJSON() and inspect() prototype
 * methods, if no function provided they become aliases for toString().
 */

function defineToJSON(classObject) {
  var fn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : classObject.prototype.toString;
  classObject.prototype.toJSON = fn;
  classObject.prototype.inspect = fn;

  if (nodejsCustomInspectSymbol/* default */.Z) {
    classObject.prototype[nodejsCustomInspectSymbol/* default */.Z] = fn;
  }
}

;// CONCATENATED MODULE: ./node_modules/graphql/jsutils/isObjectLike.mjs
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Return true if `value` is object-like. A value is object-like if it's not
 * `null` and has a `typeof` result of "object".
 */
function isObjectLike(value) {
  return _typeof(value) == 'object' && value !== null;
}

;// CONCATENATED MODULE: ./node_modules/graphql/language/location.mjs
/**
 * Represents a location in a Source.
 */

/**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */
function getLocation(source, position) {
  var lineRegexp = /\r\n|[\n\r]/g;
  var line = 1;
  var column = position + 1;
  var match;

  while ((match = lineRegexp.exec(source.body)) && match.index < position) {
    line += 1;
    column = position + 1 - (match.index + match[0].length);
  }

  return {
    line: line,
    column: column
  };
}

;// CONCATENATED MODULE: ./node_modules/graphql/language/printLocation.mjs

/**
 * Render a helpful description of the location in the GraphQL Source document.
 */

function printLocation(location) {
  return printSourceLocation(location.source, getLocation(location.source, location.start));
}
/**
 * Render a helpful description of the location in the GraphQL Source document.
 */

function printSourceLocation(source, sourceLocation) {
  var firstLineColumnOffset = source.locationOffset.column - 1;
  var body = whitespace(firstLineColumnOffset) + source.body;
  var lineIndex = sourceLocation.line - 1;
  var lineOffset = source.locationOffset.line - 1;
  var lineNum = sourceLocation.line + lineOffset;
  var columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
  var columnNum = sourceLocation.column + columnOffset;
  var locationStr = "".concat(source.name, ":").concat(lineNum, ":").concat(columnNum, "\n");
  var lines = body.split(/\r\n|[\n\r]/g);
  var locationLine = lines[lineIndex]; // Special case for minified documents

  if (locationLine.length > 120) {
    var sublineIndex = Math.floor(columnNum / 80);
    var sublineColumnNum = columnNum % 80;
    var sublines = [];

    for (var i = 0; i < locationLine.length; i += 80) {
      sublines.push(locationLine.slice(i, i + 80));
    }

    return locationStr + printPrefixedLines([["".concat(lineNum), sublines[0]]].concat(sublines.slice(1, sublineIndex + 1).map(function (subline) {
      return ['', subline];
    }), [[' ', whitespace(sublineColumnNum - 1) + '^'], ['', sublines[sublineIndex + 1]]]));
  }

  return locationStr + printPrefixedLines([// Lines specified like this: ["prefix", "string"],
  ["".concat(lineNum - 1), lines[lineIndex - 1]], ["".concat(lineNum), locationLine], ['', whitespace(columnNum - 1) + '^'], ["".concat(lineNum + 1), lines[lineIndex + 1]]]);
}

function printPrefixedLines(lines) {
  var existingLines = lines.filter(function (_ref) {
    var _ = _ref[0],
        line = _ref[1];
    return line !== undefined;
  });
  var padLen = Math.max.apply(Math, existingLines.map(function (_ref2) {
    var prefix = _ref2[0];
    return prefix.length;
  }));
  return existingLines.map(function (_ref3) {
    var prefix = _ref3[0],
        line = _ref3[1];
    return lpad(padLen, prefix) + (line ? ' | ' + line : ' |');
  }).join('\n');
}

function whitespace(len) {
  return Array(len + 1).join(' ');
}

function lpad(len, str) {
  return whitespace(len - str.length) + str;
}

;// CONCATENATED MODULE: ./node_modules/graphql/error/GraphQLError.mjs



/**
 * A GraphQLError describes an Error found during the parse, validate, or
 * execute phases of performing a GraphQL operation. In addition to a message
 * and stack trace, it also includes information about the locations in a
 * GraphQL document and/or execution result that correspond to the Error.
 */

function GraphQLError( // eslint-disable-line no-redeclare
message, nodes, source, positions, path, originalError, extensions) {
  // Compute list of blame nodes.
  var _nodes = Array.isArray(nodes) ? nodes.length !== 0 ? nodes : undefined : nodes ? [nodes] : undefined; // Compute locations in the source for the given nodes/positions.


  var _source = source;

  if (!_source && _nodes) {
    var node = _nodes[0];
    _source = node && node.loc && node.loc.source;
  }

  var _positions = positions;

  if (!_positions && _nodes) {
    _positions = _nodes.reduce(function (list, node) {
      if (node.loc) {
        list.push(node.loc.start);
      }

      return list;
    }, []);
  }

  if (_positions && _positions.length === 0) {
    _positions = undefined;
  }

  var _locations;

  if (positions && source) {
    _locations = positions.map(function (pos) {
      return getLocation(source, pos);
    });
  } else if (_nodes) {
    _locations = _nodes.reduce(function (list, node) {
      if (node.loc) {
        list.push(getLocation(node.loc.source, node.loc.start));
      }

      return list;
    }, []);
  }

  var _extensions = extensions;

  if (_extensions == null && originalError != null) {
    var originalExtensions = originalError.extensions;

    if (isObjectLike(originalExtensions)) {
      _extensions = originalExtensions;
    }
  }

  Object.defineProperties(this, {
    message: {
      value: message,
      // By being enumerable, JSON.stringify will include `message` in the
      // resulting output. This ensures that the simplest possible GraphQL
      // service adheres to the spec.
      enumerable: true,
      writable: true
    },
    locations: {
      // Coercing falsey values to undefined ensures they will not be included
      // in JSON.stringify() when not provided.
      value: _locations || undefined,
      // By being enumerable, JSON.stringify will include `locations` in the
      // resulting output. This ensures that the simplest possible GraphQL
      // service adheres to the spec.
      enumerable: Boolean(_locations)
    },
    path: {
      // Coercing falsey values to undefined ensures they will not be included
      // in JSON.stringify() when not provided.
      value: path || undefined,
      // By being enumerable, JSON.stringify will include `path` in the
      // resulting output. This ensures that the simplest possible GraphQL
      // service adheres to the spec.
      enumerable: Boolean(path)
    },
    nodes: {
      value: _nodes || undefined
    },
    source: {
      value: _source || undefined
    },
    positions: {
      value: _positions || undefined
    },
    originalError: {
      value: originalError
    },
    extensions: {
      // Coercing falsey values to undefined ensures they will not be included
      // in JSON.stringify() when not provided.
      value: _extensions || undefined,
      // By being enumerable, JSON.stringify will include `path` in the
      // resulting output. This ensures that the simplest possible GraphQL
      // service adheres to the spec.
      enumerable: Boolean(_extensions)
    }
  }); // Include (non-enumerable) stack trace.

  if (originalError && originalError.stack) {
    Object.defineProperty(this, 'stack', {
      value: originalError.stack,
      writable: true,
      configurable: true
    });
  } else if (Error.captureStackTrace) {
    Error.captureStackTrace(this, GraphQLError);
  } else {
    Object.defineProperty(this, 'stack', {
      value: Error().stack,
      writable: true,
      configurable: true
    });
  }
}
GraphQLError.prototype = Object.create(Error.prototype, {
  constructor: {
    value: GraphQLError
  },
  name: {
    value: 'GraphQLError'
  },
  toString: {
    value: function toString() {
      return printError(this);
    }
  }
});
/**
 * Prints a GraphQLError to a string, representing useful location information
 * about the error's position in the source.
 */

function printError(error) {
  var output = error.message;

  if (error.nodes) {
    for (var _i2 = 0, _error$nodes2 = error.nodes; _i2 < _error$nodes2.length; _i2++) {
      var node = _error$nodes2[_i2];

      if (node.loc) {
        output += '\n\n' + printLocation(node.loc);
      }
    }
  } else if (error.source && error.locations) {
    for (var _i4 = 0, _error$locations2 = error.locations; _i4 < _error$locations2.length; _i4++) {
      var location = _error$locations2[_i4];
      output += '\n\n' + printSourceLocation(error.source, location);
    }
  }

  return output;
}

;// CONCATENATED MODULE: ./node_modules/graphql/error/syntaxError.mjs

/**
 * Produces a GraphQLError representing a syntax error, containing useful
 * descriptive information about the syntax error's position in the source.
 */

function syntaxError(source, position, description) {
  return new GraphQLError("Syntax Error: ".concat(description), undefined, source, [position]);
}

// EXTERNAL MODULE: ./node_modules/graphql/language/kinds.mjs
var kinds = __webpack_require__(97359);
// EXTERNAL MODULE: ./node_modules/graphql/language/source.mjs + 1 modules
var language_source = __webpack_require__(49786);
// EXTERNAL MODULE: ./node_modules/graphql/language/blockString.mjs
var blockString = __webpack_require__(87392);
;// CONCATENATED MODULE: ./node_modules/graphql/language/tokenKind.mjs
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */
var tokenKind_TokenKind = Object.freeze({
  SOF: '<SOF>',
  EOF: '<EOF>',
  BANG: '!',
  DOLLAR: '$',
  AMP: '&',
  PAREN_L: '(',
  PAREN_R: ')',
  SPREAD: '...',
  COLON: ':',
  EQUALS: '=',
  AT: '@',
  BRACKET_L: '[',
  BRACKET_R: ']',
  BRACE_L: '{',
  PIPE: '|',
  BRACE_R: '}',
  NAME: 'Name',
  INT: 'Int',
  FLOAT: 'Float',
  STRING: 'String',
  BLOCK_STRING: 'BlockString',
  COMMENT: 'Comment'
});
/**
 * The enum type representing the token kinds values.
 */

;// CONCATENATED MODULE: ./node_modules/graphql/language/lexer.mjs




/**
 * Given a Source object, this returns a Lexer for that source.
 * A Lexer is a stateful stream generator in that every time
 * it is advanced, it returns the next token in the Source. Assuming the
 * source lexes, the final Token emitted by the lexer will be of kind
 * EOF, after which the lexer will repeatedly return the same EOF token
 * whenever called.
 */

function createLexer(source, options) {
  var startOfFileToken = new Tok(tokenKind_TokenKind.SOF, 0, 0, 0, 0, null);
  var lexer = {
    source: source,
    options: options,
    lastToken: startOfFileToken,
    token: startOfFileToken,
    line: 1,
    lineStart: 0,
    advance: advanceLexer,
    lookahead: lookahead
  };
  return lexer;
}

function advanceLexer() {
  this.lastToken = this.token;
  var token = this.token = this.lookahead();
  return token;
}

function lookahead() {
  var token = this.token;

  if (token.kind !== tokenKind_TokenKind.EOF) {
    do {
      // Note: next is only mutable during parsing, so we cast to allow this.
      token = token.next || (token.next = readToken(this, token));
    } while (token.kind === tokenKind_TokenKind.COMMENT);
  }

  return token;
}
/**
 * The return type of createLexer.
 */


// @internal
function isPunctuatorToken(token) {
  var kind = token.kind;
  return kind === TokenKind.BANG || kind === TokenKind.DOLLAR || kind === TokenKind.AMP || kind === TokenKind.PAREN_L || kind === TokenKind.PAREN_R || kind === TokenKind.SPREAD || kind === TokenKind.COLON || kind === TokenKind.EQUALS || kind === TokenKind.AT || kind === TokenKind.BRACKET_L || kind === TokenKind.BRACKET_R || kind === TokenKind.BRACE_L || kind === TokenKind.PIPE || kind === TokenKind.BRACE_R;
}
/**
 * Helper function for constructing the Token object.
 */

function Tok(kind, start, end, line, column, prev, value) {
  this.kind = kind;
  this.start = start;
  this.end = end;
  this.line = line;
  this.column = column;
  this.value = value;
  this.prev = prev;
  this.next = null;
} // Print a simplified form when appearing in JSON/util.inspect.


defineToJSON(Tok, function () {
  return {
    kind: this.kind,
    value: this.value,
    line: this.line,
    column: this.column
  };
});

function printCharCode(code) {
  return (// NaN/undefined represents access beyond the end of the file.
    isNaN(code) ? tokenKind_TokenKind.EOF : // Trust JSON for ASCII.
    code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : // Otherwise print the escaped form.
    "\"\\u".concat(('00' + code.toString(16).toUpperCase()).slice(-4), "\"")
  );
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */


function readToken(lexer, prev) {
  var source = lexer.source;
  var body = source.body;
  var bodyLength = body.length;
  var pos = positionAfterWhitespace(body, prev.end, lexer);
  var line = lexer.line;
  var col = 1 + pos - lexer.lineStart;

  if (pos >= bodyLength) {
    return new Tok(tokenKind_TokenKind.EOF, bodyLength, bodyLength, line, col, prev);
  }

  var code = body.charCodeAt(pos); // SourceCharacter

  switch (code) {
    // !
    case 33:
      return new Tok(tokenKind_TokenKind.BANG, pos, pos + 1, line, col, prev);
    // #

    case 35:
      return readComment(source, pos, line, col, prev);
    // $

    case 36:
      return new Tok(tokenKind_TokenKind.DOLLAR, pos, pos + 1, line, col, prev);
    // &

    case 38:
      return new Tok(tokenKind_TokenKind.AMP, pos, pos + 1, line, col, prev);
    // (

    case 40:
      return new Tok(tokenKind_TokenKind.PAREN_L, pos, pos + 1, line, col, prev);
    // )

    case 41:
      return new Tok(tokenKind_TokenKind.PAREN_R, pos, pos + 1, line, col, prev);
    // .

    case 46:
      if (body.charCodeAt(pos + 1) === 46 && body.charCodeAt(pos + 2) === 46) {
        return new Tok(tokenKind_TokenKind.SPREAD, pos, pos + 3, line, col, prev);
      }

      break;
    // :

    case 58:
      return new Tok(tokenKind_TokenKind.COLON, pos, pos + 1, line, col, prev);
    // =

    case 61:
      return new Tok(tokenKind_TokenKind.EQUALS, pos, pos + 1, line, col, prev);
    // @

    case 64:
      return new Tok(tokenKind_TokenKind.AT, pos, pos + 1, line, col, prev);
    // [

    case 91:
      return new Tok(tokenKind_TokenKind.BRACKET_L, pos, pos + 1, line, col, prev);
    // ]

    case 93:
      return new Tok(tokenKind_TokenKind.BRACKET_R, pos, pos + 1, line, col, prev);
    // {

    case 123:
      return new Tok(tokenKind_TokenKind.BRACE_L, pos, pos + 1, line, col, prev);
    // |

    case 124:
      return new Tok(tokenKind_TokenKind.PIPE, pos, pos + 1, line, col, prev);
    // }

    case 125:
      return new Tok(tokenKind_TokenKind.BRACE_R, pos, pos + 1, line, col, prev);
    // A-Z _ a-z

    case 65:
    case 66:
    case 67:
    case 68:
    case 69:
    case 70:
    case 71:
    case 72:
    case 73:
    case 74:
    case 75:
    case 76:
    case 77:
    case 78:
    case 79:
    case 80:
    case 81:
    case 82:
    case 83:
    case 84:
    case 85:
    case 86:
    case 87:
    case 88:
    case 89:
    case 90:
    case 95:
    case 97:
    case 98:
    case 99:
    case 100:
    case 101:
    case 102:
    case 103:
    case 104:
    case 105:
    case 106:
    case 107:
    case 108:
    case 109:
    case 110:
    case 111:
    case 112:
    case 113:
    case 114:
    case 115:
    case 116:
    case 117:
    case 118:
    case 119:
    case 120:
    case 121:
    case 122:
      return readName(source, pos, line, col, prev);
    // - 0-9

    case 45:
    case 48:
    case 49:
    case 50:
    case 51:
    case 52:
    case 53:
    case 54:
    case 55:
    case 56:
    case 57:
      return readNumber(source, pos, code, line, col, prev);
    // "

    case 34:
      if (body.charCodeAt(pos + 1) === 34 && body.charCodeAt(pos + 2) === 34) {
        return readBlockString(source, pos, line, col, prev, lexer);
      }

      return readString(source, pos, line, col, prev);
  }

  throw syntaxError(source, pos, unexpectedCharacterMessage(code));
}
/**
 * Report a message that an unexpected character was encountered.
 */


function unexpectedCharacterMessage(code) {
  if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) {
    return "Cannot contain the invalid character ".concat(printCharCode(code), ".");
  }

  if (code === 39) {
    // '
    return 'Unexpected single quote character (\'), did you mean to use a double quote (")?';
  }

  return "Cannot parse the unexpected character ".concat(printCharCode(code), ".");
}
/**
 * Reads from body starting at startPosition until it finds a non-whitespace
 * character, then returns the position of that character for lexing.
 */


function positionAfterWhitespace(body, startPosition, lexer) {
  var bodyLength = body.length;
  var position = startPosition;

  while (position < bodyLength) {
    var code = body.charCodeAt(position); // tab | space | comma | BOM

    if (code === 9 || code === 32 || code === 44 || code === 0xfeff) {
      ++position;
    } else if (code === 10) {
      // new line
      ++position;
      ++lexer.line;
      lexer.lineStart = position;
    } else if (code === 13) {
      // carriage return
      if (body.charCodeAt(position + 1) === 10) {
        position += 2;
      } else {
        ++position;
      }

      ++lexer.line;
      lexer.lineStart = position;
    } else {
      break;
    }
  }

  return position;
}
/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */


function readComment(source, start, line, col, prev) {
  var body = source.body;
  var code;
  var position = start;

  do {
    code = body.charCodeAt(++position);
  } while (!isNaN(code) && ( // SourceCharacter but not LineTerminator
  code > 0x001f || code === 0x0009));

  return new Tok(tokenKind_TokenKind.COMMENT, start, position, line, col, prev, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */


function readNumber(source, start, firstCode, line, col, prev) {
  var body = source.body;
  var code = firstCode;
  var position = start;
  var isFloat = false;

  if (code === 45) {
    // -
    code = body.charCodeAt(++position);
  }

  if (code === 48) {
    // 0
    code = body.charCodeAt(++position);

    if (code >= 48 && code <= 57) {
      throw syntaxError(source, position, "Invalid number, unexpected digit after 0: ".concat(printCharCode(code), "."));
    }
  } else {
    position = readDigits(source, position, code);
    code = body.charCodeAt(position);
  }

  if (code === 46) {
    // .
    isFloat = true;
    code = body.charCodeAt(++position);
    position = readDigits(source, position, code);
    code = body.charCodeAt(position);
  }

  if (code === 69 || code === 101) {
    // E e
    isFloat = true;
    code = body.charCodeAt(++position);

    if (code === 43 || code === 45) {
      // + -
      code = body.charCodeAt(++position);
    }

    position = readDigits(source, position, code);
    code = body.charCodeAt(position);
  } // Numbers cannot be followed by . or e


  if (code === 46 || code === 69 || code === 101) {
    throw syntaxError(source, position, "Invalid number, expected digit but got: ".concat(printCharCode(code), "."));
  }

  return new Tok(isFloat ? tokenKind_TokenKind.FLOAT : tokenKind_TokenKind.INT, start, position, line, col, prev, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading digits.
 */


function readDigits(source, start, firstCode) {
  var body = source.body;
  var position = start;
  var code = firstCode;

  if (code >= 48 && code <= 57) {
    // 0 - 9
    do {
      code = body.charCodeAt(++position);
    } while (code >= 48 && code <= 57); // 0 - 9


    return position;
  }

  throw syntaxError(source, position, "Invalid number, expected digit but got: ".concat(printCharCode(code), "."));
}
/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */


function readString(source, start, line, col, prev) {
  var body = source.body;
  var position = start + 1;
  var chunkStart = position;
  var code = 0;
  var value = '';

  while (position < body.length && !isNaN(code = body.charCodeAt(position)) && // not LineTerminator
  code !== 0x000a && code !== 0x000d) {
    // Closing Quote (")
    if (code === 34) {
      value += body.slice(chunkStart, position);
      return new Tok(tokenKind_TokenKind.STRING, start, position + 1, line, col, prev, value);
    } // SourceCharacter


    if (code < 0x0020 && code !== 0x0009) {
      throw syntaxError(source, position, "Invalid character within String: ".concat(printCharCode(code), "."));
    }

    ++position;

    if (code === 92) {
      // \
      value += body.slice(chunkStart, position - 1);
      code = body.charCodeAt(position);

      switch (code) {
        case 34:
          value += '"';
          break;

        case 47:
          value += '/';
          break;

        case 92:
          value += '\\';
          break;

        case 98:
          value += '\b';
          break;

        case 102:
          value += '\f';
          break;

        case 110:
          value += '\n';
          break;

        case 114:
          value += '\r';
          break;

        case 116:
          value += '\t';
          break;

        case 117:
          {
            // uXXXX
            var charCode = uniCharCode(body.charCodeAt(position + 1), body.charCodeAt(position + 2), body.charCodeAt(position + 3), body.charCodeAt(position + 4));

            if (charCode < 0) {
              var invalidSequence = body.slice(position + 1, position + 5);
              throw syntaxError(source, position, "Invalid character escape sequence: \\u".concat(invalidSequence, "."));
            }

            value += String.fromCharCode(charCode);
            position += 4;
            break;
          }

        default:
          throw syntaxError(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
      }

      ++position;
      chunkStart = position;
    }
  }

  throw syntaxError(source, position, 'Unterminated string.');
}
/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */


function readBlockString(source, start, line, col, prev, lexer) {
  var body = source.body;
  var position = start + 3;
  var chunkStart = position;
  var code = 0;
  var rawValue = '';

  while (position < body.length && !isNaN(code = body.charCodeAt(position))) {
    // Closing Triple-Quote (""")
    if (code === 34 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) {
      rawValue += body.slice(chunkStart, position);
      return new Tok(tokenKind_TokenKind.BLOCK_STRING, start, position + 3, line, col, prev, (0,blockString/* dedentBlockStringValue */.W7)(rawValue));
    } // SourceCharacter


    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) {
      throw syntaxError(source, position, "Invalid character within String: ".concat(printCharCode(code), "."));
    }

    if (code === 10) {
      // new line
      ++position;
      ++lexer.line;
      lexer.lineStart = position;
    } else if (code === 13) {
      // carriage return
      if (body.charCodeAt(position + 1) === 10) {
        position += 2;
      } else {
        ++position;
      }

      ++lexer.line;
      lexer.lineStart = position;
    } else if ( // Escape Triple-Quote (\""")
    code === 92 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34 && body.charCodeAt(position + 3) === 34) {
      rawValue += body.slice(chunkStart, position) + '"""';
      position += 4;
      chunkStart = position;
    } else {
      ++position;
    }
  }

  throw syntaxError(source, position, 'Unterminated string.');
}
/**
 * Converts four hexadecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */


function uniCharCode(a, b, c, d) {
  return char2hex(a) << 12 | char2hex(b) << 8 | char2hex(c) << 4 | char2hex(d);
}
/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */


function char2hex(a) {
  return a >= 48 && a <= 57 ? a - 48 // 0-9
  : a >= 65 && a <= 70 ? a - 55 // A-F
  : a >= 97 && a <= 102 ? a - 87 // a-f
  : -1;
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */


function readName(source, start, line, col, prev) {
  var body = source.body;
  var bodyLength = body.length;
  var position = start + 1;
  var code = 0;

  while (position !== bodyLength && !isNaN(code = body.charCodeAt(position)) && (code === 95 || // _
  code >= 48 && code <= 57 || // 0-9
  code >= 65 && code <= 90 || // A-Z
  code >= 97 && code <= 122) // a-z
  ) {
    ++position;
  }

  return new Tok(tokenKind_TokenKind.NAME, start, position, line, col, prev, body.slice(start, position));
}

;// CONCATENATED MODULE: ./node_modules/graphql/language/directiveLocation.mjs
/**
 * The set of allowed directive location values.
 */
var DirectiveLocation = Object.freeze({
  // Request Definitions
  QUERY: 'QUERY',
  MUTATION: 'MUTATION',
  SUBSCRIPTION: 'SUBSCRIPTION',
  FIELD: 'FIELD',
  FRAGMENT_DEFINITION: 'FRAGMENT_DEFINITION',
  FRAGMENT_SPREAD: 'FRAGMENT_SPREAD',
  INLINE_FRAGMENT: 'INLINE_FRAGMENT',
  VARIABLE_DEFINITION: 'VARIABLE_DEFINITION',
  // Type System Definitions
  SCHEMA: 'SCHEMA',
  SCALAR: 'SCALAR',
  OBJECT: 'OBJECT',
  FIELD_DEFINITION: 'FIELD_DEFINITION',
  ARGUMENT_DEFINITION: 'ARGUMENT_DEFINITION',
  INTERFACE: 'INTERFACE',
  UNION: 'UNION',
  ENUM: 'ENUM',
  ENUM_VALUE: 'ENUM_VALUE',
  INPUT_OBJECT: 'INPUT_OBJECT',
  INPUT_FIELD_DEFINITION: 'INPUT_FIELD_DEFINITION'
});
/**
 * The enum type representing the directive location values.
 */

;// CONCATENATED MODULE: ./node_modules/graphql/language/parser.mjs










/**
 * Given a GraphQL source, parses it into a Document.
 * Throws GraphQLError if a syntax error is encountered.
 */
function parse(source, options) {
  var parser = new Parser(source, options);
  return parser.parseDocument();
}
/**
 * Given a string containing a GraphQL value (ex. `[42]`), parse the AST for
 * that value.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Values directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: valueFromAST().
 */

function parseValue(source, options) {
  var parser = new Parser(source, options);
  parser.expectToken(TokenKind.SOF);
  var value = parser.parseValueLiteral(false);
  parser.expectToken(TokenKind.EOF);
  return value;
}
/**
 * Given a string containing a GraphQL Type (ex. `[Int!]`), parse the AST for
 * that type.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Types directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: typeFromAST().
 */

function parseType(source, options) {
  var parser = new Parser(source, options);
  parser.expectToken(TokenKind.SOF);
  var type = parser.parseTypeReference();
  parser.expectToken(TokenKind.EOF);
  return type;
}

var Parser =
/*#__PURE__*/
function () {
  function Parser(source, options) {
    var sourceObj = typeof source === 'string' ? new language_source/* Source */.H(source) : source;
    sourceObj instanceof language_source/* Source */.H || (0,devAssert/* default */.Z)(0, "Must provide Source. Received: ".concat((0,inspect/* default */.Z)(sourceObj)));
    this._lexer = createLexer(sourceObj);
    this._options = options || {};
  }
  /**
   * Converts a name lex token into a name parse node.
   */


  var _proto = Parser.prototype;

  _proto.parseName = function parseName() {
    var token = this.expectToken(tokenKind_TokenKind.NAME);
    return {
      kind: kinds/* Kind.NAME */.h.NAME,
      value: token.value,
      loc: this.loc(token)
    };
  } // Implements the parsing rules in the Document section.

  /**
   * Document : Definition+
   */
  ;

  _proto.parseDocument = function parseDocument() {
    var start = this._lexer.token;
    return {
      kind: kinds/* Kind.DOCUMENT */.h.DOCUMENT,
      definitions: this.many(tokenKind_TokenKind.SOF, this.parseDefinition, tokenKind_TokenKind.EOF),
      loc: this.loc(start)
    };
  }
  /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   */
  ;

  _proto.parseDefinition = function parseDefinition() {
    if (this.peek(tokenKind_TokenKind.NAME)) {
      switch (this._lexer.token.value) {
        case 'query':
        case 'mutation':
        case 'subscription':
          return this.parseOperationDefinition();

        case 'fragment':
          return this.parseFragmentDefinition();

        case 'schema':
        case 'scalar':
        case 'type':
        case 'interface':
        case 'union':
        case 'enum':
        case 'input':
        case 'directive':
          return this.parseTypeSystemDefinition();

        case 'extend':
          return this.parseTypeSystemExtension();
      }
    } else if (this.peek(tokenKind_TokenKind.BRACE_L)) {
      return this.parseOperationDefinition();
    } else if (this.peekDescription()) {
      return this.parseTypeSystemDefinition();
    }

    throw this.unexpected();
  } // Implements the parsing rules in the Operations section.

  /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */
  ;

  _proto.parseOperationDefinition = function parseOperationDefinition() {
    var start = this._lexer.token;

    if (this.peek(tokenKind_TokenKind.BRACE_L)) {
      return {
        kind: kinds/* Kind.OPERATION_DEFINITION */.h.OPERATION_DEFINITION,
        operation: 'query',
        name: undefined,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet(),
        loc: this.loc(start)
      };
    }

    var operation = this.parseOperationType();
    var name;

    if (this.peek(tokenKind_TokenKind.NAME)) {
      name = this.parseName();
    }

    return {
      kind: kinds/* Kind.OPERATION_DEFINITION */.h.OPERATION_DEFINITION,
      operation: operation,
      name: name,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
      loc: this.loc(start)
    };
  }
  /**
   * OperationType : one of query mutation subscription
   */
  ;

  _proto.parseOperationType = function parseOperationType() {
    var operationToken = this.expectToken(tokenKind_TokenKind.NAME);

    switch (operationToken.value) {
      case 'query':
        return 'query';

      case 'mutation':
        return 'mutation';

      case 'subscription':
        return 'subscription';
    }

    throw this.unexpected(operationToken);
  }
  /**
   * VariableDefinitions : ( VariableDefinition+ )
   */
  ;

  _proto.parseVariableDefinitions = function parseVariableDefinitions() {
    return this.optionalMany(tokenKind_TokenKind.PAREN_L, this.parseVariableDefinition, tokenKind_TokenKind.PAREN_R);
  }
  /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */
  ;

  _proto.parseVariableDefinition = function parseVariableDefinition() {
    var start = this._lexer.token;
    return {
      kind: kinds/* Kind.VARIABLE_DEFINITION */.h.VARIABLE_DEFINITION,
      variable: this.parseVariable(),
      type: (this.expectToken(tokenKind_TokenKind.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(tokenKind_TokenKind.EQUALS) ? this.parseValueLiteral(true) : undefined,
      directives: this.parseDirectives(true),
      loc: this.loc(start)
    };
  }
  /**
   * Variable : $ Name
   */
  ;

  _proto.parseVariable = function parseVariable() {
    var start = this._lexer.token;
    this.expectToken(tokenKind_TokenKind.DOLLAR);
    return {
      kind: kinds/* Kind.VARIABLE */.h.VARIABLE,
      name: this.parseName(),
      loc: this.loc(start)
    };
  }
  /**
   * SelectionSet : { Selection+ }
   */
  ;

  _proto.parseSelectionSet = function parseSelectionSet() {
    var start = this._lexer.token;
    return {
      kind: kinds/* Kind.SELECTION_SET */.h.SELECTION_SET,
      selections: this.many(tokenKind_TokenKind.BRACE_L, this.parseSelection, tokenKind_TokenKind.BRACE_R),
      loc: this.loc(start)
    };
  }
  /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */
  ;

  _proto.parseSelection = function parseSelection() {
    return this.peek(tokenKind_TokenKind.SPREAD) ? this.parseFragment() : this.parseField();
  }
  /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */
  ;

  _proto.parseField = function parseField() {
    var start = this._lexer.token;
    var nameOrAlias = this.parseName();
    var alias;
    var name;

    if (this.expectOptionalToken(tokenKind_TokenKind.COLON)) {
      alias = nameOrAlias;
      name = this.parseName();
    } else {
      name = nameOrAlias;
    }

    return {
      kind: kinds/* Kind.FIELD */.h.FIELD,
      alias: alias,
      name: name,
      arguments: this.parseArguments(false),
      directives: this.parseDirectives(false),
      selectionSet: this.peek(tokenKind_TokenKind.BRACE_L) ? this.parseSelectionSet() : undefined,
      loc: this.loc(start)
    };
  }
  /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */
  ;

  _proto.parseArguments = function parseArguments(isConst) {
    var item = isConst ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(tokenKind_TokenKind.PAREN_L, item, tokenKind_TokenKind.PAREN_R);
  }
  /**
   * Argument[Const] : Name : Value[?Const]
   */
  ;

  _proto.parseArgument = function parseArgument() {
    var start = this._lexer.token;
    var name = this.parseName();
    this.expectToken(tokenKind_TokenKind.COLON);
    return {
      kind: kinds/* Kind.ARGUMENT */.h.ARGUMENT,
      name: name,
      value: this.parseValueLiteral(false),
      loc: this.loc(start)
    };
  };

  _proto.parseConstArgument = function parseConstArgument() {
    var start = this._lexer.token;
    return {
      kind: kinds/* Kind.ARGUMENT */.h.ARGUMENT,
      name: this.parseName(),
      value: (this.expectToken(tokenKind_TokenKind.COLON), this.parseValueLiteral(true)),
      loc: this.loc(start)
    };
  } // Implements the parsing rules in the Fragments section.

  /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */
  ;

  _proto.parseFragment = function parseFragment() {
    var start = this._lexer.token;
    this.expectToken(tokenKind_TokenKind.SPREAD);
    var hasTypeCondition = this.expectOptionalKeyword('on');

    if (!hasTypeCondition && this.peek(tokenKind_TokenKind.NAME)) {
      return {
        kind: kinds/* Kind.FRAGMENT_SPREAD */.h.FRAGMENT_SPREAD,
        name: this.parseFragmentName(),
        directives: this.parseDirectives(false),
        loc: this.loc(start)
      };
    }

    return {
      kind: kinds/* Kind.INLINE_FRAGMENT */.h.INLINE_FRAGMENT,
      typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
      loc: this.loc(start)
    };
  }
  /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */
  ;

  _proto.parseFragmentDefinition = function parseFragmentDefinition() {
    var start = this._lexer.token;
    this.expectKeyword('fragment'); // Experimental support for defining variables within fragments changes
    // the grammar of FragmentDefinition:
    //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet

    if (this._options.experimentalFragmentVariables) {
      return {
        kind: kinds/* Kind.FRAGMENT_DEFINITION */.h.FRAGMENT_DEFINITION,
        name: this.parseFragmentName(),
        variableDefinitions: this.parseVariableDefinitions(),
        typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
        directives: this.parseDirectives(false),
        selectionSet: this.parseSelectionSet(),
        loc: this.loc(start)
      };
    }

    return {
      kind: kinds/* Kind.FRAGMENT_DEFINITION */.h.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
      loc: this.loc(start)
    };
  }
  /**
   * FragmentName : Name but not `on`
   */
  ;

  _proto.parseFragmentName = function parseFragmentName() {
    if (this._lexer.token.value === 'on') {
      throw this.unexpected();
    }

    return this.parseName();
  } // Implements the parsing rules in the Values section.

  /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */
  ;

  _proto.parseValueLiteral = function parseValueLiteral(isConst) {
    var token = this._lexer.token;

    switch (token.kind) {
      case tokenKind_TokenKind.BRACKET_L:
        return this.parseList(isConst);

      case tokenKind_TokenKind.BRACE_L:
        return this.parseObject(isConst);

      case tokenKind_TokenKind.INT:
        this._lexer.advance();

        return {
          kind: kinds/* Kind.INT */.h.INT,
          value: token.value,
          loc: this.loc(token)
        };

      case tokenKind_TokenKind.FLOAT:
        this._lexer.advance();

        return {
          kind: kinds/* Kind.FLOAT */.h.FLOAT,
          value: token.value,
          loc: this.loc(token)
        };

      case tokenKind_TokenKind.STRING:
      case tokenKind_TokenKind.BLOCK_STRING:
        return this.parseStringLiteral();

      case tokenKind_TokenKind.NAME:
        if (token.value === 'true' || token.value === 'false') {
          this._lexer.advance();

          return {
            kind: kinds/* Kind.BOOLEAN */.h.BOOLEAN,
            value: token.value === 'true',
            loc: this.loc(token)
          };
        } else if (token.value === 'null') {
          this._lexer.advance();

          return {
            kind: kinds/* Kind.NULL */.h.NULL,
            loc: this.loc(token)
          };
        }

        this._lexer.advance();

        return {
          kind: kinds/* Kind.ENUM */.h.ENUM,
          value: token.value,
          loc: this.loc(token)
        };

      case tokenKind_TokenKind.DOLLAR:
        if (!isConst) {
          return this.parseVariable();
        }

        break;
    }

    throw this.unexpected();
  };

  _proto.parseStringLiteral = function parseStringLiteral() {
    var token = this._lexer.token;

    this._lexer.advance();

    return {
      kind: kinds/* Kind.STRING */.h.STRING,
      value: token.value,
      block: token.kind === tokenKind_TokenKind.BLOCK_STRING,
      loc: this.loc(token)
    };
  }
  /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */
  ;

  _proto.parseList = function parseList(isConst) {
    var _this = this;

    var start = this._lexer.token;

    var item = function item() {
      return _this.parseValueLiteral(isConst);
    };

    return {
      kind: kinds/* Kind.LIST */.h.LIST,
      values: this.any(tokenKind_TokenKind.BRACKET_L, item, tokenKind_TokenKind.BRACKET_R),
      loc: this.loc(start)
    };
  }
  /**
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   */
  ;

  _proto.parseObject = function parseObject(isConst) {
    var _this2 = this;

    var start = this._lexer.token;

    var item = function item() {
      return _this2.parseObjectField(isConst);
    };

    return {
      kind: kinds/* Kind.OBJECT */.h.OBJECT,
      fields: this.any(tokenKind_TokenKind.BRACE_L, item, tokenKind_TokenKind.BRACE_R),
      loc: this.loc(start)
    };
  }
  /**
   * ObjectField[Const] : Name : Value[?Const]
   */
  ;

  _proto.parseObjectField = function parseObjectField(isConst) {
    var start = this._lexer.token;
    var name = this.parseName();
    this.expectToken(tokenKind_TokenKind.COLON);
    return {
      kind: kinds/* Kind.OBJECT_FIELD */.h.OBJECT_FIELD,
      name: name,
      value: this.parseValueLiteral(isConst),
      loc: this.loc(start)
    };
  } // Implements the parsing rules in the Directives section.

  /**
   * Directives[Const] : Directive[?Const]+
   */
  ;

  _proto.parseDirectives = function parseDirectives(isConst) {
    var directives = [];

    while (this.peek(tokenKind_TokenKind.AT)) {
      directives.push(this.parseDirective(isConst));
    }

    return directives;
  }
  /**
   * Directive[Const] : @ Name Arguments[?Const]?
   */
  ;

  _proto.parseDirective = function parseDirective(isConst) {
    var start = this._lexer.token;
    this.expectToken(tokenKind_TokenKind.AT);
    return {
      kind: kinds/* Kind.DIRECTIVE */.h.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(isConst),
      loc: this.loc(start)
    };
  } // Implements the parsing rules in the Types section.

  /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */
  ;

  _proto.parseTypeReference = function parseTypeReference() {
    var start = this._lexer.token;
    var type;

    if (this.expectOptionalToken(tokenKind_TokenKind.BRACKET_L)) {
      type = this.parseTypeReference();
      this.expectToken(tokenKind_TokenKind.BRACKET_R);
      type = {
        kind: kinds/* Kind.LIST_TYPE */.h.LIST_TYPE,
        type: type,
        loc: this.loc(start)
      };
    } else {
      type = this.parseNamedType();
    }

    if (this.expectOptionalToken(tokenKind_TokenKind.BANG)) {
      return {
        kind: kinds/* Kind.NON_NULL_TYPE */.h.NON_NULL_TYPE,
        type: type,
        loc: this.loc(start)
      };
    }

    return type;
  }
  /**
   * NamedType : Name
   */
  ;

  _proto.parseNamedType = function parseNamedType() {
    var start = this._lexer.token;
    return {
      kind: kinds/* Kind.NAMED_TYPE */.h.NAMED_TYPE,
      name: this.parseName(),
      loc: this.loc(start)
    };
  } // Implements the parsing rules in the Type Definition section.

  /**
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */
  ;

  _proto.parseTypeSystemDefinition = function parseTypeSystemDefinition() {
    // Many definitions begin with a description and require a lookahead.
    var keywordToken = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;

    if (keywordToken.kind === tokenKind_TokenKind.NAME) {
      switch (keywordToken.value) {
        case 'schema':
          return this.parseSchemaDefinition();

        case 'scalar':
          return this.parseScalarTypeDefinition();

        case 'type':
          return this.parseObjectTypeDefinition();

        case 'interface':
          return this.parseInterfaceTypeDefinition();

        case 'union':
          return this.parseUnionTypeDefinition();

        case 'enum':
          return this.parseEnumTypeDefinition();

        case 'input':
          return this.parseInputObjectTypeDefinition();

        case 'directive':
          return this.parseDirectiveDefinition();
      }
    }

    throw this.unexpected(keywordToken);
  };

  _proto.peekDescription = function peekDescription() {
    return this.peek(tokenKind_TokenKind.STRING) || this.peek(tokenKind_TokenKind.BLOCK_STRING);
  }
  /**
   * Description : StringValue
   */
  ;

  _proto.parseDescription = function parseDescription() {
    if (this.peekDescription()) {
      return this.parseStringLiteral();
    }
  }
  /**
   * SchemaDefinition : schema Directives[Const]? { OperationTypeDefinition+ }
   */
  ;

  _proto.parseSchemaDefinition = function parseSchemaDefinition() {
    var start = this._lexer.token;
    this.expectKeyword('schema');
    var directives = this.parseDirectives(true);
    var operationTypes = this.many(tokenKind_TokenKind.BRACE_L, this.parseOperationTypeDefinition, tokenKind_TokenKind.BRACE_R);
    return {
      kind: kinds/* Kind.SCHEMA_DEFINITION */.h.SCHEMA_DEFINITION,
      directives: directives,
      operationTypes: operationTypes,
      loc: this.loc(start)
    };
  }
  /**
   * OperationTypeDefinition : OperationType : NamedType
   */
  ;

  _proto.parseOperationTypeDefinition = function parseOperationTypeDefinition() {
    var start = this._lexer.token;
    var operation = this.parseOperationType();
    this.expectToken(tokenKind_TokenKind.COLON);
    var type = this.parseNamedType();
    return {
      kind: kinds/* Kind.OPERATION_TYPE_DEFINITION */.h.OPERATION_TYPE_DEFINITION,
      operation: operation,
      type: type,
      loc: this.loc(start)
    };
  }
  /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */
  ;

  _proto.parseScalarTypeDefinition = function parseScalarTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('scalar');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    return {
      kind: kinds/* Kind.SCALAR_TYPE_DEFINITION */.h.SCALAR_TYPE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */
  ;

  _proto.parseObjectTypeDefinition = function parseObjectTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('type');
    var name = this.parseName();
    var interfaces = this.parseImplementsInterfaces();
    var directives = this.parseDirectives(true);
    var fields = this.parseFieldsDefinition();
    return {
      kind: kinds/* Kind.OBJECT_TYPE_DEFINITION */.h.OBJECT_TYPE_DEFINITION,
      description: description,
      name: name,
      interfaces: interfaces,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */
  ;

  _proto.parseImplementsInterfaces = function parseImplementsInterfaces() {
    var types = [];

    if (this.expectOptionalKeyword('implements')) {
      // Optional leading ampersand
      this.expectOptionalToken(tokenKind_TokenKind.AMP);

      do {
        types.push(this.parseNamedType());
      } while (this.expectOptionalToken(tokenKind_TokenKind.AMP) || // Legacy support for the SDL?
      this._options.allowLegacySDLImplementsInterfaces && this.peek(tokenKind_TokenKind.NAME));
    }

    return types;
  }
  /**
   * FieldsDefinition : { FieldDefinition+ }
   */
  ;

  _proto.parseFieldsDefinition = function parseFieldsDefinition() {
    // Legacy support for the SDL?
    if (this._options.allowLegacySDLEmptyFields && this.peek(tokenKind_TokenKind.BRACE_L) && this._lexer.lookahead().kind === tokenKind_TokenKind.BRACE_R) {
      this._lexer.advance();

      this._lexer.advance();

      return [];
    }

    return this.optionalMany(tokenKind_TokenKind.BRACE_L, this.parseFieldDefinition, tokenKind_TokenKind.BRACE_R);
  }
  /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */
  ;

  _proto.parseFieldDefinition = function parseFieldDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    var name = this.parseName();
    var args = this.parseArgumentDefs();
    this.expectToken(tokenKind_TokenKind.COLON);
    var type = this.parseTypeReference();
    var directives = this.parseDirectives(true);
    return {
      kind: kinds/* Kind.FIELD_DEFINITION */.h.FIELD_DEFINITION,
      description: description,
      name: name,
      arguments: args,
      type: type,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */
  ;

  _proto.parseArgumentDefs = function parseArgumentDefs() {
    return this.optionalMany(tokenKind_TokenKind.PAREN_L, this.parseInputValueDef, tokenKind_TokenKind.PAREN_R);
  }
  /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */
  ;

  _proto.parseInputValueDef = function parseInputValueDef() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    var name = this.parseName();
    this.expectToken(tokenKind_TokenKind.COLON);
    var type = this.parseTypeReference();
    var defaultValue;

    if (this.expectOptionalToken(tokenKind_TokenKind.EQUALS)) {
      defaultValue = this.parseValueLiteral(true);
    }

    var directives = this.parseDirectives(true);
    return {
      kind: kinds/* Kind.INPUT_VALUE_DEFINITION */.h.INPUT_VALUE_DEFINITION,
      description: description,
      name: name,
      type: type,
      defaultValue: defaultValue,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */
  ;

  _proto.parseInterfaceTypeDefinition = function parseInterfaceTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('interface');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var fields = this.parseFieldsDefinition();
    return {
      kind: kinds/* Kind.INTERFACE_TYPE_DEFINITION */.h.INTERFACE_TYPE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */
  ;

  _proto.parseUnionTypeDefinition = function parseUnionTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('union');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var types = this.parseUnionMemberTypes();
    return {
      kind: kinds/* Kind.UNION_TYPE_DEFINITION */.h.UNION_TYPE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      types: types,
      loc: this.loc(start)
    };
  }
  /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */
  ;

  _proto.parseUnionMemberTypes = function parseUnionMemberTypes() {
    var types = [];

    if (this.expectOptionalToken(tokenKind_TokenKind.EQUALS)) {
      // Optional leading pipe
      this.expectOptionalToken(tokenKind_TokenKind.PIPE);

      do {
        types.push(this.parseNamedType());
      } while (this.expectOptionalToken(tokenKind_TokenKind.PIPE));
    }

    return types;
  }
  /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */
  ;

  _proto.parseEnumTypeDefinition = function parseEnumTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('enum');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var values = this.parseEnumValuesDefinition();
    return {
      kind: kinds/* Kind.ENUM_TYPE_DEFINITION */.h.ENUM_TYPE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      values: values,
      loc: this.loc(start)
    };
  }
  /**
   * EnumValuesDefinition : { EnumValueDefinition+ }
   */
  ;

  _proto.parseEnumValuesDefinition = function parseEnumValuesDefinition() {
    return this.optionalMany(tokenKind_TokenKind.BRACE_L, this.parseEnumValueDefinition, tokenKind_TokenKind.BRACE_R);
  }
  /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   *
   * EnumValue : Name
   */
  ;

  _proto.parseEnumValueDefinition = function parseEnumValueDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    return {
      kind: kinds/* Kind.ENUM_VALUE_DEFINITION */.h.ENUM_VALUE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */
  ;

  _proto.parseInputObjectTypeDefinition = function parseInputObjectTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('input');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var fields = this.parseInputFieldsDefinition();
    return {
      kind: kinds/* Kind.INPUT_OBJECT_TYPE_DEFINITION */.h.INPUT_OBJECT_TYPE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * InputFieldsDefinition : { InputValueDefinition+ }
   */
  ;

  _proto.parseInputFieldsDefinition = function parseInputFieldsDefinition() {
    return this.optionalMany(tokenKind_TokenKind.BRACE_L, this.parseInputValueDef, tokenKind_TokenKind.BRACE_R);
  }
  /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */
  ;

  _proto.parseTypeSystemExtension = function parseTypeSystemExtension() {
    var keywordToken = this._lexer.lookahead();

    if (keywordToken.kind === tokenKind_TokenKind.NAME) {
      switch (keywordToken.value) {
        case 'schema':
          return this.parseSchemaExtension();

        case 'scalar':
          return this.parseScalarTypeExtension();

        case 'type':
          return this.parseObjectTypeExtension();

        case 'interface':
          return this.parseInterfaceTypeExtension();

        case 'union':
          return this.parseUnionTypeExtension();

        case 'enum':
          return this.parseEnumTypeExtension();

        case 'input':
          return this.parseInputObjectTypeExtension();
      }
    }

    throw this.unexpected(keywordToken);
  }
  /**
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   */
  ;

  _proto.parseSchemaExtension = function parseSchemaExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('schema');
    var directives = this.parseDirectives(true);
    var operationTypes = this.optionalMany(tokenKind_TokenKind.BRACE_L, this.parseOperationTypeDefinition, tokenKind_TokenKind.BRACE_R);

    if (directives.length === 0 && operationTypes.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: kinds/* Kind.SCHEMA_EXTENSION */.h.SCHEMA_EXTENSION,
      directives: directives,
      operationTypes: operationTypes,
      loc: this.loc(start)
    };
  }
  /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */
  ;

  _proto.parseScalarTypeExtension = function parseScalarTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('scalar');
    var name = this.parseName();
    var directives = this.parseDirectives(true);

    if (directives.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: kinds/* Kind.SCALAR_TYPE_EXTENSION */.h.SCALAR_TYPE_EXTENSION,
      name: name,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */
  ;

  _proto.parseObjectTypeExtension = function parseObjectTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('type');
    var name = this.parseName();
    var interfaces = this.parseImplementsInterfaces();
    var directives = this.parseDirectives(true);
    var fields = this.parseFieldsDefinition();

    if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: kinds/* Kind.OBJECT_TYPE_EXTENSION */.h.OBJECT_TYPE_EXTENSION,
      name: name,
      interfaces: interfaces,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * InterfaceTypeExtension :
   *   - extend interface Name Directives[Const]? FieldsDefinition
   *   - extend interface Name Directives[Const]
   */
  ;

  _proto.parseInterfaceTypeExtension = function parseInterfaceTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('interface');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var fields = this.parseFieldsDefinition();

    if (directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: kinds/* Kind.INTERFACE_TYPE_EXTENSION */.h.INTERFACE_TYPE_EXTENSION,
      name: name,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */
  ;

  _proto.parseUnionTypeExtension = function parseUnionTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('union');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var types = this.parseUnionMemberTypes();

    if (directives.length === 0 && types.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: kinds/* Kind.UNION_TYPE_EXTENSION */.h.UNION_TYPE_EXTENSION,
      name: name,
      directives: directives,
      types: types,
      loc: this.loc(start)
    };
  }
  /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */
  ;

  _proto.parseEnumTypeExtension = function parseEnumTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('enum');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var values = this.parseEnumValuesDefinition();

    if (directives.length === 0 && values.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: kinds/* Kind.ENUM_TYPE_EXTENSION */.h.ENUM_TYPE_EXTENSION,
      name: name,
      directives: directives,
      values: values,
      loc: this.loc(start)
    };
  }
  /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */
  ;

  _proto.parseInputObjectTypeExtension = function parseInputObjectTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('input');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var fields = this.parseInputFieldsDefinition();

    if (directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: kinds/* Kind.INPUT_OBJECT_TYPE_EXTENSION */.h.INPUT_OBJECT_TYPE_EXTENSION,
      name: name,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   */
  ;

  _proto.parseDirectiveDefinition = function parseDirectiveDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('directive');
    this.expectToken(tokenKind_TokenKind.AT);
    var name = this.parseName();
    var args = this.parseArgumentDefs();
    var repeatable = this.expectOptionalKeyword('repeatable');
    this.expectKeyword('on');
    var locations = this.parseDirectiveLocations();
    return {
      kind: kinds/* Kind.DIRECTIVE_DEFINITION */.h.DIRECTIVE_DEFINITION,
      description: description,
      name: name,
      arguments: args,
      repeatable: repeatable,
      locations: locations,
      loc: this.loc(start)
    };
  }
  /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */
  ;

  _proto.parseDirectiveLocations = function parseDirectiveLocations() {
    // Optional leading pipe
    this.expectOptionalToken(tokenKind_TokenKind.PIPE);
    var locations = [];

    do {
      locations.push(this.parseDirectiveLocation());
    } while (this.expectOptionalToken(tokenKind_TokenKind.PIPE));

    return locations;
  }
  /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */
  ;

  _proto.parseDirectiveLocation = function parseDirectiveLocation() {
    var start = this._lexer.token;
    var name = this.parseName();

    if (DirectiveLocation[name.value] !== undefined) {
      return name;
    }

    throw this.unexpected(start);
  } // Core parsing utility functions

  /**
   * Returns a location object, used to identify the place in
   * the source that created a given parsed object.
   */
  ;

  _proto.loc = function loc(startToken) {
    if (!this._options.noLocation) {
      return new Loc(startToken, this._lexer.lastToken, this._lexer.source);
    }
  }
  /**
   * Determines if the next token is of a given kind
   */
  ;

  _proto.peek = function peek(kind) {
    return this._lexer.token.kind === kind;
  }
  /**
   * If the next token is of the given kind, return that token after advancing
   * the lexer. Otherwise, do not change the parser state and throw an error.
   */
  ;

  _proto.expectToken = function expectToken(kind) {
    var token = this._lexer.token;

    if (token.kind === kind) {
      this._lexer.advance();

      return token;
    }

    throw syntaxError(this._lexer.source, token.start, "Expected ".concat(kind, ", found ").concat(getTokenDesc(token)));
  }
  /**
   * If the next token is of the given kind, return that token after advancing
   * the lexer. Otherwise, do not change the parser state and return undefined.
   */
  ;

  _proto.expectOptionalToken = function expectOptionalToken(kind) {
    var token = this._lexer.token;

    if (token.kind === kind) {
      this._lexer.advance();

      return token;
    }

    return undefined;
  }
  /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  ;

  _proto.expectKeyword = function expectKeyword(value) {
    var token = this._lexer.token;

    if (token.kind === tokenKind_TokenKind.NAME && token.value === value) {
      this._lexer.advance();
    } else {
      throw syntaxError(this._lexer.source, token.start, "Expected \"".concat(value, "\", found ").concat(getTokenDesc(token)));
    }
  }
  /**
   * If the next token is a given keyword, return "true" after advancing
   * the lexer. Otherwise, do not change the parser state and return "false".
   */
  ;

  _proto.expectOptionalKeyword = function expectOptionalKeyword(value) {
    var token = this._lexer.token;

    if (token.kind === tokenKind_TokenKind.NAME && token.value === value) {
      this._lexer.advance();

      return true;
    }

    return false;
  }
  /**
   * Helper function for creating an error when an unexpected lexed token
   * is encountered.
   */
  ;

  _proto.unexpected = function unexpected(atToken) {
    var token = atToken || this._lexer.token;
    return syntaxError(this._lexer.source, token.start, "Unexpected ".concat(getTokenDesc(token)));
  }
  /**
   * Returns a possibly empty list of parse nodes, determined by
   * the parseFn. This list begins with a lex token of openKind
   * and ends with a lex token of closeKind. Advances the parser
   * to the next lex token after the closing token.
   */
  ;

  _proto.any = function any(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    var nodes = [];

    while (!this.expectOptionalToken(closeKind)) {
      nodes.push(parseFn.call(this));
    }

    return nodes;
  }
  /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always
   * return non-empty list that begins with a lex token of openKind and ends
   * with a lex token of closeKind. Advances the parser to the next lex token
   * after the closing token.
   */
  ;

  _proto.optionalMany = function optionalMany(openKind, parseFn, closeKind) {
    if (this.expectOptionalToken(openKind)) {
      var nodes = [];

      do {
        nodes.push(parseFn.call(this));
      } while (!this.expectOptionalToken(closeKind));

      return nodes;
    }

    return [];
  }
  /**
   * Returns a non-empty list of parse nodes, determined by
   * the parseFn. This list begins with a lex token of openKind
   * and ends with a lex token of closeKind. Advances the parser
   * to the next lex token after the closing token.
   */
  ;

  _proto.many = function many(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    var nodes = [];

    do {
      nodes.push(parseFn.call(this));
    } while (!this.expectOptionalToken(closeKind));

    return nodes;
  };

  return Parser;
}();

function Loc(startToken, endToken, source) {
  this.start = startToken.start;
  this.end = endToken.end;
  this.startToken = startToken;
  this.endToken = endToken;
  this.source = source;
} // Print a simplified form when appearing in JSON/util.inspect.


defineToJSON(Loc, function () {
  return {
    start: this.start,
    end: this.end
  };
});
/**
 * A helper function to describe a token as a string for debugging
 */

function getTokenDesc(token) {
  var value = token.value;
  return value ? "".concat(token.kind, " \"").concat(value, "\"") : token.kind;
}

;// CONCATENATED MODULE: ./node_modules/graphql-tag/lib/index.js


var docCache = new Map();
var fragmentSourceMap = new Map();
var printFragmentWarnings = true;
var experimentalFragmentVariables = false;
function normalize(string) {
    return string.replace(/[\s,]+/g, ' ').trim();
}
function cacheKeyFromLoc(loc) {
    return normalize(loc.source.body.substring(loc.start, loc.end));
}
function processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function (fragmentDefinition) {
        if (fragmentDefinition.kind === 'FragmentDefinition') {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if (printFragmentWarnings) {
                    console.warn("Warning: fragment with name " + fragmentName + " already exists.\n"
                        + "graphql-tag enforces all fragment names across your application to be unique; read more about\n"
                        + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
                }
            }
            else if (!sourceKeySet) {
                fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            }
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        }
        else {
            definitions.push(fragmentDefinition);
        }
    });
    return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, ast), { definitions: definitions });
}
function stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function (node) {
        if (node.loc)
            delete node.loc;
        Object.keys(node).forEach(function (key) {
            var value = node[key];
            if (value && typeof value === 'object') {
                workSet.add(value);
            }
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function parseDocument(source) {
    var cacheKey = normalize(source);
    if (!docCache.has(cacheKey)) {
        var parsed = parse(source, {
            experimentalFragmentVariables: experimentalFragmentVariables,
            allowLegacyFragmentVariables: experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== 'Document') {
            throw new Error('Not a valid GraphQL document.');
        }
        docCache.set(cacheKey, stripLoc(processFragments(parsed)));
    }
    return docCache.get(cacheKey);
}
function gql(literals) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (typeof literals === 'string') {
        literals = [literals];
    }
    var result = literals[0];
    args.forEach(function (arg, i) {
        if (arg && arg.kind === 'Document') {
            result += arg.loc.source.body;
        }
        else {
            result += arg;
        }
        result += literals[i + 1];
    });
    return parseDocument(result);
}
function resetCaches() {
    docCache.clear();
    fragmentSourceMap.clear();
}
function disableFragmentWarnings() {
    printFragmentWarnings = false;
}
function enableExperimentalFragmentVariables() {
    experimentalFragmentVariables = true;
}
function disableExperimentalFragmentVariables() {
    experimentalFragmentVariables = false;
}
var extras = {
    gql: gql,
    resetCaches: resetCaches,
    disableFragmentWarnings: disableFragmentWarnings,
    enableExperimentalFragmentVariables: enableExperimentalFragmentVariables,
    disableExperimentalFragmentVariables: disableExperimentalFragmentVariables
};
(function (gql_1) {
    gql_1.gql = extras.gql, gql_1.resetCaches = extras.resetCaches, gql_1.disableFragmentWarnings = extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = extras.disableExperimentalFragmentVariables;
})(gql || (gql = {}));
gql["default"] = gql;
/* harmony default export */ var lib = (gql);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 8679:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(59864);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 80645:
/***/ (function(__unused_webpack_module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ 77090:
/***/ (function(module) {

(function(window, factory) {
	var lazySizes = factory(window, window.document, Date);
	window.lazySizes = lazySizes;
	if( true && module.exports){
		module.exports = lazySizes;
	}
}(typeof window != 'undefined' ?
      window : {}, 
/**
 * import("./types/global")
 * @typedef { import("./types/lazysizes-config").LazySizesConfigPartial } LazySizesConfigPartial
 */
function l(window, document, Date) { // Pass in the window Date function also for SSR because the Date class can be lost
	'use strict';
	/*jshint eqnull:true */

	var lazysizes,
		/**
		 * @type { LazySizesConfigPartial }
		 */
		lazySizesCfg;

	(function(){
		var prop;

		var lazySizesDefaults = {
			lazyClass: 'lazyload',
			loadedClass: 'lazyloaded',
			loadingClass: 'lazyloading',
			preloadClass: 'lazypreload',
			errorClass: 'lazyerror',
			//strictClass: 'lazystrict',
			autosizesClass: 'lazyautosizes',
			fastLoadedClass: 'ls-is-cached',
			iframeLoadMode: 0,
			srcAttr: 'data-src',
			srcsetAttr: 'data-srcset',
			sizesAttr: 'data-sizes',
			//preloadAfterLoad: false,
			minSize: 40,
			customMedia: {},
			init: true,
			expFactor: 1.5,
			hFac: 0.8,
			loadMode: 2,
			loadHidden: true,
			ricTimeout: 0,
			throttleDelay: 125,
		};

		lazySizesCfg = window.lazySizesConfig || window.lazysizesConfig || {};

		for(prop in lazySizesDefaults){
			if(!(prop in lazySizesCfg)){
				lazySizesCfg[prop] = lazySizesDefaults[prop];
			}
		}
	})();

	if (!document || !document.getElementsByClassName) {
		return {
			init: function () {},
			/**
			 * @type { LazySizesConfigPartial }
			 */
			cfg: lazySizesCfg,
			/**
			 * @type { true }
			 */
			noSupport: true,
		};
	}

	var docElem = document.documentElement;

	var supportPicture = window.HTMLPictureElement;

	var _addEventListener = 'addEventListener';

	var _getAttribute = 'getAttribute';

	/**
	 * Update to bind to window because 'this' becomes null during SSR
	 * builds.
	 */
	var addEventListener = window[_addEventListener].bind(window);

	var setTimeout = window.setTimeout;

	var requestAnimationFrame = window.requestAnimationFrame || setTimeout;

	var requestIdleCallback = window.requestIdleCallback;

	var regPicture = /^picture$/i;

	var loadEvents = ['load', 'error', 'lazyincluded', '_lazyloaded'];

	var regClassCache = {};

	var forEach = Array.prototype.forEach;

	/**
	 * @param ele {Element}
	 * @param cls {string}
	 */
	var hasClass = function(ele, cls) {
		if(!regClassCache[cls]){
			regClassCache[cls] = new RegExp('(\\s|^)'+cls+'(\\s|$)');
		}
		return regClassCache[cls].test(ele[_getAttribute]('class') || '') && regClassCache[cls];
	};

	/**
	 * @param ele {Element}
	 * @param cls {string}
	 */
	var addClass = function(ele, cls) {
		if (!hasClass(ele, cls)){
			ele.setAttribute('class', (ele[_getAttribute]('class') || '').trim() + ' ' + cls);
		}
	};

	/**
	 * @param ele {Element}
	 * @param cls {string}
	 */
	var removeClass = function(ele, cls) {
		var reg;
		if ((reg = hasClass(ele,cls))) {
			ele.setAttribute('class', (ele[_getAttribute]('class') || '').replace(reg, ' '));
		}
	};

	var addRemoveLoadEvents = function(dom, fn, add){
		var action = add ? _addEventListener : 'removeEventListener';
		if(add){
			addRemoveLoadEvents(dom, fn);
		}
		loadEvents.forEach(function(evt){
			dom[action](evt, fn);
		});
	};

	/**
	 * @param elem { Element }
	 * @param name { string }
	 * @param detail { any }
	 * @param noBubbles { boolean }
	 * @param noCancelable { boolean }
	 * @returns { CustomEvent }
	 */
	var triggerEvent = function(elem, name, detail, noBubbles, noCancelable){
		var event = document.createEvent('Event');

		if(!detail){
			detail = {};
		}

		detail.instance = lazysizes;

		event.initEvent(name, !noBubbles, !noCancelable);

		event.detail = detail;

		elem.dispatchEvent(event);
		return event;
	};

	var updatePolyfill = function (el, full){
		var polyfill;
		if( !supportPicture && ( polyfill = (window.picturefill || lazySizesCfg.pf) ) ){
			if(full && full.src && !el[_getAttribute]('srcset')){
				el.setAttribute('srcset', full.src);
			}
			polyfill({reevaluate: true, elements: [el]});
		} else if(full && full.src){
			el.src = full.src;
		}
	};

	var getCSS = function (elem, style){
		return (getComputedStyle(elem, null) || {})[style];
	};

	/**
	 *
	 * @param elem { Element }
	 * @param parent { Element }
	 * @param [width] {number}
	 * @returns {number}
	 */
	var getWidth = function(elem, parent, width){
		width = width || elem.offsetWidth;

		while(width < lazySizesCfg.minSize && parent && !elem._lazysizesWidth){
			width =  parent.offsetWidth;
			parent = parent.parentNode;
		}

		return width;
	};

	var rAF = (function(){
		var running, waiting;
		var firstFns = [];
		var secondFns = [];
		var fns = firstFns;

		var run = function(){
			var runFns = fns;

			fns = firstFns.length ? secondFns : firstFns;

			running = true;
			waiting = false;

			while(runFns.length){
				runFns.shift()();
			}

			running = false;
		};

		var rafBatch = function(fn, queue){
			if(running && !queue){
				fn.apply(this, arguments);
			} else {
				fns.push(fn);

				if(!waiting){
					waiting = true;
					(document.hidden ? setTimeout : requestAnimationFrame)(run);
				}
			}
		};

		rafBatch._lsFlush = run;

		return rafBatch;
	})();

	var rAFIt = function(fn, simple){
		return simple ?
			function() {
				rAF(fn);
			} :
			function(){
				var that = this;
				var args = arguments;
				rAF(function(){
					fn.apply(that, args);
				});
			}
		;
	};

	var throttle = function(fn){
		var running;
		var lastTime = 0;
		var gDelay = lazySizesCfg.throttleDelay;
		var rICTimeout = lazySizesCfg.ricTimeout;
		var run = function(){
			running = false;
			lastTime = Date.now();
			fn();
		};
		var idleCallback = requestIdleCallback && rICTimeout > 49 ?
			function(){
				requestIdleCallback(run, {timeout: rICTimeout});

				if(rICTimeout !== lazySizesCfg.ricTimeout){
					rICTimeout = lazySizesCfg.ricTimeout;
				}
			} :
			rAFIt(function(){
				setTimeout(run);
			}, true)
		;

		return function(isPriority){
			var delay;

			if((isPriority = isPriority === true)){
				rICTimeout = 33;
			}

			if(running){
				return;
			}

			running =  true;

			delay = gDelay - (Date.now() - lastTime);

			if(delay < 0){
				delay = 0;
			}

			if(isPriority || delay < 9){
				idleCallback();
			} else {
				setTimeout(idleCallback, delay);
			}
		};
	};

	//based on http://modernjavascript.blogspot.de/2013/08/building-better-debounce.html
	var debounce = function(func) {
		var timeout, timestamp;
		var wait = 99;
		var run = function(){
			timeout = null;
			func();
		};
		var later = function() {
			var last = Date.now() - timestamp;

			if (last < wait) {
				setTimeout(later, wait - last);
			} else {
				(requestIdleCallback || run)(run);
			}
		};

		return function() {
			timestamp = Date.now();

			if (!timeout) {
				timeout = setTimeout(later, wait);
			}
		};
	};

	var loader = (function(){
		var preloadElems, isCompleted, resetPreloadingTimer, loadMode, started;

		var eLvW, elvH, eLtop, eLleft, eLright, eLbottom, isBodyHidden;

		var regImg = /^img$/i;
		var regIframe = /^iframe$/i;

		var supportScroll = ('onscroll' in window) && !(/(gle|ing)bot/.test(navigator.userAgent));

		var shrinkExpand = 0;
		var currentExpand = 0;

		var isLoading = 0;
		var lowRuns = -1;

		var resetPreloading = function(e){
			isLoading--;
			if(!e || isLoading < 0 || !e.target){
				isLoading = 0;
			}
		};

		var isVisible = function (elem) {
			if (isBodyHidden == null) {
				isBodyHidden = getCSS(document.body, 'visibility') == 'hidden';
			}

			return isBodyHidden || !(getCSS(elem.parentNode, 'visibility') == 'hidden' && getCSS(elem, 'visibility') == 'hidden');
		};

		var isNestedVisible = function(elem, elemExpand){
			var outerRect;
			var parent = elem;
			var visible = isVisible(elem);

			eLtop -= elemExpand;
			eLbottom += elemExpand;
			eLleft -= elemExpand;
			eLright += elemExpand;

			while(visible && (parent = parent.offsetParent) && parent != document.body && parent != docElem){
				visible = ((getCSS(parent, 'opacity') || 1) > 0);

				if(visible && getCSS(parent, 'overflow') != 'visible'){
					outerRect = parent.getBoundingClientRect();
					visible = eLright > outerRect.left &&
						eLleft < outerRect.right &&
						eLbottom > outerRect.top - 1 &&
						eLtop < outerRect.bottom + 1
					;
				}
			}

			return visible;
		};

		var checkElements = function() {
			var eLlen, i, rect, autoLoadElem, loadedSomething, elemExpand, elemNegativeExpand, elemExpandVal,
				beforeExpandVal, defaultExpand, preloadExpand, hFac;
			var lazyloadElems = lazysizes.elements;

			if((loadMode = lazySizesCfg.loadMode) && isLoading < 8 && (eLlen = lazyloadElems.length)){

				i = 0;

				lowRuns++;

				for(; i < eLlen; i++){

					if(!lazyloadElems[i] || lazyloadElems[i]._lazyRace){continue;}

					if(!supportScroll || (lazysizes.prematureUnveil && lazysizes.prematureUnveil(lazyloadElems[i]))){unveilElement(lazyloadElems[i]);continue;}

					if(!(elemExpandVal = lazyloadElems[i][_getAttribute]('data-expand')) || !(elemExpand = elemExpandVal * 1)){
						elemExpand = currentExpand;
					}

					if (!defaultExpand) {
						defaultExpand = (!lazySizesCfg.expand || lazySizesCfg.expand < 1) ?
							docElem.clientHeight > 500 && docElem.clientWidth > 500 ? 500 : 370 :
							lazySizesCfg.expand;

						lazysizes._defEx = defaultExpand;

						preloadExpand = defaultExpand * lazySizesCfg.expFactor;
						hFac = lazySizesCfg.hFac;
						isBodyHidden = null;

						if(currentExpand < preloadExpand && isLoading < 1 && lowRuns > 2 && loadMode > 2 && !document.hidden){
							currentExpand = preloadExpand;
							lowRuns = 0;
						} else if(loadMode > 1 && lowRuns > 1 && isLoading < 6){
							currentExpand = defaultExpand;
						} else {
							currentExpand = shrinkExpand;
						}
					}

					if(beforeExpandVal !== elemExpand){
						eLvW = innerWidth + (elemExpand * hFac);
						elvH = innerHeight + elemExpand;
						elemNegativeExpand = elemExpand * -1;
						beforeExpandVal = elemExpand;
					}

					rect = lazyloadElems[i].getBoundingClientRect();

					if ((eLbottom = rect.bottom) >= elemNegativeExpand &&
						(eLtop = rect.top) <= elvH &&
						(eLright = rect.right) >= elemNegativeExpand * hFac &&
						(eLleft = rect.left) <= eLvW &&
						(eLbottom || eLright || eLleft || eLtop) &&
						(lazySizesCfg.loadHidden || isVisible(lazyloadElems[i])) &&
						((isCompleted && isLoading < 3 && !elemExpandVal && (loadMode < 3 || lowRuns < 4)) || isNestedVisible(lazyloadElems[i], elemExpand))){
						unveilElement(lazyloadElems[i]);
						loadedSomething = true;
						if(isLoading > 9){break;}
					} else if(!loadedSomething && isCompleted && !autoLoadElem &&
						isLoading < 4 && lowRuns < 4 && loadMode > 2 &&
						(preloadElems[0] || lazySizesCfg.preloadAfterLoad) &&
						(preloadElems[0] || (!elemExpandVal && ((eLbottom || eLright || eLleft || eLtop) || lazyloadElems[i][_getAttribute](lazySizesCfg.sizesAttr) != 'auto')))){
						autoLoadElem = preloadElems[0] || lazyloadElems[i];
					}
				}

				if(autoLoadElem && !loadedSomething){
					unveilElement(autoLoadElem);
				}
			}
		};

		var throttledCheckElements = throttle(checkElements);

		var switchLoadingClass = function(e){
			var elem = e.target;

			if (elem._lazyCache) {
				delete elem._lazyCache;
				return;
			}

			resetPreloading(e);
			addClass(elem, lazySizesCfg.loadedClass);
			removeClass(elem, lazySizesCfg.loadingClass);
			addRemoveLoadEvents(elem, rafSwitchLoadingClass);
			triggerEvent(elem, 'lazyloaded');
		};
		var rafedSwitchLoadingClass = rAFIt(switchLoadingClass);
		var rafSwitchLoadingClass = function(e){
			rafedSwitchLoadingClass({target: e.target});
		};

		var changeIframeSrc = function(elem, src){
			var loadMode = elem.getAttribute('data-load-mode') || lazySizesCfg.iframeLoadMode;

			// loadMode can be also a string!
			if (loadMode == 0) {
				elem.contentWindow.location.replace(src);
			} else if (loadMode == 1) {
				elem.src = src;
			}
		};

		var handleSources = function(source){
			var customMedia;

			var sourceSrcset = source[_getAttribute](lazySizesCfg.srcsetAttr);

			if( (customMedia = lazySizesCfg.customMedia[source[_getAttribute]('data-media') || source[_getAttribute]('media')]) ){
				source.setAttribute('media', customMedia);
			}

			if(sourceSrcset){
				source.setAttribute('srcset', sourceSrcset);
			}
		};

		var lazyUnveil = rAFIt(function (elem, detail, isAuto, sizes, isImg){
			var src, srcset, parent, isPicture, event, firesLoad;

			if(!(event = triggerEvent(elem, 'lazybeforeunveil', detail)).defaultPrevented){

				if(sizes){
					if(isAuto){
						addClass(elem, lazySizesCfg.autosizesClass);
					} else {
						elem.setAttribute('sizes', sizes);
					}
				}

				srcset = elem[_getAttribute](lazySizesCfg.srcsetAttr);
				src = elem[_getAttribute](lazySizesCfg.srcAttr);

				if(isImg) {
					parent = elem.parentNode;
					isPicture = parent && regPicture.test(parent.nodeName || '');
				}

				firesLoad = detail.firesLoad || (('src' in elem) && (srcset || src || isPicture));

				event = {target: elem};

				addClass(elem, lazySizesCfg.loadingClass);

				if(firesLoad){
					clearTimeout(resetPreloadingTimer);
					resetPreloadingTimer = setTimeout(resetPreloading, 2500);
					addRemoveLoadEvents(elem, rafSwitchLoadingClass, true);
				}

				if(isPicture){
					forEach.call(parent.getElementsByTagName('source'), handleSources);
				}

				if(srcset){
					elem.setAttribute('srcset', srcset);
				} else if(src && !isPicture){
					if(regIframe.test(elem.nodeName)){
						changeIframeSrc(elem, src);
					} else {
						elem.src = src;
					}
				}

				if(isImg && (srcset || isPicture)){
					updatePolyfill(elem, {src: src});
				}
			}

			if(elem._lazyRace){
				delete elem._lazyRace;
			}
			removeClass(elem, lazySizesCfg.lazyClass);

			rAF(function(){
				// Part of this can be removed as soon as this fix is older: https://bugs.chromium.org/p/chromium/issues/detail?id=7731 (2015)
				var isLoaded = elem.complete && elem.naturalWidth > 1;

				if( !firesLoad || isLoaded){
					if (isLoaded) {
						addClass(elem, lazySizesCfg.fastLoadedClass);
					}
					switchLoadingClass(event);
					elem._lazyCache = true;
					setTimeout(function(){
						if ('_lazyCache' in elem) {
							delete elem._lazyCache;
						}
					}, 9);
				}
				if (elem.loading == 'lazy') {
					isLoading--;
				}
			}, true);
		});

		/**
		 *
		 * @param elem { Element }
		 */
		var unveilElement = function (elem){
			if (elem._lazyRace) {return;}
			var detail;

			var isImg = regImg.test(elem.nodeName);

			//allow using sizes="auto", but don't use. it's invalid. Use data-sizes="auto" or a valid value for sizes instead (i.e.: sizes="80vw")
			var sizes = isImg && (elem[_getAttribute](lazySizesCfg.sizesAttr) || elem[_getAttribute]('sizes'));
			var isAuto = sizes == 'auto';

			if( (isAuto || !isCompleted) && isImg && (elem[_getAttribute]('src') || elem.srcset) && !elem.complete && !hasClass(elem, lazySizesCfg.errorClass) && hasClass(elem, lazySizesCfg.lazyClass)){return;}

			detail = triggerEvent(elem, 'lazyunveilread').detail;

			if(isAuto){
				 autoSizer.updateElem(elem, true, elem.offsetWidth);
			}

			elem._lazyRace = true;
			isLoading++;

			lazyUnveil(elem, detail, isAuto, sizes, isImg);
		};

		var afterScroll = debounce(function(){
			lazySizesCfg.loadMode = 3;
			throttledCheckElements();
		});

		var altLoadmodeScrollListner = function(){
			if(lazySizesCfg.loadMode == 3){
				lazySizesCfg.loadMode = 2;
			}
			afterScroll();
		};

		var onload = function(){
			if(isCompleted){return;}
			if(Date.now() - started < 999){
				setTimeout(onload, 999);
				return;
			}


			isCompleted = true;

			lazySizesCfg.loadMode = 3;

			throttledCheckElements();

			addEventListener('scroll', altLoadmodeScrollListner, true);
		};

		return {
			_: function(){
				started = Date.now();

				lazysizes.elements = document.getElementsByClassName(lazySizesCfg.lazyClass);
				preloadElems = document.getElementsByClassName(lazySizesCfg.lazyClass + ' ' + lazySizesCfg.preloadClass);

				addEventListener('scroll', throttledCheckElements, true);

				addEventListener('resize', throttledCheckElements, true);

				addEventListener('pageshow', function (e) {
					if (e.persisted) {
						var loadingElements = document.querySelectorAll('.' + lazySizesCfg.loadingClass);

						if (loadingElements.length && loadingElements.forEach) {
							requestAnimationFrame(function () {
								loadingElements.forEach( function (img) {
									if (img.complete) {
										unveilElement(img);
									}
								});
							});
						}
					}
				});

				if(window.MutationObserver){
					new MutationObserver( throttledCheckElements ).observe( docElem, {childList: true, subtree: true, attributes: true} );
				} else {
					docElem[_addEventListener]('DOMNodeInserted', throttledCheckElements, true);
					docElem[_addEventListener]('DOMAttrModified', throttledCheckElements, true);
					setInterval(throttledCheckElements, 999);
				}

				addEventListener('hashchange', throttledCheckElements, true);

				//, 'fullscreenchange'
				['focus', 'mouseover', 'click', 'load', 'transitionend', 'animationend'].forEach(function(name){
					document[_addEventListener](name, throttledCheckElements, true);
				});

				if((/d$|^c/.test(document.readyState))){
					onload();
				} else {
					addEventListener('load', onload);
					document[_addEventListener]('DOMContentLoaded', throttledCheckElements);
					setTimeout(onload, 20000);
				}

				if(lazysizes.elements.length){
					checkElements();
					rAF._lsFlush();
				} else {
					throttledCheckElements();
				}
			},
			checkElems: throttledCheckElements,
			unveil: unveilElement,
			_aLSL: altLoadmodeScrollListner,
		};
	})();


	var autoSizer = (function(){
		var autosizesElems;

		var sizeElement = rAFIt(function(elem, parent, event, width){
			var sources, i, len;
			elem._lazysizesWidth = width;
			width += 'px';

			elem.setAttribute('sizes', width);

			if(regPicture.test(parent.nodeName || '')){
				sources = parent.getElementsByTagName('source');
				for(i = 0, len = sources.length; i < len; i++){
					sources[i].setAttribute('sizes', width);
				}
			}

			if(!event.detail.dataAttr){
				updatePolyfill(elem, event.detail);
			}
		});
		/**
		 *
		 * @param elem {Element}
		 * @param dataAttr
		 * @param [width] { number }
		 */
		var getSizeElement = function (elem, dataAttr, width){
			var event;
			var parent = elem.parentNode;

			if(parent){
				width = getWidth(elem, parent, width);
				event = triggerEvent(elem, 'lazybeforesizes', {width: width, dataAttr: !!dataAttr});

				if(!event.defaultPrevented){
					width = event.detail.width;

					if(width && width !== elem._lazysizesWidth){
						sizeElement(elem, parent, event, width);
					}
				}
			}
		};

		var updateElementsSizes = function(){
			var i;
			var len = autosizesElems.length;
			if(len){
				i = 0;

				for(; i < len; i++){
					getSizeElement(autosizesElems[i]);
				}
			}
		};

		var debouncedUpdateElementsSizes = debounce(updateElementsSizes);

		return {
			_: function(){
				autosizesElems = document.getElementsByClassName(lazySizesCfg.autosizesClass);
				addEventListener('resize', debouncedUpdateElementsSizes);
			},
			checkElems: debouncedUpdateElementsSizes,
			updateElem: getSizeElement
		};
	})();

	var init = function(){
		if(!init.i && document.getElementsByClassName){
			init.i = true;
			autoSizer._();
			loader._();
		}
	};

	setTimeout(function(){
		if(lazySizesCfg.init){
			init();
		}
	});

	lazysizes = {
		/**
		 * @type { LazySizesConfigPartial }
		 */
		cfg: lazySizesCfg,
		autoSizer: autoSizer,
		loader: loader,
		init: init,
		uP: updatePolyfill,
		aC: addClass,
		rC: removeClass,
		hC: hasClass,
		fire: triggerEvent,
		gW: getWidth,
		rAF: rAF,
	};

	return lazysizes;
}
));


/***/ }),

/***/ 29505:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(window, factory) {
	if(!window) {return;}
	var globalInstall = function(){
		factory(window.lazySizes);
		window.removeEventListener('lazyunveilread', globalInstall, true);
	};

	factory = factory.bind(null, window, window.document);

	if( true && module.exports){
		factory(__webpack_require__(77090));
	} else if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(77090)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}(typeof window != 'undefined' ?
	window : 0, function(window, document, lazySizes) {
	'use strict';

	var addObserver = function(){
		var connect, disconnect, observer, connected;
		var lsCfg = lazySizes.cfg;
		var attributes = {'data-bgset': 1, 'data-include': 1, 'data-poster': 1, 'data-bg': 1, 'data-script': 1};
		var regClassTest = '(\\s|^)(' + lsCfg.loadedClass;
		var docElem = document.documentElement;

		var setClass = function(target){
			lazySizes.rAF(function(){
				lazySizes.rC(target, lsCfg.loadedClass);
				if(lsCfg.unloadedClass){
					lazySizes.rC(target, lsCfg.unloadedClass);
				}
				lazySizes.aC(target, lsCfg.lazyClass);

				if(target.style.display == 'none' || (target.parentNode && target.parentNode.style.display == 'none')){
					setTimeout(function () {
						lazySizes.loader.unveil(target);
					}, 0);
				}
			});
		};

		var onMutation = function(mutations){
			var i, len, mutation, target;
			for(i = 0, len = mutations.length; i < len; i++){
				mutation = mutations[i];
				target = mutation.target;

				if(!target.getAttribute(mutation.attributeName)){continue;}

				if(target.localName == 'source' && target.parentNode){
					target = target.parentNode.querySelector('img');
				}

				if(target && regClassTest.test(target.className)){
					setClass(target);
				}
			}
		};

		if(lsCfg.unloadedClass){
			regClassTest += '|' + lsCfg.unloadedClass;
		}

		regClassTest += '|' + lsCfg.loadingClass + ')(\\s|$)';

		regClassTest = new RegExp(regClassTest);

		attributes[lsCfg.srcAttr] = 1;
		attributes[lsCfg.srcsetAttr] = 1;

		if(window.MutationObserver){
			observer = new MutationObserver(onMutation);

			connect = function(){
				if(!connected){
					connected = true;
					observer.observe( docElem, { subtree: true, attributes: true, attributeFilter: Object.keys(attributes)} );
				}
			};
			disconnect = function(){
				if(connected){
					connected = false;
					observer.disconnect();
				}
			};
		} else {
			docElem.addEventListener('DOMAttrModified', (function(){
				var runs;
				var modifications = [];
				var callMutations = function(){
					onMutation(modifications);
					modifications = [];
					runs = false;
				};
				return function(e){
					if(connected && attributes[e.attrName] && e.newValue){
						modifications.push({target: e.target, attributeName: e.attrName});
						if(!runs){
							setTimeout(callMutations);
							runs = true;
						}
					}
				};
			})(), true);

			connect = function(){
				connected = true;
			};
			disconnect = function(){
				connected = false;
			};
		}

		addEventListener('lazybeforeunveil', disconnect, true);
		addEventListener('lazybeforeunveil', connect);

		addEventListener('lazybeforesizes', disconnect, true);
		addEventListener('lazybeforesizes', connect);
		connect();

		removeEventListener('lazybeforeunveil', addObserver);
	};


	addEventListener('lazybeforeunveil', addObserver);
}));


/***/ }),

/***/ 18552:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),

/***/ 1989:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hashClear = __webpack_require__(51789),
    hashDelete = __webpack_require__(80401),
    hashGet = __webpack_require__(57667),
    hashHas = __webpack_require__(21327),
    hashSet = __webpack_require__(81866);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),

/***/ 38407:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var listCacheClear = __webpack_require__(27040),
    listCacheDelete = __webpack_require__(14125),
    listCacheGet = __webpack_require__(82117),
    listCacheHas = __webpack_require__(67518),
    listCacheSet = __webpack_require__(54705);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ 57071:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),

/***/ 83369:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(24785),
    mapCacheDelete = __webpack_require__(11285),
    mapCacheGet = __webpack_require__(96000),
    mapCacheHas = __webpack_require__(49916),
    mapCacheSet = __webpack_require__(95265);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),

/***/ 53818:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),

/***/ 58525:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),

/***/ 46384:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(38407),
    stackClear = __webpack_require__(37465),
    stackDelete = __webpack_require__(63779),
    stackGet = __webpack_require__(67599),
    stackHas = __webpack_require__(44758),
    stackSet = __webpack_require__(34309);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),

/***/ 62705:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ 11149:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ 70577:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),

/***/ 77412:
/***/ (function(module) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),

/***/ 34963:
/***/ (function(module) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),

/***/ 14636:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTimes = __webpack_require__(22545),
    isArguments = __webpack_require__(35694),
    isArray = __webpack_require__(1469),
    isBuffer = __webpack_require__(44144),
    isIndex = __webpack_require__(65776),
    isTypedArray = __webpack_require__(36719);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ 62488:
/***/ (function(module) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),

/***/ 34865:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(89465),
    eq = __webpack_require__(77813);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),

/***/ 18470:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var eq = __webpack_require__(77813);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ 44037:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(98363),
    keys = __webpack_require__(3674);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),

/***/ 63886:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(98363),
    keysIn = __webpack_require__(81704);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),

/***/ 89465:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var defineProperty = __webpack_require__(38777);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),

/***/ 85990:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(46384),
    arrayEach = __webpack_require__(77412),
    assignValue = __webpack_require__(34865),
    baseAssign = __webpack_require__(44037),
    baseAssignIn = __webpack_require__(63886),
    cloneBuffer = __webpack_require__(64626),
    copyArray = __webpack_require__(278),
    copySymbols = __webpack_require__(18805),
    copySymbolsIn = __webpack_require__(1911),
    getAllKeys = __webpack_require__(58234),
    getAllKeysIn = __webpack_require__(46904),
    getTag = __webpack_require__(64160),
    initCloneArray = __webpack_require__(43824),
    initCloneByTag = __webpack_require__(29148),
    initCloneObject = __webpack_require__(38517),
    isArray = __webpack_require__(1469),
    isBuffer = __webpack_require__(44144),
    isMap = __webpack_require__(56688),
    isObject = __webpack_require__(13218),
    isSet = __webpack_require__(72928),
    keys = __webpack_require__(3674),
    keysIn = __webpack_require__(81704);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),

/***/ 3118:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(13218);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),

/***/ 68866:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(62488),
    isArray = __webpack_require__(1469);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),

/***/ 44239:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705),
    getRawTag = __webpack_require__(89607),
    objectToString = __webpack_require__(2333);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ 9454:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ 25588:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getTag = __webpack_require__(64160),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),

/***/ 28458:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(23560),
    isMasked = __webpack_require__(15346),
    isObject = __webpack_require__(13218),
    toSource = __webpack_require__(80346);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ 29221:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getTag = __webpack_require__(64160),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),

/***/ 38749:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isLength = __webpack_require__(41780),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ 280:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPrototype = __webpack_require__(25726),
    nativeKeys = __webpack_require__(86916);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ 10313:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(13218),
    isPrototype = __webpack_require__(25726),
    nativeKeysIn = __webpack_require__(33498);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),

/***/ 22545:
/***/ (function(module) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ 7518:
/***/ (function(module) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ 74318:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Uint8Array = __webpack_require__(11149);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),

/***/ 64626:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(55639);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;


/***/ }),

/***/ 57157:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(74318);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),

/***/ 93147:
/***/ (function(module) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),

/***/ 40419:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),

/***/ 77133:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(74318);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),

/***/ 278:
/***/ (function(module) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),

/***/ 98363:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assignValue = __webpack_require__(34865),
    baseAssignValue = __webpack_require__(89465);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),

/***/ 18805:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(98363),
    getSymbols = __webpack_require__(99551);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),

/***/ 1911:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(98363),
    getSymbolsIn = __webpack_require__(51442);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),

/***/ 14429:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ 38777:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),

/***/ 31957:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

module.exports = freeGlobal;


/***/ }),

/***/ 58234:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(68866),
    getSymbols = __webpack_require__(99551),
    keys = __webpack_require__(3674);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),

/***/ 46904:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(68866),
    getSymbolsIn = __webpack_require__(51442),
    keysIn = __webpack_require__(81704);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),

/***/ 45050:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isKeyable = __webpack_require__(37019);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),

/***/ 10852:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsNative = __webpack_require__(28458),
    getValue = __webpack_require__(47801);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ 85924:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(5569);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),

/***/ 89607:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ 99551:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayFilter = __webpack_require__(34963),
    stubArray = __webpack_require__(70479);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),

/***/ 51442:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(62488),
    getPrototype = __webpack_require__(85924),
    getSymbols = __webpack_require__(99551),
    stubArray = __webpack_require__(70479);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),

/***/ 64160:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DataView = __webpack_require__(18552),
    Map = __webpack_require__(57071),
    Promise = __webpack_require__(53818),
    Set = __webpack_require__(58525),
    WeakMap = __webpack_require__(70577),
    baseGetTag = __webpack_require__(44239),
    toSource = __webpack_require__(80346);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),

/***/ 47801:
/***/ (function(module) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ 51789:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(94536);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),

/***/ 80401:
/***/ (function(module) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),

/***/ 57667:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(94536);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),

/***/ 21327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(94536);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),

/***/ 81866:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(94536);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),

/***/ 43824:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),

/***/ 29148:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(74318),
    cloneDataView = __webpack_require__(57157),
    cloneRegExp = __webpack_require__(93147),
    cloneSymbol = __webpack_require__(40419),
    cloneTypedArray = __webpack_require__(77133);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),

/***/ 38517:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseCreate = __webpack_require__(3118),
    getPrototype = __webpack_require__(85924),
    isPrototype = __webpack_require__(25726);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),

/***/ 65776:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ 37019:
/***/ (function(module) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),

/***/ 15346:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var coreJsData = __webpack_require__(14429);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ 25726:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ 27040:
/***/ (function(module) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ 14125:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(18470);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ 82117:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(18470);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ 67518:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(18470);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ 54705:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(18470);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ 24785:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Hash = __webpack_require__(1989),
    ListCache = __webpack_require__(38407),
    Map = __webpack_require__(57071);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),

/***/ 11285:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(45050);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),

/***/ 96000:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(45050);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),

/***/ 49916:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(45050);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),

/***/ 95265:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(45050);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),

/***/ 94536:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),

/***/ 86916:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(5569);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ 33498:
/***/ (function(module) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),

/***/ 31167:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var freeGlobal = __webpack_require__(31957);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;


/***/ }),

/***/ 2333:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 5569:
/***/ (function(module) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ 55639:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var freeGlobal = __webpack_require__(31957);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ 37465:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(38407);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),

/***/ 63779:
/***/ (function(module) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),

/***/ 67599:
/***/ (function(module) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),

/***/ 44758:
/***/ (function(module) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),

/***/ 34309:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(38407),
    Map = __webpack_require__(57071),
    MapCache = __webpack_require__(83369);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),

/***/ 80346:
/***/ (function(module) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ 50361:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseClone = __webpack_require__(85990);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

module.exports = cloneDeep;


/***/ }),

/***/ 77813:
/***/ (function(module) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ 35694:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(9454),
    isObjectLike = __webpack_require__(37005);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ 1469:
/***/ (function(module) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ 98612:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(23560),
    isLength = __webpack_require__(41780);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ 44144:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(55639),
    stubFalse = __webpack_require__(95062);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;


/***/ }),

/***/ 23560:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isObject = __webpack_require__(13218);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ 41780:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ 56688:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsMap = __webpack_require__(25588),
    baseUnary = __webpack_require__(7518),
    nodeUtil = __webpack_require__(31167);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),

/***/ 13218:
/***/ (function(module) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ 37005:
/***/ (function(module) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ 72928:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsSet = __webpack_require__(29221),
    baseUnary = __webpack_require__(7518),
    nodeUtil = __webpack_require__(31167);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),

/***/ 36719:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(38749),
    baseUnary = __webpack_require__(7518),
    nodeUtil = __webpack_require__(31167);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ 3674:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(14636),
    baseKeys = __webpack_require__(280),
    isArrayLike = __webpack_require__(98612);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ 81704:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(14636),
    baseKeysIn = __webpack_require__(10313),
    isArrayLike = __webpack_require__(98612);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),

/***/ 96486:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports =  true && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else {}
}.call(this));


/***/ }),

/***/ 70479:
/***/ (function(module) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ 95062:
/***/ (function(module) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ 7544:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(91203)


/***/ }),

/***/ 16361:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);
function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}

function SvgCalendarIcon(props) {
  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", _objectSpread(_objectSpread({ viewBox: "0 0 13 14", xmlns: "http://www.w3.org/2000/svg" }, props), {}, { children: /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M8.5 14a4 4 0 110-8 4 4 0 010 8zm0-7a3 3 0 100 6 3 3 0 000-6zm.795 4.5L8 10.205V8h1v1.795l1 1-.705.705zM12 2a1 1 0 00-1-1H9V0H8v1H4V0H3v1H1a1 1 0 00-1 1v10a1 1 0 001 1h2v-1H1V2h2v1h1V2h4v1h1V2h2v3h1V2z",
        fill: "#000",
        fillRule: "evenodd" }) })));



}

/* harmony default export */ __webpack_exports__["Z"] = (SvgCalendarIcon);

/***/ }),

/***/ 4333:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);
function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}

var SvgCameraIcon = function SvgCameraIcon(props) {return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", _objectSpread(_objectSpread({ viewBox: "0 0 14 11", xmlns: "http://www.w3.org/2000/svg" }, props), {}, { children: /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M3 3.19h4.5v1H3v-1Zm0 2.5h2.5v1H3v-1Zm6.5 4.5H1c-.552 0-1-.448-1-1v-8c0-.552.448-1 1-1h8.5c.552 0 1 .448 1 1v2.029l2.71-1.936a.5.5 0 0 1 .79.407v7a.5.5 0 0 1-.79.407L10.5 7.162V9.19c0 .552-.448 1-1 1Zm-8.5-9v8h8.5v-3a.5.5 0 0 1 .79-.407L13 7.718V2.662l-2.71 1.935a.5.5 0 0 1-.79-.407v-3H1Z",
        fill: "#000",
        fillRule: "evenodd" }) })));};




/* harmony default export */ __webpack_exports__["Z"] = (SvgCameraIcon);

/***/ }),

/***/ 32850:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);
function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}

var SvgExploreIcon = function SvgExploreIcon(props) {return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", _objectSpread(_objectSpread({ viewBox: "0 0 14 15", xmlns: "http://www.w3.org/2000/svg" }, props), {}, { children: /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M5 10H1V1.5h9v4h1v-4a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1V10a1 1 0 0 0 1 1h4v-1Zm9 3.79-1.555-1.555a3 3 0 1 0-.71.71L13.29 14.5l.71-.71Zm-4-1.29a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z",
        fill: "#000",
        fillRule: "evenodd" }) })));};




/* harmony default export */ __webpack_exports__["Z"] = (SvgExploreIcon);

/***/ }),

/***/ 17778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);
function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}

var SvgPlayIcon = function SvgPlayIcon(props) {return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", _objectSpread(_objectSpread({ viewBox: "0 0 14 14", xmlns: "http://www.w3.org/2000/svg" }, props), {}, { children: /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M7 1a6 6 0 1 1 0 12A6 6 0 0 1 7 1Zm0-1a7 7 0 1 0 0 14A7 7 0 0 0 7 0ZM5 10.5a.5.5 0 0 1-.5-.5V4a.5.5 0 0 1 .245-.43.5.5 0 0 1 .5 0l5.5 3a.5.5 0 0 1 0 .88l-5.5 3A.5.5 0 0 1 5 10.5Zm.5-5.66v4.32L9.455 7 5.5 4.84Z",
        fill: "#000",
        fillRule: "evenodd" }) })));};




/* harmony default export */ __webpack_exports__["Z"] = (SvgPlayIcon);

/***/ }),

/***/ 72194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);
function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}

var SvgSearchIcon = function SvgSearchIcon(props) {return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", _objectSpread(_objectSpread({ viewBox: "0 0 28 29", xmlns: "http://www.w3.org/2000/svg" }, props), {}, { children: /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M28 26.59 20.45 19A11 11 0 1 0 19 20.45L26.59 28 28 26.59ZM3 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0Z",
        fill: "#000",
        fillRule: "evenodd" }) })));};




/* harmony default export */ __webpack_exports__["Z"] = (SvgSearchIcon);

/***/ }),

/***/ 92137:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);
function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}

var SvgStoreIcon = function SvgStoreIcon(props) {return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", _objectSpread(_objectSpread({
      width: 14,
      height: 13,
      xmlns: "http://www.w3.org/2000/svg",
      role: "img" },
    props), {}, { children: /*#__PURE__*/

      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "m14 3.84-1-3a.5.5 0 0 0-.5-.34h-11a.5.5 0 0 0-.5.34l-1 3A.595.595 0 0 0 0 4v3a.5.5 0 0 0 .5.5H1v5h1v-5h3v5h8v-5h.5A.5.5 0 0 0 14 7V4a.595.595 0 0 0 0-.16Zm-2 7.66H6v-4h6v4Zm1-5h-2v-2h-1v2H7.5v-2h-1v2H4v-2H3v2H1V4.08l.86-2.58h10.28L13 4.08V6.5Z",
        fill: "#000",
        fillRule: "evenodd" }) })));};




/* harmony default export */ __webpack_exports__["Z"] = (SvgStoreIcon);

/***/ }),

/***/ 48740:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31157);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);
function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}


var Element = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({ displayName: "Divider__Element", componentId: "sc-rzbujb-0" })(["display:", ";border-bottom:1px solid ", ";@media (max-width:", "){display:", ";}"],
function (props) {return props.showMobile ? 'none' : 'block';},

function (props) {return (
    props.color ? props.color : props.theme.colors.secondary['gray-4']);},
function (props) {return "".concat(props.theme.viewports.tablet, "px");},
function (props) {return props.showMobile ? 'block' : null;});



var Divider = function Divider(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Element, _objectSpread({}, props));
};

/* harmony default export */ __webpack_exports__["Z"] = (Divider);

/***/ }),

/***/ 54444:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export icons */
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31157);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);
function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}


var icons = (/* unused pure expression or super */ null && ([
'ygb-icon-edit',
'ygb-icon-checkmark',
'ygb-icon-flashlight-dashboard', //not working reason: stroke wait for nother icon with filled color
'ygb-icon-heart-dashboard', //not working reason: stroke wait for nother icon with filled color
'ygb-icon-restart', //not working reason: stroke wait for nother icon with filled color
'ygb-icon-warning2',
'ygb-icon-backward2',
'ygb-icon-forward3',
'ygb-icon-first',
'ygb-icon-last',
'ygb-icon-previous2',
'ygb-icon-next2',
'ygb-icon-cast_connected',
'ygb-icon-cast',
'ygb-icon-calendar-o',
'ygb-icon-arrow-down',
'ygb-icon-arrow-left',
'ygb-icon-arrow-right',
'ygb-icon-arrow-up',
'ygb-icon-bloc',
'ygb-icon-calendar',
'ygb-icon-chevron-down',
'ygb-icon-chevron-down-alt',
'ygb-icon-chevron-left-alt',
'ygb-icon-chevron-right-alt',
'ygb-icon-chevron-up',
'ygb-icon-chevron-up-alt',
'ygb-icon-chevron-right',
'ygb-icon-chevron-left',
'ygb-icon-close',
'ygb-icon-download',
'ygb-icon-emoji1',
'ygb-icon-emoji2',
'ygb-icon-emoji3',
'ygb-icon-emoji4',
'ygb-icon-emoji5',
'ygb-icon-fullscreen-alt',
'ygb-icon-fullscreenb',
'ygb-icon-hamburgermenub',
'ygb-icon-heart-filled',
'ygb-icon-heart-outline',
'ygb-icon-infob',
'ygb-icon-list',
'ygb-icon-list-old',
'ygb-icon-menu-hor',
'ygb-icon-menu-verb',
'ygb-icon-play',
'ygb-icon-playlist',
'ygb-icon-play-video-large',
'ygb-icon-plus',
'ygb-icon-plus-alt',
'ygb-icon-questionb',
'ygb-icon-searchb',
'ygb-icon-settings',
'ygb-icon-share',
'ygb-icon-trash',
'ygb-icon-volume',
'ygb-icon-warningb',
'ygb-icon-yogobe',
'ygb-icon-dismiss',
'ygb-icon-remove',
'ygb-icon-close1',
'ygb-icon-cancel',
'ygb-icon-YBlogo-y',
'ygb-icon-yb-icon-alt',
'ygb-icon-facebook-ic',
'ygb-icon-instagram-ic',
'ygb-icon-linkedin-ic',
'ygb-icon-twitter-ic',
'ygb-icon-youtube-ic',
'ygb-icon-checkmark',
'ygb-icon-card-ic',
'ygb-icon-banktransfer-ic',
'ygb-icon-playlist-empty-ic',
'ygb-icon-yogobe-logo2019_1',
'ygb-icon-receiptsEmpty-ic',
'ygb-icon-programlenght-ic',
'ygb-icon-programlock-ic',
'ygb-icon-quiz-ic',
'ygb-icon-resume-ic',
'ygb-icon-stat1-ic',
'ygb-icon-stat2-ic',
'ygb-icon-stat3-ic',
'ygb-icon-stat4-ic',
'ygb-icon-youhere-ic',
'ygb-icon-Back-arrow-ic',
'ygb-icon-program-ic']));












var I = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].i.withConfig({ displayName: "Icon__I", componentId: "sc-1a7dbw3-0" })(["font-size:", ";line-height:", ";:before{", ";font-size:", ";color:", ";margin-right:", ";}", ""],
function (props) {return props.fontSize ? props.fontSize : '10px';},
function (props) {return props.fontSize ? props.fontSize : '10px';},

function (props) {return props.clickable ? 'cursor: pointer;' : null;},
function (props) {return props.fontSize ? props.fontSize : '10px';},
function (props) {return props.color ? props.color : null;},
function (p) {return p.mr ? p.mr : null;},

function (_ref) {var customStyle = _ref.customStyle;return customStyle;});




var Icon = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function (props, ref) {
  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(I, _objectSpread(_objectSpread({ ref: ref }, props), {}, { className: "".concat(props.name, " ").concat(props.className) })));

});

Icon.toString = I.toString;

/* harmony default export */ __webpack_exports__["Z"] = (Icon);

/***/ }),

/***/ 4338:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SY": function() { return /* binding */ FooterLink; },
/* harmony export */   "ee": function() { return /* binding */ Anchor; }
/* harmony export */ });
/* unused harmony exports AHeaderSpan, AHeader, A */
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31157);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);
var _excluded = ["className", "href", "children"];function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}




var AHeaderSpan = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].span.withConfig({ displayName: "Link__AHeaderSpan", componentId: "sc-czxuex-0" })(["color:", ";font-size:13px;text-decoration:none;cursor:pointer;&:hover{color:", ";}", ";"],
function (props) {return props.theme.colors.neutrals['black'];},





function (props) {return props.theme.colors.primary['blue-1'];},


function (props) {return (
    props.selected &&
    (0,styled_components__WEBPACK_IMPORTED_MODULE_4__.css)(["color:", ";"],
    function (props) {return props.theme.colors.primary['blue-1'];}));});



var AHeader = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].a.withConfig({ displayName: "Link__AHeader", componentId: "sc-czxuex-1" })(["color:", ";font-size:13px;text-decoration:none;cursor:pointer;&:hover{color:", ";}", ";"],
function (props) {return props.theme.colors.neutrals['black'];},





function (props) {return props.theme.colors.primary['blue-1'];},


function (props) {return (
    props.selected &&
    (0,styled_components__WEBPACK_IMPORTED_MODULE_4__.css)(["color:", ";"],
    function (props) {return props.theme.colors.primary['blue-1'];}));});



var A = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].a.withConfig({ displayName: "Link__A", componentId: "sc-czxuex-2" })(["color:", ";font-weight:", ";font-size:13px;text-decoration:none;cursor:pointer;&:hover{color:", ";}"],
function (props) {return (
    props.color ? props.color : props.theme.colors.primary['blue-2']);},
function (props) {return props.bold ? '600' : 'normal';},





function (props) {return (
    props.color ? props.color : props.theme.colors.primary['blue-1']);});



var FooterAnchor = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__["default"])(A).withConfig({ displayName: "Link__FooterAnchor", componentId: "sc-czxuex-3" })(["&:hover{color:", ";font-weight:bold;text-decoration:underline;}"],

function (props) {return (
    props.color ? props.color : props.theme.colors.neutrals['white']);});





var Link = function Link(props) {
  return /*#__PURE__*/ (
    // <NextLink href={props.href} as={props.asPath}>
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(A, { href: props.href, bold: props.bold, color: props.color, children:
      props.children })

    // </NextLink>
  );
};

var Anchor = function Anchor(_ref) {var _ref$className = _ref.className,className = _ref$className === void 0 ? '' : _ref$className,href = _ref.href,children = _ref.children,props = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), _objectSpread(_objectSpread({
      passHref: true,
      href: href,
      className: className,
      target: props.target,
      style: _objectSpread({ textDecoration: 'none' }, props.style) },
    props), {}, { children:

      children })));};




// created FooterLink/FooterAnchor because not sure if the Link is used outside of the footer
var FooterLink = function FooterLink(props) {
  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(FooterAnchor, { href: props.href, bold: props.bold, color: props.color, children:
      props.children }));


};

/* harmony default export */ __webpack_exports__["ZP"] = (Link);

/***/ }),

/***/ 35281:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "TQ": function() { return /* binding */ Link_; },
/* harmony export */   "jL": function() { return /* binding */ Banner; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31157);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(23855);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(82644);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(61436);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(33913);
/* harmony import */ var _components_Icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54444);
/* harmony import */ var _components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94007);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);
var _excluded = ["className", "closable", "show"];






var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div.withConfig({ displayName: "MessageStripe__Wrapper", componentId: "sc-16cj3r1-0" })(["display:flex;align-items:center;width:100%;min-height:50px;padding-left:20px;padding-right:20px;margin:0;background-color:", ";z-index:12;overflow:hidden;will-change:height;transition:height 500ms ease-out;"],







function (props) {return props.bg || '#ea6ea3';});







var Banner = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].p.withConfig({ displayName: "MessageStripe__Banner", componentId: "sc-16cj3r1-1" })(["color:", ";font-size:13px;line-height:16px;font-weight:200;margin:10px 0;a{color:", ";text-decoration:none;}"],
function (p) {return p._color;},






function (p) {return p._color;});




var Anchor = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__["default"])((next_link__WEBPACK_IMPORTED_MODULE_1___default())).withConfig({ displayName: "MessageStripe__Anchor", componentId: "sc-16cj3r1-2" })(["font-weight:600;cursor:pointer;"]);




var AnimatedBox = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__["default"])(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu).withConfig({ displayName: "MessageStripe__AnimatedBox", componentId: "sc-16cj3r1-3" })(["height:20px;width:20px;display:flex;align-items:center;justify-content:center;&:hover{transition:transform 200ms ease-in;transform:rotate(90deg);transform-origin:center;}"]);

























var Link_ = function Link_(_ref) {var href = _ref.href,_ref$target = _ref.target,target = _ref$target === void 0 ? null : _ref$target,_ref$children = _ref.children,children = _ref$children === void 0 ? '' : _ref$children;
  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(Anchor, { href: href, target: target, children:
      children }));


};

var MessageStripe = function MessageStripe(_ref2)




{var className = _ref2.className,_ref2$closable = _ref2.closable,closable = _ref2$closable === void 0 ? true : _ref2$closable,_ref2$show = _ref2.show,show = _ref2$show === void 0 ? true : _ref2$show,props = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_ref2, _excluded);
  var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),hideBanner = _useState[0],setHideBanner = _useState[1];

  var handleClose = function handleClose(e) {
    e.preventDefault();
    if (ref.current) {
      ref.current.style.height = '0px';
      setTimeout(function () {
        setHideBanner(true);
      }, 500);
    }
  };

  var shouldShow = show;
  // if props.show is false then if try the start&end Date
  if (show !== false && (props.startDate || props.endDate)) {
    var startDate = (0,date_fns__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(props.startDate);
    var endDate = (0,date_fns__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(props.endDate);

    // start date must not be in the future
    shouldShow = !(0,date_fns__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(startDate);

    if (shouldShow && (0,date_fns__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(endDate)) {
      shouldShow = !(0,date_fns__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(endDate);
    }
  }

  if (shouldShow) {
    return !hideBanner ? /*#__PURE__*/
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(Wrapper, {
      ref: ref,
      className: "MessageStripe " + (className !== null && className !== void 0 ? className : ''),
      bg: props.bg, children: /*#__PURE__*/



      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Container */ .W2, { px: [10, 10, 20], py: 0, flexDirection: "column", children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .kC, { alignItems: "center", justifyContent: "space-between", children: [/*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(Banner, { _color: props.color, children: props.children }),
          closable ? /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(AnimatedBox, { children: /*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
              name: "ygb-icon-close",
              color: props.color,
              onClick: handleClose,
              clickable: true }) }) :


          null] }) }) }) :



    null;
  }

  return null;
};

/* harmony default export */ __webpack_exports__["ZP"] = (MessageStripe);

/***/ }),

/***/ 24452:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31157);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);
var _excluded = ["className", "size", "spinnerColor", "style"];function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}


var SpinnerEl = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].span.withConfig({ displayName: "Spinner__SpinnerEl", componentId: "sc-15oetmu-0" })([".c-spinner{--spinner-duration:1.4s;--spinner-color:", ";--spinner-size:", ";--spinner-width:2px;position:relative;box-sizing:border-box;display:inline-block;height:var(--spinner-size);width:var(--spinner-size);animation:spinner-reveal var(--spinner-duration) steps(1,end) infinite,spinner-rotation var(--spinner-duration) ease-in-out infinite;clip-path:inset(0 0 0 50%);}.c-spinner::before,.c-spinner::after{box-sizing:border-box;content:'';width:100%;height:100%;border:var(--spinner-width) solid var(--spinner-color);border-radius:50%;position:absolute;top:0;left:0;clip-path:inset(0 50% 0 0);animation:spinner-rotation-a var(--spinner-duration) linear infinite;transition:border-color 0.5s ease-out;}.c-spinner::after{animation-name:spinner-rotation-b;}.c-spinner--big{--spinner-size:64px;}@keyframes spinner-rotation{100%{transform:rotate(360deg);}}@keyframes spinner-rotation-a{40%,60%{transform:rotate(180deg);}100%{transform:rotate(540deg);}}@keyframes spinner-rotation-b{40%{transform:rotate(180deg);}80%{transform:rotate(360deg);}100%{transform:rotate(540deg);}}@keyframes spinner-reveal{40%{clip-path:inset(0 0 0 0);}80%{clip-path:inset(0 50% 0 0);}}"],


function (_ref) {var spinnerColor = _ref.spinnerColor;return (
    spinnerColor ? spinnerColor : '#ffffff');},
function (_ref2) {var size = _ref2.size;return size ? "".concat(size, "px") : '16px';});














































































var Spinner = function Spinner(_ref3) {var
  className = _ref3.className,
  size = _ref3.size,
  spinnerColor = _ref3.spinnerColor,
  style = _ref3.style,
  otherProps = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref3, _excluded);return /*#__PURE__*/(

    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(SpinnerEl, _objectSpread(_objectSpread({
      className: className,
      size: size,
      style: style,
      spinnerColor: spinnerColor },
    otherProps), {}, { children: /*#__PURE__*/

      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", { className: "c-spinner" }) })));};



/* harmony default export */ __webpack_exports__["Z"] = (Spinner);

/***/ }),

/***/ 44154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var Stickable = function Stickable(props) {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),showSticky = _useState[0],setSticky = _useState[1];
  var scrollPosition = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(props.scrollAfterY);

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    scrollPosition.current = props.scrollAfterY;
  }, [props.scrollAfterY]);

  var handleScroll = function handleScroll() {
    if (window.scrollY >= scrollPosition.current) {
      setSticky(true);
    } else if (window.scrollY < scrollPosition.current) {
      setSticky(false);
    }
  };

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    window.addEventListener('scroll', handleScroll);
    return function () {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return props.children(showSticky);
};

/* harmony default export */ __webpack_exports__["Z"] = (Stickable);

/***/ }),

/***/ 49613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "er": function() { return /* binding */ StyledMaterialButton; }
/* harmony export */ });
/* unused harmony export colors */
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4730);
/* harmony import */ var _material_ui_core_Button__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(282);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31157);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54444);
/* harmony import */ var _layout_Span__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88865);
/* harmony import */ var _Spinner__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24452);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);
var _excluded = ["loading"];function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}






function colors(theme) {
  return {
    'default-blue': {
      backgroundColor: theme.colors.primary['blue-2'],
      hover: theme.colors.interactive['color-11'],
      active: theme.colors.interactive['color-12'],
      disabled: theme.colors.interactive['color-3'],
      color: theme.colors.neutrals['white'] },

    'default-pink': {
      backgroundColor: theme.colors.primary['pink-2'],
      hover: theme.colors.interactive['color-13'],
      active: theme.colors.interactive['color-14'],
      disabled: theme.colors.primary['pink-3'],
      color: theme.colors.neutrals['white'] },

    'default-green': {
      backgroundColor: theme.colors.secondary['green-4'],
      hover: theme.colors.interactive['color-9'],
      active: theme.colors.interactive['color-10'],
      disabled: theme.colors.interactive['color-2'],
      color: theme.colors.neutrals['white'] },

    'default-black': {
      backgroundColor: theme.colors.interactive['color-15'],
      hover: theme.colors.interactive['color-16'],
      active: theme.colors.interactive['color-17'],
      disabled: theme.colors.interactive['color-2'],
      color: theme.colors.neutrals['white'] },

    'default-white': {
      backgroundColor: theme.colors.neutrals['white'],
      hover: theme.colors.secondary['gray-4'],
      active: theme.colors.neutrals['white'],
      disabled: theme.colors.interactive['color-2'],
      color: theme.colors.neutrals['black'] },

    'default-gold': {
      backgroundColor: '#CCB375',
      hover: 'rgba(204, 179, 117, .8)',
      active: 'rgba(204, 179, 117, .8)',
      disabled: theme.colors.interactive['color-2'],
      color: theme.colors.neutrals['black'] },

    'default-purple': {
      backgroundColor: theme.colors.channels.meditation,
      hover: 'rgba(150, 87, 128, .8)',
      active: 'rgba(150, 87, 128, .8)',
      disabled: theme.colors.interactive['color-2'],
      color: theme.colors.neutrals['white'] },

    'dark-blue': {
      backgroundColor: 'rgb(36, 50, 64)',
      hover: 'rgba(36, 50, 64, 0.9)',
      active: 'rgba(36, 50, 64, 0.8)',
      disabled: 'rgba(36, 50, 64, 0.6)',
      color: theme.colors.neutrals['white'] },

    stone: {
      backgroundColor: theme.colors.primary.stone,
      hover: theme.colors.primary.stone,
      active: theme.colors.primary.stone,
      disabled: theme.colors.secondary['gray-4'],
      color: theme.colors.neutrals['white'] },

    'stone-outline': {
      backgroundColor: theme.colors.secondary['gray-5'],
      hover: theme.colors.primary.stone,
      active: theme.colors.primary.stone,
      disabled: theme.colors.secondary['gray-4'],
      color: theme.colors.primary.stone },

    green: {
      backgroundColor: theme.colors.primary.green,
      hover: theme.colors.primary.green,
      active: theme.colors.primary.green,
      disabled: theme.colors.secondary['gray-4'],
      color: theme.colors.neutrals['white'] } };


}

function sharedStyling(theme, width) {
  return "\n    cursor: pointer;\n    border: 0;\n    width: ".concat(


  width ? '100%' : 'auto', ";\n    font-weight: 600;\n    font-size: 13px;\n    outline: none;\n    &:first-letter {\n      text-transform: uppercase;\n    }\n  ");







}

function defaultStyling(
theme,
appearance,
borderRadiuslessRight,
borderRadiuslessLeft)
{
  return "\n    background-color: ".concat(
  colors(theme)[appearance].backgroundColor, ";\n    color: ").concat(
  colors(theme)[appearance].color, ";\n    \n    border-radius: 5px;\n    ").concat(


  borderRadiuslessRight ? 'border-top-right-radius: 0' : '', ";\n    ").concat(
  borderRadiuslessRight ? 'border-bottom-right-radius: 0' : '', ";\n    ").concat(
  borderRadiuslessLeft ? 'border-top-left-radius: 0' : '', ";\n    ").concat(
  borderRadiuslessLeft ? 'border-bottom-left-radius: 0' : '', ";\n    \n    padding: 12px 24px;\n\n    &:hover {\n      background-color: ").concat(




  colors(theme)[appearance].hover, ";\n    }\n\n    &:active {\n      background-color: ").concat(



  colors(theme)[appearance].active, ";\n    }\n\n    &:disabled{\n      background-color: ").concat(



  colors(theme)[appearance].disabled, ";\n      pointer-events: none;\n    }\n\n    i {\n      color: ").concat(




  colors(theme)[appearance].color, ";\n    }\n  ");


}

function linkStyling(_ref) {var theme = _ref.theme,color = _ref.color,alignement = _ref.alignement;
  return "\n    background-color: transparent;\n    color: ".concat(

  color ? color : theme.colors.primary['blue-2'], ";\n    &:hover {\n      color: ").concat(

  color ? color : theme.colors.primary['blue-1'], ";\n    }\n    &:disabled{\n      color: ").concat(


  theme.colors.neutrals['gray-3'], ";\n      cursor: not-allowed;\n      pointer-events: none;\n    }\n    padding: 0;\n    text-align: ").concat(




  alignement ? alignement : 'left', ";\n  ");

}

function outlineStyling(
theme,
active,
borderRadiuslessRight,
borderRadiuslessLeft,
color,
size)
{
  return "\n    background-color: ".concat(

  active ? theme.colors.primary['blue-2'] : 'rgba(255, 255, 255, 0.2)', ";\n    \n    ").concat(



  color ? "color: ".concat(
  color) : "color: ".concat(

  active ?
  theme.colors.neutrals['white'] :
  theme.colors.neutrals['gray'], ";"), "\n    \n    border-radius: ").concat(



  size === 'small' ? '3px' : '5px', ";\n    ").concat(
  borderRadiuslessRight || borderRadiuslessLeft ? 'margin: 0' : '', "\n    ").concat(
  borderRadiuslessRight ? 'border-top-right-radius: 0' : '', ";\n    ").concat(
  borderRadiuslessRight ? 'border-bottom-right-radius: 0' : '', ";\n    ").concat(
  borderRadiuslessLeft ? 'border-top-left-radius: 0' : '', ";\n    ").concat(
  borderRadiuslessLeft ? 'border-bottom-left-radius: 0' : '', ";\n    border: solid 1px ").concat(

  active ?
  theme.colors.primary['blue-2'] :
  theme.colors.neutrals['white-darkest'], ";\n    padding: ").concat(

  size === 'small' ? '5px' : '12px 24px', ";\n    \n    &:hover {\n      border-color: ").concat(


  theme.colors.primary['blue-2'], ";\n      color: ").concat(

  active ? theme.colors.neutrals.white : theme.colors.primary['blue-2'], ";\n    }\n\n    &:active {\n      border-color: ").concat(




  theme.colors.neutrals['gray-3'], ";\n      color: ").concat(

  active ? theme.colors.neutrals['white'] : theme.colors.neutrals['gray'], ";\n    }\n  ");



}

var Element = styled_components__WEBPACK_IMPORTED_MODULE_6__["default"].button.withConfig({ displayName: "buttons__Element", componentId: "sc-1ujyjlf-0" })(["", ";", ";", ";", ";"],
function (props) {return sharedStyling(props.theme, props.fullWidth);},

function (props) {return (
    props.appearance && props.appearance === 'link' ?
    linkStyling({
      theme: props.theme,
      color: props.color,
      alignement: props.alignement }) :

    null);},

function (props) {return (
    props.appearance && colors(props.theme).hasOwnProperty(props.appearance) ?
    defaultStyling(
    props.theme,
    props.appearance,
    props.borderRadiuslessRight,
    props.borderRadiuslessLeft) :

    null);},

function (props) {return (
    props.appearance && props.appearance === 'outline' ?
    outlineStyling(
    props.theme,
    props.active,
    props.borderRadiuslessRight,
    props.borderRadiuslessLeft,
    props.color,
    props.size) :

    null);});


var AnchorElement = styled_components__WEBPACK_IMPORTED_MODULE_6__["default"].a.withConfig({ displayName: "buttons__AnchorElement", componentId: "sc-1ujyjlf-1" })(["text-decoration:none;display:inline-block;text-align:center;", ";", ";", ";", ";", ";"],



function (props) {return sharedStyling(props.theme, props.fullWidth);},

function (props) {return (
    props.appearance && props.appearance === 'link' ?
    linkStyling({
      theme: props.theme,
      color: props.color,
      alignement: props.alignement }) :

    null);},

function (props) {return (
    props.appearance && props.appearance.startsWith('default') ?
    defaultStyling(
    props.theme,
    props.appearance,
    props.borderRadiuslessRight,
    props.borderRadiuslessLeft) :

    null);},

function (props) {return (
    props.appearance && colors(props.theme).hasOwnProperty(props.appearance) ?
    defaultStyling(
    props.theme,
    props.appearance,
    props.borderRadiuslessRight,
    props.borderRadiuslessLeft) :

    null);},

function (props) {return (
    props.appearance && props.appearance === 'outline' ?
    outlineStyling(
    props.theme,
    props.active,
    props.borderRadiuslessRight,
    props.borderRadiuslessLeft,
    props.color,
    props.size) :

    null);});


var _Button = function _Button(_ref2, ref) {var _ref2$loading = _ref2.loading,loading = _ref2$loading === void 0 ? false : _ref2$loading,props = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_ref2, _excluded);
  var E = props.href ? AnchorElement : Element;

  // button content
  var content = null;
  if (loading) {
    // TODO
    // all colors should get white
    // white / outline should get the grey spinner
    content = /*#__PURE__*/
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_Spinner__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
      spinnerColor: props.spinnerColor ? props.spinnerColor : '#7d7d7d' });


  } else if (props.icon) {
    content = /*#__PURE__*/
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, { children: [/*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_layout_Span__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, { marginRight: props.children ? 5 : 0, verticalInline: "middle", children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { name: props.icon, fontSize: props.iconSize }) }), /*#__PURE__*/

      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_layout_Span__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, { verticalInline: "middle", children: props.children })] });


  } else {
    content = props.children;
  }

  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(E, _objectSpread(_objectSpread({
      ref: ref,
      className: props.className,
      appearance: props.appearance ? props.appearance : 'default-blue',
      size: props.size,
      onClick: props.onClick,
      href: props.href,
      type: props.type,
      disabled: props.disabled || loading,
      fullWidth: props.fullWidth,
      alignement: props.alignement,
      active: props.active,
      borderRadiuslessRight: props.borderRadiuslessRight,
      borderRadiuslessLeft: props.borderRadiuslessLeft,
      color: props.color,
      style: props.style,
      target: props.target,
      download: props.download },
    props), {}, { children:

      content })));


};

var StyledMaterialButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__["default"])(_material_ui_core_Button__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z).withConfig({ displayName: "buttons__StyledMaterialButton", componentId: "sc-1ujyjlf-2" })(["&&{background-color:transparent;font-size:11px;font-weight:600;padding:0px;min-width:auto;min-height:100%;height:100%;color:#242424;white-space:pre;display:block;transition:color 300ms ease-in;&:hover{background-color:transparent;color:", ";transition:color 300ms ease-in;}}"],















function (props) {return props.theme.colors.interactive['color-7'];});





var Button = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(_Button);

/* harmony default export */ __webpack_exports__["ZP"] = (Button);

/***/ }),

/***/ 774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _lingui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85169);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31157);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var Element = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({ displayName: "FormGroup__Element", componentId: "sc-djz60g-0" })(["margin-bottom:", ";& > label{margin-bottom:7px;display:block;}label{font-size:13px;font-weight:600;letter-spacing:normal;color:", ";}"],
function (props) {return (
    'undefined' !== typeof props.marginBottom ? "".concat(
    props.marginBottom, "px") :
    '20px');},








function (props) {return props.theme.colors.neutrals.black;});


var HelperMessage = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({ displayName: "FormGroup__HelperMessage", componentId: "sc-djz60g-1" })(["color:", ";font-size:13px;margin-top:6px;"],
function (props) {return props.theme.colors.secondary['red-1'];});




var FormGroup = function FormGroup(props) {
  var dataTestId = props['data-testid'];

  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Element, { marginBottom: props.marginBottom, children: [
      props.children,
      !props.i18n && props.errorMsg ? /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(HelperMessage, { children:
        props.errorMsg }) :

      null,
      props.i18n && props.errorMsg ? /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(HelperMessage, { children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_3__/* .Trans */ .cC, { id: props.errorMsg }) }) :

      null] }));


};

FormGroup.defaultProps = {
  'data-testid': 'formGroup' };


/* harmony default export */ __webpack_exports__["Z"] = (FormGroup);

/***/ }),

/***/ 25077:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ TypographyCheckbox; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31157);
/* harmony import */ var _lib_theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62594);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);
var _excluded = ["className", "children"];function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}



var TypographyCheckbox = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].span.withConfig({ displayName: "Label__TypographyCheckbox", componentId: "sc-1ircllp-0" })(["font-size:13px;color:", ";& img{width:15px;margin-right:5px;}"],

function (props) {return props.labelColor ? props.labelColor : 'black';});







var Element = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].label.withConfig({ displayName: "Label__Element", componentId: "sc-1ircllp-1" })(["font-size:13px;font-weight:600;cursor:pointer;color:", ";"],



function (props) {return props.color ? props.color : _lib_theme__WEBPACK_IMPORTED_MODULE_2__/* ["default"].colors.neutrals.black */ .Z.colors.neutrals.black;});


var Label = function Label(_ref) {var _ref$className = _ref.className,className = _ref$className === void 0 ? '' : _ref$className,children = _ref.children,otherProps = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);
  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Element, _objectSpread(_objectSpread({ className: className }, otherProps), {}, { children:
      children })));


};

Label.toString = Element.toString;
/* harmony default export */ __webpack_exports__["Z"] = (Label);

/***/ }),

/***/ 74014:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31157);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);
function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}


var InputDesign = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].input.withConfig({ displayName: "NewInput__InputDesign", componentId: "sc-66e1g6-0" })(["width:100%;height:47px;font-size:16px;border:solid 1px #dddddd;border-radius:5px;padding:11px;background-color:#ffffff;outline:0;&:disabled{background-color:#f7f7f7;}&:focus{border:1px solid #129edc;}"]);




















var NewInput = function NewInput(props) {return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(InputDesign, _objectSpread({}, props));};

/* harmony default export */ __webpack_exports__["Z"] = (NewInput);

/***/ }),

/***/ 94007:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EO": function() { return /* binding */ ShowInMediumDown; },
/* harmony export */   "W2": function() { return /* binding */ Container; },
/* harmony export */   "X5": function() { return /* binding */ ShowInMediumOnly; },
/* harmony export */   "kC": function() { return /* reexport safe */ reflexbox_styled_components__WEBPACK_IMPORTED_MODULE_0__.kC; },
/* harmony export */   "n": function() { return /* binding */ ShowInSmallOnly; },
/* harmony export */   "tf": function() { return /* binding */ ShowInLargeUp; },
/* harmony export */   "vR": function() { return /* binding */ ShowInMediumUp; },
/* harmony export */   "xu": function() { return /* reexport safe */ reflexbox_styled_components__WEBPACK_IMPORTED_MODULE_0__.xu; }
/* harmony export */ });
/* unused harmony exports ShowInLargeDown, ShowInXSmallOnly, ShowInXMediumUp, ShowInXLargeDown, ShowInXLargeUp */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31157);
/* harmony import */ var reflexbox_styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78561);




var ShowInLargeDown = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].div.withConfig({ displayName: "Grid__ShowInLargeDown", componentId: "sc-yk8ati-0" })(["&&&{display:none;@media (max-width:", "){display:block;}}"],


function (props) {return "".concat(props.theme.viewports.laptop, "px");});





var ShowInMediumDown = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].div.withConfig({ displayName: "Grid__ShowInMediumDown", componentId: "sc-yk8ati-1" })(["&&&{display:none;@media (max-width:", "){display:block;}}"],


function (props) {return "".concat(props.theme.viewports.tablet, "px");});





var ShowInMediumOnly = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].div.withConfig({ displayName: "Grid__ShowInMediumOnly", componentId: "sc-yk8ati-2" })(["&&&{display:none;@media (min-width:", ") and (max-width:", "){display:block;}}"],


function (props) {return "".concat(
  props.theme.viewports.mobile, "px");}, function (props) {return "".concat(
  props.theme.viewports.tablet, "px");});





var ShowInSmallOnly = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].div.withConfig({ displayName: "Grid__ShowInSmallOnly", componentId: "sc-yk8ati-3" })(["&&&{display:none;@media (max-width:", "){display:block;}}"],


function (props) {return "".concat(props.theme.viewports.mobile, "px");});





var ShowInXSmallOnly = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].div.withConfig({ displayName: "Grid__ShowInXSmallOnly", componentId: "sc-yk8ati-4" })(["&&&{display:none;@media (max-width:", "){display:block;}}"],


function (props) {return "".concat(props.theme.viewports['x-small'], "px");});





var ShowInXMediumUp = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].div.withConfig({ displayName: "Grid__ShowInXMediumUp", componentId: "sc-yk8ati-5" })(["&&&{display:none;@media (min-width:", "){display:block;}}"],


function (props) {return "".concat(
  props.theme.viewports['x-small'] + 1, "px");});





var ShowInMediumUp = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].div.withConfig({ displayName: "Grid__ShowInMediumUp", componentId: "sc-yk8ati-6" })(["&&&{display:none;@media (min-width:", "){display:block;}}"],


function (props) {return "".concat(props.theme.viewports.mobile + 1, "px");});





var ShowInLargeUp = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].div.withConfig({ displayName: "Grid__ShowInLargeUp", componentId: "sc-yk8ati-7" })(["&&&{display:none;@media (min-width:", "){display:", ";", ";}}"],


function (props) {return "".concat(props.theme.viewports.tablet + 1, "px");},
function (props) {return props.display ? props.display : 'block';},
function (props) {return props.display === 'flex' ? "flex-direction: row;" : null;});




var ShowInXLargeDown = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].div.withConfig({ displayName: "Grid__ShowInXLargeDown", componentId: "sc-yk8ati-8" })(["&&&{display:none;@media (max-width:", "){display:block;}}"],


function (props) {return "".concat(props.theme.viewports.laptop, "px");});




var ShowInXLargeUp = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].div.withConfig({ displayName: "Grid__ShowInXLargeUp", componentId: "sc-yk8ati-9" })(["&&&{display:none;@media (min-width:", "){display:block;}}"],


function (props) {return "".concat(props.theme.viewports.laptop + 1, "px");});





var Container = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__["default"])(reflexbox_styled_components__WEBPACK_IMPORTED_MODULE_0__/* .Flex */ .kC).withConfig({ displayName: "Grid__Container", componentId: "sc-yk8ati-10" })(["width:100%;max-width:", ";margin-left:auto;margin-right:auto;"],

function (props) {return !props.fullWidth ? '1280px' : null;});

/***/ }),

/***/ 88865:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31157);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);



var Span = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].span.withConfig({ displayName: "Span", componentId: "sc-1grchtl-0" })(["", " ", " ", " ", " ", " ", " color:", ";font-size:", ";font-weight:", ";text-transform:", ";"],

function (props) {return (
    props.margin && "\n      margin: ".concat(

    props.margin, "px;\n    "));},


function (props) {return (
    props.marginBottom && "\n      margin-bottom: ".concat(

    props.marginBottom, "px;\n    "));},


function (props) {return (
    props.marginTop && "\n      margin-top: ".concat(

    props.marginTop, "px;\n    "));},


function (props) {return (
    props.marginLeft && "\n      margin-left: ".concat(

    props.marginLeft, "px;\n    "));},


function (props) {return (
    props.marginRight && "\n      margin-right: ".concat(

    props.marginRight, "px;\n    "));},


function (props) {return (
    props.verticalInline && "\n      display: inline-block;\n      vertical-align: ".concat(


    props.verticalInline, ";\n    "));},



function (props) {return props.color ? props.color : null;},

function (props) {return props.fontSize ? props.fontSize : null;},

function (props) {return props.bold ? '600' : 'normal';},

function (props) {return props.upperCase ? 'uppercase' : 'normal';});


var span = function span(props) {return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Span, {
      margin: props.margin,
      marginBottom: props.marginBottom,
      marginTop: props.marginTop,
      marginLeft: props.marginLeft,
      marginRight: props.marginRight,
      color: props.color,
      fontSize: props.fontSize,
      bold: props.bold,
      upperCase: props.upperCase,
      verticalInline: props.verticalInline, children:


      props.children }));};



/* harmony default export */ __webpack_exports__["Z"] = (span);

/***/ }),

/***/ 45945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$K": function() { return /* binding */ HelperSettingsSubscriptions; },
/* harmony export */   "$d": function() { return /* binding */ NextDayDateLabel; },
/* harmony export */   "Bc": function() { return /* binding */ ErrorMessage; },
/* harmony export */   "C3": function() { return /* binding */ ProgramIntroductionStyles; },
/* harmony export */   "CG": function() { return /* binding */ PlaylistsCollectionSubHeaderP; },
/* harmony export */   "Ck": function() { return /* binding */ ProgramCollapsibleTextTitle; },
/* harmony export */   "D5": function() { return /* binding */ DatePostCard; },
/* harmony export */   "DK": function() { return /* binding */ SubTitle; },
/* harmony export */   "DY": function() { return /* binding */ CardDescriptionDivStyledP; },
/* harmony export */   "Fx": function() { return /* binding */ ULFooter; },
/* harmony export */   "Hb": function() { return /* binding */ PSettingsReferralPrograms; },
/* harmony export */   "Ih": function() { return /* binding */ DescriptionPostCard; },
/* harmony export */   "Jf": function() { return /* binding */ ProgramsSchedule; },
/* harmony export */   "Kn": function() { return /* binding */ BlogSingeMeta; },
/* harmony export */   "Kx": function() { return /* binding */ BlogSingleH1; },
/* harmony export */   "L0": function() { return /* binding */ H2SectionHeader; },
/* harmony export */   "L7": function() { return /* binding */ SubTitlePosition; },
/* harmony export */   "Lq": function() { return /* binding */ ProgramsTotalVideosDuration; },
/* harmony export */   "OT": function() { return /* binding */ CategoryPostCard; },
/* harmony export */   "Qn": function() { return /* binding */ PSettingsHeaderTitle; },
/* harmony export */   "SG": function() { return /* binding */ InputActionTextHelper; },
/* harmony export */   "SZ": function() { return /* binding */ CardDescription; },
/* harmony export */   "T6": function() { return /* binding */ PSettingsFringeHealthBenefits; },
/* harmony export */   "U6": function() { return /* binding */ PlaylistsCollectionSubHeaderA; },
/* harmony export */   "WB": function() { return /* binding */ PCancelSubscriptionModal; },
/* harmony export */   "WF": function() { return /* binding */ PError; },
/* harmony export */   "Xi": function() { return /* binding */ H1Position; },
/* harmony export */   "Z0": function() { return /* binding */ PBanner; },
/* harmony export */   "Z7": function() { return /* binding */ H3PostCard; },
/* harmony export */   "ZE": function() { return /* binding */ EmptyResultsDescription; },
/* harmony export */   "Zo": function() { return /* binding */ InstructorMetaTitle; },
/* harmony export */   "_x": function() { return /* binding */ ProgramsTitle; },
/* harmony export */   "a1": function() { return /* binding */ ParagraphProgram; },
/* harmony export */   "aC": function() { return /* binding */ EmptyResultsTextAction; },
/* harmony export */   "b7": function() { return /* binding */ H3StaticPage; },
/* harmony export */   "c": function() { return /* binding */ CourseCardPrice; },
/* harmony export */   "d1": function() { return /* binding */ sectionTitleStyle; },
/* harmony export */   "e5": function() { return /* binding */ LIFooter; },
/* harmony export */   "eQ": function() { return /* binding */ ParagraphNewCourseCard; },
/* harmony export */   "ey": function() { return /* binding */ H2Position; },
/* harmony export */   "fd": function() { return /* binding */ PlaylistSingleTitle; },
/* harmony export */   "g6": function() { return /* binding */ TestimonialStatic; },
/* harmony export */   "gJ": function() { return /* binding */ CopyrightFooter; },
/* harmony export */   "gz": function() { return /* binding */ MainSubHeaderDescription; },
/* harmony export */   "iC": function() { return /* binding */ H3Position; },
/* harmony export */   "ll": function() { return /* binding */ CardTitle; },
/* harmony export */   "mR": function() { return /* binding */ PlaylistSingleMeta; },
/* harmony export */   "n1": function() { return /* binding */ PPosition; },
/* harmony export */   "nL": function() { return /* binding */ H1Error; },
/* harmony export */   "nT": function() { return /* binding */ MainSubHeaderTitle; },
/* harmony export */   "nw": function() { return /* binding */ H2Positions; },
/* harmony export */   "oA": function() { return /* binding */ PStaticPagePrison; },
/* harmony export */   "rU": function() { return /* binding */ LabelSettingsSubscriptions; },
/* harmony export */   "sm": function() { return /* binding */ ProgramCollapsibleTitleMeta; },
/* harmony export */   "sv": function() { return /* binding */ ProgramCardDuration; },
/* harmony export */   "uH": function() { return /* binding */ InstructorMetaDescription; },
/* harmony export */   "v5": function() { return /* binding */ NextDayTitle; },
/* harmony export */   "vo": function() { return /* binding */ DivStaticPage; },
/* harmony export */   "wG": function() { return /* binding */ PStaticPagePS; },
/* harmony export */   "wK": function() { return /* binding */ FormHelper; },
/* harmony export */   "wc": function() { return /* binding */ BioParagraphProfileHeader; },
/* harmony export */   "xM": function() { return /* binding */ EmptyResultsText; },
/* harmony export */   "zP": function() { return /* binding */ ProgramStepTitle; },
/* harmony export */   "zg": function() { return /* binding */ LanguagesMenuFooter; }
/* harmony export */ });
/* unused harmony exports resetMarginPadding, LISignup, ULConfirmPublicPlaylistModal, LIConfirmPublicPlaylistModal, PNewSubscriptionModal, PSignUp, ParagraphMeDashboard, PFaq, DescriptionHistoryItemCard, BodyPAccordion, HeaderPAccordion, Helper, NewsCardDate, NewsCardTitle, NewsCardDescription, TeamCardP, HomeStarterP, HomeAsSubscriber, HomeUlSubscriber, HomeLiSubscriber, H1Positions, PPositions, TitlePositions, DescriptionPositions, TestimonialText, TestimonialAuthor, StoreTitle, StoreDescription, EmptyResultsLi, EmptyResultsUl, PStaticPage, H4StaticPage, H5StaticPage, LiStaticPage, UlLiStyling, ProgressLabelPrograms, ProgramsDuration, ProgramsResume, ProgramsAccess, ProgramsLabel, ProgramsSingleBoxTitle, ProgramsSingleBoxDescription, ProgramTitleVideo, ProgramDescriptionVideo */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31157);


/**
 * Utils
 */

function resetMarginPadding() {
  return "\n    margin: 0;\n    padding: 0;\n  ";



}

var H1Error = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].h1.withConfig({ displayName: "texts__H1Error", componentId: "sc-1q907ux-0" })(["font-size:", ";color:", ";font-weight:bold;", " @media (max-width:", "){font-size:40px;}"],
function (p) {return p.fontSize ? p.fontSize : '80px';},
function (props) {return props.theme.colors.neutrals['white'];},

resetMarginPadding(),

function (props) {return "".concat(props.theme.viewports.mobile, "px");});




var PError = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({ displayName: "texts__PError", componentId: "sc-1q907ux-1" })(["font-size:24px;font-weight:300;color:", ";", ";a{color:", ";}"],


function (props) {return props.theme.colors.neutrals['white'];},
resetMarginPadding(),

function (props) {return props.theme.colors.neutrals['white'];});



var LISignup = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].li.withConfig({ displayName: "texts__LISignup", componentId: "sc-1q907ux-2" })(["font-size:13px;font-weight:normal;"]);




var ULConfirmPublicPlaylistModal = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].ul.withConfig({ displayName: "texts__ULConfirmPublicPlaylistModal", componentId: "sc-1q907ux-3" })(["font-size:13px;color:", ";"],

function (props) {return props.theme.colors.neutrals.black;});


var LIConfirmPublicPlaylistModal = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].li.withConfig({ displayName: "texts__LIConfirmPublicPlaylistModal", componentId: "sc-1q907ux-4" })(["margin-bottom:5px;"]);



var ULFooter = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].ul.withConfig({ displayName: "texts__ULFooter", componentId: "sc-1q907ux-5" })(["list-style-type:none;", " margin-top:20px;"],

resetMarginPadding());


var LIFooter = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].li.withConfig({ displayName: "texts__LIFooter", componentId: "sc-1q907ux-6" })(["margin-bottom:20px;font-size:16px;font-weight:300;& a{color:white;font-weight:normal;}"]);










var InputActionTextHelper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({ displayName: "texts__InputActionTextHelper", componentId: "sc-1q907ux-7" })(["margin-top:5px;font-size:13px;font-weight:300;font-style:italic;color:", ";", ";", ";"],







function (props) {return props.theme.colors.primary['black'];},

function (props) {return (
    props.success ? "color: ".concat(props.theme.colors.secondary['green-3'], ";") : '');},

function (props) {return (
    props.error ? "color: ".concat(props.theme.colors.secondary['red-1'], ";") : '');});


var PNewSubscriptionModal = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({ displayName: "texts__PNewSubscriptionModal", componentId: "sc-1q907ux-8" })(["max-width:30em;font-size:13px;font-weight:normal;margin:0;"]);






var ProgramCardDuration = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].span.withConfig({ displayName: "texts__ProgramCardDuration", componentId: "sc-1q907ux-9" })(["color:white;font-size:10px;font-weight:500;"]);




var CourseCardPrice = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].span.withConfig({ displayName: "texts__CourseCardPrice", componentId: "sc-1q907ux-10" })(["color:white;font-size:16px;font-weight:600;"]);





var PSignUp = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({ displayName: "texts__PSignUp", componentId: "sc-1q907ux-11" })(["font-size:13px;font-weight:normal;color:", ";"],


function (props) {return props.theme.colors.neutrals['black'];});


var ParagraphProgram = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({ displayName: "texts__ParagraphProgram", componentId: "sc-1q907ux-12" })(["font-size:16px;font-weight:normal;line-height:1.94;color:", ";", ";"],



function (props) {return props.theme.colors.neutrals.gray;},
resetMarginPadding());


var ParagraphMeDashboard = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({ displayName: "texts__ParagraphMeDashboard", componentId: "sc-1q907ux-13" })(["font-size:16px;", " color:", ";"],

resetMarginPadding(),
function (props) {return (
    props.color ? props.color : props.theme.colors.neutrals['black-ligther']);});


var PFaq = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({ displayName: "texts__PFaq", componentId: "sc-1q907ux-14" })(["font-size:13px;font-weight:normal;color:", ";margin:0;"],


function (props) {return props.theme.colors.neutrals.black;});



var PCancelSubscriptionModal = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({ displayName: "texts__PCancelSubscriptionModal", componentId: "sc-1q907ux-15" })(["font-size:13px;font-weight:normal;margin:0;"]);





var CopyrightFooter = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({ displayName: "texts__CopyrightFooter", componentId: "sc-1q907ux-16" })(["font-size:13px;font-weight:300;"]);




var LanguagesMenuFooter = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({ displayName: "texts__LanguagesMenuFooter", componentId: "sc-1q907ux-17" })(["font-size:16px;font-weight:300;margin:0;& a{color:white;font-weight:normal;}"]);










var ParagraphNewCourseCard = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({ displayName: "texts__ParagraphNewCourseCard", componentId: "sc-1q907ux-18" })(["", ";font-size:13px;color:", ";", ";"],
resetMarginPadding(),

function (props) {return props.theme.colors.neutrals.gray;},

function (props) {return props.italic ? 'font-style: italic;' : '';});


var DescriptionHistoryItemCard = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({ displayName: "texts__DescriptionHistoryItemCard", componentId: "sc-1q907ux-19" })(["font-size:13px;color:", ";margin:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"],

function (props) {return props.theme.colors.neutrals.gray;});






var PBanner = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({ displayName: "texts__PBanner", componentId: "sc-1q907ux-20" })(["color:", ";", " font-size:13px;line-height:16px;font-weight:", ";a{color:#fff;}"],
function (props) {return props.dark ? props.theme.colors.neutrals.black : "white";},
resetMarginPadding(),

function (props) {return props.bold ? 500 : 200;});





var BodyPAccordion = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({ displayName: "texts__BodyPAccordion", componentId: "sc-1q907ux-21" })(["font-size:13px;font-weight:normal;padding:0;margin:0;"]);






var HeaderPAccordion = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({ displayName: "texts__HeaderPAccordion", componentId: "sc-1q907ux-22" })(["font-size:13px;font-weight:600;color:", ";padding:0;margin:0;"],


function (props) {return props.theme.colors.primary['blue-2'];});




var LabelSettingsSubscriptions = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({ displayName: "texts__LabelSettingsSubscriptions", componentId: "sc-1q907ux-23" })(["font-size:16px;font-weight:600;color:", ";margin:0;margin-bottom:10px;"],


function (props) {return props.theme.colors.primary['black'];});




var HelperSettingsSubscriptions = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({ displayName: "texts__HelperSettingsSubscriptions", componentId: "sc-1q907ux-24" })(["font-size:13px;font-weight:300;color:", ";margin:0;margin-bottom:10px;font-style:", ";"],


function (props) {return props.theme.colors.primary['black'];},


function (props) {return props.italic ? 'italic' : null;});


var PSettingsReferralPrograms = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({ displayName: "texts__PSettingsReferralPrograms", componentId: "sc-1q907ux-25" })(["font-size:13px;font-weight:normal;color:", ";"],


function (props) {return props.theme.colors.neutrals['black'];});


var PSettingsHeaderTitle = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({ displayName: "texts__PSettingsHeaderTitle", componentId: "sc-1q907ux-26" })(["margin:0;font-size:13px;line-height:1.38;color:", ";font-style:italic;"],



function (props) {return props.theme.colors.neutrals.black;});



var PSettingsFringeHealthBenefits = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({ displayName: "texts__PSettingsFringeHealthBenefits", componentId: "sc-1q907ux-27" })(["font-size:13px;font-weight:normal;color:", ";"],


function (props) {return props.theme.colors.neutrals['black'];});


var Helper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({ displayName: "texts__Helper", componentId: "sc-1q907ux-28" })(["margin-top:5px;font-size:13px;font-weight:300;font-style:italic;color:", ";"],




function (props) {return props.theme.colors.primary['black'];});


var BioParagraphProfileHeader = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({ displayName: "texts__BioParagraphProfileHeader", componentId: "sc-1q907ux-29" })(["", " font-size:13px;color:", ";& a{color:", ";}"],
resetMarginPadding(),
function (props) {return props.theme.colors.neutrals.gray;},


function (props) {return props.theme.colors.primary['blue-2'];});



var NewsCardDate = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({ displayName: "texts__NewsCardDate", componentId: "sc-1q907ux-30" })(["margin:0;font-size:13px;font-weight:normal;"]);





var NewsCardTitle = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].h5.withConfig({ displayName: "texts__NewsCardTitle", componentId: "sc-1q907ux-31" })(["font-size:24px;font-weight:600;color:", ";"],


function (props) {return props.color;});


var NewsCardDescription = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({ displayName: "texts__NewsCardDescription", componentId: "sc-1q907ux-32" })(["margin:0;font-size:18px;font-weight:600;color:", ";"],



function (props) {return props.color;});


var TeamCardP = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({ displayName: "texts__TeamCardP", componentId: "sc-1q907ux-33" })(["font-size:24px;font-weight:600;line-height:32px;color:", ";"],



function (props) {return props.theme.colors.primary['blue-1'];});


var HomeStarterP = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({ displayName: "texts__HomeStarterP", componentId: "sc-1q907ux-34" })(["font-size:18px;font-weight:300;margin:0;color:", ";"],



function (props) {return props.theme.colors.neutrals.black;});


var HomeAsSubscriber = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({ displayName: "texts__HomeAsSubscriber", componentId: "sc-1q907ux-35" })(["font-size:18px;font-weight:300;color:", ";margin:0;"],


function (props) {return props.theme.colors.neutrals.black;});



var HomeUlSubscriber = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].ul.withConfig({ displayName: "texts__HomeUlSubscriber", componentId: "sc-1q907ux-36" })(["", ";"],
resetMarginPadding());


var HomeLiSubscriber = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].li.withConfig({ displayName: "texts__HomeLiSubscriber", componentId: "sc-1q907ux-37" })(["list-style-type:none;margin:0;margin-bottom:20px;font-size:16px;font-weight:600;color:", ";"],





function (props) {return props.theme.colors.neutrals.black;});


var H1Positions = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].h1.withConfig({ displayName: "texts__H1Positions", componentId: "sc-1q907ux-38" })(["font-size:16px;font-weight:600;margin:0;color:", ";padding:0;"],



function (props) {return props.theme.colors.neutrals.black;});



var PPositions = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({ displayName: "texts__PPositions", componentId: "sc-1q907ux-39" })(["font-size:13px;font-weight:normal;color:", ";", ";line-height:23px;"],


function (props) {return props.theme.colors.neutrals.black;},
resetMarginPadding());



var TitlePositions = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({ displayName: "texts__TitlePositions", componentId: "sc-1q907ux-40" })(["font-size:13px;font-weight:600;", " color:", ";"],


resetMarginPadding(),
function (props) {return props.theme.colors.neutrals.black;});


var DescriptionPositions = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({ displayName: "texts__DescriptionPositions", componentId: "sc-1q907ux-41" })(["font-size:13px;font-weight:normal;", " color:", ";"],


resetMarginPadding(),
function (props) {return props.theme.colors.neutrals.gray;});


var H2Positions = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].h2.withConfig({ displayName: "texts__H2Positions", componentId: "sc-1q907ux-42" })(["font-size:18px;font-weight:300;color:", ";", ";"],


function (props) {return props.theme.colors.neutrals.black;},
resetMarginPadding());


var H1Position = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].h1.withConfig({ displayName: "texts__H1Position", componentId: "sc-1q907ux-43" })(["font-size:34px;font-weight:300;", " color:", ";"],


resetMarginPadding(),
function (props) {return props.theme.colors.neutrals.black;});


var H2Position = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].h1.withConfig({ displayName: "texts__H2Position", componentId: "sc-1q907ux-44" })(["font-size:16px;font-weight:600;", " color:", ";"],


resetMarginPadding(),
function (props) {return props.theme.colors.neutrals.black;});


var H3Position = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].h1.withConfig({ displayName: "texts__H3Position", componentId: "sc-1q907ux-45" })(["font-size:13px;font-weight:600;", " color:", ";"],


resetMarginPadding(),
function (props) {return props.theme.colors.neutrals.black;});


var SubTitlePosition = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({ displayName: "texts__SubTitlePosition", componentId: "sc-1q907ux-46" })(["font-size:11px;font-weight:600;color:", ";", ";"],


function (props) {return props.theme.colors.neutrals.black;},
resetMarginPadding());


var SubTitle = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({ displayName: "texts__SubTitle", componentId: "sc-1q907ux-47" })(["font-size:13px;line-height:23px;color:", ";", ";margin-top:8px;", ""],


function (props) {return props.theme.colors.neutrals.black;},
resetMarginPadding(),



function (props) {return props.customStyle;});


var PPosition = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({ displayName: "texts__PPosition", componentId: "sc-1q907ux-48" })(["h2{margin-bottom:10px;color:", ";font-size:16px;font-weight:600;}p{font-size:13px;font-weight:normal;color:", ";", ";}ul{font-size:13px;font-weight:normal;color:", ";}"],


function (props) {return props.theme.colors.neutrals['black'];},







function (props) {return props.theme.colors.neutrals.black;},
resetMarginPadding(),





function (props) {return props.theme.colors.neutrals.black;});



var H2SectionHeader = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].h2.withConfig({ displayName: "texts__H2SectionHeader", componentId: "sc-1q907ux-49" })(["font-size:18px;font-weight:300;color:", ";margin:0;padding:0;line-height:40px;"],


function (props) {return props.theme.colors.neutrals.black;});





/**
 * PostCard
 */

var H3PostCard = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].h3.withConfig({ displayName: "texts__H3PostCard", componentId: "sc-1q907ux-50" })(["font-size:34px;font-weight:bold;", " color:", ";"],


resetMarginPadding(),
function (props) {return props.theme.colors.neutrals.black;});


var CategoryPostCard = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({ displayName: "texts__CategoryPostCard", componentId: "sc-1q907ux-51" })(["", " font-size:13px;font-weight:600;color:", ";"],
resetMarginPadding(),

function (props) {return props.theme.colors.neutrals.black;});


var DatePostCard = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({ displayName: "texts__DatePostCard", componentId: "sc-1q907ux-52" })(["font-size:13px;font-weight:normal;", " color:", ";"],


resetMarginPadding(),
function (props) {return props.theme.colors.neutrals.black;});


var DescriptionPostCard = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({ displayName: "texts__DescriptionPostCard", componentId: "sc-1q907ux-53" })(["font-size:18px;font-weight:300;", " color:", ";"],


resetMarginPadding(),
function (props) {return props.theme.colors.neutrals.black;});


/**
 * Layout
 */

var MainSubHeaderTitle = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].h1.withConfig({ displayName: "texts__MainSubHeaderTitle", componentId: "sc-1q907ux-54" })(["", ";color:#253238;font-size:48px;@media (max-width:", "){font-size:32px;}font-weight:bold;"],
resetMarginPadding(),


function (props) {return "".concat(props.theme.viewports.tablet, "px");});





var MainSubHeaderDescription = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({ displayName: "texts__MainSubHeaderDescription", componentId: "sc-1q907ux-55" })(["", ";color:#253238;font-size:13px;line-height:23px;"],
resetMarginPadding());





/**
 * Testimonial
 */

var TestimonialText = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({ displayName: "texts__TestimonialText", componentId: "sc-1q907ux-56" })(["font-size:30px;font-style:italic;font-weight:300;color:", ";", ";"],



function (props) {return props.theme.colors.neutrals.white;},
resetMarginPadding());


var TestimonialAuthor = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({ displayName: "texts__TestimonialAuthor", componentId: "sc-1q907ux-57" })(["font-size:16px;font-weight:600;color:", ";", ";"],


function (props) {return props.theme.colors.neutrals.white;},
resetMarginPadding());


/**
 * Yogobe Store
 */

var StoreTitle = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({ displayName: "texts__StoreTitle", componentId: "sc-1q907ux-58" })(["font-size:34px;font-weight:bold;color:", ";", ";"],


function (props) {return props.theme.colors.neutrals.white;},
resetMarginPadding());


var StoreDescription = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({ displayName: "texts__StoreDescription", componentId: "sc-1q907ux-59" })(["font-size:24px;font-weight:300;color:", ";", ";"],


function (props) {return props.theme.colors.neutrals.white;},
resetMarginPadding());


var CardTitle = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({ displayName: "texts__CardTitle", componentId: "sc-1q907ux-60" })(["font-size:16px;font-weight:600;text-decoration:none;", ";color:", ";white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"],



resetMarginPadding(),
function (props) {return props.theme.colors.neutrals.black;});





var CardDescriptionDivStyledP = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({ displayName: "texts__CardDescriptionDivStyledP", componentId: "sc-1q907ux-61" })(["display:-webkit-box;height:100%;font-size:14px;color:", ";line-height:19px;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;", ";"],



function (props) {return props.theme.colors.neutrals.gray;},




resetMarginPadding());


var CardDescription = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({ displayName: "texts__CardDescription", componentId: "sc-1q907ux-62" })(["display:-webkit-box;font-size:14px;color:", ";height:100%;line-height:22px;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;", ";"],


function (props) {return props.theme.colors.neutrals.gray;},





resetMarginPadding());


/**
 * EmptyResults
 */

var EmptyResultsText = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({ displayName: "texts__EmptyResultsText", componentId: "sc-1q907ux-63" })(["", ";font-size:18px;font-weight:300;"],
resetMarginPadding());




var EmptyResultsDescription = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({ displayName: "texts__EmptyResultsDescription", componentId: "sc-1q907ux-64" })(["max-width:700px;font-size:13px;color:", ";font-weight:300;text-align:center;margin-left:auto;margin-right:auto;", ";"],


function (props) {return props.theme.colors.neutrals['gray'];},




resetMarginPadding());


var EmptyResultsTextAction = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({ displayName: "texts__EmptyResultsTextAction", componentId: "sc-1q907ux-65" })(["", ";font-size:13px;color:", ";"],
resetMarginPadding(),

function (props) {return props.theme.colors.neutrals.gray;});


var EmptyResultsLi = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].li.withConfig({ displayName: "texts__EmptyResultsLi", componentId: "sc-1q907ux-66" })(["list-style-type:none;font-size:16px;font-weight:600;color:", ";margin:10px 10px;cursor:pointer;"],



function (props) {return props.theme.colors.neutrals.black;});




var EmptyResultsUl = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].ul.withConfig({ displayName: "texts__EmptyResultsUl", componentId: "sc-1q907ux-67" })(["padding:0;display:flex;flex-wrap:wrap;margin:0px -10px;justify-content:center;"]);







var PlaylistsCollectionSubHeaderA = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].a.withConfig({ displayName: "texts__PlaylistsCollectionSubHeaderA", componentId: "sc-1q907ux-68" })(["text-decoration:none;cursor:pointer;font-size:13px;font-weight:", ";", ";color:#404040;&:first-letter{text-transform:capitalize;}"],



function (props) {return props.bold ? 600 : 'normal';},
resetMarginPadding());






var PlaylistsCollectionSubHeaderP = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({ displayName: "texts__PlaylistsCollectionSubHeaderP", componentId: "sc-1q907ux-69" })(["font-size:13px;font-weight:", ";", ";color:#404040;&::first-letter{text-transform:uppercase;}"],

function (props) {return props.bold ? 600 : 'normal';},
resetMarginPadding());






var FormHelper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].span.withConfig({ displayName: "texts__FormHelper", componentId: "sc-1q907ux-70" })(["font-size:13px;font-weight:500;color:#e53b4d;"]);





/**
 * Instructor Meta
 */

var InstructorMetaTitle = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({ displayName: "texts__InstructorMetaTitle", componentId: "sc-1q907ux-71" })(["", ";font-size:13px;font-weight:600;"],
resetMarginPadding());




var InstructorMetaDescription = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({ displayName: "texts__InstructorMetaDescription", componentId: "sc-1q907ux-72" })(["", ";color:", ";font-size:13px;"],
resetMarginPadding(),
function (props) {return props.theme.colors.neutrals['black'];});



/**
 * Static Pages
 */

var H3StaticPage = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].h3.withConfig({ displayName: "texts__H3StaticPage", componentId: "sc-1q907ux-73" })(["", ";font-size:24px;font-weight:300;"],
resetMarginPadding());




var PStaticPage = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({ displayName: "texts__PStaticPage", componentId: "sc-1q907ux-74" })(["", ";color:", ";font-size:13px;"],
resetMarginPadding(),
function (props) {return props.theme.colors.neutrals['black'];});



var PStaticPagePrison = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({ displayName: "texts__PStaticPagePrison", componentId: "sc-1q907ux-75" })(["", ";color:", ";font-size:13px;line-height:23px;b{display:inline-block;margin:0;padding:0;}strong{margin:0;padding:0;}"],
resetMarginPadding(),
function (props) {return props.theme.colors.neutrals['black'];});












var PStaticPagePS = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({ displayName: "texts__PStaticPagePS", componentId: "sc-1q907ux-76" })(["", ";color:", ";font-size:13px;line-height:23px;b{display:inline-block;margin:0;padding:0;}strong{margin:0;padding:0;}ul{margin:0;margin-bottom:20px;padding-left:20px;list-style-type:none;li{&:before{font-family:'ygb-font' !important;speak:none;font-style:normal;font-weight:normal;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;content:'\\e944';color:#cd206a;margin-right:10px;}}}"],
resetMarginPadding(),
function (props) {return props.theme.colors.neutrals['black'];});





































var DivStaticPage = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({ displayName: "texts__DivStaticPage", componentId: "sc-1q907ux-77" })(["", ";color:", ";font-size:13px;"],
resetMarginPadding(),
function (props) {return props.theme.colors.neutrals['black'];});



var H4StaticPage = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].h4.withConfig({ displayName: "texts__H4StaticPage", componentId: "sc-1q907ux-78" })(["", ";color:", ";font-size:16px;font-weight:600;"],
resetMarginPadding(),
function (props) {return props.theme.colors.neutrals['black'];});




var H5StaticPage = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].h5.withConfig({ displayName: "texts__H5StaticPage", componentId: "sc-1q907ux-79" })(["", ";color:", ";font-size:13px;font-weight:600;"],
resetMarginPadding(),
function (props) {return props.theme.colors.neutrals['black'];});




var TestimonialStatic = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({ displayName: "texts__TestimonialStatic", componentId: "sc-1q907ux-80" })(["", ";color:", ";margin-top:17px;font-size:16px;line-height:24px;"],
resetMarginPadding(),
function (props) {return props.theme.colors.neutrals['black'];});





var LiStaticPage = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].li.withConfig({ displayName: "texts__LiStaticPage", componentId: "sc-1q907ux-81" })(["", ";font-size:13px;color:", ";"],
resetMarginPadding(),

function (props) {return props.theme.colors.neutrals['black'];});


var PlaylistSingleTitle = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].h2.withConfig({ displayName: "texts__PlaylistSingleTitle", componentId: "sc-1q907ux-82" })(["", ";font-size:18px;font-weight:300;color:", ";"],
resetMarginPadding(),


function (props) {return props.theme.colors.neutrals['black'];});


var PlaylistSingleMeta = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({ displayName: "texts__PlaylistSingleMeta", componentId: "sc-1q907ux-83" })(["", ";font-size:13px;font-weight:normal;color:", ";"],
resetMarginPadding(),


function (props) {return props.theme.colors.neutrals['gray'];});


var UlLiStyling = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({ displayName: "texts__UlLiStyling", componentId: "sc-1q907ux-84" })(["ul{font-size:13px;font-weight:normal;color:", ";}"],



function (props) {return props.theme.colors.neutrals.black;});



var BlogSingleH1 = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].h1.withConfig({ displayName: "texts__BlogSingleH1", componentId: "sc-1q907ux-85" })(["", ";font-size:34px;font-weight:normal;color:", ";font-weight:bold;@media (max-width:", "){font-size:14px;}"],
resetMarginPadding(),


function (props) {return props.theme.colors.neutrals.white;},

function (props) {return "".concat(props.theme.viewports.mobile, "px");});




var BlogSingeMeta = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].span.withConfig({ displayName: "texts__BlogSingeMeta", componentId: "sc-1q907ux-86" })(["", ";font-size:13px;font-weight:normal;color:", ";"],
resetMarginPadding(),


function (props) {return props.theme.colors.neutrals.black;});


var ProgressLabelPrograms = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].span.withConfig({ displayName: "texts__ProgressLabelPrograms", componentId: "sc-1q907ux-87" })(["", ";font-size:12px;font-weight:600;color:", ";"],
resetMarginPadding(),


function (props) {return props.theme.colors.neutrals.black;});


var ProgramsDuration = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].span.withConfig({ displayName: "texts__ProgramsDuration", componentId: "sc-1q907ux-88" })(["", ";font-size:13px;color:#444444;"],
resetMarginPadding());




var ProgramsResume = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].span.withConfig({ displayName: "texts__ProgramsResume", componentId: "sc-1q907ux-89" })(["", ";font-size:13px;color:", ";.bold{font-weight:600;}"],
resetMarginPadding(),

function (props) {return props.theme.colors.neutrals['black'];});






var ProgramsAccess = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].span.withConfig({ displayName: "texts__ProgramsAccess", componentId: "sc-1q907ux-90" })(["", ";font-size:13px;color:", ";font-style:italic;"],
resetMarginPadding(),

function (props) {return props.theme.colors.neutrals['gray'];});



var ProgramsLabel = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].span.withConfig({ displayName: "texts__ProgramsLabel", componentId: "sc-1q907ux-91" })(["", ";border-radius:5px;background-color:", ";color:white;padding:5px;margin-right:5px;font-size:11px;text-transform:uppercase;"],
resetMarginPadding(),

function (props) {return props.theme.colors.primary['blue-2'];});







var ProgramsTitle = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].span.withConfig({ displayName: "texts__ProgramsTitle", componentId: "sc-1q907ux-92" })(["", ";color:", ";font-weight:bold;font-size:24px;@media (max-width:", "){font-size:20px;}"],
resetMarginPadding(),
function (props) {return props.theme.colors.neutrals['black'];},



function (props) {return "".concat(props.theme.viewports.tablet, "px");});




var ProgramsSchedule = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({ displayName: "texts__ProgramsSchedule", componentId: "sc-1q907ux-93" })(["", ";font-weight:300;font-size:16px;color:", ";margin:0;@media (max-width:", "){text-align:center;}"],
resetMarginPadding(),


function (props) {return props.theme.colors.neutrals['gray'];},


function (props) {return "".concat(props.theme.viewports.tablet, "px");});




var ProgramsTotalVideosDuration = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({ displayName: "texts__ProgramsTotalVideosDuration", componentId: "sc-1q907ux-94" })(["", ";font-weight:600;font-size:11px;color:", ";@media (max-width:", "){text-align:center;}"],
resetMarginPadding(),


function (props) {return props.theme.colors.neutrals['black'];},

function (props) {return "".concat(props.theme.viewports.tablet, "px");});




var NextDayDateLabel = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].span.withConfig({ displayName: "texts__NextDayDateLabel", componentId: "sc-1q907ux-95" })(["font-size:13px;font-weight:600;color:", ";"],


function (props) {return props.theme.colors.neutrals['black'];});


var NextDayTitle = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].h3.withConfig({ displayName: "texts__NextDayTitle", componentId: "sc-1q907ux-96" })(["width:100%;font-size:16px;color:", ";font-weight:", ";margin:0;white-space:pre;overflow:hidden;text-overflow:ellipsis;"],


function (props) {return (
    props.isCurrent ? '#243240' : props.theme.colors.neutrals['black']);},
function (props) {return props.isCurrent ? 600 : 400;});






var ProgramsSingleBoxTitle = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({ displayName: "texts__ProgramsSingleBoxTitle", componentId: "sc-1q907ux-97" })(["", ";color:", ";font-size:24px;font-weight:300;"],
resetMarginPadding(),
function (props) {return props.theme.colors.neutrals['black'];});




var ProgramsSingleBoxDescription = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({ displayName: "texts__ProgramsSingleBoxDescription", componentId: "sc-1q907ux-98" })(["", ";color:", ";font-size:13px;"],
resetMarginPadding(),
function (props) {return props.theme.colors.neutrals['black'];});



var ProgramCollapsibleTextTitle = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({ displayName: "texts__ProgramCollapsibleTextTitle", componentId: "sc-1q907ux-99" })(["", ";display:flex;color:", ";font-size:22px;font-weight:400;@media (max-width:", "){font-size:18px;}"],
resetMarginPadding(),

function (props) {return props.theme.colors.neutrals['black'];},



function (props) {return "".concat(props.theme.viewports.tablet, "px");});




var ProgramCollapsibleTitleMeta = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({ displayName: "texts__ProgramCollapsibleTitleMeta", componentId: "sc-1q907ux-100" })(["", ";font-size:11px;font-weight:600;color:", ";text-transform:uppercase;"],
resetMarginPadding(),


function (props) {return props.theme.colors.neutrals['gray'];});



var ProgramIntroductionStyles = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({ displayName: "texts__ProgramIntroductionStyles", componentId: "sc-1q907ux-101" })(["ul{margin:0;padding:0;}p,li{font-size:16px;color:", ";margin:0;padding:0;line-height:23px;}"],








function (props) {return props.theme.colors.neutrals['black'];});






var ProgramTitleVideo = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({ displayName: "texts__ProgramTitleVideo", componentId: "sc-1q907ux-102" })(["color:", ";font-size:18px;font-weight:300;"],
function (props) {return props.theme.colors.neutrals['black'];});




var ProgramDescriptionVideo = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({ displayName: "texts__ProgramDescriptionVideo", componentId: "sc-1q907ux-103" })(["color:", ";font-size:13px;"],
function (props) {return props.theme.colors.neutrals['gray'];});



var ProgramStepTitle = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({ displayName: "texts__ProgramStepTitle", componentId: "sc-1q907ux-104" })(["display:flex;align-items:center;font-size:14px;color:", ";font-weight:600;"],



function (props) {return props.theme.colors.neutrals['black'];});



var sectionTitleStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["@media (max-width:", "px){font-size:14px;color:", ";font-weight:normal;line-height:1.4;}"],
function (_ref) {var theme = _ref.theme;return theme.viewports.mobile;},

function (_ref2) {var theme = _ref2.theme;return theme.colors.neutrals.black;});




//
var ErrorMessage = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({ displayName: "texts__ErrorMessage", componentId: "sc-1q907ux-105" })(["font-size:14px;color:", ";margin:10;"],

function (props) {return props.theme.colors.secondary['red-1'];});

/***/ }),

/***/ 94268:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H2": function() { return /* binding */ H2; },
/* harmony export */   "H3": function() { return /* binding */ H3; },
/* harmony export */   "H4": function() { return /* binding */ H4; },
/* harmony export */   "H5": function() { return /* binding */ H5; }
/* harmony export */ });
/* unused harmony exports H1, H6 */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31157);


var H1 = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].h1.withConfig({ displayName: "Headings__H1", componentId: "sc-ydbl0z-0" })(["font-size:34px;font-weight:300;color:", ";"],


function (props) {return props.theme.colors.neutrals.black;});


var H2 = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].h2.withConfig({ displayName: "Headings__H2", componentId: "sc-ydbl0z-1" })(["font-size:24px;font-weight:300;color:", ";"],


function (props) {return props.theme.colors.neutrals.black;});

var H3 = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].h3.withConfig({ displayName: "Headings__H3", componentId: "sc-ydbl0z-2" })(["font-size:18px;font-weight:", ";color:", ";text-transform:", ";text-transform:", ";margin:0;"],





function (props) {return props.bold ? '600' : '300';},
function (props) {return props.theme.colors.neutrals.black;},
function (props) {return props.uppercase ? 'uppercase' : null;},
function (props) {return props.capitalize ? 'capitalize' : null;});



var H4 = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].h4.withConfig({ displayName: "Headings__H4", componentId: "sc-ydbl0z-3" })(["font-size:16px;font-weight:", ";color:", ";text-transform:", ";text-transform:", ";"],





function (props) {return props.bold ? '600' : 'normal';},
function (props) {return (
    props.color ? props.color : props.theme.colors.neutrals.black);},
function (props) {return props.uppercase ? 'uppercase' : null;},
function (props) {return props.capitalize ? 'capitalize' : null;});


var H5 = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].h5.withConfig({ displayName: "Headings__H5", componentId: "sc-ydbl0z-4" })(["font-size:13px;font-weight:", ";color:", ";text-transform:", ";"],





function (props) {return props.bold ? '600' : 'normal';},
function (props) {return props.theme.colors.neutrals.black;},
function (props) {return props.uppercase ? 'uppercase' : null;});


var H6 = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].h1.withConfig({ displayName: "Headings__H6", componentId: "sc-ydbl0z-5" })(["font-size:11px;font-weight:600;color:", ";"],


function (props) {return props.theme.colors.neutrals.black;});

/***/ }),

/***/ 36225:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ P; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31157);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);
function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}


var Paragraph = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].p.withConfig({ displayName: "Paragraph", componentId: "sc-qwpn4r-0" })(["font-size:", ";color:", ";line-height:", ";font-weight:", ";"],
function (props) {return props.fontSize ? props.fontSize : "13px";},
function (_ref) {var color = _ref.color,theme = _ref.theme;return color ? color : theme.colors.neutrals.gray;},
function (props) {return props.lineHeight ? props.lineHeight : null;},
function (_ref2) {var fontWeight = _ref2.fontWeight,bold = _ref2.bold;
  if (bold) {
    return '600';
  } else {
    return fontWeight ? fontWeight : 'normal';
  }
});


var P = function P(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Paragraph, _objectSpread({}, props));
};

/***/ }),

/***/ 94371:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Yl": function() { return /* reexport */ companyFavorite; },
  "SR": function() { return /* reexport */ emailValidation; },
  "k8": function() { return /* reexport */ ios; }
});

// UNUSED EXPORTS: SafariBanner

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(92777);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(82262);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(10748);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(81531);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(63553);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(37247);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@lingui/react/esm/index.js + 1 modules
var esm = __webpack_require__(85169);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(31157);
// EXTERNAL MODULE: ./components/Icon.tsx
var Icon = __webpack_require__(54444);
// EXTERNAL MODULE: ./components/layout/Grid.ts
var Grid = __webpack_require__(94007);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./ecosystems/banner/companyFavorite.js
function _createSuper(Derived) {var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {var Super = (0,getPrototypeOf/* default */.Z)(Derived),result;if (hasNativeReflectConstruct) {var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);} else {result = Super.apply(this, arguments);}return (0,possibleConstructorReturn/* default */.Z)(this, result);};}function _isNativeReflectConstruct() {if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));return true;} catch (e) {return false;}}





var PBanner = styled_components_browser_esm["default"].div.withConfig({ displayName: "companyFavorite__PBanner", componentId: "sc-141e5j3-0" })(["color:", ";font-size:13px;margin:0;padding:0;line-height:24px;font-weight:", ";"],
function (props) {return props.dark ? props.theme.colors.neutrals.black : "white";},




function (props) {return props.bold ? 500 : 200;});


var Container = styled_components_browser_esm["default"].div.withConfig({ displayName: "companyFavorite__Container", componentId: "sc-141e5j3-1" })(["background-color:", ";width:100%;margin:0;z-index:8;padding:20px;border-radius:3px;"],
function (props) {return props.theme.colors.secondary['green-5'];});







var GraySectionWrapper = styled_components_browser_esm["default"].div.withConfig({ displayName: "companyFavorite__GraySectionWrapper", componentId: "sc-141e5j3-2" })(["background-color:#f7f7f7;"]);var



Banner = /*#__PURE__*/function (_Component) {(0,inherits/* default */.Z)(Banner, _Component);var _super = _createSuper(Banner);function Banner() {var _this;(0,classCallCheck/* default */.Z)(this, Banner);for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}_this = _super.call.apply(_super, [this].concat(args));(0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "state",
    {
      shown: false });(0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "closeBanner",








    function () {
      localStorage.setItem('closed_company_favorite_banner', true);
      _this.setState({
        shown: false });

    });return _this;}(0,createClass/* default */.Z)(Banner, [{ key: "componentDidMount", value: function componentDidMount() {this.setState({ shown: !localStorage.getItem('closed_company_favorite_banner') });} }, { key: "render", value:

    function render() {
      var shown = this.state.shown;
      var noBackground = this.props.noBackground;
      return shown ? /*#__PURE__*/
      (0,jsx_runtime.jsx)(Grid/* Container */.W2, {
        flexDirection: 'column',
        fullWidth: true,
        pt: "40px",
        mb: "0",
        as: !noBackground ? GraySectionWrapper : 'section', children: /*#__PURE__*/

        (0,jsx_runtime.jsx)(Grid/* Container */.W2, { px: [25, 25, 20], flexDirection: 'column', children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(Container, { children: /*#__PURE__*/
            (0,jsx_runtime.jsxs)(Grid/* Flex */.kC, { alignItems: "center", justifyContent: "space-between", children: [/*#__PURE__*/
              (0,jsx_runtime.jsx)(Grid/* Box */.xu, { mx: "10px", children: /*#__PURE__*/
                (0,jsx_runtime.jsx)(PBanner, { dark: true, bold: true, children: /*#__PURE__*/
                  (0,jsx_runtime.jsxs)(Grid/* Flex */.kC, { children: [/*#__PURE__*/
                    (0,jsx_runtime.jsx)(Grid/* Box */.xu, { mr: 15, children: /*#__PURE__*/
                      (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                        name: "ygb-icon-infob",
                        fontSize: '24px',
                        color: "rgba(0,0,0,0.54)" }) }), /*#__PURE__*/


                    (0,jsx_runtime.jsx)(Grid/* Box */.xu, { children: /*#__PURE__*/
                      (0,jsx_runtime.jsx)(esm/* Trans */.cC, {
                        id: "banner.companyFavorites",
                        message: "Any content that you save to favorites will be displayed in the\n                Overview as recommended content and will be visible to all\n                visitors" }) })] }) }) }), /*#__PURE__*/







              (0,jsx_runtime.jsx)(Grid/* Box */.xu, { mx: "10px", children: /*#__PURE__*/
                (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                  name: "ygb-icon-close",
                  color: "rgba(0,0,0,0.54)",
                  onClick: this.closeBanner }) })] }) }) }) }) :






      null;
    } }]);return Banner;}(react.Component);


/* harmony default export */ var companyFavorite = ((0,styled_components_browser_esm.withTheme)(Banner));
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(17674);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71383);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/@lingui/core/esm/index.js + 1 modules
var core_esm = __webpack_require__(94471);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(50319);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(12922);
// EXTERNAL MODULE: ./components/buttons.js
var buttons = __webpack_require__(49613);
// EXTERNAL MODULE: ./lib/apollo/policies/index.ts + 23 modules
var policies = __webpack_require__(54734);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./lib/CookieManager.ts + 1 modules
var CookieManager = __webpack_require__(64986);
// EXTERNAL MODULE: ./lib/constants.tsx
var constants = __webpack_require__(22498);
// EXTERNAL MODULE: ./components/MessageStripe.tsx
var MessageStripe = __webpack_require__(35281);
;// CONCATENATED MODULE: ./ecosystems/banner/emailValidation.js
var _templateObject;












var emailValidation_MessageStripe = (0,styled_components_browser_esm["default"])(MessageStripe/* default */.ZP).withConfig({ displayName: "emailValidation__MessageStripe", componentId: "sc-196u7aq-0" })(["", "{width:100%;padding:10px 0;margin:0;z-index:8;.resendEmail{color:white;font-weight:500;&[disabled]{pointer-events:initial;}}}"],
MessageStripe/* Banner */.jL);
















var RESEND_CONFIRMATION_EMAIL = (0,lib/* default */.ZP)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  mutation resendConfirmationEmail($email: String!) {\n    resendConfirmationEmail(email: $email) {\n      success\n    }\n  }\n"])));







var ENABLED_PATHS = [
{ path: '/[lang]/playlists', exact: false },
{ path: '/[lang]/videos', exact: false },
{ path: '/[lang]/me', exact: false },
{ path: '/[lang]/programs/[programId]', exact: false },
{ path: '/[lang]/c/[client]/b/[slug]', exact: false }];


var timeoutID;
var EmailValidationEmail = function EmailValidationEmail(_ref) {var currentUser = _ref.currentUser;
  var theme = (0,react.useContext)(styled_components_browser_esm.ThemeContext);
  var disabled = false;
  if (true) {
    disabled = !!CookieManager/* default.get */.Z.get({ key: constants/* VERIFICATION_EMAIL_SENT */.bU });
  }
  var _useState = (0,react.useState)(disabled),resendDisabled = _useState[0],setResendDisabled = _useState[1];
  var router = (0,next_router.useRouter)();
  var _useMutation = (0,useMutation/* useMutation */.D)(
  RESEND_CONFIRMATION_EMAIL),_useMutation2 = (0,slicedToArray/* default */.Z)(_useMutation, 2),resendConfirmationEmail = _useMutation2[0],loading = _useMutation2[1].loading;


  (0,react.useEffect)(function () {
    return function () {
      clearTimeout(timeoutID);
    };
  }, []);

  var allowed_on_page = ENABLED_PATHS.some(function (item) {
    if (item.exact && item.path === router.pathname) {
      return true;
    } else {
      return router.pathname.startsWith(item.path);
    }
  });

  if (!allowed_on_page) {
    return null;
  }

  var email = currentUser.email;

  var handleClick = /*#__PURE__*/function () {var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {return regenerator_default().wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:_context.next = 2;return (
                resendConfirmationEmail({
                  variables: {
                    email: email } }));case 2:


              (0,policies/* snackbarVar */.Ck)({
                isSnackBarOpen: true,
                goTo: 'NONE',
                id: 'resend_confirmation_email',
                snackBarMessage: core_esm/* i18n._ */.ag._( /*i18n*/{
                  id: 'account.verification_email_resent',
                  values: { email: email } }) });


              //
              setResendDisabled(true);
              CookieManager/* default.set */.Z.set(
              { key: constants/* VERIFICATION_EMAIL_SENT */.bU, value: '1' },
              // 1min
              1 / (24 * 60));

              timeoutID = setTimeout(function () {
                setResendDisabled(false);
                timeoutID = null;
              }, 60000);case 6:case "end":return _context.stop();}}}, _callee);}));return function handleClick() {return _ref2.apply(this, arguments);};}();


  return /*#__PURE__*/(
    (0,jsx_runtime.jsx)(emailValidation_MessageStripe, {
      color: theme.colors.neutrals.white,
      bg: theme.colors.primary['blue-5'],
      closable: false, children:

      currentUser !== null && currentUser !== void 0 && currentUser.previousEmail ? /*#__PURE__*/
      (0,jsx_runtime.jsx)(esm/* Trans */.cC, {
        id: "banner.email_verify_change_settings",
        components: [/*#__PURE__*/
        (0,jsx_runtime.jsx)(buttons/* default */.ZP, {

          className: "resendEmail",
          appearance: "link",
          onClick: handleClick,
          disabled: resendDisabled,
          loading: loading }, "summerCampaign")] }) : /*#__PURE__*/




      (0,jsx_runtime.jsx)(esm/* Trans */.cC, {
        id: 'banner.email_verify',
        values: { email: email },
        components: [/*#__PURE__*/
        (0,jsx_runtime.jsx)(buttons/* default */.ZP, {

          className: "resendEmail",
          appearance: "link",
          onClick: handleClick,
          disabled: resendDisabled,
          loading: loading }, "summerCampaign")] }) }));






};
/* harmony default export */ var emailValidation = (EmailValidationEmail);
// EXTERNAL MODULE: ./components/texts.tsx
var texts = __webpack_require__(45945);
;// CONCATENATED MODULE: ./ecosystems/banner/ios.js
function ios_createSuper(Derived) {var hasNativeReflectConstruct = ios_isNativeReflectConstruct();return function _createSuperInternal() {var Super = (0,getPrototypeOf/* default */.Z)(Derived),result;if (hasNativeReflectConstruct) {var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);} else {result = Super.apply(this, arguments);}return (0,possibleConstructorReturn/* default */.Z)(this, result);};}function ios_isNativeReflectConstruct() {if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));return true;} catch (e) {return false;}}







var ios_Container = styled_components_browser_esm["default"].div.withConfig({ displayName: "ios__Container", componentId: "sc-c950f9-0" })(["background-color:", ";width:100%;margin:0;z-index:8;padding:10px 20px;"],
function (props) {return props.theme.colors.primary['blue-5'];});var






ios_Banner = /*#__PURE__*/function (_Component) {(0,inherits/* default */.Z)(Banner, _Component);var _super = ios_createSuper(Banner);function Banner() {var _this;(0,classCallCheck/* default */.Z)(this, Banner);for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}_this = _super.call.apply(_super, [this].concat(args));(0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "state",
    {
      shown: false });(0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "isiOS",


    function () {return navigator.userAgent.match(/iPhone|iPad|iPod/i);});(0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "closeBanner",

    function () {
      CookieManager/* default.set */.Z.set({ key: 'closed_ios_banner', value: true });
      _this.setState({
        shown: false });

    });return _this;}(0,createClass/* default */.Z)(Banner, [{ key: "componentDidMount", value:

    function componentDidMount() {
      this.setState({
        shown: this.isiOS() && !CookieManager/* default.get */.Z.get({ key: 'closed_ios_banner' }) });

    } }, { key: "render", value:

    function render() {
      var shown = this.state.shown;
      return shown ? /*#__PURE__*/
      (0,jsx_runtime.jsx)(ios_Container, { children: /*#__PURE__*/
        (0,jsx_runtime.jsx)(Grid/* Container */.W2, { flexDirection: 'column', children: /*#__PURE__*/
          (0,jsx_runtime.jsxs)(Grid/* Flex */.kC, { alignItems: "center", justifyContent: "space-between", children: [/*#__PURE__*/
            (0,jsx_runtime.jsx)(Grid/* Box */.xu, { mx: "10px", children: /*#__PURE__*/
              (0,jsx_runtime.jsx)(texts/* PBanner */.Z0, { children: /*#__PURE__*/
                (0,jsx_runtime.jsx)(esm/* Trans */.cC, {
                  id: "banner.castBanner",
                  message: "We have just released a new cast feature. To watch the videos on your TV, use airplay or chromecast* (*Is not currently supported on iOS)" }) }) }), /*#__PURE__*/



            (0,jsx_runtime.jsx)(Grid/* Box */.xu, { mx: "10px", children: /*#__PURE__*/
              (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                name: "ygb-icon-close",
                color: "rgba(0,0,0,0.54)",
                onClick: this.closeBanner }) })] }) }) }) :





      null;
    } }]);return Banner;}(react.Component);


/* harmony default export */ var ios = (ios_Banner);
;// CONCATENATED MODULE: ./ecosystems/banner/safari.js
function safari_createSuper(Derived) {var hasNativeReflectConstruct = safari_isNativeReflectConstruct();return function _createSuperInternal() {var Super = (0,getPrototypeOf/* default */.Z)(Derived),result;if (hasNativeReflectConstruct) {var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);} else {result = Super.apply(this, arguments);}return (0,possibleConstructorReturn/* default */.Z)(this, result);};}function safari_isNativeReflectConstruct() {if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));return true;} catch (e) {return false;}}






var safari_Container = styled_components_browser_esm["default"].div.withConfig({ displayName: "safari__Container", componentId: "sc-lgegux-0" })(["background-color:", ";width:100%;margin:0;z-index:8;padding:20px;"],
function (props) {return props.theme.colors.primary['blue-5'];});var






safari_Banner = /*#__PURE__*/function (_Component) {(0,inherits/* default */.Z)(Banner, _Component);var _super = safari_createSuper(Banner);function Banner() {var _this;(0,classCallCheck/* default */.Z)(this, Banner);for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}_this = _super.call.apply(_super, [this].concat(args));(0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "state",
    {
      shown: false });(0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "isSafari",


    function () {
      return /constructor/i.test(window.HTMLElement) ||
      function (p) {
        return p.toString() === '[object SafariRemoteNotification]';
      }(
      !window['safari'] ||
      typeof safari !== 'undefined' && safari.pushNotification) ||

      window.navigator.userAgent.match(/iPad/i) ||
      window.navigator.userAgent.match(/iPhone/i);
      // return /^((?!chrome|android|crios|fxios).)*safari/i.test(
      //   navigator.userAgent
      // );
    });return _this;}(0,createClass/* default */.Z)(Banner, [{ key: "componentDidMount", value:

    function componentDidMount() {
      this.setState({
        shown: this.isSafari() });

    } }, { key: "render", value:

    function render() {
      var shown = this.state.shown;
      return shown ? /*#__PURE__*/
      (0,jsx_runtime.jsx)(safari_Container, { children: /*#__PURE__*/
        (0,jsx_runtime.jsx)(Grid/* Container */.W2, { flexDirection: 'column', children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(Grid/* Flex */.kC, { alignItems: "center", justifyContent: "space-between", children: /*#__PURE__*/
            (0,jsx_runtime.jsx)(Grid/* Box */.xu, { mx: "10px", children: /*#__PURE__*/
              (0,jsx_runtime.jsxs)(texts/* PBanner */.Z0, { children: [/*#__PURE__*/
                (0,jsx_runtime.jsx)(esm/* Trans */.cC, {
                  id: "banner.download_chrome",
                  message: "When watching a video, you might experience some issues in Safari. We highly recommend using" }), " ", /*#__PURE__*/


                (0,jsx_runtime.jsx)(buttons/* default */.ZP, {
                  appearance: "link",
                  target: '_blank',
                  href: 'https://www.google.com/chrome/', children: /*#__PURE__*/

                  (0,jsx_runtime.jsx)(esm/* Trans */.cC, {
                    id: "banner.download_chrome_action",
                    message: "Google Chrome." }) })] }) }) }) }) }) :







      null;
    } }]);return Banner;}(react.Component);


/* harmony default export */ var banner_safari = ((/* unused pure expression or super */ null && (safari_Banner)));
;// CONCATENATED MODULE: ./ecosystems/banner/index.js





/***/ }),

/***/ 25322:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "D": function() { return /* binding */ Title; },
  "Z": function() { return /* binding */ login_LoginForm; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(17674);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/@lingui/core/esm/index.js + 1 modules
var esm = __webpack_require__(94471);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(31157);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@lingui/react/esm/index.js + 1 modules
var react_esm = __webpack_require__(85169);
// EXTERNAL MODULE: ./components/buttons.js
var buttons = __webpack_require__(49613);
// EXTERNAL MODULE: ./components/layout/Grid.ts
var Grid = __webpack_require__(94007);
// EXTERNAL MODULE: ./lib/helpers.ts
var helpers = __webpack_require__(32460);
// EXTERNAL MODULE: ./lib/contexts/languageContext.js
var languageContext = __webpack_require__(17516);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(92777);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(82262);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(10748);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(81531);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(63553);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(37247);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71383);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/components/Mutation.js
var Mutation = __webpack_require__(63659);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(12922);
// EXTERNAL MODULE: ./components/typography/Headings.tsx
var Headings = __webpack_require__(94268);
// EXTERNAL MODULE: ./organisms/modals/base/index.tsx + 3 modules
var base = __webpack_require__(10842);
// EXTERNAL MODULE: ./components/texts.tsx
var texts = __webpack_require__(45945);
// EXTERNAL MODULE: ./components/form/FormGroup.js
var FormGroup = __webpack_require__(774);
// EXTERNAL MODULE: ./components/form/NewInput.tsx
var NewInput = __webpack_require__(74014);
// EXTERNAL MODULE: ./lib/apollo/policies/index.ts + 23 modules
var policies = __webpack_require__(54734);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./organisms/modals/ForgotPasswordModal.js
var _templateObject;function _createSuper(Derived) {var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {var Super = (0,getPrototypeOf/* default */.Z)(Derived),result;if (hasNativeReflectConstruct) {var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);} else {result = Super.apply(this, arguments);}return (0,possibleConstructorReturn/* default */.Z)(this, result);};}function _isNativeReflectConstruct() {if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));return true;} catch (e) {return false;}}












var RESET_PASSWORD = (0,lib/* default */.ZP)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  mutation resetPassword($email: String!) {\n    resetPassword(email: $email) {\n      success\n    }\n  }\n"])));var _default = /*#__PURE__*/function (_Component) {(0,inherits/* default */.Z)(_default, _Component);var _super = _createSuper(_default);function _default() {var _this;(0,classCallCheck/* default */.Z)(this, _default);for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}_this = _super.call.apply(_super, [this].concat(args));(0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "state",








    {
      open: false,
      email: '',
      error: '' });(0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "handleOpenModal",


    function () {
      _this.setState({
        open: true });

    });(0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "handleCloseModal",

    function () {
      _this.setState({
        open: false });

    });return _this;}(0,createClass/* default */.Z)(_default, [{ key: "render", value:

    function render() {var _this2 = this;
      return /*#__PURE__*/(
        (0,jsx_runtime.jsxs)(react.Fragment, { children: [/*#__PURE__*/
          (0,jsx_runtime.jsx)(base/* Modal */.u_, {
            open: this.state.open,
            handleClose: this.handleCloseModal,
            customWidth: "500px", children: /*#__PURE__*/

            (0,jsx_runtime.jsx)(Mutation/* Mutation */.m, { mutation: RESET_PASSWORD, children:
              function children(resetPassword, _ref) {var loading = _ref.loading;return /*#__PURE__*/(
                  (0,jsx_runtime.jsxs)("form", {
                    onSubmit: function onSubmit(e) {
                      e.preventDefault();
                      resetPassword({
                        variables: {
                          email: _this2.state.email } }).

                      then(function (_ref2) {var resetPassword = _ref2.data.resetPassword;
                        if ((resetPassword === null || resetPassword === void 0 ? void 0 : resetPassword.success) === true) {
                          (0,policies/* snackbarVar */.Ck)({
                            isSnackBarOpen: true,
                            goTo: 'NONE',
                            id: 'password_recovery',
                            snackBarMessage: 'Email successfully sent' });

                          _this2.handleCloseModal();
                        } else {
                          _this2.setState({
                            error: 'Something went wrong' });

                        }
                      });
                    }, children: [/*#__PURE__*/

                    (0,jsx_runtime.jsx)(base/* Header */.h4, { handleClose: _this2.handleCloseModal, paddingBottom: 20, children: /*#__PURE__*/
                      (0,jsx_runtime.jsx)(Grid/* Box */.xu, { as: Headings.H4, mt: "0px", mb: "0px", children: /*#__PURE__*/
                        (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, {
                          id: "forgot_password_modal.title",
                          message: 'Forgotten your password?' }) }) }), /*#__PURE__*/



                    (0,jsx_runtime.jsxs)(base/* Body */.uT, { children: [/*#__PURE__*/
                      (0,jsx_runtime.jsx)(Grid/* Box */.xu, { mb: "20px", children: /*#__PURE__*/
                        (0,jsx_runtime.jsx)(texts/* PCancelSubscriptionModal */.WB, { children: /*#__PURE__*/
                          (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, {
                            id: "forgot_password_modal.paragraph",
                            message:
                            'Enter your email address and you will receive an email containing instructions on how to reset your password.' }) }) }), /*#__PURE__*/




                      (0,jsx_runtime.jsx)(Grid/* Box */.xu, { mb: "20px", children: /*#__PURE__*/
                        (0,jsx_runtime.jsxs)(FormGroup/* default */.Z, { errorMsg: _this2.state.error, children: [/*#__PURE__*/
                          (0,jsx_runtime.jsx)("label", { htmlFor: "email", children: /*#__PURE__*/
                            (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, {
                              id: "forgot_password_modal.email",
                              message: "Email" }) }), /*#__PURE__*/


                          (0,jsx_runtime.jsx)(NewInput/* default */.Z, {
                            type: "email",
                            name: "email",
                            id: "email",
                            onChange: function onChange(e) {
                              _this2.setState({
                                email: e.target.value });

                            },
                            value: _this2.state.email })] }) })] }), /*#__PURE__*/




                    (0,jsx_runtime.jsx)(base/* Footer */.$_, { children: /*#__PURE__*/
                      (0,jsx_runtime.jsxs)(Grid/* Flex */.kC, {
                        justifyContent: "space-between",
                        alignItems: "center",
                        style: {
                          width: '100%' }, children: [/*#__PURE__*/


                        (0,jsx_runtime.jsx)(Grid/* Box */.xu, { px: "10px", children: /*#__PURE__*/
                          (0,jsx_runtime.jsx)(buttons/* default */.ZP, {
                            type: "button",
                            appearance: "link",
                            onClick: _this2.handleCloseModal,
                            spinnerColor: "white", children: /*#__PURE__*/

                            (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, {
                              id: "forgot_password_modal.back",
                              message: "Back to login" }) }) }), /*#__PURE__*/



                        (0,jsx_runtime.jsx)(Grid/* Box */.xu, { px: "10px", children: /*#__PURE__*/
                          (0,jsx_runtime.jsx)(buttons/* default */.ZP, {
                            type: "submit",
                            loading: loading,
                            spinnerColor: "white", children: /*#__PURE__*/

                            (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, {
                              id: "forgot_password_modal.send_instructions",
                              message: "Send Intructions" }) }) })] }) })] }));} }) }),









          this.props.children(this.handleOpenModal)] }));


    } }]);return _default;}(react.Component);
// EXTERNAL MODULE: ./ecosystems/register/SocialAuth.tsx
var SocialAuth = __webpack_require__(85473);
// EXTERNAL MODULE: ./gql/generated/index.tsx
var generated = __webpack_require__(48354);
// EXTERNAL MODULE: ./components/typography/Paragraph.js
var Paragraph = __webpack_require__(36225);
// EXTERNAL MODULE: ./lib/analytics/manager.ts + 4 modules
var manager = __webpack_require__(88224);
;// CONCATENATED MODULE: ./ecosystems/login/LoginForm.tsx
















var Container = (0,styled_components_browser_esm["default"])(Grid/* Flex */.kC).withConfig({ displayName: "LoginForm__Container", componentId: "sc-a9a69v-0" })(["flex:1;justify-content:center;max-width:500px;width:100%;"]);






var Title = (0,styled_components_browser_esm["default"])(Headings.H2).withConfig({ displayName: "LoginForm__Title", componentId: "sc-a9a69v-1" })(["font-weight:600;"]);



var Input = styled_components_browser_esm["default"].input.withConfig({ displayName: "LoginForm__Input", componentId: "sc-a9a69v-2" })(["", "  width:100%;background-color:#ffffff;padding:11px;font-size:16px;outline:0;&::placeholder{font-size:13px;color:#c7c7c7;}&:disabled{background-color:#eaeaea;}", ""],

(0,helpers/* borders */.Lz)('both'),



















function (props) {return props.maxLengthError ? 'border: 1px solid red;' : null;});


var SignUp = styled_components_browser_esm["default"].p.withConfig({ displayName: "LoginForm__SignUp", componentId: "sc-a9a69v-3" })(["font-size:13px;color:", ";font-weight:600;text-align:center;:first-letter{text-transform:capitalize;}"],

function (_ref) {var theme = _ref.theme;return theme.colors.neutrals['black'];});








var ErrorText = styled_components_browser_esm["default"].span.withConfig({ displayName: "LoginForm__ErrorText", componentId: "sc-a9a69v-4" })(["color:", ";font-size:13px;text-align:center;"],
function (_ref2) {var theme = _ref2.theme;return theme.colors.secondary['red-1'];});











var LoginForm = function LoginForm(props) {var _socialAuthErrors$gra, _socialAuthData$socia;
  var noRegister = props.noRegister;
  var formRef = (0,react.useRef)();
  var router = (0,next_router.useRouter)();
  var _useState = (0,react.useState)(false),loading = _useState[0],setLoading = _useState[1];
  var lang = (0,react.useContext)(languageContext/* default */.Z);
  var _useAuthenticateUserM = (0,generated/* useAuthenticateUserMutation */.pBN)(),_useAuthenticateUserM2 = (0,slicedToArray/* default */.Z)(_useAuthenticateUserM, 2),authenticateUser = _useAuthenticateUserM2[0],error = _useAuthenticateUserM2[1].error;
  var theme = (0,react.useContext)(styled_components_browser_esm.ThemeContext);

  (0,react.useEffect)(function () {var _formRef$current;
    (_formRef$current = formRef.current) === null || _formRef$current === void 0 ? void 0 : _formRef$current.email.focus();
  }, []);

  var registerUrl = (0,react.useMemo)(function () {
    var params = new URLSearchParams();

    var to = router.query.to;
    var redirect_to = router.query.redirect_to;

    if (to) {
      params.set('to', to);
    } else if (redirect_to) {
      params.set('redirect_to', redirect_to);
    }
    var query = params.toString() ? '?' + params.toString() : '';
    return "/".concat(lang, "/register/account") + query;
  }, []);

  var handleLogin = function handleLogin(userId) {
    (0,manager/* default */.Z)().login({ user_id: userId });
    if (props.callBack && typeof props.callBack === 'function') {
      props.callBack();
    } else {
      if (router.query.hasOwnProperty('to') && router.query.to) {
        window.location.href = decodeURIComponent(router.query.to);
      } else if (
      router.query.hasOwnProperty('redirect_to') &&
      router.query.redirect_to)
      {
        window.location.href = decodeURIComponent(
        router.query.redirect_to);

      } else {
        window.location.reload();
      }
    }
  };

  var _useSocialSignInMutat =






  (0,generated/* useSocialSignInMutation */.p$N)({
    onCompleted: function onCompleted(resp) {
      if (resp.socialSignIn.user.id) {var _resp$socialSignIn$us;
        handleLogin((_resp$socialSignIn$us = resp.socialSignIn.user) === null || _resp$socialSignIn$us === void 0 ? void 0 : _resp$socialSignIn$us.id);
      }
    } }),_useSocialSignInMutat2 = (0,slicedToArray/* default */.Z)(_useSocialSignInMutat, 2),socialSignIn = _useSocialSignInMutat2[0],_useSocialSignInMutat3 = _useSocialSignInMutat2[1],socialAuthData = _useSocialSignInMutat3.data,socialAuthLoading = _useSocialSignInMutat3.loading,socialAuthErrors = _useSocialSignInMutat3.error;


  var handleSocialSignIn = /*#__PURE__*/function () {var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(token, provider) {return regenerator_default().wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:_context.prev = 0;_context.next = 3;return (

                socialSignIn({
                  variables: {
                    method: generated/* MethodTypes.Token */.TuT.Token,
                    provider: provider,
                    accessToken: token,
                    identityToken: '',
                    code: '' } }));case 3:_context.next = 7;break;case 5:_context.prev = 5;_context.t0 = _context["catch"](0);case 7:case "end":return _context.stop();}}}, _callee, null, [[0, 5]]);}));return function handleSocialSignIn(_x, _x2) {return _ref3.apply(this, arguments);};}();







  var handleSubmit = /*#__PURE__*/function () {var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(event) {var _event$target, _event$target$email, _event$target2, _event$target2$passwo, _data$authenticateUse, _data$authenticateUse2, _data$authenticateUse3, _data$authenticateUse4, email, password, _yield$authenticateUs, data;return regenerator_default().wrap(function _callee2$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:
              event.preventDefault();
              setLoading(true);_context2.prev = 2;

              email = event === null || event === void 0 ? void 0 : (_event$target = event.target) === null || _event$target === void 0 ? void 0 : (_event$target$email = _event$target.email) === null || _event$target$email === void 0 ? void 0 : _event$target$email.value;
              password = event === null || event === void 0 ? void 0 : (_event$target2 = event.target) === null || _event$target2 === void 0 ? void 0 : (_event$target2$passwo = _event$target2.password) === null || _event$target2$passwo === void 0 ? void 0 : _event$target2$passwo.value;
              //
              _context2.next = 7;return authenticateUser({
                variables: { email: email, password: password } });case 7:_yield$authenticateUs = _context2.sent;data = _yield$authenticateUs.data;


              // for some reason this promise never resolves or rejects
              setLoading(false);

              //
              if (data !== null && data !== void 0 && (_data$authenticateUse = data.authenticateUser) !== null && _data$authenticateUse !== void 0 && (_data$authenticateUse2 = _data$authenticateUse.user) !== null && _data$authenticateUse2 !== void 0 && _data$authenticateUse2.id) {_context2.next = 12;break;}return _context2.abrupt("return",
              null);case 12:


              handleLogin(data === null || data === void 0 ? void 0 : (_data$authenticateUse3 = data.authenticateUser) === null || _data$authenticateUse3 === void 0 ? void 0 : (_data$authenticateUse4 = _data$authenticateUse3.user) === null || _data$authenticateUse4 === void 0 ? void 0 : _data$authenticateUse4.id);_context2.next = 18;break;case 15:_context2.prev = 15;_context2.t0 = _context2["catch"](2);

              setLoading(false);case 18:case "end":return _context2.stop();}}}, _callee2, null, [[2, 15]]);}));return function handleSubmit(_x3) {return _ref4.apply(this, arguments);};}();



  return /*#__PURE__*/(
    (0,jsx_runtime.jsxs)(Container, { className: props.className, flexDirection: "column", children: [/*#__PURE__*/
      (0,jsx_runtime.jsx)(Title, { children: /*#__PURE__*/
        (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, { id: "login_modal.title", message: "Log In" }) }), /*#__PURE__*/

      (0,jsx_runtime.jsx)(Grid/* Box */.xu, { mt: "0px", mb: "20px", as: Paragraph.P, bold: true, children:
        props.message ?
        props.message : /*#__PURE__*/

        (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, {
          id: "login_modal.helper",
          message:
          'Logga in för åtkomst till videobiblioteket, vårt växande kursutbud online och din profil.' }) }), /*#__PURE__*/




      (0,jsx_runtime.jsxs)("form", { ref: formRef, onSubmit: handleSubmit, children: [/*#__PURE__*/
        (0,jsx_runtime.jsx)(Grid/* Box */.xu, { mb: "10px", children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(Input, {
            type: "email",
            name: "email",
            placeholder: /*i18n*/esm/* i18n._ */.ag._("login_modal.inputplaceholder.email") }) }), /*#__PURE__*/



        (0,jsx_runtime.jsx)(Grid/* Box */.xu, { mb: "10px", children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(Input, {
            type: "password",
            name: "password",
            placeholder: /*i18n*/esm/* i18n._ */.ag._("login_modal.inputplaceholder.password") }) }),



        error ? /*#__PURE__*/
        (0,jsx_runtime.jsx)(Grid/* Box */.xu, { mb: "30px", children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(ErrorText, {
            dangerouslySetInnerHTML: {
              __html: esm/* i18n._ */.ag._( /*i18n*/{ id: 'login_modal.errors.incorrect' }) } }) }) :



        null, /*#__PURE__*/
        (0,jsx_runtime.jsx)(Grid/* Box */.xu, { mb: "10px", children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(buttons/* default */.ZP, {
            type: "submit",
            loading: loading || socialAuthLoading,
            spinnerColor: "white",

            fullWidth: true, children: /*#__PURE__*/

            (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, { id: "login_modal.action.login", message: "LOG IN" }) }) })] }), /*#__PURE__*/



      (0,jsx_runtime.jsx)(Grid/* Box */.xu, { mb: 30, children: /*#__PURE__*/
        (0,jsx_runtime.jsx)(_default, { children:
          function children(handleOpenModal) {return /*#__PURE__*/(
              (0,jsx_runtime.jsx)(buttons/* default */.ZP, {
                fullWidth: true,
                alignement: "center",
                appearance: "link",
                color: theme.colors.neutrals['black-ligther'],
                onClick: handleOpenModal, children: /*#__PURE__*/


                (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, {
                  id: "login_modal.action.forgot",
                  message: "Forgot Password?" }) }));} }) }), /*#__PURE__*/





      (0,jsx_runtime.jsx)(SocialAuth/* default */.Z, {
        title: esm/* i18n._ */.ag._( /*i18n*/{ id: 'login_modal.action.social_label' }),
        onGoogleAuth: function onGoogleAuth(token) {
          handleSocialSignIn(token, generated/* ProviderTypes.Google */.yIQ.Google);
        },
        onFacebookAuth: function onFacebookAuth(token) {
          handleSocialSignIn(token, generated/* ProviderTypes.Facebook */.yIQ.Facebook);
        },
        onAppleAuth: function onAppleAuth(token) {
          handleSocialSignIn(token, generated/* ProviderTypes.Apple */.yIQ.Apple);
        } }),

      (socialAuthErrors === null || socialAuthErrors === void 0 ? void 0 : (_socialAuthErrors$gra = socialAuthErrors.graphQLErrors) === null || _socialAuthErrors$gra === void 0 ? void 0 : _socialAuthErrors$gra.length) > 0 ||
      (socialAuthData === null || socialAuthData === void 0 ? void 0 : (_socialAuthData$socia = socialAuthData.socialSignIn) === null || _socialAuthData$socia === void 0 ? void 0 : _socialAuthData$socia.success) === false ? /*#__PURE__*/
      (0,jsx_runtime.jsx)(Grid/* Flex */.kC, { justifyContent: "center", alignItems: "center", mt: "10px", mb: "10px", children: /*#__PURE__*/
        (0,jsx_runtime.jsx)(ErrorText, { children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, { id: "login_modal.errors.incorrect_socials" }) }) }) :


      null,
      !noRegister && /*#__PURE__*/
      (0,jsx_runtime.jsx)(Grid/* Box */.xu, { pb: [20, 20, 30], children: /*#__PURE__*/
        (0,jsx_runtime.jsx)(SignUp, { children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, {
            id: "login_modal.action.or_create",
            components: [/*#__PURE__*/
            (0,jsx_runtime.jsx)(buttons/* default */.ZP, { href: registerUrl, appearance: "link" }, "0")] }) }) })] }));







};

/* harmony default export */ var login_LoginForm = (LoginForm);

/***/ }),

/***/ 12980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ Placeholder; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31157);


var Placeholder = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({ displayName: "components__Placeholder", componentId: "sc-1xch8vo-0" })(["height:", ";"],
function (props) {return props.height ? "".concat(props.height, "px") : null;});

/***/ }),

/***/ 85473:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(50029);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(17674);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87794);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(31157);
/* harmony import */ var react_google_login__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93645);
/* harmony import */ var react_google_login__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_google_login__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _greatsumini_react_facebook_login__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73502);
/* harmony import */ var _greatsumini_react_facebook_login__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_greatsumini_react_facebook_login__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_apple_signin_auth__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96701);
/* harmony import */ var _components_layout_Grid__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94007);
/* harmony import */ var _lib_hooks_useFlags__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(55932);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85893);
function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}






var Title = styled_components__WEBPACK_IMPORTED_MODULE_8__["default"].p.withConfig({ displayName: "SocialAuth__Title", componentId: "sc-1mbigjg-0" })(["display:flex;align-items:center;color:#242424;font-size:13px;text-transform:uppercase;line-height:22px;opacity:0.5;:after,:before{content:'';flex:1;height:1px;background-color:#242424;opacity:0.3;}:after{margin-left:8px;}:before{margin-right:8px;}"]);


























var SocialButton = styled_components__WEBPACK_IMPORTED_MODULE_8__["default"].button.withConfig({ displayName: "SocialAuth__SocialButton", componentId: "sc-1mbigjg-1" })(["flex:1;display:flex;align-items:center;justify-content:center;color:#6d6d6d;font-size:13px;font-weight:600;line-height:16px;text-align:center;border:1px solid ", ";border-radius:3px;padding:8px 12px;margin:8px 5px;background:none;cursor:pointer;transition:border-color 200ms ease;:hover{border-color:", ";box-shadow:0px 1px 2px 0px ", ";}"],









function (_ref) {var theme = _ref.theme;return theme.colors.neutrals['gray-3'];},








function (_ref2) {var theme = _ref2.theme;return theme.colors.neutrals['gray'];},

function (_ref3) {var theme = _ref3.theme;return theme.colors.neutrals['gray-3'];});



var Icon = styled_components__WEBPACK_IMPORTED_MODULE_8__["default"].img.withConfig({ displayName: "SocialAuth__Icon", componentId: "sc-1mbigjg-2" })(["height:24px;margin-right:8px;"]);




function getFacebookProfile() {
  return new Promise(function (resolve, reject) {
    var ID = setTimeout(reject, 5000);
    _greatsumini_react_facebook_login__WEBPACK_IMPORTED_MODULE_3__.FacebookLoginClient.getProfile(
    function (profile) {var _profile$name, _profile$name$split3, _profile$picture, _profile$picture$data;
      clearTimeout(ID);
      var _profile$name$split = (_profile$name = profile['name']) === null || _profile$name === void 0 ? void 0 : (_profile$name$split3 = _profile$name.split) === null || _profile$name$split3 === void 0 ? void 0 : _profile$name$split3.call(_profile$name, ' '),_profile$name$split2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_profile$name$split, 2),firstName = _profile$name$split2[0],lastName = _profile$name$split2[1];
      var picture = (_profile$picture = profile['picture']) === null || _profile$picture === void 0 ? void 0 : (_profile$picture$data = _profile$picture.data) === null || _profile$picture$data === void 0 ? void 0 : _profile$picture$data.url;
      resolve({ firstName: firstName, lastName: lastName, picture: picture });
    },
    { fields: 'name,email,picture' });

  });
}













var SocialAuth = function SocialAuth(props) {
  var _useFlags = (0,_lib_hooks_useFlags__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(),_useFlags2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_useFlags, 1),flags = _useFlags2[0];
  var _props$title = props.title,title = _props$title === void 0 ? 'Or sign up with' : _props$title;

  var responseGoogle = function responseGoogle(resp) {var _resp$profileObj, _resp$profileObj2, _resp$profileObj3;
    var firstName = (_resp$profileObj = resp.profileObj) === null || _resp$profileObj === void 0 ? void 0 : _resp$profileObj.givenName;
    var lastName = (_resp$profileObj2 = resp.profileObj) === null || _resp$profileObj2 === void 0 ? void 0 : _resp$profileObj2.familyName;
    var picture = (_resp$profileObj3 = resp.profileObj) === null || _resp$profileObj3 === void 0 ? void 0 : _resp$profileObj3.imageUrl;
    props === null || props === void 0 ? void 0 : props.onGoogleAuth(resp['accessToken'], {
      firstName: firstName,
      lastName: lastName,
      picture: picture });

  };

  var onFacebookResponse = /*#__PURE__*/function () {var _ref4 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)( /*#__PURE__*/_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee(resp) {var info;return _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:_context.next = 2;return (
                getFacebookProfile());case 2:info = _context.sent;
              props === null || props === void 0 ? void 0 : props.onFacebookAuth(resp['accessToken'], {
                firstName: info['firstName'],
                lastName: info['lastName'],
                picture: info['picture'] });case 4:case "end":return _context.stop();}}}, _callee);}));return function onFacebookResponse(_x) {return _ref4.apply(this, arguments);};}();



  var onAppleResponse = function onAppleResponse(resp) {var _resp$user, _resp$authorization;
    var _ref5 = (resp === null || resp === void 0 ? void 0 : (_resp$user = resp.user) === null || _resp$user === void 0 ? void 0 : _resp$user.name) || {},firstName = _ref5.firstName,lastName = _ref5.lastName;
    props === null || props === void 0 ? void 0 : props.onAppleAuth(resp === null || resp === void 0 ? void 0 : (_resp$authorization = resp.authorization) === null || _resp$authorization === void 0 ? void 0 : _resp$authorization.id_token, { firstName: firstName, lastName: lastName });
  };

  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, { children: [/*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(Title, { children: title }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_5__/* .Flex */ .kC, { my: 20, children: [/*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(react_google_login__WEBPACK_IMPORTED_MODULE_2__.GoogleLogin, {
          clientId: "1027033081047-sieeheoqf2dmlcn457oq824t9rvbve5h.apps.googleusercontent.com",
          onSuccess: responseGoogle,
          responseType: "token",
          scope: "profile email",
          accessType: "online",
          redirectUri: "https://devenv.yogobe.com",
          uxMode: "popup",
          render: function render(renderProps) {return /*#__PURE__*/(
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(SocialButton, _objectSpread(_objectSpread({},
              renderProps), {}, {
                onClick: renderProps.onClick,
                disabled: renderProps.disabled, children: [/*#__PURE__*/

                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(Icon, { src: "/static/icons/google.svg" }), "Google"] })));} }), /*#__PURE__*/




        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(react_apple_signin_auth__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP
        /** Auth options passed to AppleID.auth.init() */, {
          authOptions: {
            /** Client ID - eg: 'com.example.com' */
            clientId: "com.yogobe.oauth",
            /** Requested scopes, seperated by spaces - eg: 'email name' */
            scope: 'email name',
            /** Apple's redirectURI - must be one of the URIs you added to the serviceID - the undocumented trick in apple docs is that you should call auth from a page that is listed as a redirectURI, localhost fails */
            redirectURI: "https://devenv.yogobe.com",
            /** State string that is returned with the apple response */
            state: 'state',
            /** Nonce */
            nonce: 'nonce',
            /** Uses popup auth instead of redirection */
            usePopup: true }
          // REQUIRED
          /** General props */,
          uiType: "dark"
          /** className */,
          className: "apple-auth-btn"
          /** Removes default style tag */,
          noDefaultStyle: false
          /** Allows to change the button's children, eg: for changing the button text */,
          buttonExtraChildren: "Continue with Apple"
          /** Extra controlling props */
          /** Called upon signin success in case authOptions.usePopup = true -- which means auth is handled client side */,
          onSuccess: onAppleResponse // default = undefined
          /** Called upon signin error */

          /** Skips loading the apple script if true */,
          skipScript: false // default = undefined
          /** Apple image props */,
          iconProp: { style: { marginTop: '10px' } } // default = undefined
          /** render function - called with all props - can be used to fully customize the UI by rendering your own component  */,
          render: function render(props) {return /*#__PURE__*/(
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(SocialButton, _objectSpread(_objectSpread({}, props), {}, { children: [/*#__PURE__*/
                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(Icon, { src: "/static/icons/apple.svg" }), " Apple"] })));} }), /*#__PURE__*/



        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)((_greatsumini_react_facebook_login__WEBPACK_IMPORTED_MODULE_3___default()), {
          appId: "497361388227067",
          scope: "public_profile,email",
          dialogParams: {
            redirect_uri: "https://devenv.yogobe.com",
            state: '' },

          loginOptions: {
            return_scopes: true },

          onSuccess: onFacebookResponse,
          render: function render(_ref6) {var onClick = _ref6.onClick;return /*#__PURE__*/(
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(SocialButton, { onClick: onClick, children: [/*#__PURE__*/
                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(Icon, { src: "/static/icons/facebook.svg" }), " Facebook"] }));} })] })] }));






};

/* harmony default export */ __webpack_exports__["Z"] = (SocialAuth);

/***/ }),

/***/ 48354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$BZ": function() { return /* binding */ useUserPlaylistsQuery; },
/* harmony export */   "$PN": function() { return /* binding */ LanguageKind; },
/* harmony export */   "$bM": function() { return /* binding */ BundleAccessStrategyKind; },
/* harmony export */   "$bR": function() { return /* binding */ AccessPeriodUnitKind; },
/* harmony export */   "$sk": function() { return /* binding */ useGenericProgramsQuery; },
/* harmony export */   "BBx": function() { return /* binding */ useEmailPreferencesQuery; },
/* harmony export */   "B_J": function() { return /* binding */ usePricingSubscriptionPlansQuery; },
/* harmony export */   "CKW": function() { return /* binding */ useVideoWatchMutation; },
/* harmony export */   "CKx": function() { return /* binding */ WeeklyProgramDocument; },
/* harmony export */   "CbT": function() { return /* binding */ useGetFullGenericProgramQuery; },
/* harmony export */   "DeO": function() { return /* binding */ ProgramAccessStatus; },
/* harmony export */   "EE8": function() { return /* binding */ useUserStatsQuery; },
/* harmony export */   "EKh": function() { return /* binding */ Code; },
/* harmony export */   "Eov": function() { return /* binding */ useVideosQuery; },
/* harmony export */   "GY_": function() { return /* binding */ useVideoQuery; },
/* harmony export */   "Gxw": function() { return /* binding */ useAddFavoriteVideoMutation; },
/* harmony export */   "H1Z": function() { return /* binding */ useSearchLazyQuery; },
/* harmony export */   "H9D": function() { return /* binding */ GlobalSearch; },
/* harmony export */   "IAd": function() { return /* binding */ useStoreUserDecisionMutation; },
/* harmony export */   "Iy2": function() { return /* binding */ ActionInput; },
/* harmony export */   "JBT": function() { return /* binding */ BundleSectionKind; },
/* harmony export */   "LZ": function() { return /* binding */ useTaxonomiesLazyQuery; },
/* harmony export */   "MdM": function() { return /* binding */ useChangeProfileDataMutation; },
/* harmony export */   "Mim": function() { return /* binding */ ProxyEventKind; },
/* harmony export */   "MrK": function() { return /* binding */ EligibleForTrialReclaimKind; },
/* harmony export */   "Muc": function() { return /* binding */ useAddSearchResultMutation; },
/* harmony export */   "N$9": function() { return /* binding */ GenericProgramSortAttribute; },
/* harmony export */   "OEF": function() { return /* binding */ useSignUpMutation; },
/* harmony export */   "OTz": function() { return /* binding */ useOrderQuery; },
/* harmony export */   "OeP": function() { return /* binding */ useBasicBundleQuery; },
/* harmony export */   "OxH": function() { return /* binding */ useParticipateInAnEventMutation; },
/* harmony export */   "PC6": function() { return /* binding */ useLiveEventCodesLazyQuery; },
/* harmony export */   "PEq": function() { return /* binding */ useAddVideoToPlaylistMutation; },
/* harmony export */   "Q6Z": function() { return /* binding */ useActivateFullAccessCodeMutation; },
/* harmony export */   "QZc": function() { return /* binding */ useLiveEventCodesQuery; },
/* harmony export */   "Qnu": function() { return /* binding */ useMyBundlesQuery; },
/* harmony export */   "RWI": function() { return /* binding */ usePayForItemMutation; },
/* harmony export */   "T0H": function() { return /* binding */ CurrentUserDocument; },
/* harmony export */   "TDG": function() { return /* binding */ useAnswerSurveyMutation; },
/* harmony export */   "TuT": function() { return /* binding */ MethodTypes; },
/* harmony export */   "Uf9": function() { return /* binding */ useGetFavoritePlaylistsQuery; },
/* harmony export */   "VH3": function() { return /* binding */ usePhasedProgramQuery; },
/* harmony export */   "Vog": function() { return /* binding */ useActivateOneTimeCodeMutation; },
/* harmony export */   "Vu3": function() { return /* binding */ useBundleQuery; },
/* harmony export */   "WVK": function() { return /* binding */ PhasedProgramFieldsFragmentDoc; },
/* harmony export */   "Wq_": function() { return /* binding */ GetFullGenericProgramDocument; },
/* harmony export */   "Wxm": function() { return /* binding */ Option; },
/* harmony export */   "X8q": function() { return /* binding */ useLastWatchedSessionsQuery; },
/* harmony export */   "Y5y": function() { return /* binding */ UserPlaylistsDocument; },
/* harmony export */   "Ys_": function() { return /* binding */ useGetFavoriteVideosQuery; },
/* harmony export */   "ZaT": function() { return /* binding */ useAvailableTrialExtensionsQuery; },
/* harmony export */   "__V": function() { return /* binding */ useSpecificSearchLazyQuery; },
/* harmony export */   "_xv": function() { return /* binding */ PriceTypeKind; },
/* harmony export */   "bwk": function() { return /* binding */ usePaymentsStoreAdyenDropinMutation; },
/* harmony export */   "c2y": function() { return /* binding */ useLiveEventsQuery; },
/* harmony export */   "c45": function() { return /* binding */ usePayForVoucherMutation; },
/* harmony export */   "ciD": function() { return /* binding */ useValidateLiveEventCodeQuery; },
/* harmony export */   "dAt": function() { return /* binding */ useInstructorByGenreQuery; },
/* harmony export */   "dG2": function() { return /* binding */ DevicePlatformKind; },
/* harmony export */   "eP0": function() { return /* binding */ useCompleteProfileMutation; },
/* harmony export */   "enR": function() { return /* binding */ UserDecisionKind; },
/* harmony export */   "f3e": function() { return /* binding */ StatsPeriodKind; },
/* harmony export */   "fiA": function() { return /* binding */ BundleKind; },
/* harmony export */   "foS": function() { return /* binding */ useLiveEventQuery; },
/* harmony export */   "frd": function() { return /* binding */ usePaymentsStoreTrustlyMutation; },
/* harmony export */   "g$W": function() { return /* binding */ CurrentUser2Document; },
/* harmony export */   "gXh": function() { return /* binding */ useSocialSignUpMutation; },
/* harmony export */   "jI7": function() { return /* binding */ useDashboardTaxonomiesQuery; },
/* harmony export */   "jWO": function() { return /* binding */ CodeStatusKind; },
/* harmony export */   "l1j": function() { return /* binding */ useChangeEmailPreferenceMutation; },
/* harmony export */   "l92": function() { return /* binding */ ProgramCategory; },
/* harmony export */   "mRf": function() { return /* binding */ useCurrentUser2LazyQuery; },
/* harmony export */   "mb": function() { return /* binding */ useReclaimTrialMutation; },
/* harmony export */   "mzs": function() { return /* binding */ ItemKind; },
/* harmony export */   "nEM": function() { return /* binding */ SurveyTypeKind; },
/* harmony export */   "nMP": function() { return /* binding */ LiveEventKind; },
/* harmony export */   "o1x": function() { return /* binding */ useRemoveVideoFromPlaylistMutation; },
/* harmony export */   "p$N": function() { return /* binding */ useSocialSignInMutation; },
/* harmony export */   "pAI": function() { return /* binding */ useAddFavoritePlaylistMutation; },
/* harmony export */   "pBN": function() { return /* binding */ useAuthenticateUserMutation; },
/* harmony export */   "pQJ": function() { return /* binding */ CodeTypeKind; },
/* harmony export */   "qVS": function() { return /* binding */ usePlaylistQuery; },
/* harmony export */   "rNv": function() { return /* binding */ useValidateBundleCodeLazyQuery; },
/* harmony export */   "rkO": function() { return /* binding */ useCurrentUserQuery; },
/* harmony export */   "sYl": function() { return /* binding */ useAvailableOneTimeCodeLazyQuery; },
/* harmony export */   "ttg": function() { return /* binding */ useActivateLiveEventMutation; },
/* harmony export */   "uV0": function() { return /* binding */ useStartOverviewQuery; },
/* harmony export */   "ueT": function() { return /* binding */ ModelNameKind; },
/* harmony export */   "ut8": function() { return /* binding */ useWeeklyProgramQuery; },
/* harmony export */   "vRJ": function() { return /* binding */ useActivateBundleMutation; },
/* harmony export */   "vfP": function() { return /* binding */ useEventProxyMutation; },
/* harmony export */   "w3$": function() { return /* binding */ useDeleteFavoritePlaylistMutation; },
/* harmony export */   "xaU": function() { return /* binding */ useCancelSubscriptionMutation; },
/* harmony export */   "y9j": function() { return /* binding */ useUserPlaylistsLazyQuery; },
/* harmony export */   "yIQ": function() { return /* binding */ ProviderTypes; },
/* harmony export */   "ygI": function() { return /* binding */ useDeleteFavoriteVideoMutation; },
/* harmony export */   "yhH": function() { return /* binding */ SubscriptionStatus; },
/* harmony export */   "yqz": function() { return /* binding */ useGetBasicGenericProgramQuery; },
/* harmony export */   "zfm": function() { return /* binding */ useFullAvailableSubscriptionPlansQuery; },
/* harmony export */   "zpD": function() { return /* binding */ useVideoWatchCompletedMutation; }
/* harmony export */ });
/* unused harmony exports DiscountTypeKind, DurationUnitKind, DurationDisplayUnitKind, ProgramKind, SurveyKind, ThemeKind, BundleCategoryKind, LiveEventLevel, LiveEventStatus, PaymentStatusKind, Provider, PlaylistSortAttribute, VideoSortAttribute, SortAttribute, SortOrder, LiveEventSortAttribute, CurrencyKind, PaymentProviderKind, MoodTrackerKind, VideoKind, State, OtherTypeKind, SlugTypeKind, WellnessProviderKind, PromotionCodeTypeKind, VideoKindInput, VideoOrderBy, ErrorValue, ItemTypeKind, ClassName, GenderKind, CodeSourceKind, PricingSubscriptionFieldsFragmentDoc, BundleEssentialFieldsFragmentDoc, BlogPostFieldsFragmentDoc, ProgramInstructorsFragmentDoc, EssentialGenericFieldsFragmentDoc, FullGenericProgramFieldsFragmentDoc, PlaylistEssentialFieldsFragmentDoc, PlaylistCardFieldsFragmentDoc, VideoFieldsFragmentDoc, LiveEventEssentialFieldsFragmentDoc, LiveCodeDataFieldsFragmentDoc, FullLiveEventFieldsFragmentDoc, ProgramIntroFieldsFragmentDoc, ProgramVideoFieldsFragmentDoc, ProgramOutroFieldsFragmentDoc, SearchVideoFieldsFragmentDoc, SearchPlaylistFieldsFragmentDoc, SearchGenericProgramFieldsFragmentDoc, SearchInstructorFieldsFragmentDoc, SearchEventFieldsFragmentDoc, SearchLiveEventFieldsFragmentDoc, SearchLandingPageFieldsFragmentDoc, SearchBlogPostFieldsFragmentDoc, ProgramTextElementFieldsFragmentDoc, ProgramSurveyFieldsFragmentDoc, ProgramSurveyElementFieldsFragmentDoc, ProgramDocumentFieldsFragmentDoc, WeeklyProgramWeekFragmentFragmentDoc, WeeklyProgramFieldsFragmentDoc, CancelSubscriptionDocument, AuthenticateUserDocument, AvailableOneTimeCodeDocument, useAvailableOneTimeCodeQuery, refetchAvailableOneTimeCodeQuery, PricingSubscriptionPlansDocument, usePricingSubscriptionPlansLazyQuery, refetchPricingSubscriptionPlansQuery, FullAvailableSubscriptionPlansDocument, useFullAvailableSubscriptionPlansLazyQuery, refetchFullAvailableSubscriptionPlansQuery, AvailableTrialExtensionsDocument, useAvailableTrialExtensionsLazyQuery, refetchAvailableTrialExtensionsQuery, BasicBundleDocument, useBasicBundleLazyQuery, refetchBasicBundleQuery, BundleDocument, useBundleLazyQuery, refetchBundleQuery, ActivateBundleDocument, ValidateBundleCodeDocument, useValidateBundleCodeQuery, refetchValidateBundleCodeQuery, BundlesDocument, useBundlesQuery, useBundlesLazyQuery, refetchBundlesQuery, MyBundlesDocument, useMyBundlesLazyQuery, refetchMyBundlesQuery, ChangeProfileDataDocument, CompleteProfileDocument, useCurrentUserLazyQuery, refetchCurrentUserQuery, useCurrentUser2Query, refetchCurrentUser2Query, DashboardRecentVideosDocument, useDashboardRecentVideosQuery, useDashboardRecentVideosLazyQuery, refetchDashboardRecentVideosQuery, DashboardTaxonomiesDocument, useDashboardTaxonomiesLazyQuery, refetchDashboardTaxonomiesQuery, EmailPreferencesDocument, useEmailPreferencesLazyQuery, refetchEmailPreferencesQuery, ChangeEmailPreferenceDocument, EventProxyDocument, GetBasicGenericProgramDocument, useGetBasicGenericProgramLazyQuery, refetchGetBasicGenericProgramQuery, useGetFullGenericProgramLazyQuery, refetchGetFullGenericProgramQuery, GenericProgramsDocument, useGenericProgramsLazyQuery, refetchGenericProgramsQuery, PlaylistDocument, usePlaylistLazyQuery, refetchPlaylistQuery, VideosDocument, useVideosLazyQuery, refetchVideosQuery, LastWatchedSessionsDocument, useLastWatchedSessionsLazyQuery, refetchLastWatchedSessionsQuery, LiveEventCodesDocument, refetchLiveEventCodesQuery, ParticipateInAnEventDocument, ActivateLiveEventDocument, LiveEventDocument, useLiveEventLazyQuery, refetchLiveEventQuery, ValidateLiveEventCodeDocument, useValidateLiveEventCodeLazyQuery, refetchValidateLiveEventCodeQuery, LiveEventsDocument, useLiveEventsLazyQuery, refetchLiveEventsQuery, OrderDocument, useOrderLazyQuery, refetchOrderQuery, PayForItemDocument, PayForVoucherDocument, PhasedProgramDocument, usePhasedProgramLazyQuery, refetchPhasedProgramQuery, AddFavoritePlaylistDocument, DeleteFavoritePlaylistDocument, AutocompleteDocument, useAutocompleteQuery, useAutocompleteLazyQuery, refetchAutocompleteQuery, SpecificSearchDocument, useSpecificSearchQuery, refetchSpecificSearchQuery, SearchDocument, useSearchQuery, refetchSearchQuery, AddSearchResultDocument, SignUpDocument, SocialSignUpDocument, SocialSignInDocument, StartOverviewDocument, useStartOverviewLazyQuery, refetchStartOverviewQuery, VideoWatchDocument, VideoWatchCompletedDocument, UserStatsDocument, useUserStatsLazyQuery, refetchUserStatsQuery, ActivateFullAccessCodeDocument, ActivateOneTimeCodeDocument, PaymentsStoreAdyenDropinDocument, PaymentsStoreTrustlyDocument, SurveyDocument, useSurveyQuery, useSurveyLazyQuery, refetchSurveyQuery, GetSurveyDocument, useGetSurveyQuery, useGetSurveyLazyQuery, refetchGetSurveyQuery, refetchUserPlaylistsQuery, RemoveVideoFromPlaylistDocument, AddVideoToPlaylistDocument, DeleteFavoriteVideoDocument, AddFavoriteVideoDocument, TaxonomiesDocument, useTaxonomiesQuery, refetchTaxonomiesQuery, VideoDocument, useVideoLazyQuery, refetchVideoQuery, InstructorByGenreDocument, useInstructorByGenreLazyQuery, refetchInstructorByGenreQuery, useWeeklyProgramLazyQuery, refetchWeeklyProgramQuery, YearlyPageDocument, useYearlyPageQuery, useYearlyPageLazyQuery, refetchYearlyPageQuery, AnswerSurveyDocument, GetFavoritePlaylistsDocument, useGetFavoritePlaylistsLazyQuery, refetchGetFavoritePlaylistsQuery, GetFavoriteVideosDocument, useGetFavoriteVideosLazyQuery, refetchGetFavoriteVideosQuery, ReclaimTrialDocument, StoreUserDecisionDocument */
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71383);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12922);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50319);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73359);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37887);
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30, _templateObject31, _templateObject32, _templateObject33, _templateObject34, _templateObject35, _templateObject36, _templateObject37, _templateObject38, _templateObject39, _templateObject40, _templateObject41, _templateObject42, _templateObject43, _templateObject44, _templateObject45, _templateObject46, _templateObject47, _templateObject48, _templateObject49, _templateObject50, _templateObject51, _templateObject52, _templateObject53, _templateObject54, _templateObject55, _templateObject56, _templateObject57, _templateObject58, _templateObject59, _templateObject60, _templateObject61, _templateObject62, _templateObject63, _templateObject64, _templateObject65, _templateObject66, _templateObject67, _templateObject68, _templateObject69, _templateObject70, _templateObject71, _templateObject72, _templateObject73, _templateObject74, _templateObject75, _templateObject76, _templateObject77, _templateObject78, _templateObject79, _templateObject80, _templateObject81, _templateObject82, _templateObject83, _templateObject84, _templateObject85, _templateObject86, _templateObject87, _templateObject88, _templateObject89, _templateObject90, _templateObject91, _templateObject92, _templateObject93, _templateObject94, _templateObject95, _templateObject96, _templateObject97, _templateObject98, _templateObject99, _templateObject100, _templateObject101;function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}







var defaultOptions = {};
/** All built-in and custom scalars, mapped to their actual values */











































































































































































































































































































































































































































































































































































var GlobalSearch;(function (GlobalSearch) {GlobalSearch["All"] = "All";GlobalSearch["Blog"] = "Blog";GlobalSearch["CourseTravel"] = "CourseTravel";GlobalSearch["Live"] = "Live";GlobalSearch["Play"] = "Play";GlobalSearch["Resources"] = "Resources";})(GlobalSearch || (GlobalSearch = {}));















var DevicePlatformKind;(function (DevicePlatformKind) {DevicePlatformKind["Android"] = "android";DevicePlatformKind["Ios"] = "ios";DevicePlatformKind["Web"] = "web";})(DevicePlatformKind || (DevicePlatformKind = {}));


























var Code;(function (Code) {Code["OneTimeCode"] = "one_time_code";Code["SubscriptionDiscountCode"] = "subscription_discount_code";Code["SubscriptionFullAccessCode"] = "subscription_full_access_code";Code["TrialCampaignCode"] = "trial_campaign_code";Code["TrialReferralCode"] = "trial_referral_code";})(Code || (Code = {}));














































































































































































var AccessPeriodUnitKind;(function (AccessPeriodUnitKind) {AccessPeriodUnitKind["Days"] = "days";AccessPeriodUnitKind["Months"] = "months";AccessPeriodUnitKind["Weeks"] = "weeks";})(AccessPeriodUnitKind || (AccessPeriodUnitKind = {}));





var ProgramAccessStatus;(function (ProgramAccessStatus) {ProgramAccessStatus["Active"] = "active";ProgramAccessStatus["Expired"] = "expired";ProgramAccessStatus["ExpiringSoon"] = "expiring_soon";ProgramAccessStatus["Locked"] = "locked";})(ProgramAccessStatus || (ProgramAccessStatus = {}));










var ProgramCategory;(function (ProgramCategory) {ProgramCategory["Challenges"] = "challenges";ProgramCategory["Courses"] = "courses";ProgramCategory["Healthcare"] = "healthcare";ProgramCategory["Programs"] = "programs";})(ProgramCategory || (ProgramCategory = {}));
















var DiscountTypeKind;(function (DiscountTypeKind) {DiscountTypeKind["ByValue"] = "by_value";DiscountTypeKind["Percentage"] = "percentage";})(DiscountTypeKind || (DiscountTypeKind = {}));




var PriceTypeKind;(function (PriceTypeKind) {PriceTypeKind["AccessCodesOnly"] = "access_codes_only";PriceTypeKind["BySubscription"] = "by_subscription";PriceTypeKind["DiscountForAll"] = "discount_for_all";PriceTypeKind["DiscountForPaying"] = "discount_for_paying";PriceTypeKind["FreeForAll"] = "free_for_all";PriceTypeKind["FreeForPaying"] = "free_for_paying";PriceTypeKind["RegularPrice"] = "regular_price";})(PriceTypeKind || (PriceTypeKind = {}));















var DurationUnitKind;(function (DurationUnitKind) {DurationUnitKind["Days"] = "days";DurationUnitKind["Weeks"] = "weeks";})(DurationUnitKind || (DurationUnitKind = {}));










var DurationDisplayUnitKind;(function (DurationDisplayUnitKind) {DurationDisplayUnitKind["DaysDisplay"] = "days_display";DurationDisplayUnitKind["PartsDisplay"] = "parts_display";DurationDisplayUnitKind["WeeksDisplay"] = "weeks_display";})(DurationDisplayUnitKind || (DurationDisplayUnitKind = {}));

























































var ProgramKind;(function (ProgramKind) {ProgramKind["CompletionBased"] = "completion_based";ProgramKind["ContentBased"] = "content_based";ProgramKind["DailyBased"] = "daily_based";ProgramKind["DateBased"] = "date_based";ProgramKind["PhaseBased"] = "phase_based";ProgramKind["WeeklyBased"] = "weekly_based";})(ProgramKind || (ProgramKind = {}));








var LanguageKind;(function (LanguageKind) {LanguageKind["En"] = "en";LanguageKind["Fi"] = "fi";LanguageKind["No"] = "no";LanguageKind["Se"] = "se";})(LanguageKind || (LanguageKind = {}));























var SurveyKind;(function (SurveyKind) {SurveyKind["Post"] = "post";SurveyKind["Pre"] = "pre";})(SurveyKind || (SurveyKind = {}));























































var ThemeKind;(function (ThemeKind) {ThemeKind["Athletes"] = "athletes";ThemeKind["Beginner"] = "beginner";ThemeKind["Breathing"] = "breathing";ThemeKind["DietAndNutrition"] = "diet_and_nutrition";ThemeKind["Meditation"] = "meditation";ThemeKind["MobilityAndPrehab"] = "mobility_and_prehab";ThemeKind["PersonalGrowth"] = "personal_growth";ThemeKind["Philosophy"] = "philosophy";ThemeKind["Postnatal"] = "postnatal";ThemeKind["Prenatal"] = "prenatal";ThemeKind["Restoration"] = "restoration";ThemeKind["Skills"] = "skills";ThemeKind["SmartBreaks"] = "smart_breaks";ThemeKind["StressAndAnxiety"] = "stress_and_anxiety";ThemeKind["WomensHealth"] = "womens_health";ThemeKind["Workout"] = "workout";ThemeKind["Yoga"] = "yoga";ThemeKind["YogaTeachers"] = "yoga_teachers";})(ThemeKind || (ThemeKind = {}));









































































































var BundleAccessStrategyKind;(function (BundleAccessStrategyKind) {BundleAccessStrategyKind["ByCode"] = "by_code";BundleAccessStrategyKind["ForAll"] = "for_all";BundleAccessStrategyKind["ForPremiumOnly"] = "for_premium_only";BundleAccessStrategyKind["ForUsersWithAccess"] = "for_users_with_access";})(BundleAccessStrategyKind || (BundleAccessStrategyKind = {}));






var BundleCategoryKind;(function (BundleCategoryKind) {BundleCategoryKind["ContentHub"] = "content_hub";BundleCategoryKind["FaR"] = "FaR";BundleCategoryKind["Partners"] = "partners";})(BundleCategoryKind || (BundleCategoryKind = {}));








































































var LiveEventKind;(function (LiveEventKind) {LiveEventKind["Classe"] = "classe";LiveEventKind["DonationClass"] = "donation_class";LiveEventKind["FreeEvent"] = "free_event";LiveEventKind["Lecture"] = "lecture";LiveEventKind["PartOfOnlineCourse"] = "part_of_online_course";LiveEventKind["Skills"] = "skills";LiveEventKind["Talk"] = "talk";LiveEventKind["Workshop"] = "workshop";})(LiveEventKind || (LiveEventKind = {}));










var LiveEventLevel;(function (LiveEventLevel) {LiveEventLevel["Advanced"] = "advanced";LiveEventLevel["Beginner"] = "beginner";LiveEventLevel["Everyone"] = "everyone";LiveEventLevel["Intermediate"] = "intermediate";LiveEventLevel["Other"] = "other";})(LiveEventLevel || (LiveEventLevel = {}));














var LiveEventStatus;(function (LiveEventStatus) {LiveEventStatus["Archived"] = "archived";LiveEventStatus["Canceled"] = "canceled";LiveEventStatus["Draft"] = "draft";LiveEventStatus["Published"] = "published";})(LiveEventStatus || (LiveEventStatus = {}));

























































































































































var UserDecisionKind;(function (UserDecisionKind) {UserDecisionKind["ProvaYogobe14"] = "ProvaYogobe14";})(UserDecisionKind || (UserDecisionKind = {}));



var EligibleForTrialReclaimKind;(function (EligibleForTrialReclaimKind) {EligibleForTrialReclaimKind["Available"] = "available";EligibleForTrialReclaimKind["Declined"] = "declined";})(EligibleForTrialReclaimKind || (EligibleForTrialReclaimKind = {}));













































var PaymentStatusKind;(function (PaymentStatusKind) {PaymentStatusKind["Archived"] = "archived";PaymentStatusKind["Authorized"] = "authorized";PaymentStatusKind["Done"] = "done";PaymentStatusKind["Draft"] = "draft";PaymentStatusKind["Pending"] = "pending";PaymentStatusKind["Processed"] = "processed";PaymentStatusKind["Refunded"] = "refunded";PaymentStatusKind["Rejected"] = "rejected";PaymentStatusKind["Timeout"] = "timeout";})(PaymentStatusKind || (PaymentStatusKind = {}));
























































































































var Provider;(function (Provider) {Provider["Apple"] = "apple";Provider["Email"] = "email";Provider["Facebook"] = "facebook";Provider["Google"] = "google";})(Provider || (Provider = {}));







































































var SubscriptionStatus;(function (SubscriptionStatus) {SubscriptionStatus["Active"] = "active";SubscriptionStatus["Cancelled"] = "cancelled";SubscriptionStatus["PastDue"] = "past_due";SubscriptionStatus["Unpaid"] = "unpaid";})(SubscriptionStatus || (SubscriptionStatus = {}));














































var BundleKind;(function (BundleKind) {BundleKind["BySubscription"] = "by_subscription";BundleKind["WithAccess"] = "with_access";})(BundleKind || (BundleKind = {}));




var BundleSectionKind;(function (BundleSectionKind) {BundleSectionKind["BlogPosts"] = "blog_posts";BundleSectionKind["Challenges"] = "challenges";BundleSectionKind["Documents"] = "documents";BundleSectionKind["InfoPanel"] = "info_panel";BundleSectionKind["InfoPanel_2"] = "info_panel_2";BundleSectionKind["LiveEvents"] = "live_events";BundleSectionKind["Playlists"] = "playlists";BundleSectionKind["Programs"] = "programs";BundleSectionKind["Videos"] = "videos";})(BundleSectionKind || (BundleSectionKind = {}));














































































































































































































var PlaylistSortAttribute;(function (PlaylistSortAttribute) {PlaylistSortAttribute["Alphabetical"] = "alphabetical";PlaylistSortAttribute["NewestFirst"] = "newest_first";})(PlaylistSortAttribute || (PlaylistSortAttribute = {}));












var VideoSortAttribute;(function (VideoSortAttribute) {VideoSortAttribute["Alphabetical"] = "alphabetical";VideoSortAttribute["Duration"] = "duration";VideoSortAttribute["Instructor"] = "instructor";VideoSortAttribute["NewestFirst"] = "newest_first";})(VideoSortAttribute || (VideoSortAttribute = {}));












var GenericProgramSortAttribute;(function (GenericProgramSortAttribute) {GenericProgramSortAttribute["Alphabetical"] = "alphabetical";GenericProgramSortAttribute["Duration"] = "duration";GenericProgramSortAttribute["NewestFirst"] = "newest_first";})(GenericProgramSortAttribute || (GenericProgramSortAttribute = {}));




















var CodeStatusKind;(function (CodeStatusKind) {CodeStatusKind["Invalid"] = "invalid";CodeStatusKind["Mismatch"] = "mismatch";CodeStatusKind["Valid"] = "valid";})(CodeStatusKind || (CodeStatusKind = {}));


















var Option;(function (Option) {Option["All"] = "all";Option["CourseInstructorsOnly"] = "course_instructors_only";Option["LiveEventsInstructorsOnly"] = "live_events_instructors_only";Option["ProgramInstructorsOnly"] = "program_instructors_only";})(Option || (Option = {}));






var SortAttribute;(function (SortAttribute) {SortAttribute["Name"] = "name";})(SortAttribute || (SortAttribute = {}));



var SortOrder;(function (SortOrder) {SortOrder["Asc"] = "ASC";SortOrder["Desc"] = "DESC";})(SortOrder || (SortOrder = {}));





































var LiveEventSortAttribute;(function (LiveEventSortAttribute) {LiveEventSortAttribute["AmountCents"] = "amount_cents";LiveEventSortAttribute["FirstEventDate"] = "first_event_date";})(LiveEventSortAttribute || (LiveEventSortAttribute = {}));










































var CurrencyKind;(function (CurrencyKind) {CurrencyKind["Eur"] = "EUR";CurrencyKind["Sek"] = "SEK";})(CurrencyKind || (CurrencyKind = {}));




var PaymentProviderKind;(function (PaymentProviderKind) {PaymentProviderKind["Adyen"] = "adyen";PaymentProviderKind["AdyenDibs"] = "adyen_dibs";PaymentProviderKind["Apple"] = "apple";PaymentProviderKind["Free"] = "free";PaymentProviderKind["Google"] = "google";PaymentProviderKind["Trustly"] = "trustly";PaymentProviderKind["Wellness"] = "wellness";})(PaymentProviderKind || (PaymentProviderKind = {}));












































































































































var MoodTrackerKind;(function (MoodTrackerKind) {MoodTrackerKind["Post"] = "post";MoodTrackerKind["Pre"] = "pre";})(MoodTrackerKind || (MoodTrackerKind = {}));




var VideoKind;(function (VideoKind) {VideoKind["Bonus"] = "bonus";VideoKind["Exercise"] = "exercise";VideoKind["Introduction"] = "introduction";VideoKind["Lecture"] = "lecture";VideoKind["Question"] = "question";VideoKind["Skills"] = "skills";VideoKind["Talk"] = "talk";VideoKind["Workshop"] = "workshop";})(VideoKind || (VideoKind = {}));






































































































































var SurveyTypeKind;(function (SurveyTypeKind) {SurveyTypeKind["CheckBoxes"] = "check_boxes";SurveyTypeKind["DropDown"] = "drop_down";SurveyTypeKind["DropDownMulti"] = "drop_down_multi";SurveyTypeKind["EmojiSlider"] = "emoji_slider";SurveyTypeKind["Input"] = "input";SurveyTypeKind["MoodSlider"] = "mood_slider";SurveyTypeKind["NumericalSlider"] = "numerical_slider";SurveyTypeKind["RadioButtons"] = "radio_buttons";SurveyTypeKind["RadioSlider"] = "radio_slider";SurveyTypeKind["RadioSlider2"] = "radio_slider2";SurveyTypeKind["StarRating"] = "star_rating";SurveyTypeKind["TextArea"] = "text_area";})(SurveyTypeKind || (SurveyTypeKind = {}));





























var State;(function (State) {State["Draft"] = "draft";State["Finished"] = "finished";})(State || (State = {}));



































































































































































































var ModelNameKind;(function (ModelNameKind) {ModelNameKind["BlogPosts"] = "blog_posts";ModelNameKind["Challenges"] = "challenges";ModelNameKind["Courses"] = "courses";ModelNameKind["Events"] = "events";ModelNameKind["GenericPrograms"] = "generic_programs";ModelNameKind["Instructors"] = "instructors";ModelNameKind["LandingPages"] = "landing_pages";ModelNameKind["LiveEvents"] = "live_events";ModelNameKind["Playlists"] = "playlists";ModelNameKind["Videos"] = "videos";})(ModelNameKind || (ModelNameKind = {}));








































































































var OtherTypeKind;(function (OtherTypeKind) {OtherTypeKind["Challenges"] = "challenges";OtherTypeKind["Live"] = "live";OtherTypeKind["Playlists"] = "playlists";OtherTypeKind["Programs"] = "programs";OtherTypeKind["Videos"] = "videos";})(OtherTypeKind || (OtherTypeKind = {}));







var SlugTypeKind;(function (SlugTypeKind) {SlugTypeKind["Breath"] = "breath";SlugTypeKind["Grow"] = "grow";SlugTypeKind["Meditate"] = "meditate";SlugTypeKind["Move"] = "move";SlugTypeKind["Yoga"] = "yoga";})(SlugTypeKind || (SlugTypeKind = {}));














































































var StatsPeriodKind;(function (StatsPeriodKind) {StatsPeriodKind["SevenDays"] = "sevenDays";StatsPeriodKind["ThirtyDays"] = "thirtyDays";})(StatsPeriodKind || (StatsPeriodKind = {}));
































var WellnessProviderKind;(function (WellnessProviderKind) {WellnessProviderKind["Actiway"] = "Actiway";WellnessProviderKind["Benefits"] = "Benefits";WellnessProviderKind["Benify"] = "Benify";WellnessProviderKind["Epassi"] = "Epassi";WellnessProviderKind["Wellnet"] = "Wellnet";})(WellnessProviderKind || (WellnessProviderKind = {}));







var PromotionCodeTypeKind;(function (PromotionCodeTypeKind) {PromotionCodeTypeKind["Trial"] = "trial";PromotionCodeTypeKind["Wellness"] = "wellness";})(PromotionCodeTypeKind || (PromotionCodeTypeKind = {}));










var VideoKindInput;(function (VideoKindInput) {VideoKindInput["Audio"] = "audio";VideoKindInput["Video"] = "video";})(VideoKindInput || (VideoKindInput = {}));




var VideoOrderBy;(function (VideoOrderBy) {VideoOrderBy["Alphabetical"] = "alphabetical";VideoOrderBy["Duration"] = "duration";VideoOrderBy["DurationAscending"] = "duration_ascending";VideoOrderBy["DurationDescending"] = "duration_descending";VideoOrderBy["Instructor"] = "instructor";VideoOrderBy["NewestFirst"] = "newest_first";VideoOrderBy["None"] = "none";VideoOrderBy["PublishedDescending"] = "published_descending";})(VideoOrderBy || (VideoOrderBy = {}));






















































































































































































































































































































































































































































































































































































































































































































var ErrorValue;
































/** Autogenerated return type of Validate */(function (ErrorValue) {ErrorValue["AccessShorter"] = "AccessShorter";ErrorValue["AccessUntilMissing"] = "AccessUntilMissing";ErrorValue["AlreadyAccessed"] = "AlreadyAccessed";ErrorValue["AlreadyUsed"] = "AlreadyUsed";ErrorValue["AnswersInvalid"] = "AnswersInvalid";ErrorValue["AnswersNotSaved"] = "AnswersNotSaved";ErrorValue["NoAccess"] = "NoAccess";ErrorValue["NoActiveProgram"] = "NoActiveProgram";ErrorValue["NotAuthorized"] = "NotAuthorized";ErrorValue["NotCompleted"] = "NotCompleted";ErrorValue["NotFound"] = "NotFound";ErrorValue["NotUnlocked"] = "NotUnlocked";ErrorValue["ProgramProgressNotCreated"] = "ProgramProgressNotCreated";ErrorValue["SurveyNotFound"] = "SurveyNotFound";ErrorValue["UserMissing"] = "UserMissing";})(ErrorValue || (ErrorValue = {}));


































































































































































var ItemTypeKind;



/** Autogenerated return type of AddWaitingItem */(function (ItemTypeKind) {ItemTypeKind["Bundle"] = "Bundle";})(ItemTypeKind || (ItemTypeKind = {}));











var ActionInput;




/** Autogenerated return type of AnswerSurvey */(function (ActionInput) {ActionInput["Complete"] = "COMPLETE";ActionInput["Draft"] = "DRAFT";})(ActionInput || (ActionInput = {}));












































var ClassName;





/** Autogenerated return type of ChangeProductEmailPreference */(function (ClassName) {ClassName["EmailPreference"] = "EmailPreference";ClassName["GenericProgram"] = "GenericProgram";ClassName["LiveEvent"] = "LiveEvent";})(ClassName || (ClassName = {}));
























var GenderKind;





/** Autogenerated return type of CompleteProfile */(function (GenderKind) {GenderKind["Female"] = "Female";GenderKind["Male"] = "Male";GenderKind["Other"] = "Other";})(GenderKind || (GenderKind = {}));























































var ProxyEventKind;(function (ProxyEventKind) {ProxyEventKind["SurveyStarted"] = "SURVEY_STARTED";ProxyEventKind["TrialPeriodStarted"] = "TRIAL_PERIOD_STARTED";})(ProxyEventKind || (ProxyEventKind = {}));






























































var ItemKind;(function (ItemKind) {ItemKind["Course"] = "Course";ItemKind["GenericProgram"] = "GenericProgram";ItemKind["LiveEvent"] = "LiveEvent";})(ItemKind || (ItemKind = {}));





































































































































































var MethodTypes;(function (MethodTypes) {MethodTypes["Code"] = "code";MethodTypes["Token"] = "token";})(MethodTypes || (MethodTypes = {}));




var ProviderTypes;





/** Autogenerated return type of SignIn */(function (ProviderTypes) {ProviderTypes["Apple"] = "Apple";ProviderTypes["Facebook"] = "Facebook";ProviderTypes["Google"] = "Google";})(ProviderTypes || (ProviderTypes = {}));























































var CodeSourceKind;(function (CodeSourceKind) {CodeSourceKind["App"] = "app";CodeSourceKind["Voucher"] = "voucher";})(CodeSourceKind || (CodeSourceKind = {}));




var CodeTypeKind;






/** Autogenerated return type of Favorite */(function (CodeTypeKind) {CodeTypeKind["AccessCode"] = "access_code";CodeTypeKind["AccessToken"] = "access_token";CodeTypeKind["ChallengePass"] = "challenge_pass";CodeTypeKind["DiscountCode"] = "discount_code";})(CodeTypeKind || (CodeTypeKind = {}));



















































































































































































































































































































































































































































































































































































































































































































var PricingSubscriptionFieldsFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject || (_templateObject = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    fragment PricingSubscriptionFields on UserSubscription {\n  title\n  description\n  shortDescription\n  amount\n  discountedAmount\n  currency\n  months\n  days\n  subscriptionName\n  subscriptionPlan\n  promotionKind\n  promotionName\n  recurringPromotion\n}\n    "])));
















var BundleEssentialFieldsFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject2 || (_templateObject2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    fragment BundleEssentialFields on Bundle {\n  id\n  title\n  slug\n  heroImage\n  heroMobileImage\n  active\n  kind\n  accessStrategy\n  isUserEligible\n  bundleCategory\n  userAccess {\n    active\n    accessUntil\n  }\n  client {\n    id\n    logo\n    name\n    slug\n  }\n  hiddenInListing\n  metaDescription\n  metaImage\n  publishedAt\n  shortDescription\n  promotionalImage\n  tags\n}\n    "])));






























var BlogPostFieldsFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject3 || (_templateObject3 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    fragment BlogPostFields on BlogPost {\n  id\n  slug\n  tags\n  title\n  body\n  authors\n  categories\n  featuredImage\n  language\n  market\n  publishedAt\n}\n    "])));














var ProgramInstructorsFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject4 || (_templateObject4 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    fragment ProgramInstructors on Instructor {\n  id\n  name\n  slug\n  assets {\n    squareImage\n  }\n}\n    "])));









var EssentialGenericFieldsFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject5 || (_templateObject5 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    fragment EssentialGenericFields on GenericProgram {\n  id\n  title\n  slug\n  promotionalImageUrl\n  category\n  priceType\n  kind\n  language\n  titleImageUrl\n  shortDescription\n  description\n  themes\n  accessStatus\n  price {\n    originalPrice\n    discountedPrice\n    discountApplied\n    currency\n  }\n  accessPeriod {\n    unit\n    value\n  }\n  duration {\n    unit\n    value\n  }\n  instructors {\n    ...ProgramInstructors\n  }\n}\n    ", ""])),
































ProgramInstructorsFragmentDoc);
var FullGenericProgramFieldsFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject6 || (_templateObject6 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    fragment FullGenericProgramFields on GenericProgram {\n  id\n  ...EssentialGenericFields\n  progress\n  summaryAsset\n  meta {\n    title\n    description\n    imageUrl\n  }\n  discount {\n    discountType\n    discountValue\n    discountedPrice\n    endDate\n    identifier\n    startDate\n  }\n  postSurvey {\n    id\n    label\n    kind\n    link\n    finished\n    locked\n  }\n  preSurvey {\n    id\n    label\n    kind\n    link\n    finished\n    locked\n  }\n  trailer {\n    content {\n      title\n    }\n    minutes\n    thumbnailUrl\n    hls\n    player {\n      assets {\n        resolution\n        src\n      }\n    }\n  }\n}\n    ", ""])),

















































EssentialGenericFieldsFragmentDoc);
var PlaylistEssentialFieldsFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject7 || (_templateObject7 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    fragment PlaylistEssentialFields on Playlist {\n  id\n  identifier\n  visibility\n  title\n  description\n  owner {\n    id\n    firstName\n  }\n  meta {\n    videoCount\n    minutes\n  }\n  assets {\n    thumbnailUrl\n  }\n  videos {\n    id\n    identifier\n    kind\n    assets {\n      thumbnailUrl\n    }\n    hls\n    hasAccess\n    player {\n      assets {\n        src\n        resolution\n      }\n    }\n    cursorAt\n    meta {\n      minutes\n    }\n    content {\n      title\n      longDescription\n      shortDescription\n    }\n    taxonomies {\n      instructors {\n        id\n        name\n        slug\n      }\n      needs {\n        id\n        name\n      }\n      bodyparts {\n        id\n        name\n      }\n      styles {\n        id\n        name\n      }\n      genre {\n        id\n        name\n        slug\n      }\n    }\n  }\n}\n    "])));




































































var PlaylistCardFieldsFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject8 || (_templateObject8 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    fragment PlaylistCardFields on Playlist {\n  id\n  identifier\n  visibility\n  title\n  description\n  owner {\n    id\n    firstName\n  }\n  meta {\n    videoCount\n    minutes\n  }\n  assets {\n    thumbnailUrl\n  }\n}\n    "])));



















var VideoFieldsFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject9 || (_templateObject9 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    fragment VideoFields on Video {\n  id\n  identifier\n  kind\n  cursorAt\n  content {\n    title\n    shortDescription\n    longDescription\n  }\n  meta {\n    minutes\n    publishedAt\n  }\n  primaryStyle {\n    name\n    slug\n  }\n  taxonomies {\n    flavor {\n      id\n      name\n    }\n    needs {\n      id\n      name\n    }\n    instructors {\n      id\n      name\n      slug\n    }\n    genre {\n      id\n      name\n      slug\n    }\n  }\n  assets {\n    thumbnailUrl\n  }\n}\n    "])));











































var LiveEventEssentialFieldsFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject10 || (_templateObject10 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    fragment LiveEventEssentialFields on LiveEvent {\n  id\n  title\n  slug\n  thumbnail\n  duration\n  eventDates\n  kind\n  language\n  level\n  theme\n  availableSpots\n  maximumParticipants\n  bookingAvailable\n  price {\n    originalPrice\n    discountApplied\n    discountedPrice\n    currency\n  }\n  descriptionLong\n  registrationEndDate\n  registrationStartDate\n  isExpired @client\n  isComingSoon @client\n  primaryInstructor {\n    id\n    name\n    slug\n    assets {\n      squareImage\n    }\n  }\n  instructors @client {\n    id\n    name\n    slug\n    assets {\n      squareImage\n    }\n  }\n}\n    "])));











































var LiveCodeDataFieldsFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject11 || (_templateObject11 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    fragment LiveCodeDataFields on PromotionCode {\n  code\n  expirationDate\n  usageLimit\n  creationDate\n  provider\n  matchingResources {\n    ... on LiveEvent {\n      ...LiveEventEssentialFields\n    }\n  }\n  usedIn {\n    usageDate\n    live {\n      ...LiveEventEssentialFields\n    }\n  }\n}\n    ", ""])),


















LiveEventEssentialFieldsFragmentDoc);
var FullLiveEventFieldsFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject12 || (_templateObject12 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    fragment FullLiveEventFields on LiveEvent {\n  ...LiveEventEssentialFields\n  otherInstructors {\n    id\n    name\n    slug\n    assets {\n      squareImage\n    }\n  }\n  accessories\n  linkToRecordings {\n    link\n    id\n    eventDate\n  }\n}\n    ", ""])),

















LiveEventEssentialFieldsFragmentDoc);
var ProgramIntroFieldsFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject13 || (_templateObject13 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    fragment ProgramIntroFields on SpecialSection {\n  description\n  label\n  assetUrl\n  slug\n}\n    "])));







var ProgramVideoFieldsFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject14 || (_templateObject14 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    fragment ProgramVideoFields on ProgramVideo {\n  id\n  slug\n  title\n  subheader\n  customTitle\n  locked\n  watched\n  finished\n  position\n  positionLabel\n  videoKind\n  progressIsCurrent\n  repeatRecomendation\n  customDescription\n  preMoodTracker {\n    id\n    finished\n    kind\n  }\n  postMoodTracker {\n    id\n    finished\n    kind\n  }\n  video {\n    id\n    title\n    kind\n    identifier\n    hasAccess\n    cursorAt\n    content {\n      title\n      shortDescription\n      longDescription\n    }\n    hls\n    player {\n      assets {\n        src\n        size\n        resolution\n      }\n    }\n    meta {\n      publishedAt\n      minutes\n    }\n    taxonomies {\n      flavor {\n        name\n      }\n      instructors {\n        name\n        slug\n      }\n      genre {\n        name\n        slug\n      }\n    }\n    assets {\n      thumbnailUrl\n    }\n  }\n}\n    "])));




































































var ProgramOutroFieldsFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject15 || (_templateObject15 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    fragment ProgramOutroFields on SpecialSection {\n  description\n  label\n  slug\n  videos {\n    ...ProgramVideoFields\n  }\n}\n    ", ""])),








ProgramVideoFieldsFragmentDoc);
var PhasedProgramFieldsFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject16 || (_templateObject16 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    fragment PhasedProgramFields on PhasedProgram {\n  id\n  slug\n  title @client\n  progress @client\n  language @client\n  weeksCount @client\n  phasesCount @client\n  currentElement @client {\n    path\n    title\n  }\n  videosCount @client\n  instructors @client {\n    id\n    name\n    assets {\n      squareImage\n    }\n  }\n  intro {\n    ...ProgramIntroFields\n  }\n  outro {\n    ...ProgramOutroFields\n  }\n  phases {\n    id\n    description\n    label\n    progress\n    slug\n    finished\n    locked\n    videosCount @client\n    videosDuration @client\n    weeksRange @client\n    weeks {\n      id\n      label\n      slug\n      locked\n      finished\n      indexInProgram @client\n      videos {\n        ...ProgramVideoFields\n      }\n    }\n  }\n}\n    ", "\n", "\n", ""])),


















































ProgramIntroFieldsFragmentDoc,
ProgramOutroFieldsFragmentDoc,
ProgramVideoFieldsFragmentDoc);
var SearchVideoFieldsFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject17 || (_templateObject17 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    fragment SearchVideoFields on SearchVideo {\n  id\n  identifier\n  title\n  thumbnailUrl\n  instructorName\n  instructorSlug\n  longDescription\n  kind\n  minutes\n  primaryStyleName\n  primaryStyleSlug\n  shortDescription\n}\n    "])));















var SearchPlaylistFieldsFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject18 || (_templateObject18 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    fragment SearchPlaylistFields on SearchPlaylist {\n  id\n  identifier\n  title\n  description\n  minutes\n  thumbnailUrl\n  videoCount\n  ownerId\n  visibility\n}\n    "])));












var SearchGenericProgramFieldsFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject19 || (_templateObject19 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    fragment SearchGenericProgramFields on SearchGenericProgram {\n  accessPeriod {\n    unit\n    value\n  }\n  category\n  description\n  durationUnit\n  durationValue\n  id\n  instructorName\n  instructorSlug\n  price {\n    currency\n    discountApplied\n    discountedPrice\n    originalPrice\n  }\n  priceType\n  slug\n  themes\n  title\n  titleImageUrl\n}\n    "])));

























var SearchInstructorFieldsFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject20 || (_templateObject20 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    fragment SearchInstructorFields on SearchInstructor {\n  description\n  id\n  name\n  slug\n  squareImageUrl\n}\n    "])));








var SearchEventFieldsFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject21 || (_templateObject21 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    fragment SearchEventFields on SearchEvent {\n  id\n  name\n  slug\n  description\n  endsAt\n  instructor\n  startsAt\n  titleImageUrl\n  location\n}\n    "])));












var SearchLiveEventFieldsFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject22 || (_templateObject22 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    fragment SearchLiveEventFields on SearchLiveEvent {\n  id\n  kind\n  slug\n  theme\n  thumbnailUrl\n  title\n  availableSpots\n  bookingAvailable\n  duration\n  eventDates\n  instructorName\n  instructorSlug\n  maximumParticipants\n  registrationEndDate\n  registrationStartDate\n  isExpired @client\n  isComingSoon @client\n  price @client {\n    currency\n    discountApplied\n    discountedPrice\n    originalPrice\n  }\n}\n    "])));


























var SearchLandingPageFieldsFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject23 || (_templateObject23 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    fragment SearchLandingPageFields on SearchLandingPage {\n  id\n  lede\n  locale\n  title\n  slug\n}\n    "])));








var SearchBlogPostFieldsFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject24 || (_templateObject24 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    fragment SearchBlogPostFields on SearchBlogPost {\n  featuredImageUrl\n  id\n  slug\n  title\n}\n    "])));







var ProgramTextElementFieldsFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject25 || (_templateObject25 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    fragment ProgramTextElementFields on ProgramPartElement {\n  id\n  slug\n  subheader\n  title\n  description\n  locked\n  finished\n  position\n  positionLabel\n  progressIsCurrent\n}\n    "])));













var ProgramSurveyFieldsFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject26 || (_templateObject26 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    fragment ProgramSurveyFields on Survey {\n  id\n  name\n  description\n  content {\n    page1Description\n    page1Title\n    page2Description\n    page2Title\n    page3ButtonUrl\n    page3ButtonText\n    page3Description\n    page3Title\n  }\n  questions {\n    id\n    question\n    answers\n    options {\n      default\n      hint\n      leftLabel\n      maxValue\n      minValue\n      required\n      rightLabel\n      useForNps\n      type\n    }\n  }\n}\n    "])));
































var ProgramSurveyElementFieldsFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject27 || (_templateObject27 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    fragment ProgramSurveyElementFields on ProgramSurveyElement {\n  id\n  slug\n  subheader\n  title\n  description\n  locked\n  finished\n  position\n  positionLabel\n  progressIsCurrent\n  lastSubmittedAt\n  surveysAnswer {\n    id\n    state\n    contextableType\n    content {\n      key\n      value\n    }\n  }\n  survey {\n    ...ProgramSurveyFields\n  }\n}\n    ", ""])),

























ProgramSurveyFieldsFragmentDoc);
var ProgramDocumentFieldsFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject28 || (_templateObject28 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    fragment ProgramDocumentFields on ProgramDocument {\n  id\n  slug\n  title\n  subheader\n  description\n  finished\n  kind\n  locked\n  position\n  positionLabel\n  progressIsCurrent\n  document {\n    url\n    name\n  }\n}\n    "])));


















var WeeklyProgramWeekFragmentFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject29 || (_templateObject29 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    fragment WeeklyProgramWeekFragment on ProgramWeek {\n  id\n  label\n  slug\n  locked\n  finished\n  progress\n  description\n  duration @client\n  videosCount @client\n  elements {\n    __typename\n    ... on ProgramPartElement {\n      ...ProgramTextElementFields\n    }\n    ... on ProgramSurveyElement {\n      ...ProgramSurveyElementFields\n    }\n    ... on ProgramDocument {\n      ...ProgramDocumentFields\n    }\n    ... on ProgramVideo {\n      ...ProgramVideoFields\n    }\n  }\n}\n    ", "\n", "\n", "\n", ""])),


























ProgramTextElementFieldsFragmentDoc,
ProgramSurveyElementFieldsFragmentDoc,
ProgramDocumentFieldsFragmentDoc,
ProgramVideoFieldsFragmentDoc);
var WeeklyProgramFieldsFragmentDoc = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject30 || (_templateObject30 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    fragment WeeklyProgramFields on WeeklyProgram {\n  id\n  slug\n  recomendation\n  progress @client\n  videosCount @client\n  currentElement @client {\n    path\n    title\n  }\n  instructors @client {\n    ...ProgramInstructors\n  }\n  intro {\n    ...ProgramIntroFields\n  }\n  outro {\n    ...ProgramOutroFields\n  }\n  weeks {\n    ...WeeklyProgramWeekFragment\n  }\n}\n    ", "\n", "\n", "\n", ""])),























ProgramInstructorsFragmentDoc,
ProgramIntroFieldsFragmentDoc,
ProgramOutroFieldsFragmentDoc,
WeeklyProgramWeekFragmentFragmentDoc);
var CancelSubscriptionDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject31 || (_templateObject31 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    mutation cancelSubscription {\n  cancelSubscription {\n    success\n  }\n}\n    "])));








/**
 * __useCancelSubscriptionMutation__
 *
 * To run a mutation, you first call `useCancelSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSubscriptionMutation, { data, loading, error }] = useCancelSubscriptionMutation({
 *   variables: {
 *   },
 * });
 */
function useCancelSubscriptionMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D(CancelSubscriptionDocument, options);
}



var AuthenticateUserDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject32 || (_templateObject32 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    mutation authenticateUser($email: String!, $password: String!) {\n  authenticateUser(email: $email, password: $password) {\n    user {\n      id\n      firstName\n      lastName\n      email\n    }\n  }\n}\n    "])));













/**
 * __useAuthenticateUserMutation__
 *
 * To run a mutation, you first call `useAuthenticateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticateUserMutation, { data, loading, error }] = useAuthenticateUserMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
function useAuthenticateUserMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D(AuthenticateUserDocument, options);
}



var AvailableOneTimeCodeDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject33 || (_templateObject33 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    query availableOneTimeCode($code: String) {\n  availableOneTimeCode(code: $code, platform: web) {\n    isCodeValid\n    code\n    codeType\n    validationMessage\n    oneTimeCodes {\n      ...PricingSubscriptionFields\n    }\n  }\n}\n    ", ""])),











PricingSubscriptionFieldsFragmentDoc);

/**
 * __useAvailableOneTimeCodeQuery__
 *
 * To run a query within a React component, call `useAvailableOneTimeCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableOneTimeCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableOneTimeCodeQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
function useAvailableOneTimeCodeQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return Apollo.useQuery(AvailableOneTimeCodeDocument, options);
}
function useAvailableOneTimeCodeLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .useLazyQuery */ .t(AvailableOneTimeCodeDocument, options);
}



function refetchAvailableOneTimeCodeQuery(variables) {
  return { query: AvailableOneTimeCodeDocument, variables: variables };
}
var PricingSubscriptionPlansDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject34 || (_templateObject34 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    query PricingSubscriptionPlans($code: String) {\n  availableSubscriptionPlans(code: $code, platform: web) {\n    code\n    isCodeValid\n    subscriptions {\n      ...PricingSubscriptionFields\n    }\n  }\n}\n    ", ""])),









PricingSubscriptionFieldsFragmentDoc);

/**
 * __usePricingSubscriptionPlansQuery__
 *
 * To run a query within a React component, call `usePricingSubscriptionPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `usePricingSubscriptionPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePricingSubscriptionPlansQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
function usePricingSubscriptionPlansQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_5__/* .useQuery */ .a(PricingSubscriptionPlansDocument, options);
}
function usePricingSubscriptionPlansLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(PricingSubscriptionPlansDocument, options);
}



function refetchPricingSubscriptionPlansQuery(variables) {
  return { query: PricingSubscriptionPlansDocument, variables: variables };
}
var FullAvailableSubscriptionPlansDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject35 || (_templateObject35 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    query FullAvailableSubscriptionPlans($code: String) {\n  availableSubscriptionPlans(code: $code, platform: web) {\n    code\n    codeType\n    isCodeValid\n    validationMessage\n    subscriptions {\n      ...PricingSubscriptionFields\n    }\n    fullAccesses {\n      title\n      description\n      shortDescription\n      currency\n      promotionKind\n      promotionName\n      extraPromotion\n      subscriptionName\n      subscriptionPlan\n    }\n    oneTimeCodes {\n      title\n      description\n      shortDescription\n      promotionKind\n      promotionName\n    }\n  }\n}\n    ", ""])),





























PricingSubscriptionFieldsFragmentDoc);

/**
 * __useFullAvailableSubscriptionPlansQuery__
 *
 * To run a query within a React component, call `useFullAvailableSubscriptionPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useFullAvailableSubscriptionPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFullAvailableSubscriptionPlansQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
function useFullAvailableSubscriptionPlansQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_5__/* .useQuery */ .a(FullAvailableSubscriptionPlansDocument, options);
}
function useFullAvailableSubscriptionPlansLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(FullAvailableSubscriptionPlansDocument, options);
}



function refetchFullAvailableSubscriptionPlansQuery(variables) {
  return { query: FullAvailableSubscriptionPlansDocument, variables: variables };
}
var AvailableTrialExtensionsDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject36 || (_templateObject36 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    query availableTrialExtensions($code: String) {\n  availableTrialExtensions(code: $code, platform: web) {\n    code\n    codeType\n    isCodeValid\n    validationMessage\n    trials {\n      months\n      days\n      subscriptionPlan\n      promotionKind\n      promotionName\n    }\n    trialReferralCodes {\n      months\n      days\n      subscriptionPlan\n      promotionKind\n      promotionName\n    }\n    oneTimeCodes {\n      accessUntil\n      months\n      days\n      subscriptionPlan\n      promotionKind\n      promotionName\n    }\n  }\n}\n    "])));
































/**
 * __useAvailableTrialExtensionsQuery__
 *
 * To run a query within a React component, call `useAvailableTrialExtensionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableTrialExtensionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableTrialExtensionsQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
function useAvailableTrialExtensionsQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_5__/* .useQuery */ .a(AvailableTrialExtensionsDocument, options);
}
function useAvailableTrialExtensionsLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(AvailableTrialExtensionsDocument, options);
}



function refetchAvailableTrialExtensionsQuery(variables) {
  return { query: AvailableTrialExtensionsDocument, variables: variables };
}
var BasicBundleDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject37 || (_templateObject37 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    query basicBundle($slug: String!, $client: String!) {\n  basicBundle: bundle(slug: $slug, client: $client) {\n    ...BundleEssentialFields\n  }\n}\n    ", ""])),





BundleEssentialFieldsFragmentDoc);

/**
 * __useBasicBundleQuery__
 *
 * To run a query within a React component, call `useBasicBundleQuery` and pass it any options that fit your needs.
 * When your component renders, `useBasicBundleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBasicBundleQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      client: // value for 'client'
 *   },
 * });
 */
function useBasicBundleQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_5__/* .useQuery */ .a(BasicBundleDocument, options);
}
function useBasicBundleLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(BasicBundleDocument, options);
}



function refetchBasicBundleQuery(variables) {
  return { query: BasicBundleDocument, variables: variables };
}
var BundleDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject38 || (_templateObject38 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    query bundle($slug: String!, $client: String!) {\n  bundle(slug: $slug, client: $client) {\n    ...BundleEssentialFields\n    trailer {\n      identifier\n      minutes\n      thumbnailUrl\n      hls\n      player {\n        assets {\n          resolution\n          src\n        }\n      }\n    }\n    sections\n    infoPanel {\n      title\n      description\n      image\n    }\n    infoPanel2 {\n      title\n      image\n      longText\n      previewText\n    }\n    bundleItems {\n      __typename\n      videos {\n        ... on Video {\n          ...VideoFields\n        }\n      }\n      challenges {\n        ... on GenericProgram {\n          ...EssentialGenericFields\n        }\n      }\n      programs {\n        ... on GenericProgram {\n          ...EssentialGenericFields\n        }\n      }\n      playlists {\n        ... on Playlist {\n          ...PlaylistCardFields\n        }\n      }\n      liveEvents {\n        ... on LiveEvent {\n          ...LiveEventEssentialFields\n        }\n      }\n      blogPosts {\n        ... on BlogPost {\n          ...BlogPostFields\n        }\n      }\n      documents {\n        ... on Document {\n          contentType\n          id\n          name\n          url\n        }\n      }\n    }\n  }\n}\n    ", "\n", "\n", "\n", "\n", "\n", ""])),






































































BundleEssentialFieldsFragmentDoc,
VideoFieldsFragmentDoc,
EssentialGenericFieldsFragmentDoc,
PlaylistCardFieldsFragmentDoc,
LiveEventEssentialFieldsFragmentDoc,
BlogPostFieldsFragmentDoc);

/**
 * __useBundleQuery__
 *
 * To run a query within a React component, call `useBundleQuery` and pass it any options that fit your needs.
 * When your component renders, `useBundleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBundleQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      client: // value for 'client'
 *   },
 * });
 */
function useBundleQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_5__/* .useQuery */ .a(BundleDocument, options);
}
function useBundleLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(BundleDocument, options);
}



function refetchBundleQuery(variables) {
  return { query: BundleDocument, variables: variables };
}
var ActivateBundleDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject39 || (_templateObject39 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    mutation activateBundle($slug: String!, $client: String!, $code: String!) {\n  activateBundle(slug: $slug, code: $code, client: $client) {\n    success\n    errors\n  }\n}\n    "])));









/**
 * __useActivateBundleMutation__
 *
 * To run a mutation, you first call `useActivateBundleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateBundleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateBundleMutation, { data, loading, error }] = useActivateBundleMutation({
 *   variables: {
 *      slug: // value for 'slug'
 *      client: // value for 'client'
 *      code: // value for 'code'
 *   },
 * });
 */
function useActivateBundleMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D(ActivateBundleDocument, options);
}



var ValidateBundleCodeDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject40 || (_templateObject40 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    query validateBundleCode($slug: String!, $code: String!, $client: String!) {\n  validateBundleCode(slug: $slug, code: $code, client: $client) {\n    code\n    message\n    status\n  }\n}\n    "])));









/**
 * __useValidateBundleCodeQuery__
 *
 * To run a query within a React component, call `useValidateBundleCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateBundleCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateBundleCodeQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      code: // value for 'code'
 *      client: // value for 'client'
 *   },
 * });
 */
function useValidateBundleCodeQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return Apollo.useQuery(ValidateBundleCodeDocument, options);
}
function useValidateBundleCodeLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .useLazyQuery */ .t(ValidateBundleCodeDocument, options);
}



function refetchValidateBundleCodeQuery(variables) {
  return { query: ValidateBundleCodeDocument, variables: variables };
}
var BundlesDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject41 || (_templateObject41 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    query bundles($page: Int, $perPage: Int) {\n  bundles(page: $page, perPage: $perPage) {\n    page\n    perPage\n    totalCount\n    data {\n      slug\n      client {\n        slug\n      }\n    }\n  }\n}\n    "])));















/**
 * __useBundlesQuery__
 *
 * To run a query within a React component, call `useBundlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBundlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBundlesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
function useBundlesQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return Apollo.useQuery(BundlesDocument, options);
}
function useBundlesLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(BundlesDocument, options);
}



function refetchBundlesQuery(variables) {
  return { query: BundlesDocument, variables: variables };
}
var MyBundlesDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject42 || (_templateObject42 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    query myBundles($page: Int, $perPage: Int) {\n  myBundles(page: $page, perPage: $perPage) {\n    page\n    perPage\n    totalCount\n    data {\n      ...BundleEssentialFields\n    }\n  }\n}\n    ", ""])),










BundleEssentialFieldsFragmentDoc);

/**
 * __useMyBundlesQuery__
 *
 * To run a query within a React component, call `useMyBundlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyBundlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyBundlesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
function useMyBundlesQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_5__/* .useQuery */ .a(MyBundlesDocument, options);
}
function useMyBundlesLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(MyBundlesDocument, options);
}



function refetchMyBundlesQuery(variables) {
  return { query: MyBundlesDocument, variables: variables };
}
var ChangeProfileDataDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject43 || (_templateObject43 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    mutation changeProfileData($displayName: String, $shortBio: String, $instagramUrl: String, $facebookUrl: String, $linkedinUrl: String, $timezone: String, $avatar: Upload) {\n  changeProfileData(displayName: $displayName, shortBio: $shortBio, instagramUrl: $instagramUrl, facebookUrl: $facebookUrl, linkedinUrl: $linkedinUrl, timezone: $timezone, avatar: $avatar) {\n    user {\n      id\n    }\n  }\n}\n    "])));










/**
 * __useChangeProfileDataMutation__
 *
 * To run a mutation, you first call `useChangeProfileDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeProfileDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeProfileDataMutation, { data, loading, error }] = useChangeProfileDataMutation({
 *   variables: {
 *      displayName: // value for 'displayName'
 *      shortBio: // value for 'shortBio'
 *      instagramUrl: // value for 'instagramUrl'
 *      facebookUrl: // value for 'facebookUrl'
 *      linkedinUrl: // value for 'linkedinUrl'
 *      timezone: // value for 'timezone'
 *      avatar: // value for 'avatar'
 *   },
 * });
 */
function useChangeProfileDataMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D(ChangeProfileDataDocument, options);
}



var CompleteProfileDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject44 || (_templateObject44 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    mutation completeProfile($phone: String, $address: String, $postalCode: String, $city: String, $gender: GenderKind, $country: String, $countryCode: String = \"SE\", $trialExtensionCode: String, $oneTimeCode: String) {\n  completeProfile(phone: $phone, address: $address, postalCode: $postalCode, city: $city, gender: $gender, country: $country, countryCode: $countryCode, platform: web, trialExtensionCode: $trialExtensionCode, oneTimeCode: $oneTimeCode) {\n    errors {\n      message\n    }\n    user {\n      id\n    }\n  }\n}\n    "])));













/**
 * __useCompleteProfileMutation__
 *
 * To run a mutation, you first call `useCompleteProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeProfileMutation, { data, loading, error }] = useCompleteProfileMutation({
 *   variables: {
 *      phone: // value for 'phone'
 *      address: // value for 'address'
 *      postalCode: // value for 'postalCode'
 *      city: // value for 'city'
 *      gender: // value for 'gender'
 *      country: // value for 'country'
 *      countryCode: // value for 'countryCode'
 *      trialExtensionCode: // value for 'trialExtensionCode'
 *      oneTimeCode: // value for 'oneTimeCode'
 *   },
 * });
 */
function useCompleteProfileMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D(CompleteProfileDocument, options);
}



var CurrentUserDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject45 || (_templateObject45 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    query currentUser {\n  currentUser {\n    id\n    firstName\n    lastName\n    email\n    accessToken\n    accessUntil\n    completedAt\n    eligibleForTrialReclaim(promotionName: ProvaYogobe14)\n    isPremium @client\n    isNoneTrialPremium @client\n    hasWellness @client\n    group\n    isEmailActivated\n    accountActivatedAt\n    isPublic\n    kind\n    locale\n    slug\n    previousEmail\n    trialPeriod\n    country\n    zipcode\n    city\n    phone\n    address\n    referralCode\n    profile {\n      displayName\n      shortBio\n      instagramURL\n      linkedinURL\n      facebookURL\n      timezone\n    }\n    assets {\n      avatar\n    }\n    preferences {\n      contentLanguages\n      preferTerms\n      excludeTerms\n      videoLevels\n    }\n    subscriptionPlanSelected\n    subscription {\n      provider\n      status\n      inTrialPeriod\n      currentSubscriptionPlan {\n        platform\n        planType\n        platform\n        productId\n      }\n    }\n    onboardingCompleted\n    onboardingSkipped\n    onboardingInterestsSkipped\n    onboardingTopicsSkipped\n  }\n}\n    "])));

































































/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
function useCurrentUserQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_5__/* .useQuery */ .a(CurrentUserDocument, options);
}
function useCurrentUserLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(CurrentUserDocument, options);
}



function refetchCurrentUserQuery(variables) {
  return { query: CurrentUserDocument, variables: variables };
}
var CurrentUser2Document = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject46 || (_templateObject46 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    query currentUser2 {\n  currentUser {\n    id\n    accessUntil\n    paymentTypeRenews\n    paymentFailedAt\n    gender\n    dateOfBirth\n    profession\n    nextBillingCycle {\n      paymentStatus\n      amount\n      billingDate\n      planName\n    }\n    topics {\n      name\n      slug\n    }\n    interests {\n      name\n      slug\n    }\n    favorites {\n      videos\n      playlists\n    }\n    privacySettings {\n      isPrivateFavorites\n      isPrivateHistory\n      isPrivatePlaylists\n      isPrivateProfile\n      isPrivateStats\n    }\n    statistics {\n      sessionsLastWeek\n      sessionsCompleted\n      totalTime\n      averageDuration\n    }\n    receipts {\n      date\n      number\n      paymentType\n      paymentProvider\n      amount\n      currency\n      transact\n      downloadUrl\n    }\n    extraPayments {\n      date\n      number\n      paymentType\n      amount\n      currency\n      transact\n      downloadUrl\n    }\n    liveEventsAccess {\n      liveEvent {\n        id\n        duration\n        eventDates\n        kind\n        language\n        level\n        theme\n        slug\n        title\n        thumbnail\n        accessories\n        price {\n          originalPrice\n          discountApplied\n          discountedPrice\n          currency\n        }\n        registrationEndDate\n        registrationStartDate\n        descriptionLong\n        availableSpots\n        bookingAvailable\n        primaryInstructor {\n          id\n          name\n          slug\n          assets {\n            squareImage\n          }\n        }\n        otherInstructors {\n          id\n          name\n          slug\n          assets {\n            squareImage\n          }\n        }\n        instructors @client {\n          id\n          name\n          slug\n          assets {\n            squareImage\n          }\n        }\n      }\n      zoomLink\n      zoomPassword\n    }\n    programAccess {\n      accessStatus\n      accessUntil\n      program {\n        id\n        name\n        title: name\n        slug\n        lede\n        shortDescription\n        themes\n        legacy\n        language\n        titleImageUrl\n        tags\n        duration {\n          value\n          unit\n        }\n        instructors {\n          id\n          name\n          slug\n          assets {\n            squareImage\n          }\n        }\n      }\n    }\n    courseAccesses {\n      accessUntil\n      accessStatus\n      course {\n        id\n        name\n        titleImageUrl\n        slug\n        path\n        themes\n        legacy\n        content {\n          lede\n        }\n      }\n    }\n    challengeParticipations {\n      accessUntil\n      challenge {\n        name\n      }\n    }\n  }\n}\n    "])));






































































































































































/**
 * __useCurrentUser2Query__
 *
 * To run a query within a React component, call `useCurrentUser2Query` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUser2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUser2Query({
 *   variables: {
 *   },
 * });
 */
function useCurrentUser2Query(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return Apollo.useQuery(CurrentUser2Document, options);
}
function useCurrentUser2LazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .useLazyQuery */ .t(CurrentUser2Document, options);
}



function refetchCurrentUser2Query(variables) {
  return { query: CurrentUser2Document, variables: variables };
}
var DashboardRecentVideosDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject47 || (_templateObject47 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    query dashboardRecentVideos {\n  recentVideos {\n    id\n    identifier\n    content {\n      title\n      shortDescription\n    }\n    meta {\n      minutes\n      publishedAt\n    }\n    taxonomies {\n      flavor {\n        name\n      }\n      instructors {\n        name\n        slug\n      }\n      genre {\n        name\n        slug\n      }\n    }\n    assets {\n      thumbnailUrl\n    }\n  }\n}\n    "])));
































/**
 * __useDashboardRecentVideosQuery__
 *
 * To run a query within a React component, call `useDashboardRecentVideosQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardRecentVideosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardRecentVideosQuery({
 *   variables: {
 *   },
 * });
 */
function useDashboardRecentVideosQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return Apollo.useQuery(DashboardRecentVideosDocument, options);
}
function useDashboardRecentVideosLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(DashboardRecentVideosDocument, options);
}



function refetchDashboardRecentVideosQuery(variables) {
  return { query: DashboardRecentVideosDocument, variables: variables };
}
var DashboardTaxonomiesDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject48 || (_templateObject48 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    query dashboardTaxonomies($filter: String) {\n  playlists: taxonomies(filter: $filter) {\n    terms {\n      id\n      name\n      titleImageUrl\n      slug\n    }\n  }\n}\n    "])));












/**
 * __useDashboardTaxonomiesQuery__
 *
 * To run a query within a React component, call `useDashboardTaxonomiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardTaxonomiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardTaxonomiesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
function useDashboardTaxonomiesQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_5__/* .useQuery */ .a(DashboardTaxonomiesDocument, options);
}
function useDashboardTaxonomiesLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(DashboardTaxonomiesDocument, options);
}



function refetchDashboardTaxonomiesQuery(variables) {
  return { query: DashboardTaxonomiesDocument, variables: variables };
}
var EmailPreferencesDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject49 || (_templateObject49 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    query EmailPreferences($email: String, $token: String) {\n  emailPreferences(email: $email, token: $token) {\n    id\n    isMuted\n    key\n    name\n    description\n  }\n}\n    "])));











/**
 * __useEmailPreferencesQuery__
 *
 * To run a query within a React component, call `useEmailPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailPreferencesQuery({
 *   variables: {
 *      email: // value for 'email'
 *      token: // value for 'token'
 *   },
 * });
 */
function useEmailPreferencesQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_5__/* .useQuery */ .a(EmailPreferencesDocument, options);
}
function useEmailPreferencesLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(EmailPreferencesDocument, options);
}



function refetchEmailPreferencesQuery(variables) {
  return { query: EmailPreferencesDocument, variables: variables };
}
var ChangeEmailPreferenceDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject50 || (_templateObject50 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    mutation ChangeEmailPreference($mute: Boolean!, $key: String!, $email: String, $token: String) {\n  changeEmailPreference(mute: $mute, key: $key, email: $email, token: $token) {\n    errors\n    success\n  }\n}\n    "])));









/**
 * __useChangeEmailPreferenceMutation__
 *
 * To run a mutation, you first call `useChangeEmailPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeEmailPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeEmailPreferenceMutation, { data, loading, error }] = useChangeEmailPreferenceMutation({
 *   variables: {
 *      mute: // value for 'mute'
 *      key: // value for 'key'
 *      email: // value for 'email'
 *      token: // value for 'token'
 *   },
 * });
 */
function useChangeEmailPreferenceMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D(ChangeEmailPreferenceDocument, options);
}



var EventProxyDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject51 || (_templateObject51 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    mutation eventProxy($event: ProxyEventKind!, $properties: [EventPropertyInput!]) {\n  eventProxy(event: $event, properties: $properties) {\n    errors {\n      message\n    }\n  }\n}\n    "])));










/**
 * __useEventProxyMutation__
 *
 * To run a mutation, you first call `useEventProxyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEventProxyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [eventProxyMutation, { data, loading, error }] = useEventProxyMutation({
 *   variables: {
 *      event: // value for 'event'
 *      properties: // value for 'properties'
 *   },
 * });
 */
function useEventProxyMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D(EventProxyDocument, options);
}



var GetBasicGenericProgramDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject52 || (_templateObject52 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    query GetBasicGenericProgram($slug: String!) {\n  genericProgram(slug: $slug) {\n    ...EssentialGenericFields\n  }\n}\n    ", ""])),





EssentialGenericFieldsFragmentDoc);

/**
 * __useGetBasicGenericProgramQuery__
 *
 * To run a query within a React component, call `useGetBasicGenericProgramQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBasicGenericProgramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBasicGenericProgramQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
function useGetBasicGenericProgramQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_5__/* .useQuery */ .a(GetBasicGenericProgramDocument, options);
}
function useGetBasicGenericProgramLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(GetBasicGenericProgramDocument, options);
}



function refetchGetBasicGenericProgramQuery(variables) {
  return { query: GetBasicGenericProgramDocument, variables: variables };
}
var GetFullGenericProgramDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject53 || (_templateObject53 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    query GetFullGenericProgram($slug: String!) {\n  genericProgram(slug: $slug) {\n    ...FullGenericProgramFields\n  }\n}\n    ", ""])),





FullGenericProgramFieldsFragmentDoc);

/**
 * __useGetFullGenericProgramQuery__
 *
 * To run a query within a React component, call `useGetFullGenericProgramQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFullGenericProgramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFullGenericProgramQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
function useGetFullGenericProgramQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_5__/* .useQuery */ .a(GetFullGenericProgramDocument, options);
}
function useGetFullGenericProgramLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(GetFullGenericProgramDocument, options);
}



function refetchGetFullGenericProgramQuery(variables) {
  return { query: GetFullGenericProgramDocument, variables: variables };
}
var GenericProgramsDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject54 || (_templateObject54 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    query genericPrograms($perPage: Int = 12, $page: Int, $search: String, $languages: [LanguageKind!], $instructor: String, $sortBy: GenericProgramSortAttribute, $theme: String, $category: ProgramCategory, $tags: [String!]) {\n  genericPrograms(perPage: $perPage, page: $page, query: $search, languages: $languages, instructor: $instructor, sort: $sortBy, theme: $theme, category: $category, tags: $tags) {\n    page\n    totalCount\n    data {\n      ...EssentialGenericFields\n      discount {\n        discountType\n        discountValue\n        discountedPrice\n        endDate\n        identifier\n        startDate\n      }\n    }\n  }\n}\n    ", ""])),

















EssentialGenericFieldsFragmentDoc);

/**
 * __useGenericProgramsQuery__
 *
 * To run a query within a React component, call `useGenericProgramsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenericProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenericProgramsQuery({
 *   variables: {
 *      perPage: // value for 'perPage'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *      languages: // value for 'languages'
 *      instructor: // value for 'instructor'
 *      sortBy: // value for 'sortBy'
 *      theme: // value for 'theme'
 *      category: // value for 'category'
 *      tags: // value for 'tags'
 *   },
 * });
 */
function useGenericProgramsQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_5__/* .useQuery */ .a(GenericProgramsDocument, options);
}
function useGenericProgramsLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(GenericProgramsDocument, options);
}



function refetchGenericProgramsQuery(variables) {
  return { query: GenericProgramsDocument, variables: variables };
}
var PlaylistDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject55 || (_templateObject55 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    query playlist($id: ID!) {\n  playlist(id: $id) {\n    ...PlaylistEssentialFields\n  }\n}\n    ", ""])),





PlaylistEssentialFieldsFragmentDoc);

/**
 * __usePlaylistQuery__
 *
 * To run a query within a React component, call `usePlaylistQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlaylistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlaylistQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
function usePlaylistQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_5__/* .useQuery */ .a(PlaylistDocument, options);
}
function usePlaylistLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(PlaylistDocument, options);
}



function refetchPlaylistQuery(variables) {
  return { query: PlaylistDocument, variables: variables };
}
var VideosDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject56 || (_templateObject56 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    query videos($taxonomies: [TaxonomyInput!], $page: Int, $perPage: Int, $genre: String, $query: String, $useLocale: Boolean, $contentLanguages: [String], $excludeTerms: [String], $videoLevels: [String], $orderBy: VideoOrderBy) {\n  videos(taxonomies: $taxonomies, perPage: $perPage, page: $page, genre: $genre, query: $query, useLocale: $useLocale, contentLanguages: $contentLanguages, excludeTerms: $excludeTerms, videoLevels: $videoLevels, orderBy: $orderBy) {\n    page\n    perPage\n    totalCount\n    data {\n      ...VideoFields\n    }\n  }\n}\n    ", ""])),










VideoFieldsFragmentDoc);

/**
 * __useVideosQuery__
 *
 * To run a query within a React component, call `useVideosQuery` and pass it any options that fit your needs.
 * When your component renders, `useVideosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVideosQuery({
 *   variables: {
 *      taxonomies: // value for 'taxonomies'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      genre: // value for 'genre'
 *      query: // value for 'query'
 *      useLocale: // value for 'useLocale'
 *      contentLanguages: // value for 'contentLanguages'
 *      excludeTerms: // value for 'excludeTerms'
 *      videoLevels: // value for 'videoLevels'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
function useVideosQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_5__/* .useQuery */ .a(VideosDocument, options);
}
function useVideosLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(VideosDocument, options);
}



function refetchVideosQuery(variables) {
  return { query: VideosDocument, variables: variables };
}
var LastWatchedSessionsDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject57 || (_templateObject57 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    query lastWatchedSessions {\n  lastWatchedSessions {\n    ...VideoFields\n  }\n}\n    ", ""])),





VideoFieldsFragmentDoc);

/**
 * __useLastWatchedSessionsQuery__
 *
 * To run a query within a React component, call `useLastWatchedSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLastWatchedSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLastWatchedSessionsQuery({
 *   variables: {
 *   },
 * });
 */
function useLastWatchedSessionsQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_5__/* .useQuery */ .a(LastWatchedSessionsDocument, options);
}
function useLastWatchedSessionsLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(LastWatchedSessionsDocument, options);
}



function refetchLastWatchedSessionsQuery(variables) {
  return { query: LastWatchedSessionsDocument, variables: variables };
}
var LiveEventCodesDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject58 || (_templateObject58 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    query liveEventCodes {\n  liveEventCodes {\n    trial {\n      ...LiveCodeDataFields\n    }\n    wellness {\n      ...LiveCodeDataFields\n    }\n  }\n}\n    ", ""])),










LiveCodeDataFieldsFragmentDoc);

/**
 * __useLiveEventCodesQuery__
 *
 * To run a query within a React component, call `useLiveEventCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLiveEventCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveEventCodesQuery({
 *   variables: {
 *   },
 * });
 */
function useLiveEventCodesQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_5__/* .useQuery */ .a(LiveEventCodesDocument, options);
}
function useLiveEventCodesLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .useLazyQuery */ .t(LiveEventCodesDocument, options);
}



function refetchLiveEventCodesQuery(variables) {
  return { query: LiveEventCodesDocument, variables: variables };
}
var ParticipateInAnEventDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject59 || (_templateObject59 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    mutation participateInAnEvent($slug: String!) {\n  participateInAnEvent(slug: $slug) {\n    success\n    errors {\n      message\n    }\n  }\n}\n    "])));











/**
 * __useParticipateInAnEventMutation__
 *
 * To run a mutation, you first call `useParticipateInAnEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useParticipateInAnEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [participateInAnEventMutation, { data, loading, error }] = useParticipateInAnEventMutation({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
function useParticipateInAnEventMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D(ParticipateInAnEventDocument, options);
}



var ActivateLiveEventDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject60 || (_templateObject60 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    mutation activateLiveEvent($slug: String!, $code: String!) {\n  activateLiveEvent(slug: $slug, code: $code) {\n    success\n    errors\n  }\n}\n    "])));









/**
 * __useActivateLiveEventMutation__
 *
 * To run a mutation, you first call `useActivateLiveEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateLiveEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateLiveEventMutation, { data, loading, error }] = useActivateLiveEventMutation({
 *   variables: {
 *      slug: // value for 'slug'
 *      code: // value for 'code'
 *   },
 * });
 */
function useActivateLiveEventMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D(ActivateLiveEventDocument, options);
}



var LiveEventDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject61 || (_templateObject61 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    query liveEvent($slug: String!) {\n  liveEvent(slug: $slug) {\n    ...FullLiveEventFields\n  }\n}\n    ", ""])),





FullLiveEventFieldsFragmentDoc);

/**
 * __useLiveEventQuery__
 *
 * To run a query within a React component, call `useLiveEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useLiveEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveEventQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
function useLiveEventQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_5__/* .useQuery */ .a(LiveEventDocument, options);
}
function useLiveEventLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(LiveEventDocument, options);
}



function refetchLiveEventQuery(variables) {
  return { query: LiveEventDocument, variables: variables };
}
var ValidateLiveEventCodeDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject62 || (_templateObject62 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    query validateLiveEventCode($slug: String!, $code: String!) {\n  validateLiveEventCode(slug: $slug, code: $code) {\n    code\n    message\n    status\n  }\n}\n    "])));









/**
 * __useValidateLiveEventCodeQuery__
 *
 * To run a query within a React component, call `useValidateLiveEventCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateLiveEventCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateLiveEventCodeQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      code: // value for 'code'
 *   },
 * });
 */
function useValidateLiveEventCodeQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_5__/* .useQuery */ .a(ValidateLiveEventCodeDocument, options);
}
function useValidateLiveEventCodeLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(ValidateLiveEventCodeDocument, options);
}



function refetchValidateLiveEventCodeQuery(variables) {
  return { query: ValidateLiveEventCodeDocument, variables: variables };
}
var LiveEventsDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject63 || (_templateObject63 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    query liveEvents($perPage: Int = 12, $page: Int, $search: String, $languages: [LanguageKind!], $instructor: String, $sortBy: LiveEventSortAttribute, $kind: LiveEventKind) {\n  liveEvents(perPage: $perPage, page: $page, keyword: $search, languages: $languages, instructor: $instructor, sortBy: $sortBy, kind: $kind) {\n    page\n    totalCount\n    availableKinds\n    data {\n      ...LiveEventEssentialFields\n    }\n  }\n}\n    ", ""])),










LiveEventEssentialFieldsFragmentDoc);

/**
 * __useLiveEventsQuery__
 *
 * To run a query within a React component, call `useLiveEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLiveEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveEventsQuery({
 *   variables: {
 *      perPage: // value for 'perPage'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *      languages: // value for 'languages'
 *      instructor: // value for 'instructor'
 *      sortBy: // value for 'sortBy'
 *      kind: // value for 'kind'
 *   },
 * });
 */
function useLiveEventsQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_5__/* .useQuery */ .a(LiveEventsDocument, options);
}
function useLiveEventsLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(LiveEventsDocument, options);
}



function refetchLiveEventsQuery(variables) {
  return { query: LiveEventsDocument, variables: variables };
}
var OrderDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject64 || (_templateObject64 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    query Order($id: String!) {\n  order(id: $id) {\n    ... on GenericProgramPayment {\n      success\n      amountCents\n      amountCurrency\n      orderId\n      originalAmountCents\n      paymentProvider\n      voucher\n      program {\n        id\n        slug\n        title\n        category\n      }\n    }\n    ... on LiveEventPayment {\n      success\n      amountCents\n      amountCurrency\n      orderId\n      originalAmountCents\n      paymentProvider\n      live {\n        id\n        slug\n        title\n      }\n    }\n    ... on SubscriptionPayment {\n      amountCents\n      amountCurrency\n      months\n      orderId\n      originalAmountCents\n      paymentProvider\n      recurringAmountCents\n      recurringDate\n      success\n    }\n  }\n}\n    "])));













































/**
 * __useOrderQuery__
 *
 * To run a query within a React component, call `useOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
function useOrderQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_5__/* .useQuery */ .a(OrderDocument, options);
}
function useOrderLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(OrderDocument, options);
}



function refetchOrderQuery(variables) {
  return { query: OrderDocument, variables: variables };
}
var PayForItemDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject65 || (_templateObject65 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    mutation payForItem($slug: String!, $paymentMethod: PaymentMethodInput!, $riskData: RiskDataInput, $redirectToSuccess: String, $redirectToFailed: String, $browserInfo: BrowserInfoInput, $itemKind: ItemKind!, $discountCode: String) {\n  payForItem(slug: $slug, paymentMethod: $paymentMethod, riskData: $riskData, browserInfo: $browserInfo, itemKind: $itemKind, discountCode: $discountCode, redirectToSuccess: $redirectToSuccess, redirectToFailed: $redirectToFailed) {\n    orderId\n    resultAction {\n      actionType\n      url\n      httpMethod\n      paymentMethodType\n      paymentData\n      redirectData\n    }\n    resultCode\n    transaction\n    errors {\n      message\n    }\n  }\n}\n    "])));





















/**
 * __usePayForItemMutation__
 *
 * To run a mutation, you first call `usePayForItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePayForItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [payForItemMutation, { data, loading, error }] = usePayForItemMutation({
 *   variables: {
 *      slug: // value for 'slug'
 *      paymentMethod: // value for 'paymentMethod'
 *      riskData: // value for 'riskData'
 *      redirectToSuccess: // value for 'redirectToSuccess'
 *      redirectToFailed: // value for 'redirectToFailed'
 *      browserInfo: // value for 'browserInfo'
 *      itemKind: // value for 'itemKind'
 *      discountCode: // value for 'discountCode'
 *   },
 * });
 */
function usePayForItemMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D(PayForItemDocument, options);
}



var PayForVoucherDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject66 || (_templateObject66 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    mutation payForVoucher($slug: String!, $paymentMethod: PaymentMethodInput!, $itemKind: ItemKind!, $redirectToSuccess: String, $redirectToFailed: String, $riskData: RiskDataInput, $browserInfo: BrowserInfoInput, $discountCode: String, $senderName: String!, $recipientName: String!, $recipientEmail: String!, $sendGiftEmail: Boolean!, $customMessage: String) {\n  payForVoucher(slug: $slug, paymentMethod: $paymentMethod, itemKind: $itemKind, redirectToSuccess: $redirectToSuccess, redirectToFailed: $redirectToFailed, riskData: $riskData, browserInfo: $browserInfo, discountCode: $discountCode, senderName: $senderName, recipientName: $recipientName, recipientEmail: $recipientEmail, customMessage: $customMessage, sendGiftEmail: $sendGiftEmail) {\n    orderId\n    resultCode\n    transaction\n    resultAction {\n      actionType\n      url\n      httpMethod\n      paymentMethodType\n      paymentData\n      redirectData\n    }\n    errors {\n      message\n    }\n  }\n}\n    "])));





















/**
 * __usePayForVoucherMutation__
 *
 * To run a mutation, you first call `usePayForVoucherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePayForVoucherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [payForVoucherMutation, { data, loading, error }] = usePayForVoucherMutation({
 *   variables: {
 *      slug: // value for 'slug'
 *      paymentMethod: // value for 'paymentMethod'
 *      itemKind: // value for 'itemKind'
 *      redirectToSuccess: // value for 'redirectToSuccess'
 *      redirectToFailed: // value for 'redirectToFailed'
 *      riskData: // value for 'riskData'
 *      browserInfo: // value for 'browserInfo'
 *      discountCode: // value for 'discountCode'
 *      senderName: // value for 'senderName'
 *      recipientName: // value for 'recipientName'
 *      recipientEmail: // value for 'recipientEmail'
 *      sendGiftEmail: // value for 'sendGiftEmail'
 *      customMessage: // value for 'customMessage'
 *   },
 * });
 */
function usePayForVoucherMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D(PayForVoucherDocument, options);
}



var PhasedProgramDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject67 || (_templateObject67 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    query phasedProgram($slug: String!) {\n  phasedProgram(slug: $slug) {\n    ...PhasedProgramFields\n  }\n}\n    ", ""])),





PhasedProgramFieldsFragmentDoc);

/**
 * __usePhasedProgramQuery__
 *
 * To run a query within a React component, call `usePhasedProgramQuery` and pass it any options that fit your needs.
 * When your component renders, `usePhasedProgramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePhasedProgramQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
function usePhasedProgramQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_5__/* .useQuery */ .a(PhasedProgramDocument, options);
}
function usePhasedProgramLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(PhasedProgramDocument, options);
}



function refetchPhasedProgramQuery(variables) {
  return { query: PhasedProgramDocument, variables: variables };
}
var AddFavoritePlaylistDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject68 || (_templateObject68 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    mutation addFavoritePlaylist($playlistId: ID!) {\n  addFavoritePlaylist(playlistId: $playlistId) {\n    playlist {\n      favorited\n    }\n  }\n}\n    "])));










/**
 * __useAddFavoritePlaylistMutation__
 *
 * To run a mutation, you first call `useAddFavoritePlaylistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFavoritePlaylistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFavoritePlaylistMutation, { data, loading, error }] = useAddFavoritePlaylistMutation({
 *   variables: {
 *      playlistId: // value for 'playlistId'
 *   },
 * });
 */
function useAddFavoritePlaylistMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D(AddFavoritePlaylistDocument, options);
}



var DeleteFavoritePlaylistDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject69 || (_templateObject69 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    mutation deleteFavoritePlaylist($playlistId: ID!) {\n  deleteFavoritePlaylist(playlistId: $playlistId) {\n    playlist {\n      favorited\n    }\n  }\n}\n    "])));










/**
 * __useDeleteFavoritePlaylistMutation__
 *
 * To run a mutation, you first call `useDeleteFavoritePlaylistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFavoritePlaylistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFavoritePlaylistMutation, { data, loading, error }] = useDeleteFavoritePlaylistMutation({
 *   variables: {
 *      playlistId: // value for 'playlistId'
 *   },
 * });
 */
function useDeleteFavoritePlaylistMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D(DeleteFavoritePlaylistDocument, options);
}



var AutocompleteDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject70 || (_templateObject70 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    query autocomplete($query: String!) {\n  autocomplete(query: $query) {\n    query\n    error\n    results\n  }\n}\n    "])));









/**
 * __useAutocompleteQuery__
 *
 * To run a query within a React component, call `useAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutocompleteQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
function useAutocompleteQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return Apollo.useQuery(AutocompleteDocument, options);
}
function useAutocompleteLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(AutocompleteDocument, options);
}



function refetchAutocompleteQuery(variables) {
  return { query: AutocompleteDocument, variables: variables };
}
var SpecificSearchDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject71 || (_templateObject71 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    query specificSearch($query: String!, $page: Int = 1, $perPage: Int = 10, $modelType: ModelNameKind!, $languages: [LanguageKind!]!) {\n  specificSearch(query: $query, page: $page, perPage: $perPage, modelType: $modelType, languages: $languages) {\n    query\n    blogPosts {\n      page\n      perPage\n      totalCount\n      results {\n        __typename\n        ... on SearchBlogPost {\n          ...SearchBlogPostFields\n        }\n      }\n    }\n    challenges {\n      page\n      perPage\n      totalCount\n      results {\n        __typename\n        ... on SearchGenericProgram {\n          ...SearchGenericProgramFields\n        }\n      }\n    }\n    events {\n      page\n      perPage\n      totalCount\n      results {\n        __typename\n        ... on SearchEvent {\n          ...SearchEventFields\n        }\n      }\n    }\n    genericPrograms {\n      page\n      perPage\n      totalCount\n      results {\n        __typename\n        ... on SearchGenericProgram {\n          ...SearchGenericProgramFields\n        }\n      }\n    }\n    challenges {\n      page\n      perPage\n      totalCount\n      results {\n        __typename\n        ... on SearchGenericProgram {\n          ...SearchGenericProgramFields\n        }\n      }\n    }\n    courses {\n      page\n      perPage\n      totalCount\n      results {\n        __typename\n        ... on SearchGenericProgram {\n          ...SearchGenericProgramFields\n        }\n      }\n    }\n    instructors {\n      page\n      perPage\n      totalCount\n      results {\n        __typename\n        ... on SearchInstructor {\n          ...SearchInstructorFields\n        }\n      }\n    }\n    landingPages {\n      page\n      perPage\n      totalCount\n      results {\n        __typename\n        ... on SearchLandingPage {\n          ...SearchLandingPageFields\n        }\n      }\n    }\n    liveEvents {\n      page\n      perPage\n      totalCount\n      results {\n        __typename\n        ... on SearchLiveEvent {\n          ...SearchLiveEventFields\n        }\n      }\n    }\n    playlists {\n      page\n      perPage\n      totalCount\n      results {\n        __typename\n        ... on SearchPlaylist {\n          ...SearchPlaylistFields\n        }\n      }\n    }\n    videos {\n      page\n      perPage\n      totalCount\n      results {\n        __typename\n        ... on SearchVideo {\n          ...SearchVideoFields\n        }\n      }\n    }\n  }\n}\n    ", "\n", "\n", "\n", "\n", "\n", "\n", "\n", ""])),






























































































































SearchBlogPostFieldsFragmentDoc,
SearchGenericProgramFieldsFragmentDoc,
SearchEventFieldsFragmentDoc,
SearchInstructorFieldsFragmentDoc,
SearchLandingPageFieldsFragmentDoc,
SearchLiveEventFieldsFragmentDoc,
SearchPlaylistFieldsFragmentDoc,
SearchVideoFieldsFragmentDoc);

/**
 * __useSpecificSearchQuery__
 *
 * To run a query within a React component, call `useSpecificSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpecificSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpecificSearchQuery({
 *   variables: {
 *      query: // value for 'query'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      modelType: // value for 'modelType'
 *      languages: // value for 'languages'
 *   },
 * });
 */
function useSpecificSearchQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return Apollo.useQuery(SpecificSearchDocument, options);
}
function useSpecificSearchLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .useLazyQuery */ .t(SpecificSearchDocument, options);
}



function refetchSpecificSearchQuery(variables) {
  return { query: SpecificSearchDocument, variables: variables };
}
var SearchDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject72 || (_templateObject72 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    query Search($query: String!, $searchType: GlobalSearch!, $languages: [LanguageKind!]!) {\n  search(query: $query, searchType: $searchType, languages: $languages) {\n    query\n    blogPosts {\n      page\n      perPage\n      totalCount\n      results {\n        __typename\n        ... on SearchBlogPost {\n          ...SearchBlogPostFields\n        }\n      }\n    }\n    challenges {\n      page\n      perPage\n      totalCount\n      results {\n        __typename\n        ... on SearchGenericProgram {\n          ...SearchGenericProgramFields\n        }\n      }\n    }\n    events {\n      page\n      perPage\n      totalCount\n      results {\n        __typename\n        ... on SearchEvent {\n          ...SearchEventFields\n        }\n      }\n    }\n    genericPrograms {\n      page\n      perPage\n      totalCount\n      results {\n        __typename\n        ... on SearchGenericProgram {\n          ...SearchGenericProgramFields\n        }\n      }\n    }\n    challenges {\n      page\n      perPage\n      totalCount\n      results {\n        __typename\n        ... on SearchGenericProgram {\n          ...SearchGenericProgramFields\n        }\n      }\n    }\n    courses {\n      page\n      perPage\n      totalCount\n      results {\n        __typename\n        ... on SearchGenericProgram {\n          ...SearchGenericProgramFields\n        }\n      }\n    }\n    instructors {\n      page\n      perPage\n      totalCount\n      results {\n        __typename\n        ... on SearchInstructor {\n          ...SearchInstructorFields\n        }\n      }\n    }\n    landingPages {\n      page\n      perPage\n      totalCount\n      results {\n        __typename\n        ... on SearchLandingPage {\n          ...SearchLandingPageFields\n        }\n      }\n    }\n    liveEvents {\n      page\n      perPage\n      totalCount\n      results {\n        __typename\n        ... on SearchLiveEvent {\n          ...SearchLiveEventFields\n        }\n      }\n    }\n    playlists {\n      page\n      perPage\n      totalCount\n      results {\n        __typename\n        ... on SearchPlaylist {\n          ...SearchPlaylistFields\n        }\n      }\n    }\n    videos {\n      page\n      perPage\n      totalCount\n      results {\n        __typename\n        ... on SearchVideo {\n          ...SearchVideoFields\n        }\n      }\n    }\n  }\n}\n    ", "\n", "\n", "\n", "\n", "\n", "\n", "\n", ""])),






























































































































SearchBlogPostFieldsFragmentDoc,
SearchGenericProgramFieldsFragmentDoc,
SearchEventFieldsFragmentDoc,
SearchInstructorFieldsFragmentDoc,
SearchLandingPageFieldsFragmentDoc,
SearchLiveEventFieldsFragmentDoc,
SearchPlaylistFieldsFragmentDoc,
SearchVideoFieldsFragmentDoc);

/**
 * __useSearchQuery__
 *
 * To run a query within a React component, call `useSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQuery({
 *   variables: {
 *      query: // value for 'query'
 *      searchType: // value for 'searchType'
 *      languages: // value for 'languages'
 *   },
 * });
 */
function useSearchQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return Apollo.useQuery(SearchDocument, options);
}
function useSearchLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .useLazyQuery */ .t(SearchDocument, options);
}



function refetchSearchQuery(variables) {
  return { query: SearchDocument, variables: variables };
}
var AddSearchResultDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject73 || (_templateObject73 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    mutation addSearchResult($modelType: ModelNameKind!, $documentId: String!, $query: String!) {\n  addSearchResult(modelType: $modelType, documentId: $documentId, query: $query) {\n    documentId\n  }\n}\n    "])));








/**
 * __useAddSearchResultMutation__
 *
 * To run a mutation, you first call `useAddSearchResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSearchResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSearchResultMutation, { data, loading, error }] = useAddSearchResultMutation({
 *   variables: {
 *      modelType: // value for 'modelType'
 *      documentId: // value for 'documentId'
 *      query: // value for 'query'
 *   },
 * });
 */
function useAddSearchResultMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D(AddSearchResultDocument, options);
}



var SignUpDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject74 || (_templateObject74 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    mutation signUp($firstName: String!, $email: String!, $password: String!, $country: String!, $lastName: String, $utmSource: String, $utmMedium: String, $utmCampaign: String, $paymentType: String, $campaignCode: String) {\n  signUpV2(firstName: $firstName, lastName: $lastName, email: $email, country: $country, password: $password, paymentType: $paymentType, campaignCode: $campaignCode, utmSource: $utmSource, utmMedium: $utmMedium, utmCampaign: $utmCampaign, platform: web) {\n    user {\n      id\n      email\n      gender\n      country\n      accessUntil\n    }\n    errors {\n      message\n    }\n  }\n}\n    "])));

















/**
 * __useSignUpMutation__
 *
 * To run a mutation, you first call `useSignUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpMutation, { data, loading, error }] = useSignUpMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      country: // value for 'country'
 *      lastName: // value for 'lastName'
 *      utmSource: // value for 'utmSource'
 *      utmMedium: // value for 'utmMedium'
 *      utmCampaign: // value for 'utmCampaign'
 *      paymentType: // value for 'paymentType'
 *      campaignCode: // value for 'campaignCode'
 *   },
 * });
 */
function useSignUpMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D(SignUpDocument, options);
}



var SocialSignUpDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject75 || (_templateObject75 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    mutation socialSignUp($provider: ProviderTypes!, $method: MethodTypes!, $code: String, $accessToken: String, $identityToken: String, $firstName: String, $lastName: String, $avatarFromUrl: String, $paymentType: String, $campaignCode: String, $utmSource: String, $utmMedium: String, $utmCampaign: String) {\n  socialSignUp(provider: $provider, method: $method, code: $code, accessToken: $accessToken, identityToken: $identityToken, firstName: $firstName, lastName: $lastName, avatarFromUrl: $avatarFromUrl, paymentType: $paymentType, campaignCode: $campaignCode, utmSource: $utmSource, utmMedium: $utmMedium, utmCampaign: $utmCampaign, platform: web) {\n    success\n    user {\n      id\n    }\n  }\n}\n    "])));











/**
 * __useSocialSignUpMutation__
 *
 * To run a mutation, you first call `useSocialSignUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSocialSignUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [socialSignUpMutation, { data, loading, error }] = useSocialSignUpMutation({
 *   variables: {
 *      provider: // value for 'provider'
 *      method: // value for 'method'
 *      code: // value for 'code'
 *      accessToken: // value for 'accessToken'
 *      identityToken: // value for 'identityToken'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      avatarFromUrl: // value for 'avatarFromUrl'
 *      paymentType: // value for 'paymentType'
 *      campaignCode: // value for 'campaignCode'
 *      utmSource: // value for 'utmSource'
 *      utmMedium: // value for 'utmMedium'
 *      utmCampaign: // value for 'utmCampaign'
 *   },
 * });
 */
function useSocialSignUpMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D(SocialSignUpDocument, options);
}



var SocialSignInDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject76 || (_templateObject76 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    mutation socialSignIn($provider: ProviderTypes!, $method: MethodTypes!, $code: String, $accessToken: String, $identityToken: String) {\n  socialSignIn(provider: $provider, method: $method, code: $code, accessToken: $accessToken, identityToken: $identityToken, platform: web) {\n    success\n    user {\n      id\n    }\n  }\n}\n    "])));











/**
 * __useSocialSignInMutation__
 *
 * To run a mutation, you first call `useSocialSignInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSocialSignInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [socialSignInMutation, { data, loading, error }] = useSocialSignInMutation({
 *   variables: {
 *      provider: // value for 'provider'
 *      method: // value for 'method'
 *      code: // value for 'code'
 *      accessToken: // value for 'accessToken'
 *      identityToken: // value for 'identityToken'
 *   },
 * });
 */
function useSocialSignInMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D(SocialSignInDocument, options);
}



var StartOverviewDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject77 || (_templateObject77 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    query startOverview {\n  startOverview {\n    metaSection {\n      description\n      imageUrl\n      title\n    }\n    heroSection {\n      title\n      description\n      smallNote\n      imageUrl\n    }\n    coursesSection {\n      title\n      description\n      group1Title\n      group1Description\n      group1ButtonLink\n      group1ButtonText\n      group1ImageUrl\n      group2Title\n      group2Description\n      group2ButtonLink\n      group2ButtonText\n      group2ImageUrl\n    }\n    campaignSection {\n      title\n      description\n      buttonLink\n      buttonText\n      imageUrl\n      tag\n    }\n    featuresSection {\n      description\n      featureBullets\n      imageUrl\n      title\n    }\n    genresSection {\n      title\n      description\n      genre {\n        title\n        slug\n        name\n        description\n        imageUrl\n        otherType\n        sectionType\n      }\n    }\n    mobileAppSection {\n      description\n      imageUrl\n      title\n    }\n    otherFeaturesSection {\n      description\n      title\n      otherFeatures {\n        description\n        imageUrl\n        name\n        url\n        otherType\n        sectionType\n        slug\n        title\n      }\n    }\n    videoLibrarySection {\n      description\n      title\n      videosLibrary {\n        slug\n        title\n        name\n        description\n        url\n        imageUrl\n        otherType\n        sectionType\n      }\n    }\n  }\n}\n    "])));



























































































/**
 * __useStartOverviewQuery__
 *
 * To run a query within a React component, call `useStartOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useStartOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStartOverviewQuery({
 *   variables: {
 *   },
 * });
 */
function useStartOverviewQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_5__/* .useQuery */ .a(StartOverviewDocument, options);
}
function useStartOverviewLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(StartOverviewDocument, options);
}



function refetchStartOverviewQuery(variables) {
  return { query: StartOverviewDocument, variables: variables };
}
var VideoWatchDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject78 || (_templateObject78 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    mutation videoWatch($videoId: String!, $seconds: Int!, $cursorAt: Int!) {\n  videoWatch(videoId: $videoId, seconds: $seconds, cursorAt: $cursorAt) {\n    errors {\n      message\n    }\n  }\n}\n    "])));










/**
 * __useVideoWatchMutation__
 *
 * To run a mutation, you first call `useVideoWatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVideoWatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [videoWatchMutation, { data, loading, error }] = useVideoWatchMutation({
 *   variables: {
 *      videoId: // value for 'videoId'
 *      seconds: // value for 'seconds'
 *      cursorAt: // value for 'cursorAt'
 *   },
 * });
 */
function useVideoWatchMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D(VideoWatchDocument, options);
}



var VideoWatchCompletedDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject79 || (_templateObject79 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    mutation videoWatchCompleted($videoId: String!, $seconds: Int!, $cursorAt: Int!) {\n  videoWatchCompleted(videoId: $videoId, seconds: $seconds, cursorAt: $cursorAt) {\n    errors {\n      message\n    }\n  }\n}\n    "])));










/**
 * __useVideoWatchCompletedMutation__
 *
 * To run a mutation, you first call `useVideoWatchCompletedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVideoWatchCompletedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [videoWatchCompletedMutation, { data, loading, error }] = useVideoWatchCompletedMutation({
 *   variables: {
 *      videoId: // value for 'videoId'
 *      seconds: // value for 'seconds'
 *      cursorAt: // value for 'cursorAt'
 *   },
 * });
 */
function useVideoWatchCompletedMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D(VideoWatchCompletedDocument, options);
}



var UserStatsDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject80 || (_templateObject80 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    query userStats($period: StatsPeriodKind) {\n  userStats(period: $period) {\n    numberOfChallengesStarted\n    numberOfCoursesStarted\n    numberOfLiveEventsBooked\n    numberOfProgramsStarted\n    playlistsCreated\n    sessionsCompleted\n    sessionsFavorited\n    threeMostWatchedInstructors {\n      id\n      name\n      assets {\n        squareImage\n      }\n    }\n    threeMostWatchedStyles {\n      slug\n      name\n    }\n    totalWatchTime\n  }\n}\n    "])));

























/**
 * __useUserStatsQuery__
 *
 * To run a query within a React component, call `useUserStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserStatsQuery({
 *   variables: {
 *      period: // value for 'period'
 *   },
 * });
 */
function useUserStatsQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_5__/* .useQuery */ .a(UserStatsDocument, options);
}
function useUserStatsLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(UserStatsDocument, options);
}



function refetchUserStatsQuery(variables) {
  return { query: UserStatsDocument, variables: variables };
}
var ActivateFullAccessCodeDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject81 || (_templateObject81 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    mutation activateFullAccessCode($promotionName: String!, $code: String!) {\n  activateFullAccessCode(promotionName: $promotionName, code: $code) {\n    success\n    errors {\n      message\n    }\n  }\n}\n    "])));











/**
 * __useActivateFullAccessCodeMutation__
 *
 * To run a mutation, you first call `useActivateFullAccessCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateFullAccessCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateFullAccessCodeMutation, { data, loading, error }] = useActivateFullAccessCodeMutation({
 *   variables: {
 *      promotionName: // value for 'promotionName'
 *      code: // value for 'code'
 *   },
 * });
 */
function useActivateFullAccessCodeMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D(ActivateFullAccessCodeDocument, options);
}



var ActivateOneTimeCodeDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject82 || (_templateObject82 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    mutation activateOneTimeCode($promotionName: String!, $code: String!) {\n  activateOneTimeCode(promotionName: $promotionName, code: $code) {\n    success\n    errors {\n      message\n    }\n  }\n}\n    "])));











/**
 * __useActivateOneTimeCodeMutation__
 *
 * To run a mutation, you first call `useActivateOneTimeCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateOneTimeCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateOneTimeCodeMutation, { data, loading, error }] = useActivateOneTimeCodeMutation({
 *   variables: {
 *      promotionName: // value for 'promotionName'
 *      code: // value for 'code'
 *   },
 * });
 */
function useActivateOneTimeCodeMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D(ActivateOneTimeCodeDocument, options);
}



var PaymentsStoreAdyenDropinDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject83 || (_templateObject83 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    mutation paymentsStoreAdyenDropin($redirectTo: String, $paymentType: String!, $riskData: RiskDataInput, $paymentMethod: PaymentMethodInput!, $storePaymentMethod: Boolean, $browserInfo: BrowserInfoInput) {\n  paymentsStoreAdyenDropin(redirectTo: $redirectTo, paymentType: $paymentType, riskData: $riskData, paymentMethod: $paymentMethod, storePaymentMethod: $storePaymentMethod, browserInfo: $browserInfo) {\n    orderId\n    transaction\n    recurringDate\n    recurringPaymentAmount\n    resultCode\n    resultAction {\n      actionType\n      url\n      httpMethod\n      paymentMethodType\n      paymentData\n      redirectData\n    }\n    errors {\n      message\n    }\n  }\n}\n    "])));























/**
 * __usePaymentsStoreAdyenDropinMutation__
 *
 * To run a mutation, you first call `usePaymentsStoreAdyenDropinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentsStoreAdyenDropinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentsStoreAdyenDropinMutation, { data, loading, error }] = usePaymentsStoreAdyenDropinMutation({
 *   variables: {
 *      redirectTo: // value for 'redirectTo'
 *      paymentType: // value for 'paymentType'
 *      riskData: // value for 'riskData'
 *      paymentMethod: // value for 'paymentMethod'
 *      storePaymentMethod: // value for 'storePaymentMethod'
 *      browserInfo: // value for 'browserInfo'
 *   },
 * });
 */
function usePaymentsStoreAdyenDropinMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D(PaymentsStoreAdyenDropinDocument, options);
}



var PaymentsStoreTrustlyDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject84 || (_templateObject84 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    mutation paymentsStoreTrustly($paymentType: String!, $redirectTo: String) {\n  paymentsStoreTrustly(paymentType: $paymentType, redirectTo: $redirectTo) {\n    resultUrl\n    recurringPaymentAmount\n    recurringPaymentCurrency\n    recurringDate\n    transaction\n    orderId\n    errors {\n      path\n      message\n    }\n  }\n}\n    "])));

















/**
 * __usePaymentsStoreTrustlyMutation__
 *
 * To run a mutation, you first call `usePaymentsStoreTrustlyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentsStoreTrustlyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentsStoreTrustlyMutation, { data, loading, error }] = usePaymentsStoreTrustlyMutation({
 *   variables: {
 *      paymentType: // value for 'paymentType'
 *      redirectTo: // value for 'redirectTo'
 *   },
 * });
 */
function usePaymentsStoreTrustlyMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D(PaymentsStoreTrustlyDocument, options);
}



var SurveyDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject85 || (_templateObject85 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    query survey($slug: String!) {\n  survey(slug: $slug) {\n    ...ProgramSurveyFields\n  }\n}\n    ", ""])),





ProgramSurveyFieldsFragmentDoc);

/**
 * __useSurveyQuery__
 *
 * To run a query within a React component, call `useSurveyQuery` and pass it any options that fit your needs.
 * When your component renders, `useSurveyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSurveyQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
function useSurveyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return Apollo.useQuery(SurveyDocument, options);
}
function useSurveyLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(SurveyDocument, options);
}



function refetchSurveyQuery(variables) {
  return { query: SurveyDocument, variables: variables };
}
var GetSurveyDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject86 || (_templateObject86 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    query GetSurvey($surveyPartId: Int!) {\n  surveyPart(surveyPartId: $surveyPartId) {\n    ...ProgramSurveyElementFields\n  }\n}\n    ", ""])),





ProgramSurveyElementFieldsFragmentDoc);

/**
 * __useGetSurveyQuery__
 *
 * To run a query within a React component, call `useGetSurveyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSurveyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSurveyQuery({
 *   variables: {
 *      surveyPartId: // value for 'surveyPartId'
 *   },
 * });
 */
function useGetSurveyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return Apollo.useQuery(GetSurveyDocument, options);
}
function useGetSurveyLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(GetSurveyDocument, options);
}



function refetchGetSurveyQuery(variables) {
  return { query: GetSurveyDocument, variables: variables };
}
var UserPlaylistsDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject87 || (_templateObject87 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    query userPlaylists($id: ID, $page: Int, $perPage: Int) {\n  userPlaylists(id: $id, page: $page, perPage: $perPage) {\n    page\n    perPage\n    totalCount\n    data {\n      id\n      identifier\n      title\n      visibility\n      owner {\n        id\n        firstName\n      }\n      meta {\n        videoCount\n        minutes\n      }\n      description\n      assets {\n        thumbnailUrl\n      }\n      videos {\n        id\n      }\n    }\n  }\n}\n    "])));






























/**
 * __useUserPlaylistsQuery__
 *
 * To run a query within a React component, call `useUserPlaylistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPlaylistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPlaylistsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
function useUserPlaylistsQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_5__/* .useQuery */ .a(UserPlaylistsDocument, options);
}
function useUserPlaylistsLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .useLazyQuery */ .t(UserPlaylistsDocument, options);
}



function refetchUserPlaylistsQuery(variables) {
  return { query: UserPlaylistsDocument, variables: variables };
}
var RemoveVideoFromPlaylistDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject88 || (_templateObject88 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    mutation removeVideoFromPlaylist($playlistId: ID!, $videoId: ID!) {\n  removeVideoFromPlaylist(playlistId: $playlistId, videoId: $videoId) {\n    playlist {\n      id\n    }\n  }\n}\n    "])));










/**
 * __useRemoveVideoFromPlaylistMutation__
 *
 * To run a mutation, you first call `useRemoveVideoFromPlaylistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveVideoFromPlaylistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeVideoFromPlaylistMutation, { data, loading, error }] = useRemoveVideoFromPlaylistMutation({
 *   variables: {
 *      playlistId: // value for 'playlistId'
 *      videoId: // value for 'videoId'
 *   },
 * });
 */
function useRemoveVideoFromPlaylistMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D(RemoveVideoFromPlaylistDocument, options);
}



var AddVideoToPlaylistDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject89 || (_templateObject89 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    mutation addVideoToPlaylist($playlistId: ID!, $videoId: ID!) {\n  addVideoToPlaylist(playlistId: $playlistId, videoId: $videoId) {\n    playlist {\n      id\n    }\n  }\n}\n    "])));










/**
 * __useAddVideoToPlaylistMutation__
 *
 * To run a mutation, you first call `useAddVideoToPlaylistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddVideoToPlaylistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addVideoToPlaylistMutation, { data, loading, error }] = useAddVideoToPlaylistMutation({
 *   variables: {
 *      playlistId: // value for 'playlistId'
 *      videoId: // value for 'videoId'
 *   },
 * });
 */
function useAddVideoToPlaylistMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D(AddVideoToPlaylistDocument, options);
}



var DeleteFavoriteVideoDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject90 || (_templateObject90 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    mutation deleteFavoriteVideo($videoId: ID!) {\n  deleteFavoriteVideo(videoId: $videoId) {\n    video {\n      favorited\n    }\n  }\n}\n    "])));










/**
 * __useDeleteFavoriteVideoMutation__
 *
 * To run a mutation, you first call `useDeleteFavoriteVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFavoriteVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFavoriteVideoMutation, { data, loading, error }] = useDeleteFavoriteVideoMutation({
 *   variables: {
 *      videoId: // value for 'videoId'
 *   },
 * });
 */
function useDeleteFavoriteVideoMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D(DeleteFavoriteVideoDocument, options);
}



var AddFavoriteVideoDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject91 || (_templateObject91 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    mutation addFavoriteVideo($videoId: ID!) {\n  addFavoriteVideo(videoId: $videoId) {\n    video {\n      favorited\n    }\n  }\n}\n    "])));










/**
 * __useAddFavoriteVideoMutation__
 *
 * To run a mutation, you first call `useAddFavoriteVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFavoriteVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFavoriteVideoMutation, { data, loading, error }] = useAddFavoriteVideoMutation({
 *   variables: {
 *      videoId: // value for 'videoId'
 *   },
 * });
 */
function useAddFavoriteVideoMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D(AddFavoriteVideoDocument, options);
}



var TaxonomiesDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject92 || (_templateObject92 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    query taxonomies($genre: String, $languages: [String!]) {\n  taxonomies(genre: $genre, languages: $languages) {\n    id\n    name\n    slug\n    terms {\n      id\n      name\n      slug\n      important\n    }\n  }\n}\n    "])));















/**
 * __useTaxonomiesQuery__
 *
 * To run a query within a React component, call `useTaxonomiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaxonomiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaxonomiesQuery({
 *   variables: {
 *      genre: // value for 'genre'
 *      languages: // value for 'languages'
 *   },
 * });
 */
function useTaxonomiesQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return Apollo.useQuery(TaxonomiesDocument, options);
}
function useTaxonomiesLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .useLazyQuery */ .t(TaxonomiesDocument, options);
}



function refetchTaxonomiesQuery(variables) {
  return { query: TaxonomiesDocument, variables: variables };
}
var VideoDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject93 || (_templateObject93 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    query video($id: ID!) {\n  video(id: $id) {\n    id\n    kind\n    hls\n    identifier\n    hasAccess\n    cursorAt\n    categories\n    player {\n      assets {\n        src\n        resolution\n      }\n    }\n    crossPromotion {\n      id\n      slug\n      title\n      category\n      description\n      titleImageUrl\n    }\n    assets {\n      thumbnailUrl\n      thumbnailUrlMedium\n    }\n    primaryStyle {\n      name\n      slug\n    }\n    taxonomies {\n      flavor {\n        id\n        name\n      }\n      needs {\n        id\n        name\n      }\n      instructors {\n        id\n        name\n        slug\n        shortDescription\n        assets {\n          squareImage\n        }\n      }\n      genre {\n        id\n        name\n        slug\n      }\n    }\n    meta {\n      minutes\n    }\n    content {\n      title\n      shortDescription\n      longDescription\n    }\n  }\n}\n    "])));



































































/**
 * __useVideoQuery__
 *
 * To run a query within a React component, call `useVideoQuery` and pass it any options that fit your needs.
 * When your component renders, `useVideoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVideoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
function useVideoQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_5__/* .useQuery */ .a(VideoDocument, options);
}
function useVideoLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(VideoDocument, options);
}



function refetchVideoQuery(variables) {
  return { query: VideoDocument, variables: variables };
}
var InstructorByGenreDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject94 || (_templateObject94 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    query instructorByGenre($genre: String, $instructor: String!, $languages: [String]) {\n  instructorByGenre(genre: $genre, instructor: $instructor, languages: $languages) {\n    instructor {\n      id\n      name\n      assets {\n        squareImage\n      }\n    }\n    videosCountInGenres {\n      channel\n      slug\n      count\n    }\n  }\n}\n    "])));


















/**
 * __useInstructorByGenreQuery__
 *
 * To run a query within a React component, call `useInstructorByGenreQuery` and pass it any options that fit your needs.
 * When your component renders, `useInstructorByGenreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInstructorByGenreQuery({
 *   variables: {
 *      genre: // value for 'genre'
 *      instructor: // value for 'instructor'
 *      languages: // value for 'languages'
 *   },
 * });
 */
function useInstructorByGenreQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_5__/* .useQuery */ .a(InstructorByGenreDocument, options);
}
function useInstructorByGenreLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(InstructorByGenreDocument, options);
}



function refetchInstructorByGenreQuery(variables) {
  return { query: InstructorByGenreDocument, variables: variables };
}
var WeeklyProgramDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject95 || (_templateObject95 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    query weeklyProgram($slug: String!) {\n  weeklyProgram(slug: $slug) {\n    ...WeeklyProgramFields\n  }\n}\n    ", ""])),





WeeklyProgramFieldsFragmentDoc);

/**
 * __useWeeklyProgramQuery__
 *
 * To run a query within a React component, call `useWeeklyProgramQuery` and pass it any options that fit your needs.
 * When your component renders, `useWeeklyProgramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWeeklyProgramQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
function useWeeklyProgramQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_5__/* .useQuery */ .a(WeeklyProgramDocument, options);
}
function useWeeklyProgramLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(WeeklyProgramDocument, options);
}



function refetchWeeklyProgramQuery(variables) {
  return { query: WeeklyProgramDocument, variables: variables };
}
var YearlyPageDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject96 || (_templateObject96 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    query YearlyPage {\n  startOverview {\n    featuresSection {\n      description\n      featureBullets\n      imageUrl\n      title\n    }\n  }\n}\n    "])));












/**
 * __useYearlyPageQuery__
 *
 * To run a query within a React component, call `useYearlyPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useYearlyPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useYearlyPageQuery({
 *   variables: {
 *   },
 * });
 */
function useYearlyPageQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return Apollo.useQuery(YearlyPageDocument, options);
}
function useYearlyPageLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(YearlyPageDocument, options);
}



function refetchYearlyPageQuery(variables) {
  return { query: YearlyPageDocument, variables: variables };
}
var AnswerSurveyDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject97 || (_templateObject97 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    mutation answerSurvey($surveyPartId: ID!, $surveyAnswerId: ID, $answers: [AnswerInput!], $surveyAction: ActionInput!) {\n  answerSurvey(surveyPartId: $surveyPartId, surveyAnswerId: $surveyAnswerId, answers: $answers, surveyAction: $surveyAction) {\n    errors {\n      message\n      status\n    }\n  }\n}\n    "])));











/**
 * __useAnswerSurveyMutation__
 *
 * To run a mutation, you first call `useAnswerSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnswerSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [answerSurveyMutation, { data, loading, error }] = useAnswerSurveyMutation({
 *   variables: {
 *      surveyPartId: // value for 'surveyPartId'
 *      surveyAnswerId: // value for 'surveyAnswerId'
 *      answers: // value for 'answers'
 *      surveyAction: // value for 'surveyAction'
 *   },
 * });
 */
function useAnswerSurveyMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D(AnswerSurveyDocument, options);
}



var GetFavoritePlaylistsDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject98 || (_templateObject98 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    query getFavoritePlaylists($id: ID!, $page: Int, $perPage: Int) {\n  getFavoritePlaylists(id: $id, page: $page, perPage: $perPage) {\n    totalCount\n    perPage\n    page\n    data {\n      id\n      identifier\n      title\n      owner {\n        id\n        firstName\n      }\n      meta {\n        videoCount\n        minutes\n      }\n      description\n      assets {\n        thumbnailUrl\n      }\n    }\n  }\n}\n    "])));


























/**
 * __useGetFavoritePlaylistsQuery__
 *
 * To run a query within a React component, call `useGetFavoritePlaylistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFavoritePlaylistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFavoritePlaylistsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
function useGetFavoritePlaylistsQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_5__/* .useQuery */ .a(GetFavoritePlaylistsDocument, options);
}
function useGetFavoritePlaylistsLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(GetFavoritePlaylistsDocument, options);
}



function refetchGetFavoritePlaylistsQuery(variables) {
  return { query: GetFavoritePlaylistsDocument, variables: variables };
}
var GetFavoriteVideosDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject99 || (_templateObject99 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    query getFavoriteVideos($id: ID!, $page: Int, $perPage: Int) {\n  getFavoriteVideos(id: $id, page: $page, perPage: $perPage) {\n    totalCount\n    perPage\n    page\n    data {\n      id\n      identifier\n      content {\n        title\n        shortDescription\n      }\n      cursorAt\n      meta {\n        minutes\n        publishedAt\n      }\n      taxonomies {\n        flavor {\n          name\n        }\n        instructors {\n          id\n          name\n          slug\n        }\n        genre {\n          id\n          name\n          slug\n        }\n      }\n      assets {\n        thumbnailUrl\n      }\n    }\n  }\n}\n    "])));








































/**
 * __useGetFavoriteVideosQuery__
 *
 * To run a query within a React component, call `useGetFavoriteVideosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFavoriteVideosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFavoriteVideosQuery({
 *   variables: {
 *      id: // value for 'id'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
function useGetFavoriteVideosQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_5__/* .useQuery */ .a(GetFavoriteVideosDocument, options);
}
function useGetFavoriteVideosLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(GetFavoriteVideosDocument, options);
}



function refetchGetFavoriteVideosQuery(variables) {
  return { query: GetFavoriteVideosDocument, variables: variables };
}
var ReclaimTrialDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject100 || (_templateObject100 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    mutation reclaimTrial($code: String!, $source: String!) {\n  reclaimTrial(code: $code, source: $source) {\n    errors\n    success\n  }\n}\n    "])));









/**
 * __useReclaimTrialMutation__
 *
 * To run a mutation, you first call `useReclaimTrialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReclaimTrialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reclaimTrialMutation, { data, loading, error }] = useReclaimTrialMutation({
 *   variables: {
 *      code: // value for 'code'
 *      source: // value for 'source'
 *   },
 * });
 */
function useReclaimTrialMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D(ReclaimTrialDocument, options);
}



var StoreUserDecisionDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject101 || (_templateObject101 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n    mutation storeUserDecision($decision: UserDecisionKind!, $value: Boolean) {\n  storeUserDecision(decision: $decision, value: $value) {\n    user {\n      id\n    }\n  }\n}\n    "])));










/**
 * __useStoreUserDecisionMutation__
 *
 * To run a mutation, you first call `useStoreUserDecisionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStoreUserDecisionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storeUserDecisionMutation, { data, loading, error }] = useStoreUserDecisionMutation({
 *   variables: {
 *      decision: // value for 'decision'
 *      value: // value for 'value'
 *   },
 * });
 */
function useStoreUserDecisionMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D(StoreUserDecisionDocument, options);
}









var result = {
  "possibleTypes": {
    "VideoInterface": [
    "Video"],

    "PagedInterface": [
    "PagedVideos",
    "PagedBundles",
    "PagedPlaylists",
    "PagedGenericPrograms",
    "PagedInstructors",
    "PagedLiveEvents",
    "PagedPages",
    "PagedBlogPosts",
    "SearchResults",
    "PagedSurveys",
    "PagedUsers"],

    "Item": [
    "BlogPost",
    "Document",
    "GenericProgram",
    "LiveEvent",
    "Playlist",
    "Video"],

    "UserInterface": [
    "User",
    "CurrentUser"],

    "PromotionCodeResource": [
    "Bundle",
    "GenericProgram",
    "LiveEvent"],

    "Order": [
    "GenericProgramPayment",
    "LiveEventPayment",
    "SubscriptionPayment"],

    "OrderPaymentInterface": [
    "GenericProgramPayment",
    "LiveEventPayment",
    "SubscriptionPayment"],

    "ProgramElement": [
    "ProgramDocument",
    "ProgramPartElement",
    "ProgramSurveyElement",
    "ProgramVideo"],

    "SearchResult": [
    "SearchBlogPost",
    "SearchEvent",
    "SearchGenericProgram",
    "SearchInstructor",
    "SearchLandingPage",
    "SearchLiveEvent",
    "SearchPlaylist",
    "SearchVideo"] } };



/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (result)));

/***/ }),

/***/ 64986:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CookieManager; }
});

// EXTERNAL MODULE: ./node_modules/cookie/index.js
var cookie = __webpack_require__(76489);
;// CONCATENATED MODULE: ./node_modules/js-cookie/dist/js.cookie.mjs
/*! js-cookie v3.0.1 | MIT */
/* eslint-disable no-var */
function js_cookie_assign (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target
}
/* eslint-enable no-var */

/* eslint-disable no-var */
var defaultConverter = {
  read: function (value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
  },
  write: function (value) {
    return encodeURIComponent(value).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    )
  }
};
/* eslint-enable no-var */

/* eslint-disable no-var */

function init (converter, defaultAttributes) {
  function set (key, value, attributes) {
    if (typeof document === 'undefined') {
      return
    }

    attributes = js_cookie_assign({}, defaultAttributes, attributes);

    if (typeof attributes.expires === 'number') {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }

    key = encodeURIComponent(key)
      .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
      .replace(/[()]/g, escape);

    var stringifiedAttributes = '';
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue
      }

      stringifiedAttributes += '; ' + attributeName;

      if (attributes[attributeName] === true) {
        continue
      }

      // Considers RFC 6265 section 5.2:
      // ...
      // 3.  If the remaining unparsed-attributes contains a %x3B (";")
      //     character:
      // Consume the characters of the unparsed-attributes up to,
      // not including, the first %x3B (";") character.
      // ...
      stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    }

    return (document.cookie =
      key + '=' + converter.write(value, key) + stringifiedAttributes)
  }

  function get (key) {
    if (typeof document === 'undefined' || (arguments.length && !key)) {
      return
    }

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var jar = {};
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      var value = parts.slice(1).join('=');

      try {
        var foundKey = decodeURIComponent(parts[0]);
        jar[foundKey] = converter.read(value, foundKey);

        if (key === foundKey) {
          break
        }
      } catch (e) {}
    }

    return key ? jar[key] : jar
  }

  return Object.create(
    {
      set: set,
      get: get,
      remove: function (key, attributes) {
        set(
          key,
          '',
          js_cookie_assign({}, attributes, {
            expires: -1
          })
        );
      },
      withAttributes: function (attributes) {
        return init(this.converter, js_cookie_assign({}, this.attributes, attributes))
      },
      withConverter: function (converter) {
        return init(js_cookie_assign({}, this.converter, converter), this.attributes)
      }
    },
    {
      attributes: { value: Object.freeze(defaultAttributes) },
      converter: { value: Object.freeze(converter) }
    }
  )
}

var api = init(defaultConverter, { path: '/' });
/* eslint-enable no-var */

/* harmony default export */ var js_cookie = (api);

;// CONCATENATED MODULE: ./lib/CookieManager.ts



/* harmony default export */ var CookieManager = ({
  get: function get(_ref) {var key = _ref.key,_ref$req = _ref.req,req = _ref$req === void 0 ? null : _ref$req;
    if (req && req.headers && !true) { var cookiesJSON, cookies; } else {
      // Client-side
      return js_cookie.get(key);
    }
    return undefined;
  },

  set: function set(_ref2) {var key = _ref2.key,value = _ref2.value,_ref2$path = _ref2.path,path = _ref2$path === void 0 ? '/' : _ref2$path;var expires = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 7;
    if (!value) return;
    var jsonValue = typeof value !== 'string' ? JSON.stringify(value) : value;

    js_cookie.set(key, jsonValue, { expires: expires, path: path });
  },

  remove: function remove(_ref3) {var key = _ref3.key,_ref3$res = _ref3.res,res = _ref3$res === void 0 ? null : _ref3$res;
    if (res && !true) {} else {
      // Client-side
      js_cookie.remove(key);
      js_cookie.remove(key, { domain: '.yogobe.com' });
    }
  } });

/***/ }),

/***/ 88224:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ analytics_manager; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(92777);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(82262);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./gql/generated/index.tsx
var generated = __webpack_require__(48354);
// EXTERNAL MODULE: ./lib/contexts/UserProvider.tsx
var UserProvider = __webpack_require__(47493);
;// CONCATENATED MODULE: ./lib/analytics/amplitude.ts
function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,defineProperty/* default */.Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}


var manager;

function getUserProperties(currentUser) {var _currentUser$subscrip, _currentUser$subscrip2, _currentUser$subscrip3, _currentUser$subscrip4;
  var subscription_type = (_currentUser$subscrip =
  currentUser.subscription) === null || _currentUser$subscrip === void 0 ? void 0 : (_currentUser$subscrip2 = _currentUser$subscrip.currentSubscriptionPlan) === null || _currentUser$subscrip2 === void 0 ? void 0 : _currentUser$subscrip2.planType;

  if (
  ['monthly', 'quarterly', 'yearly'].includes((_currentUser$subscrip3 =
  currentUser.subscription) === null || _currentUser$subscrip3 === void 0 ? void 0 : (_currentUser$subscrip4 = _currentUser$subscrip3.currentSubscriptionPlan) === null || _currentUser$subscrip4 === void 0 ? void 0 : _currentUser$subscrip4.planType))

  {var _currentUser$subscrip5;
    subscription_type = "".concat(subscription_type, "_").concat((_currentUser$subscrip5 = currentUser.subscription) === null || _currentUser$subscrip5 === void 0 ? void 0 : _currentUser$subscrip5.status);
  }
  return {
    user_id: currentUser.id,
    subscription_type: subscription_type,
    access_until: currentUser.accessUntil,
    gender: currentUser.gender,
    country: currentUser.country };

}var
AmplitudeManager = /*#__PURE__*/function () {



  function AmplitudeManager(currentUser) {(0,classCallCheck/* default */.Z)(this, AmplitudeManager);(0,defineProperty/* default */.Z)(this, "amplitude", void 0);(0,defineProperty/* default */.Z)(this, "userProperties", void 0);
    var amplitude = (__webpack_require__(19494)/* ["default"] */ .Z);
    this.amplitude = amplitude.getInstance();
    this.amplitude.init("870c8778ead554528f92646947025534", (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id) || '');
    if (currentUser !== null && currentUser !== void 0 && currentUser.id) {
      // eslint-disable-next-line
      this.userProperties = getUserProperties(currentUser);
      this.setUserProperties(this.userProperties);
    }
  }(0,createClass/* default */.Z)(AmplitudeManager, [{ key: "setUserProperties", value:

    function setUserProperties() {var userProperties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if (userProperties) {
        this.amplitude.setUserProperties(userProperties);
      }
    } }, { key: "sendPlayVideoEvent", value:

    function sendPlayVideoEvent(data) {
      var event = 'single video play';
      if (this.userProperties) {
        this.amplitude.logEvent(event, _objectSpread(_objectSpread({}, this.userProperties), data));
      }
    } }, { key: "sendPlaylistPlayEvent", value:

    function sendPlaylistPlayEvent() {
      var event = 'playlist play';
      if (this.userProperties) {
        this.amplitude.logEvent(event, this.userProperties);
      }
    } }, { key: "sendVideoAddedToFavorites", value:

    function sendVideoAddedToFavorites() {var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var event = 'video added to favorites';
      if (this.userProperties) {
        this.amplitude.logEvent(event, _objectSpread(_objectSpread({}, this.userProperties), data));
      }
    } }, { key: "sendPlaylistAddedToFavorites", value:

    function sendPlaylistAddedToFavorites() {var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var event = 'playlist added to favorites';
      if (this.userProperties) {
        this.amplitude.logEvent(event, _objectSpread(_objectSpread({}, this.userProperties), data));
      }
    } }, { key: "sendVideoAddToPlaylistEvent", value:

    function sendVideoAddToPlaylistEvent() {var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var event = 'video add to playlist';
      if (this.userProperties) {
        this.amplitude.logEvent(event, _objectSpread(_objectSpread({}, this.userProperties), data));
      }
    } }, { key: "sendPlaylistCreatedEvent", value:

    function sendPlaylistCreatedEvent() {var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var event = 'playlist created';
      if (this.userProperties) {
        this.amplitude.logEvent(event, _objectSpread(_objectSpread({}, this.userProperties), data));
      }
    } }, { key: "sendClickedScheduleEvent", value:

    function sendClickedScheduleEvent() {var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var event = 'clicked on schedule';
      if (this.userProperties) {
        this.amplitude.logEvent(event, _objectSpread(_objectSpread({}, this.userProperties), data));
      }
    } }, { key: "sendClickedShareVideoEvent", value:

    function sendClickedShareVideoEvent() {var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var event = 'clicked on share video';
      if (this.userProperties) {
        this.amplitude.logEvent(event, _objectSpread(_objectSpread({}, this.userProperties), data));
      }
    } }, { key: "sendClickedSharePlaylistEvent", value:

    function sendClickedSharePlaylistEvent() {var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var event = 'clicked on share playlist';
      if (this.userProperties) {
        this.amplitude.logEvent(event, _objectSpread(_objectSpread({}, this.userProperties), data));
      }
    } }, { key: "sendRecommendationsEditedEvent", value:

    function sendRecommendationsEditedEvent() {var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var event = 'recommendations edited';
      if (this.userProperties) {
        this.amplitude.logEvent(event, _objectSpread(_objectSpread({}, this.userProperties), data));
      }
    } }, { key: "sendUpgradedPlanEvent", value:

    function sendUpgradedPlanEvent() {var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var event = 'upgraded to a paying plan';
      if (this.userProperties) {
        this.amplitude.logEvent(event, _objectSpread(_objectSpread({}, this.userProperties), data));
      }
    } }, { key: "sendSubscriptionCancelledEvent", value:
    function sendSubscriptionCancelledEvent() {var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var event = 'subscription canceled';
      if (this.userProperties) {
        this.amplitude.logEvent(event, _objectSpread(_objectSpread({}, this.userProperties), data));
      }
    } }, { key: "sendSearchEvent", value:
    function sendSearchEvent() {var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var event = 'search submitted';
      if (this.userProperties) {
        this.amplitude.logEvent(event, _objectSpread(_objectSpread({}, this.userProperties), data));
      }
    } }, { key: "sendJoinedLiveEvent", value:

    function sendJoinedLiveEvent() {var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var event = 'joined event';
      if (this.userProperties) {
        this.amplitude.logEvent(event, _objectSpread(_objectSpread({}, this.userProperties), data));
      }
    } }, { key: "sendPaidLiveEvent", value:

    function sendPaidLiveEvent() {var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var event = 'paid event';
      if (this.userProperties) {
        this.amplitude.logEvent(event, _objectSpread(_objectSpread({}, this.userProperties), data));
      }
    } }, { key: "sendUsedLiveEventCode", value:

    function sendUsedLiveEventCode() {var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var event = 'User - LIVE code used';
      if (this.userProperties) {
        this.amplitude.logEvent(event, _objectSpread(_objectSpread({}, this.userProperties), data));
      }
    } }, { key: "sendClickedLiveRecordingEvent", value:

    function sendClickedLiveRecordingEvent() {var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var event = 'clicked on recording URL';
      if (this.userProperties) {
        this.amplitude.logEvent(event, _objectSpread(_objectSpread({}, this.userProperties), data));
      }
    } }, { key: "sendLiveSignupEvent", value:

    function sendLiveSignupEvent() {var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var event = 'signed up from live';
      if (this.userProperties) {
        this.amplitude.logEvent(event, _objectSpread(_objectSpread({}, this.userProperties), data));
      }
    } }, { key: "sendProgramAccessGrantedEvent", value:

    function sendProgramAccessGrantedEvent(_ref) {var title = _ref.title,themes = _ref.themes,duration = _ref.duration,access_code = _ref.access_code;
      var event = 'Program - access granted';
      if (this.userProperties) {
        this.amplitude.logEvent(event, _objectSpread(_objectSpread({},
        this.userProperties), {}, {
          program_title: title,
          program_theme: themes,
          program_duration: duration,
          access_code: access_code }));

      }
    } }, { key: "sendChallengeAccessGrantedEvent", value:

    function sendChallengeAccessGrantedEvent(_ref2) {var title = _ref2.title,themes = _ref2.themes,duration = _ref2.duration,access_code = _ref2.access_code;
      var event = 'Challenge - access granted';
      if (this.userProperties) {
        this.amplitude.logEvent(event, _objectSpread(_objectSpread({},
        this.userProperties), {}, {
          program_title: title,
          program_theme: themes,
          program_duration: duration,
          access_code: access_code }));

      }
    } }, { key: "sendUpgradedFromProgramPageEvent", value:

    function sendUpgradedFromProgramPageEvent(_ref3) {var title = _ref3.title,subscription = _ref3.subscription;
      var event = 'Program - upgraded from program page';
      if (this.userProperties) {
        this.amplitude.logEvent(event, _objectSpread(_objectSpread({},
        this.userProperties), {}, {
          program_title: title,
          subscription: subscription }));

      }
    } }, { key: "sendSignupFromProgramPageEvent", value:

    function sendSignupFromProgramPageEvent(_ref4) {var title = _ref4.title;
      var event = 'Program - signed up from program page';
      this.amplitude.logEvent(event, {
        program_title: title });

    } }, { key: "sendProgramCompletionEvent", value:

    function sendProgramCompletionEvent(_ref5) {var title = _ref5.title;
      var event = 'Program - completed 100%';
      if (this.userProperties) {
        this.amplitude.logEvent(event, _objectSpread(_objectSpread({},
        this.userProperties), {}, {
          program_title: title }));

      }
    } }, { key: "sendProgramPurchasedGiftEvent", value:

    function sendProgramPurchasedGiftEvent(_ref6) {var title = _ref6.title,amount = _ref6.amount,slug = _ref6.slug;
      var event = 'Program - Purchased gift';
      if (this.userProperties) {
        this.amplitude.logEvent(event, _objectSpread(_objectSpread({},
        this.userProperties), {}, {
          program_title: title,
          amount: amount,
          slug: slug }));

      }
    } }, { key: "sendProgramPurchaseEvent", value:

    function sendProgramPurchaseEvent(_ref7)





    {var title = _ref7.title,slug = _ref7.slug,amount = _ref7.amount,discountedAmount = _ref7.discountedAmount,category = _ref7.category;
      var event = 'Program - Purchase';
      if (category === generated/* ProgramCategory.Courses */.l92.Courses) {
        event = 'Course - Purchase';
      }
      if (this.userProperties) {
        this.amplitude.logEvent(event, _objectSpread(_objectSpread({},
        this.userProperties), {}, {
          program_title: title,
          discountedAmount: discountedAmount,
          amount: amount,
          slug: slug }));

      }
    } }, { key: "sendCoursePurchasedGiftEvent", value:

    function sendCoursePurchasedGiftEvent(_ref8) {var title = _ref8.title,amount = _ref8.amount,slug = _ref8.slug;
      var event = 'Course - Purchased gift';
      if (this.userProperties) {
        this.amplitude.logEvent(event, _objectSpread(_objectSpread({},
        this.userProperties), {}, {
          program_title: title,
          amount: amount,
          slug: slug }));

      }
    } }, { key: "sendProgramGiftActivatedEvent", value:

    function sendProgramGiftActivatedEvent(_ref9) {var title = _ref9.title,amount = _ref9.amount,slug = _ref9.slug;
      var event = 'Program - Gift activated';
      if (this.userProperties) {
        this.amplitude.logEvent(event, _objectSpread(_objectSpread({},
        this.userProperties), {}, {
          program_title: title,
          amount: amount,
          slug: slug }));

      }
    } }, { key: "sendCourseGiftActivatedEvent", value:

    function sendCourseGiftActivatedEvent(_ref10) {var title = _ref10.title,amount = _ref10.amount,slug = _ref10.slug;
      var event = 'Course - Gift activated';
      if (this.userProperties) {
        this.amplitude.logEvent(event, _objectSpread(_objectSpread({},
        this.userProperties), {}, {
          program_title: title,
          amount: amount,
          slug: slug }));

      }
    } }, { key: "sendProgramVideoCompletionEvent", value:

    function sendProgramVideoCompletionEvent(_ref11)




    {var programTitle = _ref11.programTitle,videoTitle = _ref11.videoTitle,weekTitle = _ref11.weekTitle,videoSlug = _ref11.videoSlug;
      var event = 'Program - video completed';
      if (this.userProperties) {
        this.amplitude.logEvent(event, _objectSpread(_objectSpread({},
        this.userProperties), {}, {
          program_title: programTitle,
          video_title: videoTitle,
          week_title: weekTitle,
          video_slug: videoSlug }));

      }
    } }, { key: "sendSurveyStartedEvent", value:

    function sendSurveyStartedEvent(_ref12) {var title = _ref12.title,program_title = _ref12.program_title,program_slug = _ref12.program_slug,part_slug = _ref12.part_slug;
      var event = 'Program - survey started';
      if (this.userProperties) {
        this.amplitude.logEvent(event, _objectSpread(_objectSpread({},
        this.userProperties), {}, {
          title: title,
          program_title: program_title,
          program_slug: program_slug,
          part_slug: part_slug }));

      }
    } }, { key: "sendSurveyCompletedEvent", value:

    function sendSurveyCompletedEvent(_ref13) {var title = _ref13.title,program_title = _ref13.program_title,program_slug = _ref13.program_slug,part_slug = _ref13.part_slug;
      var event = 'Program - survey completed';
      if (this.userProperties) {
        this.amplitude.logEvent(event, _objectSpread(_objectSpread({},
        this.userProperties), {}, {
          title: title,
          program_title: program_title,
          program_slug: program_slug,
          part_slug: part_slug }));

      }
    } }, { key: "sendRegisterEvent", value:

    function sendRegisterEvent(_ref14) {var email = _ref14.email,firstName = _ref14.firstName,lastName = _ref14.lastName,source = _ref14.source;
      var event = 'Register';
      this.amplitude.logEvent(event, {
        email: email,
        firstName: firstName,
        lastName: lastName,
        source: source });

    } }, { key: "sendProfileCompletedEvent", value:

    function sendProfileCompletedEvent(_ref15) {var email = _ref15.email,firstName = _ref15.firstName,lastName = _ref15.lastName,source = _ref15.source;
      var event = 'Register - Profile details completed';
      this.amplitude.logEvent(event, _objectSpread(_objectSpread({},
      this.userProperties || {}), {}, {
        email: email,
        firstName: firstName,
        lastName: lastName,
        source: source }));

    }

    //
  }, { key: "sendSearchTerm", value: function sendSearchTerm(_ref16) {var keyword = _ref16.keyword,category = _ref16.category;
      var event = 'Search - User searched term';
      this.amplitude.logEvent(event, _objectSpread(_objectSpread({},
      this.userProperties || {}), {}, {
        keyword: keyword,
        category: category }));

    } }, { key: "sendSearchViewAll", value:

    function sendSearchViewAll(_ref17) {var category = _ref17.category;
      var event = 'Search - User clicked view all';
      this.amplitude.logEvent(event, _objectSpread(_objectSpread({},
      this.userProperties || {}), {}, {
        category: category }));

    } }, { key: "sendSearchClickedTab", value:

    function sendSearchClickedTab(_ref18) {var tab = _ref18.tab;
      var event = 'Search - User selected tab';
      this.amplitude.logEvent(event, _objectSpread(_objectSpread({},
      this.userProperties || {}), {}, {
        tab: tab }));

    } }, { key: "sendSearchClickedSuggestion", value:

    function sendSearchClickedSuggestion(_ref19) {var searchQuery = _ref19.searchQuery,suggestion = _ref19.suggestion;
      var event = 'Search - User clicked suggestion';
      this.amplitude.logEvent(event, _objectSpread(_objectSpread({},
      this.userProperties || {}), {}, {
        keyword: searchQuery,
        suggestion: suggestion }));

    } }, { key: "sendSearchClickedCorrection", value:

    function sendSearchClickedCorrection(_ref20) {var keyword = _ref20.keyword;
      var event = 'Search - User clicked correction';
      this.amplitude.logEvent(event, _objectSpread(_objectSpread({},
      this.userProperties || {}), {}, {
        keyword: keyword }));

    } }, { key: "sendJoinedBundle", value:

    function sendJoinedBundle(_ref21) {var name = _ref21.name,slug = _ref21.slug,client_name = _ref21.client_name,code = _ref21.code;
      var event = 'Bundle - Joined';
      this.amplitude.logEvent(event, _objectSpread(_objectSpread({},
      this.userProperties || {}), {}, {
        name: name,
        slug: slug,
        client_name: client_name,
        code: code }));

    } }, { key: "sendTrialReclaimed", value:

    function sendTrialReclaimed(_ref22) {var source = _ref22.source;
      var event = 'User - reclaimed trial';
      this.amplitude.logEvent(event, _objectSpread(_objectSpread({},
      this.userProperties || {}), {}, {
        source: source }));

    } }, { key: "sendTrialRejected", value:

    function sendTrialRejected() {
      var event = 'User - rejected trial reclaim';
      this.amplitude.logEvent(event, _objectSpread({},
      this.userProperties || {}));

    } }]);return AmplitudeManager;}();


function getAmplitude() {var userProperties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  if (manager && manager.userProperties) {
    return manager;
  } else {
    manager = new AmplitudeManager(userProperties);
    return manager;
  }
}
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
;// CONCATENATED MODULE: ./lib/analytics/gtag-triggers.ts
var _excluded = (/* unused pure expression or super */ null && (["program_name", "program_slug", "category"])),_excluded2 = ["program_name", "program_slug", "category"],_excluded3 = (/* unused pure expression or super */ null && (["program_name", "program_slug", "category"])),_excluded4 = ["program_name", "program_slug", "category"];function gtag_triggers_ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function gtag_triggers_objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? gtag_triggers_ownKeys(Object(source), !0).forEach(function (key) {(0,defineProperty/* default */.Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : gtag_triggers_ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}var sendTrialStartedTrigger = function sendTrialStartedTrigger(_ref) {var _ref$trialDays = _ref.trialDays,trialDays = _ref$trialDays === void 0 ? 14 : _ref$trialDays;
  window.dataLayer.push({ event: 'trial-started', trialDays: trialDays });
};



















// SUBSCRIPTION TRIGGERS
var monthlySubscription = function monthlySubscription(data) {
  window.dataLayer.push(gtag_triggers_objectSpread({
    event: 'monthly-subscription' },
  data));

};

var quarterlySubscription = function quarterlySubscription(data) {
  window.dataLayer.push(gtag_triggers_objectSpread({
    event: 'quarterly-subscription' },
  data));

};

var yearlySubscription = function yearlySubscription(data) {
  window.dataLayer.push(gtag_triggers_objectSpread({ event: 'yearly-subscription' }, data));
};
// SUBSCRIPTION TRIGGERS END

//
var sendSubscriptionTrigger = function sendSubscriptionTrigger(params) {
  var events = {
    1: monthlySubscription,
    3: quarterlySubscription,
    12: yearlySubscription };


  var months = params.months;
  var fn = events[months];

  if (fn) {
    fn(params);
  }
};

//









var sendLiveEventPurchaseTrigger = function sendLiveEventPurchaseTrigger(data) {
  window.dataLayer.push(gtag_triggers_objectSpread({ event: 'live-event-purchase' }, data));
};







var sendLiveEventFreeActivateTrigger = function sendLiveEventFreeActivateTrigger(
data)
{
  window.dataLayer.push(gtag_triggers_objectSpread({ event: 'live-event-free-activation' }, data));
};

//








var SendProgramActivationEvent = function SendProgramActivationEvent(
params)
{var _objectSpread2;
  var program_name = params.program_name,program_slug = params.program_slug,category = params.category,other = _objectWithoutProperties(params, _excluded);
  window.dataLayer.push(gtag_triggers_objectSpread((_objectSpread2 = {
    event: "".concat(category, "-free-activation") }, _defineProperty(_objectSpread2, "".concat(
  category, "_name"), program_name), _defineProperty(_objectSpread2, "".concat(
  category, "_slug"), program_slug), _objectSpread2),
  other));

};

//








var SendProgramPurchaseEvent = function SendProgramPurchaseEvent(params) {var _objectSpread3;
  var program_name = params.program_name,program_slug = params.program_slug,category = params.category,other = (0,objectWithoutProperties/* default */.Z)(params, _excluded2);
  window.dataLayer.push(gtag_triggers_objectSpread((_objectSpread3 = {
    event: "".concat(params.category, "-purchase") }, (0,defineProperty/* default */.Z)(_objectSpread3, "".concat(
  category, "_name"), program_name), (0,defineProperty/* default */.Z)(_objectSpread3, "".concat(
  category, "_slug"), program_slug), _objectSpread3),
  other));

};

//









var SendProgramCodeActivationEvent = function SendProgramCodeActivationEvent(
params)
{var _objectSpread4;
  var program_name = params.program_name,program_slug = params.program_slug,category = params.category,other = _objectWithoutProperties(params, _excluded3);
  window.dataLayer.push(gtag_triggers_objectSpread((_objectSpread4 = {
    event: "".concat(params.category, "-purchase") }, _defineProperty(_objectSpread4, "".concat(
  category, "_name"), program_name), _defineProperty(_objectSpread4, "".concat(
  category, "_slug"), program_slug), _objectSpread4),
  other));

};

//








var SendProgramGiftCodePurchaseEvent = function SendProgramGiftCodePurchaseEvent(
params)
{var _objectSpread5;
  var program_name = params.program_name,program_slug = params.program_slug,category = params.category,other = (0,objectWithoutProperties/* default */.Z)(params, _excluded4);
  window.dataLayer.push(gtag_triggers_objectSpread((_objectSpread5 = {
    event: "".concat(params.category, "-gift-code-purchase") }, (0,defineProperty/* default */.Z)(_objectSpread5, "".concat(
  category, "_name"), program_name), (0,defineProperty/* default */.Z)(_objectSpread5, "".concat(
  category, "_slug"), program_slug), _objectSpread5),
  other));

};
;// CONCATENATED MODULE: ./lib/analytics/pixel.ts
/* provided dependency */ var process = __webpack_require__(34155);
var ReactPixel;var
FBPixel = /*#__PURE__*/function () {function FBPixel() {(0,classCallCheck/* default */.Z)(this, FBPixel);}(0,createClass/* default */.Z)(FBPixel, null, [{ key: "load", value:
    function load() {
      // eslint-disable-next-line
      ReactPixel = (__webpack_require__(51767)["default"]);
      var options = {
        autoConfig: true, // set pixel's autoConfig
        debug: "https://devenv.yogobe.com" !== 'yogobe.com' // enable logs
      };
      ReactPixel.init(process.env.FB_PIXEL_ID, {}, options);
    } }, { key: "trackPage", value:

    function trackPage(url) {
      FBPixel.track('PageView', false, { url: url });
    } }, { key: "track", value:

    function track(event, custom, data) {
      if (false) {} else {
        if (custom) {
          ReactPixel.trackCustom(event);
        } else {
          ReactPixel.track(event, data);
        }
      }
    } }]);return FBPixel;}();


/* harmony default export */ var pixel = (FBPixel);
// EXTERNAL MODULE: ./node_modules/@sentry/hub/esm/exports.js
var esm_exports = __webpack_require__(92876);
;// CONCATENATED MODULE: ./lib/analytics/ga-manager.ts
/* provided dependency */ var ga_manager_process = __webpack_require__(34155);
function ga_manager_ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function ga_manager_objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ga_manager_ownKeys(Object(source), !0).forEach(function (key) {(0,defineProperty/* default */.Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ga_manager_ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}var GA4_TRACKING_ID = "G-Q4EQS9RG3N";
var GA_TRACKING_ID = ga_manager_process.env.GA_TRACKING_ID;
var GTM_ID = (/* unused pure expression or super */ null && ("347753875"));var









GoogleAnalyticsManager = /*#__PURE__*/function () {


  function GoogleAnalyticsManager(user_id) {(0,classCallCheck/* default */.Z)(this, GoogleAnalyticsManager);(0,defineProperty/* default */.Z)(this, "user_id", void 0);(0,defineProperty/* default */.Z)(this, "event",
























































































































































    function (params) {
      var action = params.action,category = params.category,label = params.label,value = params.value,currency = params.currency;
      window.gtag('event', action, {
        event_category: category,
        event_label: label,
        value: value,
        currency: currency,
        send_to: GA_TRACKING_ID });

    });this.user_id = user_id;}(0,createClass/* default */.Z)(GoogleAnalyticsManager, [{ key: "setUserProperties", value: function setUserProperties(user_id) {if (user_id) {this.setGAUser(user_id);}this.user_id = user_id;} }, { key: "pageview", value: function pageview(url) {window.gtag('config', GA_TRACKING_ID, { page_path: url });window.dataLayer.push({ event: 'pageview', page: url });this.sendEvent('pageview', { page: url });} }, { key: "setGAUser", value: function setGAUser(userId) {window.gtag('set', 'user_id', userId);} }, { key: "login", value: function login() {var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};this.sendEvent('login', data);} }, { key: "registration_begin", value: function registration_begin() {this.sendEvent('registration_begin', {});} }, { key: "registration_step1Complete", value: function registration_step1Complete() {this.sendEvent('registration_step1_complete', {});} }, { key: "registration_step2Complete", value: function registration_step2Complete() {this.sendEvent('registration_step2_complete', {});} }, { key: "registration_campaignCodeUsed", value: function registration_campaignCodeUsed(data) {this.sendEvent('registration_campaign-code_used', data);} //
  }, { key: "book_event", value: function book_event(data) {this.sendEvent('book_event', data);} /* DONE */ }, { key: "program_begin", value: function program_begin(data) {this.sendEvent('program_begin', data);} }, { key: "program_complete", value: function program_complete(data) {this.sendEvent('program_complete', data);} }, { key: "challenge_begin", value: function challenge_begin(data) {this.sendEvent('challenge_begin', data);} }, { key: "challenge_complete", value: function challenge_complete(data) {this.sendEvent('challenge_complete', data);} }, { key: "course_begin", value: function course_begin(data) {this.sendEvent('course_begin', data);} }, { key: "course_complete", value: function course_complete(data) {this.sendEvent('course_complete', data);} }, { key: "bundle_preRegister", value: function bundle_preRegister(data) {this.sendEvent('bundle_pre-register', data);} }, { key: "bundle_begin", value: function bundle_begin(data) {this.sendEvent('bundle_begin', data);} }, { key: "recommendations_begin", value: function recommendations_begin(data) {this.sendEvent('recommendations_begin', data);} }, { key: "recommendations_complete", value: function recommendations_complete(data) {this.sendEvent('recommendations_complete', data);} }, { key: "addto_playlist", value: function addto_playlist(data) {this.sendEvent('addto_playlist', data);} }, { key: "favorite_session", value: function favorite_session(data) {this.sendEvent('favorite_session', data);} }, { key: "favorite_playlist", value: function favorite_playlist(data) {this.sendEvent('favorite_playlist', data);} }, { key: "search_global", value: function search_global(data) {this.sendEvent('search_global', data);} }, { key: "search_library", value: function search_library(data) {this.sendEvent('search_library', data);} //
  }, { key: "purchase_subscriptionBegin", value: function purchase_subscriptionBegin(data) {this.sendEvent('purchase_subscription_begin', data);} }, { key: "purchase_subscriptionComplete", value: function purchase_subscriptionComplete(data) {this.sendEvent('purchase_subscription_complete', data);} }, { key: "purchase_subscriptionFail", value: function purchase_subscriptionFail(data) {this.sendEvent('purchase_subscription_fail', data);} //
  }, { key: "purchase_extraBegin", value: function purchase_extraBegin(data) {this.sendEvent('purchase_extra_begin', data);} }, { key: "purchase_extraComplete", value: function purchase_extraComplete(data) {this.sendEvent('purchase_extra_complete', data);} }, { key: "purchase_extraFail", value: function purchase_extraFail(data) {this.sendEvent('purchase_extra_fail', data);} //
  }, { key: "subscription_cancel", value: function subscription_cancel(data) {this.sendEvent('subscription_cancel', data);} //
  }, { key: "sendEvent", value: function sendEvent(event) {var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}; // for GA4, send user data on all events
      window.gtag('event', event, ga_manager_objectSpread(ga_manager_objectSpread({ user_id: this.user_id }, data), {}, { send_to: GA4_TRACKING_ID }));} // https://developers.google.com/analytics/devguides/collection/gtagjs/events
  }]);return GoogleAnalyticsManager;}();/* harmony default export */ var ga_manager = (GoogleAnalyticsManager);
;// CONCATENATED MODULE: ./lib/analytics/manager.ts
function manager_ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function manager_objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? manager_ownKeys(Object(source), !0).forEach(function (key) {(0,defineProperty/* default */.Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : manager_ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}
















var defaultConfig = {
  pixel: true,
  ga: true,
  amplitude: true };var


AnalyticsManager_ = /*#__PURE__*/function () {function AnalyticsManager_() {var _this = this;(0,classCallCheck/* default */.Z)(this, AnalyticsManager_);(0,defineProperty/* default */.Z)(this, "amplitude", void 0);(0,defineProperty/* default */.Z)(this, "ga", void 0);(0,defineProperty/* default */.Z)(this, "_userAttributes", void 0);(0,defineProperty/* default */.Z)(this, "pixelEnabled",




    false);(0,defineProperty/* default */.Z)(this, "amplitudeEnabled",
    false);(0,defineProperty/* default */.Z)(this, "gaEnabled",
    false);(0,defineProperty/* default */.Z)(this, "_PIXEL_TRACK",














































































































































































































































































































































































































































































































































































































































































































































































































































































































    function () {for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {params[_key] = arguments[_key];}
      if (_this.pixelEnabled) pixel.track.apply(null, params);
    });}(0,createClass/* default */.Z)(AnalyticsManager_, [{ key: "initLibraries", value: function initLibraries() {for (var _len2 = arguments.length, params = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {params[_key2] = arguments[_key2];}var config = params[0],currentUser = params[1];var _config = Object.assign({}, defaultConfig, config);this.ga = new ga_manager(currentUser === null || currentUser === void 0 ? void 0 : currentUser.id); //
      if (_config.pixel) {this.pixelEnabled = true;pixel.load();} //
      if (_config.ga) {this.gaEnabled = true;if (currentUser) {this._userAttributes = currentUser;this.ga.setUserProperties(currentUser.id);}} //
      if (_config.amplitude) {this.amplitudeEnabled = true;this.amplitude = getAmplitude({});}this.trackPageChange();this.trackPage(window.location.pathname);} }, { key: "_getUserDataProperties", value: function _getUserDataProperties() {var _this$_userAttributes, _this$_userAttributes2, _this$_userAttributes3, _this$_userAttributes4, _this$_userAttributes5, _this$_userAttributes6, _this$_userAttributes7, _this$_userAttributes8, _this$_userAttributes9;return { user_id: (_this$_userAttributes = this._userAttributes) === null || _this$_userAttributes === void 0 ? void 0 : _this$_userAttributes.id, user_first_name: (_this$_userAttributes2 = this._userAttributes) === null || _this$_userAttributes2 === void 0 ? void 0 : _this$_userAttributes2.firstName, user_last_name: (_this$_userAttributes3 = this._userAttributes) === null || _this$_userAttributes3 === void 0 ? void 0 : _this$_userAttributes3.lastName, user_email: (_this$_userAttributes4 = this._userAttributes) === null || _this$_userAttributes4 === void 0 ? void 0 : _this$_userAttributes4.email, user_phone: (_this$_userAttributes5 = this._userAttributes) === null || _this$_userAttributes5 === void 0 ? void 0 : _this$_userAttributes5.phone, user_address: (_this$_userAttributes6 = this._userAttributes) === null || _this$_userAttributes6 === void 0 ? void 0 : _this$_userAttributes6.address, user_city: (_this$_userAttributes7 = this._userAttributes) === null || _this$_userAttributes7 === void 0 ? void 0 : _this$_userAttributes7.city, user_zipcode: (_this$_userAttributes8 = this._userAttributes) === null || _this$_userAttributes8 === void 0 ? void 0 : _this$_userAttributes8.zipcode, user_country: (_this$_userAttributes9 = this._userAttributes) === null || _this$_userAttributes9 === void 0 ? void 0 : _this$_userAttributes9.country };} }, { key: "setUserProperties", value: function setUserProperties(userProperties) {this._userAttributes = userProperties; //
      if (this.amplitudeEnabled) {this.amplitude = getAmplitude(userProperties);this.amplitude.setUserProperties(userProperties);}if (this.gaEnabled) {var _this$_userAttributes10;this.ga.setUserProperties((_this$_userAttributes10 = this._userAttributes) === null || _this$_userAttributes10 === void 0 ? void 0 : _this$_userAttributes10.id);}} }, { key: "trackPageChange", value: function trackPageChange() {var _this2 = this;router_default().events.on('routeChangeComplete', this.trackPage.bind(this));window.addEventListener('beforeunload', function () {router_default().events.off('routeChangeComplete', _this2.trackPage.bind(_this2));});} }, { key: "trackPage", value: function trackPage(url) {if (this.pixelEnabled) {pixel.trackPage(url);}if (this.gaEnabled) {this.ga.pageview(url);}} }, { key: "login", value: function login(userId) {if (this.gaEnabled) {this.ga.login(userId);}} }, { key: "sendPlayVideoEvent", value: function sendPlayVideoEvent() {var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}; //
      if (this.amplitudeEnabled) {this.amplitude.sendPlayVideoEvent(data);}} }, { key: "sendPlaylistPlayEvent", value: function sendPlaylistPlayEvent() {//
      if (this.amplitudeEnabled) {this.amplitude.sendPlaylistPlayEvent();}} }, { key: "sendVideoAddedToFavorites", value: function sendVideoAddedToFavorites() {var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}; //
      if (this.amplitudeEnabled) {this.amplitude.sendVideoAddedToFavorites(data);}if (this.gaEnabled) {this.ga.favorite_session(data);}} }, { key: "sendPlaylistAddedToFavorites", value: function sendPlaylistAddedToFavorites() {var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}; //
      if (this.amplitudeEnabled) {this.amplitude.sendPlaylistAddedToFavorites(data);}if (this.gaEnabled) {this.ga.favorite_playlist(data);}} }, { key: "sendVideoAddToPlaylistEvent", value: function sendVideoAddToPlaylistEvent() {var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}; //
      if (this.amplitudeEnabled) {this.amplitude.sendVideoAddToPlaylistEvent(data);}if (this.gaEnabled) {this.ga.addto_playlist(data);}} }, { key: "sendPlaylistCreatedEvent", value: function sendPlaylistCreatedEvent() {var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}; //
      if (this.amplitudeEnabled) {this.amplitude.sendPlaylistCreatedEvent(data);}} }, { key: "sendClickedScheduleEvent", value: function sendClickedScheduleEvent() {var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}; //
      if (this.amplitudeEnabled) {this.amplitude.sendClickedScheduleEvent(data);}} }, { key: "sendClickedShareVideoEvent", value: function sendClickedShareVideoEvent() {var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}; //
      if (this.amplitudeEnabled) {this.amplitude.sendClickedShareVideoEvent(data);}} }, { key: "sendClickedSharePlaylistEvent", value: function sendClickedSharePlaylistEvent() {var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}; //
      if (this.amplitudeEnabled) {this.amplitude.sendClickedSharePlaylistEvent(data);}} }, { key: "sendRecommendationsSetupBeginEvent", value: function sendRecommendationsSetupBeginEvent() {var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};if (this.gaEnabled) {this.ga.recommendations_begin(data);}} }, { key: "sendRecommendationsSetupCompleteEvent", value: function sendRecommendationsSetupCompleteEvent() {var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};if (this.gaEnabled) {this.ga.recommendations_complete(data);}} }, { key: "sendRecommendationsEditedEvent", value: function sendRecommendationsEditedEvent() {var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}; //
      if (this.amplitudeEnabled) {this.amplitude.sendRecommendationsEditedEvent(data);}} }, { key: "sendUpgradedPlanEvent", value: function sendUpgradedPlanEvent(data) {//
      if (this.amplitudeEnabled) {this.amplitude.sendUpgradedPlanEvent(data);}if (this.gaEnabled) {sendSubscriptionTrigger(manager_objectSpread(manager_objectSpread({}, data), this._getUserDataProperties()));}var CYCLES = { 1: 'monthly', 3: 'quarterly', 12: 'yearly' };if (this.pixelEnabled) {pixel.track('Subscribe', false, { subscription_type: CYCLES[data.months], value: data.amount, currency: data.currency, content_type: data.content_type });}if (this.gaEnabled) {// TODO: abstract this
        var GA_SUBS = { 1: { label: '1month', value: 189 }, 3: { label: '3months', value: 499 }, 12: { label: '12months', value: 1899 } };this.ga.event({ category: 'subscription', action: 'subscribe', label: GA_SUBS[data.months].label, value: GA_SUBS[data.months].value, currency: data.currency });}} }, { key: "sendSubscriptionPurchaseBeginEvent", value: function sendSubscriptionPurchaseBeginEvent() {var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};if (this.gaEnabled) {this.ga.purchase_subscriptionBegin(data);}} }, { key: "sendSubscriptionPurchaseCompleteEvent", value: function sendSubscriptionPurchaseCompleteEvent() {var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};if (this.gaEnabled) {this.ga.purchase_subscriptionComplete(data);}} }, { key: "SendSubscriptionPurchaseFailEvent", value: function SendSubscriptionPurchaseFailEvent() {var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};if (this.gaEnabled) {this.ga.purchase_subscriptionFail(data);}} }, { key: "sendSubscriptionCancelledEvent", value: function sendSubscriptionCancelledEvent() {var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}; //
      if (this.amplitudeEnabled) {this.amplitude.sendSubscriptionCancelledEvent(data);}if (this.gaEnabled) {this.ga.subscription_cancel(data);}} }, { key: "sendSearchEvent", value: function sendSearchEvent() {var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}; //
      if (this.amplitudeEnabled) {this.amplitude.sendSearchEvent(data);}if (this.gaEnabled) {this.ga.search_library(data);}} }, { key: "sendJoinedLiveEvent", value: function sendJoinedLiveEvent(data) {//
      if (this.amplitudeEnabled) {this.amplitude.sendJoinedLiveEvent(data);}if (this.gaEnabled) {sendLiveEventFreeActivateTrigger(manager_objectSpread({ event_name: data.name, event_theme: data.theme, amount: data.amount, currency: data.currency }, this._getUserDataProperties())); //
        this.ga.book_event({ title: data.name, instructor: data.instructor, price: data.amount / 100, currency: data.currency, discount: Math.floor(data.discountedAmount > 0 ? data.amount - data.discountedAmount : 0) / 100 }); //
        this.ga.event({ category: 'live', action: 'free_activation', label: data.name, value: data.amount, currency: data.currency });}} }, { key: "sendUsedLiveEventCode", value: function sendUsedLiveEventCode(data) {if (this.amplitudeEnabled) {this.amplitude.sendUsedLiveEventCode({ name: data.name, amount: data.amount, currency: data.currency, type: data.theme, instructor: data.instructor, code: data.code });}} }, { key: "sendPaidLiveEvent", value: function sendPaidLiveEvent(data) {//
      if (this.amplitudeEnabled) {this.amplitude.sendPaidLiveEvent({ name: data.event_name, amount: data.amount, type: data.event_theme, instructor: data.instructor });}if (this.gaEnabled) {sendLiveEventPurchaseTrigger(manager_objectSpread({ event_name: data.event_name, event_theme: data.event_theme, currency: data.currency, amount: data.amount, discountedAmount: data.discountedAmount }, this._getUserDataProperties())); //
        this.ga.event({ category: 'live', action: 'purchase', label: data.event_name, value: data.amount, currency: data.currency });}if (this.pixelEnabled) {pixel.track('Purchase', false, { value: data.discountedAmount || data.amount, currency: data.currency, content_name: data.event_name, content_category: 'live_event', contents: [{ id: data.event_name, quantity: 1 }], content_type: 'live_event' });}} }, { key: "sendClickedLiveRecordingEvent", value: function sendClickedLiveRecordingEvent() {var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}; //
      if (this.amplitudeEnabled) {this.amplitude.sendClickedLiveRecordingEvent(data);}} }, { key: "sendLiveSignupEvent", value: function sendLiveSignupEvent() {var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}; //
      if (this.amplitudeEnabled) {this.amplitude.sendLiveSignupEvent(data);}} }, { key: "sendProgramAccessGrantedEvent", value: function sendProgramAccessGrantedEvent(_ref) {var id = _ref.id,title = _ref.title,category = _ref.category,slug = _ref.slug,_ref$access_code = _ref.access_code,access_code = _ref$access_code === void 0 ? '' : _ref$access_code,_ref$themes = _ref.themes,themes = _ref$themes === void 0 ? '' : _ref$themes,_ref$duration = _ref.duration,duration = _ref$duration === void 0 ? '' : _ref$duration; //
      if (this.amplitudeEnabled) {this.amplitude.sendProgramAccessGrantedEvent({ id: id, title: title, slug: slug, themes: themes, duration: duration, access_code: access_code });}if (this.gaEnabled) {var begin_fns = null;if (category === generated/* ProgramCategory.Courses */.l92.Courses) {begin_fns = this.ga.course_begin;} else if (category === generated/* ProgramCategory.Programs */.l92.Programs) {begin_fns = this.ga.program_begin;} else if (category === generated/* ProgramCategory.Challenges */.l92.Challenges) {begin_fns = this.ga.challenge_begin;}if (begin_fns) {begin_fns.apply(this.ga, [{ id: id, title: title, slug: slug, category: category }]);}}} }, { key: "sendProgramPurchaseEvent", value: function sendProgramPurchaseEvent(data) {//
      if (this.amplitudeEnabled) {this.amplitude.sendProgramPurchaseEvent({ id: data.id, name: data.name, slug: data.slug, amount: data.amount, discountedAmount: data.discountedAmount, category: data.category });}var programType = 'program';if (data.category === generated/* ProgramCategory.Courses */.l92.Courses) {programType = 'course';}if (this.gaEnabled) {SendProgramPurchaseEvent(manager_objectSpread({ category: programType, program_name: data.name, program_slug: data.slug, currency: data.currency, amount: data.amount }, this._getUserDataProperties()));this.ga.event({ category: programType, action: 'purchase', label: data.name, value: data.amount, currency: data.currency });}if (this.pixelEnabled) {pixel.track('Purchase', false, { value: data.discountedAmount || data.amount, currency: data.currency, content_name: data.name, content_category: programType, contents: [{ id: data.name, quantity: 1 }], content_type: programType });}} }, { key: "sendChallengeAccessGrantedEvent", value: function sendChallengeAccessGrantedEvent(_ref2) {var title = _ref2.title,themes = _ref2.themes,duration = _ref2.duration,access_code = _ref2.access_code; //
      if (this.amplitudeEnabled) {this.amplitude.sendChallengeAccessGrantedEvent({ title: title, themes: themes, duration: duration, access_code: access_code });}if (this.pixelEnabled) {this.ga.challenge_begin({ title: title, themes: themes, duration: duration, access_code: access_code });pixel.track('Purchase', false, { value: '0', currency: 'SEK', content_name: title, content_category: 'challenge', contents: [{ id: title, quantity: 1 }], content_type: 'challenge' });}} }, { key: "sendTrialStarted", value: function sendTrialStarted() {if (this.gaEnabled) {this.ga.event({ category: 'registration', action: 'trial', label: 'trial', value: 80 });}if (this.pixelEnabled) {pixel.track('StartTrial', false, {});}} }, { key: "SendRegistrationStep1visited", value: function SendRegistrationStep1visited() {if (this.gaEnabled) {this.ga.registration_begin();}if (this.pixelEnabled) {pixel.track('Step 1 - visited', true, {});}} }, { key: "SendRegistrationStep1Completed", value: function SendRegistrationStep1Completed() {if (this.gaEnabled) {this.ga.registration_step1Complete();}if (this.pixelEnabled) {pixel.track('Step 1 - completed', true, {});}} }, { key: "SendRegistrationStep2Completed", value: function SendRegistrationStep2Completed() {if (this.gaEnabled) {this.ga.registration_step2Complete();}if (this.pixelEnabled) {pixel.track('Step 2 - completed', true, {});}} }, { key: "registrationCampaignCodeUsed", value: function registrationCampaignCodeUsed(_ref3) {var code = _ref3.code;if (this.gaEnabled) {this.ga.registration_campaignCodeUsed({ code: code });}} }, { key: "sendUpgradedFromProgramPageEvent", value: function sendUpgradedFromProgramPageEvent(_ref4) {var title = _ref4.title,subscription = _ref4.subscription; //
      if (this.amplitudeEnabled) {this.amplitude.sendUpgradedFromProgramPageEvent({ title: title, subscription: subscription });}} }, { key: "sendSignupFromProgramPageEvent", value: function sendSignupFromProgramPageEvent(_ref5) {var title = _ref5.title; //
      if (this.amplitudeEnabled) {this.amplitude.sendSignupFromProgramPageEvent({ title: title });}} }, { key: "sendProgramCompletionEvent", value: function sendProgramCompletionEvent(_ref6) {var category = _ref6.category,slug = _ref6.slug,title = _ref6.title; //
      if (this.amplitudeEnabled) {this.amplitude.sendProgramCompletionEvent({ title: title });}var complete_fnc = null;if (category === generated/* ProgramCategory.Courses */.l92.Courses) {complete_fnc = this.ga.course_complete;} else if (category === generated/* ProgramCategory.Programs */.l92.Programs) {complete_fnc = this.ga.program_complete;} else if (category === generated/* ProgramCategory.Challenges */.l92.Challenges) {complete_fnc = this.ga.challenge_complete;}if (complete_fnc) {complete_fnc.apply(this.ga, [{ title: title, category: category, slug: slug }]);}} }, { key: "sendProgramVideoCompletionEvent", value: function sendProgramVideoCompletionEvent(_ref7) {var programTitle = _ref7.programTitle,videoTitle = _ref7.videoTitle,weekTitle = _ref7.weekTitle,videoSlug = _ref7.videoSlug; //
      if (this.amplitudeEnabled) {this.amplitude.sendProgramVideoCompletionEvent({ programTitle: programTitle, videoTitle: videoTitle, weekTitle: weekTitle, videoSlug: videoSlug });}} }, { key: "sendProgramPurchasedGiftEvent", value: function sendProgramPurchasedGiftEvent(_ref8) {var category = _ref8.category,title = _ref8.title,slug = _ref8.slug,amount = _ref8.amount,currency = _ref8.currency;if (this.amplitudeEnabled) {this.amplitude.sendProgramPurchasedGiftEvent({ category: category, title: title, slug: slug, amount: amount, currency: currency });}if (this.gaEnabled) {//
        SendProgramGiftCodePurchaseEvent(manager_objectSpread({ category: category, program_name: title, program_slug: slug, amount: amount, currency: currency }, this._getUserDataProperties()));}} }, { key: "sendCoursePurchasedGiftEvent", value: function sendCoursePurchasedGiftEvent(_ref9) {var category = _ref9.category,title = _ref9.title,slug = _ref9.slug,amount = _ref9.amount,currency = _ref9.currency;if (this.amplitudeEnabled) {this.amplitude.sendCoursePurchasedGiftEvent({ category: category, title: title, slug: slug, amount: amount, currency: currency });}if (this.gaEnabled) {//
        SendProgramGiftCodePurchaseEvent(manager_objectSpread({ category: category, program_name: title, program_slug: slug, amount: amount, currency: currency }, this._getUserDataProperties()));}} }, { key: "sendProgramGiftActivatedEvent", value: function sendProgramGiftActivatedEvent(_ref10) {var id = _ref10.id,category = _ref10.category,title = _ref10.title,slug = _ref10.slug,amount = _ref10.amount,currency = _ref10.currency,access_code = _ref10.access_code;if (this.amplitudeEnabled) {this.amplitude.sendProgramGiftActivatedEvent({ id: id, title: title, amount: amount, slug: slug, category: category, currency: currency, access_code: access_code });}} }, { key: "sendCourseGiftActivatedEvent", value: function sendCourseGiftActivatedEvent(_ref11) {var id = _ref11.id,category = _ref11.category,title = _ref11.title,slug = _ref11.slug,amount = _ref11.amount,currency = _ref11.currency,access_code = _ref11.access_code;if (this.amplitudeEnabled) {this.amplitude.sendCourseGiftActivatedEvent({ id: id, title: title, amount: amount, slug: slug, category: category, currency: currency, access_code: access_code });}} }, { key: "sendSurveyStartedEvent", value: function sendSurveyStartedEvent(_ref12) {var title = _ref12.title,program_title = _ref12.program_title,program_slug = _ref12.program_slug,part_slug = _ref12.part_slug;if (this.amplitudeEnabled) {this.amplitude.sendSurveyStartedEvent({ title: title, program_title: program_title, program_slug: program_slug, part_slug: part_slug });}} }, { key: "sendSurveyCompletedEvent", value: function sendSurveyCompletedEvent(_ref13) {var title = _ref13.title,program_title = _ref13.program_title,program_slug = _ref13.program_slug,part_slug = _ref13.part_slug;if (this.amplitudeEnabled) {this.amplitude.sendSurveyCompletedEvent({ title: title, program_title: program_title, program_slug: program_slug, part_slug: part_slug });}} }, { key: "sendRegisterEvent", value: function sendRegisterEvent(_ref14) {var email = _ref14.email,firstName = _ref14.firstName,lastName = _ref14.lastName,source = _ref14.source;if (this.amplitudeEnabled) {this.amplitude.sendRegisterEvent({ email: email, lastName: lastName, firstName: firstName, source: source });}if (this.gaEnabled) {this.ga.registration_step1Complete();}} }, { key: "sendProfileCompletedEvent", value: function sendProfileCompletedEvent(_ref15) {var email = _ref15.email,firstName = _ref15.firstName,lastName = _ref15.lastName,_ref15$source = _ref15.source,source = _ref15$source === void 0 ? '' : _ref15$source;if (this.amplitudeEnabled) {this.amplitude.sendProfileCompletedEvent({ email: email, firstName: firstName, lastName: lastName, source: source });}if (this.gaEnabled) {this.ga.registration_step2Complete();}} //
    // this event is sent on search page
  }, { key: "sendSearchTerm", value: function sendSearchTerm(_ref16) {var keyword = _ref16.keyword,category = _ref16.category; //
      if (this.amplitudeEnabled) {this.amplitude.sendSearchTerm({ keyword: keyword, category: category });}if (this.gaEnabled) {this.ga.search_global({ query: keyword, category: category });}} }, { key: "sendSearchViewAll", value: function sendSearchViewAll(_ref17) {var category = _ref17.category; //
      if (this.amplitudeEnabled) {this.amplitude.sendSearchViewAll({ category: category });}} }, { key: "sendSearchClickedTab", value: function sendSearchClickedTab(_ref18) {var tab = _ref18.tab; //
      if (this.amplitudeEnabled) {this.amplitude.sendSearchClickedTab({ tab: tab });}} }, { key: "sendSearchClickedSuggestion", value: function sendSearchClickedSuggestion(_ref19) {var searchQuery = _ref19.searchQuery,suggestion = _ref19.suggestion; //
      if (this.amplitudeEnabled) {this.amplitude.sendSearchClickedSuggestion({ searchQuery: searchQuery, suggestion: suggestion });}} }, { key: "sendSearchClickedCorrection", value: function sendSearchClickedCorrection(_ref20) {var keyword = _ref20.keyword,correction = _ref20.correction; //
      if (this.amplitudeEnabled) {this.amplitude.sendSearchClickedCorrection({ keyword: keyword, correction: correction });}} }, { key: "sendJoinedBundle", value: function sendJoinedBundle(_ref21) {var name = _ref21.name,slug = _ref21.slug,client_name = _ref21.client_name,code = _ref21.code,category = _ref21.category; //
      if (this.amplitudeEnabled) {this.amplitude.sendJoinedBundle({ name: name, slug: slug, client_name: client_name, code: code, category: category });}if (this.gaEnabled) {this.ga.bundle_begin({ name: name, slug: slug, client_name: client_name, code: code, category: category });}} }, { key: "sendTrialReclaimed", value: function sendTrialReclaimed(_ref22) {var source = _ref22.source; //
      if (this.amplitudeEnabled) {this.amplitude.sendTrialReclaimed({ source: source });}} }, { key: "sendTrialRejected", value: function sendTrialRejected() {//
      if (this.amplitudeEnabled) {this.amplitude.sendTrialRejected();}} }, { key: "sendExtraPaymentBeginEvent", value: function sendExtraPaymentBeginEvent(data) {if (this.gaEnabled) {this.ga.purchase_extraBegin(data);}} }, { key: "sendExtraPaymentCompleteEvent", value: function sendExtraPaymentCompleteEvent(data) {if (this.gaEnabled) {this.ga.purchase_extraComplete(data);}} }, { key: "sendExtraPaymentFailedEvent", value: function sendExtraPaymentFailedEvent(data) {if (this.gaEnabled) {this.ga.purchase_extraFail(data);}} }]);return AnalyticsManager_;}();var manager_manager;function AnalyticsManager() {try {if (false) {}if (manager_manager) {return manager_manager;}manager_manager = new AnalyticsManager_();return manager_manager;} catch (ex) {esm_exports/* captureException */.Tb(ex);}}/* harmony default export */ var analytics_manager = (AnalyticsManager);

/***/ }),

/***/ 15049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ji": function() { return /* binding */ GET_VIDEO_SETTINGS; },
  "Rq": function() { return /* binding */ initApolloClient; },
  "cB": function() { return /* reexport */ policies/* videoSettingsModalOpenVar */.cB; },
  "FY": function() { return /* reexport */ policies/* videoSettingsVar */.FY; }
});

// UNUSED EXPORTS: apolloClient, createApolloClient

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71383);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(12922);
// EXTERNAL MODULE: ./node_modules/@apollo/client/core/ApolloClient.js + 8 modules
var ApolloClient = __webpack_require__(64096);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/@apollo/client/link/core/ApolloLink.js + 3 modules
var ApolloLink = __webpack_require__(86909);
// EXTERNAL MODULE: ./node_modules/zen-observable-ts/module.js
var zen_observable_ts_module = __webpack_require__(48216);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/context/index.js



function setContext(setter) {
    return new ApolloLink/* ApolloLink */.i(function (operation, forward) {
        var request = (0,tslib_es6/* __rest */._T)(operation, []);
        return new zen_observable_ts_module/* Observable */.y(function (observer) {
            var handle;
            var closed = false;
            Promise.resolve(request)
                .then(function (req) { return setter(req, operation.getContext()); })
                .then(operation.setContext)
                .then(function () {
                if (closed)
                    return;
                handle = forward(operation).subscribe({
                    next: observer.next.bind(observer),
                    error: observer.error.bind(observer),
                    complete: observer.complete.bind(observer),
                });
            })
                .catch(observer.error.bind(observer));
            return function () {
                closed = true;
                if (handle)
                    handle.unsubscribe();
            };
        });
    });
}
//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/apollo-upload-client/public/createUploadLink.js
var createUploadLink = __webpack_require__(89776);
var createUploadLink_default = /*#__PURE__*/__webpack_require__.n(createUploadLink);
// EXTERNAL MODULE: ./node_modules/next/dist/build/polyfills/fetch/index.js
var fetch = __webpack_require__(63144);
var fetch_default = /*#__PURE__*/__webpack_require__.n(fetch);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./lib/constants.tsx
var constants = __webpack_require__(22498);
// EXTERNAL MODULE: ./lib/apollo/policies/index.ts + 23 modules
var policies = __webpack_require__(54734);
;// CONCATENATED MODULE: ./lib/apollo/index.tsx
/* provided dependency */ var process = __webpack_require__(34155);
var _templateObject;function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,defineProperty/* default */.Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}









var GET_VIDEO_SETTINGS = (0,lib/* default */.ZP)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  query videoSettings {\n    videoSettings @client {\n      excludeTerms\n      contentLanguages\n      videoLevels\n    }\n  }\n"])));









var apolloClient = null;

/**
 * Creates and configures the ApolloClient
 * @param  {Object} [initialState={}]
 */

function createApolloClient(_ref)




{var initialState = _ref.initialState,lang = _ref.lang,_ref$cookies = _ref.cookies,cookies = _ref$cookies === void 0 ? null : _ref$cookies,_ref$api_url = _ref.api_url,api_url = _ref$api_url === void 0 ? null : _ref$api_url;
  var VERCEL_URL =  true ? "https://".concat(
  "yogobe-2ebx6r7su-yogobe.vercel.app") :
  0;

  var ENABLE_API = !['master', 'develop'].includes(
  "monssef/yog-3178-healthcare-page-feedback-2002");


  var API_URL = api_url;
  if (!api_url && ENABLE_API && !process.env.browser) {
    API_URL = VERCEL_URL + '/api';
  } else {
    API_URL = "https://devenv.yogobe.com/graphql";
  }

  var simpleHttpLink = new (createUploadLink_default())({
    uri: API_URL,
    credentials: 'same-origin',
    fetch: (fetch_default()) });


  var headersEnhancer = setContext(function (_, _ref2) {var headers = _ref2.headers;
    var language = lang;
    if (true) {
      language = (router_default()).query.lang;
    }

    return {
      headers: _objectSpread(_objectSpread({},
      headers), {}, {
        'Accept-Language': language || 'se' },


       false ?
      0 :

      {}) };


  });

  var httpEnahncedLink = headersEnhancer.concat(simpleHttpLink);

  var ssrMode = false;
  if (false) {}

  var client = new ApolloClient/* ApolloClient */.f({
    ssrMode: ssrMode, // Disables forceFetch on the server (so queries are only run once)
    link: httpEnahncedLink,
    cache: (0,policies/* getMemoryCache */.J3)({ initialState: initialState }, ssrMode),
    connectToDevTools: false });


  client.onResetStore(function () {
    return Promise.resolve((0,policies/* resetReactiveVars */.QC)());
  });

  return client;
}

/**
 * Always creates a new apollo client on the server
 * Creates or reuses apollo client in the browser.
 * @param  {Object} initialState
 */







function initApolloClient(params) {
  // Make sure to create a new client for every server-side request so that data
  // isn't shared between connections (which would be bad)
  if (false) {}

  // Reuse client on the client-side
  if (!apolloClient) {
    apolloClient = createApolloClient(params);
  }

  return apolloClient;
}

/***/ }),

/***/ 54734:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "J3": function() { return /* binding */ getMemoryCache; },
  "QC": function() { return /* binding */ resetReactiveVars; },
  "Ck": function() { return /* binding */ snackbarVar; },
  "cB": function() { return /* binding */ videoSettingsModalOpenVar; },
  "FY": function() { return /* binding */ videoSettingsVar; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(90116);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/@apollo/client/cache/inmemory/reactiveVars.js + 1 modules
var reactiveVars = __webpack_require__(9237);
// EXTERNAL MODULE: ./node_modules/@apollo/client/cache/inmemory/inMemoryCache.js + 6 modules
var inMemoryCache = __webpack_require__(55598);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/parse/index.js + 41 modules
var parse = __webpack_require__(35337);
// EXTERNAL MODULE: ./lib/helpers.ts
var helpers = __webpack_require__(32460);
;// CONCATENATED MODULE: ./lib/apollo/policies/programs/GenericProgram.ts



var genericFieldResolvers = {
  title: function title(_, _ref) {var readField = _ref.readField,toReference = _ref.toReference;
    var genericProgramRef = toReference({
      __typename: 'GenericProgram',
      slug: readField('slug') });

    return readField('title', genericProgramRef);
  },
  trailer: function trailer(_, _ref2) {var readField = _ref2.readField,toReference = _ref2.toReference;
    var genericProgramRef = toReference({
      __typename: 'GenericProgram',
      slug: readField('slug') });

    return readField('trailer', genericProgramRef);
  },
  language: function language(_, _ref3) {var readField = _ref3.readField,toReference = _ref3.toReference;
    var genericProgramRef = toReference({
      __typename: 'GenericProgram',
      slug: readField('slug') });

    return readField('language', genericProgramRef);
  },
  progress: function progress(_, _ref4) {var readField = _ref4.readField,toReference = _ref4.toReference;
    var genericProgramRef = toReference({
      __typename: 'GenericProgram',
      slug: readField('slug') });

    return readField('progress', genericProgramRef);
  },
  instructors: function instructors(_, _ref5) {var readField = _ref5.readField,toReference = _ref5.toReference;
    var genericProgramRef = toReference({
      __typename: 'GenericProgram',
      slug: readField('slug') });

    return readField('instructors', genericProgramRef);
  } };


/* harmony default export */ var GenericProgram = ({
  typePolicies: {
    GenericProgram: {
      keyFields: ['slug'],
      fields: {
        titleImageUrl: {
          merge: function merge(_, incoming) {
            return (0,helpers/* normalizeImagePath */.i6)(incoming);
          } } } } } });
;// CONCATENATED MODULE: ./lib/apollo/policies/programs/WeeklyProgram.ts
function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,defineProperty/* default */.Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}







function enhanceVideoObject(_ref) {var element = _ref.element,weekSlug = _ref.weekSlug,programSlug = _ref.programSlug;
  var _currentElement = _objectSpread({}, element);
  // we generate url to video, to make the navigation from the header card easy
  _currentElement.path = "".concat(programSlug, "/").concat(weekSlug, "/").concat(element.slug);
  return _currentElement;
}

/* harmony default export */ var WeeklyProgram = ({
  typePolicies: {
    WeeklyProgram: {
      keyFields: ['slug'],
      fields: _objectSpread(_objectSpread({},
      genericFieldResolvers), {}, {
        //
        currentElement: function currentElement(_, _ref2) {var _currentElement2, _currentElement3;var readField = _ref2.readField;
          var currentElement = null;
          readField('weeks').forEach(function (weekRef, weekIndex) {
            var elements = readField('elements', weekRef);
            var weekSlug = readField('slug', weekRef);
            var programSlug = readField('slug');

            // we find video marked as current
            var element = elements.find(function (element, elementIndex) {
              var progressIsCurrent = element.progressIsCurrent;
              if (weekIndex === 0 && elementIndex === 0) {
                // we set first video to be currentElement as fallback
                currentElement = enhanceVideoObject({
                  element: element,
                  weekSlug: weekSlug,
                  programSlug: programSlug });

              }

              if (progressIsCurrent) {
                return true;
              }
              return false;
            });

            // if video is found then we enhance the object with the needed data through out the components

            if (element) {
              currentElement = enhanceVideoObject({
                element: element,
                weekSlug: weekSlug,
                programSlug: programSlug });

            }
          });

          if (((_currentElement2 = currentElement) === null || _currentElement2 === void 0 ? void 0 : _currentElement2.__typename) === 'ProgramDocument') {
            return {
              title: currentElement.title,
              path: currentElement['path'] };

          } else if (((_currentElement3 = currentElement) === null || _currentElement3 === void 0 ? void 0 : _currentElement3.__typename) === 'ProgramVideo') {
            return {
              title:
              currentElement.customTitle ||
              currentElement.title ||
              readField('title', currentElement.video),
              path: currentElement['path'] };

          } else {
            return null;
          }
        },
        videosCount: function videosCount(_, _ref3) {var readField = _ref3.readField;
          var count = 0;
          readField('weeks').forEach(function (week) {
            count += readField('videosCount', week);
          });
          return count;
        },
        progress: function progress(_, _ref4) {var readField = _ref4.readField;
          var weeks = readField('weeks');
          var totalProgress = weeks.reduce(function (total, week) {
            var progress = readField(
            'progress',
            week);

            return total + progress;
          }, 0);
          return parseInt((totalProgress / weeks.length).toString());
        } }) },


    ProgramWeek: {
      fields: {
        progress: {
          merge: function merge(_, incoming) {
            return parseFloat(Math.round(incoming).toString());
          } },

        videosCount: function videosCount(_, _ref5) {var readField = _ref5.readField;
          return (
            (readField('elements') || []).filter(
            function (element) {return element.__typename === 'ProgramVideo';}).
            length || null);

        },
        duration: function duration(_, _ref6) {var readField = _ref6.readField;
          var elements = readField('elements');
          var totalMinutes = elements.reduce(
          function (total, element) {
            if (element.__typename === 'ProgramVideo') {
              var videoMeta = readField('meta', element.video);
              return total + (videoMeta === null || videoMeta === void 0 ? void 0 : videoMeta.minutes);
            }
            return total;
          },
          0);

          var hours = Math.trunc(totalMinutes / 60);
          var minutes = totalMinutes % 60;
          return (
            (hours > 0 ? "".concat(hours, "H") : '') + (
            minutes > 0 ? "".concat(minutes, "Min") : ''));

        } } },


    ProgramDocument: {
      keyFields: false } } });
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71383);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(12922);
;// CONCATENATED MODULE: ./lib/apollo/policies/programs/PhaseProgram.ts
var _templateObject;function PhaseProgram_ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function PhaseProgram_objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? PhaseProgram_ownKeys(Object(source), !0).forEach(function (key) {(0,defineProperty/* default */.Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PhaseProgram_ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}



// TODO: find a way to cache some of these calculations..
// NOTE: most of them dont re-execute often so there is not much impact on performace... unlike in component data enhancers..

/* harmony default export */ var PhaseProgram = ({
  typePolicies: {
    PhasedProgram: {
      keyFields: ['slug'],
      fields: PhaseProgram_objectSpread(PhaseProgram_objectSpread({},
      genericFieldResolvers), {}, {
        //
        preSurvey: function preSurvey(_, _ref) {var readField = _ref.readField,toReference = _ref.toReference;
          var genericProgramRef = toReference({
            __typename: 'GenericProgram',
            slug: readField('slug') });

          return readField('preSurvey', genericProgramRef);
        },
        postSurvey: function postSurvey(_, _ref2) {var readField = _ref2.readField,toReference = _ref2.toReference;
          var genericProgramRef = toReference({
            __typename: 'GenericProgram',
            slug: readField('slug') });

          return readField('postSurvey', genericProgramRef);
        },
        weeksCount: function weeksCount(_, _ref3) {var readField = _ref3.readField;
          var phases = readField('phases');
          return phases.reduce(
          function (total, phaseRef) {return total + readField('weeksCount', phaseRef);},
          0);

        },
        phasesCount: function phasesCount(_, _ref4) {var _phases$phases;var readField = _ref4.readField;
          var phases = readField('phases');
          return (phases === null || phases === void 0 ? void 0 : (_phases$phases = phases.phases) === null || _phases$phases === void 0 ? void 0 : _phases$phases.length) || null;
        },
        videosCount: function videosCount(_, _ref5) {var readField = _ref5.readField;
          var phases = readField('phases');
          return phases.reduce(
          function (total, phaseRef) {return total + readField('videosCount', phaseRef);},
          0);

        },
        currentVideo: function currentVideo(_, _ref6) {var readField = _ref6.readField;
          var currentVideo = null;
          readField('phases').forEach(function (phaseRef) {
            if (!readField('locked', phaseRef) && !currentVideo) {
              var weeks = readField('weeks', phaseRef);
              var phaseSlug = readField('slug', phaseRef);
              // we find video marked as current
              var videoWeek = weeks.find(function (week) {
                if (!currentVideo) {
                  var videos = readField('videos', week);
                  currentVideo = videos.find(function (_ref7) {var progressIsCurrent = _ref7.progressIsCurrent;
                    if (progressIsCurrent) {
                      return true;
                    }
                    return false;
                  });

                  // for not wasting anytime we use find so we can stopt it
                  // once the video is found
                  return currentVideo;
                }
                return false;
              });

              // if video is found then we enhance the object with the needed data through out the components
              if (currentVideo) {
                currentVideo = PhaseProgram_objectSpread({}, currentVideo);
                var programSlug = readField('slug');
                // we generate url to video, to make the navigation from the header card easy
                currentVideo.path = "programs/".concat(programSlug, "/").concat(phaseSlug, "/").concat(videoWeek.slug, "/").concat(currentVideo.slug);
              }
            }
          });

          return currentVideo;
        },
        phases: {
          merge: function merge(_, incoming, _ref8) {var readField = _ref8.readField,cache = _ref8.cache;
            var WeekIndexFragment = (0,lib/* default */.ZP)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n              fragment WeekProgramIndex on ProgramWeek {\n                indexInProgram\n              }\n            "])));




            var weekCount = 1;
            incoming.forEach(function (phaseRef) {
              readField('weeks', phaseRef).forEach(function (week) {
                cache.writeFragment({
                  id: cache.identify(week),
                  fragment: WeekIndexFragment,
                  data: {
                    indexInProgram: weekCount++ } });


              });
            });
            return incoming;
          } } }) },



    ProgramPhase: {
      fields: {
        weeksCount: function weeksCount(_, _ref9) {var _readField;var readField = _ref9.readField;
          return ((_readField = readField('weeks')) === null || _readField === void 0 ? void 0 : _readField.length) || null;
        },
        weeksRange: function weeksRange(_, _ref10) {var readField = _ref10.readField,toReference = _ref10.toReference,_ref10$variables = _ref10.variables,variables = _ref10$variables === void 0 ? {} : _ref10$variables;
          var phaseID = readField('id');
          var phases = readField(
          'phases',
          toReference({
            __typename: 'PhasedProgram',
            slug: variables['slug'] }));


          return (
            phases.reduce(
            function (acc, phaseRef) {
              var weeks = readField('weeks', phaseRef);
              var id = readField('id', phaseRef);
              var offset = acc.offset;
              acc.ranges[id] = "".concat(offset, " - ").concat(offset + weeks.length - 1);
              acc.offset += weeks.length;
              return acc;
            },
            { ranges: {}, offset: 1 }).
            ranges[phaseID] || null);

        },
        videosCount: function videosCount(_, _ref11) {var readField = _ref11.readField;
          var weeks = readField('weeks');
          return (
            weeks.reduce(function (acc, week) {
              var videos = readField('videos', week);
              return acc + videos.length;
            }, 0) || null);

        },
        videosDuration: function videosDuration(_, _ref12) {var readField = _ref12.readField;
          var weeks = readField('weeks');
          var totalMinutes = weeks.reduce(function (acc, week) {
            var videos = readField('videos', week);
            return acc += videos.reduce(
            function (totalMinutes, _ref13) {var videoRef = _ref13.video;
              var meta = readField('meta', videoRef);
              return totalMinutes + (meta === null || meta === void 0 ? void 0 : meta.minutes);
            },
            0);

          }, 0);

          var hours = Math.trunc(totalMinutes / 60);
          var minutes = totalMinutes % 60;
          return "".concat(hours, "H ").concat(minutes, "Min");
        } } } } });
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isFuture/index.js
var isFuture = __webpack_require__(82644);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isPast/index.js
var isPast = __webpack_require__(33913);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isValid/index.js + 1 modules
var isValid = __webpack_require__(61436);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(19013);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(13882);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/compareAsc/index.js


/**
 * @name compareAsc
 * @category Common Helpers
 * @summary Compare the two dates and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return 1 if the first date is after the second,
 * -1 if the first date is before the second or 0 if dates are equal.
 *
 * @param {Date|Number} dateLeft - the first date to compare
 * @param {Date|Number} dateRight - the second date to compare
 * @returns {Number} the result of the comparison
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989:
 * const result = compareAsc(new Date(1987, 1, 11), new Date(1989, 6, 10))
 * //=> -1
 *
 * @example
 * // Sort the array of dates:
 * const result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareAsc)
 * //=> [
 * //   Wed Feb 11 1987 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Sun Jul 02 1995 00:00:00
 * // ]
 */

function compareAsc(dirtyDateLeft, dirtyDateRight) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var dateLeft = (0,toDate/* default */.Z)(dirtyDateLeft);
  var dateRight = (0,toDate/* default */.Z)(dirtyDateRight);
  var diff = dateLeft.getTime() - dateRight.getTime();

  if (diff < 0) {
    return -1;
  } else if (diff > 0) {
    return 1; // Return 0 if diff is 0; return NaN if diff is NaN
  } else {
    return diff;
  }
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/compareDesc/index.js


/**
 * @name compareDesc
 * @category Common Helpers
 * @summary Compare the two dates reverse chronologically and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return -1 if the first date is after the second,
 * 1 if the first date is before the second or 0 if dates are equal.
 *
 * @param {Date|Number} dateLeft - the first date to compare
 * @param {Date|Number} dateRight - the second date to compare
 * @returns {Number} the result of the comparison
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989 reverse chronologically:
 * const result = compareDesc(new Date(1987, 1, 11), new Date(1989, 6, 10))
 * //=> 1
 *
 * @example
 * // Sort the array of dates in reverse chronological order:
 * const result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareDesc)
 * //=> [
 * //   Sun Jul 02 1995 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Wed Feb 11 1987 00:00:00
 * // ]
 */

function compareDesc(dirtyDateLeft, dirtyDateRight) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var dateLeft = (0,toDate/* default */.Z)(dirtyDateLeft);
  var dateRight = (0,toDate/* default */.Z)(dirtyDateRight);
  var diff = dateLeft.getTime() - dateRight.getTime();

  if (diff > 0) {
    return -1;
  } else if (diff < 0) {
    return 1; // Return 0 if diff is 0; return NaN if diff is NaN
  } else {
    return diff;
  }
}
;// CONCATENATED MODULE: ./lib/apollo/policies/CurrentUser.ts
var _excluded = ["accessUntil"],_excluded2 = ["accessUntil"];function CurrentUser_ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function CurrentUser_objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? CurrentUser_ownKeys(Object(source), !0).forEach(function (key) {(0,defineProperty/* default */.Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CurrentUser_ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}






var CurrentUserPolicy = {
  typePolicies: {
    CurrentUser: {
      fields: {
        accessUntil: function accessUntil(_accessUntil2) {
          if (_accessUntil2 instanceof Date) {
            return _accessUntil2;
          }
          return (0,parse/* default */.Z)(_accessUntil2, 'yyyy-MM-dd', new Date());
        },
        hasWellness: function hasWellness(_, _ref) {var _receipts$;var readField = _ref.readField;
          var receipts = readField('receipts');
          var userUsedWellness = ['benify', 'wellness'].includes(
          receipts === null || receipts === void 0 ? void 0 : (_receipts$ = receipts[0]) === null || _receipts$ === void 0 ? void 0 : _receipts$.paymentType);

          return userUsedWellness;
        },
        isPremium: function isPremium(_, _ref2) {var readField = _ref2.readField;
          var accessUntil = readField('accessUntil');
          return (0,isFuture/* default */.Z)(new Date(accessUntil));
        },
        isNoneTrialPremium: function isNoneTrialPremium(_, _ref3) {var readField = _ref3.readField;
          var isPremium = readField('isPremium');
          var subscription = readField(
          'subscription');


          return isPremium && !(subscription !== null && subscription !== void 0 && subscription.inTrialPeriod);
        },
        liveEventsAccess: {
          merge: function merge(_, coming, _ref4) {var readField = _ref4.readField;
            return coming.sort(function (a, b) {
              var A_eventDate = new Date(
              readField('eventDates', a['liveEvent'])[0]);

              var B_eventDate = new Date(
              readField('eventDates', b['liveEvent'])[0]);

              if ((0,isFuture/* default */.Z)(A_eventDate) && (0,isFuture/* default */.Z)(B_eventDate)) {
                // if both events are upcoming we sort them ASC
                return compareAsc(A_eventDate, B_eventDate);
              } else {
                return compareDesc(A_eventDate, B_eventDate);
              }
            });
          } },

        programAccess: {
          read: function read(value, _ref5) {var readField = _ref5.readField;
            var userAccess = readField('accessUntil');
            return (0,toConsumableArray/* default */.Z)(value || []).map(function (_ref6) {var accessUntil = _ref6.accessUntil,otherField = (0,objectWithoutProperties/* default */.Z)(_ref6, _excluded);
              // convert accessUntil from unix timestamp to Date
              var acessUntil = new Date(parseInt(accessUntil) * 1000);
              return CurrentUser_objectSpread(CurrentUser_objectSpread({},
              otherField), {}, {
                accessUntil: (0,isValid/* default */.Z)(acessUntil) ? acessUntil : userAccess });

            });
            // .sort((a, b) => {
            //   const date1 = new Date(
            //     parseInt(readField('accessUntil', a)) * 1000
            //   );
            //   const date2 = new Date(
            //     parseInt(readField('accessUntil', b)) * 1000
            //   );
            //   if (isPast(date1) && !isPast(date2)) {
            //     return 1;
            //   } else if (isPast(date2) && !isPast(date1)) {
            //     return -1;
            //   } else {
            //     return 0;
            //   }
            // });
          } },

        courseAccesses: {
          read: function read(value, _ref7) {var readField = _ref7.readField;
            return (0,toConsumableArray/* default */.Z)(value || []).
            filter(function (item) {
              return !readField('legacy', item.course);
            }).
            map(function (_ref8) {var accessUntil = _ref8.accessUntil,otherField = (0,objectWithoutProperties/* default */.Z)(_ref8, _excluded2);
              // convert accessUntil from unix timestamp to Date
              var _accessUntil = new Date(parseInt(accessUntil) * 1000);

              return CurrentUser_objectSpread(CurrentUser_objectSpread({},
              otherField), {}, {
                accessUntil: (0,isValid/* default */.Z)(_accessUntil) ?
                _accessUntil :
                new Date(1, 1, 1990) });

            }).
            sort(function (a, b) {
              var date1 = a.accessUntil;
              var date2 = b.accessUntil;
              if ((0,isPast/* default */.Z)(date1) && !(0,isPast/* default */.Z)(date2)) {
                return -1;
              } else if ((0,isPast/* default */.Z)(date2) && !(0,isPast/* default */.Z)(date1)) {
                return 1;
              } else {
                return 0;
              }
            });
          } } } } } };






/* harmony default export */ var CurrentUser = (CurrentUserPolicy);
;// CONCATENATED MODULE: ./lib/apollo/policies/LiveEventAccess.ts
var LiveEventAccessPolicy = {
  typePolicies: {
    LiveEventAccess: {
      fields: {
        zoomLink: {
          merge: function merge(_, incoming) {
            var path = incoming;
            if (!String(path).startsWith('/')) {
              path = "/".concat(path);
            }

            return 'https://zoom.us' + path;
          } } } } } };






/* harmony default export */ var LiveEventAccess = (LiveEventAccessPolicy);
;// CONCATENATED MODULE: ./lib/apollo/policies/LiveEvent.ts


function isExpired(_, _ref) {var readField = _ref.readField;
  var registrationEndDate = readField('registrationEndDate');
  var bookingAvailable = readField('bookingAvailable');
  var expiredEvent =
  (0,isPast/* default */.Z)(new Date(registrationEndDate)) || !bookingAvailable;
  return expiredEvent;
}

function isComingSoon(_, _ref2) {var readField = _ref2.readField;
  var registrationStartDate = readField('registrationStartDate');
  var expiredEvent = readField('expiredEvent');
  var comingSoonEvent =
  !expiredEvent && (0,isFuture/* default */.Z)(new Date(registrationStartDate));
  return comingSoonEvent;
}

var liveEventPolicy = {
  typePolicies: {
    LiveEvent: {
      fields: {
        isExpired: isExpired,
        isComingSoon: isComingSoon,
        instructors: function instructors(_, _ref3) {var readField = _ref3.readField;
          var instructors = [];
          var primaryInstructor = readField('primaryInstructor');
          var otherInstructors = readField('otherInstructors');

          if (primaryInstructor) {
            instructors.push(primaryInstructor);
          }

          if (otherInstructors) {
            instructors.push.apply(instructors, (0,toConsumableArray/* default */.Z)(otherInstructors));
          }

          return instructors;
        } } } } };





var searchliveEventPolicy = {
  typePolicies: {
    SearchLiveEvent: {
      fields: {
        price: function price() {
          return null;
        },
        isExpired: isExpired,
        isComingSoon: isComingSoon } } } };
// EXTERNAL MODULE: ./lib/constants.tsx
var constants = __webpack_require__(22498);
;// CONCATENATED MODULE: ./lib/apollo/policies/Playlist.ts



var PlaylistPolicy = {
  typePolicies: {
    Playlist: {
      fields: {
        videos: {
          read: function read(videos, _ref) {var readField = _ref.readField;
            return (videos || []).filter(function (ref) {
              var identifier = readField('identifier', ref);
              return identifier !== constants/* VIDEO_NOT_FOUND_KEY */.vt;
            });
          } },

        thumbnailUrl: {
          merge: function merge(_, incoming) {
            return (0,helpers/* normalizeImagePath */.i6)(incoming);
          } } } } } };






/* harmony default export */ var Playlist = (PlaylistPolicy);
;// CONCATENATED MODULE: ./lib/apollo/policies/PlaylistAssets.ts


var PlaylistAssets = {
  typePolicies: {
    PlaylistAssets: {
      fields: {
        thumbnailUrl: {
          merge: function merge(_, incoming) {
            return (0,helpers/* normalizeImagePath */.i6)(incoming);
          } } } } } };






/* harmony default export */ var policies_PlaylistAssets = (PlaylistAssets);
;// CONCATENATED MODULE: ./lib/apollo/policies/Term.tsx


var Term = {
  typePolicies: {
    Term: {
      fields: {
        titleImageUrl: {
          merge: function merge(_, incoming) {
            return (0,helpers/* normalizeImagePath */.i6)(incoming);
          } } } } } };






/* harmony default export */ var policies_Term = (Term);
;// CONCATENATED MODULE: ./lib/apollo/policies/PagedVideos.ts
function PagedVideos_ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function PagedVideos_objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? PagedVideos_ownKeys(Object(source), !0).forEach(function (key) {(0,defineProperty/* default */.Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PagedVideos_ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}var PagedVideos = {
  typePolicies: {
    PagedVideos: {
      merge: function merge(existing, incoming) {
        if (!existing) {
          return incoming;
        } else if ((existing === null || existing === void 0 ? void 0 : existing.page) >= (incoming === null || incoming === void 0 ? void 0 : incoming.page)) {
          return existing;
        } else {
          return PagedVideos_objectSpread(PagedVideos_objectSpread({},
          incoming), {}, {
            data: [].concat((0,toConsumableArray/* default */.Z)(existing === null || existing === void 0 ? void 0 : existing.data), (0,toConsumableArray/* default */.Z)(incoming === null || incoming === void 0 ? void 0 : incoming.data)) });

        }
      } } } };




/* harmony default export */ var policies_PagedVideos = (PagedVideos);
;// CONCATENATED MODULE: ./lib/apollo/policies/programs/Program.ts


var ProgramPolicy = {
  typePolicies: {
    Program: {
      fields: {
        titleImageUrl: {
          merge: function merge(_, incoming) {
            return (0,helpers/* normalizeImagePath */.i6)(incoming);
          } },

        lede: function lede(value, _ref) {var readField = _ref.readField;
          return value || readField('shortDescription') || '';
        } } } } };





/* harmony default export */ var Program = (ProgramPolicy);
;// CONCATENATED MODULE: ./lib/apollo/policies/PageAssets.ts


var PageAssetsPolicy = {
  typePolicies: {
    PageAssets: {
      fields: {
        titleImage: {
          merge: function merge(_, incoming) {
            return (0,helpers/* normalizeImagePath */.i6)(incoming);
          } },

        externalImage: {
          merge: function merge(_, incoming) {
            return (0,helpers/* normalizeImagePath */.i6)(incoming);
          } },

        internalImage: {
          merge: function merge(_, incoming) {
            return (0,helpers/* normalizeImagePath */.i6)(incoming);
          } } } } } };






/* harmony default export */ var PageAssets = (PageAssetsPolicy);
;// CONCATENATED MODULE: ./lib/apollo/policies/BlogPost.ts


var BlogPostPolicy = {
  typePolicies: {
    BlogPost: {
      fields: {
        featuredImage: {
          merge: function merge(_, incoming) {
            return (0,helpers/* normalizeImagePath */.i6)(incoming);
          } } } } } };






/* harmony default export */ var BlogPost = (BlogPostPolicy);
;// CONCATENATED MODULE: ./lib/apollo/policies/InstructorAssets.ts
function InstructorAssets_ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function InstructorAssets_objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? InstructorAssets_ownKeys(Object(source), !0).forEach(function (key) {(0,defineProperty/* default */.Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : InstructorAssets_ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}

var InstructorAssetsPolicy = {
  typePolicies: {
    InstructorAssets: {
      // for some reason read functions on fields is not called & its caused next/image to throw..
      merge: function merge(existing, incoming) {
        var fields = ['externalImage', 'squareImage', 'titleImage'];

        var data = InstructorAssets_objectSpread({},
        incoming);

        fields.forEach(function (field) {
          if (data[field]) {
            data[field] = (0,helpers/* normalizeImagePath */.i6)(data[field]);
          }
        });

        return InstructorAssets_objectSpread(InstructorAssets_objectSpread({}, existing), data);
      } } } };




/* harmony default export */ var InstructorAssets = (InstructorAssetsPolicy);
;// CONCATENATED MODULE: ./lib/apollo/policies/Video.ts


var Video = {
  typePolicies: {
    Video: {
      merge: function merge(existing, incoming, _ref) {var mergeObjects = _ref.mergeObjects;
        return mergeObjects(existing, incoming);
      },
      fields: {
        thumbnailUrl: {
          merge: function merge(_, incoming) {
            return (0,helpers/* normalizeImagePath */.i6)(incoming);
          } },

        thumbnailUrlMedium: {
          merge: function merge(_, incoming) {
            return (0,helpers/* normalizeImagePath */.i6)(incoming);
          } },

        // IDK if apollo merges nested fields
        // but they do call merge on all fields when the whole parent object is merged with merge function
        assets: {
          merge: function merge(existing, incoming, _ref2) {var mergeObjects = _ref2.mergeObjects;
            return mergeObjects(existing, incoming);
          } },

        cursorAt: function cursorAt() {
          // disable cursorAt field
          return 0;
        },
        meta: {
          merge: function merge(existing, incoming, _ref3) {var mergeObjects = _ref3.mergeObjects;
            return mergeObjects(existing, incoming);
          } },

        content: {
          merge: function merge(existing, incoming, _ref4) {var mergeObjects = _ref4.mergeObjects;
            return mergeObjects(existing, incoming);
          } } } } } };






/* harmony default export */ var policies_Video = (Video);
;// CONCATENATED MODULE: ./lib/apollo/policies/ProgramVideo.ts
var ProgramVideo = {
  typePolicies: {
    ProgramVideo: {
      // for some reason TS doesnt like just false
      keyFields: false,
      fields: {
        title: function title(_title, _ref) {var readField = _ref.readField;
          var customTitle = readField('customTitle');
          return customTitle || _title;
        } } } } };





/* harmony default export */ var policies_ProgramVideo = (ProgramVideo);
;// CONCATENATED MODULE: ./lib/apollo/policies/Course.ts


var CoursePolicy = {
  typePolicies: {
    Course: {
      fields: {
        titleImageUrl: {
          merge: function merge(_, incoming) {
            return (0,helpers/* normalizeImagePath */.i6)(incoming);
          } },

        externalImageUrl: {
          merge: function merge(_, incoming) {
            return (0,helpers/* normalizeImagePath */.i6)(incoming);
          } } } } } };






/* harmony default export */ var Course = (CoursePolicy);
;// CONCATENATED MODULE: ./lib/apollo/policies/AvailableSubscriptionPlan.ts


var AvailableSubscriptionPlan = {
  typePolicies: {
    AvailableSubscriptionPlan: {
      fields: {
        subscriptions: function subscriptions(_subscriptions, ctx) {
          var variables = ctx.variables;
          if (variables['_filter_subscriptions_'] === false) {
            return _subscriptions;
          }
          // if a promotion is available we want to exclude its related original none-promotion subscription
          // example: remove original quarterly in-favore of quarterly discount
          var filteredSubs = _subscriptions.reduce(
          function (acc, subscription) {
            var key = subscription.subscriptionPlan;
            if (
            subscription.promotionKind &&
            ![
            'global',
            'subscription_discount_code',
            'subscription_full_access_code'].
            includes(subscription.promotionKind))
            {
              key = subscription.promotionName;
            }
            acc[key] = subscription;

            return acc;
          },
          {});


          // sort subs
          return Object.values(filteredSubs).sort(
          function (a, b) {
            return a.months - b.months;
          });

        } } } } };





/* harmony default export */ var policies_AvailableSubscriptionPlan = (AvailableSubscriptionPlan);
;// CONCATENATED MODULE: ./lib/apollo/policies/VideoAssets.ts


var videoAssetsPolicy = {
  typePolicies: {
    VideoAssets: {
      fields: {
        thumbnailUrl: {
          merge: function merge(_, incoming) {
            return (0,helpers/* normalizeImagePath */.i6)(incoming);
          } },

        thumbnailUrlMedium: {
          merge: function merge(_, incoming) {
            return (0,helpers/* normalizeImagePath */.i6)(incoming);
          } } } } } };






/* harmony default export */ var VideoAssets = (videoAssetsPolicy);
;// CONCATENATED MODULE: ./lib/apollo/policies/Document.ts
var DocumentPolicy = {
  typePolicies: {
    Document: {
      fields: {
        name: {
          merge: function merge(_, incoming) {
            var name = String(incoming).
            split('/').
            reverse()[0];
            return name.replace(/[-_]/g, ' ');
          } } } } } };






/* harmony default export */ var Document = (DocumentPolicy);
;// CONCATENATED MODULE: ./lib/apollo/policies/Bundle.ts




var BundlePolicy = {
  typePolicies: {
    BundleItem: {
      fields: {
        promotionalImage: helpers/* normalizeImagePath */.i6,
        heroImage: helpers/* normalizeImagePath */.i6,
        liveEvents: {
          read: function read(value, _ref) {var readField = _ref.readField;
            return (0,toConsumableArray/* default */.Z)(value).sort(function (a, b) {
              var A_eventDate = new Date(readField('eventDates', a)[0]);
              var B_eventDate = new Date(readField('eventDates', b)[0]);
              var A_isExpired = readField('isExpired', a);
              var B_isExpired = readField('isExpired', b);
              if (!A_isExpired && B_isExpired) {
                return -1;
              } else if (!B_isExpired) {
                return 1;
              } else if ((0,isFuture/* default */.Z)(A_eventDate) && (0,isFuture/* default */.Z)(B_eventDate)) {
                // if both events are upcoming we sort them ASC
                return compareAsc(A_eventDate, B_eventDate);
              } else {
                return compareDesc(A_eventDate, B_eventDate);
              }
            });
          } } } } } };






/* harmony default export */ var Bundle = (BundlePolicy);
;// CONCATENATED MODULE: ./lib/apollo/policies/index.ts
function policies_ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function policies_objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? policies_ownKeys(Object(source), !0).forEach(function (key) {(0,defineProperty/* default */.Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : policies_ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}




















// import SearchPolicy from './Search';


















var snackbarVar = (0,reactiveVars/* makeVar */.QS)({
  isSnackBarOpen: false });


var videoSettingsModalOpenVar = (0,reactiveVars/* makeVar */.QS)(false);

var videoSettingsVar = (0,reactiveVars/* makeVar */.QS)({
  excludeTerms: [],
  contentLanguages: ['en', 'se', 'fi', 'no'],
  videoLevels: [] });


var resetReactiveVars = function resetReactiveVars() {
  // reset video settings
  videoSettingsVar({
    excludeTerms: [],
    contentLanguages: ['en', 'se', 'fi', 'no'],
    videoLevels: [] });


  // reset video setting modal
  videoSettingsModalOpenVar(false);

  // reset snackbar
  snackbarVar({
    isSnackBarOpen: false });

};

/*
  ****** BIG NOTE ******
  if @client field resolves to undefined or resolver doesn't exist in field-policies
  --> THE WHOLE QUERY WILL FAIL
  *********************
*/
var cache;
var getMemoryCache = function getMemoryCache()


{var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},_ref$initialState = _ref.initialState,initialState = _ref$initialState === void 0 ? {} : _ref$initialState;var ssr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (cache && !ssr) {
    return cache;
  }

  cache = new inMemoryCache/* InMemoryCache */.h({
    typePolicies: policies_objectSpread(policies_objectSpread(policies_objectSpread(policies_objectSpread(policies_objectSpread(policies_objectSpread(policies_objectSpread(policies_objectSpread(policies_objectSpread(policies_objectSpread(policies_objectSpread(policies_objectSpread(policies_objectSpread(policies_objectSpread(policies_objectSpread(policies_objectSpread(policies_objectSpread(policies_objectSpread(policies_objectSpread(policies_objectSpread(policies_objectSpread(policies_objectSpread(policies_objectSpread({
      Taxonomy: { keyFields: false },
      TaxonomyItem: {
        fields: {
          terms: {
            merge: function merge(_, incoming) {
              return incoming;
            } } } },



      MoodTracker: { keyFields: false },
      ProgramSurvey: { keyFields: false },
      Instructor: { keyFields: false },
      PhasedProgram: { keyFields: ['slug'] },
      LiveEvent: { keyFields: ['slug'] },
      User: {
        fields: {
          accessUntil: {
            merge: function merge(_, accessUntil) {
              return (0,parse/* default */.Z)(accessUntil, 'yyyy-MM-dd', new Date());
            } } } } },



    InstructorAssets.typePolicies),
    policies_PagedVideos.typePolicies),
    policies_Term.typePolicies),
    PageAssets.typePolicies),
    VideoAssets.typePolicies),
    Program.typePolicies),
    GenericProgram.typePolicies),
    Course.typePolicies),
    PhaseProgram.typePolicies),
    WeeklyProgram.typePolicies),
    policies_ProgramVideo.typePolicies),
    CurrentUser.typePolicies),
    policies_Video.typePolicies),
    liveEventPolicy.typePolicies),
    searchliveEventPolicy.typePolicies),
    LiveEventAccess.typePolicies),
    Playlist.typePolicies),
    policies_PlaylistAssets.typePolicies),
    BlogPost.typePolicies),
    policies_AvailableSubscriptionPlan.typePolicies),

    Document.typePolicies),
    Bundle.typePolicies), {}, {
      Query: {
        fields: {
          myBundles: {
            keyArgs: [],
            merge: function merge(existing, coming) {
              return policies_objectSpread(policies_objectSpread({},
              coming), {}, {
                page: coming.page,
                data: [].concat((0,toConsumableArray/* default */.Z)((existing === null || existing === void 0 ? void 0 : existing.data) || []), (0,toConsumableArray/* default */.Z)(coming.data)) });

            } },

          videos: {
            keyArgs: [
            'taxonomies',
            'perPage',
            'genre',
            'query',
            'useLocale',
            'contentLanguages',
            'excludeTerms',
            'videoLevels',
            'orderBy'] },


          getFavoriteVideos: {
            keyArgs: ['id'] },

          getFavoritePlaylists: {
            keyArgs: ['id'] },

          snackbar: function snackbar() {
            return snackbarVar();
          },
          isVideoSettingsModalOpen: function isVideoSettingsModalOpen() {
            return videoSettingsModalOpenVar();
          },
          videoSettings: function videoSettings() {
            return videoSettingsVar();
          },
          liveEvents: {
            keyArgs: [],
            merge: function merge(existing, coming) {
              return policies_objectSpread(policies_objectSpread({},
              coming), {}, {
                page: coming.page,
                data: [].concat((0,toConsumableArray/* default */.Z)((existing === null || existing === void 0 ? void 0 : existing.data) || []), (0,toConsumableArray/* default */.Z)(coming.data)) });

            } },

          specificSearch: {
            keyArgs: ['query', 'languages', 'modelType'],
            merge: function merge(existing, coming) {
              return Object.keys(coming).reduce(function (merged, key) {var _coming$key, _coming$key2, _existing$key;
                if (
                ((_coming$key = coming[key]) === null || _coming$key === void 0 ? void 0 : _coming$key.__typename) === 'SearchResults' &&
                (coming === null || coming === void 0 ? void 0 : (_coming$key2 = coming[key]) === null || _coming$key2 === void 0 ? void 0 : _coming$key2.page) > (existing === null || existing === void 0 ? void 0 : (_existing$key = existing[key]) === null || _existing$key === void 0 ? void 0 : _existing$key.page))
                {var _existing$key$results, _existing$key2, _coming$key$results, _coming$key3;
                  merged[key] = policies_objectSpread(policies_objectSpread({},
                  coming[key]), {}, {
                    results: [].concat((0,toConsumableArray/* default */.Z)((_existing$key$results =
                    existing === null || existing === void 0 ? void 0 : (_existing$key2 = existing[key]) === null || _existing$key2 === void 0 ? void 0 : _existing$key2.results) !== null && _existing$key$results !== void 0 ? _existing$key$results : []), (0,toConsumableArray/* default */.Z)((_coming$key$results =
                    coming === null || coming === void 0 ? void 0 : (_coming$key3 = coming[key]) === null || _coming$key3 === void 0 ? void 0 : _coming$key3.results) !== null && _coming$key$results !== void 0 ? _coming$key$results : [])) });


                } else {
                  merged[key] = coming[key];
                }
                return merged;
              }, {});
            } },

          genericPrograms: {
            keyArgs: [
            'query',
            'languages',
            'instructor',
            'sort',
            'theme',
            'category',
            'tags'],

            merge: function merge(existing, coming) {
              var exitingPrograms = (existing === null || existing === void 0 ? void 0 : existing.data) || [];
              var newPrograms = (coming === null || coming === void 0 ? void 0 : coming.data) || [];
              return policies_objectSpread(policies_objectSpread({},
              coming || {}), {}, {
                data: [].concat((0,toConsumableArray/* default */.Z)(exitingPrograms), (0,toConsumableArray/* default */.Z)(newPrograms)) });

            } } } } }) }).




  restore(initialState);

  return cache;
};

/***/ }),

/***/ 22498:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BA": function() { return /* binding */ ProgramCategoryNames; },
/* harmony export */   "DP": function() { return /* binding */ PROGRAMS_PAGE_SLUG; },
/* harmony export */   "Eo": function() { return /* binding */ SUMMER_CHALLENGE_LINK; },
/* harmony export */   "FG": function() { return /* binding */ ANDROID_APP_LINK; },
/* harmony export */   "GX": function() { return /* binding */ IOS_MOBILE_SUBSCRIPTION; },
/* harmony export */   "G_": function() { return /* binding */ IOS_APP_LINK; },
/* harmony export */   "Gd": function() { return /* binding */ HEALTHCARE_PAGE_SLUG; },
/* harmony export */   "Mz": function() { return /* binding */ HEADER_HEIGHT; },
/* harmony export */   "O9": function() { return /* binding */ SOMMER_SPECIAL_TYPE; },
/* harmony export */   "OD": function() { return /* binding */ VIDEOS_COUNT; },
/* harmony export */   "Op": function() { return /* binding */ ENABLED_LOCALS; },
/* harmony export */   "Q0": function() { return /* binding */ REF_BUNDLE; },
/* harmony export */   "Qe": function() { return /* binding */ SUMMER_CHALLENGE_PROGRAMS; },
/* harmony export */   "TD": function() { return /* binding */ AUTH_REFRESH_TOKEN; },
/* harmony export */   "T_": function() { return /* binding */ CHALLENGE_PROGRAMS; },
/* harmony export */   "Th": function() { return /* binding */ SEARCH_CATEGORY_NAMES; },
/* harmony export */   "U3": function() { return /* binding */ DISABLED_PROGRAMS; },
/* harmony export */   "UA": function() { return /* binding */ AUTH_TOKEN; },
/* harmony export */   "V7": function() { return /* binding */ DASHBOARD_PLAYLISTS_CATEGORY_ID; },
/* harmony export */   "Xy": function() { return /* binding */ SUPPORT_EMAIL; },
/* harmony export */   "Yb": function() { return /* binding */ VIDEOS_GENRES_ID; },
/* harmony export */   "_g": function() { return /* binding */ programTypes; },
/* harmony export */   "_p": function() { return /* binding */ DASHBOARD_BOTTOM_PADDING_SECTION; },
/* harmony export */   "bU": function() { return /* binding */ VERIFICATION_EMAIL_SENT; },
/* harmony export */   "be": function() { return /* binding */ CONTACT_EMAIL; },
/* harmony export */   "c3": function() { return /* binding */ EVENT_VISIT_DATE_COOKIE; },
/* harmony export */   "dG": function() { return /* binding */ PREGLIFE_SPECIAL_TYPE; },
/* harmony export */   "ei": function() { return /* binding */ DASHBOARD_TOP_PADDING_SECTION; },
/* harmony export */   "hY": function() { return /* binding */ LOGIN_ACTION; },
/* harmony export */   "je": function() { return /* binding */ CORONA_SPECIAL_TYPE; },
/* harmony export */   "jp": function() { return /* binding */ CAMPAIGN_CODE_COOKIE; },
/* harmony export */   "lI": function() { return /* binding */ durations; },
/* harmony export */   "oM": function() { return /* binding */ PROGRAM_THEMES; },
/* harmony export */   "qk": function() { return /* binding */ SEARCH_MODEL_SLUGS; },
/* harmony export */   "sU": function() { return /* binding */ LIVE_KINDS; },
/* harmony export */   "uu": function() { return /* binding */ KAROLINSKA_SLUG; },
/* harmony export */   "vt": function() { return /* binding */ VIDEO_NOT_FOUND_KEY; },
/* harmony export */   "w7": function() { return /* binding */ ANDROID_MOBILE_SUBSCRIPTION; },
/* harmony export */   "wU": function() { return /* binding */ DASHBOARD_PLAYLISTS_IDS; },
/* harmony export */   "wd": function() { return /* binding */ PAUSA_SMART_CHALLENGE_GET_STARTED; },
/* harmony export */   "yA": function() { return /* binding */ FALL2020_SPECIAL_TYPE; },
/* harmony export */   "zM": function() { return /* binding */ DASHBOARD_LEFTRIGHT_PADDING_SECTION; },
/* harmony export */   "zo": function() { return /* binding */ PAYMENT_CONFIRMATION_ACTION; }
/* harmony export */ });
/* unused harmony exports VOUCHER_CONFIRMATION_ACTION, PROGRAM_CONFIRMATION_ACTION, PAYMENT_FAILED_ACTION, PROGRAM_PAYMENT_FAILED_ACTION, CHALLENGES_PAGE_SLUG, ONLINE_COURSE_FEVER_LINK, SPECIAL_PAYMENT_TYPES, USE_NATIVE_TOKEN */
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59499);
/* harmony import */ var _lingui_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94471);
/* harmony import */ var _lingui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85169);
/* harmony import */ var _gql_generated__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48354);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
var _programTypes, _ProgramCategoryNames;



var CONTACT_EMAIL = 'info@yogobe.com';
var VIDEOS_COUNT = 2100;
var SUPPORT_EMAIL = 'infocom';
var LOGIN_ACTION = 'login';
var VIDEO_NOT_FOUND_KEY = 'not_found';
var PAYMENT_CONFIRMATION_ACTION = 'payment_confirmation';
var VOUCHER_CONFIRMATION_ACTION = 'voucher_confirmation';
var PROGRAM_CONFIRMATION_ACTION = 'program_confirmation';
var PAYMENT_FAILED_ACTION = 'payment_failed';
var PROGRAM_PAYMENT_FAILED_ACTION = 'program_payment_failed';
var PAUSA_SMART_CHALLENGE_GET_STARTED = 'pausa-smart-challenge';
var VIDEOS_GENRES_ID = '4a4423f5-3774-47e5-ac70-30ff9df0b3b3';
var DASHBOARD_PLAYLISTS_CATEGORY_ID =
'02e12572-1156-46c7-9c0c-b05f7a7c745d';
var DASHBOARD_PLAYLISTS_IDS = {
  '1cf14e61-d072-473d-9e65-ce6d84b419e6': null,
  '95cc1186-7b3c-4e35-9c75-bef25dc00a29': null,
  '7e538c20-ee09-40ef-805e-ae896b0f62e2': null,
  '401862f3-539f-43da-b15f-a842d42fac5e': null,
  '338d73c7-7417-4955-a96d-911fc0900afa': null };


//
var PROGRAMS_PAGE_SLUG = 'programs';
var HEALTHCARE_PAGE_SLUG = 'healthcare/programs';
var CHALLENGES_PAGE_SLUG = 'challenges';

//
var IOS_MOBILE_SUBSCRIPTION = 'https://apple.co/2Th4vqI';
var ANDROID_MOBILE_SUBSCRIPTION =
'https://play.google.com/store/account/subscriptions?package=com.yogobe.mobile';

//
var IOS_APP_LINK =
'https://apps.apple.com/se/app/yogobe-yoga-och-meditation/id1445170539';
var ANDROID_APP_LINK =
'https://play.google.com/store/apps/details?id=com.yogobe.mobile';

//
var CHALLENGE_PROGRAMS = [
'16-weeks-of-well',
'7-day-kickstart',
'beginner-baby',
'strong-and-graceful',
'restore-and-relax',
'holy-trinity',
'athlete-junkie'];

var ONLINE_COURSE_FEVER_LINK =
'/se/marketplace/online-courses?utm_source=banners%20onsite&utm_medium=banner&utm_campaign=Course%20Fever_April_2020&utm_content=Course%20Fever_April_2020_banners_onsite';
var CORONA_SPECIAL_TYPE = 'special_corona';
var SOMMER_SPECIAL_TYPE = 'special_sommar';
var PREGLIFE_SPECIAL_TYPE = 'preglife_discount';
var FALL2020_SPECIAL_TYPE = 'special_fall';
var SPECIAL_PAYMENT_TYPES = [
SOMMER_SPECIAL_TYPE,
CORONA_SPECIAL_TYPE,
PREGLIFE_SPECIAL_TYPE,
FALL2020_SPECIAL_TYPE,
'special'];


var HEADER_HEIGHT = 50;
var USE_NATIVE_TOKEN = '2_BVeVtoennh6rfG6HmvdDc_zAN5rahN1q';

var AUTH_TOKEN = 'token';
var AUTH_REFRESH_TOKEN = 'refresh_token';
var CAMPAIGN_CODE_COOKIE = 'campaign_code';
var EVENT_VISIT_DATE_COOKIE = 'visit_date';

var VERIFICATION_EMAIL_SENT = 'verification_sent';

var SUMMER_CHALLENGE_LINK = function SUMMER_CHALLENGE_LINK() {var lang = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'se';return "/".concat(
  lang, "/summerchallenge");};

var KAROLINSKA_SLUG = 'stress-study2020';

var ENABLED_LOCALS = ['se', 'en', 'fi', 'no'];
var SUMMER_CHALLENGE_PROGRAMS = {
  se: [
  {
    id: '3d408d1f-c06f-4369-a1ce-2ca3d1ad5130',
    slug: 'happybeginner',
    title: 'Happy Beginner',
    link: '/se/programs/happybeginner/overview',
    tooltip:
    'Detta program passar dig som är ny till yoga och vill hitta träningsglädjen',
    subtitle: '',
    thumbnail: '/static/happybeginner.jpg',
    description: ["Det h\xE4r \xE4r programmet f\xF6r dig som beh\xF6ver motivation och pepp f\xF6r att komma ig\xE5ng med enkel tr\xE4ning och hitta den d\xE4r gl\xE4djen alla snackar om. I detta program f\xE5r du testa p\xE5 enklare tr\xE4ning, funktionell tr\xE4ning, yoga f\xF6r nyb\xF6rjare, mindfulness samt korta motiverande talks."] },



  {
    id: 'ae775e1a-441f-4f74-b519-e60709598b76',
    slug: 'completerestoration',
    title: 'Complete Restoration',
    link: '/se/programs/completerestoration/overview',
    tooltip:
    'Detta program passar dig som är i stort behov av återhämtning och vila',
    subtitle: '',
    thumbnail: '/static/completerestoration.jpg',
    description: ["Det h\xE4r \xE4r programmet f\xF6r dig som vill landa efter en period av l\xE5ngvarig stress, sm\xE4rta eller utmattning - genom att uppleva kroppen med mjuk yoga, f\xE5 ett lugnare sinne med kortare meditation, yoga nidra och enkla andningstekniker samt ta del av motiverande och betryggande f\xF6rel\xE4sningar kring stresshantering."] },



  {
    id: '88acaf92-b5e5-46df-8f2e-df9b21e43e5a',
    slug: 'sweatyandhealthy',
    title: 'Sweaty & Healthy',
    link: '/se/programs/sweatyandhealthy/overview',
    tooltip: 'Detta program passar dig som vill svettas, flåsa och ha kul',
    subtitle: '',
    thumbnail: '/static/sweatyandhealthy.jpg',
    description: ["Det h\xE4r \xE4r programmet f\xF6r dig som \xE4r pepp p\xE5 en fysisk utmaning som kommer ge m\xE4rkbara resultat i styrka, r\xF6rlighet och kondition.\n          I detta program f\xE5r du testa p\xE5 funktionell tr\xE4ning, utmanande helkroppsklasser, SOMA MOVE, pilates, dynamisk yoga, Barre Move samt motiverande f\xF6rel\xE4sningar. "] },




  {
    id: '0da49d95-712a-4119-a8bc-513f820a0d92',
    slug: 'godeepandwithin',
    title: 'Go deep & within',
    link: '/se/programs/godeepandwithin/overview',
    tooltip:
    'Detta program passar dig som är erfaren yogi och vill gå djupare i din praktik',
    subtitle: '',
    thumbnail: '/static/godeep.jpg',
    description: ["Det h\xE4r \xE4r programmet f\xF6r dig som \xE4r erfaren yogaut\xF6vare och vill utveckla din asana, f\xF6rdjupa din filosofiska f\xF6rst\xE5else samt komma vidare p\xE5 din spirituella resa.\n          I detta program f\xE5r du ta del av flera korta f\xF6rel\xE4sningar kring personlig utveckling och yogans filosofi, testa ett par meditationstekniker, landa m.h.a. yoga nidra, v\xE4cka sinnet med mantra och chanting samt uppleva och utmana din kropp med avancerade yogaklasser."] }],





  fi: [
  {
    id: '1950791a-5593-4a48-b7ef-14e8017ae9f0',
    slug: 'joogapolulle',
    title: 'Joogapolulle',
    link: '/fi/programs/joogapolulle/overview',
    tooltip:
    'Tämä ohjelma soveltuu sinulle, joka olet utelias tutustumaan joogaan ja syventämään harjoitustasi',
    subtitle:
    'Suorita 12 harjoitusta neljässä viikossa ja voit voittaa palkinnon!',
    thumbnail: '/static/joogapolulle.jpg',
    description: ["Sinulle, joka olet kiinnostunut kurkistamaan joogan ja meditaation maailmaan ja halukas tuomaan lis\xE4\xE4 itsemy\xF6t\xE4tuntoa ja kiitollisuutta el\xE4m\xE4\xE4si. Haaste tutustuttaa sinut joogan eri tyylisuuntiin ja mindfulnessharjoituksiin sek\xE4 inspiroi ja motivoi sinua yll\xE4pit\xE4m\xE4\xE4n p\xE4ivitt\xE4isen harjoituksen.\n          Tutustut tulevien viikkojen aikana mm. lempe\xE4sti virtaavaan flowjoogaan, pys\xE4htymist\xE4 opettavaan passiiviseen yinjoogaan, rauhalliseen hathajoogaan, fyysiseen astangajoogaan ja erilaisiin meditaatiotekniikoihin sek\xE4 hengitysharjoituksiin. Lis\xE4ksi k\xE4ymme l\xE4pi oikeanlaista tekniikkaa, joka vaikuttaa harjoituksen turvallisuuteen."] },




  {
    id: '9d006309-53b2-4058-ac5f-eed3df4c4700',
    slug: 'kehomielenyhteys',
    title: 'Kehomielen Yhteys',
    link: '/fi/programs/kehomielenyhteys/overview',
    tooltip:
    'Tämä ohjelma soveltuu sinulle, joka tarvitset lepoa ja tietoista läsnäoloa.',
    subtitle:
    'Suorita 12 harjoitusta neljässä viikossa ja voit voittaa palkinnon!',
    thumbnail: '/static/kehomielenyhteys.jpg',
    description: ["Sinulle joka haluat vahvistaa yhteytt\xE4 kehomieleen n\xE4in\xE4 ep\xE4varmuuden aikoina, jolloin mieli voi olla t\xE4ynn\xE4 stressi\xE4 ja ahdistusta. T\xE4m\xE4 haaste on lempe\xE4 kutsu takaisin kehoon erilaisten kehomieli \u2013yhteytt\xE4 vahvistavien harjoitusten kautta, jotka lis\xE4\xE4v\xE4t my\xF6s notkeutta ja liikkuvuutta.\n          Haaste tuo luoksesi aktiivisen flowjoogan, passiivisen yinjoogan, kehomielt\xE4 helliv\xE4n restoratiivisen joogan, somaattisen liikkeen, erilaiset meditaatio- ja hengitysharjoitukset sek\xE4 funktionaalisen liikkeen. Lis\xE4ksi se kutsuu koko perheen mukaan lasten joogaan."] }] };







/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
  dev: {
    url: 'http://localhost:4000/' },

  origin: {
    url: 'https://yogobe.com' },

  beta: {
    url: 'https://beta.yogobe.com' } });



var PROGRAM_THEMES = {
  workout: /*i18n*/_lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("programs_2021.themes.workout"),
  yoga: /*i18n*/_lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("programs_2021.themes.yoga"),
  meditation: /*i18n*/_lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("programs_2021.themes.meditation"),
  beginner: /*i18n*/_lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("programs_2021.themes.beginner"),
  athletes: /*i18n*/_lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("programs_2021.themes.athletes"),
  breathing: /*i18n*/_lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("programs_2021.themes.breathing"),
  personal_growth: /*i18n*/_lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("programs_2021.themes.personal_growth"),
  diet_and_nutrition: /*i18n*/_lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("programs_2021.themes.diet_and_nutrition"),
  mobility_and_prehab: /*i18n*/_lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("programs_2021.themes.mobility_and_prehab"),
  womens_health: /*i18n*/_lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("programs_2021.themes.womens_health"),
  skills: /*i18n*/_lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("programs_2021.themes.skills"),
  stress_and_anxiety: /*i18n*/_lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("programs_2021.themes.stress_and_anxiety"),
  smart_breaks: /*i18n*/_lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("programs_2021.themes.smart_breaks"),
  philosophy: /*i18n*/_lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("programs_2021.themes.philosophy"),
  postnatal: /*i18n*/_lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("programs_2021.themes.postnatal"),
  prenatal: /*i18n*/_lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("programs_2021.themes.prenatal"),
  restoration: /*i18n*/_lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("programs_2021.themes.restoration"),
  yoga_teachers: /*i18n*/_lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("programs_2021.themes.yoga_teachers") };












var programTypes = (_programTypes = {}, (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_programTypes,
_gql_generated__WEBPACK_IMPORTED_MODULE_0__/* .ProgramCategory.Programs */ .l92.Programs, {
  text: /*i18n*/_lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("programs_2021.program_page.breadcrumb"),
  listingPageSlug: PROGRAMS_PAGE_SLUG }), (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_programTypes,

_gql_generated__WEBPACK_IMPORTED_MODULE_0__/* .ProgramCategory.Courses */ .l92.Courses, {
  text: /*i18n*/_lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("courses_2021.program_page.breadcrumb"),
  listingPageSlug: 'courses' }), (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_programTypes,

_gql_generated__WEBPACK_IMPORTED_MODULE_0__/* .ProgramCategory.Programs */ .l92.Programs, {
  text: /*i18n*/_lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("programs_2021.program_page.breadcrumb"),
  listingPageSlug: PROGRAMS_PAGE_SLUG }), (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_programTypes,

_gql_generated__WEBPACK_IMPORTED_MODULE_0__/* .ProgramCategory.Challenges */ .l92.Challenges, {
  text: _gql_generated__WEBPACK_IMPORTED_MODULE_0__/* .ProgramCategory.Challenges */ .l92.Challenges,
  listingPageSlug: _gql_generated__WEBPACK_IMPORTED_MODULE_0__/* .ProgramCategory.Challenges */ .l92.Challenges }), (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_programTypes,

_gql_generated__WEBPACK_IMPORTED_MODULE_0__/* .ProgramCategory.Healthcare */ .l92.Healthcare, {
  text: _gql_generated__WEBPACK_IMPORTED_MODULE_0__/* .ProgramCategory.Healthcare */ .l92.Healthcare,
  listingPageSlug: _gql_generated__WEBPACK_IMPORTED_MODULE_0__/* .ProgramCategory.Healthcare */ .l92.Healthcare }), _programTypes);





var ProgramCategoryNames = (_ProgramCategoryNames = {}, (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ProgramCategoryNames,
_gql_generated__WEBPACK_IMPORTED_MODULE_0__/* .ProgramCategory.Courses */ .l92.Courses, /*i18n*/_lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("metadata.course")), (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ProgramCategoryNames,
_gql_generated__WEBPACK_IMPORTED_MODULE_0__/* .ProgramCategory.Programs */ .l92.Programs, /*i18n*/_lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("metadata.program")), (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ProgramCategoryNames,
_gql_generated__WEBPACK_IMPORTED_MODULE_0__/* .ProgramCategory.Challenges */ .l92.Challenges, /*i18n*/_lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("metadata.challenge")), _ProgramCategoryNames);


var durations = {
  days: /*i18n*/_lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("metadata.days.label"),
  weeks: /*i18n*/_lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("metadata.weeks.label") };


var LIVE_KINDS = {
  donation_class: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_4__/* .Trans */ .cC, { id: "live.listings_page.filters.donation_class" }),
  talk: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_4__/* .Trans */ .cC, { id: "live.listings_page.filters.kind_talk" }),
  lecture: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_4__/* .Trans */ .cC, { id: "live.listings_page.filters.kind_lecture" }),
  classe: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_4__/* .Trans */ .cC, { id: "live.listings_page.filters.kind_class" }),
  workshop: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_4__/* .Trans */ .cC, { id: "live.listings_page.filters.kind_workshop" }),
  skills: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_4__/* .Trans */ .cC, { id: "live.listings_page.filters.kind_skills" }),
  part_of_online_course: /*#__PURE__*/
  (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_4__/* .Trans */ .cC, { id: "live.listings_page.filters.kind_online_course" }),

  free_event: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_4__/* .Trans */ .cC, { id: "live.listings_page.filters.free_event" }) };


var SEARCH_MODEL_SLUGS = {
  blog: _gql_generated__WEBPACK_IMPORTED_MODULE_0__/* .ModelNameKind.BlogPosts */ .ueT.BlogPosts,
  programs: _gql_generated__WEBPACK_IMPORTED_MODULE_0__/* .ModelNameKind.GenericPrograms */ .ueT.GenericPrograms,
  courses: _gql_generated__WEBPACK_IMPORTED_MODULE_0__/* .ModelNameKind.Courses */ .ueT.Courses,
  pages: _gql_generated__WEBPACK_IMPORTED_MODULE_0__/* .ModelNameKind.LandingPages */ .ueT.LandingPages,
  playlists: _gql_generated__WEBPACK_IMPORTED_MODULE_0__/* .ModelNameKind.Playlists */ .ueT.Playlists,
  videos: _gql_generated__WEBPACK_IMPORTED_MODULE_0__/* .ModelNameKind.Videos */ .ueT.Videos,
  challenges: _gql_generated__WEBPACK_IMPORTED_MODULE_0__/* .ModelNameKind.Challenges */ .ueT.Challenges,
  instructors: _gql_generated__WEBPACK_IMPORTED_MODULE_0__/* .ModelNameKind.Instructors */ .ueT.Instructors,
  live: _gql_generated__WEBPACK_IMPORTED_MODULE_0__/* .ModelNameKind.LiveEvents */ .ueT.LiveEvents,
  events: _gql_generated__WEBPACK_IMPORTED_MODULE_0__/* .ModelNameKind.Events */ .ueT.Events };


var SEARCH_CATEGORY_NAMES = {
  videos: /*i18n*/_lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("search.category.video_audio.title"),
  playlists: /*i18n*/_lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("search.category.playlists.title"),
  live: /*i18n*/_lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("search.category.live_events.title"),
  programs: /*i18n*/_lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("search.category.programs.title"),
  challenges: /*i18n*/_lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("search.category.challenges.title"),
  courses: /*i18n*/_lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("search.category.courses.title"),
  events: /*i18n*/_lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("search.category.events.title"),
  blog: /*i18n*/_lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("search.category.blog.title"),
  pages: /*i18n*/_lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("search.category.pages.title"),
  instructors: /*i18n*/_lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("search.category.instructors.title") };


var DASHBOARD_LEFTRIGHT_PADDING_SECTION = [15, 25, 20];
var DASHBOARD_TOP_PADDING_SECTION = 25;
var DASHBOARD_BOTTOM_PADDING_SECTION = 35;

var DISABLED_PROGRAMS = [
'summer-challenge-beginner',
'summer-challenge-advanced',
'fall-challenge-feel-the-connection',
'fall-challenge-feelthesweat',
'fall-challenge-embracethelight'];


var REF_BUNDLE = 'bundle';

/***/ }),

/***/ 47493:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ UserContext; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90116);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17674);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92876);
/* harmony import */ var _gql_generated__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48354);
/* harmony import */ var _lib_analytics_manager__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88224);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);
 /* eslint-disable no-prototype-builtins */






var USER_INITIAL_PROPTETIES = _gql_generated__WEBPACK_IMPORTED_MODULE_1__/* .CurrentUserDocument.definitions[0].selectionSet.selections[0].selectionSet.selections.map */ .T0H.definitions[0].selectionSet.selections[0].selectionSet.selections.map(function (_ref) {var name = _ref.name;return name.value;});

// extract the fields in the complex query
var USER_COMPLEX_PROPTETIES = _gql_generated__WEBPACK_IMPORTED_MODULE_1__/* .CurrentUser2Document.definitions[0].selectionSet.selections[0].selectionSet.selections.map */ .g$W.definitions[0].selectionSet.selections[0].selectionSet.selections.map(function (_ref2) {var name = _ref2.name;return name.value;});

/*
  THOUGHTS
  to break the currentUser query into two queries
  we need a way to detect when to load the second query
    - either by adding a parameter to the hook to mark usage as full query, and we load the full query on initial load
    - we make the loading dynamic, we proxy the initial currentUser and when a field on the second part is looked-up 
      we load the second query
    - we can also separate the queries, make two hooks each should be responsible for one part. (some components might need items in the two parts)

    ? how do we handle UI when initial part is loaded & the complex part is loading
      - separate the loading of the two queries?
      - keep one loading, UI that depends on the complex properties will be hidden because of missing data until all is loaded!!

    + need to talk to someone from the backend to know which queries require lookup in other tables
    + generally we should bullet proof the code to not fail when some object are null/undefined and find a good way of loading the rest of the user
*/

// tried using `called` on lazyQuery but its doesn't update fast enought, it causes lots of re-renders









var UserContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);

var UserProviderHook = function UserProviderHook(initialUser) {var _initialUserData$curr5, _initialUserData$curr7;
  var _calledLazy = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);

  // we can even split `GET_REST_CURRENT_USER` into more queries
  var _useCurrentUser2LazyQ =


  (0,_gql_generated__WEBPACK_IMPORTED_MODULE_1__/* .useCurrentUser2LazyQuery */ .mRf)(),_useCurrentUser2LazyQ2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_useCurrentUser2LazyQ, 2),loadRestOfUser = _useCurrentUser2LazyQ2[0],_useCurrentUser2LazyQ3 = _useCurrentUser2LazyQ2[1],lazyUserParts = _useCurrentUser2LazyQ3.data,refetchLazy = _useCurrentUser2LazyQ3.refetch;

  var _useCurrentUserQuery =




  (0,_gql_generated__WEBPACK_IMPORTED_MODULE_1__/* .useCurrentUserQuery */ .rkO)(),initialUserData = _useCurrentUserQuery.data,loading = _useCurrentUserQuery.loading,error = _useCurrentUserQuery.error,refetchUserBase = _useCurrentUserQuery.refetch;

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    // USING setInterval TO SOLVE THE FOLLOWING ISSUE
    // https://github.com/facebook/react/issues/18178
    //
    var ID = setInterval(function () {
      if (_calledLazy.current) {
        loadRestOfUser();
        clearInterval(ID);
      }
    }, 500);

    return function () {
      clearInterval(ID);
    };
  }, []);

  var getProxiedUserObject = function getProxiedUserObject() {var _initialUserData$curr;
    if (!(initialUserData !== null && initialUserData !== void 0 && (_initialUserData$curr = initialUserData.currentUser) !== null && _initialUserData$curr !== void 0 && _initialUserData$curr.id)) {
      return null;
    }
    var fullUser = Object.assign(
    {},
    (initialUserData === null || initialUserData === void 0 ? void 0 : initialUserData.currentUser) || {},
    (lazyUserParts === null || lazyUserParts === void 0 ? void 0 : lazyUserParts.currentUser) || {});


    var proxied = new Proxy(fullUser, {
      // to differentiate between properties that are falsy
      // we check if user has the property, if not we load the query that contains the property
      getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, prop) {
        if (
        !target.hasOwnProperty(prop) &&
        // if we break the second query into multiple, we can lookup in which query the prop exists and load that
        USER_COMPLEX_PROPTETIES.includes(prop))
        {
          if (!_calledLazy.current) {
            _calledLazy.current = true;
          }
          return undefined;
        }
        return {
          enumerable: true,
          configurable: true,
          value: target[prop] };

      },
      get: function get(target, prop) {
        if (
        Object.prototype.hasOwnProperty(prop) ||
        ['$$typeof'].includes(String(prop)))
        {
          return target[prop];
        }
        if (
        // hasn't loaded
        !target.hasOwnProperty(prop) &&
        // if we break the second query into multiple, we can lookup in which query the prop exists and load that
        USER_COMPLEX_PROPTETIES.includes(prop))
        {
          if (!_calledLazy.current) {
            _calledLazy.current = true;
          }
        } else {
          if (
          ![].concat((0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(USER_INITIAL_PROPTETIES), (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(USER_COMPLEX_PROPTETIES)).includes(
          prop))

          {
            // if we forgot to include a field
            // TODO: convert this is normal error before going PROD
            _sentry_nextjs__WEBPACK_IMPORTED_MODULE_6__/* .captureException */ .Tb(
            new Error("tried to access an unknown property ".concat(
            prop, " on currentUser")),

            {
              level: 'warning' });


          }
          return target[prop];
        }
      } });


    return proxied;
  };

  var currentUserState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    if (false) {} else {
      return getProxiedUserObject();
    }
  }, [lazyUserParts === null || lazyUserParts === void 0 ? void 0 : lazyUserParts.currentUser, initialUserData === null || initialUserData === void 0 ? void 0 : initialUserData.currentUser, initialUser]);

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {var _initialUserData$curr2;
    if (initialUserData !== null && initialUserData !== void 0 && (_initialUserData$curr2 = initialUserData.currentUser) !== null && _initialUserData$curr2 !== void 0 && _initialUserData$curr2.id) {var _initialUserData$curr3, _initialUserData$curr4;
      (0,_lib_analytics_manager__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().setUserProperties(
      initialUserData === null || initialUserData === void 0 ? void 0 : initialUserData.currentUser);

      _sentry_nextjs__WEBPACK_IMPORTED_MODULE_6__/* .setUser */ .av({
        id: initialUserData === null || initialUserData === void 0 ? void 0 : (_initialUserData$curr3 = initialUserData.currentUser) === null || _initialUserData$curr3 === void 0 ? void 0 : _initialUserData$curr3.id,
        email: initialUserData === null || initialUserData === void 0 ? void 0 : (_initialUserData$curr4 = initialUserData.currentUser) === null || _initialUserData$curr4 === void 0 ? void 0 : _initialUserData$curr4.email });

    }
  }, [initialUserData === null || initialUserData === void 0 ? void 0 : (_initialUserData$curr5 = initialUserData.currentUser) === null || _initialUserData$curr5 === void 0 ? void 0 : _initialUserData$curr5.id]);

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {var _initialUserData$curr6;
    if (!(initialUserData !== null && initialUserData !== void 0 && (_initialUserData$curr6 = initialUserData.currentUser) !== null && _initialUserData$curr6 !== void 0 && _initialUserData$curr6.id)) {
      // reset for future login
      _calledLazy.current = false;
    }
  }, [initialUserData === null || initialUserData === void 0 ? void 0 : (_initialUserData$curr7 = initialUserData.currentUser) === null || _initialUserData$curr7 === void 0 ? void 0 : _initialUserData$curr7.id]);

  var refetch = function refetch() {var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},_ref3$onlyBasePropert = _ref3.onlyBaseProperties,onlyBaseProperties = _ref3$onlyBasePropert === void 0 ? false : _ref3$onlyBasePropert;
    // in some cases we need to wait for user to refrech then do an action
    // so we return the promises so we can do await on them
    var promises = [];
    promises.push(refetchUserBase());
    if (!onlyBaseProperties) {
      // if lazy query was never fired, it's refetch function is undefined
      promises.push(refetchLazy === null || refetchLazy === void 0 ? void 0 : refetchLazy());
    }

    return Promise.all(promises);
  };

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (!(initialUserData !== null && initialUserData !== void 0 && initialUserData.currentUser)) {
      refetchUserBase();
    }
  }, []);

  return [
  currentUserState,
  {
    loading: loading,
    error: error,
    refetch: refetch }];


};

var UserProvider = function UserProvider(props) {
  var _UserProviderHook =


  UserProviderHook(props.initialValue),_UserProviderHook2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_UserProviderHook, 2),currentUserState = _UserProviderHook2[0],_UserProviderHook2$ = _UserProviderHook2[1],loading = _UserProviderHook2$.loading,error = _UserProviderHook2$.error,refetch = _UserProviderHook2$.refetch;

  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(UserContext.Provider, {
      value: [currentUserState, { loading: loading, error: error, refetch: refetch }], children:

      props.children }));


};

/* harmony default export */ __webpack_exports__["Z"] = (UserProvider);

/***/ }),

/***/ 87811:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var DeviceContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)();

/* harmony default export */ __webpack_exports__["Z"] = (DeviceContext);

/***/ }),

/***/ 17516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var LanguageContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext('se');
LanguageContext.displayName = 'LanguageContext';
/* harmony default export */ __webpack_exports__["Z"] = (LanguageContext);

/***/ }),

/***/ 32460:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ak": function() { return /* binding */ getVideoDescription; },
/* harmony export */   "IF": function() { return /* binding */ canBuyProgramGift; },
/* harmony export */   "Lz": function() { return /* binding */ borders; },
/* harmony export */   "VR": function() { return /* binding */ getUserProgramAccess; },
/* harmony export */   "i6": function() { return /* binding */ normalizeImagePath; },
/* harmony export */   "o8": function() { return /* binding */ hideURLParams; },
/* harmony export */   "o_": function() { return /* binding */ getMargins; },
/* harmony export */   "uq": function() { return /* binding */ canExtendProgramAccess; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17674);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22498);
/* harmony import */ var _gql_generated__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48354);
function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}



function borders(type) {
  return "\n    border-top: 1px solid #dddddd;\n    border-bottom: 1px solid #dddddd;\n    ".concat(


  type === 'both' && "\n        border-left: 1px solid #dddddd;\n        border-right: 1px solid #dddddd;\n        border-radius: 3px;\n      ", ";\n\n    ").concat(






  type === 'left' && "\n        border-right: 0;\n        border-left: 1px solid #dddddd;\n        border-top-left-radius: 3px;\n        border-bottom-left-radius: 3px;\n      ", ";\n\n    ").concat(







  type === 'right' && "\n        border-left: 0;\n        border-right: 1px solid #dddddd;\n        border-top-right-radius: 3px;\n        border-bottom-right-radius: 3px;\n      ", ";\n    ");







}

var getMargins = function getMargins(index, length) {var nextline = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var margins = {
    mb: [20, 20] };


  if (index === 0 || index === nextline)
  return _objectSpread(_objectSpread({},
  margins), {}, {
    pl: 0,
    pr: [0, 20] });


  if (index === length - 1 || index === length + nextline - 1)
  return _objectSpread(_objectSpread({},
  margins), {}, {
    pl: [0, 20],
    pr: 0 });


  return _objectSpread(_objectSpread({},
  margins), {}, {
    px: [0, 10] });

};

var getUserProgramAccess = function getUserProgramAccess(_ref)







{var user = _ref.user,programSlug = _ref.programSlug,programCategory = _ref.programCategory;
  if (programSlug) {
    if (
    user !== null && user !== void 0 && user.courseAccesses &&
    programCategory === _gql_generated__WEBPACK_IMPORTED_MODULE_3__/* .ProgramCategory.Courses */ .l92.Courses)
    {var _user$courseAccesses;
      return (_user$courseAccesses = user.courseAccesses) === null || _user$courseAccesses === void 0 ? void 0 : _user$courseAccesses.find(function (p) {
        if (p.course.slug === programSlug) {
          return true;
        }
      });
    } else if (
    user !== null && user !== void 0 && user.programAccess &&
    programCategory === _gql_generated__WEBPACK_IMPORTED_MODULE_3__/* .ProgramCategory.Programs */ .l92.Programs)
    {var _user$programAccess;
      return (_user$programAccess = user.programAccess) === null || _user$programAccess === void 0 ? void 0 : _user$programAccess.find(function (p) {
        if (p.program.slug === programSlug) {
          return true;
        }
      });
    }
  }
  return null;
};

var hideURLParams = function hideURLParams(action_type) {
  var pathname = (next_router__WEBPACK_IMPORTED_MODULE_1___default().pathname),query = (next_router__WEBPACK_IMPORTED_MODULE_1___default().query);
  if (action_type === _constants__WEBPACK_IMPORTED_MODULE_2__/* .PAYMENT_CONFIRMATION_ACTION */ .zo) {
    var expectedParams = [
    'action',
    'amount',
    'amount_cents',
    'subscription_type',
    'recurring_date',
    'recurring_amount',
    'months',
    'recurring_currency',
    'currency',
    'amount_currency',
    'email',

    // these are probably sent by adyen
    'payload',
    'type',
    'resultCode',
    'order_id',
    'transact',
    'transaction'];


    var params = Object.fromEntries(
    Object.entries(query).filter(function (_ref2) {var _ref3 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref2, 1),key = _ref3[0];
      if (expectedParams.includes(key)) {
        return false;
      }
      return true;
    }));


    next_router__WEBPACK_IMPORTED_MODULE_1___default().replace({ pathname: pathname, query: params });
  } else if (action_type === _constants__WEBPACK_IMPORTED_MODULE_2__/* .LOGIN_ACTION */ .hY) {
    // TODO: handle login clean up here
  }
};

var getVideoDescription = function getVideoDescription(video) {
  if (video !== null && video !== void 0 && video.content) {
    var _video$content = video.content,longDescription = _video$content.longDescription,shortDescription = _video$content.shortDescription;
    return shortDescription || longDescription;
  }
  return '';
};

function normalizeImagePath(value) {
  if (String(value).startsWith('//')) {
    return 'https:' + value;
  }
  return value;
}

var canBuyProgramGift = function canBuyProgramGift(price, priceType) {
  if (
  [
  _gql_generated__WEBPACK_IMPORTED_MODULE_3__/* .PriceTypeKind.AccessCodesOnly */ ._xv.AccessCodesOnly,
  _gql_generated__WEBPACK_IMPORTED_MODULE_3__/* .PriceTypeKind.BySubscription */ ._xv.BySubscription,
  _gql_generated__WEBPACK_IMPORTED_MODULE_3__/* .PriceTypeKind.FreeForAll */ ._xv.FreeForAll].
  includes(priceType) ||
  price === null)
  {
    return false;
  }

  return true;
};

var canExtendProgramAccess = function canExtendProgramAccess(
price,
priceType,
accessStatus)
{
  if (
  ([_gql_generated__WEBPACK_IMPORTED_MODULE_3__/* .PriceTypeKind.BySubscription */ ._xv.BySubscription, _gql_generated__WEBPACK_IMPORTED_MODULE_3__/* .PriceTypeKind.FreeForAll */ ._xv.FreeForAll].includes(
  priceType) ||

  price === null) &&
  ![
  _gql_generated__WEBPACK_IMPORTED_MODULE_3__/* .ProgramAccessStatus.Expired */ .DeO.Expired,
  _gql_generated__WEBPACK_IMPORTED_MODULE_3__/* .ProgramAccessStatus.ExpiringSoon */ .DeO.ExpiringSoon].
  includes(accessStatus))
  {
    return false;
  }

  return true;
};

/***/ }),

/***/ 55932:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R5": function() { return /* binding */ names; },
/* harmony export */   "gW": function() { return /* binding */ FLAGS_QUERY; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71383);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37887);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12922);
var _templateObject;




var FLAGS_QUERY = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject || (_templateObject = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n  query flagsQuery($names: [String!]!) {\n    flipperFlags(names: $names) {\n      name\n      value\n    }\n  }\n"])));








var names = [
'payments_adyen',
'yearly_campaign',
'quarterly_campaign',
'disable_trustly',
'disable_hls',
'google_oauth_feature',
'sommar99_campaign',
'search_disabled',
'enable_trialclaim_modal',
'mindfulnesskalendern',
'video_stats',
'disable_dashboard_stats',
'wellness',
'yearly_campaign_banners'];




function buildFlags(flags) {
  return (
    (flags === null || flags === void 0 ? void 0 : flags.reduce(function (acc, flag) {
      acc[flag.name] = flag.value;
      return acc;
    }, {})) || {});

}

var useFlags = function useFlags()


{
  var _useQuery = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .a)(

  FLAGS_QUERY, {
    variables: {
      names: names } }),data = _useQuery.data,loading = _useQuery.loading,error = _useQuery.error;



  var flags = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    var flags = buildFlags(data === null || data === void 0 ? void 0 : data.flipperFlags);
    return flags;
  }, [data === null || data === void 0 ? void 0 : data.flipperFlags]);

  return [flags, { loading: loading, error: error }];
};

/* harmony default export */ __webpack_exports__["ZP"] = (useFlags);

/***/ }),

/***/ 62594:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _gql_generated__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48354);


var theme = {
  colors: {
    channels: {
      yoga: '#129edc',
      breathing: '#88bfbd',
      workout: '#cc531d',
      meditation: '#965780' },

    neutrals: {
      realBlack: '#000',
      black: '#242424',
      'black-ligther': '#3c3c3c',
      'gray-dark': '#6e6e6e',
      gray: '#7d7d7d',
      'gray-3': '#c7c7c7',
      'white-darkest': '#eaeaea',
      'white-darker': '#f7f7f7',
      'light-gray': '#f2f2f2',
      white: '#ffffff',
      'black-1': '#cccccc',
      'black-2': '#e5e5e5',
      'black-3': 'rgba(0, 0, 0, 0.175)' },

    primary: {
      'blue-1': '#129edc',
      'blue-2': '#56b9e5',
      'blue-3': '#c5edff',
      'blue-4': '#dff5ff',
      'blue-5': '#51667a',
      'pink-1': '#cd206a',
      'pink-2': '#ea6ea3',
      'pink-3': '#fae0eb',
      'pink-4': '#fbedf3',
      stone: '#667c91',
      green: '#32847e',
      'green-1': '#d9e8e7',
      'green-2': '#213e3d',
      crystalBlue: '#6C97A7' },

    secondary: {
      'green-2': '#2F7518',
      'green-3': '#88bfbd',
      'green-4': '#9dc9c7',
      'green-5': '#d9e8e7',
      'gray-1': '#6e96a8',
      'gray-2': '#87a5b4',
      'gray-3': '#d1d9df',
      'gray-4': '#eeeeee',
      'gray-5': '#667c91',
      'grey-6': '#566776',
      black: '#d9d9d9',
      'red-1': '#e53b4d',
      'red-2': '#e86062',
      yellow: '#e2d2af',
      blue: '#119edd',
      orange: '#F3A661',
      'orange-1': '#ffa351',
      'light-bronze': '#F2ECDD',
      gold: '#CCB375' },

    interactive: {
      'color-1': '#41B1E3',
      'color-2': '#108DC5',
      'color-3': '#D7D7D7',
      'color-4': '#D74C87',
      'color-5': '#B81C5F',
      'color-6': '#454857',
      'color-7': '#6A6C78',
      'color-8': '#3A3A3A',
      'color-9': '#B0D3D2',
      'color-10': '#8CB4B2',

      'color-11': '#77C7EA',
      'color-12': '#4DA6CD',
      'color-13': '#EE8BB5',
      'color-14': '#D26292',
      'color-15': '#404040',
      'color-16': '#666666',
      'color-17': '#393939',
      'color-18': '#dddddd' } },


  shadows: {
    light: 'rgba(0, 0, 0, 0.05)' },

  viewports: {
    'x-small': 320,
    mobile: 425,
    tablet: 768,
    laptop: 1024,
    desktop: 1220 },

  breakpoints: ['426px', '769px', '1024px'],
  sizes: {
    MobileBreakpoint: 320,
    MobileLargeBreakpoint: 425,
    TabletBreakpoint: 768,
    Breakpoint980: 980,
    Breakpoint740: 740,
    LaptopBreakPoint: 1024,
    DesktopBreakpoint: 1220,
    DesktopLargeBreakpoint: 1220,
    DesktopUpBreakpoint: 1400,
    FourKBreakPoint: 2560 },

  helpers: {
    getProgramThemeColor: function getProgramThemeColor(category) {
      if (category === _gql_generated__WEBPACK_IMPORTED_MODULE_0__/* .ProgramCategory.Courses */ .l92.Courses) {
        return theme.colors.primary['green'];
      } else {
        return theme.colors.primary['stone'];
      }
    } } };



/* harmony default export */ __webpack_exports__["Z"] = (theme);

/***/ }),

/***/ 66629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "eC": function() { return /* binding */ findParentElement; },
/* harmony export */   "f4": function() { return /* binding */ isParentElement; },
/* harmony export */   "mR": function() { return /* binding */ hexToRgbA; },
/* harmony export */   "rT": function() { return /* binding */ isEnabledOnPage; },
/* harmony export */   "rz": function() { return /* binding */ normalizePrograms; },
/* harmony export */   "tq": function() { return /* binding */ isMobile; }
/* harmony export */ });
/* unused harmony exports phoneRegExp, generateUserKey, loadAddresses */
/* harmony import */ var crypto__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42474);
/* harmony import */ var crypto__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(crypto__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33913);
/* harmony import */ var lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50361);
/* harmony import */ var lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22498);
function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {_defineProperty(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}





var phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

var isMobile = function isMobile() {
  var agent = navigator.userAgent || navigator.vendor || window['opera'];
  if (/Mobile|iP(hone|od|ad)|Android/i.test(agent)) {
    return true;
  }
  return false;
};

var generateUserKey = function generateUserKey(userId) {
  if (userId) {
    return crypto.
    createHmac('sha256', "fpU6rf5iapDyrZAofYQjd-qJaA-TA6jy").
    update(userId).
    digest('base64');
  }

  return null;
};

function hexToRgbA(hex) {var alpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var c;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split('');
    if (c.length == 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = '0x' + c.join('');
    return (
      'rgba(' +
      [c >> 16 & 255, c >> 8 & 255, c & 255].join(',') + ",".concat(
      alpha, ")"));

  }
  throw new Error('Bad Hex');
}

var isParentElement = function isParentElement(parent, child) {
  if (
  !child ||
  !parent ||
  (child === null || child === void 0 ? void 0 : child.parentElement) === null ||
  (child === null || child === void 0 ? void 0 : child.parentElement) instanceof HTMLBodyElement)
  {
    return false;
  } else if (parent !== null && parent !== void 0 && parent.contains(child)) {
    return true;
  } else {
    return isParentElement(parent, child === null || child === void 0 ? void 0 : child.parentElement);
  }
};

var findParentElement = function findParentElement(el, selector) {
  if (el) {var _el$parentElement;
    if ((_el$parentElement = el.parentElement) !== null && _el$parentElement !== void 0 && _el$parentElement.matches(selector)) {
      return el.parentElement;
    }
    return findParentElement(el.parentElement, selector);
  }

  return null;
};

var loadAddresses = function loadAddresses(address) {
  var config = {
    method: 'get',
    headers: {} };

  fetch("https://maps.googleapis.com/maps/api/place/autocomplete/json?input=".concat(
  address, "&types=geocode&key=AIzaSyDTIqhUmW_Jx5E0CWOzIN6ZNNEtRqudfBo"), _objectSpread({},
  config));

};

var normalizePrograms = function normalizePrograms(items) {
  return lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_1___default()(items).reduce(function (mergedList, item) {
    if (item.program && _constants__WEBPACK_IMPORTED_MODULE_2__/* .DISABLED_PROGRAMS.includes */ .U3.includes(item.program.slug)) {
      // EXCLUDE DISABLED PROGRAMS
      return mergedList;
    } else if (item.program) {var _item$program;
      // HANDLE PROGRAMS
      if (item.program.lede && !item.program.shortDescription) {
        item.program.shortDescription = item.program.lede.
        replace(/<\/?[^>]+(>|$)/g, '').
        replace(/(\r\n|\n|\r)/gm, '').
        replace(/&nbsp;/gi, '');
      }
      var lang = item.program.language || 'se';
      if (item.program.slug === 'pausa-smart') {
        if ((0,date_fns__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(item.accessUntil)) {
          item.path = "/".concat(lang, "/pausasmart");
        } else {
          item.path = "/".concat(lang, "/pausasmart/videos");
        }
      } else if ((_item$program = item.program) !== null && _item$program !== void 0 && _item$program.legacy) {
        item.path = "/".concat(lang, "/program/").concat(item.program.slug);
      } else {
        item.path = "/".concat(lang, "/programs/").concat(item.program.slug, "/progress");
      }
      item.progressPercentage = item.progressPercentage || 0;
    }

    mergedList.push(item);
    return mergedList;
  }, []);
};

var isEnabledOnPage = function isEnabledOnPage(
paths,
pathname)
{
  return paths.some(function (item) {
    if (item.exact) {
      return item.path === pathname;
    } else {
      return pathname.startsWith(item.path);
    }
  });
};

/***/ }),

/***/ 90673:
/***/ (function(module) {

/*eslint-disable*/module.exports = { messages: { "An account verification email has been sent to {0}": ["An account verification email has been sent to ", ["0"]], "LegacyPaymentModal.choose_a_payment_method": "Choose a payment method", "The terms and conditions must be accepted.": "The terms and conditions must be accepted.", "WeeklyProgram.moodtracker.post.description": "WeeklyProgram.moodtracker.post.description", "WeeklyProgram.moodtracker.post.start_button": "WeeklyProgram.moodtracker.post.start_button", "WeeklyProgram.moodtracker.post.title": "WeeklyProgram.moodtracker.post.title", "WeeklyProgram.moodtracker.pre.description": "WeeklyProgram.moodtracker.pre.description", "WeeklyProgram.moodtracker.pre.start_button": "WeeklyProgram.moodtracker.pre.start_button", "WeeklyProgram.moodtracker.pre.title": "WeeklyProgram.moodtracker.pre.title", "access_code_modal.checkmark_activate": "Activate", "access_code_modal.code_error": "Incorrect access code. Please try again!", "access_code_modal.code_success": "Access code successfully registered", "access_code_modal.code_success_access": ["Great! You now have access to your designated content from ", ["companyName"], "!"], "access_code_modal.code_success_redirect": "You will be now redirected to the Overview page in…", "access_code_modal.description": ["Access will be granted to ", ["companyName"], " employees or partners who have received invitation or access codes from ", ["companyName"], "."], "access_code_modal.input_label": "Access code", "access_code_modal.title": ["Access ", ["companyName"], "'s curated and recommended Yogobe content"], "account.verification_email_resent": ["An account verification email has been sent to ", ["email"]], "banner.action": "Yes, please", "banner.action2": "Give feedback", "banner.body": "Return to the old video library?", "banner.castBanner": "You can now cast videos from your device to your TV using either airplay or chromecast. FYI: Chromecast is currently not supported on iOS devices. ", "banner.companyFavorites": "All the content you mark as a favorite will be public and displayed in the Overview-tab as recommended content", "banner.course_maintenance": "We are currently making updates to Yogobe Courses which unfortunately means that you cannot be inside them while this work is going on. We are sorry for the inconvenience and welcome you back tomorrow morning!", "banner.download_chrome": "When watching a video, you might experience some issues in your current browser. We highly recommend using", "banner.download_chrome_action": "Google Chrome", "banner.email_verify": ["Please verify your email address (", ["email"], ") to activate your membership. Haven't received the email? <0>Click here</0>"], "banner.email_verify_change_settings": "Please confirm your updated account settings. Haven't received the verification email? <0>Click here</0>", "banner.monthlyCourseOffer": "banner.monthlyCourseOffer", "banner2.body": "You're viewing one of our new programs. Your feedback will help us tweek the experience.", "banner_subscribe.go_premium": "Go premium", "banner_subscribe.header": "Would you like unlimited access to our video library?", "blog.title": "Blog", "bundle.dashboard_card.access_expired": "Access expired", "bundle.get_started..access_code.show_text": "If you have an access code, <0>click here</0>", "bundle.get_started.access_code.info_text": "Enter access code", "bundle.get_started.access_code.label": "Have you been given an access code?", "bundle.get_started.access_code.not_valid": "The access code which you have entered is either no longer valid for this bundle page, inaccurate OR it has already been used once by you. Let us know if you have any questions: info@yogobe.com", "bundle.get_started.access_code.tooltip_text": "Have you received an access code from one of our partners? Use it for access to the content.", "bundle.get_started.access_code.valid": "Access code is valid", "bundle.get_started.activation_failed_error": "We failed to activate the theme page for you. Please try again or contact us via <0></0>", "bundle.get_started.button.get_started": "Get started", "bundle.get_started.button.login": "Log in and continue", "bundle.get_started.button.register": "Join and continue<<<<<<< HEAD", "bundle.get_started.by_code_description": "This theme page is accessible via access code only. Please enter it below.", "bundle.get_started.description": "You need an access code for this content", "bundle.get_started.for_all_description": "This theme page is free for everyone. Click on \"Get started\" below to get access to the content.", "bundle.get_started.for_premium_description": "This theme page is included in a subscription for Yogobe Play. It is also available through an access code, if you have one, please enter it below.", "bundle.get_started.for_subscription_only": "This theme page is included in your Yogobe Play subscription.", "bundle.get_started.guest.welcome_message": ["Welcome to ", ["bundle_name"]], "bundle.get_started.guest_description": ["Welcome to ", ["bundle_name"], ", the content on this theme page is either accessible via a subscription or through an access code from a Yogobe parther or your employer. Please log in or create an account. Thereafter you will be asked to fill in the access code."], "bundle.get_started.guest_title": "Join theme page", "bundle.get_started.snackbar.access_granted": "You now have access to this content", "bundle.get_started.user.welcome_message": ["Hey ", ["name"], ", welcome to ", ["bundle_name"]], "bundle.get_started.verify_account_banner": "Verify your account to be able to join the bundle.", "bundle.id_page.blog_sections.title": "Blog", "bundle.id_page.challenge.discover_button": "Discover the challenge", "bundle.id_page.challenges_sections.title": "Challenges", "bundle.id_page.documents.required_access": "You need premium access to see this document", "bundle.id_page.documents_sections.title": "Documents", "bundle.id_page.hero.access_until_text": ["You have valid access to this content until ", ["accessUntil"]], "bundle.id_page.hero.client_text": ["Exclusive to ", ["clientName"], " members"], "bundle.id_page.hero.extend_access": "Extend access", "bundle.id_page.hero.get_access_btn": "Get access", "bundle.id_page.hero.options_menu": "Options", "bundle.id_page.hero.tooltip_text": "Get access to this content in the next step. For content exclusive to members to a Yogobe partner – please enter your unique access code. For content exclusive for Yogobe members – please log in to your account, you need an active trial period or paying subscription.", "bundle.id_page.live_sections.title": "LIVE sessions", "bundle.id_page.playlists_sections.title": "Playlists", "bundle.id_page.program.discover_button": "Discover the program", "bundle.id_page.programs_sections.title": "Programs", "bundle.id_page.videos_sections.title": "Video & audio", "button.spring_challenge.end": "Join Yogobe Summer Challenge", "button.winter_challenge.end": "Join Yogobe Spring Challenge", "button_add_to_playlist.hidden": "Hidden", "button_add_to_playlist.private": "Private", "button_add_to_playlist.public": "Public", "buy_gift.send_email_directly_label": "buy_gift.send_email_directly_label", "campaign.infos_show_less": "Show Less", "campaign_info.read_less": "Hide text", "campaign_info.read_more": "Read More", "cancel_subscription_modal_four.paragraph": "We wish you all the best, you are always welcome back!", "cancel_subscription_modal_four.title": "It’s sad to see you go…", "cancel_subscription_modal_one.button_one": "Go back, I changed my mind", "cancel_subscription_modal_one.button_two": "Yes, cancel subscription", "cancel_subscription_modal_one.paragraphe_one": ["If you choose to cancel your premium subscription today, you will as of ", ["date"], " no longer have unlimited access to Yogobe's constantly growing video library."], "cancel_subscription_modal_one.paragraphe_two": "It is our constant ambition to improve our services and welcome your feedback and thoughts.", "cancel_subscription_modal_one.title": "Are you sure you want to cancel your subscription?", "cancel_subscription_modal_three.button_activate": "Activate 7 extra days and stay", "cancel_subscription_modal_three.paragraph": "We’re happy to offer you 7 more days in case you’d like to try out Yogobe for free.", "cancel_subscription_modal_three.title": "I have not found time", "cancel_subscription_modal_two.checkbox1": "I had trouble finding videos that suited me", "cancel_subscription_modal_two.checkbox2": "I have not found time", "cancel_subscription_modal_two.checkbox3": "I can not prioritize Yogobe at the moment", "cancel_subscription_modal_two.checkbox4": "Other reason", "cancel_subscription_modal_two.title": "Why do you choose to cancel your subscription today?", "cast_modal.subtitle": "in order to cast sessions, upgrade your membership and get unlimited access to the entire library, programs and much more!", "cast_modal.title": "This is a premium feature", "cast_modal.view_offers": "View Offers", "challenge.week.infobar": "Complete three sessions/videos each week, over four weeks to meet the Challenge target. Note: The videos watched through Cast unfortunately can not be marked as done", "challenge_2021.banner.discount_text": "Pay only 9,99 EUR for my first month*", "challenge_2021.banner.verify_account": "Verify your account to get your trial access and be able to start the challenges ", "challenge_2021.challenges_section.title": "Choose one of 5 challenge programs", "challenge_2021.contact.contact_text": "Contakt: <0>business@yogobe.com</0>", "challenge_2021.contact.desc": "challenge_2021.contact.desc", "challenge_2021.contact.purchase_banner_back": "Go back", "challenge_2021.contact.title": "challenge_2021.contact.title", "challenge_2021.features_section.title": "Vad är du i behov av?", "challenge_2021.get_started.button.continue": "Continue", "challenge_2021.get_started.button.continue_trial": "Continue with a 14 day free trial", "challenge_2021.get_started.button.start_suscription": "Start a subscription", "challenge_2021.get_started.button.upgrade_continue": "Upgrade and continue", "challenge_2021.get_started.description": "We're so happy that you want to join our program. Programs and challenges are included in Yogobe's subscriptions and business packages. Click on \"Start program\" below to access the program and its content.", "challenge_2021.get_started.guest_title": ["Welcome to ", ["program"]], "challenge_2021.get_started.option.have_account": "I already have a members account", "challenge_2021.get_started.option.no_account": "I don’t have a members account", "challenge_2021.get_started.show_code_input": "Have you received an access code to the program from your workplace or an organisation? <0>Click here</0>", "challenge_2021.get_started.show_code_input_description": "This code is usually provided by a person from within your company or organization ", "challenge_2021.get_started.user_title": ["Dear ", ["name"], ", welcome to ", ["program"]], "challenge_2021.get_started_loggedin.description": "We're so happy that you want to join our program. Programs and challenges are included in Yogobe's subscriptions and business packages. Click on \"Start program\" below to access the program and its content.", "challenge_2021.listing_page.hero.no_premium_desc": "Welcome Yogobe Challenge! Get unlimited access to all challenge programs by starting a subscription from 99 SEK only*", "challenge_2021.listing_page.hero.no_premium_disclaimer": "*This price is valid for your first month only and will automatically convert to ordinary price of 19,99 EUR for recurring payments.", "challenge_2021.listing_page.hero.premium_desc": "Welcome to Yogobe Challenge! Stay motivated, prioritize your well-being and challenge yourself with one of the programs below.*", "challenge_2021.listing_page.hero.premium_disclaimer": "*As long as you are on a premium subscription plan you have access to programs and challenges.", "challenge_2021.listing_page.hero.title": "Yogobe Challenge <0>new</0>", "challenge_2021.metadata.browse_challenges": "Browse challenge programs", "challenge_2021.metadata.explore_challenges_btn": "Explore the Challenge programs", "challenge_2021.metadata.get_started_btn": "Get started", "challenge_2021.metadata.how_it_works_btn": "How it works", "challenge_2021.metadata.start_now_btn": "Start now for 99 SEK*", "challenge_2021.metadata.tags.challenge": "Challenge", "challenge_2021.metadata.tags.participating": "Participating", "challenge_2021.steps_section.step1.desc": "Whatever your need is, we've got you covered. We are always working on adding more content.", "challenge_2021.steps_section.step1.title": "1. Choose your Challenge program", "challenge_2021.steps_section.step2.desc": "Find the challenge program you want to start with, activate your access* and get instant access!", "challenge_2021.steps_section.step2.title": "2. Start the challenge", "challenge_2021.steps_section.step3.desc": "Try to take 3 classes every week for four weeks. Consistency is key!", "challenge_2021.steps_section.step3.title": "3. Challenge yourself", "challenge_2021.steps_section.step4.desc": "Now that you have completed the challenge, maintain the habit by retaking it or choosing a completely new one.", "challenge_2021.steps_section.step4.title": "4. Maintain the good habit!", "challenge_2021.steps_section.title": "Here is a step by step guide", "challenge_form.already_applied": ["We are almost there. We have emailed you via ", ["email"], ". Should you have any questions, please contact us: info@yogobe.com"], "challenge_form.already_applied_paragraph": ["Have you not received the email? <0>Click and resend (", ["count"], "s)</0>"], "challenge_form.didnt_apply": "You can switch programs in the Challenge", "challenge_form.didnt_apply_1": ["Dear ", ["firstName"], ", please fill out the form for complete access to ", ["title"], "!"], "challenge_form.didnt_apply_2": ["Fill out the form for compete access to ", ["title"], "!"], "challenge_form.email": "Email", "challenge_form.errors.email_used": "The email you entered already exists. If it belongs to you, please log in.", "challenge_form.errors.required": "This field is required", "challenge_form.first_name": "First name", "challenge_form.gotoprogram": "Go to program", "challenge_form.inprogram": ["You are currently active in the <0>", ["name"], "</0> program."], "challenge_form.last_name": "Last name", "challenge_form.level": "Program", "challenge_form.level_note": "Scroll down to read more", "challenge_form.login": "challenge_form.login", "challenge_form.reset_program": "Want to change program? <0>Click here to edit</0>", "challenge_form.submit": "Get started", "company.access_code_action": "Enter access code", "company.empty_company_programs_courses": ["Enter your access code to see ", ["companyName"], "’s courses and programs"], "company.playlists_description": ["Any playlists presented here are collections of audio and video content put together by ", ["companyName"]], "company.recommended_blog_posts": "Recommended Blog Posts", "confirm_delete_playlist_modal.description": ["You are about to permanently delete the playlist <0>", ["title"], "</0>, which contains ", ["videos_count"], " sessions. This action can not be undone. Do you want to proceed?"], "confirm_delete_playlist_modal.no": "No, keep the playlist", "confirm_delete_playlist_modal.title": "Delete Playlist", "confirm_delete_playlist_modal.yes": "Yes, I want to delete the playlist", "consent.cookies.accept": "Accept cookies", "consent.cookies.desc": "We use our own and third-party cookies to personalize content for you and improve our service through analyzing web traffic.", "consent.cookies.read_more": "Read more about cookies", "consent.cookies.reject": "Reject ", "consent.cookies.title": "We use cookies", "courses_2021.banner.verify_account": "Please verify your email address to activate your membership.", "courses_2021.buy_gift.banner_text": "You are buying this course as a gift. If you wish to get access to it for yourself, <0>click here</0>", "courses_2021.buy_gift.description": "We’re happy that you wish to give this course to a friend, as a gift", "courses_2021.buy_gift.description_tooltip": "Upon payment, you will recieve an email including the course gift voucher and instructions on how to activate the program", "courses_2021.buy_gift.meta_title": ["Yogobe course - ", ["title"]], "courses_2021.contact.contact_text": "Contact: <0>business@yogobe.com</0>", "courses_2021.contact.desc": "We are so happy that you and your organization are interested in getting started with Yogobe. Digital, accessible and easy to get started. Together we develop and tailor content and support with the purpose of promoting both physical and mental health within companies and organizations for individuals and emplyees. The format of our courses is perfect for teams that meet remotely and workplaces that seek inspiration and guidance for an active everyday life. A wide variety of interest and needs are taken into account – there is something for everyone. To get started, contact me via email!", "courses_2021.contact.purchase_banner_back": "courses_2021.contact.purchase_banner_back", "courses_2021.contact.title": "Welcome to Yogobe courses! ", "courses_2021.expiration_banner.expire_soon.buy_program_text": ["Your access to this course expires in ", ["days"], " days. Extend access now to continue the course. All your progress is saved. <0>Paying via wellness provider?</0>"], "courses_2021.expiration_banner.expire_soon.renew_access_free_text": ["Your access to this course expires in ", ["days"], " days. Extend access now for free. All your progress will be saved."], "courses_2021.expiration_banner.expire_soon.upgrade_to_renew_text": ["Your access to this course expires in ", ["days"], " days. Upgrade to a paying subscription and unlimited access to this course is included. All your progress has been saved."], "courses_2021.expiration_banner.expired.buy_program_text": ["Your access to this course expired ", ["days"], " days ago. Renew access to continue the course. All your progress has been saved."], "courses_2021.expiration_banner.expired.renew_access_free_text": ["Your access to this course expired ", ["days"], " days ago. Renew access now for free. All your progress is saved."], "courses_2021.expiration_banner.expired.renew_with_discount_text": ["Your access to this course expired ", ["days"], " days ago. Renew access now and get a ", ["discount"], " discount. All your progress has been saved. <0>Paying via wellness provider?</0>"], "courses_2021.expiration_banner.expired.upgrade_to_renew_text": ["This course expired ", ["days"], " ago. You can renew access now for free."], "courses_2021.expiration_banner.expires_soon.extend_with_discount_text": ["Your access to this course expires in ", ["days"], " days. Renew access now and get a ", ["discount"], " discount. All your progress is saved. <0>Paying via wellness provider?</0>"], "courses_2021.get_started.access_code.icon_text": "Enter your unique code in the above box", "courses_2021.get_started.access_code.not_valid": "The code you provided is not valid!", "courses_2021.get_started.access_code.tooltip_text": "You can use different kindes of codes with Yogobe. They give you access or discounts to different segments of our vast content library.  Access code: A code which you might recieve from your employer or partner organisation to Yogobe.  Gift voucher: A code you may have received from a friend.  Discount code: A code / loyalty offer which gives you a discount on a segment or service within Yogobe.", "courses_2021.get_started.access_code.valid": "The code has been applied!", "courses_2021.get_started.access_code_mismatch": "This code is valid but activates another course", "courses_2021.get_started.access_code_only_description": "Welcome!<br/> This course is only joinable using an access code. This code will be provided to you via either Yogobe, a partner organization or a specific company/employer.", "courses_2021.get_started.activation_error": "Sorry, we were unable to activate the course for you, please contact us at info@yogobe.com", "courses_2021.get_started.button.activate_for_free": "Activate", "courses_2021.get_started.button.continue_trial": "Continue with a 14 day free trial", "courses_2021.get_started.button.login": "Login and continue", "courses_2021.get_started.button.purchase": "Proceed to secure payment", "courses_2021.get_started.button.start_suscription": "Start a subscription", "courses_2021.get_started.code_label": "Your unique code", "courses_2021.get_started.description": "Welcome!<br/> You may join this course by paying for it or if you have an access code or gift voucher!", "courses_2021.get_started.end_of_access": "Access until", "courses_2021.get_started.guest_title": ["Welcome to ", ["program"]], "courses_2021.get_started.join_btn": "Join course", "courses_2021.get_started.option.have_account": "I already have a members account", "courses_2021.get_started.option.no_account": "I don’t have an account", "courses_2021.get_started.purchase_banner_text": "If you are representing an organization and would like to purchase access for your employees, <0>Click here</0>", "courses_2021.get_started.show_code_input": "Do you have a unique code? <0>Click here</0>", "courses_2021.get_started.show_code_input_description": "A code can be either an access code, gift voucher or give you a specific discount.", "courses_2021.get_started.user_title": ["Dear ", ["name"], ", welcome to ", ["program"]], "courses_2021.get_started_loggedin.description": "Welcome!<br/> You may join this course by paying for it or if you have an access code or gift voucher!", "courses_2021.header.access_until": ["Access to this course expires on ", ["date"]], "courses_2021.listing_page.hero.no_premium_disclaimer": "Paying with wellness grant? <0>Learn more here</0>", "courses_2021.listing_page.hero.premium_disclaimer": "Paying with wellness grant? <0>Learn more here</0>", "courses_2021.listing_page.meta.description": "Welcome to Yogobe courses – tailored to meet a number of different needs and interests we have created online courses / immersions together with leading experts. This segment lives outside of the Yogobe Subscription offering. Courses are bought with one-time payments with each up to 12 months access. Explore the different courses today and participate in one or several at a time.", "courses_2021.listing_page.meta.title": "Yogobe Courses", "courses_2021.listings_page.clear_events_filters": "Clear filters & search", "courses_2021.listings_page.explore_programs_btn": "Explore courses", "courses_2021.listings_page.faq_btn": "FAQ", "courses_2021.listings_page.filters.languages": "Show me courses in", "courses_2021.listings_page.hero_title": "Yogobe courses", "courses_2021.listings_page.load_more_btn": "Show more courses", "courses_2021.listings_page.no_programs_found": "Oops... We could not find a course that matches this specific search term or combination of filters. This does not mean that we do not have what you are looking for. Please try clearing the filters or reword your search query!", "courses_2021.listings_page.search_input_placeholder": "Search Yogobe courses…", "courses_2021.listings_page.subtitle": "Tailored to meet a number of different needs and interests we have created online courses / immersions together with leading experts. This segment lives outside of the Yogobe Subscription offering, Yogobe Play. Courses are bought with one-time payments with each up to 12 months access. Explore our different courses today and participate in one or several at a time.", "courses_2021.other_courses": "Other courses", "courses_2021.program_page.breadcrumb": "Yogobe courses", "courses_2021.progress_page.parts_title": "Course content", "courses_2021.progress_page.video_lock.button_text": "Join course", "courses_2021.progress_page.video_lock.text": "You have just watched a 60 second preview. Would you like to login and/or start this course now to unlock all its contents?", "courses_2021.snackbars.access_granted": "You successfully joined this course", "courses_listing.faq.item1.body": "Our online courses are not part of Yogobe Play and subscriptions, which means they are purchased separately, whether you already are a paying member or not. In order to participate in a course, log in to your account on Yogobe and proceed with a purchase of your chosen course.", "courses_listing.faq.item1.title": "Who can participate in an online course?", "courses_listing.faq.item10.body": "Our courses have recently got a similar design and structure to our programs and challenges. The new structure was created to improve the user experience, for example the participants are now able to see their progress in a much clearer and more rewarding way, amongst other great features.", "courses_listing.faq.item10.title": "What does the new course design and structure imply?", "courses_listing.faq.item11.body": "When your access time to a course expires, you will be offered a renewal at a discounted price, which generally is 30% off the original price. If you choose not to renew the course, you will lose access to it upon the expiration of your access time. However, your course progress is saved in case you wish to extend your access and use the offered discount at a later time.", "courses_listing.faq.item11.title": "What happens when my access time expires?", "courses_listing.faq.item12.body": "Yes! If you wish to participate in a course for a longer time than its access time (which usually is up to 12 months – see the specifics for each course) you are able to extend the access by buying it at a discounted price, which usually is a 30% discount. The offer is valid from your last 30 days of access and onwards, even when your access period has expired. <br/> <br/> This offer only applies to purchases made directly on <a href=\"https://www.yogobe.com\">www.yogobe.com</a> and is not valid if you’ve initially purchased the course through a wellness grant provider.", "courses_listing.faq.item12.title": "Will I receive a discount if I purchase the course again at a later time?", "courses_listing.faq.item13.body": "When you click on the course, go to the top right of the overview page and find a large box. Click on the three dots in the upper right corner of the box and select Extend access. When the course has 30 days of access left or has already expired, you will also see a banner on top of the page where you can click on Extend/Renew access.", "courses_listing.faq.item13.title": "How do I extend my access time to a course?", "courses_listing.faq.item14.body": "1) If you wish to purchase the course that yourself are participating in as a gift for someone else: Go to the course overview page. At the top right of the page you will find a large box – click on the three dots in its upper right corner. Proceed by clicking on Buy as a gift. <br/> <br/> 2) If you wish to purchase a course that you are not participating in as a gift: <br/> <br/> Click on the course you wish to purchase as a gift, then click on the link Buy as a gift – which you find next to the main button Join Course.  <br/> <br/> A gift card is valid for 12 months from the date of purchase.", "courses_listing.faq.item14.title": "How do I purchase a course as a gift?", "courses_listing.faq.item15.body": "All courses are purchased with a one-time payment and your participation can’t be canceled at the moment. The course you’ve purchased will be available to you until the access time has expired. Soon, we will add a feature where you will be able to stop/archive the course if you wish to.", "courses_listing.faq.item15.title": "Can I cancel my participation in a course?", "courses_listing.faq.item16.body": "Click on the course you have received an access code to. Click “Join course”. <br/> Find the text: “Do you have a unique code? Click here” and click on the link. <br/> Fill in the code in the box and click on ✓.", "courses_listing.faq.item16.title": "How do I join a course via an access code?", "courses_listing.faq.item2.body": "Begin by clicking on the course you are interested in purchasing. Then click on the button Join course and fill in your payment information. You will be offered two choices, either making a one-time payment with a credit card or directly through Swish. The course will be activated as soon as the purchase have been completed.", "courses_listing.faq.item2.title": "How do I purchase a course?", "courses_listing.faq.item3.body": "Yes, you can purchase an online course with your wellness grant. Begin by making your purchase directly on www.yogobe.com. You will then find your receipt through your profile in the upper right corner of the page. Click on My settings and then on <a href=\"https://yogobe.com/en/me/settings/receipts\">My receipts</a> to download your receipt to your device.", "courses_listing.faq.item3.title": "Can I purchase a course with my wellness grant?", "courses_listing.faq.item4.body": "Yes, absolutely! Our online courses are available through Benify, Wellnet and ePassi.", "courses_listing.faq.item4.title": "Can I purchase a course through a wellness grant partner?", "courses_listing.faq.item5.body": "No, our online courses are not included in any of our subscriptions – they are purchased separately. You do not need to have an active subscription to be able to purchase or participate in our online courses. However, you must have an account on Yogobe to be able to log in, proceed with your purchase and participate in the course you’ve chosen.", "courses_listing.faq.item5.title": "Are any of the courses included in my subscription?", "courses_listing.faq.item6.body": "When you purchase a course, you are granted access for up to 12 months, regardless of the length of the course itself. Please see the specifics of each course to learn about its access time.", "courses_listing.faq.item6.title": "For how long do I have access to a course?", "courses_listing.faq.item7.body": "You can find your active courses under your <a href=\"https://yogobe.com/en/me/dashboard\">Dashboard</a>. To access your profile, you need to be logged in to your Yogobe account.", "courses_listing.faq.item7.title": "I have purchased a course, where do I find it?", "courses_listing.faq.item8.body": "At the moment courses are only available through our website www.yogobe.com. But you can always access them through a web browser on your smartphone. Soon, courses will be available through the apps as well.", "courses_listing.faq.item8.title": "Can I participate in a course through the app?", "courses_listing.faq.item9.body": "Absolutely! You can participate in as many courses as you would like at the same time.", "courses_listing.faq.item9.title": "Can I purchase and participate in more than one course at a time?", "createplaylist_modal.actions.primary": "Save", "createplaylist_modal.actions.secondary": "Cancel", "createplaylist_modal.description.label": "Description", "createplaylist_modal.description.placeholder": "Provide a description for your playlist", "createplaylist_modal.hidden_helper": "Your playlist is hidden.", "createplaylist_modal.hidden_title": "Hidden Playlist", "createplaylist_modal.name.label": "Name", "createplaylist_modal.name.placeholder": "Give your playlist a title", "createplaylist_modal.options.one": "Public", "createplaylist_modal.options.three": "Private", "createplaylist_modal.options.two": "Hidden", "createplaylist_modal.privacy_helper": "Your profile is currently set to private but this playlist will still be visible to the public. <0>Edit Privacy Settings.</0>", "createplaylist_modal.private_helper": "Your playlist is private.", "createplaylist_modal.private_title": "Private Playlist", "createplaylist_modal.public_helper": "Your playlist may be shown in public listings and promoted to other users.", "createplaylist_modal.public_title": "Public playlist", "dashboard.bundles_section.title": "Your bundles", "dashboard.challenges_section.description": ["You currently participate in ", ["count"], " challenges"], "dashboard.challenges_section.discover": "Discover our challenges", "dashboard.challenges_section.explore_programs": "Explore Yogobe Challenges", "dashboard.challenges_section.title": "Your challenges", "dashboard.courses_section.description": ["You currently participate in ", ["count"], " courses"], "dashboard.courses_section.discover": "Discover our courses", "dashboard.courses_section.empty_list": "You are currently not part of any course", "dashboard.courses_section.explore_courses": "Explore Yogobe Courses", "dashboard.courses_section.title": "Your courses", "dashboard.events_section.discover": "Discover new upcoming LIVE sessions", "dashboard.events_section.empty_list": "You don't have any upcoming LIVE sessions", "dashboard.events_section.expired_events": "Expired LIVE-sessions", "dashboard.events_section.explore": "Explore all LIVE sessions", "dashboard.events_section.show_previous_events": "Show my previous sessions", "dashboard.events_section.title": "Your booked live events", "dashboard.for_me.courses.title": "Courses for you", "dashboard.for_me.playlists.title": "Playlists recommended for you", "dashboard.for_me.programs.title": "Programs for you", "dashboard.for_me.videos.title": "Videos recommended for you", "dashboard.last_watched_sessions_section.title": "My latest viewed sessions", "dashboard.my_stats.beta_stripe_message": "This feature is in beta, some results may not be 100% accurate. As you increase your interactions with our service we will collect more and more data on your behalf and find ways of illustrating it here with graphs and diagrams. This is our first version. Our goal is to provide you with a clear and transparent overview of your Yogobe-activity. If there are things you feel are missing, please connect: data@yogobe.com", "dashboard.my_stats.challenges_started": "Number of challenges started", "dashboard.my_stats.completed_sessions": "Number of sessions completed", "dashboard.my_stats.courses_started": "Number of courses started", "dashboard.my_stats.empty_result": "Use our service and we will visualize your data", "dashboard.my_stats.explore_challenges": "Explore Yogobe challenges", "dashboard.my_stats.explore_courses": "Explore yogobe courses", "dashboard.my_stats.explore_library": "Explore Yogobe library", "dashboard.my_stats.explore_live_events": "Explore Yogobe LIVE", "dashboard.my_stats.explore_programs": "Explore Yogobe programs", "dashboard.my_stats.explore_yogobe_team": "Explore Team Yogobe", "dashboard.my_stats.favorited_sessions": "Number of sessions favorited", "dashboard.my_stats.live_events_booked": "Number of LIVE events booked", "dashboard.my_stats.most_watched_instructors": "Top 3 most viewed experts", "dashboard.my_stats.most_watched_instructors<<<<<<< HEAD": "Your top 3 most watched experts>>>>>>> master>>>>>>> master", "dashboard.my_stats.most_watched_styles": "3 most watched session styles", "dashboard.my_stats.my_favorited_sessions": "View my favorites", "dashboard.my_stats.my_playlists": "View my playlists", "dashboard.my_stats.period_month": "Last 30 days", "dashboard.my_stats.period_week": "Last 7 days", "dashboard.my_stats.playlists_created": "Number of playlists created", "dashboard.my_stats.programs_started": "Number of programs started", "dashboard.my_stats.three_most_watched_styles": "Your total audio and video engagement in minutes", "dashboard.my_stats.title": "Your personal engagement and statistics", "dashboard.pricing_description": "Which premium membership option do you prefer?", "dashboard.pricing_title": "Subscribe to a premium plan for full access to our video library", "dashboard.programs_section.description": ["You currently participate in ", ["count"], " programs"], "dashboard.programs_section.discover": "Discover our programs", "dashboard.programs_section.empty_list": "You are currently not part of any program", "dashboard.programs_section.explore_programs": "Explore Yogobe Programs", "dashboard.programs_section.title": "Your programs", "dashboard.recommendation.empty.button": "Edit preferences", "dashboard.recommendation.empty.desc": "Tell us about your interests and needs to get recommended content!", "dashboard.recommendation.empty.title": "Recommended videos & playlists", "dashboard.recommendations.complete_onboarding": "Let's do it", "dashboard.recommendations.content_languages": "Show me recommended content in:", "dashboard.recommendations.edit_preferences": "Edit preferences", "dashboard.recommendations.filter_default_label": "Filter by interests & needs", "dashboard.recommendations.meta_title": "Recommended for you", "dashboard.recommendations.title": "Your recommended content is based on preferences you have selected. You can edit anytime.", "dashboard.recommendations.view_recommendations": "Would you like to find videos that meet your interests and needs? <0>View your recommendations</0>", "dashboard.recommendations.visit_recommendations": "Let us recommend videos and playlists based on your interests and needs!", "dashboard.settings.email_settings.desc": "Control which emails you'd like to receive. You can change these settings at any time.", "dashboard.settings.email_settings.title": "Manage email notifications", "dashboard.settings.email_update_failed": ["For some reason we could not save your email address. Please try again or contact <0>", ["email"], "</0> so that we can help you out!"], "dashboard.settings.live_codes.banner_desc": "Select your desired LIVE class and click on <0>Book</0>, in the next step enter your code in the <0>Access code</0> field and apply it to get access to the class in question without any further payment! <0></0> PS. The codes are unique to your account only and cannot be shared.", "dashboard.settings.live_codes.banner_title": "How to apply the code?", "dashboard.settings.live_codes.code_label": "LIVE code", "dashboard.settings.live_codes.empty_text": "You currently dont have any LIVE event codes.", "dashboard.settings.live_codes.events": "Eligible LIVE events", "dashboard.settings.live_codes.expiration": ["Expiring on ", ["date"]], "dashboard.settings.live_codes.multiple_usage_code_item": ["Redeemed on ", ["usageDate"], " on ", ["title"], " with ", ["instructor"], "."], "dashboard.settings.live_codes.multiple_usage_code_left": ["You can still use this code ", ["availableUsage"], " times."], "dashboard.settings.live_codes.multiple_usage_code_summary": ["This code has been redeemed ", ["usedTimes"], " out of ", ["usageLimit"], " times."], "dashboard.settings.live_codes.single_usage_code": ["This code was redeemed on ", ["usageDate"], " on ", ["title"], " with ", ["instructor"], "."], "dashboard.settings.live_codes.title": "LIVE access codes", "dashboard.settings.live_codes.trial_panel.desc": "As part of your trial, you have received two access codes that can be redeemed in any of our premium LIVE classes. <0>Explore Yogobe LIVE</0>", "dashboard.settings.live_codes.trial_panel.title": "Codes to test Yogobe LIVE ", "dashboard.settings.live_codes.trial_panel.title_tooltip": "These two free LIVE codes are a part of your Yogobe trial. They are valid for 60 days from your account creation. <0>Explore Yogobe LIVE</0>", "dashboard.settings.live_codes.wellness_panel.desc": ["You have purchased a LIVE code package through ", ["provider"], " on ", ["date"], ". Use your code/codes on the LIVE events listed below."], "dashboard.settings.live_codes.wellness_panel.title": "Friskvårdsbidrag LIVE code", "dashboard.settings.live_codes.wellness_panel.title_tooltip": "This is usually a code/package you have purchased through your wellness provider.", "email_preferences.prefrences_updated": "email_preferences.prefrences_updated", "email_preferences_page.desc": "Control which emails you'd like to receive. You can change these settings at any time either by clicking on the link in the footer of our marketing emails or via your Dashboard on Yogobe.com ", "email_preferences_page.title": "Manage email notifications", "emptyresults.click_here": "Click here", "emptyresults.empty": "Oops… 0 results found.", "emptyresults.empty_filter": "We cannot find results to match your search. Please adjust your chosen tags or use the search bar. Obs: Your results are affected by your language preferences in the <0>Video settings</0>. We welcome you to review and edit them!", "emptyresults.to_clear_filters": "to clear all filters", "emptyresults.try_adjusting_or": "Adjust your search criteria for more results, or", "error.action": "Take me to the start page", "error.body_404_part1": "You are trying to acces a page on Yogobe which does not seem to exist.", "error.body_404_part2": "Something seems to be upside down. Please use our search feature to find what it is you are looking for and thank you for visiting Yogobe.", "error.body_500": "Most likely there is an issue with the link which you've clicked. It could also be a browser or internet connection issue. Please refresh your page or test Google Chrome. If the issue persists PLEASE report your experience to <0>data@yogobe.com</0> so that we immediately can look into it and get back to you with a fix. Thank you!", "error.dear_visitor": "You should not be seeing this page.", "error.server_error": "You should not be seeing this page.", "errors.maxlength": [["length"], " characters is the maximum number"], "favorites.empty_playlists_description": "You have not yet marked any playlists as favorites", "favorites.empty_playlists_title": "My favorite playlists", "favorites.empty_videos_description": "You have not yet marked any videos as favorites", "favorites.empty_videos_title": "My favorite videos", "favorites.playlists_company_empty_description": [["companyName"], " hasn't marked any playlists as favorites yet"], "favorites.playlists_company_empty_title": "Favorite playlists", "favorites.playlists_company_second_empty_description": "This company isn't sharing any favorite playlists at the moment", "favorites.playlists_public_profile_empty_description": "This member isn't sharing any playlist favorites yet", "favorites.playlists_public_profile_empty_title": "Favorite playlists", "favorites.videos_company_empty_description": [["companyName"], " don't seem to have marked any videos from the library as favorites yet"], "favorites.videos_company_empty_title": "Favorite videos", "favorites.videos_public_profile_empty_description": "This member isn't sharing any video favorites right now", "favorites.videos_public_profile_empty_title": "Favorite videos", "featuredblgoposts.title": "Featured blog posts", "feedback_modal.icons.awesome": "I love this new beta", "feedback_modal.icons.happy": "I’m happy with the new beta", "feedback_modal.icons.hate": "I don't like this beta", "feedback_modal.icons.sad": "It needs improvement", "feedback_modal.question1": "How was your overall user experience?", "feedback_modal.question2": "Do you have any suggestions for improvement?", "feedback_modal.question3": "I have encoutered some bugs", "feedback_modal.title": "We’d love to hear your feedback", "footer.copyright": ["©YOGOBE ", ["year"], ". All rights reserved."], "footer.label2": "Social media", "footer.label3": "The service", "footer.languages.english": "English", "footer.languages.finnish": "Suomi", "footer.languages.label": "Language", "footer.languages.norwegian": "Norsk", "footer.languages.swedish": "Svenska", "footer.links.community": "Community", "footer.links.discover": "Discover", "footer.links.yogobe": "Yogobe", "forgot_password_modal.back": "Back to login", "forgot_password_modal.email": "Email", "forgot_password_modal.paragraph": "Enter your email address and you will receive an email containing instructions on how to reset your password.", "forgot_password_modal.send_instructions": "Send Intructions", "forgot_password_modal.title": "Forgotten your password?", "getstarted.breathe": "Breathe", "getstarted.meditation": "Meditate", "getstarted.move": "Move", "getstarted.yoga": "Yoga", "global_menu.course.courses_trainings.desc": "Deepen you knowledge within health, yoga & exercise.", "global_menu.course.courses_trainings.title": "Courses & trainings", "global_menu.course.events.desc": "Attend events hosted by us and our partners.", "global_menu.course.events.title": "Events", "global_menu.course.onlinekurser.desc": "Explore our online courses. ", "global_menu.course.onlinekurser.title": "Online courses", "global_menu.course.title": "Courses", "global_menu.course.travel_retreats.desc": "Discover and enjoy destinations worldwide.", "global_menu.course.travel_retreats.title": "Travel & retreats", "global_menu.live.title": "LIVE", "global_menu.more.about.desc": "Learn more about Yogobe.", "global_menu.more.about.title": "About us", "global_menu.more.blog.desc": "Insights, tips, and interesting reads.", "global_menu.more.blog.title": "Blog", "global_menu.more.business.desc": "Support for employers and organizations", "global_menu.more.business.title": "Business", "global_menu.more.contact.desc": "Say hello to us!", "global_menu.more.contact.title": "Contact us", "global_menu.more.en_business.item1": "Yogobe business", "global_menu.more.en_business.item2": "Classes and lectures", "global_menu.more.en_business.item3": "For yoga teachers", "global_menu.more.friskvårdsbidrag.desc": "global_menu.more.friskvårdsbidrag.desc", "global_menu.more.friskvårdsbidrag.title": "global_menu.more.friskvårdsbidrag.title", "global_menu.more.healthcare.desc": "global_menu.more.healthcare.desc", "global_menu.more.healthcare.title": "global_menu.more.healthcare.title", "global_menu.more.non_profit.desc": "global_menu.more.non_profit.desc", "global_menu.more.non_profit.title": "global_menu.more.non_profit.title", "global_menu.more.se_business.item1": "global_menu.more.se_business.item1", "global_menu.more.se_business.item2": "global_menu.more.se_business.item2", "global_menu.more.se_business.item3": "global_menu.more.se_business.item3", "global_menu.more.se_business.item4": "global_menu.more.se_business.item4", "global_menu.more.se_business.item5": "global_menu.more.se_business.item5", "global_menu.more.se_healthcare.item1": "global_menu.more.se_healthcare.item1", "global_menu.more.store.desc": "Purchase yoga mats, apparel, and more.", "global_menu.more.store.title": "Store", "global_menu.more.team.desc": "Get to know our experts.", "global_menu.more.team.title": "Team Yogobe", "global_menu.more.title": "More", "global_menu.more_menu.banner.button": "Read more", "global_menu.more_menu.banner.title": "Did you know you can use your wellness grant within Yogobe?", "global_menu.play.playlists.desc": "Browse our vast playlist collection.", "global_menu.play.playlists.title": "Playlists", "global_menu.play.programs.desc": "Get inspired and achieve your goals. ", "global_menu.play.programs.title": "Programs", "global_menu.play.title": "Play", "global_menu.play.video_audio.desc": "Discover 2100+ sessions", "global_menu.play.video_audio.title": "Video & audio", "global_menu.play.yogobe_challenge.desc": "Join a challenge and stay motivated.", "global_menu.play.yogobe_challenge.title": "Yogobe Challenge", "global_menu.search.title": "Search", "global_menu.store.title": "Store", "header.login": "Sign in", "header.try_free": "Try for free", "healthcare.listing_page.hero.no_premium_disclaimer": "*You need an access code from your employer, caregiver or a partner to Yogobe in order to access this program", "healthcare.listing_page.hero.premium_disclaimer": "*You need an access code from your employer, caregiver or a partner to Yogobe in order to access this program", "healthcare.listing_page.meta.description": "Programs within digital prevention and healh", "healthcare.listing_page.meta.title": "Yogobe Healthcare Programs", "healthcare.listings_page.explore_programs_btn": "Explore programs", "healthcare.listings_page.faq_btn": "FAQ", "healthcare.listings_page.hero_title": "Programs within digital health and prevention", "healthcare.listings_page.subtitle": "We help employers, health insurance companies and caregivers in supporting employees and patients with digital tools within mental and physical health and wellbering. Please explore our programs within digital prevention.", "healthcare_listing.faq.item1.body": "Anyone who has been provided with a prescription or access code from a caregiver, employer or health insurance company. These programs are part of Yogobe Healthcare, a segment of Yogobe not included in Yogobe Play, our consumer subscription service.", "healthcare_listing.faq.item1.title": "Who can participate in a program?", "healthcare_listing.faq.item2.body": "After you have registered and gained access to a program, you have easy access to it via the Yogobe app under \"My library\" or at the top of your <0>dashboard</0> when you are logged in to <1>yogobe.com</1>", "healthcare_listing.faq.item2.title": "How will I get access to my program?", "healthcare_listing.faq.item3.body": "Of course! Both employers and insurance and healthcare companies can purchase Yogobe and our programs as well as digital interventions, as support and complement to existing efforts for the benefit of individuals, employees and patients. Email us at <0>business@yogobe.com</0> and we'll tell you more.", "healthcare_listing.faq.item3.title": "Can companies buy individual programs?", "healthcare_listing.faq.item4.body": "No. If you enter Yogobe Healthcare with an access code that you have received from a patient association, healthcare provider, employer or insurance company, you personally pay nothing to access the specific Yogobe program or material that you have been prescribed.", "healthcare_listing.faq.item4.title": "Do I have to pay?", "healthcare_listing.faq.item5.body": "If you have a FaR prescription that you would like to use on Yogobe, please send a copy (a photo is OK) of your FaR prescription to <0>info@yogobe.com</0>. You will then receive instructions on how to easily get started with Yogobe's FaR-specific content.", "healthcare_listing.faq.item5.title": "How do I use my FaR prescription at Yogobe?", "hero.get_started": "Get started", "hero_thank_you.dashboard": "My dashboard", "hero_thank_you.gotoprogram": "Go to program", "hero_thank_you.reset": "Want to change program? <0>Click here to edit</0>", "hero_thank_you.thanks": ["Thank you ", ["firstName"], "!"], "hero_thank_you.you_are_in_program": ["You now have access to the program: <0>", ["program"], "</0>."], "homepage.courses_section.explore_marketplace": "Explore online courses>>>>>>> master>>>>>>> develop", "homepage.cta_section.pricing_btn": "Subscription options", "homepage.features_section.get_app_btn": "Get the app", "homepage.hero_section.register_btn": "homepage.hero_section.register_btn<<<<<<< HEAD", "homepage.hero_section.wellness_btn": "Wellnes grant", "homepage.mobile_section.app_store_btn": "App Store", "homepage.mobile_section.play_store_btn": "Play Store", "homepage.sections.register_btn": "Get started", "instructor.title": "About", "karolinska.get_started.access_code.label": "Access code", "karolinska.get_started.access_code.not_valid": "Access code you provided is not valid!", "karolinska.get_started.access_code.required": "You need an access code to access the program", "karolinska.get_started.access_code.requirement": "To join this program, an access code is required", "karolinska.get_started.access_code.valid": "Access code is valid!", "karolinska.get_started.activation_error": "Sorry, we were unable to activate the program for you, please contact us on info@yogobe.com", "karolinska.get_started.button.continue": "Continue", "karolinska.get_started.button.login": "Login and continue", "karolinska.get_started.button.register": "Create a 14-day free trial account", "karolinska.get_started.button.start_program": "Start the program", "karolinska.get_started.guest.welcome_message": "Welcome to the Stress Program", "karolinska.get_started.option.have_account": "I already have an account", "karolinska.get_started.option.no_account": "I don’t have an account", "karolinska.get_started.select_option": "Please choose what’s applicable for you", "karolinska.get_started.terms.label": "I accept the <0>terms and conditions</0>", "karolinska.get_started.terms.required": "Please agree to our terms and condition to continue!", "karolinska.get_started.user.welcome_message": ["Hey ", ["name"], ", welcome to the Stress Program"], "karolinska.preview_cover.guest.button": "Join Program", "karolinska.preview_cover.guest.video_locked": "if you have an access code to the program click the button below to get started.", "karolinska.preview_cover.user.video_locked": "You watched a 60 seconds preview. The full video will be unlocked after you complete the previous week(s).", "landing_page.offer.best_value": "Best value", "landing_page.offer.blue_section.cta_text": "Try 14 days for free", "landing_page.offer.blue_section.list_item1": "2100 videos for all your needs", "landing_page.offer.blue_section.list_item2": "Save offline. Yoga and exercise anywhere, anytime", "landing_page.offer.blue_section.list_item3": "Unlimited access to our video library, all programs and challenges", "landing_page.offer.blue_section.list_item4": "Create, share and add playlists to favorites", "landing_page.offer.blue_section.title": "What do you get as an active member?", "landing_page.offer.first_section.cta_text": "Start your 14 day trial", "landing_page.offer.free_trial": "14 day free trial", "landing_page.offer.getstarted": "Get Started", "landing_page.offer.most_affordable": "Most Affordable", "landing_page.offer.playlists_section.title": "Upptäck relevanta playlists", "landing_page.offer.programs_section.title": "Program som ingår för aktiva medlemmar", "landing_page.offer.subscription_annually_billed": "billed annually", "landing_page.offer.subscription_free_plan_label": "Unlimited access without entering bank details", "landing_page.offer.subscription_free_price_label": "Free", "landing_page.offer.subscription_free_title": "Free Trial", "landing_page.offer.subscription_monthly_billed": "billed monthly", "landing_page.offer.subscription_monthly_per": "/ month", "landing_page.offer.subscription_quarterly_billed": "billed quarterly and will automatically revert to ordinary pricing after three months", "landing_page.offer.subscription_quarterly_per": "/ quarter", "landing_page.offer.subscription_sub_title": "Subscribe for a year and and get a 500 SEK Yogiraj voucher.", "landing_page.offer.subscription_title": "Go Premium and access unlimited features", "landing_page.offer.testomonials_section.title": "Vad säger våra medlemmar?", "landing_page.offer.videos_section.title": "Utvalda videor för dina behov", "landingpage.hero.bullet1": "On-demand & LIVE online", "landingpage.hero.bullet2": "Watch offline through our app", "landingpage.hero.bullet3": "Free trial, cancel anytime", "landingpage.hero.cta": "14 day free trial", "landingpage.hero.subtitle": "A few minutes every day will do wonders for your health", "landingpage.hero.title": "Yoga, meditation and movement online", "landingpage.mobileapp_section.desc": "Download our new app today and share your feedback regarding how you use the app.", "landingpage.mobileapp_section.title": "Download the app and try it out today!", "landingpage.section2.desc": "We welcome you to practice yoga, meditation and explore home workouts with market leading teachers, instructors and therapists who are passionate about health and live to inspire more people to happy and healthy lives. Yogobe is easy to use any time – anywhere. Create and maintain a great habit together with us. As a member you will also join an amazing Community. Welcome to explore our service free of charge!", "landingpage.section2.link": "Explore 2000 videos", "landingpage.section2.title": "Yoga and home workouts for you", "landingpage.section2.trailer_tag": "Trailer", "landingpage.section4.item1.desc": "We support employers throughout the Nordics by providing access to tailormade health programs to meet the vast variety of individual health needs within an organisation. Our delivery is digital first but we also arrange courses, events, lectures and more within stress, sleep, focus and sustainability. Anything and everything to increase workplace health, a sense of community and minimzing physical and/or mental health issues. ", "landingpage.section4.item1.title": "Corporate health", "landingpage.section4.item2.desc": "Does your employer give you fringe health benefits? Check with them if they will cover your costs by accepting your receipts from Yogobe. Throughout Scandinavia we work with the health benefits corporation Benify. In Sweden other partners are: Actiway, Wellnet and ePassi and through their platforms it is easy to upgrade your Yogobe account.", "landingpage.section4.item2.title": "Wellness grant", "landingpage.section4.item3.desc": "We collaborate with foundations, associations and organisations on a mission to democratically provide everyone with tools and guidance for sustainable mental and physical wellbeing. Together we can be the change we wish to see in the world!", "landingpage.section4.item3.title": "Yogobe Non-profit", "landingpage.section4.readmore": "READ MORE", "landingpage.section5.title": "More at Yogobe", "landingpage.section6.cta": "14 day free trial", "landingpage.section6.disclaimer": "The trial period does not convert into a paying subscription", "landingpage.section6.subtitle": "Would you like unlimited access to classes, playlists, programs and challenges?", "landingpage.section6.title": "Yogobe membership", "landingpage.section7.title": "What do our members say about Yogobe?", "landingpage.squareitems.alt_text.book_retreat": "Book your next retreat or register for a yoga teacher training at Yogobe", "landingpage.squareitems.alt_text.deepen_your_knowledge": "Deepen your knowledge - check out our discounted online courses here.", "landingpage.squareitems.alt_text.getstarted": "Get started with Yogobe - for your online yoga and fitness practice.", "landingpage.squareitems.alt_text.live": "Experience our real-time classes online via Yogobe LIVE - check out the schedule here!", "landingpage.squareitems.alt_text.news_yogobe": "Check out our latest releases at Yogobe - videos, playlists & program within yoga, meditation, fitness and relaxation.", "landingpage.squareitems.alt_text.program_card": "Join our online program and explore mindfulness meditation with Eleonora Ramsby Herrera.", "landingpage.squareitems.alt_text.wellness_grant": "Read more about how you can use your wellness grant at Yogobe", "landingpage.squareitems.alt_text.ybteam": "Get to know Team Yogobe - with more than 90 experts within yoga, meditation, fitness and breathwork.", "landingpage.squareitems.challenge.text1": "Yogobe Challenge", "landingpage.squareitems.challenge.text2": "FIRST MONTH", "landingpage.squareitems.challenge.text3": "SEK", "landingpage.squareitems.challenge.text4": "99", "landingpage.squareitems.challenge.text5": "5 DIFFERENT CHALLENGES", "landingpage.squareitems.get_started.text1": "How do I", "landingpage.squareitems.get_started.text2": "easily get started", "landingpage.squareitems.get_started.text3": "with Yogobe?", "landingpage.squareitems.get_started.text4": "Step-by-step guide. Click here!", "landingpage.squareitems.live.text1": "LIVE", "landingpage.squareitems.live.text2": "Experience the energy of participating", "landingpage.squareitems.live.text3": "LIVE-online in real time", "landingpage.squareitems.live.text4": "Several classes", "landingpage.squareitems.live.text5": "each week", "landingpage.squareitems.marketplace.text1": "Do you want to book", "landingpage.squareitems.marketplace.text2": "a reatreat or", "landingpage.squareitems.marketplace.text3": "educate yourself within", "landingpage.squareitems.marketplace.text4": "yoga?", "landingpage.squareitems.marketplace.text5": "Go to Yogobe Marketplace", "landingpage.squareitems.online_courses.text1": "Deepen", "landingpage.squareitems.online_courses.text2": "your knowledge", "landingpage.squareitems.online_courses.text3": "Take part of the discounted", "landingpage.squareitems.online_courses.text4": "courses of the month", "landingpage.squareitems.running_program.text1": "Mindfulness meditation", "landingpage.squareitems.running_program.text2": "Program with Eleonora Ramsby Herrera", "landingpage.squareitems.team_yogobe.text1": "Get to know", "landingpage.squareitems.team_yogobe.text2": "Team Yogobe", "landingpage.squareitems.team_yogobe.text3": "with over 70 experts", "landingpage.squareitems.team_yogobe2.text1": "News at Yogobe", "landingpage.squareitems.wellness_grant.text1": "How can I", "landingpage.squareitems.wellness_grant.text2": "use my", "landingpage.squareitems.wellness_grant.text3": "wellness grant", "landingpage.squareitems.wellness_grant.text4": "at Yogobe?", "landingpage.squareitems.wellness_grant.text5": "Read more about it here.", "landingpage.testimonials.item1.name": "Ann-Sofie Forsmark", "landingpage.testimonials.item1.quote": "\"It is by far the best way for me and my kids to practice yoga, and for me to get access to SOMA.\"", "landingpage.testimonials.item1.title": "Health strategist", "landingpage.testimonials.item2.name": "Lori Wäne", "landingpage.testimonials.item2.quote": "\"To have access to yoga classes at home on the days I don't have the opportunity to go to a studio is incredibly valuable.\"", "landingpage.testimonials.item2.title": "Aspiring yoga teacher", "landingpage.testimonials.item3.name": "Malin Magnusson", "landingpage.testimonials.item3.quote": "\"In my eyes, Yogobe is incredibly affordable and it allows me to bring my health routine everywhere.\"", "landingpage.testimonials.item3.title": "Mother & multi-tasker", "landingpage.testimonials.item4.name": "Anna Åhlgren", "landingpage.testimonials.item4.quote": "\"To get inspiration from wise and fun colleagues\"", "landingpage.testimonials.item4.title": "Yoga teacher & storyteller", "live.event.levels.advanced": "Advanced", "live.event.levels.beginner": "Beginners", "live.event.levels.everyone": "Everyone", "live.event.levels.intermediate": "Intermediate", "live.event.levels.other": "Other", "live.event_page.about_event": "About the session", "live.event_page.all_event_link": "All sessions", "live.event_page.banner_donation_class": "Denna LIVE-klass är till förmån för Världsnaturfonden WWF", "live.event_page.book_btn": "Book", "live.event_page.booking_closed_banner": "Booking for this session is now closed.", "live.event_page.coming_soon": "Coming soon", "live.event_page.donation_class": "Donation class", "live.event_page.event_date_time": "Date & time of session", "live.event_page.event_free": "Free", "live.event_page.event_instructors": "Experts", "live.event_page.event_lang_label": "Language of session", "live.event_page.event_prerequisites": "Equipment", "live.event_page.expired_event": "Expired", "live.event_page.for_for_you": "Free for you", "live.event_page.fully_booked_event": "Fully booked", "live.event_page.join_btn": "Join now", "live.event_page.join_btn_reserved": "You've booked your spot", "live.event_page.no_prerequisites_required": "No equipment needed for this session", "live.event_page.prerequisites_yogobe_store": "Looking for equipment and props? <0>Visit Yogobe Store</0>", "live.event_page.recording_more_info": "More info", "live.event_page.recording_more_info_tooltip": "The recording expires about 24h after it's been generated by Zoom. Once that period passes you will no longer be able to watch this recorded LIVE session.", "live.event_page.registration_end_label": "Last possible time to book", "live.event_page.reserve_spot_banner.book_btn": "Book my spot", "live.event_page.reserve_spot_banner.browse_events": "Browse other sessions", "live.event_page.reserve_spot_banner.desc": ["Book your spot for <0>", ["event_name"], "</0> while it’s still available. "], "live.event_page.reserve_spot_banner.event_date": ["Date of session: ", ["date"]], "live.event_page.reserve_spot_banner.expired_desc": ["Signups for <0>", ["event_name"], "</0> is now closed. "], "live.event_page.reserve_spot_banner.last_registration_date": ["Sign up before: ", ["endDate"]], "live.event_page.reserve_spot_banner.reserved_desc": ["Your spot for <0>", ["event_name"], "</0> has been booked."], "live.event_page.reserve_spot_banner.reserved_title": "Booking confirmed!", "live.event_page.reserve_spot_banner.share_btn": "Share session", "live.event_page.reserve_spot_banner.title": "Reserve your spot!", "live.event_page.reserved_spot.click_join": "Click to join", "live.event_page.reserved_spot.hosted_zoom": "This session is hosted on Zoom", "live.event_page.reserved_spot.or_copy_link": "Or copy and paste the link in your browser", "live.event_page.reserved_spot.zoom_code_label": "Passcode", "live.event_page.spots_left": ["Only ", ["spots"], " spots left"], "live.event_page.sticky_banner.discount_available": "You get 30% discount since you have premium access.", "live.event_page.sticky_banner.free_for_you": "This session is included, without extra cost as part of your subscription ", "live.event_page.subscription_discount_text": "Weekly LIVE classes are included in a premium subscription. <0>Upgrade</0> ", "live.event_page.view_all_instructor_events": ["<0>View all sessions</0> with ", ["name"]], "live.event_page.watch_session_recording": "Watch the recorded session", "live.event_page.you_r_in_event": "Session booked", "live.listings.live_codes_card.description": "You have one or more available LIVE codes to use in some of our premium weekly classes", "live.listings.live_codes_card.description2": "Act now before they expire!", "live.listings.live_codes_card.see_code_btn": "See my codes", "live.listings.live_codes_card.title": "Very good to know:", "live.listings_page.banner.subscription_discount_text": "LIVE-classes are included in Subscriptions AND you get 30% off on all premium LIVE sessions. Choose the subscription type that suits you", "live.listings_page.clear_events_filters": "Clear filters & search", "live.listings_page.disclaimer": "LIVE-classes are included for all premium subscribers", "live.listings_page.explore_events_btn": "Explore the calendar", "live.listings_page.filter_applied_toaster": "Filters successfully applied", "live.listings_page.filters.donation_class": "Donation class", "live.listings_page.filters.free_event": "Free event", "live.listings_page.filters.instructors": "All experts", "live.listings_page.filters.kind_class": "Class", "live.listings_page.filters.kind_label": "All types", "live.listings_page.filters.kind_lecture": "Lecture", "live.listings_page.filters.kind_online_course": "Course", "live.listings_page.filters.kind_skills": "Skills", "live.listings_page.filters.kind_talk": "Talk", "live.listings_page.filters.kind_workshop": "Workshop", "live.listings_page.filters.languages": "Show me sessions in", "live.listings_page.filters.sort_by_date": "Date", "live.listings_page.filters.sort_by_price": "Price", "live.listings_page.filters.sort_label": "Sort by", "live.listings_page.filters.sort_mobile_label": "Sort & filter settings", "live.listings_page.filters.sort_modal_title": "Filter", "live.listings_page.hero_title": "Yogobe LIVE", "live.listings_page.load_more_btn": "Load more", "live.listings_page.no_events_found": "Oops... No sessions found for this search. Please remove the filters and/or reword your search.", "live.listings_page.pricing_section.title": "Our LIVE-classes are included for those with an active subscription!", "live.listings_page.search_input_placeholder": "Search LIVE sessions…", "live.listings_page.subtitle": "Meet teachers and other members for classes, workshops and lectures LIVE online. Team Yogobe will guide you in real time!", "live.live_page.metadata.desc": ["Check out LIVE session ", ["eventName"], " with ", ["instructor"], " - book your spot now or discover other sessions at yogobe.com/live"], "live.payment_page.access_code.not_valid": "Your access code is not valid", "live.payment_page.access_code.valid": "Access code is valid", "live.payment_page.action_button.activate": "Activate", "live.payment_page.action_button.login": "Login and continue", "live.payment_page.action_button.register": "Login and continue", "live.payment_page.action_button.start_suscription": "Create a 14-day free trial account", "live.payment_page.activate_email_banner": "We are very happy that you wish to join this LIVE-event. Before you can book we ask that you please verify your email address via the email we've sent to you!", "live.payment_page.code_input.description": "Have a code provided by us or by your employer?", "live.payment_page.code_input.description_tooltip": "If you have been provided with a LIVE discount or access code, this is where you enter it to get access to this LIVE class.", "live.payment_page.code_input.show_text": "If you have a discount or an access code, <0>click here</0>", "live.payment_page.countdown_banner": ["Complete the booking to secure your spot. Remaining time: <0>", ["min"], ":", ["sec"], " min</0>"], "live.payment_page.countdown_timeout_btn": "Back to the event page", "live.payment_page.countdown_timeout_desc": "The 10min reservation time for this booking has expired because no payment was made. Please go back and try again.", "live.payment_page.details": "You will receive a confirmation email with the link for the session. We will also send you a reminder 15 minutes before the session starts.", "live.payment_page.discount_amount": "Discount", "live.payment_page.discount_text": "Live classes are included in our subscription plans. You also get 30% discount on premium LIVE-events. Upgrade and you will be redirected back to this page automatically. <0>View offers</0>", "live.payment_page.donation_class_details": "Detta är en donationsklass till förmån för WWF. Om du inte redan har donerat en gåva till kampanjen Yoga for Nature så skulle vi bli tacksamma om du vill göra det. <0> Läs mer och donera hos WWF här!</0> <1></1> <1></1> När du har bokat din plats så får du ett email där vi bekräftar din anmälan och delar praktisk information.", "live.payment_page.event_accesscode_activated.toast": "The live event has successfully been booked!", "live.payment_page.free_event_reserved.toast": "The live event has successfully been booked!", "live.payment_page.free_reserve_spot": "Book your spot", "live.payment_page.payment_amount": "You’ll pay", "live.payment_page.payment_reserve_spot": "Proceed to Secure Payment", "live.payment_page.summary_title": "Order Summary", "live.payment_page.term_conditions": "I agree to Yogobes <0>payment & refund policy</0>", "live.payment_page.term_conditions_tooltip": "The terms related to Yogobe LIVE you will find under paragraph 4.10 in the Terms & Conditions. <0>Read more</0>", "live.paymentfail.body": ["Something went wrong… your payment of ", ["amount"], " has failed. Please try again. If the problems persists, contact our technical support team on <0>data@yogobe.com</0>"], "live.paymentfail.btn": "Go Back & Try Again", "live.paymentfail.orderdetails.body": ["Transaction ID: ", ["transaction"]], "live.paymentfail.title": "Payment Failed", "live.paymentsuccess.body": ["Thank you, your payment of ", ["amount"], " ", ["currency"], " has been received. An automated payment confirmation will be sent to ", ["email"]], "live.paymentsuccess.btn": "Continue", "live.paymentsuccess.orderdetails.body": ["Order ID: ", ["order"]], "live.paymentsuccess.title": "Payment successful!", "login_modal.action.create": "Create account", "login_modal.action.forgot": "Forgotten your password?", "login_modal.action.login": "Log in", "login_modal.action.or_create": "Not a member yet? <0>signup</0>", "login_modal.action.social_label": "Or login with", "login_modal.errors.incorrect": "Incorrect email address or password, please try again", "login_modal.errors.incorrect_socials": "We can't find a Yogobe member associated with your provided social account. If you are new to Yogobe please proceed and become a member with us using a social account, or if you'd rather prefer to sign up using your email address and personal password that works perfectly fine as well. <br><br>If you happen to already have an account and would like to connect it to one of your social accounts, please have patience with us. This is currently not possible. In the meanwhile, please log in as you have in the past, using email and password. ", "login_modal.helper": "Log in to access to our video library, online courses and your profile", "login_modal.inputplaceholder.email": "Email", "login_modal.inputplaceholder.password": "Password", "login_modal.title": "Log In", "login_page.landing.headline": "We are very happy to have you as a member!", "login_page.landing.subtitle": "Login and let us inspire, motivate and gudie you to more sustainable mental health and wellbeing", "maintenae_page.role": "Founder and CEO", "maintenance_page.body": "Between 04:00 and 05:00 today GMT+2, we are doing updates to the system!  <br /> We are very excited about all the good things happening on the tech side of Yogobe at the moment and kindly ask for your patience. As you cannot access our video library just now we’d like to recommend a short chat with the magical Alan Finger on the topic of stress and how yoga and meditation can help us cope with it. <a href=\"https://www.facebook.com/YOGOBEcom/videos/420176531509273/\">Find it via the Yogobes Facebook page.</a> <br /> All the best,", "maintenance_page.title": "Midnight updates", "menu_add_playlist.add": "Add to playlist", "menu_add_playlist.create": "Create new Playlist", "menu_more.schedule": "Schedule", "menu_more.share": "Share", "menu_more.share_page": "Share", "message1.spring_challenge.end": "The Spring Challenge is behind us. If you already have access to a program, it can be accessed via your dashboard. ", "message1.summer_challenge2020.end": "The Summer Challenge is behind us. If you already have access to a program, it can be accessed via your dashboard. ", "message1.winter_challenge.end": "The Winter Challenge is behind us. If you already have access to a program, it can be accessed via your dashboard. ", "message2.spring_challenge.end": "Do you want a new Challenge?", "message2.winter_challenge.end": "Do you want a new Challenge?", "meta.follow": "Follow", "metadata.accessUntil": "Access until", "metadata.active": "active", "metadata.all": "All", "metadata.and": "and", "metadata.apply": "Apply", "metadata.back_to_dashboard": "Back to dashboard", "metadata.bodyparts": "Bodyparts", "metadata.bonus": "Bonus", "metadata.browse_all": "Browse All", "metadata.challenge": "Challenge", "metadata.choose_file": "Choose a file", "metadata.clear_all": "Clear all", "metadata.close": "CLOSE", "metadata.code_activation.failed": "We’re sorry, an error has occurred during the activation of your code. Please write to us and we will help you! <0>Contact Yogobe</0>", "metadata.company_empty_playlists": "No public playlists ", "metadata.course": "Course", "metadata.courseLabel": "Course", "metadata.course_by": "Course by", "metadata.created_by": "Created by", "metadata.days.label": "Days", "metadata.delete": "Delete", "metadata.delete_playlist": "Delete Playlist", "metadata.document": "Document", "metadata.download": "Download", "metadata.downloadPDF": "Course outline", "metadata.download_all": "Download All", "metadata.duration": "Duration", "metadata.edit_playlist": "Edit Playlist", "metadata.edit_profile": "Edit Profile", "metadata.edite_privacy_settings": "Edit privacy settings", "metadata.empty_playlists": "You haven’t created any of your own playlists yet", "metadata.empty_playlists_action": "Discover playlists created by Yogobe", "metadata.english": "English", "metadata.exercise": "Exercise", "metadata.expire_on": ["This course expires on ", ["expirationDate"]], "metadata.expired_on": ["This course expired on ", ["expirationDate"]], "metadata.frequently_asked_questions.title": "Frequently asked questions", "metadata.getStarted": "Get started", "metadata.go_back_simple": "Go back", "metadata.introduction": "Introduction", "metadata.lecture": "Lecture", "metadata.load-more": "Load more", "metadata.login": "Login", "metadata.min": "min", "metadata.minuter": "minuter", "metadata.more": "more", "metadata.more_items": ["& ", ["number"], " more"], "metadata.my_stats": "View my statistics", "metadata.needs": "Needs", "metadata.new": "New", "metadata.next": "Next", "metadata.only_you_can_see_this": "Only you can see this", "metadata.payment.failed": "Unfortunately we couldn't process the payment with the details you provided. Please try again. If the issue persists contact us at <0></0>", "metadata.payment.success.continue_button": "Continue", "metadata.payment.success.receipt_button": "View reciept", "metadata.payment.success.title": "Payment completed", "metadata.paymentfail.btn": "Go Back & Try Again", "metadata.paymentfail.title": "Payment Failed", "metadata.playlists": "Playlists", "metadata.playlists_public_profile_empty_description": "This member is not yet sharing playlists", "metadata.please_wait": "Please wait...", "metadata.premium": "Premium", "metadata.preview": "Preview", "metadata.profile_private": "Public profile", "metadata.program": "Program", "metadata.programLabel": "Program", "metadata.program_by": "Program by", "metadata.programs.my_progress": "My Progress", "metadata.programs.overview": "Overview", "metadata.progressPercentage": [["percentage"], "% Completed"], "metadata.public_profile_empty_playlists": "No public playlists ", "metadata.question": "Question", "metadata.read_more": "Read more", "metadata.read_more_about": "Read more about", "metadata.recently_viewed_videos": "Recently viewed videos", "metadata.recommended_courses_programs_title": "Gain access to Yogobe programs", "metadata.recommended_playlists_title": "Recommended playlists", "metadata.recommended_videos_title": "Recommended videos", "metadata.remove_from_playlist": "Remove from playlist", "metadata.resume": "Resume", "metadata.save": "Save", "metadata.save_favorites": "Save to favorites", "metadata.save_more_than_per_year": ["Save more than SEK ", ["amount"], " per year"], "metadata.saved_favorites": "Saved to favorites", "metadata.search": "Search the entire video library", "metadata.search_library": "Search everything on Yogobe", "metadata.show_less": "Show Less", "metadata.show_more": "Show more", "metadata.signup": "Sign Up", "metadata.skills": "Skills", "metadata.statistics": ["You watched ", ["sessionsLastWeek"], " videos last week"], "metadata.statistics_title": "Statistics", "metadata.styles": "Styles", "metadata.survey": "Survey", "metadata.swedish": "Swedish", "metadata.tags": "Tags", "metadata.talk": "Talk", "metadata.textElement": "Text", "metadata.this_profile_is_private": "This profile is private", "metadata.this_profile_is_private_title": "Private Profile", "metadata.upgrade": "upgrade", "metadata.videos": "Videos", "metadata.view_all": "View all", "metadata.visitor": "visitor", "metadata.weeks.label": "Weeks", "metadata.with": "with", "metadata.workshop": "Workshop", "metadeta.programs.other_programs": "All programs", "metatadata.errors.unexpectedError": "Something seems to have gone amiss! Please try again or contact us via data@yogobe.com", "modals.publicplaylist.button1": "Yes, make my profile", "modals.publicplaylist.button2": "No, I wish my profile to remain private", "modals.publicplaylist.helper": "You wish to make a playlist public and share it with friends and the world. To make this happen you need an open profile and the following information will become visible:", "modals.publicplaylist.option1": "Your profile picture", "modals.publicplaylist.option2": "Your first and last name", "modals.publicplaylist.option3": "Your biography", "modals.publicplaylist.title": "Your public playlists", "my_playlists.title": "My Playlists", "new_subscription_modal.bank_transfer": "Instant Bank Transfer", "new_subscription_modal.debit_credit_card": "Card Payment", "new_subscription_modal.description": "Our subscriptions are recurring, have no binding period and can be canceled at any time", "new_subscription_modal.helper_bank": "I wish to pay for my subscription via bank transfer directly from my bank account.", "new_subscription_modal.select_option": "Select the option that suits you the best", "new_subscription_modal.title": "Upgrade membership to premium", "new_subscription_modal.warning_finland_cc": "This option is not available in Finland yet.", "onboarding.back.btn_text": "Back", "onboarding.banner.missed_onboarding": "Let us curate and recommend videos and content based on your individual needs and wants!", "onboarding.completed.explore_store.desc": "Explore Yogobe store and get -10% off on your first purchase using the code: MY10OFF", "onboarding.completed.explore_store.title": "Gear Up", "onboarding.completed.my_favorites.desc": "Explore the content we've have curated to meet your individual needs", "onboarding.completed.my_favorites.title": "My reecommended content", "onboarding.completed.programs.desc": "onboarding.completed.programs.desc", "onboarding.completed.programs.title": "Discover different programs and courses for all your needs", "onboarding.completed.video_library.desc": "Explore 1900+ videos across 4 different channels: Yoga, Meditate, Breathe and Move", "onboarding.completed.video_library.title": "Video Library", "onboarding.continue.btn_text": "Continue", "onboarding.description.edit_text": "Edit your preferences anytime. Your recommended content will be updated and accessible via your Dashboard", "onboarding.description.text": "Please help us to curate content for you by telling us what your needs and interests are… ", "onboarding.finish.btn_text": "Finish", "onboarding.meta_title": "Get started step by step", "onboarding.missing_lang.interests": "onboarding.missing_lang.interests", "onboarding.missing_lang.topics": "onboarding.missing_lang.topics", "onboarding.select.choices": "Select up to 3 choices ", "onboarding.select_interests.text": "I am interested in...", "onboarding.select_topics.text": "I would like to…", "onboarding.skip.btn_text": "Skip", "onboarding.welcome.text": ["Welcome ", ["name"]], "opengraph.companyFavorites_title": "Favorites", "opengraph.companyOverview_title": "Overview", "opengraph.companyPlaylists_title": "Playlists", "opengraph.dashboard_title": "Dashboard", "opengraph.mefavorites_title": "My favorites", "opengraph.myplaylists_title": "My playlists", "opengraph.password_recovery_title": "Recover password", "opengraph.playlists_collections_title": "Yogobe Playlist collections", "opengraph.playlists_title": "Yogobe Playlists", "opengraph.profilePlaylists_title": "My playlists", "opengraph.profilefavorites_title": "Profile favorites", "opengraph.profilestats_title": "My Statistics", "opengraph.programs_title": "4-12 week programs for all members", "opengraph.settings_title": "My Settings", "opengraph.stats_title": "My Statistics", "opengraph.videos_description": "Yoga, Meditate, Breathe and Move online together with us!", "opengraph.videos_genres_title": "Yogobe Video library", "opengraph.videos_title": "Yogobe Video library", "ourprograms.title": "Discover our programs", "pages.company_favorite.title": "Favorite", "pages.favorite.title": "My favorites", "pages.favorite_public_title": "Favorites", "pages.playlist_public_title": "Playlists", "pausa-smart.all-categories": "All Categories", "pausa-smart.already-in-program": "You are already in this program", "pausa-smart.browse-all-videos": "Browse all videos", "pausa-smart.download-pdf": "Download", "pausa-smart.employee-access-code": "I’m an employee with an access code", "pausa-smart.form-access-code.already-used": "The entered access code has already been used", "pausa-smart.form-comment": "Comment", "pausa-smart.form-company-name": "Company name", "pausa-smart.form-email": "Email", "pausa-smart.form-full-name": "Full name", "pausa-smart.form-rules.accessCode.required": "An access code is required", "pausa-smart.form-rules.comment.max": "The comment can have max 200 characters", "pausa-smart.form-rules.companyName.required": "Your company name is required", "pausa-smart.form-rules.email.required": "Your email address is required", "pausa-smart.form-rules.email.valid": "Please submit a valid email", "pausa-smart.form-rules.fullName.required": "Your full name is required", "pausa-smart.form-submit": "Send", "pausa-smart.form-title": "Get Your Free 14 Day Access", "pausa-smart.form.success-existing": ["You have now been given access to Pausa Smart for ", ["days"], " days. You can access the program via your dashboard. A confirmation email has also been sent to you."], "pausa-smart.form.success-interest": "Thanks for submitting the form, we will get back to you via email", "pausa-smart.form.success-new": ["Great! A confirmation email has been sent to ", ["email"], ". Click on the link you have received in order to activate your account with Pausa Smart access"], "pausa-smart.form_access_code": "Access code", "pausa-smart.get-started": "Get started", "pausa-smart.go-to-program": "Go to program", "pausa-smart.interviews-testimonials-title": "Explore these free classes", "pausa-smart.organization": "I’m representing an organization", "pausa-smart.read-less": "Read Less", "pausa-smart.read-more": "Read More", "pausa-smart.testimonials-title": "Testimonials from clients", "pausa-smart.title": "Pausa Smart", "pausa-smart.videos-in-total": ["Displaying ", ["n"], " videos in in total"], "pausa-smart.videos.languagues.all": "All languages", "pausa-smart.videos.languagues.english": "English", "pausa-smart.videos.languagues.swedish": "Swedish", "pausasmart.form.no_account.title": "Login or register an account in order to input the code", "pausasmart.get_started.access_code.desc": "This code is normally provided by someone within your organization", "pausasmart.get_started.access_code.dont_have": "I don’t have an access code", "pausasmart.get_started.access_code.have": "I have received an access code from my employer", "pausasmart.get_started.access_code.label": "Access code", "pausasmart.get_started.access_code.not_valid": "We are sorry, this code doesn't seem to be valid", "pausasmart.get_started.access_code.valid": "You have now been given access to Pausa Smart Challenge", "pausasmart.get_started.account.dont_have": "I wish to create an account", "pausasmart.get_started.account.have": "I already have an account", "pausasmart.get_started.button.continue": "Continue", "pausasmart.get_started.button.continue_plan": "Continue with a monthly plan", "pausasmart.get_started.button.continue_trial": "Continue with a free trial", "pausasmart.get_started.button.login": "Login", "pausasmart.get_started.button.upgrade_continue": "Upgrade and continue", "pausasmart.get_started.dont_have_code.hovertip": "In order to view or listen to entire audio or video sessions, have access to playlists, programs as well as challenges, your account on Yogobe needs to either be upgraded to subscription or if you still have access time left as part of your introductory free trial offer.   For as long as you have access time, you will be able to access content, such as this program. If you have been given access to this program from your employer or a partner organisation, then entering the access code will give you a 90-day access period to this specific content on Yogobe, and you will find it for easy access on your profile page/dashboard.", "pausasmart.get_started.dont_have_code.text": "This program is included in our premium subscription plans. If you don’t already have an account, sign up for a 14 day free trial and get access. Alternatively you can upgrade to a paying subscription and get unlimited access to all videos, playlists, programs and challenges within Yogobe. <0>Learn more</0>", "pausasmart.get_started.have_premium.text": "This program is included in our premium subscription plans.", "pausasmart.get_started.program_activation_failed": "Something seems to be upside down. Please try again or <0>contact our support</0>", "pausasmart.get_started.purchase_banner_back": "Go back", "pausasmart.get_started.purchase_banner_text": "If you are representing an organization and would like to purchase access for your employees, <0>Click here</0>", "pausasmart.get_started.subtitle": "Please choose an option that suits you the most:", "pausasmart.get_started.title": ["Dear ", ["name"], ", welcome to Pausa Smart Challenge"], "pausasmart.purchase.contact": "Contakt: <0>business@yogobe.com</0>", "pausasmart.purchase.desc": "We are very happy that you and your organisation are interested in this Pausa Smart Challenge. This challenge has been created based on the wishes of our corporate clients and members. A digital health tool perfect for remote teams, the home office and/or to inspire ourselves and each other to movement and meditation in our everyday lives. When you buy this challenge ALL your employees, members or partners will gain access at the flate fee of 5000 SEK. It does not matter if you are 100 or 10 000 employees. Welcome to a unique offering especially suited for our current Covid-19 climate. To get start please connect with us via email!", "pausasmart.purchase.title": "Hey, welcome to Pausa Smart Challenge!", "payment.modal.banktransfer.info": "Trustly enables secure transfers to Yogobe straight from your bank account. Easy to pay, renew or cancel as your subscription has no binding period.", "payment.modal.cardpayment.info": "Yogobe collaborates with Nets/DIBS so that you can pay for our services using VISA / Mastercard.  Easy to pay, renew and cancel as your subscription has no binding period", "payment_modal.banner.active_subscription_upgrade": "We are happy that you wish to extend your active subscription. Your current access days will automatically be added on top of your first payment period. ", "payment_modal.banner.inactive_subscription_upgrade": "We are happy that you wish to upgrade your membership to an active subscription, giving you unlimited access to the library, playlists, programs and challenges. Renew or cancel at any time with no binding period.", "payment_modal.banner.subscription_upgrade": "We are happy that you wish to upgrade your subscription. Your current access time will automatically be added to your first payment period.", "payment_modal.banner.trial_upgrade": "You are very welcome to upgrade your free trial to an active subscription with Yogobe. Your current access time will automatically be added to your first payment period.", "payment_modal.banner.unverified_trial_upgrade": "You are very welcome to upgrade your membership to an active subscription with Yogobe. Also: once you verify your account in the email we've sent you the free trial period which you signed up with will also be added to your access time and automatically extend your subscription period.", "payment_modal.error": "We love that you want to become a paying Yogobe member! Due to maintanance of the payment module the video library is currently open/free for you and all members. This work will be done sometime Wednesday. Welcome back then, to join us as a premium member!", "payment_modal.payment_method.card.label": "Pay with card", "payment_modal.payment_method.trustly.submit_button": "Continue with the bank payment via", "paymentconfirmation.btn1": "Close", "paymentconfirmation.btn2": "Show receipts", "paymentconfirmation_subscription.modal.body": ["Your payment of ", ["paymentAmount"], " has been approved. We confirm that your account has been successfully upgraded to a recurring ", ["subscriptionType"], " subscription. It will be automatically renewed on ", ["recurringDate"], " with ", ["recurringPaymentAmount"], "."], "paymentconfirmation_subscription.modal.title": "Payment confirmation", "paymentverification_modal.body": "We are about to process your payment and in order for us to verify your credit/debit our provider NETS will make a reservation of 1 SEK. This is just part of the process for secure card payments..", "phasedProgram.introduction.label": "Introduction", "phasedProgram.moodtracker.post.description": "Hur känner du dig nu? Checka in med dig själv för att känna hur du mår efter övningen genom att fylla i denna mood-tracker.", "phasedProgram.moodtracker.post.start_button": "Gå vidare", "phasedProgram.moodtracker.post.title": "Hur mår du nu?", "phasedProgram.moodtracker.pre.description": "Ta en kort stund för att checka in hur du mår genom att fylla i denna korta mood-tracker. Det tar inte mer tid än några långa, djupa andetag.", "phasedProgram.moodtracker.pre.start_button": "Fortsätt", "phasedProgram.moodtracker.pre.title": "Hur mår du?", "phasedProgram.moodtracker_modal.post.description": "Hur känner du dig nu? Checka in med dig själv för att känna hur du mår efter övningen genom att fylla i denna mood-tracker.", "phasedProgram.moodtracker_modal.post.title": "Hur mår du nu?", "phasedProgram.moodtracker_modal.pre.description": "Ta en kort stund för att checka in hur du mår genom att fylla i denna korta mood-tracker. Det tar inte mer tid än några långa, djupa andetag.", "phasedProgram.moodtracker_modal.pre.title": "Hur mår du?", "phasedProgram.moodtracker_modal.submit_button": "Save and close", "phasedProgram.outro.videos_count": [["videosCount"], " videos"], "phasedProgram.phase.number": ["Phase ", ["number"]], "phasedProgram.phase.number_weekRange": ["Phase ", ["phaseNumber"], ": week ", ["weekRange"]], "phasedProgram.phase.videos_duration": [["videosCount"], " videos - ", ["duration"]], "phasedProgram.phase.weekRange": ["Week ", ["weekRange"]], "phasedProgram.phase_progress.text": "The progress indicates the number of videos you have completed out of all videos in this week", "phasedProgram.postsurvey.requirement_notification": "The evaluation is now unlocked, <0>click here</0> to take it now.", "phasedProgram.presurvey.requirement_notification": "In order to unlock the next videos and start your program journey, you need to complete the pre-survey in Phase 1. Or <0>click here</0> to open it.", "phasedProgram.survey.post.description": "Ea in consequat amet deserunt elit. Pariatur consequat nisi adipisicing ut ex qui labore consectetur ut id id labore magna ut. Exercitation aliqua esse laborum reprehenderit minim deserunt irure esse duis veniam sunt in enim. Cillum cillum sit culpa quis esse aliquip pariatur anim. Sit pariatur ea qui sunt fugiat aliquip.", "phasedProgram.survey.post.start_button": "Gå vidare", "phasedProgram.survey.post.title": "Evaluation", "phasedProgram.survey.pre.description": "Denna enkät kommer ta mellan 10-15 minuter att slutföra. Se gärna detta som en möjlighet att lära känna dig sjäv bättre. Försök att vara uppriktigt mot dig själv, det finns inga svar som är rätt eller fel. Dina svar kommer vara en mycket viktig del till denna forskningsstudie.  För att delta i studien behöver du uppfylla följande kriterier: (1) Du är över 18 år; (2) Du har inte någon klinisk diagnos av depression, ångest eller stress; (3) Du är för närvarande inte under psykologisk eller psykiatrisk behandling, eller tar medicin för diagnostiserad psykisk sjukdom; (4) Du har inte en omfattande tidigare erfarenhet eller nuvarande yoga/mindfulness/meditationspraktik; (5) Du har tid och engagemang för att genomföra programmets föreläsninga veckovis och dagliga meditationsövningar; (6) Du har daglig tillgång till internet och förmåga att använda en persondator.", "phasedProgram.survey.pre.start_button": "Fortsätt", "phasedProgram.survey.pre.title": "Pre survey", "phasedProgram.week.number": ["Week ", ["number"]], "playlist.created_by": "Skapad av", "playlist.empty_plalist": "This playlist is currently empty", "playlist.playlist_deleted": "Playlist deleted", "playlist.playlist_title": "Playlist", "playlists.browse_by_categories": "Browse playlists by category", "playlists.browse_category": "Browse by category", "playlists.empty_description": "You have yet to create your first playlist", "playlists.get_started": "Recommended playlists", "playlists.title": "Playlists", "playlists.view_my_playlist": "View My Playlists", "playlistscollectionsubheadersection.title": "Playlist Collections", "position.other_yoga_positions": "Other Yoga Positions", "position.other_yoga_styles": "Other Yoga Styles", "premium_banner_card.get_started": "Get started", "pricing.monthly": "Monthly subscription", "pricing.option1": "Videos, playlists and programs", "pricing.option2": "Easy to use and flexible", "pricing.option3": "No binding period", "pricing.option4": "Use your wellness grant", "pricing.quarterly": "Quarterly subscription", "pricing.yearly": "Yearly subscription", "pricing_section.bullets.option1": "Videos, playlists and programs", "pricing_section.bullets.option2": "Easy to use and flexible", "pricing_section.bullets.option3": "No binding period", "pricing_section.bullets.option4": "Use your wellness grant", "pricing_section.plan.annually.body": "Pay once a year. Equivalent to 16.99€/mo. Save 40€", "pricing_section.plan.annually.label": "12 months", "pricing_section.plan.annually.title": "Annual subscription", "pricing_section.plan.best_value": "Best value", "pricing_section.plan.button_text": "Activate", "pricing_section.plan.monthly.body": "19.99€ billed every month.", "pricing_section.plan.monthly.label": "1 month", "pricing_section.plan.monthly.title": "Monthly subscription", "pricing_section.plan.quarterly.body": "Pay once every 3 months. Equivalent to 17.7 €/mo. Save 7€", "pricing_section.plan.quarterly.label": "3 months", "pricing_section.plan.quarterly.title": "Quarterly subscription", "pricing_section.plan.trial.body": "Enjoy all premium features for free for 14 days", "pricing_section.plan.trial.button_text": "14 day free trial", "pricing_section.plan.trial.price": "Free", "pricing_section.plan.trial.title": "14 day free trial", "pricing_section.title": "Go Premium and access unlimited features", "pricing_section.yearly_offers_description": "Choose between 2 time-limited offers. <0>Learn more here</0>", "prisonyoga.insperational": "Extra material: Lectures and classes", "prisonyoga.moreabout": "More about this initiative and Prison Yoga Project", "prisonyoga.readmore": "Read More", "prisonyoga.relatedPrograms": "A selection of video programs", "prisonyoga.startPracticingEnglish": "Playlists for English speaking members", "prisonyoga.startPracticingSwedish": "Playlists for Swedish speaking members", "prisonyoga.teachersInvolved": "Involved teachers and experts", "prisonyoga.testimonials": "Feedback from people who tried", "prisonyoga.title": "Welcome to The Prison Yoga Project Scandinavia", "profileheader.privacy_settings": "Privacy settings", "profileheader.view_public_profile": "View public profile", "program.backtoprogram": "Thank you for answering. Click here to go back to the program once you are done!", "program.description": "Our custom-made training programs consist of curated video library content in an easy to follow format where we also provide you with a deeper understanding of the area.", "program.duration": [["value"], " ", ["unit"], " program"], "program.introduction_show_less": "Hide text", "program.introduction_show_more": "Read more", "program.phaseCompletion": ["Completion: ", ["progress"], "%"], "program.quizAction": "Share your mood", "program.quizCount": [["quizCount"], " quiz"], "program.title": "Choose a training program", "program.video.repeat_explanation": "This is the recommended number of times to rewatch this session.", "program.videosCount": [["videoCount"], " Videos"], "program.videosTotal": [["videoCount"], " videos in total"], "program.weekCount": [["weekCount"], " week"], "program.weekCountShort": [["weekCount"], " week"], "program.whatToDoNextContinueProgress": "Continue My Progress", "program.whatToDoNextNextVideo": "Go to next session", "programs.duration": "30 day program", "programs_2021.banner.already_verified": "Already verified?", "programs_2021.banner.verify_account": "Verify your account to be able to join the program. ", "programs_2021.buy_gift.banner_text": "You are buying this program as a gift. If you wish to get access to it for yourself, <0>click here</0>", "programs_2021.buy_gift.buyer_name.input_label": "From", "programs_2021.buy_gift.buyer_name.input_placeholder": "First name", "programs_2021.buy_gift.code_label": "Discount code", "programs_2021.buy_gift.confirmation_modal_text": ["Your payment of ", ["paymentAmount"], " has been successfull. You will now receive a confirmation email including further instructions."], "programs_2021.buy_gift.custom_message.input_label": "Write a custom message to the recipient (optional)", "programs_2021.buy_gift.description": "We’re happy that you wish to give this program to a friend, as a gift", "programs_2021.buy_gift.description_tooltip": "Upon payment, you will recieve an email including the program gift voucher and instructions on how to activate the program", "programs_2021.buy_gift.direct_email.checkbox_label": "Send gift email to recipient directly", "programs_2021.buy_gift.direct_email.tooltip_text": "If this option is active, the recipient will receive an email including the gift voucher and instructions on how to activate the program/course. Uncheck it if you would like to forward the email yourself.", "programs_2021.buy_gift.go_courses_btn": "Explore courses", "programs_2021.buy_gift.go_dashboard_btn": "Go to Dashboard", "programs_2021.buy_gift.go_programs_btn": "Explore programs", "programs_2021.buy_gift.meta_title": ["Yogobe program - ", ["title"]], "programs_2021.buy_gift.recipient_email.input_label": "Recipient's email ", "programs_2021.buy_gift.recipient_name.input_label": "To (recipient’s name) ", "programs_2021.buy_gift.send_email_directly_label": "programs_2021.buy_gift.send_email_directly_label", "programs_2021.card.sale_tag": "Sale", "programs_2021.contact.contact_text": "Contact: <0>business@yogobe.com</0>", "programs_2021.contact.desc": "We are so happy that you and your organization are interested in getting started with Yogobe. Digital, accessible and easy to get started. Together we develop and tailor content and support with the purpose of promoting both physical and mental health within companies and organizations for individuals and emplyees. The format of our programs is perfect for teams that meet remotely and workplaces that seek inspiration and guidance for an active everyday life. A wide variety of interest and needs are taken into account – there is something for everyone. To get started, contact me via email!", "programs_2021.contact.purchase_banner_back": "Go back", "programs_2021.contact.title": "Hey, welcome to Yogobe programs! ", "programs_2021.expiration_banner.expire_soon.buy_program_text": ["Your access to this program expires in ", ["days"], " days. Extend access now to continue the program. We save all your progress. <0>Paying via wellness provider?</0>"], "programs_2021.expiration_banner.expire_soon.renew_access_free_text": ["Your access to this program expires in ", ["days"], " days. Extend access now for free. All your progress is saved."], "programs_2021.expiration_banner.expire_soon.renew_free_button": "Extend access", "programs_2021.expiration_banner.expire_soon.upgrade_button": "Upgrade now", "programs_2021.expiration_banner.expire_soon.upgrade_to_renew_text": ["Your access to this program expires in ", ["days"], " days. Upgrade to a paying subscription and unlimited access to this program is included. All your progress will be saved."], "programs_2021.expiration_banner.expired.buy_program_text": ["Your access to this program expired ", ["days"], " days ago. Renew your access to continue the program. All your progress is saved."], "programs_2021.expiration_banner.expired.renew_access_free_text": ["Your access to this program expired ", ["days"], " days ago. Renew access now for free. All your progress is saved."], "programs_2021.expiration_banner.expired.renew_free_button": "Re-activate now", "programs_2021.expiration_banner.expired.renew_with_discount_text": ["Your access to this program expired ", ["days"], " days ago. Renew access now and get a discount of ", ["discount"], ". All your progress has been saved. <0>Paying via wellness provider?</0>"], "programs_2021.expiration_banner.expired.upgrade_to_renew_text": ["Your access to this program expired ", ["days"], " days ago. Upgrade to a paying subscription and unlimited access to this program is included. Your progress has been saved."], "programs_2021.expiration_banner.expires_soon.extend_with_discount_text": ["Your access to this program expires in ", ["days"], " days. Renew access now and get a ", ["discount"], " discount. We save your progress. <0>Paying via wellness provider?</0>"], "programs_2021.expiration_banner.extend_button": ["Extend for ", ["price"]], "programs_2021.get_started.access_code.icon_text": "You need an access code to access the program. You could get such a code from an employer, caregiver, association or partner to Yogoobe. It could also come in the form of gift voucher from a friend.", "programs_2021.get_started.access_code.not_valid": "The code you provided is not valid!", "programs_2021.get_started.access_code.tooltip_text": "If you were provided with a code that gives you access to a certain program, you can enter it here", "programs_2021.get_started.access_code.valid": "The code has been successfully applied!", "programs_2021.get_started.access_code_mismatch": "This code is valid but activates another program", "programs_2021.get_started.access_code_only_description": "Welcome!<br/> This program is only joinable using an access code. This code will be provided to you via either Yogobe, a partner organization or a specific company/employer.", "programs_2021.get_started.activation_error": "Sorry, we were unable to activate the program for you, please contact us at info@yogobe.com", "programs_2021.get_started.button.activate_for_free": "Join program", "programs_2021.get_started.button.continue_trial": "Continue with a 14 day free trial", "programs_2021.get_started.button.login": "Login and continue", "programs_2021.get_started.button.purchase": "Proceed to secure payment", "programs_2021.get_started.button.start_suscription": "Start a subscription", "programs_2021.get_started.buy_gift_btn": "Buy as a gift", "programs_2021.get_started.code_label": "Your unique code", "programs_2021.get_started.description": "We are excited that you want to join this program. Login or create an account to continue. This program is included in our premium subscription plans and can also be accessed via corporate plans.", "programs_2021.get_started.discount_amount": "Discount", "programs_2021.get_started.end_of_access": "Access until", "programs_2021.get_started.guest_title": ["Welcome to ", ["program"]], "programs_2021.get_started.join_btn": "Start program", "programs_2021.get_started.payment_amount": "You’ll pay", "programs_2021.get_started.purchase_banner_text": "If you are representing an organization and would like to purchase access for your employees, <0>Click here</0>", "programs_2021.get_started.show_code_input": "Do you have an access code? <0>Click here</0>", "programs_2021.get_started.show_code_input_description": "This code is usually provided by a person from within your company or organization ", "programs_2021.get_started.user_title": ["Dear ", ["name"], ", welcome to ", ["program"]], "programs_2021.get_started_loggedin.description": "We are excited that you want to join this program. This program is included in our premium subscription plans and can also be accessed via corporate plans.", "programs_2021.header.access_until": ["Access to this program expires on ", ["date"]], "programs_2021.header.buy_as_gift": "Buy as gift", "programs_2021.header.extend_access": "Extend access", "programs_2021.listing_page.hero.no_premium_disclaimer": "*You can choose from our 3 main subscription plans: monthly, quarterly, or yearly. Starting from 19.99 EUR.", "programs_2021.listing_page.hero.premium_disclaimer": "*As long as you are on a premium subscription or you have valid access, you can join programs and challenges.", "programs_2021.listing_page.legacy_programs_banner": "Welcome to the new programs structure! Can’t find a program? <0>Click here</0>", "programs_2021.listing_page.meta.description": "Explore online programs on Yogobe within yoga, mindfulness, beginners workout, stress management and much more. Read more", "programs_2021.listing_page.meta.title": "Tailored video based programs online", "programs_2021.listings_page.clear_events_filters": "Clear Filters & search", "programs_2021.listings_page.explore_programs_btn": "Explore programs", "programs_2021.listings_page.faq_btn": "FAQ", "programs_2021.listings_page.filter_applied_toaster": "Filters successfully applied", "programs_2021.listings_page.filters.instructors": "All instructors", "programs_2021.listings_page.filters.kind_theme": "All themes", "programs_2021.listings_page.filters.languages": "Show me programs in", "programs_2021.listings_page.filters.sort_alphabetically": "Sort alphabetically (A-Z)", "programs_2021.listings_page.filters.sort_by": "Sort by", "programs_2021.listings_page.filters.sort_duration": "Sort by duration", "programs_2021.listings_page.filters.sort_new": "Sort by newest first", "programs_2021.listings_page.hero_title": "Explore programs", "programs_2021.listings_page.load_more_btn": "Load More", "programs_2021.listings_page.no_programs_found": "Oops... We could not find a program that matches this specific search term or combination of filters. This does not mean that we do not have what you are looking for. Please try clearing the filters or reword your search query!", "programs_2021.listings_page.option4": "User your fringe health benefits", "programs_2021.listings_page.pricing_section.title": "Upgrade now and get access to ALL programs", "programs_2021.listings_page.search_input_placeholder": "Search programs…", "programs_2021.listings_page.subtitle": "Welcome to Yogobe programs – tailored to meet a number of different needs and interests. Explore the different programs today and participate in one or several at a time.", "programs_2021.overview.text_card.locked_text": ["Join the ", ["programType"], " to see this content."], "programs_2021.pricing.free": "Free", "programs_2021.pricing.free_for_you": "Included in your subscription", "programs_2021.pricing.included_in_subscription": "Included in subscription", "programs_2021.program_card.program_access_label": "You have access", "programs_2021.program_card.program_expire_soon": "Access expiring soon", "programs_2021.program_card.program_expired": "Access expired", "programs_2021.program_page.breadcrumb": "Yogobe programs", "programs_2021.program_purchase.confirmation_modal_text": ["Your payment of ", ["paymentAmount"], " is successfully completed. You can get started right away"], "programs_2021.program_purchase.get_started": "Get started", "programs_2021.program_purchase.go_dashboard_btn": "Go to dashboard", "programs_2021.programs.instructors_modal_title": ["Instructors in ", ["program"]], "programs_2021.programs.other_instructors_count": [["number"], " more"], "programs_2021.progress_page.video_lock.button_text": "Join program", "programs_2021.progress_page.video_lock.text": "You have just watched a 60 second preview. Would you like to login and/or start this program now to unlock all its contents?", "programs_2021.snackbars.access_granted": "You successfully joined this program", "programs_2021.themes.athletes": "Athletes", "programs_2021.themes.beginner": "Beginner", "programs_2021.themes.breathing": "Breathing", "programs_2021.themes.diet_and_nutrition": "Diet & nutrition", "programs_2021.themes.meditation": "Meditation", "programs_2021.themes.mobility_and_prehab": "Mobility & prehab", "programs_2021.themes.personal_growth": "Personal growth", "programs_2021.themes.philosophy": "Philosophy", "programs_2021.themes.postnatal": "Postnatal", "programs_2021.themes.prenatal": "Prenatal", "programs_2021.themes.restoration": "Restoration", "programs_2021.themes.skills": "Skills & technique", "programs_2021.themes.smart_breaks": "Smart breaks", "programs_2021.themes.stress_and_anxiety": "Stress & anxiety", "programs_2021.themes.womens_health": "Women's health", "programs_2021.themes.workout": "Workout", "programs_2021.themes.yoga": "Yoga", "programs_2021.themes.yoga_teachers": "Yoga teachers", "programs_2022.progress.program_recomendation_hide": "Hide", "programs_2022.progress.program_recomendation_show": "Show", "programs_2022.progress.program_tip": "Good to know", "programs_2022.survey.close_modal_button": "Close", "programs_2022.survey.draft_saved": "Your answers have been saved as draft.", "programs_2022.survey.edit_survey_btn": "View or edit answers", "programs_2022.survey.exit_alert": "You have made some changes and haven't submitted the answers, are you sure you want to exit?", "programs_2022.survey.last_submit": ["You have last submitted your answers on ", ["date"]], "programs_2022.survey.start_survey_btn": "Take survey", "programs_2022.survey.submit_answers_btn": "Submit answers", "programs_2022.survey.thank_you_desc": "We truly value your input. Thank you for completing the survey!", "programs_2022.survey.thank_you_title": "Thank you!", "programs_body.read_more": "Read More", "programs_legacy_listing.banner_message": "We moved some of our programs to our new structure. <0>Check them out</0>", "programs_listing.faq.item1.body": "All programs are included for active members on Yogobe. You can also join a program if you are currently on a trial, but you only have access to the program for as long as you have access days left.", "programs_listing.faq.item1.title": "Who can participate in a program?", "programs_listing.faq.item2.body": "When you have joined a program (which you do by clicking on \"Get started\" in the program you are interested in) you will always find your programs on your <0>Dashboard</0> as a logged in member for easy access.", "programs_listing.faq.item2.title": "Where can I find my programs?", "programs_listing.faq.item3.body": "Of course! You can join as many programs as you want. If you join several programs in one day you will however only receive emails connected to the first program that you joined. This to ensure that you do not get too many emails.", "programs_listing.faq.item3.title": "Can I participate in several programs at the same time?", "programs_listing.faq.item4.body": "Now all our programs get a similar design and structure as our existing programs within Yogobe Challenge. The layout makes it easier for you as a user to actually join a program and track your progress. The new design also makes it easier to follow the program and thus get the guidance that the programs are intended to give you.", "programs_listing.faq.item4.body2": "There are two tabs for each program – \"Overview\" and \"My progress\". Under \"Overview\" you get all the information about the program and get an overview of each week/part included in the program. In \"My progress\" you easily see which sessions belong to which week and which sessions you have already completed.", "programs_listing.faq.item4.title": "Why are the programs in a new design?", "programs_listing.faq.item5.body": "Of course! We have several different B2B solutions and gladly tailor solutions to find something that suits your wishes and neeeds. Send us an email to <0>business@yogobe.com</0> and we will give you more information.", "programs_listing.faq.item5.title": "Can companies buy individual programs?", "programs_listing.faq.item6.body": "The programs are currently, just as Yogobe Challenge, only available through the website Yogobe.com. You can of course visit the website on your smartphone and reach the program on your phone in that way.", "programs_listing.faq.item6.title": "Are the programs available in the app?", "programs_listing.faq.item7.body": "You can always start with a <0>trial on Yogobe</0> which is free, does not require any payment details and always without binding period. A free trial on Yogobe never automatically turns into a paying subscription. After your free trial you can choose if you want to upgrade your membership to a recurring subscription and pay though bank payment, credit card or through one of the <0>wellness grant partners</0> that we work with. Simple as that! As a logged in member you find the <0>Subscription settings</0> via your menu and you can take part of our different offers on monthly, quarterly and yearly subscription.", "programs_listing.faq.item7.title": "How do I become a paying member on Yogobe?", "programs_listing.walkthrough_section.subtitle": "In this video we show how easy it is to get started with the program of your choice, and show you how to navigate between the different views. Join any program today!", "programs_listing.walkthrough_section.title": "How to get started", "promotions.code_apply.fallback_failure_message": "We're sorry, but either the code you have entered does not exist or the offer is no longer valid", "public_profile.error_msg": "It seems we can't load this profile. Please refresh the page or try again in a little while.", "quickstart.awesome_message": ["Awesome! Here are a few ", ["yogaDuration"], " videos that are ", ["yogaType"]], "quickstart.awesome_message_yogaTypeCalm": "calm", "quickstart.awesome_message_yogaTypeIntensive": "physical", "quickstart.cancel": "Cancel", "quickstart.go_back": "Go back", "quickstart.hide_this": "Hide this", "quickstart.something_physical": "Something physical", "quickstart.something_relaxing": "Something relaxing", "quickstart.start_message": ["Dear ", ["name"], ", would you like our help to choose a video?"], "quickstart.time_you_have": "Great job! How much time do you have?", "quickstart.todo_today": "Okay, start by telling us what you are looking for!", "quickstart.try_quickstart": "Try Quick Start", "receipts.check_premium": "Check Premium Offers", "receipts.empty_description": "You’re currently on a free plan, maybe this is your chance to become Premium", "receipts.empty_title": "You don’t have any receipt yet", "receipts.payment_made": "We have received your payment and you can find your receipt on this page", "receipts.title": "Receipts", "reclaim_trial.body": "reclaim_trial.body", "reclaim_trial.confirmation.generic_error": "reclaim_trial.confirmation.generic_error", "reclaim_trial.confirmation.progress_text": "reclaim_trial.confirmation.progress_text", "reclaim_trial.confirmation.success": "reclaim_trial.confirmation.success", "reclaim_trial.dashboard_btn": "reclaim_trial.dashboard_btn", "reclaim_trial.intro": "reclaim_trial.intro", "reclaim_trial.title": "reclaim_trial.title=======", "reclaim_trial_modal.claim_btn": "Yes please!", "reclaim_trial_modal.desc": "We are happy to have you back with us and would love to give you the opportunity to explore Yogobe Play <b>at no cost</b> for 14 days. Would you like to get started?", "reclaim_trial_modal.not_intrested_btn": "No, I'm not interested", "reclaim_trial_modal.title": "Would you like a new 14 day trial period?", "reclaim_trial_page.body": "You will automatically be redirected to your dashboard in", "reclaim_trial_page.confirmation.generic_error": "We have failed to activate a renewed trial period for you, please contact us at <0>info@yogobe.com</0>", "reclaim_trial_page.confirmation.progress_text": "Activating your new trial period...", "reclaim_trial_page.confirmation.toaster_message": "Your account has been successfully upgraded with a new 14 day free trial period with unlimitied acces to the on-demand section of Yogobe Play. our subscription service.", "reclaim_trial_page.dashboard_btn": "Or click to continue", "reclaim_trial_page.desc": "Your renewed trial period has been successfully activated! You’re all set to start exploring all the premium content and features of Yogobe Play.", "reclaim_trial_page.title": "14-day free trial", "register.tooltip.message": "Upon signing up, you will get a free trial. Upgrade at any time to a monthly, quarterly or yearly subscription starting from (99 SEK). <br /> <br /> If you have bought an online course with us or you’ve been provided with an access code from your employer, this is also where you register and create your personal account. <br /> <br /> <br /> See you on the inside! <br /> Peter Munteanu, CEO and Founder.", "registration.access_code.valid": ["Your code has been validated. Complete your registration and you will get Yogobe access until ", ["date"]], "registration.campaign_code.valid": ["Campaign code is valid. You will receive a ", ["days"], " day trial period upon completing your account registration"], "registration.campaign_code_applied": ["<0>", ["code"], "</0> code has been applied. Continue the registration to get access!"], "registration.complete_profile.address": "Add your address", "registration.complete_profile.title2": [["name"], ", do you have a campaign code?"], "registration.confirmation.generic_error": "<p>Dear member,</p> <p>The verification link you have clicked is no longer valid. Please try to reload the page or login/logout, and if you believe there is an issue we would appreciate it if you would contact <a href=\"mailto:data@yogobe.com\">data@yogobe.com</a> so that we can help you out!</p> <p>Warm regards<br/> Peter</p>", "registration.confirmation.progress_text": "Confirming your email…", "registration.confirmation.success": "Your email has been successfully confirmed!", "registration.continue_to_dashboard.btn": "Go to dashboard", "registration.course.access_code_banner": ["<0>", ["code"], "</0> code has been applied. Continue the registration to get access to <0>", ["courseName"], "</0>."], "registration.course.banner": "We are excited about sharing this course with you. Create an account and you will be redirected to the payment page.", "registration.course_card.desc": "One-year access to the course and all related material.", "registration.course_card.title": "In addition to the course, you will also get a 14-day free trial to the entire yogobe library.", "registration.cycle.12months.label": "12 months", "registration.cycle.1month.label": "1 month", "registration.cycle.3months.label": "3 months", "registration.landing.alreadymember": "Already a member? <0>Log in</0>", "registration.landing.btn": "Continue", "registration.landing.country": "Country", "registration.landing.email": "Email", "registration.landing.firstname": "First Name", "registration.landing.headline": "Explore yoga, meditation, movement and breathing!", "registration.landing.lastname": "Last Name", "registration.landing.password": "Password", "registration.landing.pricing.info": "Free trial, no binding period, no bank details requried ", "registration.landing.pricing.text": "Learn more about your membership and pricing", "registration.landing.socials_label": "Or sign up with", "registration.landing.subtitle": "Create an account to watch, save and favorite thousands of videos", "registration.landing.tc": "By continuing, you agree to our <0>Terms & Conditions</0> and <1>Privacy Policy</1>", "registration.landing.title": "Become a member!", "registration.landing.usp1": "Video & audio sessions on-demand", "registration.landing.usp2": "LIVE streamed classes & events", "registration.landing.usp4": "Create & share playlists", "registration.onboarding.max_selected": "Please de-select one or more choices to renew", "registration.payment.btn1": "Proceed to Secure Payment", "registration.payment.btn2": "Back", "registration.payment.code_applied": "Your code has been successfully validated", "registration.payment.discount.label": "Bonus discount", "registration.payment.nextpayment.body": ["You will pay ", ["amount"], " now.  <br/> ", ["cycle"], " recurring billing of ", ["recurringAmount"], " from the next payment - Cancel anytime"], "registration.payment.now.label": "Total amount:", "registration.payment.ordersummary.label": "Order summary", "registration.payment.title": "Payment", "registration.paymentfail.body": ["Something went wrong… your payment of ", ["amount"], "€ has failed. Please try again. If the problems persists, contact our support technical support team on data@yogobe.com"], "registration.paymentfail.btn": "Go Back & Try Again", "registration.paymentfail.orderdetails.body": ["Transaction ID: ", ["transaction"]], "registration.paymentfail.title": "Payment Failed", "registration.paymentsuccess.body": ["Thank you, your payment of ", ["amount"], " ", ["currency"], " has been received. An automated payment confirmation will be sent to ", ["email"]], "registration.paymentsuccess.btn": "Continue", "registration.paymentsuccess.orderdetails.body": ["Order ID: ", ["order"], "   |   Transaction ID: ", ["transaction"]], "registration.paymentsuccess.title": "Payment Successful!", "registration.plan.annually.body": "Pay once a year. Equivalent to 16.99€/mo. Save 40€", "registration.plan.annually.title": ["Annual subscription - ", ["amount"]], "registration.plan.btn": "Continue to payment", "registration.plan.code.info.tooltip": "A discount code will apply a discount on a subscription plan giving you either a one period discount or a renewable discount. If you have questions, please write to info@yogobe.com", "registration.plan.code.info_text": "Do you have a discount code?", "registration.plan.code.label": "Do you have a discount code?", "registration.plan.code.success": "Your code has been successfully validated", "registration.plan.codecamp.info.tooltip": "If you have received a campaign code via your yoga teacher, instructor or one of Yogobes partners, here is where you enter it to claim your extended free trail of our service, including the entire video library, programs, playlists and challenges. This is also the place to enter a friend code, if you have been referred to Yogobe via a friend.", "registration.plan.codecamp.info_text": "Enter your campaign or referral code.", "registration.plan.continue_btn": "Continue", "registration.plan.monthly.body": "19.99€ billed every month.", "registration.plan.monthly.title": ["Monthly subscription - ", ["amount"]], "registration.plan.or_subscription.desc": ["You can easily choose to start a premium subscription right away. Your ", ["days"], " day free trial will of course be added ontop. "], "registration.plan.or_subscription.title": "Or choose a subscription plan that suits you", "registration.plan.quarterly.body": "Pay once every 3 months. Equivalent to 17.7 €/mo. Save 7€", "registration.plan.quarterly.title": ["Quarterly subscription - ", ["amount"]], "registration.plan.title": "Choose a subscription plan that suits you", "registration.plan.trial.body": "Free trial, no bank or card details required", "registration.plan.trial.btn_text": "Continue", "registration.plan.trial.title": ["Hey ", ["name"], ", continue with your ", ["days"], "-day free trial"], "registration.plan.usp.title": "All subscription plans include the following:", "registration.plan.usp1": "Save, share and add videos to your own playlists.", "registration.plan.usp2": "Unlimited access to 2100+ videos and 45+ programs ", "registration.plan.usp3": "Easy to upgrade or cancel anytime.", "registration.referral_code.valid": ["Your code has been validated. Complete your registration and you will receive a ", ["days"], " day free trial thanks to your friend"], "registration.trial_code_input.label": "Have you been given a campaign code, please fill that in here. Do you have an access code for a theme page, programs etc? Please click continue, without filling in your code below!", "registration.verification1.intro": ["To continue, please verify your account by clicking on the link we've sent to: <0>", ["email"], "</0>"], "registration.verification1.resend": "Haven’t received the verification email? <0>Click here</0>", "registration.verification1.resend_failed": "Failed to re-send the email, please try again or contact our support. info@yogobe.com", "registration.verification1.resend_success": "Email resend successful, please check your inbox!", "registration.verification1.title": "Verify your account", "registration.verification2.body": "You will be automatically redirected…", "registration.verification2.btn": "Or click to continue", "registration.verification2.intro": "Your account has been successfully verified! You’re all set to start exploring Yogobe.", "registration.verification2.title": "All set!", "registration.verify_email_toaster": ["An activation email has been sent to ", ["email"], ". Please activate and verify your account to claim the free trial period. Has your address been added wrongly? Contact info@yogobe.com"], "registration.wellness.learn_more": "Did you know you can use your employee wellness grant for Yogobe? <0>Learn more</0>", "regsocial.best_value": "Best value", "regsocial.feature1_desc": ["Unlimited access to more than ", ["videos_count"], " videos. On-demand video tutorials between 5-90 minutes within yoga, meditation, pilates, mobility, pre- and postnatal training, cardio, core, stretch, run-coaching, lectures and more. Anytime, anywhere."], "regsocial.feature1_title": [["videos_count"], "+ videos"], "regsocial.feature2_desc": "Videos and guidance to get started Team Yogobe have put together brief wellness programs with videos from the library. Everything which we produce and offer is a direct result of the expressed needs among our members.", "regsocial.feature2_title": "Health and wellness programs", "regsocial.feature3_desc": "Create, follow and share playlists. Both your own and others. Playlists are collections of videos or audio files with an auto-play feature for undisturbed viewing.", "regsocial.feature3_title": "Create playlists", "regsocial.feature5_desc": "Join our growing forums on Fb: BEYOGA365 and YOGAMOM365 The community which has evolved within Yogobes online forums is strong, authentic and provides a safe place for genuine meetings. Yoga, compassion and a passion for health are the uniting factors. At Yogobe we aspire to guide and inspire individuals, corporations and our joint collective toward sustainability by providing high quality tools, services and forums for creating space in every day life for physical, mental, spiritual and social health and wellbeing.", "regsocial.feature5_title": "Community", "regsocial.getstarted": "Activate", "regsocial.hero_btn1": "Our membership plans", "regsocial.hero_btn2": "14 day free trial", "regsocial.hero_title": "Get unlimited access to our video library", "regsocial.hero_usp": "No binding period - Unlimited video library access - No credit card details required", "regsocial.live_desc": "Meet teachers and other members for classes, workshops and lectures LIVE online. Let Team Yogobe guide you in real time!", "regsocial.live_title": "LIVE – be guided in real time", "regsocial.mobile_section.desc": "In our app for iOS and Android you get access to the entire library, playlists, offline mode as well as Cast via Airplay and ChromeCast.", "regsocial.mobile_section.title": "Explore our new app", "regsocial.most_affordable": "Most Affordable", "regsocial.offer_description": "TAKE PART IN ANNUAL OFFER <0/> Start an annual subscription with Yogobe and have some of the best yogateachers and training instructors guide you in videos online and offline about yoga, meditation, pilates, movement training, pre- and post natal training and lots more – the best way to stay happy, strong and prosperous. <0/> Who can take adventage of this offer? <0/> <0/> Anyone that starts, upgrades or activly renews a subscription with Yogobe (to the permanent price 1899 SEK with a VISA/Mastercard payment through our payment system DIBS or Trustly) gets a 500 SEK giftcard from Yogiraj that can be used as payment in Yogobe Store. <0/> <0/> The offer is valid until midnight 8th of May 2019. When you accept this offer you will automatically get an email from us with your unique giftcode. This giftcode is valid for purchase of products for the specified amount. Shipping costs will apply and is payable by the buyer. Vi offer affordable shippingcosts and delivery within 3 working days after your order. The gifcard is valid until 31st of December 2019 and can not be exchanged for cash. Klick the button and read more about this offer. <0/> <0/> About Yogiraj (yogamats and equipment) <0/> With inspiration from the forest, mountains, plains and ocean Yogiraj has it’s roots in the nordic nature. Yogirajs mats and equipment is toxic-free and often ecological. Give yourself yoga with Yogiraj and leave behind a smaller ecological footprint as well as being kind to your body and the planet.  <0/> <0/> Yogiraj has plenty of yogaprops – everything from bolsters and meditations pillows with ecological buckwheat, to eye pillows, heavy cotton blankets and blocks in different sizes. Vi also think that Yogiraj offers some of the best yogamats around – from simple allround mats to the new grip mat for bikram and other more intense yogastyles. <0/> <0/> Good to know when you upgrade your subscrition <0/> If you at the moment have a free-trial period your year will automatically be extended for the same amount of days as you have left. <0/> If you have an active subscription your membertype will be changed to YEAR and payment will be charged today. Left over days from your previous subscription will be added to you new subscription. <0/> If you have any other questions please don’t hesitate to contact us: info@yogobe.com. <0/> Use your wellness grant <0/> As a paying member of Yogobe you can easily print your receipts of payment from your settings. These you can give your employer that will decide wether or not your membership with us is covered by the wellness grant. If you are unsure about what is covered by the wellness grant please ask your employer in advance if online training is covered. <0/> This offer that gives you a giftcard at Yogobe Store (value 500 SEK) is not applicable for anyone paying for Yogobe through a wellness provider such as Benify or Actiway as they are one-time payments to Yogobe, not an ongoing subscription. <0/>   ", "regsocial.offer_title": "Take part in our exclusive annual offer", "regsocial.page_title": "Become a member", "regsocial.special_page_title": "Become a member", "regsocial.subscription_annually_billed": "billed annually", "regsocial.subscription_annually_save": "Save 40 € per year", "regsocial.subscription_free_plan_label": "Enjoy all premium features for free for 14 days", "regsocial.subscription_free_price_label": "Free", "regsocial.subscription_free_title": "Free Trial", "regsocial.subscription_monthly_billed": "billed monthly", "regsocial.subscription_monthly_per": "/ month", "regsocial.subscription_quarterly_billed": "billed quarterly", "regsocial.subscription_quarterly_per": "/ quarter", "regsocial.subscription_quarterly_save": "Save 28 € per year", "regsocial.subscription_sub_title": "Subscribe for a year and and get a 500 SEK Yogiraj voucher.", "regsocial.subscription_title": "Go Premium and access unlimited features", "regsocial.subscription_year_per": "/ year", "regsocial.testimonial_title": "What our members think", "reset_program.body": "Do you want to switch from the program you started during the Yogobe Spring Challenge? In the next steps you will be able to choose the program you want and also fill in the form again.", "reset_program.info": ["Your statistics for your program (", ["programName"], ") will be lost. Are you sure you want to proceed?"], "reset_program.no": "No, I want to stay", "reset_program.title": "Change program", "reset_program.yes": "Yes, choose another program", "schedule_modal.googlecalendar": "Export to my Google Calendar", "schedule_modal.icp": "Save to my calendar", "schedule_modal.time": "Time", "schedule_modal.title": "Schedule", "search.category.blog.title": "Blog", "search.category.challenges.title": "Challenges", "search.category.courses.title": "Online courses", "search.category.events.title": "Events", "search.category.instructors.title": "Teachers & experts", "search.category.live_events.title": "LIVE online", "search.category.pages.title": "Resources", "search.category.playlists.title": "Playlists", "search.category.programs.title": "Programs", "search.category.video_audio.title": "Video & audio", "search.filters.languages": "Languages", "search.go_back": "Go back", "search.input_placeholder": "Search Yogobe...", "search.program_card.view_blog": "Read article", "search.program_card.view_challenge": "View challenge", "search.program_card.view_course": "View course", "search.program_card.view_live": "View LIVE class", "search.program_card.view_program": "View program", "search.result_found": "1 result found", "search.results.many": [["count"], " results"], "search.results.one": [["count"], " result"], "search.results_found": [["totalCount"], " results <0>found for ", ["query"], "</0>"], "search.results_not_found": "No results found, try rewording your search!", "search.search_correction": "Maybe try the following option(s) instead:", "search.search_input_button": "Search", "search.search_not_started": "Start your search and explore all that we have to offer – classes, inspirational reading, training programs and much more!", "search.section.blog.explore": "Yogobe blog=======>>>>>>> master", "search.section.blog.title": "Blog", "search.section.challenges.title": "Challenges", "search.section.courses.title": "Online courses", "search.section.events.title": "Events", "search.section.instructors.title": "Teachers & experts", "search.section.live.title": "Live online", "search.section.playlists.title": "Playlists", "search.section.programs.title": "Programs", "search.section.resources.title": "Resources", "search.section.slide.more": ["View all ", ["totalCount"], " results for ", ["searchQuery"], " in ", ["title"]], "search.section.video_audio.title": "Video & audio", "search.tabs.all": "All", "search.tabs.blog": "Blog", "search.tabs.coursetravel": "Courses & travel", "search.tabs.live": "LIVE", "search.tabs.mobile_play": "Play (Videos, Playlists, programs)", "search.tabs.play": "Play", "search.tabs.play_tooltip": "Yogobe Play is everything you get as a premium user with active access time. It includes the entire video library, weekly LIVE classes, playlists, programs, and challenges.", "search.tabs.resources": "Resources", "search.temporary_banner": "We just launched Search, are constantly working on improving it and would appreciate your input! <0>Leave feedback</0>", "search.title": "What are you looking for?", "search_details.blogPosts.explore": "search_details.blogPosts.explore", "search_details.challenges.explore": "Explore challenges", "search_details.courses.explore": "Explore online courses", "search_details.events.explore": "Explore events", "search_details.genericPrograms.explore": "Explore programs", "search_details.instructors.explore": "Explore Team Yogobe", "search_details.live.explore": "Explore LIVE", "search_details.playlists.explore": "Explore playlists", "search_details.results.load_more": "Show more", "search_details.results_found.mutiple_results": [["totalCount"], " results for <0>", ["query"], "</0> in ", ["category"]], "search_details.results_found.single_results": [["totalCount"], " result for <0>", ["query"], "</0> in ", ["category"]], "search_details.title": ["Searching within ", ["category"]], "search_details.videos.explore": "Explore library", "settings.go_back": "Back to dashboard", "settings.subsriptions.failed_renew": ["The latest charge to your payment card or account failed. If you have switched cards, please choose a subscription form below to renew your card information. Contact us <0>", ["email"], "</0> if you want us to perform a new charge on the existing card or account between now and our next automated attempt."], "settings_account.change_password.logout_notice": "Upon changing your password, you will be asked to log in to your account again", "settings_account.confirm_new_password": "Confirm new password", "settings_account.mailaddress": "Email address", "settings_account.new_password": "New password", "settings_account.password_updated_successfully": "Password updated successfully", "settings_account.recover_your_password": "Recover your password", "settings_account.token_wrong": "The token which you've entered seems to be either invalid or wrong. Please try again!", "settings_fringe_health.descriPSettingsFringeHealthBenefitstion": "Does your employer give you fringe health benefits? Check with them if they will cover your costs by accepting your receipts from Yogobe. Throughout Scandinavia we work with the health benefits corporation Benify. In Sweden other partners are: Actiway, Wellnet and Min Friskvård and via their platforms it is easy to upgrade your Yogobe account.", "settings_fringe_health.read_more": "Read more on fringe health benefits", "settings_fringe_health.title": "Use all or parts of your corporate health benefits", "settings_history.action": "Clear all history", "settings_history.title": "History", "settings_modal.accessible-yoga": "Accessible Yoga", "settings_modal.barn-ungdom": "Children and Youth", "settings_modal.beginner": "Only beginner friendly videos", "settings_modal.english": "English", "settings_modal.finnish": "Finnish", "settings_modal.helper": "We aim to always give you relevant search results in the library. This feature helps you narrow down your possible results.", "settings_modal.helper_label": "Customize your Yogobe experience", "settings_modal.left_section_title": "Languages", "settings_modal.norwegian": "Norwegian", "settings_modal.office-yoga": "Office Yoga", "settings_modal.postnatal": "Postnatal yoga & training", "settings_modal.prenatal": "Prenatal yoga & training", "settings_modal.primary_button": "Save", "settings_modal.right_section_title": "Search filters", "settings_modal.secondary_button": "Cancel", "settings_modal.senior-yoga": "Senior Yoga", "settings_modal.swedish": "Swedish", "settings_modal.title": "Settings", "settings_privacy.description": "The content you select here will be visible on your public profile", "settings_privacy.favorites": "Favorites", "settings_privacy.private_profile_notice": "You’ve decided to make your profile private. Other users won’t be able to see your favorites and the playlists you have created.", "settings_privacy.statistics": "Statistics", "settings_private_informations.city": "City", "settings_private_informations.dateOfBirth": "Birthday", "settings_private_informations.first_name": "First Name", "settings_private_informations.lastName": "Surname", "settings_private_informations.phone": "Phone", "settings_private_informations.profession": "Profession", "settings_private_informations.street_address": "Street Address", "settings_private_informations.timezone": "Timezone", "settings_private_informations.zip_code": "Zip Code", "settings_profile.cancel_url_not_available": "You don't have a recurring subscription. This means that you don't have to cancel anything. Contact us on info@yogobe.com if you have any questions.", "settings_profile.display_name": "Display name", "settings_profile.facebook": "Facebook", "settings_profile.instagram": "Instagram", "settings_profile.linkedin": "LinkedIn", "settings_profile.remove_photo": "Remove photo", "settings_profile.short_bio": "Short bio", "settings_profile.short_bio_placeholder": "Write a few lines describing yourself", "settings_receipts.date": "Date", "settings_receipts.payment_type": "Payment type", "settings_receipts.receipt": "Receipt", "settings_receipts.receipt_number": "Receipt number", "settings_receipts.total_including_vat": "Total Including VAT", "settings_referall.description": "and when they become premium subscription members your account automatically gets a 30 day bonus upgrade for each friend.", "settings_referall.paragraph_one": "Give your friends their first 21 days with Yogobe for free. It's simple, no lock-in period, no card details, and bonuses for you!", "settings_referall.paragraph_two": "For every one of your friends who start a subscription with Yogobe using your friend code, and become paying members, your account will automatically be upgraded with 30 bonus days (value 19.99 EUR). So, go ahead and share your friend code with everyone you believe will benefit from Yogobe and when they each pay atleast 19,99 EUR with us you get your upgrade.", "settings_referall.personal_code_action": "Copy", "settings_referall.personal_code_label": "Your personal friend code", "settings_referall.refer": "Invite a friend using:", "settings_referall.title": "Invite friends", "settings_subheader.account": "Account settings", "settings_subheader.fringe_health_benefits": "Fringe Health Benefits", "settings_subheader.live_codes": "LIVE codes", "settings_subheader.manage_notifications": "Email preferences", "settings_subheader.privacy": "Privacy Settings", "settings_subheader.private": "Private Information", "settings_subheader.profile": "Profile settings", "settings_subheader.receipts": "Receipts", "settings_subheader.referral_program": "Referral Program", "settings_subheader.subscriptions": "Subscription", "settings_subscriptions.access_code.activation_failed": "The activation of the code failed. Try again or contact us for help via <0>info@yogobe.com</0> ", "settings_subscriptions.access_code.buy_gift": "Click here to buy a gift voucher", "settings_subscriptions.access_code.description": "If you have a code that gives you a specific access period, such as a code provided by Mecenat or by your employer, you can enter it in the text field below", "settings_subscriptions.access_code.input_description": "Also applies to Mecenat codes", "settings_subscriptions.access_code.input_label": "Enter your code", "settings_subscriptions.access_code.invalid_code_message": "The code you provided is not correct or no longer valid. You can try again or connect with us for help at <0>info@yogobe.com</0>", "settings_subscriptions.access_code.submit_btn": "Activate", "settings_subscriptions.access_code.title": "Do you have an access code?", "settings_subscriptions.access_code.valid_code_message": "Your code is valid!", "settings_subscriptions.annually": "Annually", "settings_subscriptions.cancel_mobile_subscription": ["You are currently paying your subscription through ", ["provider"], ". Please cancel it first in order to continue your subscription directly via Yogobe. For more info, visit our"], "settings_subscriptions.cancelled_no_access": "Your active subscription has been cancelled. Therefore you currently do not have access to videos, playlists, programs or challenges. Reactivate anytime by making a subscription payment.", "settings_subscriptions.cancelled_with_access": ["Your active subscription has been cancelled but you still have access to videos, playlists, programs and challenges until ", ["date"], ". Reactivate anytime by making a subscription payment."], "settings_subscriptions.description_free": "Your membership does not currently have a premium subscription", "settings_subscriptions.description_no_subscription_premium": ["You have valid access until ", ["date"]], "settings_subscriptions.discount_code.description": "If you have a code that gives you a subscription discount, you can enter it in the below text field", "settings_subscriptions.discount_code.input_description": "Also applies to discount- and special offer codes", "settings_subscriptions.discount_code.input_label": "Enter your discount code", "settings_subscriptions.discount_code.invalid_code_message": "The code you provided is not correct or no longer valid. You can try again or connect with us for help at <0>info@yogobe.com</0>", "settings_subscriptions.discount_code.submit_btn": "Activate", "settings_subscriptions.discount_code.title": "Do you have a discount code?", "settings_subscriptions.discount_code.valid_code_message": "Your code is valid!", "settings_subscriptions.mobile_description_premium_renew": ["Your subscription will automatically be renewed via ", ["platform"], " on ", ["date"]], "settings_subscriptions.monthly": "Monthly", "settings_subscriptions.quarterly": "Quarterly", "settings_subscriptions.subscription_next_billing": ["Your recurring ", ["plan"], " subscription of ", ["amount"], " will be automatically renewed on ", ["date"]], "settings_subscriptions.subscription_next_billing_failed": ["The payment of ", ["amount"], " could not be processed"], "settings_subscriptions.subscription_next_billing_processing": "Your payment is being processed", "settings_subscriptions.subscription_next_billing_unpaid": ["The payment of ", ["amount"], " could not be processed at this time. We are making charge attempts in order to keep your subscription active."], "settings_subscriptions.title": "Would you like to change your subscription type?", "settings_subscriptions.toaster_message.access_code_activated": "Code successfully activated!", "settings_subscriptions.updated": "Confirmation: Access time added", "settings_subscriptions.wellness_banner.description": "You can use your wellness grant allowance to purchase Yogobe subscriptions and online courses. We currently support Benify, ePassi, Wellnet, and Benefits. <0>Read more here.</0>", "settings_subscriptions.wellness_banner.title": "Did you know?", "share_modal.copied_button": "Copied!", "share_modal.copy_placeholder": "Copy this URL to share:", "share_modal.hidden": "You can share this playlist but it can only be accessed via the link/URL. <0>Edit playlist settings.</0>", "share_modal.privacy": "You can share this playlist but no one will be able to see it. <0>Edit playlist settings.</0>", "share_modal.title": "Share", "snackbar.faq": "FAQ page", "snackbar.favorites": "Favorites", "snackbar.playlist": "View Playlist", "snackbar.playlists": "Playlists", "snackbars.added_video_playlist": "Video successfully added to playlist", "snackbars.cancel_subscription_faild": "Sorry, the subscription couldn’t be cancelled. Please try again!", "snackbars.challenge.program_access_granted": "You successfully joined this challenge", "snackbars.created_playlist": "Playlist created successfully", "snackbars.favorited_playlist": "Successfully saved to favorites", "snackbars.favorited_video": "Successfully saved to favorites", "snackbars.removed_video_playlist": "Video successfully removed from playlist", "snackbars.settings_update": "Your settings have been successfully updated", "snackbars.subscription_succussfuly_canceled": "Subscription successfully cancelled. We hope to see you again soon!", "snackbars.unfavorited_playlist": "Removed as favorite", "snackbars.unfavorited_video": "Removed as favorite", "snackbars.updated_playlist": "Playlist updated successfully", "sortby.published_at": "Latest added", "sortby.time": "Time", "special399.banner.usp1": "special399.banner.usp1", "specialoffer.banner_cta": "Yes please", "specialoffer.banner_tag1": "14 day free trial", "specialoffer.banner_tag2": "Limited time offer", "specialoffer.banner_title": "Upgrade your subscription and get a 500 SEK Yogiraj voucher", "specialoffer.new_banner_title": "Join 115 000 members and become part of the Yogobe family", "spring_challenge.thankyou": "We are happy that you are joining Yogobe Spring Challenge and we look forward to following your progress over the coming weeks. Remember. Don't think, just do. CLICK PLAY!", "springchallenge.banner.disclaimer": "springchallenge.banner.disclaimer", "springchallenge.banner.subtitle": "springchallenge.banner.subtitle", "springchallenge.banner.title": "Yogobe Spring Challenge", "springchallenge.form.title": "Yogobe Spring Challenge", "springchallenge.info.excerpt": "springchallenge.info.excerpt", "springchallenge.info.rest": "springchallenge.info.rest", "springchallenge.info.title": "springchallenge.info.title", "springchallenge.programsBody.more.body": "springchallenge.programsBody.more.body", "springchallenge.programsBody.more.title": "springchallenge.programsBody.more.title", "springchallenge.programsBody.subtitle": "springchallenge.programsBody.subtitle", "springchallenge.programsBody.title": "springchallenge.programsBody.title", "springchallenge.testimonials.title": "Leading teachers and experts guide and inspire", "start.section3_title": "Browse videos by categories", "statistics_banner.info": ["During ", ["year"], " we’ll be relaunching the statistics tab on Yogobe. Until further notice it is therefore on pause and we will let you know once its ready!"], "stats.average_duration": "Average duration", "stats.favorite_yoga_style": "Favorite yoga style", "stats.minutes": "minutes", "stats.sessions": "sessions", "stats.sessions_completed": "Sessions completed", "stats.total_time": "Total time", "stripe_banner.wellness_grant.december.text": "stripe_banner.wellness_grant.december.text", "stripe_banner.wellness_grant.november.text": "stripe_banner.wellness_grant.november.text", "subheader.overview": "Overview", "subheader.playlists": "Playlists", "subheader.programs": "Programs", "subscriptions.cancel_subscription": "Cancel subscription", "subscriptions.cancel_subscription_helper": "You can easily cancel an active subscription, If you actually decide to do so, you will still obviously have full access to the video library for the full duration of your current payment period.", "subscriptions.cancel_subscription_label": "Would you like to cancel your subscription?", "subscriptions.full_accesse_code.default_title": "Access via access code", "subscriptions.one_time_code.default_title": "Access via one time access code", "summerchallenge.banner.text": "summerchallenge.banner.text", "summerchallenge.banner.title": "Yogobe Spring Challenge", "summerchallenge.challenge_form.activate_account": "summerchallenge.challenge_form.activate_account", "summerchallenge.challenge_form.level_note": "summerchallenge.challenge_form.level_note", "summerchallenge.challenge_form.login": "summerchallenge.challenge_form.login", "summerchallenge.challenge_form.resend_activation": "summerchallenge.challenge_form.resend_activation", "summerchallenge.dashboard_banner.text": "summerchallenge.dashboard_banner.text", "summerchallenge.form.title": "summerchallenge.form.title", "summerchallenge.info.excerpt": "summerchallenge.info.excerpt", "summerchallenge.info.rest": "summerchallenge.info.rest", "summerchallenge.info.title": "summerchallenge.info.title", "summerchallenge.programsBody.more.body": "summerchallenge.programsBody.more.body", "summerchallenge.programsBody.more.title": "summerchallenge.programsBody.more.title", "summerchallenge.programsBody.subtitle": "summerchallenge.programsBody.subtitle", "summerchallenge.programsBody.title": "summerchallenge.programsBody.title", "summerchallenge.testimonials.title": "Leading teachers and experts guide and inspire", "summerchallenge.thank_you.text": "summerchallenge.thank_you.text", "summerchallenge.usergroup1.disclaimer": "*as long as you have an active subscription", "summerchallenge.usergroup1.infoform": "This challenge is included in your active subscription. Join today!", "summerchallenge.usergroup1.mainbanner": ["Hey ", ["firstName"], ", welcome to Yogobe Summer Challenge. The challenge is free for all active members*, get started today!"], "summerchallenge.usergroup2.disclaimer": "*Applies to both new and existing members. Get unlimited access to the video library, challenges and programs! (normal price: 189 SEK) ", "summerchallenge.usergroup2.infoform": "You need at least 28 days of access or a recurring subscription to start the challenge.", "summerchallenge.usergroup2.mainbanner": ["Hey ", ["firstName"], ", welcome to Yogobe Summer Challenge. Enter the challenge now for only 99 SEK*, get started today!"], "summerchallenge.usergroup3.disclaimer": "*Applies to both new and existing members. Get unlimited access to the video library, challenges and programs! (normal price: 189 SEK) ", "summerchallenge.usergroup3.infoform": "Enter the challenge now for only 99 SEK*", "summerchallenge.usergroup3.mainbanner": "Welcome to Yogobe Summer Challenge. Enter the challenge for only 99 SEK*, get started today!", "summerchallenge.video.extra": "summerchallenge.video.extra", "summerchallenge.video.repeat": "summerchallenge.video.repeat", "summerchallenge.video.technic": "summerchallenge.video.technic", "surveys_2022.validation.maxlength": ["A maximum of ", ["length"], " characters is allowed"], "surveys_2022.validation.minlength": ["A minimum of ", ["length"], " characters is required"], "surveys_2022.validation.required": "This field is required", "teacher_modal.go_to_profile": "Visit profile", "teacher_modal.homepage": "Homepage", "teacher_modal.location": "Location", "teacher_modal.speciality": "Speciality", "userlogin.logout": "Logout", "userlogin.menu.cancelled_plan": "Cancelled subscription", "userlogin.menu.expired_plan": "Inactive subscription", "userlogin.menu.free_premium": "Premium access", "userlogin.menu.free_trial": "Free trial", "userlogin.menu.manage": "Manage", "userlogin.menu.monthly_plan": "Monthly plan", "userlogin.menu.no_plan": "No subscription", "userlogin.menu.premium_plan": "Premium plan", "userlogin.menu.quarterly_plan": "Quarterly plan", "userlogin.menu.renew": "Reactivate", "userlogin.menu.upgrade": "Upgrade", "userlogin.menu.yearly_plan": "Yearly plan", "userlogin.my_dashboard": "Dashboard", "userlogin.my_favorites": "My Favorites", "userlogin.my_playlists": "My Playlists", "userlogin.my_stats": "My Statistics", "userlogin.my_subscription": "Subscription", "userlogin.settings": "My Settings", "usersubheader.dashboard": "Dashboard", "usersubheader.favorites": "Favorites", "usersubheader.for_me": "Recommendations", "usersubheader.my_favorites": "My Favorites", "usersubheader.my_playlists": "My Playlists", "usersubheader.playlists": "Playlists", "usersubheader.statistics": "Statistics", "validation.DOBInvalid": "The date format should be DD/MM/YYYY", "validation.DOBMax": "You should be X years old", "validation.DOBMin": "You're not that old are you?", "validation.email": "Please submit a valid email", "validation.email_taken": "You have entered an email address which already belongs to a Yogobe member. Please continue by logging in! ", "validation.firstNameMax": "First name is too long", "validation.lastNameMax": "Last name is too long", "validation.link": "Please fill in a complete URL", "validation.passwordConfirmNotMatch": "The passwords don't match", "validation.passwordMax": "You password may contain 18 characters at most", "validation.passwordMin": "Please make sure that you new password has at least 8 characters", "validation.phone": "This field should be a phone number", "validation.required": "This field is required", "validation.user_social_already_exists": "The email associated with the social account you used already belongs to a Yogobe member. Please try logging in instead or signup using a different social account/email.", "video.bundle_video_banner": "The following content is not part of your bundle", "video.premium_msg": "You have watched a 60 second preview. Do you want to see the rest?", "video.preview_msg": "Watching a 60s free preview", "video.related_video_title": "Related videos", "video.video_not_found": "Video not found", "video_cover_locked.Upgrade": "Upgrade", "video_cover_locked.login": "Login", "video_cover_locked.register": "Sign up", "video_settings_banner.info": "Customize your Yogobe experience by using the below filters instead of text search for exact results! Please also manage your language and video settings if needed!", "videos.beyoga365.description": "Theme- and intention months", "videos.beyoga365.title": "BEYOGA365", "videos.blog_posts_title": "Inspiration from our blog", "videos.get_started_section.title": "I want to", "videos.playlists_recommended.title": "Playlists recommended for you", "videos.programs.title": "Training programs", "videos.quickstart.suggestions": "Suggestions for you", "videos.weekly_picks.title": "Weekly picks", "videos.yogamom365.description": "Theme- and intention months", "videos.yogamom365.title": "YOGAMOM365", "videosGenres.discover": ["Discover ", ["name"], "’s sessions within other areas"], "videosGenres.sessions": "sessions", "videos_genres.count": [["count"], " results"], "videos_genres.keyword": ["for keyword \"", ["keyword"], "\""], "videos_genres.settings_button": "Video settings", "weeklyProgram.course_survey.locked": "Join the course in order to access this survey.", "weeklyProgram.document.locked": "weeklyProgram.document.locked", "weeklyProgram.document.open_document": "Open document", "weeklyProgram.introduction.label": "Introduction", "weeklyProgram.program_survey.locked": "Join the program and get access to this survey.", "weeklyProgram.survey.locked": "weeklyProgram.survey.locked", "weeklyProgram.week.number": ["Week ", ["number"]], "weeklyProgram.week.videos_duration": [["videosCount"], " videos - ", ["duration"]], "weeklyProgram.week_progress.text": "The progress indicates the percentage of videos you have completed in this week", "weeklyProgram.weekly_progress.program_content": "Program content", "yearlyfall2021.yearly_subscription_description": "Renewed every year. Upgrade before Oct 11 and get a free yoga mat." } };

/***/ }),

/***/ 91196:
/***/ (function(module) {

/*eslint-disable*/module.exports = { messages: { "An account verification email has been sent to {0}": ["An account verification email has been sent to ", ["0"]], "LegacyPaymentModal.choose_a_payment_method": "Choose a payment method", "The terms and conditions must be accepted.": "The terms and conditions must be accepted.", "WeeklyProgram.moodtracker.post.description": "WeeklyProgram.moodtracker.post.description", "WeeklyProgram.moodtracker.post.start_button": "WeeklyProgram.moodtracker.post.start_button", "WeeklyProgram.moodtracker.post.title": "WeeklyProgram.moodtracker.post.title", "WeeklyProgram.moodtracker.pre.description": "WeeklyProgram.moodtracker.pre.description", "WeeklyProgram.moodtracker.pre.start_button": "WeeklyProgram.moodtracker.pre.start_button", "WeeklyProgram.moodtracker.pre.title": "WeeklyProgram.moodtracker.pre.title", "access_code_modal.checkmark_activate": "Aktivoi", "access_code_modal.code_error": "Väärä pääsykoodi. Yritä uudelleen!", "access_code_modal.code_success": "Pääsykoodi rekisteröity onnistuneesti", "access_code_modal.code_success_access": ["Hienoa! Sinulla on nyt pääsy yrityksen ", ["companyName"], " valikoituun Yogobe-materiaaliin!"], "access_code_modal.code_success_redirect": "Sinut ohjataan nyt takaisin yleiskatsaukseen...", "access_code_modal.description": ["Yrityksen ", ["companyName"], " työntekijät ja yhteisyökumppanit saavat käyttöoikeuden tähän sisältöön pääsykoodia käyttämällä."], "access_code_modal.input_label": "Pääsykoodi", "access_code_modal.title": [" Siirry yrityksen ", ["companyName"], " suositeltuun sisältöön Yogobessa"], "account.verification_email_resent": ["Sinulle on lähetetty käyttäjätilin vahvistukseen liittyvä sähköposti osoitteeseen ", ["email"]], "banner.action": "Kyllä, kiitos", "banner.action2": "Anna meille palautetta", "banner.body": "Palaa vanhaan videokirjastoon?", "banner.castBanner": "Voit nyt jakaa videoita laitteestasi televisioon airplayta tai chromecastia käyttäen. (Chromecast ei valitettavasti tue vielä iOS-laitteita.)", "banner.companyFavorites": "Kaikki mitä merkitset suosikiksi näkyy julkisesti Yleiskatsauksessa suositeltuna sisältönä", "banner.course_maintenance": "Teemme parhaillaan päivityksiä Yogoben kursseihin tämän illan ja yön aikana. Kurssit eivät valitettavasti ole sinä aikana käytössä. Kiitämme ymmärryksestä ja toivotamme sinut tervetulleeksi jatkamaan käyttöä huomenna aamulla.", "banner.download_chrome": "Katsoessasi videota, käyttämäsi selain ei välttämättä toimi moitteettomasti. Suosittelemme sinua käyttämään", "banner.download_chrome_action": "Google Chromea", "banner.email_verify": ["Vahvista sähköpostisi (", ["email"], ") aktivoidaksesi jäsenyytesi. Etkö saanut viestiä? <0>Click here</0>"], "banner.email_verify_change_settings": "Vahvista päivitetyt käyttäjätilisi asetukset. Etkö saanut vahvistus emailia? <0>Click here</0>", "banner.monthlyCourseOffer": "banner.monthlyCourseOffer", "banner2.body": "Tarkastelet yhtä uusimmista ohjelmistamme. Palautteesi auttaa meitä kehittämään palveluamme.", "banner_subscribe.go_premium": "Päivitä jäsenyytesi", "banner_subscribe.header": "Haluaisitko rajoittamattoman pääsyn videokirjastoomme?", "blog.title": "Blogi", "bundle.dashboard_card.access_expired": "Käyttöoikeus on vanhentunut.", "bundle.get_started..access_code.show_text": "If you have an access code, <0>click here</0>", "bundle.get_started.access_code.info_text": "Lisää pääsykoodi.", "bundle.get_started.access_code.label": "Onko sinulle annettu pääsykoodi?", "bundle.get_started.access_code.not_valid": "The access code which you have entered is either no longer valid for this bundle page OR it has already been used once. Contact info@yogobe.com if you have any questions!", "bundle.get_started.access_code.tooltip_text": "Oletko saanut pääsykoodin yhdeltä kumppaniltamme? Käytä sitä päästäksesi sisältöön.", "bundle.get_started.access_code.valid": "Pääsykoodi on voimassa", "bundle.get_started.activation_failed_error": "Sivun aktivointi epäonnistui. Yritä uudelleen tai ota meihin yhteyttä osoitteessa <0></0>", "bundle.get_started.button.get_started": "Aloita", "bundle.get_started.button.login": "Kirjaudu sisään ja jatka", "bundle.get_started.button.register": "Liity ja jatka<<<<<<< HEAD", "bundle.get_started.by_code_description": "Tämä teemasivu on käytettävissä vain koodin kautta. Jos sinulla on pääsykoodi, kirjoita se alle.", "bundle.get_started.description": "Tarvitset pääsykoodin tähän sisältöön", "bundle.get_started.for_all_description": "Tämä teemasivu on ilmainen kaikille. Aktivoi se napsauttamalla alapuolelta Aloita.", "bundle.get_started.for_premium_description": "Tämä teemasivu sisältyy Yogobe Play -tilaukseen. Vaihtoehtoisesti, jos sinulla on pääsykoodi, voit kirjoittaa sen alle.", "bundle.get_started.for_subscription_only": "Tämä teemasivu kuuluu Yogobe Play -tilaukseesi.", "bundle.get_started.guest.welcome_message": ["Tervetuloa kokoelmaan ", ["bundle_name"]], "bundle.get_started.guest_description": ["Tervetuloa palveluun ", ["bundle_name"], ", tämän teemasivun sisältö on käytettävissä joko tilauksen kautta tai pääsykoodilla, jonka voit saada Yogobe-kumppanilta tai työnantajaltasi. Kirjaudu sisään tai luo tili, jonka jälkeen sinua pyydetään täyttämään pääsykoodi."], "bundle.get_started.guest_title": "Liity teemasivulle", "bundle.get_started.snackbar.access_granted": "Sinulla on nyt pääsy tähän sisältöön", "bundle.get_started.user.welcome_message": ["Hei ", ["name"], ", tervetuloa kokoelmaan ", ["bundle_name"]], "bundle.get_started.verify_account_banner": "Verify your account to be able to join the bundle.", "bundle.id_page.blog_sections.title": "Blogi", "bundle.id_page.challenge.discover_button": "Tutustu haasteeseen.", "bundle.id_page.challenges_sections.title": "Haasteet", "bundle.id_page.documents.required_access": "Tarvitset premium-pääsyoikeuden nähdäksesi tämän dokumentin", "bundle.id_page.documents_sections.title": "Dokumentit", "bundle.id_page.hero.access_until_text": ["Sinulla on voimassa oleva käyttöoikeus tähän sisältöön ", ["accessUntil"], " asti"], "bundle.id_page.hero.client_text": ["Vain ", ["clientName"], " jäsenille"], "bundle.id_page.hero.extend_access": "Pidennä pääsyoikeutta", "bundle.id_page.hero.get_access_btn": "Hae käyttöoikeutta", "bundle.id_page.hero.options_menu": "Vaihtoehdot", "bundle.id_page.hero.tooltip_text": "Hanki pääsy tähän sisältöön seuraavassa vaiheessa. Jos haluat vain Yogobe-kumppaneiden jäsenille tarkoitettua sisältöä, anna yksilöllinen pääsykoodisi. Yogobe-jäsenille tarkoitettua sisältöä varten – kirjaudu sisään tilillesi, tarvitset aktiivisen kokeilujakson tai maksullisen tilauksen.", "bundle.id_page.hero.tooltip_text<<<<<<< HEAD": "Rekisteröitymällä saat pääsyoikeuden tämän sivun sisältöihin maksutta siksi aikaa, kun tämä teemasivu on käytettävissä. Kokeilujakso ei muutu maksulliseksi tilaukseksi eikä vaadi luottokorttitietoja.>>>>>>> develop", "bundle.id_page.live_sections.title": "Live tapahtumat", "bundle.id_page.playlists_sections.title": "Soittolistat", "bundle.id_page.program.discover_button": "Tutustu ohjelmaan", "bundle.id_page.programs_sections.title": "Ohjelmat", "bundle.id_page.videos_sections.title": "Video & audio", "button.spring_challenge.end": "Liity Yogobe Summer Challengeen", "button.winter_challenge.end": "Liity Yogobe Spring Challengeen", "button_add_to_playlist.hidden": "Piilotettu", "button_add_to_playlist.private": "Yksityinen", "button_add_to_playlist.public": "Julkinen", "buy_gift.send_email_directly_label": "buy_gift.send_email_directly_label", "campaign.infos_show_less": "Näytä vähemmän", "campaign_info.read_less": "Piilota teksti", "campaign_info.read_more": "Lue lisää", "cancel_subscription_modal_four.paragraph": "Toivomme sinulle kaikkea hyvää, olet aina tervetullut takaisin!", "cancel_subscription_modal_four.title": "Ikävää, ettet voi jäädä aktiiviseksi jäseneksemme.", "cancel_subscription_modal_one.button_one": "Mene takaisin, muutin mieleni", "cancel_subscription_modal_one.button_two": "Kyllä, peruuta tilaus", "cancel_subscription_modal_one.paragraphe_one": ["Jos päätät lopettaa tilauksesi tänään, käyttöoikeutesi Yogoben jatkuvasti kasvavaan videokirjastoon päättyy ", ["date"], "."], "cancel_subscription_modal_one.paragraphe_two": "Teemme jatkuvasti töitä kehittääksemme palveluamme ja siksi arvostamme kovasti palautettasi.", "cancel_subscription_modal_one.title": "Haluatko varmasti keskeyttää tilauksesi?", "cancel_subscription_modal_three.button_activate": "Aktivoi 7 ekstrapäivää ja jää", "cancel_subscription_modal_three.paragraph": "Saammeko tarjota sinulle 7 ilmaispäivää Yogobeen?", "cancel_subscription_modal_three.title": "Minulla ei ole ollut aikaa", "cancel_subscription_modal_two.checkbox1": "Minulla oli vaikeuksia löytää itselleni sopivia videoita", "cancel_subscription_modal_two.checkbox2": "Minulla ei ole ollut aikaa", "cancel_subscription_modal_two.checkbox3": "Minulla ei ole tällä hetkellä mahdollisuuksia keskittyä Yogobeen", "cancel_subscription_modal_two.checkbox4": "Muu syy", "cancel_subscription_modal_two.title": "Miksi haluat peruuttaa tilauksesi tänään?", "cast_modal.subtitle": " suoratoistaaksesi istuntoja, päivitä jäsenyytesi ja saat rajoittamattoman pääsyn koko kirjastoon, ohjelmiin ja paljon muuta!", "cast_modal.title": "Tämä on premium-ominaisuus", "cast_modal.view_offers": "Katso tarjoukset", "challenge.week.infobar": "Tee kolme harjoitusta joka viikko neljän viikon ajan päästäksesi haastetavoitteeseen. Huom: ChromeCastin kautta katsottuja videoita ei valitettavasti voi merkitä tehdyksi", "challenge_2021.banner.discount_text": "Maksa vain 9,99e ensimmäisestä kuukaudesta*", "challenge_2021.banner.verify_account": "Vahvista jäsenyytesi aktivoidaksesi kokeilujakson, minkä jälkeen voit osallistua Yogobe Challengeen ", "challenge_2021.challenges_section.title": "Valitse yksi viidestä haasteohjelmasta", "challenge_2021.contact.contact_text": "Ota yhteyttä <0>business@yogobe.com</0>", "challenge_2021.contact.desc": "challenge_2021.contact.desc", "challenge_2021.contact.purchase_banner_back": "Takaisin", "challenge_2021.contact.title": "challenge_2021.contact.title", "challenge_2021.features_section.title": "Mitä tarvitset juuri nyt?", "challenge_2021.get_started.button.continue": "Jatka", "challenge_2021.get_started.button.continue_trial": "Jatka 14 päivän ilmaisjaksolla", "challenge_2021.get_started.button.start_suscription": "Aloita tilaus", "challenge_2021.get_started.button.upgrade_continue": "Päivitä ja jatka", "challenge_2021.get_started.description": "Olemme innoissamme, että haluat liittyä tähän ohjelmaan. Kirjaudu sisään tai luo tili jatkaaksesi. Tämä ohjelma sisältyy premium-tilaukseemme, ja sitä voi käyttää myös yrityspakettien kautta.", "challenge_2021.get_started.guest_title": ["Tervetuloa ohjelmaan ", ["program"]], "challenge_2021.get_started.option.have_account": "Olen jo jäsen", "challenge_2021.get_started.option.no_account": "Minulla ei ole jäsenyyttä", "challenge_2021.get_started.show_code_input": "Onko sinulla pääsykoodi? <0>Klikkaa tästä</0>", "challenge_2021.get_started.show_code_input_description": "Tämä on koodi, joka saadaan yleensä työpaikan tai oman organisaation kautta. ", "challenge_2021.get_started.user_title": ["Hei ", ["name"], ", tervetuloa ohjelmaan ", ["program"]], "challenge_2021.get_started_loggedin.description": "We are excited that you want to join this program. This program is included in our premium subscription plans and can also be accessed via corporate plans.", "challenge_2021.listing_page.hero.no_premium_desc": "Tervetuloa Yogobe Challengeen! Hanki rajoittamaton pääsy kaikkiin haasteohjelmiin aloittamalla tilaus vain 99 SEK*", "challenge_2021.listing_page.hero.no_premium_disclaimer": "*Tämä hinta on voimassa vain ensimmäisen kuukauden ja muuttuu automaattisesti normaalihinnaksi 19,99 EUR toistuvia maksuja varten.", "challenge_2021.listing_page.hero.premium_desc": "Tervetuloa Yogobe Challengeen! Pysy motivoituneena, aseta hyvinvointisi etusijalle ja haasta itsesi jollakin alla olevista ohjelmista.*", "challenge_2021.listing_page.hero.premium_disclaimer": "* Niin kauan kuin sinulla on premium-tilaus, sinulla on pääsy ohjelmiin ja haasteisiin.", "challenge_2021.listing_page.hero.title": "Yogobe Challenge <0>Uutuus</0>", "challenge_2021.metadata.browse_challenges": "Tutustu haasteohjelmiin", "challenge_2021.metadata.explore_challenges_btn": "Tutustu haasteohjelmiin", "challenge_2021.metadata.get_started_btn": "Aloita", "challenge_2021.metadata.how_it_works_btn": "Miten se toimii", "challenge_2021.metadata.start_now_btn": "Aloita nyt hintaan 99 SEK*", "challenge_2021.metadata.tags.challenge": "Challenge", "challenge_2021.metadata.tags.participating": "Osallistut", "challenge_2021.steps_section.step1.desc": "Valitse ohjelma, joka sopii sinulle parhaiten. Pyrimme tarjoamaan jokaiselle jotakin ja lisäämme sisältöä jatkuvasti!", "challenge_2021.steps_section.step1.title": "1. Valitse Challenge-ohjelmasi", "challenge_2021.steps_section.step2.desc": "Valitse ohjelma, jonka haluat aloittaa, aktivoi käyttöoikeutesi ja pääset heti alkuun!", "challenge_2021.steps_section.step2.title": "2. Aloita challenge", "challenge_2021.steps_section.step3.desc": "Pyri osallistumaan kolmeen harjoitukseen joka viikko neljän viikon ajan. Pitkäjänteisyys kannattaa!", "challenge_2021.steps_section.step3.title": "3. Haasta itsesi", "challenge_2021.steps_section.step4.desc": "Nyt kun olet saanut ohjelman päätökseen, jatka harjoittelua samojen videoiden kanssa tai aloita kokonaan uusi haaste.", "challenge_2021.steps_section.step4.title": "4. Pidä yllä hyviä rutiineja!", "challenge_2021.steps_section.title": "Aloittelijan opas", "challenge_form.already_applied": ["Melkein valmista! Olemme lähettäneet sinulle sähköpostia osoitteeseen ", ["email"], ". Jos sinulla on kysyttävää, otathan yhteyttä meihin: info@yogobe.com"], "challenge_form.already_applied_paragraph": ["Etkö ole saanut sähköpostia? <0>Paina tästä ja lähetä uudelleen. (", ["count"], "s)</0>"], "challenge_form.didnt_apply": "Voit vaihtaa ohjelmaa haasteen aikana ", "challenge_form.didnt_apply_1": ["Hyvä ", ["firstName"], ", täytä lomake, jotta pääset ohjelmaan ", ["title"], "!"], "challenge_form.didnt_apply_2": ["Täytä lomake, jotta saat rajoittamattoman pääsyn ohjelmaan ", ["title"], "!"], "challenge_form.email": "Sähköposti", "challenge_form.errors.email_used": "Antamasi sähköpostiosoite on jo käytössä. Jos se kuuluu sinulle, kirjaudu sisään.", "challenge_form.errors.required": "Tämä kohta on pakollinen", "challenge_form.first_name": "Etunimi", "challenge_form.gotoprogram": "Siirry ohjelmaan", "challenge_form.inprogram": ["Olet tällä hetkellä aktiivinen <0>", ["name"], "</0> ohjelmassa."], "challenge_form.last_name": "Sukunimi ", "challenge_form.level": "Ohjelma", "challenge_form.level_note": "Selaa alas ja lue lisää", "challenge_form.login": "challenge_form.login", "challenge_form.reset_program": "Haluatko vaihtaa ohjelmaa? <0>Paina tästä.</0>", "challenge_form.submit": "Aloita", "company.access_code_action": "Syötä pääsykoodi", "company.empty_company_programs_courses": ["Syötä pääsykoodisi nähdäksesi yrityksen ", ["companyName"], " kurssit ja ohjelmat"], "company.playlists_description": ["Soittolistat ovat video- ja audiokokoelmia yritykseltä ", ["companyName"]], "company.recommended_blog_posts": "Suositellut blogipostaukset", "confirm_delete_playlist_modal.description": ["Olet poistamassa pysyvästi soittolistaa <0>", ["title"], "</0>, joka koostuu ", ["videos_count"], " videosta. Tätä toimintoa ei voi perua. Haluatko jatkaa?"], "confirm_delete_playlist_modal.no": "Ei, en halua poistaa soittolistaa", "confirm_delete_playlist_modal.title": "Poista soittolista", "confirm_delete_playlist_modal.yes": "Kyllä, haluan poistaa soittolistan", "consent.cookies.accept": "Hyväksy evästeet", "consent.cookies.desc": "Käytämme omia ja kolmannen osapuolen evästeitä muokataksemme sisältöä sinulle ja parantaaksemme palveluamme analysoimalla verkkoliikennettä.", "consent.cookies.read_more": "Lue lisää evästeistä", "consent.cookies.reject": "Hylkää", "consent.cookies.title": "Käytämme evästeitä.", "courses_2021.banner.verify_account": "Vahvista sähköpostisi aktivoidaksesi jäsenyytesi.", "courses_2021.buy_gift.banner_text": " Ostat tämän kurssin lahjaksi. Jos haluat käyttää sitä itse, <0> napsauta tätä </0>", "courses_2021.buy_gift.description": "Olemme iloisia, että haluat antaa tämän kurssin lahjaksi ystävällesi", "courses_2021.buy_gift.description_tooltip": "Maksun jälkeen saat sähköpostiisi kurssin lahjakortin ja ohjeet ohjelman aktivointiin", "courses_2021.buy_gift.meta_title": ["Yogobe kurssi - ", ["title"]], "courses_2021.contact.contact_text": "Ota yhteyttä <0>business@yogobe.com</0>", "courses_2021.contact.desc": "Olemme niin iloisia, että sinä ja organisaatiosi olette kiinnostuneita aloittamaan Yogoben käytön. Digitaalinen, helppokäyttöinen ja helppo aloittaa. Yhdessä kehitämme ja räätälöimme sisältöä edistääksemme sekä fyysistä että henkistä terveyttä yrityksissä ja organisaatioissa yksilöille ja työntekijöille. Ohjelmamme muoto sopii erinomaisesti etätapaaville tiimeille ja työpaikoille, jotka etsivät inspiraatiota ja ohjausta aktiiviseen arkeen. Monipuoliset kiinnostuksen kohteet ja tarpeet huomioidaan – jokaiselle löytyy jotakin. Aloita ottamalla minuun yhteyttä sähköpostitse!", "courses_2021.contact.purchase_banner_back": "courses_2021.contact.purchase_banner_back", "courses_2021.contact.title": "Hei, tervetuloa Yogoben ohjelmaan!", "courses_2021.expiration_banner.expire_soon.buy_program_text": ["Käyttöoikeutesi tälle kurssille vanhenee ", ["days"], " päivän kuluttua. Laajenna käyttöoikeutta nyt jatkaaksesi kurssia. Kaikki edistymisesi tallennetaan. <0>Maksatko hyvinvointipalvelun kautta?</0>"], "courses_2021.expiration_banner.expire_soon.renew_access_free_text": ["Käyttöoikeutesi tälle kurssille vanhenee ", ["days"], " päivän kuluttua. Laajenna käyttöoikeutta nyt ilmaiseksi. Kaikki edistymisesi tallennetaan."], "courses_2021.expiration_banner.expire_soon.upgrade_to_renew_text": ["Käyttöoikeutesi tälle kurssille vanhenee ", ["days"], " päivän kuluttua. Päivitä maksulliseen tilaukseen ja rajoittamaton pääsy tälle kurssille sisältyy hintaan. Kaikki edistymisesi on tallennettu."], "courses_2021.expiration_banner.expired.buy_program_text": ["Käyttöoikeutesi tähän ohjelmaan päättyi ", ["days"], " päivää sitten. Uusi käyttöoikeutesi jatkaaksesi kurssia. Kaikki edistymisesi on tallennettu."], "courses_2021.expiration_banner.expired.renew_access_free_text": ["Käyttöoikeutesi tälle kurssille päättyi ", ["days"], " päivää sitten. Uusi käyttöoikeus nyt ilmaiseksi. Kaikki edistymisesi tallennetaan."], "courses_2021.expiration_banner.expired.renew_with_discount_text": ["Käyttöoikeutesi tälle kurssille päättyi ", ["days"], " päivää sitten. Uusi käyttöoikeutesi nyt ja saat ", ["discount"], " alennuksen. Kaikki edistymisesi on tallennettu. <0>Maksatko hyvinvointipalvelun kautta?</0>"], "courses_2021.expiration_banner.expired.upgrade_to_renew_text": ["Tämä kurssi vanheni ", ["days"], " sitten. Voit uusia käyttöoikeuden nyt ilmaiseksi."], "courses_2021.expiration_banner.expires_soon.extend_with_discount_text": ["Käyttöoikeutesi tälle kurssille vanhenee ", ["days"], " päivän kuluttua. Uusi käyttöoikeutesi nyt ja saat ", ["discount"], " alennuksen. Kaikki edistymisesi tallennetaan. <0>Maksatko hyvinvointipalvelun kautta?</0>"], "courses_2021.get_started.access_code.icon_text": "Enter your unique code in the above box", "courses_2021.get_started.access_code.not_valid": "Antamasi pääsykoodi ei kelpaa.", "courses_2021.get_started.access_code.tooltip_text": "Voit käyttää Yogobessa erilaisia ​​koodeja. Ne antavat sinulle pääsyn tai alennuksia laajan sisältökirjastomme eri segmentteihin.  Pääsykoodi: Koodi, jonka saatat saada työnantajaltasi tai kumppaniorganisaatioltasi Yogobelle.  Lahjakortti: Koodi, jonka olet saattanut saada ystävältäsi.  Alennuskoodi: Koodi/uskollisuustarjous, joka antaa sinulle alennuksen Yogoben segmentistä tai palvelusta. ", "courses_2021.get_started.access_code.valid": "Koodi rekisteröity!", "courses_2021.get_started.access_code_mismatch": "Tämä koodi on voimassa, mutta aktivoi toisen kurssin", "courses_2021.get_started.access_code_only_description": "Tervetuloa! <br/> Kurssille voi osallistua vain pääsykoodilla. Tämä koodi toimitetaan sinulle joko Yogoben, kumppaniorganisaation tai tietyn yrityksen/työnantajan kautta.", "courses_2021.get_started.activation_error": "Sorry, we were unable to activate the course for you, please contact us at info@yogobe.com", "courses_2021.get_started.button.activate_for_free": "Aktivoi", "courses_2021.get_started.button.continue_trial": "Jatka 14 päivän ilmaisjaksolla", "courses_2021.get_started.button.login": "Kirjaudu ja jatka", "courses_2021.get_started.button.purchase": "Jatka vahvistamaan maksu", "courses_2021.get_started.button.start_suscription": "Aloita tilaus", "courses_2021.get_started.code_label": "Yksilöllinen koodisi", "courses_2021.get_started.description": " Tervetuloa! <br/> Kurssille voit osallistua maksamalla sen tai pääsykoodilla tai lahjakortilla!", "courses_2021.get_started.end_of_access": "Käyttöoikeus voimassa", "courses_2021.get_started.guest_title": ["Tervetuloa ohjelmaan ", ["program"]], "courses_2021.get_started.join_btn": "Join course", "courses_2021.get_started.option.have_account": "Olen jo jäsen", "courses_2021.get_started.option.no_account": "Minulla ei ole jäsenyyttä", "courses_2021.get_started.purchase_banner_text": "Jos edustat yritystä ja haluat tarjota henkilöstöllesi käyttöoikeuden, <0>klikkaa tästä</0>", "courses_2021.get_started.show_code_input": "Onko sinulla yksilöllinen koodi? <0>Klikkaa tästä</0>", "courses_2021.get_started.show_code_input_description": "Koodi voi olla joko pääsykoodi, lahjakortti tai antaa sinulle tietyn alennuksen.", "courses_2021.get_started.user_title": ["Hei ", ["name"], ", tervetuloa ohjelmaan ", ["program"]], "courses_2021.get_started_loggedin.description": "Tervetuloa! <br/> Kurssille voit osallistua maksamalla sen tai pääsykoodilla tai lahjakortilla!", "courses_2021.header.access_until": ["Käyttöoikeus tähän kurssiin päättyy ", ["date"]], "courses_2021.listing_page.hero.no_premium_disclaimer": "Maksatko hyvinvointiedulla? <0>Lue lisää täältä</0>", "courses_2021.listing_page.hero.premium_disclaimer": "Maksatko hyvinvointiedulla? <0>Lue lisää täältä</0>", "courses_2021.listing_page.meta.description": "Tervetuloa Yogobe-kursseille - yhdessä johtavien asiantuntijoiden kanssa olemme luoneet useisiin erilaisiin tarpeisiin ja kiinnostuksen kohteisiin räätälöityjä verkkokursseja. Tämä segmentti on Yogobe-tilaustarjouksen ulkopuolella. Kurssit ostetaan kertamaksulla, jolla saa 12 kuukauden käyttöoikeuden. Tutustu erilaisiin kursseihin jo tänään ja osallistu yhdelle tai useammalle kerrallaan.", "courses_2021.listing_page.meta.title": "Yogobe Kurssit", "courses_2021.listings_page.clear_events_filters": "Tyhennä suodattimet ja etsi", "courses_2021.listings_page.explore_programs_btn": "Tutustu kursseihin", "courses_2021.listings_page.faq_btn": "UKK", "courses_2021.listings_page.filters.languages": "Näytä minulle kurssit", "courses_2021.listings_page.hero_title": "Yogobe kurssit", "courses_2021.listings_page.load_more_btn": "Näytä lisää kursseja", "courses_2021.listings_page.no_programs_found": "Hups... Emme löytäneet tätä hakutermiä tai suodatinyhdistelmää vastaavaa ohjelmaa. Tämä ei tarkoita, etteikö meillä olisi etsimääsi. Yritä tyhjentää suodattimet tai muotoilla hakukyselysi uudelleen!", "courses_2021.listings_page.search_input_placeholder": "Etsi Yogoben kursseja", "courses_2021.listings_page.subtitle": "Tervetuloa Yogobe-kursseille - yhdessä johtavien asiantuntijoiden kanssa olemme luoneet useisiin erilaisiin tarpeisiin ja kiinnostuksen kohteisiin räätälöityjä verkkokursseja. Tämä segmentti on Yogobe-tilaustarjouksen ulkopuolella. Kurssit ostetaan kertamaksulla, jolla saa 12 kuukauden käyttöoikeuden. Tutustu erilaisiin kursseihin jo tänään ja osallistu yhdelle tai useammalle kerrallaan.", "courses_2021.other_courses": "Muut kurssit", "courses_2021.program_page.breadcrumb": "Yogobe kurssit", "courses_2021.progress_page.parts_title": "Kurssin sisältö", "courses_2021.progress_page.video_lock.button_text": "Osallistu kurssille", "courses_2021.progress_page.video_lock.text": "Olet juuri katsonut 60 sekunnin esikatselun. Haluatko kirjautua sisään ja/tai aloittaa tämän kurssin nyt avataksesi sen kaiken sisällön?", "courses_2021.snackbars.access_granted": "Liityit onnistuneesti tälle kurssille.", "courses_listing.faq.item1.body": "Verkkokurssimme eivät ole osa Yogobe Playta ja tilauksia, mikä tarkoittaa, että ne ostetaan erikseen, olitpa jo maksava jäsen vai et. Osallistuaksesi kurssille kirjaudu sisään Yogobe-tilillesi ja jatka valitsemasi kurssin ostamista.", "courses_listing.faq.item1.title": "Kuka voi osallistua online-kurssille?", "courses_listing.faq.item10.body": "Kurssimme ovat viime aikoina saaneet samanlaisen suunnittelun ja rakenteen kuin ohjelmamme ja haasteemme. Uusi rakenne luotiin parantamaan käyttökokemusta, esimerkiksi osallistujat voivat nyt nähdä edistymisensä paljon selkeämmin ja palkitsevammin muiden hienojen ominaisuuksien ohella.", "courses_listing.faq.item10.title": "Mitä uusi kurssisuunnittelu ja -rakenne tarkoittaa?", "courses_listing.faq.item11.body": "Kun pääsyaikasi kurssille päättyy, sinulle tarjotaan uusinta alennettuun hintaan, joka on yleensä 30% alennus alkuperäisestä hinnasta. Jos päätät olla uusimatta kurssia, menetät sen käyttöoikeuden käyttöaikasi umpeuduttua. Kurssi edistyminen kuitenkin tallennetaan, jos haluat jatkaa pääsyäsi ja käyttää tarjottua alennusta myöhemmin.", "courses_listing.faq.item11.title": "Mitä tapahtuu, kun käyttöaikani päättyy?", "courses_listing.faq.item12.body": "Kyllä! Jos haluat osallistua kurssille pidempään kuin sen pääsyaika (joka yleensä on jopa 12 kuukautta – katso kunkin kurssin tarkemmat tiedot), voit pidentää pääsyä ostamalla sen alennettuun hintaan, joka yleensä on 30 % alennus. Tarjous on voimassa viimeisestä 30 käyttöpäivästä alkaen, vaikka käyttöaikasi olisi umpeutunut. <br/> <br/> Tämä tarjous koskee vain ostoksia, jotka on tehty suoraan osoitteessa <a href=\"https://www.yogobe.com\">www.yogobe.com</a>, eikä se ole voimassa, jos olet osti kurssin alun perin hyvinvointiedun tarjoajan kautta.", "courses_listing.faq.item12.title": "Saanko alennuksen, jos ostan kurssin uudelleen myöhemmin?", "courses_listing.faq.item13.body": "Kun napsautat kurssia, siirry yleiskatsaussivun oikeaan yläkulmaan ja etsi suuri laatikko. Napsauta kolmea pistettä ruudun oikeassa yläkulmassa ja valitse Pidennä käyttöoikeutta. Kun kurssilla on 30 päivää käyttöoikeutta jäljellä tai se on jo vanhentunut, näet myös sivun yläosassa bannerin, josta voit klikata Pidennä/Uusi pääsyoikeus.", "courses_listing.faq.item13.title": "Kuinka voin pidentää pääsyaikani kurssille?", "courses_listing.faq.item14.body": "1) Jos haluat ostaa kurssin, jolle itse osallistut, lahjaksi jollekin toiselle: Mene kurssin yleiskatsaussivulle. Sivun oikeasta yläkulmasta löydät suuren laatikon – napsauta kolmea pistettä sen oikeassa yläkulmassa. Jatka klikkaamalla Osta lahjaksi. <br/> <br/> 2) Jos haluat ostaa lahjaksi kurssin, jolle et osallistu: <br/> <br/> Napsauta kurssia, jonka haluat ostaa lahjaksi ja napsauta sitten Osta lahjaksi -linkki, jonka löydät Liity kurssille -painikkeen vierestä. <br/> <br/> Lahjakortti on voimassa 12 kuukautta ostopäivästä.", "courses_listing.faq.item14.title": "Miten ostan kurssin lahjaksi?", "courses_listing.faq.item15.body": "Kaikki kurssit ostetaan kertamaksulla, eikä osallistumistasi voi perua tällä hetkellä. Ostamasi kurssi on käytettävissäsi, kunnes käyttöaika on umpeutunut. Lisäämme pian ominaisuuden, jolla voit halutessasi pysäyttää/arkistoida kurssin.", "courses_listing.faq.item15.title": "Voinko perua osallistumiseni kurssille?", "courses_listing.faq.item16.body": "Klikkaa kurssia, jolle olet saanut pääsykoodin. Klikkaa \"Liity kurssille\". <br/> Etsi teksti: \"Onko sinulla yksilöllinen koodi? Klikkaa tästä\" ja klikkaa linkkiä. <br/> Täytä koodi kenttään ja klikkaa ✓.", "courses_listing.faq.item16.title": "Miten osallistun kurssille pääsykoodilla?", "courses_listing.faq.item2.body": "Aloita klikkaamalla kurssia, jonka olet kiinnostunut ostamaan. Napsauta sitten Liity kurssille -painiketta ja täytä maksutietosi. Sinulle tarjotaan kaksi vaihtoehtoa, joko kertamaksun suorittaminen luottokortilla tai suoraan Swishin kautta. Kurssi aktivoidaan heti, kun osto on suoritettu.", "courses_listing.faq.item2.title": "Miten ostan kurssin?", "courses_listing.faq.item3.body": "Kyllä, voit ostaa verkkokurssin hyvinvointiapurahallasi. Aloita tekemällä ostoksesi suoraan osoitteessa www.yogobe.com. Löydät sitten kuitin profiilisi kautta sivun oikeasta yläkulmasta. Lataa kuitti laitteellesi napsauttamalla Omat asetukset ja sitten <a href=\"https://yogobe.com/en/me/settings/receipts\">Omat kuitit</a>.", "courses_listing.faq.item3.title": "Voinko ostaa kurssin hyvinvointiedullani?", "courses_listing.faq.item4.body": "Kyllä, totta kai! Online-kurssimme ovat saataville Benifyn, Wellnetin ja ePassin kautta.", "courses_listing.faq.item4.title": "Voinko ostaa kurssin hyvinvointietukumppanin kautta?", "courses_listing.faq.item5.body": "Ei, verkkokurssimme eivät sisälly tilauksiin – ne ostetaan erikseen. Sinulla ei tarvitse olla aktiivista tilausta voidaksesi ostaa tai osallistua verkkokursseillemme. Sinulla on kuitenkin oltava tili Yogobessa, jotta voit kirjautua sisään, jatkaa ostoa ja osallistua valitsemallesi kurssille.", "courses_listing.faq.item5.title": "Kuuluuko tilaukseeni mitään kursseja?", "courses_listing.faq.item6.body": "Kun ostat kurssin, sinulla on pääsy enintään 12 kuukaudeksi kurssin pituudesta riippumatta. Katso kunkin kurssin tiedot saadaksesi lisätietoja niiden käyttöajoista.", "courses_listing.faq.item6.title": "Kuinka kauan minulla on pääsy kurssille?", "courses_listing.faq.item7.body": "Löydät aktiiviset kurssisi <a href=\"https://yogobe.com/en/me/dashboard\">hallintapaneelistasi</a>. Päästäksesi profiiliisi sinun tulee olla kirjautuneena Yogobe-tilillesi.", "courses_listing.faq.item7.title": "Olen ostanut kurssin, mistä löydän sen?", "courses_listing.faq.item8.body": "Tällä hetkellä kurssit ovat saatavilla vain verkkosivuillamme www.yogobe.com. Mutta voit aina käyttää niitä älypuhelimesi verkkoselaimen kautta. Pian kurssit ovat saatavilla myös sovellusten kautta.", "courses_listing.faq.item8.title": "Voinko osallistua kurssille sovelluksessa?", "courses_listing.faq.item9.body": "Ehdottomasti! Voit osallistua niin monelle kurssille samanaikaisesti kuin haluat.", "courses_listing.faq.item9.title": "Voinko ostaa ja osallistua useammalle kuin yhdelle kurssille kerrallaan?", "createplaylist_modal.actions.primary": "Tallenna", "createplaylist_modal.actions.secondary": "Peruuta", "createplaylist_modal.description.label": "Kuvaus", "createplaylist_modal.description.placeholder": "Kuvaile soittolistaasi", "createplaylist_modal.hidden_helper": "Soittolistasi on piilotettu.", "createplaylist_modal.hidden_title": "Piilotettu soittolista", "createplaylist_modal.name.label": "Nimi", "createplaylist_modal.name.placeholder": "Anna soittolistallesi nimi", "createplaylist_modal.options.one": "Julkinen", "createplaylist_modal.options.three": "Yksityinen", "createplaylist_modal.options.two": "Piilotettu", "createplaylist_modal.privacy_helper": "Profiilisi on määritelty yksityiseksi, mutta tämä soittolista on kuitenkin julkinen. <0>Muokkaa yksityisyysasetuksia.</0>", "createplaylist_modal.private_helper": "Soittolistasi on yksityinen.", "createplaylist_modal.private_title": "Yksityinen soittolista", "createplaylist_modal.public_helper": "Soittolistasi on julkinen ja se voi näkyä myös muille käyttäjille.", "createplaylist_modal.public_title": "Julkinen soittolista", "dashboard.bundles_section.title": "Sinun kokoelmasi", "dashboard.challenges_section.description": ["Osallistut tällä hetkellä ", ["count"], " haasteeseen"], "dashboard.challenges_section.discover": "Tutustu haasteisiimme", "dashboard.challenges_section.explore_programs": "Tutustu haasteisiimme", "dashboard.challenges_section.title": "Sinun haasteesi", "dashboard.courses_section.description": ["Osallistut tällähetkellä ", ["count"], " kurssiin"], "dashboard.courses_section.discover": "Tutustu kursseihimme", "dashboard.courses_section.empty_list": "Et tällä  hetkellä osallistu yhteenkään kurssiin.", "dashboard.courses_section.explore_courses": "Tutustu Yogoben kursseihin", "dashboard.courses_section.title": "Sinun kurssisi", "dashboard.events_section.discover": "Tutustu tuleviin LIVE-tunteihin", "dashboard.events_section.empty_list": "Sinulla ei ole tulevia LIVE-tapahtumia", "dashboard.events_section.expired_events": "Päättyneet LIVE-tunnit", "dashboard.events_section.explore": "Tutustu kaikkiin LIVE-tunteihin", "dashboard.events_section.show_previous_events": "Näytä aikaisemmat tuntini", "dashboard.events_section.title": "Varatut LIVE-tapahtumasi", "dashboard.for_me.courses.title": "Kurssit sinulle", "dashboard.for_me.playlists.title": "Soittolistasuositukset sinulle", "dashboard.for_me.programs.title": "Ohjelmat sinulle", "dashboard.for_me.videos.title": "Videosuositukset sinulle", "dashboard.last_watched_sessions_section.title": "My latest viewed sessions", "dashboard.my_stats.beta_stripe_message": "Tämä ominaisuus on betavaiheessa, joten jotkin tulokset eivät välttämättä ole 100 % tarkkoja. Kun toimit pidempään palvelumme parissa, keräämme lisää tietoja puolestasi ja etsimme tapoja havainnollistaa niitä täällä erilaisten kaavioiden avulla. Tämä on ensimmäinen versiomme. Tavoitteemme on tarjota sinulle selkeä ja läpinäkyvä yleiskuva Yogobe-toiminnastasi. Jos sinusta tuntuu, että jotain puuttuu, ota yhteyttä: data@yogobe.com", "dashboard.my_stats.challenges_started": "Number of challenges started", "dashboard.my_stats.completed_sessions": "Number of sessions completed", "dashboard.my_stats.courses_started": "Number of courses started", "dashboard.my_stats.empty_result": "So far, no data to visualize!", "dashboard.my_stats.explore_challenges": "Explore Yogobe challenges", "dashboard.my_stats.explore_courses": "Explore yogobe courses", "dashboard.my_stats.explore_library": "Explore Yogobe library", "dashboard.my_stats.explore_live_events": "Explore Yogobe LIVE", "dashboard.my_stats.explore_programs": "Explore Yogobe programs", "dashboard.my_stats.explore_yogobe_team": "Explore Team Yogobe", "dashboard.my_stats.favorited_sessions": "Number of sessions favorited", "dashboard.my_stats.live_events_booked": "Number of LIVE events booked", "dashboard.my_stats.most_watched_instructors": "Top 3 most viewed experts", "dashboard.my_stats.most_watched_styles": "3 most watched session styles", "dashboard.my_stats.my_favorited_sessions": "View my favorites", "dashboard.my_stats.my_playlists": "View my playlists", "dashboard.my_stats.period_month": "Last 30 days", "dashboard.my_stats.period_week": "Last 7 days", "dashboard.my_stats.playlists_created": "Number of playlists created", "dashboard.my_stats.programs_started": "Number of programs started", "dashboard.my_stats.three_most_watched_styles": "Your total audio and video engagement in minutes", "dashboard.my_stats.title": "Your personal engagement and statistics", "dashboard.pricing_description": "Mikä jäsenyysvaihtoehto sopii sinulle parhaiten?", "dashboard.pricing_title": "Liity jäseneksi ja saat rajoittamattoman käyttöoikeuden videokirjastoon!", "dashboard.programs_section.description": ["Osallistut tällä hetkellä ", ["count"], " ohjelmaan"], "dashboard.programs_section.discover": "Tutustu ohjelmiimme", "dashboard.programs_section.empty_list": "Et tällä hetkellä osallistu mihinkään ohjelmaan.", "dashboard.programs_section.explore_programs": "Tutustu Yogoben ohjelmiin", "dashboard.programs_section.title": "Sinun ohjelmasi", "dashboard.recommendation.empty.button": "Muokkaa suosituksia", "dashboard.recommendation.empty.desc": "Kerro meille kiinnostuksen kohteistasi ja tarpeistasi, jotta voimme suositella sinulle sopivaa sisältöä!", "dashboard.recommendation.empty.title": "Suositeltuja videoita & soittolistoja", "dashboard.recommendations.complete_onboarding": "Aloitetaan", "dashboard.recommendations.content_languages": "Näytä minulle suositeltua sisältöä", "dashboard.recommendations.edit_preferences": "Muokkaa suosituksia", "dashboard.recommendations.filter_default_label": "Suodata tarpeiden ja kiinnostuksen kohteiden mukaan ", "dashboard.recommendations.meta_title": "Suositukset", "dashboard.recommendations.title": "Sinulle suositeltu sisältö perustuu valitsemiisi mieltymyksiin. Voit muokata niitä milloin haluat.", "dashboard.recommendations.view_recommendations": "Haluatko löytää kiinnostavia ja tarpeisiisi sopivia videoita? <0>Katso suosituksemme</0>", "dashboard.recommendations.visit_recommendations": "Haluatko löytää sinua kiinnostavat ja tarpeisiisi sopivat videot helposti ja nopeasti?", "dashboard.settings.email_settings.desc": "Hallinnoi, mitä sähköposteja haluat vastaanottaa. Voit muuttaa näitä asetuksia koska tahansa.", "dashboard.settings.email_settings.title": "Hallinnoi sähköposti-ilmoituksia", "dashboard.settings.email_update_failed": ["Jostakin syystä emme voineet tallentaa sähköpostiasi. Yritä uudelleen tai ota yhteyttä <0>", ["email"], "</0> jotta voimme auttaa sinua!"], "dashboard.settings.live_codes.banner_desc": "Valitse haluamasi LIVE-tunti ja napsauta <0>Varaa</0>. Seuraavassa vaiheessa kirjoita koodi <0>Pääsykoodi</0>-kenttään ja käytä sitä päästäksesi harjoitukseen ilman maksua! <0></0> PS. Koodit koskevat vain sinun tiliäsi, eikä niitä voi jakaa.", "dashboard.settings.live_codes.banner_title": "Miten käytän koodia?", "dashboard.settings.live_codes.code_label": "Live koodi", "dashboard.settings.live_codes.desc": "=======>>>>>>> master", "dashboard.settings.live_codes.empty_text": "Sinulla ei tällä hetkellä ole LIVE-tapahtumakoodeja.", "dashboard.settings.live_codes.events": "Sopivat LIVE tapahtumat", "dashboard.settings.live_codes.expiration": ["Päättymässä ", ["date"]], "dashboard.settings.live_codes.multiple_usage_code_item": ["Lunastettu ", ["usageDate"], " ", ["title"], " ja ", ["instructor"], "."], "dashboard.settings.live_codes.multiple_usage_code_left": ["Voit silti käyttää tätä koodia ", ["availableUsage"], " kertaa."], "dashboard.settings.live_codes.multiple_usage_code_summary": ["Tämä koodi lunastettiin ", ["usedTimes"], " / ", ["usageLimit"], " tapahtumasta."], "dashboard.settings.live_codes.single_usage_code": ["Tämä koodi lunastettiin ", ["usageDate"], " ", ["title"], " ja ", ["instructor"], "."], "dashboard.settings.live_codes.title": "LIVE pääsykoodit", "dashboard.settings.live_codes.trial_panel.desc": "Osana kokeilujaksoasi olet saanut kaksi pääsykoodia, jotka voit lunastaa missä tahansa premium LIVE-tunneillamme. <0>Tutustu Yogobeen LIVE-tilassa</0>", "dashboard.settings.live_codes.trial_panel.title": "LIVE -kokeilukoodit", "dashboard.settings.live_codes.trial_panel.title_tooltip": "Nämä kaksi ilmaista LIVE-koodia ovat osa Yogobe-kokeiluasi. Ne ovat voimassa 60 päivää tilisi luomisesta. <0>Tutustu Yogobeen LIVE-tilassa</0>", "dashboard.settings.live_codes.wellness_panel.desc": ["Olet ostanut tämän LIVE-koodipaketin palveluntarjoajalta ", ["provider"], " ", ["date"], " ja olet saanut seuraavan pääsykoodin, jota voit käyttää alla mainituissa LIVE-tapahtumissa."], "dashboard.settings.live_codes.wellness_panel.title": "Hyvinvointi LIVE koodi", "dashboard.settings.live_codes.wellness_panel.title_tooltip": "Tämä on yleensä koodi/paketti, jonka olet ostanut hyvinvointipalveluntarjoajaltasi.", "email_preferences.prefrences_updated": "email_preferences.prefrences_updated", "email_preferences_page.desc": "Hallinnoi, mitä sähköposteja haluat vastaanottaa. Voit muuttaa näitä asetuksia koska tahansa joko napsauttamalla markkinointisähköpostiemme alatunnisteessa olevaa linkkiä tai hallintapaneelin kautta Yogobe.comissa.", "email_preferences_page.title": "Hallinnoi sähköposti-ilmoituksia", "emptyresults.click_here": "Klikkaa tästä", "emptyresults.empty": "Hups... Löytyi 0 tulosta.", "emptyresults.empty_filter": "Emme löytäneet hakuasi vastaavia tuloksia. Muokkaa hakuasi poistamalla valintoja tai kokeile vapaata sanahakua. Huomioi, että hakutuloksiin vaikuttaa myös kielivalintasi, jonka olet määrittänyt kohdassa <0>Videoasetukset</0>.", "emptyresults.to_clear_filters": "tyhjennä kaikki suodattimet", "emptyresults.try_adjusting_or": "Muuta hakukriteereitäsi saadaksesi lisää tuloksia tai", "error.action": "Siirry aloitussivulle", "error.body_404_part1": "Yrität päästä sivulle, jota ei näytä olevan olemassa. Kokeile Yogoben hakutoimintoa löytääksesi etsimäsi. Kiitos, kun vierailit sivuillamme!", "error.body_404_part2": "Jotain meni vikaan. Kokeile Yogoben hakutoimintoa löytääksesi etsimäsi. Kiitos, kun vierailit sivuillamme!", "error.body_500": "Todennäköisesti ongelma on linkissä, jota klikkaamalla päädyit tänne. Vika voi myös olla selaimessa tai verkkoyhteydessä. Päivitä ensin sivu tai kokeile Google Chromea. Jos ongelma jatkuu, otathan meihin yhteyttä <0>data@yogobe.com</0>, jotta voimme auttaa sinua parhaamme mukaan. Kiitos!", "error.dear_visitor": "Jotain meni pieleen...", "error.server_error": "Jotain meni pieleen...", "errors.maxlength": ["Voit kirjoittaa max ", ["length"], " merkkiä"], "favorites.empty_playlists_description": "Et ole vielä lisännyt soittolistoja suosikkeihisi", "favorites.empty_playlists_title": "Suosikkisoittolistani", "favorites.empty_videos_description": "Et ole vielä lisännyt videoita suosikkeihisi", "favorites.empty_videos_title": "Suosikkivideoni", "favorites.playlists_company_empty_description": [["companyName"], " ei ole vielä valinnut yhtään suosikkisoittolistaa"], "favorites.playlists_company_empty_title": "Suosikkisoittolistat", "favorites.playlists_company_second_empty_description": "Tämä yritys ei vielä jaa suosikkisoittolistojaan julkisesti", "favorites.playlists_public_profile_empty_description": "Tämä jäsen ei vielä jaa suosikkisoittolistojaan julkisesti", "favorites.playlists_public_profile_empty_title": "Suosikkisoittolistat", "favorites.videos_company_empty_description": [["companyName"], " ei ole vielä valinnut yhtään videota suosikkeihin"], "favorites.videos_company_empty_title": "Suosikkivideot", "favorites.videos_public_profile_empty_description": "Tämä jäsen ei tällä hetkellä jaa suosikkivideoitaan julkisesti", "favorites.videos_public_profile_empty_title": "Suosikkivideot", "featuredblgoposts.title": "Suositellut blogikirjoitukset", "feedback_modal.icons.awesome": "Pidän tästä uudesta versiosta erittäin paljon", "feedback_modal.icons.happy": "Pidän tästä uudesta versiosta", "feedback_modal.icons.hate": "En pidä tästä versiosta", "feedback_modal.icons.sad": "Kaipaa kehittämistä", "feedback_modal.question1": "Millainen oli käyttäjäkokemuksesi kokonaisuudessaan?", "feedback_modal.question2": "Onko sinulla kehitysehdotuksia?", "feedback_modal.question3": "Huomasin joitakin vikoja", "feedback_modal.title": "Kerro mitä mieltä olet", "footer.copyright": ["©YOGOBE ", ["year"], ". All rights reserved."], "footer.label2": "Sosiaalinen media", "footer.label3": "Palvelu", "footer.languages.english": "English", "footer.languages.finnish": "Suomi", "footer.languages.label": "Kieli", "footer.languages.norwegian": "Norsk", "footer.languages.swedish": "Svenska", "footer.links.community": "Yhteisö", "footer.links.discover": "Löydä", "footer.links.yogobe": "Yogobe", "forgot_password_modal.back": "Takaisin sisäänkirjautumiseen", "forgot_password_modal.email": "Sähköposti", "forgot_password_modal.paragraph": "Anna sähköpostiosoitteesi ja lähetämme sinulle viestillä ohjeet salasanan palauttamiseksi.", "forgot_password_modal.send_instructions": "Lähetä ohjeet", "forgot_password_modal.title": "Oletko unohtanut salasanasi?", "getstarted.breathe": "hengitysharjoituksia", "getstarted.meditation": "meditaatiota", "getstarted.move": "lihaskuntoharjoittelua", "getstarted.yoga": "joogaa", "global_menu.course.courses_trainings.desc": "Syvennä tietojasi terveydestä, joogasta ja harjoittelusta.", "global_menu.course.courses_trainings.title": "Kurssit ja harjoitukset", "global_menu.course.events.desc": "Osallistu meidän ja kumppaneidemme järjestämiin tapahtumiin.", "global_menu.course.events.title": "Tapahtumat", "global_menu.course.onlinekurser.desc": "Tutustu online-kursseihimme", "global_menu.course.onlinekurser.title": "Online-kurssit", "global_menu.course.title": "Kurssit", "global_menu.course.travel_retreats.desc": "Löydä ja nauti kohteista maailmanlaajuisesti.", "global_menu.course.travel_retreats.title": "Matkat & retriitit", "global_menu.live.title": "LIVE", "global_menu.more.about.desc": "Tutustu Yogobeen yrityksenä.", "global_menu.more.about.title": "Meistä", "global_menu.more.blog.desc": "Näkemyksiä, vinkkejä ja mielenkiintoista luettavaa.", "global_menu.more.blog.title": "Blogi", "global_menu.more.business.desc": "Tukea työnantajille ja organisaatioille", "global_menu.more.business.title": "Yritys", "global_menu.more.contact.desc": "Kerro meille terveisiä!", "global_menu.more.contact.title": "Ota yhteyttä", "global_menu.more.en_business.item1": "Yogobe business", "global_menu.more.en_business.item2": "Tunnit ja luennot", "global_menu.more.en_business.item3": "Joogaopettajille", "global_menu.more.friskvårdsbidrag.desc": "global_menu.more.friskvårdsbidrag.desc", "global_menu.more.friskvårdsbidrag.title": "global_menu.more.friskvårdsbidrag.title", "global_menu.more.healthcare.desc": "Ota selvää, miten Yogobe tulee terveydenhuoltoa", "global_menu.more.healthcare.title": "Terveydenhuolto", "global_menu.more.non_profit.desc": "Tutustu voittoa tavoittelemattomiin aloitteisiimme.", "global_menu.more.non_profit.title": "voittoa tavoittelematon", "global_menu.more.se_business.item1": "Työnantaja", "global_menu.more.se_business.item2": "global_menu.more.se_business.item2", "global_menu.more.se_business.item3": "Yogobe joogaopettajille", "global_menu.more.se_business.item4": "Hotelli ja konferenssi", "global_menu.more.se_business.item5": "Yhteistyökumppanit", "global_menu.more.se_healthcare.item1": "FaR - Fyysistä aktiivisuutta reseptillä", "global_menu.more.store.desc": "Osta joogamattoja, varusteita ja muuta.", "global_menu.more.store.title": "Kauppa", "global_menu.more.team.desc": "Tutustu asiantuntijoihimme.", "global_menu.more.team.title": "Team Yogobe", "global_menu.more.title": "Lisää", "global_menu.more_menu.banner.button": "Lue lisää", "global_menu.more_menu.banner.title": "Tiesitkö, että voit käyttää liikunta- ja hyvinvointietujasi Yogobessa?", "global_menu.play.playlists.desc": "Selaa laajaa soittolistakokoelmaamme.", "global_menu.play.playlists.title": "Soittolistat", "global_menu.play.programs.desc": "Inspiroidu ja saavuta tavoitteesi", "global_menu.play.programs.title": "Ohjelmat", "global_menu.play.title": "Toista", "global_menu.play.video_audio.desc": "Löydä 2100+ tuntia.", "global_menu.play.video_audio.title": "Video & ääni", "global_menu.play.yogobe_challenge.desc": "Osallistu haasteeseen ja säilytä motivaatiosi.", "global_menu.play.yogobe_challenge.title": "Yogobe Haaste", "global_menu.search.title": "Etsi", "global_menu.store.title": "Kauppa", "header.login": "Kirjaudu sisään", "header.try_free": "Kokeile ilmaiseksi", "healthcare.listing_page.hero.no_premium_disclaimer": "* Tarvitset pääsykoodin työnantajaltasi, hoitajaltasi tai Yogobe-kumppanilta päästäksesi tähän ohjelmaan", "healthcare.listing_page.hero.premium_disclaimer": "* Tarvitset pääsykoodin työnantajaltasi, hoitajaltasi tai Yogobe-kumppanilta päästäksesi tähän ohjelmaan", "healthcare.listing_page.meta.description": "Digitaalisen ennaltaehkäisyn ja terveydenhuollon ohjelmat", "healthcare.listing_page.meta.title": "Yogoben terveydenhuolto-ohjelmat", "healthcare.listings_page.explore_programs_btn": "Tutustu ohjelmiin", "healthcare.listings_page.faq_btn": "Usein kysytyt kysymykset", "healthcare.listings_page.hero_title": "Programs within digital health and prevention", "healthcare.listings_page.subtitle": "Autamme työnantajia, sairausvakuutusyhtiöitä ja omaishoitajia tukemaan työntekijöitä ja potilaita digitaalisilla työkaluilla henkisen ja fyysisen terveyden ja hyvinvoinnin alalla. Tutustu digitaalisen ehkäisyn ohjelmiimme.", "healthcare_listing.faq.item1.body": "Anyone who has been provided with a prescription or access code from a caregiver, employer or health insurance company. These programs are part of Yogobe Healthcare, a segment of Yogobe not included in Yogobe Play, our consumer subscription service.", "healthcare_listing.faq.item1.title": "Who can participate in a program?", "healthcare_listing.faq.item2.body": "After you have registered and gained access to a program, you have easy access to it via the Yogobe app under \"My library\" or at the top of your <0>dashboard</0> when you are logged in to <1>yogobe.com</1>", "healthcare_listing.faq.item2.title": "How will I get access to my program?", "healthcare_listing.faq.item3.body": "Of course! Both employers and insurance and healthcare companies can purchase Yogobe and our programs as well as digital interventions, as support and complement to existing efforts for the benefit of individuals, employees and patients. Email us at <0>business@yogobe.com</0> and we'll tell you more.", "healthcare_listing.faq.item3.title": "Can companies buy individual programs?", "healthcare_listing.faq.item4.body": "No. If you enter Yogobe Healthcare with an access code that you have received from a patient association, healthcare provider, employer or insurance company, you personally pay nothing to access the specific Yogobe program or material that you have been prescribed.", "healthcare_listing.faq.item4.title": "Do I have to pay?", "healthcare_listing.faq.item5.body": "If you have a FaR prescription that you would like to use on Yogobe, please send a copy (a photo is OK) of your FaR prescription to <0>info@yogobe.com</0>. You will then receive instructions on how to easily get started with Yogobe's FaR-specific content.", "healthcare_listing.faq.item5.title": "How do I use my FaR prescription at Yogobe?", "hero.get_started": "Aloita", "hero_thank_you.dashboard": "Yleiskatsaus", "hero_thank_you.gotoprogram": "Siirry ohjelmaan", "hero_thank_you.reset": "Haluatko vaihtaa ohjelmaa? <0>Paina tästä.</0>", "hero_thank_you.thanks": ["Kiitos ", ["firstName"], "!"], "hero_thank_you.you_are_in_program": ["Sinulla on nyt pääsy seuraavaan ohjelmaan: <0>", ["program"], "</0>."], "homepage.courses_section.explore_marketplace": "Tutustu>>>>>>> master>>>>>>> develop", "homepage.cta_section.pricing_btn": "Tilausvaihtoehdot", "homepage.features_section.get_app_btn": "Hanki sovellus", "homepage.hero_section.register_btn": "<<<<<<< HEAD", "homepage.hero_section.wellness_btn": "Wellnes grant", "homepage.mobile_section.app_store_btn": "App Store", "homepage.mobile_section.play_store_btn": "Play Store", "homepage.sections.register_btn": "Aloita", "instructor.title": "Lisää opettajasta", "karolinska.get_started.access_code.label": "Pääsykoodi", "karolinska.get_started.access_code.not_valid": "Pääsykoodi ei toimi", "karolinska.get_started.access_code.required": "Tarvitset pääsykoodin päästäksesi ohjelmaan.", "karolinska.get_started.access_code.requirement": "Tarvitset pääsykoodin päästäksesi ohjelmaan.", "karolinska.get_started.access_code.valid": "Pääsykoodi toimii!", "karolinska.get_started.activation_error": "Anteeksi, emme kyenneet aktivoimaan ohjelmaa sinulle, ota meihin yhteyttä info@yogobe.com", "karolinska.get_started.button.continue": "Jatka", "karolinska.get_started.button.login": "Kirjaudu sisään ja aloita ", "karolinska.get_started.button.register": "Luo 14 vuorokauden ilmainen kokeilujakso", "karolinska.get_started.button.start_program": "Aloita ohjelma", "karolinska.get_started.guest.welcome_message": "Tervetuloa stressiohjelmaan", "karolinska.get_started.option.have_account": "Olen jo jäsen", "karolinska.get_started.option.no_account": "Minulla ei ole jäsenyyttä", "karolinska.get_started.select_option": "Valitse sinulle sopiva vaihtoehto", "karolinska.get_started.terms.label": "Hyväksyn <0>käyttöehdot</0>", "karolinska.get_started.terms.required": "Hyväksy käyttöehdot jatkaaksesi.", "karolinska.get_started.user.welcome_message": ["Hei ", ["name"], ", tervetuloa stressiohjelmaan"], "karolinska.preview_cover.guest.button": "Liity ohjelmaan", "karolinska.preview_cover.guest.video_locked": "Jos sinulla on pääsykoodi ohjelmaan, klikkaa alapuolelta jatkaaksesi. ", "karolinska.preview_cover.user.video_locked": "Katsoit 60 sekunnin esittelyn. Näet koko videon kun edelliset viikot on suoritettu.", "landing_page.offer.best_value": "Best value", "landing_page.offer.blue_section.cta_text": "Kokeile ilmaiseksi 14 päivän ajan", "landing_page.offer.blue_section.list_item1": "2100 videota kaikkiin tarpeisiisi", "landing_page.offer.blue_section.list_item2": "Tallenna offlineen. Joogaa ja treenaa missä vain, milloin vain.", "landing_page.offer.blue_section.list_item3": "Rajoittamaton käyttöoikeus videokirjastoon, ohjelmiin ja haasteisiin", "landing_page.offer.blue_section.list_item4": "Luo, tallenna ja jaa soittolistoja", "landing_page.offer.blue_section.title": "Mitä saat liittyessäsi aktiiviseksi jäseneksi?", "landing_page.offer.first_section.cta_text": "Aloita 14 päivän kokeilujakso", "landing_page.offer.free_trial": "Kokeile ilmaiseksi 14 päivän ajan", "landing_page.offer.getstarted": "Get Started", "landing_page.offer.most_affordable": "Most Affordable", "landing_page.offer.playlists_section.title": "Löydä sopivia soittolistoja", "landing_page.offer.programs_section.title": "Aktiiviseen jäsenyyteen sisältyvät ohjelmat", "landing_page.offer.subscription_annually_billed": "laskutus vuosittain", "landing_page.offer.subscription_free_plan_label": "Rajoittamaton käyttöoikeus ilman maksutietojen syöttämistä", "landing_page.offer.subscription_free_price_label": "Ilmainen", "landing_page.offer.subscription_free_title": "Kokeile ilmaiseksi", "landing_page.offer.subscription_monthly_billed": "laskutus kuukausittain", "landing_page.offer.subscription_monthly_per": "/ kuukausi", "landing_page.offer.subscription_quarterly_billed": "laskutus neljännesvuosittain, päivittyy normaalihintaan automaattisesti kolmen kuukauden jälkeen", "landing_page.offer.subscription_quarterly_per": "/ vuosineljännes", "landing_page.offer.subscription_sub_title": "Aloita vuosijäsenyys ja saat 50 euron lahjakortin Yogirajin tuotteisiin.", "landing_page.offer.subscription_title": "Tule jäseneksi ja saat rajoittamattoman käyttöoikeuden videokirjastoon", "landing_page.offer.testomonials_section.title": "Mitä jäsenemme sanovat?", "landing_page.offer.videos_section.title": "Tarpeisiisi sopivia valikoituja videoita", "landingpage.hero.bullet1": "Tallenteita ja LIVE-tunteja", "landingpage.hero.bullet2": "Katso offline-tilassa sovelluksemme kautta ", "landingpage.hero.bullet3": "Maksuton kokeilujakso, peruuta koska vain", "landingpage.hero.cta": "14 päivän ilmainen kokeilu", "landingpage.hero.subtitle": "Muutama minuutti päivittäin tekee ihmeitä terveydellesi.", "landingpage.hero.title": "Joogaa, meditoi ja liiku verkossa", "landingpage.mobileapp_section.desc": "Lataa uusi sovelluksemme ja jaa palautteesi sen käytöstä.", "landingpage.mobileapp_section.title": "Lataa sovellus ja kokeile jo tänään!", "landingpage.section2.desc": "Toivotamme sinut tervetulleeksi harjoittelemaan joogaa, meditaatiota ja tutkimaan kotitreenejä markkinoiden johtavien opettajien, ohjaajien ja terapeuttien kanssa, joiden intohimona on terveys ja jotka elävät innostaakseen ihmisiä onnelliseen ja terveelliseen elämään. Yogobea on helppo käyttää milloin tahansa – missä tahansa. Luo tästä hyvä tapa ja pidä sitä yllä yhdessä kanssamme. Jäsenenä liityt myös mahtavaan yhteisöön. Tervetuloa tutustumaan palveluumme maksutta!", "landingpage.section2.link": "Tutustu 2000 videoon", "landingpage.section2.title": "Joogaa ja kotitreenejä sinulle", "landingpage.section2.trailer_tag": "Traileri", "landingpage.section4.item1.desc": "Tuemme työnantajia kaikkialla Pohjoismaissa tarjoamalla räätälöityjä terveysohjelmia, jotka vastaavat organisaation monenlaisiin yksilöllisiin terveystarpeisiin. Toimituksemme on ensisijaisesti digitaalinen, mutta järjestämme myös kursseja, tapahtumia, luentoja ja paljon muuta stressin, unen, keskittymisen ja kestävyyden parissa. Kaikkea ja kaikkea työterveyden, yhteisöllisyyden ja fyysisten ja/tai mielenterveysongelmien minimoimiseksi.", "landingpage.section4.item1.title": "Terveys yrityksissä", "landingpage.section4.item2.desc": " Antaako työnantajasi sinulle luontoisetuja? Tarkista heiltä, ​​kattavatko he kulut hyväksymällä kuittisi Yogobesta. Kaikkialla Skandinaviassa teemme yhteistyötä terveyshyötyyhtiö Benifyn kanssa. Ruotsissa muita kumppaneita ovat: Actiway, Wellnet ja Min Friskvård, joiden kautta Yogobe-tilisi on helppo päivittää.", "landingpage.section4.item2.title": "Liikuntaetu", "landingpage.section4.item3.desc": "Teemme yhteistyötä säätiöiden, yhdistysten ja järjestöjen kanssa tavoitteena tarjota tasapuolisesti jokaiselle työkaluja ja ohjausta kestävään henkiseen ja fyysiseen hyvinvointiin. Yhdessä voimme olla se muutos, jonka haluamme maailmassa nähdä!", "landingpage.section4.item3.title": "Yogobe Non-profit", "landingpage.section4.readmore": "LUE LISÄÄ", "landingpage.section5.title": "Lisää Yogobessa", "landingpage.section6.cta": "14 päivän maksuton kokeilujakso", "landingpage.section6.disclaimer": "Kokeilujakso ei muutu maksulliseksi tilaukseksi.", "landingpage.section6.subtitle": "Haluaisitko rajattoman pääsyn tunneille, soittolistoihin, ohjelmiin ja haasteisiin?", "landingpage.section6.title": "Yogobe jäsenyys", "landingpage.section7.title": "Mitä jäsenemme sanovat Yogobesta?", "landingpage.squareitems.alt_text.book_retreat": "Varaa seuraava retriitti tai rekisteröidy jooganopettajakoulutukseen Yogobessa", "landingpage.squareitems.alt_text.deepen_your_knowledge": "Syvennä osaamistasi – tutustu edullisiin verkkokursseihimme täältä.", "landingpage.squareitems.alt_text.getstarted": "Aloita Yogobe - joogaa ja treenaa verkossa.", "landingpage.squareitems.alt_text.live": "Koe reaaliaikaiset tuntimme verkossa Yogobe LIVEn kautta - katso aikataulu tästä!", "landingpage.squareitems.alt_text.news_yogobe": "Tutustu uusimpiin julkaisuihimme Yogobessa – videoita, soittolistoja ja ohljelmia joogasta, meditaatiosta, kuntoiluista ja rentoutumisesta.", "landingpage.squareitems.alt_text.program_card": "Liity online-ohjelmaamme ja tutustu mindfulness-meditaatioon Eleonora Ramsby Herreran kanssa.", "landingpage.squareitems.alt_text.wellness_grant": "Lue lisää liikuntaedun käyttämisestä Yogobessa", "landingpage.squareitems.alt_text.ybteam": "Tutustu Team Yogobeen – yli 90 joogan, meditaation, kuntoilun ja hengitysharjoittelun asiantuntijaa.", "landingpage.squareitems.challenge.text1": "Yogobe Challenge", "landingpage.squareitems.challenge.text2": "Ensimmäinen kuukausi", "landingpage.squareitems.challenge.text3": "EUR", "landingpage.squareitems.challenge.text4": "9.99", "landingpage.squareitems.challenge.text5": "5 ERILAISTA HAASTETTA", "landingpage.squareitems.get_started.text1": "Miten pääsen", "landingpage.squareitems.get_started.text2": "helposti alkuun", "landingpage.squareitems.get_started.text3": "Yogobessa?", "landingpage.squareitems.get_started.text4": "Vaiheittainen opas. Klikkaa tästä!", "landingpage.squareitems.live.text1": "LIVE", "landingpage.squareitems.live.text2": "Koe osallistumisen energia", "landingpage.squareitems.live.text3": "LIVE-online reaaliajassa", "landingpage.squareitems.live.text4": "Useita tunteja", "landingpage.squareitems.live.text5": "joka viikko", "landingpage.squareitems.marketplace.text1": "Haluatko varata", "landingpage.squareitems.marketplace.text2": "retriitin tai", "landingpage.squareitems.marketplace.text3": "kouluttaa itseäsi", "landingpage.squareitems.marketplace.text4": "joogaan?", "landingpage.squareitems.marketplace.text5": "Mene Yogobe Marketplaceen", "landingpage.squareitems.online_courses.text1": "Syvennä", "landingpage.squareitems.online_courses.text2": "tietoasi", "landingpage.squareitems.online_courses.text3": "Osallistu kuukauden ", "landingpage.squareitems.online_courses.text4": "alennushintaisille kursseille", "landingpage.squareitems.running_program.text1": "Joogaa aloittelijoille", "landingpage.squareitems.running_program.text2": "Ohjelma Satu Tuomelan kanssa", "landingpage.squareitems.team_yogobe.text1": "Tutustu", "landingpage.squareitems.team_yogobe.text2": "Team Yogobe", "landingpage.squareitems.team_yogobe.text3": "yli 70 asiantuntijan kanssa", "landingpage.squareitems.team_yogobe2.text1": "Uutiset", "landingpage.squareitems.wellness_grant.text1": "Miten voin", "landingpage.squareitems.wellness_grant.text2": "käyttää minun", "landingpage.squareitems.wellness_grant.text3": "hyvinvointiapurahaa", "landingpage.squareitems.wellness_grant.text4": "Yogobessa?", "landingpage.squareitems.wellness_grant.text5": "Lue siitä lisää täältä.", "landingpage.testimonials.item1.name": "Ann-Sofie Forsmark", "landingpage.testimonials.item1.quote": "\"Se on ylivoimaisesti paras tapa minulle ja lapsilleni harjoitella joogaa ja minun päästä SOMAan.\"", "landingpage.testimonials.item1.title": "Terveysstrategi", "landingpage.testimonials.item2.name": "Lori Wäne", "landingpage.testimonials.item2.quote": "\"On uskomattoman arvokasta päästä joogatunneille kotona niinä päivinä, kun minulla ei ole mahdollisuutta mennä studioon.\"", "landingpage.testimonials.item2.title": "Tuleva joogaopettaja", "landingpage.testimonials.item3.name": "Malin Magnusson", "landingpage.testimonials.item3.quote": "\"Minun silmissäni Yogobe on uskomattoman edullinen ja sen avulla voin tuoda terveysrutiinini kaikkialle.\"", "landingpage.testimonials.item3.title": "Äiti ja jokapaikanhöylä", "landingpage.testimonials.item4.name": "Anna Åhlgren", "landingpage.testimonials.item4.quote": " \"Saada inspiraatiota viisailta ja hauskoilta kollegoilta\"", "landingpage.testimonials.item4.title": "Joogaopettaja ja tarinankertoja", "live.event.levels.advanced": "Edistyneet", "live.event.levels.beginner": "Aloittelijat", "live.event.levels.everyone": "Kaikki", "live.event.levels.intermediate": "Aikaisemmin harjoitelleet", "live.event.levels.other": "Muu", "live.event_page.about_event": "Tapahtumasta", "live.event_page.all_event_link": "Kaikki tapahtumat", "live.event_page.banner_donation_class": "Denna LIVE-klass är till förmån för Världsnaturfonden WWF", "live.event_page.book_btn": "Varaa paikkasi", "live.event_page.booking_closed_banner": "Ilmoittautuminen tähän tapahtumaan on päättynyt.", "live.event_page.coming_soon": "Tulossa pian", "live.event_page.donation_class": "Donation class", "live.event_page.event_date_time": "Tapahtuman aika ja päivämäärä", "live.event_page.event_free": "Ilmainen", "live.event_page.event_instructors": "Asiantuntijat", "live.event_page.event_lang_label": "Tapahtuman kieli", "live.event_page.event_prerequisites": "Apuvälineet", "live.event_page.expired_event": "Toteutunut", "live.event_page.for_for_you": "Maksutta sinulle", "live.event_page.fully_booked_event": "Täynnä", "live.event_page.join_btn": "Liity nyt", "live.event_page.join_btn_reserved": "Olet varannut paikkasi", "live.event_page.no_prerequisites_required": "Tätä tapahtumaa varten et tarvitse apuvälineitä.", "live.event_page.prerequisites_yogobe_store": "Tarvitsetko apuvälineitä? <0>Vieraile Yogobe Storessa</0>", "live.event_page.recording_more_info": "Lisätietoa", "live.event_page.recording_more_info_tooltip": "Tallenne vanhenee noin 24 tunnin kuluttua siitä, kun Zoom on luonut sen. Kun tämä ajanjakso on kulunut, et voi enää katsoa tätä tallennettua LIVE-istuntoa.", "live.event_page.registration_end_label": "Viimeinen mahdollisuus ilmoittautua", "live.event_page.reserve_spot_banner.book_btn": "Varaa paikka", "live.event_page.reserve_spot_banner.browse_events": "Tutki muita tapahtumia", "live.event_page.reserve_spot_banner.desc": ["Varaa paikkasi tapahtumaan <0>", ["event_name"], "</0>, kun siellä on vielä tilaa. "], "live.event_page.reserve_spot_banner.event_date": ["Tapahtuman päivämäärä: ", ["date"]], "live.event_page.reserve_spot_banner.expired_desc": ["Ilmoittautuminen tapahtumaan <0>", ["event_name"], "</0> on nyt päättynyt. "], "live.event_page.reserve_spot_banner.last_registration_date": ["Ilmoittaudu viimeistään: ", ["endDate"]], "live.event_page.reserve_spot_banner.reserved_desc": ["Paikkasi tapahtumaan <0>", ["event_name"], "</0> on varattu."], "live.event_page.reserve_spot_banner.reserved_title": "Varaus vahvistettu!", "live.event_page.reserve_spot_banner.share_btn": "Jaa tapahtuma", "live.event_page.reserve_spot_banner.title": "Varaa paikkasi!", "live.event_page.reserved_spot.click_join": "Klikkaa osallistuaksesi", "live.event_page.reserved_spot.hosted_zoom": "Tämä tapahtuma toteutetaan Zoomissa", "live.event_page.reserved_spot.or_copy_link": "Tai kopioi ja liitä linkki selaimeesi", "live.event_page.reserved_spot.zoom_code_label": "Pääsykoodi", "live.event_page.spots_left": ["Vain ", ["spots"], " paikkaa jäljellä"], "live.event_page.sticky_banner.discount_available": "Saat 30% alennuksen, koska sinulla on voimassaoleva maksullinen jäsenyys.", "live.event_page.sticky_banner.free_for_you": "Tämä istunto sisältyy tilaukseesi ilman lisäkustannuksia,", "live.event_page.subscription_discount_text": "Ilmaiset LIVE-tunnit, kun päivität jäsenyytesi aktiiviseksi tilaukseksi tänään! <0> Katso tarjouksemme </0>", "live.event_page.view_all_instructor_events": ["<0>Näytä kaikki tapahtumat</0> ohjaajan ", ["name"], " kanssa"], "live.event_page.watch_session_recording": "Katso tallenne", "live.event_page.you_r_in_event": "Ilmoittautuminen valmis", "live.listings.live_codes_card.description": "Sinulla on yksi tai useampi käytettävissä oleva LIVE-koodi käytettäväksi joissakin premium-viikoittaisissa tunneissamme", "live.listings.live_codes_card.description2": "Toimi nyt, ennen kuin ne menevät vanhaksi!", "live.listings.live_codes_card.see_code_btn": "Näytä koodini", "live.listings.live_codes_card.title": "Todella hyvä tietää", "live.listings_page.banner.subscription_discount_text": "LIVE-tunnit sisältyvät tilauksiin JA saat 30 % alennuksen kaikista premium-LIVE-istunnoista. Valitse sinulle sopiva tilaustyyppi", "live.listings_page.clear_events_filters": "Tyhjennä suodattimet ja haku", "live.listings_page.disclaimer": "Jäsenet, joilla on aktiivinen maksullinen tilaus, saavat 30% alennuksen kaikista LIVE-tapahtumista.", "live.listings_page.explore_events_btn": "Tutki kalenteria", "live.listings_page.filter_applied_toaster": "Suodattimet lisätty", "live.listings_page.filters.donation_class": "Donation class", "live.listings_page.filters.free_event": "Maksuton tapahtuma", "live.listings_page.filters.instructors": "Kaikki ohjaajat", "live.listings_page.filters.kind_class": "Tunnit", "live.listings_page.filters.kind_label": "Kaikki tyypit", "live.listings_page.filters.kind_lecture": "Luennot", "live.listings_page.filters.kind_online_course": "Kurssi", "live.listings_page.filters.kind_skills": "Taidot", "live.listings_page.filters.kind_talk": "Keskustelut", "live.listings_page.filters.kind_workshop": "Työpajat", "live.listings_page.filters.languages": "Näytä tapahtumat", "live.listings_page.filters.sort_by_date": "Päivämäärä", "live.listings_page.filters.sort_by_price": "Hinta", "live.listings_page.filters.sort_label": "Jaottele", "live.listings_page.filters.sort_mobile_label": "Suodatin- & filtteriasetukset", "live.listings_page.filters.sort_modal_title": "Suodata", "live.listings_page.hero_title": "Yogobe LIVE", "live.listings_page.load_more_btn": "Näytä lisää", "live.listings_page.no_events_found": "Hups... Tällä haulla ei löytynyt tapahtumia. Kokeile muuttaa suodattimia tai hakusanoja.", "live.listings_page.pricing_section.title": "LIVE-tuntimme sisältyvät niille, joilla on aktiivinen tilaus!", "live.listings_page.search_input_placeholder": "Etsi LIVE-tapahtumia…", "live.listings_page.subtitle": "Koe LIVE-tapahtumaan osallistumisen energia. Harjoittele yhdessä Team Yogoben asiantuntijoiden kanssa ja valitse itsellesi mieluisia harjoituksia, työpajoja ja luentoja.", "live.live_page.metadata.desc": ["Tutustu LIVE-tapahtumaan ", ["eventName"], " ohjaajana ", ["instructor"], " - varaa paikkasi nyt tai selaa muita tapahtumia: yogobe.com/live"], "live.payment_page.access_code.not_valid": "Pääsykoodisi ei kelpaa", "live.payment_page.access_code.valid": "Pääsykoodisi on voimassa", "live.payment_page.action_button.activate": "Aktivoi", "live.payment_page.action_button.login": "Kirjaudu ja jatka", "live.payment_page.action_button.register": "Kirjaudu ja jatka", "live.payment_page.action_button.start_suscription": "Luo 14 päivän maksuton kokeilujakso", "live.payment_page.activate_email_banner": "Olemme erittäin iloisia, että haluat liittyä tähän LIVE-tapahtumaan. Ennen kuin voit varata sen, pyydämme sinua vahvistamaan sähköpostiosoitteesi sinulle lähettämämme sähköpostin kautta!", "live.payment_page.code_input.description": "Onko sinulla meiltä tai työnantajaltasi saatu koodi?", "live.payment_page.code_input.description_tooltip": "Jos olet saanut LIVE-alennus- tai pääsykoodin, syötä se tähän päästäksesi tälle LIVE-tunnille.", "live.payment_page.code_input.show_text": "Jos sinulle on alennus- tai pääsykoodi, <0>klikkaa tästä</0>", "live.payment_page.countdown_banner": ["Viimeistele varaus varmistaaksesi paikkasi. Aikaa jäljellä: <0>", ["min"], ":", ["sec"], " min</0>"], "live.payment_page.countdown_timeout_btn": "Takaisin tapahtumasivulle", "live.payment_page.countdown_timeout_desc": "Varausaika päättyi, sillä maksua ei suoritettu 10 minuutin kuluessa. Palaa takaisin tapahtumasivulle ja yritä uudelleen.", "live.payment_page.details": "Saat sähköpostitse vahvistusviestin, josta löytyy myös linkki tapahtumaan. Lisäksi lähetämme muistutusviestin 15 min ennen tapahtuman alkua.", "live.payment_page.discount_amount": "Alennus", "live.payment_page.discount_text": "Livetunnit sisältyvät tilauspaketteihimme. Saat myös 30 % alennuksen premium-LIVE-tapahtumista. Päivitä tilauksesi ja sinut ohjataan takaisin tälle sivulle automaattisesti. <0>View offers</0>", "live.payment_page.donation_class_details": "Detta är en donationsklass till förmån för WWF. Om du inte redan har donerat en gåva till kampanjen Yoga for Nature så skulle vi bli tacksamma om du vill göra det. <0> Läs mer och donera hos WWF här!</0> <1></1> <1></1> När du har bokat din plats så får du ett email där vi bekräftar din anmälan och delar praktisk information.", "live.payment_page.event_accesscode_activated.toast": "Live-tapahtuma on varattu onnistuneesti!", "live.payment_page.free_event_reserved.toast": "Live-tapahtuma on varattu onnistuneesti!", "live.payment_page.free_reserve_spot": "Varaa paikkasi", "live.payment_page.payment_amount": "Maksettavaa", "live.payment_page.payment_reserve_spot": "Jatka turvalliseen maksamiseen", "live.payment_page.summary_title": "Tilauksen yhteenveto", "live.payment_page.term_conditions": "Hyväksyn Yogoben <0>maksu- ja palautusehdot</0>", "live.payment_page.term_conditions_tooltip": "Yogobe LIVE:en liittyvät ehdot löydät käyttöehdoistamme kappaleen 4.10 alta. <0>Lue lisää</0>", "live.paymentfail.body": ["Jotain meni pieleen... maksusi summalla ", ["amount"], " € epäonnistui. Yritä uudelleen. Jos ongelmat jatkuvat, ota yhteyttä käyttötukeemme data@yogobe.com"], "live.paymentfail.btn": "Mene takaisin & yritä uudelleen", "live.paymentfail.orderdetails.body": ["Transaction ID: ", ["transaction"]], "live.paymentfail.title": "Maksu epäonnistui", "live.paymentsuccess.body": ["Kiitos, maksusi summalla ", ["amount"], " ", ["currency"], " on suoritettu. Automaattinen maksuvahvistus lähetetään osoitteeseen ", ["email"]], "live.paymentsuccess.btn": "Jatka", "live.paymentsuccess.orderdetails.body": ["Order ID: ", ["order"]], "live.paymentsuccess.title": "Maksu suoritettu onnistuneestil!", "login_modal.action.create": "Luo tili", "login_modal.action.forgot": "Unohditko salasanasi?", "login_modal.action.login": "Kirjaudu sisään", "login_modal.action.or_create": "Etkö ole vielä jäsen? <0>rekisteröidy</0>", "login_modal.action.social_label": "Tai kirjaudu sisään", "login_modal.errors.incorrect": "Virheellinen sähköposti tai salasana, kokeile uudestaan", "login_modal.errors.incorrect_socials": "Emme löydä Yogobe-jäsentä, joka olisi liitetty antamaasi sosiaaliseen tiliin. Jos olet uusi Yogobessa, jatka ja liity jäseneksi sosiaalisen tilin kautta, tai jos haluat mieluummin rekisteröityä käyttämällä sähköpostiosoitettasi ja henkilökohtaista salasanaa, se onnistuu myös. <br><br>Jos sinulla on jo tili ja haluat yhdistää sen johonkin sosiaaliseen tiliisi, ole kärsivällinen kanssamme. Tämä ei ole tällä hetkellä mahdollista. Sillä välin, ole hyvä ja kirjaudu sisään kuten ennenkin, käyttämällä sähköpostia ja salasanaa.", "login_modal.helper": "Kirjaudu sisään ja pääset tutkimaan videokirjaston sisältöä, kasvavaa kurssitarjontaamme sekä omaa profiiliasi", "login_modal.inputplaceholder.email": "Sähköposti", "login_modal.inputplaceholder.password": "Salasana", "login_modal.title": "Kirjaudu sisään", "login_page.landing.headline": "Olemme iloisia saadessamme sinut jäseneksemme!", "login_page.landing.subtitle": "Kirjaudu sisään ja anna meidän innostaa, motivoida ja ohjata sinua kestävämpään mielenterveyteen ja hyvinvointiin", "maintenae_page.role": "Perustaja ja toimitusjohtaja", "maintenance_page.body": "05:00 ja 06:00 välillä tänään teemme päivityksiä ohjelmistoon! <br /> Me olemme innoissamme kaikista uusista hyvistä jutuista, joita tapahtuu Yogoben teknisellä puolella juuri nyt ja pyydämme sinulta kärsivällisyyttä. Nyt kun et pääse käsiksi videokirjastoomme, haluaisimme suositella tuokiota taianomaisen Alan Fingerin kanssa, missä aiheena on stressi ja miten jooga ja meditaatio voivat auttaa meitä selviytymään siitä. <a href=\"https://www.facebook.com/YOGOBEcom/videos/420176531509273/\">Löydä se Yogoben Facebook-sivulta.</a> <br /> Kaikkea hyvää,", "maintenance_page.title": "Midnight updates", "menu_add_playlist.add": "Lisää soittolistaan", "menu_add_playlist.create": "Luo uusi soittolista", "menu_more.schedule": "Aikataulu", "menu_more.share": "Jaa", "menu_more.share_page": "Jaa", "message1.spring_challenge.end": "The Spring Challenge on takana. Jos sinulla on jo pääsy ohjelmaan, pääset sisään aloitussivun kautta.", "message1.summer_challenge2020.end": "The Summer Challenge on takana. Jos sinulla on jo pääsy ohjelmaan, pääset sisään aloitussivun kautta.", "message1.winter_challenge.end": "The Winter Challenge on takana. Jos sinulla on jo pääsy ohjelmaan, pääset sisään aloitussivun kautta.", "message2.spring_challenge.end": "Haluatko ottaa uuden haasteen vastaan?", "message2.winter_challenge.end": "Haluatko ottaa uuden haasteen vastaan?", "meta.follow": "Seuraa", "metadata.accessUntil": "Käyttöoikeus päättyy", "metadata.active": "aktiivinen", "metadata.all": "Kaikki", "metadata.and": "ja", "metadata.apply": "Aktivoi", "metadata.back_to_dashboard": "Takaisin yleiskatsaukseen", "metadata.bodyparts": "Kehonosat", "metadata.bonus": "Bonus", "metadata.browse_all": "Näytä kaikki", "metadata.challenge": "Challenge", "metadata.choose_file": "Valitse tiedosto", "metadata.clear_all": "Poista kaikki", "metadata.close": "SULJE", "metadata.code_activation.failed": "Pahoittelut, koodin aktivoinnissa tapahtui virhe. Olethan yhteydessä meihin, jotta voimme auttaa sinua! <0>Ota yhteyttä Yogobeen</0>", "metadata.company_empty_playlists": "Ei julkisia soittolistoja", "metadata.course": "Kurssi", "metadata.courseLabel": "Kurssi", "metadata.course_by": "Kurssi opettajalta", "metadata.created_by": "Luonut", "metadata.days.label": "Päivää", "metadata.delete": "Poista", "metadata.delete_playlist": "Poista soittolista", "metadata.document": "Dokumentti", "metadata.download": "Lataa", "metadata.downloadPDF": "Yleiskatsaus kurssiin", "metadata.download_all": "Lataa kaikki", "metadata.duration": "Kesto", "metadata.edit_playlist": "Muokkaa soittolistaa", "metadata.edit_profile": "Muokkaa Profiilia", "metadata.edite_privacy_settings": "Muokkaa yksityisyysasetuksia", "metadata.empty_playlists": "Et ole vielä luonut omia soittolistoja", "metadata.empty_playlists_action": "Selaa Yogoben luomia soittolistoja", "metadata.english": "englanti", "metadata.exercise": "Harjoitus", "metadata.expire_on": ["Tämä kurssi päättyy ", ["expirationDate"]], "metadata.expired_on": ["Tämä kurssi päättyi ", ["expirationDate"]], "metadata.frequently_asked_questions.title": "Usein kysyttyjä kysymyksiä", "metadata.getStarted": "Aloita", "metadata.go_back_simple": "Takaisin", "metadata.introduction": "Esittely", "metadata.lecture": "Luento", "metadata.load-more": "Näytä lisää", "metadata.login": "Kirjaudu sisään", "metadata.min": "min", "metadata.minuter": "minuuteissa", "metadata.more": "näytä enemmän", "metadata.more_items": ["& ", ["number"], " lisää"], "metadata.my_stats": "Näytä tilastoni", "metadata.needs": "Tarpeeni", "metadata.new": "Uutuus", "metadata.next": "Seuraava", "metadata.only_you_can_see_this": "Vain sinä voit nähdä tämän", "metadata.payment.failed": "Valitettavasti emme voineet suorittaa maksua loppuun antamillasi maksutiedoilla.Yritä uudelleen. Jos ongelma jatkuu, ole meihin yhteydessä <0></0>", "metadata.payment.success.continue_button": "Jatka", "metadata.payment.success.receipt_button": "Näytä kuitti", "metadata.payment.success.title": "Maksu suoritettu", "metadata.paymentfail.btn": "Mene takaisin & yritä uudelleen", "metadata.paymentfail.title": "Maksu epäonnistui", "metadata.playlists": "Soittolistat", "metadata.playlists_public_profile_empty_description": "Tämä jäsen ei tällä hetkellä jaa soittolistojaan julkisesti", "metadata.please_wait": "Pieni hetki...", "metadata.premium": "Premium", "metadata.preview": "Esikatselu", "metadata.profile_private": "Julkinen profiili", "metadata.program": "Ohjelma", "metadata.programLabel": "Ohjelma", "metadata.program_by": "Ohjelma opettajalta", "metadata.programs.my_progress": "Edistymiseni", "metadata.programs.overview": "Yleiskatsaus", "metadata.progressPercentage": [["percentage"], "% Saavutettu"], "metadata.public_profile_empty_playlists": "Ei julkisia soittolistoja", "metadata.question": "Kysymys", "metadata.read_more": "Lue lisää", "metadata.read_more_about": "Lue lisää aiheesta", "metadata.recently_viewed_videos": "Viimeksi katsotut videot", "metadata.recommended_courses_programs_title": "Hanki itsellesi pääsy Yogoben ohjelmiin", "metadata.recommended_playlists_title": "Suositellut soittolistat", "metadata.recommended_videos_title": "Suositellut videot", "metadata.remove_from_playlist": "Poista soittolistalta", "metadata.resume": "Jatka", "metadata.save": "Tallenna", "metadata.save_favorites": "Tallenna suosikkeihin ", "metadata.save_more_than_per_year": ["Säästä enemmän kuin ", ["amount"], " € vuodessa"], "metadata.saved_favorites": "Tallenna suosikkeihin ", "metadata.search": "Etsi videokirjastosta", "metadata.search_library": "Etsi Yogoben sivuilta", "metadata.show_less": "Näytä vähemmän", "metadata.show_more": "Näytä enemmän", "metadata.signup": "Liity jäseneksi", "metadata.skills": "Taidot", "metadata.statistics": ["Katsoit viime viikolla ", ["sessionsLastWeek"], " videota"], "metadata.statistics_title": "Tilastot", "metadata.styles": "Tyylit", "metadata.survey": "Kysely", "metadata.swedish": "ruotsi", "metadata.tags": "Merkinnät", "metadata.talk": "Keskustelu", "metadata.textElement": "Teksti", "metadata.this_profile_is_private": "Tämä profiili on yksityinen", "metadata.this_profile_is_private_title": "Yksityinen profiili", "metadata.upgrade": "Päivitä", "metadata.videos": "Videot", "metadata.view_all": "Näytä kaikki", "metadata.visitor": "vierailija", "metadata.weeks.label": "Viikkoa", "metadata.with": "kanssa", "metadata.workshop": "Workshop", "metadeta.programs.other_programs": "Kaikki ohjelmat", "metatadata.errors.unexpectedError": "Jokin meni pieleen. Yritä uudelleen tai ota meihin yhteyttä data@yogobe.com", "modals.publicplaylist.button1": "Kyllä, luo profiili", "modals.publicplaylist.button2": "Ei, haluan pitää profiilini yksityisenä", "modals.publicplaylist.helper": "Haluat tehdä soittolistastasi julkisen ja jakaa sen ystäviesi ja muun yhteisön kanssa. Jotta se on mahdollista tarvitset julkisen profiilin, jolloin seuraavat tiedot tulevat näkyviksi:", "modals.publicplaylist.option1": "Profiilikuvasi", "modals.publicplaylist.option2": "Etu- ja sukunimi", "modals.publicplaylist.option3": "Profiilikuvauksesi", "modals.publicplaylist.title": "Julkiset soittolistasi", "my_playlists.title": "Soittolistani", "new_subscription_modal.bank_transfer": "Pankkisiirto", "new_subscription_modal.debit_credit_card": "Pankki- / Luottokortti", "new_subscription_modal.description": "Jäsenyytemme ovat jatkuvia, ilman sitoutumisaikaa ja peruutettavissa koska vain.", "new_subscription_modal.helper_bank": "Haluan maksaa jäsenyyteni pankkisiirrolla suoraan pankkitililtäni.", "new_subscription_modal.select_option": "Valitse vaihtoehto, joka sopii sinulle parhaiten", "new_subscription_modal.title": "Päivitä jäsenyytesi", "new_subscription_modal.warning_finland_cc": "Tämä ominaisuus ei ole vielä käytössä Suomessa.", "onboarding.back.btn_text": "Takaisin", "onboarding.banner.missed_onboarding": "Kutsumme sinua valitsemaan yhden sisäänkirjautumisen ominaisuuden, se auttaa meitä ymmärtämään tarpeesi!", "onboarding.completed.explore_store.desc": "Selaa kauppaamme ja saa -10% ensimmäisestä tilauksestasi käyttämällä koodia: MY10OFF", "onboarding.completed.explore_store.title": "Valmistaudu", "onboarding.completed.my_favorites.desc": "Hae videot jotka valitsimme sinulle mieltymystesi perusteella", "onboarding.completed.my_favorites.title": "Suosikkini", "onboarding.completed.programs.desc": "Löydä tarpeisiisi soveltuvia eri ohjelmia ja kursseja", "onboarding.completed.programs.title": "Ohjelmat ja kurssit", "onboarding.completed.video_library.desc": "Selaa 1400+ videota eri aiheista: jooga, meditaatio, hengittäminen and liike", "onboarding.completed.video_library.title": "Videokirjasto", "onboarding.continue.btn_text": "Jatka", "onboarding.description.edit_text": "Täällä voit muokata mieltymyksiäsii koska vain. Päivitämme sen mukaan automaattisesti sinulle suositeltua sisältöä.", "onboarding.description.text": "Auta meitä luomaan sinulle sopivaa sisältöä kertomalla toiveistasi ja tarpeistasi! ", "onboarding.finish.btn_text": "Valmis", "onboarding.meta_title": "Aloita askel askeleelta", "onboarding.missing_lang.interests": "Tämä osio on englanniksi. Suomalainen sisältö on työn alla.", "onboarding.missing_lang.topics": "Jotta pääset alkuun, olemme luoneet sinulle tämän osion, jossa suosittelemme videosisältöä sinulle. Nyt suositukset ovat englanniksi. Suomalainen sisältö on työn alla.", "onboarding.select.choices": "Voit valita kolme kohtaa ", "onboarding.select_interests.text": "Olen kiinnostunut...", "onboarding.select_topics.text": "Haluaisin...", "onboarding.skip.btn_text": "Ohita", "onboarding.welcome.text": ["Tervetuloa, ", ["name"]], "opengraph.companyFavorites_title": "Suosikit", "opengraph.companyOverview_title": "Yleiskatsaus", "opengraph.companyPlaylists_title": "Soittolistat", "opengraph.dashboard_title": "Yleiskatsaus", "opengraph.mefavorites_title": "Suosikkini", "opengraph.myplaylists_title": "Soittolistani", "opengraph.password_recovery_title": "Palauta salasana", "opengraph.playlists_collections_title": "Yogobe Soittolistakokoelmat", "opengraph.playlists_title": "Yogobe Soittolistat", "opengraph.profilePlaylists_title": "Soittolistani", "opengraph.profilefavorites_title": "Profiilisuosikit", "opengraph.profilestats_title": "Tilastoni", "opengraph.programs_title": "4-12 viikon ohjelmat kaikille jäsenille", "opengraph.settings_title": "Asetukseni", "opengraph.stats_title": "Tilastoni", "opengraph.videos_description": "Joogaa, meditoi, hengitä ja treenaa verkossa yhdessä meidän kanssamme", "opengraph.videos_genres_title": "Yogobe Videokirjasto", "opengraph.videos_title": "Yogobe Videokirjasto", "ourprograms.title": "Tutustu ohjelmiimme", "pages.company_favorite.title": "Suosikit", "pages.favorite.title": "Suosikkini", "pages.favorite_public_title": "Suosikit", "pages.playlist_public_title": "Soittolistat", "pausa-smart.all-categories": "Kaikki kategoriat", "pausa-smart.already-in-program": "Olet jo tässä ohjelmassa", "pausa-smart.browse-all-videos": "Näytä kaikki videot", "pausa-smart.download-pdf": "Lataa", "pausa-smart.employee-access-code": "Olen työntekijä ja minulla on pääsykoodi", "pausa-smart.form-access-code.already-used": "Käyttäjätunnus on jo käytössä", "pausa-smart.form-comment": "Kommentti", "pausa-smart.form-company-name": "Yrityksen nimi", "pausa-smart.form-email": "Sähköposti", "pausa-smart.form-full-name": "Koko nimi", "pausa-smart.form-rules.accessCode.required": "Tarvitset pääsykoodin ", "pausa-smart.form-rules.comment.max": "Kommentti voi sisältää vain 200 merkkiä. ", "pausa-smart.form-rules.companyName.required": "Yrityksen nimi on pakollinen ", "pausa-smart.form-rules.email.required": "Sähköposti on pakollinen", "pausa-smart.form-rules.email.valid": "Anna toimiva sähköpostiosoite ", "pausa-smart.form-rules.fullName.required": "Koko nimi on pakollinen", "pausa-smart.form-submit": "Lähetä", "pausa-smart.form-title": "Haluatko kokeilla 14 päivää ilmaiseksi?", "pausa-smart.form.success-existing": ["Sinulla on nyt pääsy Pausa Smart -ohjelmaan ", ["days"], " päivän ajan. Löydät ohjelman yleiskatsaussivultasi. Vahvistusviesti on lähetetty osoitteeseen ", ["email"], "."], "pausa-smart.form.success-interest": ["Kiitos ", ["firstname"], " kiinnostuksestasi Pausa Smartia kohtaan. Olemme sinuun yhteydessä sähköpostitse mahdollisimman pian ja selvitämme miten voisimme vastata yrityksenne tarpeisiin parhaalla mahdollisella tavalla."], "pausa-smart.form.success-new": ["Kiitos! Vahvistusviesti on lähetetty osoitteeseen ", ["email"], ". Klikkaa sähköpostin linkkiä ja luo tili, jonka avulla pääset aktivoimaan Pausa Smart -jäsenyyden. Jos sinulla on jo tili Yogobessa, pyydä työnantajaltasi uusi koodi ja aloita alusta. Kirjaudu uudelleen tiliisi liitetyllä sähköpostiosoitteella, jolloin kaikki ohjelmasi löytyvät saman profiilin alta. Tervetuloa!"], "pausa-smart.form_access_code": "Pääsykoodi", "pausa-smart.get-started": "Pääse alkuun", "pausa-smart.go-to-program": "Mene ohjelmaan", "pausa-smart.interviews-testimonials-title": "Ilmaisia kokeiluvideoita", "pausa-smart.organization": "Edustan yritystä/organisaatiota", "pausa-smart.read-less": "Sulje", "pausa-smart.read-more": "Lue lisää", "pausa-smart.testimonials-title": "Käyttökokemuksia jäseniltämme", "pausa-smart.title": "Pausa Smart", "pausa-smart.videos-in-total": ["Näyttää yhteensä ", ["n"], " videota"], "pausa-smart.videos.languagues.all": "Kaikki kielet", "pausa-smart.videos.languagues.english": "Englanti", "pausa-smart.videos.languagues.swedish": "Ruotsi", "pausasmart.form.no_account.title": "Kirjaudu sisään tai rekisteröidy, jotta voit käyttää koodisi", "pausasmart.get_started.access_code.desc": "Tämä koodi on yleensä yrityksesi tai organisaatiosi tarjoama", "pausasmart.get_started.access_code.dont_have": "Minulla ei ole pääsykoodia", "pausasmart.get_started.access_code.have": "Olen saanut koodin työnantajaltani", "pausasmart.get_started.access_code.label": "Pääsykoodi", "pausasmart.get_started.access_code.not_valid": "Olemme pahoillamme, tämä koodi ei näytä toimivan", "pausasmart.get_started.access_code.valid": "Olet nyt saanut käyttöoikeuden Pausa Smart -haasteeseen", "pausasmart.get_started.account.dont_have": "Haluan luoda tilin", "pausasmart.get_started.account.have": "Minulla on jo tili", "pausasmart.get_started.button.continue": "Jatka", "pausasmart.get_started.button.continue_plan": "Jatka kuukausijäsenyydellä", "pausasmart.get_started.button.continue_trial": "Jatka 14 päivän ilmaisjaksolla", "pausasmart.get_started.button.login": "Kirjaudu sisään", "pausasmart.get_started.button.upgrade_continue": "Päivitä ja jatka", "pausasmart.get_started.dont_have_code.hovertip": "Voidaksesi katsoa tai kuunnella rajoittamattomasti audio- tai videosisältöämme sekä saada käyttöösi ohjelmat, soittolistat ja haasteet, tilisi tulee päivittää tai jos sinulla on yhä jäljellä aikaa ilmaisella kokeilujaksolla. Niin kauan, kuin jäsenyytesi on voimassa, sinulla on rajoittamaton pääsy sisältöön, kuten tähän ohjelmaan. Jos työnantajasi on antanut sinulle pääsyn tähän ohjelmaan, pääsykoodin lisäämällä saat 90 vuorokauden käyttöoikeuden tähän tiettyyn sisältöön ja löydät sen helposti profiilistasi. ", "pausasmart.get_started.dont_have_code.text": "Tämä ohjelma kuuluu premiumtilaukseemme. Jos sinulla ei vielä ole jäsenyyttä, rekisteröidy saadaksesi 14 vuorokauden ilmainen kokeilujakso. Voit myös päivittää maksavaksi asiakkaaksi ja saada rajattoman pääsyn kaikkiin videoihin, soittolistoihin, ohjelmiin ja haasteisiin Yogobessa. <0>Lue lisää</0>", "pausasmart.get_started.have_premium.text": "Tämä ohjelma kuuluu premium jäsenyyteen. ", "pausasmart.get_started.program_activation_failed": "Jokin on pielessä. Yritä uudelleen tai <0>ota yhteys käyttötukeen</0>", "pausasmart.get_started.purchase_banner_back": "Takaisin", "pausasmart.get_started.purchase_banner_text": "Jos edustat yritystä ja haluat tarjota henkilöstöllesi käyttöoikeuden, <0>klikkaa tästä</0>", "pausasmart.get_started.subtitle": "Valitse vaihtoehto, joka sopii sinulle parhaiten:", "pausasmart.get_started.title": ["Hei ", ["name"], ", tervetuloa Pausa Smart -haasteeseen"], "pausasmart.purchase.contact": "Ota yhteyttä <0>business@yogobe.com</0>", "pausasmart.purchase.desc": "Hienoa että sinä ja yrityksesi olette kiinnostuneet Pausa Smart -haasteesta. Tämä haaste on luotu vastaamaan yritysasiakkaimme toiveita ja tarpeita. Se on digitaalinen hyvinvoinnin työkalu, kotona työskentelyyn ja inspiroimaan meditaatioharjoituksen ylläpitoon arjessa. Lunastaessasi tämän haasteen kaikki työntekijäsi, jäsenesi tai kumppanisi saavat pääsyn hintaan 5000 SEK. Sillä ei ole väliä, kuuluuko tiimiisi 100 tai 10 000 työntekijää. Tervetuloa mukaan ainutkertaiseen tarjoukseen, joka on suunniteltu koronan aiheuttamien muutosten keskelle. Ota yhteyttä meihin sähköpostitse aloittaaksesi!", "pausasmart.purchase.title": "Hei, tervetuloa Pausa Smart -haasteeseen!", "payment.modal.banktransfer.info": "Yogobe tekee yhteistyötä Trustlyn kanssa, jotta voit turvallisesti maksaa jäsenyytesi suoraan pankkitililtäsi. Helppo tapa maksaa, uusia ja peruuttaa tilauksesi ilman sitoutumisaikaa.", "payment.modal.cardpayment.info": "Yogobe tekee yhteistyötä maksupalvelun Nets/DIBS kanssa, jotta voit maksaa jäsenyytesi VISA:lla tai Mastercardilla.  Helppo tapa maksaa, uusia ja peruuttaa tilauksesi ilman sitoutumisaikaa", "payment_modal.banner.active_subscription_upgrade": "Olemme iloisia, että haluat jatkaa tilaustasi. Nykyiset käyttöpäiväsi lisätään automaattisesti ensimmäisen maksujaksosi päälle.", "payment_modal.banner.inactive_subscription_upgrade": " Olemme iloisia, että haluat päivittää jäsenyytesi aktiiviseksi tilaukseksi, joka antaa sinulle rajoittamattoman pääsyn kirjastoon, soittolistoihin, ohjelmiin ja haasteisiin. Voit uusia jäsenyytesi tai peruuttaa sen milloin tahansa.", "payment_modal.banner.subscription_upgrade": "Ihanaa, että haluat päivittää jäsenyytesi! Nykyinen käyttöaikasi lisätään tilaukseen automaattisesti.", "payment_modal.banner.trial_upgrade": "Olet tervetullut päivittämään ilmaisen kokeilujaksosi aktiiviseksi Yogoben tilaukseksi. Nykyinen käyttöaikasi lisätään automaattisesti ensimmäiseen maksujaksoosi.", "payment_modal.banner.unverified_trial_upgrade": "Olet erittäin tervetullut päivittämään jäsenyytesi aktiiviseksi Yogoben tilaukseksi. Lisäksi: kun olet vahvistanut tilisi lähettämällämme sähköpostilla, ilmainen kokeilujakso, johon kirjauduit, lisätään käyttöaikaasi ja se pidentää tilausjaksoasi automaattisesti.", "payment_modal.error": "Ihanaa, että haluat Yogoben maksavaksi asiakkaaksi! Sillä aikaa kun päivitämme maksutoimintoja videokirjasto on ilmainen sinulle ja kaikille jäsenille. Kaikki on valmista keskiviikon aikana. Tervetuloa takaisin sen jälkeen, premium jäsenenä!", "payment_modal.payment_method.card.label": "Maksa kortilla.", "payment_modal.payment_method.trustly.submit_button": "Jatka verkkopankkimaksuun", "paymentconfirmation.btn1": "Sulje", "paymentconfirmation.btn2": "Näytä kuitit", "paymentconfirmation_subscription.modal.body": ["Maksusi, jonka summa on ", ["paymentAmount"], ", on hyväksytty. Vahvistamme, että tilisi on päivitetty jatkuvaan ", ["subscriptionType"], "tilaukseen. Se uusitaan automaattisesti ", ["recurringDate"], " hintaan ", ["recurringPaymentAmount"], "."], "paymentconfirmation_subscription.modal.title": "Maksuvahvistus", "paymentverification_modal.body": "Jotta voimme vahvistaa pankki-/luottokortin ja saattaa jäsenmaksun loppuun, käyttämämme palveluntarjoaja NETS tekee 1SEK arvoisen varausvahvistuksen. Korttimaksut turvataan tämän käytännön avulla.", "phasedProgram.introduction.label": "Esittely", "phasedProgram.moodtracker.post.description": "Kuinka voit juuri nyt? Pysähdy hetkeksi itsesi äärelle ja kuulostele omaa olotilaa täyttämällä tämä lyhyt mood-tracker.", "phasedProgram.moodtracker.post.start_button": "Siirry eteenpäin", "phasedProgram.moodtracker.post.title": "Kuinka voit nyt?", "phasedProgram.moodtracker.pre.description": "Ota hetki aikaa itsellesi ja tarkista miten voit kokeilemalla tätä nopeaa mood-trackeria. Se vie vain muutaman syvän hengityksen verran ajastasi.", "phasedProgram.moodtracker.pre.start_button": "Jatka", "phasedProgram.moodtracker.pre.title": "Kuinka voit?", "phasedProgram.moodtracker_modal.post.description": "Kuinka voit juuri nyt? Pysähdy hetkeksi itsesi äärelle ja kuulostele omaa olotilaa täyttämällä tämä lyhyt mood-tracker.", "phasedProgram.moodtracker_modal.post.title": "Kuinka voit nyt?", "phasedProgram.moodtracker_modal.pre.description": "Ota hetki aikaa itsellesi ja tarkista miten voit kokeilemalla tätä nopeaa mood-trackeria. Se vie vain muutaman syvän hengityksen verran ajastasi.", "phasedProgram.moodtracker_modal.pre.title": "Kuinka voit?", "phasedProgram.moodtracker_modal.submit_button": "Tallenna ja sulje", "phasedProgram.outro.videos_count": [["videosCount"], " videota - ", ["duration"]], "phasedProgram.phase.number": ["Vaihe ", ["number"]], "phasedProgram.phase.number_weekRange": ["Vaihe ", ["phaseNumber"], ": viikko ", ["weekRange"]], "phasedProgram.phase.videos_duration": [["videosCount"], " videota - ", ["duration"]], "phasedProgram.phase.weekRange": ["Viikko ", ["weekRange"]], "phasedProgram.phase_progress.text": "Edistyminen näyttää miten monta videota olet tällä viikolla suorittanut.", "phasedProgram.postsurvey.requirement_notification": "Loppukysely on avattu. <0>Klikkaa tästä</0> vastataksesi siihen.", "phasedProgram.presurvey.requirement_notification": "Avataksesi seuraavat videot ja aloittaaksesi ohjelman, täytä aloituskysely vaiheessa 1 tai <0>klikkaa tästä</0> suoraan kyselyyn.", "phasedProgram.survey.post.description": "Tämän kyselyn täyttäminen vie 10-15 minuuttia. Näe se mahdollisuutena tutustua itseesi paremmin. Yritä olla rehellinen itsellesi, yhteenkään kysymykseen ei ole oikeaa tai väärää vastausta. Vastauksesi tulee olemaan erittäin tärkeä osa tätä tutkimusta!", "phasedProgram.survey.post.start_button": "Siirry eteenpäin", "phasedProgram.survey.post.title": "Jälkikartoitus", "phasedProgram.survey.pre.description": "Tämän kyselyn täyttäminen vie 10-15 minuuttia. Näe se mahdollisuutena tutustua itseesi paremmin. Yritä olla rehellinen itsellesi, yhteenkään kysymykseen ei ole oikeaa tai väärää vastausta. Vastauksesi tulee olemaan erittäin tärkeä osa tätä tutkimusta!  Voidaksesi osallistua tutkimukseen, sinun tulee täyttää seuraavat kriteerit: (1) Olet yli 18-vuotias; (2) Sinulla ei ole kliinistä diagnoosia liittyen masennukseen, ahdistuneisuuteen tai stressiin; (3) Et ole tällä hetkellä psykologisessa tai psykiatrisessa hoidossa tai käytä lääkkeitä diagnosoidun mielisairauden hoitoon; (4) Sinulla ei ole laajaa aikaisempaa kokemusta joogasta/meditaatiosta/mindfulnessista; (5) Sinulla on aikaa ja mahdollisuuksia sitoutua viikoittaisiin luentoihin ja päivittäisiin meditaatioharjoituksiin; (6) Sinulla on päivittäin mahdollisuus käyttää internetiä ja omaa tietokonetta.", "phasedProgram.survey.pre.start_button": "Jatka", "phasedProgram.survey.pre.title": "Alkukartoitus", "phasedProgram.week.number": ["Viikko ", ["number"]], "playlist.created_by": "Luonut", "playlist.empty_plalist": "Tämä soittolista on vielä tyhjä", "playlist.playlist_deleted": "Soittolista poistettu", "playlist.playlist_title": "Soittolista", "playlists.browse_by_categories": "Selaa soittolistoja kategorioittain", "playlists.browse_category": "Kategoriat", "playlists.empty_description": "Et ole vielä luonut ensimmäistä soittolistaasi", "playlists.get_started": "Suositellut soittolistat", "playlists.title": "Soittolistani", "playlists.view_my_playlist": "Näytä soittolistani", "playlistscollectionsubheadersection.title": "Soittolistakokoelmat", "position.other_yoga_positions": "Muita jooga-asentoja", "position.other_yoga_styles": "Muut joogatyylit", "premium_banner_card.get_started": "Aloita", "pricing.monthly": "Kuukausitilaus", "pricing.option1": "Videot, soittolistat ja ohjelmat", "pricing.option2": "Helppokäyttöinen ja joustava", "pricing.option3": "Ei sitoutumisaikaa", "pricing.option4": "Käytä työnantajan tarjoama hyvinvointietu", "pricing.quarterly": "Neljännesvuositilaus", "pricing.yearly": "Vuositilaus", "pricing_section.bullets.option1": "Videot, soittolistat ja ohjelmat", "pricing_section.bullets.option2": "Helppokäyttöinen ja joustava", "pricing_section.bullets.option3": "Ei sitoutumisaikaa", "pricing_section.bullets.option4": "Käytä työnantajan tarjoama hyvinvointietu", "pricing_section.plan.annually.body": "Maksa kerran vuodessa. Vastaa 16.99€/kk. Säästä 40€", "pricing_section.plan.annually.label": "12 kuukautta", "pricing_section.plan.annually.title": "Vuositilaus", "pricing_section.plan.best_value": "Paras hinta", "pricing_section.plan.button_text": "Aktivoi", "pricing_section.plan.monthly.body": "19.99€ laskutetaan kerran kuukaudessa", "pricing_section.plan.monthly.label": "1 kuukausi", "pricing_section.plan.monthly.title": "Kuukausitilaus", "pricing_section.plan.quarterly.body": "Maksa kerran 3:ssa kuukaudessa. Vastaa 17.7€/kk. Säästä 7€", "pricing_section.plan.quarterly.label": "3 kuukautta", "pricing_section.plan.quarterly.title": "Neljännesvuositilaus", "pricing_section.plan.trial.body": "Kokeile videokirjastoamme ilmaiseksi 14 päivän ajan", "pricing_section.plan.trial.button_text": "Kokeile ilmaiseksi 14 päivän ajan", "pricing_section.plan.trial.price": "Ilmainen", "pricing_section.plan.trial.title": "Kokeile ilmaiseksi 14 päivän ajan", "pricing_section.title": "Tule jäseneksi ja saat rajoittamattoman käyttöoikeuden videokirjastoon", "pricing_section.yearly_offers_description": "Choose between 2 time-limited offers. <0>Learn more here</0> ", "prisonyoga.insperational": "Lisämateriaali: Luennot ja tunnit", "prisonyoga.moreabout": "Lue lisää tästä aloitteesta ja Prison Yoga -projektista", "prisonyoga.readmore": "Lue lisää", "prisonyoga.relatedPrograms": "Valikoima videopohjaisia ohjelmia", "prisonyoga.startPracticingEnglish": "Soittolistoja englanniksi", "prisonyoga.startPracticingSwedish": "Soittolistoja ruotsiksi", "prisonyoga.teachersInvolved": "Mukana olevat opettajat ja asiantuntijat", "prisonyoga.testimonials": "Palautetta käyttäjiltä", "prisonyoga.title": "Tervetuloa mukaan The Prison Yoga Project Scandinavia", "profileheader.privacy_settings": "Yksityisyysasetukset", "profileheader.view_public_profile": "Näytä julkinen profiili", "program.backtoprogram": "Kiitos vastauksestasi. Klikkaa tästä palataksesi takaisin ohjelmaan, kun olet valmis.", "program.description": "Harjoitusohjelmamme koostuvat videokirjaston videoista, jotka on koottu helposti seurattavaksi ohjelmaksi. Ohjelman avulla tarjoamme myös syvemmän ymmärryksen aihealueesta.", "program.duration": [["value"], " ", ["unit"], "  ohjelma"], "program.introduction_show_less": "Piilota teksti", "program.introduction_show_more": "Lue lisää", "program.phaseCompletion": ["Edistyminen: ", ["progress"], "%"], "program.quizAction": "Jaa tuntemuksesi", "program.quizCount": [["quizCount"], " kysely"], "program.title": "Valitse harjoitusohjelma", "program.video.repeat_explanation": "Tämä on suositeltu määrä kertoja tämän istunnon uudelleenkatseluun.", "program.videosCount": [["videoCount"], " videota"], "program.videosTotal": [["videoCount"], " videota yhteensä"], "program.weekCount": [["weekCount"], " viikon"], "program.weekCountShort": [["weekCount"], ". viikko"], "program.whatToDoNextContinueProgress": "Jatka prosessiasi", "program.whatToDoNextNextVideo": "Katso seuraava video", "programs.duration": "30 päivän ohjelma", "programs_2021.banner.already_verified": "Jo vahvistettu?", "programs_2021.banner.verify_account": "Vahvista jäsenyytesi aktivoidaksesi kokeilujakson, minkä jälkeen voit osallistua Yogobe Challengeen", "programs_2021.buy_gift.banner_text": " Ostat tämän kurssin lahjaksi. Jos haluat käyttää sitä itse, <0> napsauta tätä </0>", "programs_2021.buy_gift.buyer_name.input_label": "Keneltä", "programs_2021.buy_gift.buyer_name.input_placeholder": "Etunimi", "programs_2021.buy_gift.code_label": "Alennuskoodi", "programs_2021.buy_gift.confirmation_modal_text": ["Maksusi ", ["paymentAmount"], " on suoritettu onnistuneesti. Voit aloittaa heti"], "programs_2021.buy_gift.custom_message.input_label": "Kirjoita henkilökohtainen viesti vastaanottajalle (vapaaehtoinen)", "programs_2021.buy_gift.description": "Olemme iloisia, että haluat antaa tämän ohjelman lahjaksi ystävällesi", "programs_2021.buy_gift.description_tooltip": "Maksun jälkeen saat sähköpostiisi ohjelman lahjakortin ja ohjeet ohjelman aktivointiin", "programs_2021.buy_gift.direct_email.checkbox_label": "Lähetä lahja sähköpostitse suoraan vastaanottajalle", "programs_2021.buy_gift.direct_email.tooltip_text": "Jos tämä vaihtoehto on aktiivinen, vastaanottaja saa sähköpostin, joka sisältää lahjakortin ja ohjeet ohjelman/kurssin aktivointiin. Poista valinta, jos haluat lähettää sähköpostin itse eteenpäin.", "programs_2021.buy_gift.go_courses_btn": "Tutustu kursseihin", "programs_2021.buy_gift.go_dashboard_btn": "Siirry yleiskuvaan", "programs_2021.buy_gift.go_programs_btn": "Tutustu ohjelmiin", "programs_2021.buy_gift.meta_title": ["Yogobe ohjelma - ", ["title"]], "programs_2021.buy_gift.recipient_email.input_label": "Vastaanottajan sähköpostiosoite", "programs_2021.buy_gift.recipient_name.input_label": "Kenelle (vastaanottajan nimi)", "programs_2021.buy_gift.send_email_directly_label": "programs_2021.buy_gift.send_email_directly_label", "programs_2021.card.sale_tag": "Alennus", "programs_2021.contact.contact_text": "Ota yhteyttä <0>business@yogobe.com</0>", "programs_2021.contact.desc": "Olemme niin iloisia, että sinä ja organisaatiosi olette kiinnostuneita aloittamaan Yogoben käytön. Digitaalinen, helppokäyttöinen ja helppo aloittaa. Yhdessä kehitämme ja räätälöimme sisältöä edistääksemme sekä fyysistä että henkistä terveyttä yrityksissä ja organisaatioissa yksilöille ja työntekijöille. Ohjelmamme muoto sopii erinomaisesti etätapaaville tiimeille ja työpaikoille, jotka etsivät inspiraatiota ja ohjausta aktiiviseen arkeen. Monipuoliset kiinnostuksen kohteet ja tarpeet huomioidaan – jokaiselle löytyy jotakin. Aloita ottamalla minuun yhteyttä sähköpostitse!", "programs_2021.contact.purchase_banner_back": "Takaisin", "programs_2021.contact.title": "Hei, tervetuloa Yogoben ohjelmaan!", "programs_2021.expiration_banner.expire_soon.buy_program_text": ["Käyttöoikeutesi tähän ohjelmaan vanhenee ", ["days"], " päivän kuluttua. Laajenna pääsyä nyt jatkaaksesi ohjelmaa. Tallennamme kaiken edistymisesi. <0>Maksatko hyvinvointipalvelun kautta?</0>"], "programs_2021.expiration_banner.expire_soon.renew_access_free_text": ["Käyttöoikeutesi tähän ohjelmaan vanhenee ", ["days"], " päivän kuluttua. Laajenna käyttöoikeutta nyt ilmaiseksi. Kaikki edistymisesi tallennetaan."], "programs_2021.expiration_banner.expire_soon.renew_free_button": "Jatka käyttöoikeutta", "programs_2021.expiration_banner.expire_soon.upgrade_button": "Päivitä nyt", "programs_2021.expiration_banner.expire_soon.upgrade_to_renew_text": ["Käyttöoikeutesi tähän ohjelmaan vanhenee ", ["days"], " päivän kuluttua. Päivitä maksulliseen tilaukseen ja rajoittamaton pääsy tähän ohjelmaan sisältyy hintaan. Kaikki edistymisesi tallennetaan."], "programs_2021.expiration_banner.expired.buy_program_text": ["Käyttöoikeutesi tähän ohjelmaan päättyi ", ["days"], " päivää sitten. Uusi käyttöoikeutesi jatkaaksesi ohjelmaa. Kaikki edistymisesi tallennetaan."], "programs_2021.expiration_banner.expired.renew_access_free_text": ["Käyttöoikeutesi tähän ohjelmaan päättyi ", ["days"], " päivää sitten. Uusi käyttöoikeus nyt ilmaiseksi. Kaikki edistymisesi tallennetaan."], "programs_2021.expiration_banner.expired.renew_free_button": "Uudelleenaktivoi nyt", "programs_2021.expiration_banner.expired.renew_with_discount_text": ["Käyttöoikeutesi tähän ohjelmaan päättyi ", ["days"], " päivää sitten. Uusi käyttöoikeus nyt ja saat ", ["discount"], " alennuksen. Kaikki edistymisesi on tallennettu. <0>Maksatko hyvinvointipalvelun kautta?</0>"], "programs_2021.expiration_banner.expired.upgrade_to_renew_text": ["Käyttöoikeutesi tähän ohjelmaan päättyi ", ["days"], " päivää sitten. Päivitä maksulliseen tilaukseen ja rajoittamaton pääsy tähän ohjelmaan sisältyy hintaan. Edistymisesi on tallennettu."], "programs_2021.expiration_banner.expires_soon.extend_with_discount_text": ["Käyttöoikeutesi tähän ohjelmaan vanhenee ", ["days"], " päivän kuluttua. Uusi käyttöoikeus nyt ja saat ", ["discount"], " alennuksen. Tallennamme edistymisesi. <0>Maksatko hyvinvointipalvelun kautta?</0>"], "programs_2021.expiration_banner.extend_button": ["Jatka hintaan ", ["price"]], "programs_2021.get_started.access_code.icon_text": "Tarvitset pääsykoodin päästäksesi ohjelmaan.", "programs_2021.get_started.access_code.not_valid": "Antamasi pääsykoodi ei kelpaa.", "programs_2021.get_started.access_code.tooltip_text": "Jos sait koodin, joka antaa sinulle pääsyn tiettyyn ohjelmaan, voit kirjoittaa sen tähän", "programs_2021.get_started.access_code.valid": "Koodisi on rekisteröity onnistuneesti!", "programs_2021.get_started.access_code_mismatch": " Tämä koodi on voimassa, mutta aktivoi toisen ohjelman", "programs_2021.get_started.access_code_only_description": "Tervetuloa! <br/> Tähän ohjelmaan voi liittyä vain pääsykoodilla. Koodi toimitetaan sinulle joko Yogoben, kumppaniorganisaation tai tietyn yrityksen/työnantajan kautta.", "programs_2021.get_started.activation_error": "Pahoittelut, emme pystyneet aktivoimaan ohjelmaa sinulle, olethan yhteydessä meihin info@yogobe.com", "programs_2021.get_started.button.activate_for_free": "Jatka", "programs_2021.get_started.button.continue_trial": "Jatka 14 päivän ilmaisjaksolla", "programs_2021.get_started.button.login": "Kirjaudu ja jatka", "programs_2021.get_started.button.purchase": "Jatka maksun vahvistukseen", "programs_2021.get_started.button.start_suscription": "Aloita tilaus", "programs_2021.get_started.buy_gift_btn": "Osta lahjaksi", "programs_2021.get_started.code_label": "Yksilöllinen koodisi", "programs_2021.get_started.description": "Olemme innoissamme, että haluat liittyä tähän ohjelmaan. Kirjaudu sisään tai luo tili jatkaaksesi. Tämä ohjelma sisältyy premium-tilaussuunnitelmiimme, ja sitä voi käyttää myös yrityspakettien kautta.", "programs_2021.get_started.discount_amount": "Alennus", "programs_2021.get_started.end_of_access": "Käyttöoikeus voimassa", "programs_2021.get_started.guest_title": ["Tervetuloa ohjelmaan ", ["program"]], "programs_2021.get_started.join_btn": "Aloita ohjelma", "programs_2021.get_started.payment_amount": "Maksettavaa", "programs_2021.get_started.purchase_banner_text": "Jos edustat yritystä ja haluat tarjota henkilöstöllesi käyttöoikeuden, <0>klikkaa tästä</0>", "programs_2021.get_started.show_code_input": "Onko sinulla pääsykoodi? <0>Klikkaa tästä</0>", "programs_2021.get_started.show_code_input_description": "Tämä on koodi, joka saadaan yleensä työpaikan tai oman organisaation kautta. ", "programs_2021.get_started.user_title": ["Hei ", ["name"], ", tervetuloa ohjelmaan ", ["program"]], "programs_2021.get_started_loggedin.description": " Olemme innoissamme, että haluat liittyä tähän ohjelmaan. Tämä ohjelma sisältyy premium-tilaussuunnitelmiimme, ja sitä voi käyttää myös yrityspakettien kautta.", "programs_2021.header.access_until": ["Pääsysi tähän ohjelmaan päättyy ", ["date"]], "programs_2021.header.buy_as_gift": "Osta lahjaksi", "programs_2021.header.extend_access": "Pidennetty käyttöoikeus", "programs_2021.listing_page.hero.no_premium_disclaimer": "*Tämä hinta on voimassa vain ensimmäisen kuukauden ja muuttuu automaattisesti normaalihinnaksi 19,99 EUR toistuvia maksuja varten.", "programs_2021.listing_page.hero.premium_disclaimer": "* Niin kauan kuin sinulla on premium-tilaus, sinulla on pääsy ohjelmiin ja haasteisiin.", "programs_2021.listing_page.legacy_programs_banner": "Welcome to the new programs structure! Can’t find a program? <0>Click here</0>", "programs_2021.listing_page.meta.description": "Tutustu Yogoben online-ohjelmiin kuten joogaan, mindfulnessiin, aloittelijoiden harjoitteluun, stressinhallintaan ja moneen muuhun. Lue lisää täältä.", "programs_2021.listing_page.meta.title": "Yogobe-ohjelmat - joogaa, meditaatiota, treenejä ja muuta", "programs_2021.listings_page.clear_events_filters": "Tyhjennä suodattimet ja haku", "programs_2021.listings_page.explore_programs_btn": "Tutustu ohjelmiin", "programs_2021.listings_page.faq_btn": "Usein kysytyt kysymykset", "programs_2021.listings_page.filter_applied_toaster": "Suodattimet tallennettu", "programs_2021.listings_page.filters.instructors": "Kaikki opettajat", "programs_2021.listings_page.filters.kind_theme": "Kaikki teemat", "programs_2021.listings_page.filters.languages": "Näytä minulle ohjelmia", "programs_2021.listings_page.filters.sort_alphabetically": "Järjestä aakkosjärjestykseen (A-Ö)", "programs_2021.listings_page.filters.sort_by": "Jaottele", "programs_2021.listings_page.filters.sort_duration": "Järjestä keston mukaan", "programs_2021.listings_page.filters.sort_new": "Järjestä uusin ensimmäiseksi", "programs_2021.listings_page.hero_title": "Tutki ohjelmia", "programs_2021.listings_page.load_more_btn": "Näytä lisää", "programs_2021.listings_page.no_programs_found": "Hups... Emme löytäneet tätä hakutermiä tai suodatinyhdistelmää vastaavaa ohjelmaa. Tämä ei tarkoita, etteikö meillä olisi etsimääsi. Yritä tyhjentää suodattimet tai muotoilla hakukyselysi uudelleen!", "programs_2021.listings_page.option4": "User your fringe health benefits", "programs_2021.listings_page.pricing_section.title": "Päivitä nyt ja saat pääsyn KAIKKIIN ohjelmiin", "programs_2021.listings_page.search_input_placeholder": "Etsi ohjelmaa", "programs_2021.listings_page.subtitle": "Tervetuloa Yogobe-ohjelmiin – ne on räätälöity vastaamaan useita erilaisia ​​tarpeita ja kiinnostuksen kohteita. Tutustu eri ohjelmiin tänään ja osallistu yhteen tai useampaan kerrallaan.", "programs_2021.overview.text_card.locked_text": ["Osallistu ", ["programType"], " nähdäksesi tämän sisällön."], "programs_2021.pricing.free": "Maksutta", "programs_2021.pricing.free_for_you": "Sisältyy tilaukseen", "programs_2021.pricing.included_in_subscription": "Sisältyvät tilaukseen", "programs_2021.program_card.program_access_label": "Sinulla on pääsy", "programs_2021.program_card.program_expire_soon": "Käyttöoikeus vanhenee pian", "programs_2021.program_card.program_expired": "Käyttöoikeus on vanhentunut", "programs_2021.program_page.breadcrumb": "Yogobe-ohjelmat", "programs_2021.program_purchase.confirmation_modal_text": ["Maksusi ", ["paymentAmount"], " on suoritettu onnistuneesti. Voit aloittaa heti"], "programs_2021.program_purchase.get_started": "Pääse alkuun", "programs_2021.program_purchase.go_dashboard_btn": "Go to dashboard", "programs_2021.programs.instructors_modal_title": ["Ohjeet ", ["program"]], "programs_2021.programs.other_instructors_count": [["number"], " lisää"], "programs_2021.progress_page.video_lock.button_text": "Liity ohjelmaan", "programs_2021.progress_page.video_lock.text": "Olet juuri katsonut 60 sekunnin esikatselun. Haluatko kirjautua sisään ja/tai käynnistää tämän ohjelman nyt avataksesi sen kaiken sisällön?", "programs_2021.snackbars.access_granted": "Osallistut nyt tähän ohjelmaan", "programs_2021.themes.athletes": "Urheilijat", "programs_2021.themes.beginner": "Aloittelija", "programs_2021.themes.breathing": "Hengitys", "programs_2021.themes.diet_and_nutrition": "Ruokavalio & ravitsemus", "programs_2021.themes.meditation": "Meditaatio", "programs_2021.themes.mobility_and_prehab": "Liikkuvuus & ennakkohoito", "programs_2021.themes.personal_growth": "Henkilökohtainen kasvu", "programs_2021.themes.philosophy": "FIlosofia", "programs_2021.themes.postnatal": "Raskauden jälkeen", "programs_2021.themes.prenatal": "Raskausajan", "programs_2021.themes.restoration": "Palautuminen", "programs_2021.themes.skills": "Taidot & tekniikka", "programs_2021.themes.smart_breaks": "Älykkäät tauot", "programs_2021.themes.stress_and_anxiety": "Stressi & ahdistus", "programs_2021.themes.womens_health": "Naisten terveys", "programs_2021.themes.workout": "Treeni", "programs_2021.themes.yoga": "Jooga", "programs_2021.themes.yoga_teachers": "Joogaopettajat", "programs_2022.progress.program_recomendation_hide": "Piilota", "programs_2022.progress.program_recomendation_show": "Näytä", "programs_2022.progress.program_tip": "Hyvä tietää", "programs_2022.survey.close_modal_button": "Sulje", "programs_2022.survey.draft_saved": "Vastauksesi on tallennettu luonnoksena.", "programs_2022.survey.edit_survey_btn": "Tarkastele tai muokkaa vastauksia", "programs_2022.survey.exit_alert": "Olet tehnyt joitain muutoksia etkä ole lähettänyt vastauksia. Haluatko varmasti poistua?", "programs_2022.survey.last_submit": ["Olet viimeksi lähettänyt vastauksesi ", ["date"]], "programs_2022.survey.start_survey_btn": "Osallistu kyselyyn", "programs_2022.survey.submit_answers_btn": "Lähetä vastaukset", "programs_2022.survey.thank_you_desc": "Kiitos kyselyn täyttämisestä! Tietosi ovat erittäin arvokkaita palveluidemme kehittämisessä.", "programs_2022.survey.thank_you_title": "Kiitos!", "programs_body.read_more": "Lue lisää", "programs_legacy_listing.banner_message": "Olemme muuttaneet osan ohjelmistamme uuteen rakenteeseen.  <0>Katso tästä</0>", "programs_listing.faq.item1.body": "Kaikki ohjelmat kuuluvat Yogoben aktiivisille jäsenille. Voit myös liittyä ohjelmaan, jos olet parhaillaan kokeilujaksossa, mutta sinulla on pääsy ohjelmaan vain niin kauan kuin sinulla on kokeilujaksoa jäljellä.", "programs_listing.faq.item1.title": "Kuka voi osallistua ohjelmaan?", "programs_listing.faq.item2.body": "Kun olet liittynyt ohjelmaan (minkää teet napsauttamalla \"Aloita\" sinua kiinnostavassa ohjelmassa), löydät aina ohjelmasi <0>sivukartasta</0> ollessasi kirjautuneena.", "programs_listing.faq.item2.title": "Mistä löydän omat ohjelmani?", "programs_listing.faq.item3.body": "Tietysti! Voit liittyä niin moneen ohjelmaan kuin haluat. Jos liityt useisiin ohjelmiin samana päivänä, saat kuitenkin vain sähköpostit, jotka liittyvät ensimmäiseen ohjelmaan, johon liityit. Tämä varmistaa, että et saa liikaa sähköposteja.", "programs_listing.faq.item3.title": "Voinko osallistua useampaan ohjelmaan samanaikaisesti?", "programs_listing.faq.item4.body": "Nyt kaikki ohjelmamme saavat samanlaisen ulkoasun ja rakenteen kuin nykyiset ohjelmamme Yogobe Challengessa. Asettelu helpottaa sinua käyttäjänä liittyessäsi ohjelmiin ja seuratessasi eistymistäsi. Uusi ulkoasu helpottaa myös ohjelman seuraamista ja niiden ohjeiden saamista, mitä ohjelmien on tarkoitus antaa.", "programs_listing.faq.item4.body2": "Jokaiselle ohjelmalle on kaksi välilehteä – \"Yleiskatsaus\" ja \"Omat etenemiseni\". Kohdassa \"Yleiskatsaus\" saat kaikki tiedot ohjelmasta ja yleiskatsauksen jokaisesta ohjelmaan kuuluvasta viikosta/osasta. \"Minun edistyminen\" -kohdasta näet helposti mitkä istunnot kuuluvat mille viikkoon ja mitkä istunnot olet jo suorittanut.", "programs_listing.faq.item4.title": "Miksi ohjelmat ovat uudessa ulkoasussa?", "programs_listing.faq.item5.body": "Tietysti! Meillä on useita erilaisia ​​B2B-ratkaisuja ja räätälöimme mielellämme ratkaisuja, jotka sopivat sinun toiveisiisi ja tarpeisiisi. Lähetä meille sähköpostia <0>business@yogobe.com</0> niin annamme lisätietoa.", "programs_listing.faq.item5.title": "Voivatko yritykset ostaa yksilöllisiä ohjelmia?", "programs_listing.faq.item6.body": "Ohjelmat ovat tällä hetkellä, kuten myös Yogobe Challenge, saatavilla vain Yogobe.com-sivuston kautta. Voit tietysti vierailla verkkosivulla älypuhelimella ja päästä puhelimellasi olevaan ohjelmaan sillä tavalla.", "programs_listing.faq.item6.title": "Ovatko ohjelmat saatavilla sovelluksessa?", "programs_listing.faq.item7.body": "Voit aina aloittaa <0>Yogoben kokeilujaksolla</0> joka on maksuton eikä vaadi minkäänlaista sitoutumista tai maksutietoja. Maksuton kokeilujakso ei koskaan muutu maksulliseksi tilaukseksi automaattisesti.Kokeulujakson jälkeen voit valita päivittäväsi jäsenyytesi toistuvaksi tilaukseksi ja maksaa sen verkkopankkimaksuna, luottokortilla tai yhteistyökumppaneidemme <0>hyvinvointiapurahojen avulla</0>. Niin yksinkertaista! Kirjautuneena jäsenenä löydät  <0>tilauskesi asetukset</0> valikostan kautta ja voit osallistua erilaisiin kuukausi-, neljännesvuosi- ja vuositilaustarjouksiimme.", "programs_listing.faq.item7.title": "Kuinka pääsen maksavaksi jäseneksi Yogobessa?", "programs_listing.walkthrough_section.subtitle": " Tässä videossa näytämme, kuinka helppoa on aloittaa valitsemasi ohjelman käyttäminen, ja näytämme kuinka navigoida eri näkymien välillä. Liity mihin tahansa ohjelmaan tänään!", "programs_listing.walkthrough_section.title": "Näin pääset alkuun", "promotions.code_apply.fallback_failure_message": "Olemme pahoillamme, mutta antamaasi koodia ei ole olemassa tai se on vanhentunut", "public_profile.error_msg": "Profiilin lataaminen ei onnistunut. Päivitä sivu tai kokeile hetken kuluttua uudelleen.", "quickstart.awesome_message": ["Hienoa! Tässä muutamia ", ["yogaDuration"], " mittaisia videoita, jotka sopivat aiheeseen ", ["yogaType"]], "quickstart.awesome_message_yogaTypeCalm": "rauhallista", "quickstart.awesome_message_yogaTypeIntensive": "fyysistä", "quickstart.cancel": "Peruuta", "quickstart.go_back": "Takaisin", "quickstart.hide_this": "Piilota", "quickstart.something_physical": "Jotain sykettä kohottavaa", "quickstart.something_relaxing": "Jotain rentouttavaa", "quickstart.start_message": [["name"], ", tarvitsetko apua sopivan videon etsimisessä?"], "quickstart.time_you_have": "Mahtavaa! Kuinka paljon sinulla on aikaa?", "quickstart.todo_today": "Hienoa, aloita kertomalla meille mitä etsit!", "quickstart.try_quickstart": "Kokeile Quickstartia", "receipts.check_premium": "Tutki jäsenyysvaihtoehtoja", "receipts.empty_description": "Et maksa Yogoben jäsenyydestä tällä hetkellä. Haluaisitko päivittää tilauksesi?", "receipts.empty_title": "Sinulla ei ole vielä kuitteja", "receipts.payment_made": "Olemme vastaanottaneet maksun. Löydät kuitin maksusta tältä sivulta.", "receipts.title": "Kuitit", "reclaim_trial.body": "reclaim_trial.body", "reclaim_trial.confirmation.generic_error": "reclaim_trial.confirmation.generic_error", "reclaim_trial.confirmation.progress_text": "reclaim_trial.confirmation.progress_text", "reclaim_trial.confirmation.success": "reclaim_trial.confirmation.success", "reclaim_trial.dashboard_btn": "reclaim_trial.dashboard_btn", "reclaim_trial.intro": "reclaim_trial.intro", "reclaim_trial.title": "=======", "reclaim_trial_modal.claim_btn": "Kyllä, kiitos!", "reclaim_trial_modal.desc": "Olemme iloisia saadessamme sinut takaisin luoksemme ja haluaisimme antaa sinulle mahdollisuuden tutustua Yogobe Playhin <b>maksutta</b> 14 päivän ajan. Haluatko aloittaa?", "reclaim_trial_modal.not_intrested_btn": "Ei, en ole kiinnostunut", "reclaim_trial_modal.title": "Haluatko uuden 14 päivän kokeilujakson Yogobe Playsta?", "reclaim_trial_page.body": "Sinut uudelleenohjataan automaattisesti hallintapaneeliisi", "reclaim_trial_page.confirmation.generic_error": "Emme voineet aktivoida sinulle uusittua kokeilujaksoa. Ota yhteyttä osoitteeseen <0>info@yogobe.com</0>", "reclaim_trial_page.confirmation.progress_text": "Aktivoidaan uutta kokeilujaksoasi...", "reclaim_trial_page.confirmation.toaster_message": "Tilisi on onnistuneesti päivitetty uudella 14 päivän ilmaisella kokeilujaksolla", "reclaim_trial_page.dashboard_btn": "Tai klikkaa jatkaaksesi", "reclaim_trial_page.desc": "Uusittu kokeilujaksosi on aktivoitu! Olet valmis aloittamaan kaiken Yogobe Playn premium-sisällön ja -ominaisuuksien tutkimisen.", "reclaim_trial_page.title": "14 päivän maksuton kokeilu", "register.tooltip.message": "Rekisteröityessäsi saat ilmaisen kokeilujakson. Voit päivittää koska vain kuukausi- neljännesvuosi- tai vuositilaajaksi alkaen  (99 SEK). <br /> <br /> Jos olet ostanut onlinekurssin tai olet saanut työnantajaltasi kokeilukoodin, tämä on myös paikka jossa rekisteröidyt ja luot henkilökohtaisen tilin. <br /> <br /> <br /> Nähdään Yopgobessa <br /> Peter Munteanu, CEO & Founder.", "registration.access_code.valid": ["Koodisi on vahvistettu. Suorita rekisteröinti loppuun, niin saat Yogobe-käyttöoikeuden ", ["date"], " asti"], "registration.campaign_code.valid": ["Kampanjakoodisi on aktivoitu. Saat ", ["days"], " päivän kokeilujakson, kun olet vienyt rekisteröitymisesi loppuun."], "registration.campaign_code_applied": ["<0>", ["code"], "</0> koodi on lisätty. Jatka rekisteröitymistä saadaksesi pääsyoikeuden."], "registration.complete_profile.address": "Lisää osoitteesi", "registration.complete_profile.title2": [["name"], ", onko sinulla koodi?"], "registration.confirmation.generic_error": "<p>Hyvä jäsenemme,</p> <p>Varmistuslinkki, jota klikkasit ei ole enää käytössä. Yritä päivittää sivu tai kirjaudu uudelleen sisään tai ulos, jos sinulla on ongelmia otathan yhteyttä <a href=\"mailto:data@yogobe.com\">data@yogobe.com</a> jotta voimme auttaa sinua!</p> <p>Lämpimin terveisin<br/> Peter</p>", "registration.confirmation.progress_text": "Vahvistaa sähköpostia…", "registration.confirmation.success": "Sähköpostisi on vahvistettu onnistuneesti!", "registration.continue_to_dashboard.btn": "Siirry Yhteenveto-sivulle", "registration.course.access_code_banner": ["<0>", ["code"], "</0> koodi on lisätty. Jatkamalla rekisteröitymistä saat käyttöikeuden ohjelmaan <0>", ["courseName"], "</0>."], "registration.course.banner": "Odotamme innolla tämän kurssin jakamista kanssasi. Luo käyttäjätili ja sinut ohjataan maksusivulle.", "registration.course_card.desc": "Saat vuoden mittaisen käyttöikeuden kurssiin ja siihen liittyvään materiaaliin. ", "registration.course_card.title": "Saat kurssin lisäksi 14 vuorokauden ilmaisen kokeilujakson joka kattaa koko Yogoben videokirjaston.", "registration.cycle.12months.label": "12 kuukautta", "registration.cycle.1month.label": "1 kuukausi", "registration.cycle.3months.label": "3 kuukautta", "registration.landing.alreadymember": "Oletko jo rekisteröitynyt? <0>Kirjaudu sisään</0>", "registration.landing.btn": "Jatka", "registration.landing.country": "Maa", "registration.landing.email": "Email", "registration.landing.firstname": "Etunimi", "registration.landing.headline": "Tutustu joogaan, meditaatioon, liikkeeseen ja hengitykseen!", "registration.landing.lastname": "Sukunimi", "registration.landing.password": "Salasana", "registration.landing.pricing.info": "Ilmainen kokeilujakso ilman sitoutumista ja pankkitietoja.", "registration.landing.pricing.text": "Lue lisää jäsenyydestä ja hinnoista.", "registration.landing.socials_label": "Tai rekisteröidy", "registration.landing.subtitle": "Luo tili katsoaksesi ja tallentaaksesi tuhansia lempivideoitasi.", "registration.landing.tc": "Jatkaessasi sitoudut  <0>käyttöehtoihimme</0> ja <1> yksityisyyskäytäntöihimme</1>", "registration.landing.title": "Liity Yogobeen. Tule jäseneksi! ", "registration.landing.usp1": "Video- ja audioharjoitteet tilauksesta", "registration.landing.usp2": "LIVE-striimattuja tunteja ja tapahtumia", "registration.landing.usp4": "Luo & jaa soittolistoja", "registration.onboarding.max_selected": "Poista yksi tai useampi valinta jatkaaksesi", "registration.payment.btn1": "Jatka turvalliseen maksamiseen", "registration.payment.btn2": "Takaisin", "registration.payment.code_applied": "Koodisi on luotu onnistuneesti. ", "registration.payment.discount.label": "Alennus", "registration.payment.nextpayment.body": ["Maksat nyt ", ["amount"], ".  <br/> ", ["cycle"], " toistuva laskutus hintaan ", ["recurringAmount"], " - Keskeytä koska tahansa"], "registration.payment.now.label": "Summa", "registration.payment.ordersummary.label": "Tilauksen yhteenveto", "registration.payment.title": "Maksu", "registration.paymentfail.body": ["Jotain meni pieleen... maksusi summalla ", ["amount"], " € epäonnistui. Yritä uudelleen. Jos ongelmat jatkuvat, ota yhteyttä käyttötukeemme data@yogobe.com"], "registration.paymentfail.btn": "Mene takaisin & yritä uudelleen", "registration.paymentfail.orderdetails.body": ["Transaction ID: ", ["transaction"]], "registration.paymentfail.title": "Maksu epäonnistui", "registration.paymentsuccess.body": ["Maksusi summalla ", ["amount"], " ", ["currency"], " on suoritettu. Automaattinen kuitti lähetetään osoitteeseen ", ["email"]], "registration.paymentsuccess.btn": "Jatka", "registration.paymentsuccess.orderdetails.body": ["Tilaus ID: ", ["order"], "   |   Maskutapahtuma ID: ", ["transaction"]], "registration.paymentsuccess.title": "Maksu suoritettu onnistuneestil!", "registration.plan.annually.body": "Maksa kerran vuodessa. Vastaa 16.99€/kk. Säästä 40€", "registration.plan.annually.title": ["Vuositilaus - ", ["amount"]], "registration.plan.btn": "Jatka maksamaan", "registration.plan.code.info.tooltip": "Alennuskoodi antaa alennuksen tilaussopimuksesta, antaen sinulle joko yhden kauden alennuksen tai uusiutuvan alennuksen. Jos sinulla on kysyttävää, ota yhteyttä info@yogobe.com", "registration.plan.code.info_text": "Oletko saanut alennus-, lahjakortti- tai pääsykoodin? Kirjoita se tähän!", "registration.plan.code.label": "Onko sinulla koodi?", "registration.plan.code.success": "Koodisi on vahvistettu onnistuneesti", "registration.plan.codecamp.info.tooltip": "Jos olet saanut kampanjakoodin joogaopettajaltasi, ohjaajaltasi tai joltakin Yogoben kumppaneista, lisää se tähän ja saat pidennetyn ilmaisen kokeilujakson palveluumme, johon kuuluu koko videokirjasto, ohjelmat, soittolistat ja haasteet. Myös Yogoben jäseneltä saatu ystäväkoodi tulee lisätä tähän.", "registration.plan.codecamp.info_text": "Anna kampanja- tai ystäväkoodi", "registration.plan.continue_btn": "Jatka", "registration.plan.monthly.body": "19.99€ laskutetaan kerran kuukaudessa", "registration.plan.monthly.title": ["Kuukausitilaus - ", ["amount"]], "registration.plan.or_subscription.desc": ["Voit aloittaa premiumtilauksesi vaikka heti. Jäljellä olevat ", ["days"], " ilmaispäivää lisätään tietenkin automaattisesti tilaukseesi. "], "registration.plan.or_subscription.title": "Tai valitse tilaus joka sopii sinulle parhaiten", "registration.plan.quarterly.body": "Maksa kerran 3:ssa kuukaudessa. Vastaa 17.7€/kk. Säästä 7€", "registration.plan.quarterly.title": ["Neljännesvuositilaus - ", ["amount"]], "registration.plan.title": "Valitse sinulle sopiva tilaus", "registration.plan.trial.body": "Ilmainen kokeilujakso, pankkitietoja ei tarvita.", "registration.plan.trial.btn_text": "Jatka", "registration.plan.trial.title": ["Hei ", ["name"], ", jatka ", ["days"], "-päivän ilmaistilauksella."], "registration.plan.usp.title": "Kaikkiin tilauksiin kuuluu seuraavat ominaisuudet:", "registration.plan.usp1": "Tallenna, jaa ja lisää videoita omille soittolistoillesi.", "registration.plan.usp2": "Rajoittamaton pääsy 2100+ videoon ja 45+ ohjelmaan.", "registration.plan.usp3": "Helppo päivittää ja peruuttaa koska vain", "registration.referral_code.valid": ["Koodisi on aktivoitu. Tee rekisteröityminen loppuun ja saat ", ["days"], " päivän ilmaisjakson ystäväsi ansiosta"], "registration.trial_code_input.label": "Oletko saanut kampanjakoodin, Mecenatin, ystäväkoodin tai pääsykoodin?", "registration.verification1.intro": ["Jatkaaksesi, varmista tilisi klikkaamalla linkkiä jonka lähetimme <0>", ["email"], "</0>"], "registration.verification1.resend": "Etkö ole vastaanottanut vahvistusviestiä <0>Klikkaa tästä</0>", "registration.verification1.resend_failed": "Sähköpostin uudelleen lähetys epäonnistui, yritä uudelleen tai ota yhteyttä käyttötukeen info@yogobe.com", "registration.verification1.resend_success": "Email uudelleen lähetetty onnistuneesti, tarkistathan sähköpostisi!", "registration.verification1.title": "Varmista käyttäjätilisi", "registration.verification2.body": "Sinut ohjataan automaattisesti...", "registration.verification2.btn": "Klikkaa jatkaaksesi", "registration.verification2.intro": "Tilisi on luotu onnistuneesti! Voit alkaa tutustumaan Yogobeen.", "registration.verification2.title": "Kaikki valmista!", "registration.verify_email_toaster": ["Aktivointisähköposti on lähetetty osoitteeseen ", ["email"], ". Aktivoi ja vahvista tilisi saadaksesi ilmaisen kokeilujakson. Onko osoitteesi lisätty väärin? Ota yhteyttä info@yogobe.com"], "registration.wellness.learn_more": "Did you know you can use your employee wellness grant for Yogobe? <0>Learn more</0>", "regsocial.best_value": "Paras hinta", "regsocial.feature1_desc": ["Rajoittamaton käyttöoikeus yli ", ["videos_count"], " videoon. Harjoituksia, luentoja ja workshopeja liittyen joogaan, meditaatioon, pilatekseen, liikkuvuuteen, raskaus- ja äitiystreenaamiseen, kuntoutumiseen, coreen, venyttelyyn, juoksuharjoitteluun jne. Missä haluat, milloin haluat!"], "regsocial.feature1_title": [["videos_count"], "+ videota"], "regsocial.feature2_desc": "Videot ja opastus aloittelijalle  Team Yogobe on koonnut eri mittaisia hyvinvointiin liittyviä harjoitusohjelmia, joiden sisältö pohjautuu videokirjaston materiaaliin. Kaikki tuottamamme sisältö on tehty jäsentemme toiveiden ja tarpeiden pohjalta.", "regsocial.feature2_title": "Hyvinvointi- ja treeniohjelmat", "regsocial.feature3_desc": "Luo, seuraa ja jaa soittolistoja. Sekä omiasi että muiden käyttäjien. Soittolistat ovat kokoelmia videoista tai audionauhoista. Autoplay-ominaisuuden ansiosta seuraava video jatkuu automaattisesti edellisen jälkeen.", "regsocial.feature3_title": "Luo soittolistoja", "regsocial.feature5_desc": "Liity kasvavaan yhteisöömme Facebookissa: YOGA365 Jooga, välittäminen ja intohimo hyvinvointiin yhdistävät yhteisömme jäseniä. Me Yogobella opastaa ja inspiroida yksilöitä ja yhteisöjä kestävään terveyteen tarjoamalla laadukkaita työkaluja, palveluja ja kanavia, jotka kannustavat fyysiseen, psyykkiseen, hengelliseen ja sosiaaliseen hyvinvointiin.", "regsocial.feature5_title": "Yhteisö", "regsocial.getstarted": "Aktivoi", "regsocial.hero_btn1": "Tutki jäsenyysvaihtoehtoja", "regsocial.hero_btn2": "Kokeile ilmaiseksi 14 päivän ajan", "regsocial.hero_title": "Hanki rajaton käyttöoikeus videokirjastoomme", "regsocial.hero_usp": "Helppoa - ei sitoutumisaikaa - kokeilu ilman pankkikorttitietoja", "regsocial.live_desc": "Meet teachers and other members for classes, workshops and lectures LIVE online. Let Team Yogobe guide you in real time!", "regsocial.live_title": "LIVE – be guided in real time", "regsocial.mobile_section.desc": "In our app for iOS and Android you get access to the entire library, playlists, offline mode as well as Cast via Airplay and ChromeCast.", "regsocial.mobile_section.title": "Explore our new app", "regsocial.most_affordable": "Most Affordable", "regsocial.offer_description": "HYÖDYNNÄ VUOSITARJOUKSEMME <0/> Hanki itsellesi Yogoben vuosijäsenyys ja anna pohjoismaiden parhaiden opettajien ja ohjaajien opastaa sinua joogaan, meditaatioon, pilatekseen, toiminnalliseen harjoitteluun, raskaus- ja äitiystreenaamiseen yms. liittyvien online- ja offline-videoiden välityksellä. Paras tapa pysyä toimintakykyisenä, vahvana ja hyvinvoivana! <0/> Kuka voi hyödyntää tarjouksen? <0/> <0/> Kuka tahansa, joka aloittaa, päivittää tai uudistaa jäsenyytensä Yogobessa (pysyvään hintaan 199 euroa käyttäen VISA/Mastercard -veloitusta maksujärjestelmiemme DIBS:n tai Trustlyn kautta) saa 50 euron Yogirajin lahjakortin, jota voi käyttää maksuvälineenä Yogobe Storessa. <0/> <0/> Tarjous on voimassa 8.5.2019 keskiyöhön asti. Hyväksyttyäsi tämän tarjouksen saat meiltä lahjakoodisi automaattisesti sähköpostilla.  Lahjakortti oikeuttaa tietyn tuotemäärän ostamiseen. Toimituskulut lisätään tilaukseen ja ne jäävät tilaajan maksettavaksi. Lahjakortti on voimassa 31.12.2019 asti eikä sitä voi vaihtaa rahaksi. Klikkaa ja lue lisää tarjouksesta. <0/> <0/> Yogirajista (joogamatot ja välineet) <0/> Pohjolan metsistä, tuntureista, lakeuksista ja merestä inspiraationsa saava Yogiraj pyrkii valmistamaan tuotteita, jotka ovat kestäviä ja pitävät huolta sekä sinusta että ympäristöstä. Kaikki tuotteet ovat myrkyttömiä ja useimmat myös täysin ekologisia.  <0/> <0/> Yogirajin valikoimista löytyy paljon joogavälineitä – kaikkea bolstereista ja meditaatiotyynyistä silmätyynyihin, painaviin puuvillapeittoihin ja eri kokoisiin blokkeihin. Mielestämme Yogiraj tarjoaa myös parhaat joogamatot – edullisista allround matoista uuteen, lämpöjoogaan ja muuhun intensiiviseen harjoitteluun sopivaan grip mattoon. <0/> <0/> Hyvä tietää päivittäessäsi jäsenyyttäsi <0/> Jos sinulla on ilmainen kokeilujakso käynnissä, vuoden jäsenyys lisätään jäljellä olevien päivien jatkeeksi. <0/> Jos sinulla on aktiivinen jäsenyys käynnissä, jäsenyystyyppisi muutetaan vuosijäsenyydeksi ja uusi veloitus tehdään tänään. Jäljelle jäävät päivät edellisestä jäsenyydestä lisätään nykyiseen jäsenyyteesi. <0/> Jos sinulla on muita kysymyksiä, ota meihin yhteyttä: info@yogobe.com. <0/> Käytä työnantajan tarjoama liikuntaetu <0/> Yogoben maksavana jäsenenä voit helposti tulostaa kuittisi omista asetuksistasi. Voit antaa kuitit työnantajallesi, joka päättää jäsenyyden korvaamisesta. Jos olet epävarma siitä, mitä liikuntaetu sisältää, kysy työnantajaltasi etukäteen kattaako se verkkoharjoittelun. <0/> Yogobe Storen lahjakorttiin (arvo 50 euroa) oikeuttava tarjous ei ole yhdistettävissä liikuntaetua tarjoavien yritysten, kuten Benifyn tai Actiwayn kautta maksettaviin jäsenyyksiin, sillä ne ovat kertaluontoisia maksuja eivätkä jatkuvia tilauksia. <0/> ", "regsocial.offer_title": "Ota osaa huikeaan vuositarjoukseemme", "regsocial.page_title": "Tule jäseneksi", "regsocial.special_page_title": "Tule vuosijäseneksi", "regsocial.subscription_annually_billed": "Jäsenyytesi uusiutuu vuosittain.", "regsocial.subscription_annually_save": "Säästä 40 euroa vuodessa", "regsocial.subscription_free_plan_label": "Kokeile videokirjastoamme ilmaiseksi 14 päivän ajan", "regsocial.subscription_free_price_label": "Ilmainen", "regsocial.subscription_free_title": "Kokeile ilmaiseksi", "regsocial.subscription_monthly_billed": "Jäsenyytesi uusiutuu kuukausittain.", "regsocial.subscription_monthly_per": "/ kuukausi", "regsocial.subscription_quarterly_billed": "Jäsenyytesi uusiutuu neljännesvuosittain ja päivittyy normaalihintaan toisella neljänneksellä.", "regsocial.subscription_quarterly_per": "/ vuosineljännes", "regsocial.subscription_quarterly_save": "Säästä 28 euroa vuodessa", "regsocial.subscription_sub_title": "Aloita vuosijäsenyys ja saat 50 euron lahjakortin Yogirajin tuotteisiin.", "regsocial.subscription_title": "Tule jäseneksi ja saat rajoittamattoman käyttöoikeuden videokirjastoon", "regsocial.subscription_year_per": "/ vuosi", "regsocial.testimonial_title": "Mitä käyttäjämme ovat mieltä", "reset_program.body": "Haluatko muuttaa ohjelmaa jonka aloitit Yogobe Spring Challenge? Seuraavien ohjeiden avulla voit valita haluamasi ohjelman ja täyttää lomakkeen uudelleen.", "reset_program.info": ["Tietosi liittyen valitsemaasi haasteeseen (", ["programName"], ") hävitetään. Haluatko silti jatkaa?"], "reset_program.no": "Ei, haluan jatkaa haastetta", "reset_program.title": "Vaihda ohjelmaa", "reset_program.yes": "Kyllä, valitsen toisen ohjelman", "schedule_modal.googlecalendar": "Siirrä Google-kalenteriin", "schedule_modal.icp": "Tallenna kalenteriin", "schedule_modal.time": "Aika", "schedule_modal.title": "Aikataulu", "search.category.blog.title": "Blogi", "search.category.challenges.title": "Haasteet", "search.category.courses.title": "Online-kurssit", "search.category.events.title": "Tapahtumat", "search.category.instructors.title": "Opettajat ja asiantuntijat", "search.category.live_events.title": "LIVE online", "search.category.pages.title": "Tiedot", "search.category.playlists.title": "Soittolistat", "search.category.programs.title": "Ohjelmat", "search.category.video_audio.title": "Video & audio", "search.filters.languages": "Kielet", "search.go_back": "Takaisin", "search.input_placeholder": "Hae Yogobesta...", "search.program_card.view_blog": "Lue artikkeli", "search.program_card.view_challenge": "Katso haaste", "search.program_card.view_course": "Katso kurssi", "search.program_card.view_live": "Katso LIVE-tunti", "search.program_card.view_program": "Katso ohjelma", "search.result_found": "1 tulos löytyi", "search.results.many": [["count"], " tulosta"], "search.results.one": [["count"], " tulos"], "search.results_found": [["totalCount"], " tulokset <0>haulle ", ["query"], "</0>"], "search.results_not_found": "Ei tuloksia tälle haulle, voit yrittää muotoilla haun uudestaan!", "search.search_correction": "Voit kokeilla sen sijaan jotain näistä:", "search.search_input_button": "Hae", "search.search_not_started": "Aloita haku ja tutustu kaikkeen, mitä meillä on tarjota – tunteja, inspiroivaa luettavaa, harjoitusohjelmia ja paljon muuta!", "search.section.blog.title": "Blogi", "search.section.challenges.title": "Haasteet", "search.section.courses.title": "Online-kurssit", "search.section.events.title": "Tapahtumat", "search.section.instructors.title": "Opettajat ja asiantuntijat", "search.section.live.title": "Live", "search.section.playlists.title": "Soittolistat", "search.section.programs.title": "Ohjelmat", "search.section.resources.title": "Tiedot", "search.section.slide.more": ["Katso kaikki ", ["totalCount"], " tulokset haulle ", ["searchQuery"], " kohteessa ", ["title"]], "search.section.video_audio.title": "Video & ääni", "search.tabs.all": "Kaikki", "search.tabs.blog": "Blogi", "search.tabs.coursetravel": "Kurssit & matkat", "search.tabs.live": "LIVE", "search.tabs.mobile_play": "Play (Videot, Soittolistat, Ohjelmat)", "search.tabs.play": "Play", "search.tabs.play_tooltip": "Yogobe Play on kaikki, mitä saat premium-käyttäjänä aktiivisella käyttöajalla. Siihen kuuluu koko videokirjasto, viikoittaiset LIVE-tunnit, soittolistat, ohjelmat ja haasteet.", "search.tabs.resources": "Tiedot", "search.temporary_banner": "Olemme juuri julkaisseet hakutoiminnon, pyrimme jatkuvasti parantamaan sitä ja arvostamme palautettasi! <0>Anna palautetta</0>", "search.title": "Mitä etsit?", "search_details.blogPosts.explore": "search_details.blogPosts.explore", "search_details.challenges.explore": "Tutustu haasteisiin", "search_details.courses.explore": "Tutustu online-kursseihin", "search_details.events.explore": "Tutustu tapahtumiin", "search_details.genericPrograms.explore": "Tutustu ohjelmiin", "search_details.instructors.explore": "Tutustu Team Yogobeen", "search_details.live.explore": "Tutustu LIVEen", "search_details.playlists.explore": "Tutustu soittolistoihin", "search_details.results.load_more": "Näytä lisää", "search_details.results_found.mutiple_results": [["totalCount"], " tulosta <0>", ["query"], "</0> kohteessa ", ["category"]], "search_details.results_found.single_results": [["totalCount"], " tulos <0>", ["query"], "</0> kohteessa ", ["category"]], "search_details.title": ["Hae kohteesta ", ["category"]], "search_details.videos.explore": "Tutustu kirjastoon", "settings.go_back": "Takaisin yleiskatsaukseen", "settings.subsriptions.failed_renew": ["Viimeisin yrityksemme veloittaa jäsenmaksu maksukortiltasi tai tililtäsi epäonnistui. Jos korttisi on vaihtunut, suosittelemme valitsemaan alta jäsenyyslomakkeen ja päivittämään tietosi. Ota meihin yhteyttä <0>", ["email"], "</0>, jos haluat meidän tekevän uuden veloituksen nykyiseltä kortiltasi tai tililtäsi ennen seuraavaa automaattisen veloituksen ajankohtaa."], "settings_account.change_password.logout_notice": "Kun vaihdat salasanasi, sinua pyydetään kirjautumaan tilillesi uudelleen", "settings_account.confirm_new_password": "Vahvista uusi salasana", "settings_account.mailaddress": "Sähköposti", "settings_account.new_password": "Uusi salasana", "settings_account.password_updated_successfully": "Salasanasi on päivitetty", "settings_account.recover_your_password": "Palauta salasana", "settings_account.token_wrong": "Kirjoittamasi koodi näyttää olevan virheellinen. Yritä ystävällisesti uudestaan!", "settings_fringe_health.descriPSettingsFringeHealthBenefitstion": "Tarjoaako työnantajasi liikuntaetuja? Kysy, maksaisivatko he jäsenyytesi ottamalla vastaan Yogoben kuitit. Pohjoismaissa teemme yhteistyötä liikuntaetuja tarjoavan yrityksen, Benifyn, kanssa. Ruotsissa muita yhteistyökumppaneita ovat Actiway, Wellnet ja Min Friskvård. Heidän sivustojensa kautta Yogoben tilin päivittäminen on helppoa.", "settings_fringe_health.read_more": "Lue lisää työnantajan tarjoamasta liikuntaedusta", "settings_fringe_health.title": "Käytä työnantajasi tarjoama liikuntaetu osittain tai kokonaan", "settings_history.action": "Tyhjennä koko historia", "settings_history.title": "Historia", "settings_modal.accessible-yoga": "Esteetön jooga", "settings_modal.barn-ungdom": "Lapset ja nuoret", "settings_modal.beginner": "Vain aloittelijaystävälliset videot", "settings_modal.english": "Englanti", "settings_modal.finnish": "Suomi", "settings_modal.helper": "Haluamme auttaa sinua löytämään parhaat ja kiinnostavimmat hakutulokset videokirjastostamme. Tämän toiminnon avulla voit rajata hakua toiveidesi mukaan.", "settings_modal.helper_label": "Räätälöi oma Yogobe-kokemuksesi", "settings_modal.left_section_title": "Kielet", "settings_modal.norwegian": "Norja", "settings_modal.office-yoga": "Toimistojooga", "settings_modal.postnatal": "Raskauden jälkeinen jooga & treenit", "settings_modal.prenatal": "Raskausjooga & -treenit", "settings_modal.primary_button": "Tallenna", "settings_modal.right_section_title": "Suodattimet", "settings_modal.secondary_button": "Peruuta", "settings_modal.senior-yoga": "Seniorijooga", "settings_modal.swedish": "Ruotsi", "settings_modal.title": "Asetukset", "settings_privacy.description": "Valitsemasi sisältö näkyy julkisessa profiilissasi", "settings_privacy.favorites": "Suosikit", "settings_privacy.private_profile_notice": "Olet päättänyt tehdä profiilistasi yksityisen. Muut käyttäjät eivät voi nähdä suosikkejasi tai luomiasi soittolistoja.", "settings_privacy.statistics": "Tilastot", "settings_private_informations.city": "Kaupunki", "settings_private_informations.dateOfBirth": "Syntymäpäivä", "settings_private_informations.first_name": "Etunimi", "settings_private_informations.lastName": "Sukunimi", "settings_private_informations.phone": "Puhelin", "settings_private_informations.profession": "Ammatti", "settings_private_informations.street_address": "Katuosoite", "settings_private_informations.timezone": "Aikavyöhyke", "settings_private_informations.zip_code": "Postinumero", "settings_profile.cancel_url_not_available": "Sinulla ei ole tällä hetkellä voimassaolevaa tilausta. Se tarkoittaa, että sinun ei tarvitse peruuttaa mitään. Ota meihin yhteyttä info@yogobe.com jos sinulla on jotakin kysyttävää!", "settings_profile.display_name": "Näytä nimi", "settings_profile.facebook": "Facebook", "settings_profile.instagram": "Instagram", "settings_profile.linkedin": "LinkedIn", "settings_profile.remove_photo": "Poista kuva", "settings_profile.short_bio": "Lyhyt kuvaus", "settings_profile.short_bio_placeholder": "Kirjoita muutaman rivin kuvaus itsestäsi", "settings_receipts.date": "Päivämäärä", "settings_receipts.payment_type": "Maksutapa", "settings_receipts.receipt": "Kuitti", "settings_receipts.receipt_number": "Kuittinumero", "settings_receipts.total_including_vat": "Summa sis. ALV", "settings_referall.description": "Kutsu ystäväsi Yogobeen ja tilisi päivittyy automaattisesti 30 lisäpäivällä", "settings_referall.paragraph_one": "Anna ystävillesi 21 ensimmäistä Yogobe-päivää ilmaiseksi. Ilman sitoutumisaikaa tai maksukorttitietoja ja bonukset saat sinä!", "settings_referall.paragraph_two": "Jokainen ystäväkoodiasi rekisteröitymiseen käyttävä ja maksullisen jäsenyyden tilaava ystäväsi tuo sinun tilillesi automaattisesti 30 ilmaista bonuspäivää (arvo 19,99 euroa). Jaa siis koodiasi kaikille ystävillesi, joiden luulet hyötyvän Yogobesta ja hyödyt samalla itsekin!", "settings_referall.personal_code_action": "Kopioi", "settings_referall.personal_code_label": "Henkilökohtainen koodisi", "settings_referall.refer": "Kutsu ystäväsi:", "settings_referall.title": "Kutsu ystäväsi", "settings_subheader.account": "Tilin asetukset", "settings_subheader.fringe_health_benefits": "Työnantajan tarjoama liikuntaetu", "settings_subheader.live_codes": "LIVE-koodit", "settings_subheader.manage_notifications": "Sähköpostiasetukset", "settings_subheader.privacy": "Yksityisyysasetukset", "settings_subheader.private": "Jäsentiedot", "settings_subheader.profile": "Profiilin asetukset", "settings_subheader.receipts": "Kuitit", "settings_subheader.referral_program": "Kutsu ystäviä", "settings_subheader.subscriptions": "Jäsenyys", "settings_subscriptions.access_code.activation_failed": "Koodin aktivointi epäonnistui. Yritä uudelleen tai ota yhteyttä meihin <0>info@yogobe.com</0> ", "settings_subscriptions.access_code.buy_gift": "Klikkaa tästä ostaaksesi lahjakortin", "settings_subscriptions.access_code.description": "Jos sinulla on koodi, joka antaa sinulle tietyn käyttöajan, kuten Mecenatin tai työnantajasi antama koodi, voit kirjoittaa sen alla olevaan tekstikenttään", "settings_subscriptions.access_code.input_description": "Koskee myös Mecenatin koodeja", "settings_subscriptions.access_code.input_label": "Syötä koodisi", "settings_subscriptions.access_code.invalid_code_message": "Syöttämäsi koodi on virheellinen tai se ei ole enää voimassa. Voit yrittää uudelleen tai ota yhteyttä meihin <0>info@yogobe.com</0>", "settings_subscriptions.access_code.submit_btn": "Aktivoi", "settings_subscriptions.access_code.title": "Onko sinulla pääsykoodi?", "settings_subscriptions.access_code.valid_code_message": "Koodisi on rekisteröity!", "settings_subscriptions.annually": "Vuosittain", "settings_subscriptions.cancel_mobile_subscription": ["Maksat tällä hetkellä jäsenyytesi palveluntarjoajan ", ["provider"], " kautta. Keskeytäthän tilauksesi ensin, jotta voit jatkaa tilaustasi suoraan Yogoben kautta. Lisää tietoa saat täältä"], "settings_subscriptions.cancelled_no_access": "Aktiivinen tilauksesi on päättynyt eikä sinulla ole enää pääsyä videoihin, soittolistoihin, ohjelmiin tai haasteisiin. Maksamalla uuden jäsenmaksun voit aktivoida tilauksesi uudelleen koska tahansa.", "settings_subscriptions.cancelled_with_access": ["Aktiivinen tilauksesi on keskeytetty, mutta sinulla on yhä käyttöoikeus videoihin, soittolistoihin, ohjelmiin ja haasteisiin ", ["date"], " asti. Maksamalla uuden jäsenmaksun voit aktivoida tilauksesi uudelleen koska tahansa."], "settings_subscriptions.description_free": "Sinulla ei ole tällä hetkellä voimassaolevaa maksullista tilausta", "settings_subscriptions.description_no_subscription_premium": ["Sinulla on voimassaoleva jäsenyys ", ["date"], " asti"], "settings_subscriptions.discount_code.description": "Jos sinulla on koodi, joka oikeuttaa alennukseen tilauksestasi, voit kirjoittaa sen alla olevaan tekstikenttään", "settings_subscriptions.discount_code.input_description": "Koskee myös alennus- ja erikoistarjouskoodeja", "settings_subscriptions.discount_code.input_label": "Syötä alennuskoodi", "settings_subscriptions.discount_code.invalid_code_message": "Syöttämäsi koodi on virheellinen tai se ei ole enää voimassa. Voit yrittää uudelleen tai ota yhteyttä meihin <0>info@yogobe.com</0>", "settings_subscriptions.discount_code.submit_btn": "Aktivoi", "settings_subscriptions.discount_code.title": "Onko sinulla alennuskoodi?", "settings_subscriptions.discount_code.valid_code_message": "Koodisi on rekisteröity!", "settings_subscriptions.mobile_description_premium_renew": ["Aktiivinen tilauksesi uusiutuu automaattisesti ", ["date"], " alustan ", ["platform"], " kautta"], "settings_subscriptions.monthly": "Kuukausittain", "settings_subscriptions.quarterly": "Neljännesvuosittain", "settings_subscriptions.subscription_next_billing": ["Sinulla on tällä hetkellä ", ["plan"], " tilaus ", ["amount"], " ja se uusiutuu automaattisesti ", ["date"]], "settings_subscriptions.subscription_next_billing_failed": ["Maksuasi ", ["amount"], " ei voitu käsitellä."], "settings_subscriptions.subscription_next_billing_processing": "Maksuasi käsitellään.", "settings_subscriptions.subscription_next_billing_unpaid": ["Maksua ", ["amount"], " ei voitu käsitellä tällä hetkellä. Yritämme veloittaa tilauksesi pitääksemme aktiivisena."], "settings_subscriptions.title": "Haluatko vaihtaa jäsenyytesi?", "settings_subscriptions.toaster_message.access_code_activated": "Koodi on aktivoitu!", "settings_subscriptions.updated": "Katseluoikeuttasi on jatkettu", "settings_subscriptions.wellness_banner.description": "Voit käyttää hyvinvointirahaa Yogobe-tilausten ja verkkokurssien ostamiseen. Tuemme tällä hetkellä Benifya, ePassia, Wellnetiä ja etuja. <0>Lue lisää täältä.</0>", "settings_subscriptions.wellness_banner.title": "Tiesitkö?", "share_modal.copied_button": "Kopioitu", "share_modal.copy_placeholder": "Kopioi tämä URL jakamista varten:", "share_modal.hidden": "Voit jakaa tämän soittolistan, mutta se onnistuu vain linkin/URL:n kautta. <0>Muokkaa soittolista-asetuksia.</0>", "share_modal.privacy": "Voit jakaa tämän soittolistan, mutta kukaan ei voi nähdä sitä. <0>Muokkaa soittolista-asetuksia.</0>", "share_modal.title": "Jaa", "snackbar.faq": "UKK sivu", "snackbar.favorites": "Suosikit", "snackbar.playlist": "Näytä soittolista", "snackbar.playlists": "Soittolistat", "snackbars.added_video_playlist": "Video lisätty soittolistaan", "snackbars.cancel_subscription_faild": "Valitettavasti tilausta ei voitu peruuttaa. Kokeile uudelleen!", "snackbars.challenge.program_access_granted": "Osallistut nyt tähän haasteeseen.", "snackbars.created_playlist": "Soittolistasi on luotu", "snackbars.favorited_playlist": "Tallennettu suosikkeihin", "snackbars.favorited_video": "Tallennettu suosikkeihin", "snackbars.removed_video_playlist": "Video poistettu soittolistalta", "snackbars.settings_update": "Asetuksesi on päivitetty", "snackbars.subscription_succussfuly_canceled": "Tilaus peruutettu onnistuneesti. Toivottavasti näemme pian uudelleen!", "snackbars.unfavorited_playlist": "Poistettu suosikeista", "snackbars.unfavorited_video": "Poistettu suosikeista", "snackbars.updated_playlist": "Soittolistasi on päivitetty", "sortby.published_at": "Viimeisin", "sortby.time": "Aika", "special399.banner.usp1": "special399.banner.usp1", "specialoffer.banner_cta": "Kyllä kiitos", "specialoffer.banner_tag1": "Kokeile ilmaiseksi 14 päivän ajan", "specialoffer.banner_tag2": "Tarjous voimassa rajoitetun ajan", "specialoffer.banner_title": "Päivitä jäsenyytesi ja saat 50 euron lahjakortin Yogirajin tuotteisiin", "specialoffer.new_banner_title": "Liity 115 000 jäsenen joukkoon ja tule osaksi Yogoben kasvavaa yhteisöä!", "spring_challenge.thankyou": "Ihanaa, että päätit liittyä Yogobe Spring Challengeen! Odotamme innolla, että pääsemme seuraamaan matkaasi seuraavien viikkojen aikana. Muista: paras harjoitus on tehty harjoitus.", "springchallenge.banner.disclaimer": "*Tarjous koskee sekä uusia että vanhoja jäseniä. Normaalihinta 19,99€", "springchallenge.banner.subtitle": "Tervetuloa mukaan keväthaasteeseen! Kirjaudu sisään ja aloita hintaan 9,90€.  ", "springchallenge.banner.title": "Yogobe Spring Challenge", "springchallenge.form.title": "Yogobe Spring Challenge", "springchallenge.info.excerpt": "Toivotamme sinut tervetulleeksi neljän viikon haasteeseen jonka tarkoitus on inspiroida kokeilemaan joogaa, meditaatiota, funktionaalista liikettä, pilatesta ja hengitysharjoituksia stressinhallinnan tukena. Harjoitustasi kannattelevat pohjoismaiden johtavat opettajat ja asiantuntijat ja saat joka viikko 10 uutta videota, joista valita mieleisesi (tunteja, luentoja ja tekniikkavideoita).   <h2>Päätä itse koska liityt haasteeseen</h2> Kirjaudu sisään 20.3–15.4.2020 välisenä aikana ja suorita haaste loppuun 20.5.2020 mennessä.  <h2>Valitse ohjelmasi</h2> Haaste tarjoaa kaksi erilaista ohjelmaa jotta voit löytää oman flowsi ja pitää hauskaa tarjoamiemme apuvälineiden tuella. Alla lisäinfoa ohjelmista. Haaste toteutuu myös Ruotsissa. Jos haluat tutustua sisarhaasteeseen <a href=\"https://yogobe.com/se/springchallenge\">klikkaa tästä!</a>    <ul> <li><bold>Lempeä liike</bold> : sinulle, joka olet utelias kokeilemaan joogaa, funktionaalista liikettä tai meditaatiota. Anna harjoituksen virrata ja pidä hauskaa!</li>  <li><bold>Elvy ja heleydy</bold> :  Sinulle, joka kärsit burnoutista, uupumuksesta tai väsymyksen ensioireista. Saat oppia meditaatiosta, lempeästä joogasta, motivoivista luennoista ja stressinhallintaan vaikuttavista harjoituksista.</li> </ul> Lisätietoa molemmista ohjelmista skrollaamalla alaspäin.", "springchallenge.info.rest": "<h2>Mahdollisuus voittaa palkinto </h2> Jos teet vähintään kolme videota viikossa saatat olla yksi kymmenestä, jotka voittavat vuoden ilmaisjäsenyyden Yogobeen ja valitsemasi onlinekurssin (arvo 250€).  <h2>Kuka voi osallistua haasteeseen?</h2> Kuka vain! Osallistuaksesi sinun täytyy vain rekisteröityä Yogobeen. Kaikki uudet jäsenet ja sellaiset, jotka eivät ole aktiivisia tai maksavia jäseniä, saavat yhden kuukauden tarjoushintaan 9,99€ joka oikeuttaa pääsyn mukaan molempiin haasteisiin ja lisäksi koko videokirjaston sisältöön (+1600 videota, +45 ohjelmaa, satoja soittolistoja yms). Tilaus jatkuu automaattisesti kuukausitilauksena (19,99€) jos et peru sitä. Uudet jäsenet saavat automaattisesti 14 vuorokauden ilmaisen kokeilujakson 30:n vuorokauden päätteeksi (normaalihinta 9,99€).  <h2>Saa tukea ja inspiraatiota haasteen aikana</h2> Jaa kehitystäsi haasteen aikana käyttämällä tägiä #yogobespringchallenge ja liity facebookryhmäämme <a href=\"https://www.facebook.com/groups/beyoga365/\">#BEYOGA365</a> jossa saat tukea ja inspiraatiota muilta haasteeseen osallistuvilta ja Yogoben tiimiltä.", "springchallenge.info.title": "Joogaa ja liiku kanssamme tänä keväänä!", "springchallenge.programsBody.more.body": "Jos teet vähintään kolme videota per viikko saatat olla yksi kymmenestä voittajasta, joille on luvassa pääpalkinto: vuoden ilmaisjäsenyys Yogobeen sekä vapaavalintainen onlinekurssi (arvo 250€). Olet mukana arvonnassa, kun aloitat haasteen viimeistään 1.5.", "springchallenge.programsBody.more.title": "Kilpailu!", "springchallenge.programsBody.subtitle": "Aloita keväthaaste jo tänään!", "springchallenge.programsBody.title": "Mikä ohjelma vastaa tarpeisiisi?", "springchallenge.testimonials.title": "Johtavat opettajat ja asiantuntijat opastavat ja inspiroivat", "start.section3_title": "Etsi videoita kategorioittain", "statistics_banner.info": ["Vuoden ", ["year"], " aikana lanseeraamme tilastovälilehden uudelleen. Tämä toiminto on tauolla kunnes toisin ilmoitamme."], "stats.average_duration": "Keskimääräinen kesto", "stats.favorite_yoga_style": "Suosikkijoogatyylisi", "stats.minutes": "minuuttia", "stats.sessions": "Videot", "stats.sessions_completed": "Katsotut videot", "stats.total_time": "Kokonaisaika", "stripe_banner.wellness_grant.december.text": "stripe_banner.wellness_grant.december.text", "stripe_banner.wellness_grant.november.text": "stripe_banner.wellness_grant.november.text", "subheader.overview": "Yleisnäkymä", "subheader.playlists": "Soittolistat", "subheader.programs": "Harjoitteluohjelmat", "subscriptions.cancel_subscription": "Peruuta tilaus", "subscriptions.cancel_subscription_helper": "Aktiivisen jäsenyyden peruuttaminen on helppoa. Jos päätät tehdä niin, sinulla on luonnollisesti täysi käyttöoikeus videokirjaston sisältöön nykyisen maksukautesi loppuun asti.", "subscriptions.cancel_subscription_label": "Haluatko peruuttaa jäsenyytesi?", "subscriptions.full_accesse_code.default_title": "Access via access code", "subscriptions.one_time_code.default_title": "Access via one time access code", "summerchallenge.banner.text": "<0>Pidä hyvinvointiasi yllä myös kesällä - osallistu haasteeseemme #yogobesummerchallenge</0>", "summerchallenge.banner.title": "Yogobe Summer Challenge", "summerchallenge.challenge_form.activate_account": "Kiitos tilauksestasi!  Olemme nyt lähettäneet sinulle viestin, jonka pitäisi saapua sähköpostiisi muutamassa minuutissa. Löydät alapuolelta linkin, jota painamalla voit aktivoida tilisi ja pääset mukaan ohjelmaan. ", "summerchallenge.challenge_form.level_note": "Skrollaa alas ja lue lisää. Uusi toiminto: Vaihda ohjelmaa milloin haluat.", "summerchallenge.challenge_form.login": "Täytä tämä lomake ja pääset mukaan Yogoben kesähaasteeseen!", "summerchallenge.challenge_form.resend_activation": "Etkö saanut sähköpostia? <0>Klikkaa tästä ja lähetä tiedot uudelleen.</0>", "summerchallenge.dashboard_banner.text": "Aloita kesä Yogoben kanssa – liity mukaan haasteeseen #yogobesummerchallenge", "summerchallenge.form.title": "Yogobe Spring Challenge", "summerchallenge.info.excerpt": "Toivotamme sinut tervetulleeksi neljän viikon haasteeseen, jonka tarkoitus on inspiroida sinua joogapolullasi – olitpa sitten aloittelija tai jo kokeneempi joogi. Voit valita kahdesta ohjelmasta mieleisesi (lisää infoa alla). Harjoitustasi kannattelevat pohjoismaiden johtavat opettajat ja asiantuntijat ja saat joka viikko 10 uutta inspiroivaa videota, joista valita mieleisesi (tunteja, luentoja ja tekniikkavideoita).  <h2>Päätä itse koska liityt haasteeseen</h2> Liity haasteeseen, kun sinulle parhaiten sopii. Kirjautuminen on avoinna 15.6–15.8.2020 välisenä aikana ja aloituspäivästä alkaen haaste on käynnissä neljän viikon ajan. Sisältö on nähtävissä sivulla Yleiskatsaus heti haasteen aloitettuasi 30.9.2020 asti.  <h2>Valitse ohjelmasi</h2>   Haaste tarjoaa kaksi erilaista ohjelmaa, joiden avulla saat mahdollisuuden löytää oman flowsi, kerätä lisää energiaa ja kehittää itseäsi. Alla lisäinfoa ohjelmista. Haaste toteutuu myös Ruotsissa – tutustu sisarhaasteeseen <a href=\"/se/summerchallenge\" target=\"_blank\">klikkaamalla</a> tästä!    <ul>   <li>     <bold>Joogapolulle</bold> - sinulle joka olet kiinnostunut kurkistamaan joogan ja meditaation maailmaan ja halukas tuomaan lisää itsemyötätuntoa elämääsi. Haaste tutustuttaa sinut joogan eri tyylisuuntiin ja mindfulnessharjoituksiin sekä inspiroi ja motivoi sinua ylläpitämään päivittäisen harjoituksen.   </li>    <li>     <bold>Kehomielen yhteys</bold> - sinulle joka haluat vahvistaa yhteyttä kehomieleen näinä epävarmuuden aikoina, jolloin mieli voi olla täynnä stressiä ja ahdistusta. Tämä haaste on lempeä kutsu takaisin kehoon erilaisten kehomieli –yhteyttä vahvistavien harjoitusten kautta, jotka lisäävät myös notkeutta ja liikkuvuutta.   </li> </ul>", "summerchallenge.info.rest": "<h2>Mahdollisuus voittaa palkinto </h2> Suorittaessasi vähintään kolme videota viikossa saatat olla yksi kymmenestä, jotka voittavat vuoden ilmaisjäsenyyden Yogobeen ja valitsemansa onlinekurssin (arvo 250€).  <h2>Kuka voi osallistua haasteeseen?</h2> Kuka vain! Osallistuaksesi sinun täytyy vain rekisteröityä Yogobeen. Kaikki uudet jäsenet ja jäsenet, jotka eivät ole aktiivisia tai maksavia jäseniä, saavat yhden kuukauden tarjoushintaan 9,99€. Tämä oikeuttaa pääsyn mukaan molempiin haasteisiin ja lisäksi koko videokirjaston sisältöön (+1600 videota, +45 ohjelmaa, satoja soittolistoja jne.). Tilaus jatkuu automaattisesti kuukausitilauksena (19,99€), jos et peru sitä. Uudet jäsenet saavat automaattisesti 14 vuorokauden ilmaisen kokeilujakson 30:n vuorokauden lisäksi (normaalihinta 9,99€).  <h2>Saa tukea ja inspiraatiota haasteen aikana</h2> Jaa kehitystäsi haasteen aikana käyttämällä hashtagia #yogobesummerchallenge ja liity facebookryhmäämme #YOGA365, jossa saat tukea ja inspiraatiota muilta haasteeseen osallistuvilta sekä Yogoben tiimiltä.", "summerchallenge.info.title": "Joogaa ja liiku kanssamme koko kesän!", "summerchallenge.programsBody.more.body": "Suorittaessasi vähintään kolme videota viikossa saatat olla yksi kymmenestä, jotka voittavat vuoden ilmaisjäsenyyden Yogobeen ja valitsemansa onlinekurssin (arvo 250€).", "summerchallenge.programsBody.more.title": "Kilpailu!", "summerchallenge.programsBody.subtitle": "Aloita kesähaaste jo tänään!", "summerchallenge.programsBody.title": "Mikä ohjelma vastaa tarpeisiisi?", "summerchallenge.testimonials.title": "Ledande lärare och profiler guidar och peppar", "summerchallenge.thank_you.text": "Ihanaa, että päätit ottaa osaa #yogobesummerchallenge –haasteeseen! Seuraamme innolla matkaasi haasteen parissa seuraavien viikkojen aikana. Muista, että paras harjoitus on se, joka tulee tehtyä. Ole kiitollinen jokaisesta hetkestä, jonka omistat itsellesi.", "summerchallenge.usergroup1.disclaimer": "*kunhan sinulla on aktiivinen tilaus.", "summerchallenge.usergroup1.infoform": "Tämä haaste sisältyy aktiiviseen jäsenyyteesi. Aloita jo tänään!", "summerchallenge.usergroup1.mainbanner": ["Hei ", ["firstName"], ", tervetuloa Yogobe Summer Challengeen. Tämä haaste on ilmainen kaikille aktiivisille jäsenille - aloita jo tänään!"], "summerchallenge.usergroup2.disclaimer": "*Koskee sekä uusia että jo olemassaolevia jäseniä. Saat rajoittamattoman käyttöoikeuden videokirjastoon, haasteisiin ja kaikkiin ohjelmiin! (nomaalihinta 19,99e)", "summerchallenge.usergroup2.infoform": "Sinulla pitää olla vähintään 28 käyttöoikeuspäivää jäljellä tai jatkuva tilaus aloittaaksesi haasteen.", "summerchallenge.usergroup2.mainbanner": ["Hei ", ["firstName"], ", tervetuloa Yogobe Summer Challengeen. Aloita haaste hintaan 9,99e* jo tänään!"], "summerchallenge.usergroup3.disclaimer": "*Koskee sekä uusia että jo olemassaolevia jäseniä. Saat rajoittamattoman käyttöoikeuden videokirjastoon, haasteisiin ja kaikkiin ohjelmiin! (nomaalihinta 19,99e)", "summerchallenge.usergroup3.infoform": "Aloita haaste hintaan 9,99e* jo tänään", "summerchallenge.usergroup3.mainbanner": "Tervetuloa Yogobe Summer Challengeen. Aloita haaste hintaan 9,99e jo tänään!", "summerchallenge.video.extra": "Ekstra", "summerchallenge.video.repeat": "Kokeile uudestaan", "summerchallenge.video.technic": "Tekniikka", "surveys_2022.validation.maxlength": ["Voit kirjoittaa max ", ["length"], " merkkiä"], "surveys_2022.validation.minlength": ["A minimum of ", ["length"], " characters is required"], "surveys_2022.validation.required": "On tärkeää, että täytät tämän kohdan", "teacher_modal.go_to_profile": "Vieraile profiilissa", "teacher_modal.homepage": "Kotisivu", "teacher_modal.location": "Paikka", "teacher_modal.speciality": "Erikoisuus", "userlogin.logout": "Kirjaudu ulos", "userlogin.menu.cancelled_plan": "Keskeytetty tilaus", "userlogin.menu.expired_plan": "Aktivoimaton jäsenyys", "userlogin.menu.free_premium": "Premium-pääsyoikeus", "userlogin.menu.free_trial": "Kokeilujakso", "userlogin.menu.manage": "Muokkaa", "userlogin.menu.monthly_plan": "Kuukausijäsenyys", "userlogin.menu.no_plan": "Ei jäsenyyttä", "userlogin.menu.premium_plan": "Aktiivinen jäsenyys", "userlogin.menu.quarterly_plan": "Kvartaalijäsenyys", "userlogin.menu.renew": "Uusi", "userlogin.menu.upgrade": "Päivitä", "userlogin.menu.yearly_plan": "Vuosijäsenyys", "userlogin.my_dashboard": "Yleiskatsaus", "userlogin.my_favorites": "Suosikkini", "userlogin.my_playlists": "Soittolistani", "userlogin.my_stats": "Tilastoni", "userlogin.my_subscription": "Jäsenyys", "userlogin.settings": "Asetukseni", "usersubheader.dashboard": "Yleiskatsaus", "usersubheader.favorites": "Suosikit", "usersubheader.for_me": "Suositukset", "usersubheader.my_favorites": "Suosikkini", "usersubheader.my_playlists": "Soittolistani", "usersubheader.playlists": "Soittolistat", "usersubheader.statistics": "Statistiikka", "validation.DOBInvalid": "Kirjoita vuosiluku muodossa DD/MM/YYYY", "validation.DOBMax": "Sinun pitäisi olla X vuotta vanha", "validation.DOBMin": "Ethän ole ihan noin vanha?", "validation.email": "Anna toimiva sähköpostiosoite ", "validation.email_taken": "Käytät sähköpostiosoitetta, joka kuuluu Yogobeen rekisteröityneelle jäsenelle. Jatka kirjautumalla sisään!", "validation.firstNameMax": "Etunimi on liian pitkä", "validation.lastNameMax": "Sukunimi on liian pitkä", "validation.link": "Kirjoita koko URL-osoite", "validation.passwordConfirmNotMatch": "Salasana ei täsmää", "validation.passwordMax": "Salasanasi voi sisältää korkeintaan 18 merkkiä", "validation.passwordMin": "Tarkistathan, että uusi salasanasi sisältää vähintään 6 merkkiä", "validation.phone": "Kirjoita tähän puhelinnumero", "validation.required": "On tärkeää, että täytät tämän kohdan", "validation.user_social_already_exists": "The email associated with the social account you used already belongs to a Yogobe member. Please try logging in instead or signup using a different social account/email.", "video.bundle_video_banner": "Seuraava sisältö ei ole osa pakettiasi", "video.premium_msg": "60 sekunnin ilmainen esikatselu päättyi. Haluatko nähdä loput?", "video.preview_msg": "60 sekunnin ilmainen esikatselu käynnissä", "video.related_video_title": "Aiheeseen liittyvät videot", "video.video_not_found": "Videota ei löytynyt", "video_cover_locked.Upgrade": "Päivitä", "video_cover_locked.login": "Kirjaudu sisään", "video_cover_locked.register": "Luo tili", "video_settings_banner.info": "Muokkaa Yogobe-kokemustasi! Videoasetuksista voit vaihtaa kieltä, taitotasoa ja videon tyyppiä.", "videos.beyoga365.description": "Teema- ja intentiokuukaudet", "videos.beyoga365.title": "BEYOGA365", "videos.blog_posts_title": "Inspiraatiota blogistamme", "videos.get_started_section.title": "Haluan kokeilla", "videos.playlists_recommended.title": "Sinulle suositeltuja soittolistoja", "videos.programs.title": "Harjoitteluohjelmat", "videos.quickstart.suggestions": "Ehdotuksia sinulle", "videos.weekly_picks.title": "Viikon poiminnat", "videos.yogamom365.description": "Teema- ja intentiokuukaudet", "videos.yogamom365.title": "YOGAMOM365", "videosGenres.discover": ["Tutki henkilön ", ["name"], " muita videoita"], "videosGenres.sessions": "Tuokiot", "videos_genres.count": [["count"], " tulosta"], "videos_genres.keyword": ["avainsanalla \"", ["keyword"], "\""], "videos_genres.settings_button": "Videoasetukset", "weeklyProgram.course_survey.locked": "Liity kurssille ja pääset mukaan tähän kyselyyn.", "weeklyProgram.document.locked": "weeklyProgram.document.locked", "weeklyProgram.document.open_document": "Avaa tiedosto.", "weeklyProgram.introduction.label": "Esittely", "weeklyProgram.program_survey.locked": "Liity ohjelmaan ja pääset mukaan tähän kyselyyn.", "weeklyProgram.survey.locked": "weeklyProgram.survey.locked", "weeklyProgram.week.number": ["Viikko ", ["number"]], "weeklyProgram.week.videos_duration": [["videosCount"], " videota - ", ["duration"]], "weeklyProgram.week_progress.text": "Edistyminen näyttää miten monta videota olet tällä viikolla suorittanut.", "weeklyProgram.weekly_progress.program_content": "Ohjelman sisältö", "yearlyfall2021.yearly_subscription_description": " Uusiutuu joka vuosi. Päivitä ennen 11. lokakuuta ja saat ilmaisen joogamaton." } };

/***/ }),

/***/ 85967:
/***/ (function(module) {

/*eslint-disable*/module.exports = { messages: { "An account verification email has been sent to {0}": ["An account verification email has been sent to ", ["0"]], "LegacyPaymentModal.choose_a_payment_method": "Choose a payment method", "The terms and conditions must be accepted.": "The terms and conditions must be accepted.", "WeeklyProgram.moodtracker.post.description": "WeeklyProgram.moodtracker.post.description", "WeeklyProgram.moodtracker.post.start_button": "WeeklyProgram.moodtracker.post.start_button", "WeeklyProgram.moodtracker.post.title": "WeeklyProgram.moodtracker.post.title", "WeeklyProgram.moodtracker.pre.description": "WeeklyProgram.moodtracker.pre.description", "WeeklyProgram.moodtracker.pre.start_button": "WeeklyProgram.moodtracker.pre.start_button", "WeeklyProgram.moodtracker.pre.title": "WeeklyProgram.moodtracker.pre.title", "access_code_modal.checkmark_activate": "Aktivera", "access_code_modal.code_error": "Felaktig accesskod. Vänligen försök igen!", "access_code_modal.code_success": "Din accesskod har registrerats", "access_code_modal.code_success_access": ["Fantastiskt! Nu har du tillgång till ", ["companyName"], "’s utvalda innehåll hos Yogobe"], "access_code_modal.code_success_redirect": "Du kommer nu att skickas tillbaka till översiktssidan om...", "access_code_modal.description": ["Medarbetare hos, eller partners till ", ["companyName"], " får åtkomst till detta material genom att fylla i sin unika accesskod."], "access_code_modal.input_label": "Accesskod", "access_code_modal.title": ["Få tillgång till ", ["companyName"], "'s dedikerade innehåll på Yogobe"], "account.verification_email_resent": ["Ett aktiveringsmail har skickats till ", ["email"]], "banner.action": "Ja tack", "banner.action2": "Ge oss feedback", "banner.body": "Använd det gamla videobiblioteket?", "banner.castBanner": "Nu kan du se videor från din mobila enhet på din TV via Airplay och Chromecast. (Tyvärr stödjer inte Chromecast iOS-enheter ännu).", "banner.companyFavorites": "Allt du favoritmarkerar kommer synas publikt och som rekommenderat innehåll under fliken Översikt", "banner.course_maintenance": "Vi gör underhåll och uppdateringar på Yogobes fördjupningskurser under kvällen och natten. Tyvärr kan du inte vara inne på din kurs medan vi gör detta arbete och är tacksamma för din förståelse. Välkommen åter imorgonbitti!", "banner.download_chrome": "När du tittar på en video kan du ibland uppleva problem med din webbläsare. Vi rekommenderar varmt att du använder ", "banner.download_chrome_action": "Google Chrome", "banner.email_verify": ["Bekräfta din mailadress (", ["email"], ") och aktivera ditt medlemskap för obegränsad access. Har du inte fått aktiveringsmailet? <0>Klicka här</0>"], "banner.email_verify_change_settings": "Verifiera att du uppdaterat din medlemsinformation. Har du inte fått bekräftelsesmailet? <0>Klicka här</0>", "banner.monthlyCourseOffer": "Under oktober månad har vi 50% rabatt på två utvalda onlinekurser. Klicka här!", "banner2.body": "Du är aktiv på ett av våra nya program. Ge oss gärna feedback och hjälp oss utvecklas", "banner_subscribe.go_premium": "Uppgradera konto", "banner_subscribe.header": "Vill du få obegränsad tillgång till vårt videobibliotek?", "blog.title": "Blogg", "bundle.dashboard_card.access_expired": "Tilgangen er avsluttet", "bundle.get_started..access_code.show_text": "If you have an access code, <0>click here</0>", "bundle.get_started.access_code.info_text": "Skriv inn tilgangskode.", "bundle.get_started.access_code.label": "Har du mottatt en tilgangskode?", "bundle.get_started.access_code.not_valid": "Tilgangskoden du skrev inn kan ikke aktiveres. Dette er enten fordi det allerede har blitt brukt av deg én gang, eller at den ikke lenger er gyldig for denne temasiden. Ved spørsmål, ta kontakt via info@yogobe.com", "bundle.get_started.access_code.tooltip_text": "Har du mottatt en tilgangskode via en av våre partnere? Fyll ut dette for å ta del i innholdet.", "bundle.get_started.access_code.valid": "Tilgangskoden er gyldig", "bundle.get_started.activation_failed_error": "Aktivering av temaside mislyktes. Vennligst prøv igjen, eller kontakt oss på <0></0>", "bundle.get_started.button.get_started": "Kom i gang", "bundle.get_started.button.login": "Logga in och fortsätt", "bundle.get_started.button.register": "Bli medlem och fortsätt<<<<<<< HEAD", "bundle.get_started.by_code_description": "Denne temasiden er kun tilgjengelig via en tilgangskode. Hvis du har en tilgangskode, kan du skrive inn den nedenfor.", "bundle.get_started.description": "Du trenger en tilgangskode for å få tilgang til innholdet", "bundle.get_started.for_all_description": "Denne temasiden er gratis for alle. Klikk \"Kom i gang\" for å få tilgang til innholdet.", "bundle.get_started.for_premium_description": "Denne temasiden er inkludert for deg som både har et aktivt abonnement og en tilgangskode. Hvis du har en tilgangskode, skriv den inn nedenfor.", "bundle.get_started.for_subscription_only": "Denne temasiden inngår for deg med et aktivt Yogobe Play-abonnement.", "bundle.get_started.guest.welcome_message": ["Velkommen til ", ["bundle_name"]], "bundle.get_started.guest_description": ["Velkommen til ", ["bundle_name"], "! Vi er glade for at du ønsker å delta på denne temasiden - logg inn eller opprett en konto for å fortsette. Innholdet er tilgjengelig via en tilgangskode fra din arbeidsgiver."], "bundle.get_started.guest_title": "Ta del på temasiden", "bundle.get_started.snackbar.access_granted": "Du har nå tilgang til dette innholdet.", "bundle.get_started.user.welcome_message": ["Hei ", ["name"], ", velkommen til ", ["bundle_name"]], "bundle.get_started.verify_account_banner": "Verify your account to be able to join the bundle.", "bundle.id_page.blog_sections.title": "Blogg", "bundle.id_page.challenge.discover_button": "Ta del i utfordringen", "bundle.id_page.challenges_sections.title": "Utfordringer", "bundle.id_page.documents.required_access": "Du trenger gyldig tilgang for å se dette dokumentet", "bundle.id_page.documents_sections.title": "Dokument", "bundle.id_page.hero.access_until_text": ["Du har ubegrenset tilgang til dette innholdet opptil ", ["accessUntil"]], "bundle.id_page.hero.client_text": ["Eksklusivt for medlemmer av ", ["clientName"]], "bundle.id_page.hero.extend_access": "Utvid tilgangen", "bundle.id_page.hero.get_access_btn": "Få tilgang", "bundle.id_page.hero.options_menu": "Alternativ", "bundle.id_page.hero.tooltip_text": "Få tilgang til dette innholdet i neste trinn. <b>For innhold eksklusivt for medlemmer av en Yogobe-partner</b> - vennligst skriv inn din unike tilgangskode når du logger på eller etter at du har opprettet en konto. <b>For innhold eksklusivt for Yogobe-medlemmer</b> - vennligst logg inn på kontoen din eller opprett en konto, du trenger en aktiv prøve-periode eller et betalende abonnement for å få tilgang.", "bundle.id_page.live_sections.title": "Live event", "bundle.id_page.playlists_sections.title": "Playlists", "bundle.id_page.program.discover_button": "Ta del i programmet", "bundle.id_page.programs_sections.title": "Program", "bundle.id_page.videos_sections.title": "Video og lyd", "button.spring_challenge.end": "Joina Yogobe Summer Challenge", "button.winter_challenge.end": "Joina Yogobe Spring Challenge", "button_add_to_playlist.hidden": "Dold", "button_add_to_playlist.private": "Privat", "button_add_to_playlist.public": "Publik", "buy_gift.send_email_directly_label": "buy_gift.send_email_directly_label", "campaign.infos_show_less": "Visa färre", "campaign_info.read_less": "Dölj text", "campaign_info.read_more": "Läs mer", "cancel_subscription_modal_four.paragraph": "Vi önskar dig glada äventyr och ser fram emot att välkomna dig tillbaka till oss!", "cancel_subscription_modal_four.title": "Det är tråkigt att du inte har möjlighet att fortsätta vara en aktiv medlem hos oss", "cancel_subscription_modal_one.button_one": "Gå tillbaka. jag har ändrat mig", "cancel_subscription_modal_one.button_two": "Ja, avbryt min prenumeration", "cancel_subscription_modal_one.paragraphe_one": ["Om du väljer att avbryta din prenumeration idag så kommer du med start ", ["date"], " inte ha obegränsad åtkomst till vårt videobibliotek."], "cancel_subscription_modal_one.paragraphe_two": "Vi arbetar ständigt med att utveckla och förbättra vår tjänst och sätter stort pris på din feedback och tankar.", "cancel_subscription_modal_one.title": "Är du säker på att du vill avbryta din prenumeration?", "cancel_subscription_modal_three.button_activate": "Aktivera 7 gratisdagar och stanna kvar", "cancel_subscription_modal_three.paragraph": "Får vi lov att erbjuda dig 7 gratisdagar med Yogobe?", "cancel_subscription_modal_three.title": "Jag har inte haft tid", "cancel_subscription_modal_two.checkbox1": "Jag har svårt att hitta videor och vägledning som passar mig", "cancel_subscription_modal_two.checkbox2": "Jag har inte haft tid", "cancel_subscription_modal_two.checkbox3": "Jag har ingen möjlighet att prioritera Yogobe just nu", "cancel_subscription_modal_two.checkbox4": "Annan anledning", "cancel_subscription_modal_two.title": "Varför väljer du att avbryta din prenumeration idag?", "cast_modal.subtitle": "för att kunna casta, uppgradera ditt medlemskap till en prenumeration och få obegränsad tillgång till hela videobiblioteket, program och mycket mer!", "cast_modal.title": "Denna funktion är tillgänglig för betalande medlemmar", "cast_modal.view_offers": "Se erbjudanden", "challenge.week.infobar": "Slutför tre sessioner/videor varje vecka under fyra veckor för att fullfölja utmaningen OBS: De videor du tittar på via ChromeCast kan våra system tyvärr inte registrera som slutförda.", "challenge_2021.banner.discount_text": "Betala bara 99 SEK för min första månad*", "challenge_2021.banner.verify_account": "Bekräfta ditt konto genom att verifiera din mailadress. Då kan du direkt joina Yogobe Challenge", "challenge_2021.challenges_section.title": "Velg en utfordring", "challenge_2021.contact.contact_text": "Kontakt: <0>business@yogobe.com</0>", "challenge_2021.contact.desc": "Vad roligt att du och din organisation är intresserade av att komma igång med Yogobe Challenge. Digitalt, demokratiskt, lättillgängligt och enkelt att komma igång. Tillsammans med Yogobe tar vi fram innehåll och stöd med syfte att främja såväl fysisk och mental hälsa inom företag och organisationer för individ och medarbetare. Just detta format är perfekt för team som träffas remote och arbetsplatser där man önskar inspiration och vägledning för rörelse i vardagen. Inom Yogobe Challenge ryms fem 4-veckorsprogram för olika intressen och behov - det finns alltså något för alla. För att komma igång, kontakta mig via email!", "challenge_2021.contact.purchase_banner_back": "Tillbaka", "challenge_2021.contact.title": "Hej, välkommen till Yogobe Challenge! ", "challenge_2021.features_section.title": "Vad är du i behov av?", "challenge_2021.get_started.button.continue": "Gå vidare", "challenge_2021.get_started.button.continue_trial": "Fortsätt med 14 dagar gratis", "challenge_2021.get_started.button.start_suscription": "Inled en prenumeration", "challenge_2021.get_started.button.upgrade_continue": "Uppgradera och gå vidare", "challenge_2021.get_started.description": "Vi är glada över att du vill joina detta program. Program och utmaningar ingår i Yogobe's prenumerationer samt företagspaket. Klicka på knappen \"Starta programmet\" nedan för att ta del av innehållet.", "challenge_2021.get_started.guest_title": ["Välkommen till ", ["program"]], "challenge_2021.get_started.option.have_account": "Jag har redan ett medlemskonto", "challenge_2021.get_started.option.no_account": "Jag har inget medlemskonto", "challenge_2021.get_started.show_code_input": "Har du fått tillgång till programmet genom din arbetsplats eller en organisation och fått en accesskod? <0>Klicka här</0>", "challenge_2021.get_started.show_code_input_description": "Detta är en kod som du får genom din arbetsplats, organisation, kundklubb eller liknande.", "challenge_2021.get_started.user_title": ["Hej ", ["name"], ", välkommen till ", ["program"]], "challenge_2021.get_started_loggedin.description": "Vi är glada över att du vill joina detta program. Program och utmaningar ingår i Yogobe's prenumerationer samt företagspaket. Klicka på knappen \"Starta programmet\" nedan för att ta del av innehållet.", "challenge_2021.listing_page.hero.no_premium_desc": "Velkommen til Yogobe Challenge. Du får ubegrenset tilgang til alle Challenge-programmer når du starter et månedlig abonnement fra SEK 99*.", "challenge_2021.listing_page.hero.no_premium_disclaimer": "*Detta pris gäller för din första månad och övergår automatiskt till ord. pris 189 SEK/mån.", "challenge_2021.listing_page.hero.premium_desc": "Velkommen til Yogobe Challenge! Hold deg motivert og prioriter helsen din ved å utfordre deg selv med et av programmene nedenfor.*", "challenge_2021.listing_page.hero.premium_disclaimer": "*Så länge du har en aktiv prenumeration eller accesstid så har du åtkomst till program och utmaningar.", "challenge_2021.listing_page.hero.title": "Yogobe Challenge <0>Nyhet</0>", "challenge_2021.metadata.browse_challenges": "Utforska programmen", "challenge_2021.metadata.explore_challenges_btn": "Utforsk de ulike utfordringene", "challenge_2021.metadata.get_started_btn": "Kom igång", "challenge_2021.metadata.how_it_works_btn": "Hvordan virker det?", "challenge_2021.metadata.start_now_btn": "Starta nu för bara 99 SEK*", "challenge_2021.metadata.tags.challenge": "Challenge", "challenge_2021.metadata.tags.participating": "Deltar", "challenge_2021.steps_section.step1.desc": "Välj det program som låter mest lockande. Vi strävar alltid efter att möta medlemmars behov.", "challenge_2021.steps_section.step1.title": "1. Välj ditt program och utmaning", "challenge_2021.steps_section.step2.desc": "Htta det program som du vill börja med, aktivera din access och starta direkt!", "challenge_2021.steps_section.step2.title": "2. Starta din utmaning", "challenge_2021.steps_section.step3.desc": "Försök ta minst 3 klasser varje vecka i fyra veckor för god regelbundenhet.", "challenge_2021.steps_section.step3.title": "3. Utmana dig själv", "challenge_2021.steps_section.step4.desc": "När du har genomfört ditt program och slutfört din utmaning så får du gärna fortsätta med dessa videor i vardagen eller välja ett nytt program!", "challenge_2021.steps_section.step4.title": "4. Vidhåll en god vana", "challenge_2021.steps_section.title": "En steg för steg guide", "challenge_form.already_applied": ["Vi är snart igång! Du har fått ett mail skickat till ", ["email"], ". Vid frågor kontakta info@yogobe.com"], "challenge_form.already_applied_paragraph": ["Har du inte mottagit mejlet? <0>Klicka här för att skicka igen. (", ["count"], "s)</0>"], "challenge_form.didnt_apply": "Du kan byta program i utmaningen", "challenge_form.didnt_apply_1": ["Hej ", ["firstName"], ", fyll i formuläret och få fullständig tillgång till ", ["title"], "!"], "challenge_form.didnt_apply_2": ["Fyll i formuläret och få fullständig tillgång till ", ["title"], "!"], "challenge_form.email": "Email", "challenge_form.errors.email_used": "E-postadressen du angav används redan. Om den tillhör dig, vänligen logga in.", "challenge_form.errors.required": "Detta fält är obligatoriskt", "challenge_form.first_name": "Förnamn", "challenge_form.gotoprogram": "Gå till program", "challenge_form.inprogram": ["Du är aktiv i vår <0>", ["name"], "</0> programmet."], "challenge_form.last_name": "Efternamn", "challenge_form.level": "Program", "challenge_form.level_note": "Scrolla ner för att läsa mer", "challenge_form.login": "challenge_form.login", "challenge_form.reset_program": "Vill du byta program?  <0>Klicka här för att ändra</0>", "challenge_form.submit": "Kom igång", "company.access_code_action": "Skriv in din accesskod", "company.empty_company_programs_courses": ["Skriv in din accesskod för att se ", ["companyName"], "’s program och kurser"], "company.playlists_description": ["Playlists är samlingar av video- och audiofiler från Yogobes videobibliotek som satts samman av ", ["companyName"]], "company.recommended_blog_posts": "Rekommenderade blogginlägg", "confirm_delete_playlist_modal.description": ["Du håller på att radera din playlist: <0>", ["title"], "</0> som innehåller ", ["videos_count"], " sessioner. Du kan inte ångra detta. Är du säker på att du vill fortsätta?"], "confirm_delete_playlist_modal.no": "Nej, behåll min playlist", "confirm_delete_playlist_modal.title": "Ta bort playlist", "confirm_delete_playlist_modal.yes": "Ja, jag vill ta bort denna playlist", "consent.cookies.accept": "Godta informasjonskapsler", "consent.cookies.desc": "Vi bruker våre egne og tredjeparts informasjonskapsler for å tilpasse innholdet slik at det passer deg, og for å forbedre tjenesten vår ved å analysere webtrafikk.", "consent.cookies.read_more": "Les mer om informasjonskapsler", "consent.cookies.reject": "Avvise", "consent.cookies.title": "Vi bruker informasjonskapsler", "courses_2021.banner.verify_account": "Bekräfta din mailadress och aktivera ditt medlemskap.", "courses_2021.buy_gift.banner_text": "Du köper nu denna kurs som en gåva till någon annan. Om det är du själv som vill få access, <0>klicka här</0>", "courses_2021.buy_gift.description": "Vi är glada att du vill ge denna kurs som gåva till en vän!", "courses_2021.buy_gift.description_tooltip": "Efter genomförd betalning så får du ett email innehållande en unik köpkod och instruktioner hur kursen aktiveras", "courses_2021.buy_gift.meta_title": ["Yogobe kurs - ", ["title"]], "courses_2021.contact.contact_text": "Kontakt: <0>business@yogobe.com</0>", "courses_2021.contact.desc": "Vad roligt att du och din organisation är intresserade av att komma igång med Yogobe. Digitalt, demokratiskt, lättillgängligt och enkelt att komma igång. Tillsammans tar vi fram och skräddarsyr innehåll och stöd med syfte att främja såväl fysisk och mental hälsa inom företag och organisationer för individ och medarbetare. Ett programformat är perfekt för team som träffas remote och arbetsplatser där man önskar inspiration och vägledning för rörelse i vardagen där allas olika intressen och behov tas i beaktning - det finns alltså något för alla. För att komma igång, kontakta mig via email!", "courses_2021.contact.purchase_banner_back": "courses_2021.contact.purchase_banner_back", "courses_2021.contact.title": "Velkommen til Yogobes onlinekurs!", "courses_2021.expiration_banner.expire_soon.buy_program_text": ["Din access till denna kurs går ut om ", ["days"], " dagar. Förläng redan idag för att fortsätta ha access i ytterligare en period. Din tidigare data följer givetvis med."], "courses_2021.expiration_banner.expire_soon.renew_access_free_text": ["Din access till denna kurs går ut om ", ["days"], " dagar. Du är välkommen att förnya och förlänga helt utan kostnad! Din tidigare data har sparats."], "courses_2021.expiration_banner.expire_soon.upgrade_to_renew_text": ["Din access till denna kurs går ut om ", ["days"], " dagar. Uppgradera till en betalande prenumeration så ingår obegränsad tillgång till denna kurs. Din tidigare data sparas."], "courses_2021.expiration_banner.expired.buy_program_text": ["Din access till detta program gich ut för ", ["days"], " dagar sedan. Du är välkommen att förnya och förlänga! Din tidigare data har sparats."], "courses_2021.expiration_banner.expired.renew_access_free_text": ["Din access till detta program gich ut för ", ["days"], " dagar sedan. Förnya och förläng idag utan kostnad. Din tidigare data har sparats."], "courses_2021.expiration_banner.expired.renew_with_discount_text": ["Din access till denna kurs gick ut för ", ["days"], " sedan. Förnya för ytterligare en period och få ", ["discount"], " rabatt. Givetvis är din tidigare data sparad. <0>Betalar du med friskvårdsbidrag?</0>"], "courses_2021.expiration_banner.expired.upgrade_to_renew_text": ["Din access till denna kurs gick ut för ", ["days"], " dagar sedan. Du är välkommen att förnya och förlänga helt utan kostnad!"], "courses_2021.expiration_banner.expires_soon.extend_with_discount_text": ["Din access till denna kurs går ut om ", ["days"], " dagar. Förläng redan nu för en till period och få ", ["discount"], " rabatt. Givetvis sparas din data. <0>Betalar du med friskvårdsbidrag?</0>"], "courses_2021.get_started.access_code.icon_text": "Skriv in din unika kod i denna textruta", "courses_2021.get_started.access_code.not_valid": "Koden du angav är ogiltig! ", "courses_2021.get_started.access_code.tooltip_text": "Du kan använda olika sorters koder hos Yogobe för att ge dig antingen åtkomst eller rabatt på olika delar av vårt innehåll.   Accesskod: En kod som man får via en arbetsgivare eller partnerorganisation till Yogobe.  Presentkort: En kod som du kan ha fått från en vän.  Rabattkod:  En kod som ger dig en specifik rabatt på utvalt innehåll hos Yogobe.", "courses_2021.get_started.access_code.valid": "Koden har registrerats", "courses_2021.get_started.access_code_mismatch": "Denna kod är giltig men aktiverar en annan kurs", "courses_2021.get_started.access_code_only_description": "Välkommen! <br/> Du kommer enbart åt denna kurs via en accesskod som du får antingen direkt från Yogobe eller via en partner till oss så som du arbetsgivare eller förening.", "courses_2021.get_started.activation_error": "Vi lyckas tyvärr inte aktivera din kurs åt dig. Snälla skriv till oss på info@yogobe.com och uppge gärna den mailadress som är kopplad till ditt konto hos oss.", "courses_2021.get_started.button.activate_for_free": "Aktivera", "courses_2021.get_started.button.continue_trial": "Fortsätt med 14 dagar gratis", "courses_2021.get_started.button.login": "Logga in och gå vidare", "courses_2021.get_started.button.purchase": "Fortsätt till säker betalning", "courses_2021.get_started.button.start_suscription": "Inled en prenumeration", "courses_2021.get_started.code_label": "Din unika kod", "courses_2021.get_started.description": "Välkommen! <br/> Du startar denna kurs antingen genom betalning, presentkort eller accesskod!", "courses_2021.get_started.end_of_access": "Åtkomst till", "courses_2021.get_started.guest_title": ["Välkommen till ", ["program"]], "courses_2021.get_started.join_btn": "Inled kursen", "courses_2021.get_started.option.have_account": "Jag har redan ett medlemskonto", "courses_2021.get_started.option.no_account": "Jag har inte ett medlemskonto", "courses_2021.get_started.purchase_banner_text": "Företräder du ett företag eller organisation som vill utforska digitala program för friskvård och hälsa? <0>Klicka här</0>", "courses_2021.get_started.show_code_input": "Har du en unik kod? <0>Klicka här</0>", "courses_2021.get_started.show_code_input_description": "En kod kan vara antingen en accesskod, ett presentkort eller ge dig en viss rabatt.", "courses_2021.get_started.user_title": ["Hej ", ["name"], ", välkommen till ", ["program"]], "courses_2021.get_started_loggedin.description": "Välkommen! <br/> Du startar denna kurs antingen genom betalning, presentkort eller accesskod!", "courses_2021.header.access_until": ["Du har kurs-access fram till ", ["date"]], "courses_2021.listing_page.hero.no_premium_disclaimer": "Betalar du med friskvårdsbidrag? <0>Läs mer</0>", "courses_2021.listing_page.hero.premium_disclaimer": "Betalar du med friskvårdsbidrag? <0>Läs mer</0>", "courses_2021.listing_page.meta.description": "Välkommen till Yogobes kurser – Tillsammans med ledande profiler och experter erbjuder vi utöver videobiblioteket och vår prenumerationstjänst specialframtagna och nischade kurser för att möta specifika önskemål och behov. Du betalar en gång för en kurs och får access i upp till 12 månader. Givetvis kan du gå flera kurser samtidigt om så önskas.", "courses_2021.listing_page.meta.title": "Yogobe Kurser", "courses_2021.listings_page.clear_events_filters": "Rensa Filter och Sök", "courses_2021.listings_page.explore_programs_btn": "Utforska kurser", "courses_2021.listings_page.faq_btn": "FAQ", "courses_2021.listings_page.filters.languages": "Visa mig kurser på", "courses_2021.listings_page.hero_title": "Yogobe Kurser", "courses_2021.listings_page.load_more_btn": "Visa fler kurser", "courses_2021.listings_page.no_programs_found": "Hoppla! Vi lyckas inte hitta ett program som är en perfekt match på ditt/dina sökord eller valda filter. Det som du letar efter kan fortfarande finnas hos oss. Snälla förnya din sökning eller ändra dina video- och filterninställningar!", "courses_2021.listings_page.search_input_placeholder": "Sök bland kurser...", "courses_2021.listings_page.subtitle": "Utöver Yogobe Play, vår prenumerationstjänst, erbjuder vi specialframtagna och nischade onlinekurser. Vi gör detta tillsammans med ledande profiler och experter för att möta specifika önskemål och behov. Du betalar för en kurs en gång och får access i upp till 12 månader. Givetvis kan du delta i flera kurser samtidigt.", "courses_2021.other_courses": "Andra kurser", "courses_2021.program_page.breadcrumb": "Yogobe kurser", "courses_2021.progress_page.parts_title": "Kursinnehåll", "courses_2021.progress_page.video_lock.button_text": "Delta i kursen", "courses_2021.progress_page.video_lock.text": "Du har precis sett en förhandsvisning på 60 sekunder. Vill du logga in eller starta denna kursen nu?", "courses_2021.snackbars.access_granted": "Du har nu aktiverat denna kurs", "courses_listing.faq.item1.body": "Våre onlinekurs er ikke inkludert i vår abonnementstjeneste her på Yogobe, men kjøpes separat. Det betyr at hvem som helst kan ta et onlinekurs hos oss, uansett om du er betalende medlem eller ikke. Alt du trenger er en Yogobe-konto for å kunne delta på kurset ditt.", "courses_listing.faq.item1.title": "Hvem kan delta på nettkurs?", "courses_listing.faq.item10.body": "Kursene våre har nå en lignende design og struktur som våre treningsprogrammer og utfordringer. Den nye strukturen er laget for å gjøre det lettere for deg å delta på et kurs, og du kan nå følge fremgangen din på en ny måte. <br/><br/> Under hvert kurs er det to faner, «Oversikt» og «Min utvikling». Under \"Oversikt\" finner du all informasjon om kurset og får en oversikt over hver uke/del som inngår. Under «Min fremgang» kommer du til en visning hvor du enkelt kan se hvilke videoer som hører til hvilken uke/del og hva du allerede har gjennomført. Det er her du deltar på kurset og vil kunne ta del i timer, øvelser, forelesninger og fordype deg i lesning.", "courses_listing.faq.item10.title": "Hva innebærer den nye kursdesignen og strukturen?", "courses_listing.faq.item11.body": "Dersom du ikke velger å fornye kurset ditt, til en rabattert pris, mister du tilgangen til kurset etter at tilgangsperioden er utløpt. Fremgangen din i kurset er imidlertid lagret, dersom du ønsker å forlenge tilgangstiden deretter. Du får 30 % rabatt på fornyelsen din, selv etter at tilgangsperioden er utløpt.", "courses_listing.faq.item11.title": "Hva skjer når tilgangstiden min er utløpt?", "courses_listing.faq.item12.body": "Hvis du ønsker å delta på et kurs som er lengre enn tilgangsperioden, vanligvis opptil 12 måneder, men varierer fra kurs til kurs, kan du alltid kjøpe kurset på nytt med 30 % rabatt. Tilbudet er gyldig fra og med dine siste 30 tilgangsdager og utover, selv når tilgangsperioden din er utløpt. <br/> <br/>", "courses_listing.faq.item12.title": "Kan jeg få rabatt hvis jeg kjøper kurset på nytt?", "courses_listing.faq.item13.body": "Klikk på kurset. Øverst til høyre på siden finner du en stor boks, klikk på de tre prikkene i øvre høyre hjørne av boksen. Velg deretter \"Utvid tilgang\".", "courses_listing.faq.item13.title": "Hvordan utvider jeg tilgangen til et kurs?", "courses_listing.faq.item14.body": "1) Dersom du ønsker å gi bort et kurs du selv deltar på: <br/> Gå til kurset du ønsker å gi bort. Øverst til høyre på siden finner du en stor boks, klikk på de tre prikkene i øvre høyre hjørne av boksen. Klikk deretter på \"Kjøp som gave\". <br/><br/> 2) Dersom du ønsker å gi bort et kurs du selv ikke deltar på: <br/> Klikk på kurset du ønsker å gi bort og klikk deretter på \"Kjøp som gave\" link. <br/><br/> Et gavekort er gyldig i 12 måneder fra kjøpsdato.", "courses_listing.faq.item14.title": "Hva gjør jeg hvis jeg vil gi et kurs i gave?", "courses_listing.faq.item15.body": "Når et onlinekurs kjøpes med et engangsbeløp, kan ikke deltakelsen kanselleres. Kurset løper til tilgangstiden er utløpt.", "courses_listing.faq.item15.title": "Kan jeg avslutte min deltakelse på et kurs?", "courses_listing.faq.item16.body": "Klikk på kurset du har fått tilgangskode til. Klikk deretter på \"Start kurs\". <br/> Klikk på lenken i: «Har du en unik kode? Klikk her\". <br/> Fyll inn koden i boksen og klikk ✓.", "courses_listing.faq.item16.title": "Hvordan starter jeg et kurs med en tilgangskode?", "courses_listing.faq.item2.body": "Klikk på kurset du er interessert i å kjøpe. Inne i kurset - klikk på knappen \"Start kurset\" og fyll i betalingsinformasjonen din der. Du betaler et engangsgebyr via debetkort eller Vipps. Kurset aktiveres ved kjøp.", "courses_listing.faq.item2.title": "Hvordan kjøper jeg et kurs?", "courses_listing.faq.item3.body": "Som med vår abonnementstjeneste, kan du kjøpe et online-kurs med \"helse-bidrag\". Du kan kjøpe et kurs direkte på Yogobe.com og deretter skrive ut kvitteringen fra profilen din øverst til høyre på siden. Klikk på «Mine innstillinger» og deretter på «<a href=\"https://yogobe.com/se/me/settings/receipts\">Mine kvitteringer</a>». <br/></br> Hvis arbeidsgiveren din samarbeider med en av \"helse-everandørene\" <a href=\"https://yogobe.com/se/blog/friskvardsbidrag-benify\">Benify</a>, <a href= \"https ://yogobe.com/se/blog/friskvardsbidrag-wellnet\">Wellnet</a> eller <a href=\"https://yogobe.com/se/blog/friskvardsbidrag-epassi-minfriskvard\">ePassi< /a > – klikk på gjeldende leverandør for å lese mer om hvordan du kjøper et kurs der.", "courses_listing.faq.item3.title": "Kan jeg kjøpe kurs med \"helse-bidrag\"?", "courses_listing.faq.item4.body": "Ja absolutt! Våre onlinekurs er tilgjengelige hos helse-leverandørene <a href=\"https://yogobe.com/se/blog/friskvardsbidrag-benify\">Benify</a>, <a href=\"https://yogobe.com/se /blog /friskvardsbidrag-wellnet\">Wellnet</a> eller <a href=\"https://yogobe.com/se/blog/friskvardsbidrag-epassi-minfriskvard\">ePassi</a>. Les mer under den respektive lenken hvordan du kjøper kurs fra gjeldende leverandør.", "courses_listing.faq.item4.title": "Kan jeg kjøpe kurs gjennom en helse-leverandør?", "courses_listing.faq.item5.body": "Våre onlinekurs er ikke inkludert i våre abonnementer, men kjøpes separat mot en engangsavgift. Du trenger ikke ha et aktivt abonnement hos Yogobe for å kunne kjøpe og delta på våre onlinekurs, men du trenger å ha en Yogobe-konto, som du enkelt oppretter når du kjøper et kurs hvis du ikke allerede har en.", "courses_listing.faq.item5.title": "Er onlinekursene inkludert i abonnementet mitt?", "courses_listing.faq.item6.body": "Når du har kjøpt kurs hos oss har du tilgang til kurset i inntil 12 måneder fra den dagen du kjøpte kurset, uavhengig av kurslengde. Se det respektive kurset for tilgangstid.", "courses_listing.faq.item6.title": "Hvor lenge har jeg tilgang til et kurs jeg har kjøpt?", "courses_listing.faq.item7.body": "Når du har kjøpt et kurs, kan du alltid enkelt finne dine aktive kurs under <a href=\"https://yogobe.com/se/me/dashboard\">Oversikt</a> i profilen din. For å få tilgang til profilen din må du være logget på Yogobe-kontoen din.", "courses_listing.faq.item7.title": "Hvordan finner jeg et kurs jeg har kjøpt?", "courses_listing.faq.item8.body": "Foreløpig er kursene kun tilgjengelig via nettstedet Yogobe.com. Du kan selvfølgelig gå inn via en nettleser på smarttelefonen og få tilgang til programmet på mobilen på den måten.", "courses_listing.faq.item8.title": "Kan jeg delta på kursene i appen?", "courses_listing.faq.item9.body": "Selvfølgelig kan du det, du kan delta på akkurat så mange kurs du ønsker.", "courses_listing.faq.item9.title": "Kan jeg kjøpe og delta på flere kurs samtidig?", "createplaylist_modal.actions.primary": "Spara", "createplaylist_modal.actions.secondary": "Avbryt", "createplaylist_modal.description.label": "Beskrivning", "createplaylist_modal.description.placeholder": "Skapa en beskrivning för din playlist", "createplaylist_modal.hidden_helper": "Din playlist är dold", "createplaylist_modal.hidden_title": "Dold playlist", "createplaylist_modal.name.label": "Namn", "createplaylist_modal.name.placeholder": "Ge din playlist en rubrik", "createplaylist_modal.options.one": "Publik", "createplaylist_modal.options.three": "Privat", "createplaylist_modal.options.two": "Dold", "createplaylist_modal.privacy_helper": "Din profil är privat, men denna playlist syns fortfarande för alla då den är publik. <0>Ändra sekretessinställningar.</0>", "createplaylist_modal.private_helper": "Din playlist är privat", "createplaylist_modal.private_title": "Privat playlist", "createplaylist_modal.public_helper": "Din playlist syns i publika listningar och kan komma att föreslås till andra användare.", "createplaylist_modal.public_title": "Publik playlist", "dashboard.bundles_section.title": "Samlingssidene dine", "dashboard.challenges_section.description": ["Du deltar for øyeblikket i ", ["count"], " utfordringer"], "dashboard.challenges_section.discover": "Utforsk utfordringene våre", "dashboard.challenges_section.empty_list": "Du deltar just nu inte i några utmaningar>>>>>>> develop=======>>>>>>> master", "dashboard.challenges_section.explore_programs": "Utforsk utfordringene våre", "dashboard.challenges_section.title": "Dine utfordringer", "dashboard.courses_section.description": ["Du deltar för närvarande i ", ["count"], " kurser"], "dashboard.courses_section.discover": "Utforsk våre kurs", "dashboard.courses_section.empty_list": "Du deltar just nu inte i någon kurs", "dashboard.courses_section.explore_courses": "Utforska Yogobes kurser", "dashboard.courses_section.title": "Dina kurser", "dashboard.events_section.discover": "Oppdag kommende LIVE-klasser", "dashboard.events_section.empty_list": "Du er ikke booket til noen kommende LIVE-klasser", "dashboard.events_section.expired_events": "Gjennomførte LIVE klasser", "dashboard.events_section.explore": "Utforsk alle LIVE-klasser", "dashboard.events_section.show_previous_events": "Se mine fullførte klasser", "dashboard.events_section.title": "Dina bokade LIVE-event", "dashboard.for_me.courses.title": "Kurser för dig", "dashboard.for_me.playlists.title": "Dina rekommenderade playlists", "dashboard.for_me.programs.title": "Program för dig", "dashboard.for_me.videos.title": "Dina rekommenderade videor", "dashboard.last_watched_sessions_section.title": "Mine siste sett klasser", "dashboard.my_stats.beta_stripe_message": "Dette er en betaversjon og resultatene er kanskje ikke helt pålitelige. Jo mer du samhandler med tjenesten, jo flere datapunkter kan vi hente og illustrere for deg med f.eks. grafer og diagrammer. Dette er den første versjonen. Vårt mål er at du skal få en fin, oversiktlig og enkel oversikt over din Yogobe-bruk. Hvis du mangler noe, vennligst skriv og fortell oss på data@yogobe.com", "dashboard.my_stats.challenges_started": "Antall påbegynte utfordringer", "dashboard.my_stats.completed_sessions": "Antall gjennomførte sessioner", "dashboard.my_stats.courses_started": "Antall påbegynte kurs", "dashboard.my_stats.empty_result": "Ingen statistikk for noen ennå!", "dashboard.my_stats.explore_challenges": "Utforsk Yogobe-utfordringene!", "dashboard.my_stats.explore_courses": "Utforsk våre onlinekurs", "dashboard.my_stats.explore_library": "Utforsk Yogobe-biblioteket", "dashboard.my_stats.explore_live_events": "Utforsk Yogobe LIVE", "dashboard.my_stats.explore_programs": "Utforsk programmene våre", "dashboard.my_stats.explore_yogobe_team": "Utforsk Team Yogobe", "dashboard.my_stats.favorited_sessions": "Antall favorittmerkede sessioner", "dashboard.my_stats.live_events_booked": "Antall LIVE-arrangementer du har booket", "dashboard.my_stats.most_watched_instructors": "Topp 3 mest viste eksperter", "dashboard.my_stats.most_watched_styles": "3 mest viste stiler/treningsformer", "dashboard.my_stats.my_favorited_sessions": "Se mine favoritter", "dashboard.my_stats.my_playlists": "Se mine playlists", "dashboard.my_stats.period_month": "Siste 30 dager", "dashboard.my_stats.period_week": "Siste 7 dager", "dashboard.my_stats.playlists_created": "Antall spillelister opprettet", "dashboard.my_stats.programs_started": "Antall påbegynte programmer", "dashboard.my_stats.three_most_watched_styles": "Din lyd- og audiodeltakelse på minutter", "dashboard.my_stats.title": "Her samler vi inn din personlige interaksjonsstatistikk", "dashboard.pricing_description": "Vilken medlemsform passar dig?", "dashboard.pricing_title": "Bli prenumerant och få full åtkomst till vårt videobibliotek!", "dashboard.programs_section.description": ["Du deltar för närvarande i ", ["count"], " program"], "dashboard.programs_section.discover": "Utforsk programmene våre", "dashboard.programs_section.empty_list": "Du deltar just nu inte i något program", "dashboard.programs_section.explore_programs": "Utforska Yogobes program", "dashboard.programs_section.title": "Dina program", "dashboard.recommendation.empty.button": "Ändra preferenser", "dashboard.recommendation.empty.desc": "Berätta vad du har för behov och intressen så rekommenderar vi videor och playlists!", "dashboard.recommendation.empty.title": "Rekommenderade videor och playlists", "dashboard.recommendations.complete_onboarding": "Sätt igång", "dashboard.recommendations.content_languages": "Visa mig rekommenderat innehåll på:", "dashboard.recommendations.edit_preferences": "Ändra preferenser", "dashboard.recommendations.filter_default_label": "Filtrera efter intressen och behov", "dashboard.recommendations.meta_title": "Rekommenderat för dig", "dashboard.recommendations.title": "Ditt rekommenderade innehåll är baserat på de preferenser som du har valt. Du kan ändra dem när du vill. ", "dashboard.recommendations.view_recommendations": "Vill du hitta videor som möter dina behov och intressen? <0>Se dina rekommendationer</0>", "dashboard.recommendations.visit_recommendations": "Vill du snabbt och lätt hitta videor och playlists som möter dina behov och intressen?", "dashboard.settings.email_settings.desc": "Styr vilka email du önskar motta. Du kan när som helst ändra dessa inställningar.", "dashboard.settings.email_settings.title": "Hantera email-notifikationer", "dashboard.settings.email_update_failed": ["Det gick inte att spara denna mailadressen. Snälla prova igen eller skriv till oss på <0>", ["email"], "</0> så hjälper vi dig!"], "dashboard.settings.live_codes.banner_desc": "Velg ønsket LIVE-klasse og klikk <0>Bestill</0>. I neste trinn skriver du inn koden i feltet for <0>Tilgangskode</0> for å kunne delta gratis på LIVE-klassen! <0></0> PS. Kodene er unike for kontoen din og kan ikke deles med andre.", "dashboard.settings.live_codes.banner_title": "Hvordan bruke og aktivere en kode", "dashboard.settings.live_codes.code_label": "LIVE kode", "dashboard.settings.live_codes.desc": "=======>>>>>>> master", "dashboard.settings.live_codes.empty_text": "Du har for øyeblikket ingen gyldige tilgangskoder for Yogobe LIVE.", "dashboard.settings.live_codes.events": "Valgbare LIVE-events", "dashboard.settings.live_codes.expiration": ["Gyldig til ", ["date"]], "dashboard.settings.live_codes.multiple_usage_code_item": ["Bruk den ", ["usageDate"], " på ", ["title"], " med ", ["instructor"], "."], "dashboard.settings.live_codes.multiple_usage_code_left": ["Du kan fortsatt bruke denne koden ", ["availableUsage"], " ganger."], "dashboard.settings.live_codes.multiple_usage_code_summary": ["Denne koden har blitt brukt ", ["usedTimes"], " av ", ["usageLimit"], " klasser."], "dashboard.settings.live_codes.pannel.title": "=======>>>>>>> master", "dashboard.settings.live_codes.single_usage_code": ["Denne koden ble brukt ", ["usageDate"], " på ", ["title"], " med ", ["instructor"], "."], "dashboard.settings.live_codes.title": "Tilgangskoder for Yogobe LIVE", "dashboard.settings.live_codes.trial_panel.desc": "Som en del av prøveperioden vil du motta to tilgangskoder som du kan bruke på alle våre LIVE-klasser. <0>Utforsk Yogobe LIVE</0>", "dashboard.settings.live_codes.trial_panel.title": "Koder for å teste Yogobe LIVE", "dashboard.settings.live_codes.trial_panel.title_tooltip": "Disse to LIVE-kodene er inkludert i prøveperioden for Yogobe. De er gyldige i 60 dager fra det tidspunktet du opprettet kontoen din. <0>Utforsk Yogobe LIVE</0>", "dashboard.settings.live_codes.wellness_panel.desc": ["Du har kjøpt tilgangskoder for Yogobe LIVE gjennom ", ["provider"], ". Bruk disse på alle våre LIVE-klasser som er oppført nedenfor."], "dashboard.settings.live_codes.wellness_panel.desc<<<<<<< HEAD": ["Du har kjøpt tilgangskoder for Yogobe LIVE gjennom ", ["provider"], " den ", ["date"], " og har mottatt følgende tilgangskode. Dette kan brukes på alle våre LIVE-klasser som er oppført nedenfor.>>>>>>> develop=======>>>>>>> develop"], "dashboard.settings.live_codes.wellness_panel.title": "Bidrags-kode for Yogobe LIVE", "dashboard.settings.live_codes.wellness_panel.title_tooltip": "Dette er vanligvis en kode/pakke du har kjøpt gjennom en helse-portal.", "email_preferences.prefrences_updated": "email_preferences.prefrences_updated", "email_preferences_page.desc": "Styr vilka email du önskar motta från oss. Du kan när som helst ändra dessa inställningar genom att antingen klicka på länken längst ner i våra nyhetsbrev eller via din Översikt på Yogobe.com. ", "email_preferences_page.title": "Hantera email-notifikationer", "emptyresults.click_here": "Klicka här", "emptyresults.empty": "Hoppla... 0 resultat återfanns.", "emptyresults.empty_filter": "Vi kan inte hitta resultat som matchar din kompletta sökning. Kanske kan du justera den litegrann genom att ta bort taggar eller använda frisök-rutan? Observera att dina  <0>videoinställningar</0> för språk påverkar resultaten!", "emptyresults.to_clear_filters": "och rensa alla filter", "emptyresults.try_adjusting_or": "Utöka eller ändra din sökning för fler resultat, eller", "error.action": "Gå till Startsidan", "error.body_404_part1": "Du försöker få åtkomst till en sida hos Yogobe som inte finns.", "error.body_404_part2": "Något har alltså blivit fel, vänligen använd sökfunktionen hos oss för att finna det du letar efter! Tack för att du besöker oss.", "error.body_500": "Du skall inte ha landat på denna sidan. Mest sannolikt har något hänt med den länken som du tryckt på för att hamna här. Det kan också vara något som strular i din webbläsare eller med din internetuppkoppling. Snälla ladda om sidan eller testa Google Chrome. Om problemet kvarstår skulle vi bli oerhört tacksamma om du vill rapportera din upplevelse till <0>data@yogobe.com</0> så att vi snabbt kan undersöka och åtgärda. Tack!", "error.dear_visitor": "Något har gått fel..", "error.server_error": "Något har gått fel..", "errors.maxlength": ["Du kan max skriva ", ["length"], " tecken"], "favorites.empty_playlists_description": "Du har inte markerat några playlist-favoriter ännu", "favorites.empty_playlists_title": "Mina favoritplaylists", "favorites.empty_videos_description": "Du har inte markerat några video-favoriter ännu", "favorites.empty_videos_title": "Mina favoritvideor", "favorites.playlists_company_empty_description": [["companyName"], " har ännu inte markerat några playlistfavoriter"], "favorites.playlists_company_empty_title": "Favoritplaylists", "favorites.playlists_company_second_empty_description": "Denna medlem delar inte sina favoritvideor publikt ännu", "favorites.playlists_public_profile_empty_description": "Denna medlem delar inte sina favoritplaylists publikt ännu", "favorites.playlists_public_profile_empty_title": "Favoritplaylists", "favorites.videos_company_empty_description": [["companyName"], " har ännu inte markerat några videofavoriter från videobiblioteket på Yogobe"], "favorites.videos_company_empty_title": "Favoritvideor", "favorites.videos_public_profile_empty_description": "Denna medlem delar inte sina favoritvideor publikt ännu", "favorites.videos_public_profile_empty_title": "Favoritvideor", "featuredblgoposts.title": "Utvalda blogginlägg", "feedback_modal.icons.awesome": "Jag älskar den nya beta-versionen", "feedback_modal.icons.happy": "Jag gillar den nya beta-versionen", "feedback_modal.icons.hate": "Jag tycker inte om beta-versionen", "feedback_modal.icons.sad": "Den behöver förbättras ytterligare", "feedback_modal.question1": "Hur var din användarupplevelse?", "feedback_modal.question2": "Har du några förbättringsförslag?", "feedback_modal.question3": "Jag vill rapportera buggar", "feedback_modal.title": "Berätta vad du tycker", "footer.copyright": ["©YOGOBE ", ["year"], ". All rights reserved."], "footer.label2": "Sociala medier", "footer.label3": "Tjänsten", "footer.languages.english": "English", "footer.languages.finnish": "Suomi", "footer.languages.label": "Language", "footer.languages.norwegian": "Norsk", "footer.languages.swedish": "Svenska", "footer.links.community": "Community", "footer.links.discover": "Upptäck", "footer.links.yogobe": "Yogobe", "forgot_password_modal.back": "Tillbaka till login", "forgot_password_modal.email": "Email", "forgot_password_modal.paragraph": "Skriv in din mailadress så skickar vi ett mail till dig för att återställa ditt lösenord.", "forgot_password_modal.send_instructions": "Skicka instruktioner", "forgot_password_modal.title": "Har du glömt ditt lösenord?", "getstarted.breathe": "Andas", "getstarted.meditation": "Meditera", "getstarted.move": "Träna", "getstarted.yoga": "Yoga", "global_menu.course.courses_trainings.desc": "Utdype kunnskapen din innen helse, yoga og trening.", "global_menu.course.courses_trainings.title": "Kurs og utdannelser", "global_menu.course.events.desc": "Bli inspirert på arrangementer i yoga- og treningsbransjen.", "global_menu.course.events.title": "Events", "global_menu.course.onlinekurser.desc": "Utforsk våre egne nettkurs.", "global_menu.course.onlinekurser.title": "Onlinekurser", "global_menu.course.title": "Kurs & Reiser", "global_menu.course.travel_retreats.desc": "Oppdag fantastiske reisemål rundt om i verden.", "global_menu.course.travel_retreats.title": "Reiser & retreats", "global_menu.live.title": "LIVE", "global_menu.more.about.desc": "Bli kjent med oss ​​som virksomhet.", "global_menu.more.about.title": "Om Yogobe", "global_menu.more.blog.desc": "Kunnskap, tips og interessant lesning.", "global_menu.more.blog.title": "Blogg", "global_menu.more.business.desc": "Støtte til arbeidsgivere og organisasjoner", "global_menu.more.business.title": "Bedrift", "global_menu.more.contact.desc": "Si hei til oss!", "global_menu.more.contact.title": "Kontakt oss", "global_menu.more.en_business.item1": "Yogobe business", "global_menu.more.en_business.item2": "Classes and lectures", "global_menu.more.en_business.item3": "For yoga teachers", "global_menu.more.friskvårdsbidrag.desc": "global_menu.more.friskvårdsbidrag.desc", "global_menu.more.friskvårdsbidrag.title": "global_menu.more.friskvårdsbidrag.title", "global_menu.more.healthcare.desc": "Finn ut hvordan Yogobe støtter pasienter og forskrivere", "global_menu.more.healthcare.title": "Helsevesenet", "global_menu.more.non_profit.desc": "Sjekk ut våre ideelle tiltak.", "global_menu.more.non_profit.title": "Non-profit", "global_menu.more.se_business.item1": "Arbetsgivere", "global_menu.more.se_business.item2": "Pausa Smart", "global_menu.more.se_business.item3": "Yogobe för yogalærere", "global_menu.more.se_business.item4": "Hotell & Konferens", "global_menu.more.se_business.item5": "Partnere", "global_menu.more.se_healthcare.item1": "FaR – Fysisk aktivitet på resept", "global_menu.more.store.desc": "Kjøp yogamatter, props og mye mer.", "global_menu.more.store.title": "Shop", "global_menu.more.team.desc": "Bli kjent med våre eksperter.", "global_menu.more.team.title": "Team Yogobe", "global_menu.more.title": "Mer", "global_menu.more_menu.banner.button": "Led mer her", "global_menu.more_menu.banner.title": "Visste du at du kan bruke bidrag fra jobben til Yogobe?", "global_menu.play.playlists.desc": "Utforsk vårt omfattende utvalg av spillelister.", "global_menu.play.playlists.title": "Playlists", "global_menu.play.programs.desc": "Finn det rette treningsprogrammet for deg.", "global_menu.play.programs.title": "Program", "global_menu.play.title": "Play", "global_menu.play.video_audio.desc": "Oppdag +2100 sekvenser", "global_menu.play.video_audio.title": "Lyd- og videobibliotek", "global_menu.play.yogobe_challenge.desc": "Hold motivasjonen i live med en utfordring.", "global_menu.play.yogobe_challenge.title": "Utfordringer", "global_menu.search.title": "Søk", "global_menu.store.title": "Shop", "header.login": "Logga in", "header.try_free": "Testa gratis", "healthcare.listing_page.hero.no_premium_disclaimer": "*Du får tilgang til dette programmet gjennom en helsepersonell, arbeidsgiver eller partner til Yogobe", "healthcare.listing_page.hero.premium_disclaimer": "*Du får tilgang til dette programmet gjennom en helse-instans, arbeidsgiver eller partner til Yogobe", "healthcare.listing_page.meta.description": "Program i digital forebygging og velvære", "healthcare.listing_page.meta.title": "Program i digital forebygging og velvære", "healthcare.listings_page.explore_programs_btn": "Utforsk programmene våre", "healthcare.listings_page.faq_btn": "Spørsmål og svar", "healthcare.listings_page.hero_title": "Program for forebyggende helsetiltak", "healthcare.listings_page.subtitle": "Vi hjelper arbeidsgivere, forsikringsselskaper og helsepersonell med å støtte ansatte og pasienter med digitale verktøy innen psykisk og fysisk helse og velvære. Her kan du utforske våre programmer innen digital forebygging.", "healthcare_listing.faq.item1.body": "Du som har fått utskrevet eller tildelt tilgang via helse-instans, arbeidsgiver eller forsikringsselskap. Disse programmene er en del av Yogobe Healthcare og er utenfor abonnementstjenesten som tilbys enkeltpersoner.", "healthcare_listing.faq.item1.title": "Hvem kan delta i et program?", "healthcare_listing.faq.item2.body": "Etter at du har registrert deg og fått tilgang til et program, har du enkel tilgang til det via Yogobes app under \"Mitt bibliotek\" eller øverst på <0>oversiktssiden</0> når du er logget inn på <1>yogobe .com</1>", "healthcare_listing.faq.item2.title": "Hvordan får jeg tilgang til programmet mitt?", "healthcare_listing.faq.item3.body": "Åpenbart! Både arbeidsgivere og forsikrings- og helseselskaper kan kjøpe Yogobe og våre programmer samt digitale intervensjoner, som støtte og komplement til eksisterende innsats til fordel for enkeltpersoner, ansatte og pasienter. Send oss ​​en e-post på <0>business@yogobe.com</0>, så forteller vi deg mer.", "healthcare_listing.faq.item3.title": "Kan bedrifter kjøpe individuelle programmer?", "healthcare_listing.faq.item4.body": "Nei. Hvis du kommer til Yogobe Healthcare med en tilgangskode som du har mottatt fra en pasientforening, helse-instans, arbeidsgiver eller forsikringsselskap, betaler du personlig ingenting for å få tilgang til det spesifikke Yogobe-programmet eller materialet du har fått foreskrevet.", "healthcare_listing.faq.item4.title": "Må jeg betale?", "healthcare_listing.faq.item5.body": "Hvis du har en FaR-resept som du vil bruke på Yogobe, vennligst send en kopi (et bilde er ok) av FaR-resepten din til <0>info@yogobe.com</0>. Du vil da motta instruksjoner om hvordan du enkelt kommer i gang med Yogobes FaR-spesifikke utvalg.", "healthcare_listing.faq.item5.title": "Hvordan bruker jeg FaR-resepten min på Yogobe?", "hero.get_started": "Kom igång", "hero_thank_you.dashboard": "Min översikt", "hero_thank_you.gotoprogram": "Gå till programmet", "hero_thank_you.reset": "Vill du byta program?  <0>Klicka här för att ändra</0>", "hero_thank_you.thanks": ["Tack ", ["firstName"], "!"], "hero_thank_you.you_are_in_program": ["Du har nu tillgång till programmet <0>", ["program"], "</0>."], "homepage.courses_section.explore_marketplace": "Utforsk>>>>>>> master>>>>>>> develop", "homepage.cta_section.pricing_btn": "Abonnemangsalternativ", "homepage.features_section.get_app_btn": "Få appen", "homepage.hero_section.register_btn": "<<<<<<< HEAD", "homepage.hero_section.wellness_btn": "Wellnes grant", "homepage.mobile_section.app_store_btn": "App Store", "homepage.mobile_section.play_store_btn": "Play Store", "homepage.sections.register_btn": "Kom i gang", "instructor.title": "Om", "karolinska.get_started.access_code.label": "Accesskod", "karolinska.get_started.access_code.not_valid": "Acesskoden du angav är ogiltig! ", "karolinska.get_started.access_code.required": "Du behöver en accesskod för att komma åt programmet ", "karolinska.get_started.access_code.requirement": "För att delta i detta program behöver du en accesskod ", "karolinska.get_started.access_code.valid": "Accesskoden är giltig! ", "karolinska.get_started.activation_error": "Vi kunde inte aktivera detta program för dig, vänligen ta kontakt med oss på info@yogobe.com", "karolinska.get_started.button.continue": "Gå vidare", "karolinska.get_started.button.login": "Logga in och gå vidare", "karolinska.get_started.button.register": "Skapa ett 14-dagars prova-på-konto ", "karolinska.get_started.button.start_program": "Börja programmet", "karolinska.get_started.guest.welcome_message": "Välkommen till Stressprogrammet", "karolinska.get_started.option.have_account": "Jag har redan ett medlemskonto", "karolinska.get_started.option.no_account": "Jag har inte ett medlemskonto", "karolinska.get_started.select_option": "Vänligen välj det som är applicerbart för dig ", "karolinska.get_started.terms.label": "Jag accepterar <0>villkoren</0>", "karolinska.get_started.terms.required": "Vänligen godkänn våra villkor för att fortsätta! ", "karolinska.get_started.user.welcome_message": ["Hej ", ["name"], ", välkommen till Stressprogrammet "], "karolinska.preview_cover.guest.button": "Delta i programmet", "karolinska.preview_cover.guest.video_locked": "Om du har en accesskod till programmet, klicka på knappen nedan för att komma igång. ", "karolinska.preview_cover.user.video_locked": "Du har sett en 60 sekunders förhandsvisning. Hela videon kommer att låsas upp när föregående vecka är slutförd. ", "landing_page.offer.best_value": "Best value", "landing_page.offer.blue_section.cta_text": "Testa gratis 14 dagar", "landing_page.offer.blue_section.list_item1": "2100 videor för alla dina behov", "landing_page.offer.blue_section.list_item2": "Spara offline. Yoga och träna var som helst, närsomhelst", "landing_page.offer.blue_section.list_item3": "Obegränsad tillgång till vårt videobibliotek, alla program och utmaningar", "landing_page.offer.blue_section.list_item4": "Skapa, dela och följ playlists", "landing_page.offer.blue_section.title": "Vad får du som aktiv medlem?", "landing_page.offer.first_section.cta_text": "Prova gratis 14 dagar", "landing_page.offer.free_trial": "Prova 14 dagar", "landing_page.offer.getstarted": "Kom igång", "landing_page.offer.most_affordable": "Mest prisvärt", "landing_page.offer.playlists_section.title": "Upptäck relevanta playlists", "landing_page.offer.programs_section.title": "Program som ingår för aktiva medlemmar", "landing_page.offer.subscription_annually_billed": "Din prenumeration förnyas årligen.", "landing_page.offer.subscription_free_plan_label": "Obegränsad access utan att ange kortuppgifter.", "landing_page.offer.subscription_free_price_label": "Gratis", "landing_page.offer.subscription_free_title": "Gratis prova-på", "landing_page.offer.subscription_monthly_billed": "Din prenumeration förnyas varje månad.", "landing_page.offer.subscription_monthly_per": "/ månad", "landing_page.offer.subscription_quarterly_billed": "Förnyas varje kvartal och övergår automatiskt till ordinarie pris i kvartal två. ", "landing_page.offer.subscription_quarterly_per": "/ kvartal", "landing_page.offer.subscription_sub_title": "Starta en årprenumeration och få 500 SEK att handla Yogiraj för.", "landing_page.offer.subscription_title": "Bli betalande medlem och få obegränad tillgång till videobiblioteket", "landing_page.offer.testomonials_section.title": "Vad säger våra medlemmar?", "landing_page.offer.videos_section.title": "Utvalda videor för dina behov", "landingpage.hero.bullet1": "On-demand & LIVE online", "landingpage.hero.bullet2": "Lagre offline i appen vår", "landingpage.hero.bullet3": "Prøv gratis uten bindingstid", "landingpage.hero.cta": "Testa 14 dagar gratis", "landingpage.hero.subtitle": "Några minuter om dagen gör under för hälsan", "landingpage.hero.title": "Vill du också yoga, träna & meditera online?", "landingpage.mobileapp_section.desc": "Ladda ner våra nya app idag och dela gärna med dig av din feedback om hur du använder appen.", "landingpage.mobileapp_section.title": "Ladda ner appen och testa redan idag!", "landingpage.section2.desc": "Välkommen att yoga, träna och guidas till avslappning med många av landets främsta experter, instruktörer och terapeuter, som alla brinner för att dela sin kunskap för att du skall må bra i vardagen. Enkelt, roligt och lätt att använda var du vill – när du vill. Skapa och behåll en god vana tillsammans med oss! Som medlem blir du också del i en vår härliga community. Välkommen att testa gratis! Alltid utan bindningstid.", "landingpage.section2.link": "Utforska 2000 videor", "landingpage.section2.title": "Yoga och träna hemma i vardagsrummet", "landingpage.section2.trailer_tag": "Trailer", "landingpage.section4.item1.desc": "Tillsammans med arbetsgivaren skräddarsyr vi och paketerar digitala och fysiska insatser och aktiviteter som möter individbehoven i hela medarbetargruppen för fysiskt och mentalt välbefinnande genom livets många faser och skeden, bla. med klasser, föreläsningar, utmaningar och kurser inom stress, sömn, fokus och hållbarhet. Allt för att öka trivsel, gemenskap och minska risken för sjukskrivningar.", "landingpage.section4.item1.title": "Företagshälsa", "landingpage.section4.item2.desc": "Får du friskvårdsbidrag av din arbetsgivare? Då kan du enkelt använda det hos oss. Du kan välja att köpa din prenumeration direkt på Yogobe, för att därefter skriva ut och lämna in ditt kvitto direkt till arbetsgivaren. Däremot, om din arbetsgivare samarbetar med Benify, Actiway, Wellnet eller ePassi så går du via dem för att använda ditt friskvårdsbidrag på Yogobe. Lätt som en plätt. ", "landingpage.section4.item2.title": "Friskvårdsbidraget", "landingpage.section4.item3.desc": "Vi samarbetar med Mecenat, Tjejzonen, jobbar med skolan och mot asylboenden. Den bästa träningen är den som blir av, och genom att erbjuda onlineträning till en digital generation hoppas vi bidra till bättre folkhälsa! Vi ger Yogobe gratis till olika grupper som motvikt till stillasittande och psykisk ohälsa i vårt samhälle.", "landingpage.section4.item3.title": "Yogobe Non-profit", "landingpage.section4.readmore": "LÄS MER", "landingpage.section5.title": "Mer hos Yogobe", "landingpage.section6.cta": "Testa 14 dagar gratis", "landingpage.section6.disclaimer": "Provtiden övergår inte i en betalande prenumeration", "landingpage.section6.subtitle": "Vill du få obegränsad tillgång till klasser, playlists, program & utmaningar?", "landingpage.section6.title": "Yogobe medlemskap", "landingpage.section7.title": "Vad tycker våra medlemmar om Yogobe?", "landingpage.squareitems.alt_text.book_retreat": "På Yogobe kan du boka ett yogaretreat eller anmäla dig till en yogalärarutbildning.", "landingpage.squareitems.alt_text.deepen_your_knowledge": "Fördjupa dina kunskaper - läs mer om Yogobes mest populära onlinekurser. Klicka här och ta del av exklusiva rabatter!", "landingpage.squareitems.alt_text.getstarted": "Kom enkelt igång med Yogobe - för din onlineträning hemma.", "landingpage.squareitems.alt_text.live": "Upplev våra realtidsklasser online via Yogobe LIVE. Gå till schemat här!", "landingpage.squareitems.alt_text.news_yogobe": "Ta del av våra senaste nyheter på Yogobe inom online yoga, träning, meditation och andning.", "landingpage.squareitems.alt_text.program_card": "Lär dig löpträning från grunden med Magnus Hagström - i hans onlineprogram på Yogobe: 12 veckor till milen.", "landingpage.squareitems.alt_text.wellness_grant": "Läs om hur du kan använda ditt friskvårdsbidrag på Yogobe.", "landingpage.squareitems.alt_text.ybteam": "Lär känna Team Yogobe - med över 90 exeperter och lärare inom yoga, träning, meditation och andning.", "landingpage.squareitems.challenge.text1": "Yogobe Challenge", "landingpage.squareitems.challenge.text2": "FÖRSTA MÅNADEN", "landingpage.squareitems.challenge.text3": "SEK", "landingpage.squareitems.challenge.text4": "99", "landingpage.squareitems.challenge.text5": "5 OLIKA UTMANINGAR", "landingpage.squareitems.get_started.text1": "Hur kommer jag", "landingpage.squareitems.get_started.text2": "enkelt igång", "landingpage.squareitems.get_started.text3": "med Yogobe?", "landingpage.squareitems.get_started.text4": "Steg-för-steg guide. Klicka här!", "landingpage.squareitems.live.text1": "LIVE", "landingpage.squareitems.live.text2": "Upplev energin av att delta", "landingpage.squareitems.live.text3": "LIVE-online i realtid", "landingpage.squareitems.live.text4": "Flera klasser", "landingpage.squareitems.live.text5": "varje vecka", "landingpage.squareitems.marketplace.text1": "Vill du boka", "landingpage.squareitems.marketplace.text2": "ett retreat eller", "landingpage.squareitems.marketplace.text3": "utbilda dig inom", "landingpage.squareitems.marketplace.text4": "yoga?", "landingpage.squareitems.marketplace.text5": "Gå till Yogobe Marketplace", "landingpage.squareitems.online_courses.text1": "Fördjupa", "landingpage.squareitems.online_courses.text2": "dina kunskaper", "landingpage.squareitems.online_courses.text3": "Ta del av månadens", "landingpage.squareitems.online_courses.text4": "rabatterade onlinekurser", "landingpage.squareitems.running_program.text1": "12 veckor till milen", "landingpage.squareitems.running_program.text2": "Program med Magnus Hagström", "landingpage.squareitems.team_yogobe.text1": "Lära känna", "landingpage.squareitems.team_yogobe.text2": "Team Yogobe", "landingpage.squareitems.team_yogobe.text3": "med fler än 70 experter", "landingpage.squareitems.team_yogobe2.text1": "Nyheter på Yogobe", "landingpage.squareitems.wellness_grant.text1": "Hur kan jag", "landingpage.squareitems.wellness_grant.text2": "använda mitt", "landingpage.squareitems.wellness_grant.text3": "friskvådsbirag", "landingpage.squareitems.wellness_grant.text4": "på Yogobe?", "landingpage.squareitems.wellness_grant.text5": "Läs om hur du gör här.", "landingpage.testimonials.item1.name": "Ann-Sofie Forsmark", "landingpage.testimonials.item1.quote": "”Det är det solklart bästa sättet att få till yoga för mig, för barnen och att få till SOMA.”", "landingpage.testimonials.item1.title": "Hälsostrateg", "landingpage.testimonials.item2.name": "Lori Wäne", "landingpage.testimonials.item2.quote": "”Att kunna ha tillgång till yogaklasser hemma de dagar jag inte har möjlighet att ta mig till en studio är oerhört värdefullt.”", "landingpage.testimonials.item2.title": "Blivande yogalärare", "landingpage.testimonials.item3.name": "Malin Magnusson", "landingpage.testimonials.item3.quote": "”Yogobe är i mina ögon väldigt prisvärt och jag har träningen med mig överallt.”", "landingpage.testimonials.item3.title": "Småbarnsmamma & mångsysslare", "landingpage.testimonials.item4.name": "Anna Åhlgren", "landingpage.testimonials.item4.quote": "”För att få inspiration av kloka och roliga kollegor.”", "landingpage.testimonials.item4.title": "Yogalärare & berättare", "live.event.levels.advanced": "Avancerade utövare", "live.event.levels.beginner": "Nybörjare", "live.event.levels.everyone": "För alla", "live.event.levels.intermediate": "Vana utövare", "live.event.levels.other": "Annat", "live.event_page.about_event": "Om sessionen", "live.event_page.all_event_link": "Alla sessioner", "live.event_page.banner_donation_class": "Denna LIVE-klass är till förmån för Världsnaturfonden WWF", "live.event_page.book_btn": "Boka", "live.event_page.booking_closed_banner": "Bokningen för denna session är nu stängd.", "live.event_page.coming_soon": "Kommer snart", "live.event_page.donation_class": "Donation class", "live.event_page.event_date_time": "Datum & tid för sessionen", "live.event_page.event_free": "Gratis", "live.event_page.event_instructors": "Experter", "live.event_page.event_lang_label": "Språk på sessionen", "live.event_page.event_prerequisites": "Utrustning", "live.event_page.expired_event": "Genomförd", "live.event_page.for_for_you": "Gratis för dig", "live.event_page.fully_booked_event": "Fullbokad", "live.event_page.join_btn": "Delta nu", "live.event_page.join_btn_reserved": "Du har bokat din plats", "live.event_page.no_prerequisites_required": "Ingen utrustning behövs för denna session.", "live.event_page.prerequisites_yogobe_store": "Vill du fylla på med utrustning hemma? <0>Besök Yogobe Store</0>", "live.event_page.recording_more_info": "Mer information", "live.event_page.recording_more_info_tooltip": "Inspelningen försvinner cirka 24h efter att den har genererats av Zoom. Efter denna period kommer du inte längre kunna se denna inspelade LIVE-session.", "live.event_page.registration_end_label": "Sista möjlighet för att boka", "live.event_page.reserve_spot_banner.book_btn": "Boka min plats", "live.event_page.reserve_spot_banner.browse_events": "Utforska andra sessioner", "live.event_page.reserve_spot_banner.desc": ["Boka din plats på <0>", ["event_name"], "</0> medan det finns platser kvar "], "live.event_page.reserve_spot_banner.event_date": ["Datum för sessionen: ", ["date"]], "live.event_page.reserve_spot_banner.expired_desc": ["Anmälan till <0>", ["event_name"], "</0> är nu stängd."], "live.event_page.reserve_spot_banner.last_registration_date": ["Anmäl dig senast: ", ["endDate"]], "live.event_page.reserve_spot_banner.reserved_desc": ["Din plats på <0>", ["event_name"], "</0> har bokats."], "live.event_page.reserve_spot_banner.reserved_title": "Anmälan bekräftad!", "live.event_page.reserve_spot_banner.share_btn": "Dela session", "live.event_page.reserve_spot_banner.title": "Reservera din plats!", "live.event_page.reserved_spot.click_join": "Klicka för att gå med", "live.event_page.reserved_spot.hosted_zoom": "Denna session genomförs via Zoom", "live.event_page.reserved_spot.or_copy_link": "Eller kopiera och klistra in länken i din webbläsare", "live.event_page.reserved_spot.zoom_code_label": "Lösenord", "live.event_page.spots_left": ["Bara ", ["spots"], " platser kvar"], "live.event_page.sticky_banner.discount_available": "Du får 30% rabatt då du har en aktiv prenumerationsperiod", "live.event_page.sticky_banner.free_for_you": "Denna session är inkluderad, utan extra kostnad, som del i din prenumeration", "live.event_page.subscription_discount_text": "LIVE-klasser ingår varje vecka när du har en aktiv betalande prenumeration. <0>Uppgradera</0>", "live.event_page.view_all_instructor_events": ["<0>Se alla sessioner</0> med ", ["name"]], "live.event_page.watch_session_recording": "Titta på den inspelade sessionen", "live.event_page.you_r_in_event": "ANMÄLD", "live.listings.live_codes_card.description": "Du har én eller flere tilgangskoder til ukentlige klasser på Yogobe LIVE.", "live.listings.live_codes_card.description2": "Bestill nå, før de går ut", "live.listings.live_codes_card.see_code_btn": "Se mine koder", "live.listings.live_codes_card.title": "Godt å vite", "live.listings_page.banner.subscription_discount_text": "LIVE-klasser ingår i våra prenumerationer OCH du får 30% rabatt på alla premium LIVE-sessioner. Välj den medlemsform som passar dig", "live.listings_page.clear_events_filters": "Återställ Filter & sök", "live.listings_page.disclaimer": "LIVE-klasser ingår för medlemmar med en betalande prenumeration", "live.listings_page.explore_events_btn": "Ta del av kalendern", "live.listings_page.filter_applied_toaster": "Filter har sparats", "live.listings_page.filters.donation_class": "Donation class", "live.listings_page.filters.free_event": "Gratis event", "live.listings_page.filters.instructors": "Alla experter", "live.listings_page.filters.kind_class": "Klass", "live.listings_page.filters.kind_label": "Alla typer", "live.listings_page.filters.kind_lecture": "Föreläsning", "live.listings_page.filters.kind_online_course": "Kurs", "live.listings_page.filters.kind_skills": "Kunskap", "live.listings_page.filters.kind_talk": "Talks", "live.listings_page.filters.kind_workshop": "Workshop", "live.listings_page.filters.languages": "Visa sessioner på", "live.listings_page.filters.sort_by_date": "Datum", "live.listings_page.filters.sort_by_price": "Pris", "live.listings_page.filters.sort_label": "Sortera efter", "live.listings_page.filters.sort_mobile_label": "Sortera och filtrera", "live.listings_page.filters.sort_modal_title": "Filtrera", "live.listings_page.hero_title": "Yogobe LIVE", "live.listings_page.load_more_btn": "Visa fler", "live.listings_page.no_events_found": "Hoppsan... Inga sessioner hittades för denna sökning. Var vänlig att ta bort filtreringen och/eller gör om din sökning.", "live.listings_page.pricing_section.title": "Våra LIVE-klasser ingår för alla med en aktiv prenumeration!", "live.listings_page.search_input_placeholder": "Sök bland LIVE-sessioner...", "live.listings_page.subtitle": "Yoga, träna och meditera i realtid - med Yogobe LIVE. Praktisera tillsammans som ett Community under vägledning av Team Yogobe.", "live.live_page.metadata.desc": ["Spana in LIVE-sessionen ", ["eventName"], " med ", ["instructor"], " - boka din plats nu eller utforska andra live-sessioner på yogobe.com/live"], "live.payment_page.access_code.not_valid": "Tilgangskoden din er ugyldig", "live.payment_page.access_code.valid": "Tilgangskoden er gyldig", "live.payment_page.action_button.activate": "Aktivera", "live.payment_page.action_button.login": "Logga in och gå vidare", "live.payment_page.action_button.register": "Logga in och gå vidare", "live.payment_page.action_button.start_suscription": "Skapa ett 14-dagars prova-på-konto ", "live.payment_page.activate_email_banner": "Vi er glade for at du ønsker å delta på dette LIVE-event. For å bestille plass er det viktig at du først aktiverer og bekrefter kontoen din hos Yogobe via e-posten vi har sendt deg.", "live.payment_page.code_input.description": "Har du en kode fra oss eller din arbeidsgiver?", "live.payment_page.code_input.description_tooltip": "Hvis du har mottatt en rabatt eller tilgangskode for LIVE - skriv den inn her for å få tilgang til denne LIVE-klassen.", "live.payment_page.code_input.show_text": "Hvis du har en rabatt eller tilgangskode, <0>klikk her</0>", "live.payment_page.countdown_banner": ["Slutför bokningen för att säkra din plats. Återstående tid: <0>", ["min"], ":", ["sec"], " min</0>"], "live.payment_page.countdown_timeout_btn": "Tillbaka till eventsidan", "live.payment_page.countdown_timeout_desc": "Tiden för bokning har gått ut då ingen betalning genomfördes. Vänligen gå tillbaka och testa igen.", "live.payment_page.details": "Du kommer att få mail där vi bekräftar din anmälan och delar praktisk information. Vi skickar också ett påminnelsemail 15 minuter innan start.", "live.payment_page.discount_amount": "Rabatt", "live.payment_page.discount_text": "Liveklasser inkluderas i din prenumeration. Du får också 30% rabatt på premium LIVE-event. Uppgradera ditt medlemskap till Prenumeration nu. Givetvis kommer du automatiskt tillbaka till samma sidan. <0>Kika på erbjudanden</0> ", "live.payment_page.donation_class_details": "Detta är en donationsklass till förmån för WWF. Om du inte redan har donerat en gåva till kampanjen Yoga for Nature så skulle vi bli tacksamma om du vill göra det. <0> Läs mer och donera hos WWF här!</0> <1></1> <1></1> När du har bokat din plats så får du ett email där vi bekräftar din anmälan och delar praktisk information.", "live.payment_page.event_accesscode_activated.toast": "Du er nå booket på live-klassen!", "live.payment_page.free_event_reserved.toast": "Du er nå booket på live-klassen!", "live.payment_page.free_reserve_spot": "Boka din plats", "live.payment_page.payment_amount": "Att betala", "live.payment_page.payment_reserve_spot": "Fortsätt till säker betalning", "live.payment_page.summary_title": "Ordersammanfattning", "live.payment_page.term_conditions": "Jag godkänner Yogobe's <0>betalnings- och återbetalningspolicyn</0>", "live.payment_page.term_conditions_tooltip": "Villkoren för LIVE hittar du under paragraf 4.10 i våra användarvillkor. <0>Läs mer här</0>", "live.paymentfail.body": ["Något gick fel.. din betalning på ", ["amount"], " SEK gick inte igenom. Vänligen försök igen. Om problemen kvarstår, vänligen kontakta vår tekniska support: <0>data@yogobe.com</0>"], "live.paymentfail.btn": "Gå tillbaka & försök igen", "live.paymentfail.orderdetails.body": ["Transaktions-ID: ", ["transaction"]], "live.paymentfail.title": "Betalningen misslyckades", "live.paymentsuccess.body": ["Tack, din betalning på ", ["amount"], " ", ["currency"], " har mottagits. En betalningsbekräftelse skickas till ", ["email"]], "live.paymentsuccess.btn": "Fortsätt", "live.paymentsuccess.orderdetails.body": ["Order-ID: ", ["order"]], "live.paymentsuccess.title": "Betalning lyckades!", "login_modal.action.create": "Skapa konto", "login_modal.action.forgot": "Glömt ditt lösenord?", "login_modal.action.login": "Logga in", "login_modal.action.or_create": "Är du inte redan medlem? <0>skapa konto</0>", "login_modal.action.social_label": "Eller logga in med", "login_modal.errors.incorrect": "Felaktig mailadress eller lösenord, vänligen försök igen", "login_modal.errors.incorrect_socials": "Du föresöker logga in på Yogobe med hjälp av antingen Apple, Google eller Facebook. Du har ännu inget konto hos oss kopplat till detta inloggningssätt. Om du redan är medlem vänligen fyll i din mailadress och lösenord istället. Ifall du inte redah har ett konto hos oss är du varmt välkommen att skapa ett! <br><br> OBS: Vi kommer skapa en funktion så att våra befintliga medlemmar kan koppla sina existerande konton till Apple, Google eller Facebook för enklare login i framtiden, men det finns ännu inte. Tack för tålamod!", "login_modal.helper": "Logga in för åtkomst till videobiblioteket, vårt växande kursutbud och din profil.", "login_modal.inputplaceholder.email": "Mailadress", "login_modal.inputplaceholder.password": "Lösenord", "login_modal.title": "Logga in", "login_page.landing.headline": "Vi är mycket glada att du är medlem hos oss!", "login_page.landing.subtitle": "Logga in och låt oss inspirera, engagera och guida dig till ökad mental hälsa och hållbarhet!", "maintenae_page.role": "Grundare och VD", "maintenance_page.body": "Between 04:00 and 05:00 today, we are doing updates to the system!  <br /> We are very excited about all the good things happening on the tech side of Yogobe at the moment and kindly ask for your patience. As you cannot access our video library just now we’d like to recommend a short chat with the magical Alan Finger on the topic of stress and how yoga and meditation can help us cope with it. <a href=\"https://www.facebook.com/YOGOBEcom/videos/420176531509273/\">Find it via the Yogobes Facebook page.</a> <br /> All the best,", "maintenance_page.title": "Midnight updates", "menu_add_playlist.add": "Lägg till i playlist", "menu_add_playlist.create": "Skapa ny playlist", "menu_more.schedule": "Schemalägg", "menu_more.share": "Dela", "menu_more.share_page": "Dela", "message1.spring_challenge.end": "Spring Challenge är nu bakom oss men du kommer fortfarande åt ditt valda program via din Översikt / Hem.", "message1.summer_challenge2020.end": "Summer Challenge är nu bakom oss men du kommer fortfarande åt ditt valda program via din Översikt / Hem.", "message1.winter_challenge.end": "Winter Challenge är nu bakom oss men du kommer fortfarande åt ditt valda program via din Översikt / Hem.", "message2.spring_challenge.end": "Vill du ge dig själv en ny utmaning?", "message2.winter_challenge.end": "Vill du ge dig själv en ny utmaning?", "meta.follow": "Följ", "metadata.accessUntil": "Tillgång till", "metadata.active": "aktiv", "metadata.all": "Alla", "metadata.and": "och", "metadata.apply": "Aktivera", "metadata.back_to_dashboard": "Tillbaka till översikt", "metadata.bodyparts": "Kroppsdelar", "metadata.bonus": "Bonus", "metadata.browse_all": "Visa alla", "metadata.challenge": "Challenge", "metadata.choose_file": "Välj en fil", "metadata.clear_all": "Rensa alla", "metadata.close": "STÄNG", "metadata.code_activation.failed": "Det verkar som om något har gått snett vid aktivering av din kod. Vänligen skriv till oss så hjälper vi dig! <0>Kontakta Yogobe</0>", "metadata.company_empty_playlists": "Inga publika playlists", "metadata.course": "Kurs", "metadata.courseLabel": "Kurs", "metadata.course_by": "Kurs av", "metadata.created_by": "Skapad av", "metadata.days.label": "Dagar", "metadata.delete": "Radera", "metadata.delete_playlist": "Ta bort Playlist", "metadata.document": "Dokument", "metadata.download": "Ladda ner ", "metadata.downloadPDF": "Kursöversikt", "metadata.download_all": "Ladda ner alla", "metadata.duration": "Längd", "metadata.edit_playlist": "Ändra playlist", "metadata.edit_profile": "Ändra Profil", "metadata.edite_privacy_settings": "Ändra sekretessinställningar", "metadata.empty_playlists": "Du har inte skapat några egna playlists ännu", "metadata.empty_playlists_action": "Upptäck playlists skapade av Yogobe", "metadata.english": "engelska", "metadata.exercise": "Klass", "metadata.expire_on": ["Denna kurs löper ut den ", ["expirationDate"]], "metadata.expired_on": ["Denna kurs löpte ut den ", ["expirationDate"]], "metadata.frequently_asked_questions.title": "Vanliga frågor", "metadata.getStarted": "Kom igång", "metadata.go_back_simple": "Gå tillbaka", "metadata.introduction": "Introduktion", "metadata.lecture": "Föreläsning", "metadata.load-more": "Visa fler", "metadata.login": "Logga in", "metadata.min": "min", "metadata.minuter": "minuter", "metadata.more": "visa fler", "metadata.more_items": ["& ", ["number"], " fler"], "metadata.my_stats": "Se min statistik", "metadata.needs": "Behov", "metadata.new": "Ny", "metadata.next": "Nästa", "metadata.only_you_can_see_this": "Bara du kan se detta", "metadata.payment.failed": "Vi kunne dessverre ikke fullføre betalingen med informasjonen du fylte inn, så prøv igjen. Hvis problemet vedvarer, vennligst kontakt oss på <0></0>", "metadata.payment.success.continue_button": "Gå vidare", "metadata.payment.success.receipt_button": "Visa kvitto", "metadata.payment.success.title": "Betalningen genomförd", "metadata.paymentfail.btn": "Gå tillbaka & försök igen", "metadata.paymentfail.title": "Betalningen misslyckades", "metadata.playlists": "Playlists", "metadata.playlists_public_profile_empty_description": "Denna medlem delar inga playlists publikt ännu", "metadata.please_wait": "Vänligen vänta...", "metadata.premium": "Premium", "metadata.preview": "Förhandsvisning", "metadata.profile_private": "Publik profil", "metadata.program": "Program", "metadata.programLabel": "Program", "metadata.program_by": "Program av", "metadata.programs.my_progress": "Min utveckling", "metadata.programs.overview": "Översikt", "metadata.progressPercentage": [["percentage"], "% Genomfört"], "metadata.public_profile_empty_playlists": "Inga publika playlists", "metadata.question": "Fråga", "metadata.read_more": "Läs mer", "metadata.read_more_about": "Läs mer om", "metadata.recently_viewed_videos": "Senast sedda videor", "metadata.recommended_courses_programs_title": "Program på Yogobe som vi har tagit fram och erbjuder", "metadata.recommended_playlists_title": "Rekommenderade playlists", "metadata.recommended_videos_title": "Rekommenderade videor", "metadata.remove_from_playlist": "Radera från Playlist", "metadata.resume": "Fortsätt", "metadata.save": "Spara", "metadata.save_favorites": "Spara till favoriter", "metadata.save_more_than_per_year": ["Spara mer än ", ["amount"], " SEK per år"], "metadata.saved_favorites": "Sparad till favoriter ", "metadata.search": "Sök hela videobiblioteket", "metadata.search_library": "Sök allt innehåll på Yogobe", "metadata.show_less": "Visa färre", "metadata.show_more": "Visa fler", "metadata.signup": "Bli medlem", "metadata.skills": "Kunskap", "metadata.statistics": ["Du tog del av ", ["sessionsLastWeek"], " sessioner förra veckan."], "metadata.statistics_title": "Statistik", "metadata.styles": "Stil", "metadata.survey": "Enkät", "metadata.swedish": "svenska", "metadata.tags": "Tagg", "metadata.talk": "Prat", "metadata.textElement": "Text", "metadata.this_profile_is_private": "Denna profil är privat", "metadata.this_profile_is_private_title": "Privat profil", "metadata.upgrade": "Uppgradera", "metadata.videos": "Videor", "metadata.view_all": "Visa alla", "metadata.visitor": "besökare", "metadata.weeks.label": "Veckor", "metadata.with": "med", "metadata.workshop": "Workshop", "metadeta.programs.other_programs": "Alla program", "metatadata.errors.unexpectedError": "Något har blivit tokigt. Snälla försök igen eller kontakta oss via data@yogobe.com", "modals.publicplaylist.button1": "Ja, gör min profil", "modals.publicplaylist.button2": "Nej, jag önskar att min profil förblir privat", "modals.publicplaylist.helper": "Du önskar göra denna playliset publik för att dela med vänner och världen. För att det skall bli möjligt behöver du en öppen profil. Följande information kommer då att visas:", "modals.publicplaylist.option1": "Din profilbild", "modals.publicplaylist.option2": "För- och Efternamn", "modals.publicplaylist.option3": "Din beskrivningstext", "modals.publicplaylist.title": "Dina publika playlists", "my_playlists.title": "Mina playlists", "new_subscription_modal.bank_transfer": "Banköverföring", "new_subscription_modal.debit_credit_card": "Debit / kreditkort", "new_subscription_modal.description": "Våra prenumerationer är löpande, utan bindningstid och kan avbrytas när du vill", "new_subscription_modal.helper_bank": "Jag vill betala min prenumeration via mitt bankkonto (Trustly). Smidigt, tryggt och med direktkoppling till mitt konto.", "new_subscription_modal.select_option": "Välj det alternativ som passar dig allra bäst", "new_subscription_modal.title": "Uppgradera medlemskap", "new_subscription_modal.warning_finland_cc": "Detta alternativ finns ännu inte i Finland.", "onboarding.back.btn_text": "Tillbaka", "onboarding.banner.missed_onboarding": "Låt oss samla och rekommendera videor och innehåll som möter dina behov och önskemål!", "onboarding.completed.explore_store.desc": "Utforska Yogobe Store och få 10% rabatt på ditt första köp när du använder rabattkoden: MY10OFF", "onboarding.completed.explore_store.title": "Utforska yogatillbehör", "onboarding.completed.my_favorites.desc": "Utforska det innehåll som vi samlat med bas i dina uttryckta behov och önskemål", "onboarding.completed.my_favorites.title": "Innehåll rekommenderat för mig", "onboarding.completed.programs.desc": "onboarding.completed.programs.desc", "onboarding.completed.programs.title": "Utforska olika program och kurser för dina behov", "onboarding.completed.video_library.desc": "Utforska 1900+ videor inom fyra olika områden/kanaler: Yoga, Meditera, Andas och Träna", "onboarding.completed.video_library.title": "Videobiblioteket", "onboarding.continue.btn_text": "Fortsätt", "onboarding.description.edit_text": "Här kan du alltid ändra dina preferenser. Vid en ändring kommer vi automatiskt att uppdatera ditt rekommenderade innehåll som du hittar under din Översikt.", "onboarding.description.text": "Berätta gärna för oss vad du har för behov och intressen så att vi kan rekommendera videor åt dig!", "onboarding.finish.btn_text": "Slutför", "onboarding.meta_title": "Kom igång steg för steg", "onboarding.missing_lang.interests": "onboarding.missing_lang.interests", "onboarding.missing_lang.topics": "onboarding.missing_lang.topics", "onboarding.select.choices": "Du kan göra upp till tre val", "onboarding.select_interests.text": "Jag skulle vilja utforska...", "onboarding.select_topics.text": "Jag vill…", "onboarding.skip.btn_text": "Hoppa över", "onboarding.welcome.text": ["Välkommen ", ["name"]], "opengraph.companyFavorites_title": "Favoriter", "opengraph.companyOverview_title": "Översikt", "opengraph.companyPlaylists_title": "Playlists", "opengraph.dashboard_title": "Översikt", "opengraph.mefavorites_title": "Min favoriter", "opengraph.myplaylists_title": "Mina playlists", "opengraph.password_recovery_title": "Återskapa lösenord", "opengraph.playlists_collections_title": "Yogobe Playlist-kategorier", "opengraph.playlists_title": "Yogobe Playlists", "opengraph.profilePlaylists_title": "Mina playlists", "opengraph.profilefavorites_title": "Profil-favoriter", "opengraph.profilestats_title": "Min statistik", "opengraph.programs_title": "4-12 veckors program för våra medlemmar", "opengraph.settings_title": "Mina inställningar", "opengraph.stats_title": "Min statistik", "opengraph.videos_description": "Yoga, meditera, andas och träna online tillsammans med oss", "opengraph.videos_genres_title": "Yogobe Videobibliotek", "opengraph.videos_title": "Yogobe Videobibliotek", "ourprograms.title": "Upptäck våra program", "pages.company_favorite.title": "Favoriter", "pages.favorite.title": "Mina favoriter", "pages.favorite_public_title": "Favoriter", "pages.playlist_public_title": "Playlists", "pausa-smart.all-categories": "Alla kategorier", "pausa-smart.already-in-program": "Du deltar redan i detta program", "pausa-smart.browse-all-videos": "Översikt samtliga videor", "pausa-smart.download-pdf": "Ladda ner ", "pausa-smart.employee-access-code": "Jag är en medarbetare med en accesskod", "pausa-smart.form-access-code.already-used": "Den accesskod som du angivit har redan använts", "pausa-smart.form-comment": "Kommentar", "pausa-smart.form-company-name": "Företagsnamn", "pausa-smart.form-email": "Email", "pausa-smart.form-full-name": "Fullständigt namn", "pausa-smart.form-rules.accessCode.required": "Du måste ha en accesskod", "pausa-smart.form-rules.comment.max": "Din kommentar får max innehålla 200 tecken", "pausa-smart.form-rules.companyName.required": "Vänligen skriv in ert företagsnamn", "pausa-smart.form-rules.email.required": "Vänligen skriv in din email-adress", "pausa-smart.form-rules.email.valid": "Var snäll och fyll i en giltig email-adress", "pausa-smart.form-rules.fullName.required": "Vänligen fyll i ditt fullständiga namn ", "pausa-smart.form-submit": "Skicka", "pausa-smart.form-title": "Vill du prova gratis i 14 dagar?", "pausa-smart.form.success-existing": ["Du har nu fått access till Pausa Smart i ", ["days"], " dagar. Du hittar programmet enkelt vila din översiktssida. Ett bekräftelsemail har också skickats till dig. "], "pausa-smart.form.success-interest": ["Tack ", ["firstname"], " för ert intresse i Pausa Smart. Vi återkommer till dig via email inom kort för att se hur vi bäst kan göra för att erbjuda digitala verktyg och program för hälsa och välmående på ert företag."], "pausa-smart.form.success-new": ["Tack! Vi har skickat ett bekräftelsemail till ", ["email"], ". Klicka på länken i detta email för att skapa ditt konto och få Pausa Smart access. Om du redan har ett personligt medlemskonto på Yogobe snälla be din arbetsgivare om en ny accesskod och börja om. Uppge då istället den mailadress som du redan har kopplad till ditt Yogobe-konto så att du kan samla allting på samma plats hos oss. Välkommen!"], "pausa-smart.form_access_code": "Accesskod", "pausa-smart.get-started": "Kom igång", "pausa-smart.go-to-program": "Gå till program", "pausa-smart.interviews-testimonials-title": "Prova-på klasser att utforska", "pausa-smart.organization": "Jag företräder ett företag/organisation", "pausa-smart.read-less": "Stäng ", "pausa-smart.read-more": "Läs mer", "pausa-smart.testimonials-title": "Våra kunder berättar om Pausa Smart", "pausa-smart.title": "Pausa Smart", "pausa-smart.videos-in-total": ["Visar sammanlagt ", ["n"], " videor"], "pausa-smart.videos.languagues.all": "Alla språk", "pausa-smart.videos.languagues.english": "Engelska", "pausa-smart.videos.languagues.swedish": "Svenska", "pausasmart.form.no_account.title": "Logga in eller skapa ett konto för att använda koden", "pausasmart.get_started.access_code.desc": "Denna accesskod tillhandahålls vanligtvis av någon inom ert företag eller organisation", "pausasmart.get_started.access_code.dont_have": "Jag har ingen accesskod", "pausasmart.get_started.access_code.have": "Min arbetsgivare har givit mig en accesskod", "pausasmart.get_started.access_code.label": "Accesskod", "pausasmart.get_started.access_code.not_valid": "Vi beklagar, denna accesskod är ogiltig ", "pausasmart.get_started.access_code.valid": "Du har nu fått tillgång till Pausa Smart Challenge", "pausasmart.get_started.account.dont_have": "Jag vill skapa konto", "pausasmart.get_started.account.have": "Jag har ett konto", "pausasmart.get_started.button.continue": "Gå vidare", "pausasmart.get_started.button.continue_plan": "Fortsätt med månadsprenumeration", "pausasmart.get_started.button.continue_trial": "Fortsätt med 14 dagar gratis", "pausasmart.get_started.button.login": "Logga in", "pausasmart.get_started.button.upgrade_continue": "Uppgradera och gå vidare", "pausasmart.get_started.dont_have_code.hovertip": "Får att kunna ta del av audio- och videosessioner på Yogobe så måste du ha giltig accesstid via en aktiv prenumeration eller tid kvar på din gratis prova-på period. Detta inbegriper även playlists, program och våra löpande utmaningar.  Din accesstid kan också ha uppgraderats genom din arbetsgivare där du fått tillgång till hela eller delar av Yogobe som tjänst. Till exempel så kan du ha fått 90 dagars access till just detta program av din arbetsgivare - Allt du behöver göra är att skriva in den kod som du fått. Programmet sparas till din profil och visas tydligt när du loggar in.", "pausasmart.get_started.dont_have_code.text": "Denna utmaning ingår för alla aktiva medlemmar. Om du inte redan är medlem, skapa enkelt en 14 dagars prova-på period. Du kan också uppgradera ett befintligt medlemskonto med en prenumeration och få obegränsad tillgång till videor, playlists, program och utmaningar. <0>Läs mer</0>", "pausasmart.get_started.have_premium.text": "Detta program ingår för dig som aktiv eller betalande medlem", "pausasmart.get_started.program_activation_failed": "Något tycks ha blivit tokigt. Snälla försök igen eller <0>kontakta vår kundtjänst</0>", "pausasmart.get_started.purchase_banner_back": "Tillbaka", "pausasmart.get_started.purchase_banner_text": "Företräder du ett företag eller organisation som vill joina Yogobe Challenge? <0>klicka här</0>", "pausasmart.get_started.subtitle": "Vänligen välj det alternativ som stämmer in på dig:", "pausasmart.get_started.title": ["Hej ", ["name"], ", välkommen till Pausa Smart Challenge"], "pausasmart.purchase.contact": "Kontakt: <0>business@yogobe.com</0>", "pausasmart.purchase.desc": "Vi är väldigt glada att du och din organisation är intresserade av att komma igång med Pausa Smart Challenge. Detta är ett program som vi har tagit fram med bas i de behov och önskemål som våra företagskunder givit uttryck för. En fyra veckors utmaning och digitalt verktyg för fysisk och mental hälsa som är perfekt för dem som jobbar på distans, för team som träffas remote och arbetsplatser där man önskar inspiration och vägledning för rörelse och reflektion i vardagen.  För endast 5000 SEK i engångsavgift får samtliga era medarbetare tre månaders obegränsad access till utmaningen. Det spelar ingen roll om ni är 100 eller 10 000 anställda. Välkommen till ett unikt erbjudande som är specialanpassat för nuvarande Covid-19 situation. För att komma igång, kontakta oss via email!", "pausasmart.purchase.title": "Hej, välkommen till Pausa Smart Challenge!", "payment.modal.banktransfer.info": "Yogobe samarbetar med Trustly så att du tryggt och säkert kan föra pengar till oss direkt från ditt bankkonto. Förnya eller avbryt enkelt och säkert. Din prenumeration har ingen bindningstid.", "payment.modal.cardpayment.info": "Yogobe samarbetar med Nets/DIBS så att du skall kunna betala ditt medlemskap hos oss med ditt VISA eller Mastercard. Enkelt, säkert och lätt att förnya eller avbryta då din prenumeration inte har någon bindningstid", "payment_modal.banner.active_subscription_upgrade": "Vi är glada att du vill förlänga/ändra din prenumeration. Du betalar i all enkelhet direkt från ditt bankkonto eller med ett bank/betalkort. Om du vill avbryta i framtiden så gör du det med en snabb knapptryckning.", "payment_modal.banner.inactive_subscription_upgrade": "Vi är glada att du vill uppgradera ditt medlemskap till prenumeration. Du är nu bara några knapptryckningar från obegränsad åtkomst till biblioteket, playlists, progran och utmaningar. Betala i all enkelhet direkt från ditt bankkonto eller med ett bank/betalkort. Ifall du vill avbryta i framtiden så sker det med en snabb knapptryckning.", "payment_modal.banner.subscription_upgrade": "Vi är glada att du vill uppgradera ditt medlemskap med en prenumeration hos oss. Du betalar i all enkelhet direkt från ditt bankkonto eller med ett bank/betalkort. Om du i framtiden vill avbryta så sker det snabbt med en knapptryckning.", "payment_modal.banner.trial_upgrade": "Vi är glada att du vill inleda en prenumeration. Du betalar i all enkelhet direkt från ditt bankkonto eller med ett bank/betalkort. Eventuella kvarvarande accessdagar adderas givetvis automatiskt till din första prenumerationsperiod. Ifall du vill avbryta framöver så sker det snabbt med en knapptryckning.", "payment_modal.banner.unverified_trial_upgrade": "Vi är glada att du vill inleda en prenumeration. Vi ser att du inte ännu har verifierat din mailadress. Så snart du gör det så aktiveras ditt konto och du får tillgång till den gratis provperiod med Yogobe som vi lovat dig. Om du utöver denna gratisperiod vill uppgradera ditt medlemskap till prenumeration så kan du enkelt och lätt betala direkt från ditt bankkonto eller med ett bank/betalkort. OBS: När du väljer att verifiera din mailadress så adderas din innestående provperiod automatiskt till din första prenumerationsperiod. ", "payment_modal.error": "Vi älskar att du vill bli betalande medlem på Yogobe. Just nu utför vi underhållsarbete på vår betalmodul och beräknar vara klara under onsdagen. Till dess har du gratis tillgång till allt innehåll i videobiblioteket! Välkommen tillbaka hit då!", "payment_modal.payment_method.card.label": "Betala med kort", "payment_modal.payment_method.trustly.submit_button": "Fortsätt med bankbetalning via", "paymentconfirmation.btn1": "Stäng", "paymentconfirmation.btn2": "Visa kvitton", "paymentconfirmation_subscription.modal.body": ["Din betalning om ", ["paymentAmount"], " har mottagits och vi bekräftar att ditt konto har uppgraderats med en löpande prenumeration per ", ["subscriptionType"], " som förnyas automatiskt den ", ["recurringDate"], " med ", ["recurringPaymentAmount"], "."], "paymentconfirmation_subscription.modal.title": "Betalningsbekräftelse", "paymentverification_modal.body": "Vi är glada att du vill uppgradera ditt medlemskap hos oss. För att bekräfta ditt betalkort och genomföra din önskade prenumerationsbetalning kommer NETS, vår betalleverantör, först reservera 1 SEK. Detta är en del i processen av säkra kortbetalningar.", "phasedProgram.introduction.label": "Introduktion", "phasedProgram.moodtracker.post.description": "Hur känner du dig nu? Checka in med dig själv för att känna hur du mår efter övningen genom att fylla i denna mood-tracker.", "phasedProgram.moodtracker.post.start_button": "Gå vidare", "phasedProgram.moodtracker.post.title": "Hur mår du nu?", "phasedProgram.moodtracker.pre.description": "Ta en kort stund för att checka in hur du mår genom att fylla i denna korta mood-tracker. Det tar inte mer tid än några långa, djupa andetag.", "phasedProgram.moodtracker.pre.start_button": "Fortsätt", "phasedProgram.moodtracker.pre.title": "Hur mår du?", "phasedProgram.moodtracker_modal.post.description": "Hur känner du dig nu? Checka in med dig själv för att känna hur du mår efter övningen genom att fylla i denna mood-tracker.", "phasedProgram.moodtracker_modal.post.title": "Hur mår du nu?", "phasedProgram.moodtracker_modal.pre.description": "Ta en kort stund för att checka in hur du mår genom att fylla i denna korta mood-tracker. Det tar inte mer tid än några långa, djupa andetag.", "phasedProgram.moodtracker_modal.pre.title": "Hur mår du?", "phasedProgram.moodtracker_modal.submit_button": "Spara och stäng", "phasedProgram.outro.videos_count": [["videosCount"], " Videor"], "phasedProgram.phase.number": ["Fas ", ["number"]], "phasedProgram.phase.number_weekRange": ["Fas ", ["phaseNumber"], ": vecka ", ["weekRange"]], "phasedProgram.phase.videos_duration": [["videosCount"], " Videor - ", ["duration"]], "phasedProgram.phase.weekRange": ["Vecka ", ["weekRange"]], "phasedProgram.phase_progress.text": "Progressen visar antalet videor du har slutfört utav alla videor denna vecka.", "phasedProgram.postsurvey.requirement_notification": "Utvärderingen är nu tillgänglig, <0>klicka här</0> för att göra den.", "phasedProgram.presurvey.requirement_notification": "För att låsa upp videorna och för att kunna starta programmet behöver du slutföra uppstartsfolumäret i Fas 1. Eller <0>klicka här</0> för att öppna den.", "phasedProgram.survey.post.description": "Denna enkät kommer ta mellan 10-15 minuter att slutföra. Se gärna detta som en möjlighet att lära känna dig sjäv bättre. Försök att vara uppriktigt mot dig själv, det finns inga svar som är rätt eller fel. Dina svar kommer vara en mycket viktig del till denna forskningsstudie.", "phasedProgram.survey.post.start_button": "Gå vidare", "phasedProgram.survey.post.title": "Utvärdering", "phasedProgram.survey.pre.description": "Denna enkät kommer ta mellan 10-15 minuter att slutföra. Se gärna detta som en möjlighet att lära känna dig sjäv bättre. Försök att vara uppriktigt mot dig själv, det finns inga svar som är rätt eller fel. Dina svar kommer vara en mycket viktig del till denna forskningsstudie.  För att delta i studien behöver du uppfylla följande kriterier: (1) Du är över 18 år; (2) Du har inte någon klinisk diagnos av depression, ångest eller stress; (3) Du är för närvarande inte under psykologisk eller psykiatrisk behandling, eller tar medicin för diagnostiserad psykisk sjukdom; (4) Du har inte en omfattande tidigare erfarenhet eller nuvarande yoga/mindfulness/meditationspraktik; (5) Du har tid och engagemang för att genomföra programmets föreläsninga veckovis och dagliga meditationsövningar; (6) Du har daglig tillgång till internet och förmåga att använda en persondator.", "phasedProgram.survey.pre.start_button": "Fortsätt", "phasedProgram.survey.pre.title": "Uppstartsenkät", "phasedProgram.week.number": ["Vecka ", ["number"]], "playlist.created_by": "Created by", "playlist.empty_plalist": "Denna playlist är tom", "playlist.playlist_deleted": "Playlist borttagen", "playlist.playlist_title": "Playlist", "playlists.browse_by_categories": "Utforska våra playlist-kategorier ", "playlists.browse_category": "Kategorier", "playlists.empty_description": "Du har inte skapat någon playlist ännu", "playlists.get_started": "Rekommenderade playlists", "playlists.title": "playlists", "playlists.view_my_playlist": "Se mina playlists", "playlistscollectionsubheadersection.title": "Playlistsamlingar", "position.other_yoga_positions": "Andra yogapositioner", "position.other_yoga_styles": "Ytterligare yogaformer", "premium_banner_card.get_started": "Kom igång", "pricing.monthly": "Månadsprenumeration", "pricing.option1": "Videor, playlists, program och utmaningar", "pricing.option2": "Enkelt och tillgängligt", "pricing.option3": "Ingen bindningstid", "pricing.option4": "Använd ditt friskvårdsbidrag", "pricing.quarterly": "Kvartalsprenumeration", "pricing.yearly": "Årsprenumeration", "pricing_section.bullets.option1": "Videor, playlists, program och utmaningar", "pricing_section.bullets.option2": "Enkelt och tillgängligt", "pricing_section.bullets.option3": "Ingen bindningstid", "pricing_section.bullets.option4": "Använd ditt friskvårdsbidrag", "pricing_section.plan.annually.body": "Betala årsvis. Motsvarande 158 SEK/månad. Spara 369 SEK", "pricing_section.plan.annually.label": "12 månader", "pricing_section.plan.annually.title": "Årsprenumeration", "pricing_section.plan.best_value": "Mest prisvärt", "pricing_section.plan.button_text": "Aktivera", "pricing_section.plan.monthly.body": "189 SEK betalas månadsvis", "pricing_section.plan.monthly.label": "1 månad", "pricing_section.plan.monthly.title": "Månadsprenumeration", "pricing_section.plan.quarterly.body": "Betala kvartalsvis. Motsvarande 166 SEK/månad. Spara 68 SEK", "pricing_section.plan.quarterly.label": "3 månader", "pricing_section.plan.quarterly.title": "Kvartalsprenumeration", "pricing_section.plan.trial.body": "Obegränsad access utan att ange kortuppgifter.", "pricing_section.plan.trial.button_text": "Testa gratis 14 dagar", "pricing_section.plan.trial.price": "Gratis", "pricing_section.plan.trial.title": "Prova 14 dagar", "pricing_section.title": "Bli betalande medlem och få obegränad tillgång till videobiblioteket", "pricing_section.yearly_offers_description": "Välj ett av två tidsbegränsade erbjudanden <0>Läs mer</0> ", "prisonyoga.insperational": "Extramaterial: Föreläsningar och klasser", "prisonyoga.moreabout": "Mer om denna satsning och initiativ", "prisonyoga.readmore": "Läs mer", "prisonyoga.relatedPrograms": "Specialframtagna videobaserade program", "prisonyoga.startPracticingEnglish": "Playlists anpassade för engelsktalande medlemmar", "prisonyoga.startPracticingSwedish": "Playlists anpassade för svensktalande medlemmar", "prisonyoga.teachersInvolved": "Involverade yogalärare och profiler", "prisonyoga.testimonials": "Åsikter från utövare", "prisonyoga.title": "Välkommen till Prison Yoga Project Skandinavien", "profileheader.privacy_settings": "Sekretessinställningar", "profileheader.view_public_profile": "Se publik profil", "program.backtoprogram": "Tack att du svarar. Klicka här för att gå tillbaka till programmet när du är klar.", "program.description": "Våra träningsprogram består av videor från biblioteket i ett format som är lätt att följa samtidigt som du får fördjupade kunskaper inom området.", "program.duration": [["value"], " ", ["unit"], " program"], "program.introduction_show_less": "Dölj text", "program.introduction_show_more": "Läs mer", "program.phaseCompletion": ["Genomfört: ", ["progress"], "%"], "program.quizAction": "Svara på 4 snabba", "program.quizCount": [["quizCount"], " quiz"], "program.title": "Välj ett träningsprogram", "program.video.repeat_explanation": "Detta är det rekommenderade antalet gånger du ska repetera denna session.", "program.videosCount": [["videoCount"], " Videor"], "program.videosTotal": [["videoCount"], " videor sammanlagt"], "program.weekCount": [["weekCount"], " veckors"], "program.weekCountShort": [["weekCount"], " vecka"], "program.whatToDoNextContinueProgress": "Fortsett My Progress", "program.whatToDoNextNextVideo": "Ta del av nästa session", "programs.duration": "Program 30 dagar", "programs_2021.banner.already_verified": "Redan verifierad?", "programs_2021.banner.verify_account": "Bekräfta ditt konto genom att verifiera din mailadress. Då kan du direkt joina programmen.", "programs_2021.buy_gift.banner_text": "Du köper nu detta program som en gåva till någon annan. Om det är du själv som vill få access, <0>klicka här</0>", "programs_2021.buy_gift.buyer_name.input_label": "Från", "programs_2021.buy_gift.buyer_name.input_placeholder": "Förnamn", "programs_2021.buy_gift.code_label": "Rabattkod", "programs_2021.buy_gift.confirmation_modal_text": ["Din betalning om ", ["paymentAmount"], " har gått igenom. Du kommer nu att få ett email som innehåller vidare instruktioner!"], "programs_2021.buy_gift.custom_message.input_label": "Skriv en egen hälsning till mottagaren (valfri)", "programs_2021.buy_gift.description": "Vi är glada att du vill ge detta program som gåva till en vän!", "programs_2021.buy_gift.description_tooltip": "Efter genomförd betalning så får du ett email innehållande en unik köpkod och instruktioner hur programmet aktiveras", "programs_2021.buy_gift.direct_email.checkbox_label": "Skicka denna gåva direkt till mottagaren", "programs_2021.buy_gift.direct_email.tooltip_text": "Om detta alternativ är ikryssat så kommer mottagaren av denna gåva automatiskt få ett email som inkluderar gåvokortet/koden och instruktioner hur man aktiverar den. Kryssa ur rutan om du istället själv skulle vilja skicka/dela detta med mottagaren!", "programs_2021.buy_gift.go_courses_btn": "Utforska kurser", "programs_2021.buy_gift.go_dashboard_btn": "Gå till Översikt", "programs_2021.buy_gift.go_programs_btn": "Utforska program", "programs_2021.buy_gift.meta_title": ["Yogobe program - ", ["title"]], "programs_2021.buy_gift.recipient_email.input_label": "Mottagarens emailadress", "programs_2021.buy_gift.recipient_name.input_label": "Till (mottagarens namn)", "programs_2021.buy_gift.send_email_directly_label": "programs_2021.buy_gift.send_email_directly_label", "programs_2021.card.sale_tag": "Specialpris", "programs_2021.contact.contact_text": "Kontakt: <0>business@yogobe.com</0>", "programs_2021.contact.desc": "Vad roligt att du och din organisation är intresserade av att komma igång med Yogobe. Digitalt, demokratiskt, lättillgängligt och enkelt att komma igång. Tillsammans tar vi fram och skräddarsyr innehåll och stöd med syfte att främja såväl fysisk och mental hälsa inom företag och organisationer för individ och medarbetare. Ett programformat är perfekt för team som träffas remote och arbetsplatser där man önskar inspiration och vägledning för rörelse i vardagen där allas olika intressen och behov tas i beaktning - det finns alltså något för alla. För att komma igång, kontakta mig via email!", "programs_2021.contact.purchase_banner_back": "Tillbaka", "programs_2021.contact.title": "Hej, välkommen till Yogobe program! ", "programs_2021.expiration_banner.expire_soon.buy_program_text": ["Din access till detta program går ut om ", ["days"], " dagar. Förläng med ytterligare en period. Givetvis sparas din data. <0>Betalar du med friskvårdsbidrag?</0>"], "programs_2021.expiration_banner.expire_soon.renew_access_free_text": ["Din access till detta program går ut om ", ["days"], " dagar. Förläng för ytterligare en period, helt utan kostnad. Givetvis sparas din data. <0>Betalar du med friskvårdsbidrag?</0>"], "programs_2021.expiration_banner.expire_soon.renew_free_button": "Förläng åtkomst", "programs_2021.expiration_banner.expire_soon.upgrade_button": "Uppgradera nu", "programs_2021.expiration_banner.expire_soon.upgrade_to_renew_text": ["Din access till detta program går ut om ", ["days"], " dagar. Uppgradera till en betalande prenumeration så ingår obegränsad tillgång till detta program. Din tidigare data sparas."], "programs_2021.expiration_banner.expired.buy_program_text": ["Din access till detta program gick ut för ", ["days"], " dagar sedan. Du är välkommen att förnya och förlänga! Din tidigare data har sparats."], "programs_2021.expiration_banner.expired.renew_access_free_text": ["Din access till detta program gick ut för ", ["days"], " dagar sedan. Förnya nu helt utan kostnad. Din tidigare data har sparats."], "programs_2021.expiration_banner.expired.renew_free_button": "Återaktivera nu", "programs_2021.expiration_banner.expired.renew_with_discount_text": ["Din access till detta program gick ut för ", ["days"], " dagar sedan. Förnya din access och få ", ["discount"], " rabatt. Givetvis sparas din data. <0>Betalar du med friskvårdsbidrag?</0>"], "programs_2021.expiration_banner.expired.upgrade_to_renew_text": ["Din access till detta program gich ut för ", ["days"], " dagar sedan. Uppgradera till en betalande prenumeration så ingår obegränsad tillgång till detta program. Din tidigare data har sparats."], "programs_2021.expiration_banner.expires_soon.extend_with_discount_text": ["Din access till detta program går ut om ", ["days"], " dagar. Förläng redan idag för en ny period och få ", ["discount"], " rabatt. Givetvis sparas din data. <0>Betalar du med friskvårdsbidrag?</0>"], "programs_2021.expiration_banner.extend_button": ["Förläng för bara ", ["price"]], "programs_2021.get_started.access_code.icon_text": "Du behöver en accesskod för att komma åt programmet. En sådan kan du tex få från en arbetsgivare, vårdgivare, organisation eller partner till Yogobe. Det kan också vara ett presentkort från en vän.", "programs_2021.get_started.access_code.not_valid": "Acesskoden du angav är ogiltig! ", "programs_2021.get_started.access_code.tooltip_text": "Om du har blivit tilldelad en accesskod som ger dig tillgång till ett specifikt program så kan du använda koden här", "programs_2021.get_started.access_code.valid": "Koden har registrerats", "programs_2021.get_started.access_code_mismatch": "Denna kod är giltig men aktiverar ett annat program", "programs_2021.get_started.access_code_only_description": "Välkommen! <br/> Du kommer enbart åt detta program via en accesskod som du får antingen direkt från Yogobe eller via en partner till oss så som du arbetsgivare eller förening.", "programs_2021.get_started.activation_error": "Vi kunde inte aktivera detta program för dig, vänligen ta kontakt med oss på info@yogobe.com", "programs_2021.get_started.button.activate_for_free": "Starta programmet", "programs_2021.get_started.button.continue_trial": "Fortsätt med 14 dagar gratis", "programs_2021.get_started.button.login": "Logga in och gå vidare", "programs_2021.get_started.button.purchase": "Fortsätt till säker betalning", "programs_2021.get_started.button.start_suscription": "Inled en prenumeration", "programs_2021.get_started.buy_gift_btn": "Köp som gåva", "programs_2021.get_started.code_label": "Din unika kod", "programs_2021.get_started.description": "Vi är glada att du vill joina detta program. Logga in eller skapa ett konto för att fortsätta. Program och utmaningar är del i Yogobe's prenumerationserbjudande samt företagspaket.", "programs_2021.get_started.discount_amount": "Rabatt", "programs_2021.get_started.end_of_access": "Åtkomst till", "programs_2021.get_started.guest_title": ["Välkommen till ", ["program"]], "programs_2021.get_started.join_btn": "Starta program", "programs_2021.get_started.payment_amount": "Att betala", "programs_2021.get_started.purchase_banner_text": "Företräder du ett företag eller organisation som vill utforska digitala program för friskvård och hälsa? <0>Klicka här</0>", "programs_2021.get_started.show_code_input": "Har du en accesskod? <0>Klicka här</0>", "programs_2021.get_started.show_code_input_description": "Detta är en kod som man får genom sin arbetsplats eller organisation.", "programs_2021.get_started.user_title": ["Hej ", ["name"], ", välkommen till ", ["program"]], "programs_2021.get_started_loggedin.description": "Vi är glada att du vill joina detta program. Program och utmaningar är del i Yogobe's prenumerationserbjudande samt företagspaket.", "programs_2021.header.access_until": ["Din access till detta program går ut den ", ["date"]], "programs_2021.header.buy_as_gift": "Köp som gåva", "programs_2021.header.extend_access": "Förläng access", "programs_2021.listing_page.hero.no_premium_disclaimer": "*Vi har tre olika prenumerationstyper du kan välja bland: månads-, kvartals-, eller årsprenumeration. Från 189 SEK.", "programs_2021.listing_page.hero.premium_disclaimer": "*Så länge du har en aktiv prenumeration eller accesstid så har du åtkomst till program och utmaningar.", "programs_2021.listing_page.legacy_programs_banner": "Välkommen till ny programstruktur! Saknar du ett program? <0>Gå tillbaka till gamla sidan</0>", "programs_2021.listing_page.meta.description": "Utforska Yogobe’s onlineprogram för yoga, mindfulness, nybörjarträning, stresshantering och mycket mer. Läs mer", "programs_2021.listing_page.meta.title": "Skräddarsydda videobaserade program online", "programs_2021.listings_page.clear_events_filters": "Återställ Filter & sök", "programs_2021.listings_page.explore_programs_btn": "Utforska program", "programs_2021.listings_page.faq_btn": "Vanliga frågor", "programs_2021.listings_page.filter_applied_toaster": "Filter sparade", "programs_2021.listings_page.filters.instructors": "Alla lärare", "programs_2021.listings_page.filters.kind_theme": "Alla teman", "programs_2021.listings_page.filters.languages": "Visa mig program på", "programs_2021.listings_page.filters.sort_alphabetically": "Sortera i alfabetisk ordning (A-Z)", "programs_2021.listings_page.filters.sort_by": "Sortera efter", "programs_2021.listings_page.filters.sort_duration": "Sortera på längd", "programs_2021.listings_page.filters.sort_new": "Sortera nyast först", "programs_2021.listings_page.hero_title": "Utforska program", "programs_2021.listings_page.load_more_btn": "Visa fler", "programs_2021.listings_page.no_programs_found": "Hoppla! Vi lyckas inte hitta ett program som är en perfekt match på ditt/dina sökord eller valda filter. Det som du letar efter kan fortfarande finnas hos oss. Snälla förnya din sökning eller ändra dina video- och filterninställningar!", "programs_2021.listings_page.option4": "User your fringe health benefits", "programs_2021.listings_page.pricing_section.title": "Uppgradera nu och få tillgång till samtliga program", "programs_2021.listings_page.search_input_placeholder": "Sök program...", "programs_2021.listings_page.subtitle": "Välkommen till Yogobe's program – specialframtagna för att möta flera olika behov och intressen. Utforska programmen idag och delta i ett eller flera.", "programs_2021.overview.text_card.locked_text": ["Gå med i ", ["programType"], " for å ta del av inneholdet. "], "programs_2021.pricing.free": "Gratis", "programs_2021.pricing.free_for_you": "Ingår i din prenumeration", "programs_2021.pricing.included_in_subscription": "Ingår i prenumeration", "programs_2021.program_card.program_access_label": "Du har access", "programs_2021.program_card.program_expire_soon": "Access upphör snart", "programs_2021.program_card.program_expired": "Access har upphört", "programs_2021.program_page.breadcrumb": "Yogobe programs", "programs_2021.program_purchase.confirmation_modal_text": ["Din betalning om ", ["paymentAmount"], " har gått igenom. Du kan sätta igång nu direkt eller när det passar dig!"], "programs_2021.program_purchase.get_started": "Kom igång", "programs_2021.program_purchase.go_dashboard_btn": "Gå till Översikt", "programs_2021.programs.instructors_modal_title": ["Lärare i ", ["program"]], "programs_2021.programs.other_instructors_count": [["number"], " fler"], "programs_2021.progress_page.video_lock.button_text": "Delta i programmet", "programs_2021.progress_page.video_lock.text": "Du har precis sett en förhandsvisning på 60 sekunder. Vill du logga in eller starta detta program nu?", "programs_2021.snackbars.access_granted": "Du deltar nu i detta program", "programs_2021.themes.athletes": "Idrottare ", "programs_2021.themes.beginner": "Nybörjare", "programs_2021.themes.breathing": "Andning", "programs_2021.themes.diet_and_nutrition": "Kost & nutrition", "programs_2021.themes.meditation": "Meditation", "programs_2021.themes.mobility_and_prehab": "Mobilitet & prehab", "programs_2021.themes.personal_growth": "Personlig utveckling", "programs_2021.themes.philosophy": "Filosofi & spiritualism", "programs_2021.themes.postnatal": "Nybliven mamma", "programs_2021.themes.prenatal": "Gravid", "programs_2021.themes.restoration": "Återhämtning", "programs_2021.themes.skills": "Kunskap & teknik", "programs_2021.themes.smart_breaks": "Pausa Smart", "programs_2021.themes.stress_and_anxiety": "Stress & oro", "programs_2021.themes.womens_health": "Kvinnohälsa", "programs_2021.themes.workout": "Träning", "programs_2021.themes.yoga": "Yoga", "programs_2021.themes.yoga_teachers": "Yogalärare", "programs_2022.progress.program_recomendation_hide": "Dölj", "programs_2022.progress.program_recomendation_show": "Visa", "programs_2022.progress.program_tip": "Tips till dig", "programs_2022.survey.close_modal_button": "Stäng", "programs_2022.survey.draft_saved": "Dina svar har sparats som utkast", "programs_2022.survey.edit_survey_btn": "Se eller ändra dina svar", "programs_2022.survey.exit_alert": "Du har gjort ändringar utan att spara och skicka in. Är du verkligen säker på att du vill lämna sidan?", "programs_2022.survey.last_submit": ["Du har skickat in dina senaste svar den ", ["date"]], "programs_2022.survey.start_survey_btn": "Fortsätt", "programs_2022.survey.submit_answers_btn": "Skicka svar", "programs_2022.survey.thank_you_desc": "Tack för dina svar! Din input är oerhörd värdefull för oss.", "programs_2022.survey.thank_you_title": "Tack!", "programs_body.read_more": "Läs mer", "programs_legacy_listing.banner_message": "Vi har flyttat ett antal program till vår nya programstruktur. <0>Spana in dem</0>", "programs_listing.faq.item1.body": "Samtliga program ingår för dig som är aktiv medlem på Yogobe. Du kan också gå med i ett program om du har en prova-på-period, men du har då endast tillgång till programmet så länge du har aktiv access.", "programs_listing.faq.item1.title": "Vem kan delta i ett program?", "programs_listing.faq.item2.body": "När du har gått med i ett program (vilket du gör genom att klicka på knappen “Kom igång” på det programmet du är intresserad av) så kommer du därefter alltid, när du är inloggad på ditt Yogobe-konto, att komma åt det på din <0>Översikt</0> för enkel åtkomst.", "programs_listing.faq.item2.title": "Hur kommer jag åt mitt program?", "programs_listing.faq.item3.body": "Självklart kan du det! Du kan delta i precis så många program som du vill. Om du går med i flera program under samma dag kommer du däremot endast att få mail kopplat till det första programmet du gick med i. Detta för att du inte ska få alltför många mail.", "programs_listing.faq.item3.title": "Kan jag delta i flera program samtidigt?", "programs_listing.faq.item4.body": "Nu får våra program en liknande design och struktur som våra befintliga program inom Yogobe Challenge. Genom detta upplägg blir det lättare för dig som användare att faktiskt delta i ett program och kan följa din utveckling på ett annat sätt. Det är också enklare för dig att följa ett program och på så vis få den guidning som programmen är ämnade till att ge dig.", "programs_listing.faq.item4.body2": "Det finns två flikar för varje program – “Översikt” och “Min utveckling”. Under “Översikt” hittar du all information om programmet och får en översikt över varje vecka/del som ingår i programmet. Under “Min utveckling” kommer du till en vy där du enkelt ser vilka videor som hör till vilken vecka/del och vad du redan har genomfört.", "programs_listing.faq.item4.title": "Vad innebär den nya programdesignen och upplägget?", "programs_listing.faq.item5.body": "Självklart! Vi har många olika företagslösningar och skräddarsyr gärna för att hitta något som passar just era önskemål och behov. Maila oss på <0>business@yogobe.com</0> så berättar vi mer.", "programs_listing.faq.item5.title": "Kan företag köpa enskilda program?", "programs_listing.faq.item6.body": "I dagsläget är programmen, likt Yogobe Challenge, endast tillgängliga via hemsidan Yogobe.com. Självklart kan du gå in i en webbläsare i din smartphone och komma åt programmet i mobilen på det sättet.", "programs_listing.faq.item6.title": "Kan jag ta del av programmen i appen?", "programs_listing.faq.item7.body": "Att <0>prova-på Yogobe</0> är helt gratis, kräver inga betaluppgifter och det är aldrig någon bindningstid. En prova-på-period på Yogobe övergår aldrig automatiskt till en betalande prenumeration. Efter din prövotid får du välja om du vill uppgradera ditt medlemskap till en löpande prenumeration och betala via bankbetalning, kort eller via en av de  <0>friskvårdsleverantörer som vi</0> arbetar med. Enkelt och lätt. Som inloggad hittar du <0>prenumerationssidan</0> via användarmenyn och du kan där ta del av våra olika erbjudanden om månads-, kvartals- eller årsprenumeration.", "programs_listing.faq.item7.title": "Hur blir jag betalande medlem på Yogobe?", "programs_listing.walkthrough_section.subtitle": "I denna video visar vi hur enkelt du kommer igång med ditt valda program, samt visar dig hur du navigerar mellan de olika vyerna i programmet. Gå med i ett program redan idag!", "programs_listing.walkthrough_section.title": "Så här kommer du igång", "promotions.code_apply.fallback_failure_message": "Denna kod existerar tyvärr inte eller så är erbjudandet inte längre giltigt", "public_profile.error_msg": "Vi verkar inte kunna ladda denna profilen. Snälla ladda om sidan eller försök igen om en liten stund.", "quickstart.awesome_message": ["Super! Här har du några ", ["yogaDuration"], " videor som är ", ["yogaType"]], "quickstart.awesome_message_yogaTypeCalm": "lugna", "quickstart.awesome_message_yogaTypeIntensive": "fysiska", "quickstart.cancel": "Avbryt", "quickstart.go_back": "Gå tillbaka", "quickstart.hide_this": "Dölj", "quickstart.something_physical": "Något fysiskt och pulshöjande", "quickstart.something_relaxing": "Något lugnt och återhämtande", "quickstart.start_message": [["name"], ", vill du få hjälp att snabbt och enkelt välja en video?"], "quickstart.time_you_have": "Toppen! och hur mycket tid har du just idag?", "quickstart.todo_today": "Kul, börja med att berätta vad du är ute efter!", "quickstart.try_quickstart": "Testa Quickstart", "receipts.check_premium": "Utforska medlemsalternativ", "receipts.empty_description": "Du är en icke-betalande medlem hos oss på Yogobe. Kanske vill du uppgradera ditt medlemskap?", "receipts.empty_title": "Du har inga kvitton ännu", "receipts.payment_made": "Vi har tagit emot din betalning och du kan hitta ditt kvitto på denna sida", "receipts.title": "Kvitton", "reclaim_trial.body": "reclaim_trial.body", "reclaim_trial.confirmation.generic_error": "reclaim_trial.confirmation.generic_error", "reclaim_trial.confirmation.progress_text": "reclaim_trial.confirmation.progress_text", "reclaim_trial.confirmation.success": "reclaim_trial.confirmation.success", "reclaim_trial.dashboard_btn": "reclaim_trial.dashboard_btn", "reclaim_trial.intro": "reclaim_trial.intro", "reclaim_trial.title": "=======", "reclaim_trial_modal.claim_btn": "Ja takk!", "reclaim_trial_modal.desc": "Vi er glade for å ha deg tilbake hos oss og vil gjerne gi deg muligheten til å utforske Yogobe Play <b>gratis<b> i 14 dager. Vil du komme i gang?", "reclaim_trial_modal.not_intrested_btn": "Nei takk, ikke interessert", "reclaim_trial_modal.not_intrested_btn<<<<<<< HEAD": "Nei takk, jeg er ikke interessert>>>>>>> develop=======>>>>>>> develop", "reclaim_trial_modal.title": "Vil du prøve Yogobe gratis i 14 dager?", "reclaim_trial_page.body": "Du vil automatisk bli sendt til din oversiktsside hvis", "reclaim_trial_page.confirmation.generic_error": "En ny testperiode kan ikke reaktiveres for deg. Ta gjerne kontakt med oss ​​på <0>info@yogobe.com</0>", "reclaim_trial_page.confirmation.progress_text": "Din nye prøveperiode er aktivert...", "reclaim_trial_page.confirmation.toaster_message": "Kontoen din har blitt oppgradert med 14 dagers tilgang til Yogobe Play.", "reclaim_trial_page.dashboard_btn": "Eller klikk fortsett", "reclaim_trial_page.desc": "Din nye prøveversjon er aktivert! Du kan allerede begynne å utforske alt innhold og funksjonene til Yogobe Play.", "reclaim_trial_page.title": "14 dagers prøveperiode", "register.tooltip.message": "När du blir medlem på Yogobe så får du automatiskt en gratis prova-på period. Uppgradera när du vill till månads-, kvartals-, eller årsprenumeration. Priser från (99 SEK). <br /> <br /> Om du har köpt en onlinekurs alternativt har fått en accesskod via din arbetsgivare eller en av våra partners så är det här du registrerar dig och skapar ditt egna personliga konto.<br /> <br /> <br /> Vi ses på insidan. Varmt välkommen! <br /> Peter Munteanu, VD och Grundare", "registration.access_code.valid": ["Din kod har bekräftats. Slutför din registration och få åtkomst till ", ["date"]], "registration.campaign_code.valid": ["Kampanjkoden är gitig. Du kommer få ", ["days"], " dagar gratis prova-på när du slutfört din kontoregistrering"], "registration.campaign_code_applied": ["<0>", ["code"], "</0> koden har verifierats. Fullfölj registreringen för åtkomst."], "registration.complete_profile.address": "Fyll i din adress", "registration.complete_profile.title2": [["name"], ", har du en kode?"], "registration.confirmation.generic_error": "<p>Fina medlem,</p> <p> Länken som du har tryckt på är inte längre giltig. Kanske har du råkat trycka på den tidigare eller dubbelt? Snälla försök ladda om sidan eller logga ut/in igen med dina inloggningsuppgifter. Om du fortfarande har utmaningar eller frågar, snälla tveka inte att höra av dig till oss på <a href=\"mailto:data@yogobe.com\">data@yogobe.com</a> </p> <p>Varma hälsningar,<br/> Peter</p>", "registration.confirmation.progress_text": "Bekräftar din mailadress...", "registration.confirmation.success": "Din mailadress har nu blivit verifierad! Snyggt.", "registration.continue_to_dashboard.btn": "Gå till Översikt", "registration.course.access_code_banner": ["<0>", ["code"], "</0> koden har applicerats. Fortsätt din registrering för att få tillgång till <0>", ["courseName"], "</0>."], "registration.course.banner": "Vi ser fram emot att dela denna kurs med dig. Skapa ett konto och slutför din betalning!", "registration.course_card.desc": "Du får ett års access till kursen och eventuellt tillhörande material.", "registration.course_card.title": "Utöver kursen så bjuder vi dig också på 14 dagar gratis testperiod av Yogobes omfattande videobibliotek.", "registration.cycle.12months.label": "12 månader", "registration.cycle.1month.label": "1 månad", "registration.cycle.3months.label": "3 månader", "registration.landing.alreadymember": "Har du redan ett Yogobe-konto? <0>Logga in</0>", "registration.landing.btn": "Fortsätt", "registration.landing.country": "Land", "registration.landing.email": "Mailadress", "registration.landing.firstname": "Förnamn", "registration.landing.headline": "Utforska yoga, meditation, träning och andning", "registration.landing.lastname": "Efternamn", "registration.landing.password": "Lösenord", "registration.landing.pricing.info": "Testa gratis, ingen bindningstid, inga bankuppgifter behövs", "registration.landing.pricing.text": "Mer information om ditt medlemskap och möjligheter", "registration.landing.socials_label": "Eller skapa ditt konto via", "registration.landing.subtitle": "Skapa ett konto för att se, spara och favoritmarkera tusentals videor", "registration.landing.tc": "Genom att fortsätta godkänner du våra <0>Villkor</0> och <1>Integritetspolicy</1>", "registration.landing.title": "Bli medlem på Yogobe", "registration.landing.usp1": "Forhåndsinnspilte lyd- og videoklasser online", "registration.landing.usp2": "LIVE-streamede klasser og arrangementer", "registration.landing.usp4": "Lag og del spillelister", "registration.onboarding.max_selected": "Avmarkera ett eller flera val för att välja nya!", "registration.payment.btn1": "Fortsätt till säker betalning", "registration.payment.btn2": "Tillbaka", "registration.payment.code_applied": "Din kod har godtagits", "registration.payment.discount.label": "Bonus rabatt", "registration.payment.nextpayment.body": ["Du kommer betala ", ["amount"], " nu.  <br/> Din prenumeration fortsätter sedan löpande ", ["cycle"], " med ", ["recurringAmount"], " - Avbryt när du vill"], "registration.payment.now.label": "Totalt:", "registration.payment.ordersummary.label": "Ordersammanfattning", "registration.payment.title": "Betalning", "registration.paymentfail.body": ["Något gick fel.. din betalning på ", ["amount"], " SEK gick inte igenom. Vänligen försök igen. Om problemen kvarstår, vänligen kontakta vår tekniska support: data@yogobe.com"], "registration.paymentfail.btn": "Gå tillbaka & försök igen", "registration.paymentfail.orderdetails.body": ["Transaktions-ID: ", ["transaction"]], "registration.paymentfail.title": "Betalningen misslyckades", "registration.paymentsuccess.body": ["Tack, din betalning på ", ["amount"], " ", ["currency"], " har mottagits. Ett kvitto kommer att skickas till ", ["email"]], "registration.paymentsuccess.btn": "Fortsätt", "registration.paymentsuccess.orderdetails.body": ["Order-ID: ", ["order"], "   |   Transaktions-ID: ", ["transaction"]], "registration.paymentsuccess.title": "Betalning lyckades!", "registration.plan.annually.body": "Betala årsvis. Motsvarande 158 SEK/månad. Spara 369 SEK", "registration.plan.annually.title": ["Årsprenumeration - ", ["amount"]], "registration.plan.btn": "Fortsätt till betalning", "registration.plan.code.info.tooltip": "En rabattkod ger dig en procentuell rabatt på en eller flera prenumerationsperioder. Vid frågor kring din rabattkod, kontakta info@yogobe.com", "registration.plan.code.info_text": "Har du en rabattkod?", "registration.plan.code.label": "Har du fått en rabattkod?", "registration.plan.code.success": "Din kod har godtagits", "registration.plan.codecamp.info.tooltip": "Om du har fått en kampanjkod från din yogalärare, instruktör eller en partner till Yogobe, så skriver du in den här och får en utökad gratis provperiod av vår prenumerationstjänst. Det är också här som du skriver in en kompiskod, ifall du har fått en sådan av en vän. OBS! Om du har en accesskod för temasidor, program etc – klicka dig vidare utan att fylla i något! ", "registration.plan.codecamp.info_text": "Skriv in eventuell kampanj- eller kompiskod.", "registration.plan.continue_btn": "Fortsätt", "registration.plan.monthly.body": "189 SEK betalas månadsvis", "registration.plan.monthly.title": ["Månadsprenumeration - ", ["amount"]], "registration.plan.or_subscription.desc": ["Du kan enkelt välja att inleda en prenumeration direkt. Dina ", ["days"], " gratisdagar adderas automatiskt till din första betalperiod."], "registration.plan.or_subscription.title": "Eller välj den prenumerationtyp som passar dig", "registration.plan.quarterly.body": "Betala kvartalsvis. Motsvarande 166 SEK/månad. Spara 68 SEK", "registration.plan.quarterly.title": ["Kvartalsprenumeration - ", ["amount"]], "registration.plan.title": "Välj gärna en prenumerationform som passar dig", "registration.plan.trial.body": "Testa gratis, inga betaluppgifter krävs", "registration.plan.trial.btn_text": "Gå vidare", "registration.plan.trial.title": ["Hej ", ["name"], ", fortsätt med din ", ["days"], "-dagars prova-på-period"], "registration.plan.usp.title": "Detta ingår för aktiva prenumerationsmedlemmar:", "registration.plan.usp1": "Spara, dela och lägg till videor i egna playlists.", "registration.plan.usp2": "Obegränsad tillgång till 2100+ videor och 45+ program.", "registration.plan.usp3": "Enkelt att avbryta eller uppgradera", "registration.referral_code.valid": ["Din kod har aktiverats. Slutför din registrering och du kommer få ", ["days"], " dagar gratis prova-på tack vare din kompis"], "registration.trial_code_input.label": "Om du har fått en kampanjkodl, fyll i den här. OBS! Om du har en accesskod (för exempelvis en temasida, ett program eller en kurs) klicka dig vidare utan att fylla i något. ", "registration.verification1.intro": ["För att gå vidare, vänligen verifiera ditt konto genom att klicka på länken som vi har skickat till: <0>", ["email"], "</0>"], "registration.verification1.resend": "Har du inte fått verifieringsmailet? <0>Klicka här</0>", "registration.verification1.resend_failed": "Det gick inte att skicka mailet på nytt, vänligen försök igen eller kontakta vår support på info@yogobe.com", "registration.verification1.resend_success": "Mailet har skickats igen, vänligen kolla din inkorg!", "registration.verification1.title": "Verifiera ditt konto", "registration.verification2.body": "Du skickas snart vidare automatiskt...", "registration.verification2.btn": "Eller klicka och fortsätt", "registration.verification2.intro": "Ditt konto har nu verifierats! Allt är nu redo för dig att börja utforska Yogobe.", "registration.verification2.title": "Klart!", "registration.verify_email_toaster": ["Ett aktiveringsmail har skickats till ", ["email"], ". Aktivera och verifiera ditt konto och få din provperiod. Stämmer inte adressen? Kontakta info@yogobe.com"], "registration.wellness.learn_more": "Du vet väl att du kan använda ditt friskvårdsbidrag på Yogobe? <0>Läs mer</0>", "regsocial.best_value": "Mest prisvärt", "regsocial.feature1_desc": ["Obegränsad åtkomst till fler än ", ["videos_count"], " videor. Klasser, föreläsningar, workshops och mer, inom yoga, meditation, pilates, rörlighet, gravid- & mammaträning, kondition, core, stretch, löpcoachning etc. Var du vill, när du vill!"], "regsocial.feature1_title": [["videos_count"], "+ videor"], "regsocial.feature2_desc": "I samråd med Team Yogobe har vi satt samman korta och längre videobaserade program som består av innehåll från videobiblioteket och mer. Allt vi producerar och publicerar har sitt ursprung i ett uttryckt behov bland våra medlemmar.", "regsocial.feature2_title": "Hälsa och träningsprogram", "regsocial.feature3_desc": "Skapa, följ och dela playlists. Såväl dina egna som andras. Playlists är samlingar med audio- och videofiler som bl.a. erbjuder funktionen autoplay.", "regsocial.feature3_title": "Skapa Playlists", "regsocial.feature5_desc": "Som medlem på Yogobe är du del i en växande och autentisk gemenskap som genom åren vuxit sig stark och är en trygg plats där alla är välkomna för att möta och samtala med andra medlemmar. Just nu finner man lättast andra medlemmar via BEYOGA365, ett forum på Facebook. Alla förtjänar att ha verktyg och förutsättningar för att må bra. Fysiskt, mentalt och själsligt. Med bakgrund i detta strävar vi mot att guida, inspirera och ge stöd till individer, företag och organisationer inom hållbarhet genom att erbjuda kvalitativa tjänster, produkter, forum och sammanhang. ", "regsocial.feature5_title": "Community", "regsocial.getstarted": "Aktivera", "regsocial.hero_btn1": "Utforska medlemsalternativ", "regsocial.hero_btn2": "Testa gratis 14 dagar", "regsocial.hero_title": "Få obegränsad tillgång till vårt videobibliotek", "regsocial.hero_usp": "Enkelt - ingen bindningstid - ingen betalinformation behövs", "regsocial.live_desc": "Yoga, träna och meditera i realtid - med Yogobe LIVE. Praktisera tillsammans som ett Community under vägledning av Team Yogobe.", "regsocial.live_title": "LIVE – guidas i realtid", "regsocial.mobile_section.desc": "I vår iOS och Android app får du tillgång till hela biblioteket, playlists, offline-mode samt möjlighet att casta till TV.", "regsocial.mobile_section.title": "Utforska vår nya app", "regsocial.most_affordable": "Most Affordable", "regsocial.offer_description": "TA DEL AV ÅRSERBJUDANDE <0/> Inled en årsprenumeration hos YOGOBE och låt många av Nordens främsta yogalärare och träningsinstruktörer guida dig i videor online och offline inom yoga, meditation, pilates, rörelseträning, gravid- och mammaträning och mycket mer - ett bra sätt att hålla sig glad, stark och välmående. <0/> Vem kan ta del av prenumerationserbjudandet? <0/> <0/> Alla som inleder, uppgraderar eller aktivt förnyar* sin prenumeration hos Yogobe (till ordinarie pris, 1899 SEK, med VISA/Mastercard kortbetalning via våra betalsystem DIBS eller Trustly) får ett 500 SEK presentkort från Yogiraj att använda i Yogobe Store. <0/> <0/> Erbjudandet gäller till och med midnatt den 8 maj. I samband med att du tar del av detta erbjudande så får du automatiskt ett mail från oss med din unika presentkortskod. Presentkortet berättigar till köp av produkter till det angivna beloppet. Fraktkostnad täcks inte av presentkortet utan bekostas av köparen. Vi erbjuder förmånliga fraktkostnader och leverans sker inom 3 vardagar av din beställning. Presentkortet är giltigt fram till och med 31 december 2019 och kan inte bytas mot kontanter. Klicka på knappen och läs mer om detta erbjudande! <0/> <0/> Om Yogiraj (yogamattor och utrustning) <0/> Med inspiration från skogen, bergen, vidderna och havet har Yogiraj sitt ursprung i den nordiska naturen. Yogirajs mattor och utrustning är alltid giftfria och ofta ekologiska. Ge dig själv yoga med Yogiraj och lämna ett mindre ekologiskt fotavtryck samtidigt som du bryr dig om din kropp och planeten. <0/> <0/> Yogiraj har mängder av yogaprops - allt från bolster och meditationskuddar som innehåller ekologiskt bovete, till ögonkuddar, tunga bomullsfiltar och block i olika storlekar. Vi tycker också att Yogiraj erbjuder några av de allra bästa yogamattorna - allt från enklare all-round till den nya grip mattan för bikram och andra intensivare yogaformer. <0/> <0/> Bra att veta vid uppgradering av prenumeration <0/> Har du just nu en gratis `prova-på-period` så förlängs givetvis ditt år automatiskt med dina innestående dagar. <0/> Har du en aktiv prenumeration så ändras medlemsformen till ÅR och dragning sker idag. Kvarvarande accessdagar adderas självklart automatiskt. <0/> Vid ytterligare frågor, funderingar eller tankar tveka inte att skriva till oss: info@yogobe.com. <0/> <0/> Använd ditt friskvårdsbidrag <0/> Som betalande medlem på Yogobe kan du enkelt skriva ut dina kvitton via dina inställningar. Dessa kan du lämna in till din arbetsgivare som avgör ifall ditt medlemskap hos oss täcks av ditt friskvårdsbidrag. Om du är osäker på vad din arbetsgivare godkänner så ber vi först fråga dem om de godkänner användande av friskvårdsbidrag för onlinetjänster. <0/> Detta erbjudande om att få ett presentkort på Yogobe Store (värde 500 SEK) gäller inte dig som betalar för Yogobe via en friskvårdsleverantör så som Benify eller Actiway, då dessa inte är löpande prenumerationer utan engångsbetalningar till Yogobe. <0/> ", "regsocial.offer_title": "Ta del av vårt exklusiva årserbjudande", "regsocial.page_title": "Bli medlem", "regsocial.special_page_title": "Bli årmedlem", "regsocial.subscription_annually_billed": "Din prenumeration förnyas årligen.", "regsocial.subscription_annually_save": "Spara 369 SEK per år", "regsocial.subscription_free_plan_label": "Obegränsad access utan att ange kortuppgifter.", "regsocial.subscription_free_price_label": "Gratis", "regsocial.subscription_free_title": "Gratis prova-på", "regsocial.subscription_monthly_billed": "Din prenumeration förnyas varje månad.", "regsocial.subscription_monthly_per": "/ månad", "regsocial.subscription_quarterly_billed": "Förnyas varje kvartal och övergår automatiskt till ordinarie pris i kvartal två. ", "regsocial.subscription_quarterly_per": "/ kvartal", "regsocial.subscription_quarterly_save": "Spara 272 SEK per år", "regsocial.subscription_sub_title": "Starta en årprenumeration och få 500 SEK att handla Yogiraj för.", "regsocial.subscription_title": "Bli betalande medlem och få obegränsad tillgång till biblioteket", "regsocial.subscription_year_per": "/ år", "regsocial.testimonial_title": "Några rader från medlemmar", "reset_program.body": "Vil du byta från det program du påbörjat under Yogobe Spring Challenge? Under de kommande stegen kommer du få välja det program du önskar, men då också fylla i formuläret på nytt.", "reset_program.info": ["Din statistik för ditt befintliga program (", ["programName"], ") kommer att förloras. Är du säker på att du vill fortsätta?"], "reset_program.no": "Nej, låt mig behålla befintligt program", "reset_program.title": "Byta program", "reset_program.yes": "Ja, välj ett annat program", "schedule_modal.googlecalendar": "Exportera till Google Kalender", "schedule_modal.icp": "Spara i min kalender", "schedule_modal.time": "Tid", "schedule_modal.title": "Schemalägg", "search.category.blog.title": "Blogg", "search.category.challenges.title": "Utfordringer", "search.category.courses.title": "Kurs og utdannelser", "search.category.events.title": "Event", "search.category.instructors.title": "Lærere og eksperter", "search.category.live_events.title": "LIVE-online", "search.category.pages.title": "Kunnskap", "search.category.playlists.title": "Playlists", "search.category.programs.title": "Program", "search.category.video_audio.title": "Video og lyd", "search.filters.languages": "Språk", "search.go_back": "Tillbaka", "search.input_placeholder": "Søk på Yogobe...", "search.program_card.view_blog": "Les artikkelen", "search.program_card.view_challenge": "Vis utfordringen", "search.program_card.view_course": "Vis kurs", "search.program_card.view_live": "Se LIVE-klassen", "search.program_card.view_program": "Vis programmet", "search.result_found": "1 resultat funnet ", "search.results.many": [["count"], " resultat"], "search.results.one": [["count"], " resultat"], "search.results_found": [["totalCount"], " resultater funnet <0>for ", ["query"], "</0>"], "search.results_not_found": "Vi fant ingen resultater med dette eksakte søket. Prøv å omformulere deg!", "search.search_correction": "Prøv ett av følgende i stedet:", "search.search_input_button": "Søk", "search.search_not_started": "Start søket og utforsk alt vi har å tilby innen ditt interessefelt – klasser så vel som inspirerende lesing, treningsprogrammer og mer!", "search.section.blog.title": "Blogg", "search.section.challenges.title": "Utfordringer", "search.section.courses.title": "Onlinekurser", "search.section.events.title": "Event", "search.section.instructors.title": "Lærere og eksperter", "search.section.live.title": "LIVE-online", "search.section.playlists.title": "Playlists", "search.section.programs.title": "Program", "search.section.resources.title": "Kunnskap", "search.section.slide.more": ["Se alle ", ["totalCount"], " resultater for ", ["searchQuery"], " i ", ["title"]], "search.section.video_audio.title": "Video og lyd", "search.tabs.all": "Alt", "search.tabs.blog": "Blogg", "search.tabs.coursetravel": "Kurser & reiser", "search.tabs.live": "LIVE", "search.tabs.mobile_play": "Play (Videor, Playlists, Program)", "search.tabs.play": "Play", "search.tabs.play_tooltip": "Yogobe Play är allt det innehåll som en betalande medlem har tillgång till som del i en aktiv prenumeration. Det inkluderar hela vårt bibliotek med audio- och videosessioner, playlists, program, utmaningar samt veckoklasser LIVE-online.", "search.tabs.resources": "Kunnskap", "search.temporary_banner": "Dette er en ny funksjon. Yogobe Søk hjelper deg med å finne innhold i hele tjenesten vår. Sammenknyttede ord er noe systemet fortsatt lærer. Takk for at du bruker, finner og hjelper oss med å forbedre oss! <0>Gi tilbakemelding</0>", "search.title": "Hva leter du etter?", "search_details.blogPosts.explore": "search_details.blogPosts.explore", "search_details.challenges.explore": "Utforsk utfordringer", "search_details.courses.explore": "Utforsk onlinekurs", "search_details.events.explore": "Utforsk event", "search_details.genericPrograms.explore": "Utforsk program", "search_details.instructors.explore": "Utforsk Team Yogobe", "search_details.live.explore": "Utforsk LIVE", "search_details.playlists.explore": "Utforsk playlists", "search_details.results.load_more": "Vis mer", "search_details.results_found.mutiple_results": [["totalCount"], " resultater for <0>", ["query"], "</0> i ", ["category"]], "search_details.results_found.single_results": [["totalCount"], " resultater for <0>", ["query"], "</0> i ", ["category"]], "search_details.title": ["Søker innenfor ", ["category"]], "search_details.videos.explore": "Utforsk biblioteket", "settings.go_back": "Tillbaka till översikt", "settings.subsriptions.failed_renew": ["Vårt senaste försök att belasta ditt betalkort eller konto har misslyckats. Om du har fått ett nytt kort sedan sist vill vi tipsa dig om att på nytt välja medlemsform och förse oss med din uppdaterade information. Kontakta oss <0>", ["email"], "</0> om du önskar att vi försöker göra en ny dragning från ditt befintliga kort eller konto innan vårt nästa automatiska försök."], "settings_account.change_password.logout_notice": "När du ändrat ditt lösenord kommer du att bli ombedd att logga in på nytt", "settings_account.confirm_new_password": "Bekräfta nytt lösenord", "settings_account.mailaddress": "Mailadress", "settings_account.new_password": "Nytt lösenord", "settings_account.password_updated_successfully": "Ditt lösenord har uppdaterats", "settings_account.recover_your_password": "Återställ ditt lösenord", "settings_account.token_wrong": "Koden som du skrivit in verkar vara ogiltig. Försök gärna igen!", "settings_fringe_health.descriPSettingsFringeHealthBenefitstion": "Ger din arbetsgivare dig friskvårdsbidrag? Det är upp till varje arbetsgivare att avgöra vilka leverantörer de godtar. För att vara på den säkra sidan rekommenderar vi därför att du dubbelkollar att de godtar kvitton från Yogobe. Ifall din arbetsgivare är ansluten till friskvårdsportalerna Benify, Wellnet, Actiway, Wellnet eller Min Friskvård så kan du enkelt uppgradera ditt Yogobe-medlemskap via dem.", "settings_fringe_health.read_more": "Läs mer om friskvårdsbidrag", "settings_fringe_health.title": "Använd hela eller delar av ditt friskvårdsbidrag", "settings_history.action": "Rensa all historik", "settings_history.title": "Historik", "settings_modal.accessible-yoga": "Yoga vid rörelsehinder", "settings_modal.barn-ungdom": "Barn och ungdom", "settings_modal.beginner": "Endast nybörjarvänliga videor", "settings_modal.english": "Engelska", "settings_modal.finnish": "Finska", "settings_modal.helper": "Vi vill hjälpa dig få relevanta & för dig intressanta träffar i vårt bibliotek. Med denna funktion bestämmer du vad du vill få för sökresultat.", "settings_modal.helper_label": "Skräddarsy din Yogobe-upplevelse", "settings_modal.left_section_title": "Språk", "settings_modal.norwegian": "Norska", "settings_modal.office-yoga": "Kontorsträning", "settings_modal.postnatal": "Postnatal yoga & träning", "settings_modal.prenatal": "Gravidyoga & gravidträning", "settings_modal.primary_button": "Spara", "settings_modal.right_section_title": "Sökfilter", "settings_modal.secondary_button": "Avbryt", "settings_modal.senior-yoga": "Senioryoga", "settings_modal.swedish": "Svenska", "settings_modal.title": "Inställningar", "settings_privacy.description": "Här bestämmer du vilket innehåll som din publika profilsida skall visa", "settings_privacy.favorites": "Favoriter", "settings_privacy.private_profile_notice": "Du vill göra din profil privat. Andra medlemmar kommer inte kunna se de favoriter och playlists som du har skapat.", "settings_privacy.statistics": "Statistik", "settings_private_informations.city": "Stad", "settings_private_informations.dateOfBirth": "Födelsedag", "settings_private_informations.first_name": "Förnamn", "settings_private_informations.lastName": "Efternamn", "settings_private_informations.phone": "Telefon", "settings_private_informations.profession": "Yrke", "settings_private_informations.street_address": "Gatuadress", "settings_private_informations.timezone": "Tidzon", "settings_private_informations.zip_code": "Postnummer", "settings_profile.cancel_url_not_available": "Du har just nu ingen aktiv eller betalande prenumeration. Det betyder att det inte finns något för dig att avbryta. Kontakta oss på info@yogobe.com om du har några frågor!", "settings_profile.display_name": "Visa namn", "settings_profile.facebook": "Facebook", "settings_profile.instagram": "Instagram", "settings_profile.linkedin": "LinkedIn", "settings_profile.remove_photo": "Ta bort foto", "settings_profile.short_bio": "Kort beskrivning", "settings_profile.short_bio_placeholder": "Här kan du skriva några rader om dig själv", "settings_receipts.date": "Datum", "settings_receipts.payment_type": "Betaltyp", "settings_receipts.receipt": "Kvitto", "settings_receipts.receipt_number": "Kvittonummer", "settings_receipts.total_including_vat": "Totalt inklusive moms", "settings_referall.description": "och när de blir betalande prenumeranter så uppgraderas ditt konto automatiskt med 30 bonusdagar för varje kompis.", "settings_referall.paragraph_one": "Ge dina vänner sina 21 första dagar med Yogobe helt gratis. Enkelt, utan bindningstid, inga kortuppgifter och bonuser till dig!", "settings_referall.paragraph_two": "För varje kompis du har som inleder en betalande prenumeration på Yogobe med din kompiskod till ett värde av minst 189 SEK så uppgraderas ditt konto helt automatiskt med 30 bonusdagar. Enkelt, bra för dina kompisar och såväl kul som smart för dig!", "settings_referall.personal_code_action": "Kopiera", "settings_referall.personal_code_label": "Din personliga kompiskod", "settings_referall.refer": "Bjud in en kompis med:", "settings_referall.title": "Bjud in kompisar", "settings_subheader.account": "Kontoinställningar", "settings_subheader.fringe_health_benefits": "Friskvårdsbidrag", "settings_subheader.live_codes": "LIVE-koder", "settings_subheader.manage_notifications": "E-post preferanser", "settings_subheader.privacy": "Sekretessinställningar", "settings_subheader.private": "Medlemsinformation", "settings_subheader.profile": "Profilinställningar", "settings_subheader.receipts": "Kvitton", "settings_subheader.referral_program": "Värva vänner", "settings_subheader.subscriptions": "Prenumeration", "settings_subscriptions.access_code.activation_failed": "Koden kunde inte registreras. Prova igen eller kontakta oss för stöd på <0>info@yogobe.com</0> ", "settings_subscriptions.access_code.buy_gift": "Klicka här och köp ett presentkort", "settings_subscriptions.access_code.description": "Om du tex har en kod som ger dig åtkomst till material över en begränsad tid, såsom via Mecenat eller en arbetsgivare, så fyller du i den i nedan textfält", "settings_subscriptions.access_code.input_description": "Gäller även koder via Studentföretaget Mecenat", "settings_subscriptions.access_code.input_label": "Fyll i din kod", "settings_subscriptions.access_code.invalid_code_message": "Koden som du har fyllt i stämmer inte, eller så är den inte längre giltig. Prova igen och tveka inte att höra av dig till oss på <0>info@yogobe.com</0> vid frågor", "settings_subscriptions.access_code.submit_btn": "Aktivera", "settings_subscriptions.access_code.title": "Har du fått en accesskod?", "settings_subscriptions.access_code.valid_code_message": "Din kod har registrerats", "settings_subscriptions.annually": "Årligen", "settings_subscriptions.cancel_mobile_subscription": ["Du betalar just nu för din prenumeration via ", ["provider"], ". Avbryt detta först för att istället betala direkt till Yogobe. Vid frågor, besök gärna vår"], "settings_subscriptions.cancelled_no_access": "Din prenumeration har avbrutits och därför har du just nu ingen obegränsad åtkomst till videor, playlists, program eller utmaningar. Återaktivera när du vill genom att göra en betalning.", "settings_subscriptions.cancelled_with_access": ["Din aktiva prenumeration har avbrutits men du har fortfarande obegränsad access till vidoer, playlists, program och utmaningar fram till ", ["date"], ". Återaktivera när du vill genom att göra en prenumerationsbetalning."], "settings_subscriptions.description_free": "Du har just nu ingen aktiv eller betalande prenumeration", "settings_subscriptions.description_no_subscription_premium": ["Du har prenumerations-åtkomst till ", ["date"]], "settings_subscriptions.discount_code.description": "Om du har fått en kod som ger dig en prenumerationsrabatt så skriver du in den i nedan textfält.", "settings_subscriptions.discount_code.input_description": "Gäller också för rabatt- och specialerbjudandekoder", "settings_subscriptions.discount_code.input_label": "Fyll i din rabattkod", "settings_subscriptions.discount_code.invalid_code_message": "Den kod som du har fyllt i stämmer inte. Prova igen eller har kanske giltighetstiden gått ut? Ttveka inte att höra av dig till oss på <0>info@yogobe.com</0> vid frågor", "settings_subscriptions.discount_code.submit_btn": "Aktivera", "settings_subscriptions.discount_code.title": "Har du en rabattkod?", "settings_subscriptions.discount_code.valid_code_message": "Din kod har registrerats", "settings_subscriptions.mobile_description_premium_renew": ["Din prenumeration förnyas automatiskt via ", ["platform"], " den ", ["date"]], "settings_subscriptions.monthly": "Månatligen", "settings_subscriptions.quarterly": "Kvartalsvis", "settings_subscriptions.subscription_next_billing": ["Du har just nu en löpande prenumeration per ", ["plan"], " om ", ["amount"], ". Automatisk förnyelse sker den ", ["date"]], "settings_subscriptions.subscription_next_billing_failed": ["Betalningen om ", ["amount"], " kunde inte genomföras"], "settings_subscriptions.subscription_next_billing_processing": "Din betalning behandlas", "settings_subscriptions.subscription_next_billing_unpaid": ["Betalningen på ", ["summa"], " kunde inte slutföras. Vi har försökt debitera dig för att hålla ditt abonnemang aktivt."], "settings_subscriptions.title": "Vill du ändra din prenumerationstyp?", "settings_subscriptions.toaster_message.access_code_activated": "Koden har aktiverats!", "settings_subscriptions.updated": "Din accesstid har förlängts", "settings_subscriptions.wellness_banner.description": "You can use your wellness grant allowance to purchase Yogobe subscriptions and online courses. We currently support Benify, ePassi, Wellnet, and Benefits. <0>Read more here.</0>", "settings_subscriptions.wellness_banner.title": "Visste du at...", "share_modal.copied_button": "Kopierad till urklipp", "share_modal.copy_placeholder": "Kopiera URL för att dela:", "share_modal.hidden": "Du kan dela denna dolda playlist och den kan endast nås via sin länk/URL. <0>Ändra playlistinställningar.</0>", "share_modal.privacy": "Du kan dela denna playlist men ingen kommer kunna se den. <0>Ändra playlistinställningar.</0>", "share_modal.title": "Dela", "snackbar.faq": "FAQ sida", "snackbar.favorites": "Favorites", "snackbar.playlist": "Se playlist", "snackbar.playlists": "Playlists", "snackbars.added_video_playlist": "Videon har lagts till i playlist", "snackbars.cancel_subscription_faild": "Hoppsan, det gick inte att avbryta din prenumeration. Försök igen!", "snackbars.challenge.program_access_granted": "Du deltar nu i denna utmaning", "snackbars.created_playlist": "Din playlist har skapats", "snackbars.favorited_playlist": "Sparad som favorit", "snackbars.favorited_video": "Sparad som favorit", "snackbars.removed_video_playlist": "Videon har tagits bort från playlist", "snackbars.settings_update": "Dina inställningar har uppdaterats", "snackbars.subscription_succussfuly_canceled": "Du har nu avbrutit din prenumeration. Välkommen tillbaka snart!", "snackbars.unfavorited_playlist": "Borttagen som favorit", "snackbars.unfavorited_video": "Borttagen som favorit", "snackbars.updated_playlist": "Din playlist har uppdaterats", "sortby.published_at": "Senast tillagd", "sortby.time": "Tid", "special399.banner.usp1": "Kvartalsprenumeration", "specialoffer.banner_cta": "Ja tack", "specialoffer.banner_tag1": "Testa gratis 14 dagar", "specialoffer.banner_tag2": "Tidsbegränsat erbjudande", "specialoffer.banner_title": "Uppgradera ditt medlemskap och få 500 SEK att handla Yogiraj för", "specialoffer.new_banner_title": "Gör som 115 000 andra. Bli medlem på Yogobe och del i vår växande gemenskap!", "spring_challenge.thankyou": "Kul att du ska vara med i Yogobe Spring Challenge! Vi ser verkligen fram emot att få följa din utveckling under de kommande veckorna. Kom ihåg, den bästa träningen är den som blir av.", "springchallenge.banner.disclaimer": "*Gäller både nya och gamla medlemmar och ger access till videobiblioteket och utmaningar! (ord pris 189 SEK)", "springchallenge.banner.subtitle": "Välkommen till vårens utmaning som ingår för dig med minst 28 accessdagar. Annars kostar det bara 99 SEK din första månad", "springchallenge.banner.title": "Spring Challenge", "springchallenge.form.title": "Yogobe Spring Challenge", "springchallenge.info.excerpt": "Vi välkomnar dig till en 4-veckors utmaning för att boosta din nyfikenhet och testa allt från yoga och meditation till rörlighetsträning, andningsövningar och stresshantering. Allt tillsammans med några av Skandinaviens största namn inom hälsa. Varje vecka får du 10 nya klasser, teknikvideor och pepp att välja fritt bland.   <h2>Du väljer när du vill börja</h2> Hoppa på utmaningen mellan den 20 mars och 15 april 2020.  <h2>Välj ditt program</h2> Utmaningen erbjuder fyra olika program för att du ska kunna hitta ditt flow och ha skoj, få ny energi och utmana dig själv! Läs mer om de fyra programmen nedan. Nytt för våren är att våra vänner i Finland får en egen version av utmaningen med 2 program. På finska. <a href=\"https://yogobe.com/fi/springchallenge\">Läs mer om den här.</a> <ul> <li><bold>Stillness in self</bold> : för dig som vill landa efter en period av långvarig stress eller utmattning.</li>  <li><bold>Fire & fumes</bold> : för dig som är pepp på en fysisk utmaning som kommer ge märkbara resultat i styrka, rörlighet och kondition. </li>  <li><bold>Runners high</bold> : för dig som älskar löpning och vill utveckla din löpteknik - oavsett om du springer för vardagsmotion eller tränar inför ett lopp. </li>  <li><bold>Fierce soulwork</bold> : för dig som är erfaren yogautövare och vill utveckla din asana, fördjupa din filosofiska förståelse samt komma vidare på din spirituella resa.</li>  </ul> För en mer detaljerad beskrivning av programmen, scrolla ner.   ", "springchallenge.info.rest": "<h2>Vinn fina priser*</h2> Om du slutför minst tre klasser per vecka har du chansen att vara en av 10 vinnare som tar hem storvinsten: Ett årsmedlemskap på Yogobe plus valfri onlinekurs på Yogobe (värde fr. 2 398 SEK). Detta gäller för dig som startade din utmaning innan den 1 maj.   <h2>Vem kan delta i utmaningen?</h2> Precis alla! För att få tillgång till utmaningen behöver du bara vara aktiv medlem. Alla nya medlemmar samt du som inte är aktiv eller betalande medlem får första månaden för bara 99 SEK när du signar upp (ord. pris 189 SEK). Prenumerationen övergår sedan i en betalande månadsprenumeration (189 SEK per månad). Nya medlemmars konton blir också automatiskt uppgraderade med 14 gratis prova-på-dagar utöver de 30 dagar du betalar för.   <h2>Du kommer väl ihåg friskvårdsbidraget?!</h2> Just nu vill vi passa på att påminna er om att använda friskvårdsbidraget – bli årsmedlem för endast 1899 SEK.  <h2>Få inspiration och stöd</h2> Dela med dig av ditt deltagande via hashtaggen #yogobespringchallenge. I vår Facebookgrupp <a href=\"https://www.facebook.com/groups/beyoga365/\">#BEYOGA365</a> får du också stöd och inspiration från både Team Yogobe och våra medlemmar . Välkommen! Gå med i <a href=\"https://www.facebook.com/groups/beyoga365/\">#BEYOGA365</a> idag!", "springchallenge.info.title": "Yoga och träna med oss i vår!", "springchallenge.programsBody.more.body": "Om du slutför minst tre klasser per vecka har du chansen att vara en av 10 vinnare som tar hem storvinsten: Ett årsmedlemskap på Yogobe plus valfri onlinekurs på Yogobe (värde fr. 2 398 SEK). Detta gäller för dig som startade din utmaning innan den 1 maj.", "springchallenge.programsBody.more.title": "Tävling!", "springchallenge.programsBody.subtitle": "Kom igång och kickstarta din Spring Challenge idag!", "springchallenge.programsBody.title": "Vilket program passar dig?", "springchallenge.testimonials.title": "Ledande lärare och profiler guidar och inpirerar", "start.section3_title": "Utforska videor via kategorier", "statistics_banner.info": ["Under ", ["year"], " kommer vi lansera en ny upplevelse kring din statistik på Yogobe. Tills vidare är denna del av din profil därför pausad i väntan på nyheterna!"], "stats.average_duration": "Medellängd", "stats.favorite_yoga_style": "Din favorit yogastil", "stats.minutes": "minutter", "stats.sessions": "Sessioner", "stats.sessions_completed": "Slutförda sessioner", "stats.total_time": "Total tid", "stripe_banner.wellness_grant.december.text": "Använd hela friskvårdsbidraget innan 31 dec. Onlineträning är perfekt i dessa tider. Läs mer här!", "stripe_banner.wellness_grant.november.text": "Passa på: använd ditt friskvårdsbidrag för onlineträning i dessa tider. Läs mer här!", "subheader.overview": "Översikt", "subheader.playlists": "Playlists", "subheader.programs": "Träningsprogram", "subscriptions.cancel_subscription": "Avbryt prenumeration", "subscriptions.cancel_subscription_helper": "Det är enkelt att avbryta ditt betalande medlemskap. Ifall du gör ett aktivt val att inte fortsätta prenumerera på Yogobe så har du givetvis fortsatt tillgång till videobiblioteket för hela den period som du har förskottsbetalat för.  ", "subscriptions.cancel_subscription_label": "Vill du avbryta din prenumeration?", "subscriptions.full_accesse_code.default_title": "Access via access code", "subscriptions.one_time_code.default_title": "Access via one time access code", "summerchallenge.banner.text": "<0>Upprätthåll dina goda vanor i sommar - signa upp på #yogobesummerchallenge</0>", "summerchallenge.banner.title": "Yogobe Summer Challenge", "summerchallenge.challenge_form.activate_account": "Tack för din anmälan!  Vi har nu skickat ett mejl som borde landa i din inkorg inom ett par minuter. I mejlet finner du en länk, klicka på den för att aktivera ditt konto och du kommer få full tillgång till ditt program med start idag.", "summerchallenge.challenge_form.level_note": "Scrolla ner för att läsa mer. Ny funktion: Byt program när du vill.", "summerchallenge.challenge_form.login": "Fyll i formuläret och få fullständig tillgång till Yogobe Summer Challenge! ", "summerchallenge.challenge_form.resend_activation": "Har du inte mottagit mejlet? <0>Klicka här för att skicka igen</0>", "summerchallenge.dashboard_banner.text": "Kickstarta sommaren med oss – signa upp på #yogobesummerchallenge", "summerchallenge.form.title": "Yogobe Summer Challenge", "summerchallenge.info.excerpt": "Vi välkomnar dig till en 4-veckors utmaning för att möta dina behov, vare sig du är nybörjare, erfaren atlet, löpare eller yogaentusiast. Utmaningen finns anpassad för medlemmar i både Sverige och <a href=\"/fi/summerchallenge\" target=\"_blank\">Finland</a>. I den svenska utmaningen kan du välja mellan 4 olika program (mer info nedan) – så att du verkligen får den motivation, träning och regelbundenhet du behöver. Allt tillsammans med några av Skandinaviens största namn inom hälsa. Varje vecka får du 10 nya klasser, teknikvideor och föreläsningar att välja fritt bland.   <h2>Du väljer när du vill starta utmaningen</h2> Du kan välja att starta utmaningen när det passar dig och dina sommarplaner - allt mellan den 15 juni och 15 augusti 2020. Från dagen du aktiverar utmaningen har du sedan 4 veckor av pepp framför dig! Utmaningen kommer att finnas tillgänglig via din profil även efter denna 4-veckorsperiod.  <h2>Vem kan delta i utmaningen?</h2> Precis alla! För att få tillgång till utmaningen behöver du vara betalande medlem eller ha access via Mecenat. Alla nya medlemmar samt du som inte längre är betalande medlem får första månaden för bara 99 SEK när du signar upp (ord. pris 189 SEK). Prenumerationen övergår sedan i en betalande månadsprenumeration (189 SEK per månad). Nya medlemmars konton blir också automatiskt uppgraderade med 14 gratis prova-på-dagar utöver de 30 dagar du betalar för.   <h2>Välj ditt program</h2> Utmaningen erbjuder fyra olika program för att du ska kunna hitta ditt flow och ha skoj, få ny energi och utmana dig själv! Läs mer om de fem programmen nedan. Finland har en egen version av utmaningen med två program, på finska, <a href=\"/se/springchallenge\" target=\"_blank\">läs mer om den här</a>.  För en mer detaljerad beskrivning av programmen, scrolla ner.    ", "summerchallenge.info.rest": "<ul>   <li>     <bold>Happy beginner</bold> – för dig som behöver motivation och pepp att komma igång med enkel träning, funktionell rörelse, yoga för nybörjare, mindfulness och motivational talks.   </li>   <li>     <bold>Complete restoration</bold> – för dig som vill landa efter en period av stress, långvarig smärta eller utmattning. Du kommer få upptäcka restorative yoga, andningsövningar, yoga nidra, kognitiva övningar och mindfulness.    </li>   <li>     <bold>Sweaty & healthy</bold> – för dig som är pepp på en fysisk utmaning och vill se märkbara resultat i styrka, rörlighet och kondition.    </li>     <li>     <bold>Go deep & within</bold> – för dig som är erfaren yogautövare och vill utveckla din asana, fördjupa din filosofiska förståelse samt komma vidare på din spirituella resa. Mycket av innehållet är på engelska och kan passa en deltagare som föredrar det!   </li> </ul>  <h2>Du kan byta program</h2> Ja, du kan byta program under Yogobe Summer Challenge. Var medveten om att du kommer förlora den statistik du samlat från det program du tidigare påbörjat.   <h2>Vinn fina priser</h2> Om du slutför minst tre klasser per vecka har du chansen att vara en av 10 vinnare som tar hem storvinsten: Ett årsmedlemskap på Yogobe + valfri <a href=\"/se/marketplace/online-courses\" target=\"_blank\">onlinekurs</a> på Yogobe (värde från 2 398 SEK).  <h2>Du kommer väl ihåg friskvårdsbidraget?! </h2> Just nu vill vi passa på att påminna er om att använda friskvårdsbidraget – bli årsmedlem för endast 1899 SEK.  <h2>Få inspiration och stöd</h2> Dela med dig av ditt deltagande via hashtaggen #yogobesummerchallenge. I vår Facebookgrupp <a href=\"https://www.facebook.com/groups/beyoga365/\" target=\"_blank\" rel=\"noopener\">#BEYOGA365</a> får du också stöd och inspiration från både Team Yogobe och våra medlemmar, välkommen! Gå med i #BEYOGA365 idag!", "summerchallenge.info.title": "Yoga och träna med oss i sommar!", "summerchallenge.programsBody.more.body": "Om du slutför minst tre klasser per vecka har du chansen att vara en av 10 vinnare som tar hem storvinsten: Ett årsmedlemskap på Yogobe plus valfri onlinekurs på Yogobe (värde fr. 2 398 SEK).", "summerchallenge.programsBody.more.title": "Tävling!", "summerchallenge.programsBody.subtitle": "Kom igång och kickstarta din Summer Challenge idag!", "summerchallenge.programsBody.title": "Vilket program passar dig?", "summerchallenge.testimonials.title": "Ledande lärare och profiler guidar och peppar", "summerchallenge.thank_you.text": "Kul att du ska vara med i Yogobe Summer Challenge! Vi ser verkligen fram emot att få följa din utveckling under de kommande veckorna. Kom ihåg, den bästa träningen är den som blir av.", "summerchallenge.usergroup1.disclaimer": "*så länge du har en aktiv prenumeration.", "summerchallenge.usergroup1.infoform": "Denna utmaning är inkluderad i din aktiva prenumeration. Gå med redan idag! ", "summerchallenge.usergroup1.mainbanner": ["Hej ", ["firstName"], ", välkommen till Yogobe Summer Challenge. Denna utmaning är gratis för alla aktiva medlemmar - starta redan idag!"], "summerchallenge.usergroup2.disclaimer": "*Gäller både nya och befintliga medlemmar. Få obegränsad access till videobiblioteket, utmaningar och alla program! (ordinarie pris 189 SEK)", "summerchallenge.usergroup2.infoform": "Du behöver ha minst 28 accessdagar kvar eller en löpande prenumeration för att starta utmaningen. ", "summerchallenge.usergroup2.mainbanner": ["Hej ", ["firstName"], ", välkommen till Yogobe Summer Challenge. Gå med i utmaningen för endast 99 SEK*, starta redan idag! "], "summerchallenge.usergroup3.disclaimer": "*Gäller både nya och befintliga medlemmar. Få obegränsad access till videobiblioteket, utmaningar och alla program! (ordinarie pris 189 SEK)  ", "summerchallenge.usergroup3.infoform": "Gå med i utmaningen för endast 99 SEK*", "summerchallenge.usergroup3.mainbanner": "Välkommen till Yogobe Summer Challenge. Gå med i utmaningen för endast 99 SEK*, starta redan idag! ", "summerchallenge.video.extra": "Extra", "summerchallenge.video.repeat": "Repetera gärna", "summerchallenge.video.technic": "Teknik", "surveys_2022.validation.maxlength": ["Du kan max skriva ", ["length"], " tecken"], "surveys_2022.validation.minlength": ["Minst ", ["length"], " tecken behövs"], "surveys_2022.validation.required": "Det är viktigt att du fyller i detta fält", "teacher_modal.go_to_profile": "Gå till profil", "teacher_modal.homepage": "Hemsida", "teacher_modal.location": "Plats", "teacher_modal.speciality": "Specialitet", "userlogin.logout": "Logga ut", "userlogin.menu.cancelled_plan": "Avbruten prenumeration", "userlogin.menu.expired_plan": "Inaktiv prenumeration", "userlogin.menu.free_premium": "Prenumerations-åtkomst", "userlogin.menu.free_trial": "Provperiod", "userlogin.menu.manage": "Hantera", "userlogin.menu.monthly_plan": "Aktiv prenumeration", "userlogin.menu.no_plan": "Ingen prenumeration", "userlogin.menu.premium_plan": "Aktiv prenumeration", "userlogin.menu.quarterly_plan": "Aktiv prenumeration", "userlogin.menu.renew": "Förnya", "userlogin.menu.upgrade": "Uppgradera", "userlogin.menu.yearly_plan": "Aktiv prenumeration", "userlogin.my_dashboard": "Översikt", "userlogin.my_favorites": "Mina favoriter", "userlogin.my_playlists": "Mina playlists", "userlogin.my_stats": "Min statistik", "userlogin.my_subscription": "Prenumeration", "userlogin.settings": "Mina inställningar", "usersubheader.dashboard": "Översikt", "usersubheader.favorites": "Favoriter", "usersubheader.for_me": "Rekommendationer", "usersubheader.my_favorites": "Mina favoriter", "usersubheader.my_playlists": "Mina playlists", "usersubheader.playlists": "Playlists", "usersubheader.statistics": "Statistik", "validation.DOBInvalid": "Format för datum är DD/MM/YYYY", "validation.DOBMax": "Du borde vara X år gammal", "validation.DOBMin": "Stämmer verkligen denna ålder?", "validation.email": "Var snäll och fyll i en giltig email-adress", "validation.email_taken": "Du har skrivit in en mailadress som redan tillhör en medlem på Yogobe. Logga istället in för att fortsätta!", "validation.firstNameMax": "Angivet förnamn är för långt", "validation.lastNameMax": "Angivet efternamn är för långt", "validation.link": "Här skall du fylla i en URL/webadress", "validation.passwordConfirmNotMatch": "Lösenorden matchar inte varandra", "validation.passwordMax": "Ditt löseord får innehålla max 18 tecken.", "validation.passwordMin": "Var snäll och se till att ditt nya lösenord har minst 8 tecken", "validation.phone": "Här fyller du i ett telefonnummer", "validation.required": "Det är viktigt att du fyller i detta fält", "validation.user_social_already_exists": "E-posten knyttet til den kontoen du brukte tilhører allerede et Yogobe-medlem. Prøv å logge på i stedet eller registrer deg med en annen sosial konto/e-post.", "video.bundle_video_banner": "Disse anbefalingene er ikke inkludert på temasiden din.", "video.premium_msg": "Du har precis sett en förhandsvisning på 60 sekunder. Vill du se resten också?", "video.preview_msg": "60 sekunders förhandsvisning", "video.related_video_title": "Relaterade videor", "video.video_not_found": "Videon kan inte hittas", "video_cover_locked.Upgrade": "Uppgradera", "video_cover_locked.login": "Logga in", "video_cover_locked.register": "Skapa konto", "video_settings_banner.info": "Skräddarsy din Yogobe-upplevelse genom att använda filter och taggar nedan istället för ord-sök. Då får du alltid exakta resultat! Du kan också avgränsa dina resultat ytterligare under Videoinställningar!", "videos.beyoga365.description": "Tema- och intentionsmånader", "videos.beyoga365.title": "BEYOGA365", "videos.blog_posts_title": "Inspiration från vår blogg", "videos.get_started_section.title": "Jag vill komma igång med att", "videos.playlists_recommended.title": "Playlists rekommenderade för dig", "videos.programs.title": "Träningsprogram", "videos.quickstart.suggestions": "Förslag för dig", "videos.weekly_picks.title": "Veckans videor", "videos.yogamom365.description": "Tema- och intentionsmånader", "videos.yogamom365.title": "YOGAMOM365", "videosGenres.discover": ["Ta del av ", ["name"], "’s videor och vägledning inom andra områden"], "videosGenres.sessions": "Sessioner", "videos_genres.count": [["count"], " träffar"], "videos_genres.keyword": ["för sökordet \"", ["keyword"], "\""], "videos_genres.settings_button": "Videoinställningar", "weeklyProgram.course_survey.locked": "Aktivera kursen för att ta del av detta innehåll", "weeklyProgram.document.locked": "weeklyProgram.document.locked", "weeklyProgram.document.open_document": "Öppna dokument", "weeklyProgram.introduction.label": "Introduktion", "weeklyProgram.program_survey.locked": "Aktivera programmet för åtkomst till denna enkät", "weeklyProgram.survey.locked": "weeklyProgram.survey.locked", "weeklyProgram.week.number": ["Vecka ", ["number"]], "weeklyProgram.week.videos_duration": [["videosCount"], " Videor - ", ["duration"]], "weeklyProgram.week_progress.text": "Progressen visar antalet videor du har slutfört utav alla videor denna vecka.", "weeklyProgram.weekly_progress.program_content": "Programinnehåll", "yearlyfall2021.yearly_subscription_description": "Din prenumeration förnyas årligen. Uppgradera innan 11 oktober och få en gratis yogamatta." } };

/***/ }),

/***/ 86225:
/***/ (function(module) {

/*eslint-disable*/module.exports = { messages: { "An account verification email has been sent to {0}": ["An account verification email has been sent to ", ["0"]], "LegacyPaymentModal.choose_a_payment_method": "Choose a payment method", "The terms and conditions must be accepted.": "The terms and conditions must be accepted.", "WeeklyProgram.moodtracker.post.description": "WeeklyProgram.moodtracker.post.description", "WeeklyProgram.moodtracker.post.start_button": "WeeklyProgram.moodtracker.post.start_button", "WeeklyProgram.moodtracker.post.title": "WeeklyProgram.moodtracker.post.title", "WeeklyProgram.moodtracker.pre.description": "WeeklyProgram.moodtracker.pre.description", "WeeklyProgram.moodtracker.pre.start_button": "WeeklyProgram.moodtracker.pre.start_button", "WeeklyProgram.moodtracker.pre.title": "WeeklyProgram.moodtracker.pre.title", "access_code_modal.checkmark_activate": "Aktivera", "access_code_modal.code_error": "Felaktig accesskod. Vänligen försök igen!", "access_code_modal.code_success": "Din accesskod har registrerats", "access_code_modal.code_success_access": ["Fantastiskt! Nu har du tillgång till ", ["companyName"], "’s utvalda innehåll hos Yogobe"], "access_code_modal.code_success_redirect": "Du kommer nu att skickas tillbaka till översiktssidan om...", "access_code_modal.description": ["Medarbetare hos, eller partners till ", ["companyName"], " får åtkomst till detta material genom att fylla i sin unika accesskod."], "access_code_modal.input_label": "Accesskod", "access_code_modal.title": ["Få tillgång till ", ["companyName"], "'s dedikerade innehåll på Yogobe"], "account.verification_email_resent": ["Ett aktiveringsmail har skickats till ", ["email"]], "banner.action": "Ja tack", "banner.action2": "Ge oss feedback", "banner.body": "Använd det gamla videobiblioteket?", "banner.castBanner": "Nu kan du se videor från din mobila enhet på din TV via Airplay och Chromecast. (Tyvärr stödjer inte Chromecast iOS-enheter ännu).", "banner.companyFavorites": "Allt du favoritmarkerar kommer synas publikt och som rekommenderat innehåll under fliken Översikt", "banner.course_maintenance": "Vi gör underhåll och uppdateringar på Yogobes fördjupningskurser under kvällen och natten. Tyvärr kan du inte vara inne på din kurs medan vi gör detta arbete och är tacksamma för din förståelse. Välkommen åter imorgonbitti!", "banner.download_chrome": "När du tittar på en video kan du ibland uppleva problem med din webbläsare. Vi rekommenderar varmt att du använder ", "banner.download_chrome_action": "Google Chrome", "banner.email_verify": ["Bekräfta din mailadress (", ["email"], ") och aktivera ditt medlemskap för obegränsad access. Har du inte fått aktiveringsmailet? <0>Klicka här</0>"], "banner.email_verify_change_settings": "Verifiera att du uppdaterat din medlemsinformation. Har du inte fått bekräftelsesmailet? <0>Klicka här</0>", "banner.monthlyCourseOffer": "Under oktober månad har vi 50% rabatt på två utvalda onlinekurser. Klicka här!", "banner2.body": "Du är aktiv på ett av våra nya program. Ge oss gärna feedback och hjälp oss utvecklas", "banner_subscribe.go_premium": "Uppgradera konto", "banner_subscribe.header": "Vill du få obegränsad tillgång till vårt videobibliotek?", "blog.title": "Blogg", "bundle.dashboard_card.access_expired": "Access har upphört", "bundle.get_started..access_code.show_text": "If you have an access code, <0>click here</0>", "bundle.get_started.access_code.info_text": "Fyll i accesskod. ", "bundle.get_started.access_code.label": "Har du erhållit en accesskod?", "bundle.get_started.access_code.not_valid": "Denna accesskod går inte att aktivera. Antingen har den redan nyttjats av dig en gång eller att den är felaktig eller inte längre är giltiig för denna temasida. Vid frågor, skriv till: info@yogobe.com ", "bundle.get_started.access_code.tooltip_text": "Har du emottagit en accesskod via en av våra partners? Fyll i den här för att ta del av innehållet.", "bundle.get_started.access_code.valid": "Accesskoden är giltig", "bundle.get_started.activation_failed_error": "Aktivering av din temasida misslyckades. Vänligen försök igen, eller kontakta oss på <0></0>", "bundle.get_started.button.get_started": "Kom igång", "bundle.get_started.button.login": "Logga in och fortsätt", "bundle.get_started.button.register": "Bli medlem och fortsätt<<<<<<< HEAD", "bundle.get_started.by_code_description": "Denna temasida är endast tillgänglig via en accesskod. Vänligen fyll i din kod nedan. ", "bundle.get_started.description": "Du behöver en accesskod för att ta del av innehållet", "bundle.get_started.for_all_description": "Denna temasida är gratis för alla. Klicka på \"Kom igång\" för att få tillgång till innehållet. ", "bundle.get_started.for_premium_description": "Denna temasida ingår för dig med en aktiv prenumeration. Den är även tillgänglig för dig med en accesskod, om du har en kod, fyll i den nedan. ", "bundle.get_started.for_subscription_only": "Denna temasida ingår för dig med en aktiv Yogobe Play-prenumeration. ", "bundle.get_started.guest.welcome_message": ["Välkommen till ", ["bundle_name"]], "bundle.get_started.guest_description": ["Välkommen till ", ["bundle_name"], "! Innehållet på denna temasida görs tillgängligt för dig antingen via en aktiv prenumeration eller en accesskod från partner till Yogobe, en kundklubb där du är medlem eller din arbetsgivare. Accesskoden fylls i efter att du har loggat in eller skapat konto!"], "bundle.get_started.guest_title": "Ta del av temasidan", "bundle.get_started.snackbar.access_granted": "Du har nu tillgång till detta innehåll.", "bundle.get_started.user.welcome_message": ["Hej ", ["name"], ", välkommen till ", ["bundle_name"]], "bundle.get_started.verify_account_banner": "Verify your account to be able to join the bundle.", "bundle.id_page.blog_sections.title": "Blogg", "bundle.id_page.challenge.discover_button": "Ta del av utmaningen", "bundle.id_page.challenges_sections.title": "Utmaning", "bundle.id_page.documents.required_access": "Du behöver giltig access för att se detta dokument", "bundle.id_page.documents_sections.title": "Dokument", "bundle.id_page.hero.access_until_text": ["Du har obegränsad access till detta innehåll t.o.m. ", ["accessUntil"]], "bundle.id_page.hero.client_text": ["Exklusivt för medlemmar hos ", ["clientName"]], "bundle.id_page.hero.extend_access": "Förläng access", "bundle.id_page.hero.get_access_btn": "Få access", "bundle.id_page.hero.options_menu": "Alternativ", "bundle.id_page.hero.tooltip_text": "Få access till detta innehåll i nästa steg. <b>För innehåll exklusivt för medlemmar hos en partner till Yogobe</b> – vänligen fyll i din unika accesskod när du loggar in eller efter att du skapat ett konto. <b>För innehåll exklusivt för Yogobes medlemmar</b> – vänligen logga in på ditt konto eller skapa ett konto, du behöver ha en aktiv provperiod eller betalande prenumeration för åtkomst. ", "bundle.id_page.live_sections.title": "LIVE-sessioner ", "bundle.id_page.playlists_sections.title": "Playlists", "bundle.id_page.program.discover_button": "Ta del av programmet", "bundle.id_page.programs_sections.title": "Program", "bundle.id_page.videos_sections.title": "Video & audio", "button.spring_challenge.end": "Joina Yogobe Summer Challenge", "button.winter_challenge.end": "Joina Yogobe Spring Challenge", "button_add_to_playlist.hidden": "Dold", "button_add_to_playlist.private": "Privat", "button_add_to_playlist.public": "Publik", "buy_gift.send_email_directly_label": "buy_gift.send_email_directly_label", "campaign.infos_show_less": "Visa färre", "campaign_info.read_less": "Dölj text", "campaign_info.read_more": "Läs mer", "cancel_subscription_modal_four.paragraph": "Vi önskar dig glada äventyr och ser fram emot att välkomna dig tillbaka till oss!", "cancel_subscription_modal_four.title": "Det är tråkigt att du inte har möjlighet att fortsätta vara en aktiv medlem hos oss", "cancel_subscription_modal_one.button_one": "Gå tillbaka. jag har ändrat mig", "cancel_subscription_modal_one.button_two": "Ja, avbryt min prenumeration", "cancel_subscription_modal_one.paragraphe_one": ["Om du väljer att avbryta din prenumeration idag så kommer du med start ", ["date"], " inte ha obegränsad åtkomst till vårt videobibliotek."], "cancel_subscription_modal_one.paragraphe_two": "Vi arbetar ständigt med att utveckla och förbättra vår tjänst och sätter stort pris på din feedback och tankar.", "cancel_subscription_modal_one.title": "Är du säker på att du vill avbryta din prenumeration?", "cancel_subscription_modal_three.button_activate": "Aktivera 7 gratisdagar och stanna kvar", "cancel_subscription_modal_three.paragraph": "Får vi lov att erbjuda dig 7 gratisdagar med Yogobe?", "cancel_subscription_modal_three.title": "Jag har inte haft tid", "cancel_subscription_modal_two.checkbox1": "Jag har svårt att hitta videor och vägledning som passar mig", "cancel_subscription_modal_two.checkbox2": "Jag har inte haft tid", "cancel_subscription_modal_two.checkbox3": "Jag har ingen möjlighet att prioritera Yogobe just nu", "cancel_subscription_modal_two.checkbox4": "Annan anledning", "cancel_subscription_modal_two.title": "Varför väljer du att avbryta din prenumeration idag?", "cast_modal.subtitle": "för att kunna casta, uppgradera ditt medlemskap till en prenumeration och få obegränsad tillgång till hela videobiblioteket, program och mycket mer!", "cast_modal.title": "Denna funktion är tillgänglig för betalande medlemmar", "cast_modal.view_offers": "Se erbjudanden", "challenge.week.infobar": "Slutför tre sessioner/videor varje vecka under fyra veckor för att fullfölja utmaningen OBS: De videor du tittar på via ChromeCast kan våra system tyvärr inte registrera som slutförda.", "challenge_2021.banner.discount_text": "Betala bara 99 SEK för min första månad*", "challenge_2021.banner.verify_account": "Bekräfta ditt konto genom att verifiera din mailadress. Då kan du direkt joina Yogobe Challenge", "challenge_2021.challenges_section.title": "Välj en utmaning", "challenge_2021.contact.contact_text": "Kontakt: <0>business@yogobe.com</0>", "challenge_2021.contact.desc": "Vad roligt att du och din organisation är intresserade av att komma igång med Yogobe Challenge. Digitalt, demokratiskt, lättillgängligt och enkelt att komma igång. Tillsammans med Yogobe tar vi fram innehåll och stöd med syfte att främja såväl fysisk och mental hälsa inom företag och organisationer för individ och medarbetare. Just detta format är perfekt för team som träffas remote och arbetsplatser där man önskar inspiration och vägledning för rörelse i vardagen. Inom Yogobe Challenge ryms fem 4-veckorsprogram för olika intressen och behov - det finns alltså något för alla. För att komma igång, kontakta mig via email!", "challenge_2021.contact.purchase_banner_back": "Tillbaka", "challenge_2021.contact.title": "Hej, välkommen till Yogobe Challenge! ", "challenge_2021.features_section.title": "Vad är du i behov av?", "challenge_2021.get_started.button.continue": "Gå vidare", "challenge_2021.get_started.button.continue_trial": "Fortsätt med 14 dagar gratis", "challenge_2021.get_started.button.start_suscription": "Inled en prenumeration", "challenge_2021.get_started.button.upgrade_continue": "Uppgradera och gå vidare", "challenge_2021.get_started.description": "Vi är glada över att du vill joina detta program. Program och utmaningar ingår i Yogobe's prenumerationer samt företagspaket. Klicka på knappen \"Starta programmet\" nedan för att ta del av innehållet.", "challenge_2021.get_started.guest_title": ["Välkommen till ", ["program"]], "challenge_2021.get_started.option.have_account": "Jag har redan ett medlemskonto", "challenge_2021.get_started.option.no_account": "Jag har inget medlemskonto", "challenge_2021.get_started.show_code_input": "Har du fått tillgång till programmet genom din arbetsplats eller en organisation och fått en accesskod? <0>Klicka här</0>", "challenge_2021.get_started.show_code_input_description": "Detta är en kod som du får genom din arbetsplats, organisation, kundklubb eller liknande.", "challenge_2021.get_started.user_title": ["Hej ", ["name"], ", välkommen till ", ["program"]], "challenge_2021.get_started_loggedin.description": "Vi är glada över att du vill joina detta program. Program och utmaningar ingår i Yogobe's prenumerationer samt företagspaket. Klicka på knappen \"Starta programmet\" nedan för att ta del av innehållet.", "challenge_2021.listing_page.hero.no_premium_desc": "Välkommen till Yogobe Challenge! Du får obegränsad access till alla Challenge-program när du inleder en månadsprenumeration från 99 SEK*.", "challenge_2021.listing_page.hero.no_premium_disclaimer": "*Detta pris gäller för din första månad och övergår automatiskt till ord. pris 189 SEK/mån.", "challenge_2021.listing_page.hero.premium_desc": "Välkommen till Yogobe Challenge! Bibehåll motivationen och prioritera din hälsa genom att utmana dig själv med ett av programmen nedan.*", "challenge_2021.listing_page.hero.premium_disclaimer": "*Så länge du har en aktiv prenumeration eller accesstid så har du åtkomst till program och utmaningar.", "challenge_2021.listing_page.hero.title": "Yogobe Challenge <0>Nyhet</0>", "challenge_2021.metadata.browse_challenges": "Utforska programmen", "challenge_2021.metadata.explore_challenges_btn": "Utforska de olika utmaningarna", "challenge_2021.metadata.get_started_btn": "Kom igång", "challenge_2021.metadata.how_it_works_btn": "Hur fungerar det?", "challenge_2021.metadata.start_now_btn": "Starta nu för bara 99 SEK*", "challenge_2021.metadata.tags.challenge": "Challenge", "challenge_2021.metadata.tags.participating": "Deltar", "challenge_2021.steps_section.step1.desc": "Välj det program som låter mest lockande. Vi strävar alltid efter att möta medlemmars behov.", "challenge_2021.steps_section.step1.title": "1. Välj ditt program och utmaning", "challenge_2021.steps_section.step2.desc": "Htta det program som du vill börja med, aktivera din access och starta direkt!", "challenge_2021.steps_section.step2.title": "2. Starta din utmaning", "challenge_2021.steps_section.step3.desc": "Försök ta minst 3 klasser varje vecka i fyra veckor för god regelbundenhet.", "challenge_2021.steps_section.step3.title": "3. Utmana dig själv", "challenge_2021.steps_section.step4.desc": "När du har genomfört ditt program och slutfört din utmaning så får du gärna fortsätta med dessa videor i vardagen eller välja ett nytt program!", "challenge_2021.steps_section.step4.title": "4. Vidhåll en god vana", "challenge_2021.steps_section.title": "En steg för steg guide", "challenge_form.already_applied": ["Vi är snart igång! Du har fått ett mail skickat till ", ["email"], ". Vid frågor kontakta info@yogobe.com"], "challenge_form.already_applied_paragraph": ["Har du inte mottagit mejlet? <0>Klicka här för att skicka igen. (", ["count"], "s)</0>"], "challenge_form.didnt_apply": "Du kan byta program i utmaningen", "challenge_form.didnt_apply_1": ["Hej ", ["firstName"], ", fyll i formuläret och få fullständig tillgång till ", ["title"], "!"], "challenge_form.didnt_apply_2": ["Fyll i formuläret och få fullständig tillgång till ", ["title"], "!"], "challenge_form.email": "Email", "challenge_form.errors.email_used": "E-postadressen du angav används redan. Om den tillhör dig, vänligen logga in.", "challenge_form.errors.required": "Detta fält är obligatoriskt", "challenge_form.first_name": "Förnamn", "challenge_form.gotoprogram": "Gå till program", "challenge_form.inprogram": ["Du är aktiv i vår <0>", ["name"], "</0> programmet."], "challenge_form.last_name": "Efternamn", "challenge_form.level": "Program", "challenge_form.level_note": "Scrolla ner för att läsa mer", "challenge_form.login": "challenge_form.login", "challenge_form.reset_program": "Vill du byta program?  <0>Klicka här för att ändra</0>", "challenge_form.submit": "Kom igång", "company.access_code_action": "Skriv in din accesskod", "company.empty_company_programs_courses": ["Skriv in din accesskod för att se ", ["companyName"], "’s program och kurser"], "company.playlists_description": ["Playlists är samlingar av video- och audiofiler från Yogobes videobibliotek som satts samman av ", ["companyName"]], "company.recommended_blog_posts": "Rekommenderade blogginlägg", "confirm_delete_playlist_modal.description": ["Du håller på att radera din playlist: <0>", ["title"], "</0> som innehåller ", ["videos_count"], " sessioner. Du kan inte ångra detta. Är du säker på att du vill fortsätta?"], "confirm_delete_playlist_modal.no": "Nej, behåll min playlist", "confirm_delete_playlist_modal.title": "Ta bort playlist", "confirm_delete_playlist_modal.yes": "Ja, jag vill ta bort denna playlist", "consent.cookies.accept": "Acceptera kakor", "consent.cookies.desc": "För att ständigt kunna förbättra Yogobe och anpassa innehåll för att passa just dig, så analyserar vi gärna din webbtrafik hos oss och andra.", "consent.cookies.read_more": "Läs mer om cookies", "consent.cookies.reject": "Neka kakor", "consent.cookies.title": "Vi använder kakor", "courses_2021.banner.verify_account": "Bekräfta din mailadress och aktivera ditt medlemskap.", "courses_2021.buy_gift.banner_text": "Du köper nu denna kurs som en gåva till någon annan. Om det är du själv som vill få access, <0>klicka här</0>", "courses_2021.buy_gift.description": "Vi är glada att du vill ge denna kurs som gåva till en vän!", "courses_2021.buy_gift.description_tooltip": "Efter genomförd betalning så får du ett email innehållande en unik köpkod och instruktioner hur kursen aktiveras", "courses_2021.buy_gift.meta_title": ["Yogobe kurs - ", ["title"]], "courses_2021.contact.contact_text": "Kontakt: <0>business@yogobe.com</0>", "courses_2021.contact.desc": "Vad roligt att du och din organisation är intresserade av att komma igång med Yogobe. Digitalt, demokratiskt, lättillgängligt och enkelt att komma igång. Tillsammans tar vi fram och skräddarsyr innehåll och stöd med syfte att främja såväl fysisk och mental hälsa inom företag och organisationer för individ och medarbetare. Ett programformat är perfekt för team som träffas remote och arbetsplatser där man önskar inspiration och vägledning för rörelse i vardagen där allas olika intressen och behov tas i beaktning - det finns alltså något för alla. För att komma igång, kontakta mig via email!", "courses_2021.contact.purchase_banner_back": "courses_2021.contact.purchase_banner_back", "courses_2021.contact.title": "Välkommen till Yogobes onlinekurser!", "courses_2021.expiration_banner.expire_soon.buy_program_text": ["Din access till denna kurs går ut om ", ["days"], " dagar. Förläng redan idag för att fortsätta ha access i ytterligare en period. Din tidigare data följer givetvis med."], "courses_2021.expiration_banner.expire_soon.renew_access_free_text": ["Din access till denna kurs går ut om ", ["days"], " dagar. Du är välkommen att förnya och förlänga helt utan kostnad! Din tidigare data har sparats."], "courses_2021.expiration_banner.expire_soon.upgrade_to_renew_text": ["Din access till denna kurs går ut om ", ["days"], " dagar. Uppgradera till en betalande prenumeration så ingår obegränsad tillgång till denna kurs. Din tidigare data sparas."], "courses_2021.expiration_banner.expired.buy_program_text": ["Din access till detta program gich ut för ", ["days"], " dagar sedan. Du är välkommen att förnya och förlänga! Din tidigare data har sparats."], "courses_2021.expiration_banner.expired.renew_access_free_text": ["Din access till detta program gich ut för ", ["days"], " dagar sedan. Förnya och förläng idag utan kostnad. Din tidigare data har sparats."], "courses_2021.expiration_banner.expired.renew_with_discount_text": ["Din access till denna kurs gick ut för ", ["days"], " sedan. Förnya för ytterligare en period och få ", ["discount"], " rabatt. Givetvis är din tidigare data sparad. <0>Betalar du med friskvårdsbidrag?</0>"], "courses_2021.expiration_banner.expired.upgrade_to_renew_text": ["Din access till denna kurs gick ut för ", ["days"], " dagar sedan. Du är välkommen att förnya och förlänga helt utan kostnad!"], "courses_2021.expiration_banner.expires_soon.extend_with_discount_text": ["Din access till denna kurs går ut om ", ["days"], " dagar. Förläng redan nu för en till period och få ", ["discount"], " rabatt. Givetvis sparas din data. <0>Betalar du med friskvårdsbidrag?</0>"], "courses_2021.get_started.access_code.icon_text": "Skriv in din unika kod i denna textruta", "courses_2021.get_started.access_code.not_valid": "Koden du angav är ogiltig! ", "courses_2021.get_started.access_code.tooltip_text": "Du kan använda olika sorters koder hos Yogobe för att ge dig antingen åtkomst eller rabatt på olika delar av vårt innehåll.   Accesskod: En kod som man får via en arbetsgivare eller partnerorganisation till Yogobe.  Presentkort: En kod som du kan ha fått från en vän.  Rabattkod:  En kod som ger dig en specifik rabatt på utvalt innehåll hos Yogobe.", "courses_2021.get_started.access_code.valid": "Koden har registrerats", "courses_2021.get_started.access_code_mismatch": "Denna kod är giltig men aktiverar en annan kurs", "courses_2021.get_started.access_code_only_description": "Välkommen! <br/> Du kommer enbart åt denna kurs via en accesskod som du får antingen direkt från Yogobe eller via en partner till oss så som du arbetsgivare eller förening.", "courses_2021.get_started.activation_error": "Vi lyckas tyvärr inte aktivera din kurs åt dig. Snälla skriv till oss på info@yogobe.com och uppge gärna den mailadress som är kopplad till ditt konto hos oss.", "courses_2021.get_started.button.activate_for_free": "Aktivera", "courses_2021.get_started.button.continue_trial": "Fortsätt med 14 dagar gratis", "courses_2021.get_started.button.login": "Logga in och gå vidare", "courses_2021.get_started.button.purchase": "Fortsätt till säker betalning", "courses_2021.get_started.button.start_suscription": "Inled en prenumeration", "courses_2021.get_started.code_label": "Din unika kod", "courses_2021.get_started.description": "Välkommen! <br/> Du startar denna kurs antingen genom betalning, presentkort eller accesskod!", "courses_2021.get_started.end_of_access": "Åtkomst till", "courses_2021.get_started.guest_title": ["Välkommen till ", ["program"]], "courses_2021.get_started.join_btn": "Inled kursen", "courses_2021.get_started.option.have_account": "Jag har redan ett medlemskonto", "courses_2021.get_started.option.no_account": "Jag har inte ett medlemskonto", "courses_2021.get_started.purchase_banner_text": "Företräder du ett företag eller organisation som vill utforska digitala program för friskvård och hälsa? <0>Klicka här</0>", "courses_2021.get_started.show_code_input": "Har du en unik kod? <0>Klicka här</0>", "courses_2021.get_started.show_code_input_description": "En kod kan vara antingen en accesskod, ett presentkort eller ge dig en viss rabatt.", "courses_2021.get_started.user_title": ["Hej ", ["name"], ", välkommen till ", ["program"]], "courses_2021.get_started_loggedin.description": "Välkommen! <br/> Du startar denna kurs antingen genom betalning, presentkort eller accesskod!", "courses_2021.header.access_until": ["Du har kurs-access fram till ", ["date"]], "courses_2021.listing_page.hero.no_premium_disclaimer": "Betalar du med friskvårdsbidrag? <0>Läs mer</0>", "courses_2021.listing_page.hero.premium_disclaimer": "Betalar du med friskvårdsbidrag? <0>Läs mer</0>", "courses_2021.listing_page.meta.description": "Välkommen till Yogobes kurser – Tillsammans med ledande profiler och experter erbjuder vi utöver videobiblioteket och vår prenumerationstjänst specialframtagna och nischade kurser för att möta specifika önskemål och behov. Du betalar en gång för en kurs och får access i upp till 12 månader. Givetvis kan du gå flera kurser samtidigt om så önskas.", "courses_2021.listing_page.meta.title": "Yogobe Kurser", "courses_2021.listings_page.clear_events_filters": "Rensa Filter och Sök", "courses_2021.listings_page.explore_programs_btn": "Utforska kurser", "courses_2021.listings_page.faq_btn": "FAQ", "courses_2021.listings_page.filters.languages": "Visa mig kurser på", "courses_2021.listings_page.hero_title": "Yogobe Kurser", "courses_2021.listings_page.load_more_btn": "Visa fler kurser", "courses_2021.listings_page.no_programs_found": "Hoppla! Vi lyckas inte hitta ett program som är en perfekt match på ditt/dina sökord eller valda filter. Det som du letar efter kan fortfarande finnas hos oss. Snälla förnya din sökning eller ändra dina video- och filterninställningar!", "courses_2021.listings_page.search_input_placeholder": "Sök bland kurser...", "courses_2021.listings_page.subtitle": "Utöver Yogobe Play, vår prenumerationstjänst, erbjuder vi specialframtagna och nischade onlinekurser. Vi gör detta tillsammans med ledande profiler och experter för att möta specifika önskemål och behov. Du betalar för en kurs en gång och får access i upp till 12 månader. Givetvis kan du delta i flera kurser samtidigt.", "courses_2021.other_courses": "Andra kurser", "courses_2021.program_page.breadcrumb": "Yogobe kurser", "courses_2021.progress_page.parts_title": "Kursinnehåll", "courses_2021.progress_page.video_lock.button_text": "Delta i kursen", "courses_2021.progress_page.video_lock.text": "Du har precis sett en förhandsvisning på 60 sekunder. Vill du logga in eller starta denna kursen nu?", "courses_2021.snackbars.access_granted": "Du har nu aktiverat denna kurs", "courses_listing.faq.item1.body": "Våra onlinekurser ingår inte i vår prenumerationstjänst här på Yogobe utan köps separat. Det innebär att vem som helst kan gå en onlinekurs hos oss, oavsett om du är betalande medlem eller ej. Allt du behöver är ett Yogobe-konto för att kunna ta del av din kurs.", "courses_listing.faq.item1.title": "Vem kan ta delta i en onlinekurs? ", "courses_listing.faq.item10.body": "Våra kurser har nu fått en liknande design och struktur som våra träningsprogram samt utmaningar. Den nya strukturen är skapad för att underlätta ditt deltagande i en kurs och du kan nu följa din utveckling på ett nytt sätt. <br/><br/> Under varje kurs finns två flikar, “Översikt” och “Min utveckling”. Under “Översikt” hittar du all information om kursen och får en överblick av varje vecka/del som ingår. Under “Min utveckling” kommer du till en vy där du enkelt ser vilka videor som hör till vilken vecka/del och vad du redan har genomfört. Det är här du deltar i kursen och kommer att kunna del av klasser, övningar, föreläsningar och fördjupande läsning.", "courses_listing.faq.item10.title": "Vad innebär den nya kursdesignen och strukturen?", "courses_listing.faq.item11.body": "Om du inte väljer att förnya din kurs, till rabatterat pris, kommer du förlora access till kursen efter din accesstid gått ut. Din utveckling i kursen sparas dock, om du skulle önska förlänga din accesstid därefter. Du får 30% rabatt på din förnyelse, även efter att accesstiden löpt ut.", "courses_listing.faq.item11.title": "Vad händer när min accesstid gått ut?", "courses_listing.faq.item12.body": "Om du önskar ta del av en kurs längre än dess accesstid, vanligtvis upp till 12 månader men varierar från kurs till kurs, kan du alltid köpa kursen igen med 30% rabatt. Erbjudandet gäller från och med dina sista 30 accessdagar och framåt, även när din accesstid löpt ut. <br/> <br/> Detta erbjudande gäller endast vid köp av en kurs direkt på Yogobe.com, alltså inte om du köpt kursen via en friskvårdsleverantör.", "courses_listing.faq.item12.title": "Kan jag få rabatt om jag köper kursen igen?", "courses_listing.faq.item13.body": "Klicka dig in på kursen. Överst till höger på sidan hittar du en stor ruta, klicka på de tre prickarna i övre högra hörnet i rutan. Välj sedan “Förläng access”.", "courses_listing.faq.item13.title": "Hur förlänger jag min access till en kurs?", "courses_listing.faq.item14.body": "1) Om du önskar ge bort en kurs som du själv deltar i: <br/> Gå in på kursen du vill ge bort. Överst till höger på sidan hittar du en stor ruta, klicka på de tre prickarna i rutans övre högra hörn. Klicka sedan på “Köp som gåva”. <br/><br/> 2) Om du önskar ge bort en kurs som du själv inte deltar i: <br/> Klicka på kursen du vill ge bort och klicka dig sedan vidare på länken “Köp som gåva”. <br/><br/> Ett presentkort är giltigt i 12 månader från dagen för köp.", "courses_listing.faq.item14.title": "Hur gör jag om jag vill ge bort en kurs som gåva?", "courses_listing.faq.item15.body": "Då en onlinekurs köps med en engångssumma kan inte deltagandet avbrytas. Den löper sedan på till dess att accesstiden gått ut.", "courses_listing.faq.item15.title": "Kan jag avsluta mitt deltagande i en kurs?", "courses_listing.faq.item16.body": "Klicka på kursen du emottagit en accesskod till. Klicka sedan “Inled kurs”. <br/> Klicka på länken i: “Har du en unik kod? Klicka här”. <br/> Fyll i koden i rutan och klicka på ✓.", "courses_listing.faq.item16.title": "Hur startar jag en kurs med en accesskod?", "courses_listing.faq.item2.body": "Klicka på den kurs du är intresserad av att köpa. Inne på kursen – klicka på knappen “Inled kursen” och fyll i dina betaluppgifter där. Du betalar en engångsavgift via betalkort eller Swish. Kursen aktiveras vid köpet.", "courses_listing.faq.item2.title": "Hur köper jag en kurs?", "courses_listing.faq.item3.body": "Precis som med vår prenumerationstjänst kan du köpa en onlinekurs med ditt friskvårdsbidrag. Du kan köpa en kurs direkt på Yogobe.com och sedan skriva ut ditt kvitto från din profil i övre högra hörnet på sidan. Klicka på “Mina inställningar” och sedan på “<a href=\"https://yogobe.com/se/me/settings/receipts\">Mina kvitton</a>”. <br/></br> Om din arbetsgivare samarbetar med någon av friskvårdsleverantörerna <a href=\"https://yogobe.com/se/blog/friskvardsbidrag-benify\">Benify</a>, <a href=\"https://yogobe.com/se/blog/friskvardsbidrag-wellnet\">Wellnet</a> eller <a href=\"https://yogobe.com/se/blog/friskvardsbidrag-epassi-minfriskvard\">ePassi</a> – klicka på aktuell leverantör för att läsa mer om hur du köper en kurs där. ", "courses_listing.faq.item3.title": "Kan jag köpa en kurs med mitt friskvårdsbidrag?", "courses_listing.faq.item4.body": "Ja absolut! Våra onlinekurser finns tillgängliga hos friskvårdsleverantörerna <a href=\"https://yogobe.com/se/blog/friskvardsbidrag-benify\">Benify</a>, <a href=\"https://yogobe.com/se/blog/friskvardsbidrag-wellnet\">Wellnet</a> eller <a href=\"https://yogobe.com/se/blog/friskvardsbidrag-epassi-minfriskvard\">ePassi</a>. Läs mer under respektive länk hur du köper en kurs hos aktuell leverantör. ", "courses_listing.faq.item4.title": "Kan jag köpa en kurs via en friskvårdsleverantör? ", "courses_listing.faq.item5.body": "Våra onlinekurser ingår inte i våra prenumerationer utan köps separat för en engångssumma. Du behöver inte ha en aktiv prenumeration hos Yogobe för att kunna köpa och gå våra onlinekurser, däremot måste du ha ett Yogobe-konto, vilket du enkelt skapar när du köper en kurs om du inte har det sedan tidigare.", "courses_listing.faq.item5.title": "Ingår onlinekurserna i min prenumeration?", "courses_listing.faq.item6.body": "När du köpt en kurs hos oss har du tillgång till kursen i upp till 12 månader från den dag du köpt kursen, oavsett kurslängd. Se respektive kurs för dess accesstid.", "courses_listing.faq.item6.title": "Hur länge har jag tillgång till en kurs jag köpt?", "courses_listing.faq.item7.body": "När du har köpt en kurs hittar du alltid enkelt dina aktiva kurser under <a href=\"https://yogobe.com/se/me/dashboard\">Översikt</a> i din profil. För att komma åt din profil behöver du vara inloggad på ditt Yogobe-konto.", "courses_listing.faq.item7.title": "Hur hittar jag en kurs jag köpt?", "courses_listing.faq.item8.body": "I dagsläget är kurserna endast tillgängliga via hemsidan Yogobe.com. Självklart kan du gå in via en webbläsare i din smartphone och komma åt programmet i mobilen på det sättet.", "courses_listing.faq.item8.title": "Kan jag ta del av kurserna i appen?", "courses_listing.faq.item9.body": "Självklart kan du det, du kan delta i precis så många kurser du önskar.", "courses_listing.faq.item9.title": "Kan jag köpa och delta i flera kurser samtidigt?", "createplaylist_modal.actions.primary": "Spara", "createplaylist_modal.actions.secondary": "Avbryt", "createplaylist_modal.description.label": "Beskrivning", "createplaylist_modal.description.placeholder": "Skapa en beskrivning för din playlist", "createplaylist_modal.hidden_helper": "Din playlist är dold", "createplaylist_modal.hidden_title": "Dold playlist", "createplaylist_modal.name.label": "Namn", "createplaylist_modal.name.placeholder": "Ge din playlist en rubrik", "createplaylist_modal.options.one": "Publik", "createplaylist_modal.options.three": "Privat", "createplaylist_modal.options.two": "Dold", "createplaylist_modal.privacy_helper": "Din profil är privat, men denna playlist syns fortfarande för alla då den är publik. <0>Ändra sekretessinställningar.</0>", "createplaylist_modal.private_helper": "Din playlist är privat", "createplaylist_modal.private_title": "Privat playlist", "createplaylist_modal.public_helper": "Din playlist syns i publika listningar och kan komma att föreslås till andra användare.", "createplaylist_modal.public_title": "Publik playlist", "dashboard.bundles_section.title": "Dina temasidor", "dashboard.challenges_section.description": ["Du deltar just nu i ", ["count"], " utmaningar"], "dashboard.challenges_section.discover": "Utforska våra utmaningar", "dashboard.challenges_section.empty_list": "Du deltar just nu inte i några utmaningar>>>>>>> develop=======>>>>>>> master", "dashboard.challenges_section.explore_programs": "Utforska våra utmaningar", "dashboard.challenges_section.title": "Dina utmaningar", "dashboard.courses_section.description": ["Du deltar för närvarande i ", ["count"], " kurser"], "dashboard.courses_section.discover": "Utforska våra kurser", "dashboard.courses_section.empty_list": "Du deltar just nu inte i någon kurs", "dashboard.courses_section.explore_courses": "Utforska Yogobes kurser", "dashboard.courses_section.title": "Dina kurser", "dashboard.events_section.discover": "Upptäck kommande LIVE-klasser", "dashboard.events_section.empty_list": "Du är inte inbokad på några kommande LIVE-klasser", "dashboard.events_section.expired_events": "Genomförda LIVE-klasser", "dashboard.events_section.explore": "Utforska alla LIVE klasser", "dashboard.events_section.show_previous_events": "Visa mina genomförda klasser", "dashboard.events_section.title": "Dina bokade LIVE-event", "dashboard.for_me.courses.title": "Kurser för dig", "dashboard.for_me.playlists.title": "Dina rekommenderade playlists", "dashboard.for_me.programs.title": "Program för dig", "dashboard.for_me.videos.title": "Dina rekommenderade videor", "dashboard.last_watched_sessions_section.title": "Mina senast sedda", "dashboard.my_stats.beta_stripe_message": "Detta är en beta-version och det kan hända att resultaten inte är helt tillförlitliga. Ju mer du interagerar med tjänsten desto fler datapunkter kan vi hämta och illustrera för dig med bl.a. grafer och diagram. Detta är första versionen. Vårt mål är att du skall få en fin, tydlig och enkel överblick över ditt Yogobe-användande. Om du saknar något, snälla skriv och berätta det för oss på data@yogobe.com", "dashboard.my_stats.challenges_started": "Antal startade utmaningar", "dashboard.my_stats.challenges_started<<<<<<< HEAD": "Antal startade utmaningar>>>>>>> master", "dashboard.my_stats.completed_sessions": "Antal genomförda sessioner", "dashboard.my_stats.completed_sessions<<<<<<< HEAD": "Antal genomförda sessioner>>>>>>> master", "dashboard.my_stats.courses_started": "Antal startade kurser", "dashboard.my_stats.courses_started<<<<<<< HEAD": "Antal startade kurser>>>>>>> master", "dashboard.my_stats.empty_result": "Använd tjänsten så visualiserar vi din data", "dashboard.my_stats.explore_challenges": "Utforska Yogobe-utmaningarna!", "dashboard.my_stats.explore_challenges<<<<<<< HEAD": "Utforska Yogobe-utmaningarna!>>>>>>> master", "dashboard.my_stats.explore_courses": "Utforska våra online-kurser ", "dashboard.my_stats.explore_courses<<<<<<< HEAD": "Utforska våra online-kurser >>>>>>> master", "dashboard.my_stats.explore_library": "Utforska Yogobe-biblioteket", "dashboard.my_stats.explore_library<<<<<<< HEAD": "Utforska Yogobe-biblioteket>>>>>>> master", "dashboard.my_stats.explore_live_events": "Utforska Yogobe LIVE", "dashboard.my_stats.explore_live_events<<<<<<< HEAD": "Utforska Yogobe LIVE>>>>>>> master", "dashboard.my_stats.explore_programs": "Utforska våra program", "dashboard.my_stats.explore_programs<<<<<<< HEAD": "Explore Yogobe programs", "dashboard.my_stats.explore_yogobe_team": "Utforska Team Yogobe", "dashboard.my_stats.favorited_sessions": "Antal favoritmarkerade sessioner", "dashboard.my_stats.favorited_sessions<<<<<<< HEAD": "Antal favoritmarkerade sessioner>>>>>>> master", "dashboard.my_stats.live_events_booked": "Antal LIVE-event som du har bokat", "dashboard.my_stats.live_events_booked<<<<<<< HEAD": "Number of LIVE events booked=======", "dashboard.my_stats.most_watched_instructors": "Topp 3 mest sedda experter", "dashboard.my_stats.most_watched_instructors<<<<<<< HEAD": "Dina topp 3 mest sedda experter>>>>>>> master>>>>>>> master", "dashboard.my_stats.most_watched_styles": "3 mest sedda stilar/träningsformer", "dashboard.my_stats.my_favorited_sessions": "Se mina favoriter", "dashboard.my_stats.my_favorited_sessions<<<<<<< HEAD": "Se mina favoriter>>>>>>> master", "dashboard.my_stats.my_playlists": "Se mina playlists", "dashboard.my_stats.my_playlists<<<<<<< HEAD": "Se mina playlists>>>>>>> master", "dashboard.my_stats.period_month": "Senaste 30 dagarna", "dashboard.my_stats.period_month<<<<<<< HEAD": "Senaste 30 dagarna>>>>>>> master", "dashboard.my_stats.period_week": "Senaste 7 dagarna", "dashboard.my_stats.period_week<<<<<<< HEAD": "Senaste 7 dagarna>>>>>>> master", "dashboard.my_stats.playlists_created": "Antal skapade playlists", "dashboard.my_stats.playlists_created<<<<<<< HEAD": "Antal skapade playlists>>>>>>> master", "dashboard.my_stats.programs_started": "Antal startade program", "dashboard.my_stats.programs_started<<<<<<< HEAD": "Antal startade program>>>>>>> master", "dashboard.my_stats.three_most_watched_styles": "Ditt audio- och videodeltagande i antal minuter", "dashboard.my_stats.three_most_watched_styles<<<<<<< HEAD": "Tid i minuter av deltagande>>>>>>> master=======", "dashboard.my_stats.title": "Här samlar vi din personliga interaktions-statistik ", "dashboard.pricing_description": "Vilken medlemsform passar dig?", "dashboard.pricing_title": "Bli prenumerant och få full åtkomst till vårt videobibliotek!", "dashboard.programs_section.description": ["Du deltar för närvarande i ", ["count"], " program"], "dashboard.programs_section.discover": "Utforska våra program", "dashboard.programs_section.empty_list": "Du deltar just nu inte i något program", "dashboard.programs_section.explore_programs": "Utforska Yogobes program", "dashboard.programs_section.title": "Dina program", "dashboard.recommendation.empty.button": "Ändra preferenser", "dashboard.recommendation.empty.desc": "Berätta vad du har för behov och intressen så rekommenderar vi videor och playlists!", "dashboard.recommendation.empty.title": "Rekommenderade videor och playlists", "dashboard.recommendations.complete_onboarding": "Sätt igång", "dashboard.recommendations.content_languages": "Visa mig rekommenderat innehåll på:", "dashboard.recommendations.edit_preferences": "Ändra preferenser", "dashboard.recommendations.filter_default_label": "Filtrera efter intressen och behov", "dashboard.recommendations.meta_title": "Rekommenderat för dig", "dashboard.recommendations.title": "Ditt rekommenderade innehåll är baserat på de preferenser som du har valt. Du kan ändra dem när du vill. ", "dashboard.recommendations.view_recommendations": "Vill du hitta videor som möter dina behov och intressen? <0>Se dina rekommendationer</0>", "dashboard.recommendations.visit_recommendations": "Vill du snabbt och lätt hitta videor och playlists som möter dina behov och intressen?", "dashboard.settings.email_settings.desc": "Styr vilka email du önskar motta. Du kan när som helst ändra dessa inställningar.", "dashboard.settings.email_settings.title": "Hantera email-notifikationer", "dashboard.settings.email_update_failed": ["Det gick inte att spara denna mailadressen. Snälla prova igen eller skriv till oss på <0>", ["email"], "</0> så hjälper vi dig!"], "dashboard.settings.live_codes.banner_desc": "Välj önskad LIVE-klass och klicka på <0>Boka</0>. I nästa steg fyller du i koden i fältet för <0>Accesskod</0> för att kunna ta del av en LIVE-klass utan ytterligare betalning <0></0> PS. Koderna är unika för ditt konto och kan inte delas med andra. ", "dashboard.settings.live_codes.banner_title": "Så här använder och aktiverar du en kod", "dashboard.settings.live_codes.code_label": "LIVE-kod", "dashboard.settings.live_codes.empty_text": "Du har för tillfället inga giltiga accesskoder för Yogobe LIVE.", "dashboard.settings.live_codes.events": "Valbara LIVE event", "dashboard.settings.live_codes.expiration": ["Giltig till och med ", ["date"]], "dashboard.settings.live_codes.multiple_usage_code_item": ["Använd den ", ["usageDate"], " på ", ["title"], " med ", ["instructor"], "."], "dashboard.settings.live_codes.multiple_usage_code_left": ["Du kan fortfarande använda denna kod ", ["availableUsage"], " gånger."], "dashboard.settings.live_codes.multiple_usage_code_summary": ["Den här koden har använts ", ["usedTimes"], " av ", ["usageLimit"], " gånger."], "dashboard.settings.live_codes.single_usage_code": ["Denna kod användes ", ["usageDate"], " på ", ["title"], " med ", ["instructor"], "."], "dashboard.settings.live_codes.title": "Accesskoder för Yogobe LIVE", "dashboard.settings.live_codes.trial_panel.desc": "Som en del av din provperiod får du två accesskoder att använda på någon av våra LIVE-klasser.  <0>Utforska Yogobe LIVE</0>", "dashboard.settings.live_codes.trial_panel.title": "Koder för att testa Yogobe LIVE", "dashboard.settings.live_codes.trial_panel.title_tooltip": "Dessa två LIVE-koder ingår i din provperiod på Yogobe. De är giltiga 60 dagar från det att du har skapat ditt konto. <0>Utforska Yogobe LIVE</0>", "dashboard.settings.live_codes.wellness_panel.desc": ["Du har kjøpt én eller flere tilgangskoder for Yogobe LIVE gjennom ", ["provider"], " den ", ["date"], ". Bruk disse på noen av våre LIVE-klasser som er oppført nedenfor."], "dashboard.settings.live_codes.wellness_panel.title": "Kod via friskvårdsbidrag för Yogobe LIVE", "dashboard.settings.live_codes.wellness_panel.title_tooltip": "Detta är vanligtvis en kod/ett paket du har köpt via en friskvårdsportal. ", "email_preferences.prefrences_updated": "email_preferences.prefrences_updated", "email_preferences_page.desc": "Styr vilka email du önskar motta från oss. Du kan när som helst ändra dessa inställningar genom att antingen klicka på länken längst ner i våra nyhetsbrev eller via din Översikt på Yogobe.com. ", "email_preferences_page.title": "Hantera email-notifikationer", "emptyresults.click_here": "Klicka här", "emptyresults.empty": "Hoppla... 0 resultat återfanns.", "emptyresults.empty_filter": "Vi kan inte hitta resultat som matchar din kompletta sökning. Kanske kan du justera den litegrann genom att ta bort taggar eller använda frisök-rutan? Observera att dina  <0>videoinställningar</0> för språk påverkar resultaten!", "emptyresults.to_clear_filters": "och rensa alla filter", "emptyresults.try_adjusting_or": "Utöka eller ändra din sökning för fler resultat, eller", "error.action": "Gå till Startsidan", "error.body_404_part1": "Du försöker få åtkomst till en sida hos Yogobe som inte finns.", "error.body_404_part2": "Något har alltså blivit fel, vänligen använd sökfunktionen hos oss för att finna det du letar efter! Tack för att du besöker oss.", "error.body_500": "Du skall inte ha landat på denna sidan. Mest sannolikt har något hänt med den länken som du tryckt på för att hamna här. Det kan också vara något som strular i din webbläsare eller med din internetuppkoppling. Snälla ladda om sidan eller testa Google Chrome. Om problemet kvarstår skulle vi bli oerhört tacksamma om du vill rapportera din upplevelse till <0>data@yogobe.com</0> så att vi snabbt kan undersöka och åtgärda. Tack!", "error.dear_visitor": "Något har gått fel..", "error.server_error": "Något har gått fel..", "errors.maxlength": ["Du kan max skriva ", ["length"], " tecken"], "favorites.empty_playlists_description": "Du har inte markerat några playlist-favoriter ännu", "favorites.empty_playlists_title": "Mina favoritplaylists", "favorites.empty_videos_description": "Du har inte markerat några video-favoriter ännu", "favorites.empty_videos_title": "Mina favoritvideor", "favorites.playlists_company_empty_description": [["companyName"], " har ännu inte markerat några playlistfavoriter"], "favorites.playlists_company_empty_title": "Favoritplaylists", "favorites.playlists_company_second_empty_description": "Denna medlem delar inte sina favoritvideor publikt ännu", "favorites.playlists_public_profile_empty_description": "Denna medlem delar inte sina favoritplaylists publikt ännu", "favorites.playlists_public_profile_empty_title": "Favoritplaylists", "favorites.videos_company_empty_description": [["companyName"], " har ännu inte markerat några videofavoriter från videobiblioteket på Yogobe"], "favorites.videos_company_empty_title": "Favoritvideor", "favorites.videos_public_profile_empty_description": "Denna medlem delar inte sina favoritvideor publikt ännu", "favorites.videos_public_profile_empty_title": "Favoritvideor", "featuredblgoposts.title": "Utvalda blogginlägg", "feedback_modal.icons.awesome": "Jag älskar den nya beta-versionen", "feedback_modal.icons.happy": "Jag gillar den nya beta-versionen", "feedback_modal.icons.hate": "Jag tycker inte om beta-versionen", "feedback_modal.icons.sad": "Den behöver förbättras ytterligare", "feedback_modal.question1": "Hur var din användarupplevelse?", "feedback_modal.question2": "Har du några förbättringsförslag?", "feedback_modal.question3": "Jag vill rapportera buggar", "feedback_modal.title": "Berätta vad du tycker", "footer.copyright": ["©YOGOBE ", ["year"], ". All rights reserved."], "footer.label2": "Sociala medier", "footer.label3": "Tjänsten", "footer.languages.english": "English", "footer.languages.finnish": "Suomi", "footer.languages.label": "Language", "footer.languages.norwegian": "Norsk", "footer.languages.swedish": "Svenska", "footer.links.community": "Community", "footer.links.discover": "Upptäck", "footer.links.yogobe": "Yogobe", "forgot_password_modal.back": "Tillbaka till login", "forgot_password_modal.email": "Email", "forgot_password_modal.paragraph": "Skriv in din mailadress så skickar vi ett mail till dig för att återställa ditt lösenord.", "forgot_password_modal.send_instructions": "Skicka instruktioner", "forgot_password_modal.title": "Har du glömt ditt lösenord?", "getstarted.breathe": "Andas", "getstarted.meditation": "Meditera", "getstarted.move": "Träna", "getstarted.yoga": "Yoga", "global_menu.course.courses_trainings.desc": "Fördjupa din kunskap inom hälsa, yoga och träning.", "global_menu.course.courses_trainings.title": "Kurser & ubildningar", "global_menu.course.events.desc": "Inspireras på event inom yoga- och träningsbranschen.", "global_menu.course.events.title": "Events", "global_menu.course.onlinekurser.desc": "Utforska våra egna onlinekurser. ", "global_menu.course.onlinekurser.title": "Onlinekurser", "global_menu.course.title": "Kurser & Resor", "global_menu.course.travel_retreats.desc": "Upptäck härliga destinationer världen över.", "global_menu.course.travel_retreats.title": "Resor & retreats", "global_menu.live.title": "LIVE", "global_menu.more.about.desc": "Lär känna oss som företag.", "global_menu.more.about.title": "Om Yogobe", "global_menu.more.blog.desc": "Kunskap, tips & intressant läsning.", "global_menu.more.blog.title": "Blogg", "global_menu.more.business.desc": "Stöd till arbetsgivare och organisationer", "global_menu.more.business.title": "Företag", "global_menu.more.contact.desc": "Säg hej till oss!", "global_menu.more.contact.title": "Kontakta oss", "global_menu.more.en_business.item1": "Yogobe business", "global_menu.more.en_business.item2": "Classes and lectures", "global_menu.more.en_business.item3": "For yoga teachers", "global_menu.more.friskvårdsbidrag.desc": "Träning finansierad av din arbetsgivare", "global_menu.more.friskvårdsbidrag.title": "Friskvårdsbidrag", "global_menu.more.healthcare.desc": "Hur Yogobe stöttar patienter och förskrivare", "global_menu.more.healthcare.title": "Vården", "global_menu.more.non_profit.desc": "Kolla in våra non-profit-initiativ.", "global_menu.more.non_profit.title": "Non-profit", "global_menu.more.se_business.item1": "Arbetsgivare", "global_menu.more.se_business.item2": "Pausa Smart", "global_menu.more.se_business.item3": "Yogobe för yogalärare", "global_menu.more.se_business.item4": "Hotell & Konferens", "global_menu.more.se_business.item5": "Partners", "global_menu.more.se_healthcare.item1": "FaR – Fysisk aktivitet på recept", "global_menu.more.store.desc": "Köp yogamattor, props och mycket annat.", "global_menu.more.store.title": "Shop", "global_menu.more.team.desc": "Lär känna våra experter.", "global_menu.more.team.title": "Team Yogobe", "global_menu.more.title": "Mer", "global_menu.more_menu.banner.button": "Läs mer här", "global_menu.more_menu.banner.title": "Visste du att du kan använda ditt friskvårdsbidrag inom Yogobe?", "global_menu.play.playlists.desc": "Utforska vårt omfattande utbud av playlists.", "global_menu.play.playlists.title": "Playlists", "global_menu.play.programs.desc": "Hitta rätt träningsprogram för dig. ", "global_menu.play.programs.title": "Program", "global_menu.play.title": "Play", "global_menu.play.video_audio.desc": "Upptäck +2100 sekvenser", "global_menu.play.video_audio.title": "Audio- & videobibliotek", "global_menu.play.yogobe_challenge.desc": "Håll motivationen vid liv med en utmaning.", "global_menu.play.yogobe_challenge.title": "Utmaningar", "global_menu.search.title": "Sök", "global_menu.store.title": "Shop", "header.login": "Logga in", "header.try_free": "Testa gratis", "healthcare.listing_page.hero.no_premium_disclaimer": "*Du får åtkomst till detta program via en vårdgivare, arbetsgivare eller partner till Yogobe ", "healthcare.listing_page.hero.premium_disclaimer": "*Du får åtkomst till detta program via en accesskod från en vårdgivare, arbetsgivare eller partner till Yogobe ", "healthcare.listing_page.meta.description": "Program inom digital prevention och friskvård", "healthcare.listing_page.meta.title": "Yogobe Hälsa & friskvård", "healthcare.listings_page.explore_programs_btn": "Utforska våra program", "healthcare.listings_page.faq_btn": "Frågor & svar ", "healthcare.listings_page.hero_title": "Program för preventiva hälsoinsatser", "healthcare.listings_page.subtitle": "Vi hjälper arbetsgivare, försäkringsbolag och vårdgivare att stötta anställda och patienter med digitala verktyg inom mental och fysisk hälsa och välmående. Här kan du utforska våra program inom digital prevention.  ", "healthcare_listing.faq.item1.body": "Du som har blivit ordinerad eller tilldelad access via en vårdgivare, arbetsgivare eller ett försäkringsbolag. Dessa program är del av Yogobe Health & Care och ligger utanför den prenumerationstjänst som erbjuds till privatpersoner.", "healthcare_listing.faq.item1.title": "Vem kan delta i ett program?", "healthcare_listing.faq.item2.body": "Efter att du har anmält dig och fått access till ett program så har du smidig tillgång till det via Yogobes app under “Mitt bibliotek” eller längst upp på din <0>översiktssida</0> när du är inloggad på <1>yogobe.com</1>", "healthcare_listing.faq.item2.title": "Hur kommer jag åt mitt program?", "healthcare_listing.faq.item3.body": "Självklart! Såväl arbetsgivare som försäkrings- och vårdbolag kan köpa in Yogobe och våra program samt digitala interventioner, som stöd och komplement till befintliga insatser till förmån för individ, medarbetare och patient. Maila oss på <0>business@yogobe.com</0> så berättar vi mer.", "healthcare_listing.faq.item3.title": "Kan företag köpa enskilda program?", "healthcare_listing.faq.item4.body": "Nej. Om du kommer till Yogobe Healthcare med en accesskod som du har fått från en patientförening, vårdgivare, arbetsgivare eller försäkringsbolag så betalar du personligen ingenting för åtkomst till det specifika Yogobe-program eller material som du ordinerats.", "healthcare_listing.faq.item4.title": "Måste jag betala?", "healthcare_listing.faq.item5.body": "Om du har ett FaR-recept som du vill använda på Yogobe så ber vi dig skicka en kopia (en fotograferad bild går bra) på ditt FaR-recept till <0>info@yogobe.com</0>. Därefter får du instruktioner kring hur du enkelt kommer igång med Yogobes FaR-specifika utbud.", "healthcare_listing.faq.item5.title": "Hur använder jag mitt FaR-recept på Yogobe?", "hero.get_started": "Kom igång", "hero_thank_you.dashboard": "Min översikt", "hero_thank_you.gotoprogram": "Gå till programmet", "hero_thank_you.reset": "Vill du byta program?  <0>Klicka här för att ändra</0>", "hero_thank_you.thanks": ["Tack ", ["firstName"], "!"], "hero_thank_you.you_are_in_program": ["Du har nu tillgång till programmet <0>", ["program"], "</0>."], "homepage.courses_section.explore_marketplace": "Utforska onlinekurser>>>>>>> master>>>>>>> develop", "homepage.cta_section.pricing_btn": "Prenumerationsalternativ", "homepage.features_section.get_app_btn": "Skaffa appen", "homepage.hero_section.register_btn": "<<<<<<< HEAD", "homepage.hero_section.wellness_btn": "Friskvårdsbidrag", "homepage.mobile_section.app_store_btn": "App Store", "homepage.mobile_section.play_store_btn": "Play Store", "homepage.sections.register_btn": "Kom igång", "instructor.title": "Om", "karolinska.get_started.access_code.label": "Accesskod", "karolinska.get_started.access_code.not_valid": "Acesskoden du angav är ogiltig! ", "karolinska.get_started.access_code.required": "Du behöver en accesskod för att komma åt programmet ", "karolinska.get_started.access_code.requirement": "För att delta i detta program behöver du en accesskod ", "karolinska.get_started.access_code.valid": "Accesskoden är giltig! ", "karolinska.get_started.activation_error": "Vi kunde inte aktivera detta program för dig, vänligen ta kontakt med oss på info@yogobe.com", "karolinska.get_started.button.continue": "Gå vidare", "karolinska.get_started.button.login": "Logga in och gå vidare", "karolinska.get_started.button.register": "Skapa ett 14-dagars prova-på-konto ", "karolinska.get_started.button.start_program": "Börja programmet", "karolinska.get_started.guest.welcome_message": "Välkommen till Stressprogrammet", "karolinska.get_started.option.have_account": "Jag har redan ett medlemskonto", "karolinska.get_started.option.no_account": "Jag har inte ett medlemskonto", "karolinska.get_started.select_option": "Vänligen välj det som är applicerbart för dig ", "karolinska.get_started.terms.label": "Jag accepterar <0>villkoren</0>", "karolinska.get_started.terms.required": "Vänligen godkänn våra villkor för att fortsätta! ", "karolinska.get_started.user.welcome_message": ["Hej ", ["name"], ", välkommen till Stressprogrammet "], "karolinska.preview_cover.guest.button": "Delta i programmet", "karolinska.preview_cover.guest.video_locked": "Om du har en accesskod till programmet, klicka på knappen nedan för att komma igång. ", "karolinska.preview_cover.user.video_locked": "Du har sett en 60 sekunders förhandsvisning. Hela videon kommer att låsas upp när föregående vecka är slutförd. ", "landing_page.offer.best_value": "Best value", "landing_page.offer.blue_section.cta_text": "Testa gratis 14 dagar", "landing_page.offer.blue_section.list_item1": "2100 videor för alla dina behov", "landing_page.offer.blue_section.list_item2": "Spara offline. Yoga och träna var som helst, närsomhelst", "landing_page.offer.blue_section.list_item3": "Obegränsad tillgång till vårt videobibliotek, alla program och utmaningar", "landing_page.offer.blue_section.list_item4": "Skapa, dela och följ playlists", "landing_page.offer.blue_section.title": "Vad får du som aktiv medlem?", "landing_page.offer.first_section.cta_text": "Prova gratis 14 dagar", "landing_page.offer.free_trial": "Prova 14 dagar", "landing_page.offer.getstarted": "Kom igång", "landing_page.offer.most_affordable": "Mest prisvärt", "landing_page.offer.playlists_section.title": "Upptäck relevanta playlists", "landing_page.offer.programs_section.title": "Program som ingår för aktiva medlemmar", "landing_page.offer.subscription_annually_billed": "Din prenumeration förnyas årligen.", "landing_page.offer.subscription_free_plan_label": "Obegränsad access utan att ange kortuppgifter.", "landing_page.offer.subscription_free_price_label": "Gratis", "landing_page.offer.subscription_free_title": "Gratis prova-på", "landing_page.offer.subscription_monthly_billed": "Din prenumeration förnyas varje månad.", "landing_page.offer.subscription_monthly_per": "/ månad", "landing_page.offer.subscription_quarterly_billed": "Förnyas varje kvartal och övergår automatiskt till ordinarie pris i kvartal två. ", "landing_page.offer.subscription_quarterly_per": "/ kvartal", "landing_page.offer.subscription_sub_title": "Starta en årprenumeration och få 500 SEK att handla Yogiraj för.", "landing_page.offer.subscription_title": "Bli betalande medlem och få obegränad tillgång till videobiblioteket", "landing_page.offer.testomonials_section.title": "Vad säger våra medlemmar?", "landing_page.offer.videos_section.title": "Utvalda videor för dina behov", "landingpage.hero.bullet1": "On-demand & LIVE online", "landingpage.hero.bullet2": "Spara offline i vår app", "landingpage.hero.bullet3": "Prova gratis utan bindningstid", "landingpage.hero.cta": "Testa 14 dagar gratis", "landingpage.hero.subtitle": "Några minuter om dagen gör under för hälsan", "landingpage.hero.title": "Vill du också yoga, träna & meditera online?", "landingpage.mobileapp_section.desc": "Ladda ner våra nya app idag och dela gärna med dig av din feedback om hur du använder appen.", "landingpage.mobileapp_section.title": "Ladda ner appen och testa redan idag!", "landingpage.section2.desc": "Välkommen att yoga, träna och guidas till avslappning med många av landets främsta experter, instruktörer och terapeuter, som alla brinner för att dela sin kunskap för att du skall må bra i vardagen. Enkelt, roligt och lätt att använda var du vill – när du vill. Skapa och behåll en god vana tillsammans med oss! Som medlem blir du också del i en vår härliga community. Välkommen att testa gratis! Alltid utan bindningstid.", "landingpage.section2.link": "Utforska 2000 videor", "landingpage.section2.title": "Yoga och träna hemma i vardagsrummet", "landingpage.section2.trailer_tag": "Trailer", "landingpage.section4.item1.desc": "Tillsammans med arbetsgivaren skräddarsyr vi och paketerar digitala och fysiska insatser och aktiviteter som möter individbehoven i hela medarbetargruppen för fysiskt och mentalt välbefinnande genom livets många faser och skeden, bla. med klasser, föreläsningar, utmaningar och kurser inom stress, sömn, fokus och hållbarhet. Allt för att öka trivsel, gemenskap och minska risken för sjukskrivningar.", "landingpage.section4.item1.title": "Företagshälsa", "landingpage.section4.item2.desc": "Får du friskvårdsbidrag av din arbetsgivare? Då kan du enkelt använda det hos oss. Du kan välja att köpa din prenumeration direkt på Yogobe, för att därefter skriva ut och lämna in ditt kvitto direkt till arbetsgivaren. Däremot, om din arbetsgivare samarbetar med Benify, Actiway, Wellnet eller ePassi så går du via dem för att använda ditt friskvårdsbidrag på Yogobe. Lätt som en plätt. ", "landingpage.section4.item2.title": "Friskvårdsbidraget", "landingpage.section4.item3.desc": "Vi samarbetar med Mecenat, Tjejzonen, jobbar med skolan och mot asylboenden. Den bästa träningen är den som blir av, och genom att erbjuda onlineträning till en digital generation hoppas vi bidra till bättre folkhälsa! Vi ger Yogobe gratis till olika grupper som motvikt till stillasittande och psykisk ohälsa i vårt samhälle.", "landingpage.section4.item3.title": "Yogobe Non-profit", "landingpage.section4.readmore": "LÄS MER", "landingpage.section5.title": "Mer hos Yogobe", "landingpage.section6.cta": "Testa 14 dagar gratis", "landingpage.section6.disclaimer": "Provtiden övergår inte i en betalande prenumeration", "landingpage.section6.subtitle": "Vill du få obegränsad tillgång till klasser, playlists, program & utmaningar?", "landingpage.section6.title": "Yogobe medlemskap", "landingpage.section7.title": "Vad tycker våra medlemmar om Yogobe?", "landingpage.squareitems.alt_text.book_retreat": "På Yogobe kan du boka ett yogaretreat eller anmäla dig till en yogalärarutbildning.", "landingpage.squareitems.alt_text.deepen_your_knowledge": "Fördjupa dina kunskaper - läs mer om Yogobes mest populära onlinekurser. Klicka här och ta del av exklusiva rabatter!", "landingpage.squareitems.alt_text.getstarted": "Kom enkelt igång med Yogobe - för din onlineträning hemma.", "landingpage.squareitems.alt_text.live": "Upplev våra realtidsklasser online via Yogobe LIVE. Gå till schemat här!", "landingpage.squareitems.alt_text.news_yogobe": "Ta del av våra senaste nyheter på Yogobe inom online yoga, träning, meditation och andning.", "landingpage.squareitems.alt_text.program_card": "Lär dig löpträning från grunden med Magnus Hagström - i hans onlineprogram på Yogobe: 12 veckor till milen.", "landingpage.squareitems.alt_text.wellness_grant": "Läs om hur du kan använda ditt friskvårdsbidrag på Yogobe.", "landingpage.squareitems.alt_text.ybteam": "Lär känna Team Yogobe - med över 90 exeperter och lärare inom yoga, träning, meditation och andning.", "landingpage.squareitems.challenge.text1": "Yogobe Challenge", "landingpage.squareitems.challenge.text2": "FÖRSTA MÅNADEN", "landingpage.squareitems.challenge.text3": "SEK", "landingpage.squareitems.challenge.text4": "99", "landingpage.squareitems.challenge.text5": "5 OLIKA UTMANINGAR", "landingpage.squareitems.get_started.text1": "Hur kommer jag", "landingpage.squareitems.get_started.text2": "enkelt igång", "landingpage.squareitems.get_started.text3": "med Yogobe?", "landingpage.squareitems.get_started.text4": "Steg-för-steg guide. Klicka här!", "landingpage.squareitems.live.text1": "LIVE", "landingpage.squareitems.live.text2": "Upplev energin av att delta", "landingpage.squareitems.live.text3": "LIVE-online i realtid", "landingpage.squareitems.live.text4": "Flera klasser", "landingpage.squareitems.live.text5": "varje vecka", "landingpage.squareitems.marketplace.text1": "Vill du boka", "landingpage.squareitems.marketplace.text2": "ett retreat eller", "landingpage.squareitems.marketplace.text3": "utbilda dig inom", "landingpage.squareitems.marketplace.text4": "yoga?", "landingpage.squareitems.marketplace.text5": "Gå till Yogobe Marketplace", "landingpage.squareitems.online_courses.text1": "Fördjupa", "landingpage.squareitems.online_courses.text2": "dina kunskaper", "landingpage.squareitems.online_courses.text3": "Ta del av månadens", "landingpage.squareitems.online_courses.text4": "rabatterade onlinekurser", "landingpage.squareitems.running_program.text1": "12 veckor till milen", "landingpage.squareitems.running_program.text2": "Program med Magnus Hagström", "landingpage.squareitems.team_yogobe.text1": "Lära känna", "landingpage.squareitems.team_yogobe.text2": "Team Yogobe", "landingpage.squareitems.team_yogobe.text3": "med fler än 70 experter", "landingpage.squareitems.team_yogobe2.text1": "Nyheter på Yogobe", "landingpage.squareitems.wellness_grant.text1": "Hur kan jag", "landingpage.squareitems.wellness_grant.text2": "använda mitt", "landingpage.squareitems.wellness_grant.text3": "friskvådsbirag", "landingpage.squareitems.wellness_grant.text4": "på Yogobe?", "landingpage.squareitems.wellness_grant.text5": "Läs om hur du gör här.", "landingpage.testimonials.item1.name": "Ann-Sofie Forsmark", "landingpage.testimonials.item1.quote": "”Det är det solklart bästa sättet att få till yoga för mig, för barnen och att få till SOMA.”", "landingpage.testimonials.item1.title": "Hälsostrateg", "landingpage.testimonials.item2.name": "Lori Wäne", "landingpage.testimonials.item2.quote": "”Att kunna ha tillgång till yogaklasser hemma de dagar jag inte har möjlighet att ta mig till en studio är oerhört värdefullt.”", "landingpage.testimonials.item2.title": "Blivande yogalärare", "landingpage.testimonials.item3.name": "Malin Magnusson", "landingpage.testimonials.item3.quote": "”Yogobe är i mina ögon väldigt prisvärt och jag har träningen med mig överallt.”", "landingpage.testimonials.item3.title": "Småbarnsmamma & mångsysslare", "landingpage.testimonials.item4.name": "Anna Åhlgren", "landingpage.testimonials.item4.quote": "”För att få inspiration av kloka och roliga kollegor.”", "landingpage.testimonials.item4.title": "Yogalärare & berättare", "live.event.levels.advanced": "Avancerade utövare", "live.event.levels.beginner": "Nybörjare", "live.event.levels.everyone": "För alla", "live.event.levels.intermediate": "Vana utövare", "live.event.levels.other": "Annat", "live.event_page.about_event": "Om sessionen", "live.event_page.all_event_link": "Alla sessioner", "live.event_page.banner_donation_class": "Denna LIVE-klass är till förmån för Världsnaturfonden WWF ", "live.event_page.book_btn": "Boka", "live.event_page.booking_closed_banner": "Bokningen för denna session är nu stängd.", "live.event_page.coming_soon": "Kommer snart", "live.event_page.donation_class": "Donationsklass", "live.event_page.event_date_time": "Datum & tid för sessionen", "live.event_page.event_free": "Gratis", "live.event_page.event_instructors": "Experter", "live.event_page.event_lang_label": "Språk på sessionen", "live.event_page.event_prerequisites": "Utrustning", "live.event_page.expired_event": "Genomförd", "live.event_page.for_for_you": "Gratis för dig", "live.event_page.fully_booked_event": "Fullbokad", "live.event_page.join_btn": "Delta nu", "live.event_page.join_btn_reserved": "Du har bokat din plats", "live.event_page.no_prerequisites_required": "Ingen utrustning behövs för denna session.", "live.event_page.prerequisites_yogobe_store": "Vill du fylla på med utrustning hemma? <0>Besök Yogobe Store</0>", "live.event_page.recording_more_info": "Mer information", "live.event_page.recording_more_info_tooltip": "Inspelningen försvinner cirka 24h efter att den har genererats av Zoom. Efter denna period kommer du inte längre kunna se denna inspelade LIVE-session.", "live.event_page.registration_end_label": "Sista möjlighet för att boka", "live.event_page.reserve_spot_banner.book_btn": "Boka min plats", "live.event_page.reserve_spot_banner.browse_events": "Utforska andra sessioner", "live.event_page.reserve_spot_banner.desc": ["Boka din plats på <0>", ["event_name"], "</0> medan det finns platser kvar "], "live.event_page.reserve_spot_banner.event_date": ["Datum för sessionen: ", ["date"]], "live.event_page.reserve_spot_banner.expired_desc": ["Anmälan till <0>", ["event_name"], "</0> är nu stängd."], "live.event_page.reserve_spot_banner.last_registration_date": ["Anmäl dig senast: ", ["endDate"]], "live.event_page.reserve_spot_banner.reserved_desc": ["Din plats på <0>", ["event_name"], "</0> har bokats."], "live.event_page.reserve_spot_banner.reserved_title": "Anmälan bekräftad!", "live.event_page.reserve_spot_banner.share_btn": "Dela session", "live.event_page.reserve_spot_banner.title": "Reservera din plats!", "live.event_page.reserved_spot.click_join": "Klicka för att gå med", "live.event_page.reserved_spot.hosted_zoom": "Denna session genomförs via Zoom", "live.event_page.reserved_spot.or_copy_link": "Eller kopiera och klistra in länken i din webbläsare", "live.event_page.reserved_spot.zoom_code_label": "Lösenord", "live.event_page.spots_left": ["Bara ", ["spots"], " platser kvar"], "live.event_page.sticky_banner.discount_available": "Du får 30% rabatt då du har en aktiv prenumerationsperiod", "live.event_page.sticky_banner.free_for_you": "Denna session är inkluderad, utan extra kostnad, som del i din prenumeration", "live.event_page.subscription_discount_text": "LIVE-klasser ingår varje vecka när du har en aktiv betalande prenumeration. <0>Uppgradera</0>", "live.event_page.view_all_instructor_events": ["<0>Se alla sessioner</0> med ", ["name"]], "live.event_page.watch_session_recording": "Titta på den inspelade sessionen", "live.event_page.you_r_in_event": "ANMÄLD", "live.listings.live_codes_card.description": "Du har en eller flera accesskoder till veckoklasser på Yogobe LIVE.", "live.listings.live_codes_card.description2": "Boka nu, innan de går ut", "live.listings.live_codes_card.see_code_btn": "Se mina koder", "live.listings.live_codes_card.title": "Bra att veta", "live.listings_page.banner.subscription_discount_text": "LIVE-klasser ingår i våra prenumerationer OCH du får 30% rabatt på alla premium LIVE-sessioner. Välj den medlemsform som passar dig", "live.listings_page.clear_events_filters": "Återställ Filter & sök", "live.listings_page.disclaimer": "LIVE-klasser ingår för medlemmar med en betalande prenumeration", "live.listings_page.explore_events_btn": "Ta del av kalendern", "live.listings_page.filter_applied_toaster": "Filter har sparats", "live.listings_page.filters.donation_class": "Donationsklass", "live.listings_page.filters.free_event": "Gratis event", "live.listings_page.filters.instructors": "Alla experter", "live.listings_page.filters.kind_class": "Klass", "live.listings_page.filters.kind_label": "Alla typer", "live.listings_page.filters.kind_lecture": "Föreläsning", "live.listings_page.filters.kind_online_course": "Kurs", "live.listings_page.filters.kind_skills": "Kunskap", "live.listings_page.filters.kind_talk": "Talks", "live.listings_page.filters.kind_workshop": "Workshop", "live.listings_page.filters.languages": "Visa sessioner på", "live.listings_page.filters.sort_by_date": "Datum", "live.listings_page.filters.sort_by_price": "Pris", "live.listings_page.filters.sort_label": "Sortera efter", "live.listings_page.filters.sort_mobile_label": "Sortera och filtrera", "live.listings_page.filters.sort_modal_title": "Filtrera", "live.listings_page.hero_title": "Yogobe LIVE", "live.listings_page.load_more_btn": "Visa fler", "live.listings_page.no_events_found": "Hoppsan... Inga sessioner hittades för denna sökning. Var vänlig att ta bort filtreringen och/eller gör om din sökning.", "live.listings_page.pricing_section.title": "Våra LIVE-klasser ingår för alla med en aktiv prenumeration!", "live.listings_page.search_input_placeholder": "Sök bland LIVE-sessioner...", "live.listings_page.subtitle": "Yoga, träna och meditera i realtid - med Yogobe LIVE. Praktisera tillsammans som ett Community under vägledning av Team Yogobe.", "live.live_page.metadata.desc": ["Spana in LIVE-sessionen ", ["eventName"], " med ", ["instructor"], " - boka din plats nu eller utforska andra live-sessioner på yogobe.com/live"], "live.payment_page.access_code.not_valid": "Din accesskoden är ogiltig", "live.payment_page.access_code.valid": "Accesskoden är giltig", "live.payment_page.action_button.activate": "Aktivera", "live.payment_page.action_button.login": "Logga in och gå vidare", "live.payment_page.action_button.register": "Logga in och gå vidare", "live.payment_page.action_button.start_suscription": "Skapa ett 14-dagars prova-på-konto ", "live.payment_page.activate_email_banner": "Vi är jätteglada att du vill delta vid vid detta LIVE-event. För att kunna boka din plats är det viktigt att du först aktiverar och verifierar ditt konto hos Yogobe via det email som vi har skickat till dig.", "live.payment_page.code_input.description": "Har du en kod från oss eller din arbetsgivare?", "live.payment_page.code_input.description_tooltip": "Om du har erhållit en rabatt- eller accesskod för LIVE – fyll i den här för att få access till denna LIVE-klass.", "live.payment_page.code_input.show_text": "Om du har en rabatt- eller accesskod, <0>klicka här</0>", "live.payment_page.countdown_banner": ["Slutför bokningen för att säkra din plats. Återstående tid: <0>", ["min"], ":", ["sec"], " min</0>"], "live.payment_page.countdown_timeout_btn": "Tillbaka till eventsidan", "live.payment_page.countdown_timeout_desc": "Tiden för bokning har gått ut då ingen betalning genomfördes. Vänligen gå tillbaka och testa igen.", "live.payment_page.details": "Du kommer att få mail där vi bekräftar din anmälan och delar praktisk information. Vi skickar också ett påminnelsemail 15 minuter innan start.", "live.payment_page.discount_amount": "Rabatt", "live.payment_page.discount_text": "Liveklasser inkluderas i din prenumeration. Du får även 30% rabatt på premium LIVE-event. Uppgradera ditt medlemskap till en prenumeration på en gång, givetvis kommer du automatiskt tillbaka till samma sidan. <0>Kika på erbjudanden</0> ", "live.payment_page.donation_class_details": "Detta är en donationsklass till förmån för WWF. Om du inte redan har donerat en gåva till kampanjen Yoga for Nature så skulle vi bli tacksamma om du vill göra det. <0> Läs mer och donera hos WWF här!</0> <1></1> <1></1> När du har bokat din plats så får du ett email där vi bekräftar din anmälan och delar praktisk information.", "live.payment_page.event_accesscode_activated.toast": "Du är nu bokad på live-sessionen! ", "live.payment_page.free_event_reserved.toast": "Du är nu bokad på live-sessionen! ", "live.payment_page.free_reserve_spot": "Boka din plats", "live.payment_page.payment_amount": "Att betala", "live.payment_page.payment_reserve_spot": "Fortsätt till säker betalning", "live.payment_page.summary_title": "Ordersammanfattning", "live.payment_page.term_conditions": "Jag godkänner Yogobe's <0>betalnings- och återbetalningspolicyn</0>", "live.payment_page.term_conditions_tooltip": "Villkoren för LIVE hittar du under paragraf 4.10 i våra användarvillkor. <0>Läs mer här</0>", "live.paymentfail.body": ["Något gick fel.. din betalning på ", ["amount"], " SEK gick inte igenom. Vänligen försök igen. Om problemen kvarstår, vänligen kontakta vår tekniska support: <0>data@yogobe.com</0>"], "live.paymentfail.btn": "Gå tillbaka & försök igen", "live.paymentfail.orderdetails.body": ["Transaktions-ID: ", ["transaction"]], "live.paymentfail.title": "Betalningen misslyckades", "live.paymentsuccess.body": ["Tack, din betalning på ", ["amount"], " ", ["currency"], " har mottagits. En betalningsbekräftelse skickas till ", ["email"]], "live.paymentsuccess.btn": "Fortsätt", "live.paymentsuccess.orderdetails.body": ["Order-ID: ", ["order"]], "live.paymentsuccess.title": "Betalning lyckades!", "login_modal.action.create": "Skapa konto", "login_modal.action.forgot": "Glömt ditt lösenord?", "login_modal.action.login": "Logga in", "login_modal.action.or_create": "Är du inte redan medlem? <0>skapa konto</0>", "login_modal.action.social_label": "Eller logga in med", "login_modal.errors.incorrect": "Felaktig mailadress eller lösenord, vänligen försök igen", "login_modal.errors.incorrect_socials": "Du föresöker logga in på Yogobe med hjälp av antingen Apple, Google eller Facebook. Du har ännu inget konto hos oss kopplat till detta inloggningssätt. Om du redan är medlem vänligen fyll i din mailadress och lösenord istället. Ifall du inte redah har ett konto hos oss är du varmt välkommen att skapa ett! <br><br> OBS: Vi kommer skapa en funktion så att våra befintliga medlemmar kan koppla sina existerande konton till Apple, Google eller Facebook för enklare login i framtiden, men det finns ännu inte. Tack för tålamod!", "login_modal.helper": "Logga in för åtkomst till videobiblioteket, vårt växande kursutbud och din profil.", "login_modal.inputplaceholder.email": "Mailadress", "login_modal.inputplaceholder.password": "Lösenord", "login_modal.title": "Logga in", "login_page.landing.headline": "Vi är mycket glada att du är medlem hos oss!", "login_page.landing.subtitle": "Logga in och låt oss inspirera, engagera och guida dig till ökad mental hälsa och hållbarhet!", "maintenae_page.role": "Grundare och VD", "maintenance_page.body": "Between 04:00 and 05:00 today, we are doing updates to the system!  <br /> We are very excited about all the good things happening on the tech side of Yogobe at the moment and kindly ask for your patience. As you cannot access our video library just now we’d like to recommend a short chat with the magical Alan Finger on the topic of stress and how yoga and meditation can help us cope with it. <a href=\"https://www.facebook.com/YOGOBEcom/videos/420176531509273/\">Find it via the Yogobes Facebook page.</a> <br /> All the best,", "maintenance_page.title": "Midnight updates", "menu_add_playlist.add": "Lägg till i playlist", "menu_add_playlist.create": "Skapa ny playlist", "menu_more.schedule": "Schemalägg", "menu_more.share": "Dela", "menu_more.share_page": "Dela", "message1.spring_challenge.end": "Spring Challenge är nu bakom oss men du kommer fortfarande åt ditt valda program via din Översikt / Hem.", "message1.summer_challenge2020.end": "Summer Challenge är nu bakom oss men du kommer fortfarande åt ditt valda program via din Översikt / Hem.", "message1.winter_challenge.end": "Winter Challenge är nu bakom oss men du kommer fortfarande åt ditt valda program via din Översikt / Hem.", "message2.spring_challenge.end": "Vill du ge dig själv en ny utmaning?", "message2.winter_challenge.end": "Vill du ge dig själv en ny utmaning?", "meta.follow": "Följ", "metadata.accessUntil": "Tillgång till", "metadata.active": "aktiv", "metadata.all": "Alla", "metadata.and": "och", "metadata.apply": "Aktivera", "metadata.back_to_dashboard": "Tillbaka till översikt", "metadata.bodyparts": "Kroppsdelar", "metadata.bonus": "Bonus", "metadata.browse_all": "Visa alla", "metadata.challenge": "Challenge", "metadata.choose_file": "Välj en fil", "metadata.clear_all": "Rensa alla", "metadata.close": "STÄNG", "metadata.code_activation.failed": "Det verkar som om något har gått snett vid aktivering av din kod. Vänligen skriv till oss så hjälper vi dig! <0>Kontakta Yogobe</0>", "metadata.company_empty_playlists": "Inga publika playlists", "metadata.course": "Kurs", "metadata.courseLabel": "Kurs", "metadata.course_by": "Kurs av", "metadata.created_by": "Skapad av", "metadata.days.label": "Dagar", "metadata.delete": "Radera", "metadata.delete_playlist": "Ta bort Playlist", "metadata.document": "Dokument", "metadata.download": "Ladda ner ", "metadata.downloadPDF": "Kursöversikt", "metadata.download_all": "Ladda ner alla", "metadata.duration": "Längd", "metadata.edit_playlist": "Ändra playlist", "metadata.edit_profile": "Ändra Profil", "metadata.edite_privacy_settings": "Ändra sekretessinställningar", "metadata.empty_playlists": "Du har inte skapat några egna playlists ännu", "metadata.empty_playlists_action": "Upptäck playlists skapade av Yogobe", "metadata.english": "engelska", "metadata.exercise": "Klass", "metadata.expire_on": ["Denna kurs löper ut den ", ["expirationDate"]], "metadata.expired_on": ["Denna kurs löpte ut den ", ["expirationDate"]], "metadata.frequently_asked_questions.title": "Vanliga frågor", "metadata.getStarted": "Kom igång", "metadata.go_back_simple": "Gå tillbaka", "metadata.introduction": "Introduktion", "metadata.lecture": "Föreläsning", "metadata.load-more": "Visa fler", "metadata.login": "Logga in", "metadata.min": "min", "metadata.minuter": "minuter", "metadata.more": "visa fler", "metadata.more_items": ["& ", ["number"], " fler"], "metadata.my_stats": "Se min statistik", "metadata.needs": "Behov", "metadata.new": "Ny", "metadata.next": "Nästa", "metadata.only_you_can_see_this": "Bara du kan se detta", "metadata.payment.failed": "Vi kunde tyvärr inte genomföra din betalning med de uppgifter du fyllt i, vi ber dig därför att försöka igen. Om problement kvarstår, vänligen kontakta oss på <0></0>", "metadata.payment.success.continue_button": "Gå vidare", "metadata.payment.success.receipt_button": "Visa kvitto", "metadata.payment.success.title": "Betalningen genomförd", "metadata.paymentfail.btn": "Gå tillbaka & försök igen", "metadata.paymentfail.title": "Betalningen misslyckades", "metadata.playlists": "Playlists", "metadata.playlists_public_profile_empty_description": "Denna medlem delar inga playlists publikt ännu", "metadata.please_wait": "Vänligen vänta...", "metadata.premium": "Premium", "metadata.preview": "Förhandsvisning", "metadata.profile_private": "Publik profil", "metadata.program": "Program", "metadata.programLabel": "Program", "metadata.program_by": "Program av", "metadata.programs.my_progress": "Min utveckling", "metadata.programs.overview": "Översikt", "metadata.progressPercentage": [["percentage"], "% Genomfört"], "metadata.public_profile_empty_playlists": "Inga publika playlists", "metadata.question": "Fråga", "metadata.read_more": "Läs mer", "metadata.read_more_about": "Läs mer om", "metadata.recently_viewed_videos": "Senast sedda videor", "metadata.recommended_courses_programs_title": "Program på Yogobe som vi har tagit fram och erbjuder", "metadata.recommended_playlists_title": "Rekommenderade playlists", "metadata.recommended_videos_title": "Rekommenderade videor", "metadata.remove_from_playlist": "Radera från Playlist", "metadata.resume": "Fortsätt", "metadata.save": "Spara", "metadata.save_favorites": "Spara till favoriter", "metadata.save_more_than_per_year": ["Spara mer än ", ["amount"], " SEK per år"], "metadata.saved_favorites": "Sparad till favoriter ", "metadata.search": "Sök hela videobiblioteket", "metadata.search_library": "Sök allt innehåll på Yogobe", "metadata.show_less": "Visa färre", "metadata.show_more": "Visa fler", "metadata.signup": "Bli medlem", "metadata.skills": "Kunskap", "metadata.statistics": ["Du tog del av ", ["sessionsLastWeek"], " sessioner förra veckan."], "metadata.statistics_title": "Statistik", "metadata.styles": "Stil", "metadata.survey": "Enkät", "metadata.swedish": "svenska", "metadata.tags": "Tagg", "metadata.talk": "Prat", "metadata.textElement": "Text", "metadata.this_profile_is_private": "Denna profil är privat", "metadata.this_profile_is_private_title": "Privat profil", "metadata.upgrade": "Uppgradera", "metadata.videos": "Videor", "metadata.view_all": "Visa alla", "metadata.visitor": "besökare", "metadata.weeks.label": "Veckor", "metadata.with": "med", "metadata.workshop": "Workshop", "metadeta.programs.other_programs": "Alla program", "metatadata.errors.unexpectedError": "Något har blivit tokigt. Snälla försök igen eller kontakta oss via data@yogobe.com", "modals.publicplaylist.button1": "Ja, gör min profil", "modals.publicplaylist.button2": "Nej, jag önskar att min profil förblir privat", "modals.publicplaylist.helper": "Du önskar göra denna playliset publik för att dela med vänner och världen. För att det skall bli möjligt behöver du en öppen profil. Följande information kommer då att visas:", "modals.publicplaylist.option1": "Din profilbild", "modals.publicplaylist.option2": "För- och Efternamn", "modals.publicplaylist.option3": "Din beskrivningstext", "modals.publicplaylist.title": "Dina publika playlists", "my_playlists.title": "Mina playlists", "new_subscription_modal.bank_transfer": "Banköverföring", "new_subscription_modal.debit_credit_card": "Debit / kreditkort", "new_subscription_modal.description": "Våra prenumerationer är löpande, utan bindningstid och kan avbrytas när du vill", "new_subscription_modal.helper_bank": "Jag vill betala min prenumeration via mitt bankkonto (Trustly). Smidigt, tryggt och med direktkoppling till mitt konto.", "new_subscription_modal.select_option": "Välj det alternativ som passar dig allra bäst", "new_subscription_modal.title": "Uppgradera medlemskap", "new_subscription_modal.warning_finland_cc": "Detta alternativ finns ännu inte i Finland.", "onboarding.back.btn_text": "Tillbaka", "onboarding.banner.missed_onboarding": "Låt oss samla och rekommendera videor och innehåll som möter dina behov och önskemål!", "onboarding.completed.explore_store.desc": "Utforska Yogobe Store och få 10% rabatt på ditt första köp när du använder rabattkoden: MY10OFF", "onboarding.completed.explore_store.title": "Utforska yogatillbehör", "onboarding.completed.my_favorites.desc": "Utforska det innehåll som vi samlat med bas i dina uttryckta behov och önskemål", "onboarding.completed.my_favorites.title": "Innehåll rekommenderat för mig", "onboarding.completed.programs.desc": "onboarding.completed.programs.desc", "onboarding.completed.programs.title": "Utforska olika program och kurser för dina behov", "onboarding.completed.video_library.desc": "Utforska 1900+ videor inom fyra olika områden/kanaler: Yoga, Meditera, Andas och Träna", "onboarding.completed.video_library.title": "Videobiblioteket", "onboarding.continue.btn_text": "Fortsätt", "onboarding.description.edit_text": "Här kan du alltid ändra dina preferenser. Vid en ändring kommer vi automatiskt att uppdatera ditt rekommenderade innehåll som du hittar under din Översikt.", "onboarding.description.text": "Berätta gärna för oss vad du har för behov och intressen så att vi kan rekommendera videor åt dig!", "onboarding.finish.btn_text": "Slutför", "onboarding.meta_title": "Kom igång steg för steg", "onboarding.missing_lang.interests": "onboarding.missing_lang.interests", "onboarding.missing_lang.topics": "onboarding.missing_lang.topics", "onboarding.select.choices": "Du kan göra upp till tre val", "onboarding.select_interests.text": "Jag skulle vilja utforska...", "onboarding.select_topics.text": "Jag vill…", "onboarding.skip.btn_text": "Hoppa över", "onboarding.welcome.text": ["Välkommen ", ["name"]], "opengraph.companyFavorites_title": "Favoriter", "opengraph.companyOverview_title": "Översikt", "opengraph.companyPlaylists_title": "Playlists", "opengraph.dashboard_title": "Översikt", "opengraph.mefavorites_title": "Min favoriter", "opengraph.myplaylists_title": "Mina playlists", "opengraph.password_recovery_title": "Återskapa lösenord", "opengraph.playlists_collections_title": "Yogobe Playlist-kategorier", "opengraph.playlists_title": "Yogobe Playlists", "opengraph.profilePlaylists_title": "Mina playlists", "opengraph.profilefavorites_title": "Profil-favoriter", "opengraph.profilestats_title": "Min statistik", "opengraph.programs_title": "4-12 veckors program för våra medlemmar", "opengraph.settings_title": "Mina inställningar", "opengraph.stats_title": "Min statistik", "opengraph.videos_description": "Yoga, meditera, andas och träna online tillsammans med oss", "opengraph.videos_genres_title": "Yogobe Videobibliotek", "opengraph.videos_title": "Yogobe Videobibliotek", "ourprograms.title": "Upptäck våra program", "pages.company_favorite.title": "Favoriter", "pages.favorite.title": "Mina favoriter", "pages.favorite_public_title": "Favoriter", "pages.playlist_public_title": "Playlists", "pausa-smart.all-categories": "Alla kategorier", "pausa-smart.already-in-program": "Du deltar redan i detta program", "pausa-smart.browse-all-videos": "Översikt samtliga videor", "pausa-smart.download-pdf": "Ladda ner ", "pausa-smart.employee-access-code": "Jag är en medarbetare med en accesskod", "pausa-smart.form-access-code.already-used": "Den accesskod som du angivit har redan använts", "pausa-smart.form-comment": "Kommentar", "pausa-smart.form-company-name": "Företagsnamn", "pausa-smart.form-email": "Email", "pausa-smart.form-full-name": "Fullständigt namn", "pausa-smart.form-rules.accessCode.required": "Du måste ha en accesskod", "pausa-smart.form-rules.comment.max": "Din kommentar får max innehålla 200 tecken", "pausa-smart.form-rules.companyName.required": "Vänligen skriv in ert företagsnamn", "pausa-smart.form-rules.email.required": "Vänligen skriv in din email-adress", "pausa-smart.form-rules.email.valid": "Var snäll och fyll i en giltig email-adress", "pausa-smart.form-rules.fullName.required": "Vänligen fyll i ditt fullständiga namn ", "pausa-smart.form-submit": "Skicka", "pausa-smart.form-title": "Vill du prova gratis i 14 dagar?", "pausa-smart.form.success-existing": ["Du har nu fått access till Pausa Smart i ", ["days"], " dagar. Du hittar programmet enkelt vila din översiktssida. Ett bekräftelsemail har också skickats till dig. "], "pausa-smart.form.success-interest": ["Tack ", ["firstname"], " för ert intresse i Pausa Smart. Vi återkommer till dig via email inom kort för att se hur vi bäst kan göra för att erbjuda digitala verktyg och program för hälsa och välmående på ert företag."], "pausa-smart.form.success-new": ["Tack! Vi har skickat ett bekräftelsemail till ", ["email"], ". Klicka på länken i detta email för att skapa ditt konto och få Pausa Smart access. Om du redan har ett personligt medlemskonto på Yogobe snälla be din arbetsgivare om en ny accesskod och börja om. Uppge då istället den mailadress som du redan har kopplad till ditt Yogobe-konto så att du kan samla allting på samma plats hos oss. Välkommen!"], "pausa-smart.form_access_code": "Accesskod", "pausa-smart.get-started": "Kom igång", "pausa-smart.go-to-program": "Gå till program", "pausa-smart.interviews-testimonials-title": "Prova-på klasser att utforska", "pausa-smart.organization": "Jag företräder ett företag/organisation", "pausa-smart.read-less": "Stäng ", "pausa-smart.read-more": "Läs mer", "pausa-smart.testimonials-title": "Våra kunder berättar om Pausa Smart", "pausa-smart.title": "Pausa Smart", "pausa-smart.videos-in-total": ["Visar sammanlagt ", ["n"], " videor"], "pausa-smart.videos.languagues.all": "Alla språk", "pausa-smart.videos.languagues.english": "Engelska", "pausa-smart.videos.languagues.swedish": "Svenska", "pausasmart.form.no_account.title": "Logga in eller skapa ett konto för att använda koden", "pausasmart.get_started.access_code.desc": "Denna accesskod tillhandahålls vanligtvis av någon inom ert företag eller organisation", "pausasmart.get_started.access_code.dont_have": "Jag har ingen accesskod", "pausasmart.get_started.access_code.have": "Min arbetsgivare har givit mig en accesskod", "pausasmart.get_started.access_code.label": "Accesskod", "pausasmart.get_started.access_code.not_valid": "Vi beklagar, denna accesskod är ogiltig ", "pausasmart.get_started.access_code.valid": "Du har nu fått tillgång till Pausa Smart Challenge", "pausasmart.get_started.account.dont_have": "Jag vill skapa konto", "pausasmart.get_started.account.have": "Jag har ett konto", "pausasmart.get_started.button.continue": "Gå vidare", "pausasmart.get_started.button.continue_plan": "Fortsätt med månadsprenumeration", "pausasmart.get_started.button.continue_trial": "Fortsätt med 14 dagar gratis", "pausasmart.get_started.button.login": "Logga in", "pausasmart.get_started.button.upgrade_continue": "Uppgradera och gå vidare", "pausasmart.get_started.dont_have_code.hovertip": "Får att kunna ta del av audio- och videosessioner på Yogobe så måste du ha giltig accesstid via en aktiv prenumeration eller tid kvar på din gratis prova-på period. Detta inbegriper även playlists, program och våra löpande utmaningar.  Din accesstid kan också ha uppgraderats genom din arbetsgivare där du fått tillgång till hela eller delar av Yogobe som tjänst. Till exempel så kan du ha fått 90 dagars access till just detta program av din arbetsgivare - Allt du behöver göra är att skriva in den kod som du fått. Programmet sparas till din profil och visas tydligt när du loggar in.", "pausasmart.get_started.dont_have_code.text": "Denna utmaning ingår för alla aktiva medlemmar. Om du inte redan är medlem, skapa enkelt en 14 dagars prova-på period. Du kan också uppgradera ett befintligt medlemskonto med en prenumeration och få obegränsad tillgång till videor, playlists, program och utmaningar. <0>Läs mer</0>", "pausasmart.get_started.have_premium.text": "Detta program ingår för dig som aktiv eller betalande medlem", "pausasmart.get_started.program_activation_failed": "Något tycks ha blivit tokigt. Snälla försök igen eller <0>kontakta vår kundtjänst</0>", "pausasmart.get_started.purchase_banner_back": "Tillbaka", "pausasmart.get_started.purchase_banner_text": "Företräder du ett företag eller organisation som vill joina Yogobe Challenge? <0>klicka här</0>", "pausasmart.get_started.subtitle": "Vänligen välj det alternativ som stämmer in på dig:", "pausasmart.get_started.title": ["Hej ", ["name"], ", välkommen till Pausa Smart Challenge"], "pausasmart.purchase.contact": "Kontakt: <0>business@yogobe.com</0>", "pausasmart.purchase.desc": "Vi är väldigt glada att du och din organisation är intresserade av att komma igång med Pausa Smart Challenge. Detta är ett program som vi har tagit fram med bas i de behov och önskemål som våra företagskunder givit uttryck för. En fyra veckors utmaning och digitalt verktyg för fysisk och mental hälsa som är perfekt för dem som jobbar på distans, för team som träffas remote och arbetsplatser där man önskar inspiration och vägledning för rörelse och reflektion i vardagen.  För endast 5000 SEK i engångsavgift får samtliga era medarbetare tre månaders obegränsad access till utmaningen. Det spelar ingen roll om ni är 100 eller 10 000 anställda. Välkommen till ett unikt erbjudande som är specialanpassat för nuvarande Covid-19 situation. För att komma igång, kontakta oss via email!", "pausasmart.purchase.title": "Hej, välkommen till Pausa Smart Challenge!", "payment.modal.banktransfer.info": "Yogobe samarbetar med Trustly så att du tryggt och säkert kan föra pengar till oss direkt från ditt bankkonto. Förnya eller avbryt enkelt och säkert. Din prenumeration har ingen bindningstid.", "payment.modal.cardpayment.info": "Yogobe samarbetar med Nets/DIBS så att du skall kunna betala ditt medlemskap hos oss med ditt VISA eller Mastercard. Enkelt, säkert och lätt att förnya eller avbryta då din prenumeration inte har någon bindningstid", "payment_modal.banner.active_subscription_upgrade": "Vi är glada att du vill förlänga/ändra din prenumeration. Du betalar i all enkelhet direkt från ditt bankkonto eller med ett bank/betalkort. Om du vill avbryta i framtiden så gör du det med en snabb knapptryckning.", "payment_modal.banner.inactive_subscription_upgrade": "Vi är glada att du vill uppgradera ditt medlemskap till prenumeration. Du är nu bara några knapptryckningar från obegränsad åtkomst till biblioteket, playlists, progran och utmaningar. Betala i all enkelhet direkt från ditt bankkonto eller med ett bank/betalkort. Ifall du vill avbryta i framtiden så sker det med en snabb knapptryckning.", "payment_modal.banner.subscription_upgrade": "Vi är glada att du vill uppgradera ditt medlemskap med en prenumeration hos oss. Du betalar i all enkelhet direkt från ditt bankkonto eller med ett bank/betalkort. Om du i framtiden vill avbryta så sker det snabbt med en knapptryckning.", "payment_modal.banner.trial_upgrade": "Vi är glada att du vill inleda en prenumeration. Du betalar i all enkelhet direkt från ditt bankkonto eller med ett bank/betalkort. Eventuella kvarvarande accessdagar adderas givetvis automatiskt till din första prenumerationsperiod. Ifall du vill avbryta framöver så sker det snabbt med en knapptryckning.", "payment_modal.banner.unverified_trial_upgrade": "Vi är glada att du vill inleda en prenumeration. Vi ser att du inte ännu har verifierat din mailadress. Så snart du gör det så aktiveras ditt konto och du får tillgång till den gratis provperiod med Yogobe som vi lovat dig. Om du utöver denna gratisperiod vill uppgradera ditt medlemskap till prenumeration så kan du enkelt och lätt betala direkt från ditt bankkonto eller med ett bank/betalkort. OBS: När du väljer att verifiera din mailadress så adderas din innestående provperiod automatiskt till din första prenumerationsperiod. ", "payment_modal.error": "Vi älskar att du vill bli betalande medlem på Yogobe. Just nu utför vi underhållsarbete på vår betalmodul och beräknar vara klara under onsdagen. Till dess har du gratis tillgång till allt innehåll i videobiblioteket! Välkommen tillbaka hit då!", "payment_modal.payment_method.card.label": "Betala med kort", "payment_modal.payment_method.trustly.submit_button": "Fortsätt med bankbetalning via", "paymentconfirmation.btn1": "Stäng", "paymentconfirmation.btn2": "Visa kvitton", "paymentconfirmation_subscription.modal.body": ["Din betalning om ", ["paymentAmount"], " har mottagits och vi bekräftar att ditt konto har uppgraderats med en löpande prenumeration per ", ["subscriptionType"], " som förnyas automatiskt den ", ["recurringDate"], " med ", ["recurringPaymentAmount"], "."], "paymentconfirmation_subscription.modal.title": "Betalningsbekräftelse", "paymentverification_modal.body": "Vi är glada att du vill uppgradera ditt medlemskap hos oss. För att bekräfta ditt betalkort och genomföra din önskade prenumerationsbetalning kommer NETS, vår betalleverantör, först reservera 1 SEK. Detta är en del i processen av säkra kortbetalningar.", "phasedProgram.introduction.label": "Introduktion", "phasedProgram.moodtracker.post.description": "Hur känner du dig nu? Checka in med dig själv för att känna hur du mår efter övningen genom att fylla i denna mood-tracker.", "phasedProgram.moodtracker.post.start_button": "Gå vidare", "phasedProgram.moodtracker.post.title": "Hur mår du nu?", "phasedProgram.moodtracker.pre.description": "Ta en kort stund för att checka in hur du mår genom att fylla i denna korta mood-tracker. Det tar inte mer tid än några långa, djupa andetag.", "phasedProgram.moodtracker.pre.start_button": "Fortsätt", "phasedProgram.moodtracker.pre.title": "Hur mår du?", "phasedProgram.moodtracker_modal.post.description": "Hur känner du dig nu? Checka in med dig själv för att känna hur du mår efter övningen genom att fylla i denna mood-tracker.", "phasedProgram.moodtracker_modal.post.title": "Hur mår du nu?", "phasedProgram.moodtracker_modal.pre.description": "Ta en kort stund för att checka in hur du mår genom att fylla i denna korta mood-tracker. Det tar inte mer tid än några långa, djupa andetag.", "phasedProgram.moodtracker_modal.pre.title": "Hur mår du?", "phasedProgram.moodtracker_modal.submit_button": "Spara och stäng", "phasedProgram.outro.videos_count": [["videosCount"], " Videor"], "phasedProgram.phase.number": ["Fas ", ["number"]], "phasedProgram.phase.number_weekRange": ["Fas ", ["phaseNumber"], ": vecka ", ["weekRange"]], "phasedProgram.phase.videos_duration": [["videosCount"], " Videor - ", ["duration"]], "phasedProgram.phase.weekRange": ["Vecka ", ["weekRange"]], "phasedProgram.phase_progress.text": "Progressen visar antalet videor du har slutfört utav alla videor denna vecka.", "phasedProgram.postsurvey.requirement_notification": "Utvärderingen är nu tillgänglig, <0>klicka här</0> för att göra den.", "phasedProgram.presurvey.requirement_notification": "För att låsa upp videorna och för att kunna starta programmet behöver du slutföra enkäten i Fas 1. Eller <0>klicka här</0> för att öppna den.", "phasedProgram.survey.post.description": "Denna enkät kommer ta mellan 10-15 minuter att slutföra. Se gärna detta som en möjlighet att lära känna dig sjäv bättre. Försök att vara uppriktigt mot dig själv, det finns inga svar som är rätt eller fel. Dina svar kommer vara en mycket viktig del till denna forskningsstudie.", "phasedProgram.survey.post.start_button": "Gå vidare", "phasedProgram.survey.post.title": "Utvärdering", "phasedProgram.survey.pre.description": "Denna enkät kommer ta mellan 10-15 minuter att slutföra. Se gärna detta som en möjlighet att lära känna dig sjäv bättre. Försök att vara uppriktigt mot dig själv, det finns inga svar som är rätt eller fel. Dina svar kommer vara en mycket viktig del till denna forskningsstudie.  För att delta i studien behöver du uppfylla följande kriterier: (1) Du är över 18 år; (2) Du har inte någon klinisk diagnos av depression, ångest eller stress; (3) Du är för närvarande inte under psykologisk eller psykiatrisk behandling, eller tar medicin för diagnostiserad psykisk sjukdom; (4) Du har inte en omfattande tidigare erfarenhet eller nuvarande yoga/mindfulness/meditationspraktik; (5) Du har tid och engagemang för att genomföra programmets föreläsninga veckovis och dagliga meditationsövningar; (6) Du har daglig tillgång till internet och förmåga att använda en persondator.", "phasedProgram.survey.pre.start_button": "Fortsätt", "phasedProgram.survey.pre.title": "Uppstartsenkät", "phasedProgram.week.number": ["Vecka ", ["number"]], "playlist.created_by": "Created by", "playlist.empty_plalist": "Denna playlist är tom", "playlist.playlist_deleted": "Playlist borttagen", "playlist.playlist_title": "Playlist", "playlists.browse_by_categories": "Utforska våra playlist-kategorier ", "playlists.browse_category": "Kategorier", "playlists.empty_description": "Du har inte skapat någon playlist ännu", "playlists.get_started": "Rekommenderade playlists", "playlists.title": "playlists", "playlists.view_my_playlist": "Se mina playlists", "playlistscollectionsubheadersection.title": "Playlistsamlingar", "position.other_yoga_positions": "Andra yogapositioner", "position.other_yoga_styles": "Ytterligare yogaformer", "premium_banner_card.get_started": "Kom igång", "pricing.monthly": "Månadsprenumeration", "pricing.option1": "Videor, playlists, program och utmaningar", "pricing.option2": "Enkelt och tillgängligt", "pricing.option3": "Ingen bindningstid", "pricing.option4": "Använd ditt friskvårdsbidrag", "pricing.quarterly": "Kvartalsprenumeration", "pricing.yearly": "Årsprenumeration", "pricing_section.bullets.option1": "Videor, playlists, program och utmaningar", "pricing_section.bullets.option2": "Enkelt och tillgängligt", "pricing_section.bullets.option3": "Ingen bindningstid", "pricing_section.bullets.option4": "Använd ditt friskvårdsbidrag", "pricing_section.plan.annually.body": "Betala årsvis. Motsvarande 158 SEK/månad. Spara 369 SEK", "pricing_section.plan.annually.label": "12 månader", "pricing_section.plan.annually.title": "Årsprenumeration", "pricing_section.plan.best_value": "Mest prisvärt", "pricing_section.plan.button_text": "Aktivera", "pricing_section.plan.monthly.body": "189 SEK betalas månadsvis", "pricing_section.plan.monthly.label": "1 månad", "pricing_section.plan.monthly.title": "Månadsprenumeration", "pricing_section.plan.quarterly.body": "Betala kvartalsvis. Motsvarande 166 SEK/månad. Spara 68 SEK", "pricing_section.plan.quarterly.label": "3 månader", "pricing_section.plan.quarterly.title": "Kvartalsprenumeration", "pricing_section.plan.trial.body": "Obegränsad access utan att ange kortuppgifter.", "pricing_section.plan.trial.button_text": "Testa gratis 14 dagar", "pricing_section.plan.trial.price": "Gratis", "pricing_section.plan.trial.title": "Prova 14 dagar", "pricing_section.title": "Bli betalande medlem och få obegränad tillgång till videobiblioteket", "pricing_section.yearly_offers_description": "Välj ett av två tidsbegränsade erbjudanden <0>Läs mer</0>", "prisonyoga.insperational": "Extramaterial: Föreläsningar och klasser", "prisonyoga.moreabout": "Mer om denna satsning och initiativ", "prisonyoga.readmore": "Läs mer", "prisonyoga.relatedPrograms": "Specialframtagna videobaserade program", "prisonyoga.startPracticingEnglish": "Playlists anpassade för engelsktalande medlemmar", "prisonyoga.startPracticingSwedish": "Playlists anpassade för svensktalande medlemmar", "prisonyoga.teachersInvolved": "Involverade yogalärare och profiler", "prisonyoga.testimonials": "Åsikter från utövare", "prisonyoga.title": "Välkommen till Prison Yoga Project Skandinavien", "profileheader.privacy_settings": "Sekretessinställningar", "profileheader.view_public_profile": "Se publik profil", "program.backtoprogram": "Tack att du svarar. Klicka här för att gå tillbaka till programmet när du är klar.", "program.description": "Våra träningsprogram består av videor från biblioteket i ett format som är lätt att följa samtidigt som du får fördjupade kunskaper inom området.", "program.duration": [["value"], " ", ["unit"], " program"], "program.introduction_show_less": "Dölj text", "program.introduction_show_more": "Läs mer", "program.phaseCompletion": ["Genomfört: ", ["progress"], "%"], "program.quizAction": "Svara på 4 snabba", "program.quizCount": [["quizCount"], " quiz"], "program.title": "Välj ett träningsprogram", "program.video.repeat_explanation": "Detta är det rekommenderade antalet gånger du ska repetera denna session.", "program.videosCount": [["videoCount"], " Videor"], "program.videosTotal": [["videoCount"], " videor sammanlagt"], "program.weekCount": [["weekCount"], " veckors"], "program.weekCountShort": [["weekCount"], " vecka"], "program.whatToDoNextContinueProgress": "Fortsätt My Progress", "program.whatToDoNextNextVideo": "Ta del av nästa session", "programs.duration": "Program 30 dagar", "programs_2021.banner.already_verified": "Redan verifierad?", "programs_2021.banner.verify_account": "Bekräfta ditt konto genom att verifiera din mailadress. Då kan du direkt joina programmen.", "programs_2021.buy_gift.banner_text": "Du köper nu detta program som en gåva till någon annan. Om det är du själv som vill få access, <0>klicka här</0>", "programs_2021.buy_gift.buyer_name.input_label": "Från", "programs_2021.buy_gift.buyer_name.input_placeholder": "Förnamn", "programs_2021.buy_gift.code_label": "Rabattkod", "programs_2021.buy_gift.confirmation_modal_text": ["Din betalning om ", ["paymentAmount"], " har gått igenom. Du kommer nu att få ett email som innehåller vidare instruktioner!"], "programs_2021.buy_gift.custom_message.input_label": "Skriv en egen hälsning till mottagaren (valfri)", "programs_2021.buy_gift.description": "Vi är glada att du vill ge detta program som gåva till en vän!", "programs_2021.buy_gift.description_tooltip": "Efter genomförd betalning så får du ett email innehållande en unik köpkod och instruktioner hur programmet aktiveras", "programs_2021.buy_gift.direct_email.checkbox_label": "Skicka denna gåva direkt till mottagaren", "programs_2021.buy_gift.direct_email.tooltip_text": "Om detta alternativ är ikryssat så kommer mottagaren av denna gåva automatiskt få ett email som inkluderar gåvokortet/koden och instruktioner hur man aktiverar den. Kryssa ur rutan om du istället själv skulle vilja skicka/dela detta med mottagaren!", "programs_2021.buy_gift.go_courses_btn": "Utforska kurser", "programs_2021.buy_gift.go_dashboard_btn": "Gå till Översikt", "programs_2021.buy_gift.go_programs_btn": "Utforska program", "programs_2021.buy_gift.meta_title": ["Yogobe program - ", ["title"]], "programs_2021.buy_gift.recipient_email.input_label": "Mottagarens emailadress", "programs_2021.buy_gift.recipient_name.input_label": "Till (mottagarens namn)", "programs_2021.buy_gift.send_email_directly_label": "programs_2021.buy_gift.send_email_directly_label", "programs_2021.card.sale_tag": "Specialpris", "programs_2021.contact.contact_text": "Kontakt: <0>business@yogobe.com</0>", "programs_2021.contact.desc": "Vad roligt att du och din organisation är intresserade av att komma igång med Yogobe. Digitalt, demokratiskt, lättillgängligt och enkelt att komma igång. Tillsammans tar vi fram och skräddarsyr innehåll och stöd med syfte att främja såväl fysisk och mental hälsa inom företag och organisationer för individ och medarbetare. Ett programformat är perfekt för team som träffas remote och arbetsplatser där man önskar inspiration och vägledning för rörelse i vardagen där allas olika intressen och behov tas i beaktning - det finns alltså något för alla. För att komma igång, kontakta mig via email!", "programs_2021.contact.purchase_banner_back": "Tillbaka", "programs_2021.contact.title": "Hej, välkommen till Yogobe program! ", "programs_2021.expiration_banner.expire_soon.buy_program_text": ["Din access till detta program går ut om ", ["days"], " dagar. Förläng med ytterligare en period. Givetvis sparas din data. <0>Betalar du med friskvårdsbidrag?</0>"], "programs_2021.expiration_banner.expire_soon.renew_access_free_text": ["Din access till detta program går ut om ", ["days"], " dagar. Förläng för ytterligare en period, helt utan kostnad. Givetvis sparas din data. <0>Betalar du med friskvårdsbidrag?</0>"], "programs_2021.expiration_banner.expire_soon.renew_free_button": "Förläng åtkomst", "programs_2021.expiration_banner.expire_soon.upgrade_button": "Uppgradera nu", "programs_2021.expiration_banner.expire_soon.upgrade_to_renew_text": ["Din access till detta program går ut om ", ["days"], " dagar. Uppgradera till en betalande prenumeration så ingår obegränsad tillgång till detta program. Din tidigare data sparas."], "programs_2021.expiration_banner.expired.buy_program_text": ["Din access till detta program gick ut för ", ["days"], " dagar sedan. Du är välkommen att förnya och förlänga! Din tidigare data har sparats."], "programs_2021.expiration_banner.expired.renew_access_free_text": ["Din access till detta program gick ut för ", ["days"], " dagar sedan. Förnya nu helt utan kostnad. Din tidigare data har sparats."], "programs_2021.expiration_banner.expired.renew_free_button": "Återaktivera nu", "programs_2021.expiration_banner.expired.renew_with_discount_text": ["Din access till detta program gick ut för ", ["days"], " dagar sedan. Förnya din access och få ", ["discount"], " rabatt. Givetvis sparas din data. <0>Betalar du med friskvårdsbidrag?</0>"], "programs_2021.expiration_banner.expired.upgrade_to_renew_text": ["Din access till detta program gich ut för ", ["days"], " dagar sedan. Uppgradera till en betalande prenumeration så ingår obegränsad tillgång till detta program. Din tidigare data har sparats."], "programs_2021.expiration_banner.expires_soon.extend_with_discount_text": ["Din access till detta program går ut om ", ["days"], " dagar. Förläng redan idag för en ny period och få ", ["discount"], " rabatt. Givetvis sparas din data. <0>Betalar du med friskvårdsbidrag?</0>"], "programs_2021.expiration_banner.extend_button": ["Förläng för bara ", ["price"]], "programs_2021.get_started.access_code.icon_text": "Du behöver en accesskod för att komma åt programmet. En sådan kan du tex få från en arbetsgivare, vårdgivare, organisation eller partner till Yogobe. Det kan också vara ett presentkort från en vän.", "programs_2021.get_started.access_code.not_valid": "Acesskoden du angav är ogiltig! ", "programs_2021.get_started.access_code.tooltip_text": "Om du har blivit tilldelad en accesskod som ger dig tillgång till ett specifikt program så kan du använda koden här", "programs_2021.get_started.access_code.valid": "Koden har registrerats", "programs_2021.get_started.access_code_mismatch": "Denna kod är giltig men aktiverar ett annat program", "programs_2021.get_started.access_code_only_description": "Välkommen! <br/> Du kommer enbart åt detta program via en accesskod som du får antingen direkt från Yogobe eller via en partner till oss så som du arbetsgivare eller förening.", "programs_2021.get_started.activation_error": "Vi kunde inte aktivera detta program för dig, vänligen ta kontakt med oss på info@yogobe.com", "programs_2021.get_started.button.activate_for_free": "Starta programmet", "programs_2021.get_started.button.continue_trial": "Fortsätt med 14 dagar gratis", "programs_2021.get_started.button.login": "Logga in och gå vidare", "programs_2021.get_started.button.purchase": "Fortsätt till säker betalning", "programs_2021.get_started.button.start_suscription": "Inled en prenumeration", "programs_2021.get_started.buy_gift_btn": "Köp som gåva", "programs_2021.get_started.code_label": "Din unika kod", "programs_2021.get_started.description": "Vi är glada att du vill joina detta program. Logga in eller skapa ett konto för att fortsätta. Program och utmaningar är del i Yogobe's prenumerationserbjudande samt företagspaket.", "programs_2021.get_started.discount_amount": "Rabatt", "programs_2021.get_started.end_of_access": "Åtkomst till", "programs_2021.get_started.guest_title": ["Välkommen till ", ["program"]], "programs_2021.get_started.join_btn": "Starta program", "programs_2021.get_started.payment_amount": "Att betala", "programs_2021.get_started.purchase_banner_text": "Företräder du ett företag eller organisation som vill utforska digitala program för friskvård och hälsa? <0>Klicka här</0>", "programs_2021.get_started.show_code_input": "Har du en accesskod? <0>Klicka här</0>", "programs_2021.get_started.show_code_input_description": "Detta är en kod som man får genom sin arbetsplats eller organisation.", "programs_2021.get_started.user_title": ["Hej ", ["name"], ", välkommen till ", ["program"]], "programs_2021.get_started_loggedin.description": "Vi är glada att du vill delta i detta program. Program och utmaningar är del i Yogobe's prenumerationserbjudande samt företagspaket.", "programs_2021.header.access_until": ["Din access till detta program går ut den ", ["date"]], "programs_2021.header.buy_as_gift": "Köp som gåva", "programs_2021.header.extend_access": "Förläng access", "programs_2021.listing_page.hero.no_premium_disclaimer": "*Vi har tre olika prenumerationstyper du kan välja bland: månads-, kvartals-, eller årsprenumeration. Från 189 SEK.", "programs_2021.listing_page.hero.premium_disclaimer": "*Så länge du har en aktiv prenumeration eller accesstid så har du åtkomst till program och utmaningar.", "programs_2021.listing_page.legacy_programs_banner": "Välkommen till ny programstruktur! Saknar du ett program? <0>Gå tillbaka till gamla sidan</0>", "programs_2021.listing_page.meta.description": "Utforska Yogobe’s onlineprogram för yoga, mindfulness, nybörjarträning, stresshantering och mycket mer. Läs mer", "programs_2021.listing_page.meta.title": "Skräddarsydda videobaserade program online", "programs_2021.listings_page.clear_events_filters": "Återställ Filter & sök", "programs_2021.listings_page.explore_programs_btn": "Utforska program", "programs_2021.listings_page.faq_btn": "Vanliga frågor", "programs_2021.listings_page.filter_applied_toaster": "Filter sparade", "programs_2021.listings_page.filters.instructors": "Alla lärare", "programs_2021.listings_page.filters.kind_theme": "Alla teman", "programs_2021.listings_page.filters.languages": "Visa mig program på", "programs_2021.listings_page.filters.sort_alphabetically": "Sortera i alfabetisk ordning (A-Z)", "programs_2021.listings_page.filters.sort_by": "Sortera efter", "programs_2021.listings_page.filters.sort_duration": "Sortera på längd", "programs_2021.listings_page.filters.sort_new": "Sortera nyast först", "programs_2021.listings_page.hero_title": "Utforska program", "programs_2021.listings_page.load_more_btn": "Visa fler", "programs_2021.listings_page.no_programs_found": "Hoppla! Vi lyckas inte hitta ett program som är en perfekt match på ditt/dina sökord eller valda filter. Det som du letar efter kan fortfarande finnas hos oss. Snälla förnya din sökning eller ändra dina video- och filterninställningar!", "programs_2021.listings_page.option4": "User your fringe health benefits", "programs_2021.listings_page.pricing_section.title": "Uppgradera nu och få tillgång till samtliga program", "programs_2021.listings_page.search_input_placeholder": "Sök program...", "programs_2021.listings_page.subtitle": "Välkommen till Yogobe's program – specialframtagna för att möta flera olika behov och intressen. Utforska programmen idag och delta i ett eller flera.", "programs_2021.overview.text_card.locked_text": ["Gå med i ", ["programType"], " för att ta del av innehållet."], "programs_2021.pricing.free": "Gratis", "programs_2021.pricing.free_for_you": "Ingår i din prenumeration", "programs_2021.pricing.included_in_subscription": "Ingår i prenumeration", "programs_2021.program_card.program_access_label": "Du har access", "programs_2021.program_card.program_expire_soon": "Access upphör snart", "programs_2021.program_card.program_expired": "Access har upphört", "programs_2021.program_page.breadcrumb": "Yogobe programs", "programs_2021.program_purchase.confirmation_modal_text": ["Din betalning om ", ["paymentAmount"], " har gått igenom. Du kan sätta igång nu direkt eller när det passar dig!"], "programs_2021.program_purchase.get_started": "Kom igång", "programs_2021.program_purchase.go_dashboard_btn": "Gå till Översikt", "programs_2021.programs.instructors_modal_title": ["Lärare i ", ["program"]], "programs_2021.programs.other_instructors_count": [["number"], " fler"], "programs_2021.progress_page.video_lock.button_text": "Delta i programmet", "programs_2021.progress_page.video_lock.text": "Du har precis sett en förhandsvisning på 60 sekunder. Vill du logga in eller starta detta program nu?", "programs_2021.snackbars.access_granted": "Du deltar nu i detta program", "programs_2021.themes.athletes": "Idrottare ", "programs_2021.themes.beginner": "Nybörjare", "programs_2021.themes.breathing": "Andning", "programs_2021.themes.diet_and_nutrition": "Kost & nutrition", "programs_2021.themes.meditation": "Meditation", "programs_2021.themes.mobility_and_prehab": "Mobilitet & prehab", "programs_2021.themes.personal_growth": "Personlig utveckling", "programs_2021.themes.philosophy": "Filosofi & spiritualism", "programs_2021.themes.postnatal": "Nybliven mamma", "programs_2021.themes.prenatal": "Gravid", "programs_2021.themes.restoration": "Återhämtning", "programs_2021.themes.skills": "Kunskap & teknik", "programs_2021.themes.smart_breaks": "Pausa Smart", "programs_2021.themes.stress_and_anxiety": "Stress & oro", "programs_2021.themes.womens_health": "Kvinnohälsa", "programs_2021.themes.workout": "Träning", "programs_2021.themes.yoga": "Yoga", "programs_2021.themes.yoga_teachers": "Yogalärare", "programs_2022.progress.program_recomendation_hide": "Dölj", "programs_2022.progress.program_recomendation_show": "Visa", "programs_2022.progress.program_tip": "Tips till dig", "programs_2022.survey.close_modal_button": "Stäng", "programs_2022.survey.draft_saved": "Dina svar har sparats som utkast", "programs_2022.survey.edit_survey_btn": "Se eller ändra dina svar", "programs_2022.survey.exit_alert": "Du har gjort ändringar utan att spara och skicka in. Är du verkligen säker på att du vill lämna sidan?", "programs_2022.survey.last_submit": ["Du har skickat in dina senaste svar den ", ["date"]], "programs_2022.survey.start_survey_btn": "Fortsätt", "programs_2022.survey.submit_answers_btn": "Skicka svar", "programs_2022.survey.thank_you_desc": "Tack för dina svar! Din input är oerhörd värdefull för oss.", "programs_2022.survey.thank_you_title": "Tack!", "programs_body.read_more": "Läs mer", "programs_legacy_listing.banner_message": "Vi har flyttat ett antal program till vår nya programstruktur. <0>Spana in dem</0>", "programs_listing.faq.item1.body": "Samtliga program ingår för dig som är aktiv medlem på Yogobe. Du kan också gå med i ett program om du har en prova-på-period, men du har då endast tillgång till programmet så länge du har aktiv access.", "programs_listing.faq.item1.title": "Vem kan delta i ett program?", "programs_listing.faq.item2.body": "När du har gått med i ett program (vilket du gör genom att klicka på knappen “Kom igång” på det programmet du är intresserad av) så kommer du därefter alltid, när du är inloggad på ditt Yogobe-konto, att komma åt det på din <0>Översikt</0> för enkel åtkomst.", "programs_listing.faq.item2.title": "Hur kommer jag åt mitt program?", "programs_listing.faq.item3.body": "Självklart kan du det! Du kan delta i precis så många program som du vill. Om du går med i flera program under samma dag kommer du däremot endast att få mail kopplat till det första programmet du gick med i. Detta för att du inte ska få alltför många mail.", "programs_listing.faq.item3.title": "Kan jag delta i flera program samtidigt?", "programs_listing.faq.item4.body": "Nu får våra program en liknande design och struktur som våra befintliga program inom Yogobe Challenge. Genom detta upplägg blir det lättare för dig som användare att faktiskt delta i ett program och kan följa din utveckling på ett annat sätt. Det är också enklare för dig att följa ett program och på så vis få den guidning som programmen är ämnade till att ge dig.", "programs_listing.faq.item4.body2": "Det finns två flikar för varje program – “Översikt” och “Min utveckling”. Under “Översikt” hittar du all information om programmet och får en översikt över varje vecka/del som ingår i programmet. Under “Min utveckling” kommer du till en vy där du enkelt ser vilka videor som hör till vilken vecka/del och vad du redan har genomfört.", "programs_listing.faq.item4.title": "Vad innebär den nya programdesignen och upplägget?", "programs_listing.faq.item5.body": "Självklart! Vi har många olika företagslösningar och skräddarsyr gärna för att hitta något som passar just era önskemål och behov. Maila oss på <0>business@yogobe.com</0> så berättar vi mer.", "programs_listing.faq.item5.title": "Kan företag köpa enskilda program?", "programs_listing.faq.item6.body": "I dagsläget är programmen, likt Yogobe Challenge, endast tillgängliga via hemsidan Yogobe.com. Självklart kan du gå in i en webbläsare i din smartphone och komma åt programmet i mobilen på det sättet.", "programs_listing.faq.item6.title": "Kan jag ta del av programmen i appen?", "programs_listing.faq.item7.body": "Att <0>prova-på Yogobe</0> är helt gratis, kräver inga betaluppgifter och det är aldrig någon bindningstid. En prova-på-period på Yogobe övergår aldrig automatiskt till en betalande prenumeration. Efter din prövotid får du välja om du vill uppgradera ditt medlemskap till en löpande prenumeration och betala via bankbetalning, kort eller via en av de  <0>friskvårdsleverantörer som vi</0> arbetar med. Enkelt och lätt. Som inloggad hittar du <0>prenumerationssidan</0> via användarmenyn och du kan där ta del av våra olika erbjudanden om månads-, kvartals- eller årsprenumeration.", "programs_listing.faq.item7.title": "Hur blir jag betalande medlem på Yogobe?", "programs_listing.walkthrough_section.subtitle": "I denna video visar vi hur enkelt du kommer igång med ditt valda program, samt visar dig hur du navigerar mellan de olika vyerna i programmet. Gå med i ett program redan idag!", "programs_listing.walkthrough_section.title": "Så här kommer du igång", "promotions.code_apply.fallback_failure_message": "Denna kod existerar tyvärr inte eller så är erbjudandet inte längre giltigt", "public_profile.error_msg": "Vi verkar inte kunna ladda denna profilen. Snälla ladda om sidan eller försök igen om en liten stund.", "quickstart.awesome_message": ["Super! Här har du några ", ["yogaDuration"], " videor som är ", ["yogaType"]], "quickstart.awesome_message_yogaTypeCalm": "lugna", "quickstart.awesome_message_yogaTypeIntensive": "fysiska", "quickstart.cancel": "Avbryt", "quickstart.go_back": "Gå tillbaka", "quickstart.hide_this": "Dölj", "quickstart.something_physical": "Något fysiskt och pulshöjande", "quickstart.something_relaxing": "Något lugnt och återhämtande", "quickstart.start_message": [["name"], ", vill du få hjälp att snabbt och enkelt välja en video?"], "quickstart.time_you_have": "Toppen! och hur mycket tid har du just idag?", "quickstart.todo_today": "Kul, börja med att berätta vad du är ute efter!", "quickstart.try_quickstart": "Testa Quickstart", "receipts.check_premium": "Utforska medlemsalternativ", "receipts.empty_description": "Du är en icke-betalande medlem hos oss på Yogobe. Kanske vill du uppgradera ditt medlemskap?", "receipts.empty_title": "Du har inga kvitton ännu", "receipts.payment_made": "Vi har tagit emot din betalning och du kan hitta ditt kvitto på denna sida", "receipts.title": "Kvitton", "reclaim_trial.body": "reclaim_trial.body", "reclaim_trial.confirmation.generic_error": "reclaim_trial.confirmation.generic_error", "reclaim_trial.confirmation.progress_text": "reclaim_trial.confirmation.progress_text", "reclaim_trial.confirmation.success": "reclaim_trial.confirmation.success", "reclaim_trial.dashboard_btn": "reclaim_trial.dashboard_btn", "reclaim_trial.intro": "reclaim_trial.intro", "reclaim_trial.title": "=======", "reclaim_trial_modal.claim_btn": "Ja tack!", "reclaim_trial_modal.desc": "Vi är glada att ha dig tillbaka hos oss och vill gärna ge dig möjligheten att utforska Yogobe Play <b>kostnadsfritt<b> i 14 dagar. Vill du komma igång? ", "reclaim_trial_modal.not_intrested_btn": "Nej tack, inte intresserad", "reclaim_trial_modal.title": "Testa Yogobe Play i 14 dagar?", "reclaim_trial_page.body": "Du skickas automatiskt till din översiktssida om", "reclaim_trial_page.confirmation.generic_error": "Det går inte att aktivera en förnyad provperiod för dig. Kontakta oss gärna på <0>info@yogobe.com</0> så hjälper vi dig.", "reclaim_trial_page.confirmation.progress_text": "Din nya provperiod aktiveras...", "reclaim_trial_page.confirmation.toaster_message": "Ditt konto har uppgraderats med 14 dagar access till on-demand innehållet av Yogobe Play, vår prenumerationstjänst. ", "reclaim_trial_page.dashboard_btn": "Eller klicka på fortsätt", "reclaim_trial_page.desc": "Din nya provperiod har aktiverats! Du kan redan nu börja utforska allt on-demand innehåll i Yogobe Play, vår prenumerationstjänst.", "reclaim_trial_page.title": "14 dagar prova-på", "register.tooltip.message": "När du blir medlem på Yogobe så får du automatiskt en gratis prova-på period. Uppgradera när du vill till månads-, kvartals-, eller årsprenumeration. Priser från (99 SEK). <br /> <br /> Om du har köpt en onlinekurs alternativt har fått en accesskod via din arbetsgivare eller en av våra partners så är det här du registrerar dig och skapar ditt egna personliga konto.<br /> <br /> <br /> Vi ses på insidan. Varmt välkommen! <br /> Peter Munteanu, VD och Grundare", "registration.access_code.valid": ["Din kod har bekräftats. Slutför din registration och få åtkomst till ", ["date"]], "registration.campaign_code.valid": ["Kampanjkoden är gitig. Du kommer få ", ["days"], " dagar gratis prova-på när du slutfört din kontoregistrering"], "registration.campaign_code_applied": ["<0>", ["code"], "</0> koden har verifierats. Fullfölj registreringen för åtkomst."], "registration.complete_profile.address": "Fyll i din adress", "registration.complete_profile.title2": [["name"], ", har du en kampanjkod?"], "registration.confirmation.generic_error": "<p>Fina medlem,</p> <p> Länken som du har tryckt på är inte längre giltig. Kanske har du råkat trycka på den tidigare eller dubbelt? Snälla försök ladda om sidan eller logga ut/in igen med dina inloggningsuppgifter. Om du fortfarande har utmaningar eller frågar, snälla tveka inte att höra av dig till oss på <a href=\"mailto:data@yogobe.com\">data@yogobe.com</a> </p> <p>Varma hälsningar,<br/> Peter</p>", "registration.confirmation.progress_text": "Bekräftar din mailadress...", "registration.confirmation.success": "Din mailadress har nu blivit verifierad! Snyggt.", "registration.continue_to_dashboard.btn": "Gå till Översikt", "registration.course.access_code_banner": ["<0>", ["code"], "</0> koden har applicerats. Fortsätt din registrering för att få tillgång till <0>", ["courseName"], "</0>."], "registration.course.banner": "Vi ser fram emot att dela denna kurs med dig. Skapa ett konto och slutför din betalning!", "registration.course_card.desc": "Du får ett års access till kursen och eventuellt tillhörande material.", "registration.course_card.title": "Utöver kursen så bjuder vi dig också på 14 dagar gratis testperiod av Yogobes omfattande videobibliotek.", "registration.cycle.12months.label": "12 månader", "registration.cycle.1month.label": "1 månad", "registration.cycle.3months.label": "3 månader", "registration.landing.alreadymember": "Har du redan ett Yogobe-konto? <0>Logga in</0>", "registration.landing.btn": "Fortsätt", "registration.landing.country": "Land", "registration.landing.email": "Mailadress", "registration.landing.firstname": "Förnamn", "registration.landing.headline": "Utforska yoga, meditation, träning och andning", "registration.landing.lastname": "Efternamn", "registration.landing.password": "Lösenord", "registration.landing.pricing.info": "Testa gratis, ingen bindningstid, inga bankuppgifter behövs", "registration.landing.pricing.text": "Mer information om ditt medlemskap och möjligheter", "registration.landing.socials_label": "Eller skapa ditt konto via", "registration.landing.subtitle": "Skapa ett konto för att se, spara och favoritmarkera tusentals videor", "registration.landing.tc": "Genom att fortsätta godkänner du våra <0>Villkor</0> och <1>Integritetspolicy</1>", "registration.landing.title": "Bli medlem på Yogobe", "registration.landing.usp1": "Förinspelade audio- & videoklasser online", "registration.landing.usp2": "LIVE-streamade klasser & event", "registration.landing.usp4": "Skapa & dela playlists", "registration.onboarding.max_selected": "Avmarkera ett eller flera val för att välja nya!", "registration.payment.btn1": "Fortsätt till säker betalning", "registration.payment.btn2": "Tillbaka", "registration.payment.code_applied": "Din kod har godtagits", "registration.payment.discount.label": "Bonus rabatt", "registration.payment.nextpayment.body": ["Du kommer betala ", ["amount"], " nu.  <br/> Din prenumeration fortsätter sedan löpande ", ["cycle"], " med ", ["recurringAmount"], " - Avbryt när du vill"], "registration.payment.now.label": "Totalt:", "registration.payment.ordersummary.label": "Ordersammanfattning", "registration.payment.title": "Betalning", "registration.paymentfail.body": ["Något gick fel.. din betalning på ", ["amount"], " SEK gick inte igenom. Vänligen försök igen. Om problemen kvarstår, vänligen kontakta vår tekniska support: data@yogobe.com"], "registration.paymentfail.btn": "Gå tillbaka & försök igen", "registration.paymentfail.orderdetails.body": ["Transaktions-ID: ", ["transaction"]], "registration.paymentfail.title": "Betalningen misslyckades", "registration.paymentsuccess.body": ["Tack, din betalning på ", ["amount"], " ", ["currency"], " har mottagits. Ett kvitto kommer att skickas till ", ["email"]], "registration.paymentsuccess.btn": "Fortsätt", "registration.paymentsuccess.orderdetails.body": ["Order-ID: ", ["order"], "   |   Transaktions-ID: ", ["transaction"]], "registration.paymentsuccess.title": "Betalning lyckades!", "registration.plan.annually.body": "Betala årsvis. Motsvarande 158 SEK/månad. Spara 369 SEK", "registration.plan.annually.title": ["Årsprenumeration - ", ["amount"]], "registration.plan.btn": "Fortsätt till betalning", "registration.plan.code.info.tooltip": "En rabattkod ger dig en procentuell rabatt på en eller flera prenumerationsperioder. Vid frågor kring din rabattkod, kontakta info@yogobe.com", "registration.plan.code.info_text": "Har du en rabattkod?", "registration.plan.code.label": "Har du fått en rabattkod?", "registration.plan.code.success": "Din kod har godtagits", "registration.plan.codecamp.info.tooltip": "Om du har fått en kampanjkod från din yogalärare, instruktör eller en partner till Yogobe, så skriver du in den här och får en utökad gratis provperiod av vår prenumerationstjänst. Det är också här som du skriver in en kompiskod, ifall du har fått en sådan av en vän. GÄLLER EJ ACCESSKOD: Om du har en accesskod för temasidor, program etc – klicka dig vidare utan att fylla i något! ", "registration.plan.codecamp.info_text": "Skriv in eventuell kampanj- eller kompiskod.", "registration.plan.continue_btn": "Fortsätt", "registration.plan.monthly.body": "189 SEK betalas månadsvis", "registration.plan.monthly.title": ["Månadsprenumeration - ", ["amount"]], "registration.plan.or_subscription.desc": ["Du kan enkelt välja att inleda en prenumeration direkt. Dina ", ["days"], " gratisdagar adderas automatiskt till din första betalperiod."], "registration.plan.or_subscription.title": "Eller välj den prenumerationtyp som passar dig", "registration.plan.quarterly.body": "Betala kvartalsvis. Motsvarande 166 SEK/månad. Spara 68 SEK", "registration.plan.quarterly.title": ["Kvartalsprenumeration - ", ["amount"]], "registration.plan.title": "Välj gärna en prenumerationform som passar dig", "registration.plan.trial.body": "Testa gratis, inga betaluppgifter krävs", "registration.plan.trial.btn_text": "Gå vidare", "registration.plan.trial.title": ["Hej ", ["name"], ", fortsätt med din ", ["days"], "-dagars prova-på-period"], "registration.plan.usp.title": "Detta ingår för aktiva prenumerationsmedlemmar:", "registration.plan.usp1": "Spara, dela och lägg till videor i egna playlists.", "registration.plan.usp2": "Obegränsad tillgång till 2100+ videor och 45+ program.", "registration.plan.usp3": "Enkelt att avbryta eller uppgradera", "registration.referral_code.valid": ["Din kod har aktiverats. Slutför din registrering och du kommer få ", ["days"], " dagar gratis prova-på tack vare din kompis"], "registration.trial_code_input.label": "Om du har fått en kampanjkodl, fyll i den här. Accesskod (för ex. en temasida, ett program eller en kurs) fylls ej i här – klicka dig vidare.  ", "registration.verification1.intro": ["För att gå vidare, vänligen verifiera ditt konto genom att klicka på länken som vi har skickat till: <0>", ["email"], "</0>"], "registration.verification1.resend": "Har du inte fått verifieringsmailet? <0>Klicka här</0>", "registration.verification1.resend_failed": "Det gick inte att skicka mailet på nytt, vänligen försök igen eller kontakta vår support på info@yogobe.com", "registration.verification1.resend_success": "Mailet har skickats igen, vänligen kolla din inkorg!", "registration.verification1.title": "Verifiera ditt konto", "registration.verification2.body": "Du skickas snart vidare automatiskt...", "registration.verification2.btn": "Eller klicka och fortsätt", "registration.verification2.intro": "Ditt konto har nu verifierats! Allt är nu redo för dig att börja utforska Yogobe.", "registration.verification2.title": "Klart!", "registration.verify_email_toaster": ["Ett aktiveringsmail har skickats till ", ["email"], ". Aktivera och verifiera ditt konto och få din provperiod. Stämmer inte adressen? Kontakta info@yogobe.com"], "registration.wellness.learn_more": "Du vet väl att du kan använda ditt friskvårdsbidrag på Yogobe? <0>Läs mer</0>", "regsocial.best_value": "Mest prisvärt", "regsocial.feature1_desc": ["Obegränsad åtkomst till fler än ", ["videos_count"], " videor. Klasser, föreläsningar, workshops och mer, inom yoga, meditation, pilates, rörlighet, gravid- & mammaträning, kondition, core, stretch, löpcoachning etc. Var du vill, när du vill!"], "regsocial.feature1_title": [["videos_count"], "+ videor"], "regsocial.feature2_desc": "I samråd med Team Yogobe har vi satt samman korta och längre videobaserade program som består av innehåll från videobiblioteket och mer. Allt vi producerar och publicerar har sitt ursprung i ett uttryckt behov bland våra medlemmar.", "regsocial.feature2_title": "Hälsa och träningsprogram", "regsocial.feature3_desc": "Skapa, följ och dela playlists. Såväl dina egna som andras. Playlists är samlingar med audio- och videofiler som bl.a. erbjuder funktionen autoplay.", "regsocial.feature3_title": "Skapa Playlists", "regsocial.feature5_desc": "Som medlem på Yogobe är du del i en växande och autentisk gemenskap som genom åren vuxit sig stark och är en trygg plats där alla är välkomna för att möta och samtala med andra medlemmar. Just nu finner man lättast andra medlemmar via BEYOGA365, ett forum på Facebook. Alla förtjänar att ha verktyg och förutsättningar för att må bra. Fysiskt, mentalt och själsligt. Med bakgrund i detta strävar vi mot att guida, inspirera och ge stöd till individer, företag och organisationer inom hållbarhet genom att erbjuda kvalitativa tjänster, produkter, forum och sammanhang. ", "regsocial.feature5_title": "Community", "regsocial.getstarted": "Aktivera", "regsocial.hero_btn1": "Utforska medlemsalternativ", "regsocial.hero_btn2": "Testa gratis 14 dagar", "regsocial.hero_title": "Få obegränsad tillgång till vårt videobibliotek", "regsocial.hero_usp": "Enkelt - ingen bindningstid - ingen betalinformation behövs", "regsocial.live_desc": "Yoga, träna och meditera i realtid - med Yogobe LIVE. Praktisera tillsammans som ett Community under vägledning av Team Yogobe.", "regsocial.live_title": "LIVE – guidas i realtid", "regsocial.mobile_section.desc": "I vår iOS och Android app får du tillgång till hela biblioteket, playlists, offline-mode samt möjlighet att casta till TV.", "regsocial.mobile_section.title": "Utforska vår nya app", "regsocial.most_affordable": "Most Affordable", "regsocial.offer_description": "TA DEL AV ÅRSERBJUDANDE <0/> Inled en årsprenumeration hos YOGOBE och låt många av Nordens främsta yogalärare och träningsinstruktörer guida dig i videor online och offline inom yoga, meditation, pilates, rörelseträning, gravid- och mammaträning och mycket mer - ett bra sätt att hålla sig glad, stark och välmående. <0/> Vem kan ta del av prenumerationserbjudandet? <0/> <0/> Alla som inleder, uppgraderar eller aktivt förnyar* sin prenumeration hos Yogobe (till ordinarie pris, 1899 SEK, med VISA/Mastercard kortbetalning via våra betalsystem DIBS eller Trustly) får ett 500 SEK presentkort från Yogiraj att använda i Yogobe Store. <0/> <0/> Erbjudandet gäller till och med midnatt den 8 maj. I samband med att du tar del av detta erbjudande så får du automatiskt ett mail från oss med din unika presentkortskod. Presentkortet berättigar till köp av produkter till det angivna beloppet. Fraktkostnad täcks inte av presentkortet utan bekostas av köparen. Vi erbjuder förmånliga fraktkostnader och leverans sker inom 3 vardagar av din beställning. Presentkortet är giltigt fram till och med 31 december 2019 och kan inte bytas mot kontanter. Klicka på knappen och läs mer om detta erbjudande! <0/> <0/> Om Yogiraj (yogamattor och utrustning) <0/> Med inspiration från skogen, bergen, vidderna och havet har Yogiraj sitt ursprung i den nordiska naturen. Yogirajs mattor och utrustning är alltid giftfria och ofta ekologiska. Ge dig själv yoga med Yogiraj och lämna ett mindre ekologiskt fotavtryck samtidigt som du bryr dig om din kropp och planeten. <0/> <0/> Yogiraj har mängder av yogaprops - allt från bolster och meditationskuddar som innehåller ekologiskt bovete, till ögonkuddar, tunga bomullsfiltar och block i olika storlekar. Vi tycker också att Yogiraj erbjuder några av de allra bästa yogamattorna - allt från enklare all-round till den nya grip mattan för bikram och andra intensivare yogaformer. <0/> <0/> Bra att veta vid uppgradering av prenumeration <0/> Har du just nu en gratis `prova-på-period` så förlängs givetvis ditt år automatiskt med dina innestående dagar. <0/> Har du en aktiv prenumeration så ändras medlemsformen till ÅR och dragning sker idag. Kvarvarande accessdagar adderas självklart automatiskt. <0/> Vid ytterligare frågor, funderingar eller tankar tveka inte att skriva till oss: info@yogobe.com. <0/> <0/> Använd ditt friskvårdsbidrag <0/> Som betalande medlem på Yogobe kan du enkelt skriva ut dina kvitton via dina inställningar. Dessa kan du lämna in till din arbetsgivare som avgör ifall ditt medlemskap hos oss täcks av ditt friskvårdsbidrag. Om du är osäker på vad din arbetsgivare godkänner så ber vi först fråga dem om de godkänner användande av friskvårdsbidrag för onlinetjänster. <0/> Detta erbjudande om att få ett presentkort på Yogobe Store (värde 500 SEK) gäller inte dig som betalar för Yogobe via en friskvårdsleverantör så som Benify eller Actiway, då dessa inte är löpande prenumerationer utan engångsbetalningar till Yogobe. <0/> ", "regsocial.offer_title": "Ta del av vårt exklusiva årserbjudande", "regsocial.page_title": "Bli medlem", "regsocial.special_page_title": "Bli årmedlem", "regsocial.subscription_annually_billed": "Din prenumeration förnyas årligen.", "regsocial.subscription_annually_save": "Spara 369 SEK per år", "regsocial.subscription_free_plan_label": "Obegränsad access utan att ange kortuppgifter.", "regsocial.subscription_free_price_label": "Gratis", "regsocial.subscription_free_title": "Gratis prova-på", "regsocial.subscription_monthly_billed": "Din prenumeration förnyas varje månad.", "regsocial.subscription_monthly_per": "/ månad", "regsocial.subscription_quarterly_billed": "Förnyas varje kvartal och övergår automatiskt till ordinarie pris i kvartal två. ", "regsocial.subscription_quarterly_per": "/ kvartal", "regsocial.subscription_quarterly_save": "Spara 272 SEK per år", "regsocial.subscription_sub_title": "Starta en årprenumeration och få 500 SEK att handla Yogiraj för.", "regsocial.subscription_title": "Bli betalande medlem och få obegränsad tillgång till biblioteket", "regsocial.subscription_year_per": "/ år", "regsocial.testimonial_title": "Några rader från medlemmar", "reset_program.body": "Vil du byta från det program du påbörjat under Yogobe Spring Challenge? Under de kommande stegen kommer du få välja det program du önskar, men då också fylla i formuläret på nytt.", "reset_program.info": ["Din statistik för ditt befintliga program (", ["programName"], ") kommer att förloras. Är du säker på att du vill fortsätta?"], "reset_program.no": "Nej, låt mig behålla befintligt program", "reset_program.title": "Byta program", "reset_program.yes": "Ja, välj ett annat program", "schedule_modal.googlecalendar": "Exportera till Google Kalender", "schedule_modal.icp": "Spara i min kalender", "schedule_modal.time": "Tid", "schedule_modal.title": "Schemalägg", "search.category.blog.title": "Blogg", "search.category.challenges.title": "Utmaningar", "search.category.courses.title": "Kurser & utbildningar", "search.category.events.title": "Event", "search.category.instructors.title": "Lärare & experter", "search.category.live_events.title": "LIVE-online", "search.category.pages.title": "Kunskap", "search.category.playlists.title": "Playlists", "search.category.programs.title": "Program", "search.category.video_audio.title": "Video & audio", "search.filters.languages": "Språk", "search.go_back": "Tillbaka", "search.input_placeholder": "Sök på Yogobe...", "search.program_card.view_blog": "Läs artikeln", "search.program_card.view_challenge": "Visa utmaningen", "search.program_card.view_course": "Visa kurs", "search.program_card.view_live": "Visa LIVE-klass", "search.program_card.view_program": "Visa programmet", "search.result_found": "1 resultat hittat", "search.results.many": [["count"], " resultat"], "search.results.one": [["count"], " resultat"], "search.results_found": [["totalCount"], " resultat <0>hittade för ", ["query"], "</0>"], "search.results_not_found": "Vi hittar inga resultatet med denna exakta sökning. Prova att omformulera dig!", "search.search_correction": "Testa något av följande istället: ", "search.search_input_button": "Sök", "search.search_not_started": "Påbörja din sökning och utforska allt vi har att erbjuda inom det du är intresserad av – klasser såväl som inspirerande läsning, träninsgprogram och mycket mer!", "search.section.blog.explore": "=======>>>>>>> master", "search.section.blog.title": "Blogg", "search.section.challenges.title": "Utmaningar", "search.section.courses.title": "Onlinekurser", "search.section.events.title": "Event", "search.section.instructors.title": "Lärare & experter", "search.section.live.title": "LIVE-online", "search.section.playlists.title": "Playlists", "search.section.programs.title": "Program", "search.section.resources.title": "Kunskap", "search.section.slide.more": ["Se alla ", ["totalCount"], " resultat för ", ["searchQuery"], " i ", ["title"]], "search.section.video_audio.title": "Video & audio", "search.tabs.all": "Allt", "search.tabs.blog": "Blogg", "search.tabs.coursetravel": "Kurser & resor", "search.tabs.live": "LIVE", "search.tabs.mobile_play": "Play (Videor, Playlists, Program)", "search.tabs.play": "Play", "search.tabs.play_tooltip": "Yogobe Play är allt det innehåll som en betalande medlem har tillgång till som del i en aktiv prenumeration. Det inkluderar hela vårt bibliotek med audio- och videosessioner, playlists, program, utmaningar samt veckoklasser LIVE-online.", "search.tabs.resources": "Kunskap", "search.temporary_banner": "Detta är en ny funktion. Yogobe Sök hjälper dig att hitta innehåll i hela vår tjänst. Sammanskrivna ord är något som systemet fortfarande håller på att lära sig. Tack att du använder, hittar och hjälper oss förbättra! <0>Ge feedback</0>", "search.title": "Vad letar du efter?", "search_details.blogPosts.explore": "search_details.blogPosts.explore", "search_details.challenges.explore": "Utforska utmaningar", "search_details.courses.explore": "Utforska onlinekurser", "search_details.events.explore": "Utforska event", "search_details.genericPrograms.explore": "Utforska program", "search_details.instructors.explore": "Utforska Team Yogobe", "search_details.live.explore": "Utforska LIVE", "search_details.playlists.explore": "Utforska playlists", "search_details.results.load_more": "Visa fler", "search_details.results_found.mutiple_results": [["totalCount"], " resultat för <0>", ["query"], "</0> i ", ["category"]], "search_details.results_found.single_results": [["totalCount"], " resultat för <0>", ["query"], "</0> i ", ["category"]], "search_details.title": ["Söker inom ", ["category"]], "search_details.videos.explore": "Utforska biblioteket", "settings.go_back": "Tillbaka till översikt", "settings.subsriptions.failed_renew": ["Vårt senaste försök att belasta ditt betalkort eller konto har misslyckats. Om du har fått ett nytt kort sedan sist vill vi tipsa dig om att på nytt välja medlemsform och förse oss med din uppdaterade information. Kontakta oss <0>", ["email"], "</0> om du önskar att vi försöker göra en ny dragning från ditt befintliga kort eller konto innan vårt nästa automatiska försök."], "settings_account.change_password.logout_notice": "När du ändrat ditt lösenord kommer du att bli ombedd att logga in på nytt", "settings_account.confirm_new_password": "Bekräfta nytt lösenord", "settings_account.mailaddress": "Mailadress", "settings_account.new_password": "Nytt lösenord", "settings_account.password_updated_successfully": "Ditt lösenord har uppdaterats", "settings_account.recover_your_password": "Återställ ditt lösenord", "settings_account.token_wrong": "Koden som du skrivit in verkar vara ogiltig. Försök gärna igen!", "settings_fringe_health.descriPSettingsFringeHealthBenefitstion": "Ger din arbetsgivare dig friskvårdsbidrag? Det är upp till varje arbetsgivare att avgöra vilka leverantörer de godtar. För att vara på den säkra sidan rekommenderar vi därför att du dubbelkollar att de godtar kvitton från Yogobe. Ifall din arbetsgivare är ansluten till friskvårdsportalerna Benify, Wellnet, Actiway, Wellnet eller Min Friskvård så kan du enkelt uppgradera ditt Yogobe-medlemskap via dem.", "settings_fringe_health.read_more": "Läs mer om friskvårdsbidrag", "settings_fringe_health.title": "Använd hela eller delar av ditt friskvårdsbidrag", "settings_history.action": "Rensa all historik", "settings_history.title": "Historik", "settings_modal.accessible-yoga": "Yoga vid rörelsehinder", "settings_modal.barn-ungdom": "Barn och ungdom", "settings_modal.beginner": "Endast nybörjarvänliga videor", "settings_modal.english": "Engelska", "settings_modal.finnish": "Finska", "settings_modal.helper": "Vi vill hjälpa dig få relevanta & för dig intressanta träffar i vårt bibliotek. Med denna funktion bestämmer du vad du vill få för sökresultat.", "settings_modal.helper_label": "Skräddarsy din Yogobe-upplevelse", "settings_modal.left_section_title": "Språk", "settings_modal.norwegian": "Norska", "settings_modal.office-yoga": "Kontorsträning", "settings_modal.postnatal": "Postnatal yoga & träning", "settings_modal.prenatal": "Gravidyoga & gravidträning", "settings_modal.primary_button": "Spara", "settings_modal.right_section_title": "Sökfilter", "settings_modal.secondary_button": "Avbryt", "settings_modal.senior-yoga": "Senioryoga", "settings_modal.swedish": "Svenska", "settings_modal.title": "Inställningar", "settings_privacy.description": "Här bestämmer du vilket innehåll som din publika profilsida skall visa", "settings_privacy.favorites": "Favoriter", "settings_privacy.private_profile_notice": "Du vill göra din profil privat. Andra medlemmar kommer inte kunna se de favoriter och playlists som du har skapat.", "settings_privacy.statistics": "Statistik", "settings_private_informations.city": "Stad", "settings_private_informations.dateOfBirth": "Födelsedag", "settings_private_informations.first_name": "Förnamn", "settings_private_informations.lastName": "Efternamn", "settings_private_informations.phone": "Telefon", "settings_private_informations.profession": "Yrke", "settings_private_informations.street_address": "Gatuadress", "settings_private_informations.timezone": "Tidzon", "settings_private_informations.zip_code": "Postnummer", "settings_profile.cancel_url_not_available": "Du har just nu ingen aktiv eller betalande prenumeration. Det betyder att det inte finns något för dig att avbryta. Kontakta oss på info@yogobe.com om du har några frågor!", "settings_profile.display_name": "Visa namn", "settings_profile.facebook": "Facebook", "settings_profile.instagram": "Instagram", "settings_profile.linkedin": "LinkedIn", "settings_profile.remove_photo": "Ta bort foto", "settings_profile.short_bio": "Kort beskrivning", "settings_profile.short_bio_placeholder": "Här kan du skriva några rader om dig själv", "settings_receipts.date": "Datum", "settings_receipts.payment_type": "Betaltyp", "settings_receipts.receipt": "Kvitto", "settings_receipts.receipt_number": "Kvittonummer", "settings_receipts.total_including_vat": "Totalt inklusive moms", "settings_referall.description": "och när de blir betalande prenumeranter så uppgraderas ditt konto automatiskt med 30 bonusdagar för varje kompis.", "settings_referall.paragraph_one": "Ge dina vänner sina 21 första dagar med Yogobe helt gratis. Enkelt, utan bindningstid, inga kortuppgifter och bonuser till dig!", "settings_referall.paragraph_two": "För varje kompis du har som inleder en betalande prenumeration på Yogobe med din kompiskod till ett värde av minst 189 SEK så uppgraderas ditt konto helt automatiskt med 30 bonusdagar. Enkelt, bra för dina kompisar och såväl kul som smart för dig!", "settings_referall.personal_code_action": "Kopiera", "settings_referall.personal_code_label": "Din personliga kompiskod", "settings_referall.refer": "Bjud in en kompis med:", "settings_referall.title": "Bjud in kompisar", "settings_subheader.account": "Kontoinställningar", "settings_subheader.fringe_health_benefits": "Friskvårdsbidrag", "settings_subheader.live_codes": "LIVE-koder", "settings_subheader.manage_notifications": "Email-preferenser", "settings_subheader.privacy": "Sekretessinställningar", "settings_subheader.private": "Medlemsinformation", "settings_subheader.profile": "Profilinställningar", "settings_subheader.receipts": "Kvitton", "settings_subheader.referral_program": "Värva vänner", "settings_subheader.subscriptions": "Prenumeration", "settings_subscriptions.access_code.activation_failed": "Koden kunde inte registreras. Prova igen eller kontakta oss för stöd på <0>info@yogobe.com</0> ", "settings_subscriptions.access_code.buy_gift": "Klicka här och köp ett presentkort", "settings_subscriptions.access_code.description": "Om du tex har en kod som ger dig åtkomst till material över en begränsad tid, såsom via Mecenat eller en arbetsgivare, så fyller du i den i nedan textfält", "settings_subscriptions.access_code.input_description": "Gäller även koder via Studentföretaget Mecenat", "settings_subscriptions.access_code.input_label": "Fyll i din kod", "settings_subscriptions.access_code.invalid_code_message": "Koden som du har fyllt i stämmer inte, eller så är den inte längre giltig. Prova igen och tveka inte att höra av dig till oss på <0>info@yogobe.com</0> vid frågor", "settings_subscriptions.access_code.submit_btn": "Aktivera", "settings_subscriptions.access_code.title": "Har du fått en accesskod?", "settings_subscriptions.access_code.valid_code_message": "Din kod har registrerats", "settings_subscriptions.annually": "Årligen", "settings_subscriptions.cancel_mobile_subscription": ["Du betalar just nu för din prenumeration via ", ["provider"], ". Avbryt detta först för att istället betala direkt till Yogobe. Vid frågor, besök gärna vår"], "settings_subscriptions.cancelled_no_access": "Din prenumeration har avbrutits och därför har du just nu ingen obegränsad åtkomst till videor, playlists, program eller utmaningar. Återaktivera när du vill genom att göra en betalning.", "settings_subscriptions.cancelled_with_access": ["Din aktiva prenumeration har avbrutits men du har fortfarande obegränsad access till vidoer, playlists, program och utmaningar fram till ", ["date"], ". Återaktivera när du vill genom att göra en prenumerationsbetalning."], "settings_subscriptions.description_free": "Du har just nu ingen aktiv eller betalande prenumeration", "settings_subscriptions.description_no_subscription_premium": ["Du har prenumerations-åtkomst till ", ["date"]], "settings_subscriptions.discount_code.description": "Om du har fått en kod som ger dig en prenumerationsrabatt så skriver du in den i nedan textfält.", "settings_subscriptions.discount_code.input_description": "Gäller också för rabatt- och specialerbjudandekoder", "settings_subscriptions.discount_code.input_label": "Fyll i din rabattkod", "settings_subscriptions.discount_code.invalid_code_message": "Den kod som du har fyllt i stämmer inte. Prova igen eller har kanske giltighetstiden gått ut? Ttveka inte att höra av dig till oss på <0>info@yogobe.com</0> vid frågor", "settings_subscriptions.discount_code.submit_btn": "Aktivera", "settings_subscriptions.discount_code.title": "Har du en rabattkod?", "settings_subscriptions.discount_code.valid_code_message": "Din kod har registrerats", "settings_subscriptions.mobile_description_premium_renew": ["Din prenumeration förnyas automatiskt via ", ["platform"], " den ", ["date"]], "settings_subscriptions.monthly": "Månatligen", "settings_subscriptions.quarterly": "Kvartalsvis", "settings_subscriptions.subscription_next_billing": ["Du har just nu en löpande prenumeration per ", ["plan"], " om ", ["amount"], ". Automatisk förnyelse sker den ", ["date"]], "settings_subscriptions.subscription_next_billing_failed": ["Betalningen om ", ["amount"], " kunde inte genomföras"], "settings_subscriptions.subscription_next_billing_processing": "Din betalning behandlas", "settings_subscriptions.subscription_next_billing_unpaid": ["Betalningen på ", ["summa"], " kunde inte slutföras. Vi har försökt debitera dig för att hålla ditt abonnemang aktivt."], "settings_subscriptions.title": "Vill du ändra din prenumerationstyp?", "settings_subscriptions.toaster_message.access_code_activated": "Koden har aktiverats!", "settings_subscriptions.updated": "Din accesstid har förlängts", "settings_subscriptions.wellness_banner.description": "...du kan använda ditt friskvårdsbidrag till en prenumeration eller en kurs hos Yogobe? Bara ladda ner eller skriv ut dina kvitton. Vi samarbetar också med friskvårdsportalerna Benify, Epassi, Wellnet, och Benefits. <0>Läs mer här.</0>", "settings_subscriptions.wellness_banner.title": "Visste du att...", "share_modal.copied_button": "Kopierad till urklipp", "share_modal.copy_placeholder": "Kopiera URL för att dela:", "share_modal.hidden": "Du kan dela denna dolda playlist och den kan endast nås via sin länk/URL. <0>Ändra playlistinställningar.</0>", "share_modal.privacy": "Du kan dela denna playlist men ingen kommer kunna se den. <0>Ändra playlistinställningar.</0>", "share_modal.title": "Dela", "snackbar.faq": "FAQ sida", "snackbar.favorites": "Favorites", "snackbar.playlist": "Se playlist", "snackbar.playlists": "Playlists", "snackbars.added_video_playlist": "Videon har lagts till i playlist", "snackbars.cancel_subscription_faild": "Hoppsan, det gick inte att avbryta din prenumeration. Försök igen!", "snackbars.challenge.program_access_granted": "Du deltar nu i denna utmaning", "snackbars.created_playlist": "Din playlist har skapats", "snackbars.favorited_playlist": "Sparad som favorit", "snackbars.favorited_video": "Sparad som favorit", "snackbars.removed_video_playlist": "Videon har tagits bort från playlist", "snackbars.settings_update": "Dina inställningar har uppdaterats", "snackbars.subscription_succussfuly_canceled": "Du har nu avbrutit din prenumeration. Välkommen tillbaka snart!", "snackbars.unfavorited_playlist": "Borttagen som favorit", "snackbars.unfavorited_video": "Borttagen som favorit", "snackbars.updated_playlist": "Din playlist har uppdaterats", "sortby.published_at": "Senast tillagd", "sortby.time": "Tid", "special399.banner.usp1": "Kvartalsprenumeration", "specialoffer.banner_cta": "Ja tack", "specialoffer.banner_tag1": "Testa gratis 14 dagar", "specialoffer.banner_tag2": "Tidsbegränsat erbjudande", "specialoffer.banner_title": "Uppgradera ditt medlemskap och få 500 SEK att handla Yogiraj för", "specialoffer.new_banner_title": "Gör som 115 000 andra. Bli medlem på Yogobe och del i vår växande gemenskap!", "spring_challenge.thankyou": "Kul att du ska vara med i Yogobe Spring Challenge! Vi ser verkligen fram emot att få följa din utveckling under de kommande veckorna. Kom ihåg, den bästa träningen är den som blir av.", "springchallenge.banner.disclaimer": "*Gäller både nya och gamla medlemmar och ger access till videobiblioteket och utmaningar! (ord pris 189 SEK)", "springchallenge.banner.subtitle": "Välkommen till vårens utmaning som ingår för dig med minst 28 accessdagar. Annars kostar det bara 99 SEK din första månad", "springchallenge.banner.title": "Spring Challenge", "springchallenge.form.title": "Yogobe Spring Challenge", "springchallenge.info.excerpt": "Vi välkomnar dig till en 4-veckors utmaning för att boosta din nyfikenhet och testa allt från yoga och meditation till rörlighetsträning, andningsövningar och stresshantering. Allt tillsammans med några av Skandinaviens största namn inom hälsa. Varje vecka får du 10 nya klasser, teknikvideor och pepp att välja fritt bland.   <h2>Du väljer när du vill börja</h2> Hoppa på utmaningen mellan den 20 mars och 15 april 2020.  <h2>Välj ditt program</h2> Utmaningen erbjuder fyra olika program för att du ska kunna hitta ditt flow och ha skoj, få ny energi och utmana dig själv! Läs mer om de fyra programmen nedan. Nytt för våren är att våra vänner i Finland får en egen version av utmaningen med 2 program. På finska. <a href=\"https://yogobe.com/fi/springchallenge\">Läs mer om den här.</a> <ul> <li><bold>Stillness in self</bold> : för dig som vill landa efter en period av långvarig stress eller utmattning.</li>  <li><bold>Fire & fumes</bold> : för dig som är pepp på en fysisk utmaning som kommer ge märkbara resultat i styrka, rörlighet och kondition. </li>  <li><bold>Runners high</bold> : för dig som älskar löpning och vill utveckla din löpteknik - oavsett om du springer för vardagsmotion eller tränar inför ett lopp. </li>  <li><bold>Fierce soulwork</bold> : för dig som är erfaren yogautövare och vill utveckla din asana, fördjupa din filosofiska förståelse samt komma vidare på din spirituella resa.</li>  </ul> För en mer detaljerad beskrivning av programmen, scrolla ner.   ", "springchallenge.info.rest": "<h2>Vinn fina priser*</h2> Om du slutför minst tre klasser per vecka har du chansen att vara en av 10 vinnare som tar hem storvinsten: Ett årsmedlemskap på Yogobe plus valfri onlinekurs på Yogobe (värde fr. 2 398 SEK). Detta gäller för dig som startade din utmaning innan den 1 maj.   <h2>Vem kan delta i utmaningen?</h2> Precis alla! För att få tillgång till utmaningen behöver du bara vara aktiv medlem. Alla nya medlemmar samt du som inte är aktiv eller betalande medlem får första månaden för bara 99 SEK när du signar upp (ord. pris 189 SEK). Prenumerationen övergår sedan i en betalande månadsprenumeration (189 SEK per månad). Nya medlemmars konton blir också automatiskt uppgraderade med 14 gratis prova-på-dagar utöver de 30 dagar du betalar för.   <h2>Du kommer väl ihåg friskvårdsbidraget?!</h2> Just nu vill vi passa på att påminna er om att använda friskvårdsbidraget – bli årsmedlem för endast 1899 SEK.  <h2>Få inspiration och stöd</h2> Dela med dig av ditt deltagande via hashtaggen #yogobespringchallenge. I vår Facebookgrupp <a href=\"https://www.facebook.com/groups/beyoga365/\">#BEYOGA365</a> får du också stöd och inspiration från både Team Yogobe och våra medlemmar . Välkommen! Gå med i <a href=\"https://www.facebook.com/groups/beyoga365/\">#BEYOGA365</a> idag!", "springchallenge.info.title": "Yoga och träna med oss i vår!", "springchallenge.programsBody.more.body": "Om du slutför minst tre klasser per vecka har du chansen att vara en av 10 vinnare som tar hem storvinsten: Ett årsmedlemskap på Yogobe plus valfri onlinekurs på Yogobe (värde fr. 2 398 SEK). Detta gäller för dig som startade din utmaning innan den 1 maj.", "springchallenge.programsBody.more.title": "Tävling!", "springchallenge.programsBody.subtitle": "Kom igång och kickstarta din Spring Challenge idag!", "springchallenge.programsBody.title": "Vilket program passar dig?", "springchallenge.testimonials.title": "Ledande lärare och profiler guidar och inpirerar", "start.section3_title": "Utforska videor via kategorier", "statistics_banner.info": ["Under ", ["year"], " kommer vi lansera en ny upplevelse kring din statistik på Yogobe. Tills vidare är denna del av din profil därför pausad i väntan på nyheterna!"], "stats.average_duration": "Medellängd", "stats.favorite_yoga_style": "Din favorit yogastil", "stats.minutes": "minutter", "stats.sessions": "Sessioner", "stats.sessions_completed": "Slutförda sessioner", "stats.total_time": "Total tid", "stripe_banner.wellness_grant.december.text": "Använd hela friskvårdsbidraget innan 31 dec. Onlineträning är perfekt i dessa tider. Läs mer här!", "stripe_banner.wellness_grant.november.text": "Passa på: använd ditt friskvårdsbidrag för onlineträning i dessa tider. Läs mer här!", "subheader.overview": "Översikt", "subheader.playlists": "Playlists", "subheader.programs": "Träningsprogram", "subscriptions.cancel_subscription": "Avbryt prenumeration", "subscriptions.cancel_subscription_helper": "Det är enkelt att avbryta ditt betalande medlemskap. Ifall du gör ett aktivt val att inte fortsätta prenumerera på Yogobe så har du givetvis fortsatt tillgång till videobiblioteket för hela den period som du har förskottsbetalat för.  ", "subscriptions.cancel_subscription_label": "Vill du avbryta din prenumeration?", "subscriptions.full_accesse_code.default_title": "Access via access code", "subscriptions.one_time_code.default_title": "Access via one time access code", "summerchallenge.banner.text": "<0>Upprätthåll dina goda vanor i sommar - signa upp på #yogobesummerchallenge</0>", "summerchallenge.banner.title": "Yogobe Summer Challenge", "summerchallenge.challenge_form.activate_account": "Tack för din anmälan!  Vi har nu skickat ett mejl som borde landa i din inkorg inom ett par minuter. I mejlet finner du en länk, klicka på den för att aktivera ditt konto och du kommer få full tillgång till ditt program med start idag.", "summerchallenge.challenge_form.level_note": "Scrolla ner för att läsa mer. Ny funktion: Byt program när du vill.", "summerchallenge.challenge_form.login": "Fyll i formuläret och få fullständig tillgång till Yogobe Summer Challenge! ", "summerchallenge.challenge_form.resend_activation": "Har du inte mottagit mejlet? <0>Klicka här för att skicka igen</0>", "summerchallenge.dashboard_banner.text": "Kickstarta sommaren med oss – signa upp på #yogobesummerchallenge", "summerchallenge.form.title": "Yogobe Summer Challenge", "summerchallenge.info.excerpt": "Vi välkomnar dig till en 4-veckors utmaning för att möta dina behov, vare sig du är nybörjare, erfaren atlet, löpare eller yogaentusiast. Utmaningen finns anpassad för medlemmar i både Sverige och <a href=\"/fi/summerchallenge\" target=\"_blank\">Finland</a>. I den svenska utmaningen kan du välja mellan 4 olika program (mer info nedan) – så att du verkligen får den motivation, träning och regelbundenhet du behöver. Allt tillsammans med några av Skandinaviens största namn inom hälsa. Varje vecka får du 10 nya klasser, teknikvideor och föreläsningar att välja fritt bland.   <h2>Du väljer när du vill starta utmaningen</h2> Du kan välja att starta utmaningen när det passar dig och dina sommarplaner - allt mellan den 15 juni och 15 augusti 2020. Från dagen du aktiverar utmaningen har du sedan 4 veckor av pepp framför dig! Utmaningen kommer att finnas tillgänglig via din profil även efter denna 4-veckorsperiod.  <h2>Vem kan delta i utmaningen?</h2> Precis alla! För att få tillgång till utmaningen behöver du vara betalande medlem eller ha access via Mecenat. Alla nya medlemmar samt du som inte längre är betalande medlem får första månaden för bara 99 SEK när du signar upp (ord. pris 189 SEK). Prenumerationen övergår sedan i en betalande månadsprenumeration (189 SEK per månad). Nya medlemmars konton blir också automatiskt uppgraderade med 14 gratis prova-på-dagar utöver de 30 dagar du betalar för.   <h2>Välj ditt program</h2> Utmaningen erbjuder fyra olika program för att du ska kunna hitta ditt flow och ha skoj, få ny energi och utmana dig själv! Läs mer om de fem programmen nedan. Finland har en egen version av utmaningen med två program, på finska, <a href=\"/se/springchallenge\" target=\"_blank\">läs mer om den här</a>.  För en mer detaljerad beskrivning av programmen, scrolla ner.    ", "summerchallenge.info.rest": "<ul>   <li>     <bold>Happy beginner</bold> – för dig som behöver motivation och pepp att komma igång med enkel träning, funktionell rörelse, yoga för nybörjare, mindfulness och motivational talks.   </li>   <li>     <bold>Complete restoration</bold> – för dig som vill landa efter en period av stress, långvarig smärta eller utmattning. Du kommer få upptäcka restorative yoga, andningsövningar, yoga nidra, kognitiva övningar och mindfulness.    </li>   <li>     <bold>Sweaty & healthy</bold> – för dig som är pepp på en fysisk utmaning och vill se märkbara resultat i styrka, rörlighet och kondition.    </li>     <li>     <bold>Go deep & within</bold> – för dig som är erfaren yogautövare och vill utveckla din asana, fördjupa din filosofiska förståelse samt komma vidare på din spirituella resa. Mycket av innehållet är på engelska och kan passa en deltagare som föredrar det!   </li> </ul>  <h2>Du kan byta program</h2> Ja, du kan byta program under Yogobe Summer Challenge. Var medveten om att du kommer förlora den statistik du samlat från det program du tidigare påbörjat.   <h2>Vinn fina priser</h2> Om du slutför minst tre klasser per vecka har du chansen att vara en av 10 vinnare som tar hem storvinsten: Ett årsmedlemskap på Yogobe + valfri <a href=\"/se/marketplace/online-courses\" target=\"_blank\">onlinekurs</a> på Yogobe (värde från 2 398 SEK).  <h2>Du kommer väl ihåg friskvårdsbidraget?! </h2> Just nu vill vi passa på att påminna er om att använda friskvårdsbidraget – bli årsmedlem för endast 1899 SEK.  <h2>Få inspiration och stöd</h2> Dela med dig av ditt deltagande via hashtaggen #yogobesummerchallenge. I vår Facebookgrupp <a href=\"https://www.facebook.com/groups/beyoga365/\" target=\"_blank\" rel=\"noopener\">#BEYOGA365</a> får du också stöd och inspiration från både Team Yogobe och våra medlemmar, välkommen! Gå med i #BEYOGA365 idag!", "summerchallenge.info.title": "Yoga och träna med oss i sommar!", "summerchallenge.programsBody.more.body": "Om du slutför minst tre klasser per vecka har du chansen att vara en av 10 vinnare som tar hem storvinsten: Ett årsmedlemskap på Yogobe plus valfri onlinekurs på Yogobe (värde fr. 2 398 SEK).", "summerchallenge.programsBody.more.title": "Tävling!", "summerchallenge.programsBody.subtitle": "Kom igång och kickstarta din Summer Challenge idag!", "summerchallenge.programsBody.title": "Vilket program passar dig?", "summerchallenge.testimonials.title": "Ledande lärare och profiler guidar och peppar", "summerchallenge.thank_you.text": "Kul att du ska vara med i Yogobe Summer Challenge! Vi ser verkligen fram emot att få följa din utveckling under de kommande veckorna. Kom ihåg, den bästa träningen är den som blir av.", "summerchallenge.usergroup1.disclaimer": "*så länge du har en aktiv prenumeration.", "summerchallenge.usergroup1.infoform": "Denna utmaning är inkluderad i din aktiva prenumeration. Gå med redan idag! ", "summerchallenge.usergroup1.mainbanner": ["Hej ", ["firstName"], ", välkommen till Yogobe Summer Challenge. Denna utmaning är gratis för alla aktiva medlemmar - starta redan idag!"], "summerchallenge.usergroup2.disclaimer": "*Gäller både nya och befintliga medlemmar. Få obegränsad access till videobiblioteket, utmaningar och alla program! (ordinarie pris 189 SEK)", "summerchallenge.usergroup2.infoform": "Du behöver ha minst 28 accessdagar kvar eller en löpande prenumeration för att starta utmaningen. ", "summerchallenge.usergroup2.mainbanner": ["Hej ", ["firstName"], ", välkommen till Yogobe Summer Challenge. Gå med i utmaningen för endast 99 SEK*, starta redan idag! "], "summerchallenge.usergroup3.disclaimer": "*Gäller både nya och befintliga medlemmar. Få obegränsad access till videobiblioteket, utmaningar och alla program! (ordinarie pris 189 SEK)  ", "summerchallenge.usergroup3.infoform": "Gå med i utmaningen för endast 99 SEK*", "summerchallenge.usergroup3.mainbanner": "Välkommen till Yogobe Summer Challenge. Gå med i utmaningen för endast 99 SEK*, starta redan idag! ", "summerchallenge.video.extra": "Extra", "summerchallenge.video.repeat": "Repetera gärna", "summerchallenge.video.technic": "Teknik", "surveys_2022.validation.maxlength": ["Du kan max skriva ", ["length"], " tecken"], "surveys_2022.validation.minlength": ["Minst ", ["length"], " tecken behövs"], "surveys_2022.validation.required": "Det är viktigt att du fyller i detta fält", "teacher_modal.go_to_profile": "Gå till profil", "teacher_modal.homepage": "Hemsida", "teacher_modal.location": "Plats", "teacher_modal.speciality": "Specialitet", "userlogin.logout": "Logga ut", "userlogin.menu.cancelled_plan": "Avbruten prenumeration", "userlogin.menu.expired_plan": "Inaktiv prenumeration", "userlogin.menu.free_premium": "Prenumerations-åtkomst", "userlogin.menu.free_trial": "Provperiod", "userlogin.menu.manage": "Hantera", "userlogin.menu.monthly_plan": "Aktiv prenumeration", "userlogin.menu.no_plan": "Ingen prenumeration", "userlogin.menu.premium_plan": "Aktiv prenumeration", "userlogin.menu.quarterly_plan": "Aktiv prenumeration", "userlogin.menu.renew": "Förnya", "userlogin.menu.upgrade": "Uppgradera", "userlogin.menu.yearly_plan": "Aktiv prenumeration", "userlogin.my_dashboard": "Översikt", "userlogin.my_favorites": "Mina favoriter", "userlogin.my_playlists": "Mina playlists", "userlogin.my_stats": "Min statistik", "userlogin.my_subscription": "Prenumeration", "userlogin.settings": "Mina inställningar", "usersubheader.dashboard": "Översikt", "usersubheader.favorites": "Favoriter", "usersubheader.for_me": "Rekommendationer", "usersubheader.my_favorites": "Mina favoriter", "usersubheader.my_playlists": "Mina playlists", "usersubheader.playlists": "Playlists", "usersubheader.statistics": "Statistik", "validation.DOBInvalid": "Format för datum är DD/MM/YYYY", "validation.DOBMax": "Du borde vara X år gammal", "validation.DOBMin": "Stämmer verkligen denna ålder?", "validation.email": "Var snäll och fyll i en giltig email-adress", "validation.email_taken": "Du har skrivit in en mailadress som redan tillhör en medlem på Yogobe. Logga istället in för att fortsätta!", "validation.firstNameMax": "Angivet förnamn är för långt", "validation.lastNameMax": "Angivet efternamn är för långt", "validation.link": "Här skall du fylla i en URL/webadress", "validation.passwordConfirmNotMatch": "Lösenorden matchar inte varandra", "validation.passwordMax": "Ditt löseord får innehålla max 18 tecken.", "validation.passwordMin": "Var snäll och se till att ditt nya lösenord har minst 8 tecken", "validation.phone": "Här fyller du i ett telefonnummer", "validation.required": "Det är viktigt att du fyller i detta fält", "validation.user_social_already_exists": "The email associated with the social account you used already belongs to a Yogobe member. Please try logging in instead or signup using a different social account/email.", "video.bundle_video_banner": "Dessa rekommendationer ingår inte i din temasida.", "video.premium_msg": "Du har precis sett en förhandsvisning på 60 sekunder. Vill du se resten också?", "video.preview_msg": "60 sekunders förhandsvisning", "video.related_video_title": "Relaterade videor", "video.video_not_found": "Videon kan inte hittas", "video_cover_locked.Upgrade": "Uppgradera", "video_cover_locked.login": "Logga in", "video_cover_locked.register": "Skapa konto", "video_settings_banner.info": "Skräddarsy din Yogobe-upplevelse genom att använda filter och taggar nedan istället för ord-sök. Då får du alltid exakta resultat! Du kan också avgränsa dina resultat ytterligare under Videoinställningar!", "videos.beyoga365.description": "Tema- och intentionsmånader", "videos.beyoga365.title": "BEYOGA365", "videos.blog_posts_title": "Inspiration från vår blogg", "videos.get_started_section.title": "Jag vill komma igång med att", "videos.playlists_recommended.title": "Playlists rekommenderade för dig", "videos.programs.title": "Träningsprogram", "videos.quickstart.suggestions": "Förslag för dig", "videos.weekly_picks.title": "Veckans videor", "videos.yogamom365.description": "Tema- och intentionsmånader", "videos.yogamom365.title": "YOGAMOM365", "videosGenres.discover": ["Ta del av ", ["name"], "’s videor och vägledning inom andra områden"], "videosGenres.sessions": "Sessioner", "videos_genres.count": [["count"], " träffar"], "videos_genres.keyword": ["för sökordet \"", ["keyword"], "\""], "videos_genres.settings_button": "Videoinställningar", "weeklyProgram.course_survey.locked": "Köp kursen för att ta del av detta innehåll.", "weeklyProgram.document.locked": "weeklyProgram.document.locked", "weeklyProgram.document.open_document": "Öppna dokument", "weeklyProgram.introduction.label": "Introduktion", "weeklyProgram.program_survey.locked": "Starta programmet för åtkomst till denna enkät.", "weeklyProgram.survey.locked": "weeklyProgram.survey.locked", "weeklyProgram.week.number": ["Vecka ", ["number"]], "weeklyProgram.week.videos_duration": [["videosCount"], " Videor - ", ["duration"]], "weeklyProgram.week_progress.text": "Progressen visar antalet videor du har slutfört utav alla videor denna vecka.", "weeklyProgram.weekly_progress.program_content": "Programinnehåll", "yearlyfall2021.yearly_subscription_description": "Din prenumeration förnyas årligen. Uppgradera innan 11 oktober och få en gratis yogamatta." } };

/***/ }),

/***/ 65235:
/***/ (function(module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
  value: true }));

exports.getDomainLocale = getDomainLocale;
var basePath = (/* unused pure expression or super */ null && ( false || ''));
function getDomainLocale(path, locale, locales, domainLocales) {
  if (false) { var finalLocale, proto, domain, target, detectDomainLocale, normalizeLocalePath; } else {
    return false;
  }
}

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', { value: true });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 77913:
/***/ (function(module, exports, __webpack_require__) {

"use client";
"use strict";var _slicedToArray = __webpack_require__(85696);
Object.defineProperty(exports, "__esModule", ({
  value: true }));

exports["default"] = void 0;
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(17273)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var _router = __webpack_require__(12199);
var _formatUrl = __webpack_require__(17389);
var _addLocale = __webpack_require__(51630);
var _routerContext = __webpack_require__(59541);
var _appRouterContext = __webpack_require__(6163);
var _useIntersection = __webpack_require__(27215);
var _getDomainLocale = __webpack_require__(65235);
var _addBasePath = __webpack_require__(70729);
'use client';
var prefetched = new Set();
function prefetch(router, href, as, options) {
  if (false) {}
  if (!(0, _router).isLocalURL(href)) {
    return;
  }
  // We should only dedupe requests when experimental.optimisticClientCache is
  // disabled.
  if (!options.bypassPrefetchedCheck) {
    var locale = // Let the link's locale prop override the default router locale.
    typeof options.locale !== 'undefined' ? options.locale : 'locale' in router ? router.locale : undefined;
    var prefetchedKey = href + '%' + as + '%' + locale;
    // If we've already fetched the key, then don't prefetch it again!
    if (prefetched.has(prefetchedKey)) {
      return;
    }
    // Mark this URL as prefetched.
    prefetched.add(prefetchedKey);
  }
  // Prefetch the JSON page if asked (only in the client)
  // We need to handle a prefetch error here since we may be
  // loading with priority which can reject but we don't
  // want to force navigation since this is only a prefetch
  Promise.resolve(router.prefetch(href, as, options))["catch"](function (err) {
    if (false) {}
  });
}
function isModifiedEvent(event) {
  var target = event.currentTarget.target;
  return target && target !== '_self' || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}
function linkClicked(e, router, href, as, replace, shallow, scroll, locale, isAppRouter, prefetchEnabled) {
  var nodeName = e.currentTarget.nodeName;
  // anchors inside an svg have a lowercase nodeName
  var isAnchorNodeName = nodeName.toUpperCase() === 'A';
  if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
    // ignore click for browser’s default behavior
    return;
  }
  e.preventDefault();
  var navigate = function navigate() {
    // If the router is an NextRouter instance it will have `beforePopState`
    if ('beforePopState' in router) {
      router[replace ? 'replace' : 'push'](href, as, {
        shallow: shallow,
        locale: locale,
        scroll: scroll });

    } else {
      router[replace ? 'replace' : 'push'](as || href, {
        forceOptimisticNavigation: !prefetchEnabled });

    }
  };
  if (isAppRouter) {
    // @ts-expect-error startTransition exists.
    _react["default"].startTransition(navigate);
  } else {
    navigate();
  }
}
function formatStringOrUrl(urlObjOrString) {
  if (typeof urlObjOrString === 'string') {
    return urlObjOrString;
  }
  return (0, _formatUrl).formatUrl(urlObjOrString);
}
/**
 * React Component that enables client-side transitions between routes.
 */var Link = /*#__PURE__*/_react["default"].forwardRef(function LinkComponent(props, forwardedRef) {
  if (false) { var hasWarned, optionalProps, optionalPropsGuard, requiredProps, requiredPropsGuard, createPropError; }
  var children;
  var hrefProp = props.href,asProp = props.as,childrenProp = props.children,prefetchProp = props.prefetch,passHref = props.passHref,replace = props.replace,shallow = props.shallow,scroll = props.scroll,locale = props.locale,_onClick = props.onClick,onMouseEnterProp = props.onMouseEnter,onTouchStartProp = props.onTouchStart,_props$legacyBehavior = props.legacyBehavior,legacyBehavior = _props$legacyBehavior === void 0 ? Boolean(true) !== true : _props$legacyBehavior,restProps = _object_without_properties_loose(props, [
  "href",
  "as",
  "children",
  "prefetch",
  "passHref",
  "replace",
  "shallow",
  "scroll",
  "locale",
  "onClick",
  "onMouseEnter",
  "onTouchStart",
  "legacyBehavior"]);

  children = childrenProp;
  if (legacyBehavior && (typeof children === 'string' || typeof children === 'number')) {
    children = /*#__PURE__*/_react["default"].createElement("a", null, children);
  }
  var prefetchEnabled = prefetchProp !== false;
  var pagesRouter = _react["default"].useContext(_routerContext.RouterContext);
  var appRouter = _react["default"].useContext(_appRouterContext.AppRouterContext);
  var router = pagesRouter != null ? pagesRouter : appRouter;
  // We're in the app directory if there is no pages router.
  var isAppRouter = !pagesRouter;
  var _react$default$useMem = _react["default"].useMemo(function () {
    if (!pagesRouter) {
      var _resolvedHref = formatStringOrUrl(hrefProp);
      return {
        href: _resolvedHref,
        as: asProp ? formatStringOrUrl(asProp) : _resolvedHref };

    }
    var _resolveHref = (0, _router).resolveHref(pagesRouter, hrefProp, true),_resolveHref2 = _slicedToArray(_resolveHref, 2),resolvedHref = _resolveHref2[0],resolvedAs = _resolveHref2[1];
    return {
      href: resolvedHref,
      as: asProp ? (0, _router).resolveHref(pagesRouter, asProp) : resolvedAs || resolvedHref };

  }, [
  pagesRouter,
  hrefProp,
  asProp]),href = _react$default$useMem.href,as = _react$default$useMem.as;

  var previousHref = _react["default"].useRef(href);
  var previousAs = _react["default"].useRef(as);
  // This will return the first child, if multiple are provided it will throw an error
  var child;
  if (legacyBehavior) {
    if (false) {} else {
      child = _react["default"].Children.only(children);
    }
  } else {
    if (false) { var ref; }
  }
  var childRef = legacyBehavior ? child && typeof child === 'object' && child.ref : forwardedRef;
  var _useIntersection2 = (0, _useIntersection).useIntersection({
    rootMargin: '200px' }),_useIntersection3 = _slicedToArray(_useIntersection2, 3),setIntersectionRef = _useIntersection3[0],isVisible = _useIntersection3[1],resetVisible = _useIntersection3[2];

  var setRef = _react["default"].useCallback(function (el) {
    // Before the link getting observed, check if visible state need to be reset
    if (previousAs.current !== as || previousHref.current !== href) {
      resetVisible();
      previousAs.current = as;
      previousHref.current = href;
    }
    setIntersectionRef(el);
    if (childRef) {
      if (typeof childRef === 'function') childRef(el);else
      if (typeof childRef === 'object') {
        childRef.current = el;
      }
    }
  }, [
  as,
  childRef,
  href,
  resetVisible,
  setIntersectionRef]);

  // Prefetch the URL if we haven't already and it's visible.
  _react["default"].useEffect(function () {
    if (!router) {
      return;
    }
    // If we don't need to prefetch the URL, don't do prefetch.
    if (!isVisible || !prefetchEnabled) {
      return;
    }
    // Prefetch the URL.
    prefetch(router, href, as, {
      locale: locale });

  }, [
  as,
  href,
  isVisible,
  locale,
  prefetchEnabled,
  pagesRouter == null ? void 0 : pagesRouter.locale,
  router]);

  var childProps = {
    ref: setRef,
    onClick: function onClick(e) {
      if (false) {}
      if (!legacyBehavior && typeof _onClick === 'function') {
        _onClick(e);
      }
      if (legacyBehavior && child.props && typeof child.props.onClick === 'function') {
        child.props.onClick(e);
      }
      if (!router) {
        return;
      }
      if (e.defaultPrevented) {
        return;
      }
      linkClicked(e, router, href, as, replace, shallow, scroll, locale, isAppRouter, prefetchEnabled);
    },
    onMouseEnter: function onMouseEnter(e) {
      if (!legacyBehavior && typeof onMouseEnterProp === 'function') {
        onMouseEnterProp(e);
      }
      if (legacyBehavior && child.props && typeof child.props.onMouseEnter === 'function') {
        child.props.onMouseEnter(e);
      }
      if (!router) {
        return;
      }
      if (!prefetchEnabled && isAppRouter) {
        return;
      }
      prefetch(router, href, as, {
        locale: locale,
        priority: true,
        // @see {https://github.com/vercel/next.js/discussions/40268?sort=top#discussioncomment-3572642}
        bypassPrefetchedCheck: true });

    },
    onTouchStart: function onTouchStart(e) {
      if (!legacyBehavior && typeof onTouchStartProp === 'function') {
        onTouchStartProp(e);
      }
      if (legacyBehavior && child.props && typeof child.props.onTouchStart === 'function') {
        child.props.onTouchStart(e);
      }
      if (!router) {
        return;
      }
      if (!prefetchEnabled && isAppRouter) {
        return;
      }
      prefetch(router, href, as, {
        locale: locale,
        priority: true,
        // @see {https://github.com/vercel/next.js/discussions/40268?sort=top#discussioncomment-3572642}
        bypassPrefetchedCheck: true });

    } };

  // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
  // defined, we specify the current 'href', so that repetition is not needed by the user
  if (!legacyBehavior || passHref || child.type === 'a' && !('href' in child.props)) {
    var curLocale = typeof locale !== 'undefined' ? locale : pagesRouter == null ? void 0 : pagesRouter.locale;
    // we only render domain locales if we are currently on a domain locale
    // so that locale links are still visitable in development/preview envs
    var localeDomain = (pagesRouter == null ? void 0 : pagesRouter.isLocaleDomain) && (0, _getDomainLocale).getDomainLocale(as, curLocale, pagesRouter == null ? void 0 : pagesRouter.locales, pagesRouter == null ? void 0 : pagesRouter.domainLocales);
    childProps.href = localeDomain || (0, _addBasePath).addBasePath((0, _addLocale).addLocale(as, curLocale, pagesRouter == null ? void 0 : pagesRouter.defaultLocale));
  }
  return legacyBehavior ? /*#__PURE__*/_react["default"].cloneElement(child, childProps) : /*#__PURE__*/_react["default"].createElement("a", Object.assign({}, restProps, childProps), children);
});
var _default = Link;
exports["default"] = _default;

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', { value: true });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 27215:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _slicedToArray = __webpack_require__(85696);
Object.defineProperty(exports, "__esModule", ({
  value: true }));

exports.useIntersection = useIntersection;
var _react = __webpack_require__(67294);
var _requestIdleCallback = __webpack_require__(98065);
var hasIntersectionObserver = typeof IntersectionObserver === 'function';
var observers = new Map();
var idList = [];
function createObserver(options) {
  var id = {
    root: options.root || null,
    margin: options.rootMargin || '' };

  var existing = idList.find(function (obj) {return obj.root === id.root && obj.margin === id.margin;});
  var instance;
  if (existing) {
    instance = observers.get(existing);
    if (instance) {
      return instance;
    }
  }
  var elements = new Map();
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var callback = elements.get(entry.target);
      var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;
      if (callback && isVisible) {
        callback(isVisible);
      }
    });
  }, options);
  instance = {
    id: id,
    observer: observer,
    elements: elements };

  idList.push(id);
  observers.set(id, instance);
  return instance;
}
function observe(element, callback, options) {
  var _createObserver = createObserver(options),id = _createObserver.id,observer = _createObserver.observer,elements = _createObserver.elements;
  elements.set(element, callback);
  observer.observe(element);
  return function unobserve() {
    elements["delete"](element);
    observer.unobserve(element);
    // Destroy observer when there's nothing left to watch:
    if (elements.size === 0) {
      observer.disconnect();
      observers["delete"](id);
      var index = idList.findIndex(function (obj) {return obj.root === id.root && obj.margin === id.margin;});
      if (index > -1) {
        idList.splice(index, 1);
      }
    }
  };
}
function useIntersection(_ref) {var rootRef = _ref.rootRef,rootMargin = _ref.rootMargin,disabled = _ref.disabled;
  var isDisabled = disabled || !hasIntersectionObserver;
  var _useState = (0, _react).useState(false),_useState2 = _slicedToArray(_useState, 2),visible = _useState2[0],setVisible = _useState2[1];
  var _useState3 = (0, _react).useState(null),_useState4 = _slicedToArray(_useState3, 2),element = _useState4[0],setElement = _useState4[1];
  (0, _react).useEffect(function () {
    if (hasIntersectionObserver) {
      if (isDisabled || visible) return;
      if (element && element.tagName) {
        var unobserve = observe(element, function (isVisible) {return isVisible && setVisible(isVisible);}, {
          root: rootRef == null ? void 0 : rootRef.current,
          rootMargin: rootMargin });

        return unobserve;
      }
    } else {
      if (!visible) {
        var idleCallback = (0, _requestIdleCallback).requestIdleCallback(function () {return setVisible(true);});
        return function () {return (0, _requestIdleCallback).cancelIdleCallback(idleCallback);};
      }
    }
  }, [
  element,
  isDisabled,
  rootMargin,
  rootRef,
  visible]);

  var resetVisible = (0, _react).useCallback(function () {
    setVisible(false);
  }, []);
  return [
  setElement,
  visible,
  resetVisible];

}

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', { value: true });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 32323:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
  value: true }));

exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var _loadable = _interop_require_default(__webpack_require__(82271));
function dynamic(dynamicOptions, options) {
  var loadableFn = _loadable["default"];
  var loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
    // A loading component is not required, so we default it
    loading: function loading(_ref) {var error = _ref.error,isLoading = _ref.isLoading,pastDelay = _ref.pastDelay;
      if (!pastDelay) return null;
      if (false) {}
      return null;
    } };

  // Support for direct import(), eg: dynamic(import('../hello-world'))
  // Note that this is only kept for the edge case where someone is passing in a promise as first argument
  // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
  // To make sure we don't execute the import without rendering first
  if (dynamicOptions instanceof Promise) {
    loadableOptions.loader = function () {return dynamicOptions;};
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
  } else if (typeof dynamicOptions === 'function') {
    loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
  } else if (typeof dynamicOptions === 'object') {
    loadableOptions = _extends({}, loadableOptions, dynamicOptions);
  }
  // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
  loadableOptions = _extends({}, loadableOptions, options);
  if (loadableOptions.suspense) {
    if (false) {}
    delete loadableOptions.ssr;
    delete loadableOptions.loading;
  }
  // coming from build/babel/plugins/react-loadable-plugin.js
  if (loadableOptions.loadableGenerated) {
    loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
    delete loadableOptions.loadableGenerated;
  }
  // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
  // skip `ssr` for suspense mode and opt-in React.lazy directly
  if (typeof loadableOptions.ssr === 'boolean' && !loadableOptions.suspense) {
    if (!loadableOptions.ssr) {
      delete loadableOptions.ssr;
      return noSSR(loadableFn, loadableOptions);
    }
    delete loadableOptions.ssr;
  }
  return loadableFn(loadableOptions);
}
var isServerSide = false;
function noSSR(LoadableInitializer, loadableOptions) {
  // Removing webpack and modules means react-loadable won't try preloading
  delete loadableOptions.webpack;
  delete loadableOptions.modules;
  // This check is necessary to prevent react-loadable from initializing on the server
  if (!isServerSide) {
    return LoadableInitializer(loadableOptions);
  }
  var Loading = loadableOptions.loading;
  // This will only be rendered on the server side
  return function () {return /*#__PURE__*/_react["default"].createElement(Loading, {
      error: null,
      isLoading: true,
      pastDelay: false,
      timedOut: false });};

}

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', { value: true });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 65066:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
  value: true }));

exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var LoadableContext = _react["default"].createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {}

/***/ }),

/***/ 82271:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var _classCallCheck = __webpack_require__(33227);var _createClass = __webpack_require__(88361);function _createForOfIteratorHelper(o, allowArrayLike) {var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];if (!it) {if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {if (it) o = it;var i = 0;var F = function F() {};return { s: F, n: function n() {if (i >= o.length) return { done: true };return { done: false, value: o[i++] };}, e: function e(_e) {throw _e;}, f: F };}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}var normalCompletion = true,didErr = false,err;return { s: function s() {it = it.call(o);}, n: function n() {var step = it.next();normalCompletion = step.done;return step;}, e: function e(_e2) {didErr = true;err = _e2;}, f: function f() {try {if (!normalCompletion && it["return"] != null) it["return"]();} finally {if (didErr) throw err;}} };}function _unsupportedIterableToArray(o, minLen) {if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);}function _arrayLikeToArray(arr, len) {if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {arr2[i] = arr[i];}return arr2;}
Object.defineProperty(exports, "__esModule", ({
  value: true }));

exports["default"] = void 0;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_wildcard = (__webpack_require__(91598)/* ["default"] */ .Z);
var _react = _interop_require_wildcard(__webpack_require__(67294));
var _loadableContext = __webpack_require__(65066);
var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;
function load(loader) {
  var promise = loader();
  var state = {
    loading: true,
    loaded: null,
    error: null };

  state.promise = promise.then(function (loaded) {
    state.loading = false;
    state.loaded = loaded;
    return loaded;
  })["catch"](function (err) {
    state.loading = false;
    state.error = err;
    throw err;
  });
  return state;
}
function resolve(obj) {
  return obj && obj.__esModule ? obj["default"] : obj;
}
function createLoadableComponent(loadFn, options) {
  var opts = Object.assign({
    loader: null,
    loading: null,
    delay: 200,
    timeout: null,
    webpack: null,
    modules: null,
    suspense: false },
  options);
  if (opts.suspense) {
    opts.lazy = _react["default"].lazy(opts.loader);
  }
  /** @type LoadableSubscription */var subscription = null;
  function init() {
    if (!subscription) {
      var sub = new LoadableSubscription(loadFn, opts);
      subscription = {
        getCurrentValue: sub.getCurrentValue.bind(sub),
        subscribe: sub.subscribe.bind(sub),
        retry: sub.retry.bind(sub),
        promise: sub.promise.bind(sub) };

    }
    return subscription.promise();
  }
  // Server only
  if (false) {}
  // Client only
  if (!initialized && true) {
    // require.resolveWeak check is needed for environments that don't have it available like Jest
    var moduleIds = opts.webpack && "function" === 'function' ? opts.webpack() : opts.modules;
    if (moduleIds) {
      READY_INITIALIZERS.push(function (ids) {var _iterator = _createForOfIteratorHelper(
        moduleIds),_step;try {for (_iterator.s(); !(_step = _iterator.n()).done;) {var moduleId = _step.value;
            if (ids.indexOf(moduleId) !== -1) {
              return init();
            }
          }} catch (err) {_iterator.e(err);} finally {_iterator.f();}
      });
    }
  }
  function useLoadableModule() {
    init();
    var context = _react["default"].useContext(_loadableContext.LoadableContext);
    if (context && Array.isArray(opts.modules)) {
      opts.modules.forEach(function (moduleName) {
        context(moduleName);
      });
    }
  }
  function LoadableImpl(props, ref) {
    useLoadableModule();
    var state = (0, _react).useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
    _react["default"].useImperativeHandle(ref, function () {return {
        retry: subscription.retry };},
    []);
    return _react["default"].useMemo(function () {
      if (state.loading || state.error) {
        return _react["default"].createElement(opts.loading, {
          isLoading: state.loading,
          pastDelay: state.pastDelay,
          timedOut: state.timedOut,
          error: state.error,
          retry: subscription.retry });

      } else if (state.loaded) {
        return _react["default"].createElement(resolve(state.loaded), props);
      } else {
        return null;
      }
    }, [
    props,
    state]);

  }
  function LazyImpl(props, ref) {
    useLoadableModule();
    return _react["default"].createElement(opts.lazy, _extends({}, props, {
      ref: ref }));

  }
  var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
  LoadableComponent.preload = function () {return init();};
  LoadableComponent.displayName = 'LoadableComponent';
  return _react["default"].forwardRef(LoadableComponent);
}var
LoadableSubscription = /*#__PURE__*/function () {





























































  function LoadableSubscription(loadFn, opts) {_classCallCheck(this, LoadableSubscription);
    this._loadFn = loadFn;
    this._opts = opts;
    this._callbacks = new Set();
    this._delay = null;
    this._timeout = null;
    this.retry();
  }_createClass(LoadableSubscription, [{ key: "promise", value: function promise() {return this._res.promise;} }, { key: "retry", value: function retry() {var _this = this;this._clearTimeouts();this._res = this._loadFn(this._opts.loader);this._state = { pastDelay: false, timedOut: false };var res = this._res,opts = this._opts;if (res.loading) {if (typeof opts.delay === 'number') {if (opts.delay === 0) {this._state.pastDelay = true;} else {this._delay = setTimeout(function () {_this._update({ pastDelay: true });}, opts.delay);}}if (typeof opts.timeout === 'number') {this._timeout = setTimeout(function () {_this._update({ timedOut: true });}, opts.timeout);}}this._res.promise.then(function () {_this._update({});_this._clearTimeouts();})["catch"](function (_err) {_this._update({});_this._clearTimeouts();});this._update({});} }, { key: "_update", value: function _update(partial) {this._state = _extends({}, this._state, { error: this._res.error, loaded: this._res.loaded, loading: this._res.loading }, partial);this._callbacks.forEach(function (callback) {return callback();});} }, { key: "_clearTimeouts", value: function _clearTimeouts() {clearTimeout(this._delay);clearTimeout(this._timeout);} }, { key: "getCurrentValue", value: function getCurrentValue() {return this._state;} }, { key: "subscribe", value: function subscribe(callback) {var _this2 = this;this._callbacks.add(callback);return function () {_this2._callbacks["delete"](callback);};} }]);return LoadableSubscription;}();

function Loadable(opts) {
  return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
  var promises = [];
  while (initializers.length) {
    var init = initializers.pop();
    promises.push(init(ids));
  }
  return Promise.all(promises).then(function () {
    if (initializers.length) {
      return flushInitializers(initializers, ids);
    }
  });
}
Loadable.preloadAll = function () {
  return new Promise(function (resolveInitializers, reject) {
    flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
  });
};
Loadable.preloadReady = function () {var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return new Promise(function (resolvePreload) {
    var res = function res() {
      initialized = true;
      return resolvePreload();
    };
    // We always will resolve, errors should be handled within loading UIs.
    flushInitializers(READY_INITIALIZERS, ids).then(res, res);
  });
};
if (true) {
  window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default;

/***/ }),

/***/ 91447:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31157);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_buttons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49613);
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10842);
/* harmony import */ var _lingui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85169);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);







var StyledModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__["default"])(_base__WEBPACK_IMPORTED_MODULE_3__/* .Modal */ .u_).withConfig({ displayName: "LinksModal__StyledModal", componentId: "sc-1xbld35-0" })(["display:flex;flex-direction:column;justify-content:center;overflow-x:hidden;"]);






var StyledBody = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__["default"])(_base__WEBPACK_IMPORTED_MODULE_3__/* .Body */ .uT).withConfig({ displayName: "LinksModal__StyledBody", componentId: "sc-1xbld35-1" })(["min-width:345px;display:flex;flex-direction:column;justify-content:center;border-radius:3px;padding:0;margin:0 auto;background-color:white;box-sizing:content-box;"]);











var StyledFooter = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__["default"])(_base__WEBPACK_IMPORTED_MODULE_3__/* .Footer */ .$_).withConfig({ displayName: "LinksModal__StyledFooter", componentId: "sc-1xbld35-2" })(["border-top:none;margin:0 auto;padding:0 30px 24px;"]);






var MenuList = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].ul.withConfig({ displayName: "LinksModal__MenuList", componentId: "sc-1xbld35-3" })(["list-style:none;padding:24px 30px;padding-bottom:24px !important;margin:0;"]);






var Item = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].li.withConfig({ displayName: "LinksModal__Item", componentId: "sc-1xbld35-4" })(["display:block;font-size:11px;color:", ";font-weight:600;& + &{margin-top:2em;}"],


function (props) {return props.theme.colors.neutrals.gray;});







var Anchor = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__["default"])(_components_buttons__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP).withConfig({ displayName: "LinksModal__Anchor", componentId: "sc-1xbld35-5" })(["font-size:16px;color:", ";font-weight:normal;text-align:left;"],

function (props) {return props.theme.colors.neutrals.black;});




var CancelButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__["default"])(_components_buttons__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP).withConfig({ displayName: "LinksModal__CancelButton", componentId: "sc-1xbld35-6" })(["font-size:16px;color:", ";font-weight:normal;"],

function (props) {return props.theme.colors.neutrals.gray;});















var LinksModal = function LinksModal(_ref) {var open = _ref.open,links = _ref.links,onClose = _ref.onClose;
  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(StyledModal, { fullScreen: false, open: open, handleClose: onClose, children: /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(StyledBody, { children: [/*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(MenuList, { children:
          links.map(function (item, i) {
            return /*#__PURE__*/(
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(Item, { children: /*#__PURE__*/
                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), { href: item.href, as: item.as, legacyBehavior: true, children: /*#__PURE__*/
                  (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(Anchor, {
                    href: "#",
                    appearance: "appearance",
                    style: { display: 'block', paddingBottom: '9px' },
                    onClick: onClose, children:

                    item.text }) }) }, i));




          }) }), /*#__PURE__*/

        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(StyledFooter, { children: /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(CancelButton, { onClick: onClose, appearance: "link", children: /*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_6__/* .Trans */ .cC, { id: "settings_modal.secondary_button" }) }) })] }) }));





};

/* harmony default export */ __webpack_exports__["Z"] = (LinksModal);

/***/ }),

/***/ 77495:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31157);
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10842);
/* harmony import */ var _ecosystems_login_LoginForm__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25322);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);





var Form = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__["default"])(_ecosystems_login_LoginForm__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({ displayName: "LoginModal__Form", componentId: "sc-pkvw6j-0" })(["", "{margin-top:0px;}"],
_ecosystems_login_LoginForm__WEBPACK_IMPORTED_MODULE_2__/* .Title */ .D);

















function usePrevious(value) {
  // The ref object is a generic container whose current property is mutable ...
  // ... and can hold any value, similar to an instance property on a class
  var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();

  // Store current value in ref
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    ref.current = value;
  }, [value]); // Only re-run if value changes

  // Return previous value (happens before update in useEffect above)
  return ref.current;
}

var LoginModal = function LoginModal(props) {var _props$children;
  var prevOpenProps = usePrevious(props.open);
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),open = _useState[0],setOpen = _useState[1];

  var closeModal = function closeModal() {
    setOpen(false);
    setTimeout(function () {var _props$onClose;
      // we can delay this until after re-render
      // because onClose is used to clean url params & it slows re-render for some reason
      (_props$onClose = props.onClose) === null || _props$onClose === void 0 ? void 0 : _props$onClose.call(props);
    });
  };

  var closeModalRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(
  typeof props.callBack === 'function' ?
  props.callBack.bind(null, closeModal) :
  null);


  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    // TODO: investigate this `openByDefault`
    var openByDefault = props.openByDefault;
    var timeout;
    if (openByDefault) {
      timeout = setTimeout(function () {
        setOpen(true);
      }, 2000);
    }
    return clearTimeout(timeout);
  }, []);

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    // previously the component relies only on its internal state
    // we watch open props to make component controllable from ouside
    // mainly to support usage in a hook
    if (prevOpenProps !== props.open) {
      setOpen(props.open);
    }
  }, [props.open]);

  var openModal = function openModal() {
    setOpen(true);
  };

  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [/*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_base__WEBPACK_IMPORTED_MODULE_1__/* .Modal */ .u_, {
        open: open,
        handleClose: function handleClose() {
          closeModal();
        }, children: [/*#__PURE__*/


        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_base__WEBPACK_IMPORTED_MODULE_1__/* .Header */ .h4, { handleClose: function handleClose() {return closeModal();} }), /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_base__WEBPACK_IMPORTED_MODULE_1__/* .Body */ .uT, { children: /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Form, {
            message: props.message,
            noRegister: props.noRegister,
            callBack: closeModalRef === null || closeModalRef === void 0 ? void 0 : closeModalRef.current }) })] }), (_props$children =



      props.children) === null || _props$children === void 0 ? void 0 : _props$children.call(props, openModal, closeModal)] }));


};

/* harmony default export */ __webpack_exports__["Z"] = (LoginModal);

/***/ }),

/***/ 10842:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "uT": function() { return /* reexport */ Body; },
  "$_": function() { return /* reexport */ footer; },
  "h4": function() { return /* reexport */ header; },
  "u_": function() { return /* reexport */ Modal; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(31157);
// EXTERNAL MODULE: ./components/layout/Grid.ts
var Grid = __webpack_require__(94007);
// EXTERNAL MODULE: ./components/Icon.tsx
var Icon = __webpack_require__(54444);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./organisms/modals/base/header.tsx





var CloseButton = styled_components_browser_esm["default"].button.withConfig({ displayName: "header__CloseButton", componentId: "sc-174y1rh-0" })(["border:none;padding:0;margin:0 0 0 auto;background:none;cursor:pointer;"]);







var ModalHeader = (0,styled_components_browser_esm["default"])(Grid/* Box */.xu).withConfig({ displayName: "header__ModalHeader", componentId: "sc-174y1rh-1" })(["display:flex;@media (max-width:", "){width:100%;background-color:", ";z-index:11;box-shadow:0 2px 2px 0 ", ";h4{margin:0;}}"],


function (props) {return "".concat(props.theme.viewports.tablet + 1, "px");},

function (_ref) {var backgroundColor = _ref.backgroundColor;return (
    backgroundColor ? backgroundColor : 'white');},


function (props) {return props.theme.colors.neutrals['white-darkest'];});








var Header = function Header(props) {
  return /*#__PURE__*/(
    (0,jsx_runtime.jsxs)(ModalHeader, {
      px: [25, 25, 30],
      py: [25, 25, 30],
      backgroundColor: props.backgroundColor,
      sticky: props.sticky,
      className: props.className, children: [

      props.children,
      !props.noCloseButton && /*#__PURE__*/
      (0,jsx_runtime.jsx)(CloseButton, { type: "button", children:
        props.closeButton ?
        props.closeButton : /*#__PURE__*/

        (0,jsx_runtime.jsx)(Icon/* default */.Z, {
          name: "ygb-icon-close",
          color: props.closeIconColor ? props.closeIconColor : null,
          fontSize: "15px",
          onClick: function onClick() {var _props$handleClose;return props === null || props === void 0 ? void 0 : (_props$handleClose = props.handleClose) === null || _props$handleClose === void 0 ? void 0 : _props$handleClose.call(props);} }) })] }));






};

/* harmony default export */ var header = (Header);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/useTheme.js
var useTheme = __webpack_require__(8920);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Dialog/Dialog.js + 2 modules
var Dialog = __webpack_require__(93579);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(63457);
;// CONCATENATED MODULE: ./organisms/modals/base/footer.tsx




var StyledFooter = styled_components_browser_esm["default"].div.withConfig({ displayName: "footer__StyledFooter", componentId: "sc-1rx3pjz-0" })(["border-top:1px solid ", ";@media (max-width:", "){width:100%;background-color:white;}"],
function (props) {return props.theme.colors.secondary['gray-4'];},

function (props) {return "".concat(props.theme.viewports.tablet + 1, "px");});





var Footer = function Footer(props) {
  return /*#__PURE__*/(
    (0,jsx_runtime.jsx)(Grid/* Box */.xu, {
      className: props.className,
      px: [25, 25, 50],
      py: [10, 15, 25],
      as: StyledFooter, children: /*#__PURE__*/

      (0,jsx_runtime.jsx)(Grid/* Flex */.kC, { justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", children:
        props.children }) }));



};

/* harmony default export */ var footer = (Footer);
;// CONCATENATED MODULE: ./organisms/modals/base/body.tsx
function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,defineProperty/* default */.Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}








var ModalWrapper = styled_components_browser_esm["default"].div.withConfig({ displayName: "body__ModalWrapper", componentId: "sc-oubnv4-0" })(["display:flex;flex-direction:column;@media (min-width:", "){width:", ";margin:0 auto;}"],



function (props) {return "".concat(props.theme.viewports.tablet + 1, "px");},
function (props) {return props.customWidth ? props.customWidth : '600px';});




var StyledDialog = (0,styled_components_browser_esm["default"])(Dialog/* default */.Z).withConfig({ displayName: "body__StyledDialog", componentId: "sc-oubnv4-1" })([".MuiDialog-paper{max-width:100%;}", " transform:translateZ(0);"],




function (props) {return (
    props.fullScreen && "\n    ".concat(

    ModalWrapper, " {\n      max-height: 100vh;\n      height: 100vh;\n      overflow: hidden;\n    }\n  "));});









// IMPLEMENTATION HISTORY
// + ISSUE: BODY SCROLL UNDER THE MODAL ON IOS
// - WE TRIED MAKING THE BODY POSITION:FIXED BUT THAT REQUIRES css.top CHANGING
//   WHICH CREATED AN ISSUE WHERE THE PAGE JUMPS AFTER MODAL IS CLOSED
// - LATEST IMPL: WE JUST RESET SCROLL TO POSITION WHEN MODAL WAS OPENED WHEN EVER WE DETECT A SCROLL ON THE BODY
var preventScroll = function preventScroll(scrollX, scrollY) {return function () {
    window.scrollTo(scrollX, scrollY);
  };};










var Modal = function Modal(props) {
  (0,react.useEffect)(function () {
    if (props.open) {
      var scrollY = window.scrollY;
      var scrollX = window.scrollX;
      var scrollHandler = preventScroll(scrollX, scrollY);
      document.addEventListener('scroll', scrollHandler);

      return function () {
        document.removeEventListener('scroll', scrollHandler);
      };
    }
  }, [props.open]);

  var theme = (0,useTheme/* default */.Z)();
  var fullScreen = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down('sm'));

  if (props.hasOwnProperty('fullScreen')) {
    fullScreen = props.fullScreen;
  }

  return /*#__PURE__*/(
    (0,jsx_runtime.jsx)(StyledDialog, {
      className: props.className,
      open: props.open,
      onClose: props.handleClose,
      fullScreen: fullScreen, children: /*#__PURE__*/

      (0,jsx_runtime.jsx)(ModalWrapper, _objectSpread(_objectSpread({}, props), {}, { className: "ModalWrapper", children:
        props.children })) }));



};

var StyledBody = styled_components_browser_esm["default"].div.withConfig({ displayName: "body__StyledBody", componentId: "sc-oubnv4-2" })(["@media (max-width:", "){flex:1;overflow-y:scroll;}"],
function (props) {return "".concat(props.theme.viewports.tablet + 1, "px");});





var Body = function Body(props) {
  return /*#__PURE__*/(
    (0,jsx_runtime.jsx)(Grid/* Box */.xu, _objectSpread(_objectSpread({ as: StyledBody, px: [25, 25, 50], pt: [20, 20, 0] }, props), {}, { children:
      props.children })));


};
;// CONCATENATED MODULE: ./organisms/modals/base/index.tsx




/***/ }),

/***/ 83761:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ paymentConfirmation_PaymentConfirmationModal; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(31157);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 4 modules
var format = __webpack_require__(42298);
// EXTERNAL MODULE: ./components/layout/Grid.ts
var Grid = __webpack_require__(94007);
// EXTERNAL MODULE: ./organisms/modals/base/index.tsx + 3 modules
var base = __webpack_require__(10842);
// EXTERNAL MODULE: ./organisms/modals/paymentConfirmation/SubscriptionPaymentConfirmation.tsx
var SubscriptionPaymentConfirmation = __webpack_require__(37635);
// EXTERNAL MODULE: ./node_modules/@lingui/react/esm/index.js + 1 modules
var esm = __webpack_require__(85169);
// EXTERNAL MODULE: ./components/buttons.js
var buttons = __webpack_require__(49613);
// EXTERNAL MODULE: ./components/Icon.tsx
var Icon = __webpack_require__(54444);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./organisms/modals/paymentConfirmation/GenericPaymentFailedMessage.tsx







var Title = styled_components_browser_esm["default"].p.withConfig({ displayName: "GenericPaymentFailedMessage__Title", componentId: "sc-1o0tuax-0" })(["font-size:24px;font-weight:600;margin-top:0;"]);





var Description = styled_components_browser_esm["default"].p.withConfig({ displayName: "GenericPaymentFailedMessage__Description", componentId: "sc-1o0tuax-1" })(["display:flex;flex-direction:column;font-size:16px;margin-bottom:50px;span:nth-of-type(2){margin-top:20px;}"]);














var GenericPaymentFailedMessage = function GenericPaymentFailedMessage(_ref) {var onClose = _ref.onClose;
  return /*#__PURE__*/(
    (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [/*#__PURE__*/
      (0,jsx_runtime.jsxs)(base/* Body */.uT, { children: [/*#__PURE__*/
        (0,jsx_runtime.jsx)(Icon/* default */.Z, {
          name: "ygb-icon-cancel",
          fontSize: "40px",
          color: "#FB5A4F",
          style: {
            lineHeight: 1,
            border: '5px solid #FB5A4F',
            borderRadius: '50%',
            padding: '25px',
            margin: '0 auto 20px' } }), /*#__PURE__*/


        (0,jsx_runtime.jsx)(Title, { children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "metadata.paymentfail.title" }) }), /*#__PURE__*/

        (0,jsx_runtime.jsx)(Description, { children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "metadata.payment.failed" }) })] }), /*#__PURE__*/


      (0,jsx_runtime.jsx)(base/* Footer */.$_, { children: /*#__PURE__*/
        (0,jsx_runtime.jsx)(buttons/* default */.ZP, { appearance: "default-blue", onClick: onClose, children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "metadata.close" }) }) })] }));




};
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./lib/constants.tsx
var constants = __webpack_require__(22498);
// EXTERNAL MODULE: ./lib/helpers.ts
var helpers = __webpack_require__(32460);
;// CONCATENATED MODULE: ./organisms/modals/paymentConfirmation/ProgramPaymentConfirmationMessage.tsx











var Buttons = (0,styled_components_browser_esm["default"])(buttons/* default */.ZP).withConfig({ displayName: "ProgramPaymentConfirmationMessage__Buttons", componentId: "sc-v1k1j5-0" })(["margin:0 10px;"]);



var Wrapper = styled_components_browser_esm["default"].div.withConfig({ displayName: "ProgramPaymentConfirmationMessage__Wrapper", componentId: "sc-v1k1j5-1" })(["display:flex;flex-direction:column;text-align:center;"]);





var ProgramPaymentConfirmationMessage_Title = styled_components_browser_esm["default"].p.withConfig({ displayName: "ProgramPaymentConfirmationMessage__Title", componentId: "sc-v1k1j5-2" })(["font-size:18px;font-weight:600;margin:0;"]);





var Text = styled_components_browser_esm["default"].p.withConfig({ displayName: "ProgramPaymentConfirmationMessage__Text", componentId: "sc-v1k1j5-3" })(["font-size:16px;margin:15px 0 0;"]);










var ProgramPaymentConfirmationMessage = function ProgramPaymentConfirmationMessage(props) {
  var router = (0,next_router.useRouter)();
  var _router$query = router === null || router === void 0 ? void 0 : router.query,lang = _router$query.lang;
  var amountCents = props.amountCents,currency = props.currency;

  var onClose = function onClose() {
    (0,helpers/* hideURLParams */.o8)(constants/* PAYMENT_CONFIRMATION_ACTION */.zo);
    props.onClose();
  };

  return /*#__PURE__*/(
    (0,jsx_runtime.jsx)(jsx_runtime.Fragment, { children: /*#__PURE__*/
      (0,jsx_runtime.jsxs)(base/* Body */.uT, { pb: 40, children: [/*#__PURE__*/
        (0,jsx_runtime.jsxs)(Wrapper, { children: [/*#__PURE__*/
          (0,jsx_runtime.jsx)(Icon/* default */.Z, {
            name: "ygb-icon-checkmark",
            fontSize: "24px",
            color: "white",
            style: {
              lineHeight: 1,
              backgroundColor: '#93BDBB',
              borderRadius: '50%',
              padding: '50px',
              margin: '0 auto 20px' } }), /*#__PURE__*/


          (0,jsx_runtime.jsx)(ProgramPaymentConfirmationMessage_Title, { children: /*#__PURE__*/
            (0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "metadata.payment.success.title" }) }), /*#__PURE__*/

          (0,jsx_runtime.jsx)(Text, { children: /*#__PURE__*/
            (0,jsx_runtime.jsx)(esm/* Trans */.cC, {
              id: "programs_2021.program_purchase.confirmation_modal_text",
              values: {
                paymentAmount: "".concat(Math.floor(amountCents / 100).toFixed(
                2), " ").concat(
                currency) } }) })] }), /*#__PURE__*/




        (0,jsx_runtime.jsxs)(Grid/* Flex */.kC, { justifyContent: "center", pt: 40, children: [/*#__PURE__*/
          (0,jsx_runtime.jsx)(Buttons, { href: "#", appearance: "default-blue", onClick: onClose, children: /*#__PURE__*/
            (0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "programs_2021.program_purchase.get_started" }) }), /*#__PURE__*/

          (0,jsx_runtime.jsx)(Buttons, { href: "/".concat(lang, "/me/dashboard"), appearance: "outline", children: /*#__PURE__*/
            (0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "programs_2021.program_purchase.go_dashboard_btn" }) })] })] }) }));





};
// EXTERNAL MODULE: ./lib/contexts/languageContext.js
var languageContext = __webpack_require__(17516);
;// CONCATENATED MODULE: ./organisms/modals/paymentConfirmation/SubscriptionPaymentFailedMessage.tsx










var SubscriptionPaymentFailedMessage_Wrapper = styled_components_browser_esm["default"].div.withConfig({ displayName: "SubscriptionPaymentFailedMessage__Wrapper", componentId: "sc-1wh8e4k-0" })(["display:flex;flex-direction:column;text-align:center;"]);





var SubscriptionPaymentFailedMessage_Title = styled_components_browser_esm["default"].p.withConfig({ displayName: "SubscriptionPaymentFailedMessage__Title", componentId: "sc-1wh8e4k-1" })(["font-size:18px;font-weight:600;margin:0;"]);





var SubscriptionPaymentFailedMessage_Description = styled_components_browser_esm["default"].p.withConfig({ displayName: "SubscriptionPaymentFailedMessage__Description", componentId: "sc-1wh8e4k-2" })(["display:flex;flex-direction:column;font-size:16px;margin-bottom:50px;span:nth-of-type(2){margin-top:20px;}"]);










var SubscriptionPaymentFailedMessage = function SubscriptionPaymentFailedMessage() {
  var lang = (0,react.useContext)(languageContext/* default */.Z);

  return /*#__PURE__*/(
    (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [/*#__PURE__*/
      (0,jsx_runtime.jsx)(base/* Body */.uT, { children: /*#__PURE__*/
        (0,jsx_runtime.jsxs)(SubscriptionPaymentFailedMessage_Wrapper, { children: [/*#__PURE__*/
          (0,jsx_runtime.jsx)(Icon/* default */.Z, {
            name: "ygb-icon-cancel",
            fontSize: "40px",
            color: "#FB5A4F",
            style: {
              lineHeight: 1,
              border: '5px solid #FB5A4F',
              borderRadius: '50%',
              padding: '25px',
              margin: '0 auto 20px' } }), /*#__PURE__*/


          (0,jsx_runtime.jsx)(SubscriptionPaymentFailedMessage_Title, { children: /*#__PURE__*/
            (0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "metadata.paymentfail.title" }) }), /*#__PURE__*/

          (0,jsx_runtime.jsx)(SubscriptionPaymentFailedMessage_Description, { children: /*#__PURE__*/
            (0,jsx_runtime.jsx)(esm/* Trans */.cC, {
              id: "metadata.payment.failed",
              values: { email: constants/* CONTACT_EMAIL */.be } }) })] }) }), /*#__PURE__*/




      (0,jsx_runtime.jsx)(base/* Footer */.$_, { children: /*#__PURE__*/
        (0,jsx_runtime.jsx)(Grid/* Flex */.kC, { flex: 1, my: -10, justifyContent: "flex-end", children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(buttons/* default */.ZP, {
            appearance: "default-blue",
            href: "/".concat(lang, "/subscription/select"), children: /*#__PURE__*/

            (0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "metadata.paymentfail.btn" }) }) }) })] }));





};
// EXTERNAL MODULE: ./components/Spinner.tsx
var Spinner = __webpack_require__(24452);
// EXTERNAL MODULE: ./lib/analytics/manager.ts + 4 modules
var manager = __webpack_require__(88224);
// EXTERNAL MODULE: ./gql/generated/index.tsx
var generated = __webpack_require__(48354);
// EXTERNAL MODULE: ./node_modules/@lingui/core/esm/index.js + 1 modules
var core_esm = __webpack_require__(94471);
;// CONCATENATED MODULE: ./organisms/modals/paymentConfirmation/VoucherPaymentConfirmationModal.tsx











var VoucherPaymentConfirmationModal_Buttons = (0,styled_components_browser_esm["default"])(buttons/* default */.ZP).withConfig({ displayName: "VoucherPaymentConfirmationModal__Buttons", componentId: "sc-8l8426-0" })(["margin:0 10px;"]);



var VoucherPaymentConfirmationModal_Wrapper = styled_components_browser_esm["default"].div.withConfig({ displayName: "VoucherPaymentConfirmationModal__Wrapper", componentId: "sc-8l8426-1" })(["display:flex;flex-direction:column;text-align:center;"]);





var VoucherPaymentConfirmationModal_Title = styled_components_browser_esm["default"].p.withConfig({ displayName: "VoucherPaymentConfirmationModal__Title", componentId: "sc-8l8426-2" })(["font-size:18px;font-weight:600;margin:0;"]);





var VoucherPaymentConfirmationModal_Text = styled_components_browser_esm["default"].p.withConfig({ displayName: "VoucherPaymentConfirmationModal__Text", componentId: "sc-8l8426-3" })(["font-size:16px;margin:15px 0 0;"]);











var VoucherPaymentConfirmationMessage = function VoucherPaymentConfirmationMessage(props) {
  var router = (0,next_router.useRouter)();

  var _router$query = router === null || router === void 0 ? void 0 : router.query,lang = _router$query.lang;

  var amountCents = props.amountCents,currency = props.currency,programCategory = props.programCategory;

  return /*#__PURE__*/(
    (0,jsx_runtime.jsx)(jsx_runtime.Fragment, { children: /*#__PURE__*/
      (0,jsx_runtime.jsxs)(base/* Body */.uT, { pb: 40, children: [/*#__PURE__*/
        (0,jsx_runtime.jsxs)(VoucherPaymentConfirmationModal_Wrapper, { children: [/*#__PURE__*/
          (0,jsx_runtime.jsx)(Icon/* default */.Z, {
            name: "ygb-icon-checkmark",
            fontSize: "24px",
            color: "white",
            style: {
              lineHeight: 1,
              backgroundColor: '#93BDBB',
              borderRadius: '50%',
              padding: '50px',
              margin: '0 auto 20px' } }), /*#__PURE__*/


          (0,jsx_runtime.jsx)(VoucherPaymentConfirmationModal_Title, { children: /*#__PURE__*/
            (0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "metadata.payment.success.title" }) }), /*#__PURE__*/

          (0,jsx_runtime.jsx)(VoucherPaymentConfirmationModal_Text, { children: /*#__PURE__*/
            (0,jsx_runtime.jsx)(esm/* Trans */.cC, {
              id: "programs_2021.buy_gift.confirmation_modal_text",
              values: {
                paymentAmount: "".concat(Math.floor(amountCents / 100).toFixed(
                2), " ").concat(
                currency) } }) })] }), /*#__PURE__*/




        (0,jsx_runtime.jsxs)(Grid/* Flex */.kC, { justifyContent: "center", pt: 40, children: [
          programCategory ? /*#__PURE__*/
          (0,jsx_runtime.jsx)(VoucherPaymentConfirmationModal_Buttons, {
            href: "/".concat(lang, "/").concat(programCategory),
            appearance: "default-blue", children: /*#__PURE__*/

            (0,jsx_runtime.jsx)(esm/* Trans */.cC, {
              id:
              programCategory === generated/* ProgramCategory.Courses */.l92.Courses ? /*i18n*/
              core_esm/* i18n._ */.ag._("programs_2021.buy_gift.go_courses_btn") : /*i18n*/
              core_esm/* i18n._ */.ag._("programs_2021.buy_gift.go_programs_btn") }) }) :



          null, /*#__PURE__*/
          (0,jsx_runtime.jsx)(VoucherPaymentConfirmationModal_Buttons, { href: "/".concat(lang, "/me/dashboard"), appearance: "outline", children: /*#__PURE__*/
            (0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "programs_2021.buy_gift.go_dashboard_btn" }) })] })] }) }));





};
;// CONCATENATED MODULE: ./organisms/modals/paymentConfirmation/PaymentConfirmationModal.tsx
















var StyledModal = (0,styled_components_browser_esm["default"])(base/* Modal */.u_).withConfig({ displayName: "PaymentConfirmationModal__StyledModal", componentId: "sc-eaqhim-0" })(["overflow-y:scroll;.MuiBackdrop-root{display:none;}.MuiDialog-container{position:relative;height:unset;min-height:100vh;}.MuiDialog-paperScrollPaper{max-height:none;}.MuiDialog-container.MuiDialog-scrollPaper:before{content:\"\";position:absolute;left:0;top:0;height:100%;width:100%;background-color:rgba(0,0,0,0.5);}"]);

































var PaymentConfirmationModal = function PaymentConfirmationModal(props) {
  var _props$open = props.open,open = _props$open === void 0 ? false : _props$open,orderId = props.orderId;
  var _useState = (0,react.useState)(open),isOpen = _useState[0],setIsOpen = _useState[1];
  var _useOrderQuery = (0,generated/* useOrderQuery */.OTz)({
    variables: {
      id: orderId } }),data = _useOrderQuery.data,loading = _useOrderQuery.loading;



  var order = data === null || data === void 0 ? void 0 : data.order;
  (0,react.useEffect)(function () {
    //
    if ((order === null || order === void 0 ? void 0 : order.__typename) === 'SubscriptionPayment') {
      if (order.success) {var _data$order, _data$order2;
        (0,manager/* default */.Z)().sendSubscriptionPurchaseCompleteEvent({
          orderId: order.orderId,
          months: order.months,
          amount: Math.floor(((_data$order = data.order) === null || _data$order === void 0 ? void 0 : _data$order.amountCents) / 100),
          original_amount: Math.floor(((_data$order2 = data.order) === null || _data$order2 === void 0 ? void 0 : _data$order2.originalAmountCents) / 100),
          currency: order === null || order === void 0 ? void 0 : order.amountCurrency,
          payment_type: order === null || order === void 0 ? void 0 : order.paymentProvider });

      } else {var _data$order3, _data$order4;
        (0,manager/* default */.Z)().SendSubscriptionPurchaseFailEvent({
          orderId: order.orderId,
          months: order.months,
          amount: Math.floor(((_data$order3 = data.order) === null || _data$order3 === void 0 ? void 0 : _data$order3.amountCents) / 100),
          original_amount: Math.floor(((_data$order4 = data.order) === null || _data$order4 === void 0 ? void 0 : _data$order4.originalAmountCents) / 100),
          currency: order === null || order === void 0 ? void 0 : order.amountCurrency,
          payment_type: order === null || order === void 0 ? void 0 : order.paymentProvider });

      }
    } else if ((order === null || order === void 0 ? void 0 : order.__typename) === 'GenericProgramPayment') {
      if (order.success) {var _order$program, _order$program2, _order$program3, _order$program4, _order$program5, _order$program6, _order$program7, _order$program8, _data$order5, _data$order6;
        (0,manager/* default */.Z)().sendProgramAccessGrantedEvent({
          id: order === null || order === void 0 ? void 0 : (_order$program = order.program) === null || _order$program === void 0 ? void 0 : _order$program.id,
          title: order === null || order === void 0 ? void 0 : (_order$program2 = order.program) === null || _order$program2 === void 0 ? void 0 : _order$program2.title,
          slug: order === null || order === void 0 ? void 0 : (_order$program3 = order.program) === null || _order$program3 === void 0 ? void 0 : _order$program3.slug,
          category: order === null || order === void 0 ? void 0 : (_order$program4 = order.program) === null || _order$program4 === void 0 ? void 0 : _order$program4.category });

        (0,manager/* default */.Z)().sendExtraPaymentCompleteEvent({
          order_id: orderId,
          item_type: order === null || order === void 0 ? void 0 : (_order$program5 = order.program) === null || _order$program5 === void 0 ? void 0 : _order$program5.category,
          id: order === null || order === void 0 ? void 0 : (_order$program6 = order.program) === null || _order$program6 === void 0 ? void 0 : _order$program6.id,
          title: order === null || order === void 0 ? void 0 : (_order$program7 = order.program) === null || _order$program7 === void 0 ? void 0 : _order$program7.title,
          slug: order === null || order === void 0 ? void 0 : (_order$program8 = order.program) === null || _order$program8 === void 0 ? void 0 : _order$program8.slug,
          amount: Math.floor(((_data$order5 = data.order) === null || _data$order5 === void 0 ? void 0 : _data$order5.amountCents) / 100),
          original_amount: Math.floor(((_data$order6 = data.order) === null || _data$order6 === void 0 ? void 0 : _data$order6.originalAmountCents) / 100),
          currency: order === null || order === void 0 ? void 0 : order.amountCurrency,
          payment_type: order === null || order === void 0 ? void 0 : order.paymentProvider,
          voucher_purchase: order === null || order === void 0 ? void 0 : order.voucher });

      } else {var _order$program9, _order$program10, _order$program11, _order$program12, _data$order7, _data$order8;
        (0,manager/* default */.Z)().sendExtraPaymentFailedEvent({
          order_id: orderId,
          item_type: order === null || order === void 0 ? void 0 : (_order$program9 = order.program) === null || _order$program9 === void 0 ? void 0 : _order$program9.category,
          id: order === null || order === void 0 ? void 0 : (_order$program10 = order.program) === null || _order$program10 === void 0 ? void 0 : _order$program10.id,
          title: order === null || order === void 0 ? void 0 : (_order$program11 = order.program) === null || _order$program11 === void 0 ? void 0 : _order$program11.title,
          slug: order === null || order === void 0 ? void 0 : (_order$program12 = order.program) === null || _order$program12 === void 0 ? void 0 : _order$program12.slug,
          amount: Math.floor(((_data$order7 = data.order) === null || _data$order7 === void 0 ? void 0 : _data$order7.amountCents) / 100),
          original_amount: Math.floor(((_data$order8 = data.order) === null || _data$order8 === void 0 ? void 0 : _data$order8.originalAmountCents) / 100),
          currency: order === null || order === void 0 ? void 0 : order.amountCurrency,
          payment_type: order === null || order === void 0 ? void 0 : order.paymentProvider,
          voucher_purchase: order === null || order === void 0 ? void 0 : order.voucher });

      }
    }
  }, [order === null || order === void 0 ? void 0 : order.orderId]);

  var onClose = function onClose() {
    setIsOpen(false);
    (0,helpers/* hideURLParams */.o8)(constants/* PAYMENT_CONFIRMATION_ACTION */.zo);
  };

  var content = null;
  if ((order === null || order === void 0 ? void 0 : order.__typename) === 'SubscriptionPayment') {
    if (order !== null && order !== void 0 && order.success) {
      content = /*#__PURE__*/
      (0,jsx_runtime.jsx)(SubscriptionPaymentConfirmation/* default */.Z, {
        currency: order === null || order === void 0 ? void 0 : order.amountCurrency,
        months: order === null || order === void 0 ? void 0 : order.months,
        paymentAmount: Math.floor((order === null || order === void 0 ? void 0 : order.amountCents) / 100),
        recurringPaymentAmount: Math.floor((order === null || order === void 0 ? void 0 : order.recurringAmountCents) / 100),
        recurringDate: (0,format/* default */.Z)(new Date(order === null || order === void 0 ? void 0 : order.recurringDate), 'MMM dd yyyy'),
        onClose: onClose });


    } else {
      content = /*#__PURE__*/(0,jsx_runtime.jsx)(SubscriptionPaymentFailedMessage, {});
    }
  } else if ((order === null || order === void 0 ? void 0 : order.__typename) === 'GenericProgramPayment') {
    if (order !== null && order !== void 0 && order.success) {
      if (order !== null && order !== void 0 && order.voucher) {
        content = /*#__PURE__*/
        (0,jsx_runtime.jsx)(VoucherPaymentConfirmationMessage, {
          onClose: onClose,
          amountCents: order === null || order === void 0 ? void 0 : order.amountCents,
          currency: order.amountCurrency,
          programCategory: order === null || order === void 0 ? void 0 : order.program.category });


      } else {
        content = /*#__PURE__*/
        (0,jsx_runtime.jsx)(ProgramPaymentConfirmationMessage, {
          amountCents: order === null || order === void 0 ? void 0 : order.amountCents,
          currency: order === null || order === void 0 ? void 0 : order.amountCurrency,
          onClose: onClose });


      }
    } else {
      content = /*#__PURE__*/(0,jsx_runtime.jsx)(GenericPaymentFailedMessage, { onClose: onClose });
    }
  } else {
    return null;
  }

  return isOpen ? /*#__PURE__*/
  (0,jsx_runtime.jsxs)(StyledModal, { open: isOpen, handleClose: onClose, children: [/*#__PURE__*/
    (0,jsx_runtime.jsx)(base/* Header */.h4, { handleClose: onClose }),
    loading ? /*#__PURE__*/
    (0,jsx_runtime.jsx)(Grid/* Flex */.kC, { aligContent: "center", children: /*#__PURE__*/
      (0,jsx_runtime.jsx)(Spinner/* default */.Z, { size: 24 }) }) :

    null,
    content] }) :

  null;
};

/* harmony default export */ var paymentConfirmation_PaymentConfirmationModal = (PaymentConfirmationModal);

/***/ }),

/***/ 37635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _lingui_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(94471);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(31157);
/* harmony import */ var _components_Icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54444);
/* harmony import */ var _lingui_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(85169);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(42298);
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10842);
/* harmony import */ var _lib_contexts_languageContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17516);
/* harmony import */ var _components_buttons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(49613);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);











var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_7__["default"].div.withConfig({ displayName: "SubscriptionPaymentConfirmation__Wrapper", componentId: "sc-719keb-0" })(["display:flex;flex-direction:column;text-align:center;"]);





var Title = styled_components__WEBPACK_IMPORTED_MODULE_7__["default"].p.withConfig({ displayName: "SubscriptionPaymentConfirmation__Title", componentId: "sc-719keb-1" })(["font-size:18px;font-weight:600;margin:0;"]);





var Text = styled_components__WEBPACK_IMPORTED_MODULE_7__["default"].p.withConfig({ displayName: "SubscriptionPaymentConfirmation__Text", componentId: "sc-719keb-2" })(["font-size:16px;margin:15px 0 0;"]);




var SUBSCRIPTIONS_LABELS = {
  1: /*i18n*/_lingui_core__WEBPACK_IMPORTED_MODULE_8__/* .i18n._ */ .ag._("settings_subscriptions.monthly"),
  3: /*i18n*/_lingui_core__WEBPACK_IMPORTED_MODULE_8__/* .i18n._ */ .ag._("settings_subscriptions.quarterly"),
  12: /*i18n*/_lingui_core__WEBPACK_IMPORTED_MODULE_8__/* .i18n._ */ .ag._("settings_subscriptions.annually") };


/*
  THIS IS AN ABSTRACTION THAT IS USED BY TWO COMPONENTS (PaymentConfirmationModal & AdyenDropinModalHook)
*/

var PaymentConfirmationMessage = function PaymentConfirmationMessage(_ref)






{var currency = _ref.currency,months = _ref.months,paymentAmount = _ref.paymentAmount,recurringPaymentAmount = _ref.recurringPaymentAmount,recurringDate = _ref.recurringDate,onClose = _ref.onClose;
  var lang = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_lib_contexts_languageContext__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z);

  var nextPaymentDate;
  try {
    nextPaymentDate = (0,date_fns__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(new Date(recurringDate), 'd MMMM yyyy');
  } catch (ex) {
    // prevent crashing
    return null;
  }

  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, { children: [/*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_base__WEBPACK_IMPORTED_MODULE_3__/* .Body */ .uT, { pb: 40, children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(Wrapper, { children: [/*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            name: "ygb-icon-checkmark",
            fontSize: "24px",
            color: "white",
            style: {
              lineHeight: 1,
              backgroundColor: '#93BDBB',
              borderRadius: '50%',
              padding: '50px',
              margin: '0 auto 20px' } }), /*#__PURE__*/


          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(Title, { children: /*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_10__/* .Trans */ .cC, { id: "metadata.payment.success.title" }) }), /*#__PURE__*/

          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(Text, { children: /*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_10__/* .Trans */ .cC, {
              id: "paymentconfirmation_subscription.modal.body",
              values: {
                paymentAmount: "".concat(paymentAmount, " ").concat(currency),
                subscriptionType: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_10__/* .Trans */ .cC, { id: SUBSCRIPTIONS_LABELS[months] }),
                recurringPaymentAmount: "".concat(recurringPaymentAmount, " ").concat(currency),
                recurringDate: nextPaymentDate } }) })] }) }), /*#__PURE__*/





      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(_base__WEBPACK_IMPORTED_MODULE_3__/* .Footer */ .$_, { children: [/*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
          href: "/[lang]/me/settings/receipts",
          as: "/".concat(lang, "/me/settings/receipts"),
          legacyBehavior: true, children: /*#__PURE__*/

          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_buttons__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, { appearance: "link", as: "a", children: /*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_10__/* .Trans */ .cC, { id: "metadata.payment.success.receipt_button" }) }) }), /*#__PURE__*/


        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_buttons__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, { onClick: onClose, children: /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_10__/* .Trans */ .cC, { id: "metadata.payment.success.continue_button" }) })] })] }));




};

/* harmony default export */ __webpack_exports__["Z"] = (PaymentConfirmationMessage);

/***/ }),

/***/ 70989:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(17674);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(92777);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(82262);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(10748);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/get.js + 1 modules
var get = __webpack_require__(74450);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(81531);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(63553);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(37247);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/app.js
var app = __webpack_require__(7544);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@sentry/hub/esm/exports.js
var esm_exports = __webpack_require__(92876);
// EXTERNAL MODULE: ./node_modules/@sentry/react/esm/errorboundary.js
var errorboundary = __webpack_require__(24975);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(31157);
;// CONCATENATED MODULE: ./components/layout/Layout.js


var Main = styled_components_browser_esm["default"].main.withConfig({ displayName: "Layout__Main", componentId: "sc-1lu4n8e-0" })(["width:100%;display:flex;flex-direction:column;"]);
// EXTERNAL MODULE: ./ecosystems/banner/index.js + 4 modules
var banner = __webpack_require__(94371);
// EXTERNAL MODULE: ./components/Icon.tsx
var Icon = __webpack_require__(54444);
// EXTERNAL MODULE: ./components/layout/Grid.ts
var Grid = __webpack_require__(94007);
// EXTERNAL MODULE: ./lib/theme.ts
var theme = __webpack_require__(62594);
// EXTERNAL MODULE: ./skeletons/BaseSkeleton.tsx
var BaseSkeleton = __webpack_require__(30794);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./skeletons/UserLoadingSkeleton.js





var Avatar = (0,styled_components_browser_esm["default"])(BaseSkeleton/* default */.Z).withConfig({ displayName: "UserLoadingSkeleton__Avatar", componentId: "sc-zxohuc-0" })(["border-radius:50%;width:40px;height:40px;"]);





var FirstName = (0,styled_components_browser_esm["default"])(BaseSkeleton/* default */.Z).withConfig({ displayName: "UserLoadingSkeleton__FirstName", componentId: "sc-zxohuc-1" })(["height:13px;width:", ";display:inline-block;margin-right:10px;"],

function (props) {return props.width ? "".concat(props.width, "px") : '50px';});




var UserLoadingSkeleton = function UserLoadingSkeleton() {return /*#__PURE__*/(
    (0,jsx_runtime.jsxs)(Grid/* Flex */.kC, { children: [/*#__PURE__*/
      (0,jsx_runtime.jsxs)(Grid/* Box */.xu, { as: Grid/* ShowInMediumUp */.vR, children: [/*#__PURE__*/
        (0,jsx_runtime.jsx)(FirstName, {}), " ", /*#__PURE__*/(0,jsx_runtime.jsx)(FirstName, { width: 30 })] }), /*#__PURE__*/

      (0,jsx_runtime.jsx)(Grid/* Box */.xu, { children: /*#__PURE__*/
        (0,jsx_runtime.jsx)(Avatar, {}) })] }));};




/* harmony default export */ var skeletons_UserLoadingSkeleton = (UserLoadingSkeleton);
;// CONCATENATED MODULE: ./ecosystems/navigations/header/subcomponents.ts


var Column = styled_components_browser_esm["default"].div.withConfig({ displayName: "subcomponents__Column", componentId: "sc-1ml4m4b-0" })(["flex:1;color:black;text-align:center;line-height:40px;"]);






var Wrapper = styled_components_browser_esm["default"].div.withConfig({ displayName: "subcomponents__Wrapper", componentId: "sc-1ml4m4b-1" })(["position:relative;display:flex;align-items:center;padding:18px 15px;background:white;z-index:21;:after{content:'';display:block;width:100%;height:100%;position:absolute;top:0;left:0;background-color:white;}@media (min-width:", "){padding-left:20px;padding-right:20px;:after{content:none;}}"],


















function (props) {return "".concat(props.theme.viewports.tablet, "px");});









var Nav = (0,styled_components_browser_esm["default"])(Column).withConfig({ displayName: "subcomponents__Nav", componentId: "sc-1ml4m4b-2" })(["text-align:left;& > ul{justify-content:space-between;display:flex;list-style-type:none;margin:0;padding:0;vertical-align:top;flex-wrap:nowrap;padding-right:20%;max-width:580px;& > li{vertical-align:middle;margin:0;padding:0;flex:0 0 auto;line-height:1;&:last-child{margin-right:0;}& > a{display:block;padding:0 3px;font-size:13px;font-weight:600;text-transform:none;text-decoration:none;}}}.tabletDown{display:none;}@media (max-width:", "){flex:0 auto;.tabletDown{display:flex;padding-right:0;li > a{margin-right:18px;}}.tabletUp{display:none;}}"],

































function (props) {return "".concat(props.theme.viewports.laptop, "px");});














var Logo = (0,styled_components_browser_esm["default"])(Column).withConfig({ displayName: "subcomponents__Logo", componentId: "sc-1ml4m4b-3" })(["flex:0 0 auto;z-index:1;i:before{font-size:15px;}@media (min-width:", "px){i:before{font-size:20px;}}"],







function (_ref) {var theme = _ref.theme;return theme.viewports.mobile;});






var User = (0,styled_components_browser_esm["default"])(Column).withConfig({ displayName: "subcomponents__User", componentId: "sc-1ml4m4b-4" })(["display:flex;justify-content:flex-end;align-items:center;text-align:right;margin-left:20px;z-index:1;"]);








var SearchComp = {
  Wrapper: styled_components_browser_esm["default"].div.withConfig({ displayName: "subcomponents__Wrapper", componentId: "sc-1ml4m4b-5" })(["display:", ";position:absolute;left:100%;right:0;bottom:", ";top:", ";height:", ";", ";"],
  function (props) {return props.isMobile ? 'none' : 'flex';},



  function (props) {return props.isMobile ? null : '0';},
  function (props) {return props.isMobile ? '100%' : '0';},
  function (props) {return props.isMobile ? '50px' : null;},
  function (props) {return (
      props.isMobile ? "\n      @media (max-width: ".concat(

      props.theme.viewports.tablet, "px) {\n        display: flex;\n        left: 0%;\n      }\n      .search-icon {\n        left: 25px;\n      }\n      .search-close-icon {\n        display: none;\n      }\n      .search-close-icon,\n      .search-icon,\n      .search-input {\n        line-height: 50px;\n      }\n      .search-input {\n        box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n        border-top: 1px solid rgba(0, 0, 0, 0.05);\n      }\n    ") :



















      null);}),

  Input: styled_components_browser_esm["default"].input.withConfig({ displayName: "subcomponents__Input", componentId: "sc-1ml4m4b-6" })(["background:white;border:0;height:100%;width:100%;top:0;left:0;right:0;bottom:0;position:absolute;padding-left:70px;margin:0;font-size:16px;&:focus{border:0;outline:none;-webkit-box-shadow:none;box-shadow:none;}&::-webkit-search-cancel-button{display:none;}"]),






















  IconWrapper: styled_components_browser_esm["default"].div.withConfig({ displayName: "subcomponents__IconWrapper", componentId: "sc-1ml4m4b-7" })(["flex:0 0 auto;cursor:pointer;@media (max-width:", "){margin-left:10px;}", ";"],


  function (props) {return "".concat(props.theme.viewports.tablet, "px");},


  '' /* @media (max-width: ${props => `${props.theme.viewports.tablet}px`}) {
  display: none;
  } */),

  Icon: styled_components_browser_esm["default"].div.withConfig({ displayName: "subcomponents__Icon", componentId: "sc-1ml4m4b-8" })(["cursor:pointer;pointer-events:none;left:30px;position:absolute;line-height:76px;z-index:3;"]),







  CloseIcon: styled_components_browser_esm["default"].div.withConfig({ displayName: "subcomponents__CloseIcon", componentId: "sc-1ml4m4b-9" })(["opacity:0.5;position:absolute;right:30px;line-height:76px;z-index:3;cursor:pointer;"]) };









var Transform = styled_components_browser_esm["default"].div.withConfig({ displayName: "subcomponents__Transform", componentId: "sc-1ml4m4b-10" })(["transition:all ease-in 1s;"]);



var Login = {
  Wrapper: styled_components_browser_esm["default"].div.withConfig({ displayName: "subcomponents__Wrapper", componentId: "sc-1ml4m4b-11" })(["display:flex;margin-left:auto;@media (max-width:", "){margin-right:0;}.loginCTA{padding:8px 12px 8px 0;}@media (min-width:", "){.loginCTA{padding:8px 12px;}}"],



  function (props) {return "".concat(props.theme.viewports.tablet, "px");},











  function (props) {return "".concat(props.theme.viewports.mobile, "px");}),













  AvatarWrapper: styled_components_browser_esm["default"].div.withConfig({ displayName: "subcomponents__AvatarWrapper", componentId: "sc-1ml4m4b-12" })(["display:flex;align-items:center;cursor:pointer;padding:0px 5px;border-radius:5px;transition:background-color 100ms ease-in;&:hover{background-color:", ";}margin-left:20px;@media (max-width:", "){margin-right:0;}flex:0 auto;"],







  function (props) {return (
      props.theme.colors.neutrals['white-darkest']);},


  function (props) {return "".concat(props.theme.viewports.tablet, "px");}),




  Avatar: styled_components_browser_esm["default"].img.withConfig({ displayName: "subcomponents__Avatar", componentId: "sc-1ml4m4b-13" })(["display:inline-block;height:40px;width:40px;vertical-align:middle;border:2px solid ", ";border-radius:50%;margin-left:10px;margin-bottom:0;background-size:cover;background-color:#eeeeee;background-position:center center;cursor:pointer;"],




  function (_ref2) {var theme = _ref2.theme;return theme.colors.primary['blue-1'];}) };










var Button = styled_components_browser_esm["default"].a.withConfig({ displayName: "subcomponents__Button", componentId: "sc-1ml4m4b-14" })(["flex:1 0 auto;border-radius:3px;background:#56b9e5;font-size:13px;padding:8px 12px;margin:0;color:#ffffff;line-height:24px;white-space:nowrap;text-transform:capitalize;text-decoration:none;cursor:pointer;&:hover,&:active{background:#56b9e5;}", ";"],


















function (props) {return (
    props.link ? "background: transparent;\n        color: #242424;\n        font-weight: 600;\n        margin-right: 10px;\n        &:hover {\n          background: #dedede;\n        }" :







    '');});


var SuggestionsLayerCmp = styled_components_browser_esm["default"].div.withConfig({ displayName: "subcomponents__SuggestionsLayerCmp", componentId: "sc-1ml4m4b-15" })(["display:block;position:absolute;left:0;right:0;top:100%;padding:0;border-top:1px solid #dedede;padding-top:10px;padding-bottom:10px;background:white;padding-left:60px;box-shadow:0 1px 2px 0 rgba(0,0,0,0.05);max-height:250px;overflow-x:scroll;"]);
















var SuggestionsLayerItemCmp = styled_components_browser_esm["default"].div.withConfig({ displayName: "subcomponents__SuggestionsLayerItemCmp", componentId: "sc-1ml4m4b-16" })(["display:block;padding:15px 10px;cursor:pointer;font-size:16px;.highlight{font-weight:bold;color:black;}"]);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isPast/index.js
var isPast = __webpack_require__(33913);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/KeyboardArrowUp.js
var KeyboardArrowUp = __webpack_require__(25281);
// EXTERNAL MODULE: ./components/Divider.js
var Divider = __webpack_require__(48740);
// EXTERNAL MODULE: ./lib/contexts/languageContext.js
var languageContext = __webpack_require__(17516);
// EXTERNAL MODULE: ./node_modules/@lingui/react/esm/index.js + 1 modules
var esm = __webpack_require__(85169);
// EXTERNAL MODULE: ./organisms/modals/LoginModal.tsx
var LoginModal = __webpack_require__(77495);
// EXTERNAL MODULE: ./gql/generated/index.tsx
var generated = __webpack_require__(48354);
// EXTERNAL MODULE: ./lib/hooks/useFlags.tsx
var useFlags = __webpack_require__(55932);
;// CONCATENATED MODULE: ./ecosystems/navigations/header/UserLogin.tsx
var _excluded = ["action", "to", "lang"];function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,defineProperty/* default */.Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}














var Menu = styled_components_browser_esm["default"].div.withConfig({ displayName: "UserLogin__Menu", componentId: "sc-1fyxswi-0" })(["position:absolute;top:100%;right:20px;display:flex;flex-direction:column;text-align:left;background-color:white;box-shadow:0px 5px 5px -3px rgb(0 0 0 / 20%),0px 8px 10px 1px rgb(0 0 0 / 14%),0px 3px 14px 2px rgb(0 0 0 / 12%);opacity:0;z-index:-1;pointer-events:none;transform:scale(0.7);transform-origin:top right;transition:opacity 331ms cubic-bezier(0.4,0,0.2,1) 0ms,transform 220ms cubic-bezier(0.4,0,0.2,1) 0ms;", ";"],

















function (_ref) {var open = _ref.open;
  return open ? "\n        z-index: 999;\n        opacity: 1;\n        pointer-events: initial;\n        transform: scale(1);\n      " :






  '';
});


var MenuItem = (0,styled_components_browser_esm["default"])((link_default())).withConfig({ displayName: "UserLogin__MenuItem", componentId: "sc-1fyxswi-1" })(["min-width:230px;display:flex;align-items:center;color:", ";font-size:14px;line-height:1;text-decoration:none;padding:20px 30px;:hover{background-color:rgba(0,0,0,0.04);}"],



function (_ref2) {var theme = _ref2.theme;return theme.colors.neutrals.black;});










var HeaderMenuItem = (0,styled_components_browser_esm["default"])(MenuItem).withConfig({ displayName: "UserLogin__HeaderMenuItem", componentId: "sc-1fyxswi-2" })(["justify-content:space-between;padding:20px 30px;background-color:white;cursor:pointer;"]);






var FooterMenuItem = (0,styled_components_browser_esm["default"])(HeaderMenuItem).withConfig({ displayName: "UserLogin__FooterMenuItem", componentId: "sc-1fyxswi-3" })(["padding:18px 30px;"]);



var UpIcon = (0,styled_components_browser_esm["default"])(KeyboardArrowUp/* default */.Z).withConfig({ displayName: "UserLogin__UpIcon", componentId: "sc-1fyxswi-4" })(["&&{max-width:24px;max-height:24px;color:", ";transform:rotate3d(1,0,0,180deg);transition:transform 500ms ease;", "}"],



function (_ref3) {var theme = _ref3.theme;return theme.colors.primary['blue-1'];},


function (props) {return props.open ? 'transform: rotate3d(1, 0, 0, 0deg);' : '';});



var BlueLabel = styled_components_browser_esm["default"].span.withConfig({ displayName: "UserLogin__BlueLabel", componentId: "sc-1fyxswi-5" })(["&&&{width:auto;color:", ";font-weight:600;cursor:pointer;}"],



function (_ref4) {var theme = _ref4.theme;return theme.colors.primary['blue-1'];});





var PlanLabel = styled_components_browser_esm["default"].span.withConfig({ displayName: "UserLogin__PlanLabel", componentId: "sc-1fyxswi-6" })(["margin-right:20px;"]);



var NewTag = styled_components_browser_esm["default"].span.withConfig({ displayName: "UserLogin__NewTag", componentId: "sc-1fyxswi-7" })(["font-size:11px;color:#fff;font-weight:500;border-radius:3px;padding:5px;margin-left:8px;background-color:rgb(18,158,220);"]);









var MenuDropdown = function MenuDropdown(_ref5) {var locale = _ref5.locale,onItemClick = _ref5.onItemClick;
  var _useFlags = (0,useFlags/* default */.ZP)(),_useFlags2 = (0,slicedToArray/* default */.Z)(_useFlags, 2),flags = _useFlags2[0],loading = _useFlags2[1].loading;

  var links = [
  {
    link: "/".concat(locale, "/me/dashboard"),
    text: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "userlogin.my_dashboard" }) },

  {
    link: "/".concat(locale, "/me/favorites/videos"),
    text: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "userlogin.my_favorites" }) },

  {
    link: "/".concat(locale, "/me/playlists"),
    text: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "userlogin.my_playlists" }) },

  {
    link: "/".concat(locale, "/me/settings/profile"),
    text: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "userlogin.settings" }) },

  {
    link: "/".concat(locale, "/me/settings/subscriptions"),
    text: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "userlogin.my_subscription" }) }];



  if (!flags.disable_dashboard_stats && !loading) {
    links.push({
      link: "/".concat(locale, "/me/statistics"),
      text: /*#__PURE__*/
      (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [/*#__PURE__*/
        (0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "userlogin.my_stats" }), /*#__PURE__*/
        (0,jsx_runtime.jsx)(NewTag, { children: "New" })] }) });



  }

  return /*#__PURE__*/(
    (0,jsx_runtime.jsx)(jsx_runtime.Fragment, { children:
      links.map(function (item, i) {
        return /*#__PURE__*/(
          (0,jsx_runtime.jsx)(MenuItem, { href: item.link, onClick: onItemClick, children:
            item.text }, i));


      }) }));


};





var getHeaderItems = function getHeaderItems(currentUser, locale) {var _currentUser$subscrip, _currentUser$subscrip2, _currentUser$subscrip3, _currentUser$subscrip4;
  if (!(currentUser !== null && currentUser !== void 0 && currentUser.id)) {
    return [];
  }

  var expirationDate = currentUser.accessUntil;
  var hasWellness = currentUser === null || currentUser === void 0 ? void 0 : currentUser.hasWellness;
  var expired = expirationDate ? (0,isPast/* default */.Z)(new Date(expirationDate)) : true;

  var link = {
    link: {
      href: '/[lang]/me/settings/subscriptions',
      as: "/".concat(locale, "/me/settings/subscriptions") },

    text: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "userlogin.menu.manage" }) };


  var text;
  if (hasWellness && !expired) {
    text = /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "userlogin.menu.free_premium" });
    return [text, link];
  } else if (
  currentUser !== null && currentUser !== void 0 && (_currentUser$subscrip = currentUser.subscription) !== null && _currentUser$subscrip !== void 0 && (_currentUser$subscrip2 = _currentUser$subscrip.currentSubscriptionPlan) !== null && _currentUser$subscrip2 !== void 0 && _currentUser$subscrip2.planType.includes(
  'trial') ||

  (currentUser === null || currentUser === void 0 ? void 0 : (_currentUser$subscrip3 = currentUser.subscription) === null || _currentUser$subscrip3 === void 0 ? void 0 : (_currentUser$subscrip4 = _currentUser$subscrip3.currentSubscriptionPlan) === null || _currentUser$subscrip4 === void 0 ? void 0 : _currentUser$subscrip4.planType) === 'free_plan')
  {
    // assign text depending on the expiration state
    if (expired) {
      text = /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "userlogin.menu.no_plan" });
    } else {
      text = /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "userlogin.menu.free_trial" });
    }
    link.text = /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "userlogin.menu.upgrade" });

    return [text, link];
  } else {var _currentUser$subscrip5, _currentUser$subscrip6, _currentUser$subscrip9;
    var previousPlan =
    currentUser === null || currentUser === void 0 ? void 0 : (_currentUser$subscrip5 = currentUser.subscription) === null || _currentUser$subscrip5 === void 0 ? void 0 : (_currentUser$subscrip6 = _currentUser$subscrip5.currentSubscriptionPlan) === null || _currentUser$subscrip6 === void 0 ? void 0 : _currentUser$subscrip6.planType;
    if (expired) {var _currentUser$subscrip7, _currentUser$subscrip8;
      text = /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "userlogin.menu.expired_plan" });
      link.text = /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "userlogin.menu.renew" });
      // only send to payment page if user has plan already
      if (
      ['monthly', 'yearly', 'quarterly'].includes(
      currentUser === null || currentUser === void 0 ? void 0 : (_currentUser$subscrip7 = currentUser.subscription) === null || _currentUser$subscrip7 === void 0 ? void 0 : (_currentUser$subscrip8 = _currentUser$subscrip7.currentSubscriptionPlan) === null || _currentUser$subscrip8 === void 0 ? void 0 : _currentUser$subscrip8.planType))

      {
        link.link = {
          href: {
            pathname: '/[lang]/subscription/[step]',
            query: { paymentType: previousPlan } },

          as: "/".concat(locale, "/subscription/select") };

      }
    } else if (
    (currentUser === null || currentUser === void 0 ? void 0 : (_currentUser$subscrip9 = currentUser.subscription) === null || _currentUser$subscrip9 === void 0 ? void 0 : _currentUser$subscrip9.status) === generated/* SubscriptionStatus.Cancelled */.yhH.Cancelled)
    {
      text = /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "userlogin.menu.cancelled_plan" });
      link.text = /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "userlogin.menu.renew" });
      link.link = {
        href: {
          pathname: '/[lang]/subscription/[step]',
          query: { paymentType: previousPlan } },

        as: "/".concat(locale, "/subscription/select?paymentType=").concat(previousPlan) };

    } else {var _currentUser$subscrip10, _currentUser$subscrip11, _currentUser$subscrip12, _currentUser$subscrip13, _currentUser$subscrip14, _currentUser$subscrip15;
      if (
      currentUser !== null && currentUser !== void 0 && (_currentUser$subscrip10 = currentUser.subscription) !== null && _currentUser$subscrip10 !== void 0 && (_currentUser$subscrip11 = _currentUser$subscrip10.currentSubscriptionPlan) !== null && _currentUser$subscrip11 !== void 0 && _currentUser$subscrip11.planType.includes(
      'monthly'))

      {
        text = /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "userlogin.menu.monthly_plan" });
      } else if (
      currentUser !== null && currentUser !== void 0 && (_currentUser$subscrip12 = currentUser.subscription) !== null && _currentUser$subscrip12 !== void 0 && (_currentUser$subscrip13 = _currentUser$subscrip12.currentSubscriptionPlan) !== null && _currentUser$subscrip13 !== void 0 && _currentUser$subscrip13.planType.includes(
      'quarterly'))

      {
        text = /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "userlogin.menu.quarterly_plan" });
      } else if (
      currentUser !== null && currentUser !== void 0 && (_currentUser$subscrip14 = currentUser.subscription) !== null && _currentUser$subscrip14 !== void 0 && (_currentUser$subscrip15 = _currentUser$subscrip14.currentSubscriptionPlan) !== null && _currentUser$subscrip15 !== void 0 && _currentUser$subscrip15.planType.includes(
      'yearly'))

      {
        text = /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "userlogin.menu.yearly_plan" });
      } else {
        text = /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "userlogin.menu.premium_plan" });
      }
    }

    return [text, link];
  }
};

var UserLogin = function UserLogin(props) {var _currentUser$profile, _currentUser$assets, _currentUser$assets$a, _currentUser$assets$a2;
  var locale = (0,react.useContext)(languageContext/* default */.Z);
  var anchorEl = (0,react.useRef)(null);
  var router = (0,next_router.useRouter)();
  var _useState = (0,react.useState)(false),open = _useState[0],setOpen = _useState[1];

  (0,react.useEffect)(function () {
    if (router.query.action === 'login') {
      props.openLoginModal();
    }
    // we abserve query.action because in test mode we do frontend redirect
  }, [router.query.action]);

  var handleClick = function handleClick() {
    setOpen(!open);
    if (open) {
      props.closeMenuLayer();
    }
  };

  var handleClose = function handleClose() {
    setOpen(false);
  };

  var handleGlobalClick = (0,react.useCallback)(
  function (e) {
    setOpen(function (open) {
      if (open && !anchorEl.current.contains(e.target)) {
        return false;
      }

      return open;
    });
  },
  [open, anchorEl.current]);


  (0,react.useEffect)(function () {
    window.addEventListener('click', handleGlobalClick);

    return function () {
      setOpen(false);
      window.removeEventListener('click', handleGlobalClick);
    };
  }, []);

  var isAuthenticated = props.isAuthenticated,currentUser = props.currentUser;

  var _getHeaderItems = getHeaderItems(currentUser, locale),_getHeaderItems2 = (0,slicedToArray/* default */.Z)(_getHeaderItems, 2),planLabel = _getHeaderItems2[0],actionButton = _getHeaderItems2[1];

  return isAuthenticated ? /*#__PURE__*/
  (0,jsx_runtime.jsxs)("div", { ref: anchorEl, children: [/*#__PURE__*/
    (0,jsx_runtime.jsxs)(Login.AvatarWrapper, { onClick: handleClick, children: [
      currentUser && (
      currentUser.firstName ?
      currentUser.firstName : (_currentUser$profile =
      currentUser.profile) === null || _currentUser$profile === void 0 ? void 0 : _currentUser$profile.displayName), /*#__PURE__*/
      (0,jsx_runtime.jsx)(Login.Avatar, {
        src:
        currentUser !== null && currentUser !== void 0 && (_currentUser$assets = currentUser.assets) !== null && _currentUser$assets !== void 0 && (_currentUser$assets$a = _currentUser$assets.avatar) !== null && _currentUser$assets$a !== void 0 && (_currentUser$assets$a2 = _currentUser$assets$a.includes) !== null && _currentUser$assets$a2 !== void 0 && _currentUser$assets$a2.call(_currentUser$assets$a, 'missing.png') ?
        '/static/profile-placeholder.svg' :
        currentUser.assets.avatar }), /*#__PURE__*/


      (0,jsx_runtime.jsx)(UpIcon, { open: open })] }), /*#__PURE__*/

    (0,jsx_runtime.jsxs)(Menu, { open: open, children: [

      actionButton ? /*#__PURE__*/
      (0,jsx_runtime.jsxs)(HeaderMenuItem, { href: actionButton.link.as, onClick: handleClose, children: [/*#__PURE__*/
        (0,jsx_runtime.jsx)(PlanLabel, { children: planLabel }), /*#__PURE__*/
        (0,jsx_runtime.jsx)(BlueLabel, { children: actionButton.text })] }) :

      null, /*#__PURE__*/
      (0,jsx_runtime.jsx)(Divider/* default */.Z, {}), /*#__PURE__*/
      (0,jsx_runtime.jsx)(MenuDropdown, { locale: locale, onItemClick: handleClick }), /*#__PURE__*/
      (0,jsx_runtime.jsx)(Divider/* default */.Z, {}), /*#__PURE__*/
      (0,jsx_runtime.jsx)(FooterMenuItem, {
        href: "/logout",
        onClick: function onClick(e) {
          e.preventDefault();
          window.location.href = '/logout';
        }, children: /*#__PURE__*/

        (0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "userlogin.logout", message: "Log out" }) })] })] }) : /*#__PURE__*/




  (0,jsx_runtime.jsxs)(Login.Wrapper, { children: [/*#__PURE__*/
    (0,jsx_runtime.jsx)(Button, { className: "loginCTA", link: true, onClick: props.openLoginModal, children: /*#__PURE__*/
      (0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "header.login", message: "login" }) }), /*#__PURE__*/

    (0,jsx_runtime.jsx)(Button, { className: "register", href: "/".concat(locale, "/register"), children: /*#__PURE__*/
      (0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "header.try_free", message: "Try for free" }) })] });



};

var WithLogin = function WithLogin(props) {
  var router = (0,next_router.useRouter)();

  return /*#__PURE__*/(
    (0,jsx_runtime.jsx)(LoginModal/* default */.Z, {
      onClose: function onClose() {
        if (router.query.to || router.query.action) {
          // lang, is baked ino the url, so we exclude it from url re-build
          // eslint-disable-next-line no-unused-vars
          var _router$query = router.query,action = _router$query.action,to = _router$query.to,lang = _router$query.lang,query = (0,objectWithoutProperties/* default */.Z)(_router$query, _excluded);

          // let queryString = Object.entries(query)
          //   .map(entry => `${entry[0]}=${entry[1]}`)
          //   .join('&');
          // if (queryString) {
          //   queryString = `?` + queryString;
          // }
          var asPath = router.asPath.split('?')[0];
          setTimeout(function () {
            router.replace(router.pathname, {
              pathname: asPath,
              query: query });

          });
        }
      }, children:

      function children(openModal, closeModal) {return /*#__PURE__*/(
          (0,jsx_runtime.jsx)(UserLogin, _objectSpread(_objectSpread({},
          props), {}, {
            openLoginModal: openModal,
            closeLoginModal: closeModal })));} }));




};

/* harmony default export */ var header_UserLogin = (WithLogin);
// EXTERNAL MODULE: ./lib/contexts/UserProvider.tsx
var UserProvider = __webpack_require__(47493);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(90116);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
;// CONCATENATED MODULE: ./ecosystems/navigations/header/menu/MenuContent.tsx




var Content = styled_components_browser_esm["default"].div.withConfig({ displayName: "MenuContent__Content", componentId: "sc-eidoz-0" })(["display:flex;flex-direction:column;border-bottom:1px solid #e8e8e8;pointer-events:auto;@media (min-width:", "px){width:100%;flex-direction:row;align-items:start;justify-content:center;flex-wrap:wrap;border:1px solid lightgrey;border-radius:4px;padding:20px 32px;margin:0 auto;background-color:white;}"],





function (_ref) {var theme = _ref.theme;return theme.viewports.laptop;});














var Dropdown = styled_components_browser_esm["default"].div.withConfig({ displayName: "MenuContent__Dropdown", componentId: "sc-eidoz-1" })(["height:0;width:100%;overflow:hidden;box-sizing:content-box;transition:height 500ms ease-out;@media (min-width:", "px){position:absolute;top:52px;left:0;width:auto;opacity:0;transform-origin:top;transition:opacity 200ms ease-out,transform 500ms ease,height 500ms ease-out;pointer-events:none;&.open{opacity:1;transform:translateX(0);}}"],






function (_ref2) {var theme = _ref2.theme;return theme.viewports.laptop;});

















var Items = styled_components_browser_esm["default"].div.withConfig({ displayName: "MenuContent__Items", componentId: "sc-eidoz-2" })(["display:flex;flex-direction:column;padding:10px 0;@media (min-width:", "px){display:grid;grid-template-columns:repeat(2,minmax(min-content,max-content));width:max-content;padding:0;}"],




function (_ref3) {var theme = _ref3.theme;return theme.viewports.laptop;});







var Element = styled_components_browser_esm["default"].div.withConfig({ displayName: "MenuContent__Element", componentId: "sc-eidoz-3" })(["margin:12px 0;@media (min-width:", "px){margin-top:10px;margin-right:30px;margin-bottom:10px;}"],


function (_ref4) {var theme = _ref4.theme;return theme.viewports.tablet;});






var Anchor = styled_components_browser_esm["default"].a.attrs({ className: 'SingleLink' }).withConfig({ displayName: "MenuContent__Anchor", componentId: "sc-eidoz-4" })(["display:block;text-decoration:none;cursor:pointer;"]);





var Title = styled_components_browser_esm["default"].p.withConfig({ displayName: "MenuContent__Title", componentId: "sc-eidoz-5" })(["display:flex;align-items:center;color:#242424;font-size:16px;font-weight:600;line-height:19px;margin:0;transition:color 300ms ease;", " &:after{content:'';display:block;width:14px;height:14px;margin:0 0 0 auto;background-image:url(/static/icons/arrow-right-dark.svg);background-repeat:no-repeat;background-size:14px;background-position:center 100%;}@media (min-width:", "px){", " &:after{content:'';display:inline-block;width:14px;height:14px;margin-left:6px;background-image:url(/static/icons/arrow-right-blue.svg);background-repeat:no-repeat;background-size:14px;background-position:center 100%;opacity:0;transform:translateX(10px);transition:opacity 200ms ease,transform 200ms ease;}", ":hover &{color:", ";&:after{opacity:1;transform:translateX(0);}}}"],









Anchor,











function (_ref5) {var theme = _ref5.theme;return theme.viewports.laptop;},
Anchor,














Anchor,
function (_ref6) {var theme = _ref6.theme;return theme.colors.primary['blue-1'];});









var Description = styled_components_browser_esm["default"].p.withConfig({ displayName: "MenuContent__Description", componentId: "sc-eidoz-6" })(["width:80%;color:rgba(36,36,36,0.8);font-size:14px;font-weight:500;line-height:17px;margin:4px 0 0;@media (min-width:", "px){width:100%;}"],







function (_ref7) {var theme = _ref7.theme;return theme.viewports.laptop;});




function useCombinedRefs() {for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {refs[_key] = arguments[_key];}
  var targetRef = react.useRef();

  react.useEffect(function () {
    refs.forEach(function (ref) {
      if (!ref) return;

      if (typeof ref === 'function') {
        ref(targetRef.current);
      } else {
        ref.current = targetRef.current;
      }
    });
  }, [refs]);

  return targetRef;
}








var MenuContent = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var _props$className = props.className,className = _props$className === void 0 ? '' : _props$className,items = props.items,_props$banner = props.banner,banner = _props$banner === void 0 ? null : _props$banner,_props$open = props.open,open = _props$open === void 0 ? false : _props$open;
  var localRef = react.useRef();
  var theme = react.useContext(styled_components_browser_esm.ThemeContext);

  var proxyRef = useCombinedRefs(ref, localRef);

  var updateHeight = function updateHeight() {var _window$matchMedia, _localRef$current;
    var isLargeScreen = (_window$matchMedia = window.matchMedia("(min-width: ".concat(
    theme.viewports.laptop, "px)"))) === null || _window$matchMedia === void 0 ? void 0 : _window$matchMedia.
    matches;
    var child = (_localRef$current = localRef.current) === null || _localRef$current === void 0 ? void 0 : _localRef$current.querySelector(
    Content.toString());

    if (child !== undefined) {
      var height = "0px";
      if (open) {
        if (isLargeScreen) {
          height = '100vh';
        } else {
          height = child.getBoundingClientRect().height + 'px';
          setTimeout(function () {
            // to keep element dynamic height once open
            localRef.current.style.height = 'auto';
          }, 200);
        }
      } else {
        // we switch elment from height auto to set height before shrinking to enable animation
        var _height = localRef.current.getBoundingClientRect().height + 'px';
        localRef.current.style.height = _height;
      }
      requestAnimationFrame(function () {
        localRef.current.style.height = height;
      });
    }
  };

  var resizeHandler = (0,react.useCallback)(
  (0,lodash.debounce)(updateHeight, 500, { maxWait: 2000 }),
  []);


  (0,react.useEffect)(function () {
    updateHeight();

    if (window.matchMedia("(".concat(theme.viewports.tablet, "px)"))) {
      window.addEventListener('resize', resizeHandler);
      return function () {return window.removeEventListener('resize', resizeHandler);};
    }
  }, [props.open]);

  return /*#__PURE__*/(
    (0,jsx_runtime.jsx)(Dropdown, {
      ref: proxyRef,
      className: [className, open ? 'open' : null].join(' '), children: /*#__PURE__*/

      (0,jsx_runtime.jsxs)(Content, { children: [/*#__PURE__*/
        (0,jsx_runtime.jsx)(Items, { children:
          items.map(function (item, i) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(Element, { children: item }, i);
          }) }),

        banner] }) }));



});

/* harmony default export */ var menu_MenuContent = (MenuContent);
;// CONCATENATED MODULE: ./ecosystems/navigations/header/menu/CourseMenu.tsx






var CourseMenu_Menu = (0,styled_components_browser_esm["default"])(menu_MenuContent).withConfig({ displayName: "CourseMenu__Menu", componentId: "sc-uhbv5u-0" })(["@media (min-width:", "px){&&{transform:translateX(-25%);}}"],
function (_ref) {var theme = _ref.theme;return theme.viewports.laptop;});






var CourseMenu_text = {
  onlinekurser: {
    title: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.course.onlinekurser.title" }),
    desc: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.course.onlinekurser.desc" }) },


  courses_trainings: {
    title: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.course.courses_trainings.title" }),
    desc: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.course.courses_trainings.desc" }) },


  travel_retreats: {
    title: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.course.travel_retreats.title" }),
    desc: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.course.travel_retreats.desc" }) },


  events: {
    title: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.course.events.title" }),
    desc: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.course.events.desc" }) } };



var CourseMenu = function CourseMenu(_ref2) {var _ref2$className = _ref2.className,className = _ref2$className === void 0 ? '' : _ref2$className,_ref2$open = _ref2.open,open = _ref2$open === void 0 ? false : _ref2$open;
  var ref = /*#__PURE__*/react.createRef();
  var lang = (0,react.useContext)(languageContext/* default */.Z);

  return /*#__PURE__*/(
    (0,jsx_runtime.jsx)(CourseMenu_Menu, {
      ref: ref,
      className: className,
      open: open,
      items: [/*#__PURE__*/
      (0,jsx_runtime.jsxs)(Anchor, { href: "https://yogobe.com/".concat(lang, "/courses"), children: [/*#__PURE__*/
        (0,jsx_runtime.jsx)(Title, { children: CourseMenu_text.onlinekurser.title }), /*#__PURE__*/
        (0,jsx_runtime.jsx)(Description, { children: CourseMenu_text.onlinekurser.desc })] }, "0"), /*#__PURE__*/

      (0,jsx_runtime.jsxs)(Anchor, { href: "https://yogobe.com/".concat(lang, "/marketplace"), children: [/*#__PURE__*/
        (0,jsx_runtime.jsx)(Title, { children: CourseMenu_text.courses_trainings.title }), /*#__PURE__*/
        (0,jsx_runtime.jsx)(Description, { children: CourseMenu_text.courses_trainings.desc })] }, "1"), /*#__PURE__*/

      (0,jsx_runtime.jsxs)(Anchor, { href: "https://yogobe.com/".concat(lang, "/marketplace/travel"), children: [/*#__PURE__*/
        (0,jsx_runtime.jsx)(Title, { children: CourseMenu_text.travel_retreats.title }), /*#__PURE__*/
        (0,jsx_runtime.jsx)(Description, { children: CourseMenu_text.travel_retreats.desc })] }, "2"), /*#__PURE__*/

      (0,jsx_runtime.jsxs)(Anchor, { href: "https://yogobe.com/".concat(lang, "/marketplace/event"), children: [/*#__PURE__*/
        (0,jsx_runtime.jsx)(Title, { children: CourseMenu_text.events.title }), /*#__PURE__*/
        (0,jsx_runtime.jsx)(Description, { children: CourseMenu_text.events.desc })] }, "3")] }));




};

/* harmony default export */ var menu_CourseMenu = (CourseMenu);
;// CONCATENATED MODULE: ./ecosystems/navigations/header/menu/PlayMenu.tsx







var PlayMenu_Menu = (0,styled_components_browser_esm["default"])(menu_MenuContent).withConfig({ displayName: "PlayMenu__Menu", componentId: "sc-1xf1te0-0" })(["left:10%;"]);



var PlayMenu_text = {
  programs: {
    title: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.play.programs.title" }),
    desc: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.play.programs.desc" }) },

  video_audio: {
    title: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.play.video_audio.title" }),
    desc: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.play.video_audio.desc" }) },

  yogobe_challenge: {
    title: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.play.yogobe_challenge.title" }),
    desc: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.play.yogobe_challenge.desc" }) },

  playlists: {
    title: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.play.playlists.title" }),
    desc: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.play.playlists.desc" }) } };



var PlayMenu = function PlayMenu(_ref) {var _ref$className = _ref.className,className = _ref$className === void 0 ? '' : _ref$className,_ref$open = _ref.open,open = _ref$open === void 0 ? false : _ref$open;
  var ref = /*#__PURE__*/react.createRef();
  var lang = (0,react.useContext)(languageContext/* default */.Z);

  return /*#__PURE__*/(
    (0,jsx_runtime.jsx)(PlayMenu_Menu, {
      ref: ref,
      className: className,
      open: open,
      items: [/*#__PURE__*/
      (0,jsx_runtime.jsx)((link_default()), { href: "/".concat(lang, "/videos/genres/all"), legacyBehavior: true, children: /*#__PURE__*/
        (0,jsx_runtime.jsxs)(Anchor, { href: "/".concat(lang, "/videos/genres/all"), children: [/*#__PURE__*/
          (0,jsx_runtime.jsx)(Title, { children: PlayMenu_text.video_audio.title }), /*#__PURE__*/
          (0,jsx_runtime.jsx)(Description, { children: PlayMenu_text.video_audio.desc })] }) }, "2"), /*#__PURE__*/


      (0,jsx_runtime.jsx)((link_default()), { href: "/".concat(lang, "/playlists"), legacyBehavior: true, children: /*#__PURE__*/
        (0,jsx_runtime.jsxs)(Anchor, { href: "/".concat(lang, "/playlists"), children: [/*#__PURE__*/
          (0,jsx_runtime.jsx)(Title, { children: PlayMenu_text.playlists.title }), /*#__PURE__*/
          (0,jsx_runtime.jsx)(Description, { children: PlayMenu_text.playlists.desc })] }) }, "4"), /*#__PURE__*/


      (0,jsx_runtime.jsx)((link_default()), { href: "/".concat(lang, "/programs"), legacyBehavior: true, children: /*#__PURE__*/
        (0,jsx_runtime.jsxs)(Anchor, { href: "/".concat(lang, "/programs"), children: [/*#__PURE__*/
          (0,jsx_runtime.jsx)(Title, { children: PlayMenu_text.programs.title }), /*#__PURE__*/
          (0,jsx_runtime.jsx)(Description, { children: PlayMenu_text.programs.desc })] }) }, "1"), /*#__PURE__*/


      (0,jsx_runtime.jsx)((link_default()), { href: "/".concat(lang, "/challenge"), legacyBehavior: true, children: /*#__PURE__*/
        (0,jsx_runtime.jsxs)(Anchor, { href: "/".concat(lang, "/challenge"), children: [/*#__PURE__*/
          (0,jsx_runtime.jsx)(Title, { children: PlayMenu_text.yogobe_challenge.title }), /*#__PURE__*/
          (0,jsx_runtime.jsx)(Description, { children: PlayMenu_text.yogobe_challenge.desc })] }) }, "3")] }));





};

/* harmony default export */ var menu_PlayMenu = (PlayMenu);
;// CONCATENATED MODULE: ./ecosystems/navigations/header/menu/SubDropdown.tsx






var Header = styled_components_browser_esm["default"].div.withConfig({ displayName: "SubDropdown__Header", componentId: "sc-70kmuw-0" })(["cursor:pointer;", "{background-image:", ";background-repeat:no-repeat;background-size:10px;background-position:100%;}@media (min-width:", "px){&:hover ", "{color:", ";}", "{padding-left:20px;background-position:5px;}}"],


Title,
function (_ref) {var open = _ref.open;return (
    open ? 'url(/static/icons/minus.svg)' : 'url(/static/icons/plus.svg)');},





function (_ref2) {var theme = _ref2.theme;return theme.viewports.laptop;},
Title,
function (_ref3) {var theme = _ref3.theme;return theme.colors.primary['blue-1'];},


Title);






var Mask = styled_components_browser_esm["default"].div.withConfig({ displayName: "SubDropdown__Mask", componentId: "sc-70kmuw-1" })(["height:0px;overflow:hidden;transition:height 400ms ease-out;"]);





var Body = styled_components_browser_esm["default"].ul.withConfig({ displayName: "SubDropdown__Body", componentId: "sc-70kmuw-2" })(["list-style:none;padding:10px 0;margin-left:5px;"]);





var Item = styled_components_browser_esm["default"].li.withConfig({ displayName: "SubDropdown__Item", componentId: "sc-70kmuw-3" })(["padding:5px 0 5px 5px;margin-top:5px;"]);




var SubDropdown_Anchor = styled_components_browser_esm["default"].a.withConfig({ displayName: "SubDropdown__Anchor", componentId: "sc-70kmuw-4" })(["display:flex;color:#242424;font-size:14px;font-weight:600;line-height:17px;text-decoration:none;&:after{content:'';width:14px;height:14px;margin:2px 0 0 auto;background-image:url(/static/icons/arrow-right-dark.svg);background-repeat:no-repeat;background-size:14px;background-position:center 100%;}@media (min-width:", "px){&:after{content:'';display:inline-block;width:14px;height:14px;margin-left:6px;background-image:url(/static/icons/arrow-right-blue.svg);background-repeat:no-repeat;background-size:14px;background-position:center 100%;opacity:0;transform:translateX(10px);transition:opacity 200ms ease,transform 200ms ease;}:hover{color:", ";:after{opacity:1;transform:translateX(0);}}}"],


















function (_ref4) {var theme = _ref4.theme;return theme.viewports.laptop;},
















function (_ref5) {var theme = _ref5.theme;return theme.colors.primary['blue-1'];});









var Subdropdown = function Subdropdown(props) {
  var maskRef = (0,react.useRef)();
  var theme = (0,react.useContext)(styled_components_browser_esm.ThemeContext);
  var _useState = (0,react.useState)(false),open = _useState[0],setOpen = _useState[1];

  var header = props.header,items = props.items;

  var updateHeight = function updateHeight() {
    if (maskRef.current) {var _maskRef$current;
      var child = (_maskRef$current = maskRef.current) === null || _maskRef$current === void 0 ? void 0 : _maskRef$current.firstChild;
      if (child !== undefined) {
        var height = 0;
        if (open) {
          height = child.getBoundingClientRect().height;
        }
        maskRef.current.style.height = height + 'px';
      }
    }
  };

  var resizeHandler = (0,react.useCallback)(
  (0,lodash.debounce)(updateHeight, 500, { maxWait: 2000 }),
  []);


  (0,react.useEffect)(function () {
    updateHeight();

    if (window.matchMedia("(".concat(theme.viewports.tablet, "px)"))) {
      window.addEventListener('resize', resizeHandler);
      return function () {return window.removeEventListener('resize', resizeHandler);};
    }
  }, [open]);

  return /*#__PURE__*/(
    (0,jsx_runtime.jsxs)("div", { children: [/*#__PURE__*/
      (0,jsx_runtime.jsx)(Header, {
        open: open,
        onClick: function onClick() {
          setOpen(function (open) {return !open;});
        }, children:

        header }), /*#__PURE__*/

      (0,jsx_runtime.jsx)(Mask, { ref: maskRef, children: /*#__PURE__*/
        (0,jsx_runtime.jsx)(Body, { children:
          items.map(function (item, i) {
            return /*#__PURE__*/(
              (0,jsx_runtime.jsx)(Item, { children: /*#__PURE__*/
                (0,jsx_runtime.jsx)((link_default()), { href: item.link, legacyBehavior: true, children: /*#__PURE__*/
                  (0,jsx_runtime.jsx)(SubDropdown_Anchor, { href: item.link, children: item.text }) }) }, i));



          }) }) })] }));




};

/* harmony default export */ var SubDropdown = (Subdropdown);
// EXTERNAL MODULE: ./lib/utils.ts
var utils = __webpack_require__(66629);
;// CONCATENATED MODULE: ./ecosystems/navigations/header/menu/MoreMenu.tsx










var MoreMenu_Menu = (0,styled_components_browser_esm["default"])(menu_MenuContent).withConfig({ displayName: "MoreMenu__Menu", componentId: "sc-lpiv9a-0" })(["display:flex;flex-direction:column;@media (min-width:", "px){border-top-right-radius:0;border-top-left-radius:0;", "{max-width:1240px;grid-template-columns:repeat(3,minmax(0,1fr));}}@media (min-width:", "px){width:100vw;", "{grid-template-columns:repeat(4,minmax(0,1fr));}}"],



function (_ref) {var theme = _ref.theme;return theme.viewports.laptop;},



Items,





function (_ref2) {var theme = _ref2.theme;return theme.viewports.desktop;},


Items);





var Row = styled_components_browser_esm["default"].div.withConfig({ displayName: "MoreMenu__Row", componentId: "sc-lpiv9a-1" })([""]);

var MoreMenu_Column = styled_components_browser_esm["default"].div.withConfig({ displayName: "MoreMenu__Column", componentId: "sc-lpiv9a-2" })(["& + &{margin-top:25px;}"]);





var BannerBox = styled_components_browser_esm["default"].div.withConfig({ displayName: "MoreMenu__BannerBox", componentId: "sc-lpiv9a-3" })(["position:relative;display:flex;flex-direction:column;align-items:start;justify-content:center;width:300px;border-radius:3px;padding:24px 20px;margin-bottom:14px;background:linear-gradient( to left,rgba(17,158,221,0.7),rgba(17,158,221,0.7) ),no-repeat url(/static/Program3-Thumbnail.jpg);background-size:cover;"]);


















var BannerText = styled_components_browser_esm["default"].p.withConfig({ displayName: "MoreMenu__BannerText", componentId: "sc-lpiv9a-4" })(["width:193px;color:#fff;font-size:16px;font-weight:500;line-height:21px;margin:0 0 14px;"]);








var BannerBtn = styled_components_browser_esm["default"].a.withConfig({ displayName: "MoreMenu__BannerBtn", componentId: "sc-lpiv9a-5" })(["color:#fff;font-size:13px;font-weight:600;line-height:16px;border:1px solid currentColor;border-radius:3px;padding:8px 15px;cursor:pointer;"]);










var links = {
  en: [
  [
  {
    title: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.more.blog.title" }),
    desc: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.more.blog.desc" }),
    link: 'https://yogobe.com/en/blog' },


  {
    title: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.more.store.title" }),
    desc: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.more.store.desc" }),
    link: 'https://store.yogobe.com/' },


  {
    title: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.more.team.title" }),
    desc: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.more.team.desc" }),
    link: 'https://yogobe.com/en/team' }],


  [
  {
    title: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.more.about.title" }),
    desc: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.more.about.desc" }),
    link: 'https://yogobe.com/en/about' },


  {
    title: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.more.contact.title" }),
    desc: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.more.contact.desc" }),
    link: 'https://yogobe.com/en/contact' }],


  [
  {
    title: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.more.business.title" }),
    desc: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.more.business.desc" }),
    subItems: [
    {
      text: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.more.en_business.item1" }),
      link: 'https://yogobe.com/en/business' },

    {
      text: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.more.en_business.item2" }),
      link: 'https://yogobe.com/en/business/foretag-yoga-traning' },

    {
      text: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.more.en_business.item3" }),
      link: 'https://yogobe.com/en/business/yogalarare-en' }] }]],





  se: [
  [
  {
    title: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.more.blog.title" }),
    desc: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.more.blog.desc" }),
    link: 'https://yogobe.com/se/blog' },


  {
    title: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.more.store.title" }),
    desc: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.more.store.desc" }),
    link: 'https://store.yogobe.com/' },


  {
    title: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.more.team.title" }),
    desc: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.more.team.desc" }),
    link: 'https://yogobe.com/se/team' }],


  [
  {
    title: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.more.about.title" }),
    desc: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.more.about.desc" }),
    link: 'https://yogobe.com/se/om-oss' },


  {
    title: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.more.non_profit.title" }),
    desc: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.more.non_profit.desc" }),
    link: 'https://yogobe.com/se/non-profit' },

  {
    title: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.more.contact.title" }),
    desc: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.more.contact.desc" }),
    link: 'https://yogobe.com/se/kontakt' }],


  [
  {
    title: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.more.friskv\xE5rdsbidrag.title" }),
    desc: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.more.friskv\xE5rdsbidrag.desc" }),
    link: 'https://yogobe.com/se/friskvardsbidrag' },

  {
    title: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.more.business.title" }),
    desc: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.more.business.desc" }),
    subItems: [
    {
      text: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.more.se_business.item1" }),
      link: 'https://arbetsgivare.yogobe.com/' },

    {
      text: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.more.se_business.item2" }),
      link: 'https://yogobe.com/se/pausasmart' },

    {
      text: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.more.se_business.item3" }),
      link: 'https://yogobe.com/se/foretag/yogalarare' },

    {
      text: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.more.se_business.item4" }),
      link: 'https://yogobe.com/se/hotell' },

    {
      text: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.more.se_business.item5" }),
      link: 'https://yogobe.com/se/foretag/partners' }] },



  {
    title: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.more.healthcare.title" }),
    desc: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.more.healthcare.desc" }),
    subItems: [
    {
      text: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.more.se_healthcare.item1" }),
      link: 'https://yogobe.com/se/far' }] }]] };







var Banner = function Banner() {
  return /*#__PURE__*/(
    (0,jsx_runtime.jsx)(Grid/* Box */.xu, { children: /*#__PURE__*/
      (0,jsx_runtime.jsxs)(BannerBox, { children: [/*#__PURE__*/
        (0,jsx_runtime.jsx)(BannerText, { children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.more_menu.banner.title" }) }), /*#__PURE__*/

        (0,jsx_runtime.jsx)(BannerBtn, { href: "https://yogobe.com/se/friskvardsbidrag", children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.more_menu.banner.button" }) })] }) }));





};

var MoreMenu = function MoreMenu(_ref3) {var _ref3$className = _ref3.className,className = _ref3$className === void 0 ? '' : _ref3$className,_ref3$open = _ref3.open,open = _ref3$open === void 0 ? false : _ref3$open;
  var ref = /*#__PURE__*/react.createRef();
  var locale = (0,react.useContext)(languageContext/* default */.Z);
  var theme = react.useContext(styled_components_browser_esm.ThemeContext);

  var positionMenu = function positionMenu() {
    var banner = ref.current;
    var li = (0,utils/* findParentElement */.eC)(banner, 'li');
    var _li$getBoundingClient = li.getBoundingClientRect(),x = _li$getBoundingClient.x;
    banner.style.left = -x + 'px';
  };

  (0,react.useEffect)(function () {
    if (window.matchMedia("(".concat(theme.viewports.tablet, "px)"))) {
      setTimeout(function () {
        positionMenu();
      }, 1000);

      var resizeHandler = (0,lodash.debounce)(
      function () {
        positionMenu();
      },
      400,
      { maxWait: 1000 });


      window.addEventListener('resize', resizeHandler);
      return function () {return window.removeEventListener('resize', resizeHandler);};
    }
  }, []);

  var lang = ['en', 'fi'].includes(locale) ? 'en' : 'se';
  return /*#__PURE__*/(
    (0,jsx_runtime.jsx)(MoreMenu_Menu, {
      ref: ref,
      className: className,
      open: open,
      items: [].concat((0,toConsumableArray/* default */.Z)(
      links[lang].map(function (row, i) {
        return /*#__PURE__*/(
          (0,jsx_runtime.jsx)(Row, { children:
            row.map(function (el, i) {
              var item = null;
              if (el.subItems) {
                item = /*#__PURE__*/
                (0,jsx_runtime.jsx)(SubDropdown, {
                  header: /*#__PURE__*/
                  (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [/*#__PURE__*/
                    (0,jsx_runtime.jsx)(Title, { children: el.title }), /*#__PURE__*/
                    (0,jsx_runtime.jsx)(Description, { children: el.desc })] }),


                  items: el.subItems });


              } else {
                item = /*#__PURE__*/
                (0,jsx_runtime.jsxs)(Anchor, { href: el.link, children: [/*#__PURE__*/
                  (0,jsx_runtime.jsx)(Title, { children: el.title }), /*#__PURE__*/
                  (0,jsx_runtime.jsx)(Description, { children: el.desc })] });


              }
              return /*#__PURE__*/(0,jsx_runtime.jsx)(MoreMenu_Column, { children: item }, i);
            }) }, i));


      })), [/*#__PURE__*/
      (0,jsx_runtime.jsx)(Row, { children: /*#__PURE__*/
        (0,jsx_runtime.jsx)(Banner, {}) }, "banner")]) }));




};

/* harmony default export */ var menu_MoreMenu = (MoreMenu);
// EXTERNAL MODULE: ./assets/ExploreIcon.js
var ExploreIcon = __webpack_require__(32850);
// EXTERNAL MODULE: ./assets/StoreIcon.js
var StoreIcon = __webpack_require__(92137);
// EXTERNAL MODULE: ./assets/CameraIcon.js
var CameraIcon = __webpack_require__(4333);
// EXTERNAL MODULE: ./assets/CalendarIcon.js
var CalendarIcon = __webpack_require__(16361);
// EXTERNAL MODULE: ./assets/PlayIcon.js
var PlayIcon = __webpack_require__(17778);
// EXTERNAL MODULE: ./assets/SearchIcon.js
var SearchIcon = __webpack_require__(72194);
;// CONCATENATED MODULE: ./ecosystems/navigations/header/menu/index.tsx
var menu_excluded = ["menu"];
















var menu_Nav = styled_components_browser_esm["default"].nav.withConfig({ displayName: "menu__Nav", componentId: "sc-1iwa0kc-0" })(["position:fixed;left:0;top:0;height:100vh;width:100vw;padding-top:60px;background-color:white;transform:", ";transition:transform 400ms ease;overflow-y:scroll;@media (min-width:", "px){position:static;height:auto;width:auto;padding-top:0;margin-left:20px;overflow-y:unset;transform:none;margin-left:40px;}"],







function (_ref) {var isOpen = _ref.isOpen;return (
    isOpen ? 'translateX(0)' : 'translateX(-100%)');},



function (_ref2) {var theme = _ref2.theme;return theme.viewports.laptop;});











var List = styled_components_browser_esm["default"].ul.withConfig({ displayName: "menu__List", componentId: "sc-1iwa0kc-1" })(["display:flex;flex-direction:column;list-style:none;padding:0 20px;margin:0;@media (min-width:", "px){min-width:360px;flex-direction:row;align-items:center;padding:unset;}"],






function (_ref3) {var theme = _ref3.theme;return theme.viewports.laptop;});







var Topic = styled_components_browser_esm["default"].li.withConfig({ displayName: "menu__Topic", componentId: "sc-1iwa0kc-2" })(["position:relative;display:flex;flex-direction:column-reverse;align-items:center;@media (min-width:", "px){flex-direction:row;height:30px;padding:15px 0;}"],





function (_ref4) {var theme = _ref4.theme;return theme.viewports.laptop;});






var NavLink = (0,styled_components_browser_esm["default"])((link_default())).withConfig({ displayName: "menu__NavLink", componentId: "sc-1iwa0kc-3" })(["position:relative;display:flex;align-items:center;width:100%;color:#242424;font-size:14px;font-weight:600;line-height:17px;text-transform:capitalize;border-bottom:1px solid #e8e8e8;padding:25px 0;text-decoration:none;cursor:pointer;transition:color 200ms ease-in;&:first-child:last-child{padding-right:15px;}.Header--MenuDropdown ~ &:after{content:'';display:block;height:14px;width:14px;margin:2px 0 0 auto;background-image:url(/static/icons/chevron-down-thin.svg);background-position:center;background-size:contain;background-repeat:no-repeat;transform:rotateX(0);transition:transform 500ms ease-out;}svg{height:20px;width:20px;margin-right:8px;path{transition:fill 200ms ease-in;}}.Header--MenuDropdown ~ &.active{color:#56b9e5;svg path{fill:#56b9e5;}&:after{transform:rotateX(180deg);}}@media (min-width:", "px){width:auto;border:none;padding:10px 15px;.Header--MenuDropdown ~ &:after{height:6px;width:8px;margin-left:4px;}svg{height:14px;width:14px;}}@media (min-width:", "px){padding-left:15px;}"],























































function (_ref5) {var theme = _ref5.theme;return theme.viewports.laptop;},
















function (_ref6) {var theme = _ref6.theme;return theme.viewports.laptop;});




var SearchText = styled_components_browser_esm["default"].span.withConfig({ displayName: "menu__SearchText", componentId: "sc-1iwa0kc-4" })(["@media (min-width:", "px){display:none;}"],
function (_ref7) {var theme = _ref7.theme;return theme.viewports.laptop;});




var menu_Menu = function Menu(_ref8) {var isOpen = _ref8.isOpen,onLinkClick = _ref8.onLinkClick;
  var ref = (0,react.useRef)(null);
  var _useFlags = (0,useFlags/* default */.ZP)(),_useFlags2 = (0,slicedToArray/* default */.Z)(_useFlags, 2),flags = _useFlags2[0],flagsLoading = _useFlags2[1].loading;
  var lang = (0,react.useContext)(languageContext/* default */.Z);
  var _useState = (0,react.useState)(null),open = _useState[0],setOpen = _useState[1];

  var handleMenuClicks = function handleMenuClicks(e) {var _clickedAnchor$datase;
    var clickedInMenu = ref.current.contains(e.target);
    var clickedAnchor = e.target instanceof HTMLAnchorElement ?
    e.target :
    (0,utils/* findParentElement */.eC)(e.target, 'a');
    //
    if (
    !clickedInMenu ||
    clickedAnchor && (clickedAnchor === null || clickedAnchor === void 0 ? void 0 : (_clickedAnchor$datase = clickedAnchor.dataset) === null || _clickedAnchor$datase === void 0 ? void 0 : _clickedAnchor$datase['link']) !== '#')
    {
      setOpen(null);
      onLinkClick();
    }
  };

  var handleClick = function handleClick(e) {
    var _open = open;
    var clickedInMenu = ref.current.contains(e.target);
    if (_open && !clickedInMenu) {
      setOpen(null);
    }
  };

  (0,react.useEffect)(function () {
    if (open) {
      window.addEventListener('click', handleClick);
    } else {
      window.removeEventListener('click', handleClick);
    }
    //
    return function () {return window.removeEventListener('click', handleClick);};
  }, [open]);

  var disable_search = flags && flags.search_disabled !== false;

  var items = (0,react.useMemo)(function () {
    return [
    {
      key: 'play',
      text: /*#__PURE__*/
      (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [/*#__PURE__*/
        (0,jsx_runtime.jsx)(PlayIcon/* default */.Z, {}), " ", /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.play.title" })] }),


      link: '#',
      menu: menu_PlayMenu },

    {
      key: 'live',
      text: /*#__PURE__*/
      (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [/*#__PURE__*/
        (0,jsx_runtime.jsx)(CameraIcon/* default */.Z, {}), " ", /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.live.title" })] }),


      link: "/".concat(lang, "/live") },

    {
      key: 'courses',
      text: /*#__PURE__*/
      (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [/*#__PURE__*/
        (0,jsx_runtime.jsx)(CalendarIcon/* default */.Z, {}), " ", /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.course.title" })] }),


      link: '#',
      menu: menu_CourseMenu },

    {
      key: 'store',
      text: /*#__PURE__*/
      (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [/*#__PURE__*/
        (0,jsx_runtime.jsx)(StoreIcon/* default */.Z, {}), " ", /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.store.title" })] }),


      link: 'https://store.yogobe.com' },

    {
      key: 'more',
      text: /*#__PURE__*/
      (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [/*#__PURE__*/
        (0,jsx_runtime.jsx)(ExploreIcon/* default */.Z, {}), " ", /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.more.title" })] }),


      link: '#',
      menu: menu_MoreMenu }].concat((0,toConsumableArray/* default */.Z)(

    disable_search ?
    [] :
    [
    {
      key: 'search',
      text: /*#__PURE__*/
      (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [/*#__PURE__*/
        (0,jsx_runtime.jsx)(SearchIcon/* default */.Z, {}), ' ', /*#__PURE__*/
        (0,jsx_runtime.jsx)(SearchText, { children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "global_menu.search.title" }) })] }),



      link: "/".concat(lang, "/search") }]));



  }, [lang]);

  return /*#__PURE__*/(
    (0,jsx_runtime.jsx)(menu_Nav, { ref: ref, isOpen: isOpen, onClick: handleMenuClicks, children: /*#__PURE__*/
      (0,jsx_runtime.jsx)(List, { children:
        items.map(function (_ref9) {var Menu = _ref9.menu,item = (0,objectWithoutProperties/* default */.Z)(_ref9, menu_excluded);
          var selected = open === item.key;
          return /*#__PURE__*/(
            (0,jsx_runtime.jsxs)(Topic, { children: [
              Menu ? /*#__PURE__*/
              (0,jsx_runtime.jsx)(Menu, {
                className: ['Header--MenuDropdown'].join(' '),
                open: selected }) :

              null, /*#__PURE__*/
              (0,jsx_runtime.jsx)(NavLink, {
                href: item.link,
                prefetch: false,
                className: selected ? 'active' : '',
                onClick: function onClick(e) {
                  if (Menu) {
                    e.preventDefault();
                    setOpen(!selected ? item.key : null);
                  }
                }
                // need this in global click event to see if we should close menu
                , "data-link": item.link, children:

                item.text })] }, item.key));



        }) }) }));



};

/* harmony default export */ var menu = (menu_Menu);
;// CONCATENATED MODULE: ./ecosystems/navigations/header/Header.tsx












var GlobalStyle = (0,styled_components_browser_esm.createGlobalStyle)(["", ""],
function (_ref) {var isOpen = _ref.isOpen;return (
    isOpen ? "\n          #__next {\n            height: 100vh;\n            overflow-y: hidden;\n          }\n        " :






    null);});


var NativeNotificationsBell = styled_components_browser_esm["default"].div.withConfig({ displayName: "Header__NativeNotificationsBell", componentId: "sc-1arrdty-0" })(["height:32px;"]);



var BurgerButton = styled_components_browser_esm["default"].button.withConfig({ displayName: "Header__BurgerButton", componentId: "sc-1arrdty-1" })(["height:17px;width:17px;border:none;padding:0;margin-right:10px;margin-left:3px;background:none;outline:none;z-index:2;@media(min-width:", "px){margin-right:20px;}@media(min-width:", "px){display:none;}"],










function (_ref2) {var theme = _ref2.theme;return theme.viewports.mobile;},



function (_ref3) {var theme = _ref3.theme;return theme.viewports.laptop;});




var BurgerMenuIcon = function BurgerMenuIcon(_ref4) {var isOpen = _ref4.isOpen;
  return isOpen ? /*#__PURE__*/
  (0,jsx_runtime.jsx)(Icon/* default */.Z, { name: "ygb-icon-close", fontSize: "15px", color: "black" }) : /*#__PURE__*/

  (0,jsx_runtime.jsx)(Icon/* default */.Z, { name: "ygb-icon-hamburgermenub", fontSize: "15px", color: "black" });

};

var Header_Header = function Header(props) {
  var _useContext = (0,react.useContext)(UserProvider/* UserContext */.S),currentUser = _useContext[0],loading = _useContext[1].loading;
  var _useState = (0,react.useState)(false),openMenu = _useState[0],setOpenMenu = _useState[1];

  var _loadingState = false;
  if (!(currentUser !== null && currentUser !== void 0 && currentUser.id) && loading) {
    _loadingState = true;
  }

  var onLinkClick = function onLinkClick() {
    if (openMenu) {
      setOpenMenu(false);
    }
  };

  return /*#__PURE__*/(
    (0,jsx_runtime.jsxs)(Grid/* Container */.W2, { flexDirection: "column", children: [/*#__PURE__*/
      (0,jsx_runtime.jsx)(GlobalStyle, { isOpen: openMenu }), /*#__PURE__*/
      (0,jsx_runtime.jsxs)(Wrapper, { children: [/*#__PURE__*/
        (0,jsx_runtime.jsx)(BurgerButton, { onClick: function onClick() {return setOpenMenu(function (open) {return !open;});}, children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(BurgerMenuIcon, { isOpen: openMenu }) }), /*#__PURE__*/

        (0,jsx_runtime.jsx)(Logo, { children: /*#__PURE__*/
          (0,jsx_runtime.jsx)("a", { href: "/", style: { display: 'flex', textDecoration: 'none' }, children: /*#__PURE__*/
            (0,jsx_runtime.jsx)(Icon/* default */.Z, {
              name: "ygb-icon-yogobe-logo2019_1",
              fontSize: "20px",
              color: theme/* default.colors.primary.blue-2 */.Z.colors.primary["blue-2"] }) }) }), /*#__PURE__*/



        (0,jsx_runtime.jsx)(menu, { isOpen: openMenu, onLinkClick: onLinkClick }), /*#__PURE__*/
        (0,jsx_runtime.jsxs)(User, { children: [/*#__PURE__*/






          (0,jsx_runtime.jsx)(NativeNotificationsBell, { id: "native-notifications-bell" }),
          _loadingState ? /*#__PURE__*/
          (0,jsx_runtime.jsx)(Login.AvatarWrapper, { children: /*#__PURE__*/
            (0,jsx_runtime.jsx)(skeletons_UserLoadingSkeleton, {}) }) : /*#__PURE__*/


          (0,jsx_runtime.jsx)(header_UserLogin, {
            closeMenuLayer: props.closeMenuLayer,
            isAuthenticated: currentUser === null || currentUser === void 0 ? void 0 : currentUser.id,
            currentUser: currentUser })] })] })] }));






};

/* harmony default export */ var header_Header = ((0,next_router.withRouter)(Header_Header));
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71383);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(37887);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(12922);
// EXTERNAL MODULE: ./components/Stickable.js
var Stickable = __webpack_require__(44154);
// EXTERNAL MODULE: ./components/buttons.js
var buttons = __webpack_require__(49613);
// EXTERNAL MODULE: ./organisms/modals/LinksModal.tsx
var LinksModal = __webpack_require__(91447);
// EXTERNAL MODULE: ./ecosystems/navigations/components.ts
var components = __webpack_require__(12980);
// EXTERNAL MODULE: ./lib/constants.tsx
var constants = __webpack_require__(22498);
;// CONCATENATED MODULE: ./ecosystems/navigations/LinksVideos.tsx
function LinksVideos_ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function LinksVideos_objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? LinksVideos_ownKeys(Object(source), !0).forEach(function (key) {(0,defineProperty/* default */.Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : LinksVideos_ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}












var NavSticky = styled_components_browser_esm["default"].nav.withConfig({ displayName: "LinksVideos__NavSticky", componentId: "sc-1498bhk-0" })(["position:fixed;top:0;width:100%;margin:0;background:white;overflow:hidden;box-shadow:0px 5px 15px ", ";z-index:9;"],






function (props) {return props.theme.shadows.light;});



var LinksVideos_Element = styled_components_browser_esm["default"].nav.withConfig({ displayName: "LinksVideos__Element", componentId: "sc-1498bhk-1" })(["border-bottom:1px solid ", ";background-color:", ";box-shadow:0 1px 1px 0 ", ";"],
function (props) {return props.theme.shadows.light;},
function (props) {return props.theme.colors.neutrals['white-darker'];},
function (props) {return props.theme.shadows.light;});


var Container = (0,styled_components_browser_esm["default"])(Grid/* Container */.W2).withConfig({ displayName: "LinksVideos__Container", componentId: "sc-1498bhk-2" })(["position:relative;"]);



var LinksVideos_List = styled_components_browser_esm["default"].ul.withConfig({ displayName: "LinksVideos__List", componentId: "sc-1498bhk-3" })(["display:flex;list-style:none;padding:0;margin:15px 0 0;"]);






var ListItem = styled_components_browser_esm["default"].li.withConfig({ displayName: "LinksVideos__ListItem", componentId: "sc-1498bhk-4" })(["flex-shrink:-1;color:", ";padding:0 16px;margin-bottom:15px;&.active{color:", ";}:first-of-type{border-right:1px solid ", ";padding-left:0;}:last-of-type{padding-right:0;}:nth-last-of-type(2){margin-right:0;margin-left:auto;}@media (max-width:", "){:first-of-type{border-right:none;}:nth-last-of-type(2){margin-right:unset;margin-left:unset;}&.active{order:-1;padding-left:0;border-right:1px solid ", ";margin-right:16px;}&.active:last-of-type{padding-right:16px;}}"],

function (props) {return props.theme.colors.neutrals['gray-dark'];},




function (props) {return props.theme.colors.primary['blue-2'];},




function (props) {return props.theme.colors.neutrals['gray-dark'];},













function (props) {return "".concat(props.theme.viewports.tablet, "px");},













function (props) {return props.theme.colors.neutrals['gray-dark'];});









var LinksVideos_Anchor = styled_components_browser_esm["default"].a.withConfig({ displayName: "LinksVideos__Anchor", componentId: "sc-1498bhk-5" })(["font-size:13px;color:inherit;text-transform:capitalize;text-decoration:none;padding-bottom:9px;cursor:pointer;", ".active &{", ";}"],







ListItem,
function (props) {return "\n        font-weight: 600;\n        border-bottom: 2px solid\n          ".concat(


  props.theme.colors.primary['blue-2'], ";\n      ");});




var ExpandButton = (0,styled_components_browser_esm["default"])(buttons/* default */.ZP).withConfig({ displayName: "LinksVideos__ExpandButton", componentId: "sc-1498bhk-6" })(["position:absolute;right:0;height:100%;border:none;padding:0 20px;background:linear-gradient( to right,rgba(255,255,255,0.3),rgba(255,255,255,0.6) 20%,rgba(255,255,255,1) 40% );@media (min-width:", "px){display:none;}"],












function (props) {return props.theme.viewports.tablet;});




var buildMenuItems = function buildMenuItems(terms, _ref) {var locale = _ref.locale,router = _ref.router;
  var items = [
  {
    id: 'overview',
    link: {
      href: "/[lang]/videos",
      as: "/".concat(locale, "/videos") },

    text: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "subheader.overview", message: 'Overview' }),
    active: "/[lang]/videos" === router.pathname }];



  if (Array.isArray(terms)) {
    items.push.apply(items, (0,toConsumableArray/* default */.Z)(
    terms.map(function (item) {var _router$query;
      var asPath = "/".concat(locale, "/videos/genres/").concat(item.slug);
      return {
        id: item.id,
        link: {
          href: "/[lang]/videos/genres/[genre]",
          as: asPath },

        text: item.name,
        genre: item.slug,
        active: item.slug === ((_router$query = router.query) === null || _router$query === void 0 ? void 0 : _router$query.genre) };

    })));

  }

  items.push(
  {
    id: 'playlist',
    link: {
      href: '/[lang]/playlists',
      as: "/".concat(locale, "/playlists") },

    text: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "subheader.playlists", message: 'Playlists' }),
    active: "/[lang]/playlists" === router.pathname },

  {
    id: 'program',
    link: {
      href: "/[lang]/".concat(constants/* PROGRAMS_PAGE_SLUG */.DP),
      as: "/".concat(locale, "/").concat(constants/* PROGRAMS_PAGE_SLUG */.DP) },

    text: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "subheader.programs", message: "Programs" }),
    active: ['/[lang]/programs', '/[lang]/program'].includes(router.pathname) });


  return items;
};








var LinksVideos = function LinksVideos(props) {
  var locale = (0,react.useContext)(languageContext/* default */.Z);
  var router = (0,next_router.useRouter)();
  var _useState = (0,react.useState)(false),showMenuModal = _useState[0],setShowMenuModal = _useState[1];
  var items = buildMenuItems(props.terms, { router: router, locale: locale });
  var ListWrapper = props.showSticky ? NavSticky : LinksVideos_Element;

  return /*#__PURE__*/(
    (0,jsx_runtime.jsxs)(react.Fragment, { children: [
      props.showSticky ? /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Placeholder */.V, { height: 50 }) : null, /*#__PURE__*/
      (0,jsx_runtime.jsx)(ListWrapper, { children: /*#__PURE__*/
        (0,jsx_runtime.jsxs)(Container, {
          flexDirection: 'column',
          px: [15, 20, 25],
          sx: {
            overflow: 'hidden' }, children: [/*#__PURE__*/


          (0,jsx_runtime.jsx)(LinksVideos_List, { children:
            items.map(function (item) {
              return /*#__PURE__*/(
                (0,jsx_runtime.jsx)(ListItem, { className: item.active ? 'active' : '', children: /*#__PURE__*/
                  (0,jsx_runtime.jsx)((link_default()), LinksVideos_objectSpread(LinksVideos_objectSpread({}, item.link), {}, { legacyBehavior: true, children: /*#__PURE__*/
                    (0,jsx_runtime.jsx)(LinksVideos_Anchor, { children: item.text }) })) }, item.id));



            }) }), /*#__PURE__*/

          (0,jsx_runtime.jsx)(ExpandButton, {
            appearance: "outline",
            onClick: function onClick() {return setShowMenuModal(true);}, children: /*#__PURE__*/

            (0,jsx_runtime.jsx)(Icon/* default */.Z, { name: "ygb-icon-chevron-right" }) })] }) }), /*#__PURE__*/



      (0,jsx_runtime.jsx)(LinksModal/* default */.Z, {
        open: showMenuModal,
        onClose: function onClose() {return setShowMenuModal(false);},
        links: items.map(function (item) {return LinksVideos_objectSpread(LinksVideos_objectSpread({},
          item.link), {}, {
            text: item.text });}) })] }));




};

/* harmony default export */ var navigations_LinksVideos = (LinksVideos);
;// CONCATENATED MODULE: ./ecosystems/navigations/VideosSubHeader.tsx
var _templateObject;







var GET_PRIMARY_LINKS = (0,lib/* default */.ZP)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  query taxonomies($filter: String) {\n    taxonomies(filter: $filter) {\n      terms {\n        id\n        name\n        slug\n      }\n    }\n  }\n"])));











var order = ['yoga', 'meditation', 'breathing', 'workout', 'grow'];
var VideosSubheader = function VideosSubheader() {var _data$taxonomies, _data$taxonomies$;
  var _useQuery = (0,useQuery/* useQuery */.a)(GET_PRIMARY_LINKS, {
    variables: { filter: constants/* VIDEOS_GENRES_ID */.Yb } }),error = _useQuery.error,loading = _useQuery.loading,data = _useQuery.data;


  var sortedTaxonomies = (0,react.useMemo)(function () {
    if (data !== null && data !== void 0 && data.taxonomies) {var _ref, _taxonomies$;
      var taxonomies = data.taxonomies;
      return (
        ((_ref = (0,toConsumableArray/* default */.Z)((_taxonomies$ = taxonomies[0]) === null || _taxonomies$ === void 0 ? void 0 : _taxonomies$.terms)) === null || _ref === void 0 ? void 0 : _ref.sort(function (a, b) {
          return order.indexOf(a.slug) > order.indexOf(b.slug) ? 1 : -1;
        })) || []);

    }
    return [];
  }, [data === null || data === void 0 ? void 0 : (_data$taxonomies = data.taxonomies) === null || _data$taxonomies === void 0 ? void 0 : (_data$taxonomies$ = _data$taxonomies[0]) === null || _data$taxonomies$ === void 0 ? void 0 : _data$taxonomies$.terms]);

  return /*#__PURE__*/(
    (0,jsx_runtime.jsx)(Stickable/* default */.Z, { scrollAfterY: 77, children:
      function children(showSticky) {
        if (error) return null;
        if (loading) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(navigations_LinksVideos, { showSticky: showSticky, loading: loading });
        }

        return /*#__PURE__*/(
          (0,jsx_runtime.jsx)(navigations_LinksVideos, {
            showSticky: showSticky,
            terms: [
            {
              id: 'all',
              name: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "metadata.all", message: "All" }),
              slug: 'all' }].concat((0,toConsumableArray/* default */.Z)(

            sortedTaxonomies)) }));



      } }));


};

/* harmony default export */ var VideosSubHeader = (VideosSubheader);
// EXTERNAL MODULE: ./organisms/modals/paymentConfirmation/PaymentConfirmationModal.tsx + 4 modules
var PaymentConfirmationModal = __webpack_require__(83761);
// EXTERNAL MODULE: ./components/form/Label.js
var Label = __webpack_require__(25077);
// EXTERNAL MODULE: ./components/Link.tsx
var Link = __webpack_require__(4338);
// EXTERNAL MODULE: ./components/texts.tsx
var texts = __webpack_require__(45945);
;// CONCATENATED MODULE: ./lib/footerLinks.js


/* harmony default export */ var footerLinks = ({
  en: {
    communityLinks: [
    {
      BEYOGA365: '/se/beyoga365' },

    {
      YOGAMOM365: '/se/yogamom365' }],


    socialMediaLinks: [
    {
      Facebook: 'https://www.facebook.com/yogobe.com' },

    {
      Instagram: 'https://instagram.com/yogobe' },

    {
      Youtube: 'https://www.youtube.com/user/YogobeOfficial' },

    {
      LinkedIn: 'https://www.linkedin.com/company/yogobe-ab' }],


    servicesLinks: [
    {
      'Terms and conditions': '/en/terms-and-conditions' },

    {
      'Privacy Policy': '/en/terms-and-conditions' }] },



  se: {
    yogobeLinks: [
    { Videobibliotek: '/se/videos/genres/all' },
    { 'Marketplace - kurser och resor': '/se/marketplace' },
    { Träningsprogram: "/se/".concat(constants/* PROGRAMS_PAGE_SLUG */.DP) },
    { Blogg: '/se/blog' },
    { Webshop: 'https://store.yogobe.com/' },
    { Mecenat: '/se/register/mecenat' }],

    discoverLinks: [
    { 'Mitt Behov': '/se/behov' },
    { 'Allt om Yoga': '/se/yoga' },
    { Yogapositioner: '/se/yoga/positioner' },
    { Yogaformer: '/se/yoga/stilar' },
    { Meditation: '/se/meditation' },
    { 'Träning & Rörelse': '/se/movement' },
    { Mindfulness: '/se/mindfulness' },
    { Ayurveda: '/se/ayurveda/om-ayurveda' }],

    communityLinks: [
    {
      BEYOGA365: '/se/beyoga365' },

    {
      YOGAMOM365: '/se/yogamom365' }],


    socialMediaLinks: [
    {
      Facebook: 'https://www.facebook.com/yogobe.com' },

    {
      Instagram: 'https://instagram.com/yogobe' },

    {
      Youtube: 'https://www.youtube.com/user/YogobeOfficial' },

    {
      LinkedIn: 'https://www.linkedin.com/company/yogobe-ab' }],


    servicesLinks: [
    {
      'Kontakta oss': '/se/kontakt' },

    {
      'Frågor och svar': '/se/faq' },

    {
      Press: '/se/press' },

    { Integritetpolicy: '/se/integritetspolicy' },
    {
      Villkor: '/se/villkor' }] },



  fi: {
    communityLinks: [
    {
      BEYOGA365: '/se/beyoga365' },

    {
      YOGAMOM365: '/se/yogamom365' }],


    socialMediaLinks: [
    {
      Facebook: 'https://www.facebook.com/yogobe.com' },

    {
      Instagram: 'https://instagram.com/yogobe' },

    {
      Youtube: 'https://www.youtube.com/user/YogobeOfficial' },

    {
      LinkedIn: 'https://www.linkedin.com/company/yogobe-ab' }],


    servicesLinks: [
    {
      'Privacy Policy': '/en/terms-and-conditions' },

    {
      Yhteystiedot: '/fi/yhteystiedot' },

    {
      FAQ: '/fi/faq' },

    {
      Media: '/fi/media' },

    {
      Ehdot: '/fi/ehdot' }] },



  no: {
    communityLinks: [
    {
      BEYOGA365: '/se/beyoga365' },

    {
      YOGAMOM365: '/se/yogamom365' }],


    socialMediaLinks: [
    {
      Facebook: 'https://www.facebook.com/yogobe.com' },

    {
      Instagram: 'https://instagram.com/yogobe' },

    {
      Youtube: 'https://www.youtube.com/user/YogobeOfficial' },

    {
      LinkedIn: 'https://www.linkedin.com/company/yogobe-ab' }],


    servicesLinks: [
    {
      Kontakt: '/no/kontakt' },

    {
      FAQ: '/no/faq' },

    {
      Media: '/no/media' },

    {
      Vilkar: '/no/vilkar' }] } });
;// CONCATENATED MODULE: ./organisms/Footer.tsx
function Footer_ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function Footer_objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? Footer_ownKeys(Object(source), !0).forEach(function (key) {(0,defineProperty/* default */.Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Footer_ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}












var Footer_Wrapper = styled_components_browser_esm["default"].footer.withConfig({ displayName: "Footer__Wrapper", componentId: "sc-2bqtec-0" })(["color:white;border:1px solid transparent;background-color:", ";"],


function (props) {return props.theme.colors.secondary['gray-5'];});


var FooterSectionLabel = (0,styled_components_browser_esm["default"])(Label/* default */.Z).withConfig({ displayName: "Footer__FooterSectionLabel", componentId: "sc-2bqtec-1" })(["font-weight:bold;cursor:default;"]);




var MobileStoreImage = styled_components_browser_esm["default"].img.withConfig({ displayName: "Footer__MobileStoreImage", componentId: "sc-2bqtec-2" })(["object-fit:contain;"]);



var languages = [
{
  lang: 'se',
  trans: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "footer.languages.swedish", message: "Swedish" }) },

{
  lang: 'en',
  trans: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "footer.languages.english", message: "English" }) },

{
  lang: 'no',
  trans: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "footer.languages.norwegian", message: "Norwegian" }) },

{
  lang: 'fi',
  trans: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "footer.languages.finnish", message: "Finnish" }) }];



var Languages = function Languages() {
  var router = (0,next_router.useRouter)();

  var switchLocale = function switchLocale(lang) {
    router.push({
      pathname: router.pathname,
      query: Footer_objectSpread(Footer_objectSpread({}, router.query), {}, { lang: lang }) });

  };

  return /*#__PURE__*/(
    (0,jsx_runtime.jsxs)(texts/* LanguagesMenuFooter */.zg, { children: [/*#__PURE__*/
      (0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "footer.languages.label", message: 'Language' }), ":", " ",
      languages.map(function (_ref, i) {var lang = _ref.lang,trans = _ref.trans;return /*#__PURE__*/(
          (0,jsx_runtime.jsxs)(react.Fragment, { children: [
            i > 0 ? /*#__PURE__*/
            (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [" ", "|", " "] }) :


            null, /*#__PURE__*/
            (0,jsx_runtime.jsx)(buttons/* default */.ZP, {
              appearance: "link",
              color: "white",
              onClick: function onClick() {
                switchLocale(lang);
              }, children:

              trans })] }, lang));})] }));





};

var footerSections = {
  yogobeLinks: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "footer.links.yogobe" }),
  discoverLinks: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "footer.links.discover" }),
  communityLinks: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "footer.links.community" }),
  socialMediaLinks: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "footer.label2" }),
  servicesLinks: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "footer.label3" }) };


var Footer = function Footer() {
  var locale = (0,react.useContext)(languageContext/* default */.Z);

  return /*#__PURE__*/(
    (0,jsx_runtime.jsxs)(Footer_Wrapper, { children: [/*#__PURE__*/
      (0,jsx_runtime.jsxs)(Grid/* Container */.W2, { flexDirection: "column", my: [0, 20], px: [15, 20, 20], pt: 20, children: [/*#__PURE__*/
        (0,jsx_runtime.jsxs)(Grid/* Flex */.kC, {
          width: 1,
          mb: 30,
          order: [2, 1, 1],
          flexDirection: ['column', 'row', 'row'],
          justifyContent: ['flex-start', 'space-between', 'space-between'],
          alignItems: ['flex-start', 'center', 'center'],
          flexWrap: "wrap", children: [/*#__PURE__*/

          (0,jsx_runtime.jsx)(Languages, {}), /*#__PURE__*/
          (0,jsx_runtime.jsxs)(Grid/* Box */.xu, { mt: 10, children: [/*#__PURE__*/
            (0,jsx_runtime.jsx)("a", {
              href: constants/* ANDROID_APP_LINK */.FG,
              target: "_blank",
              rel: "noreferrer noopener", children: /*#__PURE__*/

              (0,jsx_runtime.jsx)(MobileStoreImage, {
                src:
                locale === 'se' ?
                '/static/google-play-badge-SE.png' :
                '/static/google-play-badge-en.png',

                width: "100px",
                height: "30px",
                loading: "lazy" }) }), /*#__PURE__*/


            (0,jsx_runtime.jsx)("a", { href: constants/* IOS_APP_LINK */.G_, target: "_blank", rel: "noreferrer noopener", children: /*#__PURE__*/
              (0,jsx_runtime.jsx)(MobileStoreImage, {
                src:
                locale === 'se' ?
                '/static/App_Store_Badge_se.svg' :
                '/static/App_Store_Badge_en.svg',

                width: "120px",
                height: "30px",
                loading: "lazy" }) })] })] }), /*#__PURE__*/




        (0,jsx_runtime.jsx)(Grid/* Container */.W2, { flexWrap: "wrap", order: [1, 2, 2], children:
          Object.entries(footerSections).map(function (_ref2) {var _ref3 = (0,slicedToArray/* default */.Z)(_ref2, 2),key = _ref3[0],trans = _ref3[1];
            var links = footerLinks[locale][key] || [];
            return links.length > 0 ? /*#__PURE__*/
            (0,jsx_runtime.jsxs)(Grid/* Box */.xu, {

              mb: [30, 30, 0],
              pr: [0, 20],
              width: [1, 1 / 2, 1 / 5],
              minWidth: "15em", children: [/*#__PURE__*/

              (0,jsx_runtime.jsx)(FooterSectionLabel, { as: "p", color: "white", children:
                trans }), /*#__PURE__*/

              (0,jsx_runtime.jsx)(texts/* ULFooter */.Fx, { children:
                links.map(function (item, index) {
                  return /*#__PURE__*/(
                    (0,jsx_runtime.jsx)(texts/* LIFooter */.e5, { children: /*#__PURE__*/
                      (0,jsx_runtime.jsx)(Link/* FooterLink */.SY, { href: Object.values(item)[0], children:
                        Object.keys(item)[0] }) }, index));



                }) })] }, key) :



            [];

          }) })] }), /*#__PURE__*/


      (0,jsx_runtime.jsx)(Grid/* Container */.W2, {
        px: [25, 20, 20],
        pb: [10, 20],
        justifyContent: ['start', 'center'], children: /*#__PURE__*/

        (0,jsx_runtime.jsx)(texts/* CopyrightFooter */.gJ, { children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(esm/* Trans */.cC, {
            id: "footer.copyright",
            message: '©YOGOBE 2020. All rights reserved.',
            values: { year: new Date().getFullYear() } }) }) })] }));





};

/* harmony default export */ var organisms_Footer = (Footer);
// EXTERNAL MODULE: ./components/MessageStripe.tsx
var MessageStripe = __webpack_require__(35281);
;// CONCATENATED MODULE: ./organisms/stripeBanners/YearlyOffer.tsx










var YearlyOffer_Anchor = styled_components_browser_esm["default"].a.withConfig({ displayName: "YearlyOffer__Anchor", componentId: "sc-9tkmpo-0" })(["&&{color:#fff;text-decoration:none;}"]);






var YearlyOffer_MessageStripe = (0,styled_components_browser_esm["default"])(MessageStripe/* default */.ZP).withConfig({ displayName: "YearlyOffer__MessageStripe", componentId: "sc-9tkmpo-1" })(["position:sticky;top:0;padding-left:0;padding-right:0;"]);






var ENABLED_PATHS = [
{ path: '/[lang]/playlists', exact: false },
{ path: '/[lang]/videos', exact: false },
{ path: '/[lang]', exact: true },
{ path: '/[lang]/me', exact: false }];


var YearlyOffer = function YearlyOffer() {var _currentUser$subscrip, _currentUser$subscrip2, _currentUser$subscrip3;
  var router = (0,next_router.useRouter)();
  var _useFlags = (0,useFlags/* default */.ZP)(),_useFlags2 = (0,slicedToArray/* default */.Z)(_useFlags, 1),flags = _useFlags2[0];
  var lang = (0,react.useContext)(languageContext/* default */.Z);
  var _useContext = (0,react.useContext)(UserProvider/* UserContext */.S),currentUser = _useContext[0];

  var showYearlyCampaign = true;
  if (
  // user not loaded yet
  currentUser === undefined ||
  // user doesnt have trial premium
  (currentUser === null || currentUser === void 0 ? void 0 : (_currentUser$subscrip = currentUser.subscription) === null || _currentUser$subscrip === void 0 ? void 0 : _currentUser$subscrip.status) === 'active' &&
  ['monthly', 'quarterly', 'yearly'].includes(
  currentUser === null || currentUser === void 0 ? void 0 : (_currentUser$subscrip2 = currentUser.subscription) === null || _currentUser$subscrip2 === void 0 ? void 0 : (_currentUser$subscrip3 = _currentUser$subscrip2.currentSubscriptionPlan) === null || _currentUser$subscrip3 === void 0 ? void 0 : _currentUser$subscrip3.planType) ||

  // has wellness
  currentUser !== null && currentUser !== void 0 && currentUser.hasWellness)
  {
    showYearlyCampaign = false;
  }

  var allowed_on_page = (0,utils/* isEnabledOnPage */.rT)(ENABLED_PATHS, router.pathname);
  if (
  !allowed_on_page ||
  !showYearlyCampaign ||
  !(flags !== null && flags !== void 0 && flags.yearly_campaign_banners))
  {
    return null;
  }

  return /*#__PURE__*/(
    (0,jsx_runtime.jsx)(YearlyOffer_MessageStripe, { bg: "#6C96A7", color: "#fff", show: true, children: /*#__PURE__*/
      (0,jsx_runtime.jsx)((link_default()), { href: "/".concat(lang, "/yearly"), legacyBehavior: true, children: /*#__PURE__*/
        (0,jsx_runtime.jsx)(YearlyOffer_Anchor, { href: "/".concat(lang, "/yearly"), children:
          ['en', 'fi'].includes(lang) ?
          'Invest in your health. Choose between two amazing subscription offers. Click here!' :
          'Investera i din hälsa med Yogobe. Välj mellan två fantastiska årserbjudanden (från 1599 SEK/år). Klicka här & läs mer!' }) }) }));




};

/* harmony default export */ var stripeBanners_YearlyOffer = (YearlyOffer);
// EXTERNAL MODULE: ./node_modules/@lingui/core/esm/index.js + 1 modules
var core_esm = __webpack_require__(94471);
// EXTERNAL MODULE: ./organisms/modals/base/index.tsx + 3 modules
var base = __webpack_require__(10842);
// EXTERNAL MODULE: ./lib/analytics/manager.ts + 4 modules
var manager = __webpack_require__(88224);
;// CONCATENATED MODULE: ./organisms/modals/TrialClaimModal.tsx
















var ModalBody = (0,styled_components_browser_esm["default"])(base/* Body */.uT).withConfig({ displayName: "TrialClaimModal__ModalBody", componentId: "sc-1fucret-0" })(["padding:0;"]);



var ImageContainer = styled_components_browser_esm["default"].div.withConfig({ displayName: "TrialClaimModal__ImageContainer", componentId: "sc-1fucret-1" })(["min-height:200px;display:flex;align-items:center;justify-content:center;background-image:linear-gradient( 90deg,rgba(157,201,199,0.7),rgba(157,201,199,0.7) ),url('/static/cheerful-sportswomen-giving-high-five-to-each-other.jpg');background-repeat:no-repeat;background-size:cover;background-position:center;i:before{font-weight:400;}"]);



















var TrialClaimModal_Title = styled_components_browser_esm["default"].h2.withConfig({ displayName: "TrialClaimModal__Title", componentId: "sc-1fucret-2" })(["font-size:20px;"]);



var Desc = styled_components_browser_esm["default"].p.withConfig({ displayName: "TrialClaimModal__Desc", componentId: "sc-1fucret-3" })(["font-size:14px;line-height:23px;text-align:center;margin:0;"]);






var ClaimTrial = (0,styled_components_browser_esm["default"])(buttons/* default */.ZP).withConfig({ displayName: "TrialClaimModal__ClaimTrial", componentId: "sc-1fucret-4" })(["width:100%;font-size:14px;margin-top:20px;margin-bottom:13px;background-color:rgb(17,158,221);:hover{background-color:rgba(17,158,221,0.9);}"]);











var NotInterestedButton = (0,styled_components_browser_esm["default"])(buttons/* default */.ZP).withConfig({ displayName: "TrialClaimModal__NotInterestedButton", componentId: "sc-1fucret-5" })(["font-size:14px;color:rgb(18,158,220);"]);




var TrialClaimModal_ENABLED_PATHS = [
{ path: '/[lang]/live', exact: false },
{ path: '/[lang]/playlists', exact: false },
{ path: '/[lang]/videos', exact: false },
{ path: '/[lang]/me', exact: false }];


var TrialClaimModal = function TrialClaimModal() {
  var router = (0,next_router.useRouter)();
  var _useFlags = (0,useFlags/* default */.ZP)(),_useFlags2 = (0,slicedToArray/* default */.Z)(_useFlags, 1),flags = _useFlags2[0];
  var lang = (0,react.useContext)(languageContext/* default */.Z);
  var _useContext = (0,react.useContext)(UserProvider/* UserContext */.S),currentUser = _useContext[0],refetch = _useContext[1].refetch;
  var _useStoreUserDecision = (0,generated/* useStoreUserDecisionMutation */.IAd)({
    onCompleted: function onCompleted(resp) {var _resp$storeUserDecisi, _resp$storeUserDecisi2;
      if (resp !== null && resp !== void 0 && (_resp$storeUserDecisi = resp.storeUserDecision) !== null && _resp$storeUserDecisi !== void 0 && (_resp$storeUserDecisi2 = _resp$storeUserDecisi.user) !== null && _resp$storeUserDecisi2 !== void 0 && _resp$storeUserDecisi2.id) {
        (0,manager/* default */.Z)().sendTrialRejected();
        refetch({ onlyBaseProperties: true });
      }
    } }),_useStoreUserDecision2 = (0,slicedToArray/* default */.Z)(_useStoreUserDecision, 2),storeUserDecision = _useStoreUserDecision2[0],loading = _useStoreUserDecision2[1].loading;

  //

  var allowed_on_page = TrialClaimModal_ENABLED_PATHS.some(function (item) {
    if (item.exact && item.path === router.pathname) {
      return true;
    } else {
      return router.pathname.startsWith(item.path);
    }
  });

  if (
  !(
  flags.enable_trialclaim_modal &&
  allowed_on_page &&
  (currentUser === null || currentUser === void 0 ? void 0 : currentUser.eligibleForTrialReclaim) ===
  generated/* EligibleForTrialReclaimKind.Available */.MrK.Available))

  {
    return null;
  }

  return /*#__PURE__*/(
    (0,jsx_runtime.jsx)(base/* Modal */.u_, { open: true, customWidth: "500px", children: /*#__PURE__*/
      (0,jsx_runtime.jsxs)(ModalBody, { children: [/*#__PURE__*/
        (0,jsx_runtime.jsx)(ImageContainer, { children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(Icon/* default */.Z, {
            name: "ygb-icon-yogobe-logo2019_1",
            fontSize: "24px",
            color: "#fff" }) }), /*#__PURE__*/


        (0,jsx_runtime.jsxs)(Grid/* Flex */.kC, {
          maxWidth: "428px",
          flexDirection: "column",
          alignItems: "center",
          px: 20,
          pt: 10,
          pb: 30,
          mx: "auto", children: [/*#__PURE__*/

          (0,jsx_runtime.jsx)(TrialClaimModal_Title, { children: /*#__PURE__*/
            (0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "reclaim_trial_modal.title" }) }), /*#__PURE__*/

          (0,jsx_runtime.jsx)(Desc, {
            dangerouslySetInnerHTML: {
              __html: /*i18n*/core_esm/* i18n._ */.ag._("reclaim_trial_modal.desc") } }), /*#__PURE__*/


          (0,jsx_runtime.jsx)((link_default()), {
            href: {
              pathname: "/".concat(lang, "/account/reclaimtrial"),
              query: {
                code: 'provayogobe14',
                source: 'modal' } },


            passHref: true,
            legacyBehavior: true, children: /*#__PURE__*/
            (0,jsx_runtime.jsx)(ClaimTrial, { appearance: "default-blue", children: /*#__PURE__*/
              (0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "reclaim_trial_modal.claim_btn" }) }) }), /*#__PURE__*/


          (0,jsx_runtime.jsx)(NotInterestedButton, {
            appearance: "link",
            loading: loading,
            onClick: function onClick() {
              storeUserDecision({
                variables: {
                  decision: generated/* UserDecisionKind.ProvaYogobe14 */.enR.ProvaYogobe14,
                  value: false } });


            }, children: /*#__PURE__*/

            (0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "reclaim_trial_modal.not_intrested_btn" }) })] })] }) }));





};
;// CONCATENATED MODULE: ./organisms/stripeBanners/SpringBoostBanner.tsx








var SpringBoostBanner_MessageStripe = (0,styled_components_browser_esm["default"])(MessageStripe/* default */.ZP).withConfig({ displayName: "SpringBoostBanner__MessageStripe", componentId: "sc-1leu22d-0" })(["&&&{display:flex;padding:5px 0;z-index:10;}"]);








var SpringBoostBanner_ENABLED_PATHS = [
{ path: '/[lang]/videos/genres/[genre]', exact: true },
{ path: '/[lang]/programs', exact: true },
{ path: '/[lang]/challenge', exact: true }];


var SpringBoostBanner = function SpringBoostBanner() {
  var router = (0,next_router.useRouter)();
  var _useFlags = (0,useFlags/* default */.ZP)(),_useFlags2 = (0,slicedToArray/* default */.Z)(_useFlags, 1),flags = _useFlags2[0];
  var lang = (0,react.useContext)(languageContext/* default */.Z);

  var allowed_on_page = (0,utils/* isEnabledOnPage */.rT)(SpringBoostBanner_ENABLED_PATHS, router.pathname);

  if (
  ['se', 'no'].includes(lang) &&
  allowed_on_page &&
  !flags.yearly_campaign_banners &&
  flags.yearly_campaign)
  {
    return /*#__PURE__*/(
      (0,jsx_runtime.jsx)(SpringBoostBanner_MessageStripe, { bg: "#D9E8E7", color: "#242424", children: /*#__PURE__*/
        (0,jsx_runtime.jsx)("a", { href: "/se/c/yogobe/b/spring-boost", children: "G\xE5 med i Spring Boost och m\xF6t v\xE5ren med ny energi! 8 veckor tr\xE4ning, kost och \xE5terh\xE4mtning med start 1 mars. Anm\xE4l dig h\xE4r!\xA0" }) }));





  }

  return null;
};

/* harmony default export */ var stripeBanners_SpringBoostBanner = (SpringBoostBanner);
;// CONCATENATED MODULE: ./components/layout.tsx
















var Overlay = styled_components_browser_esm["default"].div.withConfig({ displayName: "layout__Overlay", componentId: "sc-wnswlr-0" })(["position:fixed;display:", ";width:100%;height:100%;top:0;left:0;right:0;bottom:0;background-color:rgba(0,0,0,0.5);z-index:10;cursor:pointer;"],

function (props) {return props.shown ? 'block' : 'none';});











var VIDEO_SUBHEADER_ROUTES = [
'/[lang]/videos',
'/[lang]/videos/genres/[genre]',
'/blog',
'/[lang]/program',
'/[lang]/playlists'];


var Layout = function Layout(props) {var _router$query;
  var router = (0,next_router.useRouter)();
  var _useContext = (0,react.useContext)(UserProvider/* UserContext */.S),currentUser = _useContext[0];
  var theme = (0,react.useContext)(styled_components_browser_esm.ThemeContext);

  var _useState = (0,react.useState)(false),isMenuLayerActive = _useState[0],setIsMenuLayerActive = _useState[1];

  var handleCloseMenuLayer = function handleCloseMenuLayer() {
    setIsMenuLayerActive(false);
    document.body.style.overflow = 'visible';
  };

  var handleOpenMenuLayer = function handleOpenMenuLayer() {
    setIsMenuLayerActive(true);
    if (window.innerWidth >= theme.viewports.mobile) {
      document.body.style.overflow = 'hidden';
    }
  };

  if (router.route === '/[lang]/maintenance') {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Main, { children: props.children });
  }

  return /*#__PURE__*/(
    (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [/*#__PURE__*/
      (0,jsx_runtime.jsx)("header", { children: /*#__PURE__*/
        (0,jsx_runtime.jsx)(header_Header, {
          isMenuLayerActive: isMenuLayerActive,
          openMenuLayer: handleOpenMenuLayer,
          closeMenuLayer: handleCloseMenuLayer }) }),


      VIDEO_SUBHEADER_ROUTES.includes(router.route) && /*#__PURE__*/(0,jsx_runtime.jsx)(VideosSubHeader, {}),
      (currentUser === null || currentUser === void 0 ? void 0 : currentUser.isEmailActivated) === false ? /*#__PURE__*/
      (0,jsx_runtime.jsx)(banner/* EmailValidationBanner */.SR, { currentUser: currentUser }) :
      null,
      (router.route === "/video" || router.route === "/playlist") && /*#__PURE__*/
      (0,jsx_runtime.jsx)(banner/* IosBanner */.k8, {}), /*#__PURE__*/

      (0,jsx_runtime.jsx)(stripeBanners_YearlyOffer, {}), /*#__PURE__*/
      (0,jsx_runtime.jsx)(stripeBanners_SpringBoostBanner, {}), /*#__PURE__*/
      (0,jsx_runtime.jsx)(TrialClaimModal, {}),
      router.query['order_id'] ? /*#__PURE__*/
      (0,jsx_runtime.jsx)(PaymentConfirmationModal/* default */.Z, {
        open: true,
        orderId: (_router$query = router.query) === null || _router$query === void 0 ? void 0 : _router$query.order_id }) :

      null, /*#__PURE__*/
      (0,jsx_runtime.jsxs)(Main, { children: [/*#__PURE__*/
        (0,jsx_runtime.jsx)(Overlay, { shown: isMenuLayerActive, onClick: handleCloseMenuLayer }),
        props.children] }), /*#__PURE__*/

      (0,jsx_runtime.jsx)(organisms_Footer, {})] }));


};

/* harmony default export */ var layout = (Layout);
// EXTERNAL MODULE: ./lib/apollo/index.tsx + 1 modules
var apollo = __webpack_require__(15049);
// EXTERNAL MODULE: ./lib/contexts/deviceContext.js
var deviceContext = __webpack_require__(87811);
;// CONCATENATED MODULE: ./lib/globalStyles.js


/* harmony default export */ var globalStyles = ((0,styled_components_browser_esm.createGlobalStyle)(["html{scroll-behavior:smooth}body *{font-family:'Libre Franklin',Helvetica,Arial,sans-serif;box-sizing:border-box;}html body{margin:0;padding:0;background-color:white;}input[type='text'],input,button,textarea{-webkit-appearance:none;-moz-appearance:none;appearance:none;}a{color:#56b9e5;}#__next{max-width:100vw;overflow-x:hidden;}.MuiSvgIcon-root{display:none;}::-webkit-scrollbar{width:5px;}::-webkit-scrollbar-track{background:#f1f1f1;}::-webkit-scrollbar-thumb{background:#d1d9df;}::-webkit-scrollbar-thumb:hover{background:#555;}.phase-videos-indicator{position:absolute;top:0;left:6px;height:100%;width:5px;z-index:0;}.embeddedText.embeddedText{font-size:16px;h1,h2,h3,h4,h5,h6{color:", ";font-weight:600;padding:0;}h1{font-size:24px;margin:30px 0 20px 0;}h2{font-size:20px;margin:15px 0 10px 0;}h3{font-size:18px;}h4{font-size:16px;}h5{font-size:14px;}h6{font-size:12px;}ul,ol{font-size:inherit;padding-left:20px;li{font-size:inherit;}}}"],








































































function (_ref) {var theme = _ref.theme;return theme.colors.neutrals['black'];}));
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/createTheme.js + 15 modules
var createTheme = __webpack_require__(83559);
;// CONCATENATED MODULE: ./lib/muiTheme.js


/* harmony default export */ var muiTheme = ((0,createTheme/* default */.Z)({
  breakpoints: {
    // keys: ['xs', 'sm', 'md', 'lg', 'xl'],
    values: {
      xs: 0,
      sm: 425,
      md: 768,
      lg: 1024,
      xl: 1920 } },


  palette: {
    primary: {
      light: "#56b9e5", //purple[300],
      main: "#129edc", //purple[500],
      dark: "#129edc" //purple[700],
    },
    secondary: {
      light: "#fff", //green[300],
      main: "#fff", //green[500],
      dark: "#fff" //green[700],
    },
    background: {
      "default": '#fff' } } }));
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js + 1 modules
var withStyles = __webpack_require__(1591);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/CssBaseline/CssBaseline.js





var html = {
  WebkitFontSmoothing: 'antialiased',
  // Antialiasing.
  MozOsxFontSmoothing: 'grayscale',
  // Antialiasing.
  // Change from `box-sizing: content-box` so that `width`
  // is not affected by `padding` or `border`.
  boxSizing: 'border-box'
};
var body = function body(theme) {
  return (0,esm_extends/* default */.Z)({
    color: theme.palette.text.primary
  }, theme.typography.body2, {
    backgroundColor: theme.palette.background.default,
    '@media print': {
      // Save printer ink.
      backgroundColor: theme.palette.common.white
    }
  });
};
var styles = function styles(theme) {
  return {
    '@global': {
      html: html,
      '*, *::before, *::after': {
        boxSizing: 'inherit'
      },
      'strong, b': {
        fontWeight: theme.typography.fontWeightBold
      },
      body: (0,esm_extends/* default */.Z)({
        margin: 0
      }, body(theme), {
        // Add support for document.body.requestFullScreen().
        // Other elements, if background transparent, are not supported.
        '&::backdrop': {
          backgroundColor: theme.palette.background.default
        }
      })
    }
  };
};
/**
 * Kickstart an elegant, consistent, and simple baseline to build upon.
 */

function CssBaseline(props) {
  /* eslint-disable no-unused-vars */
  var _props$children = props.children,
      children = _props$children === void 0 ? null : _props$children,
      classes = props.classes;
  /* eslint-enable no-unused-vars */

  return /*#__PURE__*/react.createElement(react.Fragment, null, children);
}

 false ? 0 : void 0;

if (false) {}

/* harmony default export */ var CssBaseline_CssBaseline = ((0,withStyles/* default */.Z)(styles, {
  name: 'MuiCssBaseline'
})(CssBaseline));
// EXTERNAL MODULE: ./node_modules/@material-ui/styles/esm/useTheme/ThemeContext.js
var ThemeContext = __webpack_require__(83800);
// EXTERNAL MODULE: ./node_modules/@material-ui/styles/esm/useTheme/useTheme.js
var useTheme = __webpack_require__(159);
// EXTERNAL MODULE: ./node_modules/@material-ui/styles/esm/ThemeProvider/nested.js
var nested = __webpack_require__(17076);
;// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/ThemeProvider/ThemeProvider.js






 // To support composition of theme.

function mergeOuterLocalTheme(outerTheme, localTheme) {
  if (typeof localTheme === 'function') {
    var mergedTheme = localTheme(outerTheme);

    if (false) {}

    return mergedTheme;
  }

  return (0,esm_extends/* default */.Z)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */


function ThemeProvider(props) {
  var children = props.children,
      localTheme = props.theme;
  var outerTheme = (0,useTheme/* default */.Z)();

  if (false) {}

  var theme = react.useMemo(function () {
    var output = outerTheme === null ? localTheme : mergeOuterLocalTheme(outerTheme, localTheme);

    if (output != null) {
      output[nested/* default */.Z] = outerTheme !== null;
    }

    return output;
  }, [localTheme, outerTheme]);
  return /*#__PURE__*/react.createElement(ThemeContext/* default.Provider */.Z.Provider, {
    value: theme
  }, children);
}

 false ? 0 : void 0;

if (false) {}

/* harmony default export */ var ThemeProvider_ThemeProvider = (ThemeProvider);
// EXTERNAL MODULE: ./node_modules/nprogress/nprogress.js
var nprogress = __webpack_require__(74865);
var nprogress_default = /*#__PURE__*/__webpack_require__.n(nprogress);
// EXTERNAL MODULE: ./node_modules/ua-parser-js/src/ua-parser.js
var ua_parser = __webpack_require__(42238);
var ua_parser_default = /*#__PURE__*/__webpack_require__.n(ua_parser);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/IconButton/IconButton.js
var IconButton = __webpack_require__(17812);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var esm_objectWithoutProperties = __webpack_require__(45987);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var esm_defineProperty = __webpack_require__(4942);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/transitions.js
var transitions = __webpack_require__(43366);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ClickAwayListener/ClickAwayListener.js
var ClickAwayListener = __webpack_require__(52795);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useEventCallback.js
var useEventCallback = __webpack_require__(55192);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/capitalize.js
var capitalize = __webpack_require__(93871);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/createChainedFunction.js
var createChainedFunction = __webpack_require__(82568);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grow/Grow.js
var Grow = __webpack_require__(20170);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Paper/Paper.js
var Paper = __webpack_require__(79895);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/colorManipulator.js
var colorManipulator = __webpack_require__(59693);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/SnackbarContent/SnackbarContent.js









var SnackbarContent_styles = function styles(theme) {
  var emphasis = theme.palette.type === 'light' ? 0.8 : 0.98;
  var backgroundColor = (0,colorManipulator/* emphasize */._4)(theme.palette.background.default, emphasis);
  return {
    /* Styles applied to the root element. */
    root: (0,esm_extends/* default */.Z)({}, theme.typography.body2, (0,esm_defineProperty/* default */.Z)({
      color: theme.palette.getContrastText(backgroundColor),
      backgroundColor: backgroundColor,
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      padding: '6px 16px',
      borderRadius: theme.shape.borderRadius,
      flexGrow: 1
    }, theme.breakpoints.up('sm'), {
      flexGrow: 'initial',
      minWidth: 288
    })),

    /* Styles applied to the message wrapper element. */
    message: {
      padding: '8px 0'
    },

    /* Styles applied to the action wrapper element if `action` is provided. */
    action: {
      display: 'flex',
      alignItems: 'center',
      marginLeft: 'auto',
      paddingLeft: 16,
      marginRight: -8
    }
  };
};
var SnackbarContent = /*#__PURE__*/react.forwardRef(function SnackbarContent(props, ref) {
  var action = props.action,
      classes = props.classes,
      className = props.className,
      message = props.message,
      _props$role = props.role,
      role = _props$role === void 0 ? 'alert' : _props$role,
      other = (0,esm_objectWithoutProperties/* default */.Z)(props, ["action", "classes", "className", "message", "role"]);

  return /*#__PURE__*/react.createElement(Paper/* default */.Z, (0,esm_extends/* default */.Z)({
    role: role,
    square: true,
    elevation: 6,
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    ref: ref
  }, other), /*#__PURE__*/react.createElement("div", {
    className: classes.message
  }, message), action ? /*#__PURE__*/react.createElement("div", {
    className: classes.action
  }, action) : null);
});
 false ? 0 : void 0;
/* harmony default export */ var SnackbarContent_SnackbarContent = ((0,withStyles/* default */.Z)(SnackbarContent_styles, {
  name: 'MuiSnackbarContent'
})(SnackbarContent));
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Snackbar/Snackbar.js















var Snackbar_styles = function styles(theme) {
  var top1 = {
    top: 8
  };
  var bottom1 = {
    bottom: 8
  };
  var right = {
    justifyContent: 'flex-end'
  };
  var left = {
    justifyContent: 'flex-start'
  };
  var top3 = {
    top: 24
  };
  var bottom3 = {
    bottom: 24
  };
  var right3 = {
    right: 24
  };
  var left3 = {
    left: 24
  };
  var center = {
    left: '50%',
    right: 'auto',
    transform: 'translateX(-50%)'
  };
  return {
    /* Styles applied to the root element. */
    root: {
      zIndex: theme.zIndex.snackbar,
      position: 'fixed',
      display: 'flex',
      left: 8,
      right: 8,
      justifyContent: 'center',
      alignItems: 'center'
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'center' }}`. */
    anchorOriginTopCenter: (0,esm_extends/* default */.Z)({}, top1, (0,esm_defineProperty/* default */.Z)({}, theme.breakpoints.up('sm'), (0,esm_extends/* default */.Z)({}, top3, center))),

    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'center' }}`. */
    anchorOriginBottomCenter: (0,esm_extends/* default */.Z)({}, bottom1, (0,esm_defineProperty/* default */.Z)({}, theme.breakpoints.up('sm'), (0,esm_extends/* default */.Z)({}, bottom3, center))),

    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }}`. */
    anchorOriginTopRight: (0,esm_extends/* default */.Z)({}, top1, right, (0,esm_defineProperty/* default */.Z)({}, theme.breakpoints.up('sm'), (0,esm_extends/* default */.Z)({
      left: 'auto'
    }, top3, right3))),

    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }}`. */
    anchorOriginBottomRight: (0,esm_extends/* default */.Z)({}, bottom1, right, (0,esm_defineProperty/* default */.Z)({}, theme.breakpoints.up('sm'), (0,esm_extends/* default */.Z)({
      left: 'auto'
    }, bottom3, right3))),

    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }}`. */
    anchorOriginTopLeft: (0,esm_extends/* default */.Z)({}, top1, left, (0,esm_defineProperty/* default */.Z)({}, theme.breakpoints.up('sm'), (0,esm_extends/* default */.Z)({
      right: 'auto'
    }, top3, left3))),

    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }}`. */
    anchorOriginBottomLeft: (0,esm_extends/* default */.Z)({}, bottom1, left, (0,esm_defineProperty/* default */.Z)({}, theme.breakpoints.up('sm'), (0,esm_extends/* default */.Z)({
      right: 'auto'
    }, bottom3, left3)))
  };
};
var Snackbar = /*#__PURE__*/react.forwardRef(function Snackbar(props, ref) {
  var action = props.action,
      _props$anchorOrigin = props.anchorOrigin;
  _props$anchorOrigin = _props$anchorOrigin === void 0 ? {
    vertical: 'bottom',
    horizontal: 'center'
  } : _props$anchorOrigin;

  var vertical = _props$anchorOrigin.vertical,
      horizontal = _props$anchorOrigin.horizontal,
      _props$autoHideDurati = props.autoHideDuration,
      autoHideDuration = _props$autoHideDurati === void 0 ? null : _props$autoHideDurati,
      children = props.children,
      classes = props.classes,
      className = props.className,
      ClickAwayListenerProps = props.ClickAwayListenerProps,
      ContentProps = props.ContentProps,
      _props$disableWindowB = props.disableWindowBlurListener,
      disableWindowBlurListener = _props$disableWindowB === void 0 ? false : _props$disableWindowB,
      message = props.message,
      onClose = props.onClose,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      onMouseEnter = props.onMouseEnter,
      onMouseLeave = props.onMouseLeave,
      open = props.open,
      resumeHideDuration = props.resumeHideDuration,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? Grow/* default */.Z : _props$TransitionComp,
      _props$transitionDura = props.transitionDuration,
      transitionDuration = _props$transitionDura === void 0 ? {
    enter: transitions/* duration.enteringScreen */.x9.enteringScreen,
    exit: transitions/* duration.leavingScreen */.x9.leavingScreen
  } : _props$transitionDura,
      TransitionProps = props.TransitionProps,
      other = (0,esm_objectWithoutProperties/* default */.Z)(props, ["action", "anchorOrigin", "autoHideDuration", "children", "classes", "className", "ClickAwayListenerProps", "ContentProps", "disableWindowBlurListener", "message", "onClose", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "onMouseEnter", "onMouseLeave", "open", "resumeHideDuration", "TransitionComponent", "transitionDuration", "TransitionProps"]);

  var timerAutoHide = react.useRef();

  var _React$useState = react.useState(true),
      exited = _React$useState[0],
      setExited = _React$useState[1];

  var handleClose = (0,useEventCallback/* default */.Z)(function () {
    if (onClose) {
      onClose.apply(void 0, arguments);
    }
  });
  var setAutoHideTimer = (0,useEventCallback/* default */.Z)(function (autoHideDurationParam) {
    if (!onClose || autoHideDurationParam == null) {
      return;
    }

    clearTimeout(timerAutoHide.current);
    timerAutoHide.current = setTimeout(function () {
      handleClose(null, 'timeout');
    }, autoHideDurationParam);
  });
  react.useEffect(function () {
    if (open) {
      setAutoHideTimer(autoHideDuration);
    }

    return function () {
      clearTimeout(timerAutoHide.current);
    };
  }, [open, autoHideDuration, setAutoHideTimer]); // Pause the timer when the user is interacting with the Snackbar
  // or when the user hide the window.

  var handlePause = function handlePause() {
    clearTimeout(timerAutoHide.current);
  }; // Restart the timer when the user is no longer interacting with the Snackbar
  // or when the window is shown back.


  var handleResume = react.useCallback(function () {
    if (autoHideDuration != null) {
      setAutoHideTimer(resumeHideDuration != null ? resumeHideDuration : autoHideDuration * 0.5);
    }
  }, [autoHideDuration, resumeHideDuration, setAutoHideTimer]);

  var handleMouseEnter = function handleMouseEnter(event) {
    if (onMouseEnter) {
      onMouseEnter(event);
    }

    handlePause();
  };

  var handleMouseLeave = function handleMouseLeave(event) {
    if (onMouseLeave) {
      onMouseLeave(event);
    }

    handleResume();
  };

  var handleClickAway = function handleClickAway(event) {
    if (onClose) {
      onClose(event, 'clickaway');
    }
  };

  var handleExited = function handleExited() {
    setExited(true);
  };

  var handleEnter = function handleEnter() {
    setExited(false);
  };

  react.useEffect(function () {
    if (!disableWindowBlurListener && open) {
      window.addEventListener('focus', handleResume);
      window.addEventListener('blur', handlePause);
      return function () {
        window.removeEventListener('focus', handleResume);
        window.removeEventListener('blur', handlePause);
      };
    }

    return undefined;
  }, [disableWindowBlurListener, handleResume, open]); // So we only render active snackbars.

  if (!open && exited) {
    return null;
  }

  return /*#__PURE__*/react.createElement(ClickAwayListener/* default */.Z, (0,esm_extends/* default */.Z)({
    onClickAway: handleClickAway
  }, ClickAwayListenerProps), /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({
    className: (0,clsx_m/* default */.Z)(classes.root, classes["anchorOrigin".concat((0,capitalize/* default */.Z)(vertical)).concat((0,capitalize/* default */.Z)(horizontal))], className),
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    ref: ref
  }, other), /*#__PURE__*/react.createElement(TransitionComponent, (0,esm_extends/* default */.Z)({
    appear: true,
    in: open,
    onEnter: (0,createChainedFunction/* default */.Z)(handleEnter, onEnter),
    onEntered: onEntered,
    onEntering: onEntering,
    onExit: onExit,
    onExited: (0,createChainedFunction/* default */.Z)(handleExited, onExited),
    onExiting: onExiting,
    timeout: transitionDuration,
    direction: vertical === 'top' ? 'down' : 'up'
  }, TransitionProps), children || /*#__PURE__*/react.createElement(SnackbarContent_SnackbarContent, (0,esm_extends/* default */.Z)({
    message: message,
    action: action
  }, ContentProps)))));
});
 false ? 0 : void 0;
/* harmony default export */ var Snackbar_Snackbar = ((0,withStyles/* default */.Z)(Snackbar_styles, {
  flip: false,
  name: 'MuiSnackbar'
})(Snackbar));
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Close.js
var Close = __webpack_require__(80366);
// EXTERNAL MODULE: ./lib/apollo/policies/index.ts + 23 modules
var policies = __webpack_require__(54734);
;// CONCATENATED MODULE: ./components/Snackbar.tsx
var Snackbar_templateObject, _templateObject2;














var GET_SNACKBAR = (0,lib/* default */.ZP)(Snackbar_templateObject || (Snackbar_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  query snackbar {\n    snackbar @client\n  }\n"])));





var CLOSE_SNACKBAR = (0,lib/* default */.ZP)(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  mutation closeSnackbar {\n    closeSnackbar @client\n  }\n"])));





var components_Snackbar_styles = function styles(theme) {return {
    close: {
      padding: theme.spacing(1 / 2) } };};







var SnackBar = function SnackBar(props) {
  var theme = (0,react.useContext)(styled_components_browser_esm.ThemeContext);
  var locale = (0,react.useContext)(languageContext/* default */.Z);
  var _useQuery = (0,useQuery/* useQuery */.a)(GET_SNACKBAR),data = _useQuery.data;

  var snackbar = data === null || data === void 0 ? void 0 : data.snackbar;
  if (!(snackbar !== null && snackbar !== void 0 && snackbar.isSnackBarOpen)) {
    return null;
  }

  var _ref = snackbar.origin || {},_ref$vertical = _ref.vertical,vertical = _ref$vertical === void 0 ? 'bottom' : _ref$vertical,_ref$horizontal = _ref.horizontal,horizontal = _ref$horizontal === void 0 ? 'left' : _ref$horizontal;

  var styles = {};
  if (snackbar.goTo !== 'NONE') {
    styles['cursor'] = 'pointer';
  }
  // this is not working properly
  if (snackbar.theme === 'error') {
    styles['backgroundColor'] = theme.colors.secondary['red-1'];
  }

  var handleClose = function handleClose() {
    (0,policies/* snackbarVar */.Ck)({ isSnackBarOpen: false });
  };

  var duration = snackbar.hasOwnProperty('duration') ?
  snackbar.duration :
  7000;

  return /*#__PURE__*/(
    (0,jsx_runtime.jsx)(Snackbar_Snackbar, {
      style: styles,
      anchorOrigin: {
        vertical: vertical,
        horizontal: horizontal },

      open: snackbar.isSnackBarOpen,
      autoHideDuration: duration,
      onClose: handleClose,
      message: /*#__PURE__*/
      (0,jsx_runtime.jsxs)(Grid/* Flex */.kC, {
        flexWrap: "nowrap",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center", children: [/*#__PURE__*/

        (0,jsx_runtime.jsx)(Grid/* Box */.xu, { mr: 15, children: snackbar.snackBarMessage }),
        snackbar.goTo ? /*#__PURE__*/
        (0,jsx_runtime.jsx)(Grid/* Box */.xu, { children: /*#__PURE__*/
          (0,jsx_runtime.jsxs)(buttons/* default */.ZP, {
            appearance: "link",
            onClick: function onClick() {
              if (snackbar.goTo === 'FAVORITES') {
                router_default().push("/[lang]/me/favorites?id=videos&lang=".concat(
                locale), "/".concat(
                locale, "/me/favorites/videos"));

              } else if (snackbar.goTo === 'PLAYLISTS') {
                router_default().replace("/[lang]/me/playlists", "/".concat(

                locale, "/me/playlists"));

              } else if (snackbar.goTo === 'PLAYLIST') {
                router_default().replace("/[lang]/playlists/[id]", "/".concat(

                locale, "/playlists/").concat(snackbar.id));

              } else if (snackbar.goTo === 'FAQ') {
                window.open("/".concat(locale, "/faq"), '_blank');
              }
            }, children: [

            snackbar.goTo === 'FAQ' && /*#__PURE__*/
            (0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "snackbar.faq", message: "FAQ page" }),

            snackbar.goTo === 'FAVORITES' && /*#__PURE__*/
            (0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "snackbar.favorites", message: "Favorites" }),

            snackbar.goTo === 'PLAYLISTS' && /*#__PURE__*/
            (0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "snackbar.playlists", message: "Playlists" }),

            snackbar.goTo === 'PLAYLIST' && /*#__PURE__*/
            (0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "snackbar.playlist", message: "View Playlist" })] }) }) :



        null] }),


      action: [/*#__PURE__*/
      (0,jsx_runtime.jsx)(IconButton/* default */.Z, {

        "aria-label": "Close",
        color: "inherit",
        className: props.classes.close,
        onClick: handleClose, children: /*#__PURE__*/

        (0,jsx_runtime.jsx)(Close/* default */.Z, {}) }, "close")] }));




};

/* harmony default export */ var components_Snackbar = ((0,withStyles/* default */.Z)(components_Snackbar_styles)(SnackBar));
;// CONCATENATED MODULE: ./lib/redirect.ts


// TODO: clean up all occurances of 2nd arg of redirect
// next now support only asPath routing
function redirect(context, asPath) {
  if (context !== null && context !== void 0 && context.res) {
    // server
    // 303: "See other"
    context.res.writeHead(303, { Location: asPath });
    context.res.end();
  } else {
    // In the browser, we just pretend like this never even happened ;)
    router_default().replace(asPath);
  }
}
;// CONCATENATED MODULE: ./node_modules/make-plural/plurals.mjs
function a(n, ord) {
  if (ord) return 'other';
  return n == 1 ? 'one' : 'other';
}
function b(n, ord) {
  if (ord) return 'other';
  return (n == 0 || n == 1) ? 'one' : 'other';
}
function c(n, ord) {
  var s = String(n).split('.'), v0 = !s[1];
  if (ord) return 'other';
  return n == 1 && v0 ? 'one' : 'other';
}
function d(n, ord) {
  return 'other';
}
function e(n, ord) {
  if (ord) return 'other';
  return n == 1 ? 'one'
    : n == 2 ? 'two'
    : 'other';
}

const _in = (/* unused pure expression or super */ null && (d));
const af = (/* unused pure expression or super */ null && (a));
const ak = (/* unused pure expression or super */ null && (b));
function am(n, ord) {
  if (ord) return 'other';
  return n >= 0 && n <= 1 ? 'one' : 'other';
}
const an = (/* unused pure expression or super */ null && (a));
function ar(n, ord) {
  var s = String(n).split('.'), t0 = Number(s[0]) == n, n100 = t0 && s[0].slice(-2);
  if (ord) return 'other';
  return n == 0 ? 'zero'
    : n == 1 ? 'one'
    : n == 2 ? 'two'
    : (n100 >= 3 && n100 <= 10) ? 'few'
    : (n100 >= 11 && n100 <= 99) ? 'many'
    : 'other';
}
function ars(n, ord) {
  var s = String(n).split('.'), t0 = Number(s[0]) == n, n100 = t0 && s[0].slice(-2);
  if (ord) return 'other';
  return n == 0 ? 'zero'
    : n == 1 ? 'one'
    : n == 2 ? 'two'
    : (n100 >= 3 && n100 <= 10) ? 'few'
    : (n100 >= 11 && n100 <= 99) ? 'many'
    : 'other';
}
function as(n, ord) {
  if (ord) return (n == 1 || n == 5 || n == 7 || n == 8 || n == 9 || n == 10) ? 'one'
    : (n == 2 || n == 3) ? 'two'
    : n == 4 ? 'few'
    : n == 6 ? 'many'
    : 'other';
  return n >= 0 && n <= 1 ? 'one' : 'other';
}
const asa = (/* unused pure expression or super */ null && (a));
const ast = (/* unused pure expression or super */ null && (c));
function az(n, ord) {
  var s = String(n).split('.'), i = s[0], i10 = i.slice(-1), i100 = i.slice(-2), i1000 = i.slice(-3);
  if (ord) return (i10 == 1 || i10 == 2 || i10 == 5 || i10 == 7 || i10 == 8) || (i100 == 20 || i100 == 50 || i100 == 70 || i100 == 80) ? 'one'
    : (i10 == 3 || i10 == 4) || (i1000 == 100 || i1000 == 200 || i1000 == 300 || i1000 == 400 || i1000 == 500 || i1000 == 600 || i1000 == 700 || i1000 == 800 || i1000 == 900) ? 'few'
    : i == 0 || i10 == 6 || (i100 == 40 || i100 == 60 || i100 == 90) ? 'many'
    : 'other';
  return n == 1 ? 'one' : 'other';
}
function be(n, ord) {
  var s = String(n).split('.'), t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
  if (ord) return (n10 == 2 || n10 == 3) && n100 != 12 && n100 != 13 ? 'few' : 'other';
  return n10 == 1 && n100 != 11 ? 'one'
    : (n10 >= 2 && n10 <= 4) && (n100 < 12 || n100 > 14) ? 'few'
    : t0 && n10 == 0 || (n10 >= 5 && n10 <= 9) || (n100 >= 11 && n100 <= 14) ? 'many'
    : 'other';
}
const bem = (/* unused pure expression or super */ null && (a));
const bez = (/* unused pure expression or super */ null && (a));
const bg = (/* unused pure expression or super */ null && (a));
const bho = (/* unused pure expression or super */ null && (b));
const bm = (/* unused pure expression or super */ null && (d));
function bn(n, ord) {
  if (ord) return (n == 1 || n == 5 || n == 7 || n == 8 || n == 9 || n == 10) ? 'one'
    : (n == 2 || n == 3) ? 'two'
    : n == 4 ? 'few'
    : n == 6 ? 'many'
    : 'other';
  return n >= 0 && n <= 1 ? 'one' : 'other';
}
const bo = (/* unused pure expression or super */ null && (d));
function br(n, ord) {
  var s = String(n).split('.'), t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2), n1000000 = t0 && s[0].slice(-6);
  if (ord) return 'other';
  return n10 == 1 && n100 != 11 && n100 != 71 && n100 != 91 ? 'one'
    : n10 == 2 && n100 != 12 && n100 != 72 && n100 != 92 ? 'two'
    : ((n10 == 3 || n10 == 4) || n10 == 9) && (n100 < 10 || n100 > 19) && (n100 < 70 || n100 > 79) && (n100 < 90 || n100 > 99) ? 'few'
    : n != 0 && t0 && n1000000 == 0 ? 'many'
    : 'other';
}
const brx = (/* unused pure expression or super */ null && (a));
function bs(n, ord) {
  var s = String(n).split('.'), i = s[0], f = s[1] || '', v0 = !s[1], i10 = i.slice(-1), i100 = i.slice(-2), f10 = f.slice(-1), f100 = f.slice(-2);
  if (ord) return 'other';
  return v0 && i10 == 1 && i100 != 11 || f10 == 1 && f100 != 11 ? 'one'
    : v0 && (i10 >= 2 && i10 <= 4) && (i100 < 12 || i100 > 14) || (f10 >= 2 && f10 <= 4) && (f100 < 12 || f100 > 14) ? 'few'
    : 'other';
}
function ca(n, ord) {
  var s = String(n).split('.'), v0 = !s[1];
  if (ord) return (n == 1 || n == 3) ? 'one'
    : n == 2 ? 'two'
    : n == 4 ? 'few'
    : 'other';
  return n == 1 && v0 ? 'one' : 'other';
}
const ce = (/* unused pure expression or super */ null && (a));
function ceb(n, ord) {
  var s = String(n).split('.'), i = s[0], f = s[1] || '', v0 = !s[1], i10 = i.slice(-1), f10 = f.slice(-1);
  if (ord) return 'other';
  return v0 && (i == 1 || i == 2 || i == 3) || v0 && i10 != 4 && i10 != 6 && i10 != 9 || !v0 && f10 != 4 && f10 != 6 && f10 != 9 ? 'one' : 'other';
}
const cgg = (/* unused pure expression or super */ null && (a));
const chr = (/* unused pure expression or super */ null && (a));
const ckb = (/* unused pure expression or super */ null && (a));
function cs(n, ord) {
  var s = String(n).split('.'), i = s[0], v0 = !s[1];
  if (ord) return 'other';
  return n == 1 && v0 ? 'one'
    : (i >= 2 && i <= 4) && v0 ? 'few'
    : !v0 ? 'many'
    : 'other';
}
function cy(n, ord) {
  if (ord) return (n == 0 || n == 7 || n == 8 || n == 9) ? 'zero'
    : n == 1 ? 'one'
    : n == 2 ? 'two'
    : (n == 3 || n == 4) ? 'few'
    : (n == 5 || n == 6) ? 'many'
    : 'other';
  return n == 0 ? 'zero'
    : n == 1 ? 'one'
    : n == 2 ? 'two'
    : n == 3 ? 'few'
    : n == 6 ? 'many'
    : 'other';
}
function da(n, ord) {
  var s = String(n).split('.'), i = s[0], t0 = Number(s[0]) == n;
  if (ord) return 'other';
  return n == 1 || !t0 && (i == 0 || i == 1) ? 'one' : 'other';
}
const de = (/* unused pure expression or super */ null && (c));
function dsb(n, ord) {
  var s = String(n).split('.'), i = s[0], f = s[1] || '', v0 = !s[1], i100 = i.slice(-2), f100 = f.slice(-2);
  if (ord) return 'other';
  return v0 && i100 == 1 || f100 == 1 ? 'one'
    : v0 && i100 == 2 || f100 == 2 ? 'two'
    : v0 && (i100 == 3 || i100 == 4) || (f100 == 3 || f100 == 4) ? 'few'
    : 'other';
}
const dv = (/* unused pure expression or super */ null && (a));
const dz = (/* unused pure expression or super */ null && (d));
const ee = (/* unused pure expression or super */ null && (a));
const el = (/* unused pure expression or super */ null && (a));
function en(n, ord) {
  var s = String(n).split('.'), v0 = !s[1], t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
  if (ord) return n10 == 1 && n100 != 11 ? 'one'
    : n10 == 2 && n100 != 12 ? 'two'
    : n10 == 3 && n100 != 13 ? 'few'
    : 'other';
  return n == 1 && v0 ? 'one' : 'other';
}
const eo = (/* unused pure expression or super */ null && (a));
const es = (/* unused pure expression or super */ null && (a));
const et = (/* unused pure expression or super */ null && (c));
const eu = (/* unused pure expression or super */ null && (a));
function fa(n, ord) {
  if (ord) return 'other';
  return n >= 0 && n <= 1 ? 'one' : 'other';
}
function ff(n, ord) {
  if (ord) return 'other';
  return n >= 0 && n < 2 ? 'one' : 'other';
}
const fi = c;
function fil(n, ord) {
  var s = String(n).split('.'), i = s[0], f = s[1] || '', v0 = !s[1], i10 = i.slice(-1), f10 = f.slice(-1);
  if (ord) return n == 1 ? 'one' : 'other';
  return v0 && (i == 1 || i == 2 || i == 3) || v0 && i10 != 4 && i10 != 6 && i10 != 9 || !v0 && f10 != 4 && f10 != 6 && f10 != 9 ? 'one' : 'other';
}
const fo = (/* unused pure expression or super */ null && (a));
function fr(n, ord) {
  if (ord) return n == 1 ? 'one' : 'other';
  return n >= 0 && n < 2 ? 'one' : 'other';
}
const fur = (/* unused pure expression or super */ null && (a));
const fy = (/* unused pure expression or super */ null && (c));
function ga(n, ord) {
  var s = String(n).split('.'), t0 = Number(s[0]) == n;
  if (ord) return n == 1 ? 'one' : 'other';
  return n == 1 ? 'one'
    : n == 2 ? 'two'
    : (t0 && n >= 3 && n <= 6) ? 'few'
    : (t0 && n >= 7 && n <= 10) ? 'many'
    : 'other';
}
function gd(n, ord) {
  var s = String(n).split('.'), t0 = Number(s[0]) == n;
  if (ord) return (n == 1 || n == 11) ? 'one'
    : (n == 2 || n == 12) ? 'two'
    : (n == 3 || n == 13) ? 'few'
    : 'other';
  return (n == 1 || n == 11) ? 'one'
    : (n == 2 || n == 12) ? 'two'
    : ((t0 && n >= 3 && n <= 10) || (t0 && n >= 13 && n <= 19)) ? 'few'
    : 'other';
}
const gl = (/* unused pure expression or super */ null && (c));
const gsw = (/* unused pure expression or super */ null && (a));
function gu(n, ord) {
  if (ord) return n == 1 ? 'one'
    : (n == 2 || n == 3) ? 'two'
    : n == 4 ? 'few'
    : n == 6 ? 'many'
    : 'other';
  return n >= 0 && n <= 1 ? 'one' : 'other';
}
const guw = (/* unused pure expression or super */ null && (b));
function gv(n, ord) {
  var s = String(n).split('.'), i = s[0], v0 = !s[1], i10 = i.slice(-1), i100 = i.slice(-2);
  if (ord) return 'other';
  return v0 && i10 == 1 ? 'one'
    : v0 && i10 == 2 ? 'two'
    : v0 && (i100 == 0 || i100 == 20 || i100 == 40 || i100 == 60 || i100 == 80) ? 'few'
    : !v0 ? 'many'
    : 'other';
}
const ha = (/* unused pure expression or super */ null && (a));
const haw = (/* unused pure expression or super */ null && (a));
function he(n, ord) {
  var s = String(n).split('.'), i = s[0], v0 = !s[1], t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1);
  if (ord) return 'other';
  return n == 1 && v0 ? 'one'
    : i == 2 && v0 ? 'two'
    : v0 && (n < 0 || n > 10) && t0 && n10 == 0 ? 'many'
    : 'other';
}
function hi(n, ord) {
  if (ord) return n == 1 ? 'one'
    : (n == 2 || n == 3) ? 'two'
    : n == 4 ? 'few'
    : n == 6 ? 'many'
    : 'other';
  return n >= 0 && n <= 1 ? 'one' : 'other';
}
function hr(n, ord) {
  var s = String(n).split('.'), i = s[0], f = s[1] || '', v0 = !s[1], i10 = i.slice(-1), i100 = i.slice(-2), f10 = f.slice(-1), f100 = f.slice(-2);
  if (ord) return 'other';
  return v0 && i10 == 1 && i100 != 11 || f10 == 1 && f100 != 11 ? 'one'
    : v0 && (i10 >= 2 && i10 <= 4) && (i100 < 12 || i100 > 14) || (f10 >= 2 && f10 <= 4) && (f100 < 12 || f100 > 14) ? 'few'
    : 'other';
}
function hsb(n, ord) {
  var s = String(n).split('.'), i = s[0], f = s[1] || '', v0 = !s[1], i100 = i.slice(-2), f100 = f.slice(-2);
  if (ord) return 'other';
  return v0 && i100 == 1 || f100 == 1 ? 'one'
    : v0 && i100 == 2 || f100 == 2 ? 'two'
    : v0 && (i100 == 3 || i100 == 4) || (f100 == 3 || f100 == 4) ? 'few'
    : 'other';
}
function hu(n, ord) {
  if (ord) return (n == 1 || n == 5) ? 'one' : 'other';
  return n == 1 ? 'one' : 'other';
}
function hy(n, ord) {
  if (ord) return n == 1 ? 'one' : 'other';
  return n >= 0 && n < 2 ? 'one' : 'other';
}
const ia = (/* unused pure expression or super */ null && (c));
const id = (/* unused pure expression or super */ null && (d));
const ig = (/* unused pure expression or super */ null && (d));
const ii = (/* unused pure expression or super */ null && (d));
const io = (/* unused pure expression or super */ null && (c));
function is(n, ord) {
  var s = String(n).split('.'), i = s[0], t0 = Number(s[0]) == n, i10 = i.slice(-1), i100 = i.slice(-2);
  if (ord) return 'other';
  return t0 && i10 == 1 && i100 != 11 || !t0 ? 'one' : 'other';
}
function it(n, ord) {
  var s = String(n).split('.'), v0 = !s[1];
  if (ord) return (n == 11 || n == 8 || n == 80 || n == 800) ? 'many' : 'other';
  return n == 1 && v0 ? 'one' : 'other';
}
const iu = (/* unused pure expression or super */ null && (e));
function iw(n, ord) {
  var s = String(n).split('.'), i = s[0], v0 = !s[1], t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1);
  if (ord) return 'other';
  return n == 1 && v0 ? 'one'
    : i == 2 && v0 ? 'two'
    : v0 && (n < 0 || n > 10) && t0 && n10 == 0 ? 'many'
    : 'other';
}
const ja = (/* unused pure expression or super */ null && (d));
const jbo = (/* unused pure expression or super */ null && (d));
const jgo = (/* unused pure expression or super */ null && (a));
const ji = (/* unused pure expression or super */ null && (c));
const jmc = (/* unused pure expression or super */ null && (a));
const jv = (/* unused pure expression or super */ null && (d));
const jw = (/* unused pure expression or super */ null && (d));
function ka(n, ord) {
  var s = String(n).split('.'), i = s[0], i100 = i.slice(-2);
  if (ord) return i == 1 ? 'one'
    : i == 0 || ((i100 >= 2 && i100 <= 20) || i100 == 40 || i100 == 60 || i100 == 80) ? 'many'
    : 'other';
  return n == 1 ? 'one' : 'other';
}
function kab(n, ord) {
  if (ord) return 'other';
  return n >= 0 && n < 2 ? 'one' : 'other';
}
const kaj = (/* unused pure expression or super */ null && (a));
const kcg = (/* unused pure expression or super */ null && (a));
const kde = (/* unused pure expression or super */ null && (d));
const kea = (/* unused pure expression or super */ null && (d));
function kk(n, ord) {
  var s = String(n).split('.'), t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1);
  if (ord) return n10 == 6 || n10 == 9 || t0 && n10 == 0 && n != 0 ? 'many' : 'other';
  return n == 1 ? 'one' : 'other';
}
const kkj = (/* unused pure expression or super */ null && (a));
const kl = (/* unused pure expression or super */ null && (a));
const km = (/* unused pure expression or super */ null && (d));
function kn(n, ord) {
  if (ord) return 'other';
  return n >= 0 && n <= 1 ? 'one' : 'other';
}
const ko = (/* unused pure expression or super */ null && (d));
const ks = (/* unused pure expression or super */ null && (a));
const ksb = (/* unused pure expression or super */ null && (a));
function ksh(n, ord) {
  if (ord) return 'other';
  return n == 0 ? 'zero'
    : n == 1 ? 'one'
    : 'other';
}
const ku = (/* unused pure expression or super */ null && (a));
function kw(n, ord) {
  var s = String(n).split('.'), t0 = Number(s[0]) == n, n100 = t0 && s[0].slice(-2), n1000 = t0 && s[0].slice(-3), n100000 = t0 && s[0].slice(-5), n1000000 = t0 && s[0].slice(-6);
  if (ord) return (t0 && n >= 1 && n <= 4) || ((n100 >= 1 && n100 <= 4) || (n100 >= 21 && n100 <= 24) || (n100 >= 41 && n100 <= 44) || (n100 >= 61 && n100 <= 64) || (n100 >= 81 && n100 <= 84)) ? 'one'
    : n == 5 || n100 == 5 ? 'many'
    : 'other';
  return n == 0 ? 'zero'
    : n == 1 ? 'one'
    : (n100 == 2 || n100 == 22 || n100 == 42 || n100 == 62 || n100 == 82) || t0 && n1000 == 0 && ((n100000 >= 1000 && n100000 <= 20000) || n100000 == 40000 || n100000 == 60000 || n100000 == 80000) || n != 0 && n1000000 == 100000 ? 'two'
    : (n100 == 3 || n100 == 23 || n100 == 43 || n100 == 63 || n100 == 83) ? 'few'
    : n != 1 && (n100 == 1 || n100 == 21 || n100 == 41 || n100 == 61 || n100 == 81) ? 'many'
    : 'other';
}
const ky = (/* unused pure expression or super */ null && (a));
function lag(n, ord) {
  var s = String(n).split('.'), i = s[0];
  if (ord) return 'other';
  return n == 0 ? 'zero'
    : (i == 0 || i == 1) && n != 0 ? 'one'
    : 'other';
}
const lb = (/* unused pure expression or super */ null && (a));
const lg = (/* unused pure expression or super */ null && (a));
const lkt = (/* unused pure expression or super */ null && (d));
const ln = (/* unused pure expression or super */ null && (b));
function lo(n, ord) {
  if (ord) return n == 1 ? 'one' : 'other';
  return 'other';
}
function lt(n, ord) {
  var s = String(n).split('.'), f = s[1] || '', t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
  if (ord) return 'other';
  return n10 == 1 && (n100 < 11 || n100 > 19) ? 'one'
    : (n10 >= 2 && n10 <= 9) && (n100 < 11 || n100 > 19) ? 'few'
    : f != 0 ? 'many'
    : 'other';
}
function lv(n, ord) {
  var s = String(n).split('.'), f = s[1] || '', v = f.length, t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2), f100 = f.slice(-2), f10 = f.slice(-1);
  if (ord) return 'other';
  return t0 && n10 == 0 || (n100 >= 11 && n100 <= 19) || v == 2 && (f100 >= 11 && f100 <= 19) ? 'zero'
    : n10 == 1 && n100 != 11 || v == 2 && f10 == 1 && f100 != 11 || v != 2 && f10 == 1 ? 'one'
    : 'other';
}
const mas = (/* unused pure expression or super */ null && (a));
const mg = (/* unused pure expression or super */ null && (b));
const mgo = (/* unused pure expression or super */ null && (a));
function mk(n, ord) {
  var s = String(n).split('.'), i = s[0], f = s[1] || '', v0 = !s[1], i10 = i.slice(-1), i100 = i.slice(-2), f10 = f.slice(-1), f100 = f.slice(-2);
  if (ord) return i10 == 1 && i100 != 11 ? 'one'
    : i10 == 2 && i100 != 12 ? 'two'
    : (i10 == 7 || i10 == 8) && i100 != 17 && i100 != 18 ? 'many'
    : 'other';
  return v0 && i10 == 1 && i100 != 11 || f10 == 1 && f100 != 11 ? 'one' : 'other';
}
const ml = (/* unused pure expression or super */ null && (a));
const mn = (/* unused pure expression or super */ null && (a));
function mo(n, ord) {
  var s = String(n).split('.'), v0 = !s[1], t0 = Number(s[0]) == n, n100 = t0 && s[0].slice(-2);
  if (ord) return n == 1 ? 'one' : 'other';
  return n == 1 && v0 ? 'one'
    : !v0 || n == 0 || (n100 >= 2 && n100 <= 19) ? 'few'
    : 'other';
}
function mr(n, ord) {
  if (ord) return n == 1 ? 'one'
    : (n == 2 || n == 3) ? 'two'
    : n == 4 ? 'few'
    : 'other';
  return n == 1 ? 'one' : 'other';
}
function ms(n, ord) {
  if (ord) return n == 1 ? 'one' : 'other';
  return 'other';
}
function mt(n, ord) {
  var s = String(n).split('.'), t0 = Number(s[0]) == n, n100 = t0 && s[0].slice(-2);
  if (ord) return 'other';
  return n == 1 ? 'one'
    : n == 0 || (n100 >= 2 && n100 <= 10) ? 'few'
    : (n100 >= 11 && n100 <= 19) ? 'many'
    : 'other';
}
const my = (/* unused pure expression or super */ null && (d));
const nah = (/* unused pure expression or super */ null && (a));
const naq = (/* unused pure expression or super */ null && (e));
const nb = (/* unused pure expression or super */ null && (a));
const nd = (/* unused pure expression or super */ null && (a));
function ne(n, ord) {
  var s = String(n).split('.'), t0 = Number(s[0]) == n;
  if (ord) return (t0 && n >= 1 && n <= 4) ? 'one' : 'other';
  return n == 1 ? 'one' : 'other';
}
const nl = (/* unused pure expression or super */ null && (c));
const nn = (/* unused pure expression or super */ null && (a));
const nnh = (/* unused pure expression or super */ null && (a));
const no = a;
const nqo = (/* unused pure expression or super */ null && (d));
const nr = (/* unused pure expression or super */ null && (a));
const nso = (/* unused pure expression or super */ null && (b));
const ny = (/* unused pure expression or super */ null && (a));
const nyn = (/* unused pure expression or super */ null && (a));
const om = (/* unused pure expression or super */ null && (a));
function or(n, ord) {
  var s = String(n).split('.'), t0 = Number(s[0]) == n;
  if (ord) return (n == 1 || n == 5 || (t0 && n >= 7 && n <= 9)) ? 'one'
    : (n == 2 || n == 3) ? 'two'
    : n == 4 ? 'few'
    : n == 6 ? 'many'
    : 'other';
  return n == 1 ? 'one' : 'other';
}
const os = (/* unused pure expression or super */ null && (a));
const osa = (/* unused pure expression or super */ null && (d));
const pa = (/* unused pure expression or super */ null && (b));
const pap = (/* unused pure expression or super */ null && (a));
function pl(n, ord) {
  var s = String(n).split('.'), i = s[0], v0 = !s[1], i10 = i.slice(-1), i100 = i.slice(-2);
  if (ord) return 'other';
  return n == 1 && v0 ? 'one'
    : v0 && (i10 >= 2 && i10 <= 4) && (i100 < 12 || i100 > 14) ? 'few'
    : v0 && i != 1 && (i10 == 0 || i10 == 1) || v0 && (i10 >= 5 && i10 <= 9) || v0 && (i100 >= 12 && i100 <= 14) ? 'many'
    : 'other';
}
function prg(n, ord) {
  var s = String(n).split('.'), f = s[1] || '', v = f.length, t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2), f100 = f.slice(-2), f10 = f.slice(-1);
  if (ord) return 'other';
  return t0 && n10 == 0 || (n100 >= 11 && n100 <= 19) || v == 2 && (f100 >= 11 && f100 <= 19) ? 'zero'
    : n10 == 1 && n100 != 11 || v == 2 && f10 == 1 && f100 != 11 || v != 2 && f10 == 1 ? 'one'
    : 'other';
}
const ps = (/* unused pure expression or super */ null && (a));
function pt(n, ord) {
  var s = String(n).split('.'), i = s[0];
  if (ord) return 'other';
  return (i == 0 || i == 1) ? 'one' : 'other';
}
const pt_PT = (/* unused pure expression or super */ null && (c));
const rm = (/* unused pure expression or super */ null && (a));
function ro(n, ord) {
  var s = String(n).split('.'), v0 = !s[1], t0 = Number(s[0]) == n, n100 = t0 && s[0].slice(-2);
  if (ord) return n == 1 ? 'one' : 'other';
  return n == 1 && v0 ? 'one'
    : !v0 || n == 0 || (n100 >= 2 && n100 <= 19) ? 'few'
    : 'other';
}
const rof = (/* unused pure expression or super */ null && (a));
const root = (/* unused pure expression or super */ null && (d));
function ru(n, ord) {
  var s = String(n).split('.'), i = s[0], v0 = !s[1], i10 = i.slice(-1), i100 = i.slice(-2);
  if (ord) return 'other';
  return v0 && i10 == 1 && i100 != 11 ? 'one'
    : v0 && (i10 >= 2 && i10 <= 4) && (i100 < 12 || i100 > 14) ? 'few'
    : v0 && i10 == 0 || v0 && (i10 >= 5 && i10 <= 9) || v0 && (i100 >= 11 && i100 <= 14) ? 'many'
    : 'other';
}
const rwk = (/* unused pure expression or super */ null && (a));
const sah = (/* unused pure expression or super */ null && (d));
const saq = (/* unused pure expression or super */ null && (a));
function sc(n, ord) {
  var s = String(n).split('.'), v0 = !s[1];
  if (ord) return (n == 11 || n == 8 || n == 80 || n == 800) ? 'many' : 'other';
  return n == 1 && v0 ? 'one' : 'other';
}
function scn(n, ord) {
  var s = String(n).split('.'), v0 = !s[1];
  if (ord) return (n == 11 || n == 8 || n == 80 || n == 800) ? 'many' : 'other';
  return n == 1 && v0 ? 'one' : 'other';
}
const sd = (/* unused pure expression or super */ null && (a));
const sdh = (/* unused pure expression or super */ null && (a));
const se = e;
const seh = (/* unused pure expression or super */ null && (a));
const ses = (/* unused pure expression or super */ null && (d));
const sg = (/* unused pure expression or super */ null && (d));
function sh(n, ord) {
  var s = String(n).split('.'), i = s[0], f = s[1] || '', v0 = !s[1], i10 = i.slice(-1), i100 = i.slice(-2), f10 = f.slice(-1), f100 = f.slice(-2);
  if (ord) return 'other';
  return v0 && i10 == 1 && i100 != 11 || f10 == 1 && f100 != 11 ? 'one'
    : v0 && (i10 >= 2 && i10 <= 4) && (i100 < 12 || i100 > 14) || (f10 >= 2 && f10 <= 4) && (f100 < 12 || f100 > 14) ? 'few'
    : 'other';
}
function shi(n, ord) {
  var s = String(n).split('.'), t0 = Number(s[0]) == n;
  if (ord) return 'other';
  return n >= 0 && n <= 1 ? 'one'
    : (t0 && n >= 2 && n <= 10) ? 'few'
    : 'other';
}
function si(n, ord) {
  var s = String(n).split('.'), i = s[0], f = s[1] || '';
  if (ord) return 'other';
  return (n == 0 || n == 1) || i == 0 && f == 1 ? 'one' : 'other';
}
function sk(n, ord) {
  var s = String(n).split('.'), i = s[0], v0 = !s[1];
  if (ord) return 'other';
  return n == 1 && v0 ? 'one'
    : (i >= 2 && i <= 4) && v0 ? 'few'
    : !v0 ? 'many'
    : 'other';
}
function sl(n, ord) {
  var s = String(n).split('.'), i = s[0], v0 = !s[1], i100 = i.slice(-2);
  if (ord) return 'other';
  return v0 && i100 == 1 ? 'one'
    : v0 && i100 == 2 ? 'two'
    : v0 && (i100 == 3 || i100 == 4) || !v0 ? 'few'
    : 'other';
}
const sma = (/* unused pure expression or super */ null && (e));
const smi = (/* unused pure expression or super */ null && (e));
const smj = (/* unused pure expression or super */ null && (e));
const smn = (/* unused pure expression or super */ null && (e));
const sms = (/* unused pure expression or super */ null && (e));
const sn = (/* unused pure expression or super */ null && (a));
const so = (/* unused pure expression or super */ null && (a));
function sq(n, ord) {
  var s = String(n).split('.'), t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
  if (ord) return n == 1 ? 'one'
    : n10 == 4 && n100 != 14 ? 'many'
    : 'other';
  return n == 1 ? 'one' : 'other';
}
function sr(n, ord) {
  var s = String(n).split('.'), i = s[0], f = s[1] || '', v0 = !s[1], i10 = i.slice(-1), i100 = i.slice(-2), f10 = f.slice(-1), f100 = f.slice(-2);
  if (ord) return 'other';
  return v0 && i10 == 1 && i100 != 11 || f10 == 1 && f100 != 11 ? 'one'
    : v0 && (i10 >= 2 && i10 <= 4) && (i100 < 12 || i100 > 14) || (f10 >= 2 && f10 <= 4) && (f100 < 12 || f100 > 14) ? 'few'
    : 'other';
}
const ss = (/* unused pure expression or super */ null && (a));
const ssy = (/* unused pure expression or super */ null && (a));
const st = (/* unused pure expression or super */ null && (a));
const su = (/* unused pure expression or super */ null && (d));
function sv(n, ord) {
  var s = String(n).split('.'), v0 = !s[1], t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
  if (ord) return (n10 == 1 || n10 == 2) && n100 != 11 && n100 != 12 ? 'one' : 'other';
  return n == 1 && v0 ? 'one' : 'other';
}
const sw = (/* unused pure expression or super */ null && (c));
const syr = (/* unused pure expression or super */ null && (a));
const ta = (/* unused pure expression or super */ null && (a));
const te = (/* unused pure expression or super */ null && (a));
const teo = (/* unused pure expression or super */ null && (a));
const th = (/* unused pure expression or super */ null && (d));
const ti = (/* unused pure expression or super */ null && (b));
const tig = (/* unused pure expression or super */ null && (a));
function tk(n, ord) {
  var s = String(n).split('.'), t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1);
  if (ord) return (n10 == 6 || n10 == 9) || n == 10 ? 'few' : 'other';
  return n == 1 ? 'one' : 'other';
}
function tl(n, ord) {
  var s = String(n).split('.'), i = s[0], f = s[1] || '', v0 = !s[1], i10 = i.slice(-1), f10 = f.slice(-1);
  if (ord) return n == 1 ? 'one' : 'other';
  return v0 && (i == 1 || i == 2 || i == 3) || v0 && i10 != 4 && i10 != 6 && i10 != 9 || !v0 && f10 != 4 && f10 != 6 && f10 != 9 ? 'one' : 'other';
}
const tn = (/* unused pure expression or super */ null && (a));
const to = (/* unused pure expression or super */ null && (d));
const tr = (/* unused pure expression or super */ null && (a));
const ts = (/* unused pure expression or super */ null && (a));
function tzm(n, ord) {
  var s = String(n).split('.'), t0 = Number(s[0]) == n;
  if (ord) return 'other';
  return (n == 0 || n == 1) || (t0 && n >= 11 && n <= 99) ? 'one' : 'other';
}
const ug = (/* unused pure expression or super */ null && (a));
function uk(n, ord) {
  var s = String(n).split('.'), i = s[0], v0 = !s[1], t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2), i10 = i.slice(-1), i100 = i.slice(-2);
  if (ord) return n10 == 3 && n100 != 13 ? 'few' : 'other';
  return v0 && i10 == 1 && i100 != 11 ? 'one'
    : v0 && (i10 >= 2 && i10 <= 4) && (i100 < 12 || i100 > 14) ? 'few'
    : v0 && i10 == 0 || v0 && (i10 >= 5 && i10 <= 9) || v0 && (i100 >= 11 && i100 <= 14) ? 'many'
    : 'other';
}
const ur = (/* unused pure expression or super */ null && (c));
const uz = (/* unused pure expression or super */ null && (a));
const ve = (/* unused pure expression or super */ null && (a));
function vi(n, ord) {
  if (ord) return n == 1 ? 'one' : 'other';
  return 'other';
}
const vo = (/* unused pure expression or super */ null && (a));
const vun = (/* unused pure expression or super */ null && (a));
const wa = (/* unused pure expression or super */ null && (b));
const wae = (/* unused pure expression or super */ null && (a));
const wo = (/* unused pure expression or super */ null && (d));
const xh = (/* unused pure expression or super */ null && (a));
const xog = (/* unused pure expression or super */ null && (a));
const yi = (/* unused pure expression or super */ null && (c));
const yo = (/* unused pure expression or super */ null && (d));
const yue = (/* unused pure expression or super */ null && (d));
const zh = (/* unused pure expression or super */ null && (d));
function zu(n, ord) {
  if (ord) return 'other';
  return n >= 0 && n <= 1 ? 'one' : 'other';
}

// EXTERNAL MODULE: ./locale/en/messages.js
var messages = __webpack_require__(90673);
// EXTERNAL MODULE: ./locale/se/messages.js
var se_messages = __webpack_require__(86225);
// EXTERNAL MODULE: ./locale/fi/messages.js
var fi_messages = __webpack_require__(91196);
// EXTERNAL MODULE: ./locale/no/messages.js
var no_messages = __webpack_require__(85967);
;// CONCATENATED MODULE: ./lib/i18n.tsx











core_esm/* i18n.loadLocaleData */.ag.loadLocaleData({
  en: { plurals: en },
  se: { plurals: se },
  no: { plurals: no },
  fi: { plurals: fi } });


core_esm/* i18n.load */.ag.load({
  en: messages.messages,
  se: se_messages.messages,
  fi: fi_messages.messages,
  no: no_messages.messages });


// MANAGE loaded locales in state
var I18n = function I18n(_ref) {var children = _ref.children;
  var lang = (0,react.useContext)(languageContext/* default */.Z);

  (0,react.useMemo)(function () {
    core_esm/* i18n.activate */.ag.activate(lang);
  }, [lang]);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* I18nProvider */.bd, { i18n: core_esm/* i18n */.ag, children: children });
};

/* harmony default export */ var i18n = (I18n);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/globals/index.js + 5 modules
var globals = __webpack_require__(62985);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/context/ApolloContext.js
var context_ApolloContext = __webpack_require__(85317);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/react/context/ApolloProvider.js



var ApolloProvider = function (_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = (0,context_ApolloContext/* getApolloContext */.K)();
    return (react.createElement(ApolloContext.Consumer, null, function (context) {
        if (context === void 0) { context = {}; }
        if (client && context.client !== client) {
            context = Object.assign({}, context, { client: client });
        }
        __DEV__ ? (0,globals/* invariant */.kG)(context.client, 'ApolloProvider was not passed a client instance. Make ' +
            'sure you pass in your client via the "client" prop.') : (0,globals/* invariant */.kG)(context.client, 28);
        return (react.createElement(ApolloContext.Provider, { value: context }, children));
    }));
};
//# sourceMappingURL=ApolloProvider.js.map
// EXTERNAL MODULE: ./node_modules/set-cookie-parser/lib/set-cookie.js
var set_cookie = __webpack_require__(69328);
;// CONCATENATED MODULE: ./lib/auth.ts
function auth_ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function auth_objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? auth_ownKeys(Object(source), !0).forEach(function (key) {(0,defineProperty/* default */.Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : auth_ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}



var GET_CURRENT_USER_SIMPLE = "\n  query {\n    currentUser {\n      id\n      eligibleForTrialReclaim(promotionName: ProvaYogobe14)\n      completedAt\n    }\n  }\n";









function loadCurrentUser(_x) {return _loadCurrentUser.apply(this, arguments);}function _loadCurrentUser() {_loadCurrentUser = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(_ref) {var token, refresh_token, resp, cookies, _response$data, _response$data$curren, body, response, _response$data2;return regenerator_default().wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:
            token = _ref.token,
            refresh_token = _ref.refresh_token;_context.prev = 1;_context.next = 4;return (


              fetch("https://devenv.yogobe.com/graphql", {
                method: 'POST',
                headers: auth_objectSpread({
                  'ORIGIN-CLIENT': 'Vercel',
                  'Content-Type': 'application/json' },
                refresh_token ?
                {
                  Cookie: "".concat(constants/* AUTH_TOKEN */.UA, "=").concat(token, "; ").concat(constants/* AUTH_REFRESH_TOKEN */.TD, "=").concat(refresh_token, ";") } :

                {}),

                body: JSON.stringify({
                  query: GET_CURRENT_USER_SIMPLE }) }));case 4:resp = _context.sent;



            cookies = (0,set_cookie.splitCookiesString)(resp.headers.get('set-cookie'), {
              decodeValues: true, // default: true
              map: true // default: false
            });if (!

            resp.ok) {_context.next = 13;break;}_context.next = 9;return (
              resp.text());case 9:body = _context.sent;
            response = JSON.parse(body);if (!((_response$data =
            response.data) !== null && _response$data !== void 0 && (_response$data$curren = _response$data.currentUser) !== null && _response$data$curren !== void 0 && _response$data$curren.id)) {_context.next = 13;break;}return _context.abrupt("return",
            { cookies: cookies, currentUser: (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.currentUser });case 13:_context.next = 18;break;case 15:_context.prev = 15;_context.t0 = _context["catch"](1);



            console.error('loadCurrentUser', _context.t0);case 18:return _context.abrupt("return",

            null);case 19:case "end":return _context.stop();}}}, _callee, null, [[1, 15]]);}));return _loadCurrentUser.apply(this, arguments);}









function refreshAuthCookies(_x2, _x3) {return _refreshAuthCookies.apply(this, arguments);}function _refreshAuthCookies() {_refreshAuthCookies = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(
  cookies,
  response) {var token, refresh_token, refreshData, wantedCookies, parsedCookies;return regenerator_default().wrap(function _callee2$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:

            token = cookies[constants/* AUTH_TOKEN */.UA];
            refresh_token = cookies[constants/* AUTH_REFRESH_TOKEN */.TD];_context2.next = 4;return (

              loadCurrentUser({
                token: token,
                refresh_token: refresh_token }));case 4:refreshData = _context2.sent;


            wantedCookies = [constants/* AUTH_TOKEN */.UA, constants/* AUTH_REFRESH_TOKEN */.TD];
            // will be used by apollo requests during SSR
            parsedCookies = {};

            //
            if (!response) {_context2.next = 12;break;}if (!(
            refreshData !== null && refreshData !== void 0 && refreshData.cookies)) {_context2.next = 12;break;}
            // set cookies in response, to update browser cookies
            response.setHeader('Set-Cookie', refreshData.cookies);
            //
            refreshData.cookies.forEach(function (cookie) {
              //
              var parsedCookie = (0,set_cookie.parseString)(cookie, {
                decodeValues: true,
                map: true });

              if (wantedCookies.includes(parsedCookie.name)) {
                parsedCookies[parsedCookie.name] = parsedCookie.value;
              }
            });
            //
            return _context2.abrupt("return", { cookies: parsedCookies, currentUser: refreshData === null || refreshData === void 0 ? void 0 : refreshData.currentUser });case 12:return _context2.abrupt("return",



            null);case 13:case "end":return _context2.stop();}}}, _callee2);}));return _refreshAuthCookies.apply(this, arguments);}
// EXTERNAL MODULE: ./lib/nprogress.css
var lib_nprogress = __webpack_require__(23770);
// EXTERNAL MODULE: ./node_modules/lazysizes/lazysizes.js
var lazysizes = __webpack_require__(77090);
// EXTERNAL MODULE: ./node_modules/lazysizes/plugins/attrchange/ls.attrchange.js
var ls_attrchange = __webpack_require__(29505);
// EXTERNAL MODULE: ./organisms/video-player/css/index.scss
var css = __webpack_require__(75821);
;// CONCATENATED MODULE: ./lib/glowCookies.tsx




var policyLinkObject = {
  en: '/en/terms-and-conditions',
  se: '/se/villkor',
  fi: '/fi/ehdot',
  no: '/no/vilkar' };


var GlowCookies = function GlowCookies(_ref) {var currentUser = _ref.currentUser,locale = _ref.locale;
  (0,react.useEffect)(function () {
    if (true) {
      window['ygpAnalytics'] = (0,manager/* default */.Z)();
    }
  }, []);

  return !currentUser ? /*#__PURE__*/
  (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [/*#__PURE__*/
    (0,jsx_runtime.jsx)("script", { src: "https://cdn.jsdelivr.net/gh/manucaralmo/GlowCookies@3.1.7/src/glowCookies.min.js" }), /*#__PURE__*/
    (0,jsx_runtime.jsx)("script", {
      dangerouslySetInnerHTML: {
        __html: "\n                window.addEventListener(\"DOMContentLoaded\", function(){\n                  glowCookies.start(\"".concat(

        locale, "\", {\n                    style: 1,\n                    policyLink: \"").concat(

        policyLinkObject[locale], "\",\n                    position: 'right',\n                    hideAfterClick: true,\n                    bannerHeading: \"").concat(core_esm/* i18n._ */.ag._( /*i18n*/


        { id: 'consent.cookies.title' }), "\",\n                    bannerDescription: \"").concat(core_esm/* i18n._ */.ag._( /*i18n*/
        { id: 'consent.cookies.desc' }), "\",\n                    acceptBtnText: \"").concat(core_esm/* i18n._ */.ag._( /*i18n*/
        { id: 'consent.cookies.accept' }), "\",\n                    rejectBtnText: \"").concat(core_esm/* i18n._ */.ag._( /*i18n*/
        { id: 'consent.cookies.reject' }), "\",\n                    bannerLinkText: \"").concat(core_esm/* i18n._ */.ag._( /*i18n*/
        { id: 'consent.cookies.read_more' }), "\",\n                    acceptBtnBackground: \"#56b9e5\",\n                    customScript: [{ type: 'custom', position: 'body', content: \"window.ygpAnalytics && window.ygpAnalytics.initLibraries({})\" }, {type: \"custom\", position: 'body', content: \"document.cookie = 'GlowCookies=1';\"}]\n                 });\n                });\n              ") } })] }) :








  null;
};
;// CONCATENATED MODULE: ./pages/_app.tsx
/* provided dependency */ var process = __webpack_require__(34155);
var _app_excluded = ["Component", "lang", "isDeviceMobile"];function _app_ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _app_objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? _app_ownKeys(Object(source), !0).forEach(function (key) {(0,defineProperty/* default */.Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : _app_ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}function _createSuper(Derived) {var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {var Super = (0,getPrototypeOf/* default */.Z)(Derived),result;if (hasNativeReflectConstruct) {var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);} else {result = Super.apply(this, arguments);}return (0,possibleConstructorReturn/* default */.Z)(this, result);};}function _isNativeReflectConstruct() {if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));return true;} catch (e) {return false;}}

































function isUserAgentSignallingMobile(userAgentString) {
  var ua = ua_parser_default()(userAgentString);
  return ua.device.type === 'mobile';
}

nprogress_default().configure({ showSpinner: false });

router_default().events.on('routeChangeStart', function () {
  nprogress_default().start();
});

router_default().events.on('routeChangeComplete', function () {
  nprogress_default().done();
});

router_default().events.on('routeChangeError', function () {
  nprogress_default().done();
});

var AdyenLibrary = dynamic_default()(
Promise.resolve(function () {
  (0,react.useEffect)(function () {
    if (typeof window['AdyenCheckout'] !== 'function') {
      window['AdyenCheckout'] = __webpack_require__(41860);
    }
  }, []);

  return null;
}),
{ ssr: false });var


MyApp = /*#__PURE__*/function (_App) {(0,inherits/* default */.Z)(MyApp, _App);var _super = _createSuper(MyApp);








  function MyApp(props) {var _this;(0,classCallCheck/* default */.Z)(this, MyApp);
    _this = _super.call(this, props);(0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "apolloClient", void 0);

    _this.apolloClient = (0,apollo/* initApolloClient */.Rq)({
      lang: props.lang,
      cookies:  false ? 0 : null,
      initialState:
       true ?
      window['_apollo_cache_'] :
      0 });return _this;

  }(0,createClass/* default */.Z)(MyApp, [{ key: "componentDidCatch", value:

    function componentDidCatch(error, errorInfo) {
      esm_exports/* withScope */.$e(function (scope) {
        Object.keys(errorInfo).forEach(function (key) {
          scope.setExtra(key, errorInfo[key]);
        });

        esm_exports/* captureException */.Tb(error);
      });

      (0,get/* default */.Z)((0,getPrototypeOf/* default */.Z)(MyApp.prototype), "componentDidCatch", this).call(this, error, errorInfo);
    } }, { key: "componentDidMount", value: function () {var _componentDidMount = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(




















































































      function _callee() {var jssStyles, _this$props$currentUs, _this$props$router, query, _yield$this$apolloCli, data, currentUser, _this$props$router2, _query, asPath;return regenerator_default().wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:
                // Remove the server-side injected CSS.
                jssStyles = document.querySelector('#jss-server-side');
                if (jssStyles) {
                  jssStyles.parentNode.removeChild(jssStyles);
                }

                if (this.props.currentUser) {
                  if (
                  !((_this$props$currentUs = this.props.currentUser) !== null && _this$props$currentUs !== void 0 && _this$props$currentUs.completedAt) &&
                  ((_this$props$router = this.props.router) === null || _this$props$router === void 0 ? void 0 : _this$props$router.pathname) !== '/[lang]/register/account/details')
                  {
                    query = this.props.router.query;
                    this.props.router.replace("/".concat(query.lang, "/register/account/details"));
                  } else {
                    (0,manager/* default */.Z)().initLibraries({});
                  }
                }

                // this is mainly for test envirement
                // to mimic force auth that runs on server
                if (!(process.env.SITE_ENV === 'test')) {_context.next = 10;break;}_context.next = 6;return (
                  this.apolloClient.query({
                    query: generated/* CurrentUserDocument */.T0H }));case 6:_yield$this$apolloCli = _context.sent;data = _yield$this$apolloCli.data;

                currentUser = data.currentUser;

                if (this.props.Component['forceAuth'] && !currentUser) {_this$props$router2 =
                  this.props.router, _query = _this$props$router2.query, asPath = _this$props$router2.asPath;
                  this.props.router.replace({
                    pathname: "/".concat(_query.lang, "/login"),
                    query: { to: encodeURIComponent(asPath) } });

                }case 10:case "end":return _context.stop();}}}, _callee, this);}));function componentDidMount() {return _componentDidMount.apply(this, arguments);}return componentDidMount;}() }, { key: "render", value:



    function render() {var _pageProps$router, _pageProps$router$que;
      var _this$props =




      this.props,PageComponent = _this$props.Component,lang = _this$props.lang,isDeviceMobile = _this$props.isDeviceMobile,pageProps = (0,objectWithoutProperties/* default */.Z)(_this$props, _app_excluded);

      // this is mainly for register page
      // if other pages have same register layout we can exract it
      var PageLayout = layout;
      if (typeof PageComponent['getPageConfig'] === 'function') {var _PageComponent$getPag;
        if (((_PageComponent$getPag = PageComponent['getPageConfig']()) === null || _PageComponent$getPag === void 0 ? void 0 : _PageComponent$getPag.layout) === 'none') {
          PageLayout = react.Fragment;
        }
      }

      var language = lang || (pageProps === null || pageProps === void 0 ? void 0 : (_pageProps$router = pageProps.router) === null || _pageProps$router === void 0 ? void 0 : (_pageProps$router$que = _pageProps$router.query) === null || _pageProps$router$que === void 0 ? void 0 : _pageProps$router$que.lang);
      var locale = constants/* ENABLED_LOCALS.includes */.Op.includes(language) ? language : 'se';

      return /*#__PURE__*/(
        (0,jsx_runtime.jsx)(errorboundary/* ErrorBoundary */.SV, { children: /*#__PURE__*/
          (0,jsx_runtime.jsxs)(deviceContext/* default.Provider */.Z.Provider, { value: { isDeviceMobile: isDeviceMobile }, children: [/*#__PURE__*/
            (0,jsx_runtime.jsx)((head_default()), { children: /*#__PURE__*/

              (0,jsx_runtime.jsx)("meta", {
                name: "viewport",
                content:
                'user-scalable=0, initial-scale=1, ' +
                'minimum-scale=1, width=device-width, height=device-height' }) }), /*#__PURE__*/



            (0,jsx_runtime.jsx)(styled_components_browser_esm.ThemeProvider, { theme: theme/* default */.Z, children: /*#__PURE__*/


              (0,jsx_runtime.jsxs)(ThemeProvider_ThemeProvider, { theme: muiTheme, children: [/*#__PURE__*/

                (0,jsx_runtime.jsx)(CssBaseline_CssBaseline, {}), /*#__PURE__*/






                (0,jsx_runtime.jsx)(ApolloProvider, { client: this.apolloClient, children: /*#__PURE__*/
                  (0,jsx_runtime.jsx)(UserProvider/* default */.Z, { initialValue: pageProps.currentUser, children: /*#__PURE__*/
                    (0,jsx_runtime.jsx)(languageContext/* default.Provider */.Z.Provider, { value: locale, children: /*#__PURE__*/
                      (0,jsx_runtime.jsxs)(i18n, { children: [/*#__PURE__*/
                        (0,jsx_runtime.jsxs)(PageLayout, { children: [/*#__PURE__*/
                          (0,jsx_runtime.jsx)(globalStyles, {}), /*#__PURE__*/
                          (0,jsx_runtime.jsx)(PageComponent, _app_objectSpread({}, pageProps)), /*#__PURE__*/
                          (0,jsx_runtime.jsx)(AdyenLibrary, {}), /*#__PURE__*/
                          (0,jsx_runtime.jsx)(GlowCookies, {
                            locale: locale,
                            currentUser: this.props.currentUser })] }), /*#__PURE__*/


                        (0,jsx_runtime.jsx)(components_Snackbar, {})] }) }) }) })] }) })] }) }));









    } }], [{ key: "getInitialProps", value: function () {var _getInitialProps = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(_ref) {var _ctx$req, _ctx$req$apolloClient, _ctx$req$apolloClient2, _ctx$req2, _ctx$req2$headers;var Component, ctx, currentUser, token, refresh_token, cookies, lang, apolloClient, _userResponse$data, _ctx$req$cookies, _ctx$req$cookies2, _refreshData$currentU, refreshData, _yield$Promise$all, _yield$Promise$all2, _, userResponse, _Component$getNoAuthR, redirectURL, initialProps;return regenerator_default().wrap(function _callee2$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:Component = _ref.Component, ctx = _ref.ctx;cookies = {};lang = ctx.query.lang;_context2.prev = 3;if (!(ctx.req && Component.RefreshTokens !== false)) {_context2.next = 18;break;}cookies[constants/* AUTH_TOKEN */.UA] = (_ctx$req$cookies = ctx.req.cookies) === null || _ctx$req$cookies === void 0 ? void 0 : _ctx$req$cookies[constants/* AUTH_TOKEN */.UA];cookies[constants/* AUTH_REFRESH_TOKEN */.TD] = (_ctx$req$cookies2 = ctx.req.cookies) === null || _ctx$req$cookies2 === void 0 ? void 0 : _ctx$req$cookies2[constants/* AUTH_REFRESH_TOKEN */.TD];_context2.prev = 7;_context2.next = 10;return refreshAuthCookies(cookies, ctx.res);case 10:refreshData = _context2.sent;if (refreshData !== null && refreshData !== void 0 && refreshData.cookies) {// backend (/graphql) will always return cookies, either fresh or current cookies if they are still valid...
                  cookies[constants/* AUTH_TOKEN */.UA] = refreshData === null || refreshData === void 0 ? void 0 : refreshData.cookies[constants/* AUTH_TOKEN */.UA];cookies[constants/* AUTH_REFRESH_TOKEN */.TD] = refreshData === null || refreshData === void 0 ? void 0 : refreshData.cookies[constants/* AUTH_REFRESH_TOKEN */.TD];}if (refreshData !== null && refreshData !== void 0 && (_refreshData$currentU = refreshData.currentUser) !== null && _refreshData$currentU !== void 0 && _refreshData$currentU.id) {ctx.req.currentUser = refreshData === null || refreshData === void 0 ? void 0 : refreshData.currentUser; // for auth check below
                  currentUser = refreshData === null || refreshData === void 0 ? void 0 : refreshData.currentUser;}_context2.next = 18;break;case 15:_context2.prev = 15;_context2.t0 = _context2["catch"](7);console.error('_app', _context2.t0); // we want this code block to continue
              case 18:apolloClient = (0,apollo/* initApolloClient */.Rq)({ lang: lang, cookies: cookies, initialState:  true ? window['_apollo_cache_'] : 0 });_context2.next = 21;return Promise.all([apolloClient.query({ query: useFlags/* FLAGS_QUERY */.gW, variables: { names: useFlags/* names */.R5 } }), apolloClient.query({ query: generated/* CurrentUserDocument */.T0H })]);case 21:_yield$Promise$all = _context2.sent;_yield$Promise$all2 = (0,slicedToArray/* default */.Z)(_yield$Promise$all, 2);_ = _yield$Promise$all2[0];userResponse = _yield$Promise$all2[1];currentUser = userResponse === null || userResponse === void 0 ? void 0 : (_userResponse$data = userResponse.data) === null || _userResponse$data === void 0 ? void 0 : _userResponse$data.currentUser;_context2.next = 31;break;case 28:_context2.prev = 28;_context2.t1 = _context2["catch"](3);console.error('ex', _context2.t1.message); // suck error
              case 31:_context2.prev = 31;if (ctx !== null && ctx !== void 0 && ctx.req) {// this is needed in getServerSideProps
                  ctx.req.apolloClient = apolloClient;}return _context2.finish(31);case 34:if (!currentUser && Component.forceAuth) {redirectURL = (Component === null || Component === void 0 ? void 0 : (_Component$getNoAuthR = Component.getNoAuthRedirectURL) === null || _Component$getNoAuthR === void 0 ? void 0 : _Component$getNoAuthR.call(Component, ctx)) || "/".concat(lang, "/login?to=").concat(encodeURIComponent(ctx.asPath)); // If not signed in, send them somewhere more useful
                  redirect(ctx, redirectURL);}initialProps = { _ssr: true, lang: lang, currentUser: currentUser, apolloCache: ctx === null || ctx === void 0 ? void 0 : (_ctx$req = ctx.req) === null || _ctx$req === void 0 ? void 0 : (_ctx$req$apolloClient = _ctx$req.apolloClient) === null || _ctx$req$apolloClient === void 0 ? void 0 : (_ctx$req$apolloClient2 = _ctx$req$apolloClient.extract) === null || _ctx$req$apolloClient2 === void 0 ? void 0 : _ctx$req$apolloClient2.call(_ctx$req$apolloClient), isDeviceMobile: isUserAgentSignallingMobile((_ctx$req2 = ctx.req) === null || _ctx$req2 === void 0 ? void 0 : (_ctx$req2$headers = _ctx$req2.headers) === null || _ctx$req2$headers === void 0 ? void 0 : _ctx$req2$headers['user-agent']), cookies: { token: token, refresh_token: refresh_token }, pageProps: {} };return _context2.abrupt("return", initialProps);case 37:case "end":return _context2.stop();}}}, _callee2, null, [[3, 28, 31, 34], [7, 15]]);}));function getInitialProps(_x) {return _getInitialProps.apply(this, arguments);}return getInitialProps;}() }]);return MyApp;}(app["default"]);var ProperApp = MyApp;var empty = function empty() {return null;}; // when exported component from App doesn't have getInitialProps
// next will call getInitialProps on the Component which is a problem in test mode
// because we return null and we have no providers in the tree which causes issues...
empty.getInitialProps = function () {
  return {};
};

/* harmony default export */ var _app = ((function () {
  if (process.env.SITE_ENV === 'test' && false) {}
  return ProperApp;
})());

/***/ }),

/***/ 45919:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/version.js
var version = __webpack_require__(40105);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/sdk.js + 30 modules
var sdk = __webpack_require__(19985);
;// CONCATENATED MODULE: ./node_modules/@sentry/react/esm/sdk.js


/**
 * Inits the React SDK
 */
function init(options) {
  options._metadata = options._metadata || {};
  options._metadata.sdk = options._metadata.sdk || {
    name: 'sentry.javascript.react',
    packages: [
      {
        name: 'npm:@sentry/react',
        version: version/* SDK_VERSION */.J,
      },
    ],
    version: version/* SDK_VERSION */.J,
  };
  (0,sdk/* init */.S1)(options);
}


//# sourceMappingURL=sdk.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/hub/esm/exports.js
var esm_exports = __webpack_require__(92876);
// EXTERNAL MODULE: ./node_modules/@sentry/tracing/esm/hubextensions.js + 1 modules
var hubextensions = __webpack_require__(62758);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/logger.js
var logger = __webpack_require__(12343);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/global.js
var global = __webpack_require__(82991);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/tracing.js
var TRACEPARENT_REGEXP = new RegExp(
  '^[ \\t]*' + // whitespace
    '([0-9a-f]{32})?' + // trace_id
    '-?([0-9a-f]{16})?' + // span_id
    '-?([01])?' + // sampled
    '[ \\t]*$', // whitespace
);

/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */
function extractTraceparentData(traceparent) {
  var matches = traceparent.match(TRACEPARENT_REGEXP);
  if (matches) {
    let parentSampled;
    if (matches[3] === '1') {
      parentSampled = true;
    } else if (matches[3] === '0') {
      parentSampled = false;
    }
    return {
      traceId: matches[1],
      parentSampled,
      parentSpanId: matches[2],
    };
  }
  return undefined;
}


//# sourceMappingURL=tracing.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/baggage.js
var esm_baggage = __webpack_require__(99181);
// EXTERNAL MODULE: ./node_modules/@sentry/tracing/esm/idletransaction.js
var idletransaction = __webpack_require__(16458);
// EXTERNAL MODULE: ./node_modules/@sentry/tracing/esm/utils.js
var utils = __webpack_require__(63233);
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/backgroundtab.js



var backgroundtab_global = (0,global/* getGlobalObject */.R)();

/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */
function registerBackgroundTabDetection() {
  if (backgroundtab_global && backgroundtab_global.document) {
    backgroundtab_global.document.addEventListener('visibilitychange', () => {
      var activeTransaction = (0,utils/* getActiveTransaction */.x1)() ;
      if (backgroundtab_global.document.hidden && activeTransaction) {
        var statusType = 'cancelled';

        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
          logger/* logger.log */.kg.log(
            `[Tracing] Transaction: ${statusType} -> since tab moved to the background, op: ${activeTransaction.op}`,
          );
        // We should not set status if it is already set, this prevent important statuses like
        // error or data loss from being overwritten on transaction.
        if (!activeTransaction.status) {
          activeTransaction.setStatus(statusType);
        }
        activeTransaction.setTag('visibilitychange', 'document.hidden');
        activeTransaction.finish();
      }
    });
  } else {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.warn */.kg.warn('[Tracing] Could not set up background tab detection due to lack of global document');
  }
}


//# sourceMappingURL=backgroundtab.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/buildPolyfills/_nullishCoalesce.js
var _nullishCoalesce = __webpack_require__(45375);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/time.js
var time = __webpack_require__(21170);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/browser.js
var browser = __webpack_require__(58464);
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/lib/bindReporter.js
var bindReporter = (
  callback,
  metric,
  reportAllChanges,
) => {
  let prevValue;
  return (forceReport) => {
    if (metric.value >= 0) {
      if (forceReport || reportAllChanges) {
        metric.delta = metric.value - (prevValue || 0);

        // Report the metric if there's a non-zero delta or if no previous
        // value exists (which can happen in the case of the document becoming
        // hidden when the metric value is 0).
        // See: https://github.com/GoogleChrome/web-vitals/issues/14
        if (metric.delta || prevValue === undefined) {
          prevValue = metric.value;
          callback(metric);
        }
      }
    }
  };
};


//# sourceMappingURL=bindReporter.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/lib/generateUniqueID.js
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */
var generateUniqueID = () => {
  return `v2-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};


//# sourceMappingURL=generateUniqueID.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/lib/initMetric.js



var initMetric = (name, value) => {
  return {
    name,
    value: (0,_nullishCoalesce/* _nullishCoalesce */.h)(value, () => ( -1)),
    delta: 0,
    entries: [],
    id: generateUniqueID(),
  };
};


//# sourceMappingURL=initMetric.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/lib/observe.js
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */
var observe = (type, callback) => {
  try {
    if (PerformanceObserver.supportedEntryTypes.includes(type)) {
      // More extensive feature detect needed for Firefox due to:
      // https://github.com/GoogleChrome/web-vitals/issues/142
      if (type === 'first-input' && !('PerformanceEventTiming' in self)) {
        return;
      }

      var po = new PerformanceObserver(l => l.getEntries().map(callback));

      po.observe({ type, buffered: true });
      return po;
    }
  } catch (e) {
    // Do nothing.
  }
  return;
};


//# sourceMappingURL=observe.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/lib/onHidden.js


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var onHidden = (cb, once) => {
  var onHiddenOrPageHide = (event) => {
    if (event.type === 'pagehide' || (0,global/* getGlobalObject */.R)().document.visibilityState === 'hidden') {
      cb(event);
      if (once) {
        removeEventListener('visibilitychange', onHiddenOrPageHide, true);
        removeEventListener('pagehide', onHiddenOrPageHide, true);
      }
    }
  };
  addEventListener('visibilitychange', onHiddenOrPageHide, true);
  // Some browsers have buggy implementations of visibilitychange,
  // so we use pagehide in addition, just to be safe.
  addEventListener('pagehide', onHiddenOrPageHide, true);
};


//# sourceMappingURL=onHidden.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/getCLS.js





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

// https://wicg.github.io/layout-instability/#sec-layout-shift

var getCLS = (onReport, reportAllChanges) => {
  var metric = initMetric('CLS', 0);
  let report;

  let sessionValue = 0;
  let sessionEntries = [];

  var entryHandler = (entry) => {
    // Only count layout shifts without recent user input.
    // TODO: Figure out why entry can be undefined
    if (entry && !entry.hadRecentInput) {
      var firstSessionEntry = sessionEntries[0];
      var lastSessionEntry = sessionEntries[sessionEntries.length - 1];

      // If the entry occurred less than 1 second after the previous entry and
      // less than 5 seconds after the first entry in the session, include the
      // entry in the current session. Otherwise, start a new session.
      if (
        sessionValue &&
        sessionEntries.length !== 0 &&
        entry.startTime - lastSessionEntry.startTime < 1000 &&
        entry.startTime - firstSessionEntry.startTime < 5000
      ) {
        sessionValue += entry.value;
        sessionEntries.push(entry);
      } else {
        sessionValue = entry.value;
        sessionEntries = [entry];
      }

      // If the current session value is larger than the current CLS value,
      // update CLS and the entries contributing to it.
      if (sessionValue > metric.value) {
        metric.value = sessionValue;
        metric.entries = sessionEntries;
        if (report) {
          report();
        }
      }
    }
  };

  var po = observe('layout-shift', entryHandler );
  if (po) {
    report = bindReporter(onReport, metric, reportAllChanges);

    onHidden(() => {
      po.takeRecords().map(entryHandler );
      report(true);
    });
  }
};


//# sourceMappingURL=getCLS.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/lib/getVisibilityWatcher.js



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

let firstHiddenTime = -1;

var initHiddenTime = () => {
  return (0,global/* getGlobalObject */.R)().document.visibilityState === 'hidden' ? 0 : Infinity;
};

var trackChanges = () => {
  // Update the time if/when the document becomes hidden.
  onHidden(({ timeStamp }) => {
    firstHiddenTime = timeStamp;
  }, true);
};

var getVisibilityWatcher = (

) => {
  if (firstHiddenTime < 0) {
    // If the document is hidden when this code runs, assume it was hidden
    // since navigation start. This isn't a perfect heuristic, but it's the
    // best we can do until an API is available to support querying past
    // visibilityState.
    firstHiddenTime = initHiddenTime();
    trackChanges();
  }
  return {
    get firstHiddenTime() {
      return firstHiddenTime;
    },
  };
};


//# sourceMappingURL=getVisibilityWatcher.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/getFID.js






/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var getFID = (onReport, reportAllChanges) => {
  var visibilityWatcher = getVisibilityWatcher();
  var metric = initMetric('FID');
  let report;

  var entryHandler = (entry) => {
    // Only report if the page wasn't hidden prior to the first input.
    if (report && entry.startTime < visibilityWatcher.firstHiddenTime) {
      metric.value = entry.processingStart - entry.startTime;
      metric.entries.push(entry);
      report(true);
    }
  };

  var po = observe('first-input', entryHandler );
  if (po) {
    report = bindReporter(onReport, metric, reportAllChanges);
    onHidden(() => {
      po.takeRecords().map(entryHandler );
      po.disconnect();
    }, true);
  }
};


//# sourceMappingURL=getFID.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/getLCP.js






/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

// https://wicg.github.io/largest-contentful-paint/#sec-largest-contentful-paint-interface

var reportedMetricIDs = {};

var getLCP = (onReport, reportAllChanges) => {
  var visibilityWatcher = getVisibilityWatcher();
  var metric = initMetric('LCP');
  let report;

  var entryHandler = (entry) => {
    // The startTime attribute returns the value of the renderTime if it is not 0,
    // and the value of the loadTime otherwise.
    var value = entry.startTime;

    // If the page was hidden prior to paint time of the entry,
    // ignore it and mark the metric as final, otherwise add the entry.
    if (value < visibilityWatcher.firstHiddenTime) {
      metric.value = value;
      metric.entries.push(entry);
    }

    if (report) {
      report();
    }
  };

  var po = observe('largest-contentful-paint', entryHandler);

  if (po) {
    report = bindReporter(onReport, metric, reportAllChanges);

    var stopListening = () => {
      if (!reportedMetricIDs[metric.id]) {
        po.takeRecords().map(entryHandler );
        po.disconnect();
        reportedMetricIDs[metric.id] = true;
        report(true);
      }
    };

    // Stop listening after input. Note: while scrolling is an input that
    // stop LCP observation, it's unreliable since it can be programmatically
    // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
    ['keydown', 'click'].forEach(type => {
      addEventListener(type, stopListening, { once: true, capture: true });
    });

    onHidden(stopListening, true);
  }
};


//# sourceMappingURL=getLCP.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/metrics/utils.js
/**
 * Checks if a given value is a valid measurement value.
 */
function isMeasurementValue(value) {
  return typeof value === 'number' && isFinite(value);
}

/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 */
function _startChild(transaction, { startTimestamp, ...ctx }) {
  if (startTimestamp && transaction.startTimestamp > startTimestamp) {
    transaction.startTimestamp = startTimestamp;
  }

  return transaction.startChild({
    startTimestamp,
    ...ctx,
  });
}


//# sourceMappingURL=utils.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/metrics/index.js









var metrics_global = (0,global/* getGlobalObject */.R)();

function getBrowserPerformanceAPI() {
  return metrics_global && metrics_global.addEventListener && metrics_global.performance;
}

let _performanceCursor = 0;

let _measurements = {};
let _lcpEntry;
let _clsEntry;

/**
 * Start tracking web vitals
 */
function startTrackingWebVitals(reportAllChanges = false) {
  var performance = getBrowserPerformanceAPI();
  if (performance && time/* browserPerformanceTimeOrigin */.Z1) {
    if (performance.mark) {
      metrics_global.performance.mark('sentry-tracing-init');
    }
    _trackCLS();
    _trackLCP(reportAllChanges);
    _trackFID();
  }
}

/** Starts tracking the Cumulative Layout Shift on the current page. */
function _trackCLS() {
  // See:
  // https://web.dev/evolving-cls/
  // https://web.dev/cls-web-tooling/
  getCLS(metric => {
    var entry = metric.entries.pop();
    if (!entry) {
      return;
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Measurements] Adding CLS');
    _measurements['cls'] = { value: metric.value, unit: '' };
    _clsEntry = entry ;
  });
}

/** Starts tracking the Largest Contentful Paint on the current page. */
function _trackLCP(reportAllChanges) {
  getLCP(metric => {
    var entry = metric.entries.pop();
    if (!entry) {
      return;
    }

    var timeOrigin = (0,utils/* msToSec */.XL)(time/* browserPerformanceTimeOrigin */.Z1 );
    var startTime = (0,utils/* msToSec */.XL)(entry.startTime);
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Measurements] Adding LCP');
    _measurements['lcp'] = { value: metric.value, unit: 'millisecond' };
    _measurements['mark.lcp'] = { value: timeOrigin + startTime, unit: 'second' };
    _lcpEntry = entry ;
  }, reportAllChanges);
}

/** Starts tracking the First Input Delay on the current page. */
function _trackFID() {
  getFID(metric => {
    var entry = metric.entries.pop();
    if (!entry) {
      return;
    }

    var timeOrigin = (0,utils/* msToSec */.XL)(time/* browserPerformanceTimeOrigin */.Z1 );
    var startTime = (0,utils/* msToSec */.XL)(entry.startTime);
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Measurements] Adding FID');
    _measurements['fid'] = { value: metric.value, unit: 'millisecond' };
    _measurements['mark.fid'] = { value: timeOrigin + startTime, unit: 'second' };
  });
}

/** Add performance related spans to a transaction */
function addPerformanceEntries(transaction) {
  var performance = getBrowserPerformanceAPI();
  if (!performance || !metrics_global.performance.getEntries || !time/* browserPerformanceTimeOrigin */.Z1) {
    // Gatekeeper if performance API not available
    return;
  }

  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Tracing] Adding & adjusting spans using Performance API');
  var timeOrigin = (0,utils/* msToSec */.XL)(time/* browserPerformanceTimeOrigin */.Z1);

  var performanceEntries = performance.getEntries();

  let responseStartTimestamp;
  let requestStartTimestamp;

    performanceEntries.slice(_performanceCursor).forEach((entry) => {
    var startTime = (0,utils/* msToSec */.XL)(entry.startTime);
    var duration = (0,utils/* msToSec */.XL)(entry.duration);

    if (transaction.op === 'navigation' && timeOrigin + startTime < transaction.startTimestamp) {
      return;
    }

    switch (entry.entryType) {
      case 'navigation': {
        _addNavigationSpans(transaction, entry, timeOrigin);
        responseStartTimestamp = timeOrigin + (0,utils/* msToSec */.XL)(entry.responseStart);
        requestStartTimestamp = timeOrigin + (0,utils/* msToSec */.XL)(entry.requestStart);
        break;
      }
      case 'mark':
      case 'paint':
      case 'measure': {
        var startTimestamp = _addMeasureSpans(transaction, entry, startTime, duration, timeOrigin);

        // capture web vitals
        var firstHidden = getVisibilityWatcher();
        // Only report if the page wasn't hidden prior to the web vital.
        var shouldRecord = entry.startTime < firstHidden.firstHiddenTime;

        if (entry.name === 'first-paint' && shouldRecord) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Measurements] Adding FP');
          _measurements['fp'] = { value: entry.startTime, unit: 'millisecond' };
          _measurements['mark.fp'] = { value: startTimestamp, unit: 'second' };
        }
        if (entry.name === 'first-contentful-paint' && shouldRecord) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Measurements] Adding FCP');
          _measurements['fcp'] = { value: entry.startTime, unit: 'millisecond' };
          _measurements['mark.fcp'] = { value: startTimestamp, unit: 'second' };
        }
        break;
      }
      case 'resource': {
        var resourceName = (entry.name ).replace(metrics_global.location.origin, '');
        _addResourceSpans(transaction, entry, resourceName, startTime, duration, timeOrigin);
        break;
      }
      default:
      // Ignore other entry types.
    }
  });

  _performanceCursor = Math.max(performanceEntries.length - 1, 0);

  _trackNavigator(transaction);

  // Measurements are only available for pageload transactions
  if (transaction.op === 'pageload') {
    // Generate TTFB (Time to First Byte), which measured as the time between the beginning of the transaction and the
    // start of the response in milliseconds
    if (typeof responseStartTimestamp === 'number') {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Measurements] Adding TTFB');
      _measurements['ttfb'] = {
        value: (responseStartTimestamp - transaction.startTimestamp) * 1000,
        unit: 'millisecond',
      };

      if (typeof requestStartTimestamp === 'number' && requestStartTimestamp <= responseStartTimestamp) {
        // Capture the time spent making the request and receiving the first byte of the response.
        // This is the time between the start of the request and the start of the response in milliseconds.
        _measurements['ttfb.requestTime'] = {
          value: (responseStartTimestamp - requestStartTimestamp) * 1000,
          unit: 'millisecond',
        };
      }
    }

    ['fcp', 'fp', 'lcp'].forEach(name => {
      if (!_measurements[name] || timeOrigin >= transaction.startTimestamp) {
        return;
      }
      // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
      // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
      // to be adjusted to be relative to transaction.startTimestamp.
      var oldValue = _measurements[name].value;
      var measurementTimestamp = timeOrigin + (0,utils/* msToSec */.XL)(oldValue);

      // normalizedValue should be in milliseconds
      var normalizedValue = Math.abs((measurementTimestamp - transaction.startTimestamp) * 1000);
      var delta = normalizedValue - oldValue;

      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        logger/* logger.log */.kg.log(`[Measurements] Normalized ${name} from ${oldValue} to ${normalizedValue} (${delta})`);
      _measurements[name].value = normalizedValue;
    });

    if (_measurements['mark.fid'] && _measurements['fid']) {
      // create span for FID
      _startChild(transaction, {
        description: 'first input delay',
        endTimestamp: _measurements['mark.fid'].value + (0,utils/* msToSec */.XL)(_measurements['fid'].value),
        op: 'web.vitals',
        startTimestamp: _measurements['mark.fid'].value,
      });
    }

    // If FCP is not recorded we should not record the cls value
    // according to the new definition of CLS.
    if (!('fcp' in _measurements)) {
      delete _measurements.cls;
    }

    Object.keys(_measurements).forEach(measurementName => {
      transaction.setMeasurement(
        measurementName,
        _measurements[measurementName].value,
        _measurements[measurementName].unit,
      );
    });

    _tagMetricInfo(transaction);
  }

  _lcpEntry = undefined;
  _clsEntry = undefined;
  _measurements = {};
}

/** Create measure related spans */
function _addMeasureSpans(
  transaction,
    entry,
  startTime,
  duration,
  timeOrigin,
) {
  var measureStartTimestamp = timeOrigin + startTime;
  var measureEndTimestamp = measureStartTimestamp + duration;

  _startChild(transaction, {
    description: entry.name ,
    endTimestamp: measureEndTimestamp,
    op: entry.entryType ,
    startTimestamp: measureStartTimestamp,
  });

  return measureStartTimestamp;
}

/** Instrument navigation entries */
function _addNavigationSpans(transaction, entry, timeOrigin) {
  ['unloadEvent', 'redirect', 'domContentLoadedEvent', 'loadEvent', 'connect'].forEach(event => {
    _addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
  });
  _addPerformanceNavigationTiming(transaction, entry, 'secureConnection', timeOrigin, 'TLS/SSL', 'connectEnd');
  _addPerformanceNavigationTiming(transaction, entry, 'fetch', timeOrigin, 'cache', 'domainLookupStart');
  _addPerformanceNavigationTiming(transaction, entry, 'domainLookup', timeOrigin, 'DNS');
  _addRequest(transaction, entry, timeOrigin);
}

/** Create performance navigation related spans */
function _addPerformanceNavigationTiming(
  transaction,
    entry,
  event,
  timeOrigin,
  description,
  eventEnd,
) {
  var end = eventEnd ? (entry[eventEnd] ) : (entry[`${event}End`] );
  var start = entry[`${event}Start`] ;
  if (!start || !end) {
    return;
  }
  _startChild(transaction, {
    op: 'browser',
    description: (0,_nullishCoalesce/* _nullishCoalesce */.h)(description, () => ( event)),
    startTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(start),
    endTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(end),
  });
}

/** Create request and response related spans */
function _addRequest(transaction, entry, timeOrigin) {
  _startChild(transaction, {
    op: 'browser',
    description: 'request',
    startTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(entry.requestStart ),
    endTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(entry.responseEnd ),
  });

  _startChild(transaction, {
    op: 'browser',
    description: 'response',
    startTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(entry.responseStart ),
    endTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(entry.responseEnd ),
  });
}

/** Create resource-related spans */
function _addResourceSpans(
  transaction,
  entry,
  resourceName,
  startTime,
  duration,
  timeOrigin,
) {
  // we already instrument based on fetch and xhr, so we don't need to
  // duplicate spans here.
  if (entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch') {
    return;
  }

    var data = {};
  if ('transferSize' in entry) {
    data['Transfer Size'] = entry.transferSize;
  }
  if ('encodedBodySize' in entry) {
    data['Encoded Body Size'] = entry.encodedBodySize;
  }
  if ('decodedBodySize' in entry) {
    data['Decoded Body Size'] = entry.decodedBodySize;
  }

  var startTimestamp = timeOrigin + startTime;
  var endTimestamp = startTimestamp + duration;

  _startChild(transaction, {
    description: resourceName,
    endTimestamp,
    op: entry.initiatorType ? `resource.${entry.initiatorType}` : 'resource',
    startTimestamp,
    data,
  });
}

/**
 * Capture the information of the user agent.
 */
function _trackNavigator(transaction) {
  var navigator = metrics_global.navigator ;
  if (!navigator) {
    return;
  }

  // track network connectivity
  var connection = navigator.connection;
  if (connection) {
    if (connection.effectiveType) {
      transaction.setTag('effectiveConnectionType', connection.effectiveType);
    }

    if (connection.type) {
      transaction.setTag('connectionType', connection.type);
    }

    if (isMeasurementValue(connection.rtt)) {
      _measurements['connection.rtt'] = { value: connection.rtt, unit: 'millisecond' };
    }

    if (isMeasurementValue(connection.downlink)) {
      _measurements['connection.downlink'] = { value: connection.downlink, unit: '' }; // unit is empty string for now, while relay doesn't support download speed units
    }
  }

  if (isMeasurementValue(navigator.deviceMemory)) {
    transaction.setTag('deviceMemory', `${navigator.deviceMemory} GB`);
  }

  if (isMeasurementValue(navigator.hardwareConcurrency)) {
    transaction.setTag('hardwareConcurrency', String(navigator.hardwareConcurrency));
  }
}

/** Add LCP / CLS data to transaction to allow debugging */
function _tagMetricInfo(transaction) {
  if (_lcpEntry) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Measurements] Adding LCP Data');

    // Capture Properties of the LCP element that contributes to the LCP.

    if (_lcpEntry.element) {
      transaction.setTag('lcp.element', (0,browser/* htmlTreeAsString */.R)(_lcpEntry.element));
    }

    if (_lcpEntry.id) {
      transaction.setTag('lcp.id', _lcpEntry.id);
    }

    if (_lcpEntry.url) {
      // Trim URL to the first 200 characters.
      transaction.setTag('lcp.url', _lcpEntry.url.trim().slice(0, 200));
    }

    transaction.setTag('lcp.size', _lcpEntry.size);
  }

  // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
  if (_clsEntry && _clsEntry.sources) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Measurements] Adding CLS Data');
    _clsEntry.sources.forEach((source, index) =>
      transaction.setTag(`cls.source.${index + 1}`, (0,browser/* htmlTreeAsString */.R)(source.node)),
    );
  }
}


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/string.js
var string = __webpack_require__(57321);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/instrument.js
var instrument = __webpack_require__(9732);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(67597);
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/request.js



var DEFAULT_TRACING_ORIGINS = ['localhost', /^\//];

/** Options for Request Instrumentation */

var defaultRequestInstrumentationOptions = {
  traceFetch: true,
  traceXHR: true,
  tracingOrigins: DEFAULT_TRACING_ORIGINS,
};

/** Registers span creators for xhr and fetch requests  */
function instrumentOutgoingRequests(_options) {
    const { traceFetch, traceXHR, tracingOrigins, shouldCreateSpanForRequest } = {
    ...defaultRequestInstrumentationOptions,
    ..._options,
  };

  // We should cache url -> decision so that we don't have to compute
  // regexp everytime we create a request.
  var urlMap = {};

  var defaultShouldCreateSpan = (url) => {
    if (urlMap[url]) {
      return urlMap[url];
    }
    var origins = tracingOrigins;
    urlMap[url] =
      origins.some((origin) => (0,string/* isMatchingPattern */.zC)(url, origin)) &&
      !(0,string/* isMatchingPattern */.zC)(url, 'sentry_key');
    return urlMap[url];
  };

  // We want that our users don't have to re-implement shouldCreateSpanForRequest themselves
  // That's why we filter out already unwanted Spans from tracingOrigins
  let shouldCreateSpan = defaultShouldCreateSpan;
  if (typeof shouldCreateSpanForRequest === 'function') {
    shouldCreateSpan = (url) => {
      return defaultShouldCreateSpan(url) && shouldCreateSpanForRequest(url);
    };
  }

  var spans = {};

  if (traceFetch) {
    (0,instrument/* addInstrumentationHandler */.o)('fetch', (handlerData) => {
      fetchCallback(handlerData, shouldCreateSpan, spans);
    });
  }

  if (traceXHR) {
    (0,instrument/* addInstrumentationHandler */.o)('xhr', (handlerData) => {
      xhrCallback(handlerData, shouldCreateSpan, spans);
    });
  }
}

/**
 * Create and track fetch request spans
 */
function fetchCallback(
  handlerData,
  shouldCreateSpan,
  spans,
) {
  if (!(0,utils/* hasTracingEnabled */.zu)() || !(handlerData.fetchData && shouldCreateSpan(handlerData.fetchData.url))) {
    return;
  }

  if (handlerData.endTimestamp) {
    var spanId = handlerData.fetchData.__span;
    if (!spanId) return;

    var span = spans[spanId];
    if (span) {
      if (handlerData.response) {
        // TODO (kmclb) remove this once types PR goes through
                span.setHttpStatus(handlerData.response.status);
      } else if (handlerData.error) {
        span.setStatus('internal_error');
      }
      span.finish();

            delete spans[spanId];
    }
    return;
  }

  var activeTransaction = (0,utils/* getActiveTransaction */.x1)();
  if (activeTransaction) {
    var span = activeTransaction.startChild({
      data: {
        ...handlerData.fetchData,
        type: 'fetch',
      },
      description: `${handlerData.fetchData.method} ${handlerData.fetchData.url}`,
      op: 'http.client',
    });

    handlerData.fetchData.__span = span.spanId;
    spans[span.spanId] = span;

    var request = (handlerData.args[0] = handlerData.args[0] );
        var options = (handlerData.args[1] = (handlerData.args[1] ) || {});
    options.headers = addTracingHeaders(request, activeTransaction.getBaggage(), span, options);
  }
}

function addTracingHeaders(
  request,
  incomingBaggage,
  span,
  options,
) {
  let headers = options.headers;

  if ((0,is/* isInstanceOf */.V9)(request, Request)) {
    headers = (request ).headers;
  }

  if (headers) {
        if (typeof headers.append === 'function') {
            headers.append('sentry-trace', span.toTraceparent());
            headers.append(esm_baggage/* BAGGAGE_HEADER_NAME */.bU, (0,esm_baggage/* mergeAndSerializeBaggage */.J8)(incomingBaggage, headers.get(esm_baggage/* BAGGAGE_HEADER_NAME */.bU)));
    } else if (Array.isArray(headers)) {
      const [, headerBaggageString] = headers.find(([key, _]) => key === esm_baggage/* BAGGAGE_HEADER_NAME */.bU);
      headers = [
        ...headers,
        ['sentry-trace', span.toTraceparent()],
        [esm_baggage/* BAGGAGE_HEADER_NAME */.bU, (0,esm_baggage/* mergeAndSerializeBaggage */.J8)(incomingBaggage, headerBaggageString)],
      ];
    } else {
      headers = {
        ...headers,
        'sentry-trace': span.toTraceparent(),
                baggage: (0,esm_baggage/* mergeAndSerializeBaggage */.J8)(incomingBaggage, headers.baggage),
      };
    }
  } else {
    headers = { 'sentry-trace': span.toTraceparent(), baggage: (0,esm_baggage/* mergeAndSerializeBaggage */.J8)(incomingBaggage) };
  }
  return headers;
}

/**
 * Create and track xhr request spans
 */
function xhrCallback(
  handlerData,
  shouldCreateSpan,
  spans,
) {
  if (
    !(0,utils/* hasTracingEnabled */.zu)() ||
    (handlerData.xhr && handlerData.xhr.__sentry_own_request__) ||
    !(handlerData.xhr && handlerData.xhr.__sentry_xhr__ && shouldCreateSpan(handlerData.xhr.__sentry_xhr__.url))
  ) {
    return;
  }

  var xhr = handlerData.xhr.__sentry_xhr__;

  // check first if the request has finished and is tracked by an existing span which should now end
  if (handlerData.endTimestamp) {
    var spanId = handlerData.xhr.__sentry_xhr_span_id__;
    if (!spanId) return;

    var span = spans[spanId];
    if (span) {
      span.setHttpStatus(xhr.status_code);
      span.finish();

            delete spans[spanId];
    }
    return;
  }

  // if not, create a new span to track it
  var activeTransaction = (0,utils/* getActiveTransaction */.x1)();
  if (activeTransaction) {
    var span = activeTransaction.startChild({
      data: {
        ...xhr.data,
        type: 'xhr',
        method: xhr.method,
        url: xhr.url,
      },
      description: `${xhr.method} ${xhr.url}`,
      op: 'http.client',
    });

    handlerData.xhr.__sentry_xhr_span_id__ = span.spanId;
    spans[handlerData.xhr.__sentry_xhr_span_id__] = span;

    if (handlerData.xhr.setRequestHeader) {
      try {
        handlerData.xhr.setRequestHeader('sentry-trace', span.toTraceparent());

        var headerBaggageString =
          handlerData.xhr.getRequestHeader && handlerData.xhr.getRequestHeader(esm_baggage/* BAGGAGE_HEADER_NAME */.bU);

        handlerData.xhr.setRequestHeader(
          esm_baggage/* BAGGAGE_HEADER_NAME */.bU,
          (0,esm_baggage/* mergeAndSerializeBaggage */.J8)(activeTransaction.getBaggage(), headerBaggageString),
        );
      } catch (_) {
        // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
      }
    }
  }
}


//# sourceMappingURL=request.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/router.js


var router_global = (0,global/* getGlobalObject */.R)();

/**
 * Default function implementing pageload and navigation transactions
 */
function instrumentRoutingWithDefaults(
  customStartTransaction,
  startTransactionOnPageLoad = true,
  startTransactionOnLocationChange = true,
) {
  if (!router_global || !router_global.location) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.warn */.kg.warn('Could not initialize routing instrumentation due to invalid location');
    return;
  }

  let startingUrl = router_global.location.href;

  let activeTransaction;
  if (startTransactionOnPageLoad) {
    activeTransaction = customStartTransaction({
      name: router_global.location.pathname,
      op: 'pageload',
      metadata: { source: 'url' },
    });
  }

  if (startTransactionOnLocationChange) {
    (0,instrument/* addInstrumentationHandler */.o)('history', ({ to, from }) => {
      /**
       * This early return is there to account for some cases where a navigation transaction starts right after
       * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
       * create an uneccessary navigation transaction.
       *
       * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
       * only be caused in certain development environments where the usage of a hot module reloader is causing
       * errors.
       */
      if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
        startingUrl = undefined;
        return;
      }

      if (from !== to) {
        startingUrl = undefined;
        if (activeTransaction) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log(`[Tracing] Finishing current transaction with op: ${activeTransaction.op}`);
          // If there's an open transaction on the scope, we need to finish it before creating an new one.
          activeTransaction.finish();
        }
        activeTransaction = customStartTransaction({
          name: router_global.location.pathname,
          op: 'navigation',
          metadata: { source: 'url' },
        });
      }
    });
  }
}


//# sourceMappingURL=router.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/browsertracing.js









var BROWSER_TRACING_INTEGRATION_ID = 'BrowserTracing';

/** Options for Browser Tracing integration */

var DEFAULT_BROWSER_TRACING_OPTIONS = {
  idleTimeout: idletransaction/* DEFAULT_IDLE_TIMEOUT */.nT,
  finalTimeout: idletransaction/* DEFAULT_FINAL_TIMEOUT */.mg,
  markBackgroundTransactions: true,
  routingInstrumentation: instrumentRoutingWithDefaults,
  startTransactionOnLocationChange: true,
  startTransactionOnPageLoad: true,
  ...defaultRequestInstrumentationOptions,
};

/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 */
class BrowserTracing  {
  // This class currently doesn't have a static `id` field like the other integration classes, because it prevented
  // @sentry/tracing from being treeshaken. Tree shakers do not like static fields, because they behave like side effects.
  // TODO: Come up with a better plan, than using static fields on integration classes, and use that plan on all
  // integrations.

  /** Browser Tracing integration options */
  

  /**
   * @inheritDoc
   */
   __init() {this.name = BROWSER_TRACING_INTEGRATION_ID;}

   constructor(_options) {;BrowserTracing.prototype.__init.call(this);
    let tracingOrigins = defaultRequestInstrumentationOptions.tracingOrigins;
    // NOTE: Logger doesn't work in constructors, as it's initialized after integrations instances
    if (_options) {
      if (_options.tracingOrigins && Array.isArray(_options.tracingOrigins) && _options.tracingOrigins.length !== 0) {
        tracingOrigins = _options.tracingOrigins;
      } else {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (this._emitOptionsWarning = true);
      }
    }

    this.options = {
      ...DEFAULT_BROWSER_TRACING_OPTIONS,
      ..._options,
      tracingOrigins,
    };

    const { _metricOptions } = this.options;
    startTrackingWebVitals(_metricOptions && _metricOptions._reportAllChanges);
  }

  /**
   * @inheritDoc
   */
   setupOnce(_, getCurrentHub) {
    this._getCurrentHub = getCurrentHub;

    if (this._emitOptionsWarning) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        logger/* logger.warn */.kg.warn(
          '[Tracing] You need to define `tracingOrigins` in the options. Set an array of urls or patterns to trace.',
        );
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        logger/* logger.warn */.kg.warn(
          `[Tracing] We added a reasonable default for you: ${defaultRequestInstrumentationOptions.tracingOrigins}`,
        );
    }

        const {
      routingInstrumentation: instrumentRouting,
      startTransactionOnLocationChange,
      startTransactionOnPageLoad,
      markBackgroundTransactions,
      traceFetch,
      traceXHR,
      tracingOrigins,
      shouldCreateSpanForRequest,
    } = this.options;

    instrumentRouting(
      (context) => this._createRouteTransaction(context),
      startTransactionOnPageLoad,
      startTransactionOnLocationChange,
    );

    if (markBackgroundTransactions) {
      registerBackgroundTabDetection();
    }

    instrumentOutgoingRequests({ traceFetch, traceXHR, tracingOrigins, shouldCreateSpanForRequest });
  }

  /** Create routing idle transaction. */
   _createRouteTransaction(context) {
    if (!this._getCurrentHub) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        logger/* logger.warn */.kg.warn(`[Tracing] Did not create ${context.op} transaction because _getCurrentHub is invalid.`);
      return undefined;
    }

        const { beforeNavigate, idleTimeout, finalTimeout } = this.options;

    var parentContextFromHeader = context.op === 'pageload' ? extractTraceDataFromMetaTags() : undefined;

    var expandedContext = {
      ...context,
      ...parentContextFromHeader,
      ...(parentContextFromHeader && {
        metadata: {
          ...context.metadata,
          ...parentContextFromHeader.metadata,
        },
      }),
      trimEnd: true,
    };
    var modifiedContext = typeof beforeNavigate === 'function' ? beforeNavigate(expandedContext) : expandedContext;

    // For backwards compatibility reasons, beforeNavigate can return undefined to "drop" the transaction (prevent it
    // from being sent to Sentry).
    var finalContext = modifiedContext === undefined ? { ...expandedContext, sampled: false } : modifiedContext;

    // If `beforeNavigate` set a custom name, record that fact
    finalContext.metadata =
      finalContext.name !== expandedContext.name
        ? { ...finalContext.metadata, source: 'custom' }
        : finalContext.metadata;

    if (finalContext.sampled === false) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        logger/* logger.log */.kg.log(`[Tracing] Will not send ${finalContext.op} transaction because of beforeNavigate.`);
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log(`[Tracing] Starting ${finalContext.op} transaction on scope`);

    var hub = this._getCurrentHub();
    const { location } = (0,global/* getGlobalObject */.R)() ;

    var idleTransaction = (0,hubextensions/* startIdleTransaction */.lb)(
      hub,
      finalContext,
      idleTimeout,
      finalTimeout,
      true,
      { location }, // for use in the tracesSampler
    );
    idleTransaction.registerBeforeFinishCallback(transaction => {
      addPerformanceEntries(transaction);
      transaction.setTag(
        'sentry_reportAllChanges',
        Boolean(this.options._metricOptions && this.options._metricOptions._reportAllChanges),
      );
    });

    return idleTransaction ;
  }
}

/**
 * Gets transaction context data from `sentry-trace` and `baggage` <meta> tags.
 * @returns Transaction context data or undefined neither tag exists or has valid data
 */
function extractTraceDataFromMetaTags() {
  var sentrytraceValue = getMetaContent('sentry-trace');
  var baggageValue = getMetaContent('baggage');

  var sentrytraceData = sentrytraceValue ? extractTraceparentData(sentrytraceValue) : undefined;
  var baggage = (0,esm_baggage/* parseBaggageSetMutability */.rg)(baggageValue, sentrytraceValue);

  // TODO more extensive checks for baggage validity/emptyness?
  if (sentrytraceData || baggage) {
    return {
      ...(sentrytraceData && sentrytraceData),
      ...(baggage && { metadata: { baggage } }),
    };
  }

  return undefined;
}

/** Returns the value of a meta tag */
function getMetaContent(metaName) {
  var globalObject = (0,global/* getGlobalObject */.R)();

  // DOM/querySelector is not available in all environments
  if (globalObject.document && globalObject.document.querySelector) {
    var el = globalObject.document.querySelector(`meta[name=${metaName}]`);
    return el ? el.getAttribute('content') : null;
  } else {
    return null;
  }
}


//# sourceMappingURL=browsertracing.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/integrations/index.js









//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/index.js














;
;

// Treeshakable guard to remove all code related to tracing

// Guard for tree
if (typeof __SENTRY_TRACING__ === 'undefined' || __SENTRY_TRACING__) {
  // We are patching the global object with our hub extension methods
  (0,hubextensions/* addExtensionMethods */.ro)();
}
//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/misc.js
var misc = __webpack_require__(62844);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/object.js
var object = __webpack_require__(20535);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/performance/client.js



var client_global = (0,global/* getGlobalObject */.R)();

var DEFAULT_TAGS = {
  'routing.instrumentation': 'next-router',
} ;

let activeTransaction = undefined;
let prevTransactionName = undefined;
let startTransaction = undefined;

/**
 * Creates routing instrumention for Next Router. Only supported for
 * client side routing. Works for Next >= 10.
 *
 * Leverages the SingletonRouter from the `next/router` to
 * generate pageload/navigation transactions and parameterize
 * transaction names.
 */
function nextRouterInstrumentation(
  startTransactionCb,
  startTransactionOnPageLoad = true,
  startTransactionOnLocationChange = true,
) {
  startTransaction = startTransactionCb;
  router_default().ready(() => {
    // We can only start the pageload transaction when we have access to the parameterized
    // route name. Setting the transaction name after the transaction is started could lead
    // to possible race conditions with the router, so this approach was taken.
    if (startTransactionOnPageLoad) {
      var pathIsRoute = (router_default()).route !== null;

      prevTransactionName = pathIsRoute ? (0,misc/* stripUrlQueryAndFragment */.rt)((router_default()).route) : client_global.location.pathname;
      activeTransaction = startTransactionCb({
        name: prevTransactionName,
        op: 'pageload',
        tags: DEFAULT_TAGS,
        metadata: {
          source: pathIsRoute ? 'route' : 'url',
        },
      });
    }

    // Spans that aren't attached to any transaction are lost; so if transactions aren't
    // created (besides potentially the onpageload transaction), no need to wrap the router.
    if (!startTransactionOnLocationChange) return;

    // `withRouter` uses `useRouter` underneath:
    // https://github.com/vercel/next.js/blob/de42719619ae69fbd88e445100f15701f6e1e100/packages/next/client/with-router.tsx#L21
    // Router events also use the router:
    // https://github.com/vercel/next.js/blob/de42719619ae69fbd88e445100f15701f6e1e100/packages/next/client/router.ts#L92
    // `Router.changeState` handles the router state changes, so it may be enough to only wrap it
    // (instead of wrapping all of the Router's functions).
    var routerPrototype = Object.getPrototypeOf((router_default()).router);
    (0,object/* fill */.hl)(routerPrototype, 'changeState', changeStateWrapper);
  });
}

/**
 * Wraps Router.changeState()
 * https://github.com/vercel/next.js/blob/da97a18dafc7799e63aa7985adc95f213c2bf5f3/packages/next/next-server/lib/router/router.ts#L1204
 * Start a navigation transaction every time the router changes state.
 */
function changeStateWrapper(originalChangeStateWrapper) {
  var wrapper = function (
    
    method,
    // The parameterized url, ex. posts/[id]/[comment]
    url,
    // The actual url, ex. posts/85/my-comment
    as,
    options,
    // At the moment there are no additional arguments (meaning the rest parameter is empty).
    // This is meant to protect from future additions to Next.js API, especially since this is an
    // internal API.
    ...args
  ) {
    var newTransactionName = (0,misc/* stripUrlQueryAndFragment */.rt)(url);
    // do not start a transaction if it's from the same page
    if (startTransaction !== undefined && prevTransactionName !== newTransactionName) {
      if (activeTransaction) {
        activeTransaction.finish();
      }
      var tags = {
        ...DEFAULT_TAGS,
        method,
        ...options,
      };
      if (prevTransactionName) {
        tags.from = prevTransactionName;
      }
      prevTransactionName = newTransactionName;
      activeTransaction = startTransaction({
        name: prevTransactionName,
        op: 'navigation',
        tags,
        metadata: { source: 'route' },
      });
    }
    return originalChangeStateWrapper.call(this, method, url, as, options, ...args);
  };
  return wrapper;
}


//# sourceMappingURL=client.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/utils/metadata.js


var PACKAGE_NAME_PREFIX = 'npm:@sentry/';

/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 * @param options sdk options object that gets mutated
 * @param names list of package names
 */
function buildMetadata(options, names) {
  options._metadata = options._metadata || {};
  options._metadata.sdk =
    options._metadata.sdk ||
    ({
      name: 'sentry.javascript.nextjs',
      packages: names.map(name => ({
        name: `${PACKAGE_NAME_PREFIX}${name}`,
        version: version/* SDK_VERSION */.J,
      })),
      version: version/* SDK_VERSION */.J,
    } );
}


//# sourceMappingURL=metadata.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/utils/userIntegrations.js
/**
 * Recursively traverses an object to update an existing nested key.
 * Note: The provided key path must include existing properties,
 * the function will not create objects while traversing.
 *
 * @param obj An object to update
 * @param value The value to update the nested key with
 * @param keyPath The path to the key to update ex. fizz.buzz.foo
 */
function setNestedKey(obj, keyPath, value) {
  // Ex. foo.bar.zoop will extract foo and bar.zoop
  var match = keyPath.match(/([a-z]+)\.(.*)/i);
  if (match === null) {
    obj[keyPath] = value;
  } else {
    setNestedKey(obj[match[1]], match[2], value);
  }
}

/**
 * Retrieves the patched integrations with the provided integration.
 *
 * The integration must be present in the final user integrations, and they are compared
 * by integration name. If the user has defined one, there's nothing to patch; if not,
 * the provided integration is added.
 *
 * @param integration The integration to patch, if necessary.
 * @param userIntegrations Integrations defined by the user.
 * @param options options to update for a particular integration
 * @returns Final integrations, patched if necessary.
 */
function addIntegration(
  integration,
  userIntegrations,
  options = {},
) {
  if (Array.isArray(userIntegrations)) {
    return addIntegrationToArray(integration, userIntegrations, options);
  } else {
    return addIntegrationToFunction(integration, userIntegrations, options);
  }
}

function addIntegrationToArray(
  integration,
  userIntegrations,
  options,
) {
  let includesName = false;
    for (let x = 0; x < userIntegrations.length; x++) {
    if (userIntegrations[x].name === integration.name) {
      includesName = true;
    }

    var op = options[userIntegrations[x].name];
    if (op) {
      setNestedKey(userIntegrations[x], op.keyPath, op.value);
    }
  }

  if (includesName) {
    return userIntegrations;
  }
  return [...userIntegrations, integration];
}

function addIntegrationToFunction(
  integration,
  userIntegrationsFunc,
  options,
) {
  var wrapper = defaultIntegrations => {
    var userFinalIntegrations = userIntegrationsFunc(defaultIntegrations);
    return addIntegrationToArray(integration, userFinalIntegrations, options);
  };
  return wrapper;
}


//# sourceMappingURL=userIntegrations.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/index.client.js











// Treeshakable guard to remove all code related to tracing

/** Inits the Sentry NextJS SDK on the browser with the React SDK. */
function index_client_init(options) {
  buildMetadata(options, ['nextjs', 'react']);
  options.environment = options.environment || "production";

  let integrations = options.integrations;

  // Guard below evaluates to true unless __SENTRY_TRACING__ is text-replaced with "false"
  if (typeof __SENTRY_TRACING__ === 'undefined' || __SENTRY_TRACING__) {
    // Only add BrowserTracing if a tracesSampleRate or tracesSampler is set
    if (options.tracesSampleRate !== undefined || options.tracesSampler !== undefined) {
      integrations = createClientIntegrations(options.integrations);
    }
  }

  init({
    ...options,
    integrations,
  });

  (0,esm_exports/* configureScope */.e)(scope => {
    scope.setTag('runtime', 'browser');
    var filterTransactions = event =>
      event.type === 'transaction' && event.transaction === '/404' ? null : event;
    filterTransactions.id = 'NextClient404Filter';
    scope.addEventProcessor(filterTransactions);
  });
}

function createClientIntegrations(integrations) {
  var defaultBrowserTracingIntegration = new BrowserTracing({
    tracingOrigins: [...defaultRequestInstrumentationOptions.tracingOrigins, /^(api\/)/],
    routingInstrumentation: nextRouterInstrumentation,
  });

  if (integrations) {
    return addIntegration(defaultBrowserTracingIntegration, integrations, {
      BrowserTracing: { keyPath: 'options.routingInstrumentation', value: nextRouterInstrumentation },
    });
  } else {
    return [defaultBrowserTracingIntegration];
  }
}


//# sourceMappingURL=index.client.js.map

;// CONCATENATED MODULE: ./sentry.client.config.js



index_client_init({
  dsn: "https://f09d2ba494214876b02bfaaaaf2c8e9d@o273925.ingest.sentry.io/5627183",
  integrations: [
  new BrowserTracing({
    traceXHR: true,
    traceFetch: true })],


  ignoreErrors: [
  // android devices issue
  'ResizeObserver loop limit exceeded',
  // known issue in windows, can be fixed from settings
  'Not in fullscreen mode',
  // error caused by appleBot, no trace stack to find it & its consuming sentry quota for no reason
  'Non-Error exception captured with keys: defaultPrevented, fixed_'],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 0.1,
  beforeBreadcrumb: function beforeBreadcrumb(breadcrumb, hint) {var _breadcrumb$data, _breadcrumb$data2;
    if (
    breadcrumb.category === 'fetch' && (
    String((_breadcrumb$data = breadcrumb.data) === null || _breadcrumb$data === void 0 ? void 0 : _breadcrumb$data.url) === location.origin + '/api' ||
    // for prod until we deploy auth
    String((_breadcrumb$data2 = breadcrumb.data) === null || _breadcrumb$data2 === void 0 ? void 0 : _breadcrumb$data2.url).endsWith('yogobe.com/graphql')))
    {
      var body = JSON.parse(hint.input[1].body);
      breadcrumb.data.operationName = body.operationName;
    }
    return breadcrumb;
  },
  environment: String("https://devenv.yogobe.com").startsWith('https://yogobe.com') ?
  'production' :
  'development'
  // ...
  // Note: if you want to override the automatic release value, do not set a
  // `release` value here - use the environment variable `SENTRY_RELEASE`, so
  // that it will also get attached to your source maps
});

/***/ }),

/***/ 30794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31157);
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78127);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);
function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}










var DynamicBar = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(_base__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({ displayName: "BaseSkeleton__DynamicBar", componentId: "sc-5u0m3l-0" })(["margin:0;padding:0;width:", ";height:", ";border-radius:", ";", ";", ";", ";"],



function (props) {return props.width ? props.width + '%' : '100%';},
function (props) {return props.height ? props.height + 'px' : '0px';},
function (props) {return props.borderRadius ? props.borderRadius : '0px';},
function (props) {return props.shape === 'circle' ? 'border-radius: 50%;' : '';},

function (props) {return (
    props.marginBottom ? "margin-bottom: ".concat(props.marginBottom, "px;") : '');},

function (props) {return (
    props.animation === false && "\n      animation-duration: none;\n      animation-fill-mode: none;\n      animation-iteration-count: none;\n      animation-name: none;\n      animation-timing-function: none;\n    ");});














var BaseSkeleton = function BaseSkeleton(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(DynamicBar, _objectSpread({}, props));
};

/* harmony default export */ __webpack_exports__["Z"] = (BaseSkeleton);

/***/ }),

/***/ 78127:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export darkerBar */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31157);


var loadingAnimation = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.keyframes)(["0%{background-position:-468px 0}100%{background-position:468px 0}"]);








var bar = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({ displayName: "base__bar", componentId: "sc-1x2q20d-0" })(["border-radius:1px;background:linear-gradient( to right,rgb(247,247,247) 8%,rgb(240,240,240) 18%,rgb(247,247,247) 33% );background-size:800px 104px;display:block;width:100%;line-height:1;height:10px;margin-bottom:20px;animation-duration:1s;animation-fill-mode:forwards;animation-iteration-count:infinite;animation-name:", ";animation-timing-function:linear;"],
















loadingAnimation);



var darkerBar = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(bar).withConfig({ displayName: "base__darkerBar", componentId: "sc-1x2q20d-1" })(["background:linear-gradient( to right,rgb(240,240,240) 8%,rgb(233,233,233) 18%,rgb(240,240,240) 33% );"]);








/* harmony default export */ __webpack_exports__["Z"] = (bar);

/***/ }),

/***/ 63144:
/***/ (function(module) {

"use strict";

/* globals self */ var fetch = self.fetch.bind(self);
module.exports = fetch;
module.exports["default"] = module.exports;

//# sourceMappingURL=index.js.map

/***/ }),

/***/ 96086:
/***/ (function(module) {

"use strict";

var assign = Object.assign.bind(Object);
module.exports = assign;
module.exports["default"] = module.exports;

//# sourceMappingURL=object-assign.js.map

/***/ }),

/***/ 6840:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(70989);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 42474:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __dirname = "/";
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];
/* provided dependency */ var process = __webpack_require__(34155);
(function(){var e={7160:function(e,t,r){var i=t;i.bignum=r(711);i.define=r(495).define;i.base=r(853);i.constants=r(7335);i.decoders=r(6701);i.encoders=r(3418)},495:function(e,t,r){var i=r(7160);var n=r(3782);var a=t;a.define=function define(e,t){return new Entity(e,t)};function Entity(e,t){this.name=e;this.body=t;this.decoders={};this.encoders={}}Entity.prototype._createNamed=function createNamed(e){var t;try{t=r(6144).runInThisContext("(function "+this.name+"(entity) {\n"+"  this._initNamed(entity);\n"+"})")}catch(e){t=function(e){this._initNamed(e)}}n(t,e);t.prototype._initNamed=function initnamed(t){e.call(this,t)};return new t(this)};Entity.prototype._getDecoder=function _getDecoder(e){e=e||"der";if(!this.decoders.hasOwnProperty(e))this.decoders[e]=this._createNamed(i.decoders[e]);return this.decoders[e]};Entity.prototype.decode=function decode(e,t,r){return this._getDecoder(t).decode(e,r)};Entity.prototype._getEncoder=function _getEncoder(e){e=e||"der";if(!this.encoders.hasOwnProperty(e))this.encoders[e]=this._createNamed(i.encoders[e]);return this.encoders[e]};Entity.prototype.encode=function encode(e,t,r){return this._getEncoder(t).encode(e,r)}},6483:function(e,t,r){var i=r(3782);var n=r(853).Reporter;var a=r(4300).Buffer;function DecoderBuffer(e,t){n.call(this,t);if(!a.isBuffer(e)){this.error("Input not Buffer");return}this.base=e;this.offset=0;this.length=e.length}i(DecoderBuffer,n);t.C=DecoderBuffer;DecoderBuffer.prototype.save=function save(){return{offset:this.offset,reporter:n.prototype.save.call(this)}};DecoderBuffer.prototype.restore=function restore(e){var t=new DecoderBuffer(this.base);t.offset=e.offset;t.length=this.offset;this.offset=e.offset;n.prototype.restore.call(this,e.reporter);return t};DecoderBuffer.prototype.isEmpty=function isEmpty(){return this.offset===this.length};DecoderBuffer.prototype.readUInt8=function readUInt8(e){if(this.offset+1<=this.length)return this.base.readUInt8(this.offset++,true);else return this.error(e||"DecoderBuffer overrun")};DecoderBuffer.prototype.skip=function skip(e,t){if(!(this.offset+e<=this.length))return this.error(t||"DecoderBuffer overrun");var r=new DecoderBuffer(this.base);r._reporterState=this._reporterState;r.offset=this.offset;r.length=this.offset+e;this.offset+=e;return r};DecoderBuffer.prototype.raw=function raw(e){return this.base.slice(e?e.offset:this.offset,this.length)};function EncoderBuffer(e,t){if(Array.isArray(e)){this.length=0;this.value=e.map((function(e){if(!(e instanceof EncoderBuffer))e=new EncoderBuffer(e,t);this.length+=e.length;return e}),this)}else if(typeof e==="number"){if(!(0<=e&&e<=255))return t.error("non-byte EncoderBuffer value");this.value=e;this.length=1}else if(typeof e==="string"){this.value=e;this.length=a.byteLength(e)}else if(a.isBuffer(e)){this.value=e;this.length=e.length}else{return t.error("Unsupported type: "+typeof e)}}t.R=EncoderBuffer;EncoderBuffer.prototype.join=function join(e,t){if(!e)e=new a(this.length);if(!t)t=0;if(this.length===0)return e;if(Array.isArray(this.value)){this.value.forEach((function(r){r.join(e,t);t+=r.length}))}else{if(typeof this.value==="number")e[t]=this.value;else if(typeof this.value==="string")e.write(this.value,t);else if(a.isBuffer(this.value))this.value.copy(e,t);t+=this.length}return e}},853:function(e,t,r){var i=t;i.Reporter=r(1293).b;i.DecoderBuffer=r(6483).C;i.EncoderBuffer=r(6483).R;i.Node=r(9374)},9374:function(e,t,r){var i=r(853).Reporter;var n=r(853).EncoderBuffer;var a=r(853).DecoderBuffer;var s=r(3523);var o=["seq","seqof","set","setof","objid","bool","gentime","utctime","null_","enum","int","objDesc","bitstr","bmpstr","charstr","genstr","graphstr","ia5str","iso646str","numstr","octstr","printstr","t61str","unistr","utf8str","videostr"];var h=["key","obj","use","optional","explicit","implicit","def","choice","any","contains"].concat(o);var u=["_peekTag","_decodeTag","_use","_decodeStr","_decodeObjid","_decodeTime","_decodeNull","_decodeInt","_decodeBool","_decodeList","_encodeComposite","_encodeStr","_encodeObjid","_encodeTime","_encodeNull","_encodeInt","_encodeBool"];function Node(e,t){var r={};this._baseState=r;r.enc=e;r.parent=t||null;r.children=null;r.tag=null;r.args=null;r.reverseArgs=null;r.choice=null;r.optional=false;r.any=false;r.obj=false;r.use=null;r.useDecoder=null;r.key=null;r["default"]=null;r.explicit=null;r.implicit=null;r.contains=null;if(!r.parent){r.children=[];this._wrap()}}e.exports=Node;var d=["enc","parent","children","tag","args","reverseArgs","choice","optional","any","obj","use","alteredUse","key","default","explicit","implicit","contains"];Node.prototype.clone=function clone(){var e=this._baseState;var t={};d.forEach((function(r){t[r]=e[r]}));var r=new this.constructor(t.parent);r._baseState=t;return r};Node.prototype._wrap=function wrap(){var e=this._baseState;h.forEach((function(t){this[t]=function _wrappedMethod(){var r=new this.constructor(this);e.children.push(r);return r[t].apply(r,arguments)}}),this)};Node.prototype._init=function init(e){var t=this._baseState;s(t.parent===null);e.call(this);t.children=t.children.filter((function(e){return e._baseState.parent===this}),this);s.equal(t.children.length,1,"Root node can have only one child")};Node.prototype._useArgs=function useArgs(e){var t=this._baseState;var r=e.filter((function(e){return e instanceof this.constructor}),this);e=e.filter((function(e){return!(e instanceof this.constructor)}),this);if(r.length!==0){s(t.children===null);t.children=r;r.forEach((function(e){e._baseState.parent=this}),this)}if(e.length!==0){s(t.args===null);t.args=e;t.reverseArgs=e.map((function(e){if(typeof e!=="object"||e.constructor!==Object)return e;var t={};Object.keys(e).forEach((function(r){if(r==(r|0))r|=0;var i=e[r];t[i]=r}));return t}))}};u.forEach((function(e){Node.prototype[e]=function _overrided(){var t=this._baseState;throw new Error(e+" not implemented for encoding: "+t.enc)}}));o.forEach((function(e){Node.prototype[e]=function _tagMethod(){var t=this._baseState;var r=Array.prototype.slice.call(arguments);s(t.tag===null);t.tag=e;this._useArgs(r);return this}}));Node.prototype.use=function use(e){s(e);var t=this._baseState;s(t.use===null);t.use=e;return this};Node.prototype.optional=function optional(){var e=this._baseState;e.optional=true;return this};Node.prototype.def=function def(e){var t=this._baseState;s(t["default"]===null);t["default"]=e;t.optional=true;return this};Node.prototype.explicit=function explicit(e){var t=this._baseState;s(t.explicit===null&&t.implicit===null);t.explicit=e;return this};Node.prototype.implicit=function implicit(e){var t=this._baseState;s(t.explicit===null&&t.implicit===null);t.implicit=e;return this};Node.prototype.obj=function obj(){var e=this._baseState;var t=Array.prototype.slice.call(arguments);e.obj=true;if(t.length!==0)this._useArgs(t);return this};Node.prototype.key=function key(e){var t=this._baseState;s(t.key===null);t.key=e;return this};Node.prototype.any=function any(){var e=this._baseState;e.any=true;return this};Node.prototype.choice=function choice(e){var t=this._baseState;s(t.choice===null);t.choice=e;this._useArgs(Object.keys(e).map((function(t){return e[t]})));return this};Node.prototype.contains=function contains(e){var t=this._baseState;s(t.use===null);t.contains=e;return this};Node.prototype._decode=function decode(e,t){var r=this._baseState;if(r.parent===null)return e.wrapResult(r.children[0]._decode(e,t));var i=r["default"];var n=true;var s=null;if(r.key!==null)s=e.enterKey(r.key);if(r.optional){var o=null;if(r.explicit!==null)o=r.explicit;else if(r.implicit!==null)o=r.implicit;else if(r.tag!==null)o=r.tag;if(o===null&&!r.any){var h=e.save();try{if(r.choice===null)this._decodeGeneric(r.tag,e,t);else this._decodeChoice(e,t);n=true}catch(e){n=false}e.restore(h)}else{n=this._peekTag(e,o,r.any);if(e.isError(n))return n}}var u;if(r.obj&&n)u=e.enterObject();if(n){if(r.explicit!==null){var d=this._decodeTag(e,r.explicit);if(e.isError(d))return d;e=d}var c=e.offset;if(r.use===null&&r.choice===null){if(r.any)var h=e.save();var l=this._decodeTag(e,r.implicit!==null?r.implicit:r.tag,r.any);if(e.isError(l))return l;if(r.any)i=e.raw(h);else e=l}if(t&&t.track&&r.tag!==null)t.track(e.path(),c,e.length,"tagged");if(t&&t.track&&r.tag!==null)t.track(e.path(),e.offset,e.length,"content");if(r.any)i=i;else if(r.choice===null)i=this._decodeGeneric(r.tag,e,t);else i=this._decodeChoice(e,t);if(e.isError(i))return i;if(!r.any&&r.choice===null&&r.children!==null){r.children.forEach((function decodeChildren(r){r._decode(e,t)}))}if(r.contains&&(r.tag==="octstr"||r.tag==="bitstr")){var p=new a(i);i=this._getUse(r.contains,e._reporterState.obj)._decode(p,t)}}if(r.obj&&n)i=e.leaveObject(u);if(r.key!==null&&(i!==null||n===true))e.leaveKey(s,r.key,i);else if(s!==null)e.exitKey(s);return i};Node.prototype._decodeGeneric=function decodeGeneric(e,t,r){var i=this._baseState;if(e==="seq"||e==="set")return null;if(e==="seqof"||e==="setof")return this._decodeList(t,e,i.args[0],r);else if(/str$/.test(e))return this._decodeStr(t,e,r);else if(e==="objid"&&i.args)return this._decodeObjid(t,i.args[0],i.args[1],r);else if(e==="objid")return this._decodeObjid(t,null,null,r);else if(e==="gentime"||e==="utctime")return this._decodeTime(t,e,r);else if(e==="null_")return this._decodeNull(t,r);else if(e==="bool")return this._decodeBool(t,r);else if(e==="objDesc")return this._decodeStr(t,e,r);else if(e==="int"||e==="enum")return this._decodeInt(t,i.args&&i.args[0],r);if(i.use!==null){return this._getUse(i.use,t._reporterState.obj)._decode(t,r)}else{return t.error("unknown tag: "+e)}};Node.prototype._getUse=function _getUse(e,t){var r=this._baseState;r.useDecoder=this._use(e,t);s(r.useDecoder._baseState.parent===null);r.useDecoder=r.useDecoder._baseState.children[0];if(r.implicit!==r.useDecoder._baseState.implicit){r.useDecoder=r.useDecoder.clone();r.useDecoder._baseState.implicit=r.implicit}return r.useDecoder};Node.prototype._decodeChoice=function decodeChoice(e,t){var r=this._baseState;var i=null;var n=false;Object.keys(r.choice).some((function(a){var s=e.save();var o=r.choice[a];try{var h=o._decode(e,t);if(e.isError(h))return false;i={type:a,value:h};n=true}catch(t){e.restore(s);return false}return true}),this);if(!n)return e.error("Choice not matched");return i};Node.prototype._createEncoderBuffer=function createEncoderBuffer(e){return new n(e,this.reporter)};Node.prototype._encode=function encode(e,t,r){var i=this._baseState;if(i["default"]!==null&&i["default"]===e)return;var n=this._encodeValue(e,t,r);if(n===undefined)return;if(this._skipDefault(n,t,r))return;return n};Node.prototype._encodeValue=function encode(e,t,r){var n=this._baseState;if(n.parent===null)return n.children[0]._encode(e,t||new i);var a=null;this.reporter=t;if(n.optional&&e===undefined){if(n["default"]!==null)e=n["default"];else return}var s=null;var o=false;if(n.any){a=this._createEncoderBuffer(e)}else if(n.choice){a=this._encodeChoice(e,t)}else if(n.contains){s=this._getUse(n.contains,r)._encode(e,t);o=true}else if(n.children){s=n.children.map((function(r){if(r._baseState.tag==="null_")return r._encode(null,t,e);if(r._baseState.key===null)return t.error("Child should have a key");var i=t.enterKey(r._baseState.key);if(typeof e!=="object")return t.error("Child expected, but input is not object");var n=r._encode(e[r._baseState.key],t,e);t.leaveKey(i);return n}),this).filter((function(e){return e}));s=this._createEncoderBuffer(s)}else{if(n.tag==="seqof"||n.tag==="setof"){if(!(n.args&&n.args.length===1))return t.error("Too many args for : "+n.tag);if(!Array.isArray(e))return t.error("seqof/setof, but data is not Array");var h=this.clone();h._baseState.implicit=null;s=this._createEncoderBuffer(e.map((function(r){var i=this._baseState;return this._getUse(i.args[0],e)._encode(r,t)}),h))}else if(n.use!==null){a=this._getUse(n.use,r)._encode(e,t)}else{s=this._encodePrimitive(n.tag,e);o=true}}var a;if(!n.any&&n.choice===null){var u=n.implicit!==null?n.implicit:n.tag;var d=n.implicit===null?"universal":"context";if(u===null){if(n.use===null)t.error("Tag could be omitted only for .use()")}else{if(n.use===null)a=this._encodeComposite(u,o,d,s)}}if(n.explicit!==null)a=this._encodeComposite(n.explicit,false,"context",a);return a};Node.prototype._encodeChoice=function encodeChoice(e,t){var r=this._baseState;var i=r.choice[e.type];if(!i){s(false,e.type+" not found in "+JSON.stringify(Object.keys(r.choice)))}return i._encode(e.value,t)};Node.prototype._encodePrimitive=function encodePrimitive(e,t){var r=this._baseState;if(/str$/.test(e))return this._encodeStr(t,e);else if(e==="objid"&&r.args)return this._encodeObjid(t,r.reverseArgs[0],r.args[1]);else if(e==="objid")return this._encodeObjid(t,null,null);else if(e==="gentime"||e==="utctime")return this._encodeTime(t,e);else if(e==="null_")return this._encodeNull();else if(e==="int"||e==="enum")return this._encodeInt(t,r.args&&r.reverseArgs[0]);else if(e==="bool")return this._encodeBool(t);else if(e==="objDesc")return this._encodeStr(t,e);else throw new Error("Unsupported tag: "+e)};Node.prototype._isNumstr=function isNumstr(e){return/^[0-9 ]*$/.test(e)};Node.prototype._isPrintstr=function isPrintstr(e){return/^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(e)}},1293:function(e,t,r){var i=r(3782);function Reporter(e){this._reporterState={obj:null,path:[],options:e||{},errors:[]}}t.b=Reporter;Reporter.prototype.isError=function isError(e){return e instanceof ReporterError};Reporter.prototype.save=function save(){var e=this._reporterState;return{obj:e.obj,pathLen:e.path.length}};Reporter.prototype.restore=function restore(e){var t=this._reporterState;t.obj=e.obj;t.path=t.path.slice(0,e.pathLen)};Reporter.prototype.enterKey=function enterKey(e){return this._reporterState.path.push(e)};Reporter.prototype.exitKey=function exitKey(e){var t=this._reporterState;t.path=t.path.slice(0,e-1)};Reporter.prototype.leaveKey=function leaveKey(e,t,r){var i=this._reporterState;this.exitKey(e);if(i.obj!==null)i.obj[t]=r};Reporter.prototype.path=function path(){return this._reporterState.path.join("/")};Reporter.prototype.enterObject=function enterObject(){var e=this._reporterState;var t=e.obj;e.obj={};return t};Reporter.prototype.leaveObject=function leaveObject(e){var t=this._reporterState;var r=t.obj;t.obj=e;return r};Reporter.prototype.error=function error(e){var t;var r=this._reporterState;var i=e instanceof ReporterError;if(i){t=e}else{t=new ReporterError(r.path.map((function(e){return"["+JSON.stringify(e)+"]"})).join(""),e.message||e,e.stack)}if(!r.options.partial)throw t;if(!i)r.errors.push(t);return t};Reporter.prototype.wrapResult=function wrapResult(e){var t=this._reporterState;if(!t.options.partial)return e;return{result:this.isError(e)?null:e,errors:t.errors}};function ReporterError(e,t){this.path=e;this.rethrow(t)}i(ReporterError,Error);ReporterError.prototype.rethrow=function rethrow(e){this.message=e+" at: "+(this.path||"(shallow)");if(Error.captureStackTrace)Error.captureStackTrace(this,ReporterError);if(!this.stack){try{throw new Error(this.message)}catch(e){this.stack=e.stack}}return this}},9791:function(e,t,r){var i=r(7335);t.tagClass={0:"universal",1:"application",2:"context",3:"private"};t.tagClassByName=i._reverse(t.tagClass);t.tag={0:"end",1:"bool",2:"int",3:"bitstr",4:"octstr",5:"null_",6:"objid",7:"objDesc",8:"external",9:"real",10:"enum",11:"embed",12:"utf8str",13:"relativeOid",16:"seq",17:"set",18:"numstr",19:"printstr",20:"t61str",21:"videostr",22:"ia5str",23:"utctime",24:"gentime",25:"graphstr",26:"iso646str",27:"genstr",28:"unistr",29:"charstr",30:"bmpstr"};t.tagByName=i._reverse(t.tag)},7335:function(e,t,r){var i=t;i._reverse=function reverse(e){var t={};Object.keys(e).forEach((function(r){if((r|0)==r)r=r|0;var i=e[r];t[i]=r}));return t};i.der=r(9791)},2259:function(e,t,r){var i=r(3782);var n=r(7160);var a=n.base;var s=n.bignum;var o=n.constants.der;function DERDecoder(e){this.enc="der";this.name=e.name;this.entity=e;this.tree=new DERNode;this.tree._init(e.body)}e.exports=DERDecoder;DERDecoder.prototype.decode=function decode(e,t){if(!(e instanceof a.DecoderBuffer))e=new a.DecoderBuffer(e,t);return this.tree._decode(e,t)};function DERNode(e){a.Node.call(this,"der",e)}i(DERNode,a.Node);DERNode.prototype._peekTag=function peekTag(e,t,r){if(e.isEmpty())return false;var i=e.save();var n=derDecodeTag(e,'Failed to peek tag: "'+t+'"');if(e.isError(n))return n;e.restore(i);return n.tag===t||n.tagStr===t||n.tagStr+"of"===t||r};DERNode.prototype._decodeTag=function decodeTag(e,t,r){var i=derDecodeTag(e,'Failed to decode tag of "'+t+'"');if(e.isError(i))return i;var n=derDecodeLen(e,i.primitive,'Failed to get length of "'+t+'"');if(e.isError(n))return n;if(!r&&i.tag!==t&&i.tagStr!==t&&i.tagStr+"of"!==t){return e.error('Failed to match tag: "'+t+'"')}if(i.primitive||n!==null)return e.skip(n,'Failed to match body of: "'+t+'"');var a=e.save();var s=this._skipUntilEnd(e,'Failed to skip indefinite length body: "'+this.tag+'"');if(e.isError(s))return s;n=e.offset-a.offset;e.restore(a);return e.skip(n,'Failed to match body of: "'+t+'"')};DERNode.prototype._skipUntilEnd=function skipUntilEnd(e,t){while(true){var r=derDecodeTag(e,t);if(e.isError(r))return r;var i=derDecodeLen(e,r.primitive,t);if(e.isError(i))return i;var n;if(r.primitive||i!==null)n=e.skip(i);else n=this._skipUntilEnd(e,t);if(e.isError(n))return n;if(r.tagStr==="end")break}};DERNode.prototype._decodeList=function decodeList(e,t,r,i){var n=[];while(!e.isEmpty()){var a=this._peekTag(e,"end");if(e.isError(a))return a;var s=r.decode(e,"der",i);if(e.isError(s)&&a)break;n.push(s)}return n};DERNode.prototype._decodeStr=function decodeStr(e,t){if(t==="bitstr"){var r=e.readUInt8();if(e.isError(r))return r;return{unused:r,data:e.raw()}}else if(t==="bmpstr"){var i=e.raw();if(i.length%2===1)return e.error("Decoding of string type: bmpstr length mismatch");var n="";for(var a=0;a<i.length/2;a++){n+=String.fromCharCode(i.readUInt16BE(a*2))}return n}else if(t==="numstr"){var s=e.raw().toString("ascii");if(!this._isNumstr(s)){return e.error("Decoding of string type: "+"numstr unsupported characters")}return s}else if(t==="octstr"){return e.raw()}else if(t==="objDesc"){return e.raw()}else if(t==="printstr"){var o=e.raw().toString("ascii");if(!this._isPrintstr(o)){return e.error("Decoding of string type: "+"printstr unsupported characters")}return o}else if(/str$/.test(t)){return e.raw().toString()}else{return e.error("Decoding of string type: "+t+" unsupported")}};DERNode.prototype._decodeObjid=function decodeObjid(e,t,r){var i;var n=[];var a=0;while(!e.isEmpty()){var s=e.readUInt8();a<<=7;a|=s&127;if((s&128)===0){n.push(a);a=0}}if(s&128)n.push(a);var o=n[0]/40|0;var h=n[0]%40;if(r)i=n;else i=[o,h].concat(n.slice(1));if(t){var u=t[i.join(" ")];if(u===undefined)u=t[i.join(".")];if(u!==undefined)i=u}return i};DERNode.prototype._decodeTime=function decodeTime(e,t){var r=e.raw().toString();if(t==="gentime"){var i=r.slice(0,4)|0;var n=r.slice(4,6)|0;var a=r.slice(6,8)|0;var s=r.slice(8,10)|0;var o=r.slice(10,12)|0;var h=r.slice(12,14)|0}else if(t==="utctime"){var i=r.slice(0,2)|0;var n=r.slice(2,4)|0;var a=r.slice(4,6)|0;var s=r.slice(6,8)|0;var o=r.slice(8,10)|0;var h=r.slice(10,12)|0;if(i<70)i=2e3+i;else i=1900+i}else{return e.error("Decoding "+t+" time is not supported yet")}return Date.UTC(i,n-1,a,s,o,h,0)};DERNode.prototype._decodeNull=function decodeNull(e){return null};DERNode.prototype._decodeBool=function decodeBool(e){var t=e.readUInt8();if(e.isError(t))return t;else return t!==0};DERNode.prototype._decodeInt=function decodeInt(e,t){var r=e.raw();var i=new s(r);if(t)i=t[i.toString(10)]||i;return i};DERNode.prototype._use=function use(e,t){if(typeof e==="function")e=e(t);return e._getDecoder("der").tree};function derDecodeTag(e,t){var r=e.readUInt8(t);if(e.isError(r))return r;var i=o.tagClass[r>>6];var n=(r&32)===0;if((r&31)===31){var a=r;r=0;while((a&128)===128){a=e.readUInt8(t);if(e.isError(a))return a;r<<=7;r|=a&127}}else{r&=31}var s=o.tag[r];return{cls:i,primitive:n,tag:r,tagStr:s}}function derDecodeLen(e,t,r){var i=e.readUInt8(r);if(e.isError(i))return i;if(!t&&i===128)return null;if((i&128)===0){return i}var n=i&127;if(n>4)return e.error("length octect is too long");i=0;for(var a=0;a<n;a++){i<<=8;var s=e.readUInt8(r);if(e.isError(s))return s;i|=s}return i}},6701:function(e,t,r){var i=t;i.der=r(2259);i.pem=r(8527)},8527:function(e,t,r){var i=r(3782);var n=r(4300).Buffer;var a=r(2259);function PEMDecoder(e){a.call(this,e);this.enc="pem"}i(PEMDecoder,a);e.exports=PEMDecoder;PEMDecoder.prototype.decode=function decode(e,t){var r=e.toString().split(/[\r\n]+/g);var i=t.label.toUpperCase();var s=/^-----(BEGIN|END) ([^-]+)-----$/;var o=-1;var h=-1;for(var u=0;u<r.length;u++){var d=r[u].match(s);if(d===null)continue;if(d[2]!==i)continue;if(o===-1){if(d[1]!=="BEGIN")break;o=u}else{if(d[1]!=="END")break;h=u;break}}if(o===-1||h===-1)throw new Error("PEM section not found for: "+i);var c=r.slice(o+1,h).join("");c.replace(/[^a-z0-9\+\/=]+/gi,"");var l=new n(c,"base64");return a.prototype.decode.call(this,l,t)}},7804:function(e,t,r){var i=r(3782);var n=r(4300).Buffer;var a=r(7160);var s=a.base;var o=a.constants.der;function DEREncoder(e){this.enc="der";this.name=e.name;this.entity=e;this.tree=new DERNode;this.tree._init(e.body)}e.exports=DEREncoder;DEREncoder.prototype.encode=function encode(e,t){return this.tree._encode(e,t).join()};function DERNode(e){s.Node.call(this,"der",e)}i(DERNode,s.Node);DERNode.prototype._encodeComposite=function encodeComposite(e,t,r,i){var a=encodeTag(e,t,r,this.reporter);if(i.length<128){var s=new n(2);s[0]=a;s[1]=i.length;return this._createEncoderBuffer([s,i])}var o=1;for(var h=i.length;h>=256;h>>=8)o++;var s=new n(1+1+o);s[0]=a;s[1]=128|o;for(var h=1+o,u=i.length;u>0;h--,u>>=8)s[h]=u&255;return this._createEncoderBuffer([s,i])};DERNode.prototype._encodeStr=function encodeStr(e,t){if(t==="bitstr"){return this._createEncoderBuffer([e.unused|0,e.data])}else if(t==="bmpstr"){var r=new n(e.length*2);for(var i=0;i<e.length;i++){r.writeUInt16BE(e.charCodeAt(i),i*2)}return this._createEncoderBuffer(r)}else if(t==="numstr"){if(!this._isNumstr(e)){return this.reporter.error("Encoding of string type: numstr supports "+"only digits and space")}return this._createEncoderBuffer(e)}else if(t==="printstr"){if(!this._isPrintstr(e)){return this.reporter.error("Encoding of string type: printstr supports "+"only latin upper and lower case letters, "+"digits, space, apostrophe, left and rigth "+"parenthesis, plus sign, comma, hyphen, "+"dot, slash, colon, equal sign, "+"question mark")}return this._createEncoderBuffer(e)}else if(/str$/.test(t)){return this._createEncoderBuffer(e)}else if(t==="objDesc"){return this._createEncoderBuffer(e)}else{return this.reporter.error("Encoding of string type: "+t+" unsupported")}};DERNode.prototype._encodeObjid=function encodeObjid(e,t,r){if(typeof e==="string"){if(!t)return this.reporter.error("string objid given, but no values map found");if(!t.hasOwnProperty(e))return this.reporter.error("objid not found in values map");e=t[e].split(/[\s\.]+/g);for(var i=0;i<e.length;i++)e[i]|=0}else if(Array.isArray(e)){e=e.slice();for(var i=0;i<e.length;i++)e[i]|=0}if(!Array.isArray(e)){return this.reporter.error("objid() should be either array or string, "+"got: "+JSON.stringify(e))}if(!r){if(e[1]>=40)return this.reporter.error("Second objid identifier OOB");e.splice(0,2,e[0]*40+e[1])}var a=0;for(var i=0;i<e.length;i++){var s=e[i];for(a++;s>=128;s>>=7)a++}var o=new n(a);var h=o.length-1;for(var i=e.length-1;i>=0;i--){var s=e[i];o[h--]=s&127;while((s>>=7)>0)o[h--]=128|s&127}return this._createEncoderBuffer(o)};function two(e){if(e<10)return"0"+e;else return e}DERNode.prototype._encodeTime=function encodeTime(e,t){var r;var i=new Date(e);if(t==="gentime"){r=[two(i.getFullYear()),two(i.getUTCMonth()+1),two(i.getUTCDate()),two(i.getUTCHours()),two(i.getUTCMinutes()),two(i.getUTCSeconds()),"Z"].join("")}else if(t==="utctime"){r=[two(i.getFullYear()%100),two(i.getUTCMonth()+1),two(i.getUTCDate()),two(i.getUTCHours()),two(i.getUTCMinutes()),two(i.getUTCSeconds()),"Z"].join("")}else{this.reporter.error("Encoding "+t+" time is not supported yet")}return this._encodeStr(r,"octstr")};DERNode.prototype._encodeNull=function encodeNull(){return this._createEncoderBuffer("")};DERNode.prototype._encodeInt=function encodeInt(e,t){if(typeof e==="string"){if(!t)return this.reporter.error("String int or enum given, but no values map");if(!t.hasOwnProperty(e)){return this.reporter.error("Values map doesn't contain: "+JSON.stringify(e))}e=t[e]}if(typeof e!=="number"&&!n.isBuffer(e)){var r=e.toArray();if(!e.sign&&r[0]&128){r.unshift(0)}e=new n(r)}if(n.isBuffer(e)){var i=e.length;if(e.length===0)i++;var a=new n(i);e.copy(a);if(e.length===0)a[0]=0;return this._createEncoderBuffer(a)}if(e<128)return this._createEncoderBuffer(e);if(e<256)return this._createEncoderBuffer([0,e]);var i=1;for(var s=e;s>=256;s>>=8)i++;var a=new Array(i);for(var s=a.length-1;s>=0;s--){a[s]=e&255;e>>=8}if(a[0]&128){a.unshift(0)}return this._createEncoderBuffer(new n(a))};DERNode.prototype._encodeBool=function encodeBool(e){return this._createEncoderBuffer(e?255:0)};DERNode.prototype._use=function use(e,t){if(typeof e==="function")e=e(t);return e._getEncoder("der").tree};DERNode.prototype._skipDefault=function skipDefault(e,t,r){var i=this._baseState;var n;if(i["default"]===null)return false;var a=e.join();if(i.defaultBuffer===undefined)i.defaultBuffer=this._encodeValue(i["default"],t,r).join();if(a.length!==i.defaultBuffer.length)return false;for(n=0;n<a.length;n++)if(a[n]!==i.defaultBuffer[n])return false;return true};function encodeTag(e,t,r,i){var n;if(e==="seqof")e="seq";else if(e==="setof")e="set";if(o.tagByName.hasOwnProperty(e))n=o.tagByName[e];else if(typeof e==="number"&&(e|0)===e)n=e;else return i.error("Unknown tag: "+e);if(n>=31)return i.error("Multi-octet tag encoding unsupported");if(!t)n|=32;n|=o.tagClassByName[r||"universal"]<<6;return n}},3418:function(e,t,r){var i=t;i.der=r(7804);i.pem=r(1564)},1564:function(e,t,r){var i=r(3782);var n=r(7804);function PEMEncoder(e){n.call(this,e);this.enc="pem"}i(PEMEncoder,n);e.exports=PEMEncoder;PEMEncoder.prototype.encode=function encode(e,t){var r=n.prototype.encode.call(this,e);var i=r.toString("base64");var a=["-----BEGIN "+t.label+"-----"];for(var s=0;s<i.length;s+=64)a.push(i.slice(s,s+64));a.push("-----END "+t.label+"-----");return a.join("\n")}},711:function(e,t,r){e=r.nmd(e);(function(e,t){"use strict";function assert(e,t){if(!e)throw new Error(t||"Assertion failed")}function inherits(e,t){e.super_=t;var TempCtor=function(){};TempCtor.prototype=t.prototype;e.prototype=new TempCtor;e.prototype.constructor=e}function BN(e,t,r){if(BN.isBN(e)){return e}this.negative=0;this.words=null;this.length=0;this.red=null;if(e!==null){if(t==="le"||t==="be"){r=t;t=10}this._init(e||0,t||10,r||"be")}}if(typeof e==="object"){e.exports=BN}else{t.BN=BN}BN.BN=BN;BN.wordSize=26;var i;try{i=r(4300).Buffer}catch(e){}BN.isBN=function isBN(e){if(e instanceof BN){return true}return e!==null&&typeof e==="object"&&e.constructor.wordSize===BN.wordSize&&Array.isArray(e.words)};BN.max=function max(e,t){if(e.cmp(t)>0)return e;return t};BN.min=function min(e,t){if(e.cmp(t)<0)return e;return t};BN.prototype._init=function init(e,t,r){if(typeof e==="number"){return this._initNumber(e,t,r)}if(typeof e==="object"){return this._initArray(e,t,r)}if(t==="hex"){t=16}assert(t===(t|0)&&t>=2&&t<=36);e=e.toString().replace(/\s+/g,"");var i=0;if(e[0]==="-"){i++}if(t===16){this._parseHex(e,i)}else{this._parseBase(e,t,i)}if(e[0]==="-"){this.negative=1}this.strip();if(r!=="le")return;this._initArray(this.toArray(),t,r)};BN.prototype._initNumber=function _initNumber(e,t,r){if(e<0){this.negative=1;e=-e}if(e<67108864){this.words=[e&67108863];this.length=1}else if(e<4503599627370496){this.words=[e&67108863,e/67108864&67108863];this.length=2}else{assert(e<9007199254740992);this.words=[e&67108863,e/67108864&67108863,1];this.length=3}if(r!=="le")return;this._initArray(this.toArray(),t,r)};BN.prototype._initArray=function _initArray(e,t,r){assert(typeof e.length==="number");if(e.length<=0){this.words=[0];this.length=1;return this}this.length=Math.ceil(e.length/3);this.words=new Array(this.length);for(var i=0;i<this.length;i++){this.words[i]=0}var n,a;var s=0;if(r==="be"){for(i=e.length-1,n=0;i>=0;i-=3){a=e[i]|e[i-1]<<8|e[i-2]<<16;this.words[n]|=a<<s&67108863;this.words[n+1]=a>>>26-s&67108863;s+=24;if(s>=26){s-=26;n++}}}else if(r==="le"){for(i=0,n=0;i<e.length;i+=3){a=e[i]|e[i+1]<<8|e[i+2]<<16;this.words[n]|=a<<s&67108863;this.words[n+1]=a>>>26-s&67108863;s+=24;if(s>=26){s-=26;n++}}}return this.strip()};function parseHex(e,t,r){var i=0;var n=Math.min(e.length,r);for(var a=t;a<n;a++){var s=e.charCodeAt(a)-48;i<<=4;if(s>=49&&s<=54){i|=s-49+10}else if(s>=17&&s<=22){i|=s-17+10}else{i|=s&15}}return i}BN.prototype._parseHex=function _parseHex(e,t){this.length=Math.ceil((e.length-t)/6);this.words=new Array(this.length);for(var r=0;r<this.length;r++){this.words[r]=0}var i,n;var a=0;for(r=e.length-6,i=0;r>=t;r-=6){n=parseHex(e,r,r+6);this.words[i]|=n<<a&67108863;this.words[i+1]|=n>>>26-a&4194303;a+=24;if(a>=26){a-=26;i++}}if(r+6!==t){n=parseHex(e,t,r+6);this.words[i]|=n<<a&67108863;this.words[i+1]|=n>>>26-a&4194303}this.strip()};function parseBase(e,t,r,i){var n=0;var a=Math.min(e.length,r);for(var s=t;s<a;s++){var o=e.charCodeAt(s)-48;n*=i;if(o>=49){n+=o-49+10}else if(o>=17){n+=o-17+10}else{n+=o}}return n}BN.prototype._parseBase=function _parseBase(e,t,r){this.words=[0];this.length=1;for(var i=0,n=1;n<=67108863;n*=t){i++}i--;n=n/t|0;var a=e.length-r;var s=a%i;var o=Math.min(a,a-s)+r;var h=0;for(var u=r;u<o;u+=i){h=parseBase(e,u,u+i,t);this.imuln(n);if(this.words[0]+h<67108864){this.words[0]+=h}else{this._iaddn(h)}}if(s!==0){var d=1;h=parseBase(e,u,e.length,t);for(u=0;u<s;u++){d*=t}this.imuln(d);if(this.words[0]+h<67108864){this.words[0]+=h}else{this._iaddn(h)}}};BN.prototype.copy=function copy(e){e.words=new Array(this.length);for(var t=0;t<this.length;t++){e.words[t]=this.words[t]}e.length=this.length;e.negative=this.negative;e.red=this.red};BN.prototype.clone=function clone(){var e=new BN(null);this.copy(e);return e};BN.prototype._expand=function _expand(e){while(this.length<e){this.words[this.length++]=0}return this};BN.prototype.strip=function strip(){while(this.length>1&&this.words[this.length-1]===0){this.length--}return this._normSign()};BN.prototype._normSign=function _normSign(){if(this.length===1&&this.words[0]===0){this.negative=0}return this};BN.prototype.inspect=function inspect(){return(this.red?"<BN-R: ":"<BN: ")+this.toString(16)+">"};var n=["","0","00","000","0000","00000","000000","0000000","00000000","000000000","0000000000","00000000000","000000000000","0000000000000","00000000000000","000000000000000","0000000000000000","00000000000000000","000000000000000000","0000000000000000000","00000000000000000000","000000000000000000000","0000000000000000000000","00000000000000000000000","000000000000000000000000","0000000000000000000000000"];var a=[0,0,25,16,12,11,10,9,8,8,7,7,7,7,6,6,6,6,6,6,6,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5];var s=[0,0,33554432,43046721,16777216,48828125,60466176,40353607,16777216,43046721,1e7,19487171,35831808,62748517,7529536,11390625,16777216,24137569,34012224,47045881,64e6,4084101,5153632,6436343,7962624,9765625,11881376,14348907,17210368,20511149,243e5,28629151,33554432,39135393,45435424,52521875,60466176];BN.prototype.toString=function toString(e,t){e=e||10;t=t|0||1;var r;if(e===16||e==="hex"){r="";var i=0;var o=0;for(var h=0;h<this.length;h++){var u=this.words[h];var d=((u<<i|o)&16777215).toString(16);o=u>>>24-i&16777215;if(o!==0||h!==this.length-1){r=n[6-d.length]+d+r}else{r=d+r}i+=2;if(i>=26){i-=26;h--}}if(o!==0){r=o.toString(16)+r}while(r.length%t!==0){r="0"+r}if(this.negative!==0){r="-"+r}return r}if(e===(e|0)&&e>=2&&e<=36){var c=a[e];var l=s[e];r="";var p=this.clone();p.negative=0;while(!p.isZero()){var v=p.modn(l).toString(e);p=p.idivn(l);if(!p.isZero()){r=n[c-v.length]+v+r}else{r=v+r}}if(this.isZero()){r="0"+r}while(r.length%t!==0){r="0"+r}if(this.negative!==0){r="-"+r}return r}assert(false,"Base should be between 2 and 36")};BN.prototype.toNumber=function toNumber(){var e=this.words[0];if(this.length===2){e+=this.words[1]*67108864}else if(this.length===3&&this.words[2]===1){e+=4503599627370496+this.words[1]*67108864}else if(this.length>2){assert(false,"Number can only safely store up to 53 bits")}return this.negative!==0?-e:e};BN.prototype.toJSON=function toJSON(){return this.toString(16)};BN.prototype.toBuffer=function toBuffer(e,t){assert(typeof i!=="undefined");return this.toArrayLike(i,e,t)};BN.prototype.toArray=function toArray(e,t){return this.toArrayLike(Array,e,t)};BN.prototype.toArrayLike=function toArrayLike(e,t,r){var i=this.byteLength();var n=r||Math.max(1,i);assert(i<=n,"byte array longer than desired length");assert(n>0,"Requested array length <= 0");this.strip();var a=t==="le";var s=new e(n);var o,h;var u=this.clone();if(!a){for(h=0;h<n-i;h++){s[h]=0}for(h=0;!u.isZero();h++){o=u.andln(255);u.iushrn(8);s[n-h-1]=o}}else{for(h=0;!u.isZero();h++){o=u.andln(255);u.iushrn(8);s[h]=o}for(;h<n;h++){s[h]=0}}return s};if(Math.clz32){BN.prototype._countBits=function _countBits(e){return 32-Math.clz32(e)}}else{BN.prototype._countBits=function _countBits(e){var t=e;var r=0;if(t>=4096){r+=13;t>>>=13}if(t>=64){r+=7;t>>>=7}if(t>=8){r+=4;t>>>=4}if(t>=2){r+=2;t>>>=2}return r+t}}BN.prototype._zeroBits=function _zeroBits(e){if(e===0)return 26;var t=e;var r=0;if((t&8191)===0){r+=13;t>>>=13}if((t&127)===0){r+=7;t>>>=7}if((t&15)===0){r+=4;t>>>=4}if((t&3)===0){r+=2;t>>>=2}if((t&1)===0){r++}return r};BN.prototype.bitLength=function bitLength(){var e=this.words[this.length-1];var t=this._countBits(e);return(this.length-1)*26+t};function toBitArray(e){var t=new Array(e.bitLength());for(var r=0;r<t.length;r++){var i=r/26|0;var n=r%26;t[r]=(e.words[i]&1<<n)>>>n}return t}BN.prototype.zeroBits=function zeroBits(){if(this.isZero())return 0;var e=0;for(var t=0;t<this.length;t++){var r=this._zeroBits(this.words[t]);e+=r;if(r!==26)break}return e};BN.prototype.byteLength=function byteLength(){return Math.ceil(this.bitLength()/8)};BN.prototype.toTwos=function toTwos(e){if(this.negative!==0){return this.abs().inotn(e).iaddn(1)}return this.clone()};BN.prototype.fromTwos=function fromTwos(e){if(this.testn(e-1)){return this.notn(e).iaddn(1).ineg()}return this.clone()};BN.prototype.isNeg=function isNeg(){return this.negative!==0};BN.prototype.neg=function neg(){return this.clone().ineg()};BN.prototype.ineg=function ineg(){if(!this.isZero()){this.negative^=1}return this};BN.prototype.iuor=function iuor(e){while(this.length<e.length){this.words[this.length++]=0}for(var t=0;t<e.length;t++){this.words[t]=this.words[t]|e.words[t]}return this.strip()};BN.prototype.ior=function ior(e){assert((this.negative|e.negative)===0);return this.iuor(e)};BN.prototype.or=function or(e){if(this.length>e.length)return this.clone().ior(e);return e.clone().ior(this)};BN.prototype.uor=function uor(e){if(this.length>e.length)return this.clone().iuor(e);return e.clone().iuor(this)};BN.prototype.iuand=function iuand(e){var t;if(this.length>e.length){t=e}else{t=this}for(var r=0;r<t.length;r++){this.words[r]=this.words[r]&e.words[r]}this.length=t.length;return this.strip()};BN.prototype.iand=function iand(e){assert((this.negative|e.negative)===0);return this.iuand(e)};BN.prototype.and=function and(e){if(this.length>e.length)return this.clone().iand(e);return e.clone().iand(this)};BN.prototype.uand=function uand(e){if(this.length>e.length)return this.clone().iuand(e);return e.clone().iuand(this)};BN.prototype.iuxor=function iuxor(e){var t;var r;if(this.length>e.length){t=this;r=e}else{t=e;r=this}for(var i=0;i<r.length;i++){this.words[i]=t.words[i]^r.words[i]}if(this!==t){for(;i<t.length;i++){this.words[i]=t.words[i]}}this.length=t.length;return this.strip()};BN.prototype.ixor=function ixor(e){assert((this.negative|e.negative)===0);return this.iuxor(e)};BN.prototype.xor=function xor(e){if(this.length>e.length)return this.clone().ixor(e);return e.clone().ixor(this)};BN.prototype.uxor=function uxor(e){if(this.length>e.length)return this.clone().iuxor(e);return e.clone().iuxor(this)};BN.prototype.inotn=function inotn(e){assert(typeof e==="number"&&e>=0);var t=Math.ceil(e/26)|0;var r=e%26;this._expand(t);if(r>0){t--}for(var i=0;i<t;i++){this.words[i]=~this.words[i]&67108863}if(r>0){this.words[i]=~this.words[i]&67108863>>26-r}return this.strip()};BN.prototype.notn=function notn(e){return this.clone().inotn(e)};BN.prototype.setn=function setn(e,t){assert(typeof e==="number"&&e>=0);var r=e/26|0;var i=e%26;this._expand(r+1);if(t){this.words[r]=this.words[r]|1<<i}else{this.words[r]=this.words[r]&~(1<<i)}return this.strip()};BN.prototype.iadd=function iadd(e){var t;if(this.negative!==0&&e.negative===0){this.negative=0;t=this.isub(e);this.negative^=1;return this._normSign()}else if(this.negative===0&&e.negative!==0){e.negative=0;t=this.isub(e);e.negative=1;return t._normSign()}var r,i;if(this.length>e.length){r=this;i=e}else{r=e;i=this}var n=0;for(var a=0;a<i.length;a++){t=(r.words[a]|0)+(i.words[a]|0)+n;this.words[a]=t&67108863;n=t>>>26}for(;n!==0&&a<r.length;a++){t=(r.words[a]|0)+n;this.words[a]=t&67108863;n=t>>>26}this.length=r.length;if(n!==0){this.words[this.length]=n;this.length++}else if(r!==this){for(;a<r.length;a++){this.words[a]=r.words[a]}}return this};BN.prototype.add=function add(e){var t;if(e.negative!==0&&this.negative===0){e.negative=0;t=this.sub(e);e.negative^=1;return t}else if(e.negative===0&&this.negative!==0){this.negative=0;t=e.sub(this);this.negative=1;return t}if(this.length>e.length)return this.clone().iadd(e);return e.clone().iadd(this)};BN.prototype.isub=function isub(e){if(e.negative!==0){e.negative=0;var t=this.iadd(e);e.negative=1;return t._normSign()}else if(this.negative!==0){this.negative=0;this.iadd(e);this.negative=1;return this._normSign()}var r=this.cmp(e);if(r===0){this.negative=0;this.length=1;this.words[0]=0;return this}var i,n;if(r>0){i=this;n=e}else{i=e;n=this}var a=0;for(var s=0;s<n.length;s++){t=(i.words[s]|0)-(n.words[s]|0)+a;a=t>>26;this.words[s]=t&67108863}for(;a!==0&&s<i.length;s++){t=(i.words[s]|0)+a;a=t>>26;this.words[s]=t&67108863}if(a===0&&s<i.length&&i!==this){for(;s<i.length;s++){this.words[s]=i.words[s]}}this.length=Math.max(this.length,s);if(i!==this){this.negative=1}return this.strip()};BN.prototype.sub=function sub(e){return this.clone().isub(e)};function smallMulTo(e,t,r){r.negative=t.negative^e.negative;var i=e.length+t.length|0;r.length=i;i=i-1|0;var n=e.words[0]|0;var a=t.words[0]|0;var s=n*a;var o=s&67108863;var h=s/67108864|0;r.words[0]=o;for(var u=1;u<i;u++){var d=h>>>26;var c=h&67108863;var l=Math.min(u,t.length-1);for(var p=Math.max(0,u-e.length+1);p<=l;p++){var v=u-p|0;n=e.words[v]|0;a=t.words[p]|0;s=n*a+c;d+=s/67108864|0;c=s&67108863}r.words[u]=c|0;h=d|0}if(h!==0){r.words[u]=h|0}else{r.length--}return r.strip()}var o=function comb10MulTo(e,t,r){var i=e.words;var n=t.words;var a=r.words;var s=0;var o;var h;var u;var d=i[0]|0;var c=d&8191;var l=d>>>13;var p=i[1]|0;var v=p&8191;var b=p>>>13;var m=i[2]|0;var y=m&8191;var g=m>>>13;var _=i[3]|0;var w=_&8191;var M=_>>>13;var B=i[4]|0;var E=B&8191;var k=B>>>13;var A=i[5]|0;var N=A&8191;var P=A>>>13;var x=i[6]|0;var I=x&8191;var C=x>>>13;var D=i[7]|0;var T=D&8191;var j=D>>>13;var q=i[8]|0;var O=q&8191;var H=q>>>13;var L=i[9]|0;var z=L&8191;var F=L>>>13;var U=n[0]|0;var W=U&8191;var V=U>>>13;var G=n[1]|0;var J=G&8191;var Z=G>>>13;var X=n[2]|0;var Y=X&8191;var $=X>>>13;var Q=n[3]|0;var ee=Q&8191;var te=Q>>>13;var re=n[4]|0;var ie=re&8191;var ne=re>>>13;var ae=n[5]|0;var fe=ae&8191;var se=ae>>>13;var oe=n[6]|0;var he=oe&8191;var ue=oe>>>13;var de=n[7]|0;var ce=de&8191;var le=de>>>13;var pe=n[8]|0;var ve=pe&8191;var be=pe>>>13;var me=n[9]|0;var ye=me&8191;var ge=me>>>13;r.negative=e.negative^t.negative;r.length=19;o=Math.imul(c,W);h=Math.imul(c,V);h=h+Math.imul(l,W)|0;u=Math.imul(l,V);var _e=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(_e>>>26)|0;_e&=67108863;o=Math.imul(v,W);h=Math.imul(v,V);h=h+Math.imul(b,W)|0;u=Math.imul(b,V);o=o+Math.imul(c,J)|0;h=h+Math.imul(c,Z)|0;h=h+Math.imul(l,J)|0;u=u+Math.imul(l,Z)|0;var we=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(we>>>26)|0;we&=67108863;o=Math.imul(y,W);h=Math.imul(y,V);h=h+Math.imul(g,W)|0;u=Math.imul(g,V);o=o+Math.imul(v,J)|0;h=h+Math.imul(v,Z)|0;h=h+Math.imul(b,J)|0;u=u+Math.imul(b,Z)|0;o=o+Math.imul(c,Y)|0;h=h+Math.imul(c,$)|0;h=h+Math.imul(l,Y)|0;u=u+Math.imul(l,$)|0;var Me=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Me>>>26)|0;Me&=67108863;o=Math.imul(w,W);h=Math.imul(w,V);h=h+Math.imul(M,W)|0;u=Math.imul(M,V);o=o+Math.imul(y,J)|0;h=h+Math.imul(y,Z)|0;h=h+Math.imul(g,J)|0;u=u+Math.imul(g,Z)|0;o=o+Math.imul(v,Y)|0;h=h+Math.imul(v,$)|0;h=h+Math.imul(b,Y)|0;u=u+Math.imul(b,$)|0;o=o+Math.imul(c,ee)|0;h=h+Math.imul(c,te)|0;h=h+Math.imul(l,ee)|0;u=u+Math.imul(l,te)|0;var Se=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Se>>>26)|0;Se&=67108863;o=Math.imul(E,W);h=Math.imul(E,V);h=h+Math.imul(k,W)|0;u=Math.imul(k,V);o=o+Math.imul(w,J)|0;h=h+Math.imul(w,Z)|0;h=h+Math.imul(M,J)|0;u=u+Math.imul(M,Z)|0;o=o+Math.imul(y,Y)|0;h=h+Math.imul(y,$)|0;h=h+Math.imul(g,Y)|0;u=u+Math.imul(g,$)|0;o=o+Math.imul(v,ee)|0;h=h+Math.imul(v,te)|0;h=h+Math.imul(b,ee)|0;u=u+Math.imul(b,te)|0;o=o+Math.imul(c,ie)|0;h=h+Math.imul(c,ne)|0;h=h+Math.imul(l,ie)|0;u=u+Math.imul(l,ne)|0;var Be=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Be>>>26)|0;Be&=67108863;o=Math.imul(N,W);h=Math.imul(N,V);h=h+Math.imul(P,W)|0;u=Math.imul(P,V);o=o+Math.imul(E,J)|0;h=h+Math.imul(E,Z)|0;h=h+Math.imul(k,J)|0;u=u+Math.imul(k,Z)|0;o=o+Math.imul(w,Y)|0;h=h+Math.imul(w,$)|0;h=h+Math.imul(M,Y)|0;u=u+Math.imul(M,$)|0;o=o+Math.imul(y,ee)|0;h=h+Math.imul(y,te)|0;h=h+Math.imul(g,ee)|0;u=u+Math.imul(g,te)|0;o=o+Math.imul(v,ie)|0;h=h+Math.imul(v,ne)|0;h=h+Math.imul(b,ie)|0;u=u+Math.imul(b,ne)|0;o=o+Math.imul(c,fe)|0;h=h+Math.imul(c,se)|0;h=h+Math.imul(l,fe)|0;u=u+Math.imul(l,se)|0;var Ee=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Ee>>>26)|0;Ee&=67108863;o=Math.imul(I,W);h=Math.imul(I,V);h=h+Math.imul(C,W)|0;u=Math.imul(C,V);o=o+Math.imul(N,J)|0;h=h+Math.imul(N,Z)|0;h=h+Math.imul(P,J)|0;u=u+Math.imul(P,Z)|0;o=o+Math.imul(E,Y)|0;h=h+Math.imul(E,$)|0;h=h+Math.imul(k,Y)|0;u=u+Math.imul(k,$)|0;o=o+Math.imul(w,ee)|0;h=h+Math.imul(w,te)|0;h=h+Math.imul(M,ee)|0;u=u+Math.imul(M,te)|0;o=o+Math.imul(y,ie)|0;h=h+Math.imul(y,ne)|0;h=h+Math.imul(g,ie)|0;u=u+Math.imul(g,ne)|0;o=o+Math.imul(v,fe)|0;h=h+Math.imul(v,se)|0;h=h+Math.imul(b,fe)|0;u=u+Math.imul(b,se)|0;o=o+Math.imul(c,he)|0;h=h+Math.imul(c,ue)|0;h=h+Math.imul(l,he)|0;u=u+Math.imul(l,ue)|0;var ke=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(ke>>>26)|0;ke&=67108863;o=Math.imul(T,W);h=Math.imul(T,V);h=h+Math.imul(j,W)|0;u=Math.imul(j,V);o=o+Math.imul(I,J)|0;h=h+Math.imul(I,Z)|0;h=h+Math.imul(C,J)|0;u=u+Math.imul(C,Z)|0;o=o+Math.imul(N,Y)|0;h=h+Math.imul(N,$)|0;h=h+Math.imul(P,Y)|0;u=u+Math.imul(P,$)|0;o=o+Math.imul(E,ee)|0;h=h+Math.imul(E,te)|0;h=h+Math.imul(k,ee)|0;u=u+Math.imul(k,te)|0;o=o+Math.imul(w,ie)|0;h=h+Math.imul(w,ne)|0;h=h+Math.imul(M,ie)|0;u=u+Math.imul(M,ne)|0;o=o+Math.imul(y,fe)|0;h=h+Math.imul(y,se)|0;h=h+Math.imul(g,fe)|0;u=u+Math.imul(g,se)|0;o=o+Math.imul(v,he)|0;h=h+Math.imul(v,ue)|0;h=h+Math.imul(b,he)|0;u=u+Math.imul(b,ue)|0;o=o+Math.imul(c,ce)|0;h=h+Math.imul(c,le)|0;h=h+Math.imul(l,ce)|0;u=u+Math.imul(l,le)|0;var Ae=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Ae>>>26)|0;Ae&=67108863;o=Math.imul(O,W);h=Math.imul(O,V);h=h+Math.imul(H,W)|0;u=Math.imul(H,V);o=o+Math.imul(T,J)|0;h=h+Math.imul(T,Z)|0;h=h+Math.imul(j,J)|0;u=u+Math.imul(j,Z)|0;o=o+Math.imul(I,Y)|0;h=h+Math.imul(I,$)|0;h=h+Math.imul(C,Y)|0;u=u+Math.imul(C,$)|0;o=o+Math.imul(N,ee)|0;h=h+Math.imul(N,te)|0;h=h+Math.imul(P,ee)|0;u=u+Math.imul(P,te)|0;o=o+Math.imul(E,ie)|0;h=h+Math.imul(E,ne)|0;h=h+Math.imul(k,ie)|0;u=u+Math.imul(k,ne)|0;o=o+Math.imul(w,fe)|0;h=h+Math.imul(w,se)|0;h=h+Math.imul(M,fe)|0;u=u+Math.imul(M,se)|0;o=o+Math.imul(y,he)|0;h=h+Math.imul(y,ue)|0;h=h+Math.imul(g,he)|0;u=u+Math.imul(g,ue)|0;o=o+Math.imul(v,ce)|0;h=h+Math.imul(v,le)|0;h=h+Math.imul(b,ce)|0;u=u+Math.imul(b,le)|0;o=o+Math.imul(c,ve)|0;h=h+Math.imul(c,be)|0;h=h+Math.imul(l,ve)|0;u=u+Math.imul(l,be)|0;var Ne=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Ne>>>26)|0;Ne&=67108863;o=Math.imul(z,W);h=Math.imul(z,V);h=h+Math.imul(F,W)|0;u=Math.imul(F,V);o=o+Math.imul(O,J)|0;h=h+Math.imul(O,Z)|0;h=h+Math.imul(H,J)|0;u=u+Math.imul(H,Z)|0;o=o+Math.imul(T,Y)|0;h=h+Math.imul(T,$)|0;h=h+Math.imul(j,Y)|0;u=u+Math.imul(j,$)|0;o=o+Math.imul(I,ee)|0;h=h+Math.imul(I,te)|0;h=h+Math.imul(C,ee)|0;u=u+Math.imul(C,te)|0;o=o+Math.imul(N,ie)|0;h=h+Math.imul(N,ne)|0;h=h+Math.imul(P,ie)|0;u=u+Math.imul(P,ne)|0;o=o+Math.imul(E,fe)|0;h=h+Math.imul(E,se)|0;h=h+Math.imul(k,fe)|0;u=u+Math.imul(k,se)|0;o=o+Math.imul(w,he)|0;h=h+Math.imul(w,ue)|0;h=h+Math.imul(M,he)|0;u=u+Math.imul(M,ue)|0;o=o+Math.imul(y,ce)|0;h=h+Math.imul(y,le)|0;h=h+Math.imul(g,ce)|0;u=u+Math.imul(g,le)|0;o=o+Math.imul(v,ve)|0;h=h+Math.imul(v,be)|0;h=h+Math.imul(b,ve)|0;u=u+Math.imul(b,be)|0;o=o+Math.imul(c,ye)|0;h=h+Math.imul(c,ge)|0;h=h+Math.imul(l,ye)|0;u=u+Math.imul(l,ge)|0;var Re=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Re>>>26)|0;Re&=67108863;o=Math.imul(z,J);h=Math.imul(z,Z);h=h+Math.imul(F,J)|0;u=Math.imul(F,Z);o=o+Math.imul(O,Y)|0;h=h+Math.imul(O,$)|0;h=h+Math.imul(H,Y)|0;u=u+Math.imul(H,$)|0;o=o+Math.imul(T,ee)|0;h=h+Math.imul(T,te)|0;h=h+Math.imul(j,ee)|0;u=u+Math.imul(j,te)|0;o=o+Math.imul(I,ie)|0;h=h+Math.imul(I,ne)|0;h=h+Math.imul(C,ie)|0;u=u+Math.imul(C,ne)|0;o=o+Math.imul(N,fe)|0;h=h+Math.imul(N,se)|0;h=h+Math.imul(P,fe)|0;u=u+Math.imul(P,se)|0;o=o+Math.imul(E,he)|0;h=h+Math.imul(E,ue)|0;h=h+Math.imul(k,he)|0;u=u+Math.imul(k,ue)|0;o=o+Math.imul(w,ce)|0;h=h+Math.imul(w,le)|0;h=h+Math.imul(M,ce)|0;u=u+Math.imul(M,le)|0;o=o+Math.imul(y,ve)|0;h=h+Math.imul(y,be)|0;h=h+Math.imul(g,ve)|0;u=u+Math.imul(g,be)|0;o=o+Math.imul(v,ye)|0;h=h+Math.imul(v,ge)|0;h=h+Math.imul(b,ye)|0;u=u+Math.imul(b,ge)|0;var Pe=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Pe>>>26)|0;Pe&=67108863;o=Math.imul(z,Y);h=Math.imul(z,$);h=h+Math.imul(F,Y)|0;u=Math.imul(F,$);o=o+Math.imul(O,ee)|0;h=h+Math.imul(O,te)|0;h=h+Math.imul(H,ee)|0;u=u+Math.imul(H,te)|0;o=o+Math.imul(T,ie)|0;h=h+Math.imul(T,ne)|0;h=h+Math.imul(j,ie)|0;u=u+Math.imul(j,ne)|0;o=o+Math.imul(I,fe)|0;h=h+Math.imul(I,se)|0;h=h+Math.imul(C,fe)|0;u=u+Math.imul(C,se)|0;o=o+Math.imul(N,he)|0;h=h+Math.imul(N,ue)|0;h=h+Math.imul(P,he)|0;u=u+Math.imul(P,ue)|0;o=o+Math.imul(E,ce)|0;h=h+Math.imul(E,le)|0;h=h+Math.imul(k,ce)|0;u=u+Math.imul(k,le)|0;o=o+Math.imul(w,ve)|0;h=h+Math.imul(w,be)|0;h=h+Math.imul(M,ve)|0;u=u+Math.imul(M,be)|0;o=o+Math.imul(y,ye)|0;h=h+Math.imul(y,ge)|0;h=h+Math.imul(g,ye)|0;u=u+Math.imul(g,ge)|0;var xe=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(xe>>>26)|0;xe&=67108863;o=Math.imul(z,ee);h=Math.imul(z,te);h=h+Math.imul(F,ee)|0;u=Math.imul(F,te);o=o+Math.imul(O,ie)|0;h=h+Math.imul(O,ne)|0;h=h+Math.imul(H,ie)|0;u=u+Math.imul(H,ne)|0;o=o+Math.imul(T,fe)|0;h=h+Math.imul(T,se)|0;h=h+Math.imul(j,fe)|0;u=u+Math.imul(j,se)|0;o=o+Math.imul(I,he)|0;h=h+Math.imul(I,ue)|0;h=h+Math.imul(C,he)|0;u=u+Math.imul(C,ue)|0;o=o+Math.imul(N,ce)|0;h=h+Math.imul(N,le)|0;h=h+Math.imul(P,ce)|0;u=u+Math.imul(P,le)|0;o=o+Math.imul(E,ve)|0;h=h+Math.imul(E,be)|0;h=h+Math.imul(k,ve)|0;u=u+Math.imul(k,be)|0;o=o+Math.imul(w,ye)|0;h=h+Math.imul(w,ge)|0;h=h+Math.imul(M,ye)|0;u=u+Math.imul(M,ge)|0;var Ie=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Ie>>>26)|0;Ie&=67108863;o=Math.imul(z,ie);h=Math.imul(z,ne);h=h+Math.imul(F,ie)|0;u=Math.imul(F,ne);o=o+Math.imul(O,fe)|0;h=h+Math.imul(O,se)|0;h=h+Math.imul(H,fe)|0;u=u+Math.imul(H,se)|0;o=o+Math.imul(T,he)|0;h=h+Math.imul(T,ue)|0;h=h+Math.imul(j,he)|0;u=u+Math.imul(j,ue)|0;o=o+Math.imul(I,ce)|0;h=h+Math.imul(I,le)|0;h=h+Math.imul(C,ce)|0;u=u+Math.imul(C,le)|0;o=o+Math.imul(N,ve)|0;h=h+Math.imul(N,be)|0;h=h+Math.imul(P,ve)|0;u=u+Math.imul(P,be)|0;o=o+Math.imul(E,ye)|0;h=h+Math.imul(E,ge)|0;h=h+Math.imul(k,ye)|0;u=u+Math.imul(k,ge)|0;var Ce=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Ce>>>26)|0;Ce&=67108863;o=Math.imul(z,fe);h=Math.imul(z,se);h=h+Math.imul(F,fe)|0;u=Math.imul(F,se);o=o+Math.imul(O,he)|0;h=h+Math.imul(O,ue)|0;h=h+Math.imul(H,he)|0;u=u+Math.imul(H,ue)|0;o=o+Math.imul(T,ce)|0;h=h+Math.imul(T,le)|0;h=h+Math.imul(j,ce)|0;u=u+Math.imul(j,le)|0;o=o+Math.imul(I,ve)|0;h=h+Math.imul(I,be)|0;h=h+Math.imul(C,ve)|0;u=u+Math.imul(C,be)|0;o=o+Math.imul(N,ye)|0;h=h+Math.imul(N,ge)|0;h=h+Math.imul(P,ye)|0;u=u+Math.imul(P,ge)|0;var De=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(De>>>26)|0;De&=67108863;o=Math.imul(z,he);h=Math.imul(z,ue);h=h+Math.imul(F,he)|0;u=Math.imul(F,ue);o=o+Math.imul(O,ce)|0;h=h+Math.imul(O,le)|0;h=h+Math.imul(H,ce)|0;u=u+Math.imul(H,le)|0;o=o+Math.imul(T,ve)|0;h=h+Math.imul(T,be)|0;h=h+Math.imul(j,ve)|0;u=u+Math.imul(j,be)|0;o=o+Math.imul(I,ye)|0;h=h+Math.imul(I,ge)|0;h=h+Math.imul(C,ye)|0;u=u+Math.imul(C,ge)|0;var Te=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Te>>>26)|0;Te&=67108863;o=Math.imul(z,ce);h=Math.imul(z,le);h=h+Math.imul(F,ce)|0;u=Math.imul(F,le);o=o+Math.imul(O,ve)|0;h=h+Math.imul(O,be)|0;h=h+Math.imul(H,ve)|0;u=u+Math.imul(H,be)|0;o=o+Math.imul(T,ye)|0;h=h+Math.imul(T,ge)|0;h=h+Math.imul(j,ye)|0;u=u+Math.imul(j,ge)|0;var je=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(je>>>26)|0;je&=67108863;o=Math.imul(z,ve);h=Math.imul(z,be);h=h+Math.imul(F,ve)|0;u=Math.imul(F,be);o=o+Math.imul(O,ye)|0;h=h+Math.imul(O,ge)|0;h=h+Math.imul(H,ye)|0;u=u+Math.imul(H,ge)|0;var qe=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(qe>>>26)|0;qe&=67108863;o=Math.imul(z,ye);h=Math.imul(z,ge);h=h+Math.imul(F,ye)|0;u=Math.imul(F,ge);var Oe=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Oe>>>26)|0;Oe&=67108863;a[0]=_e;a[1]=we;a[2]=Me;a[3]=Se;a[4]=Be;a[5]=Ee;a[6]=ke;a[7]=Ae;a[8]=Ne;a[9]=Re;a[10]=Pe;a[11]=xe;a[12]=Ie;a[13]=Ce;a[14]=De;a[15]=Te;a[16]=je;a[17]=qe;a[18]=Oe;if(s!==0){a[19]=s;r.length++}return r};if(!Math.imul){o=smallMulTo}function bigMulTo(e,t,r){r.negative=t.negative^e.negative;r.length=e.length+t.length;var i=0;var n=0;for(var a=0;a<r.length-1;a++){var s=n;n=0;var o=i&67108863;var h=Math.min(a,t.length-1);for(var u=Math.max(0,a-e.length+1);u<=h;u++){var d=a-u;var c=e.words[d]|0;var l=t.words[u]|0;var p=c*l;var v=p&67108863;s=s+(p/67108864|0)|0;v=v+o|0;o=v&67108863;s=s+(v>>>26)|0;n+=s>>>26;s&=67108863}r.words[a]=o;i=s;s=n}if(i!==0){r.words[a]=i}else{r.length--}return r.strip()}function jumboMulTo(e,t,r){var i=new FFTM;return i.mulp(e,t,r)}BN.prototype.mulTo=function mulTo(e,t){var r;var i=this.length+e.length;if(this.length===10&&e.length===10){r=o(this,e,t)}else if(i<63){r=smallMulTo(this,e,t)}else if(i<1024){r=bigMulTo(this,e,t)}else{r=jumboMulTo(this,e,t)}return r};function FFTM(e,t){this.x=e;this.y=t}FFTM.prototype.makeRBT=function makeRBT(e){var t=new Array(e);var r=BN.prototype._countBits(e)-1;for(var i=0;i<e;i++){t[i]=this.revBin(i,r,e)}return t};FFTM.prototype.revBin=function revBin(e,t,r){if(e===0||e===r-1)return e;var i=0;for(var n=0;n<t;n++){i|=(e&1)<<t-n-1;e>>=1}return i};FFTM.prototype.permute=function permute(e,t,r,i,n,a){for(var s=0;s<a;s++){i[s]=t[e[s]];n[s]=r[e[s]]}};FFTM.prototype.transform=function transform(e,t,r,i,n,a){this.permute(a,e,t,r,i,n);for(var s=1;s<n;s<<=1){var o=s<<1;var h=Math.cos(2*Math.PI/o);var u=Math.sin(2*Math.PI/o);for(var d=0;d<n;d+=o){var c=h;var l=u;for(var p=0;p<s;p++){var v=r[d+p];var b=i[d+p];var m=r[d+p+s];var y=i[d+p+s];var g=c*m-l*y;y=c*y+l*m;m=g;r[d+p]=v+m;i[d+p]=b+y;r[d+p+s]=v-m;i[d+p+s]=b-y;if(p!==o){g=h*c-u*l;l=h*l+u*c;c=g}}}}};FFTM.prototype.guessLen13b=function guessLen13b(e,t){var r=Math.max(t,e)|1;var i=r&1;var n=0;for(r=r/2|0;r;r=r>>>1){n++}return 1<<n+1+i};FFTM.prototype.conjugate=function conjugate(e,t,r){if(r<=1)return;for(var i=0;i<r/2;i++){var n=e[i];e[i]=e[r-i-1];e[r-i-1]=n;n=t[i];t[i]=-t[r-i-1];t[r-i-1]=-n}};FFTM.prototype.normalize13b=function normalize13b(e,t){var r=0;for(var i=0;i<t/2;i++){var n=Math.round(e[2*i+1]/t)*8192+Math.round(e[2*i]/t)+r;e[i]=n&67108863;if(n<67108864){r=0}else{r=n/67108864|0}}return e};FFTM.prototype.convert13b=function convert13b(e,t,r,i){var n=0;for(var a=0;a<t;a++){n=n+(e[a]|0);r[2*a]=n&8191;n=n>>>13;r[2*a+1]=n&8191;n=n>>>13}for(a=2*t;a<i;++a){r[a]=0}assert(n===0);assert((n&~8191)===0)};FFTM.prototype.stub=function stub(e){var t=new Array(e);for(var r=0;r<e;r++){t[r]=0}return t};FFTM.prototype.mulp=function mulp(e,t,r){var i=2*this.guessLen13b(e.length,t.length);var n=this.makeRBT(i);var a=this.stub(i);var s=new Array(i);var o=new Array(i);var h=new Array(i);var u=new Array(i);var d=new Array(i);var c=new Array(i);var l=r.words;l.length=i;this.convert13b(e.words,e.length,s,i);this.convert13b(t.words,t.length,u,i);this.transform(s,a,o,h,i,n);this.transform(u,a,d,c,i,n);for(var p=0;p<i;p++){var v=o[p]*d[p]-h[p]*c[p];h[p]=o[p]*c[p]+h[p]*d[p];o[p]=v}this.conjugate(o,h,i);this.transform(o,h,l,a,i,n);this.conjugate(l,a,i);this.normalize13b(l,i);r.negative=e.negative^t.negative;r.length=e.length+t.length;return r.strip()};BN.prototype.mul=function mul(e){var t=new BN(null);t.words=new Array(this.length+e.length);return this.mulTo(e,t)};BN.prototype.mulf=function mulf(e){var t=new BN(null);t.words=new Array(this.length+e.length);return jumboMulTo(this,e,t)};BN.prototype.imul=function imul(e){return this.clone().mulTo(e,this)};BN.prototype.imuln=function imuln(e){assert(typeof e==="number");assert(e<67108864);var t=0;for(var r=0;r<this.length;r++){var i=(this.words[r]|0)*e;var n=(i&67108863)+(t&67108863);t>>=26;t+=i/67108864|0;t+=n>>>26;this.words[r]=n&67108863}if(t!==0){this.words[r]=t;this.length++}return this};BN.prototype.muln=function muln(e){return this.clone().imuln(e)};BN.prototype.sqr=function sqr(){return this.mul(this)};BN.prototype.isqr=function isqr(){return this.imul(this.clone())};BN.prototype.pow=function pow(e){var t=toBitArray(e);if(t.length===0)return new BN(1);var r=this;for(var i=0;i<t.length;i++,r=r.sqr()){if(t[i]!==0)break}if(++i<t.length){for(var n=r.sqr();i<t.length;i++,n=n.sqr()){if(t[i]===0)continue;r=r.mul(n)}}return r};BN.prototype.iushln=function iushln(e){assert(typeof e==="number"&&e>=0);var t=e%26;var r=(e-t)/26;var i=67108863>>>26-t<<26-t;var n;if(t!==0){var a=0;for(n=0;n<this.length;n++){var s=this.words[n]&i;var o=(this.words[n]|0)-s<<t;this.words[n]=o|a;a=s>>>26-t}if(a){this.words[n]=a;this.length++}}if(r!==0){for(n=this.length-1;n>=0;n--){this.words[n+r]=this.words[n]}for(n=0;n<r;n++){this.words[n]=0}this.length+=r}return this.strip()};BN.prototype.ishln=function ishln(e){assert(this.negative===0);return this.iushln(e)};BN.prototype.iushrn=function iushrn(e,t,r){assert(typeof e==="number"&&e>=0);var i;if(t){i=(t-t%26)/26}else{i=0}var n=e%26;var a=Math.min((e-n)/26,this.length);var s=67108863^67108863>>>n<<n;var o=r;i-=a;i=Math.max(0,i);if(o){for(var h=0;h<a;h++){o.words[h]=this.words[h]}o.length=a}if(a===0){}else if(this.length>a){this.length-=a;for(h=0;h<this.length;h++){this.words[h]=this.words[h+a]}}else{this.words[0]=0;this.length=1}var u=0;for(h=this.length-1;h>=0&&(u!==0||h>=i);h--){var d=this.words[h]|0;this.words[h]=u<<26-n|d>>>n;u=d&s}if(o&&u!==0){o.words[o.length++]=u}if(this.length===0){this.words[0]=0;this.length=1}return this.strip()};BN.prototype.ishrn=function ishrn(e,t,r){assert(this.negative===0);return this.iushrn(e,t,r)};BN.prototype.shln=function shln(e){return this.clone().ishln(e)};BN.prototype.ushln=function ushln(e){return this.clone().iushln(e)};BN.prototype.shrn=function shrn(e){return this.clone().ishrn(e)};BN.prototype.ushrn=function ushrn(e){return this.clone().iushrn(e)};BN.prototype.testn=function testn(e){assert(typeof e==="number"&&e>=0);var t=e%26;var r=(e-t)/26;var i=1<<t;if(this.length<=r)return false;var n=this.words[r];return!!(n&i)};BN.prototype.imaskn=function imaskn(e){assert(typeof e==="number"&&e>=0);var t=e%26;var r=(e-t)/26;assert(this.negative===0,"imaskn works only with positive numbers");if(this.length<=r){return this}if(t!==0){r++}this.length=Math.min(r,this.length);if(t!==0){var i=67108863^67108863>>>t<<t;this.words[this.length-1]&=i}return this.strip()};BN.prototype.maskn=function maskn(e){return this.clone().imaskn(e)};BN.prototype.iaddn=function iaddn(e){assert(typeof e==="number");assert(e<67108864);if(e<0)return this.isubn(-e);if(this.negative!==0){if(this.length===1&&(this.words[0]|0)<e){this.words[0]=e-(this.words[0]|0);this.negative=0;return this}this.negative=0;this.isubn(e);this.negative=1;return this}return this._iaddn(e)};BN.prototype._iaddn=function _iaddn(e){this.words[0]+=e;for(var t=0;t<this.length&&this.words[t]>=67108864;t++){this.words[t]-=67108864;if(t===this.length-1){this.words[t+1]=1}else{this.words[t+1]++}}this.length=Math.max(this.length,t+1);return this};BN.prototype.isubn=function isubn(e){assert(typeof e==="number");assert(e<67108864);if(e<0)return this.iaddn(-e);if(this.negative!==0){this.negative=0;this.iaddn(e);this.negative=1;return this}this.words[0]-=e;if(this.length===1&&this.words[0]<0){this.words[0]=-this.words[0];this.negative=1}else{for(var t=0;t<this.length&&this.words[t]<0;t++){this.words[t]+=67108864;this.words[t+1]-=1}}return this.strip()};BN.prototype.addn=function addn(e){return this.clone().iaddn(e)};BN.prototype.subn=function subn(e){return this.clone().isubn(e)};BN.prototype.iabs=function iabs(){this.negative=0;return this};BN.prototype.abs=function abs(){return this.clone().iabs()};BN.prototype._ishlnsubmul=function _ishlnsubmul(e,t,r){var i=e.length+r;var n;this._expand(i);var a;var s=0;for(n=0;n<e.length;n++){a=(this.words[n+r]|0)+s;var o=(e.words[n]|0)*t;a-=o&67108863;s=(a>>26)-(o/67108864|0);this.words[n+r]=a&67108863}for(;n<this.length-r;n++){a=(this.words[n+r]|0)+s;s=a>>26;this.words[n+r]=a&67108863}if(s===0)return this.strip();assert(s===-1);s=0;for(n=0;n<this.length;n++){a=-(this.words[n]|0)+s;s=a>>26;this.words[n]=a&67108863}this.negative=1;return this.strip()};BN.prototype._wordDiv=function _wordDiv(e,t){var r=this.length-e.length;var i=this.clone();var n=e;var a=n.words[n.length-1]|0;var s=this._countBits(a);r=26-s;if(r!==0){n=n.ushln(r);i.iushln(r);a=n.words[n.length-1]|0}var o=i.length-n.length;var h;if(t!=="mod"){h=new BN(null);h.length=o+1;h.words=new Array(h.length);for(var u=0;u<h.length;u++){h.words[u]=0}}var d=i.clone()._ishlnsubmul(n,1,o);if(d.negative===0){i=d;if(h){h.words[o]=1}}for(var c=o-1;c>=0;c--){var l=(i.words[n.length+c]|0)*67108864+(i.words[n.length+c-1]|0);l=Math.min(l/a|0,67108863);i._ishlnsubmul(n,l,c);while(i.negative!==0){l--;i.negative=0;i._ishlnsubmul(n,1,c);if(!i.isZero()){i.negative^=1}}if(h){h.words[c]=l}}if(h){h.strip()}i.strip();if(t!=="div"&&r!==0){i.iushrn(r)}return{div:h||null,mod:i}};BN.prototype.divmod=function divmod(e,t,r){assert(!e.isZero());if(this.isZero()){return{div:new BN(0),mod:new BN(0)}}var i,n,a;if(this.negative!==0&&e.negative===0){a=this.neg().divmod(e,t);if(t!=="mod"){i=a.div.neg()}if(t!=="div"){n=a.mod.neg();if(r&&n.negative!==0){n.iadd(e)}}return{div:i,mod:n}}if(this.negative===0&&e.negative!==0){a=this.divmod(e.neg(),t);if(t!=="mod"){i=a.div.neg()}return{div:i,mod:a.mod}}if((this.negative&e.negative)!==0){a=this.neg().divmod(e.neg(),t);if(t!=="div"){n=a.mod.neg();if(r&&n.negative!==0){n.isub(e)}}return{div:a.div,mod:n}}if(e.length>this.length||this.cmp(e)<0){return{div:new BN(0),mod:this}}if(e.length===1){if(t==="div"){return{div:this.divn(e.words[0]),mod:null}}if(t==="mod"){return{div:null,mod:new BN(this.modn(e.words[0]))}}return{div:this.divn(e.words[0]),mod:new BN(this.modn(e.words[0]))}}return this._wordDiv(e,t)};BN.prototype.div=function div(e){return this.divmod(e,"div",false).div};BN.prototype.mod=function mod(e){return this.divmod(e,"mod",false).mod};BN.prototype.umod=function umod(e){return this.divmod(e,"mod",true).mod};BN.prototype.divRound=function divRound(e){var t=this.divmod(e);if(t.mod.isZero())return t.div;var r=t.div.negative!==0?t.mod.isub(e):t.mod;var i=e.ushrn(1);var n=e.andln(1);var a=r.cmp(i);if(a<0||n===1&&a===0)return t.div;return t.div.negative!==0?t.div.isubn(1):t.div.iaddn(1)};BN.prototype.modn=function modn(e){assert(e<=67108863);var t=(1<<26)%e;var r=0;for(var i=this.length-1;i>=0;i--){r=(t*r+(this.words[i]|0))%e}return r};BN.prototype.idivn=function idivn(e){assert(e<=67108863);var t=0;for(var r=this.length-1;r>=0;r--){var i=(this.words[r]|0)+t*67108864;this.words[r]=i/e|0;t=i%e}return this.strip()};BN.prototype.divn=function divn(e){return this.clone().idivn(e)};BN.prototype.egcd=function egcd(e){assert(e.negative===0);assert(!e.isZero());var t=this;var r=e.clone();if(t.negative!==0){t=t.umod(e)}else{t=t.clone()}var i=new BN(1);var n=new BN(0);var a=new BN(0);var s=new BN(1);var o=0;while(t.isEven()&&r.isEven()){t.iushrn(1);r.iushrn(1);++o}var h=r.clone();var u=t.clone();while(!t.isZero()){for(var d=0,c=1;(t.words[0]&c)===0&&d<26;++d,c<<=1);if(d>0){t.iushrn(d);while(d-- >0){if(i.isOdd()||n.isOdd()){i.iadd(h);n.isub(u)}i.iushrn(1);n.iushrn(1)}}for(var l=0,p=1;(r.words[0]&p)===0&&l<26;++l,p<<=1);if(l>0){r.iushrn(l);while(l-- >0){if(a.isOdd()||s.isOdd()){a.iadd(h);s.isub(u)}a.iushrn(1);s.iushrn(1)}}if(t.cmp(r)>=0){t.isub(r);i.isub(a);n.isub(s)}else{r.isub(t);a.isub(i);s.isub(n)}}return{a:a,b:s,gcd:r.iushln(o)}};BN.prototype._invmp=function _invmp(e){assert(e.negative===0);assert(!e.isZero());var t=this;var r=e.clone();if(t.negative!==0){t=t.umod(e)}else{t=t.clone()}var i=new BN(1);var n=new BN(0);var a=r.clone();while(t.cmpn(1)>0&&r.cmpn(1)>0){for(var s=0,o=1;(t.words[0]&o)===0&&s<26;++s,o<<=1);if(s>0){t.iushrn(s);while(s-- >0){if(i.isOdd()){i.iadd(a)}i.iushrn(1)}}for(var h=0,u=1;(r.words[0]&u)===0&&h<26;++h,u<<=1);if(h>0){r.iushrn(h);while(h-- >0){if(n.isOdd()){n.iadd(a)}n.iushrn(1)}}if(t.cmp(r)>=0){t.isub(r);i.isub(n)}else{r.isub(t);n.isub(i)}}var d;if(t.cmpn(1)===0){d=i}else{d=n}if(d.cmpn(0)<0){d.iadd(e)}return d};BN.prototype.gcd=function gcd(e){if(this.isZero())return e.abs();if(e.isZero())return this.abs();var t=this.clone();var r=e.clone();t.negative=0;r.negative=0;for(var i=0;t.isEven()&&r.isEven();i++){t.iushrn(1);r.iushrn(1)}do{while(t.isEven()){t.iushrn(1)}while(r.isEven()){r.iushrn(1)}var n=t.cmp(r);if(n<0){var a=t;t=r;r=a}else if(n===0||r.cmpn(1)===0){break}t.isub(r)}while(true);return r.iushln(i)};BN.prototype.invm=function invm(e){return this.egcd(e).a.umod(e)};BN.prototype.isEven=function isEven(){return(this.words[0]&1)===0};BN.prototype.isOdd=function isOdd(){return(this.words[0]&1)===1};BN.prototype.andln=function andln(e){return this.words[0]&e};BN.prototype.bincn=function bincn(e){assert(typeof e==="number");var t=e%26;var r=(e-t)/26;var i=1<<t;if(this.length<=r){this._expand(r+1);this.words[r]|=i;return this}var n=i;for(var a=r;n!==0&&a<this.length;a++){var s=this.words[a]|0;s+=n;n=s>>>26;s&=67108863;this.words[a]=s}if(n!==0){this.words[a]=n;this.length++}return this};BN.prototype.isZero=function isZero(){return this.length===1&&this.words[0]===0};BN.prototype.cmpn=function cmpn(e){var t=e<0;if(this.negative!==0&&!t)return-1;if(this.negative===0&&t)return 1;this.strip();var r;if(this.length>1){r=1}else{if(t){e=-e}assert(e<=67108863,"Number is too big");var i=this.words[0]|0;r=i===e?0:i<e?-1:1}if(this.negative!==0)return-r|0;return r};BN.prototype.cmp=function cmp(e){if(this.negative!==0&&e.negative===0)return-1;if(this.negative===0&&e.negative!==0)return 1;var t=this.ucmp(e);if(this.negative!==0)return-t|0;return t};BN.prototype.ucmp=function ucmp(e){if(this.length>e.length)return 1;if(this.length<e.length)return-1;var t=0;for(var r=this.length-1;r>=0;r--){var i=this.words[r]|0;var n=e.words[r]|0;if(i===n)continue;if(i<n){t=-1}else if(i>n){t=1}break}return t};BN.prototype.gtn=function gtn(e){return this.cmpn(e)===1};BN.prototype.gt=function gt(e){return this.cmp(e)===1};BN.prototype.gten=function gten(e){return this.cmpn(e)>=0};BN.prototype.gte=function gte(e){return this.cmp(e)>=0};BN.prototype.ltn=function ltn(e){return this.cmpn(e)===-1};BN.prototype.lt=function lt(e){return this.cmp(e)===-1};BN.prototype.lten=function lten(e){return this.cmpn(e)<=0};BN.prototype.lte=function lte(e){return this.cmp(e)<=0};BN.prototype.eqn=function eqn(e){return this.cmpn(e)===0};BN.prototype.eq=function eq(e){return this.cmp(e)===0};BN.red=function red(e){return new Red(e)};BN.prototype.toRed=function toRed(e){assert(!this.red,"Already a number in reduction context");assert(this.negative===0,"red works only with positives");return e.convertTo(this)._forceRed(e)};BN.prototype.fromRed=function fromRed(){assert(this.red,"fromRed works only with numbers in reduction context");return this.red.convertFrom(this)};BN.prototype._forceRed=function _forceRed(e){this.red=e;return this};BN.prototype.forceRed=function forceRed(e){assert(!this.red,"Already a number in reduction context");return this._forceRed(e)};BN.prototype.redAdd=function redAdd(e){assert(this.red,"redAdd works only with red numbers");return this.red.add(this,e)};BN.prototype.redIAdd=function redIAdd(e){assert(this.red,"redIAdd works only with red numbers");return this.red.iadd(this,e)};BN.prototype.redSub=function redSub(e){assert(this.red,"redSub works only with red numbers");return this.red.sub(this,e)};BN.prototype.redISub=function redISub(e){assert(this.red,"redISub works only with red numbers");return this.red.isub(this,e)};BN.prototype.redShl=function redShl(e){assert(this.red,"redShl works only with red numbers");return this.red.shl(this,e)};BN.prototype.redMul=function redMul(e){assert(this.red,"redMul works only with red numbers");this.red._verify2(this,e);return this.red.mul(this,e)};BN.prototype.redIMul=function redIMul(e){assert(this.red,"redMul works only with red numbers");this.red._verify2(this,e);return this.red.imul(this,e)};BN.prototype.redSqr=function redSqr(){assert(this.red,"redSqr works only with red numbers");this.red._verify1(this);return this.red.sqr(this)};BN.prototype.redISqr=function redISqr(){assert(this.red,"redISqr works only with red numbers");this.red._verify1(this);return this.red.isqr(this)};BN.prototype.redSqrt=function redSqrt(){assert(this.red,"redSqrt works only with red numbers");this.red._verify1(this);return this.red.sqrt(this)};BN.prototype.redInvm=function redInvm(){assert(this.red,"redInvm works only with red numbers");this.red._verify1(this);return this.red.invm(this)};BN.prototype.redNeg=function redNeg(){assert(this.red,"redNeg works only with red numbers");this.red._verify1(this);return this.red.neg(this)};BN.prototype.redPow=function redPow(e){assert(this.red&&!e.red,"redPow(normalNum)");this.red._verify1(this);return this.red.pow(this,e)};var h={k256:null,p224:null,p192:null,p25519:null};function MPrime(e,t){this.name=e;this.p=new BN(t,16);this.n=this.p.bitLength();this.k=new BN(1).iushln(this.n).isub(this.p);this.tmp=this._tmp()}MPrime.prototype._tmp=function _tmp(){var e=new BN(null);e.words=new Array(Math.ceil(this.n/13));return e};MPrime.prototype.ireduce=function ireduce(e){var t=e;var r;do{this.split(t,this.tmp);t=this.imulK(t);t=t.iadd(this.tmp);r=t.bitLength()}while(r>this.n);var i=r<this.n?-1:t.ucmp(this.p);if(i===0){t.words[0]=0;t.length=1}else if(i>0){t.isub(this.p)}else{if(t.strip!==undefined){t.strip()}else{t._strip()}}return t};MPrime.prototype.split=function split(e,t){e.iushrn(this.n,0,t)};MPrime.prototype.imulK=function imulK(e){return e.imul(this.k)};function K256(){MPrime.call(this,"k256","ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f")}inherits(K256,MPrime);K256.prototype.split=function split(e,t){var r=4194303;var i=Math.min(e.length,9);for(var n=0;n<i;n++){t.words[n]=e.words[n]}t.length=i;if(e.length<=9){e.words[0]=0;e.length=1;return}var a=e.words[9];t.words[t.length++]=a&r;for(n=10;n<e.length;n++){var s=e.words[n]|0;e.words[n-10]=(s&r)<<4|a>>>22;a=s}a>>>=22;e.words[n-10]=a;if(a===0&&e.length>10){e.length-=10}else{e.length-=9}};K256.prototype.imulK=function imulK(e){e.words[e.length]=0;e.words[e.length+1]=0;e.length+=2;var t=0;for(var r=0;r<e.length;r++){var i=e.words[r]|0;t+=i*977;e.words[r]=t&67108863;t=i*64+(t/67108864|0)}if(e.words[e.length-1]===0){e.length--;if(e.words[e.length-1]===0){e.length--}}return e};function P224(){MPrime.call(this,"p224","ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001")}inherits(P224,MPrime);function P192(){MPrime.call(this,"p192","ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff")}inherits(P192,MPrime);function P25519(){MPrime.call(this,"25519","7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed")}inherits(P25519,MPrime);P25519.prototype.imulK=function imulK(e){var t=0;for(var r=0;r<e.length;r++){var i=(e.words[r]|0)*19+t;var n=i&67108863;i>>>=26;e.words[r]=n;t=i}if(t!==0){e.words[e.length++]=t}return e};BN._prime=function prime(e){if(h[e])return h[e];var prime;if(e==="k256"){prime=new K256}else if(e==="p224"){prime=new P224}else if(e==="p192"){prime=new P192}else if(e==="p25519"){prime=new P25519}else{throw new Error("Unknown prime "+e)}h[e]=prime;return prime};function Red(e){if(typeof e==="string"){var t=BN._prime(e);this.m=t.p;this.prime=t}else{assert(e.gtn(1),"modulus must be greater than 1");this.m=e;this.prime=null}}Red.prototype._verify1=function _verify1(e){assert(e.negative===0,"red works only with positives");assert(e.red,"red works only with red numbers")};Red.prototype._verify2=function _verify2(e,t){assert((e.negative|t.negative)===0,"red works only with positives");assert(e.red&&e.red===t.red,"red works only with red numbers")};Red.prototype.imod=function imod(e){if(this.prime)return this.prime.ireduce(e)._forceRed(this);return e.umod(this.m)._forceRed(this)};Red.prototype.neg=function neg(e){if(e.isZero()){return e.clone()}return this.m.sub(e)._forceRed(this)};Red.prototype.add=function add(e,t){this._verify2(e,t);var r=e.add(t);if(r.cmp(this.m)>=0){r.isub(this.m)}return r._forceRed(this)};Red.prototype.iadd=function iadd(e,t){this._verify2(e,t);var r=e.iadd(t);if(r.cmp(this.m)>=0){r.isub(this.m)}return r};Red.prototype.sub=function sub(e,t){this._verify2(e,t);var r=e.sub(t);if(r.cmpn(0)<0){r.iadd(this.m)}return r._forceRed(this)};Red.prototype.isub=function isub(e,t){this._verify2(e,t);var r=e.isub(t);if(r.cmpn(0)<0){r.iadd(this.m)}return r};Red.prototype.shl=function shl(e,t){this._verify1(e);return this.imod(e.ushln(t))};Red.prototype.imul=function imul(e,t){this._verify2(e,t);return this.imod(e.imul(t))};Red.prototype.mul=function mul(e,t){this._verify2(e,t);return this.imod(e.mul(t))};Red.prototype.isqr=function isqr(e){return this.imul(e,e.clone())};Red.prototype.sqr=function sqr(e){return this.mul(e,e)};Red.prototype.sqrt=function sqrt(e){if(e.isZero())return e.clone();var t=this.m.andln(3);assert(t%2===1);if(t===3){var r=this.m.add(new BN(1)).iushrn(2);return this.pow(e,r)}var i=this.m.subn(1);var n=0;while(!i.isZero()&&i.andln(1)===0){n++;i.iushrn(1)}assert(!i.isZero());var a=new BN(1).toRed(this);var s=a.redNeg();var o=this.m.subn(1).iushrn(1);var h=this.m.bitLength();h=new BN(2*h*h).toRed(this);while(this.pow(h,o).cmp(s)!==0){h.redIAdd(s)}var u=this.pow(h,i);var d=this.pow(e,i.addn(1).iushrn(1));var c=this.pow(e,i);var l=n;while(c.cmp(a)!==0){var p=c;for(var v=0;p.cmp(a)!==0;v++){p=p.redSqr()}assert(v<l);var b=this.pow(u,new BN(1).iushln(l-v-1));d=d.redMul(b);u=b.redSqr();c=c.redMul(u);l=v}return d};Red.prototype.invm=function invm(e){var t=e._invmp(this.m);if(t.negative!==0){t.negative=0;return this.imod(t).redNeg()}else{return this.imod(t)}};Red.prototype.pow=function pow(e,t){if(t.isZero())return new BN(1).toRed(this);if(t.cmpn(1)===0)return e.clone();var r=4;var i=new Array(1<<r);i[0]=new BN(1).toRed(this);i[1]=e;for(var n=2;n<i.length;n++){i[n]=this.mul(i[n-1],e)}var a=i[0];var s=0;var o=0;var h=t.bitLength()%26;if(h===0){h=26}for(n=t.length-1;n>=0;n--){var u=t.words[n];for(var d=h-1;d>=0;d--){var c=u>>d&1;if(a!==i[0]){a=this.sqr(a)}if(c===0&&s===0){o=0;continue}s<<=1;s|=c;o++;if(o!==r&&(n!==0||d!==0))continue;a=this.mul(a,i[s]);o=0;s=0}h=26}return a};Red.prototype.convertTo=function convertTo(e){var t=e.umod(this.m);return t===e?t.clone():t};Red.prototype.convertFrom=function convertFrom(e){var t=e.clone();t.red=null;return t};BN.mont=function mont(e){return new Mont(e)};function Mont(e){Red.call(this,e);this.shift=this.m.bitLength();if(this.shift%26!==0){this.shift+=26-this.shift%26}this.r=new BN(1).iushln(this.shift);this.r2=this.imod(this.r.sqr());this.rinv=this.r._invmp(this.m);this.minv=this.rinv.mul(this.r).isubn(1).div(this.m);this.minv=this.minv.umod(this.r);this.minv=this.r.sub(this.minv)}inherits(Mont,Red);Mont.prototype.convertTo=function convertTo(e){return this.imod(e.ushln(this.shift))};Mont.prototype.convertFrom=function convertFrom(e){var t=this.imod(e.mul(this.rinv));t.red=null;return t};Mont.prototype.imul=function imul(e,t){if(e.isZero()||t.isZero()){e.words[0]=0;e.length=1;return e}var r=e.imul(t);var i=r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);var n=r.isub(i).iushrn(this.shift);var a=n;if(n.cmp(this.m)>=0){a=n.isub(this.m)}else if(n.cmpn(0)<0){a=n.iadd(this.m)}return a._forceRed(this)};Mont.prototype.mul=function mul(e,t){if(e.isZero()||t.isZero())return new BN(0)._forceRed(this);var r=e.mul(t);var i=r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);var n=r.isub(i).iushrn(this.shift);var a=n;if(n.cmp(this.m)>=0){a=n.isub(this.m)}else if(n.cmpn(0)<0){a=n.iadd(this.m)}return a._forceRed(this)};Mont.prototype.invm=function invm(e){var t=this.imod(e._invmp(this.m).mul(this.r2));return t._forceRed(this)}})( false||e,this)},1670:function(e,t,r){e=r.nmd(e);(function(e,t){"use strict";function assert(e,t){if(!e)throw new Error(t||"Assertion failed")}function inherits(e,t){e.super_=t;var TempCtor=function(){};TempCtor.prototype=t.prototype;e.prototype=new TempCtor;e.prototype.constructor=e}function BN(e,t,r){if(BN.isBN(e)){return e}this.negative=0;this.words=null;this.length=0;this.red=null;if(e!==null){if(t==="le"||t==="be"){r=t;t=10}this._init(e||0,t||10,r||"be")}}if(typeof e==="object"){e.exports=BN}else{t.BN=BN}BN.BN=BN;BN.wordSize=26;var i;try{i=r(4300).Buffer}catch(e){}BN.isBN=function isBN(e){if(e instanceof BN){return true}return e!==null&&typeof e==="object"&&e.constructor.wordSize===BN.wordSize&&Array.isArray(e.words)};BN.max=function max(e,t){if(e.cmp(t)>0)return e;return t};BN.min=function min(e,t){if(e.cmp(t)<0)return e;return t};BN.prototype._init=function init(e,t,r){if(typeof e==="number"){return this._initNumber(e,t,r)}if(typeof e==="object"){return this._initArray(e,t,r)}if(t==="hex"){t=16}assert(t===(t|0)&&t>=2&&t<=36);e=e.toString().replace(/\s+/g,"");var i=0;if(e[0]==="-"){i++}if(t===16){this._parseHex(e,i)}else{this._parseBase(e,t,i)}if(e[0]==="-"){this.negative=1}this._strip();if(r!=="le")return;this._initArray(this.toArray(),t,r)};BN.prototype._initNumber=function _initNumber(e,t,r){if(e<0){this.negative=1;e=-e}if(e<67108864){this.words=[e&67108863];this.length=1}else if(e<4503599627370496){this.words=[e&67108863,e/67108864&67108863];this.length=2}else{assert(e<9007199254740992);this.words=[e&67108863,e/67108864&67108863,1];this.length=3}if(r!=="le")return;this._initArray(this.toArray(),t,r)};BN.prototype._initArray=function _initArray(e,t,r){assert(typeof e.length==="number");if(e.length<=0){this.words=[0];this.length=1;return this}this.length=Math.ceil(e.length/3);this.words=new Array(this.length);for(var i=0;i<this.length;i++){this.words[i]=0}var n,a;var s=0;if(r==="be"){for(i=e.length-1,n=0;i>=0;i-=3){a=e[i]|e[i-1]<<8|e[i-2]<<16;this.words[n]|=a<<s&67108863;this.words[n+1]=a>>>26-s&67108863;s+=24;if(s>=26){s-=26;n++}}}else if(r==="le"){for(i=0,n=0;i<e.length;i+=3){a=e[i]|e[i+1]<<8|e[i+2]<<16;this.words[n]|=a<<s&67108863;this.words[n+1]=a>>>26-s&67108863;s+=24;if(s>=26){s-=26;n++}}}return this._strip()};function parseHex(e,t,r){var i=0;var n=Math.min(e.length,r);var a=0;for(var s=t;s<n;s++){var o=e.charCodeAt(s)-48;i<<=4;var h;if(o>=49&&o<=54){h=o-49+10}else if(o>=17&&o<=22){h=o-17+10}else{h=o}i|=h;a|=h}assert(!(a&240),"Invalid character in "+e);return i}BN.prototype._parseHex=function _parseHex(e,t){this.length=Math.ceil((e.length-t)/6);this.words=new Array(this.length);for(var r=0;r<this.length;r++){this.words[r]=0}var i,n;var a=0;for(r=e.length-6,i=0;r>=t;r-=6){n=parseHex(e,r,r+6);this.words[i]|=n<<a&67108863;this.words[i+1]|=n>>>26-a&4194303;a+=24;if(a>=26){a-=26;i++}}if(r+6!==t){n=parseHex(e,t,r+6);this.words[i]|=n<<a&67108863;this.words[i+1]|=n>>>26-a&4194303}this._strip()};function parseBase(e,t,r,i){var n=0;var a=0;var s=Math.min(e.length,r);for(var o=t;o<s;o++){var h=e.charCodeAt(o)-48;n*=i;if(h>=49){a=h-49+10}else if(h>=17){a=h-17+10}else{a=h}assert(h>=0&&a<i,"Invalid character");n+=a}return n}BN.prototype._parseBase=function _parseBase(e,t,r){this.words=[0];this.length=1;for(var i=0,n=1;n<=67108863;n*=t){i++}i--;n=n/t|0;var a=e.length-r;var s=a%i;var o=Math.min(a,a-s)+r;var h=0;for(var u=r;u<o;u+=i){h=parseBase(e,u,u+i,t);this.imuln(n);if(this.words[0]+h<67108864){this.words[0]+=h}else{this._iaddn(h)}}if(s!==0){var d=1;h=parseBase(e,u,e.length,t);for(u=0;u<s;u++){d*=t}this.imuln(d);if(this.words[0]+h<67108864){this.words[0]+=h}else{this._iaddn(h)}}};BN.prototype.copy=function copy(e){e.words=new Array(this.length);for(var t=0;t<this.length;t++){e.words[t]=this.words[t]}e.length=this.length;e.negative=this.negative;e.red=this.red};function move(e,t){e.words=t.words;e.length=t.length;e.negative=t.negative;e.red=t.red}BN.prototype._move=function _move(e){move(e,this)};BN.prototype.clone=function clone(){var e=new BN(null);this.copy(e);return e};BN.prototype._expand=function _expand(e){while(this.length<e){this.words[this.length++]=0}return this};BN.prototype._strip=function strip(){while(this.length>1&&this.words[this.length-1]===0){this.length--}return this._normSign()};BN.prototype._normSign=function _normSign(){if(this.length===1&&this.words[0]===0){this.negative=0}return this};if(typeof Symbol!=="undefined"&&typeof Symbol.for==="function"){BN.prototype[Symbol.for("nodejs.util.inspect.custom")]=inspect}else{BN.prototype.inspect=inspect}function inspect(){return(this.red?"<BN-R: ":"<BN: ")+this.toString(16)+">"}var n=["","0","00","000","0000","00000","000000","0000000","00000000","000000000","0000000000","00000000000","000000000000","0000000000000","00000000000000","000000000000000","0000000000000000","00000000000000000","000000000000000000","0000000000000000000","00000000000000000000","000000000000000000000","0000000000000000000000","00000000000000000000000","000000000000000000000000","0000000000000000000000000"];var a=[0,0,25,16,12,11,10,9,8,8,7,7,7,7,6,6,6,6,6,6,6,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5];var s=[0,0,33554432,43046721,16777216,48828125,60466176,40353607,16777216,43046721,1e7,19487171,35831808,62748517,7529536,11390625,16777216,24137569,34012224,47045881,64e6,4084101,5153632,6436343,7962624,9765625,11881376,14348907,17210368,20511149,243e5,28629151,33554432,39135393,45435424,52521875,60466176];BN.prototype.toString=function toString(e,t){e=e||10;t=t|0||1;var r;if(e===16||e==="hex"){r="";var i=0;var o=0;for(var h=0;h<this.length;h++){var u=this.words[h];var d=((u<<i|o)&16777215).toString(16);o=u>>>24-i&16777215;if(o!==0||h!==this.length-1){r=n[6-d.length]+d+r}else{r=d+r}i+=2;if(i>=26){i-=26;h--}}if(o!==0){r=o.toString(16)+r}while(r.length%t!==0){r="0"+r}if(this.negative!==0){r="-"+r}return r}if(e===(e|0)&&e>=2&&e<=36){var c=a[e];var l=s[e];r="";var p=this.clone();p.negative=0;while(!p.isZero()){var v=p.modrn(l).toString(e);p=p.idivn(l);if(!p.isZero()){r=n[c-v.length]+v+r}else{r=v+r}}if(this.isZero()){r="0"+r}while(r.length%t!==0){r="0"+r}if(this.negative!==0){r="-"+r}return r}assert(false,"Base should be between 2 and 36")};BN.prototype.toNumber=function toNumber(){var e=this.words[0];if(this.length===2){e+=this.words[1]*67108864}else if(this.length===3&&this.words[2]===1){e+=4503599627370496+this.words[1]*67108864}else if(this.length>2){assert(false,"Number can only safely store up to 53 bits")}return this.negative!==0?-e:e};BN.prototype.toJSON=function toJSON(){return this.toString(16,2)};if(i){BN.prototype.toBuffer=function toBuffer(e,t){return this.toArrayLike(i,e,t)}}BN.prototype.toArray=function toArray(e,t){return this.toArrayLike(Array,e,t)};var o=function allocate(e,t){if(e.allocUnsafe){return e.allocUnsafe(t)}return new e(t)};BN.prototype.toArrayLike=function toArrayLike(e,t,r){this._strip();var i=this.byteLength();var n=r||Math.max(1,i);assert(i<=n,"byte array longer than desired length");assert(n>0,"Requested array length <= 0");var a=o(e,n);var s=t==="le"?"LE":"BE";this["_toArrayLike"+s](a,i);return a};BN.prototype._toArrayLikeLE=function _toArrayLikeLE(e,t){var r=0;var i=0;for(var n=0,a=0;n<this.length;n++){var s=this.words[n]<<a|i;e[r++]=s&255;if(r<e.length){e[r++]=s>>8&255}if(r<e.length){e[r++]=s>>16&255}if(a===6){if(r<e.length){e[r++]=s>>24&255}i=0;a=0}else{i=s>>>24;a+=2}}if(r<e.length){e[r++]=i;while(r<e.length){e[r++]=0}}};BN.prototype._toArrayLikeBE=function _toArrayLikeBE(e,t){var r=e.length-1;var i=0;for(var n=0,a=0;n<this.length;n++){var s=this.words[n]<<a|i;e[r--]=s&255;if(r>=0){e[r--]=s>>8&255}if(r>=0){e[r--]=s>>16&255}if(a===6){if(r>=0){e[r--]=s>>24&255}i=0;a=0}else{i=s>>>24;a+=2}}if(r>=0){e[r--]=i;while(r>=0){e[r--]=0}}};if(Math.clz32){BN.prototype._countBits=function _countBits(e){return 32-Math.clz32(e)}}else{BN.prototype._countBits=function _countBits(e){var t=e;var r=0;if(t>=4096){r+=13;t>>>=13}if(t>=64){r+=7;t>>>=7}if(t>=8){r+=4;t>>>=4}if(t>=2){r+=2;t>>>=2}return r+t}}BN.prototype._zeroBits=function _zeroBits(e){if(e===0)return 26;var t=e;var r=0;if((t&8191)===0){r+=13;t>>>=13}if((t&127)===0){r+=7;t>>>=7}if((t&15)===0){r+=4;t>>>=4}if((t&3)===0){r+=2;t>>>=2}if((t&1)===0){r++}return r};BN.prototype.bitLength=function bitLength(){var e=this.words[this.length-1];var t=this._countBits(e);return(this.length-1)*26+t};function toBitArray(e){var t=new Array(e.bitLength());for(var r=0;r<t.length;r++){var i=r/26|0;var n=r%26;t[r]=e.words[i]>>>n&1}return t}BN.prototype.zeroBits=function zeroBits(){if(this.isZero())return 0;var e=0;for(var t=0;t<this.length;t++){var r=this._zeroBits(this.words[t]);e+=r;if(r!==26)break}return e};BN.prototype.byteLength=function byteLength(){return Math.ceil(this.bitLength()/8)};BN.prototype.toTwos=function toTwos(e){if(this.negative!==0){return this.abs().inotn(e).iaddn(1)}return this.clone()};BN.prototype.fromTwos=function fromTwos(e){if(this.testn(e-1)){return this.notn(e).iaddn(1).ineg()}return this.clone()};BN.prototype.isNeg=function isNeg(){return this.negative!==0};BN.prototype.neg=function neg(){return this.clone().ineg()};BN.prototype.ineg=function ineg(){if(!this.isZero()){this.negative^=1}return this};BN.prototype.iuor=function iuor(e){while(this.length<e.length){this.words[this.length++]=0}for(var t=0;t<e.length;t++){this.words[t]=this.words[t]|e.words[t]}return this._strip()};BN.prototype.ior=function ior(e){assert((this.negative|e.negative)===0);return this.iuor(e)};BN.prototype.or=function or(e){if(this.length>e.length)return this.clone().ior(e);return e.clone().ior(this)};BN.prototype.uor=function uor(e){if(this.length>e.length)return this.clone().iuor(e);return e.clone().iuor(this)};BN.prototype.iuand=function iuand(e){var t;if(this.length>e.length){t=e}else{t=this}for(var r=0;r<t.length;r++){this.words[r]=this.words[r]&e.words[r]}this.length=t.length;return this._strip()};BN.prototype.iand=function iand(e){assert((this.negative|e.negative)===0);return this.iuand(e)};BN.prototype.and=function and(e){if(this.length>e.length)return this.clone().iand(e);return e.clone().iand(this)};BN.prototype.uand=function uand(e){if(this.length>e.length)return this.clone().iuand(e);return e.clone().iuand(this)};BN.prototype.iuxor=function iuxor(e){var t;var r;if(this.length>e.length){t=this;r=e}else{t=e;r=this}for(var i=0;i<r.length;i++){this.words[i]=t.words[i]^r.words[i]}if(this!==t){for(;i<t.length;i++){this.words[i]=t.words[i]}}this.length=t.length;return this._strip()};BN.prototype.ixor=function ixor(e){assert((this.negative|e.negative)===0);return this.iuxor(e)};BN.prototype.xor=function xor(e){if(this.length>e.length)return this.clone().ixor(e);return e.clone().ixor(this)};BN.prototype.uxor=function uxor(e){if(this.length>e.length)return this.clone().iuxor(e);return e.clone().iuxor(this)};BN.prototype.inotn=function inotn(e){assert(typeof e==="number"&&e>=0);var t=Math.ceil(e/26)|0;var r=e%26;this._expand(t);if(r>0){t--}for(var i=0;i<t;i++){this.words[i]=~this.words[i]&67108863}if(r>0){this.words[i]=~this.words[i]&67108863>>26-r}return this._strip()};BN.prototype.notn=function notn(e){return this.clone().inotn(e)};BN.prototype.setn=function setn(e,t){assert(typeof e==="number"&&e>=0);var r=e/26|0;var i=e%26;this._expand(r+1);if(t){this.words[r]=this.words[r]|1<<i}else{this.words[r]=this.words[r]&~(1<<i)}return this._strip()};BN.prototype.iadd=function iadd(e){var t;if(this.negative!==0&&e.negative===0){this.negative=0;t=this.isub(e);this.negative^=1;return this._normSign()}else if(this.negative===0&&e.negative!==0){e.negative=0;t=this.isub(e);e.negative=1;return t._normSign()}var r,i;if(this.length>e.length){r=this;i=e}else{r=e;i=this}var n=0;for(var a=0;a<i.length;a++){t=(r.words[a]|0)+(i.words[a]|0)+n;this.words[a]=t&67108863;n=t>>>26}for(;n!==0&&a<r.length;a++){t=(r.words[a]|0)+n;this.words[a]=t&67108863;n=t>>>26}this.length=r.length;if(n!==0){this.words[this.length]=n;this.length++}else if(r!==this){for(;a<r.length;a++){this.words[a]=r.words[a]}}return this};BN.prototype.add=function add(e){var t;if(e.negative!==0&&this.negative===0){e.negative=0;t=this.sub(e);e.negative^=1;return t}else if(e.negative===0&&this.negative!==0){this.negative=0;t=e.sub(this);this.negative=1;return t}if(this.length>e.length)return this.clone().iadd(e);return e.clone().iadd(this)};BN.prototype.isub=function isub(e){if(e.negative!==0){e.negative=0;var t=this.iadd(e);e.negative=1;return t._normSign()}else if(this.negative!==0){this.negative=0;this.iadd(e);this.negative=1;return this._normSign()}var r=this.cmp(e);if(r===0){this.negative=0;this.length=1;this.words[0]=0;return this}var i,n;if(r>0){i=this;n=e}else{i=e;n=this}var a=0;for(var s=0;s<n.length;s++){t=(i.words[s]|0)-(n.words[s]|0)+a;a=t>>26;this.words[s]=t&67108863}for(;a!==0&&s<i.length;s++){t=(i.words[s]|0)+a;a=t>>26;this.words[s]=t&67108863}if(a===0&&s<i.length&&i!==this){for(;s<i.length;s++){this.words[s]=i.words[s]}}this.length=Math.max(this.length,s);if(i!==this){this.negative=1}return this._strip()};BN.prototype.sub=function sub(e){return this.clone().isub(e)};function smallMulTo(e,t,r){r.negative=t.negative^e.negative;var i=e.length+t.length|0;r.length=i;i=i-1|0;var n=e.words[0]|0;var a=t.words[0]|0;var s=n*a;var o=s&67108863;var h=s/67108864|0;r.words[0]=o;for(var u=1;u<i;u++){var d=h>>>26;var c=h&67108863;var l=Math.min(u,t.length-1);for(var p=Math.max(0,u-e.length+1);p<=l;p++){var v=u-p|0;n=e.words[v]|0;a=t.words[p]|0;s=n*a+c;d+=s/67108864|0;c=s&67108863}r.words[u]=c|0;h=d|0}if(h!==0){r.words[u]=h|0}else{r.length--}return r._strip()}var h=function comb10MulTo(e,t,r){var i=e.words;var n=t.words;var a=r.words;var s=0;var o;var h;var u;var d=i[0]|0;var c=d&8191;var l=d>>>13;var p=i[1]|0;var v=p&8191;var b=p>>>13;var m=i[2]|0;var y=m&8191;var g=m>>>13;var _=i[3]|0;var w=_&8191;var M=_>>>13;var B=i[4]|0;var E=B&8191;var k=B>>>13;var A=i[5]|0;var N=A&8191;var P=A>>>13;var x=i[6]|0;var I=x&8191;var C=x>>>13;var D=i[7]|0;var T=D&8191;var j=D>>>13;var q=i[8]|0;var O=q&8191;var H=q>>>13;var L=i[9]|0;var z=L&8191;var F=L>>>13;var U=n[0]|0;var W=U&8191;var V=U>>>13;var G=n[1]|0;var J=G&8191;var Z=G>>>13;var X=n[2]|0;var Y=X&8191;var $=X>>>13;var Q=n[3]|0;var ee=Q&8191;var te=Q>>>13;var re=n[4]|0;var ie=re&8191;var ne=re>>>13;var ae=n[5]|0;var fe=ae&8191;var se=ae>>>13;var oe=n[6]|0;var he=oe&8191;var ue=oe>>>13;var de=n[7]|0;var ce=de&8191;var le=de>>>13;var pe=n[8]|0;var ve=pe&8191;var be=pe>>>13;var me=n[9]|0;var ye=me&8191;var ge=me>>>13;r.negative=e.negative^t.negative;r.length=19;o=Math.imul(c,W);h=Math.imul(c,V);h=h+Math.imul(l,W)|0;u=Math.imul(l,V);var _e=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(_e>>>26)|0;_e&=67108863;o=Math.imul(v,W);h=Math.imul(v,V);h=h+Math.imul(b,W)|0;u=Math.imul(b,V);o=o+Math.imul(c,J)|0;h=h+Math.imul(c,Z)|0;h=h+Math.imul(l,J)|0;u=u+Math.imul(l,Z)|0;var we=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(we>>>26)|0;we&=67108863;o=Math.imul(y,W);h=Math.imul(y,V);h=h+Math.imul(g,W)|0;u=Math.imul(g,V);o=o+Math.imul(v,J)|0;h=h+Math.imul(v,Z)|0;h=h+Math.imul(b,J)|0;u=u+Math.imul(b,Z)|0;o=o+Math.imul(c,Y)|0;h=h+Math.imul(c,$)|0;h=h+Math.imul(l,Y)|0;u=u+Math.imul(l,$)|0;var Me=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Me>>>26)|0;Me&=67108863;o=Math.imul(w,W);h=Math.imul(w,V);h=h+Math.imul(M,W)|0;u=Math.imul(M,V);o=o+Math.imul(y,J)|0;h=h+Math.imul(y,Z)|0;h=h+Math.imul(g,J)|0;u=u+Math.imul(g,Z)|0;o=o+Math.imul(v,Y)|0;h=h+Math.imul(v,$)|0;h=h+Math.imul(b,Y)|0;u=u+Math.imul(b,$)|0;o=o+Math.imul(c,ee)|0;h=h+Math.imul(c,te)|0;h=h+Math.imul(l,ee)|0;u=u+Math.imul(l,te)|0;var Se=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Se>>>26)|0;Se&=67108863;o=Math.imul(E,W);h=Math.imul(E,V);h=h+Math.imul(k,W)|0;u=Math.imul(k,V);o=o+Math.imul(w,J)|0;h=h+Math.imul(w,Z)|0;h=h+Math.imul(M,J)|0;u=u+Math.imul(M,Z)|0;o=o+Math.imul(y,Y)|0;h=h+Math.imul(y,$)|0;h=h+Math.imul(g,Y)|0;u=u+Math.imul(g,$)|0;o=o+Math.imul(v,ee)|0;h=h+Math.imul(v,te)|0;h=h+Math.imul(b,ee)|0;u=u+Math.imul(b,te)|0;o=o+Math.imul(c,ie)|0;h=h+Math.imul(c,ne)|0;h=h+Math.imul(l,ie)|0;u=u+Math.imul(l,ne)|0;var Be=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Be>>>26)|0;Be&=67108863;o=Math.imul(N,W);h=Math.imul(N,V);h=h+Math.imul(P,W)|0;u=Math.imul(P,V);o=o+Math.imul(E,J)|0;h=h+Math.imul(E,Z)|0;h=h+Math.imul(k,J)|0;u=u+Math.imul(k,Z)|0;o=o+Math.imul(w,Y)|0;h=h+Math.imul(w,$)|0;h=h+Math.imul(M,Y)|0;u=u+Math.imul(M,$)|0;o=o+Math.imul(y,ee)|0;h=h+Math.imul(y,te)|0;h=h+Math.imul(g,ee)|0;u=u+Math.imul(g,te)|0;o=o+Math.imul(v,ie)|0;h=h+Math.imul(v,ne)|0;h=h+Math.imul(b,ie)|0;u=u+Math.imul(b,ne)|0;o=o+Math.imul(c,fe)|0;h=h+Math.imul(c,se)|0;h=h+Math.imul(l,fe)|0;u=u+Math.imul(l,se)|0;var Ee=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Ee>>>26)|0;Ee&=67108863;o=Math.imul(I,W);h=Math.imul(I,V);h=h+Math.imul(C,W)|0;u=Math.imul(C,V);o=o+Math.imul(N,J)|0;h=h+Math.imul(N,Z)|0;h=h+Math.imul(P,J)|0;u=u+Math.imul(P,Z)|0;o=o+Math.imul(E,Y)|0;h=h+Math.imul(E,$)|0;h=h+Math.imul(k,Y)|0;u=u+Math.imul(k,$)|0;o=o+Math.imul(w,ee)|0;h=h+Math.imul(w,te)|0;h=h+Math.imul(M,ee)|0;u=u+Math.imul(M,te)|0;o=o+Math.imul(y,ie)|0;h=h+Math.imul(y,ne)|0;h=h+Math.imul(g,ie)|0;u=u+Math.imul(g,ne)|0;o=o+Math.imul(v,fe)|0;h=h+Math.imul(v,se)|0;h=h+Math.imul(b,fe)|0;u=u+Math.imul(b,se)|0;o=o+Math.imul(c,he)|0;h=h+Math.imul(c,ue)|0;h=h+Math.imul(l,he)|0;u=u+Math.imul(l,ue)|0;var ke=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(ke>>>26)|0;ke&=67108863;o=Math.imul(T,W);h=Math.imul(T,V);h=h+Math.imul(j,W)|0;u=Math.imul(j,V);o=o+Math.imul(I,J)|0;h=h+Math.imul(I,Z)|0;h=h+Math.imul(C,J)|0;u=u+Math.imul(C,Z)|0;o=o+Math.imul(N,Y)|0;h=h+Math.imul(N,$)|0;h=h+Math.imul(P,Y)|0;u=u+Math.imul(P,$)|0;o=o+Math.imul(E,ee)|0;h=h+Math.imul(E,te)|0;h=h+Math.imul(k,ee)|0;u=u+Math.imul(k,te)|0;o=o+Math.imul(w,ie)|0;h=h+Math.imul(w,ne)|0;h=h+Math.imul(M,ie)|0;u=u+Math.imul(M,ne)|0;o=o+Math.imul(y,fe)|0;h=h+Math.imul(y,se)|0;h=h+Math.imul(g,fe)|0;u=u+Math.imul(g,se)|0;o=o+Math.imul(v,he)|0;h=h+Math.imul(v,ue)|0;h=h+Math.imul(b,he)|0;u=u+Math.imul(b,ue)|0;o=o+Math.imul(c,ce)|0;h=h+Math.imul(c,le)|0;h=h+Math.imul(l,ce)|0;u=u+Math.imul(l,le)|0;var Ae=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Ae>>>26)|0;Ae&=67108863;o=Math.imul(O,W);h=Math.imul(O,V);h=h+Math.imul(H,W)|0;u=Math.imul(H,V);o=o+Math.imul(T,J)|0;h=h+Math.imul(T,Z)|0;h=h+Math.imul(j,J)|0;u=u+Math.imul(j,Z)|0;o=o+Math.imul(I,Y)|0;h=h+Math.imul(I,$)|0;h=h+Math.imul(C,Y)|0;u=u+Math.imul(C,$)|0;o=o+Math.imul(N,ee)|0;h=h+Math.imul(N,te)|0;h=h+Math.imul(P,ee)|0;u=u+Math.imul(P,te)|0;o=o+Math.imul(E,ie)|0;h=h+Math.imul(E,ne)|0;h=h+Math.imul(k,ie)|0;u=u+Math.imul(k,ne)|0;o=o+Math.imul(w,fe)|0;h=h+Math.imul(w,se)|0;h=h+Math.imul(M,fe)|0;u=u+Math.imul(M,se)|0;o=o+Math.imul(y,he)|0;h=h+Math.imul(y,ue)|0;h=h+Math.imul(g,he)|0;u=u+Math.imul(g,ue)|0;o=o+Math.imul(v,ce)|0;h=h+Math.imul(v,le)|0;h=h+Math.imul(b,ce)|0;u=u+Math.imul(b,le)|0;o=o+Math.imul(c,ve)|0;h=h+Math.imul(c,be)|0;h=h+Math.imul(l,ve)|0;u=u+Math.imul(l,be)|0;var Ne=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Ne>>>26)|0;Ne&=67108863;o=Math.imul(z,W);h=Math.imul(z,V);h=h+Math.imul(F,W)|0;u=Math.imul(F,V);o=o+Math.imul(O,J)|0;h=h+Math.imul(O,Z)|0;h=h+Math.imul(H,J)|0;u=u+Math.imul(H,Z)|0;o=o+Math.imul(T,Y)|0;h=h+Math.imul(T,$)|0;h=h+Math.imul(j,Y)|0;u=u+Math.imul(j,$)|0;o=o+Math.imul(I,ee)|0;h=h+Math.imul(I,te)|0;h=h+Math.imul(C,ee)|0;u=u+Math.imul(C,te)|0;o=o+Math.imul(N,ie)|0;h=h+Math.imul(N,ne)|0;h=h+Math.imul(P,ie)|0;u=u+Math.imul(P,ne)|0;o=o+Math.imul(E,fe)|0;h=h+Math.imul(E,se)|0;h=h+Math.imul(k,fe)|0;u=u+Math.imul(k,se)|0;o=o+Math.imul(w,he)|0;h=h+Math.imul(w,ue)|0;h=h+Math.imul(M,he)|0;u=u+Math.imul(M,ue)|0;o=o+Math.imul(y,ce)|0;h=h+Math.imul(y,le)|0;h=h+Math.imul(g,ce)|0;u=u+Math.imul(g,le)|0;o=o+Math.imul(v,ve)|0;h=h+Math.imul(v,be)|0;h=h+Math.imul(b,ve)|0;u=u+Math.imul(b,be)|0;o=o+Math.imul(c,ye)|0;h=h+Math.imul(c,ge)|0;h=h+Math.imul(l,ye)|0;u=u+Math.imul(l,ge)|0;var Re=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Re>>>26)|0;Re&=67108863;o=Math.imul(z,J);h=Math.imul(z,Z);h=h+Math.imul(F,J)|0;u=Math.imul(F,Z);o=o+Math.imul(O,Y)|0;h=h+Math.imul(O,$)|0;h=h+Math.imul(H,Y)|0;u=u+Math.imul(H,$)|0;o=o+Math.imul(T,ee)|0;h=h+Math.imul(T,te)|0;h=h+Math.imul(j,ee)|0;u=u+Math.imul(j,te)|0;o=o+Math.imul(I,ie)|0;h=h+Math.imul(I,ne)|0;h=h+Math.imul(C,ie)|0;u=u+Math.imul(C,ne)|0;o=o+Math.imul(N,fe)|0;h=h+Math.imul(N,se)|0;h=h+Math.imul(P,fe)|0;u=u+Math.imul(P,se)|0;o=o+Math.imul(E,he)|0;h=h+Math.imul(E,ue)|0;h=h+Math.imul(k,he)|0;u=u+Math.imul(k,ue)|0;o=o+Math.imul(w,ce)|0;h=h+Math.imul(w,le)|0;h=h+Math.imul(M,ce)|0;u=u+Math.imul(M,le)|0;o=o+Math.imul(y,ve)|0;h=h+Math.imul(y,be)|0;h=h+Math.imul(g,ve)|0;u=u+Math.imul(g,be)|0;o=o+Math.imul(v,ye)|0;h=h+Math.imul(v,ge)|0;h=h+Math.imul(b,ye)|0;u=u+Math.imul(b,ge)|0;var Pe=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Pe>>>26)|0;Pe&=67108863;o=Math.imul(z,Y);h=Math.imul(z,$);h=h+Math.imul(F,Y)|0;u=Math.imul(F,$);o=o+Math.imul(O,ee)|0;h=h+Math.imul(O,te)|0;h=h+Math.imul(H,ee)|0;u=u+Math.imul(H,te)|0;o=o+Math.imul(T,ie)|0;h=h+Math.imul(T,ne)|0;h=h+Math.imul(j,ie)|0;u=u+Math.imul(j,ne)|0;o=o+Math.imul(I,fe)|0;h=h+Math.imul(I,se)|0;h=h+Math.imul(C,fe)|0;u=u+Math.imul(C,se)|0;o=o+Math.imul(N,he)|0;h=h+Math.imul(N,ue)|0;h=h+Math.imul(P,he)|0;u=u+Math.imul(P,ue)|0;o=o+Math.imul(E,ce)|0;h=h+Math.imul(E,le)|0;h=h+Math.imul(k,ce)|0;u=u+Math.imul(k,le)|0;o=o+Math.imul(w,ve)|0;h=h+Math.imul(w,be)|0;h=h+Math.imul(M,ve)|0;u=u+Math.imul(M,be)|0;o=o+Math.imul(y,ye)|0;h=h+Math.imul(y,ge)|0;h=h+Math.imul(g,ye)|0;u=u+Math.imul(g,ge)|0;var xe=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(xe>>>26)|0;xe&=67108863;o=Math.imul(z,ee);h=Math.imul(z,te);h=h+Math.imul(F,ee)|0;u=Math.imul(F,te);o=o+Math.imul(O,ie)|0;h=h+Math.imul(O,ne)|0;h=h+Math.imul(H,ie)|0;u=u+Math.imul(H,ne)|0;o=o+Math.imul(T,fe)|0;h=h+Math.imul(T,se)|0;h=h+Math.imul(j,fe)|0;u=u+Math.imul(j,se)|0;o=o+Math.imul(I,he)|0;h=h+Math.imul(I,ue)|0;h=h+Math.imul(C,he)|0;u=u+Math.imul(C,ue)|0;o=o+Math.imul(N,ce)|0;h=h+Math.imul(N,le)|0;h=h+Math.imul(P,ce)|0;u=u+Math.imul(P,le)|0;o=o+Math.imul(E,ve)|0;h=h+Math.imul(E,be)|0;h=h+Math.imul(k,ve)|0;u=u+Math.imul(k,be)|0;o=o+Math.imul(w,ye)|0;h=h+Math.imul(w,ge)|0;h=h+Math.imul(M,ye)|0;u=u+Math.imul(M,ge)|0;var Ie=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Ie>>>26)|0;Ie&=67108863;o=Math.imul(z,ie);h=Math.imul(z,ne);h=h+Math.imul(F,ie)|0;u=Math.imul(F,ne);o=o+Math.imul(O,fe)|0;h=h+Math.imul(O,se)|0;h=h+Math.imul(H,fe)|0;u=u+Math.imul(H,se)|0;o=o+Math.imul(T,he)|0;h=h+Math.imul(T,ue)|0;h=h+Math.imul(j,he)|0;u=u+Math.imul(j,ue)|0;o=o+Math.imul(I,ce)|0;h=h+Math.imul(I,le)|0;h=h+Math.imul(C,ce)|0;u=u+Math.imul(C,le)|0;o=o+Math.imul(N,ve)|0;h=h+Math.imul(N,be)|0;h=h+Math.imul(P,ve)|0;u=u+Math.imul(P,be)|0;o=o+Math.imul(E,ye)|0;h=h+Math.imul(E,ge)|0;h=h+Math.imul(k,ye)|0;u=u+Math.imul(k,ge)|0;var Ce=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Ce>>>26)|0;Ce&=67108863;o=Math.imul(z,fe);h=Math.imul(z,se);h=h+Math.imul(F,fe)|0;u=Math.imul(F,se);o=o+Math.imul(O,he)|0;h=h+Math.imul(O,ue)|0;h=h+Math.imul(H,he)|0;u=u+Math.imul(H,ue)|0;o=o+Math.imul(T,ce)|0;h=h+Math.imul(T,le)|0;h=h+Math.imul(j,ce)|0;u=u+Math.imul(j,le)|0;o=o+Math.imul(I,ve)|0;h=h+Math.imul(I,be)|0;h=h+Math.imul(C,ve)|0;u=u+Math.imul(C,be)|0;o=o+Math.imul(N,ye)|0;h=h+Math.imul(N,ge)|0;h=h+Math.imul(P,ye)|0;u=u+Math.imul(P,ge)|0;var De=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(De>>>26)|0;De&=67108863;o=Math.imul(z,he);h=Math.imul(z,ue);h=h+Math.imul(F,he)|0;u=Math.imul(F,ue);o=o+Math.imul(O,ce)|0;h=h+Math.imul(O,le)|0;h=h+Math.imul(H,ce)|0;u=u+Math.imul(H,le)|0;o=o+Math.imul(T,ve)|0;h=h+Math.imul(T,be)|0;h=h+Math.imul(j,ve)|0;u=u+Math.imul(j,be)|0;o=o+Math.imul(I,ye)|0;h=h+Math.imul(I,ge)|0;h=h+Math.imul(C,ye)|0;u=u+Math.imul(C,ge)|0;var Te=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Te>>>26)|0;Te&=67108863;o=Math.imul(z,ce);h=Math.imul(z,le);h=h+Math.imul(F,ce)|0;u=Math.imul(F,le);o=o+Math.imul(O,ve)|0;h=h+Math.imul(O,be)|0;h=h+Math.imul(H,ve)|0;u=u+Math.imul(H,be)|0;o=o+Math.imul(T,ye)|0;h=h+Math.imul(T,ge)|0;h=h+Math.imul(j,ye)|0;u=u+Math.imul(j,ge)|0;var je=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(je>>>26)|0;je&=67108863;o=Math.imul(z,ve);h=Math.imul(z,be);h=h+Math.imul(F,ve)|0;u=Math.imul(F,be);o=o+Math.imul(O,ye)|0;h=h+Math.imul(O,ge)|0;h=h+Math.imul(H,ye)|0;u=u+Math.imul(H,ge)|0;var qe=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(qe>>>26)|0;qe&=67108863;o=Math.imul(z,ye);h=Math.imul(z,ge);h=h+Math.imul(F,ye)|0;u=Math.imul(F,ge);var Oe=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Oe>>>26)|0;Oe&=67108863;a[0]=_e;a[1]=we;a[2]=Me;a[3]=Se;a[4]=Be;a[5]=Ee;a[6]=ke;a[7]=Ae;a[8]=Ne;a[9]=Re;a[10]=Pe;a[11]=xe;a[12]=Ie;a[13]=Ce;a[14]=De;a[15]=Te;a[16]=je;a[17]=qe;a[18]=Oe;if(s!==0){a[19]=s;r.length++}return r};if(!Math.imul){h=smallMulTo}function bigMulTo(e,t,r){r.negative=t.negative^e.negative;r.length=e.length+t.length;var i=0;var n=0;for(var a=0;a<r.length-1;a++){var s=n;n=0;var o=i&67108863;var h=Math.min(a,t.length-1);for(var u=Math.max(0,a-e.length+1);u<=h;u++){var d=a-u;var c=e.words[d]|0;var l=t.words[u]|0;var p=c*l;var v=p&67108863;s=s+(p/67108864|0)|0;v=v+o|0;o=v&67108863;s=s+(v>>>26)|0;n+=s>>>26;s&=67108863}r.words[a]=o;i=s;s=n}if(i!==0){r.words[a]=i}else{r.length--}return r._strip()}function jumboMulTo(e,t,r){return bigMulTo(e,t,r)}BN.prototype.mulTo=function mulTo(e,t){var r;var i=this.length+e.length;if(this.length===10&&e.length===10){r=h(this,e,t)}else if(i<63){r=smallMulTo(this,e,t)}else if(i<1024){r=bigMulTo(this,e,t)}else{r=jumboMulTo(this,e,t)}return r};function FFTM(e,t){this.x=e;this.y=t}FFTM.prototype.makeRBT=function makeRBT(e){var t=new Array(e);var r=BN.prototype._countBits(e)-1;for(var i=0;i<e;i++){t[i]=this.revBin(i,r,e)}return t};FFTM.prototype.revBin=function revBin(e,t,r){if(e===0||e===r-1)return e;var i=0;for(var n=0;n<t;n++){i|=(e&1)<<t-n-1;e>>=1}return i};FFTM.prototype.permute=function permute(e,t,r,i,n,a){for(var s=0;s<a;s++){i[s]=t[e[s]];n[s]=r[e[s]]}};FFTM.prototype.transform=function transform(e,t,r,i,n,a){this.permute(a,e,t,r,i,n);for(var s=1;s<n;s<<=1){var o=s<<1;var h=Math.cos(2*Math.PI/o);var u=Math.sin(2*Math.PI/o);for(var d=0;d<n;d+=o){var c=h;var l=u;for(var p=0;p<s;p++){var v=r[d+p];var b=i[d+p];var m=r[d+p+s];var y=i[d+p+s];var g=c*m-l*y;y=c*y+l*m;m=g;r[d+p]=v+m;i[d+p]=b+y;r[d+p+s]=v-m;i[d+p+s]=b-y;if(p!==o){g=h*c-u*l;l=h*l+u*c;c=g}}}}};FFTM.prototype.guessLen13b=function guessLen13b(e,t){var r=Math.max(t,e)|1;var i=r&1;var n=0;for(r=r/2|0;r;r=r>>>1){n++}return 1<<n+1+i};FFTM.prototype.conjugate=function conjugate(e,t,r){if(r<=1)return;for(var i=0;i<r/2;i++){var n=e[i];e[i]=e[r-i-1];e[r-i-1]=n;n=t[i];t[i]=-t[r-i-1];t[r-i-1]=-n}};FFTM.prototype.normalize13b=function normalize13b(e,t){var r=0;for(var i=0;i<t/2;i++){var n=Math.round(e[2*i+1]/t)*8192+Math.round(e[2*i]/t)+r;e[i]=n&67108863;if(n<67108864){r=0}else{r=n/67108864|0}}return e};FFTM.prototype.convert13b=function convert13b(e,t,r,i){var n=0;for(var a=0;a<t;a++){n=n+(e[a]|0);r[2*a]=n&8191;n=n>>>13;r[2*a+1]=n&8191;n=n>>>13}for(a=2*t;a<i;++a){r[a]=0}assert(n===0);assert((n&~8191)===0)};FFTM.prototype.stub=function stub(e){var t=new Array(e);for(var r=0;r<e;r++){t[r]=0}return t};FFTM.prototype.mulp=function mulp(e,t,r){var i=2*this.guessLen13b(e.length,t.length);var n=this.makeRBT(i);var a=this.stub(i);var s=new Array(i);var o=new Array(i);var h=new Array(i);var u=new Array(i);var d=new Array(i);var c=new Array(i);var l=r.words;l.length=i;this.convert13b(e.words,e.length,s,i);this.convert13b(t.words,t.length,u,i);this.transform(s,a,o,h,i,n);this.transform(u,a,d,c,i,n);for(var p=0;p<i;p++){var v=o[p]*d[p]-h[p]*c[p];h[p]=o[p]*c[p]+h[p]*d[p];o[p]=v}this.conjugate(o,h,i);this.transform(o,h,l,a,i,n);this.conjugate(l,a,i);this.normalize13b(l,i);r.negative=e.negative^t.negative;r.length=e.length+t.length;return r._strip()};BN.prototype.mul=function mul(e){var t=new BN(null);t.words=new Array(this.length+e.length);return this.mulTo(e,t)};BN.prototype.mulf=function mulf(e){var t=new BN(null);t.words=new Array(this.length+e.length);return jumboMulTo(this,e,t)};BN.prototype.imul=function imul(e){return this.clone().mulTo(e,this)};BN.prototype.imuln=function imuln(e){var t=e<0;if(t)e=-e;assert(typeof e==="number");assert(e<67108864);var r=0;for(var i=0;i<this.length;i++){var n=(this.words[i]|0)*e;var a=(n&67108863)+(r&67108863);r>>=26;r+=n/67108864|0;r+=a>>>26;this.words[i]=a&67108863}if(r!==0){this.words[i]=r;this.length++}return t?this.ineg():this};BN.prototype.muln=function muln(e){return this.clone().imuln(e)};BN.prototype.sqr=function sqr(){return this.mul(this)};BN.prototype.isqr=function isqr(){return this.imul(this.clone())};BN.prototype.pow=function pow(e){var t=toBitArray(e);if(t.length===0)return new BN(1);var r=this;for(var i=0;i<t.length;i++,r=r.sqr()){if(t[i]!==0)break}if(++i<t.length){for(var n=r.sqr();i<t.length;i++,n=n.sqr()){if(t[i]===0)continue;r=r.mul(n)}}return r};BN.prototype.iushln=function iushln(e){assert(typeof e==="number"&&e>=0);var t=e%26;var r=(e-t)/26;var i=67108863>>>26-t<<26-t;var n;if(t!==0){var a=0;for(n=0;n<this.length;n++){var s=this.words[n]&i;var o=(this.words[n]|0)-s<<t;this.words[n]=o|a;a=s>>>26-t}if(a){this.words[n]=a;this.length++}}if(r!==0){for(n=this.length-1;n>=0;n--){this.words[n+r]=this.words[n]}for(n=0;n<r;n++){this.words[n]=0}this.length+=r}return this._strip()};BN.prototype.ishln=function ishln(e){assert(this.negative===0);return this.iushln(e)};BN.prototype.iushrn=function iushrn(e,t,r){assert(typeof e==="number"&&e>=0);var i;if(t){i=(t-t%26)/26}else{i=0}var n=e%26;var a=Math.min((e-n)/26,this.length);var s=67108863^67108863>>>n<<n;var o=r;i-=a;i=Math.max(0,i);if(o){for(var h=0;h<a;h++){o.words[h]=this.words[h]}o.length=a}if(a===0){}else if(this.length>a){this.length-=a;for(h=0;h<this.length;h++){this.words[h]=this.words[h+a]}}else{this.words[0]=0;this.length=1}var u=0;for(h=this.length-1;h>=0&&(u!==0||h>=i);h--){var d=this.words[h]|0;this.words[h]=u<<26-n|d>>>n;u=d&s}if(o&&u!==0){o.words[o.length++]=u}if(this.length===0){this.words[0]=0;this.length=1}return this._strip()};BN.prototype.ishrn=function ishrn(e,t,r){assert(this.negative===0);return this.iushrn(e,t,r)};BN.prototype.shln=function shln(e){return this.clone().ishln(e)};BN.prototype.ushln=function ushln(e){return this.clone().iushln(e)};BN.prototype.shrn=function shrn(e){return this.clone().ishrn(e)};BN.prototype.ushrn=function ushrn(e){return this.clone().iushrn(e)};BN.prototype.testn=function testn(e){assert(typeof e==="number"&&e>=0);var t=e%26;var r=(e-t)/26;var i=1<<t;if(this.length<=r)return false;var n=this.words[r];return!!(n&i)};BN.prototype.imaskn=function imaskn(e){assert(typeof e==="number"&&e>=0);var t=e%26;var r=(e-t)/26;assert(this.negative===0,"imaskn works only with positive numbers");if(this.length<=r){return this}if(t!==0){r++}this.length=Math.min(r,this.length);if(t!==0){var i=67108863^67108863>>>t<<t;this.words[this.length-1]&=i}return this._strip()};BN.prototype.maskn=function maskn(e){return this.clone().imaskn(e)};BN.prototype.iaddn=function iaddn(e){assert(typeof e==="number");assert(e<67108864);if(e<0)return this.isubn(-e);if(this.negative!==0){if(this.length===1&&(this.words[0]|0)<=e){this.words[0]=e-(this.words[0]|0);this.negative=0;return this}this.negative=0;this.isubn(e);this.negative=1;return this}return this._iaddn(e)};BN.prototype._iaddn=function _iaddn(e){this.words[0]+=e;for(var t=0;t<this.length&&this.words[t]>=67108864;t++){this.words[t]-=67108864;if(t===this.length-1){this.words[t+1]=1}else{this.words[t+1]++}}this.length=Math.max(this.length,t+1);return this};BN.prototype.isubn=function isubn(e){assert(typeof e==="number");assert(e<67108864);if(e<0)return this.iaddn(-e);if(this.negative!==0){this.negative=0;this.iaddn(e);this.negative=1;return this}this.words[0]-=e;if(this.length===1&&this.words[0]<0){this.words[0]=-this.words[0];this.negative=1}else{for(var t=0;t<this.length&&this.words[t]<0;t++){this.words[t]+=67108864;this.words[t+1]-=1}}return this._strip()};BN.prototype.addn=function addn(e){return this.clone().iaddn(e)};BN.prototype.subn=function subn(e){return this.clone().isubn(e)};BN.prototype.iabs=function iabs(){this.negative=0;return this};BN.prototype.abs=function abs(){return this.clone().iabs()};BN.prototype._ishlnsubmul=function _ishlnsubmul(e,t,r){var i=e.length+r;var n;this._expand(i);var a;var s=0;for(n=0;n<e.length;n++){a=(this.words[n+r]|0)+s;var o=(e.words[n]|0)*t;a-=o&67108863;s=(a>>26)-(o/67108864|0);this.words[n+r]=a&67108863}for(;n<this.length-r;n++){a=(this.words[n+r]|0)+s;s=a>>26;this.words[n+r]=a&67108863}if(s===0)return this._strip();assert(s===-1);s=0;for(n=0;n<this.length;n++){a=-(this.words[n]|0)+s;s=a>>26;this.words[n]=a&67108863}this.negative=1;return this._strip()};BN.prototype._wordDiv=function _wordDiv(e,t){var r=this.length-e.length;var i=this.clone();var n=e;var a=n.words[n.length-1]|0;var s=this._countBits(a);r=26-s;if(r!==0){n=n.ushln(r);i.iushln(r);a=n.words[n.length-1]|0}var o=i.length-n.length;var h;if(t!=="mod"){h=new BN(null);h.length=o+1;h.words=new Array(h.length);for(var u=0;u<h.length;u++){h.words[u]=0}}var d=i.clone()._ishlnsubmul(n,1,o);if(d.negative===0){i=d;if(h){h.words[o]=1}}for(var c=o-1;c>=0;c--){var l=(i.words[n.length+c]|0)*67108864+(i.words[n.length+c-1]|0);l=Math.min(l/a|0,67108863);i._ishlnsubmul(n,l,c);while(i.negative!==0){l--;i.negative=0;i._ishlnsubmul(n,1,c);if(!i.isZero()){i.negative^=1}}if(h){h.words[c]=l}}if(h){h._strip()}i._strip();if(t!=="div"&&r!==0){i.iushrn(r)}return{div:h||null,mod:i}};BN.prototype.divmod=function divmod(e,t,r){assert(!e.isZero());if(this.isZero()){return{div:new BN(0),mod:new BN(0)}}var i,n,a;if(this.negative!==0&&e.negative===0){a=this.neg().divmod(e,t);if(t!=="mod"){i=a.div.neg()}if(t!=="div"){n=a.mod.neg();if(r&&n.negative!==0){n.iadd(e)}}return{div:i,mod:n}}if(this.negative===0&&e.negative!==0){a=this.divmod(e.neg(),t);if(t!=="mod"){i=a.div.neg()}return{div:i,mod:a.mod}}if((this.negative&e.negative)!==0){a=this.neg().divmod(e.neg(),t);if(t!=="div"){n=a.mod.neg();if(r&&n.negative!==0){n.isub(e)}}return{div:a.div,mod:n}}if(e.length>this.length||this.cmp(e)<0){return{div:new BN(0),mod:this}}if(e.length===1){if(t==="div"){return{div:this.divn(e.words[0]),mod:null}}if(t==="mod"){return{div:null,mod:new BN(this.modrn(e.words[0]))}}return{div:this.divn(e.words[0]),mod:new BN(this.modrn(e.words[0]))}}return this._wordDiv(e,t)};BN.prototype.div=function div(e){return this.divmod(e,"div",false).div};BN.prototype.mod=function mod(e){return this.divmod(e,"mod",false).mod};BN.prototype.umod=function umod(e){return this.divmod(e,"mod",true).mod};BN.prototype.divRound=function divRound(e){var t=this.divmod(e);if(t.mod.isZero())return t.div;var r=t.div.negative!==0?t.mod.isub(e):t.mod;var i=e.ushrn(1);var n=e.andln(1);var a=r.cmp(i);if(a<0||n===1&&a===0)return t.div;return t.div.negative!==0?t.div.isubn(1):t.div.iaddn(1)};BN.prototype.modrn=function modrn(e){var t=e<0;if(t)e=-e;assert(e<=67108863);var r=(1<<26)%e;var i=0;for(var n=this.length-1;n>=0;n--){i=(r*i+(this.words[n]|0))%e}return t?-i:i};BN.prototype.modn=function modn(e){return this.modrn(e)};BN.prototype.idivn=function idivn(e){var t=e<0;if(t)e=-e;assert(e<=67108863);var r=0;for(var i=this.length-1;i>=0;i--){var n=(this.words[i]|0)+r*67108864;this.words[i]=n/e|0;r=n%e}this._strip();return t?this.ineg():this};BN.prototype.divn=function divn(e){return this.clone().idivn(e)};BN.prototype.egcd=function egcd(e){assert(e.negative===0);assert(!e.isZero());var t=this;var r=e.clone();if(t.negative!==0){t=t.umod(e)}else{t=t.clone()}var i=new BN(1);var n=new BN(0);var a=new BN(0);var s=new BN(1);var o=0;while(t.isEven()&&r.isEven()){t.iushrn(1);r.iushrn(1);++o}var h=r.clone();var u=t.clone();while(!t.isZero()){for(var d=0,c=1;(t.words[0]&c)===0&&d<26;++d,c<<=1);if(d>0){t.iushrn(d);while(d-- >0){if(i.isOdd()||n.isOdd()){i.iadd(h);n.isub(u)}i.iushrn(1);n.iushrn(1)}}for(var l=0,p=1;(r.words[0]&p)===0&&l<26;++l,p<<=1);if(l>0){r.iushrn(l);while(l-- >0){if(a.isOdd()||s.isOdd()){a.iadd(h);s.isub(u)}a.iushrn(1);s.iushrn(1)}}if(t.cmp(r)>=0){t.isub(r);i.isub(a);n.isub(s)}else{r.isub(t);a.isub(i);s.isub(n)}}return{a:a,b:s,gcd:r.iushln(o)}};BN.prototype._invmp=function _invmp(e){assert(e.negative===0);assert(!e.isZero());var t=this;var r=e.clone();if(t.negative!==0){t=t.umod(e)}else{t=t.clone()}var i=new BN(1);var n=new BN(0);var a=r.clone();while(t.cmpn(1)>0&&r.cmpn(1)>0){for(var s=0,o=1;(t.words[0]&o)===0&&s<26;++s,o<<=1);if(s>0){t.iushrn(s);while(s-- >0){if(i.isOdd()){i.iadd(a)}i.iushrn(1)}}for(var h=0,u=1;(r.words[0]&u)===0&&h<26;++h,u<<=1);if(h>0){r.iushrn(h);while(h-- >0){if(n.isOdd()){n.iadd(a)}n.iushrn(1)}}if(t.cmp(r)>=0){t.isub(r);i.isub(n)}else{r.isub(t);n.isub(i)}}var d;if(t.cmpn(1)===0){d=i}else{d=n}if(d.cmpn(0)<0){d.iadd(e)}return d};BN.prototype.gcd=function gcd(e){if(this.isZero())return e.abs();if(e.isZero())return this.abs();var t=this.clone();var r=e.clone();t.negative=0;r.negative=0;for(var i=0;t.isEven()&&r.isEven();i++){t.iushrn(1);r.iushrn(1)}do{while(t.isEven()){t.iushrn(1)}while(r.isEven()){r.iushrn(1)}var n=t.cmp(r);if(n<0){var a=t;t=r;r=a}else if(n===0||r.cmpn(1)===0){break}t.isub(r)}while(true);return r.iushln(i)};BN.prototype.invm=function invm(e){return this.egcd(e).a.umod(e)};BN.prototype.isEven=function isEven(){return(this.words[0]&1)===0};BN.prototype.isOdd=function isOdd(){return(this.words[0]&1)===1};BN.prototype.andln=function andln(e){return this.words[0]&e};BN.prototype.bincn=function bincn(e){assert(typeof e==="number");var t=e%26;var r=(e-t)/26;var i=1<<t;if(this.length<=r){this._expand(r+1);this.words[r]|=i;return this}var n=i;for(var a=r;n!==0&&a<this.length;a++){var s=this.words[a]|0;s+=n;n=s>>>26;s&=67108863;this.words[a]=s}if(n!==0){this.words[a]=n;this.length++}return this};BN.prototype.isZero=function isZero(){return this.length===1&&this.words[0]===0};BN.prototype.cmpn=function cmpn(e){var t=e<0;if(this.negative!==0&&!t)return-1;if(this.negative===0&&t)return 1;this._strip();var r;if(this.length>1){r=1}else{if(t){e=-e}assert(e<=67108863,"Number is too big");var i=this.words[0]|0;r=i===e?0:i<e?-1:1}if(this.negative!==0)return-r|0;return r};BN.prototype.cmp=function cmp(e){if(this.negative!==0&&e.negative===0)return-1;if(this.negative===0&&e.negative!==0)return 1;var t=this.ucmp(e);if(this.negative!==0)return-t|0;return t};BN.prototype.ucmp=function ucmp(e){if(this.length>e.length)return 1;if(this.length<e.length)return-1;var t=0;for(var r=this.length-1;r>=0;r--){var i=this.words[r]|0;var n=e.words[r]|0;if(i===n)continue;if(i<n){t=-1}else if(i>n){t=1}break}return t};BN.prototype.gtn=function gtn(e){return this.cmpn(e)===1};BN.prototype.gt=function gt(e){return this.cmp(e)===1};BN.prototype.gten=function gten(e){return this.cmpn(e)>=0};BN.prototype.gte=function gte(e){return this.cmp(e)>=0};BN.prototype.ltn=function ltn(e){return this.cmpn(e)===-1};BN.prototype.lt=function lt(e){return this.cmp(e)===-1};BN.prototype.lten=function lten(e){return this.cmpn(e)<=0};BN.prototype.lte=function lte(e){return this.cmp(e)<=0};BN.prototype.eqn=function eqn(e){return this.cmpn(e)===0};BN.prototype.eq=function eq(e){return this.cmp(e)===0};BN.red=function red(e){return new Red(e)};BN.prototype.toRed=function toRed(e){assert(!this.red,"Already a number in reduction context");assert(this.negative===0,"red works only with positives");return e.convertTo(this)._forceRed(e)};BN.prototype.fromRed=function fromRed(){assert(this.red,"fromRed works only with numbers in reduction context");return this.red.convertFrom(this)};BN.prototype._forceRed=function _forceRed(e){this.red=e;return this};BN.prototype.forceRed=function forceRed(e){assert(!this.red,"Already a number in reduction context");return this._forceRed(e)};BN.prototype.redAdd=function redAdd(e){assert(this.red,"redAdd works only with red numbers");return this.red.add(this,e)};BN.prototype.redIAdd=function redIAdd(e){assert(this.red,"redIAdd works only with red numbers");return this.red.iadd(this,e)};BN.prototype.redSub=function redSub(e){assert(this.red,"redSub works only with red numbers");return this.red.sub(this,e)};BN.prototype.redISub=function redISub(e){assert(this.red,"redISub works only with red numbers");return this.red.isub(this,e)};BN.prototype.redShl=function redShl(e){assert(this.red,"redShl works only with red numbers");return this.red.shl(this,e)};BN.prototype.redMul=function redMul(e){assert(this.red,"redMul works only with red numbers");this.red._verify2(this,e);return this.red.mul(this,e)};BN.prototype.redIMul=function redIMul(e){assert(this.red,"redMul works only with red numbers");this.red._verify2(this,e);return this.red.imul(this,e)};BN.prototype.redSqr=function redSqr(){assert(this.red,"redSqr works only with red numbers");this.red._verify1(this);return this.red.sqr(this)};BN.prototype.redISqr=function redISqr(){assert(this.red,"redISqr works only with red numbers");this.red._verify1(this);return this.red.isqr(this)};BN.prototype.redSqrt=function redSqrt(){assert(this.red,"redSqrt works only with red numbers");this.red._verify1(this);return this.red.sqrt(this)};BN.prototype.redInvm=function redInvm(){assert(this.red,"redInvm works only with red numbers");this.red._verify1(this);return this.red.invm(this)};BN.prototype.redNeg=function redNeg(){assert(this.red,"redNeg works only with red numbers");this.red._verify1(this);return this.red.neg(this)};BN.prototype.redPow=function redPow(e){assert(this.red&&!e.red,"redPow(normalNum)");this.red._verify1(this);return this.red.pow(this,e)};var u={k256:null,p224:null,p192:null,p25519:null};function MPrime(e,t){this.name=e;this.p=new BN(t,16);this.n=this.p.bitLength();this.k=new BN(1).iushln(this.n).isub(this.p);this.tmp=this._tmp()}MPrime.prototype._tmp=function _tmp(){var e=new BN(null);e.words=new Array(Math.ceil(this.n/13));return e};MPrime.prototype.ireduce=function ireduce(e){var t=e;var r;do{this.split(t,this.tmp);t=this.imulK(t);t=t.iadd(this.tmp);r=t.bitLength()}while(r>this.n);var i=r<this.n?-1:t.ucmp(this.p);if(i===0){t.words[0]=0;t.length=1}else if(i>0){t.isub(this.p)}else{if(t.strip!==undefined){t.strip()}else{t._strip()}}return t};MPrime.prototype.split=function split(e,t){e.iushrn(this.n,0,t)};MPrime.prototype.imulK=function imulK(e){return e.imul(this.k)};function K256(){MPrime.call(this,"k256","ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f")}inherits(K256,MPrime);K256.prototype.split=function split(e,t){var r=4194303;var i=Math.min(e.length,9);for(var n=0;n<i;n++){t.words[n]=e.words[n]}t.length=i;if(e.length<=9){e.words[0]=0;e.length=1;return}var a=e.words[9];t.words[t.length++]=a&r;for(n=10;n<e.length;n++){var s=e.words[n]|0;e.words[n-10]=(s&r)<<4|a>>>22;a=s}a>>>=22;e.words[n-10]=a;if(a===0&&e.length>10){e.length-=10}else{e.length-=9}};K256.prototype.imulK=function imulK(e){e.words[e.length]=0;e.words[e.length+1]=0;e.length+=2;var t=0;for(var r=0;r<e.length;r++){var i=e.words[r]|0;t+=i*977;e.words[r]=t&67108863;t=i*64+(t/67108864|0)}if(e.words[e.length-1]===0){e.length--;if(e.words[e.length-1]===0){e.length--}}return e};function P224(){MPrime.call(this,"p224","ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001")}inherits(P224,MPrime);function P192(){MPrime.call(this,"p192","ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff")}inherits(P192,MPrime);function P25519(){MPrime.call(this,"25519","7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed")}inherits(P25519,MPrime);P25519.prototype.imulK=function imulK(e){var t=0;for(var r=0;r<e.length;r++){var i=(e.words[r]|0)*19+t;var n=i&67108863;i>>>=26;e.words[r]=n;t=i}if(t!==0){e.words[e.length++]=t}return e};BN._prime=function prime(e){if(u[e])return u[e];var prime;if(e==="k256"){prime=new K256}else if(e==="p224"){prime=new P224}else if(e==="p192"){prime=new P192}else if(e==="p25519"){prime=new P25519}else{throw new Error("Unknown prime "+e)}u[e]=prime;return prime};function Red(e){if(typeof e==="string"){var t=BN._prime(e);this.m=t.p;this.prime=t}else{assert(e.gtn(1),"modulus must be greater than 1");this.m=e;this.prime=null}}Red.prototype._verify1=function _verify1(e){assert(e.negative===0,"red works only with positives");assert(e.red,"red works only with red numbers")};Red.prototype._verify2=function _verify2(e,t){assert((e.negative|t.negative)===0,"red works only with positives");assert(e.red&&e.red===t.red,"red works only with red numbers")};Red.prototype.imod=function imod(e){if(this.prime)return this.prime.ireduce(e)._forceRed(this);move(e,e.umod(this.m)._forceRed(this));return e};Red.prototype.neg=function neg(e){if(e.isZero()){return e.clone()}return this.m.sub(e)._forceRed(this)};Red.prototype.add=function add(e,t){this._verify2(e,t);var r=e.add(t);if(r.cmp(this.m)>=0){r.isub(this.m)}return r._forceRed(this)};Red.prototype.iadd=function iadd(e,t){this._verify2(e,t);var r=e.iadd(t);if(r.cmp(this.m)>=0){r.isub(this.m)}return r};Red.prototype.sub=function sub(e,t){this._verify2(e,t);var r=e.sub(t);if(r.cmpn(0)<0){r.iadd(this.m)}return r._forceRed(this)};Red.prototype.isub=function isub(e,t){this._verify2(e,t);var r=e.isub(t);if(r.cmpn(0)<0){r.iadd(this.m)}return r};Red.prototype.shl=function shl(e,t){this._verify1(e);return this.imod(e.ushln(t))};Red.prototype.imul=function imul(e,t){this._verify2(e,t);return this.imod(e.imul(t))};Red.prototype.mul=function mul(e,t){this._verify2(e,t);return this.imod(e.mul(t))};Red.prototype.isqr=function isqr(e){return this.imul(e,e.clone())};Red.prototype.sqr=function sqr(e){return this.mul(e,e)};Red.prototype.sqrt=function sqrt(e){if(e.isZero())return e.clone();var t=this.m.andln(3);assert(t%2===1);if(t===3){var r=this.m.add(new BN(1)).iushrn(2);return this.pow(e,r)}var i=this.m.subn(1);var n=0;while(!i.isZero()&&i.andln(1)===0){n++;i.iushrn(1)}assert(!i.isZero());var a=new BN(1).toRed(this);var s=a.redNeg();var o=this.m.subn(1).iushrn(1);var h=this.m.bitLength();h=new BN(2*h*h).toRed(this);while(this.pow(h,o).cmp(s)!==0){h.redIAdd(s)}var u=this.pow(h,i);var d=this.pow(e,i.addn(1).iushrn(1));var c=this.pow(e,i);var l=n;while(c.cmp(a)!==0){var p=c;for(var v=0;p.cmp(a)!==0;v++){p=p.redSqr()}assert(v<l);var b=this.pow(u,new BN(1).iushln(l-v-1));d=d.redMul(b);u=b.redSqr();c=c.redMul(u);l=v}return d};Red.prototype.invm=function invm(e){var t=e._invmp(this.m);if(t.negative!==0){t.negative=0;return this.imod(t).redNeg()}else{return this.imod(t)}};Red.prototype.pow=function pow(e,t){if(t.isZero())return new BN(1).toRed(this);if(t.cmpn(1)===0)return e.clone();var r=4;var i=new Array(1<<r);i[0]=new BN(1).toRed(this);i[1]=e;for(var n=2;n<i.length;n++){i[n]=this.mul(i[n-1],e)}var a=i[0];var s=0;var o=0;var h=t.bitLength()%26;if(h===0){h=26}for(n=t.length-1;n>=0;n--){var u=t.words[n];for(var d=h-1;d>=0;d--){var c=u>>d&1;if(a!==i[0]){a=this.sqr(a)}if(c===0&&s===0){o=0;continue}s<<=1;s|=c;o++;if(o!==r&&(n!==0||d!==0))continue;a=this.mul(a,i[s]);o=0;s=0}h=26}return a};Red.prototype.convertTo=function convertTo(e){var t=e.umod(this.m);return t===e?t.clone():t};Red.prototype.convertFrom=function convertFrom(e){var t=e.clone();t.red=null;return t};BN.mont=function mont(e){return new Mont(e)};function Mont(e){Red.call(this,e);this.shift=this.m.bitLength();if(this.shift%26!==0){this.shift+=26-this.shift%26}this.r=new BN(1).iushln(this.shift);this.r2=this.imod(this.r.sqr());this.rinv=this.r._invmp(this.m);this.minv=this.rinv.mul(this.r).isubn(1).div(this.m);this.minv=this.minv.umod(this.r);this.minv=this.r.sub(this.minv)}inherits(Mont,Red);Mont.prototype.convertTo=function convertTo(e){return this.imod(e.ushln(this.shift))};Mont.prototype.convertFrom=function convertFrom(e){var t=this.imod(e.mul(this.rinv));t.red=null;return t};Mont.prototype.imul=function imul(e,t){if(e.isZero()||t.isZero()){e.words[0]=0;e.length=1;return e}var r=e.imul(t);var i=r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);var n=r.isub(i).iushrn(this.shift);var a=n;if(n.cmp(this.m)>=0){a=n.isub(this.m)}else if(n.cmpn(0)<0){a=n.iadd(this.m)}return a._forceRed(this)};Mont.prototype.mul=function mul(e,t){if(e.isZero()||t.isZero())return new BN(0)._forceRed(this);var r=e.mul(t);var i=r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);var n=r.isub(i).iushrn(this.shift);var a=n;if(n.cmp(this.m)>=0){a=n.isub(this.m)}else if(n.cmpn(0)<0){a=n.iadd(this.m)}return a._forceRed(this)};Mont.prototype.invm=function invm(e){var t=this.imod(e._invmp(this.m).mul(this.r2));return t._forceRed(this)}})( false||e,this)},3500:function(e,t,r){var i;e.exports=function rand(e){if(!i)i=new Rand(null);return i.generate(e)};function Rand(e){this.rand=e}e.exports.Rand=Rand;Rand.prototype.generate=function generate(e){return this._rand(e)};Rand.prototype._rand=function _rand(e){if(this.rand.getBytes)return this.rand.getBytes(e);var t=new Uint8Array(e);for(var r=0;r<t.length;r++)t[r]=this.rand.getByte();return t};if(typeof self==="object"){if(self.crypto&&self.crypto.getRandomValues){Rand.prototype._rand=function _rand(e){var t=new Uint8Array(e);self.crypto.getRandomValues(t);return t}}else if(self.msCrypto&&self.msCrypto.getRandomValues){Rand.prototype._rand=function _rand(e){var t=new Uint8Array(e);self.msCrypto.getRandomValues(t);return t}}else if(typeof window==="object"){Rand.prototype._rand=function(){throw new Error("Not implemented yet")}}}else{try{var n=r(6113);if(typeof n.randomBytes!=="function")throw new Error("Not supported");Rand.prototype._rand=function _rand(e){return n.randomBytes(e)}}catch(e){}}},1387:function(e,t,r){var i=r(5055).Buffer;function asUInt32Array(e){if(!i.isBuffer(e))e=i.from(e);var t=e.length/4|0;var r=new Array(t);for(var n=0;n<t;n++){r[n]=e.readUInt32BE(n*4)}return r}function scrubVec(e){for(var t=0;t<e.length;e++){e[t]=0}}function cryptBlock(e,t,r,i,n){var a=r[0];var s=r[1];var o=r[2];var h=r[3];var u=e[0]^t[0];var d=e[1]^t[1];var c=e[2]^t[2];var l=e[3]^t[3];var p,v,b,m;var y=4;for(var g=1;g<n;g++){p=a[u>>>24]^s[d>>>16&255]^o[c>>>8&255]^h[l&255]^t[y++];v=a[d>>>24]^s[c>>>16&255]^o[l>>>8&255]^h[u&255]^t[y++];b=a[c>>>24]^s[l>>>16&255]^o[u>>>8&255]^h[d&255]^t[y++];m=a[l>>>24]^s[u>>>16&255]^o[d>>>8&255]^h[c&255]^t[y++];u=p;d=v;c=b;l=m}p=(i[u>>>24]<<24|i[d>>>16&255]<<16|i[c>>>8&255]<<8|i[l&255])^t[y++];v=(i[d>>>24]<<24|i[c>>>16&255]<<16|i[l>>>8&255]<<8|i[u&255])^t[y++];b=(i[c>>>24]<<24|i[l>>>16&255]<<16|i[u>>>8&255]<<8|i[d&255])^t[y++];m=(i[l>>>24]<<24|i[u>>>16&255]<<16|i[d>>>8&255]<<8|i[c&255])^t[y++];p=p>>>0;v=v>>>0;b=b>>>0;m=m>>>0;return[p,v,b,m]}var n=[0,1,2,4,8,16,32,64,128,27,54];var a=function(){var e=new Array(256);for(var t=0;t<256;t++){if(t<128){e[t]=t<<1}else{e[t]=t<<1^283}}var r=[];var i=[];var n=[[],[],[],[]];var a=[[],[],[],[]];var s=0;var o=0;for(var h=0;h<256;++h){var u=o^o<<1^o<<2^o<<3^o<<4;u=u>>>8^u&255^99;r[s]=u;i[u]=s;var d=e[s];var c=e[d];var l=e[c];var p=e[u]*257^u*16843008;n[0][s]=p<<24|p>>>8;n[1][s]=p<<16|p>>>16;n[2][s]=p<<8|p>>>24;n[3][s]=p;p=l*16843009^c*65537^d*257^s*16843008;a[0][u]=p<<24|p>>>8;a[1][u]=p<<16|p>>>16;a[2][u]=p<<8|p>>>24;a[3][u]=p;if(s===0){s=o=1}else{s=d^e[e[e[l^d]]];o^=e[e[o]]}}return{SBOX:r,INV_SBOX:i,SUB_MIX:n,INV_SUB_MIX:a}}();function AES(e){this._key=asUInt32Array(e);this._reset()}AES.blockSize=4*4;AES.keySize=256/8;AES.prototype.blockSize=AES.blockSize;AES.prototype.keySize=AES.keySize;AES.prototype._reset=function(){var e=this._key;var t=e.length;var r=t+6;var i=(r+1)*4;var s=[];for(var o=0;o<t;o++){s[o]=e[o]}for(o=t;o<i;o++){var h=s[o-1];if(o%t===0){h=h<<8|h>>>24;h=a.SBOX[h>>>24]<<24|a.SBOX[h>>>16&255]<<16|a.SBOX[h>>>8&255]<<8|a.SBOX[h&255];h^=n[o/t|0]<<24}else if(t>6&&o%t===4){h=a.SBOX[h>>>24]<<24|a.SBOX[h>>>16&255]<<16|a.SBOX[h>>>8&255]<<8|a.SBOX[h&255]}s[o]=s[o-t]^h}var u=[];for(var d=0;d<i;d++){var c=i-d;var l=s[c-(d%4?0:4)];if(d<4||c<=4){u[d]=l}else{u[d]=a.INV_SUB_MIX[0][a.SBOX[l>>>24]]^a.INV_SUB_MIX[1][a.SBOX[l>>>16&255]]^a.INV_SUB_MIX[2][a.SBOX[l>>>8&255]]^a.INV_SUB_MIX[3][a.SBOX[l&255]]}}this._nRounds=r;this._keySchedule=s;this._invKeySchedule=u};AES.prototype.encryptBlockRaw=function(e){e=asUInt32Array(e);return cryptBlock(e,this._keySchedule,a.SUB_MIX,a.SBOX,this._nRounds)};AES.prototype.encryptBlock=function(e){var t=this.encryptBlockRaw(e);var r=i.allocUnsafe(16);r.writeUInt32BE(t[0],0);r.writeUInt32BE(t[1],4);r.writeUInt32BE(t[2],8);r.writeUInt32BE(t[3],12);return r};AES.prototype.decryptBlock=function(e){e=asUInt32Array(e);var t=e[1];e[1]=e[3];e[3]=t;var r=cryptBlock(e,this._invKeySchedule,a.INV_SUB_MIX,a.INV_SBOX,this._nRounds);var n=i.allocUnsafe(16);n.writeUInt32BE(r[0],0);n.writeUInt32BE(r[3],4);n.writeUInt32BE(r[2],8);n.writeUInt32BE(r[1],12);return n};AES.prototype.scrub=function(){scrubVec(this._keySchedule);scrubVec(this._invKeySchedule);scrubVec(this._key)};e.exports.AES=AES},6624:function(e,t,r){var i=r(1387);var n=r(5055).Buffer;var a=r(1043);var s=r(3782);var o=r(7225);var h=r(4734);var u=r(598);function xorTest(e,t){var r=0;if(e.length!==t.length)r++;var i=Math.min(e.length,t.length);for(var n=0;n<i;++n){r+=e[n]^t[n]}return r}function calcIv(e,t,r){if(t.length===12){e._finID=n.concat([t,n.from([0,0,0,1])]);return n.concat([t,n.from([0,0,0,2])])}var i=new o(r);var a=t.length;var s=a%16;i.update(t);if(s){s=16-s;i.update(n.alloc(s,0))}i.update(n.alloc(8,0));var h=a*8;var d=n.alloc(8);d.writeUIntBE(h,0,8);i.update(d);e._finID=i.state;var c=n.from(e._finID);u(c);return c}function StreamCipher(e,t,r,s){a.call(this);var h=n.alloc(4,0);this._cipher=new i.AES(t);var u=this._cipher.encryptBlock(h);this._ghash=new o(u);r=calcIv(this,r,u);this._prev=n.from(r);this._cache=n.allocUnsafe(0);this._secCache=n.allocUnsafe(0);this._decrypt=s;this._alen=0;this._len=0;this._mode=e;this._authTag=null;this._called=false}s(StreamCipher,a);StreamCipher.prototype._update=function(e){if(!this._called&&this._alen){var t=16-this._alen%16;if(t<16){t=n.alloc(t,0);this._ghash.update(t)}}this._called=true;var r=this._mode.encrypt(this,e);if(this._decrypt){this._ghash.update(e)}else{this._ghash.update(r)}this._len+=e.length;return r};StreamCipher.prototype._final=function(){if(this._decrypt&&!this._authTag)throw new Error("Unsupported state or unable to authenticate data");var e=h(this._ghash.final(this._alen*8,this._len*8),this._cipher.encryptBlock(this._finID));if(this._decrypt&&xorTest(e,this._authTag))throw new Error("Unsupported state or unable to authenticate data");this._authTag=e;this._cipher.scrub()};StreamCipher.prototype.getAuthTag=function getAuthTag(){if(this._decrypt||!n.isBuffer(this._authTag))throw new Error("Attempting to get auth tag in unsupported state");return this._authTag};StreamCipher.prototype.setAuthTag=function setAuthTag(e){if(!this._decrypt)throw new Error("Attempting to set auth tag in unsupported state");this._authTag=e};StreamCipher.prototype.setAAD=function setAAD(e){if(this._called)throw new Error("Attempting to set AAD in unsupported state");this._ghash.update(e);this._alen+=e.length};e.exports=StreamCipher},6594:function(e,t,r){var i=r(2);var n=r(2598);var a=r(5866);function getCiphers(){return Object.keys(a)}t.createCipher=t.Cipher=i.createCipher;t.createCipheriv=t.Cipheriv=i.createCipheriv;t.createDecipher=t.Decipher=n.createDecipher;t.createDecipheriv=t.Decipheriv=n.createDecipheriv;t.listCiphers=t.getCiphers=getCiphers},2598:function(e,t,r){var i=r(6624);var n=r(5055).Buffer;var a=r(6370);var s=r(126);var o=r(1043);var h=r(1387);var u=r(8368);var d=r(3782);function Decipher(e,t,r){o.call(this);this._cache=new Splitter;this._last=void 0;this._cipher=new h.AES(t);this._prev=n.from(r);this._mode=e;this._autopadding=true}d(Decipher,o);Decipher.prototype._update=function(e){this._cache.add(e);var t;var r;var i=[];while(t=this._cache.get(this._autopadding)){r=this._mode.decrypt(this,t);i.push(r)}return n.concat(i)};Decipher.prototype._final=function(){var e=this._cache.flush();if(this._autopadding){return unpad(this._mode.decrypt(this,e))}else if(e){throw new Error("data not multiple of block length")}};Decipher.prototype.setAutoPadding=function(e){this._autopadding=!!e;return this};function Splitter(){this.cache=n.allocUnsafe(0)}Splitter.prototype.add=function(e){this.cache=n.concat([this.cache,e])};Splitter.prototype.get=function(e){var t;if(e){if(this.cache.length>16){t=this.cache.slice(0,16);this.cache=this.cache.slice(16);return t}}else{if(this.cache.length>=16){t=this.cache.slice(0,16);this.cache=this.cache.slice(16);return t}}return null};Splitter.prototype.flush=function(){if(this.cache.length)return this.cache};function unpad(e){var t=e[15];if(t<1||t>16){throw new Error("unable to decrypt data")}var r=-1;while(++r<t){if(e[r+(16-t)]!==t){throw new Error("unable to decrypt data")}}if(t===16)return;return e.slice(0,16-t)}function createDecipheriv(e,t,r){var o=a[e.toLowerCase()];if(!o)throw new TypeError("invalid suite type");if(typeof r==="string")r=n.from(r);if(o.mode!=="GCM"&&r.length!==o.iv)throw new TypeError("invalid iv length "+r.length);if(typeof t==="string")t=n.from(t);if(t.length!==o.key/8)throw new TypeError("invalid key length "+t.length);if(o.type==="stream"){return new s(o.module,t,r,true)}else if(o.type==="auth"){return new i(o.module,t,r,true)}return new Decipher(o.module,t,r)}function createDecipher(e,t){var r=a[e.toLowerCase()];if(!r)throw new TypeError("invalid suite type");var i=u(t,false,r.key,r.iv);return createDecipheriv(e,i.key,i.iv)}t.createDecipher=createDecipher;t.createDecipheriv=createDecipheriv},2:function(e,t,r){var i=r(6370);var n=r(6624);var a=r(5055).Buffer;var s=r(126);var o=r(1043);var h=r(1387);var u=r(8368);var d=r(3782);function Cipher(e,t,r){o.call(this);this._cache=new Splitter;this._cipher=new h.AES(t);this._prev=a.from(r);this._mode=e;this._autopadding=true}d(Cipher,o);Cipher.prototype._update=function(e){this._cache.add(e);var t;var r;var i=[];while(t=this._cache.get()){r=this._mode.encrypt(this,t);i.push(r)}return a.concat(i)};var c=a.alloc(16,16);Cipher.prototype._final=function(){var e=this._cache.flush();if(this._autopadding){e=this._mode.encrypt(this,e);this._cipher.scrub();return e}if(!e.equals(c)){this._cipher.scrub();throw new Error("data not multiple of block length")}};Cipher.prototype.setAutoPadding=function(e){this._autopadding=!!e;return this};function Splitter(){this.cache=a.allocUnsafe(0)}Splitter.prototype.add=function(e){this.cache=a.concat([this.cache,e])};Splitter.prototype.get=function(){if(this.cache.length>15){var e=this.cache.slice(0,16);this.cache=this.cache.slice(16);return e}return null};Splitter.prototype.flush=function(){var e=16-this.cache.length;var t=a.allocUnsafe(e);var r=-1;while(++r<e){t.writeUInt8(e,r)}return a.concat([this.cache,t])};function createCipheriv(e,t,r){var o=i[e.toLowerCase()];if(!o)throw new TypeError("invalid suite type");if(typeof t==="string")t=a.from(t);if(t.length!==o.key/8)throw new TypeError("invalid key length "+t.length);if(typeof r==="string")r=a.from(r);if(o.mode!=="GCM"&&r.length!==o.iv)throw new TypeError("invalid iv length "+r.length);if(o.type==="stream"){return new s(o.module,t,r)}else if(o.type==="auth"){return new n(o.module,t,r)}return new Cipher(o.module,t,r)}function createCipher(e,t){var r=i[e.toLowerCase()];if(!r)throw new TypeError("invalid suite type");var n=u(t,false,r.key,r.iv);return createCipheriv(e,n.key,n.iv)}t.createCipheriv=createCipheriv;t.createCipher=createCipher},7225:function(e,t,r){var i=r(5055).Buffer;var n=i.alloc(16,0);function toArray(e){return[e.readUInt32BE(0),e.readUInt32BE(4),e.readUInt32BE(8),e.readUInt32BE(12)]}function fromArray(e){var t=i.allocUnsafe(16);t.writeUInt32BE(e[0]>>>0,0);t.writeUInt32BE(e[1]>>>0,4);t.writeUInt32BE(e[2]>>>0,8);t.writeUInt32BE(e[3]>>>0,12);return t}function GHASH(e){this.h=e;this.state=i.alloc(16,0);this.cache=i.allocUnsafe(0)}GHASH.prototype.ghash=function(e){var t=-1;while(++t<e.length){this.state[t]^=e[t]}this._multiply()};GHASH.prototype._multiply=function(){var e=toArray(this.h);var t=[0,0,0,0];var r,i,n;var a=-1;while(++a<128){i=(this.state[~~(a/8)]&1<<7-a%8)!==0;if(i){t[0]^=e[0];t[1]^=e[1];t[2]^=e[2];t[3]^=e[3]}n=(e[3]&1)!==0;for(r=3;r>0;r--){e[r]=e[r]>>>1|(e[r-1]&1)<<31}e[0]=e[0]>>>1;if(n){e[0]=e[0]^225<<24}}this.state=fromArray(t)};GHASH.prototype.update=function(e){this.cache=i.concat([this.cache,e]);var t;while(this.cache.length>=16){t=this.cache.slice(0,16);this.cache=this.cache.slice(16);this.ghash(t)}};GHASH.prototype.final=function(e,t){if(this.cache.length){this.ghash(i.concat([this.cache,n],16))}this.ghash(fromArray([0,e,0,t]));return this.state};e.exports=GHASH},598:function(e){function incr32(e){var t=e.length;var r;while(t--){r=e.readUInt8(t);if(r===255){e.writeUInt8(0,t)}else{r++;e.writeUInt8(r,t);break}}}e.exports=incr32},9825:function(e,t,r){var i=r(4734);t.encrypt=function(e,t){var r=i(t,e._prev);e._prev=e._cipher.encryptBlock(r);return e._prev};t.decrypt=function(e,t){var r=e._prev;e._prev=t;var n=e._cipher.decryptBlock(t);return i(n,r)}},321:function(e,t,r){var i=r(5055).Buffer;var n=r(4734);function encryptStart(e,t,r){var a=t.length;var s=n(t,e._cache);e._cache=e._cache.slice(a);e._prev=i.concat([e._prev,r?t:s]);return s}t.encrypt=function(e,t,r){var n=i.allocUnsafe(0);var a;while(t.length){if(e._cache.length===0){e._cache=e._cipher.encryptBlock(e._prev);e._prev=i.allocUnsafe(0)}if(e._cache.length<=t.length){a=e._cache.length;n=i.concat([n,encryptStart(e,t.slice(0,a),r)]);t=t.slice(a)}else{n=i.concat([n,encryptStart(e,t,r)]);break}}return n}},3147:function(e,t,r){var i=r(5055).Buffer;function encryptByte(e,t,r){var i;var n=-1;var a=8;var s=0;var o,h;while(++n<a){i=e._cipher.encryptBlock(e._prev);o=t&1<<7-n?128:0;h=i[0]^o;s+=(h&128)>>n%8;e._prev=shiftIn(e._prev,r?o:h)}return s}function shiftIn(e,t){var r=e.length;var n=-1;var a=i.allocUnsafe(e.length);e=i.concat([e,i.from([t])]);while(++n<r){a[n]=e[n]<<1|e[n+1]>>7}return a}t.encrypt=function(e,t,r){var n=t.length;var a=i.allocUnsafe(n);var s=-1;while(++s<n){a[s]=encryptByte(e,t[s],r)}return a}},2430:function(e,t,r){var i=r(5055).Buffer;function encryptByte(e,t,r){var n=e._cipher.encryptBlock(e._prev);var a=n[0]^t;e._prev=i.concat([e._prev.slice(1),i.from([r?t:a])]);return a}t.encrypt=function(e,t,r){var n=t.length;var a=i.allocUnsafe(n);var s=-1;while(++s<n){a[s]=encryptByte(e,t[s],r)}return a}},3361:function(e,t,r){var i=r(4734);var n=r(5055).Buffer;var a=r(598);function getBlock(e){var t=e._cipher.encryptBlockRaw(e._prev);a(e._prev);return t}var s=16;t.encrypt=function(e,t){var r=Math.ceil(t.length/s);var a=e._cache.length;e._cache=n.concat([e._cache,n.allocUnsafe(r*s)]);for(var o=0;o<r;o++){var h=getBlock(e);var u=a+o*s;e._cache.writeUInt32BE(h[0],u+0);e._cache.writeUInt32BE(h[1],u+4);e._cache.writeUInt32BE(h[2],u+8);e._cache.writeUInt32BE(h[3],u+12)}var d=e._cache.slice(0,t.length);e._cache=e._cache.slice(t.length);return i(t,d)}},1590:function(e,t){t.encrypt=function(e,t){return e._cipher.encryptBlock(t)};t.decrypt=function(e,t){return e._cipher.decryptBlock(t)}},6370:function(e,t,r){var i={ECB:r(1590),CBC:r(9825),CFB:r(321),CFB8:r(2430),CFB1:r(3147),OFB:r(3412),CTR:r(3361),GCM:r(3361)};var n=r(5866);for(var a in n){n[a].module=i[n[a].mode]}e.exports=n},3412:function(e,t,r){var i=r(4734);function getBlock(e){e._prev=e._cipher.encryptBlock(e._prev);return e._prev}t.encrypt=function(e,t){while(e._cache.length<t.length){e._cache=Buffer.concat([e._cache,getBlock(e)])}var r=e._cache.slice(0,t.length);e._cache=e._cache.slice(t.length);return i(t,r)}},126:function(e,t,r){var i=r(1387);var n=r(5055).Buffer;var a=r(1043);var s=r(3782);function StreamCipher(e,t,r,s){a.call(this);this._cipher=new i.AES(t);this._prev=n.from(r);this._cache=n.allocUnsafe(0);this._secCache=n.allocUnsafe(0);this._decrypt=s;this._mode=e}s(StreamCipher,a);StreamCipher.prototype._update=function(e){return this._mode.encrypt(this,e,this._decrypt)};StreamCipher.prototype._final=function(){this._cipher.scrub()};e.exports=StreamCipher},8996:function(e,t,r){var i=r(5238);var n=r(6594);var a=r(6370);var s=r(6280);var o=r(8368);function createCipher(e,t){e=e.toLowerCase();var r,i;if(a[e]){r=a[e].key;i=a[e].iv}else if(s[e]){r=s[e].key*8;i=s[e].iv}else{throw new TypeError("invalid suite type")}var n=o(t,false,r,i);return createCipheriv(e,n.key,n.iv)}function createDecipher(e,t){e=e.toLowerCase();var r,i;if(a[e]){r=a[e].key;i=a[e].iv}else if(s[e]){r=s[e].key*8;i=s[e].iv}else{throw new TypeError("invalid suite type")}var n=o(t,false,r,i);return createDecipheriv(e,n.key,n.iv)}function createCipheriv(e,t,r){e=e.toLowerCase();if(a[e])return n.createCipheriv(e,t,r);if(s[e])return new i({key:t,iv:r,mode:e});throw new TypeError("invalid suite type")}function createDecipheriv(e,t,r){e=e.toLowerCase();if(a[e])return n.createDecipheriv(e,t,r);if(s[e])return new i({key:t,iv:r,mode:e,decrypt:true});throw new TypeError("invalid suite type")}function getCiphers(){return Object.keys(s).concat(n.getCiphers())}t.createCipher=t.Cipher=createCipher;t.createCipheriv=t.Cipheriv=createCipheriv;t.createDecipher=t.Decipher=createDecipher;t.createDecipheriv=t.Decipheriv=createDecipheriv;t.listCiphers=t.getCiphers=getCiphers},5238:function(e,t,r){var i=r(1043);var n=r(9536);var a=r(3782);var s=r(5055).Buffer;var o={"des-ede3-cbc":n.CBC.instantiate(n.EDE),"des-ede3":n.EDE,"des-ede-cbc":n.CBC.instantiate(n.EDE),"des-ede":n.EDE,"des-cbc":n.CBC.instantiate(n.DES),"des-ecb":n.DES};o.des=o["des-cbc"];o.des3=o["des-ede3-cbc"];e.exports=DES;a(DES,i);function DES(e){i.call(this);var t=e.mode.toLowerCase();var r=o[t];var n;if(e.decrypt){n="decrypt"}else{n="encrypt"}var a=e.key;if(!s.isBuffer(a)){a=s.from(a)}if(t==="des-ede"||t==="des-ede-cbc"){a=s.concat([a,a.slice(0,8)])}var h=e.iv;if(!s.isBuffer(h)){h=s.from(h)}this._des=r.create({key:a,iv:h,type:n})}DES.prototype._update=function(e){return s.from(this._des.update(e))};DES.prototype._final=function(){return s.from(this._des.final())}},6280:function(e,t){t["des-ecb"]={key:8,iv:0};t["des-cbc"]=t.des={key:8,iv:8};t["des-ede3-cbc"]=t.des3={key:24,iv:8};t["des-ede3"]={key:24,iv:0};t["des-ede-cbc"]={key:16,iv:8};t["des-ede"]={key:16,iv:0}},7166:function(e,t,r){var i=r(711);var n=r(7223);e.exports=crt;function blind(e){var t=getr(e);var r=t.toRed(i.mont(e.modulus)).redPow(new i(e.publicExponent)).fromRed();return{blinder:r,unblinder:t.invm(e.modulus)}}function crt(e,t){var r=blind(t);var n=t.modulus.byteLength();var a=i.mont(t.modulus);var s=new i(e).mul(r.blinder).umod(t.modulus);var o=s.toRed(i.mont(t.prime1));var h=s.toRed(i.mont(t.prime2));var u=t.coefficient;var d=t.prime1;var c=t.prime2;var l=o.redPow(t.exponent1);var p=h.redPow(t.exponent2);l=l.fromRed();p=p.fromRed();var v=l.isub(p).imul(u).umod(d);v.imul(c);p.iadd(v);return new Buffer(p.imul(r.unblinder).umod(t.modulus).toArray(false,n))}crt.getr=getr;function getr(e){var t=e.modulus.byteLength();var r=new i(n(t));while(r.cmp(e.modulus)>=0||!r.umod(e.prime1)||!r.umod(e.prime2)){r=new i(n(t))}return r}},9276:function(e,t,r){e.exports=r(2908)},4078:function(e,t,r){var i=r(5055).Buffer;var n=r(9739);var a=r(3726);var s=r(3782);var o=r(9807);var h=r(4013);var u=r(2908);Object.keys(u).forEach((function(e){u[e].id=i.from(u[e].id,"hex");u[e.toLowerCase()]=u[e]}));function Sign(e){a.Writable.call(this);var t=u[e];if(!t)throw new Error("Unknown message digest");this._hashType=t.hash;this._hash=n(t.hash);this._tag=t.id;this._signType=t.sign}s(Sign,a.Writable);Sign.prototype._write=function _write(e,t,r){this._hash.update(e);r()};Sign.prototype.update=function update(e,t){if(typeof e==="string")e=i.from(e,t);this._hash.update(e);return this};Sign.prototype.sign=function signMethod(e,t){this.end();var r=this._hash.digest();var i=o(r,e,this._hashType,this._signType,this._tag);return t?i.toString(t):i};function Verify(e){a.Writable.call(this);var t=u[e];if(!t)throw new Error("Unknown message digest");this._hash=n(t.hash);this._tag=t.id;this._signType=t.sign}s(Verify,a.Writable);Verify.prototype._write=function _write(e,t,r){this._hash.update(e);r()};Verify.prototype.update=function update(e,t){if(typeof e==="string")e=i.from(e,t);this._hash.update(e);return this};Verify.prototype.verify=function verifyMethod(e,t,r){if(typeof t==="string")t=i.from(t,r);this.end();var n=this._hash.digest();return h(t,n,e,this._signType,this._tag)};function createSign(e){return new Sign(e)}function createVerify(e){return new Verify(e)}e.exports={Sign:createSign,Verify:createVerify,createSign:createSign,createVerify:createVerify}},9807:function(e,t,r){var i=r(5055).Buffer;var n=r(4873);var a=r(7166);var s=r(949).ec;var o=r(1670);var h=r(9902);var u=r(9267);function sign(e,t,r,n,s){var o=h(t);if(o.curve){if(n!=="ecdsa"&&n!=="ecdsa/rsa")throw new Error("wrong private key type");return ecSign(e,o)}else if(o.type==="dsa"){if(n!=="dsa")throw new Error("wrong private key type");return dsaSign(e,o,r)}else{if(n!=="rsa"&&n!=="ecdsa/rsa")throw new Error("wrong private key type")}e=i.concat([s,e]);var u=o.modulus.byteLength();var d=[0,1];while(e.length+d.length+1<u)d.push(255);d.push(0);var c=-1;while(++c<e.length)d.push(e[c]);var l=a(d,o);return l}function ecSign(e,t){var r=u[t.curve.join(".")];if(!r)throw new Error("unknown curve "+t.curve.join("."));var n=new s(r);var a=n.keyFromPrivate(t.privateKey);var o=a.sign(e);return i.from(o.toDER())}function dsaSign(e,t,r){var i=t.params.priv_key;var n=t.params.p;var a=t.params.q;var s=t.params.g;var h=new o(0);var u;var d=bits2int(e,a).mod(a);var c=false;var l=getKey(i,a,e,r);while(c===false){u=makeKey(a,l,r);h=makeR(s,u,n,a);c=u.invm(a).imul(d.add(i.mul(h))).mod(a);if(c.cmpn(0)===0){c=false;h=new o(0)}}return toDER(h,c)}function toDER(e,t){e=e.toArray();t=t.toArray();if(e[0]&128)e=[0].concat(e);if(t[0]&128)t=[0].concat(t);var r=e.length+t.length+4;var n=[48,r,2,e.length];n=n.concat(e,[2,t.length],t);return i.from(n)}function getKey(e,t,r,a){e=i.from(e.toArray());if(e.length<t.byteLength()){var s=i.alloc(t.byteLength()-e.length);e=i.concat([s,e])}var o=r.length;var h=bits2octets(r,t);var u=i.alloc(o);u.fill(1);var d=i.alloc(o);d=n(a,d).update(u).update(i.from([0])).update(e).update(h).digest();u=n(a,d).update(u).digest();d=n(a,d).update(u).update(i.from([1])).update(e).update(h).digest();u=n(a,d).update(u).digest();return{k:d,v:u}}function bits2int(e,t){var r=new o(e);var i=(e.length<<3)-t.bitLength();if(i>0)r.ishrn(i);return r}function bits2octets(e,t){e=bits2int(e,t);e=e.mod(t);var r=i.from(e.toArray());if(r.length<t.byteLength()){var n=i.alloc(t.byteLength()-r.length);r=i.concat([n,r])}return r}function makeKey(e,t,r){var a;var s;do{a=i.alloc(0);while(a.length*8<e.bitLength()){t.v=n(r,t.k).update(t.v).digest();a=i.concat([a,t.v])}s=bits2int(a,e);t.k=n(r,t.k).update(t.v).update(i.from([0])).digest();t.v=n(r,t.k).update(t.v).digest()}while(s.cmp(e)!==-1);return s}function makeR(e,t,r,i){return e.toRed(o.mont(r)).redPow(t).fromRed().mod(i)}e.exports=sign;e.exports.getKey=getKey;e.exports.makeKey=makeKey},4013:function(e,t,r){var i=r(5055).Buffer;var n=r(1670);var a=r(949).ec;var s=r(9902);var o=r(9267);function verify(e,t,r,a,o){var h=s(r);if(h.type==="ec"){if(a!=="ecdsa"&&a!=="ecdsa/rsa")throw new Error("wrong public key type");return ecVerify(e,t,h)}else if(h.type==="dsa"){if(a!=="dsa")throw new Error("wrong public key type");return dsaVerify(e,t,h)}else{if(a!=="rsa"&&a!=="ecdsa/rsa")throw new Error("wrong public key type")}t=i.concat([o,t]);var u=h.modulus.byteLength();var d=[1];var c=0;while(t.length+d.length+2<u){d.push(255);c++}d.push(0);var l=-1;while(++l<t.length){d.push(t[l])}d=i.from(d);var p=n.mont(h.modulus);e=new n(e).toRed(p);e=e.redPow(new n(h.publicExponent));e=i.from(e.fromRed().toArray());var v=c<8?1:0;u=Math.min(e.length,d.length);if(e.length!==d.length)v=1;l=-1;while(++l<u)v|=e[l]^d[l];return v===0}function ecVerify(e,t,r){var i=o[r.data.algorithm.curve.join(".")];if(!i)throw new Error("unknown curve "+r.data.algorithm.curve.join("."));var n=new a(i);var s=r.data.subjectPrivateKey.data;return n.verify(t,e,s)}function dsaVerify(e,t,r){var i=r.data.p;var a=r.data.q;var o=r.data.g;var h=r.data.pub_key;var u=s.signature.decode(e,"der");var d=u.s;var c=u.r;checkValue(d,a);checkValue(c,a);var l=n.mont(i);var p=d.invm(a);var v=o.toRed(l).redPow(new n(t).mul(p).mod(a)).fromRed().mul(h.toRed(l).redPow(c.mul(p).mod(a)).fromRed()).mod(i).mod(a);return v.cmp(c)===0}function checkValue(e,t){if(e.cmpn(0)<=0)throw new Error("invalid sig");if(e.cmp(t)>=t)throw new Error("invalid sig")}e.exports=verify},4734:function(e){e.exports=function xor(e,t){var r=Math.min(e.length,t.length);var i=new Buffer(r);for(var n=0;n<r;++n){i[n]=e[n]^t[n]}return i}},1043:function(e,t,r){var i=r(5055).Buffer;var n=r(2781).Transform;var a=r(1576).StringDecoder;var s=r(3782);function CipherBase(e){n.call(this);this.hashMode=typeof e==="string";if(this.hashMode){this[e]=this._finalOrDigest}else{this.final=this._finalOrDigest}if(this._final){this.__final=this._final;this._final=null}this._decoder=null;this._encoding=null}s(CipherBase,n);CipherBase.prototype.update=function(e,t,r){if(typeof e==="string"){e=i.from(e,t)}var n=this._update(e);if(this.hashMode)return this;if(r){n=this._toString(n,r)}return n};CipherBase.prototype.setAutoPadding=function(){};CipherBase.prototype.getAuthTag=function(){throw new Error("trying to get auth tag in unsupported state")};CipherBase.prototype.setAuthTag=function(){throw new Error("trying to set auth tag in unsupported state")};CipherBase.prototype.setAAD=function(){throw new Error("trying to set aad in unsupported state")};CipherBase.prototype._transform=function(e,t,r){var i;try{if(this.hashMode){this._update(e)}else{this.push(this._update(e))}}catch(e){i=e}finally{r(i)}};CipherBase.prototype._flush=function(e){var t;try{this.push(this.__final())}catch(e){t=e}e(t)};CipherBase.prototype._finalOrDigest=function(e){var t=this.__final()||i.alloc(0);if(e){t=this._toString(t,e,true)}return t};CipherBase.prototype._toString=function(e,t,r){if(!this._decoder){this._decoder=new a(t);this._encoding=t}if(this._encoding!==t)throw new Error("can't switch encodings");var i=this._decoder.write(e);if(r){i+=this._decoder.end()}return i};e.exports=CipherBase},9942:function(e,t,r){var i=r(949);var n=r(711);e.exports=function createECDH(e){return new ECDH(e)};var a={secp256k1:{name:"secp256k1",byteLength:32},secp224r1:{name:"p224",byteLength:28},prime256v1:{name:"p256",byteLength:32},prime192v1:{name:"p192",byteLength:24},ed25519:{name:"ed25519",byteLength:32},secp384r1:{name:"p384",byteLength:48},secp521r1:{name:"p521",byteLength:66}};a.p224=a.secp224r1;a.p256=a.secp256r1=a.prime256v1;a.p192=a.secp192r1=a.prime192v1;a.p384=a.secp384r1;a.p521=a.secp521r1;function ECDH(e){this.curveType=a[e];if(!this.curveType){this.curveType={name:e}}this.curve=new i.ec(this.curveType.name);this.keys=void 0}ECDH.prototype.generateKeys=function(e,t){this.keys=this.curve.genKeyPair();return this.getPublicKey(e,t)};ECDH.prototype.computeSecret=function(e,t,r){t=t||"utf8";if(!Buffer.isBuffer(e)){e=new Buffer(e,t)}var i=this.curve.keyFromPublic(e).getPublic();var n=i.mul(this.keys.getPrivate()).getX();return formatReturnValue(n,r,this.curveType.byteLength)};ECDH.prototype.getPublicKey=function(e,t){var r=this.keys.getPublic(t==="compressed",true);if(t==="hybrid"){if(r[r.length-1]%2){r[0]=7}else{r[0]=6}}return formatReturnValue(r,e)};ECDH.prototype.getPrivateKey=function(e){return formatReturnValue(this.keys.getPrivate(),e)};ECDH.prototype.setPublicKey=function(e,t){t=t||"utf8";if(!Buffer.isBuffer(e)){e=new Buffer(e,t)}this.keys._importPublic(e);return this};ECDH.prototype.setPrivateKey=function(e,t){t=t||"utf8";if(!Buffer.isBuffer(e)){e=new Buffer(e,t)}var r=new n(e);r=r.toString(16);this.keys=this.curve.genKeyPair();this.keys._importPrivate(r);return this};function formatReturnValue(e,t,r){if(!Array.isArray(e)){e=e.toArray()}var i=new Buffer(e);if(r&&i.length<r){var n=new Buffer(r-i.length);n.fill(0);i=Buffer.concat([n,i])}if(!t){return i}else{return i.toString(t)}}},9739:function(e,t,r){"use strict";var i=r(3782);var n=r(3533);var a=r(3225);var s=r(4371);var o=r(1043);function Hash(e){o.call(this,"digest");this._hash=e}i(Hash,o);Hash.prototype._update=function(e){this._hash.update(e)};Hash.prototype._final=function(){return this._hash.digest()};e.exports=function createHash(e){e=e.toLowerCase();if(e==="md5")return new n;if(e==="rmd160"||e==="ripemd160")return new a;return new Hash(s(e))}},450:function(e,t,r){var i=r(3533);e.exports=function(e){return(new i).update(e).digest()}},4873:function(e,t,r){"use strict";var i=r(3782);var n=r(8119);var a=r(1043);var s=r(5055).Buffer;var o=r(450);var h=r(3225);var u=r(4371);var d=s.alloc(128);function Hmac(e,t){a.call(this,"digest");if(typeof t==="string"){t=s.from(t)}var r=e==="sha512"||e==="sha384"?128:64;this._alg=e;this._key=t;if(t.length>r){var i=e==="rmd160"?new h:u(e);t=i.update(t).digest()}else if(t.length<r){t=s.concat([t,d],r)}var n=this._ipad=s.allocUnsafe(r);var o=this._opad=s.allocUnsafe(r);for(var c=0;c<r;c++){n[c]=t[c]^54;o[c]=t[c]^92}this._hash=e==="rmd160"?new h:u(e);this._hash.update(n)}i(Hmac,a);Hmac.prototype._update=function(e){this._hash.update(e)};Hmac.prototype._final=function(){var e=this._hash.digest();var t=this._alg==="rmd160"?new h:u(this._alg);return t.update(this._opad).update(e).digest()};e.exports=function createHmac(e,t){e=e.toLowerCase();if(e==="rmd160"||e==="ripemd160"){return new Hmac("rmd160",t)}if(e==="md5"){return new n(o,t)}return new Hmac(e,t)}},8119:function(e,t,r){"use strict";var i=r(3782);var n=r(5055).Buffer;var a=r(1043);var s=n.alloc(128);var o=64;function Hmac(e,t){a.call(this,"digest");if(typeof t==="string"){t=n.from(t)}this._alg=e;this._key=t;if(t.length>o){t=e(t)}else if(t.length<o){t=n.concat([t,s],o)}var r=this._ipad=n.allocUnsafe(o);var i=this._opad=n.allocUnsafe(o);for(var h=0;h<o;h++){r[h]=t[h]^54;i[h]=t[h]^92}this._hash=[r]}i(Hmac,a);Hmac.prototype._update=function(e){this._hash.push(e)};Hmac.prototype._final=function(){var e=this._alg(n.concat(this._hash));return this._alg(n.concat([this._opad,e]))};e.exports=Hmac},9536:function(e,t,r){"use strict";t.utils=r(5334);t.Cipher=r(9876);t.DES=r(1016);t.CBC=r(8641);t.EDE=r(6159)},8641:function(e,t,r){"use strict";var i=r(3523);var n=r(3782);var a={};function CBCState(e){i.equal(e.length,8,"Invalid IV length");this.iv=new Array(8);for(var t=0;t<this.iv.length;t++)this.iv[t]=e[t]}function instantiate(e){function CBC(t){e.call(this,t);this._cbcInit()}n(CBC,e);var t=Object.keys(a);for(var r=0;r<t.length;r++){var i=t[r];CBC.prototype[i]=a[i]}CBC.create=function create(e){return new CBC(e)};return CBC}t.instantiate=instantiate;a._cbcInit=function _cbcInit(){var e=new CBCState(this.options.iv);this._cbcState=e};a._update=function _update(e,t,r,i){var n=this._cbcState;var a=this.constructor.super_.prototype;var s=n.iv;if(this.type==="encrypt"){for(var o=0;o<this.blockSize;o++)s[o]^=e[t+o];a._update.call(this,s,0,r,i);for(var o=0;o<this.blockSize;o++)s[o]=r[i+o]}else{a._update.call(this,e,t,r,i);for(var o=0;o<this.blockSize;o++)r[i+o]^=s[o];for(var o=0;o<this.blockSize;o++)s[o]=e[t+o]}}},9876:function(e,t,r){"use strict";var i=r(3523);function Cipher(e){this.options=e;this.type=this.options.type;this.blockSize=8;this._init();this.buffer=new Array(this.blockSize);this.bufferOff=0}e.exports=Cipher;Cipher.prototype._init=function _init(){};Cipher.prototype.update=function update(e){if(e.length===0)return[];if(this.type==="decrypt")return this._updateDecrypt(e);else return this._updateEncrypt(e)};Cipher.prototype._buffer=function _buffer(e,t){var r=Math.min(this.buffer.length-this.bufferOff,e.length-t);for(var i=0;i<r;i++)this.buffer[this.bufferOff+i]=e[t+i];this.bufferOff+=r;return r};Cipher.prototype._flushBuffer=function _flushBuffer(e,t){this._update(this.buffer,0,e,t);this.bufferOff=0;return this.blockSize};Cipher.prototype._updateEncrypt=function _updateEncrypt(e){var t=0;var r=0;var i=(this.bufferOff+e.length)/this.blockSize|0;var n=new Array(i*this.blockSize);if(this.bufferOff!==0){t+=this._buffer(e,t);if(this.bufferOff===this.buffer.length)r+=this._flushBuffer(n,r)}var a=e.length-(e.length-t)%this.blockSize;for(;t<a;t+=this.blockSize){this._update(e,t,n,r);r+=this.blockSize}for(;t<e.length;t++,this.bufferOff++)this.buffer[this.bufferOff]=e[t];return n};Cipher.prototype._updateDecrypt=function _updateDecrypt(e){var t=0;var r=0;var i=Math.ceil((this.bufferOff+e.length)/this.blockSize)-1;var n=new Array(i*this.blockSize);for(;i>0;i--){t+=this._buffer(e,t);r+=this._flushBuffer(n,r)}t+=this._buffer(e,t);return n};Cipher.prototype.final=function final(e){var t;if(e)t=this.update(e);var r;if(this.type==="encrypt")r=this._finalEncrypt();else r=this._finalDecrypt();if(t)return t.concat(r);else return r};Cipher.prototype._pad=function _pad(e,t){if(t===0)return false;while(t<e.length)e[t++]=0;return true};Cipher.prototype._finalEncrypt=function _finalEncrypt(){if(!this._pad(this.buffer,this.bufferOff))return[];var e=new Array(this.blockSize);this._update(this.buffer,0,e,0);return e};Cipher.prototype._unpad=function _unpad(e){return e};Cipher.prototype._finalDecrypt=function _finalDecrypt(){i.equal(this.bufferOff,this.blockSize,"Not enough data to decrypt");var e=new Array(this.blockSize);this._flushBuffer(e,0);return this._unpad(e)}},1016:function(e,t,r){"use strict";var i=r(3523);var n=r(3782);var a=r(5334);var s=r(9876);function DESState(){this.tmp=new Array(2);this.keys=null}function DES(e){s.call(this,e);var t=new DESState;this._desState=t;this.deriveKeys(t,e.key)}n(DES,s);e.exports=DES;DES.create=function create(e){return new DES(e)};var o=[1,1,2,2,2,2,2,2,1,2,2,2,2,2,2,1];DES.prototype.deriveKeys=function deriveKeys(e,t){e.keys=new Array(16*2);i.equal(t.length,this.blockSize,"Invalid key length");var r=a.readUInt32BE(t,0);var n=a.readUInt32BE(t,4);a.pc1(r,n,e.tmp,0);r=e.tmp[0];n=e.tmp[1];for(var s=0;s<e.keys.length;s+=2){var h=o[s>>>1];r=a.r28shl(r,h);n=a.r28shl(n,h);a.pc2(r,n,e.keys,s)}};DES.prototype._update=function _update(e,t,r,i){var n=this._desState;var s=a.readUInt32BE(e,t);var o=a.readUInt32BE(e,t+4);a.ip(s,o,n.tmp,0);s=n.tmp[0];o=n.tmp[1];if(this.type==="encrypt")this._encrypt(n,s,o,n.tmp,0);else this._decrypt(n,s,o,n.tmp,0);s=n.tmp[0];o=n.tmp[1];a.writeUInt32BE(r,s,i);a.writeUInt32BE(r,o,i+4)};DES.prototype._pad=function _pad(e,t){var r=e.length-t;for(var i=t;i<e.length;i++)e[i]=r;return true};DES.prototype._unpad=function _unpad(e){var t=e[e.length-1];for(var r=e.length-t;r<e.length;r++)i.equal(e[r],t);return e.slice(0,e.length-t)};DES.prototype._encrypt=function _encrypt(e,t,r,i,n){var s=t;var o=r;for(var h=0;h<e.keys.length;h+=2){var u=e.keys[h];var d=e.keys[h+1];a.expand(o,e.tmp,0);u^=e.tmp[0];d^=e.tmp[1];var c=a.substitute(u,d);var l=a.permute(c);var p=o;o=(s^l)>>>0;s=p}a.rip(o,s,i,n)};DES.prototype._decrypt=function _decrypt(e,t,r,i,n){var s=r;var o=t;for(var h=e.keys.length-2;h>=0;h-=2){var u=e.keys[h];var d=e.keys[h+1];a.expand(s,e.tmp,0);u^=e.tmp[0];d^=e.tmp[1];var c=a.substitute(u,d);var l=a.permute(c);var p=s;s=(o^l)>>>0;o=p}a.rip(s,o,i,n)}},6159:function(e,t,r){"use strict";var i=r(3523);var n=r(3782);var a=r(9876);var s=r(1016);function EDEState(e,t){i.equal(t.length,24,"Invalid key length");var r=t.slice(0,8);var n=t.slice(8,16);var a=t.slice(16,24);if(e==="encrypt"){this.ciphers=[s.create({type:"encrypt",key:r}),s.create({type:"decrypt",key:n}),s.create({type:"encrypt",key:a})]}else{this.ciphers=[s.create({type:"decrypt",key:a}),s.create({type:"encrypt",key:n}),s.create({type:"decrypt",key:r})]}}function EDE(e){a.call(this,e);var t=new EDEState(this.type,this.options.key);this._edeState=t}n(EDE,a);e.exports=EDE;EDE.create=function create(e){return new EDE(e)};EDE.prototype._update=function _update(e,t,r,i){var n=this._edeState;n.ciphers[0]._update(e,t,r,i);n.ciphers[1]._update(r,i,r,i);n.ciphers[2]._update(r,i,r,i)};EDE.prototype._pad=s.prototype._pad;EDE.prototype._unpad=s.prototype._unpad},5334:function(e,t){"use strict";t.readUInt32BE=function readUInt32BE(e,t){var r=e[0+t]<<24|e[1+t]<<16|e[2+t]<<8|e[3+t];return r>>>0};t.writeUInt32BE=function writeUInt32BE(e,t,r){e[0+r]=t>>>24;e[1+r]=t>>>16&255;e[2+r]=t>>>8&255;e[3+r]=t&255};t.ip=function ip(e,t,r,i){var n=0;var a=0;for(var s=6;s>=0;s-=2){for(var o=0;o<=24;o+=8){n<<=1;n|=t>>>o+s&1}for(var o=0;o<=24;o+=8){n<<=1;n|=e>>>o+s&1}}for(var s=6;s>=0;s-=2){for(var o=1;o<=25;o+=8){a<<=1;a|=t>>>o+s&1}for(var o=1;o<=25;o+=8){a<<=1;a|=e>>>o+s&1}}r[i+0]=n>>>0;r[i+1]=a>>>0};t.rip=function rip(e,t,r,i){var n=0;var a=0;for(var s=0;s<4;s++){for(var o=24;o>=0;o-=8){n<<=1;n|=t>>>o+s&1;n<<=1;n|=e>>>o+s&1}}for(var s=4;s<8;s++){for(var o=24;o>=0;o-=8){a<<=1;a|=t>>>o+s&1;a<<=1;a|=e>>>o+s&1}}r[i+0]=n>>>0;r[i+1]=a>>>0};t.pc1=function pc1(e,t,r,i){var n=0;var a=0;for(var s=7;s>=5;s--){for(var o=0;o<=24;o+=8){n<<=1;n|=t>>o+s&1}for(var o=0;o<=24;o+=8){n<<=1;n|=e>>o+s&1}}for(var o=0;o<=24;o+=8){n<<=1;n|=t>>o+s&1}for(var s=1;s<=3;s++){for(var o=0;o<=24;o+=8){a<<=1;a|=t>>o+s&1}for(var o=0;o<=24;o+=8){a<<=1;a|=e>>o+s&1}}for(var o=0;o<=24;o+=8){a<<=1;a|=e>>o+s&1}r[i+0]=n>>>0;r[i+1]=a>>>0};t.r28shl=function r28shl(e,t){return e<<t&268435455|e>>>28-t};var r=[14,11,17,4,27,23,25,0,13,22,7,18,5,9,16,24,2,20,12,21,1,8,15,26,15,4,25,19,9,1,26,16,5,11,23,8,12,7,17,0,22,3,10,14,6,20,27,24];t.pc2=function pc2(e,t,i,n){var a=0;var s=0;var o=r.length>>>1;for(var h=0;h<o;h++){a<<=1;a|=e>>>r[h]&1}for(var h=o;h<r.length;h++){s<<=1;s|=t>>>r[h]&1}i[n+0]=a>>>0;i[n+1]=s>>>0};t.expand=function expand(e,t,r){var i=0;var n=0;i=(e&1)<<5|e>>>27;for(var a=23;a>=15;a-=4){i<<=6;i|=e>>>a&63}for(var a=11;a>=3;a-=4){n|=e>>>a&63;n<<=6}n|=(e&31)<<1|e>>>31;t[r+0]=i>>>0;t[r+1]=n>>>0};var i=[14,0,4,15,13,7,1,4,2,14,15,2,11,13,8,1,3,10,10,6,6,12,12,11,5,9,9,5,0,3,7,8,4,15,1,12,14,8,8,2,13,4,6,9,2,1,11,7,15,5,12,11,9,3,7,14,3,10,10,0,5,6,0,13,15,3,1,13,8,4,14,7,6,15,11,2,3,8,4,14,9,12,7,0,2,1,13,10,12,6,0,9,5,11,10,5,0,13,14,8,7,10,11,1,10,3,4,15,13,4,1,2,5,11,8,6,12,7,6,12,9,0,3,5,2,14,15,9,10,13,0,7,9,0,14,9,6,3,3,4,15,6,5,10,1,2,13,8,12,5,7,14,11,12,4,11,2,15,8,1,13,1,6,10,4,13,9,0,8,6,15,9,3,8,0,7,11,4,1,15,2,14,12,3,5,11,10,5,14,2,7,12,7,13,13,8,14,11,3,5,0,6,6,15,9,0,10,3,1,4,2,7,8,2,5,12,11,1,12,10,4,14,15,9,10,3,6,15,9,0,0,6,12,10,11,1,7,13,13,8,15,9,1,4,3,5,14,11,5,12,2,7,8,2,4,14,2,14,12,11,4,2,1,12,7,4,10,7,11,13,6,1,8,5,5,0,3,15,15,10,13,3,0,9,14,8,9,6,4,11,2,8,1,12,11,7,10,1,13,14,7,2,8,13,15,6,9,15,12,0,5,9,6,10,3,4,0,5,14,3,12,10,1,15,10,4,15,2,9,7,2,12,6,9,8,5,0,6,13,1,3,13,4,14,14,0,7,11,5,3,11,8,9,4,14,3,15,2,5,12,2,9,8,5,12,15,3,10,7,11,0,14,4,1,10,7,1,6,13,0,11,8,6,13,4,13,11,0,2,11,14,7,15,4,0,9,8,1,13,10,3,14,12,3,9,5,7,12,5,2,10,15,6,8,1,6,1,6,4,11,11,13,13,8,12,1,3,4,7,10,14,7,10,9,15,5,6,0,8,15,0,14,5,2,9,3,2,12,13,1,2,15,8,13,4,8,6,10,15,3,11,7,1,4,10,12,9,5,3,6,14,11,5,0,0,14,12,9,7,2,7,2,11,1,4,14,1,7,9,4,12,10,14,8,2,13,0,15,6,12,10,9,13,0,15,3,3,5,5,6,8,11];t.substitute=function substitute(e,t){var r=0;for(var n=0;n<4;n++){var a=e>>>18-n*6&63;var s=i[n*64+a];r<<=4;r|=s}for(var n=0;n<4;n++){var a=t>>>18-n*6&63;var s=i[4*64+n*64+a];r<<=4;r|=s}return r>>>0};var n=[16,25,12,11,3,20,4,15,31,17,9,6,27,14,1,22,30,24,8,18,0,5,29,23,13,19,2,26,10,21,28,7];t.permute=function permute(e){var t=0;for(var r=0;r<n.length;r++){t<<=1;t|=e>>>n[r]&1}return t>>>0};t.padSplit=function padSplit(e,t,r){var i=e.toString(2);while(i.length<t)i="0"+i;var n=[];for(var a=0;a<t;a+=r)n.push(i.slice(a,a+r));return n.join(" ")}},6587:function(e,t,r){var i=r(296);var n=r(7992);var a=r(373);function getDiffieHellman(e){var t=new Buffer(n[e].prime,"hex");var r=new Buffer(n[e].gen,"hex");return new a(t,r)}var s={binary:true,hex:true,base64:true};function createDiffieHellman(e,t,r,n){if(Buffer.isBuffer(t)||s[t]===undefined){return createDiffieHellman(e,"binary",t,r)}t=t||"binary";n=n||"binary";r=r||new Buffer([2]);if(!Buffer.isBuffer(r)){r=new Buffer(r,n)}if(typeof e==="number"){return new a(i(e,r),r,true)}if(!Buffer.isBuffer(e)){e=new Buffer(e,t)}return new a(e,r,true)}t.DiffieHellmanGroup=t.createDiffieHellmanGroup=t.getDiffieHellman=getDiffieHellman;t.createDiffieHellman=t.DiffieHellman=createDiffieHellman},373:function(e,t,r){var i=r(711);var n=r(1354);var a=new n;var s=new i(24);var o=new i(11);var h=new i(10);var u=new i(3);var d=new i(7);var c=r(296);var l=r(7223);e.exports=DH;function setPublicKey(e,t){t=t||"utf8";if(!Buffer.isBuffer(e)){e=new Buffer(e,t)}this._pub=new i(e);return this}function setPrivateKey(e,t){t=t||"utf8";if(!Buffer.isBuffer(e)){e=new Buffer(e,t)}this._priv=new i(e);return this}var p={};function checkPrime(e,t){var r=t.toString("hex");var i=[r,e.toString(16)].join("_");if(i in p){return p[i]}var n=0;if(e.isEven()||!c.simpleSieve||!c.fermatTest(e)||!a.test(e)){n+=1;if(r==="02"||r==="05"){n+=8}else{n+=4}p[i]=n;return n}if(!a.test(e.shrn(1))){n+=2}var l;switch(r){case"02":if(e.mod(s).cmp(o)){n+=8}break;case"05":l=e.mod(h);if(l.cmp(u)&&l.cmp(d)){n+=8}break;default:n+=4}p[i]=n;return n}function DH(e,t,r){this.setGenerator(t);this.__prime=new i(e);this._prime=i.mont(this.__prime);this._primeLen=e.length;this._pub=undefined;this._priv=undefined;this._primeCode=undefined;if(r){this.setPublicKey=setPublicKey;this.setPrivateKey=setPrivateKey}else{this._primeCode=8}}Object.defineProperty(DH.prototype,"verifyError",{enumerable:true,get:function(){if(typeof this._primeCode!=="number"){this._primeCode=checkPrime(this.__prime,this.__gen)}return this._primeCode}});DH.prototype.generateKeys=function(){if(!this._priv){this._priv=new i(l(this._primeLen))}this._pub=this._gen.toRed(this._prime).redPow(this._priv).fromRed();return this.getPublicKey()};DH.prototype.computeSecret=function(e){e=new i(e);e=e.toRed(this._prime);var t=e.redPow(this._priv).fromRed();var r=new Buffer(t.toArray());var n=this.getPrime();if(r.length<n.length){var a=new Buffer(n.length-r.length);a.fill(0);r=Buffer.concat([a,r])}return r};DH.prototype.getPublicKey=function getPublicKey(e){return formatReturnValue(this._pub,e)};DH.prototype.getPrivateKey=function getPrivateKey(e){return formatReturnValue(this._priv,e)};DH.prototype.getPrime=function(e){return formatReturnValue(this.__prime,e)};DH.prototype.getGenerator=function(e){return formatReturnValue(this._gen,e)};DH.prototype.setGenerator=function(e,t){t=t||"utf8";if(!Buffer.isBuffer(e)){e=new Buffer(e,t)}this.__gen=e;this._gen=new i(e);return this};function formatReturnValue(e,t){var r=new Buffer(e.toArray());if(!t){return r}else{return r.toString(t)}}},296:function(e,t,r){var i=r(7223);e.exports=findPrime;findPrime.simpleSieve=simpleSieve;findPrime.fermatTest=fermatTest;var n=r(711);var a=new n(24);var s=r(1354);var o=new s;var h=new n(1);var u=new n(2);var d=new n(5);var c=new n(16);var l=new n(8);var p=new n(10);var v=new n(3);var b=new n(7);var m=new n(11);var y=new n(4);var g=new n(12);var _=null;function _getPrimes(){if(_!==null)return _;var e=1048576;var t=[];t[0]=2;for(var r=1,i=3;i<e;i+=2){var n=Math.ceil(Math.sqrt(i));for(var a=0;a<r&&t[a]<=n;a++)if(i%t[a]===0)break;if(r!==a&&t[a]<=n)continue;t[r++]=i}_=t;return t}function simpleSieve(e){var t=_getPrimes();for(var r=0;r<t.length;r++)if(e.modn(t[r])===0){if(e.cmpn(t[r])===0){return true}else{return false}}return true}function fermatTest(e){var t=n.mont(e);return u.toRed(t).redPow(e.subn(1)).fromRed().cmpn(1)===0}function findPrime(e,t){if(e<16){if(t===2||t===5){return new n([140,123])}else{return new n([140,39])}}t=new n(t);var r,s;while(true){r=new n(i(Math.ceil(e/8)));while(r.bitLength()>e){r.ishrn(1)}if(r.isEven()){r.iadd(h)}if(!r.testn(1)){r.iadd(u)}if(!t.cmp(u)){while(r.mod(a).cmp(m)){r.iadd(y)}}else if(!t.cmp(d)){while(r.mod(p).cmp(v)){r.iadd(y)}}s=r.shrn(1);if(simpleSieve(s)&&simpleSieve(r)&&fermatTest(s)&&fermatTest(r)&&o.test(s)&&o.test(r)){return r}}}},949:function(e,t,r){"use strict";var i=t;i.version=r(2531).i8;i.utils=r(4401);i.rand=r(3500);i.curve=r(9359);i.curves=r(6226);i.ec=r(4088);i.eddsa=r(8511)},2727:function(e,t,r){"use strict";var i=r(711);var n=r(4401);var a=n.getNAF;var s=n.getJSF;var o=n.assert;function BaseCurve(e,t){this.type=e;this.p=new i(t.p,16);this.red=t.prime?i.red(t.prime):i.mont(this.p);this.zero=new i(0).toRed(this.red);this.one=new i(1).toRed(this.red);this.two=new i(2).toRed(this.red);this.n=t.n&&new i(t.n,16);this.g=t.g&&this.pointFromJSON(t.g,t.gRed);this._wnafT1=new Array(4);this._wnafT2=new Array(4);this._wnafT3=new Array(4);this._wnafT4=new Array(4);this._bitLength=this.n?this.n.bitLength():0;var r=this.n&&this.p.div(this.n);if(!r||r.cmpn(100)>0){this.redN=null}else{this._maxwellTrick=true;this.redN=this.n.toRed(this.red)}}e.exports=BaseCurve;BaseCurve.prototype.point=function point(){throw new Error("Not implemented")};BaseCurve.prototype.validate=function validate(){throw new Error("Not implemented")};BaseCurve.prototype._fixedNafMul=function _fixedNafMul(e,t){o(e.precomputed);var r=e._getDoubles();var i=a(t,1,this._bitLength);var n=(1<<r.step+1)-(r.step%2===0?2:1);n/=3;var s=[];for(var h=0;h<i.length;h+=r.step){var u=0;for(var t=h+r.step-1;t>=h;t--)u=(u<<1)+i[t];s.push(u)}var d=this.jpoint(null,null,null);var c=this.jpoint(null,null,null);for(var l=n;l>0;l--){for(var h=0;h<s.length;h++){var u=s[h];if(u===l)c=c.mixedAdd(r.points[h]);else if(u===-l)c=c.mixedAdd(r.points[h].neg())}d=d.add(c)}return d.toP()};BaseCurve.prototype._wnafMul=function _wnafMul(e,t){var r=4;var i=e._getNAFPoints(r);r=i.wnd;var n=i.points;var s=a(t,r,this._bitLength);var h=this.jpoint(null,null,null);for(var u=s.length-1;u>=0;u--){for(var t=0;u>=0&&s[u]===0;u--)t++;if(u>=0)t++;h=h.dblp(t);if(u<0)break;var d=s[u];o(d!==0);if(e.type==="affine"){if(d>0)h=h.mixedAdd(n[d-1>>1]);else h=h.mixedAdd(n[-d-1>>1].neg())}else{if(d>0)h=h.add(n[d-1>>1]);else h=h.add(n[-d-1>>1].neg())}}return e.type==="affine"?h.toP():h};BaseCurve.prototype._wnafMulAdd=function _wnafMulAdd(e,t,r,i,n){var o=this._wnafT1;var h=this._wnafT2;var u=this._wnafT3;var d=0;for(var c=0;c<i;c++){var l=t[c];var p=l._getNAFPoints(e);o[c]=p.wnd;h[c]=p.points}for(var c=i-1;c>=1;c-=2){var v=c-1;var b=c;if(o[v]!==1||o[b]!==1){u[v]=a(r[v],o[v],this._bitLength);u[b]=a(r[b],o[b],this._bitLength);d=Math.max(u[v].length,d);d=Math.max(u[b].length,d);continue}var m=[t[v],null,null,t[b]];if(t[v].y.cmp(t[b].y)===0){m[1]=t[v].add(t[b]);m[2]=t[v].toJ().mixedAdd(t[b].neg())}else if(t[v].y.cmp(t[b].y.redNeg())===0){m[1]=t[v].toJ().mixedAdd(t[b]);m[2]=t[v].add(t[b].neg())}else{m[1]=t[v].toJ().mixedAdd(t[b]);m[2]=t[v].toJ().mixedAdd(t[b].neg())}var y=[-3,-1,-5,-7,0,7,5,1,3];var g=s(r[v],r[b]);d=Math.max(g[0].length,d);u[v]=new Array(d);u[b]=new Array(d);for(var _=0;_<d;_++){var w=g[0][_]|0;var M=g[1][_]|0;u[v][_]=y[(w+1)*3+(M+1)];u[b][_]=0;h[v]=m}}var B=this.jpoint(null,null,null);var E=this._wnafT4;for(var c=d;c>=0;c--){var k=0;while(c>=0){var A=true;for(var _=0;_<i;_++){E[_]=u[_][c]|0;if(E[_]!==0)A=false}if(!A)break;k++;c--}if(c>=0)k++;B=B.dblp(k);if(c<0)break;for(var _=0;_<i;_++){var N=E[_];var l;if(N===0)continue;else if(N>0)l=h[_][N-1>>1];else if(N<0)l=h[_][-N-1>>1].neg();if(l.type==="affine")B=B.mixedAdd(l);else B=B.add(l)}}for(var c=0;c<i;c++)h[c]=null;if(n)return B;else return B.toP()};function BasePoint(e,t){this.curve=e;this.type=t;this.precomputed=null}BaseCurve.BasePoint=BasePoint;BasePoint.prototype.eq=function eq(){throw new Error("Not implemented")};BasePoint.prototype.validate=function validate(){return this.curve.validate(this)};BaseCurve.prototype.decodePoint=function decodePoint(e,t){e=n.toArray(e,t);var r=this.p.byteLength();if((e[0]===4||e[0]===6||e[0]===7)&&e.length-1===2*r){if(e[0]===6)o(e[e.length-1]%2===0);else if(e[0]===7)o(e[e.length-1]%2===1);var i=this.point(e.slice(1,1+r),e.slice(1+r,1+2*r));return i}else if((e[0]===2||e[0]===3)&&e.length-1===r){return this.pointFromX(e.slice(1,1+r),e[0]===3)}throw new Error("Unknown point format")};BasePoint.prototype.encodeCompressed=function encodeCompressed(e){return this.encode(e,true)};BasePoint.prototype._encode=function _encode(e){var t=this.curve.p.byteLength();var r=this.getX().toArray("be",t);if(e)return[this.getY().isEven()?2:3].concat(r);return[4].concat(r,this.getY().toArray("be",t))};BasePoint.prototype.encode=function encode(e,t){return n.encode(this._encode(t),e)};BasePoint.prototype.precompute=function precompute(e){if(this.precomputed)return this;var t={doubles:null,naf:null,beta:null};t.naf=this._getNAFPoints(8);t.doubles=this._getDoubles(4,e);t.beta=this._getBeta();this.precomputed=t;return this};BasePoint.prototype._hasDoubles=function _hasDoubles(e){if(!this.precomputed)return false;var t=this.precomputed.doubles;if(!t)return false;return t.points.length>=Math.ceil((e.bitLength()+1)/t.step)};BasePoint.prototype._getDoubles=function _getDoubles(e,t){if(this.precomputed&&this.precomputed.doubles)return this.precomputed.doubles;var r=[this];var i=this;for(var n=0;n<t;n+=e){for(var a=0;a<e;a++)i=i.dbl();r.push(i)}return{step:e,points:r}};BasePoint.prototype._getNAFPoints=function _getNAFPoints(e){if(this.precomputed&&this.precomputed.naf)return this.precomputed.naf;var t=[this];var r=(1<<e)-1;var i=r===1?null:this.dbl();for(var n=1;n<r;n++)t[n]=t[n-1].add(i);return{wnd:e,points:t}};BasePoint.prototype._getBeta=function _getBeta(){return null};BasePoint.prototype.dblp=function dblp(e){var t=this;for(var r=0;r<e;r++)t=t.dbl();return t}},2705:function(e,t,r){"use strict";var i=r(4401);var n=r(711);var a=r(3782);var s=r(2727);var o=i.assert;function EdwardsCurve(e){this.twisted=(e.a|0)!==1;this.mOneA=this.twisted&&(e.a|0)===-1;this.extended=this.mOneA;s.call(this,"edwards",e);this.a=new n(e.a,16).umod(this.red.m);this.a=this.a.toRed(this.red);this.c=new n(e.c,16).toRed(this.red);this.c2=this.c.redSqr();this.d=new n(e.d,16).toRed(this.red);this.dd=this.d.redAdd(this.d);o(!this.twisted||this.c.fromRed().cmpn(1)===0);this.oneC=(e.c|0)===1}a(EdwardsCurve,s);e.exports=EdwardsCurve;EdwardsCurve.prototype._mulA=function _mulA(e){if(this.mOneA)return e.redNeg();else return this.a.redMul(e)};EdwardsCurve.prototype._mulC=function _mulC(e){if(this.oneC)return e;else return this.c.redMul(e)};EdwardsCurve.prototype.jpoint=function jpoint(e,t,r,i){return this.point(e,t,r,i)};EdwardsCurve.prototype.pointFromX=function pointFromX(e,t){e=new n(e,16);if(!e.red)e=e.toRed(this.red);var r=e.redSqr();var i=this.c2.redSub(this.a.redMul(r));var a=this.one.redSub(this.c2.redMul(this.d).redMul(r));var s=i.redMul(a.redInvm());var o=s.redSqrt();if(o.redSqr().redSub(s).cmp(this.zero)!==0)throw new Error("invalid point");var h=o.fromRed().isOdd();if(t&&!h||!t&&h)o=o.redNeg();return this.point(e,o)};EdwardsCurve.prototype.pointFromY=function pointFromY(e,t){e=new n(e,16);if(!e.red)e=e.toRed(this.red);var r=e.redSqr();var i=r.redSub(this.c2);var a=r.redMul(this.d).redMul(this.c2).redSub(this.a);var s=i.redMul(a.redInvm());if(s.cmp(this.zero)===0){if(t)throw new Error("invalid point");else return this.point(this.zero,e)}var o=s.redSqrt();if(o.redSqr().redSub(s).cmp(this.zero)!==0)throw new Error("invalid point");if(o.fromRed().isOdd()!==t)o=o.redNeg();return this.point(o,e)};EdwardsCurve.prototype.validate=function validate(e){if(e.isInfinity())return true;e.normalize();var t=e.x.redSqr();var r=e.y.redSqr();var i=t.redMul(this.a).redAdd(r);var n=this.c2.redMul(this.one.redAdd(this.d.redMul(t).redMul(r)));return i.cmp(n)===0};function Point(e,t,r,i,a){s.BasePoint.call(this,e,"projective");if(t===null&&r===null&&i===null){this.x=this.curve.zero;this.y=this.curve.one;this.z=this.curve.one;this.t=this.curve.zero;this.zOne=true}else{this.x=new n(t,16);this.y=new n(r,16);this.z=i?new n(i,16):this.curve.one;this.t=a&&new n(a,16);if(!this.x.red)this.x=this.x.toRed(this.curve.red);if(!this.y.red)this.y=this.y.toRed(this.curve.red);if(!this.z.red)this.z=this.z.toRed(this.curve.red);if(this.t&&!this.t.red)this.t=this.t.toRed(this.curve.red);this.zOne=this.z===this.curve.one;if(this.curve.extended&&!this.t){this.t=this.x.redMul(this.y);if(!this.zOne)this.t=this.t.redMul(this.z.redInvm())}}}a(Point,s.BasePoint);EdwardsCurve.prototype.pointFromJSON=function pointFromJSON(e){return Point.fromJSON(this,e)};EdwardsCurve.prototype.point=function point(e,t,r,i){return new Point(this,e,t,r,i)};Point.fromJSON=function fromJSON(e,t){return new Point(e,t[0],t[1],t[2])};Point.prototype.inspect=function inspect(){if(this.isInfinity())return"<EC Point Infinity>";return"<EC Point x: "+this.x.fromRed().toString(16,2)+" y: "+this.y.fromRed().toString(16,2)+" z: "+this.z.fromRed().toString(16,2)+">"};Point.prototype.isInfinity=function isInfinity(){return this.x.cmpn(0)===0&&(this.y.cmp(this.z)===0||this.zOne&&this.y.cmp(this.curve.c)===0)};Point.prototype._extDbl=function _extDbl(){var e=this.x.redSqr();var t=this.y.redSqr();var r=this.z.redSqr();r=r.redIAdd(r);var i=this.curve._mulA(e);var n=this.x.redAdd(this.y).redSqr().redISub(e).redISub(t);var a=i.redAdd(t);var s=a.redSub(r);var o=i.redSub(t);var h=n.redMul(s);var u=a.redMul(o);var d=n.redMul(o);var c=s.redMul(a);return this.curve.point(h,u,c,d)};Point.prototype._projDbl=function _projDbl(){var e=this.x.redAdd(this.y).redSqr();var t=this.x.redSqr();var r=this.y.redSqr();var i;var n;var a;if(this.curve.twisted){var s=this.curve._mulA(t);var o=s.redAdd(r);if(this.zOne){i=e.redSub(t).redSub(r).redMul(o.redSub(this.curve.two));n=o.redMul(s.redSub(r));a=o.redSqr().redSub(o).redSub(o)}else{var h=this.z.redSqr();var u=o.redSub(h).redISub(h);i=e.redSub(t).redISub(r).redMul(u);n=o.redMul(s.redSub(r));a=o.redMul(u)}}else{var s=t.redAdd(r);var h=this.curve._mulC(this.z).redSqr();var u=s.redSub(h).redSub(h);i=this.curve._mulC(e.redISub(s)).redMul(u);n=this.curve._mulC(s).redMul(t.redISub(r));a=s.redMul(u)}return this.curve.point(i,n,a)};Point.prototype.dbl=function dbl(){if(this.isInfinity())return this;if(this.curve.extended)return this._extDbl();else return this._projDbl()};Point.prototype._extAdd=function _extAdd(e){var t=this.y.redSub(this.x).redMul(e.y.redSub(e.x));var r=this.y.redAdd(this.x).redMul(e.y.redAdd(e.x));var i=this.t.redMul(this.curve.dd).redMul(e.t);var n=this.z.redMul(e.z.redAdd(e.z));var a=r.redSub(t);var s=n.redSub(i);var o=n.redAdd(i);var h=r.redAdd(t);var u=a.redMul(s);var d=o.redMul(h);var c=a.redMul(h);var l=s.redMul(o);return this.curve.point(u,d,l,c)};Point.prototype._projAdd=function _projAdd(e){var t=this.z.redMul(e.z);var r=t.redSqr();var i=this.x.redMul(e.x);var n=this.y.redMul(e.y);var a=this.curve.d.redMul(i).redMul(n);var s=r.redSub(a);var o=r.redAdd(a);var h=this.x.redAdd(this.y).redMul(e.x.redAdd(e.y)).redISub(i).redISub(n);var u=t.redMul(s).redMul(h);var d;var c;if(this.curve.twisted){d=t.redMul(o).redMul(n.redSub(this.curve._mulA(i)));c=s.redMul(o)}else{d=t.redMul(o).redMul(n.redSub(i));c=this.curve._mulC(s).redMul(o)}return this.curve.point(u,d,c)};Point.prototype.add=function add(e){if(this.isInfinity())return e;if(e.isInfinity())return this;if(this.curve.extended)return this._extAdd(e);else return this._projAdd(e)};Point.prototype.mul=function mul(e){if(this._hasDoubles(e))return this.curve._fixedNafMul(this,e);else return this.curve._wnafMul(this,e)};Point.prototype.mulAdd=function mulAdd(e,t,r){return this.curve._wnafMulAdd(1,[this,t],[e,r],2,false)};Point.prototype.jmulAdd=function jmulAdd(e,t,r){return this.curve._wnafMulAdd(1,[this,t],[e,r],2,true)};Point.prototype.normalize=function normalize(){if(this.zOne)return this;var e=this.z.redInvm();this.x=this.x.redMul(e);this.y=this.y.redMul(e);if(this.t)this.t=this.t.redMul(e);this.z=this.curve.one;this.zOne=true;return this};Point.prototype.neg=function neg(){return this.curve.point(this.x.redNeg(),this.y,this.z,this.t&&this.t.redNeg())};Point.prototype.getX=function getX(){this.normalize();return this.x.fromRed()};Point.prototype.getY=function getY(){this.normalize();return this.y.fromRed()};Point.prototype.eq=function eq(e){return this===e||this.getX().cmp(e.getX())===0&&this.getY().cmp(e.getY())===0};Point.prototype.eqXToP=function eqXToP(e){var t=e.toRed(this.curve.red).redMul(this.z);if(this.x.cmp(t)===0)return true;var r=e.clone();var i=this.curve.redN.redMul(this.z);for(;;){r.iadd(this.curve.n);if(r.cmp(this.curve.p)>=0)return false;t.redIAdd(i);if(this.x.cmp(t)===0)return true}};Point.prototype.toP=Point.prototype.normalize;Point.prototype.mixedAdd=Point.prototype.add},9359:function(e,t,r){"use strict";var i=t;i.base=r(2727);i.short=r(4720);i.mont=r(6653);i.edwards=r(2705)},6653:function(e,t,r){"use strict";var i=r(711);var n=r(3782);var a=r(2727);var s=r(4401);function MontCurve(e){a.call(this,"mont",e);this.a=new i(e.a,16).toRed(this.red);this.b=new i(e.b,16).toRed(this.red);this.i4=new i(4).toRed(this.red).redInvm();this.two=new i(2).toRed(this.red);this.a24=this.i4.redMul(this.a.redAdd(this.two))}n(MontCurve,a);e.exports=MontCurve;MontCurve.prototype.validate=function validate(e){var t=e.normalize().x;var r=t.redSqr();var i=r.redMul(t).redAdd(r.redMul(this.a)).redAdd(t);var n=i.redSqrt();return n.redSqr().cmp(i)===0};function Point(e,t,r){a.BasePoint.call(this,e,"projective");if(t===null&&r===null){this.x=this.curve.one;this.z=this.curve.zero}else{this.x=new i(t,16);this.z=new i(r,16);if(!this.x.red)this.x=this.x.toRed(this.curve.red);if(!this.z.red)this.z=this.z.toRed(this.curve.red)}}n(Point,a.BasePoint);MontCurve.prototype.decodePoint=function decodePoint(e,t){return this.point(s.toArray(e,t),1)};MontCurve.prototype.point=function point(e,t){return new Point(this,e,t)};MontCurve.prototype.pointFromJSON=function pointFromJSON(e){return Point.fromJSON(this,e)};Point.prototype.precompute=function precompute(){};Point.prototype._encode=function _encode(){return this.getX().toArray("be",this.curve.p.byteLength())};Point.fromJSON=function fromJSON(e,t){return new Point(e,t[0],t[1]||e.one)};Point.prototype.inspect=function inspect(){if(this.isInfinity())return"<EC Point Infinity>";return"<EC Point x: "+this.x.fromRed().toString(16,2)+" z: "+this.z.fromRed().toString(16,2)+">"};Point.prototype.isInfinity=function isInfinity(){return this.z.cmpn(0)===0};Point.prototype.dbl=function dbl(){var e=this.x.redAdd(this.z);var t=e.redSqr();var r=this.x.redSub(this.z);var i=r.redSqr();var n=t.redSub(i);var a=t.redMul(i);var s=n.redMul(i.redAdd(this.curve.a24.redMul(n)));return this.curve.point(a,s)};Point.prototype.add=function add(){throw new Error("Not supported on Montgomery curve")};Point.prototype.diffAdd=function diffAdd(e,t){var r=this.x.redAdd(this.z);var i=this.x.redSub(this.z);var n=e.x.redAdd(e.z);var a=e.x.redSub(e.z);var s=a.redMul(r);var o=n.redMul(i);var h=t.z.redMul(s.redAdd(o).redSqr());var u=t.x.redMul(s.redISub(o).redSqr());return this.curve.point(h,u)};Point.prototype.mul=function mul(e){var t=e.clone();var r=this;var i=this.curve.point(null,null);var n=this;for(var a=[];t.cmpn(0)!==0;t.iushrn(1))a.push(t.andln(1));for(var s=a.length-1;s>=0;s--){if(a[s]===0){r=r.diffAdd(i,n);i=i.dbl()}else{i=r.diffAdd(i,n);r=r.dbl()}}return i};Point.prototype.mulAdd=function mulAdd(){throw new Error("Not supported on Montgomery curve")};Point.prototype.jumlAdd=function jumlAdd(){throw new Error("Not supported on Montgomery curve")};Point.prototype.eq=function eq(e){return this.getX().cmp(e.getX())===0};Point.prototype.normalize=function normalize(){this.x=this.x.redMul(this.z.redInvm());this.z=this.curve.one;return this};Point.prototype.getX=function getX(){this.normalize();return this.x.fromRed()}},4720:function(e,t,r){"use strict";var i=r(4401);var n=r(711);var a=r(3782);var s=r(2727);var o=i.assert;function ShortCurve(e){s.call(this,"short",e);this.a=new n(e.a,16).toRed(this.red);this.b=new n(e.b,16).toRed(this.red);this.tinv=this.two.redInvm();this.zeroA=this.a.fromRed().cmpn(0)===0;this.threeA=this.a.fromRed().sub(this.p).cmpn(-3)===0;this.endo=this._getEndomorphism(e);this._endoWnafT1=new Array(4);this._endoWnafT2=new Array(4)}a(ShortCurve,s);e.exports=ShortCurve;ShortCurve.prototype._getEndomorphism=function _getEndomorphism(e){if(!this.zeroA||!this.g||!this.n||this.p.modn(3)!==1)return;var t;var r;if(e.beta){t=new n(e.beta,16).toRed(this.red)}else{var i=this._getEndoRoots(this.p);t=i[0].cmp(i[1])<0?i[0]:i[1];t=t.toRed(this.red)}if(e.lambda){r=new n(e.lambda,16)}else{var a=this._getEndoRoots(this.n);if(this.g.mul(a[0]).x.cmp(this.g.x.redMul(t))===0){r=a[0]}else{r=a[1];o(this.g.mul(r).x.cmp(this.g.x.redMul(t))===0)}}var s;if(e.basis){s=e.basis.map((function(e){return{a:new n(e.a,16),b:new n(e.b,16)}}))}else{s=this._getEndoBasis(r)}return{beta:t,lambda:r,basis:s}};ShortCurve.prototype._getEndoRoots=function _getEndoRoots(e){var t=e===this.p?this.red:n.mont(e);var r=new n(2).toRed(t).redInvm();var i=r.redNeg();var a=new n(3).toRed(t).redNeg().redSqrt().redMul(r);var s=i.redAdd(a).fromRed();var o=i.redSub(a).fromRed();return[s,o]};ShortCurve.prototype._getEndoBasis=function _getEndoBasis(e){var t=this.n.ushrn(Math.floor(this.n.bitLength()/2));var r=e;var i=this.n.clone();var a=new n(1);var s=new n(0);var o=new n(0);var h=new n(1);var u;var d;var c;var l;var p;var v;var b;var m=0;var y;var g;while(r.cmpn(0)!==0){var _=i.div(r);y=i.sub(_.mul(r));g=o.sub(_.mul(a));var w=h.sub(_.mul(s));if(!c&&y.cmp(t)<0){u=b.neg();d=a;c=y.neg();l=g}else if(c&&++m===2){break}b=y;i=r;r=y;o=a;a=g;h=s;s=w}p=y.neg();v=g;var M=c.sqr().add(l.sqr());var B=p.sqr().add(v.sqr());if(B.cmp(M)>=0){p=u;v=d}if(c.negative){c=c.neg();l=l.neg()}if(p.negative){p=p.neg();v=v.neg()}return[{a:c,b:l},{a:p,b:v}]};ShortCurve.prototype._endoSplit=function _endoSplit(e){var t=this.endo.basis;var r=t[0];var i=t[1];var n=i.b.mul(e).divRound(this.n);var a=r.b.neg().mul(e).divRound(this.n);var s=n.mul(r.a);var o=a.mul(i.a);var h=n.mul(r.b);var u=a.mul(i.b);var d=e.sub(s).sub(o);var c=h.add(u).neg();return{k1:d,k2:c}};ShortCurve.prototype.pointFromX=function pointFromX(e,t){e=new n(e,16);if(!e.red)e=e.toRed(this.red);var r=e.redSqr().redMul(e).redIAdd(e.redMul(this.a)).redIAdd(this.b);var i=r.redSqrt();if(i.redSqr().redSub(r).cmp(this.zero)!==0)throw new Error("invalid point");var a=i.fromRed().isOdd();if(t&&!a||!t&&a)i=i.redNeg();return this.point(e,i)};ShortCurve.prototype.validate=function validate(e){if(e.inf)return true;var t=e.x;var r=e.y;var i=this.a.redMul(t);var n=t.redSqr().redMul(t).redIAdd(i).redIAdd(this.b);return r.redSqr().redISub(n).cmpn(0)===0};ShortCurve.prototype._endoWnafMulAdd=function _endoWnafMulAdd(e,t,r){var i=this._endoWnafT1;var n=this._endoWnafT2;for(var a=0;a<e.length;a++){var s=this._endoSplit(t[a]);var o=e[a];var h=o._getBeta();if(s.k1.negative){s.k1.ineg();o=o.neg(true)}if(s.k2.negative){s.k2.ineg();h=h.neg(true)}i[a*2]=o;i[a*2+1]=h;n[a*2]=s.k1;n[a*2+1]=s.k2}var u=this._wnafMulAdd(1,i,n,a*2,r);for(var d=0;d<a*2;d++){i[d]=null;n[d]=null}return u};function Point(e,t,r,i){s.BasePoint.call(this,e,"affine");if(t===null&&r===null){this.x=null;this.y=null;this.inf=true}else{this.x=new n(t,16);this.y=new n(r,16);if(i){this.x.forceRed(this.curve.red);this.y.forceRed(this.curve.red)}if(!this.x.red)this.x=this.x.toRed(this.curve.red);if(!this.y.red)this.y=this.y.toRed(this.curve.red);this.inf=false}}a(Point,s.BasePoint);ShortCurve.prototype.point=function point(e,t,r){return new Point(this,e,t,r)};ShortCurve.prototype.pointFromJSON=function pointFromJSON(e,t){return Point.fromJSON(this,e,t)};Point.prototype._getBeta=function _getBeta(){if(!this.curve.endo)return;var e=this.precomputed;if(e&&e.beta)return e.beta;var t=this.curve.point(this.x.redMul(this.curve.endo.beta),this.y);if(e){var r=this.curve;var endoMul=function(e){return r.point(e.x.redMul(r.endo.beta),e.y)};e.beta=t;t.precomputed={beta:null,naf:e.naf&&{wnd:e.naf.wnd,points:e.naf.points.map(endoMul)},doubles:e.doubles&&{step:e.doubles.step,points:e.doubles.points.map(endoMul)}}}return t};Point.prototype.toJSON=function toJSON(){if(!this.precomputed)return[this.x,this.y];return[this.x,this.y,this.precomputed&&{doubles:this.precomputed.doubles&&{step:this.precomputed.doubles.step,points:this.precomputed.doubles.points.slice(1)},naf:this.precomputed.naf&&{wnd:this.precomputed.naf.wnd,points:this.precomputed.naf.points.slice(1)}}]};Point.fromJSON=function fromJSON(e,t,r){if(typeof t==="string")t=JSON.parse(t);var i=e.point(t[0],t[1],r);if(!t[2])return i;function obj2point(t){return e.point(t[0],t[1],r)}var n=t[2];i.precomputed={beta:null,doubles:n.doubles&&{step:n.doubles.step,points:[i].concat(n.doubles.points.map(obj2point))},naf:n.naf&&{wnd:n.naf.wnd,points:[i].concat(n.naf.points.map(obj2point))}};return i};Point.prototype.inspect=function inspect(){if(this.isInfinity())return"<EC Point Infinity>";return"<EC Point x: "+this.x.fromRed().toString(16,2)+" y: "+this.y.fromRed().toString(16,2)+">"};Point.prototype.isInfinity=function isInfinity(){return this.inf};Point.prototype.add=function add(e){if(this.inf)return e;if(e.inf)return this;if(this.eq(e))return this.dbl();if(this.neg().eq(e))return this.curve.point(null,null);if(this.x.cmp(e.x)===0)return this.curve.point(null,null);var t=this.y.redSub(e.y);if(t.cmpn(0)!==0)t=t.redMul(this.x.redSub(e.x).redInvm());var r=t.redSqr().redISub(this.x).redISub(e.x);var i=t.redMul(this.x.redSub(r)).redISub(this.y);return this.curve.point(r,i)};Point.prototype.dbl=function dbl(){if(this.inf)return this;var e=this.y.redAdd(this.y);if(e.cmpn(0)===0)return this.curve.point(null,null);var t=this.curve.a;var r=this.x.redSqr();var i=e.redInvm();var n=r.redAdd(r).redIAdd(r).redIAdd(t).redMul(i);var a=n.redSqr().redISub(this.x.redAdd(this.x));var s=n.redMul(this.x.redSub(a)).redISub(this.y);return this.curve.point(a,s)};Point.prototype.getX=function getX(){return this.x.fromRed()};Point.prototype.getY=function getY(){return this.y.fromRed()};Point.prototype.mul=function mul(e){e=new n(e,16);if(this.isInfinity())return this;else if(this._hasDoubles(e))return this.curve._fixedNafMul(this,e);else if(this.curve.endo)return this.curve._endoWnafMulAdd([this],[e]);else return this.curve._wnafMul(this,e)};Point.prototype.mulAdd=function mulAdd(e,t,r){var i=[this,t];var n=[e,r];if(this.curve.endo)return this.curve._endoWnafMulAdd(i,n);else return this.curve._wnafMulAdd(1,i,n,2)};Point.prototype.jmulAdd=function jmulAdd(e,t,r){var i=[this,t];var n=[e,r];if(this.curve.endo)return this.curve._endoWnafMulAdd(i,n,true);else return this.curve._wnafMulAdd(1,i,n,2,true)};Point.prototype.eq=function eq(e){return this===e||this.inf===e.inf&&(this.inf||this.x.cmp(e.x)===0&&this.y.cmp(e.y)===0)};Point.prototype.neg=function neg(e){if(this.inf)return this;var t=this.curve.point(this.x,this.y.redNeg());if(e&&this.precomputed){var r=this.precomputed;var negate=function(e){return e.neg()};t.precomputed={naf:r.naf&&{wnd:r.naf.wnd,points:r.naf.points.map(negate)},doubles:r.doubles&&{step:r.doubles.step,points:r.doubles.points.map(negate)}}}return t};Point.prototype.toJ=function toJ(){if(this.inf)return this.curve.jpoint(null,null,null);var e=this.curve.jpoint(this.x,this.y,this.curve.one);return e};function JPoint(e,t,r,i){s.BasePoint.call(this,e,"jacobian");if(t===null&&r===null&&i===null){this.x=this.curve.one;this.y=this.curve.one;this.z=new n(0)}else{this.x=new n(t,16);this.y=new n(r,16);this.z=new n(i,16)}if(!this.x.red)this.x=this.x.toRed(this.curve.red);if(!this.y.red)this.y=this.y.toRed(this.curve.red);if(!this.z.red)this.z=this.z.toRed(this.curve.red);this.zOne=this.z===this.curve.one}a(JPoint,s.BasePoint);ShortCurve.prototype.jpoint=function jpoint(e,t,r){return new JPoint(this,e,t,r)};JPoint.prototype.toP=function toP(){if(this.isInfinity())return this.curve.point(null,null);var e=this.z.redInvm();var t=e.redSqr();var r=this.x.redMul(t);var i=this.y.redMul(t).redMul(e);return this.curve.point(r,i)};JPoint.prototype.neg=function neg(){return this.curve.jpoint(this.x,this.y.redNeg(),this.z)};JPoint.prototype.add=function add(e){if(this.isInfinity())return e;if(e.isInfinity())return this;var t=e.z.redSqr();var r=this.z.redSqr();var i=this.x.redMul(t);var n=e.x.redMul(r);var a=this.y.redMul(t.redMul(e.z));var s=e.y.redMul(r.redMul(this.z));var o=i.redSub(n);var h=a.redSub(s);if(o.cmpn(0)===0){if(h.cmpn(0)!==0)return this.curve.jpoint(null,null,null);else return this.dbl()}var u=o.redSqr();var d=u.redMul(o);var c=i.redMul(u);var l=h.redSqr().redIAdd(d).redISub(c).redISub(c);var p=h.redMul(c.redISub(l)).redISub(a.redMul(d));var v=this.z.redMul(e.z).redMul(o);return this.curve.jpoint(l,p,v)};JPoint.prototype.mixedAdd=function mixedAdd(e){if(this.isInfinity())return e.toJ();if(e.isInfinity())return this;var t=this.z.redSqr();var r=this.x;var i=e.x.redMul(t);var n=this.y;var a=e.y.redMul(t).redMul(this.z);var s=r.redSub(i);var o=n.redSub(a);if(s.cmpn(0)===0){if(o.cmpn(0)!==0)return this.curve.jpoint(null,null,null);else return this.dbl()}var h=s.redSqr();var u=h.redMul(s);var d=r.redMul(h);var c=o.redSqr().redIAdd(u).redISub(d).redISub(d);var l=o.redMul(d.redISub(c)).redISub(n.redMul(u));var p=this.z.redMul(s);return this.curve.jpoint(c,l,p)};JPoint.prototype.dblp=function dblp(e){if(e===0)return this;if(this.isInfinity())return this;if(!e)return this.dbl();if(this.curve.zeroA||this.curve.threeA){var t=this;for(var r=0;r<e;r++)t=t.dbl();return t}var i=this.curve.a;var n=this.curve.tinv;var a=this.x;var s=this.y;var o=this.z;var h=o.redSqr().redSqr();var u=s.redAdd(s);for(var r=0;r<e;r++){var d=a.redSqr();var c=u.redSqr();var l=c.redSqr();var p=d.redAdd(d).redIAdd(d).redIAdd(i.redMul(h));var v=a.redMul(c);var b=p.redSqr().redISub(v.redAdd(v));var m=v.redISub(b);var y=p.redMul(m);y=y.redIAdd(y).redISub(l);var g=u.redMul(o);if(r+1<e)h=h.redMul(l);a=b;o=g;u=y}return this.curve.jpoint(a,u.redMul(n),o)};JPoint.prototype.dbl=function dbl(){if(this.isInfinity())return this;if(this.curve.zeroA)return this._zeroDbl();else if(this.curve.threeA)return this._threeDbl();else return this._dbl()};JPoint.prototype._zeroDbl=function _zeroDbl(){var e;var t;var r;if(this.zOne){var i=this.x.redSqr();var n=this.y.redSqr();var a=n.redSqr();var s=this.x.redAdd(n).redSqr().redISub(i).redISub(a);s=s.redIAdd(s);var o=i.redAdd(i).redIAdd(i);var h=o.redSqr().redISub(s).redISub(s);var u=a.redIAdd(a);u=u.redIAdd(u);u=u.redIAdd(u);e=h;t=o.redMul(s.redISub(h)).redISub(u);r=this.y.redAdd(this.y)}else{var d=this.x.redSqr();var c=this.y.redSqr();var l=c.redSqr();var p=this.x.redAdd(c).redSqr().redISub(d).redISub(l);p=p.redIAdd(p);var v=d.redAdd(d).redIAdd(d);var b=v.redSqr();var m=l.redIAdd(l);m=m.redIAdd(m);m=m.redIAdd(m);e=b.redISub(p).redISub(p);t=v.redMul(p.redISub(e)).redISub(m);r=this.y.redMul(this.z);r=r.redIAdd(r)}return this.curve.jpoint(e,t,r)};JPoint.prototype._threeDbl=function _threeDbl(){var e;var t;var r;if(this.zOne){var i=this.x.redSqr();var n=this.y.redSqr();var a=n.redSqr();var s=this.x.redAdd(n).redSqr().redISub(i).redISub(a);s=s.redIAdd(s);var o=i.redAdd(i).redIAdd(i).redIAdd(this.curve.a);var h=o.redSqr().redISub(s).redISub(s);e=h;var u=a.redIAdd(a);u=u.redIAdd(u);u=u.redIAdd(u);t=o.redMul(s.redISub(h)).redISub(u);r=this.y.redAdd(this.y)}else{var d=this.z.redSqr();var c=this.y.redSqr();var l=this.x.redMul(c);var p=this.x.redSub(d).redMul(this.x.redAdd(d));p=p.redAdd(p).redIAdd(p);var v=l.redIAdd(l);v=v.redIAdd(v);var b=v.redAdd(v);e=p.redSqr().redISub(b);r=this.y.redAdd(this.z).redSqr().redISub(c).redISub(d);var m=c.redSqr();m=m.redIAdd(m);m=m.redIAdd(m);m=m.redIAdd(m);t=p.redMul(v.redISub(e)).redISub(m)}return this.curve.jpoint(e,t,r)};JPoint.prototype._dbl=function _dbl(){var e=this.curve.a;var t=this.x;var r=this.y;var i=this.z;var n=i.redSqr().redSqr();var a=t.redSqr();var s=r.redSqr();var o=a.redAdd(a).redIAdd(a).redIAdd(e.redMul(n));var h=t.redAdd(t);h=h.redIAdd(h);var u=h.redMul(s);var d=o.redSqr().redISub(u.redAdd(u));var c=u.redISub(d);var l=s.redSqr();l=l.redIAdd(l);l=l.redIAdd(l);l=l.redIAdd(l);var p=o.redMul(c).redISub(l);var v=r.redAdd(r).redMul(i);return this.curve.jpoint(d,p,v)};JPoint.prototype.trpl=function trpl(){if(!this.curve.zeroA)return this.dbl().add(this);var e=this.x.redSqr();var t=this.y.redSqr();var r=this.z.redSqr();var i=t.redSqr();var n=e.redAdd(e).redIAdd(e);var a=n.redSqr();var s=this.x.redAdd(t).redSqr().redISub(e).redISub(i);s=s.redIAdd(s);s=s.redAdd(s).redIAdd(s);s=s.redISub(a);var o=s.redSqr();var h=i.redIAdd(i);h=h.redIAdd(h);h=h.redIAdd(h);h=h.redIAdd(h);var u=n.redIAdd(s).redSqr().redISub(a).redISub(o).redISub(h);var d=t.redMul(u);d=d.redIAdd(d);d=d.redIAdd(d);var c=this.x.redMul(o).redISub(d);c=c.redIAdd(c);c=c.redIAdd(c);var l=this.y.redMul(u.redMul(h.redISub(u)).redISub(s.redMul(o)));l=l.redIAdd(l);l=l.redIAdd(l);l=l.redIAdd(l);var p=this.z.redAdd(s).redSqr().redISub(r).redISub(o);return this.curve.jpoint(c,l,p)};JPoint.prototype.mul=function mul(e,t){e=new n(e,t);return this.curve._wnafMul(this,e)};JPoint.prototype.eq=function eq(e){if(e.type==="affine")return this.eq(e.toJ());if(this===e)return true;var t=this.z.redSqr();var r=e.z.redSqr();if(this.x.redMul(r).redISub(e.x.redMul(t)).cmpn(0)!==0)return false;var i=t.redMul(this.z);var n=r.redMul(e.z);return this.y.redMul(n).redISub(e.y.redMul(i)).cmpn(0)===0};JPoint.prototype.eqXToP=function eqXToP(e){var t=this.z.redSqr();var r=e.toRed(this.curve.red).redMul(t);if(this.x.cmp(r)===0)return true;var i=e.clone();var n=this.curve.redN.redMul(t);for(;;){i.iadd(this.curve.n);if(i.cmp(this.curve.p)>=0)return false;r.redIAdd(n);if(this.x.cmp(r)===0)return true}};JPoint.prototype.inspect=function inspect(){if(this.isInfinity())return"<EC JPoint Infinity>";return"<EC JPoint x: "+this.x.toString(16,2)+" y: "+this.y.toString(16,2)+" z: "+this.z.toString(16,2)+">"};JPoint.prototype.isInfinity=function isInfinity(){return this.z.cmpn(0)===0}},6226:function(e,t,r){"use strict";var i=t;var n=r(7028);var a=r(9359);var s=r(4401);var o=s.assert;function PresetCurve(e){if(e.type==="short")this.curve=new a.short(e);else if(e.type==="edwards")this.curve=new a.edwards(e);else this.curve=new a.mont(e);this.g=this.curve.g;this.n=this.curve.n;this.hash=e.hash;o(this.g.validate(),"Invalid curve");o(this.g.mul(this.n).isInfinity(),"Invalid curve, G*N != O")}i.PresetCurve=PresetCurve;function defineCurve(e,t){Object.defineProperty(i,e,{configurable:true,enumerable:true,get:function(){var r=new PresetCurve(t);Object.defineProperty(i,e,{configurable:true,enumerable:true,value:r});return r}})}defineCurve("p192",{type:"short",prime:"p192",p:"ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",a:"ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",b:"64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",n:"ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",hash:n.sha256,gRed:false,g:["188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012","07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"]});defineCurve("p224",{type:"short",prime:"p224",p:"ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",a:"ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",b:"b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",n:"ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",hash:n.sha256,gRed:false,g:["b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21","bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"]});defineCurve("p256",{type:"short",prime:null,p:"ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",a:"ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",b:"5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",n:"ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",hash:n.sha256,gRed:false,g:["6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296","4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"]});defineCurve("p384",{type:"short",prime:null,p:"ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff "+"fffffffe ffffffff 00000000 00000000 ffffffff",a:"ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff "+"fffffffe ffffffff 00000000 00000000 fffffffc",b:"b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f "+"5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",n:"ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 "+"f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",hash:n.sha384,gRed:false,g:["aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 "+"5502f25d bf55296c 3a545e38 72760ab7","3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 "+"0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"]});defineCurve("p521",{type:"short",prime:null,p:"000001ff ffffffff ffffffff ffffffff ffffffff ffffffff "+"ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff "+"ffffffff ffffffff ffffffff ffffffff ffffffff",a:"000001ff ffffffff ffffffff ffffffff ffffffff ffffffff "+"ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff "+"ffffffff ffffffff ffffffff ffffffff fffffffc",b:"00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b "+"99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd "+"3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",n:"000001ff ffffffff ffffffff ffffffff ffffffff ffffffff "+"ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 "+"f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",hash:n.sha512,gRed:false,g:["000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 "+"053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 "+"a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66","00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 "+"579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 "+"3fad0761 353c7086 a272c240 88be9476 9fd16650"]});defineCurve("curve25519",{type:"mont",prime:"p25519",p:"7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",a:"76d06",b:"1",n:"1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",hash:n.sha256,gRed:false,g:["9"]});defineCurve("ed25519",{type:"edwards",prime:"p25519",p:"7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",a:"-1",c:"1",d:"52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",n:"1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",hash:n.sha256,gRed:false,g:["216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a","6666666666666666666666666666666666666666666666666666666666666658"]});var h;try{h=r(9702)}catch(e){h=undefined}defineCurve("secp256k1",{type:"short",prime:"k256",p:"ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",a:"0",b:"7",n:"ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",h:"1",hash:n.sha256,beta:"7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",lambda:"5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",basis:[{a:"3086d221a7d46bcde86c90e49284eb15",b:"-e4437ed6010e88286f547fa90abfe4c3"},{a:"114ca50f7a8e2f3f657c1108d9d44cfd8",b:"3086d221a7d46bcde86c90e49284eb15"}],gRed:false,g:["79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798","483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",h]})},4088:function(e,t,r){"use strict";var i=r(711);var n=r(4910);var a=r(4401);var s=r(6226);var o=r(3500);var h=a.assert;var u=r(4724);var d=r(7526);function EC(e){if(!(this instanceof EC))return new EC(e);if(typeof e==="string"){h(s.hasOwnProperty(e),"Unknown curve "+e);e=s[e]}if(e instanceof s.PresetCurve)e={curve:e};this.curve=e.curve.curve;this.n=this.curve.n;this.nh=this.n.ushrn(1);this.g=this.curve.g;this.g=e.curve.g;this.g.precompute(e.curve.n.bitLength()+1);this.hash=e.hash||e.curve.hash}e.exports=EC;EC.prototype.keyPair=function keyPair(e){return new u(this,e)};EC.prototype.keyFromPrivate=function keyFromPrivate(e,t){return u.fromPrivate(this,e,t)};EC.prototype.keyFromPublic=function keyFromPublic(e,t){return u.fromPublic(this,e,t)};EC.prototype.genKeyPair=function genKeyPair(e){if(!e)e={};var t=new n({hash:this.hash,pers:e.pers,persEnc:e.persEnc||"utf8",entropy:e.entropy||o(this.hash.hmacStrength),entropyEnc:e.entropy&&e.entropyEnc||"utf8",nonce:this.n.toArray()});var r=this.n.byteLength();var a=this.n.sub(new i(2));do{var s=new i(t.generate(r));if(s.cmp(a)>0)continue;s.iaddn(1);return this.keyFromPrivate(s)}while(true)};EC.prototype._truncateToN=function truncateToN(e,t){var r=e.byteLength()*8-this.n.bitLength();if(r>0)e=e.ushrn(r);if(!t&&e.cmp(this.n)>=0)return e.sub(this.n);else return e};EC.prototype.sign=function sign(e,t,r,a){if(typeof r==="object"){a=r;r=null}if(!a)a={};t=this.keyFromPrivate(t,r);e=this._truncateToN(new i(e,16));var s=this.n.byteLength();var o=t.getPrivate().toArray("be",s);var h=e.toArray("be",s);var u=new n({hash:this.hash,entropy:o,nonce:h,pers:a.pers,persEnc:a.persEnc||"utf8"});var c=this.n.sub(new i(1));for(var l=0;true;l++){var p=a.k?a.k(l):new i(u.generate(this.n.byteLength()));p=this._truncateToN(p,true);if(p.cmpn(1)<=0||p.cmp(c)>=0)continue;var v=this.g.mul(p);if(v.isInfinity())continue;var b=v.getX();var m=b.umod(this.n);if(m.cmpn(0)===0)continue;var y=p.invm(this.n).mul(m.mul(t.getPrivate()).iadd(e));y=y.umod(this.n);if(y.cmpn(0)===0)continue;var g=(v.getY().isOdd()?1:0)|(b.cmp(m)!==0?2:0);if(a.canonical&&y.cmp(this.nh)>0){y=this.n.sub(y);g^=1}return new d({r:m,s:y,recoveryParam:g})}};EC.prototype.verify=function verify(e,t,r,n){e=this._truncateToN(new i(e,16));r=this.keyFromPublic(r,n);t=new d(t,"hex");var a=t.r;var s=t.s;if(a.cmpn(1)<0||a.cmp(this.n)>=0)return false;if(s.cmpn(1)<0||s.cmp(this.n)>=0)return false;var o=s.invm(this.n);var h=o.mul(e).umod(this.n);var u=o.mul(a).umod(this.n);if(!this.curve._maxwellTrick){var c=this.g.mulAdd(h,r.getPublic(),u);if(c.isInfinity())return false;return c.getX().umod(this.n).cmp(a)===0}var c=this.g.jmulAdd(h,r.getPublic(),u);if(c.isInfinity())return false;return c.eqXToP(a)};EC.prototype.recoverPubKey=function(e,t,r,n){h((3&r)===r,"The recovery param is more than two bits");t=new d(t,n);var a=this.n;var s=new i(e);var o=t.r;var u=t.s;var c=r&1;var l=r>>1;if(o.cmp(this.curve.p.umod(this.curve.n))>=0&&l)throw new Error("Unable to find sencond key candinate");if(l)o=this.curve.pointFromX(o.add(this.curve.n),c);else o=this.curve.pointFromX(o,c);var p=t.r.invm(a);var v=a.sub(s).mul(p).umod(a);var b=u.mul(p).umod(a);return this.g.mulAdd(v,o,b)};EC.prototype.getKeyRecoveryParam=function(e,t,r,i){t=new d(t,i);if(t.recoveryParam!==null)return t.recoveryParam;for(var n=0;n<4;n++){var a;try{a=this.recoverPubKey(e,t,n)}catch(e){continue}if(a.eq(r))return n}throw new Error("Unable to find valid recovery factor")}},4724:function(e,t,r){"use strict";var i=r(711);var n=r(4401);var a=n.assert;function KeyPair(e,t){this.ec=e;this.priv=null;this.pub=null;if(t.priv)this._importPrivate(t.priv,t.privEnc);if(t.pub)this._importPublic(t.pub,t.pubEnc)}e.exports=KeyPair;KeyPair.fromPublic=function fromPublic(e,t,r){if(t instanceof KeyPair)return t;return new KeyPair(e,{pub:t,pubEnc:r})};KeyPair.fromPrivate=function fromPrivate(e,t,r){if(t instanceof KeyPair)return t;return new KeyPair(e,{priv:t,privEnc:r})};KeyPair.prototype.validate=function validate(){var e=this.getPublic();if(e.isInfinity())return{result:false,reason:"Invalid public key"};if(!e.validate())return{result:false,reason:"Public key is not a point"};if(!e.mul(this.ec.curve.n).isInfinity())return{result:false,reason:"Public key * N != O"};return{result:true,reason:null}};KeyPair.prototype.getPublic=function getPublic(e,t){if(typeof e==="string"){t=e;e=null}if(!this.pub)this.pub=this.ec.g.mul(this.priv);if(!t)return this.pub;return this.pub.encode(t,e)};KeyPair.prototype.getPrivate=function getPrivate(e){if(e==="hex")return this.priv.toString(16,2);else return this.priv};KeyPair.prototype._importPrivate=function _importPrivate(e,t){this.priv=new i(e,t||16);this.priv=this.priv.umod(this.ec.curve.n)};KeyPair.prototype._importPublic=function _importPublic(e,t){if(e.x||e.y){if(this.ec.curve.type==="mont"){a(e.x,"Need x coordinate")}else if(this.ec.curve.type==="short"||this.ec.curve.type==="edwards"){a(e.x&&e.y,"Need both x and y coordinate")}this.pub=this.ec.curve.point(e.x,e.y);return}this.pub=this.ec.curve.decodePoint(e,t)};KeyPair.prototype.derive=function derive(e){return e.mul(this.priv).getX()};KeyPair.prototype.sign=function sign(e,t,r){return this.ec.sign(e,this,t,r)};KeyPair.prototype.verify=function verify(e,t){return this.ec.verify(e,t,this)};KeyPair.prototype.inspect=function inspect(){return"<Key priv: "+(this.priv&&this.priv.toString(16,2))+" pub: "+(this.pub&&this.pub.inspect())+" >"}},7526:function(e,t,r){"use strict";var i=r(711);var n=r(4401);var a=n.assert;function Signature(e,t){if(e instanceof Signature)return e;if(this._importDER(e,t))return;a(e.r&&e.s,"Signature without r or s");this.r=new i(e.r,16);this.s=new i(e.s,16);if(e.recoveryParam===undefined)this.recoveryParam=null;else this.recoveryParam=e.recoveryParam}e.exports=Signature;function Position(){this.place=0}function getLength(e,t){var r=e[t.place++];if(!(r&128)){return r}var i=r&15;if(i===0||i>4){return false}var n=0;for(var a=0,s=t.place;a<i;a++,s++){n<<=8;n|=e[s];n>>>=0}if(n<=127){return false}t.place=s;return n}function rmPadding(e){var t=0;var r=e.length-1;while(!e[t]&&!(e[t+1]&128)&&t<r){t++}if(t===0){return e}return e.slice(t)}Signature.prototype._importDER=function _importDER(e,t){e=n.toArray(e,t);var r=new Position;if(e[r.place++]!==48){return false}var a=getLength(e,r);if(a===false){return false}if(a+r.place!==e.length){return false}if(e[r.place++]!==2){return false}var s=getLength(e,r);if(s===false){return false}var o=e.slice(r.place,s+r.place);r.place+=s;if(e[r.place++]!==2){return false}var h=getLength(e,r);if(h===false){return false}if(e.length!==h+r.place){return false}var u=e.slice(r.place,h+r.place);if(o[0]===0){if(o[1]&128){o=o.slice(1)}else{return false}}if(u[0]===0){if(u[1]&128){u=u.slice(1)}else{return false}}this.r=new i(o);this.s=new i(u);this.recoveryParam=null;return true};function constructLength(e,t){if(t<128){e.push(t);return}var r=1+(Math.log(t)/Math.LN2>>>3);e.push(r|128);while(--r){e.push(t>>>(r<<3)&255)}e.push(t)}Signature.prototype.toDER=function toDER(e){var t=this.r.toArray();var r=this.s.toArray();if(t[0]&128)t=[0].concat(t);if(r[0]&128)r=[0].concat(r);t=rmPadding(t);r=rmPadding(r);while(!r[0]&&!(r[1]&128)){r=r.slice(1)}var i=[2];constructLength(i,t.length);i=i.concat(t);i.push(2);constructLength(i,r.length);var a=i.concat(r);var s=[48];constructLength(s,a.length);s=s.concat(a);return n.encode(s,e)}},8511:function(e,t,r){"use strict";var i=r(7028);var n=r(6226);var a=r(4401);var s=a.assert;var o=a.parseBytes;var h=r(9917);var u=r(9314);function EDDSA(e){s(e==="ed25519","only tested with ed25519 so far");if(!(this instanceof EDDSA))return new EDDSA(e);var e=n[e].curve;this.curve=e;this.g=e.g;this.g.precompute(e.n.bitLength()+1);this.pointClass=e.point().constructor;this.encodingLength=Math.ceil(e.n.bitLength()/8);this.hash=i.sha512}e.exports=EDDSA;EDDSA.prototype.sign=function sign(e,t){e=o(e);var r=this.keyFromSecret(t);var i=this.hashInt(r.messagePrefix(),e);var n=this.g.mul(i);var a=this.encodePoint(n);var s=this.hashInt(a,r.pubBytes(),e).mul(r.priv());var h=i.add(s).umod(this.curve.n);return this.makeSignature({R:n,S:h,Rencoded:a})};EDDSA.prototype.verify=function verify(e,t,r){e=o(e);t=this.makeSignature(t);var i=this.keyFromPublic(r);var n=this.hashInt(t.Rencoded(),i.pubBytes(),e);var a=this.g.mul(t.S());var s=t.R().add(i.pub().mul(n));return s.eq(a)};EDDSA.prototype.hashInt=function hashInt(){var e=this.hash();for(var t=0;t<arguments.length;t++)e.update(arguments[t]);return a.intFromLE(e.digest()).umod(this.curve.n)};EDDSA.prototype.keyFromPublic=function keyFromPublic(e){return h.fromPublic(this,e)};EDDSA.prototype.keyFromSecret=function keyFromSecret(e){return h.fromSecret(this,e)};EDDSA.prototype.makeSignature=function makeSignature(e){if(e instanceof u)return e;return new u(this,e)};EDDSA.prototype.encodePoint=function encodePoint(e){var t=e.getY().toArray("le",this.encodingLength);t[this.encodingLength-1]|=e.getX().isOdd()?128:0;return t};EDDSA.prototype.decodePoint=function decodePoint(e){e=a.parseBytes(e);var t=e.length-1;var r=e.slice(0,t).concat(e[t]&~128);var i=(e[t]&128)!==0;var n=a.intFromLE(r);return this.curve.pointFromY(n,i)};EDDSA.prototype.encodeInt=function encodeInt(e){return e.toArray("le",this.encodingLength)};EDDSA.prototype.decodeInt=function decodeInt(e){return a.intFromLE(e)};EDDSA.prototype.isPoint=function isPoint(e){return e instanceof this.pointClass}},9917:function(e,t,r){"use strict";var i=r(4401);var n=i.assert;var a=i.parseBytes;var s=i.cachedProperty;function KeyPair(e,t){this.eddsa=e;this._secret=a(t.secret);if(e.isPoint(t.pub))this._pub=t.pub;else this._pubBytes=a(t.pub)}KeyPair.fromPublic=function fromPublic(e,t){if(t instanceof KeyPair)return t;return new KeyPair(e,{pub:t})};KeyPair.fromSecret=function fromSecret(e,t){if(t instanceof KeyPair)return t;return new KeyPair(e,{secret:t})};KeyPair.prototype.secret=function secret(){return this._secret};s(KeyPair,"pubBytes",(function pubBytes(){return this.eddsa.encodePoint(this.pub())}));s(KeyPair,"pub",(function pub(){if(this._pubBytes)return this.eddsa.decodePoint(this._pubBytes);return this.eddsa.g.mul(this.priv())}));s(KeyPair,"privBytes",(function privBytes(){var e=this.eddsa;var t=this.hash();var r=e.encodingLength-1;var i=t.slice(0,e.encodingLength);i[0]&=248;i[r]&=127;i[r]|=64;return i}));s(KeyPair,"priv",(function priv(){return this.eddsa.decodeInt(this.privBytes())}));s(KeyPair,"hash",(function hash(){return this.eddsa.hash().update(this.secret()).digest()}));s(KeyPair,"messagePrefix",(function messagePrefix(){return this.hash().slice(this.eddsa.encodingLength)}));KeyPair.prototype.sign=function sign(e){n(this._secret,"KeyPair can only verify");return this.eddsa.sign(e,this)};KeyPair.prototype.verify=function verify(e,t){return this.eddsa.verify(e,t,this)};KeyPair.prototype.getSecret=function getSecret(e){n(this._secret,"KeyPair is public only");return i.encode(this.secret(),e)};KeyPair.prototype.getPublic=function getPublic(e){return i.encode(this.pubBytes(),e)};e.exports=KeyPair},9314:function(e,t,r){"use strict";var i=r(711);var n=r(4401);var a=n.assert;var s=n.cachedProperty;var o=n.parseBytes;function Signature(e,t){this.eddsa=e;if(typeof t!=="object")t=o(t);if(Array.isArray(t)){t={R:t.slice(0,e.encodingLength),S:t.slice(e.encodingLength)}}a(t.R&&t.S,"Signature without R or S");if(e.isPoint(t.R))this._R=t.R;if(t.S instanceof i)this._S=t.S;this._Rencoded=Array.isArray(t.R)?t.R:t.Rencoded;this._Sencoded=Array.isArray(t.S)?t.S:t.Sencoded}s(Signature,"S",(function S(){return this.eddsa.decodeInt(this.Sencoded())}));s(Signature,"R",(function R(){return this.eddsa.decodePoint(this.Rencoded())}));s(Signature,"Rencoded",(function Rencoded(){return this.eddsa.encodePoint(this.R())}));s(Signature,"Sencoded",(function Sencoded(){return this.eddsa.encodeInt(this.S())}));Signature.prototype.toBytes=function toBytes(){return this.Rencoded().concat(this.Sencoded())};Signature.prototype.toHex=function toHex(){return n.encode(this.toBytes(),"hex").toUpperCase()};e.exports=Signature},9702:function(e){e.exports={doubles:{step:4,points:[["e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a","f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"],["8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508","11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"],["175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739","d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"],["363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640","4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"],["8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c","4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"],["723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda","96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"],["eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa","5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"],["100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0","cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"],["e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d","9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"],["feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d","e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"],["da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1","9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"],["53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0","5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"],["8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047","10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"],["385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862","283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"],["6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7","7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"],["3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd","56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"],["85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83","7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"],["948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a","53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"],["6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8","bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"],["e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d","4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"],["e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725","7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"],["213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754","4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"],["4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c","17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"],["fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6","6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"],["76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39","c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"],["c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891","893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"],["d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b","febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"],["b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03","2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"],["e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d","eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"],["a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070","7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"],["90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4","e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"],["8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da","662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"],["e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11","1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"],["8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e","efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"],["e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41","2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"],["b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef","67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"],["d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8","db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"],["324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d","648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"],["4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96","35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"],["9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd","ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"],["6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5","9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"],["a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266","40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"],["7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71","34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"],["928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac","c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"],["85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751","1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"],["ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e","493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"],["827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241","c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"],["eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3","be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"],["e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f","4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"],["1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19","aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"],["146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be","b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"],["fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9","6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"],["da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2","8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"],["a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13","7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"],["174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c","ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"],["959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba","2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"],["d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151","e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"],["64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073","d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"],["8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458","38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"],["13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b","69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"],["bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366","d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"],["8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa","40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"],["8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0","620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"],["dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787","7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"],["f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e","ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"]]},naf:{wnd:7,points:[["f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9","388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"],["2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4","d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"],["5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc","6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"],["acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe","cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"],["774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb","d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"],["f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8","ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"],["d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e","581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"],["defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34","4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"],["2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c","85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"],["352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5","321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"],["2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f","2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"],["9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714","73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"],["daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729","a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"],["c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db","2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"],["6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4","e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"],["1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5","b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"],["605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479","2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"],["62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d","80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"],["80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f","1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"],["7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb","d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"],["d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9","eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"],["49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963","758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"],["77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74","958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"],["f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530","e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"],["463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b","5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"],["f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247","cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"],["caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1","cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"],["2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120","4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"],["7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435","91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"],["754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18","673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"],["e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8","59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"],["186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb","3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"],["df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f","55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"],["5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143","efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"],["290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba","e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"],["af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45","f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"],["766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a","744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"],["59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e","c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"],["f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8","e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"],["7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c","30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"],["948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519","e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"],["7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab","100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"],["3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca","ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"],["d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf","8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"],["1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610","68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"],["733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4","f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"],["15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c","d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"],["a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940","edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"],["e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980","a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"],["311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3","66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"],["34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf","9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"],["f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63","4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"],["d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448","fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"],["32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf","5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"],["7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5","8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"],["ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6","8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"],["16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5","5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"],["eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99","f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"],["78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51","f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"],["494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5","42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"],["a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5","204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"],["c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997","4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"],["841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881","73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"],["5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5","39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"],["36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66","d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"],["336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726","ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"],["8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede","6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"],["1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94","60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"],["85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31","3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"],["29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51","b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"],["a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252","ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"],["4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5","cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"],["d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b","6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"],["ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4","322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"],["af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f","6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"],["e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889","2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"],["591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246","b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"],["11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984","998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"],["3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a","b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"],["cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030","bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"],["c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197","6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"],["c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593","c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"],["a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef","21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"],["347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38","60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"],["da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a","49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"],["c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111","5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"],["4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502","7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"],["3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea","be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"],["cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26","8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"],["b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986","39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"],["d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e","62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"],["48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4","25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"],["dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda","ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"],["6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859","cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"],["e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f","f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"],["eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c","6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"],["13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942","fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"],["ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a","1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"],["b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80","5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"],["ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d","438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"],["8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1","cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"],["52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63","c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"],["e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352","6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"],["7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193","ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"],["5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00","9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"],["32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58","ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"],["e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7","d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"],["8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8","c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"],["4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e","67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"],["3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d","cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"],["674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b","299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"],["d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f","f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"],["30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6","462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"],["be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297","62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"],["93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a","7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"],["b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c","ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"],["d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52","4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"],["d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb","bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"],["463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065","bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"],["7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917","603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"],["74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9","cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"],["30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3","553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"],["9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57","712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"],["176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66","ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"],["75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8","9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"],["809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721","9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"],["1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180","4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"]]}}},4401:function(e,t,r){"use strict";var i=t;var n=r(711);var a=r(3523);var s=r(6545);i.assert=a;i.toArray=s.toArray;i.zero2=s.zero2;i.toHex=s.toHex;i.encode=s.encode;function getNAF(e,t,r){var i=new Array(Math.max(e.bitLength(),r)+1);i.fill(0);var n=1<<t+1;var a=e.clone();for(var s=0;s<i.length;s++){var o;var h=a.andln(n-1);if(a.isOdd()){if(h>(n>>1)-1)o=(n>>1)-h;else o=h;a.isubn(o)}else{o=0}i[s]=o;a.iushrn(1)}return i}i.getNAF=getNAF;function getJSF(e,t){var r=[[],[]];e=e.clone();t=t.clone();var i=0;var n=0;while(e.cmpn(-i)>0||t.cmpn(-n)>0){var a=e.andln(3)+i&3;var s=t.andln(3)+n&3;if(a===3)a=-1;if(s===3)s=-1;var o;if((a&1)===0){o=0}else{var h=e.andln(7)+i&7;if((h===3||h===5)&&s===2)o=-a;else o=a}r[0].push(o);var u;if((s&1)===0){u=0}else{var h=t.andln(7)+n&7;if((h===3||h===5)&&a===2)u=-s;else u=s}r[1].push(u);if(2*i===o+1)i=1-i;if(2*n===u+1)n=1-n;e.iushrn(1);t.iushrn(1)}return r}i.getJSF=getJSF;function cachedProperty(e,t,r){var i="_"+t;e.prototype[t]=function cachedProperty(){return this[i]!==undefined?this[i]:this[i]=r.call(this)}}i.cachedProperty=cachedProperty;function parseBytes(e){return typeof e==="string"?i.toArray(e,"hex"):e}i.parseBytes=parseBytes;function intFromLE(e){return new n(e,"hex","le")}i.intFromLE=intFromLE},8368:function(e,t,r){var i=r(5055).Buffer;var n=r(3533);function EVP_BytesToKey(e,t,r,a){if(!i.isBuffer(e))e=i.from(e,"binary");if(t){if(!i.isBuffer(t))t=i.from(t,"binary");if(t.length!==8)throw new RangeError("salt should be Buffer with 8 byte length")}var s=r/8;var o=i.alloc(s);var h=i.alloc(a||0);var u=i.alloc(0);while(s>0||a>0){var d=new n;d.update(u);d.update(e);if(t)d.update(t);u=d.digest();var c=0;if(s>0){var l=o.length-s;c=Math.min(s,u.length);u.copy(o,l,0,c);s-=c}if(c<u.length&&a>0){var p=h.length-a;var v=Math.min(a,u.length-c);u.copy(h,p,c,c+v);a-=v}}u.fill(0);return{key:o,iv:h}}e.exports=EVP_BytesToKey},9029:function(e,t,r){"use strict";var i=r(5055).Buffer;var n=r(3726).Transform;var a=r(3782);function throwIfNotStringOrBuffer(e,t){if(!i.isBuffer(e)&&typeof e!=="string"){throw new TypeError(t+" must be a string or a buffer")}}function HashBase(e){n.call(this);this._block=i.allocUnsafe(e);this._blockSize=e;this._blockOffset=0;this._length=[0,0,0,0];this._finalized=false}a(HashBase,n);HashBase.prototype._transform=function(e,t,r){var i=null;try{this.update(e,t)}catch(e){i=e}r(i)};HashBase.prototype._flush=function(e){var t=null;try{this.push(this.digest())}catch(e){t=e}e(t)};HashBase.prototype.update=function(e,t){throwIfNotStringOrBuffer(e,"Data");if(this._finalized)throw new Error("Digest already called");if(!i.isBuffer(e))e=i.from(e,t);var r=this._block;var n=0;while(this._blockOffset+e.length-n>=this._blockSize){for(var a=this._blockOffset;a<this._blockSize;)r[a++]=e[n++];this._update();this._blockOffset=0}while(n<e.length)r[this._blockOffset++]=e[n++];for(var s=0,o=e.length*8;o>0;++s){this._length[s]+=o;o=this._length[s]/4294967296|0;if(o>0)this._length[s]-=4294967296*o}return this};HashBase.prototype._update=function(){throw new Error("_update is not implemented")};HashBase.prototype.digest=function(e){if(this._finalized)throw new Error("Digest already called");this._finalized=true;var t=this._digest();if(e!==undefined)t=t.toString(e);this._block.fill(0);this._blockOffset=0;for(var r=0;r<4;++r)this._length[r]=0;return t};HashBase.prototype._digest=function(){throw new Error("_digest is not implemented")};e.exports=HashBase},7028:function(e,t,r){var i=t;i.utils=r(263);i.common=r(1330);i.sha=r(301);i.ripemd=r(3079);i.hmac=r(3092);i.sha1=i.sha.sha1;i.sha256=i.sha.sha256;i.sha224=i.sha.sha224;i.sha384=i.sha.sha384;i.sha512=i.sha.sha512;i.ripemd160=i.ripemd.ripemd160},1330:function(e,t,r){"use strict";var i=r(263);var n=r(3523);function BlockHash(){this.pending=null;this.pendingTotal=0;this.blockSize=this.constructor.blockSize;this.outSize=this.constructor.outSize;this.hmacStrength=this.constructor.hmacStrength;this.padLength=this.constructor.padLength/8;this.endian="big";this._delta8=this.blockSize/8;this._delta32=this.blockSize/32}t.BlockHash=BlockHash;BlockHash.prototype.update=function update(e,t){e=i.toArray(e,t);if(!this.pending)this.pending=e;else this.pending=this.pending.concat(e);this.pendingTotal+=e.length;if(this.pending.length>=this._delta8){e=this.pending;var r=e.length%this._delta8;this.pending=e.slice(e.length-r,e.length);if(this.pending.length===0)this.pending=null;e=i.join32(e,0,e.length-r,this.endian);for(var n=0;n<e.length;n+=this._delta32)this._update(e,n,n+this._delta32)}return this};BlockHash.prototype.digest=function digest(e){this.update(this._pad());n(this.pending===null);return this._digest(e)};BlockHash.prototype._pad=function pad(){var e=this.pendingTotal;var t=this._delta8;var r=t-(e+this.padLength)%t;var i=new Array(r+this.padLength);i[0]=128;for(var n=1;n<r;n++)i[n]=0;e<<=3;if(this.endian==="big"){for(var a=8;a<this.padLength;a++)i[n++]=0;i[n++]=0;i[n++]=0;i[n++]=0;i[n++]=0;i[n++]=e>>>24&255;i[n++]=e>>>16&255;i[n++]=e>>>8&255;i[n++]=e&255}else{i[n++]=e&255;i[n++]=e>>>8&255;i[n++]=e>>>16&255;i[n++]=e>>>24&255;i[n++]=0;i[n++]=0;i[n++]=0;i[n++]=0;for(a=8;a<this.padLength;a++)i[n++]=0}return i}},3092:function(e,t,r){"use strict";var i=r(263);var n=r(3523);function Hmac(e,t,r){if(!(this instanceof Hmac))return new Hmac(e,t,r);this.Hash=e;this.blockSize=e.blockSize/8;this.outSize=e.outSize/8;this.inner=null;this.outer=null;this._init(i.toArray(t,r))}e.exports=Hmac;Hmac.prototype._init=function init(e){if(e.length>this.blockSize)e=(new this.Hash).update(e).digest();n(e.length<=this.blockSize);for(var t=e.length;t<this.blockSize;t++)e.push(0);for(t=0;t<e.length;t++)e[t]^=54;this.inner=(new this.Hash).update(e);for(t=0;t<e.length;t++)e[t]^=106;this.outer=(new this.Hash).update(e)};Hmac.prototype.update=function update(e,t){this.inner.update(e,t);return this};Hmac.prototype.digest=function digest(e){this.outer.update(this.inner.digest());return this.outer.digest(e)}},3079:function(e,t,r){"use strict";var i=r(263);var n=r(1330);var a=i.rotl32;var s=i.sum32;var o=i.sum32_3;var h=i.sum32_4;var u=n.BlockHash;function RIPEMD160(){if(!(this instanceof RIPEMD160))return new RIPEMD160;u.call(this);this.h=[1732584193,4023233417,2562383102,271733878,3285377520];this.endian="little"}i.inherits(RIPEMD160,u);t.ripemd160=RIPEMD160;RIPEMD160.blockSize=512;RIPEMD160.outSize=160;RIPEMD160.hmacStrength=192;RIPEMD160.padLength=64;RIPEMD160.prototype._update=function update(e,t){var r=this.h[0];var i=this.h[1];var n=this.h[2];var u=this.h[3];var v=this.h[4];var b=r;var m=i;var y=n;var g=u;var _=v;for(var w=0;w<80;w++){var M=s(a(h(r,f(w,i,n,u),e[d[w]+t],K(w)),l[w]),v);r=v;v=u;u=a(n,10);n=i;i=M;M=s(a(h(b,f(79-w,m,y,g),e[c[w]+t],Kh(w)),p[w]),_);b=_;_=g;g=a(y,10);y=m;m=M}M=o(this.h[1],n,g);this.h[1]=o(this.h[2],u,_);this.h[2]=o(this.h[3],v,b);this.h[3]=o(this.h[4],r,m);this.h[4]=o(this.h[0],i,y);this.h[0]=M};RIPEMD160.prototype._digest=function digest(e){if(e==="hex")return i.toHex32(this.h,"little");else return i.split32(this.h,"little")};function f(e,t,r,i){if(e<=15)return t^r^i;else if(e<=31)return t&r|~t&i;else if(e<=47)return(t|~r)^i;else if(e<=63)return t&i|r&~i;else return t^(r|~i)}function K(e){if(e<=15)return 0;else if(e<=31)return 1518500249;else if(e<=47)return 1859775393;else if(e<=63)return 2400959708;else return 2840853838}function Kh(e){if(e<=15)return 1352829926;else if(e<=31)return 1548603684;else if(e<=47)return 1836072691;else if(e<=63)return 2053994217;else return 0}var d=[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,7,4,13,1,10,6,15,3,12,0,9,5,2,14,11,8,3,10,14,4,9,15,8,1,2,7,0,6,13,11,5,12,1,9,11,10,0,8,12,4,13,3,7,15,14,5,6,2,4,0,5,9,7,12,2,10,14,1,3,8,11,6,15,13];var c=[5,14,7,0,9,2,11,4,13,6,15,8,1,10,3,12,6,11,3,7,0,13,5,10,14,15,8,12,4,9,1,2,15,5,1,3,7,14,6,9,11,8,12,2,10,0,4,13,8,6,4,1,3,11,15,0,5,12,2,13,9,7,10,14,12,15,10,4,1,5,8,7,6,2,13,14,0,3,9,11];var l=[11,14,15,12,5,8,7,9,11,13,14,15,6,7,9,8,7,6,8,13,11,9,7,15,7,12,15,9,11,7,13,12,11,13,6,7,14,9,13,15,14,8,13,6,5,12,7,5,11,12,14,15,14,15,9,8,9,14,5,6,8,6,5,12,9,15,5,11,6,8,13,12,5,12,13,14,11,8,5,6];var p=[8,9,9,11,13,15,15,5,7,7,8,11,14,14,12,6,9,13,15,7,12,8,9,11,7,7,12,7,6,15,13,11,9,7,15,11,8,6,6,14,12,13,5,14,13,13,7,5,15,5,8,11,14,14,6,14,6,9,12,9,12,5,15,8,8,5,12,9,12,5,14,6,8,13,6,5,15,13,11,11]},301:function(e,t,r){"use strict";t.sha1=r(2742);t.sha224=r(7105);t.sha256=r(1525);t.sha384=r(9948);t.sha512=r(1319)},2742:function(e,t,r){"use strict";var i=r(263);var n=r(1330);var a=r(2975);var s=i.rotl32;var o=i.sum32;var h=i.sum32_5;var u=a.ft_1;var d=n.BlockHash;var c=[1518500249,1859775393,2400959708,3395469782];function SHA1(){if(!(this instanceof SHA1))return new SHA1;d.call(this);this.h=[1732584193,4023233417,2562383102,271733878,3285377520];this.W=new Array(80)}i.inherits(SHA1,d);e.exports=SHA1;SHA1.blockSize=512;SHA1.outSize=160;SHA1.hmacStrength=80;SHA1.padLength=64;SHA1.prototype._update=function _update(e,t){var r=this.W;for(var i=0;i<16;i++)r[i]=e[t+i];for(;i<r.length;i++)r[i]=s(r[i-3]^r[i-8]^r[i-14]^r[i-16],1);var n=this.h[0];var a=this.h[1];var d=this.h[2];var l=this.h[3];var p=this.h[4];for(i=0;i<r.length;i++){var v=~~(i/20);var b=h(s(n,5),u(v,a,d,l),p,r[i],c[v]);p=l;l=d;d=s(a,30);a=n;n=b}this.h[0]=o(this.h[0],n);this.h[1]=o(this.h[1],a);this.h[2]=o(this.h[2],d);this.h[3]=o(this.h[3],l);this.h[4]=o(this.h[4],p)};SHA1.prototype._digest=function digest(e){if(e==="hex")return i.toHex32(this.h,"big");else return i.split32(this.h,"big")}},7105:function(e,t,r){"use strict";var i=r(263);var n=r(1525);function SHA224(){if(!(this instanceof SHA224))return new SHA224;n.call(this);this.h=[3238371032,914150663,812702999,4144912697,4290775857,1750603025,1694076839,3204075428]}i.inherits(SHA224,n);e.exports=SHA224;SHA224.blockSize=512;SHA224.outSize=224;SHA224.hmacStrength=192;SHA224.padLength=64;SHA224.prototype._digest=function digest(e){if(e==="hex")return i.toHex32(this.h.slice(0,7),"big");else return i.split32(this.h.slice(0,7),"big")}},1525:function(e,t,r){"use strict";var i=r(263);var n=r(1330);var a=r(2975);var s=r(3523);var o=i.sum32;var h=i.sum32_4;var u=i.sum32_5;var d=a.ch32;var c=a.maj32;var l=a.s0_256;var p=a.s1_256;var v=a.g0_256;var b=a.g1_256;var m=n.BlockHash;var y=[1116352408,1899447441,3049323471,3921009573,961987163,1508970993,2453635748,2870763221,3624381080,310598401,607225278,1426881987,1925078388,2162078206,2614888103,3248222580,3835390401,4022224774,264347078,604807628,770255983,1249150122,1555081692,1996064986,2554220882,2821834349,2952996808,3210313671,3336571891,3584528711,113926993,338241895,666307205,773529912,1294757372,1396182291,1695183700,1986661051,2177026350,2456956037,2730485921,2820302411,3259730800,3345764771,3516065817,3600352804,4094571909,275423344,430227734,506948616,659060556,883997877,958139571,1322822218,1537002063,1747873779,1955562222,2024104815,2227730452,2361852424,2428436474,2756734187,3204031479,3329325298];function SHA256(){if(!(this instanceof SHA256))return new SHA256;m.call(this);this.h=[1779033703,3144134277,1013904242,2773480762,1359893119,2600822924,528734635,1541459225];this.k=y;this.W=new Array(64)}i.inherits(SHA256,m);e.exports=SHA256;SHA256.blockSize=512;SHA256.outSize=256;SHA256.hmacStrength=192;SHA256.padLength=64;SHA256.prototype._update=function _update(e,t){var r=this.W;for(var i=0;i<16;i++)r[i]=e[t+i];for(;i<r.length;i++)r[i]=h(b(r[i-2]),r[i-7],v(r[i-15]),r[i-16]);var n=this.h[0];var a=this.h[1];var m=this.h[2];var y=this.h[3];var g=this.h[4];var _=this.h[5];var w=this.h[6];var M=this.h[7];s(this.k.length===r.length);for(i=0;i<r.length;i++){var B=u(M,p(g),d(g,_,w),this.k[i],r[i]);var E=o(l(n),c(n,a,m));M=w;w=_;_=g;g=o(y,B);y=m;m=a;a=n;n=o(B,E)}this.h[0]=o(this.h[0],n);this.h[1]=o(this.h[1],a);this.h[2]=o(this.h[2],m);this.h[3]=o(this.h[3],y);this.h[4]=o(this.h[4],g);this.h[5]=o(this.h[5],_);this.h[6]=o(this.h[6],w);this.h[7]=o(this.h[7],M)};SHA256.prototype._digest=function digest(e){if(e==="hex")return i.toHex32(this.h,"big");else return i.split32(this.h,"big")}},9948:function(e,t,r){"use strict";var i=r(263);var n=r(1319);function SHA384(){if(!(this instanceof SHA384))return new SHA384;n.call(this);this.h=[3418070365,3238371032,1654270250,914150663,2438529370,812702999,355462360,4144912697,1731405415,4290775857,2394180231,1750603025,3675008525,1694076839,1203062813,3204075428]}i.inherits(SHA384,n);e.exports=SHA384;SHA384.blockSize=1024;SHA384.outSize=384;SHA384.hmacStrength=192;SHA384.padLength=128;SHA384.prototype._digest=function digest(e){if(e==="hex")return i.toHex32(this.h.slice(0,12),"big");else return i.split32(this.h.slice(0,12),"big")}},1319:function(e,t,r){"use strict";var i=r(263);var n=r(1330);var a=r(3523);var s=i.rotr64_hi;var o=i.rotr64_lo;var h=i.shr64_hi;var u=i.shr64_lo;var d=i.sum64;var c=i.sum64_hi;var l=i.sum64_lo;var p=i.sum64_4_hi;var v=i.sum64_4_lo;var b=i.sum64_5_hi;var m=i.sum64_5_lo;var y=n.BlockHash;var g=[1116352408,3609767458,1899447441,602891725,3049323471,3964484399,3921009573,2173295548,961987163,4081628472,1508970993,3053834265,2453635748,2937671579,2870763221,3664609560,3624381080,2734883394,310598401,1164996542,607225278,1323610764,1426881987,3590304994,1925078388,4068182383,2162078206,991336113,2614888103,633803317,3248222580,3479774868,3835390401,2666613458,4022224774,944711139,264347078,2341262773,604807628,2007800933,770255983,1495990901,1249150122,1856431235,1555081692,3175218132,1996064986,2198950837,2554220882,3999719339,2821834349,766784016,2952996808,2566594879,3210313671,3203337956,3336571891,1034457026,3584528711,2466948901,113926993,3758326383,338241895,168717936,666307205,1188179964,773529912,1546045734,1294757372,1522805485,1396182291,2643833823,1695183700,2343527390,1986661051,1014477480,2177026350,1206759142,2456956037,344077627,2730485921,1290863460,2820302411,3158454273,3259730800,3505952657,3345764771,106217008,3516065817,3606008344,3600352804,1432725776,4094571909,1467031594,275423344,851169720,430227734,3100823752,506948616,1363258195,659060556,3750685593,883997877,3785050280,958139571,3318307427,1322822218,3812723403,1537002063,2003034995,1747873779,3602036899,1955562222,1575990012,2024104815,1125592928,2227730452,2716904306,2361852424,442776044,2428436474,593698344,2756734187,3733110249,3204031479,2999351573,3329325298,3815920427,3391569614,3928383900,3515267271,566280711,3940187606,3454069534,4118630271,4000239992,116418474,1914138554,174292421,2731055270,289380356,3203993006,460393269,320620315,685471733,587496836,852142971,1086792851,1017036298,365543100,1126000580,2618297676,1288033470,3409855158,1501505948,4234509866,1607167915,987167468,1816402316,1246189591];function SHA512(){if(!(this instanceof SHA512))return new SHA512;y.call(this);this.h=[1779033703,4089235720,3144134277,2227873595,1013904242,4271175723,2773480762,1595750129,1359893119,2917565137,2600822924,725511199,528734635,4215389547,1541459225,327033209];this.k=g;this.W=new Array(160)}i.inherits(SHA512,y);e.exports=SHA512;SHA512.blockSize=1024;SHA512.outSize=512;SHA512.hmacStrength=192;SHA512.padLength=128;SHA512.prototype._prepareBlock=function _prepareBlock(e,t){var r=this.W;for(var i=0;i<32;i++)r[i]=e[t+i];for(;i<r.length;i+=2){var n=g1_512_hi(r[i-4],r[i-3]);var a=g1_512_lo(r[i-4],r[i-3]);var s=r[i-14];var o=r[i-13];var h=g0_512_hi(r[i-30],r[i-29]);var u=g0_512_lo(r[i-30],r[i-29]);var d=r[i-32];var c=r[i-31];r[i]=p(n,a,s,o,h,u,d,c);r[i+1]=v(n,a,s,o,h,u,d,c)}};SHA512.prototype._update=function _update(e,t){this._prepareBlock(e,t);var r=this.W;var i=this.h[0];var n=this.h[1];var s=this.h[2];var o=this.h[3];var h=this.h[4];var u=this.h[5];var p=this.h[6];var v=this.h[7];var y=this.h[8];var g=this.h[9];var _=this.h[10];var w=this.h[11];var M=this.h[12];var B=this.h[13];var E=this.h[14];var k=this.h[15];a(this.k.length===r.length);for(var A=0;A<r.length;A+=2){var N=E;var P=k;var x=s1_512_hi(y,g);var I=s1_512_lo(y,g);var C=ch64_hi(y,g,_,w,M,B);var D=ch64_lo(y,g,_,w,M,B);var T=this.k[A];var j=this.k[A+1];var q=r[A];var O=r[A+1];var H=b(N,P,x,I,C,D,T,j,q,O);var L=m(N,P,x,I,C,D,T,j,q,O);N=s0_512_hi(i,n);P=s0_512_lo(i,n);x=maj64_hi(i,n,s,o,h,u);I=maj64_lo(i,n,s,o,h,u);var z=c(N,P,x,I);var F=l(N,P,x,I);E=M;k=B;M=_;B=w;_=y;w=g;y=c(p,v,H,L);g=l(v,v,H,L);p=h;v=u;h=s;u=o;s=i;o=n;i=c(H,L,z,F);n=l(H,L,z,F)}d(this.h,0,i,n);d(this.h,2,s,o);d(this.h,4,h,u);d(this.h,6,p,v);d(this.h,8,y,g);d(this.h,10,_,w);d(this.h,12,M,B);d(this.h,14,E,k)};SHA512.prototype._digest=function digest(e){if(e==="hex")return i.toHex32(this.h,"big");else return i.split32(this.h,"big")};function ch64_hi(e,t,r,i,n){var a=e&r^~e&n;if(a<0)a+=4294967296;return a}function ch64_lo(e,t,r,i,n,a){var s=t&i^~t&a;if(s<0)s+=4294967296;return s}function maj64_hi(e,t,r,i,n){var a=e&r^e&n^r&n;if(a<0)a+=4294967296;return a}function maj64_lo(e,t,r,i,n,a){var s=t&i^t&a^i&a;if(s<0)s+=4294967296;return s}function s0_512_hi(e,t){var r=s(e,t,28);var i=s(t,e,2);var n=s(t,e,7);var a=r^i^n;if(a<0)a+=4294967296;return a}function s0_512_lo(e,t){var r=o(e,t,28);var i=o(t,e,2);var n=o(t,e,7);var a=r^i^n;if(a<0)a+=4294967296;return a}function s1_512_hi(e,t){var r=s(e,t,14);var i=s(e,t,18);var n=s(t,e,9);var a=r^i^n;if(a<0)a+=4294967296;return a}function s1_512_lo(e,t){var r=o(e,t,14);var i=o(e,t,18);var n=o(t,e,9);var a=r^i^n;if(a<0)a+=4294967296;return a}function g0_512_hi(e,t){var r=s(e,t,1);var i=s(e,t,8);var n=h(e,t,7);var a=r^i^n;if(a<0)a+=4294967296;return a}function g0_512_lo(e,t){var r=o(e,t,1);var i=o(e,t,8);var n=u(e,t,7);var a=r^i^n;if(a<0)a+=4294967296;return a}function g1_512_hi(e,t){var r=s(e,t,19);var i=s(t,e,29);var n=h(e,t,6);var a=r^i^n;if(a<0)a+=4294967296;return a}function g1_512_lo(e,t){var r=o(e,t,19);var i=o(t,e,29);var n=u(e,t,6);var a=r^i^n;if(a<0)a+=4294967296;return a}},2975:function(e,t,r){"use strict";var i=r(263);var n=i.rotr32;function ft_1(e,t,r,i){if(e===0)return ch32(t,r,i);if(e===1||e===3)return p32(t,r,i);if(e===2)return maj32(t,r,i)}t.ft_1=ft_1;function ch32(e,t,r){return e&t^~e&r}t.ch32=ch32;function maj32(e,t,r){return e&t^e&r^t&r}t.maj32=maj32;function p32(e,t,r){return e^t^r}t.p32=p32;function s0_256(e){return n(e,2)^n(e,13)^n(e,22)}t.s0_256=s0_256;function s1_256(e){return n(e,6)^n(e,11)^n(e,25)}t.s1_256=s1_256;function g0_256(e){return n(e,7)^n(e,18)^e>>>3}t.g0_256=g0_256;function g1_256(e){return n(e,17)^n(e,19)^e>>>10}t.g1_256=g1_256},263:function(e,t,r){"use strict";var i=r(3523);var n=r(3782);t.inherits=n;function isSurrogatePair(e,t){if((e.charCodeAt(t)&64512)!==55296){return false}if(t<0||t+1>=e.length){return false}return(e.charCodeAt(t+1)&64512)===56320}function toArray(e,t){if(Array.isArray(e))return e.slice();if(!e)return[];var r=[];if(typeof e==="string"){if(!t){var i=0;for(var n=0;n<e.length;n++){var a=e.charCodeAt(n);if(a<128){r[i++]=a}else if(a<2048){r[i++]=a>>6|192;r[i++]=a&63|128}else if(isSurrogatePair(e,n)){a=65536+((a&1023)<<10)+(e.charCodeAt(++n)&1023);r[i++]=a>>18|240;r[i++]=a>>12&63|128;r[i++]=a>>6&63|128;r[i++]=a&63|128}else{r[i++]=a>>12|224;r[i++]=a>>6&63|128;r[i++]=a&63|128}}}else if(t==="hex"){e=e.replace(/[^a-z0-9]+/gi,"");if(e.length%2!==0)e="0"+e;for(n=0;n<e.length;n+=2)r.push(parseInt(e[n]+e[n+1],16))}}else{for(n=0;n<e.length;n++)r[n]=e[n]|0}return r}t.toArray=toArray;function toHex(e){var t="";for(var r=0;r<e.length;r++)t+=zero2(e[r].toString(16));return t}t.toHex=toHex;function htonl(e){var t=e>>>24|e>>>8&65280|e<<8&16711680|(e&255)<<24;return t>>>0}t.htonl=htonl;function toHex32(e,t){var r="";for(var i=0;i<e.length;i++){var n=e[i];if(t==="little")n=htonl(n);r+=zero8(n.toString(16))}return r}t.toHex32=toHex32;function zero2(e){if(e.length===1)return"0"+e;else return e}t.zero2=zero2;function zero8(e){if(e.length===7)return"0"+e;else if(e.length===6)return"00"+e;else if(e.length===5)return"000"+e;else if(e.length===4)return"0000"+e;else if(e.length===3)return"00000"+e;else if(e.length===2)return"000000"+e;else if(e.length===1)return"0000000"+e;else return e}t.zero8=zero8;function join32(e,t,r,n){var a=r-t;i(a%4===0);var s=new Array(a/4);for(var o=0,h=t;o<s.length;o++,h+=4){var u;if(n==="big")u=e[h]<<24|e[h+1]<<16|e[h+2]<<8|e[h+3];else u=e[h+3]<<24|e[h+2]<<16|e[h+1]<<8|e[h];s[o]=u>>>0}return s}t.join32=join32;function split32(e,t){var r=new Array(e.length*4);for(var i=0,n=0;i<e.length;i++,n+=4){var a=e[i];if(t==="big"){r[n]=a>>>24;r[n+1]=a>>>16&255;r[n+2]=a>>>8&255;r[n+3]=a&255}else{r[n+3]=a>>>24;r[n+2]=a>>>16&255;r[n+1]=a>>>8&255;r[n]=a&255}}return r}t.split32=split32;function rotr32(e,t){return e>>>t|e<<32-t}t.rotr32=rotr32;function rotl32(e,t){return e<<t|e>>>32-t}t.rotl32=rotl32;function sum32(e,t){return e+t>>>0}t.sum32=sum32;function sum32_3(e,t,r){return e+t+r>>>0}t.sum32_3=sum32_3;function sum32_4(e,t,r,i){return e+t+r+i>>>0}t.sum32_4=sum32_4;function sum32_5(e,t,r,i,n){return e+t+r+i+n>>>0}t.sum32_5=sum32_5;function sum64(e,t,r,i){var n=e[t];var a=e[t+1];var s=i+a>>>0;var o=(s<i?1:0)+r+n;e[t]=o>>>0;e[t+1]=s}t.sum64=sum64;function sum64_hi(e,t,r,i){var n=t+i>>>0;var a=(n<t?1:0)+e+r;return a>>>0}t.sum64_hi=sum64_hi;function sum64_lo(e,t,r,i){var n=t+i;return n>>>0}t.sum64_lo=sum64_lo;function sum64_4_hi(e,t,r,i,n,a,s,o){var h=0;var u=t;u=u+i>>>0;h+=u<t?1:0;u=u+a>>>0;h+=u<a?1:0;u=u+o>>>0;h+=u<o?1:0;var d=e+r+n+s+h;return d>>>0}t.sum64_4_hi=sum64_4_hi;function sum64_4_lo(e,t,r,i,n,a,s,o){var h=t+i+a+o;return h>>>0}t.sum64_4_lo=sum64_4_lo;function sum64_5_hi(e,t,r,i,n,a,s,o,h,u){var d=0;var c=t;c=c+i>>>0;d+=c<t?1:0;c=c+a>>>0;d+=c<a?1:0;c=c+o>>>0;d+=c<o?1:0;c=c+u>>>0;d+=c<u?1:0;var l=e+r+n+s+h+d;return l>>>0}t.sum64_5_hi=sum64_5_hi;function sum64_5_lo(e,t,r,i,n,a,s,o,h,u){var d=t+i+a+o+u;return d>>>0}t.sum64_5_lo=sum64_5_lo;function rotr64_hi(e,t,r){var i=t<<32-r|e>>>r;return i>>>0}t.rotr64_hi=rotr64_hi;function rotr64_lo(e,t,r){var i=e<<32-r|t>>>r;return i>>>0}t.rotr64_lo=rotr64_lo;function shr64_hi(e,t,r){return e>>>r}t.shr64_hi=shr64_hi;function shr64_lo(e,t,r){var i=e<<32-r|t>>>r;return i>>>0}t.shr64_lo=shr64_lo},4910:function(e,t,r){"use strict";var i=r(7028);var n=r(6545);var a=r(3523);function HmacDRBG(e){if(!(this instanceof HmacDRBG))return new HmacDRBG(e);this.hash=e.hash;this.predResist=!!e.predResist;this.outLen=this.hash.outSize;this.minEntropy=e.minEntropy||this.hash.hmacStrength;this._reseed=null;this.reseedInterval=null;this.K=null;this.V=null;var t=n.toArray(e.entropy,e.entropyEnc||"hex");var r=n.toArray(e.nonce,e.nonceEnc||"hex");var i=n.toArray(e.pers,e.persEnc||"hex");a(t.length>=this.minEntropy/8,"Not enough entropy. Minimum is: "+this.minEntropy+" bits");this._init(t,r,i)}e.exports=HmacDRBG;HmacDRBG.prototype._init=function init(e,t,r){var i=e.concat(t).concat(r);this.K=new Array(this.outLen/8);this.V=new Array(this.outLen/8);for(var n=0;n<this.V.length;n++){this.K[n]=0;this.V[n]=1}this._update(i);this._reseed=1;this.reseedInterval=281474976710656};HmacDRBG.prototype._hmac=function hmac(){return new i.hmac(this.hash,this.K)};HmacDRBG.prototype._update=function update(e){var t=this._hmac().update(this.V).update([0]);if(e)t=t.update(e);this.K=t.digest();this.V=this._hmac().update(this.V).digest();if(!e)return;this.K=this._hmac().update(this.V).update([1]).update(e).digest();this.V=this._hmac().update(this.V).digest()};HmacDRBG.prototype.reseed=function reseed(e,t,r,i){if(typeof t!=="string"){i=r;r=t;t=null}e=n.toArray(e,t);r=n.toArray(r,i);a(e.length>=this.minEntropy/8,"Not enough entropy. Minimum is: "+this.minEntropy+" bits");this._update(e.concat(r||[]));this._reseed=1};HmacDRBG.prototype.generate=function generate(e,t,r,i){if(this._reseed>this.reseedInterval)throw new Error("Reseed is required");if(typeof t!=="string"){i=r;r=t;t=null}if(r){r=n.toArray(r,i||"hex");this._update(r)}var a=[];while(a.length<e){this.V=this._hmac().update(this.V).digest();a=a.concat(this.V)}var s=a.slice(0,e);this._update(r);this._reseed++;return n.encode(s,t)}},3782:function(e){if(typeof Object.create==="function"){e.exports=function inherits(e,t){if(t){e.super_=t;e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:false,writable:true,configurable:true}})}}}else{e.exports=function inherits(e,t){if(t){e.super_=t;var TempCtor=function(){};TempCtor.prototype=t.prototype;e.prototype=new TempCtor;e.prototype.constructor=e}}}},3533:function(e,t,r){"use strict";var i=r(3782);var n=r(9029);var a=r(5055).Buffer;var s=new Array(16);function MD5(){n.call(this,64);this._a=1732584193;this._b=4023233417;this._c=2562383102;this._d=271733878}i(MD5,n);MD5.prototype._update=function(){var e=s;for(var t=0;t<16;++t)e[t]=this._block.readInt32LE(t*4);var r=this._a;var i=this._b;var n=this._c;var a=this._d;r=fnF(r,i,n,a,e[0],3614090360,7);a=fnF(a,r,i,n,e[1],3905402710,12);n=fnF(n,a,r,i,e[2],606105819,17);i=fnF(i,n,a,r,e[3],3250441966,22);r=fnF(r,i,n,a,e[4],4118548399,7);a=fnF(a,r,i,n,e[5],1200080426,12);n=fnF(n,a,r,i,e[6],2821735955,17);i=fnF(i,n,a,r,e[7],4249261313,22);r=fnF(r,i,n,a,e[8],1770035416,7);a=fnF(a,r,i,n,e[9],2336552879,12);n=fnF(n,a,r,i,e[10],4294925233,17);i=fnF(i,n,a,r,e[11],2304563134,22);r=fnF(r,i,n,a,e[12],1804603682,7);a=fnF(a,r,i,n,e[13],4254626195,12);n=fnF(n,a,r,i,e[14],2792965006,17);i=fnF(i,n,a,r,e[15],1236535329,22);r=fnG(r,i,n,a,e[1],4129170786,5);a=fnG(a,r,i,n,e[6],3225465664,9);n=fnG(n,a,r,i,e[11],643717713,14);i=fnG(i,n,a,r,e[0],3921069994,20);r=fnG(r,i,n,a,e[5],3593408605,5);a=fnG(a,r,i,n,e[10],38016083,9);n=fnG(n,a,r,i,e[15],3634488961,14);i=fnG(i,n,a,r,e[4],3889429448,20);r=fnG(r,i,n,a,e[9],568446438,5);a=fnG(a,r,i,n,e[14],3275163606,9);n=fnG(n,a,r,i,e[3],4107603335,14);i=fnG(i,n,a,r,e[8],1163531501,20);r=fnG(r,i,n,a,e[13],2850285829,5);a=fnG(a,r,i,n,e[2],4243563512,9);n=fnG(n,a,r,i,e[7],1735328473,14);i=fnG(i,n,a,r,e[12],2368359562,20);r=fnH(r,i,n,a,e[5],4294588738,4);a=fnH(a,r,i,n,e[8],2272392833,11);n=fnH(n,a,r,i,e[11],1839030562,16);i=fnH(i,n,a,r,e[14],4259657740,23);r=fnH(r,i,n,a,e[1],2763975236,4);a=fnH(a,r,i,n,e[4],1272893353,11);n=fnH(n,a,r,i,e[7],4139469664,16);i=fnH(i,n,a,r,e[10],3200236656,23);r=fnH(r,i,n,a,e[13],681279174,4);a=fnH(a,r,i,n,e[0],3936430074,11);n=fnH(n,a,r,i,e[3],3572445317,16);i=fnH(i,n,a,r,e[6],76029189,23);r=fnH(r,i,n,a,e[9],3654602809,4);a=fnH(a,r,i,n,e[12],3873151461,11);n=fnH(n,a,r,i,e[15],530742520,16);i=fnH(i,n,a,r,e[2],3299628645,23);r=fnI(r,i,n,a,e[0],4096336452,6);a=fnI(a,r,i,n,e[7],1126891415,10);n=fnI(n,a,r,i,e[14],2878612391,15);i=fnI(i,n,a,r,e[5],4237533241,21);r=fnI(r,i,n,a,e[12],1700485571,6);a=fnI(a,r,i,n,e[3],2399980690,10);n=fnI(n,a,r,i,e[10],4293915773,15);i=fnI(i,n,a,r,e[1],2240044497,21);r=fnI(r,i,n,a,e[8],1873313359,6);a=fnI(a,r,i,n,e[15],4264355552,10);n=fnI(n,a,r,i,e[6],2734768916,15);i=fnI(i,n,a,r,e[13],1309151649,21);r=fnI(r,i,n,a,e[4],4149444226,6);a=fnI(a,r,i,n,e[11],3174756917,10);n=fnI(n,a,r,i,e[2],718787259,15);i=fnI(i,n,a,r,e[9],3951481745,21);this._a=this._a+r|0;this._b=this._b+i|0;this._c=this._c+n|0;this._d=this._d+a|0};MD5.prototype._digest=function(){this._block[this._blockOffset++]=128;if(this._blockOffset>56){this._block.fill(0,this._blockOffset,64);this._update();this._blockOffset=0}this._block.fill(0,this._blockOffset,56);this._block.writeUInt32LE(this._length[0],56);this._block.writeUInt32LE(this._length[1],60);this._update();var e=a.allocUnsafe(16);e.writeInt32LE(this._a,0);e.writeInt32LE(this._b,4);e.writeInt32LE(this._c,8);e.writeInt32LE(this._d,12);return e};function rotl(e,t){return e<<t|e>>>32-t}function fnF(e,t,r,i,n,a,s){return rotl(e+(t&r|~t&i)+n+a|0,s)+t|0}function fnG(e,t,r,i,n,a,s){return rotl(e+(t&i|r&~i)+n+a|0,s)+t|0}function fnH(e,t,r,i,n,a,s){return rotl(e+(t^r^i)+n+a|0,s)+t|0}function fnI(e,t,r,i,n,a,s){return rotl(e+(r^(t|~i))+n+a|0,s)+t|0}e.exports=MD5},1354:function(e,t,r){var i=r(711);var n=r(3500);function MillerRabin(e){this.rand=e||new n.Rand}e.exports=MillerRabin;MillerRabin.create=function create(e){return new MillerRabin(e)};MillerRabin.prototype._randbelow=function _randbelow(e){var t=e.bitLength();var r=Math.ceil(t/8);do{var n=new i(this.rand.generate(r))}while(n.cmp(e)>=0);return n};MillerRabin.prototype._randrange=function _randrange(e,t){var r=t.sub(e);return e.add(this._randbelow(r))};MillerRabin.prototype.test=function test(e,t,r){var n=e.bitLength();var a=i.mont(e);var s=new i(1).toRed(a);if(!t)t=Math.max(1,n/48|0);var o=e.subn(1);for(var h=0;!o.testn(h);h++){}var u=e.shrn(h);var d=o.toRed(a);var c=true;for(;t>0;t--){var l=this._randrange(new i(2),o);if(r)r(l);var p=l.toRed(a).redPow(u);if(p.cmp(s)===0||p.cmp(d)===0)continue;for(var v=1;v<h;v++){p=p.redSqr();if(p.cmp(s)===0)return false;if(p.cmp(d)===0)break}if(v===h)return false}return c};MillerRabin.prototype.getDivisor=function getDivisor(e,t){var r=e.bitLength();var n=i.mont(e);var a=new i(1).toRed(n);if(!t)t=Math.max(1,r/48|0);var s=e.subn(1);for(var o=0;!s.testn(o);o++){}var h=e.shrn(o);var u=s.toRed(n);for(;t>0;t--){var d=this._randrange(new i(2),s);var c=e.gcd(d);if(c.cmpn(1)!==0)return c;var l=d.toRed(n).redPow(h);if(l.cmp(a)===0||l.cmp(u)===0)continue;for(var p=1;p<o;p++){l=l.redSqr();if(l.cmp(a)===0)return l.fromRed().subn(1).gcd(e);if(l.cmp(u)===0)break}if(p===o){l=l.redSqr();return l.fromRed().subn(1).gcd(e)}}return false}},3523:function(e){e.exports=assert;function assert(e,t){if(!e)throw new Error(t||"Assertion failed")}assert.equal=function assertEqual(e,t,r){if(e!=t)throw new Error(r||"Assertion failed: "+e+" != "+t)}},6545:function(e,t){"use strict";var r=t;function toArray(e,t){if(Array.isArray(e))return e.slice();if(!e)return[];var r=[];if(typeof e!=="string"){for(var i=0;i<e.length;i++)r[i]=e[i]|0;return r}if(t==="hex"){e=e.replace(/[^a-z0-9]+/gi,"");if(e.length%2!==0)e="0"+e;for(var i=0;i<e.length;i+=2)r.push(parseInt(e[i]+e[i+1],16))}else{for(var i=0;i<e.length;i++){var n=e.charCodeAt(i);var a=n>>8;var s=n&255;if(a)r.push(a,s);else r.push(s)}}return r}r.toArray=toArray;function zero2(e){if(e.length===1)return"0"+e;else return e}r.zero2=zero2;function toHex(e){var t="";for(var r=0;r<e.length;r++)t+=zero2(e[r].toString(16));return t}r.toHex=toHex;r.encode=function encode(e,t){if(t==="hex")return toHex(e);else return e}},8687:function(e,t,r){"use strict";var i=r(7160);t.certificate=r(8782);var n=i.define("RSAPrivateKey",(function(){this.seq().obj(this.key("version").int(),this.key("modulus").int(),this.key("publicExponent").int(),this.key("privateExponent").int(),this.key("prime1").int(),this.key("prime2").int(),this.key("exponent1").int(),this.key("exponent2").int(),this.key("coefficient").int())}));t.RSAPrivateKey=n;var a=i.define("RSAPublicKey",(function(){this.seq().obj(this.key("modulus").int(),this.key("publicExponent").int())}));t.RSAPublicKey=a;var s=i.define("SubjectPublicKeyInfo",(function(){this.seq().obj(this.key("algorithm").use(o),this.key("subjectPublicKey").bitstr())}));t.PublicKey=s;var o=i.define("AlgorithmIdentifier",(function(){this.seq().obj(this.key("algorithm").objid(),this.key("none").null_().optional(),this.key("curve").objid().optional(),this.key("params").seq().obj(this.key("p").int(),this.key("q").int(),this.key("g").int()).optional())}));var h=i.define("PrivateKeyInfo",(function(){this.seq().obj(this.key("version").int(),this.key("algorithm").use(o),this.key("subjectPrivateKey").octstr())}));t.PrivateKey=h;var u=i.define("EncryptedPrivateKeyInfo",(function(){this.seq().obj(this.key("algorithm").seq().obj(this.key("id").objid(),this.key("decrypt").seq().obj(this.key("kde").seq().obj(this.key("id").objid(),this.key("kdeparams").seq().obj(this.key("salt").octstr(),this.key("iters").int())),this.key("cipher").seq().obj(this.key("algo").objid(),this.key("iv").octstr()))),this.key("subjectPrivateKey").octstr())}));t.EncryptedPrivateKey=u;var d=i.define("DSAPrivateKey",(function(){this.seq().obj(this.key("version").int(),this.key("p").int(),this.key("q").int(),this.key("g").int(),this.key("pub_key").int(),this.key("priv_key").int())}));t.DSAPrivateKey=d;t.DSAparam=i.define("DSAparam",(function(){this.int()}));var c=i.define("ECPrivateKey",(function(){this.seq().obj(this.key("version").int(),this.key("privateKey").octstr(),this.key("parameters").optional().explicit(0).use(l),this.key("publicKey").optional().explicit(1).bitstr())}));t.ECPrivateKey=c;var l=i.define("ECParameters",(function(){this.choice({namedCurve:this.objid()})}));t.signature=i.define("signature",(function(){this.seq().obj(this.key("r").int(),this.key("s").int())}))},8782:function(e,t,r){"use strict";var i=r(7160);var n=i.define("Time",(function(){this.choice({utcTime:this.utctime(),generalTime:this.gentime()})}));var a=i.define("AttributeTypeValue",(function(){this.seq().obj(this.key("type").objid(),this.key("value").any())}));var s=i.define("AlgorithmIdentifier",(function(){this.seq().obj(this.key("algorithm").objid(),this.key("parameters").optional(),this.key("curve").objid().optional())}));var o=i.define("SubjectPublicKeyInfo",(function(){this.seq().obj(this.key("algorithm").use(s),this.key("subjectPublicKey").bitstr())}));var h=i.define("RelativeDistinguishedName",(function(){this.setof(a)}));var u=i.define("RDNSequence",(function(){this.seqof(h)}));var d=i.define("Name",(function(){this.choice({rdnSequence:this.use(u)})}));var c=i.define("Validity",(function(){this.seq().obj(this.key("notBefore").use(n),this.key("notAfter").use(n))}));var l=i.define("Extension",(function(){this.seq().obj(this.key("extnID").objid(),this.key("critical").bool().def(false),this.key("extnValue").octstr())}));var p=i.define("TBSCertificate",(function(){this.seq().obj(this.key("version").explicit(0).int().optional(),this.key("serialNumber").int(),this.key("signature").use(s),this.key("issuer").use(d),this.key("validity").use(c),this.key("subject").use(d),this.key("subjectPublicKeyInfo").use(o),this.key("issuerUniqueID").implicit(1).bitstr().optional(),this.key("subjectUniqueID").implicit(2).bitstr().optional(),this.key("extensions").explicit(3).seqof(l).optional())}));var v=i.define("X509Certificate",(function(){this.seq().obj(this.key("tbsCertificate").use(p),this.key("signatureAlgorithm").use(s),this.key("signatureValue").bitstr())}));e.exports=v},6501:function(e,t,r){var i=/Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r\+\/\=]+)[\n\r]+/m;var n=/^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m;var a=/^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r\+\/\=]+)-----END \1-----$/m;var s=r(8368);var o=r(6594);var h=r(5055).Buffer;e.exports=function(e,t){var r=e.toString();var u=r.match(i);var d;if(!u){var c=r.match(a);d=new h(c[2].replace(/[\r\n]/g,""),"base64")}else{var l="aes"+u[1];var p=h.from(u[2],"hex");var v=h.from(u[3].replace(/[\r\n]/g,""),"base64");var b=s(t,p.slice(0,8),parseInt(u[1],10)).key;var m=[];var y=o.createDecipheriv(l,b,p);m.push(y.update(v));m.push(y.final());d=h.concat(m)}var g=r.match(n)[1];return{tag:g,data:d}}},9902:function(e,t,r){var i=r(8687);var n=r(2510);var a=r(6501);var s=r(6594);var o=r(4978);var h=r(5055).Buffer;e.exports=parseKeys;function parseKeys(e){var t;if(typeof e==="object"&&!h.isBuffer(e)){t=e.passphrase;e=e.key}if(typeof e==="string"){e=h.from(e)}var r=a(e,t);var n=r.tag;var s=r.data;var o,u;switch(n){case"CERTIFICATE":u=i.certificate.decode(s,"der").tbsCertificate.subjectPublicKeyInfo;case"PUBLIC KEY":if(!u){u=i.PublicKey.decode(s,"der")}o=u.algorithm.algorithm.join(".");switch(o){case"1.2.840.113549.1.1.1":return i.RSAPublicKey.decode(u.subjectPublicKey.data,"der");case"1.2.840.10045.2.1":u.subjectPrivateKey=u.subjectPublicKey;return{type:"ec",data:u};case"1.2.840.10040.4.1":u.algorithm.params.pub_key=i.DSAparam.decode(u.subjectPublicKey.data,"der");return{type:"dsa",data:u.algorithm.params};default:throw new Error("unknown key id "+o)}throw new Error("unknown key type "+n);case"ENCRYPTED PRIVATE KEY":s=i.EncryptedPrivateKey.decode(s,"der");s=decrypt(s,t);case"PRIVATE KEY":u=i.PrivateKey.decode(s,"der");o=u.algorithm.algorithm.join(".");switch(o){case"1.2.840.113549.1.1.1":return i.RSAPrivateKey.decode(u.subjectPrivateKey,"der");case"1.2.840.10045.2.1":return{curve:u.algorithm.curve,privateKey:i.ECPrivateKey.decode(u.subjectPrivateKey,"der").privateKey};case"1.2.840.10040.4.1":u.algorithm.params.priv_key=i.DSAparam.decode(u.subjectPrivateKey,"der");return{type:"dsa",params:u.algorithm.params};default:throw new Error("unknown key id "+o)}throw new Error("unknown key type "+n);case"RSA PUBLIC KEY":return i.RSAPublicKey.decode(s,"der");case"RSA PRIVATE KEY":return i.RSAPrivateKey.decode(s,"der");case"DSA PRIVATE KEY":return{type:"dsa",params:i.DSAPrivateKey.decode(s,"der")};case"EC PRIVATE KEY":s=i.ECPrivateKey.decode(s,"der");return{curve:s.parameters.value,privateKey:s.privateKey};default:throw new Error("unknown key type "+n)}}parseKeys.signature=i.signature;function decrypt(e,t){var r=e.algorithm.decrypt.kde.kdeparams.salt;var i=parseInt(e.algorithm.decrypt.kde.kdeparams.iters.toString(),10);var a=n[e.algorithm.decrypt.cipher.algo.join(".")];var u=e.algorithm.decrypt.cipher.iv;var d=e.subjectPrivateKey;var c=parseInt(a.split("-")[1],10)/8;var l=o.pbkdf2Sync(t,r,i,c,"sha1");var p=s.createDecipheriv(a,l,u);var v=[];v.push(p.update(d));v.push(p.final());return h.concat(v)}},4978:function(e,t,r){var i=r(6113);var n=r(5349);var a=r(7007);var s=r(5407);function nativePBKDF2(e,t,r,o,h,u){n(r,o);e=s(e,a,"Password");t=s(t,a,"Salt");if(typeof h==="function"){u=h;h="sha1"}if(typeof u!=="function")throw new Error("No callback provided to pbkdf2");return i.pbkdf2(e,t,r,o,h,u)}function nativePBKDF2Sync(e,t,r,o,h){n(r,o);e=s(e,a,"Password");t=s(t,a,"Salt");h=h||"sha1";return i.pbkdf2Sync(e,t,r,o,h)}if(!i.pbkdf2Sync||i.pbkdf2Sync.toString().indexOf("keylen, digest")===-1){t.pbkdf2Sync=r(2127);t.pbkdf2=r(9601)}else{t.pbkdf2Sync=nativePBKDF2Sync;t.pbkdf2=nativePBKDF2}},9601:function(e,t,r){var i=r(5055).Buffer;var n=r(5349);var a=r(7007);var s=r(2127);var o=r(5407);var h;var u=__webpack_require__.g.crypto&&__webpack_require__.g.crypto.subtle;var d={sha:"SHA-1","sha-1":"SHA-1",sha1:"SHA-1",sha256:"SHA-256","sha-256":"SHA-256",sha384:"SHA-384","sha-384":"SHA-384","sha-512":"SHA-512",sha512:"SHA-512"};var c=[];function checkNative(e){if(__webpack_require__.g.process&&!__webpack_require__.g.process.browser){return Promise.resolve(false)}if(!u||!u.importKey||!u.deriveBits){return Promise.resolve(false)}if(c[e]!==undefined){return c[e]}h=h||i.alloc(8);var t=browserPbkdf2(h,h,10,128,e).then((function(){return true})).catch((function(){return false}));c[e]=t;return t}function browserPbkdf2(e,t,r,n,a){return u.importKey("raw",e,{name:"PBKDF2"},false,["deriveBits"]).then((function(e){return u.deriveBits({name:"PBKDF2",salt:t,iterations:r,hash:{name:a}},e,n<<3)})).then((function(e){return i.from(e)}))}function resolvePromise(e,t){e.then((function(e){process.nextTick((function(){t(null,e)}))}),(function(e){process.nextTick((function(){t(e)}))}))}e.exports=function(e,t,r,i,h,u){if(typeof h==="function"){u=h;h=undefined}h=h||"sha1";var c=d[h.toLowerCase()];if(!c||typeof __webpack_require__.g.Promise!=="function"){return process.nextTick((function(){var n;try{n=s(e,t,r,i,h)}catch(e){return u(e)}u(null,n)}))}n(r,i);e=o(e,a,"Password");t=o(t,a,"Salt");if(typeof u!=="function")throw new Error("No callback provided to pbkdf2");resolvePromise(checkNative(c).then((function(n){if(n)return browserPbkdf2(e,t,r,i,c);return s(e,t,r,i,h)})),u)}},7007:function(e){var t;if(true){t="utf-8"}else { var r; }e.exports=t},5349:function(e){var t=Math.pow(2,30)-1;e.exports=function(e,r){if(typeof e!=="number"){throw new TypeError("Iterations not a number")}if(e<0){throw new TypeError("Bad iterations")}if(typeof r!=="number"){throw new TypeError("Key length not a number")}if(r<0||r>t||r!==r){throw new TypeError("Bad key length")}}},2127:function(e,t,r){var i={md5:16,sha1:20,sha224:28,sha256:32,sha384:48,sha512:64,rmd160:20,ripemd160:20};var n=r(4873);var a=r(5055).Buffer;var s=r(5349);var o=r(7007);var h=r(5407);function pbkdf2(e,t,r,u,d){s(r,u);e=h(e,o,"Password");t=h(t,o,"Salt");d=d||"sha1";var c=a.allocUnsafe(u);var l=a.allocUnsafe(t.length+4);t.copy(l,0,0,t.length);var p=0;var v=i[d];var b=Math.ceil(u/v);for(var m=1;m<=b;m++){l.writeUInt32BE(m,t.length);var y=n(d,e).update(l).digest();var g=y;for(var _=1;_<r;_++){g=n(d,e).update(g).digest();for(var w=0;w<v;w++)y[w]^=g[w]}y.copy(c,p);p+=v}return c}e.exports=pbkdf2},5407:function(e,t,r){var i=r(5055).Buffer;e.exports=function(e,t,r){if(i.isBuffer(e)){return e}else if(typeof e==="string"){return i.from(e,t)}else if(ArrayBuffer.isView(e)){return i.from(e.buffer)}else{throw new TypeError(r+" must be a string, a Buffer, a typed array or a DataView")}}},9783:function(e,t,r){t.publicEncrypt=r(3995);t.privateDecrypt=r(4366);t.privateEncrypt=function privateEncrypt(e,r){return t.publicEncrypt(e,r,true)};t.publicDecrypt=function publicDecrypt(e,r){return t.privateDecrypt(e,r,true)}},5520:function(e,t,r){var i=r(9739);var n=r(5055).Buffer;e.exports=function(e,t){var r=n.alloc(0);var a=0;var s;while(r.length<t){s=i2ops(a++);r=n.concat([r,i("sha1").update(e).update(s).digest()])}return r.slice(0,t)};function i2ops(e){var t=n.allocUnsafe(4);t.writeUInt32BE(e,0);return t}},4366:function(e,t,r){var i=r(9902);var n=r(5520);var a=r(6386);var s=r(711);var o=r(7166);var h=r(9739);var u=r(1607);var d=r(5055).Buffer;e.exports=function privateDecrypt(e,t,r){var n;if(e.padding){n=e.padding}else if(r){n=1}else{n=4}var a=i(e);var h=a.modulus.byteLength();if(t.length>h||new s(t).cmp(a.modulus)>=0){throw new Error("decryption error")}var c;if(r){c=u(new s(t),a)}else{c=o(t,a)}var l=d.alloc(h-c.length);c=d.concat([l,c],h);if(n===4){return oaep(a,c)}else if(n===1){return pkcs1(a,c,r)}else if(n===3){return c}else{throw new Error("unknown padding")}};function oaep(e,t){var r=e.modulus.byteLength();var i=h("sha1").update(d.alloc(0)).digest();var s=i.length;if(t[0]!==0){throw new Error("decryption error")}var o=t.slice(1,s+1);var u=t.slice(s+1);var c=a(o,n(u,s));var l=a(u,n(c,r-s-1));if(compare(i,l.slice(0,s))){throw new Error("decryption error")}var p=s;while(l[p]===0){p++}if(l[p++]!==1){throw new Error("decryption error")}return l.slice(p)}function pkcs1(e,t,r){var i=t.slice(0,2);var n=2;var a=0;while(t[n++]!==0){if(n>=t.length){a++;break}}var s=t.slice(2,n-1);if(i.toString("hex")!=="0002"&&!r||i.toString("hex")!=="0001"&&r){a++}if(s.length<8){a++}if(a){throw new Error("decryption error")}return t.slice(n)}function compare(e,t){e=d.from(e);t=d.from(t);var r=0;var i=e.length;if(e.length!==t.length){r++;i=Math.min(e.length,t.length)}var n=-1;while(++n<i){r+=e[n]^t[n]}return r}},3995:function(e,t,r){var i=r(9902);var n=r(7223);var a=r(9739);var s=r(5520);var o=r(6386);var h=r(711);var u=r(1607);var d=r(7166);var c=r(5055).Buffer;e.exports=function publicEncrypt(e,t,r){var n;if(e.padding){n=e.padding}else if(r){n=1}else{n=4}var a=i(e);var s;if(n===4){s=oaep(a,t)}else if(n===1){s=pkcs1(a,t,r)}else if(n===3){s=new h(t);if(s.cmp(a.modulus)>=0){throw new Error("data too long for modulus")}}else{throw new Error("unknown padding")}if(r){return d(s,a)}else{return u(s,a)}};function oaep(e,t){var r=e.modulus.byteLength();var i=t.length;var u=a("sha1").update(c.alloc(0)).digest();var d=u.length;var l=2*d;if(i>r-l-2){throw new Error("message too long")}var p=c.alloc(r-i-l-2);var v=r-d-1;var b=n(d);var m=o(c.concat([u,p,c.alloc(1,1),t],v),s(b,v));var y=o(b,s(m,d));return new h(c.concat([c.alloc(1),y,m],r))}function pkcs1(e,t,r){var i=t.length;var n=e.modulus.byteLength();if(i>n-11){throw new Error("message too long")}var a;if(r){a=c.alloc(n-i-3,255)}else{a=nonZero(n-i-3)}return new h(c.concat([c.from([0,r?1:2]),a,c.alloc(1),t],n))}function nonZero(e){var t=c.allocUnsafe(e);var r=0;var i=n(e*2);var a=0;var s;while(r<e){if(a===i.length){i=n(e*2);a=0}s=i[a++];if(s){t[r++]=s}}return t}},1607:function(e,t,r){var i=r(711);var n=r(5055).Buffer;function withPublic(e,t){return n.from(e.toRed(i.mont(t.modulus)).redPow(new i(t.publicExponent)).fromRed().toArray())}e.exports=withPublic},6386:function(e){e.exports=function xor(e,t){var r=e.length;var i=-1;while(++i<r){e[i]^=t[i]}return e}},7223:function(e,t,r){"use strict";var i=65536;var n=4294967295;function oldBrowser(){throw new Error("Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11")}var a=r(5055).Buffer;var s=__webpack_require__.g.crypto||__webpack_require__.g.msCrypto;if(s&&s.getRandomValues){e.exports=randomBytes}else{e.exports=oldBrowser}function randomBytes(e,t){if(e>n)throw new RangeError("requested too many random bytes");var r=a.allocUnsafe(e);if(e>0){if(e>i){for(var o=0;o<e;o+=i){s.getRandomValues(r.slice(o,o+i))}}else{s.getRandomValues(r)}}if(typeof t==="function"){return process.nextTick((function(){t(null,r)}))}return r}},6445:function(e,t,r){"use strict";function oldBrowser(){throw new Error("secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11")}var i=r(5055);var n=r(7223);var a=i.Buffer;var s=i.kMaxLength;var o=__webpack_require__.g.crypto||__webpack_require__.g.msCrypto;var h=Math.pow(2,32)-1;function assertOffset(e,t){if(typeof e!=="number"||e!==e){throw new TypeError("offset must be a number")}if(e>h||e<0){throw new TypeError("offset must be a uint32")}if(e>s||e>t){throw new RangeError("offset out of range")}}function assertSize(e,t,r){if(typeof e!=="number"||e!==e){throw new TypeError("size must be a number")}if(e>h||e<0){throw new TypeError("size must be a uint32")}if(e+t>r||e>s){throw new RangeError("buffer too small")}}if(o&&o.getRandomValues||!true){t.randomFill=randomFill;t.randomFillSync=randomFillSync}else{t.randomFill=oldBrowser;t.randomFillSync=oldBrowser}function randomFill(e,t,r,i){if(!a.isBuffer(e)&&!(e instanceof __webpack_require__.g.Uint8Array)){throw new TypeError('"buf" argument must be a Buffer or Uint8Array')}if(typeof t==="function"){i=t;t=0;r=e.length}else if(typeof r==="function"){i=r;r=e.length-t}else if(typeof i!=="function"){throw new TypeError('"cb" argument must be a function')}assertOffset(t,e.length);assertSize(r,t,e.length);return actualFill(e,t,r,i)}function actualFill(e,t,r,i){if(true){var a=e.buffer;var s=new Uint8Array(a,t,r);o.getRandomValues(s);if(i){process.nextTick((function(){i(null,e)}));return}return e}if(i){n(r,(function(r,n){if(r){return i(r)}n.copy(e,t);i(null,e)}));return}var h=n(r);h.copy(e,t);return e}function randomFillSync(e,t,r){if(typeof t==="undefined"){t=0}if(!a.isBuffer(e)&&!(e instanceof __webpack_require__.g.Uint8Array)){throw new TypeError('"buf" argument must be a Buffer or Uint8Array')}assertOffset(t,e.length);if(r===undefined)r=e.length-t;assertSize(r,t,e.length);return actualFill(e,t,r)}},4646:function(e){"use strict";const t={};function createErrorType(e,r,i){if(!i){i=Error}function getMessage(e,t,i){if(typeof r==="string"){return r}else{return r(e,t,i)}}class NodeError extends i{constructor(e,t,r){super(getMessage(e,t,r))}}NodeError.prototype.name=i.name;NodeError.prototype.code=e;t[e]=NodeError}function oneOf(e,t){if(Array.isArray(e)){const r=e.length;e=e.map((e=>String(e)));if(r>2){return`one of ${t} ${e.slice(0,r-1).join(", ")}, or `+e[r-1]}else if(r===2){return`one of ${t} ${e[0]} or ${e[1]}`}else{return`of ${t} ${e[0]}`}}else{return`of ${t} ${String(e)}`}}function startsWith(e,t,r){return e.substr(!r||r<0?0:+r,t.length)===t}function endsWith(e,t,r){if(r===undefined||r>e.length){r=e.length}return e.substring(r-t.length,r)===t}function includes(e,t,r){if(typeof r!=="number"){r=0}if(r+t.length>e.length){return false}else{return e.indexOf(t,r)!==-1}}createErrorType("ERR_INVALID_OPT_VALUE",(function(e,t){return'The value "'+t+'" is invalid for option "'+e+'"'}),TypeError);createErrorType("ERR_INVALID_ARG_TYPE",(function(e,t,r){let i;if(typeof t==="string"&&startsWith(t,"not ")){i="must not be";t=t.replace(/^not /,"")}else{i="must be"}let n;if(endsWith(e," argument")){n=`The ${e} ${i} ${oneOf(t,"type")}`}else{const r=includes(e,".")?"property":"argument";n=`The "${e}" ${r} ${i} ${oneOf(t,"type")}`}n+=`. Received type ${typeof r}`;return n}),TypeError);createErrorType("ERR_STREAM_PUSH_AFTER_EOF","stream.push() after EOF");createErrorType("ERR_METHOD_NOT_IMPLEMENTED",(function(e){return"The "+e+" method is not implemented"}));createErrorType("ERR_STREAM_PREMATURE_CLOSE","Premature close");createErrorType("ERR_STREAM_DESTROYED",(function(e){return"Cannot call "+e+" after a stream was destroyed"}));createErrorType("ERR_MULTIPLE_CALLBACK","Callback called multiple times");createErrorType("ERR_STREAM_CANNOT_PIPE","Cannot pipe, not readable");createErrorType("ERR_STREAM_WRITE_AFTER_END","write after end");createErrorType("ERR_STREAM_NULL_VALUES","May not write null values to stream",TypeError);createErrorType("ERR_UNKNOWN_ENCODING",(function(e){return"Unknown encoding: "+e}),TypeError);createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT","stream.unshift() after end event");e.exports.q=t},2403:function(e,t,r){"use strict";var i=Object.keys||function(e){var t=[];for(var r in e){t.push(r)}return t};e.exports=Duplex;var n=r(1709);var a=r(7337);r(3782)(Duplex,n);{var s=i(a.prototype);for(var o=0;o<s.length;o++){var h=s[o];if(!Duplex.prototype[h])Duplex.prototype[h]=a.prototype[h]}}function Duplex(e){if(!(this instanceof Duplex))return new Duplex(e);n.call(this,e);a.call(this,e);this.allowHalfOpen=true;if(e){if(e.readable===false)this.readable=false;if(e.writable===false)this.writable=false;if(e.allowHalfOpen===false){this.allowHalfOpen=false;this.once("end",onend)}}}Object.defineProperty(Duplex.prototype,"writableHighWaterMark",{enumerable:false,get:function get(){return this._writableState.highWaterMark}});Object.defineProperty(Duplex.prototype,"writableBuffer",{enumerable:false,get:function get(){return this._writableState&&this._writableState.getBuffer()}});Object.defineProperty(Duplex.prototype,"writableLength",{enumerable:false,get:function get(){return this._writableState.length}});function onend(){if(this._writableState.ended)return;process.nextTick(onEndNT,this)}function onEndNT(e){e.end()}Object.defineProperty(Duplex.prototype,"destroyed",{enumerable:false,get:function get(){if(this._readableState===undefined||this._writableState===undefined){return false}return this._readableState.destroyed&&this._writableState.destroyed},set:function set(e){if(this._readableState===undefined||this._writableState===undefined){return}this._readableState.destroyed=e;this._writableState.destroyed=e}})},7889:function(e,t,r){"use strict";e.exports=PassThrough;var i=r(1170);r(3782)(PassThrough,i);function PassThrough(e){if(!(this instanceof PassThrough))return new PassThrough(e);i.call(this,e)}PassThrough.prototype._transform=function(e,t,r){r(null,e)}},1709:function(e,t,r){"use strict";e.exports=Readable;var i;Readable.ReadableState=ReadableState;var n=r(2361).EventEmitter;var a=function EElistenerCount(e,t){return e.listeners(t).length};var s=r(4678);var o=r(4300).Buffer;var h=__webpack_require__.g.Uint8Array||function(){};function _uint8ArrayToBuffer(e){return o.from(e)}function _isUint8Array(e){return o.isBuffer(e)||e instanceof h}var u=r(3837);var d;if(u&&u.debuglog){d=u.debuglog("stream")}else{d=function debug(){}}var c=r(4379);var l=r(7025);var p=r(6776),v=p.getHighWaterMark;var b=r(4646).q,m=b.ERR_INVALID_ARG_TYPE,y=b.ERR_STREAM_PUSH_AFTER_EOF,g=b.ERR_METHOD_NOT_IMPLEMENTED,_=b.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;var w;var M;var B;r(3782)(Readable,s);var E=l.errorOrDestroy;var k=["error","close","destroy","pause","resume"];function prependListener(e,t,r){if(typeof e.prependListener==="function")return e.prependListener(t,r);if(!e._events||!e._events[t])e.on(t,r);else if(Array.isArray(e._events[t]))e._events[t].unshift(r);else e._events[t]=[r,e._events[t]]}function ReadableState(e,t,n){i=i||r(2403);e=e||{};if(typeof n!=="boolean")n=t instanceof i;this.objectMode=!!e.objectMode;if(n)this.objectMode=this.objectMode||!!e.readableObjectMode;this.highWaterMark=v(this,e,"readableHighWaterMark",n);this.buffer=new c;this.length=0;this.pipes=null;this.pipesCount=0;this.flowing=null;this.ended=false;this.endEmitted=false;this.reading=false;this.sync=true;this.needReadable=false;this.emittedReadable=false;this.readableListening=false;this.resumeScheduled=false;this.paused=true;this.emitClose=e.emitClose!==false;this.autoDestroy=!!e.autoDestroy;this.destroyed=false;this.defaultEncoding=e.defaultEncoding||"utf8";this.awaitDrain=0;this.readingMore=false;this.decoder=null;this.encoding=null;if(e.encoding){if(!w)w=r(3704).s;this.decoder=new w(e.encoding);this.encoding=e.encoding}}function Readable(e){i=i||r(2403);if(!(this instanceof Readable))return new Readable(e);var t=this instanceof i;this._readableState=new ReadableState(e,this,t);this.readable=true;if(e){if(typeof e.read==="function")this._read=e.read;if(typeof e.destroy==="function")this._destroy=e.destroy}s.call(this)}Object.defineProperty(Readable.prototype,"destroyed",{enumerable:false,get:function get(){if(this._readableState===undefined){return false}return this._readableState.destroyed},set:function set(e){if(!this._readableState){return}this._readableState.destroyed=e}});Readable.prototype.destroy=l.destroy;Readable.prototype._undestroy=l.undestroy;Readable.prototype._destroy=function(e,t){t(e)};Readable.prototype.push=function(e,t){var r=this._readableState;var i;if(!r.objectMode){if(typeof e==="string"){t=t||r.defaultEncoding;if(t!==r.encoding){e=o.from(e,t);t=""}i=true}}else{i=true}return readableAddChunk(this,e,t,false,i)};Readable.prototype.unshift=function(e){return readableAddChunk(this,e,null,true,false)};function readableAddChunk(e,t,r,i,n){d("readableAddChunk",t);var a=e._readableState;if(t===null){a.reading=false;onEofChunk(e,a)}else{var s;if(!n)s=chunkInvalid(a,t);if(s){E(e,s)}else if(a.objectMode||t&&t.length>0){if(typeof t!=="string"&&!a.objectMode&&Object.getPrototypeOf(t)!==o.prototype){t=_uint8ArrayToBuffer(t)}if(i){if(a.endEmitted)E(e,new _);else addChunk(e,a,t,true)}else if(a.ended){E(e,new y)}else if(a.destroyed){return false}else{a.reading=false;if(a.decoder&&!r){t=a.decoder.write(t);if(a.objectMode||t.length!==0)addChunk(e,a,t,false);else maybeReadMore(e,a)}else{addChunk(e,a,t,false)}}}else if(!i){a.reading=false;maybeReadMore(e,a)}}return!a.ended&&(a.length<a.highWaterMark||a.length===0)}function addChunk(e,t,r,i){if(t.flowing&&t.length===0&&!t.sync){t.awaitDrain=0;e.emit("data",r)}else{t.length+=t.objectMode?1:r.length;if(i)t.buffer.unshift(r);else t.buffer.push(r);if(t.needReadable)emitReadable(e)}maybeReadMore(e,t)}function chunkInvalid(e,t){var r;if(!_isUint8Array(t)&&typeof t!=="string"&&t!==undefined&&!e.objectMode){r=new m("chunk",["string","Buffer","Uint8Array"],t)}return r}Readable.prototype.isPaused=function(){return this._readableState.flowing===false};Readable.prototype.setEncoding=function(e){if(!w)w=r(3704).s;var t=new w(e);this._readableState.decoder=t;this._readableState.encoding=this._readableState.decoder.encoding;var i=this._readableState.buffer.head;var n="";while(i!==null){n+=t.write(i.data);i=i.next}this._readableState.buffer.clear();if(n!=="")this._readableState.buffer.push(n);this._readableState.length=n.length;return this};var A=1073741824;function computeNewHighWaterMark(e){if(e>=A){e=A}else{e--;e|=e>>>1;e|=e>>>2;e|=e>>>4;e|=e>>>8;e|=e>>>16;e++}return e}function howMuchToRead(e,t){if(e<=0||t.length===0&&t.ended)return 0;if(t.objectMode)return 1;if(e!==e){if(t.flowing&&t.length)return t.buffer.head.data.length;else return t.length}if(e>t.highWaterMark)t.highWaterMark=computeNewHighWaterMark(e);if(e<=t.length)return e;if(!t.ended){t.needReadable=true;return 0}return t.length}Readable.prototype.read=function(e){d("read",e);e=parseInt(e,10);var t=this._readableState;var r=e;if(e!==0)t.emittedReadable=false;if(e===0&&t.needReadable&&((t.highWaterMark!==0?t.length>=t.highWaterMark:t.length>0)||t.ended)){d("read: emitReadable",t.length,t.ended);if(t.length===0&&t.ended)endReadable(this);else emitReadable(this);return null}e=howMuchToRead(e,t);if(e===0&&t.ended){if(t.length===0)endReadable(this);return null}var i=t.needReadable;d("need readable",i);if(t.length===0||t.length-e<t.highWaterMark){i=true;d("length less than watermark",i)}if(t.ended||t.reading){i=false;d("reading or ended",i)}else if(i){d("do read");t.reading=true;t.sync=true;if(t.length===0)t.needReadable=true;this._read(t.highWaterMark);t.sync=false;if(!t.reading)e=howMuchToRead(r,t)}var n;if(e>0)n=fromList(e,t);else n=null;if(n===null){t.needReadable=t.length<=t.highWaterMark;e=0}else{t.length-=e;t.awaitDrain=0}if(t.length===0){if(!t.ended)t.needReadable=true;if(r!==e&&t.ended)endReadable(this)}if(n!==null)this.emit("data",n);return n};function onEofChunk(e,t){d("onEofChunk");if(t.ended)return;if(t.decoder){var r=t.decoder.end();if(r&&r.length){t.buffer.push(r);t.length+=t.objectMode?1:r.length}}t.ended=true;if(t.sync){emitReadable(e)}else{t.needReadable=false;if(!t.emittedReadable){t.emittedReadable=true;emitReadable_(e)}}}function emitReadable(e){var t=e._readableState;d("emitReadable",t.needReadable,t.emittedReadable);t.needReadable=false;if(!t.emittedReadable){d("emitReadable",t.flowing);t.emittedReadable=true;process.nextTick(emitReadable_,e)}}function emitReadable_(e){var t=e._readableState;d("emitReadable_",t.destroyed,t.length,t.ended);if(!t.destroyed&&(t.length||t.ended)){e.emit("readable");t.emittedReadable=false}t.needReadable=!t.flowing&&!t.ended&&t.length<=t.highWaterMark;flow(e)}function maybeReadMore(e,t){if(!t.readingMore){t.readingMore=true;process.nextTick(maybeReadMore_,e,t)}}function maybeReadMore_(e,t){while(!t.reading&&!t.ended&&(t.length<t.highWaterMark||t.flowing&&t.length===0)){var r=t.length;d("maybeReadMore read 0");e.read(0);if(r===t.length)break}t.readingMore=false}Readable.prototype._read=function(e){E(this,new g("_read()"))};Readable.prototype.pipe=function(e,t){var r=this;var i=this._readableState;switch(i.pipesCount){case 0:i.pipes=e;break;case 1:i.pipes=[i.pipes,e];break;default:i.pipes.push(e);break}i.pipesCount+=1;d("pipe count=%d opts=%j",i.pipesCount,t);var n=(!t||t.end!==false)&&e!==process.stdout&&e!==process.stderr;var s=n?onend:unpipe;if(i.endEmitted)process.nextTick(s);else r.once("end",s);e.on("unpipe",onunpipe);function onunpipe(e,t){d("onunpipe");if(e===r){if(t&&t.hasUnpiped===false){t.hasUnpiped=true;cleanup()}}}function onend(){d("onend");e.end()}var o=pipeOnDrain(r);e.on("drain",o);var h=false;function cleanup(){d("cleanup");e.removeListener("close",onclose);e.removeListener("finish",onfinish);e.removeListener("drain",o);e.removeListener("error",onerror);e.removeListener("unpipe",onunpipe);r.removeListener("end",onend);r.removeListener("end",unpipe);r.removeListener("data",ondata);h=true;if(i.awaitDrain&&(!e._writableState||e._writableState.needDrain))o()}r.on("data",ondata);function ondata(t){d("ondata");var n=e.write(t);d("dest.write",n);if(n===false){if((i.pipesCount===1&&i.pipes===e||i.pipesCount>1&&indexOf(i.pipes,e)!==-1)&&!h){d("false write response, pause",i.awaitDrain);i.awaitDrain++}r.pause()}}function onerror(t){d("onerror",t);unpipe();e.removeListener("error",onerror);if(a(e,"error")===0)E(e,t)}prependListener(e,"error",onerror);function onclose(){e.removeListener("finish",onfinish);unpipe()}e.once("close",onclose);function onfinish(){d("onfinish");e.removeListener("close",onclose);unpipe()}e.once("finish",onfinish);function unpipe(){d("unpipe");r.unpipe(e)}e.emit("pipe",r);if(!i.flowing){d("pipe resume");r.resume()}return e};function pipeOnDrain(e){return function pipeOnDrainFunctionResult(){var t=e._readableState;d("pipeOnDrain",t.awaitDrain);if(t.awaitDrain)t.awaitDrain--;if(t.awaitDrain===0&&a(e,"data")){t.flowing=true;flow(e)}}}Readable.prototype.unpipe=function(e){var t=this._readableState;var r={hasUnpiped:false};if(t.pipesCount===0)return this;if(t.pipesCount===1){if(e&&e!==t.pipes)return this;if(!e)e=t.pipes;t.pipes=null;t.pipesCount=0;t.flowing=false;if(e)e.emit("unpipe",this,r);return this}if(!e){var i=t.pipes;var n=t.pipesCount;t.pipes=null;t.pipesCount=0;t.flowing=false;for(var a=0;a<n;a++){i[a].emit("unpipe",this,{hasUnpiped:false})}return this}var s=indexOf(t.pipes,e);if(s===-1)return this;t.pipes.splice(s,1);t.pipesCount-=1;if(t.pipesCount===1)t.pipes=t.pipes[0];e.emit("unpipe",this,r);return this};Readable.prototype.on=function(e,t){var r=s.prototype.on.call(this,e,t);var i=this._readableState;if(e==="data"){i.readableListening=this.listenerCount("readable")>0;if(i.flowing!==false)this.resume()}else if(e==="readable"){if(!i.endEmitted&&!i.readableListening){i.readableListening=i.needReadable=true;i.flowing=false;i.emittedReadable=false;d("on readable",i.length,i.reading);if(i.length){emitReadable(this)}else if(!i.reading){process.nextTick(nReadingNextTick,this)}}}return r};Readable.prototype.addListener=Readable.prototype.on;Readable.prototype.removeListener=function(e,t){var r=s.prototype.removeListener.call(this,e,t);if(e==="readable"){process.nextTick(updateReadableListening,this)}return r};Readable.prototype.removeAllListeners=function(e){var t=s.prototype.removeAllListeners.apply(this,arguments);if(e==="readable"||e===undefined){process.nextTick(updateReadableListening,this)}return t};function updateReadableListening(e){var t=e._readableState;t.readableListening=e.listenerCount("readable")>0;if(t.resumeScheduled&&!t.paused){t.flowing=true}else if(e.listenerCount("data")>0){e.resume()}}function nReadingNextTick(e){d("readable nexttick read 0");e.read(0)}Readable.prototype.resume=function(){var e=this._readableState;if(!e.flowing){d("resume");e.flowing=!e.readableListening;resume(this,e)}e.paused=false;return this};function resume(e,t){if(!t.resumeScheduled){t.resumeScheduled=true;process.nextTick(resume_,e,t)}}function resume_(e,t){d("resume",t.reading);if(!t.reading){e.read(0)}t.resumeScheduled=false;e.emit("resume");flow(e);if(t.flowing&&!t.reading)e.read(0)}Readable.prototype.pause=function(){d("call pause flowing=%j",this._readableState.flowing);if(this._readableState.flowing!==false){d("pause");this._readableState.flowing=false;this.emit("pause")}this._readableState.paused=true;return this};function flow(e){var t=e._readableState;d("flow",t.flowing);while(t.flowing&&e.read()!==null){}}Readable.prototype.wrap=function(e){var t=this;var r=this._readableState;var i=false;e.on("end",(function(){d("wrapped end");if(r.decoder&&!r.ended){var e=r.decoder.end();if(e&&e.length)t.push(e)}t.push(null)}));e.on("data",(function(n){d("wrapped data");if(r.decoder)n=r.decoder.write(n);if(r.objectMode&&(n===null||n===undefined))return;else if(!r.objectMode&&(!n||!n.length))return;var a=t.push(n);if(!a){i=true;e.pause()}}));for(var n in e){if(this[n]===undefined&&typeof e[n]==="function"){this[n]=function methodWrap(t){return function methodWrapReturnFunction(){return e[t].apply(e,arguments)}}(n)}}for(var a=0;a<k.length;a++){e.on(k[a],this.emit.bind(this,k[a]))}this._read=function(t){d("wrapped _read",t);if(i){i=false;e.resume()}};return this};if(typeof Symbol==="function"){Readable.prototype[Symbol.asyncIterator]=function(){if(M===undefined){M=r(6871)}return M(this)}}Object.defineProperty(Readable.prototype,"readableHighWaterMark",{enumerable:false,get:function get(){return this._readableState.highWaterMark}});Object.defineProperty(Readable.prototype,"readableBuffer",{enumerable:false,get:function get(){return this._readableState&&this._readableState.buffer}});Object.defineProperty(Readable.prototype,"readableFlowing",{enumerable:false,get:function get(){return this._readableState.flowing},set:function set(e){if(this._readableState){this._readableState.flowing=e}}});Readable._fromList=fromList;Object.defineProperty(Readable.prototype,"readableLength",{enumerable:false,get:function get(){return this._readableState.length}});function fromList(e,t){if(t.length===0)return null;var r;if(t.objectMode)r=t.buffer.shift();else if(!e||e>=t.length){if(t.decoder)r=t.buffer.join("");else if(t.buffer.length===1)r=t.buffer.first();else r=t.buffer.concat(t.length);t.buffer.clear()}else{r=t.buffer.consume(e,t.decoder)}return r}function endReadable(e){var t=e._readableState;d("endReadable",t.endEmitted);if(!t.endEmitted){t.ended=true;process.nextTick(endReadableNT,t,e)}}function endReadableNT(e,t){d("endReadableNT",e.endEmitted,e.length);if(!e.endEmitted&&e.length===0){e.endEmitted=true;t.readable=false;t.emit("end");if(e.autoDestroy){var r=t._writableState;if(!r||r.autoDestroy&&r.finished){t.destroy()}}}}if(typeof Symbol==="function"){Readable.from=function(e,t){if(B===undefined){B=r(9727)}return B(Readable,e,t)}}function indexOf(e,t){for(var r=0,i=e.length;r<i;r++){if(e[r]===t)return r}return-1}},1170:function(e,t,r){"use strict";e.exports=Transform;var i=r(4646).q,n=i.ERR_METHOD_NOT_IMPLEMENTED,a=i.ERR_MULTIPLE_CALLBACK,s=i.ERR_TRANSFORM_ALREADY_TRANSFORMING,o=i.ERR_TRANSFORM_WITH_LENGTH_0;var h=r(2403);r(3782)(Transform,h);function afterTransform(e,t){var r=this._transformState;r.transforming=false;var i=r.writecb;if(i===null){return this.emit("error",new a)}r.writechunk=null;r.writecb=null;if(t!=null)this.push(t);i(e);var n=this._readableState;n.reading=false;if(n.needReadable||n.length<n.highWaterMark){this._read(n.highWaterMark)}}function Transform(e){if(!(this instanceof Transform))return new Transform(e);h.call(this,e);this._transformState={afterTransform:afterTransform.bind(this),needTransform:false,transforming:false,writecb:null,writechunk:null,writeencoding:null};this._readableState.needReadable=true;this._readableState.sync=false;if(e){if(typeof e.transform==="function")this._transform=e.transform;if(typeof e.flush==="function")this._flush=e.flush}this.on("prefinish",prefinish)}function prefinish(){var e=this;if(typeof this._flush==="function"&&!this._readableState.destroyed){this._flush((function(t,r){done(e,t,r)}))}else{done(this,null,null)}}Transform.prototype.push=function(e,t){this._transformState.needTransform=false;return h.prototype.push.call(this,e,t)};Transform.prototype._transform=function(e,t,r){r(new n("_transform()"))};Transform.prototype._write=function(e,t,r){var i=this._transformState;i.writecb=r;i.writechunk=e;i.writeencoding=t;if(!i.transforming){var n=this._readableState;if(i.needTransform||n.needReadable||n.length<n.highWaterMark)this._read(n.highWaterMark)}};Transform.prototype._read=function(e){var t=this._transformState;if(t.writechunk!==null&&!t.transforming){t.transforming=true;this._transform(t.writechunk,t.writeencoding,t.afterTransform)}else{t.needTransform=true}};Transform.prototype._destroy=function(e,t){h.prototype._destroy.call(this,e,(function(e){t(e)}))};function done(e,t,r){if(t)return e.emit("error",t);if(r!=null)e.push(r);if(e._writableState.length)throw new o;if(e._transformState.transforming)throw new s;return e.push(null)}},7337:function(e,t,r){"use strict";e.exports=Writable;function WriteReq(e,t,r){this.chunk=e;this.encoding=t;this.callback=r;this.next=null}function CorkedRequest(e){var t=this;this.next=null;this.entry=null;this.finish=function(){onCorkedFinish(t,e)}}var i;Writable.WritableState=WritableState;var n={deprecate:r(6769)};var a=r(4678);var s=r(4300).Buffer;var o=__webpack_require__.g.Uint8Array||function(){};function _uint8ArrayToBuffer(e){return s.from(e)}function _isUint8Array(e){return s.isBuffer(e)||e instanceof o}var h=r(7025);var u=r(6776),d=u.getHighWaterMark;var c=r(4646).q,l=c.ERR_INVALID_ARG_TYPE,p=c.ERR_METHOD_NOT_IMPLEMENTED,v=c.ERR_MULTIPLE_CALLBACK,b=c.ERR_STREAM_CANNOT_PIPE,m=c.ERR_STREAM_DESTROYED,y=c.ERR_STREAM_NULL_VALUES,g=c.ERR_STREAM_WRITE_AFTER_END,_=c.ERR_UNKNOWN_ENCODING;var w=h.errorOrDestroy;r(3782)(Writable,a);function nop(){}function WritableState(e,t,n){i=i||r(2403);e=e||{};if(typeof n!=="boolean")n=t instanceof i;this.objectMode=!!e.objectMode;if(n)this.objectMode=this.objectMode||!!e.writableObjectMode;this.highWaterMark=d(this,e,"writableHighWaterMark",n);this.finalCalled=false;this.needDrain=false;this.ending=false;this.ended=false;this.finished=false;this.destroyed=false;var a=e.decodeStrings===false;this.decodeStrings=!a;this.defaultEncoding=e.defaultEncoding||"utf8";this.length=0;this.writing=false;this.corked=0;this.sync=true;this.bufferProcessing=false;this.onwrite=function(e){onwrite(t,e)};this.writecb=null;this.writelen=0;this.bufferedRequest=null;this.lastBufferedRequest=null;this.pendingcb=0;this.prefinished=false;this.errorEmitted=false;this.emitClose=e.emitClose!==false;this.autoDestroy=!!e.autoDestroy;this.bufferedRequestCount=0;this.corkedRequestsFree=new CorkedRequest(this)}WritableState.prototype.getBuffer=function getBuffer(){var e=this.bufferedRequest;var t=[];while(e){t.push(e);e=e.next}return t};(function(){try{Object.defineProperty(WritableState.prototype,"buffer",{get:n.deprecate((function writableStateBufferGetter(){return this.getBuffer()}),"_writableState.buffer is deprecated. Use _writableState.getBuffer "+"instead.","DEP0003")})}catch(e){}})();var M;if(typeof Symbol==="function"&&Symbol.hasInstance&&typeof Function.prototype[Symbol.hasInstance]==="function"){M=Function.prototype[Symbol.hasInstance];Object.defineProperty(Writable,Symbol.hasInstance,{value:function value(e){if(M.call(this,e))return true;if(this!==Writable)return false;return e&&e._writableState instanceof WritableState}})}else{M=function realHasInstance(e){return e instanceof this}}function Writable(e){i=i||r(2403);var t=this instanceof i;if(!t&&!M.call(Writable,this))return new Writable(e);this._writableState=new WritableState(e,this,t);this.writable=true;if(e){if(typeof e.write==="function")this._write=e.write;if(typeof e.writev==="function")this._writev=e.writev;if(typeof e.destroy==="function")this._destroy=e.destroy;if(typeof e.final==="function")this._final=e.final}a.call(this)}Writable.prototype.pipe=function(){w(this,new b)};function writeAfterEnd(e,t){var r=new g;w(e,r);process.nextTick(t,r)}function validChunk(e,t,r,i){var n;if(r===null){n=new y}else if(typeof r!=="string"&&!t.objectMode){n=new l("chunk",["string","Buffer"],r)}if(n){w(e,n);process.nextTick(i,n);return false}return true}Writable.prototype.write=function(e,t,r){var i=this._writableState;var n=false;var a=!i.objectMode&&_isUint8Array(e);if(a&&!s.isBuffer(e)){e=_uint8ArrayToBuffer(e)}if(typeof t==="function"){r=t;t=null}if(a)t="buffer";else if(!t)t=i.defaultEncoding;if(typeof r!=="function")r=nop;if(i.ending)writeAfterEnd(this,r);else if(a||validChunk(this,i,e,r)){i.pendingcb++;n=writeOrBuffer(this,i,a,e,t,r)}return n};Writable.prototype.cork=function(){this._writableState.corked++};Writable.prototype.uncork=function(){var e=this._writableState;if(e.corked){e.corked--;if(!e.writing&&!e.corked&&!e.bufferProcessing&&e.bufferedRequest)clearBuffer(this,e)}};Writable.prototype.setDefaultEncoding=function setDefaultEncoding(e){if(typeof e==="string")e=e.toLowerCase();if(!(["hex","utf8","utf-8","ascii","binary","base64","ucs2","ucs-2","utf16le","utf-16le","raw"].indexOf((e+"").toLowerCase())>-1))throw new _(e);this._writableState.defaultEncoding=e;return this};Object.defineProperty(Writable.prototype,"writableBuffer",{enumerable:false,get:function get(){return this._writableState&&this._writableState.getBuffer()}});function decodeChunk(e,t,r){if(!e.objectMode&&e.decodeStrings!==false&&typeof t==="string"){t=s.from(t,r)}return t}Object.defineProperty(Writable.prototype,"writableHighWaterMark",{enumerable:false,get:function get(){return this._writableState.highWaterMark}});function writeOrBuffer(e,t,r,i,n,a){if(!r){var s=decodeChunk(t,i,n);if(i!==s){r=true;n="buffer";i=s}}var o=t.objectMode?1:i.length;t.length+=o;var h=t.length<t.highWaterMark;if(!h)t.needDrain=true;if(t.writing||t.corked){var u=t.lastBufferedRequest;t.lastBufferedRequest={chunk:i,encoding:n,isBuf:r,callback:a,next:null};if(u){u.next=t.lastBufferedRequest}else{t.bufferedRequest=t.lastBufferedRequest}t.bufferedRequestCount+=1}else{doWrite(e,t,false,o,i,n,a)}return h}function doWrite(e,t,r,i,n,a,s){t.writelen=i;t.writecb=s;t.writing=true;t.sync=true;if(t.destroyed)t.onwrite(new m("write"));else if(r)e._writev(n,t.onwrite);else e._write(n,a,t.onwrite);t.sync=false}function onwriteError(e,t,r,i,n){--t.pendingcb;if(r){process.nextTick(n,i);process.nextTick(finishMaybe,e,t);e._writableState.errorEmitted=true;w(e,i)}else{n(i);e._writableState.errorEmitted=true;w(e,i);finishMaybe(e,t)}}function onwriteStateUpdate(e){e.writing=false;e.writecb=null;e.length-=e.writelen;e.writelen=0}function onwrite(e,t){var r=e._writableState;var i=r.sync;var n=r.writecb;if(typeof n!=="function")throw new v;onwriteStateUpdate(r);if(t)onwriteError(e,r,i,t,n);else{var a=needFinish(r)||e.destroyed;if(!a&&!r.corked&&!r.bufferProcessing&&r.bufferedRequest){clearBuffer(e,r)}if(i){process.nextTick(afterWrite,e,r,a,n)}else{afterWrite(e,r,a,n)}}}function afterWrite(e,t,r,i){if(!r)onwriteDrain(e,t);t.pendingcb--;i();finishMaybe(e,t)}function onwriteDrain(e,t){if(t.length===0&&t.needDrain){t.needDrain=false;e.emit("drain")}}function clearBuffer(e,t){t.bufferProcessing=true;var r=t.bufferedRequest;if(e._writev&&r&&r.next){var i=t.bufferedRequestCount;var n=new Array(i);var a=t.corkedRequestsFree;a.entry=r;var s=0;var o=true;while(r){n[s]=r;if(!r.isBuf)o=false;r=r.next;s+=1}n.allBuffers=o;doWrite(e,t,true,t.length,n,"",a.finish);t.pendingcb++;t.lastBufferedRequest=null;if(a.next){t.corkedRequestsFree=a.next;a.next=null}else{t.corkedRequestsFree=new CorkedRequest(t)}t.bufferedRequestCount=0}else{while(r){var h=r.chunk;var u=r.encoding;var d=r.callback;var c=t.objectMode?1:h.length;doWrite(e,t,false,c,h,u,d);r=r.next;t.bufferedRequestCount--;if(t.writing){break}}if(r===null)t.lastBufferedRequest=null}t.bufferedRequest=r;t.bufferProcessing=false}Writable.prototype._write=function(e,t,r){r(new p("_write()"))};Writable.prototype._writev=null;Writable.prototype.end=function(e,t,r){var i=this._writableState;if(typeof e==="function"){r=e;e=null;t=null}else if(typeof t==="function"){r=t;t=null}if(e!==null&&e!==undefined)this.write(e,t);if(i.corked){i.corked=1;this.uncork()}if(!i.ending)endWritable(this,i,r);return this};Object.defineProperty(Writable.prototype,"writableLength",{enumerable:false,get:function get(){return this._writableState.length}});function needFinish(e){return e.ending&&e.length===0&&e.bufferedRequest===null&&!e.finished&&!e.writing}function callFinal(e,t){e._final((function(r){t.pendingcb--;if(r){w(e,r)}t.prefinished=true;e.emit("prefinish");finishMaybe(e,t)}))}function prefinish(e,t){if(!t.prefinished&&!t.finalCalled){if(typeof e._final==="function"&&!t.destroyed){t.pendingcb++;t.finalCalled=true;process.nextTick(callFinal,e,t)}else{t.prefinished=true;e.emit("prefinish")}}}function finishMaybe(e,t){var r=needFinish(t);if(r){prefinish(e,t);if(t.pendingcb===0){t.finished=true;e.emit("finish");if(t.autoDestroy){var i=e._readableState;if(!i||i.autoDestroy&&i.endEmitted){e.destroy()}}}}return r}function endWritable(e,t,r){t.ending=true;finishMaybe(e,t);if(r){if(t.finished)process.nextTick(r);else e.once("finish",r)}t.ended=true;e.writable=false}function onCorkedFinish(e,t,r){var i=e.entry;e.entry=null;while(i){var n=i.callback;t.pendingcb--;n(r);i=i.next}t.corkedRequestsFree.next=e}Object.defineProperty(Writable.prototype,"destroyed",{enumerable:false,get:function get(){if(this._writableState===undefined){return false}return this._writableState.destroyed},set:function set(e){if(!this._writableState){return}this._writableState.destroyed=e}});Writable.prototype.destroy=h.destroy;Writable.prototype._undestroy=h.undestroy;Writable.prototype._destroy=function(e,t){t(e)}},6871:function(e,t,r){"use strict";var i;function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}var n=r(9698);var a=Symbol("lastResolve");var s=Symbol("lastReject");var o=Symbol("error");var h=Symbol("ended");var u=Symbol("lastPromise");var d=Symbol("handlePromise");var c=Symbol("stream");function createIterResult(e,t){return{value:e,done:t}}function readAndResolve(e){var t=e[a];if(t!==null){var r=e[c].read();if(r!==null){e[u]=null;e[a]=null;e[s]=null;t(createIterResult(r,false))}}}function onReadable(e){process.nextTick(readAndResolve,e)}function wrapForNext(e,t){return function(r,i){e.then((function(){if(t[h]){r(createIterResult(undefined,true));return}t[d](r,i)}),i)}}var l=Object.getPrototypeOf((function(){}));var p=Object.setPrototypeOf((i={get stream(){return this[c]},next:function next(){var e=this;var t=this[o];if(t!==null){return Promise.reject(t)}if(this[h]){return Promise.resolve(createIterResult(undefined,true))}if(this[c].destroyed){return new Promise((function(t,r){process.nextTick((function(){if(e[o]){r(e[o])}else{t(createIterResult(undefined,true))}}))}))}var r=this[u];var i;if(r){i=new Promise(wrapForNext(r,this))}else{var n=this[c].read();if(n!==null){return Promise.resolve(createIterResult(n,false))}i=new Promise(this[d])}this[u]=i;return i}},_defineProperty(i,Symbol.asyncIterator,(function(){return this})),_defineProperty(i,"return",(function _return(){var e=this;return new Promise((function(t,r){e[c].destroy(null,(function(e){if(e){r(e);return}t(createIterResult(undefined,true))}))}))})),i),l);var v=function createReadableStreamAsyncIterator(e){var t;var r=Object.create(p,(t={},_defineProperty(t,c,{value:e,writable:true}),_defineProperty(t,a,{value:null,writable:true}),_defineProperty(t,s,{value:null,writable:true}),_defineProperty(t,o,{value:null,writable:true}),_defineProperty(t,h,{value:e._readableState.endEmitted,writable:true}),_defineProperty(t,d,{value:function value(e,t){var i=r[c].read();if(i){r[u]=null;r[a]=null;r[s]=null;e(createIterResult(i,false))}else{r[a]=e;r[s]=t}},writable:true}),t));r[u]=null;n(e,(function(e){if(e&&e.code!=="ERR_STREAM_PREMATURE_CLOSE"){var t=r[s];if(t!==null){r[u]=null;r[a]=null;r[s]=null;t(e)}r[o]=e;return}var i=r[a];if(i!==null){r[u]=null;r[a]=null;r[s]=null;i(createIterResult(undefined,true))}r[h]=true}));e.on("readable",onReadable.bind(null,r));return r};e.exports=v},4379:function(e,t,r){"use strict";function ownKeys(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);if(t)i=i.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}));r.push.apply(r,i)}return r}function _objectSpread(e){for(var t=1;t<arguments.length;t++){var r=arguments[t]!=null?arguments[t]:{};if(t%2){ownKeys(Object(r),true).forEach((function(t){_defineProperty(e,t,r[t])}))}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(e,Object.getOwnPropertyDescriptors(r))}else{ownKeys(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}}return e}function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}function _classCallCheck(e,t){if(!(e instanceof t)){throw new TypeError("Cannot call a class as a function")}}function _defineProperties(e,t){for(var r=0;r<t.length;r++){var i=t[r];i.enumerable=i.enumerable||false;i.configurable=true;if("value"in i)i.writable=true;Object.defineProperty(e,i.key,i)}}function _createClass(e,t,r){if(t)_defineProperties(e.prototype,t);if(r)_defineProperties(e,r);return e}var i=r(4300),n=i.Buffer;var a=r(3837),s=a.inspect;var o=s&&s.custom||"inspect";function copyBuffer(e,t,r){n.prototype.copy.call(e,t,r)}e.exports=function(){function BufferList(){_classCallCheck(this,BufferList);this.head=null;this.tail=null;this.length=0}_createClass(BufferList,[{key:"push",value:function push(e){var t={data:e,next:null};if(this.length>0)this.tail.next=t;else this.head=t;this.tail=t;++this.length}},{key:"unshift",value:function unshift(e){var t={data:e,next:this.head};if(this.length===0)this.tail=t;this.head=t;++this.length}},{key:"shift",value:function shift(){if(this.length===0)return;var e=this.head.data;if(this.length===1)this.head=this.tail=null;else this.head=this.head.next;--this.length;return e}},{key:"clear",value:function clear(){this.head=this.tail=null;this.length=0}},{key:"join",value:function join(e){if(this.length===0)return"";var t=this.head;var r=""+t.data;while(t=t.next){r+=e+t.data}return r}},{key:"concat",value:function concat(e){if(this.length===0)return n.alloc(0);var t=n.allocUnsafe(e>>>0);var r=this.head;var i=0;while(r){copyBuffer(r.data,t,i);i+=r.data.length;r=r.next}return t}},{key:"consume",value:function consume(e,t){var r;if(e<this.head.data.length){r=this.head.data.slice(0,e);this.head.data=this.head.data.slice(e)}else if(e===this.head.data.length){r=this.shift()}else{r=t?this._getString(e):this._getBuffer(e)}return r}},{key:"first",value:function first(){return this.head.data}},{key:"_getString",value:function _getString(e){var t=this.head;var r=1;var i=t.data;e-=i.length;while(t=t.next){var n=t.data;var a=e>n.length?n.length:e;if(a===n.length)i+=n;else i+=n.slice(0,e);e-=a;if(e===0){if(a===n.length){++r;if(t.next)this.head=t.next;else this.head=this.tail=null}else{this.head=t;t.data=n.slice(a)}break}++r}this.length-=r;return i}},{key:"_getBuffer",value:function _getBuffer(e){var t=n.allocUnsafe(e);var r=this.head;var i=1;r.data.copy(t);e-=r.data.length;while(r=r.next){var a=r.data;var s=e>a.length?a.length:e;a.copy(t,t.length-e,0,s);e-=s;if(e===0){if(s===a.length){++i;if(r.next)this.head=r.next;else this.head=this.tail=null}else{this.head=r;r.data=a.slice(s)}break}++i}this.length-=i;return t}},{key:o,value:function value(e,t){return s(this,_objectSpread({},t,{depth:0,customInspect:false}))}}]);return BufferList}()},7025:function(e){"use strict";function destroy(e,t){var r=this;var i=this._readableState&&this._readableState.destroyed;var n=this._writableState&&this._writableState.destroyed;if(i||n){if(t){t(e)}else if(e){if(!this._writableState){process.nextTick(emitErrorNT,this,e)}else if(!this._writableState.errorEmitted){this._writableState.errorEmitted=true;process.nextTick(emitErrorNT,this,e)}}return this}if(this._readableState){this._readableState.destroyed=true}if(this._writableState){this._writableState.destroyed=true}this._destroy(e||null,(function(e){if(!t&&e){if(!r._writableState){process.nextTick(emitErrorAndCloseNT,r,e)}else if(!r._writableState.errorEmitted){r._writableState.errorEmitted=true;process.nextTick(emitErrorAndCloseNT,r,e)}else{process.nextTick(emitCloseNT,r)}}else if(t){process.nextTick(emitCloseNT,r);t(e)}else{process.nextTick(emitCloseNT,r)}}));return this}function emitErrorAndCloseNT(e,t){emitErrorNT(e,t);emitCloseNT(e)}function emitCloseNT(e){if(e._writableState&&!e._writableState.emitClose)return;if(e._readableState&&!e._readableState.emitClose)return;e.emit("close")}function undestroy(){if(this._readableState){this._readableState.destroyed=false;this._readableState.reading=false;this._readableState.ended=false;this._readableState.endEmitted=false}if(this._writableState){this._writableState.destroyed=false;this._writableState.ended=false;this._writableState.ending=false;this._writableState.finalCalled=false;this._writableState.prefinished=false;this._writableState.finished=false;this._writableState.errorEmitted=false}}function emitErrorNT(e,t){e.emit("error",t)}function errorOrDestroy(e,t){var r=e._readableState;var i=e._writableState;if(r&&r.autoDestroy||i&&i.autoDestroy)e.destroy(t);else e.emit("error",t)}e.exports={destroy:destroy,undestroy:undestroy,errorOrDestroy:errorOrDestroy}},9698:function(e,t,r){"use strict";var i=r(4646).q.ERR_STREAM_PREMATURE_CLOSE;function once(e){var t=false;return function(){if(t)return;t=true;for(var r=arguments.length,i=new Array(r),n=0;n<r;n++){i[n]=arguments[n]}e.apply(this,i)}}function noop(){}function isRequest(e){return e.setHeader&&typeof e.abort==="function"}function eos(e,t,r){if(typeof t==="function")return eos(e,null,t);if(!t)t={};r=once(r||noop);var n=t.readable||t.readable!==false&&e.readable;var a=t.writable||t.writable!==false&&e.writable;var s=function onlegacyfinish(){if(!e.writable)h()};var o=e._writableState&&e._writableState.finished;var h=function onfinish(){a=false;o=true;if(!n)r.call(e)};var u=e._readableState&&e._readableState.endEmitted;var d=function onend(){n=false;u=true;if(!a)r.call(e)};var c=function onerror(t){r.call(e,t)};var l=function onclose(){var t;if(n&&!u){if(!e._readableState||!e._readableState.ended)t=new i;return r.call(e,t)}if(a&&!o){if(!e._writableState||!e._writableState.ended)t=new i;return r.call(e,t)}};var p=function onrequest(){e.req.on("finish",h)};if(isRequest(e)){e.on("complete",h);e.on("abort",l);if(e.req)p();else e.on("request",p)}else if(a&&!e._writableState){e.on("end",s);e.on("close",s)}e.on("end",d);e.on("finish",h);if(t.error!==false)e.on("error",c);e.on("close",l);return function(){e.removeListener("complete",h);e.removeListener("abort",l);e.removeListener("request",p);if(e.req)e.req.removeListener("finish",h);e.removeListener("end",s);e.removeListener("close",s);e.removeListener("finish",h);e.removeListener("end",d);e.removeListener("error",c);e.removeListener("close",l)}}e.exports=eos},9727:function(e,t,r){"use strict";function asyncGeneratorStep(e,t,r,i,n,a,s){try{var o=e[a](s);var h=o.value}catch(e){r(e);return}if(o.done){t(h)}else{Promise.resolve(h).then(i,n)}}function _asyncToGenerator(e){return function(){var t=this,r=arguments;return new Promise((function(i,n){var a=e.apply(t,r);function _next(e){asyncGeneratorStep(a,i,n,_next,_throw,"next",e)}function _throw(e){asyncGeneratorStep(a,i,n,_next,_throw,"throw",e)}_next(undefined)}))}}function ownKeys(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);if(t)i=i.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}));r.push.apply(r,i)}return r}function _objectSpread(e){for(var t=1;t<arguments.length;t++){var r=arguments[t]!=null?arguments[t]:{};if(t%2){ownKeys(Object(r),true).forEach((function(t){_defineProperty(e,t,r[t])}))}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(e,Object.getOwnPropertyDescriptors(r))}else{ownKeys(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}}return e}function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}var i=r(4646).q.ERR_INVALID_ARG_TYPE;function from(e,t,r){var n;if(t&&typeof t.next==="function"){n=t}else if(t&&t[Symbol.asyncIterator])n=t[Symbol.asyncIterator]();else if(t&&t[Symbol.iterator])n=t[Symbol.iterator]();else throw new i("iterable",["Iterable"],t);var a=new e(_objectSpread({objectMode:true},r));var s=false;a._read=function(){if(!s){s=true;next()}};function next(){return _next2.apply(this,arguments)}function _next2(){_next2=_asyncToGenerator((function*(){try{var e=yield n.next(),t=e.value,r=e.done;if(r){a.push(null)}else if(a.push(yield t)){next()}else{s=false}}catch(e){a.destroy(e)}}));return _next2.apply(this,arguments)}return a}e.exports=from},8442:function(e,t,r){"use strict";var i;function once(e){var t=false;return function(){if(t)return;t=true;e.apply(void 0,arguments)}}var n=r(4646).q,a=n.ERR_MISSING_ARGS,s=n.ERR_STREAM_DESTROYED;function noop(e){if(e)throw e}function isRequest(e){return e.setHeader&&typeof e.abort==="function"}function destroyer(e,t,n,a){a=once(a);var o=false;e.on("close",(function(){o=true}));if(i===undefined)i=r(9698);i(e,{readable:t,writable:n},(function(e){if(e)return a(e);o=true;a()}));var h=false;return function(t){if(o)return;if(h)return;h=true;if(isRequest(e))return e.abort();if(typeof e.destroy==="function")return e.destroy();a(t||new s("pipe"))}}function call(e){e()}function pipe(e,t){return e.pipe(t)}function popCallback(e){if(!e.length)return noop;if(typeof e[e.length-1]!=="function")return noop;return e.pop()}function pipeline(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++){t[r]=arguments[r]}var i=popCallback(t);if(Array.isArray(t[0]))t=t[0];if(t.length<2){throw new a("streams")}var n;var s=t.map((function(e,r){var a=r<t.length-1;var o=r>0;return destroyer(e,a,o,(function(e){if(!n)n=e;if(e)s.forEach(call);if(a)return;s.forEach(call);i(n)}))}));return t.reduce(pipe)}e.exports=pipeline},6776:function(e,t,r){"use strict";var i=r(4646).q.ERR_INVALID_OPT_VALUE;function highWaterMarkFrom(e,t,r){return e.highWaterMark!=null?e.highWaterMark:t?e[r]:null}function getHighWaterMark(e,t,r,n){var a=highWaterMarkFrom(t,n,r);if(a!=null){if(!(isFinite(a)&&Math.floor(a)===a)||a<0){var s=n?r:"highWaterMark";throw new i(s,a)}return Math.floor(a)}return e.objectMode?16:16*1024}e.exports={getHighWaterMark:getHighWaterMark}},4678:function(e,t,r){e.exports=r(2781)},3726:function(e,t,r){var i=r(2781);if(process.env.READABLE_STREAM==="disable"&&i){e.exports=i.Readable;Object.assign(e.exports,i);e.exports.Stream=i}else{t=e.exports=r(1709);t.Stream=i||t;t.Readable=t;t.Writable=r(7337);t.Duplex=r(2403);t.Transform=r(1170);t.PassThrough=r(7889);t.finished=r(9698);t.pipeline=r(8442)}},3225:function(e,t,r){"use strict";var i=r(4300).Buffer;var n=r(3782);var a=r(9029);var s=new Array(16);var o=[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,7,4,13,1,10,6,15,3,12,0,9,5,2,14,11,8,3,10,14,4,9,15,8,1,2,7,0,6,13,11,5,12,1,9,11,10,0,8,12,4,13,3,7,15,14,5,6,2,4,0,5,9,7,12,2,10,14,1,3,8,11,6,15,13];var h=[5,14,7,0,9,2,11,4,13,6,15,8,1,10,3,12,6,11,3,7,0,13,5,10,14,15,8,12,4,9,1,2,15,5,1,3,7,14,6,9,11,8,12,2,10,0,4,13,8,6,4,1,3,11,15,0,5,12,2,13,9,7,10,14,12,15,10,4,1,5,8,7,6,2,13,14,0,3,9,11];var u=[11,14,15,12,5,8,7,9,11,13,14,15,6,7,9,8,7,6,8,13,11,9,7,15,7,12,15,9,11,7,13,12,11,13,6,7,14,9,13,15,14,8,13,6,5,12,7,5,11,12,14,15,14,15,9,8,9,14,5,6,8,6,5,12,9,15,5,11,6,8,13,12,5,12,13,14,11,8,5,6];var d=[8,9,9,11,13,15,15,5,7,7,8,11,14,14,12,6,9,13,15,7,12,8,9,11,7,7,12,7,6,15,13,11,9,7,15,11,8,6,6,14,12,13,5,14,13,13,7,5,15,5,8,11,14,14,6,14,6,9,12,9,12,5,15,8,8,5,12,9,12,5,14,6,8,13,6,5,15,13,11,11];var c=[0,1518500249,1859775393,2400959708,2840853838];var l=[1352829926,1548603684,1836072691,2053994217,0];function RIPEMD160(){a.call(this,64);this._a=1732584193;this._b=4023233417;this._c=2562383102;this._d=271733878;this._e=3285377520}n(RIPEMD160,a);RIPEMD160.prototype._update=function(){var e=s;for(var t=0;t<16;++t)e[t]=this._block.readInt32LE(t*4);var r=this._a|0;var i=this._b|0;var n=this._c|0;var a=this._d|0;var p=this._e|0;var v=this._a|0;var b=this._b|0;var m=this._c|0;var y=this._d|0;var g=this._e|0;for(var _=0;_<80;_+=1){var w;var M;if(_<16){w=fn1(r,i,n,a,p,e[o[_]],c[0],u[_]);M=fn5(v,b,m,y,g,e[h[_]],l[0],d[_])}else if(_<32){w=fn2(r,i,n,a,p,e[o[_]],c[1],u[_]);M=fn4(v,b,m,y,g,e[h[_]],l[1],d[_])}else if(_<48){w=fn3(r,i,n,a,p,e[o[_]],c[2],u[_]);M=fn3(v,b,m,y,g,e[h[_]],l[2],d[_])}else if(_<64){w=fn4(r,i,n,a,p,e[o[_]],c[3],u[_]);M=fn2(v,b,m,y,g,e[h[_]],l[3],d[_])}else{w=fn5(r,i,n,a,p,e[o[_]],c[4],u[_]);M=fn1(v,b,m,y,g,e[h[_]],l[4],d[_])}r=p;p=a;a=rotl(n,10);n=i;i=w;v=g;g=y;y=rotl(m,10);m=b;b=M}var B=this._b+n+y|0;this._b=this._c+a+g|0;this._c=this._d+p+v|0;this._d=this._e+r+b|0;this._e=this._a+i+m|0;this._a=B};RIPEMD160.prototype._digest=function(){this._block[this._blockOffset++]=128;if(this._blockOffset>56){this._block.fill(0,this._blockOffset,64);this._update();this._blockOffset=0}this._block.fill(0,this._blockOffset,56);this._block.writeUInt32LE(this._length[0],56);this._block.writeUInt32LE(this._length[1],60);this._update();var e=i.alloc?i.alloc(20):new i(20);e.writeInt32LE(this._a,0);e.writeInt32LE(this._b,4);e.writeInt32LE(this._c,8);e.writeInt32LE(this._d,12);e.writeInt32LE(this._e,16);return e};function rotl(e,t){return e<<t|e>>>32-t}function fn1(e,t,r,i,n,a,s,o){return rotl(e+(t^r^i)+a+s|0,o)+n|0}function fn2(e,t,r,i,n,a,s,o){return rotl(e+(t&r|~t&i)+a+s|0,o)+n|0}function fn3(e,t,r,i,n,a,s,o){return rotl(e+((t|~r)^i)+a+s|0,o)+n|0}function fn4(e,t,r,i,n,a,s,o){return rotl(e+(t&i|r&~i)+a+s|0,o)+n|0}function fn5(e,t,r,i,n,a,s,o){return rotl(e+(t^(r|~i))+a+s|0,o)+n|0}e.exports=RIPEMD160},5055:function(e,t,r){var i=r(4300);var n=i.Buffer;function copyProps(e,t){for(var r in e){t[r]=e[r]}}if(n.from&&n.alloc&&n.allocUnsafe&&n.allocUnsafeSlow){e.exports=i}else{copyProps(i,t);t.Buffer=SafeBuffer}function SafeBuffer(e,t,r){return n(e,t,r)}SafeBuffer.prototype=Object.create(n.prototype);copyProps(n,SafeBuffer);SafeBuffer.from=function(e,t,r){if(typeof e==="number"){throw new TypeError("Argument must not be a number")}return n(e,t,r)};SafeBuffer.alloc=function(e,t,r){if(typeof e!=="number"){throw new TypeError("Argument must be a number")}var i=n(e);if(t!==undefined){if(typeof r==="string"){i.fill(t,r)}else{i.fill(t)}}else{i.fill(0)}return i};SafeBuffer.allocUnsafe=function(e){if(typeof e!=="number"){throw new TypeError("Argument must be a number")}return n(e)};SafeBuffer.allocUnsafeSlow=function(e){if(typeof e!=="number"){throw new TypeError("Argument must be a number")}return i.SlowBuffer(e)}},2858:function(e,t,r){var i=r(5055).Buffer;function Hash(e,t){this._block=i.alloc(e);this._finalSize=t;this._blockSize=e;this._len=0}Hash.prototype.update=function(e,t){if(typeof e==="string"){t=t||"utf8";e=i.from(e,t)}var r=this._block;var n=this._blockSize;var a=e.length;var s=this._len;for(var o=0;o<a;){var h=s%n;var u=Math.min(a-o,n-h);for(var d=0;d<u;d++){r[h+d]=e[o+d]}s+=u;o+=u;if(s%n===0){this._update(r)}}this._len+=a;return this};Hash.prototype.digest=function(e){var t=this._len%this._blockSize;this._block[t]=128;this._block.fill(0,t+1);if(t>=this._finalSize){this._update(this._block);this._block.fill(0)}var r=this._len*8;if(r<=4294967295){this._block.writeUInt32BE(r,this._blockSize-4)}else{var i=(r&4294967295)>>>0;var n=(r-i)/4294967296;this._block.writeUInt32BE(n,this._blockSize-8);this._block.writeUInt32BE(i,this._blockSize-4)}this._update(this._block);var a=this._hash();return e?a.toString(e):a};Hash.prototype._update=function(){throw new Error("_update must be implemented by subclass")};e.exports=Hash},4371:function(e,t,r){var i=e.exports=function SHA(e){e=e.toLowerCase();var t=i[e];if(!t)throw new Error(e+" is not supported (we accept pull requests)");return new t};i.sha=r(4018);i.sha1=r(4179);i.sha224=r(532);i.sha256=r(1843);i.sha384=r(7455);i.sha512=r(9934)},4018:function(e,t,r){var i=r(3782);var n=r(2858);var a=r(5055).Buffer;var s=[1518500249,1859775393,2400959708|0,3395469782|0];var o=new Array(80);function Sha(){this.init();this._w=o;n.call(this,64,56)}i(Sha,n);Sha.prototype.init=function(){this._a=1732584193;this._b=4023233417;this._c=2562383102;this._d=271733878;this._e=3285377520;return this};function rotl5(e){return e<<5|e>>>27}function rotl30(e){return e<<30|e>>>2}function ft(e,t,r,i){if(e===0)return t&r|~t&i;if(e===2)return t&r|t&i|r&i;return t^r^i}Sha.prototype._update=function(e){var t=this._w;var r=this._a|0;var i=this._b|0;var n=this._c|0;var a=this._d|0;var o=this._e|0;for(var h=0;h<16;++h)t[h]=e.readInt32BE(h*4);for(;h<80;++h)t[h]=t[h-3]^t[h-8]^t[h-14]^t[h-16];for(var u=0;u<80;++u){var d=~~(u/20);var c=rotl5(r)+ft(d,i,n,a)+o+t[u]+s[d]|0;o=a;a=n;n=rotl30(i);i=r;r=c}this._a=r+this._a|0;this._b=i+this._b|0;this._c=n+this._c|0;this._d=a+this._d|0;this._e=o+this._e|0};Sha.prototype._hash=function(){var e=a.allocUnsafe(20);e.writeInt32BE(this._a|0,0);e.writeInt32BE(this._b|0,4);e.writeInt32BE(this._c|0,8);e.writeInt32BE(this._d|0,12);e.writeInt32BE(this._e|0,16);return e};e.exports=Sha},4179:function(e,t,r){var i=r(3782);var n=r(2858);var a=r(5055).Buffer;var s=[1518500249,1859775393,2400959708|0,3395469782|0];var o=new Array(80);function Sha1(){this.init();this._w=o;n.call(this,64,56)}i(Sha1,n);Sha1.prototype.init=function(){this._a=1732584193;this._b=4023233417;this._c=2562383102;this._d=271733878;this._e=3285377520;return this};function rotl1(e){return e<<1|e>>>31}function rotl5(e){return e<<5|e>>>27}function rotl30(e){return e<<30|e>>>2}function ft(e,t,r,i){if(e===0)return t&r|~t&i;if(e===2)return t&r|t&i|r&i;return t^r^i}Sha1.prototype._update=function(e){var t=this._w;var r=this._a|0;var i=this._b|0;var n=this._c|0;var a=this._d|0;var o=this._e|0;for(var h=0;h<16;++h)t[h]=e.readInt32BE(h*4);for(;h<80;++h)t[h]=rotl1(t[h-3]^t[h-8]^t[h-14]^t[h-16]);for(var u=0;u<80;++u){var d=~~(u/20);var c=rotl5(r)+ft(d,i,n,a)+o+t[u]+s[d]|0;o=a;a=n;n=rotl30(i);i=r;r=c}this._a=r+this._a|0;this._b=i+this._b|0;this._c=n+this._c|0;this._d=a+this._d|0;this._e=o+this._e|0};Sha1.prototype._hash=function(){var e=a.allocUnsafe(20);e.writeInt32BE(this._a|0,0);e.writeInt32BE(this._b|0,4);e.writeInt32BE(this._c|0,8);e.writeInt32BE(this._d|0,12);e.writeInt32BE(this._e|0,16);return e};e.exports=Sha1},532:function(e,t,r){var i=r(3782);var n=r(1843);var a=r(2858);var s=r(5055).Buffer;var o=new Array(64);function Sha224(){this.init();this._w=o;a.call(this,64,56)}i(Sha224,n);Sha224.prototype.init=function(){this._a=3238371032;this._b=914150663;this._c=812702999;this._d=4144912697;this._e=4290775857;this._f=1750603025;this._g=1694076839;this._h=3204075428;return this};Sha224.prototype._hash=function(){var e=s.allocUnsafe(28);e.writeInt32BE(this._a,0);e.writeInt32BE(this._b,4);e.writeInt32BE(this._c,8);e.writeInt32BE(this._d,12);e.writeInt32BE(this._e,16);e.writeInt32BE(this._f,20);e.writeInt32BE(this._g,24);return e};e.exports=Sha224},1843:function(e,t,r){var i=r(3782);var n=r(2858);var a=r(5055).Buffer;var s=[1116352408,1899447441,3049323471,3921009573,961987163,1508970993,2453635748,2870763221,3624381080,310598401,607225278,1426881987,1925078388,2162078206,2614888103,3248222580,3835390401,4022224774,264347078,604807628,770255983,1249150122,1555081692,1996064986,2554220882,2821834349,2952996808,3210313671,3336571891,3584528711,113926993,338241895,666307205,773529912,1294757372,1396182291,1695183700,1986661051,2177026350,2456956037,2730485921,2820302411,3259730800,3345764771,3516065817,3600352804,4094571909,275423344,430227734,506948616,659060556,883997877,958139571,1322822218,1537002063,1747873779,1955562222,2024104815,2227730452,2361852424,2428436474,2756734187,3204031479,3329325298];var o=new Array(64);function Sha256(){this.init();this._w=o;n.call(this,64,56)}i(Sha256,n);Sha256.prototype.init=function(){this._a=1779033703;this._b=3144134277;this._c=1013904242;this._d=2773480762;this._e=1359893119;this._f=2600822924;this._g=528734635;this._h=1541459225;return this};function ch(e,t,r){return r^e&(t^r)}function maj(e,t,r){return e&t|r&(e|t)}function sigma0(e){return(e>>>2|e<<30)^(e>>>13|e<<19)^(e>>>22|e<<10)}function sigma1(e){return(e>>>6|e<<26)^(e>>>11|e<<21)^(e>>>25|e<<7)}function gamma0(e){return(e>>>7|e<<25)^(e>>>18|e<<14)^e>>>3}function gamma1(e){return(e>>>17|e<<15)^(e>>>19|e<<13)^e>>>10}Sha256.prototype._update=function(e){var t=this._w;var r=this._a|0;var i=this._b|0;var n=this._c|0;var a=this._d|0;var o=this._e|0;var h=this._f|0;var u=this._g|0;var d=this._h|0;for(var c=0;c<16;++c)t[c]=e.readInt32BE(c*4);for(;c<64;++c)t[c]=gamma1(t[c-2])+t[c-7]+gamma0(t[c-15])+t[c-16]|0;for(var l=0;l<64;++l){var p=d+sigma1(o)+ch(o,h,u)+s[l]+t[l]|0;var v=sigma0(r)+maj(r,i,n)|0;d=u;u=h;h=o;o=a+p|0;a=n;n=i;i=r;r=p+v|0}this._a=r+this._a|0;this._b=i+this._b|0;this._c=n+this._c|0;this._d=a+this._d|0;this._e=o+this._e|0;this._f=h+this._f|0;this._g=u+this._g|0;this._h=d+this._h|0};Sha256.prototype._hash=function(){var e=a.allocUnsafe(32);e.writeInt32BE(this._a,0);e.writeInt32BE(this._b,4);e.writeInt32BE(this._c,8);e.writeInt32BE(this._d,12);e.writeInt32BE(this._e,16);e.writeInt32BE(this._f,20);e.writeInt32BE(this._g,24);e.writeInt32BE(this._h,28);return e};e.exports=Sha256},7455:function(e,t,r){var i=r(3782);var n=r(9934);var a=r(2858);var s=r(5055).Buffer;var o=new Array(160);function Sha384(){this.init();this._w=o;a.call(this,128,112)}i(Sha384,n);Sha384.prototype.init=function(){this._ah=3418070365;this._bh=1654270250;this._ch=2438529370;this._dh=355462360;this._eh=1731405415;this._fh=2394180231;this._gh=3675008525;this._hh=1203062813;this._al=3238371032;this._bl=914150663;this._cl=812702999;this._dl=4144912697;this._el=4290775857;this._fl=1750603025;this._gl=1694076839;this._hl=3204075428;return this};Sha384.prototype._hash=function(){var e=s.allocUnsafe(48);function writeInt64BE(t,r,i){e.writeInt32BE(t,i);e.writeInt32BE(r,i+4)}writeInt64BE(this._ah,this._al,0);writeInt64BE(this._bh,this._bl,8);writeInt64BE(this._ch,this._cl,16);writeInt64BE(this._dh,this._dl,24);writeInt64BE(this._eh,this._el,32);writeInt64BE(this._fh,this._fl,40);return e};e.exports=Sha384},9934:function(e,t,r){var i=r(3782);var n=r(2858);var a=r(5055).Buffer;var s=[1116352408,3609767458,1899447441,602891725,3049323471,3964484399,3921009573,2173295548,961987163,4081628472,1508970993,3053834265,2453635748,2937671579,2870763221,3664609560,3624381080,2734883394,310598401,1164996542,607225278,1323610764,1426881987,3590304994,1925078388,4068182383,2162078206,991336113,2614888103,633803317,3248222580,3479774868,3835390401,2666613458,4022224774,944711139,264347078,2341262773,604807628,2007800933,770255983,1495990901,1249150122,1856431235,1555081692,3175218132,1996064986,2198950837,2554220882,3999719339,2821834349,766784016,2952996808,2566594879,3210313671,3203337956,3336571891,1034457026,3584528711,2466948901,113926993,3758326383,338241895,168717936,666307205,1188179964,773529912,1546045734,1294757372,1522805485,1396182291,2643833823,1695183700,2343527390,1986661051,1014477480,2177026350,1206759142,2456956037,344077627,2730485921,1290863460,2820302411,3158454273,3259730800,3505952657,3345764771,106217008,3516065817,3606008344,3600352804,1432725776,4094571909,1467031594,275423344,851169720,430227734,3100823752,506948616,1363258195,659060556,3750685593,883997877,3785050280,958139571,3318307427,1322822218,3812723403,1537002063,2003034995,1747873779,3602036899,1955562222,1575990012,2024104815,1125592928,2227730452,2716904306,2361852424,442776044,2428436474,593698344,2756734187,3733110249,3204031479,2999351573,3329325298,3815920427,3391569614,3928383900,3515267271,566280711,3940187606,3454069534,4118630271,4000239992,116418474,1914138554,174292421,2731055270,289380356,3203993006,460393269,320620315,685471733,587496836,852142971,1086792851,1017036298,365543100,1126000580,2618297676,1288033470,3409855158,1501505948,4234509866,1607167915,987167468,1816402316,1246189591];var o=new Array(160);function Sha512(){this.init();this._w=o;n.call(this,128,112)}i(Sha512,n);Sha512.prototype.init=function(){this._ah=1779033703;this._bh=3144134277;this._ch=1013904242;this._dh=2773480762;this._eh=1359893119;this._fh=2600822924;this._gh=528734635;this._hh=1541459225;this._al=4089235720;this._bl=2227873595;this._cl=4271175723;this._dl=1595750129;this._el=2917565137;this._fl=725511199;this._gl=4215389547;this._hl=327033209;return this};function Ch(e,t,r){return r^e&(t^r)}function maj(e,t,r){return e&t|r&(e|t)}function sigma0(e,t){return(e>>>28|t<<4)^(t>>>2|e<<30)^(t>>>7|e<<25)}function sigma1(e,t){return(e>>>14|t<<18)^(e>>>18|t<<14)^(t>>>9|e<<23)}function Gamma0(e,t){return(e>>>1|t<<31)^(e>>>8|t<<24)^e>>>7}function Gamma0l(e,t){return(e>>>1|t<<31)^(e>>>8|t<<24)^(e>>>7|t<<25)}function Gamma1(e,t){return(e>>>19|t<<13)^(t>>>29|e<<3)^e>>>6}function Gamma1l(e,t){return(e>>>19|t<<13)^(t>>>29|e<<3)^(e>>>6|t<<26)}function getCarry(e,t){return e>>>0<t>>>0?1:0}Sha512.prototype._update=function(e){var t=this._w;var r=this._ah|0;var i=this._bh|0;var n=this._ch|0;var a=this._dh|0;var o=this._eh|0;var h=this._fh|0;var u=this._gh|0;var d=this._hh|0;var c=this._al|0;var l=this._bl|0;var p=this._cl|0;var v=this._dl|0;var b=this._el|0;var m=this._fl|0;var y=this._gl|0;var g=this._hl|0;for(var _=0;_<32;_+=2){t[_]=e.readInt32BE(_*4);t[_+1]=e.readInt32BE(_*4+4)}for(;_<160;_+=2){var w=t[_-15*2];var M=t[_-15*2+1];var B=Gamma0(w,M);var E=Gamma0l(M,w);w=t[_-2*2];M=t[_-2*2+1];var k=Gamma1(w,M);var A=Gamma1l(M,w);var N=t[_-7*2];var P=t[_-7*2+1];var x=t[_-16*2];var I=t[_-16*2+1];var C=E+P|0;var D=B+N+getCarry(C,E)|0;C=C+A|0;D=D+k+getCarry(C,A)|0;C=C+I|0;D=D+x+getCarry(C,I)|0;t[_]=D;t[_+1]=C}for(var T=0;T<160;T+=2){D=t[T];C=t[T+1];var j=maj(r,i,n);var q=maj(c,l,p);var O=sigma0(r,c);var H=sigma0(c,r);var L=sigma1(o,b);var z=sigma1(b,o);var F=s[T];var U=s[T+1];var W=Ch(o,h,u);var V=Ch(b,m,y);var G=g+z|0;var J=d+L+getCarry(G,g)|0;G=G+V|0;J=J+W+getCarry(G,V)|0;G=G+U|0;J=J+F+getCarry(G,U)|0;G=G+C|0;J=J+D+getCarry(G,C)|0;var Z=H+q|0;var X=O+j+getCarry(Z,H)|0;d=u;g=y;u=h;y=m;h=o;m=b;b=v+G|0;o=a+J+getCarry(b,v)|0;a=n;v=p;n=i;p=l;i=r;l=c;c=G+Z|0;r=J+X+getCarry(c,G)|0}this._al=this._al+c|0;this._bl=this._bl+l|0;this._cl=this._cl+p|0;this._dl=this._dl+v|0;this._el=this._el+b|0;this._fl=this._fl+m|0;this._gl=this._gl+y|0;this._hl=this._hl+g|0;this._ah=this._ah+r+getCarry(this._al,c)|0;this._bh=this._bh+i+getCarry(this._bl,l)|0;this._ch=this._ch+n+getCarry(this._cl,p)|0;this._dh=this._dh+a+getCarry(this._dl,v)|0;this._eh=this._eh+o+getCarry(this._el,b)|0;this._fh=this._fh+h+getCarry(this._fl,m)|0;this._gh=this._gh+u+getCarry(this._gl,y)|0;this._hh=this._hh+d+getCarry(this._hl,g)|0};Sha512.prototype._hash=function(){var e=a.allocUnsafe(64);function writeInt64BE(t,r,i){e.writeInt32BE(t,i);e.writeInt32BE(r,i+4)}writeInt64BE(this._ah,this._al,0);writeInt64BE(this._bh,this._bl,8);writeInt64BE(this._ch,this._cl,16);writeInt64BE(this._dh,this._dl,24);writeInt64BE(this._eh,this._el,32);writeInt64BE(this._fh,this._fl,40);writeInt64BE(this._gh,this._gl,48);writeInt64BE(this._hh,this._hl,56);return e};e.exports=Sha512},3704:function(e,t,r){"use strict";var i=r(5055).Buffer;var n=i.isEncoding||function(e){e=""+e;switch(e&&e.toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":case"raw":return true;default:return false}};function _normalizeEncoding(e){if(!e)return"utf8";var t;while(true){switch(e){case"utf8":case"utf-8":return"utf8";case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return"utf16le";case"latin1":case"binary":return"latin1";case"base64":case"ascii":case"hex":return e;default:if(t)return;e=(""+e).toLowerCase();t=true}}}function normalizeEncoding(e){var t=_normalizeEncoding(e);if(typeof t!=="string"&&(i.isEncoding===n||!n(e)))throw new Error("Unknown encoding: "+e);return t||e}t.s=StringDecoder;function StringDecoder(e){this.encoding=normalizeEncoding(e);var t;switch(this.encoding){case"utf16le":this.text=utf16Text;this.end=utf16End;t=4;break;case"utf8":this.fillLast=utf8FillLast;t=4;break;case"base64":this.text=base64Text;this.end=base64End;t=3;break;default:this.write=simpleWrite;this.end=simpleEnd;return}this.lastNeed=0;this.lastTotal=0;this.lastChar=i.allocUnsafe(t)}StringDecoder.prototype.write=function(e){if(e.length===0)return"";var t;var r;if(this.lastNeed){t=this.fillLast(e);if(t===undefined)return"";r=this.lastNeed;this.lastNeed=0}else{r=0}if(r<e.length)return t?t+this.text(e,r):this.text(e,r);return t||""};StringDecoder.prototype.end=utf8End;StringDecoder.prototype.text=utf8Text;StringDecoder.prototype.fillLast=function(e){if(this.lastNeed<=e.length){e.copy(this.lastChar,this.lastTotal-this.lastNeed,0,this.lastNeed);return this.lastChar.toString(this.encoding,0,this.lastTotal)}e.copy(this.lastChar,this.lastTotal-this.lastNeed,0,e.length);this.lastNeed-=e.length};function utf8CheckByte(e){if(e<=127)return 0;else if(e>>5===6)return 2;else if(e>>4===14)return 3;else if(e>>3===30)return 4;return e>>6===2?-1:-2}function utf8CheckIncomplete(e,t,r){var i=t.length-1;if(i<r)return 0;var n=utf8CheckByte(t[i]);if(n>=0){if(n>0)e.lastNeed=n-1;return n}if(--i<r||n===-2)return 0;n=utf8CheckByte(t[i]);if(n>=0){if(n>0)e.lastNeed=n-2;return n}if(--i<r||n===-2)return 0;n=utf8CheckByte(t[i]);if(n>=0){if(n>0){if(n===2)n=0;else e.lastNeed=n-3}return n}return 0}function utf8CheckExtraBytes(e,t,r){if((t[0]&192)!==128){e.lastNeed=0;return"�"}if(e.lastNeed>1&&t.length>1){if((t[1]&192)!==128){e.lastNeed=1;return"�"}if(e.lastNeed>2&&t.length>2){if((t[2]&192)!==128){e.lastNeed=2;return"�"}}}}function utf8FillLast(e){var t=this.lastTotal-this.lastNeed;var r=utf8CheckExtraBytes(this,e,t);if(r!==undefined)return r;if(this.lastNeed<=e.length){e.copy(this.lastChar,t,0,this.lastNeed);return this.lastChar.toString(this.encoding,0,this.lastTotal)}e.copy(this.lastChar,t,0,e.length);this.lastNeed-=e.length}function utf8Text(e,t){var r=utf8CheckIncomplete(this,e,t);if(!this.lastNeed)return e.toString("utf8",t);this.lastTotal=r;var i=e.length-(r-this.lastNeed);e.copy(this.lastChar,0,i);return e.toString("utf8",t,i)}function utf8End(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed)return t+"�";return t}function utf16Text(e,t){if((e.length-t)%2===0){var r=e.toString("utf16le",t);if(r){var i=r.charCodeAt(r.length-1);if(i>=55296&&i<=56319){this.lastNeed=2;this.lastTotal=4;this.lastChar[0]=e[e.length-2];this.lastChar[1]=e[e.length-1];return r.slice(0,-1)}}return r}this.lastNeed=1;this.lastTotal=2;this.lastChar[0]=e[e.length-1];return e.toString("utf16le",t,e.length-1)}function utf16End(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed){var r=this.lastTotal-this.lastNeed;return t+this.lastChar.toString("utf16le",0,r)}return t}function base64Text(e,t){var r=(e.length-t)%3;if(r===0)return e.toString("base64",t);this.lastNeed=3-r;this.lastTotal=3;if(r===1){this.lastChar[0]=e[e.length-1]}else{this.lastChar[0]=e[e.length-2];this.lastChar[1]=e[e.length-1]}return e.toString("base64",t,e.length-r)}function base64End(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed)return t+this.lastChar.toString("base64",0,3-this.lastNeed);return t}function simpleWrite(e){return e.toString(this.encoding)}function simpleEnd(e){return e&&e.length?this.write(e):""}},6769:function(e){e.exports=deprecate;function deprecate(e,t){if(config("noDeprecation")){return e}var r=false;function deprecated(){if(!r){if(config("throwDeprecation")){throw new Error(t)}else if(config("traceDeprecation")){console.trace(t)}else{console.warn(t)}r=true}return e.apply(this,arguments)}return deprecated}function config(e){try{if(!__webpack_require__.g.localStorage)return false}catch(e){return false}var t=__webpack_require__.g.localStorage[e];if(null==t)return false;return String(t).toLowerCase()==="true"}},4300:function(e){"use strict";e.exports=__webpack_require__(48764)},6113:function(e){"use strict";e.exports=__webpack_require__(42474)},2361:function(e){"use strict";e.exports=__webpack_require__(25293)},2781:function(e){"use strict";e.exports=__webpack_require__(79681)},1576:function(e){"use strict";e.exports=__webpack_require__(32553)},3837:function(e){"use strict";e.exports=__webpack_require__(79720)},6144:function(e){"use strict";e.exports=__webpack_require__(51951)},5866:function(e){"use strict";e.exports=JSON.parse('{"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}')},2908:function(e){"use strict";e.exports=JSON.parse('{"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}')},9267:function(e){"use strict";e.exports=JSON.parse('{"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}')},7992:function(e){"use strict";e.exports=JSON.parse('{"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}')},2531:function(e){"use strict";e.exports={i8:"6.5.3"}},2510:function(e){"use strict";e.exports=JSON.parse('{"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}')}};var t={};function __nccwpck_require__(r){var i=t[r];if(i!==undefined){return i.exports}var n=t[r]={id:r,loaded:false,exports:{}};var a=true;try{e[r].call(n.exports,n,n.exports,__nccwpck_require__);a=false}finally{if(a)delete t[r]}n.loaded=true;return n.exports}!function(){__nccwpck_require__.nmd=function(e){e.paths=[];if(!e.children)e.children=[];return e}}();if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var r={};!function(){"use strict";var e=r;e.randomBytes=e.rng=e.pseudoRandomBytes=e.prng=__nccwpck_require__(7223);e.createHash=e.Hash=__nccwpck_require__(9739);e.createHmac=e.Hmac=__nccwpck_require__(4873);var t=__nccwpck_require__(9276);var i=Object.keys(t);var n=["sha1","sha224","sha256","sha384","sha512","md5","rmd160"].concat(i);e.getHashes=function(){return n};var a=__nccwpck_require__(4978);e.pbkdf2=a.pbkdf2;e.pbkdf2Sync=a.pbkdf2Sync;var s=__nccwpck_require__(8996);e.Cipher=s.Cipher;e.createCipher=s.createCipher;e.Cipheriv=s.Cipheriv;e.createCipheriv=s.createCipheriv;e.Decipher=s.Decipher;e.createDecipher=s.createDecipher;e.Decipheriv=s.Decipheriv;e.createDecipheriv=s.createDecipheriv;e.getCiphers=s.getCiphers;e.listCiphers=s.listCiphers;var o=__nccwpck_require__(6587);e.DiffieHellmanGroup=o.DiffieHellmanGroup;e.createDiffieHellmanGroup=o.createDiffieHellmanGroup;e.getDiffieHellman=o.getDiffieHellman;e.createDiffieHellman=o.createDiffieHellman;e.DiffieHellman=o.DiffieHellman;var h=__nccwpck_require__(4078);e.createSign=h.createSign;e.Sign=h.Sign;e.createVerify=h.createVerify;e.Verify=h.Verify;e.createECDH=__nccwpck_require__(9942);var u=__nccwpck_require__(9783);e.publicEncrypt=u.publicEncrypt;e.privateEncrypt=u.privateEncrypt;e.publicDecrypt=u.publicDecrypt;e.privateDecrypt=u.privateDecrypt;var d=__nccwpck_require__(6445);e.randomFill=d.randomFill;e.randomFillSync=d.randomFillSync;e.createCredentials=function(){throw new Error(["sorry, createCredentials is not implemented yet","we accept pull requests","https://github.com/crypto-browserify/crypto-browserify"].join("\n"))};e.constants={DH_CHECK_P_NOT_SAFE_PRIME:2,DH_CHECK_P_NOT_PRIME:1,DH_UNABLE_TO_CHECK_GENERATOR:4,DH_NOT_SUITABLE_GENERATOR:8,NPN_ENABLED:1,ALPN_ENABLED:1,RSA_PKCS1_PADDING:1,RSA_SSLV23_PADDING:2,RSA_NO_PADDING:3,RSA_PKCS1_OAEP_PADDING:4,RSA_X931_PADDING:5,RSA_PKCS1_PSS_PADDING:6,POINT_CONVERSION_COMPRESSED:2,POINT_CONVERSION_UNCOMPRESSED:4,POINT_CONVERSION_HYBRID:6}}();module.exports=r})();

/***/ }),

/***/ 25293:
/***/ (function(module) {

var __dirname = "/";
(function(){"use strict";var e={864:function(e){var t=typeof Reflect==="object"?Reflect:null;var n=t&&typeof t.apply==="function"?t.apply:function ReflectApply(e,t,n){return Function.prototype.apply.call(e,t,n)};var r;if(t&&typeof t.ownKeys==="function"){r=t.ownKeys}else if(Object.getOwnPropertySymbols){r=function ReflectOwnKeys(e){return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e))}}else{r=function ReflectOwnKeys(e){return Object.getOwnPropertyNames(e)}}function ProcessEmitWarning(e){if(console&&console.warn)console.warn(e)}var i=Number.isNaN||function NumberIsNaN(e){return e!==e};function EventEmitter(){EventEmitter.init.call(this)}e.exports=EventEmitter;e.exports.once=once;EventEmitter.EventEmitter=EventEmitter;EventEmitter.prototype._events=undefined;EventEmitter.prototype._eventsCount=0;EventEmitter.prototype._maxListeners=undefined;var s=10;function checkListener(e){if(typeof e!=="function"){throw new TypeError('The "listener" argument must be of type Function. Received type '+typeof e)}}Object.defineProperty(EventEmitter,"defaultMaxListeners",{enumerable:true,get:function(){return s},set:function(e){if(typeof e!=="number"||e<0||i(e)){throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received '+e+".")}s=e}});EventEmitter.init=function(){if(this._events===undefined||this._events===Object.getPrototypeOf(this)._events){this._events=Object.create(null);this._eventsCount=0}this._maxListeners=this._maxListeners||undefined};EventEmitter.prototype.setMaxListeners=function setMaxListeners(e){if(typeof e!=="number"||e<0||i(e)){throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received '+e+".")}this._maxListeners=e;return this};function _getMaxListeners(e){if(e._maxListeners===undefined)return EventEmitter.defaultMaxListeners;return e._maxListeners}EventEmitter.prototype.getMaxListeners=function getMaxListeners(){return _getMaxListeners(this)};EventEmitter.prototype.emit=function emit(e){var t=[];for(var r=1;r<arguments.length;r++)t.push(arguments[r]);var i=e==="error";var s=this._events;if(s!==undefined)i=i&&s.error===undefined;else if(!i)return false;if(i){var o;if(t.length>0)o=t[0];if(o instanceof Error){throw o}var f=new Error("Unhandled error."+(o?" ("+o.message+")":""));f.context=o;throw f}var u=s[e];if(u===undefined)return false;if(typeof u==="function"){n(u,this,t)}else{var a=u.length;var c=arrayClone(u,a);for(var r=0;r<a;++r)n(c[r],this,t)}return true};function _addListener(e,t,n,r){var i;var s;var o;checkListener(n);s=e._events;if(s===undefined){s=e._events=Object.create(null);e._eventsCount=0}else{if(s.newListener!==undefined){e.emit("newListener",t,n.listener?n.listener:n);s=e._events}o=s[t]}if(o===undefined){o=s[t]=n;++e._eventsCount}else{if(typeof o==="function"){o=s[t]=r?[n,o]:[o,n]}else if(r){o.unshift(n)}else{o.push(n)}i=_getMaxListeners(e);if(i>0&&o.length>i&&!o.warned){o.warned=true;var f=new Error("Possible EventEmitter memory leak detected. "+o.length+" "+String(t)+" listeners "+"added. Use emitter.setMaxListeners() to "+"increase limit");f.name="MaxListenersExceededWarning";f.emitter=e;f.type=t;f.count=o.length;ProcessEmitWarning(f)}}return e}EventEmitter.prototype.addListener=function addListener(e,t){return _addListener(this,e,t,false)};EventEmitter.prototype.on=EventEmitter.prototype.addListener;EventEmitter.prototype.prependListener=function prependListener(e,t){return _addListener(this,e,t,true)};function onceWrapper(){if(!this.fired){this.target.removeListener(this.type,this.wrapFn);this.fired=true;if(arguments.length===0)return this.listener.call(this.target);return this.listener.apply(this.target,arguments)}}function _onceWrap(e,t,n){var r={fired:false,wrapFn:undefined,target:e,type:t,listener:n};var i=onceWrapper.bind(r);i.listener=n;r.wrapFn=i;return i}EventEmitter.prototype.once=function once(e,t){checkListener(t);this.on(e,_onceWrap(this,e,t));return this};EventEmitter.prototype.prependOnceListener=function prependOnceListener(e,t){checkListener(t);this.prependListener(e,_onceWrap(this,e,t));return this};EventEmitter.prototype.removeListener=function removeListener(e,t){var n,r,i,s,o;checkListener(t);r=this._events;if(r===undefined)return this;n=r[e];if(n===undefined)return this;if(n===t||n.listener===t){if(--this._eventsCount===0)this._events=Object.create(null);else{delete r[e];if(r.removeListener)this.emit("removeListener",e,n.listener||t)}}else if(typeof n!=="function"){i=-1;for(s=n.length-1;s>=0;s--){if(n[s]===t||n[s].listener===t){o=n[s].listener;i=s;break}}if(i<0)return this;if(i===0)n.shift();else{spliceOne(n,i)}if(n.length===1)r[e]=n[0];if(r.removeListener!==undefined)this.emit("removeListener",e,o||t)}return this};EventEmitter.prototype.off=EventEmitter.prototype.removeListener;EventEmitter.prototype.removeAllListeners=function removeAllListeners(e){var t,n,r;n=this._events;if(n===undefined)return this;if(n.removeListener===undefined){if(arguments.length===0){this._events=Object.create(null);this._eventsCount=0}else if(n[e]!==undefined){if(--this._eventsCount===0)this._events=Object.create(null);else delete n[e]}return this}if(arguments.length===0){var i=Object.keys(n);var s;for(r=0;r<i.length;++r){s=i[r];if(s==="removeListener")continue;this.removeAllListeners(s)}this.removeAllListeners("removeListener");this._events=Object.create(null);this._eventsCount=0;return this}t=n[e];if(typeof t==="function"){this.removeListener(e,t)}else if(t!==undefined){for(r=t.length-1;r>=0;r--){this.removeListener(e,t[r])}}return this};function _listeners(e,t,n){var r=e._events;if(r===undefined)return[];var i=r[t];if(i===undefined)return[];if(typeof i==="function")return n?[i.listener||i]:[i];return n?unwrapListeners(i):arrayClone(i,i.length)}EventEmitter.prototype.listeners=function listeners(e){return _listeners(this,e,true)};EventEmitter.prototype.rawListeners=function rawListeners(e){return _listeners(this,e,false)};EventEmitter.listenerCount=function(e,t){if(typeof e.listenerCount==="function"){return e.listenerCount(t)}else{return listenerCount.call(e,t)}};EventEmitter.prototype.listenerCount=listenerCount;function listenerCount(e){var t=this._events;if(t!==undefined){var n=t[e];if(typeof n==="function"){return 1}else if(n!==undefined){return n.length}}return 0}EventEmitter.prototype.eventNames=function eventNames(){return this._eventsCount>0?r(this._events):[]};function arrayClone(e,t){var n=new Array(t);for(var r=0;r<t;++r)n[r]=e[r];return n}function spliceOne(e,t){for(;t+1<e.length;t++)e[t]=e[t+1];e.pop()}function unwrapListeners(e){var t=new Array(e.length);for(var n=0;n<t.length;++n){t[n]=e[n].listener||e[n]}return t}function once(e,t){return new Promise((function(n,r){function errorListener(n){e.removeListener(t,resolver);r(n)}function resolver(){if(typeof e.removeListener==="function"){e.removeListener("error",errorListener)}n([].slice.call(arguments))}eventTargetAgnosticAddListener(e,t,resolver,{once:true});if(t!=="error"){addErrorHandlerIfEventEmitter(e,errorListener,{once:true})}}))}function addErrorHandlerIfEventEmitter(e,t,n){if(typeof e.on==="function"){eventTargetAgnosticAddListener(e,"error",t,n)}}function eventTargetAgnosticAddListener(e,t,n,r){if(typeof e.on==="function"){if(r.once){e.once(t,n)}else{e.on(t,n)}}else if(typeof e.addEventListener==="function"){e.addEventListener(t,(function wrapListener(i){if(r.once){e.removeEventListener(t,wrapListener)}n(i)}))}else{throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type '+typeof e)}}}};var t={};function __nccwpck_require__(n){var r=t[n];if(r!==undefined){return r.exports}var i=t[n]={exports:{}};var s=true;try{e[n](i,i.exports,__nccwpck_require__);s=false}finally{if(s)delete t[n]}return i.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var n=__nccwpck_require__(864);module.exports=n})();

/***/ }),

/***/ 75821:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 23770:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 79681:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __dirname = "/";
/* provided dependency */ var process = __webpack_require__(34155);
(function(){var e={782:function(e){if(typeof Object.create==="function"){e.exports=function inherits(e,t){if(t){e.super_=t;e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:false,writable:true,configurable:true}})}}}else{e.exports=function inherits(e,t){if(t){e.super_=t;var TempCtor=function(){};TempCtor.prototype=t.prototype;e.prototype=new TempCtor;e.prototype.constructor=e}}}},646:function(e){"use strict";const t={};function createErrorType(e,r,n){if(!n){n=Error}function getMessage(e,t,n){if(typeof r==="string"){return r}else{return r(e,t,n)}}class NodeError extends n{constructor(e,t,r){super(getMessage(e,t,r))}}NodeError.prototype.name=n.name;NodeError.prototype.code=e;t[e]=NodeError}function oneOf(e,t){if(Array.isArray(e)){const r=e.length;e=e.map((e=>String(e)));if(r>2){return`one of ${t} ${e.slice(0,r-1).join(", ")}, or `+e[r-1]}else if(r===2){return`one of ${t} ${e[0]} or ${e[1]}`}else{return`of ${t} ${e[0]}`}}else{return`of ${t} ${String(e)}`}}function startsWith(e,t,r){return e.substr(!r||r<0?0:+r,t.length)===t}function endsWith(e,t,r){if(r===undefined||r>e.length){r=e.length}return e.substring(r-t.length,r)===t}function includes(e,t,r){if(typeof r!=="number"){r=0}if(r+t.length>e.length){return false}else{return e.indexOf(t,r)!==-1}}createErrorType("ERR_INVALID_OPT_VALUE",(function(e,t){return'The value "'+t+'" is invalid for option "'+e+'"'}),TypeError);createErrorType("ERR_INVALID_ARG_TYPE",(function(e,t,r){let n;if(typeof t==="string"&&startsWith(t,"not ")){n="must not be";t=t.replace(/^not /,"")}else{n="must be"}let i;if(endsWith(e," argument")){i=`The ${e} ${n} ${oneOf(t,"type")}`}else{const r=includes(e,".")?"property":"argument";i=`The "${e}" ${r} ${n} ${oneOf(t,"type")}`}i+=`. Received type ${typeof r}`;return i}),TypeError);createErrorType("ERR_STREAM_PUSH_AFTER_EOF","stream.push() after EOF");createErrorType("ERR_METHOD_NOT_IMPLEMENTED",(function(e){return"The "+e+" method is not implemented"}));createErrorType("ERR_STREAM_PREMATURE_CLOSE","Premature close");createErrorType("ERR_STREAM_DESTROYED",(function(e){return"Cannot call "+e+" after a stream was destroyed"}));createErrorType("ERR_MULTIPLE_CALLBACK","Callback called multiple times");createErrorType("ERR_STREAM_CANNOT_PIPE","Cannot pipe, not readable");createErrorType("ERR_STREAM_WRITE_AFTER_END","write after end");createErrorType("ERR_STREAM_NULL_VALUES","May not write null values to stream",TypeError);createErrorType("ERR_UNKNOWN_ENCODING",(function(e){return"Unknown encoding: "+e}),TypeError);createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT","stream.unshift() after end event");e.exports.q=t},403:function(e,t,r){"use strict";var n=Object.keys||function(e){var t=[];for(var r in e){t.push(r)}return t};e.exports=Duplex;var i=r(709);var a=r(337);r(782)(Duplex,i);{var o=n(a.prototype);for(var s=0;s<o.length;s++){var f=o[s];if(!Duplex.prototype[f])Duplex.prototype[f]=a.prototype[f]}}function Duplex(e){if(!(this instanceof Duplex))return new Duplex(e);i.call(this,e);a.call(this,e);this.allowHalfOpen=true;if(e){if(e.readable===false)this.readable=false;if(e.writable===false)this.writable=false;if(e.allowHalfOpen===false){this.allowHalfOpen=false;this.once("end",onend)}}}Object.defineProperty(Duplex.prototype,"writableHighWaterMark",{enumerable:false,get:function get(){return this._writableState.highWaterMark}});Object.defineProperty(Duplex.prototype,"writableBuffer",{enumerable:false,get:function get(){return this._writableState&&this._writableState.getBuffer()}});Object.defineProperty(Duplex.prototype,"writableLength",{enumerable:false,get:function get(){return this._writableState.length}});function onend(){if(this._writableState.ended)return;process.nextTick(onEndNT,this)}function onEndNT(e){e.end()}Object.defineProperty(Duplex.prototype,"destroyed",{enumerable:false,get:function get(){if(this._readableState===undefined||this._writableState===undefined){return false}return this._readableState.destroyed&&this._writableState.destroyed},set:function set(e){if(this._readableState===undefined||this._writableState===undefined){return}this._readableState.destroyed=e;this._writableState.destroyed=e}})},889:function(e,t,r){"use strict";e.exports=PassThrough;var n=r(170);r(782)(PassThrough,n);function PassThrough(e){if(!(this instanceof PassThrough))return new PassThrough(e);n.call(this,e)}PassThrough.prototype._transform=function(e,t,r){r(null,e)}},709:function(e,t,r){"use strict";e.exports=Readable;var n;Readable.ReadableState=ReadableState;var i=r(361).EventEmitter;var a=function EElistenerCount(e,t){return e.listeners(t).length};var o=r(678);var s=r(300).Buffer;var f=__webpack_require__.g.Uint8Array||function(){};function _uint8ArrayToBuffer(e){return s.from(e)}function _isUint8Array(e){return s.isBuffer(e)||e instanceof f}var l=r(837);var u;if(l&&l.debuglog){u=l.debuglog("stream")}else{u=function debug(){}}var d=r(379);var c=r(25);var h=r(776),p=h.getHighWaterMark;var b=r(646).q,g=b.ERR_INVALID_ARG_TYPE,y=b.ERR_STREAM_PUSH_AFTER_EOF,_=b.ERR_METHOD_NOT_IMPLEMENTED,v=b.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;var w;var m;var S;r(782)(Readable,o);var R=c.errorOrDestroy;var E=["error","close","destroy","pause","resume"];function prependListener(e,t,r){if(typeof e.prependListener==="function")return e.prependListener(t,r);if(!e._events||!e._events[t])e.on(t,r);else if(Array.isArray(e._events[t]))e._events[t].unshift(r);else e._events[t]=[r,e._events[t]]}function ReadableState(e,t,i){n=n||r(403);e=e||{};if(typeof i!=="boolean")i=t instanceof n;this.objectMode=!!e.objectMode;if(i)this.objectMode=this.objectMode||!!e.readableObjectMode;this.highWaterMark=p(this,e,"readableHighWaterMark",i);this.buffer=new d;this.length=0;this.pipes=null;this.pipesCount=0;this.flowing=null;this.ended=false;this.endEmitted=false;this.reading=false;this.sync=true;this.needReadable=false;this.emittedReadable=false;this.readableListening=false;this.resumeScheduled=false;this.paused=true;this.emitClose=e.emitClose!==false;this.autoDestroy=!!e.autoDestroy;this.destroyed=false;this.defaultEncoding=e.defaultEncoding||"utf8";this.awaitDrain=0;this.readingMore=false;this.decoder=null;this.encoding=null;if(e.encoding){if(!w)w=r(704).s;this.decoder=new w(e.encoding);this.encoding=e.encoding}}function Readable(e){n=n||r(403);if(!(this instanceof Readable))return new Readable(e);var t=this instanceof n;this._readableState=new ReadableState(e,this,t);this.readable=true;if(e){if(typeof e.read==="function")this._read=e.read;if(typeof e.destroy==="function")this._destroy=e.destroy}o.call(this)}Object.defineProperty(Readable.prototype,"destroyed",{enumerable:false,get:function get(){if(this._readableState===undefined){return false}return this._readableState.destroyed},set:function set(e){if(!this._readableState){return}this._readableState.destroyed=e}});Readable.prototype.destroy=c.destroy;Readable.prototype._undestroy=c.undestroy;Readable.prototype._destroy=function(e,t){t(e)};Readable.prototype.push=function(e,t){var r=this._readableState;var n;if(!r.objectMode){if(typeof e==="string"){t=t||r.defaultEncoding;if(t!==r.encoding){e=s.from(e,t);t=""}n=true}}else{n=true}return readableAddChunk(this,e,t,false,n)};Readable.prototype.unshift=function(e){return readableAddChunk(this,e,null,true,false)};function readableAddChunk(e,t,r,n,i){u("readableAddChunk",t);var a=e._readableState;if(t===null){a.reading=false;onEofChunk(e,a)}else{var o;if(!i)o=chunkInvalid(a,t);if(o){R(e,o)}else if(a.objectMode||t&&t.length>0){if(typeof t!=="string"&&!a.objectMode&&Object.getPrototypeOf(t)!==s.prototype){t=_uint8ArrayToBuffer(t)}if(n){if(a.endEmitted)R(e,new v);else addChunk(e,a,t,true)}else if(a.ended){R(e,new y)}else if(a.destroyed){return false}else{a.reading=false;if(a.decoder&&!r){t=a.decoder.write(t);if(a.objectMode||t.length!==0)addChunk(e,a,t,false);else maybeReadMore(e,a)}else{addChunk(e,a,t,false)}}}else if(!n){a.reading=false;maybeReadMore(e,a)}}return!a.ended&&(a.length<a.highWaterMark||a.length===0)}function addChunk(e,t,r,n){if(t.flowing&&t.length===0&&!t.sync){t.awaitDrain=0;e.emit("data",r)}else{t.length+=t.objectMode?1:r.length;if(n)t.buffer.unshift(r);else t.buffer.push(r);if(t.needReadable)emitReadable(e)}maybeReadMore(e,t)}function chunkInvalid(e,t){var r;if(!_isUint8Array(t)&&typeof t!=="string"&&t!==undefined&&!e.objectMode){r=new g("chunk",["string","Buffer","Uint8Array"],t)}return r}Readable.prototype.isPaused=function(){return this._readableState.flowing===false};Readable.prototype.setEncoding=function(e){if(!w)w=r(704).s;var t=new w(e);this._readableState.decoder=t;this._readableState.encoding=this._readableState.decoder.encoding;var n=this._readableState.buffer.head;var i="";while(n!==null){i+=t.write(n.data);n=n.next}this._readableState.buffer.clear();if(i!=="")this._readableState.buffer.push(i);this._readableState.length=i.length;return this};var T=1073741824;function computeNewHighWaterMark(e){if(e>=T){e=T}else{e--;e|=e>>>1;e|=e>>>2;e|=e>>>4;e|=e>>>8;e|=e>>>16;e++}return e}function howMuchToRead(e,t){if(e<=0||t.length===0&&t.ended)return 0;if(t.objectMode)return 1;if(e!==e){if(t.flowing&&t.length)return t.buffer.head.data.length;else return t.length}if(e>t.highWaterMark)t.highWaterMark=computeNewHighWaterMark(e);if(e<=t.length)return e;if(!t.ended){t.needReadable=true;return 0}return t.length}Readable.prototype.read=function(e){u("read",e);e=parseInt(e,10);var t=this._readableState;var r=e;if(e!==0)t.emittedReadable=false;if(e===0&&t.needReadable&&((t.highWaterMark!==0?t.length>=t.highWaterMark:t.length>0)||t.ended)){u("read: emitReadable",t.length,t.ended);if(t.length===0&&t.ended)endReadable(this);else emitReadable(this);return null}e=howMuchToRead(e,t);if(e===0&&t.ended){if(t.length===0)endReadable(this);return null}var n=t.needReadable;u("need readable",n);if(t.length===0||t.length-e<t.highWaterMark){n=true;u("length less than watermark",n)}if(t.ended||t.reading){n=false;u("reading or ended",n)}else if(n){u("do read");t.reading=true;t.sync=true;if(t.length===0)t.needReadable=true;this._read(t.highWaterMark);t.sync=false;if(!t.reading)e=howMuchToRead(r,t)}var i;if(e>0)i=fromList(e,t);else i=null;if(i===null){t.needReadable=t.length<=t.highWaterMark;e=0}else{t.length-=e;t.awaitDrain=0}if(t.length===0){if(!t.ended)t.needReadable=true;if(r!==e&&t.ended)endReadable(this)}if(i!==null)this.emit("data",i);return i};function onEofChunk(e,t){u("onEofChunk");if(t.ended)return;if(t.decoder){var r=t.decoder.end();if(r&&r.length){t.buffer.push(r);t.length+=t.objectMode?1:r.length}}t.ended=true;if(t.sync){emitReadable(e)}else{t.needReadable=false;if(!t.emittedReadable){t.emittedReadable=true;emitReadable_(e)}}}function emitReadable(e){var t=e._readableState;u("emitReadable",t.needReadable,t.emittedReadable);t.needReadable=false;if(!t.emittedReadable){u("emitReadable",t.flowing);t.emittedReadable=true;process.nextTick(emitReadable_,e)}}function emitReadable_(e){var t=e._readableState;u("emitReadable_",t.destroyed,t.length,t.ended);if(!t.destroyed&&(t.length||t.ended)){e.emit("readable");t.emittedReadable=false}t.needReadable=!t.flowing&&!t.ended&&t.length<=t.highWaterMark;flow(e)}function maybeReadMore(e,t){if(!t.readingMore){t.readingMore=true;process.nextTick(maybeReadMore_,e,t)}}function maybeReadMore_(e,t){while(!t.reading&&!t.ended&&(t.length<t.highWaterMark||t.flowing&&t.length===0)){var r=t.length;u("maybeReadMore read 0");e.read(0);if(r===t.length)break}t.readingMore=false}Readable.prototype._read=function(e){R(this,new _("_read()"))};Readable.prototype.pipe=function(e,t){var r=this;var n=this._readableState;switch(n.pipesCount){case 0:n.pipes=e;break;case 1:n.pipes=[n.pipes,e];break;default:n.pipes.push(e);break}n.pipesCount+=1;u("pipe count=%d opts=%j",n.pipesCount,t);var i=(!t||t.end!==false)&&e!==process.stdout&&e!==process.stderr;var o=i?onend:unpipe;if(n.endEmitted)process.nextTick(o);else r.once("end",o);e.on("unpipe",onunpipe);function onunpipe(e,t){u("onunpipe");if(e===r){if(t&&t.hasUnpiped===false){t.hasUnpiped=true;cleanup()}}}function onend(){u("onend");e.end()}var s=pipeOnDrain(r);e.on("drain",s);var f=false;function cleanup(){u("cleanup");e.removeListener("close",onclose);e.removeListener("finish",onfinish);e.removeListener("drain",s);e.removeListener("error",onerror);e.removeListener("unpipe",onunpipe);r.removeListener("end",onend);r.removeListener("end",unpipe);r.removeListener("data",ondata);f=true;if(n.awaitDrain&&(!e._writableState||e._writableState.needDrain))s()}r.on("data",ondata);function ondata(t){u("ondata");var i=e.write(t);u("dest.write",i);if(i===false){if((n.pipesCount===1&&n.pipes===e||n.pipesCount>1&&indexOf(n.pipes,e)!==-1)&&!f){u("false write response, pause",n.awaitDrain);n.awaitDrain++}r.pause()}}function onerror(t){u("onerror",t);unpipe();e.removeListener("error",onerror);if(a(e,"error")===0)R(e,t)}prependListener(e,"error",onerror);function onclose(){e.removeListener("finish",onfinish);unpipe()}e.once("close",onclose);function onfinish(){u("onfinish");e.removeListener("close",onclose);unpipe()}e.once("finish",onfinish);function unpipe(){u("unpipe");r.unpipe(e)}e.emit("pipe",r);if(!n.flowing){u("pipe resume");r.resume()}return e};function pipeOnDrain(e){return function pipeOnDrainFunctionResult(){var t=e._readableState;u("pipeOnDrain",t.awaitDrain);if(t.awaitDrain)t.awaitDrain--;if(t.awaitDrain===0&&a(e,"data")){t.flowing=true;flow(e)}}}Readable.prototype.unpipe=function(e){var t=this._readableState;var r={hasUnpiped:false};if(t.pipesCount===0)return this;if(t.pipesCount===1){if(e&&e!==t.pipes)return this;if(!e)e=t.pipes;t.pipes=null;t.pipesCount=0;t.flowing=false;if(e)e.emit("unpipe",this,r);return this}if(!e){var n=t.pipes;var i=t.pipesCount;t.pipes=null;t.pipesCount=0;t.flowing=false;for(var a=0;a<i;a++){n[a].emit("unpipe",this,{hasUnpiped:false})}return this}var o=indexOf(t.pipes,e);if(o===-1)return this;t.pipes.splice(o,1);t.pipesCount-=1;if(t.pipesCount===1)t.pipes=t.pipes[0];e.emit("unpipe",this,r);return this};Readable.prototype.on=function(e,t){var r=o.prototype.on.call(this,e,t);var n=this._readableState;if(e==="data"){n.readableListening=this.listenerCount("readable")>0;if(n.flowing!==false)this.resume()}else if(e==="readable"){if(!n.endEmitted&&!n.readableListening){n.readableListening=n.needReadable=true;n.flowing=false;n.emittedReadable=false;u("on readable",n.length,n.reading);if(n.length){emitReadable(this)}else if(!n.reading){process.nextTick(nReadingNextTick,this)}}}return r};Readable.prototype.addListener=Readable.prototype.on;Readable.prototype.removeListener=function(e,t){var r=o.prototype.removeListener.call(this,e,t);if(e==="readable"){process.nextTick(updateReadableListening,this)}return r};Readable.prototype.removeAllListeners=function(e){var t=o.prototype.removeAllListeners.apply(this,arguments);if(e==="readable"||e===undefined){process.nextTick(updateReadableListening,this)}return t};function updateReadableListening(e){var t=e._readableState;t.readableListening=e.listenerCount("readable")>0;if(t.resumeScheduled&&!t.paused){t.flowing=true}else if(e.listenerCount("data")>0){e.resume()}}function nReadingNextTick(e){u("readable nexttick read 0");e.read(0)}Readable.prototype.resume=function(){var e=this._readableState;if(!e.flowing){u("resume");e.flowing=!e.readableListening;resume(this,e)}e.paused=false;return this};function resume(e,t){if(!t.resumeScheduled){t.resumeScheduled=true;process.nextTick(resume_,e,t)}}function resume_(e,t){u("resume",t.reading);if(!t.reading){e.read(0)}t.resumeScheduled=false;e.emit("resume");flow(e);if(t.flowing&&!t.reading)e.read(0)}Readable.prototype.pause=function(){u("call pause flowing=%j",this._readableState.flowing);if(this._readableState.flowing!==false){u("pause");this._readableState.flowing=false;this.emit("pause")}this._readableState.paused=true;return this};function flow(e){var t=e._readableState;u("flow",t.flowing);while(t.flowing&&e.read()!==null){}}Readable.prototype.wrap=function(e){var t=this;var r=this._readableState;var n=false;e.on("end",(function(){u("wrapped end");if(r.decoder&&!r.ended){var e=r.decoder.end();if(e&&e.length)t.push(e)}t.push(null)}));e.on("data",(function(i){u("wrapped data");if(r.decoder)i=r.decoder.write(i);if(r.objectMode&&(i===null||i===undefined))return;else if(!r.objectMode&&(!i||!i.length))return;var a=t.push(i);if(!a){n=true;e.pause()}}));for(var i in e){if(this[i]===undefined&&typeof e[i]==="function"){this[i]=function methodWrap(t){return function methodWrapReturnFunction(){return e[t].apply(e,arguments)}}(i)}}for(var a=0;a<E.length;a++){e.on(E[a],this.emit.bind(this,E[a]))}this._read=function(t){u("wrapped _read",t);if(n){n=false;e.resume()}};return this};if(typeof Symbol==="function"){Readable.prototype[Symbol.asyncIterator]=function(){if(m===undefined){m=r(871)}return m(this)}}Object.defineProperty(Readable.prototype,"readableHighWaterMark",{enumerable:false,get:function get(){return this._readableState.highWaterMark}});Object.defineProperty(Readable.prototype,"readableBuffer",{enumerable:false,get:function get(){return this._readableState&&this._readableState.buffer}});Object.defineProperty(Readable.prototype,"readableFlowing",{enumerable:false,get:function get(){return this._readableState.flowing},set:function set(e){if(this._readableState){this._readableState.flowing=e}}});Readable._fromList=fromList;Object.defineProperty(Readable.prototype,"readableLength",{enumerable:false,get:function get(){return this._readableState.length}});function fromList(e,t){if(t.length===0)return null;var r;if(t.objectMode)r=t.buffer.shift();else if(!e||e>=t.length){if(t.decoder)r=t.buffer.join("");else if(t.buffer.length===1)r=t.buffer.first();else r=t.buffer.concat(t.length);t.buffer.clear()}else{r=t.buffer.consume(e,t.decoder)}return r}function endReadable(e){var t=e._readableState;u("endReadable",t.endEmitted);if(!t.endEmitted){t.ended=true;process.nextTick(endReadableNT,t,e)}}function endReadableNT(e,t){u("endReadableNT",e.endEmitted,e.length);if(!e.endEmitted&&e.length===0){e.endEmitted=true;t.readable=false;t.emit("end");if(e.autoDestroy){var r=t._writableState;if(!r||r.autoDestroy&&r.finished){t.destroy()}}}}if(typeof Symbol==="function"){Readable.from=function(e,t){if(S===undefined){S=r(727)}return S(Readable,e,t)}}function indexOf(e,t){for(var r=0,n=e.length;r<n;r++){if(e[r]===t)return r}return-1}},170:function(e,t,r){"use strict";e.exports=Transform;var n=r(646).q,i=n.ERR_METHOD_NOT_IMPLEMENTED,a=n.ERR_MULTIPLE_CALLBACK,o=n.ERR_TRANSFORM_ALREADY_TRANSFORMING,s=n.ERR_TRANSFORM_WITH_LENGTH_0;var f=r(403);r(782)(Transform,f);function afterTransform(e,t){var r=this._transformState;r.transforming=false;var n=r.writecb;if(n===null){return this.emit("error",new a)}r.writechunk=null;r.writecb=null;if(t!=null)this.push(t);n(e);var i=this._readableState;i.reading=false;if(i.needReadable||i.length<i.highWaterMark){this._read(i.highWaterMark)}}function Transform(e){if(!(this instanceof Transform))return new Transform(e);f.call(this,e);this._transformState={afterTransform:afterTransform.bind(this),needTransform:false,transforming:false,writecb:null,writechunk:null,writeencoding:null};this._readableState.needReadable=true;this._readableState.sync=false;if(e){if(typeof e.transform==="function")this._transform=e.transform;if(typeof e.flush==="function")this._flush=e.flush}this.on("prefinish",prefinish)}function prefinish(){var e=this;if(typeof this._flush==="function"&&!this._readableState.destroyed){this._flush((function(t,r){done(e,t,r)}))}else{done(this,null,null)}}Transform.prototype.push=function(e,t){this._transformState.needTransform=false;return f.prototype.push.call(this,e,t)};Transform.prototype._transform=function(e,t,r){r(new i("_transform()"))};Transform.prototype._write=function(e,t,r){var n=this._transformState;n.writecb=r;n.writechunk=e;n.writeencoding=t;if(!n.transforming){var i=this._readableState;if(n.needTransform||i.needReadable||i.length<i.highWaterMark)this._read(i.highWaterMark)}};Transform.prototype._read=function(e){var t=this._transformState;if(t.writechunk!==null&&!t.transforming){t.transforming=true;this._transform(t.writechunk,t.writeencoding,t.afterTransform)}else{t.needTransform=true}};Transform.prototype._destroy=function(e,t){f.prototype._destroy.call(this,e,(function(e){t(e)}))};function done(e,t,r){if(t)return e.emit("error",t);if(r!=null)e.push(r);if(e._writableState.length)throw new s;if(e._transformState.transforming)throw new o;return e.push(null)}},337:function(e,t,r){"use strict";e.exports=Writable;function WriteReq(e,t,r){this.chunk=e;this.encoding=t;this.callback=r;this.next=null}function CorkedRequest(e){var t=this;this.next=null;this.entry=null;this.finish=function(){onCorkedFinish(t,e)}}var n;Writable.WritableState=WritableState;var i={deprecate:r(769)};var a=r(678);var o=r(300).Buffer;var s=__webpack_require__.g.Uint8Array||function(){};function _uint8ArrayToBuffer(e){return o.from(e)}function _isUint8Array(e){return o.isBuffer(e)||e instanceof s}var f=r(25);var l=r(776),u=l.getHighWaterMark;var d=r(646).q,c=d.ERR_INVALID_ARG_TYPE,h=d.ERR_METHOD_NOT_IMPLEMENTED,p=d.ERR_MULTIPLE_CALLBACK,b=d.ERR_STREAM_CANNOT_PIPE,g=d.ERR_STREAM_DESTROYED,y=d.ERR_STREAM_NULL_VALUES,_=d.ERR_STREAM_WRITE_AFTER_END,v=d.ERR_UNKNOWN_ENCODING;var w=f.errorOrDestroy;r(782)(Writable,a);function nop(){}function WritableState(e,t,i){n=n||r(403);e=e||{};if(typeof i!=="boolean")i=t instanceof n;this.objectMode=!!e.objectMode;if(i)this.objectMode=this.objectMode||!!e.writableObjectMode;this.highWaterMark=u(this,e,"writableHighWaterMark",i);this.finalCalled=false;this.needDrain=false;this.ending=false;this.ended=false;this.finished=false;this.destroyed=false;var a=e.decodeStrings===false;this.decodeStrings=!a;this.defaultEncoding=e.defaultEncoding||"utf8";this.length=0;this.writing=false;this.corked=0;this.sync=true;this.bufferProcessing=false;this.onwrite=function(e){onwrite(t,e)};this.writecb=null;this.writelen=0;this.bufferedRequest=null;this.lastBufferedRequest=null;this.pendingcb=0;this.prefinished=false;this.errorEmitted=false;this.emitClose=e.emitClose!==false;this.autoDestroy=!!e.autoDestroy;this.bufferedRequestCount=0;this.corkedRequestsFree=new CorkedRequest(this)}WritableState.prototype.getBuffer=function getBuffer(){var e=this.bufferedRequest;var t=[];while(e){t.push(e);e=e.next}return t};(function(){try{Object.defineProperty(WritableState.prototype,"buffer",{get:i.deprecate((function writableStateBufferGetter(){return this.getBuffer()}),"_writableState.buffer is deprecated. Use _writableState.getBuffer "+"instead.","DEP0003")})}catch(e){}})();var m;if(typeof Symbol==="function"&&Symbol.hasInstance&&typeof Function.prototype[Symbol.hasInstance]==="function"){m=Function.prototype[Symbol.hasInstance];Object.defineProperty(Writable,Symbol.hasInstance,{value:function value(e){if(m.call(this,e))return true;if(this!==Writable)return false;return e&&e._writableState instanceof WritableState}})}else{m=function realHasInstance(e){return e instanceof this}}function Writable(e){n=n||r(403);var t=this instanceof n;if(!t&&!m.call(Writable,this))return new Writable(e);this._writableState=new WritableState(e,this,t);this.writable=true;if(e){if(typeof e.write==="function")this._write=e.write;if(typeof e.writev==="function")this._writev=e.writev;if(typeof e.destroy==="function")this._destroy=e.destroy;if(typeof e.final==="function")this._final=e.final}a.call(this)}Writable.prototype.pipe=function(){w(this,new b)};function writeAfterEnd(e,t){var r=new _;w(e,r);process.nextTick(t,r)}function validChunk(e,t,r,n){var i;if(r===null){i=new y}else if(typeof r!=="string"&&!t.objectMode){i=new c("chunk",["string","Buffer"],r)}if(i){w(e,i);process.nextTick(n,i);return false}return true}Writable.prototype.write=function(e,t,r){var n=this._writableState;var i=false;var a=!n.objectMode&&_isUint8Array(e);if(a&&!o.isBuffer(e)){e=_uint8ArrayToBuffer(e)}if(typeof t==="function"){r=t;t=null}if(a)t="buffer";else if(!t)t=n.defaultEncoding;if(typeof r!=="function")r=nop;if(n.ending)writeAfterEnd(this,r);else if(a||validChunk(this,n,e,r)){n.pendingcb++;i=writeOrBuffer(this,n,a,e,t,r)}return i};Writable.prototype.cork=function(){this._writableState.corked++};Writable.prototype.uncork=function(){var e=this._writableState;if(e.corked){e.corked--;if(!e.writing&&!e.corked&&!e.bufferProcessing&&e.bufferedRequest)clearBuffer(this,e)}};Writable.prototype.setDefaultEncoding=function setDefaultEncoding(e){if(typeof e==="string")e=e.toLowerCase();if(!(["hex","utf8","utf-8","ascii","binary","base64","ucs2","ucs-2","utf16le","utf-16le","raw"].indexOf((e+"").toLowerCase())>-1))throw new v(e);this._writableState.defaultEncoding=e;return this};Object.defineProperty(Writable.prototype,"writableBuffer",{enumerable:false,get:function get(){return this._writableState&&this._writableState.getBuffer()}});function decodeChunk(e,t,r){if(!e.objectMode&&e.decodeStrings!==false&&typeof t==="string"){t=o.from(t,r)}return t}Object.defineProperty(Writable.prototype,"writableHighWaterMark",{enumerable:false,get:function get(){return this._writableState.highWaterMark}});function writeOrBuffer(e,t,r,n,i,a){if(!r){var o=decodeChunk(t,n,i);if(n!==o){r=true;i="buffer";n=o}}var s=t.objectMode?1:n.length;t.length+=s;var f=t.length<t.highWaterMark;if(!f)t.needDrain=true;if(t.writing||t.corked){var l=t.lastBufferedRequest;t.lastBufferedRequest={chunk:n,encoding:i,isBuf:r,callback:a,next:null};if(l){l.next=t.lastBufferedRequest}else{t.bufferedRequest=t.lastBufferedRequest}t.bufferedRequestCount+=1}else{doWrite(e,t,false,s,n,i,a)}return f}function doWrite(e,t,r,n,i,a,o){t.writelen=n;t.writecb=o;t.writing=true;t.sync=true;if(t.destroyed)t.onwrite(new g("write"));else if(r)e._writev(i,t.onwrite);else e._write(i,a,t.onwrite);t.sync=false}function onwriteError(e,t,r,n,i){--t.pendingcb;if(r){process.nextTick(i,n);process.nextTick(finishMaybe,e,t);e._writableState.errorEmitted=true;w(e,n)}else{i(n);e._writableState.errorEmitted=true;w(e,n);finishMaybe(e,t)}}function onwriteStateUpdate(e){e.writing=false;e.writecb=null;e.length-=e.writelen;e.writelen=0}function onwrite(e,t){var r=e._writableState;var n=r.sync;var i=r.writecb;if(typeof i!=="function")throw new p;onwriteStateUpdate(r);if(t)onwriteError(e,r,n,t,i);else{var a=needFinish(r)||e.destroyed;if(!a&&!r.corked&&!r.bufferProcessing&&r.bufferedRequest){clearBuffer(e,r)}if(n){process.nextTick(afterWrite,e,r,a,i)}else{afterWrite(e,r,a,i)}}}function afterWrite(e,t,r,n){if(!r)onwriteDrain(e,t);t.pendingcb--;n();finishMaybe(e,t)}function onwriteDrain(e,t){if(t.length===0&&t.needDrain){t.needDrain=false;e.emit("drain")}}function clearBuffer(e,t){t.bufferProcessing=true;var r=t.bufferedRequest;if(e._writev&&r&&r.next){var n=t.bufferedRequestCount;var i=new Array(n);var a=t.corkedRequestsFree;a.entry=r;var o=0;var s=true;while(r){i[o]=r;if(!r.isBuf)s=false;r=r.next;o+=1}i.allBuffers=s;doWrite(e,t,true,t.length,i,"",a.finish);t.pendingcb++;t.lastBufferedRequest=null;if(a.next){t.corkedRequestsFree=a.next;a.next=null}else{t.corkedRequestsFree=new CorkedRequest(t)}t.bufferedRequestCount=0}else{while(r){var f=r.chunk;var l=r.encoding;var u=r.callback;var d=t.objectMode?1:f.length;doWrite(e,t,false,d,f,l,u);r=r.next;t.bufferedRequestCount--;if(t.writing){break}}if(r===null)t.lastBufferedRequest=null}t.bufferedRequest=r;t.bufferProcessing=false}Writable.prototype._write=function(e,t,r){r(new h("_write()"))};Writable.prototype._writev=null;Writable.prototype.end=function(e,t,r){var n=this._writableState;if(typeof e==="function"){r=e;e=null;t=null}else if(typeof t==="function"){r=t;t=null}if(e!==null&&e!==undefined)this.write(e,t);if(n.corked){n.corked=1;this.uncork()}if(!n.ending)endWritable(this,n,r);return this};Object.defineProperty(Writable.prototype,"writableLength",{enumerable:false,get:function get(){return this._writableState.length}});function needFinish(e){return e.ending&&e.length===0&&e.bufferedRequest===null&&!e.finished&&!e.writing}function callFinal(e,t){e._final((function(r){t.pendingcb--;if(r){w(e,r)}t.prefinished=true;e.emit("prefinish");finishMaybe(e,t)}))}function prefinish(e,t){if(!t.prefinished&&!t.finalCalled){if(typeof e._final==="function"&&!t.destroyed){t.pendingcb++;t.finalCalled=true;process.nextTick(callFinal,e,t)}else{t.prefinished=true;e.emit("prefinish")}}}function finishMaybe(e,t){var r=needFinish(t);if(r){prefinish(e,t);if(t.pendingcb===0){t.finished=true;e.emit("finish");if(t.autoDestroy){var n=e._readableState;if(!n||n.autoDestroy&&n.endEmitted){e.destroy()}}}}return r}function endWritable(e,t,r){t.ending=true;finishMaybe(e,t);if(r){if(t.finished)process.nextTick(r);else e.once("finish",r)}t.ended=true;e.writable=false}function onCorkedFinish(e,t,r){var n=e.entry;e.entry=null;while(n){var i=n.callback;t.pendingcb--;i(r);n=n.next}t.corkedRequestsFree.next=e}Object.defineProperty(Writable.prototype,"destroyed",{enumerable:false,get:function get(){if(this._writableState===undefined){return false}return this._writableState.destroyed},set:function set(e){if(!this._writableState){return}this._writableState.destroyed=e}});Writable.prototype.destroy=f.destroy;Writable.prototype._undestroy=f.undestroy;Writable.prototype._destroy=function(e,t){t(e)}},871:function(e,t,r){"use strict";var n;function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}var i=r(698);var a=Symbol("lastResolve");var o=Symbol("lastReject");var s=Symbol("error");var f=Symbol("ended");var l=Symbol("lastPromise");var u=Symbol("handlePromise");var d=Symbol("stream");function createIterResult(e,t){return{value:e,done:t}}function readAndResolve(e){var t=e[a];if(t!==null){var r=e[d].read();if(r!==null){e[l]=null;e[a]=null;e[o]=null;t(createIterResult(r,false))}}}function onReadable(e){process.nextTick(readAndResolve,e)}function wrapForNext(e,t){return function(r,n){e.then((function(){if(t[f]){r(createIterResult(undefined,true));return}t[u](r,n)}),n)}}var c=Object.getPrototypeOf((function(){}));var h=Object.setPrototypeOf((n={get stream(){return this[d]},next:function next(){var e=this;var t=this[s];if(t!==null){return Promise.reject(t)}if(this[f]){return Promise.resolve(createIterResult(undefined,true))}if(this[d].destroyed){return new Promise((function(t,r){process.nextTick((function(){if(e[s]){r(e[s])}else{t(createIterResult(undefined,true))}}))}))}var r=this[l];var n;if(r){n=new Promise(wrapForNext(r,this))}else{var i=this[d].read();if(i!==null){return Promise.resolve(createIterResult(i,false))}n=new Promise(this[u])}this[l]=n;return n}},_defineProperty(n,Symbol.asyncIterator,(function(){return this})),_defineProperty(n,"return",(function _return(){var e=this;return new Promise((function(t,r){e[d].destroy(null,(function(e){if(e){r(e);return}t(createIterResult(undefined,true))}))}))})),n),c);var p=function createReadableStreamAsyncIterator(e){var t;var r=Object.create(h,(t={},_defineProperty(t,d,{value:e,writable:true}),_defineProperty(t,a,{value:null,writable:true}),_defineProperty(t,o,{value:null,writable:true}),_defineProperty(t,s,{value:null,writable:true}),_defineProperty(t,f,{value:e._readableState.endEmitted,writable:true}),_defineProperty(t,u,{value:function value(e,t){var n=r[d].read();if(n){r[l]=null;r[a]=null;r[o]=null;e(createIterResult(n,false))}else{r[a]=e;r[o]=t}},writable:true}),t));r[l]=null;i(e,(function(e){if(e&&e.code!=="ERR_STREAM_PREMATURE_CLOSE"){var t=r[o];if(t!==null){r[l]=null;r[a]=null;r[o]=null;t(e)}r[s]=e;return}var n=r[a];if(n!==null){r[l]=null;r[a]=null;r[o]=null;n(createIterResult(undefined,true))}r[f]=true}));e.on("readable",onReadable.bind(null,r));return r};e.exports=p},379:function(e,t,r){"use strict";function ownKeys(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);if(t)n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}));r.push.apply(r,n)}return r}function _objectSpread(e){for(var t=1;t<arguments.length;t++){var r=arguments[t]!=null?arguments[t]:{};if(t%2){ownKeys(Object(r),true).forEach((function(t){_defineProperty(e,t,r[t])}))}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(e,Object.getOwnPropertyDescriptors(r))}else{ownKeys(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}}return e}function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}function _classCallCheck(e,t){if(!(e instanceof t)){throw new TypeError("Cannot call a class as a function")}}function _defineProperties(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||false;n.configurable=true;if("value"in n)n.writable=true;Object.defineProperty(e,n.key,n)}}function _createClass(e,t,r){if(t)_defineProperties(e.prototype,t);if(r)_defineProperties(e,r);return e}var n=r(300),i=n.Buffer;var a=r(837),o=a.inspect;var s=o&&o.custom||"inspect";function copyBuffer(e,t,r){i.prototype.copy.call(e,t,r)}e.exports=function(){function BufferList(){_classCallCheck(this,BufferList);this.head=null;this.tail=null;this.length=0}_createClass(BufferList,[{key:"push",value:function push(e){var t={data:e,next:null};if(this.length>0)this.tail.next=t;else this.head=t;this.tail=t;++this.length}},{key:"unshift",value:function unshift(e){var t={data:e,next:this.head};if(this.length===0)this.tail=t;this.head=t;++this.length}},{key:"shift",value:function shift(){if(this.length===0)return;var e=this.head.data;if(this.length===1)this.head=this.tail=null;else this.head=this.head.next;--this.length;return e}},{key:"clear",value:function clear(){this.head=this.tail=null;this.length=0}},{key:"join",value:function join(e){if(this.length===0)return"";var t=this.head;var r=""+t.data;while(t=t.next){r+=e+t.data}return r}},{key:"concat",value:function concat(e){if(this.length===0)return i.alloc(0);var t=i.allocUnsafe(e>>>0);var r=this.head;var n=0;while(r){copyBuffer(r.data,t,n);n+=r.data.length;r=r.next}return t}},{key:"consume",value:function consume(e,t){var r;if(e<this.head.data.length){r=this.head.data.slice(0,e);this.head.data=this.head.data.slice(e)}else if(e===this.head.data.length){r=this.shift()}else{r=t?this._getString(e):this._getBuffer(e)}return r}},{key:"first",value:function first(){return this.head.data}},{key:"_getString",value:function _getString(e){var t=this.head;var r=1;var n=t.data;e-=n.length;while(t=t.next){var i=t.data;var a=e>i.length?i.length:e;if(a===i.length)n+=i;else n+=i.slice(0,e);e-=a;if(e===0){if(a===i.length){++r;if(t.next)this.head=t.next;else this.head=this.tail=null}else{this.head=t;t.data=i.slice(a)}break}++r}this.length-=r;return n}},{key:"_getBuffer",value:function _getBuffer(e){var t=i.allocUnsafe(e);var r=this.head;var n=1;r.data.copy(t);e-=r.data.length;while(r=r.next){var a=r.data;var o=e>a.length?a.length:e;a.copy(t,t.length-e,0,o);e-=o;if(e===0){if(o===a.length){++n;if(r.next)this.head=r.next;else this.head=this.tail=null}else{this.head=r;r.data=a.slice(o)}break}++n}this.length-=n;return t}},{key:s,value:function value(e,t){return o(this,_objectSpread({},t,{depth:0,customInspect:false}))}}]);return BufferList}()},25:function(e){"use strict";function destroy(e,t){var r=this;var n=this._readableState&&this._readableState.destroyed;var i=this._writableState&&this._writableState.destroyed;if(n||i){if(t){t(e)}else if(e){if(!this._writableState){process.nextTick(emitErrorNT,this,e)}else if(!this._writableState.errorEmitted){this._writableState.errorEmitted=true;process.nextTick(emitErrorNT,this,e)}}return this}if(this._readableState){this._readableState.destroyed=true}if(this._writableState){this._writableState.destroyed=true}this._destroy(e||null,(function(e){if(!t&&e){if(!r._writableState){process.nextTick(emitErrorAndCloseNT,r,e)}else if(!r._writableState.errorEmitted){r._writableState.errorEmitted=true;process.nextTick(emitErrorAndCloseNT,r,e)}else{process.nextTick(emitCloseNT,r)}}else if(t){process.nextTick(emitCloseNT,r);t(e)}else{process.nextTick(emitCloseNT,r)}}));return this}function emitErrorAndCloseNT(e,t){emitErrorNT(e,t);emitCloseNT(e)}function emitCloseNT(e){if(e._writableState&&!e._writableState.emitClose)return;if(e._readableState&&!e._readableState.emitClose)return;e.emit("close")}function undestroy(){if(this._readableState){this._readableState.destroyed=false;this._readableState.reading=false;this._readableState.ended=false;this._readableState.endEmitted=false}if(this._writableState){this._writableState.destroyed=false;this._writableState.ended=false;this._writableState.ending=false;this._writableState.finalCalled=false;this._writableState.prefinished=false;this._writableState.finished=false;this._writableState.errorEmitted=false}}function emitErrorNT(e,t){e.emit("error",t)}function errorOrDestroy(e,t){var r=e._readableState;var n=e._writableState;if(r&&r.autoDestroy||n&&n.autoDestroy)e.destroy(t);else e.emit("error",t)}e.exports={destroy:destroy,undestroy:undestroy,errorOrDestroy:errorOrDestroy}},698:function(e,t,r){"use strict";var n=r(646).q.ERR_STREAM_PREMATURE_CLOSE;function once(e){var t=false;return function(){if(t)return;t=true;for(var r=arguments.length,n=new Array(r),i=0;i<r;i++){n[i]=arguments[i]}e.apply(this,n)}}function noop(){}function isRequest(e){return e.setHeader&&typeof e.abort==="function"}function eos(e,t,r){if(typeof t==="function")return eos(e,null,t);if(!t)t={};r=once(r||noop);var i=t.readable||t.readable!==false&&e.readable;var a=t.writable||t.writable!==false&&e.writable;var o=function onlegacyfinish(){if(!e.writable)f()};var s=e._writableState&&e._writableState.finished;var f=function onfinish(){a=false;s=true;if(!i)r.call(e)};var l=e._readableState&&e._readableState.endEmitted;var u=function onend(){i=false;l=true;if(!a)r.call(e)};var d=function onerror(t){r.call(e,t)};var c=function onclose(){var t;if(i&&!l){if(!e._readableState||!e._readableState.ended)t=new n;return r.call(e,t)}if(a&&!s){if(!e._writableState||!e._writableState.ended)t=new n;return r.call(e,t)}};var h=function onrequest(){e.req.on("finish",f)};if(isRequest(e)){e.on("complete",f);e.on("abort",c);if(e.req)h();else e.on("request",h)}else if(a&&!e._writableState){e.on("end",o);e.on("close",o)}e.on("end",u);e.on("finish",f);if(t.error!==false)e.on("error",d);e.on("close",c);return function(){e.removeListener("complete",f);e.removeListener("abort",c);e.removeListener("request",h);if(e.req)e.req.removeListener("finish",f);e.removeListener("end",o);e.removeListener("close",o);e.removeListener("finish",f);e.removeListener("end",u);e.removeListener("error",d);e.removeListener("close",c)}}e.exports=eos},727:function(e,t,r){"use strict";function asyncGeneratorStep(e,t,r,n,i,a,o){try{var s=e[a](o);var f=s.value}catch(e){r(e);return}if(s.done){t(f)}else{Promise.resolve(f).then(n,i)}}function _asyncToGenerator(e){return function(){var t=this,r=arguments;return new Promise((function(n,i){var a=e.apply(t,r);function _next(e){asyncGeneratorStep(a,n,i,_next,_throw,"next",e)}function _throw(e){asyncGeneratorStep(a,n,i,_next,_throw,"throw",e)}_next(undefined)}))}}function ownKeys(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);if(t)n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}));r.push.apply(r,n)}return r}function _objectSpread(e){for(var t=1;t<arguments.length;t++){var r=arguments[t]!=null?arguments[t]:{};if(t%2){ownKeys(Object(r),true).forEach((function(t){_defineProperty(e,t,r[t])}))}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(e,Object.getOwnPropertyDescriptors(r))}else{ownKeys(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}}return e}function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}var n=r(646).q.ERR_INVALID_ARG_TYPE;function from(e,t,r){var i;if(t&&typeof t.next==="function"){i=t}else if(t&&t[Symbol.asyncIterator])i=t[Symbol.asyncIterator]();else if(t&&t[Symbol.iterator])i=t[Symbol.iterator]();else throw new n("iterable",["Iterable"],t);var a=new e(_objectSpread({objectMode:true},r));var o=false;a._read=function(){if(!o){o=true;next()}};function next(){return _next2.apply(this,arguments)}function _next2(){_next2=_asyncToGenerator((function*(){try{var e=yield i.next(),t=e.value,r=e.done;if(r){a.push(null)}else if(a.push(yield t)){next()}else{o=false}}catch(e){a.destroy(e)}}));return _next2.apply(this,arguments)}return a}e.exports=from},442:function(e,t,r){"use strict";var n;function once(e){var t=false;return function(){if(t)return;t=true;e.apply(void 0,arguments)}}var i=r(646).q,a=i.ERR_MISSING_ARGS,o=i.ERR_STREAM_DESTROYED;function noop(e){if(e)throw e}function isRequest(e){return e.setHeader&&typeof e.abort==="function"}function destroyer(e,t,i,a){a=once(a);var s=false;e.on("close",(function(){s=true}));if(n===undefined)n=r(698);n(e,{readable:t,writable:i},(function(e){if(e)return a(e);s=true;a()}));var f=false;return function(t){if(s)return;if(f)return;f=true;if(isRequest(e))return e.abort();if(typeof e.destroy==="function")return e.destroy();a(t||new o("pipe"))}}function call(e){e()}function pipe(e,t){return e.pipe(t)}function popCallback(e){if(!e.length)return noop;if(typeof e[e.length-1]!=="function")return noop;return e.pop()}function pipeline(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++){t[r]=arguments[r]}var n=popCallback(t);if(Array.isArray(t[0]))t=t[0];if(t.length<2){throw new a("streams")}var i;var o=t.map((function(e,r){var a=r<t.length-1;var s=r>0;return destroyer(e,a,s,(function(e){if(!i)i=e;if(e)o.forEach(call);if(a)return;o.forEach(call);n(i)}))}));return t.reduce(pipe)}e.exports=pipeline},776:function(e,t,r){"use strict";var n=r(646).q.ERR_INVALID_OPT_VALUE;function highWaterMarkFrom(e,t,r){return e.highWaterMark!=null?e.highWaterMark:t?e[r]:null}function getHighWaterMark(e,t,r,i){var a=highWaterMarkFrom(t,i,r);if(a!=null){if(!(isFinite(a)&&Math.floor(a)===a)||a<0){var o=i?r:"highWaterMark";throw new n(o,a)}return Math.floor(a)}return e.objectMode?16:16*1024}e.exports={getHighWaterMark:getHighWaterMark}},678:function(e,t,r){e.exports=r(781)},55:function(e,t,r){var n=r(300);var i=n.Buffer;function copyProps(e,t){for(var r in e){t[r]=e[r]}}if(i.from&&i.alloc&&i.allocUnsafe&&i.allocUnsafeSlow){e.exports=n}else{copyProps(n,t);t.Buffer=SafeBuffer}function SafeBuffer(e,t,r){return i(e,t,r)}SafeBuffer.prototype=Object.create(i.prototype);copyProps(i,SafeBuffer);SafeBuffer.from=function(e,t,r){if(typeof e==="number"){throw new TypeError("Argument must not be a number")}return i(e,t,r)};SafeBuffer.alloc=function(e,t,r){if(typeof e!=="number"){throw new TypeError("Argument must be a number")}var n=i(e);if(t!==undefined){if(typeof r==="string"){n.fill(t,r)}else{n.fill(t)}}else{n.fill(0)}return n};SafeBuffer.allocUnsafe=function(e){if(typeof e!=="number"){throw new TypeError("Argument must be a number")}return i(e)};SafeBuffer.allocUnsafeSlow=function(e){if(typeof e!=="number"){throw new TypeError("Argument must be a number")}return n.SlowBuffer(e)}},173:function(e,t,r){e.exports=Stream;var n=r(361).EventEmitter;var i=r(782);i(Stream,n);Stream.Readable=r(709);Stream.Writable=r(337);Stream.Duplex=r(403);Stream.Transform=r(170);Stream.PassThrough=r(889);Stream.finished=r(698);Stream.pipeline=r(442);Stream.Stream=Stream;function Stream(){n.call(this)}Stream.prototype.pipe=function(e,t){var r=this;function ondata(t){if(e.writable){if(false===e.write(t)&&r.pause){r.pause()}}}r.on("data",ondata);function ondrain(){if(r.readable&&r.resume){r.resume()}}e.on("drain",ondrain);if(!e._isStdio&&(!t||t.end!==false)){r.on("end",onend);r.on("close",onclose)}var i=false;function onend(){if(i)return;i=true;e.end()}function onclose(){if(i)return;i=true;if(typeof e.destroy==="function")e.destroy()}function onerror(e){cleanup();if(n.listenerCount(this,"error")===0){throw e}}r.on("error",onerror);e.on("error",onerror);function cleanup(){r.removeListener("data",ondata);e.removeListener("drain",ondrain);r.removeListener("end",onend);r.removeListener("close",onclose);r.removeListener("error",onerror);e.removeListener("error",onerror);r.removeListener("end",cleanup);r.removeListener("close",cleanup);e.removeListener("close",cleanup)}r.on("end",cleanup);r.on("close",cleanup);e.on("close",cleanup);e.emit("pipe",r);return e}},704:function(e,t,r){"use strict";var n=r(55).Buffer;var i=n.isEncoding||function(e){e=""+e;switch(e&&e.toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":case"raw":return true;default:return false}};function _normalizeEncoding(e){if(!e)return"utf8";var t;while(true){switch(e){case"utf8":case"utf-8":return"utf8";case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return"utf16le";case"latin1":case"binary":return"latin1";case"base64":case"ascii":case"hex":return e;default:if(t)return;e=(""+e).toLowerCase();t=true}}}function normalizeEncoding(e){var t=_normalizeEncoding(e);if(typeof t!=="string"&&(n.isEncoding===i||!i(e)))throw new Error("Unknown encoding: "+e);return t||e}t.s=StringDecoder;function StringDecoder(e){this.encoding=normalizeEncoding(e);var t;switch(this.encoding){case"utf16le":this.text=utf16Text;this.end=utf16End;t=4;break;case"utf8":this.fillLast=utf8FillLast;t=4;break;case"base64":this.text=base64Text;this.end=base64End;t=3;break;default:this.write=simpleWrite;this.end=simpleEnd;return}this.lastNeed=0;this.lastTotal=0;this.lastChar=n.allocUnsafe(t)}StringDecoder.prototype.write=function(e){if(e.length===0)return"";var t;var r;if(this.lastNeed){t=this.fillLast(e);if(t===undefined)return"";r=this.lastNeed;this.lastNeed=0}else{r=0}if(r<e.length)return t?t+this.text(e,r):this.text(e,r);return t||""};StringDecoder.prototype.end=utf8End;StringDecoder.prototype.text=utf8Text;StringDecoder.prototype.fillLast=function(e){if(this.lastNeed<=e.length){e.copy(this.lastChar,this.lastTotal-this.lastNeed,0,this.lastNeed);return this.lastChar.toString(this.encoding,0,this.lastTotal)}e.copy(this.lastChar,this.lastTotal-this.lastNeed,0,e.length);this.lastNeed-=e.length};function utf8CheckByte(e){if(e<=127)return 0;else if(e>>5===6)return 2;else if(e>>4===14)return 3;else if(e>>3===30)return 4;return e>>6===2?-1:-2}function utf8CheckIncomplete(e,t,r){var n=t.length-1;if(n<r)return 0;var i=utf8CheckByte(t[n]);if(i>=0){if(i>0)e.lastNeed=i-1;return i}if(--n<r||i===-2)return 0;i=utf8CheckByte(t[n]);if(i>=0){if(i>0)e.lastNeed=i-2;return i}if(--n<r||i===-2)return 0;i=utf8CheckByte(t[n]);if(i>=0){if(i>0){if(i===2)i=0;else e.lastNeed=i-3}return i}return 0}function utf8CheckExtraBytes(e,t,r){if((t[0]&192)!==128){e.lastNeed=0;return"�"}if(e.lastNeed>1&&t.length>1){if((t[1]&192)!==128){e.lastNeed=1;return"�"}if(e.lastNeed>2&&t.length>2){if((t[2]&192)!==128){e.lastNeed=2;return"�"}}}}function utf8FillLast(e){var t=this.lastTotal-this.lastNeed;var r=utf8CheckExtraBytes(this,e,t);if(r!==undefined)return r;if(this.lastNeed<=e.length){e.copy(this.lastChar,t,0,this.lastNeed);return this.lastChar.toString(this.encoding,0,this.lastTotal)}e.copy(this.lastChar,t,0,e.length);this.lastNeed-=e.length}function utf8Text(e,t){var r=utf8CheckIncomplete(this,e,t);if(!this.lastNeed)return e.toString("utf8",t);this.lastTotal=r;var n=e.length-(r-this.lastNeed);e.copy(this.lastChar,0,n);return e.toString("utf8",t,n)}function utf8End(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed)return t+"�";return t}function utf16Text(e,t){if((e.length-t)%2===0){var r=e.toString("utf16le",t);if(r){var n=r.charCodeAt(r.length-1);if(n>=55296&&n<=56319){this.lastNeed=2;this.lastTotal=4;this.lastChar[0]=e[e.length-2];this.lastChar[1]=e[e.length-1];return r.slice(0,-1)}}return r}this.lastNeed=1;this.lastTotal=2;this.lastChar[0]=e[e.length-1];return e.toString("utf16le",t,e.length-1)}function utf16End(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed){var r=this.lastTotal-this.lastNeed;return t+this.lastChar.toString("utf16le",0,r)}return t}function base64Text(e,t){var r=(e.length-t)%3;if(r===0)return e.toString("base64",t);this.lastNeed=3-r;this.lastTotal=3;if(r===1){this.lastChar[0]=e[e.length-1]}else{this.lastChar[0]=e[e.length-2];this.lastChar[1]=e[e.length-1]}return e.toString("base64",t,e.length-r)}function base64End(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed)return t+this.lastChar.toString("base64",0,3-this.lastNeed);return t}function simpleWrite(e){return e.toString(this.encoding)}function simpleEnd(e){return e&&e.length?this.write(e):""}},769:function(e){e.exports=deprecate;function deprecate(e,t){if(config("noDeprecation")){return e}var r=false;function deprecated(){if(!r){if(config("throwDeprecation")){throw new Error(t)}else if(config("traceDeprecation")){console.trace(t)}else{console.warn(t)}r=true}return e.apply(this,arguments)}return deprecated}function config(e){try{if(!__webpack_require__.g.localStorage)return false}catch(e){return false}var t=__webpack_require__.g.localStorage[e];if(null==t)return false;return String(t).toLowerCase()==="true"}},300:function(e){"use strict";e.exports=__webpack_require__(48764)},361:function(e){"use strict";e.exports=__webpack_require__(25293)},781:function(e){"use strict";e.exports=(__webpack_require__(25293).EventEmitter)},837:function(e){"use strict";e.exports=__webpack_require__(79720)}};var t={};function __nccwpck_require__(r){var n=t[r];if(n!==undefined){return n.exports}var i=t[r]={exports:{}};var a=true;try{e[r](i,i.exports,__nccwpck_require__);a=false}finally{if(a)delete t[r]}return i.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var r=__nccwpck_require__(173);module.exports=r})();

/***/ }),

/***/ 79720:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __dirname = "/";
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];
/* provided dependency */ var process = __webpack_require__(34155);
(function(){var r={992:function(r){r.exports=function(r,t,n){if(r.filter)return r.filter(t,n);if(void 0===r||null===r)throw new TypeError;if("function"!=typeof t)throw new TypeError;var o=[];for(var i=0;i<r.length;i++){if(!e.call(r,i))continue;var a=r[i];if(t.call(n,a,i,r))o.push(a)}return o};var e=Object.prototype.hasOwnProperty},256:function(r,e,t){"use strict";var n=t(500);var o=t(139);var i=o(n("String.prototype.indexOf"));r.exports=function callBoundIntrinsic(r,e){var t=n(r,!!e);if(typeof t==="function"&&i(r,".prototype.")>-1){return o(t)}return t}},139:function(r,e,t){"use strict";var n=t(174);var o=t(500);var i=o("%Function.prototype.apply%");var a=o("%Function.prototype.call%");var f=o("%Reflect.apply%",true)||n.call(a,i);var u=o("%Object.getOwnPropertyDescriptor%",true);var s=o("%Object.defineProperty%",true);var y=o("%Math.max%");if(s){try{s({},"a",{value:1})}catch(r){s=null}}r.exports=function callBind(r){var e=f(n,a,arguments);if(u&&s){var t=u(e,"length");if(t.configurable){s(e,"length",{value:1+y(0,r.length-(arguments.length-1))})}}return e};var c=function applyBind(){return f(n,i,arguments)};if(s){s(r.exports,"apply",{value:c})}else{r.exports.apply=c}},144:function(r){var e=Object.prototype.hasOwnProperty;var t=Object.prototype.toString;r.exports=function forEach(r,n,o){if(t.call(n)!=="[object Function]"){throw new TypeError("iterator must be a function")}var i=r.length;if(i===+i){for(var a=0;a<i;a++){n.call(o,r[a],a,r)}}else{for(var f in r){if(e.call(r,f)){n.call(o,r[f],f,r)}}}}},426:function(r){"use strict";var e="Function.prototype.bind called on incompatible ";var t=Array.prototype.slice;var n=Object.prototype.toString;var o="[object Function]";r.exports=function bind(r){var i=this;if(typeof i!=="function"||n.call(i)!==o){throw new TypeError(e+i)}var a=t.call(arguments,1);var f;var binder=function(){if(this instanceof f){var e=i.apply(this,a.concat(t.call(arguments)));if(Object(e)===e){return e}return this}else{return i.apply(r,a.concat(t.call(arguments)))}};var u=Math.max(0,i.length-a.length);var s=[];for(var y=0;y<u;y++){s.push("$"+y)}f=Function("binder","return function ("+s.join(",")+"){ return binder.apply(this,arguments); }")(binder);if(i.prototype){var c=function Empty(){};c.prototype=i.prototype;f.prototype=new c;c.prototype=null}return f}},174:function(r,e,t){"use strict";var n=t(426);r.exports=Function.prototype.bind||n},500:function(r,e,t){"use strict";var n;var o=SyntaxError;var i=Function;var a=TypeError;var getEvalledConstructor=function(r){try{return i('"use strict"; return ('+r+").constructor;")()}catch(r){}};var f=Object.getOwnPropertyDescriptor;if(f){try{f({},"")}catch(r){f=null}}var throwTypeError=function(){throw new a};var u=f?function(){try{arguments.callee;return throwTypeError}catch(r){try{return f(arguments,"callee").get}catch(r){return throwTypeError}}}():throwTypeError;var s=t(115)();var y=Object.getPrototypeOf||function(r){return r.__proto__};var c={};var p=typeof Uint8Array==="undefined"?n:y(Uint8Array);var l={"%AggregateError%":typeof AggregateError==="undefined"?n:AggregateError,"%Array%":Array,"%ArrayBuffer%":typeof ArrayBuffer==="undefined"?n:ArrayBuffer,"%ArrayIteratorPrototype%":s?y([][Symbol.iterator]()):n,"%AsyncFromSyncIteratorPrototype%":n,"%AsyncFunction%":c,"%AsyncGenerator%":c,"%AsyncGeneratorFunction%":c,"%AsyncIteratorPrototype%":c,"%Atomics%":typeof Atomics==="undefined"?n:Atomics,"%BigInt%":typeof BigInt==="undefined"?n:BigInt,"%Boolean%":Boolean,"%DataView%":typeof DataView==="undefined"?n:DataView,"%Date%":Date,"%decodeURI%":decodeURI,"%decodeURIComponent%":decodeURIComponent,"%encodeURI%":encodeURI,"%encodeURIComponent%":encodeURIComponent,"%Error%":Error,"%eval%":eval,"%EvalError%":EvalError,"%Float32Array%":typeof Float32Array==="undefined"?n:Float32Array,"%Float64Array%":typeof Float64Array==="undefined"?n:Float64Array,"%FinalizationRegistry%":typeof FinalizationRegistry==="undefined"?n:FinalizationRegistry,"%Function%":i,"%GeneratorFunction%":c,"%Int8Array%":typeof Int8Array==="undefined"?n:Int8Array,"%Int16Array%":typeof Int16Array==="undefined"?n:Int16Array,"%Int32Array%":typeof Int32Array==="undefined"?n:Int32Array,"%isFinite%":isFinite,"%isNaN%":isNaN,"%IteratorPrototype%":s?y(y([][Symbol.iterator]())):n,"%JSON%":typeof JSON==="object"?JSON:n,"%Map%":typeof Map==="undefined"?n:Map,"%MapIteratorPrototype%":typeof Map==="undefined"||!s?n:y((new Map)[Symbol.iterator]()),"%Math%":Math,"%Number%":Number,"%Object%":Object,"%parseFloat%":parseFloat,"%parseInt%":parseInt,"%Promise%":typeof Promise==="undefined"?n:Promise,"%Proxy%":typeof Proxy==="undefined"?n:Proxy,"%RangeError%":RangeError,"%ReferenceError%":ReferenceError,"%Reflect%":typeof Reflect==="undefined"?n:Reflect,"%RegExp%":RegExp,"%Set%":typeof Set==="undefined"?n:Set,"%SetIteratorPrototype%":typeof Set==="undefined"||!s?n:y((new Set)[Symbol.iterator]()),"%SharedArrayBuffer%":typeof SharedArrayBuffer==="undefined"?n:SharedArrayBuffer,"%String%":String,"%StringIteratorPrototype%":s?y(""[Symbol.iterator]()):n,"%Symbol%":s?Symbol:n,"%SyntaxError%":o,"%ThrowTypeError%":u,"%TypedArray%":p,"%TypeError%":a,"%Uint8Array%":typeof Uint8Array==="undefined"?n:Uint8Array,"%Uint8ClampedArray%":typeof Uint8ClampedArray==="undefined"?n:Uint8ClampedArray,"%Uint16Array%":typeof Uint16Array==="undefined"?n:Uint16Array,"%Uint32Array%":typeof Uint32Array==="undefined"?n:Uint32Array,"%URIError%":URIError,"%WeakMap%":typeof WeakMap==="undefined"?n:WeakMap,"%WeakRef%":typeof WeakRef==="undefined"?n:WeakRef,"%WeakSet%":typeof WeakSet==="undefined"?n:WeakSet};var g=function doEval(r){var e;if(r==="%AsyncFunction%"){e=getEvalledConstructor("async function () {}")}else if(r==="%GeneratorFunction%"){e=getEvalledConstructor("function* () {}")}else if(r==="%AsyncGeneratorFunction%"){e=getEvalledConstructor("async function* () {}")}else if(r==="%AsyncGenerator%"){var t=doEval("%AsyncGeneratorFunction%");if(t){e=t.prototype}}else if(r==="%AsyncIteratorPrototype%"){var n=doEval("%AsyncGenerator%");if(n){e=y(n.prototype)}}l[r]=e;return e};var b={"%ArrayBufferPrototype%":["ArrayBuffer","prototype"],"%ArrayPrototype%":["Array","prototype"],"%ArrayProto_entries%":["Array","prototype","entries"],"%ArrayProto_forEach%":["Array","prototype","forEach"],"%ArrayProto_keys%":["Array","prototype","keys"],"%ArrayProto_values%":["Array","prototype","values"],"%AsyncFunctionPrototype%":["AsyncFunction","prototype"],"%AsyncGenerator%":["AsyncGeneratorFunction","prototype"],"%AsyncGeneratorPrototype%":["AsyncGeneratorFunction","prototype","prototype"],"%BooleanPrototype%":["Boolean","prototype"],"%DataViewPrototype%":["DataView","prototype"],"%DatePrototype%":["Date","prototype"],"%ErrorPrototype%":["Error","prototype"],"%EvalErrorPrototype%":["EvalError","prototype"],"%Float32ArrayPrototype%":["Float32Array","prototype"],"%Float64ArrayPrototype%":["Float64Array","prototype"],"%FunctionPrototype%":["Function","prototype"],"%Generator%":["GeneratorFunction","prototype"],"%GeneratorPrototype%":["GeneratorFunction","prototype","prototype"],"%Int8ArrayPrototype%":["Int8Array","prototype"],"%Int16ArrayPrototype%":["Int16Array","prototype"],"%Int32ArrayPrototype%":["Int32Array","prototype"],"%JSONParse%":["JSON","parse"],"%JSONStringify%":["JSON","stringify"],"%MapPrototype%":["Map","prototype"],"%NumberPrototype%":["Number","prototype"],"%ObjectPrototype%":["Object","prototype"],"%ObjProto_toString%":["Object","prototype","toString"],"%ObjProto_valueOf%":["Object","prototype","valueOf"],"%PromisePrototype%":["Promise","prototype"],"%PromiseProto_then%":["Promise","prototype","then"],"%Promise_all%":["Promise","all"],"%Promise_reject%":["Promise","reject"],"%Promise_resolve%":["Promise","resolve"],"%RangeErrorPrototype%":["RangeError","prototype"],"%ReferenceErrorPrototype%":["ReferenceError","prototype"],"%RegExpPrototype%":["RegExp","prototype"],"%SetPrototype%":["Set","prototype"],"%SharedArrayBufferPrototype%":["SharedArrayBuffer","prototype"],"%StringPrototype%":["String","prototype"],"%SymbolPrototype%":["Symbol","prototype"],"%SyntaxErrorPrototype%":["SyntaxError","prototype"],"%TypedArrayPrototype%":["TypedArray","prototype"],"%TypeErrorPrototype%":["TypeError","prototype"],"%Uint8ArrayPrototype%":["Uint8Array","prototype"],"%Uint8ClampedArrayPrototype%":["Uint8ClampedArray","prototype"],"%Uint16ArrayPrototype%":["Uint16Array","prototype"],"%Uint32ArrayPrototype%":["Uint32Array","prototype"],"%URIErrorPrototype%":["URIError","prototype"],"%WeakMapPrototype%":["WeakMap","prototype"],"%WeakSetPrototype%":["WeakSet","prototype"]};var d=t(174);var v=t(101);var m=d.call(Function.call,Array.prototype.concat);var S=d.call(Function.apply,Array.prototype.splice);var A=d.call(Function.call,String.prototype.replace);var h=d.call(Function.call,String.prototype.slice);var O=d.call(Function.call,RegExp.prototype.exec);var j=/[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;var w=/\\(\\)?/g;var P=function stringToPath(r){var e=h(r,0,1);var t=h(r,-1);if(e==="%"&&t!=="%"){throw new o("invalid intrinsic syntax, expected closing `%`")}else if(t==="%"&&e!=="%"){throw new o("invalid intrinsic syntax, expected opening `%`")}var n=[];A(r,j,(function(r,e,t,o){n[n.length]=t?A(o,w,"$1"):e||r}));return n};var E=function getBaseIntrinsic(r,e){var t=r;var n;if(v(b,t)){n=b[t];t="%"+n[0]+"%"}if(v(l,t)){var i=l[t];if(i===c){i=g(t)}if(typeof i==="undefined"&&!e){throw new a("intrinsic "+r+" exists, but is not available. Please file an issue!")}return{alias:n,name:t,value:i}}throw new o("intrinsic "+r+" does not exist!")};r.exports=function GetIntrinsic(r,e){if(typeof r!=="string"||r.length===0){throw new a("intrinsic name must be a non-empty string")}if(arguments.length>1&&typeof e!=="boolean"){throw new a('"allowMissing" argument must be a boolean')}if(O(/^%?[^%]*%?$/g,r)===null){throw new o("`%` may not be present anywhere but at the beginning and end of the intrinsic name")}var t=P(r);var i=t.length>0?t[0]:"";var u=E("%"+i+"%",e);var s=u.name;var y=u.value;var c=false;var p=u.alias;if(p){i=p[0];S(t,m([0,1],p))}for(var g=1,b=true;g<t.length;g+=1){var d=t[g];var A=h(d,0,1);var j=h(d,-1);if((A==='"'||A==="'"||A==="`"||(j==='"'||j==="'"||j==="`"))&&A!==j){throw new o("property names with quotes must have matching quotes")}if(d==="constructor"||!b){c=true}i+="."+d;s="%"+i+"%";if(v(l,s)){y=l[s]}else if(y!=null){if(!(d in y)){if(!e){throw new a("base intrinsic for "+r+" exists, but the property is not available.")}return void n}if(f&&g+1>=t.length){var w=f(y,d);b=!!w;if(b&&"get"in w&&!("originalValue"in w.get)){y=w.get}else{y=y[d]}}else{b=v(y,d);y=y[d]}if(b&&!c){l[s]=y}}}return y}},942:function(r,e,t){"use strict";var n=typeof Symbol!=="undefined"&&Symbol;var o=t(773);r.exports=function hasNativeSymbols(){if(typeof n!=="function"){return false}if(typeof Symbol!=="function"){return false}if(typeof n("foo")!=="symbol"){return false}if(typeof Symbol("bar")!=="symbol"){return false}return o()}},773:function(r){"use strict";r.exports=function hasSymbols(){if(typeof Symbol!=="function"||typeof Object.getOwnPropertySymbols!=="function"){return false}if(typeof Symbol.iterator==="symbol"){return true}var r={};var e=Symbol("test");var t=Object(e);if(typeof e==="string"){return false}if(Object.prototype.toString.call(e)!=="[object Symbol]"){return false}if(Object.prototype.toString.call(t)!=="[object Symbol]"){return false}var n=42;r[e]=n;for(e in r){return false}if(typeof Object.keys==="function"&&Object.keys(r).length!==0){return false}if(typeof Object.getOwnPropertyNames==="function"&&Object.getOwnPropertyNames(r).length!==0){return false}var o=Object.getOwnPropertySymbols(r);if(o.length!==1||o[0]!==e){return false}if(!Object.prototype.propertyIsEnumerable.call(r,e)){return false}if(typeof Object.getOwnPropertyDescriptor==="function"){var i=Object.getOwnPropertyDescriptor(r,e);if(i.value!==n||i.enumerable!==true){return false}}return true}},115:function(r,e,t){"use strict";var n=typeof Symbol!=="undefined"&&Symbol;var o=t(832);r.exports=function hasNativeSymbols(){if(typeof n!=="function"){return false}if(typeof Symbol!=="function"){return false}if(typeof n("foo")!=="symbol"){return false}if(typeof Symbol("bar")!=="symbol"){return false}return o()}},832:function(r){"use strict";r.exports=function hasSymbols(){if(typeof Symbol!=="function"||typeof Object.getOwnPropertySymbols!=="function"){return false}if(typeof Symbol.iterator==="symbol"){return true}var r={};var e=Symbol("test");var t=Object(e);if(typeof e==="string"){return false}if(Object.prototype.toString.call(e)!=="[object Symbol]"){return false}if(Object.prototype.toString.call(t)!=="[object Symbol]"){return false}var n=42;r[e]=n;for(e in r){return false}if(typeof Object.keys==="function"&&Object.keys(r).length!==0){return false}if(typeof Object.getOwnPropertyNames==="function"&&Object.getOwnPropertyNames(r).length!==0){return false}var o=Object.getOwnPropertySymbols(r);if(o.length!==1||o[0]!==e){return false}if(!Object.prototype.propertyIsEnumerable.call(r,e)){return false}if(typeof Object.getOwnPropertyDescriptor==="function"){var i=Object.getOwnPropertyDescriptor(r,e);if(i.value!==n||i.enumerable!==true){return false}}return true}},101:function(r,e,t){"use strict";var n=t(174);r.exports=n.call(Function.call,Object.prototype.hasOwnProperty)},782:function(r){if(typeof Object.create==="function"){r.exports=function inherits(r,e){if(e){r.super_=e;r.prototype=Object.create(e.prototype,{constructor:{value:r,enumerable:false,writable:true,configurable:true}})}}}else{r.exports=function inherits(r,e){if(e){r.super_=e;var TempCtor=function(){};TempCtor.prototype=e.prototype;r.prototype=new TempCtor;r.prototype.constructor=r}}}},157:function(r){"use strict";var e=typeof Symbol==="function"&&typeof Symbol.toStringTag==="symbol";var t=Object.prototype.toString;var n=function isArguments(r){if(e&&r&&typeof r==="object"&&Symbol.toStringTag in r){return false}return t.call(r)==="[object Arguments]"};var o=function isArguments(r){if(n(r)){return true}return r!==null&&typeof r==="object"&&typeof r.length==="number"&&r.length>=0&&t.call(r)!=="[object Array]"&&t.call(r.callee)==="[object Function]"};var i=function(){return n(arguments)}();n.isLegacyArguments=o;r.exports=i?n:o},391:function(r){"use strict";var e=Object.prototype.toString;var t=Function.prototype.toString;var n=/^\s*(?:function)?\*/;var o=typeof Symbol==="function"&&typeof Symbol.toStringTag==="symbol";var i=Object.getPrototypeOf;var getGeneratorFunc=function(){if(!o){return false}try{return Function("return function*() {}")()}catch(r){}};var a=getGeneratorFunc();var f=a?i(a):{};r.exports=function isGeneratorFunction(r){if(typeof r!=="function"){return false}if(n.test(t.call(r))){return true}if(!o){var a=e.call(r);return a==="[object GeneratorFunction]"}return i(r)===f}},994:function(r,e,t){"use strict";var n=t(144);var o=t(349);var i=t(256);var a=i("Object.prototype.toString");var f=t(942)();var u=f&&typeof Symbol.toStringTag==="symbol";var s=o();var y=i("Array.prototype.indexOf",true)||function indexOf(r,e){for(var t=0;t<r.length;t+=1){if(r[t]===e){return t}}return-1};var c=i("String.prototype.slice");var p={};var l=t(466);var g=Object.getPrototypeOf;if(u&&l&&g){n(s,(function(r){var e=new __webpack_require__.g[r];if(!(Symbol.toStringTag in e)){throw new EvalError("this engine has support for Symbol.toStringTag, but "+r+" does not have the property! Please report this.")}var t=g(e);var n=l(t,Symbol.toStringTag);if(!n){var o=g(t);n=l(o,Symbol.toStringTag)}p[r]=n.get}))}var b=function tryAllTypedArrays(r){var e=false;n(p,(function(t,n){if(!e){try{e=t.call(r)===n}catch(r){}}}));return e};r.exports=function isTypedArray(r){if(!r||typeof r!=="object"){return false}if(!u){var e=c(a(r),8,-1);return y(s,e)>-1}if(!l){return false}return b(r)}},369:function(r){r.exports=function isBuffer(r){return r instanceof Buffer}},584:function(r,e,t){"use strict";var n=t(157);var o=t(391);var i=t(490);var a=t(994);function uncurryThis(r){return r.call.bind(r)}var f=typeof BigInt!=="undefined";var u=typeof Symbol!=="undefined";var s=uncurryThis(Object.prototype.toString);var y=uncurryThis(Number.prototype.valueOf);var c=uncurryThis(String.prototype.valueOf);var p=uncurryThis(Boolean.prototype.valueOf);if(f){var l=uncurryThis(BigInt.prototype.valueOf)}if(u){var g=uncurryThis(Symbol.prototype.valueOf)}function checkBoxedPrimitive(r,e){if(typeof r!=="object"){return false}try{e(r);return true}catch(r){return false}}e.isArgumentsObject=n;e.isGeneratorFunction=o;e.isTypedArray=a;function isPromise(r){return typeof Promise!=="undefined"&&r instanceof Promise||r!==null&&typeof r==="object"&&typeof r.then==="function"&&typeof r.catch==="function"}e.isPromise=isPromise;function isArrayBufferView(r){if(typeof ArrayBuffer!=="undefined"&&ArrayBuffer.isView){return ArrayBuffer.isView(r)}return a(r)||isDataView(r)}e.isArrayBufferView=isArrayBufferView;function isUint8Array(r){return i(r)==="Uint8Array"}e.isUint8Array=isUint8Array;function isUint8ClampedArray(r){return i(r)==="Uint8ClampedArray"}e.isUint8ClampedArray=isUint8ClampedArray;function isUint16Array(r){return i(r)==="Uint16Array"}e.isUint16Array=isUint16Array;function isUint32Array(r){return i(r)==="Uint32Array"}e.isUint32Array=isUint32Array;function isInt8Array(r){return i(r)==="Int8Array"}e.isInt8Array=isInt8Array;function isInt16Array(r){return i(r)==="Int16Array"}e.isInt16Array=isInt16Array;function isInt32Array(r){return i(r)==="Int32Array"}e.isInt32Array=isInt32Array;function isFloat32Array(r){return i(r)==="Float32Array"}e.isFloat32Array=isFloat32Array;function isFloat64Array(r){return i(r)==="Float64Array"}e.isFloat64Array=isFloat64Array;function isBigInt64Array(r){return i(r)==="BigInt64Array"}e.isBigInt64Array=isBigInt64Array;function isBigUint64Array(r){return i(r)==="BigUint64Array"}e.isBigUint64Array=isBigUint64Array;function isMapToString(r){return s(r)==="[object Map]"}isMapToString.working=typeof Map!=="undefined"&&isMapToString(new Map);function isMap(r){if(typeof Map==="undefined"){return false}return isMapToString.working?isMapToString(r):r instanceof Map}e.isMap=isMap;function isSetToString(r){return s(r)==="[object Set]"}isSetToString.working=typeof Set!=="undefined"&&isSetToString(new Set);function isSet(r){if(typeof Set==="undefined"){return false}return isSetToString.working?isSetToString(r):r instanceof Set}e.isSet=isSet;function isWeakMapToString(r){return s(r)==="[object WeakMap]"}isWeakMapToString.working=typeof WeakMap!=="undefined"&&isWeakMapToString(new WeakMap);function isWeakMap(r){if(typeof WeakMap==="undefined"){return false}return isWeakMapToString.working?isWeakMapToString(r):r instanceof WeakMap}e.isWeakMap=isWeakMap;function isWeakSetToString(r){return s(r)==="[object WeakSet]"}isWeakSetToString.working=typeof WeakSet!=="undefined"&&isWeakSetToString(new WeakSet);function isWeakSet(r){return isWeakSetToString(r)}e.isWeakSet=isWeakSet;function isArrayBufferToString(r){return s(r)==="[object ArrayBuffer]"}isArrayBufferToString.working=typeof ArrayBuffer!=="undefined"&&isArrayBufferToString(new ArrayBuffer);function isArrayBuffer(r){if(typeof ArrayBuffer==="undefined"){return false}return isArrayBufferToString.working?isArrayBufferToString(r):r instanceof ArrayBuffer}e.isArrayBuffer=isArrayBuffer;function isDataViewToString(r){return s(r)==="[object DataView]"}isDataViewToString.working=typeof ArrayBuffer!=="undefined"&&typeof DataView!=="undefined"&&isDataViewToString(new DataView(new ArrayBuffer(1),0,1));function isDataView(r){if(typeof DataView==="undefined"){return false}return isDataViewToString.working?isDataViewToString(r):r instanceof DataView}e.isDataView=isDataView;var b=typeof SharedArrayBuffer!=="undefined"?SharedArrayBuffer:undefined;function isSharedArrayBufferToString(r){return s(r)==="[object SharedArrayBuffer]"}function isSharedArrayBuffer(r){if(typeof b==="undefined"){return false}if(typeof isSharedArrayBufferToString.working==="undefined"){isSharedArrayBufferToString.working=isSharedArrayBufferToString(new b)}return isSharedArrayBufferToString.working?isSharedArrayBufferToString(r):r instanceof b}e.isSharedArrayBuffer=isSharedArrayBuffer;function isAsyncFunction(r){return s(r)==="[object AsyncFunction]"}e.isAsyncFunction=isAsyncFunction;function isMapIterator(r){return s(r)==="[object Map Iterator]"}e.isMapIterator=isMapIterator;function isSetIterator(r){return s(r)==="[object Set Iterator]"}e.isSetIterator=isSetIterator;function isGeneratorObject(r){return s(r)==="[object Generator]"}e.isGeneratorObject=isGeneratorObject;function isWebAssemblyCompiledModule(r){return s(r)==="[object WebAssembly.Module]"}e.isWebAssemblyCompiledModule=isWebAssemblyCompiledModule;function isNumberObject(r){return checkBoxedPrimitive(r,y)}e.isNumberObject=isNumberObject;function isStringObject(r){return checkBoxedPrimitive(r,c)}e.isStringObject=isStringObject;function isBooleanObject(r){return checkBoxedPrimitive(r,p)}e.isBooleanObject=isBooleanObject;function isBigIntObject(r){return f&&checkBoxedPrimitive(r,l)}e.isBigIntObject=isBigIntObject;function isSymbolObject(r){return u&&checkBoxedPrimitive(r,g)}e.isSymbolObject=isSymbolObject;function isBoxedPrimitive(r){return isNumberObject(r)||isStringObject(r)||isBooleanObject(r)||isBigIntObject(r)||isSymbolObject(r)}e.isBoxedPrimitive=isBoxedPrimitive;function isAnyArrayBuffer(r){return typeof Uint8Array!=="undefined"&&(isArrayBuffer(r)||isSharedArrayBuffer(r))}e.isAnyArrayBuffer=isAnyArrayBuffer;["isProxy","isExternal","isModuleNamespaceObject"].forEach((function(r){Object.defineProperty(e,r,{enumerable:false,value:function(){throw new Error(r+" is not supported in userland")}})}))},177:function(r,e,t){var n=Object.getOwnPropertyDescriptors||function getOwnPropertyDescriptors(r){var e=Object.keys(r);var t={};for(var n=0;n<e.length;n++){t[e[n]]=Object.getOwnPropertyDescriptor(r,e[n])}return t};var o=/%[sdj%]/g;e.format=function(r){if(!isString(r)){var e=[];for(var t=0;t<arguments.length;t++){e.push(inspect(arguments[t]))}return e.join(" ")}var t=1;var n=arguments;var i=n.length;var a=String(r).replace(o,(function(r){if(r==="%%")return"%";if(t>=i)return r;switch(r){case"%s":return String(n[t++]);case"%d":return Number(n[t++]);case"%j":try{return JSON.stringify(n[t++])}catch(r){return"[Circular]"}default:return r}}));for(var f=n[t];t<i;f=n[++t]){if(isNull(f)||!isObject(f)){a+=" "+f}else{a+=" "+inspect(f)}}return a};e.deprecate=function(r,t){if(typeof process!=="undefined"&&process.noDeprecation===true){return r}if(typeof process==="undefined"){return function(){return e.deprecate(r,t).apply(this,arguments)}}var n=false;function deprecated(){if(!n){if(process.throwDeprecation){throw new Error(t)}else if(process.traceDeprecation){console.trace(t)}else{console.error(t)}n=true}return r.apply(this,arguments)}return deprecated};var i={};var a=/^$/;if(process.env.NODE_DEBUG){var f=process.env.NODE_DEBUG;f=f.replace(/[|\\{}()[\]^$+?.]/g,"\\$&").replace(/\*/g,".*").replace(/,/g,"$|^").toUpperCase();a=new RegExp("^"+f+"$","i")}e.debuglog=function(r){r=r.toUpperCase();if(!i[r]){if(a.test(r)){var t=process.pid;i[r]=function(){var n=e.format.apply(e,arguments);console.error("%s %d: %s",r,t,n)}}else{i[r]=function(){}}}return i[r]};function inspect(r,t){var n={seen:[],stylize:stylizeNoColor};if(arguments.length>=3)n.depth=arguments[2];if(arguments.length>=4)n.colors=arguments[3];if(isBoolean(t)){n.showHidden=t}else if(t){e._extend(n,t)}if(isUndefined(n.showHidden))n.showHidden=false;if(isUndefined(n.depth))n.depth=2;if(isUndefined(n.colors))n.colors=false;if(isUndefined(n.customInspect))n.customInspect=true;if(n.colors)n.stylize=stylizeWithColor;return formatValue(n,r,n.depth)}e.inspect=inspect;inspect.colors={bold:[1,22],italic:[3,23],underline:[4,24],inverse:[7,27],white:[37,39],grey:[90,39],black:[30,39],blue:[34,39],cyan:[36,39],green:[32,39],magenta:[35,39],red:[31,39],yellow:[33,39]};inspect.styles={special:"cyan",number:"yellow",boolean:"yellow",undefined:"grey",null:"bold",string:"green",date:"magenta",regexp:"red"};function stylizeWithColor(r,e){var t=inspect.styles[e];if(t){return"["+inspect.colors[t][0]+"m"+r+"["+inspect.colors[t][1]+"m"}else{return r}}function stylizeNoColor(r,e){return r}function arrayToHash(r){var e={};r.forEach((function(r,t){e[r]=true}));return e}function formatValue(r,t,n){if(r.customInspect&&t&&isFunction(t.inspect)&&t.inspect!==e.inspect&&!(t.constructor&&t.constructor.prototype===t)){var o=t.inspect(n,r);if(!isString(o)){o=formatValue(r,o,n)}return o}var i=formatPrimitive(r,t);if(i){return i}var a=Object.keys(t);var f=arrayToHash(a);if(r.showHidden){a=Object.getOwnPropertyNames(t)}if(isError(t)&&(a.indexOf("message")>=0||a.indexOf("description")>=0)){return formatError(t)}if(a.length===0){if(isFunction(t)){var u=t.name?": "+t.name:"";return r.stylize("[Function"+u+"]","special")}if(isRegExp(t)){return r.stylize(RegExp.prototype.toString.call(t),"regexp")}if(isDate(t)){return r.stylize(Date.prototype.toString.call(t),"date")}if(isError(t)){return formatError(t)}}var s="",y=false,c=["{","}"];if(isArray(t)){y=true;c=["[","]"]}if(isFunction(t)){var p=t.name?": "+t.name:"";s=" [Function"+p+"]"}if(isRegExp(t)){s=" "+RegExp.prototype.toString.call(t)}if(isDate(t)){s=" "+Date.prototype.toUTCString.call(t)}if(isError(t)){s=" "+formatError(t)}if(a.length===0&&(!y||t.length==0)){return c[0]+s+c[1]}if(n<0){if(isRegExp(t)){return r.stylize(RegExp.prototype.toString.call(t),"regexp")}else{return r.stylize("[Object]","special")}}r.seen.push(t);var l;if(y){l=formatArray(r,t,n,f,a)}else{l=a.map((function(e){return formatProperty(r,t,n,f,e,y)}))}r.seen.pop();return reduceToSingleString(l,s,c)}function formatPrimitive(r,e){if(isUndefined(e))return r.stylize("undefined","undefined");if(isString(e)){var t="'"+JSON.stringify(e).replace(/^"|"$/g,"").replace(/'/g,"\\'").replace(/\\"/g,'"')+"'";return r.stylize(t,"string")}if(isNumber(e))return r.stylize(""+e,"number");if(isBoolean(e))return r.stylize(""+e,"boolean");if(isNull(e))return r.stylize("null","null")}function formatError(r){return"["+Error.prototype.toString.call(r)+"]"}function formatArray(r,e,t,n,o){var i=[];for(var a=0,f=e.length;a<f;++a){if(hasOwnProperty(e,String(a))){i.push(formatProperty(r,e,t,n,String(a),true))}else{i.push("")}}o.forEach((function(o){if(!o.match(/^\d+$/)){i.push(formatProperty(r,e,t,n,o,true))}}));return i}function formatProperty(r,e,t,n,o,i){var a,f,u;u=Object.getOwnPropertyDescriptor(e,o)||{value:e[o]};if(u.get){if(u.set){f=r.stylize("[Getter/Setter]","special")}else{f=r.stylize("[Getter]","special")}}else{if(u.set){f=r.stylize("[Setter]","special")}}if(!hasOwnProperty(n,o)){a="["+o+"]"}if(!f){if(r.seen.indexOf(u.value)<0){if(isNull(t)){f=formatValue(r,u.value,null)}else{f=formatValue(r,u.value,t-1)}if(f.indexOf("\n")>-1){if(i){f=f.split("\n").map((function(r){return"  "+r})).join("\n").substr(2)}else{f="\n"+f.split("\n").map((function(r){return"   "+r})).join("\n")}}}else{f=r.stylize("[Circular]","special")}}if(isUndefined(a)){if(i&&o.match(/^\d+$/)){return f}a=JSON.stringify(""+o);if(a.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)){a=a.substr(1,a.length-2);a=r.stylize(a,"name")}else{a=a.replace(/'/g,"\\'").replace(/\\"/g,'"').replace(/(^"|"$)/g,"'");a=r.stylize(a,"string")}}return a+": "+f}function reduceToSingleString(r,e,t){var n=0;var o=r.reduce((function(r,e){n++;if(e.indexOf("\n")>=0)n++;return r+e.replace(/\u001b\[\d\d?m/g,"").length+1}),0);if(o>60){return t[0]+(e===""?"":e+"\n ")+" "+r.join(",\n  ")+" "+t[1]}return t[0]+e+" "+r.join(", ")+" "+t[1]}e.types=t(584);function isArray(r){return Array.isArray(r)}e.isArray=isArray;function isBoolean(r){return typeof r==="boolean"}e.isBoolean=isBoolean;function isNull(r){return r===null}e.isNull=isNull;function isNullOrUndefined(r){return r==null}e.isNullOrUndefined=isNullOrUndefined;function isNumber(r){return typeof r==="number"}e.isNumber=isNumber;function isString(r){return typeof r==="string"}e.isString=isString;function isSymbol(r){return typeof r==="symbol"}e.isSymbol=isSymbol;function isUndefined(r){return r===void 0}e.isUndefined=isUndefined;function isRegExp(r){return isObject(r)&&objectToString(r)==="[object RegExp]"}e.isRegExp=isRegExp;e.types.isRegExp=isRegExp;function isObject(r){return typeof r==="object"&&r!==null}e.isObject=isObject;function isDate(r){return isObject(r)&&objectToString(r)==="[object Date]"}e.isDate=isDate;e.types.isDate=isDate;function isError(r){return isObject(r)&&(objectToString(r)==="[object Error]"||r instanceof Error)}e.isError=isError;e.types.isNativeError=isError;function isFunction(r){return typeof r==="function"}e.isFunction=isFunction;function isPrimitive(r){return r===null||typeof r==="boolean"||typeof r==="number"||typeof r==="string"||typeof r==="symbol"||typeof r==="undefined"}e.isPrimitive=isPrimitive;e.isBuffer=t(369);function objectToString(r){return Object.prototype.toString.call(r)}function pad(r){return r<10?"0"+r.toString(10):r.toString(10)}var u=["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];function timestamp(){var r=new Date;var e=[pad(r.getHours()),pad(r.getMinutes()),pad(r.getSeconds())].join(":");return[r.getDate(),u[r.getMonth()],e].join(" ")}e.log=function(){console.log("%s - %s",timestamp(),e.format.apply(e,arguments))};e.inherits=t(782);e._extend=function(r,e){if(!e||!isObject(e))return r;var t=Object.keys(e);var n=t.length;while(n--){r[t[n]]=e[t[n]]}return r};function hasOwnProperty(r,e){return Object.prototype.hasOwnProperty.call(r,e)}var s=typeof Symbol!=="undefined"?Symbol("util.promisify.custom"):undefined;e.promisify=function promisify(r){if(typeof r!=="function")throw new TypeError('The "original" argument must be of type Function');if(s&&r[s]){var e=r[s];if(typeof e!=="function"){throw new TypeError('The "util.promisify.custom" argument must be of type Function')}Object.defineProperty(e,s,{value:e,enumerable:false,writable:false,configurable:true});return e}function e(){var e,t;var n=new Promise((function(r,n){e=r;t=n}));var o=[];for(var i=0;i<arguments.length;i++){o.push(arguments[i])}o.push((function(r,n){if(r){t(r)}else{e(n)}}));try{r.apply(this,o)}catch(r){t(r)}return n}Object.setPrototypeOf(e,Object.getPrototypeOf(r));if(s)Object.defineProperty(e,s,{value:e,enumerable:false,writable:false,configurable:true});return Object.defineProperties(e,n(r))};e.promisify.custom=s;function callbackifyOnRejected(r,e){if(!r){var t=new Error("Promise was rejected with a falsy value");t.reason=r;r=t}return e(r)}function callbackify(r){if(typeof r!=="function"){throw new TypeError('The "original" argument must be of type Function')}function callbackified(){var e=[];for(var t=0;t<arguments.length;t++){e.push(arguments[t])}var n=e.pop();if(typeof n!=="function"){throw new TypeError("The last argument must be of type Function")}var o=this;var cb=function(){return n.apply(o,arguments)};r.apply(this,e).then((function(r){process.nextTick(cb.bind(null,null,r))}),(function(r){process.nextTick(callbackifyOnRejected.bind(null,r,cb))}))}Object.setPrototypeOf(callbackified,Object.getPrototypeOf(r));Object.defineProperties(callbackified,n(r));return callbackified}e.callbackify=callbackify},490:function(r,e,t){"use strict";var n=t(144);var o=t(349);var i=t(256);var a=i("Object.prototype.toString");var f=t(942)();var u=f&&typeof Symbol.toStringTag==="symbol";var s=o();var y=i("String.prototype.slice");var c={};var p=t(466);var l=Object.getPrototypeOf;if(u&&p&&l){n(s,(function(r){if(typeof __webpack_require__.g[r]==="function"){var e=new __webpack_require__.g[r];if(!(Symbol.toStringTag in e)){throw new EvalError("this engine has support for Symbol.toStringTag, but "+r+" does not have the property! Please report this.")}var t=l(e);var n=p(t,Symbol.toStringTag);if(!n){var o=l(t);n=p(o,Symbol.toStringTag)}c[r]=n.get}}))}var g=function tryAllTypedArrays(r){var e=false;n(c,(function(t,n){if(!e){try{var o=t.call(r);if(o===n){e=o}}catch(r){}}}));return e};var b=t(994);r.exports=function whichTypedArray(r){if(!b(r)){return false}if(!u){return y(a(r),8,-1)}return g(r)}},349:function(r,e,t){"use strict";var n=t(992);r.exports=function availableTypedArrays(){return n(["BigInt64Array","BigUint64Array","Float32Array","Float64Array","Int16Array","Int32Array","Int8Array","Uint16Array","Uint32Array","Uint8Array","Uint8ClampedArray"],(function(r){return typeof __webpack_require__.g[r]==="function"}))}},466:function(r,e,t){"use strict";var n=t(500);var o=n("%Object.getOwnPropertyDescriptor%",true);if(o){try{o([],"length")}catch(r){o=null}}r.exports=o}};var e={};function __nccwpck_require__(t){var n=e[t];if(n!==undefined){return n.exports}var o=e[t]={exports:{}};var i=true;try{r[t](o,o.exports,__nccwpck_require__);i=false}finally{if(i)delete e[t]}return o.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var t=__nccwpck_require__(177);module.exports=t})();

/***/ }),

/***/ 51951:
/***/ (function(module) {

var __dirname = "/";
(function(){var __webpack_modules__={950:function(__unused_webpack_module,exports){var indexOf=function(e,t){if(e.indexOf)return e.indexOf(t);else for(var r=0;r<e.length;r++){if(e[r]===t)return r}return-1};var Object_keys=function(e){if(Object.keys)return Object.keys(e);else{var t=[];for(var r in e)t.push(r);return t}};var forEach=function(e,t){if(e.forEach)return e.forEach(t);else for(var r=0;r<e.length;r++){t(e[r],r,e)}};var defineProp=function(){try{Object.defineProperty({},"_",{});return function(e,t,r){Object.defineProperty(e,t,{writable:true,enumerable:false,configurable:true,value:r})}}catch(e){return function(e,t,r){e[t]=r}}}();var globals=["Array","Boolean","Date","Error","EvalError","Function","Infinity","JSON","Math","NaN","Number","Object","RangeError","ReferenceError","RegExp","String","SyntaxError","TypeError","URIError","decodeURI","decodeURIComponent","encodeURI","encodeURIComponent","escape","eval","isFinite","isNaN","parseFloat","parseInt","undefined","unescape"];function Context(){}Context.prototype={};var Script=exports.Script=function NodeScript(e){if(!(this instanceof Script))return new Script(e);this.code=e};Script.prototype.runInContext=function(e){if(!(e instanceof Context)){throw new TypeError("needs a 'context' argument.")}var t=document.createElement("iframe");if(!t.style)t.style={};t.style.display="none";document.body.appendChild(t);var r=t.contentWindow;var n=r.eval,o=r.execScript;if(!n&&o){o.call(r,"null");n=r.eval}forEach(Object_keys(e),(function(t){r[t]=e[t]}));forEach(globals,(function(t){if(e[t]){r[t]=e[t]}}));var c=Object_keys(r);var i=n.call(r,this.code);forEach(Object_keys(r),(function(t){if(t in e||indexOf(c,t)===-1){e[t]=r[t]}}));forEach(globals,(function(t){if(!(t in e)){defineProp(e,t,r[t])}}));document.body.removeChild(t);return i};Script.prototype.runInThisContext=function(){return eval(this.code)};Script.prototype.runInNewContext=function(e){var t=Script.createContext(e);var r=this.runInContext(t);if(e){forEach(Object_keys(t),(function(r){e[r]=t[r]}))}return r};forEach(Object_keys(Script.prototype),(function(e){exports[e]=Script[e]=function(t){var r=Script(t);return r[e].apply(r,[].slice.call(arguments,1))}}));exports.isContext=function(e){return e instanceof Context};exports.createScript=function(e){return exports.Script(e)};exports.createContext=Script.createContext=function(e){var t=new Context;if(typeof e==="object"){forEach(Object_keys(e),(function(r){t[r]=e[r]}))}return t}}};if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var __webpack_exports__={};__webpack_modules__[950](0,__webpack_exports__);module.exports=__webpack_exports__})();

/***/ }),

/***/ 5152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(32323)


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(16505)


/***/ }),

/***/ 41664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(77913)


/***/ }),

/***/ 11163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(61587)


/***/ }),

/***/ 74865:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/* NProgress, (c) 2013, 2014 Rico Sta. Cruz - http://ricostacruz.com/nprogress
 * @license MIT */

;(function(root, factory) {

  if (true) {
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}

})(this, function() {
  var NProgress = {};

  NProgress.version = '0.2.0';

  var Settings = NProgress.settings = {
    minimum: 0.08,
    easing: 'ease',
    positionUsing: '',
    speed: 200,
    trickle: true,
    trickleRate: 0.02,
    trickleSpeed: 800,
    showSpinner: true,
    barSelector: '[role="bar"]',
    spinnerSelector: '[role="spinner"]',
    parent: 'body',
    template: '<div class="bar" role="bar"><div class="peg"></div></div><div class="spinner" role="spinner"><div class="spinner-icon"></div></div>'
  };

  /**
   * Updates configuration.
   *
   *     NProgress.configure({
   *       minimum: 0.1
   *     });
   */
  NProgress.configure = function(options) {
    var key, value;
    for (key in options) {
      value = options[key];
      if (value !== undefined && options.hasOwnProperty(key)) Settings[key] = value;
    }

    return this;
  };

  /**
   * Last number.
   */

  NProgress.status = null;

  /**
   * Sets the progress bar status, where `n` is a number from `0.0` to `1.0`.
   *
   *     NProgress.set(0.4);
   *     NProgress.set(1.0);
   */

  NProgress.set = function(n) {
    var started = NProgress.isStarted();

    n = clamp(n, Settings.minimum, 1);
    NProgress.status = (n === 1 ? null : n);

    var progress = NProgress.render(!started),
        bar      = progress.querySelector(Settings.barSelector),
        speed    = Settings.speed,
        ease     = Settings.easing;

    progress.offsetWidth; /* Repaint */

    queue(function(next) {
      // Set positionUsing if it hasn't already been set
      if (Settings.positionUsing === '') Settings.positionUsing = NProgress.getPositioningCSS();

      // Add transition
      css(bar, barPositionCSS(n, speed, ease));

      if (n === 1) {
        // Fade out
        css(progress, { 
          transition: 'none', 
          opacity: 1 
        });
        progress.offsetWidth; /* Repaint */

        setTimeout(function() {
          css(progress, { 
            transition: 'all ' + speed + 'ms linear', 
            opacity: 0 
          });
          setTimeout(function() {
            NProgress.remove();
            next();
          }, speed);
        }, speed);
      } else {
        setTimeout(next, speed);
      }
    });

    return this;
  };

  NProgress.isStarted = function() {
    return typeof NProgress.status === 'number';
  };

  /**
   * Shows the progress bar.
   * This is the same as setting the status to 0%, except that it doesn't go backwards.
   *
   *     NProgress.start();
   *
   */
  NProgress.start = function() {
    if (!NProgress.status) NProgress.set(0);

    var work = function() {
      setTimeout(function() {
        if (!NProgress.status) return;
        NProgress.trickle();
        work();
      }, Settings.trickleSpeed);
    };

    if (Settings.trickle) work();

    return this;
  };

  /**
   * Hides the progress bar.
   * This is the *sort of* the same as setting the status to 100%, with the
   * difference being `done()` makes some placebo effect of some realistic motion.
   *
   *     NProgress.done();
   *
   * If `true` is passed, it will show the progress bar even if its hidden.
   *
   *     NProgress.done(true);
   */

  NProgress.done = function(force) {
    if (!force && !NProgress.status) return this;

    return NProgress.inc(0.3 + 0.5 * Math.random()).set(1);
  };

  /**
   * Increments by a random amount.
   */

  NProgress.inc = function(amount) {
    var n = NProgress.status;

    if (!n) {
      return NProgress.start();
    } else {
      if (typeof amount !== 'number') {
        amount = (1 - n) * clamp(Math.random() * n, 0.1, 0.95);
      }

      n = clamp(n + amount, 0, 0.994);
      return NProgress.set(n);
    }
  };

  NProgress.trickle = function() {
    return NProgress.inc(Math.random() * Settings.trickleRate);
  };

  /**
   * Waits for all supplied jQuery promises and
   * increases the progress as the promises resolve.
   *
   * @param $promise jQUery Promise
   */
  (function() {
    var initial = 0, current = 0;

    NProgress.promise = function($promise) {
      if (!$promise || $promise.state() === "resolved") {
        return this;
      }

      if (current === 0) {
        NProgress.start();
      }

      initial++;
      current++;

      $promise.always(function() {
        current--;
        if (current === 0) {
            initial = 0;
            NProgress.done();
        } else {
            NProgress.set((initial - current) / initial);
        }
      });

      return this;
    };

  })();

  /**
   * (Internal) renders the progress bar markup based on the `template`
   * setting.
   */

  NProgress.render = function(fromStart) {
    if (NProgress.isRendered()) return document.getElementById('nprogress');

    addClass(document.documentElement, 'nprogress-busy');
    
    var progress = document.createElement('div');
    progress.id = 'nprogress';
    progress.innerHTML = Settings.template;

    var bar      = progress.querySelector(Settings.barSelector),
        perc     = fromStart ? '-100' : toBarPerc(NProgress.status || 0),
        parent   = document.querySelector(Settings.parent),
        spinner;
    
    css(bar, {
      transition: 'all 0 linear',
      transform: 'translate3d(' + perc + '%,0,0)'
    });

    if (!Settings.showSpinner) {
      spinner = progress.querySelector(Settings.spinnerSelector);
      spinner && removeElement(spinner);
    }

    if (parent != document.body) {
      addClass(parent, 'nprogress-custom-parent');
    }

    parent.appendChild(progress);
    return progress;
  };

  /**
   * Removes the element. Opposite of render().
   */

  NProgress.remove = function() {
    removeClass(document.documentElement, 'nprogress-busy');
    removeClass(document.querySelector(Settings.parent), 'nprogress-custom-parent');
    var progress = document.getElementById('nprogress');
    progress && removeElement(progress);
  };

  /**
   * Checks if the progress bar is rendered.
   */

  NProgress.isRendered = function() {
    return !!document.getElementById('nprogress');
  };

  /**
   * Determine which positioning CSS rule to use.
   */

  NProgress.getPositioningCSS = function() {
    // Sniff on document.body.style
    var bodyStyle = document.body.style;

    // Sniff prefixes
    var vendorPrefix = ('WebkitTransform' in bodyStyle) ? 'Webkit' :
                       ('MozTransform' in bodyStyle) ? 'Moz' :
                       ('msTransform' in bodyStyle) ? 'ms' :
                       ('OTransform' in bodyStyle) ? 'O' : '';

    if (vendorPrefix + 'Perspective' in bodyStyle) {
      // Modern browsers with 3D support, e.g. Webkit, IE10
      return 'translate3d';
    } else if (vendorPrefix + 'Transform' in bodyStyle) {
      // Browsers without 3D support, e.g. IE9
      return 'translate';
    } else {
      // Browsers without translate() support, e.g. IE7-8
      return 'margin';
    }
  };

  /**
   * Helpers
   */

  function clamp(n, min, max) {
    if (n < min) return min;
    if (n > max) return max;
    return n;
  }

  /**
   * (Internal) converts a percentage (`0..1`) to a bar translateX
   * percentage (`-100%..0%`).
   */

  function toBarPerc(n) {
    return (-1 + n) * 100;
  }


  /**
   * (Internal) returns the correct CSS for changing the bar's
   * position given an n percentage, and speed and ease from Settings
   */

  function barPositionCSS(n, speed, ease) {
    var barCSS;

    if (Settings.positionUsing === 'translate3d') {
      barCSS = { transform: 'translate3d('+toBarPerc(n)+'%,0,0)' };
    } else if (Settings.positionUsing === 'translate') {
      barCSS = { transform: 'translate('+toBarPerc(n)+'%,0)' };
    } else {
      barCSS = { 'margin-left': toBarPerc(n)+'%' };
    }

    barCSS.transition = 'all '+speed+'ms '+ease;

    return barCSS;
  }

  /**
   * (Internal) Queues a function to be executed.
   */

  var queue = (function() {
    var pending = [];
    
    function next() {
      var fn = pending.shift();
      if (fn) {
        fn(next);
      }
    }

    return function(fn) {
      pending.push(fn);
      if (pending.length == 1) next();
    };
  })();

  /**
   * (Internal) Applies css properties to an element, similar to the jQuery 
   * css method.
   *
   * While this helper does assist with vendor prefixed property names, it 
   * does not perform any manipulation of values prior to setting styles.
   */

  var css = (function() {
    var cssPrefixes = [ 'Webkit', 'O', 'Moz', 'ms' ],
        cssProps    = {};

    function camelCase(string) {
      return string.replace(/^-ms-/, 'ms-').replace(/-([\da-z])/gi, function(match, letter) {
        return letter.toUpperCase();
      });
    }

    function getVendorProp(name) {
      var style = document.body.style;
      if (name in style) return name;

      var i = cssPrefixes.length,
          capName = name.charAt(0).toUpperCase() + name.slice(1),
          vendorName;
      while (i--) {
        vendorName = cssPrefixes[i] + capName;
        if (vendorName in style) return vendorName;
      }

      return name;
    }

    function getStyleProp(name) {
      name = camelCase(name);
      return cssProps[name] || (cssProps[name] = getVendorProp(name));
    }

    function applyCss(element, prop, value) {
      prop = getStyleProp(prop);
      element.style[prop] = value;
    }

    return function(element, properties) {
      var args = arguments,
          prop, 
          value;

      if (args.length == 2) {
        for (prop in properties) {
          value = properties[prop];
          if (value !== undefined && properties.hasOwnProperty(prop)) applyCss(element, prop, value);
        }
      } else {
        applyCss(element, args[1], args[2]);
      }
    }
  })();

  /**
   * (Internal) Determines if an element or space separated list of class names contains a class name.
   */

  function hasClass(element, name) {
    var list = typeof element == 'string' ? element : classList(element);
    return list.indexOf(' ' + name + ' ') >= 0;
  }

  /**
   * (Internal) Adds a class to an element.
   */

  function addClass(element, name) {
    var oldList = classList(element),
        newList = oldList + name;

    if (hasClass(oldList, name)) return; 

    // Trim the opening space.
    element.className = newList.substring(1);
  }

  /**
   * (Internal) Removes a class from an element.
   */

  function removeClass(element, name) {
    var oldList = classList(element),
        newList;

    if (!hasClass(element, name)) return;

    // Replace the class name.
    newList = oldList.replace(' ' + name + ' ', ' ');

    // Trim the opening and closing spaces.
    element.className = newList.substring(1, newList.length - 1);
  }

  /**
   * (Internal) Gets a space separated list of the class names on the element. 
   * The list is wrapped with a single space on each end to facilitate finding 
   * matches within the list.
   */

  function classList(element) {
    return (' ' + (element.className || '') + ' ').replace(/\s+/gi, ' ');
  }

  /**
   * (Internal) Removes an element from the DOM.
   */

  function removeElement(element) {
    element && element.parentNode && element.parentNode.removeChild(element);
  }

  return NProgress;
});



/***/ }),

/***/ 7697:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "dP": function() { return /* binding */ dep; },
  "re": function() { return /* binding */ wrap; }
});

// UNUSED EXPORTS: KeyTrie, asyncFromGen, bindContext, defaultMakeCacheKey, noContext, setTimeout

// EXTERNAL MODULE: ./node_modules/@wry/trie/lib/trie.esm.js
var trie_esm = __webpack_require__(657);
;// CONCATENATED MODULE: ./node_modules/@wry/context/lib/context.esm.js
// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
var currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
var MISSING_VALUE = {};
var idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
var makeSlotClass = function () { return /** @class */ (function () {
    function Slot() {
        // If you have a Slot object, you can find out its slot.id, but you cannot
        // guess the slot.id of a Slot you don't have access to, thanks to the
        // randomized suffix.
        this.id = [
            "slot",
            idCounter++,
            Date.now(),
            Math.random().toString(36).slice(2),
        ].join(":");
    }
    Slot.prototype.hasValue = function () {
        for (var context_1 = currentContext; context_1; context_1 = context_1.parent) {
            // We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context_1.slots) {
                var value = context_1.slots[this.id];
                if (value === MISSING_VALUE)
                    break;
                if (context_1 !== currentContext) {
                    // Cache the value in currentContext.slots so the next lookup will
                    // be faster. This caching is safe because the tree of contexts and
                    // the values of the slots are logically immutable.
                    currentContext.slots[this.id] = value;
                }
                return true;
            }
        }
        if (currentContext) {
            // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            currentContext.slots[this.id] = MISSING_VALUE;
        }
        return false;
    };
    Slot.prototype.getValue = function () {
        if (this.hasValue()) {
            return currentContext.slots[this.id];
        }
    };
    Slot.prototype.withValue = function (value, callback, 
    // Given the prevalence of arrow functions, specifying arguments is likely
    // to be much more common than specifying `this`, hence this ordering:
    args, thisArg) {
        var _a;
        var slots = (_a = {
                __proto__: null
            },
            _a[this.id] = value,
            _a);
        var parent = currentContext;
        currentContext = { parent: parent, slots: slots };
        try {
            // Function.prototype.apply allows the arguments array argument to be
            // omitted or undefined, so args! is fine here.
            return callback.apply(thisArg, args);
        }
        finally {
            currentContext = parent;
        }
    };
    // Capture the current context and wrap a callback function so that it
    // reestablishes the captured context when called.
    Slot.bind = function (callback) {
        var context = currentContext;
        return function () {
            var saved = currentContext;
            try {
                currentContext = context;
                return callback.apply(this, arguments);
            }
            finally {
                currentContext = saved;
            }
        };
    };
    // Immediately run a callback function without any captured context.
    Slot.noContext = function (callback, 
    // Given the prevalence of arrow functions, specifying arguments is likely
    // to be much more common than specifying `this`, hence this ordering:
    args, thisArg) {
        if (currentContext) {
            var saved = currentContext;
            try {
                currentContext = null;
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            }
            finally {
                currentContext = saved;
            }
        }
        else {
            return callback.apply(thisArg, args);
        }
    };
    return Slot;
}()); };
// We store a single global implementation of the Slot class as a permanent
// non-enumerable symbol property of the Array constructor. This obfuscation
// does nothing to prevent access to the Slot class, but at least it ensures
// the implementation (i.e. currentContext) cannot be tampered with, and all
// copies of the @wry/context package (hopefully just one) will share the
// same Slot implementation. Since the first copy of the @wry/context package
// to be imported wins, this technique imposes a very high cost for any
// future breaking changes to the Slot class.
var globalKey = "@wry/context:Slot";
var host = Array;
var Slot = host[globalKey] || function () {
    var Slot = makeSlotClass();
    try {
        Object.defineProperty(host, globalKey, {
            value: host[globalKey] = Slot,
            enumerable: false,
            writable: false,
            configurable: false,
        });
    }
    finally {
        return Slot;
    }
}();

var bind = Slot.bind, noContext = Slot.noContext;
function setTimeoutWithContext(callback, delay) {
    return setTimeout(bind(callback), delay);
}
// Turn any generator function into an async function (using yield instead
// of await), with context automatically preserved across yields.
function asyncFromGen(genFn) {
    return function () {
        var gen = genFn.apply(this, arguments);
        var boundNext = bind(gen.next);
        var boundThrow = bind(gen.throw);
        return new Promise(function (resolve, reject) {
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                }
                catch (error) {
                    return reject(error);
                }
                var next = result.done ? resolve : invokeNext;
                if (isPromiseLike(result.value)) {
                    result.value.then(next, result.done ? reject : invokeThrow);
                }
                else {
                    next(result.value);
                }
            }
            var invokeNext = function (value) { return invoke(boundNext, value); };
            var invokeThrow = function (error) { return invoke(boundThrow, error); };
            invokeNext();
        });
    };
}
function isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
var wrappedFibers = (/* unused pure expression or super */ null && ([]));
function wrapYieldingFiberMethods(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if (wrappedFibers.indexOf(Fiber) < 0) {
        var wrap = function (obj, method) {
            var fn = obj[method];
            obj[method] = function () {
                return noContext(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        wrappedFibers.push(Fiber);
    }
    return Fiber;
}


//# sourceMappingURL=context.esm.js.map

;// CONCATENATED MODULE: ./node_modules/optimism/lib/bundle.esm.js





function defaultDispose() { }
var Cache = /** @class */ (function () {
    function Cache(max, dispose) {
        if (max === void 0) { max = Infinity; }
        if (dispose === void 0) { dispose = defaultDispose; }
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    Cache.prototype.has = function (key) {
        return this.map.has(key);
    };
    Cache.prototype.get = function (key) {
        var node = this.getNode(key);
        return node && node.value;
    };
    Cache.prototype.getNode = function (key) {
        var node = this.map.get(key);
        if (node && node !== this.newest) {
            var older = node.older, newer = node.newer;
            if (newer) {
                newer.older = older;
            }
            if (older) {
                older.newer = newer;
            }
            node.older = this.newest;
            node.older.newer = node;
            node.newer = null;
            this.newest = node;
            if (node === this.oldest) {
                this.oldest = newer;
            }
        }
        return node;
    };
    Cache.prototype.set = function (key, value) {
        var node = this.getNode(key);
        if (node) {
            return node.value = value;
        }
        node = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) {
            this.newest.newer = node;
        }
        this.newest = node;
        this.oldest = this.oldest || node;
        this.map.set(key, node);
        return node.value;
    };
    Cache.prototype.clean = function () {
        while (this.oldest && this.map.size > this.max) {
            this.delete(this.oldest.key);
        }
    };
    Cache.prototype.delete = function (key) {
        var node = this.map.get(key);
        if (node) {
            if (node === this.newest) {
                this.newest = node.older;
            }
            if (node === this.oldest) {
                this.oldest = node.newer;
            }
            if (node.newer) {
                node.newer.older = node.older;
            }
            if (node.older) {
                node.older.newer = node.newer;
            }
            this.map.delete(key);
            this.dispose(node.value, key);
            return true;
        }
        return false;
    };
    return Cache;
}());

var parentEntrySlot = new Slot();

var _a;
var bundle_esm_hasOwnProperty = Object.prototype.hasOwnProperty;
var 
// This Array.from polyfill is restricted to working with Set<any> for now,
// but we can improve the polyfill and add other input types, as needed. Note
// that this fallback implementation will only be used if the host environment
// does not support a native Array.from function. In most modern JS runtimes,
// the toArray function exported here will be === Array.from.
toArray = (_a = Array.from, _a === void 0 ? function (collection) {
    var array = [];
    collection.forEach(function (item) { return array.push(item); });
    return array;
} : _a);
function maybeUnsubscribe(entryOrDep) {
    var unsubscribe = entryOrDep.unsubscribe;
    if (typeof unsubscribe === "function") {
        entryOrDep.unsubscribe = void 0;
        unsubscribe();
    }
}

var emptySetPool = [];
var POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function assert(condition, optionalMessage) {
    if (!condition) {
        throw new Error(optionalMessage || "assertion failure");
    }
}
function valueIs(a, b) {
    var len = a.length;
    return (
    // Unknown values are not equal to each other.
    len > 0 &&
        // Both values must be ordinary (or both exceptional) to be equal.
        len === b.length &&
        // The underlying value or exception must be the same.
        a[len - 1] === b[len - 1]);
}
function valueGet(value) {
    switch (value.length) {
        case 0: throw new Error("unknown value");
        case 1: return value[0];
        case 2: throw value[1];
    }
}
function valueCopy(value) {
    return value.slice(0);
}
var Entry = /** @class */ (function () {
    function Entry(fn) {
        this.fn = fn;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        this.deps = null;
        ++Entry.count;
    }
    Entry.prototype.peek = function () {
        if (this.value.length === 1 && !mightBeDirty(this)) {
            rememberParent(this);
            return this.value[0];
        }
    };
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    Entry.prototype.recompute = function (args) {
        assert(!this.recomputing, "already recomputing");
        rememberParent(this);
        return mightBeDirty(this)
            ? reallyRecompute(this, args)
            : valueGet(this.value);
    };
    Entry.prototype.setDirty = function () {
        if (this.dirty)
            return;
        this.dirty = true;
        this.value.length = 0;
        reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        maybeUnsubscribe(this);
    };
    Entry.prototype.dispose = function () {
        var _this = this;
        this.setDirty();
        // Sever any dependency relationships with our own children, so those
        // children don't retain this parent Entry in their child.parents sets,
        // thereby preventing it from being fully garbage collected.
        forgetChildren(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        eachParent(this, function (parent, child) {
            parent.setDirty();
            forgetChild(parent, _this);
        });
    };
    Entry.prototype.forget = function () {
        // The code that creates Entry objects in index.ts will replace this method
        // with one that actually removes the Entry from the cache, which will also
        // trigger the entry.dispose method.
        this.dispose();
    };
    Entry.prototype.dependOn = function (dep) {
        dep.add(this);
        if (!this.deps) {
            this.deps = emptySetPool.pop() || new Set();
        }
        this.deps.add(dep);
    };
    Entry.prototype.forgetDeps = function () {
        var _this = this;
        if (this.deps) {
            toArray(this.deps).forEach(function (dep) { return dep.delete(_this); });
            this.deps.clear();
            emptySetPool.push(this.deps);
            this.deps = null;
        }
    };
    Entry.count = 0;
    return Entry;
}());
function rememberParent(child) {
    var parent = parentEntrySlot.getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) {
            parent.childValues.set(child, []);
        }
        if (mightBeDirty(child)) {
            reportDirtyChild(parent, child);
        }
        else {
            reportCleanChild(parent, child);
        }
        return parent;
    }
}
function reallyRecompute(entry, args) {
    forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    parentEntrySlot.withValue(entry, recomputeNewValue, [entry, args]);
    if (maybeSubscribe(entry, args)) {
        // If we successfully recomputed entry.value and did not fail to
        // (re)subscribe, then this Entry is no longer explicitly dirty.
        setClean(entry);
    }
    return valueGet(entry.value);
}
function recomputeNewValue(entry, args) {
    entry.recomputing = true;
    // Set entry.value as unknown.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, args);
    }
    catch (e) {
        // If entry.fn throws, entry.value will become exceptional.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function setClean(entry) {
    entry.dirty = false;
    if (mightBeDirty(entry)) {
        // This Entry may still have dirty children, in which case we can't
        // let our parents know we're clean just yet.
        return;
    }
    reportClean(entry);
}
function reportDirty(child) {
    eachParent(child, reportDirtyChild);
}
function reportClean(child) {
    eachParent(child, reportCleanChild);
}
function eachParent(child, callback) {
    var parentCount = child.parents.size;
    if (parentCount) {
        var parents = toArray(child.parents);
        for (var i = 0; i < parentCount; ++i) {
            callback(parents[i], child);
        }
    }
}
// Let a parent Entry know that one of its children may be dirty.
function reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    assert(parent.childValues.has(child));
    assert(mightBeDirty(child));
    var parentWasClean = !mightBeDirty(parent);
    if (!parent.dirtyChildren) {
        parent.dirtyChildren = emptySetPool.pop() || new Set;
    }
    else if (parent.dirtyChildren.has(child)) {
        // If we already know this child is dirty, then we must have already
        // informed our own parents that we are dirty, so we can terminate
        // the recursion early.
        return;
    }
    parent.dirtyChildren.add(child);
    // If parent was clean before, it just became (possibly) dirty (according to
    // mightBeDirty), since we just added child to parent.dirtyChildren.
    if (parentWasClean) {
        reportDirty(parent);
    }
}
// Let a parent Entry know that one of its children is no longer dirty.
function reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    assert(parent.childValues.has(child));
    assert(!mightBeDirty(child));
    var childValue = parent.childValues.get(child);
    if (childValue.length === 0) {
        parent.childValues.set(child, valueCopy(child.value));
    }
    else if (!valueIs(childValue, child.value)) {
        parent.setDirty();
    }
    removeDirtyChild(parent, child);
    if (mightBeDirty(parent)) {
        return;
    }
    reportClean(parent);
}
function removeDirtyChild(parent, child) {
    var dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if (emptySetPool.length < POOL_TARGET_SIZE) {
                emptySetPool.push(dc);
            }
            parent.dirtyChildren = null;
        }
    }
}
// Removes all children from this entry and returns an array of the
// removed children.
function forgetChildren(parent) {
    if (parent.childValues.size > 0) {
        parent.childValues.forEach(function (_value, child) {
            forgetChild(parent, child);
        });
    }
    // Remove this parent Entry from any sets to which it was added by the
    // addToSet method.
    parent.forgetDeps();
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    assert(parent.dirtyChildren === null);
}
function forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    removeDirtyChild(parent, child);
}
function maybeSubscribe(entry, args) {
    if (typeof entry.subscribe === "function") {
        try {
            maybeUnsubscribe(entry); // Prevent double subscriptions.
            entry.unsubscribe = entry.subscribe.apply(null, args);
        }
        catch (e) {
            // If this Entry has a subscribe function and it threw an exception
            // (or an unsubscribe function it previously returned now throws),
            // return false to indicate that we were not able to subscribe (or
            // unsubscribe), and this Entry should remain dirty.
            entry.setDirty();
            return false;
        }
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}

var EntryMethods = {
    setDirty: true,
    dispose: true,
    forget: true,
};
function dep(options) {
    var depsByKey = new Map();
    var subscribe = options && options.subscribe;
    function depend(key) {
        var parent = parentEntrySlot.getValue();
        if (parent) {
            var dep_1 = depsByKey.get(key);
            if (!dep_1) {
                depsByKey.set(key, dep_1 = new Set);
            }
            parent.dependOn(dep_1);
            if (typeof subscribe === "function") {
                maybeUnsubscribe(dep_1);
                dep_1.unsubscribe = subscribe(key);
            }
        }
    }
    depend.dirty = function dirty(key, entryMethodName) {
        var dep = depsByKey.get(key);
        if (dep) {
            var m_1 = (entryMethodName &&
                bundle_esm_hasOwnProperty.call(EntryMethods, entryMethodName)) ? entryMethodName : "setDirty";
            // We have to use toArray(dep).forEach instead of dep.forEach, because
            // modifying a Set while iterating over it can cause elements in the Set
            // to be removed from the Set before they've been iterated over.
            toArray(dep).forEach(function (entry) { return entry[m_1](); });
            depsByKey.delete(key);
            maybeUnsubscribe(dep);
        }
    };
    return depend;
}

function makeDefaultMakeCacheKeyFunction() {
    var keyTrie = new trie_esm/* Trie */.B(typeof WeakMap === "function");
    return function () {
        return keyTrie.lookupArray(arguments);
    };
}
// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
var defaultMakeCacheKey = makeDefaultMakeCacheKeyFunction();
var caches = new Set();
function wrap(originalFunction, options) {
    if (options === void 0) { options = Object.create(null); }
    var cache = new Cache(options.max || Math.pow(2, 16), function (entry) { return entry.dispose(); });
    var keyArgs = options.keyArgs;
    var makeCacheKey = options.makeCacheKey ||
        makeDefaultMakeCacheKeyFunction();
    var optimistic = function () {
        var key = makeCacheKey.apply(null, keyArgs ? keyArgs.apply(null, arguments) : arguments);
        if (key === void 0) {
            return originalFunction.apply(null, arguments);
        }
        var entry = cache.get(key);
        if (!entry) {
            cache.set(key, entry = new Entry(originalFunction));
            entry.subscribe = options.subscribe;
            // Give the Entry the ability to trigger cache.delete(key), even though
            // the Entry itself does not know about key or cache.
            entry.forget = function () { return cache.delete(key); };
        }
        var value = entry.recompute(Array.prototype.slice.call(arguments));
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!parentEntrySlot.hasValue()) {
            caches.forEach(function (cache) { return cache.clean(); });
            caches.clear();
        }
        return value;
    };
    Object.defineProperty(optimistic, "size", {
        get: function () {
            return cache["map"].size;
        },
        configurable: false,
        enumerable: false,
    });
    function dirtyKey(key) {
        var entry = cache.get(key);
        if (entry) {
            entry.setDirty();
        }
    }
    optimistic.dirtyKey = dirtyKey;
    optimistic.dirty = function dirty() {
        dirtyKey(makeCacheKey.apply(null, arguments));
    };
    function peekKey(key) {
        var entry = cache.get(key);
        if (entry) {
            return entry.peek();
        }
    }
    optimistic.peekKey = peekKey;
    optimistic.peek = function peek() {
        return peekKey(makeCacheKey.apply(null, arguments));
    };
    function forgetKey(key) {
        return cache.delete(key);
    }
    optimistic.forgetKey = forgetKey;
    optimistic.forget = function forget() {
        return forgetKey(makeCacheKey.apply(null, arguments));
    };
    optimistic.makeCacheKey = makeCacheKey;
    optimistic.getKey = keyArgs ? function getKey() {
        return makeCacheKey.apply(null, keyArgs.apply(null, arguments));
    } : makeCacheKey;
    return Object.freeze(optimistic);
}


//# sourceMappingURL=bundle.esm.js.map


/***/ }),

/***/ 34155:
/***/ (function(module) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ 92703:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(50414);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 45697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(92703)();
}


/***/ }),

/***/ 50414:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 17563:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(70610);
var objectAssign = __webpack_require__(96086);
var decodeComponent = __webpack_require__(44020);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

function extract(str) {
	var queryStart = str.indexOf('?');
	if (queryStart === -1) {
		return '';
	}
	return str.slice(queryStart + 1);
}

function parse(str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^[?#&]/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeComponent(val);

		formatter(decodeComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
}

exports.extract = extract;
exports.parse = parse;

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	if (opts.sort === false) {
		opts.sort = function () {};
	}

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort(opts.sort).map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};

exports.parseUrl = function (str, opts) {
	return {
		url: str.split('?')[0] || '',
		query: parse(extract(str), opts)
	};
};


/***/ }),

/***/ 68181:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(67294));

var _useScript = _interopRequireDefault(__webpack_require__(25847));

var _appleAuthHelpers = _interopRequireDefault(__webpack_require__(93059));

var _excluded = ["onSuccess", "onError", "skipScript", "authOptions", "iconProps", "render", "uiType", "className", "noDefaultStyle", "buttonExtraChildren"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/** css styles */
var _style = "\n.react-apple-signin-auth-btn {\n  background-color: transparent;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  border-radius: 4px;\n  padding: 0 8px 0 2px;\n  font-size: 14px;\n  font-size: 1em;\n  line-height: 1;\n  border: 1px solid #000;\n  overflow: hidden;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n}\n.react-apple-signin-auth-btn-light {\n  background-color: #FFF;\n  color: #000;\n  border-color: #000;\n}\n.react-apple-signin-auth-btn-dark {\n  background-color: #000;\n  color: #FFF;\n  border-color: #FFF;\n}".replace(/ {2}|\n/g, '');

var AppleSigninButton = function AppleSigninButton(_ref) {
  var onSuccess = _ref.onSuccess,
      onError = _ref.onError,
      _ref$skipScript = _ref.skipScript,
      skipScript = _ref$skipScript === void 0 ? false : _ref$skipScript,
      authOptions = _ref.authOptions,
      iconProps = _ref.iconProps,
      render = _ref.render,
      _ref$uiType = _ref.uiType,
      uiType = _ref$uiType === void 0 ? 'dark' : _ref$uiType,
      className = _ref.className,
      _ref$noDefaultStyle = _ref.noDefaultStyle,
      noDefaultStyle = _ref$noDefaultStyle === void 0 ? false : _ref$noDefaultStyle,
      _ref$buttonExtraChild = _ref.buttonExtraChildren,
      buttonExtraChildren = _ref$buttonExtraChild === void 0 ? 'Continue with Apple' : _ref$buttonExtraChild,
      rest = _objectWithoutProperties(_ref, _excluded);

  /** load script if neccessary */
  (0, _useScript.default)(skipScript ? null : _appleAuthHelpers.default.APPLE_SCRIPT_SRC);
  /** Button click handler */

  var handleClick = function handleClick(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    _appleAuthHelpers.default.signIn({
      authOptions: authOptions,
      onSuccess: onSuccess,
      onError: onError
    });
  };
  /** common props */


  var props = _objectSpread({
    children: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("svg", _extends({
      width: "24px",
      height: "44px",
      viewBox: "0 0 24 44"
    }, iconProps), /*#__PURE__*/_react.default.createElement("g", {
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd"
    }, /*#__PURE__*/_react.default.createElement("rect", {
      fill: uiType === 'light' ? '#FFF' : '#000',
      x: "0",
      y: "0",
      width: "24",
      height: "44"
    }), /*#__PURE__*/_react.default.createElement("path", {
      d: "M12.2337427,16.9879688 C12.8896607,16.9879688 13.7118677,16.5445313 14.2014966,15.9532812 C14.6449341,15.4174609 14.968274,14.6691602 14.968274,13.9208594 C14.968274,13.8192383 14.9590357,13.7176172 14.9405591,13.6344727 C14.2107349,13.6621875 13.3330982,14.1241016 12.8065162,14.7430664 C12.3907935,15.2142188 12.012024,15.9532812 12.012024,16.7108203 C12.012024,16.8216797 12.0305005,16.9325391 12.0397388,16.9694922 C12.0859302,16.9787305 12.1598365,16.9879688 12.2337427,16.9879688 Z M9.92417241,28.1662891 C10.8202857,28.1662891 11.2175318,27.5658008 12.3353638,27.5658008 C13.4716724,27.5658008 13.721106,28.1478125 14.7188404,28.1478125 C15.6980982,28.1478125 16.3540162,27.2424609 16.972981,26.3555859 C17.6658521,25.339375 17.9522388,24.3416406 17.9707154,24.2954492 C17.9060474,24.2769727 16.0306763,23.5101953 16.0306763,21.3576758 C16.0306763,19.491543 17.5088013,18.6508594 17.5919459,18.5861914 C16.612688,17.1819727 15.1253248,17.1450195 14.7188404,17.1450195 C13.6194849,17.1450195 12.7233716,17.8101758 12.1598365,17.8101758 C11.5501099,17.8101758 10.7463794,17.1819727 9.79483648,17.1819727 C7.98413335,17.1819727 6.14571538,18.6785742 6.14571538,21.5054883 C6.14571538,23.2607617 6.8293482,25.1176563 7.67003179,26.3186328 C8.39061773,27.3348438 9.01882085,28.1662891 9.92417241,28.1662891 Z",
      fill: uiType === 'light' ? '#000' : '#FFF',
      fillRule: "nonzero"
    }))), buttonExtraChildren),
    onClick: handleClick
  }, rest);
  /** use render function if passed */


  if (render) {
    return render(props);
  }
  /** render button */


  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("button", _extends({
    className: "".concat(noDefaultStyle ? '' : "react-apple-signin-auth-btn react-apple-signin-auth-btn-".concat(uiType)).concat(className ? " ".concat(className) : ''),
    type: "button",
    "aria-label": "Signin with apple ID"
  }, props)), noDefaultStyle ? null : /*#__PURE__*/_react.default.createElement("style", null, _style));
};

var _default = AppleSigninButton;
exports["default"] = _default;

/***/ }),

/***/ 93059:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _waitForVar = _interopRequireDefault(__webpack_require__(77062));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var APPLE_SCRIPT_SRC = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';
/**
 * Performs an apple ID signIn operation
 */

var signIn = function signIn(_ref) {
  var authOptions = _ref.authOptions,
      onSuccess = _ref.onSuccess,
      onError = _ref.onError;
  return (
    /** wait for apple sript to load */
    (0, _waitForVar.default)('AppleID').then(function () {
      /** Handle if appleID script was not loaded -- log + throw error to be caught below */
      if (!window.AppleID) {
        console.error(new Error('Error loading apple script'));
      }
      /** Init apple auth */


      window.AppleID.auth.init(authOptions);
      /** Signin to appleID */

      return window.AppleID.auth.signIn().then(function (response) {
        /** This is only called in case usePopup is true */
        if (onSuccess) {
          onSuccess(response);
        }
        /** resolve with the reponse */


        return response;
      }).catch(function (err) {
        if (onError) {
          /** Call onError catching the error */
          onError(err);
        } else {
          /** Log the error to help debug */
          console.error(err);
        }

        return null;
      });
    }).catch(function (err) {
      if (onError) {
        /** Call onError catching the error */
        onError(err);
      } else {
        /** Log the error to help debug */
        console.error(err);
      }

      return null;
    })
  );
};

var _default = {
  APPLE_SCRIPT_SRC: APPLE_SCRIPT_SRC,
  signIn: signIn
};
exports["default"] = _default;

/***/ }),

/***/ 25847:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = __webpack_require__(67294);

/**
 * useScript hook
 *
 * https://usehooks.com/useScript
 */
function useScript(src) {
  (0, _react.useEffect)(function () {
    // Allow falsy src value if waiting on other data needed for
    // constructing the script URL passed to this hook.
    if (!src) {
      return;
    } // Fetch existing script element by src
    // It may have been added by another intance of this hook


    var script = document.querySelectorAll("script[src=\"".concat(src, "\"]"))[0];

    if (!script) {
      // Create script
      script = document.createElement('script');
      script.src = src;
      script.async = true; // Add script to document body

      document.body.appendChild(script);
    }
  }, [src] // Only re-run effect if script src changes
  );
}

var _default = useScript;
exports["default"] = _default;

/***/ }),

/***/ 96701:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _appleAuthHelpers.default;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _useScript.default;
  }
});
exports.ZP = void 0;

var _AppleSigninButton = _interopRequireDefault(__webpack_require__(68181));

var _appleAuthHelpers = _interopRequireDefault(__webpack_require__(93059));

var _useScript = _interopRequireDefault(__webpack_require__(25847));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _AppleSigninButton.default;
exports.ZP = _default;

/***/ }),

/***/ 77062:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

/**
 * Async wait for a variable till it gets defined in a parent
 *
 * • Usage Example: Waiting for async window.FB var to be initialized
 * - eg: `waitForVar('FB').then(FB => FB.test())`
 * - eg: `waitForVar('FB', { pollFrequency: 500, retries: 2, parent: window || global }).then(FB => FB.test())`
 * - eg: `waitForVar('FB', { retries: ({ retries } => retries * 500) }).then(FB => FB.test())`
 */
var waitForVar = function waitForVar(name) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    pollFrequency: 1000,
    retries: 100,
    parent: window
  },
      _ref$pollFrequency = _ref.pollFrequency,
      pollFrequency = _ref$pollFrequency === void 0 ? 1000 : _ref$pollFrequency,
      _ref$retries = _ref.retries,
      inRetries = _ref$retries === void 0 ? 100 : _ref$retries,
      _ref$parent = _ref.parent,
      parent = _ref$parent === void 0 ? window : _ref$parent;

  // eslint-disable-next-line no-prototype-builtins
  if (parent && parent.hasOwnProperty(name)) {
    return Promise.resolve(parent[name]);
  }

  if (!inRetries) {
    return Promise.resolve(undefined);
  }

  var retries = inRetries - 1;
  return new Promise(function (resolve) {
    return setTimeout(resolve, typeof pollFrequency === 'function' ? pollFrequency({
      retries: retries
    }) : pollFrequency);
  }).then(function () {
    return waitForVar(name, {
      pollFrequency: pollFrequency,
      parent: parent,
      retries: retries
    });
  });
};

var _default = waitForVar;
exports["default"] = _default;

/***/ }),

/***/ 51767:
/***/ (function(module) {

!function(e,t){ true?module.exports=t():0}(this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.i=function(e){return e},t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=1)}([function(e,t,n){"use strict";function r(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}Object.defineProperty(t,"__esModule",{value:!0});var o=!1,i=!1,a=function(){return o||console.warn("Pixel not initialized before using call ReactPixel.init with required params"),o},c=function(){for(var e,t=arguments.length,n=Array(t),o=0;o<t;o++)n[o]=arguments[o];(e=console).info.apply(e,r(["[react-facebook-pixel]"].concat(n)))},f={autoConfig:!0,debug:!1};t.default={init:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:f;!function(e,t,n,r,o,i,a){e.fbq||(o=e.fbq=function(){o.callMethod?o.callMethod.apply(o,arguments):o.queue.push(arguments)},e._fbq||(e._fbq=o),o.push=o,o.loaded=!0,o.version="2.0",o.queue=[],i=t.createElement(n),i.async=!0,i.src=r,a=t.getElementsByTagName(n)[0],a.parentNode.insertBefore(i,a))}(window,document,"script","https://connect.facebook.net/en_US/fbevents.js"),e?(!1===n.autoConfig&&fbq("set","autoConfig",!1,e),fbq("init",e,t),o=!0,i=n.debug):console.warn("Please insert pixel id for initializing")},pageView:function(){a()&&(fbq("track","PageView"),i&&c("called fbq('track', 'PageView');"))},track:function(e,t){a()&&(fbq("track",e,t),i&&(c("called fbq('track', '"+e+"');"),t&&c("with data",t)))},trackCustom:function(e,t){a()&&(fbq("trackCustom",e,t),i&&(c("called fbq('trackCustom', '"+e+"');"),t&&c("with data",t)))},fbq:function(e){function t(){return e.apply(this,arguments)}return t.toString=function(){return e.toString()},t}(function(){if(a()){for(var e=arguments.length,t=Array(e),n=0;n<e;n++)t[n]=arguments[n];fbq.apply(void 0,t),i&&(c("called fbq('"+t.slice(0,2).join("', '")+"')"),t[2]&&c("with data",t[2]))}})}},function(e,t,n){e.exports=n(0)}])});
//# sourceMappingURL=fb-pixel.js.map

/***/ }),

/***/ 93645:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(67294)):0}("undefined"!=typeof self?self:this,(function(e){return o={},t.m=n=[function(t){t.exports=e},function(e,t,n){e.exports=n(2)()},function(e,t,n){"use strict";function o(){}function r(){}var i=n(3);r.resetWarningCache=o,e.exports=function(){function e(e,t,n,o,r,a){if(a!==i){var c=Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw c.name="Invariant Violation",c}}function t(){return e}var n={array:e.isRequired=e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,elementType:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t,checkPropTypes:r,resetWarningCache:o};return n.PropTypes=n}},function(e){"use strict";e.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"},function(e,t,n){"use strict";function o(e,t){return function(e){if(Array.isArray(e))return e}(e)||function(e,t){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(e)){var n=[],o=!0,r=!1,i=void 0;try{for(var a,c=e[Symbol.iterator]();!(o=(a=c.next()).done)&&(n.push(a.value),!t||n.length!==t);o=!0);}catch(e){r=!0,i=e}finally{try{o||null==c.return||c.return()}finally{if(r)throw i}}return n}}(e,t)||function(e,t){if(e){if("string"==typeof e)return r(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(n):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?r(e,t):void 0}}(e,t)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function r(e,t){null!=t&&t<=e.length||(t=e.length);for(var n=0,o=Array(t);n<t;n++)o[n]=e[n];return o}function i(e,t){return function(e){if(Array.isArray(e))return e}(e)||function(e,t){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(e)){var n=[],o=!0,r=!1,i=void 0;try{for(var a,c=e[Symbol.iterator]();!(o=(a=c.next()).done)&&(n.push(a.value),!t||n.length!==t);o=!0);}catch(e){r=!0,i=e}finally{try{o||null==c.return||c.return()}finally{if(r)throw i}}return n}}(e,t)||function(e,t){if(e){if("string"==typeof e)return a(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(n):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?a(e,t):void 0}}(e,t)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function a(e,t){null!=t&&t<=e.length||(t=e.length);for(var n=0,o=Array(t);n<t;n++)o[n]=e[n];return o}function c(e,t){return function(e){if(Array.isArray(e))return e}(e)||function(e,t){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(e)){var n=[],o=!0,r=!1,i=void 0;try{for(var a,c=e[Symbol.iterator]();!(o=(a=c.next()).done)&&(n.push(a.value),!t||n.length!==t);o=!0);}catch(e){r=!0,i=e}finally{try{o||null==c.return||c.return()}finally{if(r)throw i}}return n}}(e,t)||function(e,t){if(e){if("string"==typeof e)return u(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(n):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?u(e,t):void 0}}(e,t)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function u(e,t){null!=t&&t<=e.length||(t=e.length);for(var n=0,o=Array(t);n<t;n++)o[n]=e[n];return o}function l(e,t){return function(e){if(Array.isArray(e))return e}(e)||function(e,t){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(e)){var n=[],o=!0,r=!1,i=void 0;try{for(var a,c=e[Symbol.iterator]();!(o=(a=c.next()).done)&&(n.push(a.value),!t||n.length!==t);o=!0);}catch(e){r=!0,i=e}finally{try{o||null==c.return||c.return()}finally{if(r)throw i}}return n}}(e,t)||function(e,t){if(e){if("string"==typeof e)return s(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(n):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?s(e,t):void 0}}(e,t)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function s(e,t){null!=t&&t<=e.length||(t=e.length);for(var n=0,o=Array(t);n<t;n++)o[n]=e[n];return o}function f(e,t,n,o,r,i){var a=e.getElementsByTagName(t)[0],c=a,u=a;(u=e.createElement(t)).id=n,u.src=o,c&&c.parentNode?c.parentNode.insertBefore(u,c):e.head.appendChild(u),u.onerror=i,u.onload=r}function d(e,t){var n=e.getElementById(t);n&&n.parentNode.removeChild(n)}function p(e){return b.a.createElement("span",{style:{paddingRight:10,fontWeight:500,paddingLeft:e.icon?0:10,paddingTop:10,paddingBottom:10}},e.children)}function g(e){return b.a.createElement("div",{style:{marginRight:10,background:e.active?"#eee":"#fff",padding:10,borderRadius:2}},b.a.createElement("svg",{width:"18",height:"18",xmlns:"http://www.w3.org/2000/svg"},b.a.createElement("g",{fill:"#000",fillRule:"evenodd"},b.a.createElement("path",{d:"M9 3.48c1.69 0 2.83.73 3.48 1.34l2.54-2.48C13.46.89 11.43 0 9 0 5.48 0 2.44 2.02.96 4.96l2.91 2.26C4.6 5.05 6.62 3.48 9 3.48z",fill:"#EA4335"}),b.a.createElement("path",{d:"M17.64 9.2c0-.74-.06-1.28-.19-1.84H9v3.34h4.96c-.1.83-.64 2.08-1.84 2.92l2.84 2.2c1.7-1.57 2.68-3.88 2.68-6.62z",fill:"#4285F4"}),b.a.createElement("path",{d:"M3.88 10.78A5.54 5.54 0 0 1 3.58 9c0-.62.11-1.22.29-1.78L.96 4.96A9.008 9.008 0 0 0 0 9c0 1.45.35 2.82.96 4.04l2.92-2.26z",fill:"#FBBC05"}),b.a.createElement("path",{d:"M9 18c2.43 0 4.47-.8 5.96-2.18l-2.84-2.2c-.76.53-1.78.9-3.12.9-2.38 0-4.4-1.57-5.12-3.74L.97 13.04C2.45 15.98 5.48 18 9 18z",fill:"#34A853"}),b.a.createElement("path",{fill:"none",d:"M0 0h18v18H0z"}))))}function y(e){var t=i(Object(m.useState)(!1),2),n=t[0],o=t[1],r=i(Object(m.useState)(!1),2),a=r[0],c=r[1],u=e.tag,l=e.type,s=e.className,f=e.disabledStyle,d=e.buttonText,y=e.children,v=e.render,S=e.theme,j=e.icon,O=e.disabled,x=h({onSuccess:e.onSuccess,onAutoLoadFinished:e.onAutoLoadFinished,onRequest:e.onRequest,onFailure:e.onFailure,onScriptLoadFailure:e.onScriptLoadFailure,clientId:e.clientId,cookiePolicy:e.cookiePolicy,loginHint:e.loginHint,hostedDomain:e.hostedDomain,autoLoad:e.autoLoad,isSignedIn:e.isSignedIn,fetchBasicProfile:e.fetchBasicProfile,redirectUri:e.redirectUri,discoveryDocs:e.discoveryDocs,uxMode:e.uxMode,scope:e.scope,accessType:e.accessType,responseType:e.responseType,jsSrc:e.jsSrc,prompt:e.prompt}),I=x.signIn,w=O||!x.loaded;if(v)return v({onClick:I,disabled:w});var k={backgroundColor:"dark"===S?"rgb(66, 133, 244)":"#fff",display:"inline-flex",alignItems:"center",color:"dark"===S?"#fff":"rgba(0, 0, 0, .54)",boxShadow:"0 2px 2px 0 rgba(0, 0, 0, .24), 0 0 1px 0 rgba(0, 0, 0, .24)",padding:0,borderRadius:2,border:"1px solid transparent",fontSize:14,fontWeight:"500",fontFamily:"Roboto, sans-serif"},A={cursor:"pointer",backgroundColor:"dark"===S?"#3367D6":"#eee",color:"dark"===S?"#fff":"rgba(0, 0, 0, .54)",opacity:1},_=w?Object.assign({},k,f):a?Object.assign({},k,A):n?Object.assign({},k,{cursor:"pointer",opacity:.9}):k;return b.a.createElement(u,{onMouseEnter:function(){return o(!0)},onMouseLeave:function(){o(!1),c(!1)},onMouseDown:function(){return c(!0)},onMouseUp:function(){return c(!1)},onClick:I,style:_,type:l,disabled:w,className:s},[j&&b.a.createElement(g,{key:1,active:a}),b.a.createElement(p,{icon:j,key:2},y||d)])}n.r(t),n.d(t,"default",(function(){return S})),n.d(t,"GoogleLogin",(function(){return S})),n.d(t,"GoogleLogout",(function(){return O})),n.d(t,"useGoogleLogin",(function(){return h})),n.d(t,"useGoogleLogout",(function(){return j}));var m=n(0),b=n.n(m),h=(n(1),function(e){function t(e){var t=e.getBasicProfile(),n=e.getAuthResponse(!0);e.googleId=t.getId(),e.tokenObj=n,e.tokenId=n.id_token,e.accessToken=n.access_token,e.profileObj={googleId:t.getId(),imageUrl:t.getImageUrl(),email:t.getEmail(),name:t.getName(),givenName:t.getGivenName(),familyName:t.getFamilyName()},i(e)}function n(e){if(e&&e.preventDefault(),P){var n=window.gapi.auth2.getAuthInstance(),o={prompt:L};p(),"code"===_?n.grantOfflineAccess(o).then((function(e){return i(e)}),(function(e){return l(e)})):n.signIn(o).then((function(e){return t(e)}),(function(e){return l(e)}))}}var r=e.onSuccess,i=void 0===r?function(){}:r,a=e.onAutoLoadFinished,c=void 0===a?function(){}:a,u=e.onFailure,l=void 0===u?function(){}:u,s=e.onRequest,p=void 0===s?function(){}:s,g=e.onScriptLoadFailure,y=e.clientId,b=e.cookiePolicy,h=e.loginHint,v=e.hostedDomain,S=e.autoLoad,j=e.isSignedIn,O=e.fetchBasicProfile,x=e.redirectUri,I=e.discoveryDocs,w=e.uxMode,k=e.scope,A=e.accessType,_=e.responseType,E=e.jsSrc,T=void 0===E?"https://apis.google.com/js/api.js":E,L=e.prompt,M=o(Object(m.useState)(!1),2),P=M[0],C=M[1];return Object(m.useEffect)((function(){var e=!1,n=g||l;return f(document,"script","google-login",T,(function(){var o={client_id:y,cookie_policy:b,login_hint:h,hosted_domain:v,fetch_basic_profile:O,discoveryDocs:I,ux_mode:w,redirect_uri:x,scope:k,access_type:A};"code"===_&&(o.access_type="offline"),window.gapi.load("auth2",(function(){var r=window.gapi.auth2.getAuthInstance();r?r.then((function(){e||(j&&r.isSignedIn.get()?(C(!0),c(!0),t(r.currentUser.get())):(C(!0),c(!1)))}),(function(e){l(e)})):window.gapi.auth2.init(o).then((function(n){if(!e){C(!0);var o=j&&n.isSignedIn.get();c(o),o&&t(n.currentUser.get())}}),(function(e){C(!0),c(!1),n(e)}))}))}),(function(e){n(e)})),function(){e=!0,d(document,"google-login")}}),[]),Object(m.useEffect)((function(){S&&n()}),[P]),{signIn:n,loaded:P}});function v(e){var t=l(Object(m.useState)(!1),2),n=t[0],o=t[1],r=l(Object(m.useState)(!1),2),i=r[0],a=r[1],c=e.tag,u=e.type,s=e.className,f=e.disabledStyle,d=e.buttonText,y=e.children,h=e.render,v=e.theme,S=e.icon,O=e.disabled,x=j({jsSrc:e.jsSrc,onFailure:e.onFailure,onScriptLoadFailure:e.onScriptLoadFailure,clientId:e.clientId,cookiePolicy:e.cookiePolicy,loginHint:e.loginHint,hostedDomain:e.hostedDomain,fetchBasicProfile:e.fetchBasicProfile,discoveryDocs:e.discoveryDocs,uxMode:e.uxMode,redirectUri:e.redirectUri,scope:e.scope,accessType:e.accessType,onLogoutSuccess:e.onLogoutSuccess}),I=x.signOut,w=O||!x.loaded;if(h)return h({onClick:I,disabled:w});var k={backgroundColor:"dark"===v?"rgb(66, 133, 244)":"#fff",display:"inline-flex",alignItems:"center",color:"dark"===v?"#fff":"rgba(0, 0, 0, .54)",boxShadow:"0 2px 2px 0 rgba(0, 0, 0, .24), 0 0 1px 0 rgba(0, 0, 0, .24)",padding:0,borderRadius:2,border:"1px solid transparent",fontSize:14,fontWeight:"500",fontFamily:"Roboto, sans-serif"},A={cursor:"pointer",backgroundColor:"dark"===v?"#3367D6":"#eee",color:"dark"===v?"#fff":"rgba(0, 0, 0, .54)",opacity:1},_=w?Object.assign({},k,f):i?Object.assign({},k,A):n?Object.assign({},k,{cursor:"pointer",opacity:.9}):k;return b.a.createElement(c,{onMouseEnter:function(){return o(!0)},onMouseLeave:function(){o(!1),a(!1)},onMouseDown:function(){return a(!0)},onMouseUp:function(){return a(!1)},onClick:I,style:_,type:u,disabled:w,className:s},[S&&b.a.createElement(g,{key:1,active:i}),b.a.createElement(p,{icon:S,key:2},y||d)])}y.defaultProps={type:"button",tag:"button",buttonText:"Sign in with Google",scope:"profile email",accessType:"online",prompt:"",cookiePolicy:"single_host_origin",fetchBasicProfile:!0,isSignedIn:!1,uxMode:"popup",disabledStyle:{opacity:.6},icon:!0,theme:"light",onRequest:function(){}};var S=y,j=function(e){var t=e.jsSrc,n=void 0===t?"https://apis.google.com/js/api.js":t,o=e.onFailure,r=e.onScriptLoadFailure,i=e.clientId,a=e.cookiePolicy,u=e.loginHint,l=e.hostedDomain,s=e.fetchBasicProfile,p=e.discoveryDocs,g=e.uxMode,y=e.redirectUri,b=e.scope,h=e.accessType,v=e.onLogoutSuccess,S=c(Object(m.useState)(!1),2),j=S[0],O=S[1],x=Object(m.useCallback)((function(){if(window.gapi){var e=window.gapi.auth2.getAuthInstance();null!=e&&e.then((function(){e.signOut().then((function(){e.disconnect(),v()}))}),(function(e){return o(e)}))}}),[v]);return Object(m.useEffect)((function(){var e=r||o;return f(document,"script","google-login",n,(function(){var t={client_id:i,cookie_policy:a,login_hint:u,hosted_domain:l,fetch_basic_profile:s,discoveryDocs:p,ux_mode:g,redirect_uri:y,scope:b,access_type:h};window.gapi.load("auth2",(function(){window.gapi.auth2.getAuthInstance()?O(!0):window.gapi.auth2.init(t).then((function(){return O(!0)}),(function(t){return e(t)}))}))}),(function(t){e(t)})),function(){d(document,"google-login")}}),[]),{signOut:x,loaded:j}};v.defaultProps={type:"button",tag:"button",buttonText:"Logout of Google",disabledStyle:{opacity:.6},icon:!0,theme:"light",jsSrc:"https://apis.google.com/js/api.js"};var O=v}],t.c=o,t.d=function(e,n,o){t.o(e,n)||Object.defineProperty(e,n,{enumerable:!0,get:o})},t.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},t.t=function(e,n){if(1&n&&(e=t(e)),8&n)return e;if(4&n&&"object"==typeof e&&e&&e.__esModule)return e;var o=Object.create(null);if(t.r(o),Object.defineProperty(o,"default",{enumerable:!0,value:e}),2&n&&"string"!=typeof e)for(var r in e)t.d(o,r,function(t){return e[t]}.bind(null,r));return o},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=4);function t(e){if(o[e])return o[e].exports;var r=o[e]={i:e,l:!1,exports:{}};return n[e].call(r.exports,r,r.exports,t),r.l=!0,r.exports}var n,o}));

/***/ }),

/***/ 69921:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 59864:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(69921);
} else {}


/***/ }),

/***/ 98885:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ esm_Transition; }
});

// UNUSED EXPORTS: ENTERED, ENTERING, EXITED, EXITING, UNMOUNTED

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(94578);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/config.js
/* harmony default export */ var config = ({
  disabled: false
});
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/TransitionGroupContext.js
var TransitionGroupContext = __webpack_require__(220);
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/Transition.js








var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [react_dom.findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : react_dom.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : react_dom.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        _in = _this$props.in,
        _mountOnEnter = _this$props.mountOnEnter,
        _unmountOnExit = _this$props.unmountOnExit,
        _appear = _this$props.appear,
        _enter = _this$props.enter,
        _exit = _this$props.exit,
        _timeout = _this$props.timeout,
        _addEndListener = _this$props.addEndListener,
        _onEnter = _this$props.onEnter,
        _onEntering = _this$props.onEntering,
        _onEntered = _this$props.onEntered,
        _onExit = _this$props.onExit,
        _onExiting = _this$props.onExiting,
        _onExited = _this$props.onExited,
        _nodeRef = _this$props.nodeRef,
        childProps = (0,objectWithoutPropertiesLoose/* default */.Z)(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      react.createElement(TransitionGroupContext/* default.Provider */.Z.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : react.cloneElement(react.Children.only(children), childProps))
    );
  };

  return Transition;
}(react.Component);

Transition.contextType = TransitionGroupContext/* default */.Z;
Transition.propTypes =  false ? 0 : {}; // Name the function so it is clearer in the documentation

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
/* harmony default export */ var esm_Transition = (Transition);

/***/ }),

/***/ 73350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_TransitionGroup; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(97326);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(94578);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/TransitionGroupContext.js
var TransitionGroupContext = __webpack_require__(220);
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/utils/ChildMapping.js

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */

function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0,react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */

function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return (0,react.cloneElement)(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!(0,react.isValidElement)(child)) return;
    var hasPrev = (key in prevChildMapping);
    var hasNext = (key in nextChildMapping);
    var prevChild = prevChildMapping[key];
    var isLeaving = (0,react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = (0,react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = (0,react.cloneElement)(child, {
        in: false
      });
    } else if (hasNext && hasPrev && (0,react.isValidElement)(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = (0,react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/TransitionGroup.js









var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */

var TransitionGroup = /*#__PURE__*/function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind((0,assertThisInitialized/* default */.Z)(_this)); // Initial children should all be entering, dependent on appear


    _this.state = {
      contextValue: {
        isMounting: true
      },
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.setState({
      contextValue: {
        isMounting: false
      }
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? getInitialChildMapping(nextProps, handleExited) : getNextChildMapping(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  } // node is `undefined` when user provided `nodeRef` prop
  ;

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = getChildMapping(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = (0,esm_extends/* default */.Z)({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = (0,objectWithoutPropertiesLoose/* default */.Z)(_this$props, ["component", "childFactory"]);

    var contextValue = this.state.contextValue;
    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return /*#__PURE__*/react.createElement(TransitionGroupContext/* default.Provider */.Z.Provider, {
        value: contextValue
      }, children);
    }

    return /*#__PURE__*/react.createElement(TransitionGroupContext/* default.Provider */.Z.Provider, {
      value: contextValue
    }, /*#__PURE__*/react.createElement(Component, props, children));
  };

  return TransitionGroup;
}(react.Component);

TransitionGroup.propTypes =  false ? 0 : {};
TransitionGroup.defaultProps = defaultProps;
/* harmony default export */ var esm_TransitionGroup = (TransitionGroup);

/***/ }),

/***/ 220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/* harmony default export */ __webpack_exports__["Z"] = (react__WEBPACK_IMPORTED_MODULE_0__.createContext(null));

/***/ }),

/***/ 78561:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
exports.kC = exports.xu = void 0;

var _react = _interopRequireDefault(__webpack_require__(67294));

var _styledComponents = _interopRequireDefault(__webpack_require__(31157));

var _styledSystem = __webpack_require__(74786);

var _css = _interopRequireWildcard(__webpack_require__(37947));

var _shouldForwardProp = _interopRequireDefault(__webpack_require__(61979));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var sx = function sx(props) {
  return (0, _css["default"])(props.sx)(props.theme);
};

var base = function base(props) {
  return (0, _css["default"])(props.__css)(props.theme);
};

var variant = function variant(_ref) {
  var theme = _ref.theme,
      variant = _ref.variant,
      _ref$tx = _ref.tx,
      tx = _ref$tx === void 0 ? 'variants' : _ref$tx;
  return (0, _css["default"])((0, _css.get)(theme, tx + '.' + variant, (0, _css.get)(theme, variant)))(theme);
};

var Box = (0, _styledComponents["default"])('div', {
  shouldForwardProp: _shouldForwardProp["default"]
})({
  boxSizing: 'border-box',
  margin: 0,
  minWidth: 0
}, base, variant, sx, function (props) {
  return props.css;
}, (0, _styledSystem.compose)(_styledSystem.space, _styledSystem.layout, _styledSystem.typography, _styledSystem.color, _styledSystem.flexbox));
exports.xu = Box;
var Flex = (0, _styledComponents["default"])(Box)({
  display: 'flex'
});
exports.kC = Flex;

/***/ }),

/***/ 69328:
/***/ (function(module) {

"use strict";


var defaultParseOptions = {
  decodeValues: true,
  map: false,
  silent: false,
};

function isNonEmptyString(str) {
  return typeof str === "string" && !!str.trim();
}

function parseString(setCookieValue, options) {
  var parts = setCookieValue.split(";").filter(isNonEmptyString);
  var nameValue = parts.shift().split("=");
  var name = nameValue.shift();
  var value = nameValue.join("="); // everything after the first =, joined by a "=" if there was more than one part

  options = options
    ? Object.assign({}, defaultParseOptions, options)
    : defaultParseOptions;

  try {
    value = options.decodeValues ? decodeURIComponent(value) : value; // decode cookie value
  } catch (e) {
    console.error(
      "set-cookie-parser encountered an error while decoding a cookie with value '" +
        value +
        "'. Set options.decodeValues to false to disable this feature.",
      e
    );
  }

  var cookie = {
    name: name, // grab everything before the first =
    value: value,
  };

  parts.forEach(function (part) {
    var sides = part.split("=");
    var key = sides.shift().trimLeft().toLowerCase();
    var value = sides.join("=");
    if (key === "expires") {
      cookie.expires = new Date(value);
    } else if (key === "max-age") {
      cookie.maxAge = parseInt(value, 10);
    } else if (key === "secure") {
      cookie.secure = true;
    } else if (key === "httponly") {
      cookie.httpOnly = true;
    } else if (key === "samesite") {
      cookie.sameSite = value;
    } else {
      cookie[key] = value;
    }
  });

  return cookie;
}

function parse(input, options) {
  options = options
    ? Object.assign({}, defaultParseOptions, options)
    : defaultParseOptions;

  if (!input) {
    if (!options.map) {
      return [];
    } else {
      return {};
    }
  }

  if (input.headers && input.headers["set-cookie"]) {
    // fast-path for node.js (which automatically normalizes header names to lower-case
    input = input.headers["set-cookie"];
  } else if (input.headers) {
    // slow-path for other environments - see #25
    var sch =
      input.headers[
        Object.keys(input.headers).find(function (key) {
          return key.toLowerCase() === "set-cookie";
        })
      ];
    // warn if called on a request-like object with a cookie header rather than a set-cookie header - see #34, 36
    if (!sch && input.headers.cookie && !options.silent) {
      console.warn(
        "Warning: set-cookie-parser appears to have been called on a request object. It is designed to parse Set-Cookie headers from responses, not Cookie headers from requests. Set the option {silent: true} to suppress this warning."
      );
    }
    input = sch;
  }
  if (!Array.isArray(input)) {
    input = [input];
  }

  options = options
    ? Object.assign({}, defaultParseOptions, options)
    : defaultParseOptions;

  if (!options.map) {
    return input.filter(isNonEmptyString).map(function (str) {
      return parseString(str, options);
    });
  } else {
    var cookies = {};
    return input.filter(isNonEmptyString).reduce(function (cookies, str) {
      var cookie = parseString(str, options);
      cookies[cookie.name] = cookie;
      return cookies;
    }, cookies);
  }
}

/*
  Set-Cookie header field-values are sometimes comma joined in one string. This splits them without choking on commas
  that are within a single set-cookie field-value, such as in the Expires portion.

  This is uncommon, but explicitly allowed - see https://tools.ietf.org/html/rfc2616#section-4.2
  Node.js does this for every header *except* set-cookie - see https://github.com/nodejs/node/blob/d5e363b77ebaf1caf67cd7528224b651c86815c1/lib/_http_incoming.js#L128
  React Native's fetch does this for *every* header, including set-cookie.

  Based on: https://github.com/google/j2objc/commit/16820fdbc8f76ca0c33472810ce0cb03d20efe25
  Credits to: https://github.com/tomball for original and https://github.com/chrusart for JavaScript implementation
*/
function splitCookiesString(cookiesString) {
  if (Array.isArray(cookiesString)) {
    return cookiesString;
  }
  if (typeof cookiesString !== "string") {
    return [];
  }

  var cookiesStrings = [];
  var pos = 0;
  var start;
  var ch;
  var lastComma;
  var nextStart;
  var cookiesSeparatorFound;

  function skipWhitespace() {
    while (pos < cookiesString.length && /\s/.test(cookiesString.charAt(pos))) {
      pos += 1;
    }
    return pos < cookiesString.length;
  }

  function notSpecialChar() {
    ch = cookiesString.charAt(pos);

    return ch !== "=" && ch !== ";" && ch !== ",";
  }

  while (pos < cookiesString.length) {
    start = pos;
    cookiesSeparatorFound = false;

    while (skipWhitespace()) {
      ch = cookiesString.charAt(pos);
      if (ch === ",") {
        // ',' is a cookie separator if we have later first '=', not ';' or ','
        lastComma = pos;
        pos += 1;

        skipWhitespace();
        nextStart = pos;

        while (pos < cookiesString.length && notSpecialChar()) {
          pos += 1;
        }

        // currently special character
        if (pos < cookiesString.length && cookiesString.charAt(pos) === "=") {
          // we found cookies separator
          cookiesSeparatorFound = true;
          // pos is inside the next cookie, so back up and return it.
          pos = nextStart;
          cookiesStrings.push(cookiesString.substring(start, lastComma));
          start = pos;
        } else {
          // in param ',' or param separator ';',
          // we continue from that comma
          pos = lastComma + 1;
        }
      } else {
        pos += 1;
      }
    }

    if (!cookiesSeparatorFound || pos >= cookiesString.length) {
      cookiesStrings.push(cookiesString.substring(start, cookiesString.length));
    }
  }

  return cookiesStrings;
}

module.exports = parse;
module.exports.parse = parse;
module.exports.parseString = parseString;
module.exports.splitCookiesString = splitCookiesString;


/***/ }),

/***/ 70610:
/***/ (function(module) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),

/***/ 32553:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var Buffer = (__webpack_require__(40396).Buffer);
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}

/***/ }),

/***/ 40396:
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(48764)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),

/***/ 31157:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ServerStyleSheet": function() { return /* binding */ ServerStyleSheet; },
  "StyleSheetConsumer": function() { return /* binding */ StyleSheetConsumer; },
  "StyleSheetContext": function() { return /* binding */ StyleSheetContext; },
  "StyleSheetManager": function() { return /* binding */ StyleSheetManager; },
  "ThemeConsumer": function() { return /* binding */ ThemeConsumer; },
  "ThemeContext": function() { return /* binding */ ThemeContext; },
  "ThemeProvider": function() { return /* binding */ ThemeProvider; },
  "__DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS": function() { return /* binding */ __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS; },
  "createGlobalStyle": function() { return /* binding */ createGlobalStyle; },
  "css": function() { return /* binding */ css; },
  "default": function() { return /* binding */ styled_components_browser_esm; },
  "isStyledComponent": function() { return /* binding */ isStyledComponent; },
  "keyframes": function() { return /* binding */ keyframes; },
  "withTheme": function() { return /* binding */ withTheme; }
});

// EXTERNAL MODULE: ./node_modules/stylis/stylis.min.js
var stylis_min = __webpack_require__(21746);
var stylis_min_default = /*#__PURE__*/__webpack_require__.n(stylis_min);
// EXTERNAL MODULE: ./node_modules/stylis-rule-sheet/index.js
var stylis_rule_sheet = __webpack_require__(71427);
var stylis_rule_sheet_default = /*#__PURE__*/__webpack_require__.n(stylis_rule_sheet);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@emotion/unitless/dist/unitless.browser.esm.js
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ var unitless_browser_esm = (unitlessKeys);

// EXTERNAL MODULE: ./node_modules/react-is/index.js
var react_is = __webpack_require__(59864);
;// CONCATENATED MODULE: ./node_modules/memoize-one/dist/memoize-one.esm.js
var safeIsNaN = Number.isNaN ||
    function ponyfill(value) {
        return typeof value === 'number' && value !== value;
    };
function isEqual(first, second) {
    if (first === second) {
        return true;
    }
    if (safeIsNaN(first) && safeIsNaN(second)) {
        return true;
    }
    return false;
}
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) {
        return false;
    }
    for (var i = 0; i < newInputs.length; i++) {
        if (!isEqual(newInputs[i], lastInputs[i])) {
            return false;
        }
    }
    return true;
}

function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) { isEqual = areInputsEqual; }
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newArgs[_i] = arguments[_i];
        }
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
            return lastResult;
        }
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}

/* harmony default export */ var memoize_one_esm = (memoizeOne);

// EXTERNAL MODULE: ./node_modules/@emotion/is-prop-valid/dist/is-prop-valid.browser.esm.js + 1 modules
var is_prop_valid_browser_esm = __webpack_require__(24465);
;// CONCATENATED MODULE: ./node_modules/is-what/dist/index.esm.js
/**
 * Returns the object type of the given payload
 *
 * @param {*} payload
 * @returns {string}
 */
function getType(payload) {
    return Object.prototype.toString.call(payload).slice(8, -1);
}
/**
 * Returns whether the payload is undefined
 *
 * @param {*} payload
 * @returns {payload is undefined}
 */
function isUndefined(payload) {
    return getType(payload) === 'Undefined';
}
/**
 * Returns whether the payload is null
 *
 * @param {*} payload
 * @returns {payload is null}
 */
function isNull(payload) {
    return getType(payload) === 'Null';
}
/**
 * Returns whether the payload is a plain JavaScript object (excluding special classes or objects with other prototypes)
 *
 * @param {*} payload
 * @returns {payload is PlainObject}
 */
function isPlainObject(payload) {
    if (getType(payload) !== 'Object')
        return false;
    return payload.constructor === Object && Object.getPrototypeOf(payload) === Object.prototype;
}
/**
 * Returns whether the payload is a plain JavaScript object (excluding special classes or objects with other prototypes)
 *
 * @param {*} payload
 * @returns {payload is PlainObject}
 */
function isObject(payload) {
    return isPlainObject(payload);
}
/**
 * Returns whether the payload is a an empty object (excluding special classes or objects with other prototypes)
 *
 * @param {*} payload
 * @returns {payload is { [K in any]: never }}
 */
function isEmptyObject(payload) {
    return isPlainObject(payload) && Object.keys(payload).length === 0;
}
/**
 * Returns whether the payload is a an empty object (excluding special classes or objects with other prototypes)
 *
 * @param {*} payload
 * @returns {payload is PlainObject}
 */
function isFullObject(payload) {
    return isPlainObject(payload) && Object.keys(payload).length > 0;
}
/**
 * Returns whether the payload is an any kind of object (including special classes or objects with different prototypes)
 *
 * @param {*} payload
 * @returns {payload is PlainObject}
 */
function isAnyObject(payload) {
    return getType(payload) === 'Object';
}
/**
 * Returns whether the payload is an object like a type passed in < >
 *
 * Usage: isObjectLike<{id: any}>(payload) // will make sure it's an object and has an `id` prop.
 *
 * @template T this must be passed in < >
 * @param {*} payload
 * @returns {payload is T}
 */
function isObjectLike(payload) {
    return isAnyObject(payload);
}
/**
 * Returns whether the payload is a function (regular or async)
 *
 * @param {*} payload
 * @returns {payload is AnyFunction}
 */
function isFunction(payload) {
    return typeof payload === 'function';
}
/**
 * Returns whether the payload is an array
 *
 * @param {any} payload
 * @returns {payload is any[]}
 */
function index_esm_isArray(payload) {
    return getType(payload) === 'Array';
}
/**
 * Returns whether the payload is a an array with at least 1 item
 *
 * @param {*} payload
 * @returns {payload is any[]}
 */
function isFullArray(payload) {
    return index_esm_isArray(payload) && payload.length > 0;
}
/**
 * Returns whether the payload is a an empty array
 *
 * @param {*} payload
 * @returns {payload is []}
 */
function isEmptyArray(payload) {
    return index_esm_isArray(payload) && payload.length === 0;
}
/**
 * Returns whether the payload is a string
 *
 * @param {*} payload
 * @returns {payload is string}
 */
function isString(payload) {
    return getType(payload) === 'String';
}
/**
 * Returns whether the payload is a string, BUT returns false for ''
 *
 * @param {*} payload
 * @returns {payload is string}
 */
function isFullString(payload) {
    return isString(payload) && payload !== '';
}
/**
 * Returns whether the payload is ''
 *
 * @param {*} payload
 * @returns {payload is string}
 */
function isEmptyString(payload) {
    return payload === '';
}
/**
 * Returns whether the payload is a number (but not NaN)
 *
 * This will return `false` for `NaN`!!
 *
 * @param {*} payload
 * @returns {payload is number}
 */
function isNumber(payload) {
    return getType(payload) === 'Number' && !isNaN(payload);
}
/**
 * Returns whether the payload is a boolean
 *
 * @param {*} payload
 * @returns {payload is boolean}
 */
function isBoolean(payload) {
    return getType(payload) === 'Boolean';
}
/**
 * Returns whether the payload is a regular expression (RegExp)
 *
 * @param {*} payload
 * @returns {payload is RegExp}
 */
function isRegExp(payload) {
    return getType(payload) === 'RegExp';
}
/**
 * Returns whether the payload is a Map
 *
 * @param {*} payload
 * @returns {payload is Map<any, any>}
 */
function isMap(payload) {
    return getType(payload) === 'Map';
}
/**
 * Returns whether the payload is a WeakMap
 *
 * @param {*} payload
 * @returns {payload is WeakMap<any, any>}
 */
function isWeakMap(payload) {
    return getType(payload) === 'WeakMap';
}
/**
 * Returns whether the payload is a Set
 *
 * @param {*} payload
 * @returns {payload is Set<any>}
 */
function isSet(payload) {
    return getType(payload) === 'Set';
}
/**
 * Returns whether the payload is a WeakSet
 *
 * @param {*} payload
 * @returns {payload is WeakSet<any>}
 */
function isWeakSet(payload) {
    return getType(payload) === 'WeakSet';
}
/**
 * Returns whether the payload is a Symbol
 *
 * @param {*} payload
 * @returns {payload is symbol}
 */
function isSymbol(payload) {
    return getType(payload) === 'Symbol';
}
/**
 * Returns whether the payload is a Date, and that the date is valid
 *
 * @param {*} payload
 * @returns {payload is Date}
 */
function isDate(payload) {
    return getType(payload) === 'Date' && !isNaN(payload);
}
/**
 * Returns whether the payload is a Blob
 *
 * @param {*} payload
 * @returns {payload is Blob}
 */
function isBlob(payload) {
    return getType(payload) === 'Blob';
}
/**
 * Returns whether the payload is a File
 *
 * @param {*} payload
 * @returns {payload is File}
 */
function isFile(payload) {
    return getType(payload) === 'File';
}
/**
 * Returns whether the payload is a Promise
 *
 * @param {*} payload
 * @returns {payload is Promise<any>}
 */
function isPromise(payload) {
    return getType(payload) === 'Promise';
}
/**
 * Returns whether the payload is an Error
 *
 * @param {*} payload
 * @returns {payload is Error}
 */
function isError(payload) {
    return getType(payload) === 'Error';
}
/**
 * Returns whether the payload is literally the value `NaN` (it's `NaN` and also a `number`)
 *
 * @param {*} payload
 * @returns {payload is typeof NaN}
 */
function isNaNValue(payload) {
    return getType(payload) === 'Number' && isNaN(payload);
}
/**
 * Returns whether the payload is a primitive type (eg. Boolean | Null | Undefined | Number | String | Symbol)
 *
 * @param {*} payload
 * @returns {(payload is boolean | null | undefined | number | string | symbol)}
 */
function isPrimitive(payload) {
    return (isBoolean(payload) ||
        isNull(payload) ||
        isUndefined(payload) ||
        isNumber(payload) ||
        isString(payload) ||
        isSymbol(payload));
}
/**
 * Returns true whether the payload is null or undefined
 *
 * @param {*} payload
 * @returns {(payload is null | undefined)}
 */
var isNullOrUndefined = isOneOf(isNull, isUndefined);
function isOneOf(a, b, c, d, e) {
    return function (value) {
        return a(value) || b(value) || (!!c && c(value)) || (!!d && d(value)) || (!!e && e(value));
    };
}
/**
 * Does a generic check to check that the given payload is of a given type.
 * In cases like Number, it will return true for NaN as NaN is a Number (thanks javascript!);
 * It will, however, differentiate between object and null
 *
 * @template T
 * @param {*} payload
 * @param {T} type
 * @throws {TypeError} Will throw type error if type is an invalid type
 * @returns {payload is T}
 */
function isType(payload, type) {
    if (!(type instanceof Function)) {
        throw new TypeError('Type must be a function');
    }
    if (!Object.prototype.hasOwnProperty.call(type, 'prototype')) {
        throw new TypeError('Type is not a class');
    }
    // Classes usually have names (as functions usually have names)
    var name = type.name;
    return getType(payload) === name || Boolean(payload && payload.constructor === type);
}



;// CONCATENATED MODULE: ./node_modules/merge-anything/dist/index.esm.js


/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function assignProp(carry, key, newVal, originalObject) {
    var propType = originalObject.propertyIsEnumerable(key)
        ? 'enumerable'
        : 'nonenumerable';
    if (propType === 'enumerable')
        carry[key] = newVal;
    if (propType === 'nonenumerable') {
        Object.defineProperty(carry, key, {
            value: newVal,
            enumerable: false,
            writable: true,
            configurable: true
        });
    }
}
function mergeRecursively(origin, newComer, extensions) {
    // work directly on newComer if its not an object
    if (!isPlainObject(newComer)) {
        // extend merge rules
        if (extensions && index_esm_isArray(extensions)) {
            extensions.forEach(function (extend) {
                newComer = extend(origin, newComer);
            });
        }
        return newComer;
    }
    // define newObject to merge all values upon
    var newObject = {};
    if (isPlainObject(origin)) {
        var props_1 = Object.getOwnPropertyNames(origin);
        var symbols_1 = Object.getOwnPropertySymbols(origin);
        newObject = __spreadArrays(props_1, symbols_1).reduce(function (carry, key) {
            // @ts-ignore
            var targetVal = origin[key];
            if ((!isSymbol(key) && !Object.getOwnPropertyNames(newComer).includes(key)) ||
                (isSymbol(key) && !Object.getOwnPropertySymbols(newComer).includes(key))) {
                assignProp(carry, key, targetVal, origin);
            }
            return carry;
        }, {});
    }
    var props = Object.getOwnPropertyNames(newComer);
    var symbols = Object.getOwnPropertySymbols(newComer);
    var result = __spreadArrays(props, symbols).reduce(function (carry, key) {
        // re-define the origin and newComer as targetVal and newVal
        var newVal = newComer[key];
        var targetVal = (isPlainObject(origin))
            // @ts-ignore
            ? origin[key]
            : undefined;
        // extend merge rules
        if (extensions && index_esm_isArray(extensions)) {
            extensions.forEach(function (extend) {
                newVal = extend(targetVal, newVal);
            });
        }
        // When newVal is an object do the merge recursively
        if (targetVal !== undefined && isPlainObject(newVal)) {
            newVal = mergeRecursively(targetVal, newVal, extensions);
        }
        assignProp(carry, key, newVal, newComer);
        return carry;
    }, newObject);
    return result;
}
/**
 * Merge anything recursively.
 * Objects get merged, special objects (classes etc.) are re-assigned "as is".
 * Basic types overwrite objects or other basic types.
 *
 * @param {(IConfig | any)} origin
 * @param {...any[]} newComers
 * @returns the result
 */
function merge(origin) {
    var newComers = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        newComers[_i - 1] = arguments[_i];
    }
    var extensions = null;
    var base = origin;
    if (isPlainObject(origin) && origin.extensions && Object.keys(origin).length === 1) {
        base = {};
        extensions = origin.extensions;
    }
    return newComers.reduce(function (result, newComer) {
        return mergeRecursively(result, newComer, extensions);
    }, base);
}

function concatArrays(originVal, newVal) {
    if (isArray(originVal) && isArray(newVal)) {
        // concat logic
        return originVal.concat(newVal);
    }
    return newVal; // always return newVal as fallback!!
}

/* harmony default export */ var index_esm = (merge);


;// CONCATENATED MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js
/* provided dependency */ var process = __webpack_require__(34155);










// 

var interleave = (function (strings, interpolations) {
  var result = [strings[0]];

  for (var i = 0, len = interpolations.length; i < len; i += 1) {
    result.push(interpolations[i], strings[i + 1]);
  }

  return result;
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

// 
var styled_components_browser_esm_isPlainObject = (function (x) {
  return (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && x.constructor === Object;
});

// 
var EMPTY_ARRAY = Object.freeze([]);
var EMPTY_OBJECT = Object.freeze({});

// 
function styled_components_browser_esm_isFunction(test) {
  return typeof test === 'function';
}

// 

function getComponentName(target) {
  return ( false) || target.displayName || target.name || 'Component';
}

// 
function isStatelessFunction(test) {
  return typeof test === 'function' && !(test.prototype && test.prototype.isReactComponent);
}

// 
function isStyledComponent(target) {
  return target && typeof target.styledComponentId === 'string';
}

// 

var SC_ATTR = typeof process !== 'undefined' && (process.env.REACT_APP_SC_ATTR || process.env.SC_ATTR) || 'data-styled';

var SC_VERSION_ATTR = 'data-styled-version';

var SC_STREAM_ATTR = 'data-styled-streamed';

var IS_BROWSER = typeof window !== 'undefined' && 'HTMLElement' in window;

var DISABLE_SPEEDY = typeof SC_DISABLE_SPEEDY === 'boolean' && SC_DISABLE_SPEEDY || typeof process !== 'undefined' && (process.env.REACT_APP_SC_DISABLE_SPEEDY || process.env.SC_DISABLE_SPEEDY) || "production" !== 'production';

// Shared empty execution context when generating static styles
var STATIC_EXECUTION_CONTEXT = {};

// 


/**
 * Parse errors.md and turn it into a simple hash of code: message
 */
var ERRORS =  false ? 0 : {};

/**
 * super basic version of sprintf
 */
function format() {
  var a = arguments.length <= 0 ? undefined : arguments[0];
  var b = [];

  for (var c = 1, len = arguments.length; c < len; c += 1) {
    b.push(arguments.length <= c ? undefined : arguments[c]);
  }

  b.forEach(function (d) {
    a = a.replace(/%[a-z]/, d);
  });

  return a;
}

/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 */

var StyledComponentsError = function (_Error) {
  inherits(StyledComponentsError, _Error);

  function StyledComponentsError(code) {
    classCallCheck(this, StyledComponentsError);

    for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      interpolations[_key - 1] = arguments[_key];
    }

    if (true) {
      var _this = possibleConstructorReturn(this, _Error.call(this, 'An error occurred. See https://github.com/styled-components/styled-components/blob/master/packages/styled-components/src/utils/errors.md#' + code + ' for more information.' + (interpolations.length > 0 ? ' Additional arguments: ' + interpolations.join(', ') : '')));
    } else { var _this; }
    return possibleConstructorReturn(_this);
  }

  return StyledComponentsError;
}(Error);

// 
var SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s*(\S+)\s+\*\//gm;

var extractComps = (function (maybeCSS) {
  var css = '' + (maybeCSS || ''); // Definitely a string, and a clone
  var existingComponents = [];
  css.replace(SC_COMPONENT_ID, function (match, componentId, matchIndex) {
    existingComponents.push({ componentId: componentId, matchIndex: matchIndex });
    return match;
  });
  return existingComponents.map(function (_ref, i) {
    var componentId = _ref.componentId,
        matchIndex = _ref.matchIndex;

    var nextComp = existingComponents[i + 1];
    var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
    return { componentId: componentId, cssFromDOM: cssFromDOM };
  });
});

// 

var COMMENT_REGEX = /^\s*\/\/.*$/gm;

// NOTE: This stylis instance is only used to split rules from SSR'd style tags
var stylisSplitter = new (stylis_min_default())({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: false,
  compress: false,
  semicolon: true
});

var stylis = new (stylis_min_default())({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: true,
  compress: false,
  semicolon: false // NOTE: This means "autocomplete missing semicolons"
});

// Wrap `insertRulePlugin to build a list of rules,
// and then make our own plugin to return the rules. This
// makes it easier to hook into the existing SSR architecture

var parsingRules = [];

// eslint-disable-next-line consistent-return
var returnRulesPlugin = function returnRulesPlugin(context) {
  if (context === -2) {
    var parsedRules = parsingRules;
    parsingRules = [];
    return parsedRules;
  }
};

var parseRulesPlugin = stylis_rule_sheet_default()(function (rule) {
  parsingRules.push(rule);
});

var _componentId = void 0;
var _selector = void 0;
var _selectorRegexp = void 0;

var selfReferenceReplacer = function selfReferenceReplacer(match, offset, string) {
  if (
  // the first self-ref is always untouched
  offset > 0 &&
  // there should be at least two self-refs to do a replacement (.b > .b)
  string.slice(0, offset).indexOf(_selector) !== -1 &&
  // no consecutive self refs (.b.b); that is a precedence boost and treated differently
  string.slice(offset - _selector.length, offset) !== _selector) {
    return '.' + _componentId;
  }

  return match;
};

/**
 * When writing a style like
 *
 * & + & {
 *   color: red;
 * }
 *
 * The second ampersand should be a reference to the static component class. stylis
 * has no knowledge of static class so we have to intelligently replace the base selector.
 */
var selfReferenceReplacementPlugin = function selfReferenceReplacementPlugin(context, _, selectors) {
  if (context === 2 && selectors.length && selectors[0].lastIndexOf(_selector) > 0) {
    // eslint-disable-next-line no-param-reassign
    selectors[0] = selectors[0].replace(_selectorRegexp, selfReferenceReplacer);
  }
};

stylis.use([selfReferenceReplacementPlugin, parseRulesPlugin, returnRulesPlugin]);
stylisSplitter.use([parseRulesPlugin, returnRulesPlugin]);

var splitByRules = function splitByRules(css) {
  return stylisSplitter('', css);
};

function stringifyRules(rules, selector, prefix) {
  var componentId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '&';

  var flatCSS = rules.join('').replace(COMMENT_REGEX, ''); // replace JS comments

  var cssStr = selector && prefix ? prefix + ' ' + selector + ' { ' + flatCSS + ' }' : flatCSS;

  // stylis has no concept of state to be passed to plugins
  // but since JS is single=threaded, we can rely on that to ensure
  // these properties stay in sync with the current stylis run
  _componentId = componentId;
  _selector = selector;
  _selectorRegexp = new RegExp('\\' + _selector + '\\b', 'g');

  return stylis(prefix || !selector ? '' : selector, cssStr);
}

// 
/* eslint-disable camelcase, no-undef */

var getNonce = (function () {
  return  true ? __webpack_require__.nc : 0;
});

// 
/* These are helpers for the StyleTags to keep track of the injected
 * rule names for each (component) ID that they're keeping track of.
 * They're crucial for detecting whether a name has already been
 * injected.
 * (This excludes rehydrated names) */

/* adds a new ID:name pairing to a names dictionary */
var addNameForId = function addNameForId(names, id, name) {
  if (name) {
    // eslint-disable-next-line no-param-reassign
    var namesForId = names[id] || (names[id] = Object.create(null));
    namesForId[name] = true;
  }
};

/* resets an ID entirely by overwriting it in the dictionary */
var resetIdNames = function resetIdNames(names, id) {
  // eslint-disable-next-line no-param-reassign
  names[id] = Object.create(null);
};

/* factory for a names dictionary checking the existance of an ID:name pairing */
var hasNameForId = function hasNameForId(names) {
  return function (id, name) {
    return names[id] !== undefined && names[id][name];
  };
};

/* stringifies names for the html/element output */
var stringifyNames = function stringifyNames(names) {
  var str = '';
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    str += Object.keys(names[id]).join(' ') + ' ';
  }
  return str.trim();
};

/* clones the nested names dictionary */
var cloneNames = function cloneNames(names) {
  var clone = Object.create(null);
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    clone[id] = _extends({}, names[id]);
  }
  return clone;
};

// 

/* These are helpers that deal with the insertRule (aka speedy) API
 * They are used in the StyleTags and specifically the speedy tag
 */

/* retrieve a sheet for a given style tag */
var sheetForTag = function sheetForTag(tag) {
  // $FlowFixMe
  if (tag.sheet) return tag.sheet;

  /* Firefox quirk requires us to step through all stylesheets to find one owned by the given tag */
  var size = tag.ownerDocument.styleSheets.length;
  for (var i = 0; i < size; i += 1) {
    var sheet = tag.ownerDocument.styleSheets[i];
    // $FlowFixMe
    if (sheet.ownerNode === tag) return sheet;
  }

  /* we should always be able to find a tag */
  throw new StyledComponentsError(10);
};

/* insert a rule safely and return whether it was actually injected */
var safeInsertRule = function safeInsertRule(sheet, cssRule, index) {
  /* abort early if cssRule string is falsy */
  if (!cssRule) return false;

  var maxIndex = sheet.cssRules.length;

  try {
    /* use insertRule and cap passed index with maxIndex (no of cssRules) */
    sheet.insertRule(cssRule, index <= maxIndex ? index : maxIndex);
  } catch (err) {
    /* any error indicates an invalid rule */
    return false;
  }

  return true;
};

/* deletes `size` rules starting from `removalIndex` */
var deleteRules = function deleteRules(sheet, removalIndex, size) {
  var lowerBound = removalIndex - size;
  for (var i = removalIndex; i > lowerBound; i -= 1) {
    sheet.deleteRule(i);
  }
};

// 

/* this marker separates component styles and is important for rehydration */
var makeTextMarker = function makeTextMarker(id) {
  return '\n/* sc-component-id: ' + id + ' */\n';
};

/* add up all numbers in array up until and including the index */
var addUpUntilIndex = function addUpUntilIndex(sizes, index) {
  var totalUpToIndex = 0;
  for (var i = 0; i <= index; i += 1) {
    totalUpToIndex += sizes[i];
  }

  return totalUpToIndex;
};

/* create a new style tag after lastEl */
var makeStyleTag = function makeStyleTag(target, tagEl, insertBefore) {
  var targetDocument = document;
  if (target) targetDocument = target.ownerDocument;else if (tagEl) targetDocument = tagEl.ownerDocument;

  var el = targetDocument.createElement('style');
  el.setAttribute(SC_ATTR, '');
  el.setAttribute(SC_VERSION_ATTR, "4.4.1");

  var nonce = getNonce();
  if (nonce) {
    el.setAttribute('nonce', nonce);
  }

  /* Work around insertRule quirk in EdgeHTML */
  el.appendChild(targetDocument.createTextNode(''));

  if (target && !tagEl) {
    /* Append to target when no previous element was passed */
    target.appendChild(el);
  } else {
    if (!tagEl || !target || !tagEl.parentNode) {
      throw new StyledComponentsError(6);
    }

    /* Insert new style tag after the previous one */
    tagEl.parentNode.insertBefore(el, insertBefore ? tagEl : tagEl.nextSibling);
  }

  return el;
};

/* takes a css factory function and outputs an html styled tag factory */
var wrapAsHtmlTag = function wrapAsHtmlTag(css, names) {
  return function (additionalAttrs) {
    var nonce = getNonce();
    var attrs = [nonce && 'nonce="' + nonce + '"', SC_ATTR + '="' + stringifyNames(names) + '"', SC_VERSION_ATTR + '="' + "4.4.1" + '"', additionalAttrs];

    var htmlAttr = attrs.filter(Boolean).join(' ');
    return '<style ' + htmlAttr + '>' + css() + '</style>';
  };
};

/* takes a css factory function and outputs an element factory */
var wrapAsElement = function wrapAsElement(css, names) {
  return function () {
    var _props;

    var props = (_props = {}, _props[SC_ATTR] = stringifyNames(names), _props[SC_VERSION_ATTR] = "4.4.1", _props);

    var nonce = getNonce();
    if (nonce) {
      // $FlowFixMe
      props.nonce = nonce;
    }

    // eslint-disable-next-line react/no-danger
    return react.createElement('style', _extends({}, props, { dangerouslySetInnerHTML: { __html: css() } }));
  };
};

var getIdsFromMarkersFactory = function getIdsFromMarkersFactory(markers) {
  return function () {
    return Object.keys(markers);
  };
};

/* speedy tags utilise insertRule */
var makeSpeedyTag = function makeSpeedyTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);
  var sizes = [];

  var extractImport = getImportRuleTag !== undefined;
  /* indicates whether getImportRuleTag was called */
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    markers[id] = sizes.length;
    sizes.push(0);
    resetIdNames(names, id);

    return markers[id];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var sheet = sheetForTag(el);
    var insertIndex = addUpUntilIndex(sizes, marker);

    var injectedRules = 0;
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var cssRule = cssRules[i];
      var mayHaveImport = extractImport; /* @import rules are reordered to appear first */
      if (mayHaveImport && cssRule.indexOf('@import') !== -1) {
        importRules.push(cssRule);
      } else if (safeInsertRule(sheet, cssRule, insertIndex + injectedRules)) {
        mayHaveImport = false;
        injectedRules += 1;
      }
    }

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }

    sizes[marker] += injectedRules; /* add up no of injected rules */
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;
    // $FlowFixMe
    if (el.isConnected === false) return;

    var size = sizes[marker];
    var sheet = sheetForTag(el);
    var removalIndex = addUpUntilIndex(sizes, marker) - 1;
    deleteRules(sheet, removalIndex, size);
    sizes[marker] = 0;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var _sheetForTag = sheetForTag(el),
        cssRules = _sheetForTag.cssRules;

    var str = '';

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += makeTextMarker(id);
      var marker = markers[id];
      var end = addUpUntilIndex(sizes, marker);
      var size = sizes[marker];
      for (var i = end - size; i < end; i += 1) {
        var rule = cssRules[i];
        if (rule !== undefined) {
          str += rule.cssText;
        }
      }
    }

    return str;
  };

  return {
    clone: function clone() {
      throw new StyledComponentsError(5);
    },

    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: el,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };
};

var makeTextNode = function makeTextNode(targetDocument, id) {
  return targetDocument.createTextNode(makeTextMarker(id));
};

var makeBrowserTag = function makeBrowserTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);

  var extractImport = getImportRuleTag !== undefined;

  /* indicates whether getImportRuleTag was called */
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    markers[id] = makeTextNode(el.ownerDocument, id);
    el.appendChild(markers[id]);
    names[id] = Object.create(null);

    return markers[id];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var rule = cssRules[i];
      var mayHaveImport = extractImport;
      if (mayHaveImport && rule.indexOf('@import') !== -1) {
        importRules.push(rule);
      } else {
        mayHaveImport = false;
        var separator = i === cssRulesSize - 1 ? '' : ' ';
        marker.appendData('' + rule + separator);
      }
    }

    addNameForId(names, id, name);

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;

    /* create new empty text node and replace the current one */
    var newMarker = makeTextNode(el.ownerDocument, id);
    el.replaceChild(newMarker, marker);
    markers[id] = newMarker;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var str = '';

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += markers[id].data;
    }

    return str;
  };

  return {
    clone: function clone() {
      throw new StyledComponentsError(5);
    },

    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: el,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };
};

var makeServerTag = function makeServerTag(namesArg, markersArg) {
  var names = namesArg === undefined ? Object.create(null) : namesArg;
  var markers = markersArg === undefined ? Object.create(null) : markersArg;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    return markers[id] = [''];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    marker[0] += cssRules.join(' ');
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;
    marker[0] = '';
    resetIdNames(names, id);
  };

  var css = function css() {
    var str = '';
    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      var cssForId = markers[id][0];
      if (cssForId) {
        str += makeTextMarker(id) + cssForId;
      }
    }
    return str;
  };

  var clone = function clone() {
    var namesClone = cloneNames(names);
    var markersClone = Object.create(null);

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      markersClone[id] = [markers[id][0]];
    }

    return makeServerTag(namesClone, markersClone);
  };

  var tag = {
    clone: clone,
    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: null,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };

  return tag;
};

var makeTag = function makeTag(target, tagEl, forceServer, insertBefore, getImportRuleTag) {
  if (IS_BROWSER && !forceServer) {
    var el = makeStyleTag(target, tagEl, insertBefore);

    if (DISABLE_SPEEDY) {
      return makeBrowserTag(el, getImportRuleTag);
    } else {
      return makeSpeedyTag(el, getImportRuleTag);
    }
  }

  return makeServerTag();
};

var rehydrate = function rehydrate(tag, els, extracted) {
  /* add all extracted components to the new tag */
  for (var i = 0, len = extracted.length; i < len; i += 1) {
    var _extracted$i = extracted[i],
        componentId = _extracted$i.componentId,
        cssFromDOM = _extracted$i.cssFromDOM;

    var cssRules = splitByRules(cssFromDOM);
    tag.insertRules(componentId, cssRules);
  }

  /* remove old HTMLStyleElements, since they have been rehydrated */
  for (var _i = 0, _len = els.length; _i < _len; _i += 1) {
    var el = els[_i];
    if (el.parentNode) {
      el.parentNode.removeChild(el);
    }
  }
};

// 

var SPLIT_REGEX = /\s+/;

/* determine the maximum number of components before tags are sharded */
var MAX_SIZE = void 0;
if (IS_BROWSER) {
  /* in speedy mode we can keep a lot more rules in a sheet before a slowdown can be expected */
  MAX_SIZE = DISABLE_SPEEDY ? 40 : 1000;
} else {
  /* for servers we do not need to shard at all */
  MAX_SIZE = -1;
}

var sheetRunningId = 0;
var master = void 0;

var StyleSheet = function () {

  /* a map from ids to tags */

  /* deferred rules for a given id */

  /* this is used for not reinjecting rules via hasNameForId() */

  /* when rules for an id are removed using remove() we have to ignore rehydratedNames for it */

  /* a list of tags belonging to this StyleSheet */

  /* a tag for import rules */

  /* current capacity until a new tag must be created */

  /* children (aka clones) of this StyleSheet inheriting all and future injections */

  function StyleSheet() {
    var _this = this;

    var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : IS_BROWSER ? document.head : null;
    var forceServer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    classCallCheck(this, StyleSheet);

    this.getImportRuleTag = function () {
      var importRuleTag = _this.importRuleTag;

      if (importRuleTag !== undefined) {
        return importRuleTag;
      }

      var firstTag = _this.tags[0];
      var insertBefore = true;

      return _this.importRuleTag = makeTag(_this.target, firstTag ? firstTag.styleTag : null, _this.forceServer, insertBefore);
    };

    sheetRunningId += 1;
    this.id = sheetRunningId;
    this.forceServer = forceServer;
    this.target = forceServer ? null : target;
    this.tagMap = {};
    this.deferred = {};
    this.rehydratedNames = {};
    this.ignoreRehydratedNames = {};
    this.tags = [];
    this.capacity = 1;
    this.clones = [];
  }

  /* rehydrate all SSR'd style tags */


  StyleSheet.prototype.rehydrate = function rehydrate$$1() {
    if (!IS_BROWSER || this.forceServer) return this;

    var els = [];
    var extracted = [];
    var isStreamed = false;

    /* retrieve all of our SSR style elements from the DOM */
    var nodes = document.querySelectorAll('style[' + SC_ATTR + '][' + SC_VERSION_ATTR + '="' + "4.4.1" + '"]');

    var nodesSize = nodes.length;

    /* abort rehydration if no previous style tags were found */
    if (!nodesSize) return this;

    for (var i = 0; i < nodesSize; i += 1) {
      var el = nodes[i];

      /* check if style tag is a streamed tag */
      if (!isStreamed) isStreamed = !!el.getAttribute(SC_STREAM_ATTR);

      /* retrieve all component names */
      var elNames = (el.getAttribute(SC_ATTR) || '').trim().split(SPLIT_REGEX);
      var elNamesSize = elNames.length;
      for (var j = 0, name; j < elNamesSize; j += 1) {
        name = elNames[j];
        /* add rehydrated name to sheet to avoid re-adding styles */
        this.rehydratedNames[name] = true;
      }

      /* extract all components and their CSS */
      extracted.push.apply(extracted, extractComps(el.textContent));

      /* store original HTMLStyleElement */
      els.push(el);
    }

    /* abort rehydration if nothing was extracted */
    var extractedSize = extracted.length;
    if (!extractedSize) return this;

    /* create a tag to be used for rehydration */
    var tag = this.makeTag(null);

    rehydrate(tag, els, extracted);

    /* reset capacity and adjust MAX_SIZE by the initial size of the rehydration */
    this.capacity = Math.max(1, MAX_SIZE - extractedSize);
    this.tags.push(tag);

    /* retrieve all component ids */
    for (var _j = 0; _j < extractedSize; _j += 1) {
      this.tagMap[extracted[_j].componentId] = tag;
    }

    return this;
  };

  /* retrieve a "master" instance of StyleSheet which is typically used when no other is available
   * The master StyleSheet is targeted by createGlobalStyle, keyframes, and components outside of any
    * StyleSheetManager's context */


  /* reset the internal "master" instance */
  StyleSheet.reset = function reset() {
    var forceServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    master = new StyleSheet(undefined, forceServer).rehydrate();
  };

  /* adds "children" to the StyleSheet that inherit all of the parents' rules
   * while their own rules do not affect the parent */


  StyleSheet.prototype.clone = function clone() {
    var sheet = new StyleSheet(this.target, this.forceServer);

    /* add to clone array */
    this.clones.push(sheet);

    /* clone all tags */
    sheet.tags = this.tags.map(function (tag) {
      var ids = tag.getIds();
      var newTag = tag.clone();

      /* reconstruct tagMap */
      for (var i = 0; i < ids.length; i += 1) {
        sheet.tagMap[ids[i]] = newTag;
      }

      return newTag;
    });

    /* clone other maps */
    sheet.rehydratedNames = _extends({}, this.rehydratedNames);
    sheet.deferred = _extends({}, this.deferred);

    return sheet;
  };

  /* force StyleSheet to create a new tag on the next injection */


  StyleSheet.prototype.sealAllTags = function sealAllTags() {
    this.capacity = 1;

    this.tags.forEach(function (tag) {
      // eslint-disable-next-line no-param-reassign
      tag.sealed = true;
    });
  };

  StyleSheet.prototype.makeTag = function makeTag$$1(tag) {
    var lastEl = tag ? tag.styleTag : null;
    var insertBefore = false;

    return makeTag(this.target, lastEl, this.forceServer, insertBefore, this.getImportRuleTag);
  };

  /* get a tag for a given componentId, assign the componentId to one, or shard */
  StyleSheet.prototype.getTagForId = function getTagForId(id) {
    /* simply return a tag, when the componentId was already assigned one */
    var prev = this.tagMap[id];
    if (prev !== undefined && !prev.sealed) {
      return prev;
    }

    var tag = this.tags[this.tags.length - 1];

    /* shard (create a new tag) if the tag is exhausted (See MAX_SIZE) */
    this.capacity -= 1;

    if (this.capacity === 0) {
      this.capacity = MAX_SIZE;
      tag = this.makeTag(tag);
      this.tags.push(tag);
    }

    return this.tagMap[id] = tag;
  };

  /* mainly for createGlobalStyle to check for its id */


  StyleSheet.prototype.hasId = function hasId(id) {
    return this.tagMap[id] !== undefined;
  };

  /* caching layer checking id+name to already have a corresponding tag and injected rules */


  StyleSheet.prototype.hasNameForId = function hasNameForId(id, name) {
    /* exception for rehydrated names which are checked separately */
    if (this.ignoreRehydratedNames[id] === undefined && this.rehydratedNames[name]) {
      return true;
    }

    var tag = this.tagMap[id];
    return tag !== undefined && tag.hasNameForId(id, name);
  };

  /* registers a componentId and registers it on its tag */


  StyleSheet.prototype.deferredInject = function deferredInject(id, cssRules) {
    /* don't inject when the id is already registered */
    if (this.tagMap[id] !== undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].deferredInject(id, cssRules);
    }

    this.getTagForId(id).insertMarker(id);
    this.deferred[id] = cssRules;
  };

  /* injects rules for a given id with a name that will need to be cached */


  StyleSheet.prototype.inject = function inject(id, cssRules, name) {
    var clones = this.clones;


    for (var i = 0; i < clones.length; i += 1) {
      clones[i].inject(id, cssRules, name);
    }

    var tag = this.getTagForId(id);

    /* add deferred rules for component */
    if (this.deferred[id] !== undefined) {
      // Combine passed cssRules with previously deferred CSS rules
      // NOTE: We cannot mutate the deferred array itself as all clones
      // do the same (see clones[i].inject)
      var rules = this.deferred[id].concat(cssRules);
      tag.insertRules(id, rules, name);

      this.deferred[id] = undefined;
    } else {
      tag.insertRules(id, cssRules, name);
    }
  };

  /* removes all rules for a given id, which doesn't remove its marker but resets it */


  StyleSheet.prototype.remove = function remove(id) {
    var tag = this.tagMap[id];
    if (tag === undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].remove(id);
    }

    /* remove all rules from the tag */
    tag.removeRules(id);

    /* ignore possible rehydrated names */
    this.ignoreRehydratedNames[id] = true;

    /* delete possible deferred rules */
    this.deferred[id] = undefined;
  };

  StyleSheet.prototype.toHTML = function toHTML() {
    return this.tags.map(function (tag) {
      return tag.toHTML();
    }).join('');
  };

  StyleSheet.prototype.toReactElements = function toReactElements() {
    var id = this.id;


    return this.tags.map(function (tag, i) {
      var key = 'sc-' + id + '-' + i;
      return (0,react.cloneElement)(tag.toElement(), { key: key });
    });
  };

  createClass(StyleSheet, null, [{
    key: 'master',
    get: function get$$1() {
      return master || (master = new StyleSheet().rehydrate());
    }

    /* NOTE: This is just for backwards-compatibility with jest-styled-components */

  }, {
    key: 'instance',
    get: function get$$1() {
      return StyleSheet.master;
    }
  }]);
  return StyleSheet;
}();

// 

var Keyframes = function () {
  function Keyframes(name, rules) {
    var _this = this;

    classCallCheck(this, Keyframes);

    this.inject = function (styleSheet) {
      if (!styleSheet.hasNameForId(_this.id, _this.name)) {
        styleSheet.inject(_this.id, _this.rules, _this.name);
      }
    };

    this.toString = function () {
      throw new StyledComponentsError(12, String(_this.name));
    };

    this.name = name;
    this.rules = rules;

    this.id = 'sc-keyframes-' + name;
  }

  Keyframes.prototype.getName = function getName() {
    return this.name;
  };

  return Keyframes;
}();

// 

/**
 * inlined version of
 * https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/hyphenateStyleName.js
 */

var uppercasePattern = /([A-Z])/g;
var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return string.replace(uppercasePattern, '-$1').toLowerCase().replace(msPattern, '-ms-');
}

// 

// Taken from https://github.com/facebook/react/blob/b87aabdfe1b7461e7331abb3601d9e6bb27544bc/packages/react-dom/src/shared/dangerousStyleValue.js
function addUnitIfNeeded(name, value) {
  // https://github.com/amilajack/eslint-plugin-flowtype-errors/issues/133
  // $FlowFixMe
  if (value == null || typeof value === 'boolean' || value === '') {
    return '';
  }

  if (typeof value === 'number' && value !== 0 && !(name in unitless_browser_esm)) {
    return value + 'px'; // Presumes implicit 'px' suffix for unitless numbers
  }

  return String(value).trim();
}

// 

/**
 * It's falsish not falsy because 0 is allowed.
 */
var isFalsish = function isFalsish(chunk) {
  return chunk === undefined || chunk === null || chunk === false || chunk === '';
};

var objToCssArray = function objToCssArray(obj, prevKey) {
  var rules = [];
  var keys = Object.keys(obj);

  keys.forEach(function (key) {
    if (!isFalsish(obj[key])) {
      if (styled_components_browser_esm_isPlainObject(obj[key])) {
        rules.push.apply(rules, objToCssArray(obj[key], key));

        return rules;
      } else if (styled_components_browser_esm_isFunction(obj[key])) {
        rules.push(hyphenateStyleName(key) + ':', obj[key], ';');

        return rules;
      }
      rules.push(hyphenateStyleName(key) + ': ' + addUnitIfNeeded(key, obj[key]) + ';');
    }
    return rules;
  });

  return prevKey ? [prevKey + ' {'].concat(rules, ['}']) : rules;
};

function flatten(chunk, executionContext, styleSheet) {
  if (Array.isArray(chunk)) {
    var ruleSet = [];

    for (var i = 0, len = chunk.length, result; i < len; i += 1) {
      result = flatten(chunk[i], executionContext, styleSheet);

      if (result === null) continue;else if (Array.isArray(result)) ruleSet.push.apply(ruleSet, result);else ruleSet.push(result);
    }

    return ruleSet;
  }

  if (isFalsish(chunk)) {
    return null;
  }

  /* Handle other components */
  if (isStyledComponent(chunk)) {
    return '.' + chunk.styledComponentId;
  }

  /* Either execute or defer the function */
  if (styled_components_browser_esm_isFunction(chunk)) {
    if (isStatelessFunction(chunk) && executionContext) {
      var _result = chunk(executionContext);

      if (false) {}

      return flatten(_result, executionContext, styleSheet);
    } else return chunk;
  }

  if (chunk instanceof Keyframes) {
    if (styleSheet) {
      chunk.inject(styleSheet);
      return chunk.getName();
    } else return chunk;
  }

  /* Handle objects */
  return styled_components_browser_esm_isPlainObject(chunk) ? objToCssArray(chunk) : chunk.toString();
}

// 

function css(styles) {
  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  if (styled_components_browser_esm_isFunction(styles) || styled_components_browser_esm_isPlainObject(styles)) {
    // $FlowFixMe
    return flatten(interleave(EMPTY_ARRAY, [styles].concat(interpolations)));
  }

  // $FlowFixMe
  return flatten(interleave(styles, interpolations));
}

// 

function constructWithOptions(componentConstructor, tag) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;

  if (!(0,react_is.isValidElementType)(tag)) {
    throw new StyledComponentsError(1, String(tag));
  }

  /* This is callable directly as a template function */
  // $FlowFixMe: Not typed to avoid destructuring arguments
  var templateFunction = function templateFunction() {
    return componentConstructor(tag, options, css.apply(undefined, arguments));
  };

  /* If config methods are called, wrap up a new template function and merge options */
  templateFunction.withConfig = function (config) {
    return constructWithOptions(componentConstructor, tag, _extends({}, options, config));
  };

  /* Modify/inject new props at runtime */
  templateFunction.attrs = function (attrs) {
    return constructWithOptions(componentConstructor, tag, _extends({}, options, {
      attrs: Array.prototype.concat(options.attrs, attrs).filter(Boolean)
    }));
  };

  return templateFunction;
}

// 
// Source: https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function murmurhash(c) {
  for (var e = c.length | 0, a = e | 0, d = 0, b; e >= 4;) {
    b = c.charCodeAt(d) & 255 | (c.charCodeAt(++d) & 255) << 8 | (c.charCodeAt(++d) & 255) << 16 | (c.charCodeAt(++d) & 255) << 24, b = 1540483477 * (b & 65535) + ((1540483477 * (b >>> 16) & 65535) << 16), b ^= b >>> 24, b = 1540483477 * (b & 65535) + ((1540483477 * (b >>> 16) & 65535) << 16), a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16) ^ b, e -= 4, ++d;
  }
  switch (e) {
    case 3:
      a ^= (c.charCodeAt(d + 2) & 255) << 16;
    case 2:
      a ^= (c.charCodeAt(d + 1) & 255) << 8;
    case 1:
      a ^= c.charCodeAt(d) & 255, a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16);
  }
  a ^= a >>> 13;
  a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16);
  return (a ^ a >>> 15) >>> 0;
}

// 
/* eslint-disable no-bitwise */

/* This is the "capacity" of our alphabet i.e. 2x26 for all letters plus their capitalised
 * counterparts */
var charsLength = 52;

/* start at 75 for 'a' until 'z' (25) and then start at 65 for capitalised letters */
var getAlphabeticChar = function getAlphabeticChar(code) {
  return String.fromCharCode(code + (code > 25 ? 39 : 97));
};

/* input a number, usually a hash and convert it to base-52 */
function generateAlphabeticName(code) {
  var name = '';
  var x = void 0;

  /* get a char and divide by alphabet-length */
  for (x = code; x > charsLength; x = Math.floor(x / charsLength)) {
    name = getAlphabeticChar(x % charsLength) + name;
  }

  return getAlphabeticChar(x % charsLength) + name;
}

// 

function hasFunctionObjectKey(obj) {
  // eslint-disable-next-line guard-for-in, no-restricted-syntax
  for (var key in obj) {
    if (styled_components_browser_esm_isFunction(obj[key])) {
      return true;
    }
  }

  return false;
}

function isStaticRules(rules, attrs) {
  for (var i = 0; i < rules.length; i += 1) {
    var rule = rules[i];

    // recursive case
    if (Array.isArray(rule) && !isStaticRules(rule, attrs)) {
      return false;
    } else if (styled_components_browser_esm_isFunction(rule) && !isStyledComponent(rule)) {
      // functions are allowed to be static if they're just being
      // used to get the classname of a nested styled component
      return false;
    }
  }

  if (attrs.some(function (x) {
    return styled_components_browser_esm_isFunction(x) || hasFunctionObjectKey(x);
  })) return false;

  return true;
}

// 

/* combines hashStr (murmurhash) and nameGenerator for convenience */
var hasher = function hasher(str) {
  return generateAlphabeticName(murmurhash(str));
};

/*
 ComponentStyle is all the CSS-specific stuff, not
 the React-specific stuff.
 */

var ComponentStyle = function () {
  function ComponentStyle(rules, attrs, componentId) {
    classCallCheck(this, ComponentStyle);

    this.rules = rules;
    this.isStatic =  true && isStaticRules(rules, attrs);
    this.componentId = componentId;

    if (!StyleSheet.master.hasId(componentId)) {
      StyleSheet.master.deferredInject(componentId, []);
    }
  }

  /*
   * Flattens a rule set into valid CSS
   * Hashes it, wraps the whole chunk in a .hash1234 {}
   * Returns the hash to be injected on render()
   * */


  ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
    var isStatic = this.isStatic,
        componentId = this.componentId,
        lastClassName = this.lastClassName;

    if (IS_BROWSER && isStatic && typeof lastClassName === 'string' && styleSheet.hasNameForId(componentId, lastClassName)) {
      return lastClassName;
    }

    var flatCSS = flatten(this.rules, executionContext, styleSheet);
    var name = hasher(this.componentId + flatCSS.join(''));
    if (!styleSheet.hasNameForId(componentId, name)) {
      styleSheet.inject(this.componentId, stringifyRules(flatCSS, '.' + name, undefined, componentId), name);
    }

    this.lastClassName = name;
    return name;
  };

  ComponentStyle.generateName = function generateName(str) {
    return hasher(str);
  };

  return ComponentStyle;
}();

// 

var LIMIT = 200;

var createWarnTooManyClasses = (function (displayName) {
  var generatedClasses = {};
  var warningSeen = false;

  return function (className) {
    if (!warningSeen) {
      generatedClasses[className] = true;
      if (Object.keys(generatedClasses).length >= LIMIT) {
        // Unable to find latestRule in test environment.
        /* eslint-disable no-console, prefer-template */
        console.warn('Over ' + LIMIT + ' classes were generated for component ' + displayName + '. \n' + 'Consider using the attrs method, together with a style object for frequently changed styles.\n' + 'Example:\n' + '  const Component = styled.div.attrs(props => ({\n' + '    style: {\n' + '      background: props.background,\n' + '    },\n' + '  }))`width: 100%;`\n\n' + '  <Component />');
        warningSeen = true;
        generatedClasses = {};
      }
    }
  };
});

// 

var determineTheme = (function (props, fallbackTheme) {
  var defaultProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;

  // Props should take precedence over ThemeProvider, which should take precedence over
  // defaultProps, but React automatically puts defaultProps on props.

  /* eslint-disable react/prop-types, flowtype-errors/show-errors */
  var isDefaultTheme = defaultProps ? props.theme === defaultProps.theme : false;
  var theme = props.theme && !isDefaultTheme ? props.theme : fallbackTheme || defaultProps.theme;
  /* eslint-enable */

  return theme;
});

// 
var escapeRegex = /[[\].#*$><+~=|^:(),"'`-]+/g;
var dashesAtEnds = /(^-|-$)/g;

/**
 * TODO: Explore using CSS.escape when it becomes more available
 * in evergreen browsers.
 */
function styled_components_browser_esm_escape(str) {
  return str
  // Replace all possible CSS selectors
  .replace(escapeRegex, '-')

  // Remove extraneous hyphens at the start and end
  .replace(dashesAtEnds, '');
}

// 

function isTag(target) {
  return typeof target === 'string' && ( false ? 0 : true);
}

// 

function generateDisplayName(target) {
  // $FlowFixMe
  return isTag(target) ? 'styled.' + target : 'Styled(' + getComponentName(target) + ')';
}

var _TYPE_STATICS;

var REACT_STATICS = {
  childContextTypes: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDerivedStateFromProps: true,
  propTypes: true,
  type: true
};

var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};

var TYPE_STATICS = (_TYPE_STATICS = {}, _TYPE_STATICS[react_is.ForwardRef] = {
  $$typeof: true,
  render: true
}, _TYPE_STATICS);

var defineProperty$1 = Object.defineProperty,
    getOwnPropertyNames = Object.getOwnPropertyNames,
    _Object$getOwnPropert = Object.getOwnPropertySymbols,
    getOwnPropertySymbols = _Object$getOwnPropert === undefined ? function () {
  return [];
} : _Object$getOwnPropert,
    getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor,
    getPrototypeOf = Object.getPrototypeOf,
    objectPrototype = Object.prototype;
var arrayPrototype = Array.prototype;


function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components

    var inheritedComponent = getPrototypeOf(sourceComponent);

    if (inheritedComponent && inheritedComponent !== objectPrototype) {
      hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
    }

    var keys = arrayPrototype.concat(getOwnPropertyNames(sourceComponent),
    // $FlowFixMe
    getOwnPropertySymbols(sourceComponent));

    var targetStatics = TYPE_STATICS[targetComponent.$$typeof] || REACT_STATICS;

    var sourceStatics = TYPE_STATICS[sourceComponent.$$typeof] || REACT_STATICS;

    var i = keys.length;
    var descriptor = void 0;
    var key = void 0;

    // eslint-disable-next-line no-plusplus
    while (i--) {
      key = keys[i];

      if (
      // $FlowFixMe
      !KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) &&
      // $FlowFixMe
      !(targetStatics && targetStatics[key])) {
        descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        if (descriptor) {
          try {
            // Avoid failures from read-only properties
            defineProperty$1(targetComponent, key, descriptor);
          } catch (e) {
            /* fail silently */
          }
        }
      }
    }

    return targetComponent;
  }

  return targetComponent;
}

// 
function isDerivedReactComponent(fn) {
  return !!(fn && fn.prototype && fn.prototype.isReactComponent);
}

// 
// Helper to call a given function, only once
var once = (function (cb) {
  var called = false;

  return function () {
    if (!called) {
      called = true;
      cb.apply(undefined, arguments);
    }
  };
});

// 

var ThemeContext = (0,react.createContext)();

var ThemeConsumer = ThemeContext.Consumer;

/**
 * Provide a theme to an entire react component tree via context
 */

var ThemeProvider = function (_Component) {
  inherits(ThemeProvider, _Component);

  function ThemeProvider(props) {
    classCallCheck(this, ThemeProvider);

    var _this = possibleConstructorReturn(this, _Component.call(this, props));

    _this.getContext = memoize_one_esm(_this.getContext.bind(_this));
    _this.renderInner = _this.renderInner.bind(_this);
    return _this;
  }

  ThemeProvider.prototype.render = function render() {
    if (!this.props.children) return null;

    return react.createElement(
      ThemeContext.Consumer,
      null,
      this.renderInner
    );
  };

  ThemeProvider.prototype.renderInner = function renderInner(outerTheme) {
    var context = this.getContext(this.props.theme, outerTheme);

    return react.createElement(
      ThemeContext.Provider,
      { value: context },
      this.props.children
    );
  };

  /**
   * Get the theme from the props, supporting both (outerTheme) => {}
   * as well as object notation
   */


  ThemeProvider.prototype.getTheme = function getTheme(theme, outerTheme) {
    if (styled_components_browser_esm_isFunction(theme)) {
      var mergedTheme = theme(outerTheme);

      if (false) {}

      return mergedTheme;
    }

    if (theme === null || Array.isArray(theme) || (typeof theme === 'undefined' ? 'undefined' : _typeof(theme)) !== 'object') {
      throw new StyledComponentsError(8);
    }

    return _extends({}, outerTheme, theme);
  };

  ThemeProvider.prototype.getContext = function getContext(theme, outerTheme) {
    return this.getTheme(theme, outerTheme);
  };

  return ThemeProvider;
}(react.Component);

// 

var CLOSING_TAG_R = /^\s*<\/[a-z]/i;

var ServerStyleSheet = function () {
  function ServerStyleSheet() {
    classCallCheck(this, ServerStyleSheet);

    /* The master sheet might be reset, so keep a reference here */
    this.masterSheet = StyleSheet.master;
    this.instance = this.masterSheet.clone();
    this.sealed = false;
  }

  /**
   * Mark the ServerStyleSheet as being fully emitted and manually GC it from the
   * StyleSheet singleton.
   */


  ServerStyleSheet.prototype.seal = function seal() {
    if (!this.sealed) {
      /* Remove sealed StyleSheets from the master sheet */
      var index = this.masterSheet.clones.indexOf(this.instance);
      this.masterSheet.clones.splice(index, 1);
      this.sealed = true;
    }
  };

  ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
    if (this.sealed) {
      throw new StyledComponentsError(2);
    }

    return react.createElement(
      StyleSheetManager,
      { sheet: this.instance },
      children
    );
  };

  ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
    this.seal();
    return this.instance.toHTML();
  };

  ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
    this.seal();
    return this.instance.toReactElements();
  };

  ServerStyleSheet.prototype.interleaveWithNodeStream = function interleaveWithNodeStream(readableStream) {
    var _this = this;

    {
      throw new StyledComponentsError(3);
    }

    /* the tag index keeps track of which tags have already been emitted */
    var instance = this.instance;

    var instanceTagIndex = 0;

    var streamAttr = SC_STREAM_ATTR + '="true"';

    var transformer = new stream.Transform({
      transform: function appendStyleChunks(chunk, /* encoding */_, callback) {
        var tags = instance.tags;

        var html = '';

        /* retrieve html for each new style tag */
        for (; instanceTagIndex < tags.length; instanceTagIndex += 1) {
          var tag = tags[instanceTagIndex];
          html += tag.toHTML(streamAttr);
        }

        /* force our StyleSheets to emit entirely new tags */
        instance.sealAllTags();

        var renderedHtml = chunk.toString();

        /* prepend style html to chunk, unless the start of the chunk is a closing tag in which case append right after that */
        if (CLOSING_TAG_R.test(renderedHtml)) {
          var endOfClosingTag = renderedHtml.indexOf('>');

          this.push(renderedHtml.slice(0, endOfClosingTag + 1) + html + renderedHtml.slice(endOfClosingTag + 1));
        } else this.push(html + renderedHtml);

        callback();
      }
    });

    readableStream.on('end', function () {
      return _this.seal();
    });

    readableStream.on('error', function (err) {
      _this.seal();

      // forward the error to the transform stream
      transformer.emit('error', err);
    });

    return readableStream.pipe(transformer);
  };

  return ServerStyleSheet;
}();

// 

var StyleSheetContext = (0,react.createContext)();
var StyleSheetConsumer = StyleSheetContext.Consumer;

var StyleSheetManager = function (_Component) {
  inherits(StyleSheetManager, _Component);

  function StyleSheetManager(props) {
    classCallCheck(this, StyleSheetManager);

    var _this = possibleConstructorReturn(this, _Component.call(this, props));

    _this.getContext = memoize_one_esm(_this.getContext);
    return _this;
  }

  StyleSheetManager.prototype.getContext = function getContext(sheet, target) {
    if (sheet) {
      return sheet;
    } else if (target) {
      return new StyleSheet(target);
    } else {
      throw new StyledComponentsError(4);
    }
  };

  StyleSheetManager.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        sheet = _props.sheet,
        target = _props.target;


    return react.createElement(
      StyleSheetContext.Provider,
      { value: this.getContext(sheet, target) },
       false ? 0 : children
    );
  };

  return StyleSheetManager;
}(react.Component);
 false ? 0 : void 0;

// 

var identifiers = {};

/* We depend on components having unique IDs */
function generateId(_ComponentStyle, _displayName, parentComponentId) {
  var displayName = typeof _displayName !== 'string' ? 'sc' : styled_components_browser_esm_escape(_displayName);

  /**
   * This ensures uniqueness if two components happen to share
   * the same displayName.
   */
  var nr = (identifiers[displayName] || 0) + 1;
  identifiers[displayName] = nr;

  var componentId = displayName + '-' + _ComponentStyle.generateName(displayName + nr);

  return parentComponentId ? parentComponentId + '-' + componentId : componentId;
}

// $FlowFixMe

var StyledComponent = function (_Component) {
  inherits(StyledComponent, _Component);

  function StyledComponent() {
    classCallCheck(this, StyledComponent);

    var _this = possibleConstructorReturn(this, _Component.call(this));

    _this.attrs = {};

    _this.renderOuter = _this.renderOuter.bind(_this);
    _this.renderInner = _this.renderInner.bind(_this);

    if (false) {}
    return _this;
  }

  StyledComponent.prototype.render = function render() {
    return react.createElement(
      StyleSheetConsumer,
      null,
      this.renderOuter
    );
  };

  StyledComponent.prototype.renderOuter = function renderOuter() {
    var styleSheet = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : StyleSheet.master;

    this.styleSheet = styleSheet;

    // No need to subscribe a static component to theme changes, it won't change anything
    if (this.props.forwardedComponent.componentStyle.isStatic) return this.renderInner();

    return react.createElement(
      ThemeConsumer,
      null,
      this.renderInner
    );
  };

  StyledComponent.prototype.renderInner = function renderInner(theme) {
    var _props$forwardedCompo = this.props.forwardedComponent,
        componentStyle = _props$forwardedCompo.componentStyle,
        defaultProps = _props$forwardedCompo.defaultProps,
        displayName = _props$forwardedCompo.displayName,
        foldedComponentIds = _props$forwardedCompo.foldedComponentIds,
        styledComponentId = _props$forwardedCompo.styledComponentId,
        target = _props$forwardedCompo.target;


    var generatedClassName = void 0;
    if (componentStyle.isStatic) {
      generatedClassName = this.generateAndInjectStyles(EMPTY_OBJECT, this.props);
    } else {
      generatedClassName = this.generateAndInjectStyles(determineTheme(this.props, theme, defaultProps) || EMPTY_OBJECT, this.props);
    }

    var elementToBeCreated = this.props.as || this.attrs.as || target;
    var isTargetTag = isTag(elementToBeCreated);

    var propsForElement = {};
    var computedProps = _extends({}, this.props, this.attrs);

    var key = void 0;
    // eslint-disable-next-line guard-for-in
    for (key in computedProps) {
      if (false) {}

      if (key === 'forwardedComponent' || key === 'as') {
        continue;
      } else if (key === 'forwardedRef') propsForElement.ref = computedProps[key];else if (key === 'forwardedAs') propsForElement.as = computedProps[key];else if (!isTargetTag || (0,is_prop_valid_browser_esm/* default */.Z)(key)) {
        // Don't pass through non HTML tags through to HTML elements
        propsForElement[key] = computedProps[key];
      }
    }

    if (this.props.style && this.attrs.style) {
      propsForElement.style = _extends({}, this.attrs.style, this.props.style);
    }

    propsForElement.className = Array.prototype.concat(foldedComponentIds, styledComponentId, generatedClassName !== styledComponentId ? generatedClassName : null, this.props.className, this.attrs.className).filter(Boolean).join(' ');

    return (0,react.createElement)(elementToBeCreated, propsForElement);
  };

  StyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props, attrs) {
    var _this2 = this;

    var context = _extends({}, props, { theme: theme });

    if (!attrs.length) return context;

    this.attrs = {};

    attrs.forEach(function (attrDef) {
      var resolvedAttrDef = attrDef;
      var attrDefWasFn = false;
      var attr = void 0;
      var key = void 0;

      if (styled_components_browser_esm_isFunction(resolvedAttrDef)) {
        // $FlowFixMe
        resolvedAttrDef = resolvedAttrDef(context);
        attrDefWasFn = true;
      }

      /* eslint-disable guard-for-in */
      // $FlowFixMe
      for (key in resolvedAttrDef) {
        attr = resolvedAttrDef[key];

        if (!attrDefWasFn) {
          if (styled_components_browser_esm_isFunction(attr) && !isDerivedReactComponent(attr) && !isStyledComponent(attr)) {
            if (false) {}

            attr = attr(context);

            if (false) {}
          }
        }

        _this2.attrs[key] = attr;
        context[key] = attr;
      }
      /* eslint-enable */
    });

    return context;
  };

  StyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
    var _props$forwardedCompo2 = props.forwardedComponent,
        attrs = _props$forwardedCompo2.attrs,
        componentStyle = _props$forwardedCompo2.componentStyle,
        warnTooManyClasses = _props$forwardedCompo2.warnTooManyClasses;

    // statically styled-components don't need to build an execution context object,
    // and shouldn't be increasing the number of class names

    if (componentStyle.isStatic && !attrs.length) {
      return componentStyle.generateAndInjectStyles(EMPTY_OBJECT, this.styleSheet);
    }

    var className = componentStyle.generateAndInjectStyles(this.buildExecutionContext(theme, props, attrs), this.styleSheet);

    if (false) {}

    return className;
  };

  return StyledComponent;
}(react.Component);

function createStyledComponent(target, options, rules) {
  var isTargetStyledComp = isStyledComponent(target);
  var isClass = !isTag(target);

  var _options$displayName = options.displayName,
      displayName = _options$displayName === undefined ? generateDisplayName(target) : _options$displayName,
      _options$componentId = options.componentId,
      componentId = _options$componentId === undefined ? generateId(ComponentStyle, options.displayName, options.parentComponentId) : _options$componentId,
      _options$ParentCompon = options.ParentComponent,
      ParentComponent = _options$ParentCompon === undefined ? StyledComponent : _options$ParentCompon,
      _options$attrs = options.attrs,
      attrs = _options$attrs === undefined ? EMPTY_ARRAY : _options$attrs;


  var styledComponentId = options.displayName && options.componentId ? styled_components_browser_esm_escape(options.displayName) + '-' + options.componentId : options.componentId || componentId;

  // fold the underlying StyledComponent attrs up (implicit extend)
  var finalAttrs =
  // $FlowFixMe
  isTargetStyledComp && target.attrs ? Array.prototype.concat(target.attrs, attrs).filter(Boolean) : attrs;

  var componentStyle = new ComponentStyle(isTargetStyledComp ? // fold the underlying StyledComponent rules up (implicit extend)
  // $FlowFixMe
  target.componentStyle.rules.concat(rules) : rules, finalAttrs, styledComponentId);

  /**
   * forwardRef creates a new interim component, which we'll take advantage of
   * instead of extending ParentComponent to create _another_ interim class
   */
  var WrappedStyledComponent = void 0;
  var forwardRef = function forwardRef(props, ref) {
    return react.createElement(ParentComponent, _extends({}, props, { forwardedComponent: WrappedStyledComponent, forwardedRef: ref }));
  };
  forwardRef.displayName = displayName;
  WrappedStyledComponent = react.forwardRef(forwardRef);
  WrappedStyledComponent.displayName = displayName;

  // $FlowFixMe
  WrappedStyledComponent.attrs = finalAttrs;
  // $FlowFixMe
  WrappedStyledComponent.componentStyle = componentStyle;

  // $FlowFixMe
  WrappedStyledComponent.foldedComponentIds = isTargetStyledComp ? // $FlowFixMe
  Array.prototype.concat(target.foldedComponentIds, target.styledComponentId) : EMPTY_ARRAY;

  // $FlowFixMe
  WrappedStyledComponent.styledComponentId = styledComponentId;

  // fold the underlying StyledComponent target up since we folded the styles
  // $FlowFixMe
  WrappedStyledComponent.target = isTargetStyledComp ? target.target : target;

  // $FlowFixMe
  WrappedStyledComponent.withComponent = function withComponent(tag) {
    var previousComponentId = options.componentId,
        optionsToCopy = objectWithoutProperties(options, ['componentId']);


    var newComponentId = previousComponentId && previousComponentId + '-' + (isTag(tag) ? tag : styled_components_browser_esm_escape(getComponentName(tag)));

    var newOptions = _extends({}, optionsToCopy, {
      attrs: finalAttrs,
      componentId: newComponentId,
      ParentComponent: ParentComponent
    });

    return createStyledComponent(tag, newOptions, rules);
  };

  // $FlowFixMe
  Object.defineProperty(WrappedStyledComponent, 'defaultProps', {
    get: function get$$1() {
      return this._foldedDefaultProps;
    },
    set: function set$$1(obj) {
      // $FlowFixMe
      this._foldedDefaultProps = isTargetStyledComp ? index_esm(target.defaultProps, obj) : obj;
    }
  });

  if (false) {}

  // $FlowFixMe
  WrappedStyledComponent.toString = function () {
    return '.' + WrappedStyledComponent.styledComponentId;
  };

  if (isClass) {
    hoistNonReactStatics(WrappedStyledComponent, target, {
      // all SC-specific things should not be hoisted
      attrs: true,
      componentStyle: true,
      displayName: true,
      foldedComponentIds: true,
      styledComponentId: true,
      target: true,
      withComponent: true
    });
  }

  return WrappedStyledComponent;
}

// 
// Thanks to ReactDOMFactories for this handy list!

var domElements = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr',

// SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'marker', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

// 

var styled = function styled(tag) {
  return constructWithOptions(createStyledComponent, tag);
};

// Shorthands for all valid HTML Elements
domElements.forEach(function (domElement) {
  styled[domElement] = styled(domElement);
});

// 

var GlobalStyle = function () {
  function GlobalStyle(rules, componentId) {
    classCallCheck(this, GlobalStyle);

    this.rules = rules;
    this.componentId = componentId;
    this.isStatic = isStaticRules(rules, EMPTY_ARRAY);

    if (!StyleSheet.master.hasId(componentId)) {
      StyleSheet.master.deferredInject(componentId, []);
    }
  }

  GlobalStyle.prototype.createStyles = function createStyles(executionContext, styleSheet) {
    var flatCSS = flatten(this.rules, executionContext, styleSheet);
    var css = stringifyRules(flatCSS, '');

    styleSheet.inject(this.componentId, css);
  };

  GlobalStyle.prototype.removeStyles = function removeStyles(styleSheet) {
    var componentId = this.componentId;

    if (styleSheet.hasId(componentId)) {
      styleSheet.remove(componentId);
    }
  };

  // TODO: overwrite in-place instead of remove+create?


  GlobalStyle.prototype.renderStyles = function renderStyles(executionContext, styleSheet) {
    this.removeStyles(styleSheet);
    this.createStyles(executionContext, styleSheet);
  };

  return GlobalStyle;
}();

// 

// place our cache into shared context so it'll persist between HMRs
if (IS_BROWSER) {
  window.scCGSHMRCache = {};
}

function createGlobalStyle(strings) {
  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  var rules = css.apply(undefined, [strings].concat(interpolations));
  var id = 'sc-global-' + murmurhash(JSON.stringify(rules));
  var style = new GlobalStyle(rules, id);

  var GlobalStyleComponent = function (_React$Component) {
    inherits(GlobalStyleComponent, _React$Component);

    function GlobalStyleComponent(props) {
      classCallCheck(this, GlobalStyleComponent);

      var _this = possibleConstructorReturn(this, _React$Component.call(this, props));

      var _this$constructor = _this.constructor,
          globalStyle = _this$constructor.globalStyle,
          styledComponentId = _this$constructor.styledComponentId;


      if (IS_BROWSER) {
        window.scCGSHMRCache[styledComponentId] = (window.scCGSHMRCache[styledComponentId] || 0) + 1;
      }

      /**
       * This fixes HMR compatibility. Don't ask me why, but this combination of
       * caching the closure variables via statics and then persisting the statics in
       * state works across HMR where no other combination did. ¯\_(ツ)_/¯
       */
      _this.state = {
        globalStyle: globalStyle,
        styledComponentId: styledComponentId
      };
      return _this;
    }

    GlobalStyleComponent.prototype.componentWillUnmount = function componentWillUnmount() {
      if (window.scCGSHMRCache[this.state.styledComponentId]) {
        window.scCGSHMRCache[this.state.styledComponentId] -= 1;
      }
      /**
       * Depending on the order "render" is called this can cause the styles to be lost
       * until the next render pass of the remaining instance, which may
       * not be immediate.
       */
      if (window.scCGSHMRCache[this.state.styledComponentId] === 0) {
        this.state.globalStyle.removeStyles(this.styleSheet);
      }
    };

    GlobalStyleComponent.prototype.render = function render() {
      var _this2 = this;

      if (false) {}

      return react.createElement(
        StyleSheetConsumer,
        null,
        function (styleSheet) {
          _this2.styleSheet = styleSheet || StyleSheet.master;

          var globalStyle = _this2.state.globalStyle;


          if (globalStyle.isStatic) {
            globalStyle.renderStyles(STATIC_EXECUTION_CONTEXT, _this2.styleSheet);

            return null;
          } else {
            return react.createElement(
              ThemeConsumer,
              null,
              function (theme) {
                // $FlowFixMe
                var defaultProps = _this2.constructor.defaultProps;


                var context = _extends({}, _this2.props);

                if (typeof theme !== 'undefined') {
                  context.theme = determineTheme(_this2.props, theme, defaultProps);
                }

                globalStyle.renderStyles(context, _this2.styleSheet);

                return null;
              }
            );
          }
        }
      );
    };

    return GlobalStyleComponent;
  }(react.Component);

  GlobalStyleComponent.globalStyle = style;
  GlobalStyleComponent.styledComponentId = id;


  return GlobalStyleComponent;
}

// 

var replaceWhitespace = function replaceWhitespace(str) {
  return str.replace(/\s|\\n/g, '');
};

function keyframes(strings) {
  /* Warning if you've used keyframes on React Native */
  if (false) {}

  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  var rules = css.apply(undefined, [strings].concat(interpolations));

  var name = generateAlphabeticName(murmurhash(replaceWhitespace(JSON.stringify(rules))));

  return new Keyframes(name, stringifyRules(rules, name, '@keyframes'));
}

// 

var withTheme = (function (Component$$1) {
  var WithTheme = react.forwardRef(function (props, ref) {
    return react.createElement(
      ThemeConsumer,
      null,
      function (theme) {
        // $FlowFixMe
        var defaultProps = Component$$1.defaultProps;

        var themeProp = determineTheme(props, theme, defaultProps);

        if (false) {}

        return react.createElement(Component$$1, _extends({}, props, { theme: themeProp, ref: ref }));
      }
    );
  });

  hoistNonReactStatics(WithTheme, Component$$1);

  WithTheme.displayName = 'WithTheme(' + getComponentName(Component$$1) + ')';

  return WithTheme;
});

// 

/* eslint-disable */
var __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS = {
  StyleSheet: StyleSheet
};

// 

/* Warning if you've imported this file on React Native */
if (false) {}

/* Warning if there are several instances of styled-components */
if (false) {}

//

/* harmony default export */ var styled_components_browser_esm = (styled);

//# sourceMappingURL=styled-components.browser.esm.js.map


/***/ }),

/***/ 74786:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "alignContent": function() { return /* binding */ alignContent; },
  "alignItems": function() { return /* binding */ alignItems; },
  "alignSelf": function() { return /* binding */ alignSelf; },
  "background": function() { return /* reexport */ background; },
  "backgroundImage": function() { return /* binding */ backgroundImage; },
  "backgroundPosition": function() { return /* binding */ backgroundPosition; },
  "backgroundRepeat": function() { return /* binding */ backgroundRepeat; },
  "backgroundSize": function() { return /* binding */ backgroundSize; },
  "border": function() { return /* reexport */ border; },
  "borderBottom": function() { return /* binding */ borderBottom; },
  "borderColor": function() { return /* binding */ borderColor; },
  "borderLeft": function() { return /* binding */ borderLeft; },
  "borderRadius": function() { return /* binding */ borderRadius; },
  "borderRight": function() { return /* binding */ borderRight; },
  "borderStyle": function() { return /* binding */ borderStyle; },
  "borderTop": function() { return /* binding */ borderTop; },
  "borderWidth": function() { return /* binding */ borderWidth; },
  "borders": function() { return /* reexport */ border_dist_index_esm; },
  "bottom": function() { return /* binding */ bottom; },
  "boxShadow": function() { return /* reexport */ shadow_dist_index_esm; },
  "buttonStyle": function() { return /* reexport */ buttonStyle; },
  "color": function() { return /* reexport */ color; },
  "colorStyle": function() { return /* reexport */ colorStyle; },
  "compose": function() { return /* reexport */ compose; },
  "createParser": function() { return /* reexport */ createParser; },
  "createStyleFunction": function() { return /* reexport */ createStyleFunction; },
  "display": function() { return /* binding */ display; },
  "flex": function() { return /* binding */ flex; },
  "flexBasis": function() { return /* binding */ flexBasis; },
  "flexDirection": function() { return /* binding */ flexDirection; },
  "flexGrow": function() { return /* binding */ flexGrow; },
  "flexShrink": function() { return /* binding */ flexShrink; },
  "flexWrap": function() { return /* binding */ flexWrap; },
  "flexbox": function() { return /* reexport */ flexbox; },
  "fontFamily": function() { return /* binding */ fontFamily; },
  "fontSize": function() { return /* binding */ fontSize; },
  "fontStyle": function() { return /* binding */ fontStyle; },
  "fontWeight": function() { return /* binding */ fontWeight; },
  "get": function() { return /* reexport */ get; },
  "grid": function() { return /* reexport */ grid; },
  "gridArea": function() { return /* binding */ gridArea; },
  "gridAutoColumns": function() { return /* binding */ gridAutoColumns; },
  "gridAutoFlow": function() { return /* binding */ gridAutoFlow; },
  "gridAutoRows": function() { return /* binding */ gridAutoRows; },
  "gridColumn": function() { return /* binding */ gridColumn; },
  "gridColumnGap": function() { return /* binding */ gridColumnGap; },
  "gridGap": function() { return /* binding */ gridGap; },
  "gridRow": function() { return /* binding */ gridRow; },
  "gridRowGap": function() { return /* binding */ gridRowGap; },
  "gridTemplateAreas": function() { return /* binding */ gridTemplateAreas; },
  "gridTemplateColumns": function() { return /* binding */ gridTemplateColumns; },
  "gridTemplateRows": function() { return /* binding */ gridTemplateRows; },
  "height": function() { return /* binding */ height; },
  "justifyContent": function() { return /* binding */ justifyContent; },
  "justifyItems": function() { return /* binding */ justifyItems; },
  "justifySelf": function() { return /* binding */ justifySelf; },
  "layout": function() { return /* reexport */ layout; },
  "left": function() { return /* binding */ left; },
  "letterSpacing": function() { return /* binding */ letterSpacing; },
  "lineHeight": function() { return /* binding */ lineHeight; },
  "margin": function() { return /* reexport */ margin; },
  "maxHeight": function() { return /* binding */ maxHeight; },
  "maxWidth": function() { return /* binding */ maxWidth; },
  "minHeight": function() { return /* binding */ minHeight; },
  "minWidth": function() { return /* binding */ minWidth; },
  "opacity": function() { return /* binding */ opacity; },
  "order": function() { return /* binding */ order; },
  "overflow": function() { return /* binding */ overflow; },
  "overflowX": function() { return /* binding */ overflowX; },
  "overflowY": function() { return /* binding */ overflowY; },
  "padding": function() { return /* reexport */ padding; },
  "position": function() { return /* reexport */ position; },
  "right": function() { return /* binding */ right; },
  "shadow": function() { return /* reexport */ shadow; },
  "size": function() { return /* binding */ size; },
  "space": function() { return /* reexport */ space; },
  "style": function() { return /* binding */ style; },
  "system": function() { return /* reexport */ system; },
  "textAlign": function() { return /* binding */ textAlign; },
  "textShadow": function() { return /* reexport */ shadow_dist_index_esm; },
  "textStyle": function() { return /* reexport */ textStyle; },
  "top": function() { return /* binding */ index_esm_top; },
  "typography": function() { return /* reexport */ typography; },
  "variant": function() { return /* reexport */ variant; },
  "verticalAlign": function() { return /* binding */ verticalAlign; },
  "width": function() { return /* binding */ width; },
  "zIndex": function() { return /* binding */ zIndex; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/build/polyfills/object-assign.js
var object_assign = __webpack_require__(96086);
var object_assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);
;// CONCATENATED MODULE: ./node_modules/@styled-system/core/dist/index.esm.js

var merge = function merge(a, b) {
  var result = object_assign_default()({}, a, b);

  for (var key in a) {
    var _assign;

    if (!a[key] || typeof b[key] !== 'object') continue;
    object_assign_default()(result, (_assign = {}, _assign[key] = object_assign_default()(a[key], b[key]), _assign));
  }

  return result;
}; // sort object-value responsive styles

var sort = function sort(obj) {
  var next = {};
  Object.keys(obj).sort(function (a, b) {
    return a.localeCompare(b, undefined, {
      numeric: true,
      sensitivity: 'base'
    });
  }).forEach(function (key) {
    next[key] = obj[key];
  });
  return next;
};

var defaults = {
  breakpoints: [40, 52, 64].map(function (n) {
    return n + 'em';
  })
};

var createMediaQuery = function createMediaQuery(n) {
  return "@media screen and (min-width: " + n + ")";
};

var getValue = function getValue(n, scale) {
  return get(scale, n, n);
};

var get = function get(obj, key, def, p, undef) {
  key = key && key.split ? key.split('.') : [key];

  for (p = 0; p < key.length; p++) {
    obj = obj ? obj[key[p]] : undef;
  }

  return obj === undef ? def : obj;
};
var createParser = function createParser(config) {
  var cache = {};

  var parse = function parse(props) {
    var styles = {};
    var shouldSort = false;
    var isCacheDisabled = props.theme && props.theme.disableStyledSystemCache;

    for (var key in props) {
      if (!config[key]) continue;
      var sx = config[key];
      var raw = props[key];
      var scale = get(props.theme, sx.scale, sx.defaults);

      if (typeof raw === 'object') {
        cache.breakpoints = !isCacheDisabled && cache.breakpoints || get(props.theme, 'breakpoints', defaults.breakpoints);

        if (Array.isArray(raw)) {
          cache.media = !isCacheDisabled && cache.media || [null].concat(cache.breakpoints.map(createMediaQuery));
          styles = merge(styles, parseResponsiveStyle(cache.media, sx, scale, raw, props));
          continue;
        }

        if (raw !== null) {
          styles = merge(styles, parseResponsiveObject(cache.breakpoints, sx, scale, raw, props));
          shouldSort = true;
        }

        continue;
      }

      object_assign_default()(styles, sx(raw, scale, props));
    } // sort object-based responsive styles


    if (shouldSort) {
      styles = sort(styles);
    }

    return styles;
  };

  parse.config = config;
  parse.propNames = Object.keys(config);
  parse.cache = cache;
  var keys = Object.keys(config).filter(function (k) {
    return k !== 'config';
  });

  if (keys.length > 1) {
    keys.forEach(function (key) {
      var _createParser;

      parse[key] = createParser((_createParser = {}, _createParser[key] = config[key], _createParser));
    });
  }

  return parse;
};

var parseResponsiveStyle = function parseResponsiveStyle(mediaQueries, sx, scale, raw, _props) {
  var styles = {};
  raw.slice(0, mediaQueries.length).forEach(function (value, i) {
    var media = mediaQueries[i];
    var style = sx(value, scale, _props);

    if (!media) {
      object_assign_default()(styles, style);
    } else {
      var _assign2;

      object_assign_default()(styles, (_assign2 = {}, _assign2[media] = object_assign_default()({}, styles[media], style), _assign2));
    }
  });
  return styles;
};

var parseResponsiveObject = function parseResponsiveObject(breakpoints, sx, scale, raw, _props) {
  var styles = {};

  for (var key in raw) {
    var breakpoint = breakpoints[key];
    var value = raw[key];
    var style = sx(value, scale, _props);

    if (!breakpoint) {
      object_assign_default()(styles, style);
    } else {
      var _assign3;

      var media = createMediaQuery(breakpoint);
      object_assign_default()(styles, (_assign3 = {}, _assign3[media] = object_assign_default()({}, styles[media], style), _assign3));
    }
  }

  return styles;
};

var createStyleFunction = function createStyleFunction(_ref) {
  var properties = _ref.properties,
      property = _ref.property,
      scale = _ref.scale,
      _ref$transform = _ref.transform,
      transform = _ref$transform === void 0 ? getValue : _ref$transform,
      defaultScale = _ref.defaultScale;
  properties = properties || [property];

  var sx = function sx(value, scale, _props) {
    var result = {};
    var n = transform(value, scale, _props);
    if (n === null) return;
    properties.forEach(function (prop) {
      result[prop] = n;
    });
    return result;
  };

  sx.scale = scale;
  sx.defaults = defaultScale;
  return sx;
}; // new v5 API

var system = function system(args) {
  if (args === void 0) {
    args = {};
  }

  var config = {};
  Object.keys(args).forEach(function (key) {
    var conf = args[key];

    if (conf === true) {
      // shortcut definition
      config[key] = createStyleFunction({
        property: key,
        scale: key
      });
      return;
    }

    if (typeof conf === 'function') {
      config[key] = conf;
      return;
    }

    config[key] = createStyleFunction(conf);
  });
  var parser = createParser(config);
  return parser;
};
var compose = function compose() {
  var config = {};

  for (var _len = arguments.length, parsers = new Array(_len), _key = 0; _key < _len; _key++) {
    parsers[_key] = arguments[_key];
  }

  parsers.forEach(function (parser) {
    if (!parser || !parser.config) return;
    object_assign_default()(config, parser.config);
  });
  var parser = createParser(config);
  return parser;
};

;// CONCATENATED MODULE: ./node_modules/@styled-system/layout/dist/index.esm.js


var isNumber = function isNumber(n) {
  return typeof n === 'number' && !isNaN(n);
};

var getWidth = function getWidth(n, scale) {
  return get(scale, n, !isNumber(n) || n > 1 ? n : n * 100 + '%');
};

var config = {
  width: {
    property: 'width',
    scale: 'sizes',
    transform: getWidth
  },
  height: {
    property: 'height',
    scale: 'sizes'
  },
  minWidth: {
    property: 'minWidth',
    scale: 'sizes'
  },
  minHeight: {
    property: 'minHeight',
    scale: 'sizes'
  },
  maxWidth: {
    property: 'maxWidth',
    scale: 'sizes'
  },
  maxHeight: {
    property: 'maxHeight',
    scale: 'sizes'
  },
  size: {
    properties: ['width', 'height'],
    scale: 'sizes'
  },
  overflow: true,
  overflowX: true,
  overflowY: true,
  display: true,
  verticalAlign: true
};
var layout = system(config);
/* harmony default export */ var index_esm = (layout);

;// CONCATENATED MODULE: ./node_modules/@styled-system/color/dist/index.esm.js

var index_esm_config = {
  color: {
    property: 'color',
    scale: 'colors'
  },
  backgroundColor: {
    property: 'backgroundColor',
    scale: 'colors'
  },
  opacity: true
};
index_esm_config.bg = index_esm_config.backgroundColor;
var color = system(index_esm_config);
/* harmony default export */ var dist_index_esm = (color);

;// CONCATENATED MODULE: ./node_modules/@styled-system/typography/dist/index.esm.js

var index_esm_defaults = {
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72]
};
var dist_index_esm_config = {
  fontFamily: {
    property: 'fontFamily',
    scale: 'fonts'
  },
  fontSize: {
    property: 'fontSize',
    scale: 'fontSizes',
    defaultScale: index_esm_defaults.fontSizes
  },
  fontWeight: {
    property: 'fontWeight',
    scale: 'fontWeights'
  },
  lineHeight: {
    property: 'lineHeight',
    scale: 'lineHeights'
  },
  letterSpacing: {
    property: 'letterSpacing',
    scale: 'letterSpacings'
  },
  textAlign: true,
  fontStyle: true
};
var typography = system(dist_index_esm_config);
/* harmony default export */ var typography_dist_index_esm = (typography);

;// CONCATENATED MODULE: ./node_modules/@styled-system/flexbox/dist/index.esm.js

var flexbox_dist_index_esm_config = {
  alignItems: true,
  alignContent: true,
  justifyItems: true,
  justifyContent: true,
  flexWrap: true,
  flexDirection: true,
  // item
  flex: true,
  flexGrow: true,
  flexShrink: true,
  flexBasis: true,
  justifySelf: true,
  alignSelf: true,
  order: true
};
var flexbox = system(flexbox_dist_index_esm_config);
/* harmony default export */ var flexbox_dist_index_esm = (flexbox);

;// CONCATENATED MODULE: ./node_modules/@styled-system/grid/dist/index.esm.js

var dist_index_esm_defaults = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
};
var grid_dist_index_esm_config = {
  gridGap: {
    property: 'gridGap',
    scale: 'space',
    defaultScale: dist_index_esm_defaults.space
  },
  gridColumnGap: {
    property: 'gridColumnGap',
    scale: 'space',
    defaultScale: dist_index_esm_defaults.space
  },
  gridRowGap: {
    property: 'gridRowGap',
    scale: 'space',
    defaultScale: dist_index_esm_defaults.space
  },
  gridColumn: true,
  gridRow: true,
  gridAutoFlow: true,
  gridAutoColumns: true,
  gridAutoRows: true,
  gridTemplateColumns: true,
  gridTemplateRows: true,
  gridTemplateAreas: true,
  gridArea: true
};
var grid = system(grid_dist_index_esm_config);
/* harmony default export */ var grid_dist_index_esm = (grid);

;// CONCATENATED MODULE: ./node_modules/@styled-system/border/dist/index.esm.js

var border_dist_index_esm_config = {
  border: {
    property: 'border',
    scale: 'borders'
  },
  borderWidth: {
    property: 'borderWidth',
    scale: 'borderWidths'
  },
  borderStyle: {
    property: 'borderStyle',
    scale: 'borderStyles'
  },
  borderColor: {
    property: 'borderColor',
    scale: 'colors'
  },
  borderRadius: {
    property: 'borderRadius',
    scale: 'radii'
  },
  borderTop: {
    property: 'borderTop',
    scale: 'borders'
  },
  borderTopLeftRadius: {
    property: 'borderTopLeftRadius',
    scale: 'radii'
  },
  borderTopRightRadius: {
    property: 'borderTopRightRadius',
    scale: 'radii'
  },
  borderRight: {
    property: 'borderRight',
    scale: 'borders'
  },
  borderBottom: {
    property: 'borderBottom',
    scale: 'borders'
  },
  borderBottomLeftRadius: {
    property: 'borderBottomLeftRadius',
    scale: 'radii'
  },
  borderBottomRightRadius: {
    property: 'borderBottomRightRadius',
    scale: 'radii'
  },
  borderLeft: {
    property: 'borderLeft',
    scale: 'borders'
  },
  borderX: {
    properties: ['borderLeft', 'borderRight'],
    scale: 'borders'
  },
  borderY: {
    properties: ['borderTop', 'borderBottom'],
    scale: 'borders'
  }
};
border_dist_index_esm_config.borderTopWidth = {
  property: 'borderTopWidth',
  scale: 'borderWidths'
};
border_dist_index_esm_config.borderTopColor = {
  property: 'borderTopColor',
  scale: 'colors'
};
border_dist_index_esm_config.borderTopStyle = {
  property: 'borderTopStyle',
  scale: 'borderStyles'
};
border_dist_index_esm_config.borderTopLeftRadius = {
  property: 'borderTopLeftRadius',
  scale: 'radii'
};
border_dist_index_esm_config.borderTopRightRadius = {
  property: 'borderTopRightRadius',
  scale: 'radii'
};
border_dist_index_esm_config.borderBottomWidth = {
  property: 'borderBottomWidth',
  scale: 'borderWidths'
};
border_dist_index_esm_config.borderBottomColor = {
  property: 'borderBottomColor',
  scale: 'colors'
};
border_dist_index_esm_config.borderBottomStyle = {
  property: 'borderBottomStyle',
  scale: 'borderStyles'
};
border_dist_index_esm_config.borderBottomLeftRadius = {
  property: 'borderBottomLeftRadius',
  scale: 'radii'
};
border_dist_index_esm_config.borderBottomRightRadius = {
  property: 'borderBottomRightRadius',
  scale: 'radii'
};
border_dist_index_esm_config.borderLeftWidth = {
  property: 'borderLeftWidth',
  scale: 'borderWidths'
};
border_dist_index_esm_config.borderLeftColor = {
  property: 'borderLeftColor',
  scale: 'colors'
};
border_dist_index_esm_config.borderLeftStyle = {
  property: 'borderLeftStyle',
  scale: 'borderStyles'
};
border_dist_index_esm_config.borderRightWidth = {
  property: 'borderRightWidth',
  scale: 'borderWidths'
};
border_dist_index_esm_config.borderRightColor = {
  property: 'borderRightColor',
  scale: 'colors'
};
border_dist_index_esm_config.borderRightStyle = {
  property: 'borderRightStyle',
  scale: 'borderStyles'
};
var border = system(border_dist_index_esm_config);
/* harmony default export */ var border_dist_index_esm = (border);

;// CONCATENATED MODULE: ./node_modules/@styled-system/background/dist/index.esm.js

var background_dist_index_esm_config = {
  background: true,
  backgroundImage: true,
  backgroundSize: true,
  backgroundPosition: true,
  backgroundRepeat: true
};
background_dist_index_esm_config.bgImage = background_dist_index_esm_config.backgroundImage;
background_dist_index_esm_config.bgSize = background_dist_index_esm_config.backgroundSize;
background_dist_index_esm_config.bgPosition = background_dist_index_esm_config.backgroundPosition;
background_dist_index_esm_config.bgRepeat = background_dist_index_esm_config.backgroundRepeat;
var background = system(background_dist_index_esm_config);
/* harmony default export */ var background_dist_index_esm = (background);

;// CONCATENATED MODULE: ./node_modules/@styled-system/position/dist/index.esm.js

var position_dist_index_esm_defaults = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
};
var position_dist_index_esm_config = {
  position: true,
  zIndex: {
    property: 'zIndex',
    scale: 'zIndices'
  },
  top: {
    property: 'top',
    scale: 'space',
    defaultScale: position_dist_index_esm_defaults.space
  },
  right: {
    property: 'right',
    scale: 'space',
    defaultScale: position_dist_index_esm_defaults.space
  },
  bottom: {
    property: 'bottom',
    scale: 'space',
    defaultScale: position_dist_index_esm_defaults.space
  },
  left: {
    property: 'left',
    scale: 'space',
    defaultScale: position_dist_index_esm_defaults.space
  }
};
var position = system(position_dist_index_esm_config);
/* harmony default export */ var position_dist_index_esm = (position);

;// CONCATENATED MODULE: ./node_modules/@styled-system/space/dist/index.esm.js

var space_dist_index_esm_defaults = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
};

var index_esm_isNumber = function isNumber(n) {
  return typeof n === 'number' && !isNaN(n);
};

var getMargin = function getMargin(n, scale) {
  if (!index_esm_isNumber(n)) {
    return get(scale, n, n);
  }

  var isNegative = n < 0;
  var absolute = Math.abs(n);
  var value = get(scale, absolute, absolute);

  if (!index_esm_isNumber(value)) {
    return isNegative ? '-' + value : value;
  }

  return value * (isNegative ? -1 : 1);
};

var configs = {};
configs.margin = {
  margin: {
    property: 'margin',
    scale: 'space',
    transform: getMargin,
    defaultScale: space_dist_index_esm_defaults.space
  },
  marginTop: {
    property: 'marginTop',
    scale: 'space',
    transform: getMargin,
    defaultScale: space_dist_index_esm_defaults.space
  },
  marginRight: {
    property: 'marginRight',
    scale: 'space',
    transform: getMargin,
    defaultScale: space_dist_index_esm_defaults.space
  },
  marginBottom: {
    property: 'marginBottom',
    scale: 'space',
    transform: getMargin,
    defaultScale: space_dist_index_esm_defaults.space
  },
  marginLeft: {
    property: 'marginLeft',
    scale: 'space',
    transform: getMargin,
    defaultScale: space_dist_index_esm_defaults.space
  },
  marginX: {
    properties: ['marginLeft', 'marginRight'],
    scale: 'space',
    transform: getMargin,
    defaultScale: space_dist_index_esm_defaults.space
  },
  marginY: {
    properties: ['marginTop', 'marginBottom'],
    scale: 'space',
    transform: getMargin,
    defaultScale: space_dist_index_esm_defaults.space
  }
};
configs.margin.m = configs.margin.margin;
configs.margin.mt = configs.margin.marginTop;
configs.margin.mr = configs.margin.marginRight;
configs.margin.mb = configs.margin.marginBottom;
configs.margin.ml = configs.margin.marginLeft;
configs.margin.mx = configs.margin.marginX;
configs.margin.my = configs.margin.marginY;
configs.padding = {
  padding: {
    property: 'padding',
    scale: 'space',
    defaultScale: space_dist_index_esm_defaults.space
  },
  paddingTop: {
    property: 'paddingTop',
    scale: 'space',
    defaultScale: space_dist_index_esm_defaults.space
  },
  paddingRight: {
    property: 'paddingRight',
    scale: 'space',
    defaultScale: space_dist_index_esm_defaults.space
  },
  paddingBottom: {
    property: 'paddingBottom',
    scale: 'space',
    defaultScale: space_dist_index_esm_defaults.space
  },
  paddingLeft: {
    property: 'paddingLeft',
    scale: 'space',
    defaultScale: space_dist_index_esm_defaults.space
  },
  paddingX: {
    properties: ['paddingLeft', 'paddingRight'],
    scale: 'space',
    defaultScale: space_dist_index_esm_defaults.space
  },
  paddingY: {
    properties: ['paddingTop', 'paddingBottom'],
    scale: 'space',
    defaultScale: space_dist_index_esm_defaults.space
  }
};
configs.padding.p = configs.padding.padding;
configs.padding.pt = configs.padding.paddingTop;
configs.padding.pr = configs.padding.paddingRight;
configs.padding.pb = configs.padding.paddingBottom;
configs.padding.pl = configs.padding.paddingLeft;
configs.padding.px = configs.padding.paddingX;
configs.padding.py = configs.padding.paddingY;
var margin = system(configs.margin);
var padding = system(configs.padding);
var space = compose(margin, padding);
/* harmony default export */ var space_dist_index_esm = ((/* unused pure expression or super */ null && (space)));

;// CONCATENATED MODULE: ./node_modules/@styled-system/shadow/dist/index.esm.js

var shadow = system({
  boxShadow: {
    property: 'boxShadow',
    scale: 'shadows'
  },
  textShadow: {
    property: 'textShadow',
    scale: 'shadows'
  }
});
/* harmony default export */ var shadow_dist_index_esm = (shadow);

// EXTERNAL MODULE: ./node_modules/@styled-system/css/dist/index.esm.js
var css_dist_index_esm = __webpack_require__(37947);
;// CONCATENATED MODULE: ./node_modules/@styled-system/variant/dist/index.esm.js


var variant = function variant(_ref) {
  var _config;

  var scale = _ref.scale,
      _ref$prop = _ref.prop,
      prop = _ref$prop === void 0 ? 'variant' : _ref$prop,
      _ref$variants = _ref.variants,
      variants = _ref$variants === void 0 ? {} : _ref$variants,
      key = _ref.key;
  var sx;

  if (Object.keys(variants).length) {
    sx = function sx(value, scale, props) {
      return (0,css_dist_index_esm["default"])(get(scale, value, null))(props.theme);
    };
  } else {
    sx = function sx(value, scale) {
      return get(scale, value, null);
    };
  }

  sx.scale = scale || key;
  sx.defaults = variants;
  var config = (_config = {}, _config[prop] = sx, _config);
  var parser = createParser(config);
  return parser;
};
/* harmony default export */ var variant_dist_index_esm = ((/* unused pure expression or super */ null && (variant)));
var buttonStyle = variant({
  key: 'buttons'
});
var textStyle = variant({
  key: 'textStyles',
  prop: 'textStyle'
});
var colorStyle = variant({
  key: 'colorStyles',
  prop: 'colors'
});

;// CONCATENATED MODULE: ./node_modules/styled-system/dist/index.esm.js
 // v4 api shims






















var width = index_esm.width,
    height = index_esm.height,
    minWidth = index_esm.minWidth,
    minHeight = index_esm.minHeight,
    maxWidth = index_esm.maxWidth,
    maxHeight = index_esm.maxHeight,
    size = index_esm.size,
    verticalAlign = index_esm.verticalAlign,
    display = index_esm.display,
    overflow = index_esm.overflow,
    overflowX = index_esm.overflowX,
    overflowY = index_esm.overflowY;
var opacity = dist_index_esm.opacity;
var fontSize = typography_dist_index_esm.fontSize,
    fontFamily = typography_dist_index_esm.fontFamily,
    fontWeight = typography_dist_index_esm.fontWeight,
    lineHeight = typography_dist_index_esm.lineHeight,
    textAlign = typography_dist_index_esm.textAlign,
    fontStyle = typography_dist_index_esm.fontStyle,
    letterSpacing = typography_dist_index_esm.letterSpacing;
var alignItems = flexbox_dist_index_esm.alignItems,
    alignContent = flexbox_dist_index_esm.alignContent,
    justifyItems = flexbox_dist_index_esm.justifyItems,
    justifyContent = flexbox_dist_index_esm.justifyContent,
    flexWrap = flexbox_dist_index_esm.flexWrap,
    flexDirection = flexbox_dist_index_esm.flexDirection,
    flex = flexbox_dist_index_esm.flex,
    flexGrow = flexbox_dist_index_esm.flexGrow,
    flexShrink = flexbox_dist_index_esm.flexShrink,
    flexBasis = flexbox_dist_index_esm.flexBasis,
    justifySelf = flexbox_dist_index_esm.justifySelf,
    alignSelf = flexbox_dist_index_esm.alignSelf,
    order = flexbox_dist_index_esm.order;
var gridGap = grid_dist_index_esm.gridGap,
    gridColumnGap = grid_dist_index_esm.gridColumnGap,
    gridRowGap = grid_dist_index_esm.gridRowGap,
    gridColumn = grid_dist_index_esm.gridColumn,
    gridRow = grid_dist_index_esm.gridRow,
    gridAutoFlow = grid_dist_index_esm.gridAutoFlow,
    gridAutoColumns = grid_dist_index_esm.gridAutoColumns,
    gridAutoRows = grid_dist_index_esm.gridAutoRows,
    gridTemplateColumns = grid_dist_index_esm.gridTemplateColumns,
    gridTemplateRows = grid_dist_index_esm.gridTemplateRows,
    gridTemplateAreas = grid_dist_index_esm.gridTemplateAreas,
    gridArea = grid_dist_index_esm.gridArea;
var borderWidth = border_dist_index_esm.borderWidth,
    borderStyle = border_dist_index_esm.borderStyle,
    borderColor = border_dist_index_esm.borderColor,
    borderTop = border_dist_index_esm.borderTop,
    borderRight = border_dist_index_esm.borderRight,
    borderBottom = border_dist_index_esm.borderBottom,
    borderLeft = border_dist_index_esm.borderLeft,
    borderRadius = border_dist_index_esm.borderRadius;
var backgroundImage = background_dist_index_esm.backgroundImage,
    backgroundSize = background_dist_index_esm.backgroundSize,
    backgroundPosition = background_dist_index_esm.backgroundPosition,
    backgroundRepeat = background_dist_index_esm.backgroundRepeat;
var zIndex = position_dist_index_esm.zIndex,
    index_esm_top = position_dist_index_esm.top,
    right = position_dist_index_esm.right,
    bottom = position_dist_index_esm.bottom,
    left = position_dist_index_esm.left;

 // v4 style API shim

var style = function style(_ref) {
  var prop = _ref.prop,
      cssProperty = _ref.cssProperty,
      alias = _ref.alias,
      key = _ref.key,
      transformValue = _ref.transformValue,
      scale = _ref.scale,
      properties = _ref.properties;
  var config = {};
  config[prop] = createStyleFunction({
    properties: properties,
    property: cssProperty || prop,
    scale: key,
    defaultScale: scale,
    transform: transformValue
  });
  if (alias) config[alias] = config[prop];
  var parse = createParser(config);
  return parse;
};


/***/ }),

/***/ 71427:
/***/ (function(module) {

(function (factory) {
	 true ? (module['exports'] = factory()) :
		0
}(function () {

	'use strict'

	return function (insertRule) {
		var delimiter = '/*|*/'
		var needle = delimiter+'}'

		function toSheet (block) {
			if (block)
				try {
					insertRule(block + '}')
				} catch (e) {}
		}

		return function ruleSheet (context, content, selectors, parents, line, column, length, ns, depth, at) {
			switch (context) {
				// property
				case 1:
					// @import
					if (depth === 0 && content.charCodeAt(0) === 64)
						return insertRule(content+';'), ''
					break
				// selector
				case 2:
					if (ns === 0)
						return content + delimiter
					break
				// at-rule
				case 3:
					switch (ns) {
						// @font-face, @page
						case 102:
						case 112:
							return insertRule(selectors[0]+content), ''
						default:
							return content + (at === 0 ? delimiter : '')
					}
				case -2:
					content.split(needle).forEach(toSheet)
			}
		}
	}
}))


/***/ }),

/***/ 21746:
/***/ (function(module) {

!function(e){ true?module.exports=e(null):0}(function e(a){"use strict";var r=/^\0+/g,c=/[\0\r\f]/g,s=/: */g,t=/zoo|gra/,i=/([,: ])(transform)/g,f=/,+\s*(?![^(]*[)])/g,n=/ +\s*(?![^(]*[)])/g,l=/ *[\0] */g,o=/,\r+?/g,h=/([\t\r\n ])*\f?&/g,u=/:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g,d=/\W+/g,b=/@(k\w+)\s*(\S*)\s*/,p=/::(place)/g,k=/:(read-only)/g,g=/\s+(?=[{\];=:>])/g,A=/([[}=:>])\s+/g,C=/(\{[^{]+?);(?=\})/g,w=/\s{2,}/g,v=/([^\(])(:+) */g,m=/[svh]\w+-[tblr]{2}/,x=/\(\s*(.*)\s*\)/g,$=/([\s\S]*?);/g,y=/-self|flex-/g,O=/[^]*?(:[rp][el]a[\w-]+)[^]*/,j=/stretch|:\s*\w+\-(?:conte|avail)/,z=/([^-])(image-set\()/,N="-webkit-",S="-moz-",F="-ms-",W=59,q=125,B=123,D=40,E=41,G=91,H=93,I=10,J=13,K=9,L=64,M=32,P=38,Q=45,R=95,T=42,U=44,V=58,X=39,Y=34,Z=47,_=62,ee=43,ae=126,re=0,ce=12,se=11,te=107,ie=109,fe=115,ne=112,le=111,oe=105,he=99,ue=100,de=112,be=1,pe=1,ke=0,ge=1,Ae=1,Ce=1,we=0,ve=0,me=0,xe=[],$e=[],ye=0,Oe=null,je=-2,ze=-1,Ne=0,Se=1,Fe=2,We=3,qe=0,Be=1,De="",Ee="",Ge="";function He(e,a,s,t,i){for(var f,n,o=0,h=0,u=0,d=0,g=0,A=0,C=0,w=0,m=0,$=0,y=0,O=0,j=0,z=0,R=0,we=0,$e=0,Oe=0,je=0,ze=s.length,Je=ze-1,Re="",Te="",Ue="",Ve="",Xe="",Ye="";R<ze;){if(C=s.charCodeAt(R),R===Je)if(h+d+u+o!==0){if(0!==h)C=h===Z?I:Z;d=u=o=0,ze++,Je++}if(h+d+u+o===0){if(R===Je){if(we>0)Te=Te.replace(c,"");if(Te.trim().length>0){switch(C){case M:case K:case W:case J:case I:break;default:Te+=s.charAt(R)}C=W}}if(1===$e)switch(C){case B:case q:case W:case Y:case X:case D:case E:case U:$e=0;case K:case J:case I:case M:break;default:for($e=0,je=R,g=C,R--,C=W;je<ze;)switch(s.charCodeAt(je++)){case I:case J:case W:++R,C=g,je=ze;break;case V:if(we>0)++R,C=g;case B:je=ze}}switch(C){case B:for(g=(Te=Te.trim()).charCodeAt(0),y=1,je=++R;R<ze;){switch(C=s.charCodeAt(R)){case B:y++;break;case q:y--;break;case Z:switch(A=s.charCodeAt(R+1)){case T:case Z:R=Qe(A,R,Je,s)}break;case G:C++;case D:C++;case Y:case X:for(;R++<Je&&s.charCodeAt(R)!==C;);}if(0===y)break;R++}if(Ue=s.substring(je,R),g===re)g=(Te=Te.replace(r,"").trim()).charCodeAt(0);switch(g){case L:if(we>0)Te=Te.replace(c,"");switch(A=Te.charCodeAt(1)){case ue:case ie:case fe:case Q:f=a;break;default:f=xe}if(je=(Ue=He(a,f,Ue,A,i+1)).length,me>0&&0===je)je=Te.length;if(ye>0)if(f=Ie(xe,Te,Oe),n=Pe(We,Ue,f,a,pe,be,je,A,i,t),Te=f.join(""),void 0!==n)if(0===(je=(Ue=n.trim()).length))A=0,Ue="";if(je>0)switch(A){case fe:Te=Te.replace(x,Me);case ue:case ie:case Q:Ue=Te+"{"+Ue+"}";break;case te:if(Ue=(Te=Te.replace(b,"$1 $2"+(Be>0?De:"")))+"{"+Ue+"}",1===Ae||2===Ae&&Le("@"+Ue,3))Ue="@"+N+Ue+"@"+Ue;else Ue="@"+Ue;break;default:if(Ue=Te+Ue,t===de)Ve+=Ue,Ue=""}else Ue="";break;default:Ue=He(a,Ie(a,Te,Oe),Ue,t,i+1)}Xe+=Ue,O=0,$e=0,z=0,we=0,Oe=0,j=0,Te="",Ue="",C=s.charCodeAt(++R);break;case q:case W:if((je=(Te=(we>0?Te.replace(c,""):Te).trim()).length)>1){if(0===z)if((g=Te.charCodeAt(0))===Q||g>96&&g<123)je=(Te=Te.replace(" ",":")).length;if(ye>0)if(void 0!==(n=Pe(Se,Te,a,e,pe,be,Ve.length,t,i,t)))if(0===(je=(Te=n.trim()).length))Te="\0\0";switch(g=Te.charCodeAt(0),A=Te.charCodeAt(1),g){case re:break;case L:if(A===oe||A===he){Ye+=Te+s.charAt(R);break}default:if(Te.charCodeAt(je-1)===V)break;Ve+=Ke(Te,g,A,Te.charCodeAt(2))}}O=0,$e=0,z=0,we=0,Oe=0,Te="",C=s.charCodeAt(++R)}}switch(C){case J:case I:if(h+d+u+o+ve===0)switch($){case E:case X:case Y:case L:case ae:case _:case T:case ee:case Z:case Q:case V:case U:case W:case B:case q:break;default:if(z>0)$e=1}if(h===Z)h=0;else if(ge+O===0&&t!==te&&Te.length>0)we=1,Te+="\0";if(ye*qe>0)Pe(Ne,Te,a,e,pe,be,Ve.length,t,i,t);be=1,pe++;break;case W:case q:if(h+d+u+o===0){be++;break}default:switch(be++,Re=s.charAt(R),C){case K:case M:if(d+o+h===0)switch(w){case U:case V:case K:case M:Re="";break;default:if(C!==M)Re=" "}break;case re:Re="\\0";break;case ce:Re="\\f";break;case se:Re="\\v";break;case P:if(d+h+o===0&&ge>0)Oe=1,we=1,Re="\f"+Re;break;case 108:if(d+h+o+ke===0&&z>0)switch(R-z){case 2:if(w===ne&&s.charCodeAt(R-3)===V)ke=w;case 8:if(m===le)ke=m}break;case V:if(d+h+o===0)z=R;break;case U:if(h+u+d+o===0)we=1,Re+="\r";break;case Y:case X:if(0===h)d=d===C?0:0===d?C:d;break;case G:if(d+h+u===0)o++;break;case H:if(d+h+u===0)o--;break;case E:if(d+h+o===0)u--;break;case D:if(d+h+o===0){if(0===O)switch(2*w+3*m){case 533:break;default:y=0,O=1}u++}break;case L:if(h+u+d+o+z+j===0)j=1;break;case T:case Z:if(d+o+u>0)break;switch(h){case 0:switch(2*C+3*s.charCodeAt(R+1)){case 235:h=Z;break;case 220:je=R,h=T}break;case T:if(C===Z&&w===T&&je+2!==R){if(33===s.charCodeAt(je+2))Ve+=s.substring(je,R+1);Re="",h=0}}}if(0===h){if(ge+d+o+j===0&&t!==te&&C!==W)switch(C){case U:case ae:case _:case ee:case E:case D:if(0===O){switch(w){case K:case M:case I:case J:Re+="\0";break;default:Re="\0"+Re+(C===U?"":"\0")}we=1}else switch(C){case D:if(z+7===R&&108===w)z=0;O=++y;break;case E:if(0==(O=--y))we=1,Re+="\0"}break;case K:case M:switch(w){case re:case B:case q:case W:case U:case ce:case K:case M:case I:case J:break;default:if(0===O)we=1,Re+="\0"}}if(Te+=Re,C!==M&&C!==K)$=C}}m=w,w=C,R++}if(je=Ve.length,me>0)if(0===je&&0===Xe.length&&0===a[0].length==false)if(t!==ie||1===a.length&&(ge>0?Ee:Ge)===a[0])je=a.join(",").length+2;if(je>0){if(f=0===ge&&t!==te?function(e){for(var a,r,s=0,t=e.length,i=Array(t);s<t;++s){for(var f=e[s].split(l),n="",o=0,h=0,u=0,d=0,b=f.length;o<b;++o){if(0===(h=(r=f[o]).length)&&b>1)continue;if(u=n.charCodeAt(n.length-1),d=r.charCodeAt(0),a="",0!==o)switch(u){case T:case ae:case _:case ee:case M:case D:break;default:a=" "}switch(d){case P:r=a+Ee;case ae:case _:case ee:case M:case E:case D:break;case G:r=a+r+Ee;break;case V:switch(2*r.charCodeAt(1)+3*r.charCodeAt(2)){case 530:if(Ce>0){r=a+r.substring(8,h-1);break}default:if(o<1||f[o-1].length<1)r=a+Ee+r}break;case U:a="";default:if(h>1&&r.indexOf(":")>0)r=a+r.replace(v,"$1"+Ee+"$2");else r=a+r+Ee}n+=r}i[s]=n.replace(c,"").trim()}return i}(a):a,ye>0)if(void 0!==(n=Pe(Fe,Ve,f,e,pe,be,je,t,i,t))&&0===(Ve=n).length)return Ye+Ve+Xe;if(Ve=f.join(",")+"{"+Ve+"}",Ae*ke!=0){if(2===Ae&&!Le(Ve,2))ke=0;switch(ke){case le:Ve=Ve.replace(k,":"+S+"$1")+Ve;break;case ne:Ve=Ve.replace(p,"::"+N+"input-$1")+Ve.replace(p,"::"+S+"$1")+Ve.replace(p,":"+F+"input-$1")+Ve}ke=0}}return Ye+Ve+Xe}function Ie(e,a,r){var c=a.trim().split(o),s=c,t=c.length,i=e.length;switch(i){case 0:case 1:for(var f=0,n=0===i?"":e[0]+" ";f<t;++f)s[f]=Je(n,s[f],r,i).trim();break;default:f=0;var l=0;for(s=[];f<t;++f)for(var h=0;h<i;++h)s[l++]=Je(e[h]+" ",c[f],r,i).trim()}return s}function Je(e,a,r,c){var s=a,t=s.charCodeAt(0);if(t<33)t=(s=s.trim()).charCodeAt(0);switch(t){case P:switch(ge+c){case 0:case 1:if(0===e.trim().length)break;default:return s.replace(h,"$1"+e.trim())}break;case V:switch(s.charCodeAt(1)){case 103:if(Ce>0&&ge>0)return s.replace(u,"$1").replace(h,"$1"+Ge);break;default:return e.trim()+s.replace(h,"$1"+e.trim())}default:if(r*ge>0&&s.indexOf("\f")>0)return s.replace(h,(e.charCodeAt(0)===V?"":"$1")+e.trim())}return e+s}function Ke(e,a,r,c){var l,o=0,h=e+";",u=2*a+3*r+4*c;if(944===u)return function(e){var a=e.length,r=e.indexOf(":",9)+1,c=e.substring(0,r).trim(),s=e.substring(r,a-1).trim();switch(e.charCodeAt(9)*Be){case 0:break;case Q:if(110!==e.charCodeAt(10))break;default:for(var t=s.split((s="",f)),i=0,r=0,a=t.length;i<a;r=0,++i){for(var l=t[i],o=l.split(n);l=o[r];){var h=l.charCodeAt(0);if(1===Be&&(h>L&&h<90||h>96&&h<123||h===R||h===Q&&l.charCodeAt(1)!==Q))switch(isNaN(parseFloat(l))+(-1!==l.indexOf("("))){case 1:switch(l){case"infinite":case"alternate":case"backwards":case"running":case"normal":case"forwards":case"both":case"none":case"linear":case"ease":case"ease-in":case"ease-out":case"ease-in-out":case"paused":case"reverse":case"alternate-reverse":case"inherit":case"initial":case"unset":case"step-start":case"step-end":break;default:l+=De}}o[r++]=l}s+=(0===i?"":",")+o.join(" ")}}if(s=c+s+";",1===Ae||2===Ae&&Le(s,1))return N+s+s;return s}(h);else if(0===Ae||2===Ae&&!Le(h,1))return h;switch(u){case 1015:return 97===h.charCodeAt(10)?N+h+h:h;case 951:return 116===h.charCodeAt(3)?N+h+h:h;case 963:return 110===h.charCodeAt(5)?N+h+h:h;case 1009:if(100!==h.charCodeAt(4))break;case 969:case 942:return N+h+h;case 978:return N+h+S+h+h;case 1019:case 983:return N+h+S+h+F+h+h;case 883:if(h.charCodeAt(8)===Q)return N+h+h;if(h.indexOf("image-set(",11)>0)return h.replace(z,"$1"+N+"$2")+h;return h;case 932:if(h.charCodeAt(4)===Q)switch(h.charCodeAt(5)){case 103:return N+"box-"+h.replace("-grow","")+N+h+F+h.replace("grow","positive")+h;case 115:return N+h+F+h.replace("shrink","negative")+h;case 98:return N+h+F+h.replace("basis","preferred-size")+h}return N+h+F+h+h;case 964:return N+h+F+"flex-"+h+h;case 1023:if(99!==h.charCodeAt(8))break;return l=h.substring(h.indexOf(":",15)).replace("flex-","").replace("space-between","justify"),N+"box-pack"+l+N+h+F+"flex-pack"+l+h;case 1005:return t.test(h)?h.replace(s,":"+N)+h.replace(s,":"+S)+h:h;case 1e3:switch(o=(l=h.substring(13).trim()).indexOf("-")+1,l.charCodeAt(0)+l.charCodeAt(o)){case 226:l=h.replace(m,"tb");break;case 232:l=h.replace(m,"tb-rl");break;case 220:l=h.replace(m,"lr");break;default:return h}return N+h+F+l+h;case 1017:if(-1===h.indexOf("sticky",9))return h;case 975:switch(o=(h=e).length-10,u=(l=(33===h.charCodeAt(o)?h.substring(0,o):h).substring(e.indexOf(":",7)+1).trim()).charCodeAt(0)+(0|l.charCodeAt(7))){case 203:if(l.charCodeAt(8)<111)break;case 115:h=h.replace(l,N+l)+";"+h;break;case 207:case 102:h=h.replace(l,N+(u>102?"inline-":"")+"box")+";"+h.replace(l,N+l)+";"+h.replace(l,F+l+"box")+";"+h}return h+";";case 938:if(h.charCodeAt(5)===Q)switch(h.charCodeAt(6)){case 105:return l=h.replace("-items",""),N+h+N+"box-"+l+F+"flex-"+l+h;case 115:return N+h+F+"flex-item-"+h.replace(y,"")+h;default:return N+h+F+"flex-line-pack"+h.replace("align-content","").replace(y,"")+h}break;case 973:case 989:if(h.charCodeAt(3)!==Q||122===h.charCodeAt(4))break;case 931:case 953:if(true===j.test(e))if(115===(l=e.substring(e.indexOf(":")+1)).charCodeAt(0))return Ke(e.replace("stretch","fill-available"),a,r,c).replace(":fill-available",":stretch");else return h.replace(l,N+l)+h.replace(l,S+l.replace("fill-",""))+h;break;case 962:if(h=N+h+(102===h.charCodeAt(5)?F+h:"")+h,r+c===211&&105===h.charCodeAt(13)&&h.indexOf("transform",10)>0)return h.substring(0,h.indexOf(";",27)+1).replace(i,"$1"+N+"$2")+h}return h}function Le(e,a){var r=e.indexOf(1===a?":":"{"),c=e.substring(0,3!==a?r:10),s=e.substring(r+1,e.length-1);return Oe(2!==a?c:c.replace(O,"$1"),s,a)}function Me(e,a){var r=Ke(a,a.charCodeAt(0),a.charCodeAt(1),a.charCodeAt(2));return r!==a+";"?r.replace($," or ($1)").substring(4):"("+a+")"}function Pe(e,a,r,c,s,t,i,f,n,l){for(var o,h=0,u=a;h<ye;++h)switch(o=$e[h].call(Te,e,u,r,c,s,t,i,f,n,l)){case void 0:case false:case true:case null:break;default:u=o}if(u!==a)return u}function Qe(e,a,r,c){for(var s=a+1;s<r;++s)switch(c.charCodeAt(s)){case Z:if(e===T)if(c.charCodeAt(s-1)===T&&a+2!==s)return s+1;break;case I:if(e===Z)return s+1}return s}function Re(e){for(var a in e){var r=e[a];switch(a){case"keyframe":Be=0|r;break;case"global":Ce=0|r;break;case"cascade":ge=0|r;break;case"compress":we=0|r;break;case"semicolon":ve=0|r;break;case"preserve":me=0|r;break;case"prefix":if(Oe=null,!r)Ae=0;else if("function"!=typeof r)Ae=1;else Ae=2,Oe=r}}return Re}function Te(a,r){if(void 0!==this&&this.constructor===Te)return e(a);var s=a,t=s.charCodeAt(0);if(t<33)t=(s=s.trim()).charCodeAt(0);if(Be>0)De=s.replace(d,t===G?"":"-");if(t=1,1===ge)Ge=s;else Ee=s;var i,f=[Ge];if(ye>0)if(void 0!==(i=Pe(ze,r,f,f,pe,be,0,0,0,0))&&"string"==typeof i)r=i;var n=He(xe,f,r,0,0);if(ye>0)if(void 0!==(i=Pe(je,n,f,f,pe,be,n.length,0,0,0))&&"string"!=typeof(n=i))t=0;return De="",Ge="",Ee="",ke=0,pe=1,be=1,we*t==0?n:n.replace(c,"").replace(g,"").replace(A,"$1").replace(C,"$1").replace(w," ")}if(Te.use=function e(a){switch(a){case void 0:case null:ye=$e.length=0;break;default:if("function"==typeof a)$e[ye++]=a;else if("object"==typeof a)for(var r=0,c=a.length;r<c;++r)e(a[r]);else qe=0|!!a}return e},Te.set=Re,void 0!==a)Re(a);return Te});
//# sourceMappingURL=stylis.min.js.map

/***/ }),

/***/ 70655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jh": function() { return /* binding */ __generator; },
/* harmony export */   "ZT": function() { return /* binding */ __extends; },
/* harmony export */   "_T": function() { return /* binding */ __rest; },
/* harmony export */   "ev": function() { return /* binding */ __spreadArray; },
/* harmony export */   "mG": function() { return /* binding */ __awaiter; },
/* harmony export */   "pi": function() { return /* binding */ __assign; }
/* harmony export */ });
/* unused harmony exports __decorate, __param, __metadata, __createBinding, __exportStar, __values, __read, __spread, __spreadArrays, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault, __classPrivateFieldGet, __classPrivateFieldSet, __classPrivateFieldIn */
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}


/***/ }),

/***/ 42238:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * UAParser.js v0.7.20
 * Lightweight JavaScript-based User-Agent string parser
 * https://github.com/faisalman/ua-parser-js
 *
 * Copyright © 2012-2019 Faisal Salman <f@faisalman.com>
 * Licensed under MIT License
 */

(function (window, undefined) {

    'use strict';

    //////////////
    // Constants
    /////////////


    var LIBVERSION  = '0.7.20',
        EMPTY       = '',
        UNKNOWN     = '?',
        FUNC_TYPE   = 'function',
        UNDEF_TYPE  = 'undefined',
        OBJ_TYPE    = 'object',
        STR_TYPE    = 'string',
        MAJOR       = 'major', // deprecated
        MODEL       = 'model',
        NAME        = 'name',
        TYPE        = 'type',
        VENDOR      = 'vendor',
        VERSION     = 'version',
        ARCHITECTURE= 'architecture',
        CONSOLE     = 'console',
        MOBILE      = 'mobile',
        TABLET      = 'tablet',
        SMARTTV     = 'smarttv',
        WEARABLE    = 'wearable',
        EMBEDDED    = 'embedded';


    ///////////
    // Helper
    //////////


    var util = {
        extend : function (regexes, extensions) {
            var mergedRegexes = {};
            for (var i in regexes) {
                if (extensions[i] && extensions[i].length % 2 === 0) {
                    mergedRegexes[i] = extensions[i].concat(regexes[i]);
                } else {
                    mergedRegexes[i] = regexes[i];
                }
            }
            return mergedRegexes;
        },
        has : function (str1, str2) {
          if (typeof str1 === "string") {
            return str2.toLowerCase().indexOf(str1.toLowerCase()) !== -1;
          } else {
            return false;
          }
        },
        lowerize : function (str) {
            return str.toLowerCase();
        },
        major : function (version) {
            return typeof(version) === STR_TYPE ? version.replace(/[^\d\.]/g,'').split(".")[0] : undefined;
        },
        trim : function (str) {
          return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
        }
    };


    ///////////////
    // Map helper
    //////////////


    var mapper = {

        rgx : function (ua, arrays) {

            var i = 0, j, k, p, q, matches, match;

            // loop through all regexes maps
            while (i < arrays.length && !matches) {

                var regex = arrays[i],       // even sequence (0,2,4,..)
                    props = arrays[i + 1];   // odd sequence (1,3,5,..)
                j = k = 0;

                // try matching uastring with regexes
                while (j < regex.length && !matches) {

                    matches = regex[j++].exec(ua);

                    if (!!matches) {
                        for (p = 0; p < props.length; p++) {
                            match = matches[++k];
                            q = props[p];
                            // check if given property is actually array
                            if (typeof q === OBJ_TYPE && q.length > 0) {
                                if (q.length == 2) {
                                    if (typeof q[1] == FUNC_TYPE) {
                                        // assign modified match
                                        this[q[0]] = q[1].call(this, match);
                                    } else {
                                        // assign given value, ignore regex match
                                        this[q[0]] = q[1];
                                    }
                                } else if (q.length == 3) {
                                    // check whether function or regex
                                    if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                                        // call function (usually string mapper)
                                        this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                                    } else {
                                        // sanitize match using given regex
                                        this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                                    }
                                } else if (q.length == 4) {
                                        this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                                }
                            } else {
                                this[q] = match ? match : undefined;
                            }
                        }
                    }
                }
                i += 2;
            }
        },

        str : function (str, map) {

            for (var i in map) {
                // check if array
                if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
                    for (var j = 0; j < map[i].length; j++) {
                        if (util.has(map[i][j], str)) {
                            return (i === UNKNOWN) ? undefined : i;
                        }
                    }
                } else if (util.has(map[i], str)) {
                    return (i === UNKNOWN) ? undefined : i;
                }
            }
            return str;
        }
    };


    ///////////////
    // String map
    //////////////


    var maps = {

        browser : {
            oldsafari : {
                version : {
                    '1.0'   : '/8',
                    '1.2'   : '/1',
                    '1.3'   : '/3',
                    '2.0'   : '/412',
                    '2.0.2' : '/416',
                    '2.0.3' : '/417',
                    '2.0.4' : '/419',
                    '?'     : '/'
                }
            }
        },

        device : {
            amazon : {
                model : {
                    'Fire Phone' : ['SD', 'KF']
                }
            },
            sprint : {
                model : {
                    'Evo Shift 4G' : '7373KT'
                },
                vendor : {
                    'HTC'       : 'APA',
                    'Sprint'    : 'Sprint'
                }
            }
        },

        os : {
            windows : {
                version : {
                    'ME'        : '4.90',
                    'NT 3.11'   : 'NT3.51',
                    'NT 4.0'    : 'NT4.0',
                    '2000'      : 'NT 5.0',
                    'XP'        : ['NT 5.1', 'NT 5.2'],
                    'Vista'     : 'NT 6.0',
                    '7'         : 'NT 6.1',
                    '8'         : 'NT 6.2',
                    '8.1'       : 'NT 6.3',
                    '10'        : ['NT 6.4', 'NT 10.0'],
                    'RT'        : 'ARM'
                }
            }
        }
    };


    //////////////
    // Regex map
    /////////////


    var regexes = {

        browser : [[

            // Presto based
            /(opera\smini)\/([\w\.-]+)/i,                                       // Opera Mini
            /(opera\s[mobiletab]+).+version\/([\w\.-]+)/i,                      // Opera Mobi/Tablet
            /(opera).+version\/([\w\.]+)/i,                                     // Opera > 9.80
            /(opera)[\/\s]+([\w\.]+)/i                                          // Opera < 9.80
            ], [NAME, VERSION], [

            /(opios)[\/\s]+([\w\.]+)/i                                          // Opera mini on iphone >= 8.0
            ], [[NAME, 'Opera Mini'], VERSION], [

            /\s(opr)\/([\w\.]+)/i                                               // Opera Webkit
            ], [[NAME, 'Opera'], VERSION], [

            // Mixed
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]*)/i,
                                                                                // Lunascape/Maxthon/Netfront/Jasmine/Blazer

            // Trident based
            /(avant\s|iemobile|slim|baidu)(?:browser)?[\/\s]?([\w\.]*)/i,
                                                                                // Avant/IEMobile/SlimBrowser/Baidu
            /(?:ms|\()(ie)\s([\w\.]+)/i,                                        // Internet Explorer

            // Webkit/KHTML based
            /(rekonq)\/([\w\.]*)/i,                                             // Rekonq
            /(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon)\/([\w\.-]+)/i
                                                                                // Chromium/Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
            ], [NAME, VERSION], [

            /(konqueror)\/([\w\.]+)/i                                           // Konqueror
            ], [[NAME, 'Konqueror'], VERSION], [

            /(trident).+rv[:\s]([\w\.]+).+like\sgecko/i                         // IE11
            ], [[NAME, 'IE'], VERSION], [

            /(edge|edgios|edga|edg)\/((\d+)?[\w\.]+)/i                          // Microsoft Edge
            ], [[NAME, 'Edge'], VERSION], [

            /(yabrowser)\/([\w\.]+)/i                                           // Yandex
            ], [[NAME, 'Yandex'], VERSION], [

            /(puffin)\/([\w\.]+)/i                                              // Puffin
            ], [[NAME, 'Puffin'], VERSION], [

            /(focus)\/([\w\.]+)/i                                               // Firefox Focus
            ], [[NAME, 'Firefox Focus'], VERSION], [

            /(opt)\/([\w\.]+)/i                                                 // Opera Touch
            ], [[NAME, 'Opera Touch'], VERSION], [

            /((?:[\s\/])uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i         // UCBrowser
            ], [[NAME, 'UCBrowser'], VERSION], [

            /(comodo_dragon)\/([\w\.]+)/i                                       // Comodo Dragon
            ], [[NAME, /_/g, ' '], VERSION], [

            /(windowswechat qbcore)\/([\w\.]+)/i                                // WeChat Desktop for Windows Built-in Browser
            ], [[NAME, 'WeChat(Win) Desktop'], VERSION], [

            /(micromessenger)\/([\w\.]+)/i                                      // WeChat
            ], [[NAME, 'WeChat'], VERSION], [

            /(brave)\/([\w\.]+)/i                                              // Brave browser
            ], [[NAME, 'Brave'], VERSION], [

            /(qqbrowserlite)\/([\w\.]+)/i                                       // QQBrowserLite
            ], [NAME, VERSION], [

            /(QQ)\/([\d\.]+)/i                                                  // QQ, aka ShouQ
            ], [NAME, VERSION], [

            /m?(qqbrowser)[\/\s]?([\w\.]+)/i                                    // QQBrowser
            ], [NAME, VERSION], [

            /(BIDUBrowser)[\/\s]?([\w\.]+)/i                                    // Baidu Browser
            ], [NAME, VERSION], [

            /(2345Explorer)[\/\s]?([\w\.]+)/i                                   // 2345 Browser
            ], [NAME, VERSION], [

            /(MetaSr)[\/\s]?([\w\.]+)/i                                         // SouGouBrowser
            ], [NAME], [

            /(LBBROWSER)/i                                      // LieBao Browser
            ], [NAME], [

            /xiaomi\/miuibrowser\/([\w\.]+)/i                                   // MIUI Browser
            ], [VERSION, [NAME, 'MIUI Browser']], [

            /;fbav\/([\w\.]+);/i                                                // Facebook App for iOS & Android
            ], [VERSION, [NAME, 'Facebook']], [

            /safari\s(line)\/([\w\.]+)/i,                                       // Line App for iOS
            /android.+(line)\/([\w\.]+)\/iab/i                                  // Line App for Android
            ], [NAME, VERSION], [

            /headlesschrome(?:\/([\w\.]+)|\s)/i                                 // Chrome Headless
            ], [VERSION, [NAME, 'Chrome Headless']], [

            /\swv\).+(chrome)\/([\w\.]+)/i                                      // Chrome WebView
            ], [[NAME, /(.+)/, '$1 WebView'], VERSION], [

            /((?:oculus|samsung)browser)\/([\w\.]+)/i
            ], [[NAME, /(.+(?:g|us))(.+)/, '$1 $2'], VERSION], [                // Oculus / Samsung Browser

            /android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i        // Android Browser
            ], [VERSION, [NAME, 'Android Browser']], [

            /(sailfishbrowser)\/([\w\.]+)/i                                     // Sailfish Browser
            ], [[NAME, 'Sailfish Browser'], VERSION], [

            /(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i
                                                                                // Chrome/OmniWeb/Arora/Tizen/Nokia
            ], [NAME, VERSION], [

            /(dolfin)\/([\w\.]+)/i                                              // Dolphin
            ], [[NAME, 'Dolphin'], VERSION], [

            /((?:android.+)crmo|crios)\/([\w\.]+)/i                             // Chrome for Android/iOS
            ], [[NAME, 'Chrome'], VERSION], [

            /(coast)\/([\w\.]+)/i                                               // Opera Coast
            ], [[NAME, 'Opera Coast'], VERSION], [

            /fxios\/([\w\.-]+)/i                                                // Firefox for iOS
            ], [VERSION, [NAME, 'Firefox']], [

            /version\/([\w\.]+).+?mobile\/\w+\s(safari)/i                       // Mobile Safari
            ], [VERSION, [NAME, 'Mobile Safari']], [

            /version\/([\w\.]+).+?(mobile\s?safari|safari)/i                    // Safari & Safari Mobile
            ], [VERSION, NAME], [

            /webkit.+?(gsa)\/([\w\.]+).+?(mobile\s?safari|safari)(\/[\w\.]+)/i  // Google Search Appliance on iOS
            ], [[NAME, 'GSA'], VERSION], [

            /webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i                     // Safari < 3.0
            ], [NAME, [VERSION, mapper.str, maps.browser.oldsafari.version]], [

            /(webkit|khtml)\/([\w\.]+)/i
            ], [NAME, VERSION], [

            // Gecko based
            /(navigator|netscape)\/([\w\.-]+)/i                                 // Netscape
            ], [[NAME, 'Netscape'], VERSION], [
            /(swiftfox)/i,                                                      // Swiftfox
            /(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,
                                                                                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
            /(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([\w\.-]+)$/i,

                                                                                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
            /(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i,                          // Mozilla

            // Other
            /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,
                                                                                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir
            /(links)\s\(([\w\.]+)/i,                                            // Links
            /(gobrowser)\/?([\w\.]*)/i,                                         // GoBrowser
            /(ice\s?browser)\/v?([\w\._]+)/i,                                   // ICE Browser
            /(mosaic)[\/\s]([\w\.]+)/i                                          // Mosaic
            ], [NAME, VERSION]
        ],

        cpu : [[

            /(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i                     // AMD64
            ], [[ARCHITECTURE, 'amd64']], [

            /(ia32(?=;))/i                                                      // IA32 (quicktime)
            ], [[ARCHITECTURE, util.lowerize]], [

            /((?:i[346]|x)86)[;\)]/i                                            // IA32
            ], [[ARCHITECTURE, 'ia32']], [

            // PocketPC mistakenly identified as PowerPC
            /windows\s(ce|mobile);\sppc;/i
            ], [[ARCHITECTURE, 'arm']], [

            /((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i                           // PowerPC
            ], [[ARCHITECTURE, /ower/, '', util.lowerize]], [

            /(sun4\w)[;\)]/i                                                    // SPARC
            ], [[ARCHITECTURE, 'sparc']], [

            /((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+[;l]))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i
                                                                                // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
            ], [[ARCHITECTURE, util.lowerize]]
        ],

        device : [[

            /\((ipad|playbook);[\w\s\),;-]+(rim|apple)/i                        // iPad/PlayBook
            ], [MODEL, VENDOR, [TYPE, TABLET]], [

            /applecoremedia\/[\w\.]+ \((ipad)/                                  // iPad
            ], [MODEL, [VENDOR, 'Apple'], [TYPE, TABLET]], [

            /(apple\s{0,1}tv)/i                                                 // Apple TV
            ], [[MODEL, 'Apple TV'], [VENDOR, 'Apple']], [

            /(archos)\s(gamepad2?)/i,                                           // Archos
            /(hp).+(touchpad)/i,                                                // HP TouchPad
            /(hp).+(tablet)/i,                                                  // HP Tablet
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /\s(nook)[\w\s]+build\/(\w+)/i,                                     // Nook
            /(dell)\s(strea[kpr\s\d]*[\dko])/i                                  // Dell Streak
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /(kf[A-z]+)\sbuild\/.+silk\//i                                      // Kindle Fire HD
            ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [
            /(sd|kf)[0349hijorstuw]+\sbuild\/.+silk\//i                         // Fire Phone
            ], [[MODEL, mapper.str, maps.device.amazon.model], [VENDOR, 'Amazon'], [TYPE, MOBILE]], [
            /android.+aft([bms])\sbuild/i                                       // Fire TV
            ], [MODEL, [VENDOR, 'Amazon'], [TYPE, SMARTTV]], [

            /\((ip[honed|\s\w*]+);.+(apple)/i                                   // iPod/iPhone
            ], [MODEL, VENDOR, [TYPE, MOBILE]], [
            /\((ip[honed|\s\w*]+);/i                                            // iPod/iPhone
            ], [MODEL, [VENDOR, 'Apple'], [TYPE, MOBILE]], [

            /(blackberry)[\s-]?(\w+)/i,                                         // BlackBerry
            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]*)/i,
                                                                                // BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
            /(hp)\s([\w\s]+\w)/i,                                               // HP iPAQ
            /(asus)-?(\w+)/i                                                    // Asus
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /\(bb10;\s(\w+)/i                                                   // BlackBerry 10
            ], [MODEL, [VENDOR, 'BlackBerry'], [TYPE, MOBILE]], [
                                                                                // Asus Tablets
            /android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone|p00c)/i
            ], [MODEL, [VENDOR, 'Asus'], [TYPE, TABLET]], [

            /(sony)\s(tablet\s[ps])\sbuild\//i,                                  // Sony
            /(sony)?(?:sgp.+)\sbuild\//i
            ], [[VENDOR, 'Sony'], [MODEL, 'Xperia Tablet'], [TYPE, TABLET]], [
            /android.+\s([c-g]\d{4}|so[-l]\w+)(?=\sbuild\/|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ], [MODEL, [VENDOR, 'Sony'], [TYPE, MOBILE]], [

            /\s(ouya)\s/i,                                                      // Ouya
            /(nintendo)\s([wids3u]+)/i                                          // Nintendo
            ], [VENDOR, MODEL, [TYPE, CONSOLE]], [

            /android.+;\s(shield)\sbuild/i                                      // Nvidia
            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [

            /(playstation\s[34portablevi]+)/i                                   // Playstation
            ], [MODEL, [VENDOR, 'Sony'], [TYPE, CONSOLE]], [

            /(sprint\s(\w+))/i                                                  // Sprint Phones
            ], [[VENDOR, mapper.str, maps.device.sprint.vendor], [MODEL, mapper.str, maps.device.sprint.model], [TYPE, MOBILE]], [

            /(htc)[;_\s-]+([\w\s]+(?=\)|\sbuild)|\w+)/i,                        // HTC
            /(zte)-(\w*)/i,                                                     // ZTE
            /(alcatel|geeksphone|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]*)/i
                                                                                // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
            ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [

            /(nexus\s9)/i                                                       // HTC Nexus 9
            ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [

            /d\/huawei([\w\s-]+)[;\)]/i,
            /(nexus\s6p)/i                                                      // Huawei
            ], [MODEL, [VENDOR, 'Huawei'], [TYPE, MOBILE]], [

            /(microsoft);\s(lumia[\s\w]+)/i                                     // Microsoft Lumia
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /[\s\(;](xbox(?:\sone)?)[\s\);]/i                                   // Microsoft Xbox
            ], [MODEL, [VENDOR, 'Microsoft'], [TYPE, CONSOLE]], [
            /(kin\.[onetw]{3})/i                                                // Microsoft Kin
            ], [[MODEL, /\./g, ' '], [VENDOR, 'Microsoft'], [TYPE, MOBILE]], [

                                                                                // Motorola
            /\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?:?(\s4g)?)[\w\s]+build\//i,
            /mot[\s-]?(\w*)/i,
            /(XT\d{3,4}) build\//i,
            /(nexus\s6)/i
            ], [MODEL, [VENDOR, 'Motorola'], [TYPE, MOBILE]], [
            /android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i
            ], [MODEL, [VENDOR, 'Motorola'], [TYPE, TABLET]], [

            /hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i            // HbbTV devices
            ], [[VENDOR, util.trim], [MODEL, util.trim], [TYPE, SMARTTV]], [

            /hbbtv.+maple;(\d+)/i
            ], [[MODEL, /^/, 'SmartTV'], [VENDOR, 'Samsung'], [TYPE, SMARTTV]], [

            /\(dtv[\);].+(aquos)/i                                              // Sharp
            ], [MODEL, [VENDOR, 'Sharp'], [TYPE, SMARTTV]], [

            /android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i,
            /((SM-T\w+))/i
            ], [[VENDOR, 'Samsung'], MODEL, [TYPE, TABLET]], [                  // Samsung
            /smart-tv.+(samsung)/i
            ], [VENDOR, [TYPE, SMARTTV], MODEL], [
            /((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i,
            /(sam[sung]*)[\s-]*(\w+-?[\w-]*)/i,
            /sec-((sgh\w+))/i
            ], [[VENDOR, 'Samsung'], MODEL, [TYPE, MOBILE]], [

            /sie-(\w*)/i                                                        // Siemens
            ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [

            /(maemo|nokia).*(n900|lumia\s\d+)/i,                                // Nokia
            /(nokia)[\s_-]?([\w-]*)/i
            ], [[VENDOR, 'Nokia'], MODEL, [TYPE, MOBILE]], [

            /android[x\d\.\s;]+\s([ab][1-7]\-?[0178a]\d\d?)/i                   // Acer
            ], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [

            /android.+([vl]k\-?\d{3})\s+build/i                                 // LG Tablet
            ], [MODEL, [VENDOR, 'LG'], [TYPE, TABLET]], [
            /android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i                     // LG Tablet
            ], [[VENDOR, 'LG'], MODEL, [TYPE, TABLET]], [
            /(lg) netcast\.tv/i                                                 // LG SmartTV
            ], [VENDOR, MODEL, [TYPE, SMARTTV]], [
            /(nexus\s[45])/i,                                                   // LG
            /lg[e;\s\/-]+(\w*)/i,
            /android.+lg(\-?[\d\w]+)\s+build/i
            ], [MODEL, [VENDOR, 'LG'], [TYPE, MOBILE]], [

            /(lenovo)\s?(s(?:5000|6000)(?:[\w-]+)|tab(?:[\s\w]+))/i             // Lenovo tablets
            ], [VENDOR, MODEL, [TYPE, TABLET]], [
            /android.+(ideatab[a-z0-9\-\s]+)/i                                  // Lenovo
            ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [
            /(lenovo)[_\s-]?([\w-]+)/i
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /linux;.+((jolla));/i                                               // Jolla
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /((pebble))app\/[\d\.]+\s/i                                         // Pebble
            ], [VENDOR, MODEL, [TYPE, WEARABLE]], [

            /android.+;\s(oppo)\s?([\w\s]+)\sbuild/i                            // OPPO
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /crkey/i                                                            // Google Chromecast
            ], [[MODEL, 'Chromecast'], [VENDOR, 'Google']], [

            /android.+;\s(glass)\s\d/i                                          // Google Glass
            ], [MODEL, [VENDOR, 'Google'], [TYPE, WEARABLE]], [

            /android.+;\s(pixel c)[\s)]/i                                       // Google Pixel C
            ], [MODEL, [VENDOR, 'Google'], [TYPE, TABLET]], [

            /android.+;\s(pixel( [23])?( xl)?)[\s)]/i                              // Google Pixel
            ], [MODEL, [VENDOR, 'Google'], [TYPE, MOBILE]], [

            /android.+;\s(\w+)\s+build\/hm\1/i,                                 // Xiaomi Hongmi 'numeric' models
            /android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i,               // Xiaomi Hongmi
            /android.+(mi[\s\-_]*(?:a\d|one|one[\s_]plus|note lte)?[\s_]*(?:\d?\w?)[\s_]*(?:plus)?)\s+build/i,    
                                                                                // Xiaomi Mi
            /android.+(redmi[\s\-_]*(?:note)?(?:[\s_]*[\w\s]+))\s+build/i       // Redmi Phones
            ], [[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, MOBILE]], [
            /android.+(mi[\s\-_]*(?:pad)(?:[\s_]*[\w\s]+))\s+build/i            // Mi Pad tablets
            ],[[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, TABLET]], [
            /android.+;\s(m[1-5]\snote)\sbuild/i                                // Meizu
            ], [MODEL, [VENDOR, 'Meizu'], [TYPE, MOBILE]], [
            /(mz)-([\w-]{2,})/i
            ], [[VENDOR, 'Meizu'], MODEL, [TYPE, MOBILE]], [

            /android.+a000(1)\s+build/i,                                        // OnePlus
            /android.+oneplus\s(a\d{4})\s+build/i
            ], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [

            /android.+[;\/]\s*(RCT[\d\w]+)\s+build/i                            // RCA Tablets
            ], [MODEL, [VENDOR, 'RCA'], [TYPE, TABLET]], [

            /android.+[;\/\s]+(Venue[\d\s]{2,7})\s+build/i                      // Dell Venue Tablets
            ], [MODEL, [VENDOR, 'Dell'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Q[T|M][\d\w]+)\s+build/i                         // Verizon Tablet
            ], [MODEL, [VENDOR, 'Verizon'], [TYPE, TABLET]], [

            /android.+[;\/]\s+(Barnes[&\s]+Noble\s+|BN[RT])(V?.*)\s+build/i     // Barnes & Noble Tablet
            ], [[VENDOR, 'Barnes & Noble'], MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s+(TM\d{3}.*\b)\s+build/i                           // Barnes & Noble Tablet
            ], [MODEL, [VENDOR, 'NuVision'], [TYPE, TABLET]], [

            /android.+;\s(k88)\sbuild/i                                         // ZTE K Series Tablet
            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(gen\d{3})\s+build.*49h/i                         // Swiss GEN Mobile
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, MOBILE]], [

            /android.+[;\/]\s*(zur\d{3})\s+build/i                              // Swiss ZUR Tablet
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, TABLET]], [

            /android.+[;\/]\s*((Zeki)?TB.*\b)\s+build/i                         // Zeki Tablets
            ], [MODEL, [VENDOR, 'Zeki'], [TYPE, TABLET]], [

            /(android).+[;\/]\s+([YR]\d{2})\s+build/i,
            /android.+[;\/]\s+(Dragon[\-\s]+Touch\s+|DT)(\w{5})\sbuild/i        // Dragon Touch Tablet
            ], [[VENDOR, 'Dragon Touch'], MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s*(NS-?\w{0,9})\sbuild/i                            // Insignia Tablets
            ], [MODEL, [VENDOR, 'Insignia'], [TYPE, TABLET]], [

            /android.+[;\/]\s*((NX|Next)-?\w{0,9})\s+build/i                    // NextBook Tablets
            ], [MODEL, [VENDOR, 'NextBook'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Xtreme\_)?(V(1[045]|2[015]|30|40|60|7[05]|90))\s+build/i
            ], [[VENDOR, 'Voice'], MODEL, [TYPE, MOBILE]], [                    // Voice Xtreme Phones

            /android.+[;\/]\s*(LVTEL\-)?(V1[12])\s+build/i                     // LvTel Phones
            ], [[VENDOR, 'LvTel'], MODEL, [TYPE, MOBILE]], [

            /android.+;\s(PH-1)\s/i
            ], [MODEL, [VENDOR, 'Essential'], [TYPE, MOBILE]], [                // Essential PH-1

            /android.+[;\/]\s*(V(100MD|700NA|7011|917G).*\b)\s+build/i          // Envizen Tablets
            ], [MODEL, [VENDOR, 'Envizen'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Le[\s\-]+Pan)[\s\-]+(\w{1,9})\s+build/i          // Le Pan Tablets
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s*(Trio[\s\-]*.*)\s+build/i                         // MachSpeed Tablets
            ], [MODEL, [VENDOR, 'MachSpeed'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Trinity)[\-\s]*(T\d{3})\s+build/i                // Trinity Tablets
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s*TU_(1491)\s+build/i                               // Rotor Tablets
            ], [MODEL, [VENDOR, 'Rotor'], [TYPE, TABLET]], [

            /android.+(KS(.+))\s+build/i                                        // Amazon Kindle Tablets
            ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [

            /android.+(Gigaset)[\s\-]+(Q\w{1,9})\s+build/i                      // Gigaset Tablets
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /\s(tablet|tab)[;\/]/i,                                             // Unidentifiable Tablet
            /\s(mobile)(?:[;\/]|\ssafari)/i                                     // Unidentifiable Mobile
            ], [[TYPE, util.lowerize], VENDOR, MODEL], [

            /[\s\/\(](smart-?tv)[;\)]/i                                         // SmartTV
            ], [[TYPE, SMARTTV]], [

            /(android[\w\.\s\-]{0,9});.+build/i                                 // Generic Android Device
            ], [MODEL, [VENDOR, 'Generic']]
        ],

        engine : [[

            /windows.+\sedge\/([\w\.]+)/i                                       // EdgeHTML
            ], [VERSION, [NAME, 'EdgeHTML']], [

            /webkit\/537\.36.+chrome\/(?!27)/i                                  // Blink
            ], [[NAME, 'Blink']], [

            /(presto)\/([\w\.]+)/i,                                             // Presto
            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,     
                                                                                // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
            /(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,                          // KHTML/Tasman/Links
            /(icab)[\/\s]([23]\.[\d\.]+)/i                                      // iCab
            ], [NAME, VERSION], [

            /rv\:([\w\.]{1,9}).+(gecko)/i                                       // Gecko
            ], [VERSION, NAME]
        ],

        os : [[

            // Windows based
            /microsoft\s(windows)\s(vista|xp)/i                                 // Windows (iTunes)
            ], [NAME, VERSION], [
            /(windows)\snt\s6\.2;\s(arm)/i,                                     // Windows RT
            /(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s\w]*)/i,                   // Windows Phone
            /(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i
            ], [NAME, [VERSION, mapper.str, maps.os.windows.version]], [
            /(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i
            ], [[NAME, 'Windows'], [VERSION, mapper.str, maps.os.windows.version]], [

            // Mobile/Embedded OS
            /\((bb)(10);/i                                                      // BlackBerry 10
            ], [[NAME, 'BlackBerry'], VERSION], [
            /(blackberry)\w*\/?([\w\.]*)/i,                                     // Blackberry
            /(tizen)[\/\s]([\w\.]+)/i,                                          // Tizen
            /(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|sailfish|contiki)[\/\s-]?([\w\.]*)/i
                                                                                // Android/WebOS/Palm/QNX/Bada/RIM/MeeGo/Contiki/Sailfish OS
            ], [NAME, VERSION], [
            /(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]*)/i                  // Symbian
            ], [[NAME, 'Symbian'], VERSION], [
            /\((series40);/i                                                    // Series 40
            ], [NAME], [
            /mozilla.+\(mobile;.+gecko.+firefox/i                               // Firefox OS
            ], [[NAME, 'Firefox OS'], VERSION], [

            // Console
            /(nintendo|playstation)\s([wids34portablevu]+)/i,                   // Nintendo/Playstation

            // GNU/Linux based
            /(mint)[\/\s\(]?(\w*)/i,                                            // Mint
            /(mageia|vectorlinux)[;\s]/i,                                       // Mageia/VectorLinux
            /(joli|[kxln]?ubuntu|debian|suse|opensuse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]*)/i,
                                                                                // Joli/Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware
                                                                                // Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus
            /(hurd|linux)\s?([\w\.]*)/i,                                        // Hurd/Linux
            /(gnu)\s?([\w\.]*)/i                                                // GNU
            ], [NAME, VERSION], [

            /(cros)\s[\w]+\s([\w\.]+\w)/i                                       // Chromium OS
            ], [[NAME, 'Chromium OS'], VERSION],[

            // Solaris
            /(sunos)\s?([\w\.\d]*)/i                                            // Solaris
            ], [[NAME, 'Solaris'], VERSION], [

            // BSD based
            /\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]*)/i                    // FreeBSD/NetBSD/OpenBSD/PC-BSD/DragonFly
            ], [NAME, VERSION],[

            /(haiku)\s(\w+)/i                                                   // Haiku
            ], [NAME, VERSION],[

            /cfnetwork\/.+darwin/i,
            /ip[honead]{2,4}(?:.*os\s([\w]+)\slike\smac|;\sopera)/i             // iOS
            ], [[VERSION, /_/g, '.'], [NAME, 'iOS']], [

            /(mac\sos\sx)\s?([\w\s\.]*)/i,
            /(macintosh|mac(?=_powerpc)\s)/i                                    // Mac OS
            ], [[NAME, 'Mac OS'], [VERSION, /_/g, '.']], [

            // Other
            /((?:open)?solaris)[\/\s-]?([\w\.]*)/i,                             // Solaris
            /(aix)\s((\d)(?=\.|\)|\s)[\w\.])*/i,                                // AIX
            /(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms|fuchsia)/i,
                                                                                // Plan9/Minix/BeOS/OS2/AmigaOS/MorphOS/RISCOS/OpenVMS/Fuchsia
            /(unix)\s?([\w\.]*)/i                                               // UNIX
            ], [NAME, VERSION]
        ]
    };


    /////////////////
    // Constructor
    ////////////////
    var UAParser = function (uastring, extensions) {

        if (typeof uastring === 'object') {
            extensions = uastring;
            uastring = undefined;
        }

        if (!(this instanceof UAParser)) {
            return new UAParser(uastring, extensions).getResult();
        }

        var ua = uastring || ((window && window.navigator && window.navigator.userAgent) ? window.navigator.userAgent : EMPTY);
        var rgxmap = extensions ? util.extend(regexes, extensions) : regexes;

        this.getBrowser = function () {
            var browser = { name: undefined, version: undefined };
            mapper.rgx.call(browser, ua, rgxmap.browser);
            browser.major = util.major(browser.version); // deprecated
            return browser;
        };
        this.getCPU = function () {
            var cpu = { architecture: undefined };
            mapper.rgx.call(cpu, ua, rgxmap.cpu);
            return cpu;
        };
        this.getDevice = function () {
            var device = { vendor: undefined, model: undefined, type: undefined };
            mapper.rgx.call(device, ua, rgxmap.device);
            return device;
        };
        this.getEngine = function () {
            var engine = { name: undefined, version: undefined };
            mapper.rgx.call(engine, ua, rgxmap.engine);
            return engine;
        };
        this.getOS = function () {
            var os = { name: undefined, version: undefined };
            mapper.rgx.call(os, ua, rgxmap.os);
            return os;
        };
        this.getResult = function () {
            return {
                ua      : this.getUA(),
                browser : this.getBrowser(),
                engine  : this.getEngine(),
                os      : this.getOS(),
                device  : this.getDevice(),
                cpu     : this.getCPU()
            };
        };
        this.getUA = function () {
            return ua;
        };
        this.setUA = function (uastring) {
            ua = uastring;
            return this;
        };
        return this;
    };

    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = {
        NAME    : NAME,
        MAJOR   : MAJOR, // deprecated
        VERSION : VERSION
    };
    UAParser.CPU = {
        ARCHITECTURE : ARCHITECTURE
    };
    UAParser.DEVICE = {
        MODEL   : MODEL,
        VENDOR  : VENDOR,
        TYPE    : TYPE,
        CONSOLE : CONSOLE,
        MOBILE  : MOBILE,
        SMARTTV : SMARTTV,
        TABLET  : TABLET,
        WEARABLE: WEARABLE,
        EMBEDDED: EMBEDDED
    };
    UAParser.ENGINE = {
        NAME    : NAME,
        VERSION : VERSION
    };
    UAParser.OS = {
        NAME    : NAME,
        VERSION : VERSION
    };

    ///////////
    // Export
    //////////


    // check js environment
    if (typeof(exports) !== UNDEF_TYPE) {
        // nodejs env
        if ("object" !== UNDEF_TYPE && module.exports) {
            exports = module.exports = UAParser;
        }
        exports.UAParser = UAParser;
    } else {
        // requirejs env (optional)
        if (true) {
            !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
                return UAParser;
            }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else {}
    }

    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = window && (window.jQuery || window.Zepto);
    if (typeof $ !== UNDEF_TYPE && !$.ua) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function () {
            return parser.getUA();
        };
        $.ua.set = function (uastring) {
            parser.setUA(uastring);
            var result = parser.getResult();
            for (var prop in result) {
                $.ua[prop] = result[prop];
            }
        };
    }

})(typeof window === 'object' ? window : this);


/***/ }),

/***/ 11294:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ ApolloCache; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70655);
/* harmony import */ var optimism__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7697);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23361);



var ApolloCache = (function () {
    function ApolloCache() {
        this.getFragmentDoc = (0,optimism__WEBPACK_IMPORTED_MODULE_0__/* .wrap */ .re)(_utilities_index_js__WEBPACK_IMPORTED_MODULE_1__/* .getFragmentQueryDocument */ .Yk);
    }
    ApolloCache.prototype.batch = function (options) {
        var _this = this;
        var optimisticId = typeof options.optimistic === "string" ? options.optimistic :
            options.optimistic === false ? null : void 0;
        var updateResult;
        this.performTransaction(function () { return updateResult = options.update(_this); }, optimisticId);
        return updateResult;
    };
    ApolloCache.prototype.recordOptimisticTransaction = function (transaction, optimisticId) {
        this.performTransaction(transaction, optimisticId);
    };
    ApolloCache.prototype.transformDocument = function (document) {
        return document;
    };
    ApolloCache.prototype.transformForLink = function (document) {
        return document;
    };
    ApolloCache.prototype.identify = function (object) {
        return;
    };
    ApolloCache.prototype.gc = function () {
        return [];
    };
    ApolloCache.prototype.modify = function (options) {
        return false;
    };
    ApolloCache.prototype.readQuery = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = !!options.optimistic; }
        return this.read((0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, options), { rootId: options.id || 'ROOT_QUERY', optimistic: optimistic }));
    };
    ApolloCache.prototype.readFragment = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = !!options.optimistic; }
        return this.read((0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, options), { query: this.getFragmentDoc(options.fragment, options.fragmentName), rootId: options.id, optimistic: optimistic }));
    };
    ApolloCache.prototype.writeQuery = function (_a) {
        var id = _a.id, data = _a.data, options = (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__rest */ ._T)(_a, ["id", "data"]);
        return this.write(Object.assign(options, {
            dataId: id || 'ROOT_QUERY',
            result: data,
        }));
    };
    ApolloCache.prototype.writeFragment = function (_a) {
        var id = _a.id, data = _a.data, fragment = _a.fragment, fragmentName = _a.fragmentName, options = (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__rest */ ._T)(_a, ["id", "data", "fragment", "fragmentName"]);
        return this.write(Object.assign(options, {
            query: this.getFragmentDoc(fragment, fragmentName),
            dataId: id,
            result: data,
        }));
    };
    ApolloCache.prototype.updateQuery = function (options, update) {
        return this.batch({
            update: function (cache) {
                var value = cache.readQuery(options);
                var data = update(value);
                if (data === void 0 || data === null)
                    return value;
                cache.writeQuery((0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, options), { data: data }));
                return data;
            },
        });
    };
    ApolloCache.prototype.updateFragment = function (options, update) {
        return this.batch({
            update: function (cache) {
                var value = cache.readFragment(options);
                var data = update(value);
                if (data === void 0 || data === null)
                    return value;
                cache.writeFragment((0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, options), { data: data }));
                return data;
            },
        });
    };
    return ApolloCache;
}());

//# sourceMappingURL=cache.js.map

/***/ }),

/***/ 75727:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ MissingFieldError; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70655);

var MissingFieldError = (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(MissingFieldError, _super);
    function MissingFieldError(message, path, query, variables) {
        var _a;
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.path = path;
        _this.query = query;
        _this.variables = variables;
        if (Array.isArray(_this.path)) {
            _this.missing = _this.message;
            for (var i = _this.path.length - 1; i >= 0; --i) {
                _this.missing = (_a = {}, _a[_this.path[i]] = _this.missing, _a);
            }
        }
        else {
            _this.missing = _this.path;
        }
        _this.__proto__ = MissingFieldError.prototype;
        return _this;
    }
    return MissingFieldError;
}(Error));

//# sourceMappingURL=common.js.map

/***/ }),

/***/ 49641:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$O": function() { return /* binding */ TypeOrFieldNameRegExp; },
/* harmony export */   "E_": function() { return /* binding */ fieldNameFromStoreName; },
/* harmony export */   "Is": function() { return /* binding */ extractFragmentContext; },
/* harmony export */   "RC": function() { return /* binding */ selectionSetMatchesResult; },
/* harmony export */   "RI": function() { return /* binding */ hasOwn; },
/* harmony export */   "ig": function() { return /* binding */ makeProcessedFieldsMerger; },
/* harmony export */   "j": function() { return /* binding */ storeValueIsStoreObject; },
/* harmony export */   "jS": function() { return /* binding */ normalizeConfig; },
/* harmony export */   "jp": function() { return /* binding */ getTypenameFromStoreObject; },
/* harmony export */   "kJ": function() { return /* binding */ isArray; },
/* harmony export */   "lg": function() { return /* binding */ shouldCanonizeResults; },
/* harmony export */   "uG": function() { return /* binding */ defaultDataIdFromObject; }
/* harmony export */ });
/* unused harmony export isNullish */
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53712);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51761);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13154);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19065);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(182);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23361);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36765);

var hasOwn = Object.prototype.hasOwnProperty;
function isNullish(value) {
    return value === null || value === void 0;
}
var isArray = Array.isArray;
function defaultDataIdFromObject(_a, context) {
    var __typename = _a.__typename, id = _a.id, _id = _a._id;
    if (typeof __typename === "string") {
        if (context) {
            context.keyObject =
                !isNullish(id) ? { id: id } :
                    !isNullish(_id) ? { _id: _id } :
                        void 0;
        }
        if (isNullish(id) && !isNullish(_id)) {
            id = _id;
        }
        if (!isNullish(id)) {
            return "".concat(__typename, ":").concat((typeof id === "number" ||
                typeof id === "string") ? id : JSON.stringify(id));
        }
    }
}
var defaultConfig = {
    dataIdFromObject: defaultDataIdFromObject,
    addTypename: true,
    resultCaching: true,
    canonizeResults: false,
};
function normalizeConfig(config) {
    return (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_0__/* .compact */ .o)(defaultConfig, config);
}
function shouldCanonizeResults(config) {
    var value = config.canonizeResults;
    return value === void 0 ? defaultConfig.canonizeResults : value;
}
function getTypenameFromStoreObject(store, objectOrReference) {
    return (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isReference */ .Yk)(objectOrReference)
        ? store.get(objectOrReference.__ref, "__typename")
        : objectOrReference && objectOrReference.__typename;
}
var TypeOrFieldNameRegExp = /^[_a-z][_0-9a-z]*/i;
function fieldNameFromStoreName(storeFieldName) {
    var match = storeFieldName.match(TypeOrFieldNameRegExp);
    return match ? match[0] : storeFieldName;
}
function selectionSetMatchesResult(selectionSet, result, variables) {
    if ((0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_2__/* .isNonNullObject */ .s)(result)) {
        return isArray(result)
            ? result.every(function (item) { return selectionSetMatchesResult(selectionSet, item, variables); })
            : selectionSet.selections.every(function (field) {
                if ((0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isField */ .My)(field) && (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_3__/* .shouldInclude */ .LZ)(field, variables)) {
                    var key = (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_1__/* .resultKeyNameFromField */ .u2)(field);
                    return hasOwn.call(result, key) &&
                        (!field.selectionSet ||
                            selectionSetMatchesResult(field.selectionSet, result[key], variables));
                }
                return true;
            });
    }
    return false;
}
function storeValueIsStoreObject(value) {
    return (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_2__/* .isNonNullObject */ .s)(value) &&
        !(0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isReference */ .Yk)(value) &&
        !isArray(value);
}
function makeProcessedFieldsMerger() {
    return new _utilities_index_js__WEBPACK_IMPORTED_MODULE_4__/* .DeepMerger */ .w0;
}
function extractFragmentContext(document, fragments) {
    var fragmentMap = (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_5__/* .createFragmentMap */ .F)((0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_6__/* .getFragmentDefinitions */ .kU)(document));
    return {
        fragmentMap: fragmentMap,
        lookupFragment: function (name) {
            var def = fragmentMap[name];
            if (!def && fragments) {
                def = fragments.lookup(name);
            }
            return def || null;
        },
    };
}
//# sourceMappingURL=helpers.js.map

/***/ }),

/***/ 55598:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ InMemoryCache; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/globals/index.js + 5 modules
var globals = __webpack_require__(62985);
// EXTERNAL MODULE: ./node_modules/optimism/lib/bundle.esm.js + 1 modules
var bundle_esm = __webpack_require__(7697);
// EXTERNAL MODULE: ./node_modules/@wry/equality/lib/equality.esm.js
var equality_esm = __webpack_require__(82152);
// EXTERNAL MODULE: ./node_modules/@apollo/client/cache/core/cache.js
var cache = __webpack_require__(11294);
// EXTERNAL MODULE: ./node_modules/@apollo/client/cache/core/types/common.js
var common = __webpack_require__(75727);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/graphql/storeUtils.js
var storeUtils = __webpack_require__(51761);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/graphql/transform.js + 1 modules
var transform = __webpack_require__(76982);
// EXTERNAL MODULE: ./node_modules/graphql/language/kinds.mjs
var kinds = __webpack_require__(97359);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/canUse.js
var canUse = __webpack_require__(30320);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/compact.js
var compact = __webpack_require__(53712);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/graphql/getFromAST.js
var getFromAST = __webpack_require__(36765);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/mergeDeep.js
var mergeDeep = __webpack_require__(182);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/graphql/directives.js
var directives = __webpack_require__(19065);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/graphql/fragments.js
var fragments = __webpack_require__(23361);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/maybeDeepFreeze.js
var maybeDeepFreeze = __webpack_require__(48702);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/objects.js
var objects = __webpack_require__(13154);
// EXTERNAL MODULE: ./node_modules/@wry/trie/lib/trie.esm.js
var trie_esm = __webpack_require__(657);
// EXTERNAL MODULE: ./node_modules/@apollo/client/cache/inmemory/helpers.js
var helpers = __webpack_require__(49641);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/cache/inmemory/entityStore.js







var DELETE = Object.create(null);
var delModifier = function () { return DELETE; };
var INVALIDATE = Object.create(null);
var EntityStore = (function () {
    function EntityStore(policies, group) {
        var _this = this;
        this.policies = policies;
        this.group = group;
        this.data = Object.create(null);
        this.rootIds = Object.create(null);
        this.refs = Object.create(null);
        this.getFieldValue = function (objectOrReference, storeFieldName) { return (0,maybeDeepFreeze/* maybeDeepFreeze */.J)((0,storeUtils/* isReference */.Yk)(objectOrReference)
            ? _this.get(objectOrReference.__ref, storeFieldName)
            : objectOrReference && objectOrReference[storeFieldName]); };
        this.canRead = function (objOrRef) {
            return (0,storeUtils/* isReference */.Yk)(objOrRef)
                ? _this.has(objOrRef.__ref)
                : typeof objOrRef === "object";
        };
        this.toReference = function (objOrIdOrRef, mergeIntoStore) {
            if (typeof objOrIdOrRef === "string") {
                return (0,storeUtils/* makeReference */.kQ)(objOrIdOrRef);
            }
            if ((0,storeUtils/* isReference */.Yk)(objOrIdOrRef)) {
                return objOrIdOrRef;
            }
            var id = _this.policies.identify(objOrIdOrRef)[0];
            if (id) {
                var ref = (0,storeUtils/* makeReference */.kQ)(id);
                if (mergeIntoStore) {
                    _this.merge(id, objOrIdOrRef);
                }
                return ref;
            }
        };
    }
    EntityStore.prototype.toObject = function () {
        return (0,tslib_es6/* __assign */.pi)({}, this.data);
    };
    EntityStore.prototype.has = function (dataId) {
        return this.lookup(dataId, true) !== void 0;
    };
    EntityStore.prototype.get = function (dataId, fieldName) {
        this.group.depend(dataId, fieldName);
        if (helpers/* hasOwn.call */.RI.call(this.data, dataId)) {
            var storeObject = this.data[dataId];
            if (storeObject && helpers/* hasOwn.call */.RI.call(storeObject, fieldName)) {
                return storeObject[fieldName];
            }
        }
        if (fieldName === "__typename" &&
            helpers/* hasOwn.call */.RI.call(this.policies.rootTypenamesById, dataId)) {
            return this.policies.rootTypenamesById[dataId];
        }
        if (this instanceof Layer) {
            return this.parent.get(dataId, fieldName);
        }
    };
    EntityStore.prototype.lookup = function (dataId, dependOnExistence) {
        if (dependOnExistence)
            this.group.depend(dataId, "__exists");
        if (helpers/* hasOwn.call */.RI.call(this.data, dataId)) {
            return this.data[dataId];
        }
        if (this instanceof Layer) {
            return this.parent.lookup(dataId, dependOnExistence);
        }
        if (this.policies.rootTypenamesById[dataId]) {
            return Object.create(null);
        }
    };
    EntityStore.prototype.merge = function (older, newer) {
        var _this = this;
        var dataId;
        if ((0,storeUtils/* isReference */.Yk)(older))
            older = older.__ref;
        if ((0,storeUtils/* isReference */.Yk)(newer))
            newer = newer.__ref;
        var existing = typeof older === "string"
            ? this.lookup(dataId = older)
            : older;
        var incoming = typeof newer === "string"
            ? this.lookup(dataId = newer)
            : newer;
        if (!incoming)
            return;
        __DEV__ ? (0,globals/* invariant */.kG)(typeof dataId === "string", "store.merge expects a string ID") : (0,globals/* invariant */.kG)(typeof dataId === "string", 1);
        var merged = new mergeDeep/* DeepMerger */.w0(storeObjectReconciler).merge(existing, incoming);
        this.data[dataId] = merged;
        if (merged !== existing) {
            delete this.refs[dataId];
            if (this.group.caching) {
                var fieldsToDirty_1 = Object.create(null);
                if (!existing)
                    fieldsToDirty_1.__exists = 1;
                Object.keys(incoming).forEach(function (storeFieldName) {
                    if (!existing || existing[storeFieldName] !== merged[storeFieldName]) {
                        fieldsToDirty_1[storeFieldName] = 1;
                        var fieldName = (0,helpers/* fieldNameFromStoreName */.E_)(storeFieldName);
                        if (fieldName !== storeFieldName &&
                            !_this.policies.hasKeyArgs(merged.__typename, fieldName)) {
                            fieldsToDirty_1[fieldName] = 1;
                        }
                        if (merged[storeFieldName] === void 0 && !(_this instanceof Layer)) {
                            delete merged[storeFieldName];
                        }
                    }
                });
                if (fieldsToDirty_1.__typename &&
                    !(existing && existing.__typename) &&
                    this.policies.rootTypenamesById[dataId] === merged.__typename) {
                    delete fieldsToDirty_1.__typename;
                }
                Object.keys(fieldsToDirty_1).forEach(function (fieldName) { return _this.group.dirty(dataId, fieldName); });
            }
        }
    };
    EntityStore.prototype.modify = function (dataId, fields) {
        var _this = this;
        var storeObject = this.lookup(dataId);
        if (storeObject) {
            var changedFields_1 = Object.create(null);
            var needToMerge_1 = false;
            var allDeleted_1 = true;
            var sharedDetails_1 = {
                DELETE: DELETE,
                INVALIDATE: INVALIDATE,
                isReference: storeUtils/* isReference */.Yk,
                toReference: this.toReference,
                canRead: this.canRead,
                readField: function (fieldNameOrOptions, from) { return _this.policies.readField(typeof fieldNameOrOptions === "string" ? {
                    fieldName: fieldNameOrOptions,
                    from: from || (0,storeUtils/* makeReference */.kQ)(dataId),
                } : fieldNameOrOptions, { store: _this }); },
            };
            Object.keys(storeObject).forEach(function (storeFieldName) {
                var fieldName = (0,helpers/* fieldNameFromStoreName */.E_)(storeFieldName);
                var fieldValue = storeObject[storeFieldName];
                if (fieldValue === void 0)
                    return;
                var modify = typeof fields === "function"
                    ? fields
                    : fields[storeFieldName] || fields[fieldName];
                if (modify) {
                    var newValue = modify === delModifier ? DELETE :
                        modify((0,maybeDeepFreeze/* maybeDeepFreeze */.J)(fieldValue), (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, sharedDetails_1), { fieldName: fieldName, storeFieldName: storeFieldName, storage: _this.getStorage(dataId, storeFieldName) }));
                    if (newValue === INVALIDATE) {
                        _this.group.dirty(dataId, storeFieldName);
                    }
                    else {
                        if (newValue === DELETE)
                            newValue = void 0;
                        if (newValue !== fieldValue) {
                            changedFields_1[storeFieldName] = newValue;
                            needToMerge_1 = true;
                            fieldValue = newValue;
                        }
                    }
                }
                if (fieldValue !== void 0) {
                    allDeleted_1 = false;
                }
            });
            if (needToMerge_1) {
                this.merge(dataId, changedFields_1);
                if (allDeleted_1) {
                    if (this instanceof Layer) {
                        this.data[dataId] = void 0;
                    }
                    else {
                        delete this.data[dataId];
                    }
                    this.group.dirty(dataId, "__exists");
                }
                return true;
            }
        }
        return false;
    };
    EntityStore.prototype.delete = function (dataId, fieldName, args) {
        var _a;
        var storeObject = this.lookup(dataId);
        if (storeObject) {
            var typename = this.getFieldValue(storeObject, "__typename");
            var storeFieldName = fieldName && args
                ? this.policies.getStoreFieldName({ typename: typename, fieldName: fieldName, args: args })
                : fieldName;
            return this.modify(dataId, storeFieldName ? (_a = {},
                _a[storeFieldName] = delModifier,
                _a) : delModifier);
        }
        return false;
    };
    EntityStore.prototype.evict = function (options, limit) {
        var evicted = false;
        if (options.id) {
            if (helpers/* hasOwn.call */.RI.call(this.data, options.id)) {
                evicted = this.delete(options.id, options.fieldName, options.args);
            }
            if (this instanceof Layer && this !== limit) {
                evicted = this.parent.evict(options, limit) || evicted;
            }
            if (options.fieldName || evicted) {
                this.group.dirty(options.id, options.fieldName || "__exists");
            }
        }
        return evicted;
    };
    EntityStore.prototype.clear = function () {
        this.replace(null);
    };
    EntityStore.prototype.extract = function () {
        var _this = this;
        var obj = this.toObject();
        var extraRootIds = [];
        this.getRootIdSet().forEach(function (id) {
            if (!helpers/* hasOwn.call */.RI.call(_this.policies.rootTypenamesById, id)) {
                extraRootIds.push(id);
            }
        });
        if (extraRootIds.length) {
            obj.__META = { extraRootIds: extraRootIds.sort() };
        }
        return obj;
    };
    EntityStore.prototype.replace = function (newData) {
        var _this = this;
        Object.keys(this.data).forEach(function (dataId) {
            if (!(newData && helpers/* hasOwn.call */.RI.call(newData, dataId))) {
                _this.delete(dataId);
            }
        });
        if (newData) {
            var __META = newData.__META, rest_1 = (0,tslib_es6/* __rest */._T)(newData, ["__META"]);
            Object.keys(rest_1).forEach(function (dataId) {
                _this.merge(dataId, rest_1[dataId]);
            });
            if (__META) {
                __META.extraRootIds.forEach(this.retain, this);
            }
        }
    };
    EntityStore.prototype.retain = function (rootId) {
        return this.rootIds[rootId] = (this.rootIds[rootId] || 0) + 1;
    };
    EntityStore.prototype.release = function (rootId) {
        if (this.rootIds[rootId] > 0) {
            var count = --this.rootIds[rootId];
            if (!count)
                delete this.rootIds[rootId];
            return count;
        }
        return 0;
    };
    EntityStore.prototype.getRootIdSet = function (ids) {
        if (ids === void 0) { ids = new Set(); }
        Object.keys(this.rootIds).forEach(ids.add, ids);
        if (this instanceof Layer) {
            this.parent.getRootIdSet(ids);
        }
        else {
            Object.keys(this.policies.rootTypenamesById).forEach(ids.add, ids);
        }
        return ids;
    };
    EntityStore.prototype.gc = function () {
        var _this = this;
        var ids = this.getRootIdSet();
        var snapshot = this.toObject();
        ids.forEach(function (id) {
            if (helpers/* hasOwn.call */.RI.call(snapshot, id)) {
                Object.keys(_this.findChildRefIds(id)).forEach(ids.add, ids);
                delete snapshot[id];
            }
        });
        var idsToRemove = Object.keys(snapshot);
        if (idsToRemove.length) {
            var root_1 = this;
            while (root_1 instanceof Layer)
                root_1 = root_1.parent;
            idsToRemove.forEach(function (id) { return root_1.delete(id); });
        }
        return idsToRemove;
    };
    EntityStore.prototype.findChildRefIds = function (dataId) {
        if (!helpers/* hasOwn.call */.RI.call(this.refs, dataId)) {
            var found_1 = this.refs[dataId] = Object.create(null);
            var root = this.data[dataId];
            if (!root)
                return found_1;
            var workSet_1 = new Set([root]);
            workSet_1.forEach(function (obj) {
                if ((0,storeUtils/* isReference */.Yk)(obj)) {
                    found_1[obj.__ref] = true;
                }
                if ((0,objects/* isNonNullObject */.s)(obj)) {
                    Object.keys(obj).forEach(function (key) {
                        var child = obj[key];
                        if ((0,objects/* isNonNullObject */.s)(child)) {
                            workSet_1.add(child);
                        }
                    });
                }
            });
        }
        return this.refs[dataId];
    };
    EntityStore.prototype.makeCacheKey = function () {
        return this.group.keyMaker.lookupArray(arguments);
    };
    return EntityStore;
}());

var CacheGroup = (function () {
    function CacheGroup(caching, parent) {
        if (parent === void 0) { parent = null; }
        this.caching = caching;
        this.parent = parent;
        this.d = null;
        this.resetCaching();
    }
    CacheGroup.prototype.resetCaching = function () {
        this.d = this.caching ? (0,bundle_esm/* dep */.dP)() : null;
        this.keyMaker = new trie_esm/* Trie */.B(canUse/* canUseWeakMap */.mr);
    };
    CacheGroup.prototype.depend = function (dataId, storeFieldName) {
        if (this.d) {
            this.d(makeDepKey(dataId, storeFieldName));
            var fieldName = (0,helpers/* fieldNameFromStoreName */.E_)(storeFieldName);
            if (fieldName !== storeFieldName) {
                this.d(makeDepKey(dataId, fieldName));
            }
            if (this.parent) {
                this.parent.depend(dataId, storeFieldName);
            }
        }
    };
    CacheGroup.prototype.dirty = function (dataId, storeFieldName) {
        if (this.d) {
            this.d.dirty(makeDepKey(dataId, storeFieldName), storeFieldName === "__exists" ? "forget" : "setDirty");
        }
    };
    return CacheGroup;
}());
function makeDepKey(dataId, storeFieldName) {
    return storeFieldName + '#' + dataId;
}
function maybeDependOnExistenceOfEntity(store, entityId) {
    if (supportsResultCaching(store)) {
        store.group.depend(entityId, "__exists");
    }
}
(function (EntityStore) {
    var Root = (function (_super) {
        (0,tslib_es6/* __extends */.ZT)(Root, _super);
        function Root(_a) {
            var policies = _a.policies, _b = _a.resultCaching, resultCaching = _b === void 0 ? true : _b, seed = _a.seed;
            var _this = _super.call(this, policies, new CacheGroup(resultCaching)) || this;
            _this.stump = new Stump(_this);
            _this.storageTrie = new trie_esm/* Trie */.B(canUse/* canUseWeakMap */.mr);
            if (seed)
                _this.replace(seed);
            return _this;
        }
        Root.prototype.addLayer = function (layerId, replay) {
            return this.stump.addLayer(layerId, replay);
        };
        Root.prototype.removeLayer = function () {
            return this;
        };
        Root.prototype.getStorage = function () {
            return this.storageTrie.lookupArray(arguments);
        };
        return Root;
    }(EntityStore));
    EntityStore.Root = Root;
})(EntityStore || (EntityStore = {}));
var Layer = (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(Layer, _super);
    function Layer(id, parent, replay, group) {
        var _this = _super.call(this, parent.policies, group) || this;
        _this.id = id;
        _this.parent = parent;
        _this.replay = replay;
        _this.group = group;
        replay(_this);
        return _this;
    }
    Layer.prototype.addLayer = function (layerId, replay) {
        return new Layer(layerId, this, replay, this.group);
    };
    Layer.prototype.removeLayer = function (layerId) {
        var _this = this;
        var parent = this.parent.removeLayer(layerId);
        if (layerId === this.id) {
            if (this.group.caching) {
                Object.keys(this.data).forEach(function (dataId) {
                    var ownStoreObject = _this.data[dataId];
                    var parentStoreObject = parent["lookup"](dataId);
                    if (!parentStoreObject) {
                        _this.delete(dataId);
                    }
                    else if (!ownStoreObject) {
                        _this.group.dirty(dataId, "__exists");
                        Object.keys(parentStoreObject).forEach(function (storeFieldName) {
                            _this.group.dirty(dataId, storeFieldName);
                        });
                    }
                    else if (ownStoreObject !== parentStoreObject) {
                        Object.keys(ownStoreObject).forEach(function (storeFieldName) {
                            if (!(0,equality_esm/* equal */.D)(ownStoreObject[storeFieldName], parentStoreObject[storeFieldName])) {
                                _this.group.dirty(dataId, storeFieldName);
                            }
                        });
                    }
                });
            }
            return parent;
        }
        if (parent === this.parent)
            return this;
        return parent.addLayer(this.id, this.replay);
    };
    Layer.prototype.toObject = function () {
        return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this.parent.toObject()), this.data);
    };
    Layer.prototype.findChildRefIds = function (dataId) {
        var fromParent = this.parent.findChildRefIds(dataId);
        return helpers/* hasOwn.call */.RI.call(this.data, dataId) ? (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, fromParent), _super.prototype.findChildRefIds.call(this, dataId)) : fromParent;
    };
    Layer.prototype.getStorage = function () {
        var p = this.parent;
        while (p.parent)
            p = p.parent;
        return p.getStorage.apply(p, arguments);
    };
    return Layer;
}(EntityStore));
var Stump = (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(Stump, _super);
    function Stump(root) {
        return _super.call(this, "EntityStore.Stump", root, function () { }, new CacheGroup(root.group.caching, root.group)) || this;
    }
    Stump.prototype.removeLayer = function () {
        return this;
    };
    Stump.prototype.merge = function () {
        return this.parent.merge.apply(this.parent, arguments);
    };
    return Stump;
}(Layer));
function storeObjectReconciler(existingObject, incomingObject, property) {
    var existingValue = existingObject[property];
    var incomingValue = incomingObject[property];
    return (0,equality_esm/* equal */.D)(existingValue, incomingValue) ? existingValue : incomingValue;
}
function supportsResultCaching(store) {
    return !!(store instanceof EntityStore && store.group.caching);
}
//# sourceMappingURL=entityStore.js.map
// EXTERNAL MODULE: ./node_modules/@apollo/client/cache/inmemory/object-canon.js
var object_canon = __webpack_require__(80900);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/cache/inmemory/readFromStore.js









;
function execSelectionSetKeyArgs(options) {
    return [
        options.selectionSet,
        options.objectOrReference,
        options.context,
        options.context.canonizeResults,
    ];
}
var StoreReader = (function () {
    function StoreReader(config) {
        var _this = this;
        this.knownResults = new (canUse/* canUseWeakMap */.mr ? WeakMap : Map)();
        this.config = (0,compact/* compact */.o)(config, {
            addTypename: config.addTypename !== false,
            canonizeResults: (0,helpers/* shouldCanonizeResults */.lg)(config),
        });
        this.canon = config.canon || new object_canon/* ObjectCanon */.h;
        this.executeSelectionSet = (0,bundle_esm/* wrap */.re)(function (options) {
            var _a;
            var canonizeResults = options.context.canonizeResults;
            var peekArgs = execSelectionSetKeyArgs(options);
            peekArgs[3] = !canonizeResults;
            var other = (_a = _this.executeSelectionSet).peek.apply(_a, peekArgs);
            if (other) {
                if (canonizeResults) {
                    return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, other), { result: _this.canon.admit(other.result) });
                }
                return other;
            }
            maybeDependOnExistenceOfEntity(options.context.store, options.enclosingRef.__ref);
            return _this.execSelectionSetImpl(options);
        }, {
            max: this.config.resultCacheMaxSize,
            keyArgs: execSelectionSetKeyArgs,
            makeCacheKey: function (selectionSet, parent, context, canonizeResults) {
                if (supportsResultCaching(context.store)) {
                    return context.store.makeCacheKey(selectionSet, (0,storeUtils/* isReference */.Yk)(parent) ? parent.__ref : parent, context.varString, canonizeResults);
                }
            }
        });
        this.executeSubSelectedArray = (0,bundle_esm/* wrap */.re)(function (options) {
            maybeDependOnExistenceOfEntity(options.context.store, options.enclosingRef.__ref);
            return _this.execSubSelectedArrayImpl(options);
        }, {
            max: this.config.resultCacheMaxSize,
            makeCacheKey: function (_a) {
                var field = _a.field, array = _a.array, context = _a.context;
                if (supportsResultCaching(context.store)) {
                    return context.store.makeCacheKey(field, array, context.varString);
                }
            }
        });
    }
    StoreReader.prototype.resetCanon = function () {
        this.canon = new object_canon/* ObjectCanon */.h;
    };
    StoreReader.prototype.diffQueryAgainstStore = function (_a) {
        var store = _a.store, query = _a.query, _b = _a.rootId, rootId = _b === void 0 ? 'ROOT_QUERY' : _b, variables = _a.variables, _c = _a.returnPartialData, returnPartialData = _c === void 0 ? true : _c, _d = _a.canonizeResults, canonizeResults = _d === void 0 ? this.config.canonizeResults : _d;
        var policies = this.config.cache.policies;
        variables = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, (0,getFromAST/* getDefaultValues */.O4)((0,getFromAST/* getQueryDefinition */.iW)(query))), variables);
        var rootRef = (0,storeUtils/* makeReference */.kQ)(rootId);
        var execResult = this.executeSelectionSet({
            selectionSet: (0,getFromAST/* getMainDefinition */.p$)(query).selectionSet,
            objectOrReference: rootRef,
            enclosingRef: rootRef,
            context: (0,tslib_es6/* __assign */.pi)({ store: store, query: query, policies: policies, variables: variables, varString: (0,object_canon/* canonicalStringify */.B)(variables), canonizeResults: canonizeResults }, (0,helpers/* extractFragmentContext */.Is)(query, this.config.fragments)),
        });
        var missing;
        if (execResult.missing) {
            missing = [new common/* MissingFieldError */.y(firstMissing(execResult.missing), execResult.missing, query, variables)];
            if (!returnPartialData) {
                throw missing[0];
            }
        }
        return {
            result: execResult.result,
            complete: !missing,
            missing: missing,
        };
    };
    StoreReader.prototype.isFresh = function (result, parent, selectionSet, context) {
        if (supportsResultCaching(context.store) &&
            this.knownResults.get(result) === selectionSet) {
            var latest = this.executeSelectionSet.peek(selectionSet, parent, context, this.canon.isKnown(result));
            if (latest && result === latest.result) {
                return true;
            }
        }
        return false;
    };
    StoreReader.prototype.execSelectionSetImpl = function (_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, objectOrReference = _a.objectOrReference, enclosingRef = _a.enclosingRef, context = _a.context;
        if ((0,storeUtils/* isReference */.Yk)(objectOrReference) &&
            !context.policies.rootTypenamesById[objectOrReference.__ref] &&
            !context.store.has(objectOrReference.__ref)) {
            return {
                result: this.canon.empty,
                missing: "Dangling reference to missing ".concat(objectOrReference.__ref, " object"),
            };
        }
        var variables = context.variables, policies = context.policies, store = context.store;
        var typename = store.getFieldValue(objectOrReference, "__typename");
        var objectsToMerge = [];
        var missing;
        var missingMerger = new mergeDeep/* DeepMerger */.w0();
        if (this.config.addTypename &&
            typeof typename === "string" &&
            !policies.rootIdsByTypename[typename]) {
            objectsToMerge.push({ __typename: typename });
        }
        function handleMissing(result, resultName) {
            var _a;
            if (result.missing) {
                missing = missingMerger.merge(missing, (_a = {}, _a[resultName] = result.missing, _a));
            }
            return result.result;
        }
        var workSet = new Set(selectionSet.selections);
        workSet.forEach(function (selection) {
            var _a, _b;
            if (!(0,directives/* shouldInclude */.LZ)(selection, variables))
                return;
            if ((0,storeUtils/* isField */.My)(selection)) {
                var fieldValue = policies.readField({
                    fieldName: selection.name.value,
                    field: selection,
                    variables: context.variables,
                    from: objectOrReference,
                }, context);
                var resultName = (0,storeUtils/* resultKeyNameFromField */.u2)(selection);
                if (fieldValue === void 0) {
                    if (!transform/* addTypenameToDocument.added */.Gw.added(selection)) {
                        missing = missingMerger.merge(missing, (_a = {},
                            _a[resultName] = "Can't find field '".concat(selection.name.value, "' on ").concat((0,storeUtils/* isReference */.Yk)(objectOrReference)
                                ? objectOrReference.__ref + " object"
                                : "object " + JSON.stringify(objectOrReference, null, 2)),
                            _a));
                    }
                }
                else if ((0,helpers/* isArray */.kJ)(fieldValue)) {
                    fieldValue = handleMissing(_this.executeSubSelectedArray({
                        field: selection,
                        array: fieldValue,
                        enclosingRef: enclosingRef,
                        context: context,
                    }), resultName);
                }
                else if (!selection.selectionSet) {
                    if (context.canonizeResults) {
                        fieldValue = _this.canon.pass(fieldValue);
                    }
                }
                else if (fieldValue != null) {
                    fieldValue = handleMissing(_this.executeSelectionSet({
                        selectionSet: selection.selectionSet,
                        objectOrReference: fieldValue,
                        enclosingRef: (0,storeUtils/* isReference */.Yk)(fieldValue) ? fieldValue : enclosingRef,
                        context: context,
                    }), resultName);
                }
                if (fieldValue !== void 0) {
                    objectsToMerge.push((_b = {}, _b[resultName] = fieldValue, _b));
                }
            }
            else {
                var fragment = (0,fragments/* getFragmentFromSelection */.hi)(selection, context.lookupFragment);
                if (!fragment && selection.kind === kinds/* Kind.FRAGMENT_SPREAD */.h.FRAGMENT_SPREAD) {
                    throw __DEV__ ? new globals/* InvariantError */.ej("No fragment named ".concat(selection.name.value)) : new globals/* InvariantError */.ej(5);
                }
                if (fragment && policies.fragmentMatches(fragment, typename)) {
                    fragment.selectionSet.selections.forEach(workSet.add, workSet);
                }
            }
        });
        var result = (0,mergeDeep/* mergeDeepArray */.bw)(objectsToMerge);
        var finalResult = { result: result, missing: missing };
        var frozen = context.canonizeResults
            ? this.canon.admit(finalResult)
            : (0,maybeDeepFreeze/* maybeDeepFreeze */.J)(finalResult);
        if (frozen.result) {
            this.knownResults.set(frozen.result, selectionSet);
        }
        return frozen;
    };
    StoreReader.prototype.execSubSelectedArrayImpl = function (_a) {
        var _this = this;
        var field = _a.field, array = _a.array, enclosingRef = _a.enclosingRef, context = _a.context;
        var missing;
        var missingMerger = new mergeDeep/* DeepMerger */.w0();
        function handleMissing(childResult, i) {
            var _a;
            if (childResult.missing) {
                missing = missingMerger.merge(missing, (_a = {}, _a[i] = childResult.missing, _a));
            }
            return childResult.result;
        }
        if (field.selectionSet) {
            array = array.filter(context.store.canRead);
        }
        array = array.map(function (item, i) {
            if (item === null) {
                return null;
            }
            if ((0,helpers/* isArray */.kJ)(item)) {
                return handleMissing(_this.executeSubSelectedArray({
                    field: field,
                    array: item,
                    enclosingRef: enclosingRef,
                    context: context,
                }), i);
            }
            if (field.selectionSet) {
                return handleMissing(_this.executeSelectionSet({
                    selectionSet: field.selectionSet,
                    objectOrReference: item,
                    enclosingRef: (0,storeUtils/* isReference */.Yk)(item) ? item : enclosingRef,
                    context: context,
                }), i);
            }
            if (__DEV__) {
                assertSelectionSetForIdValue(context.store, field, item);
            }
            return item;
        });
        return {
            result: context.canonizeResults ? this.canon.admit(array) : array,
            missing: missing,
        };
    };
    return StoreReader;
}());

function firstMissing(tree) {
    try {
        JSON.stringify(tree, function (_, value) {
            if (typeof value === "string")
                throw value;
            return value;
        });
    }
    catch (result) {
        return result;
    }
}
function assertSelectionSetForIdValue(store, field, fieldValue) {
    if (!field.selectionSet) {
        var workSet_1 = new Set([fieldValue]);
        workSet_1.forEach(function (value) {
            if ((0,objects/* isNonNullObject */.s)(value)) {
                __DEV__ ? (0,globals/* invariant */.kG)(!(0,storeUtils/* isReference */.Yk)(value), "Missing selection set for object of type ".concat((0,helpers/* getTypenameFromStoreObject */.jp)(store, value), " returned for query field ").concat(field.name.value)) : (0,globals/* invariant */.kG)(!(0,storeUtils/* isReference */.Yk)(value), 6);
                Object.values(value).forEach(workSet_1.add, workSet_1);
            }
        });
    }
}
//# sourceMappingURL=readFromStore.js.map
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/cloneDeep.js
var cloneDeep = __webpack_require__(79487);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/arrays.js
var arrays = __webpack_require__(21436);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/makeUniqueId.js
var makeUniqueId = __webpack_require__(60897);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/utilities/common/stringifyForDisplay.js

function stringifyForDisplay(value) {
    var undefId = (0,makeUniqueId/* makeUniqueId */.X)("stringifyForDisplay");
    return JSON.stringify(value, function (key, value) {
        return value === void 0 ? undefId : value;
    }).split(JSON.stringify(undefId)).join("<undefined>");
}
//# sourceMappingURL=stringifyForDisplay.js.map
// EXTERNAL MODULE: ./node_modules/@apollo/client/cache/inmemory/reactiveVars.js + 1 modules
var reactiveVars = __webpack_require__(9237);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/cache/inmemory/key-extractor.js



var specifierInfoCache = Object.create(null);
function lookupSpecifierInfo(spec) {
    var cacheKey = JSON.stringify(spec);
    return specifierInfoCache[cacheKey] ||
        (specifierInfoCache[cacheKey] = Object.create(null));
}
function keyFieldsFnFromSpecifier(specifier) {
    var info = lookupSpecifierInfo(specifier);
    return info.keyFieldsFn || (info.keyFieldsFn = function (object, context) {
        var extract = function (from, key) { return context.readField(key, from); };
        var keyObject = context.keyObject = collectSpecifierPaths(specifier, function (schemaKeyPath) {
            var extracted = extractKeyPath(context.storeObject, schemaKeyPath, extract);
            if (extracted === void 0 &&
                object !== context.storeObject &&
                helpers/* hasOwn.call */.RI.call(object, schemaKeyPath[0])) {
                extracted = extractKeyPath(object, schemaKeyPath, extractKey);
            }
            __DEV__ ? (0,globals/* invariant */.kG)(extracted !== void 0, "Missing field '".concat(schemaKeyPath.join('.'), "' while extracting keyFields from ").concat(JSON.stringify(object))) : (0,globals/* invariant */.kG)(extracted !== void 0, 2);
            return extracted;
        });
        return "".concat(context.typename, ":").concat(JSON.stringify(keyObject));
    });
}
function keyArgsFnFromSpecifier(specifier) {
    var info = lookupSpecifierInfo(specifier);
    return info.keyArgsFn || (info.keyArgsFn = function (args, _a) {
        var field = _a.field, variables = _a.variables, fieldName = _a.fieldName;
        var collected = collectSpecifierPaths(specifier, function (keyPath) {
            var firstKey = keyPath[0];
            var firstChar = firstKey.charAt(0);
            if (firstChar === "@") {
                if (field && (0,arrays/* isNonEmptyArray */.O)(field.directives)) {
                    var directiveName_1 = firstKey.slice(1);
                    var d = field.directives.find(function (d) { return d.name.value === directiveName_1; });
                    var directiveArgs = d && (0,storeUtils/* argumentsObjectFromField */.NC)(d, variables);
                    return directiveArgs && extractKeyPath(directiveArgs, keyPath.slice(1));
                }
                return;
            }
            if (firstChar === "$") {
                var variableName = firstKey.slice(1);
                if (variables && helpers/* hasOwn.call */.RI.call(variables, variableName)) {
                    var varKeyPath = keyPath.slice(0);
                    varKeyPath[0] = variableName;
                    return extractKeyPath(variables, varKeyPath);
                }
                return;
            }
            if (args) {
                return extractKeyPath(args, keyPath);
            }
        });
        var suffix = JSON.stringify(collected);
        if (args || suffix !== "{}") {
            fieldName += ":" + suffix;
        }
        return fieldName;
    });
}
function collectSpecifierPaths(specifier, extractor) {
    var merger = new mergeDeep/* DeepMerger */.w0;
    return getSpecifierPaths(specifier).reduce(function (collected, path) {
        var _a;
        var toMerge = extractor(path);
        if (toMerge !== void 0) {
            for (var i = path.length - 1; i >= 0; --i) {
                toMerge = (_a = {}, _a[path[i]] = toMerge, _a);
            }
            collected = merger.merge(collected, toMerge);
        }
        return collected;
    }, Object.create(null));
}
function getSpecifierPaths(spec) {
    var info = lookupSpecifierInfo(spec);
    if (!info.paths) {
        var paths_1 = info.paths = [];
        var currentPath_1 = [];
        spec.forEach(function (s, i) {
            if ((0,helpers/* isArray */.kJ)(s)) {
                getSpecifierPaths(s).forEach(function (p) { return paths_1.push(currentPath_1.concat(p)); });
                currentPath_1.length = 0;
            }
            else {
                currentPath_1.push(s);
                if (!(0,helpers/* isArray */.kJ)(spec[i + 1])) {
                    paths_1.push(currentPath_1.slice(0));
                    currentPath_1.length = 0;
                }
            }
        });
    }
    return info.paths;
}
function extractKey(object, key) {
    return object[key];
}
function extractKeyPath(object, path, extract) {
    extract = extract || extractKey;
    return normalize(path.reduce(function reducer(obj, key) {
        return (0,helpers/* isArray */.kJ)(obj)
            ? obj.map(function (child) { return reducer(child, key); })
            : obj && extract(obj, key);
    }, object));
}
function normalize(value) {
    if ((0,objects/* isNonNullObject */.s)(value)) {
        if ((0,helpers/* isArray */.kJ)(value)) {
            return value.map(normalize);
        }
        return collectSpecifierPaths(Object.keys(value).sort(), function (path) { return extractKeyPath(value, path); });
    }
    return value;
}
//# sourceMappingURL=key-extractor.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/cache/inmemory/policies.js







storeUtils/* getStoreKeyName.setStringify */.PT.setStringify(object_canon/* canonicalStringify */.B);
function argsFromFieldSpecifier(spec) {
    return spec.args !== void 0 ? spec.args :
        spec.field ? (0,storeUtils/* argumentsObjectFromField */.NC)(spec.field, spec.variables) : null;
}
var nullKeyFieldsFn = function () { return void 0; };
var simpleKeyArgsFn = function (_args, context) { return context.fieldName; };
var mergeTrueFn = function (existing, incoming, _a) {
    var mergeObjects = _a.mergeObjects;
    return mergeObjects(existing, incoming);
};
var mergeFalseFn = function (_, incoming) { return incoming; };
var Policies = (function () {
    function Policies(config) {
        this.config = config;
        this.typePolicies = Object.create(null);
        this.toBeAdded = Object.create(null);
        this.supertypeMap = new Map();
        this.fuzzySubtypes = new Map();
        this.rootIdsByTypename = Object.create(null);
        this.rootTypenamesById = Object.create(null);
        this.usingPossibleTypes = false;
        this.config = (0,tslib_es6/* __assign */.pi)({ dataIdFromObject: helpers/* defaultDataIdFromObject */.uG }, config);
        this.cache = this.config.cache;
        this.setRootTypename("Query");
        this.setRootTypename("Mutation");
        this.setRootTypename("Subscription");
        if (config.possibleTypes) {
            this.addPossibleTypes(config.possibleTypes);
        }
        if (config.typePolicies) {
            this.addTypePolicies(config.typePolicies);
        }
    }
    Policies.prototype.identify = function (object, partialContext) {
        var _a;
        var policies = this;
        var typename = partialContext && (partialContext.typename ||
            ((_a = partialContext.storeObject) === null || _a === void 0 ? void 0 : _a.__typename)) || object.__typename;
        if (typename === this.rootTypenamesById.ROOT_QUERY) {
            return ["ROOT_QUERY"];
        }
        var storeObject = partialContext && partialContext.storeObject || object;
        var context = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, partialContext), { typename: typename, storeObject: storeObject, readField: partialContext && partialContext.readField || function () {
                var options = normalizeReadFieldOptions(arguments, storeObject);
                return policies.readField(options, {
                    store: policies.cache["data"],
                    variables: options.variables,
                });
            } });
        var id;
        var policy = typename && this.getTypePolicy(typename);
        var keyFn = policy && policy.keyFn || this.config.dataIdFromObject;
        while (keyFn) {
            var specifierOrId = keyFn(object, context);
            if ((0,helpers/* isArray */.kJ)(specifierOrId)) {
                keyFn = keyFieldsFnFromSpecifier(specifierOrId);
            }
            else {
                id = specifierOrId;
                break;
            }
        }
        id = id ? String(id) : void 0;
        return context.keyObject ? [id, context.keyObject] : [id];
    };
    Policies.prototype.addTypePolicies = function (typePolicies) {
        var _this = this;
        Object.keys(typePolicies).forEach(function (typename) {
            var _a = typePolicies[typename], queryType = _a.queryType, mutationType = _a.mutationType, subscriptionType = _a.subscriptionType, incoming = (0,tslib_es6/* __rest */._T)(_a, ["queryType", "mutationType", "subscriptionType"]);
            if (queryType)
                _this.setRootTypename("Query", typename);
            if (mutationType)
                _this.setRootTypename("Mutation", typename);
            if (subscriptionType)
                _this.setRootTypename("Subscription", typename);
            if (helpers/* hasOwn.call */.RI.call(_this.toBeAdded, typename)) {
                _this.toBeAdded[typename].push(incoming);
            }
            else {
                _this.toBeAdded[typename] = [incoming];
            }
        });
    };
    Policies.prototype.updateTypePolicy = function (typename, incoming) {
        var _this = this;
        var existing = this.getTypePolicy(typename);
        var keyFields = incoming.keyFields, fields = incoming.fields;
        function setMerge(existing, merge) {
            existing.merge =
                typeof merge === "function" ? merge :
                    merge === true ? mergeTrueFn :
                        merge === false ? mergeFalseFn :
                            existing.merge;
        }
        setMerge(existing, incoming.merge);
        existing.keyFn =
            keyFields === false ? nullKeyFieldsFn :
                (0,helpers/* isArray */.kJ)(keyFields) ? keyFieldsFnFromSpecifier(keyFields) :
                    typeof keyFields === "function" ? keyFields :
                        existing.keyFn;
        if (fields) {
            Object.keys(fields).forEach(function (fieldName) {
                var existing = _this.getFieldPolicy(typename, fieldName, true);
                var incoming = fields[fieldName];
                if (typeof incoming === "function") {
                    existing.read = incoming;
                }
                else {
                    var keyArgs = incoming.keyArgs, read = incoming.read, merge = incoming.merge;
                    existing.keyFn =
                        keyArgs === false ? simpleKeyArgsFn :
                            (0,helpers/* isArray */.kJ)(keyArgs) ? keyArgsFnFromSpecifier(keyArgs) :
                                typeof keyArgs === "function" ? keyArgs :
                                    existing.keyFn;
                    if (typeof read === "function") {
                        existing.read = read;
                    }
                    setMerge(existing, merge);
                }
                if (existing.read && existing.merge) {
                    existing.keyFn = existing.keyFn || simpleKeyArgsFn;
                }
            });
        }
    };
    Policies.prototype.setRootTypename = function (which, typename) {
        if (typename === void 0) { typename = which; }
        var rootId = "ROOT_" + which.toUpperCase();
        var old = this.rootTypenamesById[rootId];
        if (typename !== old) {
            __DEV__ ? (0,globals/* invariant */.kG)(!old || old === which, "Cannot change root ".concat(which, " __typename more than once")) : (0,globals/* invariant */.kG)(!old || old === which, 3);
            if (old)
                delete this.rootIdsByTypename[old];
            this.rootIdsByTypename[typename] = rootId;
            this.rootTypenamesById[rootId] = typename;
        }
    };
    Policies.prototype.addPossibleTypes = function (possibleTypes) {
        var _this = this;
        this.usingPossibleTypes = true;
        Object.keys(possibleTypes).forEach(function (supertype) {
            _this.getSupertypeSet(supertype, true);
            possibleTypes[supertype].forEach(function (subtype) {
                _this.getSupertypeSet(subtype, true).add(supertype);
                var match = subtype.match(helpers/* TypeOrFieldNameRegExp */.$O);
                if (!match || match[0] !== subtype) {
                    _this.fuzzySubtypes.set(subtype, new RegExp(subtype));
                }
            });
        });
    };
    Policies.prototype.getTypePolicy = function (typename) {
        var _this = this;
        if (!helpers/* hasOwn.call */.RI.call(this.typePolicies, typename)) {
            var policy_1 = this.typePolicies[typename] = Object.create(null);
            policy_1.fields = Object.create(null);
            var supertypes = this.supertypeMap.get(typename);
            if (supertypes && supertypes.size) {
                supertypes.forEach(function (supertype) {
                    var _a = _this.getTypePolicy(supertype), fields = _a.fields, rest = (0,tslib_es6/* __rest */._T)(_a, ["fields"]);
                    Object.assign(policy_1, rest);
                    Object.assign(policy_1.fields, fields);
                });
            }
        }
        var inbox = this.toBeAdded[typename];
        if (inbox && inbox.length) {
            inbox.splice(0).forEach(function (policy) {
                _this.updateTypePolicy(typename, policy);
            });
        }
        return this.typePolicies[typename];
    };
    Policies.prototype.getFieldPolicy = function (typename, fieldName, createIfMissing) {
        if (typename) {
            var fieldPolicies = this.getTypePolicy(typename).fields;
            return fieldPolicies[fieldName] || (createIfMissing && (fieldPolicies[fieldName] = Object.create(null)));
        }
    };
    Policies.prototype.getSupertypeSet = function (subtype, createIfMissing) {
        var supertypeSet = this.supertypeMap.get(subtype);
        if (!supertypeSet && createIfMissing) {
            this.supertypeMap.set(subtype, supertypeSet = new Set());
        }
        return supertypeSet;
    };
    Policies.prototype.fragmentMatches = function (fragment, typename, result, variables) {
        var _this = this;
        if (!fragment.typeCondition)
            return true;
        if (!typename)
            return false;
        var supertype = fragment.typeCondition.name.value;
        if (typename === supertype)
            return true;
        if (this.usingPossibleTypes &&
            this.supertypeMap.has(supertype)) {
            var typenameSupertypeSet = this.getSupertypeSet(typename, true);
            var workQueue_1 = [typenameSupertypeSet];
            var maybeEnqueue_1 = function (subtype) {
                var supertypeSet = _this.getSupertypeSet(subtype, false);
                if (supertypeSet &&
                    supertypeSet.size &&
                    workQueue_1.indexOf(supertypeSet) < 0) {
                    workQueue_1.push(supertypeSet);
                }
            };
            var needToCheckFuzzySubtypes = !!(result && this.fuzzySubtypes.size);
            var checkingFuzzySubtypes = false;
            for (var i = 0; i < workQueue_1.length; ++i) {
                var supertypeSet = workQueue_1[i];
                if (supertypeSet.has(supertype)) {
                    if (!typenameSupertypeSet.has(supertype)) {
                        if (checkingFuzzySubtypes) {
                            __DEV__ && globals/* invariant.warn */.kG.warn("Inferring subtype ".concat(typename, " of supertype ").concat(supertype));
                        }
                        typenameSupertypeSet.add(supertype);
                    }
                    return true;
                }
                supertypeSet.forEach(maybeEnqueue_1);
                if (needToCheckFuzzySubtypes &&
                    i === workQueue_1.length - 1 &&
                    (0,helpers/* selectionSetMatchesResult */.RC)(fragment.selectionSet, result, variables)) {
                    needToCheckFuzzySubtypes = false;
                    checkingFuzzySubtypes = true;
                    this.fuzzySubtypes.forEach(function (regExp, fuzzyString) {
                        var match = typename.match(regExp);
                        if (match && match[0] === typename) {
                            maybeEnqueue_1(fuzzyString);
                        }
                    });
                }
            }
        }
        return false;
    };
    Policies.prototype.hasKeyArgs = function (typename, fieldName) {
        var policy = this.getFieldPolicy(typename, fieldName, false);
        return !!(policy && policy.keyFn);
    };
    Policies.prototype.getStoreFieldName = function (fieldSpec) {
        var typename = fieldSpec.typename, fieldName = fieldSpec.fieldName;
        var policy = this.getFieldPolicy(typename, fieldName, false);
        var storeFieldName;
        var keyFn = policy && policy.keyFn;
        if (keyFn && typename) {
            var context = {
                typename: typename,
                fieldName: fieldName,
                field: fieldSpec.field || null,
                variables: fieldSpec.variables,
            };
            var args = argsFromFieldSpecifier(fieldSpec);
            while (keyFn) {
                var specifierOrString = keyFn(args, context);
                if ((0,helpers/* isArray */.kJ)(specifierOrString)) {
                    keyFn = keyArgsFnFromSpecifier(specifierOrString);
                }
                else {
                    storeFieldName = specifierOrString || fieldName;
                    break;
                }
            }
        }
        if (storeFieldName === void 0) {
            storeFieldName = fieldSpec.field
                ? (0,storeUtils/* storeKeyNameFromField */.vf)(fieldSpec.field, fieldSpec.variables)
                : (0,storeUtils/* getStoreKeyName */.PT)(fieldName, argsFromFieldSpecifier(fieldSpec));
        }
        if (storeFieldName === false) {
            return fieldName;
        }
        return fieldName === (0,helpers/* fieldNameFromStoreName */.E_)(storeFieldName)
            ? storeFieldName
            : fieldName + ":" + storeFieldName;
    };
    Policies.prototype.readField = function (options, context) {
        var objectOrReference = options.from;
        if (!objectOrReference)
            return;
        var nameOrField = options.field || options.fieldName;
        if (!nameOrField)
            return;
        if (options.typename === void 0) {
            var typename = context.store.getFieldValue(objectOrReference, "__typename");
            if (typename)
                options.typename = typename;
        }
        var storeFieldName = this.getStoreFieldName(options);
        var fieldName = (0,helpers/* fieldNameFromStoreName */.E_)(storeFieldName);
        var existing = context.store.getFieldValue(objectOrReference, storeFieldName);
        var policy = this.getFieldPolicy(options.typename, fieldName, false);
        var read = policy && policy.read;
        if (read) {
            var readOptions = makeFieldFunctionOptions(this, objectOrReference, options, context, context.store.getStorage((0,storeUtils/* isReference */.Yk)(objectOrReference)
                ? objectOrReference.__ref
                : objectOrReference, storeFieldName));
            return reactiveVars/* cacheSlot.withValue */.ab.withValue(this.cache, read, [existing, readOptions]);
        }
        return existing;
    };
    Policies.prototype.getReadFunction = function (typename, fieldName) {
        var policy = this.getFieldPolicy(typename, fieldName, false);
        return policy && policy.read;
    };
    Policies.prototype.getMergeFunction = function (parentTypename, fieldName, childTypename) {
        var policy = this.getFieldPolicy(parentTypename, fieldName, false);
        var merge = policy && policy.merge;
        if (!merge && childTypename) {
            policy = this.getTypePolicy(childTypename);
            merge = policy && policy.merge;
        }
        return merge;
    };
    Policies.prototype.runMergeFunction = function (existing, incoming, _a, context, storage) {
        var field = _a.field, typename = _a.typename, merge = _a.merge;
        if (merge === mergeTrueFn) {
            return makeMergeObjectsFunction(context.store)(existing, incoming);
        }
        if (merge === mergeFalseFn) {
            return incoming;
        }
        if (context.overwrite) {
            existing = void 0;
        }
        return merge(existing, incoming, makeFieldFunctionOptions(this, void 0, { typename: typename, fieldName: field.name.value, field: field, variables: context.variables }, context, storage || Object.create(null)));
    };
    return Policies;
}());

function makeFieldFunctionOptions(policies, objectOrReference, fieldSpec, context, storage) {
    var storeFieldName = policies.getStoreFieldName(fieldSpec);
    var fieldName = (0,helpers/* fieldNameFromStoreName */.E_)(storeFieldName);
    var variables = fieldSpec.variables || context.variables;
    var _a = context.store, toReference = _a.toReference, canRead = _a.canRead;
    return {
        args: argsFromFieldSpecifier(fieldSpec),
        field: fieldSpec.field || null,
        fieldName: fieldName,
        storeFieldName: storeFieldName,
        variables: variables,
        isReference: storeUtils/* isReference */.Yk,
        toReference: toReference,
        storage: storage,
        cache: policies.cache,
        canRead: canRead,
        readField: function () {
            return policies.readField(normalizeReadFieldOptions(arguments, objectOrReference, variables), context);
        },
        mergeObjects: makeMergeObjectsFunction(context.store),
    };
}
function normalizeReadFieldOptions(readFieldArgs, objectOrReference, variables) {
    var fieldNameOrOptions = readFieldArgs[0], from = readFieldArgs[1], argc = readFieldArgs.length;
    var options;
    if (typeof fieldNameOrOptions === "string") {
        options = {
            fieldName: fieldNameOrOptions,
            from: argc > 1 ? from : objectOrReference,
        };
    }
    else {
        options = (0,tslib_es6/* __assign */.pi)({}, fieldNameOrOptions);
        if (!helpers/* hasOwn.call */.RI.call(options, "from")) {
            options.from = objectOrReference;
        }
    }
    if (__DEV__ && options.from === void 0) {
        __DEV__ && globals/* invariant.warn */.kG.warn("Undefined 'from' passed to readField with arguments ".concat(stringifyForDisplay(Array.from(readFieldArgs))));
    }
    if (void 0 === options.variables) {
        options.variables = variables;
    }
    return options;
}
function makeMergeObjectsFunction(store) {
    return function mergeObjects(existing, incoming) {
        if ((0,helpers/* isArray */.kJ)(existing) || (0,helpers/* isArray */.kJ)(incoming)) {
            throw __DEV__ ? new globals/* InvariantError */.ej("Cannot automatically merge arrays") : new globals/* InvariantError */.ej(4);
        }
        if ((0,objects/* isNonNullObject */.s)(existing) &&
            (0,objects/* isNonNullObject */.s)(incoming)) {
            var eType = store.getFieldValue(existing, "__typename");
            var iType = store.getFieldValue(incoming, "__typename");
            var typesDiffer = eType && iType && eType !== iType;
            if (typesDiffer) {
                return incoming;
            }
            if ((0,storeUtils/* isReference */.Yk)(existing) &&
                (0,helpers/* storeValueIsStoreObject */.j)(incoming)) {
                store.merge(existing.__ref, incoming);
                return existing;
            }
            if ((0,helpers/* storeValueIsStoreObject */.j)(existing) &&
                (0,storeUtils/* isReference */.Yk)(incoming)) {
                store.merge(existing, incoming.__ref);
                return incoming;
            }
            if ((0,helpers/* storeValueIsStoreObject */.j)(existing) &&
                (0,helpers/* storeValueIsStoreObject */.j)(incoming)) {
                return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, existing), incoming);
            }
        }
        return incoming;
    };
}
//# sourceMappingURL=policies.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/cache/inmemory/writeToStore.js









;
function getContextFlavor(context, clientOnly, deferred) {
    var key = "".concat(clientOnly).concat(deferred);
    var flavored = context.flavors.get(key);
    if (!flavored) {
        context.flavors.set(key, flavored = (context.clientOnly === clientOnly &&
            context.deferred === deferred) ? context : (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, context), { clientOnly: clientOnly, deferred: deferred }));
    }
    return flavored;
}
var StoreWriter = (function () {
    function StoreWriter(cache, reader, fragments) {
        this.cache = cache;
        this.reader = reader;
        this.fragments = fragments;
    }
    StoreWriter.prototype.writeToStore = function (store, _a) {
        var _this = this;
        var query = _a.query, result = _a.result, dataId = _a.dataId, variables = _a.variables, overwrite = _a.overwrite;
        var operationDefinition = (0,getFromAST/* getOperationDefinition */.$H)(query);
        var merger = (0,helpers/* makeProcessedFieldsMerger */.ig)();
        variables = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, (0,getFromAST/* getDefaultValues */.O4)(operationDefinition)), variables);
        var context = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({ store: store, written: Object.create(null), merge: function (existing, incoming) {
                return merger.merge(existing, incoming);
            }, variables: variables, varString: (0,object_canon/* canonicalStringify */.B)(variables) }, (0,helpers/* extractFragmentContext */.Is)(query, this.fragments)), { overwrite: !!overwrite, incomingById: new Map, clientOnly: false, deferred: false, flavors: new Map });
        var ref = this.processSelectionSet({
            result: result || Object.create(null),
            dataId: dataId,
            selectionSet: operationDefinition.selectionSet,
            mergeTree: { map: new Map },
            context: context,
        });
        if (!(0,storeUtils/* isReference */.Yk)(ref)) {
            throw __DEV__ ? new globals/* InvariantError */.ej("Could not identify object ".concat(JSON.stringify(result))) : new globals/* InvariantError */.ej(7);
        }
        context.incomingById.forEach(function (_a, dataId) {
            var storeObject = _a.storeObject, mergeTree = _a.mergeTree, fieldNodeSet = _a.fieldNodeSet;
            var entityRef = (0,storeUtils/* makeReference */.kQ)(dataId);
            if (mergeTree && mergeTree.map.size) {
                var applied = _this.applyMerges(mergeTree, entityRef, storeObject, context);
                if ((0,storeUtils/* isReference */.Yk)(applied)) {
                    return;
                }
                storeObject = applied;
            }
            if (__DEV__ && !context.overwrite) {
                var fieldsWithSelectionSets_1 = Object.create(null);
                fieldNodeSet.forEach(function (field) {
                    if (field.selectionSet) {
                        fieldsWithSelectionSets_1[field.name.value] = true;
                    }
                });
                var hasSelectionSet_1 = function (storeFieldName) {
                    return fieldsWithSelectionSets_1[(0,helpers/* fieldNameFromStoreName */.E_)(storeFieldName)] === true;
                };
                var hasMergeFunction_1 = function (storeFieldName) {
                    var childTree = mergeTree && mergeTree.map.get(storeFieldName);
                    return Boolean(childTree && childTree.info && childTree.info.merge);
                };
                Object.keys(storeObject).forEach(function (storeFieldName) {
                    if (hasSelectionSet_1(storeFieldName) &&
                        !hasMergeFunction_1(storeFieldName)) {
                        warnAboutDataLoss(entityRef, storeObject, storeFieldName, context.store);
                    }
                });
            }
            store.merge(dataId, storeObject);
        });
        store.retain(ref.__ref);
        return ref;
    };
    StoreWriter.prototype.processSelectionSet = function (_a) {
        var _this = this;
        var dataId = _a.dataId, result = _a.result, selectionSet = _a.selectionSet, context = _a.context, mergeTree = _a.mergeTree;
        var policies = this.cache.policies;
        var incoming = Object.create(null);
        var typename = (dataId && policies.rootTypenamesById[dataId]) ||
            (0,storeUtils/* getTypenameFromResult */.qw)(result, selectionSet, context.fragmentMap) ||
            (dataId && context.store.get(dataId, "__typename"));
        if ("string" === typeof typename) {
            incoming.__typename = typename;
        }
        var readField = function () {
            var options = normalizeReadFieldOptions(arguments, incoming, context.variables);
            if ((0,storeUtils/* isReference */.Yk)(options.from)) {
                var info = context.incomingById.get(options.from.__ref);
                if (info) {
                    var result_1 = policies.readField((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { from: info.storeObject }), context);
                    if (result_1 !== void 0) {
                        return result_1;
                    }
                }
            }
            return policies.readField(options, context);
        };
        var fieldNodeSet = new Set();
        this.flattenFields(selectionSet, result, context, typename).forEach(function (context, field) {
            var _a;
            var resultFieldKey = (0,storeUtils/* resultKeyNameFromField */.u2)(field);
            var value = result[resultFieldKey];
            fieldNodeSet.add(field);
            if (value !== void 0) {
                var storeFieldName = policies.getStoreFieldName({
                    typename: typename,
                    fieldName: field.name.value,
                    field: field,
                    variables: context.variables,
                });
                var childTree = getChildMergeTree(mergeTree, storeFieldName);
                var incomingValue = _this.processFieldValue(value, field, field.selectionSet
                    ? getContextFlavor(context, false, false)
                    : context, childTree);
                var childTypename = void 0;
                if (field.selectionSet &&
                    ((0,storeUtils/* isReference */.Yk)(incomingValue) ||
                        (0,helpers/* storeValueIsStoreObject */.j)(incomingValue))) {
                    childTypename = readField("__typename", incomingValue);
                }
                var merge = policies.getMergeFunction(typename, field.name.value, childTypename);
                if (merge) {
                    childTree.info = {
                        field: field,
                        typename: typename,
                        merge: merge,
                    };
                }
                else {
                    maybeRecycleChildMergeTree(mergeTree, storeFieldName);
                }
                incoming = context.merge(incoming, (_a = {},
                    _a[storeFieldName] = incomingValue,
                    _a));
            }
            else if (__DEV__ &&
                !context.clientOnly &&
                !context.deferred &&
                !transform/* addTypenameToDocument.added */.Gw.added(field) &&
                !policies.getReadFunction(typename, field.name.value)) {
                __DEV__ && globals/* invariant.error */.kG.error("Missing field '".concat((0,storeUtils/* resultKeyNameFromField */.u2)(field), "' while writing result ").concat(JSON.stringify(result, null, 2)).substring(0, 1000));
            }
        });
        try {
            var _b = policies.identify(result, {
                typename: typename,
                selectionSet: selectionSet,
                fragmentMap: context.fragmentMap,
                storeObject: incoming,
                readField: readField,
            }), id = _b[0], keyObject = _b[1];
            dataId = dataId || id;
            if (keyObject) {
                incoming = context.merge(incoming, keyObject);
            }
        }
        catch (e) {
            if (!dataId)
                throw e;
        }
        if ("string" === typeof dataId) {
            var dataRef = (0,storeUtils/* makeReference */.kQ)(dataId);
            var sets = context.written[dataId] || (context.written[dataId] = []);
            if (sets.indexOf(selectionSet) >= 0)
                return dataRef;
            sets.push(selectionSet);
            if (this.reader && this.reader.isFresh(result, dataRef, selectionSet, context)) {
                return dataRef;
            }
            var previous_1 = context.incomingById.get(dataId);
            if (previous_1) {
                previous_1.storeObject = context.merge(previous_1.storeObject, incoming);
                previous_1.mergeTree = mergeMergeTrees(previous_1.mergeTree, mergeTree);
                fieldNodeSet.forEach(function (field) { return previous_1.fieldNodeSet.add(field); });
            }
            else {
                context.incomingById.set(dataId, {
                    storeObject: incoming,
                    mergeTree: mergeTreeIsEmpty(mergeTree) ? void 0 : mergeTree,
                    fieldNodeSet: fieldNodeSet,
                });
            }
            return dataRef;
        }
        return incoming;
    };
    StoreWriter.prototype.processFieldValue = function (value, field, context, mergeTree) {
        var _this = this;
        if (!field.selectionSet || value === null) {
            return __DEV__ ? (0,cloneDeep/* cloneDeep */.X)(value) : value;
        }
        if ((0,helpers/* isArray */.kJ)(value)) {
            return value.map(function (item, i) {
                var value = _this.processFieldValue(item, field, context, getChildMergeTree(mergeTree, i));
                maybeRecycleChildMergeTree(mergeTree, i);
                return value;
            });
        }
        return this.processSelectionSet({
            result: value,
            selectionSet: field.selectionSet,
            context: context,
            mergeTree: mergeTree,
        });
    };
    StoreWriter.prototype.flattenFields = function (selectionSet, result, context, typename) {
        if (typename === void 0) { typename = (0,storeUtils/* getTypenameFromResult */.qw)(result, selectionSet, context.fragmentMap); }
        var fieldMap = new Map();
        var policies = this.cache.policies;
        var limitingTrie = new trie_esm/* Trie */.B(false);
        (function flatten(selectionSet, inheritedContext) {
            var visitedNode = limitingTrie.lookup(selectionSet, inheritedContext.clientOnly, inheritedContext.deferred);
            if (visitedNode.visited)
                return;
            visitedNode.visited = true;
            selectionSet.selections.forEach(function (selection) {
                if (!(0,directives/* shouldInclude */.LZ)(selection, context.variables))
                    return;
                var clientOnly = inheritedContext.clientOnly, deferred = inheritedContext.deferred;
                if (!(clientOnly && deferred) &&
                    (0,arrays/* isNonEmptyArray */.O)(selection.directives)) {
                    selection.directives.forEach(function (dir) {
                        var name = dir.name.value;
                        if (name === "client")
                            clientOnly = true;
                        if (name === "defer") {
                            var args = (0,storeUtils/* argumentsObjectFromField */.NC)(dir, context.variables);
                            if (!args || args.if !== false) {
                                deferred = true;
                            }
                        }
                    });
                }
                if ((0,storeUtils/* isField */.My)(selection)) {
                    var existing = fieldMap.get(selection);
                    if (existing) {
                        clientOnly = clientOnly && existing.clientOnly;
                        deferred = deferred && existing.deferred;
                    }
                    fieldMap.set(selection, getContextFlavor(context, clientOnly, deferred));
                }
                else {
                    var fragment = (0,fragments/* getFragmentFromSelection */.hi)(selection, context.lookupFragment);
                    if (!fragment && selection.kind === kinds/* Kind.FRAGMENT_SPREAD */.h.FRAGMENT_SPREAD) {
                        throw __DEV__ ? new globals/* InvariantError */.ej("No fragment named ".concat(selection.name.value)) : new globals/* InvariantError */.ej(8);
                    }
                    if (fragment &&
                        policies.fragmentMatches(fragment, typename, result, context.variables)) {
                        flatten(fragment.selectionSet, getContextFlavor(context, clientOnly, deferred));
                    }
                }
            });
        })(selectionSet, context);
        return fieldMap;
    };
    StoreWriter.prototype.applyMerges = function (mergeTree, existing, incoming, context, getStorageArgs) {
        var _a;
        var _this = this;
        if (mergeTree.map.size && !(0,storeUtils/* isReference */.Yk)(incoming)) {
            var e_1 = (!(0,helpers/* isArray */.kJ)(incoming) &&
                ((0,storeUtils/* isReference */.Yk)(existing) || (0,helpers/* storeValueIsStoreObject */.j)(existing))) ? existing : void 0;
            var i_1 = incoming;
            if (e_1 && !getStorageArgs) {
                getStorageArgs = [(0,storeUtils/* isReference */.Yk)(e_1) ? e_1.__ref : e_1];
            }
            var changedFields_1;
            var getValue_1 = function (from, name) {
                return (0,helpers/* isArray */.kJ)(from)
                    ? (typeof name === "number" ? from[name] : void 0)
                    : context.store.getFieldValue(from, String(name));
            };
            mergeTree.map.forEach(function (childTree, storeFieldName) {
                var eVal = getValue_1(e_1, storeFieldName);
                var iVal = getValue_1(i_1, storeFieldName);
                if (void 0 === iVal)
                    return;
                if (getStorageArgs) {
                    getStorageArgs.push(storeFieldName);
                }
                var aVal = _this.applyMerges(childTree, eVal, iVal, context, getStorageArgs);
                if (aVal !== iVal) {
                    changedFields_1 = changedFields_1 || new Map;
                    changedFields_1.set(storeFieldName, aVal);
                }
                if (getStorageArgs) {
                    (0,globals/* invariant */.kG)(getStorageArgs.pop() === storeFieldName);
                }
            });
            if (changedFields_1) {
                incoming = ((0,helpers/* isArray */.kJ)(i_1) ? i_1.slice(0) : (0,tslib_es6/* __assign */.pi)({}, i_1));
                changedFields_1.forEach(function (value, name) {
                    incoming[name] = value;
                });
            }
        }
        if (mergeTree.info) {
            return this.cache.policies.runMergeFunction(existing, incoming, mergeTree.info, context, getStorageArgs && (_a = context.store).getStorage.apply(_a, getStorageArgs));
        }
        return incoming;
    };
    return StoreWriter;
}());

var emptyMergeTreePool = [];
function getChildMergeTree(_a, name) {
    var map = _a.map;
    if (!map.has(name)) {
        map.set(name, emptyMergeTreePool.pop() || { map: new Map });
    }
    return map.get(name);
}
function mergeMergeTrees(left, right) {
    if (left === right || !right || mergeTreeIsEmpty(right))
        return left;
    if (!left || mergeTreeIsEmpty(left))
        return right;
    var info = left.info && right.info ? (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, left.info), right.info) : left.info || right.info;
    var needToMergeMaps = left.map.size && right.map.size;
    var map = needToMergeMaps ? new Map :
        left.map.size ? left.map : right.map;
    var merged = { info: info, map: map };
    if (needToMergeMaps) {
        var remainingRightKeys_1 = new Set(right.map.keys());
        left.map.forEach(function (leftTree, key) {
            merged.map.set(key, mergeMergeTrees(leftTree, right.map.get(key)));
            remainingRightKeys_1.delete(key);
        });
        remainingRightKeys_1.forEach(function (key) {
            merged.map.set(key, mergeMergeTrees(right.map.get(key), left.map.get(key)));
        });
    }
    return merged;
}
function mergeTreeIsEmpty(tree) {
    return !tree || !(tree.info || tree.map.size);
}
function maybeRecycleChildMergeTree(_a, name) {
    var map = _a.map;
    var childTree = map.get(name);
    if (childTree && mergeTreeIsEmpty(childTree)) {
        emptyMergeTreePool.push(childTree);
        map.delete(name);
    }
}
var warnings = new Set();
function warnAboutDataLoss(existingRef, incomingObj, storeFieldName, store) {
    var getChild = function (objOrRef) {
        var child = store.getFieldValue(objOrRef, storeFieldName);
        return typeof child === "object" && child;
    };
    var existing = getChild(existingRef);
    if (!existing)
        return;
    var incoming = getChild(incomingObj);
    if (!incoming)
        return;
    if ((0,storeUtils/* isReference */.Yk)(existing))
        return;
    if ((0,equality_esm/* equal */.D)(existing, incoming))
        return;
    if (Object.keys(existing).every(function (key) { return store.getFieldValue(incoming, key) !== void 0; })) {
        return;
    }
    var parentType = store.getFieldValue(existingRef, "__typename") ||
        store.getFieldValue(incomingObj, "__typename");
    var fieldName = (0,helpers/* fieldNameFromStoreName */.E_)(storeFieldName);
    var typeDotName = "".concat(parentType, ".").concat(fieldName);
    if (warnings.has(typeDotName))
        return;
    warnings.add(typeDotName);
    var childTypenames = [];
    if (!(0,helpers/* isArray */.kJ)(existing) &&
        !(0,helpers/* isArray */.kJ)(incoming)) {
        [existing, incoming].forEach(function (child) {
            var typename = store.getFieldValue(child, "__typename");
            if (typeof typename === "string" &&
                !childTypenames.includes(typename)) {
                childTypenames.push(typename);
            }
        });
    }
    __DEV__ && globals/* invariant.warn */.kG.warn("Cache data may be lost when replacing the ".concat(fieldName, " field of a ").concat(parentType, " object.\n\nTo address this problem (which is not a bug in Apollo Client), ").concat(childTypenames.length
        ? "either ensure all objects of type " +
            childTypenames.join(" and ") + " have an ID or a custom merge function, or "
        : "", "define a custom merge function for the ").concat(typeDotName, " field, so InMemoryCache can safely merge these objects:\n\n  existing: ").concat(JSON.stringify(existing).slice(0, 1000), "\n  incoming: ").concat(JSON.stringify(incoming).slice(0, 1000), "\n\nFor more information about these options, please refer to the documentation:\n\n  * Ensuring entity objects have IDs: https://go.apollo.dev/c/generating-unique-identifiers\n  * Defining custom merge functions: https://go.apollo.dev/c/merging-non-normalized-objects\n"));
}
//# sourceMappingURL=writeToStore.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/cache/inmemory/inMemoryCache.js















var InMemoryCache = (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) { config = {}; }
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.typenameDocumentCache = new Map();
        _this.makeVar = reactiveVars/* makeVar */.QS;
        _this.txCount = 0;
        _this.config = (0,helpers/* normalizeConfig */.jS)(config);
        _this.addTypename = !!_this.config.addTypename;
        _this.policies = new Policies({
            cache: _this,
            dataIdFromObject: _this.config.dataIdFromObject,
            possibleTypes: _this.config.possibleTypes,
            typePolicies: _this.config.typePolicies,
        });
        _this.init();
        return _this;
    }
    InMemoryCache.prototype.init = function () {
        var rootStore = this.data = new EntityStore.Root({
            policies: this.policies,
            resultCaching: this.config.resultCaching,
        });
        this.optimisticData = rootStore.stump;
        this.resetResultCache();
    };
    InMemoryCache.prototype.resetResultCache = function (resetResultIdentities) {
        var _this = this;
        var previousReader = this.storeReader;
        var fragments = this.config.fragments;
        this.storeWriter = new StoreWriter(this, this.storeReader = new StoreReader({
            cache: this,
            addTypename: this.addTypename,
            resultCacheMaxSize: this.config.resultCacheMaxSize,
            canonizeResults: (0,helpers/* shouldCanonizeResults */.lg)(this.config),
            canon: resetResultIdentities
                ? void 0
                : previousReader && previousReader.canon,
            fragments: fragments,
        }), fragments);
        this.maybeBroadcastWatch = (0,bundle_esm/* wrap */.re)(function (c, options) {
            return _this.broadcastWatch(c, options);
        }, {
            max: this.config.resultCacheMaxSize,
            makeCacheKey: function (c) {
                var store = c.optimistic ? _this.optimisticData : _this.data;
                if (supportsResultCaching(store)) {
                    var optimistic = c.optimistic, id = c.id, variables = c.variables;
                    return store.makeCacheKey(c.query, c.callback, (0,object_canon/* canonicalStringify */.B)({ optimistic: optimistic, id: id, variables: variables }));
                }
            }
        });
        new Set([
            this.data.group,
            this.optimisticData.group,
        ]).forEach(function (group) { return group.resetCaching(); });
    };
    InMemoryCache.prototype.restore = function (data) {
        this.init();
        if (data)
            this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function (optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return (optimistic ? this.optimisticData : this.data).extract();
    };
    InMemoryCache.prototype.read = function (options) {
        var _a = options.returnPartialData, returnPartialData = _a === void 0 ? false : _a;
        try {
            return this.storeReader.diffQueryAgainstStore((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { store: options.optimistic ? this.optimisticData : this.data, config: this.config, returnPartialData: returnPartialData })).result || null;
        }
        catch (e) {
            if (e instanceof common/* MissingFieldError */.y) {
                return null;
            }
            throw e;
        }
    };
    InMemoryCache.prototype.write = function (options) {
        try {
            ++this.txCount;
            return this.storeWriter.writeToStore(this.data, options);
        }
        finally {
            if (!--this.txCount && options.broadcast !== false) {
                this.broadcastWatches();
            }
        }
    };
    InMemoryCache.prototype.modify = function (options) {
        if (helpers/* hasOwn.call */.RI.call(options, "id") && !options.id) {
            return false;
        }
        var store = options.optimistic
            ? this.optimisticData
            : this.data;
        try {
            ++this.txCount;
            return store.modify(options.id || "ROOT_QUERY", options.fields);
        }
        finally {
            if (!--this.txCount && options.broadcast !== false) {
                this.broadcastWatches();
            }
        }
    };
    InMemoryCache.prototype.diff = function (options) {
        return this.storeReader.diffQueryAgainstStore((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { store: options.optimistic ? this.optimisticData : this.data, rootId: options.id || "ROOT_QUERY", config: this.config }));
    };
    InMemoryCache.prototype.watch = function (watch) {
        var _this = this;
        if (!this.watches.size) {
            (0,reactiveVars/* recallCache */._v)(this);
        }
        this.watches.add(watch);
        if (watch.immediate) {
            this.maybeBroadcastWatch(watch);
        }
        return function () {
            if (_this.watches.delete(watch) && !_this.watches.size) {
                (0,reactiveVars/* forgetCache */.li)(_this);
            }
            _this.maybeBroadcastWatch.forget(watch);
        };
    };
    InMemoryCache.prototype.gc = function (options) {
        object_canon/* canonicalStringify.reset */.B.reset();
        var ids = this.optimisticData.gc();
        if (options && !this.txCount) {
            if (options.resetResultCache) {
                this.resetResultCache(options.resetResultIdentities);
            }
            else if (options.resetResultIdentities) {
                this.storeReader.resetCanon();
            }
        }
        return ids;
    };
    InMemoryCache.prototype.retain = function (rootId, optimistic) {
        return (optimistic ? this.optimisticData : this.data).retain(rootId);
    };
    InMemoryCache.prototype.release = function (rootId, optimistic) {
        return (optimistic ? this.optimisticData : this.data).release(rootId);
    };
    InMemoryCache.prototype.identify = function (object) {
        if ((0,storeUtils/* isReference */.Yk)(object))
            return object.__ref;
        try {
            return this.policies.identify(object)[0];
        }
        catch (e) {
            __DEV__ && globals/* invariant.warn */.kG.warn(e);
        }
    };
    InMemoryCache.prototype.evict = function (options) {
        if (!options.id) {
            if (helpers/* hasOwn.call */.RI.call(options, "id")) {
                return false;
            }
            options = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { id: "ROOT_QUERY" });
        }
        try {
            ++this.txCount;
            return this.optimisticData.evict(options, this.data);
        }
        finally {
            if (!--this.txCount && options.broadcast !== false) {
                this.broadcastWatches();
            }
        }
    };
    InMemoryCache.prototype.reset = function (options) {
        var _this = this;
        this.init();
        object_canon/* canonicalStringify.reset */.B.reset();
        if (options && options.discardWatches) {
            this.watches.forEach(function (watch) { return _this.maybeBroadcastWatch.forget(watch); });
            this.watches.clear();
            (0,reactiveVars/* forgetCache */.li)(this);
        }
        else {
            this.broadcastWatches();
        }
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function (idToRemove) {
        var newOptimisticData = this.optimisticData.removeLayer(idToRemove);
        if (newOptimisticData !== this.optimisticData) {
            this.optimisticData = newOptimisticData;
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.batch = function (options) {
        var _this = this;
        var update = options.update, _a = options.optimistic, optimistic = _a === void 0 ? true : _a, removeOptimistic = options.removeOptimistic, onWatchUpdated = options.onWatchUpdated;
        var updateResult;
        var perform = function (layer) {
            var _a = _this, data = _a.data, optimisticData = _a.optimisticData;
            ++_this.txCount;
            if (layer) {
                _this.data = _this.optimisticData = layer;
            }
            try {
                return updateResult = update(_this);
            }
            finally {
                --_this.txCount;
                _this.data = data;
                _this.optimisticData = optimisticData;
            }
        };
        var alreadyDirty = new Set();
        if (onWatchUpdated && !this.txCount) {
            this.broadcastWatches((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { onWatchUpdated: function (watch) {
                    alreadyDirty.add(watch);
                    return false;
                } }));
        }
        if (typeof optimistic === 'string') {
            this.optimisticData = this.optimisticData.addLayer(optimistic, perform);
        }
        else if (optimistic === false) {
            perform(this.data);
        }
        else {
            perform();
        }
        if (typeof removeOptimistic === "string") {
            this.optimisticData = this.optimisticData.removeLayer(removeOptimistic);
        }
        if (onWatchUpdated && alreadyDirty.size) {
            this.broadcastWatches((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { onWatchUpdated: function (watch, diff) {
                    var result = onWatchUpdated.call(this, watch, diff);
                    if (result !== false) {
                        alreadyDirty.delete(watch);
                    }
                    return result;
                } }));
            if (alreadyDirty.size) {
                alreadyDirty.forEach(function (watch) { return _this.maybeBroadcastWatch.dirty(watch); });
            }
        }
        else {
            this.broadcastWatches(options);
        }
        return updateResult;
    };
    InMemoryCache.prototype.performTransaction = function (update, optimisticId) {
        return this.batch({
            update: update,
            optimistic: optimisticId || (optimisticId !== null),
        });
    };
    InMemoryCache.prototype.transformDocument = function (document) {
        if (this.addTypename) {
            var result = this.typenameDocumentCache.get(document);
            if (!result) {
                result = (0,transform/* addTypenameToDocument */.Gw)(document);
                this.typenameDocumentCache.set(document, result);
                this.typenameDocumentCache.set(result, result);
            }
            return result;
        }
        return document;
    };
    InMemoryCache.prototype.transformForLink = function (document) {
        var fragments = this.config.fragments;
        return fragments
            ? fragments.transform(document)
            : document;
    };
    InMemoryCache.prototype.broadcastWatches = function (options) {
        var _this = this;
        if (!this.txCount) {
            this.watches.forEach(function (c) { return _this.maybeBroadcastWatch(c, options); });
        }
    };
    InMemoryCache.prototype.broadcastWatch = function (c, options) {
        var lastDiff = c.lastDiff;
        var diff = this.diff(c);
        if (options) {
            if (c.optimistic &&
                typeof options.optimistic === "string") {
                diff.fromOptimisticTransaction = true;
            }
            if (options.onWatchUpdated &&
                options.onWatchUpdated.call(this, c, diff, lastDiff) === false) {
                return;
            }
        }
        if (!lastDiff || !(0,equality_esm/* equal */.D)(lastDiff.result, diff.result)) {
            c.callback(c.lastDiff = diff, lastDiff);
        }
    };
    return InMemoryCache;
}(cache/* ApolloCache */.R));

//# sourceMappingURL=inMemoryCache.js.map

/***/ }),

/***/ 80900:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ canonicalStringify; },
/* harmony export */   "h": function() { return /* binding */ ObjectCanon; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70655);
/* harmony import */ var _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62985);
/* harmony import */ var _wry_trie__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(657);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13154);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30320);
/* harmony import */ var _helpers_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49641);





function shallowCopy(value) {
    if ((0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_2__/* .isNonNullObject */ .s)(value)) {
        return (0,_helpers_js__WEBPACK_IMPORTED_MODULE_3__/* .isArray */ .kJ)(value)
            ? value.slice(0)
            : (0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__assign */ .pi)({ __proto__: Object.getPrototypeOf(value) }, value);
    }
    return value;
}
var ObjectCanon = (function () {
    function ObjectCanon() {
        this.known = new (_utilities_index_js__WEBPACK_IMPORTED_MODULE_5__/* .canUseWeakSet */ .sy ? WeakSet : Set)();
        this.pool = new _wry_trie__WEBPACK_IMPORTED_MODULE_1__/* .Trie */ .B(_utilities_index_js__WEBPACK_IMPORTED_MODULE_5__/* .canUseWeakMap */ .mr);
        this.passes = new WeakMap();
        this.keysByJSON = new Map();
        this.empty = this.admit({});
    }
    ObjectCanon.prototype.isKnown = function (value) {
        return (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_2__/* .isNonNullObject */ .s)(value) && this.known.has(value);
    };
    ObjectCanon.prototype.pass = function (value) {
        if ((0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_2__/* .isNonNullObject */ .s)(value)) {
            var copy = shallowCopy(value);
            this.passes.set(copy, value);
            return copy;
        }
        return value;
    };
    ObjectCanon.prototype.admit = function (value) {
        var _this = this;
        if ((0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_2__/* .isNonNullObject */ .s)(value)) {
            var original = this.passes.get(value);
            if (original)
                return original;
            var proto = Object.getPrototypeOf(value);
            switch (proto) {
                case Array.prototype: {
                    if (this.known.has(value))
                        return value;
                    var array = value.map(this.admit, this);
                    var node = this.pool.lookupArray(array);
                    if (!node.array) {
                        this.known.add(node.array = array);
                        if (__DEV__) {
                            Object.freeze(array);
                        }
                    }
                    return node.array;
                }
                case null:
                case Object.prototype: {
                    if (this.known.has(value))
                        return value;
                    var proto_1 = Object.getPrototypeOf(value);
                    var array_1 = [proto_1];
                    var keys = this.sortedKeys(value);
                    array_1.push(keys.json);
                    var firstValueIndex_1 = array_1.length;
                    keys.sorted.forEach(function (key) {
                        array_1.push(_this.admit(value[key]));
                    });
                    var node = this.pool.lookupArray(array_1);
                    if (!node.object) {
                        var obj_1 = node.object = Object.create(proto_1);
                        this.known.add(obj_1);
                        keys.sorted.forEach(function (key, i) {
                            obj_1[key] = array_1[firstValueIndex_1 + i];
                        });
                        if (__DEV__) {
                            Object.freeze(obj_1);
                        }
                    }
                    return node.object;
                }
            }
        }
        return value;
    };
    ObjectCanon.prototype.sortedKeys = function (obj) {
        var keys = Object.keys(obj);
        var node = this.pool.lookupArray(keys);
        if (!node.keys) {
            keys.sort();
            var json = JSON.stringify(keys);
            if (!(node.keys = this.keysByJSON.get(json))) {
                this.keysByJSON.set(json, node.keys = { sorted: keys, json: json });
            }
        }
        return node.keys;
    };
    return ObjectCanon;
}());

var canonicalStringify = Object.assign(function (value) {
    if ((0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_2__/* .isNonNullObject */ .s)(value)) {
        if (stringifyCanon === void 0) {
            resetCanonicalStringify();
        }
        var canonical = stringifyCanon.admit(value);
        var json = stringifyCache.get(canonical);
        if (json === void 0) {
            stringifyCache.set(canonical, json = JSON.stringify(canonical));
        }
        return json;
    }
    return JSON.stringify(value);
}, {
    reset: resetCanonicalStringify,
});
var stringifyCanon;
var stringifyCache;
function resetCanonicalStringify() {
    stringifyCanon = new ObjectCanon;
    stringifyCache = new (_utilities_index_js__WEBPACK_IMPORTED_MODULE_5__/* .canUseWeakMap */ .mr ? WeakMap : Map)();
}
//# sourceMappingURL=object-canon.js.map

/***/ }),

/***/ 9237:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ab": function() { return /* binding */ cacheSlot; },
  "li": function() { return /* binding */ forgetCache; },
  "QS": function() { return /* binding */ makeVar; },
  "_v": function() { return /* binding */ recallCache; }
});

// EXTERNAL MODULE: ./node_modules/optimism/lib/bundle.esm.js + 1 modules
var bundle_esm = __webpack_require__(7697);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/node_modules/@wry/context/lib/context.esm.js
// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
var currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
var MISSING_VALUE = {};
var idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
var makeSlotClass = function () { return /** @class */ (function () {
    function Slot() {
        // If you have a Slot object, you can find out its slot.id, but you cannot
        // guess the slot.id of a Slot you don't have access to, thanks to the
        // randomized suffix.
        this.id = [
            "slot",
            idCounter++,
            Date.now(),
            Math.random().toString(36).slice(2),
        ].join(":");
    }
    Slot.prototype.hasValue = function () {
        for (var context_1 = currentContext; context_1; context_1 = context_1.parent) {
            // We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context_1.slots) {
                var value = context_1.slots[this.id];
                if (value === MISSING_VALUE)
                    break;
                if (context_1 !== currentContext) {
                    // Cache the value in currentContext.slots so the next lookup will
                    // be faster. This caching is safe because the tree of contexts and
                    // the values of the slots are logically immutable.
                    currentContext.slots[this.id] = value;
                }
                return true;
            }
        }
        if (currentContext) {
            // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            currentContext.slots[this.id] = MISSING_VALUE;
        }
        return false;
    };
    Slot.prototype.getValue = function () {
        if (this.hasValue()) {
            return currentContext.slots[this.id];
        }
    };
    Slot.prototype.withValue = function (value, callback, 
    // Given the prevalence of arrow functions, specifying arguments is likely
    // to be much more common than specifying `this`, hence this ordering:
    args, thisArg) {
        var _a;
        var slots = (_a = {
                __proto__: null
            },
            _a[this.id] = value,
            _a);
        var parent = currentContext;
        currentContext = { parent: parent, slots: slots };
        try {
            // Function.prototype.apply allows the arguments array argument to be
            // omitted or undefined, so args! is fine here.
            return callback.apply(thisArg, args);
        }
        finally {
            currentContext = parent;
        }
    };
    // Capture the current context and wrap a callback function so that it
    // reestablishes the captured context when called.
    Slot.bind = function (callback) {
        var context = currentContext;
        return function () {
            var saved = currentContext;
            try {
                currentContext = context;
                return callback.apply(this, arguments);
            }
            finally {
                currentContext = saved;
            }
        };
    };
    // Immediately run a callback function without any captured context.
    Slot.noContext = function (callback, 
    // Given the prevalence of arrow functions, specifying arguments is likely
    // to be much more common than specifying `this`, hence this ordering:
    args, thisArg) {
        if (currentContext) {
            var saved = currentContext;
            try {
                currentContext = null;
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            }
            finally {
                currentContext = saved;
            }
        }
        else {
            return callback.apply(thisArg, args);
        }
    };
    return Slot;
}()); };
function maybe(fn) {
    try {
        return fn();
    }
    catch (ignored) { }
}
// We store a single global implementation of the Slot class as a permanent
// non-enumerable property of the globalThis object. This obfuscation does
// nothing to prevent access to the Slot class, but at least it ensures the
// implementation (i.e. currentContext) cannot be tampered with, and all copies
// of the @wry/context package (hopefully just one) will share the same Slot
// implementation. Since the first copy of the @wry/context package to be
// imported wins, this technique imposes a steep cost for any future breaking
// changes to the Slot class.
var globalKey = "@wry/context:Slot";
var host = 
// Prefer globalThis when available.
// https://github.com/benjamn/wryware/issues/347
maybe(function () { return globalThis; }) ||
    // Fall back to global, which works in Node.js and may be converted by some
    // bundlers to the appropriate identifier (window, self, ...) depending on the
    // bundling target. https://github.com/endojs/endo/issues/576#issuecomment-1178515224
    maybe(function () { return __webpack_require__.g; }) ||
    // Otherwise, use a dummy host that's local to this module. We used to fall
    // back to using the Array constructor as a namespace, but that was flagged in
    // https://github.com/benjamn/wryware/issues/347, and can be avoided.
    Object.create(null);
// Whichever globalHost we're using, make TypeScript happy about the additional
// globalKey property.
var globalHost = host;
var Slot = globalHost[globalKey] ||
    // Earlier versions of this package stored the globalKey property on the Array
    // constructor, so we check there as well, to prevent Slot class duplication.
    Array[globalKey] ||
    (function (Slot) {
        try {
            Object.defineProperty(globalHost, globalKey, {
                value: Slot,
                enumerable: false,
                writable: false,
                // When it was possible for globalHost to be the Array constructor (a
                // legacy Slot dedup strategy), it was important for the property to be
                // configurable:true so it could be deleted. That does not seem to be as
                // important when globalHost is the global object, but I don't want to
                // cause similar problems again, and configurable:true seems safest.
                // https://github.com/endojs/endo/issues/576#issuecomment-1178274008
                configurable: true
            });
        }
        finally {
            return Slot;
        }
    })(makeSlotClass());

var bind = Slot.bind, noContext = Slot.noContext;
function setTimeoutWithContext(callback, delay) {
    return setTimeout(bind(callback), delay);
}
// Turn any generator function into an async function (using yield instead
// of await), with context automatically preserved across yields.
function asyncFromGen(genFn) {
    return function () {
        var gen = genFn.apply(this, arguments);
        var boundNext = bind(gen.next);
        var boundThrow = bind(gen.throw);
        return new Promise(function (resolve, reject) {
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                }
                catch (error) {
                    return reject(error);
                }
                var next = result.done ? resolve : invokeNext;
                if (isPromiseLike(result.value)) {
                    result.value.then(next, result.done ? reject : invokeThrow);
                }
                else {
                    next(result.value);
                }
            }
            var invokeNext = function (value) { return invoke(boundNext, value); };
            var invokeThrow = function (error) { return invoke(boundThrow, error); };
            invokeNext();
        });
    };
}
function isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
var wrappedFibers = (/* unused pure expression or super */ null && ([]));
function wrapYieldingFiberMethods(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if (wrappedFibers.indexOf(Fiber) < 0) {
        var wrap = function (obj, method) {
            var fn = obj[method];
            obj[method] = function () {
                return noContext(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        wrappedFibers.push(Fiber);
    }
    return Fiber;
}


//# sourceMappingURL=context.esm.js.map

;// CONCATENATED MODULE: ./node_modules/@apollo/client/cache/inmemory/reactiveVars.js


var cacheSlot = new Slot();
var cacheInfoMap = new WeakMap();
function getCacheInfo(cache) {
    var info = cacheInfoMap.get(cache);
    if (!info) {
        cacheInfoMap.set(cache, info = {
            vars: new Set,
            dep: (0,bundle_esm/* dep */.dP)(),
        });
    }
    return info;
}
function forgetCache(cache) {
    getCacheInfo(cache).vars.forEach(function (rv) { return rv.forgetCache(cache); });
}
function recallCache(cache) {
    getCacheInfo(cache).vars.forEach(function (rv) { return rv.attachCache(cache); });
}
function makeVar(value) {
    var caches = new Set();
    var listeners = new Set();
    var rv = function (newValue) {
        if (arguments.length > 0) {
            if (value !== newValue) {
                value = newValue;
                caches.forEach(function (cache) {
                    getCacheInfo(cache).dep.dirty(rv);
                    broadcast(cache);
                });
                var oldListeners = Array.from(listeners);
                listeners.clear();
                oldListeners.forEach(function (listener) { return listener(value); });
            }
        }
        else {
            var cache = cacheSlot.getValue();
            if (cache) {
                attach(cache);
                getCacheInfo(cache).dep(rv);
            }
        }
        return value;
    };
    rv.onNextChange = function (listener) {
        listeners.add(listener);
        return function () {
            listeners.delete(listener);
        };
    };
    var attach = rv.attachCache = function (cache) {
        caches.add(cache);
        getCacheInfo(cache).vars.add(rv);
        return rv;
    };
    rv.forgetCache = function (cache) { return caches.delete(cache); };
    return rv;
}
function broadcast(cache) {
    if (cache.broadcastWatches) {
        cache.broadcastWatches();
    }
}
//# sourceMappingURL=reactiveVars.js.map

/***/ }),

/***/ 64096:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f": function() { return /* binding */ ApolloClient; }
});

// UNUSED EXPORTS: mergeOptions

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/globals/index.js + 5 modules
var globals = __webpack_require__(62985);
// EXTERNAL MODULE: ./node_modules/@apollo/client/link/core/ApolloLink.js + 3 modules
var ApolloLink = __webpack_require__(86909);
// EXTERNAL MODULE: ./node_modules/@apollo/client/link/core/execute.js
var execute = __webpack_require__(47037);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/version.js
var version = '3.7.0';
//# sourceMappingURL=version.js.map
// EXTERNAL MODULE: ./node_modules/@apollo/client/link/http/HttpLink.js
var HttpLink = __webpack_require__(72198);
// EXTERNAL MODULE: ./node_modules/@wry/equality/lib/equality.esm.js
var equality_esm = __webpack_require__(82152);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/utilities/common/incrementalResult.js
function isExecutionPatchIncrementalResult(value) {
    return !!value.incremental;
}
//# sourceMappingURL=incrementalResult.js.map
// EXTERNAL MODULE: ./node_modules/@apollo/client/cache/inmemory/object-canon.js
var object_canon = __webpack_require__(80900);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/canUse.js
var canUse = __webpack_require__(30320);
// EXTERNAL MODULE: ./node_modules/zen-observable-ts/module.js
var zen_observable_ts_module = __webpack_require__(48216);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/utilities/observables/asyncMap.js

function asyncMap(observable, mapFn, catchFn) {
    return new zen_observable_ts_module/* Observable */.y(function (observer) {
        var next = observer.next, error = observer.error, complete = observer.complete;
        var activeCallbackCount = 0;
        var completed = false;
        var promiseQueue = {
            then: function (callback) {
                return new Promise(function (resolve) { return resolve(callback()); });
            },
        };
        function makeCallback(examiner, delegate) {
            if (examiner) {
                return function (arg) {
                    ++activeCallbackCount;
                    var both = function () { return examiner(arg); };
                    promiseQueue = promiseQueue.then(both, both).then(function (result) {
                        --activeCallbackCount;
                        next && next.call(observer, result);
                        if (completed) {
                            handler.complete();
                        }
                    }, function (error) {
                        --activeCallbackCount;
                        throw error;
                    }).catch(function (caught) {
                        error && error.call(observer, caught);
                    });
                };
            }
            else {
                return function (arg) { return delegate && delegate.call(observer, arg); };
            }
        }
        var handler = {
            next: makeCallback(mapFn, next),
            error: makeCallback(catchFn, error),
            complete: function () {
                completed = true;
                if (!activeCallbackCount) {
                    complete && complete.call(observer);
                }
            },
        };
        var sub = observable.subscribe(handler);
        return function () { return sub.unsubscribe(); };
    });
}
//# sourceMappingURL=asyncMap.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/utilities/common/errorHandling.js
function graphQLResultHasError(result) {
    return (result.errors && result.errors.length > 0) || false;
}
//# sourceMappingURL=errorHandling.js.map
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/graphql/getFromAST.js
var getFromAST = __webpack_require__(36765);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/graphql/transform.js + 1 modules
var transform = __webpack_require__(76982);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/graphql/directives.js
var directives = __webpack_require__(19065);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/graphql/storeUtils.js
var storeUtils = __webpack_require__(51761);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/objects.js
var objects = __webpack_require__(13154);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/makeUniqueId.js
var makeUniqueId = __webpack_require__(60897);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/observables/iteration.js
var iteration = __webpack_require__(18263);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/observables/subclassing.js
var subclassing = __webpack_require__(86403);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/utilities/observables/Concast.js




function isPromiseLike(value) {
    return value && typeof value.then === "function";
}
var Concast = (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(Concast, _super);
    function Concast(sources) {
        var _this = _super.call(this, function (observer) {
            _this.addObserver(observer);
            return function () { return _this.removeObserver(observer); };
        }) || this;
        _this.observers = new Set();
        _this.promise = new Promise(function (resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
        _this.handlers = {
            next: function (result) {
                if (_this.sub !== null) {
                    _this.latest = ["next", result];
                    _this.notify("next", result);
                    (0,iteration/* iterateObserversSafely */.p)(_this.observers, "next", result);
                }
            },
            error: function (error) {
                var sub = _this.sub;
                if (sub !== null) {
                    if (sub)
                        setTimeout(function () { return sub.unsubscribe(); });
                    _this.sub = null;
                    _this.latest = ["error", error];
                    _this.reject(error);
                    _this.notify("error", error);
                    (0,iteration/* iterateObserversSafely */.p)(_this.observers, "error", error);
                }
            },
            complete: function () {
                var sub = _this.sub;
                if (sub !== null) {
                    var value = _this.sources.shift();
                    if (!value) {
                        if (sub)
                            setTimeout(function () { return sub.unsubscribe(); });
                        _this.sub = null;
                        if (_this.latest &&
                            _this.latest[0] === "next") {
                            _this.resolve(_this.latest[1]);
                        }
                        else {
                            _this.resolve();
                        }
                        _this.notify("complete");
                        (0,iteration/* iterateObserversSafely */.p)(_this.observers, "complete");
                    }
                    else if (isPromiseLike(value)) {
                        value.then(function (obs) { return _this.sub = obs.subscribe(_this.handlers); });
                    }
                    else {
                        _this.sub = value.subscribe(_this.handlers);
                    }
                }
            },
        };
        _this.nextResultListeners = new Set();
        _this.cancel = function (reason) {
            _this.reject(reason);
            _this.sources = [];
            _this.handlers.complete();
        };
        _this.promise.catch(function (_) { });
        if (typeof sources === "function") {
            sources = [new zen_observable_ts_module/* Observable */.y(sources)];
        }
        if (isPromiseLike(sources)) {
            sources.then(function (iterable) { return _this.start(iterable); }, _this.handlers.error);
        }
        else {
            _this.start(sources);
        }
        return _this;
    }
    Concast.prototype.start = function (sources) {
        if (this.sub !== void 0)
            return;
        this.sources = Array.from(sources);
        this.handlers.complete();
    };
    Concast.prototype.deliverLastMessage = function (observer) {
        if (this.latest) {
            var nextOrError = this.latest[0];
            var method = observer[nextOrError];
            if (method) {
                method.call(observer, this.latest[1]);
            }
            if (this.sub === null &&
                nextOrError === "next" &&
                observer.complete) {
                observer.complete();
            }
        }
    };
    Concast.prototype.addObserver = function (observer) {
        if (!this.observers.has(observer)) {
            this.deliverLastMessage(observer);
            this.observers.add(observer);
        }
    };
    Concast.prototype.removeObserver = function (observer) {
        if (this.observers.delete(observer) &&
            this.observers.size < 1) {
            this.handlers.complete();
        }
    };
    Concast.prototype.notify = function (method, arg) {
        var nextResultListeners = this.nextResultListeners;
        if (nextResultListeners.size) {
            this.nextResultListeners = new Set;
            nextResultListeners.forEach(function (listener) { return listener(method, arg); });
        }
    };
    Concast.prototype.beforeNext = function (callback) {
        var called = false;
        this.nextResultListeners.add(function (method, arg) {
            if (!called) {
                called = true;
                callback(method, arg);
            }
        });
    };
    return Concast;
}(zen_observable_ts_module/* Observable */.y));

(0,subclassing/* fixObservableSubclass */.D)(Concast);
//# sourceMappingURL=Concast.js.map
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/cloneDeep.js
var cloneDeep = __webpack_require__(79487);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/arrays.js
var arrays = __webpack_require__(21436);
// EXTERNAL MODULE: ./node_modules/@apollo/client/errors/index.js
var errors = __webpack_require__(30990);
// EXTERNAL MODULE: ./node_modules/@apollo/client/core/ObservableQuery.js
var ObservableQuery = __webpack_require__(44780);
// EXTERNAL MODULE: ./node_modules/@apollo/client/core/networkStatus.js
var core_networkStatus = __webpack_require__(1644);
// EXTERNAL MODULE: ./node_modules/graphql/language/visitor.mjs
var visitor = __webpack_require__(77304);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/mergeDeep.js
var mergeDeep = __webpack_require__(182);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/graphql/fragments.js
var graphql_fragments = __webpack_require__(23361);
// EXTERNAL MODULE: ./node_modules/@apollo/client/cache/inmemory/reactiveVars.js + 1 modules
var reactiveVars = __webpack_require__(9237);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/core/LocalState.js





var LocalState = (function () {
    function LocalState(_a) {
        var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
        this.cache = cache;
        if (client) {
            this.client = client;
        }
        if (resolvers) {
            this.addResolvers(resolvers);
        }
        if (fragmentMatcher) {
            this.setFragmentMatcher(fragmentMatcher);
        }
    }
    LocalState.prototype.addResolvers = function (resolvers) {
        var _this = this;
        this.resolvers = this.resolvers || {};
        if (Array.isArray(resolvers)) {
            resolvers.forEach(function (resolverGroup) {
                _this.resolvers = (0,mergeDeep/* mergeDeep */.Ee)(_this.resolvers, resolverGroup);
            });
        }
        else {
            this.resolvers = (0,mergeDeep/* mergeDeep */.Ee)(this.resolvers, resolvers);
        }
    };
    LocalState.prototype.setResolvers = function (resolvers) {
        this.resolvers = {};
        this.addResolvers(resolvers);
    };
    LocalState.prototype.getResolvers = function () {
        return this.resolvers || {};
    };
    LocalState.prototype.runResolvers = function (_a) {
        var document = _a.document, remoteResult = _a.remoteResult, context = _a.context, variables = _a.variables, _b = _a.onlyRunForcedResolvers, onlyRunForcedResolvers = _b === void 0 ? false : _b;
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function () {
            return (0,tslib_es6/* __generator */.Jh)(this, function (_c) {
                if (document) {
                    return [2, this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function (localResult) { return ((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, remoteResult), { data: localResult.result })); })];
                }
                return [2, remoteResult];
            });
        });
    };
    LocalState.prototype.setFragmentMatcher = function (fragmentMatcher) {
        this.fragmentMatcher = fragmentMatcher;
    };
    LocalState.prototype.getFragmentMatcher = function () {
        return this.fragmentMatcher;
    };
    LocalState.prototype.clientQuery = function (document) {
        if ((0,directives/* hasDirectives */.FS)(['client'], document)) {
            if (this.resolvers) {
                return document;
            }
        }
        return null;
    };
    LocalState.prototype.serverQuery = function (document) {
        return (0,transform/* removeClientSetsFromDocument */.ob)(document);
    };
    LocalState.prototype.prepareContext = function (context) {
        var cache = this.cache;
        return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, context), { cache: cache, getCacheKey: function (obj) {
                return cache.identify(obj);
            } });
    };
    LocalState.prototype.addExportedVariables = function (document, variables, context) {
        if (variables === void 0) { variables = {}; }
        if (context === void 0) { context = {}; }
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function () {
            return (0,tslib_es6/* __generator */.Jh)(this, function (_a) {
                if (document) {
                    return [2, this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function (data) { return ((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, variables), data.exportedVariables)); })];
                }
                return [2, (0,tslib_es6/* __assign */.pi)({}, variables)];
            });
        });
    };
    LocalState.prototype.shouldForceResolvers = function (document) {
        var forceResolvers = false;
        (0,visitor/* visit */.Vn)(document, {
            Directive: {
                enter: function (node) {
                    if (node.name.value === 'client' && node.arguments) {
                        forceResolvers = node.arguments.some(function (arg) {
                            return arg.name.value === 'always' &&
                                arg.value.kind === 'BooleanValue' &&
                                arg.value.value === true;
                        });
                        if (forceResolvers) {
                            return visitor/* BREAK */.$_;
                        }
                    }
                },
            },
        });
        return forceResolvers;
    };
    LocalState.prototype.buildRootValueFromCache = function (document, variables) {
        return this.cache.diff({
            query: (0,transform/* buildQueryFromSelectionSet */.aL)(document),
            variables: variables,
            returnPartialData: true,
            optimistic: false,
        }).result;
    };
    LocalState.prototype.resolveDocument = function (document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
        if (context === void 0) { context = {}; }
        if (variables === void 0) { variables = {}; }
        if (fragmentMatcher === void 0) { fragmentMatcher = function () { return true; }; }
        if (onlyRunForcedResolvers === void 0) { onlyRunForcedResolvers = false; }
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function () {
            var mainDefinition, fragments, fragmentMap, definitionOperation, defaultOperationType, _a, cache, client, execContext;
            return (0,tslib_es6/* __generator */.Jh)(this, function (_b) {
                mainDefinition = (0,getFromAST/* getMainDefinition */.p$)(document);
                fragments = (0,getFromAST/* getFragmentDefinitions */.kU)(document);
                fragmentMap = (0,graphql_fragments/* createFragmentMap */.F)(fragments);
                definitionOperation = mainDefinition
                    .operation;
                defaultOperationType = definitionOperation
                    ? definitionOperation.charAt(0).toUpperCase() +
                        definitionOperation.slice(1)
                    : 'Query';
                _a = this, cache = _a.cache, client = _a.client;
                execContext = {
                    fragmentMap: fragmentMap,
                    context: (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, context), { cache: cache, client: client }),
                    variables: variables,
                    fragmentMatcher: fragmentMatcher,
                    defaultOperationType: defaultOperationType,
                    exportedVariables: {},
                    onlyRunForcedResolvers: onlyRunForcedResolvers,
                };
                return [2, this.resolveSelectionSet(mainDefinition.selectionSet, rootValue, execContext).then(function (result) { return ({
                        result: result,
                        exportedVariables: execContext.exportedVariables,
                    }); })];
            });
        });
    };
    LocalState.prototype.resolveSelectionSet = function (selectionSet, rootValue, execContext) {
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function () {
            var fragmentMap, context, variables, resultsToMerge, execute;
            var _this = this;
            return (0,tslib_es6/* __generator */.Jh)(this, function (_a) {
                fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                resultsToMerge = [rootValue];
                execute = function (selection) { return (0,tslib_es6/* __awaiter */.mG)(_this, void 0, void 0, function () {
                    var fragment, typeCondition;
                    return (0,tslib_es6/* __generator */.Jh)(this, function (_a) {
                        if (!(0,directives/* shouldInclude */.LZ)(selection, variables)) {
                            return [2];
                        }
                        if ((0,storeUtils/* isField */.My)(selection)) {
                            return [2, this.resolveField(selection, rootValue, execContext).then(function (fieldResult) {
                                    var _a;
                                    if (typeof fieldResult !== 'undefined') {
                                        resultsToMerge.push((_a = {},
                                            _a[(0,storeUtils/* resultKeyNameFromField */.u2)(selection)] = fieldResult,
                                            _a));
                                    }
                                })];
                        }
                        if ((0,storeUtils/* isInlineFragment */.Ao)(selection)) {
                            fragment = selection;
                        }
                        else {
                            fragment = fragmentMap[selection.name.value];
                            __DEV__ ? (0,globals/* invariant */.kG)(fragment, "No fragment named ".concat(selection.name.value)) : (0,globals/* invariant */.kG)(fragment, 11);
                        }
                        if (fragment && fragment.typeCondition) {
                            typeCondition = fragment.typeCondition.name.value;
                            if (execContext.fragmentMatcher(rootValue, typeCondition, context)) {
                                return [2, this.resolveSelectionSet(fragment.selectionSet, rootValue, execContext).then(function (fragmentResult) {
                                        resultsToMerge.push(fragmentResult);
                                    })];
                            }
                        }
                        return [2];
                    });
                }); };
                return [2, Promise.all(selectionSet.selections.map(execute)).then(function () {
                        return (0,mergeDeep/* mergeDeepArray */.bw)(resultsToMerge);
                    })];
            });
        });
    };
    LocalState.prototype.resolveField = function (field, rootValue, execContext) {
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function () {
            var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
            var _this = this;
            return (0,tslib_es6/* __generator */.Jh)(this, function (_a) {
                variables = execContext.variables;
                fieldName = field.name.value;
                aliasedFieldName = (0,storeUtils/* resultKeyNameFromField */.u2)(field);
                aliasUsed = fieldName !== aliasedFieldName;
                defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                resultPromise = Promise.resolve(defaultResult);
                if (!execContext.onlyRunForcedResolvers ||
                    this.shouldForceResolvers(field)) {
                    resolverType = rootValue.__typename || execContext.defaultOperationType;
                    resolverMap = this.resolvers && this.resolvers[resolverType];
                    if (resolverMap) {
                        resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                        if (resolve) {
                            resultPromise = Promise.resolve(reactiveVars/* cacheSlot.withValue */.ab.withValue(this.cache, resolve, [
                                rootValue,
                                (0,storeUtils/* argumentsObjectFromField */.NC)(field, variables),
                                execContext.context,
                                { field: field, fragmentMap: execContext.fragmentMap },
                            ]));
                        }
                    }
                }
                return [2, resultPromise.then(function (result) {
                        if (result === void 0) { result = defaultResult; }
                        if (field.directives) {
                            field.directives.forEach(function (directive) {
                                if (directive.name.value === 'export' && directive.arguments) {
                                    directive.arguments.forEach(function (arg) {
                                        if (arg.name.value === 'as' && arg.value.kind === 'StringValue') {
                                            execContext.exportedVariables[arg.value.value] = result;
                                        }
                                    });
                                }
                            });
                        }
                        if (!field.selectionSet) {
                            return result;
                        }
                        if (result == null) {
                            return result;
                        }
                        if (Array.isArray(result)) {
                            return _this.resolveSubSelectedArray(field, result, execContext);
                        }
                        if (field.selectionSet) {
                            return _this.resolveSelectionSet(field.selectionSet, result, execContext);
                        }
                    })];
            });
        });
    };
    LocalState.prototype.resolveSubSelectedArray = function (field, result, execContext) {
        var _this = this;
        return Promise.all(result.map(function (item) {
            if (item === null) {
                return null;
            }
            if (Array.isArray(item)) {
                return _this.resolveSubSelectedArray(field, item, execContext);
            }
            if (field.selectionSet) {
                return _this.resolveSelectionSet(field.selectionSet, item, execContext);
            }
        }));
    };
    return LocalState;
}());

//# sourceMappingURL=LocalState.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/core/QueryInfo.js






;
var destructiveMethodCounts = new (canUse/* canUseWeakMap */.mr ? WeakMap : Map)();
function wrapDestructiveCacheMethod(cache, methodName) {
    var original = cache[methodName];
    if (typeof original === "function") {
        cache[methodName] = function () {
            destructiveMethodCounts.set(cache, (destructiveMethodCounts.get(cache) + 1) % 1e15);
            return original.apply(this, arguments);
        };
    }
}
function cancelNotifyTimeout(info) {
    if (info["notifyTimeout"]) {
        clearTimeout(info["notifyTimeout"]);
        info["notifyTimeout"] = void 0;
    }
}
var QueryInfo = (function () {
    function QueryInfo(queryManager, queryId) {
        if (queryId === void 0) { queryId = queryManager.generateQueryId(); }
        this.queryId = queryId;
        this.listeners = new Set();
        this.document = null;
        this.lastRequestId = 1;
        this.subscriptions = new Set();
        this.stopped = false;
        this.dirty = false;
        this.observableQuery = null;
        var cache = this.cache = queryManager.cache;
        if (!destructiveMethodCounts.has(cache)) {
            destructiveMethodCounts.set(cache, 0);
            wrapDestructiveCacheMethod(cache, "evict");
            wrapDestructiveCacheMethod(cache, "modify");
            wrapDestructiveCacheMethod(cache, "reset");
        }
    }
    QueryInfo.prototype.init = function (query) {
        var networkStatus = query.networkStatus || core_networkStatus/* NetworkStatus.loading */.I.loading;
        if (this.variables &&
            this.networkStatus !== core_networkStatus/* NetworkStatus.loading */.I.loading &&
            !(0,equality_esm/* equal */.D)(this.variables, query.variables)) {
            networkStatus = core_networkStatus/* NetworkStatus.setVariables */.I.setVariables;
        }
        if (!(0,equality_esm/* equal */.D)(query.variables, this.variables)) {
            this.lastDiff = void 0;
        }
        Object.assign(this, {
            document: query.document,
            variables: query.variables,
            networkError: null,
            graphQLErrors: this.graphQLErrors || [],
            networkStatus: networkStatus,
        });
        if (query.observableQuery) {
            this.setObservableQuery(query.observableQuery);
        }
        if (query.lastRequestId) {
            this.lastRequestId = query.lastRequestId;
        }
        return this;
    };
    QueryInfo.prototype.reset = function () {
        cancelNotifyTimeout(this);
        this.dirty = false;
    };
    QueryInfo.prototype.getDiff = function (variables) {
        if (variables === void 0) { variables = this.variables; }
        var options = this.getDiffOptions(variables);
        if (this.lastDiff && (0,equality_esm/* equal */.D)(options, this.lastDiff.options)) {
            return this.lastDiff.diff;
        }
        this.updateWatch(this.variables = variables);
        var oq = this.observableQuery;
        if (oq && oq.options.fetchPolicy === "no-cache") {
            return { complete: false };
        }
        var diff = this.cache.diff(options);
        this.updateLastDiff(diff, options);
        return diff;
    };
    QueryInfo.prototype.updateLastDiff = function (diff, options) {
        this.lastDiff = diff ? {
            diff: diff,
            options: options || this.getDiffOptions(),
        } : void 0;
    };
    QueryInfo.prototype.getDiffOptions = function (variables) {
        var _a;
        if (variables === void 0) { variables = this.variables; }
        return {
            query: this.document,
            variables: variables,
            returnPartialData: true,
            optimistic: true,
            canonizeResults: (_a = this.observableQuery) === null || _a === void 0 ? void 0 : _a.options.canonizeResults,
        };
    };
    QueryInfo.prototype.setDiff = function (diff) {
        var _this = this;
        var oldDiff = this.lastDiff && this.lastDiff.diff;
        this.updateLastDiff(diff);
        if (!this.dirty &&
            !(0,equality_esm/* equal */.D)(oldDiff && oldDiff.result, diff && diff.result)) {
            this.dirty = true;
            if (!this.notifyTimeout) {
                this.notifyTimeout = setTimeout(function () { return _this.notify(); }, 0);
            }
        }
    };
    QueryInfo.prototype.setObservableQuery = function (oq) {
        var _this = this;
        if (oq === this.observableQuery)
            return;
        if (this.oqListener) {
            this.listeners.delete(this.oqListener);
        }
        this.observableQuery = oq;
        if (oq) {
            oq["queryInfo"] = this;
            this.listeners.add(this.oqListener = function () {
                var diff = _this.getDiff();
                if (diff.fromOptimisticTransaction) {
                    oq["observe"]();
                }
                else {
                    (0,ObservableQuery/* reobserveCacheFirst */.vj)(oq);
                }
            });
        }
        else {
            delete this.oqListener;
        }
    };
    QueryInfo.prototype.notify = function () {
        var _this = this;
        cancelNotifyTimeout(this);
        if (this.shouldNotify()) {
            this.listeners.forEach(function (listener) { return listener(_this); });
        }
        this.dirty = false;
    };
    QueryInfo.prototype.shouldNotify = function () {
        if (!this.dirty || !this.listeners.size) {
            return false;
        }
        if ((0,core_networkStatus/* isNetworkRequestInFlight */.O)(this.networkStatus) &&
            this.observableQuery) {
            var fetchPolicy = this.observableQuery.options.fetchPolicy;
            if (fetchPolicy !== "cache-only" &&
                fetchPolicy !== "cache-and-network") {
                return false;
            }
        }
        return true;
    };
    QueryInfo.prototype.stop = function () {
        if (!this.stopped) {
            this.stopped = true;
            this.reset();
            this.cancel();
            this.cancel = QueryInfo.prototype.cancel;
            this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
            var oq = this.observableQuery;
            if (oq)
                oq.stopPolling();
        }
    };
    QueryInfo.prototype.cancel = function () { };
    QueryInfo.prototype.updateWatch = function (variables) {
        var _this = this;
        if (variables === void 0) { variables = this.variables; }
        var oq = this.observableQuery;
        if (oq && oq.options.fetchPolicy === "no-cache") {
            return;
        }
        var watchOptions = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this.getDiffOptions(variables)), { watcher: this, callback: function (diff) { return _this.setDiff(diff); } });
        if (!this.lastWatch ||
            !(0,equality_esm/* equal */.D)(watchOptions, this.lastWatch)) {
            this.cancel();
            this.cancel = this.cache.watch(this.lastWatch = watchOptions);
        }
    };
    QueryInfo.prototype.resetLastWrite = function () {
        this.lastWrite = void 0;
    };
    QueryInfo.prototype.shouldWrite = function (result, variables) {
        var lastWrite = this.lastWrite;
        return !(lastWrite &&
            lastWrite.dmCount === destructiveMethodCounts.get(this.cache) &&
            (0,equality_esm/* equal */.D)(variables, lastWrite.variables) &&
            (0,equality_esm/* equal */.D)(result.data, lastWrite.result.data));
    };
    QueryInfo.prototype.markResult = function (result, document, options, cacheWriteBehavior) {
        var _this = this;
        var graphQLErrors = (0,arrays/* isNonEmptyArray */.O)(result.errors)
            ? result.errors.slice(0)
            : [];
        this.reset();
        if ('incremental' in result && (0,arrays/* isNonEmptyArray */.O)(result.incremental)) {
            var mergedData_1 = this.getDiff().result;
            var merger_1 = new mergeDeep/* DeepMerger */.w0();
            result.incremental.forEach(function (_a) {
                var data = _a.data, path = _a.path, errors = _a.errors;
                for (var i = path.length - 1; i >= 0; --i) {
                    var key = path[i];
                    var isNumericKey = !isNaN(+key);
                    var parent_1 = isNumericKey ? [] : {};
                    parent_1[key] = data;
                    data = parent_1;
                }
                if (errors) {
                    graphQLErrors.push.apply(graphQLErrors, errors);
                }
                mergedData_1 = merger_1.merge(mergedData_1, data);
            });
            result.data = mergedData_1;
        }
        this.graphQLErrors = graphQLErrors;
        if (options.fetchPolicy === 'no-cache') {
            this.updateLastDiff({ result: result.data, complete: true }, this.getDiffOptions(options.variables));
        }
        else if (cacheWriteBehavior !== 0) {
            if (shouldWriteResult(result, options.errorPolicy)) {
                this.cache.performTransaction(function (cache) {
                    if (_this.shouldWrite(result, options.variables)) {
                        cache.writeQuery({
                            query: document,
                            data: result.data,
                            variables: options.variables,
                            overwrite: cacheWriteBehavior === 1,
                        });
                        _this.lastWrite = {
                            result: result,
                            variables: options.variables,
                            dmCount: destructiveMethodCounts.get(_this.cache),
                        };
                    }
                    else {
                        if (_this.lastDiff &&
                            _this.lastDiff.diff.complete) {
                            result.data = _this.lastDiff.diff.result;
                            return;
                        }
                    }
                    var diffOptions = _this.getDiffOptions(options.variables);
                    var diff = cache.diff(diffOptions);
                    if (!_this.stopped) {
                        _this.updateWatch(options.variables);
                    }
                    _this.updateLastDiff(diff, diffOptions);
                    if (diff.complete) {
                        result.data = diff.result;
                    }
                });
            }
            else {
                this.lastWrite = void 0;
            }
        }
    };
    QueryInfo.prototype.markReady = function () {
        this.networkError = null;
        return this.networkStatus = core_networkStatus/* NetworkStatus.ready */.I.ready;
    };
    QueryInfo.prototype.markError = function (error) {
        this.networkStatus = core_networkStatus/* NetworkStatus.error */.I.error;
        this.lastWrite = void 0;
        this.reset();
        if (error.graphQLErrors) {
            this.graphQLErrors = error.graphQLErrors;
        }
        if (error.networkError) {
            this.networkError = error.networkError;
        }
        return error;
    };
    return QueryInfo;
}());

function shouldWriteResult(result, errorPolicy) {
    if (errorPolicy === void 0) { errorPolicy = "none"; }
    var ignoreErrors = errorPolicy === "ignore" ||
        errorPolicy === "all";
    var writeWithErrors = !graphQLResultHasError(result);
    if (!writeWithErrors && ignoreErrors && result.data) {
        writeWithErrors = true;
    }
    return writeWithErrors;
}
//# sourceMappingURL=QueryInfo.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/core/QueryManager.js












var QueryManager_hasOwnProperty = Object.prototype.hasOwnProperty;
var QueryManager = (function () {
    function QueryManager(_a) {
        var cache = _a.cache, link = _a.link, defaultOptions = _a.defaultOptions, _b = _a.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, onBroadcast = _a.onBroadcast, _c = _a.ssrMode, ssrMode = _c === void 0 ? false : _c, _d = _a.clientAwareness, clientAwareness = _d === void 0 ? {} : _d, localState = _a.localState, assumeImmutableResults = _a.assumeImmutableResults;
        this.clientAwareness = {};
        this.queries = new Map();
        this.fetchCancelFns = new Map();
        this.transformCache = new (canUse/* canUseWeakMap */.mr ? WeakMap : Map)();
        this.queryIdCounter = 1;
        this.requestIdCounter = 1;
        this.mutationIdCounter = 1;
        this.inFlightLinkObservables = new Map();
        this.cache = cache;
        this.link = link;
        this.defaultOptions = defaultOptions || Object.create(null);
        this.queryDeduplication = queryDeduplication;
        this.clientAwareness = clientAwareness;
        this.localState = localState || new LocalState({ cache: cache });
        this.ssrMode = ssrMode;
        this.assumeImmutableResults = !!assumeImmutableResults;
        if ((this.onBroadcast = onBroadcast)) {
            this.mutationStore = Object.create(null);
        }
    }
    QueryManager.prototype.stop = function () {
        var _this = this;
        this.queries.forEach(function (_info, queryId) {
            _this.stopQueryNoBroadcast(queryId);
        });
        this.cancelPendingFetches(__DEV__ ? new globals/* InvariantError */.ej('QueryManager stopped while query was in flight') : new globals/* InvariantError */.ej(13));
    };
    QueryManager.prototype.cancelPendingFetches = function (error) {
        this.fetchCancelFns.forEach(function (cancel) { return cancel(error); });
        this.fetchCancelFns.clear();
    };
    QueryManager.prototype.mutate = function (_a) {
        var _b, _c;
        var mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, updateQueries = _a.updateQueries, _d = _a.refetchQueries, refetchQueries = _d === void 0 ? [] : _d, _e = _a.awaitRefetchQueries, awaitRefetchQueries = _e === void 0 ? false : _e, updateWithProxyFn = _a.update, onQueryUpdated = _a.onQueryUpdated, _f = _a.fetchPolicy, fetchPolicy = _f === void 0 ? ((_b = this.defaultOptions.mutate) === null || _b === void 0 ? void 0 : _b.fetchPolicy) || "network-only" : _f, _g = _a.errorPolicy, errorPolicy = _g === void 0 ? ((_c = this.defaultOptions.mutate) === null || _c === void 0 ? void 0 : _c.errorPolicy) || "none" : _g, keepRootFields = _a.keepRootFields, context = _a.context;
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function () {
            var mutationId, _h, document, hasClientExports, mutationStoreValue, self;
            return (0,tslib_es6/* __generator */.Jh)(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        __DEV__ ? (0,globals/* invariant */.kG)(mutation, 'mutation option is required. You must specify your GraphQL document in the mutation option.') : (0,globals/* invariant */.kG)(mutation, 14);
                        __DEV__ ? (0,globals/* invariant */.kG)(fetchPolicy === 'network-only' ||
                            fetchPolicy === 'no-cache', "Mutations support only 'network-only' or 'no-cache' fetchPolicy strings. The default `network-only` behavior automatically writes mutation results to the cache. Passing `no-cache` skips the cache write.") : (0,globals/* invariant */.kG)(fetchPolicy === 'network-only' ||
                            fetchPolicy === 'no-cache', 15);
                        mutationId = this.generateMutationId();
                        _h = this.transform(mutation), document = _h.document, hasClientExports = _h.hasClientExports;
                        mutation = this.cache.transformForLink(document);
                        variables = this.getVariables(mutation, variables);
                        if (!hasClientExports) return [3, 2];
                        return [4, this.localState.addExportedVariables(mutation, variables, context)];
                    case 1:
                        variables = (_j.sent());
                        _j.label = 2;
                    case 2:
                        mutationStoreValue = this.mutationStore &&
                            (this.mutationStore[mutationId] = {
                                mutation: mutation,
                                variables: variables,
                                loading: true,
                                error: null,
                            });
                        if (optimisticResponse) {
                            this.markMutationOptimistic(optimisticResponse, {
                                mutationId: mutationId,
                                document: mutation,
                                variables: variables,
                                fetchPolicy: fetchPolicy,
                                errorPolicy: errorPolicy,
                                context: context,
                                updateQueries: updateQueries,
                                update: updateWithProxyFn,
                                keepRootFields: keepRootFields,
                            });
                        }
                        this.broadcastQueries();
                        self = this;
                        return [2, new Promise(function (resolve, reject) {
                                return asyncMap(self.getObservableFromLink(mutation, (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, context), { optimisticResponse: optimisticResponse }), variables, false), function (result) {
                                    if (graphQLResultHasError(result) && errorPolicy === 'none') {
                                        throw new errors/* ApolloError */.c({
                                            graphQLErrors: result.errors,
                                        });
                                    }
                                    if (mutationStoreValue) {
                                        mutationStoreValue.loading = false;
                                        mutationStoreValue.error = null;
                                    }
                                    var storeResult = (0,tslib_es6/* __assign */.pi)({}, result);
                                    if (typeof refetchQueries === "function") {
                                        refetchQueries = refetchQueries(storeResult);
                                    }
                                    if (errorPolicy === 'ignore' &&
                                        graphQLResultHasError(storeResult)) {
                                        delete storeResult.errors;
                                    }
                                    return self.markMutationResult({
                                        mutationId: mutationId,
                                        result: storeResult,
                                        document: mutation,
                                        variables: variables,
                                        fetchPolicy: fetchPolicy,
                                        errorPolicy: errorPolicy,
                                        context: context,
                                        update: updateWithProxyFn,
                                        updateQueries: updateQueries,
                                        awaitRefetchQueries: awaitRefetchQueries,
                                        refetchQueries: refetchQueries,
                                        removeOptimistic: optimisticResponse ? mutationId : void 0,
                                        onQueryUpdated: onQueryUpdated,
                                        keepRootFields: keepRootFields,
                                    });
                                }).subscribe({
                                    next: function (storeResult) {
                                        self.broadcastQueries();
                                        resolve(storeResult);
                                    },
                                    error: function (err) {
                                        if (mutationStoreValue) {
                                            mutationStoreValue.loading = false;
                                            mutationStoreValue.error = err;
                                        }
                                        if (optimisticResponse) {
                                            self.cache.removeOptimistic(mutationId);
                                        }
                                        self.broadcastQueries();
                                        reject(err instanceof errors/* ApolloError */.c ? err : new errors/* ApolloError */.c({
                                            networkError: err,
                                        }));
                                    },
                                });
                            })];
                }
            });
        });
    };
    QueryManager.prototype.markMutationResult = function (mutation, cache) {
        var _this = this;
        if (cache === void 0) { cache = this.cache; }
        var result = mutation.result;
        var cacheWrites = [];
        var skipCache = mutation.fetchPolicy === "no-cache";
        if (!skipCache && shouldWriteResult(result, mutation.errorPolicy)) {
            cacheWrites.push({
                result: result.data,
                dataId: 'ROOT_MUTATION',
                query: mutation.document,
                variables: mutation.variables,
            });
            var updateQueries_1 = mutation.updateQueries;
            if (updateQueries_1) {
                this.queries.forEach(function (_a, queryId) {
                    var observableQuery = _a.observableQuery;
                    var queryName = observableQuery && observableQuery.queryName;
                    if (!queryName || !QueryManager_hasOwnProperty.call(updateQueries_1, queryName)) {
                        return;
                    }
                    var updater = updateQueries_1[queryName];
                    var _b = _this.queries.get(queryId), document = _b.document, variables = _b.variables;
                    var _c = cache.diff({
                        query: document,
                        variables: variables,
                        returnPartialData: true,
                        optimistic: false,
                    }), currentQueryResult = _c.result, complete = _c.complete;
                    if (complete && currentQueryResult) {
                        var nextQueryResult = updater(currentQueryResult, {
                            mutationResult: result,
                            queryName: document && (0,getFromAST/* getOperationName */.rY)(document) || void 0,
                            queryVariables: variables,
                        });
                        if (nextQueryResult) {
                            cacheWrites.push({
                                result: nextQueryResult,
                                dataId: 'ROOT_QUERY',
                                query: document,
                                variables: variables,
                            });
                        }
                    }
                });
            }
        }
        if (cacheWrites.length > 0 ||
            mutation.refetchQueries ||
            mutation.update ||
            mutation.onQueryUpdated ||
            mutation.removeOptimistic) {
            var results_1 = [];
            this.refetchQueries({
                updateCache: function (cache) {
                    if (!skipCache) {
                        cacheWrites.forEach(function (write) { return cache.write(write); });
                    }
                    var update = mutation.update;
                    if (update) {
                        if (!skipCache) {
                            var diff = cache.diff({
                                id: "ROOT_MUTATION",
                                query: _this.transform(mutation.document).asQuery,
                                variables: mutation.variables,
                                optimistic: false,
                                returnPartialData: true,
                            });
                            if (diff.complete && !(isExecutionPatchIncrementalResult(result))) {
                                result = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, result), { data: diff.result });
                            }
                        }
                        update(cache, result, {
                            context: mutation.context,
                            variables: mutation.variables,
                        });
                    }
                    if (!skipCache && !mutation.keepRootFields) {
                        cache.modify({
                            id: 'ROOT_MUTATION',
                            fields: function (value, _a) {
                                var fieldName = _a.fieldName, DELETE = _a.DELETE;
                                return fieldName === "__typename" ? value : DELETE;
                            },
                        });
                    }
                },
                include: mutation.refetchQueries,
                optimistic: false,
                removeOptimistic: mutation.removeOptimistic,
                onQueryUpdated: mutation.onQueryUpdated || null,
            }).forEach(function (result) { return results_1.push(result); });
            if (mutation.awaitRefetchQueries || mutation.onQueryUpdated) {
                return Promise.all(results_1).then(function () { return result; });
            }
        }
        return Promise.resolve(result);
    };
    QueryManager.prototype.markMutationOptimistic = function (optimisticResponse, mutation) {
        var _this = this;
        var data = typeof optimisticResponse === "function"
            ? optimisticResponse(mutation.variables)
            : optimisticResponse;
        return this.cache.recordOptimisticTransaction(function (cache) {
            try {
                _this.markMutationResult((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, mutation), { result: { data: data } }), cache);
            }
            catch (error) {
                __DEV__ && globals/* invariant.error */.kG.error(error);
            }
        }, mutation.mutationId);
    };
    QueryManager.prototype.fetchQuery = function (queryId, options, networkStatus) {
        return this.fetchQueryObservable(queryId, options, networkStatus).promise;
    };
    QueryManager.prototype.getQueryStore = function () {
        var store = Object.create(null);
        this.queries.forEach(function (info, queryId) {
            store[queryId] = {
                variables: info.variables,
                networkStatus: info.networkStatus,
                networkError: info.networkError,
                graphQLErrors: info.graphQLErrors,
            };
        });
        return store;
    };
    QueryManager.prototype.resetErrors = function (queryId) {
        var queryInfo = this.queries.get(queryId);
        if (queryInfo) {
            queryInfo.networkError = undefined;
            queryInfo.graphQLErrors = [];
        }
    };
    QueryManager.prototype.transform = function (document) {
        var transformCache = this.transformCache;
        if (!transformCache.has(document)) {
            var transformed = this.cache.transformDocument(document);
            var noConnection = (0,transform/* removeConnectionDirectiveFromDocument */.Fo)(transformed);
            var clientQuery = this.localState.clientQuery(transformed);
            var serverQuery = noConnection && this.localState.serverQuery(noConnection);
            var cacheEntry_1 = {
                document: transformed,
                hasClientExports: (0,directives/* hasClientExports */.mj)(transformed),
                hasForcedResolvers: this.localState.shouldForceResolvers(transformed),
                clientQuery: clientQuery,
                serverQuery: serverQuery,
                defaultVars: (0,getFromAST/* getDefaultValues */.O4)((0,getFromAST/* getOperationDefinition */.$H)(transformed)),
                asQuery: (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, transformed), { definitions: transformed.definitions.map(function (def) {
                        if (def.kind === "OperationDefinition" &&
                            def.operation !== "query") {
                            return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, def), { operation: "query" });
                        }
                        return def;
                    }) })
            };
            var add = function (doc) {
                if (doc && !transformCache.has(doc)) {
                    transformCache.set(doc, cacheEntry_1);
                }
            };
            add(document);
            add(transformed);
            add(clientQuery);
            add(serverQuery);
        }
        return transformCache.get(document);
    };
    QueryManager.prototype.getVariables = function (document, variables) {
        return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this.transform(document).defaultVars), variables);
    };
    QueryManager.prototype.watchQuery = function (options) {
        options = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { variables: this.getVariables(options.query, options.variables) });
        if (typeof options.notifyOnNetworkStatusChange === 'undefined') {
            options.notifyOnNetworkStatusChange = false;
        }
        var queryInfo = new QueryInfo(this);
        var observable = new ObservableQuery/* ObservableQuery */.ue({
            queryManager: this,
            queryInfo: queryInfo,
            options: options,
        });
        this.queries.set(observable.queryId, queryInfo);
        queryInfo.init({
            document: observable.query,
            observableQuery: observable,
            variables: observable.variables,
        });
        return observable;
    };
    QueryManager.prototype.query = function (options, queryId) {
        var _this = this;
        if (queryId === void 0) { queryId = this.generateQueryId(); }
        __DEV__ ? (0,globals/* invariant */.kG)(options.query, 'query option is required. You must specify your GraphQL document ' +
            'in the query option.') : (0,globals/* invariant */.kG)(options.query, 16);
        __DEV__ ? (0,globals/* invariant */.kG)(options.query.kind === 'Document', 'You must wrap the query string in a "gql" tag.') : (0,globals/* invariant */.kG)(options.query.kind === 'Document', 17);
        __DEV__ ? (0,globals/* invariant */.kG)(!options.returnPartialData, 'returnPartialData option only supported on watchQuery.') : (0,globals/* invariant */.kG)(!options.returnPartialData, 18);
        __DEV__ ? (0,globals/* invariant */.kG)(!options.pollInterval, 'pollInterval option only supported on watchQuery.') : (0,globals/* invariant */.kG)(!options.pollInterval, 19);
        return this.fetchQuery(queryId, options).finally(function () { return _this.stopQuery(queryId); });
    };
    QueryManager.prototype.generateQueryId = function () {
        return String(this.queryIdCounter++);
    };
    QueryManager.prototype.generateRequestId = function () {
        return this.requestIdCounter++;
    };
    QueryManager.prototype.generateMutationId = function () {
        return String(this.mutationIdCounter++);
    };
    QueryManager.prototype.stopQueryInStore = function (queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryInStoreNoBroadcast = function (queryId) {
        var queryInfo = this.queries.get(queryId);
        if (queryInfo)
            queryInfo.stop();
    };
    QueryManager.prototype.clearStore = function (options) {
        if (options === void 0) { options = {
            discardWatches: true,
        }; }
        this.cancelPendingFetches(__DEV__ ? new globals/* InvariantError */.ej('Store reset while query was in flight (not completed in link chain)') : new globals/* InvariantError */.ej(20));
        this.queries.forEach(function (queryInfo) {
            if (queryInfo.observableQuery) {
                queryInfo.networkStatus = core_networkStatus/* NetworkStatus.loading */.I.loading;
            }
            else {
                queryInfo.stop();
            }
        });
        if (this.mutationStore) {
            this.mutationStore = Object.create(null);
        }
        return this.cache.reset(options);
    };
    QueryManager.prototype.getObservableQueries = function (include) {
        var _this = this;
        if (include === void 0) { include = "active"; }
        var queries = new Map();
        var queryNamesAndDocs = new Map();
        var legacyQueryOptions = new Set();
        if (Array.isArray(include)) {
            include.forEach(function (desc) {
                if (typeof desc === "string") {
                    queryNamesAndDocs.set(desc, false);
                }
                else if ((0,storeUtils/* isDocumentNode */.JW)(desc)) {
                    queryNamesAndDocs.set(_this.transform(desc).document, false);
                }
                else if ((0,objects/* isNonNullObject */.s)(desc) && desc.query) {
                    legacyQueryOptions.add(desc);
                }
            });
        }
        this.queries.forEach(function (_a, queryId) {
            var oq = _a.observableQuery, document = _a.document;
            if (oq) {
                if (include === "all") {
                    queries.set(queryId, oq);
                    return;
                }
                var queryName = oq.queryName, fetchPolicy = oq.options.fetchPolicy;
                if (fetchPolicy === "standby" ||
                    (include === "active" && !oq.hasObservers())) {
                    return;
                }
                if (include === "active" ||
                    (queryName && queryNamesAndDocs.has(queryName)) ||
                    (document && queryNamesAndDocs.has(document))) {
                    queries.set(queryId, oq);
                    if (queryName)
                        queryNamesAndDocs.set(queryName, true);
                    if (document)
                        queryNamesAndDocs.set(document, true);
                }
            }
        });
        if (legacyQueryOptions.size) {
            legacyQueryOptions.forEach(function (options) {
                var queryId = (0,makeUniqueId/* makeUniqueId */.X)("legacyOneTimeQuery");
                var queryInfo = _this.getQuery(queryId).init({
                    document: options.query,
                    variables: options.variables,
                });
                var oq = new ObservableQuery/* ObservableQuery */.ue({
                    queryManager: _this,
                    queryInfo: queryInfo,
                    options: (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { fetchPolicy: "network-only" }),
                });
                (0,globals/* invariant */.kG)(oq.queryId === queryId);
                queryInfo.setObservableQuery(oq);
                queries.set(queryId, oq);
            });
        }
        if (__DEV__ && queryNamesAndDocs.size) {
            queryNamesAndDocs.forEach(function (included, nameOrDoc) {
                if (!included) {
                    __DEV__ && globals/* invariant.warn */.kG.warn("Unknown query ".concat(typeof nameOrDoc === "string" ? "named " : "").concat(JSON.stringify(nameOrDoc, null, 2), " requested in refetchQueries options.include array"));
                }
            });
        }
        return queries;
    };
    QueryManager.prototype.reFetchObservableQueries = function (includeStandby) {
        var _this = this;
        if (includeStandby === void 0) { includeStandby = false; }
        var observableQueryPromises = [];
        this.getObservableQueries(includeStandby ? "all" : "active").forEach(function (observableQuery, queryId) {
            var fetchPolicy = observableQuery.options.fetchPolicy;
            observableQuery.resetLastResults();
            if (includeStandby ||
                (fetchPolicy !== "standby" &&
                    fetchPolicy !== "cache-only")) {
                observableQueryPromises.push(observableQuery.refetch());
            }
            _this.getQuery(queryId).setDiff(null);
        });
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.setObservableQuery = function (observableQuery) {
        this.getQuery(observableQuery.queryId).setObservableQuery(observableQuery);
    };
    QueryManager.prototype.startGraphQLSubscription = function (_a) {
        var _this = this;
        var query = _a.query, fetchPolicy = _a.fetchPolicy, errorPolicy = _a.errorPolicy, variables = _a.variables, _b = _a.context, context = _b === void 0 ? {} : _b;
        query = this.transform(query).document;
        variables = this.getVariables(query, variables);
        var makeObservable = function (variables) {
            return _this.getObservableFromLink(query, context, variables).map(function (result) {
                if (fetchPolicy !== 'no-cache') {
                    if (shouldWriteResult(result, errorPolicy)) {
                        _this.cache.write({
                            query: query,
                            result: result.data,
                            dataId: 'ROOT_SUBSCRIPTION',
                            variables: variables,
                        });
                    }
                    _this.broadcastQueries();
                }
                if (graphQLResultHasError(result)) {
                    throw new errors/* ApolloError */.c({
                        graphQLErrors: result.errors,
                    });
                }
                return result;
            });
        };
        if (this.transform(query).hasClientExports) {
            var observablePromise_1 = this.localState.addExportedVariables(query, variables, context).then(makeObservable);
            return new zen_observable_ts_module/* Observable */.y(function (observer) {
                var sub = null;
                observablePromise_1.then(function (observable) { return sub = observable.subscribe(observer); }, observer.error);
                return function () { return sub && sub.unsubscribe(); };
            });
        }
        return makeObservable(variables);
    };
    QueryManager.prototype.stopQuery = function (queryId) {
        this.stopQueryNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryNoBroadcast = function (queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function (queryId) {
        this.fetchCancelFns.delete(queryId);
        if (this.queries.has(queryId)) {
            this.getQuery(queryId).stop();
            this.queries.delete(queryId);
        }
    };
    QueryManager.prototype.broadcastQueries = function () {
        if (this.onBroadcast)
            this.onBroadcast();
        this.queries.forEach(function (info) { return info.notify(); });
    };
    QueryManager.prototype.getLocalState = function () {
        return this.localState;
    };
    QueryManager.prototype.getObservableFromLink = function (query, context, variables, deduplication) {
        var _this = this;
        var _a;
        if (deduplication === void 0) { deduplication = (_a = context === null || context === void 0 ? void 0 : context.queryDeduplication) !== null && _a !== void 0 ? _a : this.queryDeduplication; }
        var observable;
        var serverQuery = this.transform(query).serverQuery;
        if (serverQuery) {
            var _b = this, inFlightLinkObservables_1 = _b.inFlightLinkObservables, link = _b.link;
            var operation = {
                query: serverQuery,
                variables: variables,
                operationName: (0,getFromAST/* getOperationName */.rY)(serverQuery) || void 0,
                context: this.prepareContext((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, context), { forceFetch: !deduplication })),
            };
            context = operation.context;
            if (deduplication) {
                var byVariables_1 = inFlightLinkObservables_1.get(serverQuery) || new Map();
                inFlightLinkObservables_1.set(serverQuery, byVariables_1);
                var varJson_1 = (0,object_canon/* canonicalStringify */.B)(variables);
                observable = byVariables_1.get(varJson_1);
                if (!observable) {
                    var concast = new Concast([
                        (0,execute/* execute */.h)(link, operation)
                    ]);
                    byVariables_1.set(varJson_1, observable = concast);
                    concast.beforeNext(function () {
                        if (byVariables_1.delete(varJson_1) &&
                            byVariables_1.size < 1) {
                            inFlightLinkObservables_1.delete(serverQuery);
                        }
                    });
                }
            }
            else {
                observable = new Concast([
                    (0,execute/* execute */.h)(link, operation)
                ]);
            }
        }
        else {
            observable = new Concast([
                zen_observable_ts_module/* Observable.of */.y.of({ data: {} })
            ]);
            context = this.prepareContext(context);
        }
        var clientQuery = this.transform(query).clientQuery;
        if (clientQuery) {
            observable = asyncMap(observable, function (result) {
                return _this.localState.runResolvers({
                    document: clientQuery,
                    remoteResult: result,
                    context: context,
                    variables: variables,
                });
            });
        }
        return observable;
    };
    QueryManager.prototype.getResultsFromLink = function (queryInfo, cacheWriteBehavior, options) {
        var requestId = queryInfo.lastRequestId = this.generateRequestId();
        options = (0,cloneDeep/* cloneDeep */.X)(options);
        var linkDocument = this.cache.transformForLink(this.transform(queryInfo.document).document);
        return asyncMap(this.getObservableFromLink(linkDocument, options.context, options.variables), function (result) {
            var graphQLErrors = (0,arrays/* isNonEmptyArray */.O)(result.errors)
                ? result.errors.slice(0)
                : [];
            if ('incremental' in result && (0,arrays/* isNonEmptyArray */.O)(result.incremental)) {
                result.incremental.forEach(function (incrementalResult) {
                    if (incrementalResult.errors) {
                        graphQLErrors.push.apply(graphQLErrors, incrementalResult.errors);
                    }
                });
            }
            var hasErrors = (0,arrays/* isNonEmptyArray */.O)(graphQLErrors);
            if (requestId >= queryInfo.lastRequestId) {
                if (hasErrors && options.errorPolicy === "none") {
                    throw queryInfo.markError(new errors/* ApolloError */.c({
                        graphQLErrors: graphQLErrors,
                    }));
                }
                queryInfo.markResult(result, linkDocument, options, cacheWriteBehavior);
                queryInfo.markReady();
            }
            var aqr = {
                data: result.data,
                loading: false,
                networkStatus: core_networkStatus/* NetworkStatus.ready */.I.ready,
            };
            if (hasErrors && options.errorPolicy !== "ignore") {
                aqr.errors = graphQLErrors;
                aqr.networkStatus = core_networkStatus/* NetworkStatus.error */.I.error;
            }
            return aqr;
        }, function (networkError) {
            var error = (0,errors/* isApolloError */.M)(networkError)
                ? networkError
                : new errors/* ApolloError */.c({ networkError: networkError });
            if (requestId >= queryInfo.lastRequestId) {
                queryInfo.markError(error);
            }
            throw error;
        });
    };
    QueryManager.prototype.fetchQueryObservable = function (queryId, options, networkStatus) {
        var _this = this;
        if (networkStatus === void 0) { networkStatus = core_networkStatus/* NetworkStatus.loading */.I.loading; }
        var query = this.transform(options.query).document;
        var variables = this.getVariables(query, options.variables);
        var queryInfo = this.getQuery(queryId);
        var defaults = this.defaultOptions.watchQuery;
        var _a = options.fetchPolicy, fetchPolicy = _a === void 0 ? defaults && defaults.fetchPolicy || "cache-first" : _a, _b = options.errorPolicy, errorPolicy = _b === void 0 ? defaults && defaults.errorPolicy || "none" : _b, _c = options.returnPartialData, returnPartialData = _c === void 0 ? false : _c, _d = options.notifyOnNetworkStatusChange, notifyOnNetworkStatusChange = _d === void 0 ? false : _d, _e = options.context, context = _e === void 0 ? {} : _e;
        var normalized = Object.assign({}, options, {
            query: query,
            variables: variables,
            fetchPolicy: fetchPolicy,
            errorPolicy: errorPolicy,
            returnPartialData: returnPartialData,
            notifyOnNetworkStatusChange: notifyOnNetworkStatusChange,
            context: context,
        });
        var fromVariables = function (variables) {
            normalized.variables = variables;
            var concastSources = _this.fetchQueryByPolicy(queryInfo, normalized, networkStatus);
            if (normalized.fetchPolicy !== "standby" &&
                concastSources.length > 0 &&
                queryInfo.observableQuery) {
                queryInfo.observableQuery["applyNextFetchPolicy"]("after-fetch", options);
            }
            return concastSources;
        };
        var cleanupCancelFn = function () { return _this.fetchCancelFns.delete(queryId); };
        this.fetchCancelFns.set(queryId, function (reason) {
            cleanupCancelFn();
            setTimeout(function () { return concast.cancel(reason); });
        });
        var concast = new Concast(this.transform(normalized.query).hasClientExports
            ? this.localState.addExportedVariables(normalized.query, normalized.variables, normalized.context).then(fromVariables)
            : fromVariables(normalized.variables));
        concast.promise.then(cleanupCancelFn, cleanupCancelFn);
        return concast;
    };
    QueryManager.prototype.refetchQueries = function (_a) {
        var _this = this;
        var updateCache = _a.updateCache, include = _a.include, _b = _a.optimistic, optimistic = _b === void 0 ? false : _b, _c = _a.removeOptimistic, removeOptimistic = _c === void 0 ? optimistic ? (0,makeUniqueId/* makeUniqueId */.X)("refetchQueries") : void 0 : _c, onQueryUpdated = _a.onQueryUpdated;
        var includedQueriesById = new Map();
        if (include) {
            this.getObservableQueries(include).forEach(function (oq, queryId) {
                includedQueriesById.set(queryId, {
                    oq: oq,
                    lastDiff: _this.getQuery(queryId).getDiff(),
                });
            });
        }
        var results = new Map;
        if (updateCache) {
            this.cache.batch({
                update: updateCache,
                optimistic: optimistic && removeOptimistic || false,
                removeOptimistic: removeOptimistic,
                onWatchUpdated: function (watch, diff, lastDiff) {
                    var oq = watch.watcher instanceof QueryInfo &&
                        watch.watcher.observableQuery;
                    if (oq) {
                        if (onQueryUpdated) {
                            includedQueriesById.delete(oq.queryId);
                            var result = onQueryUpdated(oq, diff, lastDiff);
                            if (result === true) {
                                result = oq.refetch();
                            }
                            if (result !== false) {
                                results.set(oq, result);
                            }
                            return result;
                        }
                        if (onQueryUpdated !== null) {
                            includedQueriesById.set(oq.queryId, { oq: oq, lastDiff: lastDiff, diff: diff });
                        }
                    }
                },
            });
        }
        if (includedQueriesById.size) {
            includedQueriesById.forEach(function (_a, queryId) {
                var oq = _a.oq, lastDiff = _a.lastDiff, diff = _a.diff;
                var result;
                if (onQueryUpdated) {
                    if (!diff) {
                        var info = oq["queryInfo"];
                        info.reset();
                        diff = info.getDiff();
                    }
                    result = onQueryUpdated(oq, diff, lastDiff);
                }
                if (!onQueryUpdated || result === true) {
                    result = oq.refetch();
                }
                if (result !== false) {
                    results.set(oq, result);
                }
                if (queryId.indexOf("legacyOneTimeQuery") >= 0) {
                    _this.stopQueryNoBroadcast(queryId);
                }
            });
        }
        if (removeOptimistic) {
            this.cache.removeOptimistic(removeOptimistic);
        }
        return results;
    };
    QueryManager.prototype.fetchQueryByPolicy = function (queryInfo, _a, networkStatus) {
        var _this = this;
        var query = _a.query, variables = _a.variables, fetchPolicy = _a.fetchPolicy, refetchWritePolicy = _a.refetchWritePolicy, errorPolicy = _a.errorPolicy, returnPartialData = _a.returnPartialData, context = _a.context, notifyOnNetworkStatusChange = _a.notifyOnNetworkStatusChange;
        var oldNetworkStatus = queryInfo.networkStatus;
        queryInfo.init({
            document: this.transform(query).document,
            variables: variables,
            networkStatus: networkStatus,
        });
        var readCache = function () { return queryInfo.getDiff(variables); };
        var resultsFromCache = function (diff, networkStatus) {
            if (networkStatus === void 0) { networkStatus = queryInfo.networkStatus || core_networkStatus/* NetworkStatus.loading */.I.loading; }
            var data = diff.result;
            if (__DEV__ &&
                !returnPartialData &&
                !(0,equality_esm/* equal */.D)(data, {})) {
                (0,ObservableQuery/* logMissingFieldErrors */.DC)(diff.missing);
            }
            var fromData = function (data) { return zen_observable_ts_module/* Observable.of */.y.of((0,tslib_es6/* __assign */.pi)({ data: data, loading: (0,core_networkStatus/* isNetworkRequestInFlight */.O)(networkStatus), networkStatus: networkStatus }, (diff.complete ? null : { partial: true }))); };
            if (data && _this.transform(query).hasForcedResolvers) {
                return _this.localState.runResolvers({
                    document: query,
                    remoteResult: { data: data },
                    context: context,
                    variables: variables,
                    onlyRunForcedResolvers: true,
                }).then(function (resolved) { return fromData(resolved.data || void 0); });
            }
            return fromData(data);
        };
        var cacheWriteBehavior = fetchPolicy === "no-cache" ? 0 :
            (networkStatus === core_networkStatus/* NetworkStatus.refetch */.I.refetch &&
                refetchWritePolicy !== "merge") ? 1
                : 2;
        var resultsFromLink = function () { return _this.getResultsFromLink(queryInfo, cacheWriteBehavior, {
            variables: variables,
            context: context,
            fetchPolicy: fetchPolicy,
            errorPolicy: errorPolicy,
        }); };
        var shouldNotify = notifyOnNetworkStatusChange &&
            typeof oldNetworkStatus === "number" &&
            oldNetworkStatus !== networkStatus &&
            (0,core_networkStatus/* isNetworkRequestInFlight */.O)(networkStatus);
        switch (fetchPolicy) {
            default:
            case "cache-first": {
                var diff = readCache();
                if (diff.complete) {
                    return [
                        resultsFromCache(diff, queryInfo.markReady()),
                    ];
                }
                if (returnPartialData || shouldNotify) {
                    return [
                        resultsFromCache(diff),
                        resultsFromLink(),
                    ];
                }
                return [
                    resultsFromLink(),
                ];
            }
            case "cache-and-network": {
                var diff = readCache();
                if (diff.complete || returnPartialData || shouldNotify) {
                    return [
                        resultsFromCache(diff),
                        resultsFromLink(),
                    ];
                }
                return [
                    resultsFromLink(),
                ];
            }
            case "cache-only":
                return [
                    resultsFromCache(readCache(), queryInfo.markReady()),
                ];
            case "network-only":
                if (shouldNotify) {
                    return [
                        resultsFromCache(readCache()),
                        resultsFromLink(),
                    ];
                }
                return [resultsFromLink()];
            case "no-cache":
                if (shouldNotify) {
                    return [
                        resultsFromCache(queryInfo.getDiff()),
                        resultsFromLink(),
                    ];
                }
                return [resultsFromLink()];
            case "standby":
                return [];
        }
    };
    QueryManager.prototype.getQuery = function (queryId) {
        if (queryId && !this.queries.has(queryId)) {
            this.queries.set(queryId, new QueryInfo(this, queryId));
        }
        return this.queries.get(queryId);
    };
    QueryManager.prototype.prepareContext = function (context) {
        if (context === void 0) { context = {}; }
        var newContext = this.localState.prepareContext(context);
        return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, newContext), { clientAwareness: this.clientAwareness });
    };
    return QueryManager;
}());

//# sourceMappingURL=QueryManager.js.map
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/mergeOptions.js
var mergeOptions = __webpack_require__(14012);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/core/ApolloClient.js







var hasSuggestedDevtools = false;


var ApolloClient = (function () {
    function ApolloClient(options) {
        var _this = this;
        this.resetStoreCallbacks = [];
        this.clearStoreCallbacks = [];
        var uri = options.uri, credentials = options.credentials, headers = options.headers, cache = options.cache, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, _c = options.connectToDevTools, connectToDevTools = _c === void 0 ? typeof window === 'object' &&
            !window.__APOLLO_CLIENT__ &&
            __DEV__ : _c, _d = options.queryDeduplication, queryDeduplication = _d === void 0 ? true : _d, defaultOptions = options.defaultOptions, _e = options.assumeImmutableResults, assumeImmutableResults = _e === void 0 ? false : _e, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version;
        var link = options.link;
        if (!link) {
            link = uri
                ? new HttpLink/* HttpLink */.u({ uri: uri, credentials: credentials, headers: headers })
                : ApolloLink/* ApolloLink.empty */.i.empty();
        }
        if (!cache) {
            throw __DEV__ ? new globals/* InvariantError */.ej("To initialize Apollo Client, you must specify a 'cache' property " +
                "in the options object. \n" +
                "For more information, please visit: https://go.apollo.dev/c/docs") : new globals/* InvariantError */.ej(9);
        }
        this.link = link;
        this.cache = cache;
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.defaultOptions = defaultOptions || Object.create(null);
        this.typeDefs = typeDefs;
        if (ssrForceFetchDelay) {
            setTimeout(function () { return (_this.disableNetworkFetches = false); }, ssrForceFetchDelay);
        }
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        if (connectToDevTools && typeof window === 'object') {
            window.__APOLLO_CLIENT__ = this;
        }
        if (!hasSuggestedDevtools && __DEV__) {
            hasSuggestedDevtools = true;
            if (typeof window !== 'undefined' &&
                window.document &&
                window.top === window.self &&
                !window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__) {
                var nav = window.navigator;
                var ua = nav && nav.userAgent;
                var url = void 0;
                if (typeof ua === "string") {
                    if (ua.indexOf("Chrome/") > -1) {
                        url = "https://chrome.google.com/webstore/detail/" +
                            "apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm";
                    }
                    else if (ua.indexOf("Firefox/") > -1) {
                        url = "https://addons.mozilla.org/en-US/firefox/addon/apollo-developer-tools/";
                    }
                }
                if (url) {
                    __DEV__ && globals/* invariant.log */.kG.log("Download the Apollo DevTools for a better development " +
                        "experience: " + url);
                }
            }
        }
        this.version = version;
        this.localState = new LocalState({
            cache: cache,
            client: this,
            resolvers: resolvers,
            fragmentMatcher: fragmentMatcher,
        });
        this.queryManager = new QueryManager({
            cache: this.cache,
            link: this.link,
            defaultOptions: this.defaultOptions,
            queryDeduplication: queryDeduplication,
            ssrMode: ssrMode,
            clientAwareness: {
                name: clientAwarenessName,
                version: clientAwarenessVersion,
            },
            localState: this.localState,
            assumeImmutableResults: assumeImmutableResults,
            onBroadcast: connectToDevTools ? function () {
                if (_this.devToolsHookCb) {
                    _this.devToolsHookCb({
                        action: {},
                        state: {
                            queries: _this.queryManager.getQueryStore(),
                            mutations: _this.queryManager.mutationStore || {},
                        },
                        dataWithOptimisticResults: _this.cache.extract(true),
                    });
                }
            } : void 0,
        });
    }
    ApolloClient.prototype.stop = function () {
        this.queryManager.stop();
    };
    ApolloClient.prototype.watchQuery = function (options) {
        if (this.defaultOptions.watchQuery) {
            options = (0,mergeOptions/* mergeOptions */.J)(this.defaultOptions.watchQuery, options);
        }
        if (this.disableNetworkFetches &&
            (options.fetchPolicy === 'network-only' ||
                options.fetchPolicy === 'cache-and-network')) {
            options = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { fetchPolicy: 'cache-first' });
        }
        return this.queryManager.watchQuery(options);
    };
    ApolloClient.prototype.query = function (options) {
        if (this.defaultOptions.query) {
            options = (0,mergeOptions/* mergeOptions */.J)(this.defaultOptions.query, options);
        }
        __DEV__ ? (0,globals/* invariant */.kG)(options.fetchPolicy !== 'cache-and-network', 'The cache-and-network fetchPolicy does not work with client.query, because ' +
            'client.query can only return a single result. Please use client.watchQuery ' +
            'to receive multiple results from the cache and the network, or consider ' +
            'using a different fetchPolicy, such as cache-first or network-only.') : (0,globals/* invariant */.kG)(options.fetchPolicy !== 'cache-and-network', 10);
        if (this.disableNetworkFetches && options.fetchPolicy === 'network-only') {
            options = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { fetchPolicy: 'cache-first' });
        }
        return this.queryManager.query(options);
    };
    ApolloClient.prototype.mutate = function (options) {
        if (this.defaultOptions.mutate) {
            options = (0,mergeOptions/* mergeOptions */.J)(this.defaultOptions.mutate, options);
        }
        return this.queryManager.mutate(options);
    };
    ApolloClient.prototype.subscribe = function (options) {
        return this.queryManager.startGraphQLSubscription(options);
    };
    ApolloClient.prototype.readQuery = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.cache.readQuery(options, optimistic);
    };
    ApolloClient.prototype.readFragment = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.cache.readFragment(options, optimistic);
    };
    ApolloClient.prototype.writeQuery = function (options) {
        this.cache.writeQuery(options);
        this.queryManager.broadcastQueries();
    };
    ApolloClient.prototype.writeFragment = function (options) {
        this.cache.writeFragment(options);
        this.queryManager.broadcastQueries();
    };
    ApolloClient.prototype.__actionHookForDevTools = function (cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function (payload) {
        return (0,execute/* execute */.h)(this.link, payload);
    };
    ApolloClient.prototype.resetStore = function () {
        var _this = this;
        return Promise.resolve()
            .then(function () { return _this.queryManager.clearStore({
            discardWatches: false,
        }); })
            .then(function () { return Promise.all(_this.resetStoreCallbacks.map(function (fn) { return fn(); })); })
            .then(function () { return _this.reFetchObservableQueries(); });
    };
    ApolloClient.prototype.clearStore = function () {
        var _this = this;
        return Promise.resolve()
            .then(function () { return _this.queryManager.clearStore({
            discardWatches: true,
        }); })
            .then(function () { return Promise.all(_this.clearStoreCallbacks.map(function (fn) { return fn(); })); });
    };
    ApolloClient.prototype.onResetStore = function (cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function () {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function (c) { return c !== cb; });
        };
    };
    ApolloClient.prototype.onClearStore = function (cb) {
        var _this = this;
        this.clearStoreCallbacks.push(cb);
        return function () {
            _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function (c) { return c !== cb; });
        };
    };
    ApolloClient.prototype.reFetchObservableQueries = function (includeStandby) {
        return this.queryManager.reFetchObservableQueries(includeStandby);
    };
    ApolloClient.prototype.refetchQueries = function (options) {
        var map = this.queryManager.refetchQueries(options);
        var queries = [];
        var results = [];
        map.forEach(function (result, obsQuery) {
            queries.push(obsQuery);
            results.push(result);
        });
        var result = Promise.all(results);
        result.queries = queries;
        result.results = results;
        result.catch(function (error) {
            __DEV__ && globals/* invariant.debug */.kG.debug("In client.refetchQueries, Promise.all promise rejected with error ".concat(error));
        });
        return result;
    };
    ApolloClient.prototype.getObservableQueries = function (include) {
        if (include === void 0) { include = "active"; }
        return this.queryManager.getObservableQueries(include);
    };
    ApolloClient.prototype.extract = function (optimistic) {
        return this.cache.extract(optimistic);
    };
    ApolloClient.prototype.restore = function (serializedState) {
        return this.cache.restore(serializedState);
    };
    ApolloClient.prototype.addResolvers = function (resolvers) {
        this.localState.addResolvers(resolvers);
    };
    ApolloClient.prototype.setResolvers = function (resolvers) {
        this.localState.setResolvers(resolvers);
    };
    ApolloClient.prototype.getResolvers = function () {
        return this.localState.getResolvers();
    };
    ApolloClient.prototype.setLocalStateFragmentMatcher = function (fragmentMatcher) {
        this.localState.setFragmentMatcher(fragmentMatcher);
    };
    ApolloClient.prototype.setLink = function (newLink) {
        this.link = this.queryManager.link = newLink;
    };
    return ApolloClient;
}());

//# sourceMappingURL=ApolloClient.js.map

/***/ }),

/***/ 44780:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DC": function() { return /* binding */ logMissingFieldErrors; },
/* harmony export */   "ue": function() { return /* binding */ ObservableQuery; },
/* harmony export */   "vj": function() { return /* binding */ reobserveCacheFirst; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70655);
/* harmony import */ var _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62985);
/* harmony import */ var _wry_equality__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82152);
/* harmony import */ var _networkStatus_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1644);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36765);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(79487);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21436);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(53712);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(18263);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(48216);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(86403);





var assign = Object.assign, hasOwnProperty = Object.hasOwnProperty;
var ObservableQuery = (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__extends */ .ZT)(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var queryManager = _a.queryManager, queryInfo = _a.queryInfo, options = _a.options;
        var _this = _super.call(this, function (observer) {
            try {
                var subObserver = observer._subscription._observer;
                if (subObserver && !subObserver.error) {
                    subObserver.error = defaultSubscriptionObserverErrorCallback;
                }
            }
            catch (_a) { }
            var first = !_this.observers.size;
            _this.observers.add(observer);
            var last = _this.last;
            if (last && last.error) {
                observer.error && observer.error(last.error);
            }
            else if (last && last.result) {
                observer.next && observer.next(last.result);
            }
            if (first) {
                _this.reobserve().catch(function () { });
            }
            return function () {
                if (_this.observers.delete(observer) && !_this.observers.size) {
                    _this.tearDownQuery();
                }
            };
        }) || this;
        _this.observers = new Set();
        _this.subscriptions = new Set();
        _this.queryInfo = queryInfo;
        _this.queryManager = queryManager;
        _this.isTornDown = false;
        var _b = queryManager.defaultOptions.watchQuery, _c = _b === void 0 ? {} : _b, _d = _c.fetchPolicy, defaultFetchPolicy = _d === void 0 ? "cache-first" : _d;
        var _e = options.fetchPolicy, fetchPolicy = _e === void 0 ? defaultFetchPolicy : _e, _f = options.initialFetchPolicy, initialFetchPolicy = _f === void 0 ? (fetchPolicy === "standby" ? defaultFetchPolicy : fetchPolicy) : _f;
        _this.options = (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, options), { initialFetchPolicy: initialFetchPolicy, fetchPolicy: fetchPolicy });
        _this.queryId = queryInfo.queryId || queryManager.generateQueryId();
        var opDef = (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_3__/* .getOperationDefinition */ .$H)(_this.query);
        _this.queryName = opDef && opDef.name && opDef.name.value;
        return _this;
    }
    Object.defineProperty(ObservableQuery.prototype, "query", {
        get: function () {
            return this.queryManager.transform(this.options.query).document;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ObservableQuery.prototype, "variables", {
        get: function () {
            return this.options.variables;
        },
        enumerable: false,
        configurable: true
    });
    ObservableQuery.prototype.result = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var observer = {
                next: function (result) {
                    resolve(result);
                    _this.observers.delete(observer);
                    if (!_this.observers.size) {
                        _this.queryManager.removeQuery(_this.queryId);
                    }
                    setTimeout(function () {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: reject,
            };
            var subscription = _this.subscribe(observer);
        });
    };
    ObservableQuery.prototype.getCurrentResult = function (saveAsLastResult) {
        if (saveAsLastResult === void 0) { saveAsLastResult = true; }
        var lastResult = this.getLastResult(true);
        var networkStatus = this.queryInfo.networkStatus ||
            (lastResult && lastResult.networkStatus) ||
            _networkStatus_js__WEBPACK_IMPORTED_MODULE_4__/* .NetworkStatus.ready */ .I.ready;
        var result = (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, lastResult), { loading: (0,_networkStatus_js__WEBPACK_IMPORTED_MODULE_4__/* .isNetworkRequestInFlight */ .O)(networkStatus), networkStatus: networkStatus });
        var _a = this.options.fetchPolicy, fetchPolicy = _a === void 0 ? "cache-first" : _a;
        if (fetchPolicy === 'network-only' ||
            fetchPolicy === 'no-cache' ||
            fetchPolicy === 'standby' ||
            this.queryManager.transform(this.options.query).hasForcedResolvers) {
        }
        else {
            var diff = this.queryInfo.getDiff();
            if (diff.complete || this.options.returnPartialData) {
                result.data = diff.result;
            }
            if ((0,_wry_equality__WEBPACK_IMPORTED_MODULE_1__/* .equal */ .D)(result.data, {})) {
                result.data = void 0;
            }
            if (diff.complete) {
                delete result.partial;
                if (diff.complete &&
                    result.networkStatus === _networkStatus_js__WEBPACK_IMPORTED_MODULE_4__/* .NetworkStatus.loading */ .I.loading &&
                    (fetchPolicy === 'cache-first' ||
                        fetchPolicy === 'cache-only')) {
                    result.networkStatus = _networkStatus_js__WEBPACK_IMPORTED_MODULE_4__/* .NetworkStatus.ready */ .I.ready;
                    result.loading = false;
                }
            }
            else {
                result.partial = true;
            }
            if (__DEV__ &&
                !diff.complete &&
                !this.options.partialRefetch &&
                !result.loading &&
                !result.data &&
                !result.error) {
                logMissingFieldErrors(diff.missing);
            }
        }
        if (saveAsLastResult) {
            this.updateLastResult(result);
        }
        return result;
    };
    ObservableQuery.prototype.isDifferentFromLastResult = function (newResult) {
        return !this.last || !(0,_wry_equality__WEBPACK_IMPORTED_MODULE_1__/* .equal */ .D)(this.last.result, newResult);
    };
    ObservableQuery.prototype.getLast = function (key, variablesMustMatch) {
        var last = this.last;
        if (last &&
            last[key] &&
            (!variablesMustMatch || (0,_wry_equality__WEBPACK_IMPORTED_MODULE_1__/* .equal */ .D)(last.variables, this.variables))) {
            return last[key];
        }
    };
    ObservableQuery.prototype.getLastResult = function (variablesMustMatch) {
        return this.getLast("result", variablesMustMatch);
    };
    ObservableQuery.prototype.getLastError = function (variablesMustMatch) {
        return this.getLast("error", variablesMustMatch);
    };
    ObservableQuery.prototype.resetLastResults = function () {
        delete this.last;
        this.isTornDown = false;
    };
    ObservableQuery.prototype.resetQueryStoreErrors = function () {
        this.queryManager.resetErrors(this.queryId);
    };
    ObservableQuery.prototype.refetch = function (variables) {
        var _a;
        var reobserveOptions = {
            pollInterval: 0,
        };
        var fetchPolicy = this.options.fetchPolicy;
        if (fetchPolicy === 'cache-and-network') {
            reobserveOptions.fetchPolicy = fetchPolicy;
        }
        else if (fetchPolicy === 'no-cache') {
            reobserveOptions.fetchPolicy = 'no-cache';
        }
        else {
            reobserveOptions.fetchPolicy = 'network-only';
        }
        if (__DEV__ && variables && hasOwnProperty.call(variables, "variables")) {
            var queryDef = (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_3__/* .getQueryDefinition */ .iW)(this.query);
            var vars = queryDef.variableDefinitions;
            if (!vars || !vars.some(function (v) { return v.variable.name.value === "variables"; })) {
                __DEV__ && _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant.warn */ .kG.warn("Called refetch(".concat(JSON.stringify(variables), ") for query ").concat(((_a = queryDef.name) === null || _a === void 0 ? void 0 : _a.value) || JSON.stringify(queryDef), ", which does not declare a $variables variable.\nDid you mean to call refetch(variables) instead of refetch({ variables })?"));
            }
        }
        if (variables && !(0,_wry_equality__WEBPACK_IMPORTED_MODULE_1__/* .equal */ .D)(this.options.variables, variables)) {
            reobserveOptions.variables = this.options.variables = (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, this.options.variables), variables);
        }
        this.queryInfo.resetLastWrite();
        return this.reobserve(reobserveOptions, _networkStatus_js__WEBPACK_IMPORTED_MODULE_4__/* .NetworkStatus.refetch */ .I.refetch);
    };
    ObservableQuery.prototype.fetchMore = function (fetchMoreOptions) {
        var _this = this;
        var combinedOptions = (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, (fetchMoreOptions.query ? fetchMoreOptions : (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, this.options), { query: this.query }), fetchMoreOptions), { variables: (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, this.options.variables), fetchMoreOptions.variables) }))), { fetchPolicy: "no-cache" });
        var qid = this.queryManager.generateQueryId();
        var queryInfo = this.queryInfo;
        var originalNetworkStatus = queryInfo.networkStatus;
        queryInfo.networkStatus = _networkStatus_js__WEBPACK_IMPORTED_MODULE_4__/* .NetworkStatus.fetchMore */ .I.fetchMore;
        if (combinedOptions.notifyOnNetworkStatusChange) {
            this.observe();
        }
        var updatedQuerySet = new Set();
        return this.queryManager.fetchQuery(qid, combinedOptions, _networkStatus_js__WEBPACK_IMPORTED_MODULE_4__/* .NetworkStatus.fetchMore */ .I.fetchMore).then(function (fetchMoreResult) {
            _this.queryManager.removeQuery(qid);
            if (queryInfo.networkStatus === _networkStatus_js__WEBPACK_IMPORTED_MODULE_4__/* .NetworkStatus.fetchMore */ .I.fetchMore) {
                queryInfo.networkStatus = originalNetworkStatus;
            }
            _this.queryManager.cache.batch({
                update: function (cache) {
                    var updateQuery = fetchMoreOptions.updateQuery;
                    if (updateQuery) {
                        cache.updateQuery({
                            query: _this.query,
                            variables: _this.variables,
                            returnPartialData: true,
                            optimistic: false,
                        }, function (previous) { return updateQuery(previous, {
                            fetchMoreResult: fetchMoreResult.data,
                            variables: combinedOptions.variables,
                        }); });
                    }
                    else {
                        cache.writeQuery({
                            query: combinedOptions.query,
                            variables: combinedOptions.variables,
                            data: fetchMoreResult.data,
                        });
                    }
                },
                onWatchUpdated: function (watch) {
                    updatedQuerySet.add(watch.query);
                },
            });
            return fetchMoreResult;
        }).finally(function () {
            if (!updatedQuerySet.has(_this.query)) {
                reobserveCacheFirst(_this);
            }
        });
    };
    ObservableQuery.prototype.subscribeToMore = function (options) {
        var _this = this;
        var subscription = this.queryManager
            .startGraphQLSubscription({
            query: options.document,
            variables: options.variables,
            context: options.context,
        })
            .subscribe({
            next: function (subscriptionData) {
                var updateQuery = options.updateQuery;
                if (updateQuery) {
                    _this.updateQuery(function (previous, _a) {
                        var variables = _a.variables;
                        return updateQuery(previous, {
                            subscriptionData: subscriptionData,
                            variables: variables,
                        });
                    });
                }
            },
            error: function (err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
                __DEV__ && _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant.error */ .kG.error('Unhandled GraphQL subscription error', err);
            },
        });
        this.subscriptions.add(subscription);
        return function () {
            if (_this.subscriptions.delete(subscription)) {
                subscription.unsubscribe();
            }
        };
    };
    ObservableQuery.prototype.setOptions = function (newOptions) {
        return this.reobserve(newOptions);
    };
    ObservableQuery.prototype.setVariables = function (variables) {
        if ((0,_wry_equality__WEBPACK_IMPORTED_MODULE_1__/* .equal */ .D)(this.variables, variables)) {
            return this.observers.size
                ? this.result()
                : Promise.resolve();
        }
        this.options.variables = variables;
        if (!this.observers.size) {
            return Promise.resolve();
        }
        return this.reobserve({
            fetchPolicy: this.options.initialFetchPolicy,
            variables: variables,
        }, _networkStatus_js__WEBPACK_IMPORTED_MODULE_4__/* .NetworkStatus.setVariables */ .I.setVariables);
    };
    ObservableQuery.prototype.updateQuery = function (mapFn) {
        var queryManager = this.queryManager;
        var result = queryManager.cache.diff({
            query: this.options.query,
            variables: this.variables,
            returnPartialData: true,
            optimistic: false,
        }).result;
        var newResult = mapFn(result, {
            variables: this.variables,
        });
        if (newResult) {
            queryManager.cache.writeQuery({
                query: this.options.query,
                data: newResult,
                variables: this.variables,
            });
            queryManager.broadcastQueries();
        }
    };
    ObservableQuery.prototype.startPolling = function (pollInterval) {
        this.options.pollInterval = pollInterval;
        this.updatePolling();
    };
    ObservableQuery.prototype.stopPolling = function () {
        this.options.pollInterval = 0;
        this.updatePolling();
    };
    ObservableQuery.prototype.applyNextFetchPolicy = function (reason, options) {
        if (options.nextFetchPolicy) {
            var _a = options.fetchPolicy, fetchPolicy = _a === void 0 ? "cache-first" : _a, _b = options.initialFetchPolicy, initialFetchPolicy = _b === void 0 ? fetchPolicy : _b;
            if (fetchPolicy === "standby") {
            }
            else if (typeof options.nextFetchPolicy === "function") {
                options.fetchPolicy = options.nextFetchPolicy(fetchPolicy, {
                    reason: reason,
                    options: options,
                    observable: this,
                    initialFetchPolicy: initialFetchPolicy,
                });
            }
            else if (reason === "variables-changed") {
                options.fetchPolicy = initialFetchPolicy;
            }
            else {
                options.fetchPolicy = options.nextFetchPolicy;
            }
        }
        return options.fetchPolicy;
    };
    ObservableQuery.prototype.fetch = function (options, newNetworkStatus) {
        this.queryManager.setObservableQuery(this);
        return this.queryManager.fetchQueryObservable(this.queryId, options, newNetworkStatus);
    };
    ObservableQuery.prototype.updatePolling = function () {
        var _this = this;
        if (this.queryManager.ssrMode) {
            return;
        }
        var _a = this, pollingInfo = _a.pollingInfo, pollInterval = _a.options.pollInterval;
        if (!pollInterval) {
            if (pollingInfo) {
                clearTimeout(pollingInfo.timeout);
                delete this.pollingInfo;
            }
            return;
        }
        if (pollingInfo &&
            pollingInfo.interval === pollInterval) {
            return;
        }
        __DEV__ ? (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(pollInterval, 'Attempted to start a polling query without a polling interval.') : (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(pollInterval, 12);
        var info = pollingInfo || (this.pollingInfo = {});
        info.interval = pollInterval;
        var maybeFetch = function () {
            if (_this.pollingInfo) {
                if (!(0,_networkStatus_js__WEBPACK_IMPORTED_MODULE_4__/* .isNetworkRequestInFlight */ .O)(_this.queryInfo.networkStatus)) {
                    _this.reobserve({
                        fetchPolicy: _this.options.initialFetchPolicy === 'no-cache' ? 'no-cache' : 'network-only',
                    }, _networkStatus_js__WEBPACK_IMPORTED_MODULE_4__/* .NetworkStatus.poll */ .I.poll).then(poll, poll);
                }
                else {
                    poll();
                }
            }
            ;
        };
        var poll = function () {
            var info = _this.pollingInfo;
            if (info) {
                clearTimeout(info.timeout);
                info.timeout = setTimeout(maybeFetch, info.interval);
            }
        };
        poll();
    };
    ObservableQuery.prototype.updateLastResult = function (newResult, variables) {
        if (variables === void 0) { variables = this.variables; }
        this.last = (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, this.last), { result: this.queryManager.assumeImmutableResults
                ? newResult
                : (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_5__/* .cloneDeep */ .X)(newResult), variables: variables });
        if (!(0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_6__/* .isNonEmptyArray */ .O)(newResult.errors)) {
            delete this.last.error;
        }
        return this.last;
    };
    ObservableQuery.prototype.reobserve = function (newOptions, newNetworkStatus) {
        var _this = this;
        this.isTornDown = false;
        var useDisposableConcast = newNetworkStatus === _networkStatus_js__WEBPACK_IMPORTED_MODULE_4__/* .NetworkStatus.refetch */ .I.refetch ||
            newNetworkStatus === _networkStatus_js__WEBPACK_IMPORTED_MODULE_4__/* .NetworkStatus.fetchMore */ .I.fetchMore ||
            newNetworkStatus === _networkStatus_js__WEBPACK_IMPORTED_MODULE_4__/* .NetworkStatus.poll */ .I.poll;
        var oldVariables = this.options.variables;
        var oldFetchPolicy = this.options.fetchPolicy;
        var mergedOptions = (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_7__/* .compact */ .o)(this.options, newOptions || {});
        var options = useDisposableConcast
            ? mergedOptions
            : assign(this.options, mergedOptions);
        if (!useDisposableConcast) {
            this.updatePolling();
            if (newOptions &&
                newOptions.variables &&
                !(0,_wry_equality__WEBPACK_IMPORTED_MODULE_1__/* .equal */ .D)(newOptions.variables, oldVariables) &&
                options.fetchPolicy !== "standby" &&
                options.fetchPolicy === oldFetchPolicy) {
                this.applyNextFetchPolicy("variables-changed", options);
                if (newNetworkStatus === void 0) {
                    newNetworkStatus = _networkStatus_js__WEBPACK_IMPORTED_MODULE_4__/* .NetworkStatus.setVariables */ .I.setVariables;
                }
            }
        }
        var variables = options.variables && (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, options.variables);
        var concast = this.fetch(options, newNetworkStatus);
        var observer = {
            next: function (result) {
                _this.reportResult(result, variables);
            },
            error: function (error) {
                _this.reportError(error, variables);
            },
        };
        if (!useDisposableConcast) {
            if (this.concast && this.observer) {
                this.concast.removeObserver(this.observer);
            }
            this.concast = concast;
            this.observer = observer;
        }
        concast.addObserver(observer);
        return concast.promise;
    };
    ObservableQuery.prototype.observe = function () {
        this.reportResult(this.getCurrentResult(false), this.variables);
    };
    ObservableQuery.prototype.reportResult = function (result, variables) {
        var lastError = this.getLastError();
        if (lastError || this.isDifferentFromLastResult(result)) {
            if (lastError || !result.partial || this.options.returnPartialData) {
                this.updateLastResult(result, variables);
            }
            (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_8__/* .iterateObserversSafely */ .p)(this.observers, 'next', result);
        }
    };
    ObservableQuery.prototype.reportError = function (error, variables) {
        var errorResult = (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, this.getLastResult()), { error: error, errors: error.graphQLErrors, networkStatus: _networkStatus_js__WEBPACK_IMPORTED_MODULE_4__/* .NetworkStatus.error */ .I.error, loading: false });
        this.updateLastResult(errorResult, variables);
        (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_8__/* .iterateObserversSafely */ .p)(this.observers, 'error', this.last.error = error);
    };
    ObservableQuery.prototype.hasObservers = function () {
        return this.observers.size > 0;
    };
    ObservableQuery.prototype.tearDownQuery = function () {
        if (this.isTornDown)
            return;
        if (this.concast && this.observer) {
            this.concast.removeObserver(this.observer);
            delete this.concast;
            delete this.observer;
        }
        this.stopPolling();
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
        this.subscriptions.clear();
        this.queryManager.stopQuery(this.queryId);
        this.observers.clear();
        this.isTornDown = true;
    };
    return ObservableQuery;
}(_utilities_index_js__WEBPACK_IMPORTED_MODULE_9__/* .Observable */ .y));

(0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_10__/* .fixObservableSubclass */ .D)(ObservableQuery);
function reobserveCacheFirst(obsQuery) {
    var _a = obsQuery.options, fetchPolicy = _a.fetchPolicy, nextFetchPolicy = _a.nextFetchPolicy;
    if (fetchPolicy === "cache-and-network" ||
        fetchPolicy === "network-only") {
        return obsQuery.reobserve({
            fetchPolicy: "cache-first",
            nextFetchPolicy: function () {
                this.nextFetchPolicy = nextFetchPolicy;
                if (typeof nextFetchPolicy === "function") {
                    return nextFetchPolicy.apply(this, arguments);
                }
                return fetchPolicy;
            },
        });
    }
    return obsQuery.reobserve();
}
function defaultSubscriptionObserverErrorCallback(error) {
    __DEV__ && _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant.error */ .kG.error('Unhandled error', error.message, error.stack);
}
function logMissingFieldErrors(missing) {
    if (__DEV__ && missing) {
        __DEV__ && _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant.debug */ .kG.debug("Missing cache result fields: ".concat(JSON.stringify(missing)), missing);
    }
}
//# sourceMappingURL=ObservableQuery.js.map

/***/ }),

/***/ 42451:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ApolloCache": function() { return /* reexport */ cache/* ApolloCache */.R; },
  "ApolloClient": function() { return /* reexport */ ApolloClient/* ApolloClient */.f; },
  "ApolloError": function() { return /* reexport */ errors/* ApolloError */.c; },
  "ApolloLink": function() { return /* reexport */ ApolloLink/* ApolloLink */.i; },
  "Cache": function() { return /* reexport */ Cache; },
  "HttpLink": function() { return /* reexport */ http.HttpLink; },
  "InMemoryCache": function() { return /* reexport */ inMemoryCache/* InMemoryCache */.h; },
  "MissingFieldError": function() { return /* reexport */ common/* MissingFieldError */.y; },
  "NetworkStatus": function() { return /* reexport */ networkStatus/* NetworkStatus */.I; },
  "Observable": function() { return /* reexport */ zen_observable_ts_module/* Observable */.y; },
  "ObservableQuery": function() { return /* reexport */ ObservableQuery/* ObservableQuery */.ue; },
  "checkFetcher": function() { return /* reexport */ http.checkFetcher; },
  "concat": function() { return /* reexport */ concat; },
  "createHttpLink": function() { return /* reexport */ http.createHttpLink; },
  "createSignalIfSupported": function() { return /* reexport */ http.createSignalIfSupported; },
  "defaultDataIdFromObject": function() { return /* reexport */ helpers/* defaultDataIdFromObject */.uG; },
  "defaultPrinter": function() { return /* reexport */ http.defaultPrinter; },
  "disableExperimentalFragmentVariables": function() { return /* reexport */ lib/* disableExperimentalFragmentVariables */.J9; },
  "disableFragmentWarnings": function() { return /* reexport */ lib/* disableFragmentWarnings */._t; },
  "empty": function() { return /* reexport */ empty; },
  "enableExperimentalFragmentVariables": function() { return /* reexport */ lib/* enableExperimentalFragmentVariables */.wO; },
  "execute": function() { return /* reexport */ execute/* execute */.h; },
  "fallbackHttpConfig": function() { return /* reexport */ http.fallbackHttpConfig; },
  "from": function() { return /* reexport */ from; },
  "fromError": function() { return /* reexport */ fromError/* fromError */.Q; },
  "fromPromise": function() { return /* reexport */ fromPromise; },
  "gql": function() { return /* reexport */ lib/* gql */.Ps; },
  "isApolloError": function() { return /* reexport */ errors/* isApolloError */.M; },
  "isReference": function() { return /* reexport */ storeUtils/* isReference */.Yk; },
  "makeReference": function() { return /* reexport */ storeUtils/* makeReference */.kQ; },
  "makeVar": function() { return /* reexport */ reactiveVars/* makeVar */.QS; },
  "mergeOptions": function() { return /* reexport */ mergeOptions/* mergeOptions */.J; },
  "parseAndCheckHttpResponse": function() { return /* reexport */ http.parseAndCheckHttpResponse; },
  "resetCaches": function() { return /* reexport */ lib/* resetCaches */.HW; },
  "rewriteURIForGET": function() { return /* reexport */ http.rewriteURIForGET; },
  "selectHttpOptionsAndBody": function() { return /* reexport */ http.selectHttpOptionsAndBody; },
  "selectHttpOptionsAndBodyInternal": function() { return /* reexport */ http.selectHttpOptionsAndBodyInternal; },
  "selectURI": function() { return /* reexport */ http.selectURI; },
  "serializeFetchParameter": function() { return /* reexport */ http.serializeFetchParameter; },
  "setLogVerbosity": function() { return /* reexport */ invariant/* setVerbosity */.U6; },
  "split": function() { return /* reexport */ split; },
  "throwServerError": function() { return /* reexport */ throwServerError/* throwServerError */.P; },
  "toPromise": function() { return /* reexport */ toPromise; }
});

// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/globals/index.js + 5 modules
var globals = __webpack_require__(62985);
// EXTERNAL MODULE: ./node_modules/@apollo/client/core/ApolloClient.js + 8 modules
var ApolloClient = __webpack_require__(64096);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/mergeOptions.js
var mergeOptions = __webpack_require__(14012);
// EXTERNAL MODULE: ./node_modules/@apollo/client/core/ObservableQuery.js
var ObservableQuery = __webpack_require__(44780);
// EXTERNAL MODULE: ./node_modules/@apollo/client/core/networkStatus.js
var networkStatus = __webpack_require__(1644);
// EXTERNAL MODULE: ./node_modules/@apollo/client/errors/index.js
var errors = __webpack_require__(30990);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/cache/core/types/Cache.js
var Cache;
(function (Cache) {
})(Cache || (Cache = {}));
//# sourceMappingURL=Cache.js.map
// EXTERNAL MODULE: ./node_modules/@apollo/client/cache/core/cache.js
var cache = __webpack_require__(11294);
// EXTERNAL MODULE: ./node_modules/@apollo/client/cache/inmemory/inMemoryCache.js + 6 modules
var inMemoryCache = __webpack_require__(55598);
// EXTERNAL MODULE: ./node_modules/@apollo/client/cache/core/types/common.js
var common = __webpack_require__(75727);
// EXTERNAL MODULE: ./node_modules/@apollo/client/cache/inmemory/helpers.js
var helpers = __webpack_require__(49641);
// EXTERNAL MODULE: ./node_modules/@apollo/client/cache/inmemory/reactiveVars.js + 1 modules
var reactiveVars = __webpack_require__(9237);
// EXTERNAL MODULE: ./node_modules/@apollo/client/link/core/ApolloLink.js + 3 modules
var ApolloLink = __webpack_require__(86909);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/core/empty.js

var empty = ApolloLink/* ApolloLink.empty */.i.empty;
//# sourceMappingURL=empty.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/core/from.js

var from = ApolloLink/* ApolloLink.from */.i.from;
//# sourceMappingURL=from.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/core/split.js

var split = ApolloLink/* ApolloLink.split */.i.split;
//# sourceMappingURL=split.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/core/concat.js

var concat = ApolloLink/* ApolloLink.concat */.i.concat;
//# sourceMappingURL=concat.js.map
// EXTERNAL MODULE: ./node_modules/@apollo/client/link/core/execute.js
var execute = __webpack_require__(47037);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/core/index.js








//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/@apollo/client/link/http/index.js
var http = __webpack_require__(85645);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/utils/toPromise.js

function toPromise(observable) {
    var completed = false;
    return new Promise(function (resolve, reject) {
        observable.subscribe({
            next: function (data) {
                if (completed) {
                    __DEV__ && globals/* invariant.warn */.kG.warn("Promise Wrapper does not support multiple results from Observable");
                }
                else {
                    completed = true;
                    resolve(data);
                }
            },
            error: reject,
        });
    });
}
//# sourceMappingURL=toPromise.js.map
// EXTERNAL MODULE: ./node_modules/zen-observable-ts/module.js
var zen_observable_ts_module = __webpack_require__(48216);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/utils/fromPromise.js

function fromPromise(promise) {
    return new zen_observable_ts_module/* Observable */.y(function (observer) {
        promise
            .then(function (value) {
            observer.next(value);
            observer.complete();
        })
            .catch(observer.error.bind(observer));
    });
}
//# sourceMappingURL=fromPromise.js.map
// EXTERNAL MODULE: ./node_modules/@apollo/client/link/utils/fromError.js
var fromError = __webpack_require__(16261);
// EXTERNAL MODULE: ./node_modules/@apollo/client/link/utils/throwServerError.js
var throwServerError = __webpack_require__(12782);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/graphql/storeUtils.js
var storeUtils = __webpack_require__(51761);
// EXTERNAL MODULE: ./node_modules/@apollo/client/node_modules/ts-invariant/lib/invariant.js
var invariant = __webpack_require__(53124);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(12922);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/core/index.js














(0,invariant/* setVerbosity */.U6)(globals/* DEV */.Rk ? "log" : "silent");

//# sourceMappingURL=index.js.map

/***/ }),

/***/ 1644:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ NetworkStatus; },
/* harmony export */   "O": function() { return /* binding */ isNetworkRequestInFlight; }
/* harmony export */ });
var NetworkStatus;
(function (NetworkStatus) {
    NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    NetworkStatus[NetworkStatus["error"] = 8] = "error";
})(NetworkStatus || (NetworkStatus = {}));
function isNetworkRequestInFlight(networkStatus) {
    return networkStatus ? networkStatus < 7 : false;
}
//# sourceMappingURL=networkStatus.js.map

/***/ }),

/***/ 30990:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ isApolloError; },
/* harmony export */   "c": function() { return /* binding */ ApolloError; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70655);
/* harmony import */ var _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62985);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21436);



function isApolloError(err) {
    return err.hasOwnProperty('graphQLErrors');
}
var generateErrorMessage = function (err) {
    var message = '';
    if ((0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isNonEmptyArray */ .O)(err.graphQLErrors) || (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isNonEmptyArray */ .O)(err.clientErrors)) {
        var errors = (err.graphQLErrors || [])
            .concat(err.clientErrors || []);
        errors.forEach(function (error) {
            var errorMessage = error
                ? error.message
                : 'Error message not found.';
            message += "".concat(errorMessage, "\n");
        });
    }
    if (err.networkError) {
        message += "".concat(err.networkError.message, "\n");
    }
    message = message.replace(/\n$/, '');
    return message;
};
var ApolloError = (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__extends */ .ZT)(ApolloError, _super);
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, clientErrors = _a.clientErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.graphQLErrors = graphQLErrors || [];
        _this.clientErrors = clientErrors || [];
        _this.networkError = networkError || null;
        _this.message = errorMessage || generateErrorMessage(_this);
        _this.extraInfo = extraInfo;
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error));

//# sourceMappingURL=index.js.map

/***/ }),

/***/ 86909:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i": function() { return /* binding */ ApolloLink; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/globals/index.js + 5 modules
var globals = __webpack_require__(62985);
// EXTERNAL MODULE: ./node_modules/zen-observable-ts/module.js
var zen_observable_ts_module = __webpack_require__(48216);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/utils/createOperation.js

function createOperation(starting, operation) {
    var context = (0,tslib_es6/* __assign */.pi)({}, starting);
    var setContext = function (next) {
        if (typeof next === 'function') {
            context = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, context), next(context));
        }
        else {
            context = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, context), next);
        }
    };
    var getContext = function () { return ((0,tslib_es6/* __assign */.pi)({}, context)); };
    Object.defineProperty(operation, 'setContext', {
        enumerable: false,
        value: setContext,
    });
    Object.defineProperty(operation, 'getContext', {
        enumerable: false,
        value: getContext,
    });
    return operation;
}
//# sourceMappingURL=createOperation.js.map
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/graphql/getFromAST.js
var getFromAST = __webpack_require__(36765);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/utils/transformOperation.js

function transformOperation(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query,
    };
    if (!transformedOperation.operationName) {
        transformedOperation.operationName =
            typeof transformedOperation.query !== 'string'
                ? (0,getFromAST/* getOperationName */.rY)(transformedOperation.query) || undefined
                : '';
    }
    return transformedOperation;
}
//# sourceMappingURL=transformOperation.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/utils/validateOperation.js

function validateOperation(operation) {
    var OPERATION_FIELDS = [
        'query',
        'operationName',
        'variables',
        'extensions',
        'context',
    ];
    for (var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++) {
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) {
            throw __DEV__ ? new globals/* InvariantError */.ej("illegal argument: ".concat(key)) : new globals/* InvariantError */.ej(26);
        }
    }
    return operation;
}
//# sourceMappingURL=validateOperation.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/core/ApolloLink.js




function passthrough(op, forward) {
    return (forward ? forward(op) : zen_observable_ts_module/* Observable.of */.y.of());
}
function toLink(handler) {
    return typeof handler === 'function' ? new ApolloLink(handler) : handler;
}
function isTerminating(link) {
    return link.request.length <= 1;
}
var LinkError = (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(LinkError, _super);
    function LinkError(message, link) {
        var _this = _super.call(this, message) || this;
        _this.link = link;
        return _this;
    }
    return LinkError;
}(Error));
var ApolloLink = (function () {
    function ApolloLink(request) {
        if (request)
            this.request = request;
    }
    ApolloLink.empty = function () {
        return new ApolloLink(function () { return zen_observable_ts_module/* Observable.of */.y.of(); });
    };
    ApolloLink.from = function (links) {
        if (links.length === 0)
            return ApolloLink.empty();
        return links.map(toLink).reduce(function (x, y) { return x.concat(y); });
    };
    ApolloLink.split = function (test, left, right) {
        var leftLink = toLink(left);
        var rightLink = toLink(right || new ApolloLink(passthrough));
        if (isTerminating(leftLink) && isTerminating(rightLink)) {
            return new ApolloLink(function (operation) {
                return test(operation)
                    ? leftLink.request(operation) || zen_observable_ts_module/* Observable.of */.y.of()
                    : rightLink.request(operation) || zen_observable_ts_module/* Observable.of */.y.of();
            });
        }
        else {
            return new ApolloLink(function (operation, forward) {
                return test(operation)
                    ? leftLink.request(operation, forward) || zen_observable_ts_module/* Observable.of */.y.of()
                    : rightLink.request(operation, forward) || zen_observable_ts_module/* Observable.of */.y.of();
            });
        }
    };
    ApolloLink.execute = function (link, operation) {
        return (link.request(createOperation(operation.context, transformOperation(validateOperation(operation)))) || zen_observable_ts_module/* Observable.of */.y.of());
    };
    ApolloLink.concat = function (first, second) {
        var firstLink = toLink(first);
        if (isTerminating(firstLink)) {
            __DEV__ && globals/* invariant.warn */.kG.warn(new LinkError("You are calling concat on a terminating link, which will have no effect", firstLink));
            return firstLink;
        }
        var nextLink = toLink(second);
        if (isTerminating(nextLink)) {
            return new ApolloLink(function (operation) {
                return firstLink.request(operation, function (op) { return nextLink.request(op) || zen_observable_ts_module/* Observable.of */.y.of(); }) || zen_observable_ts_module/* Observable.of */.y.of();
            });
        }
        else {
            return new ApolloLink(function (operation, forward) {
                return (firstLink.request(operation, function (op) {
                    return nextLink.request(op, forward) || zen_observable_ts_module/* Observable.of */.y.of();
                }) || zen_observable_ts_module/* Observable.of */.y.of());
            });
        }
    };
    ApolloLink.prototype.split = function (test, left, right) {
        return this.concat(ApolloLink.split(test, left, right || new ApolloLink(passthrough)));
    };
    ApolloLink.prototype.concat = function (next) {
        return ApolloLink.concat(this, next);
    };
    ApolloLink.prototype.request = function (operation, forward) {
        throw __DEV__ ? new globals/* InvariantError */.ej('request is not implemented') : new globals/* InvariantError */.ej(21);
    };
    ApolloLink.prototype.onError = function (error, observer) {
        if (observer && observer.error) {
            observer.error(error);
            return false;
        }
        throw error;
    };
    ApolloLink.prototype.setOnError = function (fn) {
        this.onError = fn;
        return this;
    };
    return ApolloLink;
}());

//# sourceMappingURL=ApolloLink.js.map

/***/ }),

/***/ 47037:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ execute; }
/* harmony export */ });
/* harmony import */ var _ApolloLink_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86909);

var execute = _ApolloLink_js__WEBPACK_IMPORTED_MODULE_0__/* .ApolloLink.execute */ .i.execute;
//# sourceMappingURL=execute.js.map

/***/ }),

/***/ 72198:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ HttpLink; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70655);
/* harmony import */ var _core_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86909);
/* harmony import */ var _createHttpLink_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34747);



var HttpLink = (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(HttpLink, _super);
    function HttpLink(options) {
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, (0,_createHttpLink_js__WEBPACK_IMPORTED_MODULE_1__/* .createHttpLink */ .L)(options).request) || this;
        _this.options = options;
        return _this;
    }
    return HttpLink;
}(_core_index_js__WEBPACK_IMPORTED_MODULE_2__/* .ApolloLink */ .i));

//# sourceMappingURL=HttpLink.js.map

/***/ }),

/***/ 23178:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ checkFetcher; }
/* harmony export */ });
/* harmony import */ var _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62985);

var checkFetcher = function (fetcher) {
    if (!fetcher && typeof fetch === 'undefined') {
        throw __DEV__ ? new _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .InvariantError */ .ej("\n\"fetch\" has not been found globally and no fetcher has been configured. To fix this, install a fetch package (like https://www.npmjs.com/package/cross-fetch), instantiate the fetcher, and pass it into your HttpLink constructor. For example:\n\nimport fetch from 'cross-fetch';\nimport { ApolloClient, HttpLink } from '@apollo/client';\nconst client = new ApolloClient({\n  link: new HttpLink({ uri: '/graphql', fetch })\n});\n    ") : new _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .InvariantError */ .ej(22);
    }
};
//# sourceMappingURL=checkFetcher.js.map

/***/ }),

/***/ 34747:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ createHttpLink; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70655);
/* harmony import */ var _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62985);
/* harmony import */ var graphql__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(77304);
/* harmony import */ var _core_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86909);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19065);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(48216);
/* harmony import */ var _serializeFetchParameter_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(88793);
/* harmony import */ var _selectURI_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11037);
/* harmony import */ var _parseAndCheckHttpResponse_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(93227);
/* harmony import */ var _checkFetcher_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23178);
/* harmony import */ var _selectHttpOptionsAndBody_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58995);
/* harmony import */ var _createSignalIfSupported_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(77388);
/* harmony import */ var _rewriteURIForGET_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(88663);
/* harmony import */ var _utils_index_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(16261);














var backupFetch = (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .maybe */ .wY)(function () { return fetch; });
var createHttpLink = function (linkOptions) {
    if (linkOptions === void 0) { linkOptions = {}; }
    var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, preferredFetch = linkOptions.fetch, _b = linkOptions.print, print = _b === void 0 ? _selectHttpOptionsAndBody_js__WEBPACK_IMPORTED_MODULE_1__/* .defaultPrinter */ .sb : _b, includeExtensions = linkOptions.includeExtensions, preserveHeaderCase = linkOptions.preserveHeaderCase, useGETForQueries = linkOptions.useGETForQueries, _c = linkOptions.includeUnusedVariables, includeUnusedVariables = _c === void 0 ? false : _c, requestOptions = (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__rest */ ._T)(linkOptions, ["uri", "fetch", "print", "includeExtensions", "preserveHeaderCase", "useGETForQueries", "includeUnusedVariables"]);
    if (__DEV__) {
        (0,_checkFetcher_js__WEBPACK_IMPORTED_MODULE_3__/* .checkFetcher */ .U)(preferredFetch || backupFetch);
    }
    var linkConfig = {
        http: { includeExtensions: includeExtensions, preserveHeaderCase: preserveHeaderCase },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers,
    };
    return new _core_index_js__WEBPACK_IMPORTED_MODULE_4__/* .ApolloLink */ .i(function (operation) {
        var chosenURI = (0,_selectURI_js__WEBPACK_IMPORTED_MODULE_5__/* .selectURI */ .r)(operation, uri);
        var context = operation.getContext();
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) {
                clientAwarenessHeaders['apollographql-client-name'] = name_1;
            }
            if (version) {
                clientAwarenessHeaders['apollographql-client-version'] = version;
            }
        }
        var contextHeaders = (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, clientAwarenessHeaders), context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders,
        };
        var _b = (0,_selectHttpOptionsAndBody_js__WEBPACK_IMPORTED_MODULE_1__/* .selectHttpOptionsAndBodyInternal */ .ve)(operation, print, _selectHttpOptionsAndBody_js__WEBPACK_IMPORTED_MODULE_1__/* .fallbackHttpConfig */ .SC, linkConfig, contextConfig), options = _b.options, body = _b.body;
        if (body.variables && !includeUnusedVariables) {
            var unusedNames_1 = new Set(Object.keys(body.variables));
            (0,graphql__WEBPACK_IMPORTED_MODULE_6__/* .visit */ .Vn)(operation.query, {
                Variable: function (node, _key, parent) {
                    if (parent && parent.kind !== 'VariableDefinition') {
                        unusedNames_1.delete(node.name.value);
                    }
                },
            });
            if (unusedNames_1.size) {
                body.variables = (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, body.variables);
                unusedNames_1.forEach(function (name) {
                    delete body.variables[name];
                });
            }
        }
        var controller;
        if (!options.signal) {
            var _c = (0,_createSignalIfSupported_js__WEBPACK_IMPORTED_MODULE_7__/* .createSignalIfSupported */ .$)(), _controller = _c.controller, signal = _c.signal;
            controller = _controller;
            if (controller)
                options.signal = signal;
        }
        var definitionIsMutation = function (d) {
            return d.kind === 'OperationDefinition' && d.operation === 'mutation';
        };
        if (useGETForQueries &&
            !operation.query.definitions.some(definitionIsMutation)) {
            options.method = 'GET';
        }
        if ((0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_8__/* .hasDirectives */ .FS)(['defer'], operation.query)) {
            options.headers.accept = "multipart/mixed; deferSpec=20220824, application/json";
        }
        if (options.method === 'GET') {
            var _d = (0,_rewriteURIForGET_js__WEBPACK_IMPORTED_MODULE_9__/* .rewriteURIForGET */ .H)(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
            if (parseError) {
                return (0,_utils_index_js__WEBPACK_IMPORTED_MODULE_10__/* .fromError */ .Q)(parseError);
            }
            chosenURI = newURI;
        }
        else {
            try {
                options.body = (0,_serializeFetchParameter_js__WEBPACK_IMPORTED_MODULE_11__/* .serializeFetchParameter */ .g)(body, 'Payload');
            }
            catch (parseError) {
                return (0,_utils_index_js__WEBPACK_IMPORTED_MODULE_10__/* .fromError */ .Q)(parseError);
            }
        }
        return new _utilities_index_js__WEBPACK_IMPORTED_MODULE_12__/* .Observable */ .y(function (observer) {
            var currentFetch = preferredFetch || (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .maybe */ .wY)(function () { return fetch; }) || backupFetch;
            currentFetch(chosenURI, options)
                .then(function (response) {
                var _a;
                operation.setContext({ response: response });
                var ctype = (_a = response.headers) === null || _a === void 0 ? void 0 : _a.get('content-type');
                if (ctype !== null && /^multipart\/mixed/i.test(ctype)) {
                    return (0,_parseAndCheckHttpResponse_js__WEBPACK_IMPORTED_MODULE_13__/* .readMultipartBody */ .TF)(response, observer);
                }
                else {
                    return (0,_parseAndCheckHttpResponse_js__WEBPACK_IMPORTED_MODULE_13__/* .readJsonBody */ .Wm)(response, operation, observer);
                }
            })
                .catch(function (err) { return (0,_parseAndCheckHttpResponse_js__WEBPACK_IMPORTED_MODULE_13__/* .handleError */ .S3)(err, observer); });
            return function () {
                if (controller)
                    controller.abort();
            };
        });
    });
};
//# sourceMappingURL=createHttpLink.js.map

/***/ }),

/***/ 77388:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ createSignalIfSupported; }
/* harmony export */ });
var createSignalIfSupported = function () {
    if (typeof AbortController === 'undefined')
        return { controller: false, signal: false };
    var controller = new AbortController();
    var signal = controller.signal;
    return { controller: controller, signal: signal };
};
//# sourceMappingURL=createSignalIfSupported.js.map

/***/ }),

/***/ 85645:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HttpLink": function() { return /* reexport safe */ _HttpLink_js__WEBPACK_IMPORTED_MODULE_8__.u; },
/* harmony export */   "checkFetcher": function() { return /* reexport safe */ _checkFetcher_js__WEBPACK_IMPORTED_MODULE_4__.U; },
/* harmony export */   "createHttpLink": function() { return /* reexport safe */ _createHttpLink_js__WEBPACK_IMPORTED_MODULE_7__.L; },
/* harmony export */   "createSignalIfSupported": function() { return /* reexport safe */ _createSignalIfSupported_js__WEBPACK_IMPORTED_MODULE_5__.$; },
/* harmony export */   "defaultPrinter": function() { return /* reexport safe */ _selectHttpOptionsAndBody_js__WEBPACK_IMPORTED_MODULE_3__.sb; },
/* harmony export */   "fallbackHttpConfig": function() { return /* reexport safe */ _selectHttpOptionsAndBody_js__WEBPACK_IMPORTED_MODULE_3__.SC; },
/* harmony export */   "parseAndCheckHttpResponse": function() { return /* reexport safe */ _parseAndCheckHttpResponse_js__WEBPACK_IMPORTED_MODULE_1__.dO; },
/* harmony export */   "rewriteURIForGET": function() { return /* reexport safe */ _rewriteURIForGET_js__WEBPACK_IMPORTED_MODULE_9__.H; },
/* harmony export */   "selectHttpOptionsAndBody": function() { return /* reexport safe */ _selectHttpOptionsAndBody_js__WEBPACK_IMPORTED_MODULE_3__.E4; },
/* harmony export */   "selectHttpOptionsAndBodyInternal": function() { return /* reexport safe */ _selectHttpOptionsAndBody_js__WEBPACK_IMPORTED_MODULE_3__.ve; },
/* harmony export */   "selectURI": function() { return /* reexport safe */ _selectURI_js__WEBPACK_IMPORTED_MODULE_6__.r; },
/* harmony export */   "serializeFetchParameter": function() { return /* reexport safe */ _serializeFetchParameter_js__WEBPACK_IMPORTED_MODULE_2__.g; }
/* harmony export */ });
/* harmony import */ var _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62985);
/* harmony import */ var _parseAndCheckHttpResponse_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93227);
/* harmony import */ var _serializeFetchParameter_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88793);
/* harmony import */ var _selectHttpOptionsAndBody_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58995);
/* harmony import */ var _checkFetcher_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23178);
/* harmony import */ var _createSignalIfSupported_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77388);
/* harmony import */ var _selectURI_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11037);
/* harmony import */ var _createHttpLink_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34747);
/* harmony import */ var _HttpLink_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(72198);
/* harmony import */ var _rewriteURIForGET_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(88663);










//# sourceMappingURL=index.js.map

/***/ }),

/***/ 93227:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S3": function() { return /* binding */ handleError; },
  "dO": function() { return /* binding */ parseAndCheckHttpResponse; },
  "Wm": function() { return /* binding */ readJsonBody; },
  "TF": function() { return /* binding */ readMultipartBody; }
});

// UNUSED EXPORTS: parseHeaders, parseJsonBody

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/canUse.js
var canUse = __webpack_require__(30320);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/utilities/common/responseIterator.js

function isNodeResponse(value) {
    return !!value.body;
}
function isReadableStream(value) {
    return !!value.getReader;
}
function isAsyncIterableIterator(value) {
    return !!(canUse/* canUseAsyncIteratorSymbol */.DN &&
        value[Symbol.asyncIterator]);
}
function isStreamableBlob(value) {
    return !!value.stream;
}
function isBlob(value) {
    return !!value.arrayBuffer;
}
function isNodeReadableStream(value) {
    return !!value.pipe;
}
//# sourceMappingURL=responseIterator.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/http/iterators/async.js
function asyncIterator(source) {
    var _a;
    var iterator = source[Symbol.asyncIterator]();
    return _a = {
            next: function () {
                return iterator.next();
            }
        },
        _a[Symbol.asyncIterator] = function () {
            return this;
        },
        _a;
}
//# sourceMappingURL=async.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/http/iterators/nodeStream.js

function nodeStreamIterator(stream) {
    var cleanup = null;
    var error = null;
    var done = false;
    var data = [];
    var waiting = [];
    function onData(chunk) {
        if (error)
            return;
        if (waiting.length) {
            var shiftedArr = waiting.shift();
            if (Array.isArray(shiftedArr) && shiftedArr[0]) {
                return shiftedArr[0]({ value: chunk, done: false });
            }
        }
        data.push(chunk);
    }
    function onError(err) {
        error = err;
        var all = waiting.slice();
        all.forEach(function (pair) {
            pair[1](err);
        });
        !cleanup || cleanup();
    }
    function onEnd() {
        done = true;
        var all = waiting.slice();
        all.forEach(function (pair) {
            pair[0]({ value: undefined, done: true });
        });
        !cleanup || cleanup();
    }
    cleanup = function () {
        cleanup = null;
        stream.removeListener("data", onData);
        stream.removeListener("error", onError);
        stream.removeListener("end", onEnd);
        stream.removeListener("finish", onEnd);
        stream.removeListener("close", onEnd);
    };
    stream.on("data", onData);
    stream.on("error", onError);
    stream.on("end", onEnd);
    stream.on("finish", onEnd);
    stream.on("close", onEnd);
    function getNext() {
        return new Promise(function (resolve, reject) {
            if (error)
                return reject(error);
            if (data.length)
                return resolve({ value: data.shift(), done: false });
            if (done)
                return resolve({ value: undefined, done: true });
            waiting.push([resolve, reject]);
        });
    }
    var iterator = {
        next: function () {
            return getNext();
        },
    };
    if (canUse/* canUseAsyncIteratorSymbol */.DN) {
        iterator[Symbol.asyncIterator] = function () {
            return this;
        };
    }
    return iterator;
}
//# sourceMappingURL=nodeStream.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/http/iterators/promise.js

function promiseIterator(promise) {
    var resolved = false;
    var iterator = {
        next: function () {
            if (resolved)
                return Promise.resolve({
                    value: undefined,
                    done: true,
                });
            resolved = true;
            return new Promise(function (resolve, reject) {
                promise
                    .then(function (value) {
                    resolve({ value: value, done: false });
                })
                    .catch(reject);
            });
        },
    };
    if (canUse/* canUseAsyncIteratorSymbol */.DN) {
        iterator[Symbol.asyncIterator] = function () {
            return this;
        };
    }
    return iterator;
}
//# sourceMappingURL=promise.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/http/iterators/reader.js

function readerIterator(reader) {
    var iterator = {
        next: function () {
            return reader.read();
        },
    };
    if (canUse/* canUseAsyncIteratorSymbol */.DN) {
        iterator[Symbol.asyncIterator] = function () {
            return this;
        };
    }
    return iterator;
}
//# sourceMappingURL=reader.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/http/responseIterator.js





function responseIterator(response) {
    var body = response;
    if (isNodeResponse(response))
        body = response.body;
    if (isAsyncIterableIterator(body))
        return asyncIterator(body);
    if (isReadableStream(body))
        return readerIterator(body.getReader());
    if (isStreamableBlob(body)) {
        return readerIterator(body.stream().getReader());
    }
    if (isBlob(body))
        return promiseIterator(body.arrayBuffer());
    if (isNodeReadableStream(body))
        return nodeStreamIterator(body);
    throw new Error("Unknown body type for responseIterator. Please pass a streamable response.");
}
//# sourceMappingURL=responseIterator.js.map
// EXTERNAL MODULE: ./node_modules/@apollo/client/link/utils/throwServerError.js
var throwServerError = __webpack_require__(12782);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/http/parseAndCheckHttpResponse.js



var parseAndCheckHttpResponse_hasOwnProperty = Object.prototype.hasOwnProperty;
function readMultipartBody(response, observer) {
    var _a, _b, _c;
    return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function () {
        var decoder, contentType, delimiter, boundaryVal, boundary, buffer, iterator, running, _d, value, done, chunk, bi, message, i, headers, contentType_1, body, result;
        var _e;
        return (0,tslib_es6/* __generator */.Jh)(this, function (_f) {
            switch (_f.label) {
                case 0:
                    if (TextDecoder === undefined) {
                        throw new Error("TextDecoder must be defined in the environment: please import a polyfill.");
                    }
                    decoder = new TextDecoder("utf-8");
                    contentType = (_a = response.headers) === null || _a === void 0 ? void 0 : _a.get('content-type');
                    delimiter = "boundary=";
                    boundaryVal = (contentType === null || contentType === void 0 ? void 0 : contentType.includes(delimiter))
                        ? contentType === null || contentType === void 0 ? void 0 : contentType.substring((contentType === null || contentType === void 0 ? void 0 : contentType.indexOf(delimiter)) + delimiter.length).replace(/['"]/g, "").replace(/\;(.*)/gm, "").trim()
                        : "-";
                    boundary = "--".concat(boundaryVal);
                    buffer = "";
                    iterator = responseIterator(response);
                    running = true;
                    _f.label = 1;
                case 1:
                    if (!running) return [3, 3];
                    return [4, iterator.next()];
                case 2:
                    _d = _f.sent(), value = _d.value, done = _d.done;
                    chunk = typeof value === "string" ? value : decoder.decode(value);
                    running = !done;
                    buffer += chunk;
                    bi = buffer.indexOf(boundary);
                    while (bi > -1) {
                        message = void 0;
                        _e = [
                            buffer.slice(0, bi),
                            buffer.slice(bi + boundary.length),
                        ], message = _e[0], buffer = _e[1];
                        if (message.trim()) {
                            i = message.indexOf("\r\n\r\n");
                            headers = parseHeaders(message.slice(0, i));
                            contentType_1 = headers["content-type"];
                            if (contentType_1 &&
                                contentType_1.toLowerCase().indexOf("application/json") === -1) {
                                throw new Error("Unsupported patch content type: application/json is required.");
                            }
                            body = message.slice(i);
                            try {
                                result = parseJsonBody(response, body.replace("\r\n", ""));
                                if (Object.keys(result).length > 1 ||
                                    "data" in result ||
                                    "incremental" in result ||
                                    "errors" in result) {
                                    (_b = observer.next) === null || _b === void 0 ? void 0 : _b.call(observer, result);
                                }
                            }
                            catch (err) {
                                handleError(err, observer);
                            }
                        }
                        bi = buffer.indexOf(boundary);
                    }
                    return [3, 1];
                case 3:
                    (_c = observer.complete) === null || _c === void 0 ? void 0 : _c.call(observer);
                    return [2];
            }
        });
    });
}
function parseHeaders(headerText) {
    var headersInit = {};
    headerText.split("\n").forEach(function (line) {
        var i = line.indexOf(":");
        if (i > -1) {
            var name_1 = line.slice(0, i).trim().toLowerCase();
            var value = line.slice(i + 1).trim();
            headersInit[name_1] = value;
        }
    });
    return headersInit;
}
function parseJsonBody(response, bodyText) {
    if (response.status >= 300) {
        var getResult = function () {
            try {
                return JSON.parse(bodyText);
            }
            catch (err) {
                return bodyText;
            }
        };
        (0,throwServerError/* throwServerError */.P)(response, getResult(), "Response not successful: Received status code ".concat(response.status));
    }
    try {
        return JSON.parse(bodyText);
    }
    catch (err) {
        var parseError = err;
        parseError.name = "ServerParseError";
        parseError.response = response;
        parseError.statusCode = response.status;
        parseError.bodyText = bodyText;
        throw parseError;
    }
}
function handleError(err, observer) {
    var _a, _b;
    if (err.name === "AbortError")
        return;
    if (err.result && err.result.errors && err.result.data) {
        (_a = observer.next) === null || _a === void 0 ? void 0 : _a.call(observer, err.result);
    }
    (_b = observer.error) === null || _b === void 0 ? void 0 : _b.call(observer, err);
}
function readJsonBody(response, operation, observer) {
    parseAndCheckHttpResponse(operation)(response)
        .then(function (result) {
        var _a, _b;
        (_a = observer.next) === null || _a === void 0 ? void 0 : _a.call(observer, result);
        (_b = observer.complete) === null || _b === void 0 ? void 0 : _b.call(observer);
    })
        .catch(function (err) { return handleError(err, observer); });
}
function parseAndCheckHttpResponse(operations) {
    return function (response) {
        return response
            .text()
            .then(function (bodyText) { return parseJsonBody(response, bodyText); })
            .then(function (result) {
            if (response.status >= 300) {
                (0,throwServerError/* throwServerError */.P)(response, result, "Response not successful: Received status code ".concat(response.status));
            }
            if (!Array.isArray(result) &&
                !parseAndCheckHttpResponse_hasOwnProperty.call(result, "data") &&
                !parseAndCheckHttpResponse_hasOwnProperty.call(result, "errors")) {
                (0,throwServerError/* throwServerError */.P)(response, result, "Server response was missing for query '".concat(Array.isArray(operations)
                    ? operations.map(function (op) { return op.operationName; })
                    : operations.operationName, "'."));
            }
            return result;
        });
    };
}
//# sourceMappingURL=parseAndCheckHttpResponse.js.map

/***/ }),

/***/ 88663:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ rewriteURIForGET; }
/* harmony export */ });
/* harmony import */ var _serializeFetchParameter_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88793);

function rewriteURIForGET(chosenURI, body) {
    var queryParams = [];
    var addQueryParam = function (key, value) {
        queryParams.push("".concat(key, "=").concat(encodeURIComponent(value)));
    };
    if ('query' in body) {
        addQueryParam('query', body.query);
    }
    if (body.operationName) {
        addQueryParam('operationName', body.operationName);
    }
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = (0,_serializeFetchParameter_js__WEBPACK_IMPORTED_MODULE_0__/* .serializeFetchParameter */ .g)(body.variables, 'Variables map');
        }
        catch (parseError) {
            return { parseError: parseError };
        }
        addQueryParam('variables', serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = (0,_serializeFetchParameter_js__WEBPACK_IMPORTED_MODULE_0__/* .serializeFetchParameter */ .g)(body.extensions, 'Extensions map');
        }
        catch (parseError) {
            return { parseError: parseError };
        }
        addQueryParam('extensions', serializedExtensions);
    }
    var fragment = '', preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf('#');
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
    var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
    return { newURI: newURI };
}
//# sourceMappingURL=rewriteURIForGET.js.map

/***/ }),

/***/ 58995:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "sb": function() { return /* binding */ defaultPrinter; },
  "SC": function() { return /* binding */ fallbackHttpConfig; },
  "E4": function() { return /* binding */ selectHttpOptionsAndBody; },
  "ve": function() { return /* binding */ selectHttpOptionsAndBodyInternal; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/graphql/language/visitor.mjs
var visitor = __webpack_require__(77304);
// EXTERNAL MODULE: ./node_modules/graphql/language/blockString.mjs
var blockString = __webpack_require__(87392);
;// CONCATENATED MODULE: ./node_modules/graphql/language/printer.mjs


/**
 * Converts an AST into a string, using one set of reasonable
 * formatting rules.
 */

function print(ast) {
  return (0,visitor/* visit */.Vn)(ast, {
    leave: printDocASTReducer
  });
} // TODO: provide better type coverage in future

var printDocASTReducer = {
  Name: function Name(node) {
    return node.value;
  },
  Variable: function Variable(node) {
    return '$' + node.name;
  },
  // Document
  Document: function Document(node) {
    return join(node.definitions, '\n\n') + '\n';
  },
  OperationDefinition: function OperationDefinition(node) {
    var op = node.operation;
    var name = node.name;
    var varDefs = wrap('(', join(node.variableDefinitions, ', '), ')');
    var directives = join(node.directives, ' ');
    var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
    // the query short form.

    return !name && !directives && !varDefs && op === 'query' ? selectionSet : join([op, join([name, varDefs]), directives, selectionSet], ' ');
  },
  VariableDefinition: function VariableDefinition(_ref) {
    var variable = _ref.variable,
        type = _ref.type,
        defaultValue = _ref.defaultValue,
        directives = _ref.directives;
    return variable + ': ' + type + wrap(' = ', defaultValue) + wrap(' ', join(directives, ' '));
  },
  SelectionSet: function SelectionSet(_ref2) {
    var selections = _ref2.selections;
    return block(selections);
  },
  Field: function Field(_ref3) {
    var alias = _ref3.alias,
        name = _ref3.name,
        args = _ref3.arguments,
        directives = _ref3.directives,
        selectionSet = _ref3.selectionSet;
    return join([wrap('', alias, ': ') + name + wrap('(', join(args, ', '), ')'), join(directives, ' '), selectionSet], ' ');
  },
  Argument: function Argument(_ref4) {
    var name = _ref4.name,
        value = _ref4.value;
    return name + ': ' + value;
  },
  // Fragments
  FragmentSpread: function FragmentSpread(_ref5) {
    var name = _ref5.name,
        directives = _ref5.directives;
    return '...' + name + wrap(' ', join(directives, ' '));
  },
  InlineFragment: function InlineFragment(_ref6) {
    var typeCondition = _ref6.typeCondition,
        directives = _ref6.directives,
        selectionSet = _ref6.selectionSet;
    return join(['...', wrap('on ', typeCondition), join(directives, ' '), selectionSet], ' ');
  },
  FragmentDefinition: function FragmentDefinition(_ref7) {
    var name = _ref7.name,
        typeCondition = _ref7.typeCondition,
        variableDefinitions = _ref7.variableDefinitions,
        directives = _ref7.directives,
        selectionSet = _ref7.selectionSet;
    return (// Note: fragment variable definitions are experimental and may be changed
      // or removed in the future.
      "fragment ".concat(name).concat(wrap('(', join(variableDefinitions, ', '), ')'), " ") + "on ".concat(typeCondition, " ").concat(wrap('', join(directives, ' '), ' ')) + selectionSet
    );
  },
  // Value
  IntValue: function IntValue(_ref8) {
    var value = _ref8.value;
    return value;
  },
  FloatValue: function FloatValue(_ref9) {
    var value = _ref9.value;
    return value;
  },
  StringValue: function StringValue(_ref10, key) {
    var value = _ref10.value,
        isBlockString = _ref10.block;
    return isBlockString ? (0,blockString/* printBlockString */.LZ)(value, key === 'description' ? '' : '  ') : JSON.stringify(value);
  },
  BooleanValue: function BooleanValue(_ref11) {
    var value = _ref11.value;
    return value ? 'true' : 'false';
  },
  NullValue: function NullValue() {
    return 'null';
  },
  EnumValue: function EnumValue(_ref12) {
    var value = _ref12.value;
    return value;
  },
  ListValue: function ListValue(_ref13) {
    var values = _ref13.values;
    return '[' + join(values, ', ') + ']';
  },
  ObjectValue: function ObjectValue(_ref14) {
    var fields = _ref14.fields;
    return '{' + join(fields, ', ') + '}';
  },
  ObjectField: function ObjectField(_ref15) {
    var name = _ref15.name,
        value = _ref15.value;
    return name + ': ' + value;
  },
  // Directive
  Directive: function Directive(_ref16) {
    var name = _ref16.name,
        args = _ref16.arguments;
    return '@' + name + wrap('(', join(args, ', '), ')');
  },
  // Type
  NamedType: function NamedType(_ref17) {
    var name = _ref17.name;
    return name;
  },
  ListType: function ListType(_ref18) {
    var type = _ref18.type;
    return '[' + type + ']';
  },
  NonNullType: function NonNullType(_ref19) {
    var type = _ref19.type;
    return type + '!';
  },
  // Type System Definitions
  SchemaDefinition: function SchemaDefinition(_ref20) {
    var directives = _ref20.directives,
        operationTypes = _ref20.operationTypes;
    return join(['schema', join(directives, ' '), block(operationTypes)], ' ');
  },
  OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
    var operation = _ref21.operation,
        type = _ref21.type;
    return operation + ': ' + type;
  },
  ScalarTypeDefinition: addDescription(function (_ref22) {
    var name = _ref22.name,
        directives = _ref22.directives;
    return join(['scalar', name, join(directives, ' ')], ' ');
  }),
  ObjectTypeDefinition: addDescription(function (_ref23) {
    var name = _ref23.name,
        interfaces = _ref23.interfaces,
        directives = _ref23.directives,
        fields = _ref23.fields;
    return join(['type', name, wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  }),
  FieldDefinition: addDescription(function (_ref24) {
    var name = _ref24.name,
        args = _ref24.arguments,
        type = _ref24.type,
        directives = _ref24.directives;
    return name + (hasMultilineItems(args) ? wrap('(\n', indent(join(args, '\n')), '\n)') : wrap('(', join(args, ', '), ')')) + ': ' + type + wrap(' ', join(directives, ' '));
  }),
  InputValueDefinition: addDescription(function (_ref25) {
    var name = _ref25.name,
        type = _ref25.type,
        defaultValue = _ref25.defaultValue,
        directives = _ref25.directives;
    return join([name + ': ' + type, wrap('= ', defaultValue), join(directives, ' ')], ' ');
  }),
  InterfaceTypeDefinition: addDescription(function (_ref26) {
    var name = _ref26.name,
        directives = _ref26.directives,
        fields = _ref26.fields;
    return join(['interface', name, join(directives, ' '), block(fields)], ' ');
  }),
  UnionTypeDefinition: addDescription(function (_ref27) {
    var name = _ref27.name,
        directives = _ref27.directives,
        types = _ref27.types;
    return join(['union', name, join(directives, ' '), types && types.length !== 0 ? '= ' + join(types, ' | ') : ''], ' ');
  }),
  EnumTypeDefinition: addDescription(function (_ref28) {
    var name = _ref28.name,
        directives = _ref28.directives,
        values = _ref28.values;
    return join(['enum', name, join(directives, ' '), block(values)], ' ');
  }),
  EnumValueDefinition: addDescription(function (_ref29) {
    var name = _ref29.name,
        directives = _ref29.directives;
    return join([name, join(directives, ' ')], ' ');
  }),
  InputObjectTypeDefinition: addDescription(function (_ref30) {
    var name = _ref30.name,
        directives = _ref30.directives,
        fields = _ref30.fields;
    return join(['input', name, join(directives, ' '), block(fields)], ' ');
  }),
  DirectiveDefinition: addDescription(function (_ref31) {
    var name = _ref31.name,
        args = _ref31.arguments,
        repeatable = _ref31.repeatable,
        locations = _ref31.locations;
    return 'directive @' + name + (hasMultilineItems(args) ? wrap('(\n', indent(join(args, '\n')), '\n)') : wrap('(', join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + join(locations, ' | ');
  }),
  SchemaExtension: function SchemaExtension(_ref32) {
    var directives = _ref32.directives,
        operationTypes = _ref32.operationTypes;
    return join(['extend schema', join(directives, ' '), block(operationTypes)], ' ');
  },
  ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
    var name = _ref33.name,
        directives = _ref33.directives;
    return join(['extend scalar', name, join(directives, ' ')], ' ');
  },
  ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
    var name = _ref34.name,
        interfaces = _ref34.interfaces,
        directives = _ref34.directives,
        fields = _ref34.fields;
    return join(['extend type', name, wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  },
  InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
    var name = _ref35.name,
        directives = _ref35.directives,
        fields = _ref35.fields;
    return join(['extend interface', name, join(directives, ' '), block(fields)], ' ');
  },
  UnionTypeExtension: function UnionTypeExtension(_ref36) {
    var name = _ref36.name,
        directives = _ref36.directives,
        types = _ref36.types;
    return join(['extend union', name, join(directives, ' '), types && types.length !== 0 ? '= ' + join(types, ' | ') : ''], ' ');
  },
  EnumTypeExtension: function EnumTypeExtension(_ref37) {
    var name = _ref37.name,
        directives = _ref37.directives,
        values = _ref37.values;
    return join(['extend enum', name, join(directives, ' '), block(values)], ' ');
  },
  InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
    var name = _ref38.name,
        directives = _ref38.directives,
        fields = _ref38.fields;
    return join(['extend input', name, join(directives, ' '), block(fields)], ' ');
  }
};

function addDescription(cb) {
  return function (node) {
    return join([node.description, cb(node)], '\n');
  };
}
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */


function join(maybeArray, separator) {
  return maybeArray ? maybeArray.filter(function (x) {
    return x;
  }).join(separator || '') : '';
}
/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */


function block(array) {
  return array && array.length !== 0 ? '{\n' + indent(join(array, '\n')) + '\n}' : '';
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise
 * print an empty string.
 */


function wrap(start, maybeString, end) {
  return maybeString ? start + maybeString + (end || '') : '';
}

function indent(maybeString) {
  return maybeString && '  ' + maybeString.replace(/\n/g, '\n  ');
}

function isMultiline(string) {
  return string.indexOf('\n') !== -1;
}

function hasMultilineItems(maybeArray) {
  return maybeArray && maybeArray.some(isMultiline);
}

;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/http/selectHttpOptionsAndBody.js


;
var defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false,
    preserveHeaderCase: false,
};
var defaultHeaders = {
    accept: '*/*',
    'content-type': 'application/json',
};
var defaultOptions = {
    method: 'POST',
};
var fallbackHttpConfig = {
    http: defaultHttpOptions,
    headers: defaultHeaders,
    options: defaultOptions,
};
var defaultPrinter = function (ast, printer) { return printer(ast); };
function selectHttpOptionsAndBody(operation, fallbackConfig) {
    var configs = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        configs[_i - 2] = arguments[_i];
    }
    configs.unshift(fallbackConfig);
    return selectHttpOptionsAndBodyInternal.apply(void 0, (0,tslib_es6/* __spreadArray */.ev)([operation,
        defaultPrinter], configs, false));
}
function selectHttpOptionsAndBodyInternal(operation, printer) {
    var configs = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        configs[_i - 2] = arguments[_i];
    }
    var options = {};
    var http = {};
    configs.forEach(function (config) {
        options = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), config.options), { headers: (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options.headers), config.headers) });
        if (config.credentials) {
            options.credentials = config.credentials;
        }
        http = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, http), config.http);
    });
    options.headers = removeDuplicateHeaders(options.headers, http.preserveHeaderCase);
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = { operationName: operationName, variables: variables };
    if (http.includeExtensions)
        body.extensions = extensions;
    if (http.includeQuery)
        body.query = printer(query, print);
    return {
        options: options,
        body: body,
    };
}
;
function removeDuplicateHeaders(headers, preserveHeaderCase) {
    if (!preserveHeaderCase) {
        var normalizedHeaders_1 = Object.create(null);
        Object.keys(Object(headers)).forEach(function (name) {
            normalizedHeaders_1[name.toLowerCase()] = headers[name];
        });
        return normalizedHeaders_1;
    }
    var headerData = Object.create(null);
    Object.keys(Object(headers)).forEach(function (name) {
        headerData[name.toLowerCase()] = { originalName: name, value: headers[name] };
    });
    var normalizedHeaders = Object.create(null);
    Object.keys(headerData).forEach(function (name) {
        normalizedHeaders[headerData[name].originalName] = headerData[name].value;
    });
    return normalizedHeaders;
}
//# sourceMappingURL=selectHttpOptionsAndBody.js.map

/***/ }),

/***/ 11037:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ selectURI; }
/* harmony export */ });
var selectURI = function (operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) {
        return contextURI;
    }
    else if (typeof fallbackURI === 'function') {
        return fallbackURI(operation);
    }
    else {
        return fallbackURI || '/graphql';
    }
};
//# sourceMappingURL=selectURI.js.map

/***/ }),

/***/ 88793:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ serializeFetchParameter; }
/* harmony export */ });
/* harmony import */ var _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62985);

var serializeFetchParameter = function (p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    }
    catch (e) {
        var parseError = __DEV__ ? new _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .InvariantError */ .ej("Network request failed. ".concat(label, " is not serializable: ").concat(e.message)) : new _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .InvariantError */ .ej(23);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};
//# sourceMappingURL=serializeFetchParameter.js.map

/***/ }),

/***/ 16261:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ fromError; }
/* harmony export */ });
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48216);

function fromError(errorValue) {
    return new _utilities_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Observable */ .y(function (observer) {
        observer.error(errorValue);
    });
}
//# sourceMappingURL=fromError.js.map

/***/ }),

/***/ 12782:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ throwServerError; }
/* harmony export */ });
var throwServerError = function (response, result, message) {
    var error = new Error(message);
    error.name = 'ServerError';
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};
//# sourceMappingURL=throwServerError.js.map

/***/ }),

/***/ 53124:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U6": function() { return /* binding */ setVerbosity; },
/* harmony export */   "ej": function() { return /* binding */ InvariantError; },
/* harmony export */   "kG": function() { return /* binding */ invariant; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70655);

var genericMessage = "Invariant Violation";
var _a = Object.setPrototypeOf, setPrototypeOf = _a === void 0 ? function (obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : _a;
var InvariantError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) { message = genericMessage; }
        var _this = _super.call(this, typeof message === "number"
            ? genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)"
            : message) || this;
        _this.framesToPop = 1;
        _this.name = genericMessage;
        setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error));

function invariant(condition, message) {
    if (!condition) {
        throw new InvariantError(message);
    }
}
var verbosityLevels = ["debug", "log", "warn", "error", "silent"];
var verbosityLevel = verbosityLevels.indexOf("log");
function wrapConsoleMethod(name) {
    return function () {
        if (verbosityLevels.indexOf(name) >= verbosityLevel) {
            // Default to console.log if this host environment happens not to provide
            // all the console.* methods we need.
            var method = console[name] || console.log;
            return method.apply(console, arguments);
        }
    };
}
(function (invariant) {
    invariant.debug = wrapConsoleMethod("debug");
    invariant.log = wrapConsoleMethod("log");
    invariant.warn = wrapConsoleMethod("warn");
    invariant.error = wrapConsoleMethod("error");
})(invariant || (invariant = {}));
function setVerbosity(level) {
    var old = verbosityLevels[verbosityLevel];
    verbosityLevel = Math.max(0, verbosityLevels.indexOf(level));
    return old;
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (invariant)));
//# sourceMappingURL=invariant.js.map

/***/ }),

/***/ 63659:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ Mutation; }
/* harmony export */ });
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45697);
/* harmony import */ var _hooks_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50319);


function Mutation(props) {
    var _a = (0,_hooks_index_js__WEBPACK_IMPORTED_MODULE_0__/* .useMutation */ .D)(props.mutation, props), runMutation = _a[0], result = _a[1];
    return props.children ? props.children(runMutation, result) : null;
}
Mutation.propTypes = {
    mutation: prop_types__WEBPACK_IMPORTED_MODULE_1__.object.isRequired,
    variables: prop_types__WEBPACK_IMPORTED_MODULE_1__.object,
    optimisticResponse: prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_1__.object, prop_types__WEBPACK_IMPORTED_MODULE_1__.func]),
    refetchQueries: prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOfType([
        prop_types__WEBPACK_IMPORTED_MODULE_1__.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_1__.string, prop_types__WEBPACK_IMPORTED_MODULE_1__.object])),
        prop_types__WEBPACK_IMPORTED_MODULE_1__.func
    ]),
    awaitRefetchQueries: prop_types__WEBPACK_IMPORTED_MODULE_1__.bool,
    update: prop_types__WEBPACK_IMPORTED_MODULE_1__.func,
    children: prop_types__WEBPACK_IMPORTED_MODULE_1__.func.isRequired,
    onCompleted: prop_types__WEBPACK_IMPORTED_MODULE_1__.func,
    onError: prop_types__WEBPACK_IMPORTED_MODULE_1__.func,
    fetchPolicy: prop_types__WEBPACK_IMPORTED_MODULE_1__.string,
};
//# sourceMappingURL=Mutation.js.map

/***/ }),

/***/ 85317:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ getApolloContext; }
/* harmony export */ });
/* unused harmony export resetApolloContext */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30320);


var contextKey = _utilities_index_js__WEBPACK_IMPORTED_MODULE_1__/* .canUseSymbol */ .aS
    ? Symbol.for('__APOLLO_CONTEXT__')
    : '__APOLLO_CONTEXT__';
function getApolloContext() {
    var context = react__WEBPACK_IMPORTED_MODULE_0__.createContext[contextKey];
    if (!context) {
        Object.defineProperty(react__WEBPACK_IMPORTED_MODULE_0__.createContext, contextKey, {
            value: context = react__WEBPACK_IMPORTED_MODULE_0__.createContext({}),
            enumerable: false,
            writable: false,
            configurable: true,
        });
        context.displayName = 'ApolloContext';
    }
    return context;
}

//# sourceMappingURL=ApolloContext.js.map

/***/ }),

/***/ 66252:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ useApolloClient; }
/* harmony export */ });
/* harmony import */ var _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62985);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _context_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85317);



function useApolloClient(override) {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)((0,_context_index_js__WEBPACK_IMPORTED_MODULE_2__/* .getApolloContext */ .K)());
    var client = override || context.client;
    __DEV__ ? (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(!!client, 'Could not find "client" in the context or passed in as an option. ' +
        'Wrap the root component in an <ApolloProvider>, or pass an ApolloClient ' +
        'instance in via options.') : (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(!!client, 31);
    return client;
}
//# sourceMappingURL=useApolloClient.js.map

/***/ }),

/***/ 73359:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ useLazyQuery; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14012);
/* harmony import */ var _useQuery_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37887);
/* harmony import */ var _useApolloClient_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66252);





var EAGER_METHODS = [
    'refetch',
    'reobserve',
    'fetchMore',
    'updateQuery',
    'startPolling',
    'subscribeToMore',
];
function useLazyQuery(query, options) {
    var internalState = (0,_useQuery_js__WEBPACK_IMPORTED_MODULE_1__/* .useInternalState */ .A)((0,_useApolloClient_js__WEBPACK_IMPORTED_MODULE_2__/* .useApolloClient */ .x)(options && options.client), query);
    var execOptionsRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    var merged = execOptionsRef.current
        ? (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_3__/* .mergeOptions */ .J)(options, execOptionsRef.current)
        : options;
    var useQueryResult = internalState.useQuery((0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__assign */ .pi)({}, merged), { skip: !execOptionsRef.current }));
    var initialFetchPolicy = useQueryResult.observable.options.initialFetchPolicy ||
        internalState.getDefaultFetchPolicy();
    var result = Object.assign(useQueryResult, {
        called: !!execOptionsRef.current,
    });
    var eagerMethods = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
        var eagerMethods = {};
        var _loop_1 = function (key) {
            var method = result[key];
            eagerMethods[key] = function () {
                if (!execOptionsRef.current) {
                    execOptionsRef.current = Object.create(null);
                    internalState.forceUpdate();
                }
                return method.apply(this, arguments);
            };
        };
        for (var _i = 0, EAGER_METHODS_1 = EAGER_METHODS; _i < EAGER_METHODS_1.length; _i++) {
            var key = EAGER_METHODS_1[_i];
            _loop_1(key);
        }
        return eagerMethods;
    }, []);
    Object.assign(result, eagerMethods);
    var execute = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (executeOptions) {
        execOptionsRef.current = executeOptions ? (0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__assign */ .pi)({}, executeOptions), { fetchPolicy: executeOptions.fetchPolicy || initialFetchPolicy }) : {
            fetchPolicy: initialFetchPolicy,
        };
        var promise = internalState
            .asyncUpdate()
            .then(function (queryResult) { return Object.assign(queryResult, eagerMethods); });
        promise.catch(function () { });
        return promise;
    }, []);
    return [execute, result];
}
//# sourceMappingURL=useLazyQuery.js.map

/***/ }),

/***/ 50319:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ useMutation; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _core_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14012);
/* harmony import */ var _wry_equality__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82152);
/* harmony import */ var _parser_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14692);
/* harmony import */ var _errors_index_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30990);
/* harmony import */ var _useApolloClient_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66252);







function useMutation(mutation, options) {
    var client = (0,_useApolloClient_js__WEBPACK_IMPORTED_MODULE_2__/* .useApolloClient */ .x)(options === null || options === void 0 ? void 0 : options.client);
    (0,_parser_index_js__WEBPACK_IMPORTED_MODULE_3__/* .verifyDocumentType */ .Vp)(mutation, _parser_index_js__WEBPACK_IMPORTED_MODULE_3__/* .DocumentType.Mutation */ .n_.Mutation);
    var _a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        called: false,
        loading: false,
        client: client,
    }), result = _a[0], setResult = _a[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({
        result: result,
        mutationId: 0,
        isMounted: true,
        client: client,
        mutation: mutation,
        options: options,
    });
    {
        Object.assign(ref.current, { client: client, options: options, mutation: mutation });
    }
    var execute = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (executeOptions) {
        if (executeOptions === void 0) { executeOptions = {}; }
        var _a = ref.current, client = _a.client, options = _a.options, mutation = _a.mutation;
        var baseOptions = (0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__assign */ .pi)({}, options), { mutation: mutation });
        if (!ref.current.result.loading && !baseOptions.ignoreResults && ref.current.isMounted) {
            setResult(ref.current.result = {
                loading: true,
                error: void 0,
                data: void 0,
                called: true,
                client: client,
            });
        }
        var mutationId = ++ref.current.mutationId;
        var clientOptions = (0,_core_index_js__WEBPACK_IMPORTED_MODULE_5__/* .mergeOptions */ .J)(baseOptions, executeOptions);
        return client.mutate(clientOptions).then(function (response) {
            var _a, _b, _c;
            var data = response.data, errors = response.errors;
            var error = errors && errors.length > 0
                ? new _errors_index_js__WEBPACK_IMPORTED_MODULE_6__/* .ApolloError */ .c({ graphQLErrors: errors })
                : void 0;
            if (mutationId === ref.current.mutationId &&
                !clientOptions.ignoreResults) {
                var result_1 = {
                    called: true,
                    loading: false,
                    data: data,
                    error: error,
                    client: client,
                };
                if (ref.current.isMounted && !(0,_wry_equality__WEBPACK_IMPORTED_MODULE_1__/* .equal */ .D)(ref.current.result, result_1)) {
                    setResult(ref.current.result = result_1);
                }
            }
            (_b = (_a = ref.current.options) === null || _a === void 0 ? void 0 : _a.onCompleted) === null || _b === void 0 ? void 0 : _b.call(_a, response.data, clientOptions);
            (_c = executeOptions.onCompleted) === null || _c === void 0 ? void 0 : _c.call(executeOptions, response.data, clientOptions);
            return response;
        }).catch(function (error) {
            var _a, _b, _c, _d;
            if (mutationId === ref.current.mutationId &&
                ref.current.isMounted) {
                var result_2 = {
                    loading: false,
                    error: error,
                    data: void 0,
                    called: true,
                    client: client,
                };
                if (!(0,_wry_equality__WEBPACK_IMPORTED_MODULE_1__/* .equal */ .D)(ref.current.result, result_2)) {
                    setResult(ref.current.result = result_2);
                }
            }
            if (((_a = ref.current.options) === null || _a === void 0 ? void 0 : _a.onError) || clientOptions.onError) {
                (_c = (_b = ref.current.options) === null || _b === void 0 ? void 0 : _b.onError) === null || _c === void 0 ? void 0 : _c.call(_b, error, clientOptions);
                (_d = executeOptions.onError) === null || _d === void 0 ? void 0 : _d.call(executeOptions, error, clientOptions);
                return { data: void 0, errors: error };
            }
            throw error;
        });
    }, []);
    var reset = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
        if (ref.current.isMounted) {
            setResult({ called: false, loading: false, client: client });
        }
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        ref.current.isMounted = true;
        return function () {
            ref.current.isMounted = false;
        };
    }, []);
    return [execute, (0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__assign */ .pi)({ reset: reset }, result)];
}
//# sourceMappingURL=useMutation.js.map

/***/ }),

/***/ 37887:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ useInternalState; },
  "a": function() { return /* binding */ useQuery; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/globals/index.js + 5 modules
var globals = __webpack_require__(62985);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
var react_namespaceObject = /*#__PURE__*/__webpack_require__.t(react, 2);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/canUse.js
var canUse = __webpack_require__(30320);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/react/hooks/useSyncExternalStore.js



var didWarnUncachedGetSnapshot = false;
var uSESKey = "useSyncExternalStore";
var realHook = react_namespaceObject[uSESKey];
var useSyncExternalStore = realHook || (function (subscribe, getSnapshot, getServerSnapshot) {
    var value = getSnapshot();
    if (__DEV__ &&
        !didWarnUncachedGetSnapshot &&
        value !== getSnapshot()) {
        didWarnUncachedGetSnapshot = true;
        __DEV__ && globals/* invariant.error */.kG.error('The result of getSnapshot should be cached to avoid an infinite loop');
    }
    var _a = react.useState({ inst: { value: value, getSnapshot: getSnapshot } }), inst = _a[0].inst, forceUpdate = _a[1];
    if (canUse/* canUseLayoutEffect */.JC) {
        react.useLayoutEffect(function () {
            Object.assign(inst, { value: value, getSnapshot: getSnapshot });
            if (checkIfSnapshotChanged(inst)) {
                forceUpdate({ inst: inst });
            }
        }, [subscribe, value, getSnapshot]);
    }
    else {
        Object.assign(inst, { value: value, getSnapshot: getSnapshot });
    }
    react.useEffect(function () {
        if (checkIfSnapshotChanged(inst)) {
            forceUpdate({ inst: inst });
        }
        return subscribe(function handleStoreChange() {
            if (checkIfSnapshotChanged(inst)) {
                forceUpdate({ inst: inst });
            }
        });
    }, [subscribe]);
    return value;
});
function checkIfSnapshotChanged(_a) {
    var value = _a.value, getSnapshot = _a.getSnapshot;
    try {
        return value !== getSnapshot();
    }
    catch (_b) {
        return true;
    }
}
//# sourceMappingURL=useSyncExternalStore.js.map
// EXTERNAL MODULE: ./node_modules/@wry/equality/lib/equality.esm.js
var equality_esm = __webpack_require__(82152);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/mergeOptions.js
var mergeOptions = __webpack_require__(14012);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/context/ApolloContext.js
var ApolloContext = __webpack_require__(85317);
// EXTERNAL MODULE: ./node_modules/@apollo/client/errors/index.js
var errors = __webpack_require__(30990);
// EXTERNAL MODULE: ./node_modules/@apollo/client/core/networkStatus.js
var networkStatus = __webpack_require__(1644);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/parser/index.js
var parser = __webpack_require__(14692);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useApolloClient.js
var useApolloClient = __webpack_require__(66252);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/maybeDeepFreeze.js
var maybeDeepFreeze = __webpack_require__(48702);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/compact.js
var compact = __webpack_require__(53712);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/arrays.js
var arrays = __webpack_require__(21436);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/react/hooks/useQuery.js












var useQuery_hasOwnProperty = Object.prototype.hasOwnProperty;
function useQuery(query, options) {
    if (options === void 0) { options = Object.create(null); }
    return useInternalState((0,useApolloClient/* useApolloClient */.x)(options.client), query).useQuery(options);
}
function useInternalState(client, query) {
    var stateRef = (0,react.useRef)();
    if (!stateRef.current ||
        client !== stateRef.current.client ||
        query !== stateRef.current.query) {
        stateRef.current = new InternalState(client, query, stateRef.current);
    }
    var state = stateRef.current;
    var _a = (0,react.useState)(0), _tick = _a[0], setTick = _a[1];
    state.forceUpdate = function () {
        setTick(function (tick) { return tick + 1; });
    };
    return state;
}
var InternalState = (function () {
    function InternalState(client, query, previous) {
        this.client = client;
        this.query = query;
        this.asyncResolveFns = new Set();
        this.optionsToIgnoreOnce = new (canUse/* canUseWeakSet */.sy ? WeakSet : Set)();
        this.ssrDisabledResult = (0,maybeDeepFreeze/* maybeDeepFreeze */.J)({
            loading: true,
            data: void 0,
            error: void 0,
            networkStatus: networkStatus/* NetworkStatus.loading */.I.loading,
        });
        this.skipStandbyResult = (0,maybeDeepFreeze/* maybeDeepFreeze */.J)({
            loading: false,
            data: void 0,
            error: void 0,
            networkStatus: networkStatus/* NetworkStatus.ready */.I.ready,
        });
        this.toQueryResultCache = new (canUse/* canUseWeakMap */.mr ? WeakMap : Map)();
        (0,parser/* verifyDocumentType */.Vp)(query, parser/* DocumentType.Query */.n_.Query);
        var previousResult = previous && previous.result;
        var previousData = previousResult && previousResult.data;
        if (previousData) {
            this.previousData = previousData;
        }
    }
    InternalState.prototype.forceUpdate = function () {
        __DEV__ && globals/* invariant.warn */.kG.warn("Calling default no-op implementation of InternalState#forceUpdate");
    };
    InternalState.prototype.asyncUpdate = function () {
        var _this = this;
        return new Promise(function (resolve) {
            _this.asyncResolveFns.add(resolve);
            _this.optionsToIgnoreOnce.add(_this.watchQueryOptions);
            _this.forceUpdate();
        });
    };
    InternalState.prototype.useQuery = function (options) {
        var _this = this;
        this.renderPromises = (0,react.useContext)((0,ApolloContext/* getApolloContext */.K)()).renderPromises;
        this.useOptions(options);
        var obsQuery = this.useObservableQuery();
        var result = useSyncExternalStore((0,react.useCallback)(function () {
            if (_this.renderPromises) {
                return function () { };
            }
            var onNext = function () {
                var previousResult = _this.result;
                var result = obsQuery.getCurrentResult();
                if (previousResult &&
                    previousResult.loading === result.loading &&
                    previousResult.networkStatus === result.networkStatus &&
                    (0,equality_esm/* equal */.D)(previousResult.data, result.data)) {
                    return;
                }
                _this.setResult(result);
            };
            var onError = function (error) {
                var last = obsQuery["last"];
                subscription.unsubscribe();
                try {
                    obsQuery.resetLastResults();
                    subscription = obsQuery.subscribe(onNext, onError);
                }
                finally {
                    obsQuery["last"] = last;
                }
                if (!useQuery_hasOwnProperty.call(error, 'graphQLErrors')) {
                    throw error;
                }
                var previousResult = _this.result;
                if (!previousResult ||
                    (previousResult && previousResult.loading) ||
                    !(0,equality_esm/* equal */.D)(error, previousResult.error)) {
                    _this.setResult({
                        data: (previousResult && previousResult.data),
                        error: error,
                        loading: false,
                        networkStatus: networkStatus/* NetworkStatus.error */.I.error,
                    });
                }
            };
            var subscription = obsQuery.subscribe(onNext, onError);
            return function () { return subscription.unsubscribe(); };
        }, [
            obsQuery,
            this.renderPromises,
            this.client.disableNetworkFetches,
        ]), function () { return _this.getCurrentResult(); }, function () { return _this.getCurrentResult(); });
        this.unsafeHandlePartialRefetch(result);
        var queryResult = this.toQueryResult(result);
        if (!queryResult.loading && this.asyncResolveFns.size) {
            this.asyncResolveFns.forEach(function (resolve) { return resolve(queryResult); });
            this.asyncResolveFns.clear();
        }
        return queryResult;
    };
    InternalState.prototype.useOptions = function (options) {
        var _a;
        var watchQueryOptions = this.createWatchQueryOptions(this.queryHookOptions = options);
        var currentWatchQueryOptions = this.watchQueryOptions;
        if (this.optionsToIgnoreOnce.has(currentWatchQueryOptions) ||
            !(0,equality_esm/* equal */.D)(watchQueryOptions, currentWatchQueryOptions)) {
            this.watchQueryOptions = watchQueryOptions;
            if (currentWatchQueryOptions && this.observable) {
                this.optionsToIgnoreOnce.delete(currentWatchQueryOptions);
                this.observable.reobserve(this.getObsQueryOptions());
                this.previousData = ((_a = this.result) === null || _a === void 0 ? void 0 : _a.data) || this.previousData;
                this.result = void 0;
            }
        }
        this.onCompleted = options.onCompleted || InternalState.prototype.onCompleted;
        this.onError = options.onError || InternalState.prototype.onError;
        if ((this.renderPromises || this.client.disableNetworkFetches) &&
            this.queryHookOptions.ssr === false &&
            !this.queryHookOptions.skip) {
            this.result = this.ssrDisabledResult;
        }
        else if (this.queryHookOptions.skip ||
            this.watchQueryOptions.fetchPolicy === 'standby') {
            this.result = this.skipStandbyResult;
        }
        else if (this.result === this.ssrDisabledResult ||
            this.result === this.skipStandbyResult) {
            this.result = void 0;
        }
    };
    InternalState.prototype.getObsQueryOptions = function () {
        var toMerge = [];
        var globalDefaults = this.client.defaultOptions.watchQuery;
        if (globalDefaults)
            toMerge.push(globalDefaults);
        if (this.queryHookOptions.defaultOptions) {
            toMerge.push(this.queryHookOptions.defaultOptions);
        }
        toMerge.push((0,compact/* compact */.o)(this.observable && this.observable.options, this.watchQueryOptions));
        return toMerge.reduce(mergeOptions/* mergeOptions */.J);
    };
    InternalState.prototype.createWatchQueryOptions = function (_a) {
        var _b;
        if (_a === void 0) { _a = {}; }
        var skip = _a.skip, ssr = _a.ssr, onCompleted = _a.onCompleted, onError = _a.onError, defaultOptions = _a.defaultOptions, otherOptions = (0,tslib_es6/* __rest */._T)(_a, ["skip", "ssr", "onCompleted", "onError", "defaultOptions"]);
        var watchQueryOptions = Object.assign(otherOptions, { query: this.query });
        if (this.renderPromises &&
            (watchQueryOptions.fetchPolicy === 'network-only' ||
                watchQueryOptions.fetchPolicy === 'cache-and-network')) {
            watchQueryOptions.fetchPolicy = 'cache-first';
        }
        if (!watchQueryOptions.variables) {
            watchQueryOptions.variables = {};
        }
        if (skip) {
            var _c = watchQueryOptions.fetchPolicy, fetchPolicy = _c === void 0 ? this.getDefaultFetchPolicy() : _c, _d = watchQueryOptions.initialFetchPolicy, initialFetchPolicy = _d === void 0 ? fetchPolicy : _d;
            Object.assign(watchQueryOptions, {
                initialFetchPolicy: initialFetchPolicy,
                fetchPolicy: 'standby',
            });
        }
        else if (!watchQueryOptions.fetchPolicy) {
            watchQueryOptions.fetchPolicy =
                ((_b = this.observable) === null || _b === void 0 ? void 0 : _b.options.initialFetchPolicy) ||
                    this.getDefaultFetchPolicy();
        }
        return watchQueryOptions;
    };
    InternalState.prototype.getDefaultFetchPolicy = function () {
        var _a, _b;
        return (((_a = this.queryHookOptions.defaultOptions) === null || _a === void 0 ? void 0 : _a.fetchPolicy) ||
            ((_b = this.client.defaultOptions.watchQuery) === null || _b === void 0 ? void 0 : _b.fetchPolicy) ||
            "cache-first");
    };
    InternalState.prototype.onCompleted = function (data) { };
    InternalState.prototype.onError = function (error) { };
    InternalState.prototype.useObservableQuery = function () {
        var obsQuery = this.observable =
            this.renderPromises
                && this.renderPromises.getSSRObservable(this.watchQueryOptions)
                || this.observable
                || this.client.watchQuery(this.getObsQueryOptions());
        this.obsQueryFields = (0,react.useMemo)(function () { return ({
            refetch: obsQuery.refetch.bind(obsQuery),
            reobserve: obsQuery.reobserve.bind(obsQuery),
            fetchMore: obsQuery.fetchMore.bind(obsQuery),
            updateQuery: obsQuery.updateQuery.bind(obsQuery),
            startPolling: obsQuery.startPolling.bind(obsQuery),
            stopPolling: obsQuery.stopPolling.bind(obsQuery),
            subscribeToMore: obsQuery.subscribeToMore.bind(obsQuery),
        }); }, [obsQuery]);
        var ssrAllowed = !(this.queryHookOptions.ssr === false ||
            this.queryHookOptions.skip);
        if (this.renderPromises && ssrAllowed) {
            this.renderPromises.registerSSRObservable(obsQuery);
            if (obsQuery.getCurrentResult().loading) {
                this.renderPromises.addObservableQueryPromise(obsQuery);
            }
        }
        return obsQuery;
    };
    InternalState.prototype.setResult = function (nextResult) {
        var previousResult = this.result;
        if (previousResult && previousResult.data) {
            this.previousData = previousResult.data;
        }
        this.result = nextResult;
        this.forceUpdate();
        this.handleErrorOrCompleted(nextResult);
    };
    InternalState.prototype.handleErrorOrCompleted = function (result) {
        var _this = this;
        if (!result.loading) {
            Promise.resolve().then(function () {
                if (result.error) {
                    _this.onError(result.error);
                }
                else if (result.data) {
                    _this.onCompleted(result.data);
                }
            }).catch(function (error) {
                __DEV__ && globals/* invariant.warn */.kG.warn(error);
            });
        }
    };
    InternalState.prototype.getCurrentResult = function () {
        if (!this.result) {
            this.handleErrorOrCompleted(this.result = this.observable.getCurrentResult());
        }
        return this.result;
    };
    InternalState.prototype.toQueryResult = function (result) {
        var queryResult = this.toQueryResultCache.get(result);
        if (queryResult)
            return queryResult;
        var data = result.data, partial = result.partial, resultWithoutPartial = (0,tslib_es6/* __rest */._T)(result, ["data", "partial"]);
        this.toQueryResultCache.set(result, queryResult = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({ data: data }, resultWithoutPartial), this.obsQueryFields), { client: this.client, observable: this.observable, variables: this.observable.variables, called: !this.queryHookOptions.skip, previousData: this.previousData }));
        if (!queryResult.error && (0,arrays/* isNonEmptyArray */.O)(result.errors)) {
            queryResult.error = new errors/* ApolloError */.c({ graphQLErrors: result.errors });
        }
        return queryResult;
    };
    InternalState.prototype.unsafeHandlePartialRefetch = function (result) {
        if (result.partial &&
            this.queryHookOptions.partialRefetch &&
            !result.loading &&
            (!result.data || Object.keys(result.data).length === 0) &&
            this.observable.options.fetchPolicy !== 'cache-only') {
            Object.assign(result, {
                loading: true,
                networkStatus: networkStatus/* NetworkStatus.refetch */.I.refetch,
            });
            this.observable.refetch();
        }
    };
    return InternalState;
}());
//# sourceMappingURL=useQuery.js.map

/***/ }),

/***/ 14692:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Vp": function() { return /* binding */ verifyDocumentType; },
/* harmony export */   "n_": function() { return /* binding */ DocumentType; }
/* harmony export */ });
/* unused harmony exports operationName, parser */
/* harmony import */ var _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62985);

var DocumentType;
(function (DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})(DocumentType || (DocumentType = {}));
var cache = new Map();
function operationName(type) {
    var name;
    switch (type) {
        case DocumentType.Query:
            name = 'Query';
            break;
        case DocumentType.Mutation:
            name = 'Mutation';
            break;
        case DocumentType.Subscription:
            name = 'Subscription';
            break;
    }
    return name;
}
function parser(document) {
    var cached = cache.get(document);
    if (cached)
        return cached;
    var variables, type, name;
    __DEV__ ? (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(!!document && !!document.kind, "Argument of ".concat(document, " passed to parser was not a valid GraphQL ") +
        "DocumentNode. You may need to use 'graphql-tag' or another method " +
        "to convert your operation into a document") : (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(!!document && !!document.kind, 32);
    var fragments = [];
    var queries = [];
    var mutations = [];
    var subscriptions = [];
    for (var _i = 0, _a = document.definitions; _i < _a.length; _i++) {
        var x = _a[_i];
        if (x.kind === 'FragmentDefinition') {
            fragments.push(x);
            continue;
        }
        if (x.kind === 'OperationDefinition') {
            switch (x.operation) {
                case 'query':
                    queries.push(x);
                    break;
                case 'mutation':
                    mutations.push(x);
                    break;
                case 'subscription':
                    subscriptions.push(x);
                    break;
            }
        }
    }
    __DEV__ ? (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(!fragments.length ||
        (queries.length || mutations.length || subscriptions.length), "Passing only a fragment to 'graphql' is not yet supported. " +
        "You must include a query, subscription or mutation as well") : (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(!fragments.length ||
        (queries.length || mutations.length || subscriptions.length), 33);
    __DEV__ ? (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(queries.length + mutations.length + subscriptions.length <= 1, "react-apollo only supports a query, subscription, or a mutation per HOC. " +
        "".concat(document, " had ").concat(queries.length, " queries, ").concat(subscriptions.length, " ") +
        "subscriptions and ".concat(mutations.length, " mutations. ") +
        "You can use 'compose' to join multiple operation types to a component") : (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(queries.length + mutations.length + subscriptions.length <= 1, 34);
    type = queries.length ? DocumentType.Query : DocumentType.Mutation;
    if (!queries.length && !mutations.length)
        type = DocumentType.Subscription;
    var definitions = queries.length
        ? queries
        : mutations.length
            ? mutations
            : subscriptions;
    __DEV__ ? (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(definitions.length === 1, "react-apollo only supports one definition per HOC. ".concat(document, " had ") +
        "".concat(definitions.length, " definitions. ") +
        "You can use 'compose' to join multiple operation types to a component") : (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(definitions.length === 1, 35);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === 'Name') {
        name = definition.name.value;
    }
    else {
        name = 'data';
    }
    var payload = { name: name, type: type, variables: variables };
    cache.set(document, payload);
    return payload;
}
function verifyDocumentType(document, type) {
    var operation = parser(document);
    var requiredOperationName = operationName(type);
    var usedOperationName = operationName(operation.type);
    __DEV__ ? (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(operation.type === type, "Running a ".concat(requiredOperationName, " requires a graphql ") +
        "".concat(requiredOperationName, ", but a ").concat(usedOperationName, " was used instead.")) : (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(operation.type === type, 36);
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 21436:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ isNonEmptyArray; }
/* harmony export */ });
function isNonEmptyArray(value) {
    return Array.isArray(value) && value.length > 0;
}
//# sourceMappingURL=arrays.js.map

/***/ }),

/***/ 30320:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DN": function() { return /* binding */ canUseAsyncIteratorSymbol; },
/* harmony export */   "JC": function() { return /* binding */ canUseLayoutEffect; },
/* harmony export */   "aS": function() { return /* binding */ canUseSymbol; },
/* harmony export */   "mr": function() { return /* binding */ canUseWeakMap; },
/* harmony export */   "sy": function() { return /* binding */ canUseWeakSet; }
/* harmony export */ });
/* unused harmony export canUseDOM */
/* harmony import */ var _globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62985);

var canUseWeakMap = typeof WeakMap === 'function' &&
    (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .maybe */ .wY)(function () { return navigator.product; }) !== 'ReactNative';
var canUseWeakSet = typeof WeakSet === 'function';
var canUseSymbol = typeof Symbol === 'function' &&
    typeof Symbol.for === 'function';
var canUseAsyncIteratorSymbol = canUseSymbol && Symbol.asyncIterator;
var canUseDOM = typeof (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .maybe */ .wY)(function () { return window.document.createElement; }) === "function";
var usingJSDOM = (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .maybe */ .wY)(function () { return navigator.userAgent.indexOf("jsdom") >= 0; }) || false;
var canUseLayoutEffect = canUseDOM && !usingJSDOM;
//# sourceMappingURL=canUse.js.map

/***/ }),

/***/ 79487:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ cloneDeep; }
/* harmony export */ });
var toString = Object.prototype.toString;
function cloneDeep(value) {
    return cloneDeepHelper(value);
}
function cloneDeepHelper(val, seen) {
    switch (toString.call(val)) {
        case "[object Array]": {
            seen = seen || new Map;
            if (seen.has(val))
                return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function (child, i) {
                copy_1[i] = cloneDeepHelper(child, seen);
            });
            return copy_1;
        }
        case "[object Object]": {
            seen = seen || new Map;
            if (seen.has(val))
                return seen.get(val);
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function (key) {
                copy_2[key] = cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        }
        default:
            return val;
    }
}
//# sourceMappingURL=cloneDeep.js.map

/***/ }),

/***/ 53712:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ compact; }
/* harmony export */ });
function compact() {
    var objects = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        objects[_i] = arguments[_i];
    }
    var result = Object.create(null);
    objects.forEach(function (obj) {
        if (!obj)
            return;
        Object.keys(obj).forEach(function (key) {
            var value = obj[key];
            if (value !== void 0) {
                result[key] = value;
            }
        });
    });
    return result;
}
//# sourceMappingURL=compact.js.map

/***/ }),

/***/ 60897:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ makeUniqueId; }
/* harmony export */ });
var prefixCounts = new Map();
function makeUniqueId(prefix) {
    var count = prefixCounts.get(prefix) || 1;
    prefixCounts.set(prefix, count + 1);
    return "".concat(prefix, ":").concat(count, ":").concat(Math.random().toString(36).slice(2));
}
//# sourceMappingURL=makeUniqueId.js.map

/***/ }),

/***/ 48702:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ maybeDeepFreeze; }
/* harmony export */ });
/* harmony import */ var _globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62985);
/* harmony import */ var _objects_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13154);


function deepFreeze(value) {
    var workSet = new Set([value]);
    workSet.forEach(function (obj) {
        if ((0,_objects_js__WEBPACK_IMPORTED_MODULE_1__/* .isNonNullObject */ .s)(obj) && shallowFreeze(obj) === obj) {
            Object.getOwnPropertyNames(obj).forEach(function (name) {
                if ((0,_objects_js__WEBPACK_IMPORTED_MODULE_1__/* .isNonNullObject */ .s)(obj[name]))
                    workSet.add(obj[name]);
            });
        }
    });
    return value;
}
function shallowFreeze(obj) {
    if (__DEV__ && !Object.isFrozen(obj)) {
        try {
            Object.freeze(obj);
        }
        catch (e) {
            if (e instanceof TypeError)
                return null;
            throw e;
        }
    }
    return obj;
}
function maybeDeepFreeze(obj) {
    if (__DEV__) {
        deepFreeze(obj);
    }
    return obj;
}
//# sourceMappingURL=maybeDeepFreeze.js.map

/***/ }),

/***/ 182:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ee": function() { return /* binding */ mergeDeep; },
/* harmony export */   "bw": function() { return /* binding */ mergeDeepArray; },
/* harmony export */   "w0": function() { return /* binding */ DeepMerger; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70655);
/* harmony import */ var _objects_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13154);


var hasOwnProperty = Object.prototype.hasOwnProperty;
function mergeDeep() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    return mergeDeepArray(sources);
}
function mergeDeepArray(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var merger = new DeepMerger();
        for (var i = 1; i < count; ++i) {
            target = merger.merge(target, sources[i]);
        }
    }
    return target;
}
var defaultReconciler = function (target, source, property) {
    return this.merge(target[property], source[property]);
};
var DeepMerger = (function () {
    function DeepMerger(reconciler) {
        if (reconciler === void 0) { reconciler = defaultReconciler; }
        this.reconciler = reconciler;
        this.isObject = _objects_js__WEBPACK_IMPORTED_MODULE_0__/* .isNonNullObject */ .s;
        this.pastCopies = new Set();
    }
    DeepMerger.prototype.merge = function (target, source) {
        var _this = this;
        var context = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            context[_i - 2] = arguments[_i];
        }
        if ((0,_objects_js__WEBPACK_IMPORTED_MODULE_0__/* .isNonNullObject */ .s)(source) && (0,_objects_js__WEBPACK_IMPORTED_MODULE_0__/* .isNonNullObject */ .s)(target)) {
            Object.keys(source).forEach(function (sourceKey) {
                if (hasOwnProperty.call(target, sourceKey)) {
                    var targetValue = target[sourceKey];
                    if (source[sourceKey] !== targetValue) {
                        var result = _this.reconciler.apply(_this, (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__spreadArray */ .ev)([target, source, sourceKey], context, false));
                        if (result !== targetValue) {
                            target = _this.shallowCopyForMerge(target);
                            target[sourceKey] = result;
                        }
                    }
                }
                else {
                    target = _this.shallowCopyForMerge(target);
                    target[sourceKey] = source[sourceKey];
                }
            });
            return target;
        }
        return source;
    };
    DeepMerger.prototype.shallowCopyForMerge = function (value) {
        if ((0,_objects_js__WEBPACK_IMPORTED_MODULE_0__/* .isNonNullObject */ .s)(value)) {
            if (!this.pastCopies.has(value)) {
                if (Array.isArray(value)) {
                    value = value.slice(0);
                }
                else {
                    value = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({ __proto__: Object.getPrototypeOf(value) }, value);
                }
                this.pastCopies.add(value);
            }
        }
        return value;
    };
    return DeepMerger;
}());

//# sourceMappingURL=mergeDeep.js.map

/***/ }),

/***/ 14012:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ mergeOptions; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70655);
/* harmony import */ var _compact_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53712);


function mergeOptions(defaults, options) {
    return (0,_compact_js__WEBPACK_IMPORTED_MODULE_0__/* .compact */ .o)(defaults, options, options.variables && {
        variables: (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({}, (defaults && defaults.variables)), options.variables),
    });
}
//# sourceMappingURL=mergeOptions.js.map

/***/ }),

/***/ 13154:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ isNonNullObject; }
/* harmony export */ });
function isNonNullObject(obj) {
    return obj !== null && typeof obj === 'object';
}
//# sourceMappingURL=objects.js.map

/***/ }),

/***/ 62985:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Rk": function() { return /* reexport */ DEV; },
  "ej": function() { return /* reexport */ invariant/* InvariantError */.ej; },
  "kG": function() { return /* reexport */ invariant/* invariant */.kG; },
  "wY": function() { return /* reexport */ maybe; }
});

// UNUSED EXPORTS: checkDEV, global

// EXTERNAL MODULE: ./node_modules/@apollo/client/node_modules/ts-invariant/lib/invariant.js
var invariant = __webpack_require__(53124);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/utilities/globals/maybe.js
function maybe(thunk) {
    try {
        return thunk();
    }
    catch (_a) { }
}
//# sourceMappingURL=maybe.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/utilities/globals/global.js

/* harmony default export */ var globals_global = (maybe(function () { return globalThis; }) ||
    maybe(function () { return window; }) ||
    maybe(function () { return self; }) ||
    maybe(function () { return global; }) || maybe(function () { return maybe.constructor("return this")(); }));
//# sourceMappingURL=global.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/utilities/globals/DEV.js


var __ = "__";
var GLOBAL_KEY = [__, __].join("DEV");
function getDEV() {
    try {
        return Boolean(__DEV__);
    }
    catch (_a) {
        Object.defineProperty(globals_global, GLOBAL_KEY, {
            value: maybe(function () { return "production"; }) !== "production",
            enumerable: false,
            configurable: true,
            writable: true,
        });
        return globals_global[GLOBAL_KEY];
    }
}
/* harmony default export */ var DEV = (getDEV());
//# sourceMappingURL=DEV.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/node_modules/ts-invariant/process/index.js
/* provided dependency */ var process = __webpack_require__(34155);
function process_maybe(thunk) {
  try { return thunk() } catch (_) {}
}

var safeGlobal = (
  process_maybe(function() { return globalThis }) ||
  process_maybe(function() { return window }) ||
  process_maybe(function() { return self }) ||
  process_maybe(function() { return global }) ||
  // We don't expect the Function constructor ever to be invoked at runtime, as
  // long as at least one of globalThis, window, self, or global is defined, so
  // we are under no obligation to make it easy for static analysis tools to
  // detect syntactic usage of the Function constructor. If you think you can
  // improve your static analysis to detect this obfuscation, think again. This
  // is an arms race you cannot win, at least not in JavaScript.
  process_maybe(function() { return process_maybe.constructor("return this")() })
);

var needToRemove = false;

function install() {
  if (safeGlobal &&
      !process_maybe(function() { return "production" }) &&
      !process_maybe(function() { return process })) {
    Object.defineProperty(safeGlobal, "process", {
      value: {
        env: {
          // This default needs to be "production" instead of "development", to
          // avoid the problem https://github.com/graphql/graphql-js/pull/2894
          // will eventually solve, once merged and released.
          NODE_ENV: "production",
        },
      },
      // Let anyone else change global.process as they see fit, but hide it from
      // Object.keys(global) enumeration.
      configurable: true,
      enumerable: false,
      writable: true,
    });
    needToRemove = true;
  }
}

// Call install() at least once, when this module is imported.
install();

function remove() {
  if (needToRemove) {
    delete safeGlobal.process;
    needToRemove = false;
  }
}

// EXTERNAL MODULE: ./node_modules/graphql/language/source.mjs + 1 modules
var source = __webpack_require__(49786);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/utilities/globals/fix-graphql.js


function removeTemporaryGlobals() {
    return typeof source/* Source */.H === "function" ? remove() : remove();
}
//# sourceMappingURL=fix-graphql.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/utilities/globals/index.js



function checkDEV() {
    __DEV__ ? (0,invariant/* invariant */.kG)("boolean" === typeof DEV, DEV) : (0,invariant/* invariant */.kG)("boolean" === typeof DEV, 38);
}

removeTemporaryGlobals();



checkDEV();
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 19065:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FS": function() { return /* binding */ hasDirectives; },
/* harmony export */   "LZ": function() { return /* binding */ shouldInclude; },
/* harmony export */   "mj": function() { return /* binding */ hasClientExports; }
/* harmony export */ });
/* unused harmony exports getDirectiveNames, hasAnyDirectives, hasAllDirectives, getInclusionDirectives */
/* harmony import */ var _globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62985);
/* harmony import */ var graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77304);


function shouldInclude(_a, variables) {
    var directives = _a.directives;
    if (!directives || !directives.length) {
        return true;
    }
    return getInclusionDirectives(directives).every(function (_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === 'Variable') {
            evaledValue = variables && variables[ifArgument.value.name.value];
            __DEV__ ? (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(evaledValue !== void 0, "Invalid variable referenced in @".concat(directive.name.value, " directive.")) : (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(evaledValue !== void 0, 39);
        }
        else {
            evaledValue = ifArgument.value.value;
        }
        return directive.name.value === 'skip' ? !evaledValue : evaledValue;
    });
}
function getDirectiveNames(root) {
    var names = [];
    visit(root, {
        Directive: function (node) {
            names.push(node.name.value);
        },
    });
    return names;
}
var hasAnyDirectives = function (names, root) { return hasDirectives(names, root, false); };
var hasAllDirectives = function (names, root) { return hasDirectives(names, root, true); };
function hasDirectives(names, root, all) {
    var nameSet = new Set(names);
    var uniqueCount = nameSet.size;
    (0,graphql__WEBPACK_IMPORTED_MODULE_1__/* .visit */ .Vn)(root, {
        Directive: function (node) {
            if (nameSet.delete(node.name.value) &&
                (!all || !nameSet.size)) {
                return graphql__WEBPACK_IMPORTED_MODULE_1__/* .BREAK */ .$_;
            }
        },
    });
    return all ? !nameSet.size : nameSet.size < uniqueCount;
}
function hasClientExports(document) {
    return document && hasDirectives(['client', 'export'], document, true);
}
function isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === 'skip' || value === 'include';
}
function getInclusionDirectives(directives) {
    var result = [];
    if (directives && directives.length) {
        directives.forEach(function (directive) {
            if (!isInclusionDirective(directive))
                return;
            var directiveArguments = directive.arguments;
            var directiveName = directive.name.value;
            __DEV__ ? (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(directiveArguments && directiveArguments.length === 1, "Incorrect number of arguments for the @".concat(directiveName, " directive.")) : (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(directiveArguments && directiveArguments.length === 1, 40);
            var ifArgument = directiveArguments[0];
            __DEV__ ? (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(ifArgument.name && ifArgument.name.value === 'if', "Invalid argument for the @".concat(directiveName, " directive.")) : (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(ifArgument.name && ifArgument.name.value === 'if', 41);
            var ifValue = ifArgument.value;
            __DEV__ ? (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(ifValue &&
                (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), "Argument for the @".concat(directiveName, " directive must be a variable or a boolean value.")) : (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(ifValue &&
                (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), 42);
            result.push({ directive: directive, ifArgument: ifArgument });
        });
    }
    return result;
}
//# sourceMappingURL=directives.js.map

/***/ }),

/***/ 23361:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ createFragmentMap; },
/* harmony export */   "Yk": function() { return /* binding */ getFragmentQueryDocument; },
/* harmony export */   "hi": function() { return /* binding */ getFragmentFromSelection; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70655);
/* harmony import */ var _globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62985);


function getFragmentQueryDocument(document, fragmentName) {
    var actualFragmentName = fragmentName;
    var fragments = [];
    document.definitions.forEach(function (definition) {
        if (definition.kind === 'OperationDefinition') {
            throw __DEV__ ? new _globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .InvariantError */ .ej("Found a ".concat(definition.operation, " operation").concat(definition.name ? " named '".concat(definition.name.value, "'") : '', ". ") +
                'No operations are allowed when using a fragment as a query. Only fragments are allowed.') : new _globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .InvariantError */ .ej(43);
        }
        if (definition.kind === 'FragmentDefinition') {
            fragments.push(definition);
        }
    });
    if (typeof actualFragmentName === 'undefined') {
        __DEV__ ? (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(fragments.length === 1, "Found ".concat(fragments.length, " fragments. `fragmentName` must be provided when there is not exactly 1 fragment.")) : (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(fragments.length === 1, 44);
        actualFragmentName = fragments[0].name.value;
    }
    var query = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({}, document), { definitions: (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__spreadArray */ .ev)([
            {
                kind: 'OperationDefinition',
                operation: 'query',
                selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                        {
                            kind: 'FragmentSpread',
                            name: {
                                kind: 'Name',
                                value: actualFragmentName,
                            },
                        },
                    ],
                },
            }
        ], document.definitions, true) });
    return query;
}
function createFragmentMap(fragments) {
    if (fragments === void 0) { fragments = []; }
    var symTable = {};
    fragments.forEach(function (fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function getFragmentFromSelection(selection, fragmentMap) {
    switch (selection.kind) {
        case 'InlineFragment':
            return selection;
        case 'FragmentSpread': {
            var fragmentName = selection.name.value;
            if (typeof fragmentMap === "function") {
                return fragmentMap(fragmentName);
            }
            var fragment = fragmentMap && fragmentMap[fragmentName];
            __DEV__ ? (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(fragment, "No fragment named ".concat(fragmentName)) : (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(fragment, 45);
            return fragment || null;
        }
        default:
            return null;
    }
}
//# sourceMappingURL=fragments.js.map

/***/ }),

/***/ 36765:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$H": function() { return /* binding */ getOperationDefinition; },
/* harmony export */   "A$": function() { return /* binding */ checkDocument; },
/* harmony export */   "O4": function() { return /* binding */ getDefaultValues; },
/* harmony export */   "iW": function() { return /* binding */ getQueryDefinition; },
/* harmony export */   "kU": function() { return /* binding */ getFragmentDefinitions; },
/* harmony export */   "p$": function() { return /* binding */ getMainDefinition; },
/* harmony export */   "pD": function() { return /* binding */ getFragmentDefinition; },
/* harmony export */   "rY": function() { return /* binding */ getOperationName; }
/* harmony export */ });
/* harmony import */ var _globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62985);
/* harmony import */ var _storeUtils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51761);


function checkDocument(doc) {
    __DEV__ ? (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(doc && doc.kind === 'Document', "Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a \"gql\" tag? http://docs.apollostack.com/apollo-client/core.html#gql") : (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(doc && doc.kind === 'Document', 46);
    var operations = doc.definitions
        .filter(function (d) { return d.kind !== 'FragmentDefinition'; })
        .map(function (definition) {
        if (definition.kind !== 'OperationDefinition') {
            throw __DEV__ ? new _globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .InvariantError */ .ej("Schema type definitions not allowed in queries. Found: \"".concat(definition.kind, "\"")) : new _globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .InvariantError */ .ej(47);
        }
        return definition;
    });
    __DEV__ ? (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(operations.length <= 1, "Ambiguous GraphQL document: contains ".concat(operations.length, " operations")) : (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(operations.length <= 1, 48);
    return doc;
}
function getOperationDefinition(doc) {
    checkDocument(doc);
    return doc.definitions.filter(function (definition) { return definition.kind === 'OperationDefinition'; })[0];
}
function getOperationName(doc) {
    return (doc.definitions
        .filter(function (definition) {
        return definition.kind === 'OperationDefinition' && definition.name;
    })
        .map(function (x) { return x.name.value; })[0] || null);
}
function getFragmentDefinitions(doc) {
    return doc.definitions.filter(function (definition) { return definition.kind === 'FragmentDefinition'; });
}
function getQueryDefinition(doc) {
    var queryDef = getOperationDefinition(doc);
    __DEV__ ? (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(queryDef && queryDef.operation === 'query', 'Must contain a query definition.') : (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(queryDef && queryDef.operation === 'query', 49);
    return queryDef;
}
function getFragmentDefinition(doc) {
    __DEV__ ? (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(doc.kind === 'Document', "Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a \"gql\" tag? http://docs.apollostack.com/apollo-client/core.html#gql") : (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(doc.kind === 'Document', 50);
    __DEV__ ? (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(doc.definitions.length <= 1, 'Fragment must have exactly one definition.') : (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(doc.definitions.length <= 1, 51);
    var fragmentDef = doc.definitions[0];
    __DEV__ ? (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(fragmentDef.kind === 'FragmentDefinition', 'Must be a fragment definition.') : (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(fragmentDef.kind === 'FragmentDefinition', 52);
    return fragmentDef;
}
function getMainDefinition(queryDoc) {
    checkDocument(queryDoc);
    var fragmentDefinition;
    for (var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++) {
        var definition = _a[_i];
        if (definition.kind === 'OperationDefinition') {
            var operation = definition.operation;
            if (operation === 'query' ||
                operation === 'mutation' ||
                operation === 'subscription') {
                return definition;
            }
        }
        if (definition.kind === 'FragmentDefinition' && !fragmentDefinition) {
            fragmentDefinition = definition;
        }
    }
    if (fragmentDefinition) {
        return fragmentDefinition;
    }
    throw __DEV__ ? new _globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .InvariantError */ .ej('Expected a parsed GraphQL query with a query, mutation, subscription, or a fragment.') : new _globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .InvariantError */ .ej(53);
}
function getDefaultValues(definition) {
    var defaultValues = Object.create(null);
    var defs = definition && definition.variableDefinitions;
    if (defs && defs.length) {
        defs.forEach(function (def) {
            if (def.defaultValue) {
                (0,_storeUtils_js__WEBPACK_IMPORTED_MODULE_1__/* .valueToObjectRepresentation */ .vb)(defaultValues, def.variable.name, def.defaultValue);
            }
        });
    }
    return defaultValues;
}
//# sourceMappingURL=getFromAST.js.map

/***/ }),

/***/ 51761:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ao": function() { return /* binding */ isInlineFragment; },
/* harmony export */   "JW": function() { return /* binding */ isDocumentNode; },
/* harmony export */   "My": function() { return /* binding */ isField; },
/* harmony export */   "NC": function() { return /* binding */ argumentsObjectFromField; },
/* harmony export */   "PT": function() { return /* binding */ getStoreKeyName; },
/* harmony export */   "Yk": function() { return /* binding */ isReference; },
/* harmony export */   "kQ": function() { return /* binding */ makeReference; },
/* harmony export */   "qw": function() { return /* binding */ getTypenameFromResult; },
/* harmony export */   "u2": function() { return /* binding */ resultKeyNameFromField; },
/* harmony export */   "vb": function() { return /* binding */ valueToObjectRepresentation; },
/* harmony export */   "vf": function() { return /* binding */ storeKeyNameFromField; }
/* harmony export */ });
/* harmony import */ var _globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62985);
/* harmony import */ var _common_objects_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13154);
/* harmony import */ var _fragments_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23361);



function makeReference(id) {
    return { __ref: String(id) };
}
function isReference(obj) {
    return Boolean(obj && typeof obj === 'object' && typeof obj.__ref === 'string');
}
function isDocumentNode(value) {
    return ((0,_common_objects_js__WEBPACK_IMPORTED_MODULE_1__/* .isNonNullObject */ .s)(value) &&
        value.kind === "Document" &&
        Array.isArray(value.definitions));
}
function isStringValue(value) {
    return value.kind === 'StringValue';
}
function isBooleanValue(value) {
    return value.kind === 'BooleanValue';
}
function isIntValue(value) {
    return value.kind === 'IntValue';
}
function isFloatValue(value) {
    return value.kind === 'FloatValue';
}
function isVariable(value) {
    return value.kind === 'Variable';
}
function isObjectValue(value) {
    return value.kind === 'ObjectValue';
}
function isListValue(value) {
    return value.kind === 'ListValue';
}
function isEnumValue(value) {
    return value.kind === 'EnumValue';
}
function isNullValue(value) {
    return value.kind === 'NullValue';
}
function valueToObjectRepresentation(argObj, name, value, variables) {
    if (isIntValue(value) || isFloatValue(value)) {
        argObj[name.value] = Number(value.value);
    }
    else if (isBooleanValue(value) || isStringValue(value)) {
        argObj[name.value] = value.value;
    }
    else if (isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function (obj) {
            return valueToObjectRepresentation(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    }
    else if (isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    }
    else if (isListValue(value)) {
        argObj[name.value] = value.values.map(function (listValue) {
            var nestedArgArrayObj = {};
            valueToObjectRepresentation(nestedArgArrayObj, name, listValue, variables);
            return nestedArgArrayObj[name.value];
        });
    }
    else if (isEnumValue(value)) {
        argObj[name.value] = value.value;
    }
    else if (isNullValue(value)) {
        argObj[name.value] = null;
    }
    else {
        throw __DEV__ ? new _globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .InvariantError */ .ej("The inline argument \"".concat(name.value, "\" of kind \"").concat(value.kind, "\"") +
            'is not supported. Use variables instead of inline arguments to ' +
            'overcome this limitation.') : new _globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .InvariantError */ .ej(54);
    }
}
function storeKeyNameFromField(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function (directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) {
                directive.arguments.forEach(function (_a) {
                    var name = _a.name, value = _a.value;
                    return valueToObjectRepresentation(directivesObj[directive.name.value], name, value, variables);
                });
            }
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function (_a) {
            var name = _a.name, value = _a.value;
            return valueToObjectRepresentation(argObj, name, value, variables);
        });
    }
    return getStoreKeyName(field.name.value, argObj, directivesObj);
}
var KNOWN_DIRECTIVES = [
    'connection',
    'include',
    'skip',
    'client',
    'rest',
    'export',
];
var getStoreKeyName = Object.assign(function (fieldName, args, directives) {
    if (args &&
        directives &&
        directives['connection'] &&
        directives['connection']['key']) {
        if (directives['connection']['filter'] &&
            directives['connection']['filter'].length > 0) {
            var filterKeys = directives['connection']['filter']
                ? directives['connection']['filter']
                : [];
            filterKeys.sort();
            var filteredArgs_1 = {};
            filterKeys.forEach(function (key) {
                filteredArgs_1[key] = args[key];
            });
            return "".concat(directives['connection']['key'], "(").concat(stringify(filteredArgs_1), ")");
        }
        else {
            return directives['connection']['key'];
        }
    }
    var completeFieldName = fieldName;
    if (args) {
        var stringifiedArgs = stringify(args);
        completeFieldName += "(".concat(stringifiedArgs, ")");
    }
    if (directives) {
        Object.keys(directives).forEach(function (key) {
            if (KNOWN_DIRECTIVES.indexOf(key) !== -1)
                return;
            if (directives[key] && Object.keys(directives[key]).length) {
                completeFieldName += "@".concat(key, "(").concat(stringify(directives[key]), ")");
            }
            else {
                completeFieldName += "@".concat(key);
            }
        });
    }
    return completeFieldName;
}, {
    setStringify: function (s) {
        var previous = stringify;
        stringify = s;
        return previous;
    },
});
var stringify = function defaultStringify(value) {
    return JSON.stringify(value, stringifyReplacer);
};
function stringifyReplacer(_key, value) {
    if ((0,_common_objects_js__WEBPACK_IMPORTED_MODULE_1__/* .isNonNullObject */ .s)(value) && !Array.isArray(value)) {
        value = Object.keys(value).sort().reduce(function (copy, key) {
            copy[key] = value[key];
            return copy;
        }, {});
    }
    return value;
}
function argumentsObjectFromField(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function (_a) {
            var name = _a.name, value = _a.value;
            return valueToObjectRepresentation(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function resultKeyNameFromField(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function getTypenameFromResult(result, selectionSet, fragmentMap) {
    if (typeof result.__typename === 'string') {
        return result.__typename;
    }
    for (var _i = 0, _a = selectionSet.selections; _i < _a.length; _i++) {
        var selection = _a[_i];
        if (isField(selection)) {
            if (selection.name.value === '__typename') {
                return result[resultKeyNameFromField(selection)];
            }
        }
        else {
            var typename = getTypenameFromResult(result, (0,_fragments_js__WEBPACK_IMPORTED_MODULE_2__/* .getFragmentFromSelection */ .hi)(selection, fragmentMap).selectionSet, fragmentMap);
            if (typeof typename === 'string') {
                return typename;
            }
        }
    }
}
function isField(selection) {
    return selection.kind === 'Field';
}
function isInlineFragment(selection) {
    return selection.kind === 'InlineFragment';
}
//# sourceMappingURL=storeUtils.js.map

/***/ }),

/***/ 76982:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Gw": function() { return /* binding */ addTypenameToDocument; },
  "aL": function() { return /* binding */ buildQueryFromSelectionSet; },
  "ob": function() { return /* binding */ removeClientSetsFromDocument; },
  "Fo": function() { return /* binding */ removeConnectionDirectiveFromDocument; }
});

// UNUSED EXPORTS: removeArgumentsFromDocument, removeDirectivesFromDocument, removeFragmentSpreadFromDocument

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/globals/index.js + 5 modules
var globals = __webpack_require__(62985);
// EXTERNAL MODULE: ./node_modules/graphql/language/visitor.mjs
var visitor = __webpack_require__(77304);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/graphql/getFromAST.js
var getFromAST = __webpack_require__(36765);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/utilities/common/filterInPlace.js
function filterInPlace(array, test, context) {
    var target = 0;
    array.forEach(function (elem, i) {
        if (test.call(this, elem, i, array)) {
            array[target++] = elem;
        }
    }, context);
    array.length = target;
    return array;
}
//# sourceMappingURL=filterInPlace.js.map
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/graphql/storeUtils.js
var storeUtils = __webpack_require__(51761);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/graphql/fragments.js
var fragments = __webpack_require__(23361);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/utilities/graphql/transform.js







var TYPENAME_FIELD = {
    kind: 'Field',
    name: {
        kind: 'Name',
        value: '__typename',
    },
};
function isEmpty(op, fragmentMap) {
    return !op || op.selectionSet.selections.every(function (selection) { return selection.kind === 'FragmentSpread' &&
        isEmpty(fragmentMap[selection.name.value], fragmentMap); });
}
function nullIfDocIsEmpty(doc) {
    return isEmpty((0,getFromAST/* getOperationDefinition */.$H)(doc) || (0,getFromAST/* getFragmentDefinition */.pD)(doc), (0,fragments/* createFragmentMap */.F)((0,getFromAST/* getFragmentDefinitions */.kU)(doc)))
        ? null
        : doc;
}
function getDirectiveMatcher(directives) {
    return function directiveMatcher(directive) {
        return directives.some(function (dir) {
            return (dir.name && dir.name === directive.name.value) ||
                (dir.test && dir.test(directive));
        });
    };
}
function removeDirectivesFromDocument(directives, doc) {
    var variablesInUse = Object.create(null);
    var variablesToRemove = [];
    var fragmentSpreadsInUse = Object.create(null);
    var fragmentSpreadsToRemove = [];
    var modifiedDoc = nullIfDocIsEmpty((0,visitor/* visit */.Vn)(doc, {
        Variable: {
            enter: function (node, _key, parent) {
                if (parent.kind !== 'VariableDefinition') {
                    variablesInUse[node.name.value] = true;
                }
            },
        },
        Field: {
            enter: function (node) {
                if (directives && node.directives) {
                    var shouldRemoveField = directives.some(function (directive) { return directive.remove; });
                    if (shouldRemoveField &&
                        node.directives &&
                        node.directives.some(getDirectiveMatcher(directives))) {
                        if (node.arguments) {
                            node.arguments.forEach(function (arg) {
                                if (arg.value.kind === 'Variable') {
                                    variablesToRemove.push({
                                        name: arg.value.name.value,
                                    });
                                }
                            });
                        }
                        if (node.selectionSet) {
                            getAllFragmentSpreadsFromSelectionSet(node.selectionSet).forEach(function (frag) {
                                fragmentSpreadsToRemove.push({
                                    name: frag.name.value,
                                });
                            });
                        }
                        return null;
                    }
                }
            },
        },
        FragmentSpread: {
            enter: function (node) {
                fragmentSpreadsInUse[node.name.value] = true;
            },
        },
        Directive: {
            enter: function (node) {
                if (getDirectiveMatcher(directives)(node)) {
                    return null;
                }
            },
        },
    }));
    if (modifiedDoc &&
        filterInPlace(variablesToRemove, function (v) { return !!v.name && !variablesInUse[v.name]; }).length) {
        modifiedDoc = removeArgumentsFromDocument(variablesToRemove, modifiedDoc);
    }
    if (modifiedDoc &&
        filterInPlace(fragmentSpreadsToRemove, function (fs) { return !!fs.name && !fragmentSpreadsInUse[fs.name]; })
            .length) {
        modifiedDoc = removeFragmentSpreadFromDocument(fragmentSpreadsToRemove, modifiedDoc);
    }
    return modifiedDoc;
}
var addTypenameToDocument = Object.assign(function (doc) {
    return (0,visitor/* visit */.Vn)(doc, {
        SelectionSet: {
            enter: function (node, _key, parent) {
                if (parent &&
                    parent.kind === 'OperationDefinition') {
                    return;
                }
                var selections = node.selections;
                if (!selections) {
                    return;
                }
                var skip = selections.some(function (selection) {
                    return ((0,storeUtils/* isField */.My)(selection) &&
                        (selection.name.value === '__typename' ||
                            selection.name.value.lastIndexOf('__', 0) === 0));
                });
                if (skip) {
                    return;
                }
                var field = parent;
                if ((0,storeUtils/* isField */.My)(field) &&
                    field.directives &&
                    field.directives.some(function (d) { return d.name.value === 'export'; })) {
                    return;
                }
                return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, node), { selections: (0,tslib_es6/* __spreadArray */.ev)((0,tslib_es6/* __spreadArray */.ev)([], selections, true), [TYPENAME_FIELD], false) });
            },
        },
    });
}, {
    added: function (field) {
        return field === TYPENAME_FIELD;
    },
});
var connectionRemoveConfig = {
    test: function (directive) {
        var willRemove = directive.name.value === 'connection';
        if (willRemove) {
            if (!directive.arguments ||
                !directive.arguments.some(function (arg) { return arg.name.value === 'key'; })) {
                __DEV__ && globals/* invariant.warn */.kG.warn('Removing an @connection directive even though it does not have a key. ' +
                    'You may want to use the key parameter to specify a store key.');
            }
        }
        return willRemove;
    },
};
function removeConnectionDirectiveFromDocument(doc) {
    return removeDirectivesFromDocument([connectionRemoveConfig], (0,getFromAST/* checkDocument */.A$)(doc));
}
function hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) { nestedCheck = true; }
    return (!!selectionSet &&
        selectionSet.selections &&
        selectionSet.selections.some(function (selection) {
            return hasDirectivesInSelection(directives, selection, nestedCheck);
        }));
}
function hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) { nestedCheck = true; }
    if (!isField(selection)) {
        return true;
    }
    if (!selection.directives) {
        return false;
    }
    return (selection.directives.some(getDirectiveMatcher(directives)) ||
        (nestedCheck &&
            hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck)));
}
function getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function (aConfig) {
            return argument.value &&
                argument.value.kind === 'Variable' &&
                argument.value.name &&
                (aConfig.name === argument.value.name.value ||
                    (aConfig.test && aConfig.test(argument)));
        });
    };
}
function removeArgumentsFromDocument(config, doc) {
    var argMatcher = getArgumentMatcher(config);
    return nullIfDocIsEmpty((0,visitor/* visit */.Vn)(doc, {
        OperationDefinition: {
            enter: function (node) {
                return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, node), { variableDefinitions: node.variableDefinitions ? node.variableDefinitions.filter(function (varDef) {
                        return !config.some(function (arg) { return arg.name === varDef.variable.name.value; });
                    }) : [] });
            },
        },
        Field: {
            enter: function (node) {
                var shouldRemoveField = config.some(function (argConfig) { return argConfig.remove; });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    if (node.arguments) {
                        node.arguments.forEach(function (arg) {
                            if (argMatcher(arg)) {
                                argMatchCount_1 += 1;
                            }
                        });
                    }
                    if (argMatchCount_1 === 1) {
                        return null;
                    }
                }
            },
        },
        Argument: {
            enter: function (node) {
                if (argMatcher(node)) {
                    return null;
                }
            },
        },
    }));
}
function removeFragmentSpreadFromDocument(config, doc) {
    function enter(node) {
        if (config.some(function (def) { return def.name === node.name.value; })) {
            return null;
        }
    }
    return nullIfDocIsEmpty((0,visitor/* visit */.Vn)(doc, {
        FragmentSpread: { enter: enter },
        FragmentDefinition: { enter: enter },
    }));
}
function getAllFragmentSpreadsFromSelectionSet(selectionSet) {
    var allFragments = [];
    selectionSet.selections.forEach(function (selection) {
        if (((0,storeUtils/* isField */.My)(selection) || (0,storeUtils/* isInlineFragment */.Ao)(selection)) &&
            selection.selectionSet) {
            getAllFragmentSpreadsFromSelectionSet(selection.selectionSet).forEach(function (frag) { return allFragments.push(frag); });
        }
        else if (selection.kind === 'FragmentSpread') {
            allFragments.push(selection);
        }
    });
    return allFragments;
}
function buildQueryFromSelectionSet(document) {
    var definition = (0,getFromAST/* getMainDefinition */.p$)(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === 'query') {
        return document;
    }
    var modifiedDoc = (0,visitor/* visit */.Vn)(document, {
        OperationDefinition: {
            enter: function (node) {
                return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, node), { operation: 'query' });
            },
        },
    });
    return modifiedDoc;
}
function removeClientSetsFromDocument(document) {
    (0,getFromAST/* checkDocument */.A$)(document);
    var modifiedDoc = removeDirectivesFromDocument([
        {
            test: function (directive) { return directive.name.value === 'client'; },
            remove: true,
        },
    ], document);
    if (modifiedDoc) {
        modifiedDoc = (0,visitor/* visit */.Vn)(modifiedDoc, {
            FragmentDefinition: {
                enter: function (node) {
                    if (node.selectionSet) {
                        var isTypenameOnly = node.selectionSet.selections.every(function (selection) {
                            return (0,storeUtils/* isField */.My)(selection) && selection.name.value === '__typename';
                        });
                        if (isTypenameOnly) {
                            return null;
                        }
                    }
                },
            },
        });
    }
    return modifiedDoc;
}
//# sourceMappingURL=transform.js.map

/***/ }),

/***/ 18263:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ iterateObserversSafely; }
/* harmony export */ });
function iterateObserversSafely(observers, method, argument) {
    var observersWithMethod = [];
    observers.forEach(function (obs) { return obs[method] && observersWithMethod.push(obs); });
    observersWithMethod.forEach(function (obs) { return obs[method](argument); });
}
//# sourceMappingURL=iteration.js.map

/***/ }),

/***/ 86403:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ fixObservableSubclass; }
/* harmony export */ });
/* harmony import */ var _Observable_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48216);
/* harmony import */ var _common_canUse_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30320);


function fixObservableSubclass(subclass) {
    function set(key) {
        Object.defineProperty(subclass, key, { value: _Observable_js__WEBPACK_IMPORTED_MODULE_0__/* .Observable */ .y });
    }
    if (_common_canUse_js__WEBPACK_IMPORTED_MODULE_1__/* .canUseSymbol */ .aS && Symbol.species) {
        set(Symbol.species);
    }
    set("@@species");
    return subclass;
}
//# sourceMappingURL=subclassing.js.map

/***/ }),

/***/ 30907:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

/***/ }),

/***/ 97326:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _assertThisInitialized; }
/* harmony export */ });
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),

/***/ 15671:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ 43144:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _createClass; }
/* harmony export */ });
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

/***/ }),

/***/ 4942:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),

/***/ 87462:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),

/***/ 61120:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _getPrototypeOf; }
/* harmony export */ });
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),

/***/ 60136:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _inherits; }
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89611);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(subClass, superClass);
}

/***/ }),

/***/ 94578:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _inheritsLoose; }
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89611);

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(subClass, superClass);
}

/***/ }),

/***/ 45987:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectWithoutProperties; }
/* harmony export */ });
/* harmony import */ var _objectWithoutPropertiesLoose_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63366);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = (0,_objectWithoutPropertiesLoose_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 63366:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectWithoutPropertiesLoose; }
/* harmony export */ });
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),

/***/ 82963:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _possibleConstructorReturn; }
/* harmony export */ });
/* harmony import */ var _typeof_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71002);
/* harmony import */ var _assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97326);


function _possibleConstructorReturn(self, call) {
  if (call && ((0,_typeof_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return (0,_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(self);
}

/***/ }),

/***/ 89611:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),

/***/ 86854:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(40181);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || (0,unsupportedIterableToArray/* default */.Z)(arr, i) || _nonIterableRest();
}

/***/ }),

/***/ 41451:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
var arrayLikeToArray = __webpack_require__(30907);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,arrayLikeToArray/* default */.Z)(arr);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(40181);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || (0,unsupportedIterableToArray/* default */.Z)(arr) || _nonIterableSpread();
}

/***/ }),

/***/ 71002:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ }),

/***/ 40181:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30907);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}

/***/ }),

/***/ 37826:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ devAssert; }
/* harmony export */ });
function devAssert(condition, message) {
  var booleanCondition = Boolean(condition);

  if (!booleanCondition) {
    throw new Error(message);
  }
}


/***/ }),

/***/ 25821:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ inspect; }
/* harmony export */ });
/* harmony import */ var _nodejsCustomInspectSymbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45695);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }


var MAX_ARRAY_LENGTH = 10;
var MAX_RECURSIVE_DEPTH = 2;
/**
 * Used to print values in error messages.
 */

function inspect(value) {
  return formatValue(value, []);
}

function formatValue(value, seenValues) {
  switch (_typeof(value)) {
    case 'string':
      return JSON.stringify(value);

    case 'function':
      return value.name ? "[function ".concat(value.name, "]") : '[function]';

    case 'object':
      if (value === null) {
        return 'null';
      }

      return formatObjectValue(value, seenValues);

    default:
      return String(value);
  }
}

function formatObjectValue(value, previouslySeenValues) {
  if (previouslySeenValues.indexOf(value) !== -1) {
    return '[Circular]';
  }

  var seenValues = [].concat(previouslySeenValues, [value]);
  var customInspectFn = getCustomFn(value);

  if (customInspectFn !== undefined) {
    // $FlowFixMe(>=0.90.0)
    var customValue = customInspectFn.call(value); // check for infinite recursion

    if (customValue !== value) {
      return typeof customValue === 'string' ? customValue : formatValue(customValue, seenValues);
    }
  } else if (Array.isArray(value)) {
    return formatArray(value, seenValues);
  }

  return formatObject(value, seenValues);
}

function formatObject(object, seenValues) {
  var keys = Object.keys(object);

  if (keys.length === 0) {
    return '{}';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[' + getObjectTag(object) + ']';
  }

  var properties = keys.map(function (key) {
    var value = formatValue(object[key], seenValues);
    return key + ': ' + value;
  });
  return '{ ' + properties.join(', ') + ' }';
}

function formatArray(array, seenValues) {
  if (array.length === 0) {
    return '[]';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[Array]';
  }

  var len = Math.min(MAX_ARRAY_LENGTH, array.length);
  var remaining = array.length - len;
  var items = [];

  for (var i = 0; i < len; ++i) {
    items.push(formatValue(array[i], seenValues));
  }

  if (remaining === 1) {
    items.push('... 1 more item');
  } else if (remaining > 1) {
    items.push("... ".concat(remaining, " more items"));
  }

  return '[' + items.join(', ') + ']';
}

function getCustomFn(object) {
  var customInspectFn = object[String(_nodejsCustomInspectSymbol__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)];

  if (typeof customInspectFn === 'function') {
    return customInspectFn;
  }

  if (typeof object.inspect === 'function') {
    return object.inspect;
  }
}

function getObjectTag(object) {
  var tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');

  if (tag === 'Object' && typeof object.constructor === 'function') {
    var name = object.constructor.name;

    if (typeof name === 'string' && name !== '') {
      return name;
    }
  }

  return tag;
}


/***/ }),

/***/ 45695:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__) {

"use strict";
var nodejsCustomInspectSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('nodejs.util.inspect.custom') : undefined;
/* harmony default export */ __webpack_exports__["Z"] = (nodejsCustomInspectSymbol);


/***/ }),

/***/ 87392:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LZ": function() { return /* binding */ printBlockString; },
/* harmony export */   "W7": function() { return /* binding */ dedentBlockStringValue; }
/* harmony export */ });
/* unused harmony export getBlockStringIndentation */
/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 */
function dedentBlockStringValue(rawString) {
  // Expand a block string's raw value into independent lines.
  var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.

  var commonIndent = getBlockStringIndentation(lines);

  if (commonIndent !== 0) {
    for (var i = 1; i < lines.length; i++) {
      lines[i] = lines[i].slice(commonIndent);
    }
  } // Remove leading and trailing blank lines.


  while (lines.length > 0 && isBlank(lines[0])) {
    lines.shift();
  }

  while (lines.length > 0 && isBlank(lines[lines.length - 1])) {
    lines.pop();
  } // Return a string of the lines joined with U+000A.


  return lines.join('\n');
} // @internal

function getBlockStringIndentation(lines) {
  var commonIndent = null;

  for (var i = 1; i < lines.length; i++) {
    var line = lines[i];
    var indent = leadingWhitespace(line);

    if (indent === line.length) {
      continue; // skip empty lines
    }

    if (commonIndent === null || indent < commonIndent) {
      commonIndent = indent;

      if (commonIndent === 0) {
        break;
      }
    }
  }

  return commonIndent === null ? 0 : commonIndent;
}

function leadingWhitespace(str) {
  var i = 0;

  while (i < str.length && (str[i] === ' ' || str[i] === '\t')) {
    i++;
  }

  return i;
}

function isBlank(str) {
  return leadingWhitespace(str) === str.length;
}
/**
 * Print a block string in the indented block form by adding a leading and
 * trailing blank line. However, if a block string starts with whitespace and is
 * a single-line, adding a leading blank line would strip that whitespace.
 */


function printBlockString(value) {
  var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var isSingleLine = value.indexOf('\n') === -1;
  var hasLeadingSpace = value[0] === ' ' || value[0] === '\t';
  var hasTrailingQuote = value[value.length - 1] === '"';
  var printAsMultipleLines = !isSingleLine || hasTrailingQuote || preferMultipleLines;
  var result = ''; // Format a multi-line block quote to account for leading space.

  if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) {
    result += '\n' + indentation;
  }

  result += indentation ? value.replace(/\n/g, '\n' + indentation) : value;

  if (printAsMultipleLines) {
    result += '\n';
  }

  return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}


/***/ }),

/***/ 97359:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Kind; }
/* harmony export */ });
/**
 * The set of allowed kind values for AST nodes.
 */
var Kind = Object.freeze({
  // Name
  NAME: 'Name',
  // Document
  DOCUMENT: 'Document',
  OPERATION_DEFINITION: 'OperationDefinition',
  VARIABLE_DEFINITION: 'VariableDefinition',
  SELECTION_SET: 'SelectionSet',
  FIELD: 'Field',
  ARGUMENT: 'Argument',
  // Fragments
  FRAGMENT_SPREAD: 'FragmentSpread',
  INLINE_FRAGMENT: 'InlineFragment',
  FRAGMENT_DEFINITION: 'FragmentDefinition',
  // Values
  VARIABLE: 'Variable',
  INT: 'IntValue',
  FLOAT: 'FloatValue',
  STRING: 'StringValue',
  BOOLEAN: 'BooleanValue',
  NULL: 'NullValue',
  ENUM: 'EnumValue',
  LIST: 'ListValue',
  OBJECT: 'ObjectValue',
  OBJECT_FIELD: 'ObjectField',
  // Directives
  DIRECTIVE: 'Directive',
  // Types
  NAMED_TYPE: 'NamedType',
  LIST_TYPE: 'ListType',
  NON_NULL_TYPE: 'NonNullType',
  // Type System Definitions
  SCHEMA_DEFINITION: 'SchemaDefinition',
  OPERATION_TYPE_DEFINITION: 'OperationTypeDefinition',
  // Type Definitions
  SCALAR_TYPE_DEFINITION: 'ScalarTypeDefinition',
  OBJECT_TYPE_DEFINITION: 'ObjectTypeDefinition',
  FIELD_DEFINITION: 'FieldDefinition',
  INPUT_VALUE_DEFINITION: 'InputValueDefinition',
  INTERFACE_TYPE_DEFINITION: 'InterfaceTypeDefinition',
  UNION_TYPE_DEFINITION: 'UnionTypeDefinition',
  ENUM_TYPE_DEFINITION: 'EnumTypeDefinition',
  ENUM_VALUE_DEFINITION: 'EnumValueDefinition',
  INPUT_OBJECT_TYPE_DEFINITION: 'InputObjectTypeDefinition',
  // Directive Definitions
  DIRECTIVE_DEFINITION: 'DirectiveDefinition',
  // Type System Extensions
  SCHEMA_EXTENSION: 'SchemaExtension',
  // Type Extensions
  SCALAR_TYPE_EXTENSION: 'ScalarTypeExtension',
  OBJECT_TYPE_EXTENSION: 'ObjectTypeExtension',
  INTERFACE_TYPE_EXTENSION: 'InterfaceTypeExtension',
  UNION_TYPE_EXTENSION: 'UnionTypeExtension',
  ENUM_TYPE_EXTENSION: 'EnumTypeExtension',
  INPUT_OBJECT_TYPE_EXTENSION: 'InputObjectTypeExtension'
});
/**
 * The enum type representing the possible kind values of AST nodes.
 */


/***/ }),

/***/ 49786:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* binding */ Source; }
});

// EXTERNAL MODULE: ./node_modules/graphql/jsutils/devAssert.mjs
var devAssert = __webpack_require__(37826);
;// CONCATENATED MODULE: ./node_modules/graphql/jsutils/defineToStringTag.mjs
/**
 * The `defineToStringTag()` function checks first to see if the runtime
 * supports the `Symbol` class and then if the `Symbol.toStringTag` constant
 * is defined as a `Symbol` instance. If both conditions are met, the
 * Symbol.toStringTag property is defined as a getter that returns the
 * supplied class constructor's name.
 *
 * @method defineToStringTag
 *
 * @param {Class<any>} classObject a class such as Object, String, Number but
 * typically one of your own creation through the class keyword; `class A {}`,
 * for example.
 */
function defineToStringTag(classObject) {
  if (typeof Symbol === 'function' && Symbol.toStringTag) {
    Object.defineProperty(classObject.prototype, Symbol.toStringTag, {
      get: function get() {
        return this.constructor.name;
      }
    });
  }
}

;// CONCATENATED MODULE: ./node_modules/graphql/language/source.mjs



/**
 * A representation of source input to GraphQL.
 * `name` and `locationOffset` are optional. They are useful for clients who
 * store GraphQL documents in source files; for example, if the GraphQL input
 * starts at line 40 in a file named Foo.graphql, it might be useful for name to
 * be "Foo.graphql" and location to be `{ line: 40, column: 0 }`.
 * line and column in locationOffset are 1-indexed
 */
var Source = function Source(body, name, locationOffset) {
  this.body = body;
  this.name = name || 'GraphQL request';
  this.locationOffset = locationOffset || {
    line: 1,
    column: 1
  };
  this.locationOffset.line > 0 || (0,devAssert/* default */.Z)(0, 'line in locationOffset is 1-indexed and must be positive');
  this.locationOffset.column > 0 || (0,devAssert/* default */.Z)(0, 'column in locationOffset is 1-indexed and must be positive');
}; // Conditionally apply `[Symbol.toStringTag]` if `Symbol`s are supported

defineToStringTag(Source);


/***/ }),

/***/ 77304:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$_": function() { return /* binding */ BREAK; },
/* harmony export */   "Vn": function() { return /* binding */ visit; }
/* harmony export */ });
/* unused harmony exports QueryDocumentKeys, visitInParallel, visitWithTypeInfo, getVisitFn */
/* harmony import */ var _jsutils_inspect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25821);

var QueryDocumentKeys = {
  Name: [],
  Document: ['definitions'],
  OperationDefinition: ['name', 'variableDefinitions', 'directives', 'selectionSet'],
  VariableDefinition: ['variable', 'type', 'defaultValue', 'directives'],
  Variable: ['name'],
  SelectionSet: ['selections'],
  Field: ['alias', 'name', 'arguments', 'directives', 'selectionSet'],
  Argument: ['name', 'value'],
  FragmentSpread: ['name', 'directives'],
  InlineFragment: ['typeCondition', 'directives', 'selectionSet'],
  FragmentDefinition: ['name', // Note: fragment variable definitions are experimental and may be changed
  // or removed in the future.
  'variableDefinitions', 'typeCondition', 'directives', 'selectionSet'],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ['values'],
  ObjectValue: ['fields'],
  ObjectField: ['name', 'value'],
  Directive: ['name', 'arguments'],
  NamedType: ['name'],
  ListType: ['type'],
  NonNullType: ['type'],
  SchemaDefinition: ['directives', 'operationTypes'],
  OperationTypeDefinition: ['type'],
  ScalarTypeDefinition: ['description', 'name', 'directives'],
  ObjectTypeDefinition: ['description', 'name', 'interfaces', 'directives', 'fields'],
  FieldDefinition: ['description', 'name', 'arguments', 'type', 'directives'],
  InputValueDefinition: ['description', 'name', 'type', 'defaultValue', 'directives'],
  InterfaceTypeDefinition: ['description', 'name', 'directives', 'fields'],
  UnionTypeDefinition: ['description', 'name', 'directives', 'types'],
  EnumTypeDefinition: ['description', 'name', 'directives', 'values'],
  EnumValueDefinition: ['description', 'name', 'directives'],
  InputObjectTypeDefinition: ['description', 'name', 'directives', 'fields'],
  DirectiveDefinition: ['description', 'name', 'arguments', 'locations'],
  SchemaExtension: ['directives', 'operationTypes'],
  ScalarTypeExtension: ['name', 'directives'],
  ObjectTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
  InterfaceTypeExtension: ['name', 'directives', 'fields'],
  UnionTypeExtension: ['name', 'directives', 'types'],
  EnumTypeExtension: ['name', 'directives', 'values'],
  InputObjectTypeExtension: ['name', 'directives', 'fields']
};
var BREAK = Object.freeze({});
/**
 * visit() will walk through an AST using a depth first traversal, calling
 * the visitor's enter function at each node in the traversal, and calling the
 * leave function after visiting that node and all of its child nodes.
 *
 * By returning different values from the enter and leave functions, the
 * behavior of the visitor can be altered, including skipping over a sub-tree of
 * the AST (by returning false), editing the AST by returning a value or null
 * to remove the value, or to stop the whole traversal by returning BREAK.
 *
 * When using visit() to edit an AST, the original AST will not be modified, and
 * a new version of the AST with the changes applied will be returned from the
 * visit function.
 *
 *     const editedAST = visit(ast, {
 *       enter(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: skip visiting this node
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       },
 *       leave(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: no action
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       }
 *     });
 *
 * Alternatively to providing enter() and leave() functions, a visitor can
 * instead provide functions named the same as the kinds of AST nodes, or
 * enter/leave visitors at a named key, leading to four permutations of
 * visitor API:
 *
 * 1) Named visitors triggered when entering a node a specific kind.
 *
 *     visit(ast, {
 *       Kind(node) {
 *         // enter the "Kind" node
 *       }
 *     })
 *
 * 2) Named visitors that trigger upon entering and leaving a node of
 *    a specific kind.
 *
 *     visit(ast, {
 *       Kind: {
 *         enter(node) {
 *           // enter the "Kind" node
 *         }
 *         leave(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 *
 * 3) Generic visitors that trigger upon entering and leaving any node.
 *
 *     visit(ast, {
 *       enter(node) {
 *         // enter any node
 *       },
 *       leave(node) {
 *         // leave any node
 *       }
 *     })
 *
 * 4) Parallel visitors for entering and leaving nodes of a specific kind.
 *
 *     visit(ast, {
 *       enter: {
 *         Kind(node) {
 *           // enter the "Kind" node
 *         }
 *       },
 *       leave: {
 *         Kind(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 */

function visit(root, visitor) {
  var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : QueryDocumentKeys;

  /* eslint-disable no-undef-init */
  var stack = undefined;
  var inArray = Array.isArray(root);
  var keys = [root];
  var index = -1;
  var edits = [];
  var node = undefined;
  var key = undefined;
  var parent = undefined;
  var path = [];
  var ancestors = [];
  var newRoot = root;
  /* eslint-enable no-undef-init */

  do {
    index++;
    var isLeaving = index === keys.length;
    var isEdited = isLeaving && edits.length !== 0;

    if (isLeaving) {
      key = ancestors.length === 0 ? undefined : path[path.length - 1];
      node = parent;
      parent = ancestors.pop();

      if (isEdited) {
        if (inArray) {
          node = node.slice();
        } else {
          var clone = {};

          for (var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++) {
            var k = _Object$keys2[_i2];
            clone[k] = node[k];
          }

          node = clone;
        }

        var editOffset = 0;

        for (var ii = 0; ii < edits.length; ii++) {
          var editKey = edits[ii][0];
          var editValue = edits[ii][1];

          if (inArray) {
            editKey -= editOffset;
          }

          if (inArray && editValue === null) {
            node.splice(editKey, 1);
            editOffset++;
          } else {
            node[editKey] = editValue;
          }
        }
      }

      index = stack.index;
      keys = stack.keys;
      edits = stack.edits;
      inArray = stack.inArray;
      stack = stack.prev;
    } else {
      key = parent ? inArray ? index : keys[index] : undefined;
      node = parent ? parent[key] : newRoot;

      if (node === null || node === undefined) {
        continue;
      }

      if (parent) {
        path.push(key);
      }
    }

    var result = void 0;

    if (!Array.isArray(node)) {
      if (!isNode(node)) {
        throw new Error('Invalid AST Node: ' + (0,_jsutils_inspect__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(node));
      }

      var visitFn = getVisitFn(visitor, node.kind, isLeaving);

      if (visitFn) {
        result = visitFn.call(visitor, node, key, parent, path, ancestors);

        if (result === BREAK) {
          break;
        }

        if (result === false) {
          if (!isLeaving) {
            path.pop();
            continue;
          }
        } else if (result !== undefined) {
          edits.push([key, result]);

          if (!isLeaving) {
            if (isNode(result)) {
              node = result;
            } else {
              path.pop();
              continue;
            }
          }
        }
      }
    }

    if (result === undefined && isEdited) {
      edits.push([key, node]);
    }

    if (isLeaving) {
      path.pop();
    } else {
      stack = {
        inArray: inArray,
        index: index,
        keys: keys,
        edits: edits,
        prev: stack
      };
      inArray = Array.isArray(node);
      keys = inArray ? node : visitorKeys[node.kind] || [];
      index = -1;
      edits = [];

      if (parent) {
        ancestors.push(parent);
      }

      parent = node;
    }
  } while (stack !== undefined);

  if (edits.length !== 0) {
    newRoot = edits[edits.length - 1][1];
  }

  return newRoot;
}

function isNode(maybeNode) {
  return Boolean(maybeNode && typeof maybeNode.kind === 'string');
}
/**
 * Creates a new visitor instance which delegates to many visitors to run in
 * parallel. Each visitor will be visited for each node before moving on.
 *
 * If a prior visitor edits a node, no following visitors will see that node.
 */


function visitInParallel(visitors) {
  var skipping = new Array(visitors.length);
  return {
    enter: function enter(node) {
      for (var i = 0; i < visitors.length; i++) {
        if (!skipping[i]) {
          var fn = getVisitFn(visitors[i], node.kind,
          /* isLeaving */
          false);

          if (fn) {
            var result = fn.apply(visitors[i], arguments);

            if (result === false) {
              skipping[i] = node;
            } else if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined) {
              return result;
            }
          }
        }
      }
    },
    leave: function leave(node) {
      for (var i = 0; i < visitors.length; i++) {
        if (!skipping[i]) {
          var fn = getVisitFn(visitors[i], node.kind,
          /* isLeaving */
          true);

          if (fn) {
            var result = fn.apply(visitors[i], arguments);

            if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined && result !== false) {
              return result;
            }
          }
        } else if (skipping[i] === node) {
          skipping[i] = null;
        }
      }
    }
  };
}
/**
 * Creates a new visitor instance which maintains a provided TypeInfo instance
 * along with visiting visitor.
 */

function visitWithTypeInfo(typeInfo, visitor) {
  return {
    enter: function enter(node) {
      typeInfo.enter(node);
      var fn = getVisitFn(visitor, node.kind,
      /* isLeaving */
      false);

      if (fn) {
        var result = fn.apply(visitor, arguments);

        if (result !== undefined) {
          typeInfo.leave(node);

          if (isNode(result)) {
            typeInfo.enter(result);
          }
        }

        return result;
      }
    },
    leave: function leave(node) {
      var fn = getVisitFn(visitor, node.kind,
      /* isLeaving */
      true);
      var result;

      if (fn) {
        result = fn.apply(visitor, arguments);
      }

      typeInfo.leave(node);
      return result;
    }
  };
}
/**
 * Given a visitor instance, if it is leaving or not, and a node kind, return
 * the function the visitor runtime should call.
 */

function getVisitFn(visitor, kind, isLeaving) {
  var kindVisitor = visitor[kind];

  if (kindVisitor) {
    if (!isLeaving && typeof kindVisitor === 'function') {
      // { Kind() {} }
      return kindVisitor;
    }

    var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;

    if (typeof kindSpecificVisitor === 'function') {
      // { Kind: { enter() {}, leave() {} } }
      return kindSpecificVisitor;
    }
  } else {
    var specificVisitor = isLeaving ? visitor.leave : visitor.enter;

    if (specificVisitor) {
      if (typeof specificVisitor === 'function') {
        // { enter() {}, leave() {} }
        return specificVisitor;
      }

      var specificKindVisitor = specificVisitor[kind];

      if (typeof specificKindVisitor === 'function') {
        // { enter: { Kind() {} }, leave: { Kind() {} } }
        return specificKindVisitor;
      }
    }
  }
}


/***/ }),

/***/ 52587:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

/***/ }),

/***/ 14666:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayWithHoles; }
/* harmony export */ });
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

/***/ }),

/***/ 10748:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _assertThisInitialized; }
/* harmony export */ });
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),

/***/ 50029:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

/***/ }),

/***/ 92777:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ 82262:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _createClass; }
/* harmony export */ });
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

/***/ }),

/***/ 59499:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),

/***/ 74450:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _get; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(37247);
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/superPropBase.js

function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = (0,getPrototypeOf/* default */.Z)(object);
    if (object === null) break;
  }

  return object;
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/get.js

function _get(target, property, receiver) {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get = Reflect.get;
  } else {
    _get = function _get(target, property, receiver) {
      var base = _superPropBase(target, property);
      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);

      if (desc.get) {
        return desc.get.call(receiver);
      }

      return desc.value;
    };
  }

  return _get(target, property, receiver || target);
}

/***/ }),

/***/ 37247:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _getPrototypeOf; }
/* harmony export */ });
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),

/***/ 81531:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _inherits; }
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90607);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(subClass, superClass);
}

/***/ }),

/***/ 28811:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

/***/ }),

/***/ 14882:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _nonIterableRest; }
/* harmony export */ });
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),

/***/ 4730:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 63553:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _possibleConstructorReturn; }
/* harmony export */ });
/* harmony import */ var next_dist_compiled_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14027);
/* harmony import */ var _assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10748);


function _possibleConstructorReturn(self, call) {
  if (call && (next_dist_compiled_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return (0,_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(self);
}

/***/ }),

/***/ 90607:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),

/***/ 17674:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayWithHoles.js
var arrayWithHoles = __webpack_require__(14666);
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(2937);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/nonIterableRest.js
var nonIterableRest = __webpack_require__(14882);
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return (0,arrayWithHoles/* default */.Z)(arr) || _iterableToArrayLimit(arr, i) || (0,unsupportedIterableToArray/* default */.Z)(arr, i) || (0,nonIterableRest/* default */.Z)();
}

/***/ }),

/***/ 71383:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _taggedTemplateLiteral; }
/* harmony export */ });
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

/***/ }),

/***/ 90116:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayLikeToArray.js
var arrayLikeToArray = __webpack_require__(52587);
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,arrayLikeToArray/* default */.Z)(arr);
}
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/iterableToArray.js
var iterableToArray = __webpack_require__(28811);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(2937);
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,iterableToArray/* default */.Z)(arr) || (0,unsupportedIterableToArray/* default */.Z)(arr) || _nonIterableSpread();
}

/***/ }),

/***/ 2937:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52587);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}

/***/ }),

/***/ 48216:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ Observable; }
/* harmony export */ });
function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

// === Symbol Support ===
var hasSymbols = function () {
  return typeof Symbol === 'function';
};

var hasSymbol = function (name) {
  return hasSymbols() && Boolean(Symbol[name]);
};

var getSymbol = function (name) {
  return hasSymbol(name) ? Symbol[name] : '@@' + name;
};

if (hasSymbols() && !hasSymbol('observable')) {
  Symbol.observable = Symbol('observable');
}

var SymbolIterator = getSymbol('iterator');
var SymbolObservable = getSymbol('observable');
var SymbolSpecies = getSymbol('species'); // === Abstract Operations ===

function getMethod(obj, key) {
  var value = obj[key];
  if (value == null) return undefined;
  if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
  return value;
}

function getSpecies(obj) {
  var ctor = obj.constructor;

  if (ctor !== undefined) {
    ctor = ctor[SymbolSpecies];

    if (ctor === null) {
      ctor = undefined;
    }
  }

  return ctor !== undefined ? ctor : Observable;
}

function isObservable(x) {
  return x instanceof Observable; // SPEC: Brand check
}

function hostReportError(e) {
  if (hostReportError.log) {
    hostReportError.log(e);
  } else {
    setTimeout(function () {
      throw e;
    });
  }
}

function enqueue(fn) {
  Promise.resolve().then(function () {
    try {
      fn();
    } catch (e) {
      hostReportError(e);
    }
  });
}

function cleanupSubscription(subscription) {
  var cleanup = subscription._cleanup;
  if (cleanup === undefined) return;
  subscription._cleanup = undefined;

  if (!cleanup) {
    return;
  }

  try {
    if (typeof cleanup === 'function') {
      cleanup();
    } else {
      var unsubscribe = getMethod(cleanup, 'unsubscribe');

      if (unsubscribe) {
        unsubscribe.call(cleanup);
      }
    }
  } catch (e) {
    hostReportError(e);
  }
}

function closeSubscription(subscription) {
  subscription._observer = undefined;
  subscription._queue = undefined;
  subscription._state = 'closed';
}

function flushSubscription(subscription) {
  var queue = subscription._queue;

  if (!queue) {
    return;
  }

  subscription._queue = undefined;
  subscription._state = 'ready';

  for (var i = 0; i < queue.length; ++i) {
    notifySubscription(subscription, queue[i].type, queue[i].value);
    if (subscription._state === 'closed') break;
  }
}

function notifySubscription(subscription, type, value) {
  subscription._state = 'running';
  var observer = subscription._observer;

  try {
    var m = getMethod(observer, type);

    switch (type) {
      case 'next':
        if (m) m.call(observer, value);
        break;

      case 'error':
        closeSubscription(subscription);
        if (m) m.call(observer, value);else throw value;
        break;

      case 'complete':
        closeSubscription(subscription);
        if (m) m.call(observer);
        break;
    }
  } catch (e) {
    hostReportError(e);
  }

  if (subscription._state === 'closed') cleanupSubscription(subscription);else if (subscription._state === 'running') subscription._state = 'ready';
}

function onNotify(subscription, type, value) {
  if (subscription._state === 'closed') return;

  if (subscription._state === 'buffering') {
    subscription._queue.push({
      type: type,
      value: value
    });

    return;
  }

  if (subscription._state !== 'ready') {
    subscription._state = 'buffering';
    subscription._queue = [{
      type: type,
      value: value
    }];
    enqueue(function () {
      return flushSubscription(subscription);
    });
    return;
  }

  notifySubscription(subscription, type, value);
}

var Subscription = /*#__PURE__*/function () {
  function Subscription(observer, subscriber) {
    // ASSERT: observer is an object
    // ASSERT: subscriber is callable
    this._cleanup = undefined;
    this._observer = observer;
    this._queue = undefined;
    this._state = 'initializing';
    var subscriptionObserver = new SubscriptionObserver(this);

    try {
      this._cleanup = subscriber.call(undefined, subscriptionObserver);
    } catch (e) {
      subscriptionObserver.error(e);
    }

    if (this._state === 'initializing') this._state = 'ready';
  }

  var _proto = Subscription.prototype;

  _proto.unsubscribe = function unsubscribe() {
    if (this._state !== 'closed') {
      closeSubscription(this);
      cleanupSubscription(this);
    }
  };

  _createClass(Subscription, [{
    key: "closed",
    get: function () {
      return this._state === 'closed';
    }
  }]);

  return Subscription;
}();

var SubscriptionObserver = /*#__PURE__*/function () {
  function SubscriptionObserver(subscription) {
    this._subscription = subscription;
  }

  var _proto2 = SubscriptionObserver.prototype;

  _proto2.next = function next(value) {
    onNotify(this._subscription, 'next', value);
  };

  _proto2.error = function error(value) {
    onNotify(this._subscription, 'error', value);
  };

  _proto2.complete = function complete() {
    onNotify(this._subscription, 'complete');
  };

  _createClass(SubscriptionObserver, [{
    key: "closed",
    get: function () {
      return this._subscription._state === 'closed';
    }
  }]);

  return SubscriptionObserver;
}();

var Observable = /*#__PURE__*/function () {
  function Observable(subscriber) {
    if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
    if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
    this._subscriber = subscriber;
  }

  var _proto3 = Observable.prototype;

  _proto3.subscribe = function subscribe(observer) {
    if (typeof observer !== 'object' || observer === null) {
      observer = {
        next: observer,
        error: arguments[1],
        complete: arguments[2]
      };
    }

    return new Subscription(observer, this._subscriber);
  };

  _proto3.forEach = function forEach(fn) {
    var _this = this;

    return new Promise(function (resolve, reject) {
      if (typeof fn !== 'function') {
        reject(new TypeError(fn + ' is not a function'));
        return;
      }

      function done() {
        subscription.unsubscribe();
        resolve();
      }

      var subscription = _this.subscribe({
        next: function (value) {
          try {
            fn(value, done);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  };

  _proto3.map = function map(fn) {
    var _this2 = this;

    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
    var C = getSpecies(this);
    return new C(function (observer) {
      return _this2.subscribe({
        next: function (value) {
          try {
            value = fn(value);
          } catch (e) {
            return observer.error(e);
          }

          observer.next(value);
        },
        error: function (e) {
          observer.error(e);
        },
        complete: function () {
          observer.complete();
        }
      });
    });
  };

  _proto3.filter = function filter(fn) {
    var _this3 = this;

    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
    var C = getSpecies(this);
    return new C(function (observer) {
      return _this3.subscribe({
        next: function (value) {
          try {
            if (!fn(value)) return;
          } catch (e) {
            return observer.error(e);
          }

          observer.next(value);
        },
        error: function (e) {
          observer.error(e);
        },
        complete: function () {
          observer.complete();
        }
      });
    });
  };

  _proto3.reduce = function reduce(fn) {
    var _this4 = this;

    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
    var C = getSpecies(this);
    var hasSeed = arguments.length > 1;
    var hasValue = false;
    var seed = arguments[1];
    var acc = seed;
    return new C(function (observer) {
      return _this4.subscribe({
        next: function (value) {
          var first = !hasValue;
          hasValue = true;

          if (!first || hasSeed) {
            try {
              acc = fn(acc, value);
            } catch (e) {
              return observer.error(e);
            }
          } else {
            acc = value;
          }
        },
        error: function (e) {
          observer.error(e);
        },
        complete: function () {
          if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
          observer.next(acc);
          observer.complete();
        }
      });
    });
  };

  _proto3.concat = function concat() {
    var _this5 = this;

    for (var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++) {
      sources[_key] = arguments[_key];
    }

    var C = getSpecies(this);
    return new C(function (observer) {
      var subscription;
      var index = 0;

      function startNext(next) {
        subscription = next.subscribe({
          next: function (v) {
            observer.next(v);
          },
          error: function (e) {
            observer.error(e);
          },
          complete: function () {
            if (index === sources.length) {
              subscription = undefined;
              observer.complete();
            } else {
              startNext(C.from(sources[index++]));
            }
          }
        });
      }

      startNext(_this5);
      return function () {
        if (subscription) {
          subscription.unsubscribe();
          subscription = undefined;
        }
      };
    });
  };

  _proto3.flatMap = function flatMap(fn) {
    var _this6 = this;

    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
    var C = getSpecies(this);
    return new C(function (observer) {
      var subscriptions = [];

      var outer = _this6.subscribe({
        next: function (value) {
          if (fn) {
            try {
              value = fn(value);
            } catch (e) {
              return observer.error(e);
            }
          }

          var inner = C.from(value).subscribe({
            next: function (value) {
              observer.next(value);
            },
            error: function (e) {
              observer.error(e);
            },
            complete: function () {
              var i = subscriptions.indexOf(inner);
              if (i >= 0) subscriptions.splice(i, 1);
              completeIfDone();
            }
          });
          subscriptions.push(inner);
        },
        error: function (e) {
          observer.error(e);
        },
        complete: function () {
          completeIfDone();
        }
      });

      function completeIfDone() {
        if (outer.closed && subscriptions.length === 0) observer.complete();
      }

      return function () {
        subscriptions.forEach(function (s) {
          return s.unsubscribe();
        });
        outer.unsubscribe();
      };
    });
  };

  _proto3[SymbolObservable] = function () {
    return this;
  };

  Observable.from = function from(x) {
    var C = typeof this === 'function' ? this : Observable;
    if (x == null) throw new TypeError(x + ' is not an object');
    var method = getMethod(x, SymbolObservable);

    if (method) {
      var observable = method.call(x);
      if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
      if (isObservable(observable) && observable.constructor === C) return observable;
      return new C(function (observer) {
        return observable.subscribe(observer);
      });
    }

    if (hasSymbol('iterator')) {
      method = getMethod(x, SymbolIterator);

      if (method) {
        return new C(function (observer) {
          enqueue(function () {
            if (observer.closed) return;

            for (var _iterator = _createForOfIteratorHelperLoose(method.call(x)), _step; !(_step = _iterator()).done;) {
              var item = _step.value;
              observer.next(item);
              if (observer.closed) return;
            }

            observer.complete();
          });
        });
      }
    }

    if (Array.isArray(x)) {
      return new C(function (observer) {
        enqueue(function () {
          if (observer.closed) return;

          for (var i = 0; i < x.length; ++i) {
            observer.next(x[i]);
            if (observer.closed) return;
          }

          observer.complete();
        });
      });
    }

    throw new TypeError(x + ' is not observable');
  };

  Observable.of = function of() {
    for (var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      items[_key2] = arguments[_key2];
    }

    var C = typeof this === 'function' ? this : Observable;
    return new C(function (observer) {
      enqueue(function () {
        if (observer.closed) return;

        for (var i = 0; i < items.length; ++i) {
          observer.next(items[i]);
          if (observer.closed) return;
        }

        observer.complete();
      });
    });
  };

  _createClass(Observable, null, [{
    key: SymbolSpecies,
    get: function () {
      return this;
    }
  }]);

  return Observable;
}();

if (hasSymbols()) {
  Object.defineProperty(Observable, Symbol('extensions'), {
    value: {
      symbol: SymbolObservable,
      hostReportError: hostReportError
    },
    configurable: true
  });
}




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,179], function() { return __webpack_exec__(16395), __webpack_exec__(45919), __webpack_exec__(6840), __webpack_exec__(61587); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);